(function () {
	'use strict';

	angular.module('Spartan.components', []);
})();

(function () {
	'use strict';
	angular
		.module('Spartan.pages', [
			'ui.router',
			'Spartan.pages.dashboard',
			'Spartan.pages.feeds',
			'Spartan.pages.groups',
			'Spartan.pages.herds',
			'Spartan.pages.rations',
			'Spartan.pages.teams',
			'Spartan.pages.settings',
			'Spartan.pages.pens',
			'Spartan.pages.premixes',
			'Spartan.pages.recipes',
			'Spartan.pages.iManagement',
			'Spartan.pages.mixerWagons',
			'Spartan.pages.reports',
			'Spartan.pages.calendar',
			'Spartan.pages.insights',
			'Spartan.pages.rap'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($urlRouterProvider) {
		$urlRouterProvider.otherwise('/dashboard');
	}
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('Spartan.theme', [
	  'toastr',
	  'textAngular',
	  'Spartan.theme.components',
	  'Spartan.theme.inputs'
  ]);

})();

(function () {
	'use strict';
	angular.module('Spartan.pages.calendar', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('calendar', {
			url: '/calendar',
			templateUrl: 'app/pages/calendar/calendar.html',
			controller: 'calendarCtrl',
			controllerAs: 'vm',
			title: '_page_title_calendar_',
			sidebarMeta: {
				img: 'assets/img/feedCalendar.png',
				imgLarge: 'assets/img/feedCalendar.png',
				order: 900,
				accessControl: 64
			},
			resolve: {
                'accessContols': ['$q', 'authService', 'APP_CONST', function ($q, authService, APP_CONST) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();


(function () {
	'use strict';
	angular.module('Spartan.pages.dashboard', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('dashboard', {
			url: '/dashboard',
			controller: 'dashboardCtrl',
			controllerAs: 'vm',
			templateUrl: 'app/pages/dashboard/dashboard.html',
			title: '_menu_dashboard_',
			sidebarMeta: {
				img: 'assets/img/icons/Dashboard.svg',
				imgLarge: 'assets/img/icons/Dashboard.svg',
				order: 0
			}
		});
	}
})();

(function () {
    'use strict';
    angular.module('Spartan.pages.configurations', [
      'Spartan.pages.configurations.equipment'
      //, 'Spartan.pages.configurations.feeders'
      //, 'Spartan.pages.configurations.locations'
      //, 'Spartan.pages.configurations.stock'
  , ]).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('configurations', {
            url: '/configurations'
            , template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>'
            , title: '_m_f_menu_configurations_'
            , abstract: true
            , sidebarMeta: {
                icon: 'ion-android-options'
                , order: 850
            , }
        , });
    }
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.groups', ['Spartan.pages.groups.myGroups', 'Spartan.pages.groups.addNewGroup', 'Spartan.pages.groups.groupHistory', 'Spartan.pages.groups.editGroup']).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('groups', {
			url: '/groups',
			template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			title: '_menu_groups_',
			abstract: true,
			sidebarMeta: {
				img: 'assets/img/icons/Groups.svg',
				imgLarge: 'assets/img/icons/Groups.svg',
				order: 300,
				accessControl: 16
			},
			resolve: {
				accessContols: [
					'$q',
					'authService',
					function ($q, authService) {
						if (authService.can(16)) {
							return true;
						} else {
							return $q.reject('Unauthorized');
						}
					}
				]
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.herds', ['Spartan.pages.herds.myHerds', 'Spartan.pages.herds.addNewHerd']).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('herds', {
			url: '/herds',
			template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			title: '_menu_herds_',
			abstract: true,
			sidebarMeta: {
				img: 'assets/img/icons/Herds.svg',
				imgLarge: 'assets/img/icons/Herds.svg',
				order: 200
			}
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('Spartan.pages.feeds', [
			'Spartan.pages.feeds.myfeeds',
			'Spartan.pages.feeds.mymanualfeeds',
			'Spartan.pages.feeds.addNewFeed',
			'Spartan.pages.feeds.addNewManualFeed',
			'Spartan.pages.feeds.editFeed',
			'Spartan.pages.feeds.importSpartan3',
			'Spartan.pages.feeds.importXml',
			'Spartan.pages.feeds.importXmlFeed',
			'Spartan.pages.feeds.feedHistory',
			'Spartan.pages.feeds.manualFeedsHistory'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('feeds', {
			url: '/feeds',
			template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			title: '_menu_feeds_',
			abstract: true,
			sidebarMeta: {
				img: 'assets/img/icons/Feeds.svg',
				imgLarge: 'assets/img/icons/Feeds.svg',
				order: 400
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('Spartan.pages.iManagement', [
			'Spartan.pages.iManagement.inventory',
			// 'Spartan.pages.iManagement.overview',
			'Spartan.pages.iManagement.addNewIngredient',
			'Spartan.pages.iManagement.ingredientHistory',
			'Spartan.pages.iManagement.ingredientDetails',
			'Spartan.pages.iManagement.editIngredient',
			'Spartan.pages.iManagement.ingredientUsageOverview'
		])
		.config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('iManagement', {
			url: '/iManagement',
			template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			title: '_m_f_menu_ingredients_management_',
			abstract: true,
			sidebarMeta: {
				img: 'assets/img/inventory.png',
				imgLarge: 'assets/img/inventory.png',
				order: 800,
				accessControl: 64
			},
			resolve: {
				accessContols: [
					'$q',
					'authService',
					function ($q, authService) {
						if (authService.can(64)) {
							return true;
						} else {
							return $q.reject('Unauthorized');
						}
					}
				]
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.login', ['ui.router']).config(routeConfig);

	function routeConfig($stateProvider) {
		$stateProvider.state('login', {
			url: '/login',
			templateUrl: 'auth.html',
			controller: 'loginCtrl',
			controllerAs: 'lc',
			title: 'login'
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.insights', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('insights', {
			url: '/insights',
			controller: 'insightsCtrl',
			controllerAs: 'vm',
			templateUrl: 'app/pages/insights/insights.html',
			title: '_menu_insights_',
			sidebarMeta: {
				img: 'assets/img/icons/Insights.svg',
				imgLarge: 'assets/img/icons/Insights.svg',
				order: 990,
				accessControl: 261120
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(261120)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.my', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('my', {
			abstract: true
			, title: '_menu_my_mmmooogle_'
			, fixedHref: 'https://my.mmmooogle.com'
			, sidebarMeta: {
				img: 'assets/img/icons/MyMmmooOgle-24.png'
				, imgLarge: 'assets/img/icons/MyMmmooOgle-32.png'
				, order: 650
			, }
		, });
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.mixerWagons', ['Spartan.pages.mixerWagons.myWagons', 'Spartan.pages.mixerWagons.addNewWagon', 'Spartan.pages.mixerWagons.editWagon', 'Spartan.pages.mixerWagons.wagonHistory']).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('mixerWagons', {
			url: '/mixerWagons',
			template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			title: '_m_f_menu_mixer_wagons_',
			abstract: true,
			sidebarMeta: {
				img: 'assets/img/wagon.png',
				imgLarge: 'assets/img/wagon.png',
				order: 850,
				accessControl: 64
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.pens', ['Spartan.pages.pens.myPens', 'Spartan.pages.pens.addNewPen', 'Spartan.pages.pens.editPen', 'Spartan.pages.pens.penDetails', 'Spartan.pages.pens.penHistory']).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('pens', {
			url: '/pens',
			template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			title: '_m_f_menu_pens_',
			abstract: true,
			sidebarMeta: {
				img: 'assets/img/pens.svg',
				imgLarge:'assets/img/pens.svg',
				order: 700,
				accessControl: 64
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.premixes', ['Spartan.pages.premixes.addNewPremix', 'Spartan.pages.premixes.editPremix', 'Spartan.pages.premixes.myPremixes']).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('premixes', {
			url: '/premixes',
			template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
			title: '_m_f_menu_premixes_',
			abstract: true,
			sidebarMeta: {
				img: 'assets/img/premix.png',
				imgLarge: 'assets/img/premix.png',
				order: 710,
				accessControl: 64
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('Spartan.pages.rations', [
			'Spartan.pages.rations.myrations',
			'Spartan.pages.rations.manualrations',
			'Spartan.pages.rations.addnewration',
			'Spartan.pages.rations.addmanualration',
			'Spartan.pages.rations.editmanualration',
			'Spartan.pages.rations.balanceRation',
			'Spartan.pages.rations.rationHistory',
			'Spartan.pages.rations.rationFeedHistory',
			'Spartan.pages.rations.importration',
			'Spartan.pages.rations.importrationnew',
			'Spartan.pages.rations.rationComparisonList',
			'Spartan.pages.rations.rationComparison',
			'Spartan.pages.rations.manualRationsHistory',
			'Spartan.pages.rations.manualRationFeedsHistory'
		])
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('rations', {
			url: '/rations',
			template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			title: '_menu_rations_',
			abstract: true,
			sidebarMeta: {
				img: 'assets/img/icons/Rations.svg',
				imgLarge: 'assets/img/icons/Rations.svg',
				order: 500
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rap', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('robot-view', {
			url: '/robot-view',
			templateUrl: 'app/pages/rap/rap.html',
			title: '_menu_rap_',
			controller: 'rapCtrl',
			controllerAs: 'vm',
			sidebarMeta: {
				img: 'assets/img/icons/production.png',
				imgLarge: 'assets/img/icons/production.png',
				order: 999,
				accessControl: 128
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(128)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('Spartan.pages.reports', [
			'Spartan.pages.reports.mixing'
			//, 'Spartan.pages.reports.dropping'
			// 'Spartan.pages.reports.weighback',
			// 'Spartan.pages.reports.communication',
			// 'Spartan.pages.reports.compliance'
		])
		.config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('reports', {
			url: '/reports',
			template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			title: '_m_f_menu_reports_',
			abstract: true,
			sidebarMeta: {
				img: 'assets/img/graph.png',
				imgLarge: 'assets/img/graph.png',
				order: 900,
				accessControl: 64
			},
			resolve: {
				accessContols: [
					'$q',
					'authService',
					function ($q, authService) {
						if (authService.can(64)) {
							return true;
						} else {
							return $q.reject('Unauthorized');
						}
					}
				]
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.settings', ['toggle-switch', 'ui.select', 'ngSanitize']).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('settings', {
			url: '/settings',
			templateUrl: 'app/pages/settings/settings.html',
			title: '_menu_settings_',
			controller: 'settingsCtrl',
			controllerAs: 'vm'
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('Spartan.pages.recipes', [
			'Spartan.pages.recipes.myRecipes',
			'Spartan.pages.recipes.addNewRecipe',
			'Spartan.pages.recipes.editRecipe',
			'Spartan.pages.recipes.recipeDetails',
			'Spartan.pages.recipes.recipeHistory'
		])
		.config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('recipes', {
			url: '/recipes',
			template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			title: '_m_f_menu_recipes_',
			abstract: true,
			sidebarMeta: {
				img: 'assets/img/recipe-min.svg',
				imgLarge: 'assets/img/recipe.svg',
				order: 750,
				accessControl: 64
			},
			resolve: {
				accessContols: [
					'$q',
					'authService',
					function ($q, authService) {
						if (authService.can(64)) {
							return true;
						} else {
							return $q.reject('Unauthorized');
						}
					}
				]
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.teams', ['Spartan.pages.teams.myTeams', 'Spartan.pages.teams.addNewTeam']).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('teams', {
			url: '/teams',
			template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			title: '_menu_teams_',
			abstract: true,
			sidebarMeta: {
				img: 'assets/img/icons/Teams.svg',
				imgLarge: 'assets/img/icons/Teams.svg',
				order: 100,
			}
		});
	}
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Spartan.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('Spartan.theme.inputs', []);

})();

(function () {
  'use strict';

  angular.module('Spartan.pages.configurations.equipment', [])
	  .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
	$stateProvider
		.state('configurations.equipment', {
		  url: '/configurations/equipment',
		  templateUrl: 'app/pages/configurations/equipment/equipment.html',
		  title: '_m_f_menu_configurations_equipment_',
		  controller: 'equipmentCtrl',
		  controllerAs: 'vm',
		  sidebarMeta: {
			order: 100,
		  },
		});
  }

})();

(function () {
  'use strict';

  angular.module('Spartan.pages.configurations.locations', [])
	  .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
	$stateProvider
		.state('configurations.locations', {
		  url: '/configurations/locations',
		  templateUrl: 'app/pages/configurations/locations/locations.html',
		  title: '_m_f_menu_configurations_locations_',
		  controller: 'locationsCtrl',
		  controllerAs: 'vm',
		  sidebarMeta: {
			order: 300,
		  },
		});
  }

})();

(function () {
  'use strict';

  angular.module('Spartan.pages.configurations.feeders', [])
	  .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
	$stateProvider
		.state('configurations.feeders', {
		  url: '/configurations/feeders',
		  templateUrl: 'app/pages/configurations/feeders/feeders.html',
		  title: '_m_f_menu_configurations_feeders_',
		  controller: 'feedersCtrl',
		  controllerAs: 'vm',
		  sidebarMeta: {
			order: 200,
		  },
		});
  }

})();

(function () {
  'use strict';

  angular.module('Spartan.pages.configurations.stock', [])
	  .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
	$stateProvider
		.state('configurations.stock', {
		  url: '/configurations/stock',
		  templateUrl: 'app/pages/configurations/stock/stock.html',
		  title: '_m_f_menu_configurations_stock_',
		  controller: 'stockCtrl',
		  controllerAs: 'vm',
		  sidebarMeta: {
			order: 400,
		  },
		});
  }

})();

(function () {
	'use strict';
	angular.module('Spartan.pages.groups.editGroup', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('groups.editGroup', {
			url: '/editGroup/{uuid:string}',
			templateUrl: 'app/pages/groups/editGroup/editGroup.html',
			title: '_menu_edit_group_',
			controller: 'editGroupCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_groups_',
				state: 'groups.myGroups',
				parent_data: {
					title: '_menu_groups_'
				}
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.groups.groupDetails', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('groups.groupDetails', {
			url: '/groupdetails/{uuid:string}',
			templateUrl: 'app/pages/groups/groupDetails/groupDetails.html',
			title: '_menu_group_details_',
			controller: 'groupDetailsCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_groups_',
				state: 'groups.myGroups',
				parent_data: {
					title: '_menu_groups_'
				}
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.groups.addNewGroup', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('groups.addNewGroup', {
			url: '/addnewgroup',
			templateUrl: 'app/pages/groups/addNewGroup/addNewGroup.html',
			title: '_menu_add_new_group_',
			controller: 'addNewGroupCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_groups_',
				state: 'groups.myGroups',
				parent_data: {
					title: '_menu_groups_'
				}
			},
			sidebarMeta: {
				order: 100,
				accessControl: 16
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.groups.myGroups', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('groups.myGroups', {
			url: '/mygroups',
			templateUrl: 'app/pages/groups/myGroups/myGroups.html',
			title: '_menu_my_groups_',
			controller: 'mygroupsCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_groups_'
			},
			sidebarMeta: {
				order: 0,
				accessControl: 16
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.groups.groupHistory', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('groups.groupHistory', {
			url: '/groupHistory/{uuid:string}',
			templateUrl: 'app/pages/groups/groupHistory/groupHistory.html',
			title: '_menu_history_',
			controller: 'groupHistoryCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_groups_',
				state: 'groups.myGroups',
				parent_data: {
					title: '_menu_groups_'
				}
			},
			disable_herd_selector: true,
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.herds.addNewHerd', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('herds.addNewHerd', {
			url: '/herds/addNewHerd',
			templateUrl: 'app/pages/herds/addNewHerd/addNewHerd.html',
			title: '_menu_add_new_herd_',
			controller: 'addNewHerdCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_herds_',
				state: 'herds.myHerds',
				parent_data: {
					title: '_menu_herds_'
				}
			},
			sidebarMeta: {
				order: 200
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.herds.myHerds', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('herds.myHerds', {
			url: '/herds/myHerds',
			templateUrl: 'app/pages/herds/myHerds/myHerds.html',
			title: '_menu_my_herds_',
			controller: 'myHerdsCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_herds_'
			},
			sidebarMeta: {
				order: 100
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.addNewFeed', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('feeds.addNewFeed', {
			url: '/newfeed',
			templateUrl: 'app/pages/feeds/addNewFeed/addNewFeed.html',
			title: '_menu_add_new_feed_',
			controller: 'newFeedCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_feeds_',
				state: 'feeds.myfeeds',
				parent_data: {
					title: '_menu_feeds_'
				}
			},
			sidebarMeta: {
				order: 100,
				accessControl: 16
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.editFeed', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('feeds.editFeed', {
			url: '/editFeed/{uuid:string}',
			templateUrl: 'app/pages/feeds/editFeed/editFeed.html',
			title: '_menu_edit_feed_',
			controller: 'editFeedCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_feeds_',
				state: 'feeds.myfeeds',
				parent_data: {
					title: '_menu_feeds_'
				}
			},
			keep_premix_data: true,
			resolve: {
				accessContols: [
					'$q',
					'authService',
					function ($q, authService) {
						if (authService.can(16)) {
							return true;
						} else {
							return $q.reject('Unauthorized');
						}
					}
				]
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.addNewManualFeed', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('feeds.addNewManualFeed', {
			url: '/newmanualfeed',
			templateUrl: 'app/pages/feeds/addNewManualFeed/addNewManualFeed.html',
			title: '_m_f_feeds_add_new_manual_feed_',
			controller: 'addNewManualFeedCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_feeds_my_manual_feeds_',
				state: 'feeds.mymanualfeeds',
				parent_data: {
					title: '_menu_feeds_'
				}
			},
			sidebarMeta: {
				order: 300,
				accessControl: 64
			},
			resolve: {
				accessContols: [
					'$q',
					'authService',
					function ($q, authService) {
						if (authService.can(64)) {
							return true;
						} else {
							return $q.reject('Unauthorized');
						}
					}
				]
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.feedHistory', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('feeds.feedHistory', {
			url: '/feedHistory/{uuid:string}',
			templateUrl: 'app/pages/feeds/feedHistory/feedHistory.html',
			title: '_menu_history_',
			controller: 'feedHistoryCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_feeds_',
				state: 'feeds.myfeeds',
				parent_data: {
					title: '_menu_feeds_'
				}
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.importSpartan3', ['ngFileUpload']).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('feeds.importSpartan3', {
			url: '/import-spartan3',
			templateUrl: 'app/pages/feeds/importSpartan3/importSpartan3.html',
			title: '_menu_import_feed_',
			controller: 'importSpartan3Ctrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_feeds_',
				state: 'feeds.myfeeds',
				parent_data: {
					title: '_menu_feeds_'
				}
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.importXml', ['ngFileUpload']).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('feeds.importXml', {
			url: '/import-xml',
			templateUrl: 'app/pages/feeds/importXML/importXML.html',
			title: '_menu_import_feed_',
			controller: 'importXmlCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_feeds_',
				state: 'feeds.myfeeds',
				parent_data: {
					title: '_menu_feeds_'
				}
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.importXmlFeed', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('feeds.importXmlFeed', {
			url: '/import-xml/{uuid:string}',
			templateUrl: 'app/pages/feeds/importXMLFeed/importXMLFeed.html',
			title: '_menu_import_feed_',
			controller: 'importXmlFeedCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_feeds_',
				state: 'feeds.myfeeds',
				parent_data: {
					title: '_menu_feeds_'
				}
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.manualFeedsHistory', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('feeds.manualFeedsHistory', {
			url: '/manualfeedshistory/{uuid:string}',
			templateUrl: 'app/pages/feeds/manualFeedHistory/manualFeedsHistory.html',
			title: '_m_f_feeds_manual_feeds_history_',
			controller: 'manualFeedsHistoryCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_feeds_my_manual_feeds_',
				state: 'feeds.mymanualfeeds',
				parent_data: {
					title: '_menu_feeds_'
				}
			},
			disable_herd_selector: true,
			resolve: {
				accessContols: [
					'$q',
					'authService',
					function ($q, authService) {
						if (authService.can(64)) {
							return true;
						} else {
							return $q.reject('Unauthorized');
						}
					}
				]
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.myfeeds', ['ngSanitize', 'ui.select']).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('feeds.myfeeds', {
			url: '/myfeeds',
			templateUrl: 'app/pages/feeds/myfeeds/myfeeds.html',
			title: '_menu_my_feeds_',
			controller: 'myfeedsCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_feeds_'
			},
			keep_premix_data: true,
			sidebarMeta: {
				order: 0,
				accessControl: 16
			},resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.mymanualfeeds', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('feeds.mymanualfeeds', {
			url: '/mymanualfeeds',
			templateUrl: 'app/pages/feeds/myManualFeeds/myManualFeeds.html',
			title: '_m_f_feeds_my_manual_feeds_',
			controller: 'myManualFeedsCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_feeds_'
			},
			sidebarMeta: {
				order: 200,
				accessControl: 64
			},
			resolve: {
				accessContols: [
					'$q',
					'authService',
					function ($q, authService) {
						if (authService.can(64)) {
							return true;
						} else {
							return $q.reject('Unauthorized');
						}
					}
				]
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.iManagement.addNewIngredient', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('iManagement.addNewIngredient', {
			url: '/addNewIngredient',
			templateUrl: 'app/pages/ingredientsManagement/addNewIngredient/addNewIngredient.html',
			title: '_m_f_menu_add_new_ingredient_',
			controller: 'addNewIngredientCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_ingredients_management_stocking_',
				state: 'iManagement.inventory',
				parent_data: {
					title: '_m_f_menu_ingredients_management_'
				}
			},
			keep_recipe_data: true,
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.iManagement.editIngredient', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('iManagement.editIngredient', {
			url: '/editIngredient/{uuid:string}',
			templateUrl: 'app/pages/ingredientsManagement/editIngredient/editIngredient.html',
			title: '_m_f_menu_ingredients_edit_ingredient_',
			controller: 'editIngredientCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_ingredients_management_stocking_',
				state: 'iManagement.inventory',
				parent_data: {
					title: '_m_f_menu_ingredients_management_'
				}
			},
			disable_herd_selector: true,
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.iManagement.ingredientHistory', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('iManagement.ingredientHistory', {
			url: '/ingredientHistory/{uuid:string}',
			templateUrl: 'app/pages/ingredientsManagement/ingredientHistory/ingredientHistory.html',
			title: '_m_f_menu_ingredients_ingredient_history_',
			controller: 'ingredientHistoryCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_ingredients_management_stocking_',
				state: 'iManagement.inventory',
				parent_data: {
					title: '_m_f_menu_ingredients_management_'
				}
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.iManagement.ingredientDetails', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('iManagement.ingredientDetails', {
			url: '/ingredientDetails/{uuid:string}',
			templateUrl: 'app/pages/ingredientsManagement/ingredientDetails/ingredientDetails.html',
			title: '_m_f_menu_ingredients_details_',
			controller: 'ingredientDetailsCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_ingredients_management_stocking_',
				state: 'iManagement.inventory',
				parent_data: {
					title: '_m_f_menu_ingredients_management_'
				}
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.iManagement.ingredientUsageOverview', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('iManagement.ingredientUsageOverview', {
			url: '/ingredientUsageOverview',
			templateUrl: 'app/pages/ingredientsManagement/ingredientUsageOverview/ingredientUsageOverview.html',
			title: '_m_f_ingredient_usage_overview_',
			controller: 'ingredientUsageOverviewCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_ingredients_management_'
			},
			sidebarMeta: {
				order: 300,
				accessControl: 64
			},
			resolve: {
				accessContols: [
					'$q',
					'authService',
					function ($q, authService) {
						if (authService.can(64)) {
							return true;
						} else {
							return $q.reject('Unauthorized');
						}
					}
				]
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.iManagement.inventory', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('iManagement.inventory', {
			url: '/inventory',
			templateUrl: 'app/pages/ingredientsManagement/inventory/inventory.html',
			title: '_m_f_menu_ingredients_management_stocking_',
			controller: 'inventoryCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_ingredients_management_'
			},
			sidebarMeta: {
				order: 100,
				accessControl: 64
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.iManagement.overview', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('iManagement.overview', {
			url: '/overview',
			templateUrl: 'app/pages/ingredientsManagement/overview/overview.html',
			title: '_m_f_menu_ingredients_overview_',
			controller: 'overviewCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_ingredients_management_'
			},
			sidebarMeta: {
				order: 200,
				accessControl: 64
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.mixerWagons.addNewWagon', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('mixerWagons.addNewWagon', {
			url: '/addNewWagon',
			templateUrl: 'app/pages/mixerWagons/addNewWagon/addNewWagon.html',
			title: '_m_f_menu_wagons_add_wagon_',
			controller: 'addNewWagonCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_wagons_my_wagons_',
				state: 'mixerWagons.myWagons',
				parent_data: {
					title: '_m_f_menu_mixer_wagons_'
				}
			},
			sidebarMeta: {
				order: 200,
				accessControl: 64
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.mixerWagons.editWagon', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('mixerWagons.editWagon', {
			url: '/editWagon/{uuid:string}',
			templateUrl: 'app/pages/mixerWagons/editWagon/editWagon.html',
			title: '_m_f_menu_wagons_edit_wagon_',
			controller: 'editWagonCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_wagons_my_wagons_',
				state: 'mixerWagons.myWagons',
				parent_data: {
					title: '_m_f_menu_mixer_wagons_'
				}
			},
			disable_herd_selector: true,
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.mixerWagons.myWagons', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('mixerWagons.myWagons', {
			url: '/myWagons',
			templateUrl: 'app/pages/mixerWagons/myWagons/myWagons.html',
			title: '_m_f_menu_wagons_my_wagons_',
			controller: 'myWagonsCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_mixer_wagons_'
			},
			sidebarMeta: {
				order: 100,
				accessControl: 64
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.mixerWagons.wagonHistory', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('mixerWagons.wagonHistory', {
			url: '/wagonHistory/{uuid:string}',
			templateUrl: 'app/pages/mixerWagons/wagonHistory/wagonHistory.html',
			title: '_m_f_menu_wagons_wagon_history_',
			controller: 'wagonHistoryCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_wagons_my_wagons_',
				state: 'mixerWagons.myWagons',
				parent_data: {
					title: '_m_f_menu_mixer_wagons_'
				}
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.pens.addNewPen', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('pens.addNewPen', {
			url: '/addNewPen',
			templateUrl: 'app/pages/pens/addNewPen/addNewPen.html',
			title: '_m_f_menu_pens_add_new_pen_',
			controller: 'addNewPenCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_pens_my_pens_',
				state: 'pens.myPens',
				parent_data: {
					title: '_menu_pens_'
				}
			},
			sidebarMeta: {
				order: 200,
				accessControl: 64
			},
			keep_recipe_data: true,
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.pens.editPen', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('pens.editPen', {
			url: '/editPen/{uuid:string}',
			templateUrl: 'app/pages/pens/editPen/editPen.html',
			title: '_m_f_menu_pens_edit_pen_',
			controller: 'editPenCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_pens_my_pens_',
				state: 'pens.myPens',
				parent_data: {
					title: '_menu_pens_'
				}
			},
			disable_herd_selector: true,
			keep_recipe_data: true,
			keep_calendar_filter: true,
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.pens.myPens', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('pens.myPens', {
			url: '/myPens',
			templateUrl: 'app/pages/pens/myPens/myPens.html',
			title: '_m_f_menu_pens_my_pens_',
			controller: 'myPensCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_pens_'
			},
			sidebarMeta: {
				order: 100,
				accessControl: 64
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.pens.penDetails', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('pens.penDetails', {
			url: '/penDetails/{uuid:string}',
			templateUrl: 'app/pages/pens/penDetails/penDetails.html',
			title: '_m_f_menu_pens_details_',
			controller: 'penDetailsCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_pens_my_pens_',
				state: 'pens.myPens',
				parent_data: {
					title: '_menu_pens_'
				}
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.pens.penHistory', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('pens.penHistory', {
			url: '/penHistory/{uuid:string}',
			templateUrl: 'app/pages/pens/penHistory/penHistory.html',
			title: '_m_f_menu_pens_history_',
			controller: 'penHistoryCtrl',
			controllerAs: 'vm',
			keep_recipe_data: true,
			parent_data: {
				title: '_m_f_menu_pens_my_pens_',
				state: 'pens.myPens',
				parent_data: {
					title: '_menu_pens_'
				}
			},
			disable_herd_selector: true,
			resolve: {
				accessContols: [
					'$q',
					'authService',
					function ($q, authService) {
						if (authService.can(64)) {
							return true;
						} else {
							return $q.reject('Unauthorized');
						}
					}
				]
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.premixes.addNewPremix', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('premixes.addNewPremix', {
			url: '/addNewPremix',
			templateUrl: 'app/pages/premixes/addNewPremix/addNewPremix.html',
			title: '_m_f_menu_premixes_add_new_premix_',
			controller: 'addNewPremixCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_premixes_my_premixes_',
				state: 'premixes.myPremixes',
				parent_data: {
					title: '_m_f_menu_premixes_'
				}
			},
			sidebarMeta: {
				order: 300,
				accessControl: 64
			},
			keep_premix_data: true,
			resolve: {
				accessContols: [
					'$q',
					'authService',
					function ($q, authService) {
						if (authService.can(64)) {
							return true;
						} else {
							return $q.reject('Unauthorized');
						}
					}
				]
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.premixes.myPremixes', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('premixes.myPremixes', {
			url: '/myPremixes',
			templateUrl: 'app/pages/premixes/myPremixes/myPremixes.html',
			title: '_m_f_menu_premixes_my_premixes_',
			controller: 'myPremixesCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_premixes_'
			},
			sidebarMeta: {
				order: 200,
				accessControl: 64
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.premixes.editPremix', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('premixes.editPremix', {
			url: '/editPremix/{uuid:string}',
			templateUrl: 'app/pages/premixes/editPremix/editPremix.html',
			title: '_m_f_menu_premixes_edit_premix_',
			controller: 'editPremixCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_premixes_my_premixes_',
				state: 'premixes.myPremixes',
				parent_data: {
					title: '_m_f_menu_premixes_'
				}
			},
			disable_herd_selector: true,
			keep_edit_premix_data: true,
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.addnewration', ['ngSanitize', 'ui.select']).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('rations.addnewration', {
			url: '/addnewration',
			templateUrl: 'app/pages/rations/addNewRation/addNewRation.html',
			title: '_menu_add_new_ration_',
			controller: 'addNewRationCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_rations_',
				state: 'rations.myrations',
				parent_data: {
					title: '_menu_rations_'
				}
			},
			sidebarMeta: {
				order: 200,
				accessControl: 16
			},
            keep_recipe_data: true,
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		})
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.addmanualration', ['ngSanitize', 'ui.select']).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('rations.addmanualration', {
			url: '/addmanualration',
			templateUrl: 'app/pages/rations/addManualRation/addManualRation.html',
			title: '_menu_add_manual_ration_',
			controller: 'addManualRationCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_manual_rations_',
				state: 'rations.manualrations',
				parent_data: {
					title: '_menu_rations_'
				}
			},
			sidebarMeta: {
				order: 600,
				accessControl: 64
			},
			keep_recipe_data: true,
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.editmanualration', ['ngSanitize', 'ui.select']).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('rations.editmanualration', {
			url: '/editmanualration/{uuid:string}',
			templateUrl: 'app/pages/rations/editManualRation/editManualRation.html',
			title: '_menu_edit_manual_ration_',
			controller: 'editManualRationCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_manual_rations_',
				state: 'rations.manualrations',
				parent_data: {
					title: '_menu_rations_'
				}
			},
            disable_herd_selector: true,
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();
(function () {
	'use strict';
	angular.module('Spartan.pages.rations.balanceRation', [, 'ngSanitize', 'ui.select', 'chart.js']).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('rations.balanceration', {
			url: '/balance/{uuid:string}',
			templateUrl: 'app/pages/rations/balanceRation/balanceRation.html',
			title: '_menu_rations_balance_',
			controller: 'balanceRationCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_rations_',
				state: 'rations.myrations',
				parent_data: {
					title: '_menu_rations_'
				}
			},
			disable_herd_selector: true,
			keep_recipe_data: true,
			keep_premix_data: true,
			keep_edit_premix_data: true,
			resolve: {
				accessContols: [
					'$q',
					'authService',
					function ($q, authService) {
						if (authService.can(16)) {
							return true;
						} else {
							return $q.reject('Unauthorized');
						}
					}
				]
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.importration', ['ngSanitize', 'ui.select']).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('rations.importration', {
			url: '/import',
			templateUrl: 'app/pages/rations/importRation/importRation.html',
			title: '_menu_import_ration_',
			controller: 'importRationCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_rations_',
				state: 'rations.myrations',
				parent_data: {
					title: '_menu_rations_'
				}
			},
			sidebarMeta: {
				order: 300,
				accessControl: 16
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.importrationnew', ['ngSanitize', 'ui.select']).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('rations.importrationnew', {
			url: '/import/new/{uuid:string}',
			templateUrl: 'app/pages/rations/importRationNew/importRationNew.html',
			title: '_menu_import_ration_',
			controller: 'importRationNewCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_rations_',
				state: 'rations.myrations',
				parent_data: {
					title: '_menu_rations_'
				}
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.manualRationFeedsHistory', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('rations.manualRationFeedsHistory', {
			url: '/manualrationfeedshistory/{uuid:string}',
			templateUrl: 'app/pages/rations/manualRationFeedHistory/manualRationFeedHistory.html',
			title: '_m_f_rations_manual_ration_feeds_history_',
			controller: 'manualRationFeedsHistoryCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_manual_rations_',
				state: 'rations.manualrations',
				parent_data: {
					title: '_menu_rations_'
				}
			},
			resolve: {
				accessContols: [
					'$q',
					'authService',
					function ($q, authService) {
						if (authService.can(64)) {
							return true;
						} else {
							return $q.reject('Unauthorized');
						}
					}
				]
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.manualRationsHistory', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('rations.manualRationsHistory', {
			url: '/manualrationshistory/{uuid:string}',
			templateUrl: 'app/pages/rations/manualRationHistory/manualRationHistory.html',
			title: '_m_f_rations_manual_rations_history_',
			controller: 'manualRationsHistoryCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_manual_rations_',
				state: 'rations.manualrations',
				parent_data: {
					title: '_menu_rations_'
				}
			},
			disable_herd_selector: true,
			resolve: {
				accessContols: [
					'$q',
					'authService',
					function ($q, authService) {
						if (authService.can(64)) {
							return true;
						} else {
							return $q.reject('Unauthorized');
						}
					}
				]
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.manualrations', ['ngSanitize', 'ui.select']).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('rations.manualrations', {
			url: '/manualrations',
			templateUrl: 'app/pages/rations/myManualRations/myManualRations.html',
			title: '_menu_manual_rations_',
			controller: 'myManualRationsCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_rations_'
			},
			sidebarMeta: {
				order: 500,
				accessControl: 64
			},
			resolve: {
				'accessContols': ['$q', 'authService', function ($q, authService) {
					if (authService.can(64)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.myrations', ['ngSanitize', 'ui.select']).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('rations.myrations', {
			url: '/myrations',
			templateUrl: 'app/pages/rations/myRations/myRations.html',
			title: '_menu_my_rations_',
			controller: 'myRationsCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_rations_'
			},
			sidebarMeta: {
				order: 100,
				accessControl: 16
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.rationComparison', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('rations.rationComparison', {
			url: '/rationComparison/compare',
			templateUrl: 'app/pages/rations/rationComparison/rationComparison.html',
			title: '_menu_rations_comparison_',
			controller: 'rationComparisonCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_rations_',
				state: 'rations.myrations',
				parent_data: {
					title: '_menu_rations_'
				}
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.rationFeedHistory', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('rations.rationFeedHistory', {
			url: '/rationFeedHistory/{uuid:string}',
			templateUrl: 'app/pages/rations/rationFeedHistory/rationFeedHistory.html',
			title: '_menu_history_',
			controller: 'rationFeedHistoryCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_rations_',
				state: 'rations.myrations',
				parent_data: {
					title: '_menu_rations_'
				}
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.rationComparisonList', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('rations.rationComparisonList', {
			url: '/rationComparison',
			templateUrl: 'app/pages/rations/rationComparisonList/rationComparisonList.html',
			title: '_menu_rations_comparison_',
			controller: 'rationComparisonListCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_rations_',
				state: 'rations.myrations',
				parent_data: {
					title: '_menu_rations_'
				}
			},
			sidebarMeta: {
				order: 400,
				accessControl: 16
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.reports.compliance', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('reports.compliance', {
			url: '/reports/compliance',
			templateUrl: 'app/pages/reports/complianceDashboard/complianceDashboard.html',
			title: '_m_f_menu_reports_compliance_',
			controller: 'complianceCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_reports_'
			},
			sidebarMeta: {
				order: 400,
				accessControl: 64
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.reports.communication', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('reports.communication', {
			url: '/reports/communication',
			templateUrl: 'app/pages/reports/communication/communication.html',
			title: '_m_f_menu_reports_pricing_',
			controller: 'communicationCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_reports_'
			},
			sidebarMeta: {
				order: 400,
				accessControl: 64
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.rationHistory', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('rations.rationHistory', {
			url: '/{groupId:string}/rationHistory/{rationId:string}',
			templateUrl: 'app/pages/rations/rationHistory/rationHistory.html',
			title: '_menu_history_',
			controller: 'rationHistoryCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_rations_',
				state: 'rations.myrations',
				parent_data: {
					title: '_menu_rations_'
				}
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(16)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.reports.weighback', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('reports.weighback', {
			url: '/reports/weighback',
			templateUrl: 'app/pages/reports/weighback/weighback.html',
			title: '_m_f_menu_reports_weighback_',
			controller: 'weighbackCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_reports_'
			},
			sidebarMeta: {
				order: 300,
				accessControl: 64
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.reports.mixing', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('reports.mixing', {
			url: '/reports/loading',
			templateUrl: 'app/pages/reports/mixing/mixing.html',
			title: '_m_f_menu_reports_mixing_',
			controller: 'mixingCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_reports_'
			},
			sidebarMeta: {
				order: 100,
				accessControl: 64
			},
			keep_calendar_filter: true,
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.recipes.addNewRecipe', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('recipes.addNewRecipe', {
			url: '/addNewRecipe',
			templateUrl: 'app/pages/recipes/addNewRecipe/addNewRecipe.html',
			title: '_m_f_menu_recipes_add_new_recipe_',
			controller: 'addNewRecipeCtrl',
			controllerAs: 'vm',
			keep_recipe_data: true,
			parent_data: {
				title: '_m_f_menu_recipes_my_recipes_',
				state: 'recipes.myRecipes',
				parent_data: {
					title: '_menu_recipes_'
				}
			},
			sidebarMeta: {
				order: 200,
				accessControl: 64
			},
			resolve: {
				accessContols: [
					'$q',
					'authService',
					function ($q, authService) {
						if (authService.can(64)) {
							return true;
						} else {
							return $q.reject('Unauthorized');
						}
					}
				]
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.reports.dropping', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('reports.dropping', {
			url: '/reports/dropping',
			templateUrl: 'app/pages/reports/dropping/dropping.html',
			title: '_m_f_menu_reports_dropping_',
			controller: 'droppingCtrl',
			controllerAs: 'vm',
			sidebarMeta: {
				order: 200,
				accessControl: 64
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.recipes.editRecipe', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('recipes.editRecipe', {
			url: '/editRecipe/{uuid:string}',
			templateUrl: 'app/pages/recipes/editRecipe/editRecipe.html',
			title: '_m_f_menu_recipes_edit_recipe_',
			controller: 'editRecipeCtrl',
			controllerAs: 'vm',
			keep_recipe_data: true,
			parent_data: {
				title: '_m_f_menu_recipes_my_recipes_',
				state: 'recipes.myRecipes',
				parent_data: {
					title: '_menu_recipes_'
				}
			},
			disable_herd_selector: true,
			keep_calendar_filter: true,
			resolve: {
				accessContols: [
					'$q',
					'authService',
					function ($q, authService) {
						if (authService.can(64)) {
							return true;
						} else {
							return $q.reject('Unauthorized');
						}
					}
				]
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.recipes.myRecipes', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('recipes.myRecipes', {
			url: '/myRecipes',
			templateUrl: 'app/pages/recipes/myRecipes/myRecipes.html',
			title: '_m_f_menu_recipes_my_recipes_',
			controller: 'myRecipesCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_recipes_'
			},
			sidebarMeta: {
				order: 100,
				accessControl: 64
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.recipes.recipeDetails', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('recipes.recipeDetails', {
			url: '/recipeDetails/{uuid:string}',
			templateUrl: 'app/pages/recipes/recipeDetails/recipeDetails.html',
			title: '_m_f_menu_recipe_details_',
			controller: 'recipeDetailsCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_recipes_my_recipes_',
				state: 'recipes.myRecipes',
				parent_data: {
					title: '_menu_recipes_'
				}
			},
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.recipes.recipeHistory', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('recipes.recipeHistory', {
			url: '/recipeHistory/{uuid:string}',
			templateUrl: 'app/pages/recipes/recipeHistory/recipeHistory.html',
			title: '_m_f_menu_recipes_history_',
			controller: 'recipeHistoryCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_m_f_menu_recipes_my_recipes_',
				state: 'recipes.myRecipes',
				parent_data: {
					title: '_menu_recipes_'
				}
			},
			disable_herd_selector: true,
			resolve: {
                'accessContols': ['$q', 'authService', function ($q, authService) {
                    if (authService.can(64)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
		});
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.teams.addNewTeam', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('teams.addNewTeam', {
			url: '/addNewTeam',
			templateUrl: 'app/pages/teams/addNewTeam/addNewTeam.html',
			title: '_menu_add_new_team_',
			controller: 'addNewTeamCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_my_teams_',
				state: 'teams.myTeams',
				parent_data: {
					title: '_menu_teams_'
				}
			},
			sidebarMeta: {
				order: 200
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.teams.myTeams', []).config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('teams.myTeams', {
			url: '/myTeams',
			templateUrl: 'app/pages/teams/myTeams/myTeams.html',
			title: '_menu_my_teams_',
			controller: 'myTeamsCtrl',
			controllerAs: 'vm',
			parent_data: {
				title: '_menu_teams_'
			},
			sidebarMeta: {
				order: 100
			}
		});
	}
})();

'use strict';

// Promise that resolves when the Tableau v3 embedding shim has loaded.
// Controllers gate viz creation on this so they can run before/after the
// async ES module that exposes window.TableauV3 has finished loading.
window.tableauV3Ready = new Promise(function (resolve) {
	if (window.TableauV3) {
		resolve();
		return;
	}
	window.addEventListener('tableau-v3-ready', function () { resolve(); }, false);
});

// Polyfill angular.lowercase/uppercase removed in 1.7 — needed by textAngular
if (!angular.lowercase) {
	angular.lowercase = function (str) { return (str && typeof str === 'string') ? str.toLowerCase() : str; };
}
if (!angular.uppercase) {
	angular.uppercase = function (str) { return (str && typeof str === 'string') ? str.toUpperCase() : str; };
}

angular
	.module('Spartan', [
		//'auth0.lock',
		'angular-jwt',
		'ngAnimate',
		'ui.bootstrap',
		'ui.sortable',
		'ui.router',
		'dndLists',
		'ngTouch',
		'toastr',
		'smart-table',
		'xeditable',
		'ngCookies',
		'angular-tour',
		'tmh.dynamicLocale',
		'ui.slimscroll',
		'localization',
		'angularSpinners',
		'rzModule',
		'angular.filter',
		'angularLazyImg',
		'moment-picker',
		'Spartan.theme',
		'Spartan.pages',
		'Spartan.login',
		'Spartan.components'
	])
	.config(appConfig)
	.run(appRun)
	.factory('$exceptionHandler', catchExceptions);

var host = window.location.origin;
var apiTime = 45000; //time in ms for bugsnag

/** @ngInject */
function appConfig($httpProvider, jwtOptionsProvider, $locationProvider, $uibTooltipProvider, tmhDynamicLocaleProvider, APP_CONST, toastrConfig, bugsnagServiceProvider) {
	bugsnagServiceProvider.load(host, APP_CONST);
	setupGoogleAnalytics();
	$uibTooltipProvider.options({
		appendToBody: true
	});
	jwtOptionsProvider.config({
		tokenGetter: [
			'options',
			function () {
				return localStorage.getItem('id_token');
			}
		],
		whiteListedDomains: ['localhost', APP_CONST.api_domen, 'visuals.mmmooogle.com', 'tabvis.mmmooogle.com', APP_CONST.animals_domen, 'bovinet.auth0.com', APP_CONST.tableau_domen]
		//, unauthenticatedRedirectPath: '/login'
	});
	$locationProvider.html5Mode(true);
	$locationProvider.hashPrefix('');
	// Add the jwtInterceptorto the array of HTTP interceptors
	// so that JWTs are attached as Authorization headers
	$httpProvider.interceptors.push('jwtInterceptor');
	$httpProvider.interceptors.push(retryInterceptor);
	$httpProvider.interceptors.push(httpInterceptor);
	$httpProvider.interceptors.push(cacheInterceptor);
	tmhDynamicLocaleProvider.localeLocationPattern('assets/js/angular-i18n/angular-locale_{{locale}}.js');

	function retryInterceptor($injector, $q, $timeout, bugsnagService) {
		return {
			responseError: function (response) {
				if (response && response.status !== 401 && response.status !== 403 && response.config && response.config.method === 'GET' && !response.config._done && !response.config.url.includes('_retry')) {
					/*return $timeout(function () {
						var $http = $injector.get('$http');
						response.config._done = true;
						if (response.config.url.includes('?')) {
							response.config.url += '&_retry=1';
						} else {
							response.config.url += '?_retry=1';
						}
						bugsnagService.logMessage('Request retried', response.data, 'warning');
						//TO-DO remove toastr
						var toastr = $injector.get('toastr');
						toastr.warning('Request retried');
						return $http(response.config);
					}, 2000);*/
				}

				return $q.reject(response);
			}
		};
	}

	function httpInterceptor($q, $timeout, $filter, $injector, bugsnagService) {
		return {
			responseError: responseError,
			request: requestFn,
			response: responseFn
		};

		function responseError(rejection) {
			bugsnagService.logError(rejection);
			if (rejection.status === 401) {
				localStorage.removeItem('id_token');
				localStorage.removeItem('user_settings');
				$timeout(function () {
					var state = $injector.get('$state');
					state.go('login');
				}, 1);
			}
			return $q.reject(rejection);
		}

		function requestFn(config) {
			if (config.url.indexOf('mmmooogle.com') !== -1) {
				config.requestTiming = performance.now();
			}
			return config;
		}

		function responseFn(response) {
			if (response.config.url.indexOf('mmmooogle.com') !== -1) {
				response.config.responseTiming = performance.now();
				var timing = response.config.responseTiming - response.config.requestTiming;
				if (timing > apiTime) {
					bugsnagService.logTimingError(response, timing);
				}
				if (timing > 15000) {
					var toastr = $injector.get('toastr');
					toastr.clear();
					toastr.info($filter('i18n')('_ration_request_info_'));
				}
			}
			return response;
		}
	}

	function cacheInterceptor() {
		return {
			request: function (request) {
				if (request.url.indexOf(APP_CONST.api_domen) == -1 && request.url.indexOf('spartan-visuals.mmmooogle.com') == -1) {
					if (request.url.indexOf('.js') != -1 || request.url.indexOf('.css') != -1 || request.url.indexOf('.jpg') != -1 || request.url.indexOf('.jpeg') != -1 || request.url.indexOf('.gif') != -1 || request.url.indexOf('.png') != -1) {
						request.url = request.url + '?time=' + APP_CONST.buildTimeStamp;
					}
				}
				return request;
			}
		};
	}

	function setupGoogleAnalytics() {
		var elem = document.createElement('script');
		elem.src = 'https://www.googletagmanager.com/gtag/js?id=' + APP_CONST.analytics_key;
		elem.type = 'text/javascript';
		document.getElementsByTagName('head')[0].appendChild(elem);
	}

	angular.extend(toastrConfig, {
		autoDismiss: false,
		containerId: 'toast-container',
		maxOpened: 0,
		newestOnTop: true,
		positionClass: 'toast-top-left',
		preventDuplicates: false,
		preventOpenDuplicates: false,
		target: 'main',
		timeOut: '10000'
	});
}
/** @ngInject */
function appRun($rootScope, $state, $window, $timeout, $location, editableOptions, cookiesService, APP_CONST, $cookies, toastr, $filter, authService, authManager) {
	var connectionTimer;
	checkVersion();
	authManager.checkAuthOnRefresh();
	editableOptions.activate = 'select';
	$rootScope.$on('$stateChangeStart', stateChange);
	$rootScope.$on('$stateChangeSuccess', stateChangeSuccess);
	$rootScope.$on('$stateChangeError', stateChangeError);
	if (localStorage.getItem('dirty')) {
		localStorage.removeItem('dirty');
	}

	function gtag() {
		$window.dataLayer = $window.dataLayer || [];
		dataLayer.push(arguments);
	}

	try {
		gtag('js', new Date());
		gtag('set', {
			page_title: $location.path()
		});
		gtag('config', APP_CONST.analytics_key);
	} catch (error) {
		console.log(error);
	}

	function stateChange(event, toState) {
		var token = localStorage.getItem('id_token');
		var user_settings = localStorage.getItem('user_settings');
		var calendar_login = localStorage.getItem('calendar_login');
		if (token && user_settings && authService.isAuthenticated()) {
			if (toState.name === 'login') {
				event.preventDefault();
				$state.go('dashboard');
			} else if (toState.name === 'dashboard') {
				if (calendar_login) {
					event.preventDefault();
					localStorage.removeItem('calendar_login');
					$state.go('calendar');
				}
			} else if (toState.name === 'pens.editPen') {
				if ($state.current.name != 'recipes.addNewRecipe' || $state.current.name != '') {
					localStorage.removeItem('recipe_details');
				}
			} else if (toState.name === 'recipes.addNewRecipe') {
				if ($state.current.name == 'pens.editPen' || $state.current.name == '') {
					console.log('preload');
				} else {
					localStorage.removeItem('recipe_details');
				}
			} else if (toState.name === 'pens.myPens') {
				if ($state.current.name != 'pens.editPen' && $state.current.name != 'pens.penDetails' && $state.current.name != 'pens.penHistory') {
					localStorage.removeItem('pen_curent_page');
				}
			}
		} else {
			if (toState.name !== 'login') {
				var sso = localStorage.getItem('auth0.ssodata');
				localStorage.clear();
				if (sso) {
					localStorage.setItem('auth0.ssodata', sso);
				}
				event.preventDefault();
				$state.go('login');
			}
			if (toState.name === 'calendar') {
				localStorage.setItem('calendar_login', true);
			}
		}
	}

	function stateChangeSuccess() {
		try {
			gtag('set', {
				page_title: $location.path()
			});
		} catch (error) {
			console.error(error);
		}
	}

	function stateChangeError(event, toState, toParams, fromState, fromParams, error) {
		if (error == 'Unauthorized') {
			var state = {
				name: toState.name,
				param: toParams
			};
			localStorage.setItem('toState', JSON.stringify(state));
			event.preventDefault();
		}
	}

	function checkVersion() {
		var expireDate = new Date();
		expireDate.setDate(expireDate.getDate() + 1);
		var currentVersion = $cookies.get('version');
		if (currentVersion) {
			if (currentVersion != APP_CONST.buildTimeStamp) {
				cookiesService.setCookie('version', APP_CONST.buildTimeStamp, {
					samesite: 'strict',
					expires: expireDate
				});
				window.location.reload(true);
			}
		} else {
			cookiesService.setCookie('version', APP_CONST.buildTimeStamp, {
				samesite: 'strict',
				expires: expireDate
			});
		}
	}

	window.onbeforeunload = function () {
		var dirty = localStorage.getItem('dirty');
		if (dirty) {
			return 'Are you sure you want to navigate away?';
		}
	};

	$rootScope.online = navigator.onLine;
	$window.addEventListener(
		'offline',
		function () {
			$rootScope.online = false;
			if (connectionTimer) {
				$timeout.cancel(connectionTimer);
			}
			connectionTimer = $timeout(function () {
				if (!$rootScope.online) {
					var offlineMsg = document.getElementById('offline-message');
					document.getElementsByTagName('html')[0].setAttribute('offline', true);
					offlineMsg.setAttribute('aria-hidden', 'false');
					setTimeout(function () {
						offlineMsg.focus();
					}, 400);
				}
			}, 750);
		},
		false
	);

	$window.addEventListener(
		'online',
		function () {
			$rootScope.online = true;
			if (connectionTimer) {
				$timeout.cancel(connectionTimer);
			}
			connectionTimer = $timeout(function () {
				if ($rootScope.online) {
					var offlineMsg = document.getElementById('offline-message');
					document.getElementsByTagName('html')[0].setAttribute('offline', false);
					offlineMsg.setAttribute('aria-hidden', 'true');
					var onlineMsg = document.getElementById('online-message');
					document.getElementsByTagName('html')[0].setAttribute('online', true);
					onlineMsg.setAttribute('aria-hidden', 'true');
					setTimeout(function () {
						onlineMsg.focus();
					}, 400);

					setTimeout(function () {
						onlineMsg.setAttribute('aria-hidden', 'false');
						document.getElementsByTagName('html')[0].setAttribute('online', false);
					}, 3200);
				}
			}, 750);
		},
		false
	);
}

/** @ngInject */
function catchExceptions($log, bugsnagService, $injector) {
	return function (exception) {
		var errorService = $injector.get('errorService');
		$log.error(exception);
		var completed = bugsnagService.logUnhandledError(exception);
		if (completed) {
			//errorService.showErrorMessage(exception, true, '_unhandled_error_occurred_');
		}
	};
}

'use strict';

/*
 * An AngularJS Localization Service
 *
 * Written by Jim Lavin
 * http://codingsmackdown.tv
 *
 */

angular
	.module('localization', [])
	// localization service responsible for retrieving resource files from the server and
	// managing the translation dictionary
	.provider('localize', function localizeProvider() {
		this.languages = ['en-gb', 'en-us', 'nl-nl', 'cs-cz', 'es-es', 'it-it', 'pl-pl', 'pt-br', 'de-de'];
		this.defaultLanguage = 'en-gb';
		this.ext = 'json';
		this.baseUrl = '/assets/js/i18n/';

		var provider = this;

		this.$get = [
			'$http',
			'$rootScope',
			'$window',
			'$injector',
			function ($http, $rootScope, $window, $injector) {
				var debounce;
				var timeoutService = $injector.get('$timeout');
				var bugsnagService = $injector.get('bugsnagService');
				var localize = {
					// use the $window service to get the language of the user's browser
					language: '',
					// array to hold the localized resource string entries
					dictionary: [],
					// location of the resource file
					url: undefined,
					// flag to indicate if the service hs loaded the resource file
					resourceFileLoaded: false,

					// success handler for all server communication
					successCallback: function (data) {
						// store the returned array in the dictionary
						localize.dictionary = data;
						// set the flag that the resource are loaded
						localize.resourceFileLoaded = true;
						// broadcast that the file has been loaded
						$rootScope.$broadcast('localizeResourcesUpdated');
					},

					// allows setting of language on the fly
					setLanguage: function (value) {
						localize.language = this.fallbackLanguage(value);
						return localize.initLocalizedResources();
					},

					fallbackLanguage: function (value) {
						value = String(value);

						if (provider.languages.indexOf(value) > -1) {
							return value;
						}

						value = value.split('-')[0];

						if (provider.languages.indexOf(value) > -1) {
							return value;
						}

						return provider.defaultLanguage;
					},

					// allows setting of resource url on the fly
					setUrl: function (value) {
						localize.url = value;
						localize.initLocalizedResources();
					},
					// builds the url for locating an image
					buildImgUrl: function (imageUrl) {
						return $http({
							method: 'GET',
							url: imageUrl,
							cache: false
						});
					},
					// builds the url for locating the resource file
					buildUrl: function (baseUrl) {
						if (!localize.language) {
							var lang, androidLang;
							// works for earlier version of Android (2.3.x)
							if ($window.navigator && $window.navigator.userAgent && (androidLang = $window.navigator.userAgent.match(/android.*\W(\w\w)-(\w\w)\W/i))) {
								lang = androidLang[1];
							} else {
								// works for iOS, Android 4.x and other devices
								lang = $window.navigator.userLanguage || $window.navigator.language;
							}
							// set language
							localize.language = this.fallbackLanguage(lang);
						}
						return baseUrl + 'resources-locale_' + localize.language + '.' + provider.ext;
					},

					// loads the language resource file from the server
					initLocalizedResources: function () {
						// build the url to retrieve the localized resource file
						var url = localize.url || localize.buildUrl(provider.baseUrl);
						// request the resource file
						return $http({
							method: 'GET',
							url: url,
							cache: false
						})
							.then(function (response) {
								localize.successCallback(response.data);
							})
							.catch(function (error) {
								bugsnagService.logMessage('Translation resource file failed to load', error);
								// the request failed set the url to the default resource file
								var url = provider.baseUrl + 'resources-locale_en-GB' + '.' + provider.ext;
								// request the default resource file
								return $http({
									method: 'GET',
									url: url,
									cache: false
								}).then(function (response) {
									localize.successCallback(response.data);
								});
							});
					},

					// checks the dictionary for a localized resource string
					getLocalizedString: function (KEY) {
						// default the result to an empty string
						var result = '';

						// make sure the dictionary has valid data
						if (localize.resourceFileLoaded) {
							// use the filter service to only return those entries which match the KEY
							// and only take the first result
							var entry;
							for (var i = 0; i < localize.dictionary.length; i++) {
								if (localize.dictionary[i].key === KEY) {
									entry = localize.dictionary[i];
									break;
								}
							}
							// set the result
							if (!entry) {
								//console.log(KEY);
								if (debounce) {
									timeoutService.cancel(debounce);
								}
								debounce = timeoutService(function () {
									bugsnagService.logMessage('Translation key is missing, KEY: ' + KEY);
								}, 50);
							}
							result = entry.value ? entry.value : KEY;
						}
						// return the value to the call
						return result;
					}
				};

				// force the load of the resource file
				//localize.initLocalizedResources();

				// return the local instance when called
				return localize;
			}
		];
	})
	// simple translation filter
	// usage {{ TOKEN | i18n }}
	.filter('i18n', [
		'localize',
		function (localize) {
			return function (input) {
				return localize.getLocalizedString(input);
			};
		}
	])
	// translation directive that can handle dynamic strings
	// updates the text value of the attached element
	// usage <span data-i18n="TOKEN" ></span>
	// or
	// <span data-i18n="TOKEN|VALUE1|VALUE2" ></span>
	.directive('i18n', [
		'localize',
		function (localize) {
			var i18nDirective = {
				restrict: 'EAC',
				updateText: function (elm, token, html) {
					//console.log(token)
					var values = token.split('|');
					if (values.length >= 1) {
						// construct the tag to insert into the element
						var tag = localize.getLocalizedString(values[0]);
						// update the element only if data was returned
						if (tag !== null && tag !== undefined && tag !== '') {
							if (values.length > 1) {
								for (var index = 1; index < values.length; index++) {
									var target = '{' + (index - 1) + '}';
									tag = tag.replace(target, values[index]);
								}
							}
							// insert the text into the element
							elm[html ? 'html' : 'text'](tag);
						}
					}
				},

				link: function (scope, elm, attrs) {
					scope.$on('localizeResourcesUpdated', function () {
						i18nDirective.updateText(elm, attrs.i18n, angular.isDefined(attrs.i18nHtml));
					});

					attrs.$observe('i18n', function () {
						i18nDirective.updateText(elm, attrs.i18n, angular.isDefined(attrs.i18nHtml));
					});
				}
			};

			return i18nDirective;
		}
	])
	// translation directive that can handle dynamic strings
	// updates the attribute value of the attached element
	// usage <span data-i18n-attr="TOKEN|ATTRIBUTE" ></span>
	// or
	// <span data-i18n-attr="TOKEN|ATTRIBUTE|VALUE1|VALUE2" ></span>
	.directive('i18nAttr', [
		'localize',
		function (localize) {
			var i18NAttrDirective = {
				restrict: 'EAC',
				updateText: function (elm, token) {
					var values = token.split('|');
					// construct the tag to insert into the element
					var tag = localize.getLocalizedString(values[0]);
					// update the element only if data was returned
					if (tag !== null && tag !== undefined && tag !== '') {
						if (values.length > 2) {
							for (var index = 2; index < values.length; index++) {
								var target = '{' + (index - 2) + '}';
								tag = tag.replace(target, values[index]);
							}
						}
						// insert the text into the element
						elm.attr(values[1], tag);
					}
				},
				link: function (scope, elm, attrs) {
					scope.$on('localizeResourcesUpdated', function () {
						i18NAttrDirective.updateText(elm, attrs.i18nAttr);
					});

					attrs.$observe('i18nAttr', function (value) {
						i18NAttrDirective.updateText(elm, value);
					});
				}
			};

			return i18NAttrDirective;
		}
	])
	// translation directive that handles the localization of images.
	// usage <img data-i18n-img-src="IMAGE" />
	.directive('i18nImgSrc', [
		'localize',
		function (localize) {
			var i18NImageDirective = {
				restrict: 'A',
				link: function (scope, element, attrs) {
					var i18Nsrc = attrs.i18nImgSrc;
					var imagePath = provider.baseUrl + '/images/' + localize.language + '/';
					var imageUrl = imagePath + i18Nsrc;
					localize
						.buildImgUrl(imageUrl)
						.then(function () {
							element[0].src = imageUrl;
						})
						.catch(function () {
							element[0].src = provider.baseUrl + '/images/default/' + i18Nsrc;
						});
				}
			};
			return i18NImageDirective;
		}
	]);

/* xlsx-js-style 1.2.0-beta @ 2022-04-05T01:40:48.447Z */

(function(){
var XLSX={};function make_xlsx_lib(a){a.version="0.18.5",a.style_version="1.2.0";var re,f=1200,_=1252;"undefined"!=typeof cptable?re=cptable:"undefined"!=typeof module&&"undefined"!=typeof require&&(re=require("./cpexcel.js"));var t=[874,932,936,949,950,1250,1251,1252,1253,1254,1255,1256,1257,1258,1e4],l={0:1252,1:65001,2:65001,77:1e4,128:932,129:949,130:1361,134:936,136:950,161:1253,162:1254,163:1258,177:1255,178:1256,186:1257,204:1251,222:874,238:1250,255:1252,69:6969},c=function(e){-1!=t.indexOf(e)&&(_=l[0]=e)};var ie=function(e){c(f=e)};function h(){ie(1200),c(1252)}function ae(e){for(var t=[],r=0,a=e.length;r<a;++r)t[r]=e.charCodeAt(r);return t}function s(e){for(var t=[],r=0;r<e.length>>1;++r)t[r]=String.fromCharCode(e.charCodeAt(2*r+1)+(e.charCodeAt(2*r)<<8));return t.join("")}var ne=function(e){var t=e.charCodeAt(0),r=e.charCodeAt(1);return 255==t&&254==r?function(e){for(var t=[],r=0;r<e.length>>1;++r)t[r]=String.fromCharCode(e.charCodeAt(2*r)+(e.charCodeAt(2*r+1)<<8));return t.join("")}(e.slice(2)):254==t&&255==r?s(e.slice(2)):65279==t?e.slice(1):e},u=function(e){return String.fromCharCode(e)},n=function(e){return String.fromCharCode(e)};void 0!==re&&(ie=function(e){c(f=e)},ne=function(e){return 255===e.charCodeAt(0)&&254===e.charCodeAt(1)?re.utils.decode(1200,ae(e.slice(2))):e},u=function(e){return 1200===f?String.fromCharCode(e):re.utils.decode(f,[255&e,e>>8])[0]},n=function(e){return re.utils.decode(_,[e])[0]});var oe=null,d=!0,p="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";function ee(e){for(var t,r,a,n,s,i="",o=0,c=0,l=0;l<e.length;)n=(t=e.charCodeAt(l++))>>2,s=(3&t)<<4|(r=e.charCodeAt(l++))>>4,o=(15&r)<<2|(a=e.charCodeAt(l++))>>6,c=63&a,isNaN(r)?o=c=64:isNaN(a)&&(c=64),i+=p.charAt(n)+p.charAt(s)+p.charAt(o)+p.charAt(c);return i}function te(e){var t,r,a,n,s,i,o="";e=e.replace(/[^\w\+\/\=]/g,"");for(var c=0;c<e.length;)t=p.indexOf(e.charAt(c++))<<2|(n=p.indexOf(e.charAt(c++)))>>4,o+=String.fromCharCode(t),r=(15&n)<<4|(s=p.indexOf(e.charAt(c++)))>>2,64!==s&&(o+=String.fromCharCode(r)),a=(3&s)<<6|(i=p.indexOf(e.charAt(c++))),64!==i&&(o+=String.fromCharCode(a));return o}var se="undefined"!=typeof Buffer&&"undefined"!=typeof process&&void 0!==process.versions&&!!process.versions.node,ce=function(){if("undefined"==typeof Buffer)return function(){};var t=!Buffer.from;if(!t)try{Buffer.from("foo","utf8")}catch(e){t=!0}return t?function(e,t){return t?new Buffer(e,t):new Buffer(e)}:Buffer.from.bind(Buffer)}();function le(e){return se?Buffer.alloc?Buffer.alloc(e):new Buffer(e):new("undefined"!=typeof Uint8Array?Uint8Array:Array)(e)}function fe(e){return se?Buffer.allocUnsafe?Buffer.allocUnsafe(e):new Buffer(e):new("undefined"!=typeof Uint8Array?Uint8Array:Array)(e)}var he=function(e){return se?ce(e,"binary"):e.split("").map(function(e){return 255&e.charCodeAt(0)})};function o(e){if("undefined"==typeof ArrayBuffer)return he(e);for(var t=new ArrayBuffer(e.length),r=new Uint8Array(t),a=0;a!=e.length;++a)r[a]=255&e.charCodeAt(a);return t}function i(e){if(Array.isArray(e))return e.map(function(e){return String.fromCharCode(e)}).join("");for(var t=[],r=0;r<e.length;++r)t[r]=String.fromCharCode(e[r]);return t.join("")}function m(e){if("undefined"==typeof ArrayBuffer)throw new Error("Unsupported");if(e instanceof ArrayBuffer)return m(new Uint8Array(e));for(var t=new Array(e.length),r=0;r<e.length;++r)t[r]=e[r];return t}var ue=se?function(e){return Buffer.concat(e.map(function(e){return Buffer.isBuffer(e)?e:ce(e)}))}:function(e){if("undefined"==typeof Uint8Array)return[].concat.apply([],e.map(function(e){return Array.isArray(e)?e:[].slice.call(e)}));for(var t=0,r=0,t=0;t<e.length;++t)r+=e[t].length;for(var a,n=new Uint8Array(r),r=t=0;t<e.length;r+=a,++t)if(a=e[t].length,e[t]instanceof Uint8Array)n.set(e[t],r);else{if("string"==typeof e[t])throw"wtf";n.set(new Uint8Array(e[t]),r)}return n};var de=/\u0000/g,pe=/[\u0001-\u0006]/g;function v(e){for(var t="",r=e.length-1;0<=r;)t+=e.charAt(r--);return t}function x(e,t){e=""+e;return t<=e.length?e:Ge("0",t-e.length)+e}function w(e,t){e=""+e;return t<=e.length?e:Ge(" ",t-e.length)+e}function T(e,t){e=""+e;return t<=e.length?e:e+Ge(" ",t-e.length)}var g=Math.pow(2,32);function E(e,t){if(g<e||e<-g)return r=e,a=t,r=""+Math.round(r),a<=r.length?r:Ge("0",a-r.length)+r;var r,a,e=Math.round(e);return(t=t)<=(e=""+(e=e)).length?e:Ge("0",t-e.length)+e}function A(e,t){return t=t||0,e.length>=7+t&&103==(32|e.charCodeAt(t))&&101==(32|e.charCodeAt(t+1))&&110==(32|e.charCodeAt(t+2))&&101==(32|e.charCodeAt(t+3))&&114==(32|e.charCodeAt(t+4))&&97==(32|e.charCodeAt(t+5))&&108==(32|e.charCodeAt(t+6))}var C=[["Sun","Sunday"],["Mon","Monday"],["Tue","Tuesday"],["Wed","Wednesday"],["Thu","Thursday"],["Fri","Friday"],["Sat","Saturday"]],R=[["J","Jan","January"],["F","Feb","February"],["M","Mar","March"],["A","Apr","April"],["M","May","May"],["J","Jun","June"],["J","Jul","July"],["A","Aug","August"],["S","Sep","September"],["O","Oct","October"],["N","Nov","November"],["D","Dec","December"]];var me={0:"General",1:"0",2:"0.00",3:"#,##0",4:"#,##0.00",9:"0%",10:"0.00%",11:"0.00E+00",12:"# ?/?",13:"# ??/??",14:"m/d/yy",15:"d-mmm-yy",16:"d-mmm",17:"mmm-yy",18:"h:mm AM/PM",19:"h:mm:ss AM/PM",20:"h:mm",21:"h:mm:ss",22:"m/d/yy h:mm",37:"#,##0 ;(#,##0)",38:"#,##0 ;[Red](#,##0)",39:"#,##0.00;(#,##0.00)",40:"#,##0.00;[Red](#,##0.00)",45:"mm:ss",46:"[h]:mm:ss",47:"mmss.0",48:"##0.0E+0",49:"@",56:'"上午/下午 "hh"時"mm"分"ss"秒 "'},b={5:37,6:38,7:39,8:40,23:0,24:0,25:0,26:0,27:14,28:14,29:14,30:14,31:14,50:14,51:14,52:14,53:14,54:14,55:14,56:14,57:14,58:14,59:1,60:2,61:3,62:4,67:9,68:10,69:12,70:13,71:14,72:14,73:15,74:16,75:17,76:20,77:21,78:22,79:45,80:46,81:47,82:0},k={5:'"$"#,##0_);\\("$"#,##0\\)',63:'"$"#,##0_);\\("$"#,##0\\)',6:'"$"#,##0_);[Red]\\("$"#,##0\\)',64:'"$"#,##0_);[Red]\\("$"#,##0\\)',7:'"$"#,##0.00_);\\("$"#,##0.00\\)',65:'"$"#,##0.00_);\\("$"#,##0.00\\)',8:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',66:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',41:'_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',42:'_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',43:'_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',44:'_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'};function y(e,t,r){for(var a=e<0?-1:1,n=e*a,s=0,i=1,o=0,c=1,l=0,f=0,h=Math.floor(n);l<t&&(o=(h=Math.floor(n))*i+s,f=h*l+c,!(n-h<5e-8));)n=1/(n-h),s=i,i=o,c=l,l=f;if(t<f&&(o=t<l?(f=c,s):(f=l,i)),!r)return[0,a*o,f];r=Math.floor(a*o/f);return[r,a*o-r*f,f]}function L(e,t,r){if(2958465<e||e<0)return null;var a=0|e,n=Math.floor(86400*(e-a)),s=0,i=[],e={D:a,T:n,u:86400*(e-a)-n,y:0,m:0,d:0,H:0,M:0,S:0,q:0};return Math.abs(e.u)<1e-6&&(e.u=0),t&&t.date1904&&(a+=1462),.9999<e.u&&(e.u=0,86400==++n&&(e.T=n=0,++a,++e.D)),60===a?(i=r?[1317,10,29]:[1900,2,29],s=3):0===a?(i=r?[1317,8,29]:[1900,1,0],s=6):(60<a&&--a,(t=new Date(1900,0,1)).setDate(t.getDate()+a-1),i=[t.getFullYear(),t.getMonth()+1,t.getDate()],s=t.getDay(),a<60&&(s=(s+6)%7),r&&(s=function(e,t){t[0]-=581;t=e.getDay();e<60&&(t=(t+6)%7);return t}(t,i))),e.y=i[0],e.m=i[1],e.d=i[2],e.S=n%60,n=Math.floor(n/60),e.M=n%60,n=Math.floor(n/60),e.H=n,e.q=s,e}var S=new Date(1899,11,31,0,0,0),O=S.getTime(),I=new Date(1900,2,1,0,0,0);function N(e,t){var r=e.getTime();return t?r-=1262304e5:I<=e&&(r+=864e5),(r-(O+6e4*(e.getTimezoneOffset()-S.getTimezoneOffset())))/864e5}function F(e){return-1==e.indexOf(".")?e:e.replace(/(?:\.0*|(\.\d*[1-9])0+)$/,"$1")}function D(e){var t,r,a,n=Math.floor(Math.log(Math.abs(e))*Math.LOG10E),s=-4<=n&&n<=-1?e.toPrecision(10+n):Math.abs(n)<=9?(r=(t=e)<0?12:11,(a=F(t.toFixed(12))).length<=r||(a=t.toPrecision(10)).length<=r?a:t.toExponential(5)):10===n?e.toFixed(10).substr(0,12):(s=F((e=e).toFixed(11))).length>(e<0?12:11)||"0"===s||"-0"===s?e.toPrecision(6):s;return F(-1==(s=s.toUpperCase()).indexOf("E")?s:s.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/,"$1E").replace(/(E[+-])(\d)$/,"$10$2"))}function P(e,t){switch(typeof e){case"string":return e;case"boolean":return e?"TRUE":"FALSE";case"number":return(0|e)===e?e.toString(10):D(e);case"undefined":return"";case"object":if(null==e)return"";if(e instanceof Date)return ve(14,N(e,t&&t.date1904),t)}throw new Error("unsupported value in General format: "+e)}function M(e){if(e.length<=3)return e;for(var t=e.length%3,r=e.substr(0,t);t!=e.length;t+=3)r+=(0<r.length?",":"")+e.substr(t,3);return r}var U=/%/g;var B=/# (\?+)( ?)\/( ?)(\d+)/;var W=/^#*0*\.([0#]+)/,H=/\).*[0#]/,z=/\(###\) ###\\?-####/;function V(e){for(var t,r="",a=0;a!=e.length;++a)switch(t=e.charCodeAt(a)){case 35:break;case 63:r+=" ";break;case 48:r+="0";break;default:r+=String.fromCharCode(t)}return r}function G(e,t){t=Math.pow(10,t);return""+Math.round(e*t)/t}function j(e,t){var r=e-Math.floor(e),e=Math.pow(10,t);return t<(""+Math.round(r*e)).length?0:Math.round(r*e)}function X(e,t,r){if(40===e.charCodeAt(0)&&!t.match(H)){var a=t.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");return 0<=r?X("n",a,r):"("+X("n",a,-r)+")"}if(44===t.charCodeAt(t.length-1))return function(e,t,r){for(var a=t.length-1;44===t.charCodeAt(a-1);)--a;return K(e,t.substr(0,a),r/Math.pow(10,3*(t.length-a)))}(e,t,r);if(-1!==t.indexOf("%"))return o=e,l=r,c=(f=t).replace(U,""),f=f.length-c.length,K(o,c,l*Math.pow(10,2*f))+Ge("%",f);var n;if(-1!==t.indexOf("E"))return function e(t,r){var a,n=t.indexOf("E")-t.indexOf(".")-1;if(t.match(/^#+0.0E\+0$/)){if(0==r)return"0.0E+0";if(r<0)return"-"+e(t,-r);var s=t.indexOf(".");-1===s&&(s=t.indexOf("E"));var i=Math.floor(Math.log(r)*Math.LOG10E)%s;if(i<0&&(i+=s),-1===(a=(r/Math.pow(10,i)).toPrecision(1+n+(s+i)%s)).indexOf("e")){var o=Math.floor(Math.log(r)*Math.LOG10E);for(-1===a.indexOf(".")?a=a.charAt(0)+"."+a.substr(1)+"E+"+(o-a.length+i):a+="E+"+(o-i);"0."===a.substr(0,2);)a=(a=a.charAt(0)+a.substr(2,s)+"."+a.substr(2+s)).replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");a=a.replace(/\+-/,"-")}a=a.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function(e,t,r,a){return t+r+a.substr(0,(s+i)%s)+"."+a.substr(i)+"E"})}else a=r.toExponential(n);return t.match(/E\+00$/)&&a.match(/e[+-]\d$/)&&(a=a.substr(0,a.length-1)+"0"+a.charAt(a.length-1)),(a=t.match(/E\-/)&&a.match(/e\+/)?a.replace(/e\+/,"e"):a).replace("e","E")}(t,r);if(36===t.charCodeAt(0))return"$"+X(e,t.substr(" "==t.charAt(1)?2:1),r);var s,i,o,c,l,f,h,u=Math.abs(r),d=r<0?"-":"";if(t.match(/^00+$/))return d+E(u,t.length);if(t.match(/^[#?]+$/))return(n="0"===(n=E(r,0))?"":n).length>t.length?n:V(t.substr(0,t.length-n.length))+n;if(s=t.match(B))return h=s,o=u,c=d,l=parseInt(h[4],10),f=Math.round(o*l),o=Math.floor(f/l),l,c+(0===o?"":""+o)+" "+(0==(f-=o*l)?Ge(" ",h[1].length+1+h[4].length):w(f,h[1].length)+h[2]+"/"+h[3]+x(l,h[4].length));if(t.match(/^#+0+$/))return d+E(u,t.length-t.indexOf("0"));if(s=t.match(W))return n=G(r,s[1].length).replace(/^([^\.]+)$/,"$1."+V(s[1])).replace(/\.$/,"."+V(s[1])).replace(/\.(\d*)$/,function(e,t){return"."+t+Ge("0",V(s[1]).length-t.length)}),-1!==t.indexOf("0.")?n:n.replace(/^0\./,".");if(t=t.replace(/^#+([0.])/,"$1"),s=t.match(/^(0*)\.(#*)$/))return d+G(u,s[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,s[1].length?"0.":".");if(s=t.match(/^#{1,3},##0(\.?)$/))return d+M(E(u,0));if(s=t.match(/^#,##0\.([#0]*0)$/))return r<0?"-"+X(e,t,-r):M(""+(Math.floor(r)+(h=r,(p=s[1].length)<(""+Math.round((h-Math.floor(h))*Math.pow(10,p))).length?1:0)))+"."+x(j(r,s[1].length),s[1].length);if(s=t.match(/^#,#*,#0/))return X(e,t.replace(/^#,#*,/,""),r);if(s=t.match(/^([0#]+)(\\?-([0#]+))+$/))return n=v(X(e,t.replace(/[\\-]/g,""),r)),i=0,v(v(t.replace(/\\/g,"")).replace(/[0#]/g,function(e){return i<n.length?n.charAt(i++):"0"===e?"0":""}));if(t.match(z))return"("+(n=X(e,"##########",r)).substr(0,3)+") "+n.substr(3,3)+"-"+n.substr(6);var p="";if(s=t.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))return i=Math.min(s[4].length,7),m=y(u,Math.pow(10,i)-1,!1),n=d," "==(p=K("n",s[1],m[1])).charAt(p.length-1)&&(p=p.substr(0,p.length-1)+"0"),n+=p+s[2]+"/"+s[3],(p=T(m[2],i)).length<s[4].length&&(p=V(s[4].substr(s[4].length-p.length))+p),n+=p;if(s=t.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))return i=Math.min(Math.max(s[1].length,s[4].length),7),d+((m=y(u,Math.pow(10,i)-1,!0))[0]||(m[1]?"":"0"))+" "+(m[1]?w(m[1],i)+s[2]+"/"+s[3]+T(m[2],i):Ge(" ",2*i+1+s[2].length+s[3].length));if(s=t.match(/^[#0?]+$/))return n=E(r,0),t.length<=n.length?n:V(t.substr(0,t.length-n.length))+n;if(s=t.match(/^([#0?]+)\.([#0]+)$/)){n=""+r.toFixed(Math.min(s[2].length,10)).replace(/([^0])0+$/,"$1"),i=n.indexOf(".");var m=t.indexOf(".")-i,g=t.length-n.length-m;return V(t.substr(0,m)+n+t.substr(t.length-g))}if(s=t.match(/^00,000\.([#0]*0)$/))return i=j(r,s[1].length),r<0?"-"+X(e,t,-r):M((g=r)<2147483647&&-2147483648<g?""+(0<=g?0|g:g-1|0):""+Math.floor(g)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function(e){return"00,"+(e.length<3?x(0,3-e.length):"")+e})+"."+x(i,s[1].length);switch(t){case"###,##0.00":return X(e,"#,##0.00",r);case"###,###":case"##,###":case"#,###":var b=M(E(u,0));return"0"!==b?d+b:"";case"###,###.00":return X(e,"###,##0.00",r).replace(/^0\./,".");case"#,###.00":return X(e,"#,##0.00",r).replace(/^0\./,".")}throw new Error("unsupported format |"+t+"|")}function Y(e,t,r){if(40===e.charCodeAt(0)&&!t.match(H)){var a=t.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");return 0<=r?Y("n",a,r):"("+Y("n",a,-r)+")"}if(44===t.charCodeAt(t.length-1))return function(e,t,r){for(var a=t.length-1;44===t.charCodeAt(a-1);)--a;return K(e,t.substr(0,a),r/Math.pow(10,3*(t.length-a)))}(e,t,r);if(-1!==t.indexOf("%"))return n=e,i=r,a=(s=t).replace(U,""),s=s.length-a.length,K(n,a,i*Math.pow(10,2*s))+Ge("%",s);var n,s,i,o;if(-1!==t.indexOf("E"))return function e(t,r){var a,n=t.indexOf("E")-t.indexOf(".")-1;if(t.match(/^#+0.0E\+0$/)){if(0==r)return"0.0E+0";if(r<0)return"-"+e(t,-r);var s=t.indexOf(".");-1===s&&(s=t.indexOf("E"));var i,o=Math.floor(Math.log(r)*Math.LOG10E)%s;o<0&&(o+=s),(a=(r/Math.pow(10,o)).toPrecision(1+n+(s+o)%s)).match(/[Ee]/)||(i=Math.floor(Math.log(r)*Math.LOG10E),-1===a.indexOf(".")?a=a.charAt(0)+"."+a.substr(1)+"E+"+(i-a.length+o):a+="E+"+(i-o),a=a.replace(/\+-/,"-")),a=a.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function(e,t,r,a){return t+r+a.substr(0,(s+o)%s)+"."+a.substr(o)+"E"})}else a=r.toExponential(n);return t.match(/E\+00$/)&&a.match(/e[+-]\d$/)&&(a=a.substr(0,a.length-1)+"0"+a.charAt(a.length-1)),(a=t.match(/E\-/)&&a.match(/e\+/)?a.replace(/e\+/,"e"):a).replace("e","E")}(t,r);if(36===t.charCodeAt(0))return"$"+Y(e,t.substr(" "==t.charAt(1)?2:1),r);var c,l,f=Math.abs(r),h=r<0?"-":"";if(t.match(/^00+$/))return h+x(f,t.length);if(t.match(/^[#?]+$/))return(o=0===r?"":""+r).length>t.length?o:V(t.substr(0,t.length-o.length))+o;if(c=t.match(B))return h+(0===(u=f)?"":""+u)+Ge(" ",(u=c)[1].length+2+u[4].length);if(t.match(/^#+0+$/))return h+x(f,t.length-t.indexOf("0"));if(c=t.match(W))return o=(o=(""+r).replace(/^([^\.]+)$/,"$1."+V(c[1])).replace(/\.$/,"."+V(c[1]))).replace(/\.(\d*)$/,function(e,t){return"."+t+Ge("0",V(c[1]).length-t.length)}),-1!==t.indexOf("0.")?o:o.replace(/^0\./,".");if(t=t.replace(/^#+([0.])/,"$1"),c=t.match(/^(0*)\.(#*)$/))return h+(""+f).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,c[1].length?"0.":".");if(c=t.match(/^#{1,3},##0(\.?)$/))return h+M(""+f);if(c=t.match(/^#,##0\.([#0]*0)$/))return r<0?"-"+Y(e,t,-r):M(""+r)+"."+Ge("0",c[1].length);if(c=t.match(/^#,#*,#0/))return Y(e,t.replace(/^#,#*,/,""),r);if(c=t.match(/^([0#]+)(\\?-([0#]+))+$/))return o=v(Y(e,t.replace(/[\\-]/g,""),r)),l=0,v(v(t.replace(/\\/g,"")).replace(/[0#]/g,function(e){return l<o.length?o.charAt(l++):"0"===e?"0":""}));if(t.match(z))return"("+(o=Y(e,"##########",r)).substr(0,3)+") "+o.substr(3,3)+"-"+o.substr(6);var u="";if(c=t.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))return l=Math.min(c[4].length,7),d=y(f,Math.pow(10,l)-1,!1),o=h," "==(u=K("n",c[1],d[1])).charAt(u.length-1)&&(u=u.substr(0,u.length-1)+"0"),o+=u+c[2]+"/"+c[3],(u=T(d[2],l)).length<c[4].length&&(u=V(c[4].substr(c[4].length-u.length))+u),o+=u;if(c=t.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))return l=Math.min(Math.max(c[1].length,c[4].length),7),h+((d=y(f,Math.pow(10,l)-1,!0))[0]||(d[1]?"":"0"))+" "+(d[1]?w(d[1],l)+c[2]+"/"+c[3]+T(d[2],l):Ge(" ",2*l+1+c[2].length+c[3].length));if(c=t.match(/^[#0?]+$/))return o=""+r,t.length<=o.length?o:V(t.substr(0,t.length-o.length))+o;if(c=t.match(/^([#0]+)\.([#0]+)$/)){o=""+r.toFixed(Math.min(c[2].length,10)).replace(/([^0])0+$/,"$1"),l=o.indexOf(".");var u=t.indexOf(".")-l,d=t.length-o.length-u;return V(t.substr(0,u)+o+t.substr(t.length-d))}if(c=t.match(/^00,000\.([#0]*0)$/))return r<0?"-"+Y(e,t,-r):M(""+r).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function(e){return"00,"+(e.length<3?x(0,3-e.length):"")+e})+"."+x(0,c[1].length);switch(t){case"###,###":case"##,###":case"#,###":var p=M(""+f);return"0"!==p?h+p:"";default:if(t.match(/\.[0#?]*$/))return Y(e,t.slice(0,t.lastIndexOf(".")),r)+V(t.slice(t.lastIndexOf(".")))}throw new Error("unsupported format |"+t+"|")}function K(e,t,r){return((0|r)===r?Y:X)(e,t,r)}var J=/\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;function q(e){for(var t=0,r="",a="";t<e.length;)switch(r=e.charAt(t)){case"G":A(e,t)&&(t+=6),t++;break;case'"':for(;34!==e.charCodeAt(++t)&&t<e.length;);++t;break;case"\\":case"_":t+=2;break;case"@":++t;break;case"B":case"b":if("1"===e.charAt(t+1)||"2"===e.charAt(t+1))return!0;case"M":case"D":case"Y":case"H":case"S":case"E":case"m":case"d":case"y":case"h":case"s":case"e":case"g":return!0;case"A":case"a":case"上":if("A/P"===e.substr(t,3).toUpperCase())return!0;if("AM/PM"===e.substr(t,5).toUpperCase())return!0;if("上午/下午"===e.substr(t,5).toUpperCase())return!0;++t;break;case"[":for(a=r;"]"!==e.charAt(t++)&&t<e.length;)a+=e.charAt(t);if(a.match(J))return!0;break;case".":case"0":case"#":for(;t<e.length&&(-1<"0#?.,E+-%".indexOf(r=e.charAt(++t))||"\\"==r&&"-"==e.charAt(t+1)&&-1<"0#".indexOf(e.charAt(t+2))););break;case"?":for(;e.charAt(++t)===r;);break;case"*":++t," "!=e.charAt(t)&&"*"!=e.charAt(t)||++t;break;case"(":case")":++t;break;case"1":case"2":case"3":case"4":case"5":case"6":case"7":case"8":case"9":for(;t<e.length&&-1<"0123456789".indexOf(e.charAt(++t)););break;case" ":default:++t}return!1}function Z(e,t,r,a){for(var n,s,i,o=[],c="",l=0,f="",h="t",u="H";l<e.length;)switch(f=e.charAt(l)){case"G":if(!A(e,l))throw new Error("unrecognized character "+f+" in "+e);o[o.length]={t:"G",v:"General"},l+=7;break;case'"':for(c="";34!==(i=e.charCodeAt(++l))&&l<e.length;)c+=String.fromCharCode(i);o[o.length]={t:"t",v:c},++l;break;case"\\":var d=e.charAt(++l),p="("===d||")"===d?d:"t";o[o.length]={t:p,v:d},++l;break;case"_":o[o.length]={t:"t",v:" "},l+=2;break;case"@":o[o.length]={t:"T",v:t},++l;break;case"B":case"b":if("1"===e.charAt(l+1)||"2"===e.charAt(l+1)){if(null==n&&null==(n=L(t,r,"2"===e.charAt(l+1))))return"";o[o.length]={t:"X",v:e.substr(l,2)},h=f,l+=2;break}case"M":case"D":case"Y":case"H":case"S":case"E":f=f.toLowerCase();case"m":case"d":case"y":case"h":case"s":case"e":case"g":if(t<0)return"";if(null==n&&null==(n=L(t,r)))return"";for(c=f;++l<e.length&&e.charAt(l).toLowerCase()===f;)c+=f;"h"===(f="m"===f&&"h"===h.toLowerCase()?"M":f)&&(f=u),o[o.length]={t:f,v:c},h=f;break;case"A":case"a":case"上":d={t:f,v:f};if(null==n&&(n=L(t,r)),"A/P"===e.substr(l,3).toUpperCase()?(null!=n&&(d.v=12<=n.H?"P":"A"),d.t="T",u="h",l+=3):"AM/PM"===e.substr(l,5).toUpperCase()?(null!=n&&(d.v=12<=n.H?"PM":"AM"),d.t="T",l+=5,u="h"):"上午/下午"===e.substr(l,5).toUpperCase()?(null!=n&&(d.v=12<=n.H?"下午":"上午"),d.t="T",l+=5,u="h"):(d.t="t",++l),null==n&&"T"===d.t)return"";o[o.length]=d,h=f;break;case"[":for(c=f;"]"!==e.charAt(l++)&&l<e.length;)c+=e.charAt(l);if("]"!==c.slice(-1))throw'unterminated "[" block: |'+c+"|";if(c.match(J)){if(null==n&&null==(n=L(t,r)))return"";o[o.length]={t:"Z",v:c.toLowerCase()},h=c.charAt(1)}else-1<c.indexOf("$")&&(c=(c.match(/\$([^-\[\]]*)/)||[])[1]||"$",q(e)||(o[o.length]={t:"t",v:c}));break;case".":if(null!=n){for(c=f;++l<e.length&&"0"===(f=e.charAt(l));)c+=f;o[o.length]={t:"s",v:c};break}case"0":case"#":for(c=f;++l<e.length&&-1<"0#?.,E+-%".indexOf(f=e.charAt(l));)c+=f;o[o.length]={t:"n",v:c};break;case"?":for(c=f;e.charAt(++l)===f;)c+=f;o[o.length]={t:f,v:c},h=f;break;case"*":++l," "!=e.charAt(l)&&"*"!=e.charAt(l)||++l;break;case"(":case")":o[o.length]={t:1===a?"t":f,v:f},++l;break;case"1":case"2":case"3":case"4":case"5":case"6":case"7":case"8":case"9":for(c=f;l<e.length&&-1<"0123456789".indexOf(e.charAt(++l));)c+=e.charAt(l);o[o.length]={t:"D",v:c};break;case" ":o[o.length]={t:f,v:f},++l;break;case"$":o[o.length]={t:"t",v:"$"},++l;break;default:if(-1===",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(f))throw new Error("unrecognized character "+f+" in "+e);o[o.length]={t:"t",v:f},++l}var m,g=0,b=0;for(l=o.length-1,h="t";0<=l;--l)switch(o[l].t){case"h":case"H":o[l].t=u,h="h",g<1&&(g=1);break;case"s":(m=o[l].v.match(/\.0+$/))&&(b=Math.max(b,m[0].length-1)),g<3&&(g=3);case"d":case"y":case"M":case"e":h=o[l].t;break;case"m":"s"===h&&(o[l].t="M",g<2&&(g=2));break;case"X":break;case"Z":(g=(g=g<1&&o[l].v.match(/[Hh]/)?1:g)<2&&o[l].v.match(/[Mm]/)?2:g)<3&&o[l].v.match(/[Ss]/)&&(g=3)}switch(g){case 0:break;case 1:.5<=n.u&&(n.u=0,++n.S),60<=n.S&&(n.S=0,++n.M),60<=n.M&&(n.M=0,++n.H);break;case 2:.5<=n.u&&(n.u=0,++n.S),60<=n.S&&(n.S=0,++n.M)}var v,w="";for(l=0;l<o.length;++l)switch(o[l].t){case"t":case"T":case" ":case"D":break;case"X":o[l].v="",o[l].t=";";break;case"d":case"m":case"y":case"h":case"H":case"M":case"s":case"e":case"b":case"Z":o[l].v=function(e,t,r,a){var n,s="",i=0,o=0,c=r.y,l=0;switch(e){case 98:c=r.y+543;case 121:switch(t.length){case 1:case 2:n=c%100,l=2;break;default:n=c%1e4,l=4}break;case 109:switch(t.length){case 1:case 2:n=r.m,l=t.length;break;case 3:return R[r.m-1][1];case 5:return R[r.m-1][0];default:return R[r.m-1][2]}break;case 100:switch(t.length){case 1:case 2:n=r.d,l=t.length;break;case 3:return C[r.q][0];default:return C[r.q][1]}break;case 104:switch(t.length){case 1:case 2:n=1+(r.H+11)%12,l=t.length;break;default:throw"bad hour format: "+t}break;case 72:switch(t.length){case 1:case 2:n=r.H,l=t.length;break;default:throw"bad hour format: "+t}break;case 77:switch(t.length){case 1:case 2:n=r.M,l=t.length;break;default:throw"bad minute format: "+t}break;case 115:if("s"!=t&&"ss"!=t&&".0"!=t&&".00"!=t&&".000"!=t)throw"bad second format: "+t;return 0!==r.u||"s"!=t&&"ss"!=t?(60*(o=2<=a?3===a?1e3:100:1===a?10:1)<=(i=Math.round(o*(r.S+r.u)))&&(i=0),"s"===t?0===i?"0":""+i/o:(s=x(i,2+a),"ss"===t?s.substr(0,2):"."+s.substr(2,t.length-1))):x(r.S,t.length);case 90:switch(t){case"[h]":case"[hh]":n=24*r.D+r.H;break;case"[m]":case"[mm]":n=60*(24*r.D+r.H)+r.M;break;case"[s]":case"[ss]":n=60*(60*(24*r.D+r.H)+r.M)+Math.round(r.S+r.u);break;default:throw"bad abstime format: "+t}l=3===t.length?1:2;break;case 101:n=c,l=1}return 0<l?x(n,l):""}(o[l].t.charCodeAt(0),o[l].v,n,b),o[l].t="t";break;case"n":case"?":for(v=l+1;null!=o[v]&&("?"===(f=o[v].t)||"D"===f||(" "===f||"t"===f)&&null!=o[v+1]&&("?"===o[v+1].t||"t"===o[v+1].t&&"/"===o[v+1].v)||"("===o[l].t&&(" "===f||"n"===f||")"===f)||"t"===f&&("/"===o[v].v||" "===o[v].v&&null!=o[v+1]&&"?"==o[v+1].t));)o[l].v+=o[v].v,o[v]={v:"",t:";"},++v;w+=o[l].v,l=v-1;break;case"G":o[l].t="t",o[l].v=P(t,r)}var T,E,k="";if(0<w.length){40==w.charCodeAt(0)?(T=t<0&&45===w.charCodeAt(0)?-t:t,E=K("n",w,T)):(E=K("n",w,T=t<0&&1<a?-t:t),T<0&&o[0]&&"t"==o[0].t&&(E=E.substr(1),o[0].v="-"+o[0].v)),v=E.length-1;for(var y=o.length,l=0;l<o.length;++l)if(null!=o[l]&&"t"!=o[l].t&&-1<o[l].v.indexOf(".")){y=l;break}var S=o.length;if(y===o.length&&-1===E.indexOf("E")){for(l=o.length-1;0<=l;--l)null!=o[l]&&-1!=="n?".indexOf(o[l].t)&&(v>=o[l].v.length-1?(v-=o[l].v.length,o[l].v=E.substr(v+1,o[l].v.length)):v<0?o[l].v="":(o[l].v=E.substr(0,v+1),v=-1),o[l].t="t",S=l);0<=v&&S<o.length&&(o[S].v=E.substr(0,v+1)+o[S].v)}else if(y!==o.length&&-1===E.indexOf("E")){for(v=E.indexOf(".")-1,l=y;0<=l;--l)if(null!=o[l]&&-1!=="n?".indexOf(o[l].t)){for(s=-1<o[l].v.indexOf(".")&&l===y?o[l].v.indexOf(".")-1:o[l].v.length-1,k=o[l].v.substr(s+1);0<=s;--s)0<=v&&("0"===o[l].v.charAt(s)||"#"===o[l].v.charAt(s))&&(k=E.charAt(v--)+k);o[l].v=k,o[l].t="t",S=l}for(0<=v&&S<o.length&&(o[S].v=E.substr(0,v+1)+o[S].v),v=E.indexOf(".")+1,l=y;l<o.length;++l)if(null!=o[l]&&(-1!=="n?(".indexOf(o[l].t)||l===y)){for(s=-1<o[l].v.indexOf(".")&&l===y?o[l].v.indexOf(".")+1:0,k=o[l].v.substr(0,s);s<o[l].v.length;++s)v<E.length&&(k+=E.charAt(v++));o[l].v=k,o[l].t="t",S=l}}}for(l=0;l<o.length;++l)null!=o[l]&&-1<"n?".indexOf(o[l].t)&&(T=1<a&&t<0&&0<l&&"-"===o[l-1].v?-t:t,o[l].v=K(o[l].t,o[l].v,T),o[l].t="t");var _="";for(l=0;l!==o.length;++l)null!=o[l]&&(_+=o[l].v);return _}var Q=/\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;function ge(e,t){if(null!=t){var r=parseFloat(t[2]);switch(t[1]){case"=":if(e==r)return 1;break;case">":if(r<e)return 1;break;case"<":if(e<r)return 1;break;case"<>":if(e!=r)return 1;break;case">=":if(r<=e)return 1;break;case"<=":if(e<=r)return 1}}}function be(e,t){var r=function(e){for(var t=[],r=!1,a=0,n=0;a<e.length;++a)switch(e.charCodeAt(a)){case 34:r=!r;break;case 95:case 42:case 92:++a;break;case 59:t[t.length]=e.substr(n,a-n),n=a+1}if(t[t.length]=e.substr(n),!0===r)throw new Error("Format |"+e+"| unterminated string ");return t}(e),a=r.length,n=r[a-1].indexOf("@");if(a<4&&-1<n&&--a,4<r.length)throw new Error("cannot find right format for |"+r.join("|")+"|");if("number"!=typeof t)return[4,4===r.length||-1<n?r[r.length-1]:"@"];switch(r.length){case 1:r=-1<n?["General","General","General",r[0]]:[r[0],r[0],r[0],"@"];break;case 2:r=-1<n?[r[0],r[0],r[0],r[1]]:[r[0],r[1],r[0],"@"];break;case 3:r=-1<n?[r[0],r[1],r[0],r[2]]:[r[0],r[1],r[2],"@"]}var s=0<t?r[0]:t<0?r[1]:r[2];if(-1===r[0].indexOf("[")&&-1===r[1].indexOf("["))return[a,s];if(null==r[0].match(/\[[=<>]/)&&null==r[1].match(/\[[=<>]/))return[a,s];e=r[0].match(Q),s=r[1].match(Q);return ge(t,e)?[a,r[0]]:ge(t,s)?[a,r[1]]:[a,r[null!=e&&null!=s?2:1]]}function ve(e,t,r){null==r&&(r={});var a="";switch(typeof e){case"string":a="m/d/yy"==e&&r.dateNF?r.dateNF:e;break;case"number":null==(a=null==(a=14==e&&r.dateNF?r.dateNF:(null!=r.table?r.table:me)[e])?r.table&&r.table[b[e]]||me[b[e]]:a)&&(a=k[e]||"General")}if(A(a,0))return P(t,r);var n=be(a,t=t instanceof Date?N(t,r.date1904):t);if(A(n[1]))return P(t,r);if(!0===t)t="TRUE";else if(!1===t)t="FALSE";else if(""===t||null==t)return"";return Z(n[1],t,r,n[0])}function we(e,t){if("number"!=typeof t){t=+t||-1;for(var r=0;r<392;++r)if(null!=me[r]){if(me[r]==e){t=r;break}}else t<0&&(t=r);t<0&&(t=391)}return me[t]=e,t}function Te(e){for(var t=0;392!=t;++t)void 0!==e[t]&&we(e[t],t)}function Ee(){var e;(e=e||{})[0]="General",e[1]="0",e[2]="0.00",e[3]="#,##0",e[4]="#,##0.00",e[9]="0%",e[10]="0.00%",e[11]="0.00E+00",e[12]="# ?/?",e[13]="# ??/??",e[14]="m/d/yy",e[15]="d-mmm-yy",e[16]="d-mmm",e[17]="mmm-yy",e[18]="h:mm AM/PM",e[19]="h:mm:ss AM/PM",e[20]="h:mm",e[21]="h:mm:ss",e[22]="m/d/yy h:mm",e[37]="#,##0 ;(#,##0)",e[38]="#,##0 ;[Red](#,##0)",e[39]="#,##0.00;(#,##0.00)",e[40]="#,##0.00;[Red](#,##0.00)",e[45]="mm:ss",e[46]="[h]:mm:ss",e[47]="mmss.0",e[48]="##0.0E+0",e[49]="@",e[56]='"上午/下午 "hh"時"mm"分"ss"秒 "',me=e}var e={format:ve,load:we,_table:me,load_table:Te,parse_date_code:L,is_date:q,get_table:function(){return e._table=me}},ke={5:'"$"#,##0_);\\("$"#,##0\\)',6:'"$"#,##0_);[Red]\\("$"#,##0\\)',7:'"$"#,##0.00_);\\("$"#,##0.00\\)',8:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',23:"General",24:"General",25:"General",26:"General",27:"m/d/yy",28:"m/d/yy",29:"m/d/yy",30:"m/d/yy",31:"m/d/yy",32:"h:mm:ss",33:"h:mm:ss",34:"h:mm:ss",35:"h:mm:ss",36:"m/d/yy",41:'_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)',42:'_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)',43:'_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)',44:'_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',50:"m/d/yy",51:"m/d/yy",52:"m/d/yy",53:"m/d/yy",54:"m/d/yy",55:"m/d/yy",56:"m/d/yy",57:"m/d/yy",58:"m/d/yy",59:"0",60:"0.00",61:"#,##0",62:"#,##0.00",63:'"$"#,##0_);\\("$"#,##0\\)',64:'"$"#,##0_);[Red]\\("$"#,##0\\)',65:'"$"#,##0.00_);\\("$"#,##0.00\\)',66:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',67:"0%",68:"0.00%",69:"# ?/?",70:"# ??/??",71:"m/d/yy",72:"m/d/yy",73:"d-mmm-yy",74:"d-mmm",75:"mmm-yy",76:"h:mm",77:"h:mm:ss",78:"m/d/yy h:mm",79:"mm:ss",80:"[h]:mm:ss",81:"mmss.0"},ye=/[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;var Se,_e=function(){var e={};e.version="1.2.0";var o=function(){for(var e=0,t=new Array(256),r=0;256!=r;++r)e=1&(e=1&(e=1&(e=1&(e=1&(e=1&(e=1&(e=1&(e=r)?-306674912^e>>>1:e>>>1)?-306674912^e>>>1:e>>>1)?-306674912^e>>>1:e>>>1)?-306674912^e>>>1:e>>>1)?-306674912^e>>>1:e>>>1)?-306674912^e>>>1:e>>>1)?-306674912^e>>>1:e>>>1)?-306674912^e>>>1:e>>>1,t[r]=e;return"undefined"!=typeof Int32Array?new Int32Array(t):t}();var t=function(e){for(var t=0,r=0,a=0,n=new("undefined"!=typeof Int32Array?Int32Array:Array)(4096),a=0;256!=a;++a)n[a]=e[a];for(a=0;256!=a;++a)for(r=e[a],t=256+a;t<4096;t+=256)r=n[t]=r>>>8^e[255&r];var s=[];for(a=1;16!=a;++a)s[a-1]="undefined"!=typeof Int32Array?n.subarray(256*a,256*a+256):n.slice(256*a,256*a+256);return s}(o),s=t[0],i=t[1],c=t[2],l=t[3],f=t[4],h=t[5],u=t[6],d=t[7],p=t[8],m=t[9],g=t[10],b=t[11],v=t[12],w=t[13],T=t[14];return e.table=o,e.bstr=function(e,t){for(var r=-1^t,a=0,n=e.length;a<n;)r=r>>>8^o[255&(r^e.charCodeAt(a++))];return~r},e.buf=function(e,t){for(var r=-1^t,a=e.length-15,n=0;n<a;)r=T[e[n++]^255&r]^w[e[n++]^r>>8&255]^v[e[n++]^r>>16&255]^b[e[n++]^r>>>24]^g[e[n++]]^m[e[n++]]^p[e[n++]]^d[e[n++]]^u[e[n++]]^h[e[n++]]^f[e[n++]]^l[e[n++]]^c[e[n++]]^i[e[n++]]^s[e[n++]]^o[e[n++]];for(a+=15;n<a;)r=r>>>8^o[255&(r^e[n++])];return~r},e.str=function(e,t){for(var r,a=-1^t,n=0,s=e.length,i=0;n<s;)a=(i=e.charCodeAt(n++))<128?a>>>8^o[255&(a^i)]:i<2048?(a=a>>>8^o[255&(a^(192|i>>6&31))])>>>8^o[255&(a^(128|63&i))]:55296<=i&&i<57344?(i=64+(1023&i),r=1023&e.charCodeAt(n++),(a=(a=(a=a>>>8^o[255&(a^(240|i>>8&7))])>>>8^o[255&(a^(128|i>>2&63))])>>>8^o[255&(a^(128|r>>6&15|(3&i)<<4))])>>>8^o[255&(a^(128|63&r))]):(a=(a=a>>>8^o[255&(a^(224|i>>12&15))])>>>8^o[255&(a^(128|i>>6&63))])>>>8^o[255&(a^(128|63&i))];return~a},e}(),xe=function(){var s,e={};function d(e){if("/"==e.charAt(e.length-1))return-1===e.slice(0,-1).indexOf("/")?e:d(e.slice(0,-1));var t=e.lastIndexOf("/");return-1===t?e:e.slice(0,t+1)}function p(e){if("/"==e.charAt(e.length-1))return p(e.slice(0,-1));var t=e.lastIndexOf("/");return-1===t?e:e.slice(t+1)}function g(e){Dr(e,0);for(var t,r={};e.l<=e.length-4;){var a=e.read_shift(2),n=e.read_shift(2),s=e.l+n,i={};21589===a&&(1&(t=e.read_shift(1))&&(i.mtime=e.read_shift(4)),5<n&&(2&t&&(i.atime=e.read_shift(4)),4&t&&(i.ctime=e.read_shift(4))),i.mtime&&(i.mt=new Date(1e3*i.mtime))),e.l=s,r[a]=i}return r}function i(){return s=s||require("fs")}function o(e,t){if(80==e[0]&&75==e[1])return q(e,t);if(109==(32|e[0])&&105==(32|e[1]))return function(e,t){if("mime-version:"!=_(e.slice(0,13)).toLowerCase())throw new Error("Unsupported MAD header");var r=t&&t.root||"",a=(se&&Buffer.isBuffer(e)?e.toString("binary"):_(e)).split("\r\n"),n=0,s="";for(n=0;n<a.length;++n)if(s=a[n],/^Content-Location:/i.test(s)&&(s=s.slice(s.indexOf("file")),r=r||s.slice(0,s.lastIndexOf("/")+1),s.slice(0,r.length)!=r))for(;0<r.length&&(r=(r=r.slice(0,r.length-1)).slice(0,r.lastIndexOf("/")+1),s.slice(0,r.length)!=r););e=(a[1]||"").match(/boundary="(.*?)"/);if(!e)throw new Error("MAD cannot find boundary");var i="--"+(e[1]||""),o={FileIndex:[],FullPaths:[]};w(o);var c,l=0;for(n=0;n<a.length;++n){var f=a[n];f!==i&&f!==i+"--"||(l++&&function(e,t,r){for(var a,n="",s="",i="",o=0;o<10;++o){var c=t[o];if(!c||c.match(/^\s*$/))break;var l=c.match(/^(.*?):\s*([^\s].*)$/);if(l)switch(l[1].toLowerCase()){case"content-location":n=l[2].trim();break;case"content-type":i=l[2].trim();break;case"content-transfer-encoding":s=l[2].trim()}}switch(++o,s.toLowerCase()){case"base64":a=he(te(t.slice(o).join("")));break;case"quoted-printable":a=function(e){for(var t=[],r=0;r<e.length;++r){for(var a=e[r];r<=e.length&&"="==a.charAt(a.length-1);)a=a.slice(0,a.length-1)+e[++r];t.push(a)}for(var n=0;n<t.length;++n)t[n]=t[n].replace(/[=][0-9A-Fa-f]{2}/g,function(e){return String.fromCharCode(parseInt(e.slice(1),16))});return he(t.join("\r\n"))}(t.slice(o));break;default:throw new Error("Unsupported Content-Transfer-Encoding "+s)}r=Q(e,n.slice(r.length),a,{unsafe:!0}),i&&(r.ctype=i)}(o,a.slice(c,n),r),c=n)}return o}(e,t);if(e.length<512)throw new Error("CFB file size "+e.length+" < 512");var r,m,a,n=3,s=512,i=0,o=[],c=e.slice(0,512);Dr(c,0);var l=function(e){if(80==e[e.l]&&75==e[e.l+1])return[0,0];e.chk(y,"Header Signature: "),e.l+=16;var t=e.read_shift(2,"u");return[e.read_shift(2,"u"),t]}(c);switch(n=l[0]){case 3:s=512;break;case 4:s=4096;break;case 0:if(0==l[1])return q(e,t);default:throw new Error("Major Version: Expected 3 or 4 saw "+n)}512!==s&&Dr(c=e.slice(0,s),28);var f=e.slice(0,s);!function(e,t){var r=9;switch(e.l+=2,r=e.read_shift(2)){case 9:if(3!=t)throw new Error("Sector Shift: Expected 9 saw "+r);break;case 12:if(4!=t)throw new Error("Sector Shift: Expected 12 saw "+r);break;default:throw new Error("Sector Shift: Expected 9 or 12 saw "+r)}e.chk("0600","Mini Sector Shift: "),e.chk("000000000000","Reserved: ")}(c,n);var h=c.read_shift(4,"i");if(3===n&&0!==h)throw new Error("# Directory Sectors: Expected 0 saw "+h);c.l+=4,m=c.read_shift(4,"i"),c.l+=4,c.chk("00100000","Mini Stream Cutoff Size: "),a=c.read_shift(4,"i"),r=c.read_shift(4,"i"),b=c.read_shift(4,"i"),i=c.read_shift(4,"i");for(var u,d=0;d<109&&!((u=c.read_shift(4,"i"))<0);++d)o[d]=u;var p=function(e,t){for(var r=Math.ceil(e.length/t)-1,a=[],n=1;n<r;++n)a[n-1]=e.slice(n*t,(n+1)*t);return a[r-1]=e.slice(r*t),a}(e,s);!function e(t,r,a,n,s){var i=k;if(t===k){if(0!==r)throw new Error("DIFAT chain shorter than expected")}else if(-1!==t){var o=a[t],c=(n>>>2)-1;if(o){for(var l=0;l<c&&(i=xr(o,4*l))!==k;++l)s.push(i);e(xr(o,n-4),r-1,a,n,s)}}}(b,i,p,s,o);var g=function(e,t,r,a){var n=e.length,s=[],i=[],o=[],c=[],l=a-1,f=0,h=0,u=0,d=0;for(f=0;f<n;++f)if(o=[],n<=(u=f+t)&&(u-=n),!i[u]){c=[];var p=[];for(h=u;0<=h;){p[h]=!0,i[h]=!0,o[o.length]=h,c.push(e[h]);var m=r[Math.floor(4*h/a)];if(a<4+(d=4*h&l))throw new Error("FAT boundary crossed: "+h+" 4 "+a);if(!e[m])break;if(h=xr(e[m],d),p[h])break}s[u]={nodes:o,data:hr([c])}}return s}(p,m,o,s);g[m].name="!Directory",0<r&&a!==k&&(g[a].name="!MiniFAT"),g[o[0]].name="!FAT",g.fat_addrs=o,g.ssz=s;var h=[],b=[],i=[];!function(e,t,r,a,n,s,i){for(var o,c=0,l=r.length?2:0,f=e[m].data,h=0,u=0;h<f.length;h+=128){var d=f.slice(h,h+128);Dr(d,64),u=d.read_shift(2),o=ur(d,0,u-l),r.push(o);var p={name:o,type:d.read_shift(1),color:d.read_shift(1),L:d.read_shift(4,"i"),R:d.read_shift(4,"i"),C:d.read_shift(4,"i"),clsid:d.read_shift(16),state:d.read_shift(4,"i"),start:0,size:0};0!==d.read_shift(2)+d.read_shift(2)+d.read_shift(2)+d.read_shift(2)&&(p.ct=v(d,d.l-8)),0!==d.read_shift(2)+d.read_shift(2)+d.read_shift(2)+d.read_shift(2)&&(p.mt=v(d,d.l-8)),p.start=d.read_shift(4,"i"),p.size=d.read_shift(4,"i"),p.size<0&&p.start<0&&(p.size=p.type=0,p.start=k,p.name=""),5===p.type?(c=p.start,0<a&&c!==k&&(e[c].name="!StreamData")):4096<=p.size?(p.storage="fat",void 0===e[p.start]&&(e[p.start]=function(e,t,r,a,n){var s=[],i=[];n=n||[];var o=a-1,c=0,l=0;for(c=t;0<=c;){n[c]=!0,s[s.length]=c,i.push(e[c]);var f=r[Math.floor(4*c/a)];if(a<4+(l=4*c&o))throw new Error("FAT boundary crossed: "+c+" 4 "+a);if(!e[f])break;c=xr(e[f],l)}return{nodes:s,data:hr([i])}}(t,p.start,e.fat_addrs,e.ssz)),e[p.start].name=p.name,p.content=e[p.start].data.slice(0,p.size)):(p.storage="minifat",p.size<0?p.size=0:c!==k&&p.start!==k&&e[c]&&(p.content=function(e,t,r){var a=e.start,n=e.size,s=[],i=a;for(;r&&0<n&&0<=i;)s.push(t.slice(i*E,i*E+E)),n-=E,i=xr(r,4*i);return 0===s.length?Lr(0):ue(s).slice(0,e.size)}(p,e[c].data,(e[i]||{}).data))),p.content&&Dr(p.content,0),n[o]=p,s.push(p)}}(g,p,h,r,{},b,a),function(e,t,r){for(var a=0,n=0,s=0,i=0,o=0,c=r.length,l=[],f=[];a<c;++a)l[a]=f[a]=a,t[a]=r[a];for(;o<f.length;++o)a=f[o],n=e[a].L,s=e[a].R,i=e[a].C,l[a]===a&&(-1!==n&&l[n]!==n&&(l[a]=l[n]),-1!==s&&l[s]!==s&&(l[a]=l[s])),-1!==i&&(l[i]=a),-1!==n&&a!=l[a]&&(l[n]=l[a],f.lastIndexOf(n)<o&&f.push(n)),-1!==s&&a!=l[a]&&(l[s]=l[a],f.lastIndexOf(s)<o&&f.push(s));for(a=1;a<c;++a)l[a]===a&&(-1!==s&&l[s]!==s?l[a]=l[s]:-1!==n&&l[n]!==n&&(l[a]=l[n]));for(a=1;a<c;++a)if(0!==e[a].type){if((o=a)!=l[o])for(;o=l[o],t[a]=t[o]+"/"+t[a],0!==o&&-1!==l[o]&&o!=l[o];);l[a]=-1}for(t[0]+="/",a=1;a<c;++a)2!==e[a].type&&(t[a]+="/")}(b,i,h),h.shift();i={FileIndex:b,FullPaths:i};return t&&t.raw&&(i.raw={header:f,sectors:p}),i}function v(e,t){return new Date(1e3*(_r(e,t+4)/1e7*Math.pow(2,32)+_r(e,t)/1e7-11644473600))}function w(e,t){var r=t||{},t=r.root||"Root Entry";if(e.FullPaths||(e.FullPaths=[]),e.FileIndex||(e.FileIndex=[]),e.FullPaths.length!==e.FileIndex.length)throw new Error("inconsistent CFB structure");0===e.FullPaths.length&&(e.FullPaths[0]=t+"/",e.FileIndex[0]={name:t,type:5}),r.CLSID&&(e.FileIndex[0].clsid=r.CLSID),t=e,r="Sh33tJ5",xe.find(t,"/"+r)||((e=Lr(4))[0]=55,e[1]=e[3]=50,e[2]=54,t.FileIndex.push({name:r,type:2,content:e,size:4,L:69,R:69,C:69}),t.FullPaths.push(t.FullPaths[0]+r),u(t))}function u(e,t){w(e);for(var r=!1,a=!1,n=e.FullPaths.length-1;0<=n;--n){var s=e.FileIndex[n];switch(s.type){case 0:a?r=!0:(e.FileIndex.pop(),e.FullPaths.pop());break;case 1:case 2:case 5:a=!0,isNaN(s.R*s.L*s.C)&&(r=!0),-1<s.R&&-1<s.L&&s.R==s.L&&(r=!0);break;default:r=!0}}if(r||t){for(var i=new Date(1987,1,19),o=0,c=Object.create?Object.create(null):{},l=[],n=0;n<e.FullPaths.length;++n)c[e.FullPaths[n]]=!0,0!==e.FileIndex[n].type&&l.push([e.FullPaths[n],e.FileIndex[n]]);for(n=0;n<l.length;++n){var f=d(l[n][0]);(a=c[f])||(l.push([f,{name:p(f).replace("/",""),type:1,clsid:b,ct:i,mt:i,content:null}]),c[f]=!0)}for(l.sort(function(e,t){return function(e,t){for(var r,a=e.split("/"),n=t.split("/"),s=0,i=Math.min(a.length,n.length);s<i;++s){if(r=a[s].length-n[s].length)return r;if(a[s]!=n[s])return a[s]<n[s]?-1:1}return a.length-n.length}(e[0],t[0])}),e.FullPaths=[],e.FileIndex=[],n=0;n<l.length;++n)e.FullPaths[n]=l[n][0],e.FileIndex[n]=l[n][1];for(n=0;n<l.length;++n){var h=e.FileIndex[n],u=e.FullPaths[n];if(h.name=p(u).replace("/",""),h.L=h.R=h.C=-(h.color=1),h.size=h.content?h.content.length:0,h.start=0,h.clsid=h.clsid||b,0===n)h.C=1<l.length?1:-1,h.size=0,h.type=5;else if("/"==u.slice(-1)){for(o=n+1;o<l.length&&d(e.FullPaths[o])!=u;++o);for(h.C=o>=l.length?-1:o,o=n+1;o<l.length&&d(e.FullPaths[o])!=d(u);++o);h.R=o>=l.length?-1:o,h.type=1}else d(e.FullPaths[n+1]||"")==d(u)&&(h.R=n+1),h.type=2}}}function a(e,t){var r=t||{};if("mad"==r.fileType)return function(e,t){for(var r=t||{},a=r.boundary||"SheetJS",n=["MIME-Version: 1.0",'Content-Type: multipart/related; boundary="'+(a="------="+a).slice(2)+'"',"","",""],s=e.FullPaths[0],i=s,o=e.FileIndex[0],c=1;c<e.FullPaths.length;++c)if(i=e.FullPaths[c].slice(s.length),(o=e.FileIndex[c]).size&&o.content&&"Sh33tJ5"!=i){i=i.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g,function(e){return"_x"+e.charCodeAt(0).toString(16)+"_"}).replace(/[\u0080-\uFFFF]/g,function(e){return"_u"+e.charCodeAt(0).toString(16)+"_"});for(var l=o.content,f=se&&Buffer.isBuffer(l)?l.toString("binary"):_(l),h=0,u=Math.min(1024,f.length),d=0,p=0;p<=u;++p)32<=(d=f.charCodeAt(p))&&d<128&&++h;l=4*u/5<=h;n.push(a),n.push("Content-Location: "+(r.root||"file:///C:/SheetJS/")+i),n.push("Content-Transfer-Encoding: "+(l?"quoted-printable":"base64")),n.push("Content-Type: "+function(e,t){if(e.ctype)return e.ctype;var r=e.name||"",e=r.match(/\.([^\.]+)$/);if(e&&Z[e[1]])return Z[e[1]];if(t&&(e=(r=t).match(/[\.\\]([^\.\\])+$/))&&Z[e[1]])return Z[e[1]];return"application/octet-stream"}(o,i)),n.push(""),n.push((l?function(e){e=e.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g,function(e){e=e.charCodeAt(0).toString(16).toUpperCase();return"="+(1==e.length?"0"+e:e)});"\n"==(e=e.replace(/ $/gm,"=20").replace(/\t$/gm,"=09")).charAt(0)&&(e="=0D"+e.slice(1));e=e.replace(/\r(?!\n)/gm,"=0D").replace(/\n\n/gm,"\n=0A").replace(/([^\r\n])\n/gm,"$1=0A");for(var t=[],r=e.split("\r\n"),a=0;a<r.length;++a){var n=r[a];if(0!=n.length)for(var s=0;s<n.length;){var i=76,o=n.slice(s,s+i);"="==o.charAt(i-1)?i--:"="==o.charAt(i-2)?i-=2:"="==o.charAt(i-3)&&(i-=3),o=n.slice(s,s+i),(s+=i)<n.length&&(o+="="),t.push(o)}else t.push("")}return t.join("\r\n")}:function(e){for(var t=ee(e),r=[],a=0;a<t.length;a+=76)r.push(t.slice(a,a+76));return r.join("\r\n")+"\r\n"})(f))}return n.push(a+"--\r\n"),n.join("\r\n")}(e,r);if(u(e),"zip"===r.fileType)return function(e,t){var t=t||{},r=[],a=[],n=Lr(1),s=t.compression?8:0,i=0;0;var o=0,c=0,l=0,f=0,h=e.FullPaths[0],u=h,d=e.FileIndex[0],p=[],m=0;for(o=1;o<e.FullPaths.length;++o)if(u=e.FullPaths[o].slice(h.length),(d=e.FileIndex[o]).size&&d.content&&"Sh33tJ5"!=u){var g=l,b=Lr(u.length);for(c=0;c<u.length;++c)b.write_shift(1,127&u.charCodeAt(c));b=b.slice(0,b.l),p[f]=_e.buf(d.content,0);var v=d.content;8==s&&(v=function(e){return T?T.deflateRawSync(e):V(e)}(v)),(n=Lr(30)).write_shift(4,67324752),n.write_shift(2,20),n.write_shift(2,i),n.write_shift(2,s),d.mt?function(e,t){var r=(t="string"==typeof t?new Date(t):t).getHours();r=(r=r<<6|t.getMinutes())<<5|t.getSeconds()>>>1,e.write_shift(2,r),r=(r=(r=t.getFullYear()-1980)<<4|t.getMonth()+1)<<5|t.getDate(),e.write_shift(2,r)}(n,d.mt):n.write_shift(4,0),n.write_shift(-4,8&i?0:p[f]),n.write_shift(4,8&i?0:v.length),n.write_shift(4,8&i?0:d.content.length),n.write_shift(2,b.length),n.write_shift(2,0),l+=n.length,r.push(n),l+=b.length,r.push(b),l+=v.length,r.push(v),8&i&&((n=Lr(12)).write_shift(-4,p[f]),n.write_shift(4,v.length),n.write_shift(4,d.content.length),l+=n.l,r.push(n)),(n=Lr(46)).write_shift(4,33639248),n.write_shift(2,0),n.write_shift(2,20),n.write_shift(2,i),n.write_shift(2,s),n.write_shift(4,0),n.write_shift(-4,p[f]),n.write_shift(4,v.length),n.write_shift(4,d.content.length),n.write_shift(2,b.length),n.write_shift(2,0),n.write_shift(2,0),n.write_shift(2,0),n.write_shift(2,0),n.write_shift(4,0),n.write_shift(4,g),m+=n.l,a.push(n),m+=b.length,a.push(b),++f}return(n=Lr(22)).write_shift(4,101010256),n.write_shift(2,0),n.write_shift(2,0),n.write_shift(2,f),n.write_shift(2,f),n.write_shift(4,m),n.write_shift(4,l),n.write_shift(2,0),ue([ue(r),ue(a),n])}(e,r);for(var a=function(e){for(var t=0,r=0,a=0;a<e.FileIndex.length;++a){var n=e.FileIndex[a];n.content&&(0<(n=n.content.length)&&(n<4096?t+=n+63>>6:r+=n+511>>9))}for(var s=e.FullPaths.length+3>>2,i=t+127>>7,o=(t+7>>3)+r+s+i,c=o+127>>7,l=c<=109?0:Math.ceil((c-109)/127);c<o+c+l+127>>7;)l=++c<=109?0:Math.ceil((c-109)/127);s=[1,l,c,i,s,r,t,0];return e.FileIndex[0].size=t<<6,s[7]=(e.FileIndex[0].start=s[0]+s[1]+s[2]+s[3]+s[4]+s[5])+(s[6]+7>>3),s}(e),n=Lr(a[7]<<9),s=0,i=0,s=0;s<8;++s)n.write_shift(1,m[s]);for(s=0;s<8;++s)n.write_shift(2,0);for(n.write_shift(2,62),n.write_shift(2,3),n.write_shift(2,65534),n.write_shift(2,9),n.write_shift(2,6),s=0;s<3;++s)n.write_shift(2,0);for(n.write_shift(4,0),n.write_shift(4,a[2]),n.write_shift(4,a[0]+a[1]+a[2]+a[3]-1),n.write_shift(4,0),n.write_shift(4,4096),n.write_shift(4,a[3]?a[0]+a[1]+a[2]-1:k),n.write_shift(4,a[3]),n.write_shift(-4,a[1]?a[0]-1:k),n.write_shift(4,a[1]),s=0;s<109;++s)n.write_shift(-4,s<a[2]?a[1]+s:-1);if(a[1])for(i=0;i<a[1];++i){for(;s<236+127*i;++s)n.write_shift(-4,s<a[2]?a[1]+s:-1);n.write_shift(-4,i===a[1]-1?k:i+1)}function o(e){for(i+=e;s<i-1;++s)n.write_shift(-4,s+1);e&&(++s,n.write_shift(-4,k))}i=s=0;for(i+=a[1];s<i;++s)n.write_shift(-4,S.DIFSECT);for(i+=a[2];s<i;++s)n.write_shift(-4,S.FATSECT);o(a[3]),o(a[4]);for(var c=0,l=0,f=e.FileIndex[0];c<e.FileIndex.length;++c)(f=e.FileIndex[c]).content&&((l=f.content.length)<4096||(f.start=i,o(l+511>>9)));for(o(a[6]+7>>3);511&n.l;)n.write_shift(-4,S.ENDOFCHAIN);for(c=i=s=0;c<e.FileIndex.length;++c)(f=e.FileIndex[c]).content&&(!(l=f.content.length)||4096<=l||(f.start=i,o(l+63>>6)));for(;511&n.l;)n.write_shift(-4,S.ENDOFCHAIN);for(s=0;s<a[4]<<2;++s){var h=e.FullPaths[s];if(h&&0!==h.length){f=e.FileIndex[s],0===s&&(f.start=f.size?f.start-1:k);h=0===s&&r.root||f.name,l=2*(h.length+1);if(n.write_shift(64,h,"utf16le"),n.write_shift(2,l),n.write_shift(1,f.type),n.write_shift(1,f.color),n.write_shift(-4,f.L),n.write_shift(-4,f.R),n.write_shift(-4,f.C),f.clsid)n.write_shift(16,f.clsid,"hex");else for(c=0;c<4;++c)n.write_shift(4,0);n.write_shift(4,f.state||0),n.write_shift(4,0),n.write_shift(4,0),n.write_shift(4,0),n.write_shift(4,0),n.write_shift(4,f.start),n.write_shift(4,f.size),n.write_shift(4,0)}else{for(c=0;c<17;++c)n.write_shift(4,0);for(c=0;c<3;++c)n.write_shift(4,-1);for(c=0;c<12;++c)n.write_shift(4,0)}}for(s=1;s<e.FileIndex.length;++s)if(4096<=(f=e.FileIndex[s]).size)if(n.l=f.start+1<<9,se&&Buffer.isBuffer(f.content))f.content.copy(n,n.l,0,f.size),n.l+=f.size+511&-512;else{for(c=0;c<f.size;++c)n.write_shift(1,f.content[c]);for(;511&c;++c)n.write_shift(1,0)}for(s=1;s<e.FileIndex.length;++s)if(0<(f=e.FileIndex[s]).size&&f.size<4096)if(se&&Buffer.isBuffer(f.content))f.content.copy(n,n.l,0,f.size),n.l+=f.size+63&-64;else{for(c=0;c<f.size;++c)n.write_shift(1,f.content[c]);for(;63&c;++c)n.write_shift(1,0)}if(se)n.l=n.length;else for(;n.l<n.length;)n.write_shift(1,0);return n}e.version="1.2.1";var T,E=64,k=-2,y="d0cf11e0a1b11ae1",m=[208,207,17,224,161,177,26,225],b="00000000000000000000000000000000",S={MAXREGSECT:-6,DIFSECT:-4,FATSECT:-3,ENDOFCHAIN:k,FREESECT:-1,HEADER_SIGNATURE:y,HEADER_MINOR_VERSION:"3e00",MAXREGSID:-6,NOSTREAM:-1,HEADER_CLSID:b,EntryTypes:["unknown","storage","stream","lockbytes","property","root"]};function _(e){for(var t=new Array(e.length),r=0;r<e.length;++r)t[r]=String.fromCharCode(e[r]);return t.join("")}var x=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],A=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258],C=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577];for(var t,R="undefined"!=typeof Uint8Array,O=R?new Uint8Array(256):[],r=0;r<256;++r)O[r]=255&((t=139536&((t=r)<<1|t<<11)|558144&(t<<5|t<<15))>>16|t>>8|t);function I(e,t){var r=7&t,t=t>>>3;return(e[t]|(r<=5?0:e[1+t]<<8))>>>r&7}function N(e,t){var r=7&t,t=t>>>3;return(e[t]|(r<=3?0:e[1+t]<<8))>>>r&31}function F(e,t){var r=7&t,t=t>>>3;return(e[t]|(r<=1?0:e[1+t]<<8))>>>r&127}function D(e,t,r){var a=7&t,n=t>>>3,s=(1<<r)-1,t=e[n]>>>a;return r<8-a?t&s:(t|=e[1+n]<<8-a,r<16-a?t&s:(t|=e[2+n]<<16-a,r<24-a?t&s:(t|=e[3+n]<<24-a)&s))}function P(e,t,r){var a=7&t,n=t>>>3;return a<=5?e[n]|=(7&r)<<a:(e[n]|=r<<a&255,e[1+n]=(7&r)>>8-a),t+3}function L(e,t,r){var a=t>>>3;return r<<=7&t,e[a]|=255&r,r>>>=8,e[1+a]=r,t+8}function M(e,t,r){var a=t>>>3;return r<<=7&t,e[a]|=255&r,r>>>=8,e[1+a]=255&r,e[2+a]=r>>>8,t+16}function U(e,t){var r=e.length,a=t<2*r?2*r:t+5,n=0;if(t<=r)return e;if(se){var s=fe(a);if(e.copy)e.copy(s);else for(;n<e.length;++n)s[n]=e[n];return s}if(R){var i=new Uint8Array(a);if(i.set)i.set(e);else for(;n<r;++n)i[n]=e[n];return i}return e.length=a,e}function B(e){for(var t=new Array(e),r=0;r<e;++r)t[r]=0;return t}function W(e,t,r){for(var a,n=1,s=0,i=0,o=0,c=e.length,l=R?new Uint16Array(32):B(32),s=0;s<32;++s)l[s]=0;for(s=c;s<r;++s)e[s]=0;c=e.length;var f=R?new Uint16Array(c):B(c);for(s=0;s<c;++s)l[a=e[s]]++,n<a&&(n=a),f[s]=0;for(l[0]=0,s=1;s<=n;++s)l[s+16]=o=o+l[s-1]<<1;for(s=0;s<c;++s)0!=(o=e[s])&&(f[s]=l[o+16]++);var h,u,d,p;for(s=0;s<c;++s)if(0!=(h=e[s]))for(u=f[s],d=n,p=void 0,p=O[255&u],o=(d<=8?p>>>8-d:(p=p<<8|O[u>>8&255],d<=16?p>>>16-d:(p=p<<8|O[u>>16&255])>>>24-d))>>n-h,i=(1<<n+4-h)-1;0<=i;--i)t[o|i<<h]=15&h|s<<4;return n}var H=R?new Uint16Array(512):B(512),z=R?new Uint16Array(32):B(32);if(!R){for(var n=0;n<512;++n)H[n]=0;for(n=0;n<32;++n)z[n]=0}!function(){for(var e=[],t=0;t<32;t++)e.push(5);W(e,z,32);for(var r=[],t=0;t<=143;t++)r.push(8);for(;t<=255;t++)r.push(9);for(;t<=279;t++)r.push(7);for(;t<=287;t++)r.push(8);W(r,H,288)}();var c=function(){for(var d=R?new Uint8Array(32768):[],e=0,t=0;e<C.length-1;++e)for(;t<C[e+1];++t)d[t]=e;for(;t<32768;++t)d[t]=29;for(var p=R?new Uint8Array(259):[],e=0,t=0;e<A.length-1;++e)for(;t<A[e+1];++t)p[t]=e;return function(e,t){return(e.length<8?function(e,t){for(var r=0;r<e.length;){var a=Math.min(65535,e.length-r),n=r+a==e.length;for(t.write_shift(1,+n),t.write_shift(2,a),t.write_shift(2,65535&~a);0<a--;)t[t.l++]=e[r++]}return t.l}:function(e,t){for(var r=0,a=0,n=R?new Uint16Array(32768):[];a<e.length;){var s=Math.min(65535,e.length-a);if(s<10){for(7&(r=P(t,r,+!(a+s!=e.length)))&&(r+=8-(7&r)),t.l=r/8|0,t.write_shift(2,s),t.write_shift(2,65535&~s);0<s--;)t[t.l++]=e[a++];r=8*t.l}else{r=P(t,r,+!(a+s!=e.length)+2);for(var i=0;0<s--;){var o=e[a],i=32767&(i<<5^o),c=-1,l=0;if((c=n[i])&&(a<(c|=-32768&a)&&(c-=32768),c<a))for(;e[c+l]==e[a+l]&&l<250;)++l;if(2<l){(o=p[l])<=22?r=L(t,r,O[o+1]>>1)-1:(L(t,r,3),L(t,r+=5,O[o-23]>>5),r+=3);var f=o<8?0:o-4>>2;0<f&&(M(t,r,l-A[o]),r+=f),o=d[a-c],r=L(t,r,O[o]>>3),r-=3;var h=o<4?0:o-2>>1;0<h&&(M(t,r,a-c-C[o]),r+=h);for(var u=0;u<l;++u)n[i]=32767&a,i=32767&(i<<5^e[a]),++a;s-=l-1}else o<=143?o+=48:(f=((f=1)&f)<<(7&(h=r)),t[h>>>3]|=f,r=h+1),r=L(t,r,O[o]),n[i]=32767&a,++a}r=L(t,r,0)-1}}return t.l=(r+7)/8|0,t.l})(e,t)}}();function V(e){var t=Lr(50+Math.floor(1.1*e.length)),e=c(e,t);return t.slice(0,e)}var G=R?new Uint16Array(32768):B(32768),j=R?new Uint16Array(32768):B(32768),$=R?new Uint16Array(128):B(128),X=1,Y=1;function l(e,t){if(3==e[0]&&!(3&e[1]))return[le(t),2];for(var r=0,a=0,n=fe(t||1<<18),s=0,i=n.length>>>0,o=0,c=0;0==(1&a);)if(a=I(e,r),r+=3,a>>>1!=0)for(c=a>>1==1?(o=9,5):(r=function(e,t){var r,a,n,s=N(e,t)+257,i=N(e,t+=5)+1,o=(n=7&(a=t+=5),4+(((r=e)[a=a>>>3]|(n<=4?0:r[1+a]<<8))>>>n&15));t+=4;for(var c=0,l=R?new Uint8Array(19):B(19),f=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],h=1,u=R?new Uint8Array(8):B(8),d=R?new Uint8Array(8):B(8),p=l.length,m=0;m<o;++m)l[x[m]]=c=I(e,t),h<c&&(h=c),u[c]++,t+=3;var g=0;for(u[0]=0,m=1;m<=h;++m)d[m]=g=g+u[m-1]<<1;for(m=0;m<p;++m)0!=(g=l[m])&&(f[m]=d[g]++);for(var b,m=0;m<p;++m)if(0!=(b=l[m])){g=O[f[m]]>>8-b;for(var v=(1<<7-b)-1;0<=v;--v)$[g|v<<b]=7&b|m<<3}for(var w,T,E,k=[],h=1;k.length<s+i;)switch(t+=7&(g=$[F(e,t)]),g>>>=3){case 16:for(c=3+(E=void 0,E=7&(T=t),((w=e)[T=T>>>3]|(E<=6?0:w[1+T]<<8))>>>E&3),t+=2,g=k[k.length-1];0<c--;)k.push(g);break;case 17:for(c=3+I(e,t),t+=3;0<c--;)k.push(0);break;case 18:for(c=11+F(e,t),t+=7;0<c--;)k.push(0);break;default:k.push(g),h<g&&(h=g)}var y=k.slice(0,s),S=k.slice(s);for(m=s;m<286;++m)y[m]=0;for(m=i;m<30;++m)S[m]=0;return X=W(y,G,286),Y=W(S,j,30),t}(e,r),o=X,Y);;){!t&&i<s+32767&&(i=(n=U(n,s+32767)).length);var l=D(e,r,o),f=(a>>>1==1?H:G)[l];if(r+=15&f,0==((f>>>=4)>>>8&255))n[s++]=f;else{if(256==f)break;var h=(f-=257)<8?0:f-4>>2;5<h&&(h=0);var u=s+A[f];0<h&&(u+=D(e,r,h),r+=h),l=D(e,r,c),r+=15&(f=(a>>>1==1?z:j)[l]);var l=(f>>>=4)<4?0:f-2>>1,d=C[f];for(0<l&&(d+=D(e,r,l),r+=l),!t&&i<u&&(i=(n=U(n,u+100)).length);s<u;)n[s]=n[s-d],++s}}else{7&r&&(r+=8-(7&r));var p=e[r>>>3]|e[1+(r>>>3)]<<8;if(r+=32,0<p)for(!t&&i<s+p&&(i=(n=U(n,s+p)).length);0<p--;)n[s++]=e[r>>>3],r+=8}return t?[n,r+7>>>3]:[n.slice(0,s),r+7>>>3]}function K(e,t){t=l(e.slice(e.l||0),t);return e.l+=t[1],t[0]}function J(e,t){if(!e)throw new Error(t);"undefined"!=typeof console&&console.error(t)}function q(e,t){var r=e;Dr(r,0);var a={FileIndex:[],FullPaths:[]};w(a,{root:t.root});for(var n=r.length-4;(80!=r[n]||75!=r[n+1]||5!=r[n+2]||6!=r[n+3])&&0<=n;)--n;r.l=n+4,r.l+=4;var s=r.read_shift(2);r.l+=6;t=r.read_shift(4);for(r.l=t,n=0;n<s;++n){r.l+=20;var i=r.read_shift(4),o=r.read_shift(4),c=r.read_shift(2),l=r.read_shift(2),f=r.read_shift(2);r.l+=8;var h=r.read_shift(4),u=g(r.slice(r.l+c,r.l+c+l));r.l+=c+l+f;f=r.l;r.l=h+4,function(e,t,r,a,n){e.l+=2;var s=e.read_shift(2),i=e.read_shift(2),o=function(e){var t=65535&e.read_shift(2),r=65535&e.read_shift(2),a=new Date,n=31&r,e=15&(r>>>=5);return r>>>=4,a.setMilliseconds(0),a.setFullYear(1980+r),a.setMonth(e-1),a.setDate(n),e=31&t,n=63&(t>>>=5),t>>>=6,a.setHours(t),a.setMinutes(n),a.setSeconds(e<<1),a}(e);if(8257&s)throw new Error("Unsupported ZIP encryption");e.read_shift(4);for(var c,l=e.read_shift(4),f=e.read_shift(4),h=e.read_shift(2),u=e.read_shift(2),d="",p=0;p<h;++p)d+=String.fromCharCode(e[e.l++]);u&&(((c=g(e.slice(e.l,e.l+u)))[21589]||{}).mt&&(o=c[21589].mt),((n||{})[21589]||{}).mt&&(o=n[21589].mt)),e.l+=u;var m=e.slice(e.l,e.l+l);switch(i){case 8:m=function(e,t){if(!T)return K(e,t);var r=new T.InflateRaw,t=r._processChunk(e.slice(e.l),r._finishFlushFlag);return e.l+=r.bytesRead,t}(e,f);break;case 0:break;default:throw new Error("Unsupported ZIP Compression method "+i)}u=!1,8&s&&(134695760==e.read_shift(4)&&(e.read_shift(4),u=!0),l=e.read_shift(4),f=e.read_shift(4)),l!=t&&J(u,"Bad compressed size: "+t+" != "+l),f!=r&&J(u,"Bad uncompressed size: "+r+" != "+f),Q(a,d,m,{unsafe:!0,mt:o})}(r,i,o,a,u),r.l=f}return a}var Z={htm:"text/html",xml:"text/xml",gif:"image/gif",jpg:"image/jpeg",png:"image/png",mso:"application/x-mso",thmx:"application/vnd.ms-officetheme",sh33tj5:"application/octet-stream"};function Q(e,t,r,a){var n=a&&a.unsafe;n||w(e);var s,i=!n&&xe.find(e,t);return i||(s=e.FullPaths[0],s=t.slice(0,s.length)==s?t:("/"!=s.slice(-1)&&(s+="/"),(s+t).replace("//","/")),i={name:p(t),type:2},e.FileIndex.push(i),e.FullPaths.push(s),n||xe.utils.cfb_gc(e)),i.content=r,i.size=r?r.length:0,a&&(a.CLSID&&(i.clsid=a.CLSID),a.mt&&(i.mt=a.mt),a.ct&&(i.ct=a.ct)),i}return e.find=function(e,t){var r=e.FullPaths.map(function(e){return e.toUpperCase()}),a=r.map(function(e){var t=e.split("/");return t[t.length-("/"==e.slice(-1)?2:1)]}),n=!1;47===t.charCodeAt(0)?(n=!0,t=r[0].slice(0,-1)+t):n=-1!==t.indexOf("/");var s=t.toUpperCase(),i=(!0===n?r:a).indexOf(s);if(-1!==i)return e.FileIndex[i];var o=!s.match(pe),s=s.replace(de,"");for(o&&(s=s.replace(pe,"!")),i=0;i<r.length;++i){if((o?r[i].replace(pe,"!"):r[i]).replace(de,"")==s)return e.FileIndex[i];if((o?a[i].replace(pe,"!"):a[i]).replace(de,"")==s)return e.FileIndex[i]}return null},e.read=function(e,t){var r,a,n=t&&t.type;switch(n||se&&Buffer.isBuffer(e)&&(n="buffer"),n||"base64"){case"file":return r=e,a=t,i(),o(s.readFileSync(r),a);case"base64":return o(he(te(e)),t);case"binary":return o(he(e),t)}return o(e,t)},e.parse=o,e.write=function(e,t){var r=a(e,t);switch(t&&t.type||"buffer"){case"file":return i(),s.writeFileSync(t.filename,r),r;case"binary":return"string"==typeof r?r:_(r);case"base64":return ee("string"==typeof r?r:_(r));case"buffer":if(se)return Buffer.isBuffer(r)?r:ce(r);case"array":return"string"==typeof r?he(r):r}return r},e.writeFile=function(e,t,r){i(),r=a(e,r),s.writeFileSync(t,r)},e.utils={cfb_new:function(e){var t={};return w(t,e),t},cfb_add:Q,cfb_del:function(e,t){w(e);var r=xe.find(e,t);if(r)for(var a=0;a<e.FileIndex.length;++a)if(e.FileIndex[a]==r)return e.FileIndex.splice(a,1),e.FullPaths.splice(a,1),!0;return!1},cfb_mov:function(e,t,r){w(e);var a=xe.find(e,t);if(a)for(var n=0;n<e.FileIndex.length;++n)if(e.FileIndex[n]==a)return e.FileIndex[n].name=p(r),e.FullPaths[n]=r,!0;return!1},cfb_gc:function(e){u(e,!0)},ReadShift:Cr,CheckField:Fr,prep_blob:Dr,bconcat:ue,use_zlib:function(e){try{var t=new e.InflateRaw;if(t._processChunk(new Uint8Array([3,0]),t._finishFlushFlag),!t.bytesRead)throw new Error("zlib does not expose bytesRead");T=e}catch(e){console.error("cannot use native zlib: "+(e.message||e))}},_deflateRaw:V,_inflateRaw:K,consts:S},e}();if("undefined"!=typeof require)try{Se=require("fs")}catch(e){}function Ae(e){return"string"==typeof e?o(e):Array.isArray(e)?function(e){if("undefined"==typeof Uint8Array)throw new Error("Unsupported");return new Uint8Array(e)}(e):e}function Ce(e,t,r){if(void 0!==Se&&Se.writeFileSync)return r?Se.writeFileSync(e,t,r):Se.writeFileSync(e,t);if("undefined"!=typeof Deno){if(r&&"string"==typeof t)switch(r){case"utf8":t=new TextEncoder(r).encode(t);break;case"binary":t=o(t);break;default:throw new Error("Unsupported encoding "+r)}return Deno.writeFileSync(e,t)}var a="utf8"==r?Ut(t):t;if("undefined"!=typeof IE_SaveFile)return IE_SaveFile(a,e);if("undefined"!=typeof Blob){a=new Blob([Ae(a)],{type:"application/octet-stream"});if("undefined"!=typeof navigator&&navigator.msSaveBlob)return navigator.msSaveBlob(a,e);if("undefined"!=typeof saveAs)return saveAs(a,e);if("undefined"!=typeof URL&&"undefined"!=typeof document&&document.createElement&&URL.createObjectURL){var n=URL.createObjectURL(a);if("object"==typeof chrome&&"function"==typeof(chrome.downloads||{}).download)return URL.revokeObjectURL&&"undefined"!=typeof setTimeout&&setTimeout(function(){URL.revokeObjectURL(n)},6e4),chrome.downloads.download({url:n,filename:e,saveAs:!0});a=document.createElement("a");if(null!=a.download)return a.download=e,a.href=n,document.body.appendChild(a),a.click(),document.body.removeChild(a),URL.revokeObjectURL&&"undefined"!=typeof setTimeout&&setTimeout(function(){URL.revokeObjectURL(n)},6e4),n}}if("undefined"!=typeof $&&"undefined"!=typeof File&&"undefined"!=typeof Folder)try{var s=File(e);return s.open("w"),s.encoding="binary",Array.isArray(t)&&(t=i(t)),s.write(t),s.close(),t}catch(e){if(!e.message||!e.message.match(/onstruct/))throw e}throw new Error("cannot save file "+e)}function Re(e){for(var t=Object.keys(e),r=[],a=0;a<t.length;++a)Object.prototype.hasOwnProperty.call(e,t[a])&&r.push(t[a]);return r}function Oe(e,t){for(var r=[],a=Re(e),n=0;n!==a.length;++n)null==r[e[a[n]][t]]&&(r[e[a[n]][t]]=a[n]);return r}function Ie(e){for(var t=[],r=Re(e),a=0;a!==r.length;++a)t[e[r[a]]]=r[a];return t}function Ne(e){for(var t=[],r=Re(e),a=0;a!==r.length;++a)t[e[r[a]]]=parseInt(r[a],10);return t}var Fe=new Date(1899,11,30,0,0,0);function De(e,t){var r=e.getTime();return t&&(r-=1263168e5),(r-(Fe.getTime()+6e4*(e.getTimezoneOffset()-Fe.getTimezoneOffset())))/864e5}var r=new Date,Pe=Fe.getTime()+6e4*(r.getTimezoneOffset()-Fe.getTimezoneOffset()),Le=r.getTimezoneOffset();function Me(e){var t=new Date;return t.setTime(24*e*60*60*1e3+Pe),t.getTimezoneOffset()!==Le&&t.setTime(t.getTime()+6e4*(t.getTimezoneOffset()-Le)),t}var Ue=new Date("2017-02-19T19:06:09.000Z"),Be=isNaN(Ue.getFullYear())?new Date("2/19/17"):Ue,We=2017==Be.getFullYear();function He(e,t){var r=new Date(e);if(We)return 0<t?r.setTime(r.getTime()+60*r.getTimezoneOffset()*1e3):t<0&&r.setTime(r.getTime()-60*r.getTimezoneOffset()*1e3),r;if(e instanceof Date)return e;if(1917==Be.getFullYear()&&!isNaN(r.getFullYear())){t=r.getFullYear();return-1<e.indexOf(""+t)?r:(r.setFullYear(r.getFullYear()+100),r)}r=e.match(/\d+/g)||["2017","2","19","0","0","0"],r=new Date(+r[0],+r[1]-1,+r[2],+r[3]||0,+r[4]||0,+r[5]||0);return r=-1<e.indexOf("Z")?new Date(r.getTime()-60*r.getTimezoneOffset()*1e3):r}function ze(e,t){if(se&&Buffer.isBuffer(e)){if(t){if(255==e[0]&&254==e[1])return Ut(e.slice(2).toString("utf16le"));if(254==e[1]&&255==e[2])return Ut(s(e.slice(2).toString("binary")))}return e.toString("binary")}if("undefined"!=typeof TextDecoder)try{if(t){if(255==e[0]&&254==e[1])return Ut(new TextDecoder("utf-16le").decode(e.slice(2)));if(254==e[0]&&255==e[1])return Ut(new TextDecoder("utf-16be").decode(e.slice(2)))}var r={"€":"","‚":"","ƒ":"","„":"","…":"","†":"","‡":"","ˆ":"","‰":"","Š":"","‹":"","Œ":"","Ž":"","‘":"","’":"","“":"","”":"","•":"","–":"","—":"","˜":"","™":"","š":"","›":"","œ":"","ž":"","Ÿ":""};return Array.isArray(e)&&(e=new Uint8Array(e)),new TextDecoder("latin1").decode(e).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g,function(e){return r[e]||e})}catch(e){}for(var a=[],n=0;n!=e.length;++n)a.push(String.fromCharCode(e[n]));return a.join("")}function Ve(e){if("undefined"!=typeof JSON&&!Array.isArray(e))return JSON.parse(JSON.stringify(e));if("object"!=typeof e||null==e)return e;if(e instanceof Date)return new Date(e.getTime());var t,r={};for(t in e)Object.prototype.hasOwnProperty.call(e,t)&&(r[t]=Ve(e[t]));return r}function Ge(e,t){for(var r="";r.length<t;)r+=e;return r}function je(e){var t=Number(e);if(!isNaN(t))return isFinite(t)?t:NaN;if(!/\d/.test(e))return t;var r=1,e=e.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g,function(){return r*=100,""});return isNaN(t=Number(e))?(e=e.replace(/[(](.*)[)]/,function(e,t){return r=-r,t}),isNaN(t=Number(e))?t:t/r):t/r}var $e=["january","february","march","april","may","june","july","august","september","october","november","december"];function Xe(e){var t=new Date(e),r=new Date(NaN),a=t.getYear(),n=t.getMonth(),s=t.getDate();if(isNaN(s))return r;var i=e.toLowerCase();if(i.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)){if(3<(i=i.replace(/[^a-z]/g,"").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/,"")).length&&-1==$e.indexOf(i))return r}else if(i.match(/[a-z]/))return r;return a<0||8099<a||(!(0<n||1<s)||101==a)&&e.match(/[^-0-9:,\/\\]/)?r:t}var Ye,Ke=(Ye=5=="abacaba".split(/(:?b)/i).length,function(e,t,r){if(Ye||"string"==typeof t)return e.split(t);for(var a=e.split(t),n=[a[0]],s=1;s<a.length;++s)n.push(r),n.push(a[s]);return n});function Je(e){return e?e.content&&e.type?ze(e.content,!0):e.data?ne(e.data):e.asNodeBuffer&&se?ne(e.asNodeBuffer().toString("binary")):e.asBinary?ne(e.asBinary()):e._data&&e._data.getContent?ne(ze(Array.prototype.slice.call(e._data.getContent(),0))):null:null}function qe(e){if(!e)return null;if(e.data)return ae(e.data);if(e.asNodeBuffer&&se)return e.asNodeBuffer();if(e._data&&e._data.getContent){var t=e._data.getContent();return"string"==typeof t?ae(t):Array.prototype.slice.call(t)}return e.content&&e.type?e.content:null}function Ze(e,t){for(var r=e.FullPaths||Re(e.files),a=t.toLowerCase().replace(/[\/]/g,"\\"),n=a.replace(/\\/g,"/"),s=0;s<r.length;++s){var i=r[s].replace(/^Root Entry[\/]/,"").toLowerCase();if(a==i||n==i)return e.files?e.files[r[s]]:e.FileIndex[s]}return null}function Qe(e,t){e=Ze(e,t);if(null==e)throw new Error("Cannot find file "+t+" in zip");return e}function et(e,t,r){if(!r)return((r=Qe(e,t))&&".bin"===r.name.slice(-4)?qe:Je)(r);if(!t)return null;try{return et(e,t)}catch(e){return null}}function tt(e,t,r){if(!r)return Je(Qe(e,t));if(!t)return null;try{return tt(e,t)}catch(e){return null}}function rt(e){for(var t=e.FullPaths||Re(e.files),r=[],a=0;a<t.length;++a)"/"!=t[a].slice(-1)&&r.push(t[a].replace(/^Root Entry[\/]/,""));return r.sort()}function at(e,t,r){if(e.FullPaths){if("string"==typeof r){var a=(se?ce:function(e){for(var t=[],r=0,a=e.length+250,n=le(e.length+255),s=0;s<e.length;++s){var i,o=e.charCodeAt(s);o<128?n[r++]=o:o<2048?(n[r++]=192|o>>6&31,n[r++]=128|63&o):55296<=o&&o<57344?(o=64+(1023&o),i=1023&e.charCodeAt(++s),n[r++]=240|o>>8&7,n[r++]=128|o>>2&63,n[r++]=128|i>>6&15|(3&o)<<4,n[r++]=128|63&i):(n[r++]=224|o>>12&15,n[r++]=128|o>>6&63,n[r++]=128|63&o),a<r&&(t.push(n.slice(0,r)),r=0,n=le(65535),a=65530)}return t.push(n.slice(0,r)),ue(t)})(r);return xe.utils.cfb_add(e,t,a)}xe.utils.cfb_add(e,t,r)}else e.file(t,r)}function nt(){return xe.utils.cfb_new()}function st(e,t){switch(t.type){case"base64":return xe.read(e,{type:"base64"});case"binary":return xe.read(e,{type:"binary"});case"buffer":case"array":return xe.read(e,{type:"buffer"})}throw new Error("Unrecognized type "+t.type)}function it(e,t){if("/"==e.charAt(0))return e.slice(1);var r=t.split("/");"/"!=t.slice(-1)&&r.pop();for(var a=e.split("/");0!==a.length;){var n=a.shift();".."===n?r.pop():"."!==n&&r.push(n)}return r.join("/")}var ot='<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n',ct=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g,lt=/<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/gm,ft=ot.match(lt)?lt:/<[^>]*>/g,ht=/<\w*:/,ut=/<(\/?)\w+:/;function dt(e,t,r){for(var a={},n=0,s=0;n!==e.length&&(32!==(s=e.charCodeAt(n))&&10!==s&&13!==s);++n);if(t||(a[0]=e.slice(0,n)),n===e.length)return a;var i,o,c,l=e.match(ct),f=0,h=0,u="",d="";if(l)for(h=0;h!=l.length;++h){for(d=l[h],s=0;s!=d.length&&61!==d.charCodeAt(s);++s);for(u=d.slice(0,s).trim();32==d.charCodeAt(s+1);)++s;for(o=34==(n=d.charCodeAt(s+1))||39==n?1:0,i=d.slice(s+1+o,d.length-o),f=0;f!=u.length&&58!==u.charCodeAt(f);++f);f===u.length?(a[u=0<u.indexOf("_")?u.slice(0,u.indexOf("_")):u]=i,r||(a[u.toLowerCase()]=i)):a[c=(5===f&&"xmlns"===u.slice(0,5)?"xmlns":"")+u.slice(f+1)]&&"ext"==u.slice(f-3,f)||(a[c]=i,r||(a[c.toLowerCase()]=i))}return a}function pt(e){return e.replace(ut,"<$1")}var mt,gt,bt={"&quot;":'"',"&apos;":"'","&gt;":">","&lt;":"<","&amp;":"&"},vt=Ie(bt),wt=(mt=/&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/gi,gt=/_x([\da-fA-F]{4})_/gi,function e(t){var r=t+"",a=r.indexOf("<![CDATA[");if(-1==a)return r.replace(mt,function(e,t){return bt[e]||String.fromCharCode(parseInt(t,-1<e.indexOf("x")?16:10))||e}).replace(gt,function(e,t){return String.fromCharCode(parseInt(t,16))});t=r.indexOf("]]>");return e(r.slice(0,a))+r.slice(a+9,t)+e(r.slice(t+3))}),Tt=/[&<>'"]/g,Et=/[\u0000-\u0008\u000b-\u001f]/g;function kt(e){return(e+"").replace(Tt,function(e){return vt[e]}).replace(Et,function(e){return"_x"+("000"+e.charCodeAt(0).toString(16)).slice(-4)+"_"})}function yt(e){return kt(e).replace(/ /g,"_x0020_")}var St=/[\u0000-\u001f]/g;function _t(e){return(e+"").replace(Tt,function(e){return vt[e]}).replace(/\n/g,"<br/>").replace(St,function(e){return"&#x"+("000"+e.charCodeAt(0).toString(16)).slice(-4)+";"})}var xt,At=(xt=/&#(\d+);/g,function(e){return e.replace(xt,Ct)});function Ct(e,t){return String.fromCharCode(parseInt(t,10))}function Rt(e){switch(e){case 1:case!0:case"1":case"true":case"TRUE":return!0;default:return!1}}function Ot(e){for(var t,r,a,n,s="",i=0,o=0;i<e.length;)(t=e.charCodeAt(i++))<128?s+=String.fromCharCode(t):(r=e.charCodeAt(i++),191<t&&t<224?(o=(31&t)<<6,o|=63&r,s+=String.fromCharCode(o)):(a=e.charCodeAt(i++),t<240?s+=String.fromCharCode((15&t)<<12|(63&r)<<6|63&a):(n=((7&t)<<18|(63&r)<<12|(63&a)<<6|63&(o=e.charCodeAt(i++)))-65536,s+=String.fromCharCode(55296+(n>>>10&1023)),s+=String.fromCharCode(56320+(1023&n)))));return s}function It(e){for(var t,r,a=le(2*e.length),n=1,s=0,i=0,o=0;o<e.length;o+=n)n=1,(r=e.charCodeAt(o))<128?t=r:r<224?(t=64*(31&r)+(63&e.charCodeAt(o+1)),n=2):r<240?(t=4096*(15&r)+64*(63&e.charCodeAt(o+1))+(63&e.charCodeAt(o+2)),n=3):(n=4,t=262144*(7&r)+4096*(63&e.charCodeAt(o+1))+64*(63&e.charCodeAt(o+2))+(63&e.charCodeAt(o+3)),i=55296+((t-=65536)>>>10&1023),t=56320+(1023&t)),0!==i&&(a[s++]=255&i,a[s++]=i>>>8,i=0),a[s++]=t%256,a[s++]=t>>>8;return a.slice(0,s).toString("ucs2")}function Nt(e){return ce(e,"binary").toString("utf8")}var Ft,Dt,Pt,Lt="foo bar bazâð£",Mt=se&&(Nt(Lt)==Ot(Lt)?Nt:It(Lt)==Ot(Lt)&&It)||Ot,Ut=se?function(e){return ce(e,"utf8").toString("binary")}:function(e){for(var t,r=[],a=0,n=0;a<e.length;)switch(!0){case(n=e.charCodeAt(a++))<128:r.push(String.fromCharCode(n));break;case n<2048:r.push(String.fromCharCode(192+(n>>6))),r.push(String.fromCharCode(128+(63&n)));break;case 55296<=n&&n<57344:n-=55296,t=e.charCodeAt(a++)-56320+(n<<10),r.push(String.fromCharCode(240+(t>>18&7))),r.push(String.fromCharCode(144+(t>>12&63))),r.push(String.fromCharCode(128+(t>>6&63))),r.push(String.fromCharCode(128+(63&t)));break;default:r.push(String.fromCharCode(224+(n>>12))),r.push(String.fromCharCode(128+(n>>6&63))),r.push(String.fromCharCode(128+(63&n)))}return r.join("")},Bt=(Ft={},function(e,t){var r=e+"|"+(t||"");return Ft[r]||(Ft[r]=new RegExp("<(?:\\w+:)?"+e+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+e+">",t||""))}),Wt=(Dt=[["nbsp"," "],["middot","·"],["quot",'"'],["apos","'"],["gt",">"],["lt","<"],["amp","&"]].map(function(e){return[new RegExp("&"+e[0]+";","ig"),e[1]]}),function(e){for(var t=e.replace(/^[\t\n\r ]+/,"").replace(/[\t\n\r ]+$/,"").replace(/>\s+/g,">").replace(/\s+</g,"<").replace(/[\t\n\r ]+/g," ").replace(/<\s*[bB][rR]\s*\/?>/g,"\n").replace(/<[^>]*>/g,""),r=0;r<Dt.length;++r)t=t.replace(Dt[r][0],Dt[r][1]);return t}),Ht=(Pt={},function(e){return void 0!==Pt[e]?Pt[e]:Pt[e]=new RegExp("<(?:vt:)?"+e+">([\\s\\S]*?)</(?:vt:)?"+e+">","g")}),zt=/<\/?(?:vt:)?variant>/g,Vt=/<(?:vt:)([^>]*)>([\s\S]*)</;function Gt(e,t){var r=dt(e),e=e.match(Ht(r.baseType))||[],a=[];if(e.length==r.size)return e.forEach(function(e){e=e.replace(zt,"").match(Vt);e&&a.push({v:Mt(e[2]),t:e[1]})}),a;if(t.WTF)throw new Error("unexpected vector length "+e.length+" != "+r.size);return a}var jt=/(^\s|\s$|\n)/;function $t(e,t){return"<"+e+(t.match(jt)?' xml:space="preserve"':"")+">"+t+"</"+e+">"}function Xt(t){return Re(t).map(function(e){return" "+e+'="'+t[e]+'"'}).join("")}function Yt(e,t,r){return"<"+e+(null!=r?Xt(r):"")+(null!=t?(t.match(jt)?' xml:space="preserve"':"")+">"+t+"</"+e:"/")+">"}function Kt(e,t){try{return e.toISOString().replace(/\.\d*/,"")}catch(e){if(t)throw e}return""}function Jt(e){if(se&&Buffer.isBuffer(e))return e.toString("utf8");if("string"==typeof e)return e;if("undefined"!=typeof Uint8Array&&e instanceof Uint8Array)return Mt(i(m(e)));throw new Error("Bad input format: expected Buffer or string")}var qt=/<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/gm,Zt={CORE_PROPS:"http://schemas.openxmlformats.org/package/2006/metadata/core-properties",CUST_PROPS:"http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",EXT_PROPS:"http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",CT:"http://schemas.openxmlformats.org/package/2006/content-types",RELS:"http://schemas.openxmlformats.org/package/2006/relationships",TCMNT:"http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments",dc:"http://purl.org/dc/elements/1.1/",dcterms:"http://purl.org/dc/terms/",dcmitype:"http://purl.org/dc/dcmitype/",mx:"http://schemas.microsoft.com/office/mac/excel/2008/main",r:"http://schemas.openxmlformats.org/officeDocument/2006/relationships",sjs:"http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",vt:"http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",xsi:"http://www.w3.org/2001/XMLSchema-instance",xsd:"http://www.w3.org/2001/XMLSchema"},Qt=["http://schemas.openxmlformats.org/spreadsheetml/2006/main","http://purl.oclc.org/ooxml/spreadsheetml/main","http://schemas.microsoft.com/office/excel/2006/main","http://schemas.microsoft.com/office/excel/2006/2"],er={o:"urn:schemas-microsoft-com:office:office",x:"urn:schemas-microsoft-com:office:excel",ss:"urn:schemas-microsoft-com:office:spreadsheet",dt:"uuid:C2F41010-65B3-11d1-A29F-00AA00C14882",mv:"http://macVmlSchemaUri",v:"urn:schemas-microsoft-com:vml",html:"http://www.w3.org/TR/REC-html40"};function tr(e){for(var t=[],r=0;r<e[0].length;++r)if(e[0][r])for(var a=0,n=e[0][r].length;a<n;a+=10240)t.push.apply(t,e[0][r].slice(a,a+10240));return t}function rr(e,t,r){for(var a=[],n=t;n<r;n+=2)a.push(String.fromCharCode(yr(e,n)));return a.join("").replace(de,"")}function ar(e,t,r){for(var a=[],n=t;n<t+r;++n)a.push(("0"+e[n].toString(16)).slice(-2));return a.join("")}function nr(e,t,r){for(var a=[],n=t;n<r;n++)a.push(String.fromCharCode(kr(e,n)));return a.join("")}function sr(e,t){var r=_r(e,t);return 0<r?pr(e,t+4,t+4+r-1):""}function ir(e,t){var r=_r(e,t);return 0<r?pr(e,t+4,t+4+r-1):""}function or(e,t){var r=2*_r(e,t);return 0<r?pr(e,t+4,t+4+r-1):""}function cr(e,t){var r=_r(e,t);return 0<r?ur(e,t+4,t+4+r):""}function lr(e,t){var r=_r(e,t);return 0<r?pr(e,t+4,t+4+r):""}function fr(e,t){for(var r=1-2*(e[t+7]>>>7),a=((127&e[t+7])<<4)+(e[t+6]>>>4&15),n=15&e[t+6],s=5;0<=s;--s)n=256*n+e[t+s];return 2047==a?0==n?1/0*r:NaN:(0==a?a=-1022:(a-=1023,n+=Math.pow(2,52)),r*Math.pow(2,a-52)*n)}var hr=se?function(e){return 0<e[0].length&&Buffer.isBuffer(e[0][0])?Buffer.concat(e[0].map(function(e){return Buffer.isBuffer(e)?e:ce(e)})):tr(e)}:tr,ur=se?function(e,t,r){return Buffer.isBuffer(e)?e.toString("utf16le",t,r).replace(de,""):rr(e,t,r)}:rr,dr=se?function(e,t,r){return Buffer.isBuffer(e)?e.toString("hex",t,t+r):ar(e,t,r)}:ar,pr=se?function(e,t,r){return Buffer.isBuffer(e)?e.toString("utf8",t,r):nr(e,t,r)}:nr,mr=sr,gr=ir,br=or,vr=cr,wr=lr,Tr=fr,Er=function(e){return Array.isArray(e)||"undefined"!=typeof Uint8Array&&e instanceof Uint8Array};se&&(mr=function(e,t){if(!Buffer.isBuffer(e))return sr(e,t);var r=e.readUInt32LE(t);return 0<r?e.toString("utf8",t+4,t+4+r-1):""},gr=function(e,t){if(!Buffer.isBuffer(e))return ir(e,t);var r=e.readUInt32LE(t);return 0<r?e.toString("utf8",t+4,t+4+r-1):""},br=function(e,t){if(!Buffer.isBuffer(e))return or(e,t);var r=2*e.readUInt32LE(t);return e.toString("utf16le",t+4,t+4+r-1)},vr=function(e,t){if(!Buffer.isBuffer(e))return cr(e,t);var r=e.readUInt32LE(t);return e.toString("utf16le",t+4,t+4+r)},wr=function(e,t){if(!Buffer.isBuffer(e))return lr(e,t);var r=e.readUInt32LE(t);return e.toString("utf8",t+4,t+4+r)},Tr=function(e,t){return Buffer.isBuffer(e)?e.readDoubleLE(t):fr(e,t)},Er=function(e){return Buffer.isBuffer(e)||Array.isArray(e)||"undefined"!=typeof Uint8Array&&e instanceof Uint8Array}),void 0!==re&&(ur=function(e,t,r){return re.utils.decode(1200,e.slice(t,r)).replace(de,"")},pr=function(e,t,r){return re.utils.decode(65001,e.slice(t,r))},mr=function(e,t){var r=_r(e,t);return 0<r?re.utils.decode(_,e.slice(t+4,t+4+r-1)):""},gr=function(e,t){var r=_r(e,t);return 0<r?re.utils.decode(f,e.slice(t+4,t+4+r-1)):""},br=function(e,t){var r=2*_r(e,t);return 0<r?re.utils.decode(1200,e.slice(t+4,t+4+r-1)):""},vr=function(e,t){var r=_r(e,t);return 0<r?re.utils.decode(1200,e.slice(t+4,t+4+r)):""},wr=function(e,t){var r=_r(e,t);return 0<r?re.utils.decode(65001,e.slice(t+4,t+4+r)):""});var kr=function(e,t){return e[t]},yr=function(e,t){return 256*e[t+1]+e[t]},Sr=function(e,t){t=256*e[t+1]+e[t];return t<32768?t:-1*(65535-t+1)},_r=function(e,t){return e[t+3]*(1<<24)+(e[t+2]<<16)+(e[t+1]<<8)+e[t]},xr=function(e,t){return e[t+3]<<24|e[t+2]<<16|e[t+1]<<8|e[t]},Ar=function(e,t){return e[t]<<24|e[t+1]<<16|e[t+2]<<8|e[t+3]};function Cr(e,t){var r,a,n,s,i,o,c="",l=[];switch(t){case"dbcs":if(o=this.l,se&&Buffer.isBuffer(this))c=this.slice(this.l,this.l+2*e).toString("utf16le");else for(i=0;i<e;++i)c+=String.fromCharCode(yr(this,o)),o+=2;e*=2;break;case"utf8":c=pr(this,this.l,this.l+e);break;case"utf16le":e*=2,c=ur(this,this.l,this.l+e);break;case"wstr":if(void 0===re)return Cr.call(this,e,"dbcs");c=re.utils.decode(f,this.slice(this.l,this.l+2*e)),e*=2;break;case"lpstr-ansi":c=mr(this,this.l),e=4+_r(this,this.l);break;case"lpstr-cp":c=gr(this,this.l),e=4+_r(this,this.l);break;case"lpwstr":c=br(this,this.l),e=4+2*_r(this,this.l);break;case"lpp4":e=4+_r(this,this.l),c=vr(this,this.l),2&e&&(e+=2);break;case"8lpp4":e=4+_r(this,this.l),c=wr(this,this.l),3&e&&(e+=4-(3&e));break;case"cstr":for(e=0,c="";0!==(n=kr(this,this.l+e++));)l.push(u(n));c=l.join("");break;case"_wstr":for(e=0,c="";0!==(n=yr(this,this.l+e));)l.push(u(n)),e+=2;e+=2,c=l.join("");break;case"dbcs-cont":for(c="",o=this.l,i=0;i<e;++i){if(this.lens&&-1!==this.lens.indexOf(o))return n=kr(this,o),this.l=o+1,s=Cr.call(this,e-i,n?"dbcs-cont":"sbcs-cont"),l.join("")+s;l.push(u(yr(this,o))),o+=2}c=l.join(""),e*=2;break;case"cpstr":if(void 0!==re){c=re.utils.decode(f,this.slice(this.l,this.l+e));break}case"sbcs-cont":for(c="",o=this.l,i=0;i!=e;++i){if(this.lens&&-1!==this.lens.indexOf(o))return n=kr(this,o),this.l=o+1,s=Cr.call(this,e-i,n?"dbcs-cont":"sbcs-cont"),l.join("")+s;l.push(u(kr(this,o))),o+=1}c=l.join("");break;default:switch(e){case 1:return r=kr(this,this.l),this.l++,r;case 2:return r=("i"===t?Sr:yr)(this,this.l),this.l+=2,r;case 4:case-4:return"i"===t||0==(128&this[this.l+3])?(r=(0<e?xr:Ar)(this,this.l),this.l+=4,r):(a=_r(this,this.l),this.l+=4,a);case 8:case-8:if("f"===t)return a=8==e?Tr(this,this.l):Tr([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]],0),this.l+=8,a;e=8;case 16:c=dr(this,this.l,e)}}return this.l+=e,c}var Rr=function(e,t,r){e[r]=255&t,e[r+1]=t>>>8&255,e[r+2]=t>>>16&255,e[r+3]=t>>>24&255},Or=function(e,t,r){e[r]=255&t,e[r+1]=t>>8&255,e[r+2]=t>>16&255,e[r+3]=t>>24&255},Ir=function(e,t,r){e[r]=255&t,e[r+1]=t>>>8&255};function Nr(e,t,r){var a=0,n=0;if("dbcs"===r){for(n=0;n!=t.length;++n)Ir(this,t.charCodeAt(n),this.l+2*n);a=2*t.length}else if("sbcs"===r){if(void 0!==re&&874==_)for(n=0;n!=t.length;++n){var s=re.utils.encode(_,t.charAt(n));this[this.l+n]=s[0]}else for(t=t.replace(/[^\x00-\x7F]/g,"_"),n=0;n!=t.length;++n)this[this.l+n]=255&t.charCodeAt(n);a=t.length}else{if("hex"===r){for(;n<e;++n)this[this.l++]=parseInt(t.slice(2*n,2*n+2),16)||0;return this}if("utf16le"===r){for(var i=Math.min(this.l+e,this.length),n=0;n<Math.min(t.length,e);++n){var o=t.charCodeAt(n);this[this.l++]=255&o,this[this.l++]=o>>8}for(;this.l<i;)this[this.l++]=0;return this}switch(e){case 1:a=1,this[this.l]=255&t;break;case 2:a=2,this[this.l]=255&t,t>>>=8,this[this.l+1]=255&t;break;case 3:a=3,this[this.l]=255&t,t>>>=8,this[this.l+1]=255&t,t>>>=8,this[this.l+2]=255&t;break;case 4:a=4,Rr(this,t,this.l);break;case 8:if(a=8,"f"===r){!function(e,t,r){var a=(t<0||1/t==-1/0?1:0)<<7,n=0,s=0,i=a?-t:t;isFinite(i)?0==i?n=s=0:(n=Math.floor(Math.log(i)/Math.LN2),s=i*Math.pow(2,52-n),n<=-1023&&(!isFinite(s)||s<Math.pow(2,52))?n=-1022:(s-=Math.pow(2,52),n+=1023)):(n=2047,s=isNaN(t)?26985:0);for(var o=0;o<=5;++o,s/=256)e[r+o]=255&s;e[r+6]=(15&n)<<4|15&s,e[r+7]=n>>4|a}(this,t,this.l);break}case 16:break;case-4:a=4,Or(this,t,this.l)}}return this.l+=a,this}function Fr(e,t){var r=dr(this,this.l,e.length>>1);if(r!==e)throw new Error(t+"Expected "+e+" saw "+r);this.l+=e.length>>1}function Dr(e,t){e.l=t,e.read_shift=Cr,e.chk=Fr,e.write_shift=Nr}function Pr(e,t){e.l+=t}function Lr(e){e=le(e);return Dr(e,0),e}function Mr(e,t,r){if(e){Dr(e,e.l||0);for(var a,n=e.length,s=0;e.l<n;){128&(s=e.read_shift(1))&&(s=(127&s)+((127&e.read_shift(1))<<7));for(var i,o=Df[s]||Df[65535],c=127&(i=e.read_shift(1)),l=1;l<4&&128&i;++l)c+=(127&(i=e.read_shift(1)))<<7*l;a=e.l+c;var f=o.f&&o.f(e,c,r);if(e.l=a,t(f,o,s))return}}}function Ur(){function t(e){return Dr(e=Lr(e),0),e}function r(){s&&(s.length>s.l&&((s=s.slice(0,s.l)).l=s.length),0<s.length&&e.push(s),s=null)}function a(e){return s&&e<s.length-s.l?s:(r(),s=t(Math.max(e+1,n)))}var e=[],n=se?256:2048,s=t(n);return{next:a,push:function(e){r(),null==(s=e).l&&(s.l=s.length),a(n)},end:function(){return r(),ue(e)},_bufs:e}}function Br(e,t,r,a){var n=+t;if(!isNaN(n)){t=1+(128<=n?1:0)+1,128<=(a=a||(Df[n].p||(r||[]).length||0))&&++t,16384<=a&&++t,2097152<=a&&++t;var s=e.next(t);n<=127?s.write_shift(1,n):(s.write_shift(1,128+(127&n)),s.write_shift(1,n>>7));for(var i=0;4!=i;++i){if(!(128<=a)){s.write_shift(1,a);break}s.write_shift(1,128+(127&a)),a>>=7}0<a&&Er(r)&&e.push(r)}}function Wr(e,t,r){var a=Ve(e);if(t.s?(a.cRel&&(a.c+=t.s.c),a.rRel&&(a.r+=t.s.r)):(a.cRel&&(a.c+=t.c),a.rRel&&(a.r+=t.r)),!r||r.biff<12){for(;256<=a.c;)a.c-=256;for(;65536<=a.r;)a.r-=65536}return a}function Hr(e,t,r){e=Ve(e);return e.s=Wr(e.s,t.s,r),e.e=Wr(e.e,t.s,r),e}function zr(e,t){if(e.cRel&&e.c<0)for(e=Ve(e);e.c<0;)e.c+=8<t?16384:256;if(e.rRel&&e.r<0)for(e=Ve(e);e.r<0;)e.r+=8<t?1048576:5<t?65536:16384;var r=Kr(e);return e.cRel||null==e.cRel||(r=r.replace(/^([A-Z])/,"$$$1")),r=!e.rRel&&null!=e.rRel?r.replace(/([A-Z]|^)(\d+)$/,"$1$$$2"):r}function Vr(e,t){return 0!=e.s.r||e.s.rRel||e.e.r!=(12<=t.biff?1048575:8<=t.biff?65536:16384)||e.e.rRel?0!=e.s.c||e.s.cRel||e.e.c!=(12<=t.biff?16383:255)||e.e.cRel?zr(e.s,t.biff)+":"+zr(e.e,t.biff):(e.s.rRel?"":"$")+jr(e.s.r)+":"+(e.e.rRel?"":"$")+jr(e.e.r):(e.s.cRel?"":"$")+Xr(e.s.c)+":"+(e.e.cRel?"":"$")+Xr(e.e.c)}function Gr(e){return parseInt(e.replace(/\$(\d+)$/,"$1"),10)-1}function jr(e){return""+(e+1)}function $r(e){for(var t=e.replace(/^\$([A-Z])/,"$1"),r=0,a=0;a!==t.length;++a)r=26*r+t.charCodeAt(a)-64;return r-1}function Xr(e){if(e<0)throw new Error("invalid column "+e);var t="";for(++e;e;e=Math.floor((e-1)/26))t=String.fromCharCode((e-1)%26+65)+t;return t}function Yr(e){for(var t=0,r=0,a=0;a<e.length;++a){var n=e.charCodeAt(a);48<=n&&n<=57?t=10*t+(n-48):65<=n&&n<=90&&(r=26*r+(n-64))}return{c:r-1,r:t-1}}function Kr(e){for(var t=e.c+1,r="";t;t=(t-1)/26|0)r=String.fromCharCode((t-1)%26+65)+r;return r+(e.r+1)}function Jr(e){var t=e.indexOf(":");return-1==t?{s:Yr(e),e:Yr(e)}:{s:Yr(e.slice(0,t)),e:Yr(e.slice(t+1))}}function qr(e,t){return void 0===t||"number"==typeof t?qr(e.s,e.e):(e="string"!=typeof e?Kr(e):e)==(t="string"!=typeof t?Kr(t):t)?e:e+":"+t}function Zr(e){for(var t={s:{c:0,r:0},e:{c:0,r:0}},r=0,a=0,n=0,s=e.length,r=0;a<s&&!((n=e.charCodeAt(a)-64)<1||26<n);++a)r=26*r+n;for(t.s.c=--r,r=0;a<s&&!((n=e.charCodeAt(a)-48)<0||9<n);++a)r=10*r+n;if(t.s.r=--r,a===s||10!=n)return t.e.c=t.s.c,t.e.r=t.s.r,t;for(++a,r=0;a!=s&&!((n=e.charCodeAt(a)-64)<1||26<n);++a)r=26*r+n;for(t.e.c=--r,r=0;a!=s&&!((n=e.charCodeAt(a)-48)<0||9<n);++a)r=10*r+n;return t.e.r=--r,t}function Qr(e,t){var r="d"==e.t&&t instanceof Date;if(null!=e.z)try{return e.w=ve(e.z,r?De(t):t)}catch(e){}try{return e.w=ve((e.XF||{}).numFmtId||(r?14:0),r?De(t):t)}catch(e){return""+t}}function ea(e,t,r){return null==e||null==e.t||"z"==e.t?"":void 0!==e.w?e.w:("d"==e.t&&!e.z&&r&&r.dateNF&&(e.z=r.dateNF),"e"==e.t?Wa[e.v]||e.v:Qr(e,null==t?e.v:t))}function ta(e,t){var r=t&&t.sheet?t.sheet:"Sheet1",t={};return t[r]=e,{SheetNames:[r],Sheets:t}}function ra(e,t,r){var a=r||{},n=e?Array.isArray(e):a.dense;null!=oe&&null==n&&(n=oe);var s=e||(n?[]:{}),i=0,o=0;s&&null!=a.origin&&("number"==typeof a.origin?i=a.origin:(i=(c="string"==typeof a.origin?Yr(a.origin):a.origin).r,o=c.c),s["!ref"]||(s["!ref"]="A1:A1"));var c,l={s:{c:1e7,r:1e7},e:{c:0,r:0}};s["!ref"]&&(c=Zr(s["!ref"]),l.s.c=c.s.c,l.s.r=c.s.r,l.e.c=Math.max(l.e.c,c.e.c),l.e.r=Math.max(l.e.r,c.e.r),-1==i&&(l.e.r=i=c.e.r+1));for(var f=0;f!=t.length;++f)if(t[f]){if(!Array.isArray(t[f]))throw new Error("aoa_to_sheet expects an array of arrays");for(var h=0;h!=t[f].length;++h)if(void 0!==t[f][h]){var u={v:t[f][h]},d=i+f,p=o+h;if(l.s.r>d&&(l.s.r=d),l.s.c>p&&(l.s.c=p),l.e.r<d&&(l.e.r=d),l.e.c<p&&(l.e.c=p),!t[f][h]||"object"!=typeof t[f][h]||Array.isArray(t[f][h])||t[f][h]instanceof Date)if(Array.isArray(u.v)&&(u.f=t[f][h][1],u.v=u.v[0]),null===u.v)if(u.f)u.t="n";else if(a.nullError)u.t="e",u.v=0;else{if(!a.sheetStubs)continue;u.t="z"}else"number"==typeof u.v?u.t="n":"boolean"==typeof u.v?u.t="b":u.v instanceof Date?(u.z=a.dateNF||me[14],a.cellDates?(u.t="d",u.w=ve(u.z,De(u.v))):(u.t="n",u.v=De(u.v),u.w=ve(u.z,u.v))):u.t="s";else u=t[f][h];n?(s[d]||(s[d]=[]),s[d][p]&&s[d][p].z&&(u.z=s[d][p].z),s[d][p]=u):(s[d=Kr({c:p,r:d})]&&s[d].z&&(u.z=s[d].z),s[d]=u)}}return l.s.c<1e7&&(s["!ref"]=qr(l)),s}function aa(e,t){return ra(null,e,t)}function na(e,t){return(t=t||Lr(4)).write_shift(4,e),t}function sa(e){var t=e.read_shift(4);return 0===t?"":e.read_shift(t,"dbcs")}function ia(e,t){var r=!1;return null==t&&(r=!0,t=Lr(4+2*e.length)),t.write_shift(4,e.length),0<e.length&&t.write_shift(0,e,"dbcs"),r?t.slice(0,t.l):t}function oa(e,t){var r,a=e.l,n=e.read_shift(1),s=sa(e),i=[],s={t:s,h:s};if(0!=(1&n)){for(var o=e.read_shift(4),c=0;c!=o;++c)i.push({ich:(r=e).read_shift(2),ifnt:r.read_shift(2)});s.r=i}else s.r=[{ich:0,ifnt:0}];return e.l=a+t,s}var ca=oa;function la(e,t){var r,a=!1;return null==t&&(a=!0,t=Lr(23+4*e.t.length)),t.write_shift(1,1),ia(e.t,t),t.write_shift(4,1),r={ich:0,ifnt:0},(e=(e=t)||Lr(4)).write_shift(2,r.ich||0),e.write_shift(2,r.ifnt||0),a?t.slice(0,t.l):t}function fa(e){var t=e.read_shift(4),r=e.read_shift(2);return r+=e.read_shift(1)<<16,e.l++,{c:t,iStyleRef:r}}function ha(e,t){return(t=null==t?Lr(8):t).write_shift(-4,e.c),t.write_shift(3,e.iStyleRef||e.s),t.write_shift(1,0),t}function ua(e){var t=e.read_shift(2);return t+=e.read_shift(1)<<16,e.l++,{c:-1,iStyleRef:t}}function da(e,t){return(t=null==t?Lr(4):t).write_shift(3,e.iStyleRef||e.s),t.write_shift(1,0),t}var pa=sa,ma=ia;function ga(e){var t=e.read_shift(4);return 0===t||4294967295===t?"":e.read_shift(t,"dbcs")}function ba(e,t){var r=!1;return null==t&&(r=!0,t=Lr(127)),t.write_shift(4,0<e.length?e.length:4294967295),0<e.length&&t.write_shift(0,e,"dbcs"),r?t.slice(0,t.l):t}var va=sa,wa=ga,Ta=ba;function Ea(e){var t=e.slice(e.l,e.l+4),r=1&t[0],a=2&t[0];e.l+=4;t=0==a?Tr([0,0,0,0,252&t[0],t[1],t[2],t[3]],0):xr(t,0)>>2;return r?t/100:t}function ka(e,t){null==t&&(t=Lr(4));var r=0,a=0,n=100*e;if(e==(0|e)&&-(1<<29)<=e&&e<1<<29?a=1:n==(0|n)&&-(1<<29)<=n&&n<1<<29&&(r=a=1),!a)throw new Error("unsupported RkNumber "+e);t.write_shift(-4,((r?n:e)<<2)+(r+2))}function ya(e){var t={s:{},e:{}};return t.s.r=e.read_shift(4),t.e.r=e.read_shift(4),t.s.c=e.read_shift(4),t.e.c=e.read_shift(4),t}var Sa=ya,_a=function(e,t){return(t=t||Lr(16)).write_shift(4,e.s.r),t.write_shift(4,e.e.r),t.write_shift(4,e.s.c),t.write_shift(4,e.e.c),t};function xa(e){if(e.length-e.l<8)throw"XLS Xnum Buffer underflow";return e.read_shift(8,"f")}function Aa(e,t){return(t||Lr(8)).write_shift(8,e,"f")}function Ca(e,t){if(t=t||Lr(8),!e||e.auto)return t.write_shift(4,0),t.write_shift(4,0),t;null!=e.index?(t.write_shift(1,2),t.write_shift(1,e.index)):null!=e.theme?(t.write_shift(1,6),t.write_shift(1,e.theme)):(t.write_shift(1,5),t.write_shift(1,0));var r=e.tint||0;return 0<r?r*=32767:r<0&&(r*=32768),t.write_shift(2,r),e.rgb&&null==e.theme?("number"==typeof(e=e.rgb||"FFFFFF")&&(e=("000000"+e.toString(16)).slice(-6)),t.write_shift(1,parseInt(e.slice(0,2),16)),t.write_shift(1,parseInt(e.slice(2,4),16)),t.write_shift(1,parseInt(e.slice(4,6),16)),t.write_shift(1,255)):(t.write_shift(2,0),t.write_shift(1,0),t.write_shift(1,0)),t}function Ra(e,t){var r=e.read_shift(4);switch(r){case 0:return"";case 4294967295:case 4294967294:return{2:"BITMAP",3:"METAFILEPICT",8:"DIB",14:"ENHMETAFILE"}[e.read_shift(4)]||""}if(400<r)throw new Error("Unsupported Clipboard: "+r.toString(16));return e.l-=4,e.read_shift(0,1==t?"lpstr":"lpwstr")}var Oa=2,Ia=3,Na=12,Fa=81,Da=[80,Fa],Pa={1:{n:"CodePage",t:Oa},2:{n:"Category",t:80},3:{n:"PresentationFormat",t:80},4:{n:"ByteCount",t:Ia},5:{n:"LineCount",t:Ia},6:{n:"ParagraphCount",t:Ia},7:{n:"SlideCount",t:Ia},8:{n:"NoteCount",t:Ia},9:{n:"HiddenCount",t:Ia},10:{n:"MultimediaClipCount",t:Ia},11:{n:"ScaleCrop",t:11},12:{n:"HeadingPairs",t:4108},13:{n:"TitlesOfParts",t:4126},14:{n:"Manager",t:80},15:{n:"Company",t:80},16:{n:"LinksUpToDate",t:11},17:{n:"CharacterCount",t:Ia},19:{n:"SharedDoc",t:11},22:{n:"HyperlinksChanged",t:11},23:{n:"AppVersion",t:Ia,p:"version"},24:{n:"DigSig",t:65},26:{n:"ContentType",t:80},27:{n:"ContentStatus",t:80},28:{n:"Language",t:80},29:{n:"Version",t:80},255:{},2147483648:{n:"Locale",t:19},2147483651:{n:"Behavior",t:19},1919054434:{}},La={1:{n:"CodePage",t:Oa},2:{n:"Title",t:80},3:{n:"Subject",t:80},4:{n:"Author",t:80},5:{n:"Keywords",t:80},6:{n:"Comments",t:80},7:{n:"Template",t:80},8:{n:"LastAuthor",t:80},9:{n:"RevNumber",t:80},10:{n:"EditTime",t:64},11:{n:"LastPrinted",t:64},12:{n:"CreatedDate",t:64},13:{n:"ModifiedDate",t:64},14:{n:"PageCount",t:Ia},15:{n:"WordCount",t:Ia},16:{n:"CharCount",t:Ia},17:{n:"Thumbnail",t:71},18:{n:"Application",t:80},19:{n:"DocSecurity",t:Ia},255:{},2147483648:{n:"Locale",t:19},2147483651:{n:"Behavior",t:19},1919054434:{}},Ma={1:"US",2:"CA",3:"",7:"RU",20:"EG",30:"GR",31:"NL",32:"BE",33:"FR",34:"ES",36:"HU",39:"IT",41:"CH",43:"AT",44:"GB",45:"DK",46:"SE",47:"NO",48:"PL",49:"DE",52:"MX",55:"BR",61:"AU",64:"NZ",66:"TH",81:"JP",82:"KR",84:"VN",86:"CN",90:"TR",105:"JS",213:"DZ",216:"MA",218:"LY",351:"PT",354:"IS",358:"FI",420:"CZ",886:"TW",961:"LB",962:"JO",963:"SY",964:"IQ",965:"KW",966:"SA",971:"AE",972:"IL",974:"QA",981:"IR",65535:"US"},Ua=[null,"solid","mediumGray","darkGray","lightGray","darkHorizontal","darkVertical","darkDown","darkUp","darkGrid","darkTrellis","lightHorizontal","lightVertical","lightDown","lightUp","lightGrid","lightTrellis","gray125","gray0625"];var Ba=Ve([0,16777215,16711680,65280,255,16776960,16711935,65535,0,16777215,16711680,65280,255,16776960,16711935,65535,8388608,32768,128,8421376,8388736,32896,12632256,8421504,10066431,10040166,16777164,13434879,6684774,16744576,26316,13421823,128,16711935,16776960,65535,8388736,8388608,32896,255,52479,13434879,13434828,16777113,10079487,16751052,13408767,16764057,3368703,3394764,10079232,16763904,16750848,16737792,6710937,9868950,13158,3381606,13056,3355392,10040064,10040166,3355545,3355443,16777215,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0].map(function(e){return[e>>16&255,e>>8&255,255&e]})),Wa={0:"#NULL!",7:"#DIV/0!",15:"#VALUE!",23:"#REF!",29:"#NAME?",36:"#NUM!",42:"#N/A",43:"#GETTING_DATA",255:"#WTF?"},Ha={"#NULL!":0,"#DIV/0!":7,"#VALUE!":15,"#REF!":23,"#NAME?":29,"#NUM!":36,"#N/A":42,"#GETTING_DATA":43,"#WTF?":255},za={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":"workbooks","application/vnd.ms-excel.sheet.macroEnabled.main+xml":"workbooks","application/vnd.ms-excel.sheet.binary.macroEnabled.main":"workbooks","application/vnd.ms-excel.addin.macroEnabled.main+xml":"workbooks","application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":"workbooks","application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":"sheets","application/vnd.ms-excel.worksheet":"sheets","application/vnd.ms-excel.binIndexWs":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":"charts","application/vnd.ms-excel.chartsheet":"charts","application/vnd.ms-excel.macrosheet+xml":"macros","application/vnd.ms-excel.macrosheet":"macros","application/vnd.ms-excel.intlmacrosheet":"TODO","application/vnd.ms-excel.binIndexMs":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":"dialogs","application/vnd.ms-excel.dialogsheet":"dialogs","application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml":"strs","application/vnd.ms-excel.sharedStrings":"strs","application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":"styles","application/vnd.ms-excel.styles":"styles","application/vnd.openxmlformats-package.core-properties+xml":"coreprops","application/vnd.openxmlformats-officedocument.custom-properties+xml":"custprops","application/vnd.openxmlformats-officedocument.extended-properties+xml":"extprops","application/vnd.openxmlformats-officedocument.customXmlProperties+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":"comments","application/vnd.ms-excel.comments":"comments","application/vnd.ms-excel.threadedcomments+xml":"threadedcomments","application/vnd.ms-excel.person+xml":"people","application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml":"metadata","application/vnd.ms-excel.sheetMetadata":"metadata","application/vnd.ms-excel.pivotTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.chart+xml":"TODO","application/vnd.ms-office.chartcolorstyle+xml":"TODO","application/vnd.ms-office.chartstyle+xml":"TODO","application/vnd.ms-office.chartex+xml":"TODO","application/vnd.ms-excel.calcChain":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings":"TODO","application/vnd.ms-office.activeX":"TODO","application/vnd.ms-office.activeX+xml":"TODO","application/vnd.ms-excel.attachedToolbars":"TODO","application/vnd.ms-excel.connections":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":"TODO","application/vnd.ms-excel.externalLink":"links","application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml":"links","application/vnd.ms-excel.pivotCacheDefinition":"TODO","application/vnd.ms-excel.pivotCacheRecords":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml":"TODO","application/vnd.ms-excel.queryTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml":"TODO","application/vnd.ms-excel.userNames":"TODO","application/vnd.ms-excel.revisionHeaders":"TODO","application/vnd.ms-excel.revisionLog":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml":"TODO","application/vnd.ms-excel.tableSingleCells":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml":"TODO","application/vnd.ms-excel.slicer":"TODO","application/vnd.ms-excel.slicerCache":"TODO","application/vnd.ms-excel.slicer+xml":"TODO","application/vnd.ms-excel.slicerCache+xml":"TODO","application/vnd.ms-excel.wsSortMap":"TODO","application/vnd.ms-excel.table":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":"TODO","application/vnd.openxmlformats-officedocument.theme+xml":"themes","application/vnd.openxmlformats-officedocument.themeOverride+xml":"TODO","application/vnd.ms-excel.Timeline+xml":"TODO","application/vnd.ms-excel.TimelineCache+xml":"TODO","application/vnd.ms-office.vbaProject":"vba","application/vnd.ms-office.vbaProjectSignature":"TODO","application/vnd.ms-office.volatileDependencies":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml":"TODO","application/vnd.ms-excel.controlproperties+xml":"TODO","application/vnd.openxmlformats-officedocument.model+data":"TODO","application/vnd.ms-excel.Survey+xml":"TODO","application/vnd.openxmlformats-officedocument.drawing+xml":"drawings","application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml":"TODO","application/vnd.openxmlformats-officedocument.vmlDrawing":"TODO","application/vnd.openxmlformats-package.relationships+xml":"rels","application/vnd.openxmlformats-officedocument.oleObject":"TODO","image/png":"TODO",sheet:"js"},Va={workbooks:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",xlsm:"application/vnd.ms-excel.sheet.macroEnabled.main+xml",xlsb:"application/vnd.ms-excel.sheet.binary.macroEnabled.main",xlam:"application/vnd.ms-excel.addin.macroEnabled.main+xml",xltx:"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"},strs:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",xlsb:"application/vnd.ms-excel.sharedStrings"},comments:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",xlsb:"application/vnd.ms-excel.comments"},sheets:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",xlsb:"application/vnd.ms-excel.worksheet"},charts:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",xlsb:"application/vnd.ms-excel.chartsheet"},dialogs:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",xlsb:"application/vnd.ms-excel.dialogsheet"},macros:{xlsx:"application/vnd.ms-excel.macrosheet+xml",xlsb:"application/vnd.ms-excel.macrosheet"},metadata:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",xlsb:"application/vnd.ms-excel.sheetMetadata"},styles:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",xlsb:"application/vnd.ms-excel.styles"}};function Ga(){return{workbooks:[],sheets:[],charts:[],dialogs:[],macros:[],rels:[],strs:[],comments:[],threadedcomments:[],links:[],coreprops:[],extprops:[],custprops:[],themes:[],styles:[],calcchains:[],vba:[],drawings:[],metadata:[],people:[],TODO:[],xmlns:""}}function ja(r,a){var t,n=function(e){for(var t=[],r=Re(e),a=0;a!==r.length;++a)null==t[e[r[a]]]&&(t[e[r[a]]]=[]),t[e[r[a]]].push(r[a]);return t}(za),s=[];s[s.length]=ot,s[s.length]=Yt("Types",null,{xmlns:Zt.CT,"xmlns:xsd":Zt.xsd,"xmlns:xsi":Zt.xsi}),s=s.concat([["xml","application/xml"],["bin","application/vnd.ms-excel.sheet.binary.macroEnabled.main"],["vml","application/vnd.openxmlformats-officedocument.vmlDrawing"],["data","application/vnd.openxmlformats-officedocument.model+data"],["bmp","image/bmp"],["png","image/png"],["gif","image/gif"],["emf","image/x-emf"],["wmf","image/x-wmf"],["jpg","image/jpeg"],["jpeg","image/jpeg"],["tif","image/tiff"],["tiff","image/tiff"],["pdf","application/pdf"],["rels","application/vnd.openxmlformats-package.relationships+xml"]].map(function(e){return Yt("Default",null,{Extension:e[0],ContentType:e[1]})}));function e(e){r[e]&&0<r[e].length&&(t=r[e][0],s[s.length]=Yt("Override",null,{PartName:("/"==t[0]?"":"/")+t,ContentType:Va[e][a.bookType]||Va[e].xlsx}))}function i(t){(r[t]||[]).forEach(function(e){s[s.length]=Yt("Override",null,{PartName:("/"==e[0]?"":"/")+e,ContentType:Va[t][a.bookType]||Va[t].xlsx})})}function o(t){(r[t]||[]).forEach(function(e){s[s.length]=Yt("Override",null,{PartName:("/"==e[0]?"":"/")+e,ContentType:n[t][0]})})}return e("workbooks"),i("sheets"),i("charts"),o("themes"),["strs","styles"].forEach(e),["coreprops","extprops","custprops"].forEach(o),o("vba"),o("comments"),o("threadedcomments"),o("drawings"),i("metadata"),o("people"),2<s.length&&(s[s.length]="</Types>",s[1]=s[1].replace("/>",">")),s.join("")}var $a={WB:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",SHEET:"http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",HLINK:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",VML:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",XPATH:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",XMISS:"http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",XLINK:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",CXML:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",CXMLP:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",CMNT:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",CORE_PROPS:"http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",EXT_PROPS:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",CUST_PROPS:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties",SST:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",STY:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",THEME:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",CHART:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",CHARTEX:"http://schemas.microsoft.com/office/2014/relationships/chartEx",CS:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",WS:["http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet","http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"],DS:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",MS:"http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",IMG:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",DRAW:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",XLMETA:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",TCMNT:"http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",PEOPLE:"http://schemas.microsoft.com/office/2017/10/relationships/person",VBA:"http://schemas.microsoft.com/office/2006/relationships/vbaProject"};function Xa(e){var t=e.lastIndexOf("/");return e.slice(0,t+1)+"_rels/"+e.slice(t+1)+".rels"}function Ya(e,a){var n={"!id":{}};if(!e)return n;"/"!==a.charAt(0)&&(a="/"+a);var s={};return(e.match(ft)||[]).forEach(function(e){var t,r=dt(e);"<Relationship"===r[0]&&((t={}).Type=r.Type,t.Target=r.Target,t.Id=r.Id,r.TargetMode&&(t.TargetMode=r.TargetMode),e="External"===r.TargetMode?r.Target:it(r.Target,a),n[e]=t,s[r.Id]=t)}),n["!id"]=s,n}function Ka(t){var r=[ot,Yt("Relationships",null,{xmlns:Zt.RELS})];return Re(t["!id"]).forEach(function(e){r[r.length]=Yt("Relationship",null,t["!id"][e])}),2<r.length&&(r[r.length]="</Relationships>",r[1]=r[1].replace("/>",">")),r.join("")}function Ja(e,t,r,a,n,s){if(n=n||{},e["!id"]||(e["!id"]={}),e["!idx"]||(e["!idx"]=1),t<0)for(t=e["!idx"];e["!id"]["rId"+t];++t);if(e["!idx"]=t+1,n.Id="rId"+t,n.Type=a,n.Target=r,s?n.TargetMode=s:-1<[$a.HLINK,$a.XPATH,$a.XMISS].indexOf(n.Type)&&(n.TargetMode="External"),e["!id"][n.Id])throw new Error("Cannot rewrite rId "+t);return e["!id"][n.Id]=n,e[("/"+n.Target).replace("//","/")]=n,t}var qa="application/vnd.oasis.opendocument.spreadsheet";function Za(e,t,r){return['  <rdf:Description rdf:about="'+e+'">\n','    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/'+(r||"odf")+"#"+t+'"/>\n',"  </rdf:Description>\n"].join("")}function Qa(){return'<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS '+a.version+"</meta:generator></office:meta></office:document-meta>"}var en=[["cp:category","Category"],["cp:contentStatus","ContentStatus"],["cp:keywords","Keywords"],["cp:lastModifiedBy","LastAuthor"],["cp:lastPrinted","LastPrinted"],["cp:revision","RevNumber"],["cp:version","Version"],["dc:creator","Author"],["dc:description","Comments"],["dc:identifier","Identifier"],["dc:language","Language"],["dc:subject","Subject"],["dc:title","Title"],["dcterms:created","CreatedDate","date"],["dcterms:modified","ModifiedDate","date"]],tn=function(){for(var e=new Array(en.length),t=0;t<en.length;++t){var r=en[t],r="(?:"+r[0].slice(0,r[0].indexOf(":"))+":)"+r[0].slice(r[0].indexOf(":")+1);e[t]=new RegExp("<"+r+"[^>]*>([\\s\\S]*?)</"+r+">")}return e}();function rn(e){var t={};e=Mt(e);for(var r=0;r<en.length;++r){var a=en[r],n=e.match(tn[r]);null!=n&&0<n.length&&(t[a[1]]=wt(n[1])),"date"===a[2]&&t[a[1]]&&(t[a[1]]=He(t[a[1]]))}return t}function an(e,t,r,a,n){null==n[e]&&null!=t&&""!==t&&(t=kt(n[e]=t),a[a.length]=r?Yt(e,t,r):$t(e,t))}function nn(e,t){var r=t||{},a=[ot,Yt("cp:coreProperties",null,{"xmlns:cp":Zt.CORE_PROPS,"xmlns:dc":Zt.dc,"xmlns:dcterms":Zt.dcterms,"xmlns:dcmitype":Zt.dcmitype,"xmlns:xsi":Zt.xsi})],n={};if(!e&&!r.Props)return a.join("");e&&(null!=e.CreatedDate&&an("dcterms:created","string"==typeof e.CreatedDate?e.CreatedDate:Kt(e.CreatedDate,r.WTF),{"xsi:type":"dcterms:W3CDTF"},a,n),null!=e.ModifiedDate&&an("dcterms:modified","string"==typeof e.ModifiedDate?e.ModifiedDate:Kt(e.ModifiedDate,r.WTF),{"xsi:type":"dcterms:W3CDTF"},a,n));for(var s=0;s!=en.length;++s){var i=en[s],o=r.Props&&null!=r.Props[i[1]]?r.Props[i[1]]:e?e[i[1]]:null;!0===o?o="1":!1===o?o="0":"number"==typeof o&&(o=String(o)),null!=o&&an(i[0],o,null,a,n)}return 2<a.length&&(a[a.length]="</cp:coreProperties>",a[1]=a[1].replace("/>",">")),a.join("")}var sn=[["Application","Application","string"],["AppVersion","AppVersion","string"],["Company","Company","string"],["DocSecurity","DocSecurity","string"],["Manager","Manager","string"],["HyperlinksChanged","HyperlinksChanged","bool"],["SharedDoc","SharedDoc","bool"],["LinksUpToDate","LinksUpToDate","bool"],["ScaleCrop","ScaleCrop","bool"],["HeadingPairs","HeadingPairs","raw"],["TitlesOfParts","TitlesOfParts","raw"]],on=["Worksheets","SheetNames","NamedRanges","DefinedNames","Chartsheets","ChartNames"];function cn(e,t,r,a){var n=[];if("string"==typeof e)n=Gt(e,a);else for(var s=0;s<e.length;++s)n=n.concat(e[s].map(function(e){return{v:e}}));var i,o="string"==typeof t?Gt(t,a).map(function(e){return e.v}):t,c=0;if(0<o.length)for(var l=0;l!==n.length;l+=2){switch(i=+n[l+1].v,n[l].v){case"Worksheets":case"工作表":case"Листы":case"أوراق العمل":case"ワークシート":case"גליונות עבודה":case"Arbeitsblätter":case"Çalışma Sayfaları":case"Feuilles de calcul":case"Fogli di lavoro":case"Folhas de cálculo":case"Planilhas":case"Regneark":case"Hojas de cálculo":case"Werkbladen":r.Worksheets=i,r.SheetNames=o.slice(c,c+i);break;case"Named Ranges":case"Rangos con nombre":case"名前付き一覧":case"Benannte Bereiche":case"Navngivne områder":r.NamedRanges=i,r.DefinedNames=o.slice(c,c+i);break;case"Charts":case"Diagramme":r.Chartsheets=i,r.ChartNames=o.slice(c,c+i)}c+=i}}function ln(r){var a=[],n=Yt;return(r=r||{}).Application="SheetJS",a[a.length]=ot,a[a.length]=Yt("Properties",null,{xmlns:Zt.EXT_PROPS,"xmlns:vt":Zt.vt}),sn.forEach(function(e){if(void 0!==r[e[1]]){var t;switch(e[2]){case"string":t=kt(String(r[e[1]]));break;case"bool":t=r[e[1]]?"true":"false"}void 0!==t&&(a[a.length]=n(e[0],t))}}),a[a.length]=n("HeadingPairs",n("vt:vector",n("vt:variant","<vt:lpstr>Worksheets</vt:lpstr>")+n("vt:variant",n("vt:i4",String(r.Worksheets))),{size:2,baseType:"variant"})),a[a.length]=n("TitlesOfParts",n("vt:vector",r.SheetNames.map(function(e){return"<vt:lpstr>"+kt(e)+"</vt:lpstr>"}).join(""),{size:r.Worksheets,baseType:"lpstr"})),2<a.length&&(a[a.length]="</Properties>",a[1]=a[1].replace("/>",">")),a.join("")}var fn=/<[^>]+>[^<]*/g;function hn(t){var r=[ot,Yt("Properties",null,{xmlns:Zt.CUST_PROPS,"xmlns:vt":Zt.vt})];if(!t)return r.join("");var a=1;return Re(t).forEach(function(e){++a,r[r.length]=Yt("property",function(e,t){switch(typeof e){case"string":var r=Yt("vt:lpwstr",kt(e));return r=t?r.replace(/&quot;/g,"_x0022_"):r;case"number":return Yt((0|e)==e?"vt:i4":"vt:r8",kt(String(e)));case"boolean":return Yt("vt:bool",e?"true":"false")}if(e instanceof Date)return Yt("vt:filetime",Kt(e));throw new Error("Unable to serialize "+e)}(t[e],!0),{fmtid:"{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",pid:a,name:kt(e)})}),2<r.length&&(r[r.length]="</Properties>",r[1]=r[1].replace("/>",">")),r.join("")}var un,dn={Title:"Title",Subject:"Subject",Author:"Author",Keywords:"Keywords",Comments:"Description",LastAuthor:"LastAuthor",RevNumber:"Revision",Application:"AppName",LastPrinted:"LastPrinted",CreatedDate:"Created",ModifiedDate:"LastSaved",Category:"Category",Manager:"Manager",Company:"Company",AppVersion:"Version",ContentStatus:"ContentStatus",Identifier:"Identifier",Language:"Language"};function pn(e){var t=e.read_shift(4),e=e.read_shift(4);return new Date(1e3*(e/1e7*Math.pow(2,32)+t/1e7-11644473600)).toISOString().replace(/\.000/,"")}function mn(e,t,r){var a=e.l,n=e.read_shift(0,"lpstr-cp");if(r)for(;e.l-a&3;)++e.l;return n}function gn(e,t,r){var a=e.read_shift(0,"lpwstr");return r&&(e.l+=4-(a.length+1&3)&3),a}function bn(e,t,r){return 31===t?gn(e):mn(e,0,r)}function vn(e,t,r){return bn(e,t,!1===r?0:4)}function wn(e){for(var t,r,a,n=e.read_shift(4),s=[],i=0;i<n/2;++i)s.push((a=r=void 0,r=(t=e).l,a=kn(t,Fa),0==t[t.l]&&0==t[t.l+1]&&t.l-r&2&&(t.l+=2),[a,kn(t,Ia)]));return s}function Tn(e,t){for(var r=e.read_shift(4),a={},n=0;n!=r;++n){var s=e.read_shift(4),i=e.read_shift(4);a[s]=e.read_shift(i,1200===t?"utf16le":"utf8").replace(de,"").replace(pe,"!"),1200===t&&i%2&&(e.l+=2)}return 3&e.l&&(e.l=e.l>>3<<2),a}function En(e){var t=e.read_shift(4),r=e.slice(e.l,e.l+t);return e.l+=t,0<(3&t)&&(e.l+=4-(3&t)&3),r}function kn(e,t,r){var a,n,s=e.read_shift(2),i=r||{};if(e.l+=2,t!==Na&&s!==t&&-1===Da.indexOf(t)&&(4126!=(65534&t)||4126!=(65534&s)))throw new Error("Expected type "+t+" saw "+s);switch(t===Na?s:t){case 2:return a=e.read_shift(2,"i"),i.raw||(e.l+=2),a;case 3:return a=e.read_shift(4,"i");case 11:return 0!==e.read_shift(4);case 19:return a=e.read_shift(4);case 30:return mn(e,0,4).replace(de,"");case 31:return gn(e);case 64:return pn(e);case 65:return En(e);case 71:return(n={}).Size=(a=e).read_shift(4),a.l+=n.Size+3-(n.Size-1)%4,n;case 80:return vn(e,s,!i.raw).replace(de,"");case 81:return function(e,t){if(!t)throw new Error("VtUnalignedString must have positive length");return bn(e,t,0)}(e,s).replace(de,"");case 4108:return wn(e);case 4126:case 4127:return(4127==s?function(e){for(var t=e.read_shift(4),r=[],a=0;a!=t;++a){var n=e.l;r[a]=e.read_shift(0,"lpwstr").replace(de,""),e.l-n&2&&(e.l+=2)}return r}:function(e){for(var t=e.read_shift(4),r=[],a=0;a!=t;++a)r[a]=e.read_shift(0,"lpstr-cp").replace(de,"");return r})(e);default:throw new Error("TypedPropertyValue unrecognized type "+t+" "+s)}}function yn(e,t){var r,a,n,s=Lr(4),i=Lr(4);switch(s.write_shift(4,80==e?31:e),e){case 3:i.write_shift(-4,t);break;case 5:(i=Lr(8)).write_shift(8,t,"f");break;case 11:i.write_shift(4,t?1:0);break;case 64:a=("string"==typeof(r=t)?new Date(Date.parse(r)):r).getTime()/1e3+11644473600,n=a%Math.pow(2,32),r=(a-n)/Math.pow(2,32),r*=1e7,0<(a=(n*=1e7)/Math.pow(2,32)|0)&&(n%=Math.pow(2,32),r+=a),(a=Lr(8)).write_shift(4,n),a.write_shift(4,r),i=a;break;case 31:case 80:for((i=Lr(4+2*(t.length+1)+(t.length%2?0:2))).write_shift(4,t.length+1),i.write_shift(0,t,"dbcs");i.l!=i.length;)i.write_shift(1,0);break;default:throw new Error("TypedPropertyValue unrecognized type "+e+" "+t)}return ue([s,i])}function Sn(e,t){for(var r=e.l,a=e.read_shift(4),n=e.read_shift(4),s=[],i=0,o=0,c=-1,l={},i=0;i!=n;++i){var f=e.read_shift(4),h=e.read_shift(4);s[i]=[f,h+r]}s.sort(function(e,t){return e[1]-t[1]});var u={};for(i=0;i!=n;++i){if(e.l!==s[i][1]){var d=!0;if(0<i&&t)switch(t[s[i-1][0]].t){case 2:e.l+2===s[i][1]&&(e.l+=2,d=!1);break;case 80:case 4108:e.l<=s[i][1]&&(e.l=s[i][1],d=!1)}if((!t||0==i)&&e.l<=s[i][1]&&(d=!1,e.l=s[i][1]),d)throw new Error("Read Error: Expected address "+s[i][1]+" at "+e.l+" :"+i)}if(t){var p=t[s[i][0]];if(u[p.n]=kn(e,p.t,{raw:!0}),"version"===p.p&&(u[p.n]=String(u[p.n]>>16)+"."+("0000"+String(65535&u[p.n])).slice(-4)),"CodePage"==p.n)switch(u[p.n]){case 0:u[p.n]=1252;case 874:case 932:case 936:case 949:case 950:case 1250:case 1251:case 1253:case 1254:case 1255:case 1256:case 1257:case 1258:case 1e4:case 1200:case 1201:case 1252:case 65e3:case-536:case 65001:case-535:ie(o=u[p.n]>>>0&65535);break;default:throw new Error("Unsupported CodePage: "+u[p.n])}}else if(1===s[i][0]){o=u.CodePage=kn(e,Oa);ie(o),-1!==c&&(g=e.l,e.l=s[c][1],l=Tn(e,o),e.l=g)}else if(0===s[i][0])0!==o?l=Tn(e,o):(c=i,e.l=s[i+1][1]);else{var m,g=l[s[i][0]];switch(e[e.l]){case 65:e.l+=4,m=En(e);break;case 30:case 31:e.l+=4,m=vn(e,e[e.l-4]).replace(/\u0000+$/,"");break;case 3:e.l+=4,m=e.read_shift(4,"i");break;case 19:e.l+=4,m=e.read_shift(4);break;case 5:e.l+=4,m=e.read_shift(8,"f");break;case 11:e.l+=4,m=On(e,4);break;case 64:e.l+=4,m=He(pn(e));break;default:throw new Error("unparsed value: "+e[e.l])}u[g]=m}}return e.l=r+a,u}var _n=["CodePage","Thumbnail","_PID_LINKBASE","_PID_HLINKS","SystemIdentifier","FMTID"];function xn(e,t,r){var a,n,s,i,o=Lr(8),c=[],l=[],f=8,h=0,u=Lr(8),d=Lr(8);if(u.write_shift(4,2),u.write_shift(4,1200),d.write_shift(4,1),l.push(u),c.push(d),f+=8+u.length,!t){(d=Lr(8)).write_shift(4,0),c.unshift(d);var p=[Lr(4)];for(p[0].write_shift(4,e.length),h=0;h<e.length;++h){var m=e[h][0];for((u=Lr(8+2*(m.length+1)+(m.length%2?0:2))).write_shift(4,h+2),u.write_shift(4,m.length+1),u.write_shift(0,m,"dbcs");u.l!=u.length;)u.write_shift(1,0);p.push(u)}u=ue(p),l.unshift(u),f+=8+u.length}for(h=0;h<e.length;++h)t&&!t[e[h][0]]||-1<_n.indexOf(e[h][0])||-1<on.indexOf(e[h][0])||null!=e[h][1]&&(s=e[h][1],a=0,u=t?("version"==(i=r[a=+t[e[h][0]]]).p&&"string"==typeof s&&(s=(+(n=s.split("."))[0]<<16)+(+n[1]||0)),yn(i.t,s)):(-1==(i=function(e){switch(typeof e){case"boolean":return 11;case"number":return(0|e)==e?3:5;case"string":return 31;case"object":if(e instanceof Date)return 64}return-1}(s))&&(i=31,s=String(s)),yn(i,s)),l.push(u),(d=Lr(8)).write_shift(4,t?a:2+h),c.push(d),f+=8+u.length);for(var g=8*(l.length+1),h=0;h<l.length;++h)c[h].write_shift(4,g),g+=l[h].length;return o.write_shift(4,f),o.write_shift(4,l.length),ue([o].concat(c).concat(l))}function An(e,t,r){var a=e.content;if(!a)return{};Dr(a,0);var n,s=0;a.chk("feff","Byte Order: "),a.read_shift(2);var i=a.read_shift(4),o=a.read_shift(16);if(o!==xe.utils.consts.HEADER_CLSID&&o!==r)throw new Error("Bad PropertySet CLSID "+o);if(1!==(e=a.read_shift(4))&&2!==e)throw new Error("Unrecognized #Sets: "+e);if(r=a.read_shift(16),o=a.read_shift(4),1===e&&o!==a.l)throw new Error("Length mismatch: "+o+" !== "+a.l);2===e&&(n=a.read_shift(16),s=a.read_shift(4));var c,l,f=Sn(a,t),h={SystemIdentifier:i};for(c in f)h[c]=f[c];if(h.FMTID=r,1===e)return h;if(s-a.l==2&&(a.l+=2),a.l!==s)throw new Error("Length mismatch 2: "+a.l+" !== "+s);try{l=Sn(a,null)}catch(e){}for(c in l)h[c]=l[c];return h.FMTID=[r,n],h}function Cn(e,t,r,a,n,s){var i=Lr(n?68:48),o=[i];i.write_shift(2,65534),i.write_shift(2,0),i.write_shift(4,842412599),i.write_shift(16,xe.utils.consts.HEADER_CLSID,"hex"),i.write_shift(4,n?2:1),i.write_shift(16,t,"hex"),i.write_shift(4,n?68:48);a=xn(e,r,a);return o.push(a),n&&(n=xn(n,null,null),i.write_shift(16,s,"hex"),i.write_shift(4,68+a.length),o.push(n)),ue(o)}function Rn(e,t){return e.read_shift(t),null}function On(e,t){return 1===e.read_shift(t)}function In(e,t){return(t=t||Lr(2)).write_shift(2,+!!e),t}function Nn(e){return e.read_shift(2,"u")}function Fn(e,t){return(t=t||Lr(2)).write_shift(2,e),t}function Dn(e,t){return function(e,t,r){for(var a=[],n=e.l+t;e.l<n;)a.push(r(e,n-e.l));if(n!==e.l)throw new Error("Slurp error");return a}(e,t,Nn)}function Pn(e,t,r){return(r=r||Lr(2)).write_shift(1,"e"==t?+e:+!!e),r.write_shift(1,"e"==t?1:0),r}function Ln(e,t,r){var a=e.read_shift(r&&12<=r.biff?2:1),n="sbcs-cont",s=f;r&&8<=r.biff&&(f=1200),r&&8!=r.biff?12==r.biff&&(n="wstr"):e.read_shift(1)&&(n="dbcs-cont"),2<=r.biff&&r.biff<=5&&(n="cpstr");n=a?e.read_shift(a,n):"";return f=s,n}function Mn(e,t,r){if(r){if(2<=r.biff&&r.biff<=5)return e.read_shift(t,"cpstr");if(12<=r.biff)return e.read_shift(t,"dbcs-cont")}return 0===e.read_shift(1)?e.read_shift(t,"sbcs-cont"):e.read_shift(t,"dbcs-cont")}function Un(e,t,r){var a=e.read_shift(r&&2==r.biff?1:2);return 0===a?(e.l++,""):Mn(e,a,r)}function Bn(e,t,r){if(5<r.biff)return Un(e,0,r);var a=e.read_shift(1);return 0===a?(e.l++,""):e.read_shift(a,r.biff<=4||!e.lens?"cpstr":"sbcs-cont")}function Wn(e,t,r){return(r=r||Lr(3+2*e.length)).write_shift(2,e.length),r.write_shift(1,1),r.write_shift(31,e,"utf16le"),r}function Hn(e){var t,r,a,n,s=e.read_shift(16);switch(s){case"e0c9ea79f9bace118c8200aa004ba90b":return r=(t=e).read_shift(4),a=t.l,n=!1,24<r&&(t.l+=r-24,"795881f43b1d7f48af2c825dc4852763"===t.read_shift(16)&&(n=!0),t.l=a),r=t.read_shift((n?r-24:r)>>1,"utf16le").replace(de,""),n&&(t.l+=24),r;case"0303000000000000c000000000000046":return function(e){for(var t=e.read_shift(2),r="";0<t--;)r+="../";var a=e.read_shift(0,"lpstr-ansi");if(e.l+=2,57005!=e.read_shift(2))throw new Error("Bad FileMoniker");if(0===e.read_shift(4))return r+a.replace(/\\/g,"/");if(a=e.read_shift(4),3!=e.read_shift(2))throw new Error("Bad FileMoniker");return r+e.read_shift(a>>1,"utf16le").replace(de,"")}(e);default:throw new Error("Unsupported Moniker "+s)}}function zn(e){var t=e.read_shift(4);return 0<t?e.read_shift(t,"utf16le").replace(de,""):""}function Vn(e,t){(t=t||Lr(6+2*e.length)).write_shift(4,1+e.length);for(var r=0;r<e.length;++r)t.write_shift(2,e.charCodeAt(r));return t.write_shift(2,0),t}function Gn(e){return[e.read_shift(1),e.read_shift(1),e.read_shift(1),e.read_shift(1)]}function jn(e){e=Gn(e);return e[3]=0,e}function $n(e){return{r:e.read_shift(2),c:e.read_shift(2),ixfe:e.read_shift(2)}}function Xn(e,t,r,a){return(a=a||Lr(6)).write_shift(2,e),a.write_shift(2,t),a.write_shift(2,r||0),a}function Yn(e){return[e.read_shift(2),Ea(e)]}function Kn(e){var t=e.read_shift(2),r=e.read_shift(2);return{s:{c:e.read_shift(2),r:t},e:{c:e.read_shift(2),r:r}}}function Jn(e,t){return(t=t||Lr(8)).write_shift(2,e.s.r),t.write_shift(2,e.e.r),t.write_shift(2,e.s.c),t.write_shift(2,e.e.c),t}function qn(e){var t=e.read_shift(2),r=e.read_shift(2);return{s:{c:e.read_shift(1),r:t},e:{c:e.read_shift(1),r:r}}}var Zn=qn;function Qn(e){e.l+=4;var t=e.read_shift(2),r=e.read_shift(2),a=e.read_shift(2);return e.l+=12,[r,t,a]}function es(e){e.l+=2,e.l+=e.read_shift(2)}var ts={0:es,4:es,5:es,6:es,7:function(e){return e.l+=4,e.cf=e.read_shift(2),{}},8:es,9:es,10:es,11:es,12:es,13:function(e){var t={};return e.l+=4,e.l+=16,t.fSharedNote=e.read_shift(2),e.l+=4,t},14:es,15:es,16:es,17:es,18:es,19:es,20:es,21:Qn};function rs(e,t){var r={BIFFVer:0,dt:0};switch(r.BIFFVer=e.read_shift(2),2<=(t-=2)&&(r.dt=e.read_shift(2),e.l-=2),r.BIFFVer){case 1536:case 1280:case 1024:case 768:case 512:case 2:case 7:break;default:if(6<t)throw new Error("Unexpected BIFF Ver "+r.BIFFVer)}return e.read_shift(t),r}function as(e,t,r){var a=1536,n=16;switch(r.bookType){case"biff8":break;case"biff5":a=1280,n=8;break;case"biff4":a=4,n=6;break;case"biff3":a=3,n=6;break;case"biff2":a=2,n=4;break;case"xla":break;default:throw new Error("unsupported BIFF version")}r=Lr(n);return r.write_shift(2,a),r.write_shift(2,t),4<n&&r.write_shift(2,29282),6<n&&r.write_shift(2,1997),8<n&&(r.write_shift(2,49161),r.write_shift(2,1),r.write_shift(2,1798),r.write_shift(2,0)),r}function ns(e){var t=Lr(8);t.write_shift(4,e.Count),t.write_shift(4,e.Unique);for(var r,a,n,s=[],i=0;i<e.length;++i)s[i]=(r=e[i],n=a=void 0,a=r.t||"",(n=Lr(3)).write_shift(2,a.length),n.write_shift(1,1),(r=Lr(2*a.length)).write_shift(2*a.length,a,"utf16le"),ue([n,r]));var o=ue([t].concat(s));return o.parts=[t.length].concat(s.map(function(e){return e.length})),o}function ss(e,t,r){var a=0;r&&2==r.biff||(a=e.read_shift(2));e=e.read_shift(2);return r&&2==r.biff&&(a=1-(e>>15),e&=32767),[{Unsynced:1&a,DyZero:(2&a)>>1,ExAsc:(4&a)>>2,ExDsc:(8&a)>>3},e]}var is=Bn;function os(e,t,r){var a=e.l+t,n=8!=r.biff&&r.biff?2:4,s=e.read_shift(n),t=e.read_shift(n),r=e.read_shift(2),n=e.read_shift(2);return e.l=a,{s:{r:s,c:r},e:{r:t,c:n}}}function cs(e,t,r,a){r=r&&5==r.biff;(a=a||Lr(r?16:20)).write_shift(2,0),e.style?(a.write_shift(2,e.numFmtId||0),a.write_shift(2,65524)):(a.write_shift(2,e.numFmtId||0),a.write_shift(2,t<<4));t=0;return 0<e.numFmtId&&r&&(t|=1024),a.write_shift(4,t),a.write_shift(4,0),r||a.write_shift(4,0),a.write_shift(2,0),a}function ls(e,t,r){var a=$n(e);2!=r.biff&&9!=t||++e.l;e=(t=e).read_shift(1),e=1===t.read_shift(1)?e:1===e;return a.val=e,a.t=!0===e||!1===e?"b":"e",a}function fs(e,t,r){return 0===t?"":Bn(e,0,r)}function hs(e,t,r){var a,n=e.read_shift(2),n={fBuiltIn:1&n,fWantAdvise:n>>>1&1,fWantPict:n>>>2&1,fOle:n>>>3&1,fOleLink:n>>>4&1,cf:n>>>5&1023,fIcon:n>>>15&1};return 14849===r.sbcch&&(a=function(e,t,r){e.l+=4,t-=4;var a=e.l+t,t=Ln(e,0,r);if((r=e.read_shift(2))!==(a-=e.l))throw new Error("Malformed AddinUdf: padding = "+a+" != "+r);return e.l+=r,t}(e,t-2,r)),n.body=a||e.read_shift(t-2),"string"==typeof a&&(n.Name=a),n}var us=["_xlnm.Consolidate_Area","_xlnm.Auto_Open","_xlnm.Auto_Close","_xlnm.Extract","_xlnm.Database","_xlnm.Criteria","_xlnm.Print_Area","_xlnm.Print_Titles","_xlnm.Recorder","_xlnm.Data_Form","_xlnm.Auto_Activate","_xlnm.Auto_Deactivate","_xlnm.Sheet_Title","_xlnm._FilterDatabase"];function ds(e,t,r){var a=e.l+t,n=e.read_shift(2),s=e.read_shift(1),i=e.read_shift(1),o=e.read_shift(r&&2==r.biff?1:2),t=0;(!r||5<=r.biff)&&(5!=r.biff&&(e.l+=2),t=e.read_shift(2),5==r.biff&&(e.l+=2),e.l+=4);i=Mn(e,i,r);32&n&&(i=us[i.charCodeAt(0)]);n=a-e.l;return r&&2==r.biff&&--n,{chKey:s,Name:i,itab:t,rgce:a!=e.l&&0!==o&&0<n?function(e,t,r,a){var n,t=e.l+t,a=Ic(e,a,r);t!==e.l&&(n=Oc(e,t-e.l,a,r));return[a,n]}(e,n,r,o):[]}}function ps(e,t,r){if(r.biff<8)return function(e,t){3==e[e.l+1]&&e[e.l]++;t=Ln(e,0,t);return 3==t.charCodeAt(0)?t.slice(1):t}(e,r);for(var a,n,s=[],t=e.l+t,i=e.read_shift(8<r.biff?4:2);0!=i--;)s.push((a=e,r.biff,n=8<(n=r).biff?4:2,[a.read_shift(n),a.read_shift(n,"i"),a.read_shift(n,"i")]));if(e.l!=t)throw new Error("Bad ExternSheet: "+e.l+" != "+t);return s}function ms(e,t,r){var a=Zn(e,6);switch(r.biff){case 2:e.l++,t-=7;break;case 3:case 4:e.l+=2,t-=8;break;default:e.l+=6,t-=12}return[a,function(e,t,r){var a,n=e.l+t,s=2==r.biff?1:2,i=e.read_shift(s);if(65535==i)return[[],Pr(e,t-2)];var o=Ic(e,i,r);t!==i+s&&(a=Oc(e,t-i-s,o,r));return e.l=n,[o,a]}(e,t,r)]}var gs={8:function(e,t){var r=e.l+t;e.l+=10;var a=e.read_shift(2);e.l+=4,e.l+=2,e.l+=2,e.l+=2,e.l+=4;t=e.read_shift(1);return e.l+=t,e.l=r,{fmt:a}}};function bs(e){var t=Lr(24),r=Yr(e[0]);t.write_shift(2,r.r),t.write_shift(2,r.r),t.write_shift(2,r.c),t.write_shift(2,r.c);for(var a="d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" "),n=0;n<16;++n)t.write_shift(1,parseInt(a[n],16));return ue([t,function(e){var t=Lr(512),r=0,a=e.Target,n=-1<(e=(a="file://"==a.slice(0,7)?a.slice(7):a).indexOf("#"))?31:23;switch(a.charAt(0)){case"#":n=28;break;case".":n&=-3}t.write_shift(4,2),t.write_shift(4,n);for(var s=[8,6815827,6619237,4849780,83],r=0;r<s.length;++r)t.write_shift(4,s[r]);if(28==n)Vn(a=a.slice(1),t);else if(2&n){for(s="e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" "),r=0;r<s.length;++r)t.write_shift(1,parseInt(s[r],16));var i=-1<e?a.slice(0,e):a;for(t.write_shift(4,2*(i.length+1)),r=0;r<i.length;++r)t.write_shift(2,i.charCodeAt(r));t.write_shift(2,0),8&n&&Vn(-1<e?a.slice(e+1):"",t)}else{for(s="03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" "),r=0;r<s.length;++r)t.write_shift(1,parseInt(s[r],16));for(var o=0;"../"==a.slice(3*o,3*o+3)||"..\\"==a.slice(3*o,3*o+3);)++o;for(t.write_shift(2,o),t.write_shift(4,a.length-3*o+1),r=0;r<a.length-3*o;++r)t.write_shift(1,255&a.charCodeAt(r+3*o));for(t.write_shift(1,0),t.write_shift(2,65535),t.write_shift(2,57005),r=0;r<6;++r)t.write_shift(4,0)}return t.slice(0,t.l)}(e[1])])}function vs(e,t,r){if(!r.cellStyles)return Pr(e,t);var a=r&&12<=r.biff?4:2,n=e.read_shift(a),s=e.read_shift(a),i=e.read_shift(a),o=e.read_shift(a),t=e.read_shift(2);2==a&&(e.l+=2);o={s:n,e:s,w:i,ixfe:o,flags:t};return(5<=r.biff||!r.biff)&&(o.level=t>>8&7),o}var ws=$n,Ts=Dn,Es=Un;var ks,ys,Ss,_s=[2,3,48,49,131,139,140,245],xs=(ks={1:437,2:850,3:1252,4:1e4,100:852,101:866,102:865,103:861,104:895,105:620,106:737,107:857,120:950,121:949,122:936,123:932,124:874,125:1255,126:1256,150:10007,151:10029,152:10006,200:1250,201:1251,202:1254,203:1253,0:20127,8:865,9:437,10:850,11:437,13:437,14:850,15:437,16:850,17:437,18:850,19:932,20:850,21:437,22:850,23:865,24:437,25:437,26:850,27:437,28:863,29:850,31:852,34:852,35:852,36:860,37:850,38:866,55:850,64:852,77:936,78:949,79:950,80:874,87:1252,88:1252,89:1252,108:863,134:737,135:852,136:857,204:1257,255:16969},ys=Ie({1:437,2:850,3:1252,4:1e4,100:852,101:866,102:865,103:861,104:895,105:620,106:737,107:857,120:950,121:949,122:936,123:932,124:874,125:1255,126:1256,150:10007,151:10029,152:10006,200:1250,201:1251,202:1254,203:1253,0:20127}),Ss={B:8,C:250,L:1,D:8,"?":0,"":0},{to_workbook:function(e,t){try{return ta(As(e,t),t)}catch(e){if(t&&t.WTF)throw e}return{SheetNames:[],Sheets:{}}},to_sheet:As,from_sheet:function(e,t){if(0<=+(t=t||{}).codepage&&ie(+t.codepage),"string"==t.type)throw new Error("Cannot write DBF to JS string");for(var r=Ur(),a=(t=iu(e,{header:1,raw:!0,cellDates:!0}))[0],n=t.slice(1),s=e["!cols"]||[],i=0,o=0,c=0,l=1,i=0;i<a.length;++i)if(((s[i]||{}).DBF||{}).name)a[i]=s[i].DBF.name,++c;else if(null!=a[i]){if(++c,"number"==typeof a[i]&&(a[i]=a[i].toString(10)),"string"!=typeof a[i])throw new Error("DBF Invalid column name "+a[i]+" |"+typeof a[i]+"|");if(a.indexOf(a[i])!==i)for(o=0;o<1024;++o)if(-1==a.indexOf(a[i]+"_"+o)){a[i]+="_"+o;break}}var f=Zr(e["!ref"]),h=[],u=[],d=[];for(i=0;i<=f.e.c-f.s.c;++i){for(var p="",m="",g=0,b=[],o=0;o<n.length;++o)null!=n[o][i]&&b.push(n[o][i]);if(0!=b.length&&null!=a[i]){for(o=0;o<b.length;++o){switch(typeof b[o]){case"number":m="B";break;case"string":m="C";break;case"boolean":m="L";break;case"object":m=b[o]instanceof Date?"D":"C";break;default:m="C"}g=Math.max(g,String(b[o]).length),p=p&&p!=m?"C":m}250<g&&(g=250),"C"==(m=((s[i]||{}).DBF||{}).type)&&s[i].DBF.len>g&&(g=s[i].DBF.len),"B"==p&&"N"==m&&(p="N",d[i]=s[i].DBF.dec,g=s[i].DBF.len),u[i]="C"==p||"N"==m?g:Ss[p]||0,l+=u[i],h[i]=p}else h[i]="?"}var v,w,T=r.next(32);for(T.write_shift(4,318902576),T.write_shift(4,n.length),T.write_shift(2,296+32*c),T.write_shift(2,l),i=0;i<4;++i)T.write_shift(4,0);for(T.write_shift(4,0|(+ys[_]||3)<<8),o=i=0;i<a.length;++i)null!=a[i]&&(v=r.next(32),w=(a[i].slice(-10)+"\0\0\0\0\0\0\0\0\0\0\0").slice(0,11),v.write_shift(1,w,"sbcs"),v.write_shift(1,"?"==h[i]?"C":h[i],"sbcs"),v.write_shift(4,o),v.write_shift(1,u[i]||Ss[h[i]]||0),v.write_shift(1,d[i]||0),v.write_shift(1,2),v.write_shift(4,0),v.write_shift(1,0),v.write_shift(4,0),v.write_shift(4,0),o+=u[i]||Ss[h[i]]||0);var E=r.next(264);for(E.write_shift(4,13),i=0;i<65;++i)E.write_shift(4,0);for(i=0;i<n.length;++i){var k=r.next(l);for(k.write_shift(1,0),o=0;o<a.length;++o)if(null!=a[o])switch(h[o]){case"L":k.write_shift(1,null==n[i][o]?63:n[i][o]?84:70);break;case"B":k.write_shift(8,n[i][o]||0,"f");break;case"N":var y="0";for("number"==typeof n[i][o]&&(y=n[i][o].toFixed(d[o]||0)),c=0;c<u[o]-y.length;++c)k.write_shift(1,32);k.write_shift(1,y,"sbcs");break;case"D":n[i][o]?(k.write_shift(4,("0000"+n[i][o].getFullYear()).slice(-4),"sbcs"),k.write_shift(2,("00"+(n[i][o].getMonth()+1)).slice(-2),"sbcs"),k.write_shift(2,("00"+n[i][o].getDate()).slice(-2),"sbcs")):k.write_shift(8,"00000000","sbcs");break;case"C":var S=String(null!=n[i][o]?n[i][o]:"").slice(0,u[o]);for(k.write_shift(1,S,"sbcs"),c=0;c<u[o]-S.length;++c)k.write_shift(1,32)}}return r.next(1).write_shift(1,26),r.end()}});function As(e,t){t=t||{};t.dateNF||(t.dateNF="yyyymmdd");e=aa(function(e,t){var r=[],a=le(1);switch(t.type){case"base64":a=he(te(e));break;case"binary":a=he(e);break;case"buffer":case"array":a=e}Dr(a,0);var n=a.read_shift(1),s=!!(136&n),i=!1,o=!1;switch(n){case 2:case 3:break;case 48:case 49:s=i=!0;break;case 131:case 139:break;case 140:o=!0;break;case 245:break;default:throw new Error("DBF Unsupported Version: "+n.toString(16))}var c=0,l=521;2==n&&(c=a.read_shift(2)),a.l+=3,1048576<(c=2!=n?a.read_shift(4):c)&&(c=1e6),2!=n&&(l=a.read_shift(2));var f=a.read_shift(2),h=t.codepage||1252;2!=n&&(a.l+=16,a.read_shift(1),0!==a[a.l]&&(h=ks[a[a.l]]),a.l+=1,a.l+=2),o&&(a.l+=36);for(var u=[],d={},p=Math.min(a.length,2==n?521:l-10-(i?264:0)),m=o?32:11;a.l<p&&13!=a[a.l];)switch((d={}).name=re.utils.decode(h,a.slice(a.l,a.l+m)).replace(/[\u0000\r\n].*$/g,""),a.l+=m,d.type=String.fromCharCode(a.read_shift(1)),2==n||o||(d.offset=a.read_shift(4)),d.len=a.read_shift(1),2==n&&(d.offset=a.read_shift(2)),d.dec=a.read_shift(1),d.name.length&&u.push(d),2!=n&&(a.l+=o?13:14),d.type){case"B":i&&8==d.len||!t.WTF||console.log("Skipping "+d.name+":"+d.type);break;case"G":case"P":t.WTF&&console.log("Skipping "+d.name+":"+d.type);break;case"+":case"0":case"@":case"C":case"D":case"F":case"I":case"L":case"M":case"N":case"O":case"T":case"Y":break;default:throw new Error("Unknown Field Type: "+d.type)}if(13!==a[a.l]&&(a.l=l-1),13!==a.read_shift(1))throw new Error("DBF Terminator not found "+a.l+" "+a[a.l]);a.l=l;var g=0,b=0;for(r[0]=[],b=0;b!=u.length;++b)r[0][b]=u[b].name;for(;0<c--;)if(42!==a[a.l])for(++a.l,r[++g]=[],b=b=0;b!=u.length;++b){var v=a.slice(a.l,a.l+u[b].len);a.l+=u[b].len,Dr(v,0);var w=re.utils.decode(h,v);switch(u[b].type){case"C":w.trim().length&&(r[g][b]=w.replace(/\s+$/,""));break;case"D":8===w.length?r[g][b]=new Date(+w.slice(0,4),+w.slice(4,6)-1,+w.slice(6,8)):r[g][b]=w;break;case"F":r[g][b]=parseFloat(w.trim());break;case"+":case"I":r[g][b]=o?2147483648^v.read_shift(-4,"i"):v.read_shift(4,"i");break;case"L":switch(w.trim().toUpperCase()){case"Y":case"T":r[g][b]=!0;break;case"N":case"F":r[g][b]=!1;break;case"":case"?":break;default:throw new Error("DBF Unrecognized L:|"+w+"|")}break;case"M":if(!s)throw new Error("DBF Unexpected MEMO for type "+n.toString(16));r[g][b]="##MEMO##"+(o?parseInt(w.trim(),10):v.read_shift(4));break;case"N":(w=w.replace(/\u0000/g,"").trim())&&"."!=w&&(r[g][b]=+w||0);break;case"@":r[g][b]=new Date(v.read_shift(-8,"f")-621356832e5);break;case"T":r[g][b]=new Date(864e5*(v.read_shift(4)-2440588)+v.read_shift(4));break;case"Y":r[g][b]=v.read_shift(4,"i")/1e4+v.read_shift(4,"i")/1e4*Math.pow(2,32);break;case"O":r[g][b]=-v.read_shift(-8,"f");break;case"B":if(i&&8==u[b].len){r[g][b]=v.read_shift(8,"f");break}case"G":case"P":v.l+=u[b].len;break;case"0":if("_NullFlags"===u[b].name)break;default:throw new Error("DBF Unsupported data type "+u[b].type)}}else a.l+=f;if(2!=n&&a.l<a.length&&26!=a[a.l++])throw new Error("DBF EOF Marker missing "+(a.l-1)+" of "+a.length+" "+a[a.l-1].toString(16));return t&&t.sheetRows&&(r=r.slice(0,t.sheetRows)),t.DBF=u,r}(e,t),t);return e["!cols"]=t.DBF.map(function(e){return{wch:e.len,DBF:e}}),delete t.DBF,e}var Cs,Rs,Os,Is,Ns=(Cs={AA:"À",BA:"Á",CA:"Â",DA:195,HA:"Ä",JA:197,AE:"È",BE:"É",CE:"Ê",HE:"Ë",AI:"Ì",BI:"Í",CI:"Î",HI:"Ï",AO:"Ò",BO:"Ó",CO:"Ô",DO:213,HO:"Ö",AU:"Ù",BU:"Ú",CU:"Û",HU:"Ü",Aa:"à",Ba:"á",Ca:"â",Da:227,Ha:"ä",Ja:229,Ae:"è",Be:"é",Ce:"ê",He:"ë",Ai:"ì",Bi:"í",Ci:"î",Hi:"ï",Ao:"ò",Bo:"ó",Co:"ô",Do:245,Ho:"ö",Au:"ù",Bu:"ú",Cu:"û",Hu:"ü",KC:"Ç",Kc:"ç",q:"æ",z:"œ",a:"Æ",j:"Œ",DN:209,Dn:241,Hy:255,S:169,c:170,R:174,"B ":180,0:176,1:177,2:178,3:179,5:181,6:182,7:183,Q:185,k:186,b:208,i:216,l:222,s:240,y:248,"!":161,'"':162,"#":163,"(":164,"%":165,"'":167,"H ":168,"+":171,";":187,"<":188,"=":189,">":190,"?":191,"{":223},Rs=new RegExp("N("+Re(Cs).join("|").replace(/\|\|\|/,"|\\||").replace(/([?()+])/g,"\\$1")+"|\\|)","gm"),Os=function(e,t){t=Cs[t];return"number"==typeof t?n(t):t},Is=function(e,t,r){r=t.charCodeAt(0)-32<<4|r.charCodeAt(0)-48;return 59==r?e:n(r)},Cs["|"]=254,{to_workbook:function(e,t){return ta(Ds(e,t),t)},to_sheet:Ds,from_sheet:function(e,t){var r,a,n=["ID;PWXL;N;E"],s=[],i=Zr(e["!ref"]),o=Array.isArray(e),c="\r\n";n.push("P;PGeneral"),n.push("F;P0;DG0G8;M255"),e["!cols"]&&(r=n,e["!cols"].forEach(function(e,t){t="F;W"+(t+1)+" "+(t+1)+" ";e.hidden?t+="0":("number"!=typeof e.width||e.wpx||(e.wpx=so(e.width)),"number"!=typeof e.wpx||e.wch||(e.wch=io(e.wpx)),"number"==typeof e.wch&&(t+=Math.round(e.wch)))," "!=t.charAt(t.length-1)&&r.push(t)})),e["!rows"]&&(a=n,e["!rows"].forEach(function(e,t){var r="F;";e.hidden?r+="M0;":e.hpt?r+="M"+20*e.hpt+";":e.hpx&&(r+="M"+20*uo(e.hpx)+";"),2<r.length&&a.push(r+"R"+(t+1))})),n.push("B;Y"+(i.e.r-i.s.r+1)+";X"+(i.e.c-i.s.c+1)+";D"+[i.s.c,i.s.r,i.e.c,i.e.r].join(" "));for(var l=i.s.r;l<=i.e.r;++l)for(var f=i.s.c;f<=i.e.c;++f){var h=Kr({r:l,c:f});(h=o?(e[l]||[])[f]:e[h])&&(null!=h.v||h.f&&!h.F)&&s.push(function(e,t,r){var a="C;Y"+(t+1)+";X"+(r+1)+";K";switch(e.t){case"n":a+=e.v||0,e.f&&!e.F&&(a+=";E"+fc(e.f,{r:t,c:r}));break;case"b":a+=e.v?"TRUE":"FALSE";break;case"e":a+=e.w||e.v;break;case"d":a+='"'+(e.w||e.v)+'"';break;case"s":a+='"'+e.v.replace(/"/g,"").replace(/;/g,";;")+'"'}return a}(h,l,f))}return n.join(c)+c+s.join(c)+c+"E"+c}});function Fs(e,t){var r,a,n=e.split(/[\n\r]+/),s=-1,i=-1,o=0,c=0,l=[],f=[],h=null,e={},u=[],d=[],p=0;for(0<=+t.codepage&&ie(+t.codepage);o!==n.length;++o){p=0;var m,g=n[o].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g,Is).replace(Rs,Os),b=g.replace(/;;/g,"\0").split(";").map(function(e){return e.replace(/\u0000/g,";")}),v=b[0];if(0<g.length)switch(v){case"ID":case"E":case"B":case"O":case"W":break;case"P":"P"==b[1].charAt(0)&&f.push(g.slice(3).replace(/;;/g,";"));break;case"C":for(var w=!1,T=!1,E=!1,k=!1,y=-1,S=-1,c=1;c<b.length;++c)switch(b[c].charAt(0)){case"A":break;case"X":i=parseInt(b[c].slice(1))-1,T=!0;break;case"Y":for(s=parseInt(b[c].slice(1))-1,T||(i=0),a=l.length;a<=s;++a)l[a]=[];break;case"K":'"'===(m=b[c].slice(1)).charAt(0)?m=m.slice(1,m.length-1):"TRUE"===m?m=!0:"FALSE"===m?m=!1:isNaN(je(m))?isNaN(Xe(m).getDate())||(m=He(m)):(m=je(m),null!==h&&q(h)&&(m=Me(m))),void 0!==re&&"string"==typeof m&&"string"!=(t||{}).type&&(t||{}).codepage&&(m=re.utils.decode(t.codepage,m)),w=!0;break;case"E":k=!0;var _=oc(b[c].slice(1),{r:s,c:i});l[s][i]=[l[s][i],_];break;case"S":E=!0,l[s][i]=[l[s][i],"S5S"];break;case"G":break;case"R":y=parseInt(b[c].slice(1))-1;break;case"C":S=parseInt(b[c].slice(1))-1;break;default:if(t&&t.WTF)throw new Error("SYLK bad record "+g)}if(w&&(l[s][i]&&2==l[s][i].length?l[s][i][0]=m:l[s][i]=m,h=null),E){if(k)throw new Error("SYLK shared formula cannot have own formula");var x=-1<y&&l[y][S];if(!x||!x[1])throw new Error("SYLK shared formula cannot find base");l[s][i][1]=hc(x[1],{r:s-y,c:i-S})}break;case"F":var A=0;for(c=1;c<b.length;++c)switch(b[c].charAt(0)){case"X":i=parseInt(b[c].slice(1))-1,++A;break;case"Y":for(s=parseInt(b[c].slice(1))-1,a=l.length;a<=s;++a)l[a]=[];break;case"M":p=parseInt(b[c].slice(1))/20;break;case"F":case"G":break;case"P":h=f[parseInt(b[c].slice(1))];break;case"S":case"D":case"N":break;case"W":for(r=b[c].slice(1).split(" "),a=parseInt(r[0],10);a<=parseInt(r[1],10);++a)p=parseInt(r[2],10),d[a-1]=0===p?{hidden:!0}:{wch:p},fo(d[a-1]);break;case"C":d[i=parseInt(b[c].slice(1))-1]||(d[i]={});break;case"R":u[s=parseInt(b[c].slice(1))-1]||(u[s]={}),0<p?(u[s].hpt=p,u[s].hpx=po(p)):0===p&&(u[s].hidden=!0);break;default:if(t&&t.WTF)throw new Error("SYLK bad record "+g)}A<1&&(h=null);break;default:if(t&&t.WTF)throw new Error("SYLK bad record "+g)}}return 0<u.length&&(e["!rows"]=u),0<d.length&&(e["!cols"]=d),[l=t&&t.sheetRows?l.slice(0,t.sheetRows):l,e]}function Ds(e,t){var r=function(e,t){switch(t.type){case"base64":return Fs(te(e),t);case"binary":return Fs(e,t);case"buffer":return Fs(se&&Buffer.isBuffer(e)?e.toString("binary"):i(e),t);case"array":return Fs(ze(e),t)}throw new Error("Unrecognized type "+t.type)}(e,t),e=r[0],a=r[1],n=aa(e,t);return Re(a).forEach(function(e){n[e]=a[e]}),n}var Ps={to_workbook:function(e,t){return ta(Ms(e,t),t)},to_sheet:Ms,from_sheet:function(e){var t=[],r=Zr(e["!ref"]),a=Array.isArray(e);Us(t,"TABLE",0,1,"sheetjs"),Us(t,"VECTORS",0,r.e.r-r.s.r+1,""),Us(t,"TUPLES",0,r.e.c-r.s.c+1,""),Us(t,"DATA",0,0,"");for(var n=r.s.r;n<=r.e.r;++n){Bs(t,-1,0,"BOT");for(var s=r.s.c;s<=r.e.c;++s){var i,o=Kr({r:n,c:s});if(i=a?(e[n]||[])[s]:e[o])switch(i.t){case"n":var c=d?i.w:i.v;null==(c=!c&&null!=i.v?i.v:c)?d&&i.f&&!i.F?Bs(t,1,0,"="+i.f):Bs(t,1,0,""):Bs(t,0,c,"V");break;case"b":Bs(t,0,i.v?1:0,i.v?"TRUE":"FALSE");break;case"s":Bs(t,1,0,!d||isNaN(i.v)?i.v:'="'+i.v+'"');break;case"d":i.w||(i.w=ve(i.z||me[14],De(He(i.v)))),d?Bs(t,0,i.w,"V"):Bs(t,1,0,i.w);break;default:Bs(t,1,0,"")}else Bs(t,1,0,"")}}Bs(t,-1,0,"EOD");return t.join("\r\n")}};function Ls(e,t){for(var r=e.split("\n"),a=-1,n=-1,s=0,i=[];s!==r.length;++s)if("BOT"!==r[s].trim()){if(!(a<0)){for(var o=r[s].trim().split(","),c=o[0],l=o[1],f=r[++s]||"";1&(f.match(/["]/g)||[]).length&&s<r.length-1;)f+="\n"+r[++s];switch(f=f.trim(),+c){case-1:if("BOT"===f){i[++a]=[],n=0;continue}if("EOD"!==f)throw new Error("Unrecognized DIF special command "+f);break;case 0:"TRUE"===f?i[a][n]=!0:"FALSE"===f?i[a][n]=!1:isNaN(je(l))?isNaN(Xe(l).getDate())?i[a][n]=l:i[a][n]=He(l):i[a][n]=je(l),++n;break;case 1:f=(f=f.slice(1,f.length-1)).replace(/""/g,'"'),d&&f&&f.match(/^=".*"$/)&&(f=f.slice(2,-1)),i[a][n++]=""!==f?f:null}if("EOD"===f)break}}else i[++a]=[],n=0;return i=t&&t.sheetRows?i.slice(0,t.sheetRows):i}function Ms(e,t){return aa(function(e,t){switch(t.type){case"base64":return Ls(te(e),t);case"binary":return Ls(e,t);case"buffer":return Ls(se&&Buffer.isBuffer(e)?e.toString("binary"):i(e),t);case"array":return Ls(ze(e),t)}throw new Error("Unrecognized type "+t.type)}(e,t),t)}function Us(e,t,r,a,n){e.push(t),e.push(r+","+a),e.push('"'+n.replace(/"/g,'""')+'"')}function Bs(e,t,r,a){e.push(t+","+r),e.push(1==t?'"'+a.replace(/"/g,'""')+'"':a)}var Ws,Hs,zs,Vs,Gs=(Ws=["socialcalc:version:1.5","MIME-Version: 1.0","Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"].join("\n"),Hs=["--SocialCalcSpreadsheetControlSave","Content-type: text/plain; charset=UTF-8"].join("\n")+"\n",zs=["# SocialCalc Spreadsheet Control Save","part:sheet"].join("\n"),Vs="--SocialCalcSpreadsheetControlSave--",{to_workbook:function(e,t){return ta($s(e,t),t)},to_sheet:$s,from_sheet:function(e){return[Ws,Hs,zs,Hs,function(e){if(!e||!e["!ref"])return"";for(var t,r,a=[],n=[],s=Jr(e["!ref"]),i=Array.isArray(e),o=s.s.r;o<=s.e.r;++o)for(var c=s.s.c;c<=s.e.c;++c)if(r=Kr({r:o,c:c}),(t=i?(e[o]||[])[c]:e[r])&&null!=t.v&&"z"!==t.t){switch(n=["cell",r,"t"],t.t){case"s":case"str":n.push(js(t.v));break;case"n":t.f?(n[2]="vtf",n[3]="n",n[4]=t.v,n[5]=js(t.f)):(n[2]="v",n[3]=t.v);break;case"b":n[2]="vt"+(t.f?"f":"c"),n[3]="nl",n[4]=t.v?"1":"0",n[5]=js(t.f||(t.v?"TRUE":"FALSE"));break;case"d":var l=De(He(t.v));n[2]="vtc",n[3]="nd",n[4]=""+l,n[5]=t.w||ve(t.z||me[14],l);break;case"e":continue}a.push(n.join(":"))}return a.push("sheet:c:"+(s.e.c-s.s.c+1)+":r:"+(s.e.r-s.s.r+1)+":tvf:1"),a.push("valueformat:1:text-wiki"),a.join("\n")}(e),Vs].join("\n")}});function js(e){return e.replace(/\\/g,"\\b").replace(/:/g,"\\c").replace(/\n/g,"\\n")}function $s(e,t){return aa(function(e,t){for(var r,a=e.split("\n"),n=-1,s=0,i=[];s!==a.length;++s){var o=a[s].trim().split(":");if("cell"===o[0]){var c=Yr(o[1]);if(i.length<=c.r)for(n=i.length;n<=c.r;++n)i[n]||(i[n]=[]);switch(n=c.r,r=c.c,o[2]){case"t":i[n][r]=o[3].replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n");break;case"v":i[n][r]=+o[3];break;case"vtf":var l=o[o.length-1];case"vtc":"nl"===o[3]?i[n][r]=!!+o[4]:i[n][r]=+o[4],"vtf"==o[2]&&(i[n][r]=[i[n][r],l])}}}return i=t&&t.sheetRows?i.slice(0,t.sheetRows):i}(e,t),t)}var Xs,Ys,Ks=(Xs={44:",",9:"\t",59:";",124:"|"},Ys={44:3,9:2,59:1,124:0},{to_workbook:function(e,t){return ta(ei(e,t),t)},to_sheet:ei,from_sheet:function(e){for(var t=[],r=Zr(e["!ref"]),a=Array.isArray(e),n=r.s.r;n<=r.e.r;++n){for(var s=[],i=r.s.c;i<=r.e.c;++i){var o=Kr({r:n,c:i});if((o=a?(e[n]||[])[i]:e[o])&&null!=o.v){for(var c=(o.w||(ea(o),o.w)||"").slice(0,10);c.length<10;)c+=" ";s.push(c+(0===i?" ":""))}else s.push("          ")}t.push(s.join(""))}return t.join("\n")}});function Js(e,t,r,a,n){n.raw?t[r][a]=e:""===e||("TRUE"===e?t[r][a]=!0:"FALSE"===e?t[r][a]=!1:isNaN(je(e))?isNaN(Xe(e).getDate())?t[r][a]=e:t[r][a]=He(e):t[r][a]=je(e))}function qs(e){for(var t={},r=!1,a=0,n=0;a<e.length;++a)34==(n=e.charCodeAt(a))?r=!r:!r&&n in Xs&&(t[n]=(t[n]||0)+1);for(a in n=[],t)Object.prototype.hasOwnProperty.call(t,a)&&n.push([t[a],a]);if(!n.length)for(a in t=Ys)Object.prototype.hasOwnProperty.call(t,a)&&n.push([t[a],a]);return n.sort(function(e,t){return e[0]-t[0]||Ys[e[1]]-Ys[t[1]]}),Xs[n.pop()[1]]||44}function Zs(a,e){var n=e||{},e="";null!=oe&&null==n.dense&&(n.dense=oe);var s=n.dense?[]:{},i={s:{c:0,r:0},e:{c:0,r:0}};"sep="==a.slice(0,4)?13==a.charCodeAt(5)&&10==a.charCodeAt(6)?(e=a.charAt(4),a=a.slice(7)):13==a.charCodeAt(5)||10==a.charCodeAt(5)?(e=a.charAt(4),a=a.slice(6)):e=qs(a.slice(0,1024)):e=n&&n.FS?n.FS:qs(a.slice(0,1024));var o=0,c=0,l=0,f=0,h=0,u=e.charCodeAt(0),t=!1,d=0,p=a.charCodeAt(0);a=a.replace(/\r\n/gm,"\n");var m=null!=n.dateNF?(e=(e="number"==typeof(e=n.dateNF)?me[e]:e).replace(ye,"(\\d+)"),new RegExp("^"+e+"$")):null;function r(){var e,t=a.slice(f,h),r={};if(0===(t='"'==t.charAt(0)&&'"'==t.charAt(t.length-1)?t.slice(1,-1).replace(/""/g,'"'):t).length?r.t="z":n.raw||0===t.trim().length?(r.t="s",r.v=t):61==t.charCodeAt(0)?34==t.charCodeAt(1)&&34==t.charCodeAt(t.length-1)?(r.t="s",r.v=t.slice(2,-1).replace(/""/g,'"')):1!=t.length?(r.t="n",r.f=t.slice(1)):(r.t="s",r.v=t):"TRUE"==t?(r.t="b",r.v=!0):"FALSE"==t?(r.t="b",r.v=!1):isNaN(l=je(t))?!isNaN(Xe(t).getDate())||m&&t.match(m)?(r.z=n.dateNF||me[14],e=0,m&&t.match(m)&&(t=function(e,a){var n=-1,s=-1,i=-1,o=-1,c=-1,l=-1;(e.match(ye)||[]).forEach(function(e,t){var r=parseInt(a[t+1],10);switch(e.toLowerCase().charAt(0)){case"y":n=r;break;case"d":i=r;break;case"h":o=r;break;case"s":l=r;break;case"m":0<=o?c=r:s=r}}),0<=l&&-1==c&&0<=s&&(c=s,s=-1);var t=(""+(0<=n?n:(new Date).getFullYear())).slice(-4)+"-"+("00"+(1<=s?s:1)).slice(-2)+"-"+("00"+(1<=i?i:1)).slice(-2);return 8==(t=7==t.length?"0"+t:t).length&&(t="20"+t),e=("00"+(0<=o?o:0)).slice(-2)+":"+("00"+(0<=c?c:0)).slice(-2)+":"+("00"+(0<=l?l:0)).slice(-2),-1==o&&-1==c&&-1==l?t:-1==n&&-1==s&&-1==i?e:t+"T"+e}(n.dateNF,t.match(m)||[]),e=1),n.cellDates?(r.t="d",r.v=He(t,e)):(r.t="n",r.v=De(He(t,e))),!1!==n.cellText&&(r.w=ve(r.z,r.v instanceof Date?De(r.v):r.v)),n.cellNF||delete r.z):(r.t="s",r.v=t):(!(r.t="n")!==n.cellText&&(r.w=t),r.v=l),"z"==r.t||(n.dense?(s[o]||(s[o]=[]),s[o][c]=r):s[Kr({c:c,r:o})]=r),f=h+1,p=a.charCodeAt(f),i.e.c<c&&(i.e.c=c),i.e.r<o&&(i.e.r=o),d!=u)return c=0,++o,n.sheetRows&&n.sheetRows<=o?1:void 0;++c}e:for(;h<a.length;++h)switch(d=a.charCodeAt(h)){case 34:34===p&&(t=!t);break;case u:case 10:case 13:if(!t&&r())break e}return 0<h-f&&r(),s["!ref"]=qr(i),s}function Qs(e,t){return!t||!t.PRN||t.FS||"sep="==e.slice(0,4)||0<=e.indexOf("\t")||0<=e.indexOf(",")||0<=e.indexOf(";")?Zs(e,t):aa(function(e,t){var r=t||{},a=[];if(!e||0===e.length)return a;for(var n=e.split(/[\r\n]/),s=n.length-1;0<=s&&0===n[s].length;)--s;for(var i=10,o=0,c=0;c<=s;++c)-1==(o=n[c].indexOf(" "))?o=n[c].length:o++,i=Math.max(i,o);for(c=0;c<=s;++c){a[c]=[];var l=0;for(Js(n[c].slice(0,i).trim(),a,c,l,r),l=1;l<=(n[c].length-i)/10+1;++l)Js(n[c].slice(i+10*(l-1),i+10*l).trim(),a,c,l,r)}return a=r.sheetRows?a.slice(0,r.sheetRows):a}(e,t),t)}function ei(e,t){var r="",a="string"==t.type?[0,0,0,0]:$h(e,t);switch(t.type){case"base64":r=te(e);break;case"binary":r=e;break;case"buffer":r=65001==t.codepage?e.toString("utf8"):t.codepage&&void 0!==re?re.utils.decode(t.codepage,e):se&&Buffer.isBuffer(e)?e.toString("binary"):i(e);break;case"array":r=ze(e);break;case"string":r=e;break;default:throw new Error("Unrecognized type "+t.type)}return 239==a[0]&&187==a[1]&&191==a[2]?r=Mt(r.slice(3)):"string"!=t.type&&"buffer"!=t.type&&65001==t.codepage?r=Mt(r):"binary"==t.type&&void 0!==re&&t.codepage&&(r=re.utils.decode(t.codepage,re.utils.encode(28591,r))),"socialcalc:version:"==r.slice(0,19)?Gs.to_sheet("string"==t.type?r:Mt(r),t):Qs(r,t)}var ti,ri,ai,ni,si=(ti={51:["FALSE",0],52:["TRUE",0],70:["LEN",1],80:["SUM",69],81:["AVERAGEA",69],82:["COUNTA",69],83:["MINA",69],84:["MAXA",69],111:["T",1]},ri=["","","","","","","","","","+","-","*","/","^","=","<>","<=",">=","<",">","","","","","&","","","","","","",""],ai={0:{n:"BOF",f:Nn},1:{n:"EOF"},2:{n:"CALCMODE"},3:{n:"CALCORDER"},4:{n:"SPLIT"},5:{n:"SYNC"},6:{n:"RANGE",f:function(e,t,r){var a={s:{c:0,r:0},e:{c:0,r:0}};return 8==t&&r.qpro?(a.s.c=e.read_shift(1),e.l++,a.s.r=e.read_shift(2),a.e.c=e.read_shift(1),e.l++,a.e.r=e.read_shift(2)):(a.s.c=e.read_shift(2),a.s.r=e.read_shift(2),12==t&&r.qpro&&(e.l+=2),a.e.c=e.read_shift(2),a.e.r=e.read_shift(2),12==t&&r.qpro&&(e.l+=2),65535==a.s.c&&(a.s.c=a.e.c=a.s.r=a.e.r=0)),a}},7:{n:"WINDOW1"},8:{n:"COLW1"},9:{n:"WINTWO"},10:{n:"COLW2"},11:{n:"NAME"},12:{n:"BLANK"},13:{n:"INTEGER",f:function(e,t,r){return(r=ci(e,0,r))[1].v=e.read_shift(2,"i"),r}},14:{n:"NUMBER",f:function(e,t,r){return(r=ci(e,0,r))[1].v=e.read_shift(8,"f"),r}},15:{n:"LABEL",f:li},16:{n:"FORMULA",f:function(e,t,r){var a=e.l+t;return(t=ci(e,0,r))[1].v=e.read_shift(8,"f"),r.qpro?e.l=a:(a=e.read_shift(2),function(e,t){Dr(e,0);for(var r=[],a=0,n="",s="",i="",o="";e.l<e.length;){var c=e[e.l++];switch(c){case 0:r.push(e.read_shift(8,"f"));break;case 1:s=fi(t[0].c,e.read_shift(2),!0),n=fi(t[0].r,e.read_shift(2),!1),r.push(s+n);break;case 2:var l=fi(t[0].c,e.read_shift(2),!0),f=fi(t[0].r,e.read_shift(2),!1);s=fi(t[0].c,e.read_shift(2),!0),n=fi(t[0].r,e.read_shift(2),!1),r.push(l+f+":"+s+n);break;case 3:if(e.l<e.length)return console.error("WK1 premature formula end");break;case 4:r.push("("+r.pop()+")");break;case 5:r.push(e.read_shift(2));break;case 6:for(var h="";c=e[e.l++];)h+=String.fromCharCode(c);r.push('"'+h.replace(/"/g,'""')+'"');break;case 8:r.push("-"+r.pop());break;case 23:r.push("+"+r.pop());break;case 22:r.push("NOT("+r.pop()+")");break;case 20:case 21:o=r.pop(),i=r.pop(),r.push(["AND","OR"][c-20]+"("+i+","+o+")");break;default:if(c<32&&ri[c])o=r.pop(),i=r.pop(),r.push(i+ri[c]+o);else{if(!ti[c])return c<=7?console.error("WK1 invalid opcode "+c.toString(16)):c<=24?console.error("WK1 unsupported op "+c.toString(16)):c<=30?console.error("WK1 invalid opcode "+c.toString(16)):c<=115?console.error("WK1 unsupported function opcode "+c.toString(16)):console.error("WK1 unrecognized opcode "+c.toString(16));if((a=69==(a=ti[c][1])?e[e.l++]:a)>r.length)return console.error("WK1 bad formula parse 0x"+c.toString(16)+":|"+r.join("|")+"|");f=r.slice(-a);r.length-=a,r.push(ti[c][0]+"("+f.join(",")+")")}}}1==r.length?t[1].f=""+r[0]:console.error("WK1 bad formula parse |"+r.join("|")+"|")}(e.slice(e.l,e.l+a),t),e.l+=a),t}},24:{n:"TABLE"},25:{n:"ORANGE"},26:{n:"PRANGE"},27:{n:"SRANGE"},28:{n:"FRANGE"},29:{n:"KRANGE1"},32:{n:"HRANGE"},35:{n:"KRANGE2"},36:{n:"PROTEC"},37:{n:"FOOTER"},38:{n:"HEADER"},39:{n:"SETUP"},40:{n:"MARGINS"},41:{n:"LABELFMT"},42:{n:"TITLES"},43:{n:"SHEETJS"},45:{n:"GRAPH"},46:{n:"NGRAPH"},47:{n:"CALCCOUNT"},48:{n:"UNFORMATTED"},49:{n:"CURSORW12"},50:{n:"WINDOW"},51:{n:"STRING",f:li},55:{n:"PASSWORD"},56:{n:"LOCKED"},60:{n:"QUERY"},61:{n:"QUERYNAME"},62:{n:"PRINT"},63:{n:"PRINTNAME"},64:{n:"GRAPH2"},65:{n:"GRAPHNAME"},66:{n:"ZOOM"},67:{n:"SYMSPLIT"},68:{n:"NSROWS"},69:{n:"NSCOLS"},70:{n:"RULER"},71:{n:"NNAME"},72:{n:"ACOMM"},73:{n:"AMACRO"},74:{n:"PARSE"},102:{n:"PRANGES??"},103:{n:"RRANGES??"},104:{n:"FNAME??"},105:{n:"MRANGES??"},204:{n:"SHEETNAMECS",f:pi},222:{n:"SHEETNAMELP",f:function(e,t){var r=e[e.l++];t-1<r&&(r=t-1);for(var a="";a.length<r;)a+=String.fromCharCode(e[e.l++]);return a}},65535:{n:""}},ni={0:{n:"BOF"},1:{n:"EOF"},2:{n:"PASSWORD"},3:{n:"CALCSET"},4:{n:"WINDOWSET"},5:{n:"SHEETCELLPTR"},6:{n:"SHEETLAYOUT"},7:{n:"COLUMNWIDTH"},8:{n:"HIDDENCOLUMN"},9:{n:"USERRANGE"},10:{n:"SYSTEMRANGE"},11:{n:"ZEROFORCE"},12:{n:"SORTKEYDIR"},13:{n:"FILESEAL"},14:{n:"DATAFILLNUMS"},15:{n:"PRINTMAIN"},16:{n:"PRINTSTRING"},17:{n:"GRAPHMAIN"},18:{n:"GRAPHSTRING"},19:{n:"??"},20:{n:"ERRCELL"},21:{n:"NACELL"},22:{n:"LABEL16",f:function(e,t){var r=hi(e);return r[1].t="s",r[1].v=e.read_shift(t-4,"cstr"),r}},23:{n:"NUMBER17",f:ui},24:{n:"NUMBER18",f:function(e,t){var r=hi(e);r[1].v=e.read_shift(2);var a=r[1].v>>1;if(1&r[1].v)switch(7&a){case 0:a=5e3*(a>>3);break;case 1:a=500*(a>>3);break;case 2:a=(a>>3)/20;break;case 3:a=(a>>3)/200;break;case 4:a=(a>>3)/2e3;break;case 5:a=(a>>3)/2e4;break;case 6:a=(a>>3)/16;break;case 7:a=(a>>3)/64}return r[1].v=a,r}},25:{n:"FORMULA19",f:function(e,t){var r=ui(e);return e.l+=t-14,r}},26:{n:"FORMULA1A"},27:{n:"XFORMAT",f:function(e,t){for(var r={},a=e.l+t;e.l<a;){var n=e.read_shift(2);if(14e3==n){for(r[n]=[0,""],r[n][0]=e.read_shift(2);e[e.l];)r[n][1]+=String.fromCharCode(e[e.l]),e.l++;e.l++}}return r}},28:{n:"DTLABELMISC"},29:{n:"DTLABELCELL"},30:{n:"GRAPHWINDOW"},31:{n:"CPA"},32:{n:"LPLAUTO"},33:{n:"QUERY"},34:{n:"HIDDENSHEET"},35:{n:"??"},37:{n:"NUMBER25",f:function(e,t){var r=hi(e),e=e.read_shift(4);return r[1].v=e>>6,r}},38:{n:"??"},39:{n:"NUMBER27",f:di},40:{n:"FORMULA28",f:function(e,t){var r=di(e);return e.l+=t-10,r}},142:{n:"??"},147:{n:"??"},150:{n:"??"},151:{n:"??"},152:{n:"??"},153:{n:"??"},154:{n:"??"},155:{n:"??"},156:{n:"??"},163:{n:"??"},174:{n:"??"},175:{n:"??"},176:{n:"??"},177:{n:"??"},184:{n:"??"},185:{n:"??"},186:{n:"??"},187:{n:"??"},188:{n:"??"},195:{n:"??"},201:{n:"??"},204:{n:"SHEETNAMECS",f:pi},205:{n:"??"},206:{n:"??"},207:{n:"??"},208:{n:"??"},256:{n:"??"},259:{n:"??"},260:{n:"??"},261:{n:"??"},262:{n:"??"},263:{n:"??"},265:{n:"??"},266:{n:"??"},267:{n:"??"},268:{n:"??"},270:{n:"??"},271:{n:"??"},384:{n:"??"},389:{n:"??"},390:{n:"??"},393:{n:"??"},396:{n:"??"},512:{n:"??"},514:{n:"??"},513:{n:"??"},516:{n:"??"},517:{n:"??"},640:{n:"??"},641:{n:"??"},642:{n:"??"},643:{n:"??"},644:{n:"??"},645:{n:"??"},646:{n:"??"},647:{n:"??"},648:{n:"??"},658:{n:"??"},659:{n:"??"},660:{n:"??"},661:{n:"??"},662:{n:"??"},665:{n:"??"},666:{n:"??"},768:{n:"??"},772:{n:"??"},1537:{n:"SHEETINFOQP",f:function(e,t,r){if(r.qpro&&!(t<21)){r=e.read_shift(1);return e.l+=17,e.l+=1,e.l+=2,[r,e.read_shift(t-21,"cstr")]}}},1600:{n:"??"},1602:{n:"??"},1793:{n:"??"},1794:{n:"??"},1795:{n:"??"},1796:{n:"??"},1920:{n:"??"},2048:{n:"??"},2049:{n:"??"},2052:{n:"??"},2688:{n:"??"},10998:{n:"??"},12849:{n:"??"},28233:{n:"??"},28484:{n:"??"},65535:{n:""}},{sheet_to_wk1:function(e,t){var r=t||{};if(0<=+r.codepage&&ie(+r.codepage),"string"==r.type)throw new Error("Cannot write WK1 to JS string");var a=Ur(),n=Zr(e["!ref"]),s=Array.isArray(e),i=[];Lf(a,0,(t=1030,(r=Lr(2)).write_shift(2,t),r)),Lf(a,6,(t=n,(r=Lr(8)).write_shift(2,t.s.c),r.write_shift(2,t.s.r),r.write_shift(2,t.e.c),r.write_shift(2,t.e.r),r));for(var o,c,l,f,h=Math.min(n.e.r,8191),u=n.s.r;u<=h;++u)for(var d=jr(u),p=n.s.c;p<=n.e.c;++p){u===n.s.r&&(i[p]=Xr(p));var m=i[p]+d,m=s?(e[u]||[])[p]:e[m];m&&"z"!=m.t&&("n"==m.t?(0|m.v)==m.v&&-32768<=m.v&&m.v<=32767?Lf(a,13,(o=u,c=p,l=m.v,f=void 0,(f=Lr(7)).write_shift(1,255),f.write_shift(2,c),f.write_shift(2,o),f.write_shift(2,l,"i"),f)):Lf(a,14,(c=u,o=p,l=m.v,f=void 0,(f=Lr(13)).write_shift(1,255),f.write_shift(2,o),f.write_shift(2,c),f.write_shift(8,l,"f"),f)):Lf(a,15,function(e,t,r){var a=Lr(7+r.length);a.write_shift(1,255),a.write_shift(2,t),a.write_shift(2,e),a.write_shift(1,39);for(var n=0;n<a.length;++n){var s=r.charCodeAt(n);a.write_shift(1,128<=s?95:s)}return a.write_shift(1,0),a}(u,p,ea(m).slice(0,239))))}return Lf(a,1),a.end()},book_to_wk3:function(e,t){if(0<=+(t=t||{}).codepage&&ie(+t.codepage),"string"==t.type)throw new Error("Cannot write WK3 to JS string");var r=Ur();Lf(r,0,function(e){var t=Lr(26);t.write_shift(2,4096),t.write_shift(2,4),t.write_shift(4,0);for(var r=0,a=0,n=0,s=0;s<e.SheetNames.length;++s){var i=e.SheetNames[s],i=e.Sheets[i];i&&i["!ref"]&&(++n,i=Jr(i["!ref"]),r<i.e.r&&(r=i.e.r),a<i.e.c&&(a=i.e.c))}8191<r&&(r=8191);return t.write_shift(2,r),t.write_shift(1,n),t.write_shift(1,a),t.write_shift(2,0),t.write_shift(2,0),t.write_shift(1,1),t.write_shift(1,2),t.write_shift(4,0),t.write_shift(4,0),t}(e));for(var a=0,n=0;a<e.SheetNames.length;++a)(e.Sheets[e.SheetNames[a]]||{})["!ref"]&&Lf(r,27,function(e,t){var r=Lr(5+e.length);r.write_shift(2,14e3),r.write_shift(2,t);for(var a=0;a<e.length;++a){var n=e.charCodeAt(a);r[r.l++]=127<n?95:n}return r[r.l++]=0,r}(e.SheetNames[a],n++));for(var s=0,a=0;a<e.SheetNames.length;++a){var i=e.Sheets[e.SheetNames[a]];if(i&&i["!ref"]){for(var o=Zr(i["!ref"]),c=Array.isArray(i),l=[],f=Math.min(o.e.r,8191),h=o.s.r;h<=f;++h)for(var u=jr(h),d=o.s.c;d<=o.e.c;++d){h===o.s.r&&(l[d]=Xr(d));var p=l[d]+u,p=c?(i[h]||[])[d]:i[p];p&&"z"!=p.t&&("n"==p.t?Lf(r,23,function(e,t,r,a){var n=Lr(14);if(n.write_shift(2,e),n.write_shift(1,r),n.write_shift(1,t),0==a)return n.write_shift(4,0),n.write_shift(4,0),n.write_shift(2,65535),n;var s=0,e=0,r=0,t=0;a<0&&(s=1,a=-a);e=0|Math.log2(a),a/=Math.pow(2,e-31),0==(2147483648&(t=a>>>0))&&(++e,t=(a/=2)>>>0);return a-=t,t|=2147483648,t>>>=0,a*=Math.pow(2,32),r=a>>>0,n.write_shift(4,r),n.write_shift(4,t),e+=16383+(s?32768:0),n.write_shift(2,e),n}(h,d,s,p.v)):Lf(r,22,function(e,t,r,a){var n=Lr(6+a.length);n.write_shift(2,e),n.write_shift(1,r),n.write_shift(1,t),n.write_shift(1,39);for(var s=0;s<a.length;++s){var i=a.charCodeAt(s);n.write_shift(1,128<=i?95:i)}return n.write_shift(1,0),n}(h,d,s,ea(p).slice(0,239))))}++s}}return Lf(r,1),r.end()},to_workbook:function(e,t){switch(t.type){case"base64":return oi(he(te(e)),t);case"binary":return oi(he(e),t);case"buffer":case"array":return oi(e,t)}throw"Unsupported type "+t.type}});function ii(e,t,r){if(e){Dr(e,e.l||0);for(var a=r.Enum||ai;e.l<e.length;){var n=e.read_shift(2),s=a[n]||a[65535],i=e.read_shift(2),o=e.l+i,i=s.f&&s.f(e,i,r);if(e.l=o,t(i,s,n))return}}}function oi(e,t){if(!e)return e;var n=t||{};null!=oe&&null==n.dense&&(n.dense=oe);var s=n.dense?[]:{},i="Sheet1",o="",c=0,l={},f=[],a=[],h={s:{r:0,c:0},e:{r:0,c:0}},u=n.sheetRows||0;if(0==e[2]&&(8==e[3]||9==e[3])&&16<=e.length&&5==e[14]&&108===e[15])throw new Error("Unsupported Works 3 for Mac file");if(2==e[2])n.Enum=ai,ii(e,function(e,t,r){switch(r){case 0:4096<=(n.vers=e)&&(n.qpro=!0);break;case 6:h=e;break;case 204:e&&(o=e);break;case 222:o=e;break;case 15:case 51:n.qpro||(e[1].v=e[1].v.slice(1));case 13:case 14:case 16:14==r&&112==(112&e[2])&&1<(15&e[2])&&(15&e[2])<15&&(e[1].z=n.dateNF||me[14],n.cellDates&&(e[1].t="d",e[1].v=Me(e[1].v))),n.qpro&&e[3]>c&&(s["!ref"]=qr(h),l[i]=s,f.push(i),s=n.dense?[]:{},h={s:{r:0,c:0},e:{r:0,c:0}},c=e[3],i=o||"Sheet"+(c+1),o="");var a=n.dense?(s[e[0].r]||[])[e[0].c]:s[Kr(e[0])];if(a){a.t=e[1].t,a.v=e[1].v,null!=e[1].z&&(a.z=e[1].z),null!=e[1].f&&(a.f=e[1].f);break}n.dense?(s[e[0].r]||(s[e[0].r]=[]),s[e[0].r][e[0].c]=e[1]):s[Kr(e[0])]=e[1]}},n);else{if(26!=e[2]&&14!=e[2])throw new Error("Unrecognized LOTUS BOF "+e[2]);n.Enum=ni,14==e[2]&&(n.qpro=!0,e.l=0),ii(e,function(e,t,r){switch(r){case 204:i=e;break;case 22:e[1].v=e[1].v.slice(1);case 23:case 24:case 25:case 37:case 39:case 40:if(e[3]>c&&(s["!ref"]=qr(h),l[i]=s,f.push(i),s=n.dense?[]:{},h={s:{r:0,c:0},e:{r:0,c:0}},c=e[3],i="Sheet"+(c+1)),0<u&&e[0].r>=u)break;n.dense?(s[e[0].r]||(s[e[0].r]=[]),s[e[0].r][e[0].c]=e[1]):s[Kr(e[0])]=e[1],h.e.c<e[0].c&&(h.e.c=e[0].c),h.e.r<e[0].r&&(h.e.r=e[0].r);break;case 27:e[14e3]&&(a[e[14e3][0]]=e[14e3][1]);break;case 1537:a[e[0]]=e[1],e[0]==c&&(i=e[1])}},n)}if(s["!ref"]=qr(h),l[o||i]=s,f.push(o||i),!a.length)return{SheetNames:f,Sheets:l};for(var r={},d=[],p=0;p<a.length;++p)l[f[p]]?(d.push(a[p]||f[p]),r[a[p]]=l[a[p]]||l[f[p]]):(d.push(a[p]),r[a[p]]={"!ref":"A1"});return{SheetNames:d,Sheets:r}}function ci(e,t,r){var a=[{c:0,r:0},{t:"n",v:0},0,0];return r.qpro&&20768!=r.vers?(a[0].c=e.read_shift(1),a[3]=e.read_shift(1),a[0].r=e.read_shift(2),e.l+=2):(a[2]=e.read_shift(1),a[0].c=e.read_shift(2),a[0].r=e.read_shift(2)),a}function li(e,t,r){var a=e.l+t,t=ci(e,0,r);if(t[1].t="s",20768!=r.vers)return r.qpro&&e.l++,t[1].v=e.read_shift(a-e.l,"cstr"),t;e.l++;a=e.read_shift(1);return t[1].v=e.read_shift(a,"utf8"),t}function fi(e,t,r){var a=32768&t;return(a?"":"$")+(r?Xr:jr)(t=(a?e:0)+(8192<=(t&=-32769)?t-16384:t))}function hi(e){var t=[{c:0,r:0},{t:"n",v:0},0];return t[0].r=e.read_shift(2),t[3]=e[e.l++],t[0].c=e[e.l++],t}function ui(e,t){var r=hi(e),a=e.read_shift(4),n=e.read_shift(4);if(65535==(s=e.read_shift(2)))return 0===a&&3221225472===n?(r[1].t="e",r[1].v=15):0===a&&3489660928===n?(r[1].t="e",r[1].v=42):r[1].v=0,r;var e=32768&s,s=(32767&s)-16446;return r[1].v=(1-2*e)*(n*Math.pow(2,32+s)+a*Math.pow(2,s)),r}function di(e,t){var r=hi(e),e=e.read_shift(8,"f");return r[1].v=e,r}function pi(e,t){return 0==e[e.l+t-1]?e.read_shift(t,"cstr"):""}var mi,gi,bi,vi,wi=(mi=Bt("t"),gi=Bt("rPr"),bi=/<(?:\w+:)?r>/g,vi=/<\/(?:\w+:)?r>/,function(e){return e.replace(bi,"").split(vi).map(Ti).filter(function(e){return e.v})});function Ti(e){var t=e.match(mi);if(!t)return{t:"s",v:""};t={t:"s",v:wt(t[1])},e=e.match(gi);return e&&(t.s=function(e){var t={},r=e.match(ft),a=0,n=!1;if(r)for(;a!=r.length;++a){var s=dt(r[a]);switch(s[0].replace(/\w*:/g,"")){case"<condense":case"<extend":break;case"<shadow":if(!s.val)break;case"<shadow>":case"<shadow/>":t.shadow=1;break;case"</shadow>":break;case"<charset":if("1"==s.val)break;t.cp=l[parseInt(s.val,10)];break;case"<outline":if(!s.val)break;case"<outline>":case"<outline/>":t.outline=1;break;case"</outline>":break;case"<rFont":t.name=s.val;break;case"<sz":t.sz=s.val;break;case"<strike":if(!s.val)break;case"<strike>":case"<strike/>":t.strike=1;break;case"</strike>":break;case"<u":if(!s.val)break;switch(s.val){case"double":t.uval="double";break;case"singleAccounting":t.uval="single-accounting";break;case"doubleAccounting":t.uval="double-accounting"}case"<u>":case"<u/>":t.u=1;break;case"</u>":break;case"<b":if("0"==s.val)break;case"<b>":case"<b/>":t.b=1;break;case"</b>":break;case"<i":if("0"==s.val)break;case"<i>":case"<i/>":t.i=1;break;case"</i>":break;case"<color":s.rgb&&(t.color=s.rgb.slice(2,8));break;case"<color>":case"<color/>":case"</color>":break;case"<family":t.family=s.val;break;case"<family>":case"<family/>":case"</family>":break;case"<vertAlign":t.valign=s.val;break;case"<vertAlign>":case"<vertAlign/>":case"</vertAlign>":case"<scheme":break;case"<scheme>":case"<scheme/>":case"</scheme>":break;case"<extLst":case"<extLst>":case"</extLst>":break;case"<ext":n=!0;break;case"</ext>":n=!1;break;default:if(47!==s[0].charCodeAt(1)&&!n)throw new Error("Unrecognized rich format "+s[0])}}return t}(e[1])),t}var Ei,ki=(Ei=/(\r\n|\n)/g,function(e){return e.map(yi).join("")});function yi(e){var t,r,a,n=[[],e.v,[]];return e.v?(e.s&&(t=e.s,r=n[0],a=n[2],e=[],t.u&&e.push("text-decoration: underline;"),t.uval&&e.push("text-underline-style:"+t.uval+";"),t.sz&&e.push("font-size:"+t.sz+"pt;"),t.outline&&e.push("text-effect: outline;"),t.shadow&&e.push("text-shadow: auto;"),r.push('<span style="'+e.join("")+'">'),t.b&&(r.push("<b>"),a.push("</b>")),t.i&&(r.push("<i>"),a.push("</i>")),t.strike&&(r.push("<s>"),a.push("</s>")),"superscript"==(e=t.valign||"")||"super"==e?e="sup":"subscript"==e&&(e="sub"),""!=e&&(r.push("<"+e+">"),a.push("</"+e+">")),a.push("</span>")),n[0].join("")+n[1].replace(Ei,"<br/>")+n[2].join("")):""}var Si=/<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g,_i=/<(?:\w+:)?r>/,xi=/<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;function Ai(e,t){var r=!t||t.cellHTML,t={};return e?(e.match(/^\s*<(?:\w+:)?t[^>]*>/)?(t.t=wt(Mt(e.slice(e.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||"")),t.r=Mt(e),r&&(t.h=_t(t.t))):e.match(_i)&&(t.r=Mt(e),t.t=wt(Mt((e.replace(xi,"").match(Si)||[]).join("").replace(ft,""))),r&&(t.h=ki(wi(t.r)))),t):{t:""}}var Ci=/<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/,Ri=/<(?:\w+:)?(?:si|sstItem)>/g,Oi=/<\/(?:\w+:)?(?:si|sstItem)>/;var Ii=/^\s|\s$|[\t\n\r]/;function Ni(e,t){if(!t.bookSST)return"";var r=[ot];r[r.length]=Yt("sst",null,{xmlns:Qt[0],count:e.Count,uniqueCount:e.Unique});for(var a,n,s=0;s!=e.length;++s)null!=e[s]&&(n="<si>",(a=e[s]).r?n+=a.r:(n+="<t",a.t||(a.t=""),a.t.match(Ii)&&(n+=' xml:space="preserve"'),n+=">"+kt(a.t)+"</t>"),n+="</si>",r[r.length]=n);return 2<r.length&&(r[r.length]="</sst>",r[1]=r[1].replace("/>",">")),r.join("")}var Fi=function(e,t){var r=!1;return null==t&&(r=!0,t=Lr(15+4*e.t.length)),t.write_shift(1,0),ia(e.t,t),r?t.slice(0,t.l):t};function Di(e){var t,r,a=Ur();Br(a,159,(t=e,(r=r||Lr(8)).write_shift(4,t.Count),r.write_shift(4,t.Unique),r));for(var n=0;n<e.length;++n)Br(a,19,Fi(e[n]));return Br(a,160),a.end()}function Pi(e){if(void 0!==re)return re.utils.encode(_,e);for(var t=[],r=e.split(""),a=0;a<r.length;++a)t[a]=r[a].charCodeAt(0);return t}function Li(e,t){var r={};return r.Major=e.read_shift(2),r.Minor=e.read_shift(2),4<=t&&(e.l+=t-4),r}function Mi(e){var t=[];e.l+=4;for(var r=e.read_shift(4);0<r--;)t.push(function(e){for(var t=e.read_shift(4),r=e.l+t-4,t={},a=e.read_shift(4),n=[];0<a--;)n.push({t:e.read_shift(4),v:e.read_shift(0,"lpp4")});if(t.name=e.read_shift(0,"lpp4"),t.comps=n,e.l!=r)throw new Error("Bad DataSpaceMapEntry: "+e.l+" != "+r);return t}(e));return t}function Ui(e){var t,r,r=(r={},(t=e).read_shift(4),t.l+=4,r.id=t.read_shift(0,"lpp4"),r.name=t.read_shift(0,"lpp4"),r.R=Li(t,4),r.U=Li(t,4),r.W=Li(t,4),r);if(r.ename=e.read_shift(0,"8lpp4"),r.blksz=e.read_shift(4),r.cmode=e.read_shift(4),4!=e.read_shift(4))throw new Error("Bad !Primary record");return r}function Bi(e,t){var t=e.l+t,r={};r.Flags=63&e.read_shift(4),e.l+=4,r.AlgID=e.read_shift(4);var a=!1;switch(r.AlgID){case 26126:case 26127:case 26128:a=36==r.Flags;break;case 26625:a=4==r.Flags;break;case 0:a=16==r.Flags||4==r.Flags||36==r.Flags;break;default:throw"Unrecognized encryption algorithm: "+r.AlgID}if(!a)throw new Error("Encryption Flags/AlgID mismatch");return r.AlgIDHash=e.read_shift(4),r.KeySize=e.read_shift(4),r.ProviderType=e.read_shift(4),e.l+=8,r.CSPName=e.read_shift(t-e.l>>1,"utf16le"),e.l=t,r}function Wi(e,t){var r={},t=e.l+t;return e.l+=4,r.Salt=e.slice(e.l,e.l+16),e.l+=16,r.Verifier=e.slice(e.l,e.l+16),e.l+=16,e.read_shift(4),r.VerifierHash=e.slice(e.l,t),e.l=t,r}function Hi(e){var t=Li(e);switch(t.Minor){case 2:return[t.Minor,function(e){if(36!=(63&e.read_shift(4)))throw new Error("EncryptionInfo mismatch");var t=e.read_shift(4),t=Bi(e,t),e=Wi(e,e.length-e.l);return{t:"Std",h:t,v:e}}(e)];case 3:return[t.Minor,function(){throw new Error("File is password-protected: ECMA-376 Extensible")}()];case 4:return[t.Minor,function(e){var r=["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];e.l+=4;var e=e.read_shift(e.length-e.l,"utf8"),a={};return e.replace(ft,function(e){var t=dt(e);switch(pt(t[0])){case"<?xml":break;case"<encryption":case"</encryption>":break;case"<keyData":r.forEach(function(e){a[e]=t[e]});break;case"<dataIntegrity":a.encryptedHmacKey=t.encryptedHmacKey,a.encryptedHmacValue=t.encryptedHmacValue;break;case"<keyEncryptors>":case"<keyEncryptors":a.encs=[];break;case"</keyEncryptors>":break;case"<keyEncryptor":a.uri=t.uri;break;case"</keyEncryptor>":break;case"<encryptedKey":a.encs.push(t);break;default:throw t[0]}}),a}(e)]}throw new Error("ECMA-376 Encrypted file unrecognized Version: "+t.Minor)}function zi(e){var t,r=0,a=Pi(e),n=a.length+1,s=le(n);for(s[0]=a.length,t=1;t!=n;++t)s[t]=a[t-1];for(t=n-1;0<=t;--t)r=((0==(16384&r)?0:1)|r<<1&32767)^s[t];return 52811^r}var Vi,Gi,ji,$i=(Vi=[187,255,255,186,255,255,185,128,0,190,15,0,191,15,0],Gi=[57840,7439,52380,33984,4364,3600,61902,12606,6258,57657,54287,34041,10252,43370,20163],ji=[44796,19929,39858,10053,20106,40212,10761,31585,63170,64933,60267,50935,40399,11199,17763,35526,1453,2906,5812,11624,23248,885,1770,3540,7080,14160,28320,56640,55369,41139,20807,41614,21821,43642,17621,28485,56970,44341,19019,38038,14605,29210,60195,50791,40175,10751,21502,43004,24537,18387,36774,3949,7898,15796,31592,63184,47201,24803,49606,37805,14203,28406,56812,17824,35648,1697,3394,6788,13576,27152,43601,17539,35078,557,1114,2228,4456,30388,60776,51953,34243,7079,14158,28316,14128,28256,56512,43425,17251,34502,7597,13105,26210,52420,35241,883,1766,3532,4129,8258,16516,33032,4657,9314,18628],function(e){for(var t,r,a=Pi(e),n=function(e){for(var t=Gi[e.length-1],r=104,a=e.length-1;0<=a;--a)for(var n=e[a],s=0;7!=s;++s)64&n&&(t^=ji[r]),n*=2,--r;return t}(a),s=a.length,i=le(16),o=0;16!=o;++o)i[o]=0;for(1==(1&s)&&(t=n>>8,i[s]=Xi(Vi[0],t),--s,t=255&n,e=a[a.length-1],i[s]=Xi(e,t));0<s;)t=n>>8,i[--s]=Xi(a[s],t),t=255&n,i[--s]=Xi(a[s],t);for(r=(s=15)-a.length;0<r;)t=n>>8,i[s]=Xi(Vi[r],t),--r,t=255&n,i[--s]=Xi(a[s],t),--s,--r;return i});function Xi(e,t){return 255&((t=e^t)/2|128*t)}var Yi=function(e){var t=0,r=$i(e);return function(e){e=function(e,t,r,a,n){var s,i;for(n=n||t,a=a||$i(e),s=0;s!=t.length;++s)i=t[s],i=255&((i^=a[r])>>5|i<<3),n[s]=i,++r;return[n,r,a]}("",e,t,r);return t=e[1],e[0]}};function Ki(e,t,r){r=r||{};return r.Info=e.read_shift(2),e.l-=2,1===r.Info?r.Data=function(e){var t={},r=t.EncryptionVersionInfo=Li(e,4);if(1!=r.Major||1!=r.Minor)throw"unrecognized version code "+r.Major+" : "+r.Minor;return t.Salt=e.read_shift(16),t.EncryptedVerifier=e.read_shift(16),t.EncryptedVerifierHash=e.read_shift(16),t}(e):r.Data=function(e,t){var r={},a=r.EncryptionVersionInfo=Li(e,4);if(t-=4,2!=a.Minor)throw new Error("unrecognized minor version code: "+a.Minor);if(4<a.Major||a.Major<2)throw new Error("unrecognized major version code: "+a.Major);return r.Flags=e.read_shift(4),t-=4,a=e.read_shift(4),t-=4,r.EncryptionHeader=Bi(e,a),t-=a,r.EncryptionVerifier=Wi(e,t),r}(e,t),r}var Ji={to_workbook:function(e,t){return ta(qi(e,t),t)},to_sheet:qi,from_sheet:function(e){for(var t=["{\\rtf1\\ansi"],r=Zr(e["!ref"]),a=Array.isArray(e),n=r.s.r;n<=r.e.r;++n){t.push("\\trowd\\trautofit1");for(var s=r.s.c;s<=r.e.c;++s)t.push("\\cellx"+(s+1));for(t.push("\\pard\\intbl"),s=r.s.c;s<=r.e.c;++s){var i=Kr({r:n,c:s});(i=a?(e[n]||[])[s]:e[i])&&(null!=i.v||i.f&&!i.F)&&(t.push(" "+(i.w||(ea(i),i.w))),t.push("\\cell"))}t.push("\\pard\\intbl\\row")}return t.join("")+"}"}};function qi(e,t){switch(t.type){case"base64":return Zi(te(e),t);case"binary":return Zi(e,t);case"buffer":return Zi(se&&Buffer.isBuffer(e)?e.toString("binary"):i(e),t);case"array":return Zi(ze(e),t)}throw new Error("Unrecognized type "+t.type)}function Zi(e,t){var i=(t||{}).dense?[]:{},e=e.match(/\\trowd.*?\\row\b/g);if(!e.length)throw new Error("RTF missing table");var o={s:{c:0,r:0},e:{c:0,r:e.length-1}};return e.forEach(function(e,t){Array.isArray(i)&&(i[t]=[]);for(var r,a=/\\\w+\b/g,n=0,s=-1;r=a.exec(e);)"\\cell"===r[0]&&(++s,(r=" "==(r=e.slice(n,a.lastIndex-r[0].length))[0]?r.slice(1):r).length&&(r={v:r,t:"s"},Array.isArray(i)?i[t][s]=r:i[Kr({r:t,c:s})]=r)),n=a.lastIndex;s>o.e.c&&(o.e.c=s)}),i["!ref"]=qr(o),i}function Qi(e){for(var t=0,r=1;3!=t;++t)r=256*r+(255<e[t]?255:e[t]<0?0:e[t]);return r.toString(16).toUpperCase().slice(1)}function eo(e,t){if(0===t)return e;e=function(e){var t=e[0]/255,r=e[1]/255,a=e[2]/255,n=Math.max(t,r,a),s=Math.min(t,r,a),i=n-s;if(0==i)return[0,0,t];var o=0,e=0,e=i/(1<(s=n+s)?2-s:s);switch(n){case t:o=((r-a)/i+6)%6;break;case r:o=(a-t)/i+2;break;case a:o=(t-r)/i+4}return[o/6,e,s/2]}((e=(e=e).slice("#"===e[0]?1:0).slice(0,6),[parseInt(e.slice(0,2),16),parseInt(e.slice(2,4),16),parseInt(e.slice(4,6),16)]));return e[2]=t<0?e[2]*(1+t):1-(1-e[2])*(1-t),Qi(function(e){var t,r=e[0],a=e[1],e=e[2],n=2*a*(e<.5?e:1-e),s=[e=e-n/2,e,e],i=6*r;if(0!==a)switch(0|i){case 0:case 6:t=n*i,s[0]+=n,s[1]+=t;break;case 1:t=n*(2-i),s[0]+=t,s[1]+=n;break;case 2:t=n*(i-2),s[1]+=n,s[2]+=t;break;case 3:t=n*(4-i),s[1]+=t,s[2]+=n;break;case 4:t=n*(i-4),s[2]+=n,s[0]+=t;break;case 5:t=n*(6-i),s[2]+=t,s[0]+=n}for(var o=0;3!=o;++o)s[o]=Math.round(255*s[o]);return s}(e))}var to=6,ro=15,ao=1,no=to;function so(e){return Math.floor((e+Math.round(128/no)/256)*no)}function io(e){return Math.floor((e-5)/no*100+.5)/100}function oo(e){return Math.round((e*no+5)/no*256)/256}function co(e){return oo(io(so(e)))}function lo(e){var t=Math.abs(e-co(e)),r=no;if(.005<t)for(no=ao;no<ro;++no)Math.abs(e-co(e))<=t&&(t=Math.abs(e-co(e)),r=no);no=r}function fo(e){e.width?(e.wpx=so(e.width),e.wch=io(e.wpx),e.MDW=no):e.wpx?(e.wch=io(e.wpx),e.width=oo(e.wch),e.MDW=no):"number"==typeof e.wch&&(e.width=oo(e.wch),e.wpx=so(e.width),e.MDW=no),e.customWidth&&delete e.customWidth}var ho=96;function uo(e){return 96*e/ho}function po(e){return e*ho/96}var mo={None:"none",Solid:"solid",Gray50:"mediumGray",Gray75:"darkGray",Gray25:"lightGray",HorzStripe:"darkHorizontal",VertStripe:"darkVertical",ReverseDiagStripe:"darkDown",DiagStripe:"darkUp",DiagCross:"darkGrid",ThickDiagCross:"darkTrellis",ThinHorzStripe:"lightHorizontal",ThinVertStripe:"lightVertical",ThinReverseDiagStripe:"lightDown",ThinHorzCross:"lightGrid"};var go=["numFmtId","fillId","fontId","borderId","xfId"],bo=["applyAlignment","applyBorder","applyFill","applyFont","applyNumberFormat","applyProtection","pivotButton","quotePrefix"];var vo,wo,To,Eo,ko,yo,So=(vo=/<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/,wo=/<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/,To=/<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/,Eo=/<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/,ko=/<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/,function(e,t,r){var a,n,s,i,o,c={};return e&&((a=(e=e.replace(/<!--([\s\S]*?)-->/gm,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"")).match(vo))&&function(e,t,r){t.NumberFmt=[];for(var a=Re(me),n=0;n<a.length;++n)t.NumberFmt[a[n]]=me[a[n]];var s=e[0].match(ft);if(s)for(n=0;n<s.length;++n){var i=dt(s[n]);switch(pt(i[0])){case"<numFmts":case"</numFmts>":case"<numFmts/>":case"<numFmts>":break;case"<numFmt":var o=wt(Mt(i.formatCode)),c=parseInt(i.numFmtId,10);if(t.NumberFmt[c]=o,0<c){if(392<c){for(c=392;60<c&&null!=t.NumberFmt[c];--c);t.NumberFmt[c]=o}we(o,c)}break;case"</numFmt>":break;default:if(r.WTF)throw new Error("unrecognized "+i[0]+" in numFmts")}}}(a,c,r),(a=e.match(Eo))&&function(e,a,n,s){a.Fonts=[];var i={},o=!1;(e[0].match(ft)||[]).forEach(function(e){var t,r=dt(e);switch(pt(r[0])){case"<fonts":case"<fonts>":case"</fonts>":break;case"<font":case"<font>":break;case"</font>":case"<font/>":a.Fonts.push(i),i={};break;case"<name":r.val&&(i.name=Mt(r.val));break;case"<name/>":case"</name>":break;case"<b":i.bold=r.val?Rt(r.val):1;break;case"<b/>":i.bold=1;break;case"<i":i.italic=r.val?Rt(r.val):1;break;case"<i/>":i.italic=1;break;case"<u":switch(r.val){case"none":i.underline=0;break;case"single":i.underline=1;break;case"double":i.underline=2;break;case"singleAccounting":i.underline=33;break;case"doubleAccounting":i.underline=34}break;case"<u/>":i.underline=1;break;case"<strike":i.strike=r.val?Rt(r.val):1;break;case"<strike/>":i.strike=1;break;case"<outline":i.outline=r.val?Rt(r.val):1;break;case"<outline/>":i.outline=1;break;case"<shadow":i.shadow=r.val?Rt(r.val):1;break;case"<shadow/>":i.shadow=1;break;case"<condense":i.condense=r.val?Rt(r.val):1;break;case"<condense/>":i.condense=1;break;case"<extend":i.extend=r.val?Rt(r.val):1;break;case"<extend/>":i.extend=1;break;case"<sz":r.val&&(i.sz=+r.val);break;case"<sz/>":case"</sz>":break;case"<vertAlign":r.val&&(i.vertAlign=r.val);break;case"<vertAlign/>":case"</vertAlign>":break;case"<family":r.val&&(i.family=parseInt(r.val,10));break;case"<family/>":case"</family>":break;case"<scheme":r.val&&(i.scheme=r.val);break;case"<scheme/>":case"</scheme>":break;case"<charset":if("1"==r.val)break;r.codepage=l[parseInt(r.val,10)];break;case"<color":i.color||(i.color={}),r.auto&&(i.color.auto=Rt(r.auto)),r.rgb?i.color.rgb=r.rgb.slice(-6):r.indexed?(i.color.index=parseInt(r.indexed,10),t=Ba[i.color.index],t=(t=81==i.color.index?Ba[1]:t)||Ba[1],i.color.rgb=t[0].toString(16)+t[1].toString(16)+t[2].toString(16)):r.theme&&(i.color.theme=parseInt(r.theme,10),r.tint&&(i.color.tint=parseFloat(r.tint)),r.theme&&n.themeElements&&n.themeElements.clrScheme&&(i.color.rgb=eo(n.themeElements.clrScheme[i.color.theme].rgb,i.color.tint||0)));break;case"<color/>":case"</color>":break;case"<AlternateContent":o=!0;break;case"</AlternateContent>":o=!1;break;case"<extLst":case"<extLst>":case"</extLst>":break;case"<ext":o=!0;break;case"</ext>":o=!1;break;default:if(s&&s.WTF&&!o)throw new Error("unrecognized "+r[0]+" in fonts")}})}(a,c,t,r),(a=e.match(To))&&function(e,r,a){r.Fills=[];var n={},s=!1;(e[0].match(ft)||[]).forEach(function(e){var t=dt(e);switch(pt(t[0])){case"<fills":case"<fills>":case"</fills>":break;case"<fill>":case"<fill":case"<fill/>":n={},r.Fills.push(n);break;case"</fill>":case"<gradientFill>":break;case"<gradientFill":case"</gradientFill>":r.Fills.push(n),n={};break;case"<patternFill":case"<patternFill>":t.patternType&&(n.patternType=t.patternType);break;case"<patternFill/>":case"</patternFill>":break;case"<bgColor":n.bgColor||(n.bgColor={}),t.indexed&&(n.bgColor.indexed=parseInt(t.indexed,10)),t.theme&&(n.bgColor.theme=parseInt(t.theme,10)),t.tint&&(n.bgColor.tint=parseFloat(t.tint)),t.rgb&&(n.bgColor.rgb=t.rgb.slice(-6));break;case"<bgColor/>":case"</bgColor>":break;case"<fgColor":n.fgColor||(n.fgColor={}),t.theme&&(n.fgColor.theme=parseInt(t.theme,10)),t.tint&&(n.fgColor.tint=parseFloat(t.tint)),null!=t.rgb&&(n.fgColor.rgb=t.rgb.slice(-6));break;case"<fgColor/>":case"</fgColor>":break;case"<stop":case"<stop/>":case"</stop>":break;case"<color":case"<color/>":case"</color>":break;case"<extLst":case"<extLst>":case"</extLst>":break;case"<ext":s=!0;break;case"</ext>":s=!1;break;default:if(a&&a.WTF&&!s)throw new Error("unrecognized "+t[0]+" in fills")}})}(a,c,r),(a=e.match(ko))&&function(e,r,a){r.Borders=[];var n={},s=!1;(e[0].match(ft)||[]).forEach(function(e){var t=dt(e);switch(pt(t[0])){case"<borders":case"<borders>":case"</borders>":break;case"<border":case"<border>":case"<border/>":n={},t.diagonalUp&&(n.diagonalUp=Rt(t.diagonalUp)),t.diagonalDown&&(n.diagonalDown=Rt(t.diagonalDown)),r.Borders.push(n);break;case"</border>":case"<left/>":break;case"<left":case"<left>":case"</left>":case"<right/>":break;case"<right":case"<right>":case"</right>":case"<top/>":break;case"<top":case"<top>":case"</top>":case"<bottom/>":break;case"<bottom":case"<bottom>":case"</bottom>":break;case"<diagonal":case"<diagonal>":case"<diagonal/>":case"</diagonal>":break;case"<horizontal":case"<horizontal>":case"<horizontal/>":case"</horizontal>":break;case"<vertical":case"<vertical>":case"<vertical/>":case"</vertical>":break;case"<start":case"<start>":case"<start/>":case"</start>":break;case"<end":case"<end>":case"<end/>":case"</end>":break;case"<color":case"<color>":break;case"<color/>":case"</color>":break;case"<extLst":case"<extLst>":case"</extLst>":break;case"<ext":s=!0;break;case"</ext>":s=!1;break;default:if(a&&a.WTF&&!s)throw new Error("unrecognized "+t[0]+" in borders")}})}(a,c,r),(a=e.match(wo))&&(a=a,s=r,o=!((n=c).CellXf=[]),(a[0].match(ft)||[]).forEach(function(e){var t=dt(e),r=0;switch(pt(t[0])){case"<cellXfs":case"<cellXfs>":case"<cellXfs/>":case"</cellXfs>":break;case"<xf":case"<xf/>":for(delete(i=t)[0],r=0;r<go.length;++r)i[go[r]]&&(i[go[r]]=parseInt(i[go[r]],10));for(r=0;r<bo.length;++r)i[bo[r]]&&(i[bo[r]]=Rt(i[bo[r]]));if(n.NumberFmt&&392<i.numFmtId)for(r=392;60<r;--r)if(n.NumberFmt[i.numFmtId]==n.NumberFmt[r]){i.numFmtId=r;break}n.CellXf.push(i);break;case"</xf>":break;case"<alignment":case"<alignment/>":var a={};t.vertical&&(a.vertical=t.vertical),t.horizontal&&(a.horizontal=t.horizontal),null!=t.textRotation&&(a.textRotation=t.textRotation),t.indent&&(a.indent=t.indent),t.wrapText&&(a.wrapText=Rt(t.wrapText)),i.alignment=a;break;case"</alignment>":case"<protection":break;case"</protection>":case"<protection/>":break;case"<AlternateContent":o=!0;break;case"</AlternateContent>":o=!1;break;case"<extLst":case"<extLst>":case"</extLst>":break;case"<ext":o=!0;break;case"</ext>":o=!1;break;default:if(s&&s.WTF&&!o)throw new Error("unrecognized "+t[0]+" in cellXfs")}}))),c});function _o(e,t){if(void 0!==yo)return yo.toXml();var r,a,n,s,i=[ot,Yt("styleSheet",null,{xmlns:Qt[0],"xmlns:vt":Zt.vt})];return e.SSF&&null!=(a=e.SSF,n=["<numFmts>"],[[5,8],[23,26],[41,44],[50,392]].forEach(function(e){for(var t=e[0];t<=e[1];++t)null!=a[t]&&(n[n.length]=Yt("numFmt",null,{numFmtId:t,formatCode:kt(a[t])}))}),r=1===n.length?"":(n[n.length]="</numFmts>",n[0]=Yt("numFmts",null,{count:n.length-2}).replace("/>",">"),n.join("")))&&(i[i.length]=r),i[i.length]='<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>',i[i.length]='<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>',i[i.length]='<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>',i[i.length]='<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>',t=t.cellXfs,(s=[])[s.length]="<cellXfs/>",t.forEach(function(e){s[s.length]=Yt("xf",null,e)}),s[s.length]="</cellXfs>",(r=2===s.length?"":(s[0]=Yt("cellXfs",null,{count:s.length-2}).replace("/>",">"),s.join("")))&&(i[i.length]=r),i[i.length]='<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>',i[i.length]='<dxfs count="0"/>',i[i.length]='<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>',2<i.length&&(i[i.length]="</styleSheet>",i[1]=i[1].replace("/>",">")),i.join("")}function xo(e,t){var r;(t=t||Lr(153)).write_shift(2,20*e.sz),r=e,a=(a=t)||Lr(2),r=(r.italic?2:0)|(r.strike?8:0)|(r.outline?16:0)|(r.shadow?32:0)|(r.condense?64:0)|(r.extend?128:0),a.write_shift(1,r),a.write_shift(1,0),t.write_shift(2,e.bold?700:400);var a=0;"superscript"==e.vertAlign?a=1:"subscript"==e.vertAlign&&(a=2),t.write_shift(2,a),t.write_shift(1,e.underline||0),t.write_shift(1,e.family||0),t.write_shift(1,e.charset||0),t.write_shift(1,0),Ca(e.color,t);a=0;return"major"==e.scheme&&(a=1),"minor"==e.scheme&&(a=2),t.write_shift(1,a),ia(e.name,t),t.length>t.l?t.slice(0,t.l):t}var Ao,Co=["none","solid","mediumGray","darkGray","lightGray","darkHorizontal","darkVertical","darkDown","darkUp","darkGrid","darkTrellis","lightHorizontal","lightVertical","lightDown","lightUp","lightGrid","lightTrellis","gray125","gray0625"],Ro=Pr;function Oo(e,t){t=t||Lr(84);e=(Ao=Ao||Ie(Co))[e.patternType];null==e&&(e=40),t.write_shift(4,e);var r=0;if(40!=e)for(Ca({auto:1},t),Ca({auto:1},t);r<12;++r)t.write_shift(4,0);else{for(;r<4;++r)t.write_shift(4,0);for(;r<12;++r)t.write_shift(4,0)}return t.length>t.l?t.slice(0,t.l):t}function Io(e,t,r){(r=r||Lr(16)).write_shift(2,t||0),r.write_shift(2,e.numFmtId||0),r.write_shift(2,0),r.write_shift(2,0),r.write_shift(2,0),r.write_shift(1,0),r.write_shift(1,0);return r.write_shift(1,0),r.write_shift(1,0),r.write_shift(1,0),r.write_shift(1,0),r}function No(e,t){return(t=t||Lr(10)).write_shift(1,0),t.write_shift(1,0),t.write_shift(4,0),t.write_shift(4,0),t}r=Pr;function Fo(s,i){var r;i&&(r=0,[[5,8],[23,26],[41,44],[50,392]].forEach(function(e){for(var t=e[0];t<=e[1];++t)null!=i[t]&&++r}),0!=r&&(Br(s,615,na(r)),[[5,8],[23,26],[41,44],[50,392]].forEach(function(e){for(var t,r,a,n=e[0];n<=e[1];++n)null!=i[n]&&Br(s,44,(t=n,r=i[n],(a=(a=void 0)||Lr(6+4*r.length)).write_shift(2,t),ia(r,a),r=a.length>a.l?a.slice(0,a.l):a,null==a.l&&(a.l=a.length),r))}),Br(s,616)))}function Do(e){var t;Br(e,613,na(1)),Br(e,46,((t=t||Lr(51)).write_shift(1,0),No(0,t),No(0,t),No(0,t),No(0,t),No(0,t),t.length>t.l?t.slice(0,t.l):t)),Br(e,614)}function Po(e){var t,r;Br(e,619,na(1)),Br(e,48,(t={xfId:0,builtinId:0,name:"Normal"},(r=r||Lr(52)).write_shift(4,t.xfId),r.write_shift(2,1),r.write_shift(1,+t.builtinId),r.write_shift(1,0),ba(t.name||"",r),r.length>r.l?r.slice(0,r.l):r)),Br(e,620)}function Lo(e){var t,r,a,n;Br(e,508,(t=0,r="TableStyleMedium9",a="PivotStyleMedium4",(n=Lr(2052)).write_shift(4,t),ba(r,n),ba(a,n),n.length>n.l?n.slice(0,n.l):n)),Br(e,509)}function Mo(e,t){var r,a=Ur();return Br(a,278),Fo(a,e.SSF),Br(e=a,611,na(1)),Br(e,43,xo({sz:12,color:{theme:1},name:"Calibri",family:2,scheme:"minor"})),Br(e,612),Br(e=a,603,na(2)),Br(e,45,Oo({patternType:"none"})),Br(e,45,Oo({patternType:"gray125"})),Br(e,604),Do(a),Br(e=a,626,na(1)),Br(e,47,Io({numFmtId:0,fontId:0,fillId:0,borderId:0},65535)),Br(e,627),r=a,t=t.cellXfs,Br(r,617,na(t.length)),t.forEach(function(e){Br(r,47,Io(e,0))}),Br(r,618),Po(a),Br(t=a,505,na(0)),Br(t,506),Lo(a),Br(a,279),a.end()}var Uo=["</a:lt1>","</a:dk1>","</a:lt2>","</a:dk2>","</a:accent1>","</a:accent2>","</a:accent3>","</a:accent4>","</a:accent5>","</a:accent6>","</a:hlink>","</a:folHlink>"];function Bo(e,r,a){r.themeElements.clrScheme=[];var n={};(e[0].match(ft)||[]).forEach(function(e){var t=dt(e);switch(t[0]){case"<a:clrScheme":case"</a:clrScheme>":break;case"<a:srgbClr":n.rgb=t.val;break;case"<a:sysClr":n.rgb=t.lastClr;break;case"<a:dk1>":case"</a:dk1>":case"<a:lt1>":case"</a:lt1>":case"<a:dk2>":case"</a:dk2>":case"<a:lt2>":case"</a:lt2>":case"<a:accent1>":case"</a:accent1>":case"<a:accent2>":case"</a:accent2>":case"<a:accent3>":case"</a:accent3>":case"<a:accent4>":case"</a:accent4>":case"<a:accent5>":case"</a:accent5>":case"<a:accent6>":case"</a:accent6>":case"<a:hlink>":case"</a:hlink>":case"<a:folHlink>":case"</a:folHlink>":"/"===t[0].charAt(1)?(r.themeElements.clrScheme[Uo.indexOf(t[0])]=n,n={}):n.name=t[0].slice(3,t[0].length-1);break;default:if(a&&a.WTF)throw new Error("Unrecognized "+t[0]+" in clrScheme")}})}function Wo(){}function Ho(){}var zo=/<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/,Vo=/<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/,Go=/<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;var jo=/<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;function $o(e,t){var r,a,n,s,i,o={};if(!(r=(e=!e||0===e.length?Xo():e).match(jo)))throw new Error("themeElements not found in theme");return a=r[0],s=t,(n=o).themeElements={},[["clrScheme",zo,Bo],["fontScheme",Vo,Wo],["fmtScheme",Go,Ho]].forEach(function(e){if(!(i=a.match(e[1])))throw new Error(e[0]+" not found in themeElements");e[2](i,n,s)}),o.raw=e,o}function Xo(e,t){if(t&&t.themeXLSX)return t.themeXLSX;if(e&&"string"==typeof e.raw)return e.raw;e=[ot];return e[e.length]='<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">',e[e.length]="<a:themeElements>",e[e.length]='<a:clrScheme name="Office">',e[e.length]='<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>',e[e.length]='<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>',e[e.length]='<a:dk2><a:srgbClr val="1F497D"/></a:dk2>',e[e.length]='<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>',e[e.length]='<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>',e[e.length]='<a:accent2><a:srgbClr val="C0504D"/></a:accent2>',e[e.length]='<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>',e[e.length]='<a:accent4><a:srgbClr val="8064A2"/></a:accent4>',e[e.length]='<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>',e[e.length]='<a:accent6><a:srgbClr val="F79646"/></a:accent6>',e[e.length]='<a:hlink><a:srgbClr val="0000FF"/></a:hlink>',e[e.length]='<a:folHlink><a:srgbClr val="800080"/></a:folHlink>',e[e.length]="</a:clrScheme>",e[e.length]='<a:fontScheme name="Office">',e[e.length]="<a:majorFont>",e[e.length]='<a:latin typeface="Cambria"/>',e[e.length]='<a:ea typeface=""/>',e[e.length]='<a:cs typeface=""/>',e[e.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>',e[e.length]='<a:font script="Hang" typeface="맑은 고딕"/>',e[e.length]='<a:font script="Hans" typeface="宋体"/>',e[e.length]='<a:font script="Hant" typeface="新細明體"/>',e[e.length]='<a:font script="Arab" typeface="Times New Roman"/>',e[e.length]='<a:font script="Hebr" typeface="Times New Roman"/>',e[e.length]='<a:font script="Thai" typeface="Tahoma"/>',e[e.length]='<a:font script="Ethi" typeface="Nyala"/>',e[e.length]='<a:font script="Beng" typeface="Vrinda"/>',e[e.length]='<a:font script="Gujr" typeface="Shruti"/>',e[e.length]='<a:font script="Khmr" typeface="MoolBoran"/>',e[e.length]='<a:font script="Knda" typeface="Tunga"/>',e[e.length]='<a:font script="Guru" typeface="Raavi"/>',e[e.length]='<a:font script="Cans" typeface="Euphemia"/>',e[e.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>',e[e.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>',e[e.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>',e[e.length]='<a:font script="Thaa" typeface="MV Boli"/>',e[e.length]='<a:font script="Deva" typeface="Mangal"/>',e[e.length]='<a:font script="Telu" typeface="Gautami"/>',e[e.length]='<a:font script="Taml" typeface="Latha"/>',e[e.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>',e[e.length]='<a:font script="Orya" typeface="Kalinga"/>',e[e.length]='<a:font script="Mlym" typeface="Kartika"/>',e[e.length]='<a:font script="Laoo" typeface="DokChampa"/>',e[e.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>',e[e.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>',e[e.length]='<a:font script="Viet" typeface="Times New Roman"/>',e[e.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>',e[e.length]='<a:font script="Geor" typeface="Sylfaen"/>',e[e.length]="</a:majorFont>",e[e.length]="<a:minorFont>",e[e.length]='<a:latin typeface="Calibri"/>',e[e.length]='<a:ea typeface=""/>',e[e.length]='<a:cs typeface=""/>',e[e.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>',e[e.length]='<a:font script="Hang" typeface="맑은 고딕"/>',e[e.length]='<a:font script="Hans" typeface="宋体"/>',e[e.length]='<a:font script="Hant" typeface="新細明體"/>',e[e.length]='<a:font script="Arab" typeface="Arial"/>',e[e.length]='<a:font script="Hebr" typeface="Arial"/>',e[e.length]='<a:font script="Thai" typeface="Tahoma"/>',e[e.length]='<a:font script="Ethi" typeface="Nyala"/>',e[e.length]='<a:font script="Beng" typeface="Vrinda"/>',e[e.length]='<a:font script="Gujr" typeface="Shruti"/>',e[e.length]='<a:font script="Khmr" typeface="DaunPenh"/>',e[e.length]='<a:font script="Knda" typeface="Tunga"/>',e[e.length]='<a:font script="Guru" typeface="Raavi"/>',e[e.length]='<a:font script="Cans" typeface="Euphemia"/>',e[e.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>',e[e.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>',e[e.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>',e[e.length]='<a:font script="Thaa" typeface="MV Boli"/>',e[e.length]='<a:font script="Deva" typeface="Mangal"/>',e[e.length]='<a:font script="Telu" typeface="Gautami"/>',e[e.length]='<a:font script="Taml" typeface="Latha"/>',e[e.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>',e[e.length]='<a:font script="Orya" typeface="Kalinga"/>',e[e.length]='<a:font script="Mlym" typeface="Kartika"/>',e[e.length]='<a:font script="Laoo" typeface="DokChampa"/>',e[e.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>',e[e.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>',e[e.length]='<a:font script="Viet" typeface="Arial"/>',e[e.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>',e[e.length]='<a:font script="Geor" typeface="Sylfaen"/>',e[e.length]="</a:minorFont>",e[e.length]="</a:fontScheme>",e[e.length]='<a:fmtScheme name="Office">',e[e.length]="<a:fillStyleLst>",e[e.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>',e[e.length]='<a:gradFill rotWithShape="1">',e[e.length]="<a:gsLst>",e[e.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>',e[e.length]='<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>',e[e.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>',e[e.length]="</a:gsLst>",e[e.length]='<a:lin ang="16200000" scaled="1"/>',e[e.length]="</a:gradFill>",e[e.length]='<a:gradFill rotWithShape="1">',e[e.length]="<a:gsLst>",e[e.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>',e[e.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>',e[e.length]="</a:gsLst>",e[e.length]='<a:lin ang="16200000" scaled="0"/>',e[e.length]="</a:gradFill>",e[e.length]="</a:fillStyleLst>",e[e.length]="<a:lnStyleLst>",e[e.length]='<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>',e[e.length]='<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>',e[e.length]='<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>',e[e.length]="</a:lnStyleLst>",e[e.length]="<a:effectStyleLst>",e[e.length]="<a:effectStyle>",e[e.length]="<a:effectLst>",e[e.length]='<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>',e[e.length]="</a:effectLst>",e[e.length]="</a:effectStyle>",e[e.length]="<a:effectStyle>",e[e.length]="<a:effectLst>",e[e.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>',e[e.length]="</a:effectLst>",e[e.length]="</a:effectStyle>",e[e.length]="<a:effectStyle>",e[e.length]="<a:effectLst>",e[e.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>',e[e.length]="</a:effectLst>",e[e.length]='<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>',e[e.length]='<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>',e[e.length]="</a:effectStyle>",e[e.length]="</a:effectStyleLst>",e[e.length]="<a:bgFillStyleLst>",e[e.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>',e[e.length]='<a:gradFill rotWithShape="1">',e[e.length]="<a:gsLst>",e[e.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>',e[e.length]='<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>',e[e.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>',e[e.length]="</a:gsLst>",e[e.length]='<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>',e[e.length]="</a:gradFill>",e[e.length]='<a:gradFill rotWithShape="1">',e[e.length]="<a:gsLst>",e[e.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>',e[e.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>',e[e.length]="</a:gsLst>",e[e.length]='<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>',e[e.length]="</a:gradFill>",e[e.length]="</a:bgFillStyleLst>",e[e.length]="</a:fmtScheme>",e[e.length]="</a:themeElements>",e[e.length]="<a:objectDefaults>",e[e.length]="<a:spDef>",e[e.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>',e[e.length]="</a:spDef>",e[e.length]="<a:lnDef>",e[e.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>',e[e.length]="</a:lnDef>",e[e.length]="</a:objectDefaults>",e[e.length]="<a:extraClrSchemeLst/>",e[e.length]="</a:theme>",e.join("")}function Yo(e){var t={};switch(t.xclrType=e.read_shift(2),t.nTintShade=e.read_shift(2),t.xclrType){case 0:e.l+=4;break;case 1:t.xclrValue=Pr(e,4);break;case 2:t.xclrValue=Gn(e);break;case 3:t.xclrValue=e.read_shift(4);break;case 4:e.l+=4}return e.l+=8,t}function Ko(e){var t=e.read_shift(2),r=e.read_shift(2)-4,a=[t];switch(t){case 4:case 5:case 7:case 8:case 9:case 10:case 11:case 13:a[1]=Yo(e);break;case 6:a[1]=Pr(e,r);break;case 14:case 15:a[1]=e.read_shift(1==r?1:2);break;default:throw new Error("Unrecognized ExtProp type: "+t+" "+r)}return a}function Jo(){var e,t,r,a=Ur();return Br(a,332),Br(a,334,na(1)),Br(a,335,((r=Lr(12+2*(t={name:"XLDAPR",version:12e4,flags:3496657072}).name.length)).write_shift(4,t.flags),r.write_shift(4,t.version),ia(t.name,r),r.slice(0,r.l))),Br(a,336),Br(a,339,(e=1,(r=Lr(8+2*(t="XLDAPR").length)).write_shift(4,e),ia(t,r),r.slice(0,r.l))),Br(a,52),Br(a,35,na(514)),Br(a,4096,na(0)),Br(a,4097,Fn(1)),Br(a,36),Br(a,53),Br(a,340),Br(a,337,(e=1,t=!0,(r=Lr(8)).write_shift(4,e),r.write_shift(4,t?1:0),r)),Br(a,51,function(e){var t=Lr(4+8*e.length);t.write_shift(4,e.length);for(var r=0;r<e.length;++r)t.write_shift(4,e[r][0]),t.write_shift(4,e[r][1]);return t}([[1,0]])),Br(a,338),Br(a,333),a.end()}function qo(){var e=[ot];return e.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>'),e.join("")}var Zo=1024;function Qo(e,t){for(var r=[21600,21600],a=["m0,0l0",r[1],r[0],r[1],r[0],"0xe"].join(","),n=[Yt("xml",null,{"xmlns:v":er.v,"xmlns:o":er.o,"xmlns:x":er.x,"xmlns:mv":er.mv}).replace(/\/>/,">"),Yt("o:shapelayout",Yt("o:idmap",null,{"v:ext":"edit",data:e}),{"v:ext":"edit"}),Yt("v:shapetype",[Yt("v:stroke",null,{joinstyle:"miter"}),Yt("v:path",null,{gradientshapeok:"t","o:connecttype":"rect"})].join(""),{id:"_x0000_t202","o:spt":202,coordsize:r.join(","),path:a})];Zo<1e3*e;)Zo+=1e3;return t.forEach(function(e){var t=Yr(e[0]),r={color2:"#BEFF82",type:"gradient"};"gradient"==r.type&&(r.angle="-180");var a="gradient"==r.type?Yt("o:fill",null,{type:"gradientUnscaled","v:ext":"view"}):null,r=Yt("v:fill",a,r);++Zo,n=n.concat(["<v:shape"+Xt({id:"_x0000_s"+Zo,type:"#_x0000_t202",style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10"+(e[1].hidden?";visibility:hidden":""),fillcolor:"#ECFAD4",strokecolor:"#edeaa1"})+">",r,Yt("v:shadow",null,{on:"t",obscured:"t"}),Yt("v:path",null,{"o:connecttype":"none"}),'<v:textbox><div style="text-align:left"></div></v:textbox>','<x:ClientData ObjectType="Note">',"<x:MoveWithCells/>","<x:SizeWithCells/>",$t("x:Anchor",[t.c+1,0,t.r+1,0,t.c+3,20,t.r+5,20].join(",")),$t("x:AutoFill","False"),$t("x:Row",String(t.r)),$t("x:Column",String(t.c)),e[1].hidden?"":"<x:Visible/>","</x:ClientData>","</v:shape>"])}),n.push("</xml>"),n.join("")}function ec(s,e,i,o){var c,l=Array.isArray(s);e.forEach(function(e){var t,r=Yr(e.ref);(c=l?(s[r.r]||(s[r.r]=[]),s[r.r][r.c]):s[e.ref])||(c={t:"z"},l?s[r.r][r.c]=c:s[e.ref]=c,(t=Zr(s["!ref"]||"BDWGO1000001:A1")).s.r>r.r&&(t.s.r=r.r),t.e.r<r.r&&(t.e.r=r.r),t.s.c>r.c&&(t.s.c=r.c),t.e.c<r.c&&(t.e.c=r.c),(t=qr(t))!==s["!ref"]&&(s["!ref"]=t)),c.c||(c.c=[]);var a={a:e.author,t:e.t,r:e.r,T:i};e.h&&(a.h=e.h);for(var n=c.c.length-1;0<=n;--n){if(!i&&c.c[n].T)return;i&&!c.c[n].T&&c.c.splice(n,1)}if(i&&o)for(n=0;n<o.length;++n)if(a.a==o[n].id){a.a=o[n].name||a.a;break}c.c.push(a)})}function tc(e){var s=[ot,Yt("comments",null,{xmlns:Qt[0]})],i=[];return s.push("<authors>"),e.forEach(function(e){e[1].forEach(function(e){var t=kt(e.a);-1==i.indexOf(t)&&(i.push(t),s.push("<author>"+t+"</author>")),e.T&&e.ID&&-1==i.indexOf("tc="+e.ID)&&(i.push("tc="+e.ID),s.push("<author>tc="+e.ID+"</author>"))})}),0==i.length&&(i.push("SheetJ5"),s.push("<author>SheetJ5</author>")),s.push("</authors>"),s.push("<commentList>"),e.forEach(function(e){var t=0,r=[];if(e[1][0]&&e[1][0].T&&e[1][0].ID?t=i.indexOf("tc="+e[1][0].ID):e[1].forEach(function(e){e.a&&(t=i.indexOf(kt(e.a))),r.push(e.t||"")}),s.push('<comment ref="'+e[0]+'" authorId="'+t+'"><text>'),r.length<=1)s.push($t("t",kt(r[0]||"")));else{for(var a="Comment:\n    "+r[0]+"\n",n=1;n<r.length;++n)a+="Reply:\n    "+r[n]+"\n";s.push($t("t",kt(a)))}s.push("</text></comment>")}),s.push("</commentList>"),2<s.length&&(s[s.length]="</comments>",s[1]=s[1].replace("/>",">")),s.join("")}Ue=sa;function rc(e){var n=Ur(),s=[];return Br(n,628),Br(n,630),e.forEach(function(e){e[1].forEach(function(e){-1<s.indexOf(e.a)||(s.push(e.a.slice(0,54)),Br(n,632,ia(e.a.slice(0,54))))})}),Br(n,631),Br(n,633),e.forEach(function(a){a[1].forEach(function(e){e.iauthor=s.indexOf(e.a);var t,r={s:Yr(a[0]),e:Yr(a[0])};Br(n,635,(r=[r,e],(t=null==t?Lr(36):t).write_shift(4,r[1].iauthor),_a(r[0],t),t.write_shift(4,0),t.write_shift(4,0),t.write_shift(4,0),t.write_shift(4,0),t)),e.t&&0<e.t.length&&Br(n,637,la(e)),Br(n,636),delete e.iauthor})}),Br(n,634),Br(n,629),n.end()}var ac="application/vnd.ms-office.vbaProject";var nc=["xlsb","xlsm","xlam","biff8","xla"];var sc,ic,oc=(ic=/(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g,function(e,t){return sc=t,e.replace(ic,cc)});function cc(e,t,r,a){var n=!1,s=!1;0==r.length?s=!0:"["==r.charAt(0)&&(s=!0,r=r.slice(1,-1)),0==a.length?n=!0:"["==a.charAt(0)&&(n=!0,a=a.slice(1,-1));r=0<r.length?0|parseInt(r,10):0,a=0<a.length?0|parseInt(a,10):0;return n?a+=sc.c:--a,s?r+=sc.r:--r,t+(n?"":"$")+Xr(a)+(s?"":"$")+jr(r)}var lc=/(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g,fc=function(e,i){return e.replace(lc,function(e,t,r,a,n,s){a=$r(a)-(r?0:i.c),s=Gr(s)-(n?0:i.r);return t+"R"+(0==s?"":n?1+s:"["+s+"]")+"C"+(0==a?"":r?1+a:"["+a+"]")})};function hc(e,i){return e.replace(lc,function(e,t,r,a,n,s){return t+("$"==r?r+a:Xr($r(a)+i.c))+("$"==n?n+s:jr(Gr(s)+i.r))})}function uc(e){return e.replace(/_xlfn\./g,"")}function dc(e){e.l+=1}function pc(e,t){t=e.read_shift(1==t?1:2);return[16383&t,t>>14&1,t>>15&1]}function mc(e,t,r){var a=2;if(r){if(2<=r.biff&&r.biff<=5)return gc(e);12==r.biff&&(a=4)}var n=e.read_shift(a),r=e.read_shift(a),a=pc(e,2),e=pc(e,2);return{s:{r:n,c:a[0],cRel:a[1],rRel:a[2]},e:{r:r,c:e[0],cRel:e[1],rRel:e[2]}}}function gc(e){var t=pc(e,2),r=pc(e,2),a=e.read_shift(1),e=e.read_shift(1);return{s:{r:t[0],c:a,cRel:t[1],rRel:t[2]},e:{r:r[0],c:e,cRel:r[1],rRel:r[2]}}}function bc(e,t,r){if(r&&2<=r.biff&&r.biff<=5)return n=pc(a=e,2),a=a.read_shift(1),{r:n[0],c:a,cRel:n[1],rRel:n[2]};var a,n,r=e.read_shift(r&&12==r.biff?4:2),e=pc(e,2);return{r:r,c:e[0],cRel:e[1],rRel:e[2]}}function vc(e,t,r){r=r&&r.biff?r.biff:8;if(2<=r&&r<=5)return function(e){var t=e.read_shift(2),r=e.read_shift(1),a=(32768&t)>>15,e=(16384&t)>>14;t&=16383,1==a&&8192<=t&&(t-=16384);1==e&&128<=r&&(r-=256);return{r:t,c:r,cRel:e,rRel:a}}(e);var a=e.read_shift(12<=r?4:2),n=e.read_shift(2),r=(16384&n)>>14,e=(32768&n)>>15;if(n&=16383,1==e)for(;524287<a;)a-=1048576;if(1==r)for(;8191<n;)n-=16384;return{r:a,c:n,cRel:r,rRel:e}}function wc(e){var t=1&e[e.l+1];return e.l+=4,[t,1]}function Tc(e){return[e.read_shift(1),e.read_shift(1)]}function Ec(e,t,r){var a=0,n=0;12==r.biff?(a=e.read_shift(4),n=e.read_shift(4)):(n=1+e.read_shift(1),a=1+e.read_shift(2)),2<=r.biff&&r.biff<8&&(--a,0==--n&&(n=256));for(var s=0,i=[];s!=a&&(i[s]=[]);++s)for(var o=0;o!=n;++o)i[s][o]=function(e,t){var r=[e.read_shift(1)];if(12==t)switch(r[0]){case 2:r[0]=4;break;case 4:r[0]=16;break;case 0:r[0]=1;break;case 1:r[0]=2}switch(r[0]){case 4:r[1]=On(e,1)?"TRUE":"FALSE",12!=t&&(e.l+=7);break;case 37:case 16:r[1]=Wa[e[e.l]],e.l+=12==t?4:8;break;case 0:e.l+=8;break;case 1:r[1]=xa(e);break;case 2:r[1]=Bn(e,0,{biff:0<t&&t<8?2:t});break;default:throw new Error("Bad SerAr: "+r[0])}return r}(e,r.biff);return i}function kc(e,t,r){return e.l+=2,[(e=(a=e).read_shift(2),a=a.read_shift(2),{r:e,c:255&a,fQuoted:!!(16384&a),cRel:a>>15,rRel:a>>15})];var a}function yc(e){return e.l+=6,[]}function Sc(e){return e.l+=2,[Nn(e),1&e.read_shift(2)]}var _c=["Data","All","Headers","??","?Data2","??","?DataHeaders","??","Totals","??","??","??","?DataTotals","??","??","??","?Current"];var xc={1:{n:"PtgExp",f:function(e,t,r){return e.l++,r&&12==r.biff?[e.read_shift(4,"i"),0]:[e.read_shift(2),e.read_shift(r&&2==r.biff?1:2)]}},2:{n:"PtgTbl",f:Pr},3:{n:"PtgAdd",f:dc},4:{n:"PtgSub",f:dc},5:{n:"PtgMul",f:dc},6:{n:"PtgDiv",f:dc},7:{n:"PtgPower",f:dc},8:{n:"PtgConcat",f:dc},9:{n:"PtgLt",f:dc},10:{n:"PtgLe",f:dc},11:{n:"PtgEq",f:dc},12:{n:"PtgGe",f:dc},13:{n:"PtgGt",f:dc},14:{n:"PtgNe",f:dc},15:{n:"PtgIsect",f:dc},16:{n:"PtgUnion",f:dc},17:{n:"PtgRange",f:dc},18:{n:"PtgUplus",f:dc},19:{n:"PtgUminus",f:dc},20:{n:"PtgPercent",f:dc},21:{n:"PtgParen",f:dc},22:{n:"PtgMissArg",f:dc},23:{n:"PtgStr",f:function(e,t,r){return e.l++,Ln(e,0,r)}},26:{n:"PtgSheet",f:function(e,t,r){return e.l+=5,e.l+=2,e.l+=2==r.biff?1:4,["PTGSHEET"]}},27:{n:"PtgEndSheet",f:function(e,t,r){return e.l+=2==r.biff?4:5,["PTGENDSHEET"]}},28:{n:"PtgErr",f:function(e){return e.l++,Wa[e.read_shift(1)]}},29:{n:"PtgBool",f:function(e){return e.l++,0!==e.read_shift(1)}},30:{n:"PtgInt",f:function(e){return e.l++,e.read_shift(2)}},31:{n:"PtgNum",f:function(e){return e.l++,xa(e)}},32:{n:"PtgArray",f:function(e,t,r){var a=(96&e[e.l++])>>5;return e.l+=2==r.biff?6:12==r.biff?14:7,[a]}},33:{n:"PtgFunc",f:function(e,t,r){var a=(96&e[e.l])>>5;return e.l+=1,r=e.read_shift(r&&r.biff<=3?1:2),[jc[r],Gc[r],a]}},34:{n:"PtgFuncVar",f:function(e,t,r){var a=e[e.l++],n=e.read_shift(1),s=r&&r.biff<=3?[88==a?-1:0,e.read_shift(1)]:[(s=e)[s.l+1]>>7,32767&s.read_shift(2)];return[n,(0===s[0]?Gc:Vc)[s[1]]]}},35:{n:"PtgName",f:function(e,t,r){var a=e.read_shift(1)>>>5&3,n=!r||8<=r.biff?4:2,n=e.read_shift(n);switch(r.biff){case 2:e.l+=5;break;case 3:case 4:e.l+=8;break;case 5:e.l+=12}return[a,0,n]}},36:{n:"PtgRef",f:function(e,t,r){var a=(96&e[e.l])>>5;return e.l+=1,[a,bc(e,0,r)]}},37:{n:"PtgArea",f:function(e,t,r){return[(96&e[e.l++])>>5,mc(e,2<=r.biff&&r.biff,r)]}},38:{n:"PtgMemArea",f:function(e,t,r){var a=e.read_shift(1)>>>5&3;return e.l+=r&&2==r.biff?3:4,[a,e.read_shift(r&&2==r.biff?1:2)]}},39:{n:"PtgMemErr",f:Pr},40:{n:"PtgMemNoMem",f:Pr},41:{n:"PtgMemFunc",f:function(e,t,r){return[e.read_shift(1)>>>5&3,e.read_shift(r&&2==r.biff?1:2)]}},42:{n:"PtgRefErr",f:function(e,t,r){var a=e.read_shift(1)>>>5&3;return e.l+=4,r.biff<8&&e.l--,12==r.biff&&(e.l+=2),[a]}},43:{n:"PtgAreaErr",f:function(e,t,r){var a=(96&e[e.l++])>>5;return e.l+=r&&8<r.biff?12:r.biff<8?6:8,[a]}},44:{n:"PtgRefN",f:function(e,t,r){var a=(96&e[e.l])>>5;return e.l+=1,[a,vc(e,0,r)]}},45:{n:"PtgAreaN",f:function(e,t,r){return[(96&e[e.l++])>>5,function(e,t){if(t.biff<8)return gc(e);var r=e.read_shift(12==t.biff?4:2),a=e.read_shift(12==t.biff?4:2),t=pc(e,2),e=pc(e,2);return{s:{r:r,c:t[0],cRel:t[1],rRel:t[2]},e:{r:a,c:e[0],cRel:e[1],rRel:e[2]}}}(e,r)]}},46:{n:"PtgMemAreaN",f:function(e){return[e.read_shift(1)>>>5&3,e.read_shift(2)]}},47:{n:"PtgMemNoMemN",f:function(e){return[e.read_shift(1)>>>5&3,e.read_shift(2)]}},57:{n:"PtgNameX",f:function(e,t,r){return 5==r.biff?function(e){var t=e.read_shift(1)>>>5&3,r=e.read_shift(2,"i");e.l+=8;var a=e.read_shift(2);return e.l+=12,[t,r,a]}(e):[e.read_shift(1)>>>5&3,e.read_shift(2),e.read_shift(4)]}},58:{n:"PtgRef3d",f:function(e,t,r){var a=(96&e[e.l])>>5;e.l+=1;var n=e.read_shift(2);return r&&5==r.biff&&(e.l+=12),[a,n,bc(e,0,r)]}},59:{n:"PtgArea3d",f:function(e,t,r){var a=(96&e[e.l++])>>5,n=e.read_shift(2,"i");if(r)switch(r.biff){case 5:e.l+=12,0;break;case 12:0}return[a,n,mc(e,0,r)]}},60:{n:"PtgRefErr3d",f:function(e,t,r){var a=(96&e[e.l++])>>5,n=e.read_shift(2),s=4;if(r)switch(r.biff){case 5:s=15;break;case 12:s=6}return e.l+=s,[a,n]}},61:{n:"PtgAreaErr3d",f:function(e,t,r){var a=(96&e[e.l++])>>5,n=e.read_shift(2),s=8;if(r)switch(r.biff){case 5:e.l+=12,s=6;break;case 12:s=12}return e.l+=s,[a,n]}},255:{}},Ac={64:32,96:32,65:33,97:33,66:34,98:34,67:35,99:35,68:36,100:36,69:37,101:37,70:38,102:38,71:39,103:39,72:40,104:40,73:41,105:41,74:42,106:42,75:43,107:43,76:44,108:44,77:45,109:45,78:46,110:46,79:47,111:47,88:34,120:34,89:57,121:57,90:58,122:58,91:59,123:59,92:60,124:60,93:61,125:61},Cc={1:{n:"PtgElfLel",f:Sc},2:{n:"PtgElfRw",f:kc},3:{n:"PtgElfCol",f:kc},6:{n:"PtgElfRwV",f:kc},7:{n:"PtgElfColV",f:kc},10:{n:"PtgElfRadical",f:kc},11:{n:"PtgElfRadicalS",f:yc},13:{n:"PtgElfColS",f:yc},15:{n:"PtgElfColSV",f:yc},16:{n:"PtgElfRadicalLel",f:Sc},25:{n:"PtgList",f:function(e){e.l+=2;var t=e.read_shift(2),r=e.read_shift(2),a=e.read_shift(4),n=e.read_shift(2),e=e.read_shift(2);return{ixti:t,coltype:3&r,rt:_c[r>>2&31],idx:a,c:n,C:e}}},29:{n:"PtgSxName",f:function(e){return e.l+=2,[e.read_shift(4)]}},255:{}},Rc={0:{n:"PtgAttrNoop",f:function(e){return e.l+=4,[0,0]}},1:{n:"PtgAttrSemi",f:function(e,t,r){var a=255&e[e.l+1]?1:0;return e.l+=r&&2==r.biff?3:4,[a]}},2:{n:"PtgAttrIf",f:function(e,t,r){var a=255&e[e.l+1]?1:0;return e.l+=2,[a,e.read_shift(r&&2==r.biff?1:2)]}},4:{n:"PtgAttrChoose",f:function(e,t,r){e.l+=2;for(var a=e.read_shift(r&&2==r.biff?1:2),n=[],s=0;s<=a;++s)n.push(e.read_shift(r&&2==r.biff?1:2));return n}},8:{n:"PtgAttrGoto",f:function(e,t,r){var a=255&e[e.l+1]?1:0;return e.l+=2,[a,e.read_shift(r&&2==r.biff?1:2)]}},16:{n:"PtgAttrSum",f:function(e,t,r){e.l+=r&&2==r.biff?3:4}},32:{n:"PtgAttrBaxcel",f:wc},33:{n:"PtgAttrBaxcel",f:wc},64:{n:"PtgAttrSpace",f:function(e){return e.read_shift(2),Tc(e)}},65:{n:"PtgAttrSpaceSemi",f:function(e){return e.read_shift(2),Tc(e)}},128:{n:"PtgAttrIfError",f:function(e){var t=255&e[e.l+1]?1:0;return e.l+=2,[t,e.read_shift(2)]}},255:{}};function Oc(e,t,r,a){if(a.biff<8)return Pr(e,t);for(var n=e.l+t,s=[],i=0;i!==r.length;++i)switch(r[i][0]){case"PtgArray":r[i][1]=Ec(e,0,a),s.push(r[i][1]);break;case"PtgMemArea":r[i][2]=function(e,t){for(var r=e.read_shift(12==t.biff?4:2),a=[],n=0;n!=r;++n)a.push((12==t.biff?Sa:Kn)(e,8));return a}(e,(r[i][1],a)),s.push(r[i][2]);break;case"PtgExp":a&&12==a.biff&&(r[i][1][1]=e.read_shift(4),s.push(r[i][1]));break;case"PtgList":case"PtgElfRadicalS":case"PtgElfColS":case"PtgElfColSV":throw"Unsupported "+r[i][0]}return 0!==(t=n-e.l)&&s.push(Pr(e,t)),s}function Ic(e,t,r){for(var a,n,s=e.l+t,i=[];s!=e.l;)t=s-e.l,n=e[e.l],a=xc[n]||xc[Ac[n]],(a=24===n||25===n?(24===n?Cc:Rc)[e[e.l+1]]:a)&&a.f?i.push([a.n,a.f(e,t,r)]):Pr(e,t);return i}var Nc={PtgAdd:"+",PtgConcat:"&",PtgDiv:"/",PtgEq:"=",PtgGe:">=",PtgGt:">",PtgLe:"<=",PtgLt:"<",PtgMul:"*",PtgNe:"<>",PtgPower:"^",PtgSub:"-"};function Fc(e,t,r){if(!e)return"SH33TJSERR0";if(8<r.biff&&(!e.XTI||!e.XTI[t]))return e.SheetNames[t];if(!e.XTI)return"SH33TJSERR6";var a=e.XTI[t];if(r.biff<8)return 1e4<t&&(t-=65536),0==(t=t<0?-t:t)?"":e.XTI[t-1];if(!a)return"SH33TJSERR1";var n="";if(8<r.biff)switch(e[a[0]][0]){case 357:return n=-1==a[1]?"#REF":e.SheetNames[a[1]],a[1]==a[2]?n:n+":"+e.SheetNames[a[2]];case 358:return null!=r.SID?e.SheetNames[r.SID]:"SH33TJSSAME"+e[a[0]][0];case 355:default:return"SH33TJSSRC"+e[a[0]][0]}switch(e[a[0]][0][0]){case 1025:return n=-1==a[1]?"#REF":e.SheetNames[a[1]]||"SH33TJSERR3",a[1]==a[2]?n:n+":"+e.SheetNames[a[2]];case 14849:return e[a[0]].slice(1).map(function(e){return e.Name}).join(";;");default:return e[a[0]][0][3]?(n=-1==a[1]?"#REF":e[a[0]][0][3][a[1]]||"SH33TJSERR4",a[1]==a[2]?n:n+":"+e[a[0]][0][3][a[2]]):"SH33TJSERR2"}}function Dc(e,t,r){t=Fc(e,t,r);return"#REF"==t?t:function(e,t){if(!(e||t&&t.biff<=5&&2<=t.biff))throw new Error("empty sheet name");return/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(e)?"'"+e+"'":e}(t,r)}function Pc(e,t,r,a,n){var s,i,o,c=n&&n.biff||8,l={s:{c:0,r:0},e:{c:0,r:0}},f=[],h=0,u=0,d="";if(!e[0]||!e[0][0])return"";for(var p=-1,m="",g=0,b=e[0].length;g<b;++g){var v=e[0][g];switch(v[0]){case"PtgUminus":f.push("-"+f.pop());break;case"PtgUplus":f.push("+"+f.pop());break;case"PtgPercent":f.push(f.pop()+"%");break;case"PtgAdd":case"PtgConcat":case"PtgDiv":case"PtgEq":case"PtgGe":case"PtgGt":case"PtgLe":case"PtgLt":case"PtgMul":case"PtgNe":case"PtgPower":case"PtgSub":if(O=f.pop(),s=f.pop(),0<=p){switch(e[0][p][1][0]){case 0:m=Ge(" ",e[0][p][1][1]);break;case 1:m=Ge("\r",e[0][p][1][1]);break;default:if(m="",n.WTF)throw new Error("Unexpected PtgAttrSpaceType "+e[0][p][1][0])}s+=m,p=-1}f.push(s+Nc[v[0]]+O);break;case"PtgIsect":O=f.pop(),s=f.pop(),f.push(s+" "+O);break;case"PtgUnion":O=f.pop(),s=f.pop(),f.push(s+","+O);break;case"PtgRange":O=f.pop(),s=f.pop(),f.push(s+":"+O);break;case"PtgAttrChoose":case"PtgAttrGoto":case"PtgAttrIf":case"PtgAttrIfError":break;case"PtgRef":i=Wr(v[1][1],l,n),f.push(zr(i,c));break;case"PtgRefN":i=r?Wr(v[1][1],r,n):v[1][1],f.push(zr(i,c));break;case"PtgRef3d":h=v[1][1],i=Wr(v[1][2],l,n);d=Dc(a,h,n);f.push(d+"!"+zr(i,c));break;case"PtgFunc":case"PtgFuncVar":var w=v[1][0],T=v[1][1],w=w||0,E=0==(w&=127)?[]:f.slice(-w);f.length-=w,"User"===T&&(T=E.shift()),f.push(T+"("+E.join(",")+")");break;case"PtgBool":f.push(v[1]?"TRUE":"FALSE");break;case"PtgInt":f.push(v[1]);break;case"PtgNum":f.push(String(v[1]));break;case"PtgStr":f.push('"'+v[1].replace(/"/g,'""')+'"');break;case"PtgErr":f.push(v[1]);break;case"PtgAreaN":o=Hr(v[1][1],r?{s:r}:l,n),f.push(Vr(o,n));break;case"PtgArea":o=Hr(v[1][1],l,n),f.push(Vr(o,n));break;case"PtgArea3d":h=v[1][1],o=v[1][2],d=Dc(a,h,n),f.push(d+"!"+Vr(o,n));break;case"PtgAttrSum":f.push("SUM("+f.pop()+")");break;case"PtgAttrBaxcel":case"PtgAttrSemi":break;case"PtgName":u=v[1][2];var k=(a.names||[])[u-1]||(a[0]||[])[u],y=k?k.Name:"SH33TJSNAME"+String(u);y&&"_xlfn."==y.slice(0,6)&&!n.xlfn&&(y=y.slice(6)),f.push(y);break;case"PtgNameX":var S,_=v[1][1],u=v[1][2];if(!(n.biff<=5)){k="";14849==((a[_]||[])[0]||[])[0]||(1025==((a[_]||[])[0]||[])[0]?a[_][u]&&0<a[_][u].itab&&(k=a.SheetNames[a[_][u].itab-1]+"!"):k=a.SheetNames[u-1]+"!"),a[_]&&a[_][u]?k+=a[_][u].Name:a[0]&&a[0][u]?k+=a[0][u].Name:(y=(Fc(a,_,n)||"").split(";;"))[u-1]?k=y[u-1]:k+="SH33TJSERRX",f.push(k);break}S=(S=a[_=_<0?-_:_]?a[_][u]:S)||{Name:"SH33TJSERRY"},f.push(S.Name);break;case"PtgParen":var x="(",A=")";if(0<=p){switch(m="",e[0][p][1][0]){case 2:x=Ge(" ",e[0][p][1][1])+x;break;case 3:x=Ge("\r",e[0][p][1][1])+x;break;case 4:A=Ge(" ",e[0][p][1][1])+A;break;case 5:A=Ge("\r",e[0][p][1][1])+A;break;default:if(n.WTF)throw new Error("Unexpected PtgAttrSpaceType "+e[0][p][1][0])}p=-1}f.push(x+f.pop()+A);break;case"PtgRefErr":case"PtgRefErr3d":f.push("#REF!");break;case"PtgExp":i={c:v[1][1],r:v[1][0]};var C={c:r.c,r:r.r};if(a.sharedf[Kr(i)]){_=a.sharedf[Kr(i)];f.push(Pc(_,0,C,a,n))}else{for(var R=!1,O=0;O!=a.arrayf.length;++O)if(s=a.arrayf[O],!(i.c<s[0].s.c||i.c>s[0].e.c||i.r<s[0].s.r||i.r>s[0].e.r)){f.push(Pc(s[1],0,C,a,n)),R=!0;break}R||f.push(v[1])}break;case"PtgArray":f.push("{"+function(e){for(var t=[],r=0;r<e.length;++r){for(var a=e[r],n=[],s=0;s<a.length;++s){var i=a[s];i?2===i[0]?n.push('"'+i[1].replace(/"/g,'""')+'"'):n.push(i[1]):n.push("")}t.push(n.join(","))}return t.join(";")}(v[1])+"}");break;case"PtgMemArea":break;case"PtgAttrSpace":case"PtgAttrSpaceSemi":p=g;break;case"PtgTbl":case"PtgMemErr":break;case"PtgMissArg":f.push("");break;case"PtgAreaErr":case"PtgAreaErr3d":f.push("#REF!");break;case"PtgList":f.push("Table"+v[1].idx+"[#"+v[1].rt+"]");break;case"PtgMemAreaN":case"PtgMemNoMemN":case"PtgAttrNoop":case"PtgSheet":case"PtgEndSheet":case"PtgMemFunc":case"PtgMemNoMem":break;case"PtgElfCol":case"PtgElfColS":case"PtgElfColSV":case"PtgElfColV":case"PtgElfLel":case"PtgElfRadical":case"PtgElfRadicalLel":case"PtgElfRadicalS":case"PtgElfRw":case"PtgElfRwV":throw new Error("Unsupported ELFs");case"PtgSxName":default:throw new Error("Unrecognized Formula Token: "+String(v))}if(3!=n.biff&&0<=p&&-1==["PtgAttrSpace","PtgAttrSpaceSemi","PtgAttrGoto"].indexOf(e[0][g][0])){var I=!0;switch((v=e[0][p])[1][0]){case 4:I=!1;case 0:m=Ge(" ",v[1][1]);break;case 5:I=!1;case 1:m=Ge("\r",v[1][1]);break;default:if(m="",n.WTF)throw new Error("Unexpected PtgAttrSpaceType "+v[1][0])}f.push((I?m:"")+f.pop()+(I?"":m)),p=-1}}if(1<f.length&&n.WTF)throw new Error("bad formula stack");return f[0]}function Lc(e,t,r){var a=e.l+t,n=$n(e);2==r.biff&&++e.l;var s=function(e){var t;if(65535!==yr(e,e.l+6))return[xa(e),"n"];switch(e[e.l]){case 0:return e.l+=8,["String","s"];case 1:return t=1===e[e.l+2],e.l+=8,[t,"b"];case 2:return t=e[e.l+2],e.l+=8,[t,"e"];case 3:return e.l+=8,["","s"]}return[]}(e),t=e.read_shift(1);2!=r.biff&&(e.read_shift(1),5<=r.biff&&e.read_shift(4));r=function(e,t,r){var a,n=e.l+t,s=2==r.biff?1:2,i=e.read_shift(s);if(65535==i)return[[],Pr(e,t-2)];var o=Ic(e,i,r);return t!==i+s&&(a=Oc(e,t-i-s,o,r)),e.l=n,[o,a]}(e,a-e.l,r);return{cell:n,val:s[0],formula:r,shared:t>>3&1,tt:s[1]}}function Mc(e,t,r,a,n){t=Xn(t,r,n),n=null!=(r=e.v)?Aa("number"==typeof r?r:0):((r=Lr(8)).write_shift(1,3),r.write_shift(1,0),r.write_shift(2,0),r.write_shift(2,0),r.write_shift(2,65535),r),r=Lr(6);r.write_shift(2,33),r.write_shift(4,0);for(var s=Lr(e.bf.length),i=0;i<e.bf.length;++i)s[i]=e.bf[i];return ue([t,n,r,s])}function Uc(e,t,r){var a=e.read_shift(4),n=Ic(e,a,r),a=e.read_shift(4);return[n,0<a?Oc(e,a,n,r):null]}var Bc=Uc,Wc=Uc,Hc=Uc,zc=Uc,Vc={0:"BEEP",1:"OPEN",2:"OPEN.LINKS",3:"CLOSE.ALL",4:"SAVE",5:"SAVE.AS",6:"FILE.DELETE",7:"PAGE.SETUP",8:"PRINT",9:"PRINTER.SETUP",10:"QUIT",11:"NEW.WINDOW",12:"ARRANGE.ALL",13:"WINDOW.SIZE",14:"WINDOW.MOVE",15:"FULL",16:"CLOSE",17:"RUN",22:"SET.PRINT.AREA",23:"SET.PRINT.TITLES",24:"SET.PAGE.BREAK",25:"REMOVE.PAGE.BREAK",26:"FONT",27:"DISPLAY",28:"PROTECT.DOCUMENT",29:"PRECISION",30:"A1.R1C1",31:"CALCULATE.NOW",32:"CALCULATION",34:"DATA.FIND",35:"EXTRACT",36:"DATA.DELETE",37:"SET.DATABASE",38:"SET.CRITERIA",39:"SORT",40:"DATA.SERIES",41:"TABLE",42:"FORMAT.NUMBER",43:"ALIGNMENT",44:"STYLE",45:"BORDER",46:"CELL.PROTECTION",47:"COLUMN.WIDTH",48:"UNDO",49:"CUT",50:"COPY",51:"PASTE",52:"CLEAR",53:"PASTE.SPECIAL",54:"EDIT.DELETE",55:"INSERT",56:"FILL.RIGHT",57:"FILL.DOWN",61:"DEFINE.NAME",62:"CREATE.NAMES",63:"FORMULA.GOTO",64:"FORMULA.FIND",65:"SELECT.LAST.CELL",66:"SHOW.ACTIVE.CELL",67:"GALLERY.AREA",68:"GALLERY.BAR",69:"GALLERY.COLUMN",70:"GALLERY.LINE",71:"GALLERY.PIE",72:"GALLERY.SCATTER",73:"COMBINATION",74:"PREFERRED",75:"ADD.OVERLAY",76:"GRIDLINES",77:"SET.PREFERRED",78:"AXES",79:"LEGEND",80:"ATTACH.TEXT",81:"ADD.ARROW",82:"SELECT.CHART",83:"SELECT.PLOT.AREA",84:"PATTERNS",85:"MAIN.CHART",86:"OVERLAY",87:"SCALE",88:"FORMAT.LEGEND",89:"FORMAT.TEXT",90:"EDIT.REPEAT",91:"PARSE",92:"JUSTIFY",93:"HIDE",94:"UNHIDE",95:"WORKSPACE",96:"FORMULA",97:"FORMULA.FILL",98:"FORMULA.ARRAY",99:"DATA.FIND.NEXT",100:"DATA.FIND.PREV",101:"FORMULA.FIND.NEXT",102:"FORMULA.FIND.PREV",103:"ACTIVATE",104:"ACTIVATE.NEXT",105:"ACTIVATE.PREV",106:"UNLOCKED.NEXT",107:"UNLOCKED.PREV",108:"COPY.PICTURE",109:"SELECT",110:"DELETE.NAME",111:"DELETE.FORMAT",112:"VLINE",113:"HLINE",114:"VPAGE",115:"HPAGE",116:"VSCROLL",117:"HSCROLL",118:"ALERT",119:"NEW",120:"CANCEL.COPY",121:"SHOW.CLIPBOARD",122:"MESSAGE",124:"PASTE.LINK",125:"APP.ACTIVATE",126:"DELETE.ARROW",127:"ROW.HEIGHT",128:"FORMAT.MOVE",129:"FORMAT.SIZE",130:"FORMULA.REPLACE",131:"SEND.KEYS",132:"SELECT.SPECIAL",133:"APPLY.NAMES",134:"REPLACE.FONT",135:"FREEZE.PANES",136:"SHOW.INFO",137:"SPLIT",138:"ON.WINDOW",139:"ON.DATA",140:"DISABLE.INPUT",142:"OUTLINE",143:"LIST.NAMES",144:"FILE.CLOSE",145:"SAVE.WORKBOOK",146:"DATA.FORM",147:"COPY.CHART",148:"ON.TIME",149:"WAIT",150:"FORMAT.FONT",151:"FILL.UP",152:"FILL.LEFT",153:"DELETE.OVERLAY",155:"SHORT.MENUS",159:"SET.UPDATE.STATUS",161:"COLOR.PALETTE",162:"DELETE.STYLE",163:"WINDOW.RESTORE",164:"WINDOW.MAXIMIZE",166:"CHANGE.LINK",167:"CALCULATE.DOCUMENT",168:"ON.KEY",169:"APP.RESTORE",170:"APP.MOVE",171:"APP.SIZE",172:"APP.MINIMIZE",173:"APP.MAXIMIZE",174:"BRING.TO.FRONT",175:"SEND.TO.BACK",185:"MAIN.CHART.TYPE",186:"OVERLAY.CHART.TYPE",187:"SELECT.END",188:"OPEN.MAIL",189:"SEND.MAIL",190:"STANDARD.FONT",191:"CONSOLIDATE",192:"SORT.SPECIAL",193:"GALLERY.3D.AREA",194:"GALLERY.3D.COLUMN",195:"GALLERY.3D.LINE",196:"GALLERY.3D.PIE",197:"VIEW.3D",198:"GOAL.SEEK",199:"WORKGROUP",200:"FILL.GROUP",201:"UPDATE.LINK",202:"PROMOTE",203:"DEMOTE",204:"SHOW.DETAIL",206:"UNGROUP",207:"OBJECT.PROPERTIES",208:"SAVE.NEW.OBJECT",209:"SHARE",210:"SHARE.NAME",211:"DUPLICATE",212:"APPLY.STYLE",213:"ASSIGN.TO.OBJECT",214:"OBJECT.PROTECTION",215:"HIDE.OBJECT",216:"SET.EXTRACT",217:"CREATE.PUBLISHER",218:"SUBSCRIBE.TO",219:"ATTRIBUTES",220:"SHOW.TOOLBAR",222:"PRINT.PREVIEW",223:"EDIT.COLOR",224:"SHOW.LEVELS",225:"FORMAT.MAIN",226:"FORMAT.OVERLAY",227:"ON.RECALC",228:"EDIT.SERIES",229:"DEFINE.STYLE",240:"LINE.PRINT",243:"ENTER.DATA",249:"GALLERY.RADAR",250:"MERGE.STYLES",251:"EDITION.OPTIONS",252:"PASTE.PICTURE",253:"PASTE.PICTURE.LINK",254:"SPELLING",256:"ZOOM",259:"INSERT.OBJECT",260:"WINDOW.MINIMIZE",265:"SOUND.NOTE",266:"SOUND.PLAY",267:"FORMAT.SHAPE",268:"EXTEND.POLYGON",269:"FORMAT.AUTO",272:"GALLERY.3D.BAR",273:"GALLERY.3D.SURFACE",274:"FILL.AUTO",276:"CUSTOMIZE.TOOLBAR",277:"ADD.TOOL",278:"EDIT.OBJECT",279:"ON.DOUBLECLICK",280:"ON.ENTRY",281:"WORKBOOK.ADD",282:"WORKBOOK.MOVE",283:"WORKBOOK.COPY",284:"WORKBOOK.OPTIONS",285:"SAVE.WORKSPACE",288:"CHART.WIZARD",289:"DELETE.TOOL",290:"MOVE.TOOL",291:"WORKBOOK.SELECT",292:"WORKBOOK.ACTIVATE",293:"ASSIGN.TO.TOOL",295:"COPY.TOOL",296:"RESET.TOOL",297:"CONSTRAIN.NUMERIC",298:"PASTE.TOOL",302:"WORKBOOK.NEW",305:"SCENARIO.CELLS",306:"SCENARIO.DELETE",307:"SCENARIO.ADD",308:"SCENARIO.EDIT",309:"SCENARIO.SHOW",310:"SCENARIO.SHOW.NEXT",311:"SCENARIO.SUMMARY",312:"PIVOT.TABLE.WIZARD",313:"PIVOT.FIELD.PROPERTIES",314:"PIVOT.FIELD",315:"PIVOT.ITEM",316:"PIVOT.ADD.FIELDS",318:"OPTIONS.CALCULATION",319:"OPTIONS.EDIT",320:"OPTIONS.VIEW",321:"ADDIN.MANAGER",322:"MENU.EDITOR",323:"ATTACH.TOOLBARS",324:"VBAActivate",325:"OPTIONS.CHART",328:"VBA.INSERT.FILE",330:"VBA.PROCEDURE.DEFINITION",336:"ROUTING.SLIP",338:"ROUTE.DOCUMENT",339:"MAIL.LOGON",342:"INSERT.PICTURE",343:"EDIT.TOOL",344:"GALLERY.DOUGHNUT",350:"CHART.TREND",352:"PIVOT.ITEM.PROPERTIES",354:"WORKBOOK.INSERT",355:"OPTIONS.TRANSITION",356:"OPTIONS.GENERAL",370:"FILTER.ADVANCED",373:"MAIL.ADD.MAILER",374:"MAIL.DELETE.MAILER",375:"MAIL.REPLY",376:"MAIL.REPLY.ALL",377:"MAIL.FORWARD",378:"MAIL.NEXT.LETTER",379:"DATA.LABEL",380:"INSERT.TITLE",381:"FONT.PROPERTIES",382:"MACRO.OPTIONS",383:"WORKBOOK.HIDE",384:"WORKBOOK.UNHIDE",385:"WORKBOOK.DELETE",386:"WORKBOOK.NAME",388:"GALLERY.CUSTOM",390:"ADD.CHART.AUTOFORMAT",391:"DELETE.CHART.AUTOFORMAT",392:"CHART.ADD.DATA",393:"AUTO.OUTLINE",394:"TAB.ORDER",395:"SHOW.DIALOG",396:"SELECT.ALL",397:"UNGROUP.SHEETS",398:"SUBTOTAL.CREATE",399:"SUBTOTAL.REMOVE",400:"RENAME.OBJECT",412:"WORKBOOK.SCROLL",413:"WORKBOOK.NEXT",414:"WORKBOOK.PREV",415:"WORKBOOK.TAB.SPLIT",416:"FULL.SCREEN",417:"WORKBOOK.PROTECT",420:"SCROLLBAR.PROPERTIES",421:"PIVOT.SHOW.PAGES",422:"TEXT.TO.COLUMNS",423:"FORMAT.CHARTTYPE",424:"LINK.FORMAT",425:"TRACER.DISPLAY",430:"TRACER.NAVIGATE",431:"TRACER.CLEAR",432:"TRACER.ERROR",433:"PIVOT.FIELD.GROUP",434:"PIVOT.FIELD.UNGROUP",435:"CHECKBOX.PROPERTIES",436:"LABEL.PROPERTIES",437:"LISTBOX.PROPERTIES",438:"EDITBOX.PROPERTIES",439:"PIVOT.REFRESH",440:"LINK.COMBO",441:"OPEN.TEXT",442:"HIDE.DIALOG",443:"SET.DIALOG.FOCUS",444:"ENABLE.OBJECT",445:"PUSHBUTTON.PROPERTIES",446:"SET.DIALOG.DEFAULT",447:"FILTER",448:"FILTER.SHOW.ALL",449:"CLEAR.OUTLINE",450:"FUNCTION.WIZARD",451:"ADD.LIST.ITEM",452:"SET.LIST.ITEM",453:"REMOVE.LIST.ITEM",454:"SELECT.LIST.ITEM",455:"SET.CONTROL.VALUE",456:"SAVE.COPY.AS",458:"OPTIONS.LISTS.ADD",459:"OPTIONS.LISTS.DELETE",460:"SERIES.AXES",461:"SERIES.X",462:"SERIES.Y",463:"ERRORBAR.X",464:"ERRORBAR.Y",465:"FORMAT.CHART",466:"SERIES.ORDER",467:"MAIL.LOGOFF",468:"CLEAR.ROUTING.SLIP",469:"APP.ACTIVATE.MICROSOFT",470:"MAIL.EDIT.MAILER",471:"ON.SHEET",472:"STANDARD.WIDTH",473:"SCENARIO.MERGE",474:"SUMMARY.INFO",475:"FIND.FILE",476:"ACTIVE.CELL.FONT",477:"ENABLE.TIPWIZARD",478:"VBA.MAKE.ADDIN",480:"INSERTDATATABLE",481:"WORKGROUP.OPTIONS",482:"MAIL.SEND.MAILER",485:"AUTOCORRECT",489:"POST.DOCUMENT",491:"PICKLIST",493:"VIEW.SHOW",494:"VIEW.DEFINE",495:"VIEW.DELETE",509:"SHEET.BACKGROUND",510:"INSERT.MAP.OBJECT",511:"OPTIONS.MENONO",517:"MSOCHECKS",518:"NORMAL",519:"LAYOUT",520:"RM.PRINT.AREA",521:"CLEAR.PRINT.AREA",522:"ADD.PRINT.AREA",523:"MOVE.BRK",545:"HIDECURR.NOTE",546:"HIDEALL.NOTES",547:"DELETE.NOTE",548:"TRAVERSE.NOTES",549:"ACTIVATE.NOTES",620:"PROTECT.REVISIONS",621:"UNPROTECT.REVISIONS",647:"OPTIONS.ME",653:"WEB.PUBLISH",667:"NEWWEBQUERY",673:"PIVOT.TABLE.CHART",753:"OPTIONS.SAVE",755:"OPTIONS.SPELL",808:"HIDEALL.INKANNOTS"},Gc={0:"COUNT",1:"IF",2:"ISNA",3:"ISERROR",4:"SUM",5:"AVERAGE",6:"MIN",7:"MAX",8:"ROW",9:"COLUMN",10:"NA",11:"NPV",12:"STDEV",13:"DOLLAR",14:"FIXED",15:"SIN",16:"COS",17:"TAN",18:"ATAN",19:"PI",20:"SQRT",21:"EXP",22:"LN",23:"LOG10",24:"ABS",25:"INT",26:"SIGN",27:"ROUND",28:"LOOKUP",29:"INDEX",30:"REPT",31:"MID",32:"LEN",33:"VALUE",34:"TRUE",35:"FALSE",36:"AND",37:"OR",38:"NOT",39:"MOD",40:"DCOUNT",41:"DSUM",42:"DAVERAGE",43:"DMIN",44:"DMAX",45:"DSTDEV",46:"VAR",47:"DVAR",48:"TEXT",49:"LINEST",50:"TREND",51:"LOGEST",52:"GROWTH",53:"GOTO",54:"HALT",55:"RETURN",56:"PV",57:"FV",58:"NPER",59:"PMT",60:"RATE",61:"MIRR",62:"IRR",63:"RAND",64:"MATCH",65:"DATE",66:"TIME",67:"DAY",68:"MONTH",69:"YEAR",70:"WEEKDAY",71:"HOUR",72:"MINUTE",73:"SECOND",74:"NOW",75:"AREAS",76:"ROWS",77:"COLUMNS",78:"OFFSET",79:"ABSREF",80:"RELREF",81:"ARGUMENT",82:"SEARCH",83:"TRANSPOSE",84:"ERROR",85:"STEP",86:"TYPE",87:"ECHO",88:"SET.NAME",89:"CALLER",90:"DEREF",91:"WINDOWS",92:"SERIES",93:"DOCUMENTS",94:"ACTIVE.CELL",95:"SELECTION",96:"RESULT",97:"ATAN2",98:"ASIN",99:"ACOS",100:"CHOOSE",101:"HLOOKUP",102:"VLOOKUP",103:"LINKS",104:"INPUT",105:"ISREF",106:"GET.FORMULA",107:"GET.NAME",108:"SET.VALUE",109:"LOG",110:"EXEC",111:"CHAR",112:"LOWER",113:"UPPER",114:"PROPER",115:"LEFT",116:"RIGHT",117:"EXACT",118:"TRIM",119:"REPLACE",120:"SUBSTITUTE",121:"CODE",122:"NAMES",123:"DIRECTORY",124:"FIND",125:"CELL",126:"ISERR",127:"ISTEXT",128:"ISNUMBER",129:"ISBLANK",130:"T",131:"N",132:"FOPEN",133:"FCLOSE",134:"FSIZE",135:"FREADLN",136:"FREAD",137:"FWRITELN",138:"FWRITE",139:"FPOS",140:"DATEVALUE",141:"TIMEVALUE",142:"SLN",143:"SYD",144:"DDB",145:"GET.DEF",146:"REFTEXT",147:"TEXTREF",148:"INDIRECT",149:"REGISTER",150:"CALL",151:"ADD.BAR",152:"ADD.MENU",153:"ADD.COMMAND",154:"ENABLE.COMMAND",155:"CHECK.COMMAND",156:"RENAME.COMMAND",157:"SHOW.BAR",158:"DELETE.MENU",159:"DELETE.COMMAND",160:"GET.CHART.ITEM",161:"DIALOG.BOX",162:"CLEAN",163:"MDETERM",164:"MINVERSE",165:"MMULT",166:"FILES",167:"IPMT",168:"PPMT",169:"COUNTA",170:"CANCEL.KEY",171:"FOR",172:"WHILE",173:"BREAK",174:"NEXT",175:"INITIATE",176:"REQUEST",177:"POKE",178:"EXECUTE",179:"TERMINATE",180:"RESTART",181:"HELP",182:"GET.BAR",183:"PRODUCT",184:"FACT",185:"GET.CELL",186:"GET.WORKSPACE",187:"GET.WINDOW",188:"GET.DOCUMENT",189:"DPRODUCT",190:"ISNONTEXT",191:"GET.NOTE",192:"NOTE",193:"STDEVP",194:"VARP",195:"DSTDEVP",196:"DVARP",197:"TRUNC",198:"ISLOGICAL",199:"DCOUNTA",200:"DELETE.BAR",201:"UNREGISTER",204:"USDOLLAR",205:"FINDB",206:"SEARCHB",207:"REPLACEB",208:"LEFTB",209:"RIGHTB",210:"MIDB",211:"LENB",212:"ROUNDUP",213:"ROUNDDOWN",214:"ASC",215:"DBCS",216:"RANK",219:"ADDRESS",220:"DAYS360",221:"TODAY",222:"VDB",223:"ELSE",224:"ELSE.IF",225:"END.IF",226:"FOR.CELL",227:"MEDIAN",228:"SUMPRODUCT",229:"SINH",230:"COSH",231:"TANH",232:"ASINH",233:"ACOSH",234:"ATANH",235:"DGET",236:"CREATE.OBJECT",237:"VOLATILE",238:"LAST.ERROR",239:"CUSTOM.UNDO",240:"CUSTOM.REPEAT",241:"FORMULA.CONVERT",242:"GET.LINK.INFO",243:"TEXT.BOX",244:"INFO",245:"GROUP",246:"GET.OBJECT",247:"DB",248:"PAUSE",251:"RESUME",252:"FREQUENCY",253:"ADD.TOOLBAR",254:"DELETE.TOOLBAR",255:"User",256:"RESET.TOOLBAR",257:"EVALUATE",258:"GET.TOOLBAR",259:"GET.TOOL",260:"SPELLING.CHECK",261:"ERROR.TYPE",262:"APP.TITLE",263:"WINDOW.TITLE",264:"SAVE.TOOLBAR",265:"ENABLE.TOOL",266:"PRESS.TOOL",267:"REGISTER.ID",268:"GET.WORKBOOK",269:"AVEDEV",270:"BETADIST",271:"GAMMALN",272:"BETAINV",273:"BINOMDIST",274:"CHIDIST",275:"CHIINV",276:"COMBIN",277:"CONFIDENCE",278:"CRITBINOM",279:"EVEN",280:"EXPONDIST",281:"FDIST",282:"FINV",283:"FISHER",284:"FISHERINV",285:"FLOOR",286:"GAMMADIST",287:"GAMMAINV",288:"CEILING",289:"HYPGEOMDIST",290:"LOGNORMDIST",291:"LOGINV",292:"NEGBINOMDIST",293:"NORMDIST",294:"NORMSDIST",295:"NORMINV",296:"NORMSINV",297:"STANDARDIZE",298:"ODD",299:"PERMUT",300:"POISSON",301:"TDIST",302:"WEIBULL",303:"SUMXMY2",304:"SUMX2MY2",305:"SUMX2PY2",306:"CHITEST",307:"CORREL",308:"COVAR",309:"FORECAST",310:"FTEST",311:"INTERCEPT",312:"PEARSON",313:"RSQ",314:"STEYX",315:"SLOPE",316:"TTEST",317:"PROB",318:"DEVSQ",319:"GEOMEAN",320:"HARMEAN",321:"SUMSQ",322:"KURT",323:"SKEW",324:"ZTEST",325:"LARGE",326:"SMALL",327:"QUARTILE",328:"PERCENTILE",329:"PERCENTRANK",330:"MODE",331:"TRIMMEAN",332:"TINV",334:"MOVIE.COMMAND",335:"GET.MOVIE",336:"CONCATENATE",337:"POWER",338:"PIVOT.ADD.DATA",339:"GET.PIVOT.TABLE",340:"GET.PIVOT.FIELD",341:"GET.PIVOT.ITEM",342:"RADIANS",343:"DEGREES",344:"SUBTOTAL",345:"SUMIF",346:"COUNTIF",347:"COUNTBLANK",348:"SCENARIO.GET",349:"OPTIONS.LISTS.GET",350:"ISPMT",351:"DATEDIF",352:"DATESTRING",353:"NUMBERSTRING",354:"ROMAN",355:"OPEN.DIALOG",356:"SAVE.DIALOG",357:"VIEW.GET",358:"GETPIVOTDATA",359:"HYPERLINK",360:"PHONETIC",361:"AVERAGEA",362:"MAXA",363:"MINA",364:"STDEVPA",365:"VARPA",366:"STDEVA",367:"VARA",368:"BAHTTEXT",369:"THAIDAYOFWEEK",370:"THAIDIGIT",371:"THAIMONTHOFYEAR",372:"THAINUMSOUND",373:"THAINUMSTRING",374:"THAISTRINGLENGTH",375:"ISTHAIDIGIT",376:"ROUNDBAHTDOWN",377:"ROUNDBAHTUP",378:"THAIYEAR",379:"RTD",380:"CUBEVALUE",381:"CUBEMEMBER",382:"CUBEMEMBERPROPERTY",383:"CUBERANKEDMEMBER",384:"HEX2BIN",385:"HEX2DEC",386:"HEX2OCT",387:"DEC2BIN",388:"DEC2HEX",389:"DEC2OCT",390:"OCT2BIN",391:"OCT2HEX",392:"OCT2DEC",393:"BIN2DEC",394:"BIN2OCT",395:"BIN2HEX",396:"IMSUB",397:"IMDIV",398:"IMPOWER",399:"IMABS",400:"IMSQRT",401:"IMLN",402:"IMLOG2",403:"IMLOG10",404:"IMSIN",405:"IMCOS",406:"IMEXP",407:"IMARGUMENT",408:"IMCONJUGATE",409:"IMAGINARY",410:"IMREAL",411:"COMPLEX",412:"IMSUM",413:"IMPRODUCT",414:"SERIESSUM",415:"FACTDOUBLE",416:"SQRTPI",417:"QUOTIENT",418:"DELTA",419:"GESTEP",420:"ISEVEN",421:"ISODD",422:"MROUND",423:"ERF",424:"ERFC",425:"BESSELJ",426:"BESSELK",427:"BESSELY",428:"BESSELI",429:"XIRR",430:"XNPV",431:"PRICEMAT",432:"YIELDMAT",433:"INTRATE",434:"RECEIVED",435:"DISC",436:"PRICEDISC",437:"YIELDDISC",438:"TBILLEQ",439:"TBILLPRICE",440:"TBILLYIELD",441:"PRICE",442:"YIELD",443:"DOLLARDE",444:"DOLLARFR",445:"NOMINAL",446:"EFFECT",447:"CUMPRINC",448:"CUMIPMT",449:"EDATE",450:"EOMONTH",451:"YEARFRAC",452:"COUPDAYBS",453:"COUPDAYS",454:"COUPDAYSNC",455:"COUPNCD",456:"COUPNUM",457:"COUPPCD",458:"DURATION",459:"MDURATION",460:"ODDLPRICE",461:"ODDLYIELD",462:"ODDFPRICE",463:"ODDFYIELD",464:"RANDBETWEEN",465:"WEEKNUM",466:"AMORDEGRC",467:"AMORLINC",468:"CONVERT",724:"SHEETJS",469:"ACCRINT",470:"ACCRINTM",471:"WORKDAY",472:"NETWORKDAYS",473:"GCD",474:"MULTINOMIAL",475:"LCM",476:"FVSCHEDULE",477:"CUBEKPIMEMBER",478:"CUBESET",479:"CUBESETCOUNT",480:"IFERROR",481:"COUNTIFS",482:"SUMIFS",483:"AVERAGEIF",484:"AVERAGEIFS"},jc={2:1,3:1,10:0,15:1,16:1,17:1,18:1,19:0,20:1,21:1,22:1,23:1,24:1,25:1,26:1,27:2,30:2,31:3,32:1,33:1,34:0,35:0,38:1,39:2,40:3,41:3,42:3,43:3,44:3,45:3,47:3,48:2,53:1,61:3,63:0,65:3,66:3,67:1,68:1,69:1,70:1,71:1,72:1,73:1,74:0,75:1,76:1,77:1,79:2,80:2,83:1,85:0,86:1,89:0,90:1,94:0,95:0,97:2,98:1,99:1,101:3,102:3,105:1,106:1,108:2,111:1,112:1,113:1,114:1,117:2,118:1,119:4,121:1,126:1,127:1,128:1,129:1,130:1,131:1,133:1,134:1,135:1,136:2,137:2,138:2,140:1,141:1,142:3,143:4,144:4,161:1,162:1,163:1,164:1,165:2,172:1,175:2,176:2,177:3,178:2,179:1,184:1,186:1,189:3,190:1,195:3,196:3,197:1,198:1,199:3,201:1,207:4,210:3,211:1,212:2,213:2,214:1,215:1,225:0,229:1,230:1,231:1,232:1,233:1,234:1,235:3,244:1,247:4,252:2,257:1,261:1,271:1,273:4,274:2,275:2,276:2,277:3,278:3,279:1,280:3,281:3,282:3,283:1,284:1,285:2,286:4,287:3,288:2,289:4,290:3,291:3,292:3,293:4,294:1,295:3,296:1,297:3,298:1,299:2,300:3,301:3,302:4,303:2,304:2,305:2,306:2,307:2,308:2,309:3,310:2,311:2,312:2,313:2,314:2,315:2,316:4,325:2,326:2,327:2,328:2,331:2,332:2,337:2,342:1,343:1,346:2,347:1,350:4,351:3,352:1,353:2,360:1,368:1,369:1,370:1,371:1,372:1,373:1,374:1,375:1,376:1,377:1,378:1,382:3,385:1,392:1,393:1,396:2,397:2,398:2,399:1,400:1,401:1,402:1,403:1,404:1,405:1,406:1,407:1,408:1,409:1,410:1,414:4,415:1,416:1,417:2,420:1,421:1,422:2,424:1,425:2,426:2,427:2,428:2,430:3,438:3,439:3,440:3,443:2,444:2,445:2,446:2,447:6,448:6,449:2,450:2,464:2,468:3,476:2,479:1,480:2,65535:0};function $c(e){return(e=(e=(e=(e=61==(e="of:"==e.slice(0,3)?e.slice(3):e).charCodeAt(0)&&61==(e=e.slice(1)).charCodeAt(0)?e.slice(1):e).replace(/COM\.MICROSOFT\./g,"")).replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g,function(e,t){return t.replace(/\./g,"")})).replace(/\[.(#[A-Z]*[?!])\]/g,"$1")).replace(/[;~]/g,",").replace(/\|/g,";")}function Xc(e){e=e.split(":");return[e[0].split(".")[0],e[0].split(".")[1]+(1<e.length?":"+(e[1].split(".")[1]||e[1].split(".")[0]):"")]}var Yc={},Kc={},Jc="undefined"!=typeof Map;function qc(e,t,r){var a=0,n=e.length;if(r){if(Jc?r.has(t):Object.prototype.hasOwnProperty.call(r,t))for(var s=Jc?r.get(t):r[t];a<s.length;++a)if(e[s[a]].t===t)return e.Count++,s[a]}else for(;a<n;++a)if(e[a].t===t)return e.Count++,a;return e[n]={t:t},e.Count++,e.Unique++,r&&(Jc?(r.has(t)||r.set(t,[]),r.get(t).push(n)):(Object.prototype.hasOwnProperty.call(r,t)||(r[t]=[]),r[t].push(n))),n}function Zc(e,t){var r={min:e+1,max:e+1},e=-1;return t.MDW&&(no=t.MDW),null!=t.width?r.customWidth=1:null!=t.wpx?e=io(t.wpx):null!=t.wch&&(e=t.wch),-1<e?(r.width=oo(e),r.customWidth=1):null!=t.width&&(r.width=t.width),t.hidden&&(r.hidden=!0),null!=t.level&&(r.outlineLevel=r.level=t.level),r}function Qc(e,t){e&&(t="xlml"==t?[1,1,1,1,.5,.5]:[.7,.7,.75,.75,.3,.3],null==e.left&&(e.left=t[0]),null==e.right&&(e.right=t[1]),null==e.top&&(e.top=t[2]),null==e.bottom&&(e.bottom=t[3]),null==e.header&&(e.header=t[4]),null==e.footer&&(e.footer=t[5]))}function el(e,t,r){if(void 0!==yo){if(/^\d+$/.exec(t.s))return t.s;if(t.s&&t.s==+t.s)return t.s;var a=t.s||{};return t.z&&(a.numFmt=t.z),yo.addStyle(a)}var n=r.revssf[null!=t.z?t.z:"General"],s=60,i=e.length;if(null==n&&r.ssf)for(;s<392;++s)if(null==r.ssf[s]){we(t.z,s),r.ssf[s]=t.z,r.revssf[t.z]=n=s;break}for(s=0;s!=i;++s)if(e[s].numFmtId===n)return s;return e[i]={numFmtId:n,fontId:0,fillId:0,borderId:0,xfId:0,applyNumberFormat:1},i}function tl(e,t,r,a,n,s){try{a.cellNF&&(e.z=me[t])}catch(e){if(a.WTF)throw e}if("z"!==e.t||a.cellStyles){if("d"===e.t&&"string"==typeof e.v&&(e.v=He(e.v)),(!a||!1!==a.cellText)&&"z"!==e.t)try{if(null==me[t]&&we(ke[t]||"General",t),"e"===e.t)e.w=e.w||Wa[e.v];else if(0===t)if("n"===e.t)(0|e.v)===e.v?e.w=e.v.toString(10):e.w=D(e.v);else if("d"===e.t){var i=De(e.v);e.w=(0|i)===i?i.toString(10):D(i)}else{if(void 0===e.v)return;e.w=P(e.v,Kc)}else"d"===e.t?e.w=ve(t,De(e.v),Kc):e.w=ve(t,e.v,Kc)}catch(e){if(a.WTF)throw e}if(a.cellStyles&&null!=r)try{e.s=s.Fills[r],e.s.fgColor&&e.s.fgColor.theme&&!e.s.fgColor.rgb&&(e.s.fgColor.rgb=eo(n.themeElements.clrScheme[e.s.fgColor.theme].rgb,e.s.fgColor.tint||0),a.WTF&&(e.s.fgColor.raw_rgb=n.themeElements.clrScheme[e.s.fgColor.theme].rgb)),e.s.bgColor&&e.s.bgColor.theme&&(e.s.bgColor.rgb=eo(n.themeElements.clrScheme[e.s.bgColor.theme].rgb,e.s.bgColor.tint||0),a.WTF&&(e.s.bgColor.raw_rgb=n.themeElements.clrScheme[e.s.bgColor.theme].rgb))}catch(e){if(a.WTF&&s.Fills)throw e}}}var rl=/<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g,al=/<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/,nl=/<(?:\w:)?hyperlink [^>]*>/gm,sl=/"(\w*:\w*)"/,il=/<(?:\w:)?col\b[^>]*[\/]?>/g,ol=/<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g,cl=/<(?:\w:)?pageMargins[^>]*\/>/g,ll=/<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/,fl=/<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/,hl=/<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;function ul(e,t,r,a,n,s,i){if(!e)return e;a=a||{"!id":{}},null!=oe&&null==t.dense&&(t.dense=oe);var o=t.dense?[]:{},c={s:{r:2e6,c:2e6},e:{r:0,c:0}},l="",f="",h=e.match(al);h?(l=e.slice(0,h.index),f=e.slice(h.index+h[0].length)):l=f=e;var u=l.match(ll);u?dl(u[0],0,n,r):(u=l.match(fl))&&(e=u[0],u[1],u=o,d=n,p=r,dl(e.slice(0,e.indexOf(">")),0,d,p));var d,p,m=(l.match(/<(?:\w*:)?dimension/)||{index:-1}).index;0<m&&((d=l.slice(m,m+50).match(sl))&&(p=o,(b=Zr(b=d[1])).s.r<=b.e.r&&b.s.c<=b.e.c&&0<=b.s.r&&0<=b.s.c&&(p["!ref"]=qr(b))));var g,b=l.match(hl);b&&b[1]&&(w=b[1],(g=n).Views||(g.Views=[{}]),(w.match(gl)||[]).forEach(function(e,t){e=dt(e);g.Views[t]||(g.Views[t]={}),+e.zoomScale&&(g.Views[t].zoom=+e.zoomScale),Rt(e.rightToLeft)&&(g.Views[t].RTL=!0)}));var v,w=[];t.cellStyles&&(v=l.match(il))&&function(e,t){for(var r=!1,a=0;a!=t.length;++a){var n=dt(t[a],!0);n.hidden&&(n.hidden=Rt(n.hidden));var s=parseInt(n.min,10)-1,i=parseInt(n.max,10)-1;for(n.outlineLevel&&(n.level=+n.outlineLevel||0),delete n.min,delete n.max,n.width=+n.width,!r&&n.width&&(r=!0,lo(n.width)),fo(n);s<=i;)e[s++]=Ve(n)}}(w,v),h&&Sl(h[1],o,t,c,s,i);i=f.match(ol);i&&(o["!autofilter"]={ref:(i[0].match(/ref="([^"]*)"/)||[])[1]});var T=[],E=f.match(rl);if(E)for(m=0;m!=E.length;++m)T[m]=Zr(E[m].slice(E[m].indexOf('"')+1));i=f.match(nl);i&&function(e,t,r){for(var a=Array.isArray(e),n=0;n!=t.length;++n){var s=dt(Mt(t[n]),!0);if(!s.ref)return;var i=((r||{})["!id"]||[])[s.id];i?(s.Target=i.Target,s.location&&(s.Target+="#"+wt(s.location))):(s.Target="#"+wt(s.location),i={Target:s.Target,TargetMode:"Internal"}),s.Rel=i,s.tooltip&&(s.Tooltip=s.tooltip,delete s.tooltip);for(var o=Zr(s.ref),c=o.s.r;c<=o.e.r;++c)for(var l=o.s.c;l<=o.e.c;++l){var f=Kr({c:l,r:c});a?(e[c]||(e[c]=[]),e[c][l]||(e[c][l]={t:"z",v:void 0}),e[c][l].l=s):(e[f]||(e[f]={t:"z",v:void 0}),e[f].l=s)}}}(o,i,a);var k,y,f=f.match(cl);return f&&(o["!margins"]=(k=dt(f[0]),y={},["left","right","top","bottom","header","footer"].forEach(function(e){k[e]&&(y[e]=parseFloat(k[e]))}),y)),!o["!ref"]&&c.e.c>=c.s.c&&c.e.r>=c.s.r&&(o["!ref"]=qr(c)),0<t.sheetRows&&o["!ref"]&&(f=Zr(o["!ref"]),t.sheetRows<=+f.e.r&&(f.e.r=t.sheetRows-1,f.e.r>c.e.r&&(f.e.r=c.e.r),f.e.r<f.s.r&&(f.s.r=f.e.r),f.e.c>c.e.c&&(f.e.c=c.e.c),f.e.c<f.s.c&&(f.s.c=f.e.c),o["!fullref"]=o["!ref"],o["!ref"]=qr(f))),0<w.length&&(o["!cols"]=w),0<T.length&&(o["!merges"]=T),o}function dl(e,t,r,a){e=dt(e);r.Sheets[a]||(r.Sheets[a]={}),e.codeName&&(r.Sheets[a].CodeName=wt(Mt(e.codeName)))}var pl=["objects","scenarios","selectLockedCells","selectUnlockedCells"],ml=["formatColumns","formatRows","formatCells","insertColumns","insertRows","insertHyperlinks","deleteColumns","deleteRows","sort","autoFilter","pivotTables"];var gl=/<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;var bl,vl,wl,Tl,El,kl,yl,Sl=(bl=/<(?:\w+:)?c[ \/>]/,vl=/<\/(?:\w+:)?row>/,wl=/r=["']([^"']*)["']/,Tl=/<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/,El=/ref=["']([^"']*)["']/,kl=Bt("v"),yl=Bt("f"),function(e,t,r,a,n,s){for(var i,o,c,l,f,h,u=0,d="",p=[],m=[],g=0,b=0,v="",w=0,T=0,E=0,k=0,y=Array.isArray(s.CellXf),S=[],_=[],x=Array.isArray(t),A=[],C={},R=!1,O=!!r.sheetStubs,I=e.split(vl),N=0,F=I.length;N!=F;++N){var D=(d=I[N].trim()).length;if(0!==D){var P=0;e:for(u=0;u<D;++u)switch(d[u]){case">":if("/"!=d[u-1]){++u;break e}if(r&&r.cellStyles){if(w=null!=(c=dt(d.slice(P,u),!0)).r?parseInt(c.r,10):w+1,T=-1,r.sheetRows&&r.sheetRows<w)continue;R=!(C={}),c.ht&&(R=!0,C.hpt=parseFloat(c.ht),C.hpx=po(C.hpt)),"1"==c.hidden&&(R=!0,C.hidden=!0),null!=c.outlineLevel&&(R=!0,C.level=+c.outlineLevel),R&&(A[w-1]=C)}break;case"<":P=u}if(u<=P)break;if(w=null!=(c=dt(d.slice(P,u),!0)).r?parseInt(c.r,10):w+1,T=-1,!(r.sheetRows&&r.sheetRows<w)){a.s.r>w-1&&(a.s.r=w-1),a.e.r<w-1&&(a.e.r=w-1),r&&r.cellStyles&&(R=!(C={}),c.ht&&(R=!0,C.hpt=parseFloat(c.ht),C.hpx=po(C.hpt)),"1"==c.hidden&&(R=!0,C.hidden=!0),null!=c.outlineLevel&&(R=!0,C.level=+c.outlineLevel),R&&(A[w-1]=C)),p=d.slice(u).split(bl);for(var L,M=0;M!=p.length&&"<"==p[M].trim().charAt(0);++M);for(p=p.slice(M),u=0;u!=p.length;++u)if(0!==(d=p[u].trim()).length){if(m=d.match(wl),g=u,b=0,d="<c "+("<"==d.slice(0,1)?">":"")+d,null!=m&&2===m.length){for(g=0,v=m[1],b=0;b!=v.length&&!((i=v.charCodeAt(b)-64)<1||26<i);++b)g=26*g+i;T=--g}else++T;for(b=0;b!=d.length&&62!==d.charCodeAt(b);++b);if(++b,(c=dt(d.slice(0,b),!0)).r||(c.r=Kr({r:w-1,c:T})),o={t:""},null!=(m=(v=d.slice(b)).match(kl))&&""!==m[1]&&(o.v=wt(m[1])),r.cellFormula){null!=(m=v.match(yl))&&""!==m[1]?(o.f=wt(Mt(m[1])).replace(/\r\n/g,"\n"),r.xlfn||(o.f=uc(o.f)),-1<m[0].indexOf('t="array"')?(o.F=(v.match(El)||[])[1],-1<o.F.indexOf(":")&&S.push([Zr(o.F),o.F])):-1<m[0].indexOf('t="shared"')&&(f=dt(m[0]),L=wt(Mt(m[1])),r.xlfn||(L=uc(L)),_[parseInt(f.si,10)]=[f,L,c.r])):(m=v.match(/<f[^>]*\/>/))&&_[(f=dt(m[0])).si]&&(o.f=(h=_[f.si][1],W=_[f.si][2],L=c.r,W=Jr(W).s,L=Yr(L),hc(h,{r:L.r-W.r,c:L.c-W.c})));for(var U=Yr(c.r),b=0;b<S.length;++b)U.r>=S[b][0].s.r&&U.r<=S[b][0].e.r&&U.c>=S[b][0].s.c&&U.c<=S[b][0].e.c&&(o.F=S[b][1])}if(null==c.t&&void 0===o.v)if(o.f||o.F)o.v=0,o.t="n";else{if(!O)continue;o.t="z"}else o.t=c.t||"n";switch(a.s.c>T&&(a.s.c=T),a.e.c<T&&(a.e.c=T),o.t){case"n":if(""==o.v||null==o.v){if(!O)continue;o.t="z"}else o.v=parseFloat(o.v);break;case"s":if(void 0===o.v){if(!O)continue;o.t="z"}else l=Yc[parseInt(o.v,10)],o.v=l.t,o.r=l.r,r.cellHTML&&(o.h=l.h);break;case"str":o.t="s",o.v=null!=o.v?Mt(o.v):"",r.cellHTML&&(o.h=_t(o.v));break;case"inlineStr":m=v.match(Tl),o.t="s",null!=m&&(l=Ai(m[1]))?(o.v=l.t,r.cellHTML&&(o.h=l.h)):o.v="";break;case"b":o.v=Rt(o.v);break;case"d":r.cellDates?o.v=He(o.v,1):(o.v=De(He(o.v,1)),o.t="n");break;case"e":r&&!1===r.cellText||(o.w=o.v),o.v=Ha[o.v]}var B,E=k=0,W=null;y&&void 0!==c.s&&null!=(W=s.CellXf[c.s])&&(null!=W.numFmtId&&(E=W.numFmtId),r.cellStyles&&null!=W.fillId&&(k=W.fillId)),tl(o,E,k,r,n,s),r.cellDates&&y&&"n"==o.t&&q(me[E])&&(o.t="d",o.v=Me(o.v)),c.cm&&r.xlmeta&&((B=(r.xlmeta.Cell||[])[+c.cm-1])&&"XLDAPR"==B.type&&(o.D=!0)),x?(t[(B=Yr(c.r)).r]||(t[B.r]=[]),t[B.r][B.c]=o):t[c.r]=o}}}}0<A.length&&(t["!rows"]=A)});function _l(e,t){for(var r,a,n,s,i=[],o=[],c=Zr(e["!ref"]),l=[],f=0,h=0,u=e["!rows"],d=Array.isArray(e),p={r:""},m=-1,h=c.s.c;h<=c.e.c;++h)l[h]=Xr(h);for(f=c.s.r;f<=c.e.r;++f){for(o=[],n=jr(f),h=c.s.c;h<=c.e.c;++h){a=l[h]+n;var g=d?(e[f]||[])[h]:e[a];void 0!==g&&null!=(r=function(e,t,r,a){if(e.c&&r["!comments"].push([t,e.c]),void 0===e.v&&"string"!=typeof e.f||"z"===e.t&&!e.f)return"";var n="",s=e.t,i=e.v;if("z"!==e.t)switch(e.t){case"b":n=e.v?"1":"0";break;case"n":n=""+e.v;break;case"e":n=Wa[e.v];break;case"d":n=a&&a.cellDates?He(e.v,-1).toISOString():((e=Ve(e)).t="n",""+(e.v=De(He(e.v)))),void 0===e.z&&(e.z=me[14]);break;default:n=e.v}var o=$t("v",kt(n)),c={r:t},l=el(a.cellXfs,e,a);switch(0!==l&&(c.s=l),e.t){case"n":break;case"d":c.t="d";break;case"b":c.t="b";break;case"e":c.t="e";break;case"z":break;default:if(null==e.v){delete e.t;break}if(32767<e.v.length)throw new Error("Text length must not exceed 32767 characters");if(a&&a.bookSST){o=$t("v",""+qc(a.Strings,e.v,a.revStrings)),c.t="s";break}c.t="str"}return e.t!=s&&(e.t=s,e.v=i),"string"==typeof e.f&&e.f&&(i=e.F&&e.F.slice(0,t.length)==t?{t:"array",ref:e.F}:null,o=Yt("f",kt(e.f),i)+(null!=e.v?o:"")),e.l&&r["!links"].push([t,e.l]),e.D&&(c.cm=1),Yt("c",o,c)}(g,a,e,t))&&o.push(r)}(0<o.length||u&&u[f])&&(p={r:n},u&&u[f]&&((s=u[f]).hidden&&(p.hidden=1),m=-1,s.hpx?m=uo(s.hpx):s.hpt&&(m=s.hpt),-1<m&&(p.ht=m,p.customHeight=1),s.level&&(p.outlineLevel=s.level)),i[i.length]=Yt("row",o.join(""),p))}if(u)for(;f<u.length;++f)u&&u[f]&&(p={r:f+1},(s=u[f]).hidden&&(p.hidden=1),m=-1,s.hpx?m=uo(s.hpx):s.hpt&&(m=s.hpt),-1<m&&(p.ht=m,p.customHeight=1),s.level&&(p.outlineLevel=s.level),i[i.length]=Yt("row","",p));return i.join("")}function xl(e,t,r,a){var n,s,i=[ot,Yt("worksheet",null,{xmlns:Qt[0],"xmlns:r":Zt.r})],o=r.SheetNames[e],c=r.Sheets[o],l=(c=null==c?{}:c)["!ref"]||"A1",f=Zr(l);if(16383<f.e.c||1048575<f.e.r){if(t.WTF)throw new Error("Range "+l+" exceeds format limit A1:XFD1048576");f.e.c=Math.min(f.e.c,16383),f.e.r=Math.min(f.e.c,1048575),l=qr(f)}a=a||{},c["!comments"]=[];var h,u,d=[];!function(e,t,r,a,n){var s=!1,i={},o=null;if("xlsx"!==a.bookType&&t.vbaraw){var c=t.SheetNames[r];try{t.Workbook&&(c=t.Workbook.Sheets[r].CodeName||c)}catch(e){}s=!0,i.codeName=Ut(kt(c))}e&&e["!outline"]&&(a={summaryBelow:1,summaryRight:1},e["!outline"].above&&(a.summaryBelow=0),e["!outline"].left&&(a.summaryRight=0),o=(o||"")+Yt("outlinePr",null,a)),(s||o)&&(n[n.length]=Yt("sheetPr",o,i))}(c,r,e,t,i),i[i.length]=Yt("dimension",null,{ref:l}),i[i.length]=(o={workbookViewId:"0"},((((f=r)||{}).Workbook||{}).Views||[])[0]&&(o.rightToLeft=f.Workbook.Views[0].RTL?"1":"0"),Yt("sheetViews",Yt("sheetView",null,o),{})),t.sheetFormat&&(i[i.length]=Yt("sheetFormatPr",null,{defaultRowHeight:t.sheetFormat.defaultRowHeight||"16",baseColWidth:t.sheetFormat.baseColWidth||"10",outlineLevelRow:t.sheetFormat.outlineLevelRow||"7"})),null!=c["!cols"]&&0<c["!cols"].length&&(i[i.length]=function(e){for(var t,r=["<cols>"],a=0;a!=e.length;++a)(t=e[a])&&(r[r.length]=Yt("col",null,Zc(a,t)));return r[r.length]="</cols>",r.join("")}(c["!cols"])),i[n=i.length]="<sheetData/>",c["!links"]=[],null!=c["!ref"]&&0<(s=_l(c,t)).length&&(i[i.length]=s),i.length>n+1&&(i[i.length]="</sheetData>",i[n]=i[n].replace("/>",">")),c["!protect"]&&(i[i.length]=(h=c["!protect"],u={sheet:1},pl.forEach(function(e){null!=h[e]&&h[e]&&(u[e]="1")}),ml.forEach(function(e){null==h[e]||h[e]||(u[e]="0")}),h.password&&(u.password=zi(h.password).toString(16).toUpperCase()),Yt("sheetProtection",null,u))),null!=c["!autofilter"]&&(i[i.length]=function(e,t,r,a){var n="string"==typeof e.ref?e.ref:qr(e.ref);r.Workbook||(r.Workbook={Sheets:[]}),r.Workbook.Names||(r.Workbook.Names=[]);var s=r.Workbook.Names;(e=Jr(n)).s.r==e.e.r&&(e.e.r=Jr(t["!ref"]).e.r,n=qr(e));for(var i=0;i<s.length;++i){var o=s[i];if("_xlnm._FilterDatabase"==o.Name&&o.Sheet==a){o.Ref="'"+r.SheetNames[a]+"'!"+n;break}}return i==s.length&&s.push({Name:"_xlnm._FilterDatabase",Sheet:a,Ref:"'"+r.SheetNames[a]+"'!"+n}),Yt("autoFilter",null,{ref:n})}(c["!autofilter"],c,r,e)),null!=c["!merges"]&&0<c["!merges"].length&&(i[i.length]=function(e){if(0===e.length)return"";for(var t='<mergeCells count="'+e.length+'">',r=0;r!=e.length;++r)t+='<mergeCell ref="'+qr(e[r])+'"/>';return t+"</mergeCells>"}(c["!merges"]));var p,m,g=-1;return 0<c["!links"].length&&(i[i.length]="<hyperlinks>",c["!links"].forEach(function(e){e[1].Target&&(m={ref:e[0]},"#"!=e[1].Target.charAt(0)&&(g=Ja(a,-1,kt(e[1].Target).replace(/#.*$/,""),$a.HLINK),m["r:id"]="rId"+g),-1<(p=e[1].Target.indexOf("#"))&&(m.location=kt(e[1].Target.slice(p+1))),e[1].Tooltip&&(m.tooltip=kt(e[1].Tooltip)),i[i.length]=Yt("hyperlink",null,m))}),i[i.length]="</hyperlinks>"),delete c["!links"],null!=c["!margins"]&&(i[i.length]=(Qc(r=c["!margins"]),Yt("pageMargins",null,r))),t&&!t.ignoreEC&&null!=t.ignoreEC||(i[i.length]=$t("ignoredErrors",Yt("ignoredError",null,{numberStoredAsText:1,sqref:l}))),0<d.length&&(g=Ja(a,-1,"../drawings/drawing"+(e+1)+".xml",$a.DRAW),i[i.length]=Yt("drawing",null,{"r:id":"rId"+g}),c["!drawing"]=d),0<c["!comments"].length&&(g=Ja(a,-1,"../drawings/vmlDrawing"+(e+1)+".vml",$a.VML),i[i.length]=Yt("legacyDrawing",null,{"r:id":"rId"+g}),c["!legacy"]=g),1<i.length&&(i[i.length]="</worksheet>",i[1]=i[1].replace("/>",">")),i.join("")}function Al(e,t,r,a){r=function(e,t,r){var a=Lr(145),n=(r["!rows"]||[])[e]||{};a.write_shift(4,e),a.write_shift(4,0);var s=320;n.hpx?s=20*uo(n.hpx):n.hpt&&(s=20*n.hpt),a.write_shift(2,s),a.write_shift(1,0),s=0,n.level&&(s|=n.level),n.hidden&&(s|=16),(n.hpx||n.hpt)&&(s|=32),a.write_shift(1,s),a.write_shift(1,0);var i=0,s=a.l;a.l+=4;for(var o={r:e,c:0},c=0;c<16;++c)if(!(t.s.c>c+1<<10||t.e.c<c<<10)){for(var l=-1,f=-1,h=c<<10;h<c+1<<10;++h)o.c=h,(Array.isArray(r)?(r[o.r]||[])[o.c]:r[Kr(o)])&&(l<0&&(l=h),f=h);l<0||(++i,a.write_shift(4,l),a.write_shift(4,f))}return e=a.l,a.l=s,a.write_shift(4,i),a.l=e,a.length>a.l?a.slice(0,a.l):a}(a,r,t);(17<r.length||(t["!rows"]||[])[a])&&Br(e,0,r)}var lt=Sa,Cl=_a;function Rl(e){return[ua(e),xa(e),"n"]}var Lt=Sa,Ol=_a;var Il=["left","right","top","bottom","header","footer"];function Nl(e,t,r,a,n,s,i){if(void 0===t.v)return!1;var o="";switch(t.t){case"b":o=t.v?"1":"0";break;case"d":(t=Ve(t)).z=t.z||me[14],t.v=De(He(t.v)),t.t="n";break;case"n":case"e":o=""+t.v;break;default:o=t.v}var c,l,f,h,u,d,p,m,g,b,v,w,T,E,k,y,S,_,x,A,C={r:r,c:a};switch(C.s=el(n.cellXfs,t,n),t.l&&s["!links"].push([Kr(C),t.l]),t.c&&s["!comments"].push([Kr(C),t.c]),t.t){case"s":case"str":return n.bookSST?(o=qc(n.Strings,t.v,n.revStrings),C.t="s",C.v=o,i?Br(e,18,(da(S=C,_=null==_?Lr(8):_),_.write_shift(4,S.v),_)):Br(e,7,(ha(S=C,y=null==y?Lr(12):y),y.write_shift(4,S.v),y))):(C.t="str",i?Br(e,17,(E=t,da(C,k=null==k?Lr(8+4*E.v.length):k),ia(E.v,k),k.length>k.l?k.slice(0,k.l):k)):Br(e,6,(E=t,ha(C,T=null==T?Lr(12+4*E.v.length):T),ia(E.v,T),T.length>T.l?T.slice(0,T.l):T))),!0;case"n":return t.v==(0|t.v)&&-1e3<t.v&&t.v<1e3?i?Br(e,13,(v=t,da(C,w=null==w?Lr(8):w),ka(v.v,w),w)):Br(e,2,(v=t,ha(C,b=null==b?Lr(12):b),ka(v.v,b),b)):i?Br(e,16,(m=t,da(C,g=null==g?Lr(12):g),Aa(m.v,g),g)):Br(e,5,(m=t,ha(C,p=null==p?Lr(16):p),Aa(m.v,p),p)),!0;case"b":return C.t="b",i?Br(e,15,(u=t,da(C,d=null==d?Lr(5):d),d.write_shift(1,u.v?1:0),d)):Br(e,4,(u=t,ha(C,h=null==h?Lr(9):h),h.write_shift(1,u.v?1:0),h)),!0;case"e":return C.t="e",i?Br(e,14,(l=t,da(C,f=null==f?Lr(8):f),f.write_shift(1,l.v),f.write_shift(2,0),f.write_shift(1,0),f)):Br(e,3,(l=t,ha(C,c=null==c?Lr(9):c),c.write_shift(1,l.v),c)),!0}return i?Br(e,12,da(C,A=null==A?Lr(4):A)):Br(e,1,ha(C,x=null==x?Lr(8):x)),!0}function Fl(t,e){var r,a;e&&e["!merges"]&&(Br(t,177,(r=e["!merges"].length,(a=null==a?Lr(4):a).write_shift(4,r),a)),e["!merges"].forEach(function(e){Br(t,176,Ol(e))}),Br(t,178))}function Dl(r,e){e&&e["!cols"]&&(Br(r,390),e["!cols"].forEach(function(e,t){e&&Br(r,60,function(e,t,r){null==r&&(r=Lr(18));var a=Zc(e,t);return r.write_shift(-4,e),r.write_shift(-4,e),r.write_shift(4,256*(a.width||10)),r.write_shift(4,0),e=0,t.hidden&&(e|=1),"number"==typeof a.width&&(e|=2),t.level&&(e|=t.level<<8),r.write_shift(2,e),r}(t,e))}),Br(r,391))}function Pl(e,t){var r;t&&t["!ref"]&&(Br(e,648),Br(e,649,(r=Zr(t["!ref"]),(t=Lr(24)).write_shift(4,4),t.write_shift(4,1),_a(r,t),t)),Br(e,650))}function Ll(a,e,n){e["!links"].forEach(function(e){var t,r;e[1].Target&&(t=Ja(n,-1,e[1].Target.replace(/#.*$/,""),$a.HLINK),Br(a,494,(r=t,e=Lr(50+4*((t=e)[1].Target.length+(t[1].Tooltip||"").length)),_a({s:Yr(t[0]),e:Yr(t[0])},e),Ta("rId"+r,e),ia((-1==(r=t[1].Target.indexOf("#"))?"":t[1].Target.slice(r+1))||"",e),ia(t[1].Tooltip||"",e),ia("",e),e.slice(0,e.l))))}),delete e["!links"]}function Ml(e,t,r){Br(e,133),Br(e,137,function(e,t){null==t&&(t=Lr(30));var r=924;return(((e||{}).Views||[])[0]||{}).RTL&&(r|=32),t.write_shift(2,r),t.write_shift(4,0),t.write_shift(4,0),t.write_shift(4,0),t.write_shift(1,0),t.write_shift(1,0),t.write_shift(2,0),t.write_shift(2,100),t.write_shift(2,0),t.write_shift(2,0),t.write_shift(2,0),t.write_shift(4,0),t}(r)),Br(e,138),Br(e,134)}function Ul(e,t){var r,a;t["!protect"]&&Br(e,535,(r=t["!protect"],(a=null==a?Lr(66):a).write_shift(2,r.password?zi(r.password):0),a.write_shift(4,1),[["objects",!1],["scenarios",!1],["formatCells",!0],["formatColumns",!0],["formatRows",!0],["insertColumns",!0],["insertRows",!0],["insertHyperlinks",!0],["deleteColumns",!0],["deleteRows",!0],["selectLockedCells",!1],["sort",!0],["autoFilter",!0],["pivotTables",!0],["selectUnlockedCells",!1]].forEach(function(e){e[1]?a.write_shift(4,null==r[e[0]]||r[e[0]]?0:1):a.write_shift(4,null!=r[e[0]]&&r[e[0]]?0:1)}),a))}function Bl(e,t,r,a){var n=Ur(),s=r.SheetNames[e],i=r.Sheets[s]||{},o=s;try{r&&r.Workbook&&(o=r.Workbook.Sheets[e].CodeName||o)}catch(e){}var c,l,s=Zr(i["!ref"]||"A1");if(16383<s.e.c||1048575<s.e.r){if(t.WTF)throw new Error("Range "+(i["!ref"]||"A1")+" exceeds format limit A1:XFD1048576");s.e.c=Math.min(s.e.c,16383),s.e.r=Math.min(s.e.c,1048575)}return i["!links"]=[],i["!comments"]=[],Br(n,129),(r.vbaraw||i["!outline"])&&Br(n,147,function(e,t,r){null==r&&(r=Lr(84+4*e.length));var a=192;t&&(t.above&&(a&=-65),t.left&&(a&=-129)),r.write_shift(1,a);for(var n=1;n<3;++n)r.write_shift(1,0);return Ca({auto:1},r),r.write_shift(-4,-1),r.write_shift(-4,-1),ma(e,r),r.slice(0,r.l)}(o,i["!outline"])),Br(n,148,Cl(s)),Ml(n,0,r.Workbook),Dl(n,i),function(e,t,r){var a,n=Zr(t["!ref"]||"A1"),s=[];Br(e,145);var i=Array.isArray(t),o=n.e.r;t["!rows"]&&(o=Math.max(n.e.r,t["!rows"].length-1));for(var c=n.s.r;c<=o;++c){a=jr(c),Al(e,t,n,c);var l=!1;if(c<=n.e.r)for(var f=n.s.c;f<=n.e.c;++f){c===n.s.r&&(s[f]=Xr(f)),h=s[f]+a;var h=i?(t[c]||[])[f]:t[h];h?l=Nl(e,h,c,f,r,t,l):l=!1}}Br(e,146)}(n,i,t),Ul(n,i),function(e,t,r,a){if(t["!autofilter"]){var n=t["!autofilter"],s="string"==typeof n.ref?n.ref:qr(n.ref);r.Workbook||(r.Workbook={Sheets:[]}),r.Workbook.Names||(r.Workbook.Names=[]);var i=r.Workbook.Names,n=Jr(s);n.s.r==n.e.r&&(n.e.r=Jr(t["!ref"]).e.r,s=qr(n));for(var o=0;o<i.length;++o){var c=i[o];if("_xlnm._FilterDatabase"==c.Name&&c.Sheet==a){c.Ref="'"+r.SheetNames[a]+"'!"+s;break}}o==i.length&&i.push({Name:"_xlnm._FilterDatabase",Sheet:a,Ref:"'"+r.SheetNames[a]+"'!"+s}),Br(e,161,_a(Zr(s))),Br(e,162)}}(n,i,r,e),Fl(n,i),Ll(n,i,a),i["!margins"]&&Br(n,476,(c=i["!margins"],null==l&&(l=Lr(48)),Qc(c),Il.forEach(function(e){Aa(c[e],l)}),l)),t&&!t.ignoreEC&&null!=t.ignoreEC||Pl(n,i),s=n,t=e,a=a,0<(i=i)["!comments"].length&&(t=Ja(a,-1,"../drawings/vmlDrawing"+(t+1)+".vml",$a.VML),Br(s,551,Ta("rId"+t)),i["!legacy"]=t),Br(n,130),n.end()}function Wl(e,t,r,a,n,s){var i=s||{"!type":"chart"};if(!e)return s;var o,c=0,l=0,f={s:{r:2e6,c:2e6},e:{r:0,c:0}};return(e.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(e){var r=function(e){var t,r=[],a=e.match(/^<c:numCache>/);(e.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/gm)||[]).forEach(function(e){e=e.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);e&&(r[+e[1]]=a?+e[2]:e[2])});var n=wt((e.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/)||["","General"])[1]);return(e.match(/<c:f>(.*?)<\/c:f>/gm)||[]).forEach(function(e){t=e.replace(/<.*?>/g,"")}),[r,n,t]}(e);f.s.r=f.s.c=0,f.e.c=c,o=Xr(c),r[0].forEach(function(e,t){i[o+jr(t)]={t:"n",v:e,z:r[1]},l=t}),f.e.r<l&&(f.e.r=l),++c}),0<c&&(i["!ref"]=qr(f)),i}var Hl=[["allowRefreshQuery",!1,"bool"],["autoCompressPictures",!0,"bool"],["backupFile",!1,"bool"],["checkCompatibility",!1,"bool"],["CodeName",""],["date1904",!1,"bool"],["defaultThemeVersion",0,"int"],["filterPrivacy",!1,"bool"],["hidePivotFieldList",!1,"bool"],["promptedSolutions",!1,"bool"],["publishItems",!1,"bool"],["refreshAllConnections",!1,"bool"],["saveExternalLinkValues",!0,"bool"],["showBorderUnselectedTables",!0,"bool"],["showInkAnnotation",!0,"bool"],["showObjects","all"],["showPivotChartFilter",!1,"bool"],["updateLinks","userSet"]],zl=[["activeTab",0,"int"],["autoFilterDateGrouping",!0,"bool"],["firstSheet",0,"int"],["minimized",!1,"bool"],["showHorizontalScroll",!0,"bool"],["showSheetTabs",!0,"bool"],["showVerticalScroll",!0,"bool"],["tabRatio",600,"int"],["visibility","visible"]],Vl=[],Gl=[["calcCompleted","true"],["calcMode","auto"],["calcOnSave","true"],["concurrentCalc","true"],["fullCalcOnLoad","false"],["fullPrecision","true"],["iterate","false"],["iterateCount","100"],["iterateDelta","0.001"],["refMode","A1"]];function jl(e,t){for(var r=0;r!=e.length;++r)for(var a=e[r],n=0;n!=t.length;++n){var s=t[n];if(null==a[s[0]])a[s[0]]=s[1];else switch(s[2]){case"bool":"string"==typeof a[s[0]]&&(a[s[0]]=Rt(a[s[0]]));break;case"int":"string"==typeof a[s[0]]&&(a[s[0]]=parseInt(a[s[0]],10))}}}function $l(e,t){for(var r=0;r!=t.length;++r){var a=t[r];if(null==e[a[0]])e[a[0]]=a[1];else switch(a[2]){case"bool":"string"==typeof e[a[0]]&&(e[a[0]]=Rt(e[a[0]]));break;case"int":"string"==typeof e[a[0]]&&(e[a[0]]=parseInt(e[a[0]],10))}}}function Xl(e){$l(e.WBProps,Hl),$l(e.CalcPr,Gl),jl(e.WBView,zl),jl(e.Sheets,Vl),Kc.date1904=Rt(e.WBProps.date1904)}var Yl="][*?/\\".split("");function Kl(t,r){if(31<t.length){if(r)return;throw new Error("Sheet names cannot exceed 31 chars")}var a=!0;return Yl.forEach(function(e){if(-1!=t.indexOf(e)){if(!r)throw new Error("Sheet name cannot contain : \\ / ? * [ ]");a=!1}}),a}function Jl(e){if(!e||!e.SheetNames||!e.Sheets)throw new Error("Invalid Workbook");if(!e.SheetNames.length)throw new Error("Workbook is empty");var n,s,i,t=e.Workbook&&e.Workbook.Sheets||[];n=e.SheetNames,s=t,i=!!e.vbaraw,n.forEach(function(e,t){Kl(e);for(var r=0;r<t;++r)if(e==n[r])throw new Error("Duplicate Sheet Name: "+e);if(i){var a=s&&s[t]&&s[t].CodeName||e;if(95==a.charCodeAt(0)&&22<a.length)throw new Error("Bad Code Name: Worksheet"+a)}});for(var r=0;r<e.SheetNames.length;++r)!function(e,t){if(e&&e["!ref"]){var r=Zr(e["!ref"]);if(r.e.c<r.s.c||r.e.r<r.s.r)throw new Error("Bad range ("+t+"): "+e["!ref"])}}(e.Sheets[e.SheetNames[r]],(e.SheetNames[r],r))}var ql=/<\w+:workbook/;function Zl(t){var r=[ot];r[r.length]=Yt("workbook",null,{xmlns:Qt[0],"xmlns:r":Zt.r});var e=t.Workbook&&0<(t.Workbook.Names||[]).length,a={codeName:"ThisWorkbook"};t.Workbook&&t.Workbook.WBProps&&(Hl.forEach(function(e){null!=t.Workbook.WBProps[e[0]]&&t.Workbook.WBProps[e[0]]!=e[1]&&(a[e[0]]=t.Workbook.WBProps[e[0]])}),t.Workbook.WBProps.CodeName&&(a.codeName=t.Workbook.WBProps.CodeName,delete a.CodeName)),r[r.length]=Yt("workbookPr",null,a);var n=t.Workbook&&t.Workbook.Sheets||[],s=0;if(n&&n[0]&&n[0].Hidden){for(r[r.length]="<bookViews>",s=0;s!=t.SheetNames.length&&n[s]&&n[s].Hidden;++s);s==t.SheetNames.length&&(s=0),r[r.length]='<workbookView firstSheet="'+s+'" activeTab="'+s+'"/>',r[r.length]="</bookViews>"}for(r[r.length]="<sheets>",s=0;s!=t.SheetNames.length;++s){var i={name:kt(t.SheetNames[s].slice(0,31))};if(i.sheetId=""+(s+1),i["r:id"]="rId"+(s+1),n[s])switch(n[s].Hidden){case 1:i.state="hidden";break;case 2:i.state="veryHidden"}r[r.length]=Yt("sheet",null,i)}return r[r.length]="</sheets>",e&&(r[r.length]="<definedNames>",t.Workbook&&t.Workbook.Names&&t.Workbook.Names.forEach(function(e){var t={name:e.Name};e.Comment&&(t.comment=e.Comment),null!=e.Sheet&&(t.localSheetId=""+e.Sheet),e.Hidden&&(t.hidden="1"),e.Ref&&(r[r.length]=Yt("definedName",kt(e.Ref),t))}),r[r.length]="</definedNames>"),2<r.length&&(r[r.length]="</workbook>",r[1]=r[1].replace("/>",">")),r.join("")}function Ql(e,t){var r={};return e.read_shift(4),r.ArchID=e.read_shift(4),e.l+=t-8,r}function ef(e,t){Br(e,143);for(var r,a=0;a!=t.SheetNames.length;++a){var n={Hidden:t.Workbook&&t.Workbook.Sheets&&t.Workbook.Sheets[a]&&t.Workbook.Sheets[a].Hidden||0,iTabID:a+1,strRelID:"rId"+(a+1),name:t.SheetNames[a]};Br(e,156,(r=n,(n=(n=void 0)||Lr(127)).write_shift(4,r.Hidden),n.write_shift(4,r.iTabID),Ta(r.strRelID,n),ia(r.name.slice(0,31),n),n.length>n.l?n.slice(0,n.l):n))}Br(e,144)}function tf(e,t){if(t.Workbook&&t.Workbook.Sheets){for(var r,a=t.Workbook.Sheets,n=0,s=-1,i=-1;n<a.length;++n)!a[n]||!a[n].Hidden&&-1==s?s=n:1==a[n].Hidden&&-1==i&&(i=n);s<i||(Br(e,135),Br(e,158,(t=s,(r=r||Lr(29)).write_shift(-4,0),r.write_shift(-4,460),r.write_shift(4,28800),r.write_shift(4,17600),r.write_shift(4,500),r.write_shift(4,t),r.write_shift(4,t),r.write_shift(1,120),r.length>r.l?r.slice(0,r.l):r)),Br(e,136))}}function rf(e,t){var r=Ur();return Br(r,131),Br(r,128,function(e){e=e||Lr(127);for(var t=0;4!=t;++t)e.write_shift(4,0);return ia("SheetJS",e),ia(a.version,e),ia(a.version,e),ia("7262",e),e.length>e.l?e.slice(0,e.l):e}()),Br(r,153,function(e,t){t=t||Lr(72);var r=0;return e&&e.filterPrivacy&&(r|=8),t.write_shift(4,r),t.write_shift(4,0),ma(e&&e.CodeName||"ThisWorkbook",t),t.slice(0,t.l)}(e.Workbook&&e.Workbook.WBProps||null)),tf(r,e),ef(r,e),Br(r,132),r.end()}function af(e,t,r){return(".bin"===t.slice(-4)?function(e,a){var n={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},xmlns:""},s=[],i=!1;(a=a||{}).biff=12;var o=[],c=[[]];return c.SheetNames=[],c.XTI=[],Df[16]={n:"BrtFRTArchID$",f:Ql},Mr(e,function(e,t,r){switch(r){case 156:c.SheetNames.push(e.name),n.Sheets.push(e);break;case 153:n.WBProps=e;break;case 39:null!=e.Sheet&&(a.SID=e.Sheet),e.Ref=Pc(e.Ptg,0,null,c,a),delete a.SID,delete e.Ptg,o.push(e);break;case 1036:break;case 357:case 358:case 355:case 667:c[0].length?c.push([r,e]):c[0]=[r,e],c[c.length-1].XTI=[];break;case 362:0===c.length&&(c[0]=[],c[0].XTI=[]),c[c.length-1].XTI=c[c.length-1].XTI.concat(e),c.XTI=c.XTI.concat(e);break;case 361:break;case 2071:case 158:case 143:case 664:case 353:break;case 3072:case 3073:case 534:case 677:case 157:case 610:case 2050:case 155:case 548:case 676:case 128:case 665:case 2128:case 2125:case 549:case 2053:case 596:case 2076:case 2075:case 2082:case 397:case 154:case 1117:case 553:case 2091:break;case 35:s.push(r),i=!0;break;case 36:s.pop(),i=!1;break;case 37:s.push(r),i=!0;break;case 38:s.pop(),i=!1;break;case 16:break;default:if(!t.T&&(!i||a.WTF&&37!=s[s.length-1]&&35!=s[s.length-1]))throw new Error("Unexpected record 0x"+r.toString(16))}},a),Xl(n),n.Names=o,n.supbooks=c,n}:function(a,n){if(!a)throw new Error("Could not find file");var s={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},Names:[],xmlns:""},i=!1,o="xmlns",c={},l=0;if(a.replace(ft,function(e,t){var r=dt(e);switch(pt(r[0])){case"<?xml":break;case"<workbook":e.match(ql)&&(o="xmlns"+e.match(/<(\w+):/)[1]),s.xmlns=r[o];break;case"</workbook>":break;case"<fileVersion":delete r[0],s.AppVersion=r;break;case"<fileVersion/>":case"</fileVersion>":case"<fileSharing":case"<fileSharing/>":break;case"<workbookPr":case"<workbookPr/>":Hl.forEach(function(e){if(null!=r[e[0]])switch(e[2]){case"bool":s.WBProps[e[0]]=Rt(r[e[0]]);break;case"int":s.WBProps[e[0]]=parseInt(r[e[0]],10);break;default:s.WBProps[e[0]]=r[e[0]]}}),r.codeName&&(s.WBProps.CodeName=Mt(r.codeName));break;case"</workbookPr>":case"<workbookProtection":case"<workbookProtection/>":break;case"<bookViews":case"<bookViews>":case"</bookViews>":break;case"<workbookView":case"<workbookView/>":delete r[0],s.WBView.push(r);break;case"</workbookView>":break;case"<sheets":case"<sheets>":case"</sheets>":break;case"<sheet":switch(r.state){case"hidden":r.Hidden=1;break;case"veryHidden":r.Hidden=2;break;default:r.Hidden=0}delete r.state,r.name=wt(Mt(r.name)),delete r[0],s.Sheets.push(r);break;case"</sheet>":break;case"<functionGroups":case"<functionGroups/>":case"<functionGroup":break;case"<externalReferences":case"</externalReferences>":case"<externalReferences>":case"<externalReference":case"<definedNames/>":break;case"<definedNames>":case"<definedNames":i=!0;break;case"</definedNames>":i=!1;break;case"<definedName":(c={}).Name=Mt(r.name),r.comment&&(c.Comment=r.comment),r.localSheetId&&(c.Sheet=+r.localSheetId),Rt(r.hidden||"0")&&(c.Hidden=!0),l=t+e.length;break;case"</definedName>":c.Ref=wt(Mt(a.slice(l,t))),s.Names.push(c);break;case"<definedName/>":break;case"<calcPr":case"<calcPr/>":delete r[0],s.CalcPr=r;break;case"</calcPr>":case"<oleSize":break;case"<customWorkbookViews>":case"</customWorkbookViews>":case"<customWorkbookViews":break;case"<customWorkbookView":case"</customWorkbookView>":break;case"<pivotCaches>":case"</pivotCaches>":case"<pivotCaches":case"<pivotCache":break;case"<smartTagPr":case"<smartTagPr/>":break;case"<smartTagTypes":case"<smartTagTypes>":case"</smartTagTypes>":case"<smartTagType":break;case"<webPublishing":case"<webPublishing/>":break;case"<fileRecoveryPr":case"<fileRecoveryPr/>":break;case"<webPublishObjects>":case"<webPublishObjects":case"</webPublishObjects>":case"<webPublishObject":break;case"<extLst":case"<extLst>":case"</extLst>":case"<extLst/>":break;case"<ext":i=!0;break;case"</ext>":i=!1;break;case"<ArchID":break;case"<AlternateContent":case"<AlternateContent>":i=!0;break;case"</AlternateContent>":i=!1;break;case"<revisionPtr":break;default:if(!i&&n.WTF)throw new Error("unrecognized "+r[0]+" in workbook")}return e}),-1===Qt.indexOf(s.xmlns))throw new Error("Unknown Namespace: "+s.xmlns);return Xl(s),s})(e,r)}function nf(e,t,r,a,n,s,i,o){return(".bin"===t.slice(-4)?function(e,t,s,i,o,c,l){if(!e)return e;var f=t||{};i=i||{"!id":{}},null!=oe&&null==f.dense&&(f.dense=oe);var h,u,d,p,m,g,b,v,w,T,E=f.dense?[]:{},k={s:{r:2e6,c:2e6},e:{r:0,c:0}},y=[],S=!1,_=!1,x=[];f.biff=12;var A=f["!row"]=0,C=!1,R=[],O={},I=f.supbooks||o.supbooks||[[]];if(I.sharedf=O,I.arrayf=R,I.SheetNames=o.SheetNames||o.Sheets.map(function(e){return e.name}),!f.supbooks&&(f.supbooks=I,o.Names))for(var r=0;r<o.Names.length;++r)I[0][r+1]=o.Names[r];var N,F=[],D=[],P=!1;return Df[16]={n:"BrtShortReal",f:Rl},Mr(e,function(e,t,r){if(!_)switch(r){case 148:h=e;break;case 0:u=e,f.sheetRows&&f.sheetRows<=u.r&&(_=!0),w=jr(m=u.r),f["!row"]=u.r,(e.hidden||e.hpt||null!=e.level)&&(e.hpt&&(e.hpx=po(e.hpt)),D[e.r]=e);break;case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:case 11:case 13:case 14:case 15:case 16:case 17:case 18:case 62:switch(d={t:e[2]},e[2]){case"n":d.v=e[1];break;case"s":v=Yc[e[1]],d.v=v.t,d.r=v.r;break;case"b":d.v=!!e[1];break;case"e":d.v=e[1],!1!==f.cellText&&(d.w=Wa[d.v]);break;case"str":d.t="s",d.v=e[1];break;case"is":d.t="s",d.v=e[1].t}if((p=l.CellXf[e[0].iStyleRef])&&tl(d,p.numFmtId,null,f,c,l),g=-1==e[0].c?g+1:e[0].c,f.dense?(E[m]||(E[m]=[]),E[m][g]=d):E[Xr(g)+w]=d,f.cellFormula){for(C=!1,A=0;A<R.length;++A){var a=R[A];u.r>=a[0].s.r&&u.r<=a[0].e.r&&g>=a[0].s.c&&g<=a[0].e.c&&(d.F=qr(a[0]),C=!0)}!C&&3<e.length&&(d.f=e[3])}k.s.r>u.r&&(k.s.r=u.r),k.s.c>g&&(k.s.c=g),k.e.r<u.r&&(k.e.r=u.r),k.e.c<g&&(k.e.c=g),f.cellDates&&p&&"n"==d.t&&q(me[p.numFmtId])&&((n=L(d.v))&&(d.t="d",d.v=new Date(n.y,n.m-1,n.d,n.H,n.M,n.S,n.u))),N&&("XLDAPR"==N.type&&(d.D=!0),N=void 0),0;break;case 1:case 12:if(!f.sheetStubs||S)break;d={t:"z",v:void 0},g=-1==e[0].c?g+1:e[0].c,f.dense?(E[m]||(E[m]=[]),E[m][g]=d):E[Xr(g)+w]=d,k.s.r>u.r&&(k.s.r=u.r),k.s.c>g&&(k.s.c=g),k.e.r<u.r&&(k.e.r=u.r),k.e.c<g&&(k.e.c=g),N&&("XLDAPR"==N.type&&(d.D=!0),N=void 0),0;break;case 176:x.push(e);break;case 49:N=((f.xlmeta||{}).Cell||[])[e-1];break;case 494:var n=i["!id"][e.relId];for(n?(e.Target=n.Target,e.loc&&(e.Target+="#"+e.loc),e.Rel=n):""==e.relId&&(e.Target="#"+e.loc),m=e.rfx.s.r;m<=e.rfx.e.r;++m)for(g=e.rfx.s.c;g<=e.rfx.e.c;++g)f.dense?(E[m]||(E[m]=[]),E[m][g]||(E[m][g]={t:"z",v:void 0}),E[m][g].l=e):(b=Kr({c:g,r:m}),E[b]||(E[b]={t:"z",v:void 0}),E[b].l=e);break;case 426:if(!f.cellFormula)break;R.push(e),(T=f.dense?E[m][g]:E[Xr(g)+w]).f=Pc(e[1],0,{r:u.r,c:g},I,f),T.F=qr(e[0]);break;case 427:if(!f.cellFormula)break;O[Kr(e[0].s)]=e[1],(T=f.dense?E[m][g]:E[Xr(g)+w]).f=Pc(e[1],0,{r:u.r,c:g},I,f);break;case 60:if(!f.cellStyles)break;for(;e.e>=e.s;)F[e.e--]={width:e.w/256,hidden:!!(1&e.flags),level:e.level},P||(P=!0,lo(e.w/256)),fo(F[e.e+1]);break;case 161:E["!autofilter"]={ref:qr(e)};break;case 476:E["!margins"]=e;break;case 147:o.Sheets[s]||(o.Sheets[s]={}),e.name&&(o.Sheets[s].CodeName=e.name),(e.above||e.left)&&(E["!outline"]={above:e.above,left:e.left});break;case 137:o.Views||(o.Views=[{}]),o.Views[0]||(o.Views[0]={}),e.RTL&&(o.Views[0].RTL=!0);break;case 485:break;case 64:case 1053:case 151:break;case 152:case 175:case 644:case 625:case 562:case 396:case 1112:case 1146:case 471:case 1050:case 649:case 1105:case 589:case 607:case 564:case 1055:case 168:case 174:case 1180:case 499:case 507:case 550:case 171:case 167:case 1177:case 169:case 1181:case 551:case 552:case 661:case 639:case 478:case 537:case 477:case 536:case 1103:case 680:case 1104:case 1024:case 663:case 535:case 678:case 504:case 1043:case 428:case 170:case 3072:case 50:case 2070:case 1045:break;case 35:S=!0;break;case 36:S=!1;break;case 37:y.push(r),S=!0;break;case 38:y.pop(),S=!1;break;default:if(!t.T&&(!S||f.WTF))throw new Error("Unexpected record 0x"+r.toString(16))}},f),delete f.supbooks,delete f["!row"],!E["!ref"]&&(k.s.r<2e6||h&&(0<h.e.r||0<h.e.c||0<h.s.r||0<h.s.c))&&(E["!ref"]=qr(h||k)),f.sheetRows&&E["!ref"]&&(e=Zr(E["!ref"]),f.sheetRows<=+e.e.r&&(e.e.r=f.sheetRows-1,e.e.r>k.e.r&&(e.e.r=k.e.r),e.e.r<e.s.r&&(e.s.r=e.e.r),e.e.c>k.e.c&&(e.e.c=k.e.c),e.e.c<e.s.c&&(e.s.c=e.e.c),E["!fullref"]=E["!ref"],E["!ref"]=qr(e))),0<x.length&&(E["!merges"]=x),0<F.length&&(E["!cols"]=F),0<D.length&&(E["!rows"]=D),E}:ul)(e,a,r,n,s,i,o)}function sf(e,t,r,a,n,s){return".bin"===t.slice(-4)?function(e,a,n,t,s){if(!e)return e;t=t||{"!id":{}};var i={"!type":"chart","!drawel":null,"!rel":""},o=[],c=!1;return Mr(e,function(e,t,r){switch(r){case 550:i["!rel"]=e;break;case 651:s.Sheets[n]||(s.Sheets[n]={}),e.name&&(s.Sheets[n].CodeName=e.name);break;case 562:case 652:case 669:case 679:case 551:case 552:case 476:case 3072:break;case 35:c=!0;break;case 36:c=!1;break;case 37:o.push(r);break;case 38:o.pop();break;default:if(0<t.T)o.push(r);else if(t.T<0)o.pop();else if(!c||a.WTF)throw new Error("Unexpected record 0x"+r.toString(16))}},a),t["!id"][i["!rel"]]&&(i["!drawel"]=t["!id"][i["!rel"]]),i}(e,a,r,n,s):function(e,t,r,a){if(!e)return e;r=r||{"!id":{}};var n={"!type":"chart","!drawel":null,"!rel":""},s=e.match(ll);return s&&dl(s[0],0,a,t),(e=e.match(/drawing r:id="(.*?)"/))&&(n["!rel"]=e[1]),r["!id"][n["!rel"]]&&(n["!drawel"]=r["!id"][n["!rel"]]),n}(e,r,n,s)}function of(e,t,r,a){return(".bin"===t.slice(-4)?function(e,a,n){var t,s={NumberFmt:[]};for(t in me)s.NumberFmt[t]=me[t];s.CellXf=[],s.Fonts=[];var i=[],o=!1;return Mr(e,function(e,t,r){switch(r){case 44:s.NumberFmt[e[0]]=e[1],we(e[1],e[0]);break;case 43:s.Fonts.push(e),null!=e.color.theme&&a&&a.themeElements&&a.themeElements.clrScheme&&(e.color.rgb=eo(a.themeElements.clrScheme[e.color.theme].rgb,e.color.tint||0));break;case 1025:case 45:case 46:break;case 47:617==i[i.length-1]&&s.CellXf.push(e);break;case 48:case 507:case 572:case 475:break;case 1171:case 2102:case 1130:case 512:case 2095:case 3072:break;case 35:o=!0;break;case 36:o=!1;break;case 37:i.push(r),o=!0;break;case 38:i.pop(),o=!1;break;default:if(0<t.T)i.push(r);else if(t.T<0)i.pop();else if(!o||n.WTF&&37!=i[i.length-1])throw new Error("Unexpected record 0x"+r.toString(16))}}),s}:So)(e,r,a)}function cf(e,t,r){return".bin"===t.slice(-4)?(a=r,s=!(n=[]),Mr(e,function(e,t,r){switch(r){case 159:n.Count=e[0],n.Unique=e[1];break;case 19:n.push(e);break;case 160:return 1;case 35:s=!0;break;case 36:s=!1;break;default:if(t.T,!s||a.WTF)throw new Error("Unexpected record 0x"+r.toString(16))}}),n):function(e,t){var r=[],a="";if(!e)return r;if(e=e.match(Ci)){a=e[2].replace(Ri,"").split(Oi);for(var n=0;n!=a.length;++n){var s=Ai(a[n].trim(),t);null!=s&&(r[r.length]=s)}e=dt(e[1]),r.Count=e.count,r.Unique=e.uniqueCount}return r}(e,r);var a,n,s}function lf(e,t,r){return".bin"===t.slice(-4)?(a=r,n=[],s=[],o=!(i={}),Mr(e,function(e,t,r){switch(r){case 632:s.push(e);break;case 635:i=e;break;case 637:i.t=e.t,i.h=e.h,i.r=e.r;break;case 636:if(i.author=s[i.iauthor],delete i.iauthor,a.sheetRows&&i.rfx&&a.sheetRows<=i.rfx.r)break;i.t||(i.t=""),delete i.rfx,n.push(i);break;case 3072:break;case 35:o=!0;break;case 36:o=!1;break;case 37:case 38:break;default:if(!t.T&&(!o||a.WTF))throw new Error("Unexpected record 0x"+r.toString(16))}}),n):function(e,a){if(e.match(/<(?:\w+:)?comments *\/>/))return[];var n=[],s=[],t=e.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);return t&&t[1]&&t[1].split(/<\/\w*:?author>/).forEach(function(e){""===e||""===e.trim()||(e=e.match(/<(?:\w+:)?author[^>]*>(.*)/))&&n.push(e[1])}),(e=e.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/))&&e[1]&&e[1].split(/<\/\w*:?comment>/).forEach(function(e){var t,r;""===e||""===e.trim()||(t=e.match(/<(?:\w+:)?comment[^>]*>/))&&(t={author:(r=dt(t[0])).authorId&&n[r.authorId]||"sheetjsghost",ref:r.ref,guid:r.guid},r=Yr(r.ref),a.sheetRows&&a.sheetRows<=r.r||(e=!!(e=e.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/))&&!!e[1]&&Ai(e[1])||{r:"",t:"",h:""},t.r=e.r,"<t></t>"==e.r&&(e.t=e.h=""),t.t=(e.t||"").replace(/\r\n/g,"\n").replace(/\r/g,"\n"),a.cellHTML&&(t.h=e.h),s.push(t)))}),s}(e,r);var a,n,s,i,o}function ff(e,t){return".bin"===t.slice(-4)?(a=[],Mr(e,function(e,t,r){if(63===r)a.push(e);else if(!t.T)throw new Error("Unexpected record 0x"+r.toString(16))}),a):function(e){var r=[];if(!e)return r;var a=1;return(e.match(ft)||[]).forEach(function(e){var t=dt(e);switch(t[0]){case"<?xml":break;case"<calcChain":case"<calcChain>":case"</calcChain>":break;case"<c":delete t[0],t.i?a=t.i:t.i=a,r.push(t)}}),r}(e);var a}function hf(e,t,r,a){if(".bin"===r.slice(-4))return function(e,t){if(!e)return e;var a=t||{},n=!1;Mr(e,function(e,t,r){switch(0,r){case 359:case 363:case 364:case 366:case 367:case 368:case 369:case 370:case 371:case 472:case 577:case 578:case 579:case 580:case 581:case 582:case 583:case 584:case 585:case 586:case 587:break;case 35:n=!0;break;case 36:n=!1;break;default:if(!t.T&&(!n||a.WTF))throw new Error("Unexpected record 0x"+r.toString(16))}},a)}(e,a)}function uf(e,t,r){return".bin"===t.slice(-4)?(a={Types:[],Cell:[],Value:[]},n=r||{},i=!(s=[]),o=2,Mr(e,function(e,t,r){switch(r){case 335:a.Types.push({name:e.name});break;case 51:e.forEach(function(e){1==o?a.Cell.push({type:a.Types[e[0]-1].name,index:e[1]}):0==o&&a.Value.push({type:a.Types[e[0]-1].name,index:e[1]})});break;case 337:o=e?1:0;break;case 338:o=2;break;case 35:s.push(r),i=!0;break;case 36:s.pop(),i=!1;break;default:if(!t.T&&(!i||n.WTF&&35!=s[s.length-1]))throw new Error("Unexpected record 0x"+r.toString(16))}}),a):function(e,a){var n={Types:[],Cell:[],Value:[]};if(!e)return n;var s,i=!1,o=2;return e.replace(ft,function(e){var t=dt(e);switch(pt(t[0])){case"<?xml":break;case"<metadata":case"</metadata>":break;case"<metadataTypes":case"</metadataTypes>":break;case"<metadataType":n.Types.push({name:t.name});break;case"</metadataType>":break;case"<futureMetadata":for(var r=0;r<n.Types.length;++r)n.Types[r].name==t.name&&(s=n.Types[r]);break;case"</futureMetadata>":case"<bk>":case"</bk>":break;case"<rc":1==o?n.Cell.push({type:n.Types[t.t-1].name,index:+t.v}):0==o&&n.Value.push({type:n.Types[t.t-1].name,index:+t.v});break;case"</rc>":break;case"<cellMetadata":o=1;break;case"</cellMetadata>":o=2;break;case"<valueMetadata":o=0;break;case"</valueMetadata>":o=2;break;case"<extLst":case"<extLst>":case"</extLst>":case"<extLst/>":break;case"<ext":i=!0;break;case"</ext>":i=!1;break;case"<rvb":if(!s)break;s.offsets||(s.offsets=[]),s.offsets.push(+t.i);break;default:if(!i&&a.WTF)throw new Error("unrecognized "+t[0]+" in metadata")}return e}),n}(e,r);var a,n,s,i,o}var df,pf=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g,mf=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;function gf(e,t){var r=e.split(/\s+/),a=[];if(t||(a[0]=r[0]),1===r.length)return a;var n,s,i,o=e.match(pf);if(o)for(i=0;i!=o.length;++i)-1===(s=(n=o[i].match(mf))[1].indexOf(":"))?a[n[1]]=n[2].slice(1,n[2].length-1):a["xmlns:"===n[1].slice(0,6)?"xmlns"+n[1].slice(6):n[1].slice(s+1)]=n[2].slice(1,n[2].length-1);return a}function bf(e,t,r){if("z"!==e.t){if(!r||!1!==r.cellText)try{"e"===e.t?e.w=e.w||Wa[e.v]:"General"===t?"n"===e.t?(0|e.v)===e.v?e.w=e.v.toString(10):e.w=D(e.v):e.w=P(e.v):e.w=(a=t||"General",n=e.v,"General"===(a=df[a]||wt(a))?P(n):ve(a,n))}catch(e){if(r.WTF)throw e}var a,n;try{var s=df[t]||t||"General";r.cellNF&&(e.z=s),r.cellDates&&"n"==e.t&&q(s)&&((s=L(e.v))&&(e.t="d",e.v=new Date(s.y,s.m-1,s.d,s.H,s.M,s.S,s.u)))}catch(e){if(r.WTF)throw e}}}function vf(e,t){var r=t||{};Ee();var a,n=ne(Jt(e)),s=(n="binary"==r.type||"array"==r.type||"base64"==r.type?void 0!==re?re.utils.decode(65001,ae(n)):Mt(n):n).slice(0,1024).toLowerCase(),i=!1;if((1023&(s=s.replace(/".*?"/g,"")).indexOf(">"))>Math.min(1023&s.indexOf(","),1023&s.indexOf(";"))){var o=Ve(r);return o.type="string",Ks.to_workbook(n,o)}if(-1==s.indexOf("<?xml")&&["html","table","head","meta","script","style","div"].forEach(function(e){0<=s.indexOf("<"+e)&&(i=!0)}),i)return function(e,r){e=e.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);if(!e||0==e.length)throw new Error("Invalid HTML: could not find <table>");if(1==e.length)return ta(Yf(e[0],r),r);var a=du();return e.forEach(function(e,t){pu(a,Yf(e,r),"Sheet"+(t+1))}),a}(n,r);df={"General Number":"General","General Date":me[22],"Long Date":"dddd, mmmm dd, yyyy","Medium Date":me[15],"Short Date":me[14],"Long Time":me[19],"Medium Time":me[18],"Short Time":me[20],Currency:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',Fixed:me[2],Standard:me[4],Percent:me[10],Scientific:me[11],"Yes/No":'"Yes";"Yes";"No";@',"True/False":'"True";"True";"False";@',"On/Off":'"Yes";"Yes";"No";@'};var c,l=[];null!=oe&&null==r.dense&&(r.dense=oe);var f,h={},u=[],d=r.dense?[]:{},p="",m={},g={},b=gf('<Data ss:Type="String">'),v=0,w=0,T=0,E={s:{r:2e6,c:2e6},e:{r:0,c:0}},k={},y={},S="",_=0,x=[],A={},C={},R=0,O=[],I=[],N={},F=[],D=!1,P=[],L=[],M={},U=0,B=0,W={Sheets:[],WBProps:{date1904:!1}},H={};qt.lastIndex=0,n=n.replace(/<!--([\s\S]*?)-->/gm,"");for(var z,V,G,j,$="";a=qt.exec(n);)switch(a[3]=($=a[3]).toLowerCase()){case"data":if("data"==$){if("/"===a[1]){if((c=l.pop())[0]!==a[3])throw new Error("Bad state: "+c.join("|"))}else"/"!==a[0].charAt(a[0].length-2)&&l.push([a[3],!0]);break}if(l[l.length-1][1])break;"/"===a[1]?function(e,t,r,a,n,s,i,o,c,l){var f="General",h=a.StyleID,u={};l=l||{};var d=[],p=0;for(void 0===(h=void 0===h&&o?o.StyleID:h)&&i&&(h=i.StyleID);void 0!==s[h]&&(s[h].nf&&(f=s[h].nf),s[h].Interior&&d.push(s[h].Interior),s[h].Parent);)h=s[h].Parent;switch(r.Type){case"Boolean":a.t="b",a.v=Rt(e);break;case"String":a.t="s",a.r=At(wt(e)),a.v=-1<e.indexOf("<")?wt(t||e).replace(/<.*?>/g,""):a.r;break;case"DateTime":"Z"!=e.slice(-1)&&(e+="Z"),a.v=(He(e)-new Date(Date.UTC(1899,11,30)))/864e5,a.v!=a.v?a.v=wt(e):a.v<60&&(a.v=a.v-1),f&&"General"!=f||(f="yyyy-mm-dd");case"Number":void 0===a.v&&(a.v=+e),a.t||(a.t="n");break;case"Error":a.t="e",a.v=Ha[e],!1!==l.cellText&&(a.w=e);break;default:""==e&&""==t?a.t="z":(a.t="s",a.v=At(t||e))}if(bf(a,f,l),!1!==l.cellFormula)if(a.Formula){r=wt(a.Formula);61==r.charCodeAt(0)&&(r=r.slice(1)),a.f=oc(r,n),delete a.Formula,"RC"==a.ArrayRange?a.F=oc("RC:RC",n):a.ArrayRange&&(a.F=oc(a.ArrayRange,n),c.push([Zr(a.F),a.F]))}else for(p=0;p<c.length;++p)n.r>=c[p][0].s.r&&n.r<=c[p][0].e.r&&n.c>=c[p][0].s.c&&n.c<=c[p][0].e.c&&(a.F=c[p][1]);l.cellStyles&&(d.forEach(function(e){!u.patternType&&e.patternType&&(u.patternType=e.patternType)}),a.s=u),void 0!==a.StyleID&&(a.ixfe=a.StyleID)}(n.slice(v,a.index),S,b,"comment"==l[l.length-1][0]?N:m,{c:w,r:T},k,F[w],g,P,r):(S="",b=gf(a[0]),v=a.index+a[0].length);break;case"cell":if("/"===a[1])if(0<I.length&&(m.c=I),(!r.sheetRows||r.sheetRows>T)&&void 0!==m.v&&(r.dense?(d[T]||(d[T]=[]),d[T][w]=m):d[Xr(w)+jr(T)]=m),m.HRef&&(m.l={Target:wt(m.HRef)},m.HRefScreenTip&&(m.l.Tooltip=m.HRefScreenTip),delete m.HRef,delete m.HRefScreenTip),(m.MergeAcross||m.MergeDown)&&(U=w+(0|parseInt(m.MergeAcross,10)),B=T+(0|parseInt(m.MergeDown,10)),x.push({s:{c:w,r:T},e:{c:U,r:B}})),r.sheetStubs)if(m.MergeAcross||m.MergeDown){for(var X=w;X<=U;++X)for(var Y=T;Y<=B;++Y)(w<X||T<Y)&&(r.dense?(d[Y]||(d[Y]=[]),d[Y][X]={t:"z"}):d[Xr(X)+jr(Y)]={t:"z"});w=U+1}else++w;else m.MergeAcross?w=U+1:++w;else(w=(m=function(e){var t={};if(1===e.split(/\s+/).length)return t;var r,a,n,s=e.match(pf);if(s)for(n=0;n!=s.length;++n)-1===(a=(r=s[n].match(mf))[1].indexOf(":"))?t[r[1]]=r[2].slice(1,r[2].length-1):t["xmlns:"===r[1].slice(0,6)?"xmlns"+r[1].slice(6):r[1].slice(a+1)]=r[2].slice(1,r[2].length-1);return t}(a[0])).Index?+m.Index-1:w)<E.s.c&&(E.s.c=w),w>E.e.c&&(E.e.c=w),"/>"===a[0].slice(-2)&&++w,I=[];break;case"row":"/"===a[1]||"/>"===a[0].slice(-2)?(T<E.s.r&&(E.s.r=T),T>E.e.r&&(E.e.r=T),"/>"===a[0].slice(-2)&&(g=gf(a[0])).Index&&(T=+g.Index-1),w=0,++T):((g=gf(a[0])).Index&&(T=+g.Index-1),M={},"0"!=g.AutoFitHeight&&!g.Height||(M.hpx=parseInt(g.Height,10),M.hpt=uo(M.hpx),L[T]=M),"1"==g.Hidden&&(M.hidden=!0,L[T]=M));break;case"worksheet":if("/"===a[1]){if((c=l.pop())[0]!==a[3])throw new Error("Bad state: "+c.join("|"));u.push(p),E.s.r<=E.e.r&&E.s.c<=E.e.c&&(d["!ref"]=qr(E),r.sheetRows&&r.sheetRows<=E.e.r&&(d["!fullref"]=d["!ref"],E.e.r=r.sheetRows-1,d["!ref"]=qr(E))),x.length&&(d["!merges"]=x),0<F.length&&(d["!cols"]=F),0<L.length&&(d["!rows"]=L),h[p]=d}else E={s:{r:2e6,c:2e6},e:{r:0,c:0}},T=w=0,l.push([a[3],!1]),c=gf(a[0]),p=wt(c.Name),d=r.dense?[]:{},x=[],P=[],L=[],H={name:p,Hidden:0},W.Sheets.push(H);break;case"table":if("/"===a[1]){if((c=l.pop())[0]!==a[3])throw new Error("Bad state: "+c.join("|"))}else{if("/>"==a[0].slice(-2))break;l.push([a[3],!1]),D=!(F=[])}break;case"style":"/"===a[1]?(V=k,G=y,(j=r).cellStyles&&(!G.Interior||(j=G.Interior).Pattern&&(j.patternType=mo[j.Pattern]||j.Pattern)),V[G.ID]=G):y=gf(a[0]);break;case"numberformat":y.nf=wt(gf(a[0]).Format||"General"),df[y.nf]&&(y.nf=df[y.nf]);for(var K=0;392!=K&&me[K]!=y.nf;++K);if(392==K)for(K=57;392!=K;++K)if(null==me[K]){we(y.nf,K);break}break;case"column":if("table"!==l[l.length-1][0])break;if((f=gf(a[0])).Hidden&&(f.hidden=!0,delete f.Hidden),f.Width&&(f.wpx=parseInt(f.Width,10)),!D&&10<f.wpx){D=!0,no=to;for(var J=0;J<F.length;++J)F[J]&&fo(F[J])}D&&fo(f),F[f.Index-1||F.length]=f;for(var q=0;q<+f.Span;++q)F[F.length]=Ve(f);break;case"namedrange":if("/"===a[1])break;W.Names||(W.Names=[]);var Z=dt(a[0]),Q={Name:Z.Name,Ref:oc(Z.RefersTo.slice(1),{r:0,c:0})};0<W.Sheets.length&&(Q.Sheet=W.Sheets.length-1),W.Names.push(Q);break;case"namedcell":case"b":case"i":case"u":case"s":case"em":case"h2":case"h3":case"sub":case"sup":case"span":case"alignment":case"borders":case"border":break;case"font":if("/>"===a[0].slice(-2))break;"/"===a[1]?S+=n.slice(_,a.index):_=a.index+a[0].length;break;case"interior":if(!r.cellStyles)break;y.Interior=gf(a[0]);break;case"protection":break;case"author":case"title":case"description":case"created":case"keywords":case"subject":case"category":case"company":case"lastauthor":case"lastsaved":case"lastprinted":case"version":case"revision":case"totaltime":case"hyperlinkbase":case"manager":case"contentstatus":case"identifier":case"language":case"appname":if("/>"===a[0].slice(-2))break;"/"===a[1]?(G=A,Z=$,Q=n.slice(R,a.index),G[Z=(un=un||Ie(dn))[Z]||Z]=Q):R=a.index+a[0].length;break;case"paragraphs":break;case"styles":case"workbook":if("/"===a[1]){if((c=l.pop())[0]!==a[3])throw new Error("Bad state: "+c.join("|"))}else l.push([a[3],!1]);break;case"comment":if("/"===a[1]){if((c=l.pop())[0]!==a[3])throw new Error("Bad state: "+c.join("|"));(z=N).t=z.v||"",z.t=z.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n"),z.v=z.w=z.ixfe=void 0,I.push(N)}else l.push([a[3],!1]),N={a:(c=gf(a[0])).Author};break;case"autofilter":if("/"===a[1]){if((c=l.pop())[0]!==a[3])throw new Error("Bad state: "+c.join("|"))}else"/"!==a[0].charAt(a[0].length-2)&&(z=gf(a[0]),d["!autofilter"]={ref:oc(z.Range).replace(/\$/g,"")},l.push([a[3],!0]));break;case"name":break;case"datavalidation":if("/"===a[1]){if((c=l.pop())[0]!==a[3])throw new Error("Bad state: "+c.join("|"))}else"/"!==a[0].charAt(a[0].length-2)&&l.push([a[3],!0]);break;case"pixelsperinch":break;case"componentoptions":case"documentproperties":case"customdocumentproperties":case"officedocumentsettings":case"pivottable":case"pivotcache":case"names":case"mapinfo":case"pagebreaks":case"querytable":case"sorting":case"schema":case"conditionalformatting":case"smarttagtype":case"smarttags":case"excelworkbook":case"workbookoptions":case"worksheetoptions":if("/"===a[1]){if((c=l.pop())[0]!==a[3])throw new Error("Bad state: "+c.join("|"))}else"/"!==a[0].charAt(a[0].length-2)&&l.push([a[3],!0]);break;case"null":break;default:if(0==l.length&&"document"==a[3])return ih(n,r);if(0==l.length&&"uof"==a[3])return ih(n,r);var ee=!0;switch(l[l.length-1][0]){case"officedocumentsettings":switch(a[3]){case"allowpng":case"removepersonalinformation":case"downloadcomponents":case"locationofcomponents":case"colors":case"color":case"index":case"rgb":case"targetscreensize":case"readonlyrecommended":break;default:ee=!1}break;case"componentoptions":switch(a[3]){case"toolbar":case"hideofficelogo":case"spreadsheetautofit":case"label":case"caption":case"maxheight":case"maxwidth":case"nextsheetnumber":break;default:ee=!1}break;case"excelworkbook":switch(a[3]){case"date1904":W.WBProps.date1904=!0;break;case"windowheight":case"windowwidth":case"windowtopx":case"windowtopy":case"tabratio":case"protectstructure":case"protectwindow":case"protectwindows":case"activesheet":case"displayinknotes":case"firstvisiblesheet":case"supbook":case"sheetname":case"sheetindex":case"sheetindexfirst":case"sheetindexlast":case"dll":case"acceptlabelsinformulas":case"donotsavelinkvalues":case"iteration":case"maxiterations":case"maxchange":case"path":case"xct":case"count":case"selectedsheets":case"calculation":case"uncalced":case"startupprompt":case"crn":case"externname":case"formula":case"colfirst":case"collast":case"wantadvise":case"boolean":case"error":case"text":case"ole":case"noautorecover":case"publishobjects":case"donotcalculatebeforesave":case"number":case"refmoder1c1":case"embedsavesmarttags":break;default:ee=!1}break;case"workbookoptions":switch(a[3]){case"owcversion":case"height":case"width":break;default:ee=!1}break;case"worksheetoptions":switch(a[3]){case"visible":if("/>"!==a[0].slice(-2))if("/"===a[1])switch(n.slice(R,a.index)){case"SheetHidden":H.Hidden=1;break;case"SheetVeryHidden":H.Hidden=2}else R=a.index+a[0].length;break;case"header":d["!margins"]||Qc(d["!margins"]={},"xlml"),isNaN(+dt(a[0]).Margin)||(d["!margins"].header=+dt(a[0]).Margin);break;case"footer":d["!margins"]||Qc(d["!margins"]={},"xlml"),isNaN(+dt(a[0]).Margin)||(d["!margins"].footer=+dt(a[0]).Margin);break;case"pagemargins":var te=dt(a[0]);d["!margins"]||Qc(d["!margins"]={},"xlml"),isNaN(+te.Top)||(d["!margins"].top=+te.Top),isNaN(+te.Left)||(d["!margins"].left=+te.Left),isNaN(+te.Right)||(d["!margins"].right=+te.Right),isNaN(+te.Bottom)||(d["!margins"].bottom=+te.Bottom);break;case"displayrighttoleft":W.Views||(W.Views=[]),W.Views[0]||(W.Views[0]={}),W.Views[0].RTL=!0;break;case"freezepanes":case"frozennosplit":break;case"splithorizontal":case"splitvertical":case"donotdisplaygridlines":case"activerow":case"activecol":case"toprowbottompane":case"leftcolumnrightpane":case"unsynced":case"print":case"printerrors":case"panes":case"scale":case"pane":case"number":case"layout":case"pagesetup":case"selected":case"protectobjects":case"enableselection":case"protectscenarios":case"validprinterinfo":case"horizontalresolution":case"verticalresolution":case"numberofcopies":case"activepane":case"toprowvisible":case"leftcolumnvisible":case"fittopage":case"rangeselection":case"papersizeindex":case"pagelayoutzoom":case"pagebreakzoom":case"filteron":case"fitwidth":case"fitheight":case"commentslayout":case"zoom":case"lefttoright":case"gridlines":case"allowsort":case"allowfilter":case"allowinsertrows":case"allowdeleterows":case"allowinsertcols":case"allowdeletecols":case"allowinserthyperlinks":case"allowformatcells":case"allowsizecols":case"allowsizerows":break;case"nosummaryrowsbelowdetail":d["!outline"]||(d["!outline"]={}),d["!outline"].above=!0;break;case"tabcolorindex":case"donotdisplayheadings":case"showpagelayoutzoom":break;case"nosummarycolumnsrightdetail":d["!outline"]||(d["!outline"]={}),d["!outline"].left=!0;break;case"blackandwhite":case"donotdisplayzeros":case"displaypagebreak":case"rowcolheadings":case"donotdisplayoutline":case"noorientation":case"allowusepivottables":case"zeroheight":case"viewablerange":case"selection":case"protectcontents":break;default:ee=!1}break;case"pivottable":case"pivotcache":switch(a[3]){case"immediateitemsondrop":case"showpagemultipleitemlabel":case"compactrowindent":case"location":case"pivotfield":case"orientation":case"layoutform":case"layoutsubtotallocation":case"layoutcompactrow":case"position":case"pivotitem":case"datatype":case"datafield":case"sourcename":case"parentfield":case"ptlineitems":case"ptlineitem":case"countofsameitems":case"item":case"itemtype":case"ptsource":case"cacheindex":case"consolidationreference":case"filename":case"reference":case"nocolumngrand":case"norowgrand":case"blanklineafteritems":case"hidden":case"subtotal":case"basefield":case"mapchilditems":case"function":case"refreshonfileopen":case"printsettitles":case"mergelabels":case"defaultversion":case"refreshname":case"refreshdate":case"refreshdatecopy":case"versionlastrefresh":case"versionlastupdate":case"versionupdateablemin":case"versionrefreshablemin":case"calculation":break;default:ee=!1}break;case"pagebreaks":switch(a[3]){case"colbreaks":case"colbreak":case"rowbreaks":case"rowbreak":case"colstart":case"colend":case"rowend":break;default:ee=!1}break;case"autofilter":switch(a[3]){case"autofiltercolumn":case"autofiltercondition":case"autofilterand":case"autofilteror":break;default:ee=!1}break;case"querytable":switch(a[3]){case"id":case"autoformatfont":case"autoformatpattern":case"querysource":case"querytype":case"enableredirections":case"refreshedinxl9":case"urlstring":case"htmltables":case"connection":case"commandtext":case"refreshinfo":case"notitles":case"nextid":case"columninfo":case"overwritecells":case"donotpromptforfile":case"textwizardsettings":case"source":case"number":case"decimal":case"thousandseparator":case"trailingminusnumbers":case"formatsettings":case"fieldtype":case"delimiters":case"tab":case"comma":case"autoformatname":case"versionlastedit":case"versionlastrefresh":break;default:ee=!1}break;case"datavalidation":switch(a[3]){case"range":case"type":case"min":case"max":case"sort":case"descending":case"order":case"casesensitive":case"value":case"errorstyle":case"errormessage":case"errortitle":case"inputmessage":case"inputtitle":case"combohide":case"inputhide":case"condition":case"qualifier":case"useblank":case"value1":case"value2":case"format":case"cellrangelist":break;default:ee=!1}break;case"sorting":case"conditionalformatting":switch(a[3]){case"range":case"type":case"min":case"max":case"sort":case"descending":case"order":case"casesensitive":case"value":case"errorstyle":case"errormessage":case"errortitle":case"cellrangelist":case"inputmessage":case"inputtitle":case"combohide":case"inputhide":case"condition":case"qualifier":case"useblank":case"value1":case"value2":case"format":break;default:ee=!1}break;case"mapinfo":case"schema":case"data":switch(a[3]){case"map":case"entry":case"range":case"xpath":case"field":case"xsdtype":case"filteron":case"aggregate":case"elementtype":case"attributetype":break;case"schema":case"element":case"complextype":case"datatype":case"all":case"attribute":case"extends":case"row":break;default:ee=!1}break;case"smarttags":break;default:ee=!1}if(ee)break;if(a[3].match(/!\[CDATA/))break;if(!l[l.length-1][1])throw"Unrecognized tag: "+a[3]+"|"+l.join("|");if("customdocumentproperties"===l[l.length-1][0]){if("/>"===a[0].slice(-2))break;"/"===a[1]?function(e,t,r,a){var n=a;switch((r[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]){case"boolean":n=Rt(a);break;case"i2":case"int":n=parseInt(a,10);break;case"r4":case"float":n=parseFloat(a);break;case"date":case"dateTime.tz":n=He(a);break;case"i8":case"string":case"fixed":case"uuid":case"bin.base64":break;default:throw new Error("bad custprop:"+r[0])}e[wt(t)]=n}(C,$,O,n.slice(R,a.index)):R=(O=a).index+a[0].length;break}if(r.WTF)throw"Unrecognized tag: "+a[3]+"|"+l.join("|")}o={};return r.bookSheets||r.bookProps||(o.Sheets=h),o.SheetNames=u,o.Workbook=W,o.SSF=Ve(me),o.Props=A,o.Custprops=C,o}function wf(e,t){switch(Mh(t=t||{}),t.type||"base64"){case"base64":return vf(te(e),t);case"binary":case"buffer":case"file":return vf(e,t);case"array":return vf(i(e),t)}}function Tf(e,t){var r,a,n,s,i,o,c,l=[];return e.Props&&l.push((r=e.Props,a=t,n=[],Re(dn).map(function(e){for(var t=0;t<en.length;++t)if(en[t][1]==e)return en[t];for(t=0;t<sn.length;++t)if(sn[t][1]==e)return sn[t];throw e}).forEach(function(e){var t;null!=r[e[1]]&&(t=(a&&a.Props&&null!=a.Props[e[1]]?a.Props:r)[e[1]],"number"==typeof(t="date"===e[2]?new Date(t).toISOString().replace(/\.\d*Z/,"Z"):t)?t=String(t):!0===t||!1===t?t=t?"1":"0":t instanceof Date&&(t=new Date(t).toISOString().replace(/\.\d*Z/,"")),n.push($t(dn[e[1]]||e[1],t)))}),Yt("DocumentProperties",n.join(""),{xmlns:er.o}))),e.Custprops&&l.push((s=e.Props,i=e.Custprops,o=["Worksheets","SheetNames"],e="CustomDocumentProperties",c=[],s&&Re(s).forEach(function(e){if(Object.prototype.hasOwnProperty.call(s,e)){for(var t=0;t<en.length;++t)if(e==en[t][1])return;for(t=0;t<sn.length;++t)if(e==sn[t][1])return;for(t=0;t<o.length;++t)if(e==o[t])return;var r="string",a="number"==typeof(a=s[e])?(r="float",String(a)):!0===a||!1===a?(r="boolean",a?"1":"0"):String(a);c.push(Yt(yt(e),a,{"dt:dt":r}))}}),i&&Re(i).forEach(function(e){var t,r;Object.prototype.hasOwnProperty.call(i,e)&&(s&&Object.prototype.hasOwnProperty.call(s,e)||(t="string",r="number"==typeof(r=i[e])?(t="float",String(r)):!0===r||!1===r?(t="boolean",r?"1":"0"):r instanceof Date?(t="dateTime.tz",r.toISOString()):String(r),c.push(Yt(yt(e),r,{"dt:dt":t}))))}),"<"+e+' xmlns="'+er.o+'">'+c.join("")+"</"+e+">")),l.join("")}function Ef(e){return Yt("NamedRange",null,{"ss:Name":e.Name,"ss:RefersTo":"="+fc(e.Ref,{r:0,c:0})})}function kf(e,t,r,a,n,s,i){if(!e||null==e.v&&null==e.f)return"";var o={};if(e.f&&(o["ss:Formula"]="="+kt(fc(e.f,i))),e.F&&e.F.slice(0,t.length)==t&&(t=Yr(e.F.slice(t.length+1)),o["ss:ArrayRange"]="RC:R"+(t.r==i.r?"":"["+(t.r-i.r)+"]")+"C"+(t.c==i.c?"":"["+(t.c-i.c)+"]")),e.l&&e.l.Target&&(o["ss:HRef"]=kt(e.l.Target),e.l.Tooltip&&(o["x:HRefScreenTip"]=kt(e.l.Tooltip))),r["!merges"])for(var c=r["!merges"],l=0;l!=c.length;++l)c[l].s.c==i.c&&c[l].s.r==i.r&&(c[l].e.c>c[l].s.c&&(o["ss:MergeAcross"]=c[l].e.c-c[l].s.c),c[l].e.r>c[l].s.r&&(o["ss:MergeDown"]=c[l].e.r-c[l].s.r));var f="",h="";switch(e.t){case"z":if(!a.sheetStubs)return"";break;case"n":f="Number",h=String(e.v);break;case"b":f="Boolean",h=e.v?"1":"0";break;case"e":f="Error",h=Wa[e.v];break;case"d":f="DateTime",h=new Date(e.v).toISOString(),null==e.z&&(e.z=e.z||me[14]);break;case"s":f="String",h=((e.v||"")+"").replace(Tt,function(e){return vt[e]}).replace(St,function(e){return"&#x"+e.charCodeAt(0).toString(16).toUpperCase()+";"})}r=el(a.cellXfs,e,a);o["ss:StyleID"]="s"+(21+r),o["ss:Index"]=i.c+1;r=null!=e.v?h:"",r="z"==e.t?"":'<Data ss:Type="'+f+'">'+r+"</Data>";return 0<(e.c||[]).length&&(r+=e.c.map(function(e){var t=Yt("ss:Data",(e.t||"").replace(/(\r\n|[\r\n])/g,"&#10;"),{xmlns:"http://www.w3.org/TR/REC-html40"});return Yt("Comment",t,{"ss:Author":e.a})}).join("")),Yt("Cell",r,o)}function yf(e,t){if(!e["!ref"])return"";var r=Zr(e["!ref"]),a=e["!merges"]||[],n=0,s=[];e["!cols"]&&e["!cols"].forEach(function(e,t){fo(e);var r=!!e.width,a=Zc(t,e),t={"ss:Index":t+1};r&&(t["ss:Width"]=so(a.width)),e.hidden&&(t["ss:Hidden"]="1"),s.push(Yt("Column",null,t))});for(var i,o,c=Array.isArray(e),l=r.s.r;l<=r.e.r;++l){for(var f=[(i=l,o=(e["!rows"]||[])[l],i='<Row ss:Index="'+(i+1)+'"',o&&(o.hpt&&!o.hpx&&(o.hpx=po(o.hpt)),o.hpx&&(i+=' ss:AutoFitHeight="0" ss:Height="'+o.hpx+'"'),o.hidden&&(i+=' ss:Hidden="1"')),i+">")],h=r.s.c;h<=r.e.c;++h){for(var u,d,p,m=!1,n=0;n!=a.length;++n)if(!(a[n].s.c>h||a[n].s.r>l||a[n].e.c<h||a[n].e.r<l)){a[n].s.c==h&&a[n].s.r==l||(m=!0);break}m||(d=Kr(u={r:l,c:h}),p=c?(e[l]||[])[h]:e[d],f.push(kf(p,d,e,t,0,0,u)))}f.push("</Row>"),2<f.length&&s.push(f.join(""))}return s.join("")}function Sf(e,t,r){var a=[],n=r.SheetNames[e],s=r.Sheets[n],n=s?function(e,t,r){if(!e)return"";if(!((r||{}).Workbook||{}).Names)return"";for(var a=r.Workbook.Names,n=[],s=0;s<a.length;++s){var i=a[s];i.Sheet==t&&(i.Name.match(/^_xlfn\./)||n.push(Ef(i)))}return n.join("")}(s,e,r):"";return 0<n.length&&a.push("<Names>"+n+"</Names>"),0<(n=s?yf(s,t):"").length&&a.push("<Table>"+n+"</Table>"),a.push(function(t,e,r){if(!t)return"";var a=[];if(t["!margins"]&&(a.push("<PageSetup>"),t["!margins"].header&&a.push(Yt("Header",null,{"x:Margin":t["!margins"].header})),t["!margins"].footer&&a.push(Yt("Footer",null,{"x:Margin":t["!margins"].footer})),a.push(Yt("PageMargins",null,{"x:Bottom":t["!margins"].bottom||"0.75","x:Left":t["!margins"].left||"0.7","x:Right":t["!margins"].right||"0.7","x:Top":t["!margins"].top||"0.75"})),a.push("</PageSetup>")),r&&r.Workbook&&r.Workbook.Sheets&&r.Workbook.Sheets[e])if(r.Workbook.Sheets[e].Hidden)a.push(Yt("Visible",1==r.Workbook.Sheets[e].Hidden?"SheetHidden":"SheetVeryHidden",{}));else{for(var n=0;n<e&&(!r.Workbook.Sheets[n]||r.Workbook.Sheets[n].Hidden);++n);n==e&&a.push("<Selected/>")}return((((r||{}).Workbook||{}).Views||[])[0]||{}).RTL&&a.push("<DisplayRightToLeft/>"),t["!protect"]&&(a.push($t("ProtectContents","True")),t["!protect"].objects&&a.push($t("ProtectObjects","True")),t["!protect"].scenarios&&a.push($t("ProtectScenarios","True")),null==t["!protect"].selectLockedCells||t["!protect"].selectLockedCells?null==t["!protect"].selectUnlockedCells||t["!protect"].selectUnlockedCells||a.push($t("EnableSelection","UnlockedCells")):a.push($t("EnableSelection","NoSelection")),[["formatCells","AllowFormatCells"],["formatColumns","AllowSizeCols"],["formatRows","AllowSizeRows"],["insertColumns","AllowInsertCols"],["insertRows","AllowInsertRows"],["insertHyperlinks","AllowInsertHyperlinks"],["deleteColumns","AllowDeleteCols"],["deleteRows","AllowDeleteRows"],["sort","AllowSort"],["autoFilter","AllowFilter"],["pivotTables","AllowUsePivotTables"]].forEach(function(e){t["!protect"][e[0]]&&a.push("<"+e[1]+"/>")})),0==a.length?"":Yt("WorksheetOptions",a.join(""),{xmlns:er.x})}(s,e,r)),a.join("")}function _f(e,t){t=t||{},e.SSF||(e.SSF=Ve(me)),e.SSF&&(Ee(),Te(e.SSF),t.revssf=Ne(e.SSF),t.revssf[e.SSF[65535]]=0,t.ssf=e.SSF,t.cellXfs=[],el(t.cellXfs,{},{revssf:{General:0}}));var r=[];r.push(Tf(e,t)),r.push(""),r.push(""),r.push("");for(var a,n=0;n<e.SheetNames.length;++n)r.push(Yt("Worksheet",Sf(n,t,e),{"ss:Name":kt(e.SheetNames[n])}));return r[2]=(a=['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'],t.cellXfs.forEach(function(e,t){var r=[];r.push(Yt("NumberFormat",null,{"ss:Format":kt(me[e.numFmtId])}));t={"ss:ID":"s"+(21+t)};a.push(Yt("Style",r.join(""),t))}),Yt("Styles",a.join(""))),r[3]=function(e){if(!((e||{}).Workbook||{}).Names)return"";for(var t=e.Workbook.Names,r=[],a=0;a<t.length;++a){var n=t[a];null==n.Sheet&&(n.Name.match(/^_xlfn\./)||r.push(Ef(n)))}return Yt("Names",r.join(""))}(e),ot+Yt("Workbook",r.join(""),{xmlns:er.ss,"xmlns:o":er.o,"xmlns:x":er.x,"xmlns:ss":er.ss,"xmlns:dt":er.dt,"xmlns:html":er.html})}function xf(e){var t={},r=e.content;if(r.l=28,t.AnsiUserType=r.read_shift(0,"lpstr-ansi"),t.AnsiClipboardFormat=Ra(r,1),r.length-r.l<=4)return t;e=r.read_shift(4);return 0==e||40<e?t:(r.l-=4,t.Reserved1=r.read_shift(0,"lpstr-ansi"),r.length-r.l<=4||1907505652!==(e=r.read_shift(4))?t:(t.UnicodeClipboardFormat=Ra(r,2),0==(e=r.read_shift(4))||40<e?t:(r.l-=4,void(t.Reserved2=r.read_shift(0,"lpwstr")))))}var Af=[60,1084,2066,2165,2175];function Cf(e,t,r){if("z"!==e.t&&e.XF){var a,n=0;try{n=e.z||e.XF.numFmtId||0,t.cellNF&&(e.z=me[n])}catch(e){if(t.WTF)throw e}if(!t||!1!==t.cellText)try{"e"===e.t?e.w=e.w||Wa[e.v]:0===n||"General"==n?"n"===e.t?(0|e.v)===e.v?e.w=e.v.toString(10):e.w=D(e.v):e.w=P(e.v):e.w=ve(n,e.v,{date1904:!!r,dateNF:t&&t.dateNF})}catch(e){if(t.WTF)throw e}t.cellDates&&n&&"n"==e.t&&q(me[n]||String(n))&&((a=L(e.v))&&(e.t="d",e.v=new Date(a.y,a.m-1,a.d,a.H,a.M,a.S,a.u)))}}function Rf(e,t,r){return{v:e,ixfe:t,t:r}}function Of(e,t){var r={opts:{}},a={};null!=oe&&null==t.dense&&(t.dense=oe);function o(e){return!(e<8)&&e<64&&k[e-8]||Ba[e]}function n(e,t,r){if(!(1<D||r.sheetRows&&e.r>=r.sheetRows)){var a,n,s;if(r.cellStyles&&t.XF&&t.XF.data&&(n=r,(s=(a=t).XF.data)&&s.patternType&&n&&n.cellStyles&&(a.s={},a.s.patternType=s.patternType,(n=Qi(o(s.icvFore)))&&(a.s.fgColor={rgb:n}),(n=Qi(o(s.icvBack)))&&(a.s.bgColor={rgb:n}))),delete t.ixfe,delete t.XF,v=Kr(c=e),d&&d.s&&d.e||(d={s:{r:0,c:0},e:{r:0,c:0}}),e.r<d.s.r&&(d.s.r=e.r),e.c<d.s.c&&(d.s.c=e.c),e.r+1>d.e.r&&(d.e.r=e.r+1),e.c+1>d.e.c&&(d.e.c=e.c+1),r.cellFormula&&t.f)for(var i=0;i<T.length;++i)if(!(T[i][0].s.c>e.c||T[i][0].s.r>e.r||T[i][0].e.c<e.c||T[i][0].e.r<e.r)){t.F=qr(T[i][0]),T[i][0].s.c==e.c&&T[i][0].s.r==e.r||delete t.f,t.f&&(t.f=""+Pc(T[i][1],0,e,I,_));break}r.dense?(h[e.r]||(h[e.r]=[]),h[e.r][e.c]=t):h[v]=t}}var c,s,i,l,f,h=t.dense?[]:{},u={},d={},p=null,m=[],g="",b={},v="",w={},T=[],E=[],k=[],y={Sheets:[],WBProps:{date1904:!1},Views:[{}]},S={},_={enc:!1,sbcch:0,snames:[],sharedf:w,arrayf:T,rrtabid:[],lastuser:"",biff:8,codepage:0,winlocked:0,cellStyles:!!t&&!!t.cellStyles,WTF:!!t&&!!t.wtf};t.password&&(_.password=t.password);var x=[],A=[],C=[],R=[],O=!1,I=[];I.SheetNames=_.snames,I.sharedf=_.sharedf,I.arrayf=_.arrayf,I.names=[],I.XTI=[];var N,F=0,D=0,P=0,L=[],M=[];_.codepage=1200,ie(1200);for(var U=!1;e.l<e.length-1;){var B=e.l,W=e.read_shift(2);if(0===W&&10===F)break;var H=e.l===e.length?0:e.read_shift(2),z=Pf[W];if(z&&z.f){if(t.bookSheets&&133===F&&133!==W)break;if(F=W,2===z.r||12==z.r){var V=e.read_shift(2);if(H-=2,!_.enc&&V!==W&&((255&V)<<8|V>>8)!==W)throw new Error("rt mismatch: "+V+"!="+W);12==z.r&&(e.l+=10,H-=10)}var G,j,$,X={},X=10===W?z.f(e,H,_):function(e,t,r,a,n){var s=a,i=[],o=r.slice(r.l,r.l+s);if(n&&n.enc&&n.enc.insitu&&0<o.length)switch(e){case 9:case 521:case 1033:case 2057:case 47:case 405:case 225:case 406:case 312:case 404:case 10:case 133:break;default:n.enc.insitu(o)}i.push(o),r.l+=s;for(var c=yr(r,r.l),l=Pf[c],f=0;null!=l&&-1<Af.indexOf(c);)s=yr(r,r.l+2),f=r.l+4,2066==c?f+=4:2165!=c&&2175!=c||(f+=12),o=r.slice(f,r.l+4+s),i.push(o),r.l+=4+s,l=Pf[c=yr(r,r.l)];var h=ue(i);Dr(h,0);var u=0;h.lens=[];for(var d=0;d<i.length;++d)h.lens.push(u),u+=i[d].length;if(h.length<a)throw"XLS Record 0x"+e.toString(16)+" Truncated: "+h.length+" < "+a;return t.f(h,h.length,n)}(W,z,e,H,_);if(0!=D||-1!==[9,521,1033,2057].indexOf(F))switch(W){case 34:r.opts.Date1904=y.WBProps.date1904=X;break;case 134:r.opts.WriteProtect=!0;break;case 47:if(_.enc||(e.l=0),_.enc=X,!t.password)throw new Error("File is password-protected");if(null==X.valid)throw new Error("Encryption scheme unsupported");if(!X.valid)throw new Error("Password is incorrect");break;case 92:_.lastuser=X;break;case 66:var Y=Number(X);switch(Y){case 21010:Y=1200;break;case 32768:Y=1e4;break;case 32769:Y=1252}ie(_.codepage=Y),U=!0;break;case 317:_.rrtabid=X;break;case 25:_.winlocked=X;break;case 439:r.opts.RefreshAll=X;break;case 12:r.opts.CalcCount=X;break;case 16:r.opts.CalcDelta=X;break;case 17:r.opts.CalcIter=X;break;case 13:r.opts.CalcMode=X;break;case 14:r.opts.CalcPrecision=X;break;case 95:r.opts.CalcSaveRecalc=X;break;case 15:_.CalcRefMode=X;break;case 2211:r.opts.FullCalc=X;break;case 129:X.fDialog&&(h["!type"]="dialog"),X.fBelow||((h["!outline"]||(h["!outline"]={})).above=!0),X.fRight||((h["!outline"]||(h["!outline"]={})).left=!0);break;case 224:E.push(X);break;case 430:I.push([X]),I[I.length-1].XTI=[];break;case 35:case 547:I[I.length-1].push(X);break;case 24:case 536:N={Name:X.Name,Ref:Pc(X.rgce,0,null,I,_)},0<X.itab&&(N.Sheet=X.itab-1),I.names.push(N),I[0]||(I[0]=[],I[0].XTI=[]),I[I.length-1].push(X),"_xlnm._FilterDatabase"==X.Name&&0<X.itab&&X.rgce&&X.rgce[0]&&X.rgce[0][0]&&"PtgArea3d"==X.rgce[0][0][0]&&(M[X.itab-1]={ref:qr(X.rgce[0][0][1][2])});break;case 22:_.ExternCount=X;break;case 23:0==I.length&&(I[0]=[],I[0].XTI=[]),I[I.length-1].XTI=I[I.length-1].XTI.concat(X),I.XTI=I.XTI.concat(X);break;case 2196:if(_.biff<8)break;null!=N&&(N.Comment=X[1]);break;case 18:h["!protect"]=X;break;case 19:0!==X&&_.WTF&&console.error("Password verifier: "+X);break;case 133:u[X.pos]=X,_.snames.push(X.name);break;case 10:if(--D)break;d.e&&(0<d.e.r&&0<d.e.c&&(d.e.r--,d.e.c--,h["!ref"]=qr(d),t.sheetRows&&t.sheetRows<=d.e.r&&(K=d.e.r,d.e.r=t.sheetRows-1,h["!fullref"]=h["!ref"],h["!ref"]=qr(d),d.e.r=K),d.e.r++,d.e.c++),0<x.length&&(h["!merges"]=x),0<A.length&&(h["!objects"]=A),0<C.length&&(h["!cols"]=C),0<R.length&&(h["!rows"]=R),y.Sheets.push(S)),""===g?b=h:a[g]=h,h=t.dense?[]:{};break;case 9:case 521:case 1033:case 2057:if(8===_.biff&&(_.biff={9:2,521:3,1033:4}[W]||{512:2,768:3,1024:4,1280:5,1536:8,2:2,7:2}[X.BIFFVer]||8),_.biffguess=0==X.BIFFVer,0==X.BIFFVer&&4096==X.dt&&(_.biff=5,U=!0,ie(_.codepage=28591)),8==_.biff&&0==X.BIFFVer&&16==X.dt&&(_.biff=2),D++)break;var K,h=t.dense?[]:{};_.biff<8&&!U&&(U=!0,ie(_.codepage=t.codepage||1252)),_.biff<5||0==X.BIFFVer&&4096==X.dt?(""===g&&(g="Sheet1"),d={s:{r:0,c:0},e:{r:0,c:0}},K={pos:e.l-H,name:g},u[K.pos]=K,_.snames.push(g)):g=(u[B]||{name:""}).name,32==X.dt&&(h["!type"]="chart"),64==X.dt&&(h["!type"]="macro"),x=[],A=[],_.arrayf=T=[],C=[],O=!(R=[]),S={Hidden:(u[B]||{hs:0}).hs,name:g};break;case 515:case 3:case 2:"chart"==h["!type"]&&(t.dense?(h[X.r]||[])[X.c]:h[Kr({c:X.c,r:X.r})])&&++X.c,Z={ixfe:X.ixfe,XF:E[X.ixfe]||{},v:X.val,t:"n"},0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n({c:X.c,r:X.r},Z,t);break;case 5:case 517:Z={ixfe:X.ixfe,XF:E[X.ixfe],v:X.val,t:X.t},0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n({c:X.c,r:X.r},Z,t);break;case 638:Z={ixfe:X.ixfe,XF:E[X.ixfe],v:X.rknum,t:"n"},0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n({c:X.c,r:X.r},Z,t);break;case 189:for(var J=X.c;J<=X.C;++J){var q=X.rkrec[J-X.c][0],Z={ixfe:q,XF:E[q],v:X.rkrec[J-X.c][1],t:"n"};0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n({c:J,r:X.r},Z,t)}break;case 6:case 518:case 1030:if("String"==X.val){p=X;break}(Z=Rf(X.val,X.cell.ixfe,X.tt)).XF=E[Z.ixfe],t.cellFormula&&(!((Q=X.formula)&&Q[0]&&Q[0][0]&&"PtgExp"==Q[0][0][0])||w[$=Kr({r:G=Q[0][0][1][0],c:j=Q[0][0][1][1]})]?Z.f=""+Pc(X.formula,0,X.cell,I,_):Z.F=((t.dense?(h[G]||[])[j]:h[$])||{}).F),0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n(X.cell,Z,t),p=X;break;case 7:case 519:if(!p)throw new Error("String record expects Formula");(Z=Rf(p.val=X,p.cell.ixfe,"s")).XF=E[Z.ixfe],t.cellFormula&&(Z.f=""+Pc(p.formula,0,p.cell,I,_)),0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n(p.cell,Z,t),p=null;break;case 33:case 545:T.push(X);var Q=Kr(X[0].s),ee=t.dense?(h[X[0].s.r]||[])[X[0].s.c]:h[Q];if(t.cellFormula&&ee){if(!p)break;if(!Q||!ee)break;ee.f=""+Pc(X[1],0,X[0],I,_),ee.F=qr(X[0])}break;case 1212:if(!t.cellFormula)break;if(v){if(!p)break;w[Kr(p.cell)]=X[0],((ee=t.dense?(h[p.cell.r]||[])[p.cell.c]:h[Kr(p.cell)])||{}).f=""+Pc(X[0],0,c,I,_)}break;case 253:Z=Rf(m[X.isst].t,X.ixfe,"s"),m[X.isst].h&&(Z.h=m[X.isst].h),Z.XF=E[Z.ixfe],0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n({c:X.c,r:X.r},Z,t);break;case 513:t.sheetStubs&&(Z={ixfe:X.ixfe,XF:E[X.ixfe],t:"z"},0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n({c:X.c,r:X.r},Z,t));break;case 190:if(t.sheetStubs)for(var te=X.c;te<=X.C;++te){var re=X.ixfe[te-X.c];Z={ixfe:re,XF:E[re],t:"z"},0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n({c:te,r:X.r},Z,t)}break;case 214:case 516:case 4:(Z=Rf(X.val,X.ixfe,"s")).XF=E[Z.ixfe],0<P&&(Z.z=L[Z.ixfe>>8&63]),Cf(Z,t,r.opts.Date1904),n({c:X.c,r:X.r},Z,t);break;case 0:case 512:1===D&&(d=X);break;case 252:m=X;break;case 1054:if(4==_.biff){L[P++]=X[1];for(var ae=0;ae<P+163&&me[ae]!=X[1];++ae);163<=ae&&we(X[1],P+163)}else we(X[1],X[0]);break;case 30:L[P++]=X;for(var ne=0;ne<P+163&&me[ne]!=X;++ne);163<=ne&&we(X,P+163);break;case 229:x=x.concat(X);break;case 93:A[X.cmo[0]]=_.lastobj=X;break;case 438:_.lastobj.TxO=X;break;case 127:_.lastobj.ImData=X;break;case 440:for(i=X[0].s.r;i<=X[0].e.r;++i)for(s=X[0].s.c;s<=X[0].e.c;++s)(ee=t.dense?(h[i]||[])[s]:h[Kr({c:s,r:i})])&&(ee.l=X[1]);break;case 2048:for(i=X[0].s.r;i<=X[0].e.r;++i)for(s=X[0].s.c;s<=X[0].e.c;++s)(ee=t.dense?(h[i]||[])[s]:h[Kr({c:s,r:i})])&&ee.l&&(ee.l.Tooltip=X[1]);break;case 28:if(_.biff<=5&&2<=_.biff)break;ee=t.dense?(h[X[0].r]||[])[X[0].c]:h[Kr(X[0])];var se=A[X[2]];ee||(ee=t.dense?(h[X[0].r]||(h[X[0].r]=[]),h[X[0].r][X[0].c]={t:"z"}):h[Kr(X[0])]={t:"z"},d.e.r=Math.max(d.e.r,X[0].r),d.s.r=Math.min(d.s.r,X[0].r),d.e.c=Math.max(d.e.c,X[0].c),d.s.c=Math.min(d.s.c,X[0].c)),ee.c||(ee.c=[]),se={a:X[1],t:se.TxO.t},ee.c.push(se);break;case 2173:E[X.ixfe],X.ext.forEach(function(e){e[0]});break;case 125:if(!_.cellStyles)break;for(;X.e>=X.s;)C[X.e--]={width:X.w/256,level:X.level||0,hidden:!!(1&X.flags)},O||(O=!0,lo(X.w/256)),fo(C[X.e+1]);break;case 520:se={};null!=X.level&&((R[X.r]=se).level=X.level),X.hidden&&((R[X.r]=se).hidden=!0),X.hpt&&((R[X.r]=se).hpt=X.hpt,se.hpx=po(X.hpt));break;case 38:case 39:case 40:case 41:h["!margins"]||Qc(h["!margins"]={}),h["!margins"][{38:"left",39:"right",40:"top",41:"bottom"}[W]]=X;break;case 161:h["!margins"]||Qc(h["!margins"]={}),h["!margins"].header=X.header,h["!margins"].footer=X.footer;break;case 574:X.RTL&&(y.Views[0].RTL=!0);break;case 146:k=X;break;case 2198:f=X;break;case 140:l=X;break;case 442:g?S.CodeName=X||S.name:y.WBProps.CodeName=X||"ThisWorkbook"}}else z||console.error("Missing Info for XLS Record 0x"+W.toString(16)),e.l+=H}return r.SheetNames=Re(u).sort(function(e,t){return Number(e)-Number(t)}).map(function(e){return u[e].name}),t.bookSheets||(r.Sheets=a),!r.SheetNames.length&&b["!ref"]?(r.SheetNames.push("Sheet1"),r.Sheets&&(r.Sheets.Sheet1=b)):r.Preamble=b,r.Sheets&&M.forEach(function(e,t){r.Sheets[r.SheetNames[t]]["!autofilter"]=e}),r.Strings=m,r.SSF=Ve(me),_.enc&&(r.Encryption=_.enc),f&&(r.Themes=f),r.Metadata={},void 0!==l&&(r.Metadata.Country=l),0<I.names.length&&(y.Names=I.names),r.Workbook=y,r}var If={SI:"e0859ff2f94f6810ab9108002b27b3d9",DSI:"02d5cdd59c2e1b10939708002b2cf9ae",UDI:"05d5cdd59c2e1b10939708002b2cf9ae"};function Nf(e,t){var r,a,n,s,i;if(Mh(t=t||{}),h(),t.codepage&&c(t.codepage),e.FullPaths){if(xe.find(e,"/encryption"))throw new Error("File is password-protected");r=xe.find(e,"!CompObj"),n=xe.find(e,"/Workbook")||xe.find(e,"/Book")}else{switch(t.type){case"base64":e=he(te(e));break;case"binary":e=he(e);break;case"buffer":break;case"array":Array.isArray(e)||(e=Array.prototype.slice.call(e))}Dr(e,0),n={content:e}}if(r&&xf(r),t.bookProps&&!t.bookSheets)a={};else{var o=se?"buffer":"array";if(n&&n.content)a=Of(n.content,t);else if((n=xe.find(e,"PerfectOffice_MAIN"))&&n.content)a=si.to_workbook(n.content,(t.type=o,t));else{if(!(n=xe.find(e,"NativeContent_MAIN"))||!n.content)throw(n=xe.find(e,"MN0"))&&n.content?new Error("Unsupported Works 4 for Mac file"):new Error("Cannot find Workbook stream");a=si.to_workbook(n.content,(t.type=o,t))}t.bookVBA&&e.FullPaths&&xe.find(e,"/_VBA_PROJECT_CUR/VBA/dir")&&(a.vbaraw=(s=e,i=xe.utils.cfb_new({root:"R"}),s.FullPaths.forEach(function(e,t){"/"!==e.slice(-1)&&e.match(/_VBA_PROJECT_CUR/)&&(e=e.replace(/^[^\/]*/,"R").replace(/\/_VBA_PROJECT_CUR\u0000*/,""),xe.utils.cfb_add(i,e,s.FileIndex[t].content))}),xe.write(i)))}o={};return e.FullPaths&&function(e,t,r){var a=xe.find(e,"/!DocumentSummaryInformation");if(a&&0<a.size)try{var n,s=An(a,Pa,If.DSI);for(n in s)t[n]=s[n]}catch(e){if(r.WTF)throw e}var i=xe.find(e,"/!SummaryInformation");if(i&&0<i.size)try{var o,c=An(i,La,If.SI);for(o in c)null==t[o]&&(t[o]=c[o])}catch(e){if(r.WTF)throw e}t.HeadingPairs&&t.TitlesOfParts&&(cn(t.HeadingPairs,t.TitlesOfParts,t,r),delete t.HeadingPairs,delete t.TitlesOfParts)}(e,o,t),a.Props=a.Custprops=o,t.bookFiles&&(a.cfb=e),a}function Ff(e,t){var r,a,n=t||{},t=xe.utils.cfb_new({root:"R"}),s="/Workbook";switch(n.bookType||"xls"){case"xls":n.bookType="biff8";case"xla":n.bookType||(n.bookType="xla");case"biff8":s="/Workbook",n.biff=8;break;case"biff5":s="/Book",n.biff=5;break;default:throw new Error("invalid type "+n.bookType+" for XLS CFB")}return xe.utils.cfb_add(t,s,Xf(e,n)),8==n.biff&&(e.Props||e.Custprops)&&function(e,t){var r,a=[],n=[],s=[],i=0,o=Oe(Pa,"n"),c=Oe(La,"n");if(e.Props)for(r=Re(e.Props),i=0;i<r.length;++i)(Object.prototype.hasOwnProperty.call(o,r[i])?a:Object.prototype.hasOwnProperty.call(c,r[i])?n:s).push([r[i],e.Props[r[i]]]);if(e.Custprops)for(r=Re(e.Custprops),i=0;i<r.length;++i)Object.prototype.hasOwnProperty.call(e.Props||{},r[i])||(Object.prototype.hasOwnProperty.call(o,r[i])?a:Object.prototype.hasOwnProperty.call(c,r[i])?n:s).push([r[i],e.Custprops[r[i]]]);for(var l=[],i=0;i<s.length;++i)-1<_n.indexOf(s[i][0])||-1<on.indexOf(s[i][0])||null!=s[i][1]&&l.push(s[i]);n.length&&xe.utils.cfb_add(t,"/SummaryInformation",Cn(n,If.SI,c,La)),(a.length||l.length)&&xe.utils.cfb_add(t,"/DocumentSummaryInformation",Cn(a,If.DSI,o,Pa,l.length?l:null,If.UDI))}(e,t),8==n.biff&&e.vbaraw&&(r=t,(a=xe.read(e.vbaraw,{type:"string"==typeof e.vbaraw?"binary":"buffer"})).FullPaths.forEach(function(e,t){0==t||"/"!==(e=e.replace(/[^\/]*[\/]/,"/_VBA_PROJECT_CUR/")).slice(-1)&&xe.utils.cfb_add(r,e,a.FileIndex[t].content)})),t}var Df={0:{f:function(e,t){var r={},a=e.l+t;r.r=e.read_shift(4),e.l+=4;var n=e.read_shift(2);return e.l+=1,t=e.read_shift(1),e.l=a,7&t&&(r.level=7&t),16&t&&(r.hidden=!0),32&t&&(r.hpt=n/20),r}},1:{f:function(e){return[fa(e)]}},2:{f:function(e){return[fa(e),Ea(e),"n"]}},3:{f:function(e){return[fa(e),e.read_shift(1),"e"]}},4:{f:function(e){return[fa(e),e.read_shift(1),"b"]}},5:{f:function(e){return[fa(e),xa(e),"n"]}},6:{f:function(e){return[fa(e),sa(e),"str"]}},7:{f:function(e){return[fa(e),e.read_shift(4),"s"]}},8:{f:function(e,t,r){var a=e.l+t,n=fa(e);n.r=r["!row"];var s=[n,sa(e),"str"];return r.cellFormula?(e.l+=2,t=Wc(e,a-e.l,r),s[3]=Pc(t,0,n,r.supbooks,r)):e.l=a,s}},9:{f:function(e,t,r){var a=e.l+t,n=fa(e);n.r=r["!row"];var s=[n,xa(e),"n"];return r.cellFormula?(e.l+=2,t=Wc(e,a-e.l,r),s[3]=Pc(t,0,n,r.supbooks,r)):e.l=a,s}},10:{f:function(e,t,r){var a=e.l+t,n=fa(e);n.r=r["!row"];var s=[n,e.read_shift(1),"b"];return r.cellFormula?(e.l+=2,t=Wc(e,a-e.l,r),s[3]=Pc(t,0,n,r.supbooks,r)):e.l=a,s}},11:{f:function(e,t,r){var a=e.l+t,n=fa(e);n.r=r["!row"];var s=[n,e.read_shift(1),"e"];return r.cellFormula?(e.l+=2,t=Wc(e,a-e.l,r),s[3]=Pc(t,0,n,r.supbooks,r)):e.l=a,s}},12:{f:function(e){return[ua(e)]}},13:{f:function(e){return[ua(e),Ea(e),"n"]}},14:{f:function(e){return[ua(e),e.read_shift(1),"e"]}},15:{f:function(e){return[ua(e),e.read_shift(1),"b"]}},16:{f:Rl},17:{f:function(e){return[ua(e),sa(e),"str"]}},18:{f:function(e){return[ua(e),e.read_shift(4),"s"]}},19:{f:oa},20:{},21:{},22:{},23:{},24:{},25:{},26:{},27:{},28:{},29:{},30:{},31:{},32:{},33:{},34:{},35:{T:1},36:{T:-1},37:{T:1},38:{T:-1},39:{f:function(e,t,r){var a=e.l+t;e.l+=4,e.l+=1;var n=e.read_shift(4),s=va(e),t=Hc(e,0,r),r=ga(e);return e.l=a,t={Name:s,Ptg:t},n<268435455&&(t.Sheet=n),r&&(t.Comment=r),t}},40:{},42:{},43:{f:function(e,t,r){var a={};a.sz=e.read_shift(2)/20;var n,s=(s=(n=e).read_shift(1),n.l++,{fBold:1&s,fItalic:2&s,fUnderline:4&s,fStrikeout:8&s,fOutline:16&s,fShadow:32&s,fCondense:64&s,fExtend:128&s});switch(s.fItalic&&(a.italic=1),s.fCondense&&(a.condense=1),s.fExtend&&(a.extend=1),s.fShadow&&(a.shadow=1),s.fOutline&&(a.outline=1),s.fStrikeout&&(a.strike=1),700===e.read_shift(2)&&(a.bold=1),e.read_shift(2)){case 1:a.vertAlign="superscript";break;case 2:a.vertAlign="subscript"}switch(0!=(s=e.read_shift(1))&&(a.underline=s),0<(s=e.read_shift(1))&&(a.family=s),0<(s=e.read_shift(1))&&(a.charset=s),e.l++,a.color=function(e){var t={},r=e.read_shift(1)>>>1,a=e.read_shift(1),n=e.read_shift(2,"i"),s=e.read_shift(1),i=e.read_shift(1),o=e.read_shift(1);switch(e.l++,r){case 0:t.auto=1;break;case 1:t.index=a;var c=Ba[a];c&&(t.rgb=Qi(c));break;case 2:t.rgb=Qi([s,i,o]);break;case 3:t.theme=a}return 0!=n&&(t.tint=0<n?n/32767:n/32768),t}(e),e.read_shift(1)){case 1:a.scheme="major";break;case 2:a.scheme="minor"}return a.name=sa(e),a}},44:{f:function(e,t){return[e.read_shift(2),sa(e)]}},45:{f:Ro},46:{f:r},47:{f:function(e,t){var r=e.l+t,a=e.read_shift(2),t=e.read_shift(2);return e.l=r,{ixfe:a,numFmtId:t}}},48:{},49:{f:function(e){return e.read_shift(4,"i")}},50:{},51:{f:function(e){for(var t=[],r=e.read_shift(4);0<r--;)t.push([e.read_shift(4),e.read_shift(4)]);return t}},52:{T:1},53:{T:-1},54:{T:1},55:{T:-1},56:{T:1},57:{T:-1},58:{},59:{},60:{f:vs},62:{f:function(e){return[fa(e),oa(e),"is"]}},63:{f:function(e){var t={};t.i=e.read_shift(4);var r={};return r.r=e.read_shift(4),r.c=e.read_shift(4),t.r=Kr(r),2&(e=e.read_shift(1))&&(t.l="1"),8&e&&(t.a="1"),t}},64:{f:function(){}},65:{},66:{},67:{},68:{},69:{},70:{},128:{},129:{T:1},130:{T:-1},131:{T:1,f:Pr,p:0},132:{T:-1},133:{T:1},134:{T:-1},135:{T:1},136:{T:-1},137:{T:1,f:function(e){var t=e.read_shift(2);return e.l+=28,{RTL:32&t}}},138:{T:-1},139:{T:1},140:{T:-1},141:{T:1},142:{T:-1},143:{T:1},144:{T:-1},145:{T:1},146:{T:-1},147:{f:function(e,t){var r={},a=e[e.l];return++e.l,r.above=!(64&a),r.left=!(128&a),e.l+=18,r.name=pa(e,t-19),r}},148:{f:lt,p:16},151:{f:function(){}},152:{},153:{f:function(e,t){var r={},a=e.read_shift(4);return r.defaultThemeVersion=e.read_shift(4),0<(e=8<t?sa(e):"").length&&(r.CodeName=e),r.autoCompressPictures=!!(65536&a),r.backupFile=!!(64&a),r.checkCompatibility=!!(4096&a),r.date1904=!!(1&a),r.filterPrivacy=!!(8&a),r.hidePivotFieldList=!!(1024&a),r.promptedSolutions=!!(16&a),r.publishItems=!!(2048&a),r.refreshAllConnections=!!(262144&a),r.saveExternalLinkValues=!!(128&a),r.showBorderUnselectedTables=!!(4&a),r.showInkAnnotation=!!(32&a),r.showObjects=["all","placeholders","none"][a>>13&3],r.showPivotChartFilter=!!(32768&a),r.updateLinks=["userSet","never","always"][a>>8&3],r}},154:{},155:{},156:{f:function(e,t){var r={};return r.Hidden=e.read_shift(4),r.iTabID=e.read_shift(4),r.strRelID=wa(e,t-8),r.name=sa(e),r}},157:{},158:{},159:{T:1,f:function(e){return[e.read_shift(4),e.read_shift(4)]}},160:{T:-1},161:{T:1,f:Sa},162:{T:-1},163:{T:1},164:{T:-1},165:{T:1},166:{T:-1},167:{},168:{},169:{},170:{},171:{},172:{T:1},173:{T:-1},174:{},175:{},176:{f:Lt},177:{T:1},178:{T:-1},179:{T:1},180:{T:-1},181:{T:1},182:{T:-1},183:{T:1},184:{T:-1},185:{T:1},186:{T:-1},187:{T:1},188:{T:-1},189:{T:1},190:{T:-1},191:{T:1},192:{T:-1},193:{T:1},194:{T:-1},195:{T:1},196:{T:-1},197:{T:1},198:{T:-1},199:{T:1},200:{T:-1},201:{T:1},202:{T:-1},203:{T:1},204:{T:-1},205:{T:1},206:{T:-1},207:{T:1},208:{T:-1},209:{T:1},210:{T:-1},211:{T:1},212:{T:-1},213:{T:1},214:{T:-1},215:{T:1},216:{T:-1},217:{T:1},218:{T:-1},219:{T:1},220:{T:-1},221:{T:1},222:{T:-1},223:{T:1},224:{T:-1},225:{T:1},226:{T:-1},227:{T:1},228:{T:-1},229:{T:1},230:{T:-1},231:{T:1},232:{T:-1},233:{T:1},234:{T:-1},235:{T:1},236:{T:-1},237:{T:1},238:{T:-1},239:{T:1},240:{T:-1},241:{T:1},242:{T:-1},243:{T:1},244:{T:-1},245:{T:1},246:{T:-1},247:{T:1},248:{T:-1},249:{T:1},250:{T:-1},251:{T:1},252:{T:-1},253:{T:1},254:{T:-1},255:{T:1},256:{T:-1},257:{T:1},258:{T:-1},259:{T:1},260:{T:-1},261:{T:1},262:{T:-1},263:{T:1},264:{T:-1},265:{T:1},266:{T:-1},267:{T:1},268:{T:-1},269:{T:1},270:{T:-1},271:{T:1},272:{T:-1},273:{T:1},274:{T:-1},275:{T:1},276:{T:-1},277:{},278:{T:1},279:{T:-1},280:{T:1},281:{T:-1},282:{T:1},283:{T:1},284:{T:-1},285:{T:1},286:{T:-1},287:{T:1},288:{T:-1},289:{T:1},290:{T:-1},291:{T:1},292:{T:-1},293:{T:1},294:{T:-1},295:{T:1},296:{T:-1},297:{T:1},298:{T:-1},299:{T:1},300:{T:-1},301:{T:1},302:{T:-1},303:{T:1},304:{T:-1},305:{T:1},306:{T:-1},307:{T:1},308:{T:-1},309:{T:1},310:{T:-1},311:{T:1},312:{T:-1},313:{T:-1},314:{T:1},315:{T:-1},316:{T:1},317:{T:-1},318:{T:1},319:{T:-1},320:{T:1},321:{T:-1},322:{T:1},323:{T:-1},324:{T:1},325:{T:-1},326:{T:1},327:{T:-1},328:{T:1},329:{T:-1},330:{T:1},331:{T:-1},332:{T:1},333:{T:-1},334:{T:1},335:{f:function(e,t){return{flags:e.read_shift(4),version:e.read_shift(4),name:sa(e)}}},336:{T:-1},337:{f:function(e){return e.l+=4,0!=e.read_shift(4)},T:1},338:{T:-1},339:{T:1},340:{T:-1},341:{T:1},342:{T:-1},343:{T:1},344:{T:-1},345:{T:1},346:{T:-1},347:{T:1},348:{T:-1},349:{T:1},350:{T:-1},351:{},352:{},353:{T:1},354:{T:-1},355:{f:wa},357:{},358:{},359:{},360:{T:1},361:{},362:{f:ps},363:{},364:{},366:{},367:{},368:{},369:{},370:{},371:{},372:{T:1},373:{T:-1},374:{T:1},375:{T:-1},376:{T:1},377:{T:-1},378:{T:1},379:{T:-1},380:{T:1},381:{T:-1},382:{T:1},383:{T:-1},384:{T:1},385:{T:-1},386:{T:1},387:{T:-1},388:{T:1},389:{T:-1},390:{T:1},391:{T:-1},392:{T:1},393:{T:-1},394:{T:1},395:{T:-1},396:{},397:{},398:{},399:{},400:{},401:{T:1},403:{},404:{},405:{},406:{},407:{},408:{},409:{},410:{},411:{},412:{},413:{},414:{},415:{},416:{},417:{},418:{},419:{},420:{},421:{},422:{T:1},423:{T:1},424:{T:-1},425:{T:-1},426:{f:function(e,t,r){var a=e.l+t,n=ya(e),t=e.read_shift(1);return(n=[n])[2]=t,r.cellFormula?(r=Bc(e,a-e.l,r),n[1]=r):e.l=a,n}},427:{f:function(e,t,r){var a=e.l+t,t=[Sa(e,16)];return r.cellFormula&&(r=zc(e,a-e.l,r),t[1]=r),e.l=a,t}},428:{},429:{T:1},430:{T:-1},431:{T:1},432:{T:-1},433:{T:1},434:{T:-1},435:{T:1},436:{T:-1},437:{T:1},438:{T:-1},439:{T:1},440:{T:-1},441:{T:1},442:{T:-1},443:{T:1},444:{T:-1},445:{T:1},446:{T:-1},447:{T:1},448:{T:-1},449:{T:1},450:{T:-1},451:{T:1},452:{T:-1},453:{T:1},454:{T:-1},455:{T:1},456:{T:-1},457:{T:1},458:{T:-1},459:{T:1},460:{T:-1},461:{T:1},462:{T:-1},463:{T:1},464:{T:-1},465:{T:1},466:{T:-1},467:{T:1},468:{T:-1},469:{T:1},470:{T:-1},471:{},472:{},473:{T:1},474:{T:-1},475:{},476:{f:function(t){var r={};return Il.forEach(function(e){r[e]=xa(t)}),r}},477:{},478:{},479:{T:1},480:{T:-1},481:{T:1},482:{T:-1},483:{T:1},484:{T:-1},485:{f:function(){}},486:{T:1},487:{T:-1},488:{T:1},489:{T:-1},490:{T:1},491:{T:-1},492:{T:1},493:{T:-1},494:{f:function(e,t){var r=e.l+t,a=Sa(e,16),n=ga(e),s=sa(e),i=sa(e),t=sa(e);return e.l=r,t={rfx:a,relId:n,loc:s,display:t},i&&(t.Tooltip=i),t}},495:{T:1},496:{T:-1},497:{T:1},498:{T:-1},499:{},500:{T:1},501:{T:-1},502:{T:1},503:{T:-1},504:{},505:{T:1},506:{T:-1},507:{},508:{T:1},509:{T:-1},510:{T:1},511:{T:-1},512:{},513:{},514:{T:1},515:{T:-1},516:{T:1},517:{T:-1},518:{T:1},519:{T:-1},520:{T:1},521:{T:-1},522:{},523:{},524:{},525:{},526:{},527:{},528:{T:1},529:{T:-1},530:{T:1},531:{T:-1},532:{T:1},533:{T:-1},534:{},535:{},536:{},537:{},538:{T:1},539:{T:-1},540:{T:1},541:{T:-1},542:{T:1},548:{},549:{},550:{f:wa},551:{},552:{},553:{},554:{T:1},555:{T:-1},556:{T:1},557:{T:-1},558:{T:1},559:{T:-1},560:{T:1},561:{T:-1},562:{},564:{},565:{T:1},566:{T:-1},569:{T:1},570:{T:-1},572:{},573:{T:1},574:{T:-1},577:{},578:{},579:{},580:{},581:{},582:{},583:{},584:{},585:{},586:{},587:{},588:{T:-1},589:{},590:{T:1},591:{T:-1},592:{T:1},593:{T:-1},594:{T:1},595:{T:-1},596:{},597:{T:1},598:{T:-1},599:{T:1},600:{T:-1},601:{T:1},602:{T:-1},603:{T:1},604:{T:-1},605:{T:1},606:{T:-1},607:{},608:{T:1},609:{T:-1},610:{},611:{T:1},612:{T:-1},613:{T:1},614:{T:-1},615:{T:1},616:{T:-1},617:{T:1},618:{T:-1},619:{T:1},620:{T:-1},625:{},626:{T:1},627:{T:-1},628:{T:1},629:{T:-1},630:{T:1},631:{T:-1},632:{f:Ue},633:{T:1},634:{T:-1},635:{T:1,f:function(e){var t={};t.iauthor=e.read_shift(4);var r=Sa(e,16);return t.rfx=r.s,t.ref=Kr(r.s),e.l+=16,t}},636:{T:-1},637:{f:ca},638:{T:1},639:{},640:{T:-1},641:{T:1},642:{T:-1},643:{T:1},644:{},645:{T:-1},646:{T:1},648:{T:1},649:{},650:{T:-1},651:{f:function(e,t){return e.l+=10,{name:sa(e)}}},652:{},653:{T:1},654:{T:-1},655:{T:1},656:{T:-1},657:{T:1},658:{T:-1},659:{},660:{T:1},661:{},662:{T:-1},663:{},664:{T:1},665:{},666:{T:-1},667:{},668:{},669:{},671:{T:1},672:{T:-1},673:{T:1},674:{T:-1},675:{},676:{},677:{},678:{},679:{},680:{},681:{},1024:{},1025:{},1026:{T:1},1027:{T:-1},1028:{T:1},1029:{T:-1},1030:{},1031:{T:1},1032:{T:-1},1033:{T:1},1034:{T:-1},1035:{},1036:{},1037:{},1038:{T:1},1039:{T:-1},1040:{},1041:{T:1},1042:{T:-1},1043:{},1044:{},1045:{},1046:{T:1},1047:{T:-1},1048:{T:1},1049:{T:-1},1050:{},1051:{T:1},1052:{T:1},1053:{f:function(){}},1054:{T:1},1055:{},1056:{T:1},1057:{T:-1},1058:{T:1},1059:{T:-1},1061:{},1062:{T:1},1063:{T:-1},1064:{T:1},1065:{T:-1},1066:{T:1},1067:{T:-1},1068:{T:1},1069:{T:-1},1070:{T:1},1071:{T:-1},1072:{T:1},1073:{T:-1},1075:{T:1},1076:{T:-1},1077:{T:1},1078:{T:-1},1079:{T:1},1080:{T:-1},1081:{T:1},1082:{T:-1},1083:{T:1},1084:{T:-1},1085:{},1086:{T:1},1087:{T:-1},1088:{T:1},1089:{T:-1},1090:{T:1},1091:{T:-1},1092:{T:1},1093:{T:-1},1094:{T:1},1095:{T:-1},1096:{},1097:{T:1},1098:{},1099:{T:-1},1100:{T:1},1101:{T:-1},1102:{},1103:{},1104:{},1105:{},1111:{},1112:{},1113:{T:1},1114:{T:-1},1115:{T:1},1116:{T:-1},1117:{},1118:{T:1},1119:{T:-1},1120:{T:1},1121:{T:-1},1122:{T:1},1123:{T:-1},1124:{T:1},1125:{T:-1},1126:{},1128:{T:1},1129:{T:-1},1130:{},1131:{T:1},1132:{T:-1},1133:{T:1},1134:{T:-1},1135:{T:1},1136:{T:-1},1137:{T:1},1138:{T:-1},1139:{T:1},1140:{T:-1},1141:{},1142:{T:1},1143:{T:-1},1144:{T:1},1145:{T:-1},1146:{},1147:{T:1},1148:{T:-1},1149:{T:1},1150:{T:-1},1152:{T:1},1153:{T:-1},1154:{T:-1},1155:{T:-1},1156:{T:-1},1157:{T:1},1158:{T:-1},1159:{T:1},1160:{T:-1},1161:{T:1},1162:{T:-1},1163:{T:1},1164:{T:-1},1165:{T:1},1166:{T:-1},1167:{T:1},1168:{T:-1},1169:{T:1},1170:{T:-1},1171:{},1172:{T:1},1173:{T:-1},1177:{},1178:{T:1},1180:{},1181:{},1182:{},2048:{T:1},2049:{T:-1},2050:{},2051:{T:1},2052:{T:-1},2053:{},2054:{},2055:{T:1},2056:{T:-1},2057:{T:1},2058:{T:-1},2060:{},2067:{},2068:{T:1},2069:{T:-1},2070:{},2071:{},2072:{T:1},2073:{T:-1},2075:{},2076:{},2077:{T:1},2078:{T:-1},2079:{},2080:{T:1},2081:{T:-1},2082:{},2083:{T:1},2084:{T:-1},2085:{T:1},2086:{T:-1},2087:{T:1},2088:{T:-1},2089:{T:1},2090:{T:-1},2091:{},2092:{},2093:{T:1},2094:{T:-1},2095:{},2096:{T:1},2097:{T:-1},2098:{T:1},2099:{T:-1},2100:{T:1},2101:{T:-1},2102:{},2103:{T:1},2104:{T:-1},2105:{},2106:{T:1},2107:{T:-1},2108:{},2109:{T:1},2110:{T:-1},2111:{T:1},2112:{T:-1},2113:{T:1},2114:{T:-1},2115:{},2116:{},2117:{},2118:{T:1},2119:{T:-1},2120:{},2121:{T:1},2122:{T:-1},2123:{T:1},2124:{T:-1},2125:{},2126:{T:1},2127:{T:-1},2128:{},2129:{T:1},2130:{T:-1},2131:{T:1},2132:{T:-1},2133:{T:1},2134:{},2135:{},2136:{},2137:{T:1},2138:{T:-1},2139:{T:1},2140:{T:-1},2141:{},3072:{},3073:{},4096:{T:1},4097:{T:-1},5002:{T:1},5003:{T:-1},5081:{T:1},5082:{T:-1},5083:{},5084:{T:1},5085:{T:-1},5086:{T:1},5087:{T:-1},5088:{},5089:{},5090:{},5092:{T:1},5093:{T:-1},5094:{},5095:{T:1},5096:{T:-1},5097:{},5099:{},65535:{n:""}},Pf={6:{f:Lc},10:{f:Rn},12:{f:Nn},13:{f:Nn},14:{f:On},15:{f:On},16:{f:xa},17:{f:On},18:{f:On},19:{f:Nn},20:{f:fs},21:{f:fs},23:{f:ps},24:{f:ds},25:{f:On},26:{},27:{},28:{f:function(e,t,r){return function(e,t){if(!(t.biff<8)){var r=e.read_shift(2),a=e.read_shift(2),n=e.read_shift(2),s=e.read_shift(2),i=Bn(e,0,t);return t.biff<8&&e.read_shift(1),[{r:r,c:a},i,s,n]}}(e,r)}},29:{},34:{f:On},35:{f:hs},38:{f:xa},39:{f:xa},40:{f:xa},41:{f:xa},42:{f:On},43:{f:On},47:{f:function(e,t,r){var a={Type:8<=r.biff?e.read_shift(2):0};return a.Type?Ki(e,t-2,a):(t=e,r.biff,e=r,r=a,t={key:Nn(t),verificationBytes:Nn(t)},e.password&&(t.verifier=zi(e.password)),r.valid=t.verificationBytes===t.verifier,r.valid&&(r.insitu=Yi(e.password))),a}},49:{f:function(e,t,r){var a={dyHeight:e.read_shift(2),fl:e.read_shift(2)};switch(r&&r.biff||8){case 2:break;case 3:case 4:e.l+=2;break;default:e.l+=10}return a.name=Ln(e,0,r),a}},51:{f:Nn},60:{},61:{f:function(e){return{Pos:[e.read_shift(2),e.read_shift(2)],Dim:[e.read_shift(2),e.read_shift(2)],Flags:e.read_shift(2),CurTab:e.read_shift(2),FirstTab:e.read_shift(2),Selected:e.read_shift(2),TabRatio:e.read_shift(2)}}},64:{f:On},65:{f:function(){}},66:{f:Nn},77:{},80:{},81:{},82:{},85:{f:Nn},89:{},90:{},91:{},92:{f:function(e,t,r){if(r.enc)return e.l+=t,"";var a=e.l,r=Bn(e,0,r);return e.read_shift(t+a-e.l),r}},93:{f:function(e,t,r){return r&&r.biff<8?function(e,t,r){e.l+=4;var a=e.read_shift(2),n=e.read_shift(2),s=e.read_shift(2);e.l+=2,e.l+=2,e.l+=2,e.l+=2,e.l+=2,e.l+=2,e.l+=2,e.l+=2,e.l+=2,e.l+=6,t-=36;var i=[];return i.push((gs[a]||Pr)(e,t,r)),{cmo:[n,a,s],ft:i}}(e,t,r):{cmo:r=Qn(e),ft:function(t,e){for(var r=t.l+e,a=[];t.l<r;){var n=t.read_shift(2);t.l-=2;try{a.push(ts[n](t,r-t.l))}catch(e){return t.l=r,a}}return t.l!=r&&(t.l=r),a}(e,t-22,r[1])}}},94:{},95:{f:On},96:{},97:{},99:{f:On},125:{f:vs},128:{f:function(e){if(e.l+=4,0!==(e=[e.read_shift(2),e.read_shift(2)])[0]&&e[0]--,0!==e[1]&&e[1]--,7<e[0]||7<e[1])throw new Error("Bad Gutters: "+e.join("|"));return e}},129:{f:function(e,t,r){return{fDialog:16&(t=r&&8==r.biff||2==t?e.read_shift(2):(e.l+=t,0)),fBelow:64&t,fRight:128&t}}},130:{f:Nn},131:{f:On},132:{f:On},133:{f:function(e,t,r){var a=e.read_shift(4),n=3&e.read_shift(1),s=e.read_shift(1);switch(s){case 0:s="Worksheet";break;case 1:s="Macrosheet";break;case 2:s="Chartsheet";break;case 6:s="VBAModule"}return r=Ln(e,0,r),{pos:a,hs:n,dt:s,name:r=0===r.length?"Sheet1":r}}},134:{},140:{f:function(e){var t=[0,0],r=e.read_shift(2);return t[0]=Ma[r]||r,r=e.read_shift(2),t[1]=Ma[r]||r,t}},141:{f:Nn},144:{},146:{f:function(e){for(var t=e.read_shift(2),r=[];0<t--;)r.push(jn(e));return r}},151:{},152:{},153:{},154:{},155:{},156:{f:Nn},157:{},158:{},160:{f:Ts},161:{f:function(e,t){var r={};return t<32||(e.l+=16,r.header=xa(e),r.footer=xa(e),e.l+=2),r}},174:{},175:{},176:{},177:{},178:{},180:{},181:{},182:{},184:{},185:{},189:{f:function(e,t){for(var r=e.l+t-2,a=e.read_shift(2),n=e.read_shift(2),s=[];e.l<r;)s.push(Yn(e));if(e.l!==r)throw new Error("MulRK read error");if(t=e.read_shift(2),s.length!=t-n+1)throw new Error("MulRK length mismatch");return{r:a,c:n,C:t,rkrec:s}}},190:{f:function(e,t){for(var r=e.l+t-2,a=e.read_shift(2),n=e.read_shift(2),s=[];e.l<r;)s.push(e.read_shift(2));if(e.l!==r)throw new Error("MulBlank read error");if(t=e.read_shift(2),s.length!=t-n+1)throw new Error("MulBlank length mismatch");return{r:a,c:n,C:t,ixfe:s}}},193:{f:Rn},197:{},198:{},199:{},200:{},201:{},202:{f:On},203:{},204:{},205:{},206:{},207:{},208:{},209:{},210:{},211:{},213:{},215:{},216:{},217:{},218:{f:Nn},220:{},221:{f:On},222:{},224:{f:function(e,t,r){var a,n,s,i={};return i.ifnt=e.read_shift(2),i.numFmtId=e.read_shift(2),i.flags=e.read_shift(2),i.fStyle=i.flags>>2&1,t-=6,i.data=(a=e,i.fStyle,n=r,s={},t=a.read_shift(4),e=a.read_shift(4),r=a.read_shift(4),a=a.read_shift(2),s.patternType=Ua[r>>26],n.cellStyles&&(s.alc=7&t,s.fWrap=t>>3&1,s.alcV=t>>4&7,s.fJustLast=t>>7&1,s.trot=t>>8&255,s.cIndent=t>>16&15,s.fShrinkToFit=t>>20&1,s.iReadOrder=t>>22&2,s.fAtrNum=t>>26&1,s.fAtrFnt=t>>27&1,s.fAtrAlc=t>>28&1,s.fAtrBdr=t>>29&1,s.fAtrPat=t>>30&1,s.fAtrProt=t>>31&1,s.dgLeft=15&e,s.dgRight=e>>4&15,s.dgTop=e>>8&15,s.dgBottom=e>>12&15,s.icvLeft=e>>16&127,s.icvRight=e>>23&127,s.grbitDiag=e>>30&3,s.icvTop=127&r,s.icvBottom=r>>7&127,s.icvDiag=r>>14&127,s.dgDiag=r>>21&15,s.icvFore=127&a,s.icvBack=a>>7&127,s.fsxButton=a>>14&1),s),i}},225:{f:function(e,t){return 0===t||e.read_shift(2),1200}},226:{f:Rn},227:{},229:{f:function(e,t){for(var r=[],a=e.read_shift(2);a--;)r.push(Kn(e));return r}},233:{},235:{},236:{},237:{},239:{},240:{},241:{},242:{},244:{},245:{},246:{},247:{},248:{},249:{},251:{},252:{f:function(e,t){for(var r=e.l+t,t=e.read_shift(4),a=e.read_shift(4),n=[],s=0;s!=a&&e.l<r;++s)n.push(function(e){var t=f;f=1200;var r,a=e.read_shift(2),n=4&(c=e.read_shift(1)),s=8&c,i=1+(1&c),o=0,c={};return s&&(o=e.read_shift(2)),n&&(r=e.read_shift(4)),i=2==i?"dbcs-cont":"sbcs-cont",i=0===a?"":e.read_shift(a,i),s&&(e.l+=4*o),n&&(e.l+=r),c.t=i,s||(c.raw="<t>"+c.t+"</t>",c.r=c.t),f=t,c}(e));return n.Count=t,n.Unique=a,n}},253:{f:function(e){var t=$n(e);return t.isst=e.read_shift(4),t}},255:{f:function(e,t){var r={};return r.dsst=e.read_shift(2),e.l+=t-2,r}},256:{},259:{},290:{},311:{},312:{},315:{},317:{f:Dn},318:{},319:{},320:{},330:{},331:{},333:{},334:{},335:{},336:{},337:{},338:{},339:{},340:{},351:{},352:{f:On},353:{f:Rn},401:{},402:{},403:{},404:{},405:{},406:{},407:{},408:{},425:{},426:{},427:{},428:{},429:{},430:{f:function(e,t,r){var a=e.l+t,n=e.read_shift(2),t=e.read_shift(2);if(1025==(r.sbcch=t)||14849==t)return[t,n];if(t<1||255<t)throw new Error("Unexpected SupBook type: "+t);for(var r=Mn(e,t),s=[];a>e.l;)s.push(Un(e));return[t,n,r,s]}},431:{f:On},432:{},433:{},434:{},437:{},438:{f:function(t,r,e){var a=t.l,n="";try{t.l+=4;var s=(e.lastobj||{cmo:[0,0]}).cmo[1];-1==[0,5,7,11,12,14].indexOf(s)?t.l+=6:function(e){var t=e.read_shift(1);e.l++;var r=e.read_shift(2);e.l+=2}(t);var i=t.read_shift(2);t.read_shift(2),Nn(t);s=t.read_shift(2);t.l+=s;for(var o=1;o<t.lens.length-1;++o){if(t.l-a!=t.lens[o])throw new Error("TxO: bad continue record");var c=t[t.l];if((n+=Mn(t,t.lens[o+1]-t.lens[o]-1)).length>=(c?i:2*i))break}if(n.length!==i&&n.length!==2*i)throw new Error("cchText: "+i+" != "+n.length);return t.l=a+r,{t:n}}catch(e){return t.l=a+r,{t:n}}}},439:{f:On},440:{f:function(e,t){var r=Kn(e);return e.l+=16,[r,function(e,t){var r=e.l+t;if(2!==(c=e.read_shift(4)))throw new Error("Unrecognized streamVersion: "+c);t=e.read_shift(2),e.l+=2;var a,n,s,i,o,c="";16&t&&(a=zn(e,e.l)),128&t&&(n=zn(e,e.l)),257==(257&t)&&(s=zn(e,e.l)),1==(257&t)&&(l=Hn(e,e.l)),8&t&&(c=zn(e,e.l)),32&t&&(i=e.read_shift(16)),64&t&&(o=pn(e)),e.l=r;var l=n||s||l||"";return l&&c&&(l+="#"+c),l=l||"#"+c,l={Target:l=2&t&&"/"==l.charAt(0)&&"/"!=l.charAt(1)?"file://"+l:l},i&&(l.guid=i),o&&(l.time=o),a&&(l.Tooltip=a),l}(e,t-24)]}},441:{},442:{f:Un},443:{},444:{f:Nn},445:{},446:{},448:{f:Rn},449:{f:function(e){return e.read_shift(2),e.read_shift(4)},r:2},450:{f:Rn},512:{f:os},513:{f:ws},515:{f:function(e,t,r){return r.biffguess&&2==r.biff&&(r.biff=5),r=$n(e),e=xa(e),r.val=e,r}},516:{f:function(e,t,r){return r.biffguess&&2==r.biff&&(r.biff=5),e.l,t=$n(e),2==r.biff&&e.l++,r=Un(e,e.l,r),t.val=r,t}},517:{f:ls},519:{f:Es},520:{f:function(e){var t={};t.r=e.read_shift(2),t.c=e.read_shift(2),t.cnt=e.read_shift(2)-t.c;var r=e.read_shift(2);e.l+=4;var a=e.read_shift(1);return e.l+=3,7&a&&(t.level=7&a),32&a&&(t.hidden=!0),64&a&&(t.hpt=r/20),t}},523:{},545:{f:ms},549:{f:ss},566:{},574:{f:function(e,t,r){return r&&2<=r.biff&&r.biff<5?{}:{RTL:64&e.read_shift(2)}}},638:{f:function(e){var t=e.read_shift(2),r=e.read_shift(2),e=Yn(e);return{r:t,c:r,ixfe:e[0],rknum:e[1]}}},659:{},1048:{},1054:{f:function(e,t,r){return[e.read_shift(2),Bn(e,0,r)]}},1084:{},1212:{f:function(e,t,r){var a=qn(e);e.l++;var n=e.read_shift(1);return[function(e,t,r){var a,n=e.l+t,s=e.read_shift(2),i=Ic(e,s,r);if(65535==s)return[[],Pr(e,t-2)];t!==s+2&&(a=Oc(e,n-s-2,i,r));return[i,a]}(e,t-=8,r),n,a]}},2048:{f:function(e,t){return e.read_shift(2),[Kn(e),e.read_shift((t-10)/2,"dbcs-cont").replace(de,"")]}},2049:{},2050:{},2051:{},2052:{},2053:{},2054:{},2055:{},2056:{},2057:{f:rs},2058:{},2059:{},2060:{},2061:{},2062:{},2063:{},2064:{},2066:{},2067:{},2128:{},2129:{},2130:{},2131:{},2132:{},2133:{},2134:{},2135:{},2136:{},2137:{},2138:{},2146:{},2147:{r:12},2148:{},2149:{},2150:{},2151:{f:Rn},2152:{},2154:{},2155:{},2156:{},2161:{},2162:{},2164:{},2165:{},2166:{},2167:{},2168:{},2169:{},2170:{},2171:{},2172:{f:function(e){e.l+=2;var t={cxfs:0,crc:0};return t.cxfs=e.read_shift(2),t.crc=e.read_shift(4),t},r:12},2173:{f:function(e,t){e.l,e.l+=2,t=e.read_shift(2),e.l+=2;for(var r=e.read_shift(2),a=[];0<r--;)a.push(Ko(e,e.l));return{ixfe:t,ext:a}},r:12},2174:{},2175:{},2180:{},2181:{},2182:{},2183:{},2184:{},2185:{},2186:{},2187:{},2188:{f:On,r:12},2189:{},2190:{r:12},2191:{},2192:{},2194:{},2195:{},2196:{f:function(e,t,r){if(!(r.biff<8)){var a=e.read_shift(2),n=e.read_shift(2);return[Mn(e,a,r),Mn(e,n,r)]}e.l+=t},r:12},2197:{},2198:{f:function(e,t,r){var a=e.l+t;if(124226!==e.read_shift(4))if(r.cellStyles){var n,s=e.slice(e.l);e.l=a;try{n=st(s,{type:"array"})}catch(e){return}t=tt(n,"theme/theme/theme1.xml",!0);if(t)return $o(t,r)}else e.l=a},r:12},2199:{},2200:{},2201:{},2202:{f:function(e){return[0!==e.read_shift(4),0!==e.read_shift(4),e.read_shift(4)]},r:12},2203:{f:Rn},2204:{},2205:{},2206:{},2207:{},2211:{f:function(e){var t,r,a=(r=(t=e).read_shift(2),a=t.read_shift(2),t.l+=8,{type:r,flags:a});if(2211!=a.type)throw new Error("Invalid Future Record "+a.type);return 0!==e.read_shift(4)}},2212:{},2213:{},2214:{},2215:{},4097:{},4098:{},4099:{},4102:{},4103:{},4105:{},4106:{},4107:{},4108:{},4109:{},4116:{},4117:{},4118:{},4119:{},4120:{},4121:{},4122:{},4123:{},4124:{},4125:{},4126:{},4127:{},4128:{},4129:{},4130:{},4132:{},4133:{},4134:{f:Nn},4135:{},4146:{},4147:{},4148:{},4149:{},4154:{},4156:{},4157:{},4158:{},4159:{},4160:{},4161:{},4163:{},4164:{f:function(e,t,r){var a={area:!1};return 5!=r.biff?e.l+=t:(t=e.read_shift(1),e.l+=3,16&t&&(a.area=!0)),a}},4165:{},4166:{},4168:{},4170:{},4171:{},4174:{},4175:{},4176:{},4177:{},4187:{},4188:{f:function(e){for(var t=e.read_shift(2),r=[];0<t--;)r.push(jn(e));return r}},4189:{},4191:{},4192:{},4193:{},4194:{},4195:{},4196:{},4197:{},4198:{},4199:{},4200:{},0:{f:os},1:{},2:{f:function(e){var t=$n(e);return++e.l,e=e.read_shift(2),t.t="n",t.val=e,t}},3:{f:function(e){var t=$n(e);return++e.l,e=xa(e),t.t="n",t.val=e,t}},4:{f:function(e,t,r){r.biffguess&&5==r.biff&&(r.biff=2);var a=$n(e);return++e.l,r=Bn(e,0,r),a.t="str",a.val=r,a}},5:{f:ls},7:{f:function(e){var t=e.read_shift(1);return 0===t?(e.l++,""):e.read_shift(t,"sbcs-cont")}},8:{},9:{f:rs},11:{},22:{f:Nn},30:{f:is},31:{},32:{},33:{f:ms},36:{},37:{f:ss},50:{f:function(e,t){e.l+=6,e.l+=2,e.l+=1,e.l+=3,e.l+=1,e.l+=t-13}},62:{},52:{},67:{},68:{f:Nn},69:{},86:{},126:{},127:{f:function(e){var t=e.read_shift(2),r=e.read_shift(2),a=e.read_shift(4),r={fmt:t,env:r,len:a,data:e.slice(e.l,e.l+a)};return e.l+=a,r}},135:{},136:{},137:{},145:{},148:{},149:{},150:{},169:{},171:{},188:{},191:{},192:{},194:{},195:{},214:{f:function(e,t,r){var a=e.l+t,n=$n(e),t=e.read_shift(2),r=Mn(e,t,r);return e.l=a,n.t="str",n.val=r,n}},223:{},234:{},354:{},421:{},518:{f:Lc},521:{f:rs},536:{f:ds},547:{f:hs},561:{},579:{},1030:{f:Lc},1033:{f:rs},1091:{},2157:{},2163:{},2177:{},2240:{},2241:{},2242:{},2243:{},2244:{},2245:{},2246:{},2247:{},2248:{},2249:{},2250:{},2251:{},2262:{r:12},29282:{}};function Lf(e,t,r,a){var n=t;isNaN(n)||(t=a||(r||[]).length||0,(a=e.next(4)).write_shift(2,n),a.write_shift(2,t),0<t&&Er(r)&&e.push(r))}function Mf(e,t,r){return(e=e||Lr(7)).write_shift(2,t),e.write_shift(2,r),e.write_shift(2,0),e.write_shift(1,0),e}function Uf(e,t,r,a){if(null!=t.v)switch(t.t){case"d":case"n":var n="d"==t.t?De(He(t.v)):t.v;return void(n==(0|n)&&0<=n&&n<65536?Lf(e,2,(f=r,h=a,u=n,Mf(d=Lr(9),f,h),d.write_shift(2,u),d)):Lf(e,3,(u=r,d=a,n=n,Mf(l=Lr(15),u,d),l.write_shift(8,n,"f"),l)));case"b":case"e":return void Lf(e,5,(l=r,s=a,i=t.v,o=t.t,Mf(c=Lr(9),l,s),Pn(i,o||"b",c),c));case"s":case"str":return void Lf(e,4,(s=r,i=a,o=(t.v||"").slice(0,255),Mf(c=Lr(8+2*o.length),s,i),c.write_shift(1,o.length),c.write_shift(o.length,o,"sbcs"),c.l<c.length?c.slice(0,c.l):c))}var s,i,o,c,l,f,h,u,d;Lf(e,1,Mf(null,r,a))}function Bf(e,t){var r=t||{};null!=oe&&null==r.dense&&(r.dense=oe);for(var t=Ur(),a=0,n=0;n<e.SheetNames.length;++n)e.SheetNames[n]==r.sheet&&(a=n);if(0==a&&r.sheet&&e.SheetNames[0]!=r.sheet)throw new Error("Sheet not found: "+r.sheet);return Lf(t,4==r.biff?1033:3==r.biff?521:9,as(0,16,r)),function(e,t,r){var a,n,s=Array.isArray(t),i=Zr(t["!ref"]||"A1"),o=[];if(255<i.e.c||16383<i.e.r){if(r.WTF)throw new Error("Range "+(t["!ref"]||"A1")+" exceeds format limit A1:IV16384");i.e.c=Math.min(i.e.c,255),i.e.r=Math.min(i.e.c,16383),a=qr(i)}for(var c=i.s.r;c<=i.e.r;++c){n=jr(c);for(var l=i.s.c;l<=i.e.c;++l){c===i.s.r&&(o[l]=Xr(l)),a=o[l]+n;var f=s?(t[c]||[])[l]:t[a];f&&Uf(e,f,c,l)}}}(t,e.Sheets[e.SheetNames[a]],r),Lf(t,10),t.end()}function Wf(e,t,r){var a,n;Lf(e,49,(n=(a={sz:12,color:{theme:1},name:"Arial",family:2,scheme:"minor"}).name||"Arial",(e=Lr((r=(e=r)&&5==e.biff)?15+n.length:16+2*n.length)).write_shift(2,20*(a.sz||12)),e.write_shift(4,0),e.write_shift(2,400),e.write_shift(4,0),e.write_shift(2,0),e.write_shift(1,n.length),r||e.write_shift(1,1),e.write_shift((r?1:2)*n.length,n,r?"sbcs":"utf16le"),e))}function Hf(i,o,c){o&&[[5,8],[23,26],[41,44],[50,392]].forEach(function(e){for(var t,r,a,n,s=e[0];s<=e[1];++s)null!=o[s]&&Lf(i,1054,(t=s,r=o[s],n=void 0,a=(a=c)&&5==a.biff,(n=n||Lr(a?3+r.length:5+2*r.length)).write_shift(2,t),n.write_shift(a?1:2,r.length),a||n.write_shift(1,1),n.write_shift((a?1:2)*r.length,r,a?"sbcs":"utf16le"),null==(n=n.length>n.l?n.slice(0,n.l):n).l&&(n.l=n.length),n))})}function zf(e,t){for(var r=0;r<t["!links"].length;++r){var a=t["!links"][r];Lf(e,440,bs(a)),a[1].Tooltip&&Lf(e,2048,function(e){var t=e[1].Tooltip,r=Lr(10+2*(t.length+1));r.write_shift(2,2048),e=Yr(e[0]),r.write_shift(2,e.r),r.write_shift(2,e.r),r.write_shift(2,e.c),r.write_shift(2,e.c);for(var a=0;a<t.length;++a)r.write_shift(2,t.charCodeAt(a));return r.write_shift(2,0),r}(a))}delete t["!links"]}function Vf(a,e){var n;e&&(n=0,e.forEach(function(e,t){var r;++n<=256&&e&&Lf(a,125,(r=Zc(t,e),e=t,(t=Lr(12)).write_shift(2,e),t.write_shift(2,e),t.write_shift(2,256*r.width),t.write_shift(2,0),e=0,r.hidden&&(e|=1),t.write_shift(1,e),e=r.level||0,t.write_shift(1,e),t.write_shift(2,0),t))}))}function Gf(e,t,r,a,n){var s,i,o,c,l,f,h,u,d,p,m,g=16+el(n.cellXfs,t,n);if(null!=t.v||t.bf)if(t.bf)Lf(e,6,Mc(t,r,a,0,g));else switch(t.t){case"d":case"n":var b="d"==t.t?De(He(t.v)):t.v;Lf(e,515,(f=r,h=a,u=b,d=g,p=Lr(14),Xn(f,h,d,p),Aa(u,p),p));break;case"b":case"e":Lf(e,517,(b=r,f=a,h=t.v,d=g,u=t.t,p=Lr(8),Xn(b,f,d,p),Pn(h,u,p),p));break;case"s":case"str":n.bookSST?(m=qc(n.Strings,t.v,n.revStrings),Lf(e,253,(s=r,i=a,o=m,c=g,l=Lr(10),Xn(s,i,c,l),l.write_shift(4,o),l))):Lf(e,516,(m=r,s=a,i=(t.v||"").slice(0,255),c=g,o=Lr(+(l=!(o=n)||8==o.biff)+8+(1+l)*i.length),Xn(m,s,c,o),o.write_shift(2,i.length),l&&o.write_shift(1,1),o.write_shift((1+l)*i.length,i,l?"utf16le":"sbcs"),o));break;default:Lf(e,513,Xn(r,a,g))}else Lf(e,513,Xn(r,a,g))}function jf(e,t,r){var a,n,s=Ur(),i=r.SheetNames[e],o=r.Sheets[i]||{},c=(r||{}).Workbook||{},l=(c.Sheets||[])[e]||{},f=Array.isArray(o),h=8==t.biff,u=[],d=Zr(o["!ref"]||"A1"),p=h?65536:16384;if(255<d.e.c||d.e.r>=p){if(t.WTF)throw new Error("Range "+(o["!ref"]||"A1")+" exceeds format limit A1:IV16384");d.e.c=Math.min(d.e.c,255),d.e.r=Math.min(d.e.c,p-1)}Lf(s,2057,as(0,16,t)),Lf(s,13,Fn(1)),Lf(s,12,Fn(100)),Lf(s,15,In(!0)),Lf(s,17,In(!1)),Lf(s,16,Aa(.001)),Lf(s,95,In(!0)),Lf(s,42,In(!1)),Lf(s,43,In(!1)),Lf(s,130,Fn(1)),Lf(s,128,(r=[0,0],(e=Lr(8)).write_shift(4,0),e.write_shift(2,r[0]?r[0]+1:0),e.write_shift(2,r[1]?r[1]+1:0),e)),Lf(s,131,In(!1)),Lf(s,132,In(!1)),h&&Vf(s,o["!cols"]),Lf(s,512,(p=d,(r=Lr(2*(e=8!=(r=t).biff&&r.biff?2:4)+6)).write_shift(e,p.s.r),r.write_shift(e,p.e.r+1),r.write_shift(2,p.s.c),r.write_shift(2,p.e.c+1),r.write_shift(2,0),r)),h&&(o["!links"]=[]);for(var m=d.s.r;m<=d.e.r;++m){n=jr(m);for(var g=d.s.c;g<=d.e.c;++g){m===d.s.r&&(u[g]=Xr(g)),a=u[g]+n;var b=f?(o[m]||[])[g]:o[a];b&&(Gf(s,b,m,g,t),h&&b.l&&o["!links"].push([a,b.l]))}}var v,w,i=l.CodeName||l.name||i;return h&&Lf(s,574,(c=(c.Views||[])[0],w=Lr(18),v=1718,c&&c.RTL&&(v|=64),w.write_shift(2,v),w.write_shift(4,0),w.write_shift(4,64),w.write_shift(4,0),w.write_shift(4,0),w)),h&&(o["!merges"]||[]).length&&Lf(s,229,function(e){var t=Lr(2+8*e.length);t.write_shift(2,e.length);for(var r=0;r<e.length;++r)Jn(e[r],t);return t}(o["!merges"])),h&&zf(s,o),Lf(s,442,Wn(i)),h&&(v=s,w=o,(i=Lr(19)).write_shift(4,2151),i.write_shift(4,0),i.write_shift(4,0),i.write_shift(2,3),i.write_shift(1,1),i.write_shift(4,0),Lf(v,2151,i),(i=Lr(39)).write_shift(4,2152),i.write_shift(4,0),i.write_shift(4,0),i.write_shift(2,3),i.write_shift(1,0),i.write_shift(4,0),i.write_shift(2,1),i.write_shift(4,4),i.write_shift(2,0),Jn(Zr(w["!ref"]||"A1"),i),i.write_shift(4,4),Lf(v,2152,i)),Lf(s,10),s.end()}function $f(e,t,r){var a=Ur(),n=(e||{}).Workbook||{},s=n.Sheets||[],i=n.WBProps||{},o=8==r.biff,n=5==r.biff;Lf(a,2057,as(0,5,r)),"xla"==r.bookType&&Lf(a,135),Lf(a,225,o?Fn(1200):null),Lf(a,193,function(e,t){t=t||Lr(e);for(var r=0;r<e;++r)t.write_shift(1,0);return t}(2)),n&&Lf(a,191),n&&Lf(a,192),Lf(a,226),Lf(a,92,function(e){var t=!e||8==e.biff,r=Lr(t?112:54);for(r.write_shift(8==e.biff?2:1,7),t&&r.write_shift(1,0),r.write_shift(4,859007059),r.write_shift(4,5458548|(t?0:536870912));r.l<r.length;)r.write_shift(1,t?0:32);return r}(r)),Lf(a,66,Fn(o?1200:1252)),o&&Lf(a,353,Fn(0)),o&&Lf(a,448),Lf(a,317,function(e){for(var t=Lr(2*e),r=0;r<e;++r)t.write_shift(2,r+1);return t}(e.SheetNames.length)),o&&e.vbaraw&&Lf(a,211),o&&e.vbaraw&&Lf(a,442,Wn(i.CodeName||"ThisWorkbook")),Lf(a,156,Fn(17)),Lf(a,25,In(!1)),Lf(a,18,In(!1)),Lf(a,19,Fn(0)),o&&Lf(a,431,In(!1)),o&&Lf(a,444,Fn(0)),Lf(a,61,((n=Lr(18)).write_shift(2,0),n.write_shift(2,0),n.write_shift(2,29280),n.write_shift(2,17600),n.write_shift(2,56),n.write_shift(2,0),n.write_shift(2,0),n.write_shift(2,1),n.write_shift(2,500),n)),Lf(a,64,In(!1)),Lf(a,141,Fn(0)),Lf(a,34,In("true"==((i=e).Workbook&&i.Workbook.WBProps&&Rt(i.Workbook.WBProps.date1904)?"true":"false"))),Lf(a,14,In(!0)),o&&Lf(a,439,In(!1)),Lf(a,218,Fn(0)),Wf(a,0,r),Hf(a,e.SSF,r),function(t,r){for(var e=0;e<16;++e)Lf(t,224,cs({numFmtId:0,style:!0},0,r));r.cellXfs.forEach(function(e){Lf(t,224,cs(e,0,r))})}(a,r),o&&Lf(a,352,In(!1));n=a.end(),i=Ur();o&&Lf(i,140,((g=g||Lr(4)).write_shift(2,1),g.write_shift(2,1),g)),o&&r.Strings&&function(e,t,r){var a=void 0||(r||[]).length||0;if(a<=8224)return Lf(e,t,r,a);if(!isNaN(t)){for(var n=r.parts||[],s=0,i=0,o=0;o+(n[s]||8224)<=8224;)o+=n[s]||8224,s++;var c=e.next(4);for(c.write_shift(2,t),c.write_shift(2,o),e.push(r.slice(i,i+o)),i+=o;i<a;){for((c=e.next(4)).write_shift(2,60),o=0;o+(n[s]||8224)<=8224;)o+=n[s]||8224,s++;c.write_shift(2,o),e.push(r.slice(i,i+o)),i+=o}}}(i,252,ns(r.Strings)),Lf(i,10);for(var a=i.end(),c=Ur(),l=0,f=0,f=0;f<e.SheetNames.length;++f)l+=(o?12:11)+(o?2:1)*e.SheetNames[f].length;var h,u,d,p,m=n.length+l+a.length;for(f=0;f<e.SheetNames.length;++f)Lf(c,133,(h={pos:m,hs:(s[f]||{}).Hidden||0,dt:0,name:e.SheetNames[f]},p=d=void 0,d=!(u=r)||8<=u.biff?2:1,(p=Lr(8+d*h.name.length)).write_shift(4,h.pos),p.write_shift(1,h.hs||0),p.write_shift(1,h.dt),p.write_shift(1,h.name.length),8<=u.biff&&p.write_shift(1,1),p.write_shift(d*h.name.length,h.name,u.biff<8?"sbcs":"utf16le"),(u=p.slice(0,p.l)).l=p.l,u)),m+=t[f].length;var g=c.end();if(l!=g.length)throw new Error("BS8 "+l+" != "+g.length);i=[];return n.length&&i.push(n),g.length&&i.push(g),a.length&&i.push(a),ue(i)}function Xf(e,t){for(var r=0;r<=e.SheetNames.length;++r){var a=e.Sheets[e.SheetNames[r]];a&&a["!ref"]&&255<Jr(a["!ref"]).e.c&&"undefined"!=typeof console&&console.error&&console.error("Worksheet '"+e.SheetNames[r]+"' extends beyond column IV (255).  Data may be lost.")}var n=t||{};switch(n.biff||2){case 8:case 5:return function(e,t){var r=t||{},a=[];e&&!e.SSF&&(e.SSF=Ve(me)),e&&e.SSF&&(Ee(),Te(e.SSF),r.revssf=Ne(e.SSF),r.revssf[e.SSF[65535]]=0,r.ssf=e.SSF),r.Strings=[],r.Strings.Count=0,r.Strings.Unique=0,Uh(r),r.cellXfs=[],el(r.cellXfs,{},{revssf:{General:0}}),e.Props||(e.Props={});for(var n=0;n<e.SheetNames.length;++n)a[a.length]=jf(n,r,e);return a.unshift($f(e,a,r)),ue(a)}(e,t);case 4:case 3:case 2:return Bf(e,t)}throw new Error("invalid type "+n.bookType+" for BIFF")}function Yf(e,t){var r=t||{};null!=oe&&null==r.dense&&(r.dense=oe);var a=r.dense?[]:{},n=(e=e.replace(/<!--.*?-->/g,"")).match(/<table/i);if(!n)throw new Error("Invalid HTML: could not find <table>");for(var s,t=e.match(/<\/table/i),i=n.index,o=t&&t.index||e.length,c=Ke(e.slice(i,o),/(:?<tr[^>]*>)/i,"<tr>"),l=-1,f=0,h={s:{r:1e7,c:1e7},e:{r:0,c:0}},u=[],i=0;i<c.length;++i){var d=c[i].trim(),p=d.slice(0,3).toLowerCase();if("<tr"!=p){if("<td"==p||"<th"==p)for(var m=d.split(/<\/t[dh]>/i),o=0;o<m.length;++o){var g=m[o].trim();if(g.match(/<t[dh]/i)){for(var b=g,v=0;"<"==b.charAt(0)&&-1<(v=b.indexOf(">"));)b=b.slice(v+1);for(var w=0;w<u.length;++w){var T=u[w];T.s.c==f&&T.s.r<l&&l<=T.e.r&&(f=T.e.c+1,w=-1)}var E=dt(g.slice(0,g.indexOf(">"))),k=E.colspan?+E.colspan:1;(1<(s=+E.rowspan)||1<k)&&u.push({s:{r:l,c:f},e:{r:l+(s||1)-1,c:f+k-1}});g=E.t||E["data-t"]||"";b.length&&(b=Wt(b),h.s.r>l&&(h.s.r=l),h.e.r<l&&(h.e.r=l),h.s.c>f&&(h.s.c=f),h.e.c<f&&(h.e.c=f),b.length&&(E={t:"s",v:b},r.raw||!b.trim().length||"s"==g||("TRUE"===b?E={t:"b",v:!0}:"FALSE"===b?E={t:"b",v:!1}:isNaN(je(b))?isNaN(Xe(b).getDate())||(E={t:"d",v:He(b)},(E=!r.cellDates?{t:"n",v:De(E.v)}:E).z=r.dateNF||me[14]):E={t:"n",v:je(b)}),r.dense?(a[l]||(a[l]=[]),a[l][f]=E):a[Kr({r:l,c:f})]=E)),f+=k}}}else{if(++l,r.sheetRows&&r.sheetRows<=l){--l;break}f=0}}return a["!ref"]=qr(h),u.length&&(a["!merges"]=u),a}function Kf(e,t,r,a){for(var n=e["!merges"]||[],s=[],i=t.s.c;i<=t.e.c;++i){for(var o,c,l,f,h=0,u=0,d=0;d<n.length;++d)if(!(n[d].s.r>r||n[d].s.c>i||n[d].e.r<r||n[d].e.c<i)){if(n[d].s.r<r||n[d].s.c<i){h=-1;break}h=n[d].e.r-n[d].s.r+1,u=n[d].e.c-n[d].s.c+1;break}h<0||(o=Kr({r:r,c:i}),l=(c=a.dense?(e[r]||[])[i]:e[o])&&null!=c.v&&(c.h||_t(c.w||(ea(c),c.w)||""))||"",f={},1<h&&(f.rowspan=h),1<u&&(f.colspan=u),a.editable?l='<span contenteditable="true">'+l+"</span>":c&&(f["data-t"]=c&&c.t||"z",null!=c.v&&(f["data-v"]=c.v),null!=c.z&&(f["data-z"]=c.z),c.l&&"#"!=(c.l.Target||"#").charAt(0)&&(l='<a href="'+c.l.Target+'">'+l+"</a>")),f.id=(a.id||"sjs")+"-"+o,s.push(Yt("td",l,f)))}return"<tr>"+s.join("")+"</tr>"}var Jf='<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>',qf="</body></html>";function Zf(e,t,r){return[].join("")+"<table"+(r&&r.id?' id="'+r.id+'"':"")+">"}function Qf(e,t){var r=t||{},a=null!=r.header?r.header:Jf,t=null!=r.footer?r.footer:qf,n=[a],s=Jr(e["!ref"]);r.dense=Array.isArray(e),n.push(Zf(0,0,r));for(var i=s.s.r;i<=s.e.r;++i)n.push(Kf(e,s,i,r));return n.push("</table>"+t),n.join("")}function eh(e,t,r){var a=r||{};null!=oe&&(a.dense=oe);var n=0,s=0;null!=a.origin&&("number"==typeof a.origin?n=a.origin:(n=(r="string"==typeof a.origin?Yr(a.origin):a.origin).r,s=r.c));var i=t.getElementsByTagName("tr"),o=Math.min(a.sheetRows||1e7,i.length),c={s:{r:0,c:0},e:{r:n,c:s}};e["!ref"]&&(t=Jr(e["!ref"]),c.s.r=Math.min(c.s.r,t.s.r),c.s.c=Math.min(c.s.c,t.s.c),c.e.r=Math.max(c.e.r,t.e.r),c.e.c=Math.max(c.e.c,t.e.c),-1==n&&(c.e.r=n=t.e.r+1));var l,f,h=[],u=0,d=e["!rows"]||(e["!rows"]=[]),p=0,m=0,g=0,b=0;for(e["!cols"]||(e["!cols"]=[]);p<i.length&&m<o;++p){var v=i[p];if(rh(v)){if(a.display)continue;d[m]={hidden:!0}}for(var w=v.children,g=b=0;g<w.length;++g){var T=w[g];if(!a.display||!rh(T)){for(var E=T.hasAttribute("data-v")?T.getAttribute("data-v"):T.hasAttribute("v")?T.getAttribute("v"):Wt(T.innerHTML),k=T.getAttribute("data-z")||T.getAttribute("z"),u=0;u<h.length;++u){var y=h[u];y.s.c==b+s&&y.s.r<m+n&&m+n<=y.e.r&&(b=y.e.c+1-s,u=-1)}f=+T.getAttribute("colspan")||1,(1<(l=+T.getAttribute("rowspan")||1)||1<f)&&h.push({s:{r:m+n,c:b+s},e:{r:m+n+(l||1)-1,c:b+s+(f||1)-1}});var S={t:"s",v:E},_=T.getAttribute("data-t")||T.getAttribute("t")||"";null!=E&&(0==E.length?S.t=_||"z":a.raw||0==E.trim().length||"s"==_||("TRUE"===E?S={t:"b",v:!0}:"FALSE"===E?S={t:"b",v:!1}:isNaN(je(E))?isNaN(Xe(E).getDate())||(S={t:"d",v:He(E)},(S=!a.cellDates?{t:"n",v:De(S.v)}:S).z=a.dateNF||me[14]):S={t:"n",v:je(E)})),void 0===S.z&&null!=k&&(S.z=k);var x="",A=T.getElementsByTagName("A");if(A&&A.length)for(var C=0;C<A.length&&(!A[C].hasAttribute("href")||"#"==(x=A[C].getAttribute("href")).charAt(0));++C);x&&"#"!=x.charAt(0)&&(S.l={Target:x}),a.dense?(e[m+n]||(e[m+n]=[]),e[m+n][b+s]=S):e[Kr({c:b+s,r:m+n})]=S,c.e.c<b+s&&(c.e.c=b+s),b+=f}}++m}return h.length&&(e["!merges"]=(e["!merges"]||[]).concat(h)),c.e.r=Math.max(c.e.r,m-1+n),e["!ref"]=qr(c),o<=m&&(e["!fullref"]=qr((c.e.r=i.length-p+m-1+n,c))),e}function th(e,t){return eh((t||{}).dense?[]:{},e,t)}function rh(e){var t,r="",t=(t=e).ownerDocument.defaultView&&"function"==typeof t.ownerDocument.defaultView.getComputedStyle?t.ownerDocument.defaultView.getComputedStyle:"function"==typeof getComputedStyle?getComputedStyle:null;return"none"===(r=(r=t?t(e).getPropertyValue("display"):r)||e.style&&e.style.display)}var ah={day:["d","dd"],month:["m","mm"],year:["y","yy"],hours:["h","hh"],minutes:["m","mm"],seconds:["s","ss"],"am-pm":["A/P","AM/PM"],"day-of-week":["ddd","dddd"],era:["e","ee"],quarter:["\\Qm",'m\\"th quarter"']};function nh(e,t){var r=t||{};null!=oe&&null==r.dense&&(r.dense=oe);var a,n,s,i,o,c=Jt(e),l=[],f={name:""},h="",u=0,d={},p=[],m=r.dense?[]:{},g={value:""},b="",v=0,w=[],T=-1,E=-1,k={s:{r:1e6,c:1e7},e:{r:0,c:0}},y=0,S={},_=[],x={},A=[],C=1,R=1,O=[],I={Names:[]},N={},F=["",""],D=[],P={},L="",M=0,U=!1,B=!1,W=0;for(qt.lastIndex=0,c=c.replace(/<!--([\s\S]*?)-->/gm,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");i=qt.exec(c);)switch(i[3]=i[3].replace(/_.*$/,"")){case"table":case"工作表":"/"===i[1]?(k.e.c>=k.s.c&&k.e.r>=k.s.r?m["!ref"]=qr(k):m["!ref"]="A1:A1",0<r.sheetRows&&r.sheetRows<=k.e.r&&(m["!fullref"]=m["!ref"],k.e.r=r.sheetRows-1,m["!ref"]=qr(k)),_.length&&(m["!merges"]=_),A.length&&(m["!rows"]=A),s.name=s["名称"]||s.name,"undefined"!=typeof JSON&&JSON.stringify(s),p.push(s.name),d[s.name]=m,B=!1):"/"!==i[0].charAt(i[0].length-2)&&(s=dt(i[0],!1),T=E=-1,k.s.r=k.s.c=1e7,k.e.r=k.e.c=0,m=r.dense?[]:{},_=[],A=[],B=!0);break;case"table-row-group":"/"===i[1]?--y:++y;break;case"table-row":case"行":if("/"===i[1]){T+=C,C=1;break}if((H=dt(i[0],!1))["行号"]?T=H["行号"]-1:-1==T&&(T=0),(C=+H["number-rows-repeated"]||1)<10)for(W=0;W<C;++W)0<y&&(A[T+W]={level:y});E=-1;break;case"covered-table-cell":"/"!==i[1]&&++E,r.sheetStubs&&(r.dense?(m[T]||(m[T]=[]),m[T][E]={t:"z"}):m[Kr({r:T,c:E})]={t:"z"}),b="",w=[];break;case"table-cell":case"数据":if("/"===i[0].charAt(i[0].length-2))++E,g=dt(i[0],!1),R=parseInt(g["number-columns-repeated"]||"1",10),o={t:"z",v:null},g.formula&&0!=r.cellFormula&&(o.f=$c(wt(g.formula))),"string"==(g["数据类型"]||g["value-type"])&&(o.t="s",o.v=wt(g["string-value"]||""),r.dense?(m[T]||(m[T]=[]),m[T][E]=o):m[Kr({r:T,c:E})]=o),E+=R-1;else if("/"!==i[1]){b="",v=0,w=[],R=1;var H=C?T+C-1:T;if(++E>k.e.c&&(k.e.c=E),E<k.s.c&&(k.s.c=E),T<k.s.r&&(k.s.r=T),H>k.e.r&&(k.e.r=H),D=[],P={},o={t:(g=dt(i[0],!1))["数据类型"]||g["value-type"],v:null},r.cellFormula)if(g.formula&&(g.formula=wt(g.formula)),g["number-matrix-columns-spanned"]&&g["number-matrix-rows-spanned"]&&(x={s:{r:T,c:E},e:{r:T+(parseInt(g["number-matrix-rows-spanned"],10)||0)-1,c:E+(parseInt(g["number-matrix-columns-spanned"],10)||0)-1}},o.F=qr(x),O.push([x,o.F])),g.formula)o.f=$c(g.formula);else for(W=0;W<O.length;++W)T>=O[W][0].s.r&&T<=O[W][0].e.r&&E>=O[W][0].s.c&&E<=O[W][0].e.c&&(o.F=O[W][1]);switch((g["number-columns-spanned"]||g["number-rows-spanned"])&&(x={s:{r:T,c:E},e:{r:T+(parseInt(g["number-rows-spanned"],10)||0)-1,c:E+(parseInt(g["number-columns-spanned"],10)||0)-1}},_.push(x)),g["number-columns-repeated"]&&(R=parseInt(g["number-columns-repeated"],10)),o.t){case"boolean":o.t="b",o.v=Rt(g["boolean-value"]);break;case"float":case"percentage":case"currency":o.t="n",o.v=parseFloat(g.value);break;case"date":o.t="d",o.v=He(g["date-value"]),r.cellDates||(o.t="n",o.v=De(o.v)),o.z="m/d/yy";break;case"time":o.t="n",o.v=function(e){var t=0,r=0,a=!1,n=e.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);if(!n)throw new Error("|"+e+"| is not an ISO8601 Duration");for(var s=1;s!=n.length;++s)if(n[s]){switch(r=1,3<s&&(a=!0),n[s].slice(n[s].length-1)){case"Y":throw new Error("Unsupported ISO Duration Field: "+n[s].slice(n[s].length-1));case"D":r*=24;case"H":r*=60;case"M":if(!a)throw new Error("Unsupported ISO Duration Field: M");r*=60}t+=r*parseInt(n[s],10)}return t}(g["time-value"])/86400,r.cellDates&&(o.t="d",o.v=Me(o.v)),o.z="HH:MM:SS";break;case"number":o.t="n",o.v=parseFloat(g["数据数值"]);break;default:if("string"!==o.t&&"text"!==o.t&&o.t)throw new Error("Unsupported value type "+o.t);o.t="s",null!=g["string-value"]&&(b=wt(g["string-value"]),w=[])}}else{if(U=!1,"s"===o.t&&(o.v=b||"",w.length&&(o.R=w),U=0==v),N.Target&&(o.l=N),0<D.length&&(o.c=D,D=[]),b&&!1!==r.cellText&&(o.w=b),U&&(o.t="z",delete o.v),(!U||r.sheetStubs)&&!(r.sheetRows&&r.sheetRows<=T))for(var z=0;z<C;++z){if(R=parseInt(g["number-columns-repeated"]||"1",10),r.dense)for(m[T+z]||(m[T+z]=[]),m[T+z][E]=0==z?o:Ve(o);0<--R;)m[T+z][E+R]=Ve(o);else for(m[Kr({r:T+z,c:E})]=o;0<--R;)m[Kr({r:T+z,c:E+R})]=Ve(o);k.e.c<=E&&(k.e.c=E)}E+=(R=parseInt(g["number-columns-repeated"]||"1",10))-1,R=0,o={},b="",w=[]}N={};break;case"document":case"document-content":case"电子表格文档":case"spreadsheet":case"主体":case"scripts":case"styles":case"font-face-decls":case"master-styles":if("/"===i[1]){if((a=l.pop())[0]!==i[3])throw"Bad state: "+a}else"/"!==i[0].charAt(i[0].length-2)&&l.push([i[3],!0]);break;case"annotation":if("/"===i[1]){if((a=l.pop())[0]!==i[3])throw"Bad state: "+a;P.t=b,w.length&&(P.R=w),P.a=L,D.push(P)}else"/"!==i[0].charAt(i[0].length-2)&&l.push([i[3],!1]);b=L="",v=M=0,w=[];break;case"creator":"/"===i[1]?L=c.slice(M,i.index):M=i.index+i[0].length;break;case"meta":case"元数据":case"settings":case"config-item-set":case"config-item-map-indexed":case"config-item-map-entry":case"config-item-map-named":case"shapes":case"frame":case"text-box":case"image":case"data-pilot-tables":case"list-style":case"form":case"dde-links":case"event-listeners":case"chart":if("/"===i[1]){if((a=l.pop())[0]!==i[3])throw"Bad state: "+a}else"/"!==i[0].charAt(i[0].length-2)&&l.push([i[3],!1]);b="",v=0,w=[];break;case"scientific-number":case"currency-symbol":case"currency-style":break;case"number-style":case"percentage-style":case"date-style":case"time-style":if("/"===i[1]){if(S[f.name]=h,(a=l.pop())[0]!==i[3])throw"Bad state: "+a}else"/"!==i[0].charAt(i[0].length-2)&&(h="",f=dt(i[0],!1),l.push([i[3],!0]));break;case"script":case"libraries":case"automatic-styles":break;case"default-style":case"page-layout":case"style":case"map":case"font-face":case"paragraph-properties":case"table-properties":case"table-column-properties":case"table-row-properties":case"table-cell-properties":break;case"number":switch(l[l.length-1][0]){case"time-style":case"date-style":n=dt(i[0],!1),h+=ah[i[3]]["long"===n.style?1:0]}break;case"fraction":break;case"day":case"month":case"year":case"era":case"day-of-week":case"week-of-year":case"quarter":case"hours":case"minutes":case"seconds":case"am-pm":switch(l[l.length-1][0]){case"time-style":case"date-style":n=dt(i[0],!1),h+=ah[i[3]]["long"===n.style?1:0]}break;case"boolean-style":case"boolean":case"text-style":break;case"text":if("/>"===i[0].slice(-2))break;if("/"===i[1])switch(l[l.length-1][0]){case"number-style":case"date-style":case"time-style":h+=c.slice(u,i.index)}else u=i.index+i[0].length;break;case"named-range":F=Xc((n=dt(i[0],!1))["cell-range-address"]);var V={Name:n.name,Ref:F[0]+"!"+F[1]};B&&(V.Sheet=p.length),I.Names.push(V);break;case"text-content":case"text-properties":case"embedded-text":break;case"body":case"电子表格":case"forms":case"table-column":case"table-header-rows":case"table-rows":case"table-column-group":case"table-header-columns":case"table-columns":case"null-date":case"graphic-properties":case"calculation-settings":case"named-expressions":case"label-range":case"label-ranges":case"named-expression":case"sort":case"sort-by":case"sort-groups":case"tab":case"line-break":case"span":break;case"p":case"文本串":if(-1<["master-styles"].indexOf(l[l.length-1][0]))break;"/"!==i[1]||g&&g["string-value"]?(dt(i[0],!1),v=i.index+i[0].length):(V=(V=c.slice(v,i.index)).replace(/[\t\r\n]/g," ").trim().replace(/ +/g," ").replace(/<text:s\/>/g," ").replace(/<text:s text:c="(\d+)"\/>/g,function(e,t){return Array(parseInt(t,10)+1).join(" ")}).replace(/<text:tab[^>]*\/>/g,"\t").replace(/<text:line-break\/>/g,"\n"),V=[wt(V.replace(/<[^>]*>/g,""))],b=(0<b.length?b+"\n":"")+V[0]);break;case"s":break;case"database-range":if("/"===i[1])break;try{d[(F=Xc(dt(i[0])["target-range-address"]))[0]]["!autofilter"]={ref:F[1]}}catch(e){}break;case"date":case"object":break;case"title":case"标题":case"desc":case"binary-data":case"table-source":case"scenario":case"iteration":case"content-validations":case"content-validation":case"help-message":case"error-message":case"database-ranges":case"filter":case"filter-and":case"filter-or":case"filter-condition":case"list-level-style-bullet":case"list-level-style-number":case"list-level-properties":break;case"sender-firstname":case"sender-lastname":case"sender-initials":case"sender-title":case"sender-position":case"sender-email":case"sender-phone-private":case"sender-fax":case"sender-company":case"sender-phone-work":case"sender-street":case"sender-city":case"sender-postal-code":case"sender-country":case"sender-state-or-province":case"author-name":case"author-initials":case"chapter":case"file-name":case"template-name":case"sheet-name":case"event-listener":break;case"initial-creator":case"creation-date":case"print-date":case"generator":case"document-statistic":case"user-defined":case"editing-duration":case"editing-cycles":case"config-item":case"page-number":case"page-count":case"time":case"cell-range-source":case"detective":case"operation":case"highlighted-range":break;case"data-pilot-table":case"source-cell-range":case"source-service":case"data-pilot-field":case"data-pilot-level":case"data-pilot-subtotals":case"data-pilot-subtotal":case"data-pilot-members":case"data-pilot-member":case"data-pilot-display-info":case"data-pilot-sort-info":case"data-pilot-layout-info":case"data-pilot-field-reference":case"data-pilot-groups":case"data-pilot-group":case"data-pilot-group-member":case"rect":break;case"dde-connection-decls":case"dde-connection-decl":case"dde-link":case"dde-source":case"properties":case"property":break;case"a":if("/"!==i[1]){if(!(N=dt(i[0],!1)).href)break;N.Target=wt(N.href),delete N.href,"#"==N.Target.charAt(0)&&-1<N.Target.indexOf(".")?(F=Xc(N.Target.slice(1)),N.Target="#"+F[0]+"!"+F[1]):N.Target.match(/^\.\.[\\\/]/)&&(N.Target=N.Target.slice(3))}break;case"table-protection":case"data-pilot-grand-total":case"office-document-common-attrs":break;default:switch(i[2]){case"dc:":case"calcext:":case"loext:":case"ooo:":case"chartooo:":case"draw:":case"style:":case"chart:":case"form:":case"uof:":case"表:":case"字:":break;default:if(r.WTF)throw new Error(i)}}e={Sheets:d,SheetNames:p,Workbook:I};return r.bookSheets&&delete e.Sheets,e}function sh(e,t){t=t||{},Ze(e,"META-INF/manifest.xml")&&function(e,t){for(var r,a,n=Jt(e);r=qt.exec(n);)switch(r[3]){case"manifest":break;case"file-entry":if("/"==(a=dt(r[0],!1)).path&&a.type!==qa)throw new Error("This OpenDocument is not a spreadsheet");break;case"encryption-data":case"algorithm":case"start-key-generation":case"key-derivation":throw new Error("Unsupported ODS Encryption");default:if(t&&t.WTF)throw r}}(et(e,"META-INF/manifest.xml"),t);var r=tt(e,"content.xml");if(!r)throw new Error("Missing content.xml in ODS / UOF file");t=nh(Mt(r),t);return Ze(e,"meta.xml")&&(t.Props=rn(et(e,"meta.xml"))),t}function ih(e,t){return nh(e,t)}var oh=function(){var e=["<office:master-styles>",'<style:master-page style:name="mp1" style:page-layout-name="mp1">',"<style:header/>",'<style:header-left style:display="false"/>',"<style:footer/>",'<style:footer-left style:display="false"/>',"</style:master-page>","</office:master-styles>"].join(""),t="<office:document-styles "+Xt({"xmlns:office":"urn:oasis:names:tc:opendocument:xmlns:office:1.0","xmlns:table":"urn:oasis:names:tc:opendocument:xmlns:table:1.0","xmlns:style":"urn:oasis:names:tc:opendocument:xmlns:style:1.0","xmlns:text":"urn:oasis:names:tc:opendocument:xmlns:text:1.0","xmlns:draw":"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0","xmlns:fo":"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0","xmlns:xlink":"http://www.w3.org/1999/xlink","xmlns:dc":"http://purl.org/dc/elements/1.1/","xmlns:number":"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0","xmlns:svg":"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0","xmlns:of":"urn:oasis:names:tc:opendocument:xmlns:of:1.2","office:version":"1.2"})+">"+e+"</office:document-styles>";return function(){return ot+t}}(),ch=function(){function i(e,t,r){var a=[];a.push('      <table:table table:name="'+kt(t.SheetNames[r])+'" table:style-name="ta1">\n');var n=0,s=0,i=Jr(e["!ref"]||"A1"),o=e["!merges"]||[],c=0,l=Array.isArray(e);if(e["!cols"])for(s=0;s<=i.e.c;++s)a.push("        <table:table-column"+(e["!cols"][s]?' table:style-name="co'+e["!cols"][s].ods+'"':"")+"></table:table-column>\n");for(var f="",h=e["!rows"]||[],n=0;n<i.s.r;++n)f=h[n]?' table:style-name="ro'+h[n].ods+'"':"",a.push("        <table:table-row"+f+"></table:table-row>\n");for(;n<=i.e.r;++n){for(f=h[n]?' table:style-name="ro'+h[n].ods+'"':"",a.push("        <table:table-row"+f+">\n"),s=0;s<i.s.c;++s)a.push(v);for(;s<=i.e.c;++s){for(var u=!1,d={},p="",c=0;c!=o.length;++c)if(!(o[c].s.c>s||o[c].s.r>n||o[c].e.c<s||o[c].e.r<n)){o[c].s.c==s&&o[c].s.r==n||(u=!0),d["table:number-columns-spanned"]=o[c].e.c-o[c].s.c+1,d["table:number-rows-spanned"]=o[c].e.r-o[c].s.r+1;break}if(u)a.push("          <table:covered-table-cell/>\n");else{var m=Kr({r:n,c:s}),g=l?(e[n]||[])[s]:e[m];if(g&&g.f&&(d["table:formula"]=kt(("of:="+g.f.replace(lc,"$1[.$2$3$4$5]").replace(/\]:\[/g,":")).replace(/;/g,"|").replace(/,/g,";")),g.F&&g.F.slice(0,m.length)==m&&(b=Jr(g.F),d["table:number-matrix-columns-spanned"]=b.e.c-b.s.c+1,d["table:number-matrix-rows-spanned"]=b.e.r-b.s.r+1)),g){switch(g.t){case"b":p=g.v?"TRUE":"FALSE",d["office:value-type"]="boolean",d["office:boolean-value"]=g.v?"true":"false";break;case"n":p=g.w||String(g.v||0),d["office:value-type"]="float",d["office:value"]=g.v||0;break;case"s":case"str":p=null==g.v?"":g.v,d["office:value-type"]="string";break;case"d":p=g.w||He(g.v).toISOString(),d["office:value-type"]="date",d["office:date-value"]=He(g.v).toISOString(),d["table:style-name"]="ce1";break;default:a.push(v);continue}var b,m=kt(p).replace(/  +/g,function(e){return'<text:s text:c="'+e.length+'"/>'}).replace(/\t/g,"<text:tab/>").replace(/\n/g,"</text:p><text:p>").replace(/^ /,"<text:s/>").replace(/ $/,"<text:s/>");g.l&&g.l.Target&&(m=Yt("text:a",m,{"xlink:href":(b="#"!=(b="#"==(b=g.l.Target).charAt(0)?"#"+b.slice(1).replace(/\./,"!"):b).charAt(0)&&!b.match(/^\w+:/)?"../"+b:b).replace(/&/g,"&amp;")})),a.push("          "+Yt("table:table-cell",Yt("text:p",m,{}),d)+"\n")}else a.push(v)}}a.push("        </table:table-row>\n")}return a.push("      </table:table>\n"),a.join("")}var v="          <table:table-cell />\n";return function(e,t){var r=[ot],a=Xt({"xmlns:office":"urn:oasis:names:tc:opendocument:xmlns:office:1.0","xmlns:table":"urn:oasis:names:tc:opendocument:xmlns:table:1.0","xmlns:style":"urn:oasis:names:tc:opendocument:xmlns:style:1.0","xmlns:text":"urn:oasis:names:tc:opendocument:xmlns:text:1.0","xmlns:draw":"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0","xmlns:fo":"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0","xmlns:xlink":"http://www.w3.org/1999/xlink","xmlns:dc":"http://purl.org/dc/elements/1.1/","xmlns:meta":"urn:oasis:names:tc:opendocument:xmlns:meta:1.0","xmlns:number":"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0","xmlns:presentation":"urn:oasis:names:tc:opendocument:xmlns:presentation:1.0","xmlns:svg":"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0","xmlns:chart":"urn:oasis:names:tc:opendocument:xmlns:chart:1.0","xmlns:dr3d":"urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0","xmlns:math":"http://www.w3.org/1998/Math/MathML","xmlns:form":"urn:oasis:names:tc:opendocument:xmlns:form:1.0","xmlns:script":"urn:oasis:names:tc:opendocument:xmlns:script:1.0","xmlns:ooo":"http://openoffice.org/2004/office","xmlns:ooow":"http://openoffice.org/2004/writer","xmlns:oooc":"http://openoffice.org/2004/calc","xmlns:dom":"http://www.w3.org/2001/xml-events","xmlns:xforms":"http://www.w3.org/2002/xforms","xmlns:xsd":"http://www.w3.org/2001/XMLSchema","xmlns:xsi":"http://www.w3.org/2001/XMLSchema-instance","xmlns:sheet":"urn:oasis:names:tc:opendocument:sh33tjs:1.0","xmlns:rpt":"http://openoffice.org/2005/report","xmlns:of":"urn:oasis:names:tc:opendocument:xmlns:of:1.2","xmlns:xhtml":"http://www.w3.org/1999/xhtml","xmlns:grddl":"http://www.w3.org/2003/g/data-view#","xmlns:tableooo":"http://openoffice.org/2009/table","xmlns:drawooo":"http://openoffice.org/2010/draw","xmlns:calcext":"urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0","xmlns:loext":"urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0","xmlns:field":"urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0","xmlns:formx":"urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0","xmlns:css3t":"http://www.w3.org/TR/css3-text/","office:version":"1.2"}),n=Xt({"xmlns:config":"urn:oasis:names:tc:opendocument:xmlns:config:1.0","office:mimetype":"application/vnd.oasis.opendocument.spreadsheet"});"fods"==t.bookType?(r.push("<office:document"+a+n+">\n"),r.push(Qa().replace(/office:document-meta/g,"office:meta"))):r.push("<office:document-content"+a+">\n"),function(a,t){a.push(" <office:automatic-styles>\n"),a.push('  <number:date-style style:name="N37" number:automatic-order="true">\n'),a.push('   <number:month number:style="long"/>\n'),a.push("   <number:text>/</number:text>\n"),a.push('   <number:day number:style="long"/>\n'),a.push("   <number:text>/</number:text>\n"),a.push("   <number:year/>\n"),a.push("  </number:date-style>\n");var n=0;t.SheetNames.map(function(e){return t.Sheets[e]}).forEach(function(e){if(e&&e["!cols"])for(var t=0;t<e["!cols"].length;++t)if(e["!cols"][t]){var r=e["!cols"][t];if(null==r.width&&null==r.wpx&&null==r.wch)continue;fo(r),r.ods=n;r=e["!cols"][t].wpx+"px";a.push('  <style:style style:name="co'+n+'" style:family="table-column">\n'),a.push('   <style:table-column-properties fo:break-before="auto" style:column-width="'+r+'"/>\n'),a.push("  </style:style>\n"),++n}});var s=0;t.SheetNames.map(function(e){return t.Sheets[e]}).forEach(function(e){if(e&&e["!rows"])for(var t,r=0;r<e["!rows"].length;++r)e["!rows"][r]&&(e["!rows"][r].ods=s,t=e["!rows"][r].hpx+"px",a.push('  <style:style style:name="ro'+s+'" style:family="table-row">\n'),a.push('   <style:table-row-properties fo:break-before="auto" style:row-height="'+t+'"/>\n'),a.push("  </style:style>\n"),++s)}),a.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n'),a.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n'),a.push("  </style:style>\n"),a.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n'),a.push(" </office:automatic-styles>\n")}(r,e),r.push("  <office:body>\n"),r.push("    <office:spreadsheet>\n");for(var s=0;s!=e.SheetNames.length;++s)r.push(i(e.Sheets[e.SheetNames[s]],e,s));return r.push("    </office:spreadsheet>\n"),r.push("  </office:body>\n"),"fods"==t.bookType?r.push("</office:document>"):r.push("</office:document-content>"),r.join("")}}();function lh(e,t){if("fods"==t.bookType)return ch(e,t);var r=nt(),a=[],n=[];return at(r,"mimetype","application/vnd.oasis.opendocument.spreadsheet"),at(r,"content.xml",ch(e,t)),a.push(["content.xml","text/xml"]),n.push(["content.xml","ContentFile"]),at(r,"styles.xml",oh(e,t)),a.push(["styles.xml","text/xml"]),n.push(["styles.xml","StylesFile"]),at(r,"meta.xml",ot+Qa()),a.push(["meta.xml","text/xml"]),n.push(["meta.xml","MetadataFile"]),at(r,"manifest.rdf",function(e){var t=[ot];t.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');for(var r=0;r!=e.length;++r)t.push(Za(e[r][0],e[r][1])),t.push(['  <rdf:Description rdf:about="">\n','    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="'+e[r][0]+'"/>\n',"  </rdf:Description>\n"].join(""));return t.push(Za("","Document","pkg")),t.push("</rdf:RDF>"),t.join("")}(n)),a.push(["manifest.rdf","application/rdf+xml"]),at(r,"META-INF/manifest.xml",function(e){var t=[ot];t.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n'),t.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');for(var r=0;r<e.length;++r)t.push('  <manifest:file-entry manifest:full-path="'+e[r][0]+'" manifest:media-type="'+e[r][1]+'"/>\n');return t.push("</manifest:manifest>"),t.join("")}(a)),r}function fh(e){return new DataView(e.buffer,e.byteOffset,e.byteLength)}function hh(e){return"undefined"!=typeof TextDecoder?(new TextDecoder).decode(e):Mt(i(e))}function uh(e){return"undefined"!=typeof TextEncoder?(new TextEncoder).encode(e):he(Ut(e))}function dh(e){var t=e.reduce(function(e,t){return e+t.length},0),r=new Uint8Array(t),a=0;return e.forEach(function(e){r.set(e,a),a+=e.length}),r}function ph(e){return 16843009*((e=(858993459&(e-=e>>1&1431655765))+(e>>2&858993459))+(e>>4)&252645135)>>>24}function mh(e,t){var r=t?t[0]:0,a=127&e[r];return 128<=e[r++]&&(a|=(127&e[r])<<7,e[r++]<128||(a|=(127&e[r])<<14,e[r++]<128||(a|=(127&e[r])<<21,e[r++]<128||(a+=(127&e[r])*Math.pow(2,28),++r,e[r++]<128||(a+=(127&e[r])*Math.pow(2,35),++r,e[r++]<128||(a+=(127&e[r])*Math.pow(2,42),++r,e[r++])))))),t&&(t[0]=r),a}function gh(e){var t=new Uint8Array(7);t[0]=127&e;var r=1;return 127<e&&(t[r-1]|=128,t[r]=e>>7&127,++r,e<=16383||(t[r-1]|=128,t[r]=e>>14&127,++r,e<=2097151||(t[r-1]|=128,t[r]=e>>21&127,++r,e<=268435455||(t[r-1]|=128,t[r]=e/256>>>21&127,++r,e<=34359738367||(t[r-1]|=128,t[r]=e/65536>>>21&127,++r,e<=4398046511103||(t[r-1]|=128,t[r]=e/16777216>>>21&127,++r)))))),t.slice(0,r)}function bh(e){var t=0,r=127&e[0];return 128<=e[t++]&&(r|=(127&e[1])<<7,e[t++]<128||(r|=(127&e[2])<<14,e[t++]<128||(r|=(127&e[3])<<21,e[+t]<128||(r|=(127&e[4])<<28)))),r}function vh(e){for(var t=[],r=[0];r[0]<e.length;){var a,n=r[0],s=mh(e,r),i=7&s,o=0;if(0==(s=Math.floor(s/8)))break;switch(i){case 0:for(var c=r[0];128<=e[r[0]++];);a=e.slice(c,r[0]);break;case 5:o=4,a=e.slice(r[0],r[0]+o),r[0]+=o;break;case 1:o=8,a=e.slice(r[0],r[0]+o),r[0]+=o;break;case 2:o=mh(e,r),a=e.slice(r[0],r[0]+o),r[0]+=o;break;case 3:case 4:default:throw new Error("PB Type ".concat(i," for Field ").concat(s," at offset ").concat(n))}var l={data:a,type:i};null==t[s]?t[s]=[l]:t[s].push(l)}return t}function wh(e){var r=[];return e.forEach(function(e,t){0!=t&&e.forEach(function(e){e.data&&(r.push(gh(8*t+e.type)),2==e.type&&r.push(gh(e.data.length)),r.push(e.data))})}),dh(r)}function Th(e,t){return(null==e?void 0:e.map(function(e){return t(e.data)}))||[]}function Eh(r){for(var e=[],a=[0];a[0]<r.length;){var t=mh(r,a),n=vh(r.slice(a[0],a[0]+t));a[0]+=t;var s={id:bh(n[1][0].data),messages:[]};n[2].forEach(function(e){var t=vh(e.data),e=bh(t[3][0].data);s.messages.push({meta:t,data:r.slice(a[0],a[0]+e)}),a[0]+=e}),null!=(t=n[3])&&t[0]&&(s.merge=0<bh(n[3][0].data)>>>0),e.push(s)}return e}function kh(e){var a=[];return e.forEach(function(e){var t=[[],[{data:gh(e.id),type:0}],[]];null!=e.merge&&(t[3]=[{data:gh(+!!e.merge),type:0}]);var r=[];e.messages.forEach(function(e){r.push(e.data),e.meta[3]=[{type:0,data:gh(e.data.length)}],t[2].push({data:wh(e.meta),type:2})});e=wh(t);a.push(gh(e.length)),a.push(e),r.forEach(function(e){return a.push(e)})}),dh(a)}function yh(e){for(var t=[],r=0;r<e.length;){var a=e[r++],n=e[r]|e[r+1]<<8|e[r+2]<<16;r+=3,t.push(function(e,t){if(0!=e)throw new Error("Unexpected Snappy chunk type ".concat(e));for(var r=[0],a=mh(t,r),n=[];r[0]<t.length;){var s=3&t[r[0]];if(0!=s){var i=0,o=0;if(1==s?(o=4+(t[r[0]]>>2&7),i=(224&t[r[0]++])<<3,i|=t[r[0]++]):(o=1+(t[r[0]++]>>2),2==s?(i=t[r[0]]|t[r[0]+1]<<8,r[0]+=2):(i=(t[r[0]]|t[r[0]+1]<<8|t[r[0]+2]<<16|t[r[0]+3]<<24)>>>0,r[0]+=4)),n=[dh(n)],0==i)throw new Error("Invalid offset 0");if(i>n[0].length)throw new Error("Invalid offset beyond length");if(i<=o)for(n.push(n[0].slice(-i)),o-=i;o>=n[n.length-1].length;)n.push(n[n.length-1]),o-=n[n.length-1].length;n.push(n[0].slice(-i,-i+o))}else{s=t[r[0]++]>>2;s<60?++s:(i=s-59,s=t[r[0]],1<i&&(s|=t[r[0]+1]<<8),2<i&&(s|=t[r[0]+2]<<16),3<i&&(s|=t[r[0]+3]<<24),s>>>=0,s++,r[0]+=i),n.push(t.slice(r[0],r[0]+s)),r[0]+=s}}if((e=dh(n)).length!=a)throw new Error("Unexpected length: ".concat(e.length," != ").concat(a));return e}(a,e.slice(r,r+n))),r+=n}if(r!==e.length)throw new Error("data is not a valid framed stream!");return dh(t)}function Sh(e){for(var t=[],r=0;r<e.length;){var a=Math.min(e.length-r,268435455),n=new Uint8Array(4);t.push(n);var s=gh(a),i=s.length;t.push(s),a<=60?(i++,t.push(new Uint8Array([a-1<<2]))):a<=256?(i+=2,t.push(new Uint8Array([240,a-1&255]))):a<=65536?(i+=3,t.push(new Uint8Array([244,a-1&255,a-1>>8&255]))):a<=16777216?(i+=4,t.push(new Uint8Array([248,a-1&255,a-1>>8&255,a-1>>16&255]))):a<=4294967296&&(i+=5,t.push(new Uint8Array([252,a-1&255,a-1>>8&255,a-1>>16&255,a-1>>>24&255]))),t.push(e.slice(r,r+a)),i+=a,n[0]=0,n[1]=255&i,n[2]=i>>8&255,n[3]=i>>16&255,r+=a}return dh(t)}function _h(e,t,r){var a,n=fh(e),s=n.getUint32(8,!0),i=12,o=-1,c=-1,l=NaN,f=NaN,h=new Date(2001,0,1);switch(1&s&&(l=function(e,t){for(var r=(127&e[t+15])<<7|e[t+14]>>1,a=1&e[t+14],n=t+13;t<=n;--n)a=256*a+e[n];return(128&e[t+15]?-a:a)*Math.pow(10,r-6176)}(e,i),i+=16),2&s&&(f=n.getFloat64(i,!0),i+=8),4&s&&(h.setTime(h.getTime()+1e3*n.getFloat64(i,!0)),i+=8),8&s&&(c=n.getUint32(i,!0),i+=4),16&s&&(o=n.getUint32(i,!0),i+=4),e[1]){case 0:break;case 2:a={t:"n",v:l};break;case 3:a={t:"s",v:t[c]};break;case 5:a={t:"d",v:h};break;case 6:a={t:"b",v:0<f};break;case 7:a={t:"n",v:f/86400};break;case 8:a={t:"e",v:0};break;case 9:if(!(-1<o))throw new Error("Unsupported cell type ".concat(e[1]," : ").concat(31&s," : ").concat(e.slice(0,4)));a={t:"s",v:r[o]};break;case 10:a={t:"n",v:l};break;default:throw new Error("Unsupported cell type ".concat(e[1]," : ").concat(31&s," : ").concat(e.slice(0,4)))}return a}function xh(e,t){var r=new Uint8Array(32),a=fh(r),n=12,s=0;switch(r[0]=5,e.t){case"n":r[1]=2,function(e,t,r){var a=Math.floor(0==r?0:Math.LOG10E*Math.log(Math.abs(r)))+6176-16,n=r/Math.pow(10,a-6176);e[t+15]|=a>>7,e[t+14]|=(127&a)<<1;for(var s=0;1<=n;++s,n/=256)e[t+s]=255&n;e[t+15]|=0<=r?0:128}(r,n,e.v),s|=1,n+=16;break;case"b":r[1]=6,a.setFloat64(n,e.v?1:0,!0),s|=2,n+=8;break;case"s":if(-1==t.indexOf(e.v))throw new Error("Value ".concat(e.v," missing from SST!"));r[1]=3,a.setUint32(n,t.indexOf(e.v),!0),s|=8,n+=4;break;default:throw"unsupported cell type "+e.t}return a.setUint32(8,s,!0),r.slice(0,n)}function Ah(e,t){var r=new Uint8Array(32),a=fh(r),n=12,s=0;switch(r[0]=3,e.t){case"n":r[2]=2,a.setFloat64(n,e.v,!0),s|=32,n+=8;break;case"b":r[2]=6,a.setFloat64(n,e.v?1:0,!0),s|=32,n+=8;break;case"s":if(-1==t.indexOf(e.v))throw new Error("Value ".concat(e.v," missing from SST!"));r[2]=3,a.setUint32(n,t.indexOf(e.v),!0),s|=16,n+=4;break;default:throw"unsupported cell type "+e.t}return a.setUint32(4,s,!0),r.slice(0,n)}function Ch(e,t,r){switch(e[0]){case 0:case 1:case 2:case 3:return function(e,t,r,a){var n,s=fh(e),i=s.getUint32(4,!0),o=(1<a?12:8)+4*ph(i&(1<a?3470:398)),c=-1,l=-1,f=NaN,h=new Date(2001,0,1);switch(512&i&&(c=s.getUint32(o,!0),o+=4),o+=4*ph(i&(1<a?12288:4096)),16&i&&(l=s.getUint32(o,!0),o+=4),32&i&&(f=s.getFloat64(o,!0),o+=8),64&i&&(h.setTime(h.getTime()+1e3*s.getFloat64(o,!0)),o+=8),e[2]){case 0:break;case 2:n={t:"n",v:f};break;case 3:n={t:"s",v:t[l]};break;case 5:n={t:"d",v:h};break;case 6:n={t:"b",v:0<f};break;case 7:n={t:"n",v:f/86400};break;case 8:n={t:"e",v:0};break;case 9:if(-1<c)n={t:"s",v:r[c]};else if(-1<l)n={t:"s",v:t[l]};else{if(isNaN(f))throw new Error("Unsupported cell type ".concat(e.slice(0,4)));n={t:"n",v:f}}break;default:throw new Error("Unsupported cell type ".concat(e.slice(0,4)))}return n}(e,t,r,e[0]);case 5:return _h(e,t,r);default:throw new Error("Unsupported payload version ".concat(e[0]))}}function Rh(e){return mh(vh(e)[1][0].data)}function Oh(s,e){var e=vh(e.data),i=bh(e[1][0].data),e=e[3],o=[];return(e||[]).forEach(function(e){var t=vh(e.data),r=bh(t[1][0].data)>>>0;switch(i){case 1:o[r]=hh(t[3][0].data);break;case 8:var a=vh(s[Rh(t[9][0].data)][0].data),n=s[Rh(a[1][0].data)][0],a=bh(n.meta[1][0].data);if(2001!=a)throw new Error("2000 unexpected reference to ".concat(a));n=vh(n.data);o[r]=n[3].map(function(e){return hh(e.data)}).join("")}}),o}function Ih(e,t){var r=vh(t.data),a=null!=(t=null==r?void 0:r[7])&&t[0]?0<bh(r[7][0].data)>>>0?1:0:-1,t=Th(r[5],function(e){return function(e,t){var r,a,n,s=vh(e),i=bh(s[1][0].data)>>>0,o=bh(s[2][0].data)>>>0,c=(null==(e=null==(c=s[8])?void 0:c[0])?void 0:e.data)&&0<bh(s[8][0].data)||!1;if(null!=(e=null==(e=s[7])?void 0:e[0])&&e.data&&0!=t)a=null==(r=null==(r=s[7])?void 0:r[0])?void 0:r.data,n=null==(r=null==(r=s[6])?void 0:r[0])?void 0:r.data;else{if(null==(r=null==(r=s[4])?void 0:r[0])||!r.data||1==t)throw"NUMBERS Tile missing ".concat(t," cell storage");a=null==(t=null==(t=s[4])?void 0:t[0])?void 0:t.data,n=null==(s=null==(s=s[3])?void 0:s[0])?void 0:s.data}for(var l=c?4:1,f=fh(a),h=[],u=0;u<a.length/2;++u){var d=f.getUint16(2*u,!0);d<65535&&h.push([u,d])}if(h.length!=o)throw"Expected ".concat(o," cells, found ").concat(h.length);for(var p=[],u=0;u<h.length-1;++u)p[h[u][0]]=n.subarray(h[u][1]*l,h[u+1][1]*l);return 1<=h.length&&(p[h[h.length-1][0]]=n.subarray(h[h.length-1][1]*l)),{R:i,cells:p}}(e,a)});return{nrows:bh(r[4][0].data)>>>0,data:t.reduce(function(r,a){return r[a.R]||(r[a.R]=[]),a.cells.forEach(function(e,t){if(r[a.R][t])throw new Error("Duplicate cell r=".concat(a.R," c=").concat(t));r[a.R][t]=e}),r},[])}}function Nh(e,t){var r={"!ref":"A1"},a=e[Rh(vh(t.data)[2][0].data)],t=bh(a[0].meta[1][0].data);if(6001!=t)throw new Error("6000 unexpected reference to ".concat(t));return function(r,e,a){var t=vh(e.data);if((e={s:{r:0,c:0},e:{r:0,c:0}}).e.r=(bh(t[6][0].data)>>>0)-1,e.e.r<0)throw new Error("Invalid row varint ".concat(t[6][0].data));if(e.e.c=(bh(t[7][0].data)>>>0)-1,e.e.c<0)throw new Error("Invalid col varint ".concat(t[7][0].data));a["!ref"]=qr(e);var e=vh(t[4][0].data),n=Oh(r,r[Rh(e[4][0].data)][0]),s=null!=(t=e[17])&&t[0]?Oh(r,r[Rh(e[17][0].data)][0]):[],t=vh(e[3][0].data),i=0;if(t[1].forEach(function(e){var t=vh(e.data),e=r[Rh(t[2][0].data)][0],t=bh(e.meta[1][0].data);if(6002!=t)throw new Error("6001 unexpected reference to ".concat(t));e=Ih(0,e);e.data.forEach(function(e,r){e.forEach(function(e,t){t=Kr({r:i+r,c:t}),e=Ch(e,n,s);e&&(a[t]=e)})}),i+=e.nrows}),null!=(t=e[13])&&t[0]){t=r[Rh(e[13][0].data)][0],e=bh(t.meta[1][0].data);if(6144!=e)throw new Error("Expected merge type 6144, found ".concat(e));a["!merges"]=null==(t=vh(t.data))?void 0:t[1].map(function(e){var t=vh(e.data),e=fh(vh(t[1][0].data)[1][0].data),t=fh(vh(t[2][0].data)[1][0].data);return{s:{r:e.getUint16(0,!0),c:e.getUint16(2,!0)},e:{r:e.getUint16(0,!0)+t.getUint16(0,!0)-1,c:e.getUint16(2,!0)+t.getUint16(2,!0)-1}}})}}(e,a[0],r),r}function Fh(s,e){var i=du(),t=vh(e.data);if(null!=(e=t[2])&&e[0])throw new Error("Keynote presentations are not supported");if(Th(t[1],Rh).forEach(function(e){s[e].forEach(function(e){var r,t,a,n;2==bh(e.meta[1][0].data)&&(t=s,e=vh((a=e).data),n={name:null!=(a=e[1])&&a[0]?hh(e[1][0].data):"",sheets:[]},Th(e[2],Rh).forEach(function(e){t[e].forEach(function(e){6e3==bh(e.meta[1][0].data)&&n.sheets.push(Nh(t,e))})}),(r=n).sheets.forEach(function(e,t){pu(i,e,0==t?r.name:r.name+"_"+t,!0)}))})}),0==i.SheetNames.length)throw new Error("Empty NUMBERS file");return i}function Dh(e){var a={},n=[];if(e.FullPaths.forEach(function(e){if(e.match(/\.iwpv2/))throw new Error("Unsupported password protection")}),e.FileIndex.forEach(function(t){if(t.name.match(/\.iwa$/)){var e,r;try{e=yh(t.content)}catch(e){return console.log("?? "+t.content.length+" "+(e.message||e))}try{r=Eh(e)}catch(e){return console.log("## "+(e.message||e))}r.forEach(function(e){a[e.id]=e.messages,n.push(e.id)})}}),!n.length)throw new Error("File has no messages");if(null!=(e=null==(e=null==(e=null==(e=null==a?void 0:a[1])?void 0:e[0])?void 0:e.meta)?void 0:e[1])&&e[0].data&&1e4==bh(a[1][0].meta[1][0].data))throw new Error("Pages documents are not supported");var t=(null==(e=null==(e=null==(e=null==(e=null==a?void 0:a[1])?void 0:e[0])?void 0:e.meta)?void 0:e[1])?void 0:e[0].data)&&1==bh(a[1][0].meta[1][0].data)&&a[1][0];if(t||n.forEach(function(e){a[e].forEach(function(e){if(1==bh(e.meta[1][0].data)>>>0){if(t)throw new Error("Document has multiple roots");t=e}})}),!t)throw new Error("Cannot find Document root");return Fh(a,t)}function Ph(e,t){if(!t||!t.numbers)throw new Error("Must pass a `numbers` option -- check the README");var r=e.Sheets[e.SheetNames[0]];1<e.SheetNames.length&&console.error("The Numbers writer currently writes only the first table");var f=Jr(r["!ref"]);f.s.r=f.s.c=0;var a=!1;9<f.e.c&&(a=!0,f.e.c=9),49<f.e.r&&(a=!0,f.e.r=49),a&&console.error("The Numbers writer is currently limited to ".concat(qr(f)));var h=iu(r,{range:f,header:1}),u=["~Sh33tJ5~"];h.forEach(function(e){return e.forEach(function(e){"string"==typeof e&&u.push(e)})});var d={},n=[],p=xe.read(t.numbers,{type:"base64"});p.FileIndex.map(function(e,t){return[e,p.FullPaths[t]]}).forEach(function(e){var t=e[0],r=e[1];2==t.type&&t.name.match(/\.iwa/)&&Eh(yh(t.content)).forEach(function(e){n.push(e.id),d[e.id]={deps:[],location:r,type:bh(e.messages[0].meta[1][0].data)}})}),n.sort(function(e,t){return e-t});var s=n.filter(function(e){return 1<e}).map(function(e){return[e,gh(e)]});p.FileIndex.map(function(e,t){return[e,p.FullPaths[t]]}).forEach(function(e){var t=e[0];e[1];t.name.match(/\.iwa/)&&Eh(yh(t.content)).forEach(function(r){r.messages.forEach(function(e){s.forEach(function(t){r.messages.some(function(e){return 11006!=bh(e.meta[1][0].data)&&function(e,t){e:for(var r=0;r<=e.length-t.length;++r){for(var a=0;a<t.length;++a)if(e[r+a]!=t[a])continue e;return!0}return!1}(e.data,t[1])})&&d[t[0]].deps.push(r.id)})})})});for(var i,o=xe.find(p,d[1].location),c=Eh(yh(o.content)),l=0;l<c.length;++l){var m=c[l];1==m.id&&(i=m)}for(var g=Rh(vh(i.messages[0].data)[1][0].data),c=Eh(yh((o=xe.find(p,d[g].location)).content)),l=0;l<c.length;++l)(m=c[l]).id==g&&(i=m);var b=vh(i.messages[0].data);for(b[1]=[{type:2,data:uh(e.SheetNames[0])}],i.messages[0].data=wh(b),o.content=Sh(kh(c)),o.size=o.content.length,g=Rh(b[2][0].data),c=Eh(yh((o=xe.find(p,d[g].location)).content)),l=0;l<c.length;++l)(m=c[l]).id==g&&(i=m);for(g=Rh(vh(i.messages[0].data)[2][0].data),c=Eh(yh((o=xe.find(p,d[g].location)).content)),l=0;l<c.length;++l)(m=c[l]).id==g&&(i=m);a=vh(i.messages[0].data);a[6][0].data=gh(f.e.r+1),a[7][0].data=gh(f.e.c+1);for(var v=Rh(a[46][0].data),t=xe.find(p,d[v].location),w=Eh(yh(t.content)),T=0;T<w.length&&w[T].id!=v;++T);if(w[T].id!=v)throw"Bad ColumnRowUIDMapArchive";var E=vh(w[T].messages[0].data);E[1]=[],E[2]=[],E[3]=[];for(var k=0;k<=f.e.c;++k)E[1].push({type:2,data:wh([[],[{type:0,data:gh(k+420690)}],[{type:0,data:gh(k+420690)}]])}),E[2].push({type:0,data:gh(k)}),E[3].push({type:0,data:gh(k)});E[4]=[],E[5]=[],E[6]=[];for(var y=0;y<=f.e.r;++y)E[4].push({type:2,data:wh([[],[{type:0,data:gh(y+726270)}],[{type:0,data:gh(y+726270)}]])}),E[5].push({type:0,data:gh(y)}),E[6].push({type:0,data:gh(y)});w[T].messages[0].data=wh(E),t.content=Sh(kh(w)),t.size=t.content.length,delete a[46];e=vh(a[4][0].data);e[7][0].data=gh(f.e.r+1);b=Rh(vh(e[1][0].data)[2][0].data);if((w=Eh(yh((t=xe.find(p,d[b].location)).content)))[0].id!=b)throw"Bad HeaderStorageBucket";for(var S=vh(w[0].messages[0].data),y=0;y<h.length;++y){var _=vh(S[2][0].data);_[1][0].data=gh(y),_[4][0].data=gh(h[y].length),S[2][y]={type:S[2][0].type,data:wh(_)}}w[0].messages[0].data=wh(S),t.content=Sh(kh(w)),t.size=t.content.length;var x,b=Rh(e[2][0].data);if((w=Eh(yh((t=xe.find(p,d[b].location)).content)))[0].id!=b)throw"Bad HeaderStorageBucket";for(S=vh(w[0].messages[0].data),k=0;k<=f.e.c;++k)(_=vh(S[2][0].data))[1][0].data=gh(k),_[4][0].data=gh(f.e.r+1),S[2][k]={type:S[2][0].type,data:wh(_)};w[0].messages[0].data=wh(S),t.content=Sh(kh(w)),t.size=t.content.length,r["!merges"]&&(O=function(e){for(var t=927262;t<2e6;++t)if(!d[t])return d[t]=e,t;throw new Error("Too many messages")}({type:6144,deps:[g],location:d[g].location}),x=[[],[]],r["!merges"].forEach(function(e){x[1].push({type:2,data:wh([[],[{type:2,data:wh([[],[{type:5,data:new Uint8Array(new Uint16Array([e.s.r,e.s.c]).buffer)}]])}],[{type:2,data:wh([[],[{type:5,data:new Uint8Array(new Uint16Array([e.e.r-e.s.r+1,e.e.c-e.s.c+1]).buffer)}]])}]])})}),e[13]=[{type:2,data:wh([[],[{type:0,data:gh(O)}]])}],c.push({id:O,messages:[(R=6144,O=wh(x),{meta:[[],[{type:0,data:gh(R)}]],data:O})]}));var A=Rh(e[4][0].data);!function(){for(var e,t=xe.find(p,d[A].location),r=Eh(yh(t.content)),a=0;a<r.length;++a){var n=r[a];n.id==A&&(e=n)}var s=vh(e.messages[0].data);s[3]=[],u.forEach(function(e,t){s[3].push({type:2,data:wh([[],[{type:0,data:gh(t)}],[{type:0,data:gh(1)}],[{type:2,data:uh(e)}]])})}),e.messages[0].data=wh(s),t.content=Sh(kh(r)),t.size=t.content.length}();var C=vh(e[3][0].data),R=C[1][0];delete C[2];var R,O,O=vh(R.data),I=Rh(O[2][0].data);return function(){for(var e,t=xe.find(p,d[I].location),r=Eh(yh(t.content)),a=0;a<r.length;++a){var n=r[a];n.id==I&&(e=n)}var s=vh(e.messages[0].data);delete s[6],delete C[7];var i=new Uint8Array(s[5][0].data);s[5]=[];for(var o=0,c=0;c<=f.e.r;++c){var l=vh(i);o+=function(e,t,r){var a,n;if(null==(a=e[6])||!a[0]||null==(n=e[7])||!n[0])throw"Mutation only works on post-BNC storages!";if((null==(n=null==(n=e[8])?void 0:n[0])?void 0:n.data)&&0<bh(e[8][0].data)||!1)throw"Math only works with normal offsets";for(var s,i,o=0,c=fh(e[7][0].data),l=0,f=[],h=fh(e[4][0].data),u=0,d=[],p=0;p<t.length;++p)if(null!=t[p]){switch(c.setUint16(2*p,l,!0),h.setUint16(2*p,u,!0),typeof t[p]){case"string":s=xh({t:"s",v:t[p]},r),i=Ah({t:"s",v:t[p]},r);break;case"number":s=xh({t:"n",v:t[p]},r),i=Ah({t:"n",v:t[p]},r);break;case"boolean":s=xh({t:"b",v:t[p]},r),i=Ah({t:"b",v:t[p]},r);break;default:throw new Error("Unsupported value "+t[p])}f.push(s),l+=s.length,d.push(i),u+=i.length,++o}else c.setUint16(2*p,65535,!0),h.setUint16(2*p,65535);for(e[2][0].data=gh(o);p<e[7][0].data.length/2;++p)c.setUint16(2*p,65535,!0),h.setUint16(2*p,65535,!0);return e[6][0].data=dh(f),e[3][0].data=dh(d),o}(l,h[c],u),l[1][0].data=gh(c),s[5].push({data:wh(l),type:2})}s[1]=[{type:0,data:gh(f.e.c+1)}],s[2]=[{type:0,data:gh(f.e.r+1)}],s[3]=[{type:0,data:gh(o)}],s[4]=[{type:0,data:gh(f.e.r+1)}],e.messages[0].data=wh(s),t.content=Sh(kh(r)),t.size=t.content.length}(),R.data=wh(O),e[3][0].data=wh(C),a[4][0].data=wh(e),i.messages[0].data=wh(a),o.content=Sh(kh(c)),o.size=o.content.length,p}function Lh(a){return function(e){for(var t=0;t!=a.length;++t){var r=a[t];void 0===e[r[0]]&&(e[r[0]]=r[1]),"n"===r[2]&&(e[r[0]]=Number(e[r[0]]))}}}function Mh(e){Lh([["cellNF",!1],["cellHTML",!0],["cellFormula",!0],["cellStyles",!1],["cellText",!0],["cellDates",!1],["sheetStubs",!1],["sheetRows",0,"n"],["bookDeps",!1],["bookSheets",!1],["bookProps",!1],["bookFiles",!1],["bookVBA",!1],["password",""],["WTF",!1]])(e)}function Uh(e){Lh([["cellDates",!1],["bookSST",!1],["bookType","xlsx"],["compression",!1],["WTF",!1]])(e)}function Bh(t,e){if(!t)return 0;try{t=e.map(function(e){return e.id||(e.id=e.strRelID),[e.name,t["!id"][e.id].Target,(e=t["!id"][e.id].Type,-1<$a.WS.indexOf(e)?"sheet":$a.CS&&e==$a.CS?"chart":$a.DS&&e==$a.DS?"dialog":$a.MS&&e==$a.MS?"macro":e&&e.length?e:"sheet")]})}catch(e){return null}return t&&0!==t.length?t:null}function Wh(l,f,e,h,t,u,r,a,d,n,s,i){try{u[h]=Ya(tt(l,e,!0),f);var o=et(l,f);switch(a){case"sheet":g=nf(o,f,t,d,u[h],n,s,i);break;case"chart":if(!(g=sf(o,f,t,d,u[h],n))||!g["!drawel"])break;var c=it(g["!drawel"].Target,f),p=Xa(c),m=it((m=tt(l,c,!0),p=Ya(tt(l,p,!0),c),m?(m=(m.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1],p["!id"][m].Target):"??"),c),c=Xa(m),g=Wl(tt(l,m,!0),0,0,Ya(tt(l,c,!0),m),0,g);break;case"macro":v=f,u[h],v.slice(-4),g={"!type":"macro"};break;case"dialog":v=f,u[h],v.slice(-4),g={"!type":"dialog"};break;default:throw new Error("Unrecognized sheet type "+a)}r[h]=g;var b=[];u&&u[h]&&Re(u[h]).forEach(function(e){var a,n,s,i,o,c,t="";if(u[h][e].Type==$a.CMNT){t=it(u[h][e].Target,f);var r=lf(et(l,t,!0),t,d);if(!r||!r.length)return;ec(g,r,!1)}u[h][e].Type==$a.TCMNT&&(t=it(u[h][e].Target,f),b=b.concat((a=et(l,t,!0),n=d,i=!(s=[]),o={},c=0,a.replace(ft,function(e,t){var r=dt(e);switch(pt(r[0])){case"<?xml":case"<ThreadedComments":case"</ThreadedComments>":break;case"<threadedComment":o={author:r.personId,guid:r.id,ref:r.ref,T:1};break;case"</threadedComment>":null!=o.t&&s.push(o);break;case"<text>":case"<text":c=t+e.length;break;case"</text>":o.t=a.slice(c,t).replace(/\r\n/g,"\n").replace(/\r/g,"\n");break;case"<mentions":case"<mentions>":i=!0;break;case"</mentions>":i=!1;break;case"<extLst":case"<extLst>":case"</extLst>":case"<extLst/>":break;case"<ext":i=!0;break;case"</ext>":i=!1;break;default:if(!i&&n.WTF)throw new Error("unrecognized "+r[0]+" in threaded comments")}return e}),s)))}),b&&b.length&&ec(g,b,!0,d.people||[])}catch(e){if(d.WTF)throw e}var v,m}function Hh(e){return"/"==e.charAt(0)?e.slice(1):e}function zh(r,t){if(Ee(),Mh(t=t||{}),Ze(r,"META-INF/manifest.xml"))return sh(r,t);if(Ze(r,"objectdata.xml"))return sh(r,t);if(Ze(r,"Index/Document.iwa")){if("undefined"==typeof Uint8Array)throw new Error("NUMBERS file parsing requires Uint8Array support");if(0,r.FileIndex)return Dh(r);var a=xe.utils.cfb_new();return rt(r).forEach(function(e){at(a,e,function e(t,r,a){if(!a)return qe(Qe(t,r));if(!r)return null;try{return e(t,r)}catch(e){return null}}(r,e))}),Dh(a)}if(!Ze(r,"[Content_Types].xml")){if(Ze(r,"index.xml.gz"))throw new Error("Unsupported NUMBERS 08 file");if(Ze(r,"index.xml"))throw new Error("Unsupported NUMBERS 09 file");throw new Error("Unsupported ZIP file")}var e,n,s=rt(r),i=function(e){var r=Ga();if(!e||!e.match)return r;var a={};if((e.match(ft)||[]).forEach(function(e){var t=dt(e);switch(t[0].replace(ht,"<")){case"<?xml":break;case"<Types":r.xmlns=t["xmlns"+(t[0].match(/<(\w+):/)||["",""])[1]];break;case"<Default":a[t.Extension]=t.ContentType;break;case"<Override":void 0!==r[za[t.ContentType]]&&r[za[t.ContentType]].push(t.PartName)}}),r.xmlns!==Zt.CT)throw new Error("Unknown Namespace: "+r.xmlns);return r.calcchain=0<r.calcchains.length?r.calcchains[0]:"",r.sst=0<r.strs.length?r.strs[0]:"",r.style=0<r.styles.length?r.styles[0]:"",r.defaults=a,delete r.calcchains,r}(tt(r,"[Content_Types].xml")),o=!1;if(0===i.workbooks.length&&et(r,n="xl/workbook.xml",!0)&&i.workbooks.push(n),0===i.workbooks.length){if(!et(r,n="xl/workbook.bin",!0))throw new Error("Could not find workbook");i.workbooks.push(n),o=!0}"bin"==i.workbooks[0].slice(-3)&&(o=!0);var c={},l={};if(!t.bookSheets&&!t.bookProps){if(Yc=[],i.sst)try{Yc=cf(et(r,Hh(i.sst)),i.sst,t)}catch(e){if(t.WTF)throw e}t.cellStyles&&i.themes.length&&(m=tt(r,i.themes[0].replace(/^\//,""),!0)||"",i.themes[0],c=$o(m,t)),i.style&&(l=of(et(r,Hh(i.style)),i.style,c,t))}i.links.map(function(e){try{Ya(tt(r,Xa(Hh(e))),e);return hf(et(r,Hh(e)),0,e,t)}catch(e){}});var f,h,u,d=af(et(r,Hh(i.workbooks[0])),i.workbooks[0],t),p={},m="";i.coreprops.length&&((m=et(r,Hh(i.coreprops[0]),!0))&&(p=rn(m)),0!==i.extprops.length&&(m=et(r,Hh(i.extprops[0]),!0))&&(g=t,u={},h=(h=p)||{},f=Mt(f=m),sn.forEach(function(e){var t=(f.match(Bt(e[0]))||[])[1];switch(e[2]){case"string":t&&(h[e[1]]=wt(t));break;case"bool":h[e[1]]="true"===t;break;case"raw":var r=f.match(new RegExp("<"+e[0]+"[^>]*>([\\s\\S]*?)</"+e[0]+">"));r&&0<r.length&&(u[e[1]]=r[1])}}),u.HeadingPairs&&u.TitlesOfParts&&cn(u.HeadingPairs,u.TitlesOfParts,h,g)));var g={};t.bookSheets&&!t.bookProps||0!==i.custprops.length&&(m=tt(r,Hh(i.custprops[0]),!0))&&(g=function(e,t){var r={},a="",n=e.match(fn);if(n)for(var s=0;s!=n.length;++s){var i=n[s],o=dt(i);switch(o[0]){case"<?xml":case"<Properties":break;case"<property":a=wt(o.name);break;case"</property>":a=null;break;default:if(0===i.indexOf("<vt:")){var c=i.split(">"),l=c[0].slice(4),f=c[1];switch(l){case"lpstr":case"bstr":case"lpwstr":r[a]=wt(f);break;case"bool":r[a]=Rt(f);break;case"i1":case"i2":case"i4":case"i8":case"int":case"uint":r[a]=parseInt(f,10);break;case"r4":case"r8":case"decimal":r[a]=parseFloat(f);break;case"filetime":case"date":r[a]=He(f);break;case"cy":case"error":r[a]=wt(f);break;default:if("/"==l.slice(-1))break;t.WTF&&"undefined"!=typeof console&&console.warn("Unexpected",i,l,c)}}else if("</"!==i.slice(0,2)&&t.WTF)throw new Error(i)}}return r}(m,t));var b={};if((t.bookSheets||t.bookProps)&&(d.Sheets?e=d.Sheets.map(function(e){return e.name}):p.Worksheets&&0<p.SheetNames.length&&(e=p.SheetNames),t.bookProps&&(b.Props=p,b.Custprops=g),t.bookSheets&&void 0!==e&&(b.SheetNames=e),t.bookSheets?b.SheetNames:t.bookProps))return b;e={};m={};t.bookDeps&&i.calcchain&&(m=ff(et(r,Hh(i.calcchain)),i.calcchain));var v,w,T=0,E={},k=d.Sheets;p.Worksheets=k.length,p.SheetNames=[];for(var y=0;y!=k.length;++y)p.SheetNames[y]=k[y].name;var S=o?"bin":"xml",o=i.workbooks[0].lastIndexOf("/"),_=(i.workbooks[0].slice(0,o+1)+"_rels/"+i.workbooks[0].slice(o+1)+".rels").replace(/^\//,"");Ze(r,_)||(_="xl/_rels/workbook."+S+".rels");var x,A,C,R=Ya(tt(r,_,!0),_.replace(/_rels.*/,"s5s"));1<=(i.metadata||[]).length&&(t.xlmeta=uf(et(r,Hh(i.metadata[0])),i.metadata[0],t)),1<=(i.people||[]).length&&(t.people=(o=et(r,Hh(i.people[0])),x=t,C=!(A=[]),o.replace(ft,function(e){var t=dt(e);switch(pt(t[0])){case"<?xml":case"<personList":case"</personList>":break;case"<person":A.push({name:t.displayname,id:t.id});break;case"</person>":break;case"<extLst":case"<extLst>":case"</extLst>":case"<extLst/>":break;case"<ext":C=!0;break;case"</ext>":C=!1;break;default:if(!C&&x.WTF)throw new Error("unrecognized "+t[0]+" in threaded comments")}return e}),A)),R=R&&Bh(R,d.Sheets);var O=et(r,"xl/worksheets/sheet.xml",!0)?1:0;e:for(T=0;T!=p.Worksheets;++T){var I="sheet";if(R&&R[T]?(v="xl/"+R[T][1].replace(/[\/]?xl\//,""),Ze(r,v)||(v=R[T][1]),Ze(r,v)||(v=_.replace(/_rels\/.*$/,"")+R[T][1]),I=R[T][2]):v=(v="xl/worksheets/sheet"+(T+1-O)+"."+S).replace(/sheet0\./,"sheet."),w=v.replace(/^(.*)(\/)([^\/]*)$/,"$1/_rels/$3.rels"),t&&null!=t.sheets)switch(typeof t.sheets){case"number":if(T!=t.sheets)continue e;break;case"string":if(p.SheetNames[T].toLowerCase()!=t.sheets.toLowerCase())continue e;break;default:if(Array.isArray&&Array.isArray(t.sheets)){for(var N=!1,F=0;F!=t.sheets.length;++F)"number"==typeof t.sheets[F]&&t.sheets[F]==T&&(N=1),"string"==typeof t.sheets[F]&&t.sheets[F].toLowerCase()==p.SheetNames[T].toLowerCase()&&(N=1);if(!N)continue e}}Wh(r,v,w,p.SheetNames[T],T,E,e,I,t,d,c,l)}return b={Directory:i,Workbook:d,Props:p,Custprops:g,Deps:m,Sheets:e,SheetNames:p.SheetNames,Strings:Yc,Styles:l,Themes:c,SSF:Ve(me)},t&&t.bookFiles&&(r.files?(b.keys=s,b.files=r.files):(b.keys=[],b.files={},r.FullPaths.forEach(function(e,t){e=e.replace(/^Root Entry[\/]/,""),b.keys.push(e),b.files[e]=r.FileIndex[t]}))),t&&t.bookVBA&&(0<i.vba.length?b.vbaraw=et(r,Hh(i.vba[0]),!0):i.defaults&&i.defaults.bin===ac&&(b.vbaraw=et(r,"xl/vbaProject.bin",!0))),b}function Vh(e,t){var r,a=t||{},n="Workbook",s=xe.find(e,n);try{if(n="/!DataSpaces/Version",!(s=xe.find(e,n))||!s.content)throw new Error("ECMA-376 Encrypted file missing "+n);if(i=s.content,(r={}).id=i.read_shift(0,"lpp4"),r.R=Li(i,4),r.U=Li(i,4),r.W=Li(i,4),n="/!DataSpaces/DataSpaceMap",!(s=xe.find(e,n))||!s.content)throw new Error("ECMA-376 Encrypted file missing "+n);var i=Mi(s.content);if(1!==i.length||1!==i[0].comps.length||0!==i[0].comps[0].t||"StrongEncryptionDataSpace"!==i[0].name||"EncryptedPackage"!==i[0].comps[0].v)throw new Error("ECMA-376 Encrypted file bad "+n);if(n="/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace",!(s=xe.find(e,n))||!s.content)throw new Error("ECMA-376 Encrypted file missing "+n);i=function(e){var t=[];e.l+=4;for(var r=e.read_shift(4);0<r--;)t.push(e.read_shift(0,"lpp4"));return t}(s.content);if(1!=i.length||"StrongEncryptionTransform"!=i[0])throw new Error("ECMA-376 Encrypted file bad "+n);if(n="/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary",!(s=xe.find(e,n))||!s.content)throw new Error("ECMA-376 Encrypted file missing "+n);Ui(s.content)}catch(e){}if(n="/EncryptionInfo",!(s=xe.find(e,n))||!s.content)throw new Error("ECMA-376 Encrypted file missing "+n);t=Hi(s.content),n="/EncryptedPackage";if(!(s=xe.find(e,n))||!s.content)throw new Error("ECMA-376 Encrypted file missing "+n);if(4==t[0]&&"undefined"!=typeof decrypt_agile)return decrypt_agile(t[1],s.content,a.password||"",a);if(2==t[0]&&"undefined"!=typeof decrypt_std76)return decrypt_std76(t[1],s.content,a.password||"",a);throw new Error("File is password-protected")}function Gh(e,t){return("ods"==t.bookType?lh:"numbers"==t.bookType?Ph:"xlsb"==t.bookType?function(e,t){Zo=1024,e&&!e.SSF&&(e.SSF=Ve(me));e&&e.SSF&&(Ee(),Te(e.SSF),t.revssf=Ne(e.SSF),t.revssf[e.SSF[65535]]=0,t.ssf=e.SSF);t.rels={},t.wbrels={},t.Strings=[],t.Strings.Count=0,t.Strings.Unique=0,Jc?t.revStrings=new Map:(t.revStrings={},t.revStrings.foo=[],delete t.revStrings.foo);var r="xlsb"==t.bookType?"bin":"xml",a=-1<nc.indexOf(t.bookType),n=Ga();Uh(t=t||{});var s=nt(),i="",o=0;t.cellXfs=[],el(t.cellXfs,{},{revssf:{General:0}}),e.Props||(e.Props={});if(at(s,i="docProps/core.xml",nn(e.Props,t)),n.coreprops.push(i),Ja(t.rels,2,i,$a.CORE_PROPS),i="docProps/app.xml",!e.Props||!e.Props.SheetNames)if(e.Workbook&&e.Workbook.Sheets){for(var c=[],l=0;l<e.SheetNames.length;++l)2!=(e.Workbook.Sheets[l]||{}).Hidden&&c.push(e.SheetNames[l]);e.Props.SheetNames=c}else e.Props.SheetNames=e.SheetNames;e.Props.Worksheets=e.Props.SheetNames.length,at(s,i,ln(e.Props)),n.extprops.push(i),Ja(t.rels,3,i,$a.EXT_PROPS),e.Custprops!==e.Props&&0<Re(e.Custprops||{}).length&&(at(s,i="docProps/custom.xml",hn(e.Custprops)),n.custprops.push(i),Ja(t.rels,4,i,$a.CUST_PROPS));for(o=1;o<=e.SheetNames.length;++o){var f,h,u,d={"!id":{}},p=e.Sheets[e.SheetNames[o-1]];at(s,i="xl/worksheets/sheet"+o+"."+r,function(e,t,r,a,n){return(".bin"===t.slice(-4)?Bl:xl)(e,r,a,n)}(o-1,i,t,e,d)),n.sheets.push(i),Ja(t.wbrels,-1,"worksheets/sheet"+o+"."+r,$a.WS[0]),p&&(f=p["!comments"],h=!1,u="",f&&0<f.length&&(at(s,u="xl/comments"+o+"."+r,function(e,t,r){return(".bin"===t.slice(-4)?rc:tc)(e,r)}(f,u,t)),n.comments.push(u),Ja(d,-1,"../comments"+o+"."+r,$a.CMNT),h=!0),p["!legacy"]&&h&&at(s,"xl/drawings/vmlDrawing"+o+".vml",Qo(o,p["!comments"])),delete p["!comments"],delete p["!legacy"]),d["!id"].rId1&&at(s,Xa(i),Ka(d))}null!=t.Strings&&0<t.Strings.length&&(at(s,i="xl/sharedStrings."+r,function(e,t,r){return(".bin"===t.slice(-4)?Di:Ni)(e,r)}(t.Strings,i,t)),n.strs.push(i),Ja(t.wbrels,-1,"sharedStrings."+r,$a.SST));at(s,i="xl/workbook."+r,function(e,t,r){return(".bin"===t.slice(-4)?rf:Zl)(e,r)}(e,i,t)),n.workbooks.push(i),Ja(t.rels,1,i,$a.WB),at(s,i="xl/theme/theme1.xml",Xo(e.Themes,t)),n.themes.push(i),Ja(t.wbrels,-1,"theme/theme1.xml",$a.THEME),at(s,i="xl/styles."+r,function(e,t,r){return(".bin"===t.slice(-4)?Mo:_o)(e,r)}(e,i,t)),n.styles.push(i),Ja(t.wbrels,-1,"styles."+r,$a.STY),e.vbaraw&&a&&(at(s,i="xl/vbaProject.bin",e.vbaraw),n.vba.push(i),Ja(t.wbrels,-1,"vbaProject.bin",$a.VBA));return at(s,i="xl/metadata."+r,function(e){return(".bin"===e.slice(-4)?Jo:qo)()}(i)),n.metadata.push(i),Ja(t.wbrels,-1,"metadata."+r,$a.XLMETA),at(s,"[Content_Types].xml",ja(n,t)),at(s,"_rels/.rels",Ka(t.rels)),at(s,"xl/_rels/workbook."+r+".rels",Ka(t.wbrels)),delete t.revssf,delete t.ssf,s}:jh)(e,t)}function jh(e,t){Zo=1024,e&&!e.SSF&&(e.SSF=Ve(me)),e&&e.SSF&&(Ee(),Te(e.SSF),t.revssf=Ne(e.SSF),t.revssf[e.SSF[65535]]=0,t.ssf=e.SSF),t.rels={},t.wbrels={},t.Strings=[],t.Strings.Count=0,t.Strings.Unique=0,Jc?t.revStrings=new Map:(t.revStrings={},t.revStrings.foo=[],delete t.revStrings.foo);var r="xml",a=-1<nc.indexOf(t.bookType),n=Ga();Uh(t=t||{});var s=nt(),i="",o=0;if(t.cellXfs=[],el(t.cellXfs,{},{revssf:{General:0}}),e.Props||(e.Props={}),i="docProps/core.xml",at(s,i,nn(e.Props,t)),n.coreprops.push(i),Ja(t.rels,2,i,$a.CORE_PROPS),i="docProps/app.xml",!e.Props||!e.Props.SheetNames)if(e.Workbook&&e.Workbook.Sheets){for(var c=[],l=0;l<e.SheetNames.length;++l)2!=(e.Workbook.Sheets[l]||{}).Hidden&&c.push(e.SheetNames[l]);e.Props.SheetNames=c}else e.Props.SheetNames=e.SheetNames;e.Props.Worksheets=e.Props.SheetNames.length,at(s,i,ln(e.Props)),n.extprops.push(i),Ja(t.rels,3,i,$a.EXT_PROPS),e.Custprops!==e.Props&&0<Re(e.Custprops||{}).length&&(at(s,i="docProps/custom.xml",hn(e.Custprops)),n.custprops.push(i),Ja(t.rels,4,i,$a.CUST_PROPS));var f,h=["SheetJ5"];for(t.tcid=0,o=1;o<=e.SheetNames.length;++o){var u,d,p,m,g={"!id":{}},b=e.Sheets[e.SheetNames[o-1]];at(s,i="xl/worksheets/sheet"+o+"."+r,xl(o-1,t,e,g)),n.sheets.push(i),Ja(t.wbrels,-1,"worksheets/sheet"+o+"."+r,$a.WS[0]),b&&(d=!1,p="",(u=b["!comments"])&&0<u.length&&(m=!1,u.forEach(function(e){e[1].forEach(function(e){1==e.T&&(m=!0)})}),m&&(at(s,p="xl/threadedComments/threadedComment"+o+"."+r,function(e,s,i){var o=[ot,Yt("ThreadedComments",null,{xmlns:Zt.TCMNT}).replace(/[\/]>/,">")];return e.forEach(function(a){var n="";(a[1]||[]).forEach(function(e,t){var r;e.T?(e.a&&-1==s.indexOf(e.a)&&s.push(e.a),r={ref:a[0],id:"{54EE7951-7262-4200-6969-"+("000000000000"+i.tcid++).slice(-12)+"}"},0==t?n=r.id:r.parentId=n,e.ID=r.id,e.a&&(r.personId="{54EE7950-7262-4200-6969-"+("000000000000"+s.indexOf(e.a)).slice(-12)+"}"),o.push(Yt("threadedComment",$t("text",e.t||""),r))):delete e.ID})}),o.push("</ThreadedComments>"),o.join("")}(u,h,t)),n.threadedcomments.push(p),Ja(g,-1,"../threadedComments/threadedComment"+o+"."+r,$a.TCMNT)),at(s,p="xl/comments"+o+"."+r,tc(u)),n.comments.push(p),Ja(g,-1,"../comments"+o+"."+r,$a.CMNT),d=!0),b["!legacy"]&&d&&at(s,"xl/drawings/vmlDrawing"+o+".vml",Qo(o,b["!comments"])),delete b["!comments"],delete b["!legacy"]),g["!id"].rId1&&at(s,Xa(i),Ka(g))}return null!=t.Strings&&0<t.Strings.length&&(at(s,i="xl/sharedStrings.xml",Ni(t.Strings,t)),n.strs.push(i),Ja(t.wbrels,-1,"sharedStrings.xml",$a.SST)),at(s,i="xl/workbook.xml",Zl(e)),n.workbooks.push(i),Ja(t.rels,1,i,$a.WB),at(s,i="xl/theme/theme1.xml",Xo(e.Themes,t)),n.themes.push(i),Ja(t.wbrels,-1,"theme/theme1.xml",$a.THEME),at(s,i="xl/styles.xml",_o(e,t)),n.styles.push(i),Ja(t.wbrels,-1,"styles.xml",$a.STY),e.vbaraw&&a&&(at(s,i="xl/vbaProject.bin",e.vbaraw),n.vba.push(i),Ja(t.wbrels,-1,"vbaProject.bin",$a.VBA)),at(s,i="xl/metadata.xml",qo()),n.metadata.push(i),Ja(t.wbrels,-1,"metadata.xml",$a.XLMETA),1<h.length&&(at(s,i="xl/persons/person.xml",(a=h,f=[ot,Yt("personList",null,{xmlns:Zt.TCMNT,"xmlns:x":Qt[0]}).replace(/[\/]>/,">")],a.forEach(function(e,t){f.push(Yt("person",null,{displayName:e,id:"{54EE7950-7262-4200-6969-"+("000000000000"+t).slice(-12)+"}",userId:e,providerId:"None"}))}),f.push("</personList>"),f.join(""))),n.people.push(i),Ja(t.wbrels,-1,"persons/person.xml",$a.PEOPLE)),at(s,"[Content_Types].xml",ja(n,t)),at(s,"_rels/.rels",Ka(t.rels)),at(s,"xl/_rels/workbook.xml.rels",Ka(t.wbrels)),delete t.revssf,delete t.ssf,s}function $h(e,t){var r="";switch((t||{}).type||"base64"){case"buffer":return[e[0],e[1],e[2],e[3],e[4],e[5],e[6],e[7]];case"base64":r=te(e.slice(0,12));break;case"binary":r=e;break;case"array":return[e[0],e[1],e[2],e[3],e[4],e[5],e[6],e[7]];default:throw new Error("Unrecognized type "+(t&&t.type||"undefined"))}return[r.charCodeAt(0),r.charCodeAt(1),r.charCodeAt(2),r.charCodeAt(3),r.charCodeAt(4),r.charCodeAt(5),r.charCodeAt(6),r.charCodeAt(7)]}function Xh(e,t){var r=0;e:for(;r<e.length;)switch(e.charCodeAt(r)){case 10:case 13:case 32:++r;break;case 60:return wf(e.slice(r),t);default:break e}return Ks.to_workbook(e,t)}function Yh(e,t,r,a){return a?(r.type="string",Ks.to_workbook(e,r)):Ks.to_workbook(t,r)}function Kh(e,t){h();var r=t||{};if("undefined"!=typeof ArrayBuffer&&e instanceof ArrayBuffer)return Kh(new Uint8Array(e),((r=Ve(r)).type="array",r));"undefined"!=typeof Uint8Array&&e instanceof Uint8Array&&!r.type&&(r.type="undefined"!=typeof Deno?"buffer":"array");var a,n,s,i,o,c=e,l=!1;if(r.cellStyles&&(r.cellNF=!0,r.sheetStubs=!0),Kc={},r.dateNF&&(Kc.dateNF=r.dateNF),r.type||(r.type=se&&Buffer.isBuffer(e)?"buffer":"base64"),"file"==r.type&&(r.type=se?"buffer":"binary",c=function(e){if(void 0!==Se)return Se.readFileSync(e);if("undefined"!=typeof Deno)return Deno.readFileSync(e);if("undefined"!=typeof $&&"undefined"!=typeof File&&"undefined"!=typeof Folder)try{var t=File(e);t.open("r"),t.encoding="binary";var r=t.read();return t.close(),r}catch(e){if(!e.message||!e.message.match(/onstruct/))throw e}throw new Error("Cannot access file "+e)}(e),"undefined"==typeof Uint8Array||se||(r.type="array")),"string"==r.type&&(l=!0,r.type="binary",r.codepage=65001,c=(f=e).match(/[^\x00-\x7F]/)?Ut(f):f),"array"==r.type&&"undefined"!=typeof Uint8Array&&e instanceof Uint8Array&&"undefined"!=typeof ArrayBuffer){var f=new ArrayBuffer(3),f=new Uint8Array(f);if(f.foo="bar",!f.foo)return(r=Ve(r)).type="array",Kh(m(c),r)}switch((a=$h(c,r))[0]){case 208:if(207===a[1]&&17===a[2]&&224===a[3]&&161===a[4]&&177===a[5]&&26===a[6]&&225===a[7])return i=xe.read(c,r),o=r,(xe.find(i,"EncryptedPackage")?Vh:Nf)(i,o);break;case 9:if(a[1]<=8)return Nf(c,r);break;case 60:return wf(c,r);case 73:if(73===a[1]&&42===a[2]&&0===a[3])throw new Error("TIFF Image File is not a spreadsheet");if(68===a[1])return function(t,r){var a=r||{},n=!!a.WTF;a.WTF=!0;try{var e=Ns.to_workbook(t,a);return a.WTF=n,e}catch(e){if(a.WTF=n,!e.message.match(/SYLK bad record ID/)&&n)throw e;return Ks.to_workbook(t,r)}}(c,r);break;case 84:if(65===a[1]&&66===a[2]&&76===a[3])return Ps.to_workbook(c,r);break;case 80:return 75===a[1]&&a[2]<9&&a[3]<9?(s=o=c,(n=(n=r)||{}).type||(n.type=se&&Buffer.isBuffer(o)?"buffer":"base64"),zh(st(s,n),n)):Yh(e,c,r,l);case 239:return 60===a[3]?wf(c,r):Yh(e,c,r,l);case 255:if(254===a[1])return s=c,"base64"==(n=r).type&&(s=te(s)),s=re.utils.decode(1200,s.slice(2),"str"),n.type="binary",Xh(s,n);if(0===a[1]&&2===a[2]&&0===a[3])return si.to_workbook(c,r);break;case 0:if(0===a[1]){if(2<=a[2]&&0===a[3])return si.to_workbook(c,r);if(0===a[2]&&(8===a[3]||9===a[3]))return si.to_workbook(c,r)}break;case 3:case 131:case 139:case 140:return xs.to_workbook(c,r);case 123:if(92===a[1]&&114===a[2]&&116===a[3])return Ji.to_workbook(c,r);break;case 10:case 13:case 32:return function(e,t){var r="",a=$h(e,t);switch(t.type){case"base64":r=te(e);break;case"binary":r=e;break;case"buffer":r=e.toString("binary");break;case"array":r=ze(e);break;default:throw new Error("Unrecognized type "+t.type)}return 239==a[0]&&187==a[1]&&191==a[2]&&(r=Mt(r)),t.type="binary",Xh(r,t)}(c,r);case 137:if(80===a[1]&&78===a[2]&&71===a[3])throw new Error("PNG Image File is not a spreadsheet")}return-1<_s.indexOf(a[0])&&a[2]<=12&&a[3]<=31?xs.to_workbook(c,r):Yh(e,c,r,l)}function Jh(e,t){t=t||{};return t.type="file",Kh(e,t)}function qh(e,t){switch(t.type){case"base64":case"binary":break;case"buffer":case"array":t.type="";break;case"file":return Ce(t.file,xe.write(e,{type:se?"buffer":""}));case"string":throw new Error("'string' output type invalid for '"+t.bookType+"' files");default:throw new Error("Unrecognized type "+t.type)}return xe.write(e,t)}function Zh(e,t){var r={},a=se?"nodebuffer":"undefined"!=typeof Uint8Array?"array":"string";if(t.compression&&(r.compression="DEFLATE"),t.password)r.type=a;else switch(t.type){case"base64":r.type="base64";break;case"binary":r.type="string";break;case"string":throw new Error("'string' output type invalid for '"+t.bookType+"' files");case"buffer":case"file":r.type=a;break;default:throw new Error("Unrecognized type "+t.type)}e=e.FullPaths?xe.write(e,{fileType:"zip",type:{nodebuffer:"buffer",string:"binary"}[r.type]||r.type,compression:!!t.compression}):e.generate(r);if("undefined"!=typeof Deno&&"string"==typeof e){if("binary"==t.type||"base64"==t.type)return e;e=new Uint8Array(o(e))}return t.password&&"undefined"!=typeof encrypt_agile?qh(encrypt_agile(e,t.password),t):"file"===t.type?Ce(t.file,e):"string"==t.type?Mt(e):e}function Qh(e,t,r){var a=(r=r||"")+e;switch(t.type){case"base64":return ee(Ut(a));case"binary":return Ut(a);case"string":return e;case"file":return Ce(t.file,a,"utf8");case"buffer":return se?ce(a,"utf8"):"undefined"!=typeof TextEncoder?(new TextEncoder).encode(a):Qh(a,{type:"binary"}).split("").map(function(e){return e.charCodeAt(0)})}throw new Error("Unrecognized type "+t.type)}function eu(e,t){switch(t.type){case"string":case"base64":case"binary":for(var r="",a=0;a<e.length;++a)r+=String.fromCharCode(e[a]);return"base64"==t.type?ee(r):"string"==t.type?Mt(r):r;case"file":return Ce(t.file,e);case"buffer":return e;default:throw new Error("Unrecognized type "+t.type)}}function tu(e,t){h(),Jl(e);var r,a=Ve(t||{});if(a.cellStyles&&(a.cellNF=!0,a.sheetStubs=!0),"array"!=a.type)return r=e,t=Ve((t=a)||{}),Zh(jh(r,t),t);a.type="binary";e=tu(e,a);return a.type="array",o(e)}function ru(e,t){h(),Jl(e);var r=Ve(t||{});if(r.cellStyles&&(r.cellNF=!0,r.sheetStubs=!0),"array"==r.type){r.type="binary";t=ru(e,r);return r.type="array",o(t)}var a,n,s,i=0;if(r.sheet&&(i="number"==typeof r.sheet?r.sheet:e.SheetNames.indexOf(r.sheet),!e.SheetNames[i]))throw new Error("Sheet not found: "+r.sheet+" : "+typeof r.sheet);switch(r.bookType||"xlsb"){case"xml":case"xlml":return Qh(_f(e,r),r);case"slk":case"sylk":return Qh(Ns.from_sheet(e.Sheets[e.SheetNames[i]],r),r);case"htm":case"html":return Qh(Qf(e.Sheets[e.SheetNames[i]],r),r);case"txt":return function(e,t){switch(t.type){case"base64":return ee(e);case"binary":case"string":return e;case"file":return Ce(t.file,e,"binary");case"buffer":return se?ce(e,"binary"):e.split("").map(function(e){return e.charCodeAt(0)})}throw new Error("Unrecognized type "+t.type)}(fu(e.Sheets[e.SheetNames[i]],r),r);case"csv":return Qh(lu(e.Sheets[e.SheetNames[i]],r),r,"\ufeff");case"dif":return Qh(Ps.from_sheet(e.Sheets[e.SheetNames[i]],r),r);case"dbf":return eu(xs.from_sheet(e.Sheets[e.SheetNames[i]],r),r);case"prn":return Qh(Ks.from_sheet(e.Sheets[e.SheetNames[i]],r),r);case"rtf":return Qh(Ji.from_sheet(e.Sheets[e.SheetNames[i]],r),r);case"eth":return Qh(Gs.from_sheet(e.Sheets[e.SheetNames[i]],r),r);case"fods":return Qh(lh(e,r),r);case"wk1":return eu(si.sheet_to_wk1(e.Sheets[e.SheetNames[i]],r),r);case"wk3":return eu(si.book_to_wk3(e,r),r);case"biff2":r.biff||(r.biff=2);case"biff3":r.biff||(r.biff=3);case"biff4":return r.biff||(r.biff=4),eu(Xf(e,r),r);case"biff5":r.biff||(r.biff=5);case"biff8":case"xla":case"xls":return r.biff||(r.biff=8),qh(Ff(e,s=(s=r)||{}),s);case"xlsx":case"xlsm":case"xlam":case"xlsb":case"numbers":case"ods":return a=e,s=Ve((n=r)||{}),yo=new wu(n),Zh(Gh(a,s),s);default:throw new Error("Unrecognized bookType |"+r.bookType+"|")}}function au(e){var t;e.bookType||((t=e.file.slice(e.file.lastIndexOf(".")).toLowerCase()).match(/^\.[a-z]+$/)&&(e.bookType=t.slice(1)),e.bookType={xls:"biff8",htm:"html",slk:"sylk",socialcalc:"eth",Sh33tJS:"WTF"}[e.bookType]||e.bookType)}function nu(e,t,r){r=r||{};return r.type="file",r.file=t,au(r),ru(e,r)}function su(e,t,r,a,n,s,i,o){var c=jr(r),l=o.defval,f=o.raw||!Object.prototype.hasOwnProperty.call(o,"raw"),h=!0,u=1===n?[]:{};if(1!==n)if(Object.defineProperty)try{Object.defineProperty(u,"__rowNum__",{value:r,enumerable:!1})}catch(e){u.__rowNum__=r}else u.__rowNum__=r;if(!i||e[r])for(var d=t.s.c;d<=t.e.c;++d){var p=i?e[r][d]:e[a[d]+c];if(void 0!==p&&void 0!==p.t){var m=p.v;switch(p.t){case"z":if(null==m)break;continue;case"e":m=0==m?null:void 0;break;case"s":case"d":case"b":case"n":break;default:throw new Error("unrecognized type "+p.t)}if(null!=s[d]){if(null==m)if("e"==p.t&&null===m)u[s[d]]=null;else if(void 0!==l)u[s[d]]=l;else{if(!f||null!==m)continue;u[s[d]]=null}else u[s[d]]=f&&("n"!==p.t||"n"===p.t&&!1!==o.rawNumbers)?m:ea(p,m,o);null!=m&&(h=!1)}}else void 0!==l&&null!=s[d]&&(u[s[d]]=l)}return{row:u,isempty:h}}function iu(e,t){if(null==e||null==e["!ref"])return[];var r,a={t:"n",v:0},n=0,s=1,i=[],o="",c={s:{r:0,c:0},e:{r:0,c:0}},l=t||{},f=null!=l.range?l.range:e["!ref"];switch(1===l.header?n=1:"A"===l.header?n=2:Array.isArray(l.header)?n=3:null==l.header&&(n=0),typeof f){case"string":c=Zr(f);break;case"number":(c=Zr(e["!ref"])).s.r=f;break;default:c=f}0<n&&(s=0);var h=jr(c.s.r),u=[],d=[],p=0,m=0,g=Array.isArray(e),b=c.s.r,v=0,w={};g&&!e[b]&&(e[b]=[]);for(var T,E=l.skipHidden&&e["!cols"]||[],k=l.skipHidden&&e["!rows"]||[],v=c.s.c;v<=c.e.c;++v)if(!(E[v]||{}).hidden)switch(u[v]=Xr(v),a=g?e[b][v]:e[u[v]+h],n){case 1:i[v]=v-c.s.c;break;case 2:i[v]=u[v];break;case 3:i[v]=l.header[v-c.s.c];break;default:if(o=r=ea(a=null==a?{w:"__EMPTY",t:"s"}:a,null,l),m=w[r]||0){for(;o=r+"_"+m++,w[o];);w[r]=m,w[o]=1}else w[r]=1;i[v]=o}for(b=c.s.r+s;b<=c.e.r;++b)(k[b]||{}).hidden||(!1!==(T=su(e,c,b,u,n,i,g,l)).isempty&&(1===n?!1===l.blankrows:!l.blankrows)||(d[p++]=T.row));return d.length=p,d}var ou=/"/g;function cu(e,t,r,a,n,s,i,o){for(var c=!0,l=[],f="",h=jr(r),u=t.s.c;u<=t.e.c;++u)if(a[u]){var d=o.dense?(e[r]||[])[u]:e[a[u]+h];if(null==d)f="";else if(null!=d.v){c=!1,f=""+(o.rawNumbers&&"n"==d.t?d.v:ea(d,null,o));for(var p,m=0;m!==f.length;++m)if((p=f.charCodeAt(m))===n||p===s||34===p||o.forceQuotes){f='"'+f.replace(ou,'""')+'"';break}"ID"==f&&(f='"ID"')}else null==d.f||d.F?f="":(c=!1,0<=(f="="+d.f).indexOf(",")&&(f='"'+f.replace(ou,'""')+'"'));l.push(f)}return!1===o.blankrows&&c?null:l.join(i)}function lu(e,t){var r=[],a=null==t?{}:t;if(null==e||null==e["!ref"])return"";var n=Zr(e["!ref"]),s=void 0!==a.FS?a.FS:",",i=s.charCodeAt(0),o=void 0!==a.RS?a.RS:"\n",c=o.charCodeAt(0),l=new RegExp(("|"==s?"\\|":s)+"+$"),f="",h=[];a.dense=Array.isArray(e);for(var u=a.skipHidden&&e["!cols"]||[],d=a.skipHidden&&e["!rows"]||[],p=n.s.c;p<=n.e.c;++p)(u[p]||{}).hidden||(h[p]=Xr(p));for(var m=0,g=n.s.r;g<=n.e.r;++g)(d[g]||{}).hidden||null!=(f=cu(e,n,g,h,i,c,s,a))&&(!(f=a.strip?f.replace(l,""):f)&&!1===a.blankrows||r.push((m++?o:"")+f));return delete a.dense,r.join("")}function fu(e,t){(t=t||{}).FS="\t",t.RS="\n";e=lu(e,t);if(void 0===re||"string"==t.type)return e;e=re.utils.encode(1200,e,"str");return String.fromCharCode(255)+String.fromCharCode(254)+e}function hu(e,t,r){var i,o=r||{},c=+!o.skipHeader,l=e||{},f=0,h=0;l&&null!=o.origin&&("number"==typeof o.origin?f=o.origin:(a="string"==typeof o.origin?Yr(o.origin):o.origin,f=a.r,h=a.c));var a,e={s:{c:0,r:0},e:{c:h,r:f+t.length-1+c}};l["!ref"]?(a=Zr(l["!ref"]),e.e.c=Math.max(e.e.c,a.e.c),e.e.r=Math.max(e.e.r,a.e.r),-1==f&&(f=a.e.r+1,e.e.r=f+t.length-1+c)):-1==f&&(f=0,e.e.r=t.length-1+c);var u=o.header||[],d=0;t.forEach(function(n,s){Re(n).forEach(function(e){-1==(d=u.indexOf(e))&&(u[d=u.length]=e);var t=n[e],r="z",a="",e=Kr({c:h+d,r:f+s+c});i=uu(l,e),!t||"object"!=typeof t||t instanceof Date?("number"==typeof t?r="n":"boolean"==typeof t?r="b":"string"==typeof t?r="s":t instanceof Date?(r="d",o.cellDates||(r="n",t=De(t)),a=o.dateNF||me[14]):null===t&&o.nullError&&(r="e",t=0),i?(i.t=r,i.v=t,delete i.w,delete i.R,a&&(i.z=a)):l[e]=i={t:r,v:t},a&&(i.z=a)):l[e]=t})}),e.e.c=Math.max(e.e.c,h+u.length-1);var n=jr(f);if(c)for(d=0;d<u.length;++d)l[Xr(d+h)+n]={t:"s",v:u[d]};return l["!ref"]=qr(e),l}function uu(e,t,r){if("string"!=typeof t)return uu(e,Kr("number"!=typeof t?t:{r:t,c:r||0}));if(Array.isArray(e)){r=Yr(t);return e[r.r]||(e[r.r]=[]),e[r.r][r.c]||(e[r.r][r.c]={t:"z"})}return e[t]||(e[t]={t:"z"})}function du(){return{SheetNames:[],Sheets:{}}}function pu(e,t,r,a){var n=1;if(!r)for(;n<=65535&&-1!=e.SheetNames.indexOf(r="Sheet"+n);++n,r=void 0);if(!r||65535<=e.SheetNames.length)throw new Error("Too many worksheets");if(a&&0<=e.SheetNames.indexOf(r)){var a=r.match(/(^.*?)(\d+)$/),n=a&&+a[2]||0,s=a&&a[1]||r;for(++n;n<=65535&&-1!=e.SheetNames.indexOf(r=s+n);++n);}if(Kl(r),0<=e.SheetNames.indexOf(r))throw new Error("Worksheet with name |"+r+"| already exists!");return e.SheetNames.push(r),e.Sheets[r]=t,r}function mu(e,t,r){return t?(e.l={Target:t},r&&(e.l.Tooltip=r)):delete e.l,e}var gu,Es={encode_col:Xr,encode_row:jr,encode_cell:Kr,encode_range:qr,decode_col:$r,decode_row:Gr,split_cell:function(e){return e.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(",")},decode_cell:Yr,decode_range:Jr,format_cell:ea,sheet_add_aoa:ra,sheet_add_json:hu,sheet_add_dom:eh,aoa_to_sheet:aa,json_to_sheet:function(e,t){return hu(null,e,t)},table_to_sheet:th,table_to_book:function(e,t){return ta(th(e,t),t)},sheet_to_csv:lu,sheet_to_txt:fu,sheet_to_json:iu,sheet_to_html:Qf,sheet_to_formulae:function(e){var t,r="",a="";if(null==e||null==e["!ref"])return[];for(var n,s=Zr(e["!ref"]),i=[],o=[],c=Array.isArray(e),l=s.s.c;l<=s.e.c;++l)i[l]=Xr(l);for(var f=s.s.r;f<=s.e.r;++f)for(n=jr(f),l=s.s.c;l<=s.e.c;++l)if(r=i[l]+n,a="",void 0!==(t=c?(e[f]||[])[l]:e[r])){if(null!=t.F){if(r=t.F,!t.f)continue;a=t.f,-1==r.indexOf(":")&&(r=r+":"+r)}if(null!=t.f)a=t.f;else{if("z"==t.t)continue;if("n"==t.t&&null!=t.v)a=""+t.v;else if("b"==t.t)a=t.v?"TRUE":"FALSE";else if(void 0!==t.w)a="'"+t.w;else{if(void 0===t.v)continue;a="s"==t.t?"'"+t.v:""+t.v}}o[o.length]=r+"="+a}return o},sheet_to_row_object_array:iu,sheet_get_cell:uu,book_new:du,book_append_sheet:pu,book_set_sheet_visibility:function(e,t,r){switch(e.Workbook||(e.Workbook={}),e.Workbook.Sheets||(e.Workbook.Sheets=[]),t=function(e,t){if("number"==typeof t){if(0<=t&&e.SheetNames.length>t)return t;throw new Error("Cannot find sheet # "+t)}if("string"!=typeof t)throw new Error("Cannot find sheet |"+t+"|");if(-1<(e=e.SheetNames.indexOf(t)))return e;throw new Error("Cannot find sheet name |"+t+"|")}(e,t),e.Workbook.Sheets[t]||(e.Workbook.Sheets[t]={}),r){case 0:case 1:case 2:break;default:throw new Error("Bad sheet visibility setting "+r)}e.Workbook.Sheets[t].Hidden=r},cell_set_number_format:function(e,t){return e.z=t,e},cell_set_hyperlink:mu,cell_set_internal_link:function(e,t,r){return mu(e,"#"+t,r)},cell_add_comment:function(e,t,r){e.c||(e.c=[]),e.c.push({t:t,a:r||"SheetJS"})},sheet_set_array_formula:function(e,t,r,a){for(var n="string"!=typeof t?t:Zr(t),s="string"==typeof t?t:qr(t),i=n.s.r;i<=n.e.r;++i)for(var o=n.s.c;o<=n.e.c;++o){var c=uu(e,i,o);c.t="n",c.F=s,delete c.v,i==n.s.r&&o==n.s.c&&(c.f=r,a&&(c.D=!0))}return e},consts:{SHEET_VISIBLE:0,SHEET_HIDDEN:1,SHEET_VERY_HIDDEN:2}};function bu(e){gu=e}var is={to_json:function(t,e){var r=gu({objectMode:!0});if(null==t||null==t["!ref"])return r.push(null),r;var a,n={t:"n",v:0},s=0,i=1,o=[],c="",l={s:{r:0,c:0},e:{r:0,c:0}},f=e||{},h=null!=f.range?f.range:t["!ref"];switch(1===f.header?s=1:"A"===f.header?s=2:Array.isArray(f.header)&&(s=3),typeof h){case"string":l=Zr(h);break;case"number":(l=Zr(t["!ref"])).s.r=h;break;default:l=h}0<s&&(i=0);var u=jr(l.s.r),d=[],p=0,m=Array.isArray(t),g=l.s.r,b=0,v={};m&&!t[g]&&(t[g]=[]);for(var w=f.skipHidden&&t["!cols"]||[],T=f.skipHidden&&t["!rows"]||[],b=l.s.c;b<=l.e.c;++b)if(!(w[b]||{}).hidden)switch(d[b]=Xr(b),n=m?t[g][b]:t[d[b]+u],s){case 1:o[b]=b-l.s.c;break;case 2:o[b]=d[b];break;case 3:o[b]=f.header[b-l.s.c];break;default:if(c=a=ea(n=null==n?{w:"__EMPTY",t:"s"}:n,null,f),p=v[a]||0){for(;c=a+"_"+p++,v[c];);v[a]=p,v[c]=1}else v[a]=1;o[b]=c}return g=l.s.r+i,r._read=function(){for(;g<=l.e.r;)if(!(T[g-1]||{}).hidden){var e=su(t,l,g,d,s,o,m,f);if(++g,!1===e.isempty||(1===s?!1!==f.blankrows:f.blankrows))return void r.push(e.row)}return r.push(null)},r},to_html:function(e,t){var r=gu(),a=t||{},t=null!=a.header?a.header:Jf,n=null!=a.footer?a.footer:qf;r.push(t);var s=Jr(e["!ref"]);a.dense=Array.isArray(e),r.push(Zf(0,0,a));var i=s.s.r,o=!1;return r._read=function(){if(i>s.e.r)return o||(o=!0,r.push("</table>"+n)),r.push(null);for(;i<=s.e.r;){r.push(Kf(e,s,i,a)),++i;break}},r},to_csv:function(e,t){var r=gu(),a=null==t?{}:t;if(null==e||null==e["!ref"])return r.push(null),r;var n=Zr(e["!ref"]),s=void 0!==a.FS?a.FS:",",i=s.charCodeAt(0),o=void 0!==a.RS?a.RS:"\n",c=o.charCodeAt(0),l=new RegExp(("|"==s?"\\|":s)+"+$"),f="",h=[];a.dense=Array.isArray(e);for(var u=a.skipHidden&&e["!cols"]||[],d=a.skipHidden&&e["!rows"]||[],p=n.s.c;p<=n.e.c;++p)(u[p]||{}).hidden||(h[p]=Xr(p));var m=n.s.r,g=!1,b=0;return r._read=function(){if(!g)return g=!0,r.push("\ufeff");for(;m<=n.e.r;)if(++m,!(d[m-1]||{}).hidden&&(f=cu(e,n,m-1,h,i,c,s,a),null!=f&&((f=a.strip?f.replace(l,""):f)||!1!==a.blankrows)))return r.push((b++?o:"")+f);return r.push(null)},r},set_readable:bu},vu=function(){function a(e,t,r){return this instanceof a?(this.tagName=e,this._attributes=t||{},this._children=r||[],this._prefix="",this):new a(e,t,r)}a.prototype.createElement=function(){return new a(arguments)},a.prototype.children=function(){return this._children},a.prototype.append=function(e){return this._children.push(e),this},a.prototype.prefix=function(e){return 0==arguments.length?this._prefix:(this._prefix=e,this)},a.prototype.attr=function(e,t){if(null==t)return delete this._attributes[e],this;if(0==arguments.length)return this._attributes;if("string"==typeof e&&1==arguments.length)return this._attributes.attr[e];if("object"==typeof e&&1==arguments.length)for(var r in e)this._attributes[r]=e[r];else 2==arguments.length&&"string"==typeof e&&(this._attributes[e]=t);return this};return a.prototype.escapeAttributeValue=function(e){return'"'+e.replace(/\"/g,"&quot;")+'"'},a.prototype.toXml=function(e){var t=(e=e||this)._prefix;if(t+="<"+e.tagName,e._attributes)for(var r in e._attributes)t+=" "+r+"="+this.escapeAttributeValue(""+e._attributes[r]);if(e._children&&0<e._children.length){t+=">";for(var a=0;a<e._children.length;a++)t+=this.toXml(e._children[a]);t+="</"+e.tagName+">"}else t+="/>";return t},a}(),wu=function(e){var t,r=164,a={0:"General",1:"0",2:"0.00",3:"#,##0",4:"#,##0.00",9:"0%",10:"0.00%",11:"0.00E+00",12:"# ?/?",13:"# ??/??",14:"m/d/yy",15:"d-mmm-yy",16:"d-mmm",17:"mmm-yy",18:"h:mm AM/PM",19:"h:mm:ss AM/PM",20:"h:mm",21:"h:mm:ss",22:"m/d/yy h:mm",37:"#,##0 ;(#,##0)",38:"#,##0 ;[Red](#,##0)",39:"#,##0.00;(#,##0.00)",40:"#,##0.00;[Red](#,##0.00)",45:"mm:ss",46:"[h]:mm:ss",47:"mmss.0",48:"##0.0E+0",49:"@",56:'"上午/下午 "hh"時"mm"分"ss"秒 "'},n={};for(t in a)n[a[t]]=t;var s={};return{initialize:function(e){this.$fonts=vu("fonts").attr("count",0).attr("x14ac:knownFonts","1"),this.$fills=vu("fills").attr("count",0),this.$borders=vu("borders").attr("count",0),this.$numFmts=vu("numFmts").attr("count",0),this.$cellStyleXfs=vu("cellStyleXfs"),this.$xf=vu("xf").attr("numFmtId",0).attr("fontId",0).attr("fillId",0).attr("borderId",0),this.$cellXfs=vu("cellXfs").attr("count",0),this.$cellStyles=vu("cellStyles").append(vu("cellStyle").attr("name","Normal").attr("xfId",0).attr("builtinId",0)),this.$dxfs=vu("dxfs").attr("count","0"),this.$tableStyles=vu("tableStyles").attr("count","0").attr("defaultTableStyle","TableStyleMedium9").attr("defaultPivotStyle","PivotStyleMedium4"),this.$styles=vu("styleSheet").attr("xmlns:mc","http://schemas.openxmlformats.org/markup-compatibility/2006").attr("xmlns:x14ac","http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac").attr("xmlns","http://schemas.openxmlformats.org/spreadsheetml/2006/main").attr("mc:Ignorable","x14ac").prefix('<?xml version="1.0" encoding="UTF-8" standalone="yes"?>').append(this.$numFmts).append(this.$fonts).append(this.$fills).append(this.$borders).append(this.$cellStyleXfs.append(this.$xf)).append(this.$cellXfs).append(this.$cellStyles).append(this.$dxfs).append(this.$tableStyles);var t=e.defaultCellStyle||{};t.font||(t.font={name:"Calibri",sz:"11"}),t.font.name||(t.font.name="Calibri"),t.font.sz||(t.font.sz=11),t.fill||(t.fill={patternType:"none",fgColor:{}}),t.border||(t.border={}),t.numFmt||(t.numFmt=0),this.defaultStyle=t;e=JSON.parse(JSON.stringify(t));return e.fill={patternType:"gray125",fgColor:{}},this.addStyles([t,e]),this},addStyle:function(e){var t=JSON.stringify(e),r=s[t];return null==r?(r=this._addXf(e),s[t]=r):r=s[t],r},addStyles:function(e){var t=this;return e.map(function(e){return t.addStyle(e)})},_duckTypeStyle:function(e){return"object"==typeof e&&(e.patternFill||e.fgColor)?{fill:e}:e.font||e.numFmt||e.border||e.fill?e:this._getStyleCSS(e)},_getStyleCSS:function(e){return e},_addXf:function(e){var t=this._addFont(e.font),r=this._addFill(e.fill),a=this._addBorder(e.border),n=this._addNumFmt(e.numFmt),s=vu("xf").attr("numFmtId",n).attr("fontId",t).attr("fillId",r).attr("borderId",a).attr("xfId","0");0<t&&s.attr("applyFont","1"),0<r&&s.attr("applyFill","1"),0<a&&s.attr("applyBorder","1"),0<n&&s.attr("applyNumberFormat","1"),e.alignment&&(n=vu("alignment"),e.alignment.horizontal&&n.attr("horizontal",e.alignment.horizontal),e.alignment.vertical&&n.attr("vertical",e.alignment.vertical),e.alignment.indent&&n.attr("indent",e.alignment.indent),e.alignment.readingOrder&&n.attr("readingOrder",e.alignment.readingOrder),e.alignment.wrapText&&n.attr("wrapText",e.alignment.wrapText),null!=e.alignment.textRotation&&n.attr("textRotation",e.alignment.textRotation),s.append(n).attr("applyAlignment",1)),this.$cellXfs.append(s);s=+this.$cellXfs.children().length;return this.$cellXfs.attr("count",s),s-1},_addFont:function(e){if(!e)return 0;var t=vu("font").append(vu("sz").attr("val",e.sz||this.defaultStyle.font.sz)).append(vu("name").attr("val",e.name||this.defaultStyle.font.name));e.bold&&t.append(vu("b")),e.underline&&t.append(vu("u")),e.italic&&t.append(vu("i")),e.strike&&t.append(vu("strike")),e.outline&&t.append(vu("outline")),e.shadow&&t.append(vu("shadow")),e.vertAlign&&t.append(vu("vertAlign").attr("val",e.vertAlign)),e.color&&(e.color.theme?(t.append(vu("color").attr("theme",e.color.theme)),e.color.tint&&t.append(vu("tint").attr("theme",e.color.tint))):e.color.rgb&&t.append(vu("color").attr("rgb",e.color.rgb))),this.$fonts.append(t);t=this.$fonts.children().length;return this.$fonts.attr("count",t),t-1},_addNumFmt:function(e){if(!e)return 0;if("string"==typeof e){var t=n[e];if(0<=t)return t}if(/^[0-9]+$/.exec(e))return e;e=e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&apos;");e=vu("numFmt").attr("numFmtId",++r).attr("formatCode",e);this.$numFmts.append(e);e=this.$numFmts.children().length;return this.$numFmts.attr("count",e),r},_addFill:function(e){if(!e)return 0;var t,r=vu("patternFill").attr("patternType",e.patternType||"solid");e.fgColor&&(t=vu("fgColor"),e.fgColor.rgb?(6==e.fgColor.rgb.length&&(e.fgColor.rgb="FF"+e.fgColor.rgb),t.attr("rgb",e.fgColor.rgb),r.append(t)):e.fgColor.theme&&(t.attr("theme",e.fgColor.theme),e.fgColor.tint&&t.attr("tint",e.fgColor.tint),r.append(t)),e.bgColor||(e.bgColor={indexed:"64"})),e.bgColor&&(e=vu("bgColor").attr(e.bgColor),r.append(e));r=vu("fill").append(r);this.$fills.append(r);r=this.$fills.children().length;return this.$fills.attr("count",r),r-1},_getSubBorder:function(e,t){var r=vu(e);return t&&(r.attr("style",t.style||"medium"),t.color&&(e=vu("color"),t.color.auto?e.attr("auto",t.color.auto):t.color.rgb?e.attr("rgb",t.color.rgb):(t.color.theme||t.color.tint)&&(e.attr("theme",t.color.theme||"1"),e.attr("tint",t.color.tint||"0")),r.append(e))),r},_addBorder:function(t){if(!t)return 0;var r=this,a=vu("border").attr("diagonalUp",t.diagonalUp).attr("diagonalDown",t.diagonalDown);["left","right","top","bottom","diagonal"].forEach(function(e){a.append(r._getSubBorder(e,t[e]))}),this.$borders.append(a);var e=this.$borders.children().length;return this.$borders.attr("count",e),e-1},toXml:function(){return this.$styles.toXml()}}.initialize(e||{})};void 0!==Nf&&(a.parse_xlscfb=Nf),a.parse_zip=zh,a.read=Kh,a.readFile=Jh,a.readFileSync=Jh,a.write=ru,a.writeFile=nu,a.writeFileSync=nu,a.writeFileAsync=function(e,t,r,a){var n=r||{};return n.type="file",n.file=e,au(n),n.type="buffer",a instanceof Function||(a=r),Se.writeFile(e,ru(t,n),a)},a.utils=Es,a.writeXLSX=tu,a.writeFileXLSX=function(e,t,r){return(r=r||{}).type="file",r.file=t,au(r),tu(e,r)},a.SSF=e,void 0!==is&&(a.stream=is),void 0!==xe&&(a.CFB=xe),"undefined"==typeof require||((is=require("stream"))||{}).Readable&&bu(is.Readable)}if("undefined"!=typeof exports?make_xlsx_lib(exports):"undefined"!=typeof module&&module.exports?make_xlsx_lib(module.exports):"function"==typeof define&&define.amd?define("xlsx",function(){return XLSX.version||make_xlsx_lib(XLSX),XLSX}):make_xlsx_lib(XLSX),"undefined"!=typeof window&&!window.XLSX)try{window.XLSX=XLSX}catch(e){}


})();
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('Spartan.theme')
	.config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
	$provide.decorator('$uiViewScroll', uiViewScrollDecorator);
	//baConfigProvider.changeTheme({blur: true});
	//
	//baConfigProvider.changeColors({
	//  default: 'rgba(#000000, 0.2)',
	//  defaultText: '#ffffff',
	//  dashboard: {
	//    white: '#ffffff',
	//  },
	//});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
	return function (uiViewElement) {
	  if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
		$anchorScroll();
	  } else {
		$delegate(uiViewElement);
	  }
	};
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
	default: '#ffffff',
	defaultText: '#666666',
	border: '#dddddd',
	borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
	primary: '#209e91',
	info: '#2dacd1',
	success: '#90b900',
	warning: '#dfb81c',
	danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
	blueStone: '#005562',
	surfieGreen: '#0e8174',
	silverTree: '#6eba8c',
	gossip: '#b9f2a1',
	white: '#10c4b5',
  };

  angular.module('Spartan.theme')
	.provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
	var conf = {
	  theme: {
		blur: false,
	  },
	  colors: {
		default: basic.default,
		defaultText: basic.defaultText,
		border: basic.border,
		borderDark: basic.borderDark,

		primary: colorScheme.primary,
		info: colorScheme.info,
		success: colorScheme.success,
		warning: colorScheme.warning,
		danger: colorScheme.danger,

		primaryLight: colorHelper.tint(colorScheme.primary, 30),
		infoLight: colorHelper.tint(colorScheme.info, 30),
		successLight: colorHelper.tint(colorScheme.success, 30),
		warningLight: colorHelper.tint(colorScheme.warning, 30),
		dangerLight: colorHelper.tint(colorScheme.danger, 30),

		primaryDark: colorHelper.shade(colorScheme.primary, 15),
		infoDark: colorHelper.shade(colorScheme.info, 15),
		successDark: colorHelper.shade(colorScheme.success, 15),
		warningDark: colorHelper.shade(colorScheme.warning, 15),
		dangerDark: colorHelper.shade(colorScheme.danger, 15),

		dashboard: {
		  blueStone: dashboardColors.blueStone,
		  surfieGreen: dashboardColors.surfieGreen,
		  silverTree: dashboardColors.silverTree,
		  gossip: dashboardColors.gossip,
		  white: dashboardColors.white,
		},
	  }
	};

	conf.changeTheme = function(theme) {
	  angular.extend(conf.theme, theme);
	};

	conf.changeColors = function(colors) {
	  angular.extend(conf.colors, colors);
	};

	conf.$get = function () {
	  delete conf.$get;
	  return conf;
	};
	return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('Spartan.theme')
	.constant('layoutSizes', {
	  resWidthCollapseSidebar: 1200,
	  resWidthHideSidebar: 550
	})
	.constant('layoutPaths', {
	  images: {
		root: IMAGES_ROOT,
		profile: IMAGES_ROOT + 'app/profile/',
		amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
		amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
	  }
	})
	.constant('colorHelper', {
	  tint: function(color, weight) {
		return mix('#ffffff', color, weight);
	  },
	  shade: function(color, weight) {
		return mix('#000000', color, weight);
	  },
	});

  function shade(color, weight) {
	return mix('#000000', color, weight);
  }

  function tint(color, weight) {
	return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
	// convert a decimal value to hex
	function d2h(d) {
	  return d.toString(16);
	}
	// convert a hex value to decimal
	function h2d(h) {
	  return parseInt(h, 16);
	}

	var result = "#";
	for(var i = 1; i < 7; i += 2) {
	  var color1Part = h2d(color1.substr(i, 2));
	  var color2Part = h2d(color2.substr(i, 2));
	  var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
	  result += ('0' + resultPart).slice(-2);
	}
	return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
	'use strict';
	angular.module('Spartan.theme').run(themeRun);

	/** @ngInject */
	function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
		var whatToWait = [
			preloader.getUserAccess(),
			$timeout(30)
		]

		whatToWait.unshift(preloader.setViewport());
		whatToWait.unshift(preloader.setLanguage());

		var theme = themeLayoutSettings;
		if (theme.blur) {
			if (theme.mobile) {
				whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
			} else {
				whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
				whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
			}
		}


		$q.all(whatToWait).then(function () {
			$rootScope.$pageFinishedLoading = true;
		})

		$timeout(function () {
			if (!$rootScope.$pageFinishedLoading) {
				$rootScope.$pageFinishedLoading = true;
			}
		}, 30000)

		$rootScope.$baSidebarService = baSidebarService;
	}
})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('Spartan.theme')
	.service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
	var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
	var mobileClass = isMobile ? 'mobile' : '';
	var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
	angular.element(document.body).addClass(mobileClass).addClass(blurClass);

	return {
	  blur: baConfig.theme.blur,
	  mobile: isMobile,
	}
  }

})();

(function () {
	'use strict';
	angular.module('Spartan.components').component('infoPopover', {
		templateUrl: 'app/components/infoPopoverComponent/infoPopover.component.html',
		controller: 'infoPopoverCtrl',
		controllerAs: 'vm',
		bindings: {
			title: '@',
			subtitle: '@',
			items: '=',
			size: '@',
			appendToBody: '@',
			popoverPlacement: '@',
			popoverTrigger: '@',
			infoPopoverClass: '@',
			loading: '='
		}
	});
})();

(function () {
	'use strict';
	angular.module('Spartan.components').controller('infoPopoverCtrl', infoPopoverCtrl);
	/** @ngInject */
	function infoPopoverCtrl() {
		var vm = this;

		vm.$onInit = function () {
			setIconStyle();
		};

		function setIconStyle() {
			switch (vm.size) {
			case 'small':
				vm.iconStyle = {
					fontSize: '18px'
				};
				break;
			case 'medium':
				vm.iconStyle = {
					fontSize: '24px'
				};
				break;
			case 'large':
				vm.iconStyle = {
					fontSize: '30px'
				};
				break;
			default:
				vm.iconStyle = {
					fontSize: '18px'
				};
				break;
			}
		}
	}
})();

/* eslint-disable quotes */
(function () {
	'use strict';
	angular.module('Spartan').constant('APP_CONST', {
		//localhost testing
		// api_base_url: 'http://localhost:8080/api/v1/',
		// api_domen: 'localhost',
		// environment: 'Test',
		// backoffice_base_url: 'http://localhost:8080/api/v1/backoffice/',
		// database: 'Database: Localhost',

		//local for testing
		//api_base_url: 'http://192.168.1.8:8080/api/v1/',
		//api_domen: '192.168.1.8',
		//environment: 'Test',
		//backoffice_base_url: 'http://192.168.1.8:8080/api/v1/backoffice/',
		//database: 'Database: Localtest',

		//feed-production
		api_base_url: 'https://feed-api.mmmooogle.com/Spartan/api/v1/',
		api_domen: 'feed-api.mmmooogle.com',
		environment: 'Feed production',
		analytics_key: 'G-9DZN6R3K5S',
		backoffice_base_url: 'https://feed-api.mmmooogle.com/Spartan/api/v1/backoffice/',
		database: 'Database: Production',

		//staging
		//api_base_url: 'https://feed-staging-api.mmmooogle.com/Spartan/api/v1/',
		//api_domen: 'feed-staging-api.mmmooogle.com',
		//environment: 'Feed staging',
		//analytics_key: 'G-89Q4WDVTTE',
		//backoffice_base_url: 'https://feed-staging-api.mmmooogle.com/Spartan/api/v1/backoffice/',
		//database: 'Database: Staging',

		//development
		//api_base_url: 'https://feed-dev-api.mmmooogle.com/api/v1/',
		//api_domen: 'feed-dev-api.mmmooogle.com',
		//environment: 'Feed dev',
		//analytics_key: 'G-89Q4WDVTTE',
		//backoffice_base_url: 'https://feed-dev-api.mmmooogle.com/api/v1/backoffice/',
		//database: 'Database: Development',

		//----------------------------------------------------------------------------

		//Tableau
		//production
		//tableau_base_url: 'https://tabvis-prd.mmmooogle.com/api/v1/teams/',
		//tableau_domen: 'tabvis-prd.mmmooogle.com',
		//tableau_reports_base_url: 'https://tabvis-prd.mmmooogle.com/api/v1/reports',

		//New tableau production
		tableau_base_url: 'https://tabvis-prd-new.mmmooogle.com/api/v1/teams/',
		tableau_domen: 'tabvis-prd-new.mmmooogle.com',
		tableau_reports_base_url: 'https://tabvis-prd-new.mmmooogle.com/api/v1/reports',

		//staging
		//tableau_base_url: 'https://tabvis-stg.mmmooogle.com/api/v1/teams/',
		//tableau_domen: 'tabvis-stg.mmmooogle.com',
		//tableau_reports_base_url: 'https://tabvis-stg.mmmooogle.com/api/v1/reports',

		//development
		//tableau_base_url: 'https://tabvis-dev.mmmooogle.com/api/v1/teams/',
		//tableau_domen: 'tabvis-dev.mmmooogle.com',
		//tableau_reports_base_url: 'https://tabvis-dev.mmmooogle.com/api/v1/reports',

		//----------------------------------------------------------------------------

		//calendar
		animals_base_url: 'https://animals.mmmooogle.com/api/v1/',
		animals_domen: 'animals.mmmooogle.com',

		//do not change this value manually
		buildTimeStamp: '1782390436436',
		mocks: {
			breeds: [
				{
					id: 'br1',
					name: 'Ayrshire',
					value: 'ayrshire'
				},
				{
					id: 'br2',
					name: 'Brown Swiss',
					value: 'brown_swiss'
				},
				{
					id: 'br3',
					name: 'Guernsey',
					value: 'guernsey'
				},
				{
					id: 'br4',
					name: 'Holstein',
					value: 'holstein'
				},
				{
					id: 'br5',
					name: 'Jersey',
					value: 'jersey'
				},
				{
					id: 'br6',
					name: 'Large breed',
					value: 'large_breed'
				},
				{
					id: 'br7',
					name: 'Midsize breed',
					value: 'midsize_breed'
				},
				{
					id: 'br8',
					name: 'Small breed',
					value: 'small_breed'
				}
			],
			animal_types: [
				{
					id: 'ty1',
					name: 'Heifer',
					type: 'heifer'
				},
				{
					id: 'ty2',
					name: 'Lactating cow',
					type: 'lactating_cow'
				},
				{
					id: 'ty3',
					name: 'Dry cow/Late pregnant heifer',
					type: 'drycow/late_pregnant_heifer'
				}
			],
			cow_stages: [
				{
					id: 'cs1',
					name: 'Fresh cow',
					value: 'fresh_cow',
					type: 'lactating_cow'
				},
				{
					id: 'cs2',
					name: 'Early lactation cow',
					value: 'early_lac_cow',
					type: 'lactating_cow'
				},
				{
					id: 'cs3',
					name: 'Mid lactation cow',
					value: 'mid_lac_cow',
					type: 'lactating_cow'
				},
				{
					id: 'cs4',
					name: 'Late lactation cow',
					value: 'late_lac_cow',
					type: 'lactating_cow'
				},
				{
					id: 'cs5',
					name: 'Pre dry',
					value: 'pre_dry_cow',
					type: 'lactating_cow'
				},
				{
					id: 'cs6',
					name: 'Dry cow',
					value: 'dry_cow',
					type: 'drycow/late_pregnant_heifer'
				},
				{
					id: 'cs7',
					name: 'Close-up cow',
					value: 'close_up_cow',
					type: 'drycow/late_pregnant_heifer'
				},
				{
					id: 'cs8',
					name: 'Pregnant heifer',
					value: 'pregnant_heifer',
					type: 'drycow/late_pregnant_heifer'
				},
				{
					id: 'cs9',
					name: 'Close-up heifer',
					value: 'close_up_heifer',
					type: 'drycow/late_pregnant_heifer'
				}
			]
		},
		constants: {
			tags: [
				{
					value: null,
					label: '',
					trackByIndex: 0
				},
				{
					value: 'BCS',
					label: 'BCS',
					group: 'All',
					trackByIndex: 1
				},
				{
					value: 'BiosecurityPlan',
					label: 'Biosecurity Plan',
					group: 'All',
					trackByIndex: 2
				},
				{
					value: 'BullsBloodlines',
					label: 'Bulls Bloodlines',
					group: 'All',
					trackByIndex: 3
				},
				{
					value: 'Calved',
					label: 'Calved',
					group: 'All',
					trackByIndex: 4
				},
				{
					value: 'Collars',
					label: 'Collars',
					group: 'All',
					trackByIndex: 5
				},
				{
					value: 'CowsDueToCalve',
					label: 'Cows Due To Calve',
					group: 'All',
					trackByIndex: 6
				},
				{
					value: 'DailyReport',
					label: 'Daily Report',
					group: 'All',
					trackByIndex: 7
				},
				{
					value: 'Dead',
					label: 'Dead',
					group: 'All',
					trackByIndex: 8
				},
				{
					value: 'DeliveryDocuments',
					label: 'Delivery Documents',
					group: 'All',
					trackByIndex: 9
				},
				{
					value: 'DiscardedMilk',
					label: 'Discarded Milk',
					group: 'All',
					trackByIndex: 10
				},
				{
					value: 'Disease',
					label: 'Disease',
					group: 'All',
					trackByIndex: 11
				},
				{
					value: 'Prevention',
					label: 'Prevention',
					group: 'All',
					trackByIndex: 12
				},
				{
					value: 'DrugResidueTesting',
					label: 'Drug Residue Testing',
					group: 'All',
					trackByIndex: 13
				},
				{
					value: 'EmbryotransferCalf',
					label: 'Embryotransfer Calf',
					group: 'All',
					trackByIndex: 14
				},
				{
					value: 'Feedbunks',
					label: 'Feedbunks',
					group: 'All',
					trackByIndex: 15
				},
				{
					value: 'FeedingCalvesBeforeWeaning',
					label: 'Feeding Calves Before Weaning',
					group: 'All',
					trackByIndex: 16
				},
				{
					value: 'Footbath',
					label: 'Footbath',
					group: 'All',
					trackByIndex: 17
				},
				{
					value: 'FreshCows',
					label: 'FreshCows',
					group: 'All',
					trackByIndex: 18
				},
				{
					value: 'GeneticProspects',
					label: 'Genetic Prospects',
					group: 'All',
					trackByIndex: 19
				},
				{
					value: 'Heat',
					label: 'Heat',
					group: 'All',
					trackByIndex: 20
				},
				{
					value: 'HighGenomicAnimal',
					label: 'High Genomic Animal',
					group: 'All',
					trackByIndex: 21
				},
				{
					value: 'HighProductionAtDryingOff',
					label: 'High Production At Drying Off',
					group: 'All',
					trackByIndex: 22
				},
				{
					value: 'HighMaintenanceCowFertility',
					label: 'High Maintenance Cow Fertility',
					group: 'All',
					trackByIndex: 23
				},
				{
					value: 'HighMaintenanceCowLameness',
					label: 'High Maintenance Cow Lameness',
					group: 'All',
					trackByIndex: 24
				},
				{
					value: 'HighMaintenanceCowMisc',
					label: 'High Maintenance Cow Misc',
					group: 'All',
					trackByIndex: 25
				},
				{
					value: 'HighMaintenanceCowUdderhealth',
					label: 'High Maintenance Cow Udder health',
					group: 'All',
					trackByIndex: 26
				},
				{
					value: 'Hospital',
					label: 'Hospital',
					group: 'All',
					trackByIndex: 27
				},
				{
					value: 'HygienePlan',
					label: 'Hygiene Plan',
					group: 'All',
					trackByIndex: 28
				},
				{
					value: 'ListPredryDiet',
					label: 'List Predry Diet',
					group: 'All',
					trackByIndex: 29
				},
				{
					value: 'Milk',
					label: 'Milk',
					group: 'All',
					trackByIndex: 30
				},
				{
					value: 'Milktank',
					label: 'Milktank',
					group: 'All',
					trackByIndex: 31
				},
				{
					value: 'NewbornCalves',
					label: 'Newborn Calves',
					group: 'All',
					trackByIndex: 32
				},
				{
					value: 'PlanningPersonnel',
					label: 'Planning Personnel',
					group: 'All',
					trackByIndex: 33
				},
				{
					value: 'ProceduresCleaning',
					label: 'Procedures Cleaning',
					group: 'All',
					trackByIndex: 34
				},
				{
					value: 'ProceduresBulkTank',
					label: 'Procedures Bulk Tank',
					group: 'All',
					trackByIndex: 35
				},
				{
					value: 'ProceduresManagementSop',
					label: 'Procedures Management Sop',
					group: 'All',
					trackByIndex: 36
				},
				{
					value: 'ProceduresMilking',
					label: 'Procedures Milking',
					group: 'All',
					trackByIndex: 37
				},
				{
					value: 'Proceduresmilking_parlour',
					label: 'Procedures milking Parlour',
					group: 'All',
					trackByIndex: 38
				},
				{
					value: 'ProceduresPhotos',
					label: 'Procedures Photos',
					group: 'All',
					trackByIndex: 39
				},
				{
					value: 'ProfilePicture',
					label: 'Profile Picture',
					group: 'All',
					trackByIndex: 40
				},
				{
					value: 'ProtocolsTreatments',
					label: 'Protocols Treatments',
					group: 'All',
					trackByIndex: 41
				},
				{
					value: 'PurchaseMedicines',
					label: 'Purchase Medicines',
					group: 'All',
					trackByIndex: 42
				},
				{
					value: 'SemenStock',
					label: 'Semen Stock',
					group: 'All',
					trackByIndex: 43
				},
				{
					value: 'SiloManagment',
					label: 'Silo Managment',
					group: 'All',
					trackByIndex: 44
				},
				{
					value: 'SoldOtherHerd',
					label: 'Sold Other Herd',
					group: 'All',
					trackByIndex: 45
				},
				{
					value: 'SoldToSlaughterhouse',
					label: 'Sold To Slaughter house',
					group: 'All',
					trackByIndex: 46
				},
				{
					value: 'SyncProgramManagement',
					label: 'Sync Program Management',
					group: 'All',
					trackByIndex: 47
				},
				{
					value: 'TMRManagementCows',
					label: 'TMR Management Cows',
					group: 'All',
					trackByIndex: 48
				},
				{
					value: 'TMRManagementYoungstock',
					label: 'TMR Management Youngstock',
					group: 'All',
					trackByIndex: 49
				},
				{
					value: 'ToBeCulled',
					label: 'To Be Culled',
					group: 'All',
					trackByIndex: 50
				},
				{
					value: 'ToBeDriedOff',
					label: 'To Be DriedOff',
					group: 'All',
					trackByIndex: 51
				},
				{
					value: 'ToBeExamined',
					label: 'To Be Examined',
					group: 'All',
					trackByIndex: 52
				},
				{
					value: 'ToBeInseminated',
					label: 'To Be Inseminated',
					group: 'All',
					trackByIndex: 53
				},
				{
					value: 'ToBeTreated',
					label: 'To Be Treated',
					group: 'All',
					trackByIndex: 54
				},
				{
					value: 'ToBeTrimmed',
					label: 'To Be Trimmed',
					group: 'All',
					trackByIndex: 55
				},
				{
					value: 'ToCalve',
					label: 'To Calve',
					group: 'All',
					trackByIndex: 56
				},
				{
					value: 'TreatedCalves',
					label: 'Treated Calves',
					group: 'All',
					trackByIndex: 57
				},
				{
					value: 'TreatedCows',
					label: 'Treated Cows',
					group: 'All',
					trackByIndex: 58
				},
				{
					value: 'TreatedMastitis',
					label: 'Treated Mastitis',
					group: 'All',
					trackByIndex: 59
				}
			],
			visuals: {
				production: [
					{
						id: 'Recent-milk-recordings'
					},
					{
						id: 'Milk-recording-(10Y)'
					},
					{
						id: 'Milk-recording-(5Y)'
					},
					{
						id: 'Fresh-cow'
					},
					{
						id: 'Milk-deviations'
					},
					{
						id: 'Milk-Alerts'
					},
					{
						id: 'Milk-meter-2'
					},
					{
						id: 'Milk-meter'
					}
				],
				reproduction: [
					{
						id: 'First-insemination-strategy'
					},
					{
						id: 'Conception-Rate'
					},
					{
						id: 'Reproduction-cows'
					},
					{
						id: 'Reproduction-heifers'
					}
				],
				udder_health: [
					{
						id: 'Genetic-SCC-evaluation'
					},
					{
						id: 'Mastitis-dashboard'
					},
					{
						id: 'Transition-cow-cellcount-analysis'
					},
					{
						id: 'General-cellcount-analysis'
					}
				],
				hoof_health: [
					{
						id: 'Hoof-trim'
					},
					{
						id: 'Trim-overview'
					},
					{
						id: 'Trim-vs-calved-overview'
					}
				],
				herd_charachteristics: [
					{
						id: 'Herd-inventory'
					}
				],
				comments: [
					{
						id: 'Comments-last-week'
					},
					{
						id: 'Comments-last-month'
					}
				],
				environmental: [
					{
						id: 'Temperature-Humidity-Index-Quarter'
					},
					{
						id: 'Temperature-Humidity-Index-Month'
					},
					{
						id: 'Temperature-Humidity-Index'
					},
					{
						id: 'Daily-carbon-footprint'
					}
				],
				genetics: [
					{
						id: 'Genetic-Prod-Life-progress'
					},
					{
						id: 'Sire-evaluation'
					},
					{
						id: 'Genetic-DPR-progress'
					},
					{
						id: 'Genetic-production-evaluation'
					},
					{
						id: 'Genetic-company-overview'
					}
				],
				other: [
					{
						id: 'Lactation-analysis-last-year'
					},
					{
						id: 'Teatsealer-dashboard'
					},
					{
						id: 'Kexxtone-dashboard'
					},
					{
						id: 'Calving-Pattern'
					},
					{
						id: 'High-genomic-animals'
					}
				]
			},
			feed_types: [
				{
					value: 'dry_forage',
					name: 'Dry forage',
					category: 'DF',
					type: 0
				},
				{
					value: 'corn_silage',
					name: 'Corn silage',
					category: 'WF',
					type: 0
				},
				{
					value: 'alfa_silage',
					name: 'Alfalfa silage',
					category: 'WF',
					type: 0
				},
				{
					value: 'grass_silage',
					name: 'Grass silage',
					category: 'WF',
					type: 0
				},
				{
					value: 'other_wet_forage',
					name: 'Other wet forage',
					category: 'WF',
					type: 0
				},
				{
					value: 'by_product',
					name: 'By-product',
					category: 'C',
					type: 2
				},
				{
					value: 'grain',
					name: 'Grain',
					category: 'C',
					type: 0
				},
				{
					value: 'fatty_acid_source',
					name: 'Fatty acid source',
					category: 'FA',
					type: 0
				},
				{
					value: 'triglycerides',
					name: 'Triglycerides',
					category: 'TRI',
					type: 0
				},
				{
					value: 'cp_source',
					name: 'CP source',
					category: 'C',
					type: 0
				},
				{
					value: 'rup_source',
					name: 'RUP source',
					category: 'C',
					type: 0
				},
				{
					value: 'mineral',
					name: 'Mineral',
					category: 'C',
					type: 2
				},
				{
					value: 'miscellaneous',
					name: 'Miscellaneous',
					category: 'C',
					type: 2
				},
				{
					value: 'vitamin',
					name: 'Vitamin',
					category: 'C',
					type: 0
				},
				{
					value: 'mix',
					name: 'Mix',
					category: 'MIX',
					type: 2
				},
				{
					value: 'forage',
					name: 'Forage',
					category: 'Forage',
					type: 1
				},
				{
					value: 'concentrate',
					name: 'Concentrate',
					category: 'Concentrate',
					type: 1
				},
				{
					value: 'commercial',
					name: 'Commercial',
					category: 'Commercial',
					type: 1
				},
				{
					value: 'premix',
					name: 'Premix',
					category: 'MIX',
					type: 2
				},
				{
					value: 'water',
					name: 'Water',
					category: 'C',
					type: 2
				}
			],
			languages: [
				{
					name: 'English ($)',
					code: 'en-us',
					image: 'us.png'
				},
				{
					name: 'English (€)',
					code: 'en-gb',
					image: 'gb.png'
				},
				{
					name: 'Nederlands (€)',
					code: 'nl-nl',
					image: 'nl.png'
				},
				{
					name: 'Deutsch (€)',
					code: 'de-de',
					image: 'de.png'
				},
				{
					name: 'Czech (K\u010d)',
					code: 'cs-cz',
					image: 'cz.png'
				},
				{
					name: 'Español (\u20ac)',
					code: 'es-es',
					image: 'es.png'
				},
				{
					name: 'Italiano (€)',
					code: 'it-it',
					image: 'it.png'
				},
				{
					name: 'Polski (z\u0142)',
					code: 'pl-pl',
					image: 'pl.png'
				},
				{
					name: 'Português (R$)',
					code: 'pt-br',
					image: 'br.png'
				}
			],
			temperature_stresses: [
				{
					name: 'Severe cold',
					value: '_ts_severe_cold_',
					ts_dmi: 110.56,
					ts_maint_energy: 130
				},
				{
					name: 'Moderate cold',
					value: '_ts_moderate_cold_',
					ts_dmi: 107.4,
					ts_maint_energy: 120
				},
				{
					name: 'Mild cold',
					value: '_ts_mild_cold_',
					ts_dmi: 103.52,
					ts_maint_energy: 110
				},
				{
					name: 'Thermoneutral zone',
					value: '_ts_thermoneutral_zone_',
					ts_dmi: 100,
					ts_maint_energy: 100
				},
				{
					name: 'Mild heat',
					value: '_ts_mild_heat_',
					ts_dmi: 90,
					ts_maint_energy: 107
				},
				{
					name: 'Moderate heat',
					value: '_ts_moderate_heat_',
					ts_dmi: 80,
					ts_maint_energy: 114
				},
				{
					name: 'Severe heat',
					value: '_ts_severe_heat_',
					ts_dmi: 70,
					ts_maint_energy: 121
				}
			],
			activity_levels: [
				{
					name: 'No work',
					value: '_al_no_work_',
					al_dmi: 100,
					al_maint_energy: 100
				},
				{
					name: 'Light work',
					value: '_al_light_work_',
					al_dmi: 107.4,
					al_maint_energy: 120
				},
				{
					name: 'Moderate work',
					value: '_al_moderate_work_',
					al_dmi: 114.09,
					al_maint_energy: 140
				},
				{
					name: 'Extreme work',
					value: '_al_extreme_work_',
					al_dmi: 121.13,
					al_maint_energy: 160
				}
			],
			feed_additives: [
				{
					name: 'None',
					value: '_fa_none_',
					energetic_efficiency: 100,
					mic_protein_efficiency: 100,
					rup_efficiency: 100,
					dmi_factor: 100,
					maint_reqt: 100
				},
				{
					name: 'Ionophore',
					value: '_fa_ionophore_',
					energetic_efficiency: 102,
					mic_protein_efficiency: 102,
					rup_efficiency: 102,
					dmi_factor: 98,
					maint_reqt: 100
				}
			],
			met_prot_sys: [
				{
					value: 'Spartan 3 Defaults',
					name: '_mps_spartan_3_defaults_',
					energy_potential: 0.13,
					nitrogen_potential: 0.75
				},
				{
					value: 'Spartan 3',
					name: '_mps_spartan_3_',
					energy_potential: 0.13,
					nitrogen_potential: 0.75
				},
				{
					value: 'RDOM',
					name: '_mps_rdom_',
					energy_potential: 30,
					nitrogen_potential: 0.9
				}
			],

			feed_us_types: [
				{
					name: '_feeds_type_all_',
					value: null
				},
				{
					name: '_feeds_type_dry_forage_',
					value: 'Dry forage',
					category: 'DF'
				},
				{
					name: '_feeds_type_corn_silage_',
					value: 'Corn silage',
					category: 'WF'
				},
				{
					name: '_feeds_type_alfa_silage_',
					value: 'Alfalfa silage',
					category: 'WF'
				},
				{
					name: '_feeds_type_grass_silage_',
					value: 'Grass silage',
					category: 'WF'
				},
				{
					name: '_feeds_type_other_wet_forage_',
					value: 'Other wet forage',
					category: 'WF'
				},
				{
					name: '_feeds_type_by_product_',
					value: 'By-product',
					category: 'C'
				},
				{
					name: '_feeds_type_grain_',
					value: 'Grain',
					category: 'C'
				},
				{
					name: '_feeds_type_fatty_acid_source_',
					value: 'Fatty acid source',
					category: 'FA'
				},
				{
					name: '_feeds_type_triglycerides_',
					value: 'Triglycerides',
					category: 'TRI'
				},
				{
					name: '_feeds_type_cp_source_',
					value: 'CP source',
					category: 'C'
				},
				{
					name: '_feeds_type_rup_source_',
					value: 'RUP source',
					category: 'C'
				},
				{
					name: '_feeds_type_mineral_',
					value: 'Mineral',
					category: 'C'
				},
				{
					name: '_feeds_type_miscellaneous_',
					value: 'Miscellaneous',
					category: 'C'
				},
				{
					name: '_feeds_type_vitamin_',
					value: 'Vitamin',
					category: 'C'
				},
				{
					name: '_feeds_type_mix_',
					value: 'Mix',
					category: 'MIX'
				}
			],
			feed_vem_types: [
				{
					name: '_feeds_type_all_',
					value: null
				},
				{
					name: '_feeds_type_by_product_',
					value: 'By-product',
					category: 'C'
				},
				{
					name: '_feeds_type_mineral_',
					value: 'Mineral',
					category: 'C'
				},
				{
					name: '_feeds_type_forage_',
					value: 'Forage',
					category: 'Forage'
				},
				{
					name: '_feeds_type_concentrate_',
					value: 'Concentrate',
					category: 'Concentrate'
				},
				{
					name: '_feeds_type_commercial_',
					value: 'Commercial',
					category: 'Commercial'
				},
				{
					name: '_feeds_type_miscellaneous_',
					value: 'Miscellaneous',
					category: 'C'
				},
				{
					name: '_feeds_type_mix_',
					value: 'Mix',
					category: 'MIX'
				}
			],
			custom_feeding_days: [
				{
					name: '_custom_day_monday_',
					longName: '_custom_longDay_monday_',
					selected: false,
					rrule_day: 'MO',
					value: 0
				},
				{
					name: '_custom_day_tuesday_',
					longName: '_custom_longDay_tuesday_',
					selected: false,
					rrule_day: 'TU',
					value: 1
				},
				{
					name: '_custom_day_wednesday_',
					longName: '_custom_longDay_wednesday_',
					selected: false,
					rrule_day: 'WE',
					value: 2
				},
				{
					name: '_custom_day_thursday_',
					longName: '_custom_longDay_thursday_',
					selected: false,
					rrule_day: 'TH',
					value: 3
				},
				{
					name: '_custom_day_friday_',
					longName: '_custom_longDay_friday_',
					selected: false,
					rrule_day: 'FR',
					value: 4
				},
				{
					name: '_custom_day_saturday_',
					longName: '_custom_longDay_saturday_',
					selected: false,
					rrule_day: 'SA',
					value: 5
				},
				{
					name: '_custom_day_sunday_',
					longName: '_custom_longDay_sunday_',
					selected: false,
					rrule_day: 'SU',
					value: 6
				}
			],
			statesAccessList: [
				{
					state: 'calendar',
					accessControl: 64
				},
				{
					state: 'feeds.addNewFeed',
					accessControl: 16
				},
				{
					state: 'feeds.addNewManualFeed',
					accessControl: 64
				},
				{
					state: 'feeds.editFeed',
					accessControl: 16
				},
				{
					state: 'feeds.feedHistory',
					accessControl: 16
				},
				{
					state: 'feeds.manualFeedsHistory',
					accessControl: 64
				},
				{
					state: 'feeds.importSpartan3',
					accessControl: 16
				},
				{
					state: 'feeds.importXml',
					accessControl: 16
				},
				{
					state: 'feeds.importXmlFeed',
					accessControl: 16
				},
				{
					state: 'feeds.myfeeds',
					accessControl: 16
				},
				{
					state: 'feeds.mymanualfeeds',
					accessControl: 64
				},
				{
					state: 'groups.addNewGroup',
					accessControl: 16
				},
				{
					state: 'groups.editGroup',
					accessControl: 16
				},
				{
					state: 'groups.groupDetails',
					accessControl: 16
				},
				{
					state: 'groups.groupHistory',
					accessControl: 16
				},
				{
					state: 'groups.myGroups',
					accessControl: 16
				},
				{
					state: 'iManagement.addNewIngredient',
					accessControl: 64
				},
				{
					state: 'iManagement.editIngredient',
					accessControl: 64
				},
				{
					state: 'iManagement.ingredientDetails',
					accessControl: 64
				},
				{
					state: 'iManagement.ingredientHistory',
					accessControl: 64
				},
				{
					state: 'iManagement.inventory',
					accessControl: 64
				},
				{
					state: 'iManagement.overview',
					accessControl: 64
				},
				{
					state: 'iManagement.ingredientUsageOverview',
					accessControl: 64
				},
				{
					state: 'mixerWagons.addNewWagon',
					accessControl: 64
				},
				{
					state: 'mixerWagons.editWagon',
					accessControl: 64
				},
				{
					state: 'mixerWagons.myWagons',
					accessControl: 64
				},
				{
					state: 'mixerWagons.wagonHistory',
					accessControl: 64
				},
				{
					state: 'pens.addNewPen',
					accessControl: 64
				},
				{
					state: 'pens.editPen',
					accessControl: 64
				},
				{
					state: 'pens.myPens',
					accessControl: 64
				},
				{
					state: 'pens.penDetails',
					accessControl: 64
				},
				{
					state: 'pens.penHistory',
					accessControl: 64
				},
				{
					state: 'premixes.addNewPremix',
					accessControl: 64
				},
				{
					state: 'premixes.editPremix',
					accessControl: 64
				},
				{
					state: 'premixes.myPremixes',
					accessControl: 64
				},
				{
					state: 'rations.addmanualration',
					accessControl: 64
				},
				{
					state: 'rations.addnewration',
					accessControl: 16
				},
				{
					state: 'rations.balanceration',
					accessControl: 16
				},
				{
					state: 'rations.editmanualration',
					accessControl: 64
				},
				{
					state: 'rations.importration',
					accessControl: 16
				},
				{
					state: 'rations.importrationnew',
					accessControl: 64
				},
				{
					state: 'rations.manualrations',
					accessControl: 64
				},
				{
					state: 'rations.manualRationsHistory',
					accessControl: 64
				},
				{
					state: 'rations.manualRationFeedsHistory',
					accessControl: 64
				},
				{
					state: 'rations.myrations',
					accessControl: 16
				},
				{
					state: 'rations.rationComparison',
					accessControl: 16
				},
				{
					state: 'rations.rationComparisonList',
					accessControl: 16
				},
				{
					state: 'rations.rationFeedHistory',
					accessControl: 16
				},
				{
					state: 'rations.rationHistory',
					accessControl: 16
				},
				{
					state: 'recipes.addNewRecipe',
					accessControl: 64
				},
				{
					state: 'recipes.editRecipe',
					accessControl: 64
				},
				{
					state: 'recipes.myRecipes',
					accessControl: 64
				},
				{
					state: 'recipes.recipeDetails',
					accessControl: 64
				},
				{
					state: 'recipes.recipeHistory',
					accessControl: 64
				},
				{
					state: 'reports.communication',
					accessControl: 64
				},
				{
					state: 'reports.dropping',
					accessControl: 64
				},
				{
					state: 'reports.mixing',
					accessControl: 64
				},
				{
					state: 'reports.weighback',
					accessControl: 64
				},
				{
					state: 'robot-view',
					accessControl: 128
				},
				{
					state: 'insights',
					accessControl: 261120
				}
			], // when dashboard name is changed update these translations
			dashboardIdList: [
				{
					name: '_rap_workbook_name_rap_main_herd_overview_',
					id: '_rap_workbook_id_rap_main_herd_overview_'
				},
				{
					name: '_rap_workbook_name_rap_herd_dashboard_',
					id: '_rap_workbook_id_rap_herd_dashboard_'
				},
				{
					name: '_rap_workbook_name_days_in_milk_trend_',
					id: '_rap_workbook_id_days_in_milk_trend_'
				},
				{
					name: '_rap_workbook_name_milk_yield_trend_',
					id: '_rap_workbook_id_milk_yield_trend_'
				},
				{
					name: '_rap_workbook_name_milk_yield_actual_',
					id: '_rap_workbook_id_milk_yield_actual_'
				},
				{
					name: '_rap_workbook_name_first_milk_yield_by_calving_date_',
					id: '_rap_workbook_id_first_milk_yield_by_calving_date_'
				},
				{
					name: '_rap_workbook_name_spp_trend_',
					id: '_rap_workbook_id_spp_trend_'
				},
				{
					name: '_rap_workbook_name_spp_actual_',
					id: '_rap_workbook_id_spp_actual_'
				},
				{
					name: '_rap_workbook_name_milkings_trend_',
					id: '_rap_workbook_id_milkings_trend_'
				},
				{
					name: '_rap_workbook_name_milkings_actual_',
					id: '_rap_workbook_id_milkings_actual_'
				},
				{
					name: '_rap_workbook_name_milk_milkings_actual_',
					id: '_rap_workbook_id_milk_milkings_actual_'
				},
				{
					name: '_rap_workbook_name_milk_milkings_trend_',
					id: '_rap_workbook_id_milk_milkings_trend_'
				},
				{
					name: '_rap_workbook_name_concentrate_yield_trend_',
					id: '_rap_workbook_id_concentrate_yield_trend_'
				},
				{
					name: '_rap_workbook_name_concentrate_actual_by_yield_',
					id: '_rap_workbook_id_concentrate_actual_by_yield_'
				},
				{
					name: '_rap_workbook_name_concentrate_kg_trend_',
					id: '_rap_workbook_id_concentrate_kg_trend_'
				},
				{
					name: '_rap_workbook_name_concentrate_actual_by_feed_',
					id: '_rap_workbook_id_concentrate_actual_by_feed_'
				},
				{
					name: '_rap_workbook_name_feed_intake_',
					id: '_rap_workbook_id_feed_intake_'
				},
				{
					name: '_rap_workbook_name_concentrate_actual_by_milk_production_',
					id: '_rap_workbook_id_concentrate_actual_by_milk_production_'
				},
				{
					name: '_rap_workbook_name_herd_prestations_actual_',
					id: '_rap_workbook_id_herd_prestations_actual_'
				},
				{
					name: '_rap_workbook_name_herd_prestations_trend_',
					id: '_rap_workbook_id_herd_prestations_trend_'
				},
				{
					name: '_rap_workbook_name_leftovers_trend_',
					id: '_rap_workbook_id_leftovers_trends_'
				},
				{
					name: '_rap_workbook_name_leftovers_actual_',
					id: '_rap_workbook_id_leftovers_actual_'
				},
				{
					name: '_rap_workbook_name_leftovers_actual_table_',
					id: '_rap_workbook_id_leftovers_actual_table_'
				},
				{
					name: '_rap_workbook_name_leftovers_actual_milk_speed_',
					id: '_rap_workbook_id_leftovers_actual_milk_speed_'
				},
				{
					name: '_dashboard_name_milk_yield_actual_by_date_',
					id: '_dashboard_id_milk_yield_actual_by_date_'
				},
				{
					name: '_dashboard_name_spp_actual_by_date_',
					id: '_dashboard_id_spp_actual_by_date_'
				},
				{
					name: '_dashboard_name_milkings_actual_by_date_',
					id: '_dashboard_id_milkings_actual_by_date_'
				},
				{
					name: '_rap_workbook_name_milk_milkings_actual_by_date_',
					id: '_rap_workbook_id_milk_milkings_actual_by_date_'
				},
				{
					name: '_dashboard_name_conc_actual_yield_by_date_',
					id: '_dashboard_id_conc_actual_yield_by_date_'
				},
				{
					name: '_dashboard_name_conc_actual_feed_by_date_',
					id: '_dashboard_id_conc_actual_feed_by_date_'
				},
				{
					name: '_dashboard_name_leftovers_actual_by_date_',
					id: '_dashboard_id_leftovers_actual_by_date_'
				},
				{
					name: '_dashboard_name_robot_prestations_dashboard_',
					id: '_dashboard_id_robot_prestations_dashboard_'
				},
				{
					name: '_dashboard_name_robot_prestations_trend_dashboard_',
					id: '_dashboard_id_robot_prestations_trend_dashboard_'
				},
				{
					name: '_dashboard_name_actual_dashboard_',
					id: '_dashboard_id_actual_dashboard_'
				}
			],
			sheetNamePairs: [
				{
					sheet_name_transition: 'Milk yield actual',
					sheet_name: 'Milk yield (kg/cow) by DIM'
				},
				{
					sheet_name_transition: 'Production laitière réelle',
					sheet_name: 'Production laitière (kg/vache) en fonction du stade de lactation'
				},
				{
					sheet_name_transition: 'tatsächliche Milchleistung',
					sheet_name: 'Milchleistung (kg/Kuh) nach tim'
				},
				{
					sheet_name_transition: 'Melkproductie actueel',
					sheet_name: 'Melkproductie (kg/koe) volgens DIL'
				},
				{
					sheet_name_transition: 'First milk yield by calving date',
					sheet_name: 'First milk yield (kg/cow) by calving date'
				},
				{
					sheet_name_transition: 'Première production laitière par date de vêlage',
					sheet_name: 'Première production laitière (kg/vache) par date de vêlage'
				},
				{
					sheet_name_transition: 'Erste Milchleistung nach Kalbedatum',
					sheet_name: 'Erste Milchleistung (kg/Kuh) nach Kalbedatum'
				},
				{
					sheet_name_transition: 'Eerste melk productie volgens kalfdatum',
					sheet_name: 'Eerste melk productie (kg/koe) volgens kalfdatum'
				},
				{
					sheet_name_transition: 'Milk yield trend',
					sheet_name: 'Milk yield (kg) over time'
				},
				{
					sheet_name_transition: 'Tendance de la production laitière',
					sheet_name: 'Production laitière (kg) en fonction du temps'
				},
				{
					sheet_name_transition: 'Milchleistungsentwicklung',
					sheet_name: 'Milchleistung (kg) im Zeitverlauf'
				},
				{
					sheet_name_transition: 'Melkproductie trend',
					sheet_name: 'Melkproductie (kg) in de tijd'
				},
				{
					sheet_name_transition: 'SPP actual',
					sheet_name: 'BSK (kg/cow) by DIM'
				},
				{
					sheet_name_transition: 'BSK réel',
					sheet_name: 'BSK (kg/vache) par DIM'
				},
				{
					sheet_name_transition: 'tatsächliche BSK',
					sheet_name: 'BSK (kg/Kuh) nach tim'
				},
				{
					sheet_name_transition: 'BSK actueel',
					sheet_name: 'BSK (kg/koe) volgens DIL'
				},
				{
					sheet_name_transition: 'SPP trend',
					sheet_name: 'BSK over time'
				},
				{
					sheet_name_transition: 'Tendance BSK',
					sheet_name: 'BSK en fonction du temps'
				},
				{
					sheet_name_transition: 'BSK-Entwicklung',
					sheet_name: 'BSK im Zeitverlauf'
				},
				{
					sheet_name_transition: 'BSK trend',
					sheet_name: 'BSK in de tijd'
				},
				{
					sheet_name_transition: 'Milkings actual',
					sheet_name: 'Milkings by DIM'
				},
				{
					sheet_name_transition: 'Traites réelles',
					sheet_name: 'Traites en fonction du stade de lactation'
				},
				{
					sheet_name_transition: 'tatsächliche Melkvorgänge',
					sheet_name: 'Melkungen nach tim'
				},
				{
					sheet_name_transition: 'Melkingen actueel',
					sheet_name: 'Melkingen volgens DIL'
				},
				{
					sheet_name_transition: 'Milkings trend',
					sheet_name: 'Milkings over time'
				},
				{
					sheet_name_transition: 'Tendance traites',
					sheet_name: 'Traites en fonction du temps'
				},
				{
					sheet_name_transition: 'Endwicklung der Melkungen',
					sheet_name: 'Melkungen im Zeitverlauf'
				},
				{
					sheet_name_transition: 'Melkingen trend',
					sheet_name: 'Melkingen over de tijd'
				},
				{
					sheet_name_transition: 'Milk/Milkings trend',
					sheet_name: 'Milk/Milkings over time'
				},
				{
					sheet_name_transition: 'Tendance lait/traites',
					sheet_name: 'Lait/Traites en fonction du temps'
				},
				{
					sheet_name_transition: 'Milch/Melkungen Entwicklung',
					sheet_name: 'Milch/Melkungen Übersicht'
				},
				{
					sheet_name_transition: 'Melk/melking trend',
					sheet_name: 'Melk/melking in de tijd'
				},
				{
					sheet_name_transition: 'Milk/Milkings actual',
					sheet_name: 'Milk/Milkings in DIM'
				},
				{
					sheet_name_transition: 'Lait/Traites en fonction du stade de lactation',
					sheet_name: 'Lait/Traites en fonction du JEL'
				},
				{
					sheet_name_transition: 'Milch/tatsächliche Melkungen',
					sheet_name: 'Milch/Melkungen nach tim'
				},
				{
					sheet_name_transition: 'Melk/melking actueel',
					sheet_name: 'Melk/Melking volgens DIL'
				},
				{
					sheet_name_transition: 'Concentrate actual by yield',
					sheet_name: 'Concentrate intake (kg/100) by milk yield'
				},
				{
					sheet_name_transition: 'Concentré réel en fonction du stade de lactation',
					sheet_name: 'Consommation de concentré (kg/100) en fonction du stade de lactation'
				},
				{
					sheet_name_transition: 'tatsächliches Kraftfutter nach Leistung',
					sheet_name: 'Kraftfutteraufnahme (kg/100) nach Milchleistung'
				},
				{
					sheet_name_transition: 'Krachtvoer actueel volgens productie',
					sheet_name: 'Krachtvoergift (kg/100) volgens melkproductie'
				},
				{
					sheet_name_transition: 'Concentrate yield trend',
					sheet_name: 'Concentrate intake (yield) over time'
				},
				{
					sheet_name_transition: 'Tendance de la consommation de concentrés',
					sheet_name: 'Consommation de concentré (rendement) en fonction du temps'
				},
				{
					sheet_name_transition: 'Entwicklung der Kraftfutterleistung',
					sheet_name: 'Kraftfutteraufnahme (Leistung) im Zeitverlauf'
				},
				{
					sheet_name_transition: 'Krachtvoergift trend',
					sheet_name: 'Krachtvoergift over de tijd'
				},
				{
					sheet_name_transition: 'Concentrate actual by feed',
					sheet_name: 'Concentrate intake (kg/cow) by DIM'
				},
				{
					sheet_name_transition: 'Concentrés (kg) en fonction du stade de lactation',
					sheet_name: 'Consommation de concentré (kg/vache) en fonction du stade de lactation'
				},
				{
					sheet_name_transition: 'tatsächliches Kraftfutter nach Futter',
					sheet_name: 'Kraftfutteraufnahme (kg/Kuh) nach tim'
				},
				{
					sheet_name_transition: 'Krachtvoer actueel volgens voer',
					sheet_name: 'Krachtvoergift (kg/koe) volgens DIL'
				},
				{
					sheet_name_transition: 'Concentrate kg trend',
					sheet_name: 'Concentrate intake (kg) over time'
				},
				{
					sheet_name_transition: 'Tendance de la consommation de concentrés (Kg)',
					sheet_name: 'Consommation de concentré (kg) en fonction du temps'
				},
				{
					sheet_name_transition: 'Kraftfutterecntwiklung (K)',
					sheet_name: 'Kraftfutteraufnahme (kg) über die Zeit'
				},
				{
					sheet_name_transition: 'Krachtvoer kg trend',
					sheet_name: 'Krachtvoergift (kg) over de tijd'
				},
				{
					sheet_name_transition: 'Concentrate actual by milk production',
					sheet_name: 'Concentrate intake (kg/cow) by milk production'
				},
				{
					sheet_name_transition: 'Consommation de concentrés en fonction de la production de lait',
					sheet_name: 'Consommation de concentrés (kg/vache) en fonction de la production'
				},
				{
					sheet_name_transition: 'tatsächliches Kraftfutter nach Milchproduktion',
					sheet_name: 'Kraftfutteraufnahme (kg/Kuh) durch Milchproduktion'
				},
				{
					sheet_name_transition: 'Krachtvoer actueel volgens melkproductie',
					sheet_name: 'Krachtvoergift (kg/koe) volgens melkproductie'
				},
				{
					sheet_name_transition: 'Feed Intake',
					sheet_name: 'Average feed intake over time'
				},
				{
					sheet_name_transition: 'Alimentation',
					sheet_name: "Consommation moyenne d'aliments en fonction du temps"
				},
				{
					sheet_name_transition: 'Futteraufnahme',
					sheet_name: 'Durchschnittliche Futteraufnahme im Zeitverlauf'
				},
				{
					sheet_name_transition: 'Voeropname',
					sheet_name: 'Gemiddelde voeropname over de tijd'
				},
				{
					sheet_name_transition: 'Leftovers actual',
					sheet_name: 'Leftover by DIM'
				},
				{
					sheet_name_transition: 'Restes actuels',
					sheet_name: 'Restes aliments en fonction du stade de lactation'
				},
				{
					sheet_name_transition: 'tatsächliche Reste',
					sheet_name: 'Reste nach tim'
				},
				{
					sheet_name_transition: 'Restvoer actueel',
					sheet_name: 'Restvoer volgens DIL'
				},
				{
					sheet_name_transition: 'Leftovers trend',
					sheet_name: 'Leftovers over time'
				},
				{
					sheet_name_transition: 'Tendance des restes aliments',
					sheet_name: 'Restes aliments en fonction du temps'
				},
				{
					sheet_name_transition: 'Entwicklung der Reste',
					sheet_name: 'Reste im Zeitverlauf'
				},
				{
					sheet_name_transition: 'Restvoer trend',
					sheet_name: 'Restvoer in de tijd'
				},
				{
					sheet_name_transition: 'Leftovers actual Table',
					sheet_name: 'Leftover Table'
				},
				{
					sheet_name_transition: "Tableau des restes d'aliments",
					sheet_name: "Tableau des restes d'aliments"
				},
				{
					sheet_name_transition: 'Tabelle mit derzeitigen Resten',
					sheet_name: 'Restetabelle'
				},
				{
					sheet_name_transition: 'Restvoer actueel tabel',
					sheet_name: 'Restvoer tabel'
				},
				{
					sheet_name_transition: 'Leftovers actual Milk Speed',
					sheet_name: 'Leftover by Milk Speed'
				},
				{
					sheet_name_transition: 'Reste aliments en fonction de la vitesse de traite',
					sheet_name: 'Reste aliments en fonction de la vitesse de stress'
				},
				{
					sheet_name_transition: 'Reste derzeitiger Melkgeschwindigkeit',
					sheet_name: 'Reste nach Melkgeschwindigkeit'
				},
				{
					sheet_name_transition: 'Restvoer actueel melksnelheid',
					sheet_name: 'Restvoer volgens melksnelheid'
				},
				{
					sheet_name_transition: 'Herd prestations actual',
					sheet_name: 'RAP Herd prestations actual (ani1)1'
				},
				{
					sheet_name_transition: 'Prestations réelles pour le troupeau',
					sheet_name: 'Prestations réelles pour le troupeau RAP (ani1)1'
				},
				{
					sheet_name_transition: 'tatsächliche Herdenvorhersage',
					sheet_name: 'RAP tatsächliche Herdvorhersage (ani1)1'
				},
				{
					sheet_name_transition: 'Kuddeprestaties actueel',
					sheet_name: 'RAP kuddeprestaties actueel (ani1)1'
				},
				{
					sheet_name_transition: 'Herd prestations trend',
					sheet_name: 'RAP Herd prestations trend'
				},
				{
					sheet_name_transition: 'Tendance des prestations du troupeau',
					sheet_name: 'Tendance pour les prestations pour le troupeau RAP'
				},
				{
					sheet_name_transition: 'Entwicklung der Herdenvorhersage',
					sheet_name: 'RAP  Entwicklung der Herdenvorhersage'
				},
				{
					sheet_name_transition: 'Kuddeprestaties trend',
					sheet_name: 'RAP kuddeprestaties trend'
				},
				{
					sheet_name_transition: 'Days in milk trend',
					sheet_name: 'Days in milk over time'
				},
				{
					sheet_name_transition: 'Tendance des jours de lactation',
					sheet_name: 'Jours de lactation en fonction du temps'
				},
				{
					sheet_name_transition: 'Entwicklung der Tage im Milch',
					sheet_name: 'Tage in Milch im Zeitverlauf'
				},
				{
					sheet_name_transition: 'Dagen in lactatie trend',
					sheet_name: 'Dagen in lactatie in de tijd'
				},
				{
					sheet_name_transition: 'RAP Herd dashboard',
					sheet_name: 'Milk graph'
				},
				{
					sheet_name_transition: 'Tableau de bord du troupeau RAP',
					sheet_name: 'Milk graph'
				},
				{
					sheet_name_transition: 'RAP Herdentabelle',
					sheet_name: 'Milk graph'
				},
				{
					sheet_name_transition: 'RAP Bedrijfsdashboard',
					sheet_name: 'Milk graph'
				},

				{
					sheet_name_transition: 'Milk yield actual by date',
					sheet_name: 'Milk yield (kg/cow) by DIM by Date'
				},
				{
					sheet_name_transition: 'Production de lait réelle tendance',
					sheet_name: 'Production de lait (kg/vache) par JEL par date'
				},
				{
					sheet_name_transition: 'Milchproduktion tatsächlicher entwicklung',
					sheet_name: 'Milchproduktion (kg/Kuh) durch TIM nach datum'
				},
				{
					sheet_name_transition: 'Melkproductie actueel trend',
					sheet_name: 'Melkproductie (kg/koe) volgens DIL volgens datum'
				},
				{
					sheet_name_transition: 'SPP actual by date',
					sheet_name: 'BSK (kg/cow) by DIM by Date'
				},
				{
					sheet_name_transition: 'SPP réel tendance',
					sheet_name: 'SPP (kg/vache) par JEL par date'
				},
				{
					sheet_name_transition: 'BSK tatsächlicher entwicklung',
					sheet_name: 'BSK (kg/Kuh) durch TIM nach datum'
				},
				{
					sheet_name_transition: 'BSK actueel trend',
					sheet_name: 'BSK (kg/koe) volgens DIL volgens datum'
				},
				{
					sheet_name_transition: 'Milkings actual by date',
					sheet_name: 'Milkings by DIM by Date'
				},
				{
					sheet_name_transition: 'Traites actualles tendance',
					sheet_name: 'Traites par JEL par date'
				},
				{
					sheet_name_transition: 'Melkungen tatsächlicher entwicklung',
					sheet_name: 'Melkungen durch TIM nach datum'
				},
				{
					sheet_name_transition: 'Melkingen actueel trend',
					sheet_name: 'Melkingen volgens DIL volgens datum'
				},
				{
					sheet_name_transition: 'Milk/Milkings actual by date',
					sheet_name: 'Milk/Milkings in DIM by Date'
				},
				{
					sheet_name_transition: 'Lait/traite actuelle tendance',
					sheet_name: 'Lait/traite s en fonction du JEL par date'
				},
				{
					sheet_name_transition: 'Milch/Melkung tatsächlicher entwicklung',
					sheet_name: 'Milch/Melkung durch TIM nach datum'
				},
				{
					sheet_name_transition: 'Melk/melking actueel trend',
					sheet_name: 'Melk/melking in DIL volgens datum'
				},
				{
					sheet_name_transition: 'Concentrate actual by yield by date',
					sheet_name: 'Concentrate intake (kg/100) by milk yield by Date'
				},
				{
					sheet_name_transition: 'Concentré réel en fonction de la production tendance',
					sheet_name: 'Consommation de concentré (kg/100kg) en fonction de production en fonction par date'
				},
				{
					sheet_name_transition: 'Tatsächliches Kraftfutter durch Leistung entwicklung',
					sheet_name: 'Kraftfutteraufnahme (kg/100kg) durch Leistung nach datum'
				},
				{
					sheet_name_transition: 'Krachtvoer actueel volgens melkproductie trend',
					sheet_name: 'Krachtvoer opname (kg/100kg) volgens melkproductie volgens datum'
				},
				{
					sheet_name_transition: 'Concentrate actual by feed by date',
					sheet_name: 'Concentrate intake (kg/cow) by DIM by Date'
				},
				{
					sheet_name_transition: 'Concentré réel en fonction du concentré tendance',
					sheet_name: 'Consommation de concentré (kg/vache) par JEL par date'
				},
				{
					sheet_name_transition: 'Kraftfutter tatsächlicher durch Kraftfutter Entwicklung',
					sheet_name: 'Kraftfutteraufnahme (kg/Kuh) durch TIM nach datum'
				},
				{
					sheet_name_transition: 'Krachtvoer actueel volgens krachtvoer trend',
					sheet_name: 'Krachtvoer opname (kg/koe) volgens DIL volgens datum'
				},
				{
					sheet_name_transition: 'Leftovers actual by date',
					sheet_name: 'Leftover by DIM by Date'
				},
				{
					sheet_name_transition: 'Restes actuels tendance',
					sheet_name: 'Restes par JEL par date'
				},
				{
					sheet_name_transition: 'Reste tatsächlicher entwicklung',
					sheet_name: 'Reste durch TIM nach datum'
				},
				{
					sheet_name_transition: 'Restvoer actueel trend',
					sheet_name: 'Restvoer volgens DIL volgens datum'
				},
				{
					sheet_name_transition: 'Robot prestations dashboard',
					sheet_name: 'Robot prestations'
				},
				{
					sheet_name_transition: 'Prestations du robot tableau de bord',
					sheet_name: 'Prestations du robot'
				},
				{
					sheet_name_transition: 'Robotervorhersagen Tabelle',
					sheet_name: 'Robotervorhersagen'
				},
				{
					sheet_name_transition: 'Robot prestaties dashboard',
					sheet_name: 'Robotprestaties'
				},
				{
					sheet_name_transition: 'Robot prestations trend dashboard',
					sheet_name: 'Robot prestations trend'
				},
				{
					sheet_name_transition: 'Prestations du robot tendance tableau de bord',
					sheet_name: 'Prestations du robot tendance'
				},
				{
					sheet_name_transition: 'Robotervorhersagen Entwicklungtabelle',
					sheet_name: 'Robotervorhersagen Entwicklung'
				},
				{
					sheet_name_transition: 'Robot prestaties trend dashboard',
					sheet_name: 'Robot prestaties trend'
				},
				{
					sheet_name_transition: 'Actual dashboard',
					sheet_name: 'Graph'
				},
				{
					sheet_name_transition: 'Actual dashboard',
					sheet_name: 'Graph'
				},
				{
					sheet_name_transition: 'Actual dashboard',
					sheet_name: 'Graph'
				},
				{
					sheet_name_transition: 'Actual dashboard',
					sheet_name: 'Graph'
				}
			],
			dashboardIdLngList: [
				{
					internal_id: 'rap_herd_dashboard',
					id: 'RAPHerddashboard',
					lng: 'en-GB',
					index: -2,
					selected: true,
					default: true,
					actual: false,
					size: '1050,650'
				},
				{
					internal_id: 'rap_herd_dashboard',
					id: 'RAPHerddashboard',
					lng: 'en-US',
					index: -2,
					selected: true,
					default: true,
					actual: false,
					size: '1050,650'
				},
				{
					internal_id: 'rap_herd_dashboard',
					id: 'TableaudeborddutroupeauRAP',
					lng: 'fr-FR',
					index: -2,
					selected: true,
					default: true,
					actual: false,
					size: '1050,650'
				},
				{
					internal_id: 'rap_herd_dashboard',
					id: 'RAPHerdentabelle',
					lng: 'de-DE',
					index: -2,
					selected: true,
					default: true,
					actual: false,
					size: '1050,650'
				},
				{
					internal_id: 'rap_herd_dashboard',
					id: 'RAPBedrijfsdashboard',
					lng: 'nl-NL',
					index: -2,
					selected: true,
					default: true,
					actual: false,
					size: '1050,800'
				},
				{
					internal_id: 'herd_prestations_actual',
					id: 'Herdprestationsactual',
					lng: 'en-GB',
					index: -1,
					selected: true,
					default: true,
					actual: true
				},
				{
					internal_id: 'herd_prestations_actual',
					id: 'Herdprestationsactual',
					lng: 'en-US',
					index: -1,
					selected: true,
					default: true,
					actual: true
				},
				{
					internal_id: 'herd_prestations_actual',
					id: 'Prestationsrellespourletroupeau',
					lng: 'fr-FR',
					index: -1,
					selected: true,
					default: true,
					actual: true
				},
				{
					internal_id: 'herd_prestations_actual',
					id: 'tatschlicheHerdenvorhersage',
					lng: 'de-DE',
					index: -1,
					selected: true,
					default: true,
					actual: true
				},
				{
					internal_id: 'herd_prestations_actual',
					id: 'Kuddeprestatiesactueel',
					lng: 'nl-NL',
					index: -1,
					selected: true,
					default: true,
					actual: true
				},
				{
					internal_id: 'rap_main_herd_overview',
					id: 'RAPMainherdoverview',
					lng: 'en-GB',
					index: 92,
					actual: false
				},
				{
					internal_id: 'rap_main_herd_overview',
					id: 'RAPMainherdoverview',
					lng: 'en-US',
					index: 92,
					actual: false
				},
				{
					internal_id: 'rap_main_herd_overview',
					id: 'AperugnraldutroupeauRAP',
					lng: 'fr-FR',
					index: 92,
					actual: false
				},
				{
					internal_id: 'rap_main_herd_overview',
					id: 'RAPHauptherdenbersicht',
					lng: 'de-DE',
					index: 92,
					actual: false
				},
				{
					internal_id: 'rap_main_herd_overview',
					id: 'RAPHoofdoverzicht',
					lng: 'nl-NL',
					index: 92,
					actual: false
				},
				{
					internal_id: 'milk_yield_trend',
					id: 'Milkyieldtrend',
					lng: 'en-GB',
					index: 93,
					actual: false
				},
				{
					internal_id: 'milk_yield_trend',
					id: 'Milkyieldtrend',
					lng: 'en-US',
					index: 93,
					actual: false
				},
				{
					internal_id: 'milk_yield_trend',
					id: 'Tendancedelaproductionlaitire',
					lng: 'fr-FR',
					index: 93,
					actual: false
				},
				{
					internal_id: 'milk_yield_trend',
					id: 'Milchleistungsentwicklung',
					lng: 'de-DE',
					index: 93,
					actual: false
				},
				{
					internal_id: 'milk_yield_trend',
					id: 'Melkproductietrend',
					lng: 'nl-NL',
					index: 93,
					actual: false
				},
				{
					internal_id: 'milk_yield_actual',
					id: 'Milkyieldactual',
					lng: 'en-GB',
					index: 94,
					actual: true
				},
				{
					internal_id: 'milk_yield_actual',
					id: 'Milkyieldactual',
					lng: 'en-US',
					index: 94,
					actual: true
				},
				{
					internal_id: 'milk_yield_actual',
					id: 'Productionlaitirerelle',
					lng: 'fr-FR',
					index: 94,
					actual: true
				},
				{
					internal_id: 'milk_yield_actual',
					id: 'tatschlicheMilchleistung',
					lng: 'de-DE',
					index: 94,
					actual: true
				},
				{
					internal_id: 'milk_yield_actual',
					id: 'Melkproductieactueel',
					lng: 'nl-NL',
					index: 94,
					actual: true
				},
				{
					internal_id: 'first_milk',
					id: 'Firstmilkyieldbycalvingdate',
					lng: 'en-GB',
					index: 95,
					actual: false
				},
				{
					internal_id: 'first_milk',
					id: 'Firstmilkyieldbycalvingdate',
					lng: 'en-US',
					index: 95,
					actual: false
				},
				{
					internal_id: 'first_milk',
					id: 'Premireproductionlaitirepardatedevlage',
					lng: 'fr-FR',
					index: 95,
					actual: false
				},
				{
					internal_id: 'first_milk',
					id: 'ErsteMilchleistungnachKalbedatum',
					lng: 'de-DE',
					index: 95,
					actual: false
				},
				{
					internal_id: 'first_milk',
					id: 'Eerstemelkproductievolgenskalfdatum',
					lng: 'nl-NL',
					index: 95,
					actual: false
				},
				{
					internal_id: 'spp_trend',
					id: 'SPPtrend',
					lng: 'en-GB',
					index: 96,
					actual: false
				},
				{
					internal_id: 'spp_trend',
					id: 'SPPtrend',
					lng: 'en-US',
					index: 96,
					actual: false
				},
				{
					internal_id: 'spp_trend',
					id: 'TendanceBSK',
					lng: 'fr-FR',
					index: 96,
					actual: false
				},
				{
					internal_id: 'spp_trend',
					id: 'BSK-Entwicklung',
					lng: 'de-DE',
					index: 96,
					actual: false
				},
				{
					internal_id: 'spp_trend',
					id: 'BSKtrend',
					lng: 'nl-NL',
					index: 96,
					actual: false
				},
				{
					internal_id: 'spp_actual',
					id: 'SPPactual',
					lng: 'en-GB',
					index: 97,
					actual: true
				},
				{
					internal_id: 'spp_actual',
					id: 'SPPactual',
					lng: 'en-US',
					index: 97,
					actual: true
				},
				{
					internal_id: 'spp_actual',
					id: 'BSKrel',
					lng: 'fr-FR',
					index: 97,
					actual: true
				},
				{
					internal_id: 'spp_actual',
					id: 'tatschlicheBSK',
					lng: 'de-DE',
					index: 97,
					actual: true
				},
				{
					internal_id: 'spp_actual',
					id: 'BSKactueel',
					lng: 'nl-NL',
					index: 97,
					actual: true
				},
				{
					internal_id: 'conc_yield_trend',
					id: 'Concentrateyieldtrend',
					lng: 'en-GB',
					index: 912,
					actual: false
				},
				{
					internal_id: 'conc_yield_trend',
					id: 'Concentrateyieldtrend',
					lng: 'en-US',
					index: 912,
					actual: false
				},
				{
					internal_id: 'conc_yield_trend',
					id: 'Tendancedelaconsommationdeconcentrs',
					lng: 'fr-FR',
					index: 912,
					actual: false
				},
				{
					internal_id: 'conc_yield_trend',
					id: 'EntwicklungderKraftfutterleistung',
					lng: 'de-DE',
					index: 912,
					actual: false
				},
				{
					internal_id: 'conc_yield_trend',
					id: 'Krachtvoergifttrend',
					lng: 'nl-NL',
					index: 912,
					actual: false
				},
				{
					internal_id: 'conc_actual_by_yield',
					id: 'Concentrateactualbyyield',
					lng: 'en-GB',
					index: 913,
					actual: true
				},
				{
					internal_id: 'conc_actual_by_yield',
					id: 'Concentrateactualbyyield',
					lng: 'en-US',
					index: 913,
					actual: true
				},
				{
					internal_id: 'conc_actual_by_yield',
					id: 'Concentrrelenfonctiondustadedelactation',
					lng: 'fr-FR',
					index: 913,
					actual: true
				},
				{
					internal_id: 'conc_actual_by_yield',
					id: 'tatschlichesKraftfutternachLeistung',
					lng: 'de-DE',
					index: 913,
					actual: true
				},
				{
					internal_id: 'conc_actual_by_yield',
					id: 'Krachtvoeractueelvolgensproductie',
					lng: 'nl-NL',
					index: 913,
					actual: true
				},
				{
					internal_id: 'conc_kg_trend',
					id: 'Concentratekgtrend',
					lng: 'en-GB',
					index: 914,
					actual: false
				},
				{
					internal_id: 'conc_kg_trend',
					id: 'Concentratekgtrend',
					lng: 'en-US',
					index: 914,
					actual: false
				},
				{
					internal_id: 'conc_kg_trend',
					id: 'TendancedelaconsommationdeconcentrsKg',
					lng: 'fr-FR',
					index: 914,
					actual: false
				},
				{
					internal_id: 'conc_kg_trend',
					id: 'KraftfutterecntwiklungK',
					lng: 'de-DE',
					index: 914,
					actual: false
				},
				{
					internal_id: 'conc_kg_trend',
					id: 'Krachtvoerkgtrend',
					lng: 'nl-NL',
					index: 914,
					actual: false
				},
				{
					internal_id: 'conc_actual_by_feed',
					id: 'Concentrateactualbyfeed',
					lng: 'en-GB',
					index: 915,
					actual: true
				},
				{
					internal_id: 'conc_actual_by_feed',
					id: 'Concentrateactualbyfeed',
					lng: 'en-US',
					index: 915,
					actual: true
				},
				{
					internal_id: 'conc_actual_by_feed',
					id: 'Concentrskgenfonctiondustadedelactation',
					lng: 'fr-FR',
					index: 915,
					actual: true
				},
				{
					internal_id: 'conc_actual_by_feed',
					id: 'tatschlichesKraftfutternachFutter',
					lng: 'de-DE',
					index: 915,
					actual: true
				},
				{
					internal_id: 'conc_actual_by_feed',
					id: 'Krachtvoeractueelvolgensvoer',
					lng: 'nl-NL',
					index: 915,
					actual: true
				},
				{
					internal_id: 'feed_intake',
					id: 'FeedIntake',
					lng: 'en-GB',
					index: 916,
					actual: false
				},
				{
					internal_id: 'feed_intake',
					id: 'FeedIntake',
					lng: 'en-US',
					index: 916,
					actual: false
				},
				{
					internal_id: 'feed_intake',
					id: 'Alimentation',
					lng: 'fr-FR',
					index: 916,
					actual: false
				},
				{
					internal_id: 'feed_intake',
					id: 'Futteraufnahme',
					lng: 'de-DE',
					index: 916,
					actual: false
				},
				{
					internal_id: 'feed_intake',
					id: 'Voeropname',
					lng: 'nl-NL',
					index: 916,
					actual: false
				},
				{
					internal_id: 'herd_prestations_trend',
					id: 'Herdprestationstrend',
					lng: 'en-GB',
					index: 919,
					actual: false
				},
				{
					internal_id: 'herd_prestations_trend',
					id: 'Herdprestationstrend',
					lng: 'en-US',
					index: 919,
					actual: false
				},
				{
					internal_id: 'herd_prestations_trend',
					id: 'Tendancedesprestationsdutroupeau',
					lng: 'fr-FR',
					index: 919,
					actual: false
				},
				{
					internal_id: 'herd_prestations_trend',
					id: 'EntwicklungderHerdenvorhersage',
					lng: 'de-DE',
					index: 919,
					actual: false
				},
				{
					internal_id: 'herd_prestations_trend',
					id: 'Kuddeprestatiestrend',
					lng: 'nl-NL',
					index: 919,
					actual: false
				},
				{
					internal_id: 'robot_prestations_dashboard',
					id: 'Robotprestationsdashboard',
					lng: 'en-GB',
					index: 950,
					actual: false
				},
				{
					internal_id: 'robot_prestations_dashboard',
					id: 'Robotprestationsdashboard',
					lng: 'en-US',
					index: 950,
					actual: false
				},
				{
					internal_id: 'robot_prestations_dashboard',
					id: 'Prestationsdurobottableaudebord',
					lng: 'fr-FR',
					index: 950,
					actual: false
				},
				{
					internal_id: 'robot_prestations_dashboard',
					id: 'RobotervorhersagenTabelle',
					lng: 'de-DE',
					index: 950,
					actual: false
				},
				{
					internal_id: 'robot_prestations_dashboard',
					id: 'Robotprestatiesdashboard',
					lng: 'nl-NL',
					index: 950,
					actual: false
				},
				{
					internal_id: 'robot_prestations_trend_dashboard',
					id: 'Robotprestationstrenddashboard',
					lng: 'en-GB',
					index: 951,
					actual: false
				},
				{
					internal_id: 'robot_prestations_trend_dashboard',
					id: 'Robotprestationstrenddashboard',
					lng: 'en-US',
					index: 951,
					actual: false
				},
				{
					internal_id: 'robot_prestations_trend_dashboard',
					id: 'Prestationsdurobottendancetableaudebord',
					lng: 'fr-FR',
					index: 951,
					actual: false
				},
				{
					internal_id: 'robot_prestations_trend_dashboard',
					id: 'RobotervorhersagenEntwicklungtabelle',
					lng: 'de-DE',
					index: 951,
					actual: false
				},
				{
					internal_id: 'robot_prestations_trend_dashboard',
					id: 'Robotprestatiestrenddashboard',
					lng: 'nl-NL',
					index: 951,
					actual: false
				},
				{
					internal_id: 'days_in_milk_trend',
					id: 'Daysinmilktrend',
					lng: 'en-GB',
					index: 921,
					actual: false
				},
				{
					internal_id: 'days_in_milk_trend',
					id: 'Daysinmilktrend',
					lng: 'en-US',
					index: 921,
					actual: false
				},
				{
					internal_id: 'days_in_milk_trend',
					id: 'Tendancedesjoursdelactation',
					lng: 'fr-FR',
					index: 921,
					actual: false
				},
				{
					internal_id: 'days_in_milk_trend',
					id: 'EntwicklungderTageimMilch',
					lng: 'de-DE',
					index: 921,
					actual: false
				},
				{
					internal_id: 'days_in_milk_trend',
					id: 'Dageninlactatietrend',
					lng: 'nl-NL',
					index: 921,
					actual: false
				},
				{
					internal_id: 'leftovers_trend',
					id: 'Leftoverstrend',
					lng: 'en-GB',
					index: 922,
					actual: false
				},
				{
					internal_id: 'leftovers_trend',
					id: 'Leftoverstrend',
					lng: 'en-US',
					index: 922,
					actual: false
				},
				{
					internal_id: 'leftovers_trend',
					id: 'Tendancedesrestesaliments',
					lng: 'fr-FR',
					index: 922,
					actual: false
				},
				{
					internal_id: 'leftovers_trend',
					id: 'EntwicklungderReste',
					lng: 'de-DE',
					index: 922,
					actual: false
				},
				{
					internal_id: 'leftovers_trend',
					id: 'Restvoertrend',
					lng: 'nl-NL',
					index: 922,
					actual: false
				},

				{
					internal_id: 'leftovers_actual',
					id: 'Leftoversactual',
					lng: 'en-GB',
					index: 923,
					actual: true
				},
				{
					internal_id: 'leftovers_actual',
					id: 'Leftoversactual',
					lng: 'en-US',
					index: 923,
					actual: true
				},
				{
					internal_id: 'leftovers_actual',
					id: 'Restesactuels',
					lng: 'fr-FR',
					index: 923,
					actual: true
				},
				{
					internal_id: 'leftovers_actual',
					id: 'tatschlicheReste',
					lng: 'de-DE',
					index: 923,
					actual: true
				},
				{
					internal_id: 'leftovers_actual',
					id: 'Restvoeractueel',
					lng: 'nl-NL',
					index: 923,
					actual: true
				},

				{
					internal_id: 'leftovers_actual_table',
					id: 'LeftoversactualTable',
					lng: 'en-GB',
					index: 924,
					actual: true
				},
				{
					internal_id: 'leftovers_actual_table',
					id: 'LeftoversactualTable',
					lng: 'en-US',
					index: 924,
					actual: true
				},
				{
					internal_id: 'leftovers_actual_table',
					id: 'Tableaudesrestesdaliments',
					lng: 'fr-FR',
					index: 924,
					actual: true
				},
				{
					internal_id: 'leftovers_actual_table',
					id: 'TabellemitderzeitigenResten',
					lng: 'de-DE',
					index: 924,
					actual: true
				},
				{
					internal_id: 'leftovers_actual_table',
					id: 'Restvoeractueeltabel',
					lng: 'nl-NL',
					index: 924,
					actual: true
				},

				{
					internal_id: 'leftovers_actual_milk_speed',
					id: 'LeftoversactualMilkSpeed',
					lng: 'en-GB',
					index: 926,
					actual: true
				},
				{
					internal_id: 'leftovers_actual_milk_speed',
					id: 'LeftoversactualMilkSpeed',
					lng: 'en-US',
					index: 926,
					actual: true
				},
				{
					internal_id: 'leftovers_actual_milk_speed',
					id: 'Restealimentsenfonctiondelavitessedetraite',
					lng: 'fr-FR',
					index: 925,
					actual: true
				},
				{
					internal_id: 'leftovers_actual_milk_speed',
					id: 'RestederzeitigerMelkgeschwindigkeit',
					lng: 'de-DE',
					index: 925,
					actual: true
				},
				{
					internal_id: 'leftovers_actual_milk_speed',
					id: 'Restvoeractueelmelksnelheid',
					lng: 'nl-NL',
					index: 925,
					actual: true
				},

				{
					internal_id: 'milkings_actual',
					id: 'Milkingsactual',
					lng: 'en-GB',
					index: 926,
					actual: true
				},
				{
					internal_id: 'milkings_actual',
					id: 'Milkingsactual',
					lng: 'en-US',
					index: 926,
					actual: true
				},
				{
					internal_id: 'milkings_actual',
					id: 'Traitesrelles',
					lng: 'fr-FR',
					index: 926,
					actual: true
				},
				{
					internal_id: 'milkings_actual',
					id: 'tatschlicheMelkvorgnge',
					lng: 'de-DE',
					index: 926,
					actual: true
				},
				{
					internal_id: 'milkings_actual',
					id: 'Melkingenactueel',
					lng: 'nl-NL',
					index: 926,
					actual: true
				},

				{
					internal_id: 'milkings_trend',
					id: 'Milkingstrend',
					lng: 'en-GB',
					index: 927,
					actual: false
				},
				{
					internal_id: 'milkings_trend',
					id: 'Milkingstrend',
					lng: 'en-US',
					index: 927,
					actual: false
				},
				{
					internal_id: 'milkings_trend',
					id: 'Tendancetraites',
					lng: 'fr-FR',
					index: 927,
					actual: false
				},
				{
					internal_id: 'milkings_trend',
					id: 'EndwicklungderMelkungen',
					lng: 'de-DE',
					index: 927,
					actual: false
				},
				{
					internal_id: 'milkings_trend',
					id: 'Melkingentrend',
					lng: 'nl-NL',
					index: 927,
					actual: false
				},

				{
					internal_id: 'milk_milkings_actual',
					id: 'MilkMilkingsactual',
					lng: 'en-GB',
					index: 928,
					actual: true
				},
				{
					internal_id: 'milk_milkings_actual',
					id: 'MilkMilkingsactual',
					lng: 'en-US',
					index: 928,
					actual: true
				},
				{
					internal_id: 'milk_milkings_actual',
					id: 'LaitTraitesenfonctiondustadedelactation',
					lng: 'fr-FR',
					index: 928,
					actual: true
				},
				{
					internal_id: 'milk_milkings_actual',
					id: 'MilchtatschlicheMelkungen',
					lng: 'de-DE',
					index: 928,
					actual: true
				},
				{
					internal_id: 'milk_milkings_actual',
					id: 'Melkmelkingactueel',
					lng: 'nl-NL',
					index: 928,
					actual: true
				},

				{
					internal_id: 'milk_milkings_trend',
					id: 'MilkMilkingstrend',
					lng: 'en-GB',
					index: 929,
					actual: false
				},
				{
					internal_id: 'milk_milkings_trend',
					id: 'MilkMilkingstrend',
					lng: 'en-US',
					index: 929,
					actual: false
				},
				{
					internal_id: 'milk_milkings_trend',
					id: 'Tendancelaittraites',
					lng: 'fr-FR',
					index: 929,
					actual: false
				},
				{
					internal_id: 'milk_milkings_trend',
					id: 'MilchMelkungenEntwicklung',
					lng: 'de-DE',
					index: 929,
					actual: false
				},
				{
					internal_id: 'milk_milkings_trend',
					id: 'Melkmelkingtrend',
					lng: 'nl-NL',
					index: 929,
					actual: false
				},

				{
					internal_id: 'concentrate_actual_by_milk_production',
					id: 'Concentrateactualbymilkproduction',
					lng: 'en-GB',
					index: 930,
					actual: true
				},
				{
					internal_id: 'concentrate_actual_by_milk_production',
					id: 'Concentrateactualbymilkproduction',
					lng: 'en-US',
					index: 930,
					actual: true
				},
				{
					internal_id: 'concentrate_actual_by_milk_production',
					id: 'Consommationdeconcentrsenfonctiondelaproductiondelait',
					lng: 'fr-FR',
					index: 930,
					actual: true
				},
				{
					internal_id: 'concentrate_actual_by_milk_production',
					id: 'tatschlichesKraftfutternachMilchproduktion',
					lng: 'de-DE',
					index: 930,
					actual: true
				},
				{
					internal_id: 'concentrate_actual_by_milk_production',
					id: 'Krachtvoeractueelvolgensmelkproductie',
					lng: 'nl-NL',
					index: 930,
					actual: true
				},
				{
					internal_id: 'milk_yield_by_date_dashboard',
					id: 'Milkyieldactualbydate',
					lng: 'en-GB',
					index: 943,
					actual: true
				},
				{
					internal_id: 'milk_yield_by_date_dashboard',
					id: 'Milkyieldactualbydate',
					lng: 'en-US',
					index: 943,
					actual: true
				},
				{
					internal_id: 'milk_yield_by_date_dashboard',
					id: 'Productiondelaitrelletendance',
					lng: 'fr-FR',
					index: 943,
					actual: true
				},
				{
					internal_id: 'milk_yield_by_date_dashboard',
					id: 'Milchproduktiontatschlicherentwicklung',
					lng: 'de-DE',
					index: 943,
					actual: true
				},
				{
					internal_id: 'milk_yield_by_date_dashboard',
					id: 'Melkproductieactueeltrend',
					lng: 'nl-NL',
					index: 943,
					actual: true
				},

				{
					internal_id: 'spp_by_date_dashboard',
					id: 'SPPactualbydate',
					lng: 'en-GB',
					index: 944,
					actual: true
				},
				{
					internal_id: 'spp_by_date_dashboard',
					id: 'SPPactualbydate',
					lng: 'en-US',
					index: 944,
					actual: true
				},
				{
					internal_id: 'spp_by_date_dashboard',
					id: 'SPPreltendance',
					lng: 'fr-FR',
					index: 944,
					actual: true
				},
				{
					internal_id: 'spp_by_date_dashboard',
					id: 'BSKtatschlicherentwicklung',
					lng: 'de-DE',
					index: 944,
					actual: true
				},
				{
					internal_id: 'spp_by_date_dashboard',
					id: 'BSKactueeltrend',
					lng: 'nl-NL',
					index: 944,
					actual: true
				},

				{
					internal_id: 'milkings_actual_by_date_dashboard',
					id: 'Milkingsactualbydate',
					lng: 'en-GB',
					index: 945,
					actual: true
				},
				{
					internal_id: 'milkings_actual_by_date_dashboard',
					id: 'Milkingsactualbydate',
					lng: 'en-US',
					index: 945,
					actual: true
				},
				{
					internal_id: 'milkings_actual_by_date_dashboard',
					id: 'Traitesactuallestendance',
					lng: 'fr-FR',
					index: 945,
					actual: true
				},
				{
					internal_id: 'milkings_actual_by_date_dashboard',
					id: 'Melkungentatschlicherentwicklung',
					lng: 'de-DE',
					index: 945,
					actual: true
				},
				{
					internal_id: 'milkings_actual_by_date_dashboard',
					id: 'Melkingenactueeltrend',
					lng: 'nl-NL',
					index: 945,
					actual: true
				},

				{
					internal_id: 'milk_milkings_actual_by_date_dashboard',
					id: 'MilkMilkingsactualbydate',
					lng: 'en-GB',
					index: 946,
					actual: true
				},
				{
					internal_id: 'milk_milkings_actual_by_date_dashboard',
					id: 'MilkMilkingsactualbydate',
					lng: 'en-US',
					index: 946,
					actual: true
				},
				{
					internal_id: 'milk_milkings_actual_by_date_dashboard',
					id: 'Laittraiteactuelletendance',
					lng: 'fr-FR',
					index: 946,
					actual: true
				},
				{
					internal_id: 'milk_milkings_actual_by_date_dashboard',
					id: 'MilchMelkungtatschlicherentwicklung',
					lng: 'de-DE',
					index: 946,
					actual: true
				},
				{
					internal_id: 'milk_milkings_actual_by_date_dashboard',
					id: 'Melkmelkingactueeltrend',
					lng: 'nl-NL',
					index: 946,
					actual: true
				},

				{
					internal_id: 'conc_actual_yield_by_date_dashboard',
					id: 'Concentrateactualbyyieldbydate',
					lng: 'en-GB',
					index: 947,
					actual: true
				},
				{
					internal_id: 'conc_actual_yield_by_date_dashboard',
					id: 'Concentrateactualbyyieldbydate',
					lng: 'en-US',
					index: 947,
					actual: true
				},
				{
					internal_id: 'conc_actual_yield_by_date_dashboard',
					id: 'Concentrrelenfonctiondelaproductiontendance',
					lng: 'fr-FR',
					index: 947,
					actual: true
				},
				{
					internal_id: 'conc_actual_yield_by_date_dashboard',
					id: 'TatschlichesKraftfutterdurchLeistungentwicklung',
					lng: 'de-DE',
					index: 947,
					actual: true
				},
				{
					internal_id: 'conc_actual_yield_by_date_dashboard',
					id: 'Krachtvoeractueelvolgensmelkproductietrend',
					lng: 'nl-NL',
					index: 947,
					actual: true
				},

				{
					internal_id: 'conc_actual_feed_by_date_dashboard',
					id: 'Concentrateactualbyfeedbydate',
					lng: 'en-GB',
					index: 948,
					actual: true
				},
				{
					internal_id: 'conc_actual_feed_by_date_dashboard',
					id: 'Concentrateactualbyfeedbydate',
					lng: 'en-US',
					index: 948,
					actual: true
				},
				{
					internal_id: 'conc_actual_feed_by_date_dashboard',
					id: 'Concentrrelenfonctionduconcentrtendance',
					lng: 'fr-FR',
					index: 948,
					actual: true
				},
				{
					internal_id: 'conc_actual_feed_by_date_dashboard',
					id: 'KraftfuttertatschlicherdurchKraftfutterEntwicklung',
					lng: 'de-DE',
					index: 948,
					actual: true
				},
				{
					internal_id: 'conc_actual_feed_by_date_dashboard',
					id: 'Krachtvoeractueelvolgenskrachtvoertrend',
					lng: 'nl-NL',
					index: 948,
					actual: true
				},

				{
					internal_id: 'leftovers_actual__by_date_dashboard',
					id: 'Leftoversactualbydate',
					lng: 'en-GB',
					index: 949,
					actual: true
				},
				{
					internal_id: 'leftovers_actual__by_date_dashboard',
					id: 'Leftoversactualbydate',
					lng: 'en-US',
					index: 949,
					actual: true
				},
				{
					internal_id: 'leftovers_actual__by_date_dashboard',
					id: 'Restesactuelstendance',
					lng: 'fr-FR',
					index: 949,
					actual: true
				},
				{
					internal_id: 'leftovers_actual__by_date_dashboard',
					id: 'Restetatschlicherentwicklung',
					lng: 'de-DE',
					index: 949,
					actual: true
				},
				{
					internal_id: 'leftovers_actual__by_date_dashboard',
					id: 'Restvoeractueeltrend',
					lng: 'nl-NL',
					index: 949,
					actual: true
				},

				{
					internal_id: 'actual_dashboard',
					id: 'Actualdashboard',
					lng: 'en-GB',
					index: 950,
					actual: true
				},
				{
					internal_id: 'actual_dashboard',
					id: 'Actualdashboard',
					lng: 'en-US',
					index: 950,
					actual: true
				},
				{
					internal_id: 'actual_dashboard',
					id: 'Actualdashboard',
					lng: 'fr-FR',
					index: 950,
					actual: true
				},
				{
					internal_id: 'actual_dashboard',
					id: 'Actualdashboard',
					lng: 'de-DE',
					index: 950,
					actual: true
				},
				{
					internal_id: 'actual_dashboard',
					id: 'Actualdashboard',
					lng: 'nl-NL',
					index: 950,
					actual: true
				}
			],
			dashboardsDashboardIdLngList: [
				{
					internal_id: 'milk_meter',
					id: 'Milkmeterdashboard',
					lng: 'en-GB',
					index: 1
				},
				{
					internal_id: 'milk_meter',
					id: 'Milkmeterdashboard',
					lng: 'en-US',
					index: 1
				},
				{
					internal_id: 'milk_meter',
					id: 'Melkmeterdashboard',
					lng: 'nl-NL',
					index: 1
				},
				{
					internal_id: 'milk_meter',
					id: 'Melkmeterdashboard',
					lng: 'it-IT',
					index: 1
				},

				{
					internal_id: 'milk_recording',
					id: 'Milkrecordingdashboard',
					lng: 'en-GB',
					index: 2
				},
				{
					internal_id: 'milk_recording',
					id: 'Milkrecordingdashboard',
					lng: 'en-US',
					index: 2
				},
				{
					internal_id: 'milk_recording',
					id: 'Melkcontroledashboard',
					lng: 'nl-NL',
					index: 2
				},
				{
					internal_id: 'milk_recording',
					id: 'Melkcontroledashboard',
					lng: 'it-IT',
					index: 2
				},

				{
					internal_id: 'lac_curve_mrd',
					id: 'Lactationcurveanalysisbymilkrecordingdate',
					lng: 'en-GB',
					index: 3
				},
				{
					internal_id: 'lac_curve_mrd',
					id: 'Lactationcurveanalysisbymilkrecordingdate',
					lng: 'en-US',
					index: 3
				},
				{
					internal_id: 'lac_curve_mrd',
					id: 'Lactatiecurveanalysevolgensmelkcontroledatum',
					lng: 'nl-NL',
					index: 3
				},
				{
					internal_id: 'lac_curve_mrd',
					id: 'Lactatiecurveanalysevolgensmelkcontroledatum',
					lng: 'it-IT',
					index: 3
				},

				{
					internal_id: 'lac_curve_cd',
					id: 'Lactationcurveanalysisbycalvingdate',
					lng: 'en-GB',
					index: 4
				},
				{
					internal_id: 'lac_curve_cd',
					id: 'Lactationcurveanalysisbycalvingdate',
					lng: 'en-US',
					index: 4
				},
				{
					internal_id: 'lac_curve_cd',
					id: 'Lactatiecurveanalysevolgenskalfdatum',
					lng: 'nl-NL',
					index: 4
				},
				{
					internal_id: 'lac_curve_cd',
					id: 'Lactatiecurveanalysevolgenskalfdatum',
					lng: 'it-IT',
					index: 4
				},

				{
					internal_id: 'deviation_ing',
					id: 'Deviationbyingredientdashboard',
					lng: 'en-GB',
					index: 5
				},
				{
					internal_id: 'deviation_ing',
					id: 'Deviationbyingredientdashboard',
					lng: 'en-US',
					index: 5
				},
				{
					internal_id: 'deviation_ing',
					id: 'Afwijkingperingredintdashboard',
					lng: 'nl-NL',
					index: 5
				},
				{
					internal_id: 'deviation_ing',
					id: 'Afwijkingperingredintdashboard',
					lng: 'it-IT',
					index: 5
				},

				{
					internal_id: 'dev_day_week',
					id: 'Deviationbydayofweekdashboard',
					lng: 'en-GB',
					index: 6
				},
				{
					internal_id: 'dev_day_week',
					id: 'Deviationbydayofweekdashboard',
					lng: 'en-US',
					index: 6
				},
				{
					internal_id: 'dev_day_week',
					id: 'Afwijkingperdagvandeweekdashboard',
					lng: 'nl-NL',
					index: 6
				},
				{
					internal_id: 'dev_day_week',
					id: 'Afwijkingperdagvandeweekdashboard',
					lng: 'it-IT',
					index: 6
				},

				{
					internal_id: 'loading_schedule',
					id: 'Loadingscheduledashboard',
					lng: 'en-GB',
					index: 7
				},
				{
					internal_id: 'loading_schedule',
					id: 'Loadingscheduledashboard',
					lng: 'en-US',
					index: 7
				},
				{
					internal_id: 'loading_schedule',
					id: 'Laadplandashboard',
					lng: 'nl-NL',
					index: 7
				},
				{
					internal_id: 'loading_schedule',
					id: 'Laadplandashboard',
					lng: 'it-IT',
					index: 7
				},

				{
					internal_id: 'dropping_starts',
					id: 'Droppingstartsdashboard',
					lng: 'en-GB',
					index: 8
				},
				{
					internal_id: 'dropping_starts',
					id: 'Droppingstartsdashboard',
					lng: 'en-US',
					index: 8
				},
				{
					internal_id: 'dropping_starts',
					id: 'Startlossendashboard',
					lng: 'nl-NL',
					index: 8
				},
				{
					internal_id: 'dropping_starts',
					id: 'Startlossendashboard',
					lng: 'it-IT',
					index: 8
				},

				{
					internal_id: 'ing_loaded_total',
					id: 'Ingredientsloadedovertimetotaldashboard',
					lng: 'en-GB',
					index: 9
				},
				{
					internal_id: 'ing_loaded_total',
					id: 'Ingredientsloadedovertimetotaldashboard',
					lng: 'en-US',
					index: 9
				},
				{
					internal_id: 'ing_loaded_total',
					id: 'Totaalgeladeningredintenindetijddashboard',
					lng: 'nl-NL',
					index: 9
				},
				{
					internal_id: 'ing_loaded_total',
					id: 'Totaalgeladeningredintenindetijddashboard',
					lng: 'it-IT',
					index: 9
				},

				{
					internal_id: 'ing_loaded_per_pen',
					id: 'Ingredientsloadedovertimeperpendashboard',
					lng: 'en-GB',
					index: 10
				},
				{
					internal_id: 'ing_loaded_per_pen',
					id: 'Ingredientsloadedovertimeperpendashboard',
					lng: 'en-US',
					index: 10
				},
				{
					internal_id: 'ing_loaded_per_pen',
					id: 'Geladeningredintenindetijdpervoergroepdashboard',
					lng: 'nl-NL',
					index: 10
				},
				{
					internal_id: 'ing_loaded_per_pen',
					id: 'Geladeningredintenindetijdpervoergroepdashboard',
					lng: 'it-IT',
					index: 10
				},

				{
					internal_id: 'ing_dropped_per_pen',
					id: 'Ingredientsdroppedovertimeperpendashboard',
					lng: 'en-GB',
					index: 11
				},
				{
					internal_id: 'ing_dropped_per_pen',
					id: 'Ingredientsdroppedovertimeperpendashboard',
					lng: 'en-US',
					index: 11
				},
				{
					internal_id: 'ing_dropped_per_pen',
					id: 'Ingredintengelostperpenoverdetijd',
					lng: 'nl-NL',
					index: 11
				},
				{
					internal_id: 'ing_dropped_per_pen',
					id: 'Ingredintengelostperpenoverdetijd',
					lng: 'it-IT',
					index: 11
				},

				{
					internal_id: 'total_loaded_per_day',
					id: 'Totalamountloadedperdaydashboard',
					lng: 'en-GB',
					index: 12
				},
				{
					internal_id: 'total_loaded_per_day',
					id: 'Totalamountloadedperdaydashboard',
					lng: 'en-US',
					index: 12
				},
				{
					internal_id: 'total_loaded_per_day',
					id: 'Totalehoeveelheidgeladenperdagdashboard',
					lng: 'nl-NL',
					index: 12
				},
				{
					internal_id: 'total_loaded_per_day',
					id: 'Totalamountloadedperdaydashboard',
					lng: 'it-IT',
					index: 12
				},

				{
					internal_id: 'total_cost_per_day',
					id: 'Totalcostsperdaydashboard',
					lng: 'en-GB',
					index: 13
				},
				{
					internal_id: 'total_cost_per_day',
					id: 'Totalcostsperdaydashboard',
					lng: 'en-US',
					index: 13
				},
				{
					internal_id: 'total_cost_per_day',
					id: 'Totalekostperdag',
					lng: 'nl-NL',
					index: 13
				},
				{
					internal_id: 'total_cost_per_day',
					id: 'Totalcostsperdaydashboard',
					lng: 'it-IT',
					index: 13
				}
			],
			filtersLngList: [
				{
					internal_id: 'parity',
					lng: 'en-GB',
					name: 'Parity'
				},
				{
					internal_id: 'parity',
					lng: 'en-US',
					name: 'Parity'
				},
				{
					internal_id: 'parity',
					lng: 'fr-FR',
					name: 'Lactation'
				},
				{
					internal_id: 'parity',
					lng: 'de-DE',
					name: 'Laktation'
				},
				{
					internal_id: 'parity',
					lng: 'nl-NL',
					name: 'Pariteit'
				},
				{
					internal_id: 'group_by',
					lng: 'en-GB',
					name: 'Group by'
				},
				{
					internal_id: 'group_by',
					lng: 'en-US',
					name: 'Group by'
				},
				{
					internal_id: 'group_by',
					lng: 'fr-FR',
					name: 'Groupé par'
				},
				{
					internal_id: 'group_by',
					lng: 'de-DE',
					name: 'Gruppiere nach'
				},
				{
					internal_id: 'group_by',
					lng: 'nl-NL',
					name: 'Groepeer op'
				},
				{
					internal_id: 'group_by_value',
					lng: 'en-GB',
					name: 'Parity',
					translate_string: '_dashboard_name_parameter_group_by_value_parity_'
				},
				{
					internal_id: 'group_by_value',
					lng: 'en-US',
					name: 'Parity',
					translate_string: '_dashboard_name_parameter_group_by_value_parity_'
				},
				{
					internal_id: 'group_by_value',
					lng: 'fr-FR',
					name: 'Lactation',
					translate_string: '_dashboard_name_parameter_group_by_value_parity_'
				},
				{
					internal_id: 'group_by_value',
					lng: 'de-DE',
					name: 'Laktation',
					translate_string: '_dashboard_name_parameter_group_by_value_parity_'
				},
				{
					internal_id: 'group_by_value',
					lng: 'nl-NL',
					name: 'Pariteit',
					translate_string: '_dashboard_name_parameter_group_by_value_parity_'
				},
				{
					internal_id: 'group_by_value',
					lng: 'en-GB',
					name: 'Herd',
					translate_string: '_dashboard_name_parameter_group_by_value_herd_'
				},
				{
					internal_id: 'group_by_value',
					lng: 'en-US',
					name: 'Herd',
					translate_string: '_dashboard_name_parameter_group_by_value_herd_'
				},
				{
					internal_id: 'group_by_value',
					lng: 'fr-FR',
					name: 'Troupeau',
					translate_string: '_dashboard_name_parameter_group_by_value_herd_'
				},
				{
					internal_id: 'group_by_value',
					lng: 'de-DE',
					name: 'Herde',
					translate_string: '_dashboard_name_parameter_group_by_value_herd_'
				},
				{
					internal_id: 'group_by_value',
					lng: 'nl-NL',
					name: 'Bedrijf',
					translate_string: '_dashboard_name_parameter_group_by_value_herd_'
				},
				{
					internal_id: 'group_by_value',
					lng: 'en-GB',
					name: 'Days in milk category',
					translate_string: '_dashboard_name_parameter_group_by_value_dim_'
				},
				{
					internal_id: 'group_by_value',
					lng: 'en-US',
					name: 'Days in milk category',
					translate_string: '_dashboard_name_parameter_group_by_value_dim_'
				},
				{
					internal_id: 'group_by_value',
					lng: 'fr-FR',
					name: 'Catégorie de jours de lactation',
					translate_string: '_dashboard_name_parameter_group_by_value_dim_'
				},
				{
					internal_id: 'group_by_value',
					lng: 'de-DE',
					name: 'Kategorie Tage in Milch',
					translate_string: '_dashboard_name_parameter_group_by_value_dim_'
				},
				{
					internal_id: 'group_by_value',
					lng: 'nl-NL',
					name: 'Dagen in lactatie categorie',
					translate_string: '_dashboard_name_parameter_group_by_value_dim_'
				},
				{
					internal_id: 'group_by_metric',
					lng: 'en-GB',
					name: 'Group by metric'
				},
				{
					internal_id: 'group_by_metric',
					lng: 'en-US',
					name: 'Group by metric'
				},
				{
					internal_id: 'group_by_metric',
					lng: 'fr-FR',
					name: 'Grouper par métrique'
				},
				{
					internal_id: 'group_by_metric',
					lng: 'de-DE',
					name: 'Nach Metrik gruppieren'
				},
				{
					internal_id: 'group_by_metric',
					lng: 'nl-NL',
					name: 'Groepeer op kengetal'
				},
				{
					internal_id: 'feed_name',
					lng: 'en-GB',
					name: 'Feed name'
				},
				{
					internal_id: 'feed_name',
					lng: 'en-US',
					name: 'Feed name'
				},
				{
					internal_id: 'feed_name',
					lng: 'fr-FR',
					name: "Nom de l'aliment"
				},
				{
					internal_id: 'feed_name',
					lng: 'de-DE',
					name: 'Name des Futters'
				},
				{
					internal_id: 'feed_name',
					lng: 'nl-NL',
					name: 'Voer naam'
				},
				{
					internal_id: 'dim_category',
					lng: 'en-GB',
					name: 'DIM Category'
				},
				{
					internal_id: 'dim_category',
					lng: 'en-US',
					name: 'DIM Category'
				},
				{
					internal_id: 'dim_category',
					lng: 'fr-FR',
					name: 'Catégorie de JEL'
				},
				{
					internal_id: 'dim_category',
					lng: 'de-DE',
					name: 'TIM-Kategorie'
				},
				{
					internal_id: 'dim_category',
					lng: 'nl-NL',
					name: 'DIM Categorie'
				},
				{
					internal_id: 'date',
					lng: 'en-GB',
					name: 'Date'
				},
				{
					internal_id: 'date',
					lng: 'en-US',
					name: 'Date'
				},
				{
					internal_id: 'date',
					lng: 'fr-FR',
					name: 'Date'
				},
				{
					internal_id: 'date',
					lng: 'de-DE',
					name: 'Datum'
				},
				{
					internal_id: 'date',
					lng: 'nl-NL',
					name: 'Datum'
				},
				{
					internal_id: 'vwp',
					lng: 'en-GB',
					name: 'VWP'
				},
				{
					internal_id: 'vwp',
					lng: 'en-US',
					name: 'VWP'
				},
				{
					internal_id: 'vwp',
					lng: 'fr-FR',
					name: "Période d'attente volontaire (VWP)"
				},
				{
					internal_id: 'vwp',
					lng: 'de-DE',
					name: 'VWP'
				},
				{
					internal_id: 'vwp',
					lng: 'nl-NL',
					name: 'VWP (Vrijwillige wachtperiode)'
				},
				{
					internal_id: 'afi',
					lng: 'en-GB',
					name: 'AFI target'
				},
				{
					internal_id: 'afi',
					lng: 'en-US',
					name: 'AFI target'
				},
				{
					internal_id: 'afi',
					lng: 'fr-FR',
					name: 'Objectif AFI'
				},
				{
					internal_id: 'afi',
					lng: 'de-DE',
					name: 'AFI-Ziel'
				},
				{
					internal_id: 'afi',
					lng: 'nl-NL',
					name: 'Doel eerste inseminatie'
				}
			],
			feedFilterPairs: [
				{
					dashboard: 'Deviation by ingredient dashboard',
					filter: 'Action (Ingredient name)',
					lng: 'en-GB'
				},
				{
					dashboard: 'Deviation by ingredient dashboard',
					filter: 'Action (Ingredient name)',
					lng: 'en-US'
				},
				{
					dashboard: 'Afwijking per ingrediënt dashboard',
					filter: 'Action (Ingredient name)',
					lng: 'nl-NL'
				},

				{
					dashboard: 'Deviation by day of week dashboard',
					filter: 'Action (WEEKDAY(DatetimeLoadingStarted))',
					lng: 'en-GB'
				},
				{
					dashboard: 'Deviation by day of week dashboard',
					filter: 'Action (WEEKDAY(DatetimeLoadingStarted))',
					lng: 'en-US'
				},
				{
					dashboard: 'Afwijking per dag van de week dashboard',
					filter: 'Action (WEEKDAY(DatetimeLoadingStarted))',
					lng: 'nl-NL'
				},

				{
					dashboard: 'Loading schedule dashboard',
					filter: 'Action (Hour,WEEKDAY(DatetimeFirstIngredientStarted))',
					lng: 'en-GB'
				},
				{
					dashboard: 'Loading schedule dashboard',
					filter: 'Action (Hour,WEEKDAY(DatetimeFirstIngredientStarted))',
					lng: 'en-US'
				},
				{
					dashboard: 'Laadplan dashboard',
					filter: 'Action (Hour,WEEKDAY(DatetimeFirstIngredientStarted))',
					lng: 'nl-NL'
				},

				{
					dashboard: 'Dropping starts dashboard',
					filter: 'Action (Time after loading dropping starts (minutes))',
					lng: 'en-GB'
				},
				{
					dashboard: 'Dropping starts dashboard',
					filter: 'Action (Time after loading dropping starts (minutes))',
					lng: 'en-US'
				},
				{
					dashboard: 'Start lossen dashboard',
					filter: 'Action (Time after loading dropping starts (minutes))',
					lng: 'nl-NL'
				},

				{
					dashboard: 'Ingredients loaded over time total dashboard',
					filter: 'Action (Feed name,MONTH(DatetimeLoadingStarted))',
					lng: 'en-GB'
				},
				{
					dashboard: 'Ingredients loaded over time total dashboard',
					filter: 'Action (Feed name,MONTH(DatetimeLoadingStarted))',
					lng: 'en-US'
				},
				{
					dashboard: 'Totaal geladen ingrediënten in de tijd dashboard',
					filter: 'Action (Voer naam,MONTH(DatetimeLoadingStarted))',
					lng: 'nl-NL'
				},

				{
					dashboard: 'Ingredients loaded over time per pen dashboard',
					filter: 'Action (Feed name,DAY(DatetimeLoadingStarted),TargetPenName)',
					lng: 'en-GB'
				},
				{
					dashboard: 'Ingredients loaded over time per pen dashboard',
					filter: 'Action (Feed name,DAY(DatetimeLoadingStarted),TargetPenName)',
					lng: 'en-US'
				},
				{
					dashboard: 'Geladen ingrediënten in de tijd per voergroep dashboard',
					filter: 'Action (Voer naam,DAY(DatetimeLoadingStarted),TargetPenName)',
					lng: 'nl-NL'
				}
			]
		}
	});
})();

(function () {
	'use strict';
	angular.module('Spartan').controller('appCtrl', appCtrl);
	/** @ngInject */
	function appCtrl($state, $scope, $timeout, recipeDataService, dataServiceFactory) {
		var ac = this;
		ac.viewMenu = viewMenu;
		ac.getBackgroundClass = getBackgroundClass;
		ac.showView = true;
		ac.showMainView = true;
		ac.showSidebar = true;

		function viewMenu() {
			if ($state.current.title == 'login') {
				return false;
			} else {
				return true;
			}
		}

		function getBackgroundClass() {
			if ($state.current.name == 'insights') {
				if (ac.current_category != null && ac.current_category != undefined) {
					if (ac.current_category == 0) {
						return 'dashboard-image image-production';
					} else if (ac.current_category == 1) {
						return 'dashboard-image image-reproduction';
					} else if (ac.current_category == 2) {
						return 'dashboard-image image-udder_health';
					} else if (ac.current_category == 3) {
						return 'dashboard-image image-hoof_health';
					} else if (ac.current_category == 4) {
						return 'dashboard-image image-herd_characteristics';
					} else if (ac.current_category == 5) {
						return 'dashboard-image image-comments';
					} else if (ac.current_category == 6) {
						return 'dashboard-image image-herd_environmental';
					} else if (ac.current_category == 7) {
						return 'dashboard-image image-herd_genetics';
					} else if (ac.current_category == 9) {
						return 'dashboard-image image-feed';
					} else {
						return 'dashboard-image';
					}
				} else {
					return 'dashboard-image';
				}
			} else {
				return '';
			}
		}

		$scope.$on('update_sidebar', function () {
			ac.showSidebar = false;
			$timeout(function () {
				ac.showSidebar = true;
			}, 0);
		});

		$scope.$on('$stateChangeStart', function (e, toState, toParams, fromState) {
			var remove = false;
			if (!toState.keep_recipe_data) {
				remove = true;
			} else if ((fromState.name === 'recipes.editRecipe' && toState.name === 'recipes.addNewRecipe') || (fromState.name === 'recipes.addNewRecipe' && toState.name === 'recipes.editRecipe')) {
				remove = true;
			}

			if (remove) {
				recipeDataService.resetRecipe();
				localStorage.removeItem('from_recipe');
			}

			if (!toState.keep_calendar_filter) {
				dataServiceFactory.filteredRecipes = {};
			}

			if (!toState.keep_premix_data && !toState.keep_edit_premix_data) {
				dataServiceFactory.add_new_premix_data = {};
				localStorage.removeItem('from_premix');
			}
		});

		$scope.$on('set_category_background', function (event, data) {
			ac.current_category = data;
		});

		$scope.$on('show_main_view', function (event, data) {
			ac.showMainView = data;
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan').service('appService', appService);
	/** @ngInject */
	function appService($timeout) {
		var vm = this;

		vm.timeout = null;
		vm.disableRecipeUpdate = {
            value: false
        };

		vm.setDisableRecipeUpdate = function () {
			if (vm.timeout) {
				$timeout.cancel(vm.timeout);
			}

			vm.disableRecipeUpdate.value = true;

			vm.timeout = $timeout(function () {
				vm.disableRecipeUpdate.value = false;
			}, 30000);
		};
	}
})();

(function () {
	'use strict';
	angular.module('Spartan').value('APP_VERSION', '5.4.0');
})();

(function () {
	'use strict';
	angular.module('Spartan').factory('cookiesService', cookiesService);
	/** @ngInject */
	function cookiesService() {
		return {
			setCookie: setCookie
		};

		function setCookie(name, value, options) {
			if (options) {
				options.path = '/';
			} else {
				options = {
					path: '/'
				};
			}
			if (options.expires) {
				if (angular.isDate(options.expires)) {
					options.expires = options.expires.toUTCString();
				} else {
					options.expires = null;
				}
			}
			var cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);
			angular.forEach(options, function (value, key) {
				if (value) {
					cookie += '; ' + key;
					if (value !== true) {
						cookie += '=' + value;
					}
				}
			});
			document.cookie = cookie;
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.calendar').controller('calendarCtrl', calendarCtrl);
	/** @ngInject */
	function calendarCtrl(
		$locale,
		$uibModal,
		$uibModalStack,
		$scope,
		$timeout,
		$filter,
		$q,
		calendarService,
		Upload,
		APP_CONST,
		$state,
		editableOptions,
		editableThemes,
		dataServiceFactory,
		$cookies,
		uaParser,
		$window,
		$rootScope,
		errorService,
		feedingTableService,
		unitConversionService,
		bugsnagService
	) {
		var vm = this;
		var events;
		var feedingsPromise;
		var eventPromise;
		var picturePromise;
		//var reportPromise;
		var premixPromise;
		var loadingByIdPromise;
		var droppingByIdPromise;
		var loadingModal;
		var i18nFilter = $filter('i18n');
		vm.deviceType = uaParser.getDevice('type');
		vm.dateFromat = $locale.DATETIME_FORMATS.shortDate;
		vm.dateWithDayFormat = $locale.DATETIME_FORMATS.shortWithDay;
		vm.dateWithDayFormatUI = $locale.DATETIME_FORMATS.shortWithDayUI;
		vm.planningUrl = 'app/pages/calendar/feedingTable/tables/planning.table.html';
		vm.loadingUrl = 'app/pages/calendar/feedingTable/tables/loading.table.html';
		vm.droppingUrl = 'app/pages/calendar/feedingTable/tables/dropping.table.html';
		vm.notAvailableUrl = 'app/pages/calendar/feedingTable/feedingNotAvailable.html';
		vm.addNewEvent = addNewEvent;
		vm.showTimePickers = showTimePickers;
		vm.showRepeatBlock = showRepeatBlock;
		vm.openCreatePdf = openCreatePdf;
		vm.hideCreatePdfBlock = hideCreatePdfBlock;
		vm.openExportModal = openExportModal;
		vm.showNewDiscussion = showNewDiscussion;
		vm.exportPdf = exportPdf;
		vm.showCostChanged = showCostChanged;
		vm.uploadChanged = uploadChanged;
		vm.removeSelectedFile = removeSelectedFile;
		vm.loadRight = loadRight;
		vm.loadLeft = loadLeft;
		vm.selectPicture = selectPicture;
		vm.editEvent = editEvent;
		vm.closeEditBlock = closeEditBlock;
		vm.removePicture = removePicture;
		vm.updateEvent = updateEvent;
		vm.saveEvent = saveEvent;
		vm.init = init;
		vm.reloadPage = reloadPage;
		vm.closeModal = closeModal;
		vm.deleteEvent = deleteEvent;
		vm.deleteEventProceed = deleteEventProceed;
		vm.goToFeeding = goToFeeding;
		vm.back = back;
		vm.goToPage = goToPage;
		vm.goToEdit = goToEdit;
		vm.updateFeeding = updateFeeding;
		vm.deleteFeeding = deleteFeeding;
		vm.openModal = openModal;
		vm.filterEvents = filterEvents;
		vm.selectFilter = selectFilter;
		vm.checkAreAllFiltersSelected = checkAreAllFiltersSelected;
		vm.selectAllFilters = selectAllFilters;
		vm.selectAllFiltersChanged = selectAllFiltersChanged;
		vm.changeReportType = changeReportType;
		vm.reportTypeChanged = reportTypeChanged;
		vm.saveChanges = saveChanges;
		vm.setDirty = setDirty;
		vm.confirm = confirm;
		vm.cancel = cancel;
		vm.calendarDivLoaded = calendarDivLoaded;
		vm.cancelRecipeDetails = cancelRecipeDetails;
		vm.goToLoadingGraph = goToLoadingGraph;
		vm.checkStickyHeader = checkStickyHeader;
		vm.datepickerChanged = datepickerChanged;
		vm.openFilterModal = openFilterModal;
		vm.loadingEvents = true;
		vm.loadingCustomButtons = true;
		vm.options = {
			showWeeks: false
		};

		setRepeatList();
		setDefaultColors();
		setReportTypes();
		setCosts();
		init();

		function init() {
			removeDirty();
			vm.initLoading = true;
			vm.updateEventloading = true;
			vm.addNewEventShowRegular = true;
			vm.showCalendar = true;
			vm.feedingEvents = [];
			vm.loadingReports = [];
			vm.droppingReports = [];
			vm.updateList = [];
			vm.events = [];
			vm.feedingDates = {};
			vm.edited = false;
			vm.today = moment().format('YYYY-MM-DD');
			vm.todayWithTime = moment().format('YYYY-MM-DDTHH:mm:ss');
			vm.currentCalendarView = vm.deviceType ? 'agendaDay' : 'agendaWeek';
			vm.currentCalendarDate = new Date();
			vm.selected_picture_id = null;
			vm.hideRegularEvents = false;
			vm.recipeFilterActive = false;
			vm.allFiltersActive = false;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.from_calendar = JSON.parse(localStorage.getItem('from_calendar'));
			localStorage.removeItem('from_calendar');
			if (vm.settings.use_kgs) {
				vm.weight = 'Kg';
			} else {
				vm.weight = 'Lb';
			}
			toDataURL('assets/img/MmmooOgle_logo.png', function (dataurl) {
				vm.logo = dataurl;
			});
			toDataURL('assets/img/calendar.png', function (dataurl) {
				vm.defaultPicture = dataurl;
			});
			vm.eventEditable = false;
			vm.showCreatePdfBlock = false;
			vm.showAddPictureBlock = false;
			vm.showEditBlock = false;
			vm.file = null;
			vm.fileName = null;
			vm.tagsList = APP_CONST.constants.tags;
			vm.tagsList.splice(0, 1);
			vm.showFeedingDescription = false;
			vm.selectedRecipe = null;
			if (vm.settings && vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd.id;
				vm.selectedTeam = vm.settings.selectedTeam.id;
				checkLng();
				setTimes();
				vm.newEvent = {};
			} else {
				vm.selectedHerd = null;
				vm.loadingEvents = false;
			}
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			vm.datepickerStartOptions = {
				minDate: moment().subtract(30, 'days').toDate(),
				maxDate: moment().subtract(1, 'days').toDate()
			};
			vm.datepickerEndOptions = {
				minDate: moment().add(1, 'days').toDate(),
				maxDate: moment().add(30, 'days').toDate()
			};
		}

		function showCostChanged() {
			$cookies.put('show_cost', vm.showCost, {
				expires: moment().add(1, 'days').toDate()
			});
		}

		function setCosts() {
			vm.showCost = $cookies.get('show_cost') ? JSON.parse($cookies.get('show_cost')) : false;
		}

		function setReportTypes() {
			vm.reportTypes = [
				{
					label: i18nFilter('_m_f_calendar_report_loading_'),
					value: 1
				},
				{
					label: i18nFilter('_m_f_calendar_report_dropping_'),
					value: 2
				}
			];
			var type = $cookies.get('calendar_report_type');
			if (type != null) {
				if (parseInt(type) === 1) {
					vm.reportType = vm.reportTypes[0];
				} else {
					vm.reportType = vm.reportTypes[1] && vm.reportTypes[1].value ? vm.reportTypes[1] : vm.reportTypes[0];
				}
			} else {
				vm.reportType = vm.reportTypes[0];
			}
		}

		function goToEdit(isPremix, id) {
			var page = isPremix === true ? 'premixes.editPremix' : 'recipes.editRecipe';
			goToPage(page, id);
		}

		function goToPage(page, id) {
			localStorage.setItem('from_calendar', true);
			vm.redirectId = id;
			$state.go(page, {
				uuid: id ? id : vm.selectedRecipe.recipe_id
			});
		}

		function updateFeeding(action, data) {
			switch (action) {
				case 'remove':
					for (var i = 0; i < vm.feedingEvents.length; i++) {
						if (vm.feedingEvents[i].id == data) {
							vm.feedingEvents.splice(i, 1);
							break;
						}
					}
					break;
				case 'add':
					vm.feedingEvents.push({
						color: getColor(data),
						description: '',
						editable: vm.eventEditable,
						end: null,
						herd_id: vm.selectedHerd,
						id: data.id,
						pictures: [],
						recurring: 0,
						start: data.feeding_date,
						recipe_id: data.recipe_id,
						title: data.recipe_name + ': Feeding ' + data.feeding_number + i18nFilter('_m_f_recipe_load_') + (data.load_position + 1),
						is_report: false
					});
					break;
				case 'title':
					for (var j = 0; j < vm.feedingEvents.length; j++) {
						if (vm.feedingEvents[j].id == data.id) {
							vm.feedingEvents[j].title = data.recipe_name + ': Feeding ' + data.feeding_number + i18nFilter('_m_f_recipe_load_') + (data.load_position + 1);
							break;
						}
					}
					break;
				case 'set_update_data':
					setUpdateData(data);
					break;
				default:
					return;
			}
		}

		function deleteFeeding(number) {
			for (var i = 0; i < vm.feedingsList[vm.feedingIndex].feedings.length; i++) {
				if (vm.feedingsList[vm.feedingIndex].feedings[i].feeding_number == number) {
					vm.feedingsList[vm.feedingIndex].feedings.splice(i, 1);
					break;
				}
			}
			if (!vm.feedingsList[vm.feedingIndex].feedings.length) {
				vm.feedingsList.splice(vm.feedingIndex, 1);
				back();
			}
		}

		function setUpdateData(feeding) {
			var fIndex = 0;
			var found = false;
			main_loop: for (var i = 0; i < vm.feedingsList.length; i++) {
				if (vm.feedingsList[i].feeding_id === feeding.feeding_id) {
					fIndex = i;
					for (var j = 0; j < vm.updateList.length; j++) {
						if (vm.updateList[j].feeding_id === feeding.feeding_id) {
							found = true;
							break main_loop;
						}
					}
					break main_loop;
				}
			}
			if (!found) {
				vm.updateList.push(vm.feedingsList[fIndex]);
			}
		}

		function saveChanges() {
			vm.loadingPreview = true;
			var feedingList = angular.copy(vm.updateList);
			var isPremix = vm.updateList[0].is_premix;
			var saveList = [];
			if (vm.reportType.value === 1) {
				for (var i = 0; i < feedingList.length; i++) {
					saveList.push({
						feeding_date: feedingList[i].feeding_date,
						feeding_number: feedingList[i].feeding_number,
						recipe_id: feedingList[i].recipe_id,
						loads: setLoading(feedingList[i].feeding_loads),
						loading_status: feedingList[i].loading_status,
						feeding_id: feedingList[i].feeding_id ? feedingList[i].feeding_id : null
					});
				}
				if (isPremix) {
					calendarService
						.savePremixLoadingReport(saveList)
						.then(function () {
							try {
								resetReports();
								removeDirty();
								processFeedings(vm.eventRecipeID, vm.eventFeedingDate, vm.eventRecipeType);
							} catch (error) {
								init();
							}
						})
						.catch(function (error) {
							console.log(error);
							vm.loadingPreview = false;
							errorService.showErrorMessage(error, true, '_error_occurred_saving_loading_reports_');
						});
				} else {
					calendarService
						.saveLoadingReport(saveList)
						.then(function () {
							try {
								resetReports();
								removeDirty();
								processFeedings(vm.eventRecipeID, vm.eventFeedingDate, vm.eventRecipeType);
							} catch (error) {
								init();
							}
						})
						.catch(function (error) {
							console.log(error);
							vm.loadingPreview = false;
							errorService.showErrorMessage(error, true, '_error_occurred_saving_loading_reports_');
						});
				}
			} else if (vm.reportType.value === 2) {
				for (var j = 0; j < feedingList.length; j++) {
					saveList.push({
						feeding_id: feedingList[j].feeding_id,
						loads: setDropping(feedingList[j])
					});
				}
				calendarService
					.saveDroppingReport(saveList)
					.then(function () {
						try {
							resetReports();
							removeDirty();
							processFeedings(vm.eventRecipeID, vm.eventFeedingDate, vm.eventRecipeType);
						} catch (error) {
							init();
						}
					})
					.catch(function (error) {
						console.log(error);
						vm.loadingPreview = false;
						errorService.showErrorMessage(error, true, '_error_occurred_saving_dropping_reports_');
					});
			}

			function setLoading(loads) {
				var list = [];
				for (var loadIndex = 0; loadIndex < loads.length; loadIndex++) {
					//if (loads[loadIndex].dirty === true) {
					list.push({
						load_position: loads[loadIndex].load_position,
						actual_amount: loads[loadIndex].actual_amount ? loads[loadIndex].actual_amount : 0,
						loading_start: loads[loadIndex].loading_start ? moment(loads[loadIndex].loading_start).utc().format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
						loading_finish: loads[loadIndex].loading_finish ? moment(loads[loadIndex].loading_finish).utc().format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
						changed_loading_datetime: loads[loadIndex].changed_loading_datetime || false,
						visible: checkVisible(loads[loadIndex]),
						ingredients: setIngredients(loads[loadIndex].load_ingredient_list),
						loading_status: loads[loadIndex].loading_status,
						id: loads[loadIndex].id ? loads[loadIndex].id : null
					});
					//}
				}

				return list;

				function setIngredients(loadIngredients) {
					var list = [];
					for (var ingredientIndex = 0; ingredientIndex < loadIngredients.length; ingredientIndex++) {
						if (loadIngredients[ingredientIndex].dirty === true) {
							list.push({
								actual: loadIngredients[ingredientIndex].actual,
								id: loadIngredients[ingredientIndex].id,
								ration_feed_id: loadIngredients[ingredientIndex].ration_feed_id,
								visible: checkVisible(loadIngredients[ingredientIndex])
							});
						}
					}

					return list;
				}
			}

			function setDropping(feeding) {
				var list = [];
				for (var loadIndex = 0; loadIndex < feeding.feeding_loads.length; loadIndex++) {
					var loadObj = {
						feeding_id: feeding.feeding_loads[loadIndex].feeding_id,
						id: feeding.feeding_loads[loadIndex].id,
						visible: true,
						droppings: setUnloads(feeding.pen_feedings, feeding.feeding_loads[loadIndex].id)
					};
					if (loadObj.droppings.length > 0) {
						list.push(loadObj);
					}
				}
				return list;

				function setUnloads(pens, loadId) {
					var list = [];
					for (var penIndex = 0; penIndex < pens.length; penIndex++) {
						if (pens[penIndex].dirty === true) {
							for (var unloadIndex = 0; unloadIndex < pens[penIndex].load_dropped_report.length; unloadIndex++) {
								if (pens[penIndex].load_dropped_report[unloadIndex].dirty === true && pens[penIndex].load_dropped_report[unloadIndex].load_id === loadId) {
									list.push({
										dropped: pens[penIndex].load_dropped_report[unloadIndex].actual_loaded,
										id: pens[penIndex].load_dropped_report[unloadIndex].unload_id,
										pen_id: pens[penIndex].pen_id,
										amount: pens[penIndex].feeding_amount,
										status: pens[penIndex].load_dropped_report[unloadIndex].status,
										dropping_start: pens[penIndex].load_dropped_report[unloadIndex].unloading_start ? moment(pens[penIndex].load_dropped_report[unloadIndex].unloading_start).utc().format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
										dropping_finish: pens[penIndex].load_dropped_report[unloadIndex].unloading_finish ? moment(pens[penIndex].load_dropped_report[unloadIndex].unloading_finish).utc().format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
										visible: checkVisible(pens[penIndex].load_dropped_report[unloadIndex])
									});
								}
							}
						}
					}
					return list;
				}
			}

			function checkVisible(data) {
				return data.visible !== false ? true : false;
			}
		}

		function resetReports() {
			vm.updateList = [];
			vm.loadingReports = [];
			vm.droppingReports = [];
		}

		function goToFeeding(prop) {
			if (vm.dirty === true) {
				vm.confirmationPromise = $q.defer();
				openModal('app/pages/calendar/confirmation.modal.html', 'sm');
				$q.all([vm.confirmationPromise.promise]).then(function () {
					undoChanges();
					$timeout(function () {
						goToFeedingProceed(prop);
					}, 1);
				});
			} else {
				goToFeedingProceed(prop);
			}

			function goToFeedingProceed(prop) {
				if (prop == 'prev') {
					vm.feedingDatesIndex--;
					if (vm.feedingDatesIndex < 0) {
						vm.feedingDatesIndex = 0;
						return;
					}
				} else {
					vm.feedingDatesIndex++;
					if (vm.feedingDatesIndex > vm.feedingDates[vm.eventRecipeID].length - 1) {
						vm.feedingDatesIndex = vm.feedingDates[vm.eventRecipeID].length - 1;
						return;
					}
				}
				dataServiceFactory.feedingDate = vm.feedingDates[vm.eventRecipeID][vm.feedingDatesIndex];
				vm.eventFeedingDate = vm.feedingDates[vm.eventRecipeID][vm.feedingDatesIndex];
				$timeout(function () {
					processFeedings(vm.eventRecipeID, vm.feedingDates[vm.eventRecipeID][vm.feedingDatesIndex], vm.eventRecipeType);
				}, 10);
			}
		}

		function changeReportType(report) {
			if (vm.dirty === true) {
				vm.confirmationPromise = $q.defer();
				openModal('app/pages/calendar/confirmation.modal.html', 'sm');
				$q.all([vm.confirmationPromise.promise]).then(function () {
					undoChanges();
					$timeout(function () {
						changeReportProceed(report);
					}, 1);
				});
			} else {
				changeReportProceed(report);
			}

			function changeReportProceed(report) {
				if (report === 'to_loading') {
					vm.reportType = vm.reportTypes[0];
				} else {
					vm.reportType = vm.reportTypes[1];
				}
				vm.reportChanged = true;
				setReportCookie(vm.reportType.value);
				$timeout(function () {
					processFeedings(vm.eventRecipeID, vm.eventFeedingDate, vm.eventRecipeType);
				}, 10);
			}
		}

		function reportTypeChanged() {
			$timeout(function () {
				setReportCookie(vm.reportType.value);
				$('#calendar').fullCalendar('refetchEvents');
			}, 1);
		}

		function setReportCookie(type) {
			$cookies.put('calendar_report_type', type, {
				expires: moment().add(1, 'days').toDate()
			});
		}

		function setDefaultColors() {
			vm.colors = dataServiceFactory.colors;
		}

		function setRepeatList() {
			vm.repeatList = [
				{
					value: 0,
					label: i18nFilter('_calendar_do_not_repeat_')
				},
				{
					value: 1,
					label: i18nFilter('_calendar_daily_')
				},
				{
					value: 2,
					label: i18nFilter('_calendar_weekly_')
				},
				{
					value: 3,
					label: i18nFilter('_calendar_monthly_')
				},
				{
					value: 4,
					label: i18nFilter('_calendar_yearly_')
				}
			];
		}

		function reloadPage() {
			closeModal();
			init();
		}

		function checkLng() {
			if (vm.settings.language) {
				if (vm.settings.language == 'en-gb') {
					vm.locale = 'en-gb';
				} else if (vm.settings.language == 'en-us') {
					vm.locale = 'en';
				} else if (vm.settings.language == 'cs-cz') {
					vm.locale = 'cs';
				} else if (vm.settings.language == 'es-es') {
					vm.locale = 'es';
				} else if (vm.settings.language == 'nl-nl') {
					vm.locale = 'nl';
				} else if (vm.settings.language == 'it-it') {
					vm.locale = 'it';
				} else if (vm.settings.language == 'pl-pl') {
					vm.locale = 'pl';
				} else if (vm.settings.language == 'pt-br') {
					vm.locale = 'pt';
				} else if (vm.settings.language == 'de-de') {
					vm.locale = 'de';
				}
			} else {
				vm.locale = 'en-gb';
			}
		}

		function setTimes() {
			vm.times = [];
			var times = [
				'2018-07-10T00:00:00',
				'2018-07-10T00:30:00',
				'2018-07-10T01:00:00',
				'2018-07-10T01:30:00',
				'2018-07-10T02:00:00',
				'2018-07-10T02:30:00',
				'2018-07-10T03:00:00',
				'2018-07-10T03:30:00',
				'2018-07-10T04:00:00',
				'2018-07-10T04:30:00',
				'2018-07-10T05:00:00',
				'2018-07-10T05:30:00',
				'2018-07-10T06:00:00',
				'2018-07-10T06:30:00',
				'2018-07-10T07:00:00',
				'2018-07-10T07:30:00',
				'2018-07-10T08:00:00',
				'2018-07-10T08:30:00',
				'2018-07-10T09:00:00',
				'2018-07-10T09:30:00',
				'2018-07-10T10:00:00',
				'2018-07-10T10:30:00',
				'2018-07-10T11:00:00',
				'2018-07-10T11:30:00',
				'2018-07-10T12:00:00',
				'2018-07-10T12:30:00',
				'2018-07-10T13:00:00',
				'2018-07-10T13:30:00',
				'2018-07-10T14:00:00',
				'2018-07-10T14:30:00',
				'2018-07-10T15:00:00',
				'2018-07-10T15:30:00',
				'2018-07-10T16:00:00',
				'2018-07-10T16:30:00',
				'2018-07-10T17:00:00',
				'2018-07-10T17:30:00',
				'2018-07-10T18:00:00',
				'2018-07-10T18:30:00',
				'2018-07-10T19:00:00',
				'2018-07-10T19:30:00',
				'2018-07-10T20:00:00',
				'2018-07-10T20:30:00',
				'2018-07-10T21:00:00',
				'2018-07-10T21:30:00',
				'2018-07-10T22:00:00',
				'2018-07-10T22:30:00',
				'2018-07-10T23:00:00',
				'2018-07-10T23:30:00'
			];
			for (var i = 0; i < times.length; i++) {
				var date = new Date(times[i]);
				var obj = {
					date: date,
					date_string: $filter('date')(date, 'shortTime'),
					time: $filter('date')(date, 'HH:mm:ss')
				};
				vm.times.push(obj);
			}
		}

		function handleRecipes(callback) {
			vm.recipeList = [];
			var response = [].concat(vm.recipePlanners).concat(vm.premixReports);
			response = $filter('orderBy')(response, ['recipe_id', 'feeding_date', 'feeding_number']);
			for (var i = 0; i < response.length; i++) {
				var found = false;
				for (var j = 0; j < vm.colors.length; j++) {
					if (vm.colors[j].id && vm.colors[j].id == response[i].recipe_id) {
						found = true;
						break;
					}
				}
				if (!found) {
					response[i].color = setColorById(response[i].recipe_id);
				} else {
					response[i].color = getColorById(response[i].recipe_id);
				}
				var recFound = false;
				for (var k = 0; k < vm.recipeList.length; k++) {
					if (vm.recipeList[k].recipe_id === response[i].recipe_id) {
						recFound = true;
						break;
					}
				}
				if (!recFound) {
					vm.recipeList.push({
						recipe_id: response[i].recipe_id,
						recipe_name: response[i].recipe_name,
						selected: false,
						color: response[i].color
					});
				}
				if (response[i].feeding_loads) {
					response[i].feeding_loads = $filter('orderBy')(response[i].feeding_loads, 'load_position');
				}
				if (response[i].pen_feedings) {
					response[i].pen_feedings = $filter('orderBy')(response[i].pen_feedings, 'pen_id');
				}
			}
			vm.selectedRecipes = dataServiceFactory.selectedFilter ? dataServiceFactory.selectedFilter : vm.selectedRecipes;
			vm.recipeList.map(function (recipe) {
				recipe.selected = vm.filterUsed ? activeFilter(recipe.recipe_id) : vm.selectedRecipes && vm.selectedRecipes.length ? activeFilter(recipe.recipe_id) : true;
			});
			if (vm.regularEventsPresent && vm.initLoading) {
				vm.hideRegularEvents = true;
			}
			var recipes = handleEvents(response);
			var events = recipes.concat(vm.events);
			var filterActive = false;
			var filterByRecipe = [];
			for (var l = 0; l < vm.recipeList.length; l++) {
				if (!vm.recipeList[l].selected) {
					filterActive = true;
					filterByRecipe.push(vm.recipeList[l].recipe_id);
				}
			}
			if (filterActive || vm.hideRegularEvents) {
				vm.recipeFilterActive = true;
			} else {
				vm.recipeFilterActive = false;
				dataServiceFactory.selectedFilter = [];
			}
			if (vm.hideRegularEvents) {
				events = filterRegularCalendarEvents(events);
			}
			if (filterActive) {
				for (var m = 0; m < filterByRecipe.length; m++) {
					events = filterCalendarEventsByRecipeId(events, filterByRecipe[m]);
				}
			}
			callback(events);
		}

		function activeFilter(id) {
			for (var i = 0; i < vm.selectedRecipes.length; i++) {
				if (vm.selectedRecipes[i].recipe_id == id) {
					return vm.selectedRecipes[i].selected;
				}
			}
			return false;
		}

		function handleEvents(response) {
			if (vm.reportType.value === 1) {
				return handleLoadingEvents(response);
			} else {
				return handleDroppingEvents(response);
			}
		}

		function handleLoadingEvents(response) {
			var recipes = [];
			var reports = response;
			for (var i = 0; i < reports.length; i++) {
				var updatedPens = [];
				if (reports[i].pen_feedings && reports[i].pen_feedings.length) {
					for (var k = 0; k < reports[i].pen_feedings.length; k++) {
						if (reports[i].pen_feedings[k].pen && moment(reports[i].pen_feedings[k].pen.last_modified_date).isSame(moment(reports[i].feeding_date), 'day')) {
							if (reports[i].pen_feedings[k].pen.user_agent && reports[i].pen_feedings[k].pen.user_agent.indexOf('MmmooOgleApp') != -1) {
								updatedPens.push({
									last_modified_user: reports[i].pen_feedings[k].pen.last_modified_user,
									pen: reports[i].pen_feedings[k].pen.pen_name
								});
							}
						}
					}
				}

				for (var j = 0; j < reports[i].feeding_loads.length; j++) {
					setLoadDateAndTime(reports[i], reports[i].feeding_loads[j]);
					var devWarn = reports[i].feeding_loads[j].is_report && reports[i].feeding_loads[j].loading_status && (reports[i].feeding_loads[j].has_loading_deviation || reports[i].feeding_loads[j].has_loading_ingredients_deviation) ? true : undefined;

					var isEventReport = reports[i].feeding_loads[j].is_report ? true : false;
					var isEventPlanner = reports[i].feeding_loads[j].is_planner ? true : false;

					var startLoad = setLoadStartTime(reports[i].feeding_loads[j].loading_start, reports[i].feeding_loads[j].load_position, reports[i].feeding_loads[j].loading_status);
					var endLoad = setLoadEndTime(startLoad, reports[i].feeding_loads[j].loading_finish, reports[i].feeding_loads[j].loading_status);
					var originalEndLoad = reports[i].feeding_loads[j].loading_finish ? reports[i].feeding_loads[j].loading_finish : endLoad;

					var loadDeviation = unitConversionService.convertData(reports[i].feeding_loads[j].loading_deviation_percentage, ['round:0']);
					var titleLoad = reports[i].recipe_name + ': ' + i18nFilter('_m_f_recipe_load_') + ' ' + (reports[i].feeding_loads[j].load_position + 1);
					if (isEventReport && reports[i].feeding_loads[j].loading_status) {
						var deviation = i18nFilter('_m_f_reports_deviation_');
						titleLoad += ' - ' + deviation.substring(0, 3) + '. ' + loadDeviation + ' %/' + vm.weight;
					}

					var eventLoad = new LoadEvent(
						titleLoad,
						'',
						reports[i].feeding_loads[j].id,
						vm.selectedHerd,
						startLoad,
						endLoad,
						originalEndLoad,
						[],
						0,
						reports[i].recipe_id,
						vm.eventEditable,
						reports[i].color,
						isEventReport,
						isEventPlanner,
						reports[i].feeding_date,
						reports[i].feeding_loads[j].loading_status,
						loadDeviation,
						devWarn,
						invertColor(reports[i].color),
						reports[i].feeding_id,
						reports[i].feeding_loads[j].has_loading_conflict,
						reports[i].feeding_loads[j].has_conflict,
						reports[i].feeding_loads[j].actual_amount,
						reports[i].feeding_loads[j].amount,
						reports[i].type,
						reports[i].feeding_loads[j].calculated_amount,
						null,
						updatedPens
					);
					recipes.push(eventLoad);
				}
			}
			return recipes;
		}

		function handleDroppingEvents(response) {
			var recipes = [];
			var reports = response;
			for (var i = 0; i < reports.length; i++) {
				if (reports[i].is_premix !== true) {
					for (var j = 0; j < reports[i].feeding_loads.length; j++) {
						setLoadDateAndTime(reports[i], reports[i].feeding_loads[j]);
						var devWarn = reports[i].feeding_loads[j].is_report && reports[i].feeding_loads[j].dropping_status && reports[i].feeding_loads[j].has_pen_dropping_deviation ? true : undefined;

						var isEventReport = reports[i].feeding_loads[j].is_report ? true : false;
						var isEventPlanner = reports[i].feeding_loads[j].is_planner ? true : false;

						var startDrop = setLoadStartTime(reports[i].feeding_loads[j].dropping_start, reports[i].feeding_loads[j].load_position, reports[i].feeding_loads[j].dropping_status);
						var endDrop = setLoadEndTime(startDrop, reports[i].feeding_loads[j].dropping_finish, reports[i].feeding_loads[j].dropping_status);
						var originalEndDrop = reports[i].feeding_loads[j].dropping_finish ? reports[i].feeding_loads[j].dropping_finish : endDrop;

						var dropDeviation = unitConversionService.convertData(reports[i].feeding_loads[j].dropping_deviation_percentage, ['round:0']);
						var titleDrop = reports[i].recipe_name + ': ' + i18nFilter('_m_f_recipe_load_') + ' ' + (reports[i].feeding_loads[j].load_position + 1);
						if (isEventReport && reports[i].feeding_loads[j].dropping_status) {
							var deviation = i18nFilter('_m_f_reports_deviation_');
							titleDrop += ' - ' + deviation.substring(0, 3) + '. ' + dropDeviation + '%/' + vm.weight;
						}

						var eventDrop = new LoadEvent(
							titleDrop,
							'',
							reports[i].feeding_loads[j].id,
							vm.selectedHerd,
							startDrop,
							endDrop,
							originalEndDrop,
							[],
							0,
							reports[i].recipe_id,
							vm.eventEditable,
							reports[i].color,
							isEventReport,
							isEventPlanner,
							reports[i].feeding_date,
							reports[i].feeding_loads[j].dropping_status,
							dropDeviation,
							devWarn,
							invertColor(reports[i].color),
							reports[i].feeding_id,
							reports[i].feeding_loads[j].has_dropping_conflict,
							false,
							reports[i].feeding_loads[j].actual_amount,
							null,
							reports[i].type,
							null,
							reports[i].feeding_loads[j].drop_amount,
							null
						);
						recipes.push(eventDrop);
					}
				}
			}
			return recipes;
		}

		function setLoadDateAndTime(report, load) {
			if (report.feeding_number == 1) {
				if (!load.feeding_time) {
					load.feeding_time = '04:00:00Z';
				}
			} else if (report.feeding_number == 2) {
				if (!load.feeding_time) {
					load.feeding_time = '12:00:00Z';
				}
			} else {
				if (!load.feeding_time) {
					load.feeding_time = '19:00:00Z';
				}
			}
			if (!load.loading_start) {
				load.loading_start = moment.utc(report.feeding_date + 'T' + load.feeding_time).format('YYYY-MM-DDTHH:mm:ss');
			}
			if (!load.dropping_start) {
				load.dropping_start = moment.utc(report.feeding_date + 'T' + load.feeding_time).format('YYYY-MM-DDTHH:mm:ss');
			}
		}

		function LoadEvent(
			title,
			description,
			id,
			herd_id,
			start,
			end,
			original_end,
			pictures,
			recurring,
			recipe_id,
			editable,
			color,
			is_report,
			is_planner,
			feeding_date,
			status,
			deviation,
			deviation_warn,
			textColor,
			feeding_id,
			conflict,
			load_conflict,
			actual_amount,
			amount,
			recipe_type,
			calculated_amount,
			dropped_amount,
			updated_pens
		) {
			this.title = typeof title !== 'undefined' ? title : undefined;
			this.description = typeof description !== 'undefined' ? description : undefined;
			this.id = typeof id !== 'undefined' ? id : undefined;
			this.herd_id = typeof herd_id !== 'undefined' ? herd_id : undefined;
			this.start = typeof start !== 'undefined' ? start : undefined;
			this.end = typeof end !== 'undefined' ? end : undefined;
			this.original_end = typeof original_end !== 'undefined' ? original_end : undefined;
			this.pictures = typeof pictures !== 'undefined' ? pictures : undefined;
			this.recurring = typeof recurring !== 'undefined' ? recurring : undefined;
			this.recipe_id = typeof recipe_id !== 'undefined' ? recipe_id : undefined;
			this.editable = typeof editable !== 'undefined' ? editable : undefined;
			this.color = typeof color !== 'undefined' ? color : undefined;
			this.is_report = typeof is_report !== 'undefined' ? is_report : undefined;
			this.is_planner = typeof is_planner !== 'undefined' ? is_planner : undefined;
			this.feeding_date = typeof feeding_date !== 'undefined' ? feeding_date : undefined;
			this.status = typeof status !== 'undefined' ? status : undefined;
			this.deviation = typeof deviation !== 'undefined' && !isNaN(deviation) ? deviation : undefined;
			this.deviation_warn = typeof deviation_warn !== 'undefined' ? deviation_warn : undefined;
			this.textColor = typeof textColor !== 'undefined' ? textColor : undefined;
			this.feeding_id = typeof feeding_id !== 'undefined' ? feeding_id : undefined;
			this.conflict = typeof conflict !== 'undefined' ? conflict : undefined;
			this.load_conflict = typeof load_conflict !== 'undefined' ? load_conflict : undefined;
			this.actual_amount = typeof actual_amount !== 'undefined' ? actual_amount : undefined;
			this.dropped_amount = typeof dropped_amount !== 'undefined' ? dropped_amount : undefined;
			this.amount = typeof amount !== 'undefined' ? amount : undefined;
			this.recipe_type = typeof recipe_type !== 'undefined' ? recipe_type : undefined;
			this.calculated_amount = typeof calculated_amount !== 'undefined' ? calculated_amount : undefined;
			if (typeof feeding_date !== 'undefined' && typeof start !== 'undefined') {
				var dateTemp = moment(feeding_date).format('YYYY-MM-DD');
				var startTemp = moment(start).format('YYYY-MM-DD');
				this.actual_feeding_date = !moment(dateTemp).isSame(startTemp) ? start : undefined;
			}
			this.duration_time = humanizeDuration(moment.duration(moment(this.original_end).diff(this.start)));
			this.updated_pens = updated_pens || [];
		}

		function invertColor(hex) {
			hex = hex.slice(1);
			var r = parseInt(hex.substring(0, 2), 16) * 299,
				g = parseInt(hex.substring(2, 4), 16) * 587,
				b = parseInt(hex.substring(4, 6), 16) * 114;

			if ((r + g + b) / 1000 > 130) {
				return '#595959';
			} else {
				return '#ffffff';
			}
		}

		function setLoadStartTime(startDate, position, status) {
			var minutes = 0;
			if (!status) {
				minutes = 20 * position;
			}
			return moment(startDate).add(minutes, 'minutes').format('YYYY-MM-DDTHH:mm:ss');
		}

		function setLoadEndTime(startDate, endDate, status) {
			var end = null;
			if (!endDate || status === 0) {
				end = moment(startDate).add(20, 'minutes').format('YYYY-MM-DDTHH:mm:ss');
			} else {
				endDate = moment(endDate).format('YYYY-MM-DDTHH:mm:ss');
				var minutes = moment.duration(moment(endDate).diff(startDate)).asMinutes();
				if (minutes < 20) {
					minutes = 20;
				}
				end = moment(startDate).add(minutes, 'minutes').format('YYYY-MM-DDTHH:mm:ss');
			}
			return end;
		}

		function getEvents(start, end) {
			if (vm.selectedHerd) {
				var feedingStart = moment(start).format('YYYY-MM-DD');
				var feedingEnd = moment(end).subtract(1, 'day').format('YYYY-MM-DD');
				var suffix = 'herds/' + vm.selectedHerd + '/calendarevents/' + feedingStart + '/' + feedingEnd;
				$timeout(function () {
					try {
						if (events && events.promise && events.promise['$$state'] && events.promise['$$state'].status === 0) {
							events.resolve();
						}
					} catch (error) {
						$timeout(function () {
							events.resolve();
						}, 5000);
					}
				}, 5000);
				return calendarService
					.getEvents(suffix)
					.then(function (response) {
						vm.responseEvents = response;
						vm.events = [];
						if (response.length > 0) {
							vm.regularEventsPresent = true;
							for (var i = 0; i < response.length; i++) {
								for (var j = 0; j < response[i].Dates.length; j++) {
									var start = response[i].Dates[j].StartDate ? response[i].Dates[j].StartDate : null;
									var end = response[i].Dates[j].EndDate ? response[i].Dates[j].EndDate : null;
									if (!end && start) {
										start = $filter('date')(start, 'yyyy-MM-dd');
									}
									if (start && $filter('date')(start, 'HH:mm:ss') == '00:00:00' && end && $filter('date')(end, 'HH:mm:ss') == '00:00:00') {
										start = $filter('date')(start, 'yyyy-MM-dd');
										end = $filter('date')(end, 'yyyy-MM-dd');
									}
									var event = {
										title: response[i].Title,
										description: response[i].Description,
										id: response[i].Id,
										herd_id: response[i].HerdId,
										start: start,
										end: end,
										pictures: response[i].Pictures,
										recurring: response[i].Recurring,
										recurringEndDate: response[i].RecurringEndDate,
										recurringInterval: response[i].RecurringInterval
									};
									vm.events.push(event);
								}
							}
						} else {
							vm.regularEventsPresent = false;
						}
						events.resolve();
					})
					.catch(function (error) {
						console.log(error);
					});
			} else {
				vm.events = [];
				events.resolve();
			}
		}

		function getFeedings(start, end) {
			if (vm.selectedHerd) {
				var feedingStart = moment(start).format('YYYY-MM-DD');
				var feedingEnd = moment(end).subtract(1, 'day').format('YYYY-MM-DD');
				//if (!moment(feedingEnd).isBefore(vm.today)) {
				/*if (moment(feedingStart).isSameOrBefore(vm.today)) {
						feedingStart = moment().add(1, 'day').format('YYYY-MM-DD');
					}*/
				var suffix = '?herd=' + vm.selectedHerd + '&start=' + feedingStart + '&end=' + feedingEnd;
				return calendarService
					.getFeedingsbyHerd(suffix)
					.then(function (response) {
						response.forEach(function (feeding) {
							feeding.feeding_loads.forEach(function (load) {
								load.is_report = false;
								load.is_planner = false;
								if (load.loading_status) {
									load.is_report = true;
									feeding.is_report = true;
								}
								var start = load.loading_start ? load.loading_start : moment.utc(feeding.feeding_date + 'T' + load.feeding_time).format('YYYY-MM-DDTHH:mm:ss');
								if (moment(start).isBefore(vm.todayWithTime)) {
									load.is_report = true;
									feeding.is_report = true;
								} else {
									load.is_planner = true;
									feeding.is_planner = true;
								}
							});
						});
						vm.recipePlanners = response;
						feedingsPromise.resolve();
					})
					.catch(function (error) {
						console.log(error);
						feedingsPromise.reject();
					});
				/*} else {
					vm.recipePlanners = [];
					feedingsPromise.resolve();
				}*/
			} else {
				feedingsPromise.reject();
			}
		}

		/*function getFeedingReports(start, end) {
			if (vm.selectedHerd) {
				var feedingStart = moment(start).format('YYYY-MM-DD');
				var feedingEnd = moment(end).subtract(1, 'day').format('YYYY-MM-DD');
				if (!moment(feedingStart).isAfter(vm.today)) {
					if (moment(feedingEnd).isAfter(vm.today)) {
						feedingEnd = moment().format('YYYY-MM-DD');
					}
					var suffix = '?herd=' + vm.selectedHerd + '&start=' + feedingStart + '&end=' + feedingEnd;
					return calendarService
						.getFeedingReports(suffix)
						.then(function (response) {
							response.forEach(function (feeding) {
								feeding.feeding_loads.forEach(function (load) {
									load.is_report = false;
									load.is_planner = false;
									if (load.loading_status) {
										load.is_report = true;
										feeding.is_report = true;
									}
									var start = load.loading_start ? load.loading_start : moment.utc(feeding.feeding_date + 'T' + load.feeding_time).format('YYYY-MM-DDTHH:mm:ss');
									if (moment(start).isBefore(vm.todayWithTime)) {
										load.is_report = true;
										feeding.is_report = true;
									} else {
										load.is_planner = true;
										feeding.is_planner = true;
									}
								});
							});
							vm.recipeReports = response;
							reportPromise.resolve();
						})
						.catch(function (error) {
							console.log(error);
							reportPromise.reject();
						});
				} else {
					vm.recipeReports = [];
					reportPromise.resolve();
				}
			} else {
				reportPromise.reject();
			}
		}*/

		function getPremixReports(start, end) {
			if (vm.selectedHerd) {
				var feedingStart = moment(start).format('YYYY-MM-DD');
				var feedingEnd = moment(end).subtract(1, 'day').format('YYYY-MM-DD');
				var suffix = '?herd=' + vm.selectedHerd + '&start=' + feedingStart + '&end=' + feedingEnd;
				return calendarService
					.getPremixReports(suffix)
					.then(function (response) {
						response.forEach(function (feeding) {
							feeding.feeding_date = feeding.date;
							delete feeding.date;
							feeding.feeding_id = feeding.load_subject_id;
							delete feeding.load_subject_id;
							feeding.feeding_loads = feeding.loads;
							delete feeding.loads;
							feeding.feeding_amount = feeding.premix_amount;
							delete feeding.premix_amount;
							feeding.feeding_number = feeding.premix_period;
							delete feeding.premix_period;
							feeding.is_premix = true;
							feeding.feeding_loads.forEach(function (load) {
								load.is_report = false;
								load.is_planner = false;
								if (load.loading_status) {
									load.is_report = true;
									feeding.is_report = true;
								}
								var start = load.loading_start ? load.loading_start : moment.utc(feeding.feeding_date + 'T' + load.feeding_time).format('YYYY-MM-DDTHH:mm:ss');
								if (moment(start).isBefore(vm.todayWithTime)) {
									load.is_report = true;
									feeding.is_report = true;
								} else {
									load.is_planner = true;
									feeding.is_planner = true;
								}
							});
						});
						vm.premixReports = response;
						premixPromise.resolve();
					})
					.catch(function (error) {
						console.log(error);
						premixPromise.reject();
					});
			} else {
				premixPromise.reject();
			}
		}

		function getPremixReportsById(recipe_id, date) {
			var suffix = '?recipe=' + recipe_id + '&date=' + date + '&herd=' + vm.selectedHerd;
			return calendarService
				.getPremixReportsById(suffix)
				.then(function (response) {
					feedingTableService.setLoading(response);
					for (var i = 0; i < response.length; i++) {
						response[i].feeding_date = response[i].date;
						delete response[i].date;
						response[i].feeding_id = response[i].load_subject_id;
						delete response[i].load_subject_id;
						response[i].feeding_loads = response[i].loads;
						delete response[i].loads;
						response[i].feeding_amount = response[i].exception_amount || response[i].premix_amount;
						response[i].original_amount = response[i].premix_amount;
						response[i].feeding_number = response[i].premix_period;
						delete response[i].premix_period;
						var isReport = feedingTableService.checkIsReport(response[i], vm.todayWithTime);
						var isPlanner = feedingTableService.checkIsPlanner(response[i], vm.todayWithTime);
						for (var j = 0; j < response[i].feeding_loads.length; j++) {
							response[i].feeding_loads[j].loading_status = response[i].feeding_loads[j].loading_status;
							response[i].feeding_loads[j].mixer_wagon = {
								name: response[i].feeding_loads[j].mixer_wagon_name
							};
							delete response[i].feeding_loads[j].status;
							response[i].feeding_loads[j].is_report = isReport;
							response[i].feeding_loads[j].is_planner = isPlanner;
							if (response[i].feeding_loads[j].is_report) {
								for (var k = 0; k < response[i].feeding_loads[j].load_ingredient_list.length; k++) {
									for (var l = 0; l < response[i].recipe_premix_scheduler.scheduled_premix_ingredients.length; l++) {
										if (response[i].feeding_loads[j].load_ingredient_list[k].ration_feed_id === response[i].recipe_premix_scheduler.scheduled_premix_ingredients[l].id) {
											response[i].feeding_loads[j].load_ingredient_list[k].cost = (response[i].recipe_premix_scheduler.scheduled_premix_ingredients[l].cost_dm * response[i].recipe_premix_scheduler.scheduled_premix_ingredients[l].dm) / 100;
											break;
										}
									}
								}
							}
						}
						response[i].is_report = isReport;
						response[i].is_planner = isPlanner;
						response[i].is_premix = true;
					}
					vm.loadingReports = vm.loadingReports.concat(response);
					if (vm.reportType.value === 1) {
						loadingByIdPromise.resolve(response);
					} else {
						loadingByIdPromise.resolve();
					}
				})
				.catch(function (error) {
					console.log(error);
					loadingByIdPromise.reject();
				});
		}

		function getLoadingReportsById(recipe_id, date) {
			var suffix = '?recipe=' + recipe_id + '&date=' + date + '&herd=' + vm.selectedHerd;
			return calendarService
				.getLoadingReports(suffix)
				.then(function (response) {
					feedingTableService.setLoading(response);
					for (var i = 0; i < response.length; i++) {
						var isReport = feedingTableService.checkIsReport(response[i], vm.todayWithTime);
						var isPlanner = feedingTableService.checkIsPlanner(response[i], vm.todayWithTime);
						response[i].original_amount = response[i].feeding_amount;
						response[i].feeding_amount = response[i].exception_amount || response[i].feeding_amount;
						for (var j = 0; j < response[i].feeding_loads.length; j++) {
							response[i].feeding_loads[j].is_report = isReport;
							response[i].feeding_loads[j].is_planner = isPlanner;
						}
						for (var m = 0; m < response[i].pen_feedings.length; m++) {
							response[i].pen_feedings[m].feeding_amount = response[i].pen_feedings[m].exception_amount || response[i].pen_feedings[m].feeding_amount;
						}
						response[i].is_report = isReport;
						response[i].is_planner = isPlanner;
					}
					vm.loadingReports = vm.loadingReports.concat(response);
					if (vm.reportType.value === 1) {
						loadingByIdPromise.resolve(response);
					} else {
						loadingByIdPromise.resolve();
					}
				})
				.catch(function (error) {
					console.log(error);
					loadingByIdPromise.reject();
				});
		}

		function getDroppingReportsById(recipe_id, date) {
			var suffix = '?recipe=' + recipe_id + '&date=' + date + '&herd=' + vm.selectedHerd;
			return calendarService
				.getDroppingReports(suffix)
				.then(function (response) {
					$q.all([loadingByIdPromise.promise])
						.then(function () {
							feedingTableService.setDropping(response);
							var loadingData = feedingTableService.getLoading();
							for (var i = 0; i < response.length; i++) {
								var isReport = feedingTableService.checkIsReport(response[i], vm.todayWithTime);
								var isPlanner = feedingTableService.checkIsPlanner(response[i], vm.todayWithTime);
								response[i].original_amount = response[i].feeding_amount;
								response[i].pen_feedings = response[i].pen_dropping_report;
								delete response[i].pen_dropping_report;
								response[i].feeding_loads = response[i].loads;
								delete response[i].loads;
								for (var j = 0; j < response[i].pen_feedings.length; j++) {
									response[i].pen_feedings[j].visible = setPenVisible(loadingData, response[i]);
									response[i].pen_feedings[j].feeding_amount = response[i].pen_feedings[j].exception_amount || response[i].pen_feedings[j].pen_feeding_amount;
								}
								for (var k = 0; k < response[i].feeding_loads.length; k++) {
									response[i].feeding_loads[k].is_report = isReport;
									response[i].feeding_loads[k].is_planner = isPlanner;
								}
								response[i].is_report = isReport;
								response[i].is_planner = isPlanner;
								response[i].recipe_visible = setRecipeVisible(loadingData, response);
							}
							vm.droppingReports = vm.droppingReports.concat(response);
							if (vm.reportType.value === 2) {
								droppingByIdPromise.resolve(response);
							} else {
								droppingByIdPromise.resolve();
							}
						})
						.catch(function () {
							droppingByIdPromise.reject();
						});
				})
				.catch(function (error) {
					console.log(error);
					droppingByIdPromise.reject();
				});
		}

		function setRecipeVisible(load, drop) {
			for (var i = 0; i < load.length; i++) {
				for (var d = 0; d < drop.length; d++) {
					if (load[i].feeding_id == drop[d].feeding_id) {
						return load[i].recipe_visible;
					}
				}
			}
		}

		function setPenVisible(load, drop) {
			for (var i = 0; i < load.length; i++) {
				if (load[i].feeding_id == drop.feeding_id) {
					for (var j = 0; j < load[i].pen_feedings.length; j++) {
						return load[i].pen_feedings[j].pen ? load[i].pen_feedings[j].pen.visible : false;
					}
				}
			}
		}

		function openModal(page, size) {
			return $uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function selectFilter(type, index) {
			if (type == 'recipe') {
				vm.recipeList[index].selected = !vm.recipeList[index].selected;
			} else if (type == 'regular') {
				vm.hideRegularEvents = !vm.hideRegularEvents;
			}
			checkAreAllFiltersSelected();
		}

		function selectAllFilters() {
			vm.allFiltersActive = !vm.allFiltersActive;
			selectAllFiltersChanged();
		}

		function selectAllFiltersChanged() {
			if (vm.allFiltersActive) {
				for (var i = 0; i < vm.recipeList.length; i++) {
					vm.recipeList[i].selected = true;
				}
				if (vm.regularEventsPresent && vm.updateEventloading && vm.addNewEventShowRegular) {
					vm.hideRegularEvents = false;
				}
			} else {
				for (var j = 0; j < vm.recipeList.length; j++) {
					vm.recipeList[j].selected = false;
				}
				if (vm.regularEventsPresent) {
					vm.hideRegularEvents = true;
				}
			}
		}

		function checkAreAllFiltersSelected() {
			var unselectedPresent = false;
			for (var i = 0; i < vm.recipeList.length; i++) {
				if (!vm.recipeList[i].selected) {
					unselectedPresent = true;
					break;
				}
			}
			if (unselectedPresent || vm.hideRegularEvents) {
				vm.allFiltersActive = false;
			} else {
				vm.allFiltersActive = true;
			}
		}

		function filterEvents() {
			vm.initLoading = false;
			vm.selectedRecipes = [];
			if (vm.isReportTypeChanged) {
				vm.isReportTypeChanged = false;
				setReportCookie(vm.reportType.value);
			}
			var anyRecipeSelected = false;
			for (var i = 0; i < vm.recipeList.length; i++) {
				if (vm.recipeList[i].selected) {
					vm.selectedRecipes.push(vm.recipeList[i]);
					dataServiceFactory.selectedFilter = vm.selectedRecipes;
					anyRecipeSelected = true;
				}
			}
			if (!anyRecipeSelected) {
				vm.selectedRecipes = [];
				dataServiceFactory.selectedFilter = [];
			}

			vm.filterUsed = true;

			$('#calendar').fullCalendar('refetchEvents');
			closeModal();
		}

		function setColorById(id) {
			var color;
			var index = -1;
			for (var i = 0; i < vm.colors.length; i++) {
				if (vm.colors[i].id == undefined || vm.colors[i].id == null) {
					color = vm.colors[i].color;
					index = i;
					break;
				}
			}
			if (index >= 0) {
				dataServiceFactory.colors[index].id = id;
			} else {
				color = getRandomColor();
				var obj = {
					color: color,
					id: id
				};
				dataServiceFactory.colors.push(obj);
			}

			return color;
		}

		function getRandomColor() {
			var uniqueColor = false;
			var color;
			do {
				color = '#' + Math.floor(Math.random() * 16777215).toString(16);
				if (checkIsUnique(color)) {
					uniqueColor = true;
				}
			} while (!uniqueColor);
			return color;
		}

		function checkIsUnique(color) {
			var unique = true;
			for (var i = 0; i < vm.colors.length; i++) {
				if (vm.colors[i].color == color) {
					unique = false;
					break;
				}
			}

			return unique;
		}

		function getColorById(id) {
			var color;
			for (var i = 0; i < vm.colors.length; i++) {
				if (vm.colors[i].id == id) {
					color = vm.colors[i].color;
					break;
				}
			}

			return color;
		}

		function openEventModal(allDay) {
			vm.showRepeat = false;
			vm.showPictures = true;
			vm.loadingAddNewEvent = false;
			vm.showAddPictureBlock = false;
			if (allDay) {
				vm.showTime = true;
				var startTime = vm.newEvent.start.split('T')[1];
				var endTime = vm.newEvent.end.split('T')[1];
				vm.newEvent.startTime = { time: startTime };
				vm.newEvent.endTime = { time: endTime };
				for (var i = 0; i < vm.times.length; i++) {
					if (vm.times[i].time == startTime) {
						vm.newEvent.startTime = vm.times[i];
					}
					if (vm.times[i].time == endTime) {
						vm.newEvent.endTime = vm.times[i];
					}
				}
			} else {
				vm.showTime = false;
			}
			vm.newEvent.startDate = new Date(vm.newEvent.start);
			vm.newEvent.endDate = new Date(vm.newEvent.end);
			vm.selected_picture_id = null;
			getPicturesByHerd(vm.selectedHerd);
			$uibModal
				.open({
					animation: true,
					templateUrl: 'app/pages/calendar/newEvent.modal.html',
					size: 'md',
					scope: $scope,
					backdrop: 'static',
					keyboard: false
				})
				.closed.then(function () {
					$('#calendar').fullCalendar('unselect');
					vm.newEvent = {};
				});
		}

		function updateEvent(event, newStart, newEnd) {
			var newEvent;
			for (var i = 0; i < vm.responseEvents.length; i++) {
				if (event.id == vm.responseEvents[i].Id) {
					newEvent = vm.responseEvents[i];
					break;
				}
			}
			if (newEvent) {
				var suffix = '?id=' + newEvent.Id + '&';
				var herd_id = newEvent.HerdId;
				var has_start;
				var has_end;
				var has_title;
				var has_description;
				var has_repeat;
				var has_repeat_interval;
				if (newEvent.StartDate) {
					suffix = suffix + 'startDate=' + newStart;
					has_start = true;
				}
				if (newEvent.EndDate) {
					if (has_start) {
						suffix = suffix + '&';
					}
					suffix = suffix + 'endDate=' + newEnd;
					has_end = true;
				}
				if (newEvent.Title) {
					if (has_start || has_end) {
						suffix = suffix + '&';
					}
					suffix = suffix + 'title=' + newEvent.Title;
					has_title = true;
				}
				if (newEvent.Description) {
					if (has_start || has_end || has_title) {
						suffix = suffix + '&';
					}
					suffix = suffix + 'description=' + newEvent.Description;
					has_description = true;
				}
				if (newEvent.Recurring) {
					if (has_start || has_end || has_title || has_description) {
						suffix = suffix + '&';
					}
					suffix = suffix + 'recurring=' + newEvent.Recurring;
					has_repeat = true;
				}
				if (newEvent.RecurringInterval) {
					if (has_start || has_end || has_title || has_description || has_repeat) {
						suffix = suffix + '&';
					}
					suffix = suffix + 'recurringinterval=' + newEvent.RecurringInterval;
					has_repeat_interval = true;
				}
				if (newEvent.RecurringEndDate) {
					if (has_start || has_end || has_title || has_description || has_repeat || has_repeat_interval) {
						suffix = suffix + '&';
					}
					suffix = suffix + 'recurringenddate=' + newEvent.RecurringEndDate;
				}
				return calendarService
					.updateEvent(herd_id, suffix)
					.then(function (response) {
						for (var i = 0; i < vm.responseEvents.length; i++) {
							if (vm.responseEvents[i].id == response.id) {
								vm.responseEvents[i] = response;
								break;
							}
						}
					})
					.catch(function (error) {
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_updating_event_');
					});
			}
		}

		function showRepeatBlock() {
			if (vm.showRepeat) {
				vm.showRepeat = false;
			} else {
				vm.showRepeat = true;
				vm.newEvent.repeatType = vm.repeatList[0];
			}
		}

		function addNewEvent() {
			if (vm.file) {
				eventPromise = $q.defer();
				picturePromise = $q.defer();
				$q.all([eventPromise.promise, picturePromise.promise])
					.then(function (responses) {
						vm.selected_picture_id = responses[1].Id;
						addPictureToEvent(responses[0]);
					})
					.catch(function (error) {
						console.log(error);
					});
				postNewEvent(true);
				postNewPicture();
			} else {
				postNewEvent(false);
			}
		}

		function postNewEvent(with_picture) {
			vm.loadingAddNewEvent = true;
			var start = null;
			var end = null;
			if (vm.showTime) {
				start = $filter('date')(vm.newEvent.startDate, 'yyyy-MM-dd') + 'T' + vm.newEvent.startTime.momentTime.format('HH:mm:ss');
				end = $filter('date')(vm.newEvent.endDate, 'yyyy-MM-dd') + 'T' + vm.newEvent.endTime.momentTime.format('HH:mm:ss');
			} else {
				start = $filter('date')(vm.newEvent.startDate, 'yyyy-MM-dd');
				end = $filter('date')(vm.newEvent.endDate, 'yyyy-MM-dd');
			}
			var suffix = '?';
			var herd_id = vm.selectedHerd;
			var has_start;
			var has_end;
			var has_title;
			var has_description;
			var has_repeat;
			var has_repeat_interval;
			if (start) {
				suffix = suffix + 'startDate=' + start;
				has_start = true;
			}
			if (end) {
				if (has_start) {
					suffix = suffix + '&';
				}
				suffix = suffix + 'endDate=' + end;
				has_end = true;
			}
			if (vm.newEvent.title) {
				if (has_start || has_end) {
					suffix = suffix + '&';
				}
				suffix = suffix + 'title=' + vm.newEvent.title;
				has_title = true;
			}
			if (vm.newEvent.description) {
				if (has_start || has_end || has_title) {
					suffix = suffix + '&';
				}
				suffix = suffix + 'description=' + vm.newEvent.description;
				has_description = true;
			}
			if (vm.showRepeat && vm.newEvent.repeatType.value) {
				if (has_start || has_end || has_title || has_description) {
					suffix = suffix + '&';
				}
				suffix = suffix + 'recurring=' + vm.newEvent.repeatType.value;
				has_repeat = true;
			}
			if (vm.showRepeat && vm.newEvent.repeatType.value && vm.newEvent.repeatInterval) {
				if (has_start || has_end || has_title || has_description || has_repeat) {
					suffix = suffix + '&';
				}
				suffix = suffix + 'recurringinterval=' + vm.newEvent.repeatInterval;
				has_repeat_interval = true;
			}
			if (vm.showRepeat && vm.newEvent.repeatType.value && vm.newEvent.endRepeat) {
				if (has_start || has_end || has_title || has_description || has_repeat || has_repeat_interval) {
					suffix = suffix + '&';
				}
				suffix = suffix + 'recurringenddate=' + $filter('date')(vm.newEvent.endRepeat, 'yyyy-MM-dd');
			}
			return calendarService
				.addNewEvent(herd_id, suffix)
				.then(function (response) {
					if (with_picture) {
						eventPromise.resolve(response);
					} else {
						if (vm.selected_picture_id) {
							addPictureToEvent(response);
						} else {
							handleNewEventResponse(response);
							filterEvents();
							if (vm.addNewEventShowRegular) {
								vm.hideRegularEvents = false;
							}
							$('#calendar').fullCalendar('removeEvents');
							checkAreAllFiltersSelected();
						}
					}
				})
				.catch(function (error) {
					vm.loadingAddNewEvent = false;
					errorService.showErrorMessage(error, true, '_error_occurred_cerating_event_');
				});
		}

		function postNewPicture() {
			var suffix = '?created=' + new Date().toISOString();
			suffix = suffix + '&tags=calendarEvent';
			if (vm.file) {
				var url = APP_CONST.animals_base_url + 'herds/' + vm.selectedHerd + '/pictures' + suffix;
				Upload.upload({
					url: url,
					data: {
						file: vm.file
					}
				})
					.then(function (response) {
						picturePromise.resolve(response.data);
					})
					.catch(function (error) {
						vm.loadingNewDiscussion = false;
						console.log(error);
						vm.loadingAddNewEvent = false;
						errorService.showErrorMessage(error, true, '_error_occurred_adding_picture_');
					});
			} else {
				picturePromise.reject('no_file');
			}
		}

		function addPictureToEvent(event_response) {
			return calendarService
				.addPictureToEvent(event_response.Id, vm.selected_picture_id)
				.then(function (response) {
					handleNewEventResponse(response);
				})
				.catch(function (error) {
					console.log(error);
					vm.loadingAddNewEvent = false;
					errorService.showErrorMessage(error, true, '_error_occurred_adding_picture_');
				});
		}

		function handleNewEventResponse(response) {
			for (var j = 0; j < response.Dates.length; j++) {
				var start = response.Dates[j].StartDate ? response.Dates[j].StartDate : null;
				var end = response.Dates[j].EndDate ? response.Dates[j].EndDate : null;
				if (!end && start) {
					start = $filter('date')(start, 'yyyy-MM-dd');
				}
				if (start && $filter('date')(start, 'HH:mm:ss') == '00:00:00' && end && $filter('date')(end, 'HH:mm:ss') == '00:00:00') {
					start = $filter('date')(start, 'yyyy-MM-dd');
					end = $filter('date')(end, 'yyyy-MM-dd');
				}
				var event = {
					title: response.Title,
					description: response.Description,
					id: response.Id,
					herd_id: response.HerdId,
					start: start,
					end: end,
					pictures: response.Pictures
				};
				$('#calendar').fullCalendar('renderEvent', event, true);
			}
			if (vm.responseEvents && vm.responseEvents.length > 0) {
				vm.responseEvents.push(response);
			} else {
				vm.responseEvents = [response];
			}
			vm.newEvent.title = null;
			closeModal();
		}

		function processFeedings(id, date, type, init) {
			vm.loadingPreview = true;
			loadingByIdPromise = $q.defer();
			droppingByIdPromise = $q.defer();
			if (vm.selectedRecipe && vm.selectedRecipe.recipe_id !== id) {
				vm.selectedRecipe = null;
			}
			if (vm.selectedRecipe) {
				vm.selectedRecipe.feeding_date = $filter('date')(date, vm.dateWithDayFormat);
			}
			getReportsById(id, date, type);
			var promiseList = [];
			if (type === 0) {
				promiseList.push(loadingByIdPromise.promise, droppingByIdPromise.promise);
			} else {
				promiseList.push(loadingByIdPromise.promise);
			}
			$q.all(promiseList)
				.then(function (response) {
					var list = response[0] || response[1] || [];
					vm.displayButtons = 0;
					vm.hideNavButtons = false;
					if (list.length) {
						if (!vm.feedingDates[id]) {
							vm.feedingDates[id] = feedingTableService.getFeedingDates();
						}
						vm.feedingDatesIndex = vm.feedingDates[id].indexOf(date);
						for (var i = 0; i < list.length; i++) {
							if (list[i].is_premix === true) {
								vm.hideNavButtons = true;
							}
							if (!list[i].ration) {
								var feedingFromService = feedingTableService.getLoading();
								for (var j = 0; j < feedingFromService.length; j++) {
									//if (list[i].feeding_id === feedingFromService[j].feeding_id) {
									if (list[i].feeding_date == feedingFromService[j].feeding_date && list[i].feeding_number == feedingFromService[j].feeding_number) {
										list[i].ration = feedingFromService[j].recipe_ration_scheduler || feedingFromService[j].recipe_premix_scheduler;
										break;
									}
								}
							}
							if (!vm.selectedRecipe) {
								vm.selectedRecipe = new SetRecipeInfo(list[i], date);
							}
							if (list[i].is_report !== true) {
								list[i].url = vm.planningUrl;
								if (!list[i].planning_processed) {
									setPlanningData(list[i]);
								}
							} else {
								vm.displayButtons = vm.reportType.value;
								if (vm.reportType.value === 1) {
									list[i].url = vm.loadingUrl;
									list[i].report_type = 1;
									setLoadingData(list[i]);
								} else {
									list[i].url = vm.droppingUrl;
									list[i].report_type = 2;
									setDroppingData(list[i]);
								}
							}
						}
					} else {
						list = [
							{
								url: vm.notAvailableUrl
							}
						];
					}
					$timeout(function () {
						vm.feedingsList = list;
						vm.loadingEvents = false;
						vm.loadingPreview = false;
						vm.showFeedingDescription = true;
						disableHerdSelector(true);
					}, 50);
				})
				.catch(function (error) {
					vm.loadingEvents = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_reports_', init);
					bugsnagService.logMessage('Feeding date = ' + vm.eventFeedingDate, null, 'warning');
				});

			function setPlanningData(feeding) {
				feeding.planing_amount_sum = 0;
				feeding.feeding_interval_change = setFeedingIntervalChange(feeding);
				if (feeding.feeding_loads) {
					for (var i = 0; i < feeding.feeding_loads.length; i++) {
						feeding.planing_amount_sum += feeding.feeding_loads[i].amount;
						feeding.feeding_loads[i].mixing_time_deviation_warn = feeding.feeding_loads[i].mixing_time && feeding.feeding_loads[i].actual_mixing_time ? feeding.feeding_loads[i].mixing_time != feeding.feeding_loads[i].actual_mixing_time ? true : false : false;
						if (!isNaN(feeding.feeding_loads[i].calculated_amount)) {
							if (unitConversionService.convertData(feeding.feeding_loads[i].calculated_amount, ['round:0']) !== unitConversionService.convertData(feeding.feeding_loads[i].amount, ['round:0'])) {
								feeding.feeding_loads[i].load_changed = true;
							}
						}
						feeding.feeding_loads[i].load_name = i18nFilter('_m_f_recipe_load_') + ' ' + (feeding.feeding_loads[i].load_position + 1);
						feeding.feeding_loads[i].wagon = getApiData(feeding.feeding_loads[i].mixer_wagon_id, 'wagons');
						feeding.feeding_loads[i].planning_ingredients = [];
						if (feeding.ration) {
							var scheduledFeeds = feeding.ration.scheduled_ration_feeds || feeding.ration.scheduled_premix_ingredients;
							scheduledFeeds.forEach(function (rationFeed) {
								feeding.feeding_loads[i].planning_ingredients.push({
									id: rationFeed.id,
									name: rationFeed.ration_feed_name || rationFeed.premix_ingredient_name,
									percentage: rationFeed.percentage / 100,
									amount: feeding.feeding_loads[i].amount * (rationFeed.percentage / 100),
									order_number: rationFeed.order_number
								});
							});

							feeding.feeding_loads[i].planning_ingredients = $filter('orderBy')(feeding.feeding_loads[i].planning_ingredients, 'order_number');
						}
						if (i === 0) {
							feeding.planning_ingredients = feeding.feeding_loads[i].planning_ingredients;
						}
					}
					if (feeding.pen_feedings) {
						for (var k = 0; k < feeding.pen_feedings.length; k++) {
							feeding.pen_feedings[k].pen = feedingTableService.getPenById(feeding.feeding_id, feeding.pen_feedings[k].pen_id);
							feeding.pen_feedings[k].updated_from_app = feeding.pen_feedings[k].pen && feeding.pen_feedings[k].pen.user_agent && feeding.pen_feedings[k].pen.user_agent.indexOf('MmmooOgleApp') !== -1 ? true : false;
						}
					}
					feeding.feeding_loads = $filter('orderBy')(feeding.feeding_loads, 'load_position');
				}
				//feeding.dm = feeding.ration ? feeding.ration.dm : undefined;
				if (feeding.feeding_number == 1) {
					feeding.feeding_name = i18nFilter('_m_f_pen_morning_feeding_short_');
				} else if (feeding.feeding_number == 2) {
					feeding.feeding_name = i18nFilter('_m_f_pen_noon_feeding_short_');
				} else {
					feeding.feeding_name = i18nFilter('_m_f_pen_evening_feeding_short_');
				}
			}

			function setLoadingData(feeding) {
				feeding.summary = feeding.summary || {};
				feeding.loading_feeders = [];
				feeding.feeding_interval_change = setFeedingIntervalChange(feeding);
				var loading_start = [];
				var loading_finish = [];
				if (feeding.feeding_loads && feeding.feeding_loads.length) {
					for (var k = 0; k < feeding.feeding_loads.length; k++) {
						feeding.feeding_loads[k].load_name = i18nFilter('_m_f_recipe_load_') + ' ' + (feeding.feeding_loads[k].load_position + 1);
						feeding.feeding_loads[k].loading_finish = feeding.feeding_loads[k].loading_status !== 0 ? feeding.feeding_loads[k].loading_finish : null;
						feeding.feeding_loads[k].mixing_time_deviation_warn = feeding.feeding_loads[k].mixing_time && feeding.feeding_loads[k].actual_mixing_time ? feeding.feeding_loads[k].mixing_time != feeding.feeding_loads[k].actual_mixing_time ? true : false : false;
						if (!isNaN(feeding.feeding_loads[k].calculated_amount)) {
							if (unitConversionService.convertData(feeding.feeding_loads[k].calculated_amount, ['round:0']) !== unitConversionService.convertData(feeding.feeding_loads[k].amount, ['round:0'])) {
								feeding.feeding_loads[k].load_changed = true;
							}
						}
						if (!feeding.feeding_loads[k].loading_start || !feeding.feeding_loads[k].dropping_start) {
							setLoadDateAndTime(feeding, feeding.feeding_loads[k]);
						}
						var loadDateTemp = moment(feeding.feeding_loads[k].loading_start).format('YYYY-MM-DD');
						if (!moment(feeding.feeding_date).isSame(loadDateTemp)) {
							feeding.feeding_loads[k].feeding_date_changed = true;
							feeding.loading_date_changed = true;
						}
						if (feeding.feeding_loads[k].loading_status) {
							loading_start.push(moment(feeding.feeding_loads[k].loading_start));
						}
						if (feeding.feeding_loads[k].loading_status && feeding.feeding_loads[k].loading_finish) {
							loading_finish.push(moment(feeding.feeding_loads[k].loading_finish));
						}
						if (feeding.feeding_loads[k].feeder) {
							setFeedersList(feeding.loading_feeders, feeding.feeding_loads[k].feeder);
						}
						if (feeding.feeding_loads[k].load_ingredient_list) {
							for (var m = 0; m < feeding.feeding_loads[k].load_ingredient_list.length; m++) {
								feeding.feeding_loads[k].load_ingredient_list[m].ingredient_calculated_cost = feeding.feeding_loads[k].load_ingredient_list[m].calculated * feeding.feeding_loads[k].load_ingredient_list[m].cost;
								feeding.feeding_loads[k].load_ingredient_list[m].ingredient_calculated_cost_dm = getCostDm(feeding.dm, feeding.feeding_loads[k].load_ingredient_list[m].ingredient_calculated_cost);
								feeding.feeding_loads[k].load_ingredient_list[m].ingredient_actual_cost = feeding.feeding_loads[k].load_ingredient_list[m].actual * feeding.feeding_loads[k].load_ingredient_list[m].cost;
								feeding.feeding_loads[k].load_ingredient_list[m].ingredient_actual_cost_dm = getCostDm(feeding.dm, feeding.feeding_loads[k].load_ingredient_list[m].ingredient_actual_cost);
								feeding.feeding_loads[k].load_ingredient_list[m].deviation = feeding.feeding_loads[k].load_ingredient_list[m].actual - feeding.feeding_loads[k].load_ingredient_list[m].calculated;
								feeding.feeding_loads[k].load_ingredient_list[m].deviation_percentage = !isNaN((feeding.feeding_loads[k].load_ingredient_list[m].deviation / feeding.feeding_loads[k].load_ingredient_list[m].calculated) * 100)
									? (feeding.feeding_loads[k].load_ingredient_list[m].deviation / feeding.feeding_loads[k].load_ingredient_list[m].calculated) * 100
									: 0;
								if (feeding.feeding_loads[k].load_ingredient_list[m].deviation_percentage >= 5 || feeding.feeding_loads[k].load_ingredient_list[m].deviation_percentage <= -5) {
									feeding.feeding_loads[k].load_ingredient_list[m].deviation_warn = true;
									feeding.feeding_loads[k].deviation_warn = true;
									feeding.feeding_loads[k].deviation_warn_text = i18nFilter('_m_f_calendar_ingredient_deviation_warning_');
								}
								feeding.feeding_loads[k].load_ingredient_list[m].order_changed = feeding.feeding_loads[k].load_ingredient_list[m].order_number != feeding.feeding_loads[k].load_ingredient_list[m].position ? true : false;
							}
						}
						feeding.feeding_loads[k].load_ingredient_list = $filter('orderBy')(feeding.feeding_loads[k].load_ingredient_list, 'order_number');
						if ((feeding.feeding_loads[k].loading_deviation_percentage >= 5 || feeding.feeding_loads[k].loading_deviation_percentage <= -5) && feeding.feeding_loads[k].loading_status !== 0) {
							feeding.feeding_loads[k].deviation_warn = true;
							feeding.feeding_loads[k].deviation_warn_text = i18nFilter('_m_f_calendar_load_deviation_warning_');
						}
						feeding.feeding_loads[k].load_calculated_cost = feedingTableService.calculateCalculatedLoadCostPerKg(feeding, feeding.feeding_loads[k].load_position, 'amount', 'calculated') * feeding.feeding_loads[k].amount;
						feeding.feeding_loads[k].load_calculated_cost_dm = getCostDm(feeding.dm, feeding.feeding_loads[k].load_calculated_cost);
						feeding.feeding_loads[k].load_actual_cost = feedingTableService.calculateLoadCostPerKg(feeding, feeding.feeding_loads[k].load_position, 'actual_amount', 'actual') * feeding.feeding_loads[k].actual_amount;
						feeding.feeding_loads[k].load_actual_cost_dm = getCostDm(feeding.dm, feeding.feeding_loads[k].load_actual_cost);
					}

					feeding.feeding_loads = $filter('orderBy')(feeding.feeding_loads, 'load_position');
				}
				if (feeding.pen_feedings) {
					for (var penIndex = 0; penIndex < feeding.pen_feedings.length; penIndex++) {
						feeding.pen_feedings[penIndex].pen_calculated_cost = feedingTableService.calculatePenCost(feeding, feeding.pen_feedings[penIndex], 1);
						feeding.pen_feedings[penIndex].pen_calculated_cost_dm = getCostDm(feeding.dm, feeding.pen_feedings[penIndex].pen_calculated_cost);
						feeding.pen_feedings[penIndex].updated_from_app = feeding.pen_feedings[penIndex].pen && feeding.pen_feedings[penIndex].pen.user_agent && feeding.pen_feedings[penIndex].pen.user_agent.indexOf('MmmooOgleApp') !== -1 ? true : false;
					}
				}
				if (loading_start.length > 0) {
					feeding.loading_start = moment.min(loading_start).format('YYYY-MM-DDTHH:mm:ss');
				} else {
					feeding.loading_start = findLoadStartTime(feeding.feeding_loads, 'loading_start');
				}
				if (loading_finish.length > 0 && feeding.loading_status !== 0) {
					feeding.loading_finish = moment.max(loading_finish).format('YYYY-MM-DDTHH:mm:ss');
				} else {
					feeding.loading_finish = null;
				}
				if (feeding.loading_start && feeding.loading_finish && feeding.loading_status !== 0) {
					feeding.loading_duration = humanizeDuration(moment.duration(moment(feeding.loading_finish).diff(feeding.loading_start)));
				} else {
					feeding.loading_duration = 0;
				}
				if (feeding.feeding_number == 1) {
					feeding.feeding_name = i18nFilter('_m_f_pen_morning_feeding_short_');
				} else if (feeding.feeding_number == 2) {
					feeding.feeding_name = i18nFilter('_m_f_pen_noon_feeding_short_');
				} else {
					feeding.feeding_name = i18nFilter('_m_f_pen_evening_feeding_short_');
				}
			}

			function setFeedingIntervalChange(_feeding) {
				var feeding_change = null;
				if (_feeding.exception_interval_percentage) {
					if (_feeding.exception_unit == '%') {
						feeding_change = _feeding.exception_interval_percentage;
					} else if (_feeding.exception_unit == 'h') {
						feeding_change = 0.24 * _feeding.exception_interval_percentage;
					}
				}
				return feeding_change;
			}

			function setDroppingData(feeding) {
				feeding.summary = feeding.summary || {};
				feeding.feeding_interval_change = setFeedingIntervalChange(feeding);
				feeding.summary.loads = feeding.summary.loads || feeding.feeding_loads;
				feeding.dropping_feeders = [];
				var dropping_start = [];
				var dropping_finish = [];
				if (feeding.pen_feedings) {
					for (var k = 0; k < feeding.pen_feedings.length; k++) {
						feeding.pen_feedings[k].dirty = false;
						feeding.pen_feedings[k].actual_amount = 0;
						feeding.pen_feedings[k].pen_actual_cost = 0;
						if (feeding.pen_feedings[k].load_dropped_report && feeding.pen_feedings[k].load_dropped_report.length) {
							for (var l = 0; l < feeding.pen_feedings[k].load_dropped_report.length; l++) {
								if (l === 0) {
									feeding.pen_feedings[k].has_dropping_conflict = feeding.pen_feedings[k].load_dropped_report[0].has_dropping_conflict;
								}
								feeding.pen_feedings[k].load_dropped_report[l].group_by_id = feeding.pen_feedings[k].load_dropped_report[l].load_id;
								feeding.pen_feedings[k].load_dropped_report[l].load_name = i18nFilter('_m_f_recipe_load_') + ' ' + (feeding.pen_feedings[k].load_dropped_report[l].load_position + 1);
								feeding.pen_feedings[k].load_dropped_report[l].drop_actual_cost =
									feedingTableService.calculateLoadCostPerKg(feeding, feeding.pen_feedings[k].load_dropped_report[l].load_position, 'actual_amount', 'actual') * feeding.pen_feedings[k].load_dropped_report[l].actual_loaded;
								feeding.pen_feedings[k].load_dropped_report[l].drop_actual_cost_dm = getCostDm(feeding.dm, feeding.pen_feedings[k].load_dropped_report[l].drop_actual_cost);
								feeding.pen_feedings[k].pen_actual_cost += feeding.pen_feedings[k].load_dropped_report[l].drop_actual_cost;
								feeding.pen_feedings[k].actual_amount += feeding.pen_feedings[k].load_dropped_report[l].actual_loaded;
								var loadDateTemp = moment(feeding.pen_feedings[k].load_dropped_report[l].unloading_start).format('YYYY-MM-DD');
								if (!moment(feeding.feeding_date).isSame(loadDateTemp)) {
									feeding.pen_feedings[k].load_dropped_report[l].feeding_date_changed = true;
									feeding.dropping_date_changed = true;
								}
								dropping_start.push(moment(feeding.pen_feedings[k].load_dropped_report[l].unloading_start));
								if (feeding.pen_feedings[k].load_dropped_report[l].unloading_finish) {
									dropping_finish.push(moment(feeding.pen_feedings[k].load_dropped_report[l].unloading_finish));
								}
								if (feeding.pen_feedings[k].load_dropped_report[l].feeder) {
									setFeedersList(feeding.dropping_feeders, feeding.pen_feedings[k].load_dropped_report[l].feeder);
								}
							}
						}
						if (!feeding.pen_feedings[k].pen_calculated_cost) {
							feeding.pen_feedings[k].pen_calculated_cost = feedingTableService.calculatePenCost(feeding, feeding.pen_feedings[k], 2);
							feeding.pen_feedings[k].pen_calculated_cost_dm = getCostDm(feeding.dm, feeding.pen_feedings[k].pen_calculated_cost);
						}
						feeding.pen_feedings[k].pen_actual_cost_dm = getCostDm(feeding.dm, feeding.pen_feedings[k].pen_actual_cost);
						feeding.pen_feedings[k].load_dropped_report = $filter('orderBy')(feeding.pen_feedings[k].load_dropped_report, 'unload_id');
						feeding.pen_feedings[k].deviation_percentage = ((feeding.pen_feedings[k].actual_amount - feeding.pen_feedings[k].feeding_amount) / feeding.pen_feedings[k].feeding_amount) * 100;
						if (feeding.pen_feedings[k].deviation_percentage >= 5 || feeding.pen_feedings[k].deviation_percentage <= -5) {
							feeding.pen_feedings[k].deviation_warn = true;
						}
					}
				}
				feeding.pen_feedings = $filter('orderBy')(feeding.pen_feedings, 'pen_id');
				feeding.feeding_loads = $filter('orderBy')(feeding.feeding_loads, 'load_position');
				if (dropping_start.length > 0) {
					feeding.dropping_start = moment.min(dropping_start).format('YYYY-MM-DDTHH:mm:ss');
				}
				if (dropping_finish.length > 0 && feeding.dropping_status !== 0) {
					feeding.dropping_finish = moment.max(dropping_finish).format('YYYY-MM-DDTHH:mm:ss');
				} else {
					feeding.dropping_finish = null;
				}
				if (feeding.dropping_start && feeding.dropping_finish && feeding.dropping_status !== 0) {
					feeding.dropping_duration = humanizeDuration(moment.duration(moment(feeding.dropping_finish).diff(feeding.dropping_start)));
				} else {
					feeding.dropping_duration = 0;
				}
				if (feeding.feeding_number == 1) {
					feeding.feeding_name = i18nFilter('_m_f_pen_morning_feeding_short_');
				} else if (feeding.feeding_number == 2) {
					feeding.feeding_name = i18nFilter('_m_f_pen_noon_feeding_short_');
				} else {
					feeding.feeding_name = i18nFilter('_m_f_pen_evening_feeding_short_');
				}
			}

			function getReportsById(id, date, type) {
				var loadingFound = false;
				if (vm.loadingReports.length > 0) {
					angular.forEach($filter('groupBy')(vm.loadingReports, 'recipe_id'), function (byId, key) {
						if (Number.parseInt(key) === id) {
							angular.forEach($filter('groupBy')(byId, 'feeding_date'), function (byDate, key) {
								for (var loadInd = 0; loadInd < byDate.length; loadInd++) {
									if (moment(key).isSame(date)) {
										feedingTableService.setLoading(byDate);
										if (vm.reportType.value === 1) {
											loadingByIdPromise.resolve(byDate);
										} else {
											loadingByIdPromise.resolve();
										}
										loadingFound = true;
										break;
									}
								}
							});
						}
					});
				}

				if (!loadingFound) {
					if (type) {
						getPremixReportsById(id, date);
					} else {
						getLoadingReportsById(id, date);
					}
				}

				if (!type) {
					var droppingFound = false;
					if (vm.droppingReports.length > 0) {
						angular.forEach($filter('groupBy')(vm.droppingReports, 'recipe_id'), function (byId, key) {
							if (Number.parseInt(key) === id) {
								angular.forEach($filter('groupBy')(byId, 'feeding_date'), function (byDate, key) {
									for (var dropInd = 0; dropInd < byDate.length; dropInd++) {
										if (moment(key).isSame(date)) {
											feedingTableService.setDropping(byDate);
											if (vm.reportType.value === 2) {
												droppingByIdPromise.resolve(byDate);
											} else {
												droppingByIdPromise.resolve();
											}
											droppingFound = true;
											break;
										}
									}
								});
							}
						});
					}

					if (!droppingFound) {
						getDroppingReportsById(id, date);
					}
				}
			}

			function getCostDm(dm, cost) {
				return cost * (dm / 100) || 0;
			}

			function setFeedersList(list, feeder) {
				var feederFound = false;
				for (var i = 0; i < list.length; i++) {
					if (list[i] === feeder) {
						feederFound = true;
						break;
					}
				}
				if (!feederFound) {
					list.push(feeder);
				}
			}

			function findLoadStartTime(loads, prop) {
				var arr = loads.map(function (load) {
					return moment(load[prop]);
				});

				return moment.min(arr).format('YYYY-MM-DDTHH:mm:ss');
			}

			function SetRecipeInfo(feeding, date) {
				this.recipe_name = feeding.recipe_name;
				this.recipe_id = feeding.recipe_id;
				this.feeding_date = $filter('date')(date, vm.dateWithDayFormat);
			}
		}

		function getApiData(id, prop) {
			if (vm[prop] && vm[prop].length) {
				for (var i = 0; i < vm[prop].length; i++) {
					if (vm[prop][i].id == id) {
						return vm[prop][i];
					}
				}
			}
			return null;
		}

		function humanizeDuration(date) {
			var dateArr = [];
			var days = Math.floor(date.asDays());
			if (days > 0) {
				dateArr.push(days, i18nFilter('_unit_days_'));
				date = date.subtract(days * 24 * 60 * 60 * 1000);
			}
			var hours = Math.floor(date.asHours());
			if (hours > 0) {
				dateArr.push(hours, i18nFilter('_unit_hours_long_'));
				date = date.subtract(hours * 60 * 60 * 1000);
			}
			var minutes = Math.floor(date.asMinutes());
			if (minutes > 0) {
				dateArr.push(minutes, i18nFilter('_unit_minutes_'));
				date = date.subtract(minutes * 60 * 1000);
			}
			var seconds = Math.floor(date.asSeconds());
			if (seconds > 0) {
				dateArr.push(seconds, i18nFilter('_unit_seconds_'));
				date = date.subtract(seconds * 1000);
			}
			return dateArr.join(' ');
		}

		function showDescription(event, init) {
			if (event.recipe_id) {
				vm.loadingEvents = true;
				vm.eventRecipeID = event.recipe_id;
				if (dataServiceFactory.feedingDate) {
					vm.eventFeedingDate = dataServiceFactory.feedingDate;
				} else if (event.feeding_date) {
					vm.eventFeedingDate = event.feeding_date;
				} else {
					bugsnagService.logMessage('Feeding date is null: dataServiceFactory.feedingDate = ' + dataServiceFactory.feedingDate + ', event.feeding_date = ' + event.feeding_date, null, 'warning');
				}
				vm.eventRecipeType = event.recipe_type;
				processFeedings(vm.eventRecipeID, vm.eventFeedingDate, vm.eventRecipeType, init);
			} else {
				for (var i = 0; i < vm.responseEvents.length; i++) {
					if (event.id == vm.responseEvents[i].Id) {
						vm.selected_event = vm.responseEvents[i];
						break;
					}
				}
				for (var r = 0; r < vm.repeatList.length; r++) {
					if (vm.repeatList[r].value == vm.selected_event.Recurring) {
						vm.selected_event.ReccuringString = vm.repeatList[r].label;
						break;
					}
				}
				if (event.allDay) {
					vm.selected_event.startDate = $filter('date')(event.start.format(), 'shortDate');
					if (event.end) {
						vm.selected_event.endDate = $filter('date')(event.end.format(), 'shortDate');
					} else {
						vm.selected_event.endDate = vm.selected_event.startDate;
					}
				} else {
					vm.selected_event.startDate = $filter('date')(event.start.format(), 'short');
					vm.selected_event.endDate = $filter('date')(event.end.format(), 'short');
				}
				vm.selected_event.color = event.color;
				$uibModal.open({
					animation: true,
					templateUrl: 'app/pages/calendar/description.modal.html',
					size: 'sm',
					scope: $scope,
					backdrop: 'static',
					keyboard: false
				});
			}
		}

		function showTimePickers() {
			var now = new Date();
			now.setDate(10);
			now.setMonth(6);
			now.setFullYear(2018);
			for (var i = 0; i < vm.times.length; i++) {
				if (moment(now).isBefore(vm.times[i].date)) {
					vm.newEvent.startTime = vm.times[i];
					vm.newEvent.endTime = vm.times[i];
					break;
				}
			}
			vm.showTime = true;
		}

		function filterCalendarEventsByRecipeId(events, recipeId) {
			for (var k = events.length - 1; k >= 0; k--) {
				if (events[k].recipe_id == recipeId) {
					events.splice(k, 1);
				}
			}

			return events;
		}

		function filterRegularCalendarEvents(events) {
			for (var k = events.length - 1; k >= 0; k--) {
				if (!events[k].recipe_id) {
					events.splice(k, 1);
				}
			}
			return events;
		}

		function checkStickyHeader() {
			if (!vm.deviceType) {
				return 'calendar-info-header-desktop';
			}
			return 'calendar-info-header-mobile';
		}

		function calculateCalendarHeight() {
			if (!vm.deviceType) {
				return $window.innerHeight - $window.innerHeight * 0.24;
			}
			if (vm.deviceType === 'mobile') {
				return $window.innerHeight + $window.innerHeight * 0.25;
			}
			if (vm.deviceType === 'tablet') {
				return $window.innerHeight + $window.innerHeight * 0.25;
			}
			return 700;
		}

		function datepickerChanged() {
			var date = moment(vm.datepickerModel);
			if (date.isValid()) {
				$('#calendar').fullCalendar('gotoDate', date);
			}
		}

		function openFilterModal() {
			vm.startDateOverride = vm.startDateOverride || vm.startDate;
			vm.endDateOverride = vm.endDateOverride || vm.endDate;
			openModal('app/pages/calendar/recipeFilter.modal.html', 'md', 'filter');
		}

		function calendarDivLoaded() {
			$timeout(function () {
				initialize();
			}, 400);
		}

		function initialize() {
			$timeout(function () {
				checkForCalendar();
			}, 100);

			function checkForCalendar() {
				var c = document.getElementById('calendar');
				if (c) {
					$('#calendar').fullCalendar({
						locale: vm.locale,
						firstDay: 1,
						height: calculateCalendarHeight(),
						scrollTime: moment().subtract(3, 'hours').format('HH:mm:ss'),
						views: {
							month: {
								eventLimit: 5
							},
							agendaWeek: {
								duration: {
									weeks: 1
								},
								columnFormat: vm.dateWithDayFormatUI,
								eventLimit: 15,
								slotEventOverlap: false
							},
							agendaDay: {
								eventLimit: 15,
								slotEventOverlap: false
							}
						},
						header: {
							left: 'prev today next',
							center: 'title',
							right: 'month,agendaWeek,agendaDay'
						},
						displayEventTime: false,
						titleFormat: vm.dateWithDayFormatUI,
						defaultView: dataServiceFactory.agenda.name ? dataServiceFactory.agenda.name : vm.currentCalendarView,
						defaultDate: dataServiceFactory.agenda.date ? dataServiceFactory.agenda.date : vm.currentCalendarDate,
						selectable: true,
						selectHelper: true,
						navLinks: true,
						weekNumbers: true,
						columnHeader: true,
						nowIndicator: true,
						dragRevertDuration: 50,
						select: function (start, end) {
							var allDay = false;
							if (start.hasTime() || end.hasTime()) {
								allDay = true;
							}
							vm.newEvent.start = start.format();
							vm.newEvent.end = end.format();
							checkEventList(vm.newEvent.start, vm.newEvent.end);
							openEventModal(allDay);
						},
						editable: true,
						eventLimit: true, // allow "more" link when too many events
						eventSources: {
							events: function (start, end, timezone, callback) {
								var startDate;
								var endDate;
								vm.startDate = angular.copy(new Date(start));
								vm.endDate = angular.copy(new Date(end));
								if (vm.startDateOverride) {
									startDate = angular.copy(vm.startDateOverride);
									endDate = angular.copy(vm.endDateOverride);
								} else {
									startDate = start;
									endDate = end;
								}
								events = $q.defer();
								feedingsPromise = $q.defer();
								//reportPromise = $q.defer();
								premixPromise = $q.defer();
								getFeedings(startDate, endDate);
								//getFeedingReports(startDate, endDate);
								getPremixReports(startDate, endDate);
								if (window.location.origin.includes('mmmooogle.com') || window.location.origin.includes('local-test-mmm.com:3000')) {
									getEvents(startDate, endDate);
								} else {
									events.resolve();
								}
								$q.all([feedingsPromise.promise, premixPromise.promise, events.promise])
									.then(function () {
										handleRecipes(callback);
										if (vm.from_calendar && dataServiceFactory.calendarEvent.recipe_id) {
											try {
												$timeout(function () {
													showDescription(dataServiceFactory.calendarEvent, true);
												}, 500);
											} catch (error) {
												console.log(error);
											}
										}
									})
									.catch(function (error) {
										errorService.showErrorMessage(error, true, '_error_occurred_loading_reports_', true);
										vm.loadingEvents = false;
									});
							}
						},
						loading: function (isLoading) {
							$timeout(function () {
								vm.loadingEvents = isLoading;
							}, 50);
						},
						eventClick: function (calEvent) {
							dataServiceFactory.calendarEvent = calEvent;
							showDescription(calEvent);
							$timeout(function () {
								try {
									$('.feeding-calendar-tooltip').remove();
								} catch (error) {
									console.log(error);
								}
							}, 100);
						},
						eventDrop: function (event, delta, revertFunc) {
							var startDate = null;
							var endDate = null;
							if (event.start) {
								startDate = event.start.format();
							}
							var toUpdate = true;
							if (event.end) {
								endDate = event.end.format();
							} else {
								if (!event.allDay) {
									toUpdate = false;
									editEventDrop(event, delta, revertFunc);
								}
							}
							if (toUpdate) {
								updateEvent(event, startDate, endDate);
							}
						},
						eventResize: function (event) {
							var startDate = null;
							var endDate = null;
							if (event.start) {
								startDate = event.start.format();
							}
							if (event.end) {
								endDate = event.end.format();
							}
							updateEvent(event, startDate, endDate);
						},
						viewRender: function (view) {
							dataServiceFactory.agenda = {
								name: view.name,
								date: view.calendar.getDate()
							};
							vm.currentCalendarView = view.name;
							if (!moment(vm.currentCalendarDate).isSame(view.calendar.getDate()) || view.intervalUnit == 'month') {
								vm.startDateOverride = null;
								vm.endDateOverride = null;
							}
							vm.currentCalendarDate = view.calendar.getDate();
							vm.datepickerModel = view.calendar.getDate().toDate();
							if (view.name === 'agendaDay') {
								$timeout(function () {
									datepickerChanged();
								}, 10);
							}
						},
						eventMouseover: function (event) {
							var tooltip = '<div class="feeding-calendar-tooltip" style="background-color: ' + event.color + '; color: ' + event.textColor + '"><label>' + event.title + '</label>';
							if (event.is_report && event.calculated_amount != null) {
								tooltip += '<br><label>' + i18nFilter('_m_f_reports_calculated_weight_') + ':&nbsp' + unitConversionService.convertData(event.amount ? event.amount : event.calculated_amount, ['kgToLb', 'round:0']) + '&nbsp' + vm.weight + '</label>';
							}
							if (event.is_report && event.actual_amount != null) {
								tooltip += '<br><label>' + i18nFilter('_m_f_reports_loaded_weight_') + ':&nbsp' + unitConversionService.convertData(event.actual_amount, ['kgToLb', 'round:0']) + '&nbsp' + vm.weight + '</label>';
							}
							if (event.is_report && vm.reportType.value === 2 && event.dropped_amount != null) {
								tooltip += '<br><label>' + i18nFilter('_m_f_reports_dropped_weight_') + ':&nbsp' + unitConversionService.convertData(event.dropped_amount, ['kgToLb', 'round:0']) + '&nbsp' + vm.weight + '</label>';
							}

							if (event.updated_pens && event.updated_pens.length > 0) {
								for (var i = 0; i < event.updated_pens.length; i++) {
									tooltip += '<br><label>' + i18nFilter('_m_f_pen_updated_via_app_message_') + ':&nbsp' + event.updated_pens[i].pen + '</label>';
									tooltip += '<br><label>' + i18nFilter('_title_user_') + ':&nbsp' + event.updated_pens[i].last_modified_user + '</label>';
								}
							}

							if (event.feeding_date) {
								var eventFeedingDate = $filter('date')(event.feeding_date, vm.dateWithDayFormat);
								var originalText = i18nFilter('_m_f_calendar_tooltip_original_date_');
								tooltip += '<br><label>' + originalText + ':&nbsp' + eventFeedingDate + '</label>';
							}
							if (event.actual_feeding_date) {
								var actualFeedingDate = $filter('date')(event.actual_feeding_date, vm.dateWithDayFormat);
								var actualText = i18nFilter('_m_f_calendar_tooltip_actual_date_');
								var dateChangedText = i18nFilter('_m_f_calendar_feeding_date_changed_');
								tooltip += '<br><label>' + dateChangedText + '</label>';
								tooltip += '<br><label>' + actualText + ':&nbsp' + actualFeedingDate + '</label>';
							}
							if (event.start && event.original_end) {
								var eventStartTime = moment(event.start).format('h:mm a');
								var eventEndTime = event.status !== 0 ? ' - ' + moment(event.original_end).format('h:mm a') : '';
								var duration = i18nFilter('_m_f_calendar_duration_');
								var timeText = vm.reportType.value === 1 ? i18nFilter('_m_f_loading_time_') : vm.reportType.value === 2 ? i18nFilter('_m_f_calendar_dropping_time_') : i18nFilter('_m_f_pen_feeding_time_');
								tooltip += '<br><label>' + timeText + ':&nbsp' + eventStartTime + eventEndTime + '</label>';
								if (event.status !== 0) {
									tooltip += '<br><label>' + duration + ':&nbsp' + event.duration_time + '</label>';
								}
							}
							if (event.is_report) {
								var status = event.status === 1 ? i18nFilter('_m_f_calendar_report_in_progress_') : event.status === 2 ? i18nFilter('_m_f_calendar_report_done_') : i18nFilter('_m_f_calendar_report_to_do_');
								var statusText = vm.reportType.value === 1 ? i18nFilter('_m_f_reports_loading_status_') : vm.reportType.value === 2 ? i18nFilter('_m_f_reports_dropping_status_') : i18nFilter('_m_f_reports_feeding_status_');
								tooltip += '<br><label>' + statusText + ':&nbsp' + status + '</label>';
							}
							if (event.conflict || event.load_conflict) {
								var conflictText = i18nFilter('_m_f_calendar_load_conflict_tooltip_');
								tooltip += '<br><label>' + conflictText + '</label>';
							}
							tooltip += '</div>';
							var tip = $(tooltip).appendTo('body');
							$(this).on('mousemove', function (e) {
								tip.css('top', e.pageY - 15).fadeIn('1000');
								tip.css('left', e.pageX - 5).fadeTo('10', 2);
							});
						},
						eventMouseout: function () {
							$('.feeding-calendar-tooltip').remove();
						},
						eventRender: function (event, element) {
							if (event.is_report) {
								element.addClass('feeding-event');
								if (event.conflict || event.load_conflict) {
									element.addClass('event-has-conflicts');
								}
								if (!event.status) {
									element.addClass('status-to-do');
								} else if (event.status === 1) {
									element.addClass('status-in-progress');
								} else if (event.status === 2) {
									element.addClass('status-done');
								}
								element.addClass('event-add-margin');
								if (event.deviation_warn) {
									element.addClass('deviation-warning');
								}
								if (event.actual_feeding_date) {
									element.addClass('feeding-date-changed-warning');
								}
							}
						}
					});
					$timeout(function () {
						vm.loadingCustomButtons = false;
						window.dispatchEvent(new Event('resize'));
					}, 10);
				} else {
					$timeout(function () {
						checkForCalendar();
					}, 500);
				}
			}
		}

		function checkEventList(start, end) {
			var eventList = [];
			if (vm.responseEvents && vm.responseEvents.length > 0) {
				for (var i = 0; i < vm.responseEvents.length; i++) {
					var insert = false;
					if (vm.responseEvents[i].Dates && vm.responseEvents[i].Dates.length > 0) {
						for (var j = 0; j < vm.responseEvents[i].Dates.length; j++) {
							if (
								((moment(start).isBefore(vm.responseEvents[i].Dates[j].StartDate) && moment(end).isAfter(vm.responseEvents[i].Dates[j].StartDate)) || (moment(start).isBefore(vm.responseEvents[i].Dates[j].EndDate) && moment(end).isAfter(vm.responseEvents[i].Dates[j].EndDate))) &&
								vm.responseEvents[i].Dates[j].EndDate
							) {
								insert = true;
								break;
							}
						}
					}
					if (insert) {
						for (var r = 0; r < vm.repeatList.length; r++) {
							if (vm.repeatList[r].value == vm.responseEvents[i].Recurring) {
								vm.responseEvents[i].ReccuringString = vm.repeatList[r].label;
								break;
							}
						}
						eventList.push(vm.responseEvents[i]);
					}
				}
			}
			if (eventList.length > 0) {
				vm.showEventPicker = true;
				vm.showNewEventBlock = false;
			} else {
				vm.showNewEventBlock = true;
				vm.showEventPicker = false;
			}
			vm.eventsForPdf = eventList;
		}

		function openCreatePdf() {
			closeModal();
			vm.showCreatePdfBlock = true;
		}

		function hideCreatePdfBlock() {
			vm.showCreatePdfBlock = false;
			init();
		}

		function openExportModal() {
			vm.file_name = 'Calendar';
			vm.showNewDiscussionBlock = false;
			vm.loadingModal = false;
			vm.includePictures = false;
			vm.discussion = {};
			vm.discussion.importance = 0;
			$uibModal.open({
				animation: true,
				templateUrl: 'app/pages/calendar/exportPdf.modal.html',
				size: 'md',
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function getPicturesByHerd(herd_id) {
			vm.loadingPictures = true;
			vm.currentPage = 1;
			return calendarService
				.getPicturesByHerd(herd_id)
				.then(function (response) {
					vm.allPictures = response;
					setToShowPictures(1);
					vm.loadingPictures = false;
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_pictures_');
				});
		}

		function loadRight() {
			vm.currentPage++;
			vm.loadingPictures = true;
			setToShowPictures(vm.currentPage);
			$timeout(function () {
				vm.loadingPictures = false;
			}, 100);
		}

		function loadLeft() {
			vm.currentPage--;
			vm.loadingPictures = true;
			setToShowPictures(vm.currentPage);
			$timeout(function () {
				vm.loadingPictures = false;
			}, 100);
		}

		function setToShowPictures(page) {
			var list = [];
			var first = (page - 1) * 100;
			var last = page * 100;
			for (var i = first; i < last; i++) {
				if (vm.allPictures[i]) {
					list.push(vm.allPictures[i]);
				} else {
					break;
				}
			}
			if (vm.allPictures[first - 1]) {
				vm.showLoadLeft = true;
			} else {
				vm.showLoadLeft = false;
			}
			if (vm.allPictures[last + 1]) {
				vm.showLoadRight = true;
			} else {
				vm.showLoadRight = false;
			}
			vm.pictures = list;
		}

		function showNewDiscussion() {
			vm.showNewDiscussionBlock = true;
		}

		function toDataURL(url, callback) {
			var xhr = new XMLHttpRequest();
			xhr.onload = function () {
				var reader = new FileReader();
				reader.onloadend = function () {
					callback(reader.result);
				};
				reader.readAsDataURL(xhr.response);
			};
			xhr.open('GET', url);
			xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('id_token'));
			xhr.responseType = 'blob';
			xhr.send();
		}

		function exportPdf(newDiscussion) {
			vm.loadingModal = true;
			setPDFPictures(newDiscussion);

			function setPDFPictures(newDiscussion) {
				var list = [];
				for (var i = 0; i < vm.eventsForPdf.length; i++) {
					if (vm.eventsForPdf[i].Pictures && vm.eventsForPdf[i].Pictures.length > 0) {
						var name = 'pr' + i;
						vm[name] = $q.defer();
						list.push(vm[name].promise);
						getDataUrl(name, i, vm.eventsForPdf[i].Pictures[0].ThumbnailUrl);
					}
				}

				function getDataUrl(name, i, picture) {
					toDataURL(picture, function (dataUrl) {
						vm.eventsForPdf[i].Pictures[0].PdfPicture = dataUrl;
						vm[name].resolve();
					});
				}
				$q.all(list).then(function () {
					createPDF(newDiscussion);
				});
			}

			function createPDF(newDiscussion) {
				var dd = {
					pageMargins: [25, 50, 20, 0],
					content: [
						{
							table: {
								dontBreakRows: true,
								body: [],
								widths: ['auto', '*']
							}
						}
					],
					defaultStyle: {
						fontSize: 9
					},
					styles: {
						headerStyle: {
							fontSize: 10,
							bold: true
						}
					}
				};
				for (var i = 0; i < vm.eventsForPdf.length; i++) {
					var event = [
						{
							image: vm.eventsForPdf[i].Pictures && vm.eventsForPdf[i].Pictures.length > 0 ? vm.eventsForPdf[i].Pictures[0].PdfPicture : vm.defaultPicture,
							fit: [70, 70],
							margin: [0, 0, 0, 0],
							border: [false, false, false, true]
						},
						{
							text:
								(vm.eventsForPdf[i].Title ? i18nFilter('_calendar_event_title_') + ':  ' + vm.eventsForPdf[i].Title + '\n' : '') +
								(vm.eventsForPdf[i].Description ? i18nFilter('_calendar_event_description_') + ':  ' + vm.eventsForPdf[i].Description + '\n' : '') +
								(vm.eventsForPdf[i].HerdName ? i18nFilter('_label_herd_') + ':  ' + vm.eventsForPdf[i].HerdName + '\n' : '') +
								'(' +
								(vm.eventsForPdf[i].StartDate ? $filter('date')(vm.eventsForPdf[i].StartDate, 'shortDate') : '') +
								') - (' +
								(vm.eventsForPdf[i].EndDate ? $filter('date')(vm.eventsForPdf[i].EndDate, 'shortDate') : '') +
								')' +
								'\n' +
								(vm.eventsForPdf[i].Recurring && vm.eventsForPdf[i].ReccuringString ? i18nFilter('_calendar_repeat_event_') + ':  ' + i18nFilter(vm.eventsForPdf[i].ReccuringString) + '\n' : '') +
								(vm.eventsForPdf[i].Recurring && vm.eventsForPdf[i].RecurringInterval ? i18nFilter('_calendar_repeat_interval_') + ':  ' + vm.eventsForPdf[i].RecurringInterval + '\n' : '') +
								(vm.eventsForPdf[i].Recurring && vm.eventsForPdf[i].RecurringEndDate ? i18nFilter('_calendar_repeat_end_') + ':  ' + $filter('date')(vm.eventsForPdf[i].RecurringEndDate, 'shortDate') + '\n' : '') +
								(vm.eventsForPdf[i].Comment ? i18nFilter('_dc_comments_') + ':  ' + vm.eventsForPdf[i].Comment : ''),
							margin: [25, 0, 0, 0],
							border: [false, false, false, true]
						}
					];
					dd.content[0].table.body.push(event);
				}
				if (vm.file_header && vm.file_header != '' && vm.file_header.length > 0) {
					dd.header = [
						{
							columns: [
								{
									image: vm.logo,
									width: 150,
									margin: [25, 0, 0, 0]
								}
							]
						},
						{
							columns: [
								{
									style: 'headerStyle',
									margin: [30, 0, 30, 10],
									text: vm.file_header
								}
							]
						}
					];
				} else {
					dd.header = [
						{
							columns: [
								{
									image: vm.logo,
									width: 150,
									margin: [25, 0, 0, 0]
								}
							]
						}
					];
				}
				var name = vm.file_name + '.pdf';
				var dd2 = angular.copy(dd);
				if (newDiscussion) {
					pdfMake.createPdf(dd).getBlob(function (data) {
						createNewDiscussion(data);
						pdfMake.createPdf(dd2).download(name);
						vm.showCreatePdfBlock = false;
						init();
					});
				} else {
					pdfMake.createPdf(dd).download(name);
					closeModal();
					vm.showCreatePdfBlock = false;
					init();
				}
			}
		}

		function uploadChanged() {
			vm.fileName = vm.file.name;
			vm.showPictures = false;
			vm.selected_picture_id = null;
		}

		function removeSelectedFile() {
			vm.file = null;
			vm.fileName = null;
			vm.showPictures = true;
			vm.selected_picture_id = null;
		}

		function selectPicture(picture) {
			vm.showPictures = false;
			vm.file = null;
			vm.selected_picture_id = picture.Id;
			if (picture.FileName) {
				vm.fileName = picture.FileName;
			} else {
				vm.fileName = 'Picture.jpg';
			}
		}

		function deleteEvent() {
			$uibModal.open({
				animation: true,
				templateUrl: 'app/pages/calendar/deleteEvent.modal.html',
				size: 'md',
				scope: $scope
			});
		}

		function deleteEventProceed() {
			vm.loadingModal = true;
			calendarService
				.deleteEvent(vm.selected_event.Id)
				.then(function () {
					closeModal();
					vm.loadingModal = false;
					$timeout(function () {
						$('#calendar').fullCalendar('refetchEvents');
					}, 150);
				})
				.catch(function (error) {
					console.log(error);
					vm.loadingModal = false;
					errorService.showErrorMessage(error, true, '_error_occurred_deleting_event_');
				});
		}

		function editEventDrop(event, delta, revertFunc) {
			for (var i = 0; i < vm.responseEvents.length; i++) {
				if (event.id == vm.responseEvents[i].Id) {
					vm.selected_event = vm.responseEvents[i];
					break;
				}
			}

			vm.selected_event.StartDate = new Date(event.start.format());
			vm.selected_event.EndDate = new Date(event.start.add(2, 'hours').format());
			revertFunc();
			editEvent();
		}

		function editEvent() {
			vm.loadingEvents = true;
			vm.showPictures = true;
			vm.removePictureFromEvent = false;
			if (vm.selected_event.Recurring) {
				vm.showRepeat = true;
			} else {
				vm.showRepeat = false;
			}
			if (vm.selected_event.HerdId) {
				getPicturesByHerd(vm.selected_event.HerdId);
			}
			for (var i = 0; i < vm.repeatList.length; i++) {
				if (vm.repeatList[i].value == vm.selected_event.Recurring) {
					vm.selected_event.RecurringObject = vm.repeatList[i];
					break;
				}
			}
			if (vm.selected_event.RecurringEndDate) {
				vm.selected_event.RecurringEndDate = new Date(vm.selected_event.RecurringEndDate);
			}
			if (vm.selected_event.StartDate) {
				var startTime = $filter('date')(vm.selected_event.StartDate, 'HH:mm:ss');
				vm.selected_event.StartDate = new Date(vm.selected_event.StartDate);
				vm.selected_event.startTime = { time: startTime };
			}
			if (vm.selected_event.EndDate) {
				var endTime = $filter('date')(vm.selected_event.EndDate, 'HH:mm:ss');
				vm.selected_event.EndDate = new Date(vm.selected_event.EndDate);
				vm.selected_event.endTime = { time: endTime };
			}
			if (startTime && endTime) {
				if (startTime == '00:00:00' && endTime == '00:00:00') {
					vm.showTime = false;
				} else {
					if (startTime) {
						for (var j = 0; j < vm.times.length; j++) {
							if (vm.times[j].time == startTime) {
								vm.selected_event.startTime = vm.times[j];
								break;
							}
						}
					}
					if (endTime) {
						for (var k = 0; k < vm.times.length; k++) {
							if (vm.times[k].time == endTime) {
								vm.selected_event.endTime = vm.times[k];
								break;
							}
						}
					}
					vm.showTime = true;
				}
			} else {
				vm.showTime = false;
			}
			if (vm.selected_event.Pictures && vm.selected_event.Pictures.length > 0) {
				vm.hidePicturesButton = true;
			} else {
				vm.hidePicturesButton = false;
			}
			vm.showEditBlock = true;
			vm.showCreatePdfBlock = false;
			vm.loadingEvents = false;
			closeModal();
		}

		function closeEditBlock() {
			vm.showEditBlock = false;
			vm.showCreatePdfBlock = false;
			init();
		}

		function removePicture() {
			vm.removePictureFromEvent = true;
			vm.removedPicture = vm.selected_event.Pictures[0];
			vm.selected_event.Pictures = [];
			vm.hidePicturesButton = false;
		}

		function createNewDiscussion(file) {
			file.name = vm.file_name;
			var date = new Date().toISOString();
			var suffix = '?created=' + date;
			if (vm.discussion.tags && vm.discussion.tags != '') {
				suffix = suffix + '&tags=' + encodeURIComponent(vm.discussion.tags);
			}
			if (vm.discussion.comments && vm.discussion.comments != '') {
				suffix = suffix + '&comments=' + vm.discussion.comments;
			}
			suffix = suffix + '&importance=' + vm.discussion.importance;
			if (vm.discussion.isTask) {
				suffix = suffix + '&isTask=true';
			} else {
				suffix = suffix + '&isTask=false';
			}
			var url = APP_CONST.animals_base_url + 'herds/' + vm.selectedHerd + '/pictures' + suffix;
			Upload.upload({
				url: url,
				data: {
					file: file
				}
			})
				.then(function () {
					closeModal();
					vm.loadingModal = false;
					vm.loadingNewDiscussion = false;
					init();
				})
				.catch(function (error) {
					vm.loadingModal = false;
					errorService.showErrorMessage(error, true, '_error_occurred_creating_discussion_');
					console.log(error);
				});
		}

		function saveEvent() {
			vm.loadingEvents = true;
			vm.showEditBlock = false;
			if (vm.removePictureFromEvent) {
				removePicFromEvent();
			} else {
				checkPicture();
			}

			function checkPicture() {
				if (vm.file) {
					eventPromise = $q.defer();
					picturePromise = $q.defer();
					$q.all([eventPromise.promise, picturePromise.promise])
						.then(function (responses) {
							vm.selected_picture_id = responses[1].Id;
							addNewPictureToEvent(responses[0]);
						})
						.catch(function (error) {
							vm.loadingEvents = false;
							vm.showEditBlock = true;
							console.log(error);
						});
					eventUpdate(true);
					postPicture();
				} else {
					eventUpdate(false);
				}
			}

			function addNewPictureToEvent(event_response) {
				return calendarService
					.addPictureToEvent(event_response.Id, vm.selected_picture_id)
					.then(function () {
						init();
					})
					.catch(function (error) {
						console.log(error);
						vm.loadingEvents = false;
						vm.showEditBlock = true;
						errorService.showErrorMessage(error, true, '_error_occurred_adding_new_picture_');
					});
			}

			function postPicture() {
				var suffix = '?created=' + new Date().toISOString();
				suffix = suffix + '&tags=calendarEvent';
				if (vm.file) {
					var url = APP_CONST.animals_base_url + 'herds/' + vm.selected_event.HerdId + '/pictures' + suffix;
					Upload.upload({
						url: url,
						data: {
							file: vm.file
						}
					})
						.then(function (response) {
							picturePromise.resolve(response.data);
						})
						.catch(function (error) {
							vm.loadingNewDiscussion = false;
							vm.loadingEvents = false;
							vm.showEditBlock = true;
							errorService.showErrorMessage(error, true, '_error_occurred_adding_new_picture_');
						});
				} else {
					picturePromise.reject('no_file');
				}
			}

			function removePicFromEvent() {
				return calendarService
					.removePictureFromEvent(vm.selected_event.Id, vm.removedPicture.Id)
					.then(function () {
						checkPicture();
					})
					.catch(function (error) {
						vm.loadingEvents = false;
						vm.showEditBlock = true;
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_removing_picture_');
					});
			}

			function eventUpdate(with_picture) {
				var start = null;
				var end = null;
				vm.loadingAddNewEvent = true;
				if (vm.showTime) {
					start = $filter('date')(vm.selected_event.StartDate, 'yyyy-MM-dd') + 'T' + vm.selected_event.startTime.momentTime.format('HH:mm:ss');
					end = $filter('date')(vm.selected_event.EndDate, 'yyyy-MM-dd') + 'T' + vm.selected_event.endTime.momentTime.format('HH:mm:ss');
				} else {
					start = $filter('date')(vm.selected_event.StartDate, 'yyyy-MM-dd');
					end = $filter('date')(vm.selected_event.EndDate, 'yyyy-MM-dd');
				}
				var suffix = '?';
				var herd_id = vm.selected_event.HerdId;
				var has_start;
				var has_end;
				var has_title;
				var has_description;
				var has_repeat;
				var has_repeat_interval;
				if (start) {
					suffix = suffix + 'startDate=' + start;
					has_start = true;
				}
				if (end) {
					if (has_start) {
						suffix = suffix + '&';
					}
					suffix = suffix + 'endDate=' + end;
					has_end = true;
				}
				if (vm.selected_event.Title) {
					if (has_start || has_end) {
						suffix = suffix + '&';
					}
					suffix = suffix + 'title=' + vm.selected_event.Title;
					has_title = true;
				}
				if (vm.selected_event.Description) {
					if (has_start || has_end || has_title) {
						suffix = suffix + '&';
					}
					suffix = suffix + 'description=' + vm.selected_event.Description;
					has_description = true;
				}
				if (vm.showRepeat && vm.selected_event.RecurringObject.value) {
					if (has_start || has_end || has_title || has_description) {
						suffix = suffix + '&';
					}
					suffix = suffix + 'recurring=' + vm.selected_event.RecurringObject.value;
					has_repeat = true;
				}
				if (vm.showRepeat && vm.selected_event.RecurringObject.value && vm.selected_event.RecurringInterval) {
					if (has_start || has_end || has_title || has_description || has_repeat) {
						suffix = suffix + '&';
					}
					suffix = suffix + 'recurringinterval=' + vm.selected_event.RecurringInterval;
					has_repeat_interval = true;
				}
				if (vm.showRepeat && vm.selected_event.RecurringObject.value && vm.selected_event.RecurringEndDate) {
					if (has_start || has_end || has_title || has_description || has_repeat || has_repeat_interval) {
						suffix = suffix + '&';
					}
					suffix = suffix + 'recurringenddate=' + $filter('date')(vm.selected_event.RecurringEndDate, 'yyyy-MM-dd');
				}
				suffix = suffix + '&id=' + vm.selected_event.Id;
				return calendarService
					.addNewEvent(herd_id, suffix)
					.then(function (response) {
						if (with_picture) {
							eventPromise.resolve(response);
						} else {
							if (vm.selected_picture_id) {
								addNewPictureToEvent(response);
							} else {
								filterEvents();
								if (vm.updateEventloading) {
									vm.hideRegularEvents = false;
								}
								$('#calendar').fullCalendar('removeEvents', vm.selected_event.Id);
								$('#calendar').fullCalendar('refetchEvents');
								checkAreAllFiltersSelected();
							}
						}
					})
					.catch(function (error) {
						vm.loadingAddNewEvent = false;
						vm.loadingEvents = false;
						vm.showEditBlock = true;
						errorService.showErrorMessage(error, true, '_error_occurred_updating_event_');
					});
			}
		}

		function undoChanges() {
			vm.loadingPreview = true;
			$timeout(function () {
				resetReports();
			}, 1);
		}

		function cancelRecipeDetails() {
			var filtered = dataServiceFactory.selectedFilter;
			if (vm.edited === true) {
				if (vm.dirty === true) {
					vm.confirmationPromise = $q.defer();
					openModal('app/pages/calendar/confirmation.modal.html', 'sm');
					$q.all([vm.confirmationPromise.promise]).then(function () {
						undoChanges();
						back();
						$('#calendar').fullCalendar('refetchEvents');
					});
				} else {
					back();
					vm.recipeFilterActive = filtered ? true : false;
					$('#calendar').fullCalendar('refetchEvents');
				}
			} else {
				back();
				if (vm.reportChanged) {
					$('#calendar').fullCalendar('refetchEvents');
					vm.reportChanged = false;
				}
			}
			vm.edited = false;
		}

		function back() {
			vm.selectedRecipe = null;
			vm.showFeedingDescription = false;
			localStorage.removeItem('from_calendar');
			dataServiceFactory.calendarEvent = null;
			dataServiceFactory.feedingDate = null;
			dataServiceFactory.agenda.name = vm.currentCalendarView;
			dataServiceFactory.agenda.date = vm.currentCalendarDate;
			vm.from_calendar = null;
			disableHerdSelector();
		}

		function goToLoadingGraph() {
			localStorage.setItem('from_calendar', vm.selectedRecipe.recipe_id);
			$state.go('reports.mixing');
		}

		function confirm() {
			removeDirty();
			try {
				vm.confirmationPromise.resolve();
			} catch (error) {
				console.log(error);
			}
			closeModal();
		}

		function cancel() {
			try {
				vm.confirmationPromise.reject();
			} catch (error) {
				console.log(error);
			}
			closeModal();
		}

		function setDirty() {
			vm.dirty = true;
			vm.edited = true;
			localStorage.setItem('dirty', true);
		}

		function removeDirty() {
			vm.dirty = false;
			localStorage.removeItem('dirty');
		}

		function resetFilters() {
			vm.selectedRecipes = [];
			vm.isReportTypeChanged = false;
			vm.filterUsed = false;
			dataServiceFactory.selectedFilter = vm.selectedRecipes;
		}

		function closeModal(prop) {
			$uibModalStack.dismissAll();
			if (prop === 'filter' && !vm.recipeFilterActive) {
				for (var i = 0; i < vm.recipeList.length; i++) {
					vm.recipeList[i].selected = true;
				}
				checkAreAllFiltersSelected();
			}
		}

		function disableHerdSelector(prop) {
			$rootScope.$broadcast('disable_herd_selector', prop);
		}

		$scope.$watch('vm.loadingEvents', function () {
			if (vm.loadingEvents) {
				loadingModal = openModal('app/pages/calendar/loadingModal.html', 'sm');
			} else {
				$uibModalStack.dismiss(loadingModal);
			}
		});

		$scope.$on('$destroy', function () {
			try {
				$('.feeding-calendar-tooltip').remove();
			} catch (error) {
				console.log(error);
			}
		});

		$scope.$on('$stateChangeStart', function (event, toState) {
			if (vm.dirty) {
				event.preventDefault();
				vm.confirmationPromise = $q.defer();
				openModal('app/pages/calendar/confirmation.modal.html', 'sm');
				$q.all([vm.confirmationPromise.promise]).then(function () {
					$state.go(toState.name, {
						uuid: vm.redirectId
					});
				});
			}
			try {
				if (!toState.keep_calendar_filter) {
					dataServiceFactory.selectedFilter = [];
					dataServiceFactory.feedingDate = null;
				}
				$('.feeding-calendar-tooltip').remove();
			} catch (error) {
				console.log(error);
			}
		});

		$scope.$on('reload_apis', function () {
			init();
		});

		$scope.$on('default_herd_selected', function () {
			vm.showCalendar = false;
			vm.loadingEvents = true;
			$timeout(function () {
				resetFilters();
				init();
				$timeout(function () {
					if (vm.selectedHerd) {
						$('#calendar').fullCalendar('render');
					}
				}, 250);
			}, 50);
		});

		$scope.$on('default_team_selected', function () {
			vm.showCalendar = false;
			$timeout(function () {
				resetFilters();
				init();
			}, 50);
		});

		editableOptions.theme = 'bs3';
		editableOptions.blurElem = 'cancel';
		editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
		editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.calendar').factory('calendarService', calendarService);
	/** @ngInject */
	function calendarService($http, $q, APP_CONST) {
		return {
			getHerdsByTeam: getHerdsByTeam,
			getEvents: getEvents,
			addNewEvent: addNewEvent,
			updateEvent: updateEvent,
			getPicturesByHerd: getPicturesByHerd,
			addPictureToEvent: addPictureToEvent,
			removePictureFromEvent: removePictureFromEvent,
			deleteEvent: deleteEvent,
			getFeedingsbyHerd: getFeedingsbyHerd,
			getFeedingReports: getFeedingReports,
			getLoadingReports: getLoadingReports,
			getDroppingReports: getDroppingReports,
			getMixerWagons: getMixerWagons,
			getPensByTeamHerd: getPensByTeamHerd,
			getRationByRecipeId: getRationByRecipeId,
			getPremixReports: getPremixReports,
			getPremixReportsById: getPremixReportsById,
			saveLoadingReport: saveLoadingReport,
			savePremixLoadingReport: savePremixLoadingReport,
			saveDroppingReport: saveDroppingReport
		};

		function getHerdsByTeam() {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/herds/')
				.then(success)
				.catch(error);
		}

		function getEvents(suffix) {
			return $http
				.get(APP_CONST.animals_base_url + suffix)
				.then(success)
				.catch(error);
		}

		function addNewEvent(herdId, suffix) {
			return $http
				.post(APP_CONST.animals_base_url + 'herds/' + herdId + '/calendarevents' + suffix)
				.then(success)
				.catch(error);
		}

		function updateEvent(herdId, suffix) {
			return $http
				.post(APP_CONST.animals_base_url + 'herds/' + herdId + '/calendarevents' + suffix)
				.then(success)
				.catch(error);
		}

		function getPicturesByHerd(herdId) {
			return $http
				.get(APP_CONST.animals_base_url + 'herds/' + herdId + '/pictures?-orderby=-imagecommentdate')
				.then(success)
				.catch(error);
		}

		function addPictureToEvent(eventId, pictureId) {
			return $http
				.post(APP_CONST.animals_base_url + 'calendarevents/' + eventId + '/pictures/' + pictureId)
				.then(success)
				.catch(error);
		}

		function removePictureFromEvent(eventId, pictureId) {
			return $http
				.delete(APP_CONST.animals_base_url + 'calendarevents/' + eventId + '/pictures/' + pictureId)
				.then(success)
				.catch(error);
		}

		function deleteEvent(eventId) {
			return $http
				.delete(APP_CONST.animals_base_url + 'calendarevents/' + eventId)
				.then(success)
				.catch(error);
		}

		function getFeedingsbyHerd(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'feedingcalendar' + suffix)
				.then(success)
				.catch(error);
		}

		function getFeedingReports(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'feedingcalendarreport' + suffix)
				.then(success)
				.catch(error);
		}

		function getPremixReports(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'premixrecipecalendar' + suffix)
				.then(success)
				.catch(error);
		}

		function getPremixReportsById(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'premixrecipecalendarid' + suffix)
				.then(success)
				.catch(error);
		}

		function getLoadingReports(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'feedingcalendarreport/loading' + suffix)
				.then(success)
				.catch(error);
		}

		function getDroppingReports(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'feedingcalendarreport/dropping' + suffix)
				.then(success)
				.catch(error);
		}

		function getMixerWagons(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'mixerwagon' + suffix)
				.then(success)
				.catch(error);
		}

		function getPensByTeamHerd(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'pens' + suffix)
				.then(success)
				.catch(error);
		}

		function getRationByRecipeId(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'feedingcalendar/ingredients' + suffix)
				.then(success)
				.catch(error);
		}

		function saveLoadingReport(data) {
			return $http
				.post(APP_CONST.api_base_url + 'feedingcalendar/loading', data)
				.then(success)
				.catch(error);
		}

		function savePremixLoadingReport(data) {
			return $http
				.post(APP_CONST.api_base_url + 'feedingcalendar/premix/loading', data)
				.then(success)
				.catch(error);
		}

		function saveDroppingReport(data) {
			return $http
				.post(APP_CONST.api_base_url + 'feedingcalendar/dropping', data)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan').factory('auth0Service', auth0Service);
	/** @ngInject */
	function auth0Service($http, $q, APP_CONST, $timeout, authManager) {
		var origin = window.location.origin;
		if (!origin) {
			origin = 'https://feed.mmmooogle.com';
		}

		var webAuth;

		return {
			init: init,
			login: login,
			handleAuthentication: handleAuthentication,
			logout: logout,
			handleUnauthorized: handleUnauthorized
		};

		function init() {
			var redirectUri = origin.concat('/login');

			webAuth = new auth0.WebAuth({
				domain: 'bovinet.auth0.com',
				clientID: 'v5Y8rdc32moZyBUVWY6d1k2ljQS2EQKm',
				responseType: 'token id_token',
				audience: 'https://bovinet.auth0.com/userinfo',
				scope: 'openid profile email',
				redirectUri: redirectUri
			});
		}

		function login() {
			init();

			$timeout(function () {
				webAuth.authorize();
			}, 100);
		}

		function handleAuthentication() {
			var d = $q.defer();

			webAuth.parseHash(function (err, authResult) {
				if (authResult && authResult.accessToken && authResult.idToken) {
					d.resolve(authResult);
				} else if (err) {
					d.reject(err);
				} else {
					d.reject();
				}
			});

			return d.promise;
		}

		function handleUnauthorized(timeout) {
			localStorage.clear();
			authManager.unauthenticate();
			$timeout(function () {
				logout();
			}, timeout);
		}

		function logout() {
			var redirect = origin.concat('/login');

			if (!webAuth) {
				init();
			}

			$timeout(function () {
				webAuth.logout({
					returnTo: redirect
				});
			}, 100);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.dashboard').controller('dashboardCtrl', dashboardCtrl);
	/** @ngInject */
	function dashboardCtrl($uibModal, $uibModalStack, $scope, $filter, dashboardFactory, $rootScope, $state, settingsFactory, errorService, authService) {
		var vm = this;
		vm.typeSelected = typeSelected;
		vm.cancel = cancel;
		vm.setDefaultHerd = setDefaultHerd;
		vm.setDefaultTeam = setDefaultTeam;
		vm.saveDefaultCalculation = saveDefaultCalculation;
		vm.redirect = redirect;
		vm.reloadApi = reloadApi;
		vm.defaultTeamExists = false;
		vm.defaultHerdExists = false;
		vm.defaultTeamLoading = true;
		vm.defaultHerdLoading = true;
		vm.modalLoading = false;
		vm.haveFeedAccess = haveFeedAccess;
		init();

		function init() {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.feedTeams = authService.teams;
			setDefaultCalculation();
			getTeamsByUser();
			if (vm.settings && vm.settings.calculation_type == null) {
				openModal('app/pages/dashboard/selectCalculation.modal.html', 'sm');
			}
		}

		function setDefaultCalculation() {
			vm.defaultCalculationList = [
				{
					name: '_calculation_filter_us_feeds_',
					calc_type: 0
				},
				{
					name: '_calculation_filter_vem_dve_feeds_',
					calc_type: 1
				}
			];
			if (vm.settings && vm.settings.calculation_type != null) {
				for (var i = 0; i < vm.defaultCalculationList.length; i++) {
					if (vm.settings.calculation_type == vm.defaultCalculationList[i].calc_type) {
						vm.selectedCalculation = vm.defaultCalculationList[i];
					}
				}
			} else {
				vm.selectedCalculation = vm.defaultCalculationList[0];
			}
		}

		function reloadApi() {
			getTeamsByUser();
			if (vm.settings && vm.settings.calculation_type == null) {
				openModal('app/pages/dashboard/selectCalculation.modal.html', 'sm');
			}
		}

		function saveDefaultCalculation() {
			vm.modalLoading = true;
			vm.settings.calculation_type = vm.selectedCalculation.calc_type;
			return settingsFactory
				.changeSettings(vm.settings, vm.user.email)
				.then(function (response) {
					localStorage.setItem('user_settings', JSON.stringify(response));
					vm.loading = false;
					vm.modalLoading = false;
					cancel();
				})
				.catch(function (error) {
					console.log(error);
					vm.modalLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_saving_calculation_');
				});
		}

		function checkDefaultTeam(sett, teams) {
			for (var i = 0; i < teams.length; i++) {
				if (sett.selectedTeam && sett.selectedTeam.id == teams[i].Id) {
					vm.selectedTeam = teams[i];
					vm.defaultTeamExists = true;
				}
			}
			vm.defaultTeamLoading = false;
			if (vm.selectedTeam) {
				checkDefaultHerd(vm.settings, vm.selectedTeam);
			} else {
				vm.defaultHerdExists = false;
				vm.defaultHerdLoading = false;
			}
		}

		function getTeamsByUser() {
			return dashboardFactory
				.getTeamsByUser()
				.then(function (response) {
					response = $filter('orderBy')(response, 'Name');
					vm.teams = [];
					for (var i = 0; i < response.length; i++) {
						for (var j = 0; j < vm.feedTeams.length; j++) {
							if (response[i].Id == vm.feedTeams[j].id) {
								vm.teams.push(response[i]);
							}
						}
					}
					checkDefaultTeam(vm.settings, vm.teams);
				})
				.catch(function (error) {
					vm.defaultTeamLoading = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_teams_', true);
					cancel();
				});
		}

		function checkDefaultHerd(settings, team) {
			if (settings.selectedHerd) {
				dashboardFactory
					.getHerdsByTeam(team.Id)
					.then(function (response) {
						for (var i = 0; i < response.length; i++) {
							if (settings.selectedHerd.id == response[i].Id) {
								vm.selectedHerd = response[i];
								vm.defaultHerdExists = true;
							}
						}
						vm.defaultHerdLoading = false;
					})
					.catch(function (error) {
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_loading_herds_', true);
						cancel();
					});
			} else {
				vm.defaultHerdLoading = false;
			}
		}

		function typeSelected(type) {
			if (type == 'team') {
				if (vm.selectedTeam) {
					vm.modalSelectedTeam = {};
					angular.copy(vm.selectedTeam, vm.modalSelectedTeam);
				} else {
					vm.modalSelectedTeam = null;
				}
				openModal('app/pages/dashboard/teamDefault.modal.html', 'sm');
			} else if (type == 'herd') {
				if (vm.selectedTeam) {
					if (vm.selectedHerd) {
						vm.modalSelectedHerd = {};
						angular.copy(vm.selectedHerd, vm.modalSelectedHerd);
					} else {
						vm.modalSelectedHerd = null;
					}
					openModal('app/pages/dashboard/herdDefault.modal.html', 'sm');
					getHerdsByTeam(vm.selectedTeam);
				}
			}
		}

		function setDefaultHerd() {
			if (vm.modalSelectedHerd && vm.modalSelectedHerd.Id) {
				var herd = {
					herd_id: vm.modalSelectedHerd.Id
				};
				vm.modalLoading = true;
				return dashboardFactory
					.setDefaultTeamHerd(herd)
					.then(function (response) {
						localStorage.setItem('user_settings', JSON.stringify(response));
						vm.selectedHerd = vm.modalSelectedHerd;
						vm.defaultHerdExists = true;
						vm.modalLoading = false;
						brodcastHerdSelected(vm.modalSelectedHerd);
						$uibModalStack.dismissAll();
					})
					.catch(function (error) {
						vm.modalLoading = false;
						console.log(error);
						if (error.status === 403) {
							errorService.showErrorMessage(error, true, '_error_occurred_setting_default_herd_');
						} else {
							errorService.showErrorMessage(error, true, '_error_occurred_changing_default_herd_');
						}
					});
			}
		}

		function setDefaultTeam() {
			if (vm.modalSelectedTeam && vm.modalSelectedTeam.Id) {
				var team = {
					team_id: vm.modalSelectedTeam.Id
				};
				vm.modalLoading = true;
				var user = JSON.parse(localStorage.getItem('user_profile'));
				return dashboardFactory
					.setDefaultTeamHerd(team, user.email)
					.then(function (response) {
						localStorage.setItem('user_settings', JSON.stringify(response));
						vm.selectedTeam = vm.modalSelectedTeam;
						vm.selectedHerd = null;
						vm.defaultHerdExists = false;
						vm.defaultTeamExists = true;
						vm.modalLoading = false;
						brodcastTeamSelected(vm.modalSelectedTeam);
						$uibModalStack.dismissAll();
					})
					.catch(function (error) {
						vm.modalLoading = false;
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_changing_default_team_');
					});
			}
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function cancel() {
			$uibModalStack.dismissAll();
		}

		function getHerdsByTeam(team) {
			vm.modalLoading = true;
			return dashboardFactory
				.getHerdsByTeam(team.Id)
				.then(function (response) {
					vm.herdsToShow = response;
					vm.modalLoading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.modalLoading = false;
					vm.defaultHerdLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_herds_');
				});
		}

		function haveFeedAccess() {
			var access = false;
			if (authService.can(16)) {
				access = true;
			}

			return access;
		}

		function redirect(state) {
			$state.go(state);
		}

		function brodcastHerdSelected(herd) {
			$rootScope.$broadcast('default_herd_selected_from_herds', herd);
		}

		function brodcastTeamSelected(team) {
			$rootScope.$broadcast('default_team_selected_from_herds', team);
		}

		$scope.$on('default_team_selected', function (event, data) {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedTeam = data;
			vm.selectedHerd = null;
			vm.defaultHerdExists = false;
			vm.defaultTeamExists = true;
		});

		$scope.$on('default_herd_selected', function (event, data) {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedHerd = data;
			vm.defaultHerdExists = true;
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.dashboard').factory('dashboardFactory', dashboardFactory);
	/** @ngInject */
	function dashboardFactory(APP_CONST, $http, $q) {
		return {
			getTeamsByUser: getTeamsByUser,
			getHerdsByTeam: getHerdsByTeam,
			setDefaultTeamHerd: setDefaultTeamHerd
		};

		function getTeamsByUser() {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams')
				.then(success)
				.catch(error);
		}

		function getHerdsByTeam(id) {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams/' + id + '/herds')
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function setDefaultTeamHerd(obj, email) {
			var emailSuffix = '';
			if (email) {
				emailSuffix = emailSuffix + '?email=' + encodeURIComponent(email);
			}
			return $http
				.patch(APP_CONST.api_base_url + 'userSettings' + emailSuffix, obj)
				.then(success)
				.catch(error);
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages').factory('dataServiceFactory', dataServiceFactory);

	/** @ngInject */
	function dataServiceFactory() {
		return {
			add_new_recipe_data: {},
			edit_recipe_data: {},
			add_new_premix_data: {},
			edit_premix_data: {},
			colorPerRecipe: [],
			ration_tables: {},
            shared_feeds: [],
			colors: [
				{ color: '#C2005A' },
				{ color: '#00a811' },
				{ color: '#FBFF8F' },
				{ color: '#0F0300' },
				{ color: '#8F4C00' },
				{ color: '#8AA7FF' },
				{ color: '#FFADE8' },
				{ color: '#1499ff' },
				{ color: '#1AFFEC' },
				{ color: '#640080' },
				{ color: '#FF3DD5' },
				{ color: '#F8FF29' },
				{ color: '#FF2B24' },
				{ color: '#ff641c' },
				{ color: '#DBF5FF' },
				{ color: '#008F6D' },
				{ color: '#750800' },
				{ color: '#8FFFA0' }
			],
			calendarEvent: {},
			feedingDate: null,
			agenda: {},
			selectedFilter: []
		};
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages').service('unitConversionService', unitConversionService);

	/** @ngInject */
	function unitConversionService(regularUnitConfigurationService, perDayUnitConfigurationService, significantConfigurationService, $cookies) {
		var settings;
		var configuration;
		var regularConfiguration;
		var perDayConfiguration;
		var significantConfiguration;

		var lbConversionRate = 2.2046;
		var mjouleConversionRate = 4.1868;

		var convert = new SetConversionRates();

		var methods = {
			bulkKgToLb: bulkKgToLb,
			kgToLb: kgToLb,
			gramToLb: gramToLb,
			bulkLbToKg: bulkLbToKg,
			lbToKg: lbToKg,
			lbToGram: lbToGram,
			bulkAmountToProduct: bulkAmountToProduct,
			amountToProduct: amountToProduct,
			bulkProductToAmount: bulkProductToAmount,
			productToAmount: productToAmount,
			bulkMcalToMjoule: bulkMcalToMjoule,
			mcalToMjoule: mcalToMjoule,
			bulkMjouleToMcal: bulkMjouleToMcal,
			mjouleToMcal: mjouleToMcal,
			bulkPercentToAmount: bulkPercentToAmount,
			percentToAmount: percentToAmount,
			bulkAmountToPercent: bulkAmountToPercent,
			amountToPercent: amountToPercent,
			bulkRoundValues: bulkRoundValues,
			roundValues: roundValues,
			round: round,
			bulkGetSignificant: bulkGetSignificant,
			getSignificant: getSignificant,
			getSignificantDigits: getSignificantDigits,
			metricTonToImperialTon: metricTonToImperialTon,
			imperialTonToMetricTon: imperialTonToMetricTon,
			metricTonToPounds: metricTonToPounds,
			poundsToMetricTon: poundsToMetricTon,
			metricTonToKg: metricTonToKg,
			kgToMetricTon: kgToMetricTon,
			poundsToImperialTon: poundsToImperialTon,
			imperialTonToPounds: imperialTonToPounds,
			kgToImperialTon: kgToImperialTon,
			imperialTonToKg: imperialTonToKg,
			balanceKgToLbConcentration: balanceKgToLbConcentration
		};

		return {
			convertData: convertData,
			setConfiguration: setConfiguration
		};

		function convertData(data, operations, configEnum, dm) {
			try {
				if (angular.isString(data)) {
					return data;
				}
				getSettings();
				if (!settings) {
					return data;
				}
				if (!configEnum) {
					configEnum = 1;
				}
				setConfiguration(configEnum);
				for (var i = 0; i < operations.length; i++) {
					var functions = operations[i].split(':');
					if (functions.length > 1) {
						data = methods[functions[0]](data, functions[1], dm);
					} else {
						data = methods[operations[i]](data, dm);
					}
				}
				return data;
			} catch (error) {
				throw new Error('Error occured while executing convertData method', { cause: error });
			}
		}

		function setConfiguration(configEnum, type) {
			if (configEnum === 1) {
				if (!regularConfiguration) {
					regularConfiguration = new regularUnitConfigurationService.SetRegularConfiguration();
					configuration = regularConfiguration;
				} else {
					if (configuration != regularConfiguration) {
						configuration = regularConfiguration;
					}
				}
			} else if (configEnum === 2) {
				if (!perDayConfiguration) {
					perDayConfiguration = new perDayUnitConfigurationService.SetPerDayConfiguration();
					configuration = perDayConfiguration;
				} else {
					if (configuration != perDayConfiguration) {
						configuration = perDayConfiguration;
					}
				}
			} else {
				if (!significantConfiguration) {
					significantConfiguration = new significantConfigurationService.SetSignificantConfiguration();
					configuration = significantConfiguration;
				} else {
					if (configuration != significantConfiguration) {
						configuration = significantConfiguration;
					}
				}
			}
			return configuration[type];
		}

		function checkLbSettings(type) {
			if (configuration[type] && configuration[type].use_lb) {
				if (configuration[type].allowed_methods && configuration[type].allowed_methods.includes('forceConvertAmountDivisor')) {
					return {
						allow: true,
						method: 'convertAmountDivisor'
					};
				}
				if (configuration[type].allowed_methods && configuration[type].allowed_methods.includes('forceConvertAmount')) {
					return {
						allow: true,
						method: 'convertAmount'
					};
				}
				if (!settings.use_kgs) {
					if (configuration[type].allowed_methods && configuration[type].allowed_methods.includes('convertAmount')) {
						return {
							allow: true,
							method: 'convertAmount'
						};
					}
					if (configuration[type].allowed_methods && configuration[type].allowed_methods.includes('convertMjoule')) {
						return {
							allow: true,
							method: 'convertAmountDivisor'
						};
					}
					if (configuration[type].allowed_methods && configuration[type].allowed_methods.includes('convertCostDm')) {
						return {
							allow: true,
							method: 'convertAmountDivisor'
						};
					}
					if (configuration[type].use_lb_inverse) {
						if (configuration[type].allowed_methods && configuration[type].allowed_methods.includes('forcePercentConvertAmountDivisor')) {
							return {
								allow: true,
								method: 'convertAmountDivisor'
							};
						}
						if (!settings.use_percent) {
							if (configuration[type].allowed_methods && configuration[type].allowed_methods.includes('convertAmountDivisor')) {
								return {
									allow: true,
									method: 'convertAmountDivisor'
								};
							}
						}
					}
				}
			}
			return {
				allow: false
			};
		}

		function checkProductSettings(type) {
			if (configuration[type] && configuration[type].use_lb_inverse) {
				if (configuration[type].allowed_methods && configuration[type].allowed_methods.includes('forceConvertAmountProduct')) {
					return {
						allow: true,
						method: 'convertAmountProduct'
					};
				}
				if (configuration[type].allowed_methods && configuration[type].allowed_methods.includes('convertAmountProduct')) {
					var useAmount = JSON.parse($cookies.get('use_product'));
					if (!useAmount && !settings.use_percent) {
						return {
							allow: true,
							method: 'convertAmountProduct'
						};
					}
				}
			}
			return {
				allow: false
			};
		}

		function checkMjouleSettings(type) {
			if (configuration[type] && configuration[type].use_mjoule) {
				if (configuration[type].allowed_methods && configuration[type].allowed_methods.includes('forceConvertMjoule')) {
					return {
						allow: true,
						method: 'convertMjoule'
					};
				}
				if (!settings.use_mcal) {
					if (configuration[type].allowed_methods && configuration[type].allowed_methods.includes('convertMjoule')) {
						return {
							allow: true,
							method: 'convertMjoule'
						};
					}
				}
			}
			return {
				allow: false
			};
		}

		function checkPercentageSettings(type) {
			if (configuration[type] && configuration[type].use_percent) {
				if (configuration[type].allowed_methods && configuration[type].allowed_methods.includes('forceConvertPercentage')) {
					if (!settings.use_percent) {
						return {
							allow: true,
							method: 'convertPercentage'
						};
					}
					return {
						allow: false
					};
				}
				if (!settings.use_percent) {
					if (configuration[type].allowed_methods && configuration[type].allowed_methods.includes('convertPercentage')) {
						return {
							allow: true,
							method: 'convertPercentage'
						};
					}
				}
			}
			return {
				allow: false
			};
		}

		function checkRoundSettings(type) {
			if (configuration[type] && configuration[type].number_of_decimals) {
				if (configuration[type].allowed_methods && configuration[type].allowed_methods.includes('roundValue')) {
					return {
						allow: true,
						number_of_decimals: settings.use_percent ? configuration[type].number_of_decimals.percentage : configuration[type].number_of_decimals.amount,
						method: 'roundValue'
					};
				}
			}
			return {
				allow: false
			};
		}

		function checkGetSignificantSettings(type) {
			if (configuration[type] && configuration[type].use_significant) {
				if (configuration[type].allowed_methods && configuration[type].allowed_methods.includes('getSignificant')) {
					return {
						allow: true,
						method: 'getSignificant'
					};
				}
			}
			return {
				allow: false
			};
		}

		function getSettings() {
			settings = JSON.parse(localStorage.getItem('user_settings'));
		}

		function bulkKgToLb(data) {
			for (var key in data) {
				data[key] = kgToLb(data[key], key);
			}
			return data;
		}

		function kgToLb(data, type) {
			//when using kgs, value must be multiplied
			//when using grams, value must be divided

			if (type) {
				if (checkLbSettings(type).allow) {
					return convert[checkLbSettings(type).method](data, 'kgToLb');
				} else {
					return data;
				}
			} else {
				return !settings.use_kgs ? data * lbConversionRate : data;
			}
		}

		function gramToLb(data) {
			return !settings.use_kgs ? data / lbConversionRate : data;
		}

		function bulkLbToKg(data) {
			for (var key in data) {
				data[key] = lbToKg(data[key], key);
			}
			return data;
		}

		function lbToKg(data, type) {
			//when using kgs, value must be divided
			//when using grams, value must be multiplied

			if (type) {
				if (checkLbSettings(type).allow) {
					return convert[checkLbSettings(type).method](data, 'lbToKg');
				} else {
					return data;
				}
			} else {
				return !settings.use_kgs ? data / lbConversionRate : data;
			}
		}

		function lbToGram(data) {
			return !settings.use_kgs ? data * lbConversionRate : data;
		}

		function bulkAmountToProduct(data, dm) {
			for (var key in data) {
				data[key] = amountToProduct(data[key], key, dm);
			}
			return data;
		}

		function amountToProduct(data, type, dm) {
			if (type) {
				if (checkProductSettings(type).allow) {
					return convert[checkProductSettings(type).method](data, 'amountToProduct', dm);
				} else {
					return data;
				}
			} else {
				return (data * 100) / dm;
			}
		}

		function bulkProductToAmount(data, dm) {
			for (var key in data) {
				data[key] = productToAmount(data[key], key, dm);
			}
			return data;
		}

		function productToAmount(data, type, dm) {
			if (type) {
				if (checkProductSettings(type).allow) {
					return convert[checkProductSettings(type).method](data, 'productToAmount', dm);
				} else {
					return data;
				}
			} else {
				return (data * dm) / 100;
			}
		}

		function bulkMcalToMjoule(data) {
			for (var key in data) {
				data[key] = mcalToMjoule(data[key], key);
			}
			return data;
		}

		function mcalToMjoule(data, type) {
			if (type) {
				if (checkMjouleSettings(type).allow) {
					return convert[checkMjouleSettings(type).method](data, 'mcalToMjoule');
				} else {
					return data;
				}
			} else {
				return !settings.use_mcal ? data * mjouleConversionRate : data;
			}
		}

		function bulkMjouleToMcal(data) {
			for (var key in data) {
				data[key] = mjouleToMcal(data[key], key);
			}
			return data;
		}

		function mjouleToMcal(data, type) {
			if (type) {
				if (checkMjouleSettings(type).allow) {
					return convert[checkMjouleSettings(type).method](data, 'mjouleToMcal');
				} else {
					return data;
				}
			} else {
				return !settings.use_mcal ? data / mjouleConversionRate : data;
			}
		}

		function bulkPercentToAmount(data) {
			for (var key in data) {
				data[key] = percentToAmount(data[key], key);
			}
			return data;
		}

		function percentToAmount(data, type) {
			if (type) {
				if (checkPercentageSettings(type).allow) {
					return convert[checkPercentageSettings(type).method](data, 'percentToAmount');
				} else {
					return data;
				}
			} else {
				return !settings.use_percent ? data * 10 : data;
			}
		}

		function bulkAmountToPercent(data) {
			for (var key in data) {
				data[key] = amountToPercent(data[key], key);
			}
			return data;
		}

		function amountToPercent(data, type) {
			if (type) {
				if (checkPercentageSettings(type).allow) {
					return convert[checkPercentageSettings(type).method](data, 'amountToPercent');
				} else {
					return data;
				}
			} else {
				return !settings.use_percent ? data / 10 : data;
			}
		}

		function bulkRoundValues(data) {
			for (var key in data) {
				data[key] = roundValues(data[key], key);
			}
			return data;
		}

		function roundValues(data, type) {
			if (type) {
				if (checkRoundSettings(type).allow) {
					return convert[checkRoundSettings(type).method](data, checkRoundSettings(type).number_of_decimals);
				} else {
					return data;
				}
			} else {
				return round(data, 2) || data;
			}
		}

		function round(value, decimals) {
			if (value != null && Number.isFinite(value)) {
				return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
			} else {
				return 0;
			}
		}

		function bulkGetSignificant(data) {
			for (var key in data) {
				data[key] = getSignificant(data[key], key);
			}
			return data;
		}

		function getSignificant(data, type) {
			if (type) {
				if (checkGetSignificantSettings(type).allow) {
					return convert[checkGetSignificantSettings(type).method](data);
				} else {
					return data;
				}
			} else {
				return getSignificantDigits(data, 3) || data;
			}
		}

		function getSignificantDigits(value, number_of_digits) {
			var v = Number(value);
			if (v != null && Number.isFinite(v)) {
				var param = v.toPrecision(number_of_digits);
				v = Number(param);
			}
			return v;
		}

		function metricTonToImperialTon(data) {
			if (!settings.use_kgs) {
				return data * 1.1023 || 0;
			} else {
				return data;
			}
		}

		function imperialTonToMetricTon(data) {
			if (!settings.use_kgs) {
				return data / 1.1023 || 0;
			} else {
				return data;
			}
		}

		function metricTonToPounds(data) {
			if (!settings.use_kgs) {
				return data * 2204.6 || 0;
			} else {
				return data;
			}
		}

		function poundsToMetricTon(data) {
			if (!settings.use_kgs) {
				return data / 2204.6 || 0;
			} else {
				return data;
			}
		}

		function metricTonToKg(data) {
			return data * 1000 || 0;
		}

		function kgToMetricTon(data) {
			return data / 1000 || 0;
		}

		function poundsToImperialTon(data) {
			return data * 2240 || 0;
		}

		function imperialTonToPounds(data) {
			return data / 2240 || 0;
		}

		function kgToImperialTon(data) {
			if (!settings.use_kgs) {
				return data / 1016 || 0;
			} else {
				return data;
			}
		}

		function imperialTonToKg(data) {
			if (!settings.use_kgs) {
				return data * 1016 || 0;
			} else {
				return data;
			}
		}

		function balanceKgToLbConcentration(feedDTO) {
			if (!settings.use_kgs) {
				feedDTO.amount_dm = feedDTO.amount_dm * lbConversionRate;
				feedDTO.dve = feedDTO.dve * lbConversionRate;
				feedDTO.oeb = feedDTO.oeb * lbConversionRate;
				feedDTO.fos = feedDTO.fos * lbConversionRate;
				feedDTO.as_feed = feedDTO.as_feed * lbConversionRate;
				feedDTO.group_as_feed = feedDTO.group_as_feed * lbConversionRate;
				feedDTO.nel = feedDTO.nel / lbConversionRate;
				feedDTO.me = feedDTO.me / lbConversionRate;
				feedDTO.me_89 = feedDTO.me_89 / lbConversionRate;
				feedDTO.nel_89 = feedDTO.nel_89 / lbConversionRate;
				feedDTO.nel_01 = feedDTO.nel_01 / lbConversionRate;
				feedDTO.me_01 = feedDTO.me_01 / lbConversionRate;
				feedDTO.dep = feedDTO.dep / lbConversionRate;
				feedDTO.de1x = feedDTO.de1x / lbConversionRate;
				feedDTO.nem = feedDTO.nem / lbConversionRate;
				feedDTO.neg = feedDTO.neg / lbConversionRate;
				feedDTO.vitamin_a = feedDTO.vitamin_a / lbConversionRate;
				feedDTO.vitamin_d = feedDTO.vitamin_d / lbConversionRate;
				feedDTO.vitamin_e = feedDTO.vitamin_e / lbConversionRate;
				feedDTO.cost_dm = feedDTO.cost_dm / lbConversionRate;
				feedDTO.cost_dm_100 = feedDTO.cost_dm_100 / lbConversionRate;
				feedDTO.pur_cost = feedDTO.pur_cost / lbConversionRate;
			}
			return feedDTO;
		}

		function SetConversionRates() {
			this.convertAmount = function (data, type) {
				return type === 'kgToLb' ? data * lbConversionRate || 0 : data / lbConversionRate || 0;
			};

			this.convertAmountDivisor = function (data, type) {
				return type === 'kgToLb' ? data / lbConversionRate || 0 : data * lbConversionRate || 0;
			};

			this.convertAmountProduct = function (data, type, dm) {
				return type === 'amountToProduct' ? (data * 100) / dm || 0 : (data * dm) / 100 || 0;
			};

			this.convertMjoule = function (data, type) {
				return type === 'mcalToMjoule' ? data * mjouleConversionRate || 0 : data / mjouleConversionRate || 0;
			};

			this.convertPercentage = function (data, type) {
				return type === 'percentToAmount' ? data * 10 || 0 : data / 10 || 0;
			};

			this.roundValue = function (data, numOfDec) {
				return Number.isFinite(data) ? round(data, numOfDec) : 0;
			};

			this.getSignificant = function (data) {
				return getSignificantDigits(data, 3) || 0;
			};
		}
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.feeds').service('feedsService', feedsService);

	/** @ngInject */
	function feedsService() {
		this.xmlFeedUUID = null;

		this.setXmlFeedUUID = function (uuid) {
			this.xmlFeedUUID = uuid;
		};

		this.getXmlFeedUUID = function () {
			return this.xmlFeedUUID;
		};

		this.clear = function () {
			this.xmlFeedUUID = null;
		};
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.login').controller('loginCtrl', loginCtrl);
	/** @ngInject */
	function loginCtrl($uibModal, $scope, authService, $timeout, $filter, $cookies, toastr, $uibModalStack, tmhDynamicLocale, localize, $state, authManager, $http, APP_CONST, cookiesService, $location, uaParser, auth0Service) {
		var lc = this;
		lc.login = login;
		lc.getBackgroundPadding = getBackgroundPadding;
		lc.isCollapsed = true;
		var deviceType = uaParser.getDevice('type');
		var origin = window.location.origin;
		var host = $location.host();
		var rc = $cookies.getObject('rc');
		if (host === 'spartan.mmmooogle.com' || host === 'ration.mmmooogle.com') {
			// if (host === 'spartan-staging.mmmooogle.com' || host === 'ration-staging.mmmooogle.com') {
			if (rc) {
				if (moment(rc.d).isBefore(moment())) {
					rc = {
						d: moment().add(35, 'seconds').valueOf()
					};
					cookiesService.setCookie('rc', JSON.stringify(rc));
					window.location.reload();
				}
			} else {
				rc = {
					d: moment().add(35, 'seconds').valueOf()
				};
				$cookies.put('rc', JSON.stringify(rc));
				window.location.reload();
			}
		}

		init();

		function init() {
			auth0Service.init();
			handleAuthentication();
		}

		function getBackgroundPadding() {
			return deviceType === 'mobile'
				? {
						paddingBottom: '1000px'
				  }
				: deviceType === 'tablet'
				? {
						paddingBottom: '450px'
				  }
				: {
						paddingBottom: '100px'
				  };
		}
		function handleAuthentication() {
			return auth0Service
				.handleAuthentication()
				.then(function (authResult) {
					authManager.authenticate();
					openModal('app/pages/login/login.modal.html', 'sm');
					onAuthenticated(authResult);
				})
				.catch(function (error) {
					console.log(error);
				});
		}

		function onAuthenticated(authResult) {
			var user = {
				picture: authResult.idTokenPayload.picture,
				email: authResult.idTokenPayload.email,
				name: authResult.idTokenPayload.name
			};
			var expireDate = new Date();
			expireDate.setDate(expireDate.getDate() + 1);
			if (authResult.idToken) {
				cookiesService.setCookie('mmmooogle_token', authResult.idToken, {
					samesite: 'lax',
					secure: true,
					domain: '.mmmooogle.com',
					expires: expireDate
				});
			}
			localStorage.setItem('user_profile', JSON.stringify(user));
			localStorage.setItem('id_token', authResult.idToken);
			checkAccess(authResult);
		}

		function checkAccess(authResult) {
			if (authResult && authResult.idTokenPayload && authResult.idTokenPayload.sub) {
				return authService
					.getUserTeamAccess()
					.then(function (response) {
						var teams = response;

						var teamsWithAccess = [];
						for (var i = 0; i < teams.length; i++) {
							if (authService.haveFeedAccess(teams[i].AccessControls)) {
								var team = {
									id: teams[i].TeamId,
									accessControls: teams[i].AccessControls
								};
								teamsWithAccess.push(team);
							}
						}
						authService.teams = teamsWithAccess;
						if (teamsWithAccess.length > 0) {
							authorize(teamsWithAccess);
						} else {
							auth0Service.handleUnauthorized(2000);
							toastr.error($filter('i18n')('_login_error_message_403_status_'));
							$uibModalStack.dismissAll();
						}
					})
					.catch(function (error) {
						console.log(error);
						auth0Service.handleUnauthorized(1000);
						toastr.error($filter('i18n')('_toastr_error_occured_'), $filter('i18n')('_toastr_error_title_'));
						$uibModalStack.dismissAll();
					});
			} else {
				console.log(error);
				auth0Service.handleUnauthorized(1000);
				toastr.error($filter('i18n')('_toastr_error_occured_'), $filter('i18n')('_toastr_error_title_'));
				$uibModalStack.dismissAll();
			}
		}

		function authorize(teams) {
			return authService
				.getUserSettings()
				.then(function (response) {
					if (!response.use_amount) {
						response.use_amount = true;
						saveSettings(response);
					}
					var found = false;
					for (var i = 0; i < teams.length; i++) {
						if (response.selectedTeam.id == teams[i].id) {
							cookiesService.setCookie('mmmooogle_tenant', response.selectedTeam.id, {
								samesite: 'lax',
								secure: true,
								domain: '.mmmooogle.com'
							});
							found = true;
						}
					}
					if (!found) {
						response.team_id = teams[0].id;
						response.selectedTeam.id = teams[0].id;
						response.herd_id = null;
						response.selectedHerd.id = null;
						response.noSelectedTeam = true;
						cookiesService.setCookie('mmmooogle_tenant', response.selectedTeam.id, {
							samesite: 'lax',
							secure: true,
							domain: '.mmmooogle.com'
						});
						localStorage.setItem('user_settings', JSON.stringify(response));
						tmhDynamicLocale.set(response.language);
						localize.setLanguage(response.language);
						$state.go('dashboard');
					} else {
						if (response.selectedHerd.id) {
							checkHerdAccess(response);
						} else {
							localStorage.setItem('user_settings', JSON.stringify(response));
							tmhDynamicLocale.set(response.language);
							localize.setLanguage(response.language);
							$state.go('dashboard');
						}
					}
				})
				.catch(function (error) {
					if (error.status === 403) {
						toastr.error($filter('i18n')('_login_error_message_403_status_'));
						$uibModalStack.dismissAll();
					} else {
						toastr.error($filter('i18n')('_toastr_error_occured_'), $filter('i18n')('_toastr_error_title_'));
						$uibModalStack.dismissAll();
					}
					auth0Service.handleUnauthorized(2000);
				});
		}

		function checkHerdAccess(userSettings) {
			return authService
				.getUserTeamHerdAccess(userSettings.selectedHerd.id)
				.then(function (response) {
					var found = false;
					for (var i = 0; i < response.length; i++) {
						// response[i].AccessControls = 261151;
						if (response[i].HerdId == userSettings.selectedHerd.id && authService.haveFeedAccess(response[i].AccessControls)) {
							found = true;
							break;
						}
					}
					if (!found) {
						userSettings.herd_id = null;
						userSettings.selectedHerd.id = null;
						localStorage.setItem('user_settings', JSON.stringify(userSettings));
						tmhDynamicLocale.set(userSettings.language);
						localize.setLanguage(userSettings.language);
						$state.go('dashboard');
					} else {
						localStorage.setItem('user_settings', JSON.stringify(userSettings));
						tmhDynamicLocale.set(userSettings.language);
						localize.setLanguage(userSettings.language);
						$state.go('dashboard');
					}
				})
				.catch(function () {
					userSettings.herd_id = null;
					userSettings.selectedHerd.id = null;
					localStorage.setItem('user_settings', JSON.stringify(userSettings));
					tmhDynamicLocale.set(userSettings.language);
					localize.setLanguage(userSettings.language);
					$state.go('dashboard');
				});
		}

		function login() {
			var host = $location.host();
			if (host === 'spartan.mmmooogle.com' || host === 'ration.mmmooogle.com') {
				window.location.reload();
			} else {
				auth0Service.login();
			}
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function saveSettings(data) {
			$http
				.patch(APP_CONST.api_base_url + 'userSettings', data)
				.then()
				.catch(function (error) {
					console.log(error);
				});
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.login').service('authService', authService);
	/** @ngInject */
	function authService($http, APP_CONST, $q, authManager) {
		return {
			getUserTeamAccess: getUserTeamAccess,
			getUserSettings: getUserSettings,
			getUserTeamHerdAccess: getUserTeamHerdAccess,
			isAuthenticated: isAuthenticated,
			haveFeedAccess: haveFeedAccess,
			teams: [],
			can: can
		};

		function getUserTeamAccess() {
			return $http
				.get(APP_CONST.backoffice_base_url + 'users/userteamaccess')
				.then(success)
				.catch(error);
		}

		function getUserSettings() {
			return $http
				.post(APP_CONST.api_base_url + 'userSettings')
				.then(success)
				.catch(error);
		}

		function getUserTeamHerdAccess(herd_id) {
			return $http
				.get(APP_CONST.backoffice_base_url + 'userteamherdaccess/me?HerdId=' + herd_id)
				.then(success)
				.catch(error);
		}

		function can(accessContol) {
			var userSettings = JSON.parse(localStorage.getItem('user_settings'));
			var access = false;

			if (userSettings) {
				for (var i = 0; i < this.teams.length; i++) {
					if (this.teams[i].id == userSettings.selectedTeam.id) {
						if (haveAccess(this.teams[i].accessControls, accessContol)) {
							access = true;
							break;
						}
					}
				}
			}
			return access;
		}

		function haveFeedAccess(accessControl) {
			//ration - 16
			//tmr - 64
			if (haveAccess(accessControl, 16) || haveAccess(accessControl, 64)) {
				return true;
			} else {
				return false;
			}
		}

		function haveAccess(accControls, accMask) {
			if ((accControls & accMask) == accMask) {
				return true;
			} else {
				return false;
			}
		}

		function success(response) {
			return response.data;
		}

		function isAuthenticated() {
			return authManager.isAuthenticated();
		}

		function error(error) {
			console.log(error);
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.insights').controller('insightsCtrl', insightsCtrl);
	/** @ngInject */
	function insightsCtrl(insightsFactory, $sce, $cookies, $q, $timeout, $rootScope, $filter, $scope, $uibModal, $uibModalStack, errorService, APP_CONST, bugsnagService, $interval) {
		var vm = this;
		var searchTimer;
		var viz;

		// Lookup helper for v3 collections (worksheets/filters/parameters): returns
		// the first item whose name or fieldName matches, or null. Replaces the v2
		// `collection.get(name)` accessor that no longer exists in v3 (collections
		// are plain arrays).
		function _byName(list, name) {
			if (!list) { return null; }
			for (var i = 0; i < list.length; i += 1) {
				var item = list[i];
				if (item && (item.name === name || item.fieldName === name)) {
					return item;
				}
			}
			return null;
		}

		var i18nFilter = $filter('i18n');
		var herdSelectedTimer;
		var herdsPromise;
		var addToReportPromise;
		var dashboardsPromise;
		vm.selectDashboard = selectDashboard;
		vm.goBackToDashboard = goBackToDashboard;
		vm.getLabelId = getLabelId;
		vm.search = search;
		vm.setButtonColor = setButtonColor;
		vm.getBtnClass = getBtnClass;
		vm.categorySelected = categorySelected;
		vm.getTableClass = getTableClass;
		vm.closeModal = closeModal;
		vm.customTimeSelected = customTimeSelected;
		vm.timeSelectorChanged = timeSelectorChanged;
		vm.selectLayout = selectLayout;
		vm.getDashboardClass = getDashboardClass;
		vm.goBackOnClose = goBackOnClose;
		vm.goBack = goBack;
		vm.openAddToReportModal = openAddToReportModal;
		vm.addToReport = addToReport;
		var measureNameParam;
		var feedFilterPairs = APP_CONST.constants.feedFilterPairs;
		vm.searchDescriptionString = '';
		vm.searchTypeString = '';
		vm.selectedLayout = 2;
		vm.activeCategoryName = null;
		vm.init = init;
		vm.openCreateReport = openCreateReport;
		vm.setReportData = setReportData;
		vm.activeCategory = null;
		vm.work_locally = false;
		vm.loadingError = false;
		var loadingDotsCounter = 0;
		var laodingDotsInterval;
		vm.closeCreateReport = closeCreateReport;
		vm.setReportDate = setReportDate;
		vm.openReportDashboardPeriodModal = openReportDashboardPeriodModal;
		vm.setReportDashboardRange = setReportDashboardRange;
		vm.openReportCommentModal = openReportCommentModal;
		vm.setReportDashboardComment = setReportDashboardComment;
		setStrings();
		init();

		function setStrings() {
			vm.viewDataDashboardName = i18nFilter('_dashboard_feed_view_data_');
			measureNameParam = 'Measure Names';
			vm.devIng = i18nFilter('_dashboard_feed_name_deviation_ingredient_');
			vm.devWeek = i18nFilter('_dashboard_feed_name_deviation_week_day_');
			vm.loadSch = i18nFilter('_dashboard_feed_name_loading_schedule_');
			vm.dropp = i18nFilter('_dashboard_feed_name_dropping_starts_');
			vm.ingTotalT = i18nFilter('_dashboard_feed_name_ingredients_loaded_total_time_');
			vm.ingPP = i18nFilter('_dashboard_feed_name_ingredients_loaded_per_pen_');
			vm.milkMeterDashboard = i18nFilter('_dashboard_feed_name_milk_meter_');
			vm.milkRecordingDashboard = i18nFilter('_dashboard_feed_name_milk_recording_');
			vm.lactationCAnalysisByCalvingDate = i18nFilter('_dashboard_feed_name_lac_cal_anal_calving_date_');
			vm.lactationCAnalysisByMilkRecordingDate = i18nFilter('_dashboard_feed_name_lac_cal_anal_mr_date_');
			vm.totalLoadedPerDayDashboardId = i18nFilter('_dashboard_feed_id_total_loaded_per_day_');
			vm.totalCostPerDayDashboardId = i18nFilter('_dashboard_feed_id_total_cost_per_day_');
			vm.totalCostPerDayDashboard = i18nFilter('_dashboard_feed_id_total_cost_per_day_');

			vm.deviationByIngredient = i18nFilter('_feed_worksheet_name_deviation_ingredient_');
			vm.ingredientsLoadedOverTimeTotal = i18nFilter('_feed_worksheet_ing_loaded_over_time_total_');
			vm.ingredientsLoadedOverTimePerPen = i18nFilter('_feed_worksheet_ing_loaded_over_time_per_pen_');
			vm.ingredientsLoadedOverTimePerPenId = i18nFilter('_dashboard_feed_id_ingredients_loaded_per_pen_');
			vm.ingredientsDroppedOverTimePerPen = i18nFilter('_feed_worksheet_ing_dropped_over_time_per_pen_');
			vm.ingredientsDroppedOverTimePerPenId = i18nFilter('_dashboard_feed_id_ingredients_dropped_per_pen_');
			vm.totalAmountLoadedPerDay = i18nFilter('_feed_worksheet_name_total_amount_loaded_per_day_');
			vm.totalCostsPerDay = i18nFilter('_feed_worksheet_name_total_costs_per_day_');
			vm.totalCostsPerDayDashboardName = i18nFilter('_dashboard_feed_name_total_cost_per_day_');
			vm.totalAmountLoadedPerDayDashboard = i18nFilter('_dashboard_feed_name_total_loaded_per_day_');
			vm.ingredientsDroppedOverTimePerPenDashboard = i18nFilter('_dashboard_feed_name_ingredients_dropped_per_pen_');
			vm.ingredientsLoadedOverTimeTotalId = i18nFilter('_dashboard_feed_id_ingredients_loaded_total_time_');
			vm.DMIPerCowPerDayPerPenId = i18nFilter('_dashboard_feed_id_dmi_per_cow_per_day_per_pen_');
			vm.DMIPerCowPerDayPerPenName = i18nFilter('_dashboard_feed_name_dmi_per_cow_per_day_per_pen_');
		}

		function init() {
			//time selector
			// 7 - 7 days
			// 30 - 30 days
			// 1 - 1 year
			// 69 - custom
			// 90 - 90 days
			vm.selectedTime = 1;
			vm.end_date = new Date(moment().hour(23).minute(59).seconds(59).millisecond(999));
			vm.start_date = new Date(moment().hour(12).minute(0).seconds(0).millisecond(0).subtract(1, 'years').toISOString());
			vm.itemsToShow = [
				{
					label: '10',
					value: 10
				},
				{
					label: '25',
					value: 25
				},
				{
					label: '50',
					value: 50
				},
				{
					label: 'All',
					value: 999999
				}
			];
			vm.itemsPerPage = vm.itemsToShow[2];
			vm.loadingBaseTable = true;
			vm.defaultValues = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.currentLanguage = setCurrentLanguage(vm.defaultValues);
			if (vm.defaultValues.selectedTeam.id) {
				vm.selectedTeam = vm.defaultValues.selectedTeam.id;
				if (vm.defaultValues.selectedHerd.id) {
					vm.selectedHerd = vm.defaultValues.selectedHerd.id;
				} else {
					vm.selectedHerd = null;
				}
			} else {
				vm.selectedTeam = null;
			}
			vm.allCategories = [
				{
					name: '_dc_production_',
					id: 'production'
				},
				{
					name: '_dc_reproduction_',
					id: 'reproduction'
				},
				{
					name: '_dc_udder_health_',
					id: 'udder_health'
				},
				{
					name: '_dc_hoof_health_',
					id: 'hoof_health'
				},
				{
					name: '_dc_herd_characteristics_',
					id: 'herd_characteristics'
				},
				{
					name: '_dc_comments_',
					id: 'comments'
				},
				{
					name: '_dc_environmental_',
					id: 'environment'
				},
				{
					name: '_dc_genetics_',
					id: 'genetics'
				},
				{
					name: '_dc_other_',
					id: 'other'
				},
				{
					name: '_dc_feed_',
					id: 'feed'
				}
			];
			for (var i = 0; i < vm.allCategories.length; i++) {
				vm.allCategories[i].name = i18nFilter(vm.allCategories[i].name);
			}
			if (vm.defaultValues && vm.defaultValues.selectedTeam.id) {
				getDashboards(vm.selectedTeam);
			}
			vm.showBaseTable = true;
			vm.showFrame = false;
		}

		function setCategories(dashboards) {
			var udder_health_index;
			var hoof_health_index;
			var feed_index;
			for (var i = 0; i < vm.allCategories.length; i++) {
				if (vm.allCategories[i].id == 'udder_health') {
					udder_health_index = i;
				}

				if (vm.allCategories[i].id == 'hoof_health') {
					hoof_health_index = i;
				}

				if (vm.allCategories[i].id == 'feed') {
					feed_index = i;
				}
			}

			for (var i = 0; i < dashboards.length; i++) {
				dashboards[i].position = i;
				for (var j = 0; j < vm.allCategories.length; j++) {
					if (dashboards[i].category == vm.allCategories[j].id) {
						vm.allCategories[j].used = true;
						dashboards[i].category = vm.allCategories[j];
						break;
					}
				}
			}
			for (var i = 0; i < dashboards.length; i++) {
				if (!dashboards[i].category.name && dashboards[i].subcategory) {
					if ((dashboards[i].subcategory.indexOf('udder') !== -1 && dashboards[i].subcategory.indexOf('health') !== -1) || (dashboards[i].subcategory.indexOf('cows') !== -1 && dashboards[i].subcategory.indexOf('mastitis') !== -1)) {
						vm.allCategories[udder_health_index].used = true;
						dashboards[i].category = vm.allCategories[udder_health_index];
					} else if (dashboards[i].subcategory.indexOf('cows') !== -1 && dashboards[i].subcategory.indexOf('hoof') !== -1) {
						vm.allCategories[hoof_health_index].used = true;
						dashboards[i].category = vm.allCategories[hoof_health_index];
					}
				}

				if (dashboards[i].category.id && dashboards[i].category.id == 'production' && dashboards[i].subcategory == 'feed-list') {
					dashboards[i].category = vm.allCategories[feed_index];
					vm.allCategories[feed_index].used = true;
				}
			}
			for (var i = 0; i < dashboards.length; i++) {
				if (!dashboards[i].category.name) {
					var category = {
						name: dashboards[i].category,
						id: dashboards[i].category
					};
					dashboards[i].category = category;
				}
			}
			return dashboards;
		}

		function getDashboards(team_id) {
			if (!vm.work_locally) {
				return insightsFactory
					.setTableauTenant(team_id)
					.then(function () {
						getTableauDashboards(team_id);
					})
					.catch(function (error) {
						vm.loadingBaseTable = false;
						vm.loadingError = true;
					});
			} else {
				getTableauDashboards(team_id);
			}

			function getTableauDashboards(team_id) {
				if (insightsFactory.loadedDashboards.dashboards && insightsFactory.loadedDashboards.team_id == team_id && insightsFactory.loadedDashboards.lng == vm.currentLanguage) {
					if (moment(insightsFactory.loadedDashboards.expires).isBefore(moment())) {
						useAPI();
					} else {
						var dashboards = [];
						angular.copy(insightsFactory.loadedDashboards.dashboards, dashboards);
						handleResponse(dashboards);
					}
				} else {
					useAPI();
				}
			}

			function handleResponse(response) {
				var list = [];

				for (var i = 0; i < response.length; i++) {
					if (
						(response[i].category == 'production' && response[i].subcategory == 'feed-list' && response[i].description != vm.viewDataDashboardName) ||
						(response[i].description == vm.milkMeterDashboard && response[i].category == 'production' && response[i].subcategory == 'milk-meter') ||
						response[i].description == vm.milkRecordingDashboard ||
						(response[i].description == vm.lactationCAnalysisByMilkRecordingDate && response[i].category == 'production' && response[i].subcategory == 'milk-recording-curve') ||
						(response[i].description == vm.lactationCAnalysisByCalvingDate && response[i].category == 'production' && response[i].subcategory == 'milk-recording-curve')
					) {
						var temp = {
							title: response[i].description,
							category: response[i].category,
							id: response[i].id,
							url: response[i].url,
							subcategory: response[i].subcategory,
							thumbnail: setDashboardThumbnail(response[i]),
							addToReport: true
						};
						list.push(temp);
					}
				}

				setDashboards(list);
			}

			function setDashboardThumbnail(dashboard) {
				var thumb;

				switch (dashboard.description) {
					case i18nFilter('_dashboard_feed_name_milk_meter_'):
						thumb = 'assets/img/thumbnails/milk_meter_dashboard.png';
						break;
					case i18nFilter('_dashboard_feed_name_milk_recording_'):
						thumb = 'assets/img/thumbnails/milk_recording_dashboard.png';
						break;
					case i18nFilter('_dashboard_feed_name_lac_cal_anal_calving_date_'):
						thumb = 'assets/img/thumbnails/l_curve_analysis_c_d.png';
						break;
					case i18nFilter('_dashboard_feed_name_lac_cal_anal_mr_date_'):
						thumb = 'assets/img/thumbnails/l_curve_analysis_m_r_d.png';
						break;
					case i18nFilter('_dashboard_feed_name_deviation_ingredient_'):
						thumb = 'assets/img/thumbnails/deviation_ingredient_dashboard.png';
						break;
					case i18nFilter('_dashboard_feed_name_deviation_week_day_'):
						thumb = 'assets/img/thumbnails/deviation_day_of_week_dashboard.png';
						break;
					case i18nFilter('_dashboard_feed_name_loading_schedule_'):
						thumb = 'assets/img/thumbnails/loading_schedule_dashboard.png';
						break;
					case i18nFilter('_dashboard_feed_name_dropping_starts_'):
						thumb = 'assets/img/thumbnails/dropping_starts_dashboard.png';
						break;
					case i18nFilter('_dashboard_feed_name_ingredients_loaded_total_time_'):
						thumb = 'assets/img/thumbnails/ing_loaded_over_time_total_dashboard.png';
						break;
					case i18nFilter('_dashboard_feed_name_ingredients_loaded_per_pen_'):
						thumb = 'assets/img/thumbnails/ing_loaded_over_time_per_pen_dashboard.png';
						break;
					case vm.ingredientsDroppedOverTimePerPenDashboard:
						thumb = 'assets/img/thumbnails/ing_dropped_over_time_per_pen_dashboard.png';
						break;
					case vm.totalAmountLoadedPerDayDashboard:
						thumb = 'assets/img/thumbnails/amount_loaded_per_day_dashboard.png';
						break;
					case vm.totalCostsPerDayDashboardName:
						thumb = 'assets/img/thumbnails/total_costs_per_day_dashboard.png';
						break;
					case vm.DMIPerCowPerDayPerPenName:
						thumb = 'assets/img/thumbnails/dry_matter_intake_per_cow_per_day_by_pen_dashboard.png';
						break;

					default:
						break;
				}

				return thumb;
			}

			function setDashboards(dashboards) {
				vm.dashboards = dashboards;
				vm.dashboards = setCategories(vm.dashboards);
				vm.dashboardsSafe = vm.dashboards;
				vm.allDashboards = vm.dashboards;
				filterList(vm.searchString);
				if (vm.lastUsedDashboard) {
					var found;
					for (var i = 0; i < vm.allDashboards.length; i++) {
						if (vm.allDashboards[i].id == vm.lastUsedDashboard.id) {
							found = true;
							break;
						}
					}
					if (found) {
						vm.showFrame = false;
						vm.loadingBaseTable = true;
						selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, true);
					}
				}
				vm.loadingError = false;
				vm.loadingBaseTable = false;
			}

			function useAPI() {
				if (localStorage.getItem('tableauLoading')) {
					$scope.$on('tableau_loaded', function () {
						$timeout(function () {
							var response = [];
							angular.copy(insightsFactory.loadedDashboards.dashboards, response);
							handleResponse(response);
						}, 250);
					});
				} else {
					var tableauSuffix = '?locale=' + vm.currentLanguage;
					return insightsFactory
						.getTableauDashboards(team_id, tableauSuffix)
						.then(function (response) {
							var obj = {
								dashboards: response,
								expires: moment().add(30, 'minutes').format(),
								team_id: team_id,
								lng: vm.currentLanguage
							};
							insightsFactory.loadedDashboards = obj;
							handleResponse(response);
							//vm.loadingBaseTable = false;
						})
						.catch(function (error) {
							console.log(error);
							vm.dashboards = [];
							vm.loadingError = true;
						});
				}
			}
		}

		function createLastWeekSuffix() {
			vm.end_date = new Date(moment().hour(12).minute(0).seconds(0).millisecond(0));
			vm.start_date = new Date(moment().hour(12).minute(0).seconds(0).millisecond(0).subtract(7, 'days'));
		}

		function createLastMonthSuffix() {
			vm.end_date = new Date(moment().hour(12).minute(0).seconds(0).millisecond(0));
			vm.start_date = new Date(moment().hour(12).minute(0).seconds(0).millisecond(0).subtract(30, 'days'));
		}

		function createLast90DaysSuffix() {
			vm.end_date = new Date(moment().hour(12).minute(0).seconds(0).millisecond(0));
			vm.start_date = new Date(moment().hour(12).minute(0).seconds(0).millisecond(0).subtract(90, 'days'));
		}

		function createLastYearSuffix() {
			vm.end_date = new Date(moment().hour(12).minute(0).seconds(0).millisecond(0));
			vm.start_date = new Date(moment().hour(12).minute(0).seconds(0).millisecond(0).subtract(1, 'years'));
		}

		function timeSelectorChanged(type) {
			if (type != 69) {
				vm.selectedTime = type;
				vm.showFrame = false;
				vm.loadingBaseTable = true;
				selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType);
			} else {
				openModal('app/pages/insights/custom.modal.html', 'sm');
			}
		}

		function goBackToDashboard() {
			setBackButtonVisibility(false);
			vm.activeCategory = null;
			vm.activeCategoryName = null;
			vm.showFrame = false;
			vm.showBaseTable = false;
			vm.lastUsedDashboard = null;
			vm.lastUsedDashboardType = null;
			vm.embed = null;
			if (viz) {
				viz = null;
			}
			$timeout(function () {
				vm.showBaseTable = true;
			}, 50);
		}

		function selectLayout(n) {
			vm.selectedLayout = n;
		}

		function selectDashboard(dashboard, type, set_default) {
			vm.loadingBaseTable = false;
			vm.errorLoading = false;
			vm.dashboardNotAvailable = false;
			vm.showAddToReportButton = false;
			if (set_default) {
				setDefaultDates(dashboard);
			}

			openDashboard(dashboard, type);
		}

		function openDashboard(dashboard, type) {
			vm.hideAddToReport = false;
			setBackButtonVisibility(false);
			broadcastDashboard(dashboard);
			//var isMastitsDashboard = getIsMastitisDashboard(dashboard);
			vm.lastUsedDashboard = dashboard;
			vm.lastUsedDashboardType = type;
			var dash = {};
			angular.copy(dashboard, dash);
			embedPage(dash);
		}

		function setDefaultDates(dashboard) {
			if (dashboard.subcategory == 'feed-list') {
				if (dashboard.id == vm.totalCostPerDayDashboardId || dashboard.id == vm.totalLoadedPerDayDashboardId) {
					vm.selectedTime = 7;
				} else {
					vm.selectedTime = 30;
				}
			}
		}

		function setStartEndDate() {
			if (vm.selectedTime == 7) {
				createLastWeekSuffix();
			} else if (vm.selectedTime == 30) {
				createLastMonthSuffix();
			} else if (vm.selectedTime == 1) {
				createLastYearSuffix();
			} else if (vm.selectedTime == 90) {
				createLast90DaysSuffix();
			}
		}

		function getDateParam(dashboard_id, selected_time) {
			var param = null;
			if (dashboard_id == vm.ingredientsLoadedOverTimeTotalId || dashboard_id == vm.ingredientsLoadedOverTimePerPenId || dashboard_id == vm.ingredientsDroppedOverTimePerPenId) {
				if (selected_time == 7 || selected_time == 30) {
					param = 'day';
				} else if (selected_time == 90) {
					param = 'week';
				} else if (selected_time == 1) {
					param = 'month';
				} else if (selected_time == 69) {
					var diff = moment(vm.end_date).diff(vm.start_date, 'days');
					if (diff <= 30) {
						param = 'day';
					} else if (diff > 30 && diff <= 92) {
						param = 'week';
					} else if (diff > 92 && diff < 1095) {
						param = 'month';
					} else {
						param = 'year';
					}
				}
			}
			return param;
		}

		function embedPage(dashboard) {
			var url = dashboard.url;
			if (vm.selectedTime != 69) {
				setStartEndDate();
			}
			vm.dateParam = getDateParam(dashboard.id, vm.selectedTime);
			if (vm.work_locally) {
				embedUrl(url, false);
			} else {
				embedUrl(url, true);
			}
		}

		function embedUrl(url, useTabvis) {
			vm.showBaseTable = false;
			vm.showFrame = true;
			if (viz) {
				window.TableauV3.disposeViz(viz);
			}
			if (useTabvis) {
				return insightsFactory
					.setSession(url)
					.then(function (response) {
						vm.loadingDashboards = false;
						vm.showButtons = true;
						var url = response.headers('tabvis-location');
						embed(url, useTabvis);
					})
					.catch(function (response) {
						if (response.status && response.status == 404) {
							vm.dashboardNotAvailable = true;
						}
						vm.embed = null;
						vm.errorLoading = true;
						vm.loading = false;

						console.log('error getting tabvis-location header', response);
					});
			} else {
				var url = 'https://visual-prd-new.mmmooogle.com/t/Production/views/team-52-production-milk-recording_en-GB_twb/Milkrecordingdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
				// team-3091-reproduction-zoetis_nl-NL_twb/Inseminatiestrategiebijkoeien
				// team-3091-reproduction-zoetis_en-GB_twb/Inseminationstrategyincows
				embed(url, useTabvis);
			}
		}

		function embed(url, useTabvis) {
			var herdParam = createHerdParam(vm.selectedHerd);
			if (vm.selectedHerd) {
				url = url + getHerdSuffix();
			}

			var deviceType;
			var parser = new UAParser();
			var device = parser.getDevice();
			if (device && device.type) {
				if (device.type == 'mobile') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else if (device.type == 'tablet') {
					deviceType = 'tablet';
				} else if (device.type == 'smarttv') {
					deviceType = 'desktop';
				} else if (device.type == 'wearable') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else {
					//deviceType = 'phone';
					deviceType = 'tablet';
				}
			} else {
				if (window.screen.height <= 900) {
					deviceType = 'tablet';
				} else {
					deviceType = 'desktop';
				}
			}
			if (url) {
				var parameters = {
					'Start Date': $filter('date')(vm.start_date, 'yyyy-MM-dd'),
					'End Date': $filter('date')(vm.end_date, 'yyyy-MM-dd')
				};

				parameters['Herd Parameter'] = herdParam;
				if (vm.dateParam) {
					parameters['DateParam'] = vm.dateParam;
				}

				if (viz) {
					window.TableauV3.disposeViz(viz);
				}
				$timeout(function () {
					window.tableauV3Ready.then(function () {
						var containerDiv = document.getElementById('frame');
						var listeners = {};
						listeners[window.TableauV3.EventType.FirstInteractive] = onInsightsFirstInteractive;
						listeners[window.TableauV3.EventType.TabSwitched] = onTabSwitch;
						viz = window.TableauV3.createViz(containerDiv, url, {
							device: deviceType,
							hideTabs: true,
							toolbar: 'hidden',
							parameters: parameters
						}, listeners);
					});
				}, 1000);
			}

			function onInsightsFirstInteractive() {
				var workbook = viz.workbook;
				var wrks = workbook.activeSheet.worksheets;
				var worksheetName;
				for (var i = 0; i < wrks.length; i++) {
					if (wrks[i].name) {
						worksheetName = wrks[i].name;
						break;
					}
				}
				$timeout(function () {
					vm.showAddToReportButton = true;
				}, 50);
			}
		}

		function onTabSwitch(marksEvent) {
			var wrks = viz.workbook.activeSheet.worksheets;
			//console.log(wrks);
			var worksheetName;
			var oldSheetName = marksEvent.detail.oldSheetName;
			//console.log('old', oldSheetName);
			var newSheetName = marksEvent.detail.newSheetName;
			//console.log(newSheetName);
			vm.lastSheetName = oldSheetName;
			if (true) {
				for (var i = 0; i < wrks.length; i++) {
					var name = wrks[i].name;
					if (name) {
						worksheetName = name;
						break;
					}
				}

				if (newSheetName == vm.viewDataDashboardName) {
					vm.hideAddToReport = true;
					worksheetName = getWorksheetName(oldSheetName, wrks);
					if (worksheetName) {
						vm.viewDataDashboard = worksheetName;
						//console.log(worksheetName);

						var activeFilterName = getActiveFilterName(oldSheetName);
						//console.log('active', activeFilterName);
						checkFilters(wrks, worksheetName, activeFilterName);
					} else {
						vm.viewDataDashboard = null;
					}
					setBackButtonVisibility(true);
				} else {
					viz.workbook.changeParameterValueAsync(measureNameParam, '0');
					setBackButtonVisibility(false);
				}

				/*viz.workbook
					.getParametersAsync()
					.then(function (parameters) {
						console.log(parameters);
					});
				_byName(viz.workbook.activeSheet.worksheets, worksheetName)
					.getFiltersAsync()
					.then(function (filter) {
						console.log(filter);
					});*/
			}
		}

		function getWorksheetName(oldSheet, wrks) {
			var sheet_name = null;
			var found;
			switch (oldSheet) {
				case vm.devIng:
					sheet_name = 'View data table Ingredient Loading';
					break;
				case vm.devWeek:
					sheet_name = 'View data table Ingredient Loading';
					break;
				case vm.loadSch:
					sheet_name = 'View data table Total Loading';
					break;
				case vm.dropp:
					sheet_name = 'View data table Drop Loading';
					break;
				case vm.ingTotalT:
					sheet_name = 'View data table Ingredient Loading';
					break;
				case vm.ingPP:
					sheet_name = 'View data table Ingredient Loading';
					break;
				case vm.totalCostsPerDayDashboardName:
					sheet_name = 'View data table Ingredient Loading/Cost';
					break;
				case vm.totalAmountLoadedPerDayDashboard:
					sheet_name = 'View data table Ingredient Loading/Cost';
					break;

				case vm.ingredientsDroppedOverTimePerPenDashboard:
					sheet_name = 'View data table Ingredient Loading';
					break;

				default:
					break;
			}

			for (var i = 0; i < wrks.length; i++) {
				var name = wrks[i].name;
				if (name == sheet_name) {
					found = true;
					break;
				}
			}
			return found ? sheet_name : null;
		}

		function checkFilters(wrks, sheet_name, filter_name) {
			_byName(wrks, sheet_name)
				.getFiltersAsync()
				.then(function (filters) {
					var l = filters.length;
					var actionFilterList = [];
					vm.actionFilterList = [];
					for (var i = 0; i < l; i++) {
						var name = filters[i].fieldName;
						if (name.indexOf('Action') != -1) {
							actionFilterList.push(name);
						}
					}
					if (actionFilterList.length > 0 && filter_name) {
						var listToClear = [];
						var l = actionFilterList.length;
						for (var i = 0; i < l; i++) {
							if (actionFilterList[i] != filter_name) {
								listToClear.push(actionFilterList[i]);
							} else {
								vm.actionFilterList.push(actionFilterList[i]);
							}
						}

						var ll = listToClear.length;
						if (ll > 0) {
							for (var i = 0; i < ll; i++) {
								resetFilter(listToClear[i], sheet_name);
							}
						}
						//console.log('clear', listToClear);
					} else {
						vm.actionFilterList = actionFilterList;
					}
					//console.log('action', vm.actionFilterList);
				});
		}

		function resetFilter(filter, sheet_name) {
			_byName(viz.workbook.activeSheet.worksheets, sheet_name).clearFilterAsync(filter);
		}

		function getActiveFilterName(dashboard) {
			var filter;
			var list = feedFilterPairs;
			var l = list.length;
			for (var i = 0; i < l; i++) {
				if (list[i].dashboard == dashboard && vm.currentLanguage == list[i].lng) {
					filter = list[i].filter;
					break;
				}
			}
			return filter;
		}

		function goBack() {
			if (vm.viewDataDashboard) {
				var l = vm.actionFilterList.length;
				if (l > 0) {
					resetFilterN(0);
				} else {
					viz.workbook.activateSheetAsync(vm.lastSheetName);
					setBackButtonVisibility(false);
					vm.hideAddToReport = false;
				}
			} else {
				viz.workbook.activateSheetAsync(vm.lastSheetName);
				setBackButtonVisibility(false);
				vm.hideAddToReport = false;
			}

			function resetFilterBack(filter) {
				var d = $q.defer();
				_byName(viz.workbook.activeSheet.worksheets, vm.viewDataDashboard)
					.clearFilterAsync(filter)
					.then(function (response) {
						d.resolve();
						vm.hideAddToReport = false;
					});

				return d.promise;
			}

			function resetFilterN(index) {
				return resetFilterBack(vm.actionFilterList[index]).then(function () {
					index++;
					if (index < l) {
						resetFilterN(index);
					} else {
						viz.workbook.activateSheetAsync(vm.lastSheetName);
						setBackButtonVisibility(false);
					}
				});
			}
		}

		function setBackButtonVisibility(display) {
			$timeout(function () {
				vm.showBackButton = display;
			}, 0);
		}

		function getHerdSuffix() {
			var suffix = '&HerdIdentifier=';

			suffix = suffix + vm.selectedHerd;
			return suffix;
		}

		function createHerdParam(herd) {
			var herdsString = '';
			if (herd) {
				herdsString = herd;
			}
			return herdsString;
		}

		function getLabelId(dashboard) {
			return 'label-' + dashboard.category.id;
		}

		function getDashboardClass(dashboard) {
			return dashboard.category.id;
		}

		function search() {
			if (searchTimer) {
				$timeout.cancel(searchTimer);
			}
			searchTimer = $timeout(function () {
				filterList();
			}, 750);
		}

		function filterList() {
			var list = [];
			if (vm.activeCategory != null) {
				angular.copy(vm.dashboardsFiltered, list);
			} else {
				angular.copy(vm.allDashboards, list);
			}
			list = filter(list, 'title', vm.searchDescriptionString);
			vm.dashboards = list;
			vm.dashboardsSafe = vm.dashboards;
		}

		function filter(list, property, filterString, subProperty) {
			var filteredList = [];
			for (var i = 0; i < list.length; i++) {
				if (subProperty) {
					var str = list[i][property][subProperty].toLowerCase();
				} else {
					var str = list[i][property].toLowerCase();
				}
				if (str.indexOf(filterString.toLowerCase()) != -1) {
					filteredList.push(list[i]);
				}
			}
			return filteredList;
		}

		function setButtonColor(button) {
			var btnClass = '';
			if (button.description.toLowerCase() == 'last week') {
				btnClass = 'btn-lw';
			} else if (button.description.toLowerCase() == 'last month') {
				btnClass = 'btn-lm';
			} else if (button.description.toLowerCase() == 'last quarter') {
				btnClass = 'btn-lq';
			} else if (button.description.toLowerCase() == 'last year') {
				btnClass = 'btn-ly';
			} else if (button.description.toLowerCase() == 'custom') {
				btnClass = 'btn-ly';
			} else if (button.description.toLowerCase() == '') {
				btnClass = 'btn-preview';
			}
			return btnClass;
		}

		function categorySelected(index, category) {
			if (vm.activeCategory == index) {
				vm.activeCategory = null;
				$rootScope.$broadcast('category_selected', null);
				$rootScope.$broadcast('set_category_background', null);
				filterList(vm.searchString);
			} else {
				vm.activeCategory = index;
				$rootScope.$broadcast('category_selected', category);
				$rootScope.$broadcast('set_category_background', index);
				vm.dashboardsFiltered = filterByCategory(category);
				filterList(vm.searchString);
			}
		}

		function filterByCategory(category) {
			var list = [];
			for (var i = 0; i < vm.allDashboards.length; i++) {
				if (vm.allDashboards[i].category.id == category.id) {
					list.push(vm.allDashboards[i]);
				}
			}
			return list;
		}

		function getBtnClass(category, index) {
			var cl = 'btn-' + category.id;
			if (index == vm.activeCategory) {
				cl = cl + ' ' + 'active-category';
			}
			return cl;
		}

		function getTableClass() {
			if (vm.activeCategory == 0) {
				return 'image-production';
			} else if (vm.activeCategory == 1) {
				return 'image-reproduction';
			} else if (vm.activeCategory == 2) {
				return 'image-udder_health';
			} else if (vm.activeCategory == 3) {
				return 'image-hoof_health';
			} else if (vm.activeCategory == 4) {
				return 'image-herd_characteristics';
			} else if (vm.activeCategory == 5) {
				return 'image-comments';
			} else if (vm.activeCategory == 6) {
				return 'image-herd_environmental';
			} else if (vm.activeCategory == 7) {
				return 'image-herd_genetics';
			} else {
				return '';
			}
		}

		function customTimeSelected() {
			if (vm.start_date && vm.end_date) {
				if (moment(vm.end_date).isBefore(moment().hour(0).minute(0).seconds(0).millisecond(0).add(1, 'days'))) {
					if (moment(vm.end_date).isAfter(moment(vm.start_date))) {
						closeModal();
						vm.selectedTime = 69;
						vm.showFrame = false;
						vm.loadingBaseTable = true;
						selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, false);
					} else {
						vm.timePickerError = true;
						removeError('timePickerError');
					}
				} else {
					vm.timePickerError = true;
					removeError('timePickerError');
				}
			} else {
				vm.timePickerError = true;
				removeError('timePickerError');
			}
		}

		function openAddToReportModal(dashboard) {
			vm.currentDashboard = dashboard.id;
			vm.addToReportModalLoading = true;
			vm.entryAlradyExist = false;
			vm.currentEntry = null;
			var date = new Date();
			getAddedToReport(false, date, false);
			openModal('app/pages/insights/addToReport.modal.html', 'sm');
		}

		function getAddedToReport(init, date, createReport) {
			vm.multipleReports = false;
			vm.errorLoadingReports = false;
			if (vm.selectedHerd) {
				var date = moment(vm.reportDate).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
				var suffix = '?HerdId=' + vm.selectedHerd;
				suffix = suffix + '&Date=' + date;
				return insightsFactory
					.getReports(suffix)
					.then(function (response) {
						var added = response[0];
						vm.availableReports = response;
						vm.selectedReport = response[0];
						if (response.length > 1) {
							vm.multipleReports = true;
						}
						if (createReport) {
							setReport(init, added);
						} else {
							setCurrentEntry(added);
						}
					})
					.catch(function (error) {
						vm.addToReportModalLoading = false;
						vm.errorLoadingReports = true;
						if (createReport) {
							setReport(init, null);
							addToReportPromise.resolve();
						}
					});
			} else {
				if (!createReport) {
					vm.addToReportModalLoading = false;
				}
			}
		}

		function setReport(init, added) {
			var lng = vm.currentLanguage;
			if (added && added.entries) {
				for (var i = 0; i < added.entries.length; i++) {
					if (added.entries[i].locale != lng) {
						added.entries[i].dashboardId = getCurrentLngId(added.entries[i].dashboardId, lng);
						//added.entries[i].filter = getCurrentLngFilter(added.entries[i].filter, added.entries[i].locale, added.entries[i].dashboardId);
					}
				}
				vm.addedToReport = added.entries;
			} else {
				vm.addedToReport = [];
			}
			if (!init) {
				vm.reportDashboards = checkForAddedToReport(vm.allReportDashboards, vm.addedToReport);
			}
			if (init) {
				addToReportPromise.resolve();
			} else {
				vm.reportLoading = false;
			}
		}

		function setCurrentEntry(added) {
			var lng = vm.currentLanguage;
			if (added && added.entries) {
				for (var i = 0; i < added.entries.length; i++) {
					if (added.entries[i].locale != lng) {
						added.entries[i].dashboardId = getCurrentLngId(added.entries[i].dashboardId, lng);
						//added.entries[i].filter = getCurrentLngFilter(added.entries[i].filter, added.entries[i].locale, added.entries[i].dashboardId);
						added.entries[i].locale = lng;
					}
				}
				vm.addedToReport = added.entries;
			} else {
				vm.addedToReport = [];
			}
			var entry;
			for (var i = 0; i < vm.addedToReport.length; i++) {
				if (vm.addedToReport[i].dashboardId == vm.currentDashboard) {
					entry = vm.addedToReport[i];
					break;
				}
			}
			if (entry) {
				vm.entryAlradyExist = true;
				vm.currentEntry = entry;
				vm.modalComment = angular.copy(vm.currentEntry.comment);
			} else {
				vm.modalComment = '';
			}
			vm.addToReportModalLoading = false;
		}

		function getCurrentLngFilter(filter, lng, dashboard_id) {
			var filterString = angular.copy(filter);
			//split filter by param
			var splitted = filterString.split('&');
			var parityFilterString;
			var vwpFilterString;
			var afiFilerString;
			var D50FilterString;
			var DYFilterString;
			var DXFilterString;

			for (var i = 0; i < splitted.length; i++) {
				if (splitted[i].indexOf('VWP=') != -1 || splitted[i].indexOf("Période d'attente volontaire (VWP)=") != -1 || splitted[i].indexOf('VWP (Vrijwillige wachtperiode)=') != -1) {
					vwpFilterString = splitted[i];
				}
				if (splitted[i].indexOf('Parity=') != -1 || splitted[i].indexOf('Pariteit=') != -1 || splitted[i].indexOf('Laktation=') != -1 || splitted[i].indexOf('Lactation=') != -1) {
					parityFilterString = splitted[i];
				}
				if (splitted[i].indexOf('AFI target=') != -1 || splitted[i].indexOf('AFI-Ziel=') != -1 || splitted[i].indexOf('Objectif AFI=') != -1 || splitted[i].indexOf('Doel eerste inseminatie=') != -1) {
					afiFilerString = splitted[i];
				}
				if (splitted[i].indexOf('D50=') != -1) {
					D50FilterString = splitted[i];
				}
				if (splitted[i].indexOf('DY=') != -1) {
					DYFilterString = splitted[i];
				}
				if (splitted[i].indexOf('DX=') != -1) {
					DXFilterString = splitted[i];
				}
			}
			var filtersLngList = APP_CONST.constants.filtersLngList;
			var parity;
			var vwp;
			var afiFilter;
			for (var i = 0; i < filtersLngList.length; i++) {
				if (filtersLngList[i].internal_id == 'parity' && filtersLngList[i].lng == lng) {
					parity = filtersLngList[i].name;
				}
				if (filtersLngList[i].internal_id == 'vwp' && filtersLngList[i].lng == lng) {
					vwp = filtersLngList[i].name;
				}
				if (filtersLngList[i].internal_id == 'afi' && filtersLngList[i].lng == lng) {
					afiFilter = filtersLngList[i].name;
				}
			}
			if (parity && parityFilterString) {
				parityFilterString = changeFilterNameLanguage(parityFilterString, parity, parityFilter);
			}
			if (vwp && vwpFilterString) {
				vwpFilterString = changeFilterNameLanguage(vwpFilterString, vwp, vwpFilterName);
			}
			if (afiFilter && afiFilerString) {
				afiFilerString = changeFilterNameLanguage(afiFilerString, afiFilter, afiFilterName);
			}

			filterString = '';
			if (parityFilterString) {
				filterString += '&' + parityFilterString;
			}
			if (vwpFilterString) {
				filterString += '&' + vwpFilterString;
			}
			if (afiFilerString) {
				filterString += '&' + afiFilerString;
			}
			if (D50FilterString) {
				filterString += '&' + D50FilterString;
			}
			if (DYFilterString) {
				filterString += '&' + DYFilterString;
			}
			if (DXFilterString) {
				filterString += '&' + DXFilterString;
			}
			return filterString;
		}

		function getCurrentLngId(id, lng) {
			var dashboardList = angular.copy(APP_CONST.constants.dashboardsDashboardIdLngList);
			//find internal id
			var internal_id;
			for (var i = 0; i < dashboardList.length; i++) {
				if (dashboardList[i].id == id) {
					internal_id = dashboardList[i].internal_id;
					break;
				}
			}
			var translated_id;
			//find language id for current language
			if (internal_id) {
				for (var i = 0; i < dashboardList.length; i++) {
					if (internal_id == dashboardList[i].internal_id && lng == dashboardList[i].lng) {
						translated_id = dashboardList[i].id;
						break;
					}
				}
			}
			if (translated_id) {
				id = translated_id;
			}
			return id;
		}

		function addToReport() {
			if (vm.selectedHerd) {
				vm.addToReportModalLoading = true;
				var filterList = getFilterListByDashboardId(vm.currentDashboard);
				var filter = '';

				var promiseList = [];
				var promiseNameList = [];

				for (var i = 0; i < filterList.parameters.length; i++) {
					var name = 'pr_p_' + filterList.parameters[i].name;
					vm[name] = $q.defer();
					promiseList.push(vm[name].promise);
					promiseNameList.push(name);
				}

				for (var i = 0; i < filterList.filters.length; i++) {
					var name = 'pr_f_' + filterList.filters[i].name;
					vm[name] = $q.defer();
					promiseList.push(vm[name].promise);
					promiseNameList.push(name);
				}

				$q.all(promiseList).then(function () {
					setEntry(filter);
				});

				promiseList = $timeout(function () {
					for (var i = 0; i < promiseNameList.length; i++) {
						vm[promiseNameList[i]].resolve();
					}
				}, 7000);
				if (viz) {
					try {
						if (filterList.parameters.length) {
							viz.workbook
								.getParametersAsync()
								.then(function (parameters) {
									for (var i = 0; i < parameters.length; i++) {
										for (var j = 0; j < filterList.parameters.length; j++) {
											if (parameters[i].name == filterList.parameters[j].name) {
												if (parameters[i].currentValue.value != filterList.parameters[j].default) {
													filter += '&' + filterList.parameters[j].name + '=' + parameters[i].currentValue.value;
												}
												var name = 'pr_p_' + filterList.parameters[j].name;
												vm[name].resolve();
											}
										}
									}
								});
						}

						if (filterList.filters.length) {
							_byName(viz.workbook.activeSheet.worksheets, filterList.filters[0].worksheetName)
								.getFiltersAsync()
								.then(function (filtersResponse) {
									if (
										filterList.filters[0].worksheetName == vm.deviationByIngredient ||
										filterList.filters[0].worksheetName == vm.ingredientsLoadedOverTimeTotal ||
										filterList.filters[0].worksheetName == vm.ingredientsLoadedOverTimePerPen ||
										filterList.filters[0].worksheetName == vm.ingredientsDroppedOverTimePerPen ||
										filterList.filters[0].worksheetName == vm.totalAmountLoadedPerDay ||
										filterList.filters[0].worksheetName == vm.totalCostsPerDay
									) {
										for (var i = 0; i < filtersResponse.length; i++) {
											var name = filtersResponse[i].fieldName;
											for (var j = 0; j < filterList.filters.length; j++) {
												if (name == filterList.filters[j].name) {
													if (name == 'RecipeName') {
														var filter_values = filtersResponse[i].appliedValues;
														var recipeFilter = getRecipeNameFilterSting(filter_values, name);
														var name = 'pr_f_' + filterList.filters[j].name;
														if (recipeFilter) {
															filter += recipeFilter;
														}
														vm[name].resolve();
													}

													if (name == 'Pen name') {
														var filter_values = filtersResponse[i].appliedValues;
														var penFilter = getPenNameFilterSting(filter_values, name);
														var name = 'pr_f_' + filterList.filters[j].name;
														if (penFilter) {
															filter += penFilter;
														}
														vm[name].resolve();
													}
												}
											}
										}
									}
								});
						}
					} catch (error) {
						console.log(error);
						for (var i = 0; i < promiseNameList.length; i++) {
							vm[promiseNameList[i]].resolve();
						}
					}
				} else {
					for (var i = 0; i < promiseNameList.length; i++) {
						vm[promiseNameList[i]].resolve();
					}
				}
			}
		}

		function getFilterListByDashboardId(dashboardId) {
			var obj = {
				parameters: [],
				filters: []
			};

			switch (dashboardId) {
				case i18nFilter('_dashboard_feed_id_deviation_ingredient_'):
					obj.filters = [
						{
							name: 'RecipeName',
							default: 69,
							id: 1,
							worksheetName: 'Deviation by ingredient'
						}
					];
					break;

				case vm.ingredientsLoadedOverTimeTotalId:
					obj.filters = [
						{
							name: 'RecipeName',
							default: 69,
							id: 2,
							worksheetName: 'Ingredients loaded over time total'
						}
					];

					obj.parameters = [
						{
							name: 'DateParam',
							default: 69,
							id: 9,
							worksheetName: 'Ingredients loaded over time total'
						}
					];
					break;

				case vm.ingredientsLoadedOverTimePerPenId:
					obj.filters = [
						{
							name: 'RecipeName',
							default: 69,
							id: 3,
							worksheetName: 'Ingredients loaded over time per pen'
						}
					];
					obj.parameters = [
						{
							name: 'DateParam',
							default: 69,
							id: 9,
							worksheetName: 'Ingredients loaded over time per pen'
						}
					];
					break;

				case vm.ingredientsDroppedOverTimePerPenId:
					obj.filters = [
						{
							name: 'RecipeName',
							default: 69,
							id: 4,
							worksheetName: 'Ingredients dropped over time per pen'
						}
					];

					obj.parameters = [
						{
							name: 'DateParam',
							default: 69,
							id: 9,
							worksheetName: 'Ingredients dropped over time per pen'
						}
					];
					break;

				case i18nFilter('_dashboard_feed_id_total_loaded_per_day_'):
					obj.filters = [
						{
							name: 'RecipeName',
							default: 69,
							id: 5,
							worksheetName: 'Total amount loaded per day'
						},
						{
							name: 'Pen name',
							default: 69,
							id: 6,
							worksheetName: 'Total amount loaded per day'
						}
					];
					break;

				case i18nFilter('_dashboard_feed_id_total_cost_per_day_'):
					obj.filters = [
						{
							name: 'RecipeName',
							default: 69,
							id: 7,
							worksheetName: 'Total costs per day'
						},
						{
							name: 'Pen name',
							default: 69,
							id: 8,
							worksheetName: 'Total costs per day'
						}
					];
					break;
				default:
					break;
			}

			return obj;
		}

		function getRecipeNameFilterSting(value, name) {
			var filter = '';
			if (value.length) {
				for (var i = 0; i < value.length; i++) {
					if (i == 0) {
						filter = filter + value[i].formattedValue;
					} else {
						filter = filter + ',' + value[i].formattedValue;
					}
				}
			}

			if (!filter.length) {
				filter = null;
			} else {
				filter = '&' + name + '=' + filter;
			}

			return filter;
		}

		function getPenNameFilterSting(value, name) {
			var filter = '';
			if (value.length) {
				for (var i = 0; i < value.length; i++) {
					if (i == 0) {
						filter = filter + value[i].formattedValue;
					} else {
						filter = filter + ',' + value[i].formattedValue;
					}
				}
			}

			if (!filter.length) {
				filter = null;
			} else {
				filter = '&' + name + '=' + filter;
			}

			return filter;
		}

		function setEntry(filterUrl) {
			var start_date = moment(vm.start_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';

			var end_date = moment(vm.end_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
			if (vm.currentEntry) {
				var obj = {
					id: vm.currentEntry.id,
					comment: vm.modalComment,
					endDate: end_date,
					startDate: start_date,
					locale: vm.currentEntry.locale,
					dashboardId: vm.currentEntry.dashboardId,
					filter: filterUrl
				};
				return insightsFactory
					.updateReportEntry(obj.id, obj)
					.then(function (response) {
						closeModal();
					})
					.catch(function (error) {
						console.log(error);
						vm.addToReportModalLoading = false;
					});
			} else {
				var lng = vm.currentLanguage;
				var date = moment().hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
				var obj = {
					date: date,
					herdId: vm.selectedHerd,
					comment: vm.modalComment,
					endDate: end_date,
					startDate: start_date,
					locale: lng,
					dashboardId: vm.currentDashboard,
					filter: filterUrl
				};
				return insightsFactory
					.addToReport(obj)
					.then(function (response) {
						closeModal();
					})
					.catch(function (error) {
						console.log(error);
						vm.addToReportModalLoading = false;
					});
			}
		}

		function removeError(key) {
			$timeout(function () {
				vm[key] = false;
			}, 3000);
		}

		function openModal(template, size) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function setCurrentLanguage(settings) {
			var lng;

			if (settings && settings.language) {
				switch (settings.language) {
					case 'en-gb':
						{
							lng = 'en-GB';
						}
						break;
					case 'en-us':
						{
							lng = 'en-US';
						}
						break;
					case 'nl-nl': {
						lng = 'nl-NL';
						break;
					}

					case 'de-de': {
						lng = 'de-DE';
						break;
					}

					default:
						{
							lng = 'en-GB';
						}
						break;
				}
			} else {
				lng = 'en-GB';
			}
			return lng;
		}

		function openCreateReport() {
			var parser = new UAParser();
			var os = parser.getOS();
			var brw = parser.getBrowser();
			vm.report_title = i18nFilter('_report_title_');
			if (os.name == 'iOS' && brw.name == 'Mobile Safari') {
				vm.safariMobileUsed = true;
			} else {
				vm.safariMobileUsed = false;
			}
			vm.reportDate = new Date();
			vm.showCreateReportBlock = true;
			vm.reportLoading = true;
			vm.pdfLoading = false;
			if (vm.selectedHerd) {
				herdsPromise = $q.defer();
				addToReportPromise = $q.defer();
				dashboardsPromise = $q.defer();
				$q.all([herdsPromise.promise, addToReportPromise.promise, dashboardsPromise.promise])
					.then(function () {
						vm.reportError = false;
						vm.reportDashboards = checkForAddedToReport(vm.allReportDashboards, vm.addedToReport);
						if (vm.reportDashboards.length) {
							vm.reportLoading = false;
							vm.herdNotSelected = false;
						} else {
							vm.showCreateReportBlock = false;
							vm.noAvailableDashboards = true;
							vm.reportLoading = false;
							vm.herdNotSelected = false;
						}
					})
					.catch(function (error) {
						bugsnagService.logUnhandledError(error);
						vm.reportLoading = false;
						vm.reportError = true;
						vm.pdfLoading = false;
					});
				getAddedToReport(true, vm.reportDate, true);
				var herd_id = vm.selectedHerd;
				checkHerds(herd_id);
				checkAllDashboards();
			} else {
				vm.reportLoading = false;
				$interval.cancel(laodingDotsInterval);
				vm.herdNotSelected = true;
			}
		}

		function checkHerds(herd_id) {
			return insightsFactory
				.getHerdsByTeam(vm.selectedTeam)
				.then(function (response) {
					vm.currentHerdName = getHerdNameById(herd_id, response);
					herdsPromise.resolve();
				})
				.catch(function (error) {
					herdsPromise.reject();
				});
		}

		function checkAllDashboards() {
			vm.allReportDashboards = getReportDashboards(vm.allDashboards);
			dashboardsPromise.resolve();
		}

		function getReportDashboards(dashboards) {
			var list = [];
			var listOfDashboardsIds = [];
			var currentLng = vm.currentLanguage;
			for (var i = 0; i < APP_CONST.constants.dashboardsDashboardIdLngList.length; i++) {
				if (APP_CONST.constants.dashboardsDashboardIdLngList[i].lng == currentLng) {
					listOfDashboardsIds.push(APP_CONST.constants.dashboardsDashboardIdLngList[i]);
				}
			}
			for (var i = 0; i < dashboards.length; i++) {
				if (dashboards[i].addToReport) {
					dashboards[i].start_date = vm.start_date;
					dashboards[i].end_date = vm.end_date;
					for (var j = 0; j < listOfDashboardsIds.length; j++) {
						if (listOfDashboardsIds[j].id == dashboards[i].id) {
							dashboards[i].index = listOfDashboardsIds[j].index;
							dashboards[i].size = listOfDashboardsIds[j].size;
						}
					}
					list.push(dashboards[i]);
				}
			}
			return list;
		}

		function getHerdNameById(herd_id, herds) {
			var herdName = '';
			for (var i = 0; i < herds.length; i++) {
				if (herds[i].Id == herd_id) {
					herdName = herds[i].Name;
					break;
				}
			}
			return herdName;
		}

		function checkForAddedToReport(dashboards, addedToReport) {
			var list = angular.copy(dashboards);
			for (var i = 0; i < list.length; i++) {
				for (var j = 0; j < addedToReport.length; j++) {
					if (list[i].id == addedToReport[j].dashboardId) {
						list[i].comment = addedToReport[j].comment;
						list[i].end_date = new Date(addedToReport[j].endDate);
						list[i].start_date = new Date(addedToReport[j].startDate);
						list[i].selected = true;
						list[i].filter = addedToReport[j].filter;
						list[i].entry_id = addedToReport[j].id;
						list[i].locale = vm.currentLanguage;
					}
				}
			}
			return list;
		}

		function setReportData() {
			vm.errorLoadingReports = false;
			var parser = new UAParser();
			var brw = parser.getBrowser();
			var os = parser.getOS();
			vm.reportLoading = true;
			vm.pdfLoading = true;
			loadingDotsCounter = 0;
			laodingDotsInterval = $interval(function () {
				if (loadingDotsCounter == 0) {
					vm.loadingDots = '.';
					loadingDotsCounter++;
				} else if (loadingDotsCounter == 1) {
					vm.loadingDots = '..';
					loadingDotsCounter++;
				} else if (loadingDotsCounter == 2) {
					vm.loadingDots = '...';
					loadingDotsCounter = 0;
				}
			}, 400);
			var list = [];
			for (var i = 0; i < vm.reportDashboards.length; i++) {
				if (vm.reportDashboards[i].selected) {
					list.push(vm.reportDashboards[i]);
				}
			}
			vm.orderedDashboards = $filter('orderBy')(list, 'index');
			var url_promise_list = [];
			for (var i = 0; i < vm.orderedDashboards.length; i++) {
				var name = 'pr' + i;
				vm[name] = $q.defer();
				url_promise_list.push(vm[name].promise);
				getImageUrl(vm.orderedDashboards[i].url, i, name);
			}

			function getImageUrl(url, index, name) {
				if (vm.work_locally) {
					var image_url = 'assets/img/thumbnails/loading_schedule_dashboard.png?4564545';
					vm.orderedDashboards[index].image_url = image_url;
					vm.orderedDashboards[index].image_loaded = true;
					vm[name].resolve();
				} else {
					return insightsFactory
						.setSession(url)
						.then(function (response) {
							var image_url = response.headers('tabvis-location');
							vm.orderedDashboards[index].image_url = image_url;
							vm.orderedDashboards[index].image_loaded = true;
							vm[name].resolve();
						})
						.catch(function (error) {
							vm[name].resolve();
						});
				}
			}
			$q.all(url_promise_list)
				.then(function () {
					setDataUrls(vm.orderedDashboards);
				})
				.catch(function (error) {
					vm.reportLoading = false;
					vm.reportError = true;
					vm.pdfLoading = false;
				});
		}

		function setDataUrls() {
			var image_url_promise_list = [];
			for (var i = 0; i < vm.orderedDashboards.length; i++) {
				if (vm.orderedDashboards[i].image_loaded) {
					var name = 'imgpr' + i;
					vm[name] = $q.defer();
					image_url_promise_list.push(vm[name].promise);
					var image_url = setImageUrl(vm.orderedDashboards[i]);
					getDataUrl(image_url, i, name);
				}
			}
			vm.logoMmmPrm = $q.defer();
			image_url_promise_list.push(vm.logoMmmPrm.promise);

			toDataURL(
				'assets/img/logo_mmm.png',
				function (dataUrl) {
					vm.logoMmm = dataUrl;
					vm.logoMmmPrm.resolve();
				},
				'logoMmmPrm'
			);
			$q.all(image_url_promise_list)
				.then(function () {
					var date = new Date();
					date = $filter('date')(date);
					var pdfData = {
						date: date,
						logoMmm: vm.logoMmm,
						user: vm.user.name,
						colour_1: '#E0E0E1',
						colour_2: '#1E4FDC',
						colour_text: '#666666',
						red: 'red',
						positive_points: vm.positivePoints ? vm.positivePoints : '',
						points_to_improve: vm.pointsToImprove ? vm.pointsToImprove : '',
						herd_name: vm.currentHerdName,
						dashboards: vm.orderedDashboards,
						title: vm.report_title
					};
					createPDF(pdfData);
				})
				.catch(function (error) {
					vm.reportLoading = false;
					vm.reportError = true;
					vm.pdfLoading = false;
				});
		}

		function getDataUrl(url, index, name) {
			toDataURL(
				url,
				function (dataUrl) {
					vm.orderedDashboards[index].image = dataUrl;
					vm[name].resolve();
				},
				name
			);
		}

		function toDataURL(url, callback, prm) {
			var xhr = new XMLHttpRequest();
			xhr.onload = function () {
				var reader = new FileReader();
				reader.onloadend = function () {
					callback(reader.result);
				};
				if (xhr.status == 200 || xhr.status == 204) {
					reader.readAsDataURL(xhr.response);
				} else {
					vm[prm].reject();
				}
			};
			xhr.open('GET', url);
			xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('id_token'));
			xhr.responseType = 'blob';
			xhr.withCredentials = true;
			xhr.send();
		}

		function setImageUrl(dashboard) {
			var image_url;
			var size = '1024,576';
			var splitted = dashboard.image_url.split('?');
			if (vm.work_locally) {
				image_url = splitted[0];
			} else {
				image_url = splitted[0] + '.png';
			}
			var start_date = moment(dashboard.start_date).format('YYYY-MM-DD');
			var end_date = moment(dashboard.end_date).format('YYYY-MM-DD');
			var herd = vm.selectedHerd;
			var suffix = '?Start%20Date=' + start_date + '&End%20Date=' + end_date + '&HerdIdentifier=' + herd + '&Herd%20Parameter=' + herd + '&:size=';
			if (dashboard.size) {
				suffix = suffix + dashboard.size;
			} else {
				suffix = suffix + size;
			}
			image_url = image_url + suffix;
			if (dashboard.filter) {
				image_url = image_url + dashboard.filter;
			}
			return image_url;
		}

		function closeCreateReport() {
			vm.showCreateReportBlock = false;
			vm.pointsToImprove = '';
			vm.positivePoints = '';
		}

		function setReportDate() {
			vm.reportDateOpened = false;
			if (vm.reportDate) {
				getAddedToReport(false, vm.reportDate, true);
			}
		}

		function openReportDashboardPeriodModal(index) {
			vm.report_modal_start_date = vm.reportDashboards[index].start_date;
			vm.report_modal_end_date = vm.reportDashboards[index].end_date;
			vm.selectedReportDashboardIndex = index;
			vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
			vm.setRangeModalLoading = false;
			openModal('app/pages/insights/reportRangeSelector.modal.html', 'sm');
		}

		function setReportDashboardRange() {
			var range_error = checkRangeError(vm.selectedReportDashboard.actual, vm.report_modal_start_date, vm.report_modal_end_date);
			if (!range_error) {
				vm.setRangeModalLoading = true;
				if (vm.selectedReportDashboard.entry_id) {
					var end_date = moment(vm.report_modal_end_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
					if (vm.selectedReportDashboard.actual) {
						var start_date = moment(vm.report_modal_end_date).subtract(7, 'days').hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
					} else {
						var start_date = moment(vm.report_modal_start_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
					}
					var obj = {
						id: vm.selectedReportDashboard.entry_id,
						comment: vm.selectedReportDashboard.comment,
						endDate: end_date,
						startDate: start_date,
						locale: vm.selectedReportDashboard.locale,
						dashboardId: vm.selectedReportDashboard.id,
						filter: vm.selectedReportDashboard.filter
					};
					return insightsFactory
						.updateReportEntry(obj.id, obj)
						.then(function (response) {
							vm.reportDashboards[vm.selectedReportDashboardIndex].end_date = vm.report_modal_end_date;
							if (vm.selectedReportDashboard.actual) {
								vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = new Date(moment(vm.report_modal_end_date).subtract(7, 'days'));
							} else {
								vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = vm.report_modal_start_date;
							}
							closeModal();
						})
						.catch(function (error) {
							console.log(error);
							vm.setRangeModalLoading = false;
						});
				} else {
					vm.reportDashboards[vm.selectedReportDashboardIndex].end_date = vm.report_modal_end_date;
					if (vm.selectedReportDashboard.actual) {
						vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = new Date(moment(vm.report_modal_end_date).subtract(7, 'days'));
					} else {
						vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = vm.report_modal_start_date;
					}
					closeModal();
				}
			}
		}

		function checkRangeError(actual_open, start_date, end_date) {
			var error = false;
			var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
			if (today.isBefore(end_date)) {
				error = true;
			}
			if (!actual_open) {
				if (moment(end_date).isBefore(start_date)) {
					error = true;
				}
			}
			return error;
		}

		function openReportCommentModal(index) {
			vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
			vm.selectedReportDashboardIndex = index;
			vm.addCommentModalLoading = false;
			openModal('app/pages/insights/reportComment.modal.html', 'sm');
		}

		function setReportDashboardComment() {
			vm.addCommentModalLoading = true;
			var end_date = moment(vm.selectedReportDashboard.end_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
			var start_date = moment(vm.selectedReportDashboard.start_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
			if (vm.selectedReportDashboard.entry_id) {
				var obj = {
					id: vm.selectedReportDashboard.entry_id,
					comment: vm.selectedReportDashboard.comment,
					endDate: end_date,
					startDate: start_date,
					locale: vm.selectedReportDashboard.locale,
					dashboardId: vm.selectedReportDashboard.id,
					filter: vm.selectedReportDashboard.filter
				};
				return insightsFactory
					.updateReportEntry(obj.id, obj)
					.then(function (response) {
						vm.reportDashboards[vm.selectedReportDashboardIndex].comment = vm.selectedReportDashboard.comment;
						closeModal();
					})
					.catch(function (error) {
						console.log(error);
						vm.addCommentModalLoading = false;
					});
			} else {
				vm.reportDashboards[vm.selectedReportDashboardIndex].comment = vm.selectedReportDashboard.comment;
				closeModal();
			}
		}

		function createPDF(pdfData) {
			var dd = {
				pageMargins: [20, 60, 20, 70],
				pageSize: 'A4',
				header: function (page) {
					if (page == 1)
						return {
							image: pdfData.logoMmm,
							width: 150,
							alignment: 'left',
							margin: [50, 30, 0, 20]
						};
					else
						return {
							margin: [30, 30, 0, 20],
							image: pdfData.logoMmm,
							width: 110,
							alignment: 'left'
						};
				},
				content: [
					{
						text: pdfData.title,
						alignment: 'left',
						fontSize: 23,
						bold: true,
						color: pdfData.colour_2,
						margin: [40, 80, 40, 25]
					},
					// {
					// 	text: 'dasda',
					// 	text: i18nFilter('_zts_report_text_'),
					// 	alignment: 'left',
					// 	fontSize: 12,
					// 	color: pdfData.colour_text,
					// 	margin: [40, 0, 40, 12],
					// },
					{
						text: i18nFilter('_title_herd_') + ': ' + pdfData.herd_name,
						alignment: 'left',
						fontSize: 12,
						bold: true,
						color: pdfData.colour_text,
						margin: [40, 7, 40, 0]
					},
					{
						text: i18nFilter('_report_date_') + ': ' + pdfData.date,
						alignment: 'left',
						fontSize: 12,
						bold: true,
						color: pdfData.colour_text,
						margin: [40, 7, 40, 0]
					},
					{
						text: i18nFilter('_report_vet_') + ': ' + pdfData.user,
						alignment: 'left',
						fontSize: 12,
						bold: true,
						color: pdfData.colour_text,
						margin: [40, 7, 40, 22]
					},
					{
						margin: [40, 0, 40, 25],
						table: {
							widths: [465],
							heights: ['auto', 150],
							body: [
								[
									{
										text: i18nFilter('_report_positive_points_') + ':',
										color: pdfData.colour_2,
										fontSize: 14,
										border: [true, true, true, false],
										bold: true
									}
								],
								[
									{
										text: pdfData.positive_points,
										color: pdfData.colour_text,
										fontSize: 12,
										border: [true, false, true, true],
										width: 465,
										height: 150
									}
								]
							]
						},
						layout: {
							hLineColor: pdfData.colour_1,
							vLineColor: pdfData.colour_1
						}
					},
					{
						pageBreak: 'after',
						margin: [40, 0, 40, 0],
						table: {
							widths: [465],
							heights: ['auto', 150],

							body: [
								[
									{
										text: i18nFilter('_report_points_to_improve_') + ':',
										color: pdfData.colour_2,
										fontSize: 14,
										border: [true, true, true, false],
										bold: true
									}
								],
								[
									{
										text: pdfData.points_to_improve,
										color: pdfData.colour_text,
										fontSize: 12,
										border: [true, false, true, true],
										height: 150,
										width: 465
									}
								]
							]
						},
						layout: {
							hLineColor: pdfData.colour_1,
							vLineColor: pdfData.colour_1
						}
					}
				]
			};
			var c = 0;
			var s = 0;
			for (var i = 0; i < pdfData.dashboards.length; i++) {
				var obj = {};
				var table = {
					margin: [10, 30, 10, 10],
					table: {
						dontBreakRows: true,
						widths: ['*'],

						body: [
							[
								{
									image: pdfData.dashboards[i].image,
									width: 500,
									border: [true, true, true, true]
								}
							],
							[
								{
									text: pdfData.dashboards[i].comment ? pdfData.dashboards[i].comment : '',
									fontSize: 10,
									border: [false, false, false, false],
									margin: [0, 5, 0, 10],
									color: pdfData.colour_text
								}
							]
						]
					},
					layout: {
						hLineColor: pdfData.colour_1,
						vLineColor: pdfData.colour_1
					}
				};
				if (pdfData.dashboards[i].selected && pdfData.dashboards[i].image_loaded) {
					c++;
					s++;
					if (c != 0 && c % 2 == 0) {
						table.pageBreak = 'after';
					}
					dd.content.push(table);
				}
			}

			if (dd.content[dd.content.length - 1].pageBreak) {
				delete dd.content[dd.content.length - 1].pageBreak;
			}

			var reportName = i18nFilter('_report_title_robot_analysis_') + ' ' + $filter('date')(new Date(), 'yyyy-MM-dd');
			var parser = new UAParser();
			var os = parser.getOS();
			var brw = parser.getBrowser();
			var device = parser.getDevice();

			var pdf = pdfMake.createPdf(dd);
			console.log(dd);
			if (device && device.type) {
				if (os.name == 'iOS') {
					if (brw.name == 'Mobile Safari') {
						pdf.open();
					} else {
						try {
							var reader = new FileReader();
							pdf.open();
							pdf.getBlob(function (blob) {
								reader.onload = function (e) {
									var uri = reader.result;
									var link = document.createElement('a');
									link.download = reportName + '.pdf';
									link.href = uri;
									document.body.appendChild(link);
									link.click();
									document.body.removeChild(link);
								};
								reader.readAsDataURL(blob);
							});
						} catch (error) {
							toastr.error(error);
							console.log(error);
							bugsnagService.logUnhandledError(error);
						}
					}
				} else {
					pdfMake.createPdf(dd).download(reportName);
				}
			} else {
				try {
					pdfMake.createPdf(dd).open();
				} catch (error) {
					console.log(error);
					bugsnagService.logUnhandledError(error);
					toastr.error(i18nFilter('_report_create_popup_message_'));
				}
			}
			vm.pointsToImprove = '';
			vm.positivePoints = '';
			$timeout(function () {
				vm.showCreateReportBlock = false;
				vm.reportLoading = false;
				vm.pdfLoading = false;
				$interval.cancel(laodingDotsInterval);
			}, 500);
		}

		function goBackOnClose() {
			setBackButtonVisibility(false);
			$rootScope.$broadcast('dashboard_deselect');
			if (vm.activeCategory) {
				vm.showFrame = false;
				vm.showBaseTable = true;
				vm.lastUsedDashboard = null;
				vm.lastUsedDashboardType = null;
				vm.embed = null;
			} else {
				vm.activeCategory = null;
				vm.activeCategoryName = null;
				goBackToDashboard();
			}
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		function broadcastDashboard(dashboard) {
			dashboard.selectedTime = vm.selectedTime;
			$rootScope.$broadcast('dashboard_selected', dashboard);
		}

		function setBackButtonVisibility(display) {
			$timeout(function () {
				vm.showBackButton = display;
			}, 0);
		}
		$scope.$on('default_team_selected', function (event, data) {
			$rootScope.$broadcast('dashboard_deselect');
			vm.dashboards = [];
			init();
		});
		$scope.$on('default_herd_selected', function (event, data) {
			vm.defaultValues = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedHerd = vm.defaultValues.selectedHerd.id;
			if (vm.showFrame && vm.lastUsedDashboard) {
				if (herdSelectedTimer) {
					$timeout.cancel(herdSelectedTimer);
				}
				vm.showFrame = false;
				vm.loadingBaseTable = true;
				herdSelectedTimer = $timeout(function () {
					selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, true);
				}, 1000);
			}
		});
		$scope.$on('dashboards_back', function () {
			if (vm.showFrame) {
				vm.activeCategory = null;
				vm.activeCategoryName = null;
				goBackToDashboard();
			} else if (vm.activeCategory) {
				vm.activeCategory = null;
				vm.activeCategoryName = null;
				goBackToDashboard();
			}
		});
		$scope.$on('category_back', function (event, data) {
			setBackButtonVisibility(false);
			vm.showFrame = false;
			vm.showBaseTable = true;
			vm.lastUsedDashboard = null;
			vm.lastUsedDashboardType = null;
			vm.embed = null;
			if (viz) {
				viz = null;
			}
		});
		$scope.$on('time_selector_changed', function (event, data) {
			timeSelectorChanged(data);
		});

		$scope.$on('$destroy', function () {
			$rootScope.$broadcast('dashboard_selected', null);
			$rootScope.$broadcast('category_selected', null);
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.insights').factory('insightsFactory', insightsFactory);
	/** @ngInject */
	function insightsFactory(APP_CONST, $http, $q) {
		return {
			getDashboards: getDashboards,
			getDashboardById: getDashboardById,
			getTableauDashboards: getTableauDashboards,
			setTableauTenant: setTableauTenant,
			getHerdsByTeam: getHerdsByTeam,
			getReports: getReports,
			addToReport: addToReport,
			updateReportEntry: updateReportEntry,
			setSession: setSession,
			loadedDashboards: {}
		};

		function getDashboards(team_id) {
			return $http
				.get(APP_CONST.tableau_base_url + team_id + '/dashboards', {
					withCredentials: true,
					timeout: 13000
				})
				.then(success)
				.catch(error);
		}

		function getDashboardById(team_id, dashboard_id, suffix) {
			return $http
				.get(APP_CONST.tableau_base_url + team_id + '/dashboards/' + dashboard_id + suffix, {
					withCredentials: true
				})
				.then(success)
				.catch(error);
		}

		function getTableauDashboards(team_id, suffix) {
			return $http
				.get(APP_CONST.tableau_base_url + team_id + '/dashboards' + suffix, {
					withCredentials: true,
					timeout: 13000
				})
				.then(success)
				.catch(error);
		}

		function setTableauTenant(team_id) {
			return $http
				.post(APP_CONST.tableau_base_url + team_id + '/session', {}, { withCredentials: true })
				.then(success)
				.catch(error);
		}

		function getHerdsByTeam(team_id) {
			return $http
				.get(APP_CONST.backoffice_base_url + 'teams/' + team_id + '/herds')
				.then(success)
				.catch(error);
		}

		function getReports(suffix) {
			return $http
				.get(APP_CONST.tableau_reports_base_url + suffix, {
					withCredentials: true
				})
				.then(success)
				.catch(error);
		}

		function updateReportEntry(id, obj) {
			return $http
				.put(APP_CONST.tableau_reports_base_url + '/reportentry/' + id, obj, {
					withCredentials: true
				})
				.then(success)
				.catch(error);
		}

		function addToReport(obj) {
			return $http
				.post(APP_CONST.tableau_reports_base_url + '/reportentry', obj, {
					withCredentials: true
				})
				.then(success)
				.catch(error);
		}

		function setSession(url) {
			return $http
				.get(url, {
					withCredentials: true
				})
				.then(function (response) {
					return response;
				})
				.catch(function (response) {
					return $q.reject(response);
				});
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rap').controller('rapCtrl', rapCtrl);
	/** @ngInject */
	function rapCtrl($timeout, $q, toastr, APP_CONST, $http, rapService, $filter, $rootScope, $uibModal, $uibModalStack, $scope, $interval, cookiesService, insightsFactory) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var fatParam = $filter('number')(4.3, 2);
		var proteinParam = $filter('number')(3.4, 2);
		var teamTimeout;
		var timeout;
		var mapTimeout;
		var reloadTimeout;
		var viz;

		// Lookup helper for v3 collections (worksheets/filters/parameters): returns
		// the first item whose name or fieldName matches, or null. Replaces the v2
		// `collection.get(name)` accessor that no longer exists in v3 (collections
		// are plain arrays).
		function _byName(list, name) {
			if (!list) { return null; }
			for (var i = 0; i < list.length; i += 1) {
				var item = list[i];
				if (item && (item.name === name || item.fieldName === name)) {
					return item;
				}
			}
			return null;
		}

		// Resolves to a scalar last-milk-date value extracted from a Tableau v3 filter,
		// or null if none can be derived. Handles range/quantitative filters (selected
		// max → domain max) and categorical filters (latest applied value → domain
		// fallback via getDomainAsync).
		function _getLastMilkDate(filter) {
			var d = $q.defer();
			if (!filter) { d.resolve(null); return d.promise; }
			var ft = filter.filterType;

			function resolveFromDomainAsync() {
				if (typeof filter.getDomainAsync === 'function') {
					filter.getDomainAsync().then(function (domain) {
						var dm = domain && domain.max;
						d.resolve(dm && dm.value ? dm.value : null);
					}, function () { d.resolve(null); });
				} else {
					d.resolve(null);
				}
			}

			if (ft === 'range' || ft === 'quantitative') {
				var max = filter.maxValue || filter.domainMax;
				if (max && max.value) {
					d.resolve(max.value);
					return d.promise;
				}
				resolveFromDomainAsync();
				return d.promise;
			}

			var values = filter.appliedValues || [];
			var latest = null;
			for (var i = 0; i < values.length; i += 1) {
				var v = values[i] && values[i].value;
				if (v && (!latest || moment(v).isAfter(moment(latest)))) {
					latest = v;
				}
			}
			if (latest) {
				d.resolve(latest);
				return d.promise;
			}
			resolveFromDomainAsync();
			return d.promise;
		}

		var workbook;
		var fatParamName;
		var proteinParamName;
		var tmrParamName;
		var dmParamName;
		var oldName;
		var newName;
		var parityFilter;
		var filterName;
		var milkYieldActual;
		var sppActual;
		var concentrateActualByYield;
		var concentrateActualByFeed;
		var herdPrestationsActual;
		var leftoversActual;
		var leftoversActualTable;
		var leftoversActualMilkSpeed;
		var milkingsActual;
		var milkMilkingsActual;
		var feedNameFilter;
		var concActualByMilk;
		var milkYieldActualByDate;
		var sppActualByDate;
		var milkingsActualByDate;
		var milkMilkingsActualByDate;
		var concentrateActualByYieldByDate;
		var concentrateActualByFeedByDate;
		var leftoversActualByDate;
		var resetAllParities;
		var groupByParam;
		var groupByMetric;
		var legend;
		var DIMCategoryFilterName;
		var dayFilterName;
		var robotPrestations;
		var robotPrestationsTrend;
		var refusals;
		var failures;
		var milkingTime;
		var milkingTimePercentage;
		var freeTime;
		var freeTimePercentage;
		var avgMilkingSpeed;
		var maxMilkingSpeed;
		var fatChanged;
		var TMRchanged;
		var TMR;
		var DryMatterChanged;
		var DryMatter;
		var proteinChanged;
		var herdsPromise;
		var dashboardsPromise;
		var addToReportPromise;
		var parityPromise;
		var groupByPromise;
		var groupByMetricPromise;
		var DIMPromise;
		var dayPromise;
		var feedNamePromise;
		var measureNamePromise;
		var loadingDotsCounter = 0;
		var laodingDotsInterval;
		var sheetNameList = APP_CONST.constants.sheetNamePairs;
		var actualDashboardName;
		var measureParameterName;
		var actualDashboardFilterPromise;
		var actualDashboardFilterName;
		vm.openRangeSelector = openRangeSelector;
		vm.closeModal = closeModal;
		vm.openAddToReportModal = openAddToReportModal;
		vm.addToReport = addToReport;
		vm.setRange = setRange;
		vm.openCreateReport = openCreateReport;
		vm.showStartEndDate = showStartEndDate;
		vm.closeCreateReport = closeCreateReport;
		vm.openReportDashboardPeriodModal = openReportDashboardPeriodModal;
		vm.openReportDashboardDayModal = openReportDashboardDayModal;
		vm.openReportCommentModal = openReportCommentModal;
		vm.setReportDashboardRange = setReportDashboardRange;
		vm.setReportDashboardComment = setReportDashboardComment;
		vm.setActualReportDate = setActualReportDate;
		vm.setReportData = setReportData;
		vm.init = init;
		vm.hideMissingDataMessage = hideMissingDataMessage;
		init();

		function init() {
			setStrings();
			setDates();
			setDashboardIdList();
			vm.showCreateReportButton = false;
			vm.disableRangeSelector = true;
			vm.actualDashboardOpen = false;
			vm.showCreateReportBlock = false;
			vm.reportError = false;
			vm.showActualCurrentDateMessage = false;
			vm.showMissingDataMessage = false;
			vm.showDPMessage = false;
			if (teamTimeout) {
				$timeout.cancel(teamTimeout);
			}
			vm.dashboards = [];
			vm.errorLoading = false;
			vm.loadingDashboards = true;
			vm.showButtons = false;
			vm.noAvailableDashboards = false;
			vm.reselectTeamError = false;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			setLanguage(vm.settings);
			vm.selectedTeam = vm.settings.selectedTeam.id;
			vm.selectedHerd = vm.settings.selectedHerd.id;
			vm.work_locally = false;
			if (vm.selectedTeam) {
				getDashboards(vm.selectedTeam);
			} else {
				teamTimeout = $timeout(function () {
					vm.settings = JSON.parse(localStorage.getItem('user_settings'));
					if (vm.selectedTeam) {
						getDashboards(vm.selectedTeam);
					} else {
						vm.embed = null;
						vm.loadingDashboards = false;
						vm.reselectTeamError = true;
					}
				}, 5000);
			}
		}

		function setStrings() {
			fatParamName = i18nFilter('_dashboard_filter_fat_');
			proteinParamName = i18nFilter('_dashboard_filter_protein_');
			tmrParamName = i18nFilter('_dashboard_filter_TMR_concentrate_');
			dmParamName = i18nFilter('_dashboard_filter_dry_matter_');
			oldName = i18nFilter('_dashboard_name_rap_main_herd_overview_');
			newName = i18nFilter('_dashboard_name_rap_herd_dashboard_');
			parityFilter = i18nFilter('_dashboard_name_filter_parity_');
			filterName = i18nFilter('_dashboard_name_filter_');
			milkYieldActual = i18nFilter('_dashboard_name_milk_yield_actual_');
			sppActual = i18nFilter('_dashboard_name_spp_actual_');
			concentrateActualByYield = i18nFilter('_dashboard_name_conc_actual_yield_');
			concentrateActualByFeed = i18nFilter('_dashboard_name_conc_actual_feed_');
			herdPrestationsActual = i18nFilter('_dashboard_name_herd_prestations_actual_');
			leftoversActual = i18nFilter('_dashboard_name_leftovers_actual_');
			leftoversActualTable = i18nFilter('_dashboard_name_leftovers_actual_table_');
			leftoversActualMilkSpeed = i18nFilter('_dashboard_name_leftovers_actual_milk_speed_');
			milkingsActual = i18nFilter('_dashboard_name_milkings_actual_');
			milkMilkingsActual = i18nFilter('_rap_workbook_name_milk_milkings_actual_');
			feedNameFilter = i18nFilter('_dashboard_name_filter_feed_name_');
			concActualByMilk = i18nFilter('_rap_workbook_name_concentrate_actual_by_milk_production_');
			milkYieldActualByDate = i18nFilter('_dashboard_name_milk_yield_actual_by_date_');
			sppActualByDate = i18nFilter('_dashboard_name_spp_actual_by_date_');
			milkingsActualByDate = i18nFilter('_dashboard_name_milkings_actual_by_date_');
			milkMilkingsActualByDate = i18nFilter('_rap_workbook_name_milk_milkings_actual_by_date_');
			concentrateActualByYieldByDate = i18nFilter('_dashboard_name_conc_actual_yield_by_date_');
			concentrateActualByFeedByDate = i18nFilter('_dashboard_name_conc_actual_feed_by_date_');
			leftoversActualByDate = i18nFilter('_dashboard_name_leftovers_actual_by_date_');
			resetAllParities = i18nFilter('_rap_reset_all_parities_');
			groupByParam = i18nFilter('_dashboard_name_parameter_group_by_');
			groupByMetric = i18nFilter('_dashboard_name_mark_group_by_metric_');
			legend = i18nFilter('_rap_workbook_name_legend_');
			DIMCategoryFilterName = i18nFilter('_dashboard_name_parameter_dim_category_');
			dayFilterName = i18nFilter('_dashboard_name_parameter_date_');
			robotPrestations = i18nFilter('_dashboard_name_robot_prestations_dashboard_');
			robotPrestationsTrend = i18nFilter('_dashboard_name_robot_prestations_trend_dashboard_');
			refusals = i18nFilter('_animal_details_refusal_');
			failures = i18nFilter('_animal_details_failures_');
			milkingTime = i18nFilter('_rap_milking_time_');
			milkingTimePercentage = i18nFilter('_rap_milking_time_percentage_');
			freeTime = i18nFilter('_rap_free_time_');
			freeTimePercentage = i18nFilter('_rap_free_time_percentage_');
			avgMilkingSpeed = i18nFilter('_rap_average_milking_speed_');
			maxMilkingSpeed = i18nFilter('_rap_max_milking_speed_');
			actualDashboardName = 'Actual dashboard';
			measureParameterName = 'Measure name parameter';
			actualDashboardFilterName = i18nFilter('_dashboard_actual_filter_name_');
		}

		function setDates() {
			vm.end_date = new Date(moment().hour(23).minute(59).seconds(59).millisecond(999).subtract(2, 'days'));
			vm.start_date = new Date(moment().hour(0).minute(0).seconds(1).millisecond(1).subtract(32, 'days').toISOString());
			vm.actual_start_date = new Date(moment().hour(0).minute(0).seconds(1).millisecond(1).subtract(9, 'days').toISOString());
			vm.init_start_date = new Date(moment().hour(0).minute(0).seconds(1).millisecond(1).subtract(32, 'days').toISOString());
		}

		function setLanguage(settings) {
			if (settings.language) {
				if (settings.language == 'en-gb') {
					vm.locale = 'en-GB';
				} else if (settings.language == 'en-us') {
					vm.locale = 'en-US';
				} else if (settings.language == 'cs-cz') {
					vm.locale = 'en-GB';
				} else if (settings.language == 'es-es') {
					vm.locale = 'en-GB';
				} else if (settings.language == 'nl-nl') {
					vm.locale = 'nl-NL';
				} else if (settings.language == 'it-it') {
					vm.locale = 'en-GB';
				} else if (settings.language == 'de-de') {
					vm.locale = 'de-DE';
				} else {
					vm.locale = 'en-GB';
				}
			} else {
				vm.locale = 'en-GB';
			}
		}

		function setDashboardIdList() {
			var dashboardIdList = angular.copy(APP_CONST.constants.dashboardIdList);
			for (var i = 0; i < dashboardIdList.length; i++) {
				dashboardIdList[i].name = i18nFilter(dashboardIdList[i].name);
				dashboardIdList[i].id = i18nFilter(dashboardIdList[i].id);
			}
			vm.dashboardIdList = dashboardIdList;
		}

		function getDashboards(team_id) {
			if (vm.work_locally) {
				var dashboards = [];
				var obj = {
					dashboards: dashboards,
					expires: moment().add(30, 'minutes').format(),
					team_id: team_id,
					lng: vm.locale
				};
				insightsFactory.loadedDashboards = obj;
				processDashboards(dashboards, team_id);
			} else {
				if (insightsFactory && insightsFactory.loadedDashboards.dashboards && insightsFactory.loadedDashboards.team_id == team_id && insightsFactory.loadedDashboards.lng == vm.locale) {
					if (moment(insightsFactory.loadedDashboards.expires).isBefore(moment())) {
						useAPI(team_id);
					} else {
						var dashboards = [];
						angular.copy(insightsFactory.loadedDashboards.dashboards, dashboards);
						processDashboards(dashboards, team_id);
					}
				} else {
					useAPI(team_id);
				}
			}
		}

		function useAPI(team_id) {
			timeout = $q.defer();
			var setSession = setSessionHandler(team_id);
			setSession.then(
				function (data) {
					var tableauSuffix = '?locale=' + vm.locale;
					return rapService
						.getDashboards(team_id, tableauSuffix)
						.then(function (response) {
							var obj = {
								dashboards: response,
								expires: moment().add(30, 'minutes').format(),
								team_id: team_id,
								lng: vm.locale
							};
							insightsFactory.loadedDashboards = obj;
							processDashboards(response, team_id);
						})
						.catch(function (error) {
							vm.loadingDashboards = false;
							vm.errorLoading = true;
						});
				},
				function (error) {
					console.log(error);
					if (!vm.teamReselected) {
						vm.loadingDashboards = false;
						vm.errorLoading = true;
					} else {
						vm.teamReselected = false;
					}
				}
			);
		}

		function processDashboards(response, team_id) {
			if (response.length > 0) {
				var dashboard;
				for (var i = 0; i < response.length; i++) {
					if (response[i].subcategory == 'rap-fame-v3' && (response[i].id == 'RAPHerddashboard' || response[i].id == 'RAPBedrijfsdashboard' || response[i].id == 'RAPHerdentabelle' || response[i].id == 'TableaudeborddutroupeauRAP')) {
						dashboard = response[i];
						break;
					}
				}
				vm.allDashboards = response;
				rapService.allDashboards = {
					team_id: team_id,
					dashboards: response
				};
				vm.mapActive = dashboard;
				if (dashboard) {
					embedPage(dashboard);
					mapTimeout = $timeout(function () {
						var containerDiv = document.getElementById('panel-map');
						var height;
						if (containerDiv) {
							height = containerDiv.offsetHeight;
						}
						if (height == 666) {
							try {
								var bodyHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
								var bodyWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
								if (bodyWidth > 767) {
									var newHeight = bodyHeight - 300;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 330;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('frame').style.height = newHeightFrame + 'px';
								} else {
									var newHeight = bodyHeight - 435;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 465;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('frame').style.height = newHeightFrame + 'px';
								}
							} catch (error) {
								console.log(error);
							}
						}
					}, 0);
				} else {
					vm.embed = null;
					vm.loadingDashboards = false;
					vm.noAvailableDashboards = true;
				}
			} else {
				vm.embed = null;
				vm.loadingDashboards = false;
				vm.noAvailableDashboards = true;
			}
		}

		function embedPage(dashboard) {
			if (vm.selectedHerd) {
				vm.disableRangeSelector = true;
				vm.showActualCurrentDateMessage = false;
				vm.currentSheetName = angular.copy(dashboard.description);
				vm.currentSheet = getDashboardIdByName(dashboard.description);
				vm.loadingDashboards = false;
				var url = dashboard.url;
				vm.workSheetName = dashboard.description;
				embed(url);
			}
		}

		function embed(url) {
			var deviceType;
			var parser = new UAParser();
			var device = parser.getDevice();
			if (device && device.type) {
				if (device.type == 'mobile') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else if (device.type == 'tablet') {
					deviceType = 'tablet';
				} else if (device.type == 'smarttv') {
					deviceType = 'desktop';
				} else if (device.type == 'wearable') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else {
					//deviceType = 'phone';
					deviceType = 'tablet';
				}
			} else {
				if (window.screen.height <= 900) {
					deviceType = 'tablet';
				} else {
					deviceType = 'desktop';
				}
			}
			if (viz) {
				window.TableauV3.disposeViz(viz);
			}

			if (vm.work_locally) {
				// var url = 'https://visual-prd-new.mmmooogle.com/t/Production/views/team-3091-production-rap-fame-v3_en-GB_twb/RAPHerddashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
				//var url = 'https://visual-prd-new.mmmooogle.com/t/Production/views/team-2756-production-rap-fame-v3_nl-NL_twb/RAPBedrijfsdashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
				var url = 'https://visual-prd-new.mmmooogle.com/t/Production/views/team-52-production-rap-fame-v3_en-GB_twb/RAPHerddashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
				//var url = 'https://visual-prd-new.mmmooogle.com/t/Production/views/team-52-production-rap-fame-v3_nl-NL_twb/RAPBedrijfsdashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';

				openDashboard(url, deviceType);
			} else {
				return rapService
					.setSession(url)
					.then(function (response) {
						vm.loadingDashboards = false;
						vm.showButtons = true;
						var url = response.headers('tabvis-location');
						openDashboard(url, deviceType);
					})
					.catch(function (response) {
						vm.disableRangeSelector = false;
						console.log('error getting tabvis-location header', response);
					});
			}
		}

		function openDashboard(url, deviceType) {
			if (url) {
				url = url + '&:render=true&:refresh=yes';
				var parameters = {
					'herd param': vm.selectedHerd,
					'Start Date': $filter('date')(vm.start_date, 'yyyy-MM-dd'),
					'End Date': $filter('date')(vm.end_date, 'yyyy-MM-dd')
				};

				if (vm.selectedHerd) {
					parameters.HerdIdentifier = vm.selectedHerd;
				}

				parameters[fatParamName] = 4.3;
				parameters[proteinParamName] = 3.4;
				parameters[tmrParamName] = 0;

				$timeout(function () {
					window.tableauV3Ready.then(function () {
						var containerDiv = document.getElementById('rapFrame');
						var listeners = {};
						listeners[window.TableauV3.EventType.FirstInteractive] = onRapFirstInteractive;
						listeners[window.TableauV3.EventType.TabSwitched] = onTabSwitch;
						listeners[window.TableauV3.EventType.ParameterChanged] = onParameterChange;
						listeners[window.TableauV3.EventType.MarkSelectionChanged] = onMarksSelection;
						viz = window.TableauV3.createViz(containerDiv, url, {
							device: deviceType,
							hideTabs: true,
							toolbar: 'hidden',
							parameters: parameters
						}, listeners);
					});
				}, 100);
			}

			function onRapFirstInteractive() {
				$timeout(function () {
					vm.disableRangeSelector = false;
					vm.disableAddToReport = false;
					vm.showMissingDataMessage = false;
				}, 100);
				workbook = viz.workbook;
				var wrks = workbook.activeSheet.worksheets;
				var worksheetName;
				for (var i = 0; i < wrks.length; i++) {
					if (wrks[i].name) {
						worksheetName = wrks[i].name;
						break;
					}
				}

				var plc;
				for (var i = 0; i < wrks.length; i++) {
					if (wrks[i].name == 'plc') {
						plc = true;
					}
				}
				var filterDIMParityName;
				if (vm.locale == 'de-DE') {
					filterDIMParityName = 'Action (TIM-Kategorie,Laktation) 1';
				} else if (vm.locale == 'fr-FR') {
					filterDIMParityName = 'Action (Catégorie de JEL,Lactation) 1';
				} else if (vm.locale == 'en-GB') {
					filterDIMParityName = 'Action (DIM Category,Parity) 1';
				} else if (vm.locale == 'en-US') {
					filterDIMParityName = 'Action (DIM Category,Parity) 1';
				} else if (vm.locale == 'nl-NL') {
					filterDIMParityName = 'Action (DIM Categorie,Pariteit) 1';
				} else if (vm.locale == 'de-DE') {
					filterDIMParityName = 'Action (TIM-Kategorie,Laktation) 1';
				}
				if (plc) {
					_byName(wrks, 'plc').applyFilterAsync(filterDIMParityName, [], window.TableauV3.FilterUpdateType.All);
				}

				vm.actualDashboardOpen = false;
				vm.showAddToReportButton = false;
				$timeout(function () {
					vm.showCreateReportButton = true;
				}, 200);
				_byName(viz.workbook.activeSheet.worksheets, worksheetName)
					.getFiltersAsync()
					.then(function (filters) {
						var lastMilkDayFilter = null;
						for (var i = 0; i < filters.length; i += 1) {
							var name = filters[i].fieldName;
							if (name && name.indexOf('(lastDate)') !== -1) {
								lastMilkDayFilter = filters[i];
								break;
							}
						}
						if (lastMilkDayFilter) {
							_getLastMilkDate(lastMilkDayFilter).then(function (last_date) {
								if (last_date) {
									checkLastMilkDate(last_date);
								}
							});
						}
					});
			}
		}

		function onTabSwitch(marksEvent) {
			vm.disableRangeSelector = false;
			var oldSheetName = marksEvent.detail.oldSheetName;
			var newSheetName = marksEvent.detail.newSheetName;
			if (true) {
				vm.showAddToReportButton = true;
				vm.showActualCurrentDateMessage = false;
				vm.disableAddToReport = false;
				vm.showMissingDataMessage = false;
				var wrks = viz.workbook.activeSheet.worksheets;
				var worksheetName;
				//get name of one of the worksheets
				var list = [];
				var sheetNameExists;
				var worksheetName = getSheetNameByTransitionName(newSheetName);
				for (var i = 0; i < wrks.length; i++) {
					if (wrks[i].name == worksheetName) {
						sheetNameExists = true;
						break;
					}
				}
				if (!sheetNameExists) {
					worksheetName = wrks[0].name;
				}
				var currentSheet = newSheetName;
				vm.currentSheetName = angular.copy(currentSheet);
				vm.currentSheet = getDashboardIdByName(currentSheet);
				/*_byName(viz.workbook.activeSheet.worksheets, worksheetName)
					.getFiltersAsync()
					.then(function (filter) {
						console.log(filter);
					});*/

				/*viz.workbook
					.getParametersAsync()
					.then(function (parameters) {
						console.log(parameters);
					});*/
				if (newSheetName == newName) {
					var filterDIMParityName;
					if (vm.locale == 'de-DE') {
						filterDIMParityName = 'Action (TIM-Kategorie,Laktation) 1';
					} else if (vm.locale == 'fr-FR') {
						filterDIMParityName = 'Action (Catégorie de JEL,Lactation) 1';
					} else if (vm.locale == 'en-GB') {
						filterDIMParityName = 'Action (DIM Category,Parity) 1';
					} else if (vm.locale == 'en-US') {
						filterDIMParityName = 'Action (DIM Category,Parity) 1';
					} else if (vm.locale == 'nl-NL') {
						filterDIMParityName = 'Action (DIM Categorie,Pariteit) 1';
					} else if (vm.locale == 'de-DE') {
						filterDIMParityName = 'Action (TIM-Kategorie,Laktation) 1';
					}
					var plc;
					for (var i = 0; i < wrks.length; i++) {
						if (wrks[i].name == 'plc') {
							plc = true;
						}
					}
					if (plc) {
						_byName(viz.workbook.activeSheet.worksheets, 'plc').applyFilterAsync(filterDIMParityName, [], window.TableauV3.FilterUpdateType.All);
					}

					vm.showCreateReportButton = true;
					$timeout(function () {
						vm.start_date = angular.copy(vm.init_start_date);
					});
					vm.actualDashboardOpen = false;
				} else if (
					newSheetName == milkYieldActual ||
					newSheetName == sppActual ||
					newSheetName == concentrateActualByYield ||
					newSheetName == concentrateActualByFeed ||
					newSheetName == milkingsActual ||
					newSheetName == herdPrestationsActual ||
					newSheetName == leftoversActual ||
					newSheetName == leftoversActualTable ||
					newSheetName == leftoversActualMilkSpeed ||
					newSheetName == milkingsActual ||
					newSheetName == milkMilkingsActual ||
					newSheetName == concActualByMilk
				) {
					vm.actualDashboardOpen = true;
					vm.showCreateReportButton = false;
					$timeout(function () {
						vm.start_date = angular.copy(vm.actual_start_date);
					}, 0);
				} else if (
					newSheetName == milkYieldActualByDate ||
					newSheetName == sppActualByDate ||
					newSheetName == milkingsActualByDate ||
					newSheetName == milkMilkingsActualByDate ||
					newSheetName == concentrateActualByYieldByDate ||
					newSheetName == concentrateActualByFeedByDate ||
					newSheetName == leftoversActualByDate
				) {
					vm.showCreateReportButton = false;
					$timeout(function () {
						vm.disableRangeSelector = true;
					}, 50);
					_byName(viz.workbook.activeSheet.worksheets, worksheetName)
						.getFiltersAsync()
						.then(function (filter) {
							var dateFilter;
							if (vm.locale == 'de-DE') {
								dateFilter = 'DAY(Datum)';
							} else if (vm.locale == 'fr-FR') {
								dateFilter = 'DAY(Date)';
							} else if (vm.locale == 'en-GB') {
								dateFilter = 'DAY(Date)';
							} else if (vm.locale == 'en-US') {
								dateFilter = 'DAY(Date)';
							} else if (vm.locale == 'nl-NL') {
								dateFilter = 'DAY(Datum)';
							} else if (vm.locale == 'de-DE') {
								dateFilter = 'DAY(Datum)';
							}
							for (var i = 0; i < filter.length; i++) {
								var name = filter[i].fieldName;
								var lastMilkDayFilter;
								if (name && name.indexOf(dateFilter) != -1) {
									lastMilkDayFilter = name;
									break;
								}
							}

							if (lastMilkDayFilter) {
								var filter_values = _byName(filter, lastMilkDayFilter);
								if (filter_values) {
									var day = filter_values.appliedValues;
									if (day.length == 1) {
										day = day[0].value;
										vm.actualFilterValue = {
											type: 1,
											day: new Date(day),
											dim: null,
											parity: null
										};
										showActualDateMessage();
									}
								}
							}
						});
				} else if (newSheetName == 'Feed Intake' || newSheetName == 'Alimentation' || newSheetName == 'Futteraufnahme' || newSheetName == 'Voeropname') {
					_byName(viz.workbook.activeSheet.worksheets, worksheetName).clearFilterAsync(feedNameFilter);
					vm.showCreateReportButton = false;
					$timeout(function () {
						vm.start_date = angular.copy(vm.init_start_date);
					});
					vm.actualDashboardOpen = false;
				} else if (newSheetName == robotPrestations || newSheetName == robotPrestationsTrend) {
					vm.showCreateReportButton = false;
					$timeout(function () {
						vm.start_date = angular.copy(vm.init_start_date);
					});
					vm.actualDashboardOpen = false;

					if (newSheetName == robotPrestations) {
						checkMissingDataMessage(1);
					} else {
						checkMissingDataMessage(2);
					}
				} else if (newSheetName == actualDashboardName) {
					vm.actualFilterValue = {
						type: 2,
						day: null,
						dim: vm.lastSummaryDataTableMarks && vm.lastSummaryDataTableMarks.dimCategory ? vm.lastSummaryDataTableMarks.dimCategory : '',
						parity: vm.lastSummaryDataTableMarks && vm.lastSummaryDataTableMarks.parity ? vm.lastSummaryDataTableMarks.parity : ''
					};
					showActualDateMessage();
				} else {
					vm.showCreateReportButton = false;
					$timeout(function () {
						vm.start_date = angular.copy(vm.init_start_date);
					});
					vm.actualDashboardOpen = false;
				}
			}
		}

		function checkMissingDataMessage(dashboard) {
			// 1 - robot prestations
			// 2 - robot prestations trend

			if (vm.selectedHerds && vm.selectedHerds.length == 1) {
				var herd = vm.selectedHerds[0];
				if (herd == 750 || herd == 794 || herd == 795) {
					var found = false;
					var cookie = $cookies.getObject(vm.user.email);
					var value = vm.selectedHerds[0] + '/' + dashboard;
					if (cookie && cookie.DNSAL && cookie.DNSAL.length > 0) {
						for (var i = 0; i < cookie.DNSAL.length; i++) {
							if (cookie.DNSAL[i] == value) {
								found = true;
								break;
							}
						}
					}
					vm.doNotShowAgain = false;
					vm.missingDataMessageDashboard = dashboard;
					vm.missingDataColumns = [];
					var list;
					if (herd == 750) {
						if (dashboard == 1) {
							list = [refusals];
						} else if (dashboard == 2) {
							found = true;
						}
					} else if (herd == 794) {
						if (dashboard == 1) {
							list = [milkingTime, milkingTimePercentage, freeTime, freeTimePercentage, avgMilkingSpeed, maxMilkingSpeed, refusals, failures];
						} else if (dashboard == 2) {
							list = [freeTime];
						}
					} else if (herd == 795) {
						if (dashboard == 1) {
							list = [milkingTime, milkingTimePercentage, freeTime, freeTimePercentage, avgMilkingSpeed, maxMilkingSpeed, refusals, failures];
						} else if (dashboard == 2) {
							list = [freeTime];
						}
					}
					vm.missingDataColumns = angular.copy(list);
					$timeout(function () {
						if (!found) {
							vm.showMissingDataMessage = true;
						}
					}, 10);
				}
			}
		}

		function hideMissingDataMessage() {
			vm.showMissingDataMessage = false;
			if (vm.doNotShowAgain) {
				var cookie = $cookies.getObject(vm.user.email);
				var value = vm.selectedHerds[0] + '/' + vm.missingDataMessageDashboard;
				if (cookie && cookie.DNSAL && cookie.DNSAL.length > 0) {
					cookie.DNSAL.push(value);
				} else {
					cookie.DNSAL = [value];
				}

				var expireDate = new Date();
				expireDate.setDate(expireDate.getDate() + 365);
				cookiesService.setCookie(vm.user.email, JSON.stringify(cookie), {
					samesite: 'strict',
					expires: expireDate
				});
			}
		}

		function onParameterChange(event) {
			event.detail.getParameterAsync().then(function (parameter) {
				if (event.detail.parameterName == fatParamName) {
					fatChanged = true;
				} else if (event.detail.parameterName == proteinParamName) {
					proteinChanged = true;
				} else if (event.detail.parameterName == tmrParamName) {
					TMR = parameter.currentValue.value;
					TMRchanged = true;
				} else if (event.detail.parameterName == dmParamName) {
					DryMatterChanged = true;
					DryMatter = parameter.currentValue.value;
				}
			});
		}
		function onMarksSelection(event) {
			if (event && event.detail && typeof event.detail.getMarksAsync === 'function') {
				event.detail.getMarksAsync().then(function (marks) {
					if (marks && marks.data && marks.data.length) {
						var dataTable = marks.data[0];
						if (dataTable && dataTable.name === 'Summary Data Table') {
							vm.lastSummaryDataTableMarks = getSummaryDataTableMarks(dataTable);
						}
					}
				});
			}

			var ws = event && event.detail && event.detail.worksheet;
			var wsName = ws && ws.name;
			if (wsName === resetAllParities) {
				$timeout(function () {
					vm.showActualCurrentDateMessage = false;
				}, 0);
			}
		}

		function getSummaryDataTableMarks(dataTable) {
			var summary = {};
			if (!dataTable) { return summary; }
			var columns = dataTable.columns || [];
			var rows = dataTable.data || [];
			var firstRow = rows[0];
			if (!firstRow || !columns.length || columns.length !== firstRow.length) {
				return summary;
			}
			for (var i = 0; i < columns.length; i += 1) {
				var fieldName = columns[i].fieldName;
				if (fieldName === 'DIM Category') {
					summary.dimCategory = firstRow[i] && firstRow[i].formattedValue;
				} else if (fieldName === 'Parity') {
					summary.parity = firstRow[i] && firstRow[i].formattedValue;
				}
			}
			return summary;
		}

		function showActualDateMessage() {
			$timeout(function () {
				vm.showActualCurrentDateMessage = true;
			}, 100);
		}

		function checkLastMilkDate(last_milk_date) {
			var lmd = moment(last_milk_date).hour(23).minute(59).seconds(59).millisecond(999);
			var end_date = moment().year(vm.end_date.getFullYear()).month(vm.end_date.getMonth()).date(vm.end_date.getDate()).hour(23).minute(59).seconds(59).millisecond(999);
			if (moment(lmd).isBefore(end_date)) {
				$timeout(function () {
					vm.showDPMessage = true;
				}, 200);
				vm.end_date = new Date(lmd);
				vm.actual_start_date = new Date(moment(lmd).subtract(7, 'days'));
				vm.init_start_date = new Date(moment(lmd).subtract(30, 'days'));
				if (vm.actualDashboardOpen) {
					vm.start_date = angular.copy(vm.actual_start_date);
				}
				var dates = {
					start_date: vm.start_date,
					end_date: vm.end_date
				};
				cookiesService.setCookie('rap_actual_dates', JSON.stringify(dates), {
					samesite: 'lax',
					domain: '.mmmooogle.com'
				});
			}
		}

		function getSheetNameByTransitionName(currentName) {
			var sheetName;
			for (var i = 0; i < sheetNameList.length; i++) {
				if (sheetNameList[i].sheet_name_transition == currentName) {
					sheetName = sheetNameList[i].sheet_name;
					break;
				}
			}
			return sheetName;
		}

		function getDashboardIdByName(name) {
			var found;
			var id;
			for (var i = 0; i < vm.dashboardIdList.length; i++) {
				if (name == vm.dashboardIdList[i].name) {
					found = true;
					id = vm.dashboardIdList[i].id;
					break;
				}
			}
			if (found) {
				return id;
			} else {
				return null;
			}
		}

		function clearfilters(worksheet_name) {
			if (vm.herdIdentifierFilterUsed) {
				_byName(viz.workbook.activeSheet.worksheets, worksheet_name).clearFilterAsync('HerdIdentifier');
				vm.herdIdentifierFilterUsed = false;
			}

			viz.workbook.changeParameterValueAsync('herd param', 0);
			_byName(viz.workbook.activeSheet.worksheets, worksheet_name).applyFilterAsync(parityFilter, [], window.TableauV3.FilterUpdateType.All);
			vm.selectedHerd = null;
			$rootScope.$broadcast('deselect_all_herds');
			checkStartEndDate();
		}

		function checkStartEndDate() {
			var c_start_date = angular.copy(vm.init_start_date);
			var c_end_date = angular.copy(vm.end_date);
			var start_changed;
			var end_changed;
			setDates();
			if (!moment(c_start_date).isSame(vm.start_date)) {
				start_changed = true;
			}
			if (!moment(c_end_date).isSame(vm.end_date)) {
				end_changed = true;
			}
			if (start_changed && end_changed) {
				viz.workbook
					.changeParameterValueAsync('Start Date', vm.start_date)
					.then(function (param) {
						viz.workbook
							.changeParameterValueAsync('End Date', vm.end_date)
							.then(function (param) {
								checkParameters();
							});
					});
			} else if (start_changed && !end_changed) {
				viz.workbook
					.changeParameterValueAsync('Start Date', vm.start_date)
					.then(function (param) {
						checkParameters();
					});
			} else if (!start_changed && end_changed) {
				viz.workbook
					.changeParameterValueAsync('End Date', vm.end_date)
					.then(function (param) {
						checkParameters();
					});
			} else {
				checkParameters();
			}
		}

		function checkParameters() {
			var changeFat = false;
			var changeProtein = false;
			var changeTMR = false;
			viz.workbook
				.getParametersAsync()
				.then(function (parameters) {
					for (var i = 0; i < parameters.length; i++) {
						if (parameters[i].name == fatParamName) {
							if (parameters[i].currentValue.formattedValue != fatParam) {
								changeFat = true;
							}
						}
						if (parameters[i].name == proteinParamName) {
							if (parameters[i].currentValue.formattedValue != proteinParam) {
								changeProtein = true;
							}
						}
						if (parameters[i].name == tmrParamName) {
							if (parameters[i].currentValue.formattedValue != 0) {
								changeTMR = true;
							}
						}
					}
					checkFatParameter(changeFat, changeProtein, changeTMR);
				});
		}

		function checkFatParameter(changeFat, changeProtein, changeTMR) {
			if (changeFat) {
				viz.workbook
					.changeParameterValueAsync(fatParamName, fatParam)
					.then(function (parameter) {
						fatChanged = false;
						checkProteinParameter(changeProtein, changeTMR);
					});
			} else {
				checkProteinParameter(changeProtein, changeTMR);
			}
		}

		function checkProteinParameter(changeProtein, changeTMR) {
			if (changeProtein) {
				viz.workbook
					.changeParameterValueAsync(proteinParamName, proteinParam)
					.then(function (parameter) {
						proteinChanged = false;
						checkTMRParameter(changeTMR);
					});
			} else {
				checkTMRParameter(changeTMR);
			}
		}
		function checkTMRParameter(changeTMR) {
			if (changeTMR) {
				viz.workbook
					.changeParameterValueAsync(tmrParamName, 0)
					.then(function (parameter) {
						TMRchanged = false;
						checkDMParameter();
					});
			} else {
				checkDMParameter();
			}
		}

		function openRangeSelector() {
			if (!vm.disableRangeSelector) {
				vm.modal_start_date = angular.copy(vm.start_date);
				vm.modal_end_date = angular.copy(vm.end_date);
				openModal('app/pages/rap/rangeSelector.modal.html', 'sm');
			}
		}

		function openReportDashboardPeriodModal(index) {
			vm.report_modal_start_date = vm.reportDashboards[index].start_date;
			vm.report_modal_end_date = vm.reportDashboards[index].end_date;
			vm.selectedReportDashboardIndex = index;
			vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
			vm.setRangeModalLoading = false;
			openModal('app/pages/rap/reportRangeSelector.modal.html', 'sm');
		}

		function openReportDashboardDayModal(index) {
			vm.setDateModalLoading = false;
			vm.report_modal_date = angular.copy(vm.reportDashboards[index].report_date);
			vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
			vm.selectedReportDashboardIndex = index;
			openModal('app/pages/rap/daySelector.modal.html', 'sm');
		}

		function openReportCommentModal(index) {
			vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
			vm.selectedReportDashboardIndex = index;
			vm.addCommentModalLoading = false;
			openModal('app/pages/rap/reportComment.modal.html', 'sm');
		}

		function checkDMParameter() {
			if (DryMatterChanged) {
				viz.workbook
					.changeParameterValueAsync(dmParamName, 0)
					.then(function (parameter) {
						DryMatterChanged = false;
					});
			}
		}

		function setRange() {
			var start_date_changed = false;
			var end_date_changed = false;
			if (!moment(vm.start_date).isSame(vm.modal_start_date)) {
				start_date_changed = true;
			}
			if (!moment(vm.end_date).isSame(vm.modal_end_date)) {
				end_date_changed = true;
			}
			var range_error = checkRangeError(vm.actualDashboardOpen, vm.modal_start_date, vm.modal_end_date);
			if (!range_error) {
				vm.start_date = angular.copy(vm.modal_start_date);
				vm.end_date = angular.copy(vm.modal_end_date);
				if (vm.actualDashboardOpen) {
					vm.actual_start_date = new Date(moment(vm.end_date).subtract(7, 'days').toISOString());
					vm.start_date = angular.copy(vm.actual_start_date);
					vm.init_start_date = new Date(moment(vm.end_date).subtract(30, 'days').hour(0).minute(0).seconds(1).millisecond(1).toISOString());
					start_date_changed = true;
					var dates = {
						start_date: vm.start_date,
						end_date: vm.end_date
					};
					cookiesService.setCookie('rap_actual_dates', JSON.stringify(dates), {
						samesite: 'lax',
						domain: '.mmmooogle.com'
					});
				} else {
					vm.init_start_date = angular.copy(vm.start_date);
					vm.actual_start_date = new Date(moment(vm.end_date).subtract(7, 'days').hour(0).minute(0).seconds(1).millisecond(1).toISOString());
				}
				if (vm.mapActive) {
					applyParameters(start_date_changed, end_date_changed);
					vm.showActualCurrentDateMessage = false;
				}
				closeModal();
			}
		}

		function checkRangeError(actual_open, start_date, end_date) {
			var error = false;
			var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
			if (today.isBefore(end_date)) {
				error = true;
			}
			if (!actual_open) {
				if (moment(end_date).isBefore(start_date)) {
					error = true;
				}
			}
			return error;
		}

		function applyParameters(start_date_changed, end_date_changed) {
			var start_date;
			var end_date = vm.end_date;
			if (vm.actualDashboardOpen) {
				start_date = vm.init_start_date;
			} else {
				start_date = vm.start_date;
			}
			if (viz) {
				if (start_date_changed && end_date_changed) {
					viz.workbook
						.changeParameterValueAsync('Start Date', start_date)
						.then(function (param) {
							viz.workbook
								.changeParameterValueAsync('End Date', end_date)
								.then(function (param) {
									getLastMilkDate();
								});
						});
				} else if (start_date_changed && !end_date_changed) {
					viz.workbook
						.changeParameterValueAsync('Start Date', start_date)
						.then(function (param) {
							getLastMilkDate();
						});
				} else if (!start_date_changed && end_date_changed) {
					viz.workbook
						.changeParameterValueAsync('End Date', end_date)
						.then(function (param) {
							getLastMilkDate();
						});
				}
			}
		}

		function getLastMilkDate() {
			var worksheetName = getSheetNameByTransitionName(vm.currentSheetName);
			if (worksheetName) {
				_byName(viz.workbook.activeSheet.worksheets, worksheetName)
					.getFiltersAsync()
					.then(function (filters) {
						var lastMilkDayFilter = null;
						for (var i = 0; i < filters.length; i += 1) {
							var name = filters[i].fieldName;
							if (name && name.indexOf('(lastDate)') !== -1) {
								lastMilkDayFilter = filters[i];
								break;
							}
						}
						if (lastMilkDayFilter) {
							_getLastMilkDate(lastMilkDayFilter).then(function (last_date) {
								if (last_date) {
									checkLastMilkDate(last_date);
								}
							});
						}
					});
			}
		}

		function openModal(template, size) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		function openAddToReportModal() {
			vm.addToReportModalLoading = true;
			vm.entryAlradyExist = false;
			vm.currentEntry = null;
			var date = new Date();
			getAddedToReport(false, date, false);
			openModal('app/pages/rap/addToReport.modal.html', 'sm');
		}

		function getAddedToReport(init, date, createReport) {
			vm.multipleReports = false;
			if (vm.selectedHerd && vm.selectedTeam) {
				var date = moment(vm.reportDate).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
				var suffix = '?HerdId=' + vm.selectedHerd;
				suffix = suffix + '&Date=' + date;

				if (vm.work_locally) {
					var response = [];
					handleReports(init, createReport, response);
				} else {
					return rapService
						.getReports(suffix)
						.then(function (response) {
							handleReports(init, createReport, response);
						})
						.catch(function (error) {
							vm.addToReportModalLoading = false;
							if (createReport) {
								addToReportPromise.reject();
							}
						});
				}
			} else {
				if (createReport) {
				} else {
					vm.addToReportModalLoading = false;
				}
			}
		}

		function handleReports(init, createReport, response) {
			var added = response[0];
			added = handleActualDashboards(added);
			vm.addedToReport = added;
			if (response.length > 1) {
				vm.multipleReports = true;
			}
			if (createReport) {
				setReport(init, added);
			} else {
				setCurrentEntry(added);
			}
		}

		function handleActualDashboards(reports) {
			if (reports) {
				for (var i = 0; i < reports.entries.length; i++) {
					var id = reports.entries[i].dashboardId;
					if (id && id.indexOf('Actualdashboard|') != -1) {
						reports.entries[i].actualDashboard = true;
						var splitted = reports.entries[i].dashboardId.split('|');
						reports.entries[i].dashboardId = splitted[0].trim();
						reports.entries[i].filter += '&' + measureParameterName + '=' + splitted[1].trim();
						reports.entries[i].mnp = splitted[1].trim();
					}
				}
			}

			return reports;
		}

		function setReport(init, added) {
			var lng = vm.locale;
			if (added && added.entries) {
				for (var i = 0; i < added.entries.length; i++) {
					if (
						added.entries[i].locale != lng ||
						added.entries[i].dashboardId == 'Herdprestationsactual' ||
						added.entries[i].dashboardId == 'Prestationsrellespourletroupeau' ||
						added.entries[i].dashboardId == 'tatschlicheHerdenvorhersage' ||
						added.entries[i].dashboardId == 'Kuddeprestatiesactueel'
					) {
						added.entries[i].dashboardId = getCurrentLngId(added.entries[i].dashboardId, lng);
						added.entries[i].filter = getCurrentLngFilter(added.entries[i].filter, added.entries[i].locale, added.entries[i].dashboardId);
						if (added.entries[i].dashboardId == 'Actualdashboard') {
							added.entries[i] = setCurrentLngActualDashboard(added.entries[i]);
						}
					}
				}
				vm.addedToReport = added.entries;
			} else {
				vm.addedToReport = [];
			}
			if (!init) {
				vm.reportDashboards = checkForAddedToReport(vm.allReportDashboards, vm.addedToReport);
			}
			if (addToReportPromise) {
				addToReportPromise.resolve();
			} else {
				vm.reportLoading = false;
			}
		}

		function checkForAddedToReport(dashboards, addedToReport) {
			var list = angular.copy(dashboards);
			var hasActual = false;
			var actualIndex;
			var actualList = [];
			for (var i = 0; i < list.length; i++) {
				if (list[i].id != 'Actualdashboard') {
					for (var j = 0; j < addedToReport.length; j++) {
						if (list[i].id == addedToReport[j].dashboardId) {
							list[i].comment = addedToReport[j].comment;
							list[i].end_date = new Date(addedToReport[j].endDate);
							list[i].start_date = new Date(addedToReport[j].startDate);
							list[i].selected = true;
							list[i].entry_id = addedToReport[j].id;
							list[i].filter = addedToReport[j].filter;
							list[i].report_date = isActualByDate(list[i]) ? setActualDate(list[i].filter) : undefined;
						}
					}
				} else {
					actualIndex = i;
					for (var j = 0; j < addedToReport.length; j++) {
						if (addedToReport[j].dashboardId == 'Actualdashboard') {
							hasActual = true;
							var obj = angular.copy(addedToReport[j]);
							obj.id = addedToReport[j].dashboardId;
							obj.comment = addedToReport[j].comment;
							obj.description = decodeURIComponent(addedToReport[j].mnp);
							obj.end_date = new Date(addedToReport[j].endDate);
							obj.start_date = new Date(addedToReport[j].startDate);
							obj.selected = true;
							obj.entry_id = addedToReport[j].id;
							obj.filter = addedToReport[j].filter;
							obj.report_date = isActualByDate(list[i]) ? setActualDate(list[i].filter) : undefined;
							obj.url = list[i].url;

							actualList.push(obj);
						}
					}
				}
			}
			if (actualIndex) {
				list.splice(actualIndex, 1);
			}
			if (hasActual) {
				list = list.concat(actualList);
			}
			return list;
		}

		function setActualDate(filter) {
			var splitted = filter.split('&');
			var dateFilterStr;
			for (var i = 0; i < splitted.length; i++) {
				if (splitted[i].indexOf(dayFilterName) != -1) {
					dateFilterStr = splitted[i].trim();
				}
			}
			var date;
			if (dateFilterStr) {
				var splitedDate = dateFilterStr.split('=');
				date = new Date(splitedDate[1]);
			} else {
				date = vm.end_date;
			}
			return date;
		}

		function setActualByDate(dashboards) {
			var list = angular.copy(dashboards);
			var l = list.length;
			for (var i = 0; i < l; i++) {
				if (isActualByDate(list[i])) {
					if (!list[i].filter) {
						list[i].filter = '&' + dayFilterName + '=' + moment(list[i].report_date).format('YYYY-MM-DD');
					}
				}
			}
			return list;
		}

		function isActualByDate(obj) {
			var isActual = false;
			if (obj.index == 943 || obj.index == 944 || obj.index == 945 || obj.index == 946 || obj.index == 947 || obj.index == 948 || obj.index == 949) {
				isActual = true;
			}
			return isActual;
		}

		function showStartEndDate(dashboard) {
			var show = true;
			if (isActualByDate(dashboard)) {
				show = false;
			}
			return show;
		}

		function getCurrentLngFilter(filter, lng, dashboard_id) {
			var filterString = angular.copy(filter);
			//split filter by param
			var splitted = filterString.split('&');
			var parityFilterString;
			var groupByParameterString;
			var groupByMetricString;
			var feedNameFilterString;
			var DIMCatrgoryFilterString;
			var dateFilterString;
			for (var i = 0; i < splitted.length; i++) {
				if ((splitted[i] && splitted[i].indexOf('Group by=') != -1) || splitted[i].indexOf('Groupé par=') != -1 || splitted[i].indexOf('Gruppiere nach=') != -1 || splitted[i].indexOf('Groepeer op=') != -1) {
					groupByParameterString = splitted[i].trim();
				}
				if ((splitted[i] && splitted[i].indexOf('Parity=') != -1) || splitted[i].indexOf('Pariteit=') != -1 || splitted[i].indexOf('Laktation=') != -1 || splitted[i].indexOf('Lactation=') != -1) {
					parityFilterString = splitted[i].trim();
				}
				if ((splitted[i] && splitted[i].indexOf('Nach Metrik gruppieren=') != -1) || splitted[i].indexOf('Groepeer op kengetal=') != -1 || splitted[i].indexOf('Grouper par métrique=') != -1 || splitted[i].indexOf('Group by metric=') != -1) {
					groupByMetricString = splitted[i].trim();
				}
				if ((splitted[i] && splitted[i].indexOf('Feed name=') != -1) || splitted[i].indexOf('Name des Futters=') != -1 || splitted[i].indexOf("Nom de l'aliment=") != -1 || splitted[i].indexOf('Voer naam=') != -1) {
					feedNameFilterString = splitted[i].trim();
				}
				if ((splitted[i] && splitted[i].indexOf('TIM-Kategorie=') != -1) || splitted[i].indexOf('DIM Category=') != -1 || splitted[i].indexOf('Catégorie de JEL=') != -1 || splitted[i].indexOf('DIM Categorie=') != -1) {
					DIMCatrgoryFilterString = splitted[i].trim();
				}
				if ((splitted[i] && splitted[i].indexOf('Datum=') != -1) || splitted[i].indexOf('Date=') != -1) {
					dateFilterString = splitted[i].trim();
				}
			}
			var filtersLngList = APP_CONST.constants.filtersLngList;
			var parity;
			var groupBy;
			var groupByValue;
			var groupByValueTranslateString;
			var groupByMetricValue;
			var DIMCategoryValue;
			var feedName;
			var dateValue;
			for (var i = 0; i < filtersLngList.length; i++) {
				if (filtersLngList[i].internal_id == 'parity' && filtersLngList[i].lng == lng) {
					parity = filtersLngList[i].name;
				}
				if (filtersLngList[i].internal_id == 'group_by' && filtersLngList[i].lng == lng) {
					groupBy = filtersLngList[i].name;
				}
				if (filtersLngList[i].internal_id == 'group_by_value' && filtersLngList[i].lng == lng) {
					if (groupByParameterString && groupByParameterString.indexOf(filtersLngList[i].name) != -1) {
						groupByValue = filtersLngList[i].name;
						groupByValueTranslateString = filtersLngList[i].translate_string;
					}
				}
				if (filtersLngList[i].internal_id == 'feed_name' && filtersLngList[i].lng == lng) {
					feedName = filtersLngList[i].name;
				}
				if (filtersLngList[i].internal_id == 'group_by_metric' && filtersLngList[i].lng == lng) {
					groupByMetricValue = filtersLngList[i].name;
				}
				if (filtersLngList[i].internal_id == 'dim_category' && filtersLngList[i].lng == lng) {
					DIMCategoryValue = filtersLngList[i].name;
				}
				if (filtersLngList[i].internal_id == 'date' && filtersLngList[i].lng == lng) {
					dateValue = filtersLngList[i].name;
				}
			}
			if (parity && parityFilterString) {
				parityFilterString = changeFilterNameLanguage(parityFilterString, parity, parityFilter);
			}
			if (groupBy && groupByParameterString) {
				groupByParameterString = changeFilterNameLanguage(groupByParameterString, groupBy, groupByParam);
			}
			if (groupByParameterString && groupByValue && groupByValueTranslateString) {
				groupByParameterString = changeFilterNameLanguage(groupByParameterString, groupByValue, i18nFilter(groupByValueTranslateString));
			}
			if (groupByMetricValue && groupByMetricString) {
				groupByMetricString = changeFilterNameLanguage(groupByMetricString, groupByMetricValue, groupByMetric);
			}
			if (feedName && feedNameFilterString) {
				feedNameFilterString = changeFilterNameLanguage(feedNameFilterString, feedName, feedNameFilter);
			}
			filterString = '';
			if (parityFilterString) {
				if (dashboard_id != 'Herdprestationsactual' && dashboard_id != 'Prestationsrellespourletroupeau' && dashboard_id != 'tatschlicheHerdenvorhersage' && dashboard_id != 'Kuddeprestatiesactueel') {
					filterString += '&' + parityFilterString;
				}
			}
			if (DIMCategoryValue && DIMCatrgoryFilterString) {
				DIMCatrgoryFilterString = changeFilterNameLanguage(DIMCatrgoryFilterString, DIMCategoryValue, DIMCategoryFilterName);
			}
			if (dateValue && dateFilterString) {
				dateFilterString = changeFilterNameLanguage(dateFilterString, dateValue, dayFilterName);
			}

			if (groupByParameterString) {
				filterString += '&' + groupByParameterString;
			}
			if (groupByMetricString) {
				filterString += '&' + groupByMetricString;
			}
			if (feedNameFilterString) {
				filterString += '&' + feedNameFilterString;
			}
			if (DIMCatrgoryFilterString) {
				filterString += '&' + DIMCatrgoryFilterString;
			}
			if (dateFilterString) {
				filterString += '&' + dateFilterString;
			}
			return filterString;
		}

		function setCurrentLngActualDashboard(entry) {
			if (entry.mnp && (entry.mnp == 'Milkings%20' || entry.mnp == 'Melkingen' || entry.mnp == 'Melkvorg%C3%A4nge')) {
				entry.mnp = i18nFilter('_dashboard_actual_filter_value_milkings_');
			}

			if (entry.mnp && (entry.mnp == 'Animals' || entry.mnp == 'Tiere' || entry.mnp == 'Animaux' || entry.mnp == 'Dieren')) {
				entry.mnp = i18nFilter('_dashboard_actual_filter_value_animals_hpa_');
			}

			if (entry.mnp && (entry.mnp == 'Milk%20yield%20%28kg%29' || entry.mnp == 'Melk%20productie%20%28kg%29' || entry.mnp == 'Milchleistung%20%28kg%29' || entry.mnp == 'Rendement%20en%20lait%20%28kg%29')) {
				entry.mnp = i18nFilter('_dashboard_actual_filter_value_milk_yield_');
			}

			if (entry.mnp && (entry.mnp == 'SPP' || entry.mnp == 'BSK')) {
				entry.mnp = i18nFilter('_dashboard_actual_filter_value_spp_num_');
			}

			if (entry.mnp && (entry.mnp == 'M%2FMilking' || entry.mnp == 'Melk%2FMelking' || entry.mnp == 'M%2FMelkung')) {
				entry.mnp = i18nFilter('_dashboard_actual_filter_value_m_milking_');
			}

			if (entry.mnp && (entry.mnp == 'Speed' || entry.mnp == 'Melksnelheid' || entry.mnp == 'Geschwindigkeit' || entry.mnp == 'Vitesse%20de%20traite')) {
				entry.mnp = i18nFilter('_dashboard_actual_filter_value_speed_');
			}

			if (entry.mnp && (entry.mnp == 'Refusals' || entry.mnp == 'Weigeringen' || entry.mnp == 'Veweigerungen' || entry.mnp == 'Refus')) {
				entry.mnp = i18nFilter('_dashboard_actual_filter_value_refusals_');
			}

			if (entry.mnp && (entry.mnp == 'Failures' || entry.mnp == 'Mislukkingen' || entry.mnp == 'Ausf%C3%A4lle' || entry.mnp == '%C3%89checs')) {
				entry.mnp = i18nFilter('_dashboard_actual_filter_value_failures_');
			}

			if (entry.mnp && (entry.mnp == '%25Leftover' || entry.mnp == 'Restvoer%20kg' || entry.mnp == '%25%20Reste' || entry.mnp == '%25%20de%20reste')) {
				entry.mnp = i18nFilter('_dashboard_actual_filter_value_leftovers_');
			}

			if (entry.mnp && (entry.mnp == 'Concentrate%20Intake%20%28kg%2F100kg%29' || entry.mnp == 'Krachtvoergift%20%28kg%2F100kg%29' || entry.mnp == 'Kraftfutteraufnahme%20%28kg%2F100%20kg%29' || entry.mnp == 'Consommation%20de%20concentr%C3%A9s%20%28kg%2F100kg%29')) {
				entry.mnp = i18nFilter('_dashboard_actual_filter_value_c_intake_kg_100_');
			}

			if (entry.mnp && (entry.mnp == 'Concentrate%20intake%20%28kg%29' || entry.mnp == 'Krachtvoergift%20%28kg%29' || entry.mnp == 'Kraftfutteraufnahme%20%28kg%29' || entry.mnp == 'Consommation%20de%20concentr%C3%A9s%20%28kg%29')) {
				entry.mnp = i18nFilter('_dashboard_actual_filter_value_c_intake_kg_');
			}
			if (entry.mnp) {
				entry.filter += '&' + measureParameterName + '=' + entry.mnp;
			}
			return entry;
		}

		function changeFilterNameLanguage(filter, old_name, new_name) {
			var str = angular.copy(filter);
			return str.replace(old_name, new_name);
		}

		function setCurrentEntry(added) {
			var lng = vm.locale;
			if (added && added.entries) {
				for (var i = 0; i < added.entries.length; i++) {
					if (
						added.entries[i].locale != lng ||
						added.entries[i].dashboardId == 'Herdprestationsactual' ||
						added.entries[i].dashboardId == 'Prestationsrellespourletroupeau' ||
						added.entries[i].dashboardId == 'tatschlicheHerdenvorhersage' ||
						added.entries[i].dashboardId == 'Kuddeprestatiesactueel'
					) {
						added.entries[i].dashboardId = getCurrentLngId(added.entries[i].dashboardId, lng);
						added.entries[i].filter = getCurrentLngFilter(added.entries[i].filter, added.entries[i].locale, added.entries[i].dashboardId);
						if (added.entries[i].dashboardId == 'Actualdashboard') {
							added.entries[i] = setCurrentLngActualDashboard(added.entries[i]);
						}
						added.entries[i].locale = lng;
					}
				}
				vm.addedToReport = added.entries;
			} else {
				vm.addedToReport = [];
			}
			var entry;
			if (vm.currentSheet == 'Actualdashboard') {
				viz.workbook
					.getParametersAsync()
					.then(function (parameters) {
						var measureName;
						for (var i = 0; i < parameters.length; i++) {
							if (parameters[i].name == measureParameterName) {
								measureName = encode(parameters[i].currentValue.formattedValue);
								break;
							}
						}

						for (var i = 0; i < vm.addedToReport.length; i++) {
							if (vm.addedToReport[i].dashboardId == vm.currentSheet && vm.addedToReport[i].mnp == measureName) {
								entry = vm.addedToReport[i];
								break;
							}
						}
						handleEntry(entry);
					});
			} else {
				for (var i = 0; i < vm.addedToReport.length; i++) {
					if (vm.addedToReport[i].dashboardId == vm.currentSheet) {
						entry = vm.addedToReport[i];
						break;
					}
				}
				handleEntry(entry);
			}
		}

		function handleEntry(entry) {
			if (entry) {
				vm.entryAlradyExist = true;
				vm.currentEntry = entry;
				vm.modalComment = angular.copy(vm.currentEntry.comment);
			} else {
				vm.modalComment = '';
			}
			$timeout(function () {
				vm.addToReportModalLoading = false;
			}, 10);
		}

		function getCurrentLngId(id, lng) {
			var dashboardList = angular.copy(APP_CONST.constants.dashboardIdLngList);
			//find internal id
			var internal_id;
			for (var i = 0; i < dashboardList.length; i++) {
				if (dashboardList[i].id == id) {
					internal_id = dashboardList[i].internal_id;
					break;
				}
			}
			var translated_id;
			//find language id for current language
			if (internal_id) {
				for (var i = 0; i < dashboardList.length; i++) {
					if (internal_id == dashboardList[i].internal_id && lng == dashboardList[i].lng) {
						translated_id = dashboardList[i].id;
						break;
					}
				}
			}
			if (translated_id) {
				id = translated_id;
			}
			return id;
		}

		function addToReport() {
			vm.addToReportModalLoading = true;
			var filter = '';
			var parityFilterUrl = '';
			var groupByFilterUrl = '';
			var groupByMetricMarkUrl = '';
			var feedNameFilterUrl = '';
			var DIMFilterUrl = '';
			var dayFilterUrl = '';
			var measureName = '';
			var actualDashboardFilter = '';
			parityPromise = $q.defer();
			groupByPromise = $q.defer();
			groupByMetricPromise = $q.defer();
			feedNamePromise = $q.defer();
			DIMPromise = $q.defer();
			dayPromise = $q.defer();
			measureNamePromise = $q.defer();
			actualDashboardFilterPromise = $q.defer();
			var parityPromiseResolved = false;
			var groupByPromiseResolved = false;
			var groupByMetricPromiseResolved = false;
			var feedNamePromiseResolved = false;
			var dimPromiseResolved = false;
			var dayPromiseResolved = false;
			var measureNameResolved = false;
			var actualDashboardFilterResolved = false;
			var promiseTimeout;
			var isActualDashboard;

			promiseTimeout = $timeout(function () {
				if (!parityPromiseResolved) {
					parityPromise.resolve();
				}
				if (!groupByPromiseResolved) {
					groupByPromise.resolve();
				}
				if (!groupByMetricPromiseResolved) {
					groupByMetricPromise.resolve();
				}
				if (!feedNamePromiseResolved) {
					feedNamePromise.resolve();
				}
				if (!dimPromiseResolved) {
					DIMPromise.resolve();
				}
				if (!dayPromiseResolved) {
					dayPromise.resolve();
				}
				if (!measureNameResolved) {
					measureNamePromise.resolve();
				}
				if (!actualDashboardFilterResolved) {
					actualDashboardFilterPromise.resolve();
				}
			}, 7000);
			$q.all([parityPromise.promise, groupByPromise.promise, groupByMetricPromise.promise, feedNamePromise.promise, DIMPromise.promise, dayPromise, measureNamePromise.promise, actualDashboardFilterPromise.promise]).then(function () {
				if (promiseTimeout) {
					$timeout.cancel(promiseTimeout);
				}
				if (parityFilterUrl) {
					filter += parityFilterUrl;
				}
				if (groupByFilterUrl) {
					filter += groupByFilterUrl;
				}
				if (groupByMetricMarkUrl) {
					filter += groupByMetricMarkUrl;
				}
				if (feedNameFilterUrl) {
					filter += feedNameFilterUrl;
				}
				if (DIMFilterUrl) {
					filter += DIMFilterUrl;
				}
				if (dayFilterUrl) {
					filter += dayFilterUrl;
				}
				if (actualDashboardFilter) {
					filter += actualDashboardFilter;
				}
				setEntry(filter, measureName);
			});
			try {
				var worksheetName = getSheetNameByTransitionName(vm.currentSheetName);
				var sheetNameExists;
				var wrks = viz.workbook.activeSheet.worksheets;
				var feedOverTimeExist = false;
				var isFeedIntake;
				var actualDashboard;
				var actualByDateDashboard;
				for (var i = 0; i < wrks.length; i++) {
					if (wrks[i].name == worksheetName) {
						sheetNameExists = true;
						break;
					}
				}

				if (
					worksheetName == 'Milk yield (kg/cow) by DIM by Date' ||
					worksheetName == 'Melkproductie (kg/koe) volgens DIL volgens datum' ||
					worksheetName == 'Production de lait (kg/vache) par JEL par date' ||
					worksheetName == 'Concentrate intake (kg/100) by milk yield by Date' ||
					worksheetName == 'Milchproduktion (kg/Kuh) durch TIM nach datum' ||
					worksheetName == 'BSK (kg/cow) by DIM by Date' ||
					worksheetName == 'BSK (kg/koe) volgens DIL volgens datum' ||
					worksheetName == 'SPP (kg/vache) par JEL par date' ||
					worksheetName == 'BSK (kg/Kuh) durch TIM nach datum' ||
					worksheetName == 'Milkings by DIM by Date' ||
					worksheetName == 'Melkingen volgens DIL volgens datum' ||
					worksheetName == 'Traites par JEL par date' ||
					worksheetName == 'Melkungen durch TIM nach datum' ||
					worksheetName == 'Milk/Milkings in DIM by Date' ||
					worksheetName == 'Melk/melking in DIL volgens datum' ||
					worksheetName == 'Lait/traite s en fonction du JEL par date' ||
					worksheetName == 'Milch/Melkung durch TIM nach datum' ||
					worksheetName == 'Krachtvoer opname (kg/100kg) volgens melkproductie volgens datum' ||
					worksheetName == 'Consommation de concentré (kg/100kg) en fonction de production en fonction par date' ||
					worksheetName == 'Kraftfutteraufnahme (kg/100kg) durch Leistung nach datum' ||
					worksheetName == 'Concentrate intake (kg/cow) by DIM by Date' ||
					worksheetName == 'Krachtvoer opname (kg/koe) volgens DIL volgens datum' ||
					worksheetName == 'Consommation de concentré (kg/vache) par JEL par date' ||
					worksheetName == 'Kraftfutteraufnahme (kg/Kuh) durch TIM nach datum' ||
					worksheetName == 'Leftover by DIM by Date' ||
					worksheetName == 'Restvoer volgens DIL volgens datum' ||
					worksheetName == 'Restes par JEL par date' ||
					worksheetName == 'Reste durch TIM nach datum'
				) {
					actualByDateDashboard = true;
				}

				if (
					worksheetName == 'Milk yield (kg/cow) by DIM' ||
					worksheetName == 'Production laitière (kg/vache) en fonction du stade de lactation' ||
					worksheetName == 'Milchleistung (kg/Kuh) nach tim' ||
					worksheetName == 'Melkproductie (kg/koe) volgens DIL' ||
					worksheetName == 'BSK (kg/cow) by DIM' ||
					worksheetName == 'BSK (kg/vache) par DIM' ||
					worksheetName == 'BSK (kg/Kuh) nach tim' ||
					worksheetName == 'BSK (kg/koe) volgens DIL' ||
					worksheetName == 'Milkings by DIM' ||
					worksheetName == 'Traites en fonction du stade de lactation' ||
					worksheetName == 'Melkungen nach tim' ||
					worksheetName == 'Melkingen volgens DIL' ||
					worksheetName == 'Milk/Milkings in DIM' ||
					worksheetName == 'Lait/Traites en fonction du JEL' ||
					worksheetName == 'Milch/Melkungen nach tim' ||
					worksheetName == 'Melk/Melking volgens DIL' ||
					worksheetName == 'Leftover by DIM' ||
					worksheetName == 'Restes aliments en fonction du stade de lactation' ||
					worksheetName == 'Reste nach tim' ||
					worksheetName == 'Restvoer volgens DIL' ||
					worksheetName == 'Concentrate intake (kg/100) by milk yield' ||
					worksheetName == 'Consommation de concentré (kg/100) en fonction du stade de lactation' ||
					worksheetName == 'Kraftfutteraufnahme (kg/100) nach Milchleistung' ||
					worksheetName == 'Krachtvoergift (kg/100) volgens melkproductie' ||
					worksheetName == 'Concentrate intake (kg/cow) by DIM' ||
					worksheetName == 'Consommation de concentré (kg/vache) en fonction du stade de lactation' ||
					worksheetName == 'Kraftfutteraufnahme (kg/Kuh) nach tim' ||
					worksheetName == 'Krachtvoergift (kg/koe) volgens DIL'
				) {
					actualDashboard = true;
				}
				if (worksheetName == 'Average feed intake over time' || worksheetName == "Consommation moyenne d'aliments en fonction du temps" || worksheetName == 'Durchschnittliche Futteraufnahme im Zeitverlauf' || worksheetName == 'Gemiddelde voeropname over de tijd') {
					isFeedIntake = true;
				}
				if (worksheetName == 'Graph') {
					isActualDashboard = true;
				} else {
					measureNamePromise.resolve();
					measureNameResolved = true;
				}
				if (!sheetNameExists) {
					parityPromise.resolve();
					parityPromiseResolved = true;
					feedNamePromise.resolve();
					feedNamePromiseResolved = true;
				} else {
					_byName(viz.workbook.activeSheet.worksheets, worksheetName)
						.getFiltersAsync()
						.then(function (response) {
							if (isActualDashboard) {
								parityPromise.resolve();
								parityPromiseResolved = true;
								feedNamePromise.resolve();
								feedNamePromiseResolved = true;
								dayPromise.resolve();
								dayPromiseResolved = true;
								DIMPromise.resolve();
								dimPromiseResolved = true;

								actualDashboardFilter = '';
								if (vm.lastSummaryDataTableMarks && vm.lastSummaryDataTableMarks.dimCategory) {
									actualDashboardFilter += '&' + DIMCategoryFilterName + '=' + vm.lastSummaryDataTableMarks.dimCategory;
								}
								if (vm.lastSummaryDataTableMarks && vm.lastSummaryDataTableMarks.parity) {
									actualDashboardFilter += '&' + parityFilter + '=' + vm.lastSummaryDataTableMarks.parity;
								}
								actualDashboardFilterPromise.resolve();
								actualDashboardFilterResolved = true;
							} else {
								actualDashboardFilterPromise.resolve();
								actualDashboardFilterResolved = true;
								var filterValue = _byName(response, parityFilter).appliedValues;
								var feedNameFilterValue;
								if (isFeedIntake) {
									feedNameFilterValue = _byName(response, feedNameFilter).appliedValues;
									if (feedNameFilterValue && feedNameFilterValue.length) {
										feedNameFilterUrl = '&' + feedNameFilter + '=';
										for (var i = 0; i < feedNameFilterValue.length; i++) {
											var feedNameValue = encode(feedNameFilterValue[i].formattedValue);
											if (i == 0) {
												feedNameFilterUrl = feedNameFilterUrl + feedNameValue;
											} else {
												feedNameFilterUrl = feedNameFilterUrl + ',' + feedNameValue;
											}
										}
										feedNamePromise.resolve();
										feedNamePromiseResolved = true;
									} else {
										feedNamePromise.resolve();
										feedNamePromiseResolved = true;
									}
								} else {
									feedNamePromise.resolve();
									feedNamePromiseResolved = true;
								}

								if (actualByDateDashboard) {
									var dayFilterValue;
									var dateFilter;
									if (vm.locale == 'de-DE') {
										dateFilter = 'DAY(Datum)';
									} else if (vm.locale == 'fr-FR') {
										dateFilter = 'DAY(Date)';
									} else if (vm.locale == 'en-GB') {
										dateFilter = 'DAY(Date)';
									} else if (vm.locale == 'en-US') {
										dateFilter = 'DAY(Date)';
									} else if (vm.locale == 'nl-NL') {
										dateFilter = 'DAY(Datum)';
									} else if (vm.locale == 'de-DE') {
										dateFilter = 'DAY(Datum)';
									}
									for (var i = 0; i < response.length; i++) {
										var name = response[i].fieldName;
										var lastMilkDayFilter;
										if (name && name.indexOf(dateFilter) != -1) {
											lastMilkDayFilter = name;
											break;
										}
									}
									if (lastMilkDayFilter) {
										var filter_values = _byName(response, lastMilkDayFilter);
										if (filter_values) {
											dayFilterValue = filter_values.appliedValues;
											var dayFilterValueLenght = dayFilterValue.length;
											if (dayFilterValueLenght == 1) {
												dayFilterValue = moment(dayFilterValue[0].value).format('YYYY-MM-DD');
												dayFilterUrl = '&' + dayFilterName + '=' + dayFilterValue;
											}

											dayPromiseResolved = true;
											dayPromise.resolve();
										}
									} else {
										dayPromiseResolved = true;
										dayPromise.resolve();
									}
								} else {
									dayPromiseResolved = true;
									dayPromise.resolve();
								}

								if (actualDashboard) {
									var filterDIMParityName;
									if (vm.locale == 'de-DE') {
										filterDIMParityName = 'Action (TIM-Kategorie,Laktation) 1';
									} else if (vm.locale == 'fr-FR') {
										filterDIMParityName = 'Action (Catégorie de JEL,Lactation) 1';
									} else if (vm.locale == 'en-GB') {
										filterDIMParityName = 'Action (DIM Category,Parity) 1';
									} else if (vm.locale == 'en-US') {
										filterDIMParityName = 'Action (DIM Category,Parity) 1';
									} else if (vm.locale == 'nl-NL') {
										filterDIMParityName = 'Action (DIM Categorie,Pariteit) 1';
									} else if (vm.locale == 'de-DE') {
										filterDIMParityName = 'Action (TIM-Kategorie,Laktation) 1';
									}
									var filterDimParityPresent;
									for (var i = 0; i < response.length; i++) {
										var name = response[i].fieldName;
										if (name == filterDIMParityName) {
											filterDimParityPresent = true;
										}
									}
									if (filterDimParityPresent) {
										var filterDimParityNameValue = _byName(response, filterDIMParityName).appliedValues;
									} else {
										filterDimParityNameValue = null;
									}

									if (filterDimParityNameValue && filterDimParityNameValue.length == 1) {
										var splitted = filterDimParityNameValue[0].formattedValue.split(',');
										parityFilterUrl = '&' + parityFilter + '=' + splitted[1].trim();
										DIMFilterUrl = '&' + DIMCategoryFilterName + '=' + splitted[0].trim();
										DIMPromise.resolve();
										dimPromiseResolved = true;
										parityPromise.resolve();
										parityPromiseResolved = true;
									} else {
										DIMPromise.resolve();
										dimPromiseResolved = true;

										if (filterValue.length != 3) {
											if (worksheetName != 'RAP Herd prestations actual (ani1)1' && worksheetName != 'Prestations réelles pour le troupeau RAP (ani1)1' && worksheetName != 'RAP tatsächliche Herdvorhersage (ani1)1' && worksheetName != 'RAP kuddeprestaties actueel (ani1)1') {
												parityFilterUrl = '&' + parityFilter + '=';
												for (var i = 0; i < filterValue.length; i++) {
													if (i == 0) {
														parityFilterUrl = parityFilterUrl + filterValue[i].formattedValue;
													} else {
														parityFilterUrl = parityFilterUrl + ',' + filterValue[i].formattedValue;
													}
												}
											}
											parityPromise.resolve();
											parityPromiseResolved = true;
										} else {
											parityPromise.resolve();
											parityPromiseResolved = true;
										}
									}
								} else {
									DIMPromise.resolve();
									dimPromiseResolved = true;
									if (filterValue.length != 3) {
										if (worksheetName != 'RAP Herd prestations actual (ani1)1' && worksheetName != 'Prestations réelles pour le troupeau RAP (ani1)1' && worksheetName != 'RAP tatsächliche Herdvorhersage (ani1)1' && worksheetName != 'RAP kuddeprestaties actueel (ani1)1') {
											parityFilterUrl = '&' + parityFilter + '=';
											for (var i = 0; i < filterValue.length; i++) {
												if (i == 0) {
													parityFilterUrl = parityFilterUrl + filterValue[i].formattedValue;
												} else {
													parityFilterUrl = parityFilterUrl + ',' + filterValue[i].formattedValue;
												}
											}
										}
										parityPromise.resolve();
										parityPromiseResolved = true;
									} else {
										parityPromise.resolve();
										parityPromiseResolved = true;
									}
								}
							}
						});
				}
				viz.workbook
					.getParametersAsync()
					.then(function (parameters) {
						if (isActualDashboard) {
							groupByPromise.resolve();
							groupByPromiseResolved = true;
							for (var i = 0; i < parameters.length; i++) {
								if (parameters[i].name == measureParameterName) {
									measureName = parameters[i].currentValue.formattedValue;
									break;
								}
							}
							measureNamePromise.resolve();
							measureNameResolved = true;
						} else {
							var groupBy;
							for (var i = 0; i < parameters.length; i++) {
								if (parameters[i].name == groupByParam) {
									groupBy = parameters[i].currentValue.formattedValue;
									break;
								}
							}
							if (groupBy) {
								groupByFilterUrl = '&' + groupByParam + '=' + groupBy;
							}
							groupByPromise.resolve();
							groupByPromiseResolved = true;
						}
					});
				var legendExist = false;
				for (var i = 0; i < wrks.length; i++) {
					if (wrks[i].name == legend) {
						legendExist = true;
						break;
					}
				}
				if (legendExist) {
					_byName(wrks, legend)
						.getSelectedMarksAsync()
						.then(function (response) {
							if (response[0]) {
								var pairs = response[0].getPairs();
								var value;
								for (var i = 0; i < pairs.length; i++) {
									if (pairs[i].fieldName == groupByMetric) {
										value = pairs[i].formattedValue;
									}
								}
								if (value) {
									groupByMetricMarkUrl = '&' + groupByMetric + '=' + value;
								}
								groupByMetricPromise.resolve();
								groupByMetricPromiseResolved = true;
							} else {
								groupByMetricPromise.resolve();
								groupByMetricPromiseResolved = true;
							}
						});
				} else {
					groupByMetricPromise.resolve();
					groupByMetricPromiseResolved = true;
				}
			} catch (error) {
				console.log(error);
				parityPromise.resolve();
				groupByPromise.resolve();
				groupByMetricPromise.resolve();
				feedNamePromise.resolve();
				DIMPromise.resolve();
				dayPromise.resolve();
				parityPromiseResolved = false;
				groupByPromiseResolved = false;
				groupByMetricPromiseResolved = false;
				feedNamePromiseResolved = false;
				dimPromiseResolved = false;
				dayPromiseResolved = false;
			}
		}

		function setEntry(filterUrl, paramName) {
			var start_date;
			if (vm.actualDashboardOpen) {
				start_date = moment(vm.actual_start_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
			} else {
				start_date = moment(vm.start_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
			}
			var end_date = moment(vm.end_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
			if (vm.currentEntry) {
				var obj = {
					id: vm.currentEntry.id,
					comment: vm.modalComment,
					endDate: end_date,
					startDate: start_date,
					locale: vm.currentEntry.locale,
					dashboardId: paramName ? vm.currentEntry.dashboardId + '|' + encode(paramName) : vm.currentEntry.dashboardId,
					filter: filterUrl
				};
				return rapService
					.updateReportEntry(obj.id, obj)
					.then(function (response) {
						closeModal();
					})
					.catch(function (error) {
						console.log(error);
						vm.addToReportModalLoading = false;
					});
				closeModal();
			} else {
				var lng = vm.locale;
				var date = moment().hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
				var obj = {
					date: date,
					herdId: vm.selectedHerd,
					comment: vm.modalComment,
					endDate: end_date,
					startDate: start_date,
					locale: lng,
					dashboardId: paramName ? vm.currentSheet + '|' + encode(paramName) : vm.currentSheet,
					filter: filterUrl
				};
				return rapService
					.addToReport(obj)
					.then(function (response) {
						closeModal();
					})
					.catch(function (error) {
						console.log(error);
						vm.addToReportModalLoading = false;
					});
			}
		}

		function openCreateReport() {
			var parser = new UAParser();
			var os = parser.getOS();
			var brw = parser.getBrowser();
			if (os.name == 'iOS' && brw.name == 'Mobile Safari') {
				vm.safariMobileUsed = true;
			} else {
				vm.safariMobileUsed = false;
			}
			vm.reportDate = new Date();
			vm.showCreateReportBlock = true;
			vm.reportLoading = true;
			vm.pdfLoading = false;
			if (vm.selectedHerd) {
				herdsPromise = $q.defer();
				dashboardsPromise = $q.defer();
				addToReportPromise = $q.defer();
				$q.all([herdsPromise.promise, dashboardsPromise.promise, addToReportPromise.promise])
					.then(function () {
						vm.reportError = false;
						vm.reportDashboards = checkForAddedToReport(vm.allReportDashboards, vm.addedToReport);
						vm.reportDashboards = setActualByDate(vm.reportDashboards);
						if (vm.reportDashboards.length) {
							vm.reportLoading = false;
							vm.herdNotSelected = false;
						} else {
							vm.showCreateReportBlock = false;
							vm.noAvailableDashboards = true;
							vm.reportLoading = false;
							vm.herdNotSelected = false;
						}
					})
					.catch(function (error) {
						vm.reportLoading = false;
						vm.reportError = true;
						vm.pdfLoading = false;
					});

				var herd_id = vm.selectedHerd;
				var team_id = vm.selectedTeam;

				checkAllDashboards(team_id);
				getAddedToReport(false, vm.reportDate, true);
				checkHerds(herd_id);
			} else {
				vm.reportLoading = false;
				$interval.cancel(laodingDotsInterval);
				vm.herdNotSelected = true;
			}
		}

		function checkAllDashboards(team_id) {
			if (insightsFactory && insightsFactory.loadedDashboards.dashboards && insightsFactory.loadedDashboards.team_id == team_id && insightsFactory.loadedDashboards.lng == vm.locale) {
				vm.allReportDashboards = getRapDashboards(rapService.allDashboards.dashboards);
				dashboardsPromise.resolve();
			} else {
				var tableauSuffix = '?locale=' + vm.locale;
				return rapService
					.getDashboards(vm.selectedTeam, tableauSuffix)
					.then(function (response) {
						vm.allReportDashboards = getRapDashboards(response);
						dashboardsPromise.resolve();
					})
					.catch(function (error) {
						dashboardsPromise.reject();
					});
			}
		}

		function getRapDashboards(dashboards) {
			var list = [];
			var listOfDashboardsIds = [];
			var currentLng = vm.locale;
			for (var i = 0; i < APP_CONST.constants.dashboardIdLngList.length; i++) {
				if (APP_CONST.constants.dashboardIdLngList[i].lng == currentLng && APP_CONST.constants.dashboardIdLngList[i].internal_id != 'rap_main_herd_overview') {
					listOfDashboardsIds.push(APP_CONST.constants.dashboardIdLngList[i]);
				}
			}
			for (var i = 0; i < listOfDashboardsIds.length; i++) {
				for (var j = 0; j < dashboards.length; j++) {
					if (listOfDashboardsIds[i].id == dashboards[j].id && dashboards[j].locale == currentLng && dashboards[j].subcategory == 'rap-fame-v3') {
						dashboards[j].index = listOfDashboardsIds[i].index;
						dashboards[j].selected = listOfDashboardsIds[i].selected;
						dashboards[j].default = listOfDashboardsIds[i].default;
						dashboards[j].actual = listOfDashboardsIds[i].actual;
						dashboards[j].size = listOfDashboardsIds[i].size;
						if (listOfDashboardsIds[i].actual) {
							dashboards[j].start_date = vm.actual_start_date;
						} else {
							dashboards[j].start_date = vm.init_start_date;
						}
						dashboards[j].end_date = vm.end_date;
						if (isActualByDate(dashboards[j])) {
							dashboards[j].report_date = vm.end_date;
						}
						list.push(dashboards[j]);
					}
				}
			}

			return list;
		}

		function setReportDashboardComment() {
			vm.addCommentModalLoading = true;
			var end_date = moment(vm.selectedReportDashboard.end_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
			var start_date = moment(vm.selectedReportDashboard.start_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
			if (vm.selectedReportDashboard.entry_id) {
				var obj = {
					id: vm.selectedReportDashboard.entry_id,
					comment: vm.selectedReportDashboard.comment,
					endDate: end_date,
					startDate: start_date,
					locale: vm.selectedReportDashboard.locale,
					dashboardId: vm.selectedReportDashboard.id
				};
				return rapService
					.updateReportEntry(obj.id, obj)
					.then(function (response) {
						vm.reportDashboards[vm.selectedReportDashboardIndex].comment = vm.selectedReportDashboard.comment;
						closeModal();
					})
					.catch(function (error) {
						console.log(error);
						vm.addCommentModalLoading = false;
					});
			} else {
				vm.reportDashboards[vm.selectedReportDashboardIndex].comment = vm.selectedReportDashboard.comment;
				closeModal();
			}
		}

		function checkHerds(herd_id) {
			return rapService
				.getHerdsByTeam(vm.selectedTeam)
				.then(function (response) {
					vm.currentHerdName = getHerdNameById(herd_id, response);
					herdsPromise.resolve();
				})
				.catch(function (error) {
					herdsPromise.reject();
				});
		}

		function getHerdNameById(herd_id, herds) {
			var herdName = '';
			for (var i = 0; i < herds.length; i++) {
				if (herds[i].Id == herd_id) {
					herdName = herds[i].Name;
					break;
				}
			}
			return herdName;
		}

		function closeCreateReport() {
			vm.showCreateReportBlock = false;
			vm.pointsToImprove = '';
			vm.positivePoints = '';
		}

		function setReportDashboardRange() {
			var range_error = checkRangeError(vm.selectedReportDashboard.actual, vm.report_modal_start_date, vm.report_modal_end_date);
			if (!range_error) {
				vm.setRangeModalLoading = true;
				if (vm.selectedReportDashboard.entry_id) {
					var end_date = moment(vm.report_modal_end_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
					if (vm.selectedReportDashboard.actual) {
						var start_date = moment(vm.report_modal_end_date).subtract(7, 'days').hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
					} else {
						var start_date = moment(vm.report_modal_start_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
					}
					var obj = {
						id: vm.selectedReportDashboard.entry_id,
						comment: vm.selectedReportDashboard.comment,
						endDate: end_date,
						startDate: start_date,
						locale: vm.selectedReportDashboard.locale,
						dashboardId: vm.selectedReportDashboard.id,
						filter: vm.selectedReportDashboard.filter
					};
					return rapService
						.updateReportEntry(obj.id, obj)
						.then(function (response) {
							vm.reportDashboards[vm.selectedReportDashboardIndex].end_date = vm.report_modal_end_date;
							if (vm.selectedReportDashboard.actual) {
								vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = new Date(moment(vm.report_modal_end_date).subtract(7, 'days'));
							} else {
								vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = vm.report_modal_start_date;
							}
							closeModal();
						})
						.catch(function (error) {
							console.log(error);
							vm.setRangeModalLoading = false;
						});
				} else {
					vm.reportDashboards[vm.selectedReportDashboardIndex].end_date = vm.report_modal_end_date;
					if (vm.selectedReportDashboard.actual) {
						vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = new Date(moment(vm.report_modal_end_date).subtract(7, 'days'));
					} else {
						vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = vm.report_modal_start_date;
					}
					closeModal();
				}
			}
		}

		function setActualReportDate() {
			vm.setDateModalLoading = true;
			if (vm.selectedReportDashboard.entry_id) {
				var obj = {
					id: vm.selectedReportDashboard.entry_id,
					comment: vm.selectedReportDashboard.comment,
					endDate: vm.selectedReportDashboard.end_date,
					startDate: vm.selectedReportDashboard.start_date,
					locale: vm.selectedReportDashboard.locale,
					dashboardId: vm.selectedReportDashboard.id,
					filter: changeDateFilter(vm.selectedReportDashboard.filter, vm.report_modal_date)
				};
				return rapService
					.updateReportEntry(obj.id, obj)
					.then(function (response) {
						vm.reportDashboards[vm.selectedReportDashboardIndex].report_date = vm.report_modal_date;
						vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = vm.report_modal_date;

						closeModal();
					})
					.catch(function (error) {
						console.log(error);
						vm.setDateModalLoading = false;
					});
			} else {
				vm.reportDashboards[vm.selectedReportDashboardIndex].filter = '&' + dayFilterName + '=' + moment(vm.report_modal_date).format('YYYY-MM-DD');
				vm.reportDashboards[vm.selectedReportDashboardIndex].report_date = vm.report_modal_date;
				vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = vm.report_modal_date;
				closeModal();
			}
		}

		function changeDateFilter(filter, date) {
			var regex = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
			date = moment(date).format('YYYY-MM-DD');
			filter = filter.replace(regex, date);
			return filter;
		}

		function setReportData() {
			var parser = new UAParser();
			var brw = parser.getBrowser();
			var os = parser.getOS();
			vm.reportLoading = true;
			vm.pdfLoading = true;
			loadingDotsCounter = 0;
			laodingDotsInterval = $interval(function () {
				if (loadingDotsCounter == 0) {
					vm.loadingDots = '.';
					loadingDotsCounter++;
				} else if (loadingDotsCounter == 1) {
					vm.loadingDots = '..';
					loadingDotsCounter++;
				} else if (loadingDotsCounter == 2) {
					vm.loadingDots = '...';
					loadingDotsCounter = 0;
				}
			}, 400);
			var list = [];
			for (var i = 0; i < vm.reportDashboards.length; i++) {
				if (vm.reportDashboards[i].selected) {
					list.push(vm.reportDashboards[i]);
				}
			}
			vm.orderedDashboards = $filter('orderBy')(list, 'index');
			var url_promise_list = [];
			for (var i = 0; i < vm.orderedDashboards.length; i++) {
				var name = 'pr' + i;
				vm[name] = $q.defer();
				url_promise_list.push(vm[name].promise);
				getImageUrl(vm.orderedDashboards[i].url, i, name);
			}

			function getImageUrl(url, index, name) {
				if (vm.work_locally) {
					var image_url = 'assets/img/hoof_health_bcg.jpg?4564545';
					vm.orderedDashboards[index].image_url = image_url;
					vm.orderedDashboards[index].image_loaded = true;
					vm[name].resolve();
				} else {
					return rapService
						.setSession(url)
						.then(function (response) {
							var image_url = response.headers('tabvis-location');
							vm.orderedDashboards[index].image_url = image_url;
							vm.orderedDashboards[index].image_loaded = true;
							vm[name].resolve();
						})
						.catch(function (error) {
							vm[name].resolve();
						});
				}
			}
			$q.all(url_promise_list)
				.then(function () {
					setDataUrls(vm.orderedDashboards);
				})
				.catch(function (error) {
					vm.reportLoading = false;
					vm.reportError = true;
					vm.pdfLoading = false;
				});
			//}
		}

		function getDataUrl(url, index, name) {
			toDataURL(
				url,
				function (dataUrl) {
					if (dataUrl) {
						vm.orderedDashboards[index].image = dataUrl;
					} else {
						vm.orderedDashboards[index].image = null;
						vm.orderedDashboards[index].image_loaded = false;
					}
					vm[name].resolve();
				},
				name
			);
		}

		function toDataURL(url, callback, prm) {
			var xhr = new XMLHttpRequest();
			xhr.onload = function () {
				var reader = new FileReader();
				reader.onloadend = function () {
					callback(reader.result);
				};
				if (xhr.status == 200 || xhr.status == 204) {
					reader.readAsDataURL(xhr.response);
				} else {
					callback(null);
				}
			};
			xhr.open('GET', url);
			xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('id_token'));
			xhr.responseType = 'blob';
			xhr.withCredentials = true;
			xhr.send();
		}

		function setImageUrl(dashboard) {
			var image_url;
			var size = '1920,1080';
			var splitted = dashboard.image_url.split('?');
			if (vm.work_locally) {
				image_url = splitted[0];
			} else {
				image_url = splitted[0] + '.png';
			}
			var start_date = moment(dashboard.start_date).format('YYYY-MM-DD');
			var end_date = moment(dashboard.end_date).format('YYYY-MM-DD');
			var herd = vm.selectedHerd;
			var suffix = '?Start%20Date=' + start_date + '&End%20Date=' + end_date + '&HerdIdentifier=' + herd + '&herd%20param=' + herd + '&:size=';
			if (dashboard.size) {
				suffix = suffix + dashboard.size;
			} else {
				suffix = suffix + size;
			}
			if (TMRchanged) {
				suffix = suffix + '&' + tmrParamName + '=' + TMR;
			}
			if (DryMatterChanged) {
				suffix = suffix + '&' + dmParamName + '=' + DryMatter;
			}
			image_url = image_url + suffix;
			if (dashboard.filter) {
				image_url = image_url + dashboard.filter;
			}
			return image_url;
		}

		function setDataUrls() {
			var image_url_promise_list = [];
			for (var i = 0; i < vm.orderedDashboards.length; i++) {
				if (vm.orderedDashboards[i].image_loaded) {
					var name = 'imgpr' + i;
					vm[name] = $q.defer();
					image_url_promise_list.push(vm[name].promise);
					var image_url = setImageUrl(vm.orderedDashboards[i]);
					getDataUrl(image_url, i, name);
				}
			}
			vm.logoPrm = $q.defer();
			image_url_promise_list.push(vm.logoPrm.promise);
			toDataURL(
				'assets/img/MmmooOgle_logo.png',
				function (dataUrl) {
					vm.logo = dataUrl;
					vm.logoPrm.resolve();
				},
				'logoPrm'
			);
			$q.all(image_url_promise_list)
				.then(function () {
					var date = new Date();
					date = $filter('date')(date);
					var pdfData = {
						date: date,
						logo: vm.logo,
						user: vm.user.name,
						blue: '#033384',
						green: '#99B71B',
						red: 'red',
						positive_points: vm.positivePoints ? vm.positivePoints : '',
						points_to_improve: vm.pointsToImprove ? vm.pointsToImprove : '',
						herd_name: vm.currentHerdName,
						dashboards: vm.orderedDashboards
					};
					createPDF(pdfData);
				})
				.catch(function (error) {
					vm.reportLoading = false;
					vm.reportError = true;
					vm.pdfLoading = false;
				});
		}

		function createPDF(pdfData) {
			var dd = {
				pageMargins: [20, 20, 20, 20],
				pageSize: 'A4',
				content: [
					{
						image: pdfData.logo,
						width: 120,
						alignment: 'left'
					},
					{
						text: i18nFilter('_report_title_robot_analysis_') + ':',
						alignment: 'left',
						fontSize: 16,
						bold: true,
						color: pdfData.blue
					},
					{
						text: pdfData.herd_name,
						alignment: 'left',
						fontSize: 14,
						color: pdfData.blue,
						margin: [0, 10, 0, 0],
						italics: true
					},
					{
						text: pdfData.date,
						alignment: 'left',
						fontSize: 14,
						color: pdfData.blue,
						italics: true
					},
					{
						table: {
							widths: ['auto', '*'],
							body: [
								[
									{
										text: i18nFilter('_report_robot_specialist_') + ':',
										color: pdfData.blue,
										fontSize: 14,
										border: [false, false, false, true],
										italics: true,
										margin: [-5, 0, -5, 0]
									},
									{
										text: pdfData.user,
										color: pdfData.blue,
										fontSize: 14,
										border: [false, false, false, true],
										italics: true
									}
								]
							]
						},
						layout: {
							hLineColor: pdfData.green
						}
					},
					{
						text: i18nFilter('_report_positive_points_') + ':',
						alignment: 'left',
						bold: true,
						margin: [0, 5, 15, 0]
					},
					{
						text: pdfData.positive_points,
						alignment: 'left',
						pageBreak: (pdfData.positive_points.length > 1700 || pdfData.positive_points.split(/\r\n|\r|\n/).length > 22) && (pdfData.points_to_improve.length > 1700 || pdfData.points_to_improve.split(/\r\n|\r|\n/).length > 22) ? 'after' : false
					},
					{
						text: i18nFilter('_report_points_to_improve_') + ':',
						alignment: 'left',
						bold: true,
						margin: [0, 5, 15, 0]
					},
					{
						text: pdfData.points_to_improve,
						alignment: 'left'
					}
				]
			};
			for (var i = 0; i < pdfData.dashboards.length; i++) {
				var obj = {
					text: pdfData.dashboards[i].comment ? pdfData.dashboards[i].comment : '',
					border: [false, false, false, false],
					margin: [0, 5, 0, 10]
				};
				var table = {
					table: {
						dontBreakRows: true,
						widths: ['*'],
						body: [
							[
								{
									border: [false, false, false, false],
									margin: [-5, 5, -5, 10],
									stack: [
										{
											margin: [0, 5, 0, 10],
											text: isActualByDate(pdfData.dashboards[i])
												? pdfData.dashboards[i].description + ' (' + $filter('date')(pdfData.dashboards[i].report_date) + ')'
												: pdfData.dashboards[i].description + ' (' + $filter('date')(pdfData.dashboards[i].start_date) + ' - ' + $filter('date')(pdfData.dashboards[i].end_date) + ')',
											border: [false, false, false, false],
											bold: true
										},
										{
											image: pdfData.dashboards[i].image,
											width: 555,
											border: [false, false, false, false]
										}
									]
								}
							]
						]
					},
					layout: {
						hLineColor: pdfData.green
					}
				};
				if (pdfData.dashboards[i].selected && pdfData.dashboards[i].image_loaded) {
					dd.content.push(table);
					dd.content.push(obj);
				}
			}
			var reportName = i18nFilter('_report_title_robot_analysis_') + ' ' + $filter('date')(new Date(), 'yyyy-MM-dd');
			var parser = new UAParser();
			var os = parser.getOS();
			var brw = parser.getBrowser();
			var device = parser.getDevice();
			var pdf = pdfMake.createPdf(dd);
			if (device && device.type) {
				if (os.name == 'iOS') {
					if (brw.name == 'Mobile Safari') {
						try {
							pdf.open();
						} catch (error) {
							toastr.error(error);
						}
					} else {
						try {
							var reader = new FileReader();
							pdf.open();
							pdf.getBlob(function (blob) {
								reader.onload = function (e) {
									var uri = reader.result;
									var link = document.createElement('a');
									link.download = reportName + '.pdf';
									link.href = uri;
									document.body.appendChild(link);
									link.click();
									document.body.removeChild(link);
								};
								reader.readAsDataURL(blob);
							});
						} catch (error) {
							toastr.error(error);
						}
					}
				} else {
					pdfMake.createPdf(dd).download(reportName);
				}
			} else {
				try {
					pdfMake.createPdf(dd).open();
				} catch (error) {
					toastr.error(i18nFilter('_report_create_popup_message_'));
				}
			}
			$timeout(function () {
				vm.showCreateReportBlock = false;
				vm.reportLoading = false;
				vm.pdfLoading = false;
				$interval.cancel(laodingDotsInterval);
			}, 500);
		}

		function setSessionHandler(team_id) {
			var result = $q.defer(),
				setSession,
				url = APP_CONST.tableau_base_url + team_id + '/session';
			setSession = $http({
				method: 'post',
				url: url,
				data: {},
				cache: false,
				timeout: timeout.promise,
				withCredentials: true
			});
			setSession.then(function (response) {
				result.resolve(response.data);
			}, function (response) {
				console.log('error', response.data);
				result.reject(response.data);
			});
			return result.promise;
		}

		function encode(string) {
			var s = encodeURIComponent(string);
			s = s.replaceAll('(', '%28');
			s = s.replaceAll(')', '%29');
			return s;
		}

		$scope.$on('default_herd_selected', function () {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedHerd = vm.settings.selectedHerd.id;
			setDates();

			init();
		});

		$scope.$on('default_team_selected', function () {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedHerd = vm.settings.selectedHerd.id;
			vm.teamReselected = true;
			if (viz) {
				window.TableauV3.disposeViz(viz);
			}
			reloadTimeout = $timeout(function () {
				if (timeout) {
					timeout.resolve('cancel_request');
				}

				setDates();
				init();
			}, 500);
		});
		$scope.$on('default_values_loaded', function () {
			if (teamTimeout) {
				$timeout.cancel(teamTimeout);
			}
			var newDefaultValues = localStorage.getItem('default_values');
			if (newDefaultValues != JSON.stringify(vm.defaultValues)) {
				init();
			}
		});
		$scope.$on('$destroy', function () {
			if (reloadTimeout) {
				$timeout.cancel(reloadTimeout);
			}
			var expires = new Date();
			expires.setFullYear(expires.getFullYear() - 1);
			cookiesService.setCookie('rap_actual_dates', null, {
				samesite: 'lax',
				domain: '.mmmooogle.com',
				expires: expires
			});
			if (timeout) {
				timeout.resolve('cancel_request');
			}
			if (viz) {
				window.TableauV3.disposeViz(viz);
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rap').factory('rapService', rapService);
	/** @ngInject */
	function rapService(APP_CONST, $http, $q) {
		return {
			getDashboards: getDashboards,
			setTableauTenant: setTableauTenant,
			setSession: setSession,
			getHerdsByTeam: getHerdsByTeam,
			addToReport: addToReport,
			getReports: getReports,
			updateReportEntry: updateReportEntry,
			laodedHerds: {},
			allDashboards: {}
		};

		function getDashboards(team_id, suffix) {
			return $http
				.get(APP_CONST.tableau_base_url + team_id + '/dashboards' + suffix, {
					withCredentials: true,
					timeout: 20000
				})
				.then(success)
				.catch(error);
		}

		function setTableauTenant(team_id) {
			return $http
				.post(
					APP_CONST.tableau_base_url + team_id + '/session',
					{},
					{
						withCredentials: true
					}
				)
				.then(success)
				.catch(error);
		}

		function getHerdsByTeam(team_id) {
			return $http
				.get(APP_CONST.backoffice_base_url + 'teams/' + team_id + '/herds')
				.then(success)
				.catch(error);
		}

		function addToReport(obj) {
			return $http
				.post(APP_CONST.tableau_reports_base_url + '/reportentry', obj, {
					withCredentials: true
				})
				.then(success)
				.catch(error);
		}

		function getReports(suffix) {
			return $http
				.get(APP_CONST.tableau_reports_base_url + suffix, {
					withCredentials: true
				})
				.then(success)
				.catch(error);
		}

		function updateReportEntry(id, obj) {
			return $http
				.put(APP_CONST.tableau_reports_base_url + '/reportentry/' + id, obj, {
					withCredentials: true
				})
				.then(success)
				.catch(error);
		}

		function setSession(url) {
			return $http
				.get(url, {
					withCredentials: true
				})
				.then(function (response) {
					return response;
				})
				.catch(function (error) {
					return $q.reject(error);
				});
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.settings').controller('settingsCtrl', settingsCtrl);
	/** @ngInject */
	function settingsCtrl(APP_CONST, tmhDynamicLocale, settingsFactory, toastr, $filter, localize, $rootScope, errorService, $cookies, APP_VERSION) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		vm.save = save;
		init();

		function init() {
			vm.loading = false;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.weight = vm.settings.use_kgs ? 'kg' : 'lb';
			vm.languages = APP_CONST.constants.languages;
			vm.currentLanguage = null;
			vm.version = 'Version: ' + APP_VERSION;
			var timestamp = APP_CONST.buildTimeStamp;
			if (timestamp) {
				vm.buildDate = moment.unix(timestamp / 1000).format('DD MMM YYYY hh:mm a');
			}
			vm.database = APP_CONST.database;
			setDefaultCalculation();
			setSwitchLabels();
			setUseAmountSwitch();
			setCurrentLang(vm.languages);
		}

		function setSwitchLabels() {
			vm.amountSwitchLabel = i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_');
			vm.productSwitchLabel = i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_m_f_product_switch_product_type');
		}

		function setUseAmountSwitch() {
			try {
				var sw = JSON.parse($cookies.get('use_product'));
			} catch (error) {
				vm.switchUseAmount = true;
				$cookies.put('use_product', vm.switchUseAmount, {
					expires: moment().add(1, 'month').toDate()
				});
			}
			if (sw != null) {
				vm.switchUseAmount = sw;
			}
		}

		function setCurrentLang(languages) {
			for (var i = 0; i < languages.length; i++) {
				if (languages[i].code == vm.settings.language) {
					vm.currentLanguage = languages[i];
					break;
				}
			}
		}

		function setDefaultCalculation() {
			vm.defaultCalculationList = [
				{
					name: '_calculation_filter_us_feeds_',
					calc_type: 0
				},
				{
					name: '_calculation_filter_vem_dve_feeds_',
					calc_type: 1
				}
			];
			if (vm.settings.calculation_type != null) {
				for (var i = 0; i < vm.defaultCalculationList.length; i++) {
					if (vm.settings.calculation_type === vm.defaultCalculationList[i].calc_type) {
						vm.selectedCalculation = vm.defaultCalculationList[i];
					}
				}
			} else {
				vm.selectedCalculation = vm.defaultCalculationList[0];
			}
		}

		function save() {
			vm.settings.language = vm.currentLanguage ? vm.currentLanguage.code : 'en-us';
			vm.settings.team_id = null;
			vm.settings.herd_id = null;
			tmhDynamicLocale.set(vm.settings.language);
			localize.setLanguage(vm.settings.language);
			vm.settings.calculation_type = vm.selectedCalculation.calc_type;
			vm.loading = true;
			return settingsFactory
				.changeSettings(vm.settings)
				.then(function (response) {
					localStorage.setItem('user_settings', JSON.stringify(response));
					$cookies.put('use_product', vm.switchUseAmount, {
						expires: moment().add(1, 'month').toDate()
					});
					vm.weight = vm.settings.use_kgs ? 'kg' : 'lb';
					vm.loading = false;
					toastr.success('', i18nFilter('_toastr_success_title_'));
					broadcastSettings();
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_saving_user_settings_');
				});
		}

		function broadcastSettings() {
			$rootScope.$broadcast('user_settings_changed', false);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.settings').factory('settingsFactory', settingsFactory);
	/** @ngInject */
	function settingsFactory(APP_CONST, $http, $q) {
		return {
			changeSettings: changeSettings
		};

		function changeSettings(settings, email) {
			if (email) {
				email = encodeURIComponent(email);
			} else {
				email = '';
			}
			return $http
				.patch(APP_CONST.api_base_url + 'userSettings?email=' + email, settings)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages').service('recipeDataService', recipeDataService);

	/** @ngInject */
	function recipeDataService() {
		var recipe = new Recipe();

		this.getRecipe = function () {
			return recipe;
		};

		this.setRecipe = function (r) {
			recipe = r;
		};

		this.resetRecipe = function () {
			recipe = new Recipe();
		};

		this.log = function () {
			console.log(angular.toJson(recipe));
		};


		function Recipe() {
			this.tmr = true;
			this.recipe_name = '';
			this.currentPageRation = 1;
			this.currentPagePens = 1;
			this.selectedRation = null;
			this.rations = [];
			this.pens = [];
			this.selected_pens = [];
			this.changed_pens = [];
			this.wagons = [];
			this.feeding_methods = [];
			this.recipe_list = [];
			this.versions = [];
			this.historicalVersion = false;
			this.suggestion = {
				feeding_1: {},
				feeding_2: {},
				feeding_3: {}
			};
		}

	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages').service('recipePreviewDataService', recipePreviewDataService);

	/** @ngInject */
	function recipePreviewDataService($filter) {
		var RRule = rrule.RRule;
		var handledPens = [];
		return {
			generateRecipePreview: generateRecipePreview
		};

		function generateRecipePreview(recipe, date, days) {
			var versions = recipe.recipe_versions;
			versions = $filter('orderBy')(versions, ['used_from', 'id']);
			versions = filterOutSameDayVersions(versions);
			var versions_end_date = moment(versions[versions.length - 1])
				.add(3, 'M')
				.format('YYYY-MM-DD');
			handledPens = [];
			versions = versions.map(function (version, index) {
				version.used_from_date = moment(version.used_from).format('YYYY-MM-DD');
				version.used_until_date = versions[index + 1]
					? moment(versions[index + 1].used_from)
							.subtract(1, 'd')
							.format('YYYY-MM-DD')
					: moment().add(3, 'M').format('YYYY-MM-DD');

				version.scheduled_pens = setPenFeedingsPerDay(version.scheduled_pens, versions_end_date);
				return version;
			});

			var timeline = generateDayVersionList(versions, date, days);
			timeline = calculateFeedings(timeline);

			return timeline;
		}

		function filterOutSameDayVersions(versions) {
			var list = [];

			versions.forEach(function (version, index) {
				var sameDay = checkIsSameDay(version, versions[index + 1]);

				if (!sameDay) {
					list.push(version);
				} else {
					if (versions[index + 1]) {
						versions[index + 1].used_from = version.used_from;
					}
				}
			});
			return list;
		}

		function checkIsSameDay(version, version_1) {
			if (version_1 && moment(version.used_from).isSame(version_1.used_from, 'day')) {
				return true;
			}

			return false;
		}

		function generateDayVersionList(versions, first_date, days) {
			var start_date = moment(versions[0].used_from_date).format('YYYYMMDDT000000') + 'Z';
			var end_date = moment(versions[versions.length - 1].used_until_date).format('YYYYMMDDT000000') + 'Z';
			var rrule_string = 'DTSTART:' + start_date + '\nRRULE:FREQ=DAILY;INTERVAL=1;UNTIL=' + end_date;
			var dayVersionList = generateDaysUsingRRuleString(rrule_string, first_date, days);
			dayVersionList = dayVersionList.map(function (date) {
				var version = getVersionByDate(versions, date);
				var pens = getPensByDate(version, date);
				date = { date: date, version: version, pens: pens };
				return date;
			});

			return dayVersionList;
		}

		function generateDaysUsingRRuleString(string, first_date, days) {
			if (first_date && days) {
				var allDays = RRule.fromString(string).all();
				var startIndex = allDays.findIndex(function (day) {
					return moment(day).isSame(first_date, 'day');
				});
				return allDays.slice(startIndex, startIndex + days);
			}
			return RRule.fromString(string).all();
		}

		function getVersionByDate(versions, date) {
			var version = versions.filter(function (_version) {
				return moment(date).isBetween(_version.used_from_date, _version.used_until_date, 'day') || moment(date).isSame(_version.used_from_date, 'day') || moment(date).isSame(_version.used_until_date, 'day');
			});

			return version[0];
		}

		function setPenFeedingsPerDay(pens, end_date) {
			pens.map(function (pen) {
				var existing_pen = handledPens.find(function (_pen) {
					return _pen.id == pen.id;
				});

				if (!existing_pen) {
					pen.pen_feedings_per_day = generatePenFeedingsPerDay(pen, end_date);
					handledPens.push(pen);
				} else {
					pen.pen_feedings_per_day = existing_pen.pen_feedings_per_day;
				}

				return pen;
			});
			return pens;
		}

		function generatePenFeedingsPerDay(pen, version_end_date) {
			var pen_feedings_per_day = [];
			pen.pen_feeding_scheduler_list = $filter('orderBy')(pen.pen_feeding_scheduler_list, 'start_feeding_date');
			pen.pen_feeding_scheduler_list.forEach(function (pfs, index) {
				var start_date = moment(pfs.start_feeding_date).format('YYYYMMDDT000000') + 'Z';
				var end_date = pen.pen_feeding_scheduler_list[index + 1]
					? moment(pen.pen_feeding_scheduler_list[index + 1].start_feeding_date)
							.subtract(1, 'd')
							.format('YYYYMMDDT000000') + 'Z'
					: moment(version_end_date).format('YYYYMMDDT000000') + 'Z';
				var rrule_freq = pfs.feeding_frequency_rule && pfs.feeding_frequency_rule.length > 1 ? pfs.feeding_frequency_rule : 'FREQ=DAILY;INTERVAL=1';
				var rrule_string = 'DTSTART:' + start_date + '\nRRULE:' + rrule_freq + ';UNTIL=' + end_date;
				var days = generateDaysUsingRRuleString(rrule_string);
				days = days.map(function (day, index) {
					var multiply = days[index + 1] ? moment(days[index + 1]).diff(day, 'days') : 1;
					day = {
						date: day,
						pen_feeding: pfs,
						multiply: multiply
					};
					return day;
				});

				pen_feedings_per_day = pen_feedings_per_day.concat(days);
			});

			return pen_feedings_per_day;
		}

		function getPensByDate(version, date) {
			var pens = [];

			version.scheduled_pens.forEach(function (pen) {
				var pen_schedule = getPenScheduleByDate(pen, date);
				if (pen_schedule) {
					var pen_object = {
						pen_feeding: pen_schedule.pen_feeding,
						multiply: pen_schedule.multiply,
						feed_intake: pen.feed_intake,
						number_of_animals: pen.number_of_animals,
						pen_category: pen.pen_category,
						pen_name: pen.pen_name,
						use_pen_feed_intake: pen.use_pen_feed_intake
					};
					pens.push(pen_object);
				}
			});
			return pens;
		}

		function getPenScheduleByDate(pen, date) {
			var pen_schedule = pen.pen_feedings_per_day.filter(function (pfpd) {
				return moment(pfpd.date).isSame(date, 'day');
			});

			if (pen_schedule && pen_schedule.length) {
				return pen_schedule[0];
			}

			return null;
		}

		function calculateFeedings(timeline) {
			timeline = timeline.map(function (day) {
				day.pens = calculatePens(day);
				day.summary = setSummary(day);
				day.loads = setLoads(day);

				return day;
			});

			return timeline;
		}

		function calculatePens(day) {
			day.pens = day.pens.map(function (pen) {
				var multiply = 1;
				if (pen.multiply) {
					multiply = pen.multiply;
				}

				pen.total_dm = pen.use_pen_feed_intake ? pen.number_of_animals * pen.feed_intake * multiply : pen.number_of_animals * day.version.recipe_ration.amount_dm * multiply;
				if (day.version.recipe_ration.dm) {
					pen.total_as_fed = (pen.total_dm * 100) / day.version.recipe_ration.dm;
				} else {
					pen.total_as_fed = 0;
				}

				var n = 0;

				if (pen.pen_feeding.morning_feeding) {
					n++;
				}

				if (pen.pen_feeding.noon_feeding) {
					n++;
				}

				if (pen.pen_feeding.evening_feeding) {
					n++;
				}

				var per_feeding = pen.total_as_fed / n;
				if (isNaN(per_feeding)) {
					per_feeding = 1;
				}

				if (pen.pen_feeding.morning_feeding) {
					pen.morning_feeding = per_feeding;
				}

				if (pen.pen_feeding.noon_feeding) {
					pen.noon_feeding = per_feeding;
				}

				if (pen.pen_feeding.evening_feeding) {
					pen.evening_feeding = per_feeding;
				}

				return pen;
			});
			return day.pens;
		}

		function setSummary(day) {
			var summary = {
				number_of_animals: 0,
				total_dm: 0,
				total_as_fed: 0,
				morning: 0,
				noon: 0,
				evening: 0
			};

			day.pens.forEach(function (pen) {
				summary.number_of_animals += pen.number_of_animals;
				summary.total_dm += pen.total_dm;
				summary.total_as_fed += pen.total_as_fed;
				summary.morning += pen.morning_feeding ? pen.morning_feeding : 0;
				summary.noon += pen.noon_feeding ? pen.noon_feeding : 0;
				summary.evening += pen.evening_feeding ? pen.evening_feeding : 0;
			});

			return summary;
		}

		function setLoads(day) {
			var loads = {
				morning: {
					total: day.summary.morning,
					loads: []
				},
				noon: {
					total: day.summary.noon,
					loads: []
				},
				evening: {
					total: day.summary.evening,
					loads: []
				}
			};

			if (day.summary.morning) {
				var amount = day.summary.morning;

				var existing_load_management = day.version.load_management.find(function (lm) {
					return lm.load_subject_order_number == 1;
				});
				if (existing_load_management) {
					var min = existing_load_management.amount - 2;
					var max = existing_load_management.amount + 2;

					if (amount && min < amount && max > amount) {
						loads.morning.loads = getPredefinedLoads(existing_load_management, day.version);
					} else {
						loads.morning.loads = getLoads(amount, day.version);
					}
				} else {
					loads.morning.loads = getLoads(amount, day.version);
				}
			}
			if (day.summary.noon) {
				var amount = day.summary.noon;

				var existing_load_management = day.version.load_management.find(function (lm) {
					return lm.load_subject_order_number == 2;
				});
				if (existing_load_management) {
					var min = existing_load_management.amount - 2;
					var max = existing_load_management.amount + 2;

					if (amount && min < amount && max > amount) {
						loads.noon.loads = getPredefinedLoads(existing_load_management, day.version);
					} else {
						loads.noon.loads = getLoads(amount, day.version);
					}
				} else {
					loads.noon.loads = getLoads(amount, day.version);
				}
			}

			if (day.summary.evening) {
				var amount = day.summary.evening;

				var existing_load_management = day.version.load_management.find(function (lm) {
					return lm.load_subject_order_number == 3;
				});
				if (existing_load_management) {
					var min = existing_load_management.amount - 2;
					var max = existing_load_management.amount + 2;

					if (amount && min < amount && max > amount) {
						loads.evening.loads = getPredefinedLoads(existing_load_management, day.version);
					} else {
						loads.evening.loads = getLoads(amount, day.version);
					}
				} else {
					loads.evening.loads = getLoads(amount, day.version);
				}
			}

			return loads;
		}

		function getPredefinedLoads(existing_load_management, recipe) {
			existing_load_management.load_details = $filter('orderBy')(existing_load_management.load_details, 'position');
			var loads = [];

			existing_load_management.load_details.forEach(function (load) {
				var mixer_wagon = recipe.mixer_wagons.find(function (wagon) {
					return wagon.id == load.mixer_wagon_id;
				});

				var l = {
					value: load.amount,
					wagon: mixer_wagon ? mixer_wagon : null
				};

				loads.push(l);
			});

			return loads;
		}

		function getLoads(amount, recipe) {
			var mixer_wagon = recipe.mixer_wagons.find(function (mw) {
				return mw.position === 0;
			});

			if (mixer_wagon) {
				mixer_wagon.value = mixer_wagon.weight * 1000;
				var loads = [];
				var count = 0;
				while (amount > mixer_wagon.value && count < 9) {
					loads.push({
						value: mixer_wagon.value,
						wagon: mixer_wagon
					});
					amount = amount - mixer_wagon.value;
					count++;
				}
				loads = $filter('orderBy')(loads, 'value', true);
				if (amount > 0) {
					var load = {
						value: amount,
						wagon: mixer_wagon
					};
					loads.push(load);
				}
			}
			return loads;
		}
	}
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('Spartan.theme.components')
	  .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
	angular.extend(toastrConfig, {
	  closeButton: true,
	  closeHtml: '<button>&times;</button>',
	  timeOut: 5000,
	  autoDismiss: false,
	  containerId: 'toast-container',
	  maxOpened: 0,
	  newestOnTop: true,
	  positionClass: 'toast-top-right',
	  preventDuplicates: false,
	  preventOpenDuplicates: false,
	  target: 'body'
	});
  }
})();

/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('Spartan.theme')
	  .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
	return {
	  link: function (scope, element) {
		$timeout(function () {
		  var newValue = element.attr('new-value');
		  var oldvalue = parseInt(element.html());

		  function changeValue(val) {
			$timeout(function () {
			  element.html(val);
			}, 30);
		  }

		  if (newValue > oldvalue) {
			for (var i = oldvalue; i <= newValue; i++) {
			  changeValue(i);
			}
		  } else {
			for (var j = oldvalue; j >= newValue; j--) {
			  changeValue(j);
			}
		  }
		  $timeout(function () {
			element.next().find('i').addClass('show-arr');
		  }, 500);
		}, 3500);
	  }
	};
  }

})();

/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('Spartan.theme')
	  .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
	return {
	  restrict: 'A',
	  link: function ($scope, elem) {
		elem.bind('keydown', function ($event) {
		  var element = $event.target;
		  $(element).height(0);
		  var height = $(element)[0].scrollHeight;
		  height = (height < 16) ? 16 : height;
		  $(element).height(height);
		});

		// Expand the textarea as soon as it is added to the DOM
		setTimeout(function () {
		  var element = elem;
		  $(element).height(0);
		  var height = $(element)[0].scrollHeight;
		  height = (height < 16) ? 16 : height;
		  $(element).height(height);
		}, 0)
	  }
	};
  }

})();

(function () {
  'use strict';

  angular.module('Spartan.theme')
	  .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
	return {
	  link: function (scope, element, attrs) {
		var model = $parse(attrs.autoFocus);
		scope.$watch(model, function (value) {
		  if (value === true) {
			$timeout(function () {
			  element[0].focus();
			  element[0].select();
			});
		  }
		});
		element.bind('blur', function () {
		  scope.$apply(model.assign(scope, false));
		});
	  }
	};
  }

})();

(function () {
    'use strict';
    angular.module('Spartan.theme').directive('elementLoaded', loaded);

    /** @ngInject */
    function loaded($parse) {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                elem.ready(function () {
                    scope.$apply(function () {
                        var func = $parse(attrs.elementLoaded);
                        func(scope);
                    })
                })
            }
        }
    }
})();
(function () {
	'use strict';

	angular.module('Spartan.theme').directive('formatInputValue', formatInputValue);

	/** @ngInject */
	function formatInputValue(unitConversionService, bugsnagService) {
		return {
			restrict: 'A',
			require: 'ngModel',
			scope: {
				attribute: '@formatInputValue',
				returnValue: '=defaultReturnValue',
				dm: '=formatValueDm'
			},
			link: function (scope, elem, attrs, model) {
				model.$formatters.push(function (value) {
					try {
						var defaultValue = 0;
						if (scope.returnValue !== undefined) {
							try {
								defaultValue = JSON.parse(scope.returnValue);
							} catch (error) {
								defaultValue = scope.returnValue;
							}
						}
						var formattedValue = unitConversionService.convertData(
							value,
							['percentToAmount:' + scope.attribute, 'kgToLb:' + scope.attribute, 'mcalToMjoule:' + scope.attribute, 'amountToProduct:' + scope.attribute, 'getSignificant:' + scope.attribute, 'roundValues:' + scope.attribute],
							1,
							scope.dm
						);
						if (formattedValue && Number.isFinite(formattedValue)) {
							return formattedValue;
						}
						if (Number.isFinite(defaultValue) || defaultValue === null) {
							return defaultValue;
						}
						return null;
					} catch (error) {
						console.error(error);
						bugsnagService.logMessage('Error occured while trying to bind formatted data into view', error);
						return value;
					}
				});

				model.$parsers.push(function (value) {
					try {
						return unitConversionService.convertData(value, ['productToAmount:' + scope.attribute, 'lbToKg:' + scope.attribute, 'mjouleToMcal:' + scope.attribute, 'amountToPercent:' + scope.attribute], 1, scope.dm);
					} catch (error) {
						console.error(error);
						bugsnagService.logMessage('Error occured while trying to bind changed data into model', error);
						return value;
					}
				});
			}
		};
	}
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Spartan.theme')
	  .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
	return {
	  restrict: 'AE',
	  templateUrl: function(ele, attrs) {
		return attrs.includeWithScope;
	  }
	};
  }

})();

(function () {
  'use strict';

  angular.module('Spartan.theme')
	  .directive('infiniteScroll', scroll);

  /** @ngInject */
  function scroll($timeout) {
	return {
	  restrict: 'A',
	  scope: {
		  pagination: '&scrollFn',
		  noOfAll: '=scrollNoAll',
		  noOfDisplayed: '=scrollNoDisplayed',
		  scrollDisable: '=scrollDisable'
		},
	  link: {
		pre: function(scope, elem, attrs) {
			var raw = elem[0]
			var timeout
			  angular.element(elem).bind('scroll', function () {
				if (timeout) {
					$timeout.cancel(timeout);
				}
				timeout = $timeout(function () {
					if (!scope.scrollDisable) {
						if (raw.scrollTop >= (raw.scrollHeight - raw.offsetHeight)*0.95 ) {
							if (scope.noOfDisplayed < scope.noOfAll) {
								scope.pagination();
							}
						}
					}
				}, 100)
			  })
		}
	  }
	};
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('Spartan.theme')
	.directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
	return {
	  restrict: 'EA',
	  template: '<div></div>',
	  replace: true,
	  scope: {
		min: '=',
		max: '=',
		type: '@',
		prefix: '@',
		maxPostfix: '@',
		prettify: '=',
		prettifySeparator: '@',
		grid: '=',
		gridMargin: '@',
		postfix: '@',
		step: '@',
		hideMinMax: '@',
		hideFromTo: '@',
		from: '=',
		to: '=',
		disable: '=',
		onChange: '=',
		onFinish: '=',
		values: '=',
		timeout: '@'
	  },
	  link: function ($scope, $element) {
			$element.ionRangeSlider({
			  min: $scope.min,
			  max: $scope.max,
			  type: $scope.type,
			  prefix: $scope.prefix,
			  maxPostfix: $scope.maxPostfix,
			  prettify_enabled: $scope.prettify,
			  prettify_separator: $scope.prettifySeparator,
			  grid: $scope.grid,
			  gridMargin: $scope.gridMargin,
			  postfix: $scope.postfix,
			  step: $scope.step,
			  hideMinMax: $scope.hideMinMax,
			  hideFromTo: $scope.hideFromTo,
			  from: $scope.from,
			  to: $scope.to,
			  disable: $scope.disable,
			  onChange: $scope.onChange,
			  onFinish: $scope.onFinish,
			  values: $scope.values
			});

			$scope.$watch('min', function (value) {
			  $timeout(function () {
				$element.data("ionRangeSlider").update({min: value});
			  });
			}, true);
			$scope.$watch('max', function (value) {
			  $timeout(function () {
				$element.data("ionRangeSlider").update({max: value});
			  });
			});
			$scope.$watch('from', function (value) {
			  $timeout(function () {
				$element.data("ionRangeSlider").update({from: value});
			  });
			});
			$scope.$watch('to', function (value) {
			  $timeout(function () {
				$element.data("ionRangeSlider").update({to: value});
			  });
			});
			$scope.$watch('disable', function (value) {
			  $timeout(function () {
				$element.data("ionRangeSlider").update({disable: value});
			  });
			});
	  }
	};
  }

})();

(function () {
  'use strict';

  angular.module('Spartan.theme')
	  .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
	return {
	  link: function ($scope, el) {
		el.bind('change', function (e) {
		  $scope.file = (e.srcElement || e.target).files[0];
		  $scope.getFile();
		})
	  }
	}
  }

})();

(function () {
    'use strict';
  
    angular.module('Spartan.theme')
        .directive('summaryRecipeDetails', summaryRecipeDetails);
  
    /** @ngInject */
    function summaryRecipeDetails() {
      return {
        restrict: 'AE',
        scope: {
            day: '=',
            currency: '=',
            weight: '=',
            recipe: '='
        }, 
        templateUrl: function(ele, attrs) {
          return attrs.summaryRecipeDetails;
        }
      };
    }
  
  })();
  
(function () {
  'use strict';

  angular.module('Spartan.theme')
	  .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
	return {
	  scope: {
		scrollPosition: '=',
		maxHeight: '='
	  },
	  link: function (scope) {
		$(window).on('scroll', function() {
		  var scrollTop = $(window).scrollTop() > scope.maxHeight;
		  if (scrollTop !== scope.prevScrollTop) {
			scope.$apply(function() {
			  scope.scrollPosition = scrollTop;
			});
		  }
		  scope.prevScrollTop = scrollTop;
		});
	  }
	};
  }

})();

angular.module('Spartan').directive('selectOnClick', function ($timeout) {
	return {
		restrict: 'A',
		link: function (scope, element, attrs) {
			var focusedElement = null;

			element.on('focus', function () {
				var self = this;
				if (focusedElement != self) {
					focusedElement = self;
					$timeout(function () {
						self.select();
					}, 10);
				}
			});

			element.on('blur', function () {
				focusedElement = null;
			});
	}

  }

});

(function () {
	'use strict';
	angular.module('Spartan.theme').directive('penTimeValidator', penTimeValidator);

	/** @ngInject */
	function penTimeValidator() {
		return {
			restrict: 'A',
			require: 'ngModel',
			scope: {
				rule: '=timeValidatorModel'
			},
			link: {
				pre: function (scope, elem, attrs, ngModel) {
					var rule = scope.rule;

					scope.$on('time_validators', function () {
						ngModel.$validate();
					})

					ngModel.$validators.timeValidators = function () {
						var numberOfSelected = rule.selected_number_of_feedings.value;
						if (numberOfSelected === 1) {
							return true;
						}

						if (numberOfSelected === 2) {
							if (rule.feeding_period_1 && rule.feeding_period_2 && rule.feeding_period_1.value === rule.feeding_period_2.value) {
								return false;
							}
							return true;
						}

						var period;
						var firstHelper;
						var secondHelper;
						if (ngModel.$name === 'feeding_period_1_' + rule.id) {
							period = 'feeding_period_1';
							firstHelper = 'feeding_period_2';
							secondHelper = 'feeding_period_3';
						} else if (ngModel.$name === 'feeding_period_2_' + rule.id) {
							period = 'feeding_period_2';
							firstHelper = 'feeding_period_1';
							secondHelper = 'feeding_period_3';
						} else {
							period = 'feeding_period_3';
							firstHelper = 'feeding_period_1';
							secondHelper = 'feeding_period_2';
						}
						if (rule[period]) {
							if ((rule[firstHelper] && rule[period].value === rule[firstHelper].value) || (rule[secondHelper] && rule[period].value === rule[secondHelper].value)) {
								return false;
							}
						}
						return true;
					}
				}
			}
		}
	}
})();
(function () {
  'use strict';

  angular.module('Spartan.theme')
	  .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
	return {
	  scope: {
		trackWidth: '=',
		minWidth: '=',
	  },
	  link: function (scope, element) {
		scope.trackWidth = $(element).width() < scope.minWidth;
		scope.prevTrackWidth = scope.trackWidth;

		$(window).resize(function() {
		  var trackWidth = $(element).width() < scope.minWidth;
		  if (trackWidth !== scope.prevTrackWidth) {
			scope.$apply(function() {
			  scope.trackWidth = trackWidth;
			});
		  }
		  scope.prevTrackWidth = trackWidth;
		});
	  }
	};
  }

})();

/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('Spartan.theme')
	  .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
	return {
	  restrict: 'A',
	  link: function ($scope, elem) {
		var delay = 1000;

		if ($rootScope.$pageFinishedLoading) {
		  delay = 100;
		}

		$timeout(function () {
		  elem.removeClass('full-invisible');
		  elem.addClass('animated zoomIn');
		}, delay);
	  }
	};
  }

})();

(function () {
    'use strict';

    angular.module('Spartan.theme')
        .filter('feedTypeFilter', feedTypeFilter);

    /** @ngInject */
    function feedTypeFilter() {
        return function (types, calcType) {
            var arr = [];
            for (var i = 0; i < types.length; i++) {
                if (types[i].type == calcType || types[i].type == 2) {
                    arr.push(types[i]);
                }
            }
            return arr;
        };
    }

})();
(function () {
    'use strict';

    angular.module('Spartan.theme')
        .filter('time', time);

    /** @ngInject */
    function time($locale) {
        // Language-specific time unit abbreviations
        var timeAbbreviations = {
            'de': { h: 'h', m: 'm', s: 's' },      // German
            'en': { h: 'h', m: 'm', s: 's' },      // English
            'cs': { h: 'h', m: 'm', s: 's' },      // Czech
            'es': { h: 'h', m: 'm', s: 's' },      // Spanish
            'it': { h: 'h', m: 'm', s: 's' },      // Italian
            'nl': { h: 'h', m: 'm', s: 's' },      // Dutch
            'pl': { h: 'godz.', m: 'min', s: 's' },    // Polish
            'pt': { h: 'h', m: 'm', s: 's' },      // Portuguese
            'sr': { h: 'č', m: 'm', s: 's' }       // Serbian (čas, minut, sekund)
        };

        var notSetTranslations = {
            'de': 'Nicht festgelegt',
            'en': 'Not set',
            'cs': 'Nenastaveno',
            'es': 'No establecido',
            'it': 'Non impostato',
            'nl': 'Niet ingesteld',
            'pl': 'Nie ustawiono',
            'pt': 'Nao definido',
            'sr': 'Nije podeseno'
        };

        return function(seconds) {
            // Extract language code from $locale.id (e.g., 'de-de' -> 'de')
            var langCode = ($locale.id || 'en').split('-')[0].toLowerCase();

            if (seconds === undefined || seconds === null) {
                return notSetTranslations[langCode] || notSetTranslations['en'];
            }

            var abbr = timeAbbreviations[langCode] || timeAbbreviations['en'];

            var totalSeconds = Math.floor(seconds);
            var hours = Math.floor(totalSeconds / 3600);
            var minutes = Math.floor((totalSeconds % 3600) / 60);
            var secs = totalSeconds % 60;

            var parts = [];
            if (hours > 0) {
                parts.push(hours + abbr.h);
            }
            if (minutes > 0) {
                parts.push(minutes + abbr.m);
            }
            if (secs > 0 || parts.length === 0) {
                parts.push(secs + abbr.s);
            }

            return parts.join(' ');
        };
    }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
	'use strict';

	angular.module('Spartan.theme')
		.factory('baProgressModal', baProgressModal);

	/** @ngInject */
	function baProgressModal($uibModal) {
		var methods = {};
		var progress = 0;
		var max = 100;
		var opened = false;

		return {
			setProgress: function (value) {
				if (value > max) {
					throw Error('Progress can\'t be greater than max');
				}
				progress = value;
			},
			getProgress: function () {
				return progress;
			},
			open: function() {
				if (!opened) {
					methods = $uibModal.open({
						animation: true,
						templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
						size: 'sm',
						keyboard: false,
						backdrop: 'static'
					});
					opened = true;
				} else {
					throw Error('Progress modal opened now');
				}

			},
			close: function() {
				if (opened) {
					methods.close();
					opened = false;
				} else {
					throw Error('Progress modal is not active');
				}

			}
		};
	}

})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('Spartan.theme')
	  .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

	this.isDescendant = function(parent, child) {
	  var node = child.parentNode;
	  while (node != null) {
		if (node == parent) {
		  return true;
		}
		node = node.parentNode;
	  }
	  return false;
	};

	this.hexToRGB = function(hex, alpha) {
	  var r = parseInt( hex.slice(1,3), 16 );
	  var g = parseInt( hex.slice(3,5), 16 );
	  var b = parseInt( hex.slice(5,7), 16 );
	  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
	};

	this.hasAttr = function (elem, attrName) {
	  var attr = $(elem).attr(attrName);
	  return (typeof attr !== typeof undefined && attr !== false);
	}
  }
})();

(function () {
	'use strict';
	angular.module('Spartan.theme').provider('bugsnagService', bugsnagService);

	/** @ngInject */
	function bugsnagService() {
		var bugsnagClient;
		var jwtHelper;
		var constants;
		var testEnv = false;

		this.load = load;

		this.$get = function ($injector) {
			if (!jwtHelper) {
				jwtHelper = $injector.get('jwtHelper');
			}
			if (!constants) {
				constants = $injector.get('APP_CONST');
			}
			return {
				logMessage: logMessage,
				logError: logError,
				logTimingError: logTimingError,
				logUnhandledError: logUnhandledError
			};
		};

		function load(host, APP_CONST) {
			var h = testEnv ? 'test' : 'mmmooogle.com';
			var rs = testEnv ? 'Test' : APP_CONST.environment;
			if (host.includes(h)) {
				try {
					bugsnagClient = bugsnag({
						apiKey: 'a143928bab5b5d439e0b1d4a5bb786a2',
						releaseStage: rs
					});
					console.log('Bugsnag is loaded');
				} catch (e) {
					console.log('Bugsnag failed to load');
					console.error(e);
				}
			}
		}

		function logMessage(message, error, severityOverride) {
			try {
				if (bugsnagClient) {
					bugsnagClient.notify(message, {
						beforeSend: function (report) {
							report.errorClass = constants && constants.environment ? constants.environment + ' - Custom message log' : 'Custom message log';
							report.groupingHash = report.errorClass;
							Object.assign(report, setErrorBody(report, error, false));
							report.request.errorMessage = message;
							report.request.error = error || null;
						},
						severity: severityOverride ? severityOverride : 'info'
					});
					return true;
				}
			} catch (e) {
				console.error(e);
				return false;
			}
		}

		function logError(error) {
			try {
				if (bugsnagClient) {
					bugsnagClient.notify(new Error(error), {
						beforeSend: function (report) {
							report.errorClass = setHTTPErrorClass(error);
							report.groupingHash = report.errorClass;
							Object.assign(report, setErrorBody(report, error, true));
						},
						severity: setSeverity(error)
					});
					return true;
				}
			} catch (e) {
				console.error(e);
				return false;
			}
		}

		function logTimingError(error, timing) {
			try {
				if (bugsnagClient) {
					bugsnagClient.notify('The server took too long to resolve the request!', {
						beforeSend: function (report) {
							report.errorClass = constants && constants.environment ? constants.environment + ' - Response too long' : 'Response too long';
							report.groupingHash = report.errorClass;
							Object.assign(report, setErrorBody(report, error, false, timing));
						},
						severity: 'info'
					});
					return true;
				}
			} catch (e) {
				console.error(e);
				return false;
			}
		}

		function logUnhandledError(error) {
			try {
				if (bugsnagClient) {
					bugsnagClient.notify(new Error(error), {
						beforeSend: function (report) {
							report.errorClass = constants && constants.environment ? constants.environment + ' - Unhandled exception log' : 'Unhandled exception log';
							report.groupingHash = report.errorClass;
							Object.assign(report, setErrorBody(report, error, false));
						},
						severity: setSeverity(error)
					});
					return true;
				}
			} catch (e) {
				console.error(e);
				return false;
			}
		}

		function setErrorBody(report, error, fullLog, timing) {
			try {
				if (fullLog) {
					return {
						errorMessage: setMessage(error),
						breadcrumbs: removeBreadcrumbs(report.breadcrumbs),
						request: {
							status: error.status ? error.status : error.data && error.data.status ? error.data.status : 'HTTP status not available',
							error: error.data && error.data.error ? error.data.error : 'Error not available',
							path: error.data && error.data.path ? error.data.path : 'Path not available',
							message: setMessage(error),
							method: error.config && error.config.method ? error.config.method : 'HTTP method not available',
							url: setUrl(error)
						},
						user: {
							clientId: setClientId()
						}
					};
				} else {
					return {
						breadcrumbs: removeBreadcrumbs(report.breadcrumbs),
						request: {
							timing: timing != null ? timing : null
						},
						user: {
							clientId: setClientId()
						}
					};
				}
			} catch (e) {
				console.error(e);
				return null;
			}

			function setMessage(error) {
				try {
					if (error.data) {
						if (error.data.message != null && error.data.message != '') {
							return error.data.message;
						} else if (error.data.error != null && error.data.error != '') {
							return error.data.error;
						} else if (error.data.Message != null && error.data.Message != '') {
							return error.data.ExceptionMessage;
						} else {
							return 'Error message not available';
						}
					} else {
						return 'Error message not available';
					}
				} catch (e) {
					console.error(e);
					return 'Error message not available';
				}
			}
		}

		function setUrl(error) {
			try {
				var url = error.config && error.config.url ? error.config.url : undefined;
				if (url) {
					if (url.includes('userSettings')) {
						return url.split('?email')[0] ? url.split('?email')[0] : 'userSettings';
					} else {
						return url;
					}
				} else {
					return 'Url not available';
				}
			} catch (e) {
				console.error(e);
				return 'Url not available';
			}
		}

		function setClientId() {
			try {
				var token = localStorage.getItem('id_token');
				if (token) {
					var payload = jwtHelper.decodeToken(token);
					return payload.sub;
				} else {
					return 'User id not available';
				}
			} catch (e) {
				console.error(e);
				return 'User id not available';
			}
		}

		function setSeverity(error) {
			try {
				if (constants.environment === 'Feed production') {
					if (error.status === 401 || error.status === 403 || error.status === -1) {
						return 'info';
					}
					if (error.data && error.data.path && error.data.path.includes('insights')) {
						return 'info';
					}
					if (error.data && error.data.path && error.data.path.includes('robot-view')) {
						return 'info';
					}
					if (error.data && error.config.url && error.config.url.includes('tabvis')) {
						return 'info';
					}
					return 'warning';
				}
				return 'info';
			} catch (e) {
				console.error(e);
				return 'info';
			}
		}

		function setHTTPErrorClass(error) {
			try {
				var status = error.status || 'N/A';
				var url = trimUrl(setUrl(error));
				return constants && constants.environment ? constants.environment + ' - HTTP error log - ' + status + ' ' + url : 'HTTP error log - ' + status + ' ' + url;
			} catch (e) {
				console.error(e);
				return 'HTTP error log not available';
			}

			function trimUrl(url) {
				try {
					var firstpart = url.split('Spartan');
					if (firstpart[1]) {
						var secondPart = firstpart[1].split('?');
						return secondPart[0] || firstpart[1];
					}
					return url;
				} catch (error) {
					console.error(e);
					return url;
				}
			}
		}

		function removeBreadcrumbs(breadcrumbs) {
			try {
				for (var i = 0; i < breadcrumbs.length; i++) {
					if (breadcrumbs[i].type === 'request') {
						if (breadcrumbs[i].metaData && breadcrumbs[i].metaData.request && breadcrumbs[i].metaData.request.includes('email')) {
							breadcrumbs[i].metaData.request = 'Redacted due to sensitive user info';
						}
					}
					if (breadcrumbs[i].type === 'log') {
						if (breadcrumbs[i].metaData && breadcrumbs[i].metaData['[0]'] && breadcrumbs[i].metaData['[0]'].includes('Bearer')) {
							breadcrumbs[i].metaData['[0]'] = 'Redacted due to sensitive user info';
						}
					}
				}
			} catch (e) {
				console.error(e);
			}
			return breadcrumbs;
		}
	}
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Spartan.theme')
	  .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
	var onLoad = function(reader, deferred, scope) {
	  return function () {
		scope.$apply(function () {
		  deferred.resolve(reader.result);
		});
	  };
	};

	var onError = function (reader, deferred, scope) {
	  return function () {
		scope.$apply(function () {
		  deferred.reject(reader.result);
		});
	  };
	};

	var onProgress = function(reader, scope) {
	  return function (event) {
		scope.$broadcast('fileProgress',
			{
			  total: event.total,
			  loaded: event.loaded
			});
	  };
	};

	var getReader = function(deferred, scope) {
	  var reader = new FileReader();
	  reader.onload = onLoad(reader, deferred, scope);
	  reader.onerror = onError(reader, deferred, scope);
	  reader.onprogress = onProgress(reader, scope);
	  return reader;
	};

	var readAsDataURL = function (file, scope) {
	  var deferred = $q.defer();

	  var reader = getReader(deferred, scope);
	  reader.readAsDataURL(file);

	  return deferred.promise;
	};

	return {
	  readAsDataUrl: readAsDataURL
	};
  }
})();

(function () {
	'use strict';
	angular
		.module('Spartan.theme')
		.service('formatViewValuesService', formatViewValuesService)
		.filter('formatViewValues', formatViewValues)
		.filter('formatViewValuesPerDay', formatViewValuesPerDay)
		.filter('formatViewValuesSignificant', formatViewValuesSignificant)
		.filter('significantNumber', significantNumber)
		.filter('defaultReturnValue', defaultReturnValue);

	/** @ngInject */
	function formatViewValuesService(unitConversionService, $filter, bugsnagService, $timeout, toastr) {
		var timeout;
		var timeoutType;

		this.format = function (data, type, configEnum, dm) {
			try {
				var numberOfDecimals = 0;
				var config = unitConversionService.setConfiguration(configEnum, type);
				if (config) {
					if (config.number_of_decimals) {
						var settings = JSON.parse(localStorage.getItem('user_settings'));
						if (settings.use_percent) {
							numberOfDecimals = config.number_of_decimals.percentage;
						} else {
							numberOfDecimals = config.number_of_decimals.amount;
						}
					}
				} else {
					console.error('Invalid type: ', type);
					if (timeoutType) {
						$timeout.cancel(timeoutType);
					}
					timeoutType = $timeout(function () {
						bugsnagService.logMessage('Invalid type: ' + type);
					}, 50);
					return $filter('number')(formattedValue, 2);
				}
				var formattedValue = unitConversionService.convertData(data, ['percentToAmount:' + type, 'kgToLb:' + type, 'amountToProduct:' + type, 'mcalToMjoule:' + type, 'getSignificant:' + type, 'roundValues:' + type], configEnum, dm);
				if (Number.isFinite(formattedValue)) {
					if (config.use_significant) {
						return $filter('significantNumber')(formattedValue);
					} else {
						return $filter('number')(formattedValue, numberOfDecimals);
					}
				} else {
					return formattedValue;
				}
			} catch (error) {
				if (timeout) {
					$timeout.cancel(timeout);
				}
				timeout = $timeout(function () {
					toastr.warning($filter('i18n')('_error_occurred_while_converting_values_'), $filter('i18n')('_title_warning_'));
					if (error.name === 'Error') {
						bugsnagService.logMessage(error.message + ', Type: ' + type + ', Value: ' + data, error.cause);
					} else {
						bugsnagService.logMessage('Error occured while trying to format data, Type: ' + type + ', Value: ' + data, error);
					}
				}, 50);
				if (Number.isFinite(data)) {
					return $filter('number')(data, 3);
				} else {
					return data;
				}
			}
		};
	}

	/** @ngInject */
	function formatViewValues(formatViewValuesService) {
		return function (data, type, dm) {
			return formatViewValuesService.format(data, type, 1, dm);
		};
	}

	/** @ngInject */
	function formatViewValuesPerDay(formatViewValuesService) {
		return function (data, type, dm) {
			return formatViewValuesService.format(data, type, 2, dm);
		};
	}

	/** @ngInject */
	function formatViewValuesSignificant(formatViewValuesService) {
		return function (data, type, dm) {
			return formatViewValuesService.format(data, type, 3, dm);
		};
	}

	/** @ngInject */
	function significantNumber($filter, bugsnagService, $timeout) {
		var timeout;

		return function (data) {
			try {
				var value = data.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 20, useGrouping: false });
				var dataArr = value.toString().split('.');
				if (dataArr[1]) {
					return $filter('number')(value, dataArr[1].length);
				} else {
					return $filter('number')(data, 3);
				}
			} catch (error) {
				if (timeout) {
					$timeout.cancel(timeout);
				}
				timeout = $timeout(function () {
					bugsnagService.logMessage('Error occured while calculating significant digits, Value: ' + data, error);
				}, 50);
				return $filter('number')(data, 3);
			}
		};
	}

	/** @ngInject */
	function defaultReturnValue(bugsnagService, $timeout) {
		var timeout;

		return function (data, returnValue) {
			try {
				var parsed = data.replace(',', '.');
				parsed = Number.parseFloat(parsed);
			} catch (error) {
				if (timeout) {
					$timeout.cancel(timeout);
				}
				timeout = $timeout(function () {
					bugsnagService.logMessage('Error occured while parsing data for default return value, Value: ' + data + ' ,Return Value: ' + returnValue, error);
				}, 50);
			}
			if (parsed) {
				return data;
			}
			if (returnValue !== undefined) {
				return returnValue;
			}
			return data;
		};
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.theme').service('preloader', preloader);

	/** @ngInject */
	function preloader($q, uaParser, $interval, tmhDynamicLocale, localize, authService, authManager, cookiesService, $rootScope, auth0Service) {
		var deviceType = uaParser.getDevice('type');

		return {
			loadImg: loadImg,
			setViewport: setViewport,
			setLanguage: setLanguage,
			getUserAccess: getUserAccess
		};

		function loadImg(src) {
			var d = $q.defer();
			var img = new Image();
			img.src = src;
			img.onload = function () {
				d.resolve();
			};
			return d.promise;
		}

		function setViewport() {
			var d = $q.defer();
			var viewport = document.getElementById('viewport_tag');
			var interval = $interval(
				function () {
					if (viewport) {
						try {
							if (deviceType) {
								if (deviceType === 'mobile') {
									viewport.setAttribute('content', 'width=device-width, initial-scale=0.5, minimum-scale=0.5, maximum-scale=1.1');
								} else if (deviceType === 'tablet') {
									viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.3');
								} else {
									viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
								}
							} else {
								viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
							}
							d.resolve();
						} catch (error) {
							d.reject();
							console.log(error);
						}
						$interval.cancel(interval);
					}
				},
				100,
				15
			);
			return d.promise;
		}

		function setLanguage() {
			var d = $q.defer();
			try {
				var settings = JSON.parse(localStorage.getItem('user_settings'));
				if (settings) {
					tmhDynamicLocale.set(settings.language);
					localize
						.setLanguage(settings.language)
						.then(function () {
							d.resolve();
						})
						.catch(function () {
							d.resolve();
						});
				} else {
					tmhDynamicLocale.set('en-gb');
					localize
						.setLanguage('en-gb')
						.then(function () {
							d.resolve();
						})
						.catch(function () {
							d.resolve();
						});
				}
			} catch (error) {
				tmhDynamicLocale.set('en-gb');
				localize
					.setLanguage('en-gb')
					.then(function () {
						d.resolve();
					})
					.catch(function () {
						d.resolve();
					});
			}
			return d.promise;
		}

		function getUserAccess() {
			var d = $q.defer();
			checkAccess();
			return d.promise;

			function checkAccess() {
				var id_token = localStorage.getItem('id_token');
				var user_settings = JSON.parse(localStorage.getItem('user_settings'));

				if (id_token && user_settings) {
					return authService
						.getUserTeamAccess()
						.then(function (response) {
							var teams = response;
							var teamsWithAccess = [];
							for (var i = 0; i < teams.length; i++) {
								if (authService.haveFeedAccess(teams[i].AccessControls)) {
									var team = {
										id: teams[i].TeamId,
										accessControls: teams[i].AccessControls
									};
									teamsWithAccess.push(team);
								}
							}
							authService.teams = teamsWithAccess;
							if (teamsWithAccess.length > 0) {
								authorize(teamsWithAccess, user_settings);
							} else {
								auth0Service.handleUnauthorized(200);
								d.resolve();
							}
						})
						.catch(function (error) {
							auth0Service.handleUnauthorized(200);
							d.resolve();
						});
				} else {
					d.resolve();
				}
			}

			function authorize(teams, user_settings) {
				var found = false;
				for (var i = 0; i < teams.length; i++) {
					if (user_settings.selectedTeam.id == teams[i].id) {
						cookiesService.setCookie('mmmooogle_tenant', user_settings.selectedTeam.id, {
							samesite: "lax",
							secure: true,
							domain: ".mmmooogle.com"
						})
						found = true;
					}
				}
				if (!found) {
					user_settings.team_id = teams[0].id;
					user_settings.selectedTeam.id = teams[0].id;
					user_settings.herd_id = null;
					user_settings.selectedHerd.id = null;
					user_settings.noSelectedTeam = true;
					cookiesService.setCookie('mmmooogle_tenant', user_settings.selectedTeam.id, {
						samesite: "lax",
						secure: true,
						domain: ".mmmooogle.com"
					})
					localStorage.setItem('user_settings', JSON.stringify(user_settings));
					tmhDynamicLocale.set(user_settings.language);
					localize.setLanguage(user_settings.language);
					d.resolve();
				} else {
					if (user_settings.selectedHerd.id) {
						var u_s = angular.copy(user_settings);
						u_s.herd_id = null;
						u_s.selectedHerd.id = null;
						localStorage.setItem('user_settings', JSON.stringify(u_s));
						checkHerdAccess(user_settings);
					} else {
						localStorage.setItem('user_settings', JSON.stringify(user_settings));
						tmhDynamicLocale.set(user_settings.language);
						localize.setLanguage(user_settings.language);
						d.resolve();
					}
				}
			}

			function checkHerdAccess(userSettings) {
				return authService
					.getUserTeamHerdAccess(userSettings.selectedHerd.id)
					.then(function (response) {
						var found = false;
						for (var i = 0; i < response.length; i++) {
							if (response[i].HerdId == userSettings.selectedHerd.id && authService.haveFeedAccess(response[i].AccessControls)) {
								found = true;
								break;
							}
						}
						if (!found) {
							userSettings.herd_id = null;
							userSettings.selectedHerd.id = null;
							localStorage.setItem('user_settings', JSON.stringify(userSettings));
							tmhDynamicLocale.set(userSettings.language);
							localize.setLanguage(userSettings.language);
							d.resolve();
						} else {
							localStorage.setItem('user_settings', JSON.stringify(userSettings));
							tmhDynamicLocale.set(userSettings.language);
							localize.setLanguage(userSettings.language);
							d.resolve();
						}
					})
					.catch(function () {
						userSettings.herd_id = null;
						userSettings.selectedHerd.id = null;
						localStorage.setItem('user_settings', JSON.stringify(userSettings));
						tmhDynamicLocale.set(userSettings.language);
						localize.setLanguage(userSettings.language);
						$rootScope.$broadcast('remove_default_herd');
						d.resolve();
					});
			}
		}
	}
})();

/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('Spartan.theme')
	.service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
	return {
	  start: function (interval, calback, time) {
		function startInterval() {
		  return interval(calback, time);
		}

		var i = startInterval();

		angular.element($window).bind('focus', function () {
		  if (i) interval.cancel(i);
		  i = startInterval();
		});

		angular.element($window).bind('blur', function () {
		  if (i) interval.cancel(i);
		});
	  }
	}
  }

})();

(function () {
    'use strict';
    angular.module('Spartan.theme').factory('uaParser', uaParser);

    /** @ngInject */
    function uaParser() {
        var parser = new UAParser();
        return {
            getDevice: getDevice
        }

        function getDevice(prop) {
            // prop: { model: '', type: '', vendor: '' }
            return parser.getDevice()[prop];
        }
    }
})();
(function () {
	'use strict';
	angular.module('Spartan.pages.calendar').controller('feedingTableCtrl', feedingTableCtrl);

	/** @ngInject */
	function feedingTableCtrl($timeout, $q, $uibModal, $scope, $state, $locale, $filter, $uibModalStack, feedingTableService, unitConversionService) {
		var ft = this;
		var loadPromise;
		var i18nFilter = $filter('i18n');

		ft.selectLoadRow = selectLoadRow;
		ft.selectIngredientRow = selectIngredientRow;
		ft.selectPenRow = selectPenRow;
		ft.moveLoad = moveLoad;
		ft.updateLoad = updateLoad;
		ft.updatePen = updatePen;
		ft.openDeleteFeedingModal = openDeleteFeedingModal;
		ft.confirmDeleteFeeding = confirmDeleteFeeding;
		ft.openChangePopover = openChangePopover;
		ft.goToPage = goToPage;
		ft.updateIngredient = updateIngredient;
		ft.selectUnloadRow = selectUnloadRow;
		ft.updateUnload = updateUnload;
		ft.openAddDataModal = openAddDataModal;
		ft.updateLoadReport = updateLoadReport;
		ft.confirm = confirm;
		ft.cancel = cancel;
		ft.selectLoad = selectLoad;
		ft.updatePenReport = updatePenReport;
		ft.selectSummary = selectSummary;
		ft.changeLoadingTime = changeLoadingTime;
		ft.changeDroppingTime = changeDroppingTime;
		ft.checkDateValidation = checkDateValidation;
		ft.checkRationOrigin = checkRationOrigin;
		ft.$onInit = init;

		function init() {
			ft.dateFormat = $locale.DATETIME_FORMATS.short;
			ft.dateWithDayFormat = $locale.DATETIME_FORMATS.shortWithDay;
			ft.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			ft.settings = JSON.parse(localStorage.getItem('user_settings'));
			ft.user = JSON.parse(localStorage.getItem('user_profile'));
			if (!ft.settings.use_kgs) {
				ft.weight = 'Lb';
			} else {
				ft.weight = 'Kg';
			}
			ft.missingData = [];
			if (ft.feedingTableData.report_type === 1) {
				groupLoadingConflicts();
				$timeout(function () {
					dataCollapseLoadingFn();
				}, 2);
			} else if (ft.feedingTableData.report_type === 2) {
				groupDroppingConflicts();
				$timeout(function () {
					dataCollapseDroppingFn();
				}, 2);
			}
		}

		function selectSummary(list, prop) {
			if (ft.feedingTableData.summary[list].length > 0) {
				ft.feedingTableData.summary[prop] = !ft.feedingTableData.summary[prop];
			}
		}

		//Planning

		function confirmDeleteFeeding() {
			setDirty();
			for (var i = 0; i < ft.feedingTableData.feeding_loads.length; i++) {
				updateFeedingEvents('remove', ft.feedingTableData.feeding_loads[i].load_position);
			}
			ft.deleteFeeding({
				feeding_number: ft.feedingTableData.feeding_number
			});
		}

		function updatePen(pen, data, index, prop) {
			setDirty();
			loading(true);
			$timeout(function () {
				switch (prop) {
					case 'pen':
						pen.pen_id = pen.pen.id;
						pen.pen_name = pen.pen.pen_name;
						pen.feeding_amount = (pen.pen.number_of_animals * pen.pen.feed_intake) / (ft.feedingTableData.dm / 100);
						ft.feedingTableData.amount_sum = 0;
						break;
					case 'feeding_amount':
						ft.feedingTableData.amount_sum = 0;
						break;
					case 'remove':
						ft.feedingTableData.pen_feedings.splice(index, 1);
						break;
					case 'add':
						var firstPen = ft.feedingTableData.pens[0];
						firstPen.feeding_amount = (firstPen.number_of_animals * firstPen.feed_intake) / (ft.feedingTableData.dm / 100);
						ft.feedingTableData.pen_feedings.push({
							id: moment().valueOf(),
							pen: firstPen,
							number_of_animals: firstPen.number_of_animals,
							pen_id: firstPen.id,
							pen_name: firstPen.pen_name,
							feeding_amount: firstPen.feeding_amount
						});
						break;
					default:
						loading();
						return;
				}
				ft.feedingTableData.amount_sum = 0;
				for (var i = 0; i < ft.feedingTableData.pen_feedings.length; i++) {
					ft.feedingTableData.amount_sum += ft.feedingTableData.pen_feedings[i].feeding_amount;
				}
				recalculateLoads(ft.feedingTableData.amount_sum);
				loading();
			}, 200);
		}

		function recalculateLoads(amount) {
			for (var i = ft.feedingTableData.feeding_loads.length - 1; i >= 0; i--) {
				updateFeedingEvents('remove', ft.feedingTableData.feeding_loads[i].updateFeeding);
				ft.feedingTableData.feeding_loads.splice(i, 1);
			}
			addLoad(amount, ft.feedingTableData.wagons[0]);
		}

		function selectLoad(load) {
			for (var i = 0; i < ft.feedingTableData.feeding_loads.length; i++) {
				if (ft.feedingTableData.feeding_loads[i].load_position === load.load_position) {
					ft.feedingTableData.feeding_loads[i].expanded = !ft.feedingTableData.feeding_loads[i].expanded;
					break;
				}
			}
		}

		function updateLoad(load, data, index, prop) {
			setDirty();
			loadPromise = $q.defer();
			$timeout(function () {
				$q.all([loadPromise.promise]).then(function () {
					for (var i = 0; i < load.ingredients.length; i++) {
						load.ingredients[i].amount = load.amount * load.ingredients[i].percentage;
					}
				});
				switch (prop) {
					case 'amount':
						loadPromise.resolve();
						break;
					case 'increase':
						load.amount += data;
						loadPromise.resolve();
						break;
					case 'decrease':
						load.amount -= data;
						loadPromise.resolve();
						break;
					case 'wagon':
						load.mixer_wagon_id = data.id;
						load.mixer_wagon_name = data.name;
						loadPromise.resolve();
						break;
					case 'remove':
						load.amount = data;
						break;
					default:
						return;
				}
				if (load.amount <= 0) {
					removeLoad(load, index);
				} else if (load.amount > load.wagon.value) {
					addLoad(load.amount, load.wagon, load);
				}
				ft.feedingTableData.amount_sum = 0;
				for (var j = 0; j < ft.feedingTableData.feeding_loads.length; j++) {
					ft.feedingTableData.amount_sum += ft.feedingTableData.feeding_loads[j].amount;
				}
			}, 1);
		}

		function removeLoad(load, index) {
			if (ft.feedingTableData.feeding_loads.length == 1) {
				load.amount = 0;
			} else {
				for (var i = index; i < ft.feedingTableData.feeding_loads.length; i++) {
					ft.feedingTableData.feeding_loads[i].load_position--;
					ft.feedingTableData.feeding_loads[i].load_name = i18nFilter('_m_f_recipe_load_') + ' ' + (ft.feedingTableData.feeding_loads[i].load_position + 1);
					updateFeedingEvents('title', ft.feedingTableData.feeding_loads[i]);
				}
				ft.feedingTableData.feeding_loads.splice(index, 1);
				updateFeedingEvents('remove', load.load_position);
			}
		}

		function addLoad(amount, wagon, load) {
			if (load) {
				load.amount = wagon.value;
				amount -= load.amount;
			}
			if (ft.feedingTableData.feeding_loads.length) {
				for (var i = 0; i < ft.feedingTableData.feeding_loads.length; i++) {
					if (ft.feedingTableData.feeding_loads[i].amount < wagon.value) {
						ft.feedingTableData.feeding_loads[i].amount += amount;
						if (ft.feedingTableData.feeding_loads[i].amount > wagon.value) {
							amount = ft.feedingTableData.feeding_loads[i].amount - wagon.value;
							ft.feedingTableData.feeding_loads[i].amount = wagon.value;
						} else {
							amount = 0;
						}
						var ingList = ft.feedingTableData.feeding_loads[i].ingredients;
						for (var j = 0; j < ingList.length; j++) {
							ingList[j].amount = ft.feedingTableData.feeding_loads[i].amount * ingList[j].percentage;
						}
					}
				}
			}
			if (amount > 0) {
				add(ft.feedingTableData.feeding_loads);
			}

			function add(list) {
				var id = moment().valueOf();
				while (amount > 0) {
					var tempAm = angular.copy(amount);
					if (tempAm > wagon.value) {
						tempAm = wagon.value;
					}
					amount -= tempAm;
					var obj = {
						actual_amount: null,
						amount: tempAm,
						feeder: null,
						feeding_id: null,
						id: id,
						load_name: i18nFilter('_m_f_recipe_load_') + ' ' + (list.length + 1),
						load_position: list[list.length - 1] && !isNaN(list[list.length - 1].load_position) ? list[list.length - 1].load_position + 1 : 0,
						mixer_wagon_id: wagon.id,
						mixer_wagon_name: wagon.name,
						status: 0,
						wagon: wagon,
						ingredients: getIngredients(tempAm)
					};
					list.push(obj);
					updateFeedingEvents('add', obj);
					id++;
				}
			}

			function getIngredients(amount) {
				var lTemp = [];
				var ingCopy = angular.copy(ft.feedingTableData.ingredients);
				for (var j = 0; j < ingCopy.length; j++) {
					ingCopy[j].amount = amount * ingCopy[j].percentage;
					lTemp.push(ingCopy[j]);
				}
				return lTemp;
			}
		}

		function moveLoad(index, direction) {
			setDirty();
			var element = ft.feedingTableData.feeding_loads[index];
			var toIndex = 0;
			if (direction == 'up') {
				toIndex = index - 1;
			} else {
				toIndex = index + 1;
			}
			ft.feedingTableData.feeding_loads.splice(index, 1);
			ft.feedingTableData.feeding_loads.splice(toIndex, 0, element);
		}

		//Loading reports

		function groupLoadingConflicts() {
			for (var i = 0; i < ft.feedingTableData.feeding_loads.length; i++) {
				var newList = [];
				var listTemp = ft.feedingTableData.feeding_loads[i].load_ingredient_list.filter(function (ingredient) {
					return ingredient.visible !== false;
				});
				ft.feedingTableData.feeding_loads[i].has_loading_conflict = false;
				angular.forEach(groupBy(listTemp, 'ration_feed_id'), function (byId) {
					if (byId.length > 1) {
						ft.feedingTableData.feeding_loads[i].has_loading_conflict = true;
						newList.push({
							ration_feed_id: byId[0].ration_feed_id,
							feeding_name: byId[0].feeding_name,
							conflicts: byId
						});
					}
				});
				if (newList.length) {
					for (var j = 0; j < newList.length; j++) {
						var found = false;
						for (var k = listTemp.length - 1; k >= 0; k--) {
							if (newList[j].ration_feed_id === listTemp[k].ration_feed_id) {
								listTemp.splice(k, 1);
								found = true;
							}
						}
						if (found) {
							listTemp.push(newList[j]);
						}
					}
				}
				ft.feedingTableData.feeding_loads[i].ingredients = $filter('orderBy')(listTemp, 'position');
			}
			$timeout(function () {
				setLoadingSummary();
			}, 1);
		}

		function setLoadingSummary() {
			var ingredientList = [];
			var ingredientSummary = [];
			ft.feedingTableData.summary.loading_calculated_sum = 0;
			ft.feedingTableData.summary.loading_actual_sum = 0;
			ft.feedingTableData.summary.loading_calculated_cost = 0;
			ft.feedingTableData.summary.loading_actual_cost = 0;
			ft.feedingTableData.summary.ingredient_summary = [];
			for (var i = 0; i < ft.feedingTableData.feeding_loads.length; i++) {
				if (ft.feedingTableData.feeding_loads[i].visible !== false) {
					ft.feedingTableData.summary.loading_calculated_sum += ft.feedingTableData.feeding_loads[i].amount;
					ft.feedingTableData.summary.loading_calculated_cost += ft.feedingTableData.feeding_loads[i].load_calculated_cost;
					ft.feedingTableData.summary.loading_actual_sum += ft.feedingTableData.feeding_loads[i].actual_amount;
					ft.feedingTableData.summary.loading_actual_cost += ft.feedingTableData.feeding_loads[i].load_actual_cost;
					ingredientList = ingredientList.concat(
						ft.feedingTableData.feeding_loads[i].load_ingredient_list.filter(function (ingredient) {
							return ingredient.visible !== false;
						})
					);
				}
			}
			ft.feedingTableData.summary.loading_calculated_cost_dm = getCostDm(ft.feedingTableData.summary.loading_calculated_cost);
			ft.feedingTableData.summary.loading_actual_cost_dm = getCostDm(ft.feedingTableData.summary.loading_actual_cost);
			ft.feedingTableData.summary.loading_total_deviation_percentage = Number.isFinite(((ft.feedingTableData.summary.loading_actual_sum - ft.feedingTableData.summary.loading_calculated_sum) / ft.feedingTableData.summary.loading_calculated_sum) * 100)
				? Number.parseFloat(((ft.feedingTableData.summary.loading_actual_sum - ft.feedingTableData.summary.loading_calculated_sum) / ft.feedingTableData.summary.loading_calculated_sum) * 100)
				: 0;
			ft.feedingTableData.summary.loading_total_deviation_warn = ft.feedingTableData.summary.loading_total_deviation_percentage > 5 || ft.feedingTableData.summary.loading_total_deviation_percentage < -5 ? true : false;
			if (ingredientList.length > 0) {
				angular.forEach(groupBy(ingredientList, 'ration_feed_id'), function (byId) {
					ingredientSummary.push(new IngredientSummary(byId));
				});
				ft.feedingTableData.summary.ingredient_summary = $filter('orderBy')(ingredientSummary, 'position');
			}

			function IngredientSummary(ingredients) {
				this.ration_feed_id = ingredients[0].ration_feed_id;
				this.id = ingredients[0].id;
				this.position = ingredients[0].position;
				this.feeding_name = ingredients[0].feeding_name;
				this.calculated = getAmount(ingredients, 'calculated');
				this.actual = getAmount(ingredients, 'actual');
				this.ingredient_calculated_cost = ingredients[0].cost * this.calculated;
				this.ingredient_calculated_cost_dm = getCostDm(this.ingredient_calculated_cost);
				this.ingredient_actual_cost = ingredients[0].cost * this.actual;
				this.ingredient_actual_cost_dm = getCostDm(this.ingredient_actual_cost);
				this.deviation_percentage = Number.isFinite(((this.actual - this.calculated) / this.calculated) * 100) ? Number.parseFloat(((this.actual - this.calculated) / this.calculated) * 100) : 0;
				this.deviation_warning = this.deviation_percentage > 5 ? true : this.deviation_percentage < -5 ? true : false;
			}

			function getAmount(list, prop) {
				var sum = 0;
				for (var i = 0; i < list.length; i++) {
					sum += list[i][prop];
				}
				return sum;
			}
		}

		function setFeedingStatus() {
			var n_loads = ft.feedingTableData.feeding_loads.length;
			var n_status_1 = 0;
			var n_status_2 = 0;
			ft.feedingTableData.feeding_loads.forEach(function (load) {
				if (load.loading_status == 1) {
					n_status_1++;
				}
				if (load.loading_status == 2) {
					n_status_2++;
				}
			});
			if (n_status_1 == 0) {
				ft.feedingTableData.loading_status = 0;
			}

			if (n_status_1 > 0 || n_status_2 > 0) {
				ft.feedingTableData.loading_status = 1;
			}

			if (n_status_2 == n_loads) {
				ft.feedingTableData.loading_status = 2;
			}
		}

		function setDroppingStatus() {
			var n_loads = ft.feedingTableData.feeding_loads.length;
			var n_status_1 = 0;
			var n_status_2 = 0;
			ft.feedingTableData.feeding_loads.forEach(function (load) {
				if (!load.feeder && ft.user && ft.user.email) {
					load.feeder = ft.user.email;
				}
				if (load.dropping_status == 1) {
					n_status_1++;
				}
				if (load.dropping_status == 2) {
					n_status_2++;
				}
			});
			if (n_status_1 == 0) {
				ft.feedingTableData.dropping_status = 0;
			}

			if (n_status_1 > 0 || n_status_2 > 0) {
				ft.feedingTableData.dropping_status = 1;
			}

			if (n_status_2 == n_loads) {
				ft.feedingTableData.dropping_status = 2;
			}
		}

		function setLoadStatus(load) {
			var scheduled_feeds = ft.feedingTableData.is_premix ? ft.feedingTableData.ration.scheduled_premix_ingredients : ft.feedingTableData.ration.scheduled_ration_feeds;
			var n_scheduled_feeds = scheduled_feeds.length;
			var n_present_feeds = 0;
			var all_present = false;
			var without_conflict = true;
			var have_end_date = false;

			if (!load.feeder && ft.user && ft.user.email) {
				load.feeder = ft.user.email;
			}

			scheduled_feeds.forEach(function (s_feed) {
				var present = load.ingredients.find(function (ing) {
					return s_feed.id == ing.ration_feed_id;
				});
				if (present) {
					n_present_feeds++;
				}
			});
			if (n_scheduled_feeds == n_present_feeds) {
				all_present = true;
			}

			load.ingredients.forEach(function (ing) {
				if (ing.conflicts) {
					without_conflict = false;
				}
			});
			if (load.loading_finish) {
				have_end_date = true;
			}

			if (load.ingredients && load.ingredients.length) {
				load.loading_status = 1;
			}

			if (all_present && without_conflict && have_end_date) {
				load.loading_status = 2;
			}
		}

		function dataCollapseLoadingFn() {
			for (var i = 0; i < ft.feedingTableData.feeding_loads.length; i++) {
				ft.feedingTableData.feeding_loads[i].expanded = ft.feedingTableData.feeding_loads[i].expanded || false;
				if (ft.feedingTableData.feeding_loads[i].ingredients) {
					for (var j = 0; j < ft.feedingTableData.feeding_loads[i].ingredients.length; j++) {
						ft.feedingTableData.feeding_loads[i].ingredients[j].expanded = ft.feedingTableData.feeding_loads[i].ingredients[j].expanded || false;
					}
				}
			}
			ft.feedingTableData.summary.loading_expanded = ft.feedingTableData.summary.loading_expanded || false;
		}

		function selectLoadRow(load) {
			for (var i = 0; i < ft.feedingTableData.feeding_loads.length; i++) {
				if (ft.feedingTableData.feeding_loads[i].load_position === load.load_position) {
					ft.feedingTableData.feeding_loads[i].expanded = !ft.feedingTableData.feeding_loads[i].expanded;
					if (!ft.feedingTableData.feeding_loads[i].expanded) {
						for (var j = 0; j < ft.feedingTableData.feeding_loads[i].ingredients.length; j++) {
							ft.feedingTableData.feeding_loads[i].ingredients[j].expanded = false;
						}
					}
					break;
				}
			}
		}

		function updateLoadReport(load, data, index, prop) {
			try {
				$timeout(function () {
					var action;
					switch (prop) {
						case 'remove_load_report':
							ft.confirmationPromise = $q.defer();
							openConfirmationModal('delete_load');
							$q.all([ft.confirmationPromise.promise])
								.then(function () {
									action = 'set_update_data';
									for (var i = 0; i < ft.feedingTableData.feeding_loads.length; i++) {
										if (ft.feedingTableData.feeding_loads[i].load_position === load.load_position) {
											ft.feedingTableData.feeding_loads[i].visible = false;
											ft.feedingTableData.feeding_loads[i].dirty = true;
											break;
										}
									}
									loadProccess(action, ft.feedingTableData, load);
								})
								.catch(function () {
									return;
								});
							break;
						case 'add_ingredient':
							action = 'set_update_data';
							var selectedList = ft.missingData.filter(function (item) {
								return item.is_selected === true;
							});
							if (selectedList.length > 0) {
								for (var i = 0; i < ft.feedingTableData.feeding_loads.length; i++) {
									if (ft.feedingTableData.feeding_loads[i].load_position === load.load_position) {
										ft.feedingTableData.feeding_loads[i].load_ingredient_list = ft.feedingTableData.feeding_loads[i].load_ingredient_list.concat(selectedList);
										ft.feedingTableData.feeding_loads[i].dirty = true;
										break;
									}
								}
								groupLoadingConflicts();
								loadProccess(action, ft.feedingTableData, load);
							}
							break;
						default:
							break;
					}
				}, 10);
			} catch (error) {
				loading();
				dismissModals();
			}

			function loadProccess(action, data, load) {
				setDirty();
				setLoadingSummary();
				loading();
				setLoadStatus(load);
				recalculateLoad(load);
				setFeedingStatus();
				$timeout(function () {
					updateFeedingEvents(action, data);
					dismissModals();
				}, 1);
			}
		}

		function selectIngredientRow(load, ingredient) {
			if (ingredient.conflicts) {
				for (var i = 0; i < load.ingredients.length; i++) {
					if (load.ingredients[i].ration_feed_id === ingredient.ration_feed_id) {
						load.ingredients[i].expanded = !load.ingredients[i].expanded;
						break;
					}
				}
			}
		}

		function updateIngredient(load, ing, data, index, prop, conflicted) {
			try {
				$timeout(function () {
					var action;
					switch (prop) {
						case 'actual':
							ing.actual = data;
							ing.ingredient_actual_cost = ing.actual * ing.cost;
							ing.ingredient_actual_cost_dm = getCostDm(ing.ingredient_actual_cost);
							ing.deviation_percentage = Number.isFinite(((data - ing.calculated) / ing.calculated) * 100) ? Number.parseFloat(((data - ing.calculated) / ing.calculated) * 100) : 0;
							ing.deviation_warn = ing.deviation_percentage >= 5 || ing.deviation_percentage <= -5 ? true : false;
							action = 'set_update_data';
							ingredientProccess(load, ing, action);
							break;
						case 'remove_ingredient':
							ft.confirmationPromise = $q.defer();
							openConfirmationModal('delete_ingredient');
							$q.all([ft.confirmationPromise.promise])
								.then(function () {
									action = 'set_update_data';
									var conlictResolved = false;
									var ingId = ing.id || ing.temp_id;
									var idProp = ing.id ? 'id' : 'temp_id';
									ingredientMainLoop: for (var i = 0; i < load.ingredients.length; i++) {
										if (conflicted) {
											if (load.ingredients[i].conflicts) {
												for (var j = 0; j < load.ingredients[i].conflicts.length; j++) {
													if (load.ingredients[i].conflicts[j][idProp] === ingId) {
														load.ingredients[i].conflicts.splice(j, 1);
														if (load.ingredients[i].conflicts.length === 1) {
															conlictResolved = true;
														}
														break ingredientMainLoop;
													}
												}
											}
										} else {
											if (load.ingredients[i][idProp] === ingId) {
												load.ingredients.splice(i, 1);
												break ingredientMainLoop;
											}
										}
									}
									for (var k = 0; k < load.load_ingredient_list.length; k++) {
										if (load.load_ingredient_list[k][idProp] === ingId) {
											if (ing.id) {
												load.load_ingredient_list[k].visible = false;
											} else {
												load.load_ingredient_list.splice(k, 1);
											}
											break;
										}
									}
									if (conlictResolved) {
										groupLoadingConflicts();
									}
									ingredientProccess(load, ing, action);
								})
								.catch(function () {
									return;
								});
							break;
						default:
							break;
					}
				}, 10);
			} catch (error) {
				loading();
				dismissModals();
			}

			function ingredientProccess(load, ing, action) {
				setLoadStatus(load);
				setDirty();
				recalculateLoad(load, ing);
				loading();
				$timeout(function () {
					updateFeedingEvents(action, ft.feedingTableData);
				}, 1);
			}
		}

		function recalculateLoad(load, ing) {
			for (var i = 0; i < ft.feedingTableData.feeding_loads.length; i++) {
				if (ft.feedingTableData.feeding_loads[i].load_position === load.load_position) {
					ft.feedingTableData.feeding_loads[i].dirty = true;
					ft.feedingTableData.feeding_loads[i].actual_amount = 0;
					ft.feedingTableData.feeding_loads[i].load_calculated_cost = 0;
					ft.feedingTableData.feeding_loads[i].load_actual_cost = 0;
					var warn = false;
					for (var j = 0; j < ft.feedingTableData.feeding_loads[i].load_ingredient_list.length; j++) {
						if (ft.feedingTableData.feeding_loads[i].load_ingredient_list[j].visible !== false) {
							ft.feedingTableData.feeding_loads[i].actual_amount += ft.feedingTableData.feeding_loads[i].load_ingredient_list[j].actual;
							ft.feedingTableData.feeding_loads[i].load_calculated_cost += ft.feedingTableData.feeding_loads[i].load_ingredient_list[j].ingredient_calculated_cost;
							ft.feedingTableData.feeding_loads[i].load_actual_cost += ft.feedingTableData.feeding_loads[i].load_ingredient_list[j].ingredient_actual_cost;
							if (ft.feedingTableData.feeding_loads[i].load_ingredient_list[j].deviation_warn) {
								warn = true;
							}
						}
						if (ing && ft.feedingTableData.feeding_loads[i].load_ingredient_list[j].id === ing.id) {
							ft.feedingTableData.feeding_loads[i].load_ingredient_list[j].dirty = true;
						}
					}
					ft.feedingTableData.feeding_loads[i].load_actual_cost_dm = getCostDm(ft.feedingTableData.feeding_loads[i].load_actual_cost);
					ft.feedingTableData.feeding_loads[i].load_calculated_cost_dm = getCostDm(ft.feedingTableData.feeding_loads[i].load_calculated_cost);
					ft.feedingTableData.feeding_loads[i].loading_deviation_percentage = Number.isFinite(((ft.feedingTableData.feeding_loads[i].actual_amount - ft.feedingTableData.feeding_loads[i].amount) / ft.feedingTableData.feeding_loads[i].amount) * 100)
						? Number.parseFloat(((ft.feedingTableData.feeding_loads[i].actual_amount - ft.feedingTableData.feeding_loads[i].amount) / ft.feedingTableData.feeding_loads[i].amount) * 100)
						: 0;
					ft.feedingTableData.feeding_loads[i].deviation_warn = ft.feedingTableData.feeding_loads[i].loading_deviation_percentage >= 5 || ft.feedingTableData.feeding_loads[i].loading_deviation_percentage <= -5 || warn === true ? true : false;

					if (warn) {
						ft.feedingTableData.feeding_loads[i].deviation_warn_text = i18nFilter('_m_f_calendar_ingredient_deviation_warning_');
					}

					if (Math.abs(ft.feedingTableData.feeding_loads[i].loading_deviation_percentage) >= 5) {
						ft.feedingTableData.feeding_loads[i].deviation_warn_text = i18nFilter('_m_f_calendar_load_deviation_warning_');
					}
					break;
				}
			}
			setLoadingSummary();
		}

		function changeLoadingTime(load) {
			ft.confirmationPromise = $q.defer();
			ft.modalLoad = load;
			ft.modalStartDate = moment(load.loading_start || moment())
				.utc()
				.format('YYYY-MM-DDTHH:mm:ss[Z]');
			ft.modalEndDate = moment(load.loading_finish || moment())
				.utc()
				.format('YYYY-MM-DDTHH:mm:ss[Z]');
			openModal('app/pages/calendar/feedingTable/datetimePicker.modal.html', 'lg', 'modalLoad');
			checkDateValidation('modalLoad');
			$q.all([ft.confirmationPromise.promise])
				.then(function () {
					load.loading_start = moment(ft.modalStartDate).utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
					load.loading_finish = moment(ft.modalEndDate).utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
					processLoadDateChange();
				})
				.catch(function () {
					load.changed_loading_datetime = null;
					load.changed_dropping_datetime = null;
				});

			function processLoadDateChange() {
				load.changed_loading_datetime = true;
				load.dirty = true;
				setLoadStatus(load);
				setFeedingStatus();
				setDirty();
				loading();
				$timeout(function () {
					updateFeedingEvents('set_update_data', ft.feedingTableData);
				}, 1);
			}
		}

		//Dropping reports

		function groupDroppingConflicts() {
			for (var i = 0; i < ft.feedingTableData.pen_feedings.length; i++) {
				if (ft.feedingTableData.pen_feedings[i].load_dropped_report) {
					var newList = [];
					var listTemp = ft.feedingTableData.pen_feedings[i].load_dropped_report.filter(function (item) {
						return item.visible !== false;
					});
					ft.feedingTableData.pen_feedings[i].has_dropping_conflict = false;
					angular.forEach(groupBy(listTemp, 'group_by_id'), function (byId) {
						if (byId.length > 1) {
							ft.feedingTableData.pen_feedings[i].has_dropping_conflict = true;
							newList.push({
								group_by_id: byId[0].group_by_id,
								load_id: byId[0].load_id,
								load_name: byId[0].load_name,
								load_position: byId[0].load_position,
								conflicts: byId
							});
						}
					});
					if (newList.length) {
						for (var j = 0; j < newList.length; j++) {
							var found = false;
							for (var k = listTemp.length - 1; k >= 0; k--) {
								if (newList[j].group_by_id === listTemp[k].group_by_id) {
									listTemp.splice(k, 1);
									found = true;
								}
							}
							if (found) {
								listTemp.push(newList[j]);
							}
						}
					}
				}
				ft.feedingTableData.pen_feedings[i].loads = $filter('orderBy')(listTemp, 'load_position');
			}
			$timeout(function () {
				setDroppingSummary();
			}, 1);
		}

		function setDroppingSummary() {
			var unloadSummary = [];
			ft.feedingTableData.summary.dropping_calculated_sum = 0;
			ft.feedingTableData.summary.dropping_actual_sum = 0;
			ft.feedingTableData.summary.dropping_calculated_cost = 0;
			ft.feedingTableData.summary.dropping_actual_cost = 0;
			ft.feedingTableData.summary.unload_summary = [];
			for (var i = 0; i < ft.feedingTableData.pen_feedings.length; i++) {
				if (ft.feedingTableData.pen_feedings[i].visible !== false) {
					ft.feedingTableData.summary.dropping_calculated_sum += ft.feedingTableData.pen_feedings[i].feeding_amount;
					ft.feedingTableData.summary.dropping_actual_sum += ft.feedingTableData.pen_feedings[i].actual_amount;
				}
			}
			for (var j = 0; j < ft.feedingTableData.summary.loads.length; j++) {
				ft.feedingTableData.summary.loads[j].group_by_id = ft.feedingTableData.summary.loads[j].id
					? ft.feedingTableData.summary.loads[j].id
					: ft.feedingTableData.feeding_number.toString() + '-' + ft.feedingTableData.feeding_date + '-' + ft.feedingTableData.summary.loads[j].load_position.toString();
				ft.feedingTableData.summary.loads[j].load_name = i18nFilter('_m_f_recipe_load_') + ' ' + (ft.feedingTableData.summary.loads[j].load_position + 1);
				if (unitConversionService.convertData(ft.feedingTableData.summary.loads[j].calculated_amount, ['round:0']) !== unitConversionService.convertData(ft.feedingTableData.summary.loads[j].amount, ['round:0'])) {
					ft.feedingTableData.summary.loads[j].load_changed = true;
				}
				ft.feedingTableData.summary.loads[j].dropped_load_calculated_cost = feedingTableService.calculateLoadCostPerKg(ft.feedingTableData, ft.feedingTableData.summary.loads[j].load_position, 'amount', 'calculated') * ft.feedingTableData.summary.loads[j].amount;
				ft.feedingTableData.summary.loads[j].dropped_load_calculated_cost_dm = getCostDm(ft.feedingTableData.summary.loads[j].dropped_load_calculated_cost);
				ft.feedingTableData.summary.loads[j].dropped_load_actual_cost = feedingTableService.calculateLoadCostPerKg(ft.feedingTableData, ft.feedingTableData.summary.loads[j].load_position, 'actual_amount', 'actual') * ft.feedingTableData.summary.loads[j].drop_amount;
				ft.feedingTableData.summary.loads[j].dropped_load_actual_cost_dm = getCostDm(ft.feedingTableData.summary.loads[j].dropped_load_actual_cost);
				if (ft.feedingTableData.summary.loads[j].visible !== false) {
					ft.feedingTableData.summary.dropping_calculated_cost += ft.feedingTableData.summary.loads[j].dropped_load_calculated_cost;
					ft.feedingTableData.summary.dropping_actual_cost += ft.feedingTableData.summary.loads[j].dropped_load_actual_cost;
					unloadSummary.push(new UnloadSummary(ft.feedingTableData.summary.loads[j]));
				}
			}
			ft.feedingTableData.summary.dropping_calculated_cost_dm = getCostDm(ft.feedingTableData.summary.dropping_calculated_cost);
			ft.feedingTableData.summary.dropping_actual_cost_dm = getCostDm(ft.feedingTableData.summary.dropping_actual_cost);
			ft.feedingTableData.summary.dropping_total_deviation_percentage = ((ft.feedingTableData.summary.dropping_actual_sum - ft.feedingTableData.summary.dropping_calculated_sum) / ft.feedingTableData.summary.dropping_calculated_sum) * 100;
			ft.feedingTableData.summary.unload_summary = $filter('orderBy')(unloadSummary, 'position');

			function UnloadSummary(drop) {
				this.id = drop.id;
				this.load_name = drop.load_name;
				this.position = drop.load_position;
				this.actual = drop.drop_amount || 0;
				this.calculated = drop.amount;
				this.calculated_amount = drop.calculated_amount;
				this.dropping_status = drop.dropping_status;
				this.deviation = ((drop.drop_amount - drop.amount) / drop.amount) * 100;
				this.deviation_warning = this.deviation > 5 ? true : this.deviation < -5 ? true : false;
				this.dropped_load_calculated_cost_dm = drop.dropped_load_calculated_cost_dm;
				this.dropped_load_calculated_cost = drop.dropped_load_calculated_cost;
				this.dropped_load_actual_cost_dm = drop.dropped_load_actual_cost_dm;
				this.dropped_load_actual_cost = drop.dropped_load_actual_cost;
				this.load_changed = drop.load_changed;
			}
		}

		function dataCollapseDroppingFn() {
			for (var i = 0; i < ft.feedingTableData.pen_feedings.length; i++) {
				ft.feedingTableData.pen_feedings[i].expanded = ft.feedingTableData.pen_feedings[i].expanded || false;
				if (ft.feedingTableData.pen_feedings[i].loads) {
					for (var j = 0; j < ft.feedingTableData.pen_feedings[i].loads.length; j++) {
						ft.feedingTableData.pen_feedings[i].loads[j].expanded = ft.feedingTableData.pen_feedings[i].loads[j].expanded || false;
					}
				}
			}
			ft.feedingTableData.summary.dropping_expanded = ft.feedingTableData.summary.dropping_expanded || false;
		}

		function selectPenRow(pen) {
			for (var i = 0; i < ft.feedingTableData.pen_feedings.length; i++) {
				if (ft.feedingTableData.pen_feedings[i].pen_id === pen.pen_id) {
					ft.feedingTableData.pen_feedings[i].expanded = !ft.feedingTableData.pen_feedings[i].expanded;
					if (!ft.feedingTableData.pen_feedings[i].expanded) {
						for (var j = 0; j < ft.feedingTableData.pen_feedings[i].loads.length; j++) {
							ft.feedingTableData.pen_feedings[i].loads[j].expanded = false;
						}
					}
					break;
				}
			}
		}

		function updatePenReport(pen, data, index, prop) {
			try {
				$timeout(function () {
					var action;
					switch (prop) {
						case 'add_unload':
							action = 'set_update_data';
							var selectedList = ft.missingData.filter(function (item) {
								return item.is_selected === true;
							});
							if (selectedList.length > 0) {
								for (var i = 0; i < ft.feedingTableData.pen_feedings.length; i++) {
									if (ft.feedingTableData.pen_feedings[i].pen_id === pen.pen_id) {
										ft.feedingTableData.pen_feedings[i].load_dropped_report = ft.feedingTableData.pen_feedings[i].load_dropped_report.concat(selectedList);
										ft.feedingTableData.pen_feedings[i].dirty = true;
										break;
									}
								}
								groupDroppingConflicts();
								penProccess(action, ft.feedingTableData, pen);
							}
							break;
						default:
							break;
					}
				}, 10);
			} catch (error) {
				loading();
				dismissModals();
			}

			function penProccess(action, data, pen) {
				setDirty();
				recalculatePen(pen);
				loading();
				setDroppingStatus();
				$timeout(function () {
					updateFeedingEvents(action, data);
					dismissModals();
				}, 1);
			}
		}

		function selectUnloadRow(pen, load) {
			if (load.conflicts) {
				for (var i = 0; i < pen.loads.length; i++) {
					if (pen.loads[i].group_by_id === load.group_by_id) {
						pen.loads[i].expanded = !pen.loads[i].expanded;
						break;
					}
				}
			}
		}

		function updateUnload(pen, load, data, index, prop, conflicted) {
			try {
				$timeout(function () {
					var action;
					switch (prop) {
						case 'actual_loaded':
							load.actual_loaded = data;
							load.drop_actual_cost = feedingTableService.calculateLoadCostPerKg(ft.feedingTableData, load.load_position, 'actual_amount', 'actual') * load.actual_loaded;
							load.drop_actual_cost_dm = getCostDm(load.drop_actual_cost);
							action = 'set_update_data';
							unloadProccess(pen, load, action);
							break;
						case 'remove_unload':
							ft.confirmationPromise = $q.defer();
							openConfirmationModal('delete_pen_load');
							$q.all([ft.confirmationPromise.promise])
								.then(function () {
									action = 'set_update_data';
									var conlictResolved = false;
									var loadId = load.unload_id || load.temp_id;
									var idProp = load.unload_id ? 'unload_id' : 'temp_id';
									penLoadMainLoop: for (var i = 0; i < pen.loads.length; i++) {
										if (conflicted) {
											if (pen.loads[i].conflicts) {
												for (var j = 0; j < pen.loads[i].conflicts.length; j++) {
													if (pen.loads[i].conflicts[j][idProp] === loadId) {
														pen.loads[i].conflicts.splice(j, 1);
														if (pen.loads[i].conflicts.length === 1) {
															conlictResolved = true;
														}
														break penLoadMainLoop;
													}
												}
											}
										} else {
											if (pen.loads[i][idProp] === loadId) {
												pen.loads.splice(i, 1);
												break penLoadMainLoop;
											}
										}
									}
									for (var k = 0; k < pen.load_dropped_report.length; k++) {
										if (pen.load_dropped_report[k][idProp] === loadId) {
											if (load.unload_id) {
												pen.load_dropped_report[k].visible = false;
											} else {
												pen.load_dropped_report.splice(k, 1);
											}
											break;
										}
									}
									if (conlictResolved) {
										groupDroppingConflicts();
									}
									unloadProccess(pen, load, action);
								})
								.catch(function () {
									return;
								});
							break;
						default:
							break;
					}
				}, 10);
			} catch (error) {
				loading();
				dismissModals();
			}

			function unloadProccess(pen, load, action) {
				setDirty();
				recalculatePen(pen, load);
				loading();
				setDroppingStatus();
				$timeout(function () {
					updateFeedingEvents(action, ft.feedingTableData);
				}, 1);
			}
		}

		function recalculatePen(pen, load) {
			for (var i = 0; i < ft.feedingTableData.pen_feedings.length; i++) {
				if (ft.feedingTableData.pen_feedings[i].pen_id === pen.pen_id) {
					ft.feedingTableData.pen_feedings[i].dirty = true;
					ft.feedingTableData.pen_feedings[i].actual_amount = 0;
					ft.feedingTableData.pen_feedings[i].pen_actual_cost = 0;
					for (var j = 0; j < ft.feedingTableData.pen_feedings[i].load_dropped_report.length; j++) {
						if (ft.feedingTableData.pen_feedings[i].load_dropped_report[j].visible !== false) {
							ft.feedingTableData.pen_feedings[i].actual_amount += ft.feedingTableData.pen_feedings[i].load_dropped_report[j].actual_loaded;
							ft.feedingTableData.pen_feedings[i].pen_actual_cost += ft.feedingTableData.pen_feedings[i].load_dropped_report[j].drop_actual_cost;
						}
						if (load && ft.feedingTableData.pen_feedings[i].load_dropped_report[j].unload_id === load.unload_id) {
							ft.feedingTableData.pen_feedings[i].load_dropped_report[j].dirty = true;
						}
					}
					ft.feedingTableData.pen_feedings[i].pen_actual_cost_dm = getCostDm(ft.feedingTableData.pen_feedings[i].pen_actual_cost);
					ft.feedingTableData.pen_feedings[i].deviation_percentage = ((ft.feedingTableData.pen_feedings[i].actual_amount - ft.feedingTableData.pen_feedings[i].feeding_amount) / ft.feedingTableData.pen_feedings[i].feeding_amount) * 100;
					ft.feedingTableData.pen_feedings[i].deviation_warn = ft.feedingTableData.pen_feedings[i].deviation_percentage >= 5 || ft.feedingTableData.pen_feedings[i].deviation_percentage <= -5 ? true : false;
					break;
				}
			}
			if (load) {
				recalculateDropping(load);
			} else {
				recalculateDroppingAll();
			}
		}

		function recalculateDropping(load) {
			var loadAmount = 0;
			var status2Loads = 0;
			var status1Loads = 0;
			for (var i = 0; i < ft.feedingTableData.pen_feedings.length; i++) {
				if (ft.feedingTableData.pen_feedings[i].visible != false) {
					for (var j = 0; j < ft.feedingTableData.pen_feedings[i].loads.length; j++) {
						if (load.group_by_id == ft.feedingTableData.pen_feedings[i].loads[j].group_by_id) {
							if (ft.feedingTableData.pen_feedings[i].loads[j].conflicts) {
								for (var k = 0; k < ft.feedingTableData.pen_feedings[i].loads[j].conflicts.length; k++) {
									loadAmount += ft.feedingTableData.pen_feedings[i].loads[j].conflicts[k].actual_loaded;
								}
							} else {
								loadAmount += ft.feedingTableData.pen_feedings[i].loads[j].actual_loaded;
							}
							if (ft.feedingTableData.pen_feedings[i].loads[j].status == 2) {
								status2Loads++;
							}
							if (ft.feedingTableData.pen_feedings[i].loads[j].status == 1) {
								status1Loads++;
							}
						}
					}
				}
			}
			recalculateSummary(load, loadAmount, status1Loads, status2Loads);
			/*for (var l = 0; l < ft.feedingTableData.summary.loads.length; l++) {
				if (ft.feedingTableData.summary.loads[l].group_by_id == load.group_by_id) {
					ft.feedingTableData.summary.loads[l].drop_amount = loadAmount;
					ft.feedingTableData.summary.loads[l].dropping_deviation_percentage = ((ft.feedingTableData.summary.loads[l].drop_amount - ft.feedingTableData.summary.loads[l].calculated_amount) / ft.feedingTableData.summary.loads[l].calculated_amount) * 100;
					if (status2Loads == ft.feedingTableData.pen_feedings.length) {
						ft.feedingTableData.summary.loads[l].dropping_status = 2;
					} else {
						if (status2Loads > 0) {
							ft.feedingTableData.summary.loads[l].dropping_status = 1;
						} else {
							if (status1Loads > 0) {
								ft.feedingTableData.summary.loads[l].dropping_status = 1;
							} else {
								ft.feedingTableData.summary.loads[l].dropping_status = 0;
							}
						}
					}
				}
			}*/
			$timeout(function () {
				setDroppingSummary();
			}, 1);
		}

		function recalculateDroppingAll() {
			ft.feedingTableData.pen_feedings.forEach(function (pen_feeding) {
				if (pen_feeding.visible != false) {
					pen_feeding.loads.forEach(function (load) {
						var loadAmount = 0;
						var status2Loads = 0;
						var status1Loads = 0;

						if (load.conflicts) {
							for (var k = 0; k < load.conflicts.length; k++) {
								loadAmount += load.conflicts[k].actual_loaded;
							}
						} else {
							loadAmount += load.actual_loaded;
						}
						if (load.status == 2) {
							status2Loads++;
						}
						if (load.status == 1) {
							status1Loads++;
						}

						recalculateSummary(load, loadAmount, status1Loads, status2Loads);
					});
				}
			});

			$timeout(function () {
				setDroppingSummary();
			}, 1);
		}

		function recalculateSummary(load, load_amount, status_1_loads, status_2_loads) {
			for (var l = 0; l < ft.feedingTableData.summary.loads.length; l++) {
				if (ft.feedingTableData.summary.loads[l].group_by_id == load.group_by_id) {
					ft.feedingTableData.summary.loads[l].drop_amount = load_amount;
					ft.feedingTableData.summary.loads[l].dropping_deviation_percentage = ((ft.feedingTableData.summary.loads[l].drop_amount - ft.feedingTableData.summary.loads[l].calculated_amount) / ft.feedingTableData.summary.loads[l].calculated_amount) * 100;
					if (status_2_loads == ft.feedingTableData.pen_feedings.length) {
						ft.feedingTableData.summary.loads[l].dropping_status = 2;
					} else {
						if (status_2_loads > 0) {
							ft.feedingTableData.summary.loads[l].dropping_status = 1;
						} else {
							if (status_1_loads > 0) {
								ft.feedingTableData.summary.loads[l].dropping_status = 1;
							} else {
								ft.feedingTableData.summary.loads[l].dropping_status = 0;
							}
						}
					}
				}
			}
		}

		//Add missing ingredients or loads

		function openAddDataModal(type, row) {
			ft.selectedRow = row;
			if (type === 'loading') {
				ft.modalTitle = i18nFilter('_m_f_calendar_missing_ingredients_label_');
			} else {
				ft.modalTitle = i18nFilter('_m_f_calendar_missing_loads_label_');
			}
			getMissingData(type, row);
			openModal('app/pages/calendar/feedingTable/insertData.modal.html', 'md', type);
		}

		function getMissingData(type, row) {
			if (type === 'loading') {
				if (ft.feedingTableData.ration.scheduled_ration_feeds) {
					ft.missingData = angular.copy(ft.feedingTableData.ration.scheduled_ration_feeds);
				} else {
					ft.missingData = angular.copy(ft.feedingTableData.ration.scheduled_premix_ingredients);
				}
				for (var i = 0; i < ft.missingData.length; i++) {
					var obj1 = angular.copy(ft.missingData[i]);
					ft.missingData[i] = new Ingredient(obj1, row);
				}
				ft.missingData = $filter('orderBy')(ft.missingData, 'position');
			} else {
				var missingFeedingTableData = angular.copy(ft.feedingTableData);
				ft.missingData = angular.copy(ft.feedingTableData.feeding_loads);
				for (var j = 0; j < ft.missingData.length; j++) {
					var obj2 = angular.copy(ft.missingData[j]);
					ft.missingData[j] = new Load(obj2, missingFeedingTableData, ft.feedingTableData);
				}
				ft.missingData = $filter('orderBy')(ft.missingData, 'load_name');
			}

			function Ingredient(ingredient, load) {
				this.feeding_name = ingredient.ration_feed_name || ingredient.premix_ingredient_name;
				//this.id = ingredient.id;
				this.calculated = (ingredient.percentage / 100) * load.amount;
				this.cost = ingredient.cost_dm * (ingredient.dm / 100);
				this.ingredient_calculated_cost = this.calculated * this.cost;
				this.ingredient_calculated_cost_dm = getCostDm(this.ingredient_calculated_cost);
				this.ingredient_actual_cost = 0;
				this.ingredient_actual_cost_dm = 0;
				this.actual = 0;
				this.deviation_percentage = -100;
				this.ration_feed_id = ingredient.id;
				this.sort_id = ingredient.id;
				this.position = ingredient.order_number;
				this.temp_id = getGuid();
				this.dirty = true;
				this.visible = true;
				this.deviation_warn = true;
			}

			function Load(load, feeding_table, feeding_table_data) {
				this.load_name = i18nFilter('_m_f_recipe_load_') + ' ' + (load.load_position + 1);
				this.load_id = load.id;
				this.sort_id = load.id;
				this.actual_loaded = load.actual_amount == null ? 0 : load.actual_amount;
				this.drop_actual_cost = this.actual_loaded == 0 ? 0 : calculateActualDropCost(load, feeding_table, feeding_table_data);
				this.drop_actual_cost_dm = 0;
				this.unloading_start = moment.utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
				this.status = 1;
				this.temp_id = getGuid();
				this.group_by_id = this.load_id ? this.load_id : feeding_table.feeding_number.toString() + '-' + feeding_table.feeding_date + '-' + load.load_position.toString();
				this.dirty = true;
				this.visible = true;
				this.loading_status = load.loading_status;
				this.load_position = load.load_position;
				this.feeder = setFeeder(load, feedingTableService.getLoading(), feeding_table);
				this.mixer_wagon = setMixerWagon(load, feedingTableService.getLoading(), feeding_table);
			}
		}

		function calculateActualDropCost(load, feeding_table) {
			var cost = 0;
			var loading_data = feedingTableService.getLoading();
			var feeding_number = feeding_table.feeding_number;
			var load_position = load.load_position;

			var feeding = loading_data.find(function (_feeding) {
				return _feeding.feeding_number === feeding_number;
			});
			var loaded;
			if (feeding) {
				loaded = feeding.feeding_loads.find(function (_load) {
					return _load.load_position === load_position;
				});
			}

			if (loaded && loaded.load_ingredient_list) {
				loaded.load_ingredient_list.forEach(function (ingredient) {
					cost += ingredient.cost * ingredient.actual;
				});
			}

			return cost;
		}

		function setFeeder(load, loading_data, feeding_table){
			var feeder;
			loading_data.forEach(function(loading){
				if(loading.feeding_number == feeding_table.feeding_number){
					loading.feeding_loads.forEach(function(_load){
						if(_load.load_position == load.load_position){
							feeder = _load.feeder;
						}
					});
				}
			});
			return feeder;
		}

		function setMixerWagon(load, loading_data, feeding_table){
			var wagon;
			loading_data.forEach(function(loading){
				if(loading.feeding_number == feeding_table.feeding_number){
					loading.feeding_loads.forEach(function(_load){
						if(_load.load_position == load.load_position){
							wagon = _load.mixer_wagon;
						}
					});
				}
			});
			return wagon;
		}

		function getGuid() {
			function S4() {
				return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
			}
			var guid = (S4() + S4() + '-' + S4() + '-4' + S4().substring(0, 3) + '-' + S4() + '-' + S4() + S4() + S4()).toLowerCase();
			return guid;
		}

		function changeDroppingTime(pen, unload) {
			ft.confirmationPromise = $q.defer();
			ft.modalUnload = unload;
			ft.modalStartDate = moment(unload.unloading_start || moment())
				.utc()
				.format('YYYY-MM-DDTHH:mm:ss[Z]');
			ft.modalEndDate = moment(unload.unloading_finish || moment())
				.utc()
				.format('YYYY-MM-DDTHH:mm:ss[Z]');
			openModal('app/pages/calendar/feedingTable/datetimePicker.modal.html', 'lg', 'modalUnload');
			checkDateValidation('modalUnload');
			$q.all([ft.confirmationPromise.promise])
				.then(function () {
					unload.unloading_start = moment(ft.modalStartDate).utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
					unload.unloading_finish = moment(ft.modalEndDate).utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
					processUnloadDateChange();
				})
				.catch(function () {
					unload.changed_loading_datetime = null;
					unload.changed_dropping_datetime = null;
				});

			function processUnloadDateChange() {
				unload.changed_dropping_datetime = true;
				unload.dirty = true;
				unload.status = 2;
				pen.dirty = true;
				setDirty();
				loading();
				recalculateDropping(unload);
				setDroppingStatus();
				$timeout(function () {
					updateFeedingEvents('set_update_data', ft.feedingTableData);
				}, 1);
			}
		}

		//Helper functions

		function checkRationOrigin(ration) {
			if (ration) {
				if (ration.ration_header_id || ration.manual_ration_header_id) {
					return 'ration';
				}

				return 'ration_premix';
			}

			return null;
		}

		function getCostDm(cost) {
			return cost * (ft.feedingTableData.dm / 100) || 0;
		}

		function checkDateValidation(type) {
			$timeout(function () {
				ft[type].start_date_error = ft.modalStartDate ? false : true;
				ft[type].end_date_error = ft.modalEndDate ? (moment(ft.modalStartDate).isAfter(ft.modalEndDate) ? true : false) : true;
			}, 100);
		}

		function openChangePopover(e, original, type) {
			e.stopPropagation();
			if (type === 'load-date' || type === 'drop-date') {
				original = $filter('date')(original, ft.dateWithDayFormat);
			}
			ft.popoverModel = original;
			ft.popoverType = type;
		}

		function openDeleteFeedingModal(e) {
			e.stopPropagation();
			openModal('app/pages/calendar/feedingTable/confirmation.modal.html', 'sm', 'delete');
		}

		function openConfirmationModal(action) {
			openModal('app/pages/calendar/feedingTable/confirmation.modal.html', 'sm', action);
		}

		function loading(prop) {
			if (prop) {
				angular.element('html').addClass('wait-cursor');
			} else {
				angular.element('html').removeClass('wait-cursor');
			}
		}

		function goToPage(page, id) {
			localStorage.setItem('from_calendar', true);
			ft.redirectId = id;
			$state.go(page, {
				uuid: id
			});
		}

		function setDirty() {
			ft.setCalendarDirty();
		}

		function openModal(page, size, type) {
			ft.modalType = type;
			$uibModal
				.open({
					animation: true,
					templateUrl: page,
					size: size,
					scope: $scope,
					backdrop: 'static',
					keyboard: false
				})
				.closed.then(function () {
					ft.modalType = undefined;
				});
		}

		function confirm(doLoading) {
			if (doLoading === true) {
				loading(true);
			}
			try {
				ft.confirmationPromise.resolve();
			} catch (error) {
				console.log(error);
			}
			dismissModals();
		}

		function cancel() {
			try {
				ft.confirmationPromise.reject();
			} catch (error) {
				console.log(error);
			}
			dismissModals();
		}

		function dismissModals() {
			$uibModalStack.dismissAll();
		}

		function updateFeedingEvents(action, data) {
			// if (action != 'remove') {
			//     data.feeding_date = ft.feedingTableData.feeding_date;
			//     data.recipe_id = ft.feedingTableData.recipe_id;
			//     data.feeding_number = ft.feedingTableData.feeding_number;
			//     data.recipe_name = ft.feedingTableData.recipe_name;
			// }
			ft.updateFeeding({
				action: action,
				data: data
			});
		}

		function groupBy(xs, key) {
			return xs.reduce(function (rv, x) {
				(rv[x[key]] = rv[x[key]] || []).push(x);
				return rv;
			}, {});
		}

		$scope.$on('$destroy', function () {
			angular.element('html').removeClass('wait-cursor');
			try {
				if (ft.confirmationPromise) {
					ft.confirmationPromise.reject();
					ft.confirmationPromise = undefined;
				}
			} catch (error) {
				console.error(error);
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.calendar').directive('feedingTable', function () {
		return {
			restrict: 'AE',
			scope: {
				feedingTableData: '=',
				feedingTableUrl: '=',
				updateFeeding: '&',
				deleteFeeding: '&',
				setCalendarDirty: '&',
				reportType: '=',
				redirectId: '=',
				showCost: '='
			},
			template: '<div ng-include="ft.feedingTableUrl"></div>',
			controller: 'feedingTableCtrl',
			controllerAs: 'ft',
			bindToController: true
		};
	});
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.calendar').service('feedingTableService', feedingTableService);
	/** @ngInject */
	function feedingTableService($filter) {
		var loadingData;
		var droppingData;

		var RRule = rrule.RRule;

		return {
			setLoading: setLoading,
			getLoading: getLoading,
			setDropping: setDropping,
			getDropping: getDropping,
			calculateLoadCostPerKg: calculateLoadCostPerKg,
			calculatePenCost: calculatePenCost,
			checkIsReport: checkIsReport,
			checkIsPlanner: checkIsPlanner,
			getFeedingDates: getFeedingDates,
			getPenById: getPenById,
			calculateCalculatedLoadCostPerKg: calculateCalculatedLoadCostPerKg
		};

		function setLoading(list) {
			loadingData = list;
		}

		function getLoading() {
			return loadingData;
		}

		function setDropping(list) {
			droppingData = list;
		}

		function getDropping() {
			return droppingData;
		}

		function calculateLoadCostPerKg(feeding, load_position, loadProp, ingredientProp) {
			var result = 0;
			var cost = 0;
			if (loadingData.length) {
				for (var i = 0; i < loadingData.length; i++) {
					//if (loadingData[i].feeding_id === feeding.feeding_id) {
					if (loadingData[i].feeding_date == feeding.feeding_date && loadingData[i].feeding_number == feeding.feeding_number) {
						for (var j = 0; j < loadingData[i].feeding_loads.length; j++) {
							if (loadingData[i].feeding_loads[j].load_position === load_position) {
								for (var k = 0; k < loadingData[i].feeding_loads[j].load_ingredient_list.length; k++) {
									cost += loadingData[i].feeding_loads[j].load_ingredient_list[k][ingredientProp] * loadingData[i].feeding_loads[j].load_ingredient_list[k].cost;
								}
								result = cost / loadingData[i].feeding_loads[j][loadProp] || 0;
								break;
							}
						}
						break;
					}
				}
			}
			return result;
		}

		function calculateCalculatedLoadCostPerKg(feeding) {
			var result = 0;
			var cost = 0;
			var amount = 0;

			if (feeding.ration) {
				var feeds = feeding.is_premix ? feeding.ration.scheduled_premix_ingredients : feeding.ration.scheduled_ration_feeds;

				if (feeds) {
					feeds.forEach(function (feed) {
						var cost_as_fed = feed.cost_dm * (feed.dm / 100);
						var amount_as_fed = (feed.amount_dm * 100) / feed.dm;
						cost += cost_as_fed * amount_as_fed;
						amount += feed.amount_dm / (feed.dm / 100);
					});

					result = cost / amount || 0;
				}
			}

			return result;
		}

		function calculatePenCost(feeding, pen, type) {
			var totalCost = 0;
			if (type == 1 && loadingData.length) {
				for (var i = 0; i < loadingData.length; i++) {
					if (loadingData[i].feeding_number === feeding.feeding_number) {
						if (loadingData[i].ration) {
							if (loadingData[i].ration.scheduled_ration_feeds) {
								loadingData[i].ration.scheduled_ration_feeds.forEach(function (feed) {
									var cost_as_fed = feed.cost_dm * (feed.dm / 100);
									totalCost += (cost_as_fed * pen.feeding_amount * feed.percentage) / 100;
								});
							}

							if (loadingData[i].ration.scheduled_premix_ingredients) {
								loadingData[i].ration.scheduled_premix_ingredients.forEach(function (feed) {
									var cost_as_fed = feed.cost_dm * (feed.dm / 100);
									totalCost += (cost_as_fed * pen.feeding_amount * feed.percentage) / 100;
								});
							}
						}
						break;
					}
				}
			}

			if (type == 2 && droppingData.length) {
				for (var j = 0; j < droppingData.length; j++) {
					if (droppingData[j].feeding_number === feeding.feeding_number) {
						if (droppingData[j].ration) {
							if (droppingData[j].ration.scheduled_ration_feeds) {
								droppingData[j].ration.scheduled_ration_feeds.forEach(function (feed) {
									var cost_as_fed = feed.cost_dm * (feed.dm / 100);
									totalCost += (cost_as_fed * pen.feeding_amount * feed.percentage) / 100;
								});
							}
						}

						break;
					}
				}
			}

			return totalCost;
		}

		function checkIsReport(feeding, date) {
			for (var i = 0; i < loadingData.length; i++) {
				if (loadingData[i].feeding_number === feeding.feeding_number) {
					for (var j = 0; j < loadingData[i].feeding_loads.length; j++) {
						if (loadingData[i].feeding_loads[j].loading_status) {
							return true;
						}
						var start = loadingData[i].feeding_loads[j].loading_start ? loadingData[i].feeding_loads[j].loading_start : moment.utc(loadingData[i].feeding_date + 'T' + loadingData[i].feeding_loads[j].feeding_time).format('YYYY-MM-DDTHH:mm:ss');
						if (moment(start).isBefore(date)) {
							return true;
						}
					}
				}
			}
			return false;
		}

		function checkIsPlanner(feeding, date) {
			for (var i = 0; i < loadingData.length; i++) {
				if (loadingData[i].feeding_number === feeding.feeding_number) {
					for (var j = 0; j < loadingData[i].feeding_loads.length; j++) {
						var start = loadingData[i].feeding_loads[j].loading_start ? loadingData[i].feeding_loads[j].loading_start : moment.utc(loadingData[i].feeding_date + 'T' + loadingData[i].feeding_loads[j].feeding_time).format('YYYY-MM-DDTHH:mm:ss');
						if (moment(start).isAfter(date)) {
							return true;
						}
					}
				}
			}
			return false;
		}

		function getFeedingDates(type) {
			var list = [];
			var feedingsList = angular.copy(loadingData);
			if (type === 0) {
				feedingsList.forEach(function (feeding) {
					feeding.pen_feedings.forEach(function (penFeeding) {
						penFeeding.pen.pen_feeding_scheduler_list.forEach(function (scheduler) {
							var rrule_start_date = moment(scheduler.start_feeding_date).format('YYYYMMDDT000000') + 'Z';
							var rrule_end_date = feeding.recipe_active ? moment().add(30, 'days').format('YYYYMMDDT000000') + 'Z' : moment(feeding.recipe_modified_date).format('YYYYMMDDT000000') + 'Z';
							var rrule_string = 'DTSTART:' + rrule_start_date + '\nRRULE:' + (scheduler.feeding_frequency_rule ? scheduler.feeding_frequency_rule : 'FREQ=DAILY;INTERVAL=1') + ';UNTIL=' + rrule_end_date;
							var dates = RRule.fromString(rrule_string).all();
							dates.forEach(function (date) {
								list.push(moment(date).format('YYYY-MM-DD'));
							});
						});
					});
				});
				list = list.filter(function (item, pos) {
					return list.indexOf(item) == pos;
				});
			} else {
				var feeding = feedingsList[0];
				var rrule_start_date = moment(feeding.recipe_create_date ? feeding.recipe_create_date : moment().subtract(30, 'days')).format('YYYYMMDDT000000') + 'Z';
				var rrule_end_date = feeding.recipe_active ? moment().add(30, 'days').format('YYYYMMDDT000000') + 'Z' : feeding.recipe_modified_date ? moment(feeding.recipe_modified_date).format('YYYYMMDDT000000') + 'Z' : moment().add(30, 'days').format('YYYYMMDDT000000') + 'Z';
				var rrule_string = 'DTSTART:' + rrule_start_date + '\nRRULE:' + (feeding.premix_repeat_interval ? feeding.premix_repeat_interval : 'FREQ=DAILY;INTERVAL=1') + ';UNTIL=' + rrule_end_date;
				var dates = RRule.fromString(rrule_string).all();
				dates.forEach(function (date) {
					list.push(moment(date).format('YYYY-MM-DD'));
				});
			}
			return $filter('orderBy')(list);
		}

		function getPenById(feeding_id, pen_id) {
			for (var i = 0; i < loadingData.length; i++) {
				if (loadingData[i].feeding_id === feeding_id) {
					for (var j = 0; j < loadingData[i].pen_feedings.length; j++) {
						if (loadingData[i].pen_feedings[j].pen_id === pen_id) {
							return angular.copy(loadingData[i].pen_feedings[j].pen);
						}
					}
				}
			}
		}
	}
})();

(function(){
	'use strict'

	angular.module('Spartan.pages.configurations.equipment').controller('equipmentCtrl', equipmentCtrl);
	/** @ngInject */
	function equipmentCtrl(){
		var vm = this;
	}
})();

(function(){
	'use strict'

	angular.module('Spartan.pages.configurations.locations').controller('locationsCtrl', locationsCtrl);
	/** @ngInject */
	function locationsCtrl(){
		var vm = this;
	}
})();

(function(){
	'use strict'

	angular.module('Spartan.pages.configurations.feeders').controller('feedersCtrl', feedersCtrl);
	/** @ngInject */
	function feedersCtrl(){
		var vm = this;
	}
})();

(function(){
	'use strict'

	angular.module('Spartan.pages.configurations.stock').controller('stockCtrl', stockCtrl);
	/** @ngInject */
	function stockCtrl(){
		var vm = this;
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages').factory('perDayUnitConfigurationService', perDayUnitConfigurationService);

	/** @ngInject */
	function perDayUnitConfigurationService() {
		return {
			SetPerDayConfiguration: SetPerDayConfiguration
		};

		function SetPerDayConfiguration() {
			this.amount = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.amount_dm = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount'],
				number_of_decimals: null
			};
			this.as_fed = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.group_as_fed = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.wt_as_sold = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.nel = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.me = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.nel_89 = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.me_89 = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.nel_01 = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.me_01 = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.nem = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.neg = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.dep = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.de1x = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.dm = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['forcePercentConvertAmountDivisor', 'forceConvertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.ndf = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.cp = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.ca = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.p = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.na = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.lignin = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.adf = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.ndicp = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.adicp = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.starch = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.sugar = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.in_fa = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.ee = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.mg = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.k = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.cl = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.s = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.ash = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.rc = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.rus = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.vitamin_a = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.vitamin_d = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.vitamin_e = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.fos = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.dve = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.oeb = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.cost_dm = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.vem = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.rup_dig = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.b_prot = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.c_prot = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.npncpe = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.rup_89 = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.sfa = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.pufa = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.bhfa = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.fa_dig = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.ca_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.p_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.mg_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.cu_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.fe = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.fe_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.se_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.zn = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.zn_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.ef_ndf_as_ndf = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.ndf_digest = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.rd_ndf = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.disc_fac = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.kd_b_prot = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.nfc_dig = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.rd_starch = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.rd_sol_fiber = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.mo = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.mn = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.teaa = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.diet_dmi = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.ef_ndf_as_dm = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.se = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.co = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.cu = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.i = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.i_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.mn_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.lysine = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.methionine = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.cost_as_sold = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.a_prot = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.dcad = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.nfc = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.rdp = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.rup = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.sol_fiber = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.td_ndf = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.td_nfc = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.td_trup = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.tdn1x = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.mftdn = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.kp_b_prot = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.fa = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.mufa = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.td_fa = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.for_ndf = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.rdom = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.idufa = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.current_quantity = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.percentage = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.rounded_amount = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.mp = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.rdp_01 = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.mp_01 = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.cost_per_cow = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.actual_milk_yield = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['kgToLb', 'roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.rdp01 = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.mp01 = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.target_milk_cost = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertCostDm', 'getSignificant'],
				number_of_decimals: null
			};
			this.actual_milk_cost = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertCostDm', 'getSignificant'],
				number_of_decimals: null
			};
			this.cost_as_fed = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertCostDm', 'getSignificant'],
				number_of_decimals: null
			};
			this.pur_cost = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};

			//group properties

			this.mature_bw = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.target_milk_yield = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.actual_milk_yield = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.farm_milk_price = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.total_bw = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.predicted_base_dmi = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.predicted_adjusted_dmi = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.predicted_daily_gain = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.required_nem_density = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.required_nel_density = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.required_me_density = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.non_pregnant_bc3_bw = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.bw_without_fetus = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.target_non_pregnant_bc3_bw = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.daily_pregnancy_gain = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.target_daily_fg = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.target_daily_bc_gain = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.target_daily_bw_gain = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.target_body_condition_gain = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.target_frame_growth = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
		}
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages').factory('regularUnitConfigurationService', regularUnitConfigurationService);

	/** @ngInject */
	function regularUnitConfigurationService() {
		return {
			SetRegularConfiguration: SetRegularConfiguration
		};

		function SetRegularConfiguration() {
			this.amount = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.amount_dm = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount'],
				number_of_decimals: null
			};
			this.as_fed = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.group_as_fed = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.wt_as_sold = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.nel = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.me = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.nel_89 = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: false,
				allowed_methods: ['convertMjoule', 'roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.me_89 = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: false,
				allowed_methods: ['convertMjoule', 'roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.nel_01 = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.me_01 = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.nem = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.neg = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.dep = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.de1x = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.dm = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 0
				}
			};
			this.ndf = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 0
				}
			};
			this.cp = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 0
				}
			};
			this.ca = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 1
				}
			};
			this.p = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 1
				}
			};
			this.na = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 1
				}
			};
			this.lignin = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 0
				}
			};
			this.adf = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 0
				}
			};
			this.ndicp = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 0
				}
			};
			this.adicp = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 0
				}
			};
			this.starch = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 0
				}
			};
			this.sugar = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 0
				}
			};
			this.in_fa = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 0
				}
			};
			this.ee = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 0
				}
			};
			this.mg = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 1
				}
			};
			this.k = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 1
				}
			};
			this.cl = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 1
				}
			};
			this.s = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 1
				}
			};
			this.ash = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 0
				}
			};
			this.rc = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 0
				}
			};
			this.rus = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 0
				}
			};
			this.vitamin_a = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.vitamin_d = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.vitamin_e = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.fos = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['forcePercentConvertAmountDivisor', 'convertAmountProduct', 'roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.dve = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['forcePercentConvertAmountDivisor', 'convertAmountProduct', 'roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.oeb = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['forcePercentConvertAmountDivisor', 'convertAmountProduct', 'roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.cost_dm = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertCostDm', 'roundValue'],
				number_of_decimals: {
					percentage: 3,
					amount: 3
				}
			};
			this.vem = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.rup_dig = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.b_prot = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.c_prot = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.npncpe = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.rup_89 = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.sfa = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.pufa = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.bhfa = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.fa_dig = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.ca_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.p_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.mg_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.cu_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.fe = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.fe_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.se_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.zn = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.zn_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.ef_ndf_as_ndf = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.ndf_digest = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.rd_ndf = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.disc_fac = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.kd_b_prot = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.nfc_dig = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.rd_starch = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.rd_sol_fiber = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.mo = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.mn = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.teaa = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.diet_dmi = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.ef_ndf_as_dm = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.se = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.co = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.cu = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.i = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.i_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.mn_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.lysine = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.methionine = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.cost_as_sold = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.a_prot = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.dcad = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.nfc = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.rdp = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.rup = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.sol_fiber = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.td_ndf = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.td_nfc = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.td_trup = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.tdn1x = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.mftdn = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.kp_b_prot = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.fa = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.mufa = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.td_fa = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.for_ndf = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.rdom = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.idufa = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.current_quantity = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.percentage = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.rounded_amount = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 0,
					amount: 0
				}
			};
			this.mp = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.rdp_01 = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.mp_01 = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.cost_per_cow = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.actual_milk_yield = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['kgToLb', 'roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.rdp01 = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.mp01 = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.target_milk_cost = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertCostDm', 'getSignificant'],
				number_of_decimals: null
			};
			this.actual_milk_cost = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertCostDm', 'getSignificant'],
				number_of_decimals: null
			};
			this.cost_as_fed = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertCostDm', 'getSignificant'],
				number_of_decimals: null
			};
			this.pur_cost = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertCostDm', 'roundValue'],
				number_of_decimals: {
					percentage: 3,
					amount: 3
				}
			};

			//group properties

			this.mature_bw = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.target_milk_yield = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.actual_milk_yield = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.farm_milk_price = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmountDivisor', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.total_bw = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.predicted_base_dmi = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.predicted_adjusted_dmi = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.predicted_daily_gain = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.required_nem_density = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.required_nel_density = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.required_me_density = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.non_pregnant_bc3_bw = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.bw_without_fetus = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.target_non_pregnant_bc3_bw = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 1,
					amount: 1
				}
			};
			this.daily_pregnancy_gain = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.target_daily_fg = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.target_daily_bc_gain = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.target_daily_bw_gain = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.target_body_condition_gain = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.target_frame_growth = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
		}
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages').factory('significantConfigurationService', significantConfigurationService);

	/** @ngInject */
	function significantConfigurationService() {
		return {
			SetSignificantConfiguration: SetSignificantConfiguration
		};

		function SetSignificantConfiguration() {
			this.amount = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.amount_dm = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount'],
				number_of_decimals: null
			};
			this.as_fed = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: false,
				allowed_methods: ['convertAmount', 'roundValue'],
				number_of_decimals: {
					percentage: 2,
					amount: 2
				}
			};
			this.group_as_fed = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.wt_as_sold = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.nel = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.me = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.nel_89 = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.me_89 = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.nel_01 = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.me_01 = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.nem = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.neg = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.dep = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.de1x = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.dm = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.ndf = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.cp = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.ca = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.p = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.na = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.lignin = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.adf = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.ndicp = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.adicp = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.starch = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.sugar = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.in_fa = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.ee = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.mg = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.k = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.cl = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.s = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.ash = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.rc = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.rus = {
				use_percent: true,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'convertAmountProduct', 'convertPercentage', 'getSignificant'],
				number_of_decimals: null
			};
			this.vitamin_a = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'getSignificant'],
				number_of_decimals: null
			};
			this.vitamin_d = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'getSignificant'],
				number_of_decimals: null
			};
			this.vitamin_e = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'getSignificant'],
				number_of_decimals: null
			};
			this.fos = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['forcePercentConvertAmountDivisor', 'convertAmountProduct', 'getSignificant'],
				number_of_decimals: null
			};
			this.dve = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['forcePercentConvertAmountDivisor', 'convertAmountProduct', 'getSignificant'],
				number_of_decimals: null
			};
			this.oeb = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['forcePercentConvertAmountDivisor', 'convertAmountProduct', 'getSignificant'],
				number_of_decimals: null
			};
			this.cost_dm = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertCostDm', 'getSignificant'],
				number_of_decimals: null
			};
			this.vem = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.rup_dig = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.b_prot = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.c_prot = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.npncpe = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.rup_89 = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.sfa = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.pufa = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.bhfa = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.fa_dig = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.ca_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.p_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.mg_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.cu_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.fe = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.fe_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.se_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.zn = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.zn_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.ef_ndf_as_ndf = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.ndf_digest = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.rd_ndf = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.disc_fac = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.kd_b_prot = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.nfc_dig = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.rd_starch = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.rd_sol_fiber = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.mo = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.mn = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.teaa = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.diet_dmi = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.ef_ndf_as_dm = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.se = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.co = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.cu = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.i = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.i_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.mn_abs = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.lysine = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.methionine = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.cost_as_sold = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.a_prot = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.dcad = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.nfc = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.rdp = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.rup = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.sol_fiber = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.td_ndf = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.td_nfc = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.td_trup = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.tdn1x = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.mftdn = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.kp_b_prot = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.fa = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.mufa = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.td_fa = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.for_ndf = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.rdom = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.idufa = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.current_quantity = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.percentage = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.rounded_amount = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.mp = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.rdp_01 = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.mp_01 = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.cost_per_cow = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.actual_milk_yield = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['kgToLb', 'getSignificant'],
				number_of_decimals: null
			};
			this.rdp01 = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.mp01 = {
				use_percent: false,
				use_lb: false,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['getSignificant'],
				number_of_decimals: null
			};
			this.target_milk_cost = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertCostDm', 'getSignificant'],
				number_of_decimals: null
			};
			this.actual_milk_cost = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertCostDm', 'getSignificant'],
				number_of_decimals: null
			};
			this.cost_as_fed = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertCostDm', 'getSignificant'],
				number_of_decimals: null
			};
			this.pur_cost = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertCostDm', 'getSignificant'],
				number_of_decimals: null
			};

			//group properties

			this.mature_bw = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.target_milk_yield = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.actual_milk_yield = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.farm_milk_price = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmountDivisor', 'getSignificant'],
				number_of_decimals: null
			};
			this.total_bw = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.predicted_base_dmi = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.predicted_adjusted_dmi = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.predicted_daily_gain = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.required_nem_density = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.required_nel_density = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.required_me_density = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: true,
				use_mjoule: true,
				use_significant: true,
				allowed_methods: ['convertMjoule', 'getSignificant'],
				number_of_decimals: null
			};
			this.non_pregnant_bc3_bw = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.bw_without_fetus = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.target_non_pregnant_bc3_bw = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.daily_pregnancy_gain = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.target_daily_fg = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.target_daily_bc_gain = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.target_daily_bw_gain = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.target_body_condition_gain = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
			this.target_frame_growth = {
				use_percent: false,
				use_lb: true,
				use_lb_inverse: false,
				use_mjoule: false,
				use_significant: true,
				allowed_methods: ['convertAmount', 'getSignificant'],
				number_of_decimals: null
			};
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.groups.editGroup').controller('editGroupCtrl', editGroupCtrl);
	/** @ngInject */
	function editGroupCtrl($stateParams, editGroupFactory, APP_CONST, $filter, $locale, unitConversionService, addNewService, $timeout, $state, errorService, toastr) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var timeout;
		var timeoutIC;
		var timeoutCS;
		vm.editLoading = true;
		vm.groupError = false;

		vm.inputChanged = inputChanged;
		vm.selected = selected;
		vm.cowStageChanged = cowStageChanged;
		vm.copyFromTarget = copyFromTarget;
		vm.tabValidation = tabValidation;
		vm.closeEditWindow = closeEditWindow;
		vm.updateGroup = updateGroup;

		vm.group = {};
		init();

		function init() {
			var id = $stateParams.uuid;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.milk_max = unitConversionService.convertData(200, ['kgToLb', 'round:2']);
			vm.weight_max = unitConversionService.convertData(2000, ['kgToLb', 'round:2']);
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			if (!vm.settings.use_kgs) {
				vm.weight = 'lb';
			} else {
				vm.weight = 'kg';
			}
			if (!vm.settings.use_mcal) {
				vm.energy = 'Mjoule';
			} else {
				vm.energy = 'Mcal';
			}
			vm.strategies = [
				{
					name: 'Ignore DCAD considerations',
					id: 'str1'
				}
			];
			vm.selectedDcad_strategy = {
				name: 'Ignore DCAD considerations',
				id: 'str1'
			};
			setanimal_types(APP_CONST.mocks.animal_types);
			setBreeds(APP_CONST.mocks.breeds);
			setCowStages(APP_CONST.mocks.cow_stages);
			getGroup(id);
		}

		function getGroup(id) {
			return editGroupFactory
				.getGroupById(id)
				.then(function (response) {
					vm.defaultValues = response;
					for (var i = 0; i < vm.animal_types.length; i++) {
						if (vm.animal_types[i].type == response.type) {
							vm.selectedAnimalType = vm.animal_types[i];
							break;
						}
					}
					for (var i = 0; i < vm.breeds.length; i++) {
						if (vm.breeds[i].value == response.breed) {
							vm.selectedBreed = vm.breeds[i];
							break;
						}
					}
					if (response.type == 'lactating_cow' || response.type == 'drycow/late_pregnant_heifer') {
						for (var i = 0; i < vm.cow_stages.length; i++) {
							if (vm.cow_stages[i].value == response.cow_stage) {
								vm.selectedCowStage = vm.cow_stages[i];
								break;
							}
						}
						var list = [];
						for (var i = 0; i < vm.cow_stages.length; i++) {
							if (vm.cow_stages[i].type == vm.selectedAnimalType.type) {
								list.push(vm.cow_stages[i]);
							}
						}
						vm.cowStages = list;
					} else {
						vm.selectedCowStage = {
							value: null
						};
					}
					angular.copy(vm.defaultValues, vm.group);
					vm.group.dcad_strategy = {
						name: 'Ignore DCAD considerations',
						id: 'str1'
					};
					vm.group.target_t_protein = round(vm.group.target_t_protein, 2);
					var group_id = localStorage.getItem('group_id');
					vm.editLoading = false;
					/*if (group_id) {
						for (var i = 0; i < vm.herds.length; i++) {
							if (vm.group.herd_id == vm.herds[i].Id) {
								vm.selectedHerd = vm.herds[i];
							}
						}
						if (vm.selectedHerd) {
							getGroupsByHerd(vm.selectedHerd, group_id);
						}
						$timeout(function () {
							vm.editLoading = false;
							vm.loading = false;
							localStorage.removeItem('group_id');
						}, 100);
					} else {
						vm.editLoading = false;
					}*/
				})
				.catch(function (error) {
					console.log(error);
					vm.groupError = true;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_groups_', init);
				});
		}

		function updateGroup() {
			vm.editLoading = true;
			var group = {};
			angular.copy(vm.group, group);
			group.dcad_strategy = group.dcad_strategy.name;
			group.herd_id = vm.defaultValues.herd_id;
			group.id = vm.defaultValues.id;
			group.user_id = vm.user.email;
			return editGroupFactory
				.updateGroup(group)
				.then(function (response) {
					toastr.success(i18nFilter('_toastr_group_updated_'), i18nFilter('_toastr_success_title_'));
					closeEditWindow();
				})
				.catch(function (error) {
					console.log(error);
					vm.editLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_updating_group_');
				});
		}

		function inputChanged(type) {
			if (timeoutIC) {
				$timeout.cancel(timeoutIC);
			}
			timeoutIC = $timeout(function () {
				if (vm.basicInfoForm && !vm.basicInfoForm.$invalid && !vm.animalInfoForm.$invalid && !vm.bwGain.$invalid) {
					vm.showUpdate = true;
					var group = {};
					angular.copy(vm.group, group);
					if (type != 'total_bw') {
						group.total_bw = null;
					}
					if (type != 'bw_without_fetus') {
						group.bw_without_fetus = null;
					}
					if (type != 'target_non_pregnant_bc3_bw') {
						group.target_non_pregnant_bc3_bw = null;
					}
					if (type != 'non_pregnant_bc3_bw') {
						group.non_pregnant_bc3_bw = null;
					}
					if (type == 'days_in_milk') {
						group.days_pregnant = addNewService.getDefaultDaysPregnant(group.type, group.cow_stage, group.days_in_milk);
						group.days_to_achieve_fg = addNewService.getDefaultDaysToAchieveFG(group.type, group.cow_stage, group.days_in_milk, group.target_age, group.current_age);
						group.days_to_achieve_bc = addNewService.getDefaultDaysToAchieveBC(group.type, group.cow_stage, group.days_in_milk, group.target_age, group.current_age);
					}
					if (type == 'target_fat') {
						group.target_t_protein = 1.9 + 0.4 * group.target_fat;
					}
					if (type == 'actual_fat') {
						group.actual_t_protein = 1.9 + 0.4 * group.actual_fat;
					}
					if (type == 'target_age' || type == 'current_age') {
						group.days_to_achieve_bc = addNewService.getDefaultDaysToAchieveBC(group.type, group.cow_stage, group.days_in_milk, group.target_age, group.current_age);
						group.days_to_achieve_fg = addNewService.getDefaultDaysToAchieveFG(group.type, group.cow_stage, group.days_in_milk, group.target_age, group.current_age);
					}
					if (type == 'upcoming_lactation_number') {
						group.lactation_number = group.upcoming_lactation_number - 1;
					}
					if (type == 'days_to_calving') {
						group.days_pregnant = addNewService.getDaysPregnantByDaysToCalving(group.days_to_calving);
						group.days_to_achieve_bc = group.days_to_calving;
						group.days_to_achieve_fg = group.days_to_calving;
					}
					if (type == 'days_pregnant') {
						group.days_to_achieve_bc = addNewService.getDaysToAchieveBCFGByDaysPregnant(group.type, group.days_pregnant, group.days_to_achieve_bc, group.days_in_milk);
						group.days_to_achieve_fg = addNewService.getDaysToAchieveBCFGByDaysPregnant(group.type, group.days_pregnant, group.days_to_achieve_fg, group.days_in_milk);
						group.days_to_calving = 280 - group.days_pregnant;
					}
					if (type == 'lactation_number') {
						vm.showUpdate2 = true;
					}
					if (type == 'mature_bw') {
						vm.showUpdate2 = true;
						vm.showUpdate3 = true;
					}
					if (type == 'target_milk_yield') {
						vm.showUpdate2 = true;
					}
					if (type == 'body_condition_score') {
						vm.showUpdate3 = true;
					}
					if (type == 'target_body_condition_score') {
						vm.showUpdate3 = true;
					}
					if (type == 'days_to_achieve_fg') {
						vm.showUpdate3 = true;
					}
					if (type == 'days_to_achieve_bc') {
						vm.showUpdate3 = true;
					}
					getDefaultCalculations(group);
				}
			}, 500);
		}

		function selected(select_type) {
			if (timeout) {
				$timeout.cancel(timeout);
			}
			timeout = $timeout(function () {
				setBreedAnimalType(select_type, vm.selectedBreed, vm.selectedAnimalType);
				setDefaultValues(vm.selectedBreed, vm.selectedAnimalType, vm.selectedCowStage);
				getDefaultCalculations(vm.defaultValues);
			}, 750);
		}

		function setBreedAnimalType(select_type, breed, type) {
			if (select_type == 'type') {
				defineCowStages(vm.cow_stages, type);
			}
		}

		function defineCowStages(stages, type) {
			var list = [];
			for (var i = 0; i < stages.length; i++) {
				if (stages[i].type == type.type) {
					list.push(stages[i]);
				}
			}
			vm.cowStages = list;
			if (type.type == 'lactating_cow') {
				vm.selectedCowStage = list[2];
			} else if (type.type == 'drycow/late_pregnant_heifer') {
				vm.selectedCowStage = list[0];
			} else {
				vm.selectedCowStage = {
					value: null
				};
			}
		}

		function setDefaultValues(breed, type, stage) {
			vm.defaultValues.current_age = 8;
			vm.defaultValues.target_age = 24;
			vm.defaultValues.total_bw = null;
			vm.defaultValues.bw_without_fetus = null;
			vm.defaultValues.target_non_pregnant_bc3_bw = null;
			vm.defaultValues.non_pregnant_bc3_bw = null;
			vm.defaultValues.mature_bw = addNewService.getDefaultMatureBW(breed.value);
			vm.defaultValues.lactation_number = addNewService.getDefaultLactationNumber(type.type, stage.value);
			vm.defaultValues.days_in_milk = addNewService.getDefaultDaysInMilk(type.type, stage.value);
			vm.defaultValues.days_pregnant = addNewService.getDefaultDaysPregnant(type.type, stage.value, vm.defaultValues.days_in_milk);
			vm.defaultValues.upcoming_lactation_number = addNewService.getDefaultUpcomingLactationNumber(vm.defaultValues.lactation_number);
			vm.defaultValues.target_fat = addNewService.getDefaultTargetFat(breed.value, type.type);
			vm.defaultValues.actual_fat = vm.defaultValues.target_fat;
			vm.defaultValues.body_condition_score = addNewService.getDefaultBCS(vm.defaultValues.days_in_milk, type.type);
			vm.defaultValues.target_body_condition_score = addNewService.getDefaultTargetBCS(type.type, vm.defaultValues.days_in_milk);
			vm.defaultValues.days_to_achieve_bc = addNewService.getDefaultDaysToAchieveBC(type.type, stage.value, vm.defaultValues.days_in_milk, vm.defaultValues.target_age, vm.defaultValues.current_age);
			vm.defaultValues.days_to_achieve_fg = addNewService.getDefaultDaysToAchieveFG(type.type, stage.value, vm.defaultValues.days_in_milk, vm.defaultValues.target_age, vm.defaultValues.current_age);
			vm.defaultValues.target_milk_yield = addNewService.getDefaultDMilkYield(type.type);
			vm.defaultValues.actual_milk_yield = vm.defaultValues.target_milk_yield;
			vm.defaultValues.target_t_protein = addNewService.getDefaultTargetTProtein(type.type);
			vm.defaultValues.actual_t_protein = vm.group.target_t_protein;
			vm.defaultValues.days_to_calving = addNewService.getDefaultDaysToCalving(type.type, stage.value);
			vm.defaultValues.target_lactose = 4.85;
			vm.defaultValues.actual_lactose = 4.85;
			vm.defaultValues.actual_dmi = 0;
			vm.defaultValues.farm_milk_price = 0;
			vm.defaultValues.is_price_per_one = 1;
			vm.defaultValues.dmi_adjustment = 100;
			var name, number_of_animals;
			if (vm.group.name && vm.group.name.length > 0) {
				name = vm.group.name;
			}
			number_of_animals = vm.group.number_of_animals;
			angular.copy(vm.defaultValues, vm.group);
			vm.group.name = name;
			vm.group.number_of_animals = number_of_animals;
		}

		function getDefaultCalculations(group) {
			vm.disableInput = true;
			group.cow_stage = vm.selectedCowStage.value;
			group.dcad_strategy = vm.selectedDcad_strategy.name;
			group.breed = vm.selectedBreed.value;
			group.type = vm.selectedAnimalType.type;
			group.number_of_animals = vm.group.number_of_animals;
			return editGroupFactory
				.getCalculations(group)
				.then(function (response) {
					response.dcad_strategy = {
						name: 'Ignore DCAD considerations',
						id: 'str1'
					};
					response.number_of_animals = group.number_of_animals;
					response.name = vm.group.name;
					response.dmi_adjustment = group.dmi_adjustment;
					response.target_t_protein = round(response.target_t_protein, 2);
					response.actual_t_protein = round(response.actual_t_protein, 2);
					vm.group = response;
					vm.disableInput = false;
				})
				.catch(function (error) {
					vm.disableInput = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_default_calculations_');
				});
		}

		function cowStageChanged() {
			if (timeoutCS) {
				$timeout.cancel(timeoutCS);
			}
			timeoutCS = $timeout(function () {
				vm.defaultValues.lactation_number = addNewService.getDefaultLactationNumber(vm.selectedAnimalType.type, vm.selectedCowStage.value);
				vm.defaultValues.upcoming_lactation_number = addNewService.getDefaultUpcomingLactationNumber(vm.defaultValues.lactation_number);
				vm.defaultValues.days_in_milk = addNewService.getDefaultDaysInMilk(vm.selectedAnimalType.type, vm.selectedCowStage.value);
				vm.defaultValues.days_pregnant = addNewService.getDefaultDaysPregnant(vm.selectedAnimalType.type, vm.selectedCowStage.value, vm.defaultValues.days_in_milk);
				vm.defaultValues.body_condition_score = addNewService.getDefaultBCS(vm.defaultValues.days_in_milk, vm.selectedAnimalType.type);
				vm.defaultValues.target_body_condition_score = addNewService.getDefaultTargetBCS(vm.selectedAnimalType.type, vm.defaultValues.days_in_milk);
				vm.defaultValues.days_to_achieve_bc = addNewService.getDefaultDaysToAchieveBC(vm.selectedAnimalType.type, vm.selectedCowStage.value, vm.defaultValues.days_in_milk, vm.defaultValues.target_age, vm.defaultValues.current_age);
				vm.defaultValues.days_to_achieve_fg = addNewService.getDefaultDaysToAchieveFG(vm.selectedAnimalType.type, vm.selectedCowStage.value, vm.defaultValues.days_in_milk, vm.defaultValues.target_age, vm.defaultValues.current_age);
				vm.defaultValues.target_milk_yield = addNewService.getDefaultDMilkYield(vm.selectedAnimalType.type);
				vm.defaultValues.actual_milk_yield = vm.defaultValues.target_milk_yield;
				vm.defaultValues.target_t_protein = addNewService.getDefaultTargetTProtein(vm.selectedAnimalType.type);
				vm.defaultValues.actual_t_protein = vm.defaultValues.target_t_protein;
				vm.defaultValues.days_to_calving = addNewService.getDefaultDaysToCalving(vm.selectedAnimalType.type, vm.selectedCowStage.value);
				vm.defaultValues.total_bw = null;
				vm.defaultValues.bw_without_fetus = null;
				vm.defaultValues.target_non_pregnant_bc3_bw = null;
				vm.defaultValues.non_pregnant_bc3_bw = null;
				getDefaultCalculations(vm.defaultValues);
			}, 750);
		}

		function tabValidation() {
			return {
				'group-tab-validation': vm.basicInfoForm && vm.basicInfoForm.$invalid && vm.basicInfoForm.$submitted,
				'animal-tab-validation': vm.animalInfoForm && vm.animalInfoForm.$invalid && vm.animalInfoForm.$submitted && !vm.disableInput && !vm.editLoading,
				'gain-tab-validation': vm.bwGain && vm.bwGain.$invalid && vm.bwGain.$submitted && !vm.editLoading && !vm.disableInput
			};
		}

		function copyFromTarget() {
			vm.group.actual_milk_yield = vm.group.target_milk_yield;
			vm.group.actual_fat = vm.group.target_fat;
			vm.group.actual_t_protein = vm.group.target_t_protein;
			vm.group.actual_lactose = vm.group.target_lactose;

			$timeout(function () {
				inputChanged('actual_fat');
			}, 10);
		}

		function closeEditWindow() {
			$state.go('groups.myGroups');
		}

		function setanimal_types(types) {
			for (var i = 0; i < types.length; i++) {
				var temp = '_at_' + types[i].type + '_';
				types[i].name = i18nFilter(temp);
			}
			vm.animal_types = types;
		}

		function setBreeds(breeds) {
			for (var i = 0; i < breeds.length; i++) {
				var temp = '_ab_' + breeds[i].value + '_';
				breeds[i].name = i18nFilter(temp);
			}
			vm.breeds = breeds;
		}

		function setCowStages(stages) {
			for (var i = 0; i < stages.length; i++) {
				var temp = '_acs_' + stages[i].value + '_';
				stages[i].name = $filter('i18n')(temp);
			}
			vm.cow_stages = stages;
		}

		function round(value, decimals) {
			return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.groups.editGroup').factory('editGroupFactory', editGroupFactory);
	/** @ngInject */
	function editGroupFactory($http, APP_CONST, $q) {
		return {
			getGroupById: getGroupById,
			getCalculations: getCalculations,
			updateGroup: updateGroup,
		};

		function getGroupById(groupId) {
			return $http
				.get(APP_CONST.api_base_url + 'groups/' + groupId)
				.then(success)
				.catch(error);
		}

		function getCalculations(group) {
			return $http
				.post(APP_CONST.api_base_url + 'groups/calculations', group)
				.then(success)
				.catch(error);
		}

		function updateGroup(group) {
			return $http
				.put(APP_CONST.api_base_url + 'groups', group)
				.then(success)
				.catch(error);
		}


		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.groups.groupDetails').controller('groupDetailsCtrl', groupDetailsCtrl);
	/** @ngInject */
	function groupDetailsCtrl() {
		var vm = this;
		console.log(vm);
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.groups.groupDetails').factory('groupDetailsFactory', groupDetailsFactory);
	/** @ngInject */
	function groupDetailsFactory() {
		return {};
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.groups.addNewGroup').controller('addNewGroupCtrl', addNewGroupCtrl);
	/** @ngInject */
	function addNewGroupCtrl(APP_CONST, $timeout, addNewService, $state, addNewGroupFactory, toastr, $filter, $locale, $scope, errorService, unitConversionService) {
		var vm = this;
		var timeout;
		var timeoutIC;
		var timeoutCS;
		var i18nFilter = $filter('i18n');
		vm.selected = selected;
		vm.cowStageChanged = cowStageChanged;
		vm.saveGroup = saveGroup;
		vm.cancel = cancel;
		vm.inputChanged = inputChanged;
		vm.tabValidation = tabValidation;

		init();

		function init() {
			vm.loading = true;
			vm.disableInput = false;
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.from_ration = JSON.parse(localStorage.getItem('from_ration'));
			localStorage.removeItem('from_ration');
			vm.milk_max = unitConversionService.convertData(200, ['kgToLb', 'round:2']);
			vm.weight_max = unitConversionService.convertData(2000, ['kgToLb', 'round:2']);
			if (!vm.settings.use_kgs) {
				vm.weight = 'lb';
			} else {
				vm.weight = 'kg';
			}
			if (!vm.settings.use_mcal) {
				vm.energy = 'Mjoule';
			} else {
				vm.energy = 'Mcal';
			}
			vm.group = {
				breed: null,
				type: null,
				number_of_animals: 100
			};
			setAnimalTypes(APP_CONST.mocks.animal_types);
			setBreeds(APP_CONST.mocks.breeds);
			setCowStages(APP_CONST.mocks.cow_stages);
			vm.defaultValues = {};
			setBreedAnimalType('type', vm.selectedBreed, vm.selectedAnimalType);
			setDefaultValues(vm.selectedBreed, vm.selectedAnimalType, vm.selectedCowStage);
			vm.strategies = [
				{
					name: 'Ignore DCAD considerations',
					id: 'str1'
				}
			];
			vm.selectedDcad_strategy = {
				name: 'Ignore DCAD considerations',
				id: 'str1'
			};
			getDefaultCalculations(vm.defaultValues, true);
			if (vm.settings.selectedTeam.id) {
				getHerdsByTeam(vm.settings.selectedTeam.id, true);
			} else {
				$timeout(function () {
					vm.loading = false;
				}, 1000);
			}
		}

		function reloadApi() {
			vm.loading = true;
			vm.disableInput = false;
			getDefaultCalculations(vm.defaultValues, true);
			if (vm.settings.selectedTeam.id) {
				getHerdsByTeam(vm.settings.selectedTeam.id, true);
			} else {
				$timeout(function () {
					vm.loading = false;
				}, 1000);
			}
		}

		function setAnimalTypes(types) {
			for (var i = 0; i < types.length; i++) {
				var temp = '_at_' + types[i].type + '_';
				types[i].name = $filter('i18n')(temp);
			}
			vm.animal_types = types;
			vm.selectedAnimalType = vm.animal_types[1];
		}

		function setBreeds(breeds) {
			for (var i = 0; i < breeds.length; i++) {
				var temp = '_ab_' + breeds[i].value + '_';
				breeds[i].name = $filter('i18n')(temp);
			}
			vm.breeds = breeds;
			vm.selectedBreed = vm.breeds[3];
		}

		function setCowStages(stages) {
			for (var i = 0; i < stages.length; i++) {
				var temp = '_acs_' + stages[i].value + '_';
				stages[i].name = $filter('i18n')(temp);
			}
			vm.allCowStages = stages;
		}

		function selected(select_type) {
			if (timeout) {
				$timeout.cancel(timeout);
			}
			timeout = $timeout(function () {
				setBreedAnimalType(select_type, vm.selectedBreed, vm.selectedAnimalType);
				setDefaultValues(vm.selectedBreed, vm.selectedAnimalType, vm.selectedCowStage);
				getDefaultCalculations(vm.defaultValues);
			}, 750);
		}

		function getHerdsByTeam(teamID, init) {
			return addNewGroupFactory
				.getHerdsByTeam(teamID)
				.then(function (response) {
					vm.loading = false;
					vm.herds = response;
					setDefaultHerd(vm.settings, vm.herds);
				})
				.catch(function (error) {
					console.log(error);
					if (error.status === 403) {
						errorService.showErrorMessage(error, true, '_error_occurred_setting_default_herd_');
					} else {
						errorService.showErrorMessage(error, true, '_error_occurred_loading_herds_', init);
					}
				});
		}

		function getDefaultCalculations(group, init) {
			vm.disableInput = true;
			group.cow_stage = vm.selectedCowStage.value;
			group.dcad_strategy = vm.selectedDcad_strategy.name;
			group.breed = vm.selectedBreed.value;
			group.type = vm.selectedAnimalType.type;
			group.number_of_animals = vm.group.number_of_animals;
			return addNewGroupFactory
				.getCalculations(group)
				.then(function (response) {
					response.dcad_strategy = {
						name: 'Ignore DCAD considerations',
						id: 'str1'
					};
					response.number_of_animals = group.number_of_animals;
					response.name = vm.group.name;
					response.dmi_adjustment = group.dmi_adjustment;
					response.target_t_protein = round(response.target_t_protein, 2);
					response.actual_t_protein = round(response.actual_t_protein, 2);
					vm.group = response;
					vm.disableInput = false;
				})
				.catch(function (error) {
					vm.disableInput = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_default_calculations_', init);
				});
		}

		function setBreedAnimalType(select_type, breed, type) {
			if (select_type == 'type') {
				defineCowStages(vm.allCowStages, type);
			}
		}

		function defineCowStages(stages, type) {
			var list = [];
			for (var i = 0; i < stages.length; i++) {
				if (stages[i].type == type.type) {
					list.push(stages[i]);
				}
			}
			vm.cowStages = list;
			if (type.type == 'lactating_cow') {
				vm.selectedCowStage = list[2];
			} else if (type.type == 'drycow/late_pregnant_heifer') {
				vm.selectedCowStage = list[0];
			} else {
				vm.selectedCowStage = {
					value: null
				};
			}
		}

		function cowStageChanged() {
			if (timeoutCS) {
				$timeout.cancel(timeoutCS);
			}
			timeoutCS = $timeout(function () {
				vm.defaultValues.lactation_number = addNewService.getDefaultLactationNumber(vm.selectedAnimalType.type, vm.selectedCowStage.value);
				vm.defaultValues.upcoming_lactation_number = addNewService.getDefaultUpcomingLactationNumber(vm.defaultValues.lactation_number);
				vm.defaultValues.days_in_milk = addNewService.getDefaultDaysInMilk(vm.selectedAnimalType.type, vm.selectedCowStage.value);
				vm.defaultValues.days_pregnant = addNewService.getDefaultDaysPregnant(vm.selectedAnimalType.type, vm.selectedCowStage.value, vm.defaultValues.days_in_milk);
				vm.defaultValues.body_condition_score = addNewService.getDefaultBCS(vm.defaultValues.days_in_milk, vm.selectedAnimalType.type);
				vm.defaultValues.target_body_condition_score = addNewService.getDefaultTargetBCS(vm.selectedAnimalType.type, vm.defaultValues.days_in_milk);
				vm.defaultValues.days_to_achieve_bc = addNewService.getDefaultDaysToAchieveBC(vm.selectedAnimalType.type, vm.selectedCowStage.value, vm.defaultValues.days_in_milk, vm.defaultValues.target_age, vm.defaultValues.current_age);
				vm.defaultValues.days_to_achieve_fg = addNewService.getDefaultDaysToAchieveFG(vm.selectedAnimalType.type, vm.selectedCowStage.value, vm.defaultValues.days_in_milk, vm.defaultValues.target_age, vm.defaultValues.current_age);
				vm.defaultValues.target_milk_yield = addNewService.getDefaultDMilkYield(vm.selectedAnimalType.type);
				vm.defaultValues.actual_milk_yield = vm.defaultValues.target_milk_yield;
				vm.defaultValues.target_t_protein = addNewService.getDefaultTargetTProtein(vm.selectedAnimalType.type);
				vm.defaultValues.actual_t_protein = vm.defaultValues.target_t_protein;
				vm.defaultValues.days_to_calving = addNewService.getDefaultDaysToCalving(vm.selectedAnimalType.type, vm.selectedCowStage.value);
				vm.defaultValues.total_bw = null;
				vm.defaultValues.bw_without_fetus = null;
				vm.defaultValues.target_non_pregnant_bc3_bw = null;
				vm.defaultValues.non_pregnant_bc3_bw = null;
				getDefaultCalculations(vm.defaultValues);
			}, 750);
		}

		function setDefaultValues(breed, type, stage) {
			vm.defaultValues.current_age = 8;
			vm.defaultValues.target_age = 24;
			vm.defaultValues.total_bw = null;
			vm.defaultValues.bw_without_fetus = null;
			vm.defaultValues.target_non_pregnant_bc3_bw = null;
			vm.defaultValues.non_pregnant_bc3_bw = null;
			vm.defaultValues.mature_bw = addNewService.getDefaultMatureBW(breed.value);
			vm.defaultValues.lactation_number = addNewService.getDefaultLactationNumber(type.type, stage.value);
			vm.defaultValues.days_in_milk = addNewService.getDefaultDaysInMilk(type.type, stage.value);
			vm.defaultValues.days_pregnant = addNewService.getDefaultDaysPregnant(type.type, stage.value, vm.defaultValues.days_in_milk);
			vm.defaultValues.upcoming_lactation_number = addNewService.getDefaultUpcomingLactationNumber(vm.defaultValues.lactation_number);
			vm.defaultValues.target_fat = addNewService.getDefaultTargetFat(breed.value, type.type);
			vm.defaultValues.actual_fat = vm.defaultValues.target_fat;
			vm.defaultValues.body_condition_score = addNewService.getDefaultBCS(vm.defaultValues.days_in_milk, type.type);
			vm.defaultValues.target_body_condition_score = addNewService.getDefaultTargetBCS(type.type, vm.defaultValues.days_in_milk);
			vm.defaultValues.days_to_achieve_bc = addNewService.getDefaultDaysToAchieveBC(type.type, stage.value, vm.defaultValues.days_in_milk, vm.defaultValues.target_age, vm.defaultValues.current_age);
			vm.defaultValues.days_to_achieve_fg = addNewService.getDefaultDaysToAchieveFG(type.type, stage.value, vm.defaultValues.days_in_milk, vm.defaultValues.target_age, vm.defaultValues.current_age);
			vm.defaultValues.target_milk_yield = addNewService.getDefaultDMilkYield(type.type);
			vm.defaultValues.actual_milk_yield = vm.defaultValues.target_milk_yield;
			vm.defaultValues.target_t_protein = addNewService.getDefaultTargetTProtein(type.type);
			vm.defaultValues.actual_t_protein = vm.group.target_t_protein;
			vm.defaultValues.days_to_calving = addNewService.getDefaultDaysToCalving(type.type, stage.value);
			vm.defaultValues.target_lactose = 4.85;
			vm.defaultValues.actual_lactose = 4.85;
			vm.defaultValues.actual_dmi = 0;
			vm.defaultValues.farm_milk_price = 0;
			vm.defaultValues.is_price_per_one = 1;
			vm.defaultValues.dmi_adjustment = 100;
			var name, number_of_animals;
			if (vm.group.name && vm.group.name.length > 0) {
				name = vm.group.name;
			}
			number_of_animals = vm.group.number_of_animals;
			angular.copy(vm.defaultValues, vm.group);
			vm.group.name = name;
			vm.group.number_of_animals = number_of_animals;
		}

		function saveGroup() {
			vm.loading = true;
			var group = {};
			angular.copy(vm.group, group);
			group.herd_id = vm.selectedHerd.Id;
			group.herd_name = vm.selectedHerd.Name;
			group.dcad_strategy = group.dcad_strategy.name;
			group.user_id = vm.user.email;
			addNewGroupFactory
				.addNewGroup(group)
				.then(function () {
					toastr.success(i18nFilter('_toastr_group_created_'), i18nFilter('_toastr_success_title_'));
					vm.loading = false;
					if (vm.from_ration) {
						$state.go('rations.addnewration');
					} else {
						$state.go('groups.myGroups');
					}
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_creating_group_');
				});
		}

		function cancel() {
			if (vm.from_ration) {
				$state.go('rations.addnewration');
			} else {
				$state.go('groups.myGroups');
			}
		}

		function setDefaultHerd(settings, herds) {
			if (settings.selectedHerd) {
				for (var i = 0; i < herds.length; i++) {
					if (herds[i].Id == settings.selectedHerd.id) {
						vm.selectedHerd = herds[i];
						break;
					}
				}
			}
		}

		function inputChanged(type) {
			if (timeoutIC) {
				$timeout.cancel(timeoutIC);
			}
			timeoutIC = $timeout(function () {
				if (!vm.basicInfoForm.$invalid && !vm.bwGain.$invalid && !vm.animalInfoForm.$invalid) {
					var group = {};
					angular.copy(vm.group, group);
					if (type != 'total_bw') {
						group.total_bw = null;
					}
					if (type != 'bw_without_fetus') {
						group.bw_without_fetus = null;
					}
					if (type != 'target_non_pregnant_bc3_bw') {
						group.target_non_pregnant_bc3_bw = null;
					}
					if (type != 'non_pregnant_bc3_bw') {
						group.non_pregnant_bc3_bw = null;
					}
					if (type == 'days_in_milk') {
						group.days_pregnant = addNewService.getDefaultDaysPregnant(group.type, group.cow_stage, group.days_in_milk);
						group.days_to_achieve_fg = addNewService.getDefaultDaysToAchieveFG(group.type, group.cow_stage, group.days_in_milk, group.target_age, group.current_age);
						group.days_to_achieve_bc = addNewService.getDefaultDaysToAchieveBC(group.type, group.cow_stage, group.days_in_milk, group.target_age, group.current_age);
					}
					if (type == 'target_fat') {
						group.target_t_protein = 1.9 + 0.4 * group.target_fat;
					}
					if (type == 'actual_fat') {
						group.actual_t_protein = 1.9 + 0.4 * group.actual_fat;
					}
					if (type == 'target_age' || type == 'current_age') {
						group.days_to_achieve_bc = addNewService.getDefaultDaysToAchieveBC(group.type, group.cow_stage, group.days_in_milk, group.target_age, group.current_age);
						group.days_to_achieve_fg = addNewService.getDefaultDaysToAchieveFG(group.type, group.cow_stage, group.days_in_milk, group.target_age, group.current_age);
					}
					if (type == 'upcoming_lactation_number') {
						group.lactation_number = group.upcoming_lactation_number - 1;
					}
					if (type == 'days_to_calving') {
						group.days_pregnant = addNewService.getDaysPregnantByDaysToCalving(group.days_to_calving);
						group.days_to_achieve_bc = group.days_to_calving;
						group.days_to_achieve_fg = group.days_to_calving;
					}
					if (type == 'days_pregnant') {
						group.days_to_achieve_bc = addNewService.getDaysToAchieveBCFGByDaysPregnant(group.type, group.days_pregnant, group.days_to_achieve_bc, group.days_in_milk);
						group.days_to_achieve_fg = addNewService.getDaysToAchieveBCFGByDaysPregnant(group.type, group.days_pregnant, group.days_to_achieve_fg, group.days_in_milk);
						group.days_to_calving = 280 - group.days_pregnant;
					}
					getDefaultCalculations(group);
				}
			}, 2500);
		}

		function round(value, decimals) {
			return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
		}

		function tabValidation() {
			return {
				'group-tab-validation': vm.basicInfoForm && vm.basicInfoForm.$invalid && vm.basicInfoForm.$submitted,
				'animal-tab-validation': vm.animalInfoForm && vm.animalInfoForm.$invalid && vm.animalInfoForm.$submitted && !vm.disableInput && !vm.editLoading,
				'gain-tab-validation': vm.bwGain && vm.bwGain.$invalid && vm.bwGain.$submitted && !vm.editLoading && !vm.disableInput
			};
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_herd_selected', function (event, data) {
			vm.selectedHerd = data;
		});

		$scope.$on('default_team_selected', function () {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedHerd = null;
			getHerdsByTeam(vm.settings.selectedTeam.id);
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.groups.addNewGroup').service('addNewGroupFactory', addNewGroupFactory);
	/** @ngInject */
	function addNewGroupFactory(APP_CONST, $http, $q) {
		return {
			getCalculations: getCalculations,
			addNewGroup: addNewGroup,
			getHerdsByUser: getHerdsByUser,
			getHerdsByTeam: getHerdsByTeam
		};

		function getCalculations(group) {
			return $http
				.post(APP_CONST.api_base_url + 'groups/calculations', group)
				.then(success)
				.catch(error);
		}

		function getHerdsByTeam(teamID) {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams/' + teamID + '/herds')
				.then(success)
				.catch(error);
		}

		function getHerdsByUser() {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/herds')
				.then(success)
				.catch(error);
		}

		function addNewGroup(group) {
			return $http
				.post(APP_CONST.api_base_url + 'groups', group)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.groups.addNewGroup').service('addNewService', addNewService);
	/** @ngInject */
	function addNewService() {
		return {
			getDefaultMatureBW: getDefaultMatureBW,
			getDefaultLactationNumber: getDefaultLactationNumber,
			getDefaultUpcomingLactationNumber: getDefaultUpcomingLactationNumber,
			getDefaultTargetFat: getDefaultTargetFat,
			getDefaultBCS: getDefaultBCS,
			getDefaultDaysInMilk: getDefaultDaysInMilk,
			getDefaultTargetBCS: getDefaultTargetBCS,
			getDefaultDaysPregnant: getDefaultDaysPregnant,
			getDefaultDaysToAchieveBC: getDefaultDaysToAchieveBC,
			getDefaultDaysToAchieveFG: getDefaultDaysToAchieveFG,
			getDefaultDMilkYield: getDefaultDMilkYield,
			getDefaultTargetTProtein: getDefaultTargetTProtein,
			getDefaultDaysToCalving: getDefaultDaysToCalving,
			getDaysPregnantByDaysToCalving: getDaysPregnantByDaysToCalving,
			getDaysToAchieveBCFGByDaysPregnant: getDaysToAchieveBCFGByDaysPregnant
		};

		function getDefaultMatureBW(breed) {
			switch (breed) {
				case 'ayrshire':
				case 'midsize_breed': {
					return 544;
				}
				case 'guernsey': {
					return 499;
				}
				case 'jersey':
				case 'small_breed': {
					return 454;
				}
				default: {
					return 680;
				}
			}
		}

		function getDefaultLactationNumber(type, stage) {
			switch (type) {
				case 'heifer': {
					return 0;
				}
				case 'drycow/late_pregnant_heifer': {
					if (stage == 'dry_cow' || stage == 'close_up_cow') {
						return 1;
					} else if (stage == 'pregnant_heifer' || stage == 'close_up_heifer') {
						return 0;
					}
					break;
				}
				default: {
					return 2;
				}
			}
		}

		function getDefaultTargetFat(breed, type) {
			if (type == 'lactating_cow') {
				switch (breed) {
					case 'ayrshire':
					case 'midsize_breed': {
						return 3.9;
					}
					case 'brown_swiss': {
						return 4.0;
					}
					case 'guernsey': {
						return 4.5;
					}
					case 'jersey':
					case 'small_breed': {
						return 4.7;
					}
					default: {
						return 3.5;
					}
				}
			} else {
				return 0;
			}
		}

		function getDefaultBCS(days, type) {
			switch (type) {
				case 'heifer': {
					return 3.0;
				}
				case 'lactating_cow': {
					if (days >= 31 && days <= 270) {
						return 3.0;
					} else {
						return 3.5;
					}
				}
				default: {
					return 3.5;
				}
			}
		}

		function getDefaultDaysInMilk(type, stage) {
			if (type == 'lactating_cow') {
				switch (stage) {
					case 'fresh_cow': {
						return 10;
					}
					case 'early_lac_cow': {
						return 60;
					}
					case 'late_lac_cow': {
						return 240;
					}
					case 'pre_dry_cow': {
						return 320;
					}
					default: {
						return 120;
					}
				}
			} else {
				return 0;
			}
		}

		function getDefaultTargetBCS(type, days) {
			switch (type) {
				case 'heifer': {
					return 3.0;
				}
				case 'lactating_cow': {
					if (days >= 31 && days <= 60) {
						return 3.0;
					} else {
						return 3.5;
					}
				}
				default: {
					return 3.5;
				}
			}
		}

		function getDefaultUpcomingLactationNumber(number) {
			return number + 1;
		}

		function getDefaultDaysPregnant(type, stage, daysInMilk) {
			if (type == 'drycow/late_pregnant_heifer') {
				if (stage == 'dry_cow' || stage == 'pregnant_heifer') {
					return 240;
				} else if (stage == 'close_up_cow' || stage == 'close_up_heifer') {
					return 259;
				}
			} else if (type == 'lactating_cow') {
				var diference;
				diference = daysInMilk - 120;
				if (diference > 0) {
					if (diference > 220) {
						return 220;
					} else {
						return diference;
					}
				} else {
					return 0;
				}
			} else {
				return 0;
			}
		}

		function getDefaultDaysToAchieveBC(type, stage, daysInMilk, target_age, current_age) {
			var temp;
			switch (type) {
				case 'drycow/late_pregnant_heifer': {
					if (stage == 'close_up_cow') {
						return 21;
					} else {
						return 40;
					}
				}
				case 'lactating_cow': {
					if (daysInMilk <= 120) {
						return 100;
					} else {
						temp = 400 - daysInMilk;
						if (temp > 0) {
							return temp;
						} else {
							return 280;
						}
					}
				}
				case 'heifer': {
					if (target_age >= current_age) {
						temp = (target_age - current_age) * 30.44;
						return round(temp, 0);
					} else {
						return 0;
					}
				}
				default: {
					return 0;
				}
			}
		}

		function getDefaultDaysToAchieveFG(type, stage, daysInMilk, target_age, current_age) {
			var temp;
			switch (type) {
				case 'drycow/late_pregnant_heifer': {
					if (stage == 'close_up_cow') {
						return 21;
					} else {
						return 40;
					}
				}
				case 'lactating_cow': {
					temp = 400 - daysInMilk;
					if (temp > 0) {
						return temp;
					} else {
						return 280;
					}
				}
				case 'heifer': {
					if (target_age >= current_age) {
						temp = (target_age - current_age) * 30.44;
						return round(temp, 0);
					} else {
						return 0;
					}
				}
				default: {
					return 0;
				}
			}
		}

		function getDefaultDMilkYield(type) {
			switch (type) {
				case 'lactating_cow': {
					return 40;
				}
				default: {
					return 0;
				}
			}
		}

		function getDefaultTargetTProtein(type) {
			switch (type) {
				case 'lactating_cow': {
					return 3.3;
				}
				default: {
					return 0;
				}
			}
		}

		function getDefaultDaysToCalving(type, stage) {
			if (type == 'drycow/late_pregnant_heifer') {
				if (stage == 'dry_cow' || stage == 'pregnant_heifer') {
					return 40;
				} else if (stage == 'close_up_cow' || stage == 'close_up_heifer') {
					return 21;
				}
			} else {
				return 280;
			}
		}

		function getDaysPregnantByDaysToCalving(days_to_calving) {
			var temp;
			temp = 280 - days_to_calving;
			if (temp > 0) {
				return temp;
			} else {
				return 0;
			}
		}

		function getDaysToAchieveBCFGByDaysPregnant(type, days_pregnant, days, days_in_milk) {
			var temp;
			if (type == 'heifer') {
				return days;
			} else if (type == 'lactating_cow') {
				temp = 400 - days_in_milk;
				if (temp > 0) {
					return temp;
				} else {
					return 0;
				}
			} else if (type == 'drycow/late_pregnant_heifer') {
				temp = 280 - days_pregnant;
				if (temp > 0) {
					return temp;
				} else {
					return 0;
				}
			}
		}

		function round(value, decimals) {
			return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.groups.myGroups').controller('mygroupsCtrl', groupsCtrl);
	/** @ngInject */
	function groupsCtrl(APP_CONST, $state, $filter, myGroupsFactory, $locale, $timeout, addNewService, toastr, $uibModal, $uibModalStack, $scope, errorService, unitConversionService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		vm.groups = [];
		vm.group = {};
		vm.defaultValues = {};
		vm.editGroup = editGroup;
		vm.groupDetails = groupDetails;
		vm.deleteGroup = deleteGroup;
		vm.goToHistory = goToHistory;
		vm.cancel = cancel;
		vm.deleteGroupProceed = deleteGroupProceed;
		vm.closeEditWindow = closeEditWindow;
		vm.closeDetailsWindow = closeDetailsWindow;
		vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
		init();

		function init() {
			vm.selectedHerd = null;
			vm.loading = true;
			vm.showDetails = false;
			vm.showEdit = false;
			vm.disableInput = false;
			vm.groupError = false;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.milk_max = unitConversionService.convertData(200, ['kgToLb', 'round:2']);
			vm.weight_max = unitConversionService.convertData(2000, ['kgToLb', 'round:2']);
			if (!vm.settings.use_kgs) {
				vm.weight = 'lb';
			} else {
				vm.weight = 'kg';
			}
			if (!vm.settings.use_mcal) {
				vm.energy = 'Mjoule';
			} else {
				vm.energy = 'Mcal';
			}
			vm.strategies = [
				{
					name: 'Ignore DCAD considerations',
					id: 'str1'
				}
			];
			vm.selectedDcad_strategy = {
				name: 'Ignore DCAD considerations',
				id: 'str1'
			};
			setanimal_types(APP_CONST.mocks.animal_types);
			setBreeds(APP_CONST.mocks.breeds);
			setCowStages(APP_CONST.mocks.cow_stages);
			if (vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd;
				getGroupsByHerd(vm.settings.selectedHerd.id, true);
			} else {
				vm.loading = false;
			}
		}


		function setanimal_types(types) {
			for (var i = 0; i < types.length; i++) {
				var temp = '_at_' + types[i].type + '_';
				types[i].name = i18nFilter(temp);
			}
			vm.animal_types = types;
		}

		function setBreeds(breeds) {
			for (var i = 0; i < breeds.length; i++) {
				var temp = '_ab_' + breeds[i].value + '_';
				breeds[i].name = i18nFilter(temp);
			}
			vm.breeds = breeds;
		}

		function setCowStages(stages) {
			for (var i = 0; i < stages.length; i++) {
				var temp = '_acs_' + stages[i].value + '_';
				stages[i].name = $filter('i18n')(temp);
			}
			vm.cow_stages = stages;
		}


		function getGroupsByHerd(herd_id, group_id, init) {
			vm.loading = true;
			return myGroupsFactory
				.getMyGroupsByHerd(herd_id)
				.then(function (response) {
					for (var i = 0; i < response.length; i++) {
						for (var j = 0; j < vm.animal_types.length; j++) {
							if (response[i].type == vm.animal_types[j].type) {
								response[i].type = vm.animal_types[j];
								break;
							}
						}
						for (var k = 0; k < vm.breeds.length; k++) {
							if (response[i].breed == vm.breeds[k].value) {
								response[i].breed = vm.breeds[k];
								break;
							}
						}
						if (group_id) {
							if (response[i].id == group_id) {
								vm.selectedGroupIndex = i;
							}
						}
					}
					vm.groups = response;
					vm.groupsSafe = response;
					vm.groupsCopy = angular.copy(response);
					getItemsPerPage();
					vm.loading = false;
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_groups_', init);
				});
		}

		function getItemsPerPage() {
			var l = vm.groups.length;
			vm.itemsPerPageValues = [];
			if (l > 5) {
				vm.itemsPerPageValues.push(5);
				vm.itemsPerPageValues.push(10);
			}
			if (l > 10) {
				vm.itemsPerPageValues.push(15);
			}
			if (l > 15) {
				vm.itemsPerPageValues.push(20);
			}
			if (l > 20) {
				vm.itemsPerPageValues.push(25);
			}
		}

		function goToHistory(id) {
			$state.go('groups.groupHistory', {
				uuid: id
			});
		}

		function editGroup(id) {
			$state.go('groups.editGroup', {
				uuid: id
			});
		}

		function groupDetails(id, index) {
			vm.groupError = false;
			vm.selectedGroupIndex = index;
			vm.detailsLoading = true;
			vm.showEdit = false;
			vm.showDetails = true;
			myGroupsFactory
				.getGroupById(id)
				.then(function (response) {
					vm.details = response;
					for (var i = 0; i < vm.breeds.length; i++) {
						if (vm.breeds[i].value == response.breed) {
							response.breed = vm.breeds[i];
							break;
						}
					}
					for (var j = 0; j < vm.animal_types.length; j++) {
						if (vm.animal_types[j].type == response.type) {
							response.animal_type = vm.animal_types[j];
							break;
						}
					}
					for (var k = 0; k < vm.cow_stages.length; k++) {
						if (vm.cow_stages[k].value == response.cow_stage) {
							response.cow_stage = vm.cow_stages[k];
							break;
						}
					}
					vm.detailsLoading = false;
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_group_details_');
				});
		}

		function deleteGroup(group) {
			var temp = {};
			angular.copy(group, temp);
			temp.type = temp.type.type;
			temp.breed = temp.breed.value;
			temp.user_id = vm.user.email;
			for (var i = 0; i < vm.groupsCopy.length; i++) {
				if (temp.id == vm.groupsCopy[i].id) {
					temp.index = i;
					break;
				}
			}
			vm.groupToDelete = temp;
			openModal();
		}

		function deleteGroupProceed() {
			vm.showDetails = false;
			vm.showEdit = false;
			vm.modalLoading = true;
			return myGroupsFactory
				.deleteGroup(vm.groupToDelete)
				.then(function () {
					vm.groupsCopy.splice(vm.groupToDelete.index, 1);
					vm.groups = angular.copy(vm.groupsCopy);
					vm.groupsSafe = vm.groups;
					getItemsPerPage();
					$uibModalStack.dismissAll();
					vm.groupToDelete = null;
					vm.modalLoading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.modalLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_deleting_group_');
				});
		}

		function openModal() {
			$uibModal.open({
				animation: true,
				templateUrl: 'app/pages/groups/myGroups/deleteGroup.modal.html',
				size: 'md',
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function cancel() {
			$uibModalStack.dismissAll();
			vm.groupToDelete = null;
		}

		function closeEditWindow() {
			vm.showEdit = false;
			vm.selectedGroupIndex = null;
		}

		function closeDetailsWindow() {
			vm.showDetails = false;
			vm.selectedGroupIndex = null;
		}

		$scope.$on('reload_apis', function () {
			init();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});

		$scope.$on('default_team_herd_changed', function () {
			init();
		});
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.groups.myGroups').factory('myGroupsFactory', myGroupsFactory);

	/** @ngInject */
	function myGroupsFactory(APP_CONST, $http, $q) {
		return {
			getMyGroupsByHerd: getMyGroupsByHerd,
			getHerdsByUser: getHerdsByUser,
			deleteGroup: deleteGroup,
			getGroupById: getGroupById,
			getCalculations: getCalculations,
			updateGroup: updateGroup,
			getHerdsByTeam: getHerdsByTeam
		};

		function getMyGroupsByHerd(herdId) {
			return $http
				.get(APP_CONST.api_base_url + 'herds/' + herdId + '/groups')
				.then(success)
				.catch(error);
		}

		function getHerdsByUser() {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/herds')
				.then(success)
				.catch(error);
		}

		function getHerdsByTeam(teamID) {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams/' + teamID + '/herds')
				.then(success)
				.catch(error);
		}

		function deleteGroup(group) {
			return $http
				.post(APP_CONST.api_base_url + 'group/remove', group)
				.then(success)
				.catch(error);
		}

		function getGroupById(groupId) {
			return $http
				.get(APP_CONST.api_base_url + 'groups/' + groupId)
				.then(success)
				.catch(error);
		}

		function getCalculations(group) {
			return $http
				.post(APP_CONST.api_base_url + 'groups/calculations', group)
				.then(success)
				.catch(error);
		}

		function updateGroup(group) {
			return $http
				.put(APP_CONST.api_base_url + 'groups', group)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.groups.groupHistory').controller('groupHistoryCtrl', groupHistoryCtrl);
	/** @ngInject */
	function groupHistoryCtrl(groupHistoryFactory, $stateParams, APP_CONST, $filter, $timeout, $window, $scope, errorService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		vm.getDetails = getDetails;
		vm.goBack = goBack;
		init();

		function init() {
			vm.showDetails = false;
			vm.loading = true;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedHerd = vm.settings.selectedHerd.id;
			vm.hideHistory = hideHistory;
			if (vm.selectedHerd) {
				getHistory(vm.selectedHerd, true);
			} else {
				vm.loading = false;
			}
			if (!vm.settings.use_kgs) {
				vm.weight = 'lb';
			} else {
				vm.weight = 'kg';
			}
			if (!vm.settings.use_mcal) {
				vm.energy = 'Mjoule';
			} else {
				vm.energy = 'Mcal';
			}
			setAnimalTypes(APP_CONST.mocks.animal_types);
			setBreeds(APP_CONST.mocks.breeds);
			setCowStages(APP_CONST.mocks.cow_stages);
		}

		function reloadApi() {
			vm.showDetails = false;
			vm.loading = true;
			if (vm.selectedHerd) {
				getHistory(vm.selectedHerd, true);
			} else {
				vm.loading = false;
			}
		}

		function setAnimalTypes(types) {
			for (var i = 0; i < types.length; i++) {
				var temp = '_at_' + types[i].type + '_';
				types[i].name = i18nFilter(temp);
			}
			vm.animalTypes = types;
		}

		function setBreeds(breeds) {
			for (var i = 0; i < breeds.length; i++) {
				var temp = '_ab_' + breeds[i].value + '_';
				breeds[i].name = i18nFilter(temp);
			}
			vm.breeds = breeds;
		}

		function setCowStages(stages) {
			for (var i = 0; i < stages.length; i++) {
				var temp = '_acs_' + stages[i].value + '_';
				stages[i].name = $filter('i18n')(temp);
			}
			vm.cow_stages = stages;
		}

		function getHistory(herdId, init) {
			return groupHistoryFactory
				.getHistory($stateParams.uuid, herdId)
				.then(function (response) {
					vm.groups = response;
					vm.loading = false;
				})
				.catch(function (error) {
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_group_history_', init);
				});
		}

		function getDetails(id, index) {
			vm.detailsLoading = true;
			vm.showDetails = true;
			vm.selectedGroup = index;
			vm.details = {};
			for (var i = 0; i < vm.groups.length; i++) {
				if (vm.groups[i].id == id) {
					vm.details = vm.groups[i];
					for (var j = 0; j < vm.breeds.length; j++) {
						if (vm.breeds[j].value == vm.details.breed) {
							vm.details.breed = vm.breeds[j];
							break;
						}
					}
					for (var k = 0; k < vm.animalTypes.length; k++) {
						if (vm.animalTypes[k].type == vm.details.type) {
							vm.details.animal_type = vm.animalTypes[k];
							break;
						}
					}
					for (var l = 0; l < vm.cow_stages.length; l++) {
						if (vm.cow_stages[l].value == vm.details.cow_stage) {
							vm.details.cow_stage = vm.cow_stages[l];
							break;
						}
					}
					break;
				}
			}
			$timeout(function () {
				vm.detailsLoading = false;
			}, 500);
		}

		function hideHistory() {
			vm.showDetails = false;
			vm.selectedGroup = null;
		}

		function goBack() {
			$window.history.back();
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});

		$scope.$on('default_team_selected', function () {
			vm.selectedHerd = null;
			init();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.groups.groupHistory').factory('groupHistoryFactory', groupHistoryFactory);
	/** @ngInject */
	function groupHistoryFactory($http, APP_CONST, $q) {
		return {
			getHistory: getHistory
		};

		function getHistory(groupId, herdId) {
			return $http
				.get(APP_CONST.api_base_url + 'herds/' + herdId + '/groupHistory/' + groupId)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.herds.addNewHerd').controller('addNewHerdCtrl', addNewHerdCtrl);
	/** @ngInject */
	function addNewHerdCtrl(addNewHerdFactory, $rootScope, $scope, $state, errorService) {
		var vm = this;
		vm.addNewHerd = addNewHerd;
		vm.cancel = cancel;
		init();

		function init() {
			vm.selectPlaceholder = '_picker_country_placeholder_';
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			if (vm.settings.selectedTeam.id) {
				vm.selectedTeam = vm.settings.selectedTeam;
			}
		}

		function addNewHerd() {
			if (!vm.herdForm.$invalid) {
				clearCache();
				vm.loading = true;
				vm.herdDTO.Email = vm.user.email;
				return addNewHerdFactory.addNewHerd(vm.herdDTO, vm.selectedTeam.id).then(function () {
					brodcastNewHerd();
					vm.loading = false;
					$state.go('herds.myHerds');
				}).catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_creating_herd_');
					vm.loading = false;
				})
			}
		}

		function clearCache() {
			return addNewHerdFactory.clearCache().then().catch(function () {
				errorService.showErrorMessage(error, true, '_error_occurred_clearing_cache_');
			})
		}

		function cancel() {
			$state.go('herds.myHerds')
		}

		$scope.$on('default_team_selected', function () {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedTeam = vm.settings.selectedTeam
		})

		function brodcastNewHerd() {
			$rootScope.$broadcast('new_herd');
		}
	}
})();
(function () {
	'use strict';
	angular.module('Spartan.pages.herds.addNewHerd').factory('addNewHerdFactory', addNewHerdFactory);
	/** @ngInject */
	function addNewHerdFactory(APP_CONST, $http, $q) {
		return {
			addNewHerd: addNewHerd,
			getUserInfo: getUserInfo,
			clearCache: clearCache
		};

		function addNewHerd(herd, teamId) {
			return $http
				.post(APP_CONST.api_base_url + 'backoffice/teams/' + teamId + '/addherd', herd)
				.then(success)
				.catch(error);
		}

		function getUserInfo() {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/users')
				.then(success)
				.catch(error);
		}

		function clearCache() {
			return $http
				.post(APP_CONST.api_base_url + 'userSettings/remove/cache')
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.herds.myHerds').controller('myHerdsCtrl', myHerdsCtrl);
	/** @ngInject */
	function myHerdsCtrl(myHerdsFactory, toastr, $rootScope, $filter, $scope, errorService, $uibModal, $uibModalStack, $timeout, authService) {
		var vm = this;
		vm.setAsDefault = setAsDefault;
		vm.teamSelected = teamSelected;
		vm.deselectHerd = deselectHerd;
		vm.reloadApi = reloadApi;
		vm.openInterface = openInterface;
		vm.closeModal = closeModal;
		vm.generateToken = generateToken;
		vm.copyToClipboard = copyToClipboard;
		vm.regenerateToken = regenerateToken;
		init();

		function init() {
			vm.loading = true;
			vm.showLinkIcon = false;
			vm.numberOfColumns = 3;
			// if (authService.can(256)) {
			// 	vm.showLinkIcon = true;
			// 	vm.numberOfColumns = 4;
			// }
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			getTeamsByUser();
		}

		function reloadApi() {
			vm.loading = true;
			getTeamsByUser();
		}

		function checkDefaultTeam(settings, teams) {
			if (settings.selectedTeam) {
				for (var i = 0; i < teams.length; i++) {
					if (settings.selectedTeam.id == teams[i].Id) {
						vm.selectedTeam = teams[i];
						break;
					}
				}
				if (vm.selectedTeam) {
					getHerdsByTeamId(vm.selectedTeam, true);
				}
			}
		}

		function getTeamsByUser() {
			return myHerdsFactory
				.getTeamsByUser()
				.then(function (response) {
					vm.teams = response;
					vm.loading = false;
					checkDefaultTeam(vm.settings, vm.teams);
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_teams_', true);
				});
		}

		function getHerdsByTeamId(team, init) {
			vm.loadingTable = true;
			return myHerdsFactory
				.getHerdsByTeam(team.Id)
				.then(function (response) {
					vm.herds = response;
					vm.herdsSafe = vm.herds;
					var l = vm.herds.length;
					vm.itemsPerPageValues = [];
					if (l > 5) {
						vm.itemsPerPageValues.push(5);
						vm.itemsPerPageValues.push(10);
					}
					if (l > 10) {
						vm.itemsPerPageValues.push(15);
					}
					if (l > 15) {
						vm.itemsPerPageValues.push(20);
					}
					if (l > 20) {
						vm.itemsPerPageValues.push(25);
					}
					setDefaultHerd(vm.herds);
				})
				.catch(function (error) {
					console.log(error);
					vm.loadingTable = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_herds_', init);
				});
		}

		function setDefaultHerd(herds) {
			if (vm.settings.selectedHerd) {
				for (var i = 0; i < herds.length; i++) {
					if (vm.settings.selectedHerd.id == herds[i].Id) {
						vm.herds[i].isDefault = true;
					} else {
						vm.herds[i].isDefault = false;
					}
				}
			}
			vm.loadingTable = false;
		}

		function deselectHerd() {
			var temp = {
				team_id: vm.selectedTeam.Id
			};
			var tempHerds = [];
			angular.copy(vm.herds, tempHerds);
			for (var i = 0; i < tempHerds.length; i++) {
				tempHerds[i].isDefault = false;
			}
			vm.herds = tempHerds;
			var suffix = '?email=' + encodeURIComponent(vm.user.email);
			return myHerdsFactory
				.setDefaultHerd(temp, suffix)
				.then(function (response) {
					localStorage.setItem('user_settings', JSON.stringify(response));
					brodcastTeamSelected(vm.selectedTeam);
				})
				.catch(function (error) {
					console.log(error);
					if (error.status === 403) {
						getHerdsByTeamId(vm.selectedTeam);
					}
					errorService.showErrorMessage(error, true, '_error_occurred_setting_default_herd_');
				});
		}

		function teamSelected() {
			getHerdsByTeamId(vm.selectedTeam);
		}

		function setAsDefault(herd, index) {
			if (herd.isDefault) {
				deselectHerd(herd, index);
			} else {
				var temp = {
					herd_id: herd.Id
				};
				var tempHerds = [];
				angular.copy(vm.herds, tempHerds);
				for (var i = 0; i < tempHerds.length; i++) {
					if (herd.Id == tempHerds[i].Id) {
						tempHerds[i].isDefault = true;
					} else {
						tempHerds[i].isDefault = false;
					}
				}
				vm.herds = tempHerds;
				var suffix = '';
				return myHerdsFactory
					.setDefaultHerd(temp, suffix)
					.then(function (response) {
						localStorage.setItem('user_settings', JSON.stringify(response));
						toastr.success($filter('i18n')('_toastr_default_herd_selected_'));
						brodcastHerdSelected(herd);
					})
					.catch(function (error) {
						console.log(error);
						if (error.status === 403) {
							errorService.showErrorMessage(error, true, '_error_occurred_setting_default_herd_');
							getHerdsByTeamId(vm.selectedTeam);
						} else {
							errorService.showErrorMessage(error, true, '_error_occurred_changing_default_herd_');
						}
					});
			}
		}

		function openInterface(herd) {
			vm.token = null;
			vm.staticToken = null;
			vm.loadingInterfaceModal = true;
			vm.interfaceModalError = false;
			vm.interfaceHerd = herd;
			openModal('app/pages/herds/myHerds/interface.modal.html', 'md');
			checkIsTokenGenerated(herd);
		}

		function checkIsTokenGenerated(herd) {
			return myHerdsFactory
				.checkIsTokenGenerated(herd.Id)
				.then(function (response) {
					vm.loadingInterfaceModal = false;
					if (response.create_date) {
						vm.staticToken = response;
					} else {
						vm.staticToken = null;
					}
				})
				.catch(function (error) {
					vm.loadingInterfaceModal = false;
					vm.interfaceModalError = true;
				});
		}

		function generateToken() {
			vm.loadingInterfaceModal = true;
			vm.errorGeneratingToken = false;
			var body = {
				herd_id: vm.interfaceHerd.Id
			};
			return myHerdsFactory
				.generateToken(body)
				.then(function (response) {
					vm.token = response.token;
					vm.staticToken = response;
					vm.loadingInterfaceModal = false;
				})
				.catch(function (error) {
					vm.errorGeneratingToken = true;
					vm.loadingInterfaceModal = false;
				});
		}

		function regenerateToken() {
			generateToken();
		}

		function copyToClipboard() {
			try {
				navigator.clipboard.writeText(vm.token);
			} catch (error) {}
		}

		function openModal(page, size) {
			return $uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		function brodcastHerdSelected(herd) {
			$rootScope.$broadcast('default_herd_selected_from_herds', herd);
		}

		function brodcastTeamSelected(herd) {
			$rootScope.$broadcast('default_team_selected_from_herds', herd);
		}

		$scope.$on('default_team_selected', function () {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			init();
		});

		$scope.$on('default_herd_selected', function () {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			init();
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.herds.myHerds').factory('myHerdsFactory', myHerdsFactory);
	/** @ngInject */
	function myHerdsFactory(APP_CONST, $http, $q) {
		return {
			getTeamsByUser: getTeamsByUser,
			getHerdsByTeam: getHerdsByTeam,
			setDefaultHerd: setDefaultHerd,
			checkIsTokenGenerated: checkIsTokenGenerated,
			deleteToken: deleteToken,
			generateToken: generateToken
		};

		function getTeamsByUser() {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams')
				.then(success)
				.catch(error);
		}

		function getHerdsByTeam(id) {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams/' + id + '/herds')
				.then(success)
				.catch(error);
		}

		function setDefaultHerd(obj, suffix) {
			return $http
				.patch(APP_CONST.api_base_url + 'userSettings' + suffix, obj)
				.then(success)
				.catch(error);
		}

		function checkIsTokenGenerated(herd_id) {
			return $http
				.get(APP_CONST.api_base_url + 'token/info?herdId=' + herd_id)
				.then(success)
				.catch(error);
		}

		function deleteToken(herd_id) {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams')
				.then(success)
				.catch(error);
		}

		function generateToken(body) {
			return $http
				.post(APP_CONST.api_base_url + 'token/generation', body)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.addNewFeed').controller('newFeedCtrl', newFeedCtrl);
	/** @ngInject */
	function newFeedCtrl(APP_CONST, newFeedFactory, toastr, $state, $filter, $locale, $rootScope, $timeout, $uibModal, $scope, settingsFactory, dashboardFactory, $http, errorService, $cookies) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var timeoutSearch;
		var current_time = new Date();
		var feedDTO;
		vm.feeds = [];
		vm.weight = 'kg';
		vm.energy = 'Mcal';
		vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
		vm.saveFeed = saveFeed;
		vm.saveFeedProceed = saveFeedProceed;
		vm.source = source;
		vm.selectFeed = selectFeed;
		vm.teamSelected = teamSelected;
		vm.reloadApi = reloadApi;
		vm.newFeedTypeChanged = newFeedTypeChanged;
		vm.defaultCalculationChanged = defaultCalculationChanged;
		//date picker
		vm.DPOpened = false;
		vm.openDatePicker = openDatePicker;
		vm.cancel = cancel;
		vm.changeUnit = changeUnit;
		vm.importXml = importXml;
		vm.paginationChangedMaster = paginationChangedMaster;
		vm.searchMasterChanged = searchMasterChanged;
		vm.feedTypeSelected = feedTypeSelected;
		vm.sort = sort;
		vm.commonFeedChanged = commonFeedChanged;
		vm.feedTypeChanged = feedTypeChanged;
		vm.changeAmountProduct = changeAmountProduct;
		vm.sortedColumn = 'feed_name';
		vm.order = 'ASC';
		vm.sort_col = 'feed_name_ASC';
		vm.options = {
			showWeeks: false
		};
		vm.test_date = current_time;
		vm.showPanels = false;
		vm.showPicker = false;
		vm.isTeamSelected = false;
		vm.feedsLoaded = false;
		vm.currentStep = 0;
		init();

		function init() {
			vm.selected_herd = null;
			vm.selectedTeam = null;
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			vm.loading = true;
			vm.disableScroll = true;
			vm.currentPageMaster = 1;
			vm.itemsPerPageMaster = 30;
			vm.searchMaster = '';
			vm.showPanels = false;
			vm.showPicker = false;
			vm.isTeamSelected = false;
			vm.feedsLoaded = false;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.language = vm.settings.language;
			vm.nel_89Max = 10.03;
			vm.me_89max = 16.18;
			if (!vm.settings.use_kgs) {
				vm.nel_89Max = round(vm.nel_89Max / 2.2046, 2);
				vm.me_89max = round(vm.me_89max / 2.2046, 2);
			}
			if (!vm.settings.use_mcal) {
				vm.nel_89Max = round(vm.nel_89Max * 4.1868, 2);
				vm.me_89max = round(vm.me_89max * 4.1868, 2);
			}
			setFeedDTO();
			setSwitchLabels();
			setDefaultCalculation();
			setUseAmountSwitch();
			getTeamsByUser();
			setFeedFilter();
			if (!vm.settings.use_kgs) {
				vm.weight = 'lb';
			}
			if (!vm.settings.use_mcal) {
				vm.energy = 'Mjoule';
			}
			vm.unitList = [
				{
					name: '%',
					value: '%'
				},
				{
					name: 'g/' + vm.weight,
					value: 'g/' + vm.weight
				}
			];
			if (vm.settings.use_percent) {
				vm.selectedUnit = vm.unitList[0];
			} else {
				vm.selectedUnit = vm.unitList[1];
			}
			$timeout(function () {
				setStrings();
				setCommonFeedFilter();
				setFeedTypesFilter();
			}, 100);
		}

		function setSwitchLabels() {
			vm.amountSwitchLabel = i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_');
			vm.productSwitchLabel = i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_m_f_product_switch_product_type');
		}

		function setUseAmountSwitch() {
			vm.amountProductArray = [
				{
					value: true,
					name: vm.amountSwitchLabel
				},
				{
					value: false,
					name: vm.productSwitchLabel
				}
			];
			try {
				var sw = JSON.parse($cookies.get('use_product'));
			} catch (error) {
				vm.switchUseAmount = vm.amountProductArray[0];
				$cookies.put('use_product', vm.switchUseAmount.value, {
					expires: moment().add(1, 'month').toDate()
				});
			}
			if (sw != null) {
				if (sw) {
					vm.switchUseAmount = vm.amountProductArray[0];
				} else {
					vm.switchUseAmount = vm.amountProductArray[1];
				}
			}
		}

		function changeAmountProduct() {
			vm.loading = true;
			$cookies.put('use_product', vm.switchUseAmount.value, {
				expires: moment().add(1, 'month').toDate()
			});
			$timeout(function () {
				vm.loading = false;
			}, 100);
		}

		function changeUnit() {
			if (vm.selectedUnit.value == '%') {
				vm.settings.use_percent = true;
			} else {
				vm.settings.use_percent = false;
			}
			localStorage.setItem('user_settings', JSON.stringify(vm.settings));
			saveSettings();
			if (vm.showPanels) {
				vm.loading = true;
				$timeout(function () {
					vm.loading = false;
				}, 500);
			}
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = [];
			getFeedsByTeam(vm.selectedTeam.Id);
		}

		function saveSettings() {
			settingsFactory
				.changeSettings(vm.settings, vm.user.email)
				.then()
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_saving_user_settings_');
				});
		}

		function reloadApi() {
			vm.loading = true;
			vm.disableScroll = true;
			vm.showPanels = false;
			vm.showPicker = false;
			vm.isTeamSelected = false;
			vm.feedsLoaded = false;
			getTeamsByUser();
		}

		function setFeedDTO() {
			feedDTO = {
				is_mix: 0,
				feed_name: null,
				feed_category: null,
				feed_type: null,
				common_feed: 0,
				test_date: null,
				dm: 0.01,
				is_purchased: 0,
				cost_as_sold: 0.01,
				wt_as_sold: 1000,
				cp: 0,
				rup_dig: 0,
				b_prot: 0,
				c_prot: 0,
				kd_b_prot: 0,
				rup_89: 0,
				ndicp: 0,
				adicp: 0,
				npncpe: 0,
				disc_fac: 0,
				nel_89: 0,
				me_89: 0,
				adf: 0,
				ndf: 0,
				ef_ndf_as_ndf: 0,
				ndf_digest: 0,
				rd_ndf: 0,
				lignin: 0,
				nfc_dig: 0,
				starch: 0,
				rd_starch: 0,
				sugar: 0,
				in_fa: 0,
				rd_sol_fiber: 0,
				ee: 0,
				sfa: 0,
				pufa: 0,
				bhfa: 0,
				fa_dig: 0,
				ca: 0,
				ca_abs: 0,
				p: 0,
				p_abs: 0,
				mg: 0,
				mg_abs: 0,
				k: 0,
				na: 0,
				cl: 0,
				s: 0,
				ash: 0,
				vitamin_a: 0,
				vitamin_d: 0,
				vitamin_e: 0,
				co: 0,
				cu: 0.0,
				cu_abs: 0,
				fe: 0,
				fe_abs: 0,
				i: 0,
				i_abs: 0,
				mo: 0,
				mn: 0,
				mn_abs: 0,
				se: 0.0,
				se_abs: 0,
				zn: 0,
				zn_abs: 0,
				lysine: 0,
				methionine: 0,
				teaa: 0,
				blank_1: '',
				blank_2: '',
				blank_3: '',
				blank_4: '',
				blank_5: '',
				comments: '',
				team_id: 1,
				vem: 0,
				dve: 0,
				oeb: 0,
				fos: 0,
				rus: 0,
				rc: 0,
				feed_locale: null,
				calculation_type: null
			};
			vm.feedDTO = feedDTO;
		}

		function newFeedTypeChanged() {
			vm.modalFeedType = vm.feedTypesItemBlank.value;
		}

		function defaultCalculationChanged() {
			if (vm.showPanels) {
				vm.loadingFields = true;
			}
			$timeout(function () {
				vm.fieldsCalculation = angular.copy(vm.selectedCalculation);
				vm.loadingFields = false;
			}, 500);
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = [];
			setFeedDTO();
			vm.feedDTO = feedDTO;
			changeDefaultCalculation();
			setFeedTypesFilter();
			getFeedsByTeam(vm.selectedTeam.Id);
		}

		function paginationChangedMaster() {
			vm.disableScroll = true;
			vm.currentPageMaster++;
			vm.isPage = true;
			getFeedsByTeam(vm.selectedTeam.Id);
		}

		function setFeedFilter() {
			vm.filterTypes = [
				{
					name: '_feed_filter_my_feeds_',
					value: 'my_feeds'
				},
				{
					name: '_feed_filter_master_feeds_',
					value: 'master_feeds'
				}
			];
			vm.selectedFeedType = vm.filterTypes[1];
		}

		function setCommonFeedFilter() {
			vm.commonFeedList = [
				{
					name: i18nFilter('_feeds_type_all_'),
					value: null
				},
				{
					name: vm.commonYes,
					value: true
				},
				{
					name: vm.commonNo,
					value: false
				}
			];
			vm.commonFeedItem = vm.commonFeedList[0];
		}

		function commonFeedChanged() {
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = [];
			getFeedsByTeam(vm.selectedTeam.Id);
		}

		function setFeedTypesFilter() {
			if (vm.selectedCalculation.calc_type == 1) {
				vm.feedTypesList = APP_CONST.constants.feed_vem_types;
				vm.feedTypesListBlank = angular.copy(vm.feedTypesList);
				vm.feedTypesListBlank[0].name = '_picker_feed_type_placeholder_';
			} else {
				vm.feedTypesList = APP_CONST.constants.feed_us_types;
				vm.feedTypesListBlank = angular.copy(vm.feedTypesList);
				vm.feedTypesListBlank[0].name = '_picker_feed_type_placeholder_';
			}
			vm.feedTypesItem = vm.feedTypesList[0];
			vm.feedTypesItemBlank = vm.feedTypesListBlank[0];
		}

		function feedTypeChanged() {
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = [];
			getFeedsByTeam(vm.selectedTeam.Id);
		}

		function feedTypeSelected() {
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = [];
			getFeedsByTeam(vm.selectedTeam.Id);
		}

		function sort(column) {
			if (vm.feedsLoaded) {
				var col;
				if (column != vm.sortedColumn) {
					vm.sortedColumn = column;
					vm.order = 'ASC';
					col = column + '_' + vm.order;
				} else {
					if (vm.order == 'ASC') {
						vm.order = 'DESC';
						col = column + '_' + vm.order;
					} else if (vm.order == 'DESC') {
						vm.order = 'ASC';
						col = column + '_' + vm.order;
					}
				}
				vm.sort_col = col;
				vm.currentPageMaster = 1;
				vm.disableScroll = true;
				vm.feeds = [];
				vm.feedsSafe = [];
				getFeedsByTeam(vm.selectedTeam.Id);
			}
		}

		function searchMasterChanged() {
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			if (vm.searchMaster.length >= 3) {
				if (timeoutSearch) {
					$timeout.cancel(timeoutSearch);
				}
				timeoutSearch = $timeout(function () {
					vm.feeds = [];
					vm.feedsSafe = [];
					getFeedsByTeam(vm.selectedTeam.Id);
				}, 1000);
			}
			if (vm.searchMaster.length == 0) {
				vm.feeds = [];
				vm.feedsSafe = [];
				getFeedsByTeam(vm.selectedTeam.Id);
			}
		}

		function changeDefaultCalculation() {
			vm.settings.calculation_type = vm.selectedCalculation.calc_type;
			return settingsFactory
				.changeSettings(vm.settings, vm.user.email)
				.then(function (response) {
					localStorage.setItem('user_settings', JSON.stringify(response));
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_saving_user_settings_');
				});
		}

		function setStrings() {
			vm.typeAll = i18nFilter('_feeds_type_all_');
			vm.typeDryForage = i18nFilter('_feeds_type_dry_forage_');
			vm.typeCornSilage = i18nFilter('_feeds_type_corn_silage_');
			vm.typeAlfa = i18nFilter('_feeds_type_alfa_silage_');
			vm.typeOther = i18nFilter('_feeds_type_other_wet_forage_');
			vm.typeByProduct = i18nFilter('_feeds_type_by_product_');
			vm.typeGrain = i18nFilter('_feeds_type_grain_');
			vm.typeFatty = i18nFilter('_feeds_type_fatty_acid_source_');
			vm.typeTriglicerides = i18nFilter('_feeds_type_triglycerides_');
			vm.typeCP = i18nFilter('_feeds_type_cp_source_');
			vm.typeRUP = i18nFilter('_feeds_type_rup_source_');
			vm.typeMineral = i18nFilter('_feeds_type_mineral_');
			vm.typeVitamin = i18nFilter('_feeds_type_vitamin_');
			vm.typeMix = i18nFilter('_feeds_type_mix_');
			vm.commonYes = i18nFilter('_feeds_yes_');
			vm.commonNo = i18nFilter('_feeds_no_');
		}

		function setDefaultCalculation() {
			vm.defaultCalculationList = [
				{
					name: '_calculation_filter_us_feeds_',
					calc_type: 0
				},
				{
					name: '_calculation_filter_vem_dve_feeds_',
					calc_type: 1
				}
			];
			if (vm.settings.calculation_type != null) {
				for (var i = 0; i < vm.defaultCalculationList.length; i++) {
					if (vm.settings.calculation_type == vm.defaultCalculationList[i].calc_type) {
						vm.selectedCalculation = vm.defaultCalculationList[i];
					}
				}
			} else {
				vm.selectedCalculation = vm.defaultCalculationList[0];
			}
			vm.fieldsCalculation = angular.copy(vm.selectedCalculation);
		}

		function setDefaultTeam(settings, teams) {
			if (settings.selectedTeam) {
				for (var i = 0; i < teams.length; i++) {
					if (settings.selectedTeam.id == teams[i].Id) {
						vm.selectedTeam = teams[i];
						break;
					}
				}
				if (vm.selectedTeam) {
					vm.isTeamSelected = true;
					getHerdsByTeam(vm.selectedTeam);
					getFeedsByTeam(vm.selectedTeam.Id, true);
				} else {
					vm.loading = false;
				}
			}
		}

		function getTeamsByUser() {
			return newFeedFactory
				.getTeamsByUser()
				.then(function (response) {
					vm.teams = response;
					setDefaultTeam(vm.settings, vm.teams);
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_teams_', true);
				});
		}

		function getFeedsByTeam(teamId, init) {
			var suffix;
			if (vm.settings.selectedHerd && vm.settings.selectedHerd.id) {
				suffix = '?teamId=' + teamId + '&herdId=' + vm.settings.selectedHerd.id + '&feedsOnly=true';
			} else {
				suffix = '?teamId=' + teamId + '&feedsOnly=true';
			}
			if (vm.selectedCalculation && (vm.selectedCalculation.calc_type != null || vm.selectedCalculation.calc_type != undefined)) {
				suffix = suffix + '&localType=' + vm.selectedCalculation.calc_type;
			}
			if (vm.currentPageMaster) {
				suffix = suffix + '&page=' + vm.currentPageMaster;
			}
			if (vm.searchMaster) {
				suffix = suffix + '&feedName=' + encodeURIComponent(vm.searchMaster);
			}
			if (vm.selectedFeedType) {
				suffix = suffix + '&returnType=' + vm.selectedFeedType.value;
			}
			if (vm.commonFeedItem && vm.commonFeedItem.value != null) {
				suffix = suffix + '&commonFeed=' + vm.commonFeedItem.value;
			}
			if (vm.feedTypesItem && vm.feedTypesItem.value) {
				suffix = suffix + '&feedType=' + vm.feedTypesItem.value;
			}
			if (vm.sortedColumn && vm.order) {
				suffix = suffix + '&orderBy=' + vm.sortedColumn + '&orderType=' + vm.order;
			}
			if (!vm.isPage) {
				vm.feedsLoaded = false;
			}
			vm.isPage = false;
			cancelApiRequest();
			return newFeedFactory
				.getFeedsByTeam(suffix)
				.then(function (response) {
					if (response.length > 0) {
						vm.totalItemsMaster = response[0].number_of_all;
						for (var i = 0; i < response.length; i++) {
							fixVemValues(response[i]);
							vm.feeds.push(response[i]);
						}
					} else {
						vm.totalItemsMaster = 0;
					}
					vm.feedsSafe = vm.feeds;
					vm.feedsLoaded = true;
					vm.disableScroll = false;
					$timeout(function () {
						var searchInput = document.getElementById('feedsSearchInput');
						if (searchInput) {
							searchInput.focus();
						}
					}, 50);
				})
				.catch(function (error) {
					if (error != 'Canceled') {
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_loading_feeds_', init);
						vm.disableScroll = false;
					}
				});

			function fixVemValues(data) {
				data.vem = data.vem || 0;
				data.dve = data.dve || 0;
				data.oeb = data.oeb || 0;
				data.fos = data.fos || 0;
				data.rc = data.rc || 0;
				data.rus = data.rus || 0;
			}
		}

		function source(type) {
			if (type == 'existing') {
				vm.showPanels = false;
				vm.showPicker = true;
			} else {
				vm.showPanels = true;
				vm.showPicker = false;
				vm.feedDTO = feedDTO;
			}
		}

		function openDatePicker() {
			vm.DPOpened = true;
		}

		function setDefaultHerd() {
			var herd = {
				herd_id: vm.selected_herd.Id
			};
			return dashboardFactory
				.setDefaultTeamHerd(herd)
				.then(function (response) {
					localStorage.setItem('user_settings', JSON.stringify(response));
					brodcastHerdSelected(vm.selected_herd);
					$timeout(function () {
						$state.go('feeds.myfeeds');
					}, 100);
				})
				.catch(function (error) {
					vm.modalLoading = false;
					console.log(error);
					if (error.status === 403) {
						errorService.showErrorMessage(error, true, '_error_occurred_setting_default_herd_');
					} else {
						errorService.showErrorMessage(error, true, '_error_occurred_changing_default_herd_');
					}
				});
		}

		function chackSelectedHerd() {
			if (vm.settings.selectedHerd && vm.settings.selectedHerd.id) {
				for (var i = 0; i < vm.herds.length; i++) {
					if (vm.settings.selectedHerd.id == vm.herds[i].Id) {
						vm.selected_herd = vm.herds[i];
					}
				}
			} else {
				vm.selected_herd = vm.herds[0];
			}
		}

		function getHerdsByTeam(team) {
			newFeedFactory
				.getHerdsByTeam(team.Id)
				.then(function (response) {
					var temp = {
						Id: null,
						Name: ''
					};
					response.splice(0, 0, temp);
					vm.herds = response;
					chackSelectedHerd();
					vm.loading = false;
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_herds_', true);
				});
		}

		function saveFeed() {
			vm.addFeedForm.$setSubmitted(true);
			if (vm.addFeedForm.$invalid != true) {
				openModal('app/pages/feeds/addNewFeed/confirmationDialog.modal.html', 'sm');
			}
		}

		function saveFeedProceed() {
			if (vm.selectedTeam) {
				vm.modalLoading = true;
				var feedDto = angular.copy(vm.feedDTO);
				feedDto.test_date = formatDate(vm.test_date);
				feedDto.user_id = vm.user.email;
				if (feedDto.feed_name !== null && feedDto.feed_name && feedDto.feed_name !== '' && feedDto.feed_name.length > 0) {
					if (vm.feedTypesItemBlank.value) {
						feedDto.feed_type = vm.feedTypesItemBlank.value;
						feedDto.feed_category = vm.feedTypesItemBlank.category;
						feedDto.calculation_type = vm.selectedCalculation.calc_type;
						feedDto.feed_locale = vm.selectedCalculation.calc_type;
						saveNewFeed(feedDto);
					} else {
						toastr.error(i18nFilter('_toastr_feeds_type_required_'), i18nFilter('_toastr_error_title_'));
						vm.modalLoading = false;
					}
				} else {
					toastr.error(i18nFilter('_toastr_feeds_name_required_'), i18nFilter('_toastr_error_title_'));
					vm.modalLoading = false;
				}
			}
		}

		function saveNewFeed(feedDTO) {
			feedDTO.team_id = vm.selectedTeam.Id;
			var suffix;
			if (vm.selected_herd && vm.selected_herd.Id) {
				suffix = '?teamId=' + vm.selectedTeam.Id + '&herdId=' + vm.selected_herd.Id;
			} else {
				suffix = '?teamId=' + vm.selectedTeam.Id;
			}
			if (vm.selectedCalculation != null || vm.selectedCalculation != undefined) {
				suffix = suffix + '&localType=' + vm.selectedCalculation.calc_type;
			}
			return newFeedFactory
				.saveFeed(feedDTO, suffix)
				.then(function () {
					if (vm.selected_herd.Id != null && vm.selected_herd.Id != vm.settings.selectedHerd.id) {
						setDefaultHerd();
					} else {
						$state.go('feeds.myfeeds');
					}
					toastr.success(i18nFilter('_toastr_feeds_add_'), i18nFilter('_toastr_success_title_'));
				})
				.catch(function (error) {
					console.log(error);
					if (error.status === 403) {
						errorService.showErrorMessage(error, true, '_error_occurred_setting_default_herd_');
					} else {
						errorService.showErrorMessage(error, true, '_error_occurred_creating_feed_');
					}
					vm.modalLoading = false;
				});
		}

		function selectFeed(id) {
			var feed = null;
			for (var i = 0; i < vm.feeds.length; i++) {
				if (vm.feeds[i].id === id) {
					feed = vm.feeds[i];
					break;
				}
			}
			if (feed.wt_as_sold != null && feed.wt_as_sold != undefined && feed.wt_as_sold == 0) {
				feed.wt_as_sold = 1000;
			}
			setFeedType(feed.feed_type);
			vm.feedDTO = feed;
			vm.feedDTO.id = null;
			vm.showPanels = true;
			vm.showPicker = false;
		}

		function setFeedType(feed_type) {
			for (var i = 0; i < vm.feedTypesListBlank.length; i++) {
				if (vm.feedTypesListBlank[i].value && vm.feedTypesListBlank[i].value.toLowerCase() === feed_type.toLowerCase()) {
					vm.feedTypesItemBlank = vm.feedTypesListBlank[i];
					break;
				}
			}
		}

		function formatDate(dateObj) {
			dateObj.setHours(12);
			return dateObj.toISOString();
		}

		function teamSelected() {
			vm.isTeamSelected = true;
			getFeedsByTeam(vm.selectedTeam.Id);
		}

		function cancel() {
			$state.go('feeds.myfeeds');
		}

		function importXml() {
			$state.go('feeds.importXml');
		}

		function openModal(page, size) {
			var modal = $uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
			return modal;
		}

		function cancelApiRequest() {
			angular.forEach($http.pendingRequests, function (req) {
				if (req.url.split('?')[0] == APP_CONST.api_base_url + 'feeds' && req.method == 'GET') {
					newFeedFactory.cancelRequest();
				}
			});
		}

		function brodcastHerdSelected(herd) {
			$rootScope.$broadcast('default_herd_selected_from_herds', herd);
		}

		function round(value, decimals) {
			return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
		}

		$scope.$on('default_team_selected', function (event, data) {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedTeam = data;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = [];
			vm.currentPageMaster = 1;
			vm.searchMaster = '';
			getHerdsByTeam(vm.selectedTeam);
			getFeedsByTeam(data.Id, true);
			vm.isTeamSelected = true;
		});

		$scope.$on('default_herd_selected', function () {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			if (vm.settings.selectedTeam && vm.settings.selectedTeam.id) {
				vm.disableScroll = true;
				vm.feeds = [];
				vm.feedsSafe = [];
				vm.currentPageMaster = 1;
				vm.searchMaster = '';
				chackSelectedHerd();
				getFeedsByTeam(vm.settings.selectedTeam.id, true);
			}
		});

		$scope.$on('default_team_herd_changed', function () {
			cancelApiRequest();
			init();
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.addNewFeed').factory('newFeedFactory', newFeedFactory);
	/** @ngInject */
	function newFeedFactory($http, APP_CONST, $q) {
		var cancelReq;
		var statusText;

		return {
			saveFeed: saveFeed,
			getTeamsByUser: getTeamsByUser,
			getFeedsByTeam: getFeedsByTeam,
			getHerdsByTeam: getHerdsByTeam,
			cancelRequest: cancelRequest
		};

		function cancelRequest() {
			statusText = 'Canceled';
			cancelReq.resolve();
		}

		function saveFeed(feedDTO, suffix) {
			return $http
				.post(APP_CONST.api_base_url + 'feeds' + suffix, feedDTO)
				.then(success)
				.catch(error);
		}

		function getTeamsByUser() {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams')
				.then(success)
				.catch(error);
		}

		function getFeedsByTeam(suffix) {
			cancelReq = $q.defer();
			return $http
				.get(APP_CONST.api_base_url + 'feeds' + suffix, {
					timeout: cancelReq.promise
				})
				.then(success)
				.catch(function (error) {
					var err = statusText ? $q.reject(statusText) : $q.reject(error);
					statusText = undefined;
					return err;
				});
		}

		function getHerdsByTeam(id) {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams/' + id + '/herds')
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.feeds.addNewFeed').directive('selectpicker', selectpicker);

	/** @ngInject */
	function selectpicker() {
		return {
			restrict: 'A',
			require: '?ngOptions',
			priority: 1500, // make priority bigger than ngOptions and ngRepeat
			link: {
				pre: function (scope, elem, attrs) {
					elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>');
				},
				post: function (scope, elem, attrs) {
					function refresh() {
						elem.selectpicker('refresh');
					}

					if (attrs.ngModel) {
						scope.$watch(attrs.ngModel, refresh);
					}

					if (attrs.ngDisabled) {
						scope.$watch(attrs.ngDisabled, refresh);
					}

					elem.selectpicker({
						dropupAuto: false,
						hideDisabled: true
					});
				}
			}
		};
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.editFeed').controller('editFeedCtrl', editFeedCtrl);
	/** @ngInject */
	function editFeedCtrl(APP_CONST, $stateParams, toastr, editFeedFactory, settingsFactory, $state, $filter, $locale, $scope, $rootScope, dashboardFactory, $uibModal, $timeout, errorService, $cookies) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		vm.weight = 'kg';
		vm.energy = 'Mcal';
		vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
		init();
		vm.DPOpened = false;
		vm.openDatePicker = openDatePicker;
		vm.reloadApi = reloadApi;
		vm.save = save;
		vm.saveFeedProceed = saveFeedProceed;
		vm.newFeedTypeChanged = newFeedTypeChanged;
		vm.cancel = cancel;
		vm.changeUnit = changeUnit;
		vm.valueChanged = valueChanged;
		vm.changeAmountProduct = changeAmountProduct;
		vm.options = {
			showWeeks: false
		};

		function init() {
			vm.from_premix = localStorage.getItem('from_premix');
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			vm.loading = true;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.nel_89Max = 10.03;
			vm.me_89max = 16.18;
			if (!vm.settings.use_kgs) {
				vm.nel_89Max = round(vm.nel_89Max / 2.2046, 2);
				vm.me_89max = round(vm.me_89max / 2.2046, 2);
			}
			if (!vm.settings.use_mcal) {
				vm.nel_89Max = round(vm.nel_89Max * 4.1868, 2);
				vm.me_89max = round(vm.me_89max * 4.1868, 2);
			}
			if (!vm.settings.use_kgs) {
				vm.weight = 'lb';
			}
			if (!vm.settings.use_mcal) {
				vm.energy = 'Mjoule';
			}
			vm.unitList = [
				{
					name: '%',
					value: '%'
				},
				{
					name: 'g/' + vm.weight,
					value: 'g/' + vm.weight
				}
			];
			if (vm.settings.use_percent) {
				vm.selectedUnit = vm.unitList[0];
			} else {
				vm.selectedUnit = vm.unitList[1];
			}
			setSwitchLabels();
			setUseAmountSwitch();
			getFeedById($stateParams.uuid);
		}

		function setSwitchLabels() {
			vm.amountSwitchLabel = i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_');
			vm.productSwitchLabel = i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_m_f_product_switch_product_type');
		}

		function setUseAmountSwitch() {
			vm.amountProductArray = [
				{
					value: true,
					name: vm.amountSwitchLabel
				},
				{
					value: false,
					name: vm.productSwitchLabel
				}
			];
			try {
				var sw = JSON.parse($cookies.get('use_product'));
			} catch (error) {
				vm.switchUseAmount = vm.amountProductArray[0];
				$cookies.put('use_product', vm.switchUseAmount.value, {
					expires: moment().add(1, 'month').toDate()
				});
			}
			if (sw != null) {
				if (sw) {
					vm.switchUseAmount = vm.amountProductArray[0];
				} else {
					vm.switchUseAmount = vm.amountProductArray[1];
				}
			}
		}

		function changeAmountProduct() {
			vm.loading = true;
			$cookies.put('use_product', vm.switchUseAmount.value, {
				expires: moment().add(1, 'month').toDate()
			});
			$timeout(function () {
				vm.loading = false;
			}, 100);
		}

		function changeUnit() {
			if (vm.selectedUnit.name == '%') {
				vm.settings.use_percent = true;
			} else {
				vm.settings.use_percent = false;
			}
			localStorage.setItem('user_settings', JSON.stringify(vm.settings));
			saveSettings();
			vm.loading = true;
			$timeout(function () {
				vm.loading = false;
			}, 100);
		}

		function saveSettings() {
			settingsFactory
				.changeSettings(vm.settings, vm.user.email)
				.then()
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_saving_user_settings_');
				});
		}

		function newFeedTypeChanged() {
			vm.modalFeedType = vm.feedTypesItem.value;
		}

		function reloadApi() {
			vm.loading = true;
			getFeedById($stateParams.uuid);
		}

		function setFeedTypesFilter() {
			if (vm.feedDTO.feed_locale == 1) {
				vm.feedTypesList = angular.copy(APP_CONST.constants.feed_vem_types);
				vm.feedTypesList[0].name = '_picker_feed_type_placeholder_';
			} else {
				vm.feedTypesList = angular.copy(APP_CONST.constants.feed_us_types);
				vm.feedTypesList[0].name = '_picker_feed_type_placeholder_';
			}
			vm.feedTypesItem = vm.feedTypesList[0];
		}

		function getFeedById(id) {
			return editFeedFactory
				.getFeedById(id)
				.then(function (response) {
					var feed = response;
					vm.feedCalculationType = response.feed_locale;
					if (vm.feedCalculationType == null || vm.feedCalculationType == undefined) {
						vm.feedCalculationType = localStorage.getItem('feed_calculation_type');
					}
					vm.test_date = new Date(feed.test_date);
					fixVemValues(feed);
					vm.feedDTO = feed;
					getHerdsByTeam(vm.settings.selectedTeam.id);
					setFeedTypesFilter();
					setFeedType(feed.feed_type);
				})
				.catch(function (error) {
					vm.loading = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_feeds_', true);
				});

			function fixVemValues(data) {
				data.vem = data.vem || 0;
				data.dve = data.dve || 0;
				data.oeb = data.oeb || 0;
				data.fos = data.fos || 0;
				data.rc = data.rc || 0;
				data.rus = data.rus || 0;
			}
		}

		function setFeedType(feed_type) {
			for (var i = 0; i < vm.feedTypesList.length; i++) {
				if (vm.feedTypesList[i].value && vm.feedTypesList[i].value.toLowerCase() === feed_type.toLowerCase()) {
					vm.feedTypesItem = vm.feedTypesList[i];
					break;
				}
			}
		}

		function openDatePicker() {
			vm.DPOpened = true;
		}

		function setDefaultHerd() {
			var herd = {
				herd_id: vm.selected_herd.Id
			};
			return dashboardFactory
				.setDefaultTeamHerd(herd)
				.then(function (response) {
					localStorage.setItem('user_settings', JSON.stringify(response));
					brodcastHerdSelected(vm.selected_herd);
					$timeout(function () {
						$state.go('feeds.myfeeds');
					}, 100);
				})
				.catch(function (error) {
					vm.modalLoading = false;
					console.log(error);
					if (error.status === 403) {
						errorService.showErrorMessage(error, true, '_error_occurred_setting_default_herd_');
					} else {
						errorService.showErrorMessage(error, true, '_error_occurred_changing_default_herd_');
					}
				});
		}

		function chackSelectedHerd() {
			if (vm.settings.selectedHerd.id) {
				for (var i = 0; i < vm.herds.length; i++) {
					if (vm.settings.selectedHerd.id == vm.herds[i].Id) {
						vm.selected_herd = vm.herds[i];
					}
				}
			} else {
				vm.selected_herd = vm.herds[0];
			}
		}

		function getHerdsByTeam(id) {
			editFeedFactory
				.getHerdsByTeam(id)
				.then(function (response) {
					var temp = {
						Id: null,
						Name: ''
					};
					response.splice(0, 0, temp);
					vm.herds = response;
					chackSelectedHerd();
					vm.loading = false;
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_herds_', true);
				});
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function save(save_type) {
			vm.addFeedForm.$setSubmitted(true);
			if (vm.addFeedForm.$invalid != true) {
				var feedDTO = angular.copy(vm.feedDTO);
				if (feedDTO.feed_name !== null && feedDTO.feed_name && feedDTO.feed_name !== '' && feedDTO.feed_name.length > 0) {
					feedDTO.user_id = vm.user.email;
					vm.test_date.setHours(12);
					feedDTO.test_date = vm.test_date;
					if (!feedDTO.calculation_type) {
						feedDTO.calculation_type = feedDTO.feed_locale;
					}
					if (save_type == 'update') {
						if (vm.feedTypesItem.value) {
							feedDTO.feed_type = vm.feedTypesItem.value;
							feedDTO.feed_category = vm.feedTypesItem.category;
							updateFeed(feedDTO);
						} else {
							toastr.error(i18nFilter('_toastr_feeds_type_required_'), i18nFilter('_toastr_error_title_'));
						}
					} else {
						vm.modalFeed = feedDTO;
						openModal('app/pages/feeds/editFeed/confirmationDialog.modal.html', 'sm');
					}
				} else {
					toastr.error(i18nFilter('_toastr_feeds_name_required_'), i18nFilter('_toastr_error_title_'));
				}
			}
		}

		function updateFeed(feedDTO) {
			vm.loading = true;
			feedDTO.event = vm.event || null;
			return editFeedFactory
				.updateFeed(feedDTO)
				.then(function () {
					$state.go('feeds.myfeeds');
					toastr.success(i18nFilter('_toastr_feeds_updated_'), i18nFilter('_toastr_success_title_'));
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_updating_feed_');
				});
		}

		function saveFeedProceed() {
			if (vm.feedTypesItem.value) {
				var feedDTO = angular.copy(vm.modalFeed);
				feedDTO.feed_type = vm.feedTypesItem.value;
				feedDTO.feed_category = vm.feedTypesItem.category;
				vm.modalLoading = true;
				var suffix;
				if (vm.selected_herd && vm.selected_herd.Id) {
					suffix = '?teamId=' + vm.settings.selectedTeam.id + '&herdId=' + vm.selected_herd.Id;
				} else {
					suffix = '?teamId=' + vm.settings.selectedTeam.id;
				}
				feedDTO.event = vm.event || null;
				return editFeedFactory
					.addFeed(feedDTO, suffix)
					.then(function () {
						if (vm.selected_herd.Id != null && vm.selected_herd.Id != vm.settings.selectedHerd.id) {
							setDefaultHerd();
						} else {
							$state.go('feeds.myfeeds');
						}
						toastr.success(i18nFilter('_toastr_feeds_add_'), i18nFilter('_toastr_success_title_'));
					})
					.catch(function (error) {
						console.log(error);
						vm.modalLoading = false;
						if (error.status === 403) {
							errorService.showErrorMessage(error, true, '_error_occurred_setting_default_herd_');
						} else {
							errorService.showErrorMessage(error, true, '_error_occurred_creating_feed_');
						}
					});
			} else {
				toastr.error(i18nFilter('_toastr_feeds_type_required_'), i18nFilter('_toastr_error_title_'));
			}
		}

		function valueChanged(prop) {
			vm.event = prop;
		}

		function cancel() {
			if (vm.from_premix) {
				$state.go('premixes.addNewPremix');
			} else {
				$state.go('feeds.myfeeds');
			}
		}

		function round(value, decimals) {
			return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
		}

		function brodcastHerdSelected(herd) {
			$rootScope.$broadcast('default_herd_selected_from_herds', herd);
		}

		$scope.$on('default_team_selected', function () {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			getHerdsByTeam(vm.settings.selectedTeam.id);
		});

		$scope.$on('default_herd_selected', function () {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			if (vm.settings.selectedTeam && vm.settings.selectedTeam.id) {
				chackSelectedHerd();
			}
		});

		$scope.$on('$destroy', function () {
			localStorage.removeItem('feed_calculation_type');
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.editFeed').factory('editFeedFactory', editFeedFactory);
	/** @ngInject */
	function editFeedFactory($http, APP_CONST, $q) {
		return {
			updateFeed: updateFeed,
			addFeed: addFeed,
			getFeedById: getFeedById,
			getHerdsByTeam: getHerdsByTeam
		};

		function updateFeed(feedDTO) {
			return $http
				.put(APP_CONST.api_base_url + 'feeds', feedDTO)
				.then(success)
				.catch(error);
		}

		function addFeed(feedDTO, suffix) {
			return $http
				.post(APP_CONST.api_base_url + 'feeds' + suffix, feedDTO)
				.then(success)
				.catch(error);
		}

		function getFeedById(id) {
			return $http
				.get(APP_CONST.api_base_url + 'feeds/' + id)
				.then(success)
				.catch(error);
		}

		function getHerdsByTeam(id) {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams/' + id + '/herds')
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.addNewManualFeed').controller('addNewManualFeedCtrl', addNewManualFeed);
	/** @ngInject */
	function addNewManualFeed($locale, addNewManualFeedService, errorService, $scope, APP_CONST, $filter, $state) {
		var vm = this;
		var i18nFilter = $filter('i18n');

		vm.updateFeed = updateFeed;
		vm.saveFeed = saveFeed;
		vm.cancel = cancel;

		init();

		function init() {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			vm.selectedHerd = vm.settings.selectedHerd.id;
			vm.selectedTeam = vm.settings.selectedTeam.id;
			if (vm.settings.use_kgs) {
				vm.weight = 'kg';
			} else {
				vm.weight = 'lb';
			}
			setFeedDTO();
			setFeedTypes(APP_CONST.constants.feed_types);
		}

		function setFeedDTO() {
			vm.feedDTO = {
				feed_name: '',
				feed_type: null,
				amount_dm: 0,
				amount_as_fed: 0,
				cost_dm: 0,
				cost_as_fed: 0,
				dm: 0
			};
		}

		function setFeedTypes(feed_types) {
			var types = angular.copy(feed_types);

			vm.feedTypes = types.map(function (type) {
				var t = '_feeds_type_' + type.value + '_';
				type.show_name = t;
				type.translated = i18nFilter(t);
				return type;
			});
		}

		function updateFeed(type) {
			switch (type) {
				case 'dm':
					vm.feedDTO.amount_as_fed = vm.feedDTO.amount_dm && vm.feedDTO.dm ? (vm.feedDTO.amount_dm * 100) / vm.feedDTO.dm : 0;
					vm.feedDTO.cost_as_fed = vm.feedDTO.cost_dm && vm.feedDTO.dm ? (vm.feedDTO.cost_dm * vm.feedDTO.dm) / 100 : 0;
					break;
				case 'amount_dm':
					vm.feedDTO.amount_as_fed = vm.feedDTO.amount_dm && vm.feedDTO.dm ? (vm.feedDTO.amount_dm * 100) / vm.feedDTO.dm : 0;
					break;
				case 'amount_as_fed':
					vm.feedDTO.amount_dm = vm.feedDTO.amount_as_fed && vm.feedDTO.dm ? (vm.feedDTO.amount_as_fed * vm.feedDTO.dm) / 100 : 0;
					break;
				case 'cost_dm':
					vm.feedDTO.cost_as_fed = vm.feedDTO.cost_dm && vm.feedDTO.dm ? (vm.feedDTO.cost_dm * vm.feedDTO.dm) / 100 : 0;
					break;
				case 'cost_as_fed':
					vm.feedDTO.cost_dm = vm.feedDTO.cost_as_fed && vm.feedDTO.dm ? (vm.feedDTO.cost_as_fed * 100) / vm.feedDTO.dm : 0;
					break;
				default:
					break;
			}
		}

		function saveFeed() {
			if (vm.addFeedForm.$valid) {
				vm.loading = true;
				var dto = {
					feed_name: vm.feedDTO.feed_name,
					feed_type: vm.feedDTO.feed_type.name,
					amount_dm: vm.feedDTO.amount_dm,
					amount_as_fed: vm.feedDTO.amount_as_fed,
					dm: vm.feedDTO.dm,
					cost_dm: vm.feedDTO.cost_dm,
					cost_as_fed: vm.feedDTO.cost_as_fed,
					herd_id: vm.selectedHerd,
					team_id: vm.selectedTeam
				};
				addNewManualFeedService
					.saveFeed(dto)
					.then(function () {
						$state.go('feeds.mymanualfeeds');
					})
					.catch(function (error) {
						vm.loading = false;
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_creating_feed_');
					});
			}
		}

		function cancel() {
			$state.go('feeds.mymanualfeeds');
		}

		$scope.$on('default_team_herd_changed', function () {
			init();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.addNewManualFeed').factory('addNewManualFeedService', addNewManualFeedService);
	/** @ngInject */
	function addNewManualFeedService($http, APP_CONST, $q) {
		return {
			saveFeed: saveFeed
		};

		function saveFeed(feedDTO) {
			return $http
				.post(APP_CONST.api_base_url + 'manualfeed', feedDTO)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.feedHistory').controller('feedHistoryCtrl', feedHistoryCtrl);
	/** @ngInject */
	function feedHistoryCtrl($stateParams, feedHistoryFactory, APP_CONST, $locale, $window, $scope, $filter, errorService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		vm.loading = true;
		vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
		vm.weight = 'kg';
		vm.energy = 'Mcal';
		vm.getMixHistory = getMixHistory;
		vm.reloadApi = reloadApi;
		vm.goBack = goBack;
		vm.showButton = false;
		vm.closeDetailsWindow = closeDetailsWindow;
		init();

		function init() {
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			vm.feedCalculationType = localStorage.getItem('feed_calculation_type');
			vm.loading = true;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			getDefaultTeamHerd();
			if (vm.settings.selectedHerd.id) {
				getFeedHistory($stateParams.uuid);
				setFeedTypes(APP_CONST.constants.feed_types);
				if (!vm.settings.use_kgs) {
					vm.weight = 'lb';
				}
				if (!vm.settings.use_mcal) {
					vm.energy = 'Mjoule';
				}
			}
		}

		function reloadApi() {
			vm.loading = true;
			getFeedHistory($stateParams.uuid);
		}

		function setFeedTypes(feed_types) {
			vm.feed_types = [];
			for (var i = 0; i < feed_types.length; i++) {
				var temp = '_feeds_type_' + feed_types[i].value + '_';
				feed_types[i].show_name = temp;
				feed_types[i].translated = i18nFilter(temp);
				vm.feed_types.push(feed_types[i]);
			}
		}

		function getDefaultTeamHerd() {
			var settings = JSON.parse(localStorage.getItem('user_settings'));
			if (settings.selectedTeam.id) {
				vm.selectedTeam = settings.selectedTeam;
			}
			if (settings.selectedHerd.id) {
				vm.selectedHerd = settings.selectedHerd;
			}
		}

		function closeDetailsWindow() {
			vm.showDetails = false;
		}

		function getFeedHistory(feedId) {
			vm.feeds = [];
			return feedHistoryFactory
				.getFeedHistoryById(feedId)
				.then(function (response) {
					vm.feeds = setFeeds(response, true);
					vm.loading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_feed_history_', true);
				});
		}

		function setFeeds(feeds, is_feed) {
			var temp = feeds;
			if (feeds.length > 0) {
				if (feeds[feeds.length - 1].is_mix && is_feed) {
					vm.showButton = true;
				}
				for (var i = 0; i < temp.length; i++) {
					temp[i].test_date = new Date(temp[i].test_date);
					temp[i].is_selected = false;
					var hasFeedType = false;
					for (var j = 0; j < vm.feed_types.length; j++) {
						if (temp[i].feed_type.toLowerCase() === vm.feed_types[j].name.toLowerCase()) {
							temp[i].feed_type = vm.feed_types[j];
							hasFeedType = true;
							break;
						}
					}
					if (!hasFeedType) {
						temp[i].feed_type = {
							show_name: '_feeds_type_not_set_'
						};
					}
					if (temp[i].mixes) {
						for (var k = 0; k < temp[i].mixes.length; k++) {
							var hasFeedTypeMix = false;
							for (var m = 0; m < vm.feed_types.length; m++) {
								if (temp[i].mixes[k].feed_type.toLowerCase() === vm.feed_types[m].name.toLowerCase()) {
									temp[i].mixes[k].feed_type = vm.feed_types[m];
									hasFeedTypeMix = true;
									break;
								}
							}
							if (!hasFeedTypeMix) {
								temp[i].mixes[k].feed_type = {
									show_name: '_feeds_type_not_set_'
								};
							}
						}
					}
				}
			}
			return temp;
		}

		function goBack() {
			$window.history.back();
		}

		function getMixHistory() {
			vm.showDetails = true;
			vm.loadingMix = true;
			vm.loading = false;
			return feedHistoryFactory
				.getMixHistory($stateParams.uuid)
				.then(function (response) {
					for (var i = 0; i < response.length; i++) {
						response[i].as_fed = response[i].amount / (response[i].dm / 100);
					}
					var changedFeeds = checkDiferencesInMix(response);
					for (var j = 0; j < response.length; j++) {
						for (var k = 0; k < changedFeeds.length; k++) {
							if (response[j].id == changedFeeds[k].id) {
								response[j] = changedFeeds[k];
							}
						}
					}
					vm.loadingMix = false;
					vm.loading = false;
					vm.mix = setFeeds(response, false);
					vm.showMix = true;
				})
				.catch(function (error) {
					vm.loading = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_mix_history_');
				});
		}

		function checkDiferencesInMix(list) {
			var response = [];
			var listOfChanged = [];
			angular.copy(list, response);
			response.reverse();
			var obj = groupBy(response, 'mix_id');
			angular.forEach(obj, function (value) {
				if (value.length > 1) {
					for (var i = 0; i < value.length; i++) {
						if (value[i - 1]) {
							var feed = {};
							var changed = false;
							angular.copy(value[i], feed);
							angular.forEach(value[i], function (v, k) {
								if (value[i - 1][k] != value[i][k]) {
									var string = k + '_changed';
									feed[string] = true;
									changed = true;
								}
							});
							if (changed) {
								listOfChanged.push(feed);
							}
						}
					}
				}
			});
			return listOfChanged;
		}

		function groupBy(xs, key) {
			return xs.reduce(function (rv, x) {
				(rv[x[key]] = rv[x[key]] || []).push(x);
				return rv;
			}, {});
		}
		$scope.$on('default_herd_selected', function () {
			init();
		});

		$scope.$on('default_team_selected', function () {
			vm.selectedHerd = null;
			init();
		});

		$scope.$on('$destroy', function () {
			localStorage.removeItem('feed_calculation_type');
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.feedHistory').factory('feedHistoryFactory', feedHistoryFactory);
	/** @ngInject */
	function feedHistoryFactory($http, APP_CONST, $q) {
		return {
			getFeedHistoryById: getFeedHistoryById,
			getMixHistory: getMixHistory
		};

		function getFeedHistoryById(feedId) {
			return $http
				.get(APP_CONST.api_base_url + 'feedHistory/' + feedId)
				.then(success)
				.catch(error);
		}

		function getMixHistory(feedId) {
			return $http
				.get(APP_CONST.api_base_url + 'mixFeedHistory/' + feedId)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.importSpartan3').controller('importSpartan3Ctrl', importSpartan3Ctrl);
	/** @ngInject */
	function importSpartan3Ctrl(importSpartanFactory, $state, $uibModal, $scope, $uibModalStack, Upload, $filter, APP_CONST, toastr, $timeout, $q, errorService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var changed;
		vm.openUploadModal = openUploadModal;
		vm.cancel = cancel;
		vm.upload = upload;
		vm.uploadChanged = uploadChanged;
		vm.openImportModal = openImportModal;
		vm.addAll = addAll;
		vm.removeAll = removeAll;
		vm.addSelected = addSelected;
		vm.removeSelected = removeSelected;
		vm.importFeeds = importFeeds;
		vm.reloadApi = reloadApi;
		vm.weight = 'kg';
		vm.importList = [];
		vm.finish = finish;
		vm.back = back;
		init();

		function init() {
			vm.modalLoading = false;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.uploading = false;
			vm.modalLoading = false;
			vm.loadingDbs = true;
			vm.file = null;
			if (!vm.settings.use_kgs) {
				vm.weight = 'lb';
			}
			getTeamsByUser();
			getUploadedDatabases();
		}

		function reloadApi() {
			vm.uploading = false;
			vm.modalLoading = false;
			vm.loadingDbs = true;
			vm.file = null;
			getTeamsByUser();
			getUploadedDatabases();
		}

		function getUploadedDatabases() {
			vm.loadingTable = true;
			return importSpartanFactory
				.getUploadedDatabases()
				.then(function (response) {
					for (var i = 0; i < response.length; i++) {
						response[i].upload_date = $filter('date')(response[i].upload_date, 'mediumDate');
					}
					vm.dbs = response;
					if (vm.dbs.length > 0) {
						vm.hasFiles = true;
					} else {
						vm.hasFiles = false;
					}
					var l = vm.dbs.length;
					vm.itemsPerPageValues = [];
					if (l > 5) {
						vm.itemsPerPageValues.push(5);
						vm.itemsPerPageValues.push(10);
					}
					if (l > 10) {
						vm.itemsPerPageValues.push(15);
					}
					if (l > 15) {
						vm.itemsPerPageValues.push(20);
					}
					if (l > 20) {
						vm.itemsPerPageValues.push(25);
					}
					vm.loadingDbs = false;
					vm.loadingTable = false;
				})
				.catch(function (error) {
					vm.loadingDbs = false;
					vm.loadingTable = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_databases_', true);
				});
		}

		function back() {
			$state.go('feeds.myfeeds');
		}

		function openModal(page, size) {
			$uibModal
				.open({
					animation: true,
					templateUrl: page,
					size: size,
					scope: $scope,
					backdrop: 'static',
					keyboard: false
				})
				.closed.then(function () {
					vm.uploading = false;
					vm.file = null;
				});
		}

		function openCustomModal(page) {
			$uibModal
				.open({
					animation: true,
					templateUrl: page,
					scope: $scope,
					backdrop: 'static',
					keyboard: false,
					windowClass: 'modal-custom-width'
				})
				.closed.then(function () {
					vm.uploading = false;
					vm.file = null;
				});
		}

		function getTeamsByUser() {
			vm.loadingTeams = true;
			return importSpartanFactory
				.getTeamsByUser()
				.then(function (response) {
					vm.teams = response;
					checkDefaultTeam(vm.settings, vm.teams);
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_teams_', true);
				});
		}

		function checkDefaultTeam(settings, teams) {
			if (settings.selectedTeam) {
				for (var i = 0; i < teams.length; i++) {
					if (settings.selectedTeam.id == teams[i].Id) {
						vm.selectedTeam = teams[i];
						break;
					}
				}
			}
			vm.loadingTeams = false;
		}

		function getUploadedFile(id) {
			vm.loading = true;
			return importSpartanFactory
				.getUploadedFile(id)
				.then(function (response) {
					vm.masterLib = response;
					vm.masterLibSafe = response;
					vm.loading = false;
				})
				.catch(function (error) {
					vm.loading = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_file_');
				});
		}

		function openUploadModal(page, size) {
			openModal(page, size);
		}

		function openImportModal(db, page) {
			vm.importList = [];
			vm.importListSafe = [];
			if (vm.selectedTeam) {
				vm.loading = true;
				openCustomModal(page);
				getUploadedFile(db.file_uuid);
			} else {
				toastr.warning(i18nFilter('_dashboard_default_team_not_defined_'));
			}
		}

		function addAll() {
			removeAll();
			var mList = JSON.parse(JSON.stringify(vm.masterLib));
			for (var i = 0; i < mList.length; i++) {
				mList[i].is_selected = false;
				vm.importList.push(mList[i]);
			}
			vm.masterLib = [];
			vm.masterLibSafe = [];
			vm.importListSafe = vm.importList;
		}

		function removeAll() {
			for (var i = 0; i < vm.importList.length; i++) {
				vm.masterLib.push(vm.importList[i]);
			}
			vm.masterLibSafe = vm.masterLib;
			vm.importList = [];
			vm.importListSafe = vm.importList;
		}

		function addSelected(id) {
			var feedFound = false;
			var selList = [];
			for (var i = 0; i < vm.masterLib.length; i++) {
				if (vm.masterLib[i].id == id) {
					if (vm.importList.length > 0) {
						for (var j = 0; j < vm.importList.length; j++) {
							if (vm.masterLib[i].id == vm.importList[j].id) {
								feedFound = true;
								break;
							}
						}
					}
					if (!feedFound) {
						vm.importList.push(vm.masterLib.splice(i, 1)[0]);
					}
					feedFound = false;
				}
			}
			var li = [];
			angular.copy(selList, li);
			for (var k = 0; k < li.length; k++) {
				vm.importList.push(li[k]);
			}
			vm.masterLibSafe = vm.masterLib;
			vm.importListSafe = vm.importList;
		}

		function removeSelected(id) {
			for (var i = vm.importList.length - 1; i >= 0; i--) {
				if (vm.importList[i].id == id) {
					vm.masterLib.unshift(vm.importList.splice(i, 1)[0]);
				}
			}
			vm.masterLibSafe = vm.masterLib;
			vm.importListSafe = vm.importList;
		}

		function importFeeds() {
			if (vm.importList && vm.importList.length > 0) {
				vm.loading = true;
				if (vm.selectedTeam) {
					for (var i = 0; i < vm.importList.length; i++) {
						vm.importList[i].user_id = vm.user.email;
					}
					var suffix;
					if (vm.settings.selectedHerd && vm.settings.selectedHerd.id) {
						suffix = '?teamId=' + vm.selectedTeam.Id + '&herdId=' + vm.settings.selectedHerd.id;
					} else {
						suffix = '?teamId=' + vm.selectedTeam.Id;
					}
					importSpartanFactory
						.importFeeds(vm.importList, suffix)
						.then(function () {
							vm.importList = [];
							vm.importListSafe = [];
							toastr.success(i18nFilter('_toastr_feeds_import_'));
							$uibModalStack.dismissAll();
							vm.loading = false;
						})
						.catch(function (error) {
							console.log(error);
							vm.loading = false;
							errorService.showErrorMessage(error, true, '_error_occurred_importing_feeds_');
						});
				}
			}
		}

		function cancel() {
			$uibModalStack.dismissAll();
			vm.modalLoading = false;
		}

		function upload() {
			if (vm.file) {
				vm.uploading = true;
				var list = [];
				angular.forEach(vm.file, function (file, index) {
					var name = 'pr' + index;
					vm[name] = $q.defer();
					list.push(vm[name].promise);
					file.uploading = true;
					file.upload = Upload.upload({
						url: APP_CONST.api_base_url + 'upload/oldFeeds',
						data: {
							file: file
						}
					});
					file.upload
						.then(function () {
							$timeout(function () {
								file.uploading = false;
								file.status = 1;
								vm[name].resolve();
							});
						})
						.catch(function (error) {
							errorService.showErrorMessage(error, true, '_error_occurred_importing_feeds_');
							file.status = 2;
							file.uploading = false;
							vm[name].reject();
						});
				});
				$q.all(list).then(function () {
					finish();
				});
			}
		}

		function uploadChanged() {
			if (!changed) {
				changed = true;
				if (vm.file) {
					vm.fileSelected = vm.file.name;
				} else {
					vm.fileSelected = $filter('i18n')('_feeds_import_feeds_spartan3_file_error_message_');
				}
			} else {
				changed = false;
			}
		}

		function finish() {
			init();
			cancel();
		}

		$scope.$on('default_team_selected', function (event, data) {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedTeam = data;
		});

		$scope.$on('default_herd_selected', function () {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.importSpartan3').factory('importSpartanFactory', importSpartanFactory);
	/** @ngInject */
	function importSpartanFactory($q, APP_CONST, $http) {
		return {
			getUploadedDatabases: getUploadedDatabases,
			getTeamsByUser: getTeamsByUser,
			getUploadedFile: getUploadedFile,
			importFeeds: importFeeds
		};

		function getUploadedDatabases() {
			return $http
				.get(APP_CONST.api_base_url + 'storage/files')
				.then(success)
				.catch(error);
		}

		function getTeamsByUser() {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams')
				.then(success)
				.catch(error);
		}

		function getUploadedFile(id) {
			return $http
				.get(APP_CONST.api_base_url + 'storage/files/' + id)
				.then(success)
				.catch(error);
		}

		function importFeeds(feeds, suffix) {
			return $http
				.post(APP_CONST.api_base_url + 'feeds/import' + suffix, feeds)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.importXml').controller('importXmlCtrl', importXmlCtrl);
	/** @ngInject */
	function importXmlCtrl(importXmlFactory, $uibModal, $scope, $uibModalStack, Upload, $filter, APP_CONST, $state, $timeout, $q, $locale, errorService, feedsService) {
		var vm = this;
		var changed;
		vm.openUploadModal = openUploadModal;
		vm.upload = upload;
		vm.uploadChanged = uploadChanged;
		vm.cancel = cancel;
		vm.finish = finish;
		vm.redirectTo = redirectTo;
		vm.reloadApi = reloadApi;
		vm.back = back;
		init();

		function init() {
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.loadingDbs = true;
			getUploadedXmlFiles();
		}

		function reloadApi() {
			vm.loadingDbs = true;
			vm.file = null;
			getUploadedXmlFiles();
		}

		function getUploadedXmlFiles() {
			vm.loadingTable = true;
			return importXmlFactory
				.getUploadedXmlFile()
				.then(function (response) {
					if (response.length > 0) {
						vm.hasFiles = true;

						response.forEach(function (ration) {
							ration.expanded = false;
							ration.imported_count = 0;
							ration.all_feeds_imported = false;
							ration.upload_date = $filter('date')(ration.upload_date, 'mediumDate');

							if (ration.feeds && ration.feeds.length) {
								ration.feeds.forEach(function (feed) {
									if (feed.imported) {
										ration.imported_count++;
									}
								});

								if (ration.imported_count === ration.feeds.length) {
									ration.all_feeds_imported = true;
								}
							}

							vm.dbs = $filter('orderBy')(response, 'id', true);
							var l = vm.dbs.length;
							vm.itemsPerPageValues = [];
							if (l > 5) {
								vm.itemsPerPageValues.push(5);
								vm.itemsPerPageValues.push(10);
							}
							if (l > 10) {
								vm.itemsPerPageValues.push(15);
							}
							if (l > 15) {
								vm.itemsPerPageValues.push(20);
							}
							if (l > 20) {
								vm.itemsPerPageValues.push(25);
							}
						});
					} else {
						vm.hasFiles = false;
					}

					vm.loadingDbs = false;
					vm.loadingTable = false;
				})
				.catch(function (error) {
					vm.loadingDbs = false;
					vm.loadingTable = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_file_', true);
				});
		}

		function openModal(page, size) {
			$uibModal
				.open({
					animation: true,
					templateUrl: page,
					size: size,
					scope: $scope,
					backdrop: 'static',
					keyboard: false
				})
				.closed.then(function () {
					vm.uploading = false;
					vm.file = null;
				});
		}

		function openUploadModal(page, size) {
			openModal(page, size);
		}

		function cancel() {
			$uibModalStack.dismissAll();
			vm.modalLoading = false;
		}

		function back() {
			$state.go('feeds.myfeeds');
		}

		function upload() {
			if (vm.file) {
				vm.uploading = true;
				var list = [];
				angular.forEach(vm.file, function (file, index) {
					var name = 'pr' + index;
					vm[name] = $q.defer();
					list.push(vm[name].promise);
					file.uploading = true;
					file.upload = Upload.upload({
						url: APP_CONST.api_base_url + 'upload/xmlFeeds',
						data: {
							file: file
						}
					});
					file.upload
						.then(function () {
							$timeout(function () {
								file.uploading = false;
								file.status = 1;
								vm[name].resolve();
							});
						})
						.catch(function (error) {
							file.status = 2;
							vm[name].reject();
							file.uploading = false;
							console.log(error);
							errorService.showErrorMessage(error, true, '_error_occurred_uploading_files_');
						});
				});
				$q.all(list).then(function () {
					finish();
				});
			}
		}

		function uploadChanged() {
			if (!changed) {
				changed = true;
				if (vm.file) {
					vm.fileSelected = vm.file.name;
				} else {
					vm.fileSelected = $filter('i18n')('_feeds_insert_feeds_xml_error_');
				}
			} else {
				changed = false;
			}
		}

		function redirectTo(uuid, feedUuid) {
			if (feedUuid) {
				feedsService.setXmlFeedUUID(feedUuid);
			}

			$state.go('feeds.importXmlFeed', {
				uuid: uuid
			});
		}

		function finish() {
			init();
			cancel();
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.importXml').factory('importXmlFactory', importXmlFactory);
	/** @ngInject */
	function importXmlFactory($q, APP_CONST, $http) {
		return {
			getUploadedXmlFile: getUploadedXmlFile
		};

		function getUploadedXmlFile() {
			var request = {
				method: 'GET',
				url: APP_CONST.api_base_url + 'get/xmlUserFiles',
				headers: {
					Accept: 'application/mmmoooglefeed.xmlwithfeedsget.v2+json'
				}
			};

			return $http(request).then(success).catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.importXmlFeed').controller('importXmlFeedCtrl', importXmlFeedCtrl);
	/** @ngInject */
	function importXmlFeedCtrl(importXmlFeedFactory, $filter, APP_CONST, toastr, $stateParams, $timeout, settingsFactory, $locale, $uibModal, $scope, $uibModalStack, $state, $rootScope, dashboardFactory, $http, errorService, feedsService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var timeoutSearch;
		vm.selectType = selectType;
		vm.updateFeed = updateFeed;
		vm.createFeed = createFeed;
		vm.saveFeed = saveFeed;
		vm.teamSelected = teamSelected;
		vm.defineResultFeed = defineResultFeed;
		vm.openChooseFeedModal = openChooseFeedModal;
		vm.feedTypeSelected = feedTypeSelected;
		vm.paginationChangedMaster = paginationChangedMaster;
		vm.searchMasterChanged = searchMasterChanged;
		vm.selectFeed = selectFeed;
		vm.checkDeviation = checkDeviation;
		vm.reloadApi = reloadApi;
		vm.selectXmlFeed = selectXmlFeed;
		vm.cancel = cancel;
		vm.sort = sort;
		vm.commonFeedChanged = commonFeedChanged;
		vm.feedTypeChanged = feedTypeChanged;
		vm.defaultCalculationChanged = defaultCalculationChanged;
		vm.valueChanged = valueChanged;
		vm.feedTypeSelectedValidate = feedTypeSelectedValidate;
		init();

		function init() {
			vm.sortedColumn = 'feed_name';
			vm.order = 'ASC';
			vm.sort_col = 'feed_name_ASC';
			vm.commonYes = i18nFilter('_feeds_yes_');
			vm.commonNo = i18nFilter('_feeds_no_');
			vm.weight = 'kg';
			vm.energy = 'Mcal';
			vm.showFeeds = false;
			vm.updateSelected = false;
			vm.newSelected = false;
			vm.feeds = [];
			vm.feedsSafe = [];
			vm.disableScroll = true;
			vm.loadingTeams = true;
			vm.currentPageMaster = 1;
			vm.itemsPerPageMaster = 30;
			vm.totalDisplayed = 0;
			vm.searchMaster = '';
			vm.loadingXmlFeeds = true;
			vm.myFeedsLoaded = true;
			vm.loadingSave = false;
			vm.loadingUpdate = false;
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			vm.selectedXmlFeed = null;
			vm.selectedMyFeed = null;
			vm.resultFeed = null;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.textFeed = $filter('i18n')('_feeds_feed_');
			vm.nel_89Max = 10.03;
			vm.me_89max = 16.18;
			if (!vm.settings.use_kgs) {
				vm.nel_89Max = round(vm.nel_89Max / 2.2046, 2);
				vm.me_89max = round(vm.me_89max / 2.2046, 2);
			}
			if (!vm.settings.use_mcal) {
				vm.nel_89Max = round(vm.nel_89Max * 4.1868, 2);
				vm.me_89max = round(vm.me_89max * 4.1868, 2);
			}
			if (!vm.settings.use_kgs) {
				vm.weight = 'lb';
			}
			if (!vm.settings.use_mcal) {
				vm.energy = 'Mjoule';
			}
			setDefaultCalculation();
			getXml();
			getTeamsByUser();
			setFeedFilter();
			setCommonFeedFilter();
			setFeedTypesFilter();
			setFeedTypes(APP_CONST.constants.feed_types);
		}

		function reloadApi() {
			vm.disableScroll = true;
			vm.loadingTeams = true;
			vm.loadingXmlFeeds = true;
			vm.myFeedsLoaded = true;
			vm.loadingSave = false;
			vm.loadingUpdate = false;
			getXml();
			getTeamsByUser();
		}

		function paginationChangedMaster() {
			vm.currentPageMaster++;
			vm.isPage = true;
			vm.disableScroll = true;
			getFeedsByTeam(vm.selectedTeam);
		}

		function defaultCalculationChanged() {
			vm.resultFeed = null;
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = [];
			changeDefaultCalculation();
			setFeedTypesFilter();
			vm.myFeedsLoaded = false;
			vm.feedsLoaded = false;
			vm.defaultTable = angular.copy(vm.selectedCalculation);
			getFeedsByTeam(vm.selectedTeam);
		}

		function setFeedFilter() {
			vm.filterTypes = [
				{
					name: '_feed_filter_my_feeds_',
					value: 'my_feeds'
				},
				{
					name: '_feed_filter_master_feeds_',
					value: 'master_feeds'
				}
			];
			vm.selectedFeedType = vm.filterTypes[0];
		}

		function setCommonFeedFilter() {
			vm.commonFeedList = [
				{
					name: i18nFilter('_feeds_type_all_'),
					value: null
				},
				{
					name: vm.commonYes,
					value: true
				},
				{
					name: vm.commonNo,
					value: false
				}
			];
			vm.commonFeedItem = vm.commonFeedList[0];
		}

		function commonFeedChanged() {
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = [];
			getFeedsByTeam(vm.selectedTeam);
		}

		function setFeedTypesFilter() {
			if (vm.selectedCalculation.calc_type == 1) {
				vm.feedTypesList = angular.copy(APP_CONST.constants.feed_vem_types);
			} else {
				vm.feedTypesList = angular.copy(APP_CONST.constants.feed_us_types);
			}
			vm.feedTypesItem = vm.feedTypesList[0];
		}

		function feedTypeChanged() {
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = [];
			getFeedsByTeam(vm.selectedTeam);
		}

		function feedTypeSelected() {
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = [];
			vm.feedsLoaded = false;
			getFeedsByTeam(vm.selectedTeam);
		}

		function sort(column) {
			var col;
			if (column != vm.sortedColumn) {
				vm.sortedColumn = column;
				vm.order = 'ASC';
				col = column + '_' + vm.order;
			} else {
				if (vm.order == 'ASC') {
					vm.order = 'DESC';
					col = column + '_' + vm.order;
				} else if (vm.order == 'DESC') {
					vm.order = 'ASC';
					col = column + '_' + vm.order;
				}
			}
			vm.sort_col = col;
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = [];
			getFeedsByTeam(vm.selectedTeam);
		}

		function searchMasterChanged() {
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			if (vm.searchMaster.length >= 3) {
				if (timeoutSearch) {
					$timeout.cancel(timeoutSearch);
				}
				timeoutSearch = $timeout(function () {
					vm.feeds = [];
					vm.feedsSafe = [];
					getFeedsByTeam(vm.selectedTeam);
				}, 1000);
			}
			if (vm.searchMaster.length == 0) {
				vm.feeds = [];
				vm.feedsSafe = [];
				getFeedsByTeam(vm.selectedTeam);
			}
		}

		function selectFeed(feed) {
			vm.selectedMyFeed = feed;
			$timeout(function () {
				defineResultFeed();
				cancel();
			}, 20);
		}

		function openChooseFeedModal() {
			openModal('app/pages/feeds/importXMLFeed/chooseFeed.modal.html', 'lg');
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = [];
			getFeedsByTeam(vm.selectedTeam);
		}

		function changeDefaultCalculation() {
			vm.settings.calculation_type = vm.selectedCalculation.calc_type;
			return settingsFactory
				.changeSettings(vm.settings, vm.user.email)
				.then(function (response) {
					localStorage.setItem('user_settings', JSON.stringify(response));
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_saving_user_settings_');
				});
		}

		function setDefaultCalculation() {
			vm.defaultCalculationList = [
				{
					name: '_calculation_filter_us_feeds_',
					calc_type: 0
				},
				{
					name: '_calculation_filter_vem_dve_feeds_',
					calc_type: 1
				}
			];
			if (vm.settings.calculation_type != null) {
				for (var i = 0; i < vm.defaultCalculationList.length; i++) {
					if (vm.settings.calculation_type == vm.defaultCalculationList[i].calc_type) {
						vm.selectedCalculation = vm.defaultCalculationList[i];
					}
				}
			} else {
				vm.selectedCalculation = vm.defaultCalculationList[0];
			}
			vm.defaultTable = angular.copy(vm.selectedCalculation);
		}

		function getXml() {
			return importXmlFeedFactory
				.getXml($stateParams.uuid)
				.then(function (response) {
					var temp = response;
					vm.originalXml = angular.copy(response);
					var selectedFeedName = feedsService.getXmlFeedUUID();
					for (var i = 0; i < temp.length; i++) {
						if (temp[i].test_date) {
							temp[i].test_date = new Date(temp[i].test_date);
						} else {
							temp[i].test_date = '-';
						}
						temp[i].is_selected = false;
						var index = i + 1;
						if (!temp[i].feed_name) {
							temp[i].feed_name = $filter('i18n')('_feeds_feed_') + ' ' + index;
						}

						if (selectedFeedName && temp[i].feed_name === selectedFeedName) {
							vm.selectedXmlFeed = temp[i];
						}
					}
					vm.xmlFeeds = temp;
					vm.loadingXmlFeeds = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loadingXmlFeeds = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_file_', true);
				});
		}

		function getTeamsByUser() {
			return importXmlFeedFactory
				.getTeamsByUser()
				.then(function (response) {
					vm.teams = response;
					vm.loadingTeams = false;
					setDefaultTeam(vm.settings, vm.teams);
				})
				.catch(function (error) {
					console.log(error);
					vm.loadingTeams = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_teams_', true);
				});
		}

		function setDefaultTeam(settings, teams) {
			if (settings.selectedTeam) {
				for (var i = 0; i < teams.length; i++) {
					if (settings.selectedTeam.id == teams[i].Id) {
						vm.selectedTeam = teams[i];
						break;
					}
				}
				if (vm.selectedTeam) {
					getHerdsByTeam(vm.selectedTeam);
				}
			}
		}

		function getFeedsByTeam(team, init) {
			var suffix;
			if (vm.settings.selectedHerd && vm.settings.selectedHerd.id) {
				suffix = '?teamId=' + team.Id + '&herdId=' + vm.settings.selectedHerd.id + '&feedsOnly=true';
			} else {
				suffix = '?teamId=' + team.Id + '&feedsOnly=true';
			}
			if (vm.selectedCalculation != null || vm.selectedCalculation != undefined) {
				suffix = suffix + '&localType=' + vm.selectedCalculation.calc_type;
			}
			if (vm.currentPageMaster) {
				suffix = suffix + '&page=' + vm.currentPageMaster;
			}
			if (vm.searchMaster) {
				suffix = suffix + '&feedName=' + encodeURIComponent(vm.searchMaster);
			}
			if (vm.selectedFeedType) {
				suffix = suffix + '&returnType=' + vm.selectedFeedType.value;
			}
			if (vm.commonFeedItem && vm.commonFeedItem.value != null) {
				suffix = suffix + '&commonFeed=' + vm.commonFeedItem.value;
			}
			if (vm.feedTypesItem && vm.feedTypesItem.value) {
				suffix = suffix + '&feedType=' + vm.feedTypesItem.value;
			}
			if (vm.sortedColumn && vm.order) {
				suffix = suffix + '&orderBy=' + vm.sortedColumn + '&orderType=' + vm.order;
			}
			if (!vm.isPage) {
				vm.totalDisplayed = 0;
				vm.feedsLoaded = false;
			}
			vm.isPage = false;
			cancelApiRequest();
			return importXmlFeedFactory
				.getMyFeedsByTeam(suffix)
				.then(function (response) {
					if (response.length > 0) {
						vm.totalDisplayed += response.length;
						vm.totalItemsMaster = response[0].number_of_all;
					} else {
						vm.totalItemsMaster = 0;
					}
					var temp = response;
					for (var i = 0; i < temp.length; i++) {
						fixVemValues(temp[i]);
						if (temp[i].test_date) {
							temp[i].test_date = new Date(temp[i].test_date);
						} else {
							temp[i].test_date = '-';
						}
						temp[i].is_selected = false;
						var hasFeedType = false;
						for (var j = 0; j < vm.feed_types.length; j++) {
							if (temp[i].feed_type.toLowerCase() === vm.feed_types[j].name.toLowerCase()) {
								temp[i].feed_type = vm.feed_types[j];
								hasFeedType = true;
								break;
							}
						}
						if (!hasFeedType) {
							temp[i].feed_type = {
								show_name: '_feeds_type_not_set_'
							};
						}
						if (temp[i].mixes) {
							for (var k = 0; k < temp[i].mixes.length; k++) {
								fixVemValues(temp[i].mixes[k]);
								var hasFeedTypeMix = false;
								for (var m = 0; m < vm.feed_types.length; m++) {
									if (temp[i].mixes[k].feed_type.toLowerCase() === vm.feed_types[m].name.toLowerCase()) {
										temp[i].mixes[k].feed_type = vm.feed_types[m];
										hasFeedTypeMix = true;
										break;
									}
								}
								if (!hasFeedTypeMix) {
									temp[i].mixes[k].feed_type = {
										show_name: '_feeds_type_not_set_'
									};
								}
							}
						}
					}
					vm.feeds = response;
					vm.feedsSafe = vm.feeds;
					vm.myFeedsLoaded = true;
					vm.feedsLoaded = true;
					vm.disableScroll = false;
					$timeout(function () {
						var searchInput = document.getElementById('feedsSearchInput');
						if (searchInput) {
							searchInput.focus();
						}
					}, 50);
				})
				.catch(function (error) {
					if (error != 'Canceled') {
						vm.feedsLoaded = true;
						vm.disableScroll = false;
						console.log(error);
						vm.loadingTable = false;
						vm.myFeedsLoaded = true;
						errorService.showErrorMessage(error, true, '_error_occurred_loading_feeds_', init);
					}
				});

			function fixVemValues(item) {
				item.vem = item.vem || 0;
				item.dve = item.dve || 0;
				item.oeb = item.oeb || 0;
				item.fos = item.fos || 0;
				item.rc = item.rc || 0;
				item.rus = item.rus || 0;
			}
		}

		function cancelApiRequest() {
			angular.forEach($http.pendingRequests, function (req) {
				if (req.url.split('?')[0] == APP_CONST.api_base_url + 'feeds' && req.method == 'GET') {
					importXmlFeedFactory.cancelRequest();
				}
			});
		}

		function selectType(type) {
			vm.feedType = type;
			if (type == 'update') {
				vm.selectedFeedType = vm.filterTypes[0];
				vm.showFeeds = true;
				vm.updateSelected = true;
				vm.newSelected = false;
			} else if (type == 'new') {
				vm.selectedFeedType = vm.filterTypes[1];
				vm.updateSelected = false;
				vm.newSelected = true;
				vm.showFeeds = true;
			}

			$timeout(function () {
				defineResultFeed();
			}, 100);
		}

		function updateFeed() {
			var feed = angular.copy(vm.resultFeed);
			if (vm.selectedTeam) {
				feed.feed_type = feed.feed_type.name;
				feedUpdate(feed);
			}
		}

		function createFeed() {
			vm.newFeed = vm.resultFeed;
			vm.newFeed.common_feed = false;
			vm.newFeed.feed_name = vm.selectedXmlFeed.feed_name;
			vm.newFeed.original_name = vm.selectedXmlFeed.feed_name;
			openModal('app/pages/feeds/importXMLFeed/importXMLNewFeed.modal.html', 'md');
		}

		function feedUpdate(feed) {
			feed.user_id = vm.user.email;
			feed.test_date.setHours(12);
			feed.event = vm.event || 'rus';
			var DTO = {
				file_uuid: $stateParams.uuid,
				feed_dto: feed,
				import_xml_feed_compare_dto: vm.selectedXmlFeed
			};
			vm.loadingUpdate = true;
			return importXmlFeedFactory
				.updateFeed(DTO)
				.then(function () {
					toastr.success($filter('i18n')('_toastr_feeds_updated_'), $filter('i18n')('_toastr_success_title_'));
					vm.loadingUpdate = false;
					checkIfAllFeedsImported();
				})
				.catch(function (error) {
					console.log(error);
					vm.loadingUpdate = false;
					errorService.showErrorMessage(error, true, '_error_occurred_updating_feed_');
				});
		}

		function openModal(page, size) {
			var modal = $uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
			return modal;
		}

		function setFeedTypes(feed_types) {
			vm.feed_types = [];
			for (var i = 0; i < feed_types.length; i++) {
				if (feed_types[i].type == vm.selectedCalculation.calc_type || feed_types[i].type == 2) {
					var temp = '_feeds_type_' + feed_types[i].value + '_';
					feed_types[i].show_name = temp;
					feed_types[i].translated = i18nFilter(temp);
					vm.feed_types.push(feed_types[i]);
				}
			}
		}

		function cancel() {
			$uibModalStack.dismissAll();
		}

		function setDefaultHerd() {
			var herd = {
				herd_id: vm.selected_herd.Id
			};
			return dashboardFactory
				.setDefaultTeamHerd(herd)
				.then(function (response) {
					localStorage.setItem('user_settings', JSON.stringify(response));
					brodcastHerdSelected(vm.selected_herd);
					$timeout(function () {
						$state.go('feeds.myfeeds');
					}, 100);
				})
				.catch(function (error) {
					vm.loadingSave = false;
					console.log(error);
					if (error.status === 403) {
						errorService.showErrorMessage(error, true, '_error_occurred_setting_default_herd_');
					} else {
						errorService.showErrorMessage(error, true, '_error_occurred_changing_default_herd_');
					}
				});
		}

		function chackSelectedHerd() {
			if (vm.settings.selectedHerd.id) {
				for (var i = 0; i < vm.herds.length; i++) {
					if (vm.settings.selectedHerd.id == vm.herds[i].Id) {
						vm.selected_herd = vm.herds[i];
					}
				}
			} else {
				vm.selected_herd = vm.herds[0];
			}
		}

		function getHerdsByTeam(team) {
			importXmlFeedFactory
				.getHerdsByTeam(team.Id)
				.then(function (response) {
					var temp = {
						Id: null,
						Name: ''
					};
					response.splice(0, 0, temp);
					vm.herds = response;
					chackSelectedHerd();
					vm.loading = false;
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_herds_', true);
				});
		}

		function feedTypeSelectedValidate() {
			if (vm.feedTypesItem.value) {
				vm.addXmlFeedForm.feed_type.$setValidity('feed_type', true);
			} else {
				vm.addXmlFeedForm.feed_type.$setValidity('feed_type', false);
			}
		}

		function saveFeed() {
			if (vm.selectedTeam) {
				var xmlFeedDto = angular.copy(vm.newFeed);
				if (xmlFeedDto.feed_name !== null && xmlFeedDto.feed_name && xmlFeedDto.feed_name !== '' && xmlFeedDto.feed_name.length > 0) {
					if (vm.feedTypesItem.value) {
						xmlFeedDto.feed_type = vm.feedTypesItem.value;
						xmlFeedDto.feed_category = vm.feedTypesItem.category;
						saveNewFeed(xmlFeedDto);
					} else {
						vm.addXmlFeedForm.feed_type.$setValidity('feed_type', false);
					}
				}
			}
		}

		function saveNewFeed(feedDTO) {
			feedDTO.team_id = vm.selectedTeam.Id;
			feedDTO.user_id = vm.user.email;
			if (feedDTO.feed_locale) {
				feedDTO.calculation_type = feedDTO.feed_locale;
			} else {
				feedDTO.feed_locale = vm.settings.calculation_type;
				feedDTO.calculation_type = vm.settings.calculation_type;
			}
			feedDTO.test_date.setHours(12);
			feedDTO.event = vm.event || 'rus';
			var DTO = {
				file_uuid: $stateParams.uuid,
				feed_dto: feedDTO,
				import_xml_feed_compare_dto: vm.selectedXmlFeed
			};
			var suffix;
			if (vm.selected_herd && vm.selected_herd.Id) {
				suffix = '?teamId=' + vm.selectedTeam.Id + '&herdId=' + vm.selected_herd.Id;
			} else {
				suffix = '?teamId=' + vm.selectedTeam.Id;
			}
			vm.loadingSave = true;
			return importXmlFeedFactory
				.saveFeed(DTO, suffix)
				.then(function () {
					if (vm.selected_herd.Id != null && vm.selected_herd.Id != vm.settings.selectedHerd.id) {
						setDefaultHerd();
					} else {
						checkIfAllFeedsImported();
					}
					toastr.success($filter('i18n')('_toastr_feeds_add_'), $filter('i18n')('_toastr_success_title_'));
				})
				.catch(function (error) {
					vm.loadingSave = false;
					console.log(error);
					if (error.status === 403) {
						errorService.showErrorMessage(error, true, '_error_occurred_setting_default_herd_');
					} else {
						errorService.showErrorMessage(error, true, '_error_occurred_creating_feed_');
					}
				});
		}

		function checkIfAllFeedsImported() {
			var importedCount = 0;

			vm.xmlFeeds.forEach(function (feed) {
				if (feed.imported) {
					importedCount++;
				}
			});

			if (Math.abs(vm.xmlFeeds.length - importedCount) <= 1) {
				$state.go('feeds.importXml');
			} else {
				feedsService.clear();
				cancel();
				init();
			}
		}

		function defineResultFeed() {
			if (vm.selectedXmlFeed) {
				vm.resultFeed = {};
				if (vm.selectedMyFeed) {
					angular.copy(vm.selectedMyFeed, vm.resultFeed);
				}
				angular.forEach(vm.selectedXmlFeed, function (value, key) {
					if (value != '-') {
						if (key != 'comments' && key != 'feed_category' && key != 'feed_name' && key != 'feed_type') {
							vm.resultFeed[key] = value;
						}
						if (key == 'comments') {
							if (vm.resultFeed[key]) {
								vm.resultFeed[key] = vm.resultFeed[key] + ' ' + value;
							} else {
								vm.resultFeed[key] = value;
							}
						}
					}
				});
			}
		}

		function selectXmlFeed(feed) {
			vm.selectedXmlFeed = feed;

			$timeout(function () {
				defineResultFeed();
			}, 10);
		}

		//result feed my feed
		function checkDeviation(key) {
			if (vm.selectedMyFeed && vm.resultFeed) {
				var percent = vm.selectedMyFeed[key] * 0.1;
				if (vm.selectedMyFeed[key] + percent < vm.resultFeed[key]) {
					vm.deviationUp = 0;
					vm.resultFeed.deviationToolTip = i18nFilter('_import_xml_deviation_up_');
					return 'primaryModal';
				} else if (vm.selectedMyFeed[key] - percent > vm.resultFeed[key]) {
					vm.resultFeed.deviationToolTip = i18nFilter('_import_xml_deviation_down_');
					vm.deviationUp = 1;
					return 'warningModal';
				} else {
					vm.deviationUp = 3;
				}
			}
		}

		function valueChanged(prop) {
			vm.event = prop;
		}

		function teamSelected() {
			vm.isTeamSelected = true;
			getFeedsByTeam(vm.selectedTeam);
		}

		document.addEventListener('mousewheel', function () {
			if (document.activeElement.type === 'number') {
				document.activeElement.blur();
			}
		});

		function brodcastHerdSelected(herd) {
			$rootScope.$broadcast('default_herd_selected_from_herds', herd);
		}

		function round(value, decimals) {
			return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
		}

		$scope.$on('default_team_selected', function (event, data) {
			vm.feedsLoaded = false;
			vm.updateSelected = false;
			vm.newSelected = false;
			vm.selectedMyFeed = null;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedTeam = data;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = null;
			vm.currentPageMaster = 1;
			vm.searchMaster = '';
			getHerdsByTeam(vm.selectedTeam);
			getFeedsByTeam(data, true);
		});

		$scope.$on('default_herd_selected', function () {
			vm.feedsLoaded = false;
			vm.updateSelected = false;
			vm.newSelected = false;
			vm.selectedMyFeed = null;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = null;
			vm.currentPageMaster = 1;
			vm.searchMaster = '';
			chackSelectedHerd();
			getFeedsByTeam(vm.selectedTeam, true);
		});

		$scope.$on('$stateChangeStart', function () {
			feedsService.clear();
		});

		$scope.$on('default_team_herd_changed', function () {
			cancelApiRequest();
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.importXmlFeed').factory('importXmlFeedFactory', importXmlFeedFactory);
	/** @ngInject */
	function importXmlFeedFactory($q, APP_CONST, $http) {
		var cancelReq;
		var statusText;

		return {
			getXml: getXml,
			getTeamsByUser: getTeamsByUser,
			getMyFeedsByTeam: getMyFeedsByTeam,
			updateFeed: updateFeed,
			saveFeed: saveFeed,
			getHerdsByTeam: getHerdsByTeam,
			cancelRequest: cancelRequest
		};

		function cancelRequest() {
			statusText = 'Canceled';
			cancelReq.resolve();
		}

		function getXml(uuid) {
			var request = {
				method: 'GET',
				url: APP_CONST.api_base_url + 'get/xmlFeeds/' + uuid,
				headers: {
					Accept: 'application/mmmoooglefeed.feedsfromxmlget.v2+json'
				}
			};

			return $http(request).then(success).catch(error);
		}

		function getTeamsByUser() {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams')
				.then(success)
				.catch(error);
		}

		function getMyFeedsByTeam(suffix) {
			cancelReq = $q.defer();
			return $http
				.get(APP_CONST.api_base_url + 'feeds' + suffix, {
					timeout: cancelReq.promise
				})
				.then(success)
				.catch(function (error) {
					var err = statusText ? $q.reject(statusText) : $q.reject(error);
					statusText = undefined;
					return err;
				});
		}

		function updateFeed(feedDTO) {
			var request = {
				method: 'PUT',
				url: APP_CONST.api_base_url + 'feeds',
				headers: {
					Accept: 'application/mmmoooglefeed.updatefeedfromxml.v2+json'
				},
				data: feedDTO
			};

			return $http(request).then(success).catch(error);
		}

		function saveFeed(feedDTO, suffix) {
			return $http
				.post(APP_CONST.api_base_url + 'feedsFromXML' + suffix, feedDTO)
				.then(success)
				.catch(error);
		}

		function getHerdsByTeam(id) {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams/' + id + '/herds')
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.manualFeedsHistory').controller('manualFeedsHistoryCtrl', manualFeedsHistoryCtrl);
	/** @ngInject */
	function manualFeedsHistoryCtrl($stateParams, manualFeedsHistoryService, APP_CONST, $filter, $state, errorService) {
		var vm = this;
		var i18nFilter = $filter('i18n');

		vm.back = back;
		vm.paginationChanged = paginationChanged;

		init();

		function init() {
			vm.loading = true;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedTeam = vm.settings.selectedTeam.id;
			vm.selectedHerd = vm.settings.selectedHerd.id;
			vm.currentPage = 1;
			vm.itemsPerPage = 10;
			vm.history = [];
			setFeedTypes(APP_CONST.constants.feed_types);
			getHistory(true);
		}

		function setFeedTypes(feed_types) {
			var types = angular.copy(feed_types);

			vm.feedTypes = types.map(function (type) {
				var t = '_feeds_type_' + type.value + '_';
				type.show_name = t;
				type.translated = i18nFilter(t);
				return type;
			});
		}

		function getHistory(init) {
			var suffix = '?teamId=' + vm.selectedTeam + '&herdId=' + vm.selectedHerd + '&pageNumber=' + (vm.currentPage - 1);
			manualFeedsHistoryService
				.getHistory($stateParams.uuid, suffix)
				.then(function (response) {
					vm.totalItems = response && response.number_of_all ? response.number_of_all : 0;
					if (vm.totalItems > 0) {
						vm.history = response.manual_feeds_history.map(function (history) {
							var found = false;

							for (var i = 0; i < vm.feedTypes.length; i++) {
								if (history.feed_type.toLowerCase() === vm.feedTypes[i].name.toLowerCase()) {
									history.feed_type = vm.feedTypes[i];
									found = true;
									break;
								}
							}

							if (!found) {
								history.feed_type = {
									show_name: '_feeds_type_not_set_',
									translated: i18nFilter('_feeds_type_not_set_')
								};
							}

							return history;
						});
					}
					vm.loading = false;
					vm.loadingTable = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					vm.loadingTable = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_feed_history_', init);
				});
		}

		function paginationChanged() {
			vm.loadingTable = true;
			getHistory();
		}

		function back() {
			$state.go('feeds.mymanualfeeds');
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.manualFeedsHistory').factory('manualFeedsHistoryService', manualFeedsHistoryService);
	/** @ngInject */
	function manualFeedsHistoryService($http, APP_CONST, $q) {
		return {
			getHistory: getHistory
		};

		function getHistory(id, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'manualfeeds/' + id + '/history' + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.myfeeds').controller('myfeedsCtrl', myfeedsCtrl);
	/** @ngInject */
	function myfeedsCtrl(editableOptions, editableThemes, APP_CONST, $cookies, $state, $uibModal, settingsFactory, baProgressModal, $scope, toastr, $uibModalStack, $filter, myFeedsFactory, $timeout, $locale, dataServiceFactory, $http, errorService, unitConversionService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var searchTimeout;
		var timeoutCM;
		var paginationModal;
		vm.weight = 'kg';
		vm.energy = 'Mcal';
		vm.editFeed = editFeed;
		vm.select = select;
		vm.checkIsSelected = checkIsSelected;
		vm.checkIsSelectedDelete = checkIsSelectedDelete;
		vm.cancelFilters = cancelFilters;
		vm.createMIX = createMIX;
		vm.saveMIX = saveMIX;
		vm.cancel = cancel;
		vm.deleteFeed = deleteFeed;
		vm.redirectTo = redirectTo;
		vm.dataCollapseFn = dataCollapseFn;
		vm.selectTableRow = selectTableRow;
		vm.convertToFeed = convertToFeed;
		vm.teamSelected = teamSelected;
		vm.unmix = unmix;
		vm.updateFeed = updateFeed;
		vm.updateMix = updateMix;
		vm.addFeedToMix = addFeedToMix;
		vm.removeFeedFromMix = removeFeedFromMix;
		vm.addAll = addAll;
		vm.removeSelected = removeSelected;
		vm.removeAll = removeAll;
		vm.addSelected = addSelected;
		vm.insertFeeds = insertFeeds;
		vm.feedTypeSelected = feedTypeSelected;
		vm.paginationChanged = paginationChanged;
		vm.createRation = createRation;
		vm.goToHistory = goToHistory;
		vm.feedKeyDown = feedKeyDown;
		vm.mixKeyDown = mixKeyDown;
		vm.search = search;
		vm.changeAmount = changeAmount;
		vm.changeAsFed = changeAsFed;
		vm.createMixFromEdit = createMixFromEdit;
		vm.updateMixEdit = updateMixEdit;
		vm.sort = sort;
		vm.sortMix = sortMix;
		vm.feedTypeFilterChanged = feedTypeFilterChanged;
		vm.defaultCalculationChanged = defaultCalculationChanged;
		vm.proceed = proceed;
		vm.reloadApi = reloadApi;
		vm.openFiltersModal = openFiltersModal;
		vm.searchMix = searchMix;
		vm.feedTypeChangedMix = feedTypeChangedMix;
		vm.defaultCalculationChangedMix = defaultCalculationChangedMix;
		vm.feedTypeSelectedMix = feedTypeSelectedMix;
		vm.paginationMix = paginationMix;
		vm.saveFilter = saveFilter;
		vm.stopLoadingTabs = stopLoadingTabs;
		vm.changeUnits = changeUnits;
		vm.changeAmountProduct = changeAmountProduct;
		vm.tableRowExpanded = false;
		vm.tableRowIndexExpandedCurr = '';
		vm.tableRowIndexExpandedPrev = '';
		vm.idExpanded = '';
		vm.selectedList = [];
		vm.listOfFeeds = [];
		vm.importList = [];
		vm.titleUnmix = '_tips_unmix_';
		vm.titleConvert = '_tips_convert_to_feed_';
		vm.titleEdit = '_tips_edit_';
		vm.titleAddFeedToMix = '_tips_add_feed_to_mix_';
		vm.titleRemoveFeedFromMix = '_tips_remove_feed_from_mix_';
		vm.titleHistory = '_tips_history_';
		vm.titleExpand = '_tips_expand_mix_';
		vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
		vm.openProgressDialog = baProgressModal.open;
		vm.currentPage = 1;
		vm.itemsPerPage = 50;
		//date picker
		vm.opened = {};
		vm.open = function ($event, elementOpened) {
			$event.preventDefault();
			$event.stopPropagation();
			vm.opened[elementOpened] = !vm.opened[elementOpened];
		};
		init();

		document.addEventListener('mousewheel', function () {
			if (document.activeElement.type === 'number') {
				document.activeElement.blur();
			}
		});

		$scope.$watch('vm.selectedTab', function (newValue) {
			vm.loadingTabs = true;
			$timeout(function () {
				vm.showHome = newValue == 1 ? true : false;
				vm.showFiber = newValue == 2 ? true : false;
				vm.showEnergy = newValue == 3 ? true : false;
				vm.showProtein = newValue == 4 ? true : false;
				vm.showCarb = newValue == 5 ? true : false;
				vm.showLipid = newValue == 6 ? true : false;
				vm.showMineral = newValue == 7 ? true : false;
				vm.showTMineral = newValue == 8 ? true : false;
				vm.showVitamin = newValue == 9 ? true : false;
				vm.showAA = newValue == 10 ? true : false;
				vm.showCostTab = newValue == 11 ? true : false;
				vm.showMisc = newValue == 12 ? true : false;
			}, 10);
		});

		function stopLoadingTabs() {
			$timeout(function () {
				vm.loadingTabs = false;
			}, 50);
		}

		function init() {
			vm.disableScroll = true;
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			localStorage.removeItem('feed_calculation_type');
			vm.deleteDisabled = true;
			vm.modalOpened = false;
			vm.loading = true;
			vm.modalLoading = false;
			vm.loadingSubtable = false;
			vm.searchString = '';
			vm.sortedColumn = null;
			vm.sort_col = null;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.nel_89Max = 10.03;
			vm.me_89max = 16.18;
			vm.nel_89Max = unitConversionService.convertData(vm.nel_89Max, ['kgToLb:nel_89', 'mcalToMjoule:nel_89', 'round:2']);
			vm.me_89max = unitConversionService.convertData(vm.me_89max, ['kgToLb:me_89', 'mcalToMjoule:me_89', 'round:2']);
			if (vm.settings.use_percent) {
				vm.sliderUsePercent = true;
			} else {
				vm.sliderUsePercent = false;
			}
			$timeout(function () {
				setStrings();
			}, 300);
			setSwitchLabels();
			setUseAmountSwitch();
			setDefaultCalculation();
			setFeedTypes(APP_CONST.constants.feed_types);
			setFeedFilter();
			setFeedTypesFilter();
			getTeamsByUser();
			if (!vm.settings.use_kgs) {
				vm.weight = 'lb';
			}
			if (!vm.settings.use_mcal) {
				vm.energy = 'Mjoule';
			}
		}

		function setSwitchLabels() {
			vm.amountSwitchLabel = i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_');
			vm.productSwitchLabel = i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_m_f_product_switch_product_type');
		}

		function setUseAmountSwitch() {
			try {
				var sw = JSON.parse($cookies.get('use_product'));
			} catch (error) {
				vm.switchUseAmount = true;
				$cookies.put('use_product', vm.switchUseAmount, {
					expires: moment().add(1, 'month').toDate()
				});
			}
			if (sw != null) {
				vm.switchUseAmount = sw;
			}
		}

		function changeAmountProduct() {
			vm.loadingTable = true;
			$cookies.put('use_product', vm.switchUseAmount, {
				expires: moment().add(1, 'month').toDate()
			});
			$timeout(function () {
				vm.loadingTable = false;
			}, 250);
		}

		function cancelFilters() {
			vm.feedTypeItem = vm.previousValues.feedTypeItem;
			$uibModalStack.dismissAll();
		}

		function reloadApi() {
			vm.disableScroll = true;
			vm.deleteDisabled = true;
			vm.loading = true;
			vm.modalLoading = false;
			vm.loadingSubtable = false;
			getTeamsByUser();
		}

		function changeUnits() {
			vm.loadingTable = true;
			$timeout(function () {
				if (vm.sliderUsePercent) {
					vm.settings.use_percent = true;
				} else {
					vm.settings.use_percent = false;
				}
				vm.selectedList = [];
				localStorage.setItem('user_settings', JSON.stringify(vm.settings));
				saveSettings();
				getFeedsByTeam(vm.selectedTeam, vm.currentPage);
			}, 100);
		}

		function saveSettings() {
			settingsFactory
				.changeSettings(vm.settings, vm.user.email)
				.then()
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_saving_user_settings_');
				});
		}

		function setStrings() {
			vm.titleUnmix = '_tips_unmix_';
			vm.titleConvert = '_tips_convert_to_feed_';
			vm.titleEdit = '_tips_edit_';
			vm.titleAddFeedToMix = '_tips_add_feed_to_mix_';
			vm.titleRemoveFeedFromMix = '_tips_remove_feed_from_mix_';
			vm.titleHistory = '_tips_history_';
			vm.typeAll = i18nFilter('_feeds_type_all_');
			vm.typeDryForage = i18nFilter('_feeds_type_dry_forage_');
			vm.typeCornSilage = i18nFilter('_feeds_type_corn_silage_');
			vm.typeGrass = i18nFilter('_feeds_type_grass_silage_');
			vm.typeAlfa = i18nFilter('_feeds_type_alfa_silage_');
			vm.typeOther = i18nFilter('_feeds_type_other_wet_forage_');
			vm.typeByProduct = i18nFilter('_feeds_type_by_product_');
			vm.typeGrain = i18nFilter('_feeds_type_grain_');
			vm.typeFatty = i18nFilter('_feeds_type_fatty_acid_source_');
			vm.typeTriglicerides = i18nFilter('_feeds_type_triglycerides_');
			vm.typeCP = i18nFilter('_feeds_type_cp_source_');
			vm.typeRUP = i18nFilter('_feeds_type_rup_source_');
			vm.typeMineral = i18nFilter('_feeds_type_mineral_');
			vm.typeVitamin = i18nFilter('_feeds_type_vitamin_');
			vm.typeMix = i18nFilter('_feeds_type_mix_');
			vm.commonYes = i18nFilter('_feeds_yes_');
			vm.commonNo = i18nFilter('_feeds_no_');
			vm.typeForage = i18nFilter('_feeds_type_forage_');
			vm.typeConcentrate = i18nFilter('_feeds_type_concentrate_');
			vm.typeCommercial = i18nFilter('_feeds_type_commercial_');
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
		}

		function paginationChanged() {
			getFeedsByTeam(vm.selectedTeam, vm.currentPage);
		}

		function findFeed(feed) {
			for (var i = 0; i < vm.feeds.length; i++) {
				if (vm.feeds[i].id === feed.id) {
					return {
						feed: angular.copy(vm.feeds[i]),
						index: i
					};
				}
			}
		}

		function findMix(feed, index) {
			for (var i = 0; i < vm.feeds[index].mixes.length; i++) {
				if (vm.feeds[index].mixes[i].id === feed.id) {
					return {
						feed: angular.copy(vm.feeds[index].mixes[i]),
						index: i
					};
				}
			}
		}

		function select(feed, insert) {
			var mainFeed = findFeed(feed).feed;
			if (vm.dataCollapse && !insert) {
				for (var i = 0; i < vm.dataCollapse.length; i++) {
					vm.dataCollapse[i] = false;
				}
				collapseTable();
			}
			var found = false;
			var inx = null;
			if (vm.selectedList.length == 0) {
				vm.selectedList.push(mainFeed);
			} else {
				for (var j = 0; j < vm.selectedList.length; j++) {
					if (vm.selectedList[j].id == mainFeed.id) {
						found = true;
						inx = j;
					}
				}
				if (found) {
					vm.selectedList.splice(inx, 1);
				} else {
					vm.selectedList.push(mainFeed);
				}
			}
			if (vm.selectedList.length > 0) {
				var isMaster = false;
				for (var k = 0; k < vm.selectedList.length; k++) {
					if (!vm.selectedList[k].team_id) {
						isMaster = true;
						break;
					}
				}
				vm.deleteDisabled = isMaster;
			} else {
				vm.deleteDisabled = true;
			}
		}

		function addAll() {
			var mList = [];
			angular.copy(vm.feedsByTeam, mList);
			for (var i = 0; i < mList.length; i++) {
				if (!mList[i].is_mix) {
					vm.importList.push(mList[i]);
					vm.feedsByTeam = vm.feedsByTeam.filter(function (feed) {
						return feed.id != mList[i].id && feed.is_mix;
					});
				}
			}
			vm.importListSafe = vm.importList;
			vm.currentPageMaster++;
			vm.disableScroll = true;
			vm.modalOpened = true;
			getFeedsForMix(vm.selectedTeam);
		}

		function removeAll() {
			for (var i = 0; i < vm.importList.length; i++) {
				vm.feedsByTeam.push(vm.importList[i]);
			}
			vm.importList = [];
			var orderBool;
			if (vm.orderMix == 'ASC') {
				orderBool = false;
			} else {
				orderBool = true;
			}
			vm.feedsByTeam = $filter('orderBy')(vm.feedsByTeam, vm.sortedColumnMix, orderBool);
		}

		function createRation() {
			var selectedList = angular.copy(vm.selectedList);
			if (checkIsSelectedDelete()) {
				for (var i = 0; i < selectedList.length; i++) {
					selectedList[i].feed_type = selectedList[i].feed_type.name;
					if (selectedList[i].mixes && selectedList[i].mixes.length > 0) {
						for (var k = 0; k < selectedList[i].mixes.length; k++) {
							selectedList[i].mixes[k].feed_type = selectedList[i].mixes[k].feed_type.name;
						}
					}
				}
				dataServiceFactory.shared_feeds = selectedList;
				$state.go('rations.addnewration');
			} else {
				openModal('app/pages/feeds/myfeeds/ration_message.html', 'md');
			}
		}

		function insertFeeds() {
			if (vm.importList.length > 0) {
				vm.modalLoading = true;
				for (var i = 0; i < vm.importList.length; i++) {
					vm.importList[i].feed_type = vm.importList[i].feed_type.name ? vm.importList[i].feed_type.name : vm.importList[i].feed_type ? vm.importList[i].feed_type : i18nFilter('_feeds_type_miscellaneous_');
					vm.importList[i].amount = 0;
					vm.importList[i].user_id = vm.user.email;
					if (!vm.importList[i].team_id) {
						vm.importList[i].team_id = vm.selectedTeam.Id;
					}
					if (vm.importList[i].mixes && vm.importList[i].mixes.length > 0) {
						for (var k = 0; k < vm.importList[i].mixes.length; k++) {
							vm.importList[i].mixes[k].feed_type = vm.importList[i].mixes[k].feed_type.name;
							vm.importList[i].mixes[k].feed_type = vm.importList[i].mixes[k].feed_type.name ? vm.importList[i].mixes[k].feed_type.name : vm.importList[i].mixes[k].feed_type ? vm.importList[i].mixes[k].feed_type : i18nFilter('_feeds_type_miscellaneous_');
							vm.importList[i].mixes[k].amount = 0;
						}
					}
				}
				myFeedsFactory
					.insertFeedToMix(vm.mix.id, vm.importList)
					.then(function () {
						vm.selectedList = [];
						$uibModalStack.dismissAll();
						vm.modalLoading = false;
						getFeedsByTeam(vm.selectedTeam, vm.currentPage);
					})
					.catch(function (error) {
						console.log(error);
						vm.modalLoading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_feed_to_mix_');
					});
			} else {
				toastr.warning(i18nFilter('_warning_select_feeds_for_ration_'), i18nFilter('_title_warning_'));
			}
		}

		function addFeedToMix() {
			vm.sortedColumnMix = 'feed_name';
			vm.orderMix = 'ASC';
			vm.sort_col_mix = null;
			vm.importList = [];
			vm.importListSafe = [];
			vm.currentPageMaster = 1;
			vm.searchMaster = '';
			vm.feedsByTeamLength = 0;
			vm.modalLoading = true;
			vm.disableScroll = true;
			vm.feedsByTeam = [];
			getFeedsForMix(vm.selectedTeam);
		}

		function removeFeedFromMix(feed) {
			var feedIndex;
			Object.keys(vm.dataCollapse).forEach(function (key) {
				if (vm.dataCollapse[key] == true) {
					feedIndex = key;
				}
			});
			vm.convert_unmix = findMix(feed, feedIndex).feed;
			vm.warningMessage = '_feeds_remove_from_mix_warning_message_';
			openModal('app/pages/feeds/myfeeds/confirmationDialog.modal.html', 'md');
		}

		function removeFeedFromMixProceed(feed) {
			var removeFeedDTO = angular.copy(feed);
			var feedIndex;
			Object.keys(vm.dataCollapse).forEach(function (key) {
				if (vm.dataCollapse[key] == true) {
					feedIndex = key;
				}
			});
			removeFeedDTO.feed_type = removeFeedDTO.feed_type.name;
			removeFeedDTO.user_id = vm.user.email;
			var currentFeed = vm.feeds[feedIndex];
			if (currentFeed.mixes.length > 2) {
				vm.modalLoading = true;
				myFeedsFactory
					.removeFeedFromMix(currentFeed.id, removeFeedDTO)
					.then(function () {
						vm.selectedList = [];
						$uibModalStack.dismissAll();
						vm.modalLoading = false;
						getFeedsByTeam(vm.selectedTeam, vm.currentPage);
					})
					.catch(function (error) {
						console.log(error);
						vm.modalLoading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_remove_feed_from_mix_');
					});
			} else {
				toastr.warning('', i18nFilter('_toastr_mix_number_of_feeds_error_'));
			}
		}

		function checkIsSelected() {
			if (vm.selectedList.length > 1) return true;
			else return false;
		}

		function checkIsSelectedDelete() {
			if (vm.selectedList.length > 0) return true;
			else return false;
		}

		function changeAmount(feed) {
			if (timeoutCM) {
				$timeout.cancel(timeoutCM);
			}
			timeoutCM = $timeout(function () {
				feed.dirty = true;
				feed.as_fed = (feed.amount * 100) / feed.dm;
			}, 100);
		}

		function changeAsFed(feed) {
			if (timeoutCM) {
				$timeout.cancel(timeoutCM);
			}
			timeoutCM = $timeout(function () {
				feed.dirty = true;
				feed.amount = (feed.as_fed * feed.dm) / 100;
			}, 100);
		}

		function createMixFromEdit() {
			if (!vm.editMixForm.$invalid) {
				vm.listOfFeeds = vm.feedToEdit.mixes;
				vm.mix_name = vm.feedToEdit.feed_name;
				saveMIX();
			}
		}

		function createMIX(page, size) {
			if (checkIsSelected()) {
				var date = new Date();
				vm.mix_name = 'New premix ' + $filter('date')(date, 'yyyy-MM-dd');
				vm.listOfFeeds = [];
				var tempList = [];
				var isMix = false;
				for (var i = 0; i < vm.selectedList.length; i++) {
					if (vm.selectedList[i].is_mix) {
						isMix = true;
						break;
					}
					vm.selectedList[i].amount = 0;
					vm.selectedList[i].as_fed = 0;
					tempList.push(vm.selectedList[i]);
				}
				vm.listOfFeeds = angular.copy(tempList);
				if (isMix) {
					toastr.warning(i18nFilter('_toastr_create_mix_convert_error_message_'), i18nFilter('_toastr_create_mix_convert_error_message_title_'));
				} else {
					openModal(page, size);
				}
			} else {
				openModal('app/pages/feeds/myfeeds/mix_message.html', 'md');
			}
		}

		function sort(column) {
			if (!vm.loadingTable) {
				var col;
				if (column != vm.sortedColumn) {
					vm.sortedColumn = column;
					vm.order = 'DESC';
					col = column + '_' + vm.order;
				} else {
					if (vm.order == 'DESC') {
						vm.order = 'ASC';
						col = column + '_' + vm.order;
					} else if (vm.order == 'ASC') {
						if (vm.selectedFeedType.value == 'master_feeds') {
							vm.order = 'ASC';
						} else {
							vm.order = 'DESC';
						}
						vm.sortedColumn = null;
						col = null;
					}
				}
				vm.sort_col = col;
				vm.currentPage = 1;
				getFeedsByTeam(vm.selectedTeam, vm.currentPage);
			}
		}

		function sortMix(column) {
			var col;
			if (column != vm.sortedColumnMix) {
				vm.sortedColumnMix = column;
				vm.orderMix = 'DESC';
				col = column + '_' + vm.orderMix;
			} else {
				if (vm.orderMix == 'DESC') {
					vm.orderMix = 'ASC';
					col = column + '_' + vm.orderMix;
				} else if (vm.orderMix == 'ASC') {
					if (vm.selectedFeedTypeMix.value == 'master_feeds') {
						vm.orderMix = 'ASC';
					} else {
						vm.orderMix = 'DESC';
					}
					vm.sortedColumnMix = null;
					col = null;
				}
			}
			vm.sort_col_mix = col;
			vm.currentPageMaster = 1;
			vm.modalOpened = true;
			vm.feedsByTeamLength = 0;
			vm.disableScroll = true;
			vm.feedsByTeam = [];
			getFeedsForMix(vm.selectedTeam);
		}

		function feedTypeFilterChanged() {
			vm.currentPage = 1;
			getFeedsByTeam(vm.selectedTeam, vm.currentPage);
			$timeout(function () {
				$(':focus').blur();
			});
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function teamSelected() {
			vm.currentPage = 1;
			vm.searchString = '';
			getFeedsByTeam(vm.selectedTeam, vm.currentPage);
		}

		function saveMIX() {
			var feeds = [];
			vm.modalLoading = true;
			angular.copy(vm.listOfFeeds, feeds);
			for (var i = 0; i < feeds.length; i++) {
				feeds[i].feed_type = feeds[i].feed_type.name;
				feeds[i].team_id = vm.selectedTeam.Id;
				feeds[i].user_id = vm.user.email;
			}
			var suffix;
			if (vm.settings.selectedHerd && vm.settings.selectedHerd.id) {
				suffix = '?feedName=' + encodeURIComponent(vm.mix_name) + '&teamId=' + vm.selectedTeam.Id + '&herdId=' + vm.settings.selectedHerd.id;
			} else {
				suffix = '?feedName=' + encodeURIComponent(vm.mix_name) + '&teamId=' + vm.selectedTeam.Id;
			}
			if (vm.createMixCalculation != null || vm.createMixCalculation != undefined) {
				if (vm.createMixCalculation.calc_type == 2) {
					suffix = suffix + '&localType=' + vm.settings.calculation_type;
				} else {
					suffix = suffix + '&localType=' + vm.createMixCalculation.calc_type;
				}
			}
			return myFeedsFactory
				.addNewMix(feeds, suffix)
				.then(function () {
					if (vm.settings.calculation_type != vm.createMixCalculation.calc_type) {
						changeDefaultCalculation(true);
					}
					toastr.success(i18nFilter('_toastr_create_mix_success_message_'), i18nFilter('_toastr_success_title_'));
					vm.listOfFeeds = [];
					vm.selectedList = [];
					vm.modalLoading = false;
					vm.currentPage = 1;
					if (vm.selectedFeedType.value == 'master_feeds') {
						vm.order = 'ASC';
					} else {
						vm.order = 'DESC';
					}
					$uibModalStack.dismissAll();
					getFeedsByTeam(vm.selectedTeam, vm.currentPage);
				})
				.catch(function (error) {
					vm.modalLoading = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_creating_mix_');
				});
		}

		function deleteFeedProceed() {
			if (vm.selectedList && vm.selectedList.length > 0) {
				vm.modalLoading = true;
				var listOfFeeds = [];
				for (var i = 0; i < vm.selectedList.length; i++) {
					var feed = {};
					angular.copy(vm.selectedList[i], feed);
					feed.feed_type = feed.feed_type.name;
					feed.user_id = vm.user.email;
					listOfFeeds.push(feed);
				}
				for (var j = 0; j < listOfFeeds.length; j++) {
					if (listOfFeeds[j].mixes && listOfFeeds[j].mixes.length > 0) {
						for (var k = 0; k < listOfFeeds[j].mixes.length; k++) {
							listOfFeeds[j].mixes[k].feed_type = listOfFeeds[j].mixes[k].feed_type.name;
						}
					}
				}
				return myFeedsFactory
					.deleteFeeds(listOfFeeds)
					.then(function () {
						vm.selectedList = [];
						$uibModalStack.dismissAll();
						vm.modalLoading = false;
						getFeedsByTeam(vm.selectedTeam, vm.currentPage);
					})
					.catch(function (error) {
						vm.modalLoading = false;
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_deleting_feed_');
					});
			}
		}

		function deleteFeed() {
			vm.warningMessage = '_feeds_delete_warning_message_';
			for (var i = 0; i < vm.selectedList.length; i++) {
				vm.selectedList[i].to_delete = false;
			}
			openModal('app/pages/feeds/myfeeds/confirmationDialog.modal.html', 'md');
		}

		function setFeedTypes(feed_types) {
			vm.feed_types = [];
			for (var i = 0; i < feed_types.length; i++) {
				var temp = '_feeds_type_' + feed_types[i].value + '_';
				feed_types[i].show_name = temp;
				feed_types[i].translated = i18nFilter(temp);
				vm.feed_types.push(feed_types[i]);
			}
			vm.feed_types_filter = [];
			angular.copy(vm.feed_types, vm.feed_types_filter);
			var feed_type = {
				value: null,
				translated: '',
				name: ''
			};
			vm.feed_types_filter.splice(0, 0, feed_type);
		}

		function getTeamsByUser() {
			return myFeedsFactory
				.getTeamsByUser()
				.then(function (response) {
					vm.teams = response;
					vm.loading = false;
					setDefaultTeam(vm.settings, vm.teams);
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_teams_', true);
				});
		}

		function setFeedFilter() {
			vm.filterTypes = [
				{
					name: '_feed_filter_my_feeds_',
					value: 'my_feeds'
				},
				{
					name: '_feed_filter_master_feeds_',
					value: 'master_feeds'
				}
			];
			vm.selectedFeedType = $cookies.get('feed_type') ? JSON.parse($cookies.get('feed_type')) : vm.filterTypes[1];
			vm.selectedFeedTypeMix = vm.filterTypes[1];
			if (vm.selectedFeedType.value == 'master_feeds') {
				vm.order = 'ASC';
			} else {
				vm.order = 'DESC';
			}
			$cookies.put('feed_type', JSON.stringify(vm.selectedFeedType), {
				expires: moment().add(1, 'days').toDate()
			});
		}

		function searchMix() {
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			if (vm.searchMaster.length >= 4) {
				if (searchTimeout) {
					$timeout.cancel(searchTimeout);
				}
				searchTimeout = $timeout(function () {
					vm.feedsByTeam = [];
					vm.modalOpened = true;
					vm.feedsByTeamLength = 0;
					getFeedsForMix(vm.selectedTeam);
				}, 1000);
			}
			if (vm.searchMaster.length == 0) {
				vm.feedsByTeam = [];
				vm.modalOpened = true;
				vm.feedsByTeamLength = 0;
				getFeedsForMix(vm.selectedTeam);
			}
		}

		function defaultCalculationChangedMix() {
			vm.currentPageMaster = 1;
			vm.searchMaster = '';
			vm.modalOpened = true;
			vm.feedsByTeamLength = 0;
			vm.disableScroll = true;
			vm.feedsByTeam = [];
			setFeedTypesFilter(true);
			getFeedsForMix(vm.selectedTeam);
		}

		function feedTypeSelected() {
			vm.sort_col = null;
			vm.sortedColumn = null;
			if (vm.selectedFeedType.value == 'master_feeds') {
				vm.order = 'ASC';
			} else {
				vm.order = 'DESC';
			}
			vm.loadingTable = true;
			vm.currentPage = 1;
			vm.searchString = '';
			vm.feedTypeItem = vm.feedTypeList[0];
			$cookies.put('feed_type', JSON.stringify(vm.selectedFeedType), {
				expires: moment().add(1, 'days').toDate()
			});
			getFeedsByTeam(vm.selectedTeam, vm.currentPage);
		}

		function feedTypeSelectedMix() {
			vm.sort_col_mix = null;
			vm.sortedColumnMix = null;
			if (vm.selectedFeedTypeMix.value == 'master_feeds') {
				vm.orderMix = 'ASC';
			} else {
				vm.orderMix = 'DESC';
			}
			vm.currentPageMaster = 1;
			vm.searchMaster = '';
			vm.modalOpened = true;
			vm.feedsByTeamLength = 0;
			vm.disableScroll = true;
			vm.feedsByTeam = [];
			getFeedsForMix(vm.selectedTeam);
		}

		function feedTypeChangedMix() {
			vm.currentPageMaster = 1;
			vm.modalOpened = true;
			vm.feedsByTeamLength = 0;
			vm.disableScroll = true;
			vm.feedsByTeam = [];
			getFeedsForMix(vm.selectedTeam);
		}

		function paginationMix() {
			vm.currentPageMaster++;
			vm.isPage = true;
			vm.modalOpened = true;
			vm.disableScroll = true;
			getFeedsForMix(vm.selectedTeam);
		}

		function setDefaultCalculation() {
			vm.defaultCalculationList = [
				{
					name: '_calculation_filter_us_feeds_',
					calc_type: 0
				},
				{
					name: '_calculation_filter_vem_dve_feeds_',
					calc_type: 1
				}
			];
			if (vm.settings.calculation_type != null) {
				for (var i = 0; i < vm.defaultCalculationList.length; i++) {
					if (vm.settings.calculation_type == vm.defaultCalculationList[i].calc_type) {
						vm.selectedCalculation = vm.defaultCalculationList[i];
						vm.createMixCalculation = angular.copy(vm.selectedCalculation);
						vm.addFeedCalculation = angular.copy(vm.selectedCalculation);
					}
				}
			} else {
				vm.selectedCalculation = vm.defaultCalculationList[0];
				vm.createMixCalculation = angular.copy(vm.selectedCalculation);
				vm.addFeedCalculation = angular.copy(vm.selectedCalculation);
			}
		}

		function setFeedTypesFilter(mix) {
			if (mix) {
				if (vm.addFeedCalculation.calc_type == 1) {
					vm.feedTypeListMix = APP_CONST.constants.feed_vem_types;
				} else {
					vm.feedTypeListMix = APP_CONST.constants.feed_us_types;
				}
				vm.feedTypeItemMix = vm.feedTypeListMix[0];
			} else {
				if (vm.selectedCalculation.calc_type == 1) {
					vm.feedTypeList = APP_CONST.constants.feed_vem_types;
				} else {
					vm.feedTypeList = APP_CONST.constants.feed_us_types;
				}
				vm.feedTypeItem = vm.feedTypeList[0];
				vm.feedTypeListMix = angular.copy(vm.feedTypeList);
				vm.feedTypeItemMix = angular.copy(vm.feedTypeItem);
			}
		}

		function openFiltersModal() {
			vm.previousValues = {
				feedTypeItem: vm.feedTypeItem
			};
			openModal('app/pages/feeds/myfeeds/filter.modal.html', 'md');
		}

		function saveFilter() {
			vm.checkModal = true;
			vm.currentPage = 1;
			setFeedTypes(APP_CONST.constants.feed_types);
			getFeedsByTeam(vm.selectedTeam, vm.currentPage);
		}

		function defaultCalculationChanged() {
			vm.loadingTable = true;
			vm.createMixCalculation = vm.selectedCalculation;
			vm.addFeedCalculation = vm.selectedCalculation;
			vm.currentPage = 1;
			vm.searchString = '';
			changeDefaultCalculation();
			setFeedTypesFilter();
			setFeedTypes(APP_CONST.constants.feed_types);
			dataCollapseFn();
			collapseTable();
			getFeedsByTeam(vm.selectedTeam, vm.currentPage);
		}

		function changeDefaultCalculation(mix) {
			if (mix) {
				vm.settings.calculation_type = vm.createMixCalculation.calc_type;
			} else {
				vm.settings.calculation_type = vm.selectedCalculation.calc_type;
			}
			return settingsFactory
				.changeSettings(vm.settings, vm.user.email)
				.then(function (response) {
					localStorage.setItem('user_settings', JSON.stringify(response));
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_saving_user_settings_');
				});
		}

		function setDefaultTeam(settings, teams) {
			if (settings.selectedTeam) {
				for (var i = 0; i < teams.length; i++) {
					if (settings.selectedTeam.id == teams[i].Id) {
						vm.selectedTeam = teams[i];
						break;
					}
				}
				if (vm.selectedTeam) {
					vm.currentPage = 1;
					vm.searchString = '';
					getFeedsByTeam(vm.selectedTeam, vm.currentPage, true);
				}
			}
		}

		function getFeedsByTeam(team, page, init) {
			if (vm.checkModal) {
				vm.modalLoading = true;
			} else {
				vm.loadingTable = true;
			}
			var suffix = '?page=' + page;
			if (vm.settings.selectedHerd && vm.settings.selectedHerd.id) {
				suffix = suffix + '&teamId=' + team.Id + '&herdId=' + vm.settings.selectedHerd.id;
			} else {
				suffix = suffix + '&teamId=' + team.Id;
			}
			if (vm.searchString.length > 0) {
				suffix = suffix + '&feed_name=' + encodeURIComponent(vm.searchString);
			}
			if (vm.sortedColumn) {
				suffix = suffix + '&orderBy=' + vm.sortedColumn;
			}
			if (vm.order) {
				suffix = suffix + '&orderType=' + vm.order;
			}
			if (vm.selectedCalculation != null || vm.selectedCalculation != undefined) {
				suffix = suffix + '&localType=' + vm.selectedCalculation.calc_type;
			}
			if (vm.feedTypeItem && vm.feedTypeItem.value) {
				suffix = suffix + '&feedType=' + vm.feedTypeItem.value;
			}
			cancelApiRequest();
			if (vm.selectedFeedType.value == 'my_feeds') {
				return myFeedsFactory
					.getMyFeedsByTeam(suffix)
					.then(function (response) {			
						if (response.length > 0) {
							vm.totalItems = response[0].number_of_all;
						} else {
							vm.totalItems = 0;
						}
						handleResponse(response);
					})
					.catch(function (error) {
						if (error != 'Canceled') {
							console.log(error);
							errorService.showErrorMessage(error, true, '_error_occurred_loading_feeds_', init);
							vm.loadingTable = false;
							vm.modalLoading = false;
							vm.checkModal = false;
						}
					});
			} else {
				return myFeedsFactory
					.getMasterFeeds(suffix)
					.then(function (response) {
						if (response.length > 0) {
							vm.totalItems = response[0].number_of_all;
						} else {
							vm.totalItems = 0;
						}
						handleResponse(response);
					})
					.catch(function (error) {
						if (error != 'Canceled') {
							console.log(error);
							errorService.showErrorMessage(error, true, '_error_occurred_loading_feeds_', init);
							vm.loadingTable = false;
							vm.modalLoading = false;
							vm.checkModal = false;
						}
					});
			}
		}

		function openFeedsModal(page) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				scope: $scope,
				backdrop: 'static',
				keyboard: false,
				windowClass: 'modal-custom-width'
			});
		}

		function getFeedsForMix(team) {
			var feedIndex;
			Object.keys(vm.dataCollapse).forEach(function (key) {
				if (vm.dataCollapse[key] == true) {
					feedIndex = key;
				}
			});
			vm.feedIndex = feedIndex;
			if (!vm.modalOpened) {
				openFeedsModal('app/pages/feeds/myfeeds/insertFeed.modal.html');
				vm.modalOpened = false;
			}
			vm.modalOpened = false;
			var suffix = '';
			if (vm.settings.selectedHerd && vm.settings.selectedHerd.id) {
				suffix = suffix + '?teamId=' + team.Id + '&herdId=' + vm.settings.selectedHerd.id;
			} else {
				suffix = suffix + '?teamId=' + team.Id;
			}
			if (vm.sortedColumnMix) {
				suffix = suffix + '&orderBy=' + vm.sortedColumnMix;
			}
			if (vm.orderMix) {
				suffix = suffix + '&orderType=' + vm.orderMix;
			}
			if (vm.addFeedCalculation != null || vm.addFeedCalculation != undefined) {
				suffix = suffix + '&localType=' + vm.addFeedCalculation.calc_type;
			}
			if (vm.currentPageMaster) {
				suffix = suffix + '&page=' + vm.currentPageMaster;
			}
			if (vm.searchMaster) {
				suffix = suffix + '&feed_name=' + encodeURIComponent(vm.searchMaster);
			}
			if (vm.feedTypeItemMix && vm.feedTypeItemMix.value) {
				suffix = suffix + '&feedType=' + vm.feedTypeItemMix.value;
			}
			if (!vm.isPage) {
				vm.feedsLoaded = false;
			}
			vm.isPage = false;
			cancelApiRequest();
			if (vm.selectedFeedTypeMix.value == 'my_feeds') {
				return myFeedsFactory
					.getMyFeedsByTeam(suffix)
					.then(function (response) {
						if (response.length > 0) {
							vm.totalItemsMaster = response[0].number_of_all;
						} else {
							vm.totalItemsMaster = 0;
						}
						handleResponse(response, 'mix');
						$uibModalStack.dismiss(paginationModal);
					})
					.catch(function (error) {
						if (error != 'Canceled') {
							console.log(error);
							$uibModalStack.dismiss(paginationModal);
							vm.modalLoading = false;
							vm.feedsLoaded = true;
							vm.disableScroll = false;
							errorService.showErrorMessage(error, true, '_error_occurred_loading_feeds_');
						}
					});
			} else {
				return myFeedsFactory
					.getMasterFeeds(suffix)
					.then(function (response) {
						if (response.length > 0) {
							vm.totalItemsMaster = response[0].number_of_all;
						} else {
							vm.totalItemsMaster = 0;
						}
						handleResponse(response, 'mix');
						$uibModalStack.dismiss(paginationModal);
					})
					.catch(function (error) {
						if (error != 'Canceled') {
							console.log(error);
							$uibModalStack.dismiss(paginationModal);
							vm.modalLoading = false;
							vm.feedsLoaded = true;
							vm.disableScroll = false;
							errorService.showErrorMessage(error, true, '_error_occurred_loading_feeds_');
						}
					});
			}
		}

		function handleResponse(response, type, feedIndex) {
			var temp = angular.copy(response);
			for (var i = 0; i < temp.length; i++) {
				fixVemValues(temp[i]);
				temp[i].feed_type = checkFeedType(temp[i].feed_type);
				if (temp[i].mixes) {
					var amount = 0;
					for (var j = 0; j < temp[i].mixes.length; j++) {
						fixVemValues(temp[i].mixes[j]);
						temp[i].mixes[j].as_fed = temp[i].mixes[j].amount / (temp[i].mixes[j].dm / 100);
						amount = amount + temp[i].mixes[j].amount;
						temp[i].mixes[j].feed_type = checkFeedType(temp[i].mixes[j].feed_type);
					}
					temp[i].amount = amount;
					temp[i].as_fed = temp[i].amount / (temp[i].dm / 100);
				}

				if (!type) {
					for (var k = 0; k < vm.selectedList.length; k++) {
						if (temp[i].id === vm.selectedList[k].id) {
							temp[i].is_selected = true;
							break;
						}
					}
				}
			}

			if (!type) {
				vm.feeds = temp;
				vm.feedsSafe = vm.feeds;
			} else if (type === 'mix') {
				if (temp.length > 0) {
					for (var l = 0; l < temp.length; l++) {
						temp[l].test_date = new Date(temp[l].test_date);
					}
					vm.feedsByTeam = vm.feedsByTeam.concat(temp);
					var orderBool = vm.orderMix === 'ASC' ? false : true;
					vm.feedsByTeam = $filter('orderBy')(vm.feedsByTeam, vm.sortedColumnMix, orderBool);
				}
				vm.mix = vm.feeds[vm.feedIndex];
			} else {
				vm.feeds[feedIndex] = temp[0];
				vm.feedsSafe = vm.feeds;
			}

			vm.loadingTable = false;
			if (vm.checkModal) {
				$uibModalStack.dismissAll();
			}
			vm.checkModal = false;
			vm.modalLoading = false;
			vm.feedsLoaded = true;
			vm.disableScroll = false;
			$timeout(function () {
				vm.showTable = true;
			}, 0);

			function checkFeedType(prop) {
				try {
					for (var i = 0; i < vm.feed_types.length; i++) {
						if (prop && prop.toLowerCase() === vm.feed_types[i].name.toLowerCase()) {
							return vm.feed_types[i];
						}
					}
					return {
						show_name: '_feeds_type_not_set_'
					};
				} catch (error) {
					return {
						show_name: '_feeds_type_not_set_'
					};
				}
			}

			function fixVemValues(item) {
				item.vem = item.vem || 0;
				item.dve = item.dve || 0;
				item.oeb = item.oeb || 0;
				item.fos = item.fos || 0;
				item.rc = item.rc || 0;
				item.rus = item.rus || 0;
			}
		}

		function editFeed(feed) {
			if (feed.is_mix) {
				vm.feedToEdit = findFeed(feed).feed;
				vm.feedToEdit.feed_index = findFeed(feed).index;
				openModal('app/pages/feeds/myfeeds/mix_edit.modal.html', 'lg');
			} else {
				if (feed.feed_locale != null || feed.feed_locale != undefined) {
					localStorage.setItem('feed_calculation_type', feed.feed_locale);
				}
				$state.go('feeds.editFeed', {
					uuid: feed.id
				});
			}
		}

		function redirectTo(state) {
			$state.go(state);
		}

		function dataCollapseFn() {
			vm.dataCollapse = [];
			for (var i = 0; i < vm.feeds.length; i++) {
				vm.dataCollapse.push(false);
			}
		}

		function collapseTable() {
			vm.tableRowExpanded = false;
			vm.tableRowIndexExpandedCurr = '';
			vm.idExpanded = '';
		}

		function selectTableRow(index, id) {
			vm.selectedList = [];
			for (var i = 0; i < vm.feeds.length; i++) {
				vm.feeds[i].is_selected = false;
			}
			if (typeof vm.dayDataCollapse === 'undefined') {
				vm.dataCollapseFn();
			}
			if (vm.tableRowExpanded === false && vm.tableRowIndexExpandedCurr === '' && vm.idExpanded === '') {
				vm.tableRowIndexExpandedPrev = '';
				vm.tableRowExpanded = true;
				vm.tableRowIndexExpandedCurr = index;
				vm.idExpanded = id;
				vm.dataCollapse[index] = true;
			} else if (vm.tableRowExpanded === true) {
				if (vm.tableRowIndexExpandedCurr === index && vm.idExpanded === id) {
					vm.tableRowExpanded = false;
					vm.tableRowIndexExpandedCurr = '';
					vm.idExpanded = '';
					vm.dataCollapse[index] = false;
				} else {
					vm.tableRowIndexExpandedPrev = vm.tableRowIndexExpandedCurr;
					vm.tableRowIndexExpandedCurr = index;
					vm.idExpanded = id;
					vm.dataCollapse[vm.tableRowIndexExpandedPrev] = false;
					vm.dataCollapse[vm.tableRowIndexExpandedCurr] = true;
				}
			}
		}

		function cancel() {
			for (var i = 0; i < vm.listOfFeeds.length; i++) {
				vm.listOfFeeds[i].amount = 0;
			}
			$uibModalStack.dismissAll();
		}

		function proceed(msg) {
			if (msg == '_feeds_delete_warning_message_') {
				deleteFeedProceed();
			} else if (msg == '_feeds_unmix_warning_message_') {
				unmixProceed(vm.convert_unmix);
			} else if (msg == '_feeds_remove_from_mix_warning_message_') {
				removeFeedFromMixProceed(vm.convert_unmix);
			} else {
				convertToFeedProceed(vm.convert_unmix);
			}
		}

		function unmix(feed) {
			vm.convert_unmix = findFeed(feed).feed;
			vm.warningMessage = '_feeds_unmix_warning_message_';
			openModal('app/pages/feeds/myfeeds/confirmationDialog.modal.html', 'md');
		}

		function convertToFeed(feed) {
			vm.convert_unmix = findFeed(feed).feed;
			vm.warningMessage = '_feeds_convert_warning_message_';
			openModal('app/pages/feeds/myfeeds/confirmationDialog.modal.html', 'md');
		}

		function convertToFeedProceed(feed) {
			vm.modalLoading = true;
			var feedDTO = {
				user_id: vm.user.email
			};
			var suffix;
			if (vm.settings.selectedHerd && vm.settings.selectedHerd.id) {
				suffix = '?teamId=' + vm.settings.selectedTeam.id + '&herdId=' + vm.settings.selectedHerd.id;
			} else {
				suffix = '?teamId=' + vm.settings.selectedTeam.id;
			}
			myFeedsFactory
				.convertToFeed(feed.id, feedDTO, suffix)
				.then(function () {
					vm.selectedList = [];
					$uibModalStack.dismissAll();
					vm.modalLoading = false;
					getFeedsByTeam(vm.selectedTeam, vm.currentPage);
				})
				.catch(function (error) {
					console.log(error);
					vm.modalLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_converting_mix_');
				});
		}

		function unmixProceed(feedDTO) {
			vm.modalLoading = true;
			feedDTO.feed_type = feedDTO.feed_type.name ? feedDTO.feed_type.name : feedDTO.feed_type ? feedDTO.feed_type : i18nFilter('_feeds_type_miscellaneous_');
			feedDTO.user_id = vm.user.email;
			for (var i = 0; i < feedDTO.mixes.length; i++) {
				feedDTO.mixes[i].feed_type = feedDTO.mixes[i].feed_type.name ? feedDTO.mixes[i].feed_type.name : feedDTO.mixes[i].feed_type ? feedDTO.mixes[i].feed_type : i18nFilter('_feeds_type_miscellaneous_');
			}
			var suffix;
			if (vm.settings.selectedHerd && vm.settings.selectedHerd.id) {
				suffix = '?teamId=' + vm.settings.selectedTeam.id + '&herdId=' + vm.settings.selectedHerd.id;
			} else {
				suffix = '?teamId=' + vm.settings.selectedTeam.id;
			}
			myFeedsFactory
				.unmix(feedDTO, suffix)
				.then(function () {
					vm.selectedList = [];
					$uibModalStack.dismissAll();
					vm.modalLoading = false;
					getFeedsByTeam(vm.selectedTeam, vm.currentPage);
				})
				.catch(function (error) {
					console.log(error);
					vm.modalLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_unmix_');
				});
		}

		function feedKeyDown(event, data) {
			if (data != undefined) {
				if (event.keyCode == 13) {
					vm.onEnterEvent = true;
				} else if (event.keyCode == 27) {
					vm.onEnterEvent = true;
				}
			}
		}

		function updateFeed(feed, ind, data, type, page) {
			if (data == undefined && type != 'is_purchased' && type != 'common_feed') {
				return i18nFilter('_value_not_valid_');
			}
			if (data != feed[type]) {
				var feedTemp = findFeed(feed).feed;
				var index = findFeed(feed).index;
				vm.feeds[index].loading = true;
				if (type == 'feed_name') {
					feedTemp.feed_name = data;
				} else if (type == 'dm') {
					feedTemp.dm = data;
				} else if (type == 'vem') {
					feedTemp.vem = data;
				} else if (type == 'rus') {
					feedTemp.event = 'rus';
					feedTemp.rus = data;
				} else if (type == 'fos') {
					feedTemp.fos = data;
				} else if (type == 'dve') {
					feedTemp.dve = data;
				} else if (type == 'oeb') {
					feedTemp.oeb = data;
				} else if (type == 'ef_ndf_as_ndf') {
					feedTemp.ef_ndf_as_ndf = data;
				} else if (type == 'rc') {
					feedTemp.rc = data;
				} else if (type == 'ndf') {
					feedTemp.ndf = data;
				} else if (type == 'cp') {
					feedTemp.cp = data;
				} else if (type == 'rup_dig') {
					feedTemp.rup_dig = data;
				} else if (type == 'ca') {
					feedTemp.ca = data;
				} else if (type == 'p') {
					feedTemp.p = data;
				} else if (type == 'na') {
					feedTemp.na = data;
				} else if (type == 'se') {
					feedTemp.se = data;
				} else if (type == 'vitamin_e') {
					feedTemp.vitamin_e = data;
				} else if (type == 'test_date') {
					if (data) {
						data.setHours(12);
						feedTemp.test_date = data;
					}
				} else if (type == 'lignin') {
					feedTemp.lignin = data;
				} else if (type == 'ndf_digest') {
					feedTemp.ndf_digest = data;
				} else if (type == 'adf') {
					feedTemp.adf = data;
				} else if (type == 'rd_ndf') {
					feedTemp.rd_ndf = data;
				} else if (type == 'disc_fac') {
					feedTemp.disc_fac = data;
				} else if (type == 'nel_89') {
					feedTemp.nel_89 = data;
				} else if (type == 'me_89') {
					feedTemp.me_89 = data;
				} else if (type == 'b_prot') {
					feedTemp.b_prot = data;
				} else if (type == 'c_prot') {
					feedTemp.c_prot = data;
				} else if (type == 'kd_b_prot') {
					feedTemp.kd_b_prot = data;
				} else if (type == 'npncpe') {
					feedTemp.npncpe = data;
				} else if (type == 'rup_89') {
					feedTemp.rup_89 = data;
				} else if (type == 'ndicp') {
					feedTemp.ndicp = data;
				} else if (type == 'adicp') {
					feedTemp.adicp = data;
				} else if (type == 'nfc_dig') {
					feedTemp.nfc_dig = data;
				} else if (type == 'starch') {
					feedTemp.event = 'starch';
					feedTemp.starch = data;
				} else if (type == 'rd_starch') {
					feedTemp.event = 'rd_starch';
					feedTemp.rd_starch = data;
				} else if (type == 'sugar') {
					feedTemp.sugar = data;
				} else if (type == 'in_fa') {
					feedTemp.in_fa = data;
				} else if (type == 'rd_sol_fiber') {
					feedTemp.rd_sol_fiber = data;
				} else if (type == 'ee') {
					feedTemp.ee = data;
				} else if (type == 'sfa') {
					feedTemp.sfa = data;
					if (feedTemp.sfa + feedTemp.pufa > 100) {
						feedTemp.pufa = 100 - feedTemp.sfa;
					}
				} else if (type == 'pufa') {
					feedTemp.pufa = data;
					if (feedTemp.pufa + feedTemp.sfa > 0) {
						feedTemp.sfa = 100 - feedTemp.pufa;
					}
				} else if (type == 'bhfa') {
					feedTemp.bhfa = data;
				} else if (type == 'fa_dig') {
					feedTemp.fa_dig = data;
				} else if (type == 'ca_abs') {
					feedTemp.ca_abs = data;
				} else if (type == 'p_abs') {
					feedTemp.p_abs = data;
				} else if (type == 'mg') {
					feedTemp.mg = data;
				} else if (type == 'mg_abs') {
					feedTemp.mg_abs = data;
				} else if (type == 'k') {
					feedTemp.k = data;
				} else if (type == 'cl') {
					feedTemp.cl = data;
				} else if (type == 's') {
					feedTemp.s = data;
				} else if (type == 'ash') {
					feedTemp.ash = data;
				} else if (type == 'co') {
					feedTemp.co = data;
				} else if (type == 'cu') {
					feedTemp.cu = data;
				} else if (type == 'cu_abs') {
					feedTemp.cu_abs = data;
				} else if (type == 'fe') {
					feedTemp.fe = data;
				} else if (type == 'fe_abs') {
					feedTemp.fe_abs = data;
				} else if (type == 'i') {
					feedTemp.i = data;
				} else if (type == 'i_abs') {
					feedTemp.i_abs = data;
				} else if (type == 'mo') {
					feedTemp.mo = data;
				} else if (type == 'mn') {
					feedTemp.mn = data;
				} else if (type == 'mn_abs') {
					feedTemp.mn_abs = data;
				} else if (type == 'se_abs') {
					feedTemp.se_abs = data;
				} else if (type == 'zn') {
					feedTemp.zn = data;
				} else if (type == 'zn_abs') {
					feedTemp.zn_abs = data;
				} else if (type == 'vitamin_a') {
					feedTemp.vitamin_a = data;
				} else if (type == 'vitamin_d') {
					feedTemp.vitamin_d = data;
				} else if (type == 'lysine') {
					feedTemp.lysine = data;
				} else if (type == 'methionine') {
					feedTemp.methionine = data;
				} else if (type == 'teaa') {
					feedTemp.teaa = data;
				} else if (type == 'cost_as_sold') {
					feedTemp.cost_as_sold = data;
				} else if (type == 'wt_as_sold') {
					feedTemp.wt_as_sold = data;
				} else if (type == 'blank_1') {
					feedTemp.blank_1 = data;
				} else if (type == 'blank_2') {
					feedTemp.blank_2 = data;
				} else if (type == 'blank_3') {
					feedTemp.blank_3 = data;
				} else if (type == 'blank_4') {
					feedTemp.blank_4 = data;
				} else if (type == 'blank_5') {
					feedTemp.blank_5 = data;
				} else if (type == 'comments') {
					feedTemp.comments = data;
				} else if (type == 'common_feed') {
					feedTemp.common_feed = !feedTemp.common_feed;
				} else if (type == 'is_purchased') {
					feedTemp.is_purchased = !feedTemp.is_purchased;
				}
				if (type == 'feed_type') {
					feedTemp.feed_type = data.name;
					feedTemp.feed_category = data.category;
				} else {
					feedTemp.feed_type = feedTemp.feed_type.name;
				}
				if (feedTemp.mixes) {
					for (var j = 0; j < feedTemp.mixes.length; j++) {
						feedTemp.mixes[j].feed_type = feedTemp.mixes[j].feed_type.name;
					}
				}
				feedTemp.user_id = vm.user.email;
				if (vm.onEnterEvent) {
					$timeout(function () {
						try {
							var tempIndex = index + 1;
							var tempPage = '';
							if (page) {
								tempPage = page;
							}
							if (tempIndex < vm.feeds.length) {
								var elem = document.getElementById(type + tempIndex + tempPage);
								elem.click();
								if (tempIndex > 6) {
									var parent = elem.parentElement;
									parent.scrollIntoView(true);
								}
							}
							vm.onEnterEvent = false;
						} catch (error) {
							console.log(error);
						}
					}, 100);
				}
				if (vm.selectedCalculation != null || vm.selectedCalculation != undefined) {
					var suffix = '?localType=' + vm.selectedCalculation.calc_type;
				}
				myFeedsFactory
					.editFeed(feedTemp, suffix)
					.then(function (response) {
						handleResponse([response], 'update', index);
					})
					.catch(function (error) {
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_updating_feed_');
						vm.feeds[index].loading = false;
					});
			} else {
				if (vm.onEnterEvent) {
					$timeout(function () {
						try {
							var tempIndex = index + 1;
							var tempPage = '';
							if (page) {
								tempPage = page;
							}
							if (tempIndex < vm.feeds.length) {
								var elem = document.getElementById(type + tempIndex + tempPage);
								elem.click();
								if (tempIndex > 6) {
									var parent = elem.parentElement;
									parent.scrollIntoView(true);
								}
							}
							vm.onEnterEvent = false;
						} catch (error) {
							console.log(error);
						}
					}, 100);
				}
			}
		}

		function mixKeyDown(event, data) {
			if (data != undefined) {
				if (event.keyCode == 13) {
					vm.onEnterMixEvent = true;
				} else if (event.keyCode == 27) {
					vm.onEnterMixEvent = true;
				}
			}
		}

		function removeSelected(id) {
			for (var i = vm.importList.length - 1; i >= 0; i--) {
				if (vm.importList[i].id == id) {
					vm.feedsByTeam.unshift(vm.importList.splice(i, 1)[0]);
				}
			}
			var orderBool;
			if (vm.orderMix == 'ASC') {
				orderBool = false;
			} else {
				orderBool = true;
			}
			vm.feedsByTeam = $filter('orderBy')(vm.feedsByTeam, vm.sortedColumnMix, orderBool);
			vm.importListSafe = vm.importList;
		}

		function addSelected(feed) {
			if (!feed.is_mix) {
				var feedFound = false;
				var selList = [];
				for (var i = 0; i < vm.feedsByTeam.length; i++) {
					if (vm.feedsByTeam[i].id == feed.id) {
						if (vm.importList.length > 0) {
							for (var j = 0; j < vm.importList.length; j++) {
								if (vm.feedsByTeam[i].id == vm.importList[j].id) {
									feedFound = true;
									break;
								}
							}
						}
						if (!feedFound) {
							selList.push(vm.feedsByTeam[i]);
							vm.feedsByTeam.splice(i, 1);
						}
						feedFound = false;
					}
				}
				var li = [];
				angular.copy(selList, li);
				for (var k = 0; k < li.length; k++) {
					vm.importList.push(li[k]);
				}
				if (vm.feedsByTeam.length == 0) {
					vm.currentPageMaster++;
					vm.disableScroll = true;
					vm.modalOpened = true;
					getFeedsForMix(vm.selectedTeam);
				}
				vm.importListSafe = vm.importList;
			}
		}

		function updateMixEdit() {
			var list = [];
			angular.copy(vm.feedToEdit.mixes, list);
			for (var i = 0; i < list.length; i++) {
				list[i].user_id = vm.user.email;
				list[i].feed_type = list[i].feed_type.name;
				if (!list[i].dirty) {
					list[i].dirty = false;
				}
			}
			vm.modalLoading = true;
			if (vm.selectedCalculation != null || vm.selectedCalculation != undefined) {
				var suffix = '&localType=' + vm.selectedCalculation.calc_type;
			}
			myFeedsFactory
				.editMix(vm.feedToEdit.id, list, vm.feedToEdit.feed_name, suffix)
				.then(function () {
					vm.selectedList = [];
					$uibModalStack.dismissAll();
					vm.modalLoading = false;
					getFeedsByTeam(vm.selectedTeam, vm.currentPage);
				})
				.catch(function (error) {
					vm.modalLoading = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_updating_mix_');
				});
		}

		function updateMix(feed, index, data, type, page) {
			if (data == undefined && type != 'is_purchased' && type != 'common_feed') {
				return i18nFilter('_value_not_valid_');
			}
			var feedIndex;
			Object.keys(vm.dataCollapse).forEach(function (key) {
				if (vm.dataCollapse[key] == true) {
					feedIndex = key;
				}
			});
			var mainFeed = vm.feeds[feedIndex];
			if (data != feed[type]) {
				vm.feeds[feedIndex].mixes[index].loading = true;
				vm.ingredientsLoading = true;
				var feedTemp = findMix(feed, feedIndex).feed;
				if (type == 'feed_name') {
					feedTemp.feed_name = data;
				} else if (type == 'amount') {
					feedTemp.amount = data;
				} else if (type == 'as_fed') {
					feedTemp.amount = data * (feedTemp.dm / 100);
				} else if (type == 'dm') {
					feedTemp.dm = data;
				} else if (type == 'vem') {
					feedTemp.vem = data;
				} else if (type == 'rus') {
					feedTemp.event = 'rus';
					feedTemp.rus = data;
				} else if (type == 'fos') {
					feedTemp.fos = data;
				} else if (type == 'dve') {
					feedTemp.dve = data;
				} else if (type == 'oeb') {
					feedTemp.oeb = data;
				} else if (type == 'ef_ndf_as_ndf') {
					feedTemp.ef_ndf_as_ndf = data;
				} else if (type == 'rc') {
					feedTemp.rc = data;
				} else if (type == 'ndf') {
					feedTemp.ndf = data;
				} else if (type == 'cp') {
					feedTemp.cp = data;
				} else if (type == 'rup_dig') {
					feedTemp.rup_dig = data;
				} else if (type == 'ca') {
					feedTemp.ca = data;
				} else if (type == 'p') {
					feedTemp.p = data;
				} else if (type == 'na') {
					feedTemp.na = data;
				} else if (type == 'se') {
					feedTemp.se = data;
				} else if (type == 'vitamin_e') {
					feedTemp.vitamin_e = data;
				} else if (type == 'test_date') {
					if (data) {
						data.setHours(12);
						feedTemp.test_date = data;
					}
				} else if (type == 'lignin') {
					feedTemp.lignin = data;
				} else if (type == 'ndf_digest') {
					feedTemp.ndf_digest = data;
				} else if (type == 'adf') {
					feedTemp.adf = data;
				} else if (type == 'rd_ndf') {
					feedTemp.rd_ndf = data;
				} else if (type == 'disc_fac') {
					feedTemp.disc_fac = data;
				} else if (type == 'nel_89') {
					feedTemp.nel_89 = data;
				} else if (type == 'me_89') {
					feedTemp.me_89 = data;
				} else if (type == 'b_prot') {
					feedTemp.b_prot = data;
				} else if (type == 'c_prot') {
					feedTemp.c_prot = data;
				} else if (type == 'kd_b_prot') {
					feedTemp.kd_b_prot = data;
				} else if (type == 'npncpe') {
					feedTemp.npncpe = data;
				} else if (type == 'rup_89') {
					feedTemp.rup_89 = data;
				} else if (type == 'ndicp') {
					feedTemp.ndicp = data;
				} else if (type == 'adicp') {
					feedTemp.adicp = data;
				} else if (type == 'nfc_dig') {
					feedTemp.nfc_dig = data;
				} else if (type == 'starch') {
					feedTemp.event = 'starch';
					feedTemp.starch = data;
				} else if (type == 'rd_starch') {
					feedTemp.event = 'rd_starch';
					feedTemp.rd_starch = data;
				} else if (type == 'sugar') {
					feedTemp.sugar = data;
				} else if (type == 'in_fa') {
					feedTemp.in_fa = data;
				} else if (type == 'rd_sol_fiber') {
					feedTemp.rd_sol_fiber = data;
				} else if (type == 'ee') {
					feedTemp.ee = data;
				} else if (type == 'sfa') {
					feedTemp.sfa = data;
					if (feedTemp.sfa + feedTemp.pufa > 100) {
						feedTemp.pufa = 100 - feedTemp.sfa;
					}
				} else if (type == 'pufa') {
					feedTemp.pufa = data;
					if (feedTemp.pufa + feedTemp.sfa > 0) {
						feedTemp.sfa = 100 - feedTemp.pufa;
					}
				} else if (type == 'bhfa') {
					feedTemp.bhfa = data;
				} else if (type == 'fa_dig') {
					feedTemp.fa_dig = data;
				} else if (type == 'ca_abs') {
					feedTemp.ca_abs = data;
				} else if (type == 'p_abs') {
					feedTemp.p_abs = data;
				} else if (type == 'mg') {
					feedTemp.mg = data;
				} else if (type == 'mg_abs') {
					feedTemp.mg_abs = data;
				} else if (type == 'k') {
					feedTemp.k = data;
				} else if (type == 'cl') {
					feedTemp.cl = data;
				} else if (type == 's') {
					feedTemp.s = data;
				} else if (type == 'ash') {
					feedTemp.ash = data;
				} else if (type == 'co') {
					feedTemp.co = data;
				} else if (type == 'cu') {
					feedTemp.cu = data;
				} else if (type == 'cu_abs') {
					feedTemp.cu_abs = data;
				} else if (type == 'fe') {
					feedTemp.fe = data;
				} else if (type == 'fe_abs') {
					feedTemp.fe_abs = data;
				} else if (type == 'i') {
					feedTemp.i = data;
				} else if (type == 'i_abs') {
					feedTemp.i_abs = data;
				} else if (type == 'mo') {
					feedTemp.mo = data;
				} else if (type == 'mn') {
					feedTemp.mn = data;
				} else if (type == 'mn_abs') {
					feedTemp.mn_abs = data;
				} else if (type == 'se_abs') {
					feedTemp.se_abs = data;
				} else if (type == 'zn') {
					feedTemp.zn = data;
				} else if (type == 'zn_abs') {
					feedTemp.zn_abs = data;
				} else if (type == 'vitamin_a') {
					feedTemp.vitamin_a = data;
				} else if (type == 'vitamin_d') {
					feedTemp.vitamin_d = data;
				} else if (type == 'lysine') {
					feedTemp.lysine = data;
				} else if (type == 'methionine') {
					feedTemp.methionine = data;
				} else if (type == 'teaa') {
					feedTemp.teaa = data;
				} else if (type == 'cost_as_sold') {
					feedTemp.cost_as_sold = data;
				} else if (type == 'wt_as_sold') {
					feedTemp.wt_as_sold = data;
				} else if (type == 'blank_1') {
					feedTemp.blank_1 = data;
				} else if (type == 'blank_2') {
					feedTemp.blank_2 = data;
				} else if (type == 'blank_3') {
					feedTemp.blank_3 = data;
				} else if (type == 'blank_4') {
					feedTemp.blank_4 = data;
				} else if (type == 'blank_5') {
					feedTemp.blank_5 = data;
				} else if (type == 'comments') {
					feedTemp.comments = data;
				} else if (type == 'common_feed') {
					feedTemp.common_feed = !feedTemp.common_feed;
				} else if (type == 'is_purchased') {
					feedTemp.is_purchased = !feedTemp.is_purchased;
				}
				if (type == 'feed_type') {
					feedTemp.feed_type = data.name;
					feedTemp.feed_category = data.category;
				} else {
					feedTemp.feed_type = feedTemp.feed_type.name;
				}
				feedTemp.dirty = true;
				feedTemp.user_id = vm.user.email;
				var list = [];
				list.push(feedTemp);
				if (vm.selectedCalculation != null || vm.selectedCalculation != undefined) {
					var suffix = '&localType=' + vm.selectedCalculation.calc_type;
				}
				myFeedsFactory
					.editMix(mainFeed.id, list, mainFeed.feed_name, suffix)
					.then(function (response) {
						handleResponse([response], 'updateMix', feedIndex);
						vm.ingredientsLoading = false;
						if (vm.onEnterMixEvent) {
							$timeout(function () {
								try {
									var tempIndex = index + 1;
									var tempPage = '';
									if (page) {
										tempPage = page;
									}
									if (tempIndex < mainFeed.mixes.length) {
										var elem = document.getElementById(type + 'MIX' + tempIndex + tempPage + feedIndex);
										elem.click();
										if (tempIndex > 2) {
											var parent = elem.parentElement;
											parent.scrollIntoView(true);
										}
									}
									vm.onEnterMixEvent = false;
								} catch (error) {
									console.log(error);
								}
							}, 100);
						}
					})
					.catch(function (error) {
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_updating_mix_');
						vm.feeds[feedIndex].mixes[index].loading = false;
						vm.ingredientsLoading = false;
					});
			} else {
				if (vm.onEnterMixEvent) {
					$timeout(function () {
						try {
							var tempIndex = index + 1;
							var tempPage = '';
							if (page) {
								tempPage = page;
							}
							if (tempIndex < mainFeed.mixes.length) {
								var elem = document.getElementById(type + 'MIX' + tempIndex + tempPage + feedIndex);
								elem.click();
								if (tempIndex > 2) {
									var parent = elem.parentElement;
									parent.scrollIntoView(true);
								}
							}
							vm.onEnterMixEvent = false;
						} catch (error) {
							console.log(error);
						}
					}, 100);
				}
			}
		}

		function goToHistory(id, locale) {
			if (locale != null && locale != undefined) {
				localStorage.setItem('feed_calculation_type', locale);
			}
			$state.go('feeds.feedHistory', {
				uuid: id
			});
		}

		function search() {
			vm.currentPage = 1;
			if (vm.searchString.length >= 3) {
				if (searchTimeout) {
					$timeout.cancel(searchTimeout);
				}
				searchTimeout = $timeout(function () {
					getFeedsByTeam(vm.selectedTeam, vm.currentPage);
				}, 1000);
			}
			if (vm.searchString.length == 0) {
				getFeedsByTeam(vm.selectedTeam, vm.currentPage);
			}
		}

		function cancelApiRequest() {
			angular.forEach($http.pendingRequests, function (req) {
				if ((req.url.split('?')[0] == APP_CONST.api_base_url + 'myFeeds' && req.method == 'GET') || (req.url.split('?')[0] == APP_CONST.api_base_url + 'feeds/master' && req.method == 'GET')) {
					myFeedsFactory.cancelRequest();
				}
			});
		}

		$scope.$on('default_team_selected', function (event, data) {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedTeam = data;
			vm.currentPage = 1;
			vm.searchString = '';
			vm.selectedList = [];
			getFeedsByTeam(data, vm.currentPage);
		});

		$scope.$on('default_herd_selected', function () {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.currentPage = 1;
			vm.searchString = '';
			vm.selectedList = [];
			getFeedsByTeam(vm.selectedTeam, vm.currentPage);
		});

		$scope.$on('default_team_herd_changed', function () {
			cancelApiRequest();
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.currentPage = 1;
			vm.searchString = '';
			vm.selectedList = [];
			getFeedsByTeam(vm.selectedTeam, vm.currentPage);
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		editableOptions.theme = 'bs3';
		editableOptions.blurElem = 'submit';
		editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
		editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.myfeeds').factory('myFeedsFactory', myFeedsFactory);
	/** @ngInject */
	function myFeedsFactory($http, APP_CONST, $q) {
		var cancelReq;
		var statusText;

		return {
			getMyFeedsByTeam: getMyFeedsByTeam,
			getTeamsByUser: getTeamsByUser,
			addNewMix: addNewMix,
			convertToFeed: convertToFeed,
			unmix: unmix,
			editFeed: editFeed,
			deleteFeeds: deleteFeeds,
			editMix: editMix,
			insertFeedToMix: insertFeedToMix,
			removeFeedFromMix: removeFeedFromMix,
			getMasterFeeds: getMasterFeeds,
			cancelRequest: cancelRequest
		};

		function cancelRequest() {
			statusText = 'Canceled';
			cancelReq.resolve();
		}

		function getMyFeedsByTeam(suffix) {
			cancelReq = $q.defer();
			var teamId = getTeamIdFromSuffix(suffix);
			var requestConfig = {
				timeout: cancelReq.promise
			};

			return $q
				.all({
					feeds: $http.get(APP_CONST.api_base_url + 'myFeeds' + suffix, requestConfig),
					herds: getHerdsByTeam(teamId, requestConfig)
				})
				.then(function (response) {
					return mapHerdNamesToFeeds(success(response.feeds), success(response.herds));
				})
				.catch(function (error) {
					var err = statusText ? $q.reject(statusText) : $q.reject(error);
					statusText = undefined;
					return err;
				});
		}

		function getMasterFeeds(suffix) {
			cancelReq = $q.defer();
			return $http
				.get(APP_CONST.api_base_url + 'feeds/master' + suffix, {
					timeout: cancelReq.promise
				})
				.then(success)
				.catch(function (error) {
					var err = statusText ? $q.reject(statusText) : $q.reject(error);
					statusText = undefined;
					return err;
				});
		}

		function getTeamsByUser() {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams')
				.then(success)
				.catch(error);
		}

		function getHerdsByTeam(teamId, requestConfig) {
			if (!teamId) {
				return $q.when({
					data: []
				});
			}

			return $http
				.get(APP_CONST.backoffice_base_url + 'teams/' + teamId + '/herds', requestConfig);
		}

		function addNewMix(feeds, suffix) {
			return $http
				.post(APP_CONST.api_base_url + 'feed/mixes' + suffix, feeds)
				.then(success)
				.catch(error);
		}

		function convertToFeed(feedId, feedDTO, suffix) {
			return $http
				.post(APP_CONST.api_base_url + 'feed/mixToFeed/' + feedId + suffix, feedDTO)
				.then(success)
				.catch(error);
		}

		function unmix(feed, suffix) {
			return $http
				.post(APP_CONST.api_base_url + 'feed/unmix' + suffix, feed)
				.then(success)
				.catch(error);
		}

		function editFeed(feedDTO, suffix) {
			return $http
				.put(APP_CONST.api_base_url + 'feeds' + suffix, feedDTO)
				.then(success)
				.catch(error);
		}

		function deleteFeeds(feeds) {
			return $http
				.post(APP_CONST.api_base_url + 'feed/remove', feeds)
				.then(success)
				.catch(error);
		}

		function editMix(feedId, feeds, feedName, suffix) {
			return $http
				.put(APP_CONST.api_base_url + 'feed/mixes/' + feedId + '?feedName=' + feedName + suffix, feeds)
				.then(success)
				.catch(error);
		}

		function insertFeedToMix(feedId, feeds) {
			return $http
				.post(APP_CONST.api_base_url + 'feeds/' + feedId + '/mix/ingredients', feeds)
				.then(success)
				.catch(error);
		}

		function removeFeedFromMix(feedId, feeds) {
			return $http
				.put(APP_CONST.api_base_url + 'remove/mix/ingredients/feed/' + feedId, feeds)
				.then(success)
				.catch(error);
		}

		function getTeamIdFromSuffix(suffix) {
			var match = /(?:\?|&)teamId=([^&]+)/.exec(suffix || '');

			return match && match[1] ? decodeURIComponent(match[1]) : null;
		}

		function mapHerdNamesToFeeds(feeds, herds) {
			var herdNamesById = {};

			angular.forEach(herds || [], function (herd) {
				herdNamesById[herd.Id] = herd.Name;
			});

			angular.forEach(feeds || [], function (feed) {
				mapHerdName(feed, herdNamesById);
				angular.forEach(feed.mixes || [], function (mix) {
					mapHerdName(mix, herdNamesById);
				});
			});

			return feeds;
		}

		function mapHerdName(item, herdNamesById) {
			if (item && item.herd_id != null && herdNamesById[item.herd_id]) {
				item.herd_name = herdNamesById[item.herd_id];
			}
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.mymanualfeeds').controller('myManualFeedsCtrl', myManualFeeds);
	/** @ngInject */
	function myManualFeeds($locale, myManualFeedsService, $q, $uibModal, $uibModalStack, errorService, $scope, editableOptions, editableThemes, APP_CONST, $filter, $timeout, $state) {
		var vm = this;
		var i18nFilter = $filter('i18n');

		vm.paginationChanged = paginationChanged;
		vm.updateFeed = updateFeed;
		vm.deleteFeed = deleteFeed;
		vm.goToHistory = goToHistory;
		vm.feedKeyDown = feedKeyDown;
		vm.confirm = confirm;
		vm.cancel = cancel;

		init();

		function init() {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			vm.selectedHerd = vm.settings.selectedHerd.id;
			vm.selectedTeam = vm.settings.selectedTeam.id;
			vm.currentPage = 1;
			vm.itemsPerPage = 10;
			vm.loading = true;
			vm.feeds = [];
			setFeedTypes(APP_CONST.constants.feed_types);
			if (vm.settings.use_kgs) {
				vm.weight = 'kg';
			} else {
				vm.weight = 'lb';
			}
			if (vm.selectedHerd) {
				getFeeds(true);
			} else {
				vm.loading = false;
			}
		}

		function reloadApi() {
			if (vm.selectedHerd) {
				getFeeds(true);
			} else {
				vm.loading = false;
			}
		}

		function setFeedTypes(feed_types) {
			var types = angular.copy(feed_types);

			vm.feedTypes = types.map(function (type) {
				var t = '_feeds_type_' + type.value + '_';
				type.show_name = t;
				type.translated = i18nFilter(t);
				return type;
			});
		}

		function getFeeds(init) {
			var suffix = '?herdId=' + vm.selectedHerd + '&pageNumber=' + (vm.currentPage - 1);
			myManualFeedsService
				.getFeeds(suffix)
				.then(function (response) {
					vm.totalItems = response && response.number_of_all ? response.number_of_all : 0;
					for (var i = 0; i < response.manual_feeds.length; i++) {
						var found = false;
						for (var j = 0; j < vm.feedTypes.length; j++) {
							if (response.manual_feeds[i].feed_type && response.manual_feeds[i].feed_type.toLowerCase() === vm.feedTypes[j].name.toLowerCase()) {
								response.manual_feeds[i].feed_type = vm.feedTypes[j];
								found = true;
								break;
							}
						}

						if (!found) {
							response.manual_feeds[i].feed_type = {
								show_name: '_feeds_type_not_set_',
								translated: i18nFilter('_feeds_type_not_set_')
							};
						}
					}

					vm.feeds = response.manual_feeds;

					vm.loading = false;
					vm.loadingTable = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					vm.loadingTable = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_feeds_', init);
				});
		}

		function paginationChanged() {
			vm.loadingTable = true;
			getFeeds();
		}

		function updateFeed(feed, data, type) {
			loading(true);
			vm.updatingFeed = true;
			var index = vm.feeds.indexOf(feed);

			switch (type) {
				case 'dm':
					feed.amount_as_fed = (feed.amount_dm * 100) / data;
					feed.cost_as_fed = (feed.cost_dm * data) / 100;
					break;
				case 'amount_dm':
					feed.amount_as_fed = (data * 100) / feed.dm;
					break;
				case 'amount_as_fed':
					feed.amount_dm = (data * feed.dm) / 100;
					break;
				case 'cost_dm':
					feed.cost_as_fed = (data * feed.dm) / 100;
					break;
				case 'cost_as_fed':
					feed.cost_dm = (data * 100) / feed.dm;
					break;
				default:
					break;
			}

			var DTO = new SetFeedDto(feed);

			myManualFeedsService
				.updateFeed(DTO)
				.then(function (response) {
					feed = response;
					if (vm.onEnterEvent) {
						$timeout(function () {
							try {
								var tempIndex = index + 1;
								if (tempIndex < vm.feeds.length) {
									var elem = document.getElementById(type + '_' + tempIndex);
									elem.click();
									if (tempIndex > 6) {
										var parent = elem.parentElement;
										parent.scrollIntoView(true);
									}
								}
								vm.onEnterEvent = false;
							} catch (error) {
								console.log(error);
							}
						}, 100);
					}
					loading(false);
					vm.updatingFeed = false;
				})
				.catch(function (error) {
					loading(false);
					console.log(error);
					vm.updatingFeed = false;
					errorService.showErrorMessage(error, true, '_error_occurred_updating_feed_');
				});
		}

		function deleteFeed(feed) {
			vm.confirmationPromise = $q.defer();
			openModal('app/pages/feeds/myManualFeeds/confirmation.modal.html', 'sm');
			$q.all([vm.confirmationPromise.promise]).then(function () {
				vm.modalLoading = true;
				var DTO = new SetFeedDto(feed);

				myManualFeedsService
					.deleteFeed(DTO)
					.then(function () {
						vm.feeds = vm.feeds.filter(function (f) {
							return f.id !== feed.id;
						});
						closeModal();
						vm.modalLoading = false;
						if (vm.feeds.length === 0) {
							getFeeds();
						}
					})
					.catch(function (error) {
						console.log(error);
						closeModal();
						vm.modalLoading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_deleting_feed_');
					});
			});
		}

		function SetFeedDto(feed) {
			this.id = feed.id;
			this.feed_name = feed.feed_name;
			this.feed_type = feed.feed_type.name;
			this.amount_dm = feed.amount_dm;
			this.amount_as_fed = feed.amount_as_fed;
			this.dm = feed.dm;
			this.cost_dm = feed.cost_dm;
			this.cost_as_fed = feed.cost_as_fed;
			this.herd_id = vm.selectedHerd;
			this.team_id = vm.selectedTeam;
		}

		function goToHistory(id) {
			$state.go('feeds.manualFeedsHistory', {
				uuid: id
			});
		}

		function feedKeyDown(event, data) {
			if (data != undefined) {
				if (event.keyCode == 13) {
					vm.onEnterEvent = true;
				} else if (event.keyCode == 27) {
					vm.onEnterEvent = true;
				}
			}
		}

		function loading(prop) {
			if (prop) {
				angular.element('html').addClass('wait-cursor');
			} else {
				angular.element('html').removeClass('wait-cursor');
			}
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		function confirm() {
			vm.confirmationPromise.resolve();
		}

		function cancel() {
			vm.confirmationPromise.reject();
			closeModal();
		}

		$scope.$on('default_team_herd_changed', function () {
			init();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		editableOptions.theme = 'bs3';
		editableOptions.blurElem = 'cancel';
		editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
		editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.feeds.mymanualfeeds').factory('myManualFeedsService', myManualFeedsService);
	/** @ngInject */
	function myManualFeedsService($http, APP_CONST, $q) {
		return {
			getFeeds: getFeeds,
			updateFeed: updateFeed,
			deleteFeed: deleteFeed
		};

		function getFeeds(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'manualfeeds' + suffix)
				.then(success)
				.catch(error);
		}

		function updateFeed(feed) {
			return $http
				.put(APP_CONST.api_base_url + 'manualfeed', feed)
				.then(success)
				.catch(error);
		}

		function deleteFeed(feed) {
			return $http
				.delete(APP_CONST.api_base_url + 'manualfeed', { data: feed, headers: { 'Content-Type': 'application/json;charset=utf-8' } })
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.iManagement.addNewIngredient').controller('addNewIngredientCtrl', addNewIngredientCtrl);
	/** @ngInject */
	function addNewIngredientCtrl(APP_CONST, $filter, toastr, addNewIngredientsFactory, $timeout, $state, $scope, $cookies, dataServiceFactory, errorService, unitConversionService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var listener;
		vm.removeSelection = removeSelection;
		vm.addNewIngredient = addNewIngredient;
		vm.changeUnit = changeUnit;
		vm.cancel = cancel;
		vm.reloadApi = reloadApi;
		/*var drawingManager = new google.maps.drawing.DrawingManager({
			drawingControl: true,
			drawingControlOptions: {
				position: google.maps.ControlPosition.TOP_CENTER,
				drawingModes: ['polygon']
			},
			polygonOptions: {
				fillColor: '#FF4C4C',
				strokeColor: '#B23535',
				fillOpacity: 0.6,
				strokeWeight: 2,
				clickable: false,
				editable: false,
				zIndex: 1
			}
		});*/
		init();

		function init() {
			vm.loading = true;
			vm.ingredient = {};
			vm.selectedHerd = null;
			vm.ingredient = {};
			vm.showGMap = true;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.from_recipe = JSON.parse(localStorage.getItem('from_recipe'));
			var cookie = $cookies.get('ingredient_use_kg');
			if (cookie && cookie == 'true') {
				vm.use_kg = true;
				vm.unit_icon = 'toggle_off';
			} else {
				vm.use_kg = false;
				vm.unit_icon = 'toggle_on';
			}
			if (vm.settings.use_kgs) {
				vm.weight = 'Kg';
			} else {
				vm.weight = 'Lb';
			}
			if (vm.settings && vm.settings.selectedHerd.id) {
				vm.selectedTeam = vm.settings.selectedTeam.id;
				vm.selectedHerd = vm.settings.selectedHerd.id;
				setFeedTypes(APP_CONST.constants.feed_types);
				getHerdById(vm.selectedHerd);
			} else {
				vm.loading = false;
			}
		}

		function reloadApi() {
			vm.loading = true;
			vm.showGMap = true;
			if (vm.settings && vm.settings.selectedHerd.id) {
				getHerdById(vm.selectedHerd);
			} else {
				vm.loading = false;
			}
		}

		function setFeedTypes(feed_types) {
			for (var i = 0; i < feed_types.length; i++) {
				var temp = '_feeds_type_' + feed_types[i].value + '_';
				feed_types[i].show_name = i18nFilter(temp);
			}
			vm.feed_types = feed_types;
		}

		function removeSelection() {
			vm.locationSelected = false;
			vm.ingredient.location = null;
			if (vm.ingredient.lat && vm.ingredient.lng) {
				initialize(vm.ingredient.lat, vm.ingredient.lng);
			} else {
				initialize();
			}
			drawingManager.setOptions({
				drawingControl: true
			});
		}

		function initialize(lat, lng) {
			var latitude;
			var longitude;
			var zoom;
			var marker;
			if (lat && lng) {
				latitude = lat;
				longitude = lng;
				zoom = 15;
			} else {
				latitude = 43.8900745;
				longitude = 20.3492278;
				zoom = 3;
			}
			var id = 'google-maps';
			var geocoder = new google.maps.Geocoder();
			var mapCanvas = document.getElementById(id);
			var input = document.getElementById('ingredient_address');
			var searchBox = new google.maps.places.SearchBox(input);
			searchBox.addListener('places_changed', function () {
				var places = searchBox.getPlaces();
				if (places.length == 0) {
					return;
				}
				// Clear out the old markers.
				try {
					marker.setMap(null);
				} catch (error) {
					console.log(error);
				}
				// For each place, get the icon, name and location.
				var bounds = new google.maps.LatLngBounds();
				places.forEach(function (place) {
					if (!place.geometry) {
						console.log('Returned place contains no geometry');
						return;
					} else {
						vm.ingredient.address = place.formatted_address;
						var latlng = {
							lat: place.geometry.location.lat(),
							lng: place.geometry.location.lng()
						};
						placeMarker(latlng, map, false);
					}
					// Create a marker for each place.
					if (place.geometry.viewport) {
						// Only geocodes have viewport.
						bounds.union(place.geometry.viewport);
					} else {
						bounds.extend(place.geometry.location);
					}
				});
				map.fitBounds(bounds);
			});
			var mapOptions = {
				center: new google.maps.LatLng(latitude, longitude),
				zoom: zoom,
				mapTypeId: 'hybrid'
			};
			var map = new google.maps.Map(mapCanvas, mapOptions);
			if (!map || !map.renderingType) {
				vm.showGMap = false;
				return;
			}
			var has_marker = false;
			if (lat && lng) {
				var mark = {
					lat: latitude,
					lng: longitude
				};
				placeMarker(mark, map);
				has_marker = true;
			}
			map.addListener('click', function (e) {
				if (!has_marker) {
					placeMarker(e.latLng, map);
					has_marker = true;
				}
			});
			drawingManager.setMap(map);
			if (listener) {
				google.maps.event.removeListener(listener);
			}
			listener = google.maps.event.addListener(drawingManager, 'polygoncomplete', function (polygon) {
				drawingManager.setOptions({
					drawingControl: false
				});
				drawingManager.setDrawingMode(null);
				var arr = polygon.getPath().getArray();
				var coordinates = [];
				for (var i = 0; i < arr.length; i++) {
					var coordinate = {
						lat: arr[i].lat(),
						lng: arr[i].lng()
					};
					coordinates.push(coordinate);
				}
				if (coordinates.length > 6) {
					if (vm.ingredient.lat && vm.ingredient.lng) {
						initialize(vm.ingredient.lat, vm.ingredient.lng);
					} else {
						initialize();
					}
					vm.locationSelected = false;
					vm.ingredient.location = null;
					drawingManager.setOptions({
						drawingControl: true
					});
				} else {
					vm.ingredient.location = coordinates;
					$timeout(function () {
						vm.locationSelected = true;
					}, 0);
				}
			});

			function placeMarker(position, map) {
				var marker = new google.maps.Marker({
					position: position,
					map: map,
					draggable: true
				});
				vm.ingredient.lat = position.lat;
				vm.ingredient.lng = position.lng;
				map.panTo(position);
				geocodePosition(marker.getPosition());
				google.maps.event.addListener(marker, 'dragend', function (event) {
					vm.ingredient.lat = event.latLng.lat();
					vm.ingredient.lng = event.latLng.lng();
					geocodePosition(marker.getPosition());
				});
				function geocodePosition(pos) {
					geocoder.geocode(
						{
							latLng: pos
						},
						function (responses) {
							if (responses.length && responses[0]) {
								$timeout(function () {
									vm.ingredient.address = responses[0].formatted_address;
								}, 0);
							}
						}
					);
				}
			}
		}

		function getHerdById(herd_id) {
			return addNewIngredientsFactory
				.getHerdById(herd_id)
				.then(function (response) {
					vm.herd = response;
					var address = '';
					if (response.Street) {
						address = address + response.Street + ' ';
					}

					if (response.Number) {
						address = address + response.Number + ' ';
					}
					if (response.Zip) {
						address = address + ',' + response.Zip + ' ';
					}
					if (response.City) {
						address = address + response.City + ' ';
					}
					vm.ingredient.address = address;
					vm.loading = false;
					$timeout(function () {
						if (response.Latitude && response.Longitude) {
							vm.ingredient.lat = response.Latitude;
							vm.ingredient.lng = response.Longitude;
							initialize(response.Latitude, response.Longitude);
						} else {
							initialize();
						}
					}, 100);
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_herds_', true);
				});
		}

		function addNewIngredient() {
			var ingDTO = angular.copy(vm.ingredient);
			if (vm.ingredientForm.$valid) {
				vm.loading = true;
				ingDTO.location = JSON.stringify(ingDTO.location);
				ingDTO.ingredient_type = vm.selected_type.value;
				ingDTO.herd_id = vm.selectedHerd;
				ingDTO.team_id = vm.selectedTeam;
				ingDTO.last_modified_user = vm.user.email;
				if (!vm.settings.use_kgs) {
					if (!vm.use_kg) {
						ingDTO.current_quantity = unitConversionService.convertData(ingDTO.current_quantity, ['imperialTonToKg']);
					} else {
						ingDTO.current_quantity = unitConversionService.convertData(ingDTO.current_quantity, ['lbToKg']);
					}
				} else {
					if (!vm.use_kg) {
						ingDTO.current_quantity = unitConversionService.convertData(ingDTO.current_quantity, ['metricTonToKg']);
					}
				}

				ingDTO.original_quantity = ingDTO.current_quantity;
				return addNewIngredientsFactory
					.addNewIngredient(ingDTO)
					.then(function () {
						toastr.success(i18nFilter('_toastr_add_ingredient_'), i18nFilter('_toastr_success_title_'));
						if (vm.from_recipe) {
							if (vm.from_recipe.type == 'edit') {
								$state.go('recipes.editRecipe', {
									uuid: vm.from_recipe.uuid
								});
							} else if (vm.from_recipe.type == 'add') {
								$state.go('recipes.addNewRecipe');
							}
						} else {
							$state.go('iManagement.inventory');
						}
					})
					.catch(function (error) {
						console.log(error);
						vm.loading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_creating_ingredient_');
						$timeout(function () {
							initialize(ingDTO.lat, ingDTO.lng);
						}, 200);
					});
			}
		}

		function changeUnit() {
			vm.use_kg = !vm.use_kg;
			var expireDate = new Date();
			expireDate.setDate(expireDate.getDate() + 1);
			if (vm.use_kg) {
				vm.unit_icon = 'toggle_off';
				$cookies.put('ingredient_use_kg', true, {
					expires: expireDate
				});
				if (!vm.settings.use_kgs) {
					if (vm.ingredient.current_quantity) {
						vm.ingredient.current_quantity = unitConversionService.convertData(vm.ingredient.current_quantity, ['poundsToImperialTon']);
					}
				} else {
					if (vm.ingredient.current_quantity) {
						vm.ingredient.current_quantity = unitConversionService.convertData(vm.ingredient.current_quantity, ['metricTonToKg']);
					}
				}
			} else {
				vm.unit_icon = 'toggle_on';
				$cookies.put('ingredient_use_kg', false, {
					expires: expireDate
				});
				if (!vm.settings.use_kgs) {
					if (vm.ingredient.current_quantity) {
						vm.ingredient.current_quantity = unitConversionService.convertData(vm.ingredient.current_quantity, ['imperialTonToPounds']);
					}
				} else {
					if (vm.ingredient.current_quantity) {
						vm.ingredient.current_quantity = unitConversionService.convertData(vm.ingredient.current_quantity, ['kgToMetricTon']);
					}
				}
			}
		}

		function cancel() {
			if (vm.from_recipe) {
				if (vm.from_recipe.type == 'edit') {
					$state.go('recipes.editRecipe', {
						uuid: vm.from_recipe.uuid
					});
				} else if (vm.from_recipe.type == 'add') {
					$state.go('recipes.addNewRecipe');
				}
			} else {
				$state.go('iManagement.inventory');
			}
		}

		$scope.$on('$stateChangeStart', function (event, toState) {
			if (toState.url !== '/editRecipe/{uuid:string}' && toState.url !== '/addNewRecipe') {
				dataServiceFactory.add_new_recipe_data = {};
				dataServiceFactory.edit_recipe_data = {};
				localStorage.removeItem('from_recipe');
			}
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_team_selected', function () {
			init();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.iManagement.addNewIngredient').factory('addNewIngredientsFactory', addNewIngredientsFactory);
	/** @ngInject */
	function addNewIngredientsFactory(APP_CONST, $http, $q) {
		return {
			getHerdById: getHerdById,
			addNewIngredient: addNewIngredient
		};

		function getHerdById(herdId) {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/herds/' + herdId)
				.then(success)
				.catch(error);
		}

		function addNewIngredient(ingredient) {
			return $http
				.post(APP_CONST.api_base_url + 'ingredients', ingredient)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.iManagement.editIngredient').controller('editIngredientCtrl', editIngredientCtrl);
	/** @ngInject */
	function editIngredientCtrl(editIngredientService, toastr, $stateParams, $timeout, APP_CONST, $state, $filter, $cookies, $scope, errorService, unitConversionService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var listener;
		vm.removeSelection = removeSelection;
		vm.updateIngredient = updateIngredient;
		vm.currentQuantityChanged = currentQuantityChanged;
		vm.cancel = cancel;
		vm.changeUnit = changeUnit;
		vm.reloadApi = reloadApi;
		vm.firstInit = true;
		/*var drawingManager = new google.maps.drawing.DrawingManager({
			drawingControl: false,
			drawingControlOptions: {
				position: google.maps.ControlPosition.TOP_CENTER,
				drawingModes: ['polygon']
			},
			polygonOptions: {
				fillColor: '#FF4C4C',
				strokeColor: '#B23535',
				fillOpacity: 0.6,
				strokeWeight: 2,
				clickable: false,
				editable: false,
				zIndex: 1
			}
		});*/
		init();

		function init() {
			vm.showGMap = true;
			vm.loading = true;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.currentPage = 1;
			vm.ingredient_id = $stateParams.uuid;
			var cookie = $cookies.get('ingredient_use_kg');
			if (cookie && cookie == 'true') {
				vm.use_kg = true;
				vm.unit_icon = 'toggle_off';
			} else {
				vm.use_kg = false;
				vm.unit_icon = 'toggle_on';
			}
			if (vm.settings && vm.settings.selectedTeam.id && vm.settings.selectedHerd.id) {
				vm.selectedTeam = vm.settings.selectedTeam.id;
				vm.selectedHerd = vm.settings.selectedHerd.id;
				setFeedTypes(APP_CONST.constants.feed_types);
				getIngredientById();
			} else {
				vm.loading = false;
			}
		}

		function reloadApi() {
			vm.loading = true;
			vm.showGMap = true;
			if (vm.settings && vm.settings.selectedTeam.id && vm.settings.selectedHerd.id) {
				getIngredientById();
			} else {
				vm.loading = false;
			}
		}

		function setFeedTypes(feed_types) {
			for (var i = 0; i < feed_types.length; i++) {
				var temp = '_feeds_type_' + feed_types[i].value + '_';
				feed_types[i].show_name = i18nFilter(temp);
			}
			vm.feed_types = feed_types;
		}

		function getIngredientById() {
			var suffix = '/' + vm.ingredient_id + '?team=' + vm.settings.selectedTeam.id + '&herd=' + vm.settings.selectedHerd.id;
			return editIngredientService
				.getIngredientById(suffix)
				.then(function (response) {
					for (var i = 0; i < vm.feed_types.length; i++) {
						if (vm.feed_types[i].value == response.ingredient_type) {
							vm.selected_type = vm.feed_types[i];
							break;
						}
					}
					if (!vm.settings.use_kgs) {
						vm.weight = 'Lb';
						if (!vm.use_kg) {
							response.current_quantity = unitConversionService.convertData(response.current_quantity, ['kgToImperialTon']);
						} else {
							response.current_quantity = unitConversionService.convertData(response.current_quantity, ['kgToLb']);
						}
					} else {
						vm.weight = 'Kg';
						if (!vm.use_kg) {
							response.current_quantity = unitConversionService.convertData(response.current_quantity, ['kgToMetricTon']);
						}
					}
					if (response.location) {
						response.location = JSON.parse(response.location);
					}
					response.location_changed = false;
					vm.ingredient = response;
					vm.loading = false;
					$timeout(function () {
						initializeMap(response);
					}, 100);
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_ingredient_', true);
				});
		}

		function initializeMap(ingredient) {
			var latitude;
			var longitude;
			var zoom;
			var addMarkerToMap;
			var has_marker;
			if (ingredient.lat && ingredient.lng) {
				addMarkerToMap = true;
				zoom = 16;
				has_marker = true;
				latitude = Number(ingredient.lat);
				longitude = Number(ingredient.lng);
			} else {
				vm.ingredient.lat = 43.8900745;
				vm.ingredient.lng = 20.3492278;
				addMarkerToMap = false;
				zoom = 3;
				has_marker = false;
				vm.latLngMissing = true;
			}
			var marker;
			var id = 'google-maps';
			var mapCanvas = document.getElementById(id);
			var geocoder = new google.maps.Geocoder();
			var mapOptions = {
				center: new google.maps.LatLng(ingredient.lat, ingredient.lng),
				zoom: zoom,
				mapTypeId: 'hybrid'
			};
			var map = new google.maps.Map(mapCanvas, mapOptions);
			if (!map || !map.renderingType) {
				vm.showGMap = false;
				return;
			}
			var markerLatLng = {
				lat: latitude,
				lng: longitude
			};
			if (typeof markerLatLng.lat == 'number' && typeof markerLatLng.lng == 'number' && !isNaN(markerLatLng.lat) && !isNaN(markerLatLng.lng)) {
				placeMarker(markerLatLng, map);
			}

			function placeMarker(position, map) {
				marker = new google.maps.Marker({
					position: position,
					map: map,
					draggable: true
				});
				map.panTo(position);
				google.maps.event.addListener(marker, 'dragend', function () {
					geocodePosition(marker.getPosition());
				});

				function geocodePosition(pos) {
					vm.ingredient.lat = pos.lat();
					vm.ingredient.lng = pos.lng();
					geocoder.geocode(
						{
							latLng: pos
						},
						function (responses) {
							$timeout(function () {
								vm.ingredient.address = responses[0].formatted_address;
							}, 0);
						}
					);
				}
			}
			drawingManager.setMap(map);
			if (listener) {
				google.maps.event.removeListener(listener);
			}
			if (!addMarkerToMap) {
				map.addListener('click', function (e) {
					if (!has_marker) {
						placeMarker(e.latLng, map);
						has_marker = true;
					}
				});
			}
			listener = google.maps.event.addListener(drawingManager, 'polygoncomplete', function (polygon) {
				drawingManager.setOptions({
					drawingControl: false
				});
				drawingManager.setDrawingMode(null);
				var arr = polygon.getPath().getArray();
				var coordinates = [];
				for (var i = 0; i < arr.length; i++) {
					var coordinate = {
						lat: arr[i].lat(),
						lng: arr[i].lng()
					};
					coordinates.push(coordinate);
				}
				if (coordinates.length > 6) {
					initializeMap(vm.ingredient);
					vm.locationSelected = false;
					drawingManager.setOptions({
						drawingControl: true
					});
				} else {
					vm.ingredient.location = coordinates;
					$timeout(function () {
						vm.locationSelected = true;
					}, 0);
				}
				$timeout(function () {
					vm.locationSelected = true;
				}, 0);
			});
			var input = document.getElementById('ingredient_address');
			var searchBox = new google.maps.places.SearchBox(input);
			searchBox.addListener('places_changed', function () {
				var places = searchBox.getPlaces();
				if (places.length == 0) {
					return;
				}
				// Clear out the old markers.
				marker.setMap(null);
				// For each place, get the icon, name and location.
				var bounds = new google.maps.LatLngBounds();
				places.forEach(function (place) {
					if (!place.geometry) {
						console.log('Returned place contains no geometry');
						return;
					} else {
						vm.ingredient.address = place.formatted_address;
						var latlng = {
							lat: place.geometry.location.lat(),
							lng: place.geometry.location.lng()
						};
						vm.ingredient.lat = place.geometry.location.lat();
						vm.ingredient.lng = place.geometry.location.lng();
						placeMarker(latlng, map);
					}
					// Create a marker for each place.
					if (place.geometry.viewport) {
						// Only geocodes have viewport.
						bounds.union(place.geometry.viewport);
					} else {
						bounds.extend(place.geometry.location);
					}
				});
				//   map.fitBounds(bounds);
			});
			if (vm.firstInit) {
				vm.firstInit = false;
				if (vm.ingredient.location) {
					var pen = new google.maps.Polygon({
						paths: vm.ingredient.location,
						strokeColor: '#FF0000',
						strokeOpacity: 0.8,
						strokeWeight: 2,
						fillColor: '#FF0000',
						fillOpacity: 0.35
					});
					pen.setMap(map);
					drawingManager.setOptions({
						drawingControl: false
					});
					vm.locationSelected = true;
				} else {
					drawingManager.setOptions({
						drawingControl: true
					});
					vm.locationSelected = false;
				}
			}
		}

		function removeSelection() {
			vm.locationSelected = false;
			if (vm.latLngMissing) {
				vm.ingredient.lat = null;
				vm.ingredient.lng = null;
			}
			vm.ingredient.location = null;
			initializeMap(vm.ingredient);
			drawingManager.setOptions({
				drawingControl: true
			});
		}

		function currentQuantityChanged() {
			vm.current_quantity_changed = true;
		}

		function updateIngredient() {
			var ingDTO = angular.copy(vm.ingredient);
			if (vm.ingredientForm.$valid) {
				vm.loading = true;
				if (ingDTO.location) {
					ingDTO.location = JSON.stringify(ingDTO.location);
				}
				if (vm.current_quantity_changed) {
					ingDTO.quantity_date = $filter('date')(new Date(), 'yyyy-MM-dd');
				}
				ingDTO.ingredient_type = vm.selected_type.value;
				ingDTO.herd_id = vm.selectedHerd;
				ingDTO.team_id = vm.selectedTeam;
				ingDTO.last_modified_user = vm.user.email;
				if (!vm.settings.use_kgs) {
					if (!vm.use_kg) {
						ingDTO.current_quantity = unitConversionService.convertData(ingDTO.current_quantity, ['imperialTonToKg']);
					} else {
						ingDTO.current_quantity = unitConversionService.convertData(ingDTO.current_quantity, ['lbToKg']);
					}
				} else {
					if (!vm.use_kg) {
						ingDTO.current_quantity = unitConversionService.convertData(ingDTO.current_quantity, ['metricTonToKg']);
					}
				}

				ingDTO.original_quantity = ingDTO.current_quantity;
				return editIngredientService
					.updateIngredient(ingDTO)
					.then(function () {
						$state.go('iManagement.inventory');
						toastr.success(i18nFilter('_toastr_edit_ingredient_'), i18nFilter('_toastr_success_title_'));
					})
					.catch(function (error) {
						console.log(error);
						vm.loading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_updating_ingredient_');
						$timeout(function () {
							initializeMap(ingDTO);
						}, 100);
					});
			}
		}

		function changeUnit() {
			vm.use_kg = !vm.use_kg;
			var expireDate = new Date();
			expireDate.setDate(expireDate.getDate() + 1);
			if (vm.use_kg) {
				vm.unit_icon = 'toggle_off';
				$cookies.put('ingredient_use_kg', true, {
					expires: expireDate
				});
				if (!vm.settings.use_kgs) {
					if (vm.ingredient.current_quantity) {
						vm.ingredient.current_quantity = unitConversionService.convertData(vm.ingredient.current_quantity, ['poundsToImperialTon']);
					}
				} else {
					if (vm.ingredient.current_quantity) {
						vm.ingredient.current_quantity = unitConversionService.convertData(vm.ingredient.current_quantity, ['metricTonToKg']);
					}
				}
			} else {
				vm.unit_icon = 'toggle_on';
				$cookies.put('ingredient_use_kg', false, {
					expires: expireDate
				});
				if (!vm.settings.use_kgs) {
					if (vm.ingredient.current_quantity) {
						vm.ingredient.current_quantity = unitConversionService.convertData(vm.ingredient.current_quantity, ['imperialTonToPounds']);
					}
				} else {
					if (vm.ingredient.current_quantity) {
						vm.ingredient.current_quantity = unitConversionService.convertData(vm.ingredient.current_quantity, ['kgToMetricTon']);
					}
				}
			}
		}

		function cancel() {
			$state.go('iManagement.inventory');
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.iManagement.editIngredient').factory('editIngredientService', editIngredientService);
	/** @ngInject */
	function editIngredientService(APP_CONST, $http, $q) {
		return {
			getIngredientById: getIngredientById,
			updateIngredient: updateIngredient
		};

		function getIngredientById(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'ingredients' + suffix)
				.then(success)
				.catch(error);
		}

		function updateIngredient(ingredient) {
			return $http
				.put(APP_CONST.api_base_url + 'ingredients/update', ingredient)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.iManagement.ingredientHistory').controller('ingredientHistoryCtrl', ingredientHistoryCtrl);
	/** @ngInject */
	function ingredientHistoryCtrl(ingredientHistoryService, $stateParams, $state, $timeout, APP_CONST, $uibModal, $scope, $filter, $cookies, unitConversionService, errorService) {
		var vm = this;
		var feedTypes = APP_CONST.constants.feed_types;
		var i18nFilter = $filter('i18n');

		vm.openLocation = openLocation;
		vm.paginationChanged = paginationChanged;
		vm.reloadApi = reloadApi;
		vm.back = back;

		init();

		function init() {
			vm.loading = true;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.history = [];
			vm.ingredient_id = $stateParams.uuid;
			var cookie = $cookies.get('ingredient_use_kg');
			if (cookie && cookie == 'true') {
				vm.use_kg = true;
			} else {
				vm.use_kg = false;
			}
			if (vm.settings && vm.settings.selectedTeam.id && vm.settings.selectedHerd.id) {
				vm.currentPage = 1;
				getIngredientHistoryById(true);
			} else {
				vm.loading = false;
			}
		}

		function reloadApi() {
			vm.loading = true;
			if (vm.settings && vm.settings.selectedTeam.id && vm.settings.selectedHerd.id) {
				vm.currentPage = 1;
				getIngredientHistoryById(true);
			} else {
				vm.loading = false;
			}
		}

		function getIngredientHistoryById(init) {
			vm.loadingTable = true;
			var suffix = '/' + vm.ingredient_id + '?page=' + vm.currentPage;
			return ingredientHistoryService
				.getIngredientHistory(suffix)
				.then(function (response) {
					if (response.length > 0) {
						vm.totalItems = response[0].number_of_all;
						for (var i = 0; i < response.length; i++) {
							response[i].ingredient_type = setFeedType(response[i].ingredient_type);
							if (!vm.settings.use_kgs) {
								vm.weight = 'Lb';
								if (!vm.use_kg) {
									response[i].current_quantity = unitConversionService.convertData(response[i].current_quantity, ['kgToImperialTon', 'round:2']);
								} else {
									response[i].current_quantity = unitConversionService.convertData(response[i].current_quantity, ['kgToLb', 'round:2']);
								}
							} else {
								vm.weight = 'Kg';
								if (!vm.use_kg) {
									response[i].current_quantity = unitConversionService.convertData(response[i].current_quantity, ['kgToMetricTon', 'round:2']);
								}
							}
						}
					} else {
						vm.totalItems = 0;
					}
					vm.history = vm.history.concat(response);
					vm.loading = false;
					vm.loadingTable = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					vm.loadingTable = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_ingredient_history_', init);
				});
		}

		function paginationChanged() {
			vm.currentPage++;
			getIngredientHistoryById();
		}

		function back() {
			$state.go('iManagement.inventory');
		}

		function openLocation(ingredient) {
			vm.selectedIngredient = ingredient;
			openModal('app/pages/ingredientsManagement/inventory/location.modal.html', 'md');
			vm.locationError = false;
			$timeout(function () {
				initializeMap(ingredient);
			}, 200);
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope
			});
		}

		function setFeedType(feedType) {
			var obj;
			for (var i = 0; i < feedTypes.length; i++) {
				if (feedTypes[i].value === feedType) {
					obj = feedTypes[i];
					var tString = '_feeds_type_' + obj.value + '_';
					obj.name = i18nFilter(tString);
					break;
				}
			}
			return obj;
		}

		function initializeMap(ingredient) {
			var latitude;
			var longitude;
			var zoom;
			if (ingredient.lat && ingredient.lng) {
				latitude = Number(ingredient.lat);
				longitude = Number(ingredient.lng);
				zoom = 16;
				var id = 'google-maps';
				var mapCanvas = document.getElementById(id);
				var mapOptions = {
					center: new google.maps.LatLng(ingredient.lat, ingredient.lng),
					zoom: zoom,
					mapTypeId: 'hybrid'
				};
				var map = new google.maps.Map(mapCanvas, mapOptions);
				var markerLatLng = {
					lat: latitude,
					lng: longitude
				};
				if (typeof markerLatLng.lat === 'number' && typeof markerLatLng.lng === 'number' && !isNaN(markerLatLng.lat) && !isNaN(markerLatLng.lng)) {
					map.panTo(markerLatLng);
				}
				if (ingredient.location) {
					var locationPolygon = new google.maps.Polygon({
						paths: ingredient.location,
						strokeColor: '#FF0000',
						strokeOpacity: 0.8,
						strokeWeight: 2,
						fillColor: '#FF0000',
						fillOpacity: 0.35
					});
					locationPolygon.setMap(map);
				}
			} else {
				vm.locationError = true;
			}
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.iManagement.ingredientHistory').factory('ingredientHistoryService', ingredientHistoryService);
	/** @ngInject */
	function ingredientHistoryService(APP_CONST, $http, $q) {
		return {
			getIngredientHistory: getIngredientHistory
		};

		function getIngredientHistory(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'ingredients/history' + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.iManagement.ingredientDetails').controller('ingredientDetailsCtrl', ingredientDetailsCtrl);
	/** @ngInject */
	function ingredientDetailsCtrl(ingredientDetailsService, $stateParams, $timeout, APP_CONST, $scope, $filter, $cookies, unitConversionService, errorService, $state) {
		var vm = this;
		var feedTypes = APP_CONST.constants.feed_types;
		var i18nFilter = $filter('i18n');

		vm.reloadApi = reloadApi;
		vm.back = back;

		init();

		function init() {
			vm.selectedTeamHerd = false;
			vm.loading = true;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.currentPage = 1;
			vm.ingredient_id = $stateParams.uuid;
			var cookie = $cookies.get('ingredient_use_kg');
			if (cookie && cookie == 'true') {
				vm.use_kg = true;
				vm.unit_icon = 'toggle_off';
			} else {
				vm.use_kg = false;
				vm.unit_icon = 'toggle_on';
			}
			if (vm.settings && vm.settings.selectedTeam.id && vm.settings.selectedHerd.id) {
				vm.selectedTeam = vm.settings.selectedTeam.id;
				vm.selectedHerd = vm.settings.selectedHerd.id;
				getIngredientDetailsById();
			} else {
				vm.loading = false;
			}
		}

		function back() {
			$state.go('iManagement.inventory');
		}

		function reloadApi() {
			vm.loading = true;
			if (vm.settings && vm.settings.selectedTeam.id && vm.settings.selectedHerd.id) {
				getIngredientDetailsById();
			} else {
				vm.loading = false;
			}
		}

		function getIngredientDetailsById() {
			var suffix = '/' + vm.ingredient_id + '?team=' + vm.settings.selectedTeam.id + '&herd=' + vm.settings.selectedHerd.id;
			return ingredientDetailsService
				.getIngredientDetails(suffix)
				.then(function (response) {
					response.ingredient_type = setFeedType(response.ingredient_type);
					if (!vm.settings.use_kgs) {
						vm.weight = 'Lb';
						if (!vm.use_kg) {
							response.current_quantity = unitConversionService.convertData(response.current_quantity, ['kgToImperialTon', 'round:2']);
						} else {
							response.current_quantity = unitConversionService.convertData(response.current_quantity, ['kgToLb', 'round:2']);
						}
					} else {
						vm.weight = 'Kg';
						if (!vm.use_kg) {
							response.current_quantity = unitConversionService.convertData(response.current_quantity, ['kgToMetricTon', 'round:2']);
						}
					}
					vm.details = response;
					vm.loading = false;
					if (vm.settings.selectedTeam.id === vm.details.team_id) {
						vm.selectedTeamHerd = true;
					} else {
						vm.selectedTeamHerd = false;
					}
					if (vm.settings.selectedHerd.id === vm.details.herd_id) {
						vm.selectedTeamHerd = true;
					} else {
						vm.selectedTeamHerd = false;
					}
					$timeout(function () {
						initializeMap(response);
					}, 500);
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_ingredient_details_', true);
				});
		}

		function setFeedType(feedType) {
			var obj;
			for (var i = 0; i < feedTypes.length; i++) {
				if (feedTypes[i].value === feedType) {
					obj = feedTypes[i];
					var tString = '_feeds_type_' + obj.value + '_';
					obj.name = i18nFilter(tString);
					break;
				}
			}
			return obj;
		}

		function initializeMap(ingredient) {
			var addMarkerToMap;
			var zoom;
			if (ingredient.address && (!ingredient.lat || ingredient.lng)) {
				var geocoder = new google.maps.Geocoder();
				geocoder.geocode(
					{
						address: ingredient.address
					},
					function (results, status) {
						if (status === 'OK') {
							var lat = results[0].geometry.location.lat();
							var lng = results[0].geometry.location.lng();
							ingredient.lat = lat;
							ingredient.lng = lng;
						}
					}
				);
			}
			if (ingredient.lat && ingredient.lng) {
				addMarkerToMap = true;
				zoom = 16;
			} else {
				ingredient.lat = 43.8900745;
				ingredient.lng = 20.3492278;
				addMarkerToMap = false;
				zoom = 3;
				vm.latLngMissing = true;
			}
			var id = 'google-maps';
			var mapCanvas = document.getElementById(id);
			var mapOptions = {
				center: new google.maps.LatLng(ingredient.lat, ingredient.lng),
				zoom: zoom,
				mapTypeId: google.maps.MapTypeId.SATELLITE
			};
			var map = new google.maps.Map(mapCanvas, mapOptions);
			var latLng = {
				lat: Number(ingredient.lat),
				lng: Number(ingredient.lng)
			};
			if (typeof latLng.lat === 'number' && typeof latLng.lng === 'number' && !isNaN(latLng.lat) && !isNaN(latLng.lng) && addMarkerToMap) {
				map.panTo(latLng);
			}
			if (ingredient.location) {
				var ingredientObj = new google.maps.Polygon({
					paths: JSON.parse(ingredient.location),
					strokeColor: '#FF0000',
					strokeOpacity: 0.8,
					strokeWeight: 2,
					fillColor: '#FF0000',
					fillOpacity: 0.35
				});
				ingredientObj.setMap(map);
			}
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_team_selected', function () {
			vm.selectedHerd = null;
			init();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.iManagement.ingredientDetails').factory('ingredientDetailsService', ingredientDetailsService);
	/** @ngInject */
	function ingredientDetailsService(APP_CONST, $http, $q) {
		return {
			getIngredientDetails: getIngredientDetails
		};

		function getIngredientDetails(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'ingredients' + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

/* eslint-disable no-redeclare */
(function () {
	'use strict';
	angular.module('Spartan.pages.iManagement.ingredientUsageOverview').controller('ingredientUsageOverviewCtrl', ingredientUsageOverviewCtrl);
	/** @ngInject */
	function ingredientUsageOverviewCtrl($uibModal, $uibModalStack, $scope, $locale, ingredientUsageOverviewService, errorService, $filter, editableOptions, editableThemes, $timeout, unitConversionService, $q, authService, $cookies) {
		var vm = this;
		var RRule = rrule.RRule;
		var recipesPromise;
		var milkIntakePromise;
		var feedIntakePromise;
		var i18nFilter = $filter('i18n');
		vm.dateFormat = $locale.DATETIME_FORMATS.shortDate;
		vm.selectIngredient = selectIngredient;
		vm.createSummary = createSummary;
		vm.deleteSummary = deleteSummary;
		vm.checkSummaryButtonDisabled = checkSummaryButtonDisabled;
		vm.checkSummaryTableDisplayed = checkSummaryTableDisplayed;
		vm.getTableClass = getTableClass;
		vm.saveFilter = saveFilter;
		vm.openFilterModal = openFilterModal;
		vm.showCostChanged = showCostChanged;
		vm.exportToPdf = exportToPdf;
		vm.exportToXls = exportToXls;
		vm.showLoadDropChanged = showLoadDropChanged;
		vm.showRobotDataChanged = showRobotDataChanged;

		init();

		function init() {
			toDataURL('assets/img/MmmooOgle_logo.png', function (dataurl) {
				vm.logo = dataurl;
			});
			setToggleSwitches();
			vm.loading = true;
			vm.showRobotData = false;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedTeam = vm.settings.selectedTeam.id;
			vm.selectedHerd = vm.settings.selectedHerd.id;
			vm.hasRobotAccess = authService.can(128) || authService.can(261120);
			if (vm.settings.use_kgs) {
				vm.weight = 'Kg';
			} else {
				vm.weight = 'Lb';
			}
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			vm.options = {
				showWeeks: false
			};
			vm.selectedRecipes = [];
			vm.modalSelectedRecipes = [];
			vm.startDate = moment().subtract(7, 'days').toDate();
			vm.endDate = moment().toDate();
			vm.predefinedStart = moment().subtract(7, 'days').toDate();
			vm.predefinedEnd = moment().toDate();
			vm.recipeFilterActive = false;
			setDates();
			if (vm.selectedHerd) {
				getData(true);
				checkHerds(vm.selectedHerd);
			} else {
				vm.loading = false;
			}
		}

		function setToggleSwitches() {
			vm.showCost = $cookies.get('ingredient_overview_show_cost') ? JSON.parse($cookies.get('ingredient_overview_show_cost')) : true;
			vm.showLoadDrop = $cookies.get('ingredient_overview_toggle_load_drop') ? JSON.parse($cookies.get('ingredient_overview_toggle_load_drop')) : false;

			vm.toggleShowCost = vm.showCost;
			vm.toggleLoadDrop = vm.showLoadDrop;
		}

		function checkHerds(herd_id) {
			return ingredientUsageOverviewService.getHerdsByTeam(vm.selectedTeam).then(function (response) {
				vm.currentHerdName = getHerdNameById(herd_id, response);
			});
		}

		function getHerdNameById(herd_id, herds) {
			var herdName = '';
			for (var i = 0; i < herds.length; i++) {
				if (herds[i].Id == herd_id) {
					herdName = herds[i].Name;
					break;
				}
			}
			return herdName;
		}

		function reloadApi() {
			if (vm.selectedHerd) {
				getData(true);
			} else {
				vm.loading = false;
			}
		}

		function setDates() {
			vm.dates = [];
			var startDate = moment(vm.startDate).format('YYYYMMDDT000000') + 'Z';
			var endDate = moment(vm.endDate).format('YYYYMMDDT000000') + 'Z';
			var rrule_string = 'DTSTART:' + startDate + '\nRRULE:FREQ=DAILY;INTERVAL=1;UNTIL=' + endDate;
			var dates = RRule.fromString(rrule_string).all();
			dates.forEach(function (date) {
				vm.dates.push(moment(date).format('YYYY-MM-DD'));
			});
			vm.dates.sort(function (left, right) {
				return moment.utc(right).diff(moment.utc(left));
			});
		}

		function getData(init) {
			$timeout(function () {
				recipesPromise = $q.defer();
				milkIntakePromise = $q.defer();
				feedIntakePromise = $q.defer();

				$q.all([recipesPromise.promise, milkIntakePromise.promise, feedIntakePromise.promise])
					.then(function (response) {
						vm.rawRecipesResponse = response[0];
						vm.rawMilkIntakeResponse = response[1];
						vm.rawFeedIntakeResponse = response[2];
						handleResponse(response);
					})
					.catch(function (error) {
						console.log(error);
						vm.loading = false;
						closeModal();
						errorService.showErrorMessage(error, true, '_error_occurred_loading_ingredient_usage_', init);
					});

				getRecipes(init);
				if (vm.showRobotData) {
					getMilkIntakeData(init);
					getFeedIntakeData(init);
				} else {
					milkIntakePromise.resolve();
					feedIntakePromise.resolve();
				}
			}, 100);
		}

		function getRecipes(init) {
			vm.recipeFilter = [];
			var suffix = '?herd=' + vm.selectedHerd + '&start_date=' + moment(vm.startDate).format('YYYY-MM-DD') + '&end_date=' + moment(vm.endDate).format('YYYY-MM-DD');
			if (vm.selectedRecipes.length) {
				var list = [];
				for (var i = 0; i < vm.selectedRecipes.length; i++) {
					list.push(vm.selectedRecipes[i].id);
				}
				suffix += '&recipes=' + list;
			}
			ingredientUsageOverviewService
				.getRecipes(suffix)
				.then(function (response) {
					recipesPromise.resolve(response);
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					closeModal();
					errorService.showErrorMessage(error, true, '_error_occurred_loading_ingredient_usage_', init);
				});
		}

		function getMilkIntakeData() {
			var suffix = '?Date=>' + moment(vm.startDate).subtract(1, 'days').format('YYYY-MM-DD') + '&Date=<' + moment(vm.endDate).add(1, 'days').format('YYYY-MM-DD');
			ingredientUsageOverviewService
				.getMilkIntakeData(vm.selectedHerd, suffix)
				.then(function (response) {
					response.map(function (item) {
						item.Date = moment(item.Date).format('YYYY-MM-DD');
					});
					milkIntakePromise.resolve(response);
				})
				.catch(function (error) {
					console.log(error);
				});
		}

		function getFeedIntakeData() {
			var suffix = '?Date=>' + moment(vm.startDate).subtract(1, 'days').format('YYYY-MM-DD') + '&Date=<' + moment(vm.endDate).add(1, 'days').format('YYYY-MM-DD');
			ingredientUsageOverviewService
				.getFeedIntakeData(vm.selectedHerd, suffix)
				.then(function (response) {
					response.map(function (item) {
						item.Date = moment(item.Date).format('YYYY-MM-DD');
						item.LeftoversKg = item.RationKg - item.IntakeKg;
					});
					feedIntakePromise.resolve(response);
				})
				.catch(function (error) {
					console.log(error);
				});
		}

		function handleResponse(response) {
			vm.pens = [];
			vm.recipes = [];
			vm.summary = [];
			vm.feedIntake = {};
			vm.selectedIngredients = [];
			if (response.length) {
				if (vm.showLoadDrop) {
					vm.pens = getPens(response[0]);
				} else {
					response[0].forEach(function (recipe) {
						vm.recipes.push(new Recipe(recipe));
					});
				}
				if (vm.showRobotData) {
					vm.feedIntake = new FeedIntake(response[2]);
					vm.milkIntake = new MilkIntake(response[1]);
				}
				vm.loading = false;
				closeModal();
			} else {
				vm.loading = false;
				closeModal();
			}

			function Recipe(recipe) {
				this.id = recipe.id;
				this.recipe_name = recipe.name;
				this.ingredients = getIngredients(recipe.loadSubjects);
				this.total_amount = unitConversionService.convertData(getTotalRecipeAmount(this.ingredients), ['round:0']);
				this.total_amount_dm = unitConversionService.convertData(getTotalRecipeAmountDm(this.ingredients), ['round:0']);
				this.total_cost = getTotalRecipeCost(this.ingredients);
				this.feeding_dates = getRecipeDates(this.ingredients);
				this.expanded = false;
				this.dm = recipe.dm;
			}

			function getIngredients(subjectList) {
				var list = [];
				var ingredientList = [];
				subjectList.forEach(function (loadSubject) {
					loadSubject.loads.forEach(function (load) {
						load.load_ingredients.forEach(function (ingredient) {
							ingredientList.push({
								ingredient_id: ingredient.ingredient ? ingredient.ingredient.id : null,
								amount: ingredient.ingredient_actual_amount,
								ingredient_name: ingredient.ingredient ? ingredient.ingredient.name : 'unknown',
								cost: ingredient.ingredient ? (ingredient.ingredient.cost * ingredient.ingredient.dm) / 100 : 0,
								date: loadSubject.date,
								dm: ingredient.ingredient ? ingredient.ingredient.dm : 1
							});
						});
					});
				});

				angular.forEach($filter('groupBy')(ingredientList, 'ingredient_id'), function (byId, byIdKey) {
					list.push(new Ingredient(byId, byIdKey));
				});

				return list;

				function Ingredient(byId, byIdKey) {
					this.id = parseInt(byIdKey);
					this.ingredient_name = byId[0].ingredient_name;
					this.feeding_dates = getFeedingDates(byId);
					this.total_amount = getIngredientTotalAmount(this.feeding_dates);
					this.total_amount_dm = getIngredientTotalAmountDm(this.feeding_dates);
					this.dm = (this.total_amount_dm / this.total_amount) * 100;
					this.total_cost = getIngredientTotalCost(this.feeding_dates);
				}

				function getFeedingDates(byId) {
					var list = [];
					angular.forEach($filter('groupBy')(byId, 'date'), function (byDate, byDateKey) {
						var amount = 0;
						var cost = 0;
						var dm = 0;
						byDate.forEach(function (ingredient) {
							if (ingredient.amount) {
								amount += ingredient.amount;
								if (ingredient.cost) {
									cost += ingredient.cost * ingredient.amount;
								}
							}
							if (ingredient.dm) {
								dm = ingredient.dm;
							}
						});
						list.push({
							date: byDateKey,
							amount: amount,
							cost: cost,
							dm: dm,
							amount_dm: (amount * dm) / 100,
							expanded: false
						});
					});

					var newList = [];
					for (var i = 0; i < vm.dates.length; i++) {
						var found = false;
						for (var j = 0; j < list.length; j++) {
							if (moment(vm.dates[i]).isSame(list[j].date)) {
								found = true;
								break;
							}
						}
						if (!found) {
							newList.push({
								date: vm.dates[i],
								amount: 0,
								cost: 0,
								dm: 0,
								amount_dm: 0,
								expanded: false
							});
						}
					}

					list = list.concat(newList);

					list.sort(function (left, right) {
						return moment.utc(right.date).diff(moment.utc(left.date));
					});

					return list;
				}

				function getIngredientTotalAmountDm(dates) {
					var amount = 0;
					for (var i = 0; i < dates.length; i++) {
						amount += dates[i].amount_dm;
					}
					return amount;
				}

				function getIngredientTotalAmount(dates) {
					var amount = 0;
					for (var i = 0; i < dates.length; i++) {
						amount += dates[i].amount;
					}
					return amount;
				}

				function getIngredientTotalCost(dates) {
					var cost = 0;
					for (var i = 0; i < dates.length; i++) {
						cost += dates[i].cost;
					}
					return cost;
				}
			}

			function getTotalRecipeAmountDm(ingredients) {
				var amount = 0;
				for (var i = 0; i < ingredients.length; i++) {
					amount += ingredients[i].total_amount_dm;
				}
				return amount;
			}

			function getTotalRecipeAmount(ingredients) {
				var amount = 0;
				for (var i = 0; i < ingredients.length; i++) {
					amount += ingredients[i].total_amount;
				}
				return amount;
			}

			function getTotalRecipeCost(ingredients) {
				var cost = 0;
				for (var i = 0; i < ingredients.length; i++) {
					cost += ingredients[i].total_cost;
				}
				return cost;
			}

			function getRecipeDates(ingredients) {
				var amount;
				var amount_dm;
				var cost;
				var arr = [];
				for (var i = 0; i < vm.dates.length; i++) {
					amount = 0;
					amount_dm = 0;
					cost = 0;
					for (var j = 0; j < ingredients.length; j++) {
						for (var k = 0; k < ingredients[j].feeding_dates.length; k++) {
							if (moment(vm.dates[i]).isSame(ingredients[j].feeding_dates[k].date)) {
								if (ingredients[j].feeding_dates[k].amount) {
									amount += ingredients[j].feeding_dates[k].amount;
								}
								if (ingredients[j].feeding_dates[k].amount) {
									amount_dm += ingredients[j].feeding_dates[k].amount_dm;
								}
								if (ingredients[j].feeding_dates[k].cost) {
									cost += ingredients[j].feeding_dates[k].cost;
								}
								break;
							}
						}
					}

					arr.push({
						amount: amount,
						cost: cost,
						date: vm.dates[i],
						amount_dm: amount_dm,
						dm: (amount_dm / amount) * 100
					});
				}
				return arr;
			}

			function FeedIntake(feed_intake) {
				this.feeding_dates = getFeedIntakeFeedingDates(feed_intake);
				this.total_amount = getFeedIntakeTotalAmount(feed_intake);
				this.total_leftovers = getLeftoversTotalAmount(feed_intake);
				this.ingredients = getFeedIntakeIngredients(feed_intake);
			}

			function getFeedIntakeFeedingDates(intake_list) {
				var amount;
				var leftovers;
				var arr = [];

				for (var i = 0; i < vm.dates.length; i++) {
					amount = 0;
					leftovers = 0;
					var animals = [];
					for (var j = 0; j < intake_list.length; j++) {
						if (moment(vm.dates[i]).isSame(intake_list[j].Date)) {
							amount += intake_list[j].IntakeKg;
							leftovers += intake_list[j].LeftoversKg;
							animals.push(intake_list[j]);
						}
					}
					arr.push({
						amount: amount,
						date: vm.dates[i],
						leftovers: leftovers,
						n_animals: getNumberOfAnimals(animals)
					});
				}
				return arr;
			}

			function getFeedIntakeTotalAmount(intake_list) {
				var amount = 0;
				for (var j = 0; j < intake_list.length; j++) {
					amount += intake_list[j].IntakeKg;
				}
				return amount;
			}

			function getLeftoversTotalAmount(intake_list) {
				var amount = 0;
				for (var j = 0; j < intake_list.length; j++) {
					amount += intake_list[j].LeftoversKg;
				}
				return amount;
			}

			function getFeedIntakeIngredients(intake_list) {
				var list = [];
				angular.forEach($filter('groupBy')(intake_list, 'ProductId'), function (byId, byIdKey) {
					list.push(new FeedIngredient(byId, byIdKey));
				});

				return list;

				function FeedIngredient(byId, byIdKey) {
					this.id = parseInt(byIdKey);
					this.ingredient_name = byId[0].ProductName;
					this.feeding_dates = getFeedIngredientFeedingDates(byId);
					this.total_amount = getFeedIngredientTotalAmount(byId);
					this.total_leftovers = getFeedIngredientTotalLeftovers(byId);
				}

				function getFeedIngredientFeedingDates(byId) {
					var list = [];

					angular.forEach($filter('groupBy')(byId, 'Date'), function (byDate, byDateKey) {
						var amount = 0;
						var leftovers = 0;
						byDate.forEach(function (ingredient) {
							if (ingredient.IntakeKg) {
								amount += ingredient.IntakeKg;
							}
							leftovers += ingredient.LeftoversKg;
						});
						list.push({
							date: byDateKey,
							amount: amount,
							leftovers: leftovers
						});
					});

					var newList = [];
					for (var i = 0; i < vm.dates.length; i++) {
						var found = false;
						for (var j = 0; j < list.length; j++) {
							if (moment(vm.dates[i]).isSame(list[j].date)) {
								found = true;
								break;
							}
						}
						if (!found) {
							newList.push({
								date: vm.dates[i],
								amount: 0,
								leftovers: 0
							});
						}
					}

					list = list.concat(newList);

					list.sort(function (left, right) {
						return moment.utc(right.date).diff(moment.utc(left.date));
					});
					return list;
				}

				function getFeedIngredientTotalAmount(byId) {
					var sum = 0;
					for (var i = 0; i < byId.length; i++) {
						sum += byId[i].IntakeKg;
					}
					return sum;
				}

				function getFeedIngredientTotalLeftovers(byId) {
					var sum = 0;
					for (var i = 0; i < byId.length; i++) {
						sum += byId[i].LeftoversKg;
					}
					return sum;
				}
			}

			function MilkIntake(milk_intake) {
				this.feeding_dates = getMilkIntakeFeedingDates(milk_intake);
				this.total_amount = getMilkIntakeTotalAmount(milk_intake);
			}

			function getMilkIntakeFeedingDates(intake_list) {
				var amount;
				var arr = [];

				for (var i = 0; i < vm.dates.length; i++) {
					amount = 0;
					var animals = [];
					for (var j = 0; j < intake_list.length; j++) {
						if (moment(vm.dates[i]).isSame(intake_list[j].Date)) {
							amount += intake_list[j].AmountKg;
							animals.push(intake_list[j]);
						}
					}
					arr.push({
						amount: amount,
						date: vm.dates[i],
						n_animals: getNumberOfAnimals(animals)
					});
				}
				return arr;
			}

			function getMilkIntakeTotalAmount(intake_list) {
				var amount = 0;
				for (var j = 0; j < intake_list.length; j++) {
					amount += intake_list[j].AmountKg;
				}
				return amount;
			}

			function getNumberOfAnimals(animals) {
				if (animals && animals.length) {
					animals = $filter('groupBy')(animals, 'AnimalId');
					var properties = Object.keys(animals);
					return properties.length;
				}
				return 0;
			}
		}

		function getPens(response) {
			var pens = [];
			var penList = getAllUsedPens(response);
			if (penList.length) {
				penList.forEach(function (pen) {
					pens.push(new Pen(pen, response));
				});
			}

			function Pen(pen, _response) {
				this.id = pen.id;
				this.pen_name = pen.pen_name;
				this.n_animals = pen.number_of_animals;
				this.total_cost = getTotalPenCost(pen);
				this.feeding_dates = getPenFeedingDates(pen, _response);
				this.total_amount = unitConversionService.convertData(getTotalPenAmount(this.feeding_dates), ['round:0']);
				this.total_amount_dm = unitConversionService.convertData(getTotalPenAmountDm(this.feeding_dates), ['round:0']);
				this.dm = (this.total_amount_dm / this.total_amount) * 100;
				this.ingredients = getPenIngredients(pen, _response);
				this.expanded = false;
			}

			function getPenFeedingDates(pen, __response) {
				var _ingredients_drop = pen.ingredientsDrop;
				var list = [];
				for (var i = 0; i < vm.dates.length; i++) {
					var obj = {
						date: vm.dates[i],
						amount: 0,
						amount_dm: 0,
						dm: 0,
						cost: 0,
						n_animals: 0
					};
					for (var j = 0; j < _ingredients_drop.length; j++) {
						if (vm.dates[i] == _ingredients_drop[j].date) {
							obj.amount += _ingredients_drop[j].amount;
							obj.amount_dm += _ingredients_drop[j].amount_dm;
							obj.cost += _ingredients_drop[j].cost;
						}
					}

					if (obj.amount && obj.amount_dm) {
						obj.dm = (obj.amount_dm / obj.amount) * 100;
					}

					__response.forEach(function (recipe) {
						recipe.loadSubjects.forEach(function (loadSubject) {
							if (loadSubject.date == vm.dates[i]) {
								loadSubject.pen_feedings.forEach(function (pen_feeding) {
									if (pen_feeding.pen.id == pen.id) {
										obj.n_animals = pen_feeding.number_of_animals ? pen_feeding.number_of_animals : 0;
									}
								});
							}
						});
					});

					list.push(obj);
				}
				return list;
			}

			function getPenIngredients(_pen) {
				var ingredients = [];
				if (_pen.ingredients && _pen.ingredients.length) {
					_pen.ingredients.forEach(function (ingredient) {
						ingredients.push(new Ingredient(ingredient, _pen));
					});
				}

				function Ingredient(_ingredient, __pen) {
					this.id = _ingredient.id;
					this.ingredient_name = _ingredient.name;
					this.feeding_dates = getPenIngredientFeedingDates(_ingredient.id, __pen.ingredientsDrop);
					this.total_amount = getPenIngredientTotalAmount(this.feeding_dates);
					this.total_amount_dm = getPenIngredientTotalAmountDm(this.feeding_dates);
					this.total_cost = getPenIngredientTotalCost(this.feeding_dates);
					this.dm = (this.total_amount_dm / this.total_amount) * 100;
				}

				function getPenIngredientTotalCost(dates) {
					var sum = 0;
					for (var i = 0; i < dates.length; i++) {
						sum += dates[i].cost;
					}
					return sum;
				}

				function getPenIngredientTotalAmount(dates) {
					var sum = 0;
					for (var i = 0; i < dates.length; i++) {
						sum += dates[i].amount;
					}
					return sum;
				}

				function getPenIngredientTotalAmountDm(dates) {
					var sum = 0;
					for (var i = 0; i < dates.length; i++) {
						sum += dates[i].amount_dm;
					}
					return sum;
				}

				function getPenIngredientFeedingDates(id, ing_drop) {
					var list = [];

					for (var i = 0; i < vm.dates.length; i++) {
						var obj = {
							date: vm.dates[i],
							amount: 0,
							amount_dm: 0,
							dm: 0,
							cost: 0
						};
						for (var j = 0; j < ing_drop.length; j++) {
							if (vm.dates[i] == ing_drop[j].date && id == ing_drop[j].id) {
								obj.amount += ing_drop[j].amount;
								obj.amount_dm += ing_drop[j].amount_dm;
								obj.cost += ing_drop[j].cost;
							}
						}

						if (obj.amount && obj.amount_dm) {
							obj.dm = (obj.amount_dm / obj.amount) * 100;
						}

						list.push(obj);
					}

					return list;
				}

				return ingredients;
			}

			function getTotalPenAmount(feedingDates) {
				var sum = 0;
				for (var i = 0; i < feedingDates.length; i++) {
					sum += feedingDates[i].amount;
				}

				return sum;
			}

			function getTotalPenAmountDm(feedingDates) {
				var sum = 0;
				for (var i = 0; i < feedingDates.length; i++) {
					sum += feedingDates[i].amount_dm;
				}

				return sum;
			}

			function getTotalPenCost(_pen) {
				var cost = 0;
				for (var i = 0; i < _pen.unloads.length; i++) {
					for (var j = 0; j < _pen.unloads[i].ingredients.length; j++) {
						cost += ((_pen.unloads[i].dropped_amount * _pen.unloads[i].ingredients[j].ingredient.percentage) / 100) * _pen.unloads[i].ingredients[j].ingredient.cost;
					}
				}
				return cost;
			}

			function getAllUsedPens(_response) {
				var list = [];
				_response.forEach(function (recipe) {
					recipe.loadSubjects.forEach(function (loadSubject) {
						loadSubject.pen_feedings.forEach(function (pen_feeding) {
							if (!isPresent(pen_feeding.pen, list)) {
								var pen = angular.copy(pen_feeding.pen);
								var penData = getAllUsedIngredientsData(pen.id, _response);
								pen.ingredients = penData.ingredients;
								pen.unloads = penData.unloads;
								pen.ingredientsDrop = penData.ingredientsDrop;
								list.push(pen);
							}
						});
					});
				});

				function getAllUsedIngredientsData(pen_id, __response) {
					var list = [];
					var unloads = [];
					var ingredientUnloadList = [];
					__response.forEach(function (recipe) {
						recipe.loadSubjects.forEach(function (loadSubject) {
							loadSubject.loads.forEach(function (load) {
								var isDroppedToPen = false;
								for (var i = 0; i < load.unloads.length; i++) {
									if (load.unloads[i].pen_id == pen_id) {
										isDroppedToPen = true;
										var unload = load.unloads[i];
										unload.ingredients = load.load_ingredients;
										unloads.push(unload);
										for (var l = 0; l < load.load_ingredients.length; l++) {
											var ingObj = {
												id: load.load_ingredients[l].ingredient.id,
												name: load.load_ingredients[l].ingredient.name,
												dm: load.load_ingredients[l].ingredient.dm,
												amount: (load.unloads[i].dropped_amount * ((load.load_ingredients[l].ingredient_actual_amount * 100) / load.actual_weight)) / 100,
												amount_dm: (((load.unloads[i].dropped_amount * ((load.load_ingredients[l].ingredient_actual_amount * 100) / load.actual_weight)) / 100) * load.load_ingredients[l].ingredient.dm) / 100,
												cost: ((load.unloads[i].dropped_amount * ((load.load_ingredients[l].ingredient_actual_amount * 100) / load.actual_weight)) / 100) * ((load.load_ingredients[l].ingredient.cost * load.load_ingredients[l].ingredient.dm) / 100),
												date: loadSubject.date
											};
											ingredientUnloadList.push(ingObj);
										}
									}
								}

								if (isDroppedToPen) {
									for (var j = 0; j < load.load_ingredients.length; j++) {
										if (!isPresent(load.load_ingredients[j].ingredient, list)) {
											list.push(load.load_ingredients[j].ingredient);
										}
									}
								}
							});
						});
					});
					return { ingredients: $filter('orderBy')(list, 'name'), unloads: unloads, ingredientsDrop: ingredientUnloadList };
				}

				return $filter('orderBy')(list, 'pen_name');
			}

			return pens;
		}

		function selectIngredient(ingredient) {
			if (ingredient.selected) {
				vm.selectedIngredients.push(ingredient);
			} else {
				for (var i = vm.selectedIngredients.length - 1; i >= 0; i--) {
					if (vm.selectedIngredients[i].id === ingredient.id) {
						vm.selectedIngredients.splice(i, 1);
					}
				}
			}
		}

		function isPresent(obj, _list) {
			var present = false;
			for (var i = 0; i < _list.length; i++) {
				if (_list[i].id == obj.id) {
					present = true;
					break;
				}
			}
			return present;
		}

		function createSummary() {
			var amount;
			var amount_dm;
			var dm;
			var cost;
			var datesArr = [];
			var summaryId = performance.now() * Math.random();
			for (var i = 0; i < vm.dates.length; i++) {
				amount = 0;
				amount_dm = 0;
				dm = 0;
				cost = 0;
				for (var j = 0; j < vm.selectedIngredients.length; j++) {
					vm.selectedIngredients[j].disabled = true;
					vm.selectedIngredients[j].summary_id = summaryId;
					for (var k = 0; k < vm.selectedIngredients[j].feeding_dates.length; k++) {
						if (moment(vm.dates[i]).isSame(vm.selectedIngredients[j].feeding_dates[k].date)) {
							if (vm.selectedIngredients[j].feeding_dates[k].amount) {
								amount += vm.selectedIngredients[j].feeding_dates[k].amount;
							}
							if (vm.selectedIngredients[j].feeding_dates[k].amount_dm) {
								amount_dm += vm.selectedIngredients[j].feeding_dates[k].amount_dm;
							}
							if (vm.selectedIngredients[j].feeding_dates[k].cost) {
								cost += vm.selectedIngredients[j].feeding_dates[k].cost;
							}
							if (amount && amount_dm) {
								dm = (amount_dm / amount) * 100;
							}
							break;
						}
					}
				}
				datesArr.push({
					amount: amount,
					amount_dm: amount_dm,
					dm: dm,
					cost: cost,
					date: vm.dates[i]
				});
			}
			vm.summary.push(new Summary(summaryId, datesArr, vm.selectedIngredients[0].ingredient_name));
			vm.selectedIngredients = [];

			function Summary(id, dates, name) {
				this.id = id;
				this.feeding_dates = dates;
				this.total_amount = getSummaryTotalAmount(this.feeding_dates);
				this.total_amount_dm = getSummaryTotalAmountDm(this.feeding_dates);
				this.total_cost = getSummaryTotalCost(this.feeding_dates);
				this.ingredient_name = name;
				this.dm = (this.total_amount_dm / this.total_amount) * 100;
				this.expanded = false;
			}

			function getSummaryTotalAmount(dates) {
				var amount = 0;
				for (var i = 0; i < dates.length; i++) {
					if (dates[i].amount) {
						amount += dates[i].amount;
					}
				}
				return amount;
			}

			function getSummaryTotalAmountDm(dates) {
				var amount_dm = 0;
				for (var i = 0; i < dates.length; i++) {
					if (dates[i].amount_dm) {
						amount_dm += dates[i].amount_dm;
					}
				}
				return amount_dm;
			}

			function getSummaryTotalCost(dates) {
				var cost = 0;
				for (var i = 0; i < dates.length; i++) {
					if (dates[i].cost) {
						cost += dates[i].cost;
					}
				}
				return cost;
			}
		}

		function deleteSummary(summary) {
			for (var i = vm.summary.length - 1; i >= 0; i--) {
				if (vm.summary[i].id === summary.id) {
					vm.summary.splice(i, 1);
					break;
				}
			}
			if (vm.showLoadDrop) {
				for (var j = 0; j < vm.pens.length; j++) {
					for (var k = 0; k < vm.pens[j].ingredients.length; k++) {
						if (vm.pens[j].ingredients[k].summary_id === summary.id) {
							vm.pens[j].ingredients[k].disabled = false;
							vm.pens[j].ingredients[k].summary_id = null;
							vm.selectedIngredients.push(vm.pens[j].ingredients[k]);
						}
					}
				}
			} else {
				for (var jj = 0; jj < vm.recipes.length; jj++) {
					for (var kk = 0; kk < vm.recipes[jj].ingredients.length; kk++) {
						if (vm.recipes[jj].ingredients[kk].summary_id === summary.id) {
							vm.recipes[jj].ingredients[kk].disabled = false;
							vm.recipes[jj].ingredients[kk].summary_id = null;
							vm.selectedIngredients.push(vm.recipes[jj].ingredients[kk]);
						}
					}
				}
			}
		}

		function checkSummaryButtonDisabled() {
			var countSelected = 0;
			var countDisabled = 0;
			if (vm.showLoadDrop) {
				for (var i = 0; i < vm.pens.length; i++) {
					for (var j = 0; j < vm.pens[i].ingredients.length; j++) {
						if (vm.pens[i].ingredients[j].selected) {
							countSelected++;
						}
						if (vm.pens[i].ingredients[j].disabled) {
							countDisabled++;
						}
					}
				}
			} else {
				for (var ii = 0; ii < vm.recipes.length; ii++) {
					for (var jj = 0; jj < vm.recipes[ii].ingredients.length; jj++) {
						if (vm.recipes[ii].ingredients[jj].selected) {
							countSelected++;
						}
						if (vm.recipes[ii].ingredients[jj].disabled) {
							countDisabled++;
						}
					}
				}
			}

			if (countSelected > countDisabled) {
				return false;
			}
			return true;
		}

		function checkSummaryTableDisplayed() {
			if (vm.showLoadDrop) {
				for (var i = 0; i < vm.pens.length; i++) {
					for (var j = 0; j < vm.pens[i].ingredients.length; j++) {
						if (vm.pens[i].ingredients[j].selected) {
							return true;
						}
					}
				}
			} else {
				for (var ii = 0; ii < vm.recipes.length; ii++) {
					for (var jj = 0; jj < vm.recipes[ii].ingredients.length; jj++) {
						if (vm.recipes[ii].ingredients[jj].selected) {
							return true;
						}
					}
				}
			}

			return false;
		}

		function getTableClass() {
			var cls = '';
			if (checkSummaryTableDisplayed() && !vm.showRobotData) {
				cls = 'summary';
			} else if (!checkSummaryTableDisplayed() && vm.showRobotData) {
				cls = 'robot';
			} else if (checkSummaryTableDisplayed() && vm.showRobotData) {
				cls = 'sumrob';
			}
			return cls;
		}

		function saveFilter() {
			vm.selectedRecipes = angular.copy(vm.modalSelectedRecipes);
			vm.loading = true;
			closeModal();
			setDates();
			getData();
			filterActiveValidation();
		}

		function closeModal() {
			vm.modalLoading = false;
			$uibModalStack.dismissAll();
		}

		function filterActiveValidation() {
			var start_date = moment(vm.predefinedStart).format('YYYY-MM-DD');
			var start_date_changed = moment(vm.startDate).format('YYYY-MM-DD');
			var end_date = moment(vm.predefinedEnd).format('YYYY-MM-DD');
			var end_date_changed = moment(vm.endDate).format('YYYY-MM-DD');
			if (vm.selectedRecipes.length > 0 || start_date != start_date_changed || end_date != end_date_changed) {
				vm.recipeFilterActive = true;
			} else {
				vm.recipeFilterActive = false;
			}
		}

		function openFilterModal() {
			vm.modalSelectedRecipes = angular.copy(vm.selectedRecipes);

			if (vm.recipeFilter.length === 0) {
				vm.modalLoading = true;
				getRecipeFilter();
			}
			openModal('app/pages/ingredientsManagement/ingredientUsageOverview/filter.modal.html', 'sm');

			function getRecipeFilter() {
				if (vm.selectedHerd) {
					var suffix = '?team=' + vm.selectedTeam + '&herd=' + vm.selectedHerd;
					return ingredientUsageOverviewService
						.getRecipeFilter(suffix)
						.then(function (response) {
							vm.modalLoading = false;
							vm.recipeFilter = response;
						})
						.catch(function (error) {
							vm.modalLoading = false;
							console.log(error);
							errorService.showErrorMessage(error, true, '_error_occurred_loading_recipes_');
						});
				}
			}
		}

		function showCostChanged() {
			vm.loading = true;
			$timeout(function () {
				vm.showCost = vm.toggleShowCost;
				vm.loading = false;
			}, 200);
		}

		function showLoadDropChanged() {
			vm.loading = true;
			$timeout(function () {
				vm.showLoadDrop = vm.toggleLoadDrop;
				handleResponse([vm.rawRecipesResponse, vm.rawMilkIntakeResponse, vm.rawFeedIntakeResponse]);
			}, 200);
		}

		function showRobotDataChanged() {
			vm.loading = true;
			getData();
		}

		function exportToXls() {
			var file_name = $filter('i18n')('_report_ingredients_usage_title_');
			var robot_data = vm.showRobotData && vm.hasRobotAccess;
			file_name += '.xlsx';
			var wb = XLSX.utils.book_new();

			if (vm.showLoadDrop) {
				var s1 = generateLoadingDropSheet(vm.pens, robot_data, 2);
				var s2 = generateDropPerDayPerPenSheet(vm.pens);
				var ws1 = XLSX.utils.aoa_to_sheet(s1);
				var ws2 = XLSX.utils.aoa_to_sheet(s2);
				var n = vm.dates.length + 2;
				var l = [];
				for (var i = 0; i < n; i++) {
					if (i == 0) {
						l.push({ wch: 20 });
					} else {
						l.push({ wch: 10 });
					}
				}
				ws1['!cols'] = l;
				ws2['!cols'] = [{ wch: 10 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 10 }];
				XLSX.utils.book_append_sheet(wb, ws1, 'Drop per pen');
				XLSX.utils.book_append_sheet(wb, ws2, 'Drop per day pen ingredient');
			} else {
				var s12 = generateLoadingDropSheet(vm.recipes, robot_data, 1);
				var ws12 = XLSX.utils.aoa_to_sheet(s12);
				var n1 = vm.dates.length + 2;
				var l1 = [];
				for (var j = 0; j < n1; j++) {
					if (j == 0) {
						l1.push({ wch: 20 });
					} else {
						l1.push({ wch: 10 });
					}
				}
				ws12['!cols'] = l1;
				XLSX.utils.book_append_sheet(wb, ws12, 'Drop per pen');
			}

			XLSX.writeFile(wb, file_name);
		}

		/*function saveAsFile(content, fileName) {
			var a = document.createElement('a');
			var isBlob = content.toString().indexOf('Blob') > -1;
			var url = content;
			if (isBlob) {
				url = window.URL.createObjectURL(content);
			}
			a.href = url;
			a.download = fileName;
			a.click();
			if (isBlob) {
				window.URL.revokeObjectURL(url);
			}
		}*/

		function generateLoadingDropSheet(data_list, include_robot_data, type) {
			var list = [];
			var header = generateHeader(type);
			list.push(header);
			var empty_row = generateEmptyRow();
			list.push(empty_row);

			for (var i = 0; i < data_list.length; i++) {
				var obj = generateData(data_list[i], type);
				list = list.concat(obj);
				list.push(empty_row);
			}

			if (checkSummaryTableDisplayed()) {
				var summary = generateSummaryData(vm.summary);
				list = list.concat(summary);
			}

			if (include_robot_data) {
				var robots = generateRobotsData(vm.feedIntake, vm.milkIntake);
				list = list.concat(robots);
			}

			return list;

			function generateHeader(type) {
				var h = [
					{
						v: type == 1 ? $filter('i18n')('_m_f_recipe_name_') : $filter('i18n')('_m_f_pen_name_'),
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					},
					{
						v: $filter('i18n')('_m_f_total_label_'),
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					}
				];

				for (var i = 0; i < vm.dates.length; i++) {
					h.push({
						v: $filter('date')(vm.dates[i], 'shortDate'),
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					});
				}

				return h;
			}

			function generateEmptyRow() {
				var r = [];
				for (var i = 0; i < vm.dates.length + 2; i++) {
					r.push({
						v: '',
						t: 's'
					});
				}

				return r;
			}

			function generateData(obj, type) {
				var p = [];

				var h = [
					{
						v: (type == 1 ? obj.recipe_name : obj.pen_name) + ' (' + vm.weight + ')',
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					},
					{
						v: unitConversionService.convertData(obj.total_amount, ['kgToLb', 'round:0']),
						t: 'n',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					}
				];

				obj.feeding_dates.forEach(function (date) {
					var d = {
						v: unitConversionService.convertData(date.amount, ['kgToLb', 'round:0']),
						t: 'n',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					};
					h.push(d);
				});

				p.push(h);

				obj.ingredients.forEach(function (ingredient) {
					p.push(empty_row);
					var ing = [
						{
							v: ingredient.ingredient_name + ' (' + vm.weight + ')',
							t: 's',
							s: { font: { bold: true } }
						},
						{
							v: unitConversionService.convertData(ingredient.total_amount, ['kgToLb', 'round:0']),
							t: 'n',
							s: { font: { bold: true } }
						}
					];

					var dm = [
						{
							v: i18nFilter('_feeds_dm_') + ' (%)',
							t: 's'
						},
						{
							v: unitConversionService.convertData(ingredient.dm, ['round:2']),
							t: 'n'
						}
					];

					var amount = [
						{
							v: i18nFilter('_feeds_amount_') + ' (' + vm.weight + ')',
							t: 's'
						},
						{
							v: unitConversionService.convertData(ingredient.total_amount_dm, ['kgToLb', 'round:0']),
							t: 'n'
						}
					];

					var cost = [
						{
							v: i18nFilter('_feeds_tab_cost_') + ' (' + vm.currency + ')',
							t: 's'
						},
						{
							v: unitConversionService.convertData(ingredient.total_cost, ['round:0']),
							t: 'n'
						}
					];

					ingredient.feeding_dates.forEach(function (date) {
						ing.push({
							v: unitConversionService.convertData(date.amount, ['kgToLb', 'round:0']),
							t: 'n',
							s: { font: { bold: true } }
						});

						dm.push({
							v: unitConversionService.convertData(date.dm, ['round:2']),
							t: 'n'
						});

						amount.push({
							v: unitConversionService.convertData(date.amount_dm, ['kgToLb', 'round:0']),
							t: 'n'
						});

						cost.push({
							v: unitConversionService.convertData(date.cost, ['round:0']),
							t: 'n'
						});
					});
					p.push(ing);
					p.push(dm);
					p.push(amount);
					if (vm.showCost) {
						p.push(cost);
					}
				});

				var ing_total = [
					{
						v: i18nFilter('_report_total_'),
						t: 's',
						s: { font: { bold: true } }
					}
				];

				var t_dm = [
					{
						v: i18nFilter('_feeds_dm_') + ' (%)',
						t: 's'
					},
					{
						v: unitConversionService.convertData(obj.dm, ['round:2']),
						t: 'n'
					}
				];

				var t_amount = [
					{
						v: i18nFilter('_feeds_amount_') + ' (' + vm.weight + ')',
						t: 's'
					},
					{
						v: unitConversionService.convertData(obj.total_amount_dm, ['kgToLb', 'round:0']),
						t: 'n'
					}
				];

				var t_cost = [
					{
						v: i18nFilter('_feeds_tab_cost_') + ' (' + vm.currency + ')',
						t: 's'
					},
					{
						v: unitConversionService.convertData(obj.total_cost, ['round:0']),
						t: 'n'
					}
				];

				var t_n_animals = [
					{
						v: i18nFilter('_m_f_pen_number_of_animals_') + ' (' + vm.currency + ')',
						t: 's'
					},
					{
						v: '',
						t: 's'
					}
				];

				obj.feeding_dates.forEach(function (date) {
					t_dm.push({
						v: unitConversionService.convertData(date.dm, ['round:2']),
						t: 'n'
					});

					t_amount.push({
						v: unitConversionService.convertData(date.amount_dm, ['kgToLb', 'round:0']),
						t: 'n'
					});

					t_cost.push({
						v: unitConversionService.convertData(date.cost, ['round:0']),
						t: 'n'
					});

					t_n_animals.push({
						v: date.n_animals,
						t: 'n'
					});
				});
				p.push(empty_row);
				p.push(ing_total);
				p.push(t_dm);
				p.push(t_amount);
				if (vm.showCost) {
					p.push(t_cost);
				}
				p.push(t_n_animals);

				return p;
			}

			function generateSummaryData(summaries) {
				var sum = [];
				var header = [
					{
						v: i18nFilter('_m_f_i_m_ingredient_name_'),
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					},
					{
						v: i18nFilter('_m_f_total_label_'),
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					}
				];

				vm.dates.forEach(function (date) {
					header.push({
						v: $filter('date')(date, 'shortDate'),
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					});
				});

				sum.push(header);
				summaries.forEach(function (summary) {
					var ing_h = [
						{
							v: summary.ingredient_name,
							t: 's',
							s: { font: { bold: true } }
						},
						{
							v: unitConversionService.convertData(summary.total_amount, ['kgToLb', 'round:0']),
							t: 'n',
							s: { font: { bold: true } }
						}
					];

					summary.feeding_dates.forEach(function (date) {
						ing_h.push({
							v: unitConversionService.convertData(date.amount, ['kgToLb', 'round:0']),
							t: 'n',
							s: { font: { bold: true } }
						});
					});

					var dm = [
						{
							v: i18nFilter('_feeds_dm_') + ' (%)',
							t: 's'
						},
						{
							v: unitConversionService.convertData(summary.dm, ['round:2']),
							t: 'n'
						}
					];

					var amount = [
						{
							v: i18nFilter('_feeds_amount_') + ' (' + vm.weight + ')',
							t: 's'
						},
						{
							v: unitConversionService.convertData(summary.total_amount_dm, ['kgToLb', 'round:0']),
							t: 'n'
						}
					];

					var cost = [
						{
							v: i18nFilter('_feeds_tab_cost_') + ' (' + vm.currency + ')',
							t: 's'
						},
						{
							v: unitConversionService.convertData(summary.total_cost, ['round:0']),
							t: 'n'
						}
					];

					summary.feeding_dates.forEach(function (date) {
						dm.push({
							v: unitConversionService.convertData(date.dm, ['round:2']),
							t: 'n'
						});

						amount.push({
							v: unitConversionService.convertData(date.amount_dm, ['kgToLb', 'round:0']),
							t: 'n'
						});

						cost.push({
							v: unitConversionService.convertData(date.cost, ['round:0']),
							t: 'n'
						});
					});

					sum.push(ing_h);
					sum.push(dm);
					sum.push(amount);
					if (vm.showCost) {
						sum.push(cost);
					}

					sum.push(empty_row);
				});

				return sum;
			}

			function generateRobotsData(feed_intake, milk_intake) {
				var robot_data = [];
				robot_data.push(empty_row);
				var concentrate_intake = [];
				var concentrate_leftovers = [];
				var milk_production = [];
				var ci_header = [
					{
						v: $filter('i18n')('_mf_ing_overview_robot_daily_feedings_label_'),
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					},
					{
						v: $filter('i18n')('_m_f_total_label_'),
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					}
				];

				var cl_header = [
					{
						v: $filter('i18n')('_m_f_ing_overview_robot_daily_leftovers_label_'),
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					},
					{
						v: $filter('i18n')('_m_f_total_label_'),
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					}
				];

				var ci_t = [
					{
						v: '',
						t: 's'
					},
					{
						v: unitConversionService.convertData(feed_intake.total_amount, ['kgToLb', 'round:0']) + vm.weight,
						t: 's'
					}
				];

				var cl_t = [
					{
						v: '',
						t: 's'
					},
					{
						v: unitConversionService.convertData(feed_intake.total_leftovers, ['kgToLb', 'round:0']) + vm.weight,
						t: 's'
					}
				];

				var ci_ing = [];
				var cl_ing = [];

				feed_intake.feeding_dates.forEach(function (feeding) {
					ci_t.push({
						v: unitConversionService.convertData(feeding.amount, ['kgToLb', 'round:0']) + vm.weight,
						t: 's'
					});

					cl_t.push({
						v: unitConversionService.convertData(feeding.leftovers, ['kgToLb', 'round:0']) + vm.weight,
						t: 's'
					});
				});

				feed_intake.ingredients.forEach(function (ing) {
					var ci_list = [];
					var cl_list = [];
					ci_list.push({
						v: ing.ingredient_name,
						t: 's'
					});

					ci_list.push({
						v: unitConversionService.convertData(ing.total_amount, ['kgToLb', 'round:0']) + vm.weight,
						t: 's'
					});

					cl_list.push({
						v: ing.ingredient_name,
						t: 's'
					});

					cl_list.push({
						v: unitConversionService.convertData(ing.total_leftovers, ['kgToLb', 'round:0']) + vm.weight,
						t: 's'
					});

					ing.feeding_dates.forEach(function (ing_date) {
						ci_list.push({
							v: unitConversionService.convertData(ing_date.amount, ['kgToLb', 'round:0']) + vm.weight,
							t: 's'
						});

						cl_list.push({
							v: unitConversionService.convertData(ing_date.leftovers, ['kgToLb', 'round:0']) + vm.weight,
							t: 's'
						});
					});

					ci_ing.push(ci_list);
					cl_ing.push(cl_list);
				});

				var mp_header = [
					{
						v: $filter('i18n')('_mf_ing_overview_robot_daily_milkings_label_'),
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					},
					{
						v: $filter('i18n')('_m_f_total_label_'),
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					}
				];

				var mp = [
					{
						v: '',
						t: 's'
					},
					{
						v: unitConversionService.convertData(milk_intake.total_amount, ['kgToLb', 'round:0']) + vm.weight,
						t: 's'
					}
				];

				var mp_n_animals = [
					{
						v: $filter('i18n')('_m_f_pen_number_of_animals_'),
						t: 's'
					},
					{
						v: '',
						t: 's'
					}
				];

				milk_intake.feeding_dates.forEach(function (date) {
					mp.push({
						v: unitConversionService.convertData(date.amount, ['kgToLb', 'round:0']) + vm.weight,
						t: 's'
					});

					mp_n_animals.push({
						v: date.n_animals,
						t: 'n'
					});
				});

				vm.dates.forEach(function (date) {
					var d = {
						v: $filter('date')(date, 'shortDate'),
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					};
					ci_header.push(d);
					cl_header.push(d);
					mp_header.push(d);
				});

				concentrate_intake.push(ci_header);
				concentrate_intake.push(ci_t);
				concentrate_intake = concentrate_intake.concat(ci_ing);
				concentrate_leftovers.push(empty_row);
				concentrate_leftovers.push(cl_header);
				concentrate_leftovers.push(cl_t);
				concentrate_leftovers = concentrate_leftovers.concat(cl_ing);
				milk_production.push(empty_row);
				milk_production.push(mp_header);
				milk_production.push(mp);
				milk_production.push(mp_n_animals);
				robot_data = robot_data.concat(concentrate_intake).concat(concentrate_leftovers).concat(milk_production);
				return robot_data;
			}
		}

		function generateDropPerDayPerPenSheet(pens) {
			var p = pens.filter(function (item) {
				return item.total_amount;
			});

			var list = [];
			var header = generateHeader();
			list.push(header);

			p.forEach(function (pen) {
				var p_data = generatePenData(pen);
				list = list.concat(p_data);
			});

			return list;

			function generateHeader() {
				var h = [
					{
						v: $filter('i18n')('_report_date_'),
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					},
					{
						v: $filter('i18n')('_m_f_pen_label_'),
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					},
					{
						v: $filter('i18n')('_report_ingredient_'),
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					},
					{
						v: $filter('i18n')('_report_unit_'),
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					},
					{
						v: $filter('i18n')('_report_value_'),
						t: 's',
						s: { font: { bold: true }, alignment: { horizontal: 'center' } }
					}
				];
				return h;
			}

			function generatePenData(pen) {
				var list = [];
				pen.ingredients.forEach(function (ingredient) {
					var ingredient_list = [];
					ingredient.feeding_dates.forEach(function (date) {
						var date_kg = [
							{
								v: $filter('date')(date.date, 'shortDate'),
								t: 's'
							},
							{
								v: pen.pen_name,
								t: 's'
							},
							{
								v: ingredient.ingredient_name,
								t: 's'
							},
							{
								v: vm.weight,
								t: 's'
							},
							{
								v: unitConversionService.convertData(date.amount, ['kgToLb', 'round:0']),
								t: 's'
							}
						];

						var date_dm = [
							{
								v: $filter('date')(date.date, 'shortDate'),
								t: 's'
							},
							{
								v: pen.pen_name,
								t: 's'
							},
							{
								v: ingredient.ingredient_name,
								t: 's'
							},
							{
								v: i18nFilter('_feeds_dm_') + ' (%)',
								t: 's'
							},
							{
								v: unitConversionService.convertData(date.dm, ['round:2']),
								t: 's'
							}
						];

						var date_kg_dm = [
							{
								v: $filter('date')(date.date, 'shortDate'),
								t: 's'
							},
							{
								v: pen.pen_name,
								t: 's'
							},
							{
								v: ingredient.ingredient_name,
								t: 's'
							},
							{
								v: i18nFilter('_feeds_amount_') + ' (' + vm.weight + ')',
								t: 's'
							},
							{
								v: unitConversionService.convertData(date.amount_dm, ['kgToLb', 'round:0']),
								t: 's'
							}
						];

						ingredient_list.push(date_kg);
						ingredient_list.push(date_dm);
						ingredient_list.push(date_kg_dm);
					});

					list = list.concat(ingredient_list);
				});

				return list;
			}
		}

		function exportToPdf() {
			openLoadingModal();

			$timeout(function () {
				if (vm.showLoadDrop) {
					createPdf(vm.pens, vm.summary, vm.feedIntake, vm.milkIntake);
				} else {
					createPdf(vm.recipes, vm.summary, vm.feedIntake, vm.milkIntake);
				}
			}, 50);
		}

		function createPdf(data, summary, feedIntake, milkIntake) {
			var dd = {
				header: [
					{
						alignment: 'justify',
						style: 'headerStyle',
						columns: [
							{
								image: vm.logo,
								width: 120,
								margin: [10, 10, 10, 0],
								border: [true, true, true, true]
							},
							{
								text: vm.currentHerdName ? vm.currentHerdName : '',
								margin: [10, 22, 10, 0],
								width: '*',
								alignment: 'center'
							},

							{
								text: $filter('date')(vm.startDate, 'shortDate') + ' - ' + $filter('date')(vm.endDate, 'shortDate'),
								margin: [10, 22, 20, 0],
								width: 140,
								alignment: 'right'
							}
						]
					}
				],
				pageMargins: [25, 50, 20, 0],
				pageSize: 'A4',
				pageOrientation: 'landscape',
				defaultStyle: {
					fontSize: 9
				},
				styles: {
					headerStyle: {
						fontSize: 10,
						bold: true
					},
					tableStyle: {
						margin: [0, 5, 0, 15]
					},
					noMargins: {
						margin: [0, 0, 0, 0]
					}
				},
				content: []
			};

			for (var r = 0; r < data.length; r++) {
				if (data[r].total_amount > 0) {
					var dataObj = data[r];

					dataObj = groupData(dataObj);
					if (dataObj && dataObj.feeding_dates_grouped && dataObj.feeding_dates_grouped.length) {
						for (var i = 0; i < dataObj.feeding_dates_grouped.length; i++) {
							var table = {
								style: 'tableStyle',
								headerRows: 2,
								table: {
									widths: [],
									body: []
								}
							};

							var table2 = {
								style: 'tableStyle',
								headerRows: 1,
								pageBreak: 'after',
								table: {
									widths: [],
									body: []
								}
							};

							var header = [];
							var row = [];
							var row2 = [];

							if (i == 0) {
								header.push({ text: (vm.showLoadDrop ? $filter('i18n')('_m_f_reports_pen_') : $filter('i18n')('_m_f_mixing_feeding_recipe_')) + '/' + $filter('i18n')('_report_ingredient_'), bold: true });
								header.push({ text: $filter('i18n')('_report_total_'), bold: true });
								row.push({ text: vm.showLoadDrop ? dataObj.pen_name + ' (' + vm.weight + ')' : dataObj.recipe_name + ' (' + vm.weight + ')', bold: true });
								row.push({
									text: unitConversionService.convertData(dataObj.total_amount, ['kgToLb', 'round:0'])
								});
								table.table.widths.push(100);
								table.table.widths.push(59);
							} else {
								table.table.widths.push(100);
								row.push({ text: vm.showLoadDrop ? dataObj.pen_name + ' (' + vm.weight + ')' : dataObj.recipe_name + ' (' + vm.weight + ')', bold: true });
								header.push({ text: $filter('i18n')('_m_f_mixing_feeding_recipe_') + '/' + $filter('i18n')('_report_ingredient_'), bold: true });
							}

							for (var j = 0; j < dataObj.feeding_dates_grouped[i].length; j++) {
								header.push({ text: $filter('date')(new Date(dataObj.feeding_dates_grouped[i][j].date), 'shortDate'), bold: true });
								row.push({ text: unitConversionService.convertData(dataObj.feeding_dates_grouped[i][j].amount, ['kgToLb', 'round:0']), bold: true });
								table.table.widths.push(59);
							}

							table.table.body.push(header);
							table.table.body.push(row);

							for (var ing = 0; ing < dataObj.ingredients.length; ing++) {
								var ingRow = [];
								if (i == 0) {
									ingRow.push(dataObj.ingredients[ing].ingredient_name + ' (' + vm.weight + ')');
									ingRow.push({ text: unitConversionService.convertData(dataObj.ingredients[ing].total_amount, ['kgToLb', 'round:0']) });
								} else {
									ingRow.push(dataObj.ingredients[ing].ingredient_name + ' (' + vm.weight + ')');
								}
								for (var k = 0; k < dataObj.ingredients[ing].feeding_dates_grouped[i].length; k++) {
									ingRow.push({ text: unitConversionService.convertData(dataObj.ingredients[ing].feeding_dates_grouped[i][k].amount, ['kgToLb', 'round:0']) });
								}

								table.table.body.push(ingRow);

								var dmRow = [];
								if (i == 0) {
									dmRow.push({ text: i18nFilter('_feeds_dm_') + ' (%)', italics: true });
									dmRow.push({ text: unitConversionService.convertData(dataObj.ingredients[ing].dm, ['round:0']), italics: true });
								} else {
									dmRow.push({ text: i18nFilter('_feeds_dm_') + ' (%)', italics: true });
								}
								for (var f = 0; f < dataObj.ingredients[ing].feeding_dates_grouped[i].length; f++) {
									dmRow.push({ text: unitConversionService.convertData(dataObj.ingredients[ing].feeding_dates_grouped[i][f].dm, ['round:0']), italics: true });
								}

								table.table.body.push(dmRow);

								var amountDmRow = [];
								if (i == 0) {
									amountDmRow.push({ text: i18nFilter('_feeds_amount_') + ' (' + vm.weight + ')', italics: true });
									amountDmRow.push({ text: unitConversionService.convertData(dataObj.ingredients[ing].total_amount_dm, ['kgToLb', 'round:0']), italics: true });
								} else {
									amountDmRow.push({ text: i18nFilter('_feeds_amount_') + ' (' + vm.weight + ')', italics: true });
								}
								for (var u = 0; u < dataObj.ingredients[ing].feeding_dates_grouped[i].length; u++) {
									amountDmRow.push({ text: unitConversionService.convertData(dataObj.ingredients[ing].feeding_dates_grouped[i][u].amount_dm, ['kgToLb', 'round:0']), italics: true });
								}

								table.table.body.push(amountDmRow);

								if (vm.showCost) {
									var costRow = [];
									if (i == 0) {
										costRow.push({ text: i18nFilter('_feeds_tab_cost_') + ' (' + vm.currency + ')', italics: true });
										costRow.push({ text: unitConversionService.convertData(dataObj.ingredients[ing].total_cost, ['round:0']), italics: true });
									} else {
										costRow.push({ text: i18nFilter('_feeds_tab_cost_') + ' (' + vm.currency + ')', italics: true });
									}
									for (var ff = 0; ff < dataObj.ingredients[ing].feeding_dates_grouped[i].length; ff++) {
										costRow.push({ text: unitConversionService.convertData(dataObj.ingredients[ing].feeding_dates_grouped[i][ff].cost, ['round:0']), italics: true });
									}

									table.table.body.push(costRow);
								}
							}

							var totalRow = [];
							if (i === 0) {
								table2.table.widths.push(100);
								table2.table.widths.push(59);
								totalRow.push({ text: i18nFilter('_report_total_'), colSpan: dataObj.feeding_dates_grouped[i].length + 2 });
								totalRow.push('');
							} else {
								table2.table.widths.push(100);
								totalRow.push({ text: i18nFilter('_report_total_'), colSpan: dataObj.feeding_dates_grouped[i].length + 1 });
							}
							for (var mdf = 0; mdf < dataObj.feeding_dates_grouped[i].length; mdf++) {
								table2.table.widths.push(59);
								totalRow.push('');
							}

							table2.table.body.push(totalRow);

							var recipeDmRow = [];
							if (i == 0) {
								recipeDmRow.push({ text: i18nFilter('_feeds_dm_') + ' (%)' });
								recipeDmRow.push({ text: unitConversionService.convertData(dataObj.dm, ['round:0']) });
							} else {
								recipeDmRow.push({ text: i18nFilter('_feeds_dm_') + ' (%)' });
							}
							for (var cc = 0; cc < dataObj.feeding_dates_grouped[i].length; cc++) {
								recipeDmRow.push({ text: unitConversionService.convertData(dataObj.feeding_dates_grouped[i][cc].dm, ['round:0']) });
							}

							table2.table.body.push(recipeDmRow);

							var recipeAmountDmRow = [];
							if (i == 0) {
								recipeAmountDmRow.push({ text: i18nFilter('_feeds_amount_') + ' (' + vm.weight + ')' });
								recipeAmountDmRow.push({ text: unitConversionService.convertData(dataObj.total_amount_dm, ['kgToLb', 'round:0']) });
							} else {
								recipeAmountDmRow.push({ text: i18nFilter('_feeds_amount_') + ' (' + vm.weight + ')' });
							}
							for (var uu = 0; uu < dataObj.feeding_dates_grouped[i].length; uu++) {
								recipeAmountDmRow.push({ text: unitConversionService.convertData(dataObj.feeding_dates_grouped[i][uu].amount_dm, ['kgToLb', 'round:0']) });
							}

							table2.table.body.push(recipeAmountDmRow);

							if (vm.showCost) {
								var recipeCostRow = [];
								if (i == 0) {
									recipeCostRow.push({ text: i18nFilter('_feeds_tab_cost_') + ' (' + vm.currency + ')' });
									recipeCostRow.push({ text: unitConversionService.convertData(dataObj.total_cost, ['round:0']) });
								} else {
									recipeCostRow.push({ text: i18nFilter('_feeds_tab_cost_') + ' (' + vm.currency + ')' });
								}
								for (var fff = 0; fff < dataObj.feeding_dates_grouped[i].length; fff++) {
									recipeCostRow.push({ text: unitConversionService.convertData(dataObj.feeding_dates_grouped[i][fff].cost, ['round:0']) });
								}

								table2.table.body.push(recipeCostRow);
							}

							if (vm.showLoadDrop) {
								if (i === 0) {
									row2.push({ text: $filter('i18n')('_m_f_pen_number_of_animals_') });
									row2.push({ text: '' });
								} else {
									row2.push({ text: $filter('i18n')('_m_f_pen_number_of_animals_') });
								}
								for (var n = 0; n < dataObj.feeding_dates_grouped[i].length; n++) {
									row2.push({
										text: dataObj.feeding_dates_grouped[i][n].n_animals
									});
								}

								table2.table.body.push(row2);
							}

							dd.content.push(table);
							dd.content.push(table2);
						}
					}
				}
			}

			if (summary && summary.length) {
				var headerData = groupData(summary[0]);
				if (headerData && headerData.feeding_dates_grouped && headerData.feeding_dates_grouped.length) {
					for (var h = 0; h < headerData.feeding_dates_grouped.length; h++) {
						var table = {
							style: 'tableStyle',
							headerRows: 2,
							table: {
								widths: [],
								body: []
							}
						};

						var header = [];
						if (h == 0) {
							header.push({ text: $filter('i18n')('_report_mix_ingredient_name_'), bold: true });
							header.push({ text: $filter('i18n')('_report_total_'), bold: true });
							table.table.widths.push(100);
							table.table.widths.push(59);
						} else {
							header.push({ text: $filter('i18n')('_report_mix_ingredient_name_'), bold: true });
							table.table.widths.push(100);
						}

						for (var hh = 0; hh < headerData.feeding_dates_grouped[h].length; hh++) {
							table.table.widths.push(59);
							header.push({ text: $filter('date')(new Date(headerData.feeding_dates_grouped[h][hh].date), 'shortDate'), bold: true });
						}

						table.table.body.push(header);
						for (var hing = 0; hing < summary.length; hing++) {
							var ingData = groupData(summary[hing]);
							var row = [];

							if (h == 0) {
								row.push({ text: ingData.ingredient_name });
								row.push({ text: unitConversionService.convertData(ingData.total_amount, ['kgToLb', 'round:0']) });
							} else {
								row.push({ text: ingData.ingredient_name });
							}

							for (var hingg = 0; hingg < ingData.feeding_dates_grouped[h].length; hingg++) {
								row.push({ text: unitConversionService.convertData(ingData.feeding_dates_grouped[h][hingg].amount, ['kgToLb', 'round:0']) });
							}
							table.table.body.push(row);

							var summaryDmRow = [];
							if (h == 0) {
								summaryDmRow.push({ text: i18nFilter('_feeds_dm_') + ' (%)' });
								summaryDmRow.push({ text: unitConversionService.convertData(ingData.dm, ['round:0']) });
							} else {
								summaryDmRow.push({ text: i18nFilter('_feeds_dm_') + ' (%)' });
							}
							for (var ccc = 0; ccc < ingData.feeding_dates_grouped[h].length; ccc++) {
								summaryDmRow.push({ text: unitConversionService.convertData(ingData.feeding_dates_grouped[h][ccc].dm, ['round:0']) });
							}

							table.table.body.push(summaryDmRow);

							var summaryAmountDmRow = [];
							if (h == 0) {
								summaryAmountDmRow.push({ text: i18nFilter('_feeds_amount_') + ' (' + vm.weight + ')' });
								summaryAmountDmRow.push({ text: unitConversionService.convertData(ingData.total_amount_dm, ['kgToLb', 'round:0']) });
							} else {
								summaryAmountDmRow.push({ text: i18nFilter('_feeds_amount_') + ' (' + vm.weight + ')' });
							}
							for (var uuu = 0; uuu < ingData.feeding_dates_grouped[h].length; uuu++) {
								summaryAmountDmRow.push({ text: unitConversionService.convertData(ingData.feeding_dates_grouped[h][uuu].amount_dm, ['kgToLb', 'round:0']) });
							}

							table.table.body.push(summaryAmountDmRow);

							if (vm.showCost) {
								var summaryCostRow = [];
								if (h == 0) {
									summaryCostRow.push({ text: i18nFilter('_feeds_tab_cost_') + ' (' + vm.currency + ')' });
									summaryCostRow.push({ text: unitConversionService.convertData(ingData.total_cost, ['round:0']) });
								} else {
									summaryCostRow.push({ text: i18nFilter('_feeds_tab_cost_') + ' (' + vm.currency + ')' });
								}
								for (var ffff = 0; ffff < ingData.feeding_dates_grouped[h].length; ffff++) {
									summaryCostRow.push({ text: unitConversionService.convertData(ingData.feeding_dates_grouped[h][ffff].cost, ['round:0']) });
								}

								table.table.body.push(summaryCostRow);
							}
						}
						dd.content.push(table);
					}
				}
			}

			if (vm.showRobotData && vm.hasRobotAccess) {
				if (feedIntake.total_amount) {
					var dataObj = groupData(feedIntake);
				}

				if (dataObj && dataObj.feeding_dates_grouped && dataObj.feeding_dates_grouped.length) {
					for (var i = 0; i < dataObj.feeding_dates_grouped.length; i++) {
						var table = {
							style: 'tableStyle',
							headerRows: 2,
							pageBreak: 'after',
							table: {
								widths: [],
								body: []
							}
						};

						var header = [];
						var row = [];

						if (i == 0) {
							header.push({ text: $filter('i18n')('_mf_ing_overview_robot_daily_feedings_label_'), bold: true });
							header.push({ text: $filter('i18n')('_report_total_'), bold: true });
							row.push({ text: vm.showLoadDrop ? dataObj.pen_name : dataObj.recipe_name, bold: true });
							row.push({
								text: unitConversionService.convertData(dataObj.total_amount, ['kgToLb', 'round:0']) + ' ' + vm.weight
							});
							table.table.widths.push(100);
							table.table.widths.push(59);
						} else {
							table.table.widths.push(100);
							row.push({ text: '', bold: true });
							header.push({ text: $filter('i18n')('_mf_ing_overview_robot_daily_feedings_label_'), bold: true });
						}

						for (var j = 0; j < dataObj.feeding_dates_grouped[i].length; j++) {
							header.push({ text: $filter('date')(new Date(dataObj.feeding_dates_grouped[i][j].date), 'shortDate'), bold: true });
							row.push({
								text: unitConversionService.convertData(dataObj.feeding_dates_grouped[i][j].amount, ['kgToLb', 'round:0']) + ' ' + vm.weight,
								bold: true
							});

							table.table.widths.push(59);
						}
						table.table.body.push(header);
						table.table.body.push(row);

						for (var ing = 0; ing < dataObj.ingredients.length; ing++) {
							var ingRow = [];
							if (i == 0) {
								ingRow.push(dataObj.ingredients[ing].ingredient_name);
								ingRow.push({
									text: unitConversionService.convertData(dataObj.ingredients[ing].total_amount, ['kgToLb', 'round:0']) + ' ' + vm.weight
								});
							} else {
								ingRow.push(dataObj.ingredients[ing].ingredient_name);
							}
							for (var k = 0; k < dataObj.ingredients[ing].feeding_dates_grouped[i].length; k++) {
								ingRow.push({
									text: unitConversionService.convertData(dataObj.ingredients[ing].feeding_dates_grouped[i][k].amount, ['kgToLb', 'round:0']) + ' ' + vm.weight
								});
							}

							table.table.body.push(ingRow);
						}

						dd.content.push(table);
					}
				}

				if (dataObj && dataObj.feeding_dates_grouped && dataObj.feeding_dates_grouped.length) {
					for (var i = 0; i < dataObj.feeding_dates_grouped.length; i++) {
						var table = {
							style: 'tableStyle',
							headerRows: 2,
							pageBreak: 'after',
							table: {
								widths: [],
								body: []
							}
						};

						var header = [];
						var row = [];

						if (i == 0) {
							header.push({ text: $filter('i18n')('_m_f_ing_overview_robot_daily_leftovers_label_'), bold: true });
							header.push({ text: $filter('i18n')('_report_total_'), bold: true });
							row.push({ text: vm.showLoadDrop ? dataObj.pen_name : dataObj.recipe_name, bold: true });
							row.push({
								text: unitConversionService.convertData(dataObj.total_leftovers, ['kgToLb', 'round:0']) + ' ' + vm.weight
							});
							table.table.widths.push(100);
							table.table.widths.push(59);
						} else {
							table.table.widths.push(100);
							row.push({ text: '', bold: true });
							header.push({ text: $filter('i18n')('_m_f_ing_overview_robot_daily_leftovers_label_'), bold: true });
						}

						for (var j = 0; j < dataObj.feeding_dates_grouped[i].length; j++) {
							header.push({ text: $filter('date')(new Date(dataObj.feeding_dates_grouped[i][j].date), 'shortDate'), bold: true });
							row.push({
								text: unitConversionService.convertData(dataObj.feeding_dates_grouped[i][j].leftovers, ['kgToLb', 'round:0']) + ' ' + vm.weight,
								bold: true
							});

							table.table.widths.push(59);
						}
						table.table.body.push(header);
						table.table.body.push(row);

						for (var ing = 0; ing < dataObj.ingredients.length; ing++) {
							var ingRow = [];
							if (i == 0) {
								ingRow.push(dataObj.ingredients[ing].ingredient_name);
								ingRow.push({
									text: unitConversionService.convertData(dataObj.ingredients[ing].total_leftovers, ['kgToLb', 'round:0']) + ' ' + vm.weight
								});
							} else {
								ingRow.push(dataObj.ingredients[ing].ingredient_name);
							}
							for (var k = 0; k < dataObj.ingredients[ing].feeding_dates_grouped[i].length; k++) {
								ingRow.push({
									text: unitConversionService.convertData(dataObj.ingredients[ing].feeding_dates_grouped[i][k].leftovers, ['kgToLb', 'round:0']) + ' ' + vm.weight
								});
							}

							table.table.body.push(ingRow);
						}

						dd.content.push(table);
					}
				}

				var milkObj = groupData(milkIntake);

				if (milkObj && milkObj.feeding_dates_grouped && milkObj.feeding_dates_grouped.length) {
					for (var i = 0; i < milkObj.feeding_dates_grouped.length; i++) {
						var table = {
							style: 'tableStyle',
							headerRows: 2,
							pageBreak: 'after',
							table: {
								widths: [],
								body: []
							}
						};

						var header = [];
						var row = [];
						var row2 = [];

						if (i == 0) {
							header.push({ text: $filter('i18n')('_mf_ing_overview_robot_daily_milkings_label_'), bold: true });
							header.push({ text: $filter('i18n')('_report_total_'), bold: true });
							row.push({ text: vm.showLoadDrop ? milkObj.pen_name : milkObj.recipe_name, bold: true });
							row.push({
								text: unitConversionService.convertData(milkObj.total_amount, ['kgToLb', 'round:0']) + ' ' + vm.weight
							});
							row2.push({ text: $filter('i18n')('_m_f_pen_number_of_animals_') });
							row2.push({ text: '' });
							table.table.widths.push(100);
							table.table.widths.push(59);
						} else {
							table.table.widths.push(100);
							row.push({ text: '', bold: true });
							row2.push({ text: '', bold: true });
							header.push({ text: $filter('i18n')('_mf_ing_overview_robot_daily_milkings_label_'), bold: true });
						}

						for (var j = 0; j < milkObj.feeding_dates_grouped[i].length; j++) {
							header.push({ text: $filter('date')(new Date(milkObj.feeding_dates_grouped[i][j].date), 'shortDate'), bold: true });
							row.push({
								text: unitConversionService.convertData(milkObj.feeding_dates_grouped[i][j].amount, ['kgToLb', 'round:0']) + ' ' + vm.weight,
								bold: true
							});
							row2.push({ text: milkObj.feeding_dates_grouped[i][j].n_animals });

							table.table.widths.push(59);
						}
						table.table.body.push(header);
						table.table.body.push(row);
						table.table.body.push(row2);

						dd.content.push(table);
					}
				}
			}

			if (dd.content.length && dd.content[dd.content.length - 1].pageBreak) {
				delete dd.content[dd.content.length - 1].pageBreak;
			}
			var file_name = $filter('i18n')('_report_ingredients_usage_title_') + '.pdf';
			pdfMake.createPdf(dd).download(file_name);

			$timeout(function () {
				dismissLoadingModal();
			}, 50);
		}

		function groupData(data) {
			var c = Math.floor((data.feeding_dates.length - 9) / 10);
			var l = (data.feeding_dates.length - 9) % 10;
			if (c < 0) {
				c = 0;
			} else {
				if (l) {
					c += 2;
				} else {
					c++;
				}
			}

			var list = [];
			if (c) {
				for (var i = 0; i < c; i++) {
					var last_index;
					if (i == 0) {
						list.push(data.feeding_dates.slice(0, 9));
						last_index = 9;
					} else if (i > 0 && i < c - 1) {
						list.push(data.feeding_dates.slice(last_index, last_index + 10));
						last_index += 10;
					} else {
						list.push(data.feeding_dates.slice(last_index));
					}
				}
			} else {
				list = [data.feeding_dates];
			}

			data.feeding_dates_grouped = list;
			if (data.ingredients) {
				for (var ing = 0; ing < data.ingredients.length; ing++) {
					var list = [];

					if (c) {
						for (var i = 0; i < c; i++) {
							var last_index;
							if (i == 0) {
								list.push(data.ingredients[ing].feeding_dates.slice(0, 9));
								last_index = 9;
							} else if (i > 0 && i < c - 1) {
								list.push(data.ingredients[ing].feeding_dates.slice(last_index, last_index + 10));
								last_index += 10;
							} else {
								list.push(data.ingredients[ing].feeding_dates.slice(last_index));
							}
						}
					} else {
						list = [data.ingredients[ing].feeding_dates];
					}

					data.ingredients[ing].feeding_dates_grouped = list;
				}
			}

			return data;
		}

		function toDataURL(url, callback) {
			var xhr = new XMLHttpRequest();
			xhr.onload = function () {
				var reader = new FileReader();
				reader.onloadend = function () {
					callback(reader.result);
				};
				reader.readAsDataURL(xhr.response);
			};
			xhr.open('GET', url);
			xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('id_token'));
			xhr.responseType = 'blob';
			xhr.send();
		}

		function openLoadingModal() {
			openModal('app/pages/ingredientsManagement/ingredientUsageOverview/loadingModal.html', 'sm');
		}

		function dismissLoadingModal() {
			$uibModalStack.dismissAll();
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		$scope.$watch('vm.toggleShowCost', function () {
			$cookies.put('ingredient_overview_show_cost', vm.toggleShowCost, {
				expires: moment().add(1, 'days').toDate()
			});
		});

		$scope.$watch('vm.toggleLoadDrop', function () {
			$cookies.put('ingredient_overview_toggle_load_drop', vm.toggleLoadDrop, {
				expires: moment().add(1, 'days').toDate()
			});
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_team_herd_changed', function () {
			init();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});

		editableOptions.theme = 'bs3';
		editableOptions.blurElem = 'cancel';
		editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
		editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.iManagement.ingredientUsageOverview').factory('ingredientUsageOverviewService', ingredientUsageOverviewService);
	/** @ngInject */
	function ingredientUsageOverviewService(APP_CONST, $http, $q) {
		return {
			getRecipes: getRecipes,
			getRecipeFilter: getRecipeFilter,
			getHerdsByTeam: getHerdsByTeam,
			getMilkIntakeData: getMilkIntakeData,
			getFeedIntakeData: getFeedIntakeData
		};

		function getRecipes(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'ingredientoverview' + suffix)
				.then(success)
				.catch(error);
		}

		function getRecipeFilter(suffix) {
			var request = {
				method: 'GET',
				url: APP_CONST.api_base_url + 'recipes' + suffix,
				headers: {
					Accept: 'application/mmmoooglefeed.allrecipes.v2+json'
				}
			};
			return $http(request).then(success).catch(error);
		}

		function getHerdsByTeam(id) {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams/' + id + '/herds')
				.then(success)
				.catch(error);
		}

		function getMilkIntakeData(herd_id, suffix) {
			return $http
				.get(APP_CONST.animals_base_url + 'herds/' + herd_id + '/dailymilkmeteryields' + suffix)
				.then(success)
				.catch(error);
		}

		function getFeedIntakeData(herd_id, suffix) {
			return $http
				.get(APP_CONST.animals_base_url + 'herds/' + herd_id + '/dailyfeedintakes' + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.iManagement.inventory').directive('closeIngPopover', closeIngPopover);

	/** @ngInject */
	function closeIngPopover($timeout, $window) {
		var timeoutResize;
		var timeoutScroll;
		var timeoutElem;
		return {
			restrict: 'A',
			scope: {
				closePopover: '&closePopover'
			},
			link: {
				pre: function (scope, elem) {
					angular.element($window).bind('resize', function () {
						if (timeoutResize) {
							$timeout.cancel(timeoutResize);
						}
						timeoutResize = $timeout(function () {
							scope.closePopover();
						}, 50);
					});

					angular.element($window).bind('scroll', function () {
						if (timeoutScroll) {
							$timeout.cancel(timeoutScroll);
						}
						timeoutScroll = $timeout(function () {
							scope.closePopover();
						}, 50);
					});

					angular.element(elem).bind('scroll', function () {
						if (timeoutElem) {
							$timeout.cancel(timeoutElem);
						}
						timeoutElem = $timeout(function () {
							scope.closePopover();
						}, 50);
					});
				}
			}
		};
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.iManagement.inventory').controller('inventoryCtrl', inventoryCtrl);
	/** @ngInject */
	function inventoryCtrl(APP_CONST, $filter, $uibModal, $uibModalStack, $scope, $timeout, $state, inventoryService, editableOptions, editableThemes, $cookies, unitConversionService, $window, errorService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var feedTypes = APP_CONST.constants.feed_types;
		vm.popoverOpen = [];
		vm.openLocation = openLocation;
		vm.redirect = redirect;
		vm.paginationChanged = paginationChanged;
		vm.deleteIngredient = deleteIngredient;
		vm.updateIngredient = updateIngredient;
		vm.goToIngredientHistory = goToIngredientHistory;
		vm.ingredientDetails = ingredientDetails;
		vm.editIngredient = editIngredient;
		vm.reloadApi = reloadApi;
		vm.proceedDelete = proceedDelete;
		vm.openRecipe = openRecipe;
		vm.closePopover = closePopover;
		vm.changeUnit = changeUnit;
		/*var drawingManager = new google.maps.drawing.DrawingManager({
			drawingControl: false,
			drawingControlOptions: {
				position: google.maps.ControlPosition.TOP_CENTER,
				drawingModes: ['polygon']
			},
			polygonOptions: {
				fillColor: '#FF4C4C',
				strokeColor: '#B23535',
				fillOpacity: 0.6,
				strokeWeight: 2,
				clickable: false,
				editable: false,
				zIndex: 1
			}
		});*/

		init();

		function init() {
			vm.ingredient_loading = false;
			vm.loading = true;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.ingredients = [];
			var cookie = $cookies.get('ingredient_use_kg');
			if (!vm.settings.use_kgs) {
				vm.weight = 'Lb';
			} else {
				vm.weight = 'Kg';
			}
			if (cookie && cookie == 'true') {
				vm.use_kg = true;
				vm.unit_icon = 'toggle_off';
			} else {
				vm.use_kg = false;
				vm.unit_icon = 'toggle_on';
			}
			if (vm.settings && vm.settings.selectedHerd.id) {
				vm.selectedTeam = vm.settings.selectedTeam.id;
				vm.selectedHerd = vm.settings.selectedHerd.id;
				vm.currentPage = 1;
				getIngredients(true);
			} else {
				vm.loading = false;
			}
		}

		function reloadApi() {
			vm.loading = true;
			if (vm.settings && vm.settings.selectedHerd.id) {
				vm.currentPage = 1;
				getIngredients(true);
			} else {
				vm.loading = false;
			}
		}

		function closePopover() {
			if (vm.popoverOpen && vm.popoverOpen.length > 0) {
				vm.popoverOpen = [];
			}
		}

		function getIngredients(init) {
			var suffix = '?page=' + vm.currentPage + '&team=' + vm.selectedTeam + '&herd=' + vm.selectedHerd;
			return inventoryService
				.getInventory(suffix)
				.then(function (response) {
					if (response.length > 0) {
						vm.totalItems = response[0].number_of_all;
						vm.ingredients = vm.ingredients.concat(processIngredients(response));
					} else {
						vm.totalItems = 0;
					}
					vm.loading = false;
					vm.loadingTable = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					vm.loadingTable = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_ingredient_', init);
				});
		}

		function changeUnit() {
			vm.use_kg = !vm.use_kg;
			var expireDate = new Date();
			expireDate.setDate(expireDate.getDate() + 1);
			if (vm.use_kg) {
				vm.unit_icon = 'toggle_off';
				$cookies.put('ingredient_use_kg', true, {
					expires: expireDate
				});
			} else {
				vm.unit_icon = 'toggle_on';
				$cookies.put('ingredient_use_kg', false, {
					expires: expireDate
				});
			}
			init();
		}

		function processIngredients(res) {
			var ingredients = angular.copy(res);
			for (var i = 0; i < ingredients.length; i++) {
				if (ingredients[i].location) {
					ingredients[i].location = JSON.parse(ingredients[i].location);
				}

				ingredients[i].ingredient_type = setFeedType(ingredients[i].ingredient_type);
				ingredients[i].current_quantity = convertAmount(ingredients[i].current_quantity);
				ingredients[i].original_quantity = convertAmount(ingredients[i].original_quantity);
				ingredients[i].daily_ingredient_amount_usage = convertAmount(ingredients[i].amount_usage_for_30_days / 30);

				if (ingredients[i].daily_ingredient_amount_usage > 0) {
					ingredients[i].usage_30 = convertAmount(ingredients[i].amount_usage_for_30_days);
					ingredients[i].usage_60 = convertAmount(ingredients[i].amount_usage_for_60_days);
					ingredients[i].usage_90 = convertAmount(ingredients[i].amount_usage_for_90_days);
					ingredients[i].days_until_empty = ingredients[i].current_quantity / ingredients[i].daily_ingredient_amount_usage;
				}

				ingredients[i].recipes = [];
			}

			function convertAmount(data) {
				if (!vm.settings.use_kgs) {
					if (!vm.use_kg) {
						data = unitConversionService.convertData(data, ['kgToImperialTon']);
					} else {
						data = unitConversionService.convertData(data, ['kgToLb']);
					}
				} else {
					if (!vm.use_kg) {
						data = unitConversionService.convertData(data, ['kgToMetricTon']);
					}
				}
				return data;
			}

			return ingredients;
		}

		function openRecipe(ingredient, index) {
			for (var i = 0; i < vm.ingredients.length; i++) {
				vm.popoverOpen.push(false);
			}
			vm.popoverOpen[index] = true;
			if (vm.ingredients[index].recipes.length > 0) {
				vm.popoverRecipes = vm.ingredients[index].recipes;
			} else {
				vm.popoverLoading = true;
				var suffix = ingredient.id + '?type=ingredient';
				if (vm.selectedHerd) {
					suffix += '&herd=' + vm.selectedHerd;
				}
				inventoryService
					.checkLinkedRecipes(suffix)
					.then(function (response) {
						vm.ingredients[index].recipes = vm.ingredients[index].recipes.concat(response);
						vm.popoverRecipes = vm.ingredients[index].recipes;
						vm.popoverLoading = false;
					})
					.catch(function (error) {
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_loading_recipes_');
						vm.popoverLoading = false;
					});
			}
		}

		function openLocation(ingredient) {
			vm.selectedIngredient = ingredient;
			openModal('app/pages/ingredientsManagement/inventory/location.modal.html', 'md');
			vm.locationError = false;
			$timeout(function () {
				initializeMap(ingredient);
			}, 200);
		}

		function paginationChanged() {
			vm.loadingTable = true;
			vm.currentPage++;
			getIngredients();
		}

		function deleteIngredient(index, data) {
			vm.deleteData = data;
			vm.deleteIndex = index;
			vm.warningMessage = '_ing_delete_warning_message_';
			openModal('app/pages/ingredientsManagement/inventory/confirmationDialog.modal.html', 'md');
		}

		function proceedDelete() {
			vm.modalLoading = true;
			vm.deleteData.ingredient_type = null;
			vm.deleteData.location = null;
			return inventoryService
				.deleteIngredient(vm.deleteData)
				.then(function () {
					vm.ingredients.splice(vm.deleteIndex, 1);
					vm.totalItems--;
					if (vm.ingredients.length === 0) {
						vm.currentPage = 1;
						getIngredients();
					}
					$uibModalStack.dismissAll();
					vm.modalLoading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.modalLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_deleting_ingredient_');
				});
		}

		function initializeMap(ingredient) {
			var latitude;
			var longitude;
			var zoom;
			var addMarkerToMap;
			var hasMarker;
			if (ingredient.lat && ingredient.lng) {
				addMarkerToMap = true;
				zoom = 16;
				hasMarker = true;
				latitude = Number(ingredient.lat);
				longitude = Number(ingredient.lng);
			} else {
				ingredient.lat = 43.8900745;
				ingredient.lng = 20.3492278;
				addMarkerToMap = false;
				zoom = 3;
				hasMarker = false;
			}
			var marker;
			var id = 'google-maps';
			var mapCanvas = document.getElementById(id);
			var geocoder = new google.maps.Geocoder();
			var mapOptions = {
				center: new google.maps.LatLng(ingredient.lat, ingredient.lng),
				zoom: zoom,
				mapTypeId: 'hybrid'
			};
			var map = new google.maps.Map(mapCanvas, mapOptions);
			var markerLatLng = {
				lat: latitude,
				lng: longitude
			};
			if (typeof markerLatLng.lat === 'number' && typeof markerLatLng.lng === 'number' && !isNaN(markerLatLng.lat) && !isNaN(markerLatLng.lng)) {
				placeMarker(markerLatLng, map);
			}

			function placeMarker(position, map) {
				marker = new google.maps.Marker({
					position: position,
					map: map,
					draggable: true
				});
				map.panTo(position);
				google.maps.event.addListener(marker, 'dragend', function () {
					geocodePosition(marker.getPosition());
				});

				function geocodePosition(pos) {
					ingredient.lat = pos.lat();
					ingredient.lng = pos.lng();
					geocoder.geocode(
						{
							latLng: pos
						},
						function (responses) {
							$timeout(function () {
								vm.selectedIngredient.address = responses[0].formatted_address;
							}, 0);
						}
					);
				}
			}
			drawingManager.setMap(map);
			if (!addMarkerToMap) {
				map.addListener('click', function (e) {
					if (!hasMarker) {
						placeMarker(e.latLng, map);
						hasMarker = true;
					}
				});
			}
		}

		function updateIngredient(data, ingredient, index, prop) {
			vm.ingredient_loading = true;
			vm.ingredients[index].loading = true;
			var ing = angular.copy(ingredient);

			if (prop === 'q') {
				ing.original_quantity = data;
			} else if (prop === 'dm') {
				ing.dm = data;
			}

			if (!vm.settings.use_kgs) {
				if (!vm.use_kg) {
					ing.original_quantity = unitConversionService.convertData(ing.original_quantity, ['imperialTonToKg']);
				} else {
					ing.original_quantity = unitConversionService.convertData(ing.original_quantity, ['lbToKg']);
				}
			} else {
				if (!vm.use_kg) {
					ing.original_quantity = unitConversionService.convertData(ing.original_quantity, ['metricTonToKg']);
				}
			}

			ing.current_quantity = ing.original_quantity;
			ing.quantity_date = $filter('date')(new Date(), 'yyyy-MM-dd');
			ing.last_modified_user = vm.user.email;
			ing.ingredient_type = ing.ingredient_type.value;
			ing.location_changed = false;
			if (ing.location) {
				ing.location = JSON.stringify(ing.location);
			}
			return inventoryService
				.updateIngredient(ing)
				.then(function (response) {
					response = processIngredients([ing]);
					vm.ingredients[index] = response[0];
					vm.ingredient_loading = false;
					vm.ingredients[index].loading = false;
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_updating_ingredient_');
					vm.ingredient_loading = false;
					vm.ingredients[index].loading = false;
				});
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function redirect(state) {
			$state.go(state);
		}

		function setFeedType(feedType) {
			var obj;
			for (var i = 0; i < feedTypes.length; i++) {
				if (feedTypes[i].value === feedType) {
					obj = feedTypes[i];
					var tString = '_feeds_type_' + obj.value + '_';
					obj.name = i18nFilter(tString);
					break;
				}
			}
			return obj;
		}

		function goToIngredientHistory(ingredient) {
			$state.go('iManagement.ingredientHistory', {
				uuid: ingredient.id
			});
		}

		function ingredientDetails(ingredient) {
			$state.go('iManagement.ingredientDetails', {
				uuid: ingredient.id
			});
		}

		function editIngredient(ingredient) {
			$state.go('iManagement.editIngredient', {
				uuid: ingredient.id
			});
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_team_herd_changed', function () {
			vm.selectedHerd = null;
			init();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});

		$scope.$on('$destroy', function () {
			angular.element($window).unbind('resize');
			angular.element($window).unbind('scroll');
		});

		editableOptions.theme = 'bs3';
		editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
		editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.iManagement.inventory').factory('inventoryService', inventoryService);
	/** @ngInject */
	function inventoryService(APP_CONST, $http, $q) {
		return {
			getInventory: getInventory,
			deleteIngredient: deleteIngredient,
			updateIngredient: updateIngredient,
			checkLinkedRecipes: checkLinkedRecipes
		};

		function getInventory(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'ingredients' + suffix)
				.then(success)
				.catch(error);
		}

		function deleteIngredient(ingredients) {
			return $http
				.put(APP_CONST.api_base_url + 'ingredients/remove', ingredients)
				.then(success)
				.catch(error);
		}

		function updateIngredient(ingredient) {
			return $http
				.put(APP_CONST.api_base_url + 'ingredients/update', ingredient)
				.then(success)
				.catch(error);
		}

		function checkLinkedRecipes(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'linkedrecipes/' + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.iManagement.overview').controller('overviewCtrl', overviewCtrl);
	/** @ngInject */
	function overviewCtrl(APP_CONST, $filter, editableOptions, editableThemes, $uibModal, $uibModalStack, $scope, $timeout, iManagementOverviewService, $q, $cookies, errorService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var listener;
		var feedTypes = APP_CONST.constants.feed_types;
		vm.selectLayout = selectLayout;
		vm.costChanged = costChanged;
		vm.openLocation = openLocation;
		vm.removeSelection = removeSelection;
		vm.saveLocation = saveLocation;
		vm.paginationChanged = paginationChanged;
		vm.reloadApi = reloadApi;
		/*var drawingManager = new google.maps.drawing.DrawingManager({
			drawingControl: false,
			drawingControlOptions: {
				position: google.maps.ControlPosition.TOP_CENTER,
				drawingModes: ['polygon']
			},
			polygonOptions: {
				fillColor: '#FF4C4C',
				strokeColor: '#B23535',
				fillOpacity: 0.6,
				strokeWeight: 2,
				clickable: false,
				editable: false,
				zIndex: 1
			}
		});*/
		vm.firstInit = true;
		init();

		function init() {
			setCurrentLayout();
			vm.checkInit = false;
			vm.loading = true;
			vm.ingredients = [];
			vm.default_values = JSON.parse(localStorage.getItem('user_settings'));
			if (vm.default_values && vm.default_values.selectedHerd.id) {
				vm.selectedTeam = vm.default_values.selectedTeam.id;
				vm.selectedHerd = vm.default_values.selectedHerd.id;
				vm.currentPage = 1;
				getIngredients(true);
			} else {
				vm.loading = false;
			}
		}

		function reloadApi() {
			vm.checkInit = false;
			vm.loading = true;
			if (vm.default_values && vm.default_values.selectedHerd.id) {
				vm.currentPage = 1;
				getIngredients(true);
			} else {
				vm.loading = false;
			}
		}

		function setCurrentLayout() {
			var data = $cookies.get('overview_layout');
			if (data) {
				vm.selectedLayout = data;
			} else {
				vm.selectedLayout = 1;
				$cookies.put('overview_layout', 1);
			}
		}

		function getIngredients(init) {
			var suffix = '?page=' + vm.currentPage + '&team=' + vm.selectedTeam + '&herd=' + vm.selectedHerd;
			return iManagementOverviewService
				.getInventory(suffix)
				.then(function (response) {
					if (response.length > 0) {
						vm.totalItems = response[0].number_of_all;
					} else {
						vm.totalItems = 0;
					}
					vm.ingredients = vm.ingredients.concat(processIngredients(response));
					vm.loading = false;
					vm.loadingTable = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					vm.loadingTable = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_ingredient_', init);
				});
		}

		function processIngredients(ingredients) {
			for (var i = 0; i < ingredients.length; i++) {
				ingredients[i].dm = round(ingredients[i].dm, 2);
				ingredients[i].cost = round(ingredients[i].cost * 1000, 2);
				ingredients[i].cost_as_fed = round((ingredients[i].cost * 100) / ingredients[i].dm, 2);

				if (ingredients[i].ingredient && ingredients[i].ingredient.location) {
					ingredients[i].ingredient.location = JSON.parse(ingredients[i].ingredient.location);
				}
				ingredients[i].feed_type = setFeedType(ingredients[i].feed_type);
			}
			return ingredients;
		}

		function setFeedType(feedType) {
			var obj;
			for (var i = 0; i < feedTypes.length; i++) {
				if (feedTypes[i].name.toLowerCase() === feedType.toLowerCase()) {
					obj = feedTypes[i];
					obj.original_name = obj.name;
					var tString = '_feeds_type_' + obj.value + '_';
					obj.name = i18nFilter(tString);

					break;
				}
			}
			return obj;
		}

		function paginationChanged() {
			vm.loadingTable = true;
			vm.currentPage++;
			getIngredients();
		}

		function initialize(ingredient) {
			var latitude;
			var longitude;
			var zoom;
			var marker;
			if (ingredient.lat && ingredient.lng) {
				latitude = Number(ingredient.lat);
				longitude = Number(ingredient.lng);
				zoom = 16;
			} else {
				latitude = 43.8900745;
				longitude = 20.3492278;
				zoom = 3;
			}
			var id = 'google-maps';
			var geocoder = new google.maps.Geocoder();
			var mapCanvas = document.getElementById(id);
			var mapOptions = {
				center: new google.maps.LatLng(ingredient.lat, ingredient.lng),
				zoom: zoom,
				mapTypeId: 'hybrid'
			};
			var input = document.getElementById('ingredient_address');
			var searchBox = new google.maps.places.SearchBox(input);
			searchBox.addListener('places_changed', function () {
				$timeout(function () {
					vm.locationChanged = true;
				}, 0);
				var places = searchBox.getPlaces();
				if (places.length === 0) {
					return;
				}
				// Clear out the old markers.
				try {
					marker.setMap(null);
				} catch (error) {
					console.log(error);
				}
				// For each place, get the icon, name and location.
				var bounds = new google.maps.LatLngBounds();
				places.forEach(function (place) {
					if (!place.geometry) {
						return;
					} else {
						vm.selectedIngredient.ingredient.address = place.formatted_address;
						var latlng = {
							lat: place.geometry.location.lat(),
							lng: place.geometry.location.lng()
						};
						placeMarker(latlng, map, false);
					}
					// Create a marker for each place.
					if (place.geometry.viewport) {
						// Only geocodes have viewport.
						bounds.union(place.geometry.viewport);
					} else {
						bounds.extend(place.geometry.location);
					}
				});
				map.fitBounds(bounds);
			});
			var map = new google.maps.Map(mapCanvas, mapOptions);
			var latLng = {
				lat: latitude,
				lng: longitude
			};
			drawingManager.setMap(map);
			if (listener) {
				google.maps.event.removeListener(listener);
			}
			listener = google.maps.event.addListener(drawingManager, 'polygoncomplete', function (polygon) {
				vm.locationChanged = true;
				drawingManager.setOptions({
					drawingControl: false
				});
				drawingManager.setDrawingMode(null);
				var arr = polygon.getPath().getArray();
				var coordinates = [];
				for (var i = 0; i < arr.length; i++) {
					var coordinate = {
						lat: arr[i].lat(),
						lng: arr[i].lng()
					};
					coordinates.push(coordinate);
				}
				if (coordinates.length > 6) {
					if (ingredient.lat && ingredient.lng) {
						initialize(vm.selectedIngredient.ingredient);
					} else {
						initialize();
					}
					vm.locationSelected = false;
					vm.selectedIngredient.ingredient.location = null;
					drawingManager.setOptions({
						drawingControl: true
					});
				} else {
					$timeout(function () {
						vm.locationSelected = true;
					}, 0);
					vm.selectedIngredient.ingredient.location = coordinates;
				}
			});
			if (typeof latLng.lat === 'number' && typeof latLng.lng === 'number' && !isNaN(latLng.lat) && !isNaN(latLng.lng)) {
				placeMarker(latLng, map, false);
			}
			if (vm.firstInit && ingredient.location) {
				vm.firstInit = false;
				var pen = new google.maps.Polygon({
					paths: ingredient.location,
					strokeColor: '#FF0000',
					strokeOpacity: 0.8,
					strokeWeight: 2,
					fillColor: '#FF0000',
					fillOpacity: 0.35
				});
				pen.setMap(map);
			} else {
				vm.locationChanged = true;
			}
			function placeMarker(position, map, onClick) {
				marker = new google.maps.Marker({
					position: position,
					map: map,
					draggable: true
				});
				map.panTo(position);
				if (onClick) {
					geocodePosition(marker.getPosition());
				}
				google.maps.event.addListener(marker, 'dragend', function (event) {
					vm.locationChanged = true;
					vm.selectedIngredient.ingredient.lat = event.latLng.lat();
					vm.selectedIngredient.ingredient.lng = event.latLng.lng();
					geocodePosition(marker.getPosition());
				});

				function geocodePosition(pos) {
					geocoder.geocode(
						{
							latLng: pos
						},
						function (responses) {
							$timeout(function () {
								vm.selectedIngredient.ingredient.address = responses[0].formatted_address;
							}, 0);
						}
					);
				}
			}
		}

		function removeSelection() {
			vm.locationSelected = false;
			initialize(vm.selectedIngredient.ingredient);
			drawingManager.setOptions({
				drawingControl: true
			});
		}

		function costChanged(value, type, ingredient, index) {
			var orgCost = angular.copy(ingredient.cost);
			var orgAsFed = angular.copy(ingredient.cost_as_fed);
			var orgDm = angular.copy(ingredient.dm);
			var d = $q.defer();
			var ing = angular.copy(vm.ingredients[index]);
			var costAsFed;
			if (type === 'as_fed') {
				var cost = (value * ingredient.dm) / 100;
				vm.ingredients[index].cost = round(cost, 2);
				ing.cost_as_fed = value;
				ing.cost = round(cost, 2);
			} else if (type === 'cost') {
				costAsFed = (value * 100) / ingredient.dm;
				vm.ingredients[index].cost_as_fed = round(costAsFed, 2);
				ing.cost = value;
				ing.cost_as_fed = round(costAsFed, 2);
			} else if (type === 'dm') {
				costAsFed = (ingredient.cost * 100) / value;
				vm.ingredients[index].cost_as_fed = round(costAsFed, 2);
				ing.dm = value;
				ing.cost_as_fed = round(costAsFed, 2);
			}
			ing.cost = ing.cost / 1000;
			ing.cost_as_fed = ing.cost_as_fed / 1000;
			ing.feed_type = ing.feed_type.original_name;
			if (ing.ingredient && ing.ingredient.location) {
				ing.ingredient.location = JSON.stringify(ing.ingredient.location);
			}
			iManagementOverviewService
				.updateRecipeFeed(ing)
				.then(function () {
					d.resolve();
				})
				.catch(function (error) {
					d.reject();
					vm.ingredients[index].cost = orgCost;
					vm.ingredients[index].cost_as_fed = orgAsFed;
					vm.ingredients[index].dm = orgDm;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_changing_cost_');
				});
			return d.promise;
		}

		function openModal(page, size) {
			$uibModal
				.open({
					animation: true,
					templateUrl: page,
					size: size,
					scope: $scope
				})
				.closed.then(function () {
					vm.firstInit = true;
					vm.locationSelected = true;
				});
		}

		function openLocation(ingredient) {
			vm.modalLoading = false;
			vm.selectedIngredient = angular.copy(ingredient);
			try {
				if (ingredient.ingredient.location) {
					vm.locationSelected = true;
				} else {
					drawingManager.setOptions({
						drawingControl: true
					});
					vm.locationSelected = false;
				}
			} catch (error) {
				if (ingredient) {
					vm.locationSelected = true;
				}
			}
			vm.locationChanged = false;
			openModal('app/pages/ingredientsManagement/overview/location.modal.html', 'lg');
			$timeout(function () {
				try {
					initialize(ingredient.ingredient);
				} catch (error) {
					initialize(ingredient);
				}
			}, 120);
		}

		function selectLayout(type) {
			vm.selectedLayout = type;
			$cookies.put('overview_layout', vm.selectedLayout);
		}

		function saveLocation() {
			if (vm.updateLocationForm.$valid) {
				vm.modalLoading = true;
				vm.selectedIngredient.ingredient.location_changed = true;
				if (vm.selectedIngredient.ingredient.location) {
					vm.selectedIngredient.ingredient.location = JSON.stringify(vm.selectedIngredient.ingredient.location);
				}
				return iManagementOverviewService
					.updateIngredient(vm.selectedIngredient.ingredient)
					.then(function (response) {
						if (response.location) {
							response.location = JSON.parse(response.location);
						}
						for (var i = 0; i < vm.ingredients.length; i++) {
							if (vm.ingredients[i].ingredient && vm.ingredients[i].ingredient.id === response.id) {
								vm.ingredients[i].ingredient = response;
								break;
							}
						}
						$uibModalStack.dismissAll();
						vm.modalLoading = false;
					})
					.catch(function (error) {
						console.log(error);
						vm.modalLoading = false;
						$timeout(function () {
							initialize(vm.selectedIngredient.ingredient);
						}, 200);
						errorService.showErrorMessage(error, true, '_error_occurred_saving_location_');
					});
			}
		}

		function round(value, decimals) {
			if (value && !isNaN(value)) {
				return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
			} else {
				return 0;
			}
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_team_selected', function () {
			vm.selectedHerd = null;
			init();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});

		editableOptions.theme = 'bs3';
		editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
		editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.iManagement.overview').factory('iManagementOverviewService', iManagementOverviewService);
	/** @ngInject */
	function iManagementOverviewService(APP_CONST, $http, $q) {
		return {
			getInventory: getInventory,
			deleteIngredient: deleteIngredient,
			updateIngredient: updateIngredient,
			updateRecipeFeed: updateRecipeFeed
		};

		function getInventory(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'ingredients/overview' + suffix)
				.then(success)
				.catch(error);
		}

		function deleteIngredient(ingredients) {
			return $http
				.put(APP_CONST.api_base_url + 'ingredients/remove', ingredients)
				.then(success)
				.catch(error);
		}

		function updateIngredient(ingredient) {
			return $http
				.put(APP_CONST.api_base_url + 'ingredients/update', ingredient)
				.then(success)
				.catch(error);
		}

		function updateRecipeFeed(feed) {
			return $http
				.put(APP_CONST.api_base_url + 'rationfeedtmr', feed)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.mixerWagons.addNewWagon').controller('addNewWagonCtrl', addNewWagonCtrl);
	/** @ngInject */
	function addNewWagonCtrl($state, $timeout, $filter, $scope, toastr, Upload, APP_CONST, unitConversionService, errorService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		vm.saveWagon = saveWagon;
		vm.openFileSystem = openFileSystem;
		vm.removeImage = removeImage;
		vm.uploadChanged = uploadChanged;
		vm.imageUrlChanged = imageUrlChanged;
		vm.reloadApi = reloadApi;
		vm.cancel = cancel;
		init();

		function init() {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			if (vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd.id;
			} else {
				vm.selectedHerd = null;
			}
		}

		function reloadApi() {
			if (vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd.id;
			} else {
				vm.selectedHerd = null;
			}
		}

		function saveWagon() {
			if (vm.addNewWagonForm.$valid) {
				var wagonDTO = angular.copy(vm.wagon);
				vm.loading = true;
				wagonDTO.team_id = vm.settings.selectedTeam.id;
				wagonDTO.herd_id = vm.settings.selectedHerd.id;
				wagonDTO.last_modified_user = vm.user.email;
				if (!wagonDTO.volume) {
					wagonDTO.volume = 0;
				}
				wagonDTO.weight = unitConversionService.convertData(wagonDTO.weight, ['imperialTonToMetricTon']);
				var urlSuffix = '?team_id=' + vm.settings.selectedTeam.id + '&herd_id=' + vm.settings.selectedHerd.id + '&last_modified_user=' + vm.user.email + '&name=' + wagonDTO.name + '&volume=' + wagonDTO.volume + '&weight=' + wagonDTO.weight;
				if (wagonDTO.mac_address) {
					urlSuffix = urlSuffix + '&mac_address=' + encodeURIComponent(wagonDTO.mac_address);
				}
				if (!vm.file && wagonDTO.image_url) {
					urlSuffix += '&image_url=' + wagonDTO.image_url;
				}
				Upload.upload({
					url: APP_CONST.api_base_url + 'mixerwagon' + urlSuffix,
					data: {
						file: vm.file
					}
				})
					.then(function () {
						$state.go('mixerWagons.myWagons');
						toastr.success(i18nFilter('_toastr_add_wagon_'), i18nFilter('_toastr_success_title_'));
					})
					.catch(function (error) {
						console.log(error);
						vm.loading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_saving_wagon_');
					});
			}
		}

		function uploadChanged() {
			$timeout(function () {
				vm.showRemoveImageButton = true;
			}, 500);
		}

		function openFileSystem() {
			document.getElementById('up_button').click();
		}

		function cancel() {
			$state.go('mixerWagons.myWagons');
		}

		function removeImage() {
			vm.file = null;
			vm.showRemoveImageButton = false;
		}

		function imageUrlChanged() {
			if (vm.wagon.image_url && vm.wagon.image_url.length > 0) {
				vm.hideUploadButton = true;
			} else {
				vm.hideUploadButton = false;
			}
		}

		$scope.$on('default_herd_selected', function () {
			init();
		});

		$scope.$on('default_team_herd_changed', function () {
			vm.selectedHerd = null;
			init();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.mixerWagons.addNewWagon').factory('addNewWagonService', addNewWagonService);
	/** @ngInject */
	function addNewWagonService(APP_CONST, $http, $q) {
		return {
			addNewWagon: addNewWagon
		};

		function addNewWagon(wagon) {
			return $http
				.post(APP_CONST.api_base_url + 'mixerwagon', wagon)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.mixerWagons.editWagon').controller('editWagonCtrl', editWagonCtrl);
	/** @ngInject */
	function editWagonCtrl(editWagonService, $scope, $filter, toastr, $stateParams, $timeout, Upload, APP_CONST, $state, errorService, unitConversionService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		vm.saveWagon = saveWagon;
		vm.openFileSystem = openFileSystem;
		vm.removeImage = removeImage;
		vm.uploadChanged = uploadChanged;
		vm.imageUrlChanged = imageUrlChanged;
		vm.reloadApi = reloadApi;
		vm.cancel = cancel;
		init();

		function init() {
			vm.loading = true;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.wagon_id = $stateParams.uuid;
			if (vm.settings && vm.settings.selectedTeam.id && vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd.id;
				getWagonById();
			} else {
				vm.selectedHerd = null;
				vm.loading = false;
			}
		}

		function reloadApi() {
			vm.loading = true;
			if (vm.settings && vm.settings.selectedTeam.id && vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd.id;
				getWagonById();
			} else {
				vm.selectedHerd = null;
				vm.loading = false;
			}
		}

		function getWagonById() {
			var suffix = '/' + vm.wagon_id + '?team=' + vm.settings.selectedTeam.id + '&herd=' + vm.settings.selectedHerd.id;
			return editWagonService
				.getWagonById(suffix)
				.then(function (response) {
					if (response.image_url) {
						vm.showRemoveImageButton = true;
						vm.hideUrlInput = true;
					}
					response.weight = unitConversionService.convertData(response.weight, ['metricTonToImperialTon']);
					vm.wagon = response;
					vm.loading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_wagon_', true);
				});
		}

		function saveWagon() {
			if (vm.addNewWagonForm.$valid) {
				var wagonDTO = angular.copy(vm.wagon);
				vm.loading = true;
				wagonDTO.team_id = vm.settings.selectedTeam.id;
				wagonDTO.herd_id = vm.settings.selectedHerd.id;
				wagonDTO.last_modified_user = vm.user.email;
				if (!wagonDTO.volume) {
					wagonDTO.volume = 0;
				}
				wagonDTO.weight = unitConversionService.convertData(wagonDTO.weight, ['imperialTonToMetricTon']);
				var urlSuffix = '?id=' + wagonDTO.id + '&team_id=' + vm.settings.selectedTeam.id + '&herd_id=' + vm.settings.selectedHerd.id + '&last_modified_user=' + vm.user.email + '&name=' + wagonDTO.name + '&volume=' + wagonDTO.volume + '&weight=' + wagonDTO.weight;
				if (wagonDTO.mac_address) {
					urlSuffix = urlSuffix + '&mac_address=' + encodeURIComponent(wagonDTO.mac_address);
				}
				if (!vm.file && wagonDTO.image_url) {
					urlSuffix += '&image_url=' + wagonDTO.image_url;
				}
				Upload.upload({
					url: APP_CONST.api_base_url + 'mixerwagon' + urlSuffix,
					method: 'PUT',
					data: {
						file: vm.file
					}
				})
					.then(function () {
						$state.go('mixerWagons.myWagons');
						toastr.success(i18nFilter('_toastr_edit_wagon_'), i18nFilter('_toastr_success_title_'));
					})
					.catch(function (error) {
						console.log(error);
						vm.loading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_updating_wagon_');
					});
			}
		}

		function uploadChanged() {
			$timeout(function () {
				vm.showRemoveImageButton = true;
			}, 500);
		}

		function openFileSystem() {
			document.getElementById('up_button').click();
		}

		function imageUrlChanged() {
			if (vm.wagon.image_url && vm.wagon.image_url.length > 0) {
				vm.hideUploadButton = true;
			} else {
				vm.hideUploadButton = false;
			}
		}
		function cancel() {
			$state.go('mixerWagons.myWagons');
		}

		function removeImage() {
			vm.file = null;
			vm.wagon.image_url = null;
			vm.showRemoveImageButton = false;
			vm.hideUrlInput = false;
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});

		$scope.$on('default_team_herd_changed', function () {
			vm.selectedHerd = null;
			init();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.mixerWagons.editWagon').factory('editWagonService', editWagonService);
	/** @ngInject */
	function editWagonService(APP_CONST, $http, $q) {
		return {
			getWagonById: getWagonById,
			updateWagon: updateWagon
		};

		function getWagonById(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'mixerwagon' + suffix)
				.then(success)
				.catch(error);
		}

		function updateWagon(wagon) {
			return $http
				.put(APP_CONST.api_base_url + 'mixerwagon', wagon)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.mixerWagons.myWagons').controller('myWagonsCtrl', myWagonsCtrl);
	/** @ngInject */
	function myWagonsCtrl($state, $scope, $uibModal, myWagonsService, $uibModalStack, unitConversionService, $cookies, errorService, $timeout) {
		var vm = this;
		vm.selectLayout = selectLayout;
		vm.paginationChanged = paginationChanged;
		vm.showImage = showImage;
		vm.deleteWagon = deleteWagon;
		vm.editWagon = editWagon;
		vm.goToWagonHistory = goToWagonHistory;
		vm.proceedDelete = proceedDelete;
		vm.selectedLayout = 1;
		init();

		function init() {
			setCurrentLayout();
			vm.loading = true;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.wagons = [];
			if (vm.settings && vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd;
				vm.currentPage = 1;
				getWagons(true);
			} else {
				vm.selectedHerd = null;
				vm.loading = false;
			}
			if (vm.settings.use_kgs) {
				vm.weight = 'Kg';
			} else {
				vm.weight = 'Lb';
			}
		}

		function reloadApi() {
			vm.loading = true;
			vm.wagons = [];
			if (vm.settings && vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd;
				vm.currentPage = 1;
				getWagons(true);
			} else {
				vm.selectedHerd = null;
				vm.loading = false;
			}
		}

		function setCurrentLayout() {
			var data = $cookies.get('wagon_layout');
			if (data) {
				vm.selectedLayout = data;
			} else {
				vm.selectedLayout = 1;
				$cookies.put('wagon_layout', 1);
			}
		}

		function getWagons(init) {
			var suffix = '?page=' + vm.currentPage + '&team=' + vm.settings.selectedTeam.id + '&herd=' + vm.settings.selectedHerd.id;
			return myWagonsService
				.getWagons(suffix)
				.then(function (response) {
					if (response.length > 0) {
						vm.totalItems = response[0].number_of_all;
						for (var i = 0; i < response.length; i++) {
							response[i].weight = unitConversionService.convertData(response[i].weight, ['metricTonToImperialTon']);
							if (response[i].calibration_final_weight) {
								response[i].is_calibrated = true;
							} else {
								response[i].is_calibrated = false;
							}
						}
					} else {
						vm.totalItems = 0;
					}
					vm.wagons = vm.wagons.concat(response);
					vm.loadingTable = false;
					vm.loading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loadingTable = false;
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_wagon_', init);
				});
		}

		function paginationChanged() {
			vm.loadingTable = true;
			vm.currentPage++;
			$timeout(function () {
				getWagons();
			}, 10);
		}

		function showImage(wagon) {
			if (wagon.image_url) {
				vm.wagon_image = wagon.image_url;
				openModal('app/pages/mixerWagons/myWagons/image.modal.html', 'md');
			}
		}

		function deleteWagon(index, data) {
			vm.deleteData = data;
			vm.deleteIndex = index;
			vm.warningMessage = '_wagon_delete_warning_message_';
			openModal('app/pages/mixerWagons/myWagons/confirmationDialog.modal.html', 'md');
		}

		function proceedDelete() {
			vm.modalLoading = true;
			if (!vm.deleteData.team_id) {
				vm.deleteData.team_id = vm.settings.selectedTeam.id;
			}
			return myWagonsService
				.deleteWagon(vm.deleteData)
				.then(function () {
					vm.wagons.splice(vm.deleteIndex, 1);
					vm.totalItems--;
					if (vm.wagons.length === 0) {
						vm.currentPage = 1;
						getWagons();
					}
					$uibModalStack.dismissAll();
					vm.modalLoading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.modalLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_deleting_wagon_');
				});
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function editWagon(wagon) {
			$state.go('mixerWagons.editWagon', {
				uuid: wagon.id
			});
		}

		function goToWagonHistory(wagon) {
			$state.go('mixerWagons.wagonHistory', {
				uuid: wagon.id
			});
		}

		function selectLayout(type) {
			vm.selectedLayout = type;
			$cookies.put('wagon_layout', vm.selectedLayout);
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});

		$scope.$on('default_team_herd_changed', function () {
			init();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.mixerWagons.myWagons').factory('myWagonsService', myWagonsService);
	/** @ngInject */
	function myWagonsService(APP_CONST, $http, $q) {
		return {
			getWagons: getWagons,
			deleteWagon: deleteWagon
		};

		function getWagons(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'mixerwagon' + suffix)
				.then(success)
				.catch(error);
		}

		function deleteWagon(wagon) {
			return $http
				.put(APP_CONST.api_base_url + 'mixerwagon/remove', wagon)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.mixerWagons.wagonHistory').controller('wagonHistoryCtrl', wagonHistoryCtrl);
	/** @ngInject */
	function wagonHistoryCtrl(wagonHistoryService, $stateParams, $state, $uibModal, $scope, unitConversionService, errorService) {
		var vm = this;
		vm.paginationChanged = paginationChanged;
		vm.showImage = showImage;
		vm.reloadApi = reloadApi;
		vm.back = back;
		init();

		function init() {
			vm.loading = true;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.wagon_id = $stateParams.uuid;
			vm.wagons = [];
			if (vm.settings && vm.settings.selectedTeam.id && vm.settings.selectedHerd.id) {
				vm.currentPage = 1;
				getWagonById(true);
			} else {
				vm.loading = false;
			}
		}

		function reloadApi() {
			vm.loading = true;
			if (vm.settings && vm.settings.selectedTeam.id && vm.settings.selectedHerd.id) {
				vm.currentPage = 1;
				getWagonById(true);
			} else {
				vm.loading = false;
			}
		}

		function getWagonById(init) {
			var suffix = '/' + vm.wagon_id + '?page=' + vm.currentPage;
			return wagonHistoryService
				.getWagonById(suffix)
				.then(function (response) {
					vm.totalItems = response && response.number_of_all ? response.number_of_all : 0;
					response.mixer_wagons_history.forEach(function (history) {
						history.weight = unitConversionService.convertData(history.weight, ['metricTonToImperialTon']);
					});
					vm.wagons = vm.wagons.concat(response.mixer_wagons_history);
					vm.loading = false;
					vm.loadingTable = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loadingTable = false;
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_wagon_', init);
				});
		}

		function paginationChanged() {
			vm.currentPage++;
			vm.loadingTable = true;
			getWagonById();
		}

		function back() {
			$state.go('mixerWagons.myWagons');
		}

		function showImage(wagon) {
			if (wagon.image_url) {
				vm.wagon_image = wagon.image_url;
				openModal('app/pages/mixerWagons/myWagons/image.modal.html', 'md');
			}
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope
			});
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.mixerWagons.wagonHistory').factory('wagonHistoryService', wagonHistoryService);
	/** @ngInject */
	function wagonHistoryService(APP_CONST, $http, $q) {
		return {
			getWagonById: getWagonById
		};

		function getWagonById(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'mixerwagon/history' + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.pens.addNewPen').controller('addNewPenCtrl', addNewPenCtrl);
	/** @ngInject */
	function addNewPenCtrl($timeout, $scope, $filter, toastr, $uibModal, $uibModalStack, addNewPenFactory, $state, $q, dataServiceFactory, APP_CONST, $locale, $window, errorService, $rootScope, $interval) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var herd;
		var categories;
		var resizeTimer;
		//var listener;
		var RRule = rrule.RRule;
		/*var drawingManager = new google.maps.drawing.DrawingManager({
			drawingControl: true,
			drawingControlOptions: {
				position: google.maps.ControlPosition.TOP_CENTER,
				drawingModes: ['polygon']
			},
			polygonOptions: {
				fillColor: '#FF4C4C',
				strokeColor: '#B23535',
				fillOpacity: 0.6,
				strokeWeight: 2,
				clickable: false,
				editable: false,
				zIndex: 1
			}
		});*/
		vm.date_format = $locale.DATETIME_FORMATS.shortDate;
		vm.categorySelected = categorySelected;
		vm.savePen = savePen;
		vm.cancel = cancel;
		vm.addNewCategory = addNewCategory;
		vm.removeSelection = removeSelection;
		vm.cancelWizard = cancelWizard;
		vm.reloadApi = reloadApi;
		vm.daySelected = daySelected;
		vm.openTimePicker = openTimePicker;
		vm.addRule = addRule;
		vm.removeRule = removeRule;
		vm.sortRules = sortRules;
		vm.tabValidation = tabValidation;
		vm.timeChanged = timeChanged;
		vm.numberOfFeedingsChanged = numberOfFeedingsChanged;

		init();

		function init() {
			vm.ruleId = 1;
			vm.loading = true;
			vm.locationSelected = false;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.from_recipe = JSON.parse(localStorage.getItem('from_recipe'));
			vm.showGMap = true;
			checkLng();
			herd = $q.defer();
			categories = $q.defer();
			if (vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd.id;
				getHerdById(vm.selectedHerd);
				getCategories();
			} else {
				herd.resolve();
				vm.selectedHerd = null;
			}
			$q.all([herd.promise, categories.promise])
				.then(function () {
					vm.loading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
				});
			vm.today = moment().toDate();
			vm.automatic_update = false;
			vm.pen_active = true;
			vm.pen = {};
			vm.pen.use_pen_feed_intake = false;
			vm.pen_location = [];
			if (!vm.settings.use_kgs) {
				vm.max = 88.18;
			} else {
				vm.max = 40;
			}
			vm.datepickerOptions = {
				minDate: vm.today,
				dateDisabled: function (dateAndMode) {
					return dateAndMode.mode === 'day' && isAvailable(dateAndMode.date);
				}
			};
			vm.no_feedings = [
				{
					name: i18nFilter('_label_none_'),
					value: 0
				},
				{
					name: '1',
					value: 1
				},
				{
					name: '2',
					value: 2
				},
				{
					name: '3',
					value: 3
				}
			];
			vm.frequencies = [
				{
					name: i18nFilter('_every_day_frequency_'),
					value: 1
				},
				{
					name: i18nFilter('_every_two_day_frequency_'),
					value: 2
				},
				{
					name: i18nFilter('_every_three_day_frequency_'),
					value: 3
				},
				{
					name: i18nFilter('_m_f_label_custom_'),
					value: 4
				}
			];
			vm.category_names = [
				{
					name: i18nFilter('_milking_cows_hp_'),
					id: 1
				},
				{
					name: i18nFilter('_milking_cows_lp_'),
					id: 2
				},
				{
					name: i18nFilter('_dry_cows_'),
					id: 3
				},
				{
					name: i18nFilter('_heifers_2nd_year_of_life_'),
					id: 4
				},
				{
					name: i18nFilter('_heifers_1st_year_of_life_'),
					id: 5
				},
				{
					name: i18nFilter('_fattening_bulls_'),
					id: 6
				},
				{
					name: i18nFilter('_calves_'),
					id: 7
				}
			];
			vm.feedingPeriods = [
				{
					name: i18nFilter('_m_f_pen_morning_feeding_'),
					value: 1
				},
				{
					name: i18nFilter('_m_f_pen_noon_feeding_'),
					value: 2
				},
				{
					name: i18nFilter('_m_f_pen_evening_feeding_'),
					value: 3
				}
			];
			setCustomDays();
			setFeedingRules();
			$timeout(function () {
				var tabs = document.getElementsByClassName('wizard-step');
				for (var i = 0; i < tabs.length; i++) {
					tabs[i]._title = tabs[i].title;
					tabs[i].onmouseover = function () {
						this.title = '';
					};
					tabs[i].onmouseout = function () {
						this.title = this._title;
					};
				}
			}, 1000);
		}

		function checkLng() {
			if (vm.settings.language) {
				if (vm.settings.language == 'en-gb') {
					vm.locale = 'en-gb';
				} else if (vm.settings.language == 'en-us') {
					vm.locale = 'en';
				} else if (vm.settings.language == 'cs-cz') {
					vm.locale = 'cs';
				} else if (vm.settings.language == 'es-es') {
					vm.locale = 'es';
				} else if (vm.settings.language == 'nl-nl') {
					vm.locale = 'nl';
				} else if (vm.settings.language == 'it-it') {
					vm.locale = 'nl';
				} else if (vm.settings.language == 'pl-pl') {
					vm.locale = 'pl';
				} else if (vm.settings.language == 'pt-br') {
					vm.locale = 'pt';
				} else if (vm.settings.language == 'de-de') {
					vm.locale = 'de';
				}
			} else {
				vm.locale = 'en-gb';
			}
		}
		function reloadApi() {
			vm.loading = true;
			vm.showGMap = true;
			if (vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd.id;
				getHerdById(vm.selectedHerd);
				getCategories();
			} else {
				herd.resolve();
				vm.selectedHerd = null;
			}
		}

		function openTimePicker(feedingPeriod, num) {
			vm.formPeriodValue = num;
			vm.morning_displayed = feedingPeriod && feedingPeriod.value == 1 ? true : false;
			vm.noon_displayed = feedingPeriod && feedingPeriod.value == 2 ? true : false;
			vm.evening_displayed = feedingPeriod && feedingPeriod.value == 3 ? true : false;
		}

		function setFeedingRules() {
			vm.feedingRules = [];
			vm.disabledDatesList = [];
			var obj = {
				id: vm.ruleId,
				feeding_date: vm.today,
				feeding_time_1: null,
				feeding_time_2: null,
				feeding_time_3: null,
				feeding_period_1: null,
				feeding_period_2: null,
				feeding_period_3: null,
				customDays: angular.copy(vm.days)
			};
			vm.feedingRules.push(obj);
			vm.disabledDatesList.push({
				id: obj.id,
				date: obj.feeding_date
			});
		}

		function addRule(e) {
			e.preventDefault();
			vm.ruleId++;
			var obj = {
				id: vm.ruleId,
				feeding_date: moment(vm.feedingRules[0].feeding_date).add(1, 'day').toDate(),
				feeding_time_1: null,
				feeding_time_2: null,
				feeding_time_3: null,
				feeding_period_1: null,
				feeding_period_2: null,
				feeding_period_3: null,
				customDays: angular.copy(vm.days)
			};
			vm.feedingRules.unshift(obj);
			vm.disabledDatesList.push({
				id: obj.id,
				date: obj.feeding_date
			});
		}

		function isAvailable(date) {
			var found = false;
			for (var i = 0; i < vm.disabledDatesList.length; i++) {
				if (moment(date).isSame(vm.disabledDatesList[i].date)) {
					found = true;
					break;
				}
			}
			return found;
		}

		function removeRule(id, e) {
			e.preventDefault();
			for (var i = 0; i < vm.feedingRules.length; i++) {
				if (vm.feedingRules[i].id == id) {
					vm.feedingRules.splice(i, 1);
					break;
				}
			}
			for (var j = 0; j < vm.disabledDatesList.length; j++) {
				if (vm.disabledDatesList[j].id == id) {
					vm.disabledDatesList.splice(j, 1);
					break;
				}
			}
		}

		function sortRules(newValue, id) {
			var valid = true;
			Object.keys(vm.feedingInfoForm).forEach(function (key) {
				if (key.slice(0, 13) == 'feeding_date_') {
					if (vm.feedingInfoForm[key] && vm.feedingInfoForm[key].$invalid) {
						valid = false;
					}
				}
			});
			if (valid) {
				for (var k = 0; k < vm.disabledDatesList.length; k++) {
					if (vm.disabledDatesList[k].id == id) {
						vm.disabledDatesList[k].date = moment(newValue).toDate();
						break;
					}
				}
				vm.feedingRules = $filter('orderBy')(vm.feedingRules, 'feeding_date', true);
			}
		}

		function numberOfFeedingsChanged(rule) {
			if (rule.selected_number_of_feedings.value === 0) {
				rule.feeding_period_1 = null;
				rule.feeding_time_1 = null;
				rule.feeding_period_2 = null;
				rule.feeding_time_2 = null;
				rule.feeding_period_3 = null;
				rule.feeding_time_3 = null;
			} else if (rule.selected_number_of_feedings.value === 1) {
				rule.feeding_period_2 = null;
				rule.feeding_time_2 = null;
				rule.feeding_period_3 = null;
				rule.feeding_time_3 = null;
			} else if (rule.selected_number_of_feedings.value === 2) {
				rule.feeding_period_3 = null;
				rule.feeding_time_3 = null;
			}

			$timeout(function () {
				$rootScope.$broadcast('time_validators', true);
			}, 100);
		}

		function timeChanged(rule, period, time) {
			$timeout(function () {
				var period_name = period + '_' + rule.id;
				if (vm.feedingInfoForm[period_name]) {
					vm.feedingInfoForm[period_name].$dirty = true;
				}
				var hour = Number.parseInt(moment(rule[time]).format('HH'));
				if (hour >= 4 && hour <= 11) {
					rule[period] = vm.feedingPeriods[0];
				} else if (hour >= 12 && hour <= 18) {
					rule[period] = vm.feedingPeriods[1];
				} else if ((hour >= 19 && hour <= 23) || (hour >= 0 && hour <= 3)) {
					rule[period] = vm.feedingPeriods[2];
				}
				if (rule.selected_number_of_feedings && (rule.selected_number_of_feedings.value === 2 || rule.selected_number_of_feedings.value === 3)) {
					$timeout(function () {
						$rootScope.$broadcast('time_validators', true);
					}, 100);
				}
			}, 0);
		}

		function removeSelection() {
			vm.locationSelected = false;
			vm.pen_location = [];
			if (vm.pen.pen_lat && vm.pen.pen_lng) {
				//initialize(vm.pen.pen_lat, vm.pen.pen_lng);
			} else {
				//initialize();
			}
			drawingManager.setOptions({
				drawingControl: true
			});
		}

		/* function initialize(lat, lng) {
			var latitude;
			var longitude;
			var zoom;
			var marker;
			if (lat && lng) {
				latitude = lat;
				longitude = lng;
				zoom = 15;
			} else {
				latitude = 43.8900745;
				longitude = 20.3492278;
				zoom = 3;
			}
			var id = 'google-maps';
			var geocoder = new google.maps.Geocoder();
			var mapCanvas = document.getElementById(id);
			var mapOptions = {
				center: new google.maps.LatLng(latitude, longitude),
				zoom: zoom,
				mapTypeId: 'hybrid'
			};
			var map = new google.maps.Map(mapCanvas, mapOptions);
			if (!map || !map.renderingType) {
				vm.showGMap = false;
				return;
			}
			var has_marker = false;
			if (lat && lng) {
				var latLng = {
					lat: lat,
					lng: lng
				};
				placeMarker(latLng, map, false);
				has_marker = true;
			}
			map.addListener('click', function (e) {
				if (!has_marker) {
					var ll = {
						lat: e.latLng.lat(),
						lng: e.latLng.lng()
					};
					placeMarker(ll, map, true);
					has_marker = true;
				}
			});
			var input = document.getElementById('pen_address');
			var searchBox = new google.maps.places.SearchBox(input);
			searchBox.addListener('places_changed', function () {
				var places = searchBox.getPlaces();
				if (places.length == 0) {
					return;
				}
				// Clear out the old markers.
				try {
					marker.setMap(null);
				} catch (error) {
					console.log(error);
				}
				// For each place, get the icon, name and location.
				var bounds = new google.maps.LatLngBounds();
				places.forEach(function (place) {
					if (!place.geometry) {
						console.log('Returned place contains no geometry');
						return;
					} else {
						vm.pen.pen_address = place.formatted_address;
						var latlng = {
							lat: place.geometry.location.lat(),
							lng: place.geometry.location.lng()
						};
						placeMarker(latlng, map, false);
					}
					// Create a marker for each place.
					if (place.geometry.viewport) {
						// Only geocodes have viewport.
						bounds.union(place.geometry.viewport);
					} else {
						bounds.extend(place.geometry.location);
					}
				});
				map.fitBounds(bounds);
			});
			drawingManager.setMap(map);
			if (listener) {
				google.maps.event.removeListener(listener);
			}
			listener = google.maps.event.addListener(drawingManager, 'polygoncomplete', function (polygon) {
				if (vm.pen_location && vm.pen_location.length > 1) {
					drawingManager.setOptions({
						drawingControl: false
					});
				}
				drawingManager.setDrawingMode(null);
				var arr = polygon.getPath().getArray();
				var coordinates = [];
				for (var i = 0; i < arr.length; i++) {
					var coordinate = {
						lat: arr[i].lat(),
						lng: arr[i].lng()
					};
					coordinates.push(coordinate);
				}
				if (coordinates.length > 6) {
					polygon.setMap(null);
					drawingManager.setOptions({
						drawingControl: true
					});
				} else {
					vm.pen_location.push(coordinates);
					$timeout(function () {
						vm.locationSelected = true;
					}, 0);
				}
			});

			function placeMarker(position, map, onClick) {
				marker = new google.maps.Marker({
					position: position,
					map: map,
					draggable: true
				});
				vm.pen.pen_lat = position.lat;
				vm.pen.pen_lng = position.lng;
				map.panTo(position);
				if (onClick) {
					geocodePosition(marker.getPosition());
				}
				google.maps.event.addListener(marker, 'dragend', function (event) {
					vm.pen.pen_lat = event.latLng.lat();
					vm.pen.pen_lng = event.latLng.lng();
					geocodePosition(marker.getPosition());
				});

				function geocodePosition(pos) {
					geocoder.geocode(
						{
							latLng: pos
						},
						function (responses) {
							$timeout(function () {
								vm.pen.pen_address = responses[0].formatted_address;
							}, 0);
						}
					);
				}
			}
		} */

		function setCustomDays() {
			vm.days = [];
			var listOfDays = APP_CONST.constants.custom_feeding_days;
			for (var i = 0; i < listOfDays.length; i++) {
				var obj = {
					name: i18nFilter(listOfDays[i].name),
					selected: listOfDays[i].selected,
					rrule_day: RRule[listOfDays[i].rrule_day],
					value: listOfDays[i].value
				};
				vm.days.push(obj);
			}
		}

		function daySelected(rule) {
			for (var i = 0; i < rule.customDays.length; i++) {
				if (rule.customDays[i].selected) {
					rule.customDaysValidation = 'valid';
					break;
				} else {
					rule.customDaysValidation = null;
				}
			}
		}

		function createRRule(rule) {
			var ruleString = new RRule({
				freq: RRule.DAILY,
				interval: rule.selected_frequency.value != 4 ? rule.selected_frequency.value : undefined,
				byweekday: rule.selected_frequency.value == 4 ? setRruleDayList(rule) : undefined
			});
			return ruleString.toString().split(':')[1];
		}

		function setRruleDayList(rule) {
			var list = [];
			for (var i = 0; i < rule.customDays.length; i++) {
				if (rule.customDays[i].selected) {
					list.push(rule.customDays[i].rrule_day);
				}
			}
			return list;
		}

		function createScheduler() {
			var list = [];
			for (var i = 0; i < vm.feedingRules.length; i++) {
				var frequency = vm.feedingRules[i].selected_number_of_feedings && vm.feedingRules[i].selected_number_of_feedings.value ? createRRule(vm.feedingRules[i]) : '';
				var obj = new Schema(frequency, moment(vm.feedingRules[i].feeding_date).format('YYYY-MM-DD'), vm.feedingRules[i]);
				list.push(obj);
			}
			return list;

			function Schema(frequency, start_date, rule) {
				this.feeding_frequency_rule = frequency;
				this.start_feeding_date = start_date;
				this.morning_feeding_time = setTime(rule, 1) || null;
				this.noon_feeding_time = setTime(rule, 2) || null;
				this.evening_feeding_time = setTime(rule, 3) || null;
				this.morning_feeding = setFeeding(rule, 1) || false;
				this.noon_feeding = setFeeding(rule, 2) || false;
				this.evening_feeding = setFeeding(rule, 3) || false;
			}

			function setTime(rule, period) {
				if (rule.selected_number_of_feedings.value === 1) {
					if (rule.feeding_period_1 && rule.feeding_period_1.value === period) {
						return moment(rule.feeding_time_1).format('HH:mm');
					}
				}
				if (rule.selected_number_of_feedings.value === 2) {
					if (rule.feeding_period_1 && rule.feeding_period_1.value === period) {
						return moment(rule.feeding_time_1).format('HH:mm');
					}
					if (rule.feeding_period_2 && rule.feeding_period_2.value === period) {
						return moment(rule.feeding_time_2).format('HH:mm');
					}
				}
				if (rule.selected_number_of_feedings.value === 3) {
					if (rule.feeding_period_1 && rule.feeding_period_1.value === period) {
						return moment(rule.feeding_time_1).format('HH:mm');
					}
					if (rule.feeding_period_2 && rule.feeding_period_2.value === period) {
						return moment(rule.feeding_time_2).format('HH:mm');
					}
					if (rule.feeding_period_3 && rule.feeding_period_3.value === period) {
						return moment(rule.feeding_time_3).format('HH:mm');
					}
				}
			}

			function setFeeding(rule, period) {
				if (rule.feeding_period_1 && rule.feeding_period_1.value === period) {
					return true;
				}
				if (rule.feeding_period_2 && rule.feeding_period_2.value === period) {
					return true;
				}
				if (rule.feeding_period_3 && rule.feeding_period_3.value === period) {
					return true;
				}
			}
		}

		function getCategories() {
			var suffix = '?teamId=' + vm.settings.selectedTeam.id + '&herdId=' + vm.settings.selectedHerd.id + '&visible=true';

			return addNewPenFactory
				.getCategories(suffix)
				.then(function (response) {
					if (!vm.settings.use_kgs) {
						vm.weight = 'Lb';
					} else {
						vm.weight = 'Kg';
					}
					setCategoryName(response);
					vm.categories = response;
					addCustomCategory();
					categories.resolve();
				})
				.catch(function (error) {
					categories.reject(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_categories_', true);
				});
		}

		function setCategoryName(categories) {
			for (var i = 0; i < categories.length; i++) {
				for (var j = 0; j < vm.category_names.length; j++) {
					if (categories[i].id == vm.category_names[j].id) {
						categories[i].name = vm.category_names[j].name;
					}
				}
			}
			return categories;
		}

		function getHerdById(herd_id) {
			return addNewPenFactory
				.getHerdById(herd_id)
				.then(function (response) {
					vm.herd = response;
					var address = '';
					if (response.Street) {
						address = address + response.Street + ' ';
					}
					if (response.Number) {
						address = address + response.Number + ' ';
					}
					if (response.Zip) {
						address = address + ',' + response.Zip + ' ';
					}
					if (response.City) {
						address = address + response.City + ' ';
					}
					vm.pen.pen_address = address;
					$timeout(function () {
						if (response.Latitude && response.Longitude) {
							//initialize(response.Latitude, response.Longitude);
						} else {
							//initialize();
						}
					}, 100);
					vm.loading = false;
					herd.resolve();
					$timeout(function () {
						vm.showSlider = true;
					}, 200);
				})
				.catch(function (error) {
					vm.loading = false;
					herd.reject(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_herds_', true);
				});
		}

		function addCustomCategory() {
			var category = {
				name: i18nFilter('_m_f_add_new_pen_add_category_'),
				id: 'new_category'
			};
			vm.categories.push(category);
		}

		function savePen() {
			if (vm.settings && vm.settings.selectedTeam.id) {
				vm.loading = true;
				var penDTO = angular.copy(vm.pen);
				penDTO.team_id = vm.settings.selectedTeam.id;
				penDTO.herd_id = vm.settings.selectedHerd.id;
				penDTO.automatic_update = vm.automatic_update;
				penDTO.pen_active = vm.pen_active;
				if (vm.selected_pen_category.id === null) {
					penDTO.pen_category = {
						name: vm.selected_pen_category.name,
						feed_intake: vm.selected_pen_category.feed_intake,
						id: null
					};
				} else {
					penDTO.pen_category = {
						name: vm.selected_pen_category.name,
						feed_intake: vm.selected_pen_category.feed_intake,
						id: vm.selected_pen_category.id
					};
				}
				if (vm.pen_location && vm.pen_location.length > 0) {
					penDTO.pen_location = JSON.stringify(vm.pen_location);
				} else {
					penDTO.pen_location = null;
				}
				penDTO.last_modified_user = vm.user.email;
				penDTO.pen_feeding_scheduler_list = createScheduler(penDTO);
				addNewPenFactory
					.addNewPen(penDTO)
					.then(function () {
						toastr.success(i18nFilter('_toastr_add_new_pen_'), i18nFilter('_toastr_success_title_'));
						if (vm.from_recipe) {
							if (vm.from_recipe.type == 'add') {
								$state.go('recipes.addNewRecipe');
							} else if (vm.from_recipe.type == 'edit') {
								$state.go('recipes.editRecipe', {
									uuid: vm.from_recipe.uuid
								});
							} else {
								$state.go('pens.myPens');
							}
						} else {
							$state.go('pens.myPens');
						}
					})
					.catch(function (error) {
						console.log(error);
						vm.loading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_saving_pen_');
					});
			}
		}

		function categorySelected() {
			if (vm.selected_pen_category.id == 'new_category') {
				vm.addCategoryLoading = false;
				vm.selected_pen_category = null;
				openModal('app/pages/pens/addNewPen/addCategory.modal.html', 'sm');
			} else {
				vm.pen.feed_intake = vm.selected_pen_category.feed_intake;
			}
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function cancel() {
			$uibModalStack.dismissAll();
		}

		function cancelWizard() {
			if (vm.from_recipe) {
				if (vm.from_recipe.type == 'add') {
					$state.go('recipes.addNewRecipe');
				} else if (vm.from_recipe.type == 'edit') {
					$state.go('recipes.editRecipe', {
						uuid: vm.from_recipe.uuid
					});
				}
			} else {
				$state.go('pens.myPens');
			}
		}

		function addNewCategory() {
			vm.addCategoryLoading = true;
			var category = {
				name: vm.newCategory.name,
				feed_intake: vm.newCategory.feed_intake,
				id: null
			};
			vm.pen.feed_intake = vm.newCategory.feed_intake;
			var index = vm.categories.length - 1;
			vm.categories.splice(index, 0, category);
			vm.selected_pen_category = category;
			cancel();
		}

		angular.element($window).bind('resize', function () {
			if (resizeTimer) {
				$timeout.cancel(resizeTimer);
			}
			resizeTimer = $timeout(function () {
				vm.resetTable = true;
				$timeout(function () {
					vm.resetTable = false;
				}, 1);
			}, 200);
		});

		//remove default tooltip
		(function removeDefaultTooltip() {
			var tooltipInterval = $interval(
				function () {
					$timeout(function () {
						var tabs = document.getElementsByClassName('wizard-step');
						var tabLoaded = document.getElementById('add-pen-tabs');
						if (tabLoaded) {
							for (var i = 0; i < tabs.length; i++) {
								tabs[i]._title = tabs[i].title;
								tabs[i].onmouseenter = function () {
									this.title = '';
								};
								tabs[i].onmouseleave = function () {
									this.title = this._title;
								};
							}
							$interval.cancel(tooltipInterval);
						}
					}, 50);
				},
				1500,
				15
			);
		})();

		function tabValidation() {
			return {
				'basic-tab-validation': vm.basicInfoForm && vm.basicInfoForm.$invalid && vm.basicInfoForm.$submitted,
				'feeding-info-tab-validation': vm.feedingInfoForm && vm.feedingInfoForm.$invalid && vm.feedingInfoForm.$submitted
			};
		}

		$scope.$on('$destroy', function () {
			angular.element($window).unbind('resize');
		});

		$scope.$on('$stateChangeStart', function (event, toState) {
			if (toState.url !== '/editRecipe/{uuid:string}' && toState.url !== '/addNewRecipe') {
				dataServiceFactory.add_new_recipe_data = {};
				dataServiceFactory.edit_recipe_data = {};
				localStorage.removeItem('from_recipe');
			}
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});

		$scope.$on('default_team_herd_changed', function () {
			init();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.pens.addNewPen').factory('addNewPenFactory', addNewPenFactory);
	/** @ngInject */
	function addNewPenFactory(APP_CONST, $http, $q) {
		return {
			getHerdById: getHerdById,
			addNewPen: addNewPen,
			getCategories: getCategories
		};

		function getHerdById(herdId) {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/herds/' + herdId)
				.then(success)
				.catch(error);
		}

		function addNewPen(pen) {
			return $http
				.post(APP_CONST.api_base_url + 'pens', pen)
				.then(success)
				.catch(error);
		}

		function getCategories(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'penCategories' + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.pens.editPen').controller('editPenCtrl', editPenCtrl);
	/** @ngInject */
	function editPenCtrl($timeout, $state, $scope, editPenFactory, $stateParams, $filter, toastr, $q, $uibModal, $uibModalStack, dataServiceFactory, APP_CONST, $locale, $window, $rootScope, errorService, $interval, appService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var resizeTimer;
		var RRule = rrule.RRule;
		var parseString = rrule.rrulestr;
		//var listener;
		var pen;
		var categories;
		var activeRecipes;
		/*var drawingManager = new google.maps.drawing.DrawingManager({
			drawingControl: false,
			drawingControlOptions: {
				position: google.maps.ControlPosition.TOP_CENTER,
				drawingModes: ['polygon']
			},
			polygonOptions: {
				fillColor: '#FF4C4C',
				strokeColor: '#B23535',
				fillOpacity: 0.6,
				strokeWeight: 2,
				clickable: false,
				editable: false,
				zIndex: 1
			}
		});*/
		vm.date_format = $locale.DATETIME_FORMATS.shortDate;
		vm.categorySelected = categorySelected;
		vm.savePen = savePen;
		vm.cancel = cancel;
		vm.addNewCategory = addNewCategory;
		vm.removeSelection = removeSelection;
		vm.cancelWizard = cancelWizard;
		vm.reloadApi = reloadApi;
		vm.daySelected = daySelected;
		vm.openTimePicker = openTimePicker;
		vm.addRule = addRule;
		vm.removeRule = removeRule;
		vm.sortRules = sortRules;
		vm.numberOfFeedingsChanged = numberOfFeedingsChanged;
		vm.disableColumn = disableColumn;
		vm.tabValidation = tabValidation;
		vm.disableSaveButton = disableSaveButton;
		vm.timeChanged = timeChanged;
		vm.setPenEvent = setPenEvent;
		vm.openSaveModal = openSaveModal;
		vm.firstInit = true;

		init();

		function init() {
			vm.customInput = undefined;
			vm.loading = true;
			vm.pen = {};
			vm.locationSelected = true;
			vm.showGMap = true;
			vm.no_feedings = [
				{
					name: i18nFilter('_label_none_'),
					value: 0
				},
				{
					name: '1',
					value: 1
				},
				{
					name: '2',
					value: 2
				},
				{
					name: '3',
					value: 3
				}
			];
			vm.frequencies = [
				{
					name: i18nFilter('_every_day_frequency_'),
					value: 1
				},
				{
					name: i18nFilter('_every_two_day_frequency_'),
					value: 2
				},
				{
					name: i18nFilter('_every_three_day_frequency_'),
					value: 3
				},
				{
					name: i18nFilter('_m_f_label_custom_'),
					value: 4
				}
			];
			vm.category_names = [
				{
					name: i18nFilter('_milking_cows_hp_'),
					id: 1
				},
				{
					name: i18nFilter('_milking_cows_lp_'),
					id: 2
				},
				{
					name: i18nFilter('_dry_cows_'),
					id: 3
				},
				{
					name: i18nFilter('_heifers_2nd_year_of_life_'),
					id: 4
				},
				{
					name: i18nFilter('_heifers_1st_year_of_life_'),
					id: 5
				},
				{
					name: i18nFilter('_fattening_bulls_'),
					id: 6
				},
				{
					name: i18nFilter('_calves_'),
					id: 7
				}
			];
			vm.feedingPeriods = [
				{
					name: i18nFilter('_m_f_pen_morning_feeding_'),
					value: 1
				},
				{
					name: i18nFilter('_m_f_pen_noon_feeding_'),
					value: 2
				},
				{
					name: i18nFilter('_m_f_pen_evening_feeding_'),
					value: 3
				}
			];
			vm.event = 'PEN_FEEDING_AMOUNT';
			vm.today = moment().toDate();
			vm.datepickerOptions = {
				minDate: vm.today,
				dateDisabled: function (dateAndMode) {
					return dateAndMode.mode === 'day' && isAvailable(dateAndMode.date);
				}
			};
			setCustomDays();
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.from_recipe = JSON.parse(localStorage.getItem('from_recipe'));
			vm.from_calendar = JSON.parse(localStorage.getItem('from_calendar'));
			//localStorage.removeItem('from_calendar');
			checkLng();
			if (vm.settings && vm.settings.selectedTeam.id && vm.settings.selectedHerd.id) {
				pen = $q.defer();
				categories = $q.defer();
				activeRecipes = $q.defer();
				getPenById($stateParams.uuid);
				getActiveRecipes($stateParams.uuid);
				getCategories();
				$q.all([pen.promise, categories.promise, activeRecipes.promise])
					.then(function () {
						selectCategory();
					})
					.catch(function (error) {
						vm.loading = false;
						console.log(error);
					});
			} else {
				vm.loading = false;
			}
		}

		function setPenEvent() {
			//PEN_FEEDING_SCHEDULER - recreates feedings
			//PEN_FEEDING_AMOUNT - updates feeding amounts
			vm.event = 'PEN_FEEDING_SCHEDULER';
		}

		function openSaveModal() {
			if (vm.activeRecipesList && vm.activeRecipesList.length) {
				openModal('app/pages/pens/editPen/activeRecipe.modal.html', 'sm');
			} else {
				savePen();
			}
		}

		function checkLng() {
			if (vm.settings.language) {
				if (vm.settings.language == 'en-gb') {
					vm.locale = 'en-gb';
				} else if (vm.settings.language == 'en-us') {
					vm.locale = 'en';
				} else if (vm.settings.language == 'cs-cz') {
					vm.locale = 'cs';
				} else if (vm.settings.language == 'es-es') {
					vm.locale = 'es';
				} else if (vm.settings.language == 'nl-nl') {
					vm.locale = 'nl';
				} else if (vm.settings.language == 'it-it') {
					vm.locale = 'it';
				} else if (vm.settings.language == 'pl-pl') {
					vm.locale = 'pl';
				} else if (vm.settings.language == 'pt-br') {
					vm.locale = 'pt';
				} else if (vm.settings.language == 'de-de') {
					vm.locale = 'de';
				}
			} else {
				vm.locale = 'en-gb';
			}
		}

		function reloadApi() {
			vm.loading = true;
			vm.showGMap = true;
			if (vm.settings && vm.settings.selectedTeam.id && vm.settings.selectedHerd.id) {
				pen = $q.defer();
				categories = $q.defer();
				activeRecipes = $q.defer();
				getPenById($stateParams.uuid);
				getCategories();
				$q.all([pen.promise, categories.promise, activeRecipes.promise])
					.then(function () {
						selectCategory();
					})
					.catch(function (error) {
						vm.loading = false;
						console.log(error);
					});
			} else {
				vm.loading = false;
			}
		}

		function selectCategory() {
			var categoryFound = false;
			for (var i = 0; i < vm.categories.length; i++) {
				if (vm.categories[i].id === vm.pen.pen_category.id) {
					vm.selected_pen_category = vm.categories[i];
					categoryFound = true;
					break;
				}
			}
			if (categoryFound) {
				vm.loading = false;
			} else {
				editPenFactory
					.getCategoryById(vm.pen.pen_category.id)
					.then(function (response) {
						vm.selected_pen_category = vm.categories[i] = response;
						vm.loading = false;
					})
					.catch(function (error) {
						console.log(error);
						vm.loading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_loading_categories_', true);
					});
			}
		}

		function openTimePicker(feedingPeriod, num) {
			vm.formPeriodValue = num;
			vm.morning_displayed = feedingPeriod && feedingPeriod.value == 1 ? true : false;
			vm.noon_displayed = feedingPeriod && feedingPeriod.value == 2 ? true : false;
			vm.evening_displayed = feedingPeriod && feedingPeriod.value == 3 ? true : false;
		}

		function getNumberOfFeedings(item) {
			var num = 0;
			if (item.morning_feeding) {
				num++;
			}
			if (item.noon_feeding) {
				num++;
			}
			if (item.evening_feeding) {
				num++;
			}
			for (var i = 0; i < vm.no_feedings.length; i++) {
				if (vm.no_feedings[i].value == num) {
					return vm.no_feedings[i];
				}
			}
		}

		function setFeedingTime(item, period, obj) {
			if (period === 1) {
				if (item.morning_feeding) {
					item.morning_feeding = false;
					obj.feeding_period_1 = vm.feedingPeriods[0];
					return moment(moment(vm.today).format('YYYY-MM-DD') + 'T' + item.morning_feeding_time).toDate();
				}
				if (item.noon_feeding) {
					item.noon_feeding = false;
					obj.feeding_period_1 = vm.feedingPeriods[1];
					return moment(moment(vm.today).format('YYYY-MM-DD') + 'T' + item.noon_feeding_time).toDate();
				}
				if (item.evening_feeding) {
					item.evening_feeding = false;
					obj.feeding_period_1 = vm.feedingPeriods[2];
					return moment(moment(vm.today).format('YYYY-MM-DD') + 'T' + item.evening_feeding_time).toDate();
				}
			}
			if (period === 2) {
				if (item.noon_feeding) {
					item.noon_feeding = false;
					obj.feeding_period_2 = vm.feedingPeriods[1];
					return moment(moment(vm.today).format('YYYY-MM-DD') + 'T' + item.noon_feeding_time).toDate();
				}
				if (item.evening_feeding) {
					item.evening_feeding = false;
					obj.feeding_period_2 = vm.feedingPeriods[2];
					return moment(moment(vm.today).format('YYYY-MM-DD') + 'T' + item.evening_feeding_time).toDate();
				}
			}
			if (period === 3) {
				if (item.evening_feeding) {
					item.evening_feeding = false;
					obj.feeding_period_3 = vm.feedingPeriods[2];
					return moment(moment(vm.today).format('YYYY-MM-DD') + 'T' + item.evening_feeding_time).toDate();
				}
			}
			return null;
		}

		function parseRrule(item) {
			var tempRule = '';
			if (item.feeding_frequency_rule != '') {
				tempRule = parseString(item.feeding_frequency_rule);
			}
			var num;
			if (tempRule.options) {
				if (tempRule.options.byweekday) {
					num = 4;
					setDays(tempRule.options.byweekday, item);
				} else if (tempRule.options.interval != null && tempRule.options.interval != undefined) {
					num = tempRule.options.interval;
				} else {
					num = 1;
				}
			}
			for (var i = 0; i < vm.frequencies.length; i++) {
				if (vm.frequencies[i].value == num) {
					return vm.frequencies[i];
				}
			}
		}

		function disableColumn(date) {
			return !date.new_rule;
		}

		function setFeedingRules(list) {
			vm.feedingRules = [];
			vm.disabledDatesList = [];
			vm.ruleId = list[0].id;
			for (var i = 0; i < list.length; i++) {
				if (list[i].id > vm.ruleId) {
					vm.ruleId = list[i].id;
				}
				var obj = new SetSchema(list[i]);
				vm.feedingRules.push(obj);
				vm.disabledDatesList.push({
					id: obj.id,
					date: obj.feeding_date
				});
			}
			vm.feedingRules = $filter('orderBy')(vm.feedingRules, 'feeding_date', true);

			function SetSchema(item) {
				this.id = item.id;
				this.feeding_date = moment(item.start_feeding_date).toDate();
				this.selected_number_of_feedings = getNumberOfFeedings(item);
				this.feeding_time_1 = setFeedingTime(item, 1, this);
				this.feeding_time_2 = setFeedingTime(item, 2, this);
				this.feeding_time_3 = setFeedingTime(item, 3, this);
				this.ft_1 = moment(this.feeding_time_1).format('hh:mm A');
				this.ft_2 = moment(this.feeding_time_2).format('hh:mm A');
				this.ft_3 = moment(this.feeding_time_3).format('hh:mm A');
				this.feeding_frequency_rule = item.feeding_frequency_rule;
				this.customDays = angular.copy(vm.days);
				this.selected_frequency = parseRrule(this);
			}
		}

		function addRule(e) {
			e.preventDefault();
			setPenEvent();
			var tempStart = null;
			var firstDate = moment(vm.feedingRules[0].feeding_date).format('YYYY-MM-DD');
			var secondDate = moment(vm.today).format('YYYY-MM-DD');
			if (moment(firstDate).isBefore(secondDate)) {
				tempStart = angular.copy(moment(vm.today).toDate());
			} else {
				tempStart = angular.copy(moment(vm.feedingRules[0].feeding_date).add(1, 'day').toDate());
			}
			vm.ruleId++;
			var obj = {
				id: vm.ruleId,
				new_rule: true,
				feeding_date: tempStart,
				feeding_time_1: null,
				feeding_time_2: null,
				feeding_time_3: null,
				feeding_period_1: null,
				feeding_period_2: null,
				feeding_period_3: null,
				customDays: angular.copy(vm.days)
			};
			vm.feedingRules.unshift(obj);
			vm.disabledDatesList.push({
				id: obj.id,
				date: obj.feeding_date
			});
		}

		function isAvailable(date) {
			var found = false;
			for (var i = 0; i < vm.disabledDatesList.length; i++) {
				if (moment(date).isSame(vm.disabledDatesList[i].date)) {
					found = true;
					break;
				}
			}
			return found;
		}

		function removeRule(id, e) {
			e.preventDefault();
			setPenEvent();
			for (var i = 0; i < vm.feedingRules.length; i++) {
				if (vm.feedingRules[i].id == id) {
					vm.feedingRules.splice(i, 1);
					break;
				}
			}
			for (var j = 0; j < vm.disabledDatesList.length; j++) {
				if (vm.disabledDatesList[j].id == id) {
					vm.disabledDatesList.splice(j, 1);
					break;
				}
			}
		}

		function sortRules(newValue, id) {
			var valid = true;
			Object.keys(vm.feedingInfoForm).forEach(function (key) {
				if (key.slice(0, 13) == 'feeding_date_') {
					if (vm.feedingInfoForm[key] && vm.feedingInfoForm[key].$invalid) {
						valid = false;
					}
				}
			});
			if (valid) {
				setPenEvent();
				for (var k = 0; k < vm.disabledDatesList.length; k++) {
					if (vm.disabledDatesList[k].id == id) {
						vm.disabledDatesList[k].date = moment(newValue).toDate();
						break;
					}
				}
				vm.feedingRules = $filter('orderBy')(vm.feedingRules, 'feeding_date', true);
			}
		}

		function numberOfFeedingsChanged(rule) {
			setPenEvent();
			if (rule.selected_number_of_feedings.value === 0) {
				rule.feeding_period_1 = null;
				rule.feeding_time_1 = null;
				rule.feeding_period_2 = null;
				rule.feeding_time_2 = null;
				rule.feeding_period_3 = null;
				rule.feeding_time_3 = null;
			} else if (rule.selected_number_of_feedings.value === 1) {
				rule.feeding_period_2 = null;
				rule.feeding_time_2 = null;
				rule.feeding_period_3 = null;
				rule.feeding_time_3 = null;
			} else if (rule.selected_number_of_feedings.value === 2) {
				rule.feeding_period_3 = null;
				rule.feeding_time_3 = null;
			}

			$timeout(function () {
				$rootScope.$broadcast('time_validators', true);
			}, 10);
		}

		function timeChanged(rule, period, time) {
			$timeout(function () {
				setPenEvent();
				var period_name = period + '_' + rule.id;
				if (vm.feedingInfoForm[period_name]) {
					vm.feedingInfoForm[period_name].$dirty = true;
				}
				var hour = Number.parseInt(moment(rule[time]).format('HH'));
				if (hour >= 4 && hour <= 11) {
					rule[period] = vm.feedingPeriods[0];
				} else if (hour >= 12 && hour <= 18) {
					rule[period] = vm.feedingPeriods[1];
				} else if ((hour >= 19 && hour <= 23) || (hour >= 0 && hour <= 3)) {
					rule[period] = vm.feedingPeriods[2];
				}

				if (rule.selected_number_of_feedings && (rule.selected_number_of_feedings.value === 2 || rule.selected_number_of_feedings.value === 3)) {
					$timeout(function () {
						$rootScope.$broadcast('time_validators', true);
					}, 100);
				}
			}, 0);
		}

		function addCustomCategory() {
			var category = {
				name: i18nFilter('_m_f_add_new_pen_add_category_'),
				id: 'new_category'
			};
			vm.categories.push(category);
		}

		function setDays(byWeekDay, item) {
			if (byWeekDay && byWeekDay.length) {
				for (var i = 0; i < byWeekDay.length; i++) {
					for (var j = 0; j < item.customDays.length; j++) {
						if (byWeekDay[i] == item.customDays[j].value) {
							item.customDays[j].selected = true;
							item.customDaysValidation = 'valid';
							break;
						}
					}
				}
			}
		}

		function setCustomDays() {
			vm.rruleDayList = [];
			vm.days = [];
			var listOfDays = APP_CONST.constants.custom_feeding_days;
			for (var i = 0; i < listOfDays.length; i++) {
				var obj = {
					name: i18nFilter(listOfDays[i].name),
					selected: listOfDays[i].selected,
					rrule_day: RRule[listOfDays[i].rrule_day],
					value: listOfDays[i].value
				};
				vm.days.push(obj);
			}
		}

		function daySelected(rule) {
			setPenEvent();
			for (var i = 0; i < rule.customDays.length; i++) {
				if (rule.customDays[i].selected) {
					rule.customDaysValidation = 'valid';
					break;
				} else {
					rule.customDaysValidation = null;
				}
			}
		}

		function createRRule(rule) {
			var ruleString = new RRule({
				freq: RRule.DAILY,
				interval: rule.selected_frequency.value != 4 ? rule.selected_frequency.value : undefined,
				byweekday: rule.selected_frequency.value == 4 ? setRruleDayList(rule) : undefined
			});
			return ruleString.toString().split(':')[1];
		}

		function setRruleDayList(rule) {
			var list = [];
			for (var i = 0; i < rule.customDays.length; i++) {
				if (rule.customDays[i].selected) {
					list.push(rule.customDays[i].rrule_day);
				}
			}
			return list;
		}

		function createScheduler() {
			var list = [];
			for (var i = 0; i < vm.feedingRules.length; i++) {
				if (vm.feedingRules[i].new_rule) {
					var frequency = vm.feedingRules[i].selected_number_of_feedings && vm.feedingRules[i].selected_number_of_feedings.value ? createRRule(vm.feedingRules[i]) : '';
					var obj = new Schema(frequency, moment(vm.feedingRules[i].feeding_date).format('YYYY-MM-DD'), vm.feedingRules[i]);
					list.push(obj);
				}
			}
			return list;

			function Schema(frequency, start_date, rule) {
				this.feeding_frequency_rule = frequency;
				this.start_feeding_date = start_date;
				this.morning_feeding_time = setTime(rule, 1) || null;
				this.noon_feeding_time = setTime(rule, 2) || null;
				this.evening_feeding_time = setTime(rule, 3) || null;
				this.morning_feeding = setFeeding(rule, 1) || false;
				this.noon_feeding = setFeeding(rule, 2) || false;
				this.evening_feeding = setFeeding(rule, 3) || false;
			}

			function setTime(rule, period) {
				if (rule.selected_number_of_feedings.value === 1) {
					if (rule.feeding_period_1 && rule.feeding_period_1.value === period) {
						return moment(rule.feeding_time_1).format('HH:mm');
					}
				}
				if (rule.selected_number_of_feedings.value === 2) {
					if (rule.feeding_period_1 && rule.feeding_period_1.value === period) {
						return moment(rule.feeding_time_1).format('HH:mm');
					}
					if (rule.feeding_period_2 && rule.feeding_period_2.value === period) {
						return moment(rule.feeding_time_2).format('HH:mm');
					}
				}
				if (rule.selected_number_of_feedings.value === 3) {
					if (rule.feeding_period_1 && rule.feeding_period_1.value === period) {
						return moment(rule.feeding_time_1).format('HH:mm');
					}
					if (rule.feeding_period_2 && rule.feeding_period_2.value === period) {
						return moment(rule.feeding_time_2).format('HH:mm');
					}
					if (rule.feeding_period_3 && rule.feeding_period_3.value === period) {
						return moment(rule.feeding_time_3).format('HH:mm');
					}
				}
			}

			function setFeeding(rule, period) {
				if (rule.feeding_period_1 && rule.feeding_period_1.value === period) {
					return true;
				}
				if (rule.feeding_period_2 && rule.feeding_period_2.value === period) {
					return true;
				}
				if (rule.feeding_period_3 && rule.feeding_period_3.value === period) {
					return true;
				}
			}
		}

		function getPenById(penId) {
			var suffix = '?team=' + vm.settings.selectedTeam.id + '&herd=' + vm.settings.selectedHerd.id;
			return editPenFactory
				.getPenById(penId, suffix)
				.then(function (response) {
					if (response.pen_feeding_scheduler_list && response.pen_feeding_scheduler_list.length) {
						setFeedingRules(response.pen_feeding_scheduler_list);
					}
					if (response.pen_location) {
						var loc = JSON.parse(response.pen_location);
						if (!loc[0].length) {
							var list = [];
							list.push(loc);
							response.pen_location = list;
						} else {
							response.pen_location = loc;
						}
					} else {
						response.pen_location = [];
					}
					vm.pen_active = response.pen_active;
					vm.automatic_update = response.automatic_update;
					if (!vm.settings.use_kgs) {
						vm.max = 88.18;
					} else {
						vm.max = 40;
					}
					vm.pen = response;
					vm.penRemoveBackup = angular.copy(vm.pen.pen_feeding_scheduler_list.length);
					vm.intakeBackup = angular.copy(vm.pen.feed_intake);
					vm.animalBackup = angular.copy(vm.pen.number_of_animals);
					pen.resolve();
					$timeout(function () {
						//initialize(true);
						vm.showSlider = true;
					}, 100);
				})
				.catch(function (error) {
					pen.reject(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_pen_', true);
				});
		}

		function getCategories() {
			var suffix = '?teamId=' + vm.settings.selectedTeam.id + '&herdId=' + vm.settings.selectedHerd.id + '&visible=true';

			return editPenFactory
				.getCategories(suffix)
				.then(function (response) {
					if (!vm.settings.use_kgs) {
						vm.weight = 'Lb';
					} else {
						vm.weight = 'Kg';
					}
					setCategoryName(response);
					vm.categories = response;
					addCustomCategory();
					$timeout(function () {
						categories.resolve();
					}, 0);
				})
				.catch(function (error) {
					categories.reject(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_categories_', true);
				});
		}

		function getActiveRecipes(pen_id) {
			return editPenFactory
				.getActiveRecipes(pen_id)
				.then(function (response) {
					vm.activeRecipesList = response;
					activeRecipes.resolve();
				})
				.catch(function (error) {
					console.log(error);
					activeRecipes.reject();
				});
		}

		function setCategoryName(categories) {
			for (var i = 0; i < categories.length; i++) {
				for (var j = 0; j < vm.category_names.length; j++) {
					if (categories[i].id == vm.category_names[j].id) {
						categories[i].name = vm.category_names[j].name;
					}
				}
			}
			return categories;
		}

		function removeSelection() {
			vm.locationSelected = false;
			if (vm.latLngMissing) {
				vm.pen.pen_lat = null;
				vm.pen.pen_lng = null;
			}
			//initialize();
			vm.pen.pen_location = [];
			drawingManager.setOptions({
				drawingControl: true
			});
		}

		/* function initialize(first_init) {
			var addMarkerToMap;
			var zoom;
			var has_marker;
			if (vm.pen.pen_lat && vm.pen.pen_lng) {
				addMarkerToMap = true;
				zoom = 16;
				has_marker = true;
			} else {
				vm.pen.pen_lat = 43.8900745;
				vm.pen.pen_lng = 20.3492278;
				addMarkerToMap = false;
				zoom = 3;
				has_marker = false;
				vm.latLngMissing = true;
			}
			var marker;
			var id = 'google-maps';
			var geocoder = new google.maps.Geocoder();
			var mapCanvas = document.getElementById(id);
			var mapOptions = {
				center: new google.maps.LatLng(vm.pen.pen_lat, vm.pen.pen_lng),
				zoom: zoom,
				mapTypeId: google.maps.MapTypeId.HYBRID,
				labels: true
			};
			var map = new google.maps.Map(mapCanvas, mapOptions);
			if (!map || !map.renderingType) {
				vm.showGMap = false;
				return;
			}
			var latLng = {
				lat: Number(vm.pen.pen_lat),
				lng: Number(vm.pen.pen_lng)
			};
			if (typeof latLng.lat == 'number' && typeof latLng.lng == 'number' && !isNaN(latLng.lat) && !isNaN(latLng.lng) && addMarkerToMap) {
				placeMarker(latLng, map);
			}

			function placeMarker(position, map) {
				marker = new google.maps.Marker({
					position: position,
					map: map,
					draggable: true
				});
				vm.pen.pen_lat = position.lat;
				vm.pen.pen_lng = position.lng;
				map.panTo(position);
				if (!first_init) {
					geocodePosition(marker.getPosition());
				}
				google.maps.event.addListener(marker, 'dragend', function (event) {
					vm.pen.pen_lat = event.latLng.lat();
					vm.pen.pen_lng = event.latLng.lng();
					geocodePosition(marker.getPosition());
				});

				function geocodePosition(pos) {
					geocoder.geocode(
						{
							latLng: pos
						},
						function (responses) {
							$timeout(function () {
								vm.pen.pen_address = responses[0].formatted_address;
							}, 0);
						}
					);
				}
			}
			drawingManager.setMap(map);
			if (listener) {
				google.maps.event.removeListener(listener);
			}
			if (!addMarkerToMap) {
				map.addListener('click', function (e) {
					if (!has_marker) {
						placeMarker(e.latLng, map);
						has_marker = true;
					}
				});
			}
			listener = google.maps.event.addListener(drawingManager, 'polygoncomplete', function (polygon) {
				if (vm.pen.pen_location && vm.pen.pen_location.length > 1) {
					drawingManager.setOptions({
						drawingControl: false
					});
				}
				drawingManager.setDrawingMode(null);
				var arr = polygon.getPath().getArray();
				var coordinates = [];
				for (var i = 0; i < arr.length; i++) {
					var coordinate = {
						lat: arr[i].lat(),
						lng: arr[i].lng()
					};
					coordinates.push(coordinate);
				}
				if (coordinates.length > 6) {
					polygon.setMap(null);
					drawingManager.setOptions({
						drawingControl: true
					});
				} else {
					vm.pen.pen_location.push(coordinates);
					$timeout(function () {
						vm.locationSelected = true;
					}, 0);
				}
				$timeout(function () {
					vm.locationSelected = true;
				}, 0);
			});
			var input = document.getElementById('pen_address');
			var searchBox = new google.maps.places.SearchBox(input);
			searchBox.addListener('places_changed', function () {
				var places = searchBox.getPlaces();
				if (places.length == 0) {
					return;
				}
				// Clear out the old markers.
				marker.setMap(null);
				// For each place, get the icon, name and location.
				var bounds = new google.maps.LatLngBounds();
				places.forEach(function (place) {
					if (!place.geometry) {
						console.log('Returned place contains no geometry');
						return;
					} else {
						vm.pen.pen_address = place.formatted_address;
						var latlng = {
							lat: place.geometry.location.lat(),
							lng: place.geometry.location.lng()
						};
						placeMarker(latlng, map);
					}
					// Create a marker for each place.
					if (place.geometry.viewport) {
						// Only geocodes have viewport.
						bounds.union(place.geometry.viewport);
					} else {
						bounds.extend(place.geometry.location);
					}
				});
			});
			if (vm.firstInit) {
				vm.firstInit = false;
				if (vm.pen.pen_location) {
					var pen = new google.maps.Polygon({
						paths: vm.pen.pen_location,
						strokeColor: '#FF0000',
						strokeOpacity: 0.8,
						strokeWeight: 2,
						fillColor: '#FF0000',
						fillOpacity: 0.35
					});
					pen.setMap(map);
					if (vm.pen.pen_location.length < 3) {
						drawingManager.setOptions({
							drawingControl: true
						});
					}
				} else {
					drawingManager.setOptions({
						drawingControl: true
					});
					vm.locationSelected = false;
				}
			}
		}*/

		function cancelWizard() {
			if (vm.from_recipe) {
				if (vm.from_recipe.type == 'add') {
					$state.go('recipes.addNewRecipe');
				} else if (vm.from_recipe.type == 'edit') {
					$state.go('recipes.editRecipe', {
						uuid: vm.from_recipe.uuid
					});
				}
			} else if (vm.from_calendar) {
				$state.go('calendar');
			} else {
				$state.go('pens.myPens');
			}
		}

		function savePen() {
			if (vm.settings && vm.settings.selectedTeam.id) {
				cancel();
				vm.loading = true;
				var penDTO = angular.copy(vm.pen);
				penDTO.team_id = vm.settings.selectedTeam.id;
				penDTO.herd_id = vm.settings.selectedHerd.id;
				penDTO.automatic_update = vm.automatic_update;
				penDTO.pen_active = vm.pen_active;
				penDTO.event = vm.event;
				if (vm.selected_pen_category.id === null) {
					penDTO.pen_category = {
						name: vm.selected_pen_category.name,
						feed_intake: vm.selected_pen_category.feed_intake,
						id: null
					};
				} else {
					penDTO.pen_category = {
						name: vm.selected_pen_category.name,
						feed_intake: vm.selected_pen_category.feed_intake,
						id: vm.selected_pen_category.id
					};
				}
				if (penDTO.pen_location && penDTO.pen_location.length > 0) {
					penDTO.pen_location = JSON.stringify(penDTO.pen_location);
				} else {
					penDTO.pen_location = null;
				}
				penDTO.last_modified_user = vm.user.email;
				penDTO.last_modified_date = null;
				penDTO.pen_feeding_scheduler_list = createScheduler(penDTO);
				editPenFactory
					.editPen(penDTO)
					.then(function () {
						toastr.success(i18nFilter('_toastr_edit_pen_'), i18nFilter('_toastr_success_title_'));
						appService.setDisableRecipeUpdate();
						cancelWizard();
					})
					.catch(function (error) {
						console.log(error);
						vm.loading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_updating_pen_');
					});
			}
		}

		function categorySelected() {
			if (vm.selected_pen_category.id == 'new_category') {
				vm.addCategoryLoading = false;
				vm.selected_pen_category = null;
				openModal('app/pages/pens/addNewPen/addCategory.modal.html', 'sm');
			} else {
				vm.pen.feed_intake = vm.selected_pen_category.feed_intake;
			}
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function cancel() {
			$uibModalStack.dismissAll();
		}

		function addNewCategory() {
			vm.addCategoryLoading = true;
			var category = {
				name: vm.newCategory.name,
				feed_intake: vm.newCategory.feed_intake,
				id: null
			};
			vm.pen.feed_intake = vm.newCategory.feed_intake;
			var index = vm.categories.length - 1;
			vm.categories.splice(index, 0, category);
			vm.selected_pen_category = category;
			cancel();
		}

		//remove default tooltip
		(function removeDefaultTooltip() {
			var tooltipInterval = $interval(
				function () {
					$timeout(function () {
						var tabs = document.getElementsByClassName('wizard-step');
						var tabLoaded = document.getElementById('edit-pen-tabs');
						if (tabLoaded) {
							for (var i = 0; i < tabs.length; i++) {
								tabs[i]._title = tabs[i].title;
								tabs[i].onmouseenter = function () {
									this.title = '';
								};
								tabs[i].onmouseleave = function () {
									this.title = this._title;
								};
							}
							$interval.cancel(tooltipInterval);
						}
					}, 50);
				},
				1500,
				15
			);
		})();

		$scope.$on('$stateChangeStart', function (event, toState) {
			if (toState.url !== '/editRecipe/{uuid:string}' && toState.url !== '/addNewRecipe') {
				dataServiceFactory.add_new_recipe_data = {};
				dataServiceFactory.edit_recipe_data = {};
				localStorage.removeItem('from_recipe');
			}
			if (toState.name !== 'calendar') {
				localStorage.removeItem('from_calendar');
				dataServiceFactory.calendarEvent = null;
				dataServiceFactory.feedingDate = null;
				dataServiceFactory.agenda = {};
			}
		});

		angular.element($window).bind('resize', function () {
			if (resizeTimer) {
				$timeout.cancel(resizeTimer);
			}
			resizeTimer = $timeout(function () {
				vm.resetTable = true;
				$timeout(function () {
					vm.resetTable = false;
				}, 1);
			}, 200);
		});

		function tabValidation() {
			return {
				'basic-tab-validation': vm.basicInfoForm && vm.basicInfoForm.$invalid,
				'feeding-info-tab-validation': vm.feedingInfoForm && vm.feedingInfoForm.$invalid
			};
		}

		function disableSaveButton() {
			return (vm.basicInfoForm && vm.basicInfoForm.$invalid) || (vm.feedingInfoForm && vm.feedingInfoForm.$invalid);
		}
		$scope.$on('$destroy', function () {
			angular.element($window).unbind('resize');
		});

		$scope.$on('default_herd_selected', function () {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_team_herd_changed', function () {
			init();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.pens.editPen').factory('editPenFactory', editPenFactory);
	/** @ngInject */

	function editPenFactory(APP_CONST, $http, $q) {
		return {
			getPenById: getPenById,
			editPen: editPen,
			getCategories: getCategories,
			getCategoryById: getCategoryById,
			getActiveRecipes: getActiveRecipes
		};

		function getPenById(id, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'pens/' + id + suffix)
				.then(success)
				.catch(error);
		}

		function editPen(pen) {
			return $http
				.put(APP_CONST.api_base_url + 'pens', pen)
				.then(success)
				.catch(error);
		}

		function getCategories(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'penCategories' + suffix)
				.then(success)
				.catch(error);
		}

		function getCategoryById(id) {
			return $http
				.get(APP_CONST.api_base_url + 'penCategory/' + id)
				.then(success)
				.catch(error);
		}

		function getActiveRecipes(pen) {
			return $http
				.get(APP_CONST.api_base_url + 'recipe/pens/' + pen)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.pens.myPens').controller('myPensCtrl', myPensCtrl);
	/** @ngInject */
	function myPensCtrl($state, $scope, myPensFactory, $cookies, $uibModal, $uibModalStack, APP_CONST, $filter, errorService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var parseString = rrule.rrulestr;

		vm.selectLayout = selectLayout;
		vm.goToPenHistory = goToPenHistory;
		vm.editPen = editPen;
		vm.penDetails = penDetails;
		vm.changeActive = changeActive;
		vm.deletePen = deletePen;
		vm.paginationChanged = paginationChanged;
		vm.reloadApi = reloadApi;
		vm.proceedDelete = proceedDelete;
		vm.sort = sort;

		init();

		function init() {
			vm.loading = true;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.selectedHerd = vm.settings.selectedHerd.id;
			vm.selectedTeam = vm.settings.selectedTeam.id;
			setCurrentLayout();
			setCurrentPage();
			setCustomDays();
			vm.categories = [
				{
					name: 'Milking cows HP',
					feed_intake: 23,
					id: '1'
				},
				{
					name: 'Milking cows LP',
					feed_intake: 21,
					id: '2'
				},
				{
					name: 'Dry cows',
					feed_intake: 13,
					id: '3'
				},
				{
					name: 'Hifers (2nd year of life)',
					feed_intake: 10,
					id: '4'
				},
				{
					name: 'Hifers (1st year of life)',
					feed_intake: 6,
					id: '5'
				}
			];
			vm.category_names = [
				{
					name: i18nFilter('_milking_cows_hp_'),
					id: 1
				},
				{
					name: i18nFilter('_milking_cows_lp_'),
					id: 2
				},
				{
					name: i18nFilter('_dry_cows_'),
					id: 3
				},
				{
					name: i18nFilter('_heifers_2nd_year_of_life_'),
					id: 4
				},
				{
					name: i18nFilter('_heifers_1st_year_of_life_'),
					id: 5
				},
				{
					name: i18nFilter('_fattening_bulls_'),
					id: 6
				},
				{
					name: i18nFilter('_calves_'),
					id: 7
				}
			];
			vm.pens = [];
			if (vm.selectedHerd) {
				vm.currentPage = 1;
				getPens(true);
			} else {
				vm.loading = false;
			}
		}

		function reloadApi() {
			vm.loading = true;
			vm.pens = [];
			if (vm.selectedHerd) {
				vm.currentPage = 1;
				getPens(true);
			} else {
				vm.loading = false;
			}
		}

		function setCurrentLayout() {
			var data = $cookies.get('pen_layout');
			if (data) {
				vm.selectedLayout = data;
			} else {
				vm.selectedLayout = 1;
				$cookies.put('pen_layout', 1);
			}
		}

		function setCurrentPage() {
			var data = localStorage.getItem('pen_curent_page');
			if (data) {
				vm.currentPage = data;
			} else {
				vm.currentPage = 1;
			}
		}

		function sort(column) {
			if (vm.orderBy !== column) {
				vm.orderBy = column;
				vm.orderType = 'DESC';
				vm.sortCol = column + '_DESC';
			} else {
				if (!vm.orderType) {
					vm.orderType = 'DESC';
					vm.sortCol = column + '_DESC';
				} else if (vm.orderType === 'DESC') {
					vm.orderType = 'ASC';
					vm.sortCol = column + '_ASC';
				} else {
					vm.orderBy = null;
					vm.orderType = null;
					vm.sortCol = null;
				}
			}

			vm.loadingTable = true;
			vm.pens = [];
			vm.currentPage = 1;
			getPens();
		}

		function paginationChanged() {
			vm.loadingTable = true;
			vm.currentPage++;
			getPens();
		}

		function getPens(init) {
			vm.feed_date_start = [];
			var suffix = '?page=' + vm.currentPage + '&team=' + vm.selectedTeam + '&herd=' + vm.selectedHerd;

			if (vm.orderBy) {
				suffix += '&orderBy=' + vm.orderBy;
			}
			if (vm.orderType) {
				suffix += '&orderType=' + vm.orderType;
			}

			return myPensFactory
				.getPensByTeamHerd(suffix)
				.then(function (response) {
					if (response[0]) {
						vm.totalItems = response[0].number_of_all;
					} else {
						vm.totalItems = 0;
					}
					for (var i = 0; i < response.length; i++) {
						response[i].pen_feeding_scheduler_list = $filter('orderBy')(response[i].pen_feeding_scheduler_list, 'start_feeding_date');
						for (var j = 0; j < response[i].pen_feeding_scheduler_list.length; j++) {
							response[i].pen_feeding_scheduler_list[j].end_feeding_date = getSchedulerEndDate(response[i].pen_feeding_scheduler_list[j + 1] ? response[i].pen_feeding_scheduler_list[j + 1].start_feeding_date : null);
						}
						if (response[i].feeding_1) {
							response[i].feeding_1_time = moment.utc(moment().format('YYYY-MM-DD') + 'T' + response[i].feeding_1).format('YYYY-MM-DDTHH:mm:ss');
						}
						if (response[i].feeding_2) {
							response[i].feeding_2_time = moment.utc(moment().format('YYYY-MM-DD') + 'T' + response[i].feeding_2).format('YYYY-MM-DDTHH:mm:ss');
						}
						if (response[i].feeding_3) {
							response[i].feeding_3_time = moment.utc(moment().format('YYYY-MM-DD') + 'T' + response[i].feeding_3).format('YYYY-MM-DDTHH:mm:ss');
						}
						for (var k = 0; k < vm.categories.length; k++) {
							if (response[i].category == vm.categories[k].id) {
								response[i].category = vm.categories[k].name;
							}
						}
						var date = new Date();
						response[i].active_pen_feeding_scheduler_list = getActiveSchedulerByDate(response[i], date);
						if (!response[i].active_pen_feeding_scheduler_list) {
							response[i].active_pen_feeding_scheduler_list = response[i].pen_feeding_scheduler_list[0];
						}
						if (response[i].active_pen_feeding_scheduler_list.feeding_frequency_rule) {
							vm.feed_date_start = response[i].active_pen_feeding_scheduler_list.start_feeding_date;
							var current_date = new Date().toISOString().slice(0, 10);
							if (vm.feed_date_start > current_date) {
								vm.futureFeed = true;
							} else {
								vm.futureFeed = false;
							}
							response[i].feeding_frequency = getFrequency(response[i].active_pen_feeding_scheduler_list.feeding_frequency_rule);
							response[i].feeding_started = response[i].active_pen_feeding_scheduler_list.start_feeding_date;
						}
					}
					vm.pens = vm.pens.concat(response);
					vm.loading = false;
					vm.loadingTable = false;
					setCategoryName(response);
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					vm.loadingTable = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_pen_', init);
				});
		}

		function getSchedulerEndDate(next_scheduler) {
			var end_date = moment().add(31, 'd').format('YYYY-MM-DD');
			if (next_scheduler) {
				end_date = moment(next_scheduler).subtract(1, 'd').format('YYYY-MM-DD');
			}

			return end_date;
		}

		function getActiveSchedulerByDate(pen, date) {
			var active_schedule;
			var today = new Date(date);
			today.setHours(12, 0, 0);
			for (var i = 0; i < pen.pen_feeding_scheduler_list.length; i++) {
				var start_date = new Date(pen.pen_feeding_scheduler_list[i].start_feeding_date);
				start_date.setHours(12, 0, 0);
				var end_date = new Date(pen.pen_feeding_scheduler_list[i].end_feeding_date);
				end_date.setHours(12, 0, 0);
				if ((moment(start_date).isBefore(today) || moment(start_date).isSame(today, 'day')) && (moment(end_date).isAfter(today) || moment(end_date).isSame(today, 'day'))) {
					active_schedule = pen.pen_feeding_scheduler_list[i];
					break;
				}
			}
			return active_schedule;
		}

		function getFrequency(feeding_frequency_rule) {
			var rule = parseString(feeding_frequency_rule);
			if (rule) {
				var byWeekDay = rule.options.byweekday;
				var interval = rule.options.interval;
				var string = '';
				if (byWeekDay && byWeekDay.length && !vm.futureFeed) {
					for (var i = 0; i < vm.days.length; i++) {
						for (var j = 0; j < byWeekDay.length; j++) {
							if (vm.days[i].value == byWeekDay[j]) {
								if (string != '') {
									string += ', ';
								}
								string += vm.days[i].name;
							}
							if (vm.futureFeed) {
								string = i18nFilter('_feeding_not_started_');
							}
						}
					}
				} else {
					if (interval && !vm.futureFeed) {
						if (interval == 1) {
							string = i18nFilter('_every_day_frequency_');
						} else if (interval == 2) {
							string = i18nFilter('_every_two_day_frequency_');
						} else if (interval == 3) {
							string = i18nFilter('_every_three_day_frequency_');
						} else {
							string = i18nFilter('_dc_other_');
						}
					} else if (vm.futureFeed) {
						string = i18nFilter('_feeding_not_started_');
					}
				}
				return string;
			}
		}

		function setCustomDays() {
			vm.days = [];
			var listOfDays = APP_CONST.constants.custom_feeding_days;
			for (var i = 0; i < listOfDays.length; i++) {
				var obj = {
					name: i18nFilter(listOfDays[i].name),
					value: listOfDays[i].value
				};
				vm.days.push(obj);
			}
		}
		function setCategoryName(categories) {
			for (var i = 0; i < categories.length; i++) {
				for (var j = 0; j < vm.category_names.length; j++) {
					if (categories[i].pen_category.id == vm.category_names[j].id) {
						categories[i].pen_category.name = vm.category_names[j].name;
					}
				}
			}
			return categories;
		}

		function deletePen(index, pen) {
			vm.deleteData = pen;
			vm.deleteIndex = index;
			vm.warningMessage = '_pen_delete_warning_message_';
			openModal('app/pages/pens/myPens/confirmationDialog.modal.html', 'md');
		}

		function proceedDelete() {
			vm.modalLoading = true;
			vm.deleteData.last_modified_user = vm.user.email;
			var deleteDto = angular.copy(vm.deleteData);
			deleteDto.feeding_1 = $filter('date')(deleteDto.feeding_1, 'HH:mm:ss"Z"');
			deleteDto.feeding_2 = $filter('date')(deleteDto.feeding_2, 'HH:mm:ss"Z"');
			deleteDto.feeding_3 = $filter('date')(deleteDto.feeding_3, 'HH:mm:ss"Z"');
			return myPensFactory
				.deletePen([deleteDto])
				.then(function () {
					vm.pens.splice(vm.deleteIndex, 1);
					vm.totalItems--;
					if (vm.pens.length === 0) {
						vm.currentPage = 1;
						getPens();
					}
					$uibModalStack.dismissAll();
					vm.modalLoading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.modalLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_deleting_pen_');
				});
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function goToPenHistory(id) {
			$state.go('pens.penHistory', {
				uuid: id
			});

			localStorage.setItem('pen_curent_page', vm.currentPage);
		}

		function editPen(pen) {
			$state.go('pens.editPen', {
				uuid: pen.id
			});
			localStorage.setItem('pen_curent_page', vm.currentPage);
		}

		function penDetails(pen) {
			$state.go('pens.penDetails', {
				uuid: pen.id
			});
			localStorage.setItem('pen_curent_page', vm.currentPage);
		}

		function changeActive(pen, index) {
			vm.pens[index].pen_active = !vm.pens[index].pen_active;
			pen.last_modified_user = vm.user.email;
			var penDto = angular.copy(pen);
			penDto.feeding_1 = $filter('date')(penDto.feeding_1, 'HH:mm:ss"Z"');
			penDto.feeding_2 = $filter('date')(penDto.feeding_2, 'HH:mm:ss"Z"');
			penDto.feeding_3 = $filter('date')(penDto.feeding_3, 'HH:mm:ss"Z"');
			myPensFactory.updatePen(penDto).catch(function (error) {
				console.log(error);
				vm.pens[index].pen_active = !vm.pens[index].pen_active;
				errorService.showErrorMessage(error, true, '_error_occurred_changing_active_pen_');
			});
		}

		function selectLayout(type) {
			vm.selectedLayout = type;
			$cookies.put('pen_layout', vm.selectedLayout);
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});

		$scope.$on('default_team_herd_changed', function () {
			init();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.pens.myPens').factory('myPensFactory', myPensFactory);
	/** @ngInject */
	function myPensFactory(APP_CONST, $http, $q) {
		return {
			getPensByTeamHerd: getPensByTeamHerd,
			deletePen: deletePen,
			updatePen: updatePen
		};

		function getPensByTeamHerd(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'pens' + suffix)
				.then(success)
				.catch(error);
		}

		function deletePen(pen) {
			return $http
				.post(APP_CONST.api_base_url + 'pens/remove', pen)
				.then(success)
				.catch(error);
		}

		function updatePen(pen) {
			return $http
				.put(APP_CONST.api_base_url + 'pens/active', pen)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.pens.penDetails').controller('penDetailsCtrl', penDetailsCtrl);
	/** @ngInject */
	function penDetailsCtrl($timeout, $scope, $state, $filter, $stateParams, APP_CONST, penDetailsFactory, errorService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var parseString = rrule.rrulestr;
		vm.reloadApi = reloadApi;
		vm.back = back;

		init();

		function init() {
			setCustomDays();
			vm.selectedTeamHerd = false;
			vm.detailsLoading = false;
			vm.showGMap = true;
			vm.frequencies = [
				{
					name: 'Every day',
					value: 1
				},
				{
					name: 'Every 2 days',
					value: 2
				},
				{
					name: 'Every 3 days',
					value: 3
				}
			];
			vm.category_names = [
				{
					name: i18nFilter('_milking_cows_hp_'),
					id: 1
				},
				{
					name: i18nFilter('_milking_cows_lp_'),
					id: 2
				},
				{
					name: i18nFilter('_dry_cows_'),
					id: 3
				},
				{
					name: i18nFilter('_heifers_2nd_year_of_life_'),
					id: 4
				},
				{
					name: i18nFilter('_heifers_1st_year_of_life_'),
					id: 5
				},
				{
					name: i18nFilter('_fattening_bulls_'),
					id: 6
				},
				{
					name: i18nFilter('_calves_'),
					id: 7
				}
			];
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			if (vm.settings && vm.settings.selectedTeam.id && vm.settings.selectedHerd.id) {
				vm.selectedTeam = vm.settings.selectedTeam.id;
				vm.selectedHerd = vm.settings.selectedHerd.id;
				getPenById($stateParams.uuid);
				vm.selectedTeamHerd = false;
			} else {
				vm.detailsLoading = false;
			}
		}

		function reloadApi() {
			vm.showGMap = true;
			vm.detailsLoading = false;
			if (vm.settings && vm.settings.selectedTeam.id && vm.settings.selectedHerd.id) {
				getPenById($stateParams.uuid);
			} else {
				vm.detailsLoading = false;
			}
		}

		function setCustomDays() {
			vm.days = [];
			var listOfDays = APP_CONST.constants.custom_feeding_days;
			for (var i = 0; i < listOfDays.length; i++) {
				var obj = {
					name: i18nFilter(listOfDays[i].longName),
					value: listOfDays[i].value
				};
				vm.days.push(obj);
			}
		}

		function back() {
			$state.go('pens.myPens');
		}

		function getFrequency(feeding_frequency_rule) {
			var rule = parseString(feeding_frequency_rule);
			if (rule) {
				var byWeekDay = rule.options.byweekday;
				var interval = rule.options.interval;
				var string = '';
				if (byWeekDay && byWeekDay.length) {
					for (var i = 0; i < vm.days.length; i++) {
						for (var j = 0; j < byWeekDay.length; j++) {
							if (vm.days[i].value == byWeekDay[j]) {
								if (string != '') {
									string += ', ';
								}
								string += vm.days[i].name;
							}
						}
					}
				} else {
					if (interval) {
						if (interval == 1) {
							string = i18nFilter('_every_day_frequency_');
						} else if (interval == 2) {
							string = i18nFilter('_every_two_day_frequency_');
						} else if (interval == 3) {
							string = i18nFilter('_every_three_day_frequency_');
						} else {
							string = i18nFilter('_dc_other_');
						}
					}
				}
				return string;
			}
		}

		function getPenById(id) {
			vm.detailsLoading = true;
			var suffix = '?team=' + vm.settings.selectedTeam.id + '&herd=' + vm.settings.selectedHerd.id;
			return penDetailsFactory
				.getPenById(id, suffix)
				.then(function (response) {
					for (var i = 0; i < vm.frequencies.length; i++) {
						if (response.feeding_frequency == vm.frequencies[i].value) {
							response.feeding_frequency = vm.frequencies[i].name;
						}
					}
					if (!vm.settings.use_kgs) {
						vm.weight = 'Lb';
					} else {
						vm.weight = 'Kg';
					}

					for (var j = 0; j < response.pen_feeding_scheduler_list.length; j++) {
						if (response.pen_feeding_scheduler_list[j].feeding_frequency_rule) {
							response.pen_feeding_scheduler_list[j].feeding_frequency = getFrequency(response.pen_feeding_scheduler_list[j].feeding_frequency_rule);
						}
						var numb = 0;
						if (response.pen_feeding_scheduler_list[j].evening_feeding) {
							numb += 1;
						}
						if (response.pen_feeding_scheduler_list[j].morning_feeding) {
							numb += 1;
						}
						if (response.pen_feeding_scheduler_list[j].noon_feeding) {
							numb += 1;
						}
						response.pen_feeding_scheduler_list[j].number_of_feedings = numb;
						if (response.pen_feeding_scheduler_list[j].morning_feeding_time) {
							response.pen_feeding_scheduler_list[j].morning_feeding_time = moment(moment().format('YYYY-MM-DD') + 'T' + response.pen_feeding_scheduler_list[j].morning_feeding_time).toDate();
						}
						if (response.pen_feeding_scheduler_list[j].noon_feeding_time) {
							response.pen_feeding_scheduler_list[j].noon_feeding_time = moment(moment().format('YYYY-MM-DD') + 'T' + response.pen_feeding_scheduler_list[j].noon_feeding_time).toDate();
						}
						if (response.pen_feeding_scheduler_list[j].evening_feeding_time) {
							response.pen_feeding_scheduler_list[j].evening_feeding_time = moment(moment().format('YYYY-MM-DD') + 'T' + response.pen_feeding_scheduler_list[j].evening_feeding_time).toDate();
						}
					}
					response.pen_feeding_scheduler_list = currentlyActiveSchedule(response.pen_feeding_scheduler_list);
					response.dmi_source = response.use_pen_feed_intake ? $filter('i18n')('_m_f_fixed_') : $filter('i18n')('_m_f_ration_depending_');
					vm.details = response;
					vm.detailsLoading = false;
					if (vm.settings.selectedTeam.id == vm.details.team_id) {
						vm.selectedTeamHerd = true;
					} else {
						vm.selectedTeamHerd = false;
					}
					if (vm.settings.selectedHerd.id == vm.details.herd_id) {
						vm.selectedTeamHerd = true;
					} else {
						vm.selectedTeamHerd = false;
					}
					$timeout(function () {
						//initialize();
					}, 100);
					setCategoryName(response);
				})
				.catch(function (error) {
					console.log(error);
					vm.detailsLoading = false;
					vm.selectedTeamHerd = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_pen_details_', true);
				});
		}

		function setCategoryName(categories) {
				for (var j = 0; j < vm.category_names.length; j++) {
					if (categories.pen_category.id == vm.category_names[j].id) {
						categories.pen_category.name = vm.category_names[j].name;
					}
				}
			return categories;
		}

		function currentlyActiveSchedule(schedule) {
			schedule = $filter('orderBy')(schedule, 'start_feeding_date', true);
			for (var i = 0; i < schedule.length; i++) {
				var current_date = moment().format('YYYY-MM-DD');
				if (current_date == schedule[i].start_feeding_date || moment(current_date).isAfter(schedule[i].start_feeding_date)) {
					schedule[i].schedule_set = true;
					break;
				}
			}
			return schedule;
		}

		/* function initialize() {
			try {
				var addMarkerToMap;
				var zoom;
				if (vm.details.pen_address && (!vm.details.pen_lat || vm.details.pen_lng)) {
					var geocoder = new google.maps.Geocoder();
					geocoder.geocode(
						{
							address: vm.details.pen_address
						},
						function (results, status) {
							if (status === 'OK') {
								var lat = results[0].geometry.location.lat();
								var lng = results[0].geometry.location.lng();
								vm.details.pen_lat = lat;
								vm.details.pen_lng = lng;
							}
						}
					);
				}
				if (vm.details.pen_lat && vm.details.pen_lng) {
					addMarkerToMap = true;
					zoom = 16;
				} else {
					vm.details.pen_lat = 43.8900745;
					vm.details.pen_lng = 20.3492278;
					addMarkerToMap = false;
					zoom = 3;
					vm.latLngMissing = true;
				}
				var id = 'google-maps';
				var mapCanvas = document.getElementById(id);
				var mapOptions = {
					center: new google.maps.LatLng(vm.details.pen_lat, vm.details.pen_lng),
					zoom: zoom,
					mapTypeId: google.maps.MapTypeId.SATELLITE
				};
				var map = new google.maps.Map(mapCanvas, mapOptions);
				if (!map || !map.renderingType) {
					vm.showGMap = false;
					return;
				}
				var latLng = {
					lat: Number(vm.details.pen_lat),
					lng: Number(vm.details.pen_lng)
				};
				if (typeof latLng.lat === 'number' && typeof latLng.lng === 'number' && !isNaN(latLng.lat) && !isNaN(latLng.lng) && addMarkerToMap) {
					map.panTo(latLng);
				}
				if (vm.details.pen_location) {
					var pen = new google.maps.Polygon({
						paths: JSON.parse(vm.details.pen_location),
						strokeColor: '#FF0000',
						strokeOpacity: 0.8,
						strokeWeight: 2,
						fillColor: '#FF0000',
						fillOpacity: 0.35
					});
					pen.setMap(map);
				}
			} catch (error) {
				console.log(error);
			}
		} */

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_team_selected', function () {
			vm.selectedHerd = null;
			vm.selectedTeam = null;
			init();
		});

		$scope.$on('default_herd_selected', function () {
			vm.selectedHerd = null;
			vm.selectedTeam = null;
			init();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.pens.penDetails').factory('penDetailsFactory', penDetailsFactory);
	/** @ngInject */
	function penDetailsFactory(APP_CONST, $http, $q) {
		return {
			getPenById: getPenById
		};

		function getPenById(id, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'pens/' + id + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.pens.penHistory').controller('penHistoryCtrl', penHistoryCtrl);
	/** @ngInject */
	function penHistoryCtrl($stateParams, $state, $filter, penHistoryFactory, $q, $scope, errorService) {
		var vm = this;
		var history;
		vm.paginationChanged = paginationChanged;
		vm.reloadApi = reloadApi;
		vm.back = back;
		init();

		function init() {
			vm.pen_id = $stateParams.uuid;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.from_recipe = JSON.parse(localStorage.getItem('from_recipe'));
			vm.history = [];
			vm.historySafe = vm.history;
			if (vm.settings.use_kgs) {
				vm.weight = 'Kg';
			} else {
				vm.weight = 'Lb';
			}
			if (vm.settings && vm.settings.selectedTeam.id) {
				vm.selectedTeam = vm.settings.selectedTeam.id;
				vm.categoriesLoaded = false;
				vm.categories = [];
				history = $q.defer();
				vm.currentPage = 1;
				getPenHistory(vm.pen_id, true);
				//getCategories();
				$q.all([history.promise])
					.then(function (response) {
						handleHistoryResponse(response[0]);
						vm.categoriesLoaded = true;
					})
					.catch(function (error) {
						vm.categoriesLoaded = true;
						console.log(error);
					});
			}
		}

		function reloadApi() {
			if (vm.settings && vm.settings.selectedTeam.id) {
				vm.selectedTeam = vm.settings.selectedTeam.id;
				vm.categoriesLoaded = false;
				vm.categories = [];
				history = $q.defer();
				vm.currentPage = 1;
				getPenHistory(vm.pen_id, true);
				$q.all([history.promise])
					.then(function (response) {
						handleHistoryResponse(response[0]);
						vm.categoriesLoaded = true;
					})
					.catch(function (error) {
						vm.categoriesLoaded = true;
						console.log(error);
					});
			}
		}


		function getPenHistory(id, init) {
			var suffix = '?page=' + vm.currentPage + '&team=' + vm.selectedTeam;
			vm.loadingTable = true;
			return penHistoryFactory
				.getPenHistory(id, suffix)
				.then(function (response) {
					if (!vm.categoriesLoaded) {
						history.resolve(response);
					} else {
						handleHistoryResponse(response);
					}
				})
				.catch(function (error) {
					history.reject(error);
					vm.loadingTable = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_pen_history_', init);
				});
		}

		function back() {
			if (vm.from_recipe) {
				if (vm.from_recipe.type == 'add') {
					$state.go('recipes.addNewRecipe');
				} else if (vm.from_recipe.type == 'edit') {
					$state.go('recipes.editRecipe', {
						uuid: vm.from_recipe.uuid
					});
				}
			} else {
				$state.go('pens.myPens');
			}
		}

		function handleHistoryResponse(response) {
			if (response[0]) {
				vm.totalItems = response[0].number_of_all;
			}
			for (var i = 0; i < response.length; i++) {
				response[i].feedings = [];
				if (response[i].feeding_1) {
					response[i].feedings.push({
						date: response[i].feeding_1
					});
				}
				if (response[i].feeding_2) {
					response[i].feedings.push({
						date: response[i].feeding_2
					});
				}
				if (response[i].feeding_3) {
					response[i].feedings.push({
						date: response[i].feeding_3
					});
				}
				for (var c = 0; c < vm.categories.length; c++) {
					if (response[i].pen_category_id == vm.categories[c].id) {
						response[i].pen_category = vm.categories[c].name;
						break;
					}
				}
			}
			vm.loadingTable = false;
			vm.history = vm.history.concat(response);
		}

		function paginationChanged() {
			vm.currentPage++;
			getPenHistory(vm.pen_id);
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.pens.penHistory').factory('penHistoryFactory', penHistoryFactory);
	/** @ngInject */
	function penHistoryFactory(APP_CONST, $http, $q) {
		return {
			getPenHistory: getPenHistory,
			getCategories: getCategories
		};

		function getPenHistory(id, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'penHistory/' + id + suffix)
				.then(success)
				.catch(error);
		}

		function getCategories(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'penCategories' + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.premixes.addNewPremix').controller('addNewPremixCtrl', addNewPremixCtrl);

	/** @ngInject */
	function addNewPremixCtrl($state, $filter, addNewPremixService, APP_CONST, $timeout, editableOptions, editableThemes, $locale, dataServiceFactory, $scope, $rootScope, $uibModal, $uibModalStack, errorService, $interval, authService, unitConversionService, uaParser) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var nfdTimer;
		var nfcTimer;
		var nfaTimer;
		var nfaDTimer;
		var nfaAFTimer;
		var RRule = rrule.RRule;
		vm.reloadApi = reloadApi;
		vm.calculateTotalPremixAmount = calculateTotalPremixAmount;
		vm.cancelWizard = cancelWizard;
		vm.savePremix = savePremix;
		vm.disableSaveButton = disableSaveButton;
		vm.tabValidation = tabValidation;
		vm.basisChanged = basisChanged;
		vm.addNewFeed = addNewFeed;
		vm.openAddNewFeedForm = openAddNewFeedForm;
		vm.cancelAddNewFeed = cancelAddNewFeed;
		vm.newFeedDmChanged = newFeedDmChanged;
		vm.newFeedCostDmChanged = newFeedCostDmChanged;
		vm.newFeedCostAsFedChanged = newFeedCostAsFedChanged;
		vm.newFeedAmountDmChanged = newFeedAmountDmChanged;
		vm.newFeedAmountAsFedChanged = newFeedAmountAsFedChanged;
		vm.removeNewFeed = removeNewFeed;
		vm.updateNewFeed = updateNewFeed;
		vm.inputKeyPress = inputKeyPress;
		vm.feedTypeSelected = feedTypeSelected;
		vm.daySelected = daySelected;
		vm.wagonSelected = wagonSelected;
		vm.calculateTotalAmount = calculateTotalAmount;
		vm.amountOptionChanged = amountOptionChanged;
		vm.editBasis = editBasis;
		vm.selectBasis = selectBasis;
		vm.basisDetails = basisDetails;
		vm.basisPaginationChanged = basisPaginationChanged;
		vm.timeChanged = timeChanged;
		vm.addWagon = addWagon;
		vm.openAddWagonModal = openAddWagonModal;
		vm.defaultSelected = defaultSelected;
		vm.removeWagon = removeWagon;
		vm.addExistingWagon = addExistingWagon;
		vm.openAddLoadModal = openAddLoadModal;
		vm.removeLoad = removeLoad;
		vm.openEditLoadModal = openEditLoadModal;
		vm.saveLoad = saveLoad;
		vm.calculateLoad = calculateLoad;
		vm.setLoad = setLoad;
		vm.cancel = cancel;
		vm.calculateSuggestion = calculateSuggestion;
		vm.move = move;
		vm.drag = drag;
		vm.premixDirty = premixDirty;
		vm.getFeedByName = getFeedByName;
		vm.feedSelected = feedSelected;
		vm.openMixingTimeSelector = openMixingTimeSelector;
		vm.getMinutes = getMinutes;
		vm.saveMixingTime = saveMixingTime;
		//var rationAccessCode = 1024;
		var rationAccessCode = 16;

		init();

		function init() {
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			var from_premix = JSON.parse(localStorage.getItem('from_premix'));
			if (from_premix && Object.keys(dataServiceFactory.add_new_premix_data).length !== 0) {
				vm.from_premix = from_premix;
			}
			if (!vm.settings.use_kgs) {
				vm.max = 88.18;
			} else {
				vm.max = 40;
			}
			localStorage.removeItem('from_premix');
			vm.device = uaParser.getDevice('type');
			if (vm.device) {
				vm.disableDrag = true;
			}
			checkLng();
			vm.selectedTeam = vm.settings.selectedTeam.id;
			vm.selectedHerd = vm.settings.selectedHerd.id;
			vm.loading = true;
			vm.loadingBasis = true;
			vm.today = moment().toDate();
			vm.new_feed = {};
			if (!vm.settings.use_kgs) {
				vm.weight = 'Lb';
			} else {
				vm.weight = 'Kg';
			}
			vm.datepickerOptions = {
				minDate: vm.today
			};
			if (vm.from_premix) {
				vm.premix = angular.copy(dataServiceFactory.add_new_premix_data);
			} else {
				vm.premix = {
					repeat_interval: 1,
					current_page: 1,
					total_amount: 0,
					total_premix_amount: 0,
					start_feeding_date: vm.today,
					feeds: []
				};
			}
			setFeedTypes(APP_CONST.constants.feed_types);
			setStrings();
			if (vm.selectedHerd) {
				getBasisData(true);
				if (!vm.premix.wagons_loaded) {
					getWagons(true);
				}
			} else {
				vm.loading = false;
			}
		}

		function checkLng() {
			if (vm.settings.language) {
				if (vm.settings.language == 'en-gb') {
					vm.locale = 'en-gb';
				} else if (vm.settings.language == 'en-us') {
					vm.locale = 'en';
				} else if (vm.settings.language == 'cs-cz') {
					vm.locale = 'cs';
				} else if (vm.settings.language == 'es-es') {
					vm.locale = 'es';
				} else if (vm.settings.language == 'nl-nl') {
					vm.locale = 'nl';
				} else if (vm.settings.language == 'it-it') {
					vm.locale = 'it';
				} else if (vm.settings.language == 'pl-pl') {
					vm.locale = 'pl';
				} else if (vm.settings.language == 'pt-br') {
					vm.locale = 'pt';
				} else if (vm.settings.language == 'de-de') {
					vm.locale = 'de';
				}
			} else {
				vm.locale = 'en-gb';
			}
		}
		function reloadApi() {
			vm.loading = true;
			vm.loadingBasis = true;
			vm.new_feed = {};
			if (vm.from_premix) {
				vm.premix = angular.copy(dataServiceFactory.add_new_premix_data);
			} else {
				vm.premix = {
					repeat_interval: 1,
					current_page: 1,
					total_amount: 0,
					total_premix_amount: 0,
					start_feeding_date: vm.today,
					feeds: []
				};
			}
			setStrings();
			if (vm.selectedHerd) {
				getBasisData(true);
				if (!vm.premix.wagons_loaded) {
					getWagons(true);
				}
			} else {
				vm.loading = false;
			}
		}

		function setStrings() {
			vm.step1 = i18nFilter('_m_f_add_new_premix_step1_title_');
			vm.step2 = i18nFilter('_m_f_add_new_premix_step2_title_');
			vm.step3 = i18nFilter('_m_f_add_new_premix_step3_title_');
			vm.step4 = i18nFilter('_m_f_add_new_premix_step4_title_');
			setBasisTypes();
			setAmountOptions();
			setRepeatIntervalOptions();
			setFeedingPeriods();
			if (!vm.from_premix) {
				setCustomDays();
			}
		}

		function setBasisTypes() {
			vm.basisTypes = [
				{
					name: i18nFilter('_m_f_premix_basis_add_manually_'),
					value: 3
				}
			];

			if (authService.can(rationAccessCode)) {
				vm.hasRationAccess = true;
				vm.basisTypes.splice(
					0,
					0,
					{
						name: i18nFilter('_m_f_premix_basis_ration_'),
						value: 0
					},
					{
						name: i18nFilter('_m_f_premix_basis_regular_premix_'),
						value: 2
					},
					{
						name: i18nFilter('_m_f_premix_basis_premix_'),
						value: 1
					}
				);
			} else {
				vm.hasRationAccess = false;
			}

			if (!vm.from_premix) {
				vm.premix.selected_basis = vm.basisTypes[0];
			}
		}

		function setAmountOptions() {
			vm.amountOptions = [
				{
					name: i18nFilter('_m_f_premix_amount_number_of_animals_'),
					value: 0
				},
				{
					name: i18nFilter('_m_f_premix_amount_total_'),
					value: 1
				}
			];
			if (!vm.from_premix) {
				vm.premix.selected_amount_option = vm.amountOptions[0];
			}
		}

		function setRepeatIntervalOptions() {
			vm.intervalOptions = [
				{
					name: i18nFilter('_m_f_premix_repeat_interval_daily_'),
					value: 0,
					rrule_value: RRule.DAILY,
					rrule_value_string: 'DAILY'
				},
				{
					name: i18nFilter('_m_f_premix_repeat_interval_weekly_'),
					value: 1,
					rrule_value: RRule.WEEKLY,
					rrule_value_string: 'WEEKLY'
				},
				{
					name: i18nFilter('_m_f_premix_repeat_interval_monthly_'),
					value: 2,
					rrule_value: RRule.MONTHLY,
					rrule_value_string: 'MONTHLY'
				},
				{
					name: i18nFilter('_m_f_premix_repeat_interval_yearly_'),
					value: 3,
					rrule_value: RRule.YEARLY,
					rrule_value_string: 'YEARLY'
				},
				{
					name: i18nFilter('_m_f_premix_repeat_interval_custom_'),
					value: 4
				},
				{
					name: i18nFilter('_m_f_premix_repeat_interval_no_repeat_'),
					value: 5
				}
			];
			if (!vm.from_premix) {
				vm.premix.selected_interval = vm.intervalOptions[0];
			}
		}

		function setFeedingPeriods() {
			vm.feedingPeriods = [
				{
					name: i18nFilter('_m_f_pen_morning_feeding_'),
					value: 1
				},
				{
					name: i18nFilter('_m_f_pen_noon_feeding_'),
					value: 2
				},
				{
					name: i18nFilter('_m_f_pen_evening_feeding_'),
					value: 3
				}
			];
			if (!vm.from_premix) {
				vm.premix.feeding_period = vm.feedingPeriods[0];
			}
		}

		function timeChanged() {
			$timeout(function () {
				var hour = Number.parseInt(moment(vm.premix.feeding_time).format('HH'));
				if (hour >= 4 && hour <= 11) {
					vm.premix.feeding_period = vm.feedingPeriods[0];
				} else if (hour >= 12 && hour <= 18) {
					vm.premix.feeding_period = vm.feedingPeriods[1];
				} else if ((hour >= 19 && hour <= 23) || (hour >= 0 && hour <= 3)) {
					vm.premix.feeding_period = vm.feedingPeriods[2];
				}
			}, 0);
		}

		function setCustomDays() {
			vm.premix.custom_days = [];
			var listOfDays = APP_CONST.constants.custom_feeding_days;
			for (var i = 0; i < listOfDays.length; i++) {
				vm.premix.custom_days.push({
					name: i18nFilter(listOfDays[i].name),
					selected: listOfDays[i].selected,
					rrule_day: RRule[listOfDays[i].rrule_day],
					value: listOfDays[i].value
				});
			}
		}

		function daySelected() {
			for (var i = 0; i < vm.premix.custom_days.length; i++) {
				if (vm.premix.custom_days[i].selected) {
					vm.premix.custom_days_validation = 'valid';
					break;
				} else {
					vm.premix.custom_days_validation = null;
				}
			}
			calculateTotalPremixAmount();
		}

		function basisPaginationChanged() {
			getBasisData();
		}

		function basisChanged() {
			vm.premix.basis_is_changed = true;
			vm.premix.basis_selected = false;
			vm.premix.basis = null;
			vm.premix.feeds = [];
			getBasisData();
		}

		function getBasisData(init) {
			if (vm.premix.selected_basis.value === 0) {
				if (vm.premix.basis_is_changed) {
					vm.premix.current_page = 1;
				}
				cancelAddNewFeed();
				getRationBasis(init, 'ration');
				vm.premix.basis_is_changed = false;
			} else if (vm.premix.selected_basis.value === 1) {
				if (vm.premix.basis_is_changed) {
					vm.premix.current_page = 1;
				}
				cancelAddNewFeed();
				getRationBasis(init, 'ration-premix');
				vm.premix.basis_is_changed = false;
			} else if (vm.premix.selected_basis.value === 2) {
				if (vm.premix.basis_is_changed) {
					vm.premix.current_page = 1;
				}
				cancelAddNewFeed();
				getRationBasis(init, 'premix');
				vm.premix.basis_is_changed = false;
			} else {
				vm.loading = false;
				vm.loadingBasis = false;
				showInputFields();
			}
		}

		function getRationBasis(init, type) {
			vm.basis = [];
			vm.loadingBasis = true;
			var suffix = '?team=' + vm.selectedTeam + '&page_number=' + vm.premix.current_page + '&herd=' + vm.selectedHerd + '&return_type=' + type;
			return addNewPremixService
				.getRationBasis(suffix, type)
				.then(function (response) {
					if (response.length > 0) {
						vm.totalItemsBasis = response[0].number_of_all;
					} else {
						vm.totalItemsBasis = 0;
					}
					for (var i = 0; i < response.length; i++) {
						for (var j = 0; j < response[i].ingredient_list.length; j++) {
							response[i].ingredient_list[j].amount = Number.isFinite(response[i].ingredient_list[j].amount) ? Number.parseFloat(response[i].ingredient_list[j].amount) : 0;
							response[i].ingredient_list[j].as_fed = Number.isFinite(response[i].ingredient_list[j].as_fed) ? Number.parseFloat(response[i].ingredient_list[j].as_fed) : 0;
							response[i].ingredient_list[j].cost_as_fed = (response[i].ingredient_list[j].cost * response[i].ingredient_list[j].dm) / 100;
							var hasFeedType = false;
							for (var k = 0; k < vm.feed_types.length; k++) {
								if (response[i].ingredient_list[j].feed_type) {
									if (response[i].ingredient_list[j].feed_type.toLowerCase() === vm.feed_types[k].name.toLowerCase()) {
										response[i].ingredient_list[j].feed_type = vm.feed_types[k];
										hasFeedType = true;
										break;
									}
								}
							}
							if (!hasFeedType) {
								response[i].ingredient_list[j].feed_type = {
									name: i18nFilter('_feeds_type_not_set_')
								};
							}
						}
						response[i].ingredient_list = $filter('orderBy')(response[i].ingredient_list, 'id');
						if (vm.premix.basis) {
							if (response[i].id === vm.premix.basis.id) {
								if (vm.from_premix) {
									selectBasis(response[i], response);
								} else {
									response[i].is_selected = true;
									vm.premix.basis_help_input = 'valid';
								}
							}
						} else {
							vm.premix.basis_help_input = undefined;
						}
					}
					vm.basis = response;
					vm.loadingBasis = false;
					vm.loading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loadingBasis = false;
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_ration_basis_', init);
				});
		}

		function getWagons(init) {
			vm.loadingMixerWagons = true;
			var suffix = '?team=' + vm.selectedTeam + '&herd=' + vm.selectedHerd;
			return addNewPremixService
				.getMixerWagons(suffix)
				.then(function (response) {
					for (var i = 0; i < response.length; i++) {
						response[i].default = false;
						response[i].selected = false;
						response[i].value = response[i].weight * 1000;
					}
					vm.premix.wagons = response;
					vm.premix.wagons = $filter('orderBy')(vm.premix.wagons, 'weight', true);
					vm.premix.wagons_loaded = true;
					vm.premix.wagon_help_input = undefined;
					vm.loadingMixerWagons = false;
				})
				.catch(function (error) {
					vm.loadingMixerWagons = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_wagons_', init);
				});
		}

		function wagonSelected(wagon) {
			if (!wagon.selected) {
				wagon.default = false;
			}
			var selectedWagons = [];
			var selIndex;
			for (var i = 0; i < vm.premix.wagons.length; i++) {
				if (vm.premix.wagons[i].selected === true) {
					selectedWagons.push(vm.premix.wagons[i]);
					selIndex = i;
				}
			}
			if (selectedWagons.length === 1) {
				vm.premix.wagons[selIndex].default = true;
			}
			checkWagonSelection();
			if (vm.premix.suggestion && !vm.premix.suggestion.dirty) {
				calculateSuggestion();
			}
		}

		function defaultSelected(wagon) {
			for (var i = 0; i < vm.premix.wagons.length; i++) {
				if (vm.premix.wagons[i].id !== wagon.id) {
					vm.premix.wagons[i].default = false;
				} else {
					vm.premix.wagons[i].default = true;
				}
			}
			checkWagonSelection();
			if (vm.premix.suggestion && !vm.premix.suggestion.dirty) {
				calculateSuggestion();
			}
		}

		function checkWagonSelection() {
			var sel = false;
			var def = false;
			for (var i = 0; i < vm.premix.wagons.length; i++) {
				if (vm.premix.wagons[i].selected === true) {
					sel = true;
				}
				if (vm.premix.wagons[i].default === true) {
					def = true;
				}
				if (sel && def) {
					break;
				}
			}
			vm.premix.wagon_help_input = sel && def ? 'valid' : undefined;
		}

		function calculateSuggestion() {
			var selectedWagons = [];
			for (var i = 0; i < vm.premix.wagons.length; i++) {
				if (vm.premix.wagons[i].selected === true) {
					selectedWagons.push(vm.premix.wagons[i]);
				}
			}
			if (selectedWagons && vm.premix.wagon_help_input === 'valid') {
				vm.premix.suggestion = setFeedingSuggestion(vm.premix.total_premix_amount, selectedWagons);
				vm.premix.suggestion_help_input = 'valid';
				vm.feedingsError = null;
			} else {
				vm.premix.suggestion = {};
				vm.premix.suggestion_help_input = undefined;
				vm.feedingsError = null;
			}
		}

		function setFeedingSuggestion(amount, selectedWagons) {
			var numberOfLoads = 0;
			var loads = [];
			var cont = 0;
			var sum = 0;
			var maxValueWagon = selectedWagons.find(function (item) {
				return item.default === true && item.selected === true;
			});
			if (maxValueWagon) {
				amount = unitConversionService.convertData(amount, ['round:0']);
				while (amount > maxValueWagon.value && cont < 9) {
					numberOfLoads++;
					loads.push({
						value: maxValueWagon.value,
						wagon_id: maxValueWagon.id,
						weight: maxValueWagon.weight,
						wagon_name: maxValueWagon.name
					});
					sum += maxValueWagon.value;
					amount = amount - maxValueWagon.value;
					cont++;
				}
				loads = $filter('orderBy')(loads, 'value', true);
				if (amount > 0) {
					numberOfLoads++;
					loads.push({
						value: amount,
						wagon_id: maxValueWagon.id,
						weight: maxValueWagon.weight,
						wagon_name: maxValueWagon.name
					});
					sum += amount;
				}
				var suggestion = {
					number_of_loads: numberOfLoads,
					sum: sum,
					loads: loads,
					dirty: false
				};
				return suggestion;
			}
		}

		function openAddLoadModal() {
			var selectedWagons = [];
			for (var i = 0; i < vm.premix.wagons.length; i++) {
				if (vm.premix.wagons[i].selected === true) {
					selectedWagons.push(vm.premix.wagons[i]);
				}
			}
			vm.load = {
				value: 0,
				wagon: selectedWagons && selectedWagons.length === 1 ? selectedWagons[0] : null,
				wagons: selectedWagons
			};
			vm.modalType = 'add';
			calculateAddLoadAmount();
			openModal('app/pages/premixes/addNewPremix/loadForm.modal.html', 'sm');
		}

		function calculateAddLoadAmount(selected) {
			vm.showRequiredAmount = false;
			if (vm.feedingsError) {
				vm.showRequiredAmount = true;
				vm.loadRequiredAmount = Math.abs(vm.feedingsError);
				if (!selected) {
					vm.loadRequiredAmount = vm.load.value - vm.feedingsError;
				}
				if (vm.load.wagon && vm.loadRequiredAmount >= vm.load.wagon.value) {
					vm.loadRequiredAmount = vm.load.wagon.value;
				}
			}
		}

		function addNewLoad() {
			if (vm.load.value > 0 && vm.load.value <= vm.load.wagon.value) {
				var obj = {
					value: vm.load.value,
					wagon_id: vm.load.wagon.id,
					wagon_name: vm.load.wagon.name,
					weight: vm.load.wagon.weight,
					mixing_time: null
				};
				vm.premix.suggestion.loads.push(obj);
				vm.premix.suggestion.number_of_loads++;
				calculateDifference();
				cancel();
			}
		}

		function openEditLoadModal(index) {
			var selectedWagons = [];
			for (var i = 0; i < vm.premix.wagons.length; i++) {
				if (vm.premix.wagons[i].selected === true) {
					selectedWagons.push(vm.premix.wagons[i]);
				}
			}
			vm.load = {
				value: vm.premix.suggestion.loads[index].value,
				wagon: getWagon(vm.premix.suggestion.loads[index]),
				wagons: selectedWagons,
				index: index
			};
			vm.modalType = 'edit';
			calculateEditLoadAmount();
			openModal('app/pages/premixes/addNewPremix/loadForm.modal.html', 'sm');

			function getWagon(w) {
				for (var i = 0; i < vm.premix.wagons.length; i++) {
					if (vm.premix.wagons[i].id === w.wagon_id) {
						return vm.premix.wagons[i];
					}
				}
			}
		}

		function calculateEditLoadAmount(selected) {
			vm.showRequiredAmount = false;
			if (vm.feedingsError) {
				vm.showRequiredAmount = true;
				vm.loadRequiredAmount = Math.abs(vm.feedingsError);
				if (!selected) {
					vm.loadRequiredAmount = vm.load.value - vm.feedingsError;
				}
				if (vm.loadRequiredAmount >= vm.load.wagon.value) {
					vm.loadRequiredAmount = vm.load.wagon.value;
				}
			} else {
				if (vm.load.value > vm.load.wagon.value) {
					vm.showRequiredAmount = true;
				}
			}
		}

		function editLoad() {
			if (vm.load && vm.load.value <= vm.load.wagon.value) {
				if (vm.load.value > 0) {
					vm.premix.suggestion.loads[vm.load.index].value = vm.load.value;
					vm.premix.suggestion.loads[vm.load.index].wagon_id = vm.load.wagon.id;
					vm.premix.suggestion.loads[vm.load.index].wagon_name = vm.load.wagon.name;
					vm.premix.suggestion.loads[vm.load.index].weight = vm.load.wagon.weight;
				} else {
					vm.premix.suggestion.loads.splice(vm.load.index, 1);
				}
				calculateDifference();
				cancel();
			}
		}

		function saveLoad() {
			return vm.modalType === 'add' ? addNewLoad() : editLoad();
		}

		function removeLoad(index) {
			vm.premix.suggestion.loads.splice(index, 1);
			vm.premix.suggestion.loads.number_of_loads--;
			calculateDifference();
		}

		function calculateDifference() {
			//vm.premix.suggestion.loads = $filter('orderBy')(vm.premix.suggestion.loads, ['weight', '-value']);
			var sum = 0;
			for (var i = 0; i < vm.premix.suggestion.loads.length; i++) {
				sum += vm.premix.suggestion.loads[i].value;
			}
			var diff = sum - vm.premix.suggestion.sum;
			if (diff != 0) {
				vm.feedingsError = diff;
				vm.premix.suggestion.dirty = true;
			} else {
				vm.feedingsError = undefined;
			}
			if (vm.feedingsError) {
				vm.premix.suggestion_help_input = undefined;
			} else {
				vm.premix.suggestion_help_input = 'valid';
			}
		}

		function setLoad() {
			vm.load.value = vm.loadRequiredAmount;
		}

		function calculateLoad() {
			if (vm.modalType === 'add') {
				calculateAddLoadAmount(true);
			} else {
				calculateEditLoadAmount(true);
			}
		}

		function addWagon() {
			vm.modalLoading = true;
			var newWagonDTO = angular.copy(vm.newWagon);
			if (!newWagonDTO.volume) {
				newWagonDTO.volume = 0;
			}
			if (!vm.settings.use_kgs) {
				newWagonDTO.value = unitConversionService.convertData(newWagonDTO.value, ['imperialTonToMetricTon']);
			}
			newWagonDTO.weight = newWagonDTO.value;
			var suffix = '?team_id=' + vm.settings.selectedTeam.id + '&herd_id=' + vm.settings.selectedHerd.id + '&last_modified_user=' + encodeURIComponent(vm.user.email) + '&name=' + encodeURIComponent(newWagonDTO.name) + '&volume=' + newWagonDTO.volume + '&weight=' + newWagonDTO.weight;
			if (newWagonDTO.mac_address) {
				suffix = suffix + '&mac_address=' + encodeURIComponent(newWagonDTO.mac_address);
			}
			return addNewPremixService
				.addNewWagon(suffix)
				.then(function (response) {
					response.value = response.weight * 1000;
					vm.premix.wagons.push(response);
					vm.premix.wagons = $filter('orderBy')(vm.premix.wagons, 'weight', true);
					if (vm.suggestion) {
						selectWagon(response.id);
					}
					vm.suggestion = false;
					cancel();
					vm.modalLoading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.modalLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_adding_wagon_');
				});

			function selectWagon(id) {
				for (var i = 0; i < vm.premix.wagons.length; i++) {
					if (vm.premix.wagons[i].id === id) {
						vm.premix.wagons[i].selected = true;
						vm.premix.wagons[i].default = false;
						if (vm.premix.suggestion && !vm.premix.suggestion.dirty) {
							calculateSuggestion();
						}
						break;
					}
				}
			}
		}

		function openAddWagonModal(e, suggestion) {
			e.preventDefault();
			vm.suggestion = suggestion;
			vm.newWagon = {};
			openModal('app/pages/premixes/addNewPremix/addWagon.modal.html', 'md');
		}

		function addExistingWagon(wagon) {
			wagon.selected = true;
			if (vm.premix.suggestion && !vm.premix.suggestion.dirty) {
				calculateSuggestion();
			}
			cancel();
		}

		function removeWagon(wagon) {
			wagon.selected = false;
			calculateSuggestion();
		}

		function selectBasis(basis, response) {
			var basisList;
			if (response && response.length) {
				basisList = response;
			} else {
				basisList = vm.basis;
			}
			vm.premix.feeds = [];
			vm.premix.basis = basis;
			for (var i = 0; i < basisList.length; i++) {
				if (basisList[i].id !== basis.id) {
					basisList[i].is_selected = false;
				} else {
					basisList[i].is_selected = true;
					var ingredientList = basisList[i].ingredient_list;
					for (var j = 0; j < ingredientList.length; j++) {
						vm.new_feed = {
							id: ingredientList[j].id,
							ration_feed_id: ingredientList[j].ration_feed_id,
							ration_feed_mix_id: ingredientList[j].ration_feed_mix_id,
							mix_id: ingredientList[j].mix_id,
							name: ingredientList[j].name,
							feed_type: ingredientList[j].feed_type,
							category: ingredientList[j].category,
							dm: ingredientList[j].dm,
							cost: ingredientList[j].cost,
							cost_as_fed: ingredientList[j].cost_as_fed,
							amount: ingredientList[j].amount,
							as_fed: ingredientList[j].as_fed
						};
						addNewFeed(true);
					}
				}
			}
			vm.premix.basis_selected = true;
			vm.premix.basis_help_input = 'valid';
			if (checkIngredientsDmError(vm.premix.feeds)) {
				vm.hasDM0Error = true;
			} else {
				vm.hasDM0Error = false;
			}

			calculateTotalAmount();
		}

		function checkIngredientsDmError(feeds) {
			var hasDm0 = false;
			for (var i = 0; i < feeds.length; i++) {
				if (feeds[i].dm == 0) {
					hasDm0 = true;
					break;
				}
			}
			return hasDm0;
		}

		function editBasis(basis) {
			localStorage.setItem(
				'from_premix',
				JSON.stringify({
					type: 'add'
				})
			);
			var id = vm.premix.selected_basis.value === 1 ? basis.ration_id : basis.id;
			var page = vm.premix.selected_basis.value === 2 ? 'feeds.editFeed' : 'rations.balanceration';
			dataServiceFactory.add_new_premix_data = vm.premix;
			$state.go(page, {
				uuid: id
			});
		}

		function basisDetails(basis) {
			var modalBasis = vm.basis.find(function (item) {
				return basis.id == item.id;
			});
			if (modalBasis) {
				vm.modalBasis = modalBasis;
			} else {
				vm.modalBasis = {};
			}
			openModal('app/pages/premixes/addNewPremix/basisDetails.modal.html', 'lg');
		}

		function amountOptionChanged() {
			vm.premix.total_amount = 0;
			vm.premix.total_premix_amount = 0;
			vm.premix.number_of_animals = 0;
		}

		function calculateTotalAmount() {
			if (vm.premix.selected_amount_option.value === 0) {
				vm.premix.total_amount = angular.isNumber(vm.premix.number_of_animals) ? vm.premix.number_of_animals * vm.premix.amount_as_fed : 0;
				vm.premix.total_cost = angular.isNumber(vm.premix.number_of_animals) ? vm.premix.number_of_animals * vm.premix.cost : 0;
			} else {
				vm.premix.total_cost = vm.premix.cost;
			}
			calculateTotalPremixAmount();
		}

		function calculateTotalPremixAmount() {
			vm.premix.total_premix_amount = vm.premix.total_amount * getMaxDayDifference();
			calculateSuggestion();
		}

		function getMaxDayDifference() {
			var rule = new RRule({
				dtstart: moment.utc(vm.premix.start_feeding_date).toDate(),
				freq: vm.premix.selected_interval.value !== 5 ? (vm.premix.selected_interval.value !== 4 ? vm.premix.selected_interval.rrule_value : RRule.WEEKLY) : null,
				interval: vm.premix.selected_interval.value !== 5 ? vm.premix.repeat_interval : null,
				until: vm.premix.end_feeding_date ? moment.utc(vm.premix.end_feeding_date).toDate() : moment.utc(vm.premix.start_feeding_date).add(29, 'days').toDate(),
				byweekday: vm.premix.selected_interval.value === 4 ? setRruleDayList() : null,
				count: vm.premix.selected_interval.value !== 5 && vm.premix.repeat_count ? vm.premix.repeat_count : null
			});

			var days = rule.all();
			var max = 1;

			for (var i = 0; i < days.length; i++) {
				if (days[i + 1]) {
					var diff = moment(days[i + 1]).diff(days[i], 'days');
					if (diff > max) {
						max = diff;
					}
				}
			}

			return max;
		}

		function calculatePremixAmount() {
			var amount = 0;
			var amount_as_fed = 0;
			var cost = 0;
			for (var i = 0; i < vm.premix.feeds.length; i++) {
				amount += vm.premix.feeds[i].amount;
				amount_as_fed += vm.premix.feeds[i].as_fed;
				cost += vm.premix.feeds[i].cost * vm.premix.feeds[i].amount;
			}
			vm.premix.amount = amount;
			vm.premix.amount_as_fed = amount_as_fed;
			vm.premix.dm = (amount / amount_as_fed) * 100;
			vm.premix.cost = cost;
		}

		function savePremix() {
			vm.loading = true;
			var premixDTO = new PremixDTO(vm.premix);
			addNewPremixService
				.savePremix(premixDTO)
				.then(function () {
					$state.go('premixes.myPremixes');
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_saving_basis_');
				});

			function PremixDTO(premix) {
				this.name = premix.premix_name;
				this.amount = premix.total_amount;
				this.team_id = vm.selectedTeam;
				this.herd_id = vm.selectedHerd;
				this.start_from = moment.utc(premix.start_feeding_date).format('YYYY-MM-DDTHH:mm:ss[Z]');
				this.premix_period = premix.feeding_period.value;
				this.premix_production_time = moment(premix.feeding_time).format('HH:mm:ss') + 'Z';
				this.repeat_interval = createRRule();
				this.recipe_premix_scheduler = setRecipeRationSchedulerDTO(premix, this.start_from);
				this.mixer_wagon_list = setWagonData(premix.wagons);
				this.load_management = setManagementData(premix.suggestion, premix.feeding_period.value);
				this.number_of_animals = premix.number_of_animals;
			}

			function setRecipeRationSchedulerDTO(premix, startFrom) {
				var obj = {};
				if (premix.basis) {
					obj = {
						ration_header_premix_id: vm.premix.selected_basis.value === 0 ? premix.basis.id : null,
						ration_feed_premix_id: vm.premix.selected_basis.value === 1 ? premix.basis.id : null,
						feed_premix_id: vm.premix.selected_basis.value === 2 ? premix.basis.id : null,
						premix_name: premix.basis.name,
						used_from: startFrom || moment().utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
						dm: premix.basis.dm,
						amount_dm: premix.basis.amount,
						cost_dm: premix.basis.cost,
						visible: true,
						type: 1,
						scheduled_premix_ingredients: setScheduledRationFeedDTO(premix.feeds)
					};
				} else {
					obj = {
						premix_name: premix.premix_name,
						used_from: startFrom || moment().utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
						dm: premix.dm,
						amount_dm: premix.amount,
						cost_dm: premix.cost,
						visible: true,
						type: 1,
						scheduled_premix_ingredients: setScheduledRationFeedDTO(premix.feeds)
					};
				}
				return obj;

				function setScheduledRationFeedDTO(feeds) {
					var list = [];
					var sum = 0;

					feeds.forEach(function (feed, index) {
						sum += feed.as_fed;
						list.push({
							premix_ingredient_name: feed && feed.name ? feed.name : '',
							dm: feed.dm,
							amount_dm: feed.amount,
							cost_dm: feed.cost,
							type: 1,
							order_number: index + 1,
							visible: true,
							feed_type: feed.feed_type.name,
							feed_category: feed.feed_type.feed_category,
							ration_feed_id: feed.ration_feed_id,
							ration_feed_mix_id: feed.ration_feed_mix_id,
							mix_id: feed.mix_id
						});
					});

					list.forEach(function (feed) {
						feed.percentage = calculatePercentage(feed, sum);
					});

					return list;

					function calculatePercentage(feed, sum) {
						var asFed = (feed.amount_dm * 100) / feed.dm;

						return (asFed * 100) / sum;
					}
				}
			}

			function setWagonData(wagonList) {
				var selectedWagons = wagonList.filter(function (wagon) {
					return wagon.selected === true;
				});

				selectedWagons = $filter('orderBy')(selectedWagons, ['-default', '-weight']);

				var list = [];
				for (var i = 0; i < selectedWagons.length; i++) {
					list.push({
						mixer_wagon_id: selectedWagons[i].id,
						mixer_wagon: {
							id: selectedWagons[i].id,
							volume: selectedWagons[i].volume,
							weight: selectedWagons[i].weight,
							name: selectedWagons[i].name,
							herd_id: vm.selectedHerd,
							team_id: vm.selectedTeam,
							last_modified_user: vm.user.email
						},
						position: i
					});
				}
				return list;
			}

			function setManagementData(suggestion, period) {
				var feeding = {
					load_subject_order_number: period,
					load_details: []
				};

				for (var i = 0; i < suggestion.loads.length; i++) {
					feeding.load_details.push({
						amount: suggestion.loads[i].value,
						mixer_wagon_id: suggestion.loads[i].wagon_id,
						position: i,
						mixing_time: suggestion.loads[i].mixing_time ? suggestion.loads[i].mixing_time : null
					});
				}
				return [feeding];
			}

			function createRRule() {
				var rule = new RRule({
					freq: vm.premix.selected_interval.value !== 5 ? (vm.premix.selected_interval.value !== 4 ? vm.premix.selected_interval.rrule_value : RRule.WEEKLY) : null,
					interval: vm.premix.selected_interval.value !== 5 ? vm.premix.repeat_interval : null,
					until: vm.premix.end_feeding_date ? moment.utc(vm.premix.end_feeding_date).toDate() : null,
					byweekday: vm.premix.selected_interval.value === 4 ? setRruleDayList() : null,
					count: vm.premix.selected_interval.value !== 5 && vm.premix.repeat_count ? vm.premix.repeat_count : null
				});
				return rule.toString().split(':')[1];
			}
		}

		function setRruleDayList() {
			var list = [];
			for (var i = 0; i < vm.premix.custom_days.length; i++) {
				if (vm.premix.custom_days[i].selected) {
					list.push(vm.premix.custom_days[i].rrule_day);
				}
			}
			return list;
		}

		function setFeedTypes(feed_types) {
			vm.feed_types = [];
			for (var i = 0; i < feed_types.length; i++) {
				var temp = '_feeds_type_' + feed_types[i].value + '_';
				feed_types[i].show_name = temp;
				feed_types[i].feed_category = feed_types[i].category;
				feed_types[i].translated = i18nFilter(temp);
				vm.feed_types.push(feed_types[i]);
			}
		}

		function move(feed, direction) {
			var index;
			for (var i = 0; i < vm.premix.feeds.length; i++) {
				if (vm.premix.feeds[i].temp_id === feed.temp_id) {
					index = i;
					break;
				}
			}
			var element = vm.premix.feeds[index];
			var toIndex = direction === 'up' ? index - 1 : index + 1;
			vm.premix.feeds.splice(index, 1);
			vm.premix.feeds.splice(toIndex, 0, element);
		}

		function drag(index) {
			vm.premix.feeds.splice(index, 1);
		}

		function addNewFeed(automatic) {
			if (!automatic) {
				if (vm.newPremixFeedForm.$invalid) {
					return;
				}
			}

			var feedName = null;
			if (automatic) {
				feedName = vm.new_feed && vm.new_feed.name ? vm.new_feed.name : vm.feedFromApi;
			} else {
				feedName = vm.feedFromApi instanceof Object ? vm.new_feed.name : vm.feedFromApi;
				if (!feedName && vm.new_feed) {
					feedName = vm.new_feed.name;
				}
			}

			var obj = {
				id: vm.new_feed.id,
				ration_feed_id: vm.new_feed.ration_feed_id,
				ration_feed_mix_id: vm.new_feed.ration_feed_mix_id,
				mix_id: vm.new_feed.mix_id,
				temp_id: vm.new_feed.id || performance.now(),
				name: feedName,
				feed_type: vm.new_feed.feed_type,
				dm: vm.new_feed.dm,
				cost: vm.new_feed.cost || 0,
				cost_as_fed: vm.new_feed.cost_as_fed || 0,
				amount: vm.new_feed.amount,
				as_fed: vm.new_feed.as_fed
			};
			vm.premix.feeds.push(obj);
			vm.new_feed = {};
			calculatePremixAmount();
			if (!automatic) {
				calculateTotalAmount();
			}
			cancelAddNewFeed();
		}

		function openAddNewFeedForm() {
			vm.premix.selected_basis = vm.basisTypes.find(function type(type) {
				return type.value === 3;
			});
			vm.premix.basis = null;
			showInputFields();
		}

		function showInputFields() {
			vm.showIFields = true;
			vm.feedFromApi = null;
			vm.new_feed = new Feed();
		}

		function cancelAddNewFeed() {
			vm.showIFields = false;
			vm.feedFromApi = null;
			vm.new_feed = new Feed();
		}

		function newFeedDmChanged() {
			if (nfdTimer) {
				$timeout.cancel(nfdTimer);
			}
			nfdTimer = $timeout(function () {
				if (vm.new_feed.amount) {
					vm.new_feed.as_fed = (vm.new_feed.amount * 100) / vm.new_feed.dm;
				} else if (vm.new_feed.as_fed) {
					vm.new_feed.amount = (vm.new_feed.as_fed * vm.new_feed.dm) / 100;
				}
				if (vm.new_feed.cost) {
					vm.new_feed.cost_as_fed = (vm.new_feed.cost * vm.new_feed.dm) / 100;
				} else if (vm.new_feed.cost_as_fed) {
					vm.new_feed.cost = (vm.new_feed.cost_as_fed * 100) / vm.new_feed.dm;
				}
			}, 750);
		}

		function newFeedCostDmChanged() {
			if (nfcTimer) {
				$timeout.cancel(nfcTimer);
			}
			vm.disableAddFeed = true;
			nfcTimer = $timeout(function () {
				if (vm.new_feed.dm && angular.isNumber(vm.new_feed.dm) && angular.isNumber(vm.new_feed.cost)) {
					vm.new_feed.cost_as_fed = (vm.new_feed.cost * vm.new_feed.dm) / 100;
				} else {
					vm.new_feed.cost_as_fed = null;
				}
				vm.disableAddFeed = false;
			}, 750);
		}

		function newFeedCostAsFedChanged() {
			if (nfaTimer) {
				$timeout.cancel(nfaTimer);
			}
			vm.disableAddFeed = true;
			nfaTimer = $timeout(function () {
				if (vm.new_feed.dm && angular.isNumber(vm.new_feed.dm) && angular.isNumber(vm.new_feed.cost_as_fed)) {
					vm.new_feed.cost = (vm.new_feed.cost_as_fed * 100) / vm.new_feed.dm;
				} else {
					vm.new_feed.cost = null;
				}
				vm.disableAddFeed = false;
			}, 750);
		}

		function newFeedAmountDmChanged() {
			if (nfaDTimer) {
				$timeout.cancel(nfaDTimer);
			}
			nfaDTimer = $timeout(function () {
				if (vm.new_feed.dm) {
					vm.new_feed.as_fed = (vm.new_feed.amount * 100) / vm.new_feed.dm;
				}
			}, 750);
		}

		function newFeedAmountAsFedChanged() {
			if (nfaAFTimer) {
				$timeout.cancel(nfaAFTimer);
			}
			nfaAFTimer = $timeout(function () {
				if (vm.new_feed.dm) {
					vm.new_feed.amount = (vm.new_feed.as_fed * vm.new_feed.dm) / 100;
				}
			}, 750);
		}

		function removeNewFeed(feed) {
			var index;
			for (var i = 0; i < vm.premix.feeds.length; i++) {
				if (vm.premix.feeds[i].temp_id === feed.temp_id) {
					index = i;
					break;
				}
			}
			vm.premix.feeds.splice(index, 1);
			if (checkIngredientsDmError(vm.premix.feeds)) {
				vm.hasDM0Error = true;
			} else {
				vm.hasDM0Error = false;
			}
			vm.premix.selected_basis = vm.basisTypes.find(function type(type) {
				return type.value === 3;
			});
			vm.premix.basis = null;
			calculatePremixAmount();
			calculateTotalAmount();
		}

		function updateNewFeed(data, index, type) {
			$timeout(function () {
				if (type === 'name') {
					vm.premix.feeds[index].name = data;
				} else if (type == 'dm') {
					vm.premix.feeds[index].dm = data;
					if (vm.premix.feeds[index].amount) {
						vm.premix.feeds[index].as_fed = (vm.premix.feeds[index].amount * 100) / data;
					}
					if (vm.premix.feeds[index].amount) {
						vm.premix.feeds[index].cost_as_fed = (vm.premix.feeds[index].cost * data) / 100;
					}
				} else if (type == 'amount') {
					vm.premix.feeds[index].amount = data;
					if (vm.premix.feeds[index].dm) {
						vm.premix.feeds[index].as_fed = (data * 100) / vm.premix.feeds[index].dm;
					}
				} else if (type == 'as_fed') {
					vm.premix.feeds[index].as_fed = data;
					if (vm.premix.feeds[index].dm) {
						vm.premix.feeds[index].amount = (data * vm.premix.feeds[index].dm) / 100;
					}
				} else if (type == 'cost') {
					if (angular.isNumber(data)) {
						vm.premix.feeds[index].cost = data;
						if (vm.premix.feeds[index].dm) {
							vm.premix.feeds[index].cost_as_fed = (data * vm.premix.feeds[index].dm) / 100;
						}
					} else {
						vm.premix.feeds[index].cost = 0;
						vm.premix.feeds[index].cost_as_fed = 0;
					}
				} else if (type == 'cost_as_fed') {
					if (angular.isNumber(data)) {
						vm.premix.feeds[index].cost_as_fed = data;
						if (vm.premix.feeds[index].dm) {
							vm.premix.feeds[index].cost = (data * 100) / vm.premix.feeds[index].dm;
						}
					} else {
						vm.premix.feeds[index].cost = 0;
						vm.premix.feeds[index].cost_as_fed = 0;
					}
				}
				if (checkIngredientsDmError(vm.premix.feeds)) {
					vm.hasDM0Error = true;
				} else {
					vm.hasDM0Error = false;
				}
				calculatePremixAmount();
				calculateTotalAmount();
			}, 1);
		}

		function inputKeyPress(event) {
			if (event.keyCode === 13) {
				vm.newPremixFeedForm.$setSubmitted();
				addNewFeed();
			}
		}

		function feedTypeSelected() {
			vm.newPremixFeedForm.$setSubmitted();
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function saveMixingTime() {
			var minutes = vm.mixingTime && vm.mixingTime.minutes ? parseInt(vm.mixingTime.minutes, 10) : 0;
			var mixingTimeSeconds = minutes * 60 || null;

			if (vm.mixingTimeData && vm.mixingTimeData.set_to_all) {
				(vm.premix.suggestion.loads || []).forEach(function (load) {
					load.mixing_time = mixingTimeSeconds;
				});
			} else if (vm.mixingTimeData && vm.mixingTimeData.load) {
				vm.mixingTimeData.load.mixing_time = mixingTimeSeconds;
			}

			cancel();
		}

		function getMinutes() {
			return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59];
		}

		function openMixingTimeSelector(load) {
			vm.mixingTimeData = {
				load: load,
				set_to_all: false
			};

			var mixingTime = load && load.mixing_time ? {
				hours: Math.floor(load.mixing_time / 3600) || null,
				minutes: Math.floor((load.mixing_time % 3600) / 60) || null,
				seconds: load.mixing_time % 60 || null
			} : {
				hours: null,
				minutes: null,
				seconds: null
			};

			vm.mixingTime = angular.copy(mixingTime);
			openModal('app/pages/recipes/mixingTimeSelector.modal.html', 'sm');
		}

		function cancelWizard() {
			$state.go('premixes.myPremixes');
		}

		function premixDirty(val) {
			if (val === 'drop' && !vm.premix.premix_name) {
				vm.premix_name_drop = true;
			} else if (val === 'basis' && !vm.premix.premix_name) {
				vm.premix_name_basis = true;
			} else {
				vm.premix_name_basis = false;
				vm.premix_name_drop = false;
			}
		}

		function getFeedByName(value) {
			var suffix = '?herdId=' + vm.selectedHerd + '&feedName=' + value;
			return addNewPremixService
				.getFeedByName(suffix)
				.then(function (response) {
					return response;
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_feeds_', init);
				});
		}

		function feedSelected(feed) {
			vm.new_feed = new Feed(feed);
		}

		function Feed(feed) {
			this.id = feed ? feed.id : null;
			this.name = feed ? feed.feed_name : null;
			this.dm = feed ? feed.dm : null;
			this.amount = feed ? feed.amount_dm : null;
			this.as_fed = feed ? feed.amount_as_fed : null;
			this.cost = feed ? feed.cost_dm : null;
			this.cost_as_fed = feed ? feed.cost_as_fed : null;

			if (feed) {
				var hasFeedType = false;

				for (var j = 0; j < vm.feed_types.length; j++) {
					if (feed.feed_type) {
						if (feed.feed_type.toLowerCase() === vm.feed_types[j].name.toLowerCase()) {
							this.feed_type = vm.feed_types[j];
							hasFeedType = true;
							break;
						}
					} else {
						if (feed.feed_name && feed.feed_name.toLowerCase() === vm.feed_types[j].name.toLowerCase()) {
							this.feed_type = vm.feed_types[j];
							hasFeedType = true;
							break;
						}
					}
				}

				if (!hasFeedType) {
					this.feed_type.feed_type = {
						show_name: '_feeds_type_not_set_'
					};
				}
			} else {
				this.feed_type = null;
			}
		}

		//remove default tooltip
		(function removeDefaultTooltip() {
			var tooltipInterval = $interval(
				function () {
					$timeout(function () {
						var tabs = document.getElementsByClassName('wizard-step');
						var tabLoaded = document.getElementById('add-premix-tabs');
						if (tabLoaded) {
							for (var i = 0; i < tabs.length; i++) {
								tabs[i]._title = tabs[i].title;
								tabs[i].onmouseenter = function () {
									this.title = '';
								};
								tabs[i].onmouseleave = function () {
									this.title = this._title;
								};
							}
							$interval.cancel(tooltipInterval);
						}
					}, 50);
				},
				1500,
				15
			);
		})();

		function cancel() {
			$uibModalStack.dismissAll();
		}

		function disableSaveButton() {
			return (vm.selectBasisForm && vm.selectBasisForm.$invalid && vm.selectBasisForm.$submitted) || (vm.planningForm && vm.planningForm.$invalid && vm.planningForm.$submitted) || (vm.managementForm && vm.managementForm.$invalid && vm.managementForm.$submitted);
		}

		function tabValidation() {
			return {
				'basis-tab-validation': vm.selectBasisForm && vm.selectBasisForm.$invalid && vm.selectBasisForm.$submitted && !vm.premix_name_drop,
				'planning-tab-validation': vm.planningForm && vm.planningForm.$invalid && vm.planningForm.$submitted,
				'management-tab-validation': vm.managementForm && vm.managementForm.$invalid && vm.managementForm.$submitted && !vm.premix_name_basis
			};
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_herd_selected', function () {
			selectTab(0);
			init();
		});

		$scope.$on('default_team_herd_changed', function () {
			selectTab(0);
			init();
		});

		function selectTab(number) {
			$rootScope.$broadcast('select_pen_tab', number);
		}

		editableOptions.theme = 'bs3';
		editableOptions.blurElem = 'cancel';
		editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
		editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.premixes.addNewPremix').factory('addNewPremixService', addNewPremixService);

	/** @ngInject */
	function addNewPremixService(APP_CONST, $http, $q) {
		return {
			getRationBasis: getRationBasis,
			getMixerWagons: getMixerWagons,
			savePremix: savePremix,
			addNewWagon: addNewWagon,
			getFeedByName: getFeedByName
		};

		function getRationBasis(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'premix' + suffix)
				.then(success)
				.catch(error);
		}

		function getMixerWagons(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'mixerwagon' + suffix)
				.then(success)
				.catch(error);
		}

		function savePremix(premix) {
			return $http
				.post(APP_CONST.api_base_url + 'premixrecipe', premix)
				.then(success)
				.catch(error);
		}

		function addNewWagon(url) {
			return $http
				.post(APP_CONST.api_base_url + 'mixerwagon' + url)
				.then(success)
				.catch(error);
		}

		function getFeedByName(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'manualfeeds/search' + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.premixes.myPremixes').controller('myPremixesCtrl', myPremixesCtrl);

	/** @ngInject */
	function myPremixesCtrl(myPremixesService, $locale, $scope, $uibModal, $uibModalStack, errorService, $q, $timeout, uaParser, $state, $filter) {
		var vm = this;

		vm.paginationChanged = paginationChanged;
		vm.deletePremix = deletePremix;
		vm.editPremix = editPremix;
		vm.changePremixActive = changePremixActive;
		vm.move = move;
		vm.drag = drag;
		vm.saveNewOrder = saveNewOrder;
		vm.reloadApi = reloadApi;
		vm.confirm = confirm;
		vm.cancel = cancel;

		init();

		function init() {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.selectedHerd = vm.settings.selectedHerd.id;
			vm.selectedTeam = vm.settings.selectedTeam.id;
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			vm.startDate = moment().toDate();
			vm.today = moment().toDate();
			vm.options = {
				showWeeks: false,
				minDate: vm.today
			};
			vm.device = uaParser.getDevice('type');
			if (vm.device) {
				vm.disableDrag = true;
			}
			vm.currentPage = 1;
			vm.premixes = [];
			if (!vm.settings.use_kgs) {
				vm.weight = 'Lb';
			} else {
				vm.weight = 'Kg';
			}
			vm.loading = true;
			if (vm.selectedHerd) {
				getPremixes(true);
			} else {
				vm.loading = false;
			}
		}

		function reloadApi() {
			vm.startDate = moment().toDate();
			vm.currentPage = 1;
			vm.premixes = [];
			vm.loading = true;
			if (vm.selectedHerd) {
				getPremixes(true);
			} else {
				vm.loading = false;
			}
		}

		function getPremixes(init) {
			var suffix = '?herd=' + vm.selectedHerd + '&page_number=' + vm.currentPage;
			return myPremixesService
				.getPremixes(suffix)
				.then(function (response) {
					response = $filter('orderBy')(response, 'premix_position', true);
					if (response.length) {
						vm.totalItems = response[0].number_of_all;
					} else {
						vm.totalItems = 0;
					}
					vm.premixes = vm.premixes.concat(response);
					vm.loading = false;
					vm.loadingRecipes = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					vm.loadingRecipes = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_premix_', init);
				});
		}

		function paginationChanged() {
			vm.loadingRecipes = true;
			vm.currentPage++;
			getPremixes();
		}

		function deletePremix(premix) {
			var index = vm.premixes.indexOf(premix);
			var premixDTO = angular.copy(premix);

			if (Number.isFinite(index)) {
				vm.confirmationPromise = $q.defer();
				vm.warningMessage = '_m_f_premix_delete_warning_message_';
				openModal('app/pages/premixes/myPremixes/confirmationDialog.modal.html', 'md');

				$q.all([vm.confirmationPromise.promise])
					.then(function () {
						vm.modalLoading = true;
						premixDTO.last_modified_user = vm.user.email;
						premixDTO.start_from = moment.utc(vm.startDate).format('YYYY-MM-DDTHH:mm:ss[Z]');
						return myPremixesService
							.deletePremix([premixDTO])
							.then(function () {
								vm.premixes.splice(index, 1);
								if (vm.premixes.length === 0) {
									getPremixes();
								} else {
									for (var i = 0; i < vm.premixes.length; i++) {
										if (i < index) {
											vm.premixes[i].premix_position--;
										} else {
											break;
										}
									}
								}
								closeModal();
							})
							.catch(function (error) {
								console.log(error);
								vm.modalLoading = false;
								errorService.showErrorMessage(error, true, '_error_occurred_deleting_premix_');
							});
					})
					.catch(function () {
						closeModal();
					});
			}
		}

		function changePremixActive(premix) {
			vm.confirmationPromise = $q.defer();
			if (premix.active) {
				vm.warningMessage = '_m_f_recipe_deactivate_premix_warning_';
				openModal('app/pages/premixes/myPremixes/confirmationDialog.modal.html', 'md');
			} else {
				openModal('app/pages/premixes/myPremixes/feedingDatepicker.modal.html', 'sm');
			}

			$q.all([vm.confirmationPromise.promise])
				.then(function () {
					vm.modalLoading = true;
					premix.active = !premix.active;
					premix.start_from = moment.utc(vm.startDate).format('YYYY-MM-DDTHH:mm:ss[Z]');
					premix.last_modified_user = vm.user.email;
					myPremixesService
						.changeActive(premix)
						.then(function () {
							closeModal();
						})
						.catch(function (error) {
							premix.active = !premix.active;
							console.log(error);
							errorService.showErrorMessage(error, true, '_error_occurred_active_premixes_');
						});
				})
				.catch(function () {
					closeModal();
				});
		}

		function move(premix, direction) {
			var toIndex = 0;
			var index = vm.premixes.indexOf(premix);
			vm.reordered = true;
			var element = vm.premixes[index];
			if (direction == 'up') {
				toIndex = index - 1;
			} else {
				toIndex = index + 1;
			}
			vm.premixes.splice(index, 1);
			vm.premixes.splice(toIndex, 0, element);
		}

		function drag(index) {
			vm.reordered = true;
			vm.premixes.splice(index, 1);
		}

		function saveNewOrder() {
			updatePremixPositions();
			vm.reordered = false;
			vm.disableReorder = true;
			var list = vm.premixes.filter(function (premix) {
				return premix.position_changed;
			});

			return myPremixesService
				.saveOrder(list)
				.then(function () {
					vm.premixes.forEach(function (premix) {
						premix.position_changed = false;
					});
					vm.disableReorder = false;
				})
				.catch(function (error) {
					vm.disableReorder = false;
					vm.reordered = true;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_saving_order_');
				});
		}

		function updatePremixPositions() {
			var max = -1000;

			vm.premixes.forEach(function (premix) {
				if (premix.premix_position > max) {
					max = premix.premix_position;
				}
			});

			vm.premixes.forEach(function (premix) {
				if (premix.premix_position !== max) {
					premix.premix_position = max;
					premix.position_changed = true;
				}
				max--;
			});
		}

		function editPremix(premix) {
			$state.go('premixes.editPremix', {
				uuid: premix.id
			});
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function confirm() {
			try {
				vm.confirmationPromise.resolve();
			} catch (error) {
				console.log(error);
			}
		}

		function cancel() {
			try {
				vm.confirmationPromise.reject();
			} catch (error) {
				console.log(error);
			}
		}

		function closeModal() {
			$uibModalStack.dismissAll();
			$timeout(function () {
				vm.modalLoading = false;
			}, 50);
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});

		$scope.$on('default_team_herd_changed', function () {
			init();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.premixes.myPremixes').factory('myPremixesService', myPremixesService);

	/** @ngInject */
	function myPremixesService($http, APP_CONST, $q) {
		return {
			getPremixes: getPremixes,
			changeActive: changeActive,
			deletePremix: deletePremix,
			saveOrder: saveOrder
		};

		function getPremixes(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'premixrecipe' + suffix)
				.then(success)
				.catch(error);
		}

		function changeActive(premix) {
			return $http
				.put(APP_CONST.api_base_url + 'premixrecipe/activate', premix)
				.then(success)
				.catch(error);
		}

		function deletePremix(premixes) {
			return $http
				.put(APP_CONST.api_base_url + 'premixrecipe/delete', premixes)
				.then(success)
				.catch(error);
		}

		function saveOrder(premixes) {
			return $http
				.put(APP_CONST.api_base_url + 'premixrecipe/position', premixes)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.premixes.editPremix').controller('editPremixCtrl', editPremixCtrl);

	/** @ngInject */
	function editPremixCtrl($state, $filter, editPremixService, APP_CONST, $timeout, editableOptions, editableThemes, $locale, dataServiceFactory, $scope, $rootScope, $uibModal, $uibModalStack, errorService, $interval, authService, unitConversionService, uaParser, $stateParams, $q) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var nfdTimer;
		var nfcTimer;
		var nfaTimer;
		var nfaDTimer;
		var nfaAFTimer;
		var versionTimer;
		var RRule = rrule.RRule;
		var rationAccessCode = 16;
		var premixPromise;
		var basisPromise;
		var wagonsPromise;

		vm.cancelWizard = cancelWizard;
		vm.savePremix = savePremix;
		vm.toggleShowBasis = toggleShowBasis;
		vm.basisChanged = basisChanged;
		vm.selectBasis = selectBasis;
		vm.calculateTotalAmount = calculateTotalAmount;
		vm.amountOptionChanged = amountOptionChanged;
		vm.wagonSelected = wagonSelected;
		vm.defaultSelected = defaultSelected;
		vm.removeWagon = removeWagon;
		vm.openAddWagonModal = openAddWagonModal;
		vm.addExistingWagon = addExistingWagon;
		vm.addWagon = addWagon;
		vm.openAddLoadModal = openAddLoadModal;
		vm.cancel = cancel;
		vm.saveLoad = saveLoad;
		vm.removeLoad = removeLoad;
		vm.setLoad = setLoad;
		vm.calculateSuggestion = calculateSuggestion;
		vm.updateNewFeed = updateNewFeed;
		vm.openAddNewFeedForm = openAddNewFeedForm;
		vm.cancelAddNewFeed = cancelAddNewFeed;
		vm.addNewFeed = addNewFeed;
		vm.inputKeyPress = inputKeyPress;
		vm.feedTypeSelected = feedTypeSelected;
		vm.newFeedDmChanged = newFeedDmChanged;
		vm.newFeedAmountDmChanged = newFeedAmountDmChanged;
		vm.newFeedAmountAsFedChanged = newFeedAmountAsFedChanged;
		vm.newFeedCostDmChanged = newFeedCostDmChanged;
		vm.newFeedCostAsFedChanged = newFeedCostAsFedChanged;
		vm.removeNewFeed = removeNewFeed;
		vm.drag = drag;
		vm.disableSaveButton = disableSaveButton;
		vm.tabValidation = tabValidation;
		vm.selectOriginalBasis = selectOriginalBasis;
		vm.basisDetails = basisDetails;
		vm.editBasis = editBasis;
		vm.basisPaginationChanged = basisPaginationChanged;
		vm.timeChanged = timeChanged;
		vm.calculateTotalPremixAmount = calculateTotalPremixAmount;
		vm.selectVersion = selectVersion;
		vm.daySelected = daySelected;
		vm.openEditLoadModal = openEditLoadModal;
		vm.getFeedByName = getFeedByName;
		vm.feedSelected = feedSelected;
		vm.openMixingTimeSelector = openMixingTimeSelector;
		vm.getMinutes = getMinutes;
		vm.saveMixingTime = saveMixingTime;
		init();

		function init() {
			vm.errorOccured = false;
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			var from_premix = JSON.parse(localStorage.getItem('from_premix'));
			vm.historicalVersion = false;
			if (from_premix && Object.keys(dataServiceFactory.edit_premix_data).length !== 0) {
				vm.from_premix = from_premix;
			}
			if (!vm.settings.use_kgs) {
				vm.max = 88.18;
				vm.weight = 'Lb';
			} else {
				vm.max = 40;
				vm.weight = 'Kg';
			}
			vm.device = uaParser.getDevice('type');
			if (vm.device) {
				vm.disableDrag = true;
			}
			checkLng();
			vm.selectedTeam = vm.settings.selectedTeam.id;
			vm.selectedHerd = vm.settings.selectedHerd.id;
			vm.loading = true;
			vm.loadingBasis = true;
			vm.loadingMixerWagons = true;
			vm.today = moment().toDate();
			vm.new_feed = {};
			vm.datepickerOptions = {
				minDate: vm.today
			};

			setFeedTypes(APP_CONST.constants.feed_types);
			setStrings();
			if (vm.selectedHerd) {
				getInitData($stateParams.uuid);
			} else {
				vm.loading = false;
			}
		}

		function getInitData(premix_id) {
			premixPromise = $q.defer();
			basisPromise = $q.defer();
			wagonsPromise = $q.defer();

			if (vm.from_premix) {
				vm.premix = dataServiceFactory.edit_premix_data;
				getBasisData(false, vm.premix.selected_basis);
				//getMixerWagons(true);
				premixPromise.resolve();
				vm.loading = false;
				vm.loadingMixerWagons = false;
			} else {
				getPremixById(premix_id);
			}

			$q.all([premixPromise.promise, basisPromise.promise, wagonsPromise.promise])
				.then(function () {
					processResponse(true);
				})
				.catch(function (error) {
					console.log(error);
					vm.errorOccured = true;
					errorService.showErrorMessage(error, true, '_toastr_error_occured_');
					vm.loading = false;
				});
		}

		function processResponse() {
			vm.premix.original_basis = setOriginalBasis(vm.premix.active_basis);
			if (vm.premix.number_of_animals) {
				vm.premix.selected_amount_option = vm.amountOptions[0];
			} else {
				vm.premix.selected_amount_option = vm.amountOptions[1];
			}

			vm.premix.selected_interval = getInterval(vm.premix.origin_repeat_interval, 1);
			vm.premix.repeat_interval = getInterval(vm.premix.origin_repeat_interval, 2);
			vm.premix.feeding_time = getFeedingTime(vm.premix.premix_production_time);
			vm.premix.start_feeding_date = vm.premix.activeVersion && vm.premix.activeVersion.used_from ? (moment(vm.premix.activeVersion.used_from).isBefore(moment()) ? new Date() : new Date(vm.premix.activeVersion.used_from)) : new Date();
			timeChanged();
			vm.premix.wagons = getWagons(vm.premix.all_wagons, vm.premix.mixing_wagons);
			checkWagonSelection();
			vm.premix.total_amount = getTotalAmount(vm.premix.load_definitions);
			vm.premix.suggestion = getSuggestion(vm.premix.load_definitions, vm.premix.wagons);
			vm.premix.suggestion_help_input = 'valid';
			if (vm.premix.basis_type.type != 'manual') {
				vm.basis = setBasis(vm.basis, vm.premix);
				selectOriginalBasis(true);
			} else {
				selectManualBasis();
			}

			vm.loadingBasis = false;
			vm.loadingMixerWagons = false;
		}

		function setBasis(basis, premix, show) {
			var active_basis = premix.active_basis;
			var base = basis.find(function (b) {
				return (active_basis.feed_premix_id && active_basis.feed_premix_id == b.id) || (active_basis.ration_feed_premix_id && active_basis.ration_feed_premix_id == b.id) || (active_basis.ration_header_premix_id && active_basis.ration_header_premix_id == b.id);
			});

			if (base) {
				for (var i = 0; i < basis.length; i++) {
					if (basis[i].id == base.id) {
						if (show) {
							basis[i].is_displayed = true;
							if (moment(basis[i].last_modified_date).isAfter(active_basis.last_modified_date)) {
								basis[i].origin = i18nFilter('_m_f_edited_basis_');
								vm.premix.original_basis.origin = i18nFilter('_m_f_premix_basis_');
							} else {
								basis[i].origin = i18nFilter('_m_f_original_basis_');
								vm.premix.original_basis.origin = i18nFilter('_m_f_premix_basis_');
							}
						} else {
							if (moment(basis[i].last_modified_date).isAfter(active_basis.last_modified_date)) {
								basis[i].is_displayed = true;
								vm.premix.show_hide_ration_button = false;
								basis[i].origin = i18nFilter('_m_f_edited_basis_');
								vm.premix.original_basis.origin = i18nFilter('_m_f_premix_basis_');
							} else {
								basis[i].is_displayed = false;
								basis[i].duplicate = true;
								basis[i].origin = null;
								vm.premix.show_hide_ration_button = true;
								vm.premix.original_basis.origin = null;
							}
						}
					} else {
						basis[i].is_displayed = true;
					}
				}
			} else {
				vm.premix.original_basis.origin = null;
				vm.premix.show_hide_ration_button = false;
				for (var j = 0; j < basis.length; j++) {
					basis[j].is_displayed = true;
				}
			}
			return basis;
		}

		function getSuggestion(loads, wagons) {
			loads = $filter('orderBy')(loads, 'load_position');
			var l = [];
			var sum = 0;

			for (var i = 0; i < loads.length; i++) {
				sum += loads[i].amount;
				var wagon = wagons.filter(function (item) {
					return item.id == loads[i].mixer_wagon_id;
				});
				var load = {
					value: loads[i].amount,
					wagon_id: loads[i].mixer_wagon_id,
					weight: wagon ? wagon.weight : null,
					wagon_name: wagon ? wagon.name : 'undefined',
					mixing_time: loads[i].mixing_time ? loads[i].mixing_time : null
				};
				l.push(load);
			}

			var suggestion = {
				number_of_loads: l.length,
				sum: sum,
				loads: l,
				dirty: false
			};

			return suggestion;
		}

		function getTotalAmount(loads) {
			var total_amount = 0;

			for (var i = 0; i < loads.length; i++) {
				total_amount += loads[i].amount;
			}
			return total_amount;
		}

		function getWagons(all_wagons, wagons) {
			var a_wagons = angular.copy(all_wagons);
			for (var i = 0; i < wagons.length; i++) {
				var found = false;
				for (var j = 0; j < a_wagons.length; j++) {
					if (wagons[i].id == a_wagons[j].id) {
						found = true;
						a_wagons[j].selected = true;
						if (wagons[i].position === 0) {
							a_wagons[j].default = true;
						}
					}
				}
				if (!found) {
					a_wagons.push({
						id: wagons[i].id,
						name: wagons[i].mixer_wagon.name,
						value: wagons[i].mixer_wagon.weight * 1000,
						selected: true,
						default: wagons[i].position === 0 ? true : false,
						deleted: true
					});
				}
			}

			return a_wagons;
		}

		function getFeedingTime(time) {
			var t = moment();
			if (time) {
				var t_s = time.split(':');
				var h = t_s[0];
				var m = t_s[1];
				t = t.set('hour', h).set('minute', m);
				return t;
			}
			return null;
		}

		function timeChanged() {
			$timeout(function () {
				var hour = Number.parseInt(moment(vm.premix.feeding_time).format('HH'));
				if (hour >= 4 && hour <= 11) {
					vm.premix.feeding_period = vm.feedingPeriods[0];
				} else if (hour >= 12 && hour <= 18) {
					vm.premix.feeding_period = vm.feedingPeriods[1];
				} else if ((hour >= 19 && hour <= 23) || (hour >= 0 && hour <= 3)) {
					vm.premix.feeding_period = vm.feedingPeriods[2];
				}
			}, 0);
		}

		function getInterval(interval_string, type) {
			var splitted = interval_string ? interval_string.split(';') : [];

			var f = splitted.filter(function (item) {
				return item.indexOf('FREQ=') != -1;
			});
			var inter = splitted.filter(function (item) {
				return item.indexOf('INTERVAL=') != -1;
			});
			var bd = splitted.filter(function (item) {
				return item.indexOf('BYDAY=') != -1;
			});
			if (type == 1) {
				if (f && f.length == 1) {
					f = f[0].split('=')[1];
					if (f) {
						if (bd && bd.length == 1) {
							setCustomDays();
							bd = bd[0].split('=')[1];
							if (bd) {
								var days = bd.split(',');
								for (var i = 0; i < vm.premix.custom_days.length; i++) {
									for (var j = 0; j < days.length; j++) {
										if (vm.premix.custom_days[i].value_s == days[j]) {
											vm.premix.custom_days[i].selected = true;
										}
									}
								}
								vm.premix.custom_days_validation = 'valid';
							}
							//custom
							return vm.intervalOptions[4];
						} else {
							var freq;
							for (var k = 0; k < vm.intervalOptions.length; k++) {
								if (vm.intervalOptions[k].rrule_value_string == f) {
									freq = vm.intervalOptions[k];
									break;
								}
							}
							return freq;
						}
					} else {
						return vm.intervalOptions[5];
					}
				} else {
					//no repeat
					return vm.intervalOptions[5];
				}
			} else {
				if (inter) {
					inter = inter[0].split('=')[1];
					var inter_n = Number(inter);
					if (Number.isInteger(inter_n)) {
						return inter_n;
					} else {
						return 1;
					}
				} else {
					return 1;
				}
			}
		}

		function selectVersion(version) {
			if (versionTimer) {
				$timeout.cancel(versionTimer);
			}

			vm.premix.versions.forEach(function (item) {
				if (item.id != version.id) {
					item.is_selected = false;
				}
			});

			versionTimer = $timeout(function () {
				if (version.historical_version) {
					vm.premix.historicalVersion = true;
					vm.historicalVersion = true;
				} else {
					vm.premix.historicalVersion = false;
					vm.historicalVersion = false;
				}
				vm.premix.current_page = 1;
				vm.premix.activeVersion = version;
				if (vm.premix.activeVersion) {
					vm.premix = setPremix(vm.premix);
				}

				getBasisData(false, vm.premix.selected_basis, true);
			}, 750);
		}

		function selectOriginalBasis() {
			var basis = vm.premix.original_basis;
			vm.premix.original_basis_selected = true;
			vm.premix.basis_selected = true;
			if (vm.premix.original_basis.visible === false) {
				vm.deletedRation = true;
			} else {
				vm.deletedRation = false;
			}

			for (var i = 0; i < vm.basis.length; i++) {
				vm.basis[i].is_selected = false;
			}

			vm.premix.feeds = [];
			vm.premix.basis = vm.premix.original_basis;

			var ingredientList = basis.ingredient_list;
			for (var j = 0; j < ingredientList.length; j++) {
				vm.new_feed = {
					id: ingredientList[j].id,
					name: ingredientList[j].name,
					feed_type: ingredientList[j].feed_type,
					category: ingredientList[j].feed_category,
					dm: ingredientList[j].dm,
					cost: ingredientList[j].cost,
					cost_as_fed: ingredientList[j].cost_as_fed,
					amount: ingredientList[j].amount,
					as_fed: ingredientList[j].as_fed,
					mix_id: ingredientList[j].mix_id,
					ration_feed_id: ingredientList[j].ration_feed_id,
					ration_feed_mix_id: ingredientList[j].ration_feed_mix_id
				};
				addNewFeed(true);
			}

			vm.premix.basis_selected = true;
			vm.premix.basis_help_input = 'valid';
			if (checkIngredientsDmError(vm.premix.feeds)) {
				vm.hasDM0Error = true;
			} else {
				vm.hasDM0Error = false;
			}

			calculateTotalAmount(true);
		}

		function selectManualBasis() {
			var basis = vm.premix.original_basis;
			vm.premix.feeds = [];

			var ingredientList = basis.ingredient_list;
			for (var j = 0; j < ingredientList.length; j++) {
				vm.new_feed = {
					id: ingredientList[j].id,
					name: ingredientList[j].name,
					feed_type: ingredientList[j].feed_type,
					category: ingredientList[j].category,
					dm: ingredientList[j].dm,
					cost: ingredientList[j].cost,
					cost_as_fed: ingredientList[j].cost_as_fed,
					amount: ingredientList[j].amount,
					as_fed: ingredientList[j].as_fed,
					mix_id: ingredientList[j].mix_id,
					ration_feed_id: ingredientList[j].ration_feed_id,
					ration_feed_mix_id: ingredientList[j].ration_feed_mix_id
				};
				addNewFeed(true);
			}

			vm.premix.original_feeds = angular.copy(vm.premix.feeds);

			if (checkIngredientsDmError(vm.premix.feeds)) {
				vm.hasDM0Error = true;
			} else {
				vm.hasDM0Error = false;
			}
			vm.premix.original_basis_selected = true;

			calculateTotalAmount(true);
		}

		function setCustomDays() {
			vm.premix.custom_days = [];
			var listOfDays = APP_CONST.constants.custom_feeding_days;
			for (var i = 0; i < listOfDays.length; i++) {
				vm.premix.custom_days.push({
					name: i18nFilter(listOfDays[i].name),
					selected: listOfDays[i].selected,
					value_s: listOfDays[i].rrule_day,
					rrule_day: RRule[listOfDays[i].rrule_day],
					value: listOfDays[i].value
				});
			}
		}

		function daySelected() {
			for (var i = 0; i < vm.premix.custom_days.length; i++) {
				if (vm.premix.custom_days[i].selected) {
					vm.premix.custom_days_validation = 'valid';
					break;
				} else {
					vm.premix.custom_days_validation = null;
				}
			}
			calculateTotalPremixAmount();
		}

		function checkIngredientsDmError(feeds) {
			var hasDm0 = false;
			for (var i = 0; i < feeds.length; i++) {
				if (feeds[i].dm == 0) {
					hasDm0 = true;
					break;
				}
			}
			return hasDm0;
		}

		function addNewFeed(automatic) {
			if (!automatic) {
				if (vm.newPremixFeedForm.$invalid) {
					return;
				}
			}

			var feedName = null;
			if (automatic) {
				feedName = vm.new_feed && vm.new_feed.name ? vm.new_feed.name : vm.feedFromApi;
			} else {
				feedName = vm.feedFromApi instanceof Object ? vm.new_feed.name : vm.feedFromApi;
				if (!feedName && vm.new_feed) {
					feedName = vm.new_feed.name;
				}
			}

			var obj = {
				id: vm.new_feed.id,
				temp_id: vm.new_feed.id || performance.now(),
				name: feedName,
				feed_type: vm.new_feed.feed_type,
				dm: vm.new_feed.dm,
				cost: vm.new_feed.cost || 0,
				cost_as_fed: vm.new_feed.cost_as_fed || 0,
				amount: vm.new_feed.amount,
				as_fed: vm.new_feed.as_fed,
				mix_id: vm.new_feed.mix_id,
				ration_feed_id: vm.new_feed.ration_feed_id,
				ration_feed_mix_id: vm.new_feed.ration_feed_mix_id
			};
			vm.premix.feeds.push(obj);
			vm.new_feed = {};
			calculatePremixAmount();
			if (!automatic) {
				calculateTotalAmount();
			}
			cancelAddNewFeed();
		}

		function calculateTotalAmount(skip) {
			if (vm.premix.selected_amount_option.value === 0) {
				vm.premix.total_amount = angular.isNumber(vm.premix.number_of_animals) ? vm.premix.number_of_animals * vm.premix.amount_as_fed : 0;
				vm.premix.total_cost = angular.isNumber(vm.premix.number_of_animals) ? vm.premix.number_of_animals * vm.premix.cost : 0;
			} else {
				vm.premix.total_cost = vm.premix.cost;
			}
			calculateTotalPremixAmount(skip);
		}

		function calculateTotalPremixAmount(skip) {
			vm.premix.total_premix_amount = vm.premix.total_amount * getMaxDayDifference();
			if (!skip) {
				calculateSuggestion();
			}
		}

		function getMaxDayDifference() {
			var rule = new RRule({
				dtstart: moment.utc(vm.premix.start_feeding_date).toDate(),
				freq: vm.premix.selected_interval.value !== 5 ? (vm.premix.selected_interval.value !== 4 ? vm.premix.selected_interval.rrule_value : RRule.WEEKLY) : null,
				interval: vm.premix.selected_interval.value !== 5 ? vm.premix.repeat_interval : null,
				until: vm.premix.end_feeding_date ? moment.utc(vm.premix.end_feeding_date).toDate() : moment.utc(vm.premix.start_feeding_date).add(29, 'days').toDate(),
				byweekday: vm.premix.selected_interval.value === 4 ? setRruleDayList() : null,
				count: vm.premix.selected_interval.value !== 5 && vm.premix.repeat_count ? vm.premix.repeat_count : null
			});

			var days = rule.all();
			var max = 1;

			for (var i = 0; i < days.length; i++) {
				if (days[i + 1]) {
					var diff = moment(days[i + 1]).diff(days[i], 'days');
					if (diff > max) {
						max = diff;
					}
				}
			}

			return max;
		}

		function calculateSuggestion() {
			if (!vm.historicalVersion) {
				var selectedWagons = [];
				for (var i = 0; i < vm.premix.wagons.length; i++) {
					if (vm.premix.wagons[i].selected === true) {
						selectedWagons.push(vm.premix.wagons[i]);
					}
				}
				if (selectedWagons && vm.premix.wagon_help_input === 'valid') {
					vm.premix.suggestion = setFeedingSuggestion(vm.premix.total_premix_amount, selectedWagons);
					vm.premix.suggestion_help_input = 'valid';
					vm.feedingsError = null;
				} else {
					vm.premix.suggestion = {};
					vm.premix.suggestion_help_input = undefined;
					vm.feedingsError = null;
				}
			}
		}

		function setFeedingSuggestion(amount, selectedWagons) {
			var numberOfLoads = 0;
			var loads = [];
			var cont = 0;
			var sum = 0;
			var maxValueWagon = selectedWagons.find(function (item) {
				return item.default === true && item.selected === true;
			});
			if (maxValueWagon) {
				amount = unitConversionService.convertData(amount, ['round:0']);
				while (amount > maxValueWagon.value && cont < 9) {
					numberOfLoads++;
					loads.push({
						value: maxValueWagon.value,
						wagon_id: maxValueWagon.id,
						weight: maxValueWagon.weight,
						wagon_name: maxValueWagon.name
					});
					sum += maxValueWagon.value;
					amount = amount - maxValueWagon.value;
					cont++;
				}
				loads = $filter('orderBy')(loads, 'value', true);
				if (amount > 0) {
					numberOfLoads++;
					loads.push({
						value: amount,
						wagon_id: maxValueWagon.id,
						weight: maxValueWagon.weight,
						wagon_name: maxValueWagon.name
					});
					sum += amount;
				}
				var suggestion = {
					number_of_loads: numberOfLoads,
					sum: sum,
					loads: loads,
					dirty: false
				};
				return suggestion;
			}
		}

		function calculatePremixAmount() {
			var amount = 0;
			var amount_as_fed = 0;
			var cost = 0;
			for (var i = 0; i < vm.premix.feeds.length; i++) {
				amount += vm.premix.feeds[i].amount;
				amount_as_fed += vm.premix.feeds[i].as_fed;
				cost += vm.premix.feeds[i].cost * vm.premix.feeds[i].amount;
			}
			vm.premix.amount = amount;
			vm.premix.amount_as_fed = amount_as_fed;
			vm.premix.dm = (amount / amount_as_fed) * 100;
			vm.premix.cost = cost;
		}

		function setOriginalBasis(active_basis) {
			var basis = {
				amount: active_basis.amount_dm,
				dm: active_basis.dm,
				cost: active_basis.cost_dm,
				name: active_basis.premix_name,
				ingredient_list: [],
				id: active_basis.ration_header_premix_id ? active_basis.ration_header_premix_id : active_basis.ration_feed_premix_id ? active_basis.ration_feed_premix_id : active_basis.feed_premix_id,
				visible: active_basis.visible
			};

			for (var i = 0; i < active_basis.scheduled_premix_ingredients.length; i++) {
				var ingredient = {
					id: active_basis.scheduled_premix_ingredients[i].id,
					ration_feed_id: active_basis.scheduled_premix_ingredients[i].ration_feed_id,
					ration_feed_mix_id: active_basis.scheduled_premix_ingredients[i].ration_feed_mix_id,
					mix_id: active_basis.scheduled_premix_ingredients[i].mix_id,
					amount: active_basis.scheduled_premix_ingredients[i].amount_dm,
					cost: active_basis.scheduled_premix_ingredients[i].cost_dm,
					dm: active_basis.scheduled_premix_ingredients[i].dm,
					feed_category: active_basis.scheduled_premix_ingredients[i].feed_category,
					feed_type: active_basis.scheduled_premix_ingredients[i].feed_type,
					name: active_basis.scheduled_premix_ingredients[i].premix_ingredient_name,
					as_fed: (active_basis.scheduled_premix_ingredients[i].amount_dm * 100) / active_basis.scheduled_premix_ingredients[i].dm,
					cost_as_fed: (active_basis.scheduled_premix_ingredients[i].cost_dm * active_basis.scheduled_premix_ingredients[i].dm) / 100
				};
				basis.ingredient_list.push(ingredient);
			}

			return basis;
		}

		function getPremixById(premix_id) {
			return editPremixService
				.getPremixById(premix_id)
				.then(function (response) {
					response.activeVersion = getActiveVersion(response.versions);
					vm.premix = response;
					vm.premix.repeat_interval = null;
					if (vm.premix.versions && vm.premix.versions.length) {
						vm.premix.versions = setVersions(vm.premix);
						vm.premix.versions = setHistoricalFlag(vm.premix.versions, vm.premix.activeVersion);
						setCustomDays();
						getMixerWagons(true);
						vm.premix = setPremix(vm.premix);
						getBasisData(true, vm.premix.selected_basis);
						premixPromise.resolve();
						vm.loading = false;
					}
					else {
						premixPromise.reject();
					}

				})
				.catch(function (error) {
					console.log(error);
					premixPromise.reject();
				});
		}

		function setHistoricalFlag(versions, activeVersion) {
			versions = versions.map(function (version) {
				var isBefore = moment(version.used_from).isBefore(activeVersion.used_from);
				version.historical_version = isBefore ? true : false;
				return version;
			});

			return versions;
		}

		function setPremix(premix) {
			premix.number_of_animals = premix.activeVersion.number_of_animals;
			premix.mixing_wagons = premix.activeVersion.mixing_wagons;
			premix.load_definitions = premix.activeVersion.load_definitions;
			premix.original_schedules = angular.copy(premix.activeVersion.scheduled_ration);
			premix.start_from = premix.activeVersion.used_from;
			premix.premix_production_time = premix.activeVersion.premix_production_time;
			var basis = getBasis(premix.activeVersion.scheduled_ration);
			premix.active_basis = basis.active_basis;
			premix.basis_type = basis.basis_type;
			premix.selected_basis = setSelectedBasis(basis.basis_type);
			premix.origin_repeat_interval = angular.copy(premix.activeVersion.repeat_interval);
			premix.repeat_interval = null;
			premix.active_basis = setFeedCategories(premix.active_basis);

			return premix;
		}

		function setVersions(premix) {
			var versions = $filter('orderBy')(premix.versions, ['used_from', 'create_date'], true);
			versions.forEach(function (item) {
				item.feeding_time = getFeedingTime(item.premix_production_time);
				item.feeding_time = moment(item.feeding_time).format('LT');
				if (item.id == premix.activeVersion.id) {
					item.is_selected = true;
					item.is_active_version = true;
				}
			});
			return versions;
		}

		function getActiveVersion(versions) {
			var date = moment();
			var version;

			if (versions.length == 1) {
				version = versions[0];
			} else {
				versions = $filter('orderBy')(versions, ['used_from', 'create_date']);
				var versionsBefore = versions.filter(function (_version) {
					return moment(_version.used_from).isSameOrBefore(date);
				});

				if (versionsBefore.length) {
					version = versionsBefore[versionsBefore.length - 1];
				} else {
					version = versions[versions.length - 1];
				}
			}

			return version;
		}

		function setFeedCategories(active_basis) {
			for (var i = 0; i < active_basis.scheduled_premix_ingredients.length; i++) {
				var hasFeedType = false;
				for (var k = 0; k < vm.feed_types.length; k++) {
					if (active_basis.scheduled_premix_ingredients[i].feed_type && !active_basis.scheduled_premix_ingredients[i].feed_type.name) {
						if (active_basis.scheduled_premix_ingredients[i].feed_type.toLowerCase() === vm.feed_types[k].name.toLowerCase()) {
							active_basis.scheduled_premix_ingredients[i].feed_type = vm.feed_types[k];
							hasFeedType = true;
							break;
						}
					}
					if (active_basis.scheduled_premix_ingredients[i].feed_type && active_basis.scheduled_premix_ingredients[i].feed_type.name) {
						hasFeedType = true;
					}
				}
				if (!hasFeedType) {
					active_basis.scheduled_premix_ingredients[i].feed_type = {
						name: i18nFilter('_feeds_type_not_set_')
					};
				}
			}

			return active_basis;
		}

		function setSelectedBasis(type) {
			var basis;
			for (var i = 0; i < vm.basisTypes.length; i++) {
				if (vm.basisTypes[i].value == type.value) {
					basis = vm.basisTypes[i];
					break;
				}
			}

			return basis;
		}

		function getBasisData(init, type, select_basis) {
			vm.loadingBasis = true;
			if (type.value == 3) {
				if (vm.premix.original_feeds && vm.premix.original_feeds.length) {
					vm.premix.feeds = angular.copy(vm.premix.original_feeds);
				}
				showInputFields();
				vm.loadingBasis = false;
				if (init) {
					basisPromise.resolve();
				} else {
					if (select_basis) {
						processResponse();
					} else {
						vm.loadingBasis = false;
						vm.loading = false;
					}
				}
			} else {
				vm.basis = [];
				if (init) {
					vm.premix.current_page = 1;
				} else {
					if (vm.premix.basis_is_changed) {
						vm.premix.current_page = 1;
					}
				}
				var return_type;
				if (type.value === 0) {
					return_type = 'ration';
				} else if (type.value === 1) {
					return_type = 'ration-premix';
				} else {
					return_type = 'premix';
				}
				var suffix = '?team=' + vm.selectedTeam + '&page_number=' + vm.premix.current_page + '&herd=' + vm.selectedHerd + '&return_type=' + return_type;
				return editPremixService
					.getRationBasis(suffix)
					.then(function (response) {
						if (!vm.premix.original_basis_selected) {
							vm.premix.basis_help_input = undefined;
						}
						if (response.length > 0) {
							vm.totalItemsBasis = response[0].number_of_all;
						} else {
							vm.totalItemsBasis = 0;
						}
						for (var i = 0; i < response.length; i++) {
							for (var j = 0; j < response[i].ingredient_list.length; j++) {
								response[i].ingredient_list[j].amount = Number.isFinite(response[i].ingredient_list[j].amount) ? Number.parseFloat(response[i].ingredient_list[j].amount) : 0;
								response[i].ingredient_list[j].as_fed = Number.isFinite(response[i].ingredient_list[j].as_fed) ? Number.parseFloat(response[i].ingredient_list[j].as_fed) : 0;
								response[i].ingredient_list[j].cost_as_fed = (response[i].ingredient_list[j].cost * response[i].ingredient_list[j].dm) / 100;
								var hasFeedType = false;
								for (var k = 0; k < vm.feed_types.length; k++) {
									if (response[i].ingredient_list[j].feed_type) {
										if (response[i].ingredient_list[j].feed_type.toLowerCase() === vm.feed_types[k].name.toLowerCase()) {
											response[i].ingredient_list[j].feed_type = vm.feed_types[k];
											hasFeedType = true;
											break;
										}
									}
								}
								if (!hasFeedType) {
									response[i].ingredient_list[j].feed_type = {
										name: i18nFilter('_feeds_type_not_set_')
									};
								}
							}
							response[i].ingredient_list = $filter('orderBy')(response[i].ingredient_list, 'id');
						}
						vm.basis = response;
						if (init) {
							basisPromise.resolve();
						} else {
							vm.basis = setBasis(response, vm.premix);
							if (vm.from_premix) {
								vm.basis = selectBasisFromPremix(response, vm.premix);
							}

							if (select_basis) {
								processResponse();
							} else {
								vm.loadingBasis = false;
								vm.loading = false;
							}
						}
					})
					.catch(function (error) {
						console.log(error);
						vm.loadingBasis = false;
						vm.loading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_loading_ration_basis_', init);
						basisPromise.reject();
					});
			}
		}

		function selectBasisFromPremix(basis, premix) {
			if (!premix.original_basis_selected) {
				for (var i = 0; i < basis.length; i++) {
					if (basis[i].id == premix.basis.id) {
						basis[i].is_selected = true;
						vm.premix.basis_help_input = 'valid';
					}
				}
			}

			return basis;
		}

		function getMixerWagons(init) {
			vm.loadingMixerWagons = true;
			var suffix = '?team=' + vm.selectedTeam + '&herd=' + vm.selectedHerd;
			return editPremixService
				.getMixerWagons(suffix)
				.then(function (response) {
					for (var i = 0; i < response.length; i++) {
						response[i].default = false;
						response[i].selected = false;
						response[i].value = response[i].weight * 1000;
					}
					vm.premix.wagons = response;
					vm.premix.wagons = $filter('orderBy')(vm.premix.wagons, 'weight', true);
					vm.premix.all_wagons = angular.copy(vm.premix.wagons);
					wagonsPromise.resolve();
				})
				.catch(function (error) {
					vm.loadingMixerWagons = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_wagons_', init);
					wagonsPromise.reject();
				});
		}

		function showInputFields() {
			vm.showIFields = true;
			vm.feedFromApi = null;
			vm.new_feed = new Feed();
		}

		function cancelAddNewFeed() {
			vm.showIFields = false;
			vm.feedFromApi = null;
			vm.new_feed = new Feed();
		}

		function getBasis(scheduled_rations) {
			/*scheduled_rations = $filter('orderBy')(scheduled_rations, 'used_from');
			var date = new Date();
			var active_scheduler = getActiveSchedulerByDate(scheduled_rations, date);*/
			var active_scheduler = scheduled_rations;
			var basis_type;
			var basis;
			if (active_scheduler.feed_premix_id) {
				if (active_scheduler.is_manual_premix) {
					basis_type = {
						type: 'manual',
						value: 3
					};
				} else {
					basis_type = {
						type: 'premix',
						value: 2
					};
				}
			} else if (active_scheduler.ration_feed_premix_id) {
				basis_type = {
					type: 'ration-premix',
					value: 1
				};
			} else if (active_scheduler.ration_header_premix_id) {
				basis_type = {
					type: 'ration',
					value: 0
				};
			} else {
				basis_type = {
					type: 'manual',
					value: 3
				};
			}
			basis = {
				basis_type: basis_type,
				active_basis: active_scheduler
			};
			return basis;
		}

		/*function getActiveSchedulerByDate(scheduled_rations, date) {
			var active_schedule;
			for (var i = 0; i < scheduled_rations.length; i++) {
				var start_date = new Date(scheduled_rations[i].used_from);
				if (scheduled_rations[i + 1]) {
					var end_date = new Date(scheduled_rations[i + 1].used_from);
				} else {
					var end_date = new Date('2100-10-10');
				}
				if ((moment(start_date).isBefore(date) && moment(end_date).isAfter(date)) || moment(start_date).isSame(date) || moment(end_date).isSame(date)) {
					active_schedule = scheduled_rations[i];
					break;
				}
			}
			return active_schedule;
		}*/

		function checkLng() {
			if (vm.settings.language) {
				if (vm.settings.language == 'en-gb') {
					vm.locale = 'en-gb';
				} else if (vm.settings.language == 'en-us') {
					vm.locale = 'en';
				} else if (vm.settings.language == 'cs-cz') {
					vm.locale = 'cs';
				} else if (vm.settings.language == 'es-es') {
					vm.locale = 'es';
				} else if (vm.settings.language == 'nl-nl') {
					vm.locale = 'nl';
				} else if (vm.settings.language == 'it-it') {
					vm.locale = 'it';
				}
			} else {
				vm.locale = 'en-gb';
			}
		}

		function setFeedTypes(feed_types) {
			vm.feed_types = [];
			for (var i = 0; i < feed_types.length; i++) {
				var temp = '_feeds_type_' + feed_types[i].value + '_';
				feed_types[i].show_name = temp;
				feed_types[i].feed_category = feed_types[i].category;
				feed_types[i].translated = i18nFilter(temp);
				vm.feed_types.push(feed_types[i]);
			}
		}

		function setRruleDayList() {
			var list = [];
			for (var i = 0; i < vm.premix.custom_days.length; i++) {
				if (vm.premix.custom_days[i].selected) {
					list.push(vm.premix.custom_days[i].rrule_day);
				}
			}
			return list;
		}

		function setStrings() {
			vm.step1 = i18nFilter('_label_versions_');
			vm.step2 = i18nFilter('_m_f_add_new_premix_step1_title_');
			vm.step3 = i18nFilter('_m_f_add_new_premix_step2_title_');
			vm.step4 = i18nFilter('_m_f_add_new_premix_step3_title_');
			vm.step5 = i18nFilter('_m_f_add_new_premix_step4_title_');
			setBasisTypes();
			setAmountOptions();
			setRepeatIntervalOptions();
			setFeedingPeriods();
		}

		function setBasisTypes() {
			vm.basisTypes = [
				{
					name: i18nFilter('_m_f_premix_basis_add_manually_'),
					value: 3
				}
			];

			if (authService.can(rationAccessCode)) {
				vm.hasRationAccess = true;
				vm.basisTypes.splice(
					0,
					0,
					{
						name: i18nFilter('_m_f_premix_basis_ration_'),
						value: 0
					},
					{
						name: i18nFilter('_m_f_premix_basis_premix_'),
						value: 1
					},
					{
						name: i18nFilter('_m_f_premix_basis_regular_premix_'),
						value: 2
					}
				);
			} else {
				vm.hasRationAccess = false;
			}
		}

		function setAmountOptions() {
			vm.amountOptions = [
				{
					name: i18nFilter('_m_f_premix_amount_number_of_animals_'),
					value: 0
				},
				{
					name: i18nFilter('_m_f_premix_amount_total_'),
					value: 1
				}
			];
		}

		function setRepeatIntervalOptions() {
			vm.intervalOptions = [
				{
					name: i18nFilter('_m_f_premix_repeat_interval_daily_'),
					value: 0,
					rrule_value: RRule.DAILY,
					rrule_value_string: 'DAILY'
				},
				{
					name: i18nFilter('_m_f_premix_repeat_interval_weekly_'),
					value: 1,
					rrule_value: RRule.WEEKLY,
					rrule_value_string: 'WEEKLY'
				},
				{
					name: i18nFilter('_m_f_premix_repeat_interval_monthly_'),
					value: 2,
					rrule_value: RRule.MONTHLY,
					rrule_value_string: 'MONTHLY'
				},
				{
					name: i18nFilter('_m_f_premix_repeat_interval_yearly_'),
					value: 3,
					rrule_value: RRule.YEARLY,
					rrule_value_string: 'YEARLY'
				},
				{
					name: i18nFilter('_m_f_premix_repeat_interval_custom_'),
					value: 4
				},
				{
					name: i18nFilter('_m_f_premix_repeat_interval_no_repeat_'),
					value: 5
				}
			];
		}

		function setFeedingPeriods() {
			vm.feedingPeriods = [
				{
					name: i18nFilter('_m_f_pen_morning_feeding_'),
					value: 1
				},
				{
					name: i18nFilter('_m_f_pen_noon_feeding_'),
					value: 2
				},
				{
					name: i18nFilter('_m_f_pen_evening_feeding_'),
					value: 3
				}
			];
		}

		function cancelWizard() {
			$state.go('premixes.myPremixes');
		}

		function savePremix() {
			vm.loading = true;
			var premixDTO = new PremixDTO(vm.premix);
			editPremixService
				.savePremix(premixDTO)
				.then(function () {
					$state.go('premixes.myPremixes');
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_saving_basis_');
				});

			function PremixDTO(premix) {
				this.id = premix.id;
				this.name = premix.name;
				this.amount = premix.total_amount;
				this.team_id = vm.selectedTeam;
				this.herd_id = vm.selectedHerd;
				this.start_from = moment.utc(premix.start_feeding_date).format('YYYY-MM-DDTHH:mm:ss[Z]');
				this.premix_period = premix.feeding_period.value;
				this.premix_production_time = moment(premix.feeding_time).format('HH:mm:ss') + 'Z';
				this.repeat_interval = createRRule();
				this.recipe_premix_scheduler = setRecipeRationSchedulerDTO(premix, this.start_from);
				this.mixer_wagon_list = setWagonData(premix.wagons);
				this.load_management = setManagementData(premix.suggestion, premix.feeding_period.value);
				this.number_of_animals = premix.number_of_animals;
			}

			function setRecipeRationSchedulerDTO(premix, startFrom) {
				var obj = {};
				if (premix.basis) {
					obj = {
						ration_header_premix_id: vm.premix.selected_basis.value === 0 ? premix.basis.id : null,
						ration_feed_premix_id: vm.premix.selected_basis.value === 1 ? premix.basis.id : null,
						feed_premix_id: vm.premix.selected_basis.value === 2 ? premix.basis.id : null,
						premix_name: premix.basis.name,
						used_from: startFrom || moment().utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
						dm: premix.basis.dm,
						amount_dm: premix.basis.amount,
						cost_dm: premix.basis.cost,
						visible: true,
						type: 1,
						scheduled_premix_ingredients: setScheduledRationFeedDTO(premix.feeds)
					};
				} else {
					obj = {
						is_manual_premix: true,
						premix_name: premix.name,
						ration_header_premix_id: null,
						ration_feed_premix_id: null,
						feed_premix_id: null,
						used_from: startFrom || moment().utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
						dm: premix.dm,
						amount_dm: premix.amount,
						cost_dm: premix.cost,
						visible: true,
						type: 1,
						scheduled_premix_ingredients: setScheduledRationFeedDTO(premix.feeds)
					};
				}
				return obj;

				function setScheduledRationFeedDTO(feeds) {
					var list = [];
					var sum = 0;

					feeds.forEach(function (feed, index) {
						sum += feed.as_fed;
						list.push({
							premix_ingredient_name: feed && feed.name ? feed.name : '',
							dm: feed.dm,
							amount_dm: feed.amount,
							cost_dm: feed.cost,
							type: 1,
							order_number: index + 1,
							visible: true,
							feed_type: feed.feed_type.name,
							feed_category: feed.feed_type.feed_category,
							id: feed.id,
							ration_feed_id: feed.ration_feed_id,
							ration_feed_mix_id: feed.ration_feed_mix_id,
							mix_id: feed.mix_id
						});
					});

					list.forEach(function (feed) {
						feed.percentage = calculatePercentage(feed, sum);
					});

					return list;

					function calculatePercentage(feed, sum) {
						var asFed = (feed.amount_dm * 100) / feed.dm;

						return (asFed * 100) / sum;
					}
				}
			}

			function setWagonData(wagonList) {
				var selectedWagons = wagonList.filter(function (wagon) {
					return wagon.selected === true;
				});

				selectedWagons = $filter('orderBy')(selectedWagons, ['-default', '-weight']);

				var list = [];
				for (var i = 0; i < selectedWagons.length; i++) {
					list.push({
						mixer_wagon_id: selectedWagons[i].id,
						mixer_wagon: {
							id: selectedWagons[i].id,
							volume: selectedWagons[i].volume,
							weight: selectedWagons[i].weight,
							name: selectedWagons[i].name,
							herd_id: vm.selectedHerd,
							team_id: vm.selectedTeam,
							last_modified_user: vm.user.email
						},
						position: i
					});
				}
				return list;
			}

			function setManagementData(suggestion, period) {
				var feeding = {
					load_subject_order_number: period,
					load_details: []
				};
				for (var i = 0; i < suggestion.loads.length; i++) {
					feeding.load_details.push({
						amount: suggestion.loads[i].value,
						mixer_wagon_id: suggestion.loads[i].wagon_id,
						position: i,
						mixing_time: suggestion.loads[i].mixing_time ? suggestion.loads[i].mixing_time : null
					});
				}
				return [feeding];
			}

			function createRRule() {
				var rule = new RRule({
					freq: vm.premix.selected_interval.value !== 5 ? (vm.premix.selected_interval.value !== 4 ? vm.premix.selected_interval.rrule_value : RRule.WEEKLY) : null,
					interval: vm.premix.selected_interval.value !== 5 ? vm.premix.repeat_interval : null,
					until: vm.premix.end_feeding_date ? moment.utc(vm.premix.end_feeding_date).toDate() : null,
					byweekday: vm.premix.selected_interval.value === 4 ? setRruleDayList() : null,
					count: vm.premix.selected_interval.value !== 5 && vm.premix.repeat_count ? vm.premix.repeat_count : null
				});
				return rule.toString().split(':')[1];
			}
		}

		function toggleShowBasis() {
			vm.hideFilters = !vm.hideFilters;
			vm.basis = setBasis(vm.basis, vm.premix, vm.hideFilters);
		}

		function basisChanged() {
			vm.premix.basis_is_changed = true;
			vm.premix.basis_selected = false;
			vm.premix.basis = null;
			vm.premix.feeds = [];
			getBasisData(false, vm.premix.selected_basis);
		}

		function selectBasis(basis, response) {
			if (basis.id != vm.premix.original_basis) {
				vm.premix.original_basis_selected = false;
				vm.deletedRation = false;
			}
			var basisList;
			if (response && response.length) {
				basisList = response;
			} else {
				basisList = vm.basis;
			}
			vm.premix.feeds = [];
			vm.premix.basis = basis;
			for (var i = 0; i < basisList.length; i++) {
				if (basisList[i].id !== basis.id) {
					basisList[i].is_selected = false;
				} else {
					basisList[i].is_selected = true;
					var ingredientList = basisList[i].ingredient_list;
					for (var j = 0; j < ingredientList.length; j++) {
						vm.new_feed = {
							id: ingredientList[j].id,
							name: ingredientList[j].name,
							feed_type: ingredientList[j].feed_type,
							category: ingredientList[j].category,
							dm: ingredientList[j].dm,
							cost: ingredientList[j].cost,
							cost_as_fed: ingredientList[j].cost_as_fed,
							amount: ingredientList[j].amount,
							as_fed: ingredientList[j].as_fed,
							mix_id: ingredientList[j].mix_id,
							ration_feed_id: ingredientList[j].ration_feed_id,
							ration_feed_mix_id: ingredientList[j].ration_feed_mix_id
						};
						addNewFeed(true);
					}
				}
			}
			vm.premix.basis_selected = true;
			vm.premix.basis_help_input = 'valid';
			if (checkIngredientsDmError(vm.premix.feeds)) {
				vm.hasDM0Error = true;
			} else {
				vm.hasDM0Error = false;
			}

			calculateTotalAmount();
		}

		function amountOptionChanged() {
			vm.premix.total_amount = 0;
			vm.premix.total_premix_amount = 0;
			vm.premix.number_of_animals = 0;
		}

		function wagonSelected(wagon) {
			if (!wagon.selected) {
				wagon.default = false;
			}
			var selectedWagons = [];
			var selIndex;
			for (var i = 0; i < vm.premix.wagons.length; i++) {
				if (vm.premix.wagons[i].selected === true) {
					selectedWagons.push(vm.premix.wagons[i]);
					selIndex = i;
				}
			}
			if (selectedWagons.length === 1) {
				vm.premix.wagons[selIndex].default = true;
			}
			checkWagonSelection();
			if (vm.premix.suggestion && !vm.premix.suggestion.dirty) {
				calculateSuggestion();
			}
		}

		function checkWagonSelection() {
			for (var i = 0; i < vm.premix.wagons.length; i++) {
				if (vm.premix.wagons[i].selected && vm.premix.wagons[i].deleted) {
					vm.premix.wagon_help_input = null;
					return;
				}
			}

			var sel = false;
			var def = false;
			for (var k = 0; k < vm.premix.wagons.length; k++) {
				if (vm.premix.wagons[k].selected === true) {
					sel = true;
				}
				if (vm.premix.wagons[k].default === true) {
					def = true;
				}
				if (sel && def) {
					break;
				}
			}
			vm.premix.wagon_help_input = sel && def ? 'valid' : undefined;
		}

		function defaultSelected(wagon) {
			for (var i = 0; i < vm.premix.wagons.length; i++) {
				if (vm.premix.wagons[i].id !== wagon.id) {
					vm.premix.wagons[i].default = false;
				} else {
					vm.premix.wagons[i].default = true;
				}
			}
			checkWagonSelection();
			if (vm.premix.suggestion && !vm.premix.suggestion.dirty) {
				calculateSuggestion();
			}
		}

		function removeWagon(wagon) {
			if (!vm.historicalVersion) {
				wagon.selected = false;
				calculateSuggestion();
			}
		}

		function openAddWagonModal(e, suggestion) {
			if (!vm.historicalVersion) {
				e.preventDefault();
				vm.suggestion = suggestion;
				vm.newWagon = {};
				openModal('app/pages/premixes/editPremix/addWagon.modal.html', 'md');
			}
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function saveMixingTime() {
			var minutes = vm.mixingTime && vm.mixingTime.minutes ? parseInt(vm.mixingTime.minutes, 10) : 0;
			var mixingTimeSeconds = minutes * 60 || null;

			if (vm.mixingTimeData && vm.mixingTimeData.set_to_all) {
				(vm.premix.suggestion.loads || []).forEach(function (load) {
					load.mixing_time = mixingTimeSeconds;
				});
			} else if (vm.mixingTimeData && vm.mixingTimeData.load) {
				vm.mixingTimeData.load.mixing_time = mixingTimeSeconds;
			}

			cancel();
		}

		function getMinutes() {
			return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59];
		}

		function openMixingTimeSelector(load) {
			if (vm.historicalVersion) {
				return;
			}

			vm.mixingTimeData = {
				load: load,
				set_to_all: false
			};

			var mixingTime = load && load.mixing_time ? {
				hours: Math.floor(load.mixing_time / 3600) || null,
				minutes: Math.floor((load.mixing_time % 3600) / 60) || null,
				seconds: load.mixing_time % 60 || null
			} : {
				hours: null,
				minutes: null,
				seconds: null
			};

			vm.mixingTime = angular.copy(mixingTime);
			openModal('app/pages/recipes/mixingTimeSelector.modal.html', 'sm');
		}

		function addExistingWagon(wagon) {
			wagon.selected = true;
			if (vm.premix.suggestion && !vm.premix.suggestion.dirty) {
				calculateSuggestion();
			}
			cancel();
		}

		function cancel() {
			$uibModalStack.dismissAll();
		}

		function addWagon() {
			vm.modalLoading = true;
			var newWagonDTO = angular.copy(vm.newWagon);
			if (!newWagonDTO.volume) {
				newWagonDTO.volume = 0;
			}
			if (!vm.settings.use_kgs) {
				newWagonDTO.value = unitConversionService.convertData(newWagonDTO.value, ['imperialTonToMetricTon']);
			}
			newWagonDTO.weight = newWagonDTO.value;
			var suffix = '?team_id=' + vm.settings.selectedTeam.id + '&herd_id=' + vm.settings.selectedHerd.id + '&last_modified_user=' + encodeURIComponent(vm.user.email) + '&name=' + encodeURIComponent(newWagonDTO.name) + '&volume=' + newWagonDTO.volume + '&weight=' + newWagonDTO.weight;
			if (newWagonDTO.mac_address) {
				suffix = suffix + '&mac_address=' + encodeURIComponent(newWagonDTO.mac_address);
			}
			return editPremixService
				.addNewWagon(suffix)
				.then(function (response) {
					response.value = response.weight * 1000;
					vm.premix.wagons.push(response);
					vm.premix.wagons = $filter('orderBy')(vm.premix.wagons, 'weight', true);
					vm.premix.all_wagons = angular.copy(vm.premix.wagons);
					if (vm.suggestion) {
						selectWagon(response.id);
					}
					vm.suggestion = false;
					cancel();
					vm.modalLoading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.modalLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_adding_wagon_');
				});

			function selectWagon(id) {
				for (var i = 0; i < vm.premix.wagons.length; i++) {
					if (vm.premix.wagons[i].id === id) {
						vm.premix.wagons[i].selected = true;
						vm.premix.wagons[i].default = false;
						if (vm.premix.suggestion && !vm.premix.suggestion.dirty) {
							calculateSuggestion();
						}
						break;
					}
				}
			}
		}

		function openAddLoadModal() {
			if (!vm.historicalVersion) {
				var selectedWagons = [];
				for (var i = 0; i < vm.premix.wagons.length; i++) {
					if (vm.premix.wagons[i].selected === true) {
						selectedWagons.push(vm.premix.wagons[i]);
					}
				}
				vm.load = {
					value: 0,
					wagon: selectedWagons && selectedWagons.length === 1 ? selectedWagons[0] : null,
					wagons: selectedWagons
				};
				vm.modalType = 'add';
				calculateAddLoadAmount();
				openModal('app/pages/premixes/editPremix/loadForm.modal.html', 'sm');
			}
		}

		function openEditLoadModal(index) {
			if (!vm.historicalVersion) {
				var selectedWagons = [];
				for (var i = 0; i < vm.premix.wagons.length; i++) {
					if (vm.premix.wagons[i].selected === true) {
						selectedWagons.push(vm.premix.wagons[i]);
					}
				}
				vm.load = {
					value: vm.premix.suggestion.loads[index].value,
					wagon: getWagon(vm.premix.suggestion.loads[index]),
					wagons: selectedWagons,
					index: index
				};
				vm.modalType = 'edit';
				calculateEditLoadAmount();
				openModal('app/pages/premixes/editPremix/loadForm.modal.html', 'sm');
			}
		}

		function getWagon(w) {
			for (var i = 0; i < vm.premix.wagons.length; i++) {
				if (vm.premix.wagons[i].id === w.wagon_id) {
					return vm.premix.wagons[i];
				}
			}
		}

		function calculateEditLoadAmount(selected) {
			vm.showRequiredAmount = false;
			if (vm.feedingsError) {
				vm.showRequiredAmount = true;
				vm.loadRequiredAmount = Math.abs(vm.feedingsError);
				if (!selected) {
					vm.loadRequiredAmount = vm.load.value - vm.feedingsError;
				}
				if (vm.loadRequiredAmount >= vm.load.wagon.value) {
					vm.loadRequiredAmount = vm.load.wagon.value;
				}
			} else {
				if (vm.load.value > vm.load.wagon.value) {
					vm.showRequiredAmount = true;
				}
			}
		}

		function calculateAddLoadAmount(selected) {
			vm.showRequiredAmount = false;
			if (vm.feedingsError) {
				vm.showRequiredAmount = true;
				vm.loadRequiredAmount = Math.abs(vm.feedingsError);
				if (!selected) {
					vm.loadRequiredAmount = vm.load.value - vm.feedingsError;
				}
				if (vm.load.wagon && vm.loadRequiredAmount >= vm.load.wagon.value) {
					vm.loadRequiredAmount = vm.load.wagon.value;
				}
			}
		}

		function saveLoad() {
			return vm.modalType === 'add' ? addNewLoad() : editLoad();
		}

		function addNewLoad() {
			if (vm.load.value > 0 && vm.load.value <= vm.load.wagon.value) {
				var obj = {
					value: vm.load.value,
					wagon_id: vm.load.wagon.id,
					wagon_name: vm.load.wagon.name,
					weight: vm.load.wagon.weight,
					mixing_time: null
				};
				vm.premix.suggestion.loads.push(obj);
				vm.premix.suggestion.number_of_loads++;
				calculateDifference();
				cancel();
			}
		}

		function calculateDifference() {
			//vm.premix.suggestion.loads = $filter('orderBy')(vm.premix.suggestion.loads, ['weight', '-value']);
			var sum = 0;
			for (var i = 0; i < vm.premix.suggestion.loads.length; i++) {
				sum += vm.premix.suggestion.loads[i].value;
			}
			var diff = sum - vm.premix.suggestion.sum;
			if (diff != 0) {
				vm.feedingsError = diff;
				vm.premix.suggestion.dirty = true;
			} else {
				vm.feedingsError = undefined;
			}
			if (vm.feedingsError) {
				vm.premix.suggestion_help_input = undefined;
			} else {
				vm.premix.suggestion_help_input = 'valid';
			}
		}

		function editLoad() {
			if (vm.load && vm.load.value <= vm.load.wagon.value) {
				if (vm.load.value > 0) {
					vm.premix.suggestion.loads[vm.load.index].value = vm.load.value;
					vm.premix.suggestion.loads[vm.load.index].wagon_id = vm.load.wagon.id;
					vm.premix.suggestion.loads[vm.load.index].wagon_name = vm.load.wagon.name;
					vm.premix.suggestion.loads[vm.load.index].weight = vm.load.wagon.weight;
				} else {
					vm.premix.suggestion.loads.splice(vm.load.index, 1);
				}
				calculateDifference();
				cancel();
			}
		}

		function removeLoad(index) {
			if (!vm.historicalVersion) {
				vm.premix.suggestion.loads.splice(index, 1);
				vm.premix.suggestion.loads.number_of_loads--;
				calculateDifference();
			}
		}

		function setLoad() {
			vm.load.value = vm.loadRequiredAmount;
		}

		function updateNewFeed(data, index, type) {
			$timeout(function () {
				if (type === 'name') {
					vm.premix.feeds[index].name = data;
				} else if (type == 'dm') {
					vm.premix.feeds[index].dm = data;
					if (vm.premix.feeds[index].amount) {
						vm.premix.feeds[index].as_fed = (vm.premix.feeds[index].amount * 100) / data;
					}
					if (vm.premix.feeds[index].amount) {
						vm.premix.feeds[index].cost_as_fed = (vm.premix.feeds[index].cost * data) / 100;
					}
				} else if (type == 'amount') {
					vm.premix.feeds[index].amount = data;
					if (vm.premix.feeds[index].dm) {
						vm.premix.feeds[index].as_fed = (data * 100) / vm.premix.feeds[index].dm;
					}
				} else if (type == 'as_fed') {
					vm.premix.feeds[index].as_fed = data;
					if (vm.premix.feeds[index].dm) {
						vm.premix.feeds[index].amount = (data * vm.premix.feeds[index].dm) / 100;
					}
				} else if (type == 'cost') {
					if (angular.isNumber(data)) {
						vm.premix.feeds[index].cost = data;
						if (vm.premix.feeds[index].dm) {
							vm.premix.feeds[index].cost_as_fed = (data * vm.premix.feeds[index].dm) / 100;
						}
					} else {
						vm.premix.feeds[index].cost = 0;
						vm.premix.feeds[index].cost_as_fed = 0;
					}
				} else if (type == 'cost_as_fed') {
					if (angular.isNumber(data)) {
						vm.premix.feeds[index].cost_as_fed = data;
						if (vm.premix.feeds[index].dm) {
							vm.premix.feeds[index].cost = (data * 100) / vm.premix.feeds[index].dm;
						}
					} else {
						vm.premix.feeds[index].cost = 0;
						vm.premix.feeds[index].cost_as_fed = 0;
					}
				}
				if (checkIngredientsDmError(vm.premix.feeds)) {
					vm.hasDM0Error = true;
				} else {
					vm.hasDM0Error = false;
				}
				calculatePremixAmount();
				calculateTotalAmount();
			}, 1);
		}

		function openAddNewFeedForm() {
			vm.premix.selected_basis = vm.basisTypes.find(function type(type) {
				return type.value === 3;
			});
			vm.premix.basis = null;
			showInputFields();
		}

		function inputKeyPress(event) {
			if (event.keyCode === 13) {
				vm.newPremixFeedForm.$setSubmitted();
				addNewFeed();
			}
		}

		function feedTypeSelected() {
			vm.newPremixFeedForm.$setSubmitted();
		}

		function newFeedDmChanged() {
			if (nfdTimer) {
				$timeout.cancel(nfdTimer);
			}
			nfdTimer = $timeout(function () {
				if (vm.new_feed.amount) {
					vm.new_feed.as_fed = (vm.new_feed.amount * 100) / vm.new_feed.dm;
				} else if (vm.new_feed.as_fed) {
					vm.new_feed.amount = (vm.new_feed.as_fed * vm.new_feed.dm) / 100;
				}
				if (vm.new_feed.cost) {
					vm.new_feed.cost_as_fed = (vm.new_feed.cost * vm.new_feed.dm) / 100;
				} else if (vm.new_feed.cost_as_fed) {
					vm.new_feed.cost = (vm.new_feed.cost_as_fed * 100) / vm.new_feed.dm;
				}
			}, 750);
		}

		function newFeedAmountDmChanged() {
			if (nfaDTimer) {
				$timeout.cancel(nfaDTimer);
			}
			nfaDTimer = $timeout(function () {
				if (vm.new_feed.dm) {
					vm.new_feed.as_fed = (vm.new_feed.amount * 100) / vm.new_feed.dm;
				}
			}, 750);
		}

		function newFeedAmountAsFedChanged() {
			if (nfaAFTimer) {
				$timeout.cancel(nfaAFTimer);
			}
			nfaAFTimer = $timeout(function () {
				if (vm.new_feed.dm) {
					vm.new_feed.amount = (vm.new_feed.as_fed * vm.new_feed.dm) / 100;
				}
			}, 750);
		}

		function newFeedCostDmChanged() {
			if (nfcTimer) {
				$timeout.cancel(nfcTimer);
			}
			vm.disableAddFeed = true;
			nfcTimer = $timeout(function () {
				if (vm.new_feed.dm && angular.isNumber(vm.new_feed.dm) && angular.isNumber(vm.new_feed.cost)) {
					vm.new_feed.cost_as_fed = (vm.new_feed.cost * vm.new_feed.dm) / 100;
				} else {
					vm.new_feed.cost_as_fed = null;
				}
				vm.disableAddFeed = false;
			}, 750);
		}

		function newFeedCostAsFedChanged() {
			if (nfaTimer) {
				$timeout.cancel(nfaTimer);
			}
			vm.disableAddFeed = true;
			nfaTimer = $timeout(function () {
				if (vm.new_feed.dm && angular.isNumber(vm.new_feed.dm) && angular.isNumber(vm.new_feed.cost_as_fed)) {
					vm.new_feed.cost = (vm.new_feed.cost_as_fed * 100) / vm.new_feed.dm;
				} else {
					vm.new_feed.cost = null;
				}
				vm.disableAddFeed = false;
			}, 750);
		}

		function removeNewFeed(feed) {
			var index;
			for (var i = 0; i < vm.premix.feeds.length; i++) {
				if (vm.premix.feeds[i].temp_id === feed.temp_id) {
					index = i;
					break;
				}
			}
			vm.premix.feeds.splice(index, 1);
			if (checkIngredientsDmError(vm.premix.feeds)) {
				vm.hasDM0Error = true;
			} else {
				vm.hasDM0Error = false;
			}
			vm.premix.selected_basis = vm.basisTypes.find(function type(type) {
				return type.value === 3;
			});
			vm.premix.basis = null;
			calculatePremixAmount();
			calculateTotalAmount();
		}

		function drag(index) {
			vm.premix.feeds.splice(index, 1);
		}

		function disableSaveButton() {
			return (
				(vm.selectBasisForm && vm.selectBasisForm.$invalid && vm.selectBasisForm.$submitted) ||
				vm.historicalVersion ||
				vm.deletedRation ||
				(vm.planningForm && vm.planningForm.$invalid && vm.planningForm.$submitted) ||
				(vm.managementForm && vm.managementForm.$invalid && vm.managementForm.$submitted)
			);
		}

		function tabValidation() {
			return {
				'edit-basis-tab-validation': (vm.selectBasisForm && vm.selectBasisForm.$invalid && vm.selectBasisForm.$submitted && !vm.premix_name_drop) || vm.deletedRation,
				'edit-planning-tab-validation': vm.planningForm && vm.planningForm.$invalid && vm.planningForm.$submitted,
				'edit-management-tab-validation': vm.managementForm && vm.managementForm.$invalid && vm.managementForm.$submitted && !vm.premix_name_basis
			};
		}

		function basisDetails(basis) {
			var modalBasis = vm.basis.find(function (item) {
				return basis.id == item.id;
			});
			if (modalBasis) {
				vm.modalBasis = modalBasis;
			} else {
				vm.modalBasis = {};
			}
			openModal('app/pages/premixes/editPremix/basisDetails.modal.html', 'lg');
		}

		function editBasis(basis) {
			localStorage.setItem(
				'from_premix',
				JSON.stringify({
					type: 'edit',
					uuid: $stateParams.uuid
				})
			);
			var id = vm.premix.selected_basis.value === 1 ? basis.ration_id : basis.id;
			var page = vm.premix.selected_basis.value === 2 ? 'feeds.editFeed' : 'rations.balanceration';
			dataServiceFactory.edit_premix_data = vm.premix;
			$state.go(page, {
				uuid: id
			});
		}

		function basisPaginationChanged() {
			vm.premix.basis_is_changed = false;
			getBasisData(false, vm.premix.selected_basis);
		}

		function getFeedByName(value) {
			var suffix = '?herdId=' + vm.selectedHerd + '&feedName=' + value;
			return editPremixService
				.getFeedByName(suffix)
				.then(function (response) {
					return response;
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_feeds_', init);
				});
		}

		function feedSelected(feed) {
			vm.new_feed = new Feed(feed);
		}

		function Feed(feed) {
			this.id = feed ? feed.id : null;
			this.name = feed ? feed.feed_name : null;
			this.dm = feed ? feed.dm : null;
			this.amount = feed ? feed.amount_dm : null;
			this.as_fed = feed ? feed.amount_as_fed : null;
			this.cost = feed ? feed.cost_dm : null;
			this.cost_as_fed = feed ? feed.cost_as_fed : null;

			if (feed) {
				var hasFeedType = false;

				for (var j = 0; j < vm.feed_types.length; j++) {
					if (feed.feed_type) {
						if (feed.feed_type.toLowerCase() === vm.feed_types[j].name.toLowerCase()) {
							this.feed_type = vm.feed_types[j];
							hasFeedType = true;
							break;
						}
					} else {
						if (feed.feed_name && feed.feed_name.toLowerCase() === vm.feed_types[j].name.toLowerCase()) {
							this.feed_type = vm.feed_types[j];
							hasFeedType = true;
							break;
						}
					}
				}

				if (!hasFeedType) {
					this.feed_type.feed_type = {
						show_name: '_feeds_type_not_set_'
					};
				}
			} else {
				this.feed_type = null;
			}
		}

		(function removeDefaultTooltip() {
			var tooltipInterval = $interval(
				function () {
					$timeout(function () {
						var tabs = document.getElementsByClassName('wizard-step');
						var tabLoaded = document.getElementById('edit-premix-tabs');
						if (tabLoaded) {
							for (var i = 0; i < tabs.length; i++) {
								tabs[i]._title = tabs[i].title;
								tabs[i].onmouseenter = function () {
									this.title = '';
								};
								tabs[i].onmouseleave = function () {
									this.title = this._title;
								};
							}
							$interval.cancel(tooltipInterval);
						}
					}, 50);
				},
				1500,
				15
			);
		})();

		editableOptions.theme = 'bs3';
		editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
		editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.premixes.editPremix').factory('editPremixService', editPremixService);

	/** @ngInject */
	function editPremixService(APP_CONST, $http, $q) {
		return {
			getRationBasis: getRationBasis,
			getMixerWagons: getMixerWagons,
			getPremixById: getPremixById,
			savePremix: savePremix,
			addNewWagon: addNewWagon,
			getFeedByName: getFeedByName
		};

		function getRationBasis(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'premix' + suffix)
				.then(success)
				.catch(error);
		}

		function getMixerWagons(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'mixerwagon' + suffix)
				.then(success)
				.catch(error);
		}

		function getPremixById(premix_id) {
			return $http
				.get(APP_CONST.api_base_url + 'premix-recipe/' + premix_id)
				.then(success)
				.catch(error);
		}

		function savePremix(premix) {
			return $http
				.put(APP_CONST.api_base_url + 'premix-recipe', premix)
				.then(success)
				.catch(error);
		}

		function addNewWagon(url) {
			return $http
				.post(APP_CONST.api_base_url + 'mixerwagon' + url)
				.then(success)
				.catch(error);
		}

		function getFeedByName(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'manualfeeds/search' + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.addnewration').controller('addNewRationCtrl', addNewRationCtrl);
	/** @ngInject */
	function addNewRationCtrl($filter, APP_CONST, $timeout, addNewRationFactory, toastr, $state, dataServiceFactory, $uibModalStack, $scope, settingsFactory, $locale, $http, errorService) {
		var vm = this;
		var timeoutSearch;
		var i18nFilter = $filter('i18n');
		vm.selected = selected;
		vm.addAll = addAll;
		vm.removeAll = removeAll;
		vm.addSelected = addSelected;
		vm.removeSelected = removeSelected;
		vm.saveRation = saveRation;
		vm.paginationChangedMaster = paginationChangedMaster;
		vm.searchMasterChanged = searchMasterChanged;
		vm.defaultCalculationChanged = defaultCalculationChanged;
		vm.feedTypeSelected = feedTypeSelected;
		vm.cancel = cancel;
		vm.reloadApi = reloadApi;
		vm.sort = sort;
		vm.commonFeedChanged = commonFeedChanged;
		vm.feedTypeChanged = feedTypeChanged;
		vm.sortedColumn = 'feed_name';
		vm.order = 'ASC';
		vm.sort_col = 'feed_name_ASC';
		vm.weight = 'kg';
		vm.feeds = [];
		vm.feedsSafe = [];
		vm.rationList = [];
		vm.redirect = redirect;
		vm.tabValidation = tabValidation;
		init();

		function init() {
			vm.selectedHerd = null;
			vm.selectedTeam = null;
			vm.disableScroll = true;
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			vm.currentPageMaster = 1;
			vm.itemsPerPageMaster = 30;
			vm.searchMaster = '';
			vm.loading = true;
			vm.loadingFeeds = true;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.from_recipe = JSON.parse(localStorage.getItem('from_recipe'));
			if (!vm.settings.use_kgs) {
				vm.weight = 'lb';
			}
			setDefaultCalculation();
			setFeedFilter();
			checkShareFeeds();
			getTeamsByUser();
			$timeout(function () {
				setStrings();
				setCommonFeedFilter();
				setFeedTypesFilter();
			}, 100);
		}

		function reloadApi() {
			vm.disableScroll = true;
			vm.loading = true;
			vm.loadingFeeds = true;
			getTeamsByUser();
		}

		function defaultCalculationChanged(feed) {
			if (!feed) {
				vm.selectedCalculationFeed = angular.copy(vm.selectedCalculation);
				changeDefaultCalculation();
			}
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = [];
			setFeedTypesFilter();
			getFeedsByTeam(vm.selectedTeam);
		}

		function changeDefaultCalculation() {
			vm.settings.calculation_type = vm.selectedCalculation.calc_type;
			return settingsFactory
				.changeSettings(vm.settings, vm.user.email)
				.then(function (response) {
					localStorage.setItem('user_settings', JSON.stringify(response));
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_saving_user_settings_');
				});
		}

		function paginationChangedMaster() {
			vm.currentPageMaster++;
			vm.isPage = true;
			vm.disableScroll = true;
			getFeedsByTeam(vm.selectedTeam);
		}

		function searchMasterChanged() {
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			if (vm.searchMaster.length >= 3) {
				if (timeoutSearch) {
					$timeout.cancel(timeoutSearch);
				}
				timeoutSearch = $timeout(function () {
					vm.feeds = [];
					vm.feedsSafe = [];
					getFeedsByTeam(vm.selectedTeam);
				}, 1000);
			}
			if (vm.searchMaster.length == 0) {
				vm.feeds = [];
				vm.feedsSafe = [];
				getFeedsByTeam(vm.selectedTeam);
			}
		}

		function checkShareFeeds() {
			var feeds = dataServiceFactory.shared_feeds;
			if (feeds && feeds.length > 0) {
				angular.copy(feeds, vm.rationList);
				vm.rationListSafe = vm.rationList;
				dataServiceFactory.shared_feeds = [];
				vm.rations_suggestion_help_input = 'valid';
			}
		}

		function setDefaultCalculation() {
			vm.defaultCalculationList = [
				{
					name: '_calculation_filter_us_feeds_',
					calc_type: 0
				},
				{
					name: '_calculation_filter_vem_dve_feeds_',
					calc_type: 1
				}
			];
			if (vm.settings.calculation_type != null) {
				for (var i = 0; i < vm.defaultCalculationList.length; i++) {
					if (vm.settings.calculation_type == vm.defaultCalculationList[i].calc_type) {
						vm.selectedCalculation = vm.defaultCalculationList[i];
					}
				}
			} else {
				vm.selectedCalculation = vm.defaultCalculationList[0];
			}
			vm.selectedCalculationFeed = angular.copy(vm.selectedCalculation);
		}

		function setStrings() {
			vm.typeAll = i18nFilter('_feeds_type_all_');
			vm.typeDryForage = i18nFilter('_feeds_type_dry_forage_');
			vm.typeCornSilage = i18nFilter('_feeds_type_corn_silage_');
			vm.typeAlfa = i18nFilter('_feeds_type_alfa_silage_');
			vm.typeOther = i18nFilter('_feeds_type_other_wet_forage_');
			vm.typeByProduct = i18nFilter('_feeds_type_by_product_');
			vm.typeGrain = i18nFilter('_feeds_type_grain_');
			vm.typeFatty = i18nFilter('_feeds_type_fatty_acid_source_');
			vm.typeTriglicerides = i18nFilter('_feeds_type_triglycerides_');
			vm.typeCP = i18nFilter('_feeds_type_cp_source_');
			vm.typeRUP = i18nFilter('_feeds_type_rup_source_');
			vm.typeMineral = i18nFilter('_feeds_type_mineral_');
			vm.typeVitamin = i18nFilter('_feeds_type_vitamin_');
			vm.typeMix = i18nFilter('_feeds_type_mix_');
			vm.commonYes = i18nFilter('_feeds_yes_');
			vm.commonNo = i18nFilter('_feeds_no_');
		}

		function setCommonFeedFilter() {
			vm.commonFeedList = [
				{
					name: i18nFilter('_feeds_type_all_'),
					value: null
				},
				{
					name: vm.commonYes,
					value: true
				},
				{
					name: vm.commonNo,
					value: false
				}
			];
			vm.commonFeedItem = vm.commonFeedList[0];
		}

		function commonFeedChanged() {
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = [];
			getFeedsByTeam(vm.selectedTeam);
		}

		function setFeedTypesFilter() {
			if (vm.selectedCalculationFeed.calc_type == 1) {
				vm.feedTypesList = APP_CONST.constants.feed_vem_types;
			} else {
				vm.feedTypesList = APP_CONST.constants.feed_us_types;
			}
			vm.feedTypesItem = vm.feedTypesList[0];
		}

		function feedTypeChanged() {
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = [];
			getFeedsByTeam(vm.selectedTeam);
		}

		function sort(column) {
			var col;
			if (column != vm.sortedColumn) {
				vm.sortedColumn = column;
				vm.order = 'ASC';
				col = column + '_' + vm.order;
			} else {
				if (vm.order == 'ASC') {
					vm.order = 'DESC';
					col = column + '_' + vm.order;
				} else if (vm.order == 'DESC') {
					vm.order = 'ASC';
					col = column + '_' + vm.order;
				}
			}
			vm.sort_col = col;
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feedsSafe = [];
			vm.feeds = [];
			getFeedsByTeam(vm.selectedTeam);
		}

		function setFeedFilter() {
			vm.filterTypes = [
				{
					name: '_feed_filter_my_feeds_',
					value: 'my_feeds'
				},
				{
					name: '_feed_filter_master_feeds_',
					value: 'master_feeds'
				}
			];
			vm.selectedFeedType = {
				name: '_feed_filter_master_feeds_',
				value: 'master_feeds'
			};
		}

		function feedTypeSelected() {
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = [];
			getFeedsByTeam(vm.selectedTeam);
		}

		function selected(type) {
			if (type == 'team') {
				vm.herds = null;
				vm.groups = null;
				vm.selectedHerd = null;
				vm.selectedGroup = null;
				getHerdsByTeam(vm.selectedTeam);
				getFeedsByTeam(vm.selectedTeam);
			} else if (type == 'herd') {
				vm.groups = null;
				vm.selectedGroup = null;
				getGroupsByHerd(vm.selectedHerd);
			}
		}

		function getTeamsByUser() {
			return addNewRationFactory
				.getTeamsByUser()
				.then(function (response) {
					vm.teams = response;
					setDefaultTeam(vm.settings, vm.teams);
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_teams_', true);
				});
		}

		function getHerdsByTeam(team, init) {
			return addNewRationFactory
				.getHerdsByTeam(team.Id)
				.then(function (response) {
					vm.herds = response;
					setDefaultHerd(vm.settings, vm.herds);
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_herds_', init);
				});
		}

		function setDefaultHerd(settings, herds) {
			if (settings.selectedHerd && settings.selectedHerd.id) {
				for (var i = 0; i < herds.length; i++) {
					if (settings.selectedHerd.id == herds[i].Id) {
						vm.selectedHerd = herds[i];
						break;
					}
				}
			}
			if (vm.selectedHerd) {
				getGroupsByHerd(vm.selectedHerd, true);
			} else {
				vm.loading = false;
			}
		}

		function setDefaultTeam(settings, teams) {
			if (settings.selectedTeam) {
				for (var i = 0; i < teams.length; i++) {
					if (settings.selectedTeam.id == teams[i].Id) {
						vm.selectedTeam = teams[i];
					}
				}
			}
			if (vm.selectedTeam) {
				getFeedsByTeam(vm.selectedTeam, true);
				getHerdsByTeam(vm.selectedTeam, true);
			} else {
				vm.loading = false;
			}
		}

		function redirect(state) {
			$state.go(state);
			localStorage.setItem('from_ration', true);
		}

		function getGroupsByHerd(herd, init) {
			vm.loading = true;
			return addNewRationFactory
				.getGroupsByHerd(herd.Id)
				.then(function (response) {
					vm.groups = response;
					vm.loading = false;
					vm.groupList = [
						{
							name: i18nFilter('_shortcut_group_create_'),
							val: 1
						}
					];
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_groups_', init);
				});
		}

		function getFeedsByTeam(team, init) {
			var suffix;
			if (vm.settings.selectedHerd && vm.settings.selectedHerd.id) {
				suffix = '?teamId=' + team.Id + '&herdId=' + vm.settings.selectedHerd.id;
			} else {
				suffix = '?teamId=' + team.Id;
			}
			if (vm.selectedCalculationFeed != null || vm.selectedCalculationFeed != undefined) {
				suffix = suffix + '&localType=' + vm.selectedCalculationFeed.calc_type;
			}
			if (vm.currentPageMaster) {
				suffix = suffix + '&page=' + vm.currentPageMaster;
			}
			if (vm.searchMaster) {
				suffix = suffix + '&feedName=' + encodeURIComponent(vm.searchMaster);
			}
			if (vm.selectedFeedType) {
				suffix = suffix + '&returnType=' + vm.selectedFeedType.value;
			}
			if (vm.commonFeedItem && vm.commonFeedItem.value != null) {
				suffix = suffix + '&commonFeed=' + vm.commonFeedItem.value;
			}
			if (vm.feedTypesItem && vm.feedTypesItem.value) {
				suffix = suffix + '&feedType=' + vm.feedTypesItem.value;
			}
			if (vm.sortedColumn && vm.order) {
				suffix = suffix + '&orderBy=' + vm.sortedColumn + '&orderType=' + vm.order;
			}
			if (!vm.isPage) {
				vm.loadingFeeds = true;
			}
			vm.isPage = false;
			cancelApiRequest();
			return addNewRationFactory
				.getFeedsByTeam(suffix)
				.then(function (response) {
					if (response.length > 0) {
						vm.totalItemsMaster = response[0].number_of_all;
						for (var i = response.length - 1; i >= 0; i--) {
							for (var j = 0; j < vm.rationList.length; j++) {
								if (response[i].id == vm.rationList[j].id) {
									response.splice(i, 1);
									break;
								}
							}
						}
						if (vm.rationList.length > 0) {
							vm.rations_suggestion_help_input = 'valid';
						}
						vm.feeds = vm.feeds.concat(response);
						var orderBool;
						if (vm.order == 'ASC') {
							orderBool = false;
						} else {
							orderBool = true;
						}
						vm.feeds = $filter('orderBy')(vm.feeds, vm.sortedColumn, orderBool);
					} else {
						vm.totalItemsMaster = 0;
					}
					vm.feedsSafe = vm.feeds;
					vm.loadingFeeds = false;
					vm.disableScroll = false;
					$timeout(function () {
						var searchInput = document.getElementById('feedsSearchInput');
						if (searchInput) {
							searchInput.focus();
						}
					}, 50);
					$uibModalStack.dismissAll();
				})
				.catch(function (error) {
					if (error != 'Canceled') {
						console.log(error);
						$uibModalStack.dismissAll();
						vm.disableScroll = false;
						errorService.showErrorMessage(error, true, '_error_occurred_loading_feeds_', init);
					}
				});
		}

		function addAll() {
			if (vm.feeds.length) {
				removeAll();
				var mList = JSON.parse(JSON.stringify(vm.feeds));
				for (var i = 0; i < mList.length; i++) {
					mList[i].is_selected = false;
					vm.rationList.push(mList[i]);
				}
				vm.feeds = [];
				vm.rationListSafe = vm.rationList;
				vm.currentPageMaster++;
				vm.disableScroll = true;
				vm.loadingFeeds = true;
				getFeedsByTeam(vm.selectedTeam);
			}
			if (vm.rationList.length > 0) {
				vm.rations_suggestion_help_input = 'valid';
			}
		}

		function removeAll() {
			vm.rations_suggestion_help_input = undefined;
			for (var i = 0; i < vm.rationList.length; i++) {
				vm.feeds.push(vm.rationList[i]);
			}
			vm.rationList = [];
			var orderBool;
			if (vm.order == 'ASC') {
				orderBool = false;
			} else {
				orderBool = true;
			}
			vm.feeds = $filter('orderBy')(vm.feeds, vm.sortedColumn, orderBool);
		}

		function addSelected(id) {
			vm.rations_suggestion_help_input = 'valid';
			var feedFound = false;
			var selList = [];
			for (var i = 0; i < vm.feeds.length; i++) {
				if (vm.feeds[i].id == id) {
					if (vm.rationList.length > 0) {
						for (var j = 0; j < vm.rationList.length; j++) {
							if (vm.feeds[i].id == vm.rationList[j].id) {
								feedFound = true;
								break;
							}
						}
					}
					if (!feedFound) {
						selList.push(vm.feeds[i]);
						vm.feeds.splice(i, 1);
					}
					feedFound = false;
				}
			}
			var li = [];
			angular.copy(selList, li);
			for (var k = 0; k < li.length; k++) {
				vm.rationList.push(li[k]);
			}
			if (vm.feeds.length == 0) {
				vm.currentPageMaster++;
				vm.disableScroll = true;
				vm.loadingFeeds = true;
				getFeedsByTeam(vm.selectedTeam);
			}
			vm.rationListSafe = vm.rationList;
		}

		function removeSelected(id) {
			for (var i = vm.rationList.length - 1; i >= 0; i--) {
				if (vm.rationList[i].id == id) {
					vm.feeds.unshift(vm.rationList.splice(i, 1)[0]);
				}
			}
			var orderBool;
			if (vm.order == 'ASC') {
				orderBool = false;
			} else {
				orderBool = true;
			}
			vm.feeds = $filter('orderBy')(vm.feeds, vm.sortedColumn, orderBool);
			vm.rationListSafe = vm.rationList;
		}

		function saveRation() {
			if (vm.rationList.length != 0) {
				vm.loading = true;
				var ration = {
					feeds: vm.rationList,
					group_id: vm.selectedGroup.id,
					ration_name: vm.ration.ration_name,
					herd_name: vm.selectedHerd.Name,
					team_id: vm.selectedTeam.Id,
					user_id: vm.user.email
				};
				for (var i = 0; i < ration.feeds.length; i++) {
					ration.feeds[i].team_id = ration.team_id;
				}
				if (vm.selectedCalculation != null || vm.selectedCalculation != undefined) {
					var suffix = '?localType=' + vm.selectedCalculation.calc_type;
				}
				return addNewRationFactory
					.addNewRation(ration, suffix)
					.then(function () {
						toastr.success(i18nFilter('_toastr_ration_created_'), i18nFilter('_toastr_success_title_'));
						if (vm.from_recipe) {
							if (vm.from_recipe.type == 'add') {
								$state.go('recipes.addNewRecipe');
							} else if (vm.from_recipe.type == 'edit') {
								$state.go('recipes.editRecipe', {
									uuid: vm.from_recipe.uuid
								});
							}
						} else {
							$state.go('rations.myrations');
						}
						vm.loading = false;
					})
					.catch(function (error) {
						console.log(error);
						vm.loading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_saving_ration_');
					});
			} else {
				toastr.warning(i18nFilter('_warning_select_feeds_for_ration_'), i18nFilter('_title_warning_'));
			}
		}

		function cancel() {
			if (vm.from_recipe) {
				if (vm.from_recipe.type == 'add') {
					$state.go('recipes.addNewRecipe');
				} else if (vm.from_recipe.type == 'edit') {
					$state.go('recipes.editRecipe', {
						uuid: vm.from_recipe.uuid
					});
				}
			} else {
				$state.go('rations.myrations');
			}
		}

		function cancelApiRequest() {
			angular.forEach($http.pendingRequests, function (req) {
				if (req.url.split('?')[0] == APP_CONST.api_base_url + 'feeds' && req.method == 'GET') {
					addNewRationFactory.cancelRequest();
				}
			});
		}

		function filterRationListByTeam(list, team_id) {
			for (var i = list.length - 1; i >= 0; i--) {
				if (list[i].team_id && list[i].team_id != team_id) {
					list.splice(i, 1);
				}
			}
			return list;
		}

		function tabValidation() {
			return {
				'basic-tab-validation': vm.basicInfoForm && vm.basicInfoForm.$invalid && vm.basicInfoForm.$submitted,
				'feeds-tab-validation': (vm.animalInfoForm && vm.animalInfoForm.$invalid && vm.animalInfoForm.$submitted) || (vm.rations_suggestion_help_input && vm.rationList.length == 0)
			};
		}

		$scope.$on('default_herd_selected', function (event, data) {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedHerd = data;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = [];
			vm.currentPageMaster = 1;
			vm.searchMaster = '';
			vm.selectedGroup = null;
			getGroupsByHerd(data);
			getFeedsByTeam(vm.selectedTeam);
		});

		$scope.$on('default_team_selected', function (event, data) {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedTeam = data;
			vm.disableScroll = true;
			vm.feeds = [];
			vm.feedsSafe = [];
			vm.currentPageMaster = 1;
			vm.searchMaster = '';
			vm.selectedHerd = null;
			vm.rationList = filterRationListByTeam(vm.rationList, vm.settings.team_id);
			vm.rationListSafe = vm.rationList;
			getHerdsByTeam(data);
			getFeedsByTeam(data);
		});

		$scope.$on('default_team_herd_changed', function () {
			cancelApiRequest();
			init();
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('$stateChangeStart', function (event, toState) {
			if (toState.url !== '/editRecipe/{uuid:string}' && toState.url !== '/addNewRecipe') {
				dataServiceFactory.add_new_recipe_data = {};
				dataServiceFactory.edit_recipe_data = {};
				localStorage.removeItem('from_recipe');
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.addnewration').factory('addNewRationFactory', addNewRationFactory);
	/** @ngInject */
	function addNewRationFactory($http, $q, APP_CONST) {
		var cancelReq;
		var statusText;

		return {
			addNewRation: addNewRation,
			getTeamsByUser: getTeamsByUser,
			getHerdsByTeam: getHerdsByTeam,
			getGroupsByHerd: getGroupsByHerd,
			getFeedsByTeam: getFeedsByTeam,
			cancelRequest: cancelRequest
		};

		function cancelRequest() {
			statusText = 'Canceled';
			cancelReq.resolve();
		}

		function addNewRation(ration, suffix) {
			return $http
				.post(APP_CONST.api_base_url + 'rations' + suffix, ration)
				.then(success)
				.catch(error);
		}

		function getTeamsByUser() {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams')
				.then(success)
				.catch(error);
		}

		function getHerdsByTeam(teamId) {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams/' + teamId + '/herds')
				.then(success)
				.catch(error);
		}

		function getGroupsByHerd(herdId) {
			return $http
				.get(APP_CONST.api_base_url + 'herds/' + herdId + '/groups')
				.then(success)
				.catch(error);
		}

		function getFeedsByTeam(suffix) {
			cancelReq = $q.defer();
			return $http
				.get(APP_CONST.api_base_url + 'feeds' + suffix, {
					timeout: cancelReq.promise
				})
				.then(success)
				.catch(function (error) {
					var err = statusText ? $q.reject(statusText) : $q.reject(error);
					statusText = undefined;
					return err;
				});
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.addmanualration').controller('addManualRationCtrl', addManualRationCtrl);
	/** @ngInject */
	function addManualRationCtrl($timeout, APP_CONST, $filter, editableOptions, editableThemes, addManualRationsFactory, $state, $locale, $scope, dataServiceFactory, errorService, $uibModal, $uibModalStack) {
		var vm = this;
		var i18nFilter = $filter('i18n');

		vm.getFeedByName = getFeedByName;
		vm.addNewFeed = addNewFeed;
		vm.feedSelected = feedSelected;
		vm.updateNewFeed = updateNewFeed;
		vm.openFeedsModal = openFeedsModal;
		vm.loadMoreFeeds = loadMoreFeeds;
		vm.addAll = addAll;
		vm.addSelected = addSelected;
		vm.removeAll = removeAll;
		vm.removeSelected = removeSelected;
		vm.insertFeeds = insertFeeds;
		vm.updateFeed = updateFeed;
		vm.removeFeed = removeFeed;
		vm.saveRation = saveRation;
		vm.inputKeyPress = inputKeyPress;
		vm.cancel = cancel;
		vm.closeModal = closeModal;

		init();

		function init() {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.from_recipe = JSON.parse(localStorage.getItem('from_recipe'));
			vm.selectedTeam = vm.settings.selectedTeam.id;
			vm.selectedHerd = vm.settings.selectedHerd.id;
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			vm.maxAmount = 40;
			vm.currentPage = 1;
			vm.modalLoading = true;
			vm.hideLoadMoreButton = false;
			setFeedTypes(APP_CONST.constants.feed_types);
			vm.newFeed = new Feed();
			vm.ration = {
				ration_feeds: []
			};
			vm.feeds = [];
			vm.importList = [];
			if (!vm.settings.use_kgs) {
				vm.weight = 'Lb';
			} else {
				vm.weight = 'Kg';
			}
			externalIdPreventDefault();
			if (vm.selectedHerd) {
				getFeeds(true);
			} else {
				vm.loading = false;
			}
		}

		function reloadApi() {
			if (vm.selectedHerd) {
				getFeeds(true);
			} else {
				vm.loading = false;
			}
		}

		function setFeedTypes(feed_types) {
			var types = angular.copy(feed_types);

			vm.feedTypes = types.map(function (type) {
				var t = '_feeds_type_' + type.value + '_';
				type.show_name = t;
				type.translated = i18nFilter(t);
				return type;
			});
		}

		function getFeeds(init) {
			vm.loadingFeeds = true;
			var suffix = '?herdId=' + vm.selectedHerd + '&pageNumber=' + (vm.currentPage - 1);
			addManualRationsFactory
				.getFeeds(suffix)
				.then(function (response) {
					if (response.manual_feeds && response.manual_feeds.length) {
						vm.totalItems = response && response.number_of_all ? response.number_of_all : 0;
						for (var i = 0; i < response.manual_feeds.length; i++) {
							response.manual_feeds[i].displayed = true;
							var found = false;
							for (var j = 0; j < vm.feedTypes.length; j++) {
								if (response.manual_feeds[i].feed_type && response.manual_feeds[i].feed_type.toLowerCase() === vm.feedTypes[j].name.toLowerCase()) {
									response.manual_feeds[i].feed_type = vm.feedTypes[j];
									found = true;
									break;
								}
							}

							if (!found) {
								response.manual_feeds[i].feed_type = {
									show_name: '_feeds_type_not_set_',
									translated: i18nFilter('_feeds_type_not_set_')
								};
							}
							vm.feeds.push(response.manual_feeds[i]);
						}

						if (vm.totalItems === vm.feeds.length) {
							vm.hideLoadMoreButton = true;
						}
					} else {
						vm.hideLoadMoreButton = true;
					}
					vm.modalLoading = false;
					vm.loadingFeeds = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.modalLoading = false;
					vm.loadingFeeds = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_feeds_', init);
				});
		}

		function getFeedByName(value) {
			var suffix = '?herdId=' + vm.selectedHerd + '&feedName=' + value;
			return addManualRationsFactory
				.getFeedByName(suffix)
				.then(function (response) {
					return response;
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_feeds_', init);
				});
		}

		function feedSelected(feed) {
			vm.newFeed = new Feed(feed);
		}

		function Feed(feed) {
			this.id = feed ? feed.id : null;
			this.feed_name = feed ? feed.feed_name : null;
			this.dm = feed ? feed.dm : null;
			this.amount_dm = feed ? feed.amount_dm : null;
			this.amount_as_fed = feed ? feed.amount_as_fed : null;
			this.cost_dm = feed ? feed.cost_dm : null;
			this.cost_as_fed = feed ? feed.cost_as_fed : null;

			if (feed) {
				var hasFeedType = false;

				for (var j = 0; j < vm.feedTypes.length; j++) {
					if (feed.feed_type) {
						if (feed.feed_type.toLowerCase() === vm.feedTypes[j].name.toLowerCase()) {
							this.feed_type = vm.feedTypes[j];
							hasFeedType = true;
							break;
						}
					} else {
						if (feed.feed_name && feed.feed_name.toLowerCase() === vm.feedTypes[j].name.toLowerCase()) {
							this.feed_type = vm.feedTypes[j];
							hasFeedType = true;
							break;
						}
					}
				}

				if (!hasFeedType) {
					this.feed_type.feed_type = {
						show_name: '_feeds_type_not_set_'
					};
				}
			} else {
				this.feed_type = null;
			}
		}

		function addNewFeed() {
			if (vm.newManualRationForm.$valid) {
				vm.noResults = false;
				var newFeedDTO = null;
				var feedName = null;

				if (vm.feedFromApi instanceof Object) {
					feedName = vm.newFeed.feed_name;
				} else {
					feedName = vm.feedFromApi;
				}

				if (vm.newFeed.id) {
					newFeedDTO = new FeedDTO(vm.newFeed.id, feedName, vm.newFeed);
				} else {
					newFeedDTO = new FeedDTO(null, feedName, vm.newFeed);
				}

				vm.ration.ration_feeds.push(newFeedDTO);
				calculateRationAmount();

				$timeout(function () {
					resetForm();
				}, 10);
			} else {
				vm.newManualRationForm.$setSubmitted();
			}
		}

		function FeedDTO(id, name, feed) {
			this.manual_feed_id = id;
			this.feed_name = name;
			this.feed_type = feed.feed_type;
			this.dm = feed.dm;
			this.amount_dm = feed.amount_dm;
			this.amount_as_fed = feed.amount_as_fed;
			this.cost_dm = feed.cost_dm || 0;
			this.cost_as_fed = feed.cost_as_fed || 0;
		}

		function resetForm() {
			vm.feedFromApi = null;
			vm.newFeed = new Feed();
			vm.newManualRationForm.$setPristine();
		}

		function updateNewFeed(type) {
			switch (type) {
				case 'dm':
					vm.newFeed.amount_as_fed = (vm.newFeed.amount_dm * 100) / vm.newFeed.dm;
					vm.newFeed.cost_as_fed = (vm.newFeed.cost_dm * vm.newFeed.dm) / 100;
					break;
				case 'amount_dm':
					vm.newFeed.amount_as_fed = (vm.newFeed.amount_dm * 100) / vm.newFeed.dm;
					break;
				case 'amount_as_fed':
					vm.newFeed.amount_dm = (vm.newFeed.amount_as_fed * vm.newFeed.dm) / 100;
					break;
				case 'cost_dm':
					if (Number.isFinite(vm.newFeed.cost_dm)) {
						vm.newFeed.cost_as_fed = (vm.newFeed.cost_dm * vm.newFeed.dm) / 100;
					} else {
						vm.newFeed.cost_dm = 0;
						vm.newFeed.cost_as_fed = 0;
					}
					break;
				case 'cost_as_fed':
					if (Number.isFinite(vm.newFeed.cost_as_fed)) {
						vm.newFeed.cost_dm = (vm.newFeed.cost_as_fed * 100) / vm.newFeed.dm;
					} else {
						vm.newFeed.cost_dm = 0;
						vm.newFeed.cost_as_fed = 0;
					}
					break;
				default:
					break;
			}
		}

		function openFeedsModal() {
			vm.importList = [];
			var load = false;
			var found = false;
			if (!vm.feeds.length) {
				load = true;
			} else {
				for (var i = 0; i < vm.feeds.length; i++) {
					if (vm.feeds[i].displayed) {
						found = true;
						break;
					}
				}
				if (!found) {
					load = true;
				}
			}
			if (load) {
				loadMoreFeeds();
			}
			resetForm();
			openModal('app/pages/rations/addManualRation/insertFeed.modal.html', 'lg');
		}

		function loadMoreFeeds() {
			vm.currentPage++;
			getFeeds();
		}

		function addAll() {
			vm.feeds.forEach(function (f) {
				if (f.displayed) {
					vm.importList.push(f);
				}
			});

			vm.feeds.forEach(function (feed) {
				feed.displayed = false;
			});
		}

		function addSelected(feed) {
			vm.importList.push(feed);
			feed.displayed = false;
		}

		function removeAll() {
			vm.feeds.forEach(function (feed) {
				feed.displayed = true;
			});

			vm.importList = [];
		}

		function removeSelected(feed) {
			vm.importList = vm.importList.filter(function (f) {
				return feed.id !== f.id;
			});

			for (var i = 0; i < vm.feeds.length; i++) {
				if (vm.feeds[i].id === feed.id) {
					vm.feeds[i].displayed = true;
					break;
				}
			}
		}

		function insertFeeds() {
			vm.importList.forEach(function (feed) {
				vm.ration.ration_feeds.push({
					manual_feed_id: feed.id,
					feed_name: feed.feed_name,
					feed_type: feed.feed_type,
					dm: feed.dm,
					cost_dm: feed.cost_dm ? feed.cost_dm : 0,
					cost_as_fed: feed.cost_as_fed ? feed.cost_as_fed : 0,
					amount_dm: feed.amount_dm,
					amount_as_fed: feed.amount_as_fed
				});
			});

			vm.importList = [];

			calculateRationAmount();
			closeModal();
		}

		function updateFeed(feed, data, type) {
			switch (type) {
				case 'dm':
					feed.amount_as_fed = (feed.amount_dm * 100) / data;
					feed.cost_as_fed = (feed.cost_dm * data) / 100;
					break;
				case 'amount_dm':
					feed.amount_as_fed = (data * 100) / feed.dm;
					break;
				case 'amount_as_fed':
					feed.amount_dm = (data * feed.dm) / 100;
					break;
				case 'cost_dm':
					if (Number.isFinite(data)) {
						feed.cost_as_fed = (data * feed.dm) / 100;
					} else {
						feed.cost_dm = 0;
						feed.cost_as_fed = 0;
					}
					break;
				case 'cost_as_fed':
					if (Number.isFinite(data)) {
						feed.cost_dm = (data * 100) / feed.dm;
					} else {
						feed.cost_dm = 0;
						feed.cost_as_fed = 0;
					}
					break;
				default:
					break;
			}

			if (vm.onEnterEvent) {
				$timeout(function () {
					var index = vm.ration.ration_feeds.indexOf(feed);
					try {
						var tempIndex = index + 1;
						if (tempIndex < vm.ration.ration_feeds.length) {
							var elem = document.getElementById(type + '_' + tempIndex);
							elem.click();
							if (tempIndex > 6) {
								var parent = elem.parentElement;
								parent.scrollIntoView(true);
							}
						}
						vm.onEnterEvent = false;
					} catch (error) {
						console.log(error);
					}
				}, 100);
			}

			if (type) {
				calculateRationAmount();
			}
		}

		function removeFeed(feed) {
			var indexRemove = vm.ration.ration_feeds.indexOf(feed);

			if (indexRemove !== -1) {
				vm.ration.ration_feeds.splice(indexRemove, 1);
			}

			calculateRationAmount();

			for (var i = 0; i < vm.feeds.length; i++) {
				if (vm.feeds[i].id === feed.manual_feed_id) {
					vm.feeds[i].displayed = true;
					break;
				}
			}
		}

		function calculateRationAmount() {
			var amount_dm = 0;
			var amount_as_fed = 0;
			var cost_dm = 0;

			vm.ration.ration_feeds.forEach(function (feed) {
				amount_dm += feed.amount_dm;
				amount_as_fed += feed.amount_as_fed;
				cost_dm += feed.cost_dm * feed.amount_dm;
			});

			vm.ration.amount_dm = amount_dm;
			vm.ration.amount_as_fed = amount_as_fed;
			vm.ration.dm = (amount_dm / amount_as_fed) * 100;
			vm.ration.cost_dm = cost_dm;
		}

		function saveRation() {
			vm.loading = true;
			var DTO = angular.copy(vm.ration);

			DTO.team_id = vm.selectedTeam;
			DTO.herd_id = vm.selectedHerd;
			DTO.user_id = vm.user.email;

			DTO.ration_feeds.forEach(function (feed, index) {
				feed.feed_type = feed.feed_type.name;
				feed.order_number = index;
			});

			addManualRationsFactory
				.addNewRation(DTO)
				.then(function () {
					cancel();
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_saving_ration_');
				});
		}

		function inputKeyPress(event) {
			if (event.keyCode === 13 || event.keyCode === 27) {
				vm.onEnterEvent = true;
			}
		}

		function cancel() {
			if (vm.from_recipe) {
				if (vm.from_recipe.type === 'add') {
					$state.go('recipes.addNewRecipe');
				} else {
					$state.go('recipes.editRecipe', {
						uuid: vm.from_recipe.uuid
					});
				}
			} else {
				$state.go('rations.manualrations');
			}
		}

		function externalIdPreventDefault() {
			var elem = document.getElementById('external_id');
			if (elem) {
				elem.addEventListener('mousewheel', function name(e) {
					e.preventDefault();
				});
				elem.addEventListener('keydown', function name(e) {
					if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
						e.preventDefault();
					}
				});
			} else {
				$timeout(function () {
					externalIdPreventDefault();
				}, 500);
			}
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('$stateChangeStart', function (event, toState) {
			if (toState.url !== '/editRecipe/{uuid:string}' && toState.url !== '/addNewRecipe') {
				dataServiceFactory.add_new_recipe_data = {};
				dataServiceFactory.edit_recipe_data = {};
				localStorage.removeItem('from_recipe');
			}
		});

		$scope.$on('default_team_herd_changed', function () {
			init();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});

		editableOptions.theme = 'bs3';
		editableOptions.blurElem = 'cancel';
		editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
		editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.addmanualration').factory('addManualRationsFactory', addManualRationsFactory);
	/** @ngInject */
	function addManualRationsFactory(APP_CONST, $http, $q) {
		return {
			getFeeds: getFeeds,
			getFeedByName: getFeedByName,
			addNewRation: addNewRation
		};

		function getFeeds(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'manualfeeds' + suffix)
				.then(success)
				.catch(error);
		}

		function getFeedByName(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'manualfeeds/search' + suffix)
				.then(success)
				.catch(error);
		}

		function addNewRation(ration) {
			return $http
				.post(APP_CONST.api_base_url + 'importRationsWithRationFeed', ration)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.editmanualration').controller('editManualRationCtrl', editManualRationCtrl);
	/** @ngInject */
	function editManualRationCtrl($timeout, APP_CONST, $filter, editableOptions, editableThemes, editManualRationsFactory, $state, $locale, $scope, dataServiceFactory, errorService, $uibModal, $uibModalStack, $stateParams) {
		var vm = this;
		var i18nFilter = $filter('i18n');

		vm.getFeedByName = getFeedByName;
		vm.addNewFeed = addNewFeed;
		vm.feedSelected = feedSelected;
		vm.updateNewFeed = updateNewFeed;
		vm.openFeedsModal = openFeedsModal;
		vm.loadMoreFeeds = loadMoreFeeds;
		vm.addAll = addAll;
		vm.addSelected = addSelected;
		vm.removeAll = removeAll;
		vm.removeSelected = removeSelected;
		vm.insertFeeds = insertFeeds;
		vm.updateFeed = updateFeed;
		vm.removeFeed = removeFeed;
		vm.saveRation = saveRation;
		vm.goToHistory = goToHistory;
		vm.inputKeyPress = inputKeyPress;
		vm.cancel = cancel;
		vm.closeModal = closeModal;
		vm.openSaveAsModal = openSaveAsModal;

		init();

		function init() {
			vm.loading = true;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.from_recipe = JSON.parse(localStorage.getItem('from_recipe'));
			vm.selectedTeam = vm.settings.selectedTeam.id;
			vm.selectedHerd = vm.settings.selectedHerd.id;
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			setFeedTypes(APP_CONST.constants.feed_types);
			vm.newFeed = new Feed();
			vm.maxAmount = 40;
			vm.currentPage = 1;
			vm.modalLoading = true;
			vm.hideLoadMoreButton = false;
			vm.disableSave = false;
			vm.feeds = [];
			vm.importList = [];
			vm.usedRecipesList = [];
			if (!vm.settings.use_kgs) {
				vm.weight = 'Lb';
			} else {
				vm.weight = 'Kg';
			}
			externalIdPreventDefault();
			if (vm.selectedHerd) {
				checkUsedRecipes();
				getRationById();
			} else {
				vm.loading = false;
			}
		}

		function reloadApi() {
			if (vm.selectedHerd) {
				getRationById();
			} else {
				vm.loading = false;
			}
		}

		function setFeedTypes(feed_types) {
			var types = angular.copy(feed_types);

			vm.feedTypes = types.map(function (type) {
				var t = '_feeds_type_' + type.value + '_';
				type.show_name = t;
				type.translated = i18nFilter(t);
				return type;
			});
		}

		function checkUsedRecipes() {
			vm.popoverLoading = true;
			var suffix = '?manualRationId=' + $stateParams.uuid + '&date=' + moment().format('YYYY-MM-DD');

			editManualRationsFactory
				.checkUsedRecipes(suffix)
				.then(function (response) {
					response.forEach(function (r) {
						vm.usedRecipesList.push(r.recipe_name);
					});

					vm.popoverLoading = false;
				})
				.catch(function () {
					vm.popoverLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_recipes_');
				});
		}

		function getRationById() {
			editManualRationsFactory
				.getImportedRationById($stateParams.uuid)
				.then(function (response) {
					for (var i = 0; i < response.ration_feeds.length; i++) {
						var found = false;
						for (var j = 0; j < vm.feedTypes.length; j++) {
							if (response.ration_feeds[i].feed_type && vm.feedTypes[j].name && response.ration_feeds[i].feed_type.toLowerCase() === vm.feedTypes[j].name.toLowerCase()) {
								response.ration_feeds[i].feed_type = vm.feedTypes[j];
								found = true;
								break;
							}
						}

						if (!found) {
							response.ration_feeds[i].feed_type = {
								show_name: '_feeds_type_not_set_',
								translated: i18nFilter('_feeds_type_not_set_')
							};
						}
					}

					response.ration_feeds = $filter('orderBy')(response.ration_feeds, 'order_number');

					if (response.external_id) {
						vm.disableSave = true;
					}

					vm.ration = response;
					vm.loading = false;
					getFeeds(true);
					calculateRationAmount();
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_rations_', true);
				});
		}

		function getFeeds(init) {
			vm.loadingFeeds = true;
			var suffix = '?herdId=' + vm.selectedHerd + '&pageNumber=' + (vm.currentPage - 1);
			editManualRationsFactory
				.getFeeds(suffix)
				.then(function (response) {
					if (response.manual_feeds && response.manual_feeds.length) {
						vm.totalItems = response && response.number_of_all ? response.number_of_all : 0;
						for (var i = 0; i < response.manual_feeds.length; i++) {
							response.manual_feeds[i].displayed = true;
							for (var j = 0; j < vm.ration.ration_feeds.length; j++) {
								if (response.manual_feeds[i].id === vm.ration.ration_feeds[j].manual_feed_id) {
									response.manual_feeds[i].displayed = false;
								}
							}
							var found = false;
							for (var k = 0; k < vm.feedTypes.length; k++) {
								if (response.manual_feeds[i].feed_type && vm.feedTypes[k].name && response.manual_feeds[i].feed_type.toLowerCase() === vm.feedTypes[k].name.toLowerCase()) {
									response.manual_feeds[i].feed_type = vm.feedTypes[k];
									found = true;
									break;
								}
							}

							if (!found) {
								response.manual_feeds[i].feed_type = {
									show_name: '_feeds_type_not_set_',
									translated: i18nFilter('_feeds_type_not_set_')
								};
							}
							vm.feeds.push(response.manual_feeds[i]);
						}

						if (vm.totalItems === vm.feeds.length) {
							vm.hideLoadMoreButton = true;
						}
					} else {
						vm.hideLoadMoreButton = true;
					}
					vm.modalLoading = false;
					vm.loadingFeeds = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.modalLoading = false;
					vm.loadingFeeds = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_feeds_', init);
				});
		}

		function getFeedByName(value) {
			var suffix = '?herdId=' + vm.selectedHerd + '&feedName=' + value;
			return editManualRationsFactory
				.getFeedByName(suffix)
				.then(function (response) {
					return response;
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_feeds_', init);
				});
		}

		function feedSelected(feed) {
			vm.newFeed = new Feed(feed);
		}

		function Feed(feed) {
			this.id = feed ? feed.id : null;
			this.feed_name = feed ? feed.feed_name : null;
			this.dm = feed ? feed.dm : null;
			this.amount_dm = feed ? feed.amount_dm : null;
			this.amount_as_fed = feed ? feed.amount_as_fed : null;
			this.cost_dm = feed ? feed.cost_dm : null;
			this.cost_as_fed = feed ? feed.cost_as_fed : null;

			if (feed) {
				var hasFeedType = false;

				for (var j = 0; j < vm.feedTypes.length; j++) {
					if (feed.feed_type) {
						if (vm.feedTypes[j].name && feed.feed_type.toLowerCase() === vm.feedTypes[j].name.toLowerCase()) {
							this.feed_type = vm.feedTypes[j];
							hasFeedType = true;
							break;
						}
					} else {
						if (feed.feed_name && vm.feedTypes[j].name && feed.feed_name.toLowerCase() === vm.feedTypes[j].name.toLowerCase()) {
							this.feed_type = vm.feedTypes[j];
							hasFeedType = true;
							break;
						}
					}
				}

				if (!hasFeedType) {
					this.feed_type = {
						show_name: '_feeds_type_not_set_',
						translated: i18nFilter('_feeds_type_not_set_')
					};
				}
			} else {
				this.feed_type = null;
			}
		}

		function addNewFeed() {
			if (vm.newManualRationForm.$valid) {
				vm.noResults = false;
				var newFeedDTO = null;
				var feedName = null;

				if (vm.feedFromApi instanceof Object) {
					feedName = vm.newFeed.feed_name;
				} else {
					feedName = vm.feedFromApi;
				}

				if (vm.newFeed.id) {
					newFeedDTO = new FeedDTO(vm.newFeed.id, feedName, vm.newFeed);
				} else {
					newFeedDTO = new FeedDTO(null, feedName, vm.newFeed);
				}

				vm.ration.ration_feeds.push(newFeedDTO);
				calculateRationAmount();

				$timeout(function () {
					resetForm();
				}, 10);
			} else {
				vm.newManualRationForm.$setSubmitted();
			}
		}

		function FeedDTO(id, name, feed) {
			this.manual_feed_id = id;
			this.feed_name = name;
			this.feed_type = feed.feed_type;
			this.dm = feed.dm;
			this.amount_dm = feed.amount_dm;
			this.amount_as_fed = feed.amount_as_fed;
			this.cost_dm = feed.cost_dm || 0;
			this.cost_as_fed = feed.cost_as_fed || 0;
			this.visible = true;
		}

		function resetForm() {
			vm.feedFromApi = null;
			vm.newFeed = new Feed();
			vm.newManualRationForm.$setPristine();
		}

		function updateNewFeed(type) {
			switch (type) {
				case 'dm':
					vm.newFeed.amount_as_fed = (vm.newFeed.amount_dm * 100) / vm.newFeed.dm;
					vm.newFeed.cost_as_fed = (vm.newFeed.cost_dm * vm.newFeed.dm) / 100;
					break;
				case 'amount_dm':
					vm.newFeed.amount_as_fed = (vm.newFeed.amount_dm * 100) / vm.newFeed.dm;
					break;
				case 'amount_as_fed':
					vm.newFeed.amount_dm = (vm.newFeed.amount_as_fed * vm.newFeed.dm) / 100;
					break;
				case 'cost_dm':
					if (Number.isFinite(vm.newFeed.cost_dm)) {
						vm.newFeed.cost_as_fed = (vm.newFeed.cost_dm * vm.newFeed.dm) / 100;
					} else {
						vm.newFeed.cost_dm = 0;
						vm.newFeed.cost_as_fed = 0;
					}
					break;
				case 'cost_as_fed':
					if (Number.isFinite(vm.newFeed.cost_as_fed)) {
						vm.newFeed.cost_dm = (vm.newFeed.cost_as_fed * 100) / vm.newFeed.dm;
					} else {
						vm.newFeed.cost_dm = 0;
						vm.newFeed.cost_as_fed = 0;
					}
					break;
				default:
					break;
			}
		}

		function openFeedsModal() {
			vm.importList = [];
			var load = false;
			var found = false;
			if (!vm.feeds.length) {
				load = true;
			} else {
				for (var i = 0; i < vm.feeds.length; i++) {
					if (vm.feeds[i].displayed) {
						found = true;
						break;
					}
				}
				if (!found) {
					load = true;
				}
			}
			if (load) {
				loadMoreFeeds();
			}
			resetForm();
			openModal('app/pages/rations/editManualRation/insertFeed.modal.html', 'lg');
		}

		function loadMoreFeeds() {
			vm.currentPage++;
			getFeeds();
		}

		function addAll() {
			vm.feeds.forEach(function (f) {
				if (f.displayed) {
					vm.importList.push(f);
				}
			});

			vm.feeds.forEach(function (feed) {
				feed.displayed = false;
			});
		}

		function addSelected(feed) {
			vm.importList.push(feed);
			feed.displayed = false;
		}

		function removeAll() {
			vm.feeds.forEach(function (feed) {
				feed.displayed = true;
			});

			vm.importList = [];
		}

		function removeSelected(feed) {
			vm.importList = vm.importList.filter(function (f) {
				return feed.id !== f.id;
			});

			for (var i = 0; i < vm.feeds.length; i++) {
				if (vm.feeds[i].id === feed.id) {
					vm.feeds[i].displayed = true;
					break;
				}
			}
		}

		function insertFeeds() {
			for (var i = 0; i < vm.importList.length; i++) {
				var found = false;
				if (vm.ration.ration_feeds.length) {
					for (var j = 0; j < vm.ration.ration_feeds.length; j++) {
						if (vm.importList[i].id === vm.ration.ration_feeds[j].manual_feed_id) {
							vm.ration.ration_feeds[j].visible = true;
							found = true;
							break;
						}
					}
				}
				if (!found) {
					vm.ration.ration_feeds.push({
						manual_feed_id: vm.importList[i].id,
						feed_name: vm.importList[i].feed_name,
						feed_type: vm.importList[i].feed_type,
						dm: vm.importList[i].dm,
						cost_dm: vm.importList[i].cost_dm ? vm.importList[i].cost_dm : 0,
						cost_as_fed: vm.importList[i].cost_as_fed ? vm.importList[i].cost_as_fed : 0,
						amount_dm: vm.importList[i].amount_dm,
						amount_as_fed: vm.importList[i].amount_as_fed,
						visible: true
					});
				}
			}

			vm.importList = [];

			calculateRationAmount();
			closeModal();
		}

		function updateFeed(feed, data, type) {
			switch (type) {
				case 'dm':
					feed.amount_as_fed = (feed.amount_dm * 100) / data;
					feed.cost_as_fed = (feed.cost_dm * data) / 100;
					break;
				case 'amount_dm':
					feed.amount_as_fed = (data * 100) / feed.dm;
					break;
				case 'amount_as_fed':
					feed.amount_dm = (data * feed.dm) / 100;
					break;
				case 'cost_dm':
					if (Number.isFinite(data)) {
						feed.cost_as_fed = (data * feed.dm) / 100;
					} else {
						feed.cost_dm = 0;
						feed.cost_as_fed = 0;
					}
					break;
				case 'cost_as_fed':
					if (Number.isFinite(data)) {
						feed.cost_dm = (data * 100) / feed.dm;
					} else {
						feed.cost_dm = 0;
						feed.cost_as_fed = 0;
					}
					break;
				default:
					break;
			}

			if (vm.onEnterEvent) {
				$timeout(function () {
					var index = vm.ration.ration_feeds.indexOf(feed);
					clickNext(index);
				}, 100);
			}

			if (type) {
				calculateRationAmount();
			}

			function clickNext(index) {
				try {
					var tempIndex = index + 1;
					if (tempIndex < vm.ration.ration_feeds.length) {
						var elem = document.getElementById(type + '_' + tempIndex);
						elem.click();
						if (tempIndex > 6) {
							var parent = elem.parentElement;
							parent.scrollIntoView(true);
						}
					}
					vm.onEnterEvent = false;
				} catch (error) {
					index++;
					clickNext(index);
				}
			}
		}

		function removeFeed(feed) {
			feed.visible = false;

			calculateRationAmount();

			for (var i = 0; i < vm.feeds.length; i++) {
				if (vm.feeds[i].id === feed.manual_feed_id) {
					vm.feeds[i].displayed = true;
					break;
				}
			}
		}

		function calculateRationAmount() {
			var amount_dm = 0;
			var amount_as_fed = 0;
			var cost_dm = 0;

			vm.ration.ration_feeds.forEach(function (feed) {
				if (feed.visible) {
					amount_dm += feed.amount_dm;
					amount_as_fed += feed.amount_as_fed;
					cost_dm += feed.cost_dm * feed.amount_dm;
				}
			});

			vm.ration.amount_dm = amount_dm;
			vm.ration.amount_as_fed = amount_as_fed;
			vm.ration.dm = (amount_dm / amount_as_fed) * 100;
			vm.ration.cost_dm = cost_dm;
		}

		function saveRation(newRation) {
			var DTO = angular.copy(vm.ration);
			var not_set = DTO.ration_feeds.find(function(el){
				return el.feed_type && el.feed_type.show_name == '_feeds_type_not_set_';
			})

			if(not_set){
				return null;
			}

			if (newRation) {
				DTO.id = null;
				DTO.ration_feeds = DTO.ration_feeds.filter(function (f) {
					return f.visible;
				});
				DTO.ration_name = vm.rationNameSaveAs;
				if(vm.groupInfo.$invalid){
					return null;
				}
				vm.saveAsModalLoading = true;
			}
			vm.loading = true;
			DTO.team_id = vm.selectedTeam;
			DTO.herd_id = vm.selectedHerd;
			DTO.user_id = vm.user.email;

			DTO.ration_feeds.forEach(function (feed, index) {
				feed.feed_type = feed.feed_type.name;
				feed.order_number = index;
			});

			if (newRation) {
				editManualRationsFactory
					.addNewRation(DTO)
					.then(function () {
						cancel();
					})
					.catch(function (error) {
						console.log(error);
						vm.loading = false;
						vm.saveAsModalLoading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_saving_ration_');
					});
			} else {
				editManualRationsFactory
					.updateRation(DTO)
					.then(function () {
						cancel();
					})
					.catch(function (error) {
						console.log(error);
						vm.loading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_saving_ration_');
					});
			}
		}

		function openSaveAsModal(){
			vm.saveAsModalLoading = false;
			var not_set = vm.ration.ration_feeds.find(function(el){
				return el.feed_type && el.feed_type.show_name == '_feeds_type_not_set_';
			})
			if(not_set){
				return null;
			}
			vm.rationNameSaveAs = angular.copy(vm.ration.ration_name);
			if(vm.ration.external_id){
				vm.showInfoMessage = true;
			}else {
				vm.showInfoMessage = false;
			}
			openModal('app/pages/rations/editManualRation/saveAs.modal.html', 'md');
		}

		function goToHistory(id) {
			localStorage.setItem('manual_ration_id', vm.ration.id);
			$state.go('rations.manualRationFeedsHistory', {
				uuid: id
			});
		}

		function inputKeyPress(event) {
			if (event.keyCode === 13 || event.keyCode === 27) {
				vm.onEnterEvent = true;
			}
		}

		function cancel() {
			if (vm.from_recipe) {
				if (vm.from_recipe.type === 'add') {
					$state.go('recipes.addNewRecipe');
				} else {
					$state.go('recipes.editRecipe', {
						uuid: vm.from_recipe.uuid
					});
				}
			} else {
				$state.go('rations.manualrations');
			}
		}

		function externalIdPreventDefault() {
			var elem = document.getElementById('external_id');
			if (elem) {
				elem.addEventListener('mousewheel', function name(e) {
					e.preventDefault();
				});
				elem.addEventListener('keydown', function name(e) {
					if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
						e.preventDefault();
					}
				});
			} else {
				$timeout(function () {
					externalIdPreventDefault();
				}, 500);
			}
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('$stateChangeStart', function (event, toState) {
			if (toState.url !== '/editRecipe/{uuid:string}' && toState.url !== '/addNewRecipe') {
				dataServiceFactory.add_new_recipe_data = {};
				dataServiceFactory.edit_recipe_data = {};
				localStorage.removeItem('from_recipe');
			}
		});

		$scope.$on('default_team_selected', function () {
			init();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});

		editableOptions.theme = 'bs3';
		editableOptions.blurElem = 'cancel';
		editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
		editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.editmanualration').factory('editManualRationsFactory', editManualRationsFactory);
	/** @ngInject */
	function editManualRationsFactory(APP_CONST, $http, $q) {
		return {
			getImportedRationById: getImportedRationById,
			getFeeds: getFeeds,
			getFeedByName: getFeedByName,
			addNewRation: addNewRation,
			updateRation: updateRation,
			checkUsedRecipes: checkUsedRecipes
		};

		function getImportedRationById(id) {
			return $http
				.get(APP_CONST.api_base_url + 'importRationsWithRationFeedById/' + id)
				.then(success)
				.catch(error);
		}

		function getFeeds(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'manualfeeds' + suffix)
				.then(success)
				.catch(error);
		}

		function getFeedByName(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'manualfeeds/search' + suffix)
				.then(success)
				.catch(error);
		}

		function addNewRation(ration) {
			return $http
				.post(APP_CONST.api_base_url + 'importRationsWithRationFeed', ration)
				.then(success)
				.catch(error);
		}

		function updateRation(ration) {
			return $http
				.put(APP_CONST.api_base_url + 'importRationsWithRationFeed', ration)
				.then(success)
				.catch(error);
		}

		function checkUsedRecipes(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'recipesByRation' + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.balanceRation').controller('balanceRationCtrl', balanceRationCtrl);
	/** @ngInject */
	function balanceRationCtrl(
		editableOptions,
		editableThemes,
		APP_CONST,
		$timeout,
		$filter,
		$uibModal,
		$window,
		$scope,
		toastr,
		$uibModalStack,
		$stateParams,
		dataServiceFactory,
		balanceRationFactory,
		$q,
		$state,
		$locale,
		addNewRationFactory,
		$cookies,
		settingsFactory,
		$http,
		cookiesService,
		errorService,
		$injector,
		unitConversionService,
		authService
	) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var timeoutSearch;
		var timeoutResize;
		var timeoutEF;
		var timeoutMR;
		var timeoutBNOA;
		var timeoutBGIN;
		var timeoutBGIP;
		var timeoutBDAF;
		var timeoutBBS;
		var timeoutCM;
		var continueModal;
		vm.showChart = false;
		vm.insertMix = false;
		vm.edited = false;
		vm.select = select;
		vm.feedTypeSelected = feedTypeSelected;
		vm.getFeedsForMix = getFeedsForMix;
		vm.checkIsSelected = checkIsSelected;
		vm.defaultCalculationChanged = defaultCalculationChanged;
		vm.reloadApi = reloadApi;
		vm.checkIsSelectedDelete = checkIsSelectedDelete;
		vm.searchChanged = searchChanged;
		vm.paginationChanged = paginationChanged;
		vm.deleteFeed = deleteFeed;
		vm.dataCollapseFn = dataCollapseFn;
		vm.selectTableRow = selectTableRow;
		vm.convertToFeed = convertToFeed;
		vm.unmix = unmix;
		vm.createMIX = createMIX;
		vm.saveMIX = saveMIX;
		vm.cancel = cancel;
		vm.addAll = addAll;
		vm.removeAll = removeAll;
		vm.addSelected = addSelected;
		vm.removeSelected = removeSelected;
		vm.insertFeedOpenModal = insertFeed;
		vm.insertFeeds = insertFeeds;
		vm.getFeedsForRation = getFeedsForRation;
		vm.openStageBreed = openStageBreed;
		vm.openAnimalDesc = openAnimalDesc;
		vm.openAnimalGainPregnancy = openAnimalGainPregnancy;
		vm.openAnimalEnvironmentalFactors = openAnimalEnvironmentalFactors;
		vm.openAnimalFeedAdditives = openAnimalFeedAdditives;
		vm.openRationGroupInfo = openRationGroupInfo;
		vm.openRationMetProtSys = openRationMetProtSys;
		vm.openRationRatiosRelationships = openRationRatiosRelationships;
		vm.openSettingsGeneral = openSettingsGeneral;
		vm.openSettingsNBG = openSettingsNBG;
		vm.saveAnimalStageBreed = saveAnimalStageBreed;
		vm.saveAnimalDescription = saveAnimalDescription;
		vm.saveAnimalGainPregnancy = saveAnimalGainPregnancy;
		vm.saveAnimalEnvironmental = saveAnimalEnvironmental;
		vm.tempStressSelected = tempStressSelected;
		vm.activityLevelSelected = activityLevelSelected;
		vm.saveAnimalFeedAdditives = saveAnimalFeedAdditives;
		vm.feedAdditiveSelected = feedAdditiveSelected;
		vm.saveRationGeneralInfo = saveRationGeneralInfo;
		vm.mpsSelected = mpsSelected;
		vm.saveRationMPS = saveRationMPS;
		vm.saveSettingsGeneral = saveSettingsGeneral;
		vm.saveNutrientBalance = saveNutrientBalance;
		vm.envChanged = envChanged;
		vm.redirect = redirect;
		vm.updateFeed = updateFeed;
		vm.updateFeedMix = updateFeedMix;
		vm.addFeedToMix = addFeedToMix;
		vm.removeFeedFromMix = removeFeedFromMix;
		vm.saveRation = saveRation;
		vm.redirectProceed = redirectProceed;
		vm.continueModalOpen = continueModalOpen;
		vm.openMixModal = openMixModal;
		vm.reportMixUp = reportMixUp;
		vm.reportMixDown = reportMixDown;
		vm.reportBatchUp = reportBatchUp;
		vm.reportBatchDown = reportBatchDown;
		vm.exportMixReport = exportMixReport;
		vm.selectMixReportFeed = selectMixReportFeed;
		vm.mixReportBatchSizeChanged = mixReportBatchSizeChanged;
		vm.openSummaryModal = openSummaryModal;
		vm.exportSummaryOfficeReport = exportSummaryOfficeReport;
		vm.openOfficeModal = openOfficeModal;
		vm.proceed = proceed;
		vm.openBatchModal = openBatchModal;
		vm.batchNOAChanged = batchNOAChanged;
		vm.batchGINChanged = batchGINChanged;
		vm.batchGIPChanged = batchGIPChanged;
		vm.batchDAFhanged = batchDAFhanged;
		vm.batchBShanged = batchBShanged;
		vm.exportBatchReport = exportBatchReport;
		vm.editGroup = editGroup;
		vm.changeAmount = changeAmount;
		vm.changeAsFed = changeAsFed;
		vm.openSaveAsModal = openSaveAsModal;
		vm.saveRationAs = saveRationAs;
		vm.goToFeedHistory = goToFeedHistory;
		vm.goToHistory = goToHistory;
		vm.openChangeGroup = openChangeGroup;
		vm.changeGroup = changeGroup;
		vm.changeShowGraph = changeShowGraph;
		vm.feedKeyDown = feedKeyDown;
		vm.mixKeyDown = mixKeyDown;
		vm.changeUseAmount = changeUseAmount;
		vm.sort = sort;
		vm.commonFeedChanged = commonFeedChanged;
		vm.feedTypeChanged = feedTypeChanged;
		vm.stopLoadingTabs = stopLoadingTabs;
		vm.openOrderModal = openOrderModal;
		vm.closeModal = closeModal;
		vm.updateOrder = updateOrder;
		vm.changeUnits = changeUnits;
		vm.changeAmountProduct = changeAmountProduct;
		vm.move = move;
		vm.rationTables = dataServiceFactory.ration_tables;
		vm.tableRowExpanded = false;
		vm.tableRowIndexExpandedCurr = '';
		vm.tableRowIndexExpandedPrev = '';
		vm.idExpanded = '';
		vm.modal = {};
		vm.modalLoading = false;
		vm.modalRNLoading = false;
		vm.modalNALoading = false;
		vm.loadingEnv = false;
		vm.hasMix = false;
		vm.hasBatch = false;
		vm.showChart = false;
		vm.mixBatchSize = 100;
		vm.stateName = null;
		vm.stateUuid = null;
		vm.modalType = null;
		vm.modalFeed = null;
		vm.modalIndex = null;
		vm.dirtyList = [];
		vm.dirtyListMix = [];
		vm.selectedList = [];
		vm.importList = [];
		vm.summary = {};
		vm.batch = {};
		//date picker
		vm.opened = {};
		vm.open = function ($event, elementOpened) {
			$event.preventDefault();
			$event.stopPropagation();
			vm.opened[elementOpened] = !vm.opened[elementOpened];
		};

		var rationId = $stateParams.uuid;

		init();

		vm.homeInitialized = false;

		$scope.$watch('vm.activeTab', function (newValue) {
			vm.loadingTabs = true;
			$timeout(function () {
				vm.rationTables.showHome = newValue == 1 ? true : false;
				vm.rationTables.showFiber = newValue == 2 ? true : false;
				vm.rationTables.showEnergy = newValue == 3 ? true : false;
				vm.rationTables.showProtein = newValue == 4 ? true : false;
				vm.rationTables.showCarb = newValue == 5 ? true : false;
				vm.rationTables.showLipid = newValue == 6 ? true : false;
				vm.rationTables.showMineral = newValue == 7 ? true : false;
				vm.rationTables.showTMineral = newValue == 8 ? true : false;
				vm.rationTables.showVitamin = newValue == 9 ? true : false;
				vm.rationTables.showAA = newValue == 10 ? true : false;
				vm.rationTables.showCostTab = newValue == 11 ? true : false;
				vm.rationTables.showMisc = newValue == 12 ? true : false;
			}, 10);
		});

		$scope.$on('menu_collapsed', function () {
			setResize();
		});

		angular.element($window).bind('resize', function () {
			setResize();
		});

		$scope.$on('$destroy', function () {
			angular.element($window).unbind('resize');
		});

		function setResize() {
			if (timeoutResize) {
				$timeout.cancel(timeoutResize);
			}
		}

		function stopLoadingTabs() {
			$timeout(function () {
				vm.loadingTabs = false;
			}, 0);
		}

		function setUseAmountSwitch() {
			try {
				var sw = JSON.parse($cookies.get('use_product'));
			} catch (error) {
				vm.switchUseAmount = true;
				$cookies.put('use_product', vm.switchUseAmount, {
					expires: moment().add(1, 'month').toDate()
				});
			}
			if (sw != null) {
				vm.switchUseAmount = sw;
			}
		}

		function changeAmountProduct() {
			vm.loadingTabs = true;
			$cookies.put('use_product', vm.switchUseAmount, {
				expires: moment().add(1, 'month').toDate()
			});
			$timeout(function () {
				vm.loadingTabs = false;
			}, 250);
		}

		function changeUnits() {
			if (vm.edited) {
				vm.modalType = 'changeUnits';
				openModal('app/pages/rations/balanceRation/modals/changeFeeds.modal.html', 'sm', 'redirect_modal');
			} else {
				changeUnitsProceed();
			}
		}

		function changeUnitsProceed() {
			vm.loadingTabs = true;
			$timeout(function () {
				if (vm.sliderUsePercent) {
					vm.settings.use_percent = true;
				} else {
					vm.settings.use_percent = false;
				}
				localStorage.setItem('user_settings', JSON.stringify(vm.settings));
				if (vm.modalType == 'changeUnits') {
					vm.modalType = null;
				}
				saveSettings();
				getRationById(rationId);
			}, 100);
		}

		function changeUseAmount() {
			if (vm.sliderUseAmount == 1) {
				vm.use_amount = false;
			} else {
				vm.use_amount = true;
			}
			vm.settings.use_amount = vm.use_amount;
			localStorage.setItem('user_settings', JSON.stringify(vm.settings));
			vm.activeTab = null;
			if (vm.modalType == 'changeSlider') {
				vm.modalType = null;
			}
			saveSettings();
			init();
		}

		function saveSettings() {
			settingsFactory
				.changeSettings(vm.settings, vm.user.email)
				.then()
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_saving_user_settings_');
				});
		}

		function init() {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedHerd = vm.settings.selectedHerd.id;
			vm.nel_89Max = unitConversionService.convertData(10.03, ['kgToLb', 'mcalToMjoule', 'round:2']);
			vm.me_89max = unitConversionService.convertData(16.18, ['kgToLb', 'mcalToMjoule', 'round:2']);
			if (vm.settings.use_percent) {
				vm.sliderUsePercent = true;
			} else {
				vm.sliderUsePercent = false;
			}
			vm.disableScroll = true;
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			vm.feed_loading = false;
			vm.mixfeed_loading = false;
			vm.usedRecipesList = [];
			vm.currentPageMaster = 1;
			vm.itemsPerPageMaster = 30;
			vm.searchMaster = '';
			localStorage.removeItem('feed_calculation_type');
			localStorage.removeItem('ration_calculation_type');
			vm.from_premix = JSON.parse(localStorage.getItem('from_premix'));
			//this line should be removed after reselection feature is updated
			vm.loading = true;
			vm.modalOpened = false;
			vm.hasUs = false;
			vm.hasVem = false;
			setSwitchLabels();
			setDefaultCalculation();
			setUseAmountSwitch();
			setStrings();
			setFeedFilter();
			setCommonFeedFilter();
			setFeedTypesFilter();
			var showG = $cookies.get('show_graph');
			if (showG) {
				vm.showGraph = JSON.parse(showG).value;
			} else {
				var now = new Date();
				var exp = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
				cookiesService.setCookie('show_graph', '{"value":true}', {
					samesite: 'strict',
					expires: exp
				});

				vm.showGraph = true;
			}
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			setFeedTypes(APP_CONST.constants.feed_types);
			getRationById(rationId, true);
			if (authService.can(64)) {
				checkUsedRecipes();
			}

		}

		function reloadApi() {
			vm.selectedList = [];
			vm.importList = [];
			vm.disableScroll = true;
			vm.loading = true;
			getRationById(rationId, true);
		}

		function checkUsedRecipes() {
			vm.popoverLoading = true;
			var suffix = '?rationHeaderId=' + rationId + '&date=' + moment().format('YYYY-MM-DD');

			balanceRationFactory
				.checkUsedRecipes(suffix)
				.then(function (response) {
					response.forEach(function (r) {
						vm.usedRecipesList.push(r.recipe_name);
					});

					vm.popoverLoading = false;
				})
				.catch(function (error) {
					console.log(error);

					if (error.status != 403) {
						errorService.showErrorMessage(error, true, '_error_occurred_loading_recipes_');
					}
					vm.popoverLoading = false;

				});
		}

		function setSwitchLabels() {
			vm.amountSwitchLabel = i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_');
			vm.productSwitchLabel = i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_m_f_product_switch_product_type');
		}

		function paginationChanged(type) {
			vm.currentPageMaster++;
			vm.disableScroll = true;
			vm.isPage = true;
			if (type == 'ration') {
				getFeedsForRation('app/pages/rations/balanceRation/modals/insertFeed.modal.html', 'lg');
			} else {
				getFeedsForMix();
			}
		}

		function searchChanged(type) {
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			if (vm.searchMaster.length >= 3) {
				if (timeoutSearch) {
					$timeout.cancel(timeoutSearch);
				}
				timeoutSearch = $timeout(function () {
					vm.feedsByTeam = [];
					if (type == 'ration') {
						getFeedsForRation('app/pages/rations/balanceRation/modals/insertFeed.modal.html', 'lg');
					} else {
						getFeedsForMix();
					}
				}, 1000);
			}
			if (vm.searchMaster.length == 0) {
				vm.feedsByTeam = [];
				if (type == 'ration') {
					getFeedsForRation('app/pages/rations/balanceRation/modals/insertFeed.modal.html', 'lg');
				} else {
					getFeedsForMix();
				}
			}
		}

		function setDefaultCalculation() {
			vm.defaultCalculationList = [
				{
					name: '_calculation_filter_us_feeds_',
					calc_type: 0
				},
				{
					name: '_calculation_filter_vem_dve_feeds_',
					calc_type: 1
				}
			];
			if (vm.settings.calculation_type != null) {
				for (var i = 0; i < vm.defaultCalculationList.length; i++) {
					if (vm.settings.calculation_type == vm.defaultCalculationList[i].calc_type) {
						vm.defaultCalculation = vm.defaultCalculationList[i];
					}
				}
			} else {
				vm.defaultCalculation = vm.defaultCalculationList[0];
			}
		}

		function checkBatch() {
			vm.hasBatch = false;
			for (var i = 0; i < vm.ration.feeds.length; i++) {
				if (vm.ration.feeds[i].amount > 0) {
					vm.hasBatch = true;
					break;
				}
			}
		}

		$scope.$on('default_team_selected', function () {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
		});

		$scope.$on('default_herd_selected', function () {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			$uibModalStack.dismissAll();
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		function setStrings() {
			vm.titleUnmix = '_tips_unmix_ration_';
			vm.titleConvert = '_tips_convert_to_feed_';
			vm.titleEdit = '_tips_edit_';
			vm.titleAddFeedToMix = '_tips_add_feed_to_mix_';
			vm.titleRemoveFeedFromMix = '_tips_remove_feed_from_mix_';
			vm.titleHistory = '_ration_feed_history_';
			vm.titleExpand = '_tips_expand_mix_';
			vm.typeAll = i18nFilter('_feeds_type_all_');
			vm.typeDryForage = i18nFilter('_feeds_type_dry_forage_');
			vm.typeCornSilage = i18nFilter('_feeds_type_corn_silage_');
			vm.typeGrass = i18nFilter('_feeds_type_grass_silage_');
			vm.typeAlfa = i18nFilter('_feeds_type_alfa_silage_');
			vm.typeOther = i18nFilter('_feeds_type_other_wet_forage_');
			vm.typeByProduct = i18nFilter('_feeds_type_by_product_');
			vm.typeGrain = i18nFilter('_feeds_type_grain_');
			vm.typeFatty = i18nFilter('_feeds_type_fatty_acid_source_');
			vm.typeTriglicerides = i18nFilter('_feeds_type_triglycerides_');
			vm.typeCP = i18nFilter('_feeds_type_cp_source_');
			vm.typeRUP = i18nFilter('_feeds_type_rup_source_');
			vm.typeMineral = i18nFilter('_feeds_type_mineral_');
			vm.typeVitamin = i18nFilter('_feeds_type_vitamin_');
			vm.typeMix = i18nFilter('_feeds_type_mix_');
			vm.commonYes = i18nFilter('_feeds_yes_');
			vm.commonNo = i18nFilter('_feeds_no_');
			vm.amountString = i18nFilter('_unit_amount_');
			vm.concString = i18nFilter('_unit_conc_');
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
		}

		function setFeedTypes(feed_types) {
			vm.feed_types = [];
			for (var i = 0; i < feed_types.length; i++) {
				var temp = '_feeds_type_' + feed_types[i].value + '_';
				feed_types[i].show_name = temp;
				feed_types[i].translated = i18nFilter(temp);
				vm.feed_types.push(feed_types[i]);
			}
		}

		function getRationById(id, init) {
			vm.loadingTabs = true;
			vm.importList = [];
			return balanceRationFactory
				.getRationById(id)
				.then(function (response) {
					setRation(response);
				})
				.catch(function (error) {
					vm.loading = false;
					vm.loadingTabs = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_rations_', init);
				});
		}

		function setRation(response, index, mixIndex) {
			if (response.ration_header.ration_locale != null && response.ration_header.ration_locale != undefined) {
				if (response.ration_header.ration_locale == 0) {
					vm.calculationType = 0;
					vm.rationCalculationLabel = i18nFilter(vm.defaultCalculationList[0].name).split(' ')[0];
				} else {
					vm.calculationType = 1;
					vm.rationCalculationLabel = i18nFilter(vm.defaultCalculationList[1].name).split(' ')[0];
				}
			}
			vm.hasMix = false;
			var ration = {};
			angular.copy(response, ration);
			var feeds = [];
			for (var i = 0; i < ration.ration_header.rations.length; i++) {
				fixVemValues(ration.ration_header.rations[i].feed);
				if (ration.ration_header.rations[i].feed.mixes) {
					for (var j = 0; j < ration.ration_header.rations[i].feed.mixes.length; j++) {
						fixVemValues(ration.ration_header.rations[i].feed.mixes[j]);
					}
				}
				var temp = {};
				angular.copy(ration.ration_header.rations[i].feed, temp);
				temp.ration_id = ration.ration_header.rations[i].id;
				temp.ration_header_id = ration.ration_header.rations[i].ration_header_id;
				if (temp.mixes) {
					vm.hasMix = true;
					for (var j = 0; j < temp.mixes.length; j++) {
						temp.mixes[j].ration_id = ration.ration_header.rations[i].id;
					}
				}
				feeds.push(temp);
			}
			var a = $filter('orderBy')(feeds, 'feed_type');
			ration.feeds = a;
			for (var i = 0; i < ration.feeds.length; i++) {
				var hasFeedType = false;
				ration.feeds[i].position = i;
				ration.feeds[i].cost_per_cow = ration.feeds[i].cost_dm * ration.feeds[i].amount;
				if (response.group.target_milk_yield > 0) {
					ration.feeds[i].target_milk_cost = ration.feeds[i].cost_per_cow / response.group.target_milk_yield;
				} else {
					ration.feeds[i].target_milk_cost = 0;
				}
				if (response.group.actual_milk_yield > 0) {
					ration.feeds[i].actual_milk_cost = ration.feeds[i].cost_per_cow / response.group.actual_milk_yield;
				} else {
					ration.feeds[i].actual_milk_cost = 0;
				}
				if (ration.feeds[i].feed_type) {
					for (var j = 0; j < vm.feed_types.length; j++) {
						if (ration.feeds[i].feed_type.toLowerCase() === vm.feed_types[j].name.toLowerCase()) {
							ration.feeds[i].feed_type = vm.feed_types[j];
							hasFeedType = true;
							break;
						}
					}
				}
				if (!hasFeedType) {
					var t = {
						show_name: '_feeds_type_not_set_'
					};
					ration.feeds[i].feed_type = t;
				}
				if (ration.feeds[i].mixes) {
					for (var k = 0; k < ration.feeds[i].mixes.length; k++) {
						var hasFeedTypeMix = false;
						ration.feeds[i].mixes[k].cost_per_cow = ration.feeds[i].mixes[k].cost_dm * ration.feeds[i].mixes[k].amount;
						if (response.group.target_milk_yield > 0) {
							ration.feeds[i].mixes[k].target_milk_cost = ration.feeds[i].mixes[k].cost_per_cow / response.group.target_milk_yield;
						} else {
							ration.feeds[i].mixes[k].target_milk_cost = 0;
						}
						if (response.group.actual_milk_yield > 0) {
							ration.feeds[i].mixes[k].actual_milk_cost = ration.feeds[i].mixes[k].cost_per_cow / response.group.actual_milk_yield;
						} else {
							ration.feeds[i].mixes[k].actual_milk_cost = 0;
						}
						if (ration.feeds[i].mixes[k].feed_type) {
							for (var m = 0; m < vm.feed_types.length; m++) {
								if (ration.feeds[i].mixes[k].feed_type.toLowerCase() === vm.feed_types[m].name.toLowerCase()) {
									ration.feeds[i].mixes[k].feed_type = vm.feed_types[m];
									hasFeedTypeMix = true;
									break;
								}
							}
						}
						if (!hasFeedTypeMix) {
							var t = {
								show_name: '_feeds_type_not_set_'
							};
							ration.feeds[i].mixes[k].feed_type = t;
						}
					}
				}
				if (vm.selectedList.length > 0) {
					for (var l = 0; l < vm.selectedList.length; l++) {
						if (ration.feeds[i].id == vm.selectedList[l].id) {
							ration.feeds[i].is_selected = true;
						}
					}
				}
			}
			vm.feed_selected = false;
			ration.supply_amount.cost_per_cow = ration.supply_amount.cost_dm;
			ration.supply_conc.cost_per_cow = ration.supply_amount.cost_dm;
			if (ration.group.actual_milk_yield > 0) {
				ration.supply_amount.actual_milk_cost = ration.supply_amount.cost_per_cow / ration.group.actual_milk_yield;
				ration.supply_conc.actual_milk_cost = ration.supply_amount.cost_per_cow / ration.group.actual_milk_yield;
			} else {
				ration.supply_amount.actual_milk_cost = 0;
				ration.supply_conc.actual_milk_cost = 0;
			}
			if (ration.group.target_milk_yield > 0) {
				ration.supply_amount.target_milk_cost = ration.supply_amount.cost_per_cow / ration.group.target_milk_yield;
				ration.supply_conc.target_milk_cost = ration.supply_amount.cost_per_cow / ration.group.target_milk_yield;
			} else {
				ration.supply_amount.target_milk_cost = 0;
				ration.supply_conc.target_milk_cost = 0;
			}
			configChart(response);
			if (vm.settings.use_amount) {
				ration.supply = ration.supply_amount;
				ration.requirements = ration.requirement_amount;
				ration.difference = ration.balance_amount;
				vm.use_amount = true;
				vm.sliderUseAmount = 0;
			} else {
				ration.supply = ration.supply_conc;
				ration.requirements = ration.requirement_conc;
				ration.difference = ration.balance_conc;
				vm.use_amount = false;
				vm.sliderUseAmount = 1;
			}
			ration.group.tbw = ration.group.total_bw;
			ration.group.mpd = ration.group.target_milk_yield;
			ration.group.dg = ration.group.predicted_daily_gain;
			ration.group.dmi = ration.group.predicted_base_dmi;
			if (vm.settings.use_kgs) {
				vm.weight = 'kg';
			} else {
				vm.weight = 'lb';
			}
			if (vm.settings.use_mcal) {
				vm.energy = 'Mcal';
			} else {
				vm.energy = 'Mjoule';
			}
			setSwitchLabels();
			ration.group.t = '_at_' + ration.group.type + '_';
			ration.group.br = '_ab_' + ration.group.breed + '_';
			if (mixIndex != undefined && index != undefined) {
				if (vm.feed_selected) {
					ration.feeds[index].is_selected = vm.feed_selected;
				}
				vm.ration.balance_amount = ration.balance_amount;
				vm.ration.balance_conc = ration.balance_conc;
				vm.ration.concentration_supplied = ration.concentration_supplied;
				vm.ration.difference = ration.difference;
				vm.ration.group = ration.group;
				vm.ration.nutrient_balance = ration.nutrient_balance;
				vm.ration.nutrient_balance_settings = ration.nutrient_balance_settings;
				vm.ration.ration_header = ration.ration_header;
				vm.ration.rations_and_relationships = ration.rations_and_relationships;
				vm.ration.requirement_amount = ration.requirement_amount;
				vm.ration.requirement_conc = ration.requirement_conc;
				vm.ration.requirements = ration.requirements;
				vm.ration.supply = ration.supply;
				vm.ration.supply_amount = ration.supply_amount;
				vm.ration.supply_conc = ration.supply_conc;
				Object.keys(ration.feeds[index]).forEach(function (key) {
					if (key != 'mixes') {
						vm.ration.feeds[index][key] = ration.feeds[getFeedIndex(ration.feeds, vm.ration.feeds[index].id)][key];
					}
				});
				vm.ration.feeds[index].mixes[mixIndex] = ration.feeds[getFeedIndex(ration.feeds, vm.ration.feeds[index].id)].mixes[mixIndex];
			} else if (index != undefined) {
				if (vm.feed_selected) {
					ration.feeds[index].is_selected = vm.feed_selected;
				}
				vm.ration.balance_amount = ration.balance_amount;
				vm.ration.balance_conc = ration.balance_conc;
				vm.ration.concentration_supplied = ration.concentration_supplied;
				vm.ration.difference = ration.difference;
				vm.ration.group = ration.group;
				vm.ration.nutrient_balance = ration.nutrient_balance;
				vm.ration.nutrient_balance_settings = ration.nutrient_balance_settings;
				vm.ration.ration_header = ration.ration_header;
				vm.ration.rations_and_relationships = ration.rations_and_relationships;
				vm.ration.requirement_amount = ration.requirement_amount;
				vm.ration.requirement_conc = ration.requirement_conc;
				vm.ration.requirements = ration.requirements;
				vm.ration.supply = ration.supply;
				vm.ration.supply_amount = ration.supply_amount;
				vm.ration.supply_conc = ration.supply_conc;
				vm.ration.feeds[index] = ration.feeds[getFeedIndex(ration.feeds, vm.ration.feeds[index].id)];
			} else {
				vm.ration = ration;
			}
			vm.feedsSafe = vm.ration.feeds;
			checkBatch();
			vm.loading = false;
			vm.loadingTabs = false;

			function fixVemValues(item) {
				item.vem = item.vem || 0;
				item.dve = item.dve || 0;
				item.oeb = item.oeb || 0;
				item.fos = item.fos || 0;
				item.rc = item.rc || 0;
				item.rus = item.rus || 0;
			}
		}

		function configChart(ration) {
			vm.labels = [];
			vm.data = [[]];
			var graphSettings = ration.nutrient_balance_settings;
			if (ration.group.type == 'heifer') {
				graphSettings.nel = false;
			} else {
				graphSettings.neg = false;
			}
			var max = graphSettings.x_axis_max;
			var min = graphSettings.x_axis_min;
			var graphValues = JSON.parse(JSON.stringify(ration.nutrient_balance));
			//set values according to min and max x axis
			Object.keys(graphValues).forEach(function (key) {
				graphValues[key] = round(graphValues[key], 1);
				if (graphValues[key] > max) {
					graphValues[key] = max;
				} else if (graphValues[key] < min) {
					graphValues[key] = min;
				}
				if (graphSettings[key] == true) {
					var label = '_nb_' + key + '_';
					var labelTranslated = i18nFilter('_nb_' + key + '_');
					vm.labels.push(labelTranslated);
					vm.data[0].push(graphValues[key]);
				}
			});
			if (-min + max <= 20) {
				var stepSize = 5;
			} else {
				var stepSize = 20;
			}
			vm.chartOptions = {
				maintainAspectRatio: false,
				animation: false,
				scales: {
					xAxes: [
						{
							ticks: {
								min: min,
								max: max,
								stepSize: stepSize
							},
							afterBuildTicks: function (chart) {
								chart.ticks.push(0);
							}
						}
					]
				}
			};
			vm.colors = ['#1E4FDC'];
			vm.chartStyle = setChartHeight(vm.labels);
			$timeout(function () {
				vm.showChart = true;
			}, 0);
		}

		function setChartHeight(list) {
			var size = list.length;
			var chartSize;
			if (size <= 33 && size > 20) {
				chartSize = {
					height: '450px'
				};
			} else if (size <= 20 && size > 15) {
				chartSize = {
					height: '400px'
				};
			} else if (size <= 15 && size > 10) {
				chartSize = {
					height: '350px'
				};
			} else if (size <= 10 && size > 5) {
				chartSize = {
					height: '280px'
				};
			} else if (size <= 5 && size > 3) {
				chartSize = {
					height: '230px'
				};
			} else if (size <= 3 && size > 1) {
				chartSize = {
					height: '150px'
				};
			} else if (size <= 1) {
				chartSize = {
					height: '75px'
				};
			}
			return chartSize;
		}

		function select(feed, insert) {
			if (vm.dataCollapse && !insert) {
				for (var i = 0; i < vm.dataCollapse.length; i++) {
					vm.dataCollapse[i] = false;
				}
				collapseTable();
			}
			var found = false;
			var inx = null;
			if (vm.selectedList.length == 0) {
				vm.selectedList.push(feed);
			} else {
				for (var i = 0; i < vm.selectedList.length; i++) {
					if (vm.selectedList[i].id == feed.id) {
						found = true;
						inx = i;
					}
				}
				if (found) {
					vm.selectedList.splice(inx, 1);
				} else {
					vm.selectedList.push(feed);
				}
			}
		}

		function addFeedToMix(feed) {
			vm.searchMaster = '';
			vm.importList = [];
			vm.importListSafe = [];
			if (vm.edited) {
				vm.modalFeed = feed;
				vm.modalType = 'addFeedToMix';
				openModal('app/pages/rations/balanceRation/modals/changeFeeds.modal.html', 'sm', 'redirect_modal');
			} else {
				vm.modalLoading = true;
				vm.sortedColumn = 'feed_name';
				vm.order = 'ASC';
				vm.sort_col = 'feed_name_ASC';
				vm.currentPageMaster = 1;
				vm.searchMaster = '';
				vm.disableScroll = true;
				vm.feedsByTeam = [];
				getFeedsForMix();
			}
		}

		function getFeedsForMix() {
			if (!vm.modalOpened) {
				openFeedsModal('app/pages/rations/balanceRation/modals/insertFeedToMix.modal.html');
				vm.modalOpened = true;
			}
			vm.insertMix = true;
			var feedIndex;
			Object.keys(vm.dataCollapse).forEach(function (key) {
				if (vm.dataCollapse[key] === true) {
					feedIndex = key;
				}
			});
			vm.feedIndex = feedIndex;
			vm.selectedTeam = null;
			if (vm.settings.selectedTeam && vm.settings.selectedTeam.id) {
				vm.selectedTeam = vm.settings.selectedTeam.id;
				var suffix;
				if (vm.settings.selectedHerd && vm.settings.selectedHerd.id) {
					suffix = '?teamId=' + vm.selectedTeam + '&herdId=' + vm.settings.selectedHerd.id + '&feedsOnly=true';
				} else {
					suffix = '?teamId=' + vm.selectedTeam + '&feedsOnly=true';
				}
				if (vm.defaultCalculation != null || vm.defaultCalculation != undefined) {
					suffix = suffix + '&localType=' + vm.defaultCalculation.calc_type;
				}
				if (vm.currentPageMaster) {
					suffix = suffix + '&page=' + vm.currentPageMaster;
				}
				if (vm.searchMaster) {
					suffix = suffix + '&feedName=' + encodeURIComponent(vm.searchMaster);
				}
				if (vm.selectedFeedType) {
					suffix = suffix + '&returnType=' + vm.selectedFeedType.value;
				}
				if (vm.commonFeedItem && vm.commonFeedItem.value != null) {
					suffix = suffix + '&commonFeed=' + vm.commonFeedItem.value;
				}
				if (vm.feedCategotyItem && vm.feedCategotyItem.value) {
					suffix = suffix + '&feedType=' + vm.feedCategotyItem.value;
				}
				if (vm.sortedColumn && vm.order) {
					suffix = suffix + '&orderBy=' + vm.sortedColumn + '&orderType=' + vm.order;
				}
				if (!vm.isPage) {
					vm.feedsLoaded = false;
				}
				vm.isPage = false;
				cancelApiRequest();
				return balanceRationFactory
					.getFeedsByTeamId(suffix)
					.then(function (response) {
						if (response.length > 0) {
							vm.totalItemsMaster = response[0].number_of_all;
							for (var i = response.length - 1; i >= 0; i--) {
								for (var j = 0; j < vm.importList.length; j++) {
									if (response[i].id == vm.importList[j].id) {
										response.splice(i, 1);
										break;
									}
								}
							}
							vm.feedsByTeam = vm.feedsByTeam.concat(response);
							var orderBool;
							if (vm.order == 'ASC') {
								orderBool = false;
							} else {
								orderBool = true;
							}
							vm.feedsByTeam = $filter('orderBy')(vm.feedsByTeam, vm.sortedColumn, orderBool);
						} else {
							vm.totalItemsMaster = 0;
						}
						vm.mix = vm.ration.feeds[vm.feedIndex];
						vm.modalLoading = false;
						vm.feedsLoaded = true;
						vm.disableScroll = false;
						$timeout(function () {
							var searchInput = document.getElementById('feedsSearchInput');
							if (searchInput) {
								searchInput.focus();
							}
						}, 50);
					})
					.catch(function (error) {
						if (error != 'Canceled') {
							console.log(error);
							vm.disableScroll = false;
							vm.modalLoading = false;
							vm.feedsLoaded = true;
							errorService.showErrorMessage(error, true, '_error_occurred_loading_feeds_');
						}
					});
			} else {
				vm.selectedTeam = null;
				vm.modalLoading = false;
			}
		}

		function proceed(msg) {
			if (msg == '_feeds_delete_warning_message_') {
				deleteFeedProceed();
			} else if (msg == '_feeds_unmix_warning_message_') {
				unmixProceed(vm.convert_unmix, vm.convert_unmix_index);
			} else if (msg == '_feeds_remove_from_mix_warning_message_') {
				removeFeedFromMixProceed(vm.convert_unmix, vm.convert_unmix_index);
			} else {
				convertToFeedProceed(vm.convert_unmix, vm.convert_unmix_index);
			}
		}

		function removeFeedFromMix(feed, index) {
			vm.convert_unmix = angular.copy(feed);
			vm.convert_unmix_index = index;
			vm.warningMessage = '_feeds_remove_from_mix_warning_message_';
			openModal('app/pages/rations/balanceRation/modals/confirmationDialog.modal.html', 'md');
		}

		function removeFeedFromMixProceed(feed, index) {
			if (vm.edited) {
				vm.modalFeed = feed;
				vm.modalIndex = index;
				vm.modalType = 'removeFeedFromMix';
				continueModal = openLoadingModal('app/pages/rations/balanceRation/modals/changeFeeds.modal.html', 'sm', 'redirect_modal');
			} else {
				var feedIndex;
				var removeFromMixDto = angular.copy(feed);
				Object.keys(vm.dataCollapse).forEach(function (key) {
					if (vm.dataCollapse[key] === true) {
						feedIndex = key;
					}
				});
				removeFromMixDto.feed_type = removeFromMixDto.feed_type.name;
				var currentFeed = vm.ration.feeds[feedIndex];
				if (currentFeed.mixes.length > 2) {
					vm.modalLoading = true;
					removeFromMixDto.user_id = vm.user.email;
					balanceRationFactory
						.removeFeedFromMix(vm.ration.ration_header_id, removeFromMixDto)
						.then(function (response) {
							setRation(response);
							vm.modalLoading = false;
							$uibModalStack.dismissAll();
						})
						.catch(function (error) {
							console.log(error);
							vm.modalLoading = false;
							errorService.showErrorMessage(error, true, '_error_occurred_remove_feed_from_mix_');
						});
				} else {
					toastr.warning('', i18nFilter('_toastr_mix_number_of_feeds_error_'));
				}
			}
		}

		function checkIsSelected() {
			if (vm.selectedList.length > 1) return true;
			else return false;
		}

		function checkIsSelectedDelete() {
			if (vm.selectedList.length > 0) return true;
			else return false;
		}

		function deleteFeed() {
			vm.warningMessage = '_feeds_delete_warning_message_';
			for (var i = 0; i < vm.selectedList.length; i++) {
				vm.selectedList[i].to_delete = false;
			}
			openModal('app/pages/rations/balanceRation/modals/confirmationDialog.modal.html', 'md');
		}

		function deleteFeedProceed() {
			if (vm.selectedList && vm.selectedList.length > 0) {
				if (vm.edited) {
					vm.modalType = 'deleteFeed';
					continueModal = openLoadingModal('app/pages/rations/balanceRation/modals/changeFeeds.modal.html', 'sm', 'redirect_modal');
				} else {
					vm.modalLoading = true;
					var listOFFeeds = [];
					for (var i = 0; i < vm.selectedList.length; i++) {
						var rationDTO = {
							id: vm.selectedList[i].ration_id,
							user_id: vm.user.email,
							ration_header_id: vm.selectedList[i].ration_header_id
						};
						listOFFeeds.push(rationDTO);
					}
					return balanceRationFactory
						.removeFeeds(listOFFeeds, vm.ration.ration_header_id)
						.then(function () {
							$uibModalStack.dismissAll();
							vm.modalLoading = false;
							getRationById(vm.ration.ration_header_id);
							vm.listOfFeeds = [];
							vm.selectedList = [];
						})
						.catch(function (error) {
							vm.modalLoading = false;
							errorService.showErrorMessage(error, true, '_error_occurred_deleting_feed_');
							console.log(error);
						});
				}
			}
		}

		function dataCollapseFn() {
			vm.dataCollapse = [];
			for (var i = 0; i < vm.ration.feeds.length; i++) {
				vm.dataCollapse.push(false);
			}
		}

		function collapseTable() {
			vm.tableRowExpanded = false;
			vm.tableRowIndexExpandedCurr = '';
			vm.idExpanded = '';
		}

		function selectTableRow(index, id) {
			vm.selectedList = [];
			for (var i = 0; i < vm.ration.feeds.length; i++) {
				vm.ration.feeds[i].is_selected = false;
			}
			if (typeof vm.dayDataCollapse === 'undefined') {
				vm.dataCollapseFn();
			}
			if (vm.tableRowExpanded === false && vm.tableRowIndexExpandedCurr === '' && vm.idExpanded === '') {
				vm.tableRowIndexExpandedPrev = '';
				vm.tableRowExpanded = true;
				vm.tableRowIndexExpandedCurr = index;
				vm.idExpanded = id;
				vm.dataCollapse[index] = true;
			} else if (vm.tableRowExpanded === true) {
				if (vm.tableRowIndexExpandedCurr === index && vm.idExpanded === id) {
					vm.tableRowExpanded = false;
					vm.tableRowIndexExpandedCurr = '';
					vm.idExpanded = '';
					vm.dataCollapse[index] = false;
				} else {
					vm.tableRowIndexExpandedPrev = vm.tableRowIndexExpandedCurr;
					vm.tableRowIndexExpandedCurr = index;
					vm.idExpanded = id;
					vm.dataCollapse[vm.tableRowIndexExpandedPrev] = false;
					vm.dataCollapse[vm.tableRowIndexExpandedCurr] = true;
				}
			}
		}

		function convertToFeed(feed, index) {
			vm.convert_unmix = angular.copy(feed);
			vm.convert_unmix_index = index;
			vm.warningMessage = '_feeds_convert_warning_message_';
			openModal('app/pages/rations/balanceRation/modals/confirmationDialog.modal.html', 'md');
		}

		function convertToFeedProceed(feed, index) {
			if (vm.edited) {
				vm.modalFeed = feed;
				vm.modalIndex = index;
				vm.modalType = 'convert';
				continueModal = openLoadingModal('app/pages/rations/balanceRation/modals/changeFeeds.modal.html', 'sm', 'redirect_modal');
			} else {
				vm.modalLoading = true;
				var user = {
					user_id: vm.user.email,
					id: vm.ration.ration_header.id
				};
				balanceRationFactory
					.convertToFeed(feed.id, user)
					.then(function () {
						$uibModalStack.dismissAll();
						vm.modalLoading = false;
						vm.selectedList = [];
						getRationById(rationId);
					})
					.catch(function (error) {
						console.log(error);
						vm.modalLoading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_converting_mix_');
					});
			}
		}

		function unmix(feed, index) {
			vm.convert_unmix = angular.copy(feed);
			vm.convert_unmix_index = index;
			vm.warningMessage = '_feeds_unmix_warning_message_';
			openModal('app/pages/rations/balanceRation/modals/confirmationDialog.modal.html', 'md');
		}

		function unmixProceed(feed, index) {
			if (vm.edited) {
				vm.modalFeed = feed;
				vm.modalIndex = index;
				vm.modalType = 'unmix';
				continueModal = openLoadingModal('app/pages/rations/balanceRation/modals/changeFeeds.modal.html', 'sm', 'redirect_modal');
			} else {
				vm.modalLoading = true;
				var feedDTO = angular.copy(feed);
				feedDTO.feed_type = feedDTO.feed_type.name ? feedDTO.feed_type.name : feedDTO.feed_type ? feedDTO.feed_type : i18nFilter('_feeds_type_miscellaneous_');
				for (var i = 0; i < feedDTO.mixes.length; i++) {
					feedDTO.mixes[i].feed_type = feedDTO.mixes[i].feed_type.name ? feedDTO.mixes[i].feed_type.name : feedDTO.mixes[i].feed_type ? feedDTO.mixes[i].feed_type : i18nFilter('_feeds_type_miscellaneous_');
				}
				feedDTO.user_id = vm.user.email;
				balanceRationFactory
					.unmix(feedDTO, rationId)
					.then(function () {
						$uibModalStack.dismissAll();
						vm.modalLoading = false;
						vm.selectedList = [];
						getRationById(rationId);
					})
					.catch(function (error) {
						console.log(error);
						vm.modalLoading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_unmix_');
					});
			}
		}

		function createMIX(page, size) {
			if (checkIsSelected()) {
				var date = new Date();
				vm.mix_name = 'New premix ' + $filter('date')(date, 'yyyy-MM-dd');
				if (vm.edited) {
					vm.modalType = 'createMix';
					openModal('app/pages/rations/balanceRation/modals/changeFeeds.modal.html', 'sm', 'redirect_modal');
				} else {
					vm.listOfFeeds = [];
					var isMix = false;
					for (var i = 0; i < vm.ration.feeds.length; i++) {
						if (vm.ration.feeds[i].is_selected) {
							if (vm.ration.feeds[i].is_mix) {
								isMix = true;
								break;
							}
							var feed = {};
							angular.copy(vm.ration.feeds[i], feed);
							vm.listOfFeeds.push(feed);
						}
					}
					if (isMix) {
						toastr.warning(i18nFilter('_toastr_create_mix_convert_error_message_'), i18nFilter('_toastr_create_mix_convert_error_message_title_'));
					} else {
						openModal(page, size, 'create_mix');
					}
				}
			} else {
				openModal('app/pages/feeds/myfeeds/mix_message.html', 'md');
			}
		}

		function changeShowGraph() {
			vm.showGraph = !vm.showGraph;
			var now = new Date();
			var exp = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
			var value = {
				value: vm.showGraph
			};
			cookiesService.setCookie('show_graph', JSON.stringify(value), {
				samesite: 'strict',
				expires: exp
			});
		}
		function changeAmount(feed) {
			if (timeoutCM) {
				$timeout.cancel(timeoutCM);
			}
			timeoutCM = $timeout(function () {
				feed.as_fed = (feed.amount * 100) / feed.dm;
			}, 100);
		}

		function changeAsFed(feed) {
			if (timeoutCM) {
				$timeout.cancel(timeoutCM);
			}
			timeoutCM = $timeout(function () {
				feed.amount = (feed.as_fed * feed.dm) / 100;
			}, 100);
		}

		function openModal(page, size) {
			$uibModal
				.open({
					animation: true,
					templateUrl: page,
					size: size,
					scope: $scope,
					backdrop: 'static',
					keyboard: false
				})
				.closed.then(function () {
					vm.importList = [];
					vm.importListSafe = [];
				});
		}

		function openFeedsModal(page) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				scope: $scope,
				backdrop: 'static',
				keyboard: false,
				windowClass: 'modal-custom-width'
			});
		}

		function openLoadingModal(page, size) {
			var modal = $uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
			return modal;
		}

		function openReportModal(page, size) {
			$uibModal
				.open({
					animation: true,
					templateUrl: page,
					size: size,
					scope: $scope
				})
				.closed.then(function () {
					vm.importList = [];
					vm.importListSafe = [];
				});
		}

		function openOrderModal(page, size) {
			vm.rationOrderedList = angular.copy($filter('orderBy')(vm.ration.feeds, 'position'));
			vm.rationOrderedListSafe = vm.rationOrderedList;
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function move(feed, direction) {
			var index = 0;
			for (var i = 0; i < vm.rationOrderedList.length; i++) {
				if (vm.rationOrderedList[i].id === feed.id) {
					index = i;
					break;
				}
			}
			if (direction == 'up') {
				vm.rationOrderedList[index].position--;
				vm.rationOrderedList[index - 1].position++;
			} else {
				vm.rationOrderedList[index].position++;
				vm.rationOrderedList[index + 1].position--;
			}
			vm.rationOrderedList = $filter('orderBy')(vm.rationOrderedList, 'position');
		}

		function updateOrder() {
			vm.ration.feeds = $filter('orderBy')(vm.rationOrderedList, 'position');
			vm.feedsSafe = vm.ration.feeds;
			closeModal();
		}

		function saveMIX() {
			vm.modalLoading = true;
			var feeds = [];
			angular.copy(vm.listOfFeeds, feeds);
			for (var i = 0; i < feeds.length; i++) {
				feeds[i].feed_type = feeds[i].feed_type.name;
				feeds[i].user_id = vm.user.email;
			}
			var suffix = '?feedName=' + encodeURIComponent(vm.mix_name);
			if (vm.settings.selectedHerd && vm.settings.selectedHerd.id) {
				suffix = suffix + '&herdId=' + vm.settings.selectedHerd.id;
			}
			if (vm.defaultCalculation != null || vm.defaultCalculation != undefined) {
				if (vm.defaultCalculation.calc_type == 2) {
					suffix = suffix + '&localType=' + vm.settings.calculation_type;
				} else {
					suffix = suffix + '&localType=' + vm.defaultCalculation.calc_type;
				}
			}
			return balanceRationFactory
				.createMIX(rationId, feeds, suffix)
				.then(function () {
					toastr.success(i18nFilter('_toastr_create_mix_success_message_'), i18nFilter('_toastr_success_title_'));
					vm.listOfFeeds = [];
					vm.selectedList = [];
					$uibModalStack.dismissAll();
					vm.modalLoading = false;
					getRationById(rationId);
				})
				.catch(function (error) {
					vm.modalLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_creating_mix_');
					console.log(error);
				});
		}

		function cancel(type) {
			vm.modalOpened = false;
			if (type == 'create_mix') {
				for (var i = 0; i < vm.listOfFeeds.length; i++) {
					vm.listOfFeeds[i].amount = null;
				}
			} else if (type == 'change_feed_modal') {
				if (vm.modalType == 'changeUnits') {
					vm.sliderUsePercent = !vm.sliderUsePercent;
				}
			} else if (type == 'insert_feed') {
				vm.insertMix = false;
			}
			vm.modalType = null;
			$uibModalStack.dismissAll();
			vm.toRationHistory = false;
			vm.toFeedHistory = false;
		}

		function editGroup() {
			$state.go('groups.editGroup', {
				uuid: vm.ration.group.id
			})
		}

		// insert feeds modal//
		function insertFeed(page, size) {
			vm.searchMaster = '';
			vm.importList = [];
			vm.importListSafe = [];
			if (vm.edited) {
				vm.modalType = 'insertFeed';
				openModal('app/pages/rations/balanceRation/modals/changeFeeds.modal.html', 'sm', 'redirect_modal');
			} else {
				vm.modalLoading = true;
				vm.sortedColumn = 'feed_name';
				vm.order = 'ASC';
				vm.sort_col = 'feed_name_ASC';
				vm.currentPageMaster = 1;
				vm.searchMaster = '';
				vm.disableScroll = true;
				vm.feedsByTeam = [];
				getFeedsForRation(page, size);
			}
		}

		function setFeedFilter() {
			vm.filterTypes = [
				{
					name: '_feed_filter_my_feeds_',
					value: 'my_feeds'
				},
				{
					name: '_feed_filter_master_feeds_',
					value: 'master_feeds'
				}
			];
			vm.selectedFeedType = {
				name: '_feed_filter_master_feeds_',
				value: 'master_feeds'
			};
		}

		function setCommonFeedFilter() {
			vm.commonFeedList = [
				{
					name: i18nFilter('_feeds_type_all_'),
					value: null
				},
				{
					name: vm.commonYes,
					value: true
				},
				{
					name: vm.commonNo,
					value: false
				}
			];
			vm.commonFeedItem = vm.commonFeedList[0];
		}

		function commonFeedChanged(type) {
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feedsByTeam = [];
			if (type == 'ration') {
				getFeedsForRation('app/pages/rations/balanceRation/modals/insertFeed.modal.html', 'lg');
			} else {
				getFeedsForMix();
			}
		}

		function setFeedTypesFilter() {
			if (vm.defaultCalculation.calc_type == 1) {
				vm.feedCategotyList = APP_CONST.constants.feed_vem_types;
			} else {
				vm.feedCategotyList = APP_CONST.constants.feed_us_types;
			}
			vm.feedCategotyItem = vm.feedCategotyList[0];
		}

		function feedTypeChanged(type) {
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feedsByTeam = [];
			if (type == 'ration') {
				getFeedsForRation('app/pages/rations/balanceRation/modals/insertFeed.modal.html', 'lg');
			} else {
				getFeedsForMix();
			}
		}

		function sort(column, type) {
			var col;
			if (column != vm.sortedColumn) {
				vm.sortedColumn = column;
				vm.order = 'ASC';
				col = column + '_' + vm.order;
			} else {
				if (vm.order == 'ASC') {
					vm.order = 'DESC';
					col = column + '_' + vm.order;
				} else if (vm.order == 'DESC') {
					vm.order = 'ASC';
					col = column + '_' + vm.order;
				}
			}
			vm.sort_col = col;
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feedsByTeam = [];
			if (type == 'ration') {
				getFeedsForRation('app/pages/rations/balanceRation/modals/insertFeed.modal.html', 'lg');
			} else {
				getFeedsForMix();
			}
		}

		function defaultCalculationChanged(type) {
			setFeedTypesFilter();
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feedsByTeam = [];
			if (type == 'ration') {
				getFeedsForRation('app/pages/rations/balanceRation/modals/insertFeed.modal.html', 'lg');
			} else {
				getFeedsForMix();
			}
		}

		function feedTypeSelected(type) {
			vm.currentPageMaster = 1;
			vm.disableScroll = true;
			vm.feedsByTeam = [];
			if (type == 'ration') {
				getFeedsForRation('app/pages/rations/balanceRation/modals/insertFeed.modal.html', 'lg');
			} else {
				getFeedsForMix();
			}
		}

		function getFeedsForRation(page) {
			if (!vm.modalOpened) {
				openFeedsModal(page);
				vm.modalOpened = true;
			}
			if (vm.settings.selectedTeam && vm.settings.selectedTeam.id) {
				vm.selectedTeam = vm.settings.selectedTeam.id;
				var suffix;
				if (vm.settings.selectedHerd && vm.settings.selectedHerd.id) {
					suffix = '?teamId=' + vm.selectedTeam + '&herdId=' + vm.settings.selectedHerd.id;
				} else {
					suffix = '?teamId=' + vm.selectedTeam;
				}
				if (vm.defaultCalculation != null || vm.defaultCalculation != undefined) {
					suffix = suffix + '&localType=' + vm.defaultCalculation.calc_type;
				}
				if (vm.currentPageMaster) {
					suffix = suffix + '&page=' + vm.currentPageMaster;
				}
				if (vm.searchMaster) {
					suffix = suffix + '&feedName=' + encodeURIComponent(vm.searchMaster);
				}
				if (vm.selectedFeedType) {
					suffix = suffix + '&returnType=' + vm.selectedFeedType.value;
				}
				if (vm.commonFeedItem && vm.commonFeedItem.value != null) {
					suffix = suffix + '&commonFeed=' + vm.commonFeedItem.value;
				}
				if (vm.feedCategotyItem && vm.feedCategotyItem.value) {
					suffix = suffix + '&feedType=' + vm.feedCategotyItem.value;
				}
				if (vm.sortedColumn && vm.order) {
					suffix = suffix + '&orderBy=' + vm.sortedColumn + '&orderType=' + vm.order;
				}
				if (!vm.isPage) {
					vm.feedsLoaded = false;
				}
				vm.isPage = false;
				cancelApiRequest();
				return balanceRationFactory
					.getFeedsByTeamId(suffix)
					.then(function (response) {
						if (response.length > 0) {
							vm.totalItemsMaster = response[0].number_of_all;
							for (var i = response.length - 1; i >= 0; i--) {
								for (var j = 0; j < vm.importList.length; j++) {
									if (response[i].id == vm.importList[j].id) {
										response.splice(i, 1);
										break;
									}
								}
							}
							vm.feedsByTeam = vm.feedsByTeam.concat(response);
							var orderBool;
							if (vm.order == 'ASC') {
								orderBool = false;
							} else {
								orderBool = true;
							}
							vm.feedsByTeam = $filter('orderBy')(vm.feedsByTeam, vm.sortedColumn, orderBool);
						} else {
							vm.totalItemsMaster = 0;
						}
						vm.modalLoading = false;
						vm.feedsLoaded = true;
						vm.disableScroll = false;
						$timeout(function () {
							var searchInput = document.getElementById('feedsSearchInput');
							if (searchInput) {
								searchInput.focus();
							}
						}, 50);
					})
					.catch(function (error) {
						if (error != 'Canceled') {
							console.log(error);
							vm.modalLoading = false;
							vm.feedsLoaded = true;
							vm.disableScroll = false;
							errorService.showErrorMessage(error, true, '_error_occurred_loading_feeds_');
						}
					});
			} else {
				vm.selectedTeam = null;
				vm.modalLoading = false;
			}
		}

		function cancelApiRequest() {
			angular.forEach($http.pendingRequests, function (req) {
				if (req.url.split('?')[0] == APP_CONST.api_base_url + 'feeds' && req.method == 'GET') {
					balanceRationFactory.cancelRequest();
				}
			});
		}

		function addAll(type) {
			var mList = [];
			angular.copy(vm.feedsByTeam, mList);
			for (var i = 0; i < mList.length; i++) {
				vm.importList.push(mList[i]);
			}
			vm.feedsByTeam = [];
			vm.importListSafe = vm.importList;
			vm.currentPageMaster++;
			vm.disableScroll = true;
			if (type == 'mix') {
				getFeedsForMix(vm.selectedTeam);
			} else {
				getFeedsForRation(vm.selectedTeam);
			}
		}

		function removeAll() {
			for (var i = 0; i < vm.importList.length; i++) {
				vm.feedsByTeam.push(vm.importList[i]);
			}
			vm.importList = [];
			var orderBool;
			if (vm.order == 'ASC') {
				orderBool = false;
			} else {
				orderBool = true;
			}
			vm.feedsByTeam = $filter('orderBy')(vm.feedsByTeam, vm.sortedColumn, orderBool);
		}

		function addSelected(id, type) {
			var feedFound = false;
			var selList = [];
			for (var i = 0; i < vm.feedsByTeam.length; i++) {
				if (vm.feedsByTeam[i].id == id) {
					if (vm.importList.length > 0) {
						for (var j = 0; j < vm.importList.length; j++) {
							if (vm.feedsByTeam[i].id == vm.importList[j].id) {
								feedFound = true;
								break;
							}
						}
					}
					if (!feedFound) {
						selList.push(vm.feedsByTeam[i]);
						vm.feedsByTeam.splice(i, 1);
					}
				}
				feedFound = false;
			}
			var li = [];
			angular.copy(selList, li);
			for (var i = 0; i < li.length; i++) {
				vm.importList.push(li[i]);
			}
			if (vm.feedsByTeam.length == 0) {
				vm.currentPageMaster++;
				vm.disableScroll = true;
				if (type == 'mix') {
					getFeedsForMix(vm.selectedTeam);
				} else {
					getFeedsForRation(vm.selectedTeam);
				}
			}
			vm.importListSafe = vm.importList;
		}

		function removeSelected(id) {
			for (var i = vm.importList.length - 1; i >= 0; i--) {
				if (vm.importList[i].id == id) {
					vm.feedsByTeam.unshift(vm.importList.splice(i, 1)[0]);
				}
			}
			var orderBool;
			if (vm.order == 'ASC') {
				orderBool = false;
			} else {
				orderBool = true;
			}
			vm.feedsByTeam = $filter('orderBy')(vm.feedsByTeam, vm.sortedColumn, orderBool);
			vm.importListSafe = vm.importList;
		}

		function insertFeeds() {
			if (vm.importList.length > 0) {
				vm.modalOpened = false;
				if (vm.insertMix) {
					vm.modalLoading = true;
					for (var i = 0; i < vm.importList.length; i++) {
						vm.importList[i].amount = 0;
						vm.importList[i].user_id = vm.user.email;
						if (vm.importList[i].mixes && vm.importList[i].mixes.length > 0) {
							for (var k = 0; k < vm.importList[i].mixes.length; k++) {
								vm.importList[i].mixes[k].amount = 0;
							}
						}
					}
					if (vm.defaultCalculation != null || vm.defaultCalculation != undefined) {
						if (vm.defaultCalculation.calc_type == 2) {
							var suffix = '?localType=' + vm.settings.calculation_type;
						} else {
							var suffix = '?localType=' + vm.defaultCalculation.calc_type;
						}
					}
					balanceRationFactory
						.insertFeedToMix(rationId, vm.mix.id, vm.importList, suffix)
						.then(function () {
							$uibModalStack.dismissAll();
							vm.modalLoading = false;
							vm.insertMix = false;
							vm.selectedList = [];
							getRationById(vm.ration.ration_header_id);
						})
						.catch(function (error) {
							console.log(error);
							vm.modalLoading = false;
							errorService.showErrorMessage(error, true, '_error_occurred_feed_to_mix_');
						});
				} else {
					vm.modalLoading = true;
					for (var i = 0; i < vm.importList.length; i++) {
						vm.importList[i].team_id = vm.ration.ration_header.team_id;
						vm.importList[i].user_id = vm.user.email;
						if (vm.importList[i].mixes && vm.importList[i].mixes.length > 0) {
							var amount = 0;
							for (var k = 0; k < vm.importList[i].mixes.length; k++) {
								amount = amount + vm.importList[i].mixes[k].amount;
							}
							vm.importList[i].amount_dm = amount;
						}
					}
					if (vm.defaultCalculation != null || vm.defaultCalculation != undefined) {
						if (vm.defaultCalculation.calc_type == 2) {
							var suffix = '?localType=' + vm.settings.calculation_type;
						} else {
							var suffix = '?localType=' + vm.defaultCalculation.calc_type;
						}
					}
					return balanceRationFactory
						.insertFeeds(vm.importList, vm.ration.ration_header_id, suffix)
						.then(function () {
							vm.modalLoading = false;
							vm.listOfFeeds = [];
							vm.selectedList = [];
							getRationById(vm.ration.ration_header_id);
							$uibModalStack.dismissAll();
						})
						.catch(function (error) {
							vm.modalLoading = false;
							console.log(error);
							errorService.showErrorMessage(error, true, '_error_occurred_adding_feed_to_ration_');
						});
				}
			} else {
				toastr.warning(i18nFilter('_warning_select_feeds_for_ration_'), i18nFilter('_title_warning_'));
			}
		}

		// stage breed modal //
		function openStageBreed(page, size) {
			vm.breeds = APP_CONST.mocks.breeds;
			vm.animal_types = APP_CONST.mocks.animal_types;
			for (var i = 0; i < vm.breeds.length; i++) {
				if (vm.ration.group.breed == vm.breeds[i].value) {
					vm.modal.breed = vm.breeds[i];
					break;
				}
			}
			for (var i = 0; i < vm.animal_types.length; i++) {
				if (vm.ration.group.type == vm.animal_types[i].type) {
					vm.modal.animal_type = vm.animal_types[i];
					break;
				}
			}
			openModal(page, size, 'animal_stage_breed');
		}

		function saveAnimalStageBreed() {
			vm.ration.group.breed = vm.modal.breed;
			vm.ration.group.animal_type = vm.modal.animal_type;
			vm.modalLoading = true;
			closeModal();
		}

		function closeModal() {
			$uibModalStack.dismissAll();
			vm.modalLoading = false;
		}

		// animal description modal//
		function openAnimalDesc(page, size) {
			vm.selectedAnimalType = APP_CONST.mocks.groups[0].animal_type.type;
			vm.group = JSON.parse(JSON.stringify(vm.ration.group));
			openModal(page, size, 'animal_description');
		}

		function saveAnimalDescription() {
			if (!vm.animalInfoForm.$invalid) {
				vm.ration.group = vm.group;
				vm.group = {};
				vm.modalLoading = true;
				closeModal();
			}
		}

		// animal gain and pregnancy //
		function openAnimalGainPregnancy(page, size) {
			vm.group = JSON.parse(JSON.stringify(vm.ration.group));
			openModal(page, size, 'animal_gain_pregnancy');
		}

		function saveAnimalGainPregnancy() {
			if (!vm.bwGain.$invalid) {
				vm.ration.group = vm.group;
				vm.group = {};
				vm.modalLoading = true;
				closeModal();
			}
		}

		//change group
		function openChangeGroup(page, size, reload) {
			vm.changeGroupModalLoading = true;
			vm.selectedGroupGroupChange = null;
			openModal(page, size, 'change_group');
			if (!reload) {
				getGroups();
			}
		}

		function getGroups() {
			if (vm.settings.selectedHerd.id) {
				return balanceRationFactory
					.getGroupsByHerd(vm.settings.selectedHerd.id)
					.then(function (response) {
						vm.groupsSelect = response;
						vm.changeGroupModalLoading = false;
					})
					.catch(function (error) {
						console.log(error);
						vm.changeGroupModalLoading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_loading_groups_');
					});
			}
		}

		function changeGroup() {
			if (vm.selectedGroupGroupChange && vm.selectedGroupGroupChange.id) {
				if (vm.edited) {
					vm.modalType = 'change_group';
					openModal('app/pages/rations/balanceRation/modals/changeFeeds.modal.html', 'sm', 'redirect_modal');
				} else {
					vm.changeGroupModalLoading = true;
					if (vm.selectedGroupGroupChange) {
						var user = {
							user_id: vm.user.email
						};
						return balanceRationFactory
							.changeGroupForRation(vm.ration.ration_header.id, vm.selectedGroupGroupChange.id, user)
							.then(function (response) {
								setRation(response);
								closeModal();
							})
							.catch(function (error) {
								vm.changeGroupModalLoading = false;
								console.log(error);
								errorService.showErrorMessage(error, true, '_error_occurred_changing_group_');
							});
					}
				}
			}
		}

		// animal environmental factors //
		function openAnimalEnvironmentalFactors(page, size) {
			vm.modalLoading = true;
			vm.temperatureStresses = APP_CONST.constants.temperature_stresses;
			for (var i = 0; i < vm.temperatureStresses.length; i++) {
				vm.temperatureStresses[i].show_name = i18nFilter(vm.temperatureStresses[i].value);
			}
			vm.activityLevels = APP_CONST.constants.activity_levels;
			for (var i = 0; i < vm.activityLevels.length; i++) {
				vm.activityLevels[i].show_name = i18nFilter(vm.activityLevels[i].value);
			}
			openModal(page, size, 'animal_env_factors');
			for (var i = 0; i < vm.activityLevels.length; i++) {
				if (vm.activityLevels[i].name == vm.ration.ration_header.activity_level) {
					vm.selectedActivityLevel = vm.activityLevels[i];
					break;
				}
			}
			for (var i = 0; i < vm.temperatureStresses.length; i++) {
				if (vm.temperatureStresses[i].name == vm.ration.ration_header.temperature_stress) {
					vm.selectedTemperatureStress = vm.temperatureStresses[i];
					break;
				}
			}
			vm.ts_maint_energy = vm.ration.ration_header.ts_maint_energy;
			vm.ts_dmi = vm.ration.ration_header.ts_dmi;
			vm.al_maint_energy = vm.ration.ration_header.al_maint_energy;
			vm.al_dmi = vm.ration.ration_header.al_dmi;
			var change_to_energy_requirement = vm.ration.ration_header.change_in_energy_reqt;
			var change_to_predicted_dmi = vm.ration.ration_header.change_in_predicted_dmi;
			var change_to_energy_density = vm.ration.ration_header.change_in_energy_density_of_diet;
			change_to_energy_requirement = unitConversionService.convertData(change_to_energy_requirement, ['mcalToMjoule']);
			change_to_predicted_dmi = unitConversionService.convertData(change_to_predicted_dmi, ['kgToLb']);
			change_to_energy_requirement = change_to_energy_requirement.toPrecision(3);
			var change_to_energy_requirement_nod = decimalPlaces(change_to_energy_requirement);
			vm.change_to_energy_requirement = $filter('number')(change_to_energy_requirement, change_to_energy_requirement_nod);
			change_to_predicted_dmi = change_to_predicted_dmi.toPrecision(3);
			var change_to_predicted_dmi_nod = decimalPlaces(change_to_predicted_dmi);
			vm.change_to_predicted_dmi = $filter('number')(change_to_predicted_dmi, change_to_predicted_dmi_nod);
			change_to_energy_density = change_to_energy_density.toPrecision(3);
			var change_to_energy_density_nod = decimalPlaces(change_to_energy_density);
			vm.change_to_energy_density = $filter('number')(change_to_energy_density, change_to_energy_density_nod);
			vm.modalLoading = false;
		}

		function envChanged(type) {
			if (timeoutEF) {
				$timeout.cancel(timeoutEF);
			}
			timeoutEF = $timeout(function () {
				if (!vm.animalEnv.$invalid) {
					var temp = {};
					angular.copy(vm.ration.ration_header, temp);
					temp.activity_level = vm.selectedActivityLevel.name;
					temp.temperature_stress = vm.selectedTemperatureStress.name;
					temp.al_dmi = vm.al_dmi;
					temp.ts_dmi = vm.ts_dmi;
					temp.ts_maint_energy = vm.ts_maint_energy;
					temp.al_maint_energy = vm.al_maint_energy;
					temp.maint_reqt = vm.ration.ration_header.maint_reqt;
					temp.dmi_factor = vm.ration.ration_header.dmi_factor;
					getEnvironmentalCalculations(temp);
				}
			}, 1300);
		}

		function saveAnimalEnvironmental() {
			if (!vm.animalEnv.$invalid) {
				var temp = {};
				vm.modalLoading = true;
				angular.copy(vm.ration.ration_header, temp);
				temp.activity_level = vm.selectedActivityLevel.name;
				temp.temperature_stress = vm.selectedTemperatureStress.name;
				temp.al_dmi = vm.al_dmi;
				temp.ts_dmi = vm.ts_dmi;
				temp.ts_maint_energy = vm.ts_maint_energy;
				temp.al_maint_energy = vm.al_maint_energy;
				temp.dmi_factor = vm.ration.ration_header.dmi_factor;
				var dto = {
					nutrient_balance_settings: vm.ration.nutrient_balance_settings,
					group: vm.ration.group,
					ration_header: temp
				};
				return balanceRationFactory
					.editRation(rationId, dto)
					.then(function (response) {
						closeModal();
						setRation(response);
						if (!vm.edited) {
							vm.edited = true;
							localStorage.setItem('dirty', true);
						}
						vm.modalLoading = false;
					})
					.catch(function (error) {
						vm.modalLoading = false;
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_saving_env_');
					});
			}
		}

		function tempStressSelected() {
			var temp = {};
			vm.ts_maint_energy = vm.selectedTemperatureStress.ts_maint_energy;
			vm.ts_dmi = vm.selectedTemperatureStress.ts_dmi;
			angular.copy(vm.ration.ration_header, temp);
			temp.activity_level = vm.selectedActivityLevel.name;
			temp.temperature_stress = vm.selectedTemperatureStress.name;
			temp.al_dmi = vm.al_dmi;
			temp.ts_dmi = vm.ts_dmi;
			temp.ts_maint_energy = vm.ts_maint_energy;
			temp.al_maint_energy = vm.al_maint_energy;
			temp.maint_reqt = vm.ration.ration_header.maint_reqt;
			temp.dmi_factor = vm.ration.ration_header.dmi_factor;
			if (timeoutEF) {
				$timeout.cancel(timeoutEF);
			}
			timeoutEF = $timeout(function () {
				getEnvironmentalCalculations(temp);
			}, 750);
		}

		function activityLevelSelected() {
			var temp = {};
			vm.al_dmi = vm.selectedActivityLevel.al_dmi;
			vm.al_maint_energy = vm.selectedActivityLevel.al_maint_energy;
			angular.copy(vm.ration.ration_header, temp);
			temp.activity_level = vm.selectedActivityLevel.name;
			temp.temperature_stress = vm.selectedTemperatureStress.name;
			temp.al_dmi = vm.al_dmi;
			temp.ts_dmi = vm.ts_dmi;
			temp.ts_maint_energy = vm.ts_maint_energy;
			temp.al_maint_energy = vm.al_maint_energy;
			temp.maint_reqt = vm.ration.ration_header.maint_reqt;
			temp.dmi_factor = vm.ration.ration_header.dmi_factor;
			if (timeoutEF) {
				$timeout.cancel(timeoutEF);
			}
			timeoutEF = $timeout(function () {
				getEnvironmentalCalculations(temp);
			}, 750);
		}

		function getEnvironmentalCalculations(env) {
			var dto = {
				nutrient_balance_settings: vm.ration.nutrient_balance_settings,
				group: vm.ration.group,
				ration_header: env
			};
			vm.loadingEnv = true;
			return balanceRationFactory
				.editRation(rationId, dto)
				.then(function (response) {
					var change_to_energy_requirement = response.ration_header.change_in_energy_reqt;
					var change_to_predicted_dmi = response.ration_header.change_in_predicted_dmi;
					var change_to_energy_density = response.ration_header.change_in_energy_density_of_diet;
					change_to_energy_requirement = unitConversionService.convertData(change_to_energy_requirement, ['mcalToMjoule']);
					change_to_energy_requirement = unitConversionService.convertData(change_to_energy_requirement, ['kgToLb']);
					change_to_energy_requirement = change_to_energy_requirement.toPrecision(3);
					var change_to_energy_requirement_nod = decimalPlaces(change_to_energy_requirement);
					vm.change_to_energy_requirement = $filter('number')(change_to_energy_requirement, change_to_energy_requirement_nod);
					change_to_predicted_dmi = change_to_predicted_dmi.toPrecision(3);
					var change_to_predicted_dmi_nod = decimalPlaces(change_to_predicted_dmi);
					vm.change_to_predicted_dmi = $filter('number')(change_to_predicted_dmi, change_to_predicted_dmi_nod);
					change_to_energy_density = change_to_energy_density.toPrecision(3);
					var change_to_energy_density_nod = decimalPlaces(change_to_energy_density);
					vm.change_to_energy_density = $filter('number')(change_to_energy_density, change_to_energy_density_nod);
					if (!vm.edited) {
						vm.edited = true;
						localStorage.setItem('dirty', true);
					}
					vm.loadingEnv = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loadingEnv = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_env_');
				});
		}

		// animal feed additives module //
		function openAnimalFeedAdditives(page, size) {
			vm.modalLoading = true;
			openModal(page, size, 'animal_feed_additives');
			vm.feed_additives = APP_CONST.constants.feed_additives;
			for (var i = 0; i < vm.feed_additives.length; i++) {
				vm.feed_additives[i].show_name = i18nFilter(vm.feed_additives[i].value);
			}
			for (var i = 0; i < vm.feed_additives.length; i++) {
				if (vm.feed_additives[i].name == vm.ration.ration_header.description) {
					vm.selectedFeedAdditives = vm.feed_additives[i];
					vm.selectedFeedAdditives.show_name = i18nFilter(vm.selectedFeedAdditives.value);
					break;
				}
			}
			if (vm.selectedFeedAdditives.value == '_fa_ionophore_') {
				vm.is_legal = true;
			}
			vm.energetic_efficiency = vm.ration.ration_header.energetic_efficiency;
			vm.mic_protein_efficiency = vm.ration.ration_header.mic_protein_efficiency;
			vm.rup_efficiency = vm.ration.ration_header.rup_efficiency;
			vm.dmi_factor = vm.ration.ration_header.dmi_factor;
			vm.maint_reqt = vm.ration.ration_header.maint_reqt;
			vm.modalLoading = false;
		}

		function saveAnimalFeedAdditives() {
			if (!vm.feedAdditives.$invalid) {
				vm.modalLoading = true;
				var feed_additives = {};
				angular.copy(vm.ration.ration_header, feed_additives);
				feed_additives.dirty = true;
				feed_additives.energetic_efficiency = vm.energetic_efficiency;
				feed_additives.mic_protein_efficiency = vm.mic_protein_efficiency;
				feed_additives.rup_efficiency = vm.rup_efficiency;
				feed_additives.dmi_factor = vm.dmi_factor;
				feed_additives.maint_reqt = vm.maint_reqt;
				feed_additives.description = vm.selectedFeedAdditives.name;
				var dto = {
					nutrient_balance_settings: vm.ration.nutrient_balance_settings,
					group: vm.ration.group,
					ration_header: feed_additives
				};
				return balanceRationFactory
					.editRation(rationId, dto)
					.then(function (response) {
						closeModal();
						setRation(response);
						vm.modalLoading = false;
						if (!vm.edited) {
							vm.edited = true;
							localStorage.setItem('dirty', true);
						}
					})
					.catch(function (error) {
						console.log(error);
						vm.modalLoading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_saving_aditives_');
					});
			}
		}

		function feedAdditiveSelected() {
			vm.energetic_efficiency = vm.selectedFeedAdditives.energetic_efficiency;
			vm.mic_protein_efficiency = vm.selectedFeedAdditives.mic_protein_efficiency;
			vm.rup_efficiency = vm.selectedFeedAdditives.rup_efficiency;
			vm.dmi_factor = vm.selectedFeedAdditives.dmi_factor;
			vm.maint_reqt = vm.selectedFeedAdditives.maint_reqt;
		}

		// ration group informations modal //
		function openRationGroupInfo(page, size) {
			vm.modalGI = {
				number_of_animals: vm.ration.group.number_of_animals,
				ration_name: vm.ration.ration_header.ration_name
			};
			openModal(page, size, 'ration_group_info');
		}

		function saveRationGeneralInfo() {
			vm.modalRNLoading = false;
			vm.modalNALoading = false;
			var all = [];
			if (!vm.groupInfo.$invalid) {
				if (vm.modalGI.number_of_animals != vm.ration.group.number_of_animals) {
					var number_of_animals_objest = {
						id: vm.ration.group.id,
						number_of_animals: vm.modalGI.number_of_animals
					};
					var a = setNumberOfAnimals(number_of_animals_objest);
					all.push(a);
				}
				if (vm.modalGI.ration_name != vm.ration.ration_header.ration_name) {
					var ration_name_object = {
						id: rationId,
						ration_name: vm.modalGI.ration_name,
						user_id: vm.user.email
					};
					var b = setRationName(ration_name_object);
					all.push(b);
				}
				$q.all(all).then(function () {
					closeModal();
				});
			}
		}

		function setRationName(name) {
			vm.modalRNLoading = true;
			return balanceRationFactory
				.changeRationName(name)
				.then(function () {
					vm.ration.ration_header.ration_name = name.ration_name;
					vm.modalRNLoading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.modalRNLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_changing_ration_name_');
					return $q.reject();
				});
		}

		function setNumberOfAnimals(numberOfAnimals) {
			vm.modalNALoading = true;
			return balanceRationFactory
				.changeNumberOfAnimals(numberOfAnimals)
				.then(function () {
					vm.ration.group.number_of_animals = numberOfAnimals.number_of_animals;
					vm.modalNALoading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.modalNALoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_changing_number_animals_');
					return $q.reject();
				});
		}

		// ration metabolizable protein system modal//
		function openRationMetProtSys(page, size) {
			vm.modalLoading = true;
			vm.metProtSystems = APP_CONST.constants.met_prot_sys;
			vm.disableMPSInput = false;
			for (var i = 0; i < vm.metProtSystems.length; i++) {
				var tString = vm.metProtSystems[i].name;
				vm.metProtSystems[i].show_name = i18nFilter(tString);
			}
			for (var i = 0; i < vm.metProtSystems.length; i++) {
				if (vm.metProtSystems[i].value == vm.ration.ration_header.model_name) {
					vm.selectedMPS = vm.metProtSystems[i];
					break;
				}
			}
			vm.energy_potential = vm.ration.ration_header.energy_potential;
			vm.nitrogen_potential = vm.ration.ration_header.nitrogen_potential;
			configureMPS(vm.selectedMPS);
			vm.modalLoading = false;
			openModal(page, size, 'ration_met_p_sys');
		}

		function configureMPS(selected) {
			if (selected.name == '_mps_spartan_3_defaults_') {
				vm.minEP = 0.1;
				vm.maxEP = 0.18;
				vm.minNP = 0.65;
				vm.maxNP = 0.85;
				vm.disableMPSInput = true;
			} else if (selected.name == '_mps_spartan_3_') {
				vm.minEP = 0.1;
				vm.maxEP = 0.18;
				vm.minNP = 0.65;
				vm.maxNP = 0.85;
				vm.disableMPSInput = false;
			} else if (selected.name == '_mps_rdom_') {
				vm.minEP = 24;
				vm.maxEP = 36;
				vm.minNP = 0.8;
				vm.maxNP = 1;
				vm.disableMPSInput = false;
			}
		}

		function mpsSelected() {
			configureMPS(vm.selectedMPS);
			vm.energy_potential = vm.selectedMPS.energy_potential;
			vm.nitrogen_potential = vm.selectedMPS.nitrogen_potential;
		}

		function saveRationMPS() {
			if (!vm.mps.$invalid) {
				var temp = {};
				angular.copy(vm.ration.ration_header, temp);
				temp.dirty = true;
				temp.model_name = vm.selectedMPS.value;
				temp.nitrogen_potential = vm.nitrogen_potential;
				temp.energy_potential = vm.energy_potential;
				vm.modalLoading = true;
				var dto = {
					nutrient_balance_settings: vm.ration.nutrient_balance_settings,
					group: vm.ration.group,
					ration_header: temp
				};
				balanceRationFactory
					.editRation(rationId, dto)
					.then(function (response) {
						closeModal();
						setRation(response);
						$timeout(function () {
							vm.modalLoading = false;
						}, 200);
						if (!vm.edited) {
							vm.edited = true;
							localStorage.setItem('dirty', true);
						}
					})
					.catch(function (error) {
						console.log(error);
						vm.modalLoading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_saving_mps_');
					});
			}
		}

		// ration ratios relationships modal//
		function openRationRatiosRelationships(page, size) {
			getRatiosRelationships();
			openModal(page, size, 'ration_ratios_relationships_');
		}

		function getRatiosRelationships() {
			vm.modalLoading = true;
			var RR = vm.ration.rations_and_relationships;
			if (!vm.settings.use_kgs) {
				RR = RRToLb(RR);
			}
			if (!vm.settings.use_mcal) {
				RR = RRToMjoule(RR);
			}
			RR = setSignificant(RR);
			vm.r_r = RR;
			vm.modalLoading = false;
		}

		function RRToMjoule(RR) {
			var con = 4.1868;
			RR.target_body_energy_balance = RR.target_body_energy_balance * con;
			RR.feed_cost_me3x = RR.feed_cost_me3x / con;
			RR.cp_me3x = RR.cp_me3x / con;
			RR.mp_me = RR.mp_me / con;
			return RR;
		}

		function RRToLb(RR) {
			var con = 2.2046;
			RR.actual_dmi = RR.actual_dmi * con;
			RR.nrc01_predicted_dmi = RR.nrc01_predicted_dmi * con;
			RR.energycorrected_milk = RR.energycorrected_milk * con;
			RR.energyallowable_milk = RR.energyallowable_milk * con;
			RR.proteinallowable_milk = RR.proteinallowable_milk * con;
			RR.vem_allowable_milk = RR.vem_allowable_milk * con;
			RR.dve_allowable_milk = RR.dve_allowable_milk * con;
			RR.energyallowable_gain = RR.energyallowable_gain * con;
			RR.proteinallowable_gain = RR.proteinallowable_gain * con;
			RR.energyallowable_bc_gain = RR.energyallowable_bc_gain * con;
			RR.proteinallowable_bc_gain = RR.proteinallowable_bc_gain * con;
			RR.feed_cost_100_wt_milk = RR.feed_cost_100_wt_milk / con;
			RR.predicted_fecal_dm = RR.predicted_fecal_dm * con;
			RR.total_n_excreted = RR.total_n_excreted * con;
			RR.fecal_n = RR.fecal_n * con;
			RR.urinary_n = RR.urinary_n * con;
			RR.p_excreted = RR.p_excreted * con;
			RR.p_excreted_as_p205 = RR.p_excreted_as_p205 * con;
			RR.k_excreted_as_k2O = RR.k_excreted_as_k2O * con;
			return RR;
		}

		function setSignificant(obj) {
			Object.keys(obj).forEach(function (key) {
				if (key != 'amount_dm' && key != 'as_fed') {
					var temp = obj[key];
					temp = Number(temp);
					if (temp && !isNaN(temp)) {
						var param = temp.toPrecision(3);
						obj[key] = Number(param);
					}
				}
			});
			return obj;
		}

		// settings genral settings modal //
		function openSettingsGeneral(page, size) {
			vm.modalSettings = {};
			angular.copy(vm.settings, vm.modalSettings);
			openModal(page, size, 'settings_general');
		}

		function saveSettingsGeneral() {
			if (vm.edited) {
				vm.modalType = 'settingsGeneral';
				openModal('app/pages/rations/balanceRation/modals/changeFeeds.modal.html', 'sm', 'redirect_modal');
			} else {
				vm.modalLoading = true;
				if (vm.settings.use_amount != vm.modalSettings.use_amount || vm.settings.use_kgs != vm.modalSettings.use_kgs || vm.settings.use_mcal != vm.modalSettings.use_mcal) {
					vm.modalSettings.team_id = null;
					vm.modalSettings.herd_id = null;
					return balanceRationFactory
						.changeGeneralSettings(vm.modalSettings)
						.then(function (response) {
							closeModal();
							localStorage.setItem('user_settings', JSON.stringify(response));
							vm.settings = response;
							init();
						})
						.catch(function (error) {
							vm.modalLoading = false;
							errorService.showErrorMessage(error, true, '_error_occurred_saving_general_settings_');
							console.log(error);
						});
				} else {
					closeModal();
				}
			}
		}

		// settings nutrient balance graph //
		function openSettingsNBG(page, size) {
			vm.modalNutrientSettings = {};
			angular.copy(vm.ration.nutrient_balance_settings, vm.modalNutrientSettings);
			openModal(page, size, 'settings_nbg');
		}

		function saveNutrientBalance() {
			if (!angular.equals(JSON.stringify(vm.modalNutrientSettings), JSON.stringify(vm.ration.nutrient_balance_settings))) {
				vm.modalLoading = true;
				return balanceRationFactory
					.changeNutrientBalanceSettings(vm.modalNutrientSettings, rationId)
					.then(function () {
						vm.ration.nutrient_balance_settings = vm.modalNutrientSettings;
						configChart(vm.ration);
						closeModal();
					})
					.catch(function (error) {
						console.log(error);
						vm.modalLoading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_saving_graph_');
					});
			} else {
				closeModal();
			}
		}

		function decimalPlaces(num) {
			var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
			if (!match) {
				return 0;
			}
			return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
		}

		function redirect(state) {
			$state.go(state, {
				uuid: vm.ration.group.id
			});
		}

		function updateFeed(feed, index, data, type, page) {
			var d = $q.defer();
			if (data != undefined || type == 'is_purchased' || type == 'common_feed') {
				if (data != feed[type]) {
					vm.feed_loading = true;
					vm.ration.feeds[index].loading = true;
					var feedTemp = {};
					var rh_index;
					var ration_id = feed.ration_id;
					for (var i = 0; i < vm.ration.ration_header.rations.length; i++) {
						if (feed.ration_id == vm.ration.ration_header.rations[i].id) {
							angular.copy(vm.ration.ration_header.rations[i].feed, feedTemp);
							rh_index = i;
							break;
						}
					}
					var rationHeaderDTO = angular.copy(vm.ration.ration_header);
					if (type == 'as_fed') {
						feedTemp.as_fed = data;
						feedTemp.event = 'manually_changed_as_fed';
					} else if (type == 'feed_name') {
						feedTemp.feed_name = data;
					} else if (type == 'amount') {
						feedTemp.amount = data;
						feedTemp.event = 'manually_changed_amount';
					} else if (type == 'dm') {
						feedTemp.dm = data;
						feedTemp.event = 'manually_changed_dm';
					} else if (type == 'vem') {
						feedTemp.vem = data;
					} else if (type == 'rus') {
						feedTemp.event = 'rus';
						feedTemp.rus = data;
					} else if (type == 'fos') {
						feedTemp.fos = data;
					} else if (type == 'dve') {
						feedTemp.dve = data;
					} else if (type == 'oeb') {
						feedTemp.oeb = data;
					} else if (type == 'ef_ndf_as_ndf') {
						feedTemp.ef_ndf_as_ndf = data;
					} else if (type == 'ef_ndf_as_dm') {
						feedTemp.ef_ndf_as_dm = data;
						feedTemp.event = 'manually_efndf_as_dm';
					} else if (type == 'ndf') {
						feedTemp.ndf = data;
					} else if (type == 'rc') {
						feedTemp.rc = data;
					} else if (type == 'cp') {
						feedTemp.cp = data;
					} else if (type == 'rup_dig') {
						feedTemp.rup_dig = data;
					} else if (type == 'ca') {
						feedTemp.ca = data;
					} else if (type == 'p') {
						feedTemp.p = data;
					} else if (type == 'na') {
						feedTemp.na = data;
					} else if (type == 'se') {
						feedTemp.se = data;
					} else if (type == 'vitamin_e') {
						feedTemp.vitamin_e = data;
					} else if (type == 'test_date') {
						if (data) {
							data.setHours(12);
							feedTemp.test_date = data;
						}
					} else if (type == 'lignin') {
						feedTemp.lignin = data;
					} else if (type == 'ndf_digest') {
						feedTemp.ndf_digest = data;
					} else if (type == 'adf') {
						feedTemp.adf = data;
					} else if (type == 'rd_ndf') {
						feedTemp.rd_ndf = data;
					} else if (type == 'disc_fac') {
						feedTemp.disc_fac = data;
					} else if (type == 'nel_89') {
						feedTemp.nel_89 = data;
					} else if (type == 'me_89') {
						feedTemp.me_89 = data;
					} else if (type == 'b_prot') {
						feedTemp.b_prot = data;
					} else if (type == 'c_prot') {
						feedTemp.c_prot = data;
					} else if (type == 'kd_b_prot') {
						feedTemp.kd_b_prot = data;
					} else if (type == 'npncpe') {
						feedTemp.npncpe = data;
					} else if (type == 'rup_89') {
						feedTemp.rup_89 = data;
					} else if (type == 'ndicp') {
						feedTemp.ndicp = data;
					} else if (type == 'adicp') {
						feedTemp.adicp = data;
					} else if (type == 'nfc_dig') {
						feedTemp.nfc_dig = data;
					} else if (type == 'starch') {
						feedTemp.event = 'starch';
						feedTemp.starch = data;
					} else if (type == 'rd_starch') {
						feedTemp.event = 'rd_starch';
						feedTemp.rd_starch = data;
					} else if (type == 'sugar') {
						feedTemp.sugar = data;
					} else if (type == 'in_fa') {
						feedTemp.in_fa = data;
					} else if (type == 'rd_sol_fiber') {
						feedTemp.rd_sol_fiber = data;
					} else if (type == 'ee') {
						feedTemp.ee = data;
					} else if (type == 'sfa') {
						feedTemp.sfa = data;
						if (feedTemp.sfa + feedTemp.pufa > 100) {
							feedTemp.pufa = 100 - feedTemp.sfa;
						}
					} else if (type == 'pufa') {
						feedTemp.pufa = data;
						if (feedTemp.pufa + feedTemp.sfa > 100) {
							feedTemp.sfa = 100 - feedTemp.pufa;
						}
					} else if (type == 'bhfa') {
						feedTemp.bhfa = data;
					} else if (type == 'fa_dig') {
						feedTemp.fa_dig = data;
					} else if (type == 'ca_abs') {
						feedTemp.ca_abs = data;
					} else if (type == 'p_abs') {
						feedTemp.p_abs = data;
					} else if (type == 'mg') {
						feedTemp.mg = data;
					} else if (type == 'mg_abs') {
						feedTemp.mg_abs = data;
					} else if (type == 'k') {
						feedTemp.k = data;
					} else if (type == 'cl') {
						feedTemp.cl = data;
					} else if (type == 's') {
						feedTemp.s = data;
					} else if (type == 'ash') {
						feedTemp.ash = data;
					} else if (type == 'co') {
						feedTemp.co = data;
					} else if (type == 'cu') {
						feedTemp.cu = data;
					} else if (type == 'cu_abs') {
						feedTemp.cu_abs = data;
					} else if (type == 'fe') {
						feedTemp.fe = data;
					} else if (type == 'fe_abs') {
						feedTemp.fe_abs = data;
					} else if (type == 'i') {
						feedTemp.i = data;
					} else if (type == 'i_abs') {
						feedTemp.i_abs = data;
					} else if (type == 'mo') {
						feedTemp.mo = data;
					} else if (type == 'mn') {
						feedTemp.mn = data;
					} else if (type == 'mn_abs') {
						feedTemp.mn_abs = data;
					} else if (type == 'se_abs') {
						feedTemp.se_abs = data;
					} else if (type == 'zn') {
						feedTemp.zn = data;
					} else if (type == 'zn_abs') {
						feedTemp.zn_abs = data;
					} else if (type == 'vitamin_a') {
						feedTemp.vitamin_a = data;
					} else if (type == 'vitamin_d') {
						feedTemp.vitamin_d = data;
					} else if (type == 'lysine') {
						feedTemp.lysine = data;
					} else if (type == 'methionine') {
						feedTemp.methionine = data;
					} else if (type == 'teaa') {
						feedTemp.teaa = data;
					} else if (type == 'cost_as_sold') {
						feedTemp.cost_as_sold = data;
					} else if (type == 'wt_as_sold') {
						feedTemp.wt_as_sold = data;
					} else if (type == 'is_purchased') {
						feedTemp.is_purchased = !feedTemp.is_purchased;
					} else if (type == 'blank_1') {
						feedTemp.blank_1 = data;
					} else if (type == 'blank_2') {
						feedTemp.blank_2 = data;
					} else if (type == 'blank_3') {
						feedTemp.blank_3 = data;
					} else if (type == 'blank_4') {
						feedTemp.blank_4 = data;
					} else if (type == 'blank_5') {
						feedTemp.blank_5 = data;
					} else if (type == 'common_feed') {
						feedTemp.common_feed = !feedTemp.common_feed;
					} else if (type == 'comments') {
						feedTemp.comments = data;
					} else if (type == 'group_as_fed') {
						feedTemp.group_as_fed = data;
						feedTemp.event = 'manually_changed_group_as_fed';
					} else if (type == 'feed_type') {
						feedTemp.feed_type = data.name;
						feedTemp.feed_category = data.category;
					} else if (type == 'diet_dmi') {
						feedTemp.event = 'manually_changed_amount';
						feedTemp.amount = calculateDmiAmount(rationHeaderDTO.rations, rh_index, data);
					}
					feedTemp.event = feedTemp.event || 'manually_changed_amount';
					rationHeaderDTO.rations[rh_index].amount_dm = feedTemp.amount || null;
					rationHeaderDTO.rations[rh_index].dirty = true;
					rationHeaderDTO.rations[rh_index].feed = feedTemp;
					var ration_DTO = {
						group: vm.ration.group,
						ration_header: rationHeaderDTO,
						nutrient_balance_settings: vm.ration.nutrient_balance_settings
					};
					ration_DTO.ration_header.ration_header_id = vm.ration.ration_header_id;
					vm.feed_selected = feed.is_selected;
					balanceRationFactory
						.editRation(rationId, ration_DTO)
						.then(function (response) {
							// setRation(response, getFeedIndex(vm.ration.feeds, feed.id));
							setRation(response);
							addDirty(ration_id);
							if (!vm.edited) {
								vm.edited = true;
								localStorage.setItem('dirty', true);
							}
							vm.feed_loading = false;
							if (vm.onEnterEvent) {
								$timeout(function () {
									try {
										var tempPage = '';
										var tempIndex = index + 1;
										if (page) {
											tempPage = page;
										}
										if (tempIndex < vm.ration.feeds.length) {
											var elem = document.getElementById(type + tempIndex + tempPage);
											elem.click();
											if (tempIndex > 6) {
												var parent = elem.parentElement;
												parent.scrollIntoView(true);
											}
										}
										vm.onEnterEvent = false;
										d.resolve();
									} catch (error) {
										console.log(error);
									}
								}, 100);
							} else {
								d.resolve();
							}
						})
						.catch(function (error) {
							console.log(error);
							errorService.showErrorMessage(error, true, '_error_occurred_updating_feed_');
							vm.ration.feeds[index].loading = false;
							vm.feed_loading = false;
							d.reject();
						});
				} else {
					if (vm.onEnterEvent) {
						$timeout(function () {
							try {
								var tempPage = '';
								var tempIndex = index + 1;
								if (page) {
									tempPage = page;
								}
								if (tempIndex < vm.ration.feeds.length) {
									var elem = document.getElementById(type + tempIndex + tempPage);
									elem.click();
									if (tempIndex > 6) {
										var parent = elem.parentElement;
										parent.scrollIntoView(true);
									}
								}
								vm.onEnterEvent = false;
								d.resolve();
							} catch (error) {
								console.log(error);
							}
						}, 200);
					} else {
						d.resolve();
					}
				}
			} else {
				d.reject(i18nFilter('_value_not_valid_'));
			}
			return d.promise;
		}

		function calculateDmiAmount(list, index, data, mix) {
			var sum = 0;
			for (var i = 0; i < list.length; i++) {
				if (i != index) {
					if (mix) {
						sum += list[i].amount;
					} else {
						sum += list[i].feed.amount;
					}
				}
			}
			return (sum * 100) / (100 - data) - sum;
		}

		function feedKeyDown(event, data) {
			if (data != undefined) {
				if (event.keyCode == 13) {
					vm.onEnterEvent = true;
				} else if (event.keyCode == 27) {
					vm.onEnterEvent = true;
				}
			}
		}

		function mixKeyDown(event, data) {
			if (data != undefined) {
				if (event.keyCode == 13) {
					vm.onEnterMixEvent = true;
				} else if (event.keyCode == 27) {
					vm.onEnterMixEvent = true;
				}
			}
		}

		document.addEventListener('mousewheel', function (event) {
			if (document && document.activeElement && document.activeElement.type === 'number') {
				document.activeElement.blur();
			}
		});

		function updateFeedMix(feed, index, data, type, page) {
			var d = $q.defer();
			if (data != undefined || type == 'is_purchased' || type == 'common_feed') {
				var feedIndex;
				Object.keys(vm.dataCollapse).forEach(function (key) {
					if (vm.dataCollapse[key] == true) {
						feedIndex = key;
					}
				});
				var mainFeed = vm.ration.feeds[feedIndex];
				if (data != feed[type]) {
					vm.ration.feeds[feedIndex].mixes[index].loading = true;
					vm.mixfeed_loading = true;
					var feedTemp = {};
					var rh_index;
					var ration_id = feed.ration_id;
					for (var i = 0; i < vm.ration.ration_header.rations.length; i++) {
						if (feed.ration_id == vm.ration.ration_header.rations[i].id) {
							angular.copy(vm.ration.ration_header.rations[i].feed.mixes[index], feedTemp);
							rh_index = i;
							break;
						}
					}
					var mixRationHeader = angular.copy(vm.ration.ration_header);
					if (type == 'as_fed') {
						feedTemp.as_fed = data;
						feedTemp.event = 'ingredient_changed_as_fed';
					} else if (type == 'feed_name') {
						feedTemp.feed_name = data;
					} else if (type == 'amount') {
						feedTemp.amount = data;
						feedTemp.event = 'ingredient_changed_amount';
					} else if (type == 'dm') {
						feedTemp.dm = data;
						feedTemp.event = 'ingredient_changed_dm';
					} else if (type == 'ef_ndf_as_ndf') {
						feedTemp.ef_ndf_as_ndf = data;
					} else if (type == 'vem') {
						feedTemp.vem = data;
					} else if (type == 'rus') {
						feedTemp.event = 'ingredient_changed_rus';
						feedTemp.rus = data;
					} else if (type == 'fos') {
						feedTemp.fos = data;
					} else if (type == 'dve') {
						feedTemp.dve = data;
					} else if (type == 'oeb') {
						feedTemp.oeb = data;
					} else if (type == 'ef_ndf_as_dm') {
						feedTemp.event = 'ingredient_changed_efndf_as_dm';
						feedTemp.ef_ndf_as_dm = data;
					} else if (type == 'ndf') {
						feedTemp.ndf = data;
					} else if (type == 'rc') {
						feedTemp.rc = data;
					} else if (type == 'cp') {
						feedTemp.cp = data;
					} else if (type == 'rup_dig') {
						feedTemp.rup_dig = data;
					} else if (type == 'ca') {
						feedTemp.ca = data;
					} else if (type == 'p') {
						feedTemp.p = data;
					} else if (type == 'na') {
						feedTemp.na = data;
					} else if (type == 'se') {
						feedTemp.se = data;
					} else if (type == 'vitamin_e') {
						feedTemp.vitamin_e = data;
					} else if (type == 'test_date') {
						if (data) {
							data.setHours(12);
							feedTemp.test_date = data;
						}
					} else if (type == 'lignin') {
						feedTemp.lignin = data;
					} else if (type == 'ndf_digest') {
						feedTemp.ndf_digest = data;
					} else if (type == 'adf') {
						feedTemp.adf = data;
					} else if (type == 'rd_ndf') {
						feedTemp.rd_ndf = data;
					} else if (type == 'disc_fac') {
						feedTemp.disc_fac = data;
					} else if (type == 'nel_89') {
						feedTemp.nel_89 = data;
					} else if (type == 'me_89') {
						feedTemp.me_89 = data;
					} else if (type == 'b_prot') {
						feedTemp.b_prot = data;
					} else if (type == 'c_prot') {
						feedTemp.c_prot = data;
					} else if (type == 'kd_b_prot') {
						feedTemp.kd_b_prot = data;
					} else if (type == 'npncpe') {
						feedTemp.npncpe = data;
					} else if (type == 'rup_89') {
						feedTemp.rup_89 = data;
					} else if (type == 'ndicp') {
						feedTemp.ndicp = data;
					} else if (type == 'adicp') {
						feedTemp.adicp = data;
					} else if (type == 'nfc_dig') {
						feedTemp.nfc_dig = data;
					} else if (type == 'starch') {
						feedTemp.event = 'ingredient_changed_starch';
						feedTemp.starch = data;
					} else if (type == 'rd_starch') {
						feedTemp.event = 'ingredient_changed_rd_starch';
						feedTemp.rd_starch = data;
					} else if (type == 'sugar') {
						feedTemp.sugar = data;
					} else if (type == 'in_fa') {
						feedTemp.in_fa = data;
					} else if (type == 'rd_sol_fiber') {
						feedTemp.rd_sol_fiber = data;
					} else if (type == 'ee') {
						feedTemp.ee = data;
					} else if (type == 'sfa') {
						feedTemp.sfa = data;
						if (feedTemp.sfa + feedTemp.pufa > 100) {
							feedTemp.pufa = 100 - feedTemp.sfa;
						}
					} else if (type == 'pufa') {
						feedTemp.pufa = data;
						if (feedTemp.pufa + feedTemp.sfa > 100) {
							feedTemp.sfa = 100 - feedTemp.pufa;
						}
					} else if (type == 'bhfa') {
						feedTemp.bhfa = data;
					} else if (type == 'fa_dig') {
						feedTemp.fa_dig = data;
					} else if (type == 'ca_abs') {
						feedTemp.ca_abs = data;
					} else if (type == 'p_abs') {
						feedTemp.p_abs = data;
					} else if (type == 'mg') {
						feedTemp.mg = data;
					} else if (type == 'mg_abs') {
						feedTemp.mg_abs = data;
					} else if (type == 'k') {
						feedTemp.k = data;
					} else if (type == 'cl') {
						feedTemp.cl = data;
					} else if (type == 's') {
						feedTemp.s = data;
					} else if (type == 'ash') {
						feedTemp.ash = data;
					} else if (type == 'co') {
						feedTemp.co = data;
					} else if (type == 'cu') {
						feedTemp.cu = data;
					} else if (type == 'cu_abs') {
						feedTemp.cu_abs = data;
					} else if (type == 'fe') {
						feedTemp.fe = data;
					} else if (type == 'fe_abs') {
						feedTemp.fe_abs = data;
					} else if (type == 'i') {
						feedTemp.i = data;
					} else if (type == 'i_abs') {
						feedTemp.i_abs = data;
					} else if (type == 'mo') {
						feedTemp.mo = data;
					} else if (type == 'mn') {
						feedTemp.mn = data;
					} else if (type == 'mn_abs') {
						feedTemp.mn_abs = data;
					} else if (type == 'se_abs') {
						feedTemp.se_abs = data;
					} else if (type == 'zn') {
						feedTemp.zn = data;
					} else if (type == 'zn_abs') {
						feedTemp.zn_abs = data;
					} else if (type == 'vitamin_a') {
						feedTemp.vitamin_a = data;
					} else if (type == 'vitamin_d') {
						feedTemp.vitamin_d = data;
					} else if (type == 'lysine') {
						feedTemp.lysine = data;
					} else if (type == 'methionine') {
						feedTemp.methionine = data;
					} else if (type == 'teaa') {
						feedTemp.teaa = data;
					} else if (type == 'cost_as_sold') {
						feedTemp.cost_as_sold = data;
					} else if (type == 'wt_as_sold') {
						feedTemp.wt_as_sold = data;
					} else if (type == 'is_purchased') {
						feedTemp.is_purchased = !feedTemp.is_purchased;
					} else if (type == 'blank_1') {
						feedTemp.blank_1 = data;
					} else if (type == 'blank_2') {
						feedTemp.blank_2 = data;
					} else if (type == 'blank_3') {
						feedTemp.blank_3 = data;
					} else if (type == 'blank_4') {
						feedTemp.blank_4 = data;
					} else if (type == 'blank_5') {
						feedTemp.blank_5 = data;
					} else if (type == 'comments') {
						feedTemp.comments = data;
					} else if (type == 'common_feed') {
						feedTemp.common_feed = !feedTemp.common_feed;
					} else if (type == 'group_as_fed') {
						feedTemp.group_as_fed = data;
						feedTemp.event = 'ingredient_changed_group_as_fed';
					} else if (type == 'feed_type') {
						feedTemp.feed_type = data.name;
						feedTemp.feed_category = data.category;
					} else if (type == 'diet_dmi') {
						feedTemp.event = 'ingredient_changed_amount';
						feedTemp.amount = calculateDmiAmount(mixRationHeader.rations[rh_index].feed.mixes, index, data, true);
					}
					feedTemp.event = feedTemp.event || 'ingredient_changed_amount';
					mixRationHeader.rations[rh_index].dirty = true;
					mixRationHeader.rations[rh_index].feed.event = 'ingredient_changed';
					mixRationHeader.rations[rh_index].feed.mixes[index] = feedTemp;
					mixRationHeader.rations[rh_index].feed.mixes[index].dirty = true;
					mixRationHeader.rations[rh_index].amount_dm = mixRationHeader.rations[rh_index].feed.amount;
					var ration_DTO = {
						group: vm.ration.group,
						ration_header: mixRationHeader,
						nutrient_balance_settings: vm.ration.nutrient_balance_settings
					};
					balanceRationFactory
						.editRation(rationId, ration_DTO)
						.then(function (response) {
							// setRation(response, getFeedIndex(vm.ration.feeds, feed.feed_id), index);
							setRation(response);
							addDirty(ration_id);
							addDirtyMix(feedTemp.id);
							if (!vm.edited) {
								vm.edited = true;
								localStorage.setItem('dirty', true);
							}
							vm.mixfeed_loading = false;
							if (vm.onEnterMixEvent) {
								$timeout(function () {
									try {
										var tempPage = '';
										var tempIndex = index + 1;
										if (page) {
											tempPage = page;
										}
										if (tempIndex < mainFeed.mixes.length) {
											var elem = document.getElementById(type + 'MIX' + tempIndex + tempPage + feedIndex);
											elem.click();
											if (tempIndex > 2) {
												var parent = elem.parentElement;
												parent.scrollIntoView(true);
											}
										}
										vm.onEnterMixEvent = false;
										d.resolve();
									} catch (error) {
										console.log(error);
									}
								}, 100);
							} else {
								d.resolve();
							}
						})
						.catch(function (error) {
							errorService.showErrorMessage(error, true, '_error_occurred_updating_feed_');
							vm.ration.feeds[feedIndex].mixes[index].loading = false;
							vm.mixfeed_loading = false;
							d.reject();
						});
				} else {
					if (vm.onEnterMixEvent) {
						$timeout(function () {
							try {
								var tempPage = '';
								var tempIndex = index + 1;
								if (page) {
									tempPage = page;
								}
								if (tempIndex < mainFeed.mixes.length) {
									var elem = document.getElementById(type + 'MIX' + tempIndex + tempPage + feedIndex);
									elem.click();
									if (tempIndex > 2) {
										var parent = elem.parentElement;
										parent.scrollIntoView(true);
									}
								}
								vm.onEnterMixEvent = false;
								d.resolve();
							} catch (error) {
								console.log(error);
							}
						}, 100);
					} else {
						d.resolve();
					}
				}
			} else {
				d.reject(i18nFilter('_value_not_valid_'));
			}
			return d.promise;
		}

		function getFeedIndex(list, id) {
			var feed_id;
			for (var i = 0; i < list.length; i++) {
				if (list[i].id == id) {
					feed_id = i;
					break;
				}
			}
			return feed_id;
		}

		function saveRation() {
			openModal('app/pages/rations/balanceRation/modals/loadingModal.html', 'sm', 'loading_modal');
			$timeout(function () {
				var saveRationDTO = angular.copy(vm.ration.ration_header);
				for (var i = 0; i < saveRationDTO.rations.length; i++) {
					for (var j = 0; j < vm.dirtyList.length; j++) {
						if (saveRationDTO.rations[i].id == vm.dirtyList[j].feed_id) {
							saveRationDTO.rations[i].dirty = true;
						}
					}
					if (saveRationDTO.rations[i].feed.mixes) {
						for (var m = 0; m < saveRationDTO.rations[i].feed.mixes.length; m++) {
							for (var md = 0; md < vm.dirtyListMix.length; md++) {
								if (saveRationDTO.rations[i].feed.mixes[m].id == vm.dirtyListMix[md].feed_id) {
									saveRationDTO.rations[i].feed.mixes[m].dirty = true;
								}
							}
						}
					}
				}
				saveRationDTO.last_modified_date = null;
				saveRationDTO.user_id = vm.user.email;
				return balanceRationFactory
					.saveRation(saveRationDTO)
					.then(function () {
						vm.dirtyList = [];
						vm.dirtyListMix = [];
						vm.edited = false;
						localStorage.removeItem('dirty');
						if (vm.modalType && vm.modalType == 'changeUnits') {
							changeUnitsProceed();
						}
						closeModal();
						toastr.success(i18nFilter('_saved_successfully_'));
						if (vm.from_premix) {
							if (vm.from_premix.type === 'add') {
								$state.go('premixes.addNewPremix');
							} else {
								$state.go('premixes.editPremix', {
									uuid: vm.from_premix.uuid
								});
							}
						}
					})
					.catch(function (error) {
						errorService.showErrorMessage(error, true, '_error_occurred_saving_ration_');
						closeModal();
						console.log(error);
					});
			}, 1);
		}

		function openSaveAsModal(page, size) {
			vm.rationNameSaveAs = vm.ration.ration_header.ration_name;
			openModal(page, size);
			$timeout(function () {
				getGroupsByHerd();
			}, 1);
		}

		function getGroupsByHerd() {
			if (vm.settings.selectedHerd.id) {
				vm.saveAsModalLoading = true;
				return balanceRationFactory
					.getGroupsByHerd(vm.settings.selectedHerd.id)
					.then(function (response) {
						vm.groups = response;
						setSelectedGroup(response);
					})
					.catch(function (error) {
						console.log(error);
						vm.saveAsModalLoading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_loading_groups_');
					});
			}
		}

		function setSelectedGroup(groups) {
			for (var i = 0; i < groups.length; i++) {
				if (groups[i].id == vm.ration.group.id) {
					vm.selectedGroup = groups[i];
					break;
				}
			}
			vm.saveAsModalLoading = false;
		}

		function saveRationAs() {
			if (!vm.groupInfo.$invalid) {
				vm.saveAsModalLoading = true;
				var rationDTO = angular.copy(vm.ration.ration_header);
				rationDTO.id = null;
				rationDTO.ration_name = vm.rationNameSaveAs;
				rationDTO.group_id = vm.selectedGroup.id;
				rationDTO.team_id = vm.settings.selectedTeam.id;
				for (var x = 0; x < rationDTO.rations.length; x++) {
					rationDTO.rations[x].id = null;
					rationDTO.rations[x].ration_header_id = null;
					rationDTO.rations[x].feed.team_id = vm.settings.selectedTeam.id;
					rationDTO.rations[x].feed.id = null;
					rationDTO.rations[x].feed.amount_dm = rationDTO.rations[x].feed.amount;
					if (rationDTO.rations[x].feed.mixes) {
						for (var y = 0; y < rationDTO.rations[x].feed.mixes.length; y++) {
							rationDTO.rations[x].feed.mixes[y].feed_id = null;
							rationDTO.rations[x].feed.mixes[y].id = null;
							rationDTO.rations[x].feed.mixes[y].amount_dm = rationDTO.rations[x].feed.mixes[y].amount;
						}
					}
				}
				var feeds = [];
				for (var i = 0; i < rationDTO.rations.length; i++) {
					var tempFeed = rationDTO.rations[i].feed;
					feeds.push(tempFeed);
				}
				rationDTO.feeds = feeds;
				rationDTO.rations = null;
				rationDTO.user_id = vm.user.email;
				var suffix = '?localType=' + vm.ration.ration_header.ration_locale;
				return addNewRationFactory
					.addNewRation(rationDTO, suffix)
					.then(function (response) {
						vm.dirtyList = [];
						vm.dirtyListMix = [];
						vm.edited = false;
						localStorage.removeItem('dirty');
						vm.saveAsModalLoading = false;
						$state.go('rations.balanceration', {
							uuid: response
						});
						closeModal();
						if (vm.from_premix) {
							if (vm.from_premix.type === 'add') {
								$state.go('premixes.addNewPremix');
							} else {
								$state.go('premixes.editPremix', {
									uuid: vm.from_premix.uuid
								});
							}
						}
						toastr.success(i18nFilter('_saved_successfully_'));
					})
					.catch(function (error) {
						vm.saveAsModalLoading = false;
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_saving_ration_');
					});
			}
		}

		function goToFeedHistory(id, locale) {
			vm.tempFeedId = id;
			vm.toFeedHistory = true;
			if (locale != null || locale != undefined) {
				localStorage.setItem('feed_calculation_type', locale);
			}
			$state.go('rations.rationFeedHistory', {
				uuid: id
			});
		}

		function goToHistory() {
			vm.toRationHistory = true;
			localStorage.setItem('ration_calculation_type', vm.calculationType);
			$state.go('rations.rationHistory', {
				groupId: vm.ration.group.id,
				rationId: vm.ration.ration_header.id
			});
		}

		function addDirty(id) {
			var dirty = {
				feed_id: id
			};
			var found = false;
			for (var i = 0; i < vm.dirtyList.length; i++) {
				if (vm.dirtyList[i].feed_id == id) {
					found = true;
					break;
				}
			}
			if (!found) {
				vm.dirtyList.push(dirty);
			}
		}

		function addDirtyMix(id) {
			var dirty = {
				feed_id: id
			};
			var found = false;
			for (var i = 0; i < vm.dirtyListMix.length; i++) {
				if (vm.dirtyListMix[i].feed_id == id) {
					found = true;
					break;
				}
			}
			if (!found) {
				vm.dirtyListMix.push(dirty);
			}
		}

		$scope.$on('$stateChangeStart', function (event, toState, toParams) {
			if (vm.edited) {
				setRedirectModal(toState, toParams);
				event.preventDefault();
			}
		});

		function setRedirectModal(toState, toParam) {
			vm.stateName = toState.name;
			if (vm.stateName == 'groups.editGroup') {
				vm.stateUuid = toParam.uuid;
			}
			openModal('app/pages/rations/balanceRation/modals/redirectModal.html', 'sm', 'redirect_modal');
		}

		function redirectProceed() {
			vm.edited = false;
			localStorage.removeItem('dirty');
			if (!vm.toFeedHistory && !vm.toRationHistory) {
				$state.go(vm.stateName);
			}
			if (vm.toFeedHistory) {
				$state.go('rations.rationFeedHistory', {
					uuid: vm.tempFeedId
				});
			}
			if (vm.toRationHistory) {
				$state.go('rations.rationHistory', {
					groupId: vm.ration.group.id,
					rationId: vm.ration.ration_header.id
				});
			}
		}

		function continueModalOpen() {
			vm.edited = false;
			localStorage.removeItem('dirty');
			if (vm.modalType == 'insertFeed') {
				closeModal();
				insertFeed('app/pages/rations/balanceRation/modals/insertFeed.modal.html', 'lg');
			} else if (vm.modalType == 'deleteFeed') {
				$uibModalStack.dismiss(continueModal);
				deleteFeedProceed();
			} else if (vm.modalType == 'createMix') {
				closeModal();
				createMIX('app/pages/rations/balanceRation/modals/createMix.modal.html', 'md');
			} else if (vm.modalType == 'unmix') {
				$uibModalStack.dismiss(continueModal);
				unmixProceed(vm.convert_unmix, vm.convert_unmix_index);
			} else if (vm.modalType == 'convert') {
				$uibModalStack.dismiss(continueModal);
				convertToFeedProceed(vm.convert_unmix, vm.convert_unmix_index);
			} else if (vm.modalType == 'addFeedToMix') {
				closeModal();
				addFeedToMix(vm.modalFeed);
			} else if (vm.modalType == 'removeFeedFromMix') {
				$uibModalStack.dismiss(continueModal);
				removeFeedFromMixProceed(vm.convert_unmix, vm.convert_unmix_index);
			} else if (vm.modalType == 'change_group') {
				closeModal();
				changeGroup();
				openChangeGroup('app/pages/rations/balanceRation/modals/changeGroup.html', 'md', true);
			} else if (vm.modalType == 'changeUnits') {
				closeModal();
				saveRation();
			} else if (vm.modalType == 'settingsGeneral') {
				saveSettingsGeneral();
			}
		}

		function round(value, decimals) {
			return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
		}

		// REPORTS//
		// MIX REPORT//

		function mixReportBatchSizeChanged() {
			if (timeoutMR) {
				$timeout.cancel(timeoutMR);
			}
			timeoutMR = $timeout(function () {
				for (var i = 0; i < vm.reportMixFeeds.length; i++) {
					var temp = (100 * vm.reportMixFeeds[i].as_fed) / vm.asFedSum;
					var temp1 = (temp * vm.mixBatchSize) / 100;
					temp1 = Number(temp1);
					if (temp1 && !isNaN(temp1)) {
						var param = temp1.toPrecision(3);
						var param_nod = decimalPlaces(param);
						vm.reportMixFeeds[i].batch_size = $filter('number')(param, param_nod);
					}
				}
			}, 1300);
		}

		function selectMixReportFeed() {
			setMixReportFeeds();
		}

		function reportMixUp(index) {
			var feeds = [];
			angular.copy(vm.reportMixFeeds, feeds);
			var a = feeds[index - 1];
			var b = feeds[index];
			feeds[index - 1] = b;
			feeds[index] = a;
			vm.reportMixFeeds = feeds;
		}

		function reportMixDown(index) {
			var feeds = [];
			angular.copy(vm.reportMixFeeds, feeds);
			var a = feeds[index + 1];
			var b = feeds[index];
			feeds[index + 1] = b;
			feeds[index] = a;
			vm.reportMixFeeds = feeds;
		}

		function openMixModal(page, size) {
			vm.aAndC = '';
			vm.modalLoading = true;
			openReportModal(page, size);
			var feeds = [];
			for (var i = 0; i < vm.ration.feeds.length; i++) {
				if (vm.ration.feeds[i].is_mix) {
					feeds.push(vm.ration.feeds[i]);
				}
			}
			vm.reportFeeds = feeds;
			vm.selectedReportFeed = vm.reportFeeds[0];
			setMixReportFeeds();
		}

		function setMixReportFeeds() {
			var mixFeeds = [];
			angular.copy(vm.selectedReportFeed.mixes, mixFeeds);
			vm.reportMixFeeds = mixFeeds;
			vm.asFedSum = 0;
			var count = 0;
			for (var i = 0; i < vm.reportMixFeeds.length; i++) {
				count++;
				vm.asFedSum = vm.asFedSum + vm.reportMixFeeds[i].as_fed;
				var temp = vm.reportMixFeeds[i].as_fed;
				temp = Number(temp);
				if (temp && !isNaN(temp)) {
					var param = temp.toPrecision(3);
					var param_nod = decimalPlaces(param);
					vm.reportMixFeeds[i].as_fed_sign = $filter('number')(param, param_nod);
				}
			}
			vm.reportMixFeedIndexNo = count - 1;
			for (var i = 0; i < vm.reportMixFeeds.length; i++) {
				var temp = (100 * vm.reportMixFeeds[i].as_fed) / vm.asFedSum;
				var temp1 = (temp * vm.mixBatchSize) / 100;
				temp1 = Number(temp1);
				if (temp1 && !isNaN(temp1)) {
					var param = temp1.toPrecision(3);
					var param_nod = decimalPlaces(param);
					vm.reportMixFeeds[i].batch_size = $filter('number')(param, param_nod);
				}
			}
			vm.modalLoading = false;
		}

		function exportMixReport() {
			vm.modalLoading = true;
			var newScope = {
				selectedReportFeed: vm.selectedReportFeed,
				mixBatchSize: vm.mixBatchSize,
				settings: vm.settings,
				weight: vm.weight,
				reportMixFeeds: vm.reportMixFeeds,
				currency: vm.currency,
				energy: vm.energy,
				preperedFor: vm.preperedFor,
				preperedBy: vm.preperedBy,
				aAndC: vm.aAndC
			};

			$timeout(function () {
				var mixReportService = $injector.get('mixReportService');
				if (vm.defaultCalculation.calc_type == 0) {
					mixReportService.exportUsMixReport(newScope, decimalPlaces).then(function () {
						vm.modalLoading = true;
						closeModal();
					});
				} else {
					mixReportService.exportVemMixReport(newScope, decimalPlaces).then(function () {
						vm.modalLoading = true;
						closeModal();
					});
				}
			}, 10);
		}

		//SUMMARY REPORT//
		function openSummaryModal(page, size) {
			vm.aAndC = '';
			vm.modalLoading = true;
			if (vm.ration.ration_header.ration_name.length > 30) {
				vm.summary.ration_name = vm.ration.ration_header.ration_name.slice(0, 26) + '...';
			} else {
				vm.summary.ration_name = vm.ration.ration_header.ration_name;
			}
			openReportModal(page, size);
			vm.modalLoading = false;
		}

		function exportSummaryOfficeReport(isSummary) {
			vm.modalLoading = true;
			var newScope = {
				summary: vm.summary,
				ration: vm.ration,
				settings: vm.settings,
				weight: vm.weight,
				currency: vm.currency,
				energy: vm.energy,
				preperedFor: vm.preperedFor,
				preperedBy: vm.preperedBy,
				aAndC: vm.aAndC
			};

			$timeout(function () {
				var summaryOfficeReportService = $injector.get('summaryOfficeReportService');
				if (vm.defaultCalculation.calc_type == 0) {
					summaryOfficeReportService.exportSummaryOfficeReportUS(isSummary, newScope, round, setSignificant, RRToLb, RRToMjoule).then(function () {
						vm.modalLoading = true;
						closeModal();
					});
				} else {
					summaryOfficeReportService.exportSummaryOfficeReportVem(isSummary, newScope, round, setSignificant, RRToLb, RRToMjoule).then(function () {
						vm.modalLoading = true;
						closeModal();
					});
				}
			}, 10);
		}

		function openOfficeModal(page, size) {
			vm.aAndC = '';
			vm.modalLoading = true;
			if (vm.ration.ration_header.ration_name.length > 30) {
				vm.summary.ration_name = vm.ration.ration_header.ration_name.slice(0, 26) + '...';
			} else {
				vm.summary.ration_name = vm.ration.ration_header.ration_name;
			}
			openReportModal(page, size);
			vm.modalLoading = false;
		}
		// BATCH REPORT //
		function openBatchModal(page, size) {
			vm.aAndC = '';
			vm.modalLoading = true;
			if (vm.ration.ration_header.ration_name.length > 30) {
				vm.batch.ration_name = vm.ration.ration_header.ration_name.slice(0, 26) + '...';
			} else {
				vm.batch.ration_name = vm.ration.ration_header.ration_name;
			}
			vm.batch.feeds = [];
			vm.batch.tmr_a_af = 0;
			vm.batch.number_of_animals = vm.ration.group.number_of_animals;
			vm.batch.group_increment_percent = 10;
			vm.batch.group_increment_number = (vm.batch.group_increment_percent * vm.batch.number_of_animals) / 100;
			vm.batch.daily_af = 100;
			var count = 0;
			for (var i = 0; i < vm.ration.feeds.length; i++) {
				if (vm.ration.feeds[i].amount > 0) {
					vm.batch.feeds.push(vm.ration.feeds[i]);
					vm.batch.tmr_a_af = vm.batch.tmr_a_af + vm.ration.feeds[i].as_fed;
					count++;
				}
			}
			vm.batch.tmr_a_af = round(vm.batch.tmr_a_af, 2);
			vm.reportBatchFeedIndexNo = count - 1;
			vm.batch.batch_size = vm.batch.tmr_a_af * vm.batch.number_of_animals * (vm.batch.daily_af / 100);
			vm.batch.batch_size = round(vm.batch.batch_size, 2);
			openReportModal(page, size);
			vm.modalLoading = false;
		}

		function reportBatchUp(index) {
			var feeds = [];
			angular.copy(vm.batch.feeds, feeds);
			var a = feeds[index - 1];
			var b = feeds[index];
			feeds[index - 1] = b;
			feeds[index] = a;
			vm.batch.feeds = feeds;
		}

		function reportBatchDown(index) {
			var feeds = [];
			angular.copy(vm.batch.feeds, feeds);
			var a = feeds[index + 1];
			var b = feeds[index];
			feeds[index + 1] = b;
			feeds[index] = a;
			vm.batch.feeds = feeds;
		}

		function batchNOAChanged() {
			if (timeoutBNOA) {
				$timeout.cancel(timeoutBNOA);
			}
			timeoutBNOA = $timeout(function () {
				vm.batch.group_increment_number = round((vm.batch.group_increment_percent * vm.batch.number_of_animals) / 100, 0);
				vm.batch.batch_size = vm.batch.tmr_a_af * vm.batch.number_of_animals * (vm.batch.daily_af / 100);
				vm.batch.batch_size = round(vm.batch.batch_size, 2);
			}, 750);
		}

		function batchGINChanged() {
			if (timeoutBGIN) {
				$timeout.cancel(timeoutBGIN);
			}
			timeoutBGIN = $timeout(function () {
				vm.batch.group_increment_percent = (vm.batch.group_increment_number * 100) / vm.batch.number_of_animals;
				vm.batch.group_increment_percent = round(vm.batch.group_increment_percent, 2);
			}, 750);
		}

		function batchGIPChanged() {
			if (timeoutBGIP) {
				$timeout.cancel(timeoutBGIP);
			}
			timeoutBGIP = $timeout(function () {
				vm.batch.group_increment_number = (vm.batch.group_increment_percent * vm.batch.number_of_animals) / 100;
				vm.batch.group_increment_number = round(vm.batch.group_increment_number, 0);
			}, 750);
		}

		function batchDAFhanged() {
			if (timeoutBDAF) {
				$timeout.cancel(timeoutBDAF);
			}
			timeoutBDAF = $timeout(function () {
				vm.batch.batch_size = vm.batch.tmr_a_af * vm.batch.number_of_animals * (vm.batch.daily_af / 100);
				vm.batch.batch_size = round(vm.batch.batch_size, 2);
			}, 750);
		}

		function batchBShanged() {
			if (timeoutBBS) {
				$timeout.cancel(timeoutBBS);
			}
			timeoutBBS = $timeout(function () {
				vm.batch.number_of_animals = (vm.batch.batch_size * 100) / (vm.batch.tmr_a_af * vm.batch.daily_af);
				vm.batch.number_of_animals = round(vm.batch.number_of_animals, 0);
				vm.batch.group_increment_number = (vm.batch.group_increment_percent * vm.batch.number_of_animals) / 100;
				vm.batch.group_increment_number = round(vm.batch.group_increment_number, 0);
			}, 750);
		}

		function exportBatchReport() {
			vm.modalLoading = true;
			var newScope = {
				batch: vm.batch,
				settings: vm.settings,
				ration: vm.ration,
				weight: vm.weight,
				preperedFor: vm.preperedFor,
				preperedBy: vm.preperedBy,
				aAndC: vm.aAndC
			};

			$timeout(function () {
				var batchReportService = $injector.get('batchReportService');
				vm.batch.number_of_animals = round(vm.batch.number_of_animals, 0);
				vm.batch.group_increment_number = round(vm.batch.group_increment_number, 0);
				batchReportService.exportBatchReport(newScope).then(function () {
					vm.modalLoading = true;
					closeModal();
				});
			}, 10);
		}

		editableOptions.theme = 'bs3';
		editableOptions.blurElem = 'submit';
		editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
		editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.balanceRation').factory('balanceRationFactory', balanceRationFactory);
	/** @ngInject */
	function balanceRationFactory(APP_CONST, $http, $q) {
		var cancelReq;
		var statusText;

		return {
			getRationById: getRationById,
			getFeedsByTeamId: getFeedsByTeamId,
			insertFeeds: insertFeeds,
			removeFeeds: removeFeeds,
			changeGeneralSettings: changeGeneralSettings,
			changeNutrientBalanceSettings: changeNutrientBalanceSettings,
			getRatiosRelationships: getRatiosRelationships,
			changeRationName: changeRationName,
			changeNumberOfAnimals: changeNumberOfAnimals,
			createMIX: createMIX,
			unmix: unmix,
			convertToFeed: convertToFeed,
			insertFeedToMix: insertFeedToMix,
			removeFeedFromMix: removeFeedFromMix,
			saveRation: saveRation,
			editRation: editRation,
			getGroupsByHerd: getGroupsByHerd,
			changeGroupForRation: changeGroupForRation,
			checkUsedRecipes: checkUsedRecipes,
			cancelRequest: cancelRequest
		};

		function cancelRequest() {
			statusText = 'Canceled';
			cancelReq.resolve();
		}

		function getRationById(id) {
			return $http
				.get(APP_CONST.api_base_url + 'rations/' + id)
				.then(success)
				.catch(error);
		}

		function getFeedsByTeamId(suffix) {
			cancelReq = $q.defer();
			return $http
				.get(APP_CONST.api_base_url + 'feeds' + suffix, {
					timeout: cancelReq.promise
				})
				.then(success)
				.catch(function (error) {
					var err = statusText ? $q.reject(statusText) : $q.reject(error);
					statusText = undefined;
					return err;
				});
		}

		function getGroupsByHerd(herdId) {
			return $http
				.get(APP_CONST.api_base_url + 'herds/' + herdId + '/groups')
				.then(success)
				.catch(error);
		}

		function insertFeeds(feeds, rationId, suffix) {
			return $http
				.post(APP_CONST.api_base_url + 'feeds/ration/' + rationId + suffix, feeds)
				.then(success)
				.catch(error);
		}

		function removeFeeds(feeds, rationId) {
			return $http
				.post(APP_CONST.api_base_url + 'ration/' + rationId + '/feeds/remove', feeds)
				.then(success)
				.catch(error);
		}

		function changeGeneralSettings(settings) {
			return $http
				.patch(APP_CONST.api_base_url + 'userSettings', settings)
				.then(success)
				.catch(error);
		}

		function changeNutrientBalanceSettings(settings, rationId) {
			return $http
				.put(APP_CONST.api_base_url + 'ration/' + rationId + '/nutrientSettings', settings)
				.then(success)
				.catch(error);
		}

		function getRatiosRelationships(rationId) {
			return $http
				.get(APP_CONST.api_base_url + 'ration/relationships/' + rationId)
				.then(success)
				.catch(error);
		}

		function changeRationName(name) {
			return $http
				.put(APP_CONST.api_base_url + 'ration/name', name)
				.then(success)
				.catch(error);
		}

		function changeNumberOfAnimals(numberOfAnimals) {
			return $http
				.put(APP_CONST.api_base_url + 'group/numberOfAnimals', numberOfAnimals)
				.then(success)
				.catch(error);
		}

		function createMIX(rationId, ingredients, suffix) {
			return $http
				.post(APP_CONST.api_base_url + 'ration/' + rationId + '/mixes' + suffix, ingredients)
				.then(success)
				.catch(error);
		}

		function unmix(feed, rationId) {
			return $http
				.post(APP_CONST.api_base_url + 'ration/' + rationId + '/unmix', feed)
				.then(success)
				.catch(error);
		}

		function convertToFeed(feedId, user) {
			return $http
				.post(APP_CONST.api_base_url + 'ration/mixToFeed/' + feedId, user)
				.then(success)
				.catch(error);
		}

		function insertFeedToMix(rationId, feedId, feeds, suffix) {
			return $http
				.post(APP_CONST.api_base_url + 'ration/' + rationId + '/feed/' + feedId + '/mix/ingredients' + suffix, feeds)
				.then(success)
				.catch(error);
		}

		function removeFeedFromMix(rationId, feeds) {
			return $http
				.put(APP_CONST.api_base_url + 'remove/mix/ingredients/ration/' + rationId, feeds)
				.then(success)
				.catch(error);
		}

		function editRation(rationHeaderId, rationHeader) {
			return $http
				.post(APP_CONST.api_base_url + 'rations/' + rationHeaderId + '/calculations', rationHeader)
				.then(success)
				.catch(error);
		}

		function saveRation(ration_header) {
			return $http
				.put(APP_CONST.api_base_url + 'ration/update', ration_header)
				.then(success)
				.catch(error);
		}

		function changeGroupForRation(ration_header_id, group_id, user) {
			return $http
				.put(APP_CONST.api_base_url + 'ration/' + ration_header_id + '/update/group/' + group_id, user)
				.then(success)
				.catch(error);
		}

		function checkUsedRecipes(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'recipesByRation' + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.importration').controller('importRationCtrl', importRationCtrl);
	/** @ngInject */
	function importRationCtrl($uibModal, $scope, $uibModalStack, APP_CONST, Upload, $filter, importRationFactory, $state, $locale, errorService) {
		var vm = this;
		vm.openUploadModal = openUploadModal;
		vm.cancel = cancel;
		vm.upload = upload;
		vm.uploadChanged = uploadChanged;
		vm.redirectTo = redirectTo;
		vm.reloadApi = reloadApi;
		var changed;
		init();

		function openUploadModal(page, size) {
			openModal(page, size);
		}

		function init() {
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			getUploadedFiles(true);
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.loadingDbs = true;
		}

		function reloadApi() {
			vm.loadingDbs = true;
			getUploadedFiles(true);
		}

		function getUploadedFiles(init) {
			vm.loadingTable = true;
			return importRationFactory
				.getUploadedFiles()
				.then(function (response) {
					vm.dbs = response;
					if (vm.dbs.length > 0) {
						vm.hasFiles = true;
					} else {
						vm.hasFiles = false;
					}
					vm.loadingDbs = false;
					vm.loadingTable = false;
				})
				.catch(function (error) {
					vm.loadingDbs = false;
					vm.loadingTable = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_file_', init);
				});
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function cancel() {
			$uibModalStack.dismissAll();
			vm.modalLoading = false;
		}

		function upload() {
			if (vm.file) {
				vm.uploading = true;
				vm.uploadIvent = Upload.upload({
					url: APP_CONST.api_base_url + 'upload/oldRations',
					file: vm.file
				})
					.then(function () {
						vm.uploading = false;
						getUploadedFiles();
						$uibModalStack.dismissAll();
						vm.file = null;
						changed = false;
						vm.fileSelected = null;
					})
					.catch(function (error) {
						vm.uploading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_uploading_files_');
					});
			}
		}

		function uploadChanged() {
			if (!changed) {
				changed = true;
				if (vm.file) {
					vm.fileSelected = vm.file.name;
				} else {
					vm.fileSelected = $filter('i18n')('_rations_import_ration_error_');
				}
			} else {
				changed = false;
			}
		}

		function redirectTo(uuid) {
			$state.go('rations.importrationnew', {
				uuid: uuid
			});
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_team_herd_changed', function () {
			init();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.importration').factory('importRationFactory', importRationFactory);
	/** @ngInject */
	function importRationFactory($http, $q, APP_CONST) {
		return {
			getUploadedFiles: getUploadedFiles
		};

		function getUploadedFiles() {
			return $http
				.get(APP_CONST.api_base_url + 'storage/rationFiles')
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.importrationnew').controller('importRationNewCtrl', importRationNewCtrl);
	/** @ngInject */
	function importRationNewCtrl($stateParams, importRationNewFactory, $state, $uibModal, $scope, $uibModalStack, toastr, $filter, errorService) {
		var vm = this;
		vm.fileLoading = true;
		vm.groupsLoading = true;
		vm.showNew = false;
		vm.showExisting = false;
		var i18nFilter = $filter('i18n');
		vm.selectType = selectType;
		vm.cancel = cancel;
		vm.createRation = createRation;
		vm.openModal = openModal;
		vm.closeModal = closeModal;
		vm.reloadApi = reloadApi;
		init();

		function init() {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			if (vm.settings.selectedTeam.id) {
				vm.teamSelected = true;
				if (vm.settings.selectedHerd.id) {
					vm.herdSelected = true;
					getFileById($stateParams.uuid);
					getGroupsByHerd(vm.settings.selectedHerd.id);
					getHerdById(vm.settings.selectedHerd.id);
				} else {
					vm.herdSelected = false;
					vm.fileLoading = false;
					vm.groupsLoading = false;
					vm.herdLoading = false;
				}
			} else {
				vm.teamSelected = false;
				vm.fileLoading = false;
				vm.groupsLoading = false;
				vm.herdLoading = false;
			}
		}

		function reloadApi() {
			if (vm.settings.selectedTeam.id) {
				vm.teamSelected = true;
				if (vm.settings.selectedHerd.id) {
					vm.herdSelected = true;
					getFileById($stateParams.uuid);
					getGroupsByHerd(vm.settings.selectedHerd.id);
					getHerdById(vm.settings.selectedHerd.id);
				} else {
					vm.herdSelected = false;
					vm.fileLoading = false;
					vm.groupsLoading = false;
					vm.herdLoading = false;
				}
			} else {
				vm.teamSelected = false;
				vm.fileLoading = false;
				vm.groupsLoading = false;
				vm.herdLoading = false;
			}
		}

		function getFileById(id) {
			vm.fileLoading = true;
			return importRationNewFactory
				.getUploadedFileById(id)
				.then(function (response) {
					vm.ration = response;
					vm.ration_name = response.ration_name;
					vm.fileLoading = false;
				})
				.catch(function (error) {
					vm.fileLoading = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_file_', true);
				});
		}

		function getHerdById(id) {
			vm.herdLoading = true;
			return importRationNewFactory
				.getHerdById(id)
				.then(function (response) {
					vm.herd = response;
					vm.herdLoading = false;
				})
				.catch(function (error) {
					vm.herdLoading = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_herds_', true);
				});
		}

		function getGroupsByHerd(herd) {
			vm.groups = [];
			vm.groupsLoading = true;
			return importRationNewFactory
				.getGroupsByHerd(herd)
				.then(function (response) {
					vm.groups = response;
					vm.groupsLoading = false;
				})
				.catch(function (error) {
					vm.groupsLoading = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_groups_', true);
				});
		}

		function selectType(type) {
			if (type == 'new') {
				vm.showExisting = false;
				vm.showNew = true;
			} else if (type == 'existing') {
				vm.showNew = false;
				vm.showExisting = true;
			}
		}

		function cancel() {
			$state.go('rations.importration');
		}

		function createRation() {
			if (!vm.form.$invalid) {
				if (vm.showExisting) {
					vm.ration.group_name = vm.selectedGroup.name;
					vm.ration.herd_id = vm.settings.selectedHerd.id;
					vm.ration.group_id = vm.selectedGroup.id;
					vm.ration.ration_name = vm.ration_name;
					vm.ration.herd_name = vm.herd.Name;
					vm.ration.user_id = vm.user.email;
					vm.ration.team_id = vm.settings.selectedTeam.id;
				} else if (vm.showNew) {
					vm.ration.group_name = vm.group_name;
					vm.ration.herd_id = vm.settings.selectedHerd.id;
					vm.ration.group_id = null;
					vm.ration.ration_name = vm.ration_name;
					vm.ration.herd_name = vm.herd.Name;
					vm.ration.user_id = vm.user.email;
					vm.ration.team_id = vm.settings.selectedTeam.id;
				}
				vm.modalLoading = true;
				return importRationNewFactory
					.addNewRation(vm.ration)
					.then(function (response) {
						toastr.success(i18nFilter('_toastr_ration_created_'), i18nFilter('_toastr_success_title_'));
						$state.go('rations.balanceration', {
							uuid: response
						});
					})
					.catch(function (error) {
						vm.modalLoading = false;
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_saving_ration_');
					});
			}
		}

		function openModal(page, size) {
			if (!vm.form.$invalid) {
				$uibModal.open({
					animation: true,
					templateUrl: page,
					size: size,
					scope: $scope,
					backdrop: 'static',
					keyboard: false
				});
			}
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		$scope.$on('default_herd_selected', function () {
			init();
		});

		$scope.$on('default_team_selected', function () {
			init();
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.importrationnew').factory('importRationNewFactory', importRationNewFactory);
	/** @ngInject */
	function importRationNewFactory($http, $q, APP_CONST) {
		return {
			getUploadedFileById: getUploadedFileById,
			getGroupsByHerd: getGroupsByHerd,
			getHerdById: getHerdById,
			addNewRation: addNewRation
		};

		function getUploadedFileById(id) {
			return $http
				.get(APP_CONST.api_base_url + 'storage/rationFiles/' + id)
				.then(success)
				.catch(error);
		}

		function getGroupsByHerd(herdId) {
			return $http
				.get(APP_CONST.api_base_url + 'herds/' + herdId + '/groups')
				.then(success)
				.catch(error);
		}

		function getHerdById(id) {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/herds/' + id)
				.then(success)
				.catch(error);
		}

		function addNewRation(ration) {
			return $http
				.post(APP_CONST.api_base_url + 'import/ration', ration)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.manualRationFeedsHistory').controller('manualRationFeedsHistoryCtrl', manualRationFeedsHistoryCtrl);
	/** @ngInject */
	function manualRationFeedsHistoryCtrl($stateParams, manualRationFeedsHistoryService, APP_CONST, $filter, $state, errorService) {
		var vm = this;
		var i18nFilter = $filter('i18n');

		vm.back = back;
		vm.paginationChanged = paginationChanged;

		init();

		function init() {
			vm.loading = true;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.manualRationId = JSON.parse(localStorage.getItem('manual_ration_id'));
			localStorage.removeItem('manual_ration_id');
			vm.selectedTeam = vm.settings.selectedTeam.id;
			vm.selectedHerd = vm.settings.selectedHerd.id;
			vm.currentPage = 1;
			vm.itemsPerPage = 10;
			vm.history = [];
			setFeedTypes(APP_CONST.constants.feed_types);
			getHistory(true);
		}

		function setFeedTypes(feed_types) {
			var types = angular.copy(feed_types);

			vm.feedTypes = types.map(function (type) {
				var t = '_feeds_type_' + type.value + '_';
				type.show_name = t;
				type.translated = i18nFilter(t);
				return type;
			});
		}

		function getHistory(init) {
			var suffix = '?teamId=' + vm.selectedTeam + '&herdId=' + vm.selectedHerd + '&pageNumber=' + (vm.currentPage - 1);
			manualRationFeedsHistoryService
				.getHistory($stateParams.uuid, suffix)
				.then(function (response) {
					vm.totalItems = response && response.number_of_all ? response.number_of_all : 0;
					if (vm.totalItems > 0) {
						vm.history = response.manual_ration_feeds_history.map(function (history) {
							var found = false;

							for (var i = 0; i < vm.feedTypes.length; i++) {
								if (history.feed_type.toLowerCase() === vm.feedTypes[i].name.toLowerCase()) {
									history.feed_type = vm.feedTypes[i];
									found = true;
									break;
								}
							}

							if (!found) {
								history.feed_type = {
									show_name: '_feeds_type_not_set_',
									translated: i18nFilter('_feeds_type_not_set_')
								};
							}

							return history;
						});
					}
					vm.loading = false;
					vm.loadingTable = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					vm.loadingTable = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_feed_history_', init);
				});
		}

		function paginationChanged() {
			vm.loadingTable = true;
			getHistory();
		}

		function back() {
			if (vm.manualRationId) {
				$state.go('rations.editmanualration', {
					uuid: vm.manualRationId
				});
			} else {
				$state.go('rations.manualrations');
			}
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.manualRationFeedsHistory').factory('manualRationFeedsHistoryService', manualRationFeedsHistoryService);
	/** @ngInject */
	function manualRationFeedsHistoryService($http, APP_CONST, $q) {
		return {
			getHistory: getHistory
		};

		function getHistory(id, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'manualrationfeeds/' + id + '/history' + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.manualRationsHistory').controller('manualRationsHistoryCtrl', manualRationsHistoryCtrl);
	/** @ngInject */
	function manualRationsHistoryCtrl($stateParams, manualRationsHistoryService, $state, $filter, errorService, unitConversionService, $locale) {
		var vm = this;
		var i18nFilter = $filter('i18n');

		vm.back = back;
		vm.paginationChanged = paginationChanged;

		init();

		function init() {
			vm.loading = true;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedTeam = vm.settings.selectedTeam.id;
			vm.selectedHerd = vm.settings.selectedHerd.id;
			vm.currentPage = 1;
			vm.itemsPerPage = 10;
			vm.history = [];
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			getHistory(true);
		}

		function getHistory(init) {
			var suffix = '?teamId=' + vm.selectedTeam + '&herdId=' + vm.selectedHerd + '&pageNumber=' + (vm.currentPage - 1);
			manualRationsHistoryService
				.getHistory($stateParams.uuid, suffix)
				.then(function (response) {
					vm.totalItems = response && response.number_of_all ? response.number_of_all : 0;
					var history = response.manual_rations_history;
					for (var i = 0; i < history.length; i++) {
						if (history[i].user_agent) {
							if (history[i].user_agent.toLowerCase().includes('mmmooogleapp')) {
								history[i].source = i18nFilter('_m_f_ration_mmmooogle_app_label_');
							} else {
								history[i].source = i18nFilter('_m_f_ration_mmmooogle_web_label_');
							}
						} else {
							history[i].source = i18nFilter('_m_f_calendar_not_available_label_');
						}
						history[i] = setDifferences(history[i], history[i + 1]);
					}
					vm.history = history;
					vm.loading = false;
					vm.loadingTable = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					vm.loadingTable = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_feed_history_', init);
				});
		}

		function setDifferences(item, previousItem) {
			if (previousItem) {
				if (item.ration_name != previousItem.ration_name) {
					item.ration_name_changed = true;
				}
				if (unitConversionService.convertData(item.cost_dm, ['round:2']) != unitConversionService.convertData(previousItem.cost_dm, ['round:0'])) {
					item.cost_dm_changed = true;
				}
				if (unitConversionService.convertData(item.dm, ['round:2']) != unitConversionService.convertData(previousItem.dm, ['round:2'])) {
					item.dm_changed = true;
				}
			}
			return item;
		}

		function paginationChanged() {
			vm.loadingTable = true;
			getHistory();
		}

		function back() {
			$state.go('rations.manualrations');
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.manualRationsHistory').factory('manualRationsHistoryService', manualRationsHistoryService);
	/** @ngInject */
	function manualRationsHistoryService($http, APP_CONST, $q) {
		return {
			getHistory: getHistory
		};

		function getHistory(id, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'manualrations/' + id + '/history' + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.manualrations').controller('myManualRationsCtrl', myManualRationsCtrl);
	/** @ngInject */
	function myManualRationsCtrl(myManualRationsFactory, $locale, APP_CONST, $uibModal, $uibModalStack, $scope, $state, $filter, errorService, $q, editableOptions, authService, $timeout) {
		var vm = this;
		var i18nFilter = $filter('i18n');

		var confirmationPromise;

		vm.reloadApi = reloadApi;
		vm.manualRationsPaginationChanged = manualRationsPaginationChanged;
		vm.fodjanRationsPaginationChanged = fodjanRationsPaginationChanged;
		vm.onShow = onShow;
		vm.setHerd = setHerd;
		vm.confirm = confirm;
		vm.deleteRation = deleteRation;
		vm.deleteThirdPartyRation = deleteThirdPartyRation;
		vm.selectTableRow = selectTableRow;
		vm.goToHistory = goToHistory;
		vm.editRation = editRation;
		vm.cancel = cancel;
		vm.tabSelected = tabSelected;

		init();

		function init() {
			setInitialData();
			setConstants();
			callApis();
		}

		function reloadApi() {
			setInitialData();
			callApis();
		}

		function setInitialData() {
			vm.loading = true;
			vm.loadingFodjanRations = true;
			vm.manualRationsCurrentPage = 1;
			vm.fodjanRationsCurrentPage = 1;
			vm.manualRations = [];
			vm.fodjanRations = [];
			vm.herds = [];

			vm.showFodjanTable = authService.can(256);

			vm.tabs = [
				{
					name: 'MmmooOgle',
					position: 0,
					url: 'app/pages/rations/myManualRations/tables/mmmooogle.table.html',
					active: true
				}
			];
		}

		function setConstants() {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.selectedTeam = vm.settings.selectedTeam.id;
			vm.selectedHerd = vm.settings.selectedHerd.id;
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			vm.weight = vm.settings.use_kgs ? 'Kg' : 'Lb';

			setFeedTypes(APP_CONST.constants.feed_types);
		}

		function setFeedTypes(feed_types) {
			var types = angular.copy(feed_types);

			vm.feedTypes = types.map(function (type) {
				var t = '_feeds_type_' + type.value + '_';
				type.show_name = t;
				type.translated = i18nFilter(t);
				return type;
			});
		}

		function callApis() {
			if (authService.can(256)) {
				getRegularWithFodjanRations();
			} else {
				getRegularRations();
			}
		}

		function getRegularRations() {
			if (vm.selectedHerd) {
				getManualRations(true);
			} else {
				vm.loading = false;
			}
		}

		function getRegularWithFodjanRations() {
			var firstTabPromiseList = [getPartners()];
			var secondTabPromiseList = [getHerds(), getThirdPartyRations('FODJAN', true)];

			if (vm.selectedHerd) {
				firstTabPromiseList.push(getMmmmooogleRations(true));
			}
			$q.all(firstTabPromiseList).finally(function () {
				vm.loading = false;
			});

			$q.all(secondTabPromiseList).finally(function () {
				selectRationHerd();
				vm.loadingFodjanRations = false;
			});
		}

		function getPartners() {
			return myManualRationsFactory
				.getPartners()
				.then(function (response) {
					response.forEach(function (partner) {
						vm.tabs.push({
							name: partner.name,
							position: partner.id,
							url: 'app/pages/rations/myManualRations/tables/fodjan.table.html'
						});

						vm.tabs = vm.tabs.map(function (tab, index) {
							if (vm.tabs[index + 1]) {
								tab.active = false;
							} else {
								tab.active = true;
							}
							return tab;
						});
					});

					return $q.resolve();
				})
				.catch(function () {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_partners_', true);

					return $q.reject(error);
				});
		}

		function getHerds() {
			return myManualRationsFactory
				.getHerdsByTeam(vm.selectedTeam)
				.then(function (response) {
					vm.herds = response;

					return $q.resolve();
				})
				.catch(function () {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_herds_', true);

					return $q.reject(error);
				});
		}

		function getManualRations(init) {
			vm.loadingManualRationsTable = true;
			var suffix = '/' + vm.selectedHerd + '/' + vm.manualRationsCurrentPage + '?visible=true';

			myManualRationsFactory
				.getManualRations(suffix)
				.then(function (response) {
					var rations = handleApiResponse(response);

					vm.totalManualRations = response && response.number_of_all ? response.number_of_all : 0;
					vm.manualRations = vm.manualRations.concat(rations);
					vm.loadingManualRationsTable = false;
					vm.loading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loadingManualRationsTable = false;
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_rations_', init);
				});
		}

		function getMmmmooogleRations(init) {
			vm.loadingManualRationsTable = true;
			var suffix = '?herdId=' + vm.selectedHerd + '&page=' + vm.manualRationsCurrentPage;

			return myManualRationsFactory
				.getMmmmooogleRations(suffix)
				.then(function (response) {
					var rations = handleApiResponse(response);

					vm.totalManualRations = response && response.number_of_all ? response.number_of_all : 0;
					vm.manualRations = vm.manualRations.concat(rations);
					vm.loadingManualRationsTable = false;

					return $q.resolve();
				})
				.catch(function (error) {
					console.log(error);
					vm.loadingManualRationsTable = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_rations_', init);

					return $q.reject(error);
				});
		}

		function manualRationsPaginationChanged() {
			vm.manualRationsCurrentPage++;
			if (authService.can(256)) {
				getMmmmooogleRations();
			} else {
				getManualRations();
			}
		}

		function getThirdPartyRations(type, init) {
			if (!vm.showFodjanTable) {
				return $q.resolve();
			}

			vm.loadingFodjanRationsTable = true;
			var suffix = '?teamId=' + vm.selectedTeam + '&page=' + vm.fodjanRationsCurrentPage + '&type=' + type;

			return myManualRationsFactory
				.getThirdPartyRations(suffix)
				.then(function (response) {
					var rations = handleApiResponse(response);

					rations.forEach(function (ration) {
						ration.tenant_metadata.forEach(function (metadata) {
							if (metadata.key === 'FARM_NAME') {
								ration.farm_name = metadata.value;
							}

							if (metadata.key === 'FARM_ID') {
								ration.farm_id = metadata.value;
							}
						});
					});

					vm.totalFodjanRations = response && response.number_of_all ? response.number_of_all : 0;
					vm.fodjanRations = vm.fodjanRations.concat(rations);
					vm.loadingFodjanRationsTable = false;

					return $q.resolve();
				})
				.catch(function (error) {
					console.log(error);
					vm.loadingFodjanRationsTable = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_rations_', init);

					return $q.reject(error);
				});
		}

		function fodjanRationsPaginationChanged() {
			vm.fodjanRationsCurrentPage++;
			getThirdPartyRations('FODJAN');
		}

		function handleApiResponse(response) {
			var rations = angular.copy(response.manual_rations);

			rations.forEach(function (ration) {
				ration.expanded = false;
				ration.ration_feeds = $filter('orderBy')(ration.ration_feeds, 'order_number');

				ration.ration_feeds.forEach(function (feed) {
					if (!feed.feed_type) {
						feed.feed_type = i18nFilter('_feeds_type_not_set_');
					} else {
						for (var f = 0; f < vm.feedTypes.length; f++) {
							if (feed.feed_type.toLowerCase() === vm.feedTypes[f].name.toLowerCase()) {
								feed.feed_type = vm.feedTypes[f];
								break;
							}
						}
					}
				});
			});

			return rations;
		}

		function selectRationHerd() {
			vm.fodjanRations.forEach(function (ration) {
				for (var i = 0; i < vm.herds.length; i++) {
					if (ration.herd_id === vm.herds[i].Id) {
						ration.selected_herd = vm.herds[i];
						break;
					}
				}
			});
		}

		function onShow(herd) {
			vm.previousHerd = herd;
		}

		function setHerd(ration, herd) {
			if (herd && ration.selected_herd && herd.Id !== ration.selected_herd.Id) {
				changeHerd(ration, herd);
			} else {
				openModal('app/components/loadingModal/loading.modal.html');
				ration.selected_herd = herd;
				updateRationHerd(ration);
			}
		}

		function changeHerd(ration, herd) {
			vm.modalType = 'set-herd';
			confirmationPromise = $q.defer();
			openModal('app/pages/rations/myManualRations/confirmation.modal.html');

			$q.all([confirmationPromise.promise])
				.then(function () {
					vm.modalLoading = true;
					ration.selected_herd = herd;
					updateRationHerd(ration);
				})
				.catch(function () {
					ration.selected_herd = vm.previousHerd;
					vm.previousHerd = null;
				});
		}

		function deleteRation(rations, ration) {
			vm.modalType = 'delete';
			confirmationPromise = $q.defer();
			vm.modalIndex = rations.findIndex(function (r) {
				return r.id === ration.id;
			});

			openModal('app/pages/rations/myManualRations/confirmation.modal.html');

			$q.all([confirmationPromise.promise]).then(function () {
				vm.modalLoading = true;
				return myManualRationsFactory
					.deleteRation(ration.id)
					.then(function () {
						rations.splice(vm.modalIndex, 1);
						vm.totalManualRations--;
					})
					.catch(function (error) {
						console.log(error);
						vm.modalLoading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_deleting_ration_');
					})
					.finally(function () {
						closeModal();
					});
			});
		}

		function deleteThirdPartyRation(rations, ration) {
			vm.modalType = 'delete';
			confirmationPromise = $q.defer();
			vm.modalIndex = rations.findIndex(function (r) {
				return r.id === ration.id;
			});

			openModal('app/pages/rations/myManualRations/confirmation.modal.html');

			$q.all([confirmationPromise.promise]).then(function () {
				vm.modalLoading = true;
				return myManualRationsFactory
					.deleteThirdPartyRation(ration.id)
					.then(function () {
						rations.splice(vm.modalIndex, 1);
						vm.totalFodjanRations--;
					})
					.catch(function (error) {
						console.log(error);
						vm.modalLoading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_deleting_ration_');
					})
					.finally(function () {
						closeModal();
					});
			});
		}

		function confirm() {
			confirmationPromise.resolve();
		}

		function cancel() {
			closeModal();
			confirmationPromise.reject();
		}

		function tabSelected(index){
			vm.tabs = vm.tabs.map(function(tab){
				tab.active = false;
				return tab;
			});

			$timeout(function(){
				vm.tabs = vm.tabs.map(function(tab, i){
					if(i == index){
						tab.active = true;
					}
					return tab;
				});
			}, 50);
		}

		function updateRationHerd(ration) {
			myManualRationsFactory
				.updateHerd({
					manual_ration_id: ration.id,
					herd_id: ration.selected_herd.Id,
					farm_id: ration.farm_id
				})
				.catch(function (error) {
					console.log(error);
					ration.selected_herd = vm.previousHerd;
					errorService.showErrorMessage(error, true, '_error_occurred_setting_ration_herd_');
				})
				.finally(function () {
					vm.previousHerd = null;
					vm.modalLoading = false;
					closeModal();
				});
		}

		function selectTableRow(rations, ration) {
			ration.expanded = !ration.expanded;
			rations.forEach(function (r) {
				if (ration.id !== r.id) {
					r.expanded = false;
				}
			});
		}

		function editRation(id) {
			$state.go('rations.editmanualration', {
				uuid: id
			});
		}

		function goToHistory(id) {
			$state.go('rations.manualRationsHistory', {
				uuid: id
			});
		}

		function openModal(page) {
			vm.modalLoading = false;
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: 'md',
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_team_herd_changed', function () {
			init();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});

		editableOptions.theme = 'bs3';
		editableOptions.blurElem = 'submit';
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.manualrations').factory('myManualRationsFactory', myManualRationsFactory);
	/** @ngInject */
	function myManualRationsFactory(APP_CONST, $http, $q) {
		return {
			getManualRations: getManualRations,
			getMmmmooogleRations: getMmmmooogleRations,
			getThirdPartyRations: getThirdPartyRations,
			getHerdsByTeam: getHerdsByTeam,
			deleteRation: deleteRation,
			deleteThirdPartyRation: deleteThirdPartyRation,
			getPartners: getPartners,
			updateHerd: updateHerd
		};

		function getManualRations(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'importRationsWithRationFeedByHerd' + suffix)
				.then(success)
				.catch(error);
		}

		function getMmmmooogleRations(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'manual-rations/mmmooogle' + suffix)
				.then(success)
				.catch(error);
		}

		function getThirdPartyRations(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'manual-rations/third-party' + suffix)
				.then(success)
				.catch(error);
		}

		function getHerdsByTeam(id) {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams/' + id + '/herds')
				.then(success)
				.catch(error);
		}

		function deleteRation(id) {
			return $http
				.delete(APP_CONST.api_base_url + 'importRationsWithRationFeed/' + id)
				.then(success)
				.catch(error);
		}

		function deleteThirdPartyRation(id) {
			return $http
				.delete(APP_CONST.api_base_url + 'manual-rations/third-party/' + id)
				.then(success)
				.catch(error);
		}

		function getPartners() {
			return $http
				.get(APP_CONST.api_base_url + 'partners')
				.then(success)
				.catch(error);
		}

		function updateHerd(data) {
			return $http
				.put(APP_CONST.api_base_url + 'manual-rations/herd/add', data)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.myrations').controller('myRationsCtrl', myRationsCtrl);
	/** @ngInject */
	function myRationsCtrl($filter, $state, myRationsFactory, $timeout, $uibModal, $uibModalStack, $scope, $locale, errorService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var searchTimeout;
		var dateTimeout;
		vm.herdSelected = herdSelected;
		vm.groupDetails = groupDetails;
		vm.setAsActive = setAsActive;
		vm.deleteRation = deleteRation;
		vm.cancel = cancel;
		vm.deleteRationProceed = deleteRationProceed;
		vm.paginationChanged = paginationChanged;
		vm.searchRation = searchRation;
		vm.activeFilterChanged = activeFilterChanged;
		vm.dateFilterChanged = dateFilterChanged;
		vm.reloadApi = reloadApi;
		vm.rationsSafe = [];
		vm.rationFilterString = '';
		vm.herdFilterString = '';
		vm.groupFilterString = '';
		vm.loading = true;
		vm.disableGroup = true;
		init();

		function init() {
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			vm.currentPage = 1;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			setActiveFilter();
			getDefaultTeamHerd();
			if (vm.selectedTeam) {
				getRations(1);
			}
			vm.loading = true;
			vm.loadingFooter = true;
		}

		function reloadApi() {
			vm.loading = true;
			vm.loadingFooter = true;
			if (vm.selectedTeam) {
				getRations(1);
			}
		}

		function setActiveFilter() {
			// 1 - all
			// 2 - active
			// 3 - unactive
			vm.activeFilterItems = [
				{
					name: i18nFilter('_rations_active_filter_all_'),
					value: 1
				},
				{
					name: i18nFilter('_rations_active_filter_active_'),
					value: 2
				},
				{
					name: i18nFilter('_rations_active_filter_unactive_'),
					value: 3
				}
			];
			vm.activeFilter = vm.activeFilterItems[0];
		}

		function getDefaultTeamHerd() {
			var settings = JSON.parse(localStorage.getItem('user_settings'));
			if (settings.selectedTeam.id) {
				vm.selectedTeam = settings.selectedTeam;
			}
			if (settings.selectedHerd.id) {
				vm.selectedHerd = settings.selectedHerd;
			}
		}

		function getRations(page_number) {
			var suffix = generateSuffix();
			vm.loadingTable = true;
			if (vm.selectedHerd) {
				vm.showGroupSelector = true;
				vm.showFooter = false;
				getRationsByHerd(vm.selectedHerd, page_number, suffix, true);
				getGroupsByHerd(vm.selectedHerd, true);
			} else {
				vm.showFooter = true;
				getRationsByTeam(vm.selectedTeam, page_number, suffix);
			}
			vm.rationsSafe = vm.rations;
		}

		function generateSuffix() {
			var first = true;
			var suffix = '';
			if (vm.rationFilterString.length > 0) {
				suffix = suffix + '?rationName=' + encodeURIComponent(vm.rationFilterString);
				first = false;
			}
			if (!vm.selectedHerd) {
				if (vm.herdFilterString.length > 0) {
					if (first) {
						suffix = suffix + '?herdName=' + encodeURIComponent(vm.herdFilterString);
						first = false;
					} else {
						suffix = suffix + '&herdName=' + encodeURIComponent(vm.herdFilterString);
					}
				}
			}
			if (vm.groupFilterString.length > 0) {
				if (first) {
					suffix = suffix + '?groupName=' + encodeURIComponent(vm.groupFilterString);
					first = false;
				} else {
					suffix = suffix + '&groupName=' + encodeURIComponent(vm.groupFilterString);
				}
			}
			if (vm.activeFilter) {
				if (first) {
					if (vm.activeFilter.value == 2) {
						suffix = suffix + '?active=true';
						first = false;
					} else if (vm.activeFilter.value == 3) {
						suffix = suffix + '?active=false';
						first = false;
					}
				} else {
					if (vm.activeFilter.value == 2) {
						suffix = suffix + '&active=true';
					} else if (vm.activeFilter.value == 3) {
						suffix = suffix + '&active=false';
					}
				}
			}
			if (vm.dateFilter) {
				var date = $filter('date')(vm.dateFilter, 'yyyy-MM-dd');
				if (first) {
					suffix = suffix + '?createDate=' + date;
				} else {
					suffix = suffix + '&createDate=' + date;
				}
			}
			return suffix;
		}

		function getRationsByTeam(team, page_number, suffix) {
			return myRationsFactory
				.getRationsByTeam(team.id, page_number, suffix)
				.then(function (response) {
					if (response.length > 0) {
						vm.totalItems = response[0].number_of_all;
					} else {
						vm.totalItems = 0;
					}
					vm.rations = response;
					vm.loading = false;
					vm.loadingTable = false;
					vm.loadingFooter = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					vm.loadingTable = false;
					vm.loadingFooter = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_rations_', true);
				});
		}

		function getGroupsByHerd(herd, init) {
			vm.disableGroup = true;
			myRationsFactory
				.getGroupsByHerd(herd.id)
				.then(function (response) {
					var empty = {
						id: null,
						name: ''
					};
					response.splice(0, 0, empty);
					vm.groups = response;
					vm.disableGroup = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.disableGroup = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_groups_', init);
				});
		}

		function herdSelected() {
			vm.selectedGroup = null;
			getRationsByHerd(vm.selectedHerd);
			getGroupsByHerd(vm.selectedHerd);
		}

		function getRationsByHerd(herd, page_number, suffix, init) {
			vm.rations = [];
			vm.rationsSafe = [];
			vm.loadingTable = true;
			return myRationsFactory
				.getRationsByHerd(herd.id, page_number, suffix)
				.then(function (response) {
					if (response.length > 0) {
						vm.totalItems = response[0].number_of_all;
					} else {
						vm.totalItems = 0;
					}
					vm.rations = response;
					vm.loading = false;
					vm.loadingTable = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					vm.loadingTable = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_rations_', init);
				});
		}

		function groupDetails(id) {
			$state.go('rations.balanceration', {
				uuid: id
			});
		}

		function setAsActive(ration, index) {
			var temp = {
				id: ration.id,
				group_id: ration.group_id,
				user_id: vm.user.email
			};
			if (ration.active) {
				vm.rations[index].active = false;
				temp.active = false;
			} else {
				vm.rations[index].active = true;
				temp.active = true;
			}
			return myRationsFactory
				.setRationAsActive(temp)
				.then()
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_setting_active_ration_');
				});
		}

		function deleteRation(ration, index) {
			ration.user_id = vm.user.email;
			ration.index = index;
			vm.rationToDelete = ration;
			openModal();
		}

		function deleteRationProceed() {
			vm.modalLoading = true;
			return myRationsFactory
				.deleteRation(vm.rationToDelete)
				.then(function () {
					vm.rations.splice(vm.rationToDelete.index, 1);
					if (vm.rations.length == 0) {
						vm.currentPage--;
						vm.currentPage = vm.currentPage ? vm.currentPage : 1;
						if (vm.totalItems > 0) {
							getRations(vm.currentPage);
						}
					} else {
						vm.rationsSafe = vm.rations;
					}
					$uibModalStack.dismissAll();
					vm.rationToDelete = null;
					vm.modalLoading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.modalLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_deleting_ration_');
				});
		}

		function searchRation() {
			if (searchTimeout) {
				$timeout.cancel(searchTimeout);
			}
			searchTimeout = $timeout(function () {
				getRations(1);
				vm.currentPage = 1;
			}, 1000);
		}

		function activeFilterChanged() {
			getRations(1);
			vm.currentPage = 1;
			$timeout(function () {
				$(':focus').blur();
			});
		}

		function dateFilterChanged() {
			if (dateTimeout) {
				$timeout.cancel(dateTimeout);
			}
			dateTimeout = $timeout(function () {
				getRations(1);
				vm.currentPage = 1;
			}, 500);
		}

		function openModal() {
			$uibModal.open({
				animation: true,
				templateUrl: 'app/pages/rations/myRations/deleteRation.modal.html',
				size: 'md',
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function paginationChanged() {
			getRations(vm.currentPage);
		}

		function cancel() {
			$uibModalStack.dismissAll();
			vm.rationToDelete = null;
		}

		$scope.$on('default_herd_selected', function () {
			vm.selectedGroup = null;
			vm.herdFilterString = '';
			init();
		});

		$scope.$on('default_team_herd_changed', function () {
			vm.selectedGroup = null;
			vm.selectedHerd = null;
			vm.herdFilterString = '';
			vm.showGroupSelector = false;
			init();
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.myrations').factory('myRationsFactory', myRationsFactory);
	/** @ngInject */
	function myRationsFactory(APP_CONST, $http, $q) {
		return {
			getHerdsByUser: getHerdsByUser,
			getRationsByHerd: getRationsByHerd,
			getGroupsByHerd: getGroupsByHerd,
			getRationsByGroup: getRationsByGroup,
			setRationAsActive: setRationAsActive,
			deleteRation: deleteRation,
			getHerdsByTeam: getHerdsByTeam,
			getRationsByTeam: getRationsByTeam
		};

		function getHerdsByUser() {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/herds')
				.then(success)
				.catch(error);
		}

		function getHerdsByTeam(teamID) {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams/' + teamID + '/herds')
				.then(success)
				.catch(error);
		}

		function getRationsByHerd(herdId, page_number, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'herds/' + herdId + '/rations/' + page_number + suffix)
				.then(success)
				.catch(error);
		}

		function getGroupsByHerd(herdId) {
			return $http
				.get(APP_CONST.api_base_url + 'herds/' + herdId + '/groups')
				.then(success)
				.catch(error);
		}

		function getRationsByGroup(groupId, page_number, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'groups/' + groupId + '/rations/' + page_number + suffix)
				.then(success)
				.catch(error);
		}

		function deleteRation(ration) {
			return $http
				.post(APP_CONST.api_base_url + 'ration/remove', ration)
				.then(success)
				.catch(error);
		}

		function setRationAsActive(data) {
			return $http
				.put(APP_CONST.api_base_url + 'ration/active', data)
				.then(success)
				.catch(error);
		}

		function getRationsByTeam(teamId, page_number, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'teams/' + teamId + '/rations/' + page_number + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.rationComparison').controller('rationComparisonCtrl', rationComparisonCtrl);
	/** @ngInject */
	function rationComparisonCtrl() {
		var vm = this;
		console.log(vm);
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.rationComparison').factory('rationComparisonService', rationComparisonService);
	/** @ngInject */
	function rationComparisonService($http, $q, APP_CONST) {
		return {
			getRations: getRations
		};

		function getRations(id) {
			return $http
				.get(APP_CONST.api_base_url + 'rations/' + id)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.rationFeedHistory').controller('rationFeedHistoryCtrl', rationFeedHistoryCtrl);
	/** @ngInject */
	function rationFeedHistoryCtrl($stateParams, APP_CONST, $locale, rationFeedHistoryFactory, $window, $scope, $filter, errorService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		vm.loading = true;
		vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
		vm.weight = 'kg';
		vm.energy = 'Mcal';
		vm.showButton = false;
		vm.getMixHistory = getMixHistory;
		vm.reloadApi = reloadApi;
		vm.goBack = goBack;
		vm.closeDetailsWindow = closeDetailsWindow;
		init();

		function init() {
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			vm.feedCalculationType = localStorage.getItem('feed_calculation_type');
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.calculationType = vm.settings.calculation_type;
			getDefaultTeamHerd();
			if (vm.settings.selectedHerd.id) {
				getFeedHistory($stateParams.uuid);
				setFeedTypes(APP_CONST.constants.feed_types);
				if (!vm.settings.use_kgs) {
					vm.weight = 'lb';
				}
				if (!vm.settings.use_mcal) {
					vm.energy = 'Mjoule';
				}
			}
		}

		function reloadApi() {
			if (vm.settings.selectedHerd.id) {
				getFeedHistory($stateParams.uuid);
			}
		}

		function closeDetailsWindow() {
			vm.showDetails = false;
		}

		function setFeedTypes(feed_types) {
			vm.feed_types = [];
			for (var i = 0; i < feed_types.length; i++) {
				var temp = '_feeds_type_' + feed_types[i].value + '_';
				feed_types[i].show_name = temp;
				feed_types[i].translated = i18nFilter(temp);
				vm.feed_types.push(feed_types[i]);
			}
		}

		function getFeedHistory(feedId) {
			vm.feeds = [];
			return rationFeedHistoryFactory
				.getHistory(feedId)
				.then(function (response) {
					vm.feeds = setFeeds(response, true);
					vm.loading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_feed_history_', true);
				});
		}

		function getDefaultTeamHerd() {
			var settings = JSON.parse(localStorage.getItem('user_settings'));
			if (settings.selectedTeam.id) {
				vm.selectedTeam = settings.selectedTeam;
			}
			if (settings.selectedHerd.id) {
				vm.selectedHerd = settings.selectedHerd;
			}
		}

		function setFeeds(feeds, is_feed) {
			var temp = feeds;
			if (feeds.length > 0) {
				if (feeds[0].is_mix && is_feed) {
					vm.showButton = true;
				}
				for (var i = 0; i < temp.length; i++) {
					temp[i].test_date = new Date(temp[i].test_date);
					temp[i].is_selected = false;
					var hasFeedType = false;
					for (var j = 0; j < vm.feed_types.length; j++) {
						if (temp[i].feed_type.toLowerCase() === vm.feed_types[j].name.toLowerCase()) {
							temp[i].feed_type = vm.feed_types[j];
							hasFeedType = true;
							break;
						}
					}
					if (!hasFeedType) {
						temp[i].feed_type = {
							show_name: '_feeds_type_not_set_'
						};
					}
					if (temp[i].mixes) {
						for (var k = 0; k < temp[i].mixes.length; k++) {
							var hasFeedTypeMix = false;
							for (var m = 0; m < vm.feed_types.length; m++) {
								if (temp[i].mixes[k].feed_type.toLowerCase() === vm.feed_types[m].name.toLowerCase()) {
									temp[i].mixes[k].feed_type = vm.feed_types[m];
									hasFeedTypeMix = true;
									break;
								}
							}
							if (!hasFeedTypeMix) {
								temp[i].mixes[k].feed_type = {
									show_name: '_feeds_type_not_set_'
								};
							}
						}
					}
				}
			}
			return temp;
		}

		function goBack() {
			$window.history.back();
		}

		function getMixHistory() {
			vm.showDetails = true;
			vm.loadingMix = true;
			vm.loading = false;
			return rationFeedHistoryFactory
				.getMixHistory($stateParams.uuid)
				.then(function (response) {
					var changedFeeds = checkDiferencesInMix(response);
					for (var i = 0; i < response.length; i++) {
						for (var j = 0; j < changedFeeds.length; j++) {
							if (response[i].id == changedFeeds[j].id) {
								response[i] = changedFeeds[j];
							}
						}
					}
					vm.loadingMix = false;
					vm.loading = false;
					vm.mix = setFeeds(response, false);
					vm.showMix = true;
				})
				.catch(function (error) {
					vm.loading = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_mix_history_');
				});
		}

		function checkDiferencesInMix(list) {
			var response = [];
			var listOfChanged = [];
			angular.copy(list, response);
			response.reverse();
			var obj = groupBy(response, 'ration_feed_mix_id');
			angular.forEach(obj, function (value) {
				if (value.length > 1) {
					for (var i = 0; i < value.length; i++) {
						if (value[i - 1]) {
							var feed = {};
							var changed = false;
							angular.copy(value[i], feed);
							angular.forEach(value[i], function (v, k) {
								if (value[i - 1][k] != value[i][k]) {
									var string = k + '_changed';
									feed[string] = true;
									changed = true;
								}
							});
							if (changed) {
								listOfChanged.push(feed);
							}
						}
					}
				}
			});
			return listOfChanged;
		}

		function groupBy(xs, key) {
			return xs.reduce(function (rv, x) {
				(rv[x[key]] = rv[x[key]] || []).push(x);
				return rv;
			}, {});
		}

		$scope.$on('default_herd_selected', function () {
			init();
		});

		$scope.$on('default_team_selected', function () {
			vm.selectedHerd = null;
			init();
		});

		$scope.$on('$destroy', function () {
			localStorage.removeItem('feed_calculation_type');
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.rationFeedHistory').factory('rationFeedHistoryFactory', rationFeedHistoryFactory);
	/** @ngInject */
	function rationFeedHistoryFactory($http, APP_CONST, $q) {
		return {
			getHistory: getHistory,
			getMixHistory: getMixHistory
		};

		function getHistory(feedId) {
			return $http
				.get(APP_CONST.api_base_url + 'rationFeedHistory/' + feedId)
				.then(success)
				.catch(error);
		}

		function getMixHistory(feedId) {
			return $http
				.get(APP_CONST.api_base_url + 'rationMixFeedHistory/' + feedId)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.rationComparisonList').controller('rationComparisonListCtrl', rationComparisonListCtrl);
	/** @ngInject */
	function rationComparisonListCtrl(rationComparisonListService, $filter, $scope, $window, APP_CONST, $locale, $timeout, settingsFactory, $cookies, errorService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var searchTimeout;
		var timeoutResize;
		vm.paginationChanged = paginationChanged;
		vm.select = select;
		vm.compare = compare;
		vm.reset = reset;
		vm.selectTableRow = selectTableRow;
		vm.dataCollapseFn = dataCollapseFn;
		vm.searchRation = searchRation;
		vm.reloadApi = reloadApi;
		vm.changeUnits = changeUnits;
		vm.changeAmountProduct = changeAmountProduct;
		vm.stopLoadingTabs = stopLoadingTabs;
		vm.rationFilterString = '';
		vm.herdFilterString = '';
		vm.groupFilterString = '';
		vm.selectedRations = [];
		init();

		function init() {
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			vm.showGroupSelector = false;
			vm.comparisonActive = false;
			vm.loadingGroups = false;
			vm.loadingFeeds = false;
			vm.currentPage = 1;
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			if (vm.settings.use_percent) {
				vm.sliderUsePercent = true;
			} else {
				vm.sliderUsePercent = false;
			}
			setDefaultUnits();
			setFeedTypes(APP_CONST.constants.feed_types);
			setSwitchLabels();
			setUseAmountSwitch();
			getDefaultTeamHerd();
			if (vm.selectedTeam) {
				getRations(1, true);
			}
			vm.loading = true;
			vm.loadingFooter = true;
		}

		function reloadApi() {
			vm.showGroupSelector = false;
			vm.comparisonActive = false;
			vm.loadingGroups = false;
			vm.loadingFeeds = false;
			vm.loading = true;
			vm.loadingFooter = true;
			if (vm.selectedTeam) {
				getRations(1, true);
			}
		}

		function setFeedTypes(feed_types) {
			vm.feed_types = [];
			for (var i = 0; i < feed_types.length; i++) {
				if (feed_types[i].type == vm.settings.calculation_type || feed_types[i].type == 2) {
					var temp = '_feeds_type_' + feed_types[i].value + '_';
					feed_types[i].show_name = temp;
					feed_types[i].translated = i18nFilter(temp);
					vm.feed_types.push(feed_types[i]);
				}
			}
		}

		function setDefaultUnits() {
			if (vm.settings.use_kgs) {
				vm.weight = 'kg';
			} else {
				vm.weight = 'lb';
			}
			if (vm.settings.use_mcal) {
				vm.energy = 'Mcal';
			} else {
				vm.energy = 'Mjoule';
			}
		}

		function getDefaultTeamHerd() {
			var settings = JSON.parse(localStorage.getItem('user_settings'));
			if (settings.selectedTeam.id) {
				vm.selectedTeam = settings.selectedTeam;
			}
			if (settings.selectedHerd.id) {
				vm.selectedHerd = settings.selectedHerd;
			}
		}

		function getRations(page_number, init) {
			var suffix = generateSuffix();
			vm.loadingTable = true;
			vm.loadingTabs = true;
			if (vm.selectedHerd) {
				vm.showGroupSelector = true;
				getRationsByHerd(vm.selectedHerd, page_number, suffix, init);
			} else {
				getRationsByTeam(vm.selectedTeam, page_number, suffix, init);
			}
		}

		function generateSuffix() {
			var first = true;
			var suffix = '';
			if (vm.rationFilterString.length > 0) {
				suffix = suffix + '?rationName=' + encodeURIComponent(vm.rationFilterString);
				first = false;
			}
			if (!vm.selectedHerd) {
				if (vm.herdFilterString.length > 0) {
					if (first) {
						suffix = suffix + '?herdName=' + encodeURIComponent(vm.herdFilterString);
					} else {
						suffix = suffix + '&herdName=' + encodeURIComponent(vm.herdFilterString);
					}
					first = false;
				}
			}
			if (vm.groupFilterString.length > 0) {
				if (first) {
					suffix = suffix + '?groupName=' + encodeURIComponent(vm.groupFilterString);
				} else {
					suffix = suffix + '&groupName=' + encodeURIComponent(vm.groupFilterString);
				}
			}
			return suffix;
		}

		function searchRation() {
			if (searchTimeout) {
				$timeout.cancel(searchTimeout);
			}
			searchTimeout = $timeout(function () {
				getRations(1);
				vm.currentPage = 1;
			}, 1000);
		}

		function getRationsByTeam(team, page_number, suffix, init) {
			return rationComparisonListService
				.getRationsByTeam(team.id, page_number, suffix)
				.then(function (response) {
					response = setSelectedRations(response);
					setRations(response);
					vm.loading = false;
					vm.loadingTabs = false;
					vm.loadingTable = false;
					vm.loadingFooter = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					vm.loadingTable = false;
					vm.loadingFooter = false;
					vm.loadingTabs = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_rations_', init);
				});
		}

		function getRationsByHerd(herd, page_number, suffix, init) {
			return rationComparisonListService
				.getRationsByHerd(herd.id, page_number, suffix)
				.then(function (response) {
					response = setSelectedRations(response);
					setRations(response);
					vm.loadingTabs = false;
					vm.loading = false;
					vm.loadingTable = false;
					vm.loadingFooter = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loadingTabs = false;
					vm.loading = false;
					vm.loadingTable = false;
					vm.loadingFooter = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_rations_', init);
				});
		}

		function select(ration, event) {
			var found = false;
			var index = null;
			if (vm.selectedRations.length == 0) {
				vm.selectedRations.push(ration);
			} else {
				for (var i = 0; i < vm.selectedRations.length; i++) {
					if (vm.selectedRations[i].id == ration.id) {
						found = true;
						index = i;
					}
				}
				if (found) {
					vm.selectedRations.splice(index, 1);
				} else {
					vm.selectedRations.push(ration);
				}
			}
			event.stopPropagation();
		}

		function setSelectedRations(rations) {
			for (var i = 0; i < rations.length; i++) {
				for (var j = 0; j < vm.selectedRations.length; j++) {
					if (rations[i].id == vm.selectedRations[j].id) {
						rations[i].is_selected = true;
					}
				}
			}
			return rations;
		}

		function compare() {
			vm.comparisonActive = true;
			vm.rations = [];
			angular.copy(vm.selectedRations, vm.rations);
			vm.rationsSafe = vm.rations;
		}

		function setRations(response) {
			if (response.length > 0) {
				vm.totalItems = response[0].number_of_all;
			}
			var rations = [];
			for (var r = 0; r < response.length; r++) {
				var ration = {};
				angular.copy(response[r], ration);
				ration.cost_per_cow = ration.supply_Amount.cost_dm;
				ration.target_milk_yield = ration.group.target_milk_yield;
				ration.actual_milk_yield = ration.group.actual_milk_yield;
				ration.cost_per_kg = 0;
				ration.cost_as_fed = 0;
				ration.supply = ration.supply_Amount;
				setDefaultUnits();
				if (ration.target_milk_yield > 0) {
					ration.target_milk_cost = ration.cost_per_cow / ration.target_milk_yield;
				} else {
					ration.target_milk_cost = 0;
				}
				if (ration.actual_milk_yield > 0) {
					ration.actual_milk_cost = ration.cost_per_cow / ration.actual_milk_yield;
				} else {
					ration.actual_milk_cost = 0;
				}
				ration.cost_per_kg = ration.cost_per_cow / ration.supply.amount_dm;
				ration.cost_as_fed = ration.supply_Conc.cost_dm * (ration.supply_Conc.dm / 100);
				rations.push(ration);
			}
			vm.loading = false;
			vm.loadingTabs = false;
			vm.rations = rations;
			vm.rationsSafe = vm.rations;
			dataCollapseFn();
		}

		function reset() {
			vm.selectedRations = [];
			vm.comparisonActive = false;
			vm.loading = true;
			vm.activeTab = undefined;
			init();
		}

		function dataCollapseFn() {
			vm.dataCollapse = [];
			for (var i = 0; i < vm.rations.length; i++) {
				vm.dataCollapse.push(false);
			}
		}

		function selectTableRow(index, id) {
			if (!vm.loadingFeeds) {
				for (var i = 0; i < vm.dataCollapse.length; i++) {
					if (index === i) {
						vm.dataCollapse[i] = !vm.dataCollapse[i];
						break;
					}
				}
				if (vm.dataCollapse[index] === true && (!vm.rations[index].feeds || !vm.rations[index].feeds.length)) {
					vm.rations[index].feeds = [];
					vm.loadingFeeds = true;
					getFeedsByRationId(index, id);
				}
			}
		}

		function getFeedsByRationId(index, id) {
			rationComparisonListService
				.getFeedsByRationId(id)
				.then(function (response) {
					for (var i = 0; i < response.length; i++) {
						vm.rations[index].feeds.push(response[i].feed);
					}
					if (vm.selectedRations.length > 0) {
						for (var j = 0; j < vm.selectedRations.length; j++) {
							if (vm.selectedRations[j].id === id) {
								vm.selectedRations[j].feeds = angular.copy(vm.rations[index].feeds);
							}
						}
					}
					vm.loadingFeeds = false;
				})
				.catch(function (error) {
					vm.loadingFeeds = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_feeds_');
				});
		}

		$scope.$on('menu_collapsed', function () {
			setResize();
		});

		angular.element($window).bind('resize', function () {
			setResize();
		});

		$scope.$on('$destroy', function () {
			angular.element($window).unbind('resize');
		});

		function setResize() {
			if (timeoutResize) {
				$timeout.cancel(timeoutResize);
			}
		}

		$scope.$watch('vm.activeTab', function (newValue) {
			vm.loadingTabs = true;
			$timeout(function () {
				vm.showHome = newValue == 1 ? true : false;
				vm.showFiber = newValue == 2 ? true : false;
				vm.showEnergy = newValue == 3 ? true : false;
				vm.showProtein = newValue == 4 ? true : false;
				vm.showCarb = newValue == 5 ? true : false;
				vm.showLipid = newValue == 6 ? true : false;
				vm.showMineral = newValue == 7 ? true : false;
				vm.showTMineral = newValue == 8 ? true : false;
				vm.showVitamin = newValue == 9 ? true : false;
				vm.showAA = newValue == 10 ? true : false;
				vm.showCostTab = newValue == 11 ? true : false;
				vm.showMisc = newValue == 12 ? true : false;
			}, 10);
		});

		function stopLoadingTabs() {
			$timeout(function () {
				vm.loadingTabs = false;
			}, 50);
		}

		function changeUnits() {
			if (vm.sliderUsePercent) {
				vm.settings.use_percent = true;
			} else {
				vm.settings.use_percent = false;
			}
			localStorage.setItem('user_settings', JSON.stringify(vm.settings));
			if (vm.selectedRations.length > 0) {
				compare();
			} else {
				init(true);
				vm.loading = false;
			}
			saveSettings();
		}

		function setSwitchLabels() {
			vm.amountSwitchLabel = i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_');
			vm.productSwitchLabel = i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_m_f_product_switch_product_type');
		}

		function setUseAmountSwitch() {
			try {
				var sw = JSON.parse($cookies.get('use_product'));
			} catch (error) {
				vm.switchUseAmount = true;
				$cookies.put('use_product', vm.switchUseAmount, {
					expires: moment().add(1, 'month').toDate()
				});
			}
			if (sw != null) {
				vm.switchUseAmount = sw;
			}
		}

		function changeAmountProduct() {
			vm.loadingTabs = true;
			$cookies.put('use_product', vm.switchUseAmount, {
				expires: moment().add(1, 'month').toDate()
			});
			$timeout(function () {
				vm.loadingTabs = false;
			}, 250);
		}

		function saveSettings() {
			localStorage.setItem('user_settings', JSON.stringify(vm.settings));
			settingsFactory
				.changeSettings(vm.settings, vm.user.email)
				.then()
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_saving_user_settings_');
				});
		}

		function paginationChanged() {
			getRations(vm.currentPage);
		}

		$scope.$on('default_herd_selected', function () {
			vm.herdFilterString = '';
			init();
		});

		$scope.$on('default_team_selected', function () {
			vm.selectedHerd = null;
			vm.showGroupSelector = false;
			init();
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.rationComparisonList').factory('rationComparisonListService', rationComparisonListService);
	/** @ngInject */
	function rationComparisonListService($http, $q, APP_CONST) {
		return {
			getRationsByTeam: getRationsByTeam,
			getRationsByHerd: getRationsByHerd,
			getGroupsByHerd: getGroupsByHerd,
			getFeedsByRationId: getFeedsByRationId
		};

		function getRationsByTeam(teamId, page_number, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'comparison/teams/' + teamId + '/rations/' + page_number + suffix)
				.then(success)
				.catch(error);
		}

		function getRationsByHerd(herdId, page_number, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'comparison/herds/' + herdId + '/rations/' + page_number + suffix)
				.then(success)
				.catch(error);
		}

		function getGroupsByHerd(herdId) {
			return $http
				.get(APP_CONST.api_base_url + 'herds/' + herdId + '/groups')
				.then(success)
				.catch(error);
		}

		function getFeedsByRationId(id) {
			return $http
				.get(APP_CONST.api_base_url + 'rations/' + id + '/feeds')
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.reports.compliance').controller('complianceCtrl', complianceCtrl);
	/** @ngInject */
	function complianceCtrl(complianceService, $scope, $q, $timeout, $filter, errorService) {
		var vm = this;
		var herdPromise;
		var pensPromise;
		var selectPenTimer;
		vm.changeFilterVisibility = changeFilterVisibility;
		vm.penSelected = penSelected;
		vm.reloadApi = reloadApi;
		init();

		function init() {
			vm.loading = true;
			vm.showFilter = false;
			vm.currentPage = 1;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.colors = [
				{
					status: 'done',
					color: '#00FF00',
					status_label: 'Done'
				},
				{
					status: 'ongoing',
					color: '#FFA500',
					status_label: 'Ongoing'
				},
				{
					status: 'todo',
					color: '#0000FF',
					status_label: 'To do'
				}
			];
			vm.polygons = [
				{
					value: [
						[
							{
								lat: 51.08440172544414,
								lng: 4.242758758166474
							},
							{
								lat: 51.08415909972752,
								lng: 4.244775779345673
							},
							{
								lat: 51.083026829556786,
								lng: 4.244904525378388
							},
							{
								lat: 51.0829998704054,
								lng: 4.243187911608857
							}
						]
					]
				},
				{
					value: [
						[
							{
								lat: 51.08553396196197,
								lng: 4.238767631152314
							},
							{
								lat: 51.084752182565914,
								lng: 4.241299636462372
							},
							{
								lat: 51.0838895141054,
								lng: 4.2411708904296574
							},
							{
								lat: 51.08326946121218,
								lng: 4.238939292529267
							}
						]
					]
				},
				{
					value: null
				},
				{
					value: [
						[
							{
								lat: 51.08610006982811,
								lng: 4.2405700756103215
							},
							{
								lat: 51.08610006982811,
								lng: 4.242715842822236
							},
							{
								lat: 51.08512959495848,
								lng: 4.242587096789521
							},
							{
								lat: 51.085210468641975,
								lng: 4.241471297839325
							}
						]
					]
				},
				{
					value: null
				},
				{
					value: [
						[
							{
								lat: 51.08445564209723,
								lng: 4.253659255602997
							},
							{
								lat: 51.083566009284986,
								lng: 4.254989631274384
							},
							{
								lat: 51.08248764354411,
								lng: 4.253187186816376
							},
							{
								lat: 51.083026829556786,
								lng: 4.252543456652802
							},
							{
								lat: 51.083970389956995,
								lng: 4.252972610095185
							}
						]
					]
				},
				{
					value: [
						[
							{
								lat: 51.083916472738295,
								lng: 4.247651107409638
							},
							{
								lat: 51.08286507441285,
								lng: 4.248895652392548
							},
							{
								lat: 51.08246068407853,
								lng: 4.248251922228974
							},
							{
								lat: 51.083026829556786,
								lng: 4.246706969836396
							}
						]
					]
				},
				{
					value: null
				},
				{
					value: [
						[
							{
								lat: 51.08353905044785,
								lng: 4.236021049121064
							},
							{
								lat: 51.0839434313555,
								lng: 4.23735142479245
							},
							{
								lat: 51.08359296810642,
								lng: 4.23786640892331
							},
							{
								lat: 51.083188584135115,
								lng: 4.2364502025634465
							}
						]
					]
				},
				{
					value: null
				}
			];
			if (vm.settings && vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd;
				herdPromise = $q.defer();
				pensPromise = $q.defer();
				getHerdById(vm.settings.selectedHerd.id);
				getPens(vm.currentPage);
				$q.all([herdPromise.promise, pensPromise.promise]).then(function (response) {
					var pens = response[1];
					for (var i = 0; i < pens.length; i++) {
						pens[i].polygon_color = setPolygonColor(i).color;
						pens[i].pen_status = setPolygonColor(i).status_label;
					}
					vm.list_to_show = [];
					for (var j = 0; j < response[1].length; j++) {
						if (response[1][j].pen_location && vm.list_to_show.length < 10) {
							vm.pens[j].is_selected = true;
							vm.list_to_show.push(response[1][j]);
						}
					}
					$timeout(function () {
						initialize(response[0], vm.list_to_show);
					}, 125);
				});
			} else {
				vm.selectedHerd = null;
				vm.loading = false;
			}
		}

		function reloadApi() {
			vm.loading = true;
			if (vm.settings && vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd;
				herdPromise = $q.defer();
				pensPromise = $q.defer();
				getHerdById(vm.settings.selectedHerd.id);
				getPens(vm.currentPage);
				$q.all([herdPromise.promise, pensPromise.promise]).then(function (response) {
					var pens = response[1];
					for (var i = 0; i < pens.length; i++) {
						pens[i].polygon_color = setPolygonColor(i).color;
						pens[i].pen_status = setPolygonColor(i).status_label;
					}
					vm.list_to_show = [];
					for (var j = 0; j < response[1].length; j++) {
						if (response[1][j].pen_location && vm.list_to_show.length < 10) {
							vm.pens[j].is_selected = true;
							vm.list_to_show.push(response[1][j]);
						}
					}
					$timeout(function () {
						initialize(response[0], vm.list_to_show);
					}, 125);
				});
			} else {
				vm.selectedHerd = null;
				vm.loading = false;
			}
		}

		function setPolygonColor(index) {
			if (index % 2 == 0) {
				return vm.colors[1];
			} else if (index % 3 == 0) {
				return vm.colors[2];
			} else {
				return vm.colors[0];
			}
		}

		function getHerdById(herdId) {
			return complianceService
				.getHerdById(herdId)
				.then(function (response) {
					vm.herd = response;
					herdPromise.resolve(response);
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_herds_', true);
				});
		}

		function getPens(currentPage) {
			var suffix = '?page=' + currentPage;
			if (vm.settings && vm.settings.selectedHerd.id) {
				vm.loadingTable = true;
				suffix = suffix + '&team=' + vm.settings.selectedTeam.id;
				suffix = suffix + '&herd=' + vm.settings.selectedHerd.id;
				vm.loadingTable = true;
				return complianceService
					.getPensByTeamHerd(suffix)
					.then(function (response) {
						for (var i = 0; i < response.length; i++) {
							response[i].pen_location = vm.polygons[i].value;
						}
						if (response[0]) {
							vm.totalItems = response[0].number_of_all;
						} else {
							vm.totalItems = 0;
						}
						vm.pens = response;
						//                    var list = [];
						//                    for (var i = 0; i < vm.pens.length; i++) {
						//                        var it = angular.copy(vm.pens[i]);
						//                        var ir = angular.copy(vm.pens[i]);
						//                        it.id = 'aaa' + i;
						//                        ir.id = 'bbb' + i;
						//                        list.push(it);
						//                        list.push(ir);
						//                    }
						//                    vm.pens = vm.pens.concat(list);
						pensPromise.resolve(vm.pens);
						vm.loading = false;
						vm.loadingTable = false;
					})
					.catch(function (error) {
						console.log(error);
						vm.loading = false;
						vm.loadingTable = false;
						errorService.showErrorMessage(error, true, '_error_occurred_loading_pen_', true);
					});
			}
		}

		function initialize(herd, pens) {
			var zoom;
			if (herd.Latitude && herd.Longitude) {
				herd.Latitude = 51.0853183;
				herd.Longitude = 4.2473507;
				zoom = 16;
			} else {
				herd.Latitude = 51.0853183;
				// herd.Latitude = 43.8900745;
				herd.Longitude = 4.2473507;
				//herd.Longitude = 20.3492278;
				//  zoom = 3;
				zoom = 16;
				vm.latLngMissing = true;
			}
			var id = 'comp-map';
			var mapCanvas = document.getElementById(id);
			var mapOptions = {
				center: new google.maps.LatLng(herd.Latitude, herd.Longitude),
				zoom: zoom,
				mapTypeId: google.maps.MapTypeId.SATELLITE
			};
			var map = new google.maps.Map(mapCanvas, mapOptions);
			for (var i = 0; i < pens.length; i++) {
				addPolygon(pens[i]);
			}
			var infowindow = new google.maps.InfoWindow({
				size: new google.maps.Size(150, 50)
			});
			function addPolygon(pen) {
				if (pen.pen_location) {
					vm[pen.id] = new google.maps.Polygon({
						paths: pen.pen_location,
						strokeColor: pen.polygon_color,
						strokeOpacity: 0.8,
						strokeWeight: 2,
						fillColor: pen.polygon_color,
						fillOpacity: 0.35
					});
					vm[pen.id].setMap(map);
					google.maps.event.addListener(vm[pen.id], 'click', function (event) {
						var contentString =
							'<span>' +
							pen.pen_name +
							'</span><br>' +
							'<span>Status:</span><span style="margin-left:3px">' +
							pen.pen_status +
							'</span><br><span>Feeding start:<span style="margin-left:3px">' +
							$filter('date')(pen.feeding_1, 'hh:mm a') +
							'</span><br><span>Loaded:</span><span style="margin-left:3px">' +
							(Math.floor(Math.random() * 500) + 1) +
							'kg</span><br><span>Deviation:<span><span style="margin-left:3px">' +
							(Math.floor(Math.random() * 20) + 1) +
							'kg</span>';
						infowindow.setContent(contentString);
						infowindow.setPosition(event.latLng);
						infowindow.open(map);
					});
				}
			}
		}

		function penSelected() {
			var list = [];
			for (var i = 0; i < vm.pens.length; i++) {
				if (vm.pens[i].is_selected) {
					list.push(vm.pens[i]);
				}
			}
			vm.list_to_show = list;
			if (selectPenTimer) {
				$timeout.cancel(selectPenTimer);
			}
			selectPenTimer = $timeout(function () {
				initialize(vm.herd, vm.list_to_show);
			}, 500);
		}

		function changeFilterVisibility() {
			vm.showFilter = !vm.showFilter;
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});

		$scope.$on('default_team_selected', function () {
			init();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.reports.compliance').factory('complianceService', complianceService);
	/** @ngInject */
	function complianceService(APP_CONST, $http, $q) {
		return {
			getPensByTeamHerd: getPensByTeamHerd,
			getHerdById: getHerdById
		};

		function getPensByTeamHerd(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'pens' + suffix)
				.then(success)
				.catch(error);
		}

		function getHerdById(herdId) {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/herds/' + herdId)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.reports.communication').controller('communicationCtrl', communicationCtrl);
	/** @ngInject */
	function communicationCtrl() {
		var vm = this;
		console.log(vm);
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.rationHistory').controller('rationHistoryCtrl', rationHistoryCtrl);
	/** @ngInject */
	function rationHistoryCtrl($stateParams, $scope, rationHistoryFactory, APP_CONST, $state, $filter, $locale, errorService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		vm.showFeeds = false;
		vm.goBack = goBack;
		vm.reloadApi = reloadApi;
		vm.weight = 'kg';
		vm.energy = 'Mcal';
		init();

		function init() {
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			vm.loading = true;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.calculationType = JSON.parse(localStorage.getItem('ration_calculation_type'));
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			getDefaultTeamHerd();
			if (vm.settings.selectedHerd.id) {
				getHistory($stateParams.groupId, $stateParams.rationId, vm.settings.selectedHerd.id);
				getFeedHistory($stateParams.rationId, vm.settings.selectedHerd.id);
				setFeedTypes(APP_CONST.constants.feed_types);
				vm.tempStress = APP_CONST.constants.temperature_stresses;
				vm.activityLevels = APP_CONST.constants.activity_levels;
				vm.feedAdditives = APP_CONST.constants.feed_additives;
				vm.metProtSys = APP_CONST.constants.met_prot_sys;
				if (!vm.settings.use_kgs) {
					vm.weight = 'lb';
				}
				if (!vm.settings.use_mcal) {
					vm.energy = 'Mjoule';
				}
			}
		}

		function reloadApi() {
			vm.loading = true;
			if (vm.settings.selectedHerd.id) {
				getHistory($stateParams.groupId, $stateParams.rationId, vm.settings.selectedHerd.id);
				getFeedHistory($stateParams.rationId, vm.settings.selectedHerd.id);
			}
		}

		function setFeedTypes(feed_types) {
			vm.feed_types = [];
			for (var i = 0; i < feed_types.length; i++) {
				var temp = '_feeds_type_' + feed_types[i].value + '_';
				feed_types[i].show_name = temp;
				feed_types[i].translated = i18nFilter(temp);
				vm.feed_types.push(feed_types[i]);
			}
		}

		function getDefaultTeamHerd() {
			var settings = JSON.parse(localStorage.getItem('user_settings'));
			if (settings.selectedTeam.id) {
				vm.selectedTeam = settings.selectedTeam;
			}
			if (settings.selectedHerd.id) {
				vm.selectedHerd = settings.selectedHerd;
			}
		}

		function setFeeds(feeds) {
			var temp = feeds;
			for (var i = 0; i < temp.length; i++) {
				temp[i].test_date = new Date(temp[i].test_date);
				temp[i].is_selected = false;
				var hasFeedType = false;
				for (var j = 0; j < vm.feed_types.length; j++) {
					if (temp[i].feed_type.toLowerCase() === vm.feed_types[j].name.toLowerCase()) {
						temp[i].feed_type = vm.feed_types[j];
						hasFeedType = true;
						break;
					}
				}
				if (!hasFeedType) {
					temp[i].feed_type = {
						show_name: '_feeds_type_not_set_'
					};
				}
				if (temp[i].mixes) {
					for (var k = 0; k < temp[i].mixes.length; k++) {
						var hasFeedTypeMix = false;
						for (var m = 0; m < vm.feed_types.length; m++) {
							if (temp[i].mixes[k].feed_type.toLowerCase() === vm.feed_types[m].name.toLowerCase()) {
								temp[i].mixes[k].feed_type = vm.feed_types[m];
								hasFeedTypeMix = true;
								break;
							}
						}
						if (!hasFeedTypeMix) {
							temp[i].mixes[k].feed_type = {
								show_name: '_feeds_type_not_set_'
							};
						}
					}
				}
			}
			return temp;
		}

		function getHistory(groupId, rationId) {
			return rationHistoryFactory
				.getHistory(groupId, rationId)
				.then(function (response) {
					for (var k = 0; k < response.length; k++) {
						for (var i = 0; i < vm.tempStress.length; i++) {
							if (vm.tempStress[i].name == response[k].temperature_stress) {
								response[k].temperature_stress = vm.tempStress[i].value;
								break;
							}
						}
						for (var j = 0; j < vm.activityLevels.length; j++) {
							if (vm.activityLevels[j].name == response[k].activity_level) {
								response[k].activity_level = vm.activityLevels[j].value;
								break;
							}
						}
						for (var m = 0; m < vm.feedAdditives.length; m++) {
							if (vm.feedAdditives[m].name == response[k].description) {
								response[k].description = vm.feedAdditives[m].value;
								break;
							}
						}
						for (var l = 0; l < vm.metProtSys.length; l++) {
							if (vm.metProtSys[l].value == response[k].model_name) {
								response[k].model_name = vm.metProtSys[l].name;
								break;
							}
						}
					}
					vm.rations = response;
					vm.loading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_ration_history_', true);
				});
		}

		function goBack() {
			$state.go('rations.balanceration', {
				uuid: $stateParams.rationId
			});
		}

		function getFeedHistory(rationId, herdId) {
			return rationHistoryFactory
				.getFeedsHistory(rationId, herdId)
				.then(function (response) {
					vm.feeds = setFeeds(response);
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_feed_history_', true);
				});
		}
		$scope.$on('default_herd_selected', function () {
			init();
		});

		$scope.$on('default_team_selected', function () {
			vm.selectedHerd = null;
			init();
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.rationHistory').factory('rationHistoryFactory', rationHistoryFactory);
	/** @ngInject */
	function rationHistoryFactory($http, APP_CONST, $q) {
		return {
			getHistory: getHistory,
			getFeedsHistory: getFeedsHistory
		};

		function getHistory(groupId, rationId) {
			return $http
				.get(APP_CONST.api_base_url + 'groups/' + groupId + '/rationHeaderHistory/' + rationId)
				.then(success)
				.catch(error);
		}

		function getFeedsHistory(rationId, herdId) {
			return $http
				.get(APP_CONST.api_base_url + 'herd/' + herdId + '/rationFeedHistory/rationHeader/' + rationId)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function() {
	'use strict';
	angular.module('Spartan.pages.reports.weighback').controller('weighbackCtrl', weighbackCtrl);
	/** @ngInject */
	function weighbackCtrl($filter, $uibModal, dataServiceFactory, $uibModalStack, $scope, $q, weighbackService, errorService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		vm.selectLayout = selectLayout;
		vm.dataCollapseFn = dataCollapseFn;
		vm.selectTableRow = selectTableRow;
		vm.setBackgroundColor = setBackgroundColor;
		vm.changeColors = changeColors;
		vm.openFilterModal = openFilterModal;
		vm.selectPredefinedDates = selectPredefinedDates;
		vm.cancel = cancel;
		vm.showCustomSelector = showCustomSelector;
		vm.paginationChanged = paginationChanged;
		vm.getLineStyle = getLineStyle;
		vm.saveFilter = saveFilter;
		vm.tableRowExpanded = false;
		vm.tableRowIndexExpandedCurr = '';
		vm.tableRowIndexExpandedPrev = '';
		vm.idExpanded = '';
		vm.loading = false;
		vm.selectedHerd = true;
		vm.selectedLayout = 1;
		vm.currentPage = 1;
		vm.itemsPerPage = 10;
		vm.reloadApi = reloadApi;
		var categories;
		var pens;
		var recipes;
		init();

		function init() {
			vm.loading = true;
			vm.checkInit = false;
			vm.filterSuffix = '';
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.end_date_picker = new Date();
			var s_d = moment()
				.subtract(7, 'days')
				.format();
			vm.start_date_picker = new Date(s_d);
			vm.show_custom_selector = false;
			setDefaultFilters();
			if (vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd.id;
				getReports(null, true);
			} else {
				vm.selectedHerd = null;
				vm.loading = false;
			}
			if (!vm.settings.use_kgs) {
				vm.weight = 'Lb';
			} else {
				vm.weight = 'Kg';
			}
		}

		function reloadApi() {
			vm.loading = true;
			vm.checkInit = false;
			if (vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd.id;
				getReports(null, true);
			} else {
				vm.selectedHerd = null;
				vm.loading = false;
			}
		}

		function getCategories() {
			return weighbackService
				.getCategories()
				.then(function(response) {
					vm.categories = response;
					console.log(response);
					categories.resolve();
				})
				.catch(function(error) {
					console.log(error);
					categories.reject();
					errorService.showErrorMessage(error, true, '_error_occurred_loading_categories_');
				});
		}

		function getPens() {
			var suffix = '?page=1';
			if (vm.settings && vm.settings.selectedHerd.id) {
				suffix = suffix + '&team=' + vm.settings.selectedTeam.id;
				suffix = suffix + '&herd=' + vm.settings.selectedHerd.id;
				return weighbackService
					.getPensByTeamHerd(suffix)
					.then(function(response) {
						vm.pens = response;
						pens.resolve();
						console.log(response);
					})
					.catch(function(error) {
						pens.reject();
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_loading_pen_');
					});
			}
		}

		function getRecipes() {
			var suffix = '';
			if (vm.settings && vm.settings.selectedHerd.id) {
				suffix = suffix + '?team=' + vm.settings.selectedTeam.id;
				suffix = suffix + '&herd=' + vm.settings.selectedHerd.id;
				return weighbackService
					.getRecipeByTeamHerd(suffix)
					.then(function(response) {
						console.log('Recipe', response);
						vm.recipes = response;
						recipes.resolve();
					})
					.catch(function(error) {
						recipes.reject();
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_loading_recipes_');
					});
			}
		}

		function selectLayout(type) {
			vm.selectedLayout = type;
		}

		function selectPredefinedDates() {
			vm.start_date = vm.selectedPredefinedDate.start_date;
			vm.end_date = vm.selectedPredefinedDate.end_date;
			vm.show_custom_selector = false;
			console.log(vm.end_date);
			console.log(vm.start_date);
		}

		function setDefaultFilters() {
			vm.selectedRecipe = null;
			vm.selectedCategory = null;
			vm.selectedPen = null;
			vm.recipeFilterActive = false;
			vm.predefinedDates = [
				{
					id: 'last_week',
					name:  i18nFilter('_unit_last_week_'),
					end_date: moment().format(),
					start_date: moment()
						.subtract(7, 'days')
						.format()
				},
				{
					id: 'last_month',
					name:  i18nFilter('_unit_last_month_'),
					end_date: moment().format(),
					start_date: moment()
						.subtract(1, 'months')
						.format()
				}
			];
			vm.selectedPredefinedDate = vm.predefinedDates[0];
			selectPredefinedDates();
			console.log(vm.predefinedDates);
		}

		function paginationChanged() {
			vm.checkInit = true;
			if (vm.filterSuffix) {
				var suffix = '?herd=' + vm.selectedHerd + '&page_number=' + vm.currentPage;
				suffix += vm.filterSuffix;
				getReports(suffix);
			} else {
				getReports();
			}
		}

		function changeColors() {
			for (var i = 0; i < vm.reports.length; i++) {
				vm.reports[i].filtered_date = $filter('date')(vm.reports[i].report_date, 'dd-MM-yyyy');
			}
			//   var test = groupByDate(vm.reports);
			var test = $filter('groupBy')(vm.reports, 'filtered_date');
			var link_list = [];
			angular.forEach(test, function(value, key) {
				var link = {
					color: getRandomColor(),
					date: key
				};
				link_list.push(link);
			});
			for (var j = 0; j < vm.reports.length; j++) {
				for (var k = 0; k < link_list.length; k++) {
					if (vm.reports[j].filtered_date == link_list[k].date) {
						vm.reports[j].color = link_list[k].color;
					}
				}
			}
		}

		function showCustomSelector() {
			vm.show_custom_selector = !vm.show_custom_selector;
		}

		function getRandomColor() {
			var a = 'hsla(' + Math.random() * 360 + ', 100%, 50%, 1)';
			return a;
		}

		function setBackgroundColor(color) {
			var a = {
				backgroundColor: color
			};
			return a;
		}

		function dataCollapseFn() {
			vm.dataCollapse = [];
			for (var i = 0; i < vm.reports.length; i++) {
				vm.dataCollapse.push(false);
			}
			if (vm.dataSubCollapse && vm.dataSubCollapse.length > 0) {
				for (var j = 0; j < vm.dataSubCollapse.length; j++) {
					vm.dataSubCollapse[j] = false;
				}
			}
			console.log(vm.dataCollapse);
		}

		function getLineStyle(line) {
			var style = {
				borderBottomColor: line.color,
				borderBottomStyle: line.line
			};
			return style;
		}

		function openFilterModal() {
			vm.modalLoading = true;
			openModal('app/pages/reports/weighback/filter.modal.html', 'md');
			if (!vm.pens || !vm.categories) {
				if (vm.settings && vm.settings.selectedHerd.id) {
					categories = $q.defer();
					pens = $q.defer();
					recipes = $q.defer();
					getCategories();
					getPens();
					getRecipes();
					$q.all([categories.promise, pens.promise, recipes.promise])
						.then(function() {
							vm.modalLoading = false;
						})
						.catch(function() {
							vm.modalLoading = false;
						});
				}
			} else {
				vm.modalLoading = false;
			}
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function cancel() {
			$uibModalStack.dismissAll();
		}

		function selectTableRow(index, id) {
			vm.selectedList = [];
			if (typeof vm.dayDataCollapse === 'undefined') {
				vm.dataCollapseFn();
			}
			if (vm.tableRowExpanded === false && vm.tableRowIndexExpandedCurr === '' && vm.idExpanded === '') {
				vm.tableRowIndexExpandedPrev = '';
				vm.tableRowExpanded = true;
				vm.tableRowIndexExpandedCurr = index;
				vm.idExpanded = id;
				vm.dataCollapse[index] = true;
			} else if (vm.tableRowExpanded === true) {
				if (vm.tableRowIndexExpandedCurr === index && vm.idExpanded === id) {
					vm.tableRowExpanded = false;
					vm.tableRowIndexExpandedCurr = '';
					vm.idExpanded = '';
					vm.dataCollapse[index] = false;
				} else {
					vm.tableRowIndexExpandedPrev = vm.tableRowIndexExpandedCurr;
					vm.tableRowIndexExpandedCurr = index;
					vm.idExpanded = id;
					vm.dataCollapse[vm.tableRowIndexExpandedPrev] = false;
					vm.dataCollapse[vm.tableRowIndexExpandedCurr] = true;
				}
			}
		}

		function saveFilter() {
			var suffix = '';
			vm.filterSuffix = '';
			if (vm.selectedLayout == 1) {
				suffix = '?herd=' + vm.selectedHerd + '&page_number=' + vm.currentPage;
			} else {
				suffix = '?herd=' + vm.selectedHerd;
			}
			if (vm.selectedRecipe) {
				vm.filterSuffix += '&recipe_id=' + vm.selectedRecipe.id;
			}
			if (vm.selectedPen) {
				vm.filterSuffix += '&pen_id=' + vm.selectedPen.id;
			}
			if (vm.selectedCategory) {
				vm.filterSuffix += '&pen_categoryid=' + vm.selectedCategory.id;
			}
			var start_date = null;
			var end_date = null;
			if (vm.selectedPredefinedDate && !vm.show_custom_selector) {
				start_date = vm.selectedPredefinedDate.start_date.split('T')[0];
				end_date = vm.selectedPredefinedDate.end_date.split('T')[0];
				vm.filterSuffix += '&start_date=' + start_date + '&end_date=' + end_date;
			}
			if (vm.show_custom_selector) {
				start_date = vm.start_date_picker.toISOString().split('T')[0];
				end_date = vm.end_date_picker.toISOString().split('T')[0];
				vm.filterSuffix += '&start_date=' + start_date + '&end_date=' + end_date;
			}
			suffix += vm.filterSuffix;
			if (vm.selectedLayout == 1) {
				vm.checkInit = true;
				getReports(suffix);
			}
			cancel();
			filterActiveValidation();
		}

		function filterActiveValidation() {
			var start_date = vm.start_date_picker.toISOString().split('T')[0];
			var start_date_changed = vm.selectedPredefinedDate.start_date.split('T')[0];
			var end_date = vm.end_date_picker.toISOString().split('T')[0];
			var end_date_changed = vm.selectedPredefinedDate.end_date.split('T')[0];
			if (vm.selectedRecipe || vm.selectedPen || vm.selectedCategory || start_date != start_date_changed || end_date != end_date_changed) {
				vm.recipeFilterActive = true;
			} else {
				vm.recipeFilterActive = false;
			}
		}

		function getReports(suffix, init) {
			vm.loadingTable = true;
			var new_suffix;
			if (suffix) {
				new_suffix = suffix;
			} else {
				new_suffix = '?herd=' + vm.selectedHerd + '&page_number=' + vm.currentPage;
			}
			console.log(new_suffix);
			return weighbackService
				.getReports(new_suffix)
				.then(function(response) {
					if (response.length > 0 && response[0].number_of_all) {
						vm.totalItems = response[0].number_of_all;
					} else {
						vm.totalItems = 0;
					}
					for (var i = 0; i < response.length; i++) {
						for (var j = 0; j < response[i].pen_feedingWeight_DTO.length; j++) {
							if (!vm.settings.use_kgs) {
								response[i].pen_feedingWeight_DTO[j].intake_pen = dataServiceFactory.kgToLb(response[i].pen_feedingWeight_DTO[j].intake_pen);
								response[i].pen_feedingWeight_DTO[j].intake_animal = dataServiceFactory.kgToLb(response[i].pen_feedingWeight_DTO[j].intake_animal);
							}
						}
						if (!vm.settings.use_kgs) {
							response[i].total_load = dataServiceFactory.kgToLb(response[i].total_load);
						}
					}
					console.log(response);
					vm.reports = response;
					vm.loading = false;
					vm.loadingTable = false;
				})
				.catch(function(error) {
					vm.loading = false;
					vm.loadingTable = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_reports_', init);
				});
		}

		$scope.$on('reload_apis', function() {
			reloadApi();
		});

		$scope.$on('default_herd_selected', function() {
			init();
		});

		$scope.$on('default_team_selected', function() {
			init();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.reports.weighback').factory('weighbackService', weighbackService);
	/** @ngInject */
	function weighbackService(APP_CONST, $http, $q) {
		return {
			getCategories: getCategories,
			getPensByTeamHerd: getPensByTeamHerd,
			getReports: getReports,
			getRecipeByTeamHerd: getRecipeByTeamHerd
		};

		function getCategories() {
			return $http
				.get(APP_CONST.api_base_url + 'penCategories')
				.then(success)
				.catch(error);
		}

		function getPensByTeamHerd(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'pens' + suffix)
				.then(success)
				.catch(error);
		}

		function getReports(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'weightbacksreport' + suffix)
				.then(success)
				.catch(error);
		}

		function getRecipeByTeamHerd(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'recipes' + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.reports.mixing').controller('mixingCtrl', mixingCtrl);
	/** @ngInject */
	function mixingCtrl($timeout, $filter, $uibModal, $locale, dataServiceFactory, $uibModalStack, $state, $scope, $q, mixingService, APP_CONST, $http, errorService, unitConversionService) {
		var vm = this;
		vm.selectLayout = selectLayout;
		var i18nFilter = $filter('i18n');
		vm.dataCollapseFn = dataCollapseFn;
		vm.selectTableRow = selectTableRow;
		vm.setBackgroundColor = setBackgroundColor;
		vm.openFilterModal = openFilterModal;
		vm.selectPredefinedDates = selectPredefinedDates;
		vm.paginationChanged = paginationChanged;
		vm.cancel = cancel;
		vm.showCustomSelector = showCustomSelector;
		vm.getRecipeStyle = getRecipeStyle;
		vm.getRecipeLineStyle = getRecipeLineStyle;
		vm.saveFilter = saveFilter;
		vm.onSelect = onSelect;
		vm.reloadApi = reloadApi;
		vm.checkAll = checkAll;
		vm.tableRowExpanded = false;
		vm.tableRowIndexExpandedCurr = '';
		vm.tableRowIndexExpandedPrev = '';
		vm.idExpanded = '';
		vm.tableSubRowExpanded = false;
		vm.tableSubRowIndexExpandedCurr = '';
		vm.tableSubRowIndexExpandedPrev = '';
		vm.idExpandedSub = '';
		vm.selectedHerd = true;
		vm.back = back;
		vm.checkDateValidation = checkDateValidation;
		var categories;
		var pens;
		var recipes;
		var legendTimeout;
		init();

		function init() {
			vm.state_changed = false;
			vm.categories = null;
			vm.recipes = null;
			vm.pens = null;
			vm.loading = true;
			vm.loadingTable = true;
			vm.checkAllInput = true;
			vm.currentPage = 1;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.fromCalendar = JSON.parse(localStorage.getItem('from_calendar'));
			//localStorage.removeItem('from_calendar');
			vm.amountLabel = $filter('i18n')('_m_f_label_amount_');
			if (vm.fromCalendar) {
				vm.selectedLayout = 2;
			} else {
				vm.selectedLayout = 1;
			}
			setDefaultFilters();
			setDefaultColors();
			if (vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd.id;
				getReports(true, vm.fromCalendar);
			} else {
				vm.selectedHerd = null;
				vm.loading = false;
			}
			if (!vm.settings.use_kgs) {
				vm.weight = 'Lb';
			} else {
				vm.weight = 'Kg';
			}
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			vm.category_names = [
				{
					name: i18nFilter('_milking_cows_hp_'),
					id: 1
				},
				{
					name: i18nFilter('_milking_cows_lp_'),
					id: 2
				},
				{
					name: i18nFilter('_dry_cows_'),
					id: 3
				},
				{
					name: i18nFilter('_heifers_2nd_year_of_life_'),
					id: 4
				},
				{
					name: i18nFilter('_heifers_1st_year_of_life_'),
					id: 5
				},
				{
					name: i18nFilter('_fattening_bulls_'),
					id: 6
				},
				{
					name: i18nFilter('_calves_'),
					id: 7
				}
			];
		}

		function reloadApi() {
			vm.loading = true;
			vm.loadingTable = true;
			if (vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd.id;
				getReports(true);
			} else {
				vm.selectedHerd = null;
				vm.loading = false;
			}
		}

		function getCategories() {
			var suffix = '?teamId=' + vm.settings.selectedTeam.id + '&herdId=' + vm.settings.selectedHerd.id;

			return mixingService
				.getCategories(suffix)
				.then(function (response) {
					vm.categories = response;
					setCategoryName(response);
					categories.resolve();
				})
				.catch(function (error) {
					console.log(error);
					categories.reject();
					errorService.showErrorMessage(error, true, '_error_occurred_loading_categories_');
				});
		}

		function getPens() {
			if (vm.settings && vm.settings.selectedHerd.id) {
				var suffix = '?team=' + vm.settings.selectedTeam.id + '&herd=' + vm.settings.selectedHerd.id;
				return mixingService
					.getPensByTeamHerd(suffix)
					.then(function (response) {
						vm.pens = response;
						pens.resolve();
					})
					.catch(function (error) {
						pens.reject();
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_loading_pen_');
					});
			}
		}

		function checkDateValidation() {
			$timeout(function () {
				vm.end_date_error = vm.end_date_picker ? (moment(vm.start_date_picker).isAfter(vm.end_date_picker) ? true : false) : true;
			}, 100);
		}

		function setCategoryName(categories) {
			for (var i = 0; i < categories.length; i++) {
				for (var j = 0; j < vm.category_names.length; j++) {
					if (categories[i].id == vm.category_names[j].id) {
						categories[i].name = vm.category_names[j].name;
					}
				}
			}
			return categories;
		}

		function getRecipes() {
			if (vm.settings && vm.settings.selectedHerd.id) {
				var suffix = '?team=' + vm.settings.selectedTeam.id + '&herd=' + vm.settings.selectedHerd.id + '&visible=0';
				return mixingService
					.getRecipeByTeamHerd(suffix)
					.then(function (response) {
						vm.recipes = response;
						recipes.resolve();
					})
					.catch(function (error) {
						recipes.reject();
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_loading_recipes_');
					});
			}
		}

		function selectLayout(type) {
			vm.selectedLayout = type;
			vm.currentPage = 1;
			getReports();
		}

		function setGraphData(response, init) {
			var byIdByDate = [];

			var responseByRecipeId = groupBy(response, 'recipe_id');
			angular.forEach(responseByRecipeId, function (value, key) {
				var validKey = false;
				var numKey;
				try {
					numKey = Number.parseInt(key);
					validKey = true;
				} catch (error) {
					console.log(error);
				}
				if (validKey) {
					var color;
					var found = false;
					for (var j = 0; j < vm.colors.length; j++) {
						if (vm.colors[j].id && vm.colors[j].id == numKey) {
							found = true;
							break;
						}
					}
					if (!found) {
						color = setColorById(numKey);
					} else {
						color = getColorById(numKey);
					}

					var byDate = groupBy(value, 'feeding_date');
					byIdByDate.push({
						id: numKey,
						recipe_name: value[0].recipe_name,
						color: color,
						calculated_data: setAmount(byDate, 'calculated_amount'),
						loaded_data: setAmount(byDate, 'actual_amount'),
						displayed: true
					});
				}
			});
			if (vm.selectedRecipe) {
				byIdByDate = byIdByDate.filter(function (recipe) {
					return recipe.id == vm.selectedRecipe.id;
				});
			}
			if (byIdByDate.length) {
				var sumByDate = groupBy(response, 'feeding_date');
				var sumGraphData = {
					color: '#A9A9A9',
					displayed: true,
					id: -1,
					recipe_name: $filter('i18n')('_m_f_report_recipes_sum_'),
					calculated_data: setAmount(sumByDate, 'calculated_amount'),
					loaded_data: setAmount(sumByDate, 'actual_amount', true)
				};

				byIdByDate.unshift(sumGraphData);
			}
			vm.graphData = byIdByDate;
			if (!vm.state_changed) {
				initializeGraph(init);
			}
			function setColorById(id) {
				var color;
				var index = -1;
				for (var i = 0; i < vm.colors.length; i++) {
					if (vm.colors[i].id == undefined || vm.colors[i].id == null) {
						color = vm.colors[i].color;
						index = i;
						break;
					}
				}
				if (index >= 0) {
					dataServiceFactory.colors[index].id = id;
				} else {
					color = getRandomColor();
					var obj = {
						color: color,
						id: id
					};
					dataServiceFactory.colors.push(obj);
				}

				return color;
			}

			function getRandomColor() {
				var uniqueColor = false;
				var color;
				do {
					color = '#' + Math.floor(Math.random() * 16777215).toString(16);
					if (checkIsUnique(color)) {
						uniqueColor = true;
					}
				} while (!uniqueColor);
				return color;
			}

			function checkIsUnique(color) {
				var unique = true;
				for (var i = 0; i < vm.colors.length; i++) {
					if (vm.colors[i].color == color) {
						unique = false;
						break;
					}
				}

				return unique;
			}

			function getColorById(id) {
				var color;
				for (var i = 0; i < vm.colors.length; i++) {
					if (vm.colors[i].id == id) {
						color = vm.colors[i].color;
						break;
					}
				}

				return color;
			}

			function setAmount(listByDate, prop, ignoreLoads) {
				var list = [];
				angular.forEach(listByDate, function (value, key) {
					var amount = 0;
					var c_amount = 0;
					var loads = [];

					for (var i = 0; i < value.length; i++) {
						if (value[i].load_list.length) {
							value[i].load_list = $filter('orderBy')(value[i].load_list, 'id');
						}
						for (var j = 0; j < value[i].load_list.length; j++) {
							amount += value[i].load_list[j][prop];
							if (prop == 'actual_amount') {
								loads.push(value[i].load_list[j][prop]);
								c_amount += value[i].load_list[j].calculated_amount;
							}
						}
					}
					var data = {
						date: moment(key).format('l'),
						weight: amount
					};
					if (!ignoreLoads) {
						data.loads = loads;
					} else {
						data.loads = [];
					}

					if (prop == 'actual_amount') {
						var dev = ((amount - c_amount) / c_amount) * 100;
						if (dev) {
							dev = round(dev, 1);
						}
						data.deviation = dev;
					}
					list.push(data);
				});
				return list;
			}
		}

		function selectPredefinedDates() {
			vm.show_custom_selector = false;
		}

		function setDefaultFilters() {
			vm.selectedCategory = null;
			vm.selectedPen = null;
			vm.selectedRecipe = null;
			vm.recipeFilterActive = false;
			vm.end_date_picker = moment().toDate();
			vm.start_date_picker = moment().subtract(7, 'days').toDate();
			vm.predefinedDates = [
				{
					id: 'last_week',
					name: i18nFilter('_unit_last_week_'),
					end_date: moment().format(),
					start_date: moment().subtract(7, 'days').format()
				},
				{
					id: 'last_month',
					name: i18nFilter('_unit_last_month_'),
					end_date: moment().format(),
					start_date: moment().subtract(1, 'months').format()
				}
			];
			vm.selectedPredefinedDate = vm.predefinedDates[0];
			selectPredefinedDates();
		}

		function back() {
			if (vm.fromCalendar) {
				$state.go('calendar');
			}
		}

		function setDefaultColors() {
			vm.colors = dataServiceFactory.colors;
		}

		function showCustomSelector() {
			vm.show_custom_selector = !vm.show_custom_selector;
		}

		function setBackgroundColor(color) {
			var a = {
				backgroundColor: color
			};
			return a;
		}

		function onSelect(recipe) {
			vm.graphData[vm.graphData.indexOf(recipe)].displayed = !vm.graphData[vm.graphData.indexOf(recipe)].displayed;
			if (legendTimeout) {
				$timeout.cancel(legendTimeout);
			}
			legendTimeout = $timeout(function () {
				initializeGraph();
			}, 100);
		}

		function checkAll(checked) {
			vm.graphData.forEach(function (recipe) {
				if (checked) {
					recipe.displayed = true;
				} else {
					recipe.displayed = false;
				}
			});
			$timeout(function () {
				initializeGraph();
			}, 10);
		}

		function initializeGraph(init) {
			var tmt = 10;
			if (init) {
				tmt = 500;
			}
			$timeout(function () {
				var data = {};
				data.labels = setLabels();
				data.series = [];
				var series = [];
				for (var i = 0; i < vm.graphData.length; i++) {
					if (vm.graphData[i].displayed) {
						var calcualted = setSerie(vm.graphData[i].calculated_data, vm.graphData[i].color, data.labels, false, vm.graphData[i].recipe_name);
						var loaded = setSerie(vm.graphData[i].loaded_data, vm.graphData[i].color, data.labels, true, vm.graphData[i].recipe_name);
						series.push(calcualted);
						series.push(loaded);
					}
				}
				data.series = series;
				var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
				var can_fit = Math.floor(width / 130);
				var step = Math.floor(data.labels.length / can_fit);
				if (step == 0) {
					step = 1;
				}
				var option = {
					height: '450px',

					axisX: {
						labelInterpolationFnc: function (value, index) {
							return index % step == 0 ? value : null;
						}
					},
					lineSmooth: Chartist.Interpolation.cardinal({
						fillHoles: true
					}),
					plugins: [
						Chartist.plugins.tooltip({
							class: 'graph-tooltip',
							metaIsHTML: true,
							appendToBody: true,
							anchorToPoint: false,
							tooltipOffset: {
								x: 0,
								y: -15
							},
							transformTooltipTextFnc: function (tooltip) {
								return vm.amountLabel + ': ' + tooltip + ' ' + vm.weight;
							}
						})
					],
					responsive: true,
					chartPadding: {
						top: 20,
						right: 20,
						left: 50,
						bottom: 20
					}
				};
				var chart = new Chartist.Line('.ct-chart', data, option);
				chart.on('draw', function (context) {
					if (context.type === 'line') {
						var dash = '';
						if (context.series[0].dash_array) {
							dash = ';stroke-dasharray: 10px 20px';
						}
						context.element.attr({
							style: 'stroke:' + context.series[0].color + ';stroke-width:2px' + dash
						});
					} else if (context.type === 'point') {
						context.element.attr({
							style: 'stroke:' + context.series[0].color + ';stroke-width:6px'
						});
					}
				});
			}, tmt);

			function setLabels() {
				var labels = [];
				var end_date = null;
				var start_date = null;
				if (vm.show_custom_selector) {
					end_date = moment(angular.copy(vm.end_date_picker));
					start_date = moment(angular.copy(vm.start_date_picker));
				} else {
					end_date = moment(angular.copy(vm.selectedPredefinedDate.end_date));
					start_date = moment(angular.copy(vm.selectedPredefinedDate.start_date));
				}
				var difference = end_date.diff(start_date, 'days');
				for (var i = 0; i <= difference; i++) {
					var date = moment(end_date).subtract(i, 'days').format('l');
					labels.push(date);
				}
				return labels.reverse();
			}

			function setSerie(data, color, labels, dash_array, recipe_name) {
				var values = [];
				for (var i = 0; i < labels.length; i++) {
					var value = {
						value: null,
						meta: '<div>' + recipe_name + '</div>',
						color: color,
						dash_array: dash_array
					};
					for (var j = 0; j < data.length; j++) {
						if (labels[i] == data[j].date) {
							value.value = round(data[j].weight, 2);
							for (var k = 0; k < data[j].loads.length; k++) {
								value.meta += data[j].loads[k] != null ? '<div>' + i18nFilter('_m_f_recipe_load_') + ' ' + (k + 1) + ':&nbsp;' + round(data[j].loads[k], 2) + ' ' + vm.weight + '</div>' : '';
							}
							value.meta += data[j].deviation ? '<div>' + i18nFilter('_m_f_reports_deviation_') + ': ' + data[j].deviation + '%</div>' : '';
							break;
						}
					}

					values.push(value);
				}
				return values;
			}
		}

		function dataCollapseFn() {
			vm.dataCollapse = [];
			for (var i = 0; i < vm.reports.length; i++) {
				vm.dataCollapse.push(false);
			}
			if (vm.dataSubCollapse && vm.dataSubCollapse.length > 0) {
				for (var j = 0; j < vm.dataSubCollapse.length; j++) {
					vm.dataSubCollapse[j] = false;
				}
			}
		}

		function getRecipeStyle(item) {
			var style = {
				backgroundColor: item.color
			};
			return style;
		}

		function getRecipeLineStyle(item) {
			var style = {
				borderColor: item.color
			};
			return style;
		}

		function openFilterModal() {
			vm.lastUsedFilterValues = {
				selectedRecipe: angular.copy(vm.selectedRecipe),
				selectedPen: angular.copy(vm.selectedPen),
				selectedCategory: angular.copy(vm.selectedCategory),
				selectedPredefinedDate: angular.copy(vm.selectedPredefinedDate),
				show_custom_selector: angular.copy(vm.show_custom_selector),
				start_date_picker: angular.copy(vm.start_date_picker),
				end_date_picker: angular.copy(vm.end_date_picker)
			};
			vm.modalLoading = true;
			openModal('app/pages/reports/mixing/filter.modal.html', 'md');
			if (vm.settings && vm.settings.selectedHerd.id) {
				categories = $q.defer();
				pens = $q.defer();
				recipes = $q.defer();
				if (!vm.categories) {
					getCategories();
				} else {
					categories.resolve();
				}
				if (!vm.pens) {
					getPens();
				} else {
					pens.resolve();
				}
				if (!vm.recipes) {
					getRecipes();
				} else {
					recipes.resolve();
				}
				$q.all([categories.promise, pens.promise, recipes.promise])
					.then(function () {
						vm.modalLoading = false;
					})
					.catch(function () {
						vm.modalLoading = false;
					});
			}
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function cancel() {
			vm.selectedRecipe = angular.copy(vm.lastUsedFilterValues.selectedRecipe);
			vm.selectedPen = angular.copy(vm.lastUsedFilterValues.selectedPen);
			vm.selectedCategory = angular.copy(vm.lastUsedFilterValues.selectedCategory);
			vm.selectedPredefinedDate = angular.copy(vm.lastUsedFilterValues.selectedPredefinedDate);
			vm.show_custom_selector = angular.copy(vm.lastUsedFilterValues.show_custom_selector);
			vm.start_date_picker = angular.copy(vm.lastUsedFilterValues.start_date_picker);
			vm.end_date_picker = angular.copy(vm.lastUsedFilterValues.end_date_picker);

			$uibModalStack.dismissAll();
		}

		function selectTableRow(index, id) {
			vm.selectedList = [];
			if (typeof vm.dayDataCollapse === 'undefined') {
				vm.dataCollapseFn();
			}
			if (vm.tableRowExpanded === false && vm.tableRowIndexExpandedCurr === '' && vm.idExpanded === '') {
				vm.tableRowIndexExpandedPrev = '';
				vm.tableRowExpanded = true;
				vm.tableRowIndexExpandedCurr = index;
				vm.idExpanded = id;
				vm.dataCollapse[index] = true;
			} else if (vm.tableRowExpanded === true) {
				if (vm.tableRowIndexExpandedCurr === index && vm.idExpanded === id) {
					vm.tableRowExpanded = false;
					vm.tableRowIndexExpandedCurr = '';
					vm.idExpanded = '';
					vm.dataCollapse[index] = false;
				} else {
					vm.tableRowIndexExpandedPrev = vm.tableRowIndexExpandedCurr;
					vm.tableRowIndexExpandedCurr = index;
					vm.idExpanded = id;
					vm.dataCollapse[vm.tableRowIndexExpandedPrev] = false;
					vm.dataCollapse[vm.tableRowIndexExpandedCurr] = true;
				}
			}
		}

		function saveFilter() {
			vm.currentPage = 1;
			vm.modalLoading = true;
			getReports();
			filterActiveValidation();
		}

		function filterActiveValidation() {
			var start_date = moment(vm.start_date_picker).format('YYYY-MM-DD');
			var start_date_changed = moment(vm.selectedPredefinedDate.start_date).format('YYYY-MM-DD');
			var end_date = moment(vm.end_date_picker).format('YYYY-MM-DD');
			var end_date_changed = moment(vm.selectedPredefinedDate.end_date).format('YYYY-MM-DD');
			if (vm.selectedRecipe || vm.selectedPen || vm.selectedCategory || start_date != start_date_changed || end_date != end_date_changed) {
				vm.recipeFilterActive = true;
			} else {
				vm.recipeFilterActive = false;
			}
		}

		function getReports(init, from_calendar) {
			if (!vm.modalLoading) {
				vm.loadingTable = true;
			}
			var suffix = '?herd=' + vm.selectedHerd;
			/*if (vm.selectedLayout == 1) {
				suffix += '&page_number=' + vm.currentPage;
			}*/
			if (vm.selectedRecipe && vm.selectedLayout == 1) {
				suffix += '&recipe_id=' + vm.selectedRecipe.id;
			}
			if (vm.selectedPen && vm.selectedLayout == 1) {
				suffix += '&pen_id=' + vm.selectedPen.id;
			}
			if (vm.selectedCategory && vm.selectedLayout == 1) {
				suffix += '&pen_categoryid=' + vm.selectedCategory.id;
			}
			var start_date = null;
			var end_date = null;
			if (vm.selectedPredefinedDate && !vm.show_custom_selector) {
				start_date = moment(vm.selectedPredefinedDate.start_date).format('YYYY-MM-DD');
				end_date = moment(vm.selectedPredefinedDate.end_date).format('YYYY-MM-DD');
				suffix += '&start_date=' + start_date + '&end_date=' + end_date;
			}
			if (vm.show_custom_selector) {
				start_date = vm.start_date_picker ? moment(vm.start_date_picker).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
				end_date = vm.end_date_picker ? moment(vm.end_date_picker).format('YYYY-MM-DD') : moment().subtract(7, 'days').format('YYYY-MM-DD');
				suffix += '&start_date=' + start_date + '&end_date=' + end_date;
			}
			cancelApiRequest();
			if (vm.selectedLayout == 1) {
				return mixingService
					.getMixingReports(suffix)
					.then(function (response) {
						for (var i = 0; i < response.length; i++) {
							var days_diff = moment().diff(moment(response[i].feeding_date), 'days');
							if (days_diff % 2 == 0) {
								response[i].color = '#c8f1ed';
							} else {
								response[i].color = '#FFFFFF';
							}
							var loadNumber = angular.copy(response[i].load_number + 1);
							response[i].recipe_name = response[i].recipe_name + ' - ' + i18nFilter('_m_f_recipe_load_') + ' ' + loadNumber;
							var org_actual_amount = angular.copy(response[i].actual_amount);
							response[i].actual_amount = 0;

							if (response[i].load_ingredient_list && response[i].load_ingredient_list.length > 0) {
								for (var j = 0; j < response[i].load_ingredient_list.length; j++) {
									if (org_actual_amount && response[i].load_ingredient_list[j].actual_amount == null) {
										response[i].load_ingredient_list[j].actual_amount = (org_actual_amount * response[i].load_ingredient_list[j].amount_percent) / 100;
									}
									response[i].load_ingredient_list[j].calculated_weight = (response[i].calculated_weight * response[i].load_ingredient_list[j].amount_percent) / 100;
									response[i].load_ingredient_list[j].deviation = response[i].load_ingredient_list[j].actual_amount - response[i].load_ingredient_list[j].calculated_weight;
									response[i].load_ingredient_list[j].deviation_percentage = (response[i].load_ingredient_list[j].deviation / response[i].load_ingredient_list[j].calculated_weight) * 100;
									response[i].load_ingredient_list[j].calculated_weight = unitConversionService.convertData(response[i].load_ingredient_list[j].calculated_weight, ['kgToLb', 'round:0']);
									response[i].load_ingredient_list[j].deviation = unitConversionService.convertData(response[i].load_ingredient_list[j].deviation, ['kgToLb', 'round:0']);
									response[i].load_ingredient_list[j].actual_amount = unitConversionService.convertData(response[i].load_ingredient_list[j].actual_amount, ['kgToLb', 'round:0']);
									response[i].actual_amount += response[i].load_ingredient_list[j].actual_amount;
								}
							}
							response[i].calculated_weight = unitConversionService.convertData(response[i].calculated_weight, ['kgToLb', 'round:0']);
							response[i].deviation = response[i].actual_amount - response[i].calculated_weight;
							response[i].deviation_percentage = response[i].deviation / response[i].calculated_weight;
							response[i].deviation_price = response[i].cost + response[i].cost * response[i].deviation_percentage;
							response[i].deviation = unitConversionService.convertData(response[i].deviation, ['kgToLb', 'round:0']);
						}
						if (response.length > 0 && response[0].number_of_all) {
							vm.totalItems = response[0].number_of_all;
						} else {
							vm.totalItems = 0;
						}
						vm.reports = response;
						vm.loading = false;
						vm.loadingTable = false;
						vm.modalLoading = false;
						$uibModalStack.dismissAll();
					})
					.catch(function (error) {
						if (error != 'Canceled') {
							console.log(error);
							vm.loading = false;
							vm.loadingTable = false;
							vm.modalLoading = false;
							errorService.showErrorMessage(error, true, '_error_occurred_loading_reports_', init);
							$uibModalStack.dismissAll();
						}
					});
			} else {
				return mixingService
					.getMixingChart(suffix)
					.then(function (response) {
						for (var i = 0; i < response.length; i++) {
							for (var j = 0; j < response[i].load_list.length; j++) {
								response[i].load_list[j].actual_amount = unitConversionService.convertData(response[i].load_list[j].actual_amount, ['kgToLb', 'round:0']);
								response[i].load_list[j].calculated_amount = unitConversionService.convertData(response[i].load_list[j].calculated_amount, ['kgToLb', 'round:0']);
							}
						}
						vm.graphData = [];
						setGraphData(response, init, from_calendar);
						vm.loading = false;
						vm.loadingTable = false;
						vm.modalLoading = false;
						$uibModalStack.dismissAll();
					})
					.catch(function (error) {
						if (error != 'Canceled') {
							console.log(error);
							vm.loading = false;
							vm.loadingTable = false;
							vm.modalLoading = false;
							errorService.showErrorMessage(error, true, '_error_occurred_loading_reports_');
							$uibModalStack.dismissAll();
						}
					});
			}
		}

		function paginationChanged() {
			getReports();
		}

		function groupBy(xs, key) {
			return xs.reduce(function (rv, x) {
				(rv[x[key]] = rv[x[key]] || []).push(x);
				return rv;
			}, {});
		}

		function round(value, decimals) {
			if (isNaN(value) == false) {
				return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
			} else {
				return value;
			}
		}

		function cancelApiRequest() {
			angular.forEach($http.pendingRequests, function (req) {
				if ((req.url.split('?')[0] == APP_CONST.api_base_url + 'mixingfeedingreport' || req.url.split('?')[0] == APP_CONST.api_base_url + 'mixingfeedingreport/chart') && req.method == 'GET') {
					mixingService.cancelRequest();
				}
			});
		}

		$scope.$on('$stateChangeStart', function (event, toState) {
			vm.state_changed = true;
			if (toState.name !== 'calendar') {
				localStorage.removeItem('from_calendar');
				dataServiceFactory.calendarEvent = null;
				dataServiceFactory.feedingDate = null;
				dataServiceFactory.agenda = {};
			}
		});

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});

		$scope.$on('default_team_herd_changed', function () {
			cancelApiRequest();
			init();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.reports.mixing').factory('mixingService', mixingService);
	/** @ngInject */
	function mixingService(APP_CONST, $http, $q) {
		var cancelReq;
		var statusText;

		return {
			getCategories: getCategories,
			getPensByTeamHerd: getPensByTeamHerd,
			getMixingReports: getMixingReports,
			getMixingChart: getMixingChart,
			getRecipeByTeamHerd: getRecipeByTeamHerd,
			cancelRequest: cancelRequest
		};

		function cancelRequest() {
			statusText = 'Canceled';
			cancelReq.resolve();
		}

		function getCategories(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'penCategories' + suffix)
				.then(success)
				.catch(error);
		}

		function getPensByTeamHerd(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'pens' + suffix)
				.then(success)
				.catch(error);
		}

		function getRecipeByTeamHerd(suffix) {
			var request = {
				method: 'GET',
				url: APP_CONST.api_base_url + 'recipes' + suffix,
				headers: {
					Accept: 'application/mmmoooglefeed.allrecipes.v2+json'
				}
			};

			return $http(request).then(success).catch(error);
		}

		function getMixingReports(suffix) {
			cancelReq = $q.defer();
			return $http
				.get(APP_CONST.api_base_url + 'mixingfeedingreport' + suffix, {
					timeout: cancelReq.promise
				})
				.then(success)
				.catch(function (error) {
					var err = statusText ? $q.reject(statusText) : $q.reject(error);
					statusText = undefined;
					return err;
				});
		}

		function getMixingChart(suffix) {
			cancelReq = $q.defer();
			return $http
				.get(APP_CONST.api_base_url + 'mixingfeedingreport/chart' + suffix, {
					timeout: cancelReq.promise
				})
				.then(success)
				.catch(function (error) {
					var err = statusText ? $q.reject(statusText) : $q.reject(error);
					statusText = undefined;
					return err;
				});
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.recipes.addNewRecipe').controller('addNewRecipeCtrl', addNewRecipeCtrl);
	/** @ngInject */

	function addNewRecipeCtrl(recipeDataService, $timeout, $filter, authService, errorService, $q, addNewRecipeService, $scope, $anchorScroll, editableOptions, toastr, editableThemes, $interval, unitConversionService, $uibModal, $locale, $rootScope, $state, APP_CONST, $uibModalStack, uaParser) {
		var vm = this;
		var RRule = rrule.RRule;
		var parseString = rrule.rrulestr;
		var i18nFilter = $filter('i18n');
		var rationAccessCode = 16;

		var rationPromise;
		var rationsPromise;
		var ingredientsPromise;
		var pensPromise;
		//var feedingMethodsPromise;
		var wagonsPromise;

		vm.toggleCollapse = toggleCollapse;
		vm.selectRationType = selectRationType;
		vm.rationsPaginationChanged = rationsPaginationChanged;
		vm.selectRation = selectRation;
		vm.updateFeed = updateFeed;
		vm.linkIngredient = linkIngredient;
		vm.drag = drag;
		vm.pensPaginationChanged = pensPaginationChanged;
		vm.selectPen = selectPen;
		vm.openPenDetailsModal = openPenDetailsModal;
		vm.changeActive = changeActive;
		vm.updateUsePenIntake = updateUsePenIntake;
		//vm.feedingMethodSelected = feedingMethodSelected;
		vm.wagonSelected = wagonSelected;
		vm.defaultSelected = defaultSelected;
		vm.insertWagon = insertWagon;
		vm.addWagon = addWagon;
		vm.openEditLoadsModal = openEditLoadsModal;
		vm.showSetButton = showSetButton;
		vm.addLoad = addLoad;
		vm.updateLoad = updateLoad;
		vm.setLoad = setLoad;
		vm.saveLoads = saveLoads;
		vm.removeLoad = removeLoad;
		vm.loadWagonChanged = loadWagonChanged;
		vm.amountChanged = amountChanged;
		vm.checkValidation = checkValidation;
		vm.openTimePicker = openTimePicker;
		vm.saveRecipe = saveRecipe;
		vm.openFeedingDatepicker = openFeedingDatepicker;
		vm.openWeekPreviewModal = openWeekPreviewModal;
		vm.goToPage = goToPage;
		vm.cancel = cancel;
		vm.cancelWizard = cancelWizard;
		vm.tabValidation = tabValidation;
		vm.disableSaveButton = disableSaveButton;
		vm.openMixingTimeSelector = openMixingTimeSelector;
		vm.getMinutes = getMinutes;
		vm.saveMixingTime = saveMixingTime;

		init();

		function init() {
			vm.isCollapsed = true;
			vm.recipe = recipeDataService.getRecipe();
			vm.recipe.feedingMethodHelpInput = 'valid';
			vm.disableDrag = uaParser.getDevice('type') ? true : false;
			vm.showGMap = true;
			vm.saveTimeout = null;
			setConstants();
			callApis();
		}

		function toggleCollapse() {
			vm.isCollapsed = !vm.isCollapsed;
		}

		function reloadApi() {
			vm.recipe = recipeDataService.getRecipe();
			callApis();
		}

		function callApis() {
			if (vm.selectedHerd) {
				rationsPromise = $q.defer();
				pensPromise = $q.defer();
				//feedingMethodsPromise = $q.defer();
				wagonsPromise = $q.defer();
				ingredientsPromise = $q.defer();
				if (vm.from_recipe) {
					//feedingMethodsPromise.resolve();
				} else {
					//getFeedingMethods(true);
				}
				getRations(true);
				getIngredients();
				getPens(true);
				getMixerWagons(true);

				localStorage.removeItem('from_recipe');
			}
		}

		function setConstants() {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.from_recipe = JSON.parse(localStorage.getItem('from_recipe'));
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			vm.today = moment().toDate();
			vm.startDate = moment().toDate();

			if (!vm.settings.use_kgs) {
				vm.weight = 'Lb';
			} else {
				vm.weight = 'Kg';
			}

			vm.options = {
				showWeeks: false,
				minDate: vm.today
			};

			vm.maxAmount = 40;

			getDefaultTeamHerd();
			setStrings();
			setRationTypes();
			setCategories();
			setFeedIntakeSourceList();
			//setFeedingMethods();
			setFeedingFrequencies();
			setCustomDays();
			checkLng();
		}

		function getDefaultTeamHerd() {
			if (vm.settings.selectedTeam.id) {
				vm.selectedTeam = vm.settings.selectedTeam;
			}
			if (vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd;
			} else {
				vm.selectedHerd = null;
			}
		}

		function setStrings() {
			$timeout(function () {
				vm.step1 = i18nFilter('_m_f_add_new_recipe_step1_title_');
				vm.step2 = i18nFilter('_m_f_add_new_recipe_step2_title_');
				vm.step3 = i18nFilter('_m_f_recipe_choose_mixer_wagons_');
				vm.step4 = i18nFilter('_m_f_add_new_recipe_step4_title_');
				vm.step5 = i18nFilter('_m_f_add_new_recipe_step5_title_');
				vm.showPage = true;
			}, 100);
		}

		function setRationTypes() {
			vm.rationTypes = [
				{
					name: i18nFilter('_added_ration_manually_'),
					value: 1
				}
			];
			if (authService.can(rationAccessCode)) {
				vm.hasRationAccess = true;
				vm.rationTypes.splice(0, 0, {
					name: i18nFilter('_report_footer_feed_'),
					value: 0
				});
			} else {
				vm.hasRationAccess = false;
			}
			if (!vm.from_recipe) {
				vm.recipe.selected_ration_type = vm.rationTypes[0];
			}
		}

		function setCategories() {
			vm.category_names = [
				{
					name: i18nFilter('_milking_cows_hp_'),
					id: 1
				},
				{
					name: i18nFilter('_milking_cows_lp_'),
					id: 2
				},
				{
					name: i18nFilter('_dry_cows_'),
					id: 3
				},
				{
					name: i18nFilter('_heifers_2nd_year_of_life_'),
					id: 4
				},
				{
					name: i18nFilter('_heifers_1st_year_of_life_'),
					id: 5
				},
				{
					name: i18nFilter('_fattening_bulls_'),
					id: 6
				},
				{
					name: i18nFilter('_calves_'),
					id: 7
				}
			];
		}

		function setFeedIntakeSourceList() {
			vm.feedIntakeSources = [
				{
					value: true,
					name: i18nFilter('_m_f_fixed_')
				},
				{
					value: false,
					name: i18nFilter('_m_f_ration_depending_')
				}
			];
		}

		/*function setFeedingMethods() {
			vm.feeding_method_names = [
				{
					name: i18nFilter('_mf_tmr_label_'),
					id: 1
				},
				{
					name: i18nFilter('_mf_non_tmr_label_'),
					id: 2
				},
				{
					name: i18nFilter('_mf_feeding_station_'),
					id: 3
				}
			];
		}*/

		function setFeedingFrequencies() {
			vm.frequencies = [
				{
					name: i18nFilter('_every_day_frequency_'),
					value: 1
				},
				{
					name: i18nFilter('_every_two_day_frequency_'),
					value: 2
				},
				{
					name: i18nFilter('_every_three_day_frequency_'),
					value: 3
				}
			];
		}

		function setCustomDays() {
			vm.days = [];
			var listOfDays = APP_CONST.constants.custom_feeding_days;
			for (var i = 0; i < listOfDays.length; i++) {
				var obj = {
					name: i18nFilter(listOfDays[i].longName),
					value: listOfDays[i].value
				};
				vm.days.push(obj);
			}
		}

		function checkLng() {
			if (vm.settings.language) {
				if (vm.settings.language == 'en-gb') {
					vm.locale = 'en-gb';
				} else if (vm.settings.language == 'en-us') {
					vm.locale = 'en';
				} else if (vm.settings.language == 'cs-cz') {
					vm.locale = 'cs';
				} else if (vm.settings.language == 'es-es') {
					vm.locale = 'es';
				} else if (vm.settings.language == 'nl-nl') {
					vm.locale = 'nl';
				} else if (vm.settings.language == 'it-it') {
					vm.locale = 'nl';
				}
			} else {
				vm.locale = 'en-gb';
			}
		}

		function selectRationType(init) {
			vm.recipe.selectedRation = null;
			vm.recipe.rations = [];
			getRations(init);
		}

		function getRations(init) {
			if (vm.recipe.selected_ration_type.value) {
				getImportedRationsByHerd(init);
			} else {
				getRationsByHerd(init);
			}
		}

		function stopLoading() {
			$q.all([rationsPromise.promise, ingredientsPromise.promise])
				.then(function () {
					vm.loadingRations = false;
				})
				.catch(function () {
					vm.loadingRations = false;
				});
		}

		function rationsPaginationChanged() {
			vm.recipe.rations = [];
			getRations();
		}

		function getImportedRationsByHerd(init) {
			vm.loadingRations = true;
			var suffix = '/' + vm.selectedHerd.id + '/' + vm.recipe.currentPageRation + '?visible=true';
			return addNewRecipeService
				.getImportedRationsByHerd(suffix)
				.then(function (response) {
					vm.recipe.totalItemsRation = response && response.number_of_all ? response.number_of_all : 0;
					for (var i = 0; i < response.manual_rations.length; i++) {
						response.manual_rations[i] = processRation(response.manual_rations[i]);
						response.manual_rations[i] = checkSelectedRation(response.manual_rations[i]);
					}

					checkRationValidation();
					vm.recipe.rations = $filter('orderBy')(response.manual_rations, 'id', true);
					stopLoading();
					rationsPromise.resolve();
				})
				.catch(function (error) {
					console.log(error);
					rationsPromise.reject(error);
					stopLoading();
					errorService.showErrorMessage(error, true, '_error_occurred_loading_rations_', init);
				});

			function processRation(ration) {
				ration.is_displayed = true;
				ration.manual_ration_header_id = ration.id;
				ration.ration_feeds = $filter('orderBy')(ration.ration_feeds, 'order_number');

				return ration;
			}

			function checkSelectedRation(ration) {
				ration.is_selected = false;
				if (vm.recipe.rations && vm.recipe.rations.length) {
					for (var i = 0; i < vm.recipe.rations.length; i++) {
						if (ration.id === vm.recipe.rations[i].id) {
							ration = vm.recipe.rations[i];
							break;
						}
					}
				}

				if (vm.recipe.selectedRation) {
					if (ration.id === vm.recipe.selectedRation.id) {
						ration = vm.recipe.selectedRation;
					}
				}

				return ration;
			}
		}

		function getRationsByHerd(init) {
			vm.loadingRations = true;
			var suffix = '?active=true';
			if (authService.can(rationAccessCode)) {
				return addNewRecipeService
					.getRationsByHerd(vm.selectedHerd.id, vm.recipe.currentPageRation, suffix)
					.then(function (response) {
						vm.recipe.totalItemsRation = response && response.length ? response[0].number_of_all : 0;
						for (var i = 0; i < response.length; i++) {
							response[i] = processRation(response[i]);
						}

						for (var j = 0; j < response.length; j++) {
							response[j] = checkSelectedRation(response[j]);
						}

						checkRationValidation();
						vm.recipe.rations = response;
						stopLoading();
						rationsPromise.resolve();
					})
					.catch(function (error) {
						console.log(error);
						rationsPromise.reject(error);
						stopLoading();
						errorService.showErrorMessage(error, true, '_error_occurred_loading_rations_', init);
					});
			} else {
				checkRationValidation();
				rationsPromise.resolve();
				vm.recipe.rations = [];
				stopLoading();
			}

			function processRation(ration) {
				ration.is_displayed = true;
				ration.ration_header_id = ration.id;
				return ration;
				/*var p = getDmData(ration.id, init).then(function (res) {
					ration.dm = res.dm;
				});
				list.push(p);

				function getDmData(id, init) {
					var suffix = '?herd=' + vm.selectedHerd.id;
					return addNewRecipeService
						.getRationCostByRationId(id, suffix)
						.then(function (response) {
							return $q.resolve(response);
						})
						.catch(function (error) {
							console.log(error);
							errorService.showErrorMessage(error, true, '_error_occurred_loading_dm_', init);
							return $q.reject(error);
						});
				}*/
			}

			function checkSelectedRation(ration) {
				//add last modified date check when available
				ration.is_selected = false;
				if (vm.recipe.rations && vm.recipe.rations.length) {
					for (var i = 0; i < vm.recipe.rations.length; i++) {
						if (ration.id === vm.recipe.rations[i].id) {
							ration = vm.recipe.rations[i];
							break;
						}
					}
				}

				if (vm.recipe.selectedRation) {
					if (ration.id === vm.recipe.selectedRation.id) {
						ration = vm.recipe.selectedRation;
					}
				}

				return ration;
			}
		}

		function checkRationValidation() {
			if (vm.recipe.selectedRation) {
				if (vm.recipe.selectedRation.dm > 0) {
					vm.recipe.rationHelpInput = 'valid';
				} else {
					vm.recipe.rationHelpInput = null;
				}
			} else {
				vm.recipe.rationHelpInput = null;
			}
		}

		function selectRation(ration) {
			vm.recipe.popover_ration_index = vm.recipe.rations.indexOf(ration);
			ration.is_selected = true;
			vm.recipe.selectedRation = ration;

			vm.recipe.rations.forEach(function (r) {
				if (r.id !== ration.id) {
					r.is_selected = false;
				}
			});

			if (ration.manual_ration_header_id) {
				if (ration.ingredients_checked) {
					selectRationAfterInit();
				} else {
					vm.disableRationSelect = true;
					rationPromise = $q.defer();
					$q.all([rationPromise.promise]).then(function () {
						selectRationAfterInit();
					});
					if (!ration.ingredients_checked) {
						vm.loadingRationFeeds = true;
						checkImportedRationIngredients(ration);
					} else {
						rationPromise.resolve();
					}
				}
			} else {
				if (ration.ration_feeds) {
					selectRationAfterInit();
				} else {
					vm.disableRationSelect = true;
					rationPromise = $q.defer();
					$q.all([rationPromise.promise]).then(function () {
						selectRationAfterInit();
					});
					if (!ration.ration_feeds) {
						vm.loadingRationFeeds = true;
						getRationById(ration);
					} else {
						rationPromise.resolve();
					}
				}
			}
			$timeout(function () {
				var rationInfoSection = document.getElementById('recipe-info');
				if (rationInfoSection) {
					rationInfoSection.scrollIntoView({ behavior: 'smooth' });
				}
			}, 500);

			function selectRationAfterInit() {
				checkRationValidation();
				calculateRationAmount();
				if (vm.recipe.selected_pens && vm.recipe.selected_pens.length > 0) {
					calculateAmounts();
				}
				vm.disableRationSelect = false;
				vm.loadingRationFeeds = false;
			}
		}

		function calculateRationAmount() {
			var amount_dm = 0;
			var amount_as_fed = 0;
			var cost_dm = 0;

			vm.recipe.selectedRation.ration_feeds.forEach(function (feed) {
				amount_dm += feed.amount_dm;
				amount_as_fed += feed.amount_as_fed;
				cost_dm += (feed.cost_dm || 0) * feed.amount_dm;
			});

			vm.recipe.selectedRation.amount_dm = amount_dm;
			vm.recipe.selectedRation.amount_as_fed = amount_as_fed;
			vm.recipe.selectedRation.dm = (amount_dm / amount_as_fed) * 100;
			vm.recipe.selectedRation.cost_dm = cost_dm;
			vm.recipe.selectedRation.cost_per_kg_dm = cost_dm / amount_dm;

			var sum = 0;
			vm.recipe.ration_intake_warning = false;
			vm.recipe.selectedRation.ration_feeds.forEach(function (feed) {
				sum += feed.amount_dm;
			});

			if (sum > vm.maxAmount) {
				vm.recipe.ration_intake_warning = true;
			}

			vm.recipe.rationHelpInput = vm.recipe.selectedRation.dm > 0 ? 'valid' : undefined;
		}

		function updateFeed(data, feed, prop) {
			feed.dirty = true;

			switch (prop) {
				case 'dm':
					feed.amount_as_fed = (feed.amount_dm * 100) / data;
					break;
				case 'amount_dm':
					feed.amount_as_fed = (data * 100) / feed.dm;
					break;
				case 'amount_as_fed':
					feed.amount_dm = (data * feed.dm) / 100;
					break;
				default:
					break;
				case 'cost_dm':
					feed.cost_as_fed = (feed.cost_dm * feed.dm) / 100;
					break;
				case 'cost_as_fed':
					feed.cost_dm = (feed.cost_as_fed * 100) / feed.dm;
					break;
			}

			calculateRationAmount();
			if (vm.recipe.selected_pens && vm.recipe.selected_pens.length) {
				calculateAmounts();
			}
		}

		function linkIngredient(ingredient, feed) {
			var changed = false;
			if (ingredient) {
				feed.ingredient = ingredient;
				feed.dm = ingredient.dm;
				if (feed.ingredient_id !== ingredient.id) {
					feed.ingredient_changed = true;
					feed.ingredient.linked = true;
					changed = true;
				} else {
					if (feed.ingredient_changed) {
						feed.ingredient_changed = false;
						feed.ingredient.linked = false;
						changed = true;
					}
				}
			} else {
				feed.ingredient = null;
				feed.dm = feed.original_dm;
				if (feed.ingredient_id) {
					feed.ingredient_changed = true;
					changed = true;
				} else {
					if (feed.ingredient_changed) {
						feed.ingredient_changed = false;
						changed = true;
					}
				}
			}

			if (changed) {
				feed.amount_as_fed = (feed.amount_dm * 100) / feed.dm;
				feed.cost_as_fed = (feed.cost_dm * feed.dm) / 100;
				var found = false;
				var tempList = vm.recipe.selectedRation.ration_feeds;
				for (var i = 0; i < tempList.length; i++) {
					if (tempList[i].ingredient_changed) {
						found = true;
						break;
					}
				}

				if (found && !vm.recipe.selectedRation.recipe_list.length) {
					checkRecipeRecalculation(feed);
				}

				calculateRationAmount();
				if (vm.recipe.selected_pens && vm.recipe.selected_pens.length) {
					calculateAmounts();
				}
			}

			function checkRecipeRecalculation(feed) {
				var type = vm.recipe.selected_ration_type.value ? 'import_ration_feed' : 'ration_feed';
				var suffix = feed.id + '?type=' + type + '&herd=' + vm.selectedHerd.id;
				addNewRecipeService
					.checkRecipeRecalculation(suffix)
					.then(function (response) {
						vm.recipe.selectedRation.recipe_list = response;
					})
					.catch(function (error) {
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_loading_linked_recipes_');
					});
			}
		}

		function checkImportedRationIngredients(ration) {
			var promiseList = [];
			var feedIngredientList = [];

			ration.ration_feeds.forEach(function (feed) {
				var p = checkImportedIngredient(feed.id).then(function (response) {
					feedIngredientList.push({
						id: feed.id,
						ingredient_id: response.id,
						dm: response.dm
					});
				});
				promiseList.push(p);
			});

			if (!promiseList.length) {
				ration.ingredients_checked = true;
				ration.recipe_list = [];
				rationPromise.resolve();
				return;
			}

			$q.all(promiseList)
				.then(function () {
					ration.ration_feeds.forEach(function (feed) {
						feed.original_dm = feed.dm;

						var ingredient = feedIngredientList.find(function (ing) {
							return feed.id === ing.id;
						});

						if (ingredient.dm) {
							feed.ingredient = vm.recipe.ingredients.find(function (x) {
								return x.id === ingredient.ingredient_id;
							});

							feed.ingredient_id = ingredient.ingredient_id;
							feed.dm = ingredient.dm;
							feed.amount_as_fed = (feed.amount_dm * 100) / feed.dm;
							feed.cost_as_fed = (feed.cost_dm * feed.dm) / 100;
						}

						ration.ingredients_checked = true;
						ration.recipe_list = [];
						rationPromise.resolve();
					});
				})
				.catch(function () {
					rationPromise.reject();
				});

			function checkImportedIngredient(id) {
				return addNewRecipeService
					.checkImportedIngredient(id)
					.then(function (response) {
						return $q.resolve(response);
					})
					.catch(function (error) {
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_checking_ingredient_');
						return $q.reject(error);
					});
			}
		}

		function getRationById(ration) {
			return addNewRecipeService.getRationById(ration.id, '').then(function (response) {
				var promiseList = [];
				var feedIngredientList = [];

				response.ration_header.rations.forEach(function (feed) {
					var p = checkIngredient(feed.feed.id).then(function (response) {
						feedIngredientList.push({
							id: feed.feed.id,
							ingredient_id: response.id,
							dm: response.dm
						});
					});
					promiseList.push(p);
				});

				$q.all(promiseList)
					.then(function () {
						var rationFeeds = [];
						var total_dm = 0;

						response.ration_header.rations.forEach(function (feed) {
							feed.feed.original_dm = feed.feed.dm;

							var ingredient = feedIngredientList.find(function (ing) {
								return feed.feed.id === ing.id;
							});

							if (ingredient.dm) {
								feed.feed.ingredient = vm.recipe.ingredients.find(function (x) {
									return x.id === ingredient.ingredient_id;
								});

								feed.feed.ingredient_id = ingredient.ingredient_id;
								feed.feed.dm = ingredient.dm;
								feed.feed.as_fed = (feed.feed.amount * 100) / feed.feed.dm;
							}

							total_dm += feed.feed.amount;

							rationFeeds.push({
								amount_as_fed: feed.feed.as_fed,
								amount_dm: feed.feed.amount,
								cost_as_fed: (feed.feed.cost_dm * feed.feed.dm) / 100,
								cost_dm: feed.feed.cost_dm,
								dm: feed.feed.dm,
								original_dm: feed.feed.original_dm,
								feed_name: feed.feed.feed_name,
								feed_type: feed.feed.feed_type,
								id: feed.feed.id,
								ingredient: feed.feed.ingredient,
								ingredient_id: feed.feed.ingredient_id
							});
						});

						ration.cost_per_kg_dm = ration.cost_dm / total_dm;
						ration.ration_feeds = $filter('orderBy')(rationFeeds, 'id');
						ration.recipe_list = [];
						rationPromise.resolve();
					})
					.catch(function () {
						rationPromise.reject();
					});
			});

			function checkIngredient(id) {
				return addNewRecipeService
					.checkIngredient(id)
					.then(function (response) {
						return $q.resolve(response);
					})
					.catch(function (error) {
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_checking_ingredient_');
						return $q.reject(error);
					});
			}
		}

		function getIngredients() {
			var suffix = '?team=' + vm.selectedTeam.id + '&herd=' + vm.selectedHerd.id;
			return addNewRecipeService
				.getIngredients(suffix)
				.then(function (response) {
					if (vm.recipe.ingredients) {
						for (var i = 0; i < response.length; i++) {
							for (var j = 0; j < vm.recipe.ingredients.length; j++) {
								if (response[i].id === vm.recipe.ingredients[j].id && moment(response[i].last_modified_date).isSame(vm.recipe.ingredients[j].last_modified_date)) {
									response[i] = vm.recipe.ingredients[j];
									break;
								}
							}
						}
					}

					vm.recipe.ingredients = response;
					ingredientsPromise.resolve();
				})
				.catch(function (error) {
					console.log(error);
					ingredientsPromise.reject();
					errorService.showErrorMessage(error, true, '_error_occurred_loading_ingredient_', true);
				});
		}

		function drag(index) {
			vm.recipe.selectedRation.ration_feeds.splice(index, 1);
		}

		function getPens(init) {
			var suffix = '?page=' + vm.recipe.currentPagePens;
			if (vm.selectedHerd && vm.selectedHerd.id) {
				vm.loadingPensTable = true;
				suffix = suffix + '&team=' + vm.selectedTeam.id + '&herd=' + vm.selectedHerd.id;
				return addNewRecipeService
					.getPensByTeamHerd(suffix)
					.then(function (response) {
						vm.recipe.totalItemsPens = response && response.length ? response[0].number_of_all : 0;
						for (var i = 0; i < response.length; i++) {
							response[i] = processPen(response[i]);
							response[i] = checkSelectedPens(response[i]);
						}
						vm.recipe.pens = response;
						checkPenValidation();
						if (vm.recipe.selected_pens && vm.recipe.selected_pens.length) {
							calculateAmounts();
						}
						pensPromise.resolve();
						vm.loadingPensTable = false;
					})
					.catch(function (error) {
						pensPromise.reject(error);
						vm.loadingPensTable = false;
						errorService.showErrorMessage(error, true, '_error_occurred_loading_pen_', init);
					});
			}

			function checkSelectedPens(pen) {
				if (vm.recipe.pens && vm.recipe.pens.length) {
					for (var i = 0; i < vm.recipe.pens.length; i++) {
						if (vm.recipe.pens[i].id === pen.id && moment(vm.recipe.pens[i].last_modified_date).isSame(pen.last_modified_date)) {
							pen = vm.recipe.pens[i];
							break;
						}
					}
				}
				if (vm.recipe.selected_pens && vm.recipe.selected_pens.length) {
					var found = false;
					for (var j = vm.recipe.selected_pens.length - 1; j >= 0; j--) {
						if (vm.recipe.selected_pens[j].id === pen.id) {
							pen.is_selected = vm.recipe.selected_pens[j].is_selected;
							if (moment(vm.recipe.selected_pens[j].last_modified_date).isBefore(pen.last_modified_date)) {
								found = true;
								vm.recipe.selected_pens.splice(j, 1);
							} else {
								pen = vm.recipe.selected_pens[j];
							}
							break;
						}
					}
					if (found) {
						vm.recipe.selected_pens.push(pen);
					}
				}
				return pen;
			}

			function processPen(pen) {
				pen.pen_feeding_scheduler_list = $filter('orderBy')(pen.pen_feeding_scheduler_list, 'start_feeding_date');
				for (var j = 0; j < pen.pen_feeding_scheduler_list.length; j++) {
					pen.pen_feeding_scheduler_list[j].end_feeding_date = getSchedulerEndDate(pen.pen_feeding_scheduler_list[j + 1] ? pen.pen_feeding_scheduler_list[j + 1].start_feeding_date : null);
				}
				pen = setActiveFeedingValues(pen);
				for (var k = 0; k < vm.category_names.length; k++) {
					if (pen.pen_category.id == vm.category_names[k].id) {
						pen.pen_category.name = vm.category_names[k].name;
					}
				}
				var num = 0;
				if (pen.feeding_1) {
					pen.feeding_1 = moment.utc(moment().format('YYYY-MM-DD') + 'T' + pen.feeding_1).format('YYYY-MM-DDTHH:mm:ss');
					num++;
				}
				if (pen.feeding_2) {
					pen.feeding_2 = moment.utc(moment().format('YYYY-MM-DD') + 'T' + pen.feeding_2).format('YYYY-MM-DDTHH:mm:ss');
					num++;
				}
				if (pen.feeding_3) {
					pen.feeding_3 = moment.utc(moment().format('YYYY-MM-DD') + 'T' + pen.feeding_3).format('YYYY-MM-DDTHH:mm:ss');
					num++;
				}
				pen.number_of_feedings = num;
				pen.total_amount_dm = pen.feed_intake * pen.number_of_animals;
				pen.total_amount_dm_per_day = pen.feed_intake * pen.number_of_animals;
				return pen;
			}

			function getSchedulerEndDate(next_scheduler) {
				var end_date = moment().add(31, 'd').format('YYYY-MM-DD');
				if (next_scheduler) {
					end_date = moment(next_scheduler).subtract(1, 'd').format('YYYY-MM-DD');
				}

				return end_date;
			}

			function setActiveFeedingValues(pen) {
				var today = new Date();
				today.setHours(12, 0, 0);
				var activeSchedule;
				if (pen.pen_feeding_scheduler_list.length == 1) {
					activeSchedule = pen.pen_feeding_scheduler_list[0];
				} else {
					for (var i = 0; i < pen.pen_feeding_scheduler_list.length; i++) {
						var start_date = new Date(pen.pen_feeding_scheduler_list[i].start_feeding_date);
						start_date.setHours(12, 0, 0);
						var end_date = new Date(pen.pen_feeding_scheduler_list[i].end_feeding_date);
						end_date.setHours(12, 0, 0);
						if ((moment(start_date).isBefore(today) || moment(start_date).isSame(today, 'day')) && (moment(end_date).isAfter(today) || moment(end_date).isSame(today, 'day'))) {
							activeSchedule = pen.pen_feeding_scheduler_list[i];
							break;
						}
					}
				}
				if (activeSchedule && activeSchedule.morning_feeding) {
					pen.feeding_1 = activeSchedule.morning_feeding_time + ':00Z';
				}
				if (activeSchedule && activeSchedule.noon_feeding) {
					pen.feeding_2 = activeSchedule.noon_feeding_time + ':00Z';
				}
				if (activeSchedule && activeSchedule.evening_feeding) {
					pen.feeding_3 = activeSchedule.evening_feeding_time + ':00Z';
				}
				return pen;
			}
		}

		function getPenById(id) {
			var suffix = '?team=' + vm.selectedTeam.id + '&herd=' + vm.selectedHerd.id;
			return addNewRecipeService
				.getPenById(id, suffix)
				.then(function (response) {
					for (var i = 0; i < vm.frequencies.length; i++) {
						if (response.feeding_frequency == vm.frequencies[i].value) {
							response.feeding_frequency = vm.frequencies[i].name;
						}
					}
					for (var j = 0; j < response.pen_feeding_scheduler_list.length; j++) {
						if (response.pen_feeding_scheduler_list[j].feeding_frequency_rule) {
							response.pen_feeding_scheduler_list[j].feeding_frequency = getFrequency(response.pen_feeding_scheduler_list[j].feeding_frequency_rule);
						}
						var numb = 0;
						if (response.pen_feeding_scheduler_list[j].evening_feeding) {
							numb += 1;
						}
						if (response.pen_feeding_scheduler_list[j].morning_feeding) {
							numb += 1;
						}
						if (response.pen_feeding_scheduler_list[j].noon_feeding) {
							numb += 1;
						}
						response.pen_feeding_scheduler_list[j].number_of_feedings = numb;
						if (response.pen_feeding_scheduler_list[j].morning_feeding_time) {
							response.pen_feeding_scheduler_list[j].morning_feeding_time = moment(moment().format('YYYY-MM-DD') + 'T' + response.pen_feeding_scheduler_list[j].morning_feeding_time).toDate();
						}
						if (response.pen_feeding_scheduler_list[j].noon_feeding_time) {
							response.pen_feeding_scheduler_list[j].noon_feeding_time = moment(moment().format('YYYY-MM-DD') + 'T' + response.pen_feeding_scheduler_list[j].noon_feeding_time).toDate();
						}
						if (response.pen_feeding_scheduler_list[j].evening_feeding_time) {
							response.pen_feeding_scheduler_list[j].evening_feeding_time = moment(moment().format('YYYY-MM-DD') + 'T' + response.pen_feeding_scheduler_list[j].evening_feeding_time).toDate();
						}
					}
					for (var k = 0; k < vm.category_names.length; k++) {
						if (response.pen_category.id == vm.category_names[k].id) {
							response.pen_category.name = vm.category_names[k].name;
						}
					}
					response.pen_feeding_scheduler_list = currentlyActiveSchedule(response.pen_feeding_scheduler_list);
					var found = false;
					if (vm.recipe.selected_pens) {
						for (var l = 0; l < vm.recipe.selected_pens.length; l++) {
							if (vm.recipe.selected_pens[l].id === response.id) {
								response.ration_depending = !vm.recipe.selected_pens[l].use_pen_feed_intake ? vm.recipe.selected_pens[l].used_feed_intake : null;
								response.dmi_source = vm.recipe.selected_pens[l].use_pen_feed_intake ? $filter('i18n')('_m_f_fixed_') : $filter('i18n')('_m_f_ration_depending_');
								found = true;
								break;
							}
						}
					}
					if (!found) {
						for (var m = 0; m < vm.recipe.pens.length; m++) {
							if (vm.recipe.pens[m].id === response.id) {
								response.ration_depending = vm.recipe.pens[m].use_pen_feed_intake ? vm.recipe.pens[m].feed_intake : vm.ration_feed_intake;
								response.dmi_source = vm.recipe.pens[m].use_pen_feed_intake ? $filter('i18n')('_m_f_fixed_') : $filter('i18n')('_m_f_ration_depending_');
								break;
							}
						}
					}
					vm.details = response;
					vm.modalLoading = false;
					$timeout(function () {
						initialize();
					}, 100);
				})
				.catch(function (error) {
					console.log(error);
					vm.modalLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_pen_details_');
				});

			function getFrequency(feeding_frequency_rule) {
				var rule = parseString(feeding_frequency_rule);
				if (rule) {
					var byWeekDay = rule.options.byweekday;
					var interval = rule.options.interval;
					var string = '';
					if (byWeekDay && byWeekDay.length) {
						for (var i = 0; i < vm.days.length; i++) {
							for (var j = 0; j < byWeekDay.length; j++) {
								if (vm.days[i].value == byWeekDay[j]) {
									if (string != '') {
										string += ', ';
									}
									string += vm.days[i].name;
								}
							}
						}
					} else {
						if (interval) {
							if (interval == 1) {
								string = i18nFilter('_every_day_frequency_');
							} else if (interval == 2) {
								string = i18nFilter('_every_two_day_frequency_');
							} else if (interval == 3) {
								string = i18nFilter('_every_three_day_frequency_');
							} else {
								string = i18nFilter('_dc_other_');
							}
						}
					}
					return string;
				}
			}

			function currentlyActiveSchedule(schedule) {
				schedule = $filter('orderBy')(schedule, 'start_feeding_date', true);
				for (var i = 0; i < schedule.length; i++) {
					var current_date = moment().format('YYYY-MM-DD');
					if (current_date == schedule[i].start_feeding_date || moment(current_date).isAfter(schedule[i].start_feeding_date)) {
						schedule[i].schedule_set = true;
						break;
					}
				}
				return schedule;
			}
		}

		function pensPaginationChanged() {
			vm.recipe.pens = [];
			getPens();
		}

		function selectPen(pen) {
			if (vm.recipe.selected_pens.length) {
				var found = false;
				for (var i = vm.recipe.selected_pens.length - 1; i >= 0; i--) {
					if (vm.recipe.selected_pens[i].id === pen.id) {
						found = true;
						vm.recipe.selected_pens.splice(i, 1);
						break;
					}
				}
				if (!found) {
					vm.recipe.selected_pens.push(pen);
				}
			} else {
				vm.recipe.selected_pens.push(pen);
			}
			checkPenValidation();
			calculateAmounts();
		}

		function checkPenValidation() {
			vm.recipe.penHelpInput = vm.recipe.selected_pens.length ? 'valid' : null;
		}

		function calculateAmounts() {
			$q.all([rationsPromise.promise, pensPromise.promise, /*feedingMethodsPromise.promise,*/ wagonsPromise.promise, ingredientsPromise.promise]).then(function () {
				setUsedAmounts();
				setRecipeValues();
			});
		}

		function setUsedAmounts() {
			vm.recipe.pen_intake_warning = false;
			vm.recipe.ration_feed_intake = calculateRationFeedIntakeAmount();
			for (var i = 0; i < vm.recipe.selected_pens.length; i++) {
				if (vm.recipe.selected_pens[i].use_pen_feed_intake) {
					vm.recipe.selected_pens[i].used_feed_intake = angular.copy(vm.recipe.selected_pens[i].feed_intake);
					vm.recipe.selected_pens[i].total_amount_dm_per_day = vm.recipe.selected_pens[i].used_feed_intake * vm.recipe.selected_pens[i].number_of_animals;
				} else {
					vm.recipe.pen_intake_warning = vm.recipe.ration_feed_intake > vm.maxAmount ? true : false;
					vm.recipe.selected_pens[i].used_feed_intake = angular.copy(vm.recipe.ration_feed_intake);
					vm.recipe.selected_pens[i].total_amount_dm_per_day = vm.recipe.selected_pens[i].used_feed_intake * vm.recipe.selected_pens[i].number_of_animals;
				}
			}

			function calculateRationFeedIntakeAmount() {
				var amount_dm = 0;
				for (var i = 0; i < vm.recipe.selectedRation.ration_feeds.length; i++) {
					amount_dm += vm.recipe.selectedRation.ration_feeds[i].amount_dm;
				}

				return amount_dm;
			}
		}

		function setRecipeValues() {
			var total_number_of_animals = 0;
			var total_cost = 0;
			var total_amount_dm = 0;
			var total_as_fed = 0;
			var total_feeding_1 = 0;
			var total_feeding_2 = 0;
			var total_feeding_3 = 0;
			for (var i = 0; i < vm.recipe.selected_pens.length; i++) {
				vm.recipe.selected_pens[i].total_amount_dm = getWorstCaseScenarioAmount(vm.recipe.selected_pens[i]);
				vm.recipe.selected_pens[i].cost_dm = vm.recipe.selected_pens[i].total_amount_dm * vm.recipe.selectedRation.cost_per_kg_dm;
				vm.recipe.selected_pens[i].total_as_fed = Number.isFinite((vm.recipe.selected_pens[i].total_amount_dm * 100) / vm.recipe.selectedRation.dm) ? (vm.recipe.selected_pens[i].total_amount_dm * 100) / vm.recipe.selectedRation.dm : 0;
				var num = 0;
				if (vm.recipe.selected_pens[i].feeding_1) {
					num += 1;
				}
				if (vm.recipe.selected_pens[i].feeding_2) {
					num += 1;
				}
				if (vm.recipe.selected_pens[i].feeding_3) {
					num += 1;
				}
				var one_feeding = Math.floor(vm.recipe.selected_pens[i].total_as_fed / num);
				vm.recipe.selected_pens[i] = calculateFeedingAmounts(one_feeding, vm.recipe.selected_pens[i], num);
				total_number_of_animals += vm.recipe.selected_pens[i].number_of_animals;
				total_cost += vm.recipe.selected_pens[i].cost_dm;
				total_amount_dm += vm.recipe.selected_pens[i].total_amount_dm;
				total_as_fed += vm.recipe.selected_pens[i].total_as_fed;
				if (vm.recipe.selected_pens[i].feeding_1) {
					total_feeding_1 += vm.recipe.selected_pens[i].feeding_1_amount;
				}
				if (vm.recipe.selected_pens[i].feeding_2) {
					total_feeding_2 += vm.recipe.selected_pens[i].feeding_2_amount;
				}
				if (vm.recipe.selected_pens[i].feeding_3) {
					total_feeding_3 += vm.recipe.selected_pens[i].feeding_3_amount;
				}
			}
			vm.recipe.total_number_of_animals = total_number_of_animals;
			vm.recipe.total_cost = total_cost;
			vm.recipe.total_amount_dm = total_amount_dm;
			vm.recipe.total_as_fed = total_as_fed;
			vm.recipe.total_feeding_1 = total_feeding_1;
			vm.recipe.total_feeding_2 = total_feeding_2;
			vm.recipe.total_feeding_3 = total_feeding_3;
			calculateSuggestion();

			function getWorstCaseScenarioAmount(pen) {
				var all_dates = [];
				var scheduler_list = pen.pen_feeding_scheduler_list;
				scheduler_list = $filter('orderBy')(scheduler_list, 'start_feeding_date');
				all_dates = getSchedulerDays(scheduler_list);
				var maxRange = getMaxRange(all_dates);
				return pen.total_amount_dm_per_day * maxRange;

				function getMaxRange(days) {
					var max = 1;
					for (var i = 0; i < days.length; i++) {
						if (days[i + 1]) {
							var diff = moment(days[i + 1]).diff(days[i], 'days');
							if (diff > max) {
								max = diff;
							}
						}
					}
					return max;
				}
			}
		}

		function getSchedulerDays(scheduler_list) {
			var all_dates = [];
			var today = new Date();
			today.setHours(12, 0, 0);
			for (var i = 0; i < scheduler_list.length; i++) {
				var rrule_start_date = moment(scheduler_list[i].start_feeding_date).format('YYYYMMDDT000000') + 'Z';
				var rrule_end_date = moment(scheduler_list[i].end_feeding_date).format('YYYYMMDDT000000') + 'Z';
				var rrule_string = 'DTSTART:' + rrule_start_date + '\nRRULE:' + (scheduler_list[i].feeding_frequency_rule ? scheduler_list[i].feeding_frequency_rule : 'FREQ=DAILY;INTERVAL=1') + ';UNTIL=' + rrule_end_date;
				var dates = RRule.fromString(rrule_string).all();
				all_dates = all_dates.concat(dates);
			}
			for (var j = 0; j < all_dates.length; j++) {
				all_dates[j].setHours(12, 0, 0);
			}
			all_dates = all_dates.filter(function (date) {
				return moment(date).isAfter(today) || moment(date).isSame(today, 'day');
			});
			return all_dates;
		}

		function calculateFeedingAmounts(one_feeding_amount, obj, num) {
			if (num == 3) {
				obj.feeding_1_amount = one_feeding_amount;
				obj.feeding_2_amount = one_feeding_amount;
				obj.feeding_3_amount = obj.total_as_fed - 2 * one_feeding_amount;
			} else if (num == 2) {
				if (!obj.feeding_1) {
					obj.feeding_2_amount = one_feeding_amount;
					obj.feeding_3_amount = obj.total_as_fed - one_feeding_amount;
				} else if (!obj.feeding_2) {
					obj.feeding_1_amount = one_feeding_amount;
					obj.feeding_3_amount = obj.total_as_fed - one_feeding_amount;
				} else {
					obj.feeding_1_amount = one_feeding_amount;
					obj.feeding_2_amount = obj.total_as_fed - one_feeding_amount;
				}
			} else if (num == 0) {
				obj.feeding_1_amount = 0;
				obj.feeding_2_amount = 0;
				obj.feeding_3_amount = 0;
			} else {
				if (obj.feeding_1) {
					obj.feeding_1_amount = obj.total_as_fed;
				} else if (obj.feeding_2) {
					obj.feeding_2_amount = obj.total_as_fed;
				} else {
					obj.feeding_3_amount = obj.total_as_fed;
				}
			}
			return obj;
		}

		function calculateSuggestion() {
			var defaultWagon = vm.recipe.wagons.filter(function (wagon) {
				return wagon.selected === true && wagon.default === true;
			});

			if (defaultWagon.length) {
				vm.recipe.suggestion.feeding_1 = setFeedingSuggestion(vm.recipe.total_feeding_1, defaultWagon[0]);
				vm.recipe.suggestion.feeding_2 = setFeedingSuggestion(vm.recipe.total_feeding_2, defaultWagon[0]);
				vm.recipe.suggestion.feeding_3 = setFeedingSuggestion(vm.recipe.total_feeding_3, defaultWagon[0]);
			} else {
				if (!vm.recipe.tmr) {
					vm.recipe.suggestion = {
						feeding_1: {
							number_of_loads: 1,
							loads: [
								{
									wagon: {
										name: ''
									},
									value: vm.recipe.total_feeding_1
								}
							]
						},
						feeding_2: {
							number_of_loads: 1,
							loads: [
								{
									wagon: {
										name: ''
									},
									value: vm.recipe.total_feeding_2
								}
							]
						},
						feeding_3: {
							number_of_loads: 1,
							loads: [
								{
									wagon: {
										name: ''
									},
									value: vm.recipe.total_feeding_3
								}
							]
						}
					};
				}
			}

			checkSuggestionValidation();
		}

		function setFeedingSuggestion(amount, wagon) {
			var loads = [];
			var count = 0;

			while (amount > wagon.value && count < 9) {
				loads.push({
					value: wagon.value,
					wagon: wagon
				});
				amount = amount - wagon.value;
				count++;
			}

			loads = $filter('orderBy')(loads, 'value', true);

			if (amount > 0) {
				var load = {
					value: amount,
					wagon: wagon
				};
				loads.push(load);
			}

			return {
				number_of_loads: loads.length,
				loads: loads
			};
		}

		function generateSchedulerOverviewData() {
			for (var i = 0; i < vm.recipe.selected_pens.length; i++) {
				vm.recipe.selected_pens[i].pen_schedule = get7DaysSchedule(vm.recipe.selected_pens[i]);
			}
			vm.schedulerOverviewData = getSchedulerAmountsPerDay(vm.recipe.selected_pens);
			vm.schedulerOverviewData = checkAreFeedingsScheduled(vm.schedulerOverviewData);

			function get7DaysSchedule(pen) {
				var schedule = [];
				var scheduler_list = pen.pen_feeding_scheduler_list;
				var all_dates = getSchedulerDays(scheduler_list);
				var today = new Date();
				today.setHours(12, 0, 0);
				var end_date = moment(today).add(7, 'd');
				all_dates = all_dates.filter(function (date) {
					return moment(date).isAfter(today) || moment(date).isSame(today, 'day');
				});
				schedule = getPenSchedule(pen, all_dates, end_date);
				return schedule;

				function getPenSchedule(pen, dates) {
					var list = [];
					for (var i = 0; i < dates.length; i++) {
						var multi = 1;
						if (dates[i + 1]) {
							multi = moment(dates[i + 1]).diff(dates[i], 'days');
						} else {
							multi = moment(dates[i]).diff(dates[i - 1], 'days');
						}
						var amount_dm = multi * pen.total_amount_dm_per_day;
						var amount_as_fed = Number.isFinite((amount_dm * 100) / vm.recipe.selectedRation.dm) ? (amount_dm * 100) / vm.recipe.selectedRation.dm : 0;
						var active_scheduler = getActiveSchedulerByDate(pen, dates[i]);
						active_scheduler.total_as_fed = amount_as_fed;
						var num = 0;
						if (active_scheduler.morning_feeding) {
							active_scheduler.feeding_1 = true;
							num += 1;
						}
						if (active_scheduler.noon_feeding) {
							active_scheduler.feeding_2 = true;
							num += 1;
						}
						if (active_scheduler.evening_feeding) {
							active_scheduler.feeding_3 = true;
							num += 1;
						}
						var one_feeding = Math.floor(amount_as_fed / num);
						var obj = {};
						if (num) {
							active_scheduler = calculateFeedingAmounts(one_feeding, active_scheduler, num);
							obj = new CreateObj(dates[i], amount_dm, amount_as_fed, active_scheduler.feeding_1_amount, active_scheduler.feeding_2_amount, active_scheduler.feeding_3_amount, pen.pen_name);
						} else {
							obj = new CreateObj(dates[i], 0, 0, 0, 0, 0, pen.pen_name);
						}
						list.push(obj);
					}
					return list;
				}

				function getActiveSchedulerByDate(pen, date) {
					var active_schedule;
					var today = new Date(date);
					today.setHours(12, 0, 0);
					for (var i = 0; i < pen.pen_feeding_scheduler_list.length; i++) {
						var start_date = new Date(pen.pen_feeding_scheduler_list[i].start_feeding_date);
						start_date.setHours(12, 0, 0);
						var end_date = new Date(pen.pen_feeding_scheduler_list[i].end_feeding_date);
						end_date.setHours(12, 0, 0);
						if ((moment(start_date).isBefore(today) || moment(start_date).isSame(today, 'day')) && (moment(end_date).isAfter(today) || moment(end_date).isSame(today, 'day'))) {
							active_schedule = pen.pen_feeding_scheduler_list[i];
							break;
						}
					}
					return active_schedule;
				}

				function CreateObj(date, amount_dm, amount_as_fed, feeding_1, feeding_2, feeding_3, pen_name) {
					this.date = date;
					this.amount_dm = amount_dm;
					this.amount_as_fed = amount_as_fed;
					this.feeding_1 = feeding_1;
					this.feeding_2 = feeding_2;
					this.feeding_3 = feeding_3;
					this.pen_name = pen_name;
				}
			}

			function getSchedulerAmountsPerDay(pens) {
				var days = [];
				var selectedWagons = [];
				for (var i = 0; i < 7; i++) {
					var date = new Date();
					date.setHours(12, 0, 0);
					date = moment(date);
					if (i > 0) {
						date.add(i, 'd');
					}
					var obj = {
						date: date.format(),
						pens: [],
						feeding_1_sum: 0,
						feeding_2_sum: 0,
						feeding_3_sum: 0,
						total_as_fed: 0
					};
					for (var j = 0; j < pens.length; j++) {
						for (var k = 0; k < pens[j].pen_schedule.length; k++) {
							if (moment(date).isSame(pens[j].pen_schedule[k].date, 'day')) {
								obj.pens.push(pens[j].pen_schedule[k]);
								if (pens[j].pen_schedule[k].feeding_1) {
									obj.feeding_1_sum += pens[j].pen_schedule[k].feeding_1;
									obj.total_as_fed += pens[j].pen_schedule[k].feeding_1;
								}
								if (pens[j].pen_schedule[k].feeding_2) {
									obj.feeding_2_sum += pens[j].pen_schedule[k].feeding_2;
									obj.total_as_fed += pens[j].pen_schedule[k].feeding_2;
								}
								if (pens[j].pen_schedule[k].feeding_3) {
									obj.feeding_3_sum += pens[j].pen_schedule[k].feeding_3;
									obj.total_as_fed += pens[j].pen_schedule[k].feeding_3;
								}
							}
						}
					}
					days.push(obj);
				}
				for (var l = 0; l < vm.recipe.wagons.length; l++) {
					if (vm.recipe.wagons[l].selected && vm.recipe.wagons[l].default) {
						selectedWagons.push(vm.recipe.wagons[l]);
					}
				}
				for (var m = 0; m < days.length; m++) {
					if (days[m].feeding_1_sum) {
						days[m].feeding_1_loads = setFeedingSuggestion(days[m].feeding_1_sum, selectedWagons[0]);
					}
					if (days[m].feeding_2_sum) {
						days[m].feeding_2_loads = setFeedingSuggestion(days[m].feeding_2_sum, selectedWagons[0]);
					}
					if (days[m].feeding_3_sum) {
						days[m].feeding_3_loads = setFeedingSuggestion(days[m].feeding_3_sum, selectedWagons[0]);
					}
				}
				return days;
			}

			function checkAreFeedingsScheduled(pens) {
				var hasValue = false;
				for (var i = 0; i < pens.length; i++) {
					if (pens[i].pens.length) {
						hasValue = true;
						break;
					}
				}
				if (hasValue) {
					return pens;
				}
				return [];
			}
		}

		function checkCustomDefinedLoads() {
			var suggestion = angular.copy(vm.recipe.suggestion);
			var f1 = 0;
			if (suggestion.feeding_1.loads) {
				for (var i = 0; i < suggestion.feeding_1.loads.length; i++) {
					f1 += suggestion.feeding_1.loads[i].value;
				}
			}
			suggestion.feeding_1.total_amount = f1;
			var f2 = 0;
			if (suggestion.feeding_2.loads) {
				for (var j = 0; j < suggestion.feeding_2.loads.length; j++) {
					f2 += suggestion.feeding_2.loads[j].value;
				}
			}
			suggestion.feeding_2.total_amount = f2;
			var f3 = 0;
			if (suggestion.feeding_3.loads) {
				for (var k = 0; k < suggestion.feeding_3.loads.length; k++) {
					f3 += suggestion.feeding_3.loads[k].value;
				}
			}
			suggestion.feeding_3.total_amount = f3;
			for (var l = 0; l < vm.schedulerOverviewData.length; l++) {
				if (vm.schedulerOverviewData[l].pens.length) {
					if (vm.schedulerOverviewData[l].feeding_1_sum && vm.schedulerOverviewData[l].feeding_1_sum - 10 < suggestion.feeding_1.total_amount && vm.schedulerOverviewData[l].feeding_1_sum + 10 > suggestion.feeding_1.total_amount) {
						vm.schedulerOverviewData[l].feeding_1_loads.number_of_loads = suggestion.feeding_1.number_of_loads;
						vm.schedulerOverviewData[l].feeding_1_loads.loads = suggestion.feeding_1.loads;
					}

					if (vm.schedulerOverviewData[l].feeding_2_sum && vm.schedulerOverviewData[l].feeding_2_sum - 10 < suggestion.feeding_2.total_amount && vm.schedulerOverviewData[l].feeding_2_sum + 10 > suggestion.feeding_2.total_amount) {
						vm.schedulerOverviewData[l].feeding_2_loads.number_of_loads = suggestion.feeding_2.number_of_loads;
						vm.schedulerOverviewData[l].feeding_2_loads.loads = suggestion.feeding_2.loads;
					}

					if (vm.schedulerOverviewData[l].feeding_3_sum && vm.schedulerOverviewData[l].feeding_3_sum - 10 < suggestion.feeding_3.total_amount && vm.schedulerOverviewData[l].feeding_3_sum + 10 > suggestion.feeding_3.total_amount) {
						vm.schedulerOverviewData[l].feeding_3_loads.number_of_loads = suggestion.feeding_3.number_of_loads;
						vm.schedulerOverviewData[l].feeding_3_loads.loads = suggestion.feeding_3.loads;
					}
				}
			}
		}

		function changeActive(pen) {
			for (var i = 0; i < vm.recipe.pens.length; i++) {
				if (vm.recipe.pens[i].id === pen.id) {
					var index = i;
					break;
				}
			}
			vm.recipe.pens[index].pen_active = !vm.recipe.pens[index].pen_active;
			pen.last_modified_user = vm.user.email;
			var penDto = angular.copy(pen);
			penDto.feeding_1 = penDto.feeding_1 ? moment(penDto.feeding_1).format('HH:mm:ss[Z]') : null;
			penDto.feeding_2 = penDto.feeding_2 ? moment(penDto.feeding_2).format('HH:mm:ss[Z]') : null;
			penDto.feeding_3 = penDto.feeding_3 ? moment(penDto.feeding_3).format('HH:mm:ss[Z]') : null;
			addNewRecipeService.updatePen(penDto).catch(function (error) {
				console.log(error);
				vm.recipe.pens[index].pen_active = !vm.recipe.pens[index].pen_active;
				errorService.showErrorMessage(error, true, '_error_occurred_changing_active_pen_');
			});
		}

		function updateUsePenIntake(pen) {
			var penIndex = 0;
			for (var i = 0; i < vm.recipe.selected_pens.length; i++) {
				if (vm.recipe.selected_pens[i].id === pen.id) {
					vm.recipe.selected_pens[i].use_pen_feed_intake = pen.use_pen_feed_intake;
					calculateAmounts();
					break;
				}
			}
			for (var j = 0; j < vm.recipe.pens.length; j++) {
				if (vm.recipe.pens[j].id === pen.id) {
					penIndex = j;
					break;
				}
			}
			if (vm.recipe.changed_pens.length === 0) {
				vm.recipe.changed_pens.push(vm.recipe.pens[penIndex]);
			} else {
				var index = null;
				for (var k = 0; k < vm.recipe.changed_pens.length; k++) {
					if (vm.recipe.changed_pens[k].id === vm.recipe.pens[penIndex].id) {
						index = k;
						break;
					}
				}
				if (index != null) {
					vm.recipe.changed_pens.splice(index, 1);
				} else {
					vm.recipe.changed_pens.push(vm.recipe.pens[penIndex]);
				}
			}
		}

		/*function getFeedingMethods(init) {
			vm.loadingFeedingMethods = true;
			return addNewRecipeService
				.getFeedingMethods()
				.then(function (response) {
					setFeedingMethodNames(response);
					vm.recipe.feeding_methods = response;
					checkFeedingMethodValidation();
					vm.loadingFeedingMethods = false;
					feedingMethodsPromise.resolve();
				})
				.catch(function (error) {
					console.log(error);
					vm.loadingFeedingMethods = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_feeding_methods_', init);
					feedingMethodsPromise.reject();
				});

			function setFeedingMethodNames(method) {
				for (var i = 0; i < method.length; i++) {
					for (var m = 0; m < vm.feeding_method_names.length; m++) {
						if (method[i].id == vm.feeding_method_names[m].id) {
							method[i].name = vm.feeding_method_names[m].name;
						}
					}
				}
				return method;
			}
		}

		function feedingMethodSelected(fm) {
			for (var i = 0; i < vm.recipe.feeding_methods.length; i++) {
				if (vm.recipe.feeding_methods[i].id === fm.id) {
					vm.recipe.feeding_methods[i].selected = true;
				} else {
					vm.recipe.feeding_methods[i].selected = false;
				}
			}
			if (fm.selected && fm.value == 1) {
				vm.recipe.tmr = true;
			} else {
				vm.recipe.tmr = false;
			}
			checkFeedingMethodValidation();
		}

		function checkFeedingMethodValidation() {
			vm.recipe.feedingMethodHelpInput = vm.recipe.tmr ? 'valid' : null;
		}*/

		function getMixerWagons(init) {
			vm.loadingMixerWagons = true;
			var suffix = '?team=' + vm.selectedTeam.id + '&herd=' + vm.selectedHerd.id;
			return addNewRecipeService
				.getMixerWagons(suffix)
				.then(function (response) {
					for (var i = 0; i < response.length; i++) {
						response[i].default = false;
						response[i].selected = false;
						response[i].value = response[i].weight * 1000;
						if (vm.recipe.wagons) {
							for (var j = 0; j < vm.recipe.wagons.length; j++) {
								if (response[i].id === vm.recipe.wagons[j].id) {
									if (vm.recipe.wagons[j].selected) {
										response[i].selected = true;
									}
									if (vm.recipe.wagons[j].default) {
										response[i].default = true;
									}
								}
							}
						}
					}
					vm.recipe.wagons = response;
					checkWagonValidation();
					vm.recipe.wagons = $filter('orderBy')(vm.recipe.wagons, ['-weight', 'name']);
					wagonsPromise.resolve();
					vm.loadingMixerWagons = false;
				})
				.catch(function (error) {
					console.log(error);
					wagonsPromise.reject(error);
					vm.loadingMixerWagons = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_wagons_', init);
				});
		}

		function wagonSelected(wagon) {
			if (!wagon.selected) {
				wagon.default = false;
			}
			var selectedWagons = [];
			var selIndex;
			for (var i = 0; i < vm.recipe.wagons.length; i++) {
				if (vm.recipe.wagons[i].selected === true) {
					selectedWagons.push(vm.recipe.wagons[i]);
					selIndex = i;
				}
			}
			if (selectedWagons.length === 1) {
				vm.recipe.wagons[selIndex].default = true;
			}
			checkWagonValidation();
			calculateAmounts();
		}

		function defaultSelected(wagon) {
			for (var i = 0; i < vm.recipe.wagons.length; i++) {
				if (vm.recipe.wagons[i].id !== wagon.id) {
					vm.recipe.wagons[i].default = false;
				} else {
					vm.recipe.wagons[i].default = true;
				}
			}
			checkWagonValidation();
			calculateAmounts();
		}

		function checkWagonValidation() {
			var sel = false;
			var def = false;
			for (var i = 0; i < vm.recipe.wagons.length; i++) {
				if (vm.recipe.wagons[i].selected === true) {
					sel = true;
				}
				if (vm.recipe.wagons[i].default === true) {
					def = true;
				}
				if (sel && def) {
					break;
				}
			}
			vm.recipe.wagonHelpInput = sel && def ? 'valid' : null;
		}

		function insertWagon(event) {
			if (event) {
				event.preventDefault();
			}
			vm.newWagon = {};
			openModal('app/pages/recipes/addNewRecipe/insertWagon.modal.html', 'md');
		}

		function addWagon() {
			var newWagonDTO = angular.copy(vm.newWagon);
			vm.modalLoading = true;
			if (!newWagonDTO.volume) {
				newWagonDTO.volume = 0;
			}
			if (!vm.settings.use_kgs) {
				newWagonDTO.weight = unitConversionService.convertData(newWagonDTO.weight, ['imperialTonToMetricTon']);
			}
			var url_suffix = '?team_id=' + vm.settings.selectedTeam.id + '&herd_id=' + vm.settings.selectedHerd.id + '&last_modified_user=' + vm.user.email + '&name=' + newWagonDTO.name + '&volume=' + newWagonDTO.volume + '&weight=' + newWagonDTO.weight;
			if (newWagonDTO.serial_number) {
				url_suffix = url_suffix + '&serial_number=' + encodeURIComponent(newWagonDTO.serial_number);
			}
			return addNewRecipeService
				.addNewWagon(url_suffix)
				.then(function (response) {
					response.value = response.weight * 1000;
					vm.recipe.wagons.push(response);
					cancel();
					vm.modalLoading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.modalLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_adding_wagon_');
				});
		}

		function loadWagonChanged(feeding, index, wagon) {
			var sValue = 0;
			//required sum
			var rSum = vm.recipe['total_' + feeding];
			//original value
			var oValue = vm.recipe.suggestion[feeding].loads[index].value;
			var sum = 0;
			if (vm.recipe.feedingsError[feeding]) {
				if (vm.recipe.feedingsError[feeding] > 0) {
					sValue = oValue - Math.abs(vm.recipe.feedingsError[feeding]);
				} else {
					sValue = oValue + Math.abs(vm.recipe.feedingsError[feeding]);
				}
				if (sValue <= wagon.value) {
					vm.recipe.suggestion[feeding].loads[index].value = sValue;
				} else {
					vm.recipe.suggestion[feeding].loads[index].value = wagon.value;
				}
			} else {
				if (oValue <= wagon.value) {
					vm.recipe.suggestion[feeding].loads[index].value = oValue;
				} else {
					vm.recipe.suggestion[feeding].loads[index].value = wagon.value;
				}
			}
			vm.recipe.suggestion[feeding].loads[index].wagon = wagon;
			for (var j = 0; j < vm.recipe.wagons.length; j++) {
				if (vm.recipe.wagons[j].id === wagon.id) {
					vm.recipe.wagons[j].selected = true;
					break;
				}
			}
			for (var i = 0; i < vm.recipe.suggestion[feeding].loads.length; i++) {
				sum += vm.recipe.suggestion[feeding].loads[i].value;
			}
			var diff = sum - rSum;
			if (Math.abs(diff) > 2) {
				vm.recipe.feedingsError[feeding] = diff;
			} else {
				vm.recipe.feedingsError[feeding] = 0;
			}
			vm.recipe.feeding_changed = true;
			checkSuggestionValidation();
		}

		function checkSuggestionValidation() {
			var feedingsPresent = false;
			vm.recipe.feedingsError = {};

			if (vm.recipe.suggestion.feeding_1 && vm.recipe.suggestion.feeding_1.loads) {
				feedingsPresent = true;
				calculateDifference('feeding_1');
			}

			if (vm.recipe.suggestion.feeding_2 && vm.recipe.suggestion.feeding_2.loads) {
				feedingsPresent = true;
				calculateDifference('feeding_2');
			}

			if (vm.recipe.suggestion.feeding_3 && vm.recipe.suggestion.feeding_3.loads) {
				feedingsPresent = true;
				calculateDifference('feeding_3');
			}

			if (feedingsPresent) {
				if (vm.recipe.feedingsError.feeding_1 || vm.recipe.feedingsError.feeding_2 || vm.recipe.feedingsError.feeding_3) {
					vm.recipe.suggestionHelpInput = null;
				} else {
					vm.recipe.suggestionHelpInput = 'valid';
				}
			} else {
				vm.recipe.suggestionHelpInput = null;
			}

			function calculateDifference(feeding) {
				var sum = 0;
				var loads = angular.copy(vm.recipe.suggestion[feeding].loads);
				for (var i = 0; i < loads.length; i++) {
					sum += loads[i].value;
				}
				var diff = sum - vm.recipe['total_' + feeding];

				if (Math.abs(diff) > 2) {
					vm.recipe.feedingsError[feeding] = diff;
				} else {
					vm.recipe.feedingsError[feeding] = 0;
				}
			}
		}

		function openEditLoadsModal(feeding) {
			var loads;
			if (vm.recipe.suggestion[feeding] && vm.recipe.suggestion[feeding].loads.length) {
				loads = angular.copy(vm.recipe.suggestion[feeding].loads);
			} else {
				loads = [];
			}
			vm.addedWagons = [];
			vm.editLoadsData = {
				sum: vm.recipe['total_' + feeding],
				loads: loads,
				difference: vm.recipe.feedingsError[feeding],
				feeding: feeding,
				wagon: vm.recipe.wagons[0]
			};
			openModal('app/pages/recipes/addNewRecipe/editLoads.modal.html', 'md');
		}

		function showSetButton(load) {
			return load.wagon.value > load.value ? true : false;
		}

		function addLoad() {
			var loadObj = {
				value: Math.abs(vm.editLoadsData.difference),
				wagon: vm.editLoadsData.wagon
			};
			if (loadObj.value > loadObj.wagon.value) {
				loadObj.value = loadObj.wagon.value;
			}
			vm.editLoadsData.loads.push(loadObj);
			calculateLoadDiff();
			var wagonFound = false;
			if (vm.addedWagons.length > 0) {
				for (var i = 0; i < vm.addedWagons.length; i++) {
					if (vm.addedWagons[i].id === vm.editLoadsData.wagon.id) {
						wagonFound = true;
						break;
					}
				}
			}
			if (!wagonFound) {
				vm.addedWagons.push(vm.editLoadsData.wagon);
			}
		}

		function updateLoad(load, data, index, wagon) {
			var loadObj = {
				value: wagon && data > wagon.value ? wagon.value : data,
				wagon: wagon ? wagon : load.wagon
			};
			vm.editLoadsData.loads[index] = angular.copy(loadObj);
			calculateLoadDiff();
			if (wagon) {
				var wagonFound = false;
				if (vm.addedWagons.length > 0) {
					for (var i = 0; i < vm.addedWagons.length; i++) {
						if (vm.addedWagons[i].id === wagon.id) {
							wagonFound = true;
							break;
						}
					}
				}
				if (!wagonFound) {
					vm.addedWagons.push(wagon);
				}
			}
		}

		function setLoad(load, index) {
			if (vm.editLoadsData.difference > 0) {
				load.value -= Math.abs(vm.editLoadsData.difference);
			} else {
				load.value += Math.abs(vm.editLoadsData.difference);
			}
			if (load.value > load.wagon.value) {
				load.value = load.wagon.value;
			}
			if (load.value <= 0) {
				vm.editLoadsData.loads.splice(index, 1);
			}
			calculateLoadDiff();
		}

		function saveLoads() {
			if (vm.addedWagons.length > 0) {
				for (var i = 0; i < vm.addedWagons.length; i++) {
					for (var j = 0; j < vm.recipe.wagons.length; j++) {
						if (vm.addedWagons[i].id === vm.recipe.wagons[j].id) {
							vm.recipe.wagons[j].selected = true;
							break;
						}
					}
				}
			}
			vm.recipe.feeding_changed = true;
			vm.recipe.suggestion[vm.editLoadsData.feeding].loads = vm.editLoadsData.loads;
			vm.recipe.feedingsError[vm.editLoadsData.feeding] = vm.editLoadsData.difference;
			checkSuggestionValidation();
			cancel();
		}

		function removeLoad(index) {
			vm.editLoadsData.loads.splice(index, 1);
			calculateLoadDiff();
		}

		function calculateLoadDiff() {
			var sum = 0;
			for (var i = 0; i < vm.editLoadsData.loads.length; i++) {
				sum += vm.editLoadsData.loads[i].value;
			}
			var diff = sum - vm.editLoadsData.sum;
			if (Math.abs(diff) > 2) {
				vm.editLoadsData.difference = diff;
			} else {
				vm.editLoadsData.difference = 0;
			}
		}

		function amountChanged(pen, data, prop) {
			var d = $q.defer();
			var one_pen = vm.recipe.selected_pens[vm.recipe.selected_pens.indexOf(pen)];
			var amount = one_pen.total_as_fed - data;
			if (amount < 2 || data < 1) {
				d.reject();
			} else {
				var one_feeding = Math.floor(amount / 2);
				if (prop == 'feeding_1') {
					if (one_pen.feeding_2 && one_pen.feeding_3) {
						one_pen.feeding_2_amount = one_feeding;
						one_pen.feeding_3_amount = amount - one_feeding;
					} else if (one_pen.feeding_2) {
						one_pen.feeding_2_amount = amount;
					} else if (one_pen.feeding_3) {
						one_pen.feeding_3_amount = amount;
					} else {
						d.reject();
						return d.promise;
					}
				} else if (prop == 'feeding_2') {
					if (one_pen.feeding_1 && one_pen.feeding_3) {
						one_pen.feeding_1_amount = one_feeding;
						one_pen.feeding_3_amount = amount - one_feeding;
					} else if (one_pen.feeding_1) {
						one_pen.feeding_1_amount = amount;
					} else if (one_pen.feeding_3) {
						one_pen.feeding_3_amount = amount;
					} else {
						d.reject();
						return d.promise;
					}
				} else {
					if (one_pen.feeding_1 && one_pen.feeding_2) {
						one_pen.feeding_1_amount = one_feeding;
						one_pen.feeding_2_amount = amount - one_feeding;
					} else if (one_pen.feeding_1) {
						one_pen.feeding_1_amount = amount;
					} else if (one_pen.feeding_3) {
						one_pen.feeding_2_amount = amount;
					} else {
						d.reject();
						return d.promise;
					}
				}
				$timeout(function () {
					calculateAmounts();
					d.resolve();
				}, 10);
			}
			return d.promise;
		}

		function openTimePicker(prop) {
			if (prop == 'feeding_1') {
				vm.datepickerDisplay = {
					feeding_1: true,
					feeding_2: false,
					feeding_3: false
				};
			} else if (prop == 'feeding_2') {
				vm.datepickerDisplay = {
					feeding_1: false,
					feeding_2: true,
					feeding_3: false
				};
			} else {
				vm.datepickerDisplay = {
					feeding_1: false,
					feeding_2: false,
					feeding_3: true
				};
			}
		}

		function checkValidation(pen, prop) {
			var hour = moment(pen[prop]).format('HH');
			if (prop == 'feeding_1') {
				if (hour < 4 || hour > 11 || hour === 'Invalid date') {
					pen.feeding_1_valid = true;
					vm.timepickerDisable = true;
				} else {
					pen.feeding_1_valid = false;
					vm.timepickerDisable = false;
				}
			} else if (prop == 'feeding_2') {
				if (hour < 12 || hour > 18 || hour === 'Invalid date') {
					pen.feeding_2_valid = true;
					vm.timepickerDisable = true;
				} else {
					pen.feeding_2_valid = false;
					vm.timepickerDisable = false;
				}
			} else {
				if ((hour >= 19 && hour <= 23) || (hour >= 0 && hour <= 3) || hour === 'Invalid date') {
					pen.feeding_3_valid = false;
					vm.timepickerDisable = false;
				} else {
					pen.feeding_3_valid = true;
					vm.timepickerDisable = true;
				}
			}
		}

		function saveRecipe(feedNow) {
			var disableUpdate = false;

			for (var pi = 0; pi < vm.recipe.changed_pens.length; pi++) {
				if (vm.recipe.changed_pens[pi].external_uuid) {
					disableUpdate = true;
					break;
				}
			}

			if (disableUpdate) {
				toastr.warning('', i18nFilter('_m_f_warning_pen_third_party_update_error_'));
				return;
			}
			if (!vm.recipe.selectedRation) {
				toastr.warning('Please select the ration', i18nFilter('_title_warning_'));
				return;
			}

			vm.loading = true;

			if (vm.saveTimeout) {
				$timeout.cancel(vm.saveTimeout);
			}

			vm.saveTimeout = $timeout(function () {
				var recipeDTO = new RecipeDTO2(vm.recipe);				

				return addNewRecipeService
					.addNewRecipe(recipeDTO)
					.then(function () {
						$state.go('recipes.myRecipes');
					})
					.catch(function (error) {
						console.log(error);
						vm.loading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_saving_recipe_');
					});
			}, 300);

			function RecipeDTO2(recipe) {
				this.team_id = vm.selectedTeam.id;
				this.herd_id = vm.selectedHerd.id;
				this.name = recipe.recipe_name;
				//this.feeding_methods = setFeedingMethodsDTO(recipe);
				this.feeding_methods = 1;
				this.comment = recipe.recipe_comment;
				this.dropping_comment = recipe.dropping_comment;
				this.feeding_from = feedNow ? moment(vm.startTime).utc().format('YYYY-MM-DDTHH:mm:ss[Z]') : null;
				this.mixer_wagons = setMixingWagonsDTO2(recipe);
				this.pens = setPensDTO2(recipe);
				this.ration = recipe.selected_ration_type.value === 0 ? setRationRecipeDTO(recipe) : null;
				this.manual_ration = recipe.selected_ration_type.value === 1 ? setRationRecipeDTO(recipe) : null;
				this.load_managements = setLoadManagementDTO(recipe);
			}

			function setMixingWagonsDTO2(recipe) {
				var list = [];
				var selectedWagons = [];
				var wagons = angular.copy(recipe.wagons);
				for (var i = 0; i < wagons.length; i++) {
					if (wagons[i].selected) {
						selectedWagons.push(wagons[i]);
					}
				}
				var wLength = selectedWagons.length - 1;
				for (var j = 0; j < selectedWagons.length; j++) {
					list.push({
						id: selectedWagons[j].id ? selectedWagons[j].id : null,
						position: selectedWagons[j].default ? 0 : wLength
					});
					if (!selectedWagons[j].default) {
						wLength--;
					}
				}
				return list;
			}

			function setPensDTO2(recipe) {
				var list = [];
				var pens = angular.copy(recipe.selected_pens);
				for (var i = 0; i < pens.length; i++) {
					var pen = {
						id: pens[i].id,
						use_pen_intake: pens[i].use_pen_feed_intake
					};
					list.push(pen);
				}
				return list;
			}

			function setRationRecipeDTO(recipe) {
				var ration = {
					id: recipe.selectedRation.id,
					ration_feeds: []
				};

				if (recipe.selectedRation && recipe.selectedRation.ration_feeds) {
					for (var i = 0; i < recipe.selectedRation.ration_feeds.length; i++) {
						var feed = {
							id: recipe.selectedRation.ration_feeds[i].id,
							ingredient: setIngredientDTO(recipe.selectedRation.ration_feeds[i]),
							position: i
						};

						ration.ration_feeds.push(feed);
						if (recipe.selectedRation.ration_feeds[i].dirty) {
							feed.cost_dm = recipe.selectedRation.ration_feeds[i].cost_dm;
							feed.dm = recipe.selectedRation.ration_feeds[i].dm;
							feed.amount_dm = recipe.selectedRation.ration_feeds[i].amount_dm;
						}
					}
				}

				function setIngredientDTO(feed) {
					var _ingredient = {
						id: null
					};
					if (feed.ingredient) {
						_ingredient.id = feed.ingredient.id;
						_ingredient.dm = feed.ingredient.dm;

						return _ingredient;
					} else {
						if (feed.ingredient_id) {
							return _ingredient;
						} else {
							return null;
						}
					}
				}

				return ration;
			}

			function setLoadManagementDTO(recipe) {
				var list = [];
				angular.forEach(recipe.suggestion, function (value, key) {
					var feeding = {
						load_subject_order_number: key == 'feeding_1' ? 1 : key == 'feeding_2' ? 2 : 3,
						load_details: []
					};

					for (var i = 0; i < value.loads.length; i++) {		
						var load = {
							amount: value.loads[i].value,
							mixer_wagon_id: value.loads[i].wagon.id,
							position: i,
							mixing_time: value.loads[i].mixing_time ? value.loads[i].mixing_time : null
						};
						feeding.load_details.push(load);
					}

					if (feeding.load_details.length) {
						list.push(feeding);
					}
				});

				return list;
			}

			/*function setFeedingMethodsDTO(recipe) {
				for (var i = 0; i < recipe.feeding_methods.length; i++) {
					if (recipe.feeding_methods[i].selected) {
						return recipe.feeding_methods[i].value;
					}
				}
			}*/
		}

		function goToPage(page, obj) {
			localStorage.setItem(
				'from_recipe',
				JSON.stringify({
					type: 'add'
				})
			);
			$timeout(function () {
				$state.go(page, {
					uuid: obj && obj.id ? obj.id : null
				});
			}, 50);
		}

		function initialize() {
			try {
				var addMarkerToMap;
				var zoom;
				if (vm.details.pen_lat && vm.details.pen_lng) {
					addMarkerToMap = true;
					zoom = 16;
				} else {
					vm.details.pen_lat = 43.8900745;
					vm.details.pen_lng = 20.3492278;
					addMarkerToMap = false;
					zoom = 3;
					vm.latLngMissing = true;
				}
				var id = 'google-maps';
				var mapCanvas = document.getElementById(id);
				var mapOptions = {
					center: new google.maps.LatLng(vm.details.pen_lat, vm.details.pen_lng),
					zoom: zoom,
					mapTypeId: google.maps.MapTypeId.SATELLITE
				};
				var map = new google.maps.Map(mapCanvas, mapOptions);
				if (!map || !map.renderingType) {
					vm.showGMap = false;
					return;
				}
				var latLng = {
					lat: Number(vm.details.pen_lat),
					lng: Number(vm.details.pen_lng)
				};
				if (typeof latLng.lat === 'number' && typeof latLng.lng === 'number' && !isNaN(latLng.lat) && !isNaN(latLng.lng) && addMarkerToMap) {
					map.panTo(latLng);
				}
				if (vm.details.pen_location) {
					var pen = new google.maps.Polygon({
						paths: JSON.parse(vm.details.pen_location),
						strokeColor: '#FF0000',
						strokeOpacity: 0.8,
						strokeWeight: 2,
						fillColor: '#FF0000',
						fillOpacity: 0.35
					});
					pen.setMap(map);
				}
			} catch (error) {
				console.log(error);
			}
		}
		function saveMixingTime() {
			var minutes = vm.mixingTime && vm.mixingTime.minutes ? parseInt(vm.mixingTime.minutes, 10) : 0;
			var mixingTimeSeconds = minutes * 60 || null;
			if (vm.mixingTimeData && vm.mixingTimeData.set_to_all) {
				Object.keys(vm.recipe.suggestion || {}).forEach(function (feedingKey) {
					var feeding = vm.recipe.suggestion[feedingKey];
					if (feeding && Array.isArray(feeding.loads)) {
						feeding.loads.forEach(function (load) {
							load.mixing_time = mixingTimeSeconds;
						});
					}
				});
			} else if (vm.mixingTimeData && vm.mixingTimeData.feeding_number != null && vm.mixingTimeData.load_index != null) {
				vm.recipe.suggestion[vm.mixingTimeData.feeding_number].loads[vm.mixingTimeData.load_index].mixing_time = mixingTimeSeconds;
			}
			cancel();
		}

		function getMinutes() {
			return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59];
		}

		function openMixingTimeSelector(feeding_number, index) {
			vm.mixingTimeData = {
				feeding_number: feeding_number,
				load_index: index,
				set_to_all: false
			};
			var mixingTime = vm.recipe.suggestion[feeding_number].loads[index].mixing_time ? {
				hours: Math.floor(vm.recipe.suggestion[feeding_number].loads[index].mixing_time / 3600) || null,
				minutes: Math.floor((vm.recipe.suggestion[feeding_number].loads[index].mixing_time % 3600) / 60) || null,
				seconds: vm.recipe.suggestion[feeding_number].loads[index].mixing_time % 60 || null
			} : {
				hours: null,
				minutes: null,
				seconds: null
			};
			vm.mixingTime = angular.copy(mixingTime);
			openModal('app/pages/recipes/mixingTimeSelector.modal.html', 'sm');
		}

		function openFeedingDatepicker() {
			openModal('app/pages/recipes/feedingDatepicker.modal.html', 'sm');
		}

		function openPenDetailsModal(pen) {
			vm.modalLoading = true;
			openModal('app/pages/recipes/addNewRecipe/penDetails.modal.html', 'lg');
			getPenById(pen.id);
		}

		function openWeekPreviewModal() {
			vm.loadingWeekModal = true;
			$uibModal.open({
				animation: true,
				templateUrl: 'app/pages/recipes/weekOverview.modal.html',
				scope: $scope,
				backdrop: 'static',
				keyboard: false,
				windowClass: 'modal-custom-width'
			});
			$timeout(function () {
				generateSchedulerOverviewData();
				checkCustomDefinedLoads();
				vm.loadingWeekModal = false;
			}, 100);
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function cancel() {
			$uibModalStack.dismissAll();
		}

		function cancelWizard() {
			$state.go('recipes.myRecipes');
		}

		(function removeDefaultTooltip() {
			var tooltipInterval = $interval(
				function () {
					$timeout(function () {
						var tabs = document.getElementsByClassName('wizard-step');
						var tabLoaded = document.getElementById('add-recipe-tabs');
						if (tabLoaded) {
							for (var i = 0; i < tabs.length; i++) {
								tabs[i]._title = tabs[i].title;
								tabs[i].onmouseenter = function () {
									this.title = '';
								};
								tabs[i].onmouseleave = function () {
									this.title = this._title;
								};
							}
							$interval.cancel(tooltipInterval);
						}
					}, 50);
				},
				500,
				15
			);
		})();

		function tabValidation() {
			return {
				'ration-tab-validation': !vm.recipe.rationHelpInput && vm.selectRationForm && vm.selectRationForm.$submitted,
				'ration-tab-validation-dmi': vm.recipe && vm.recipe.rationHelpInput && vm.recipe.ration_intake_warning,
				'pen-tab-validation': !vm.recipe.penHelpInput && vm.selectPenForm && vm.selectPenForm.$submitted,
				'pen-tab-validation-dmi': vm.recipe && vm.recipe.penHelpInput && vm.recipe.pen_intake_warning,
				'wagon-tab-validation': ((!vm.recipe.tmr && !vm.recipe.feedingMethodHelpInput) || (vm.recipe.tmr && !vm.recipe.wagonHelpInput)) && vm.feedingMethod && vm.feedingMethod.$submitted,
				'drop-tab-validation': (!vm.recipe.suggestionHelpInput || vm.timepickerDisable) && vm.management && vm.management.$submitted
			};
		}

		function disableSaveButton() {
			return vm.timepickerDisable || (vm.recipe.feedingsError && (vm.recipe.feedingsError.feeding_1 || vm.recipe.feedingsError.feeding_2 || vm.recipe.feedingsError.feeding_3));
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_herd_selected', function () {
			selectTab(0);
			init();
		});

		$scope.$on('default_team_herd_changed', function () {
			selectTab(0);
			init();
		});

		$scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
			vm.fromState = fromState.name;
			if (vm.fromState && (vm.fromState.contains('pens.editPen') || vm.fromState.contains('pens.addNewPen') || vm.fromState.contains('pens.penHistory')) && vm.recipe.rationHelpInput) {
				$q.all([rationsPromise.promise, ingredientsPromise.promise]).then(function () {
					selectTab(1);
				});
			}
		});

		function selectTab(number) {
			$rootScope.$broadcast('select_pen_tab', number);
		}

		editableOptions.theme = 'bs3';
		editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
		editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.recipes.addNewRecipe').factory('addNewRecipeService', addNewRecipeService);
	/** @ngInject */
	function addNewRecipeService($http, $q, APP_CONST) {
		return {
			getRationsByHerd: getRationsByHerd,
			getRationsByTeam: getRationsByTeam,
			getRationById: getRationById,
			getPensByTeamHerd: getPensByTeamHerd,
			addNewRecipe: addNewRecipe,
			getFeedingMethods: getFeedingMethods,
			getRationCostByRationId: getRationCostByRationId,
			getPenById: getPenById,
			getIngredients: getIngredients,
			getMixerWagons: getMixerWagons,
			checkIngredient: checkIngredient,
			addNewRation: addNewRation,
			getImportedRationsByHerd: getImportedRationsByHerd,
			checkImportedIngredient: checkImportedIngredient,
			addNewWagon: addNewWagon,
			checkRecipeRecalculation: checkRecipeRecalculation,
			updatePen: updatePen,
			updateUsePenIntake: updateUsePenIntake
		};

		function getRationsByHerd(herdId, pageNumber, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'herds/' + herdId + '/rations/' + pageNumber + suffix)
				.then(success)
				.catch(error);
		}

		function getRationsByTeam(teamId, pageNumber, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'teams/' + teamId + '/rations/' + pageNumber + suffix)
				.then(success)
				.catch(error);
		}

		function getRationById(id) {
			return $http
				.get(APP_CONST.api_base_url + 'rations/' + id)
				.then(success)
				.catch(error);
		}

		function getPensByTeamHerd(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'pens' + suffix)
				.then(success)
				.catch(error);
		}

		function addNewRecipe(recipe) {
			return $http
				.post(APP_CONST.api_base_url + 'recipes', recipe)
				.then(success)
				.catch(error);
		}

		function getFeedingMethods() {
			return $http
				.get(APP_CONST.api_base_url + 'feedingMethods')
				.then(success)
				.catch(error);
		}

		function getRationCostByRationId(rationId, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'rations/' + rationId + '/costDm' + suffix)
				.then(success)
				.catch(error);
		}

		function getPenById(id, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'pens/' + id + suffix)
				.then(success)
				.catch(error);
		}

		function getIngredients(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'ingredients' + suffix)
				.then(success)
				.catch(error);
		}

		function getMixerWagons(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'mixerwagon' + suffix)
				.then(success)
				.catch(error);
		}

		function checkIngredient(id) {
			return $http
				.get(APP_CONST.api_base_url + 'ingredients/feed/' + id)
				.then(success)
				.catch(error);
		}

		function addNewRation(ration) {
			return $http
				.post(APP_CONST.api_base_url + 'importRationsWithRationFeed', ration)
				.then(success)
				.catch(error);
		}

		function getImportedRationsByHerd(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'importRationsWithRationFeedByHerd' + suffix)
				.then(success)
				.catch(error);
		}

		function checkImportedIngredient(id) {
			return $http
				.get(APP_CONST.api_base_url + 'ingredients/feedimport/' + id)
				.then(success)
				.catch(error);
		}

		function checkRecipeRecalculation(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'linkedrecipes/' + suffix)
				.then(success)
				.catch(error);
		}

		function addNewWagon(url) {
			return $http
				.post(APP_CONST.api_base_url + 'mixerwagon' + url)
				.then(success)
				.catch(error);
		}

		function updatePen(pen) {
			return $http
				.put(APP_CONST.api_base_url + 'pens/active', pen)
				.then(success)
				.catch(error);
		}

		function updateUsePenIntake(pen) {
			return $http
				.put(APP_CONST.api_base_url + 'pens', pen)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.reports.dropping').controller('droppingCtrl', droppingCtrl);
	/** @ngInject */
	function droppingCtrl() {
		var vm = this;
		console.log(vm);
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.recipes.editRecipe').controller('editRecipeCtrl', editRecipeCtrl);
	/** @ngInject */

	function editRecipeCtrl(
		recipeDataService,
		$timeout,
		$filter,
		authService,
		errorService,
		$q,
		editRecipeService,
		$scope,
		editableOptions,
		toastr,
		editableThemes,
		$interval,
		unitConversionService,
		$uibModal,
		$locale,
		$rootScope,
		$state,
		APP_CONST,
		$uibModalStack,
		$stateParams,
		uaParser,
		bugsnagService,
		recipePreviewDataService
	) {
		var vm = this;
		var RRule = rrule.RRule;
		var parseString = rrule.rrulestr;
		var i18nFilter = $filter('i18n');
		var rationAccessCode = 16;

		var rationPromise;
		var rationsPromise;
		var ingredientsPromise;
		var pensPromise;
		//var feedingMethodsPromise;
		var wagonsPromise;
		var recipePromise;
		var setRecipePromise;
		var loadingPromise;
		var versionTimeout;

		vm.toggleShowRation = toggleShowRation;
		vm.selectRationType = selectRationType;
		vm.rationsPaginationChanged = rationsPaginationChanged;
		vm.selectRation = selectRation;
		vm.updateFeed = updateFeed;
		vm.linkIngredient = linkIngredient;
		vm.drag = drag;
		vm.dragEnd = dragEnd;
		vm.selectRecipeRation = selectRecipeRation;
		vm.pensPaginationChanged = pensPaginationChanged;
		vm.selectPen = selectPen;
		vm.openPenDetailsModal = openPenDetailsModal;
		vm.changeActive = changeActive;
		vm.updateUsePenIntake = updateUsePenIntake;
		//vm.feedingMethodSelected = feedingMethodSelected;
		vm.wagonSelected = wagonSelected;
		vm.defaultSelected = defaultSelected;
		vm.insertWagon = insertWagon;
		vm.addWagon = addWagon;
		vm.openEditLoadsModal = openEditLoadsModal;
		vm.showSetButton = showSetButton;
		vm.addLoad = addLoad;
		vm.updateLoad = updateLoad;
		vm.setLoad = setLoad;
		vm.saveLoads = saveLoads;
		vm.removeLoad = removeLoad;
		vm.loadWagonChanged = loadWagonChanged;
		vm.amountChanged = amountChanged;
		vm.checkValidation = checkValidation;
		vm.openTimePicker = openTimePicker;
		vm.saveRecipe = saveRecipe;
		vm.openFeedingDatepicker = openFeedingDatepicker;
		vm.openWeekPreviewModal = openWeekPreviewModal;
		vm.goToPage = goToPage;
		vm.cancel = cancel;
		vm.cancelWizard = cancelWizard;
		vm.tabValidation = tabValidation;
		vm.disableSaveButton = disableSaveButton;
		vm.selectVersion = selectVersion;
		vm.openMixingTimeSelector = openMixingTimeSelector;
		vm.getMinutes = getMinutes;
		vm.saveMixingTime = saveMixingTime;

		init();

		function init() {
			vm.showPenMessage = false;
			vm.loading = true;
			var recipe = recipeDataService.getRecipe();
			if (recipe && recipe.active_version) {


				vm.lastRecipeConfig = angular.copy(recipe);
				recipeDataService.resetRecipe();
				vm.recipe = recipeDataService.getRecipe();

			} else {
				vm.recipe = recipe;
			}
			vm.recipe.feedingMethodHelpInput = 'valid';
			vm.historicalVersion = recipe.historicalVersion;
			vm.disableDrag = uaParser.getDevice('type') ? true : false;
			vm.showGMap = true;
			vm.forceDisableSave = false;
			vm.saveTimeout = null;
			setConstants();
			callApis();
		}

		function reloadApi() {
			vm.loading = true;
			vm.showGMap = true;
			vm.forceDisableSave = false;
			vm.recipe = recipeDataService.getRecipe();
			callApis();
		}

		function setConstants() {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.from_recipe = JSON.parse(localStorage.getItem('from_recipe'));
			vm.from_calendar = JSON.parse(localStorage.getItem('from_calendar'));
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			vm.today = moment().toDate();
			vm.todayWithTime = moment().format('YYYY-MM-DDTHH:mm:ss');
			vm.startDate = moment().toDate();

			if (!vm.settings.use_kgs) {
				vm.weight = 'Lb';
			} else {
				vm.weight = 'Kg';
			}

			vm.options = {
				showWeeks: false,
				minDate: vm.today
			};

			vm.maxAmount = 40;

			getDefaultTeamHerd();
			setStrings();
			setRationTypes();
			setCategories();
			setFeedIntakeSourceList();
			//setFeedingMethodsList();
			setFeedingFrequencies();
			setCustomDays();
			checkLng();
		}

		function getDefaultTeamHerd() {
			if (vm.settings.selectedTeam.id) {
				vm.selectedTeam = vm.settings.selectedTeam;
			}
			if (vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd;
			} else {
				vm.selectedHerd = null;
			}
		}

		function setStrings() {
			$timeout(function () {
				vm.step1 = i18nFilter('_m_f_add_new_recipe_step1_title_');
				vm.step2 = i18nFilter('_m_f_add_new_recipe_step2_title_');
				vm.step3 = i18nFilter('_m_f_recipe_choose_mixer_wagons_');
				vm.step4 = i18nFilter('_m_f_add_new_recipe_step4_title_');
				vm.step5 = i18nFilter('_m_f_add_new_recipe_step5_title_');
				vm.showPage = true;
			}, 100);
		}

		function setRationTypes() {
			vm.rationTypes = [
				{
					name: i18nFilter('_added_ration_manually_'),
					value: 1
				}
			];
			if (authService.can(rationAccessCode)) {
				vm.hasRationAccess = true;
				vm.rationTypes.splice(0, 0, {
					name: i18nFilter('_report_footer_feed_'),
					value: 0
				});
			} else {
				vm.hasRationAccess = false;
			}
		}

		function setCategories() {
			vm.category_names = [
				{
					name: i18nFilter('_milking_cows_hp_'),
					id: 1
				},
				{
					name: i18nFilter('_milking_cows_lp_'),
					id: 2
				},
				{
					name: i18nFilter('_dry_cows_'),
					id: 3
				},
				{
					name: i18nFilter('_heifers_2nd_year_of_life_'),
					id: 4
				},
				{
					name: i18nFilter('_heifers_1st_year_of_life_'),
					id: 5
				},
				{
					name: i18nFilter('_fattening_bulls_'),
					id: 6
				},
				{
					name: i18nFilter('_calves_'),
					id: 7
				}
			];
		}

		function setFeedIntakeSourceList() {
			vm.feedIntakeSources = [
				{
					value: true,
					name: i18nFilter('_m_f_fixed_')
				},
				{
					value: false,
					name: i18nFilter('_m_f_ration_depending_')
				}
			];
		}

		/*function setFeedingMethodsList() {
			vm.feeding_method_names = [
				{
					name: i18nFilter('_mf_tmr_label_'),
					id: 1
				},
				{
					name: i18nFilter('_mf_non_tmr_label_'),
					id: 2
				},
				{
					name: i18nFilter('_mf_feeding_station_'),
					id: 3
				}
			];
		}*/

		function setFeedingFrequencies() {
			vm.frequencies = [
				{
					name: i18nFilter('_every_day_frequency_'),
					value: 1
				},
				{
					name: i18nFilter('_every_two_day_frequency_'),
					value: 2
				},
				{
					name: i18nFilter('_every_three_day_frequency_'),
					value: 3
				}
			];
		}

		function setCustomDays() {
			vm.days = [];
			var listOfDays = APP_CONST.constants.custom_feeding_days;
			for (var i = 0; i < listOfDays.length; i++) {
				var obj = {
					name: i18nFilter(listOfDays[i].longName),
					value: listOfDays[i].value
				};
				vm.days.push(obj);
			}
		}

		function checkLng() {
			if (vm.settings.language) {
				if (vm.settings.language == 'en-gb') {
					vm.locale = 'en-gb';
				} else if (vm.settings.language == 'en-us') {
					vm.locale = 'en';
				} else if (vm.settings.language == 'cs-cz') {
					vm.locale = 'cs';
				} else if (vm.settings.language == 'es-es') {
					vm.locale = 'es';
				} else if (vm.settings.language == 'nl-nl') {
					vm.locale = 'nl';
				} else if (vm.settings.language == 'it-it') {
					vm.locale = 'nl';
				}
			} else {
				vm.locale = 'en-gb';
			}
		}

		function callApis() {
			if (vm.selectedHerd) {
				rationsPromise = $q.defer();
				pensPromise = $q.defer();
				//feedingMethodsPromise = $q.defer();
				wagonsPromise = $q.defer();
				recipePromise = $q.defer();
				loadingPromise = $q.defer();
				setRecipePromise = $q.defer();
				ingredientsPromise = $q.defer();
				if (vm.from_recipe) {
					getRecipeById();
					//getFeedingMethods();
					processResponse();
				} else {
					getRecipeById();
					//getFeedingMethods();
					processResponse();
				}
				getIngredients();
				getPens(true);
				getMixerWagons();
				stopLoading();

				localStorage.removeItem('from_recipe');
				localStorage.removeItem('from_calendar');
			}
		}

		function processResponse() {
			checkPromises()
				.then(function () {
					if (vm.lastRecipeConfig) {
						vm.recipe.is_selected = vm.lastRecipeConfig.is_selected;
					} else {
						vm.recipe.is_selected = true;
					}

					setRecipe();
				})
				.catch(function () {
					vm.forceDisableSave = true;
					loadingPromise.resolve();
				});
		}

		function setRecipe() {
			setRecipeRation();
			reorderRationList();
			setPens();
			//setFeedingMethods();
			setWagons();
			calculateAmounts(true);
			$q.all([setRecipePromise.promise]).then(function () {
				recalculateSuggestion();
			});

			function setRecipeRation() {
				try {
					//var ration = findActiveRation(vm.recipe.recipe_ration_schedulers);
					var ration = vm.recipe.active_version.recipe_ration;

					if (ration) {
						if (ration.ration_feeds && ration.ration_feeds.length) {
							ration.ration_feeds = $filter('orderBy')(ration.ration_feeds, 'position');

							//ration.scheduledRationFeedDTOs = $filter('orderBy')(ration.scheduledRationFeedDTOs, 'order_number');

							ration.ration_feeds.forEach(function (feed) {
								feed.amount_as_fed = (feed.amount_dm * 100) / feed.dm;
								feed.cost_as_fed = (feed.cost_dm * feed.dm) / 100;
							});
						}

						if (ration.manual_ration_feeds && ration.manual_ration_feeds.length) {
							ration.manual_ration_feeds = $filter('orderBy')(ration.manual_ration_feeds, 'position');

							//ration.scheduledRationFeedDTOs = $filter('orderBy')(ration.scheduledRationFeedDTOs, 'order_number');

							ration.manual_ration_feeds.forEach(function (feed) {
								feed.amount_as_fed = (feed.amount_dm * 100) / feed.dm;
								feed.cost_as_fed = (feed.cost_dm * feed.dm) / 100;
							});
						}
					}

					vm.recipe.ration = {
						id: ration.ration_header_id || ration.manual_ration_id,
						ration_header_id: ration.ration_header_id,
						manual_ration_id: ration.manual_ration_id,
						ration_feeds: ration.ration_header_id ? setRecipeRationFeeds(ration.ration_feeds, false) : setRecipeRationFeeds(ration.manual_ration_feeds, true),
						create_date: ration.create_date,
						last_modified_date: ration.last_modified_date,
						dm: ration.dm,
						ration_name: ration.ration_name,
						group: ration.group,
						recipe_list: [],
						visible: ration.visible
					};

					if (vm.lastRecipeConfig && vm.lastRecipeConfig.selectedRation) {
						vm.recipe.selectedRation = vm.lastRecipeConfig.selectedRation;
					} else {
						vm.recipe.selectedRation = vm.recipe.ration;
					}

					if (!vm.recipe.ration.visible) {
						vm.deletedRation = true;
					} else {
						vm.deletedRation = false;
					}

					compareRations();
					checkRationValidation();
					calculateRationAmount();
				} catch (error) {
					console.error(error);
					checkRationValidation();
					bugsnagService.logMessage('Error occurred while executing setRecipeRation method', error);
				}

				function setRecipeRationFeeds(feeds, manual) {
					var list = [];

					feeds.forEach(function (feed) {
						list.push({
							feed_name: feed.name,
							amount_dm: feed.amount_dm,
							amount_as_fed: feed.amount_as_fed,
							cost_dm: feed.cost_dm,
							cost_as_fed: feed.cost_as_fed,
							dm: feed.dm,
							original_dm: feed.dm,
							id: feed.id,
							ration_feed_id: manual ? null : feed.ration_feed_id,
							manual_ration_feed_id: manual ? feed.ration_feed_id : null,
							ingredient: getIngredient(feed.ingredient),
							ingredient_id: feed.ingredient ? feed.ingredient.id : null,
							ingredient_changed: false,
							dirty: false,
							access_error: !vm.hasRationAccess
						});
					});

					return list;

					function getIngredient(ingredient) {
						if (!ingredient) {
							return null;
						}
						var ing = vm.recipe.ingredients.find(function (_ingredient) {
							return _ingredient.id === ingredient.id;
						});

						return ing || null;
					}
				}
			}

			function reorderRationList() {
				var id = vm.recipe.ration.ration_header_id || vm.recipe.ration.manual_ration_id;
				var rIndex = vm.recipe.rations.findIndex(function (r) {
					return r.id === id;
				});

				if (rIndex && rIndex > 0) {
					var ration = vm.recipe.rations[rIndex];
					vm.recipe.rations.splice(rIndex, 1);
					vm.recipe.rations.unshift(ration);
				}
			}

			function setPens() {
				try {
					vm.recipe.selected_pens_deleted = [];
					vm.recipe.selected_pens = [];
					if (vm.recipe.active_version.scheduled_pens && vm.recipe.active_version.scheduled_pens.length) {
						vm.recipe.selected_pens_deleted = [];
						vm.recipe.pens.forEach(function (item) {
							item.is_selected = false;
						});
						for (var i = 0; i < vm.recipe.active_version.scheduled_pens.length; i++) {
							var p = angular.copy(processPen(vm.recipe.active_version.scheduled_pens[i], vm.recipe.active_version));
							if (p.visible) {
								p.is_selected = true;
								vm.recipe.selected_pens.push(p);
							}

							if (!vm.recipe.active_version.scheduled_pens[i].visible) {
								vm.recipe.selected_pens_deleted.push(p);
							} else {
								for (var j = 0; j < vm.recipe.pens.length; j++) {
									if (vm.recipe.active_version.scheduled_pens[i].id === vm.recipe.pens[j].id) {
										vm.recipe.pens[j].number_of_animals = vm.recipe.active_version.scheduled_pens[i].number_of_animals;
										vm.recipe.pens[j].feed_intake = vm.recipe.active_version.scheduled_pens[i].feed_intake;
										vm.recipe.pens[j].use_pen_feed_intake = vm.recipe.active_version.scheduled_pens[i].use_pen_feed_intake;
										vm.recipe.pens[j].number_of_feedings = vm.recipe.active_version.scheduled_pens[i].number_of_feedings;
										vm.recipe.pens[j].create_date = vm.recipe.active_version.scheduled_pens[i].create_date;
										vm.recipe.pens[j].is_selected = true;
										break;
									}
								}
							}
						}
					}
					checkPenValidation();

				} catch (error) {
					console.error(error);
					checkPenValidation();
					bugsnagService.logMessage('Error occurred while executing setPens method', error);
				}
			}

			/*function setFeedingMethods() {
				try {
					if (vm.recipe.recipe_methods != null) {
						for (var k = 0; k < vm.recipe.feeding_methods.length; k++) {
							if (vm.recipe.feeding_methods[k].value === vm.recipe.recipe_methods) {
								if (vm.recipe.feeding_methods[k].value === 1) {
									vm.recipe.tmr = true;
								}
								vm.recipe.feeding_methods[k].selected = true;
								break;
							}
						}
					}
					checkFeedingMethodValidation();
				} catch (error) {
					console.error(error);
					checkFeedingMethodValidation();
					bugsnagService.logMessage('Error occurred while executing setFeedingMethods method', error);
				}
			}*/

			function setWagons() {
				try {
					if (vm.deletedWagons && vm.deletedWagons.length) {
						vm.recipe.wagons = vm.recipe.wagons.filter(function (wagon) {
							return !vm.deletedWagons.some(function (deletedWagon) {
								return wagon.id === deletedWagon.id;
							});
						});
					}
					vm.deletedWagons = [];
					if (vm.recipe.active_version.mixer_wagons && vm.recipe.active_version.mixer_wagons.length) {
						vm.recipe.wagons.forEach(function (item) {
							item.selected = false;
							item.default = false;
						});
						for (var l = 0; l < vm.recipe.active_version.mixer_wagons.length; l++) {
							var found = false;
							for (var m = 0; m < vm.recipe.wagons.length; m++) {
								if (vm.recipe.active_version.mixer_wagons[l].id === vm.recipe.wagons[m].id) {
									found = true;
									vm.recipe.wagons[m].selected = true;
									vm.recipe.wagons[m].weight = vm.recipe.active_version.mixer_wagons[l].weight;
									vm.recipe.wagons[m].volume = vm.recipe.active_version.mixer_wagons[l].volume;
									vm.recipe.wagons[m].value = vm.recipe.active_version.mixer_wagons[l].weight * 1000;
									if (vm.recipe.active_version.mixer_wagons[l].position === 0) {
										vm.recipe.wagons[m].default = true;
									}
									break;
								}
							}
							if (!found) {
								vm.recipe.active_version.mixer_wagons[l].deleted = true;
								vm.recipe.active_version.mixer_wagons[l].selected = true;
								vm.recipe.active_version.mixer_wagons[l].value = vm.recipe.active_version.mixer_wagons[l].weight * 1000;
								vm.recipe.wagons.push(vm.recipe.active_version.mixer_wagons[l]);
								vm.deletedWagons.push(vm.recipe.active_version.mixer_wagons[l]);
							}
						}
					}
					checkWagonValidation();
				} catch (error) {
					console.error(error);
					checkWagonValidation();
					bugsnagService.logMessage('Error occurred while executing setWagons method', error);
				}
			}

			function recalculateSuggestion() {
				try {
					var recalculate = false;
					var total_feeding_1 = 0;
					var total_feeding_2 = 0;
					var total_feeding_3 = 0;

					vm.recipe.mixing_feedings.forEach(function (mf) {
						switch (mf.feeding) {
							case 1:
								total_feeding_1 += mf.amount;
								break;
							case 2:
								total_feeding_2 += mf.amount;
								break;
							case 3:
								total_feeding_3 += mf.amount;
								break;
							default:
								break;
						}
					});

					if (Math.abs(vm.recipe.total_feeding_1 - total_feeding_1) > 10) {
						recalculate = true;
					}

					if (Math.abs(vm.recipe.total_feeding_2 - total_feeding_2) > 10) {
						recalculate = true;
					}

					if (Math.abs(vm.recipe.total_feeding_3 - total_feeding_3) > 10) {
						recalculate = true;
					}

					if (recalculate) {
						calculateSuggestion(true);
					} else {
						setFeedings();
					}
					loadingPromise.resolve();
				} catch (error) {
					console.error(error);
					bugsnagService.logMessage('Error occurred while executing recalculateSuggestion method', error);
					loadingPromise.resolve();
				}

				function setFeedings() {
					try {
						if (vm.recipe.mixing_feedings.length && vm.recipe.mixing_feedings.length) {
							var mixingFeedings = angular.copy(vm.recipe.mixing_feedings);
							var feeding_1_loads = [];
							var feeding_2_loads = [];
							var feeding_3_loads = [];

							mixingFeedings.forEach(function (mw) {
								mw.value = mw.amount;
								mw.wagon_id = mw.mixer_wagon_id;
								mw.wagon = vm.recipe.wagons.find(function (wagon) {
									return mw.wagon_id === wagon.id;
								});

								switch (mw.feeding) {
									case 1:
										feeding_1_loads.push(mw);
										break;
									case 2:
										feeding_2_loads.push(mw);
										break;
									case 3:
										feeding_3_loads.push(mw);
										break;
									default:
										break;
								}
							});

							vm.recipe.suggestion.feeding_1.loads = feeding_1_loads;
							vm.recipe.suggestion.feeding_1.number_of_loads = feeding_1_loads.length;
							vm.recipe.suggestion.feeding_2.loads = feeding_2_loads;
							vm.recipe.suggestion.feeding_2.number_of_loads = feeding_2_loads.length;
							vm.recipe.suggestion.feeding_3.loads = feeding_3_loads;
							vm.recipe.suggestion.feeding_3.number_of_loads = feeding_3_loads.length;
						}
					} catch (error) {
						console.error(error);
						bugsnagService.logMessage('Error occurred while executing setFeedings method', error);
					}
				}
			}
		}

		function stopLoading() {
			$q.all([loadingPromise.promise]).then(function () {
				vm.loading = false;
				checkSuggestionValidation();
			});
		}

		function getRecipeById() {
			if (vm.selectedHerd && vm.selectedTeam) {
				var suffix = '/' + $stateParams.uuid + '?team=' + vm.selectedTeam.id + '&herd=' + vm.selectedHerd.id;
				return editRecipeService
					.getRecipeById(suffix)
					.then(function (response) {
						vm.recipe.recipe_name = vm.lastRecipeConfig && vm.lastRecipeConfig.recipe_name ? vm.lastRecipeConfig.recipe_name : response.name;
						vm.recipe.recipe_methods = response.feeding_methods;
						vm.recipe.id = response.id;
						vm.recipe.versions = response.recipe_versions;
						if (response.recipe_versions && response.recipe_versions.length) {
							var active_version = getActiveVersion(response.recipe_versions, null, vm.lastRecipeConfig ? vm.lastRecipeConfig.active_version : null);
							if (active_version) {
								active_version.is_active_version = true;
								vm.recipe = handleRecipeResponse(vm.recipe, active_version);

								vm.recipe.versions = setHistoricFlag(vm.recipe.versions, getActiveVersion(response.recipe_versions));
								getRations(true);
							} else {
								vm.recipe.ration_error = true;
								loadingPromise.resolve();
							}
						} else {
							vm.recipe.ration_error = true;
							loadingPromise.resolve();
						}

						recipePromise.resolve();
					})
					.catch(function (error) {
						console.log(error);
						recipePromise.reject(error);
						errorService.showErrorMessage(error, true, '_error_occurred_loading_recipes_', true);
					});
			}
		}

		function setHistoricFlag(versions, active_version) {
			versions = versions.map(function (version) {
				var isBefore = moment(version.used_from).isBefore(active_version.used_from);
				version.historical_version = isBefore ? true : false;
				return version;
			});

			return versions;
		}

		function handleRecipeResponse(recipe, active_version) {
			recipe.active_version = active_version;
			if (vm.lastRecipeConfig && ((vm.lastRecipeConfig.selected_pens && vm.lastRecipeConfig.selected_pens.length) || (vm.lastRecipeConfig.selected_pens_deleted && vm.lastRecipeConfig.selected_pens_deleted.length))) {
				recipe.active_version.scheduled_pens = vm.lastRecipeConfig.selected_pens.map(function (pen) {
					var p = angular.copy(pen);
					p.is_selected = true;
					return p;
				});
				recipe.active_version.scheduled_pens = recipe.active_version.scheduled_pens.concat(vm.lastRecipeConfig.selected_pens_deleted.map(function (pen) {
					var p = angular.copy(pen);
					p.is_selected = false;
					p.visible = false;
					return p;
				}));
			}


			if (vm.lastRecipeConfig && vm.lastRecipeConfig.wagons && vm.lastRecipeConfig.wagons.length) {

				recipe.active_version.mixer_wagons = vm.lastRecipeConfig.wagons.filter(function (wagon) {
					return wagon.selected;
				});

				recipe.active_version.mixer_wagons = recipe.active_version.mixer_wagons.map(function (wagon, index) {
					var w = angular.copy(wagon);
					w.position = w.default ? 0 : recipe.active_version.mixer_wagons.length - index;
					return w;
				});
			}


			recipe.versions = setVersions(recipe);
			if (vm.lastRecipeConfig && vm.lastRecipeConfig.selected_ration_type && vm.lastRecipeConfig.original_ration_type_string) {
				recipe.selected_ration_type = vm.lastRecipeConfig.selected_ration_type;
				recipe.original_ration_type_string = vm.lastRecipeConfig.original_ration_type_string;

			} else {
				if (authService.can(rationAccessCode)) {
					if (active_version.recipe_ration.ration_header_id) {
						recipe.selected_ration_type = vm.rationTypes[0];
						recipe.original_ration_type_string = i18nFilter('_report_footer_feed_');
					} else {
						recipe.selected_ration_type = vm.rationTypes[1];
						recipe.original_ration_type_string = i18nFilter('_added_ration_manually_');
					}
				} else {
					recipe.selected_ration_type = vm.rationTypes[0];
					if (active_version.recipe_ration.ration_header_id) {
						recipe.original_ration_type_string = i18nFilter('_m_f_recipe_ration_access_error_');
					} else {
						recipe.original_ration_type_string = i18nFilter('_added_ration_manually_');
					}
				}
			}

			if (vm.lastRecipeConfig && vm.lastRecipeConfig.mixing_feedings && vm.lastRecipeConfig.mixing_feedings.length) {
				recipe.mixing_feedings = vm.lastRecipeConfig.mixing_feedings;
			} else {
				recipe.mixing_feedings = setMixingFeedings(active_version);
			}
			return recipe;
		}

		function setVersions(recipe) {
			var versions = $filter('orderBy')(recipe.versions, ['used_from', 'create_date'], true);
			versions.forEach(function (item, index) {
				if (index) {
					item.used_until = moment(versions[index - 1].used_from);
				} else {
					item.used_until = moment().add(31, 'days');
				}
				item.total_price = 0;
				item.scheduled_pens.forEach(function (pen) {
					var price = (pen.use_pen_feed_intake ? pen.feed_intake : item.recipe_ration.amount_dm) * item.cost_dm_per_kg * pen.number_of_animals;
					item.total_price += price;
				});
				if (item.id == recipe.active_version.id) {
					item.is_selected = true;
				}
			});

			return versions;
		}

		function getActiveVersion(versions, version_date, last_active_version) {
			var date;
			if (version_date) {
				date = moment(version_date);
			} else {
				date = moment();
			}

			if (versions.length == 1) {
				return versions[0];
			} else {

				if (last_active_version) {
					var a_version = versions.find(function (_version) {
						return _version.id === last_active_version.id;
					});
					if (a_version) {
						return a_version;
					}
				}

				var versionsBefore = versions.filter(function (_version) {
					return moment(_version.used_from).isSameOrBefore(date);
				});
				versionsBefore = $filter('orderBy')(versionsBefore, ['used_from', 'create_date']);

				if (versionsBefore && versionsBefore.length > 0) {
					return versionsBefore[versionsBefore.length - 1];
				} else {
					var versionsAfter = versions.filter(function (_version) {
						return moment(_version.used_from).isSameOrAfter(date);
					});

					versionsAfter = $filter('orderBy')(versionsAfter, ['used_from', 'create_date']);
					if (versionsAfter && versionsAfter.length > 0) {
						return versionsAfter[0];
					}
				}
			}

			return null;
		}

		function setMixingFeedings(active_version) {
			var list = [];

			active_version.scheduled_pens = setPenFedDays(active_version.scheduled_pens);
			active_version.scheduled_pens = setWorstCase(active_version);
			active_version.scheduled_pens = setFeedingAmounts(active_version);
			var summary = {
				morning_feeding: 0,
				noon_feeding: 0,
				evening_feeding: 0
			};

			var morning_feeding = false;
			var noon_feeding = false;
			var evening_feeding = false;

			active_version.scheduled_pens.forEach(function (pen) {
				if (pen.morning_feeding) {
					morning_feeding = true;
					summary.morning_feeding += pen.morning_feeding;
				}

				if (pen.noon_feeding) {
					noon_feeding = true;
					summary.noon_feeding += pen.noon_feeding;
				}

				if (pen.evening_feeding) {
					evening_feeding = true;
					summary.evening_feeding += pen.evening_feeding;
				}
			});

			var lm_f_1 = active_version.load_management.find(function (lm) {
				return lm.load_subject_order_number == 1;
			});
			var lm_f_2 = active_version.load_management.find(function (lm) {
				return lm.load_subject_order_number == 2;
			});
			var lm_f_3 = active_version.load_management.find(function (lm) {
				return lm.load_subject_order_number == 3;
			});

			var mf1 = [];
			var mf2 = [];
			var mf3 = [];

			var recalculate = false;
			if (!lm_f_1 || Math.abs(lm_f_1.amount - summary.morning_feeding) > 10) {
				if (morning_feeding) {
					recalculate = true;
				}
			} else {
				lm_f_1.load_details.forEach(function (load) {
					var l = {
						amount: load.amount,
						feeding: 1,
						mixer_wagon_id: load.mixer_wagon_id,
						position: load.position,
						mixing_time: load.mixing_time
					};
					mf1.push(l);
				});
			}

			if (!lm_f_2 || Math.abs(lm_f_2.amount - summary.noon_feeding) > 10) {
				if (noon_feeding) {
					recalculate = true;
				}
			} else {
				lm_f_2.load_details.forEach(function (load) {
					var l = {
						amount: load.amount,
						feeding: 2,
						mixer_wagon_id: load.mixer_wagon_id,
						position: load.position,
						mixing_time: load.mixing_time
					};
					mf2.push(l);
				});
			}

			if (!lm_f_3 || Math.abs(lm_f_3.amount - summary.evening_feeding) > 10) {
				if (evening_feeding) {
					recalculate = true;
				}
			} else {
				lm_f_3.load_details.forEach(function (load) {
					var l = {
						amount: load.amount,
						feeding: 3,
						mixer_wagon_id: load.mixer_wagon_id,
						position: load.position,
						mixing_time: load.mixing_time
					};
					mf3.push(l);
				});
			}

			if (!recalculate) {
				list = list.concat(mf1).concat(mf2).concat(mf3);
			}

			return list;
		}

		function updateMixingFeedings() {
			var mf1 = [];
			var mf2 = [];
			var mf3 = [];

			for (var i = 0; i < vm.recipe.suggestion.feeding_1.loads.length; i++) {
				var load = vm.recipe.suggestion.feeding_1.loads[i];
				var l = {
					amount: load.value,
					feeding: 1,
					mixer_wagon_id: load.wagon ? load.wagon.id : null,
					position: i
				};
				mf1.push(l);
			}

			for (var j = 0; j < vm.recipe.suggestion.feeding_2.loads.length; j++) {
				var load2 = vm.recipe.suggestion.feeding_2.loads[j];
				var l2 = {
					amount: load2.value,
					feeding: 2,
					mixer_wagon_id: load2.wagon ? load2.wagon.id : null,
					position: j
				};
				mf2.push(l2);
			}

			for (var k = 0; k < vm.recipe.suggestion.feeding_3.loads.length; k++) {
				var load3 = vm.recipe.suggestion.feeding_3.loads[k];
				var l3 = {
					amount: load3.value,
					feeding: 3,
					mixer_wagon_id: load3.wagon ? load3.wagon.id : null,
					position: k
				};
				mf3.push(l3);
			}

			return mf1.concat(mf2).concat(mf3);


		}

		function setPenFedDays(pens) {
			pens = pens.map(function (pen) {
				pen.pen_feeding_scheduler_list = $filter('orderBy')(pen.pen_feeding_scheduler_list, 'start_feeding_date');
				var days = [];

				pen.pen_feeding_scheduler_list.forEach(function (pfs, index) {
					var rrule_start_date = moment(pfs.start_feeding_date).format('YYYYMMDDT000000') + 'Z';
					var rrule_end_date = pen.pen_feeding_scheduler_list[index + 1]
						? moment(pen.pen_feeding_scheduler_list[index + 1].start_feeding_date)
							.subtract(1, 'd')
							.format('YYYYMMDDT000000') + 'Z'
						: moment().add(30, 'd').format('YYYYMMDDT000000') + 'Z';
					var rrule_freq = pfs.feeding_frequency_rule && pfs.feeding_frequency_rule.length > 1 ? pfs.feeding_frequency_rule : 'FREQ=DAILY;INTERVAL=1';
					var rrule_string = 'DTSTART:' + rrule_start_date + '\nRRULE:' + rrule_freq + ';UNTIL=' + rrule_end_date;
					var dates = RRule.fromString(rrule_string).all();
					dates = dates.map(function (day) {
						return { d: day, pfs: pfs };
					});
					days = days.concat(dates);
				});

				days = days.map(function (day, index) {
					var to = days[index + 1] && days[index + 1].d ? days[index + 1].d : null;
					var diff = to ? moment(to).diff(day.d, 'days') : 0;
					day.multiply = diff;
					return day;
				});
				pen.days_fed = days;
				return pen;
			});

			return pens;
		}

		function setWorstCase(active_version) {
			var pens = active_version.scheduled_pens;
			pens = pens.map(function (pen) {
				var max;

				pen.days_fed.forEach(function (day) {
					if (moment(day.d).isSameOrAfter(moment(active_version.used_from).subtract(1, 'd')) && moment(day.d).isSameOrBefore(active_version.used_until)) {
						if (!max) {
							max = day;
						} else {
							if (day.multiply > max.multiply) {
								max = day;
							}
						}
					}
				});
				if (!max) {
					max = pen.days_fed[0];
				}
				pen.worst_case = max;
				return pen;
			});

			return pens;
		}

		function setFeedingAmounts(version) {
			version.scheduled_pens = version.scheduled_pens.map(function (pen) {
				var daily_intake = (pen.use_pen_feed_intake ? pen.feed_intake : version.recipe_ration.amount_dm) * pen.worst_case.multiply * pen.number_of_animals;
				pen.total_dm = daily_intake;
				pen.total_as_fed = version.recipe_ration.dm ? (pen.total_dm * 100) / version.recipe_ration.dm : 0;

				var n = 0;

				if (pen.worst_case.pfs.morning_feeding) {
					n++;
				}

				if (pen.worst_case.pfs.noon_feeding) {
					n++;
				}

				if (pen.worst_case.pfs.evening_feeding) {
					n++;
				}

				var per_feeding = pen.total_as_fed / n;
				if (isNaN(per_feeding)) {
					per_feeding = 1;
				}

				if (pen.worst_case.pfs.morning_feeding) {
					pen.morning_feeding = per_feeding;
				}

				if (pen.worst_case.pfs.noon_feeding) {
					pen.noon_feeding = per_feeding;
				}

				if (pen.worst_case.pfs.evening_feeding) {
					pen.evening_feeding = per_feeding;
				}
				return pen;
			});

			return version.scheduled_pens;
		}

		/*function findActiveRation(rations) {
			rations = rations.sort(function (a, b) {
				return moment(a.used_from).valueOf() - moment(b.used_from).valueOf();
			});

			var validRationsList = rations.filter(function (ration) {
				return moment(ration.used_from).isSameOrBefore(vm.todayWithTime);
			});

			if (!validRationsList.length) {
				return rations[0];
			}

			return validRationsList[validRationsList.length - 1];
		}*/

		function toggleShowRation() {
			vm.hideFilters = !vm.hideFilters;
			compareRations(vm.hideFilters);
		}

		function compareRations(show) {
			var ration = vm.recipe.rations.find(function (r) {
				return (vm.recipe.ration.ration_header_id && vm.recipe.ration.ration_header_id === r.ration_header_id) || (vm.recipe.ration.manual_ration_id && vm.recipe.ration.manual_ration_id === r.manual_ration_id);
			});

			if (ration) {
				if (show) {
					ration.is_displayed = true;

					if (moment(ration.last_modified_date).isAfter(vm.recipe.ration.create_date)) {
						ration.origin = setOrigin(i18nFilter('_m_f_edited_ration_'), ration);
						vm.recipe.ration.origin = setOrigin(i18nFilter('_m_f_original_ration_'));
					} else {
						ration.origin = setOrigin(i18nFilter('_m_f_original_ration_'), ration);
						vm.recipe.ration.origin = setOrigin(i18nFilter('_m_f_edited_ration_'));
					}
				} else {
					if (moment(ration.last_modified_date).isAfter(vm.recipe.ration.create_date)) {
						ration.origin = setOrigin(i18nFilter('_m_f_edited_ration_'), ration);
						vm.recipe.ration.origin = setOrigin(i18nFilter('_m_f_original_ration_'));
					} else {
						ration.is_displayed = false;
						ration.duplicate = true;
						ration.origin = null;
						vm.recipe.ration.origin = null;
						vm.recipe.show_hide_ration_button = true;
					}
				}
			} else {
				vm.recipe.ration.origin = null;
			}

			function setOrigin(message, ration) {
				if (ration) {
					if (ration.ration_header_id) {
						return message + ' - ' + i18nFilter('_report_footer_feed_');
					} else {
						return message + ' - ' + i18nFilter('_added_ration_manually_');
					}
				} else {
					return message;
				}
			}
		}

		function selectVersion(version) {
			vm.lastRecipeConfig = null;
			if (versionTimeout) {
				$timeout.cancel(versionTimeout);
			}

			vm.recipe.versions.forEach(function (item) {
				if (item.id != version.id) {
					item.is_selected = false;
				}
			});

			versionTimeout = $timeout(function () {
				if (version.historical_version) {
					vm.recipe.historicalVersion = true;
					vm.historicalVersion = true;
				} else {
					vm.recipe.historicalVersion = false;
					vm.historicalVersion = false;
				}
				setRecipePromise = $q.defer();
				vm.recipe.selected_pens = [];
				vm.recipe.pens = angular.copy(vm.recipe.current_pens);
				vm.recipe = handleRecipeResponse(vm.recipe, version);
				getRations(false, true);
			}, 750);
		}

		function selectRationType(init) {
			if (!vm.recipe.is_selected) {
				vm.recipe.selectedRation = null;
			}
			vm.recipe.rations = [];
			rationsPromise = $q.defer();
			getRations(init);
			$q.all([rationsPromise.promise]).then(function () {
				vm.recipe.show_hide_ration_button = false;
				vm.hideFilters = false;
				compareRations();
			});
		}

		function getRations(init, value_changed) {
			if (vm.recipe.selected_ration_type.value) {
				getImportedRationsByHerd(init, value_changed);
			} else {
				getRationsByHerd(init, value_changed);
			}
		}

		function rationsPaginationChanged() {
			vm.recipe.rations = [];
			getRations();
		}

		function getImportedRationsByHerd(init, value_changed) {
			vm.loadingRations = true;
			var suffix = '/' + vm.selectedHerd.id + '/' + vm.recipe.currentPageRation + '?visible=true';
			return editRecipeService
				.getImportedRationsByHerd(suffix)
				.then(function (response) {
					vm.recipe.totalItemsRation = response && response.number_of_all ? response.number_of_all : 0;

					for (var i = 0; i < response.manual_rations.length; i++) {
						response.manual_rations[i] = processRation(response.manual_rations[i]);
						response.manual_rations[i] = checkSelectedRation(response.manual_rations[i]);
					}

					checkRationValidation();
					vm.recipe.rations = $filter('orderBy')(response.manual_rations, 'id', true);
					vm.loadingRations = false;
					if (value_changed) {
						setRecipe();
					}
					rationsPromise.resolve();
				})
				.catch(function (error) {
					console.log(error);
					rationsPromise.reject(error);
					vm.loadingRations = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_rations_', init);
				});

			function processRation(ration) {
				ration.is_displayed = true;
				ration.manual_ration_id = ration.id;
				ration.ration_feeds = $filter('orderBy')(ration.ration_feeds, 'order_number');

				return ration;
			}

			function checkSelectedRation(ration) {
				ration.is_selected = false;
				if (vm.lastRecipeConfig && vm.lastRecipeConfig.selectedRation && ration.id === vm.lastRecipeConfig.selectedRation.id && vm.lastRecipeConfig.is_selected === false) {
					ration.is_selected = true;
				}

				if (vm.recipe.rations && vm.recipe.rations.length) {
					for (var i = 0; i < vm.recipe.rations.length; i++) {
						if (ration.id === vm.recipe.rations[i].id) {
							ration = vm.recipe.rations[i];
							break;
						}
					}
				}

				if (!vm.recipe.is_selected && vm.recipe.selectedRation) {
					if (ration.id === vm.recipe.selectedRation.id) {
						ration = vm.recipe.selectedRation;
					}
				}

				return ration;
			}
		}

		function getRationsByHerd(init, value_changed) {
			vm.loadingRations = true;
			var suffix = '?active=true';
			if (authService.can(rationAccessCode)) {
				return editRecipeService
					.getRationsByHerd(vm.selectedHerd.id, vm.recipe.currentPageRation, suffix)
					.then(function (response) {
						vm.recipe.totalItemsRation = response && response.length ? response[0].number_of_all : 0;
						var promiseList = [];

						for (var i = 0; i < response.length; i++) {
							processRation(response[i], promiseList);
						}

						$q.all(promiseList)
							.then(function () {
								for (var j = 0; j < response.length; j++) {
									response[j] = checkSelectedRation(response[j]);
								}

								checkRationValidation();
								vm.recipe.rations = response;
								vm.loadingRations = false;
								if (value_changed) {
									setRecipe();
								}
								rationsPromise.resolve();
							})
							.catch(function () {
								checkRationValidation();
								vm.loadingRations = false;
								rationsPromise.reject();
							});
					})
					.catch(function (error) {
						console.log(error);
						rationsPromise.reject(error);
						vm.loadingRations = false;
						errorService.showErrorMessage(error, true, '_error_occurred_loading_rations_', init);
					});
			} else {
				checkRationValidation();
				rationsPromise.resolve();
				vm.recipe.rations = [];
				vm.loadingRations = false;
			}

			function processRation(ration) {
				ration.is_displayed = true;
				ration.ration_header_id = ration.id;
				/*var p = getDmData(ration.id, init).then(function (res) {
					ration.dm = res.dm;
				});
				list.push(p);

				function getDmData(id, init) {
					var suffix = '?herd=' + vm.selectedHerd.id;
					return editRecipeService
						.getRationCostByRationId(id, suffix)
						.then(function (response) {
							return $q.resolve(response);
						})
						.catch(function (error) {
							console.log(error);
							errorService.showErrorMessage(error, true, '_error_occurred_loading_dm_', init);
							return $q.reject(error);
						});
				}*/
			}

			function checkSelectedRation(ration) {
				//add last modified date check when available
				ration.is_selected = false;
				if (vm.lastRecipeConfig && vm.lastRecipeConfig.selectedRation && ration.id === vm.lastRecipeConfig.selectedRation.id && vm.lastRecipeConfig.is_selected === false) {
					ration.is_selected = true;
				}
				if (vm.recipe.rations && vm.recipe.rations.length) {
					for (var i = 0; i < vm.recipe.rations.length; i++) {
						if (ration.id === vm.recipe.rations[i].id) {
							ration = vm.recipe.rations[i];
							break;
						}
					}
				}

				if (!vm.recipe.is_selected && vm.recipe.selectedRation) {
					if (ration.id === vm.recipe.selectedRation.id) {
						ration = vm.recipe.selectedRation;
					}
				}

				return ration;
			}
		}

		function checkRationValidation() {
			if (vm.recipe.selectedRation) {
				if (vm.recipe.selectedRation.dm > 0) {
					vm.recipe.rationHelpInput = 'valid';
				} else {
					vm.recipe.rationHelpInput = null;
				}
			} else {
				vm.recipe.rationHelpInput = null;
			}
		}

		function selectRation(ration) {
			vm.recipe.popover_ration_index = vm.recipe.rations.indexOf(ration);
			vm.recipe.selectedRation = ration;
			vm.recipe.is_selected = false;
			ration.is_selected = true;
			vm.deletedRation = false;

			vm.recipe.rations.forEach(function (r) {
				if (r.id !== ration.id) {
					r.is_selected = false;
				}
			});

			if (ration.manual_ration_id) {
				if (ration.ingredients_checked) {
					selectRationAfterInit();
				} else {
					vm.disableRationSelect = true;
					rationPromise = $q.defer();
					$q.all([rationPromise.promise]).then(function () {
						selectRationAfterInit();
					});
					if (!ration.ingredients_checked) {
						vm.loadingRationFeeds = true;
						checkImportedRationIngredients(ration);
					} else {
						rationPromise.resolve();
					}
				}
			} else {
				if (ration.ration_feeds) {
					selectRationAfterInit();
				} else {
					vm.disableRationSelect = true;
					rationPromise = $q.defer();
					$q.all([rationPromise.promise]).then(function () {
						selectRationAfterInit();
					});
					if (!ration.ration_feeds) {
						vm.loadingRationFeeds = true;
						getRationById(ration);
					} else {
						rationPromise.resolve();
					}
				}
			}

			function selectRationAfterInit() {
				checkRationValidation();
				calculateRationAmount();
				if (vm.recipe.selected_pens && vm.recipe.selected_pens.length > 0) {
					calculateAmounts();
				}
				vm.disableRationSelect = false;
				vm.loadingRationFeeds = false;
			}
		}

		function calculateRationAmount() {
			var amount_dm = 0;
			var amount_as_fed = 0;
			var cost_dm = 0;

			vm.recipe.selectedRation.ration_feeds.forEach(function (feed) {
				amount_dm += feed.amount_dm;
				amount_as_fed += feed.amount_as_fed;
				cost_dm += (feed.cost_dm || 0) * feed.amount_dm;
			});

			vm.recipe.selectedRation.amount_dm = amount_dm;
			vm.recipe.selectedRation.amount_as_fed = amount_as_fed;
			vm.recipe.selectedRation.dm = (amount_dm / amount_as_fed) * 100;
			vm.recipe.selectedRation.cost_dm = cost_dm;
			vm.recipe.selectedRation.cost_per_kg_dm = cost_dm / amount_dm;

			var sum = 0;
			vm.recipe.ration_intake_warning = false;
			vm.recipe.selectedRation.ration_feeds.forEach(function (feed) {
				sum += feed.amount_dm;
			});

			if (sum > vm.maxAmount) {
				vm.recipe.ration_intake_warning = true;
			}

			vm.recipe.rationHelpInput = (vm.recipe.selectedRation.dm > 0 && !vm.deletedRation) || vm.historicalVersion ? 'valid' : undefined;
		}

		function updateFeed(data, feed, prop) {
			feed.dirty = true;

			switch (prop) {
				case 'dm':
					feed.amount_as_fed = (feed.amount_dm * 100) / data;
					break;
				case 'amount_dm':
					feed.amount_as_fed = (data * 100) / feed.dm;
					break;
				case 'amount_as_fed':
					feed.amount_dm = (data * feed.dm) / 100;
					break;
				default:
					break;
				case 'cost_dm':
					feed.cost_as_fed = (feed.cost_dm * feed.dm) / 100;
					break;
				case 'cost_as_fed':
					feed.cost_dm = (feed.cost_as_fed * 100) / feed.dm;
					break;
			}

			calculateRationAmount();
			if (vm.recipe.selected_pens && vm.recipe.selected_pens.length) {
				calculateAmounts();
			}
		}

		function linkIngredient(ingredient, feed) {
			var changed = false;
			if (ingredient) {
				feed.ingredient = ingredient;
				feed.dm = ingredient.dm;
				if (feed.ingredient_id !== ingredient.id) {
					feed.ingredient_changed = true;
					feed.ingredient.linked = true;
					changed = true;
				} else {
					if (feed.ingredient_changed) {
						feed.ingredient_changed = false;
						feed.ingredient.linked = false;
						changed = true;
					}
				}
			} else {
				feed.ingredient = null;
				feed.dm = feed.original_dm;
				if (feed.ingredient_id) {
					feed.ingredient_changed = true;
					changed = true;
				} else {
					if (feed.ingredient_changed) {
						feed.ingredient_changed = false;
						changed = true;
					}
				}
			}

			if (changed) {
				feed.amount_as_fed = (feed.amount_dm * 100) / feed.dm;
				feed.cost_as_fed = (feed.cost_dm * feed.dm) / 100;
				var found = false;
				var tempList = vm.recipe.selectedRation.ration_feeds;
				for (var i = 0; i < tempList.length; i++) {
					if (tempList[i].ingredient_changed) {
						found = true;
						break;
					}
				}

				if (found) {
					if (vm.recipe.is_selected) {
						if (!vm.recipe.recipe_list.length) {
							checkRecipeRecalculation(feed);
						}
					} else {
						if (!vm.recipe.selectedRation.recipe_list.length) {
							checkRecipeRecalculation(feed);
						}
					}
				}

				calculateRationAmount();
				if (vm.recipe.selected_pens && vm.recipe.selected_pens.length) {
					calculateAmounts();
				}
			}

			function checkRecipeRecalculation(feed) {
				var suffix = '';
				if (feed.manual_ration_feed_id) {
					if (vm.recipe.is_selected) {
						suffix = feed.manual_ration_feed_id + '?type=import_ration_feed';
					} else {
						suffix = feed.id + '?type=import_ration_feed';
					}
				} else {
					if (vm.recipe.is_selected) {
						suffix = feed.ration_feed_id + '?type=ration_feed';
					} else {
						suffix = feed.id + '?type=ration_feed';
					}
				}
				suffix += '&herd=' + vm.selectedHerd.id;

				editRecipeService
					.checkRecipeRecalculation(suffix)
					.then(function (response) {
						var recipeList = response.filter(function (recipe) {
							return vm.recipe.id !== recipe.id;
						});

						if (vm.recipe.is_selected) {
							vm.recipe.recipe_list = recipeList;
						} else {
							vm.recipe.recipe_list = [];
							vm.recipe.selectedRation.recipe_list = recipeList;
						}
					})
					.catch(function (error) {
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_loading_linked_recipes_');
					});
			}
		}

		function checkImportedRationIngredients(ration) {
			var promiseList = [];
			var feedIngredientList = [];

			ration.ration_feeds.forEach(function (feed) {
				var p = checkImportedIngredient(feed.id).then(function (response) {
					feedIngredientList.push({
						id: feed.id,
						ingredient_id: response.id,
						dm: response.dm
					});
				});
				promiseList.push(p);
			});

			if (!promiseList.length) {
				ration.ingredients_checked = true;
				ration.recipe_list = [];
				rationPromise.resolve();
				return;
			}

			$q.all(promiseList)
				.then(function () {
					ration.ration_feeds.forEach(function (feed) {
						feed.original_dm = feed.dm;
						feed.manual_ration_feed_id = feed.id;

						var ingredient = feedIngredientList.find(function (ing) {
							return feed.id === ing.id;
						});

						if (ingredient.dm) {
							feed.ingredient = vm.recipe.ingredients.find(function (x) {
								return x.id === ingredient.ingredient_id;
							});

							feed.ingredient_id = ingredient.ingredient_id;
							feed.dm = ingredient.dm;
							feed.amount_as_fed = (feed.amount_dm * 100) / feed.dm;
							feed.cost_as_fed = (feed.cost_dm * feed.dm) / 100;
						}

						ration.ingredients_checked = true;
						ration.recipe_list = [];
						rationPromise.resolve();
					});
				})
				.catch(function () {
					rationPromise.reject();
				});

			function checkImportedIngredient(id) {
				return editRecipeService
					.checkImportedIngredient(id)
					.then(function (response) {
						return $q.resolve(response);
					})
					.catch(function (error) {
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_checking_ingredient_');
						return $q.reject(error);
					});
			}
		}

		function getRationById(ration) {
			return editRecipeService.getRationById(ration.id, '').then(function (response) {
				var promiseList = [];
				var feedIngredientList = [];

				response.ration_header.rations.forEach(function (feed) {
					var p = checkIngredient(feed.feed.id).then(function (response) {
						feedIngredientList.push({
							id: feed.feed.id,
							ingredient_id: response.id,
							dm: response.dm
						});
					});
					promiseList.push(p);
				});

				var rationFeeds = [];

				$q.all(promiseList)
					.then(function () {
						var total_dm = 0;
						response.ration_header.rations.forEach(function (feed) {
							feed.feed.original_dm = feed.feed.dm;

							var ingredient = feedIngredientList.find(function (ing) {
								return feed.feed.id === ing.id;
							});

							if (ingredient.dm) {
								feed.feed.ingredient = vm.recipe.ingredients.find(function (x) {
									return x.id === ingredient.ingredient_id;
								});

								feed.feed.ingredient_id = ingredient.ingredient_id;
								feed.feed.dm = ingredient.dm;
								feed.feed.as_fed = (feed.feed.amount * 100) / feed.feed.dm;
							}

							total_dm += feed.feed.amount;

							rationFeeds.push({
								amount_as_fed: feed.feed.as_fed,
								amount_dm: feed.feed.amount,
								cost_as_fed: (feed.feed.cost_dm * feed.feed.dm) / 100,
								cost_dm: feed.feed.cost_dm,
								dm: feed.feed.dm,
								original_dm: feed.feed.original_dm,
								feed_name: feed.feed.feed_name,
								feed_type: feed.feed.feed_type,
								id: feed.feed.id,
								ration_feed_id: feed.feed.id,
								ingredient: feed.feed.ingredient,
								ingredient_id: feed.feed.ingredient_id
							});
						});
						ration.cost_per_kg_dm = ration.cost_dm / total_dm;
						ration.ration_feeds = $filter('orderBy')(rationFeeds, 'id');
						ration.recipe_list = [];
						rationPromise.resolve();
					})
					.catch(function () {
						rationPromise.reject();
					});
			});

			function checkIngredient(id) {
				return editRecipeService
					.checkIngredient(id)
					.then(function (response) {
						return $q.resolve(response);
					})
					.catch(function (error) {
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_checking_ingredient_');
						return $q.reject(error);
					});
			}
		}

		function getIngredients() {
			var suffix = '?team=' + vm.selectedTeam.id + '&herd=' + vm.selectedHerd.id;
			return editRecipeService
				.getIngredients(suffix)
				.then(function (response) {
					if (vm.recipe.ingredients) {
						for (var i = 0; i < response.length; i++) {
							for (var j = 0; j < vm.recipe.ingredients.length; j++) {
								if (response[i].id === vm.recipe.ingredients[j].id && moment(response[i].last_modified_date).isSame(vm.recipe.ingredients[j].last_modified_date)) {
									response[i] = vm.recipe.ingredients[j];
									break;
								}
							}
						}
					}

					vm.recipe.ingredients = response;
					ingredientsPromise.resolve();
				})
				.catch(function (error) {
					console.log(error);
					ingredientsPromise.reject();
					errorService.showErrorMessage(error, true, '_error_occurred_loading_ingredient_', true);
				});
		}

		function selectRecipeRation() {
			vm.recipe.is_selected = true;
			vm.recipe.rations.forEach(function (ration) {
				ration.is_selected = false;
			});
			if (!vm.recipe.ration.visible) {
				vm.deletedRation = true;
			} else {
				vm.deletedRation = false;
			}

			vm.recipe.selectedRation = vm.recipe.ration;
			checkRationValidation();
			calculateRationAmount();
			if (vm.recipe.selected_pens && vm.recipe.selected_pens.length > 0) {
				calculateAmounts();
			}
		}

		function drag(index) {
			vm.recipe.selectedRation.ration_feeds.splice(index, 1);
		}

		function dragEnd(feed) {
			var index = vm.recipe.selectedRation.ration_feeds.findIndex(function (f) {
				return f.id === feed.id;
			});

			vm.recipe.selectedRation.ration_feeds[index].dirty = true;
		}

		function getPens(init) {
			var suffix = '?page=' + vm.recipe.currentPagePens;
			if (vm.selectedHerd && vm.selectedHerd.id) {
				vm.loadingPensTable = true;
				suffix = suffix + '&team=' + vm.selectedTeam.id + '&herd=' + vm.selectedHerd.id;
				return editRecipeService
					.getPensByTeamHerd(suffix)
					.then(function (response) {
						vm.recipe.totalItemsPens = response && response.length ? response[0].number_of_all : 0;
						for (var i = 0; i < response.length; i++) {
							response[i] = processPen(response[i]);
							response[i] = checkSelectedPens(response[i]);
							response[i].original_values = angular.copy(response[i]);
						}
						vm.recipe.pens = response;
						vm.recipe.current_pens = angular.copy(response);
						pensPromise.resolve();
						vm.loadingPensTable = false;
					})
					.catch(function (error) {
						pensPromise.reject(error);
						vm.loadingPensTable = false;
						errorService.showErrorMessage(error, true, '_error_occurred_loading_pen_', init);
					});
			}

			function checkSelectedPens(pen) {
				if (vm.recipe.pens && vm.recipe.pens.length) {
					for (var i = 0; i < vm.recipe.pens.length; i++) {
						if (vm.recipe.pens[i].id === pen.id && moment(vm.recipe.pens[i].last_modified_date).isSame(pen.last_modified_date)) {
							pen = vm.recipe.pens[i];
							break;
						}
					}
				}
				if (vm.recipe.selected_pens && vm.recipe.selected_pens.length) {
					var found = false;
					for (var j = vm.recipe.selected_pens.length - 1; j >= 0; j--) {
						if (vm.recipe.selected_pens[j].id === pen.id) {
							pen.is_selected = vm.recipe.selected_pens[j].is_selected;
							/*if (moment(vm.recipe.selected_pens[j].last_modified_date).isBefore(pen.last_modified_date)) {
								found = true;
								vm.recipe.selected_pens.splice(j, 1);
							} else {
								pen = vm.recipe.selected_pens[j];
							}
							break;*/
						}
					}
					if (found) {
						vm.recipe.selected_pens.push(pen);
					}
				}
				return pen;
			}
		}

		function processPen(pen, active_version) {
			pen.pen_feeding_scheduler_list = $filter('orderBy')(pen.pen_feeding_scheduler_list, 'start_feeding_date');
			for (var j = 0; j < pen.pen_feeding_scheduler_list.length; j++) {
				pen.pen_feeding_scheduler_list[j].end_feeding_date = getSchedulerEndDate(pen.pen_feeding_scheduler_list[j + 1] ? pen.pen_feeding_scheduler_list[j + 1].start_feeding_date : null);
			}
			pen = setActiveFeedingValues(pen, active_version);
			for (var k = 0; k < vm.category_names.length; k++) {
				if (pen.pen_category.id == vm.category_names[k].id) {
					pen.pen_category.name = vm.category_names[k].name;
				}
			}
			var num = 0;
			if (pen.feeding_1) {
				pen.feeding_1 = moment.utc(moment().format('YYYY-MM-DD') + 'T' + pen.feeding_1).format('YYYY-MM-DDTHH:mm:ss');
				num++;
			}
			if (pen.feeding_2) {
				pen.feeding_2 = moment.utc(moment().format('YYYY-MM-DD') + 'T' + pen.feeding_2).format('YYYY-MM-DDTHH:mm:ss');
				num++;
			}
			if (pen.feeding_3) {
				pen.feeding_3 = moment.utc(moment().format('YYYY-MM-DD') + 'T' + pen.feeding_3).format('YYYY-MM-DDTHH:mm:ss');
				num++;
			}
			pen.number_of_feedings = num;
			pen.total_amount_dm = pen.feed_intake * pen.number_of_animals;
			pen.total_amount_dm_per_day = pen.feed_intake * pen.number_of_animals;
			return pen;

			function getSchedulerEndDate(next_scheduler) {
				var end_date = moment().add(31, 'd').format('YYYY-MM-DD');
				if (next_scheduler) {
					end_date = moment(next_scheduler).subtract(1, 'd').format('YYYY-MM-DD');
				}
				return end_date;
			}

			function setActiveFeedingValues(pen, active_version) {
				var today;
				if (active_version && !active_version.is_active_version) {
					today = new Date(active_version.used_from);
				} else {
					today = new Date();
				}
				today.setHours(12, 0, 0);
				var activeSchedule;
				if (pen.pen_feeding_scheduler_list.length == 1) {
					activeSchedule = pen.pen_feeding_scheduler_list[0];
				} else {
					for (var i = 0; i < pen.pen_feeding_scheduler_list.length; i++) {
						var start_date = new Date(pen.pen_feeding_scheduler_list[i].start_feeding_date);
						start_date.setHours(12, 0, 0);
						var end_date = new Date(pen.pen_feeding_scheduler_list[i].end_feeding_date);
						end_date.setHours(12, 0, 0);
						if ((moment(start_date).isBefore(today) || moment(start_date).isSame(today, 'day')) && (moment(end_date).isAfter(today) || moment(end_date).isSame(today, 'day'))) {
							activeSchedule = pen.pen_feeding_scheduler_list[i];
							break;
						}
					}
				}

				if (activeSchedule && activeSchedule.morning_feeding) {
					pen.feeding_1 = activeSchedule.morning_feeding_time + ':00Z';
				}
				if (activeSchedule && activeSchedule.noon_feeding) {
					pen.feeding_2 = activeSchedule.noon_feeding_time + ':00Z';
				}
				if (activeSchedule && activeSchedule.evening_feeding) {
					pen.feeding_3 = activeSchedule.evening_feeding_time + ':00Z';
				}
				return pen;
			}
		}

		function getPenById(id) {
			var suffix = '?team=' + vm.selectedTeam.id + '&herd=' + vm.selectedHerd.id;
			return editRecipeService
				.getPenById(id, suffix)
				.then(function (response) {
					for (var i = 0; i < vm.frequencies.length; i++) {
						if (response.feeding_frequency == vm.frequencies[i].value) {
							response.feeding_frequency = vm.frequencies[i].name;
						}
					}
					for (var j = 0; j < response.pen_feeding_scheduler_list.length; j++) {
						if (response.pen_feeding_scheduler_list[j].feeding_frequency_rule) {
							response.pen_feeding_scheduler_list[j].feeding_frequency = getFrequency(response.pen_feeding_scheduler_list[j].feeding_frequency_rule);
						}
						var numb = 0;
						if (response.pen_feeding_scheduler_list[j].evening_feeding) {
							numb += 1;
						}
						if (response.pen_feeding_scheduler_list[j].morning_feeding) {
							numb += 1;
						}
						if (response.pen_feeding_scheduler_list[j].noon_feeding) {
							numb += 1;
						}
						response.pen_feeding_scheduler_list[j].number_of_feedings = numb;
						if (response.pen_feeding_scheduler_list[j].morning_feeding_time) {
							response.pen_feeding_scheduler_list[j].morning_feeding_time = moment(moment().format('YYYY-MM-DD') + 'T' + response.pen_feeding_scheduler_list[j].morning_feeding_time).toDate();
						}
						if (response.pen_feeding_scheduler_list[j].noon_feeding_time) {
							response.pen_feeding_scheduler_list[j].noon_feeding_time = moment(moment().format('YYYY-MM-DD') + 'T' + response.pen_feeding_scheduler_list[j].noon_feeding_time).toDate();
						}
						if (response.pen_feeding_scheduler_list[j].evening_feeding_time) {
							response.pen_feeding_scheduler_list[j].evening_feeding_time = moment(moment().format('YYYY-MM-DD') + 'T' + response.pen_feeding_scheduler_list[j].evening_feeding_time).toDate();
						}
					}
					for (var k = 0; k < vm.category_names.length; k++) {
						if (response.pen_category.id == vm.category_names[k].id) {
							response.pen_category.name = vm.category_names[k].name;
						}
					}
					response.pen_feeding_scheduler_list = currentlyActiveSchedule(response.pen_feeding_scheduler_list);
					var found = false;
					if (vm.recipe.selected_pens) {
						for (var l = 0; l < vm.recipe.selected_pens.length; l++) {
							if (vm.recipe.selected_pens[l].id === response.id) {
								response.ration_depending = !vm.recipe.selected_pens[l].use_pen_feed_intake ? vm.recipe.selected_pens[l].used_feed_intake : null;
								response.dmi_source = vm.recipe.selected_pens[l].use_pen_feed_intake ? $filter('i18n')('_m_f_fixed_') : $filter('i18n')('_m_f_ration_depending_');
								found = true;
								break;
							}
						}
					}
					if (!found) {
						for (var m = 0; m < vm.recipe.pens.length; m++) {
							if (vm.recipe.pens[m].id === response.id) {
								response.ration_depending = vm.recipe.pens[m].use_pen_feed_intake ? vm.recipe.pens[m].feed_intake : vm.recipe.ration_feed_intake;
								response.dmi_source = vm.recipe.pens[m].use_pen_feed_intake ? $filter('i18n')('_m_f_fixed_') : $filter('i18n')('_m_f_ration_depending_');
								break;
							}
						}
					}
					vm.details = response;
					vm.modalLoading = false;
					$timeout(function () {
						initialize();
					}, 100);
				})
				.catch(function (error) {
					console.log(error);
					vm.modalLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_pen_details_');
				});

			function getFrequency(feeding_frequency_rule) {
				var rule = parseString(feeding_frequency_rule);
				if (rule) {
					var byWeekDay = rule.options.byweekday;
					var interval = rule.options.interval;
					var string = '';
					if (byWeekDay && byWeekDay.length) {
						for (var i = 0; i < vm.days.length; i++) {
							for (var j = 0; j < byWeekDay.length; j++) {
								if (vm.days[i].value == byWeekDay[j]) {
									if (string != '') {
										string += ', ';
									}
									string += vm.days[i].name;
								}
							}
						}
					} else {
						if (interval) {
							if (interval == 1) {
								string = i18nFilter('_every_day_frequency_');
							} else if (interval == 2) {
								string = i18nFilter('_every_two_day_frequency_');
							} else if (interval == 3) {
								string = i18nFilter('_every_three_day_frequency_');
							} else {
								string = i18nFilter('_dc_other_');
							}
						}
					}
					return string;
				}
			}

			function currentlyActiveSchedule(schedule) {
				schedule = $filter('orderBy')(schedule, 'start_feeding_date', true);
				for (var i = 0; i < schedule.length; i++) {
					var current_date = moment().format('YYYY-MM-DD');
					if (current_date == schedule[i].start_feeding_date || moment(current_date).isAfter(schedule[i].start_feeding_date)) {
						schedule[i].schedule_set = true;
						break;
					}
				}
				return schedule;
			}
		}

		function pensPaginationChanged() {
			vm.recipe.pens = [];
			getPens();
		}

		function selectPen(pen) {
			vm.recipe.pen_changed = true;
			if (vm.recipe.selected_pens.length) {
				var found = false;
				for (var i = vm.recipe.selected_pens.length - 1; i >= 0; i--) {
					if (vm.recipe.selected_pens[i].id === pen.id) {
						found = true;
						vm.recipe.selected_pens.splice(i, 1);
						break;
					}
				}
				if (!found) {
					vm.recipe.selected_pens.push(pen);
				}
			} else {
				vm.recipe.selected_pens.push(pen);
			}
			checkPenValidation();
			calculateAmounts();
		}

		function checkPenValidation() {
			vm.recipe.penHelpInput = vm.recipe.selected_pens.length ? 'valid' : null;
		}

		function calculateAmounts(check) {
			checkPromises().then(function () {
				setUsedAmounts();
				setRecipeValues(check);
			});
		}

		function setUsedAmounts() {
			vm.recipe.pen_intake_warning = false;
			vm.recipe.ration_feed_intake = calculateRationFeedIntakeAmount();
			for (var i = 0; i < vm.recipe.selected_pens.length; i++) {
				if (vm.recipe.selected_pens[i].use_pen_feed_intake) {
					vm.recipe.selected_pens[i].used_feed_intake = angular.copy(vm.recipe.selected_pens[i].feed_intake);
					vm.recipe.selected_pens[i].total_amount_dm_per_day = vm.recipe.selected_pens[i].used_feed_intake * vm.recipe.selected_pens[i].number_of_animals;
				} else {
					vm.recipe.pen_intake_warning = vm.recipe.ration_feed_intake > vm.maxAmount ? true : false;
					vm.recipe.selected_pens[i].used_feed_intake = angular.copy(vm.recipe.ration_feed_intake);
					vm.recipe.selected_pens[i].total_amount_dm_per_day = vm.recipe.selected_pens[i].used_feed_intake * vm.recipe.selected_pens[i].number_of_animals;
				}
			}

			function calculateRationFeedIntakeAmount() {
				var amount_dm = 0;
				for (var i = 0; i < vm.recipe.selectedRation.ration_feeds.length; i++) {
					amount_dm += vm.recipe.selectedRation.ration_feeds[i].amount_dm;
				}

				return amount_dm;
			}
		}

		function setRecipeValues(check) {
			var total_number_of_animals = 0;
			var total_cost = 0;
			var total_amount_dm = 0;
			var total_as_fed = 0;
			var total_feeding_1 = 0;
			var total_feeding_2 = 0;
			var total_feeding_3 = 0;
			for (var i = 0; i < vm.recipe.selected_pens.length; i++) {
				vm.recipe.selected_pens[i].total_amount_dm = getWorstCaseScenarioAmount(vm.recipe.selected_pens[i]);
				vm.recipe.selected_pens[i].cost_dm = vm.recipe.selected_pens[i].total_amount_dm * vm.recipe.selectedRation.cost_per_kg_dm;
				vm.recipe.selected_pens[i].total_as_fed = Number.isFinite((vm.recipe.selected_pens[i].total_amount_dm * 100) / vm.recipe.selectedRation.dm) ? (vm.recipe.selected_pens[i].total_amount_dm * 100) / vm.recipe.selectedRation.dm : 0;
				var num = 0;
				if (vm.recipe.selected_pens[i].feeding_1) {
					num += 1;
				}
				if (vm.recipe.selected_pens[i].feeding_2) {
					num += 1;
				}
				if (vm.recipe.selected_pens[i].feeding_3) {
					num += 1;
				}
				var one_feeding = Math.floor(vm.recipe.selected_pens[i].total_as_fed / num);
				vm.recipe.selected_pens[i] = calculateFeedingAmounts(one_feeding, vm.recipe.selected_pens[i], num);
				total_number_of_animals += vm.recipe.selected_pens[i].number_of_animals;
				total_cost += vm.recipe.selected_pens[i].cost_dm;
				total_amount_dm += vm.recipe.selected_pens[i].total_amount_dm;
				total_as_fed += vm.recipe.selected_pens[i].total_as_fed;
				if (vm.recipe.selected_pens[i].feeding_1) {
					total_feeding_1 += vm.recipe.selected_pens[i].feeding_1_amount;
				}
				if (vm.recipe.selected_pens[i].feeding_2) {
					total_feeding_2 += vm.recipe.selected_pens[i].feeding_2_amount;
				}
				if (vm.recipe.selected_pens[i].feeding_3) {
					total_feeding_3 += vm.recipe.selected_pens[i].feeding_3_amount;
				}
			}
			vm.recipe.total_number_of_animals = total_number_of_animals;
			vm.recipe.total_cost = total_cost;
			vm.recipe.total_amount_dm = total_amount_dm;
			vm.recipe.total_as_fed = total_as_fed;
			vm.recipe.total_feeding_1 = total_feeding_1;
			vm.recipe.total_feeding_2 = total_feeding_2;
			vm.recipe.total_feeding_3 = total_feeding_3;
			if (!check) {
				calculateSuggestion(true);
			}
			$timeout(function () {
				if (!check) {
					loadingPromise.resolve();
				} else {
					setRecipePromise.resolve();
				}
			}, 50);

			function getWorstCaseScenarioAmount(pen) {
				var all_dates = [];
				var scheduler_list = pen.pen_feeding_scheduler_list;
				scheduler_list = $filter('orderBy')(scheduler_list, 'start_feeding_date');
				all_dates = getSchedulerDays(scheduler_list);
				var maxRange = getMaxRange(all_dates);
				return pen.total_amount_dm_per_day * maxRange;

				function getMaxRange(days) {
					var max = 1;
					for (var i = 0; i < days.length; i++) {
						if (days[i + 1]) {
							var diff = moment(days[i + 1]).diff(days[i], 'days');
							if (diff > max) {
								max = diff;
							}
						}
					}
					return max;
				}
			}
		}

		function getSchedulerDays(scheduler_list) {
			var all_dates = [];
			var today = new Date();
			today.setHours(12, 0, 0);
			for (var i = 0; i < scheduler_list.length; i++) {
				var rrule_start_date = moment(scheduler_list[i].start_feeding_date).format('YYYYMMDDT000000') + 'Z';
				var rrule_end_date = moment(scheduler_list[i].end_feeding_date).format('YYYYMMDDT000000') + 'Z';
				var rrule_string = 'DTSTART:' + rrule_start_date + '\nRRULE:' + (scheduler_list[i].feeding_frequency_rule ? scheduler_list[i].feeding_frequency_rule : 'FREQ=DAILY;INTERVAL=1') + ';UNTIL=' + rrule_end_date;
				var dates = RRule.fromString(rrule_string).all();
				all_dates = all_dates.concat(dates);
			}
			for (var j = 0; j < all_dates.length; j++) {
				all_dates[j].setHours(12, 0, 0);
			}
			all_dates = all_dates.filter(function (date) {
				return moment(date).isAfter(today) || moment(date).isSame(today, 'day');
			});
			return all_dates;
		}

		function calculateFeedingAmounts(one_feeding_amount, obj, num) {
			if (num == 3) {
				obj.feeding_1_amount = one_feeding_amount;
				obj.feeding_2_amount = one_feeding_amount;
				obj.feeding_3_amount = obj.total_as_fed - 2 * one_feeding_amount;
			} else if (num == 2) {
				if (!obj.feeding_1) {
					obj.feeding_2_amount = one_feeding_amount;
					obj.feeding_3_amount = obj.total_as_fed - one_feeding_amount;
				} else if (!obj.feeding_2) {
					obj.feeding_1_amount = one_feeding_amount;
					obj.feeding_3_amount = obj.total_as_fed - one_feeding_amount;
				} else {
					obj.feeding_1_amount = one_feeding_amount;
					obj.feeding_2_amount = obj.total_as_fed - one_feeding_amount;
				}
			} else if (num == 0) {
				obj.feeding_1_amount = 0;
				obj.feeding_2_amount = 0;
				obj.feeding_3_amount = 0;
			} else {
				if (obj.feeding_1) {
					obj.feeding_1_amount = obj.total_as_fed;
				} else if (obj.feeding_2) {
					obj.feeding_2_amount = obj.total_as_fed;
				} else {
					obj.feeding_3_amount = obj.total_as_fed;
				}
			}
			return obj;
		}

		function calculateSuggestion() {
			vm.recipe.feeding_changed = true;
			var selectedWagons = vm.recipe.wagons.filter(function (wagon) {
				return wagon.selected === true && wagon.default === true;
			});

			if (selectedWagons.length) {
				vm.recipe.suggestion.feeding_1 = setFeedingSuggestion(vm.recipe.total_feeding_1, selectedWagons[0]);
				vm.recipe.suggestion.feeding_2 = setFeedingSuggestion(vm.recipe.total_feeding_2, selectedWagons[0]);
				vm.recipe.suggestion.feeding_3 = setFeedingSuggestion(vm.recipe.total_feeding_3, selectedWagons[0]);
			} else {
				if (!vm.recipe.tmr) {
					vm.recipe.suggestion = {
						feeding_1: {
							number_of_loads: 1,
							loads: [
								{
									wagon: {
										name: ''
									},
									value: vm.recipe.total_feeding_1
								}
							]
						},
						feeding_2: {
							number_of_loads: 1,
							loads: [
								{
									wagon: {
										name: ''
									},
									value: vm.recipe.total_feeding_2
								}
							]
						},
						feeding_3: {
							number_of_loads: 1,
							loads: [
								{
									wagon: {
										name: ''
									},
									value: vm.recipe.total_feeding_3
								}
							]
						}
					};
				}
			}

			checkSuggestionValidation();
		}

		function setFeedingSuggestion(amount, wagon) {
			amount = unitConversionService.convertData(amount, ['round:3']);
			var loads = [];
			var count = 0;

			while (amount > wagon.value && count < 9) {
				loads.push({
					value: wagon.value,
					wagon: wagon
				});
				amount = amount - wagon.value;
				count++;
			}

			loads = $filter('orderBy')(loads, 'value', true);

			if (amount > 0) {
				var load = {
					value: amount,
					wagon: wagon
				};
				loads.push(load);
			}

			return {
				number_of_loads: loads.length,
				loads: loads
			};
		}

		function generateSchedulerData(recipe_preview, start_date, number_of_days) {
			var today = moment();
			if (today.isSameOrAfter(start_date)) {
				start_date = today;
			}
			return generatePreviewData(recipe_preview, start_date, number_of_days);
		}

		function generatePreviewData(recipe_preview_data, start_date, number_of_days) {
			var end_date = moment(start_date).add(number_of_days - 1, 'd');
			var days = recipe_preview_data.filter(function (day) {
				return moment(day.date).isSameOrAfter(start_date, 'day') && moment(day.date).isBefore(end_date);
			});
			days = days.map(function (day) {
				day.feeding_1_sum = day.summary.morning;
				day.feeding_1_loads = day.loads.morning;
				day.feeding_2_sum = day.summary.noon;
				day.feeding_2_loads = day.loads.noon;
				day.feeding_3_sum = day.summary.evening;
				day.feeding_3_loads = day.loads.evening;
				return day;
			});
			return days;
		}

		function changeActive(pen) {
			for (var i = 0; i < vm.recipe.pens.length; i++) {
				if (vm.recipe.pens[i].id === pen.id) {
					var index = i;
					break;
				}
			}
			vm.recipe.pens[index].pen_active = !vm.recipe.pens[index].pen_active;
			pen.last_modified_user = vm.user.email;
			var penDto = angular.copy(pen);
			penDto.feeding_1 = penDto.feeding_1 ? moment(penDto.feeding_1).format('HH:mm:ss[Z]') : null;
			penDto.feeding_2 = penDto.feeding_2 ? moment(penDto.feeding_2).format('HH:mm:ss[Z]') : null;
			penDto.feeding_3 = penDto.feeding_3 ? moment(penDto.feeding_3).format('HH:mm:ss[Z]') : null;
			editRecipeService.updatePen(penDto).catch(function (error) {
				console.log(error);
				vm.recipe.pens[index].pen_active = !vm.recipe.pens[index].pen_active;
				errorService.showErrorMessage(error, true, '_error_occurred_changing_active_pen_');
			});
		}

		function updateUsePenIntake(pen) {
			var penIndex = 0;
			for (var i = 0; i < vm.recipe.selected_pens.length; i++) {
				if (vm.recipe.selected_pens[i].id === pen.id) {
					vm.recipe.selected_pens[i].use_pen_feed_intake = pen.use_pen_feed_intake;
					calculateAmounts();
					break;
				}
			}
			for (var j = 0; j < vm.recipe.pens.length; j++) {
				if (vm.recipe.pens[j].id === pen.id) {
					penIndex = j;
					break;
				}
			}
			if (vm.recipe.changed_pens.length === 0) {
				vm.recipe.changed_pens.push(vm.recipe.pens[penIndex]);
			} else {
				var index = null;
				for (var k = 0; k < vm.recipe.changed_pens.length; k++) {
					if (vm.recipe.changed_pens[k].id === vm.recipe.pens[penIndex].id) {
						index = k;
						break;
					}
				}
				if (index != null) {
					vm.recipe.changed_pens.splice(index, 1);
				} else {
					vm.recipe.changed_pens.push(vm.recipe.pens[penIndex]);
				}
			}
		}

		/*function getFeedingMethods() {
			vm.loadingFeedingMethods = true;
			return editRecipeService
				.getFeedingMethods()
				.then(function (response) {
					/*var r = [
						{
							id: 1,
							name: 'TMR',
							value: 1
						},
						{
							id: 2,
							name: 'NON-TMR',
							value: 2
						},
						{
							id: 3,
							name: 'With feeding station',
							value: 4
						}
					];
					setFeedingMethodNames(response);
					vm.recipe.feeding_methods = response;
					checkFeedingMethodValidation();
					vm.loadingFeedingMethods = false;
					feedingMethodsPromise.resolve();
				})
				.catch(function (error) {
					console.log(error);
					vm.loadingFeedingMethods = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_feeding_methods_', true);
					feedingMethodsPromise.reject();
				});

			function setFeedingMethodNames(method) {
				for (var i = 0; i < method.length; i++) {
					for (var m = 0; m < vm.feeding_method_names.length; m++) {
						if (method[i].id == vm.feeding_method_names[m].id) {
							method[i].name = vm.feeding_method_names[m].name;
						}
					}
				}
				return method;
			}
		}

		function feedingMethodSelected(fm) {
			for (var i = 0; i < vm.recipe.feeding_methods.length; i++) {
				if (vm.recipe.feeding_methods[i].id === fm.id) {
					vm.recipe.feeding_methods[i].selected = true;
				} else {
					vm.recipe.feeding_methods[i].selected = false;
				}
			}
			if (fm.selected && fm.value == 1) {
				vm.recipe.tmr = true;
			} else {
				vm.recipe.tmr = false;
			}
			checkFeedingMethodValidation();
		}

		function checkFeedingMethodValidation() {
			vm.recipe.feedingMethodHelpInput = vm.recipe.tmr ? 'valid' : null;
		}*/

		function getMixerWagons() {
			vm.loadingMixerWagons = true;
			var suffix = '?team=' + vm.selectedTeam.id + '&herd=' + vm.selectedHerd.id;
			return editRecipeService
				.getMixerWagons(suffix)
				.then(function (response) {
					if (vm.lastRecipeConfig && vm.lastRecipeConfig.wagons) {
						vm.recipe.wagons = vm.lastRecipeConfig.wagons;
					}
					for (var i = 0; i < response.length; i++) {
						response[i].default = false;
						response[i].selected = false;
						response[i].value = response[i].weight * 1000;
						if (vm.recipe.wagons) {
							for (var j = 0; j < vm.recipe.wagons.length; j++) {
								if (response[i].id === vm.recipe.wagons[j].id) {
									response[i].weight = vm.recipe.wagons[j].weight;
									response[i].volume = vm.recipe.wagons[j].volume;
									if (vm.recipe.wagons[j].selected) {
										response[i].selected = true;
									}
									if (vm.recipe.wagons[j].default) {
										response[i].default = true;
									}
								}
							}
						}
					}
					vm.recipe.wagons = response;
					checkWagonValidation();
					vm.recipe.wagons = $filter('orderBy')(vm.recipe.wagons, ['-weight', 'name']);
					wagonsPromise.resolve();
					vm.loadingMixerWagons = false;
				})
				.catch(function (error) {
					console.log(error);
					wagonsPromise.reject(error);
					vm.loadingMixerWagons = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_wagons_', true);
				});
		}

		function wagonSelected(wagon) {
			vm.recipe.mixing_wagons_changed = true;
			if (!wagon.selected) {
				wagon.default = false;
			}
			var selectedWagons = [];
			var selIndex;
			for (var i = 0; i < vm.recipe.wagons.length; i++) {
				if (vm.recipe.wagons[i].selected === true) {
					selectedWagons.push(vm.recipe.wagons[i]);
					selIndex = i;
				}
			}
			if (selectedWagons.length === 1) {
				vm.recipe.wagons[selIndex].default = true;
			}
			checkWagonValidation();
			calculateAmounts();
		}

		function defaultSelected(wagon) {
			for (var i = 0; i < vm.recipe.wagons.length; i++) {
				if (vm.recipe.wagons[i].id !== wagon.id) {
					vm.recipe.wagons[i].default = false;
				} else {
					vm.recipe.wagons[i].default = true;
				}
			}
			checkWagonValidation();
			calculateAmounts();
		}

		function checkWagonValidation() {
			for (var i = 0; i < vm.recipe.wagons.length; i++) {
				if (vm.recipe.wagons[i].deleted && vm.recipe.wagons[i].selected) {
					vm.recipe.wagonHelpInput = null;
					return;
				}
			}

			var sel = false;
			var def = false;

			for (var j = 0; j < vm.recipe.wagons.length; j++) {
				if (vm.recipe.wagons[j].selected === true) {
					sel = true;
				}

				if (vm.recipe.wagons[j].default === true) {
					def = true;
				}

				if (sel && def) {
					break;
				}
			}

			vm.recipe.wagonHelpInput = sel && def ? 'valid' : null;
		}

		function insertWagon(event) {
			if (event) {
				event.preventDefault();
			}
			vm.newWagon = {};
			openModal('app/pages/recipes/editRecipe/insertWagon.modal.html', 'md');
		}

		function addWagon() {
			var newWagonDTO = angular.copy(vm.newWagon);
			vm.modalLoading = true;
			if (!newWagonDTO.volume) {
				newWagonDTO.volume = 0;
			}
			if (!vm.settings.use_kgs) {
				newWagonDTO.weight = unitConversionService.convertData(newWagonDTO.weight, ['imperialTonToMetricTon']);
			}
			var url_suffix = '?team_id=' + vm.settings.selectedTeam.id + '&herd_id=' + vm.settings.selectedHerd.id + '&last_modified_user=' + vm.user.email + '&name=' + newWagonDTO.name + '&volume=' + newWagonDTO.volume + '&weight=' + newWagonDTO.weight;
			if (newWagonDTO.serial_number) {
				url_suffix = url_suffix + '&serial_number=' + encodeURIComponent(newWagonDTO.serial_number);
			}
			return editRecipeService
				.addNewWagon(url_suffix)
				.then(function (response) {
					response.value = response.weight * 1000;
					vm.recipe.wagons.push(response);
					cancel();
					vm.modalLoading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.modalLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_adding_wagon_');
				});
		}

		function loadWagonChanged(feeding, index, wagon) {
			var sValue = 0;
			//required sum
			var rSum = vm.recipe['total_' + feeding];
			//original value
			var oValue = vm.recipe.suggestion[feeding].loads[index].value;
			var sum = 0;
			if (vm.recipe.feedingsError[feeding]) {
				if (vm.recipe.feedingsError[feeding] > 0) {
					sValue = oValue - Math.abs(vm.recipe.feedingsError[feeding]);
				} else {
					sValue = oValue + Math.abs(vm.recipe.feedingsError[feeding]);
				}
				if (sValue <= wagon.value) {
					vm.recipe.suggestion[feeding].loads[index].value = sValue;
				} else {
					vm.recipe.suggestion[feeding].loads[index].value = wagon.value;
				}
			} else {
				if (oValue <= wagon.value) {
					vm.recipe.suggestion[feeding].loads[index].value = oValue;
				} else {
					vm.recipe.suggestion[feeding].loads[index].value = wagon.value;
				}
			}
			vm.recipe.suggestion[feeding].loads[index].wagon = wagon;
			vm.recipe.mixing_wagons_changed = true;
			for (var j = 0; j < vm.recipe.wagons.length; j++) {
				if (vm.recipe.wagons[j].id === wagon.id) {
					vm.recipe.wagons[j].selected = true;
					break;
				}
			}
			for (var i = 0; i < vm.recipe.suggestion[feeding].loads.length; i++) {
				sum += vm.recipe.suggestion[feeding].loads[i].value;
			}
			var diff = sum - rSum;
			if (Math.abs(diff) > 2) {
				vm.recipe.feedingsError[feeding] = diff;
			} else {
				vm.recipe.feedingsError[feeding] = 0;
			}
			vm.recipe.feeding_changed = true;
			checkSuggestionValidation();
		}

		function checkSuggestionValidation() {
			var feedingsPresent = false;
			vm.recipe.feedingsError = {};

			if (vm.recipe.suggestion.feeding_1 && vm.recipe.suggestion.feeding_1.loads) {
				feedingsPresent = true;
				calculateDifference('feeding_1');
			}

			if (vm.recipe.suggestion.feeding_2 && vm.recipe.suggestion.feeding_2.loads) {
				feedingsPresent = true;
				calculateDifference('feeding_2');
			}

			if (vm.recipe.suggestion.feeding_3 && vm.recipe.suggestion.feeding_3.loads) {
				feedingsPresent = true;
				calculateDifference('feeding_3');
			}

			if (feedingsPresent) {
				if (vm.recipe.feedingsError.feeding_1 || vm.recipe.feedingsError.feeding_2 || vm.recipe.feedingsError.feeding_3) {
					vm.recipe.suggestionHelpInput = null;
				} else {
					vm.recipe.mixing_feedings = updateMixingFeedings();

					vm.recipe.suggestionHelpInput = 'valid';
				}
			} else {
				vm.recipe.suggestionHelpInput = null;
			}

			function calculateDifference(feeding) {
				var sum = 0;
				var loads = angular.copy(vm.recipe.suggestion[feeding].loads);
				for (var i = 0; i < loads.length; i++) {
					sum += loads[i].value;
				}
				var diff = sum - vm.recipe['total_' + feeding];

				if (Math.abs(diff) > 10) {
					vm.recipe.feedingsError[feeding] = diff;
				} else {
					vm.recipe.feedingsError[feeding] = 0;
				}
			}
		}

		function openEditLoadsModal(feeding) {
			var loads;
			if (vm.recipe.suggestion[feeding] && vm.recipe.suggestion[feeding].loads.length) {
				loads = angular.copy(vm.recipe.suggestion[feeding].loads);
			} else {
				loads = [];
			}
			vm.addedWagons = [];
			vm.editLoadsData = {
				sum: vm.recipe['total_' + feeding],
				loads: loads,
				difference: vm.recipe.feedingsError[feeding],
				feeding: feeding,
				wagon: vm.recipe.wagons[0]
			};
			openModal('app/pages/recipes/editRecipe/editLoads.modal.html', 'md');
		}

		function showSetButton(load) {
			return load.wagon.value > load.value ? true : false;
		}

		function addLoad() {
			var loadObj = {
				value: Math.abs(vm.editLoadsData.difference),
				wagon: vm.editLoadsData.wagon
			};
			if (loadObj.value > loadObj.wagon.value) {
				loadObj.value = loadObj.wagon.value;
			}
			vm.editLoadsData.loads.push(loadObj);
			calculateLoadDiff();
			var wagonFound = false;
			if (vm.addedWagons.length > 0) {
				for (var i = 0; i < vm.addedWagons.length; i++) {
					if (vm.addedWagons[i].id === vm.editLoadsData.wagon.id) {
						wagonFound = true;
						break;
					}
				}
			}
			if (!wagonFound) {
				vm.addedWagons.push(vm.editLoadsData.wagon);
			}
		}

		function updateLoad(load, data, index, wagon) {
			var loadObj = {
				value: wagon && data > wagon.value ? wagon.value : data,
				wagon: wagon ? wagon : load.wagon
			};
			vm.editLoadsData.loads[index] = angular.copy(loadObj);
			calculateLoadDiff();
			if (wagon) {
				var wagonFound = false;
				if (vm.addedWagons.length > 0) {
					for (var i = 0; i < vm.addedWagons.length; i++) {
						if (vm.addedWagons[i].id === wagon.id) {
							wagonFound = true;
							break;
						}
					}
				}
				if (!wagonFound) {
					vm.addedWagons.push(wagon);
				}
			}
		}

		function setLoad(load, index) {
			if (vm.editLoadsData.difference > 0) {
				load.value -= Math.abs(vm.editLoadsData.difference);
			} else {
				load.value += Math.abs(vm.editLoadsData.difference);
			}
			if (load.value > load.wagon.value) {
				load.value = load.wagon.value;
			}
			if (load.value <= 0) {
				vm.editLoadsData.loads.splice(index, 1);
			}
			calculateLoadDiff();
		}

		function saveLoads() {
			if (vm.addedWagons.length > 0) {
				for (var i = 0; i < vm.addedWagons.length; i++) {
					for (var j = 0; j < vm.recipe.wagons.length; j++) {
						if (vm.addedWagons[i].id === vm.recipe.wagons[j].id) {
							vm.recipe.mixing_wagons_changed = true;
							vm.recipe.wagons[j].selected = true;
							break;
						}
					}
				}
			}
			vm.recipe.feeding_changed = true;
			vm.recipe.suggestion[vm.editLoadsData.feeding].loads = vm.editLoadsData.loads;
			vm.recipe.feedingsError[vm.editLoadsData.feeding] = vm.editLoadsData.difference;
			checkSuggestionValidation();
			cancel();
		}

		function removeLoad(index) {
			vm.editLoadsData.loads.splice(index, 1);
			calculateLoadDiff();
		}

		function calculateLoadDiff() {
			var sum = 0;
			for (var i = 0; i < vm.editLoadsData.loads.length; i++) {
				sum += vm.editLoadsData.loads[i].value;
			}
			var diff = sum - vm.editLoadsData.sum;
			if (Math.abs(diff) > 2) {
				vm.editLoadsData.difference = diff;
			} else {
				vm.editLoadsData.difference = 0;
			}
		}

		function amountChanged(pen, data, prop) {
			var d = $q.defer();
			var one_pen = vm.recipe.selected_pens[vm.recipe.selected_pens.indexOf(pen)];
			var amount = one_pen.total_as_fed - data;
			pen.dirty = true;
			if (amount < 2 || data < 1) {
				d.reject();
			} else {
				var one_feeding = Math.floor(amount / 2);
				if (prop == 'feeding_1') {
					if (one_pen.feeding_2 && one_pen.feeding_3) {
						one_pen.feeding_2_amount = one_feeding;
						one_pen.feeding_3_amount = amount - one_feeding;
					} else if (one_pen.feeding_2) {
						one_pen.feeding_2_amount = amount;
					} else if (one_pen.feeding_3) {
						one_pen.feeding_3_amount = amount;
					} else {
						d.reject();
						return d.promise;
					}
				} else if (prop == 'feeding_2') {
					if (one_pen.feeding_1 && one_pen.feeding_3) {
						one_pen.feeding_1_amount = one_feeding;
						one_pen.feeding_3_amount = amount - one_feeding;
					} else if (one_pen.feeding_1) {
						one_pen.feeding_1_amount = amount;
					} else if (one_pen.feeding_3) {
						one_pen.feeding_3_amount = amount;
					} else {
						d.reject();
						return d.promise;
					}
				} else {
					if (one_pen.feeding_1 && one_pen.feeding_2) {
						one_pen.feeding_1_amount = one_feeding;
						one_pen.feeding_2_amount = amount - one_feeding;
					} else if (one_pen.feeding_1) {
						one_pen.feeding_1_amount = amount;
					} else if (one_pen.feeding_3) {
						one_pen.feeding_2_amount = amount;
					} else {
						d.reject();
						return d.promise;
					}
				}
				$timeout(function () {
					calculateAmounts();
					d.resolve();
				}, 10);
			}
			return d.promise;
		}

		function openTimePicker(prop) {
			if (prop == 'feeding_1') {
				vm.datepickerDisplay = {
					feeding_1: true,
					feeding_2: false,
					feeding_3: false
				};
			} else if (prop == 'feeding_2') {
				vm.datepickerDisplay = {
					feeding_1: false,
					feeding_2: true,
					feeding_3: false
				};
			} else {
				vm.datepickerDisplay = {
					feeding_1: false,
					feeding_2: false,
					feeding_3: true
				};
			}
		}

		function checkValidation(pen, prop) {
			vm.recipe.selected_pens[vm.selectedPenIndex].dirty = true;
			var hour = moment(pen[prop]).format('HH');
			if (prop == 'feeding_1') {
				if (hour < 4 || hour > 11 || hour === 'Invalid date') {
					pen.feeding_1_valid = true;
					vm.timepickerDisable = true;
				} else {
					pen.feeding_1_valid = false;
					vm.timepickerDisable = false;
				}
			} else if (prop == 'feeding_2') {
				if (hour < 12 || hour > 18 || hour === 'Invalid date') {
					pen.feeding_2_valid = true;
					vm.timepickerDisable = true;
				} else {
					pen.feeding_2_valid = false;
					vm.timepickerDisable = false;
				}
			} else {
				if ((hour >= 19 && hour <= 23) || (hour >= 0 && hour <= 3) || hour === 'Invalid date') {
					pen.feeding_3_valid = false;
					vm.timepickerDisable = false;
				} else {
					pen.feeding_3_valid = true;
					vm.timepickerDisable = true;
				}
			}
		}

		function saveRecipe(feedNow) {
			if (!vm.recipe.selectedRation) {
				toastr.warning('Please select the ration', i18nFilter('_title_warning_'));
				return;
			}
			vm.loading = true;

			if (vm.saveTimeout) {
				$timeout.cancel(vm.saveTimeout);
			}

			vm.saveTimeout = $timeout(function () {
				var recipeDTO = new RecipeDTO2(vm.recipe);
				return editRecipeService
					.updateRecipe(recipeDTO)
					.then(function () {
						$state.go('recipes.myRecipes');
					})
					.catch(function (error) {
						console.log(error);
						vm.loading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_saving_recipe_');
					});
			}, 300);

			function RecipeDTO2(recipe) {
				this.id = recipe.id;
				this.team_id = vm.selectedTeam.id;
				this.herd_id = vm.selectedHerd.id;
				this.name = recipe.recipe_name;
				//this.feeding_methods = setFeedingMethodsDTO(recipe);
				this.feeding_methods = 1;
				this.comment = recipe.recipe_comment;
				this.dropping_comment = recipe.dropping_comment;
				this.feeding_from = feedNow ? moment(vm.startTime).utc().format('YYYY-MM-DDTHH:mm:ss[Z]') : null;
				this.mixer_wagons = setMixingWagonsDTO2(recipe);
				this.pens = setPensDTO2(recipe);
				this.ration = recipe.selected_ration_type.value === 0 ? setRationRecipeDTO(recipe, false) : null;
				this.manual_ration = recipe.selected_ration_type.value === 1 ? setRationRecipeDTO(recipe, true) : null;
				this.load_managements = setLoadManagementDTO(recipe);
			}

			/*function setFeedingMethodsDTO(recipe) {
				for (var i = 0; i < recipe.feeding_methods.length; i++) {
					if (recipe.feeding_methods[i].selected) {
						return recipe.feeding_methods[i].value;
					}
				}
			}*/

			function setPensDTO2(recipe) {
				var list = [];
				var pens = angular.copy(recipe.selected_pens);
				for (var i = 0; i < pens.length; i++) {
					var pen = {
						id: pens[i].id,
						use_pen_intake: pens[i].use_pen_feed_intake
					};
					list.push(pen);
				}
				return list;
			}

			function setRationRecipeDTO(recipe, manual) {
				var ration = {
					id: recipe.selectedRation.id,
					ration_feeds: []
				};

				if (recipe.selectedRation && recipe.selectedRation.ration_feeds) {
					for (var i = 0; i < recipe.selectedRation.ration_feeds.length; i++) {
						var feed = {
							id: manual ? recipe.selectedRation.ration_feeds[i].manual_ration_feed_id : recipe.selectedRation.ration_feeds[i].ration_feed_id,
							ingredient: recipe.selectedRation.ration_feeds[i].ingredient ? setIngredientDTO(recipe.selectedRation.ration_feeds[i]) : null,
							position: i,
							cost_dm: recipe.selectedRation.ration_feeds[i].cost_dm,
							dm: recipe.selectedRation.ration_feeds[i].dm,
							amount_dm: recipe.selectedRation.ration_feeds[i].amount_dm
						};

						ration.ration_feeds.push(feed);
						/*if (recipe.selectedRation.ration_feeds[i].dirty) {
							feed.cost_dm = recipe.selectedRation.ration_feeds[i].cost_dm;
							feed.dm = recipe.selectedRation.ration_feeds[i].dm;
							feed.amount_dm = recipe.selectedRation.ration_feeds[i].amount_dm;
						}*/
					}
				}

				function setIngredientDTO(feed) {
					var _ingredient = {};
					if (feed.ingredient) {
						_ingredient = {
							id: feed.ingredient.id,
							dm: feed.ingredient.dm
						};

						return _ingredient;
					} else {
						if (feed.ingredient_id) {
							_ingredient = {
								id: null
							};

							return _ingredient;
						} else {
							return null;
						}
					}
				}

				return ration;
			}
		}

		function setLoadManagementDTO(recipe) {
			var list = [];
			angular.forEach(recipe.suggestion, function (value, key) {
				var feeding = {
					load_subject_order_number: key == 'feeding_1' ? 1 : key == 'feeding_2' ? 2 : 3,
					load_details: [],
					amount: 0
				};

				for (var i = 0; i < value.loads.length; i++) {
					feeding.amount += value.loads[i].value;
					var load = {
						amount: value.loads[i].value,
						mixer_wagon_id: value.loads[i].wagon.id,
						position: i,
						mixing_time: value.loads[i].mixing_time ? value.loads[i].mixing_time : null
					};
					feeding.load_details.push(load);
				}

				list.push(feeding);
			});

			return list;
		}

		function setMixingWagonsDTO2(recipe) {
			var list = [];
			var selectedWagons = [];
			var wagons = angular.copy(recipe.wagons);
			for (var i = 0; i < wagons.length; i++) {
				if (wagons[i].selected) {
					selectedWagons.push(wagons[i]);
				}
			}
			var wLength = selectedWagons.length - 1;
			for (var j = 0; j < selectedWagons.length; j++) {
				list.push({
					id: selectedWagons[j].id ? selectedWagons[j].id : null,
					position: selectedWagons[j].default ? 0 : wLength,
					name: selectedWagons[j].name,
					weight: selectedWagons[j].weight
				});
				if (!selectedWagons[j].default) {
					wLength--;
				}
			}
			return list;
		}

		function goToPage(page, obj) {
			localStorage.setItem(
				'from_recipe',
				JSON.stringify({
					type: 'edit',
					uuid: $stateParams.uuid
				})
			);
			$timeout(function () {
				$state.go(page, {
					uuid: obj && obj.id ? obj.id : null
				});
			}, 50);
		}

		function initialize() {
			try {
				var addMarkerToMap;
				var zoom;
				if (vm.details.pen_lat && vm.details.pen_lng) {
					addMarkerToMap = true;
					zoom = 16;
				} else {
					vm.details.pen_lat = 43.8900745;
					vm.details.pen_lng = 20.3492278;
					addMarkerToMap = false;
					zoom = 3;
					vm.latLngMissing = true;
				}
				var id = 'google-maps';
				var mapCanvas = document.getElementById(id);
				var mapOptions = {
					center: new google.maps.LatLng(vm.details.pen_lat, vm.details.pen_lng),
					zoom: zoom,
					mapTypeId: google.maps.MapTypeId.SATELLITE
				};
				var map = new google.maps.Map(mapCanvas, mapOptions);
				if (!map || !map.renderingType) {
					vm.showGMap = false;
					return;
				}
				var latLng = {
					lat: Number(vm.details.pen_lat),
					lng: Number(vm.details.pen_lng)
				};
				if (typeof latLng.lat === 'number' && typeof latLng.lng === 'number' && !isNaN(latLng.lat) && !isNaN(latLng.lng) && addMarkerToMap) {
					map.panTo(latLng);
				}
				if (vm.details.pen_location) {
					var pen = new google.maps.Polygon({
						paths: JSON.parse(vm.details.pen_location),
						strokeColor: '#FF0000',
						strokeOpacity: 0.8,
						strokeWeight: 2,
						fillColor: '#FF0000',
						fillOpacity: 0.35
					});
					pen.setMap(map);
				}
			} catch (error) {
				console.log(error);
			}
		}

		function openFeedingDatepicker() {
			openModal('app/pages/recipes/feedingDatepicker.modal.html', 'sm');
		}

		function saveMixingTime() {
			var minutes = vm.mixingTime && vm.mixingTime.minutes ? parseInt(vm.mixingTime.minutes, 10) : 0;
			var mixingTimeSeconds = minutes * 60 || null;

			if (vm.mixingTimeData && vm.mixingTimeData.set_to_all) {
				Object.keys(vm.recipe.suggestion || {}).forEach(function (feedingKey) {
					var feeding = vm.recipe.suggestion[feedingKey];
					if (feeding && Array.isArray(feeding.loads)) {
						feeding.loads.forEach(function (load) {
							load.mixing_time = mixingTimeSeconds;
						});
					}
				});
			} else if (vm.mixingTimeData && vm.mixingTimeData.feeding_number != null && vm.mixingTimeData.load_index != null) {
				vm.recipe.suggestion[vm.mixingTimeData.feeding_number].loads[vm.mixingTimeData.load_index].mixing_time = mixingTimeSeconds;
			}

			cancel();
		}

		function getMinutes() {
			return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59];
		}

		function openMixingTimeSelector(feeding_number, index) {
			if (vm.historicalVersion) {
				return;
			}

			vm.mixingTimeData = {
				feeding_number: feeding_number,
				load_index: index,
				set_to_all: false
			};

			var mixingTime = vm.recipe.suggestion[feeding_number].loads[index].mixing_time
				? {
					hours: Math.floor(vm.recipe.suggestion[feeding_number].loads[index].mixing_time / 3600) || null,
					minutes: Math.floor((vm.recipe.suggestion[feeding_number].loads[index].mixing_time % 3600) / 60) || null,
					seconds: vm.recipe.suggestion[feeding_number].loads[index].mixing_time % 60 || null
				}
				: {
					hours: null,
					minutes: null,
					seconds: null
				};

			vm.mixingTime = angular.copy(mixingTime);
			openModal('app/pages/recipes/mixingTimeSelector.modal.html', 'sm');
		}

		function openPenDetailsModal(pen) {
			vm.modalLoading = true;
			openModal('app/pages/recipes/editRecipe/penDetails.modal.html', 'lg');
			getPenById(pen.id);
		}

		function openWeekPreviewModal() {
			vm.loadingWeekModal = true;
			$uibModal.open({
				animation: true,
				templateUrl: 'app/pages/recipes/weekOverview.modal.html',
				scope: $scope,
				backdrop: 'static',
				keyboard: false,
				windowClass: 'modal-custom-width'
			});
			$timeout(function () {
				var version = createVirtualVersion(vm.recipe);
				var virtualRecipe = {
					recipe_versions: vm.recipe.versions.concat(version)
				};
				var recipePreview = recipePreviewDataService.generateRecipePreview(virtualRecipe, moment(), 7);
				vm.schedulerOverviewData = generateSchedulerData(recipePreview, vm.recipe.active_version.used_from, 7);
				vm.loadingWeekModal = false;
			}, 100);
		}

		function createVirtualVersion(recipe) {
			var version = {
				used_from: moment().utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
				is_virtual: true,
				recipe_ration: recipe.selectedRation,
				mixer_wagons: setMixingWagonsDTO2(recipe),
				scheduled_pens: recipe.selected_pens,
				load_management: setLoadManagementDTO(recipe)
			};

			return version;
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function cancel() {
			$uibModalStack.dismissAll();
		}

		function cancelWizard() {
			if (vm.from_calendar) {
				$state.go('calendar');
			} else {
				$state.go('recipes.myRecipes');
			}
		}

		function checkPromises() {
			return $q
				.all([rationsPromise.promise, pensPromise.promise, /*feedingMethodsPromise.promise,*/ wagonsPromise.promise, recipePromise.promise, ingredientsPromise.promise])
				.then(function () {
					return $q.resolve();
				})
				.catch(function (e) {
					return $q.reject(e);
				});
		}

		(function removeDefaultTooltip() {
			var tooltipInterval = $interval(
				function () {
					$timeout(function () {
						var tabs = document.getElementsByClassName('wizard-step');
						var tabLoaded = document.getElementById('edit-recipe-tabs');
						if (tabLoaded) {
							for (var i = 0; i < tabs.length; i++) {
								tabs[i]._title = tabs[i].title;
								tabs[i].onmouseenter = function () {
									this.title = '';
								};
								tabs[i].onmouseleave = function () {
									this.title = this._title;
								};
							}
							$interval.cancel(tooltipInterval);
						}
					}, 50);
				},
				500,
				15
			);
		})();

		function tabValidation() {
			return {
				'edit-ration-tab-validation': (!vm.recipe.rationHelpInput && vm.selectRationForm && vm.selectRationForm.$submitted) || (vm.deletedRation && !vm.historicalVersion),
				'edit-ration-tab-validation-dmi': vm.recipe && vm.recipe.rationHelpInput && vm.recipe.ration_intake_warning,
				'edit-pen-tab-validation': !vm.recipe.penHelpInput && vm.selectPenForm && vm.selectPenForm.$submitted,
				'edit-pen-tab-validation-dmi': vm.recipe && vm.recipe.penHelpInput && vm.recipe.pen_intake_warning,
				'edit-wagon-tab-validation': ((!vm.recipe.tmr && !vm.recipe.feedingMethodHelpInput) || (vm.recipe.tmr && !vm.recipe.wagonHelpInput)) && vm.feedingMethod && vm.feedingMethod.$submitted,
				'edit-drop-tab-validation': (!vm.recipe.suggestionHelpInput || vm.timepickerDisable) && vm.management && vm.management.$submitted
			};
		}

		function disableSaveButton() {
			return (
				vm.deletedRation ||
				vm.forceDisableSave ||
				vm.historicalVersion ||
				vm.timepickerDisable ||
				vm.disableRationSelect ||
				!vm.recipe.recipe_name ||
				!vm.recipe.rationHelpInput ||
				!vm.recipe.penHelpInput ||
				!vm.recipe.feedingMethodHelpInput ||
				!vm.recipe.wagonHelpInput ||
				!vm.recipe.suggestionHelpInput ||
				(vm.recipe.feedingsError && (vm.recipe.feedingsError.feeding_1 || vm.recipe.feedingsError.feeding_2 || vm.recipe.feedingsError.feeding_3))
			);
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
			vm.fromState = fromState.name;
			if (vm.fromState) {
				checkPromises().then(function () {
					$timeout(function () {
						if ((vm.fromState.contains('pens.editPen') || vm.fromState.contains('pens.addNewPen') || vm.fromState.contains('pens.penHistory')) && vm.recipe.rationHelpInput) {

							if (vm.fromState.contains('pens.editPen')) {
								if (vm.recipe.active_version && moment().diff(vm.recipe.active_version.create_date, 'minutes') < 1) {
									selectTab(0);
									$timeout(function () {
										openModal('app/pages/recipes/editRecipe/penMessage.modal.html', 'md');
									}, 150);
								} else {
									selectTab(2);
								}
							} else {
								selectTab(2);
							}

						} else if (vm.fromState.contains('iManagement.addNewIngredient')) {
							selectTab(1);
						}
					}, 100);
				});

			}

		});

		function selectTab(number) {
			$rootScope.$broadcast('select_pen_tab', number);
		}

		editableOptions.theme = 'bs3';
		editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
		editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.recipes.editRecipe').factory('editRecipeService', editRecipeService);
	/** @ngInject */
	function editRecipeService($http, $q, APP_CONST) {
		return {
			getRationsByHerd: getRationsByHerd,
			getRecipeById: getRecipeById,
			getRationCostByRationId: getRationCostByRationId,
			getPensByTeamHerd: getPensByTeamHerd,
			getFeedingMethods: getFeedingMethods,
			getRationById: getRationById,
			getPenById: getPenById,
			updateRecipe: updateRecipe,
			getIngredients: getIngredients,
			getMixerWagons: getMixerWagons,
			checkIngredient: checkIngredient,
			checkImportedIngredient: checkImportedIngredient,
			addNewRation: addNewRation,
			getImportedRationsByHerd: getImportedRationsByHerd,
			getImportedRationById: getImportedRationById,
			addNewWagon: addNewWagon,
			checkRecipeRecalculation: checkRecipeRecalculation,
			updatePen: updatePen,
			updateUsePenIntake: updateUsePenIntake
		};

		function getRationsByHerd(herdId, pageNumber, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'herds/' + herdId + '/rations/' + pageNumber + suffix)
				.then(success)
				.catch(error);
		}

		function getRecipeById(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'recipes' + suffix)
				.then(success)
				.catch(error);
		}

		function getRationCostByRationId(rationId, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'rations/' + rationId + '/costDm' + suffix)
				.then(success)
				.catch(error);
		}

		function getPensByTeamHerd(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'pens' + suffix)
				.then(success)
				.catch(error);
		}

		function getFeedingMethods() {
			return $http
				.get(APP_CONST.api_base_url + 'feedingMethods')
				.then(success)
				.catch(error);
		}

		function getRationById(id, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'rations/' + id + suffix)
				.then(success)
				.catch(error);
		}

		function getPenById(id, suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'pens/' + id + suffix)
				.then(success)
				.catch(error);
		}

		function updateRecipe(recipe) {
			return $http
				.put(APP_CONST.api_base_url + 'recipes', recipe)
				.then(success)
				.catch(error);
		}

		function getIngredients(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'ingredients' + suffix)
				.then(success)
				.catch(error);
		}

		function getMixerWagons(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'mixerwagon' + suffix)
				.then(success)
				.catch(error);
		}

		function checkIngredient(id) {
			return $http
				.get(APP_CONST.api_base_url + 'ingredients/feed/' + id)
				.then(success)
				.catch(error);
		}

		function checkImportedIngredient(id) {
			return $http
				.get(APP_CONST.api_base_url + 'ingredients/feedimport/' + id)
				.then(success)
				.catch(error);
		}

		function addNewRation(ration) {
			return $http
				.post(APP_CONST.api_base_url + 'importRationsWithRationFeed', ration)
				.then(success)
				.catch(error);
		}

		function getImportedRationsByHerd(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'importRationsWithRationFeedByHerd' + suffix)
				.then(success)
				.catch(error);
		}

		function getImportedRationById(id) {
			return $http
				.get(APP_CONST.api_base_url + 'importRationsWithRationFeedById/' + id)
				.then(success)
				.catch(error);
		}

		function checkRecipeRecalculation(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'linkedrecipes/' + suffix)
				.then(success)
				.catch(error);
		}

		function addNewWagon(url) {
			return $http
				.post(APP_CONST.api_base_url + 'mixerwagon' + url)
				.then(success)
				.catch(error);
		}

		function updatePen(pen) {
			return $http
				.put(APP_CONST.api_base_url + 'pens/active', pen)
				.then(success)
				.catch(error);
		}

		function updateUsePenIntake(pen) {
			return $http
				.put(APP_CONST.api_base_url + 'pens', pen)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.recipes.myRecipes').controller('myRecipesCtrl', myRecipesCtrl);
	/** @ngInject */
	function myRecipesCtrl($state, $scope, myRecipesService, $locale, $uibModal, $uibModalStack, errorService, $q, $timeout, uaParser, $filter) {
		var vm = this;

		vm.selectTableRow = selectTableRow;
		vm.move = move;
		vm.drag = drag;
		vm.onDragStart = onDragStart;
		vm.editRecipe = editRecipe;
		vm.recipeDetails = recipeDetails;
		vm.recipeHistory = recipeHistory;
		vm.deleteRecipe = deleteRecipe;
		vm.changeRecipeActive = changeRecipeActive;
		vm.saveNewOrder = saveNewOrder;
		vm.loadMore = loadMore;
		vm.reloadApi = reloadApi;
		vm.confirm = confirm;
		vm.cancel = cancel;

		init();

		//Total price = price /kg DM x kg DM/animal x n animal
		function init() {
			vm.loading = true;
			vm.reordered = false;
			vm.startDate = moment().toDate();
			vm.today = moment().toDate();
			vm.options = {
				showWeeks: false,
				minDate: vm.today
			};
			vm.date_format = $locale.DATETIME_FORMATS.shortDate;
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.device = uaParser.getDevice('type');
			if (vm.device) {
				vm.disableDrag = true;
			}
			checkLng();
			vm.selectedTeam = vm.settings.selectedTeam;
			if (vm.settings && vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd;
				vm.currentPage = 1;
				vm.recipes = [];
				getRecipes(vm.currentPage, true);
			} else {
				vm.selectedHerd = null;
				vm.loading = false;
			}
		}

		function reloadApi() {
			vm.loading = true;
			if (vm.settings && vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd;
				vm.currentPage = 1;
				vm.recipes = [];
				getRecipes(vm.currentPage, true);
			} else {
				vm.selectedHerd = null;
				vm.loading = false;
			}
		}

		function checkLng() {
			if (vm.settings.language) {
				if (vm.settings.language == 'en-gb') {
					vm.locale = 'en-gb';
				} else if (vm.settings.language == 'en-us') {
					vm.locale = 'en';
				} else if (vm.settings.language == 'cs-cz') {
					vm.locale = 'cs';
				} else if (vm.settings.language == 'es-es') {
					vm.locale = 'es';
				} else if (vm.settings.language == 'nl-nl') {
					vm.locale = 'nl';
				} else if (vm.settings.language == 'it-it') {
					vm.locale = 'nl';
				}
			} else {
				vm.locale = 'en-gb';
			}
		}

		function getRecipes(currentPage, init) {
			var suffix = '?page=' + currentPage;
			if (vm.settings && vm.settings.selectedHerd.id) {
				suffix = suffix + '&team=' + vm.settings.selectedTeam.id;
				suffix = suffix + '&herd=' + vm.settings.selectedHerd.id;
				return myRecipesService
					.getRecipeByTeamHerd(suffix)
					.then(function (response) {
						var nop = response.number_of_pages;
						response = response.recipes;
						if (currentPage < nop) {
							vm.displayShowMoreBtn = true;
						} else {
							vm.displayShowMoreBtn = false;
						}

						response.forEach(function (recipe) {
							recipe.is_expanded = false;
							recipe.number_of_pens = recipe.pens.length;
							recipe.number_of_animals_in_pens = 0;
							recipe.total_price = 0;
							recipe.recipe_position = recipe.position;
							recipe.inactive_recipe = moment.utc(recipe.feeding_from).isAfter(moment.utc());
							if (recipe.pens && recipe.pens.length) {
								recipe.pens.forEach(function (pen) {
									pen.total_price = (pen.use_pen_intake ? pen.pen_intake : recipe.ration_intake) * recipe.cost_dm_per_kg * pen.number_of_animals;
									recipe.total_price += pen.total_price;
									if (!pen.active) {
										recipe.pen_deactivated = true;
									}
								});
							}
						});
						vm.recipes = vm.recipes.concat(response);
						vm.loading = false;
						vm.loadingRecipes = false;
					})
					.catch(function (error) {
						console.log(error);
						vm.loading = false;
						vm.loadingRecipes = false;
						errorService.showErrorMessage(error, true, '_error_occurred_loading_recipes_', init);
					});
			}
		}

		function loadMore() {
			vm.loadingRecipes = true;
			vm.currentPage++;
			getRecipes(vm.currentPage);
		}

		function move(index, direction) {
			var toIndex = 0;
			vm.reordered = true;
			var element = vm.recipes[index];
			if (direction == 'up') {
				toIndex = index - 1;
			} else {
				toIndex = index + 1;
			}
			vm.recipes.splice(index, 1);
			vm.recipes.splice(toIndex, 0, element);
		}

		function drag(index) {
			vm.reordered = true;
			vm.recipes.splice(index, 1);
		}

		function onDragStart() {
			vm.recipes.forEach(function (r) {
				r.is_expanded = false;
			});
		}

		function editRecipe(recipe) {
			$state.go('recipes.editRecipe', {
				uuid: recipe.id
			});
		}

		function recipeDetails(recipe) {
			$state.go('recipes.recipeDetails', {
				uuid: recipe.id
			});
		}

		function recipeHistory(recipe) {
			$state.go('recipes.recipeHistory', {
				uuid: recipe.id
			});
		}

		function changeRecipeActive(recipe) {
			vm.confirmationPromise = $q.defer();

			if (recipe.active) {
				vm.warningMessage = '_m_f_recipe_deactivate_recipe_warning_';
				openModal('app/pages/recipes/myRecipes/confirmationDialog.modal.html', 'md');
			} else {
				vm.startDate = moment().toDate();
				openModal('app/pages/recipes/myRecipes/feedingDatepicker.modal.html', 'sm');
			}

			$q.all([vm.confirmationPromise.promise])
				.then(function () {
					vm.modalLoading = true;
					recipe.active = !recipe.active;
					recipe.feeding_from = moment.utc(vm.startTime).format('YYYY-MM-DDTHH:mm:ss[Z]');
					recipe.last_modified_user = vm.user.email;
					myRecipesService
						.updateRecipe(recipe)
						.then(function () {
							closeModal();
						})
						.catch(function (error) {
							recipe.active = !recipe.active;
							console.log(error);
							closeModal();
							errorService.showErrorMessage(error, true, '_error_occurred_active_recipes_');
						});
				})
				.catch(function () {
					closeModal();
				});
		}

		function selectTableRow(recipe) {
			recipe.is_expanded = !recipe.is_expanded;
			if (recipe.inactive_recipe && recipe.pens.length === 0) {
				recipe.pens_loading = true;
				getRecipeById(recipe);
			}
			for (var i = 0; i < vm.recipes.length; i++) {
				if (vm.recipes[i].id !== recipe.id) {
					vm.recipes[i].is_expanded = false;
				}
			}
		}

		function getRecipeById(recipe) {
			var suffix = '/' + recipe.id + '?team=' + vm.selectedTeam.id + '&herd=' + vm.selectedHerd.id;
			return myRecipesService
				.getRecipeById(suffix)
				.then(function (response) {
					if (response.recipe_versions && response.recipe_versions.length > 0) {
						var activeVersion = getActiveVersion(response.recipe_versions);
						if (activeVersion) {
							recipe = setRecipe(recipe, activeVersion);
						}
					}
					recipe.pens_loading = false;
				})
				.catch(function (error) {
					recipe.pens_loading = false;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_recipe_details_');
				});
		}

		function getActiveVersion(versions) {
			var date = moment();

			var version;

			if (versions.length == 1) {
				version = versions[0];
			} else {
				var versionsBefore = versions.filter(function (_version) {
					return moment(_version.used_from).isSameOrBefore(date);
				});
				versionsBefore = $filter('orderBy')(versionsBefore, ['used_from', 'create_date']);

				if (versionsBefore && versionsBefore.length > 0) {
					version = versionsBefore[versionsBefore.length - 1];
				} else {
					var versionsAfter = versions.filter(function (_version) {
						return moment(_version.used_from).isSameOrAfter(date);
					});

					versionsAfter = $filter('orderBy')(versionsAfter, ['used_from', 'create_date']);
					if (versionsAfter && versionsAfter.length > 0) {
						version = versionsAfter[0];
					}
				}
			}

			return version;
		}

		function setRecipe(recipe, version) {
			recipe.total_price = 0;
			recipe.number_of_pens = version.scheduled_pens.length;
			version.scheduled_pens.forEach(function (pen) {
				pen.name = pen.pen_name;
				pen.active = pen.pen_active;
				pen.total_price = (pen.use_pen_feed_intake ? pen.feed_intake : version.recipe_ration ? version.recipe_ration.amount_dm : 0) * version.cost_dm_per_kg * pen.number_of_animals;
				recipe.total_price += pen.total_price;
				
			});

			recipe.pens = version.scheduled_pens;

			return recipe;
		}

		function deleteRecipe(recipe) {
			var index = vm.recipes.indexOf(recipe);
			var recipeDTO = angular.copy(recipe);

			if (Number.isFinite(index)) {
				vm.warningMessage = '_recipe_delete_warning_message_';
				vm.confirmationPromise = $q.defer();
				openModal('app/pages/recipes/myRecipes/confirmationDialog.modal.html', 'md');

				$q.all([vm.confirmationPromise.promise])
					.then(function () {
						vm.modalLoading = true;
						recipeDTO.last_modified_user = vm.user.email;
						recipeDTO.feeding_from = moment.utc(vm.startDate).format('YYYY-MM-DDTHH:mm:ss[Z]');
						return myRecipesService
							.deleteRecipe([recipeDTO])
							.then(function () {
								vm.recipes.splice(index, 1);
								if (vm.recipes.length === 0) {
									getRecipes(vm.currentPage);
								} else {
									for (var i = 0; i < vm.recipes.length; i++) {
										if (i < index) {
											vm.recipes[i].recipe_position--;
										} else {
											break;
										}
									}
								}
								closeModal();
							})
							.catch(function (error) {
								console.log(error);
								vm.modalLoading = false;
								errorService.showErrorMessage(error, true, '_error_occurred_deleting_recipe_');
							});
					})
					.catch(function () {
						closeModal();
					});
			}
		}

		function openModal(page, size) {
			$uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function saveNewOrder() {
			updateRecipePositions();
			vm.reordered = false;
			vm.disableReorder = true;
			var list = vm.recipes.filter(function (recipe) {
				return recipe.position_changed;
			});
			return myRecipesService
				.saveOrder(list)
				.then(function () {
					vm.recipes.forEach(function (recipe) {
						recipe.position_changed = false;
					});
					vm.disableReorder = false;
				})
				.catch(function (error) {
					vm.disableReorder = false;
					vm.reordered = true;
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_saving_order_');
				});
		}

		function updateRecipePositions() {
			var max = -1000;

			vm.recipes.forEach(function (recipe) {
				if (recipe.recipe_position > max) {
					max = recipe.recipe_position;
				}
			});

			vm.recipes.forEach(function (recipe) {
				if (recipe.recipe_position !== max) {
					recipe.recipe_position = max;
					recipe.position_changed = true;
				}
				max--;
			});
		}

		function confirm() {
			try {
				vm.confirmationPromise.resolve();
			} catch (error) {
				console.log(error);
			}
		}

		function cancel() {
			try {
				vm.confirmationPromise.reject();
			} catch (error) {
				console.log(error);
			}
		}

		function closeModal() {
			$uibModalStack.dismissAll();
			$timeout(function () {
				vm.modalLoading = false;
			}, 50);
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});

		$scope.$on('default_herd_selected', function () {
			init();
		});

		$scope.$on('default_team_herd_changed', function () {
			init();
		});
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.recipes.myRecipes').factory('myRecipesService', myRecipesService);
	/** @ngInject */
	function myRecipesService($http, $q, APP_CONST) {
		return {
			getRecipeByTeamHerd: getRecipeByTeamHerd,
			deleteRecipe: deleteRecipe,
			getPenByRecipeId: getPenByRecipeId,
			updateRecipe: updateRecipe,
			saveOrder: saveOrder,
			getRecipeById: getRecipeById
		};

		function getRecipeByTeamHerd(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'recipes' + suffix)
				.then(success)
				.catch(error);
		}

		function deleteRecipe(recipe) {
			return $http
				.post(APP_CONST.api_base_url + 'recipes/remove', recipe)
				.then(success)
				.catch(error);
		}

		function getPenByRecipeId(recipeId) {
			return $http
				.get(APP_CONST.api_base_url + 'pens/recipe/' + recipeId)
				.then(success)
				.catch(error);
		}

		function updateRecipe(recipe) {
			return $http
				.put(APP_CONST.api_base_url + 'recipes/active', recipe)
				.then(success)
				.catch(error);
		}

		function saveOrder(recipe) {
			return $http
				.put(APP_CONST.api_base_url + 'recipes/position', recipe)
				.then(success)
				.catch(error);
		}

		function getRecipeById(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'recipes' + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.recipes.recipeDetails').controller('recipeDetailsCtrl', recipeDetailsCtrl);
	/** @ngInject */
	function recipeDetailsCtrl($stateParams, $scope, recipeDetailsService, $q, errorService, $filter, $state, $locale) {
		var vm = this;

		var i18nFilter = $filter('i18n');
		var RRule = rrule.RRule;
		var recipe;
		var feeding_methods;
		var mixer_wagons;

		vm.init = init;
		vm.back = back;

		init();

		function init() {
			vm.selectedTeamHerd = false;
			vm.loading = false;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
			if (!vm.settings.use_kgs) {
				vm.weight = 'Lb';
			} else {
				vm.weight = 'Kg';
			}
			getDefaultTeamHerd();
			setFeedingMethods();
			setNDaysDates(7);
			if (vm.selectedTeam && vm.selectedHerd) {
				recipe = $q.defer();
				feeding_methods = $q.defer();
				mixer_wagons = $q.defer();
				getRecipeById($stateParams.uuid);
				getFeedingMethods();
				getMixerWagons(vm.selectedTeam.id, vm.selectedHerd.id);
				vm.selectedTeamHerd = false;
				vm.loading = true;

				$q.all([recipe.promise, feeding_methods.promise, mixer_wagons.promise]).then(function () {
					var fm = [];
					for (var f = 0; f < vm.feeding_methods.length; f++) {
						if ((vm.details.feeding_methods & vm.feeding_methods[f].value) == vm.feeding_methods[f].value) {
							fm.push(vm.feeding_methods[f]);
						}
					}
					vm.details.mixer_wagons.forEach(function (mixer_wagon) {
						var mw = vm.mixer_wagons.find(function (_mw) {
							return _mw.id == mixer_wagon.id;
						});

						if (mw) {
							mixer_wagon.image_url = mw.image_url;
						}
					});
					vm.details.feeding_methods = fm;
					vm.loading = false;
				});
			}
		}

		function setFeedingMethods() {
			vm.category_names = [
				{
					name: i18nFilter('_milking_cows_hp_'),
					id: 1
				},
				{
					name: i18nFilter('_milking_cows_lp_'),
					id: 2
				},
				{
					name: i18nFilter('_dry_cows_'),
					id: 3
				},
				{
					name: i18nFilter('_heifers_2nd_year_of_life_'),
					id: 4
				},
				{
					name: i18nFilter('_heifers_1st_year_of_life_'),
					id: 5
				},
				{
					name: i18nFilter('_fattening_bulls_'),
					id: 6
				},
				{
					name: i18nFilter('_calves_'),
					id: 7
				}
			];
		}

		function getDefaultTeamHerd() {
			if (vm.settings.selectedTeam.id) {
				vm.selectedTeam = vm.settings.selectedTeam;
			}
			if (vm.settings.selectedHerd.id) {
				vm.selectedHerd = vm.settings.selectedHerd;
			}
		}

		function getRecipeById(recipe_id) {
			if (vm.selectedHerd && vm.selectedTeam) {
				var suffix = recipe_id + '?team=' + vm.selectedTeam.id + '&herd=' + vm.selectedHerd.id;
				vm.sum = {};
				return recipeDetailsService
					.getRecipeById(suffix)
					.then(function (response) {
						response.recipe_versions.forEach(function (recipe_v) {
							recipe_v.recipe_ration = setRecipeRation(recipe_v.recipe_ration);
						});
						var details = {
							recipe_name: response.name,
							team_id: response.team_id,
							herd_id: response.herd_id,
							feeding_methods: response.feeding_methods,
							per_day: setFedPerDay(angular.copy(response.recipe_versions))
						};
						details.active_version = angular.copy(details.per_day[0].version);
						details.rations = setRations(details.active_version, details.per_day);
						details.pens = setPens(details.active_version, details.per_day);
						details.mixer_wagons = setMixerWagons(details.active_version, details.per_day);
						vm.details = details;
						
						if (vm.settings.selectedTeam.id == vm.details.team_id) {
							vm.selectedTeamHerd = true;
						} else {
							vm.selectedTeamHerd = false;
						}
						if (vm.settings.selectedHerd.id == vm.details.herd_id) {
							vm.selectedTeamHerd = true;
						} else {
							vm.selectedTeamHerd = false;
						}
						recipe.resolve();
					})
					.catch(function (error) {
						console.log(error);
						recipe.reject();
						vm.loading = false;
						errorService.showErrorMessage(error, true, '_error_occurred_loading_recipes_', true);
					});
			}
		}

		function getFeedingMethods() {
			return recipeDetailsService
				.getFeedingMethods()
				.then(function (response) {
					vm.feeding_methods = response;
					feeding_methods.resolve();
				})
				.catch(function (error) {
					feeding_methods.reject(error);
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_feeding_methods_', true);
				});
		}

		function getMixerWagons(team, herd) {
			return recipeDetailsService
				.getMixerWagons(team, herd)
				.then(function (response) {
					vm.mixer_wagons = response;
					mixer_wagons.resolve();
				})
				.catch(function (error) {
					console.log(error);
					vm.mixer_wagons = [];
					mixer_wagons.resolve();
				});
		}

		function back() {
			$state.go('recipes.myRecipes');
		}

		function setNDaysDates(n) {
			var dates = [];

			for (var i = 0; i < n; i++) {
				var date;
				if (i) {
					date = moment().add(i, 'days');
				} else {
					date = moment();
				}

				dates.push(date);
			}

			vm.dates = dates;
		}

		function setRecipeRation(ration) {
			var cost_dm = 0;

			ration.ration_feeds.forEach(function (feed) {
				cost_dm += (feed.cost_dm || 0) * feed.amount_dm;
			});
			ration.cost_dm = cost_dm;
			ration.cost_per_kg_dm = cost_dm / ration.amount_dm;
			return ration;
		}

		function setRations(a_version, days) {
			var list = [];
			days.forEach(function (day) {
				if (day.version.recipe_ration.ration_header_id == a_version.recipe_ration.ration_header_id && day.version.recipe_ration.dm == a_version.recipe_ration.dm) {
					day.version.recipe_ration.active_version = true;
				}
				day.version.recipe_ration.used_from = day.version.used_from;
				if (list.length) {
					var existing = list.filter(function (el) {
						return el.ration_header_id == day.version.recipe_ration.ration_header_id && el.dm == day.version.recipe_ration.dm;
					});

					if (!existing.length) {
						list.push(day.version.recipe_ration);
					}
				} else {
					list.push(day.version.recipe_ration);
				}
			});

			return list;
		}

		function setPens(a_version, days) {
			var list = [];

			days.forEach(function (day) {
				day.version.scheduled_pens.forEach(function (pen) {
					var active = a_version.scheduled_pens.find(function (el) {
						return pen.id == el.id && pen.number_of_animals == el.number_of_animals && pen.pen_feeding_scheduler.id == el.pen_feeding_scheduler.id;
					});
					if (active) {
						pen.active_version = true;
					}
					if (list.length) {
						var existing = list.filter(function (el) {
							return pen.id == el.id && pen.number_of_animals == el.number_of_animals && pen.pen_feeding_scheduler.id == el.pen_feeding_scheduler.id;
						});
						if (!existing.length) {
							list.push(pen);
						}
					} else {
						list.push(pen);
					}
				});
			});

			return list;
		}

		function setMixerWagons(a_version, days) {
			var list = [];

			days.forEach(function (day) {
				day.version.mixer_wagons.forEach(function (mixer_wagon) {
					var active = a_version.mixer_wagons.find(function (el) {
						return mixer_wagon.id == el.id && mixer_wagon.volume == el.volume && mixer_wagon.weight == el.weight;
					});
					if (active) {
						mixer_wagon.active_version = true;
					}
					if (list.length) {
						var existing = list.filter(function (el) {
							return mixer_wagon.id == el.id && mixer_wagon.volume == el.volume && mixer_wagon.weight == el.weight;
						});
						if (!existing.length) {
							list.push(mixer_wagon);
						}
					} else {
						list.push(mixer_wagon);
					}
				});
			});

			return list;
		}

		function setFedPerDay(versions) {
			versions = $filter('orderBy')(versions, 'used_from');
			versions = versions.map(function (version, index) {
				version.end_date = versions[index + 1] ? versions[index + 1].used_from : moment().add(31, 'd').format();
				version.scheduled_pens = setPenFedDays(version.scheduled_pens);
				return version;
			});
			var list = [];

			for (var i = 0; i < vm.dates.length; i++) {
				var date = {
					date: vm.dates[i],
					date_formated: vm.dates[i].format('L'),
					version: getVersionByDate(vm.dates[i], versions)
				};
				list.push(date);
			}

			return list;
		}

		function setPenFedDays(pens) {
			pens = pens.map(function (pen) {
				pen.pen_feeding_scheduler_list = $filter('orderBy')(pen.pen_feeding_scheduler_list, 'start_feeding_date');

				var days = [];

				pen.pen_feeding_scheduler_list.forEach(function (pfs, index) {
					var rrule_start_date = moment(pfs.start_feeding_date).format('YYYYMMDDT000000') + 'Z';
					var rrule_end_date = pen.pen_feeding_scheduler_list[index + 1]
						? moment(pen.pen_feeding_scheduler_list[index + 1].start_feeding_date)
								.subtract(1, 'd')
								.format('YYYYMMDDT000000') + 'Z'
						: moment().add(30, 'd').format('YYYYMMDDT000000') + 'Z';
					var rrule_freq = pfs.feeding_frequency_rule && pfs.feeding_frequency_rule.length > 1 ? pfs.feeding_frequency_rule : 'FREQ=DAILY;INTERVAL=1';
					var rrule_string = 'DTSTART:' + rrule_start_date + '\nRRULE:' + rrule_freq + ';UNTIL=' + rrule_end_date;
					var dates = RRule.fromString(rrule_string).all();
					days = days.concat(dates);
				});

				days = days.map(function (day, index) {
					var to = days[index + 1] ? days[index + 1] : null;
					var diff = to ? moment(to).diff(day, 'days') : 0;
					return { d: day, multiply: diff };
				});
				pen.days_fed = days;
				return pen;
			});

			return pens;
		}

		function getVersionByDate(date, versions) {
			versions = angular.copy(versions);
			date = date.set('hour', 23).set('minute', 59).set('second', 59);
			if (versions && versions.length) {
				var active_version;
				if (versions.length == 1) {
					active_version = versions[0];
					active_version.scheduled_pens = getScheduledPens(date, active_version.scheduled_pens);
					active_version = setActiveVersion(date, active_version);
					return active_version;
				} else {
					var versionsBefore = versions.filter(function (version) {
						return moment(version.used_from).isSameOrBefore(date);
					});
					active_version = versionsBefore[versionsBefore.length - 1];
					active_version.scheduled_pens = getScheduledPens(date, active_version.scheduled_pens);
					active_version = setActiveVersion(date, active_version);
					return active_version;
				}
			}
			return null;
		}

		function getScheduledPens(date, pens) {
			var list = [];
			pens.forEach(function (pen) {
				pen.pen_feeding_scheduler_list = $filter('orderBy')(pen.pen_feeding_scheduler_list, 'start_feeding_date');
				if (pen.pen_feeding_scheduler_list.length == 1) {
					pen.pen_feeding_scheduler = pen.pen_feeding_scheduler_list[0];
				} else {
					var versionsBefore = pen.pen_feeding_scheduler_list.filter(function (pen_feeding_scheduler) {
						return moment(pen_feeding_scheduler.start_feeding_date).isSameOrBefore(date);
					});
					var active_version = versionsBefore[versionsBefore.length - 1];
					pen.pen_feeding_scheduler = active_version;
				}

				var present = pen.days_fed.find(function (d) {
					return date.isSame(d.d, 'day');
				});

				if (present) {
					list.push(pen);
				}
			});

			return list;
		}

		function setActiveVersion(date, version) {
			version.scheduled_pens = setScheduledPens(date, version);
			version.summary = setSummary(version);
			version.loading = setLoading(version);
			return version;
		}

		function setScheduledPens(date, recipe) {
			var pens = recipe.scheduled_pens.map(function (pen) {
				var d = pen.days_fed.find(function (el) {
					return moment(el.d).isSame(date, 'day');
				});

				var multiply = 1;
				if (d) {
					multiply = d.multiply;
				}
				pen.total_dm = pen.use_pen_feed_intake ? pen.number_of_animals * pen.feed_intake * multiply : pen.number_of_animals * recipe.recipe_ration.amount_dm * multiply;
				pen.cost_dm = pen.total_dm * recipe.recipe_ration.cost_per_kg_dm;
				if (recipe.recipe_ration.dm) {
					pen.total_as_fed = (pen.total_dm * 100) / recipe.recipe_ration.dm;
				} else {
					pen.total_as_fed = 0;
				}

				var n = 0;

				if (pen.pen_feeding_scheduler.morning_feeding) {
					n++;
				}

				if (pen.pen_feeding_scheduler.noon_feeding) {
					n++;
				}

				if (pen.pen_feeding_scheduler.evening_feeding) {
					n++;
				}

				var per_feeding = pen.total_as_fed / n;
				if (isNaN(per_feeding)) {
					per_feeding = 1;
				}

				if (pen.pen_feeding_scheduler.morning_feeding) {
					pen.morning_feeding = per_feeding;
					pen.pen_feeding_scheduler.morning_feeding_time = moment.utc(moment().format('YYYY-MM-DD') + 'T' + pen.pen_feeding_scheduler.morning_feeding_time).format('YYYY-MM-DDTHH:mm:ss');
				}

				if (pen.pen_feeding_scheduler.noon_feeding) {
					pen.noon_feeding = per_feeding;
					pen.pen_feeding_scheduler.noon_feeding_time = moment.utc(moment().format('YYYY-MM-DD') + 'T' + pen.pen_feeding_scheduler.noon_feeding_time).format('YYYY-MM-DDTHH:mm:ss');
				}

				if (pen.pen_feeding_scheduler.evening_feeding) {
					pen.evening_feeding = per_feeding;
					pen.pen_feeding_scheduler.evening_feeding_time = moment.utc(moment().format('YYYY-MM-DD') + 'T' + pen.pen_feeding_scheduler.evening_feeding_time).format('YYYY-MM-DDTHH:mm:ss');
				}

				return pen;
			});

			return pens;
		}

		function setSummary(recipe) {
			var summary = {
				number_of_animals: 0,
				cost_dm: 0,
				total_dm: 0,
				total_as_fed: 0,
				morning: 0,
				noon: 0,
				evening: 0
			};
			recipe.scheduled_pens.forEach(function (pen) {
				summary.number_of_animals += pen.number_of_animals;
				summary.cost_dm += pen.cost_dm;
				summary.total_dm += pen.total_dm;
				summary.total_as_fed += pen.total_as_fed;
				summary.morning += pen.morning_feeding ? pen.morning_feeding : 0;
				summary.noon += pen.noon_feeding ? pen.noon_feeding : 0;
				summary.evening += pen.evening_feeding ? pen.evening_feeding : 0;
			});

			return summary;
		}

		function setLoading(recipe) {
			var loading = {
				morning: {
					total: recipe.summary.morning,
					loads: []
				},
				noon: {
					total: recipe.summary.noon,
					loads: []
				},
				evening: {
					total: recipe.summary.evening,
					loads: []
				}
			};

			if (recipe.summary.morning) {
				var amount_m = recipe.summary.morning;

				var existing_load_management_m = recipe.load_management.find(function (lm) {
					return lm.load_subject_order_number == 1 && lm.amount == amount_m;
				});

				if (existing_load_management_m) {
					loading.morning.loads = getPredefinedLoads(existing_load_management_m, recipe);
				} else {
					loading.morning.loads = getLoads(amount_m, recipe, 1);
				}
			}
			if (recipe.summary.noon) {
				var amount_n = recipe.summary.noon;

				var existing_load_management_n = recipe.load_management.find(function (lm) {
					return lm.load_subject_order_number == 2 && lm.amount == amount_n;
				});

				if (existing_load_management_n) {
					loading.noon.loads = getPredefinedLoads(existing_load_management_n, recipe);
				} else {
					loading.noon.loads = getLoads(amount_n, recipe, 2);
				}
			}
			if (recipe.summary.evening) {
				var amount_e = recipe.summary.evening;

				var existing_load_management_e = recipe.load_management.find(function (lm) {
					return lm.load_subject_order_number == 3 && lm.amount == amount_e;
				});

				if (existing_load_management_e) {
					loading.evening.loads = getPredefinedLoads(existing_load_management_e, recipe);
				} else {
					loading.evening.loads = getLoads(amount_e, recipe, 3);
				}
			}

			return loading;
		}

		function getLoads(amount, recipe, load_subject_order_number) {
			var mixer_wagon = recipe.mixer_wagons.find(function (mw) {
				return mw.position === 0;
			});

			if (mixer_wagon) {		
				mixer_wagon.value = mixer_wagon.weight * 1000;
				var loads = [];
				var count = 0;
				while (amount > mixer_wagon.value && count < 9) {
					loads.push({
						value: mixer_wagon.value,
						wagon: mixer_wagon
					});
					amount = amount - mixer_wagon.value;
					count++;
				}
				loads = $filter('orderBy')(loads, 'value', true);
				if (amount > 0) {
					var load = {
						value: amount,
						wagon: mixer_wagon
					};
					loads.push(load);
				}
			}
			loads = setMixingTimes(loads, recipe, load_subject_order_number);
			return loads;
		}

		function setMixingTimes(loads, recipe, load_subject_order_number) {
			var load_management = recipe.load_management.find(function (lm) {
				return lm.load_subject_order_number == load_subject_order_number;
			});

			if (load_management) {
				for (var i = 0; i < loads.length; i++) {
					var load_detail = load_management.load_details[i];
					if (load_detail) {
						loads[i].mixing_time = load_detail.mixing_time ? load_detail.mixing_time : null;
					}
				}

			}
			return loads;
		}

		function getPredefinedLoads(existing_load_management, recipe) {
			existing_load_management.load_details = $filter('orderBy')(existing_load_management.load_details, 'position');
			var loads = [];

			existing_load_management.load_details.forEach(function (load) {
				var mixer_wagon = recipe.mixer_wagons.find(function (wagon) {
					return wagon.id == load.mixer_wagon_id;
				});

				var l = {
					value: load.amount,
					wagon: mixer_wagon ? mixer_wagon : null
				};

				loads.push(l);
			});

			return loads;
		}

		$scope.$on('reload_apis', function () {
			init();
		});

		$scope.$on('default_herd_selected', function () {
			vm.selectedHerd = null;
			vm.selectedTeam = null;
			init();
		});

		$scope.$on('default_team_selected', function () {
			vm.selectedHerd = null;
			vm.selectedTeam = null;
			init();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.recipes.recipeDetails').factory('recipeDetailsService', recipeDetailsService);
	/** @ngInject */
	function recipeDetailsService($http, $q, APP_CONST) {
		return {
			getRecipeById: getRecipeById,
			getRationById: getRationById,
			getFeedingMethods: getFeedingMethods,
			getImportedRationById: getImportedRationById,
			getMixerWagons: getMixerWagons
		};

		function getRecipeById(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'recipes/' + suffix)
				.then(success)
				.catch(error);
		}

		function getRationById(id) {
			return $http
				.get(APP_CONST.api_base_url + 'rations/' + id)
				.then(success)
				.catch(error);
		}

		function getFeedingMethods() {
			return $http
				.get(APP_CONST.api_base_url + 'feedingMethods')
				.then(success)
				.catch(error);
		}

		function getImportedRationById(id) {
			return $http
				.get(APP_CONST.api_base_url + 'importRationsWithRationFeedById/' + id + '?visible=false')
				.then(success)
				.catch(error);
		}

		function getMixerWagons(team, herd) {
			return $http
				.get(APP_CONST.api_base_url + 'mixerwagon?team=' + team + '&herd=' + herd)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.recipes.recipeHistory').controller('recipeHistoryCtrl', recipeHistoryCtrl);
	/** @ngInject */
	function recipeHistoryCtrl($stateParams, $state, $filter, recipeHistoryService, errorService, $scope, $locale, $q) {
		var vm = this;

		vm.dataCollapseFn = dataCollapseFn;
		vm.selectTableRow = selectTableRow;
		vm.tableRowExpanded = false;
		vm.tableRowIndexExpandedCurr = '';
		vm.tableRowIndexExpandedPrev = '';
		vm.idExpanded = '';
		vm.reordered = false;
		vm.back = back;
		vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;

		init();

		function init() {
			vm.loading = true;
			getDefaultTeamHerd();
			vm.currentPage = 1;
			vm.recipe_id = $stateParams.uuid;
			if (vm.selectedTeam && vm.selectedHerd) {
				getRecipeHistory(vm.currentPage);
			}
		}

		function getRecipeHistory() {
			var suffix = vm.recipe_id + '?team=' + vm.selectedTeam.id + '&herd=' + vm.selectedHerd.id;

			var getHistory = recipeHistoryService.getHistory(suffix);
			var getRecipe = recipeHistoryService.getRecipeById(suffix);

			$q.all([getHistory, getRecipe])
				.then(function (responses) {
					var historyResponse = handleHistoryResponse(responses[0]);
					var recipeResponse = handleRecipeResponse(responses[1]);
					vm.history = $filter('orderBy')(recipeResponse.concat(historyResponse), 'feeding_from', true);
					vm.loading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_loading_recipe_history_', true);
				});
		}

		function handleRecipeResponse(response) {
			var history = [];

			response.recipe_versions.forEach(function (recipe_version) {
				var obj = {
					recipe_name: response.name,
					number_of_pens: recipe_version.scheduled_pens ? recipe_version.scheduled_pens.length : 0,
					total_price: calculateTotalPrice(recipe_version),
					pens: setPens(recipe_version.scheduled_pens),
					create_date: recipe_version.create_date,
					feeding_from: recipe_version.used_from,
					last_modified_user: recipe_version.last_modified_user,
					last_modified_date: recipe_version.last_modified_date
				};

				history.push(obj);
			});

			return history;
		}

		function handleHistoryResponse(response) {
			var history = [];

			response.forEach(function (history_item) {
				var obj = {
					recipe_name: history_item.recipe_name,
					number_of_pens: history_item.pens_number ? history_item.pens_number : 0,
					pens: setPens(history_item.pens),
					create_date: history_item.create_date,
					feeding_from: history_item.feeding_from,
					last_modified_user: history_item.last_modified_user,
					last_modified_date: history_item.last_modified_date
				};
				history.push(obj);
			} );

			return history;
		}


		function calculateTotalPrice(recipe_v) {
			var price = 0;

			if (recipe_v.recipe_ration && recipe_v.recipe_ration.ration_feeds) {
				var amount_dm = 0;
				var cost_dm = 0;
				recipe_v.recipe_ration.ration_feeds.forEach(function (feed) {
					amount_dm += feed.amount_dm;
					cost_dm += (feed.cost_dm || 0) * feed.amount_dm;
				});
				var cost_per_kg_dm = cost_dm / amount_dm;

				if (recipe_v.scheduled_pens) {
					recipe_v.scheduled_pens.forEach(function (pen) {
						pen.total_price = (pen.use_pen_feed_intake ? pen.feed_intake * cost_per_kg_dm : recipe_v.recipe_ration.amount_dm * cost_per_kg_dm) * pen.number_of_animals;
						price += pen.total_price;
					});
				}
			}

			return price;
		}

		function setPens(pens) {
			return pens;
		}

		function back() {
			$state.go('recipes.myRecipes');
		}

		function getDefaultTeamHerd() {
			var settings = JSON.parse(localStorage.getItem('user_settings'));
			if (settings.selectedTeam.id) {
				vm.selectedTeam = settings.selectedTeam;
			}
			if (settings.selectedHerd.id) {
				vm.selectedHerd = settings.selectedHerd;
			}
		}

		function dataCollapseFn() {
			vm.dataCollapse = [];
			for (var i = 0; i < vm.history.length; i++) {
				vm.dataCollapse.push(false);
			}
		}

		function selectTableRow(index, id) {
			vm.selectedList = [];
			if (typeof vm.dayDataCollapse === 'undefined') {
				vm.dataCollapseFn();
			}
			if (vm.tableRowExpanded === false && vm.tableRowIndexExpandedCurr === '' && vm.idExpanded === '') {
				vm.tableRowIndexExpandedPrev = '';
				vm.tableRowExpanded = true;
				vm.tableRowIndexExpandedCurr = index;
				vm.idExpanded = id;
				vm.dataCollapse[index] = true;
			} else if (vm.tableRowExpanded === true) {
				if (vm.tableRowIndexExpandedCurr === index && vm.idExpanded === id) {
					vm.tableRowExpanded = false;
					vm.tableRowIndexExpandedCurr = '';
					vm.idExpanded = '';
					vm.dataCollapse[index] = false;
				} else {
					vm.tableRowIndexExpandedPrev = vm.tableRowIndexExpandedCurr;
					vm.tableRowIndexExpandedCurr = index;
					vm.idExpanded = id;
					vm.dataCollapse[vm.tableRowIndexExpandedPrev] = false;
					vm.dataCollapse[vm.tableRowIndexExpandedCurr] = true;
				}
			}
		}

		$scope.$on('reload_apis', function () {
			init();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.recipes.recipeHistory').factory('recipeHistoryService', recipeHistoryService);
	/** @ngInject */
	function recipeHistoryService($http, $q, APP_CONST) {
		return {
			getHistory: getHistory,
			getRecipeById: getRecipeById
		};

		function getHistory(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'recipeHistory/' + suffix)
				.then(success)
				.catch(error);
		}

		function getRecipeById(suffix) {
			return $http
				.get(APP_CONST.api_base_url + 'recipes/' + suffix)
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.teams.addNewTeam').controller('addNewTeamCtrl', addNewTeamCtrl);
	/**@ngInject */
	function addNewTeamCtrl($state, addNewTeamFactory, toastr, $filter, $rootScope, $q, $scope, errorService) {
		var vm = this;
		var ordersPromise;
		var teamsPromise;
		vm.addNewTeam = addNewTeam;
		vm.cancel = cancel;
		vm.init = init;
		var i18nFilter = $filter('i18n');
		init();

		function init() {
			vm.loading = true;
			vm.teamDTO = {};
			vm.selectPlaceholder = '_picker_country_placeholder_';
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.teamDTO.Email = vm.user.email;
			getInitData();
		}

		function reloadApi() {
			vm.loading = true;
			vm.teamDTO = {};
			getInitData();
		}

		function getInitData() {
			ordersPromise = $q.defer();
			teamsPromise = $q.defer();
			$q.all([teamsPromise.promise, ordersPromise.promise])
				.then(function (response) {
					var orders = response[1];
					vm.availableOrders = getAvailableOrders(orders);
					vm.loading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
				});
			getTeams();
			getOrders();
		}

		function getOriginalTeam(teams) {
			var team;
			for (var i = 0; i < teams.length; i++) {
				if (teams[i].Name == vm.user.email && teams[i].Email == vm.user.email) {
					team = teams[i];
					break;
				}
			}
			return team;
		}

		function getAvailableOrders(orders) {
			var o = orders.filter(function (obj) {
				return (obj.ProductId == 11 || obj.ProductId == 23) && (!obj.EndDate || (obj.EndDate && moment(obj.EndDate).isAfter(moment())));
			});

			var hasRation;
			var hasFeed;

			var rationWithoutEndDate = false;
			var feedWithoutEndDate = false;

			var rationMax;
			var feedMax;

			for (var i = 0; i < o.length; i++) {
				if (o[i].ProductId == 11) {
					hasRation = true;

					if (!o[i].EndDate) {
						rationWithoutEndDate = true;
					}

					if (o[i].EndDate) {
						if (!rationMax) {
							rationMax = o[i].EndDate;
						} else {
							if (moment(o[i].EndDate).isAfter(rationMax)) {
								rationMax = o[i].EndDate;
							}
						}
					}
				}

				if (o[i].ProductId == 23) {
					hasFeed = true;

					if (!o[i].EndDate) {
						feedWithoutEndDate = true;
					}

					if (o[i].EndDate) {
						if (!feedMax) {
							feedMax = o[i].EndDate;
						} else {
							if (moment(o[i].EndDate).isAfter(feedMax)) {
								feedMax = o[i].EndDate;
							}
						}
					}
				}
			}

			var orders = [];

			if (hasRation) {
				var obj = {
					productType: 10
				};

				if (!rationWithoutEndDate) {
					obj.endDate = encodeURIComponent(moment(rationMax).hours(12).format('YYYY-MM-DD'));
				} else {
					obj.endDate = undefined;
				}
				orders.push(obj);
			}

			if (hasFeed) {
				var obj = {
					productType: 11
				};

				if (!feedWithoutEndDate) {
					obj.endDate = encodeURIComponent(moment(feedMax).hours(12).format('YYYY-MM-DD'));
				} else {
					obj.endDate = undefined;
				}
				orders.push(obj);
			}
			return orders;
		}

		function getEndDateByTeam(team, orders) {
			var date;
			for (var i = 0; i < orders.length; i++) {
				if (orders[i].TeamId == team.Id) {
					date = orders[i].EndDate;
					break;
				}
			}
			if (date) {
				var today = moment().format('YYYY-MM-DD');
				if (today != moment(date).format('YYYY-MM-DD') && moment().isAfter(date)) {
					date = undefined;
				}
			}
			return date;
		}

		function getTeams() {
			return addNewTeamFactory
				.getTeams()
				.then(function (response) {
					teamsPromise.resolve(response);
				})
				.catch(function (error) {
					teamsPromise.reject(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_teams_', true);
				});
		}

		function getOrders() {
			return addNewTeamFactory
				.getOrders()
				.then(function (response) {
					ordersPromise.resolve(response);
				})
				.catch(function (error) {
					ordersPromise.reject(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_orders_', true);
				});
		}

		function addNewTeam() {
			if (!vm.teamForm.$invalid) {
				vm.loading = true;
				if (vm.user && vm.user.email) {
					clearCache();
					return addNewTeamFactory
						.addNewTeam(vm.teamDTO)
						.then(function (response) {
							toastr.success(i18nFilter('_toastr_team_created_'), i18nFilter('_toastr_success_title_'));
							brodcastNewTeam();
							makeAnOrder(response.Id);
							$state.go('teams.myTeams');
							localStorage.setItem('add_new_team', true);
						})
						.catch(function (error) {
							vm.loading = false;
							if (error.data.ExceptionMessage && error.data.ExceptionMessage == 'name already exists!') {
								errorService.showErrorMessage(error, true, '_error_team_already_exists_');
							} else {
								errorService.showErrorMessage(error, true, '_error_occurred_creating_team_');
							}
						});
				}
			}
		}

		function clearCache() {
			return addNewTeamFactory
				.clearCache()
				.then()
				.catch(function (error) {
					errorService.showErrorMessage(error, true, '_error_occurred_clearing_cache_');
				});
		}

		function makeAnOrder(id) {
			var promiseList = [];
			for (var i = 0; i < vm.availableOrders.length; i++) {
				var name = 'p_' + i;
				vm[name] = $q.defer();
				promiseList.push(vm[name].promise);
				var order = {
					id: id,
					productType: vm.availableOrders[i].productType,
					endDate: vm.availableOrders[i].endDate
				};
				createOrder(order, name);
			}

			$q.all(promiseList)
				.then(function () {
					vm.loading = false;
				})
				.catch(function (error) {
					console.log(error);
					vm.loading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_making_order_');
				});
		}

		function createOrder(order, name) {
			return addNewTeamFactory
				.makeAnOrder(order)
				.then(function () {
					vm[name].resolve();
				})
				.catch(function (error) {
					console.log(error);
					vm[name].reject(error);
				});
		}

		function brodcastNewTeam() {
			$rootScope.$broadcast('new_team');
		}

		function cancel() {
			$state.go('teams.myTeams');
		}

		$scope.$on('reload_apis', function () {
			reloadApi();
		});
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.pages.teams.addNewTeam').factory('addNewTeamFactory', addNewTeamFactory);

	/**@ngInject */
	function addNewTeamFactory($http, $q, APP_CONST) {
		return {
			addNewTeam: addNewTeam,
			makeAnOrder: makeAnOrder,
			clearCache: clearCache,
			getTeams: getTeams,
			getOrders: getOrders
		};

		function addNewTeam(team) {
			return $http
				.post(APP_CONST.api_base_url + 'backoffice/teams', team)
				.then(success)
				.catch(error);
		}

		function makeAnOrder(order) {
			return $http
				.post(APP_CONST.api_base_url + 'backoffice/teams/' + order.id + '/orderproduct/' + order.productType + (order.endDate ? '?endDate=' + order.endDate : ''))
				.then(success)
				.catch(error);
		}

		function clearCache() {
			return $http
				.post(APP_CONST.api_base_url + 'userSettings/remove/cache')
				.then(success)
				.catch(error);
		}

		function getTeams() {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams')
				.then(success)
				.catch(error);
		}

		function getOrders() {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/orders')
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
    'use strict';
    angular.module('Spartan.pages.teams.myTeams').controller('myTeamsCtrl', myTeamsCtrl);
    /** @ngInject */
    function myTeamsCtrl(myTeamsFactory, $rootScope, $scope, errorService, preloader, $timeout, authService, $q, $filter) {
        var vm = this;
        var teams;
        var orders;
        vm.setAsDefault = setAsDefault;
        vm.reloadApi = reloadApi;
        init();

        function init() {
            vm.loading = true;
            vm.settings = JSON.parse(localStorage.getItem('user_settings'));
            vm.check_access = JSON.parse(localStorage.getItem('add_new_team'));
            vm.feedTeams = authService.teams;
            teams = $q.defer();
            orders = $q.defer();
            getTeams(true);
            getOrders();
            handleResponses()
        }

        function handleResponses(){
            $q.all([teams.promise, orders.promise]).then(function(){
                for (var i = 0; i < vm.teams.length; i++) {
                for(var j = 0; j < vm.orders.length; j++){
                    if(vm.teams[i].Id == vm.orders[j].TeamId){
                        if(vm.orders[j].ProductId == 11){
                            vm.teams[i].rationOrder = vm.orders[j];
                        } else if (vm.orders[j].ProductId == 23) {
                            vm.teams[i].feedOrder = vm.orders[j];
                        }
                    }
                }
            }
                vm.loading = false;
            }).catch(function(error){
                errorService.showErrorMessage(error, true, '_error_occurred_loading_teams_', true);
                console.log(error);
            })
        }

        function reloadApi() {
            teams = $q.defer();
            orders = $q.defer();
            vm.loading = true;
            vm.feedTeams = authService.teams;
            getTeams(true);
            getOrders();
            handleResponses();
        }

        function getTeams(init) {
            vm.loading = true;
            if (vm.check_access) {
                preloader.getUserAccess();
                $timeout(function () {
					localStorage.removeItem('add_new_team');
				}, 1000);
            }
            myTeamsFactory.getTeamsByUser().then(function (response) {
                vm.teamsSafe = response;
                vm.teams = [];
					for (var i = 0; i < response.length; i++) {
						for (var j = 0; j < vm.feedTeams.length; j++) {
							if (response[i].Id == vm.feedTeams[j].id) {
								vm.teams.push(response[i]);
							}
						}
					}
                    if(vm.settings.selectedTeam){
                    for (var i = 0; i < vm.teams.length; i++) {
                        if (vm.settings.selectedTeam.id == vm.teams[i].Id) {
                            vm.teams[i].isDefault = true;
                        } else {
                            vm.teams[i].isDefault = false;
                        }
                    }
                }
                var l = vm.teams.length;
                vm.itemsPerPageValues = [];
                if (l > 5) {
                    vm.itemsPerPageValues.push(5);
                    vm.itemsPerPageValues.push(10);
                }
                if (l > 10) {
                    vm.itemsPerPageValues.push(15);
                }
                if (l > 15) {
                    vm.itemsPerPageValues.push(20);
                }
                if (l > 20) {
                    vm.itemsPerPageValues.push(25);
                }

                teams.resolve();
               
            }).catch(function (error) {
                console.log(error);
                
                teams.reject();
            });
        }

        function getOrders(){
            myTeamsFactory.getOrders().then(function(response){
                response = response.filter(function(order){
                    return order.ProductId == 11 || order.ProductId == 23;
                })

                var date = moment().add(1, 'month');
                var today = moment();

                response.forEach(function(order){
                    if(order.EndDate){
                        if(moment(order.EndDate).isBefore(today)){
                            order.status = 'expired';
                        } else {
                            if(moment(order.EndDate).isBefore(date)){
                                order.status = 'warning';
                            }else{
                                order.status = 'active';
                            }
                        }

                        order.EndDate = $filter('date')(order.EndDate, 'shortDate');
                    }else {
                        order.EndDate = '-';
                        order.status = 'active';
                    }
                })
                vm.orders = response;
                orders.resolve();

            }).catch(function(error){
                console.log(error);
                orders.reject();
            })
        }

        function setAsDefault(team) {
            if (!team.isDefault) {
                var temp = {
                    team_id: team.Id
                }
                var tempTeams = [];
                angular.copy(vm.teams, tempTeams);
                for (var i = 0; i < tempTeams.length; i++) {
                    if (team.Id == tempTeams[i].Id) {
                        tempTeams[i].isDefault = true;
                    } else {
                        tempTeams[i].isDefault = false;
                    }
                }
                vm.teams = tempTeams;
                var user = JSON.parse(localStorage.getItem("user_profile"));
                return myTeamsFactory.setDefaultTeam(temp, user.email).then(function (response) {
                    localStorage.setItem("user_settings", JSON.stringify(response));
                    brodcastTeamSelected(team);
                }).catch(function (error) {
                    console.log(error);
                    if (error.status == 403) {
                        getTeams();
                    }
                    errorService.showErrorMessage(error, true, '_error_occurred_changing_default_team_');
                });
            }
        }

        function brodcastTeamSelected(team) {
            $rootScope.$broadcast('default_team_selected_from_herds', team);
        }

        $scope.$on('default_team_selected', function () {
            init();
        })

        $scope.$on('reload_apis', function () {
            reloadApi();
        })
    }
})();
(function () {
	'use strict';
	angular.module('Spartan.pages.teams.myTeams').factory('myTeamsFactory', myTeamsFactory);
	/** @ngInject */
	function myTeamsFactory(APP_CONST, $http, $q) {
		return {
			getTeamsByUser: getTeamsByUser,
			setDefaultTeam: setDefaultTeam,
			getOrders: getOrders
		};

		function getTeamsByUser() {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams')
				.then(success)
				.catch(error);
		}

		function setDefaultTeam(obj, email) {
			var emailSuffix = '';
			if (email) {
				emailSuffix = emailSuffix + '?email=' + encodeURIComponent(email);
			}
			return $http
				.patch(APP_CONST.api_base_url + 'userSettings' + emailSuffix, obj)
				.then(success)
				.catch(error);
		}

		function getOrders() {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/orders')
				.then(success)
				.catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Spartan.theme.components')
	  .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
	return {
	  restrict: 'E',
	  templateUrl: 'app/theme/components/backTop/backTop.html',
	  controller: function () {
		$('#backTop').backTop({
		  'position': 200,
		  'speed': 100
		});
	  }
	};
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('Spartan.theme')
	  .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
	return angular.extend({}, baPanel, {
	  template: function(el, attrs) {
		var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
		res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
		res += baPanel.template(el, attrs);
		res += '</div>';
		return res;
	  }
	});
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('Spartan.theme')
	  .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

	/** Base baPanel directive */
	return {
	  restrict: 'A',
	  transclude: true,
	  template: function(elem, attrs) {
		var res = '<div class="panel-body" ng-transclude></div>';
		if (attrs.baPanelTitle) {
		  var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
		  res = titleTpl + res; // title should be before
		}

		return res;
	  }
	};
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Spartan.theme')
	  .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
	var bodyBgSize;

	baPanelBlurHelper.bodyBgLoad().then(function() {
	  bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
	});

	$window.addEventListener('resize', function() {
	  bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
	});

	return {
	  restrict: 'A',
	  link: function($scope, elem) {
		if(!$rootScope.$isMobile) {
		  baPanelBlurHelper.bodyBgLoad().then(function () {
			setTimeout(recalculatePanelStyle);
		  });
		  $window.addEventListener('resize', recalculatePanelStyle);

		  $scope.$on('$destroy', function () {
			$window.removeEventListener('resize', recalculatePanelStyle);
		  });
		}

		function recalculatePanelStyle() {
		  if (!bodyBgSize) {
			return;
		  }
		  elem.css({
			backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
			backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
		  });
		}

	  }
	};
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Spartan.theme')
	  .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
	var res = $q.defer();
	var computedStyle = getComputedStyle(document.body, ':before');
	var image = new Image();
	image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
	image.onerror = function() {
	  res.reject();
	};
	image.onload = function() {
	  res.resolve();
	};

	this.bodyBgLoad = function() {
	  return res.promise;
	};

	this.getBodyBgImageSizes = function() {
	  var elemW = document.documentElement.clientWidth;
	  var elemH = document.documentElement.clientHeight;
	  if(elemW <= 640) return;
	  var imgRatio = (image.height / image.width);       // original img ratio
	  var containerRatio = (elemH / elemW);     // container ratio

	  var finalHeight, finalWidth;
	  if (containerRatio > imgRatio) {
		finalHeight = elemH;
		finalWidth = (elemH / imgRatio);
	  } else {
		finalWidth = elemW;
		finalHeight = (elemW * imgRatio);
	  }
	  return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
	};
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('Spartan.theme')
	  .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
	return angular.extend({}, baPanel, {
	  link: function(scope, el, attrs) {
		el.addClass('panel panel-white');
		if (attrs.baPanelClass) {
		  el.addClass(attrs.baPanelClass);
		}
	  }
	});
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Spartan.theme.components')
	  .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
	var jqWindow = $(window);
	return {
	  restrict: 'E',
	  templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
	  controller: 'BaSidebarCtrl',
	  link: function(scope, el) {

		scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
		jqWindow.on('click', _onWindowClick);
		jqWindow.on('resize', _onWindowResize);

		scope.$on('$destroy', function() {
		  jqWindow.off('click', _onWindowClick);
		  jqWindow.off('resize', _onWindowResize);
		});

		function _onWindowClick($evt) {
		  if (!baUtil.isDescendant(el[0], $evt.target) &&
			  !$evt.originalEvent.$sidebarEventProcessed &&
			  !baSidebarService.isMenuCollapsed() &&
			  baSidebarService.canSidebarBeHidden()) {
			$evt.originalEvent.$sidebarEventProcessed = true;
			$timeout(function () {
			  baSidebarService.setMenuCollapsed(true);
			}, 10);
		  }
		}

		// watch window resize to change menu collapsed state if needed
		function _onWindowResize() {
		  var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
		  var newMenuHeight = _calculateMenuHeight();
		  if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
			scope.$apply(function () {
			  scope.menuHeight = newMenuHeight;
			  baSidebarService.setMenuCollapsed(newMenuCollapsed)
			});
		  }
		}

		function _calculateMenuHeight() {
		  return el[0].childNodes[0].clientHeight - 84;
		}
	  }
	};
  }

})();

(function () {
    'use strict';
    angular.module('Spartan.theme.components').provider('baSidebarService', baSidebarServiceProvider);
    /** @ngInject */
    function baSidebarServiceProvider() {
        var staticMenuItems = [];
        this.addStaticItem = function () {
            staticMenuItems.push.apply(staticMenuItems, arguments);
        };
        /** @ngInject */
        this.$get = function ($state, layoutSizes, $filter, $timeout,$rootScope, authService) {
            return new _factory();

            function _factory() {
                var isMenuCollapsed = false;
                //var isMenuCollapsed = shouldMenuBeCollapsed();
                this.getMenuItems = function () {
                    var states = defineMenuItemStates();
                    var menuItems = states.filter(function (item) {
                        if(item.accessControl){
                            if(authService.can(item.accessControl)){
                                return item.level == 0;
                            }
                        }else{
                            return item.level == 0;
                        }
                        
                    });
                    menuItems.forEach(function (item) {
                        $timeout(function () {
                            item.titleTranslated = $filter('i18n')(item.title);
                        }, 1500)
                        var children = states.filter(function (child) {
                            return child.level == 1 && child.name.indexOf(item.name) === 0;
                        });
                        if(children.length){
                            var ch = [];
                            for(var i = 0; i < children.length; i++){
                                if(children[i].accessControl){
                                    if(authService.can(children[i].accessControl)){
                                        ch.push(children[i]);
                                    }
                                }else{
                                    ch.push(children[i]);
                                }
                            }

                            item.subMenu = ch;
                        }else{
                            item.subMenu = null;
                        }

                        //item.subMenu = children.length ? children : null;
                    });
                    return menuItems.concat(staticMenuItems);
                };
                this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
                this.canSidebarBeHidden = canSidebarBeHidden;
                this.setMenuCollapsed = function (isCollapsed) {
                    isMenuCollapsed = isCollapsed;
                     $rootScope.$broadcast('menu_collapsed');
                };
                this.isMenuCollapsed = function () {
                    return isMenuCollapsed;
                };
                this.toggleMenuCollapsed = function () {
                    isMenuCollapsed = !isMenuCollapsed;
                      $rootScope.$broadcast('menu_collapsed');
                };
                this.getAllStateRefsRecursive = function (item) {
                    var result = [];
                    _iterateSubItems(item);
                    return result;

                    function _iterateSubItems(currentItem) {
                        currentItem.subMenu && currentItem.subMenu.forEach(function (subItem) {
                            subItem.stateRef && result.push(subItem.stateRef);
                            _iterateSubItems(subItem);
                        });
                    }
                };

                function defineMenuItemStates() {
                    return $state.get().filter(function (s) {
                        return s.sidebarMeta;
                    }).map(function (s) {
                        var meta = s.sidebarMeta;
                        return {
                            name: s.name
                            , title: s.title
                            , level: (s.name.match(/\./g) || []).length
                            , order: meta.order
                            , icon: meta.icon
                            , img: meta.img
                            , imgLarge: meta.imgLarge
                            , stateRef: s.name
                            , titleTranslated: s.title
							, fixedHref: s.fixedHref
                            , accessControl: meta.accessControl
                        };
                    }).sort(function (a, b) {
                        return (a.level - b.level) * 100 + a.order - b.order;
                    });
                }

                function shouldMenuBeCollapsed() {
                    return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
                }

                function canSidebarBeHidden() {
                    return window.innerWidth <= layoutSizes.resWidthHideSidebar;
                }
            }
        };
    }
})();

(function () {
	'use strict';

	angular.module('Spartan.theme.components').controller('BaSidebarCtrl', BaSidebarCtrl);

	/** @ngInject */
	function BaSidebarCtrl($scope, baSidebarService, toastr, $filter) {
		$scope.menuItems = baSidebarService.getMenuItems();
		$scope.defaultSidebarState = $scope.menuItems[0].stateRef;

		$scope.hoverItem = function ($event) {
			$scope.showHoverElem = true;
			$scope.hoverElemHeight = $event.currentTarget.clientHeight;
			var menuTopValue = 66;
			$scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
		};

		$scope.showToastr = function () {
			toastr.error($filter('i18n')('_toastr_access_denied_insights_message_'), $filter('i18n')('_toastr_access_denied_insights_'));
		};

		/*$scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
			if (fromState && !fromState.abstract) {
				baSidebarService.setMenuCollapsed(true);
			}
		});*/

		$scope.$on('user_settings_changed', function (event, data) {
			for (var i = 0; i < $scope.menuItems.length; i++) {
				$scope.menuItems[i].titleTranslated = $filter('i18n')($scope.menuItems[i].title);
			}
		});
	}
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('Spartan.theme.components')
	  .directive('baSidebarToggleMenu', baSidebarToggleMenu)
	  .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
	  .directive('baSidebarTogglingItem', baSidebarTogglingItem)
	  .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
	  .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
	  .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
	return {
	  restrict: 'A',
	  link: function(scope, elem) {
		elem.on('click', function($evt) {
		  $evt.originalEvent.$sidebarEventProcessed = true;
		  scope.$apply(function() {
			baSidebarService.toggleMenuCollapsed();
		  });
		});
	  }
	};
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
	return {
	  restrict: 'A',
	  link: function(scope, elem) {
		elem.on('click', function($evt) {
		  $evt.originalEvent.$sidebarEventProcessed = true;
		  if (!baSidebarService.isMenuCollapsed()) {
			scope.$apply(function() {
			  baSidebarService.setMenuCollapsed(true);
			});
		  }
		});
	  }
	};
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
	return {
	  restrict: 'A',
	  controller: 'BaSidebarTogglingItemCtrl'
	};
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
	var vm = this;
	var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
	if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
	  vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
	  vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

	  var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

	  vm.$expand = function() {
		vm.$$expandSubmenu();
		$element.addClass('ba-sidebar-item-expanded');
	  };

	  vm.$collapse = function() {
		vm.$$collapseSubmenu();
		$element.removeClass('ba-sidebar-item-expanded');
	  };

	  vm.$toggle = function() {
		$element.hasClass('ba-sidebar-item-expanded') ?
			vm.$collapse() :
			vm.$expand();
	  };

	  if (_isState($state.current)) {
		$element.addClass('ba-sidebar-item-expanded');
	  }

	  $scope.$on('$stateChangeStart', function (event, toState) {
		if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
		  vm.$collapse();
		  $element.removeClass('ba-sidebar-item-expanded');
		}
	  });

	  $scope.$on('$stateChangeSuccess', function (event, toState) {
		if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
		  vm.$expand();
		  $element.addClass('ba-sidebar-item-expanded');
		}
	  });
	}

	function _isState(state) {
	  return state && subItemsStateRefs.some(function(subItemState) {
			return state.name.indexOf(subItemState) == 0;
		  });
	}
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
	return {
	  restrict: 'A',
	  require: '^baSidebarTogglingItem',
	  link: function(scope, el, attrs, baSidebarTogglingItem) {
		baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
		baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
	  }
	};
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
	return {
	  restrict: 'A',
	  require: '^baSidebarTogglingItem',
	  link: function(scope, el, attrs, baSidebarTogglingItem) {
		el.on('click', function() {
		  if (baSidebarService.isMenuCollapsed()) {
			// If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
			// This should not affect mobiles, because on mobiles sidebar should be hidden at all
			scope.$apply(function() {
			  baSidebarService.setMenuCollapsed(false);
			});
			baSidebarTogglingItem.$expand();
		  } else {
			baSidebarTogglingItem.$toggle();
		  }
		});
	  }
	};
  }

})();

(function() {
  'use strict';

  angular.module('Spartan.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl',

    }
  }
})();

(function () {
    'use strict';

    angular.module('Spartan.theme.components')
        .controller('baWizardCtrl', baWizardCtrl);

    /** @ngInject */
    function baWizardCtrl($scope) {
        var vm = this;
        vm.tabs = [];

        vm.tabNum = 0;
        vm.progress = 0;

        vm.addTab = function (tab) {
            tab.setPrev(vm.tabs[vm.tabs.length - 1]);
            vm.tabs.push(tab);
            vm.selectTab(0);
        };

        $scope.$watch(angular.bind(vm, function () {
            return vm.tabNum;
        }), calcProgress);

        vm.selectTab = function (tabNum) {
            var oneNotAvailable = false;
            vm.tabs[vm.tabNum].submit();
            for (var i = 0; i < tabNum + 1; i++) {
                if (!vm.tabs[i].isAvailiable()) {
                    oneNotAvailable = true;
                }
            }
            if (!oneNotAvailable) {
                vm.tabNum = tabNum;
                vm.tabs.forEach(function (t, tIndex) {
                    tIndex == vm.tabNum ? t.select(true) : t.select(false);
                });
            }
        };

        vm.isFirstTab = function () {
            return vm.tabNum == 0;
        };

        vm.isLastTab = function () {
            return vm.tabNum == vm.tabs.length - 1;
        };

        vm.nextTab = function () {
            vm.selectTab(vm.tabNum + 1);
        };

        vm.previousTab = function () {
            vm.selectTab(vm.tabNum - 1);
        };

        function calcProgress() {
            vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
        }

        $scope.$on('select_pen_tab', function(event, data){
            vm.selectTab(data);
        });
    }
})();
(function() {
  'use strict';

  angular.module('Spartan.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();


(function () {
	'use strict';
	angular.module('Spartan.theme.components').controller('browserMessageCtrl', browserMessageCtrl);
	/** @ngInject */
	function browserMessageCtrl($timeout) {
		var bm = this;
		bm.show = false;
		bm.showButton = true;
		bm.ok = ok;
		init();


		function init(){
			var userLang = navigator.language || navigator.userLanguage;
			userLang = userLang.toLowerCase();
			var useNl = false;
			console.log(userLang);
			if(userLang.indexOf('nl') != -1){
				useNl = true;
			}

			var parser = new UAParser();
			var browser = parser.getResult().browser;
			var device = parser.getDevice().type;
			var os = parser.getOS().name;
			bm.message;

			if(!device){
				if(browser.name == "Chrome"){
				if(browser.major < 83){
					if(useNl){
						bm.message =  "We hebben vastgesteld dat u de oude Chrome-versie gebruikt. Update naar de nieuwste versie voor de beste ervaring."
					}else{
						bm.message = "We detected that you are using old Chrome version, please update to latest for best experience."
					}

					bm.show = true;
				}
			}else if(browser.name == "Firefox"){
				if(browser.major < 77){
					if(useNl){
						bm.message = "We hebben vastgesteld dat u de oude Firefox-versie gebruikt. Update naar de nieuwste versie voor de beste ervaring."
					}else{
						bm.message = "We detected that you are using old Firefox version, please update to latest for best experience."
					}

					bm.show = true;
				}
			}else if(browser.name == "Edge"){
				if(browser.major < 83){
					if(useNl){
						bm.message = "We hebben vastgesteld dat u de oude Edge-versie gebruikt. Update naar de nieuwste versie voor de beste ervaring."
					}else{
						bm.message = "We detected that you are using old Edge version, please update to latest for best experience."
					}


					bm.show = true;
				}
			}else if(browser.name == "IE"){
				bm.showButton = false;
				if(useNl){
					bm.message = "We hebben vastgesteld dat u de browser Internet Explorer gebruikt. Gebruik een van de moderne browsers zoals Chrome, Edge of Firefox om deze applicatie zonder fouten te kunnen gebruiken."
				}else{
					bm.message = "We detected that you are using Internet Explorer browser, please use one of the modern browsers like Chrome, Edge or Firefox, to be able to use this application without errors."
				}

					bm.show = true;
			}else if(browser.name == "Opera"){
				if(browser.major < 68){
					if(useNl){
						bm.message = "We hebben vastgesteld dat u de oude Opera-versie gebruikt. Update naar de nieuwste versie voor de beste ervaring."
					}else{
						bm.message = "We detected that you are using old Opera version, please update to latest for best experience."
					}

					bm.show = true;
				}
			}else if(browser.name == "Safari"){
				if(os != "Mac OS"){
					if(useNl){
						bm.message = "We hebben gedetecteerd dat u de Safari-browser gebruikt. Gebruik een van de moderne browsers zoals Chrome, Edge of Firefox om deze applicatie zonder fouten te kunnen gebruiken."
					}else{
						bm.message = "We detected that you are using Safari browser, please use one of the modern browsers like Chrome, Edge or Firefox, to be able to use this application without errors."
					}

					bm.showButton = false;
					bm.show = true;
				}else{
					if(useNl){
						bm.message = "We hebben vastgesteld dat u de Safari-browser gebruikt. Als u ongebruikelijke fouten tegenkomt, overweeg dan om Chrome als browser te gebruiken."
					}else{
						bm.message = "We detected that you are using Safari browser, if you experience any unusual errors please consider using Chrome as a browser."
					}

					bm.show = true;
				}
			}else{
				if(useNl){
					bm.message = "We hebben geconstateerd dat u niet een van de meest populaire browsers gebruikt. Gebruik een van de moderne populaire browsers zoals Chrome, Edge of Firefox voor de beste ervaring en om deze applicatie zonder fouten te kunnen gebruiken."
				}else{
					bm.message = "We detected that you are not using one of the most popular browsers, please use one of the modern popular browsers like Chrome, Edge or Firefox for best experience and to be able to use this application without errors."
				}

					bm.show = true;
			}
			}else{
				if(useNl){
					bm.message = "Gebruik een desktop of laptop voor de beste ervaring."

				}else{
					bm.message = "Please use desktop or laptop for best experience."

				}
				var checkBrowserId = document.getElementById("browser-id");
			   	document.getElementsByTagName("html")[0].setAttribute("browserTrue",true);
			   	checkBrowserId.setAttribute("aria-hidden","false");
			   	setTimeout(function(){
					checkBrowserId.focus();
		   		},400);
				bm.show = true;
			}

		}

		function ok(){
			bm.show = false;
				var checkBrowserId = document.getElementById("browser-id");
				document.getElementsByTagName("html")[0].setAttribute("browserTrue",false);
				checkBrowserId.setAttribute("aria-hidden","true");
				setTimeout(function(){
					checkBrowserId.focus();
				},400);
		}



	}
})();


(function () {
	'use strict';

	angular.module('Spartan.theme.components')
		.directive('browserMessage', browserMessage);

	/** @ngInject */
	function browserMessage($location, $state) {
		return {
			restrict: 'E',
			controller: 'browserMessageCtrl',
			controllerAs: 'bm',
			templateUrl: 'app/theme/components/browserMessage/browserMessage.html'
		};
	}

})();

(function () {
    'use strict';
    angular.module('Spartan.theme.components').controller('contentTopCtrl', contentTopCtrl);
    /** @ngInject */
    function contentTopCtrl($state, $rootScope, $scope, $filter) {
        var vm = this;
        vm.addClass = addClass;
        vm.showDashboardState = showDashboardState;
        vm.activeCategorySelected = activeCategorySelected;
        vm.showSelectedDashboard = showSelectedDashboard;
        vm.timeSelectorChanged = timeSelectorChanged;
        vm.goToParent = goToParent;
        vm.checkCustomTitles = checkCustomTitles;
        vm.goToCustomState = goToCustomState;
        vm.checkCustomParentTitles = checkCustomParentTitles;
        vm.goToCustomParentState = goToCustomParentState;

        function addClass() {
            if ($state.current.name == 'insights') {
                return 'al-title-hover'
            } else {
                return '';
            }
        }
        vm.activePageSelected = activePageSelected;

        function activePageSelected() {
            if ($state.current.name == 'insights') {
                $rootScope.$broadcast('dashboards_back');
                vm.selectedDashboard = null;
                vm.category = null;
            }
        }

        function checkCustomTitles() {
            var use_custom = JSON.parse(localStorage.getItem('from_recipe'));
            if ($state.current.name == 'rations.addnewration' || $state.current.name == 'pens.editPen' || $state.current.name == 'pens.addNewPen') {
                if (use_custom && use_custom.type == 'add') {
                    vm.custom_state = $filter('i18n')('_m_f_menu_recipes_add_new_recipe_');
                } else if (use_custom && use_custom.type == 'edit') {
                    vm.custom_state = $filter('i18n')('_m_f_menu_recipes_edit_recipe_');
                }
                vm.hide_parent = true;
            } else {
                vm.custom_state = null;
                vm.hide_parent = false;
            }
            if (use_custom && ($state.current.name == 'rations.addnewration' || $state.current.name == 'pens.editPen' || $state.current.name == 'pens.addNewPen')) {
                return true;
            } else {
                vm.hide_parent = false;
                return false;
            }
        }

        function checkCustomParentTitles() {
            var use_custom = JSON.parse(localStorage.getItem('from_recipe'));
            if (use_custom && use_custom.type == 'edit') {
                vm.custom_parent_state = $filter('i18n')('_m_f_menu_recipes_my_recipes_');
            } else {
                vm.custom_parent_state = null;
            }
            if (use_custom && use_custom.type == 'edit') {
                return true;
            } else {
                return false;
            }
        }

        function goToCustomParentState() {
            var custom_type = JSON.parse(localStorage.getItem('from_recipe'));
            if (custom_type && custom_type.type == 'edit') {
                localStorage.removeItem('from_recipe');
                $state.go('recipes.myRecipes')
            }
        }

        function goToCustomState() {
            var custom_type = JSON.parse(localStorage.getItem('from_recipe'));
            if (custom_type && custom_type.type == 'add') {
                $state.go('recipes.addNewRecipe');
            } else if (custom_type && custom_type.type == 'edit') {
                $state.go('recipes.editRecipe', {
                    uuid: custom_type.uuid
                })
            }
        }

        function goToParent(parent) {
            if (parent.state) {
                $state.go(parent.state);
            }
        }

        function activeCategorySelected() {
            $rootScope.$broadcast('category_back', vm.category);
            vm.selectedDashboard = null;
        }

        function showDashboardState() {
            if ($state.current.name == 'insights') {
                if (vm.category) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }

        function timeSelectorChanged(time) {
            $rootScope.$broadcast('time_selector_changed', time);
        }

        function showSelectedDashboard() {
            if (vm.selectedDashboard && $state.current.name == 'insights') {
                return true;
            } else {
                return false;
            }
        }

        $scope.$on('category_selected', function (event, data) {
            if (data) {
                vm.category = data;
            } else {
                vm.category = null;
            }
        })
        
        $scope.$on('dashboard_selected', function (event, data) {
            if (data) {
                vm.selectedTime = data.selectedTime;
                vm.selectedDashboard = data.title;
            } else {
                vm.selectedDashboard = null;
            }
        })
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Spartan.theme.components')
        .directive('contentTop', contentTop);

    /** @ngInject */
    function contentTop($location, $state) {
        return {
            restrict: 'E',
            controller: 'contentTopCtrl',
            controllerAs: 'vm',
            templateUrl: 'app/theme/components/contentTop/contentTop.html',
            link: function ($scope) {
                $scope.$watch(function () {
                    $scope.activePageTitle = $state.current.title;
                    $scope.activePageParentData = $state.current.parent_data
                });
            }
        };
    }
})();
(function () {
	'use strict';
	angular.module('Spartan.theme.components').controller('cookiePolicyCtrl', cookiePolicyCtrl);
	/** @ngInject */
	function cookiePolicyCtrl($timeout, $cookies, $state,$uibModal, $uibModalStack, $scope, cookiesService) {

		var vm = this;
		var cookie_name = 'cookies_accepted';

		vm.acceptCookies = acceptCookies;
		vm.openPrivacyPolicy = openPrivacyPolicy;
		vm.closePrivacyPolicy = closePrivacyPolicy;


		init();


		function init(){
			vm.showPrivacyPolicyText = false;
			$timeout(function(){
				var cookie = $cookies.get(cookie_name);
				if(!cookie){
				   vm.showCookiePolicyMessage = true;
				}
			},1000);
		}

		function acceptCookies(){
			vm.showCookiePolicyMessage = false;
			vm.showPrivacyPolicyText = false;
			var expireDate = new Date();
			expireDate.setYear(expireDate.getFullYear() + 1);
			cookiesService.setCookie(cookie_name, true, {
					samesite: "strict",
					expires: expireDate
				})
		}

		function openPrivacyPolicy(){
		   vm.showPrivacyPolicyText = true;
		}

		function closePrivacyPolicy(){
			vm.showPrivacyPolicyText = false;
		}

	}
})();

(function () {
	'use strict';

	angular.module('Spartan.theme.components')
		.directive('cookiePolicy', cookiePolicy);

	/** @ngInject */
	function cookiePolicy($location, $state) {
		return {
			restrict: 'E',
			controller: 'cookiePolicyCtrl',
			controllerAs: 'vm',
			templateUrl: 'app/theme/components/cookiePolicy/cookiePolicy.html'
		};
	}

})();

(function () {
	'use strict';
	angular.module('Spartan.theme.components').controller('errorHandlingCtrl', errorHandlingCtrl);
	/** @ngInject */
	function errorHandlingCtrl($scope, $rootScope, $timeout, toastr, $filter, $state) {
		var er = this;
		er.dismiss = dismiss;
		er.onBlur = onBlur;
		er.reloadApis = reloadApis;

		init();

		function init() {
			er.showError = false;
		}

		function dismiss() {
			er.showError = false;
			$rootScope.$broadcast('show_main_view', true);
		}

		function onBlur() {
			if (!er.isInit) {
				er.showError = false;
				$rootScope.$broadcast('show_main_view', true);
			}
		}

		function reloadApis() {
			er.showError = false;
			$rootScope.$broadcast('show_main_view', true);
			$rootScope.$broadcast('reload_apis');
		}

		function focusElement() {
			if (er.counter > 0) {
				var el = document.getElementById('error-handling');
				if (el) {
					el.focus();
				} else {
					$timeout(function () {
						focusElement();
					}, 100);
				}
			}
			er.counter--;
		}

		$scope.$on('error_handling', function (event, data) {
			er.isInit = data.init;
			er.showError = data.show;
			er.errorMessage = data.message;
			er.exception = data.exception;
			er.counter = 10;
			if (er.exception && er.exception.status) {
				if (er.exception.status === 401) {
					er.isInit = false;
					er.showError = false;
					if ($state.current.name !== 'login') {
						toastr.clear();
						toastr.warning($filter('i18n')('_error_message_401_status_'));
					}
				} else if (er.exception.status === 403 && er.errorMessage !== '_error_occurred_setting_default_herd_') {
					er.errorMessage = '_error_message_403_status_';
				} else if (er.exception.status === 403 && er.errorMessage === '_error_occurred_setting_default_herd_') {
					er.errorMessage = '_error_occurred_setting_default_herd_';
				} else if (er.exception.status === 404) {
					er.errorMessage = '_error_message_404_status_';
				}
			}
			if (er.isInit) {
				$rootScope.$broadcast('show_main_view', false);
			}
			focusElement();
		});

		$scope.$on('$stateChangeSuccess', function stateChange() {
			dismiss();
		});
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.theme.components').directive('errorHandling', errorHandling);
	/** @ngInject */
	function errorHandling() {
		return {
			restrict: 'E',
			controller: 'errorHandlingCtrl',
			controllerAs: 'er',
			templateUrl: 'app/theme/components/errorHandling/errorHandling.html'
		}
	}
})();
(function () {
	'use strict';
	angular.module('Spartan.theme.components').factory('errorService', errorService);
	/** @ngInject */
	function errorService($rootScope, $timeout) {
		return {
			showErrorMessage: showErrorMessage
		};

		function showErrorMessage(exception, show, message, init) {
			$timeout(function () {
				$rootScope.$broadcast('error_handling', {
					exception: exception,
					show: show,
					message: message,
					init: init
				});
			}, 300);
		}
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.theme.components').directive('loadingSpinner', loadingSpinner);

	/** @ngInject */
	function loadingSpinner($timeout) {
		return {
			restrict: 'AE',
			templateUrl: 'app/theme/components/loadingSpinner/loadingSpinner.html'
		};
	}
})();

(function () {
	'use strict';

	angular.module('Spartan.theme.components').directive('loadingSpinnerLarge', loadingSpinnerLarge);

	/** @ngInject */
	function loadingSpinnerLarge($timeout) {
		return {
			restrict: 'AE',
			templateUrl: 'app/theme/components/loadingSpinner/loadingSpinnerLarge.html'
		};
	}
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
	'use strict';
	angular.module('Spartan.theme.components').directive('msgCenter', msgCenter);
	/** @ngInject */
	function msgCenter() {
		return {
			restrict: 'E'
			, templateUrl: 'app/theme/components/msgCenter/msgCenter.html'
			, controller: 'MsgCenterCtrl'
		};
	}
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Spartan.theme.components')
	  .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
  }
})();

(function () {
	'use strict';
	angular.module('Spartan.theme.components').controller('offlineMessageCtrl', offlineMessageCtrl);
	/** @ngInject */
	function offlineMessageCtrl() {

		var vm = this;
		init();

		function init(){}

	}
})();

(function () {
	'use strict';

	angular.module('Spartan.theme.components')
		.directive('offlineMessage', offlineMessage);

	/** @ngInject */
	function offlineMessage() {
		return {
			restrict: 'E',
			controller: 'offlineMessageCtrl',
			controllerAs: 'vm',
			templateUrl: 'app/theme/components/offline-message/offlineMessage.html'
		};
	}

})();

angular.module('Spartan.theme.components').directive('focus', function($timeout, $parse) {
	  return {
		link: function(scope, element, attrs) {
		  var model = $parse(attrs.focus);
		  scope.$watch(model, function(value) {
			if(value === true) {
			  $timeout(function() {
				element[0].focus();
			  });
			}
		  });
		}
	  };
	});

(function () {
	'use strict';
	angular.module('Spartan.theme.components').controller('pageTopCtrl', pageTopCtrl);
	/** @ngInject */
	function pageTopCtrl($state, $window, $filter, $scope, pageTopFactory, $timeout, toastr, $rootScope, authManager, errorService, authService, APP_CONST, dataServiceFactory, cookiesService, auth0Service, $uibModal, $uibModalStack) {
		var vm = this;
		var herdKW;
		var teamKW;
		vm.logout = logout;
		vm.redirect = redirect;
		vm.searchItem = searchItem;
		vm.onEnter = onEnter;
		vm.focus = focus;
		vm.selectItem = selectItem;
		vm.outOfFocus = outOfFocus;
		vm.selectTeam = selectTeam;
		vm.selectHerd = selectHerd;
		vm.deselectHerd = deselectHerd;
		vm.closeModal = closeModal;
		vm.clicked = false;
		vm.teamsLoaded = false;
		vm.herdsLoaded = false;
		vm.loadingSelectTeam = false;
		init();
		vm.teams = [];
		vm.splitedText = [];
		vm.loadingTeams = false;
		vm.loadingHerds = false;

		function init() {
			vm.searchPlaceholder = $filter('i18n')('_placeholder_search_for_');
			vm.herd_placeholder = $filter('i18n')('_search_placeholder_herd_name_');
			vm.team_placeholder = $filter('i18n')('_search_placeholder_team_name_');
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.feedTeams = authService.teams;
			setUserImage();
			getTeamsByUser();
			checkStateAccess();
			$timeout(function () {
				checkState($state.current);
			}, 1000);
		}

		function checkState(state) {
			if (state.disable_herd_selector) {
				vm.disableTeamHerd = true;
			} else {
				vm.disableTeamHerd = false;
			}
		}

		function checkStateAccess() {
			var toState = JSON.parse(localStorage.getItem('toState'));
			if (toState) {
				var accessPermissionsList = APP_CONST.constants.statesAccessList;
				var accessPermission;
				for (var i = 0; i < accessPermissionsList.length; i++) {
					if (accessPermissionsList[i].state == toState.name) {
						accessPermission = accessPermissionsList[i];
						break;
					}
				}
				if (accessPermission && authService.can(accessPermission.accessControl)) {
					if (toState.param) {
						$state.go(toState.name, toState.param);
					} else {
						$state.go(toState.name);
					}
				} else {
					$state.go('dashboard');
				}
				localStorage.removeItem('toState');
			}
		}

		function selectTeam(team, withoutBroadcast) {
			vm.teamSelectorIsOpenPT = false;
			vm.textFilter = '';
			resetColors();
			vm.selectedHerd = null;
			vm.selectedTeam = team;
			setDefaultTeam(team, withoutBroadcast);
		}

		function selectHerd(herd, withoutBroadcast) {
			vm.herdSelectorIsOpenPT = false;
			vm.textFilterHerd = '';
			resetColors();
			vm.lastSelectedHerd = angular.copy(vm.selectedHerd);
			vm.selectedHerd = herd;
			setDefaultHerd(herd, withoutBroadcast);
		}

		function setUserImage() {
			var user = JSON.parse(localStorage.getItem('user_profile'));
			if (user && user.picture) {
				vm.userImage = user.picture;
			} else {
				vm.userImage = $filter('profilePicture')('Avatar');
			}
		}

		function logout() {
			auth0Service.handleUnauthorized(100);
		}

		function redirect(state) {
			$state.go(state);
		}

		function searchItem() {
			if (!teamKW) {
				teamKW = $filter('i18n')('_search_team_');
			}
			if (!herdKW) {
				herdKW = $filter('i18n')('_search_herd_');
			}
			vm.splitedText = vm.text.split(':');
			if (vm.splitedText.length == 2) {
				if (vm.splitedText[0].toLowerCase().trim() == teamKW.toLowerCase()) {
					var list = [];
					for (var i = 0; i < vm.teams.length; i++) {
						if (vm.teams[i].Name.toLowerCase().search(vm.splitedText[1].toLowerCase().trim()) > -1) {
							list.push(vm.teams[i]);
						}
					}
					for (var j = 0; j < list.length; j++) {
						list[j].active = false;
					}
					list = $filter('orderBy')(list, 'Name');
					vm.items = list;
					if (vm.items.length > 0) {
						vm.items[0].active = true;
					}
					$scope.show = 'block';
					scrollListToTop();
				} else {
					$scope.show = 'none';
					vm.items = [];
				}
			} else if (vm.splitedText.length == 4) {
				if (vm.splitedText[2].toLowerCase().trim() == herdKW.toLowerCase()) {
					var list = [];
					for (var i = 0; i < vm.herds.length; i++) {
						if (vm.herds[i].Name.toLowerCase().search(vm.splitedText[3].toLowerCase().trim()) > -1) {
							list.push(vm.herds[i]);
						}
					}
					for (var i = 0; i < list.length; i++) {
						list[i].active = false;
					}
					list = $filter('orderBy')(list, 'Name');
					vm.items = list;
					if (vm.items.length > 0) {
						vm.items[0].active = true;
					}
					$scope.show = 'block';
					scrollListToTop();
				} else {
					$scope.show = 'none';
					vm.items = [];
				}
			} else {
				$scope.show = 'none';
				vm.items = [];
			}
		}

		function scrollListToTop() {
			$timeout(function () {
				try {
					document.querySelector('.dropdown-menu').scrollTop = 0;
				} catch (e) { }
			}, 100);
		}

		function getTeamsByUser() {
			return pageTopFactory
				.getTeamsByUser()
				.then(function (response) {
					response = $filter('orderBy')(response, 'Name');
					vm.teams = [];

					for (var i = 0; i < response.length; i++) {
						for (var j = 0; j < vm.feedTeams.length; j++) {
							if (response[i].Id == vm.feedTeams[j].id) {
								vm.teams.push(response[i]);
							}
						}
					}
					if (vm.teams.length) {
						vm.teamsLoaded = true;
						checkDefaultTeam(vm.settings, vm.teams);
					} else {
						logout();
					}
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_teams_', true);
				});
		}

		function checkDefaultTeam(sett, teams) {
			for (var i = 0; i < teams.length; i++) {
				if (sett.selectedTeam && sett.selectedTeam.id == teams[i].Id) {
					vm.selectedTeam = teams[i];
					//checkOrder(vm.selectedTeam.Id);
					cookiesService.setCookie('mmmooogle_tenant', vm.selectedTeam.Id, {
						samesite: 'lax',
						secure: true,
						domain: '.mmmooogle.com'
					});
				}
			}
			if (vm.selectedTeam) {
				checkDefaultHerd(vm.settings, vm.selectedTeam);
			}
		}

		function checkDefaultHerd(settings, team) {
			if (settings.selectedHerd) {
				return pageTopFactory
					.getHerdsByTeam(team.Id)
					.then(function (response) {
						response = $filter('orderBy')(response, 'Name');
						vm.herds = response;
						for (var i = 0; i < response.length; i++) {
							if (settings.selectedHerd.id == response[i].Id) {
								vm.selectedHerd = response[i];
								vm.lastSelectedHerd = angular.copy(vm.selectedHerd);
							}
						}
						vm.loadingHerds = false;
					})
					.catch(function (error) {
						vm.selectedHerd = null;
						console.log(error);
						errorService.showErrorMessage(error, true, '_error_occurred_loading_herds_', true);
					});
			}
		}

		function onEnter(event) {
			if (event.keyCode == 13 || event.keyCode == 9) {
				if (vm.items && vm.items.length > 0) {
					for (var i = 0; i < vm.items.length; i++) {
						if (vm.items[i].active) {
							selectItem(i);
							break;
						}
					}
				}
			}
			if (event.keyCode == 38) {
				if (vm.items && vm.items.length > 0) {
					for (var i = 0; i < vm.items.length; i++) {
						if (vm.items[i].active) {
							var previous = i - 1;
							if (vm.items[previous]) {
								vm.items[i].active = false;
								vm.items[previous].active = true;
								var id = 'item' + previous;
								var elem = document.getElementById(id);
								elem.scrollIntoView(true);
							}
							break;
						}
					}
					event.preventDefault();
					event.stopPropagation();
				}
			}
			if (event.keyCode == 40) {
				if (vm.items && vm.items.length > 0) {
					for (var i = 0; i < vm.items.length; i++) {
						if (vm.items[i].active) {
							var next = i + 1;
							if (vm.items[next]) {
								vm.items[i].active = false;
								vm.items[next].active = true;
								var id = 'item' + i;
								var elem = document.getElementById(id);
								elem.scrollIntoView(true);
							}
							break;
						}
					}
					event.preventDefault();
					event.stopPropagation();
				}
			}
		}

		function selectItem(index) {
			vm.clicked = true;
			if (vm.splitedText.length == 2) {
				vm.text = vm.splitedText[0] + ':' + vm.items[index].Name + ':';
				$scope.show = 'none';
				vm.loadingHerds = true;
				vm.loadingTeams = true;
				if (vm.settings.selectedTeam.id == vm.items[index].Id) {
					vm.loadingTeams = false;
					getHerdsByTeam(vm.items[index].Id);
				} else {
					setDefaultTeam(vm.items[index]);
					vm.selectedTeam = vm.items[index];
					vm.selectedHerd = null;
					getHerdsByTeam(vm.items[index].Id);
				}
			} else if (vm.splitedText.length == 4) {
				vm.text = vm.splitedText[0] + ':' + vm.splitedText[1] + ':' + vm.splitedText[2] + ':' + vm.items[index].Name;
				$scope.show = 'none';
				if (vm.settings.selectedHerd.id == vm.items[index].Id) {
					vm.text = '';
				} else {
					vm.selectedHerd = vm.items[index];
					setDefaultHerd(vm.items[index]);
				}
			}
		}

		function setDefaultTeam(team, withoutBroadcast) {
			vm.disableTeamHerd = true;
			vm.loadingSelectTeam = true;
			var user = JSON.parse(localStorage.getItem('user_profile'));
			var teamObj = {
				team_id: team.Id
			};
			vm.loadingHerds = true;
			return pageTopFactory
				.setDefaultTeamHerd(teamObj, user.email)
				.then(function (response) {
					vm.disableTeamHerd = false;
					localStorage.setItem('user_settings', JSON.stringify(response));
					vm.settings = response;
					vm.loadingTeams = false;
					if (!withoutBroadcast) {
						broadcastTeamSelected(team);
					}
					broadcastTeamHerdChanged();
					toastr.success($filter('i18n')('_toastr_default_team_selected_'));
					vm.loadingSelectTeam = false;
					cookiesService.setCookie('mmmooogle_tenant', team.Id, {
						samesite: 'lax',
						secure: true,
						domain: '.mmmooogle.com'
					});
					//checkOrder(team.Id);
					getHerdsByTeam(team.Id);
				})
				.catch(function (error) {
					vm.disableTeamHerd = false;
					errorService.showErrorMessage(error, true, '_error_occurred_changing_default_team_');
					if (error.status == 403) {
						for (var i = 0; i < vm.teams.length; i++) {
							if (vm.teams[i].Id == vm.settings.selectedTeam.id) {
								vm.selectedTeam = vm.teams[i];
								cookiesService.setCookie('mmmooogle_tenant', team.Id, {
									samesite: 'lax',
									secure: true,
									domain: '.mmmooogle.com'
								});
								break;
							}
						}
						if (vm.herds) {
							for (var j = 0; j < vm.herds.length; j++) {
								if (vm.herds[j].Id == vm.settings.selectedHerd.id) {
									vm.selectedHerd = vm.herds[j];
									break;
								}
							}
						}
						vm.loadingTeams = false;
						vm.loadingHerds = false;
						vm.loadingSelectTeam = false;
					}
				});
		}

		function getHerdsByTeam(teamId) {
			vm.loadingHerds = true;
			return pageTopFactory
				.getHerdsByTeam(teamId)
				.then(function (response) {
					response = $filter('orderBy')(response, 'Name');
					vm.herds = response;
					vm.loadingHerds = false;
				})
				.catch(function (error) {
					console.log(error);
					errorService.showErrorMessage(error, true, '_error_occurred_loading_herds_');
				});
		}

		function setDefaultHerd(herd, withoutBroadcast) {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			vm.disableTeamHerd = true;
			vm.setHerdLoading = true;
			if (withoutBroadcast) {
				broadcastTeamHerdChanged();
			}

			var herdObj = {
				herd_id: herd.Id
			};
			if (vm.settings.noSelectedTeam) {
				herdObj.team_id = vm.settings.selectedTeam.id;
			}
			return pageTopFactory
				.setDefaultTeamHerd(herdObj)
				.then(function (response) {
					vm.disableTeamHerd = false;
					vm.setHerdLoading = false;
					localStorage.setItem('user_settings', JSON.stringify(response));
					vm.settings = response;
					vm.text = '';
					toastr.success($filter('i18n')('_toastr_default_herd_selected_'));
					if (!withoutBroadcast) {
						broadcastHerdSelected(herd);
					}
				})
				.catch(function (error) {
					vm.disableTeamHerd = false;
					vm.setHerdLoading = false;
					errorService.showErrorMessage(error, true, '_error_occurred_setting_default_herd_');
					vm.selectedHerd = angular.copy(vm.lastSelectedHerd);
					if (error.status === 403) {
						vm.loadingTeams = false;
					}
				});
		}

		function deselectHerd(withoutBroadcast) {
			selectTeam(vm.selectedTeam, withoutBroadcast);
		}

		function resetColors() {
			var colors = dataServiceFactory.colors;
			for (var i = 0; i < colors.length; i++) {
				dataServiceFactory.colors[i].id = null;
			}
		}

		function focus() {
			if (!vm.loadingTeams && !vm.loadingHerds) {
				return true;
			} else {
				return false;
			}
		}

		function outOfFocus() {
			$timeout(function () {
				if (vm.clicked) {
					vm.clicked = false;
				} else {
					$scope.show = 'none';
				}
			}, 100);
		}

		function checkOrder(team_id) {
			return pageTopFactory
				.getOrdersByTeamId(team_id)
				.then(function (response) {

					var date = moment().add(1, 'month');
					var today = moment();

					var expired = [];
					var warning = [];

					for (var i = 0; i < response.length; i++) {
						if (response[i].ProductId == 11 || response[i].ProductId == 23) {
							if (response[i].EndDate) {
								if (moment(response[i].EndDate).isBefore(today)) {
									expired.push(response[i]);
								} else {
									if (moment(response[i].EndDate).isBefore(date)) {
										warning.push(response[i]);
									}
								}
							}

						}
					}

					vm.expired = expired;
					vm.warning = warning;
					if (expired.length || warning.length) {
						openModal('app/theme/components/pageTop/orders.modal.html', 'md');
					}

				})
				.catch(function (error) {
					console.log(error);
				});
		}

		function openModal(page, size) {
			return $uibModal.open({
				animation: true,
				templateUrl: page,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		$scope.$on('default_herd_from_dashboard_selected', function (event, herd) {
			vm.selectedHerd = null;
			for (var i = 0; i < vm.herds.length; i++) {
				if (herd == vm.herds[i].Id) {
					selectHerd(vm.herds[i], true);
				}
			}
		});

		$scope.$on('deselect_all_herds', function (event, herd) {
			deselectHerd(true);
		});

		$scope.$on('$stateChangeStart', function (event, toState) {
			checkState(toState);
		});

		$scope.$on('default_team_selected_from_herds', function (event, data) {
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
			selectTeam(data);
		});

		$scope.$on('default_herd_selected_from_herds', function (event, data) {
			vm.selectedHerd = data;
			vm.settings = JSON.parse(localStorage.getItem('user_settings'));
		});

		$scope.$on('new_herd', function (event, data) {
			if (vm.selectedTeam) {
				getHerdsByTeam(vm.selectedTeam.Id);
			}
		});

		$scope.$on('new_team', function (event, data) {
			getTeamsByUser();
		});

		$scope.$on('disable_herd_selector', function (event, data) {
			if (!data) {
				data = false;
			}
			vm.disableTeamHerd = data;
		});

		function broadcastTeamSelected(team) {
			if ($state.current.sidebarMeta && $state.current.sidebarMeta.accessControl && !authService.can($state.current.sidebarMeta.accessControl)) {
				$state.go('dashboard');
			}
			$rootScope.$broadcast('default_team_selected', team);
			$rootScope.$broadcast('update_sidebar');
		}

		function broadcastHerdSelected(herd) {
			$rootScope.$broadcast('default_herd_selected', herd);
		}

		function broadcastTeamHerdChanged() {
			$rootScope.$broadcast('default_team_herd_changed');
		}

		$scope.$on('reload_apis', function () {
			init();
		});
		$scope.$on('user_settings_changed', function () {
			vm.searchPlaceholder = $filter('i18n')('_placeholder_search_for_');
			vm.herd_placeholder = $filter('i18n')('_search_placeholder_herd_name_');
			vm.team_placeholder = $filter('i18n')('_search_placeholder_team_name_');
		});
		$scope.$on('remove_default_herd', function () {
			vm.selectedHerd = null;
		});
	}
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
	'use strict';
	angular.module('Spartan.theme.components').directive('pageTop', pageTop);
	/** @ngInject */
	function pageTop() {
		return {
			restrict: 'E'
			, templateUrl: 'app/theme/components/pageTop/pageTop.html'
			, controller: 'pageTopCtrl'
			, controllerAs: 'vm'
		};
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.theme.components').factory('pageTopFactory', pageTopFactory);
	/** @ngInject */
	function pageTopFactory(APP_CONST, $http, $q) {
		return {
			getTeamsByUser: getTeamsByUser,
			setDefaultTeamHerd: setDefaultTeamHerd,
			getHerdsByTeam: getHerdsByTeam,
			getKibanaDashboards: getKibanaDashboards,
			getTableauDashboards: getTableauDashboards,
            getOrdersByTeamId: getOrdersByTeamId
		};

		function getTeamsByUser() {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams')
				.then(success)
				.catch(error);
		}

		function setDefaultTeamHerd(obj, email) {
			var emailSuffix = '';
			if (email) {
				emailSuffix = emailSuffix + '?email=' + encodeURIComponent(email);
			}
			return $http
				.patch(APP_CONST.api_base_url + 'userSettings' + emailSuffix, obj)
				.then(success)
				.catch(error);
		}

		function getHerdsByTeam(id) {
			return $http
				.get(APP_CONST.api_base_url + 'backoffice/teams/' + id + '/herds')
				.then(success)
				.catch(error);
		}

		function getKibanaDashboards(team_id) {
			return $http
				.get('https://visuals.mmmooogle.com/api/v1/teams/' + team_id + '/dashboards', {
					withCredentials: true
				})
				.then(success)
				.catch(error);
		}

		function getTableauDashboards(team_id) {
			return $http
				.get('https://tabvis.mmmooogle.com/api/v1/teams/' + team_id + '/dashboards', {
					withCredentials: true
				})
				.then(success)
				.catch(error);
		}

        function getOrdersByTeamId(team_id){
            return $http
            .get(APP_CONST.api_base_url + 'backoffice/orders?TeamId=' + team_id)
				.then(success)
				.catch(error);
        }

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
	'use strict';

	angular.module('Spartan.theme.components')
		.directive('progressBarRound', progressBarRound);

	/** @ngInject */
	function progressBarRound(baProgressModal) {
		return {
			restrict: 'E',
			templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
			link:function($scope, element, attrs) {
				$scope.baProgressDialog = baProgressModal;
				$scope.$watch(function () {
					return baProgressModal.getProgress();
				}, animateBar);

				function animateBar() {
					var circle = element.find('#loader')[0];
					circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
					$scope.progress = baProgressModal.getProgress();
				}
			}
		}
	}
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Spartan.theme.components')
	  .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
	return {
	  restrict: 'EA',
	  scope: {
		ngModel: '='
	  },
	  templateUrl: 'app/theme/components/widgets/widgets.html',
	  replace: true
	};
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Spartan.theme')
	  .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
	return function(input) {
	  return layoutPaths.images.root + input;
	};
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
    'use strict';
  
    angular.module('Spartan.theme')
        .filter('flagImg', flagImg);
  
    /** @ngInject */
    function flagImg(layoutPaths) {
      return function(input) {
        return layoutPaths.images.root + 'flags/' + input;
      };
    }
  
  })();
  
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Spartan.theme')
	  .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
	return function(input) {
	  return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
	};
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Spartan.theme')
	  .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
	return function(input, ext) {
	  ext = ext || 'png';
	  return layoutPaths.images.profile + input + '.' + ext;
	};
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('Spartan.theme')
	.filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
	return function(text) {
	  return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
	};
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('Spartan.theme.inputs')
	  .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
	return {
	  templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
	  scope: {
		switcherStyle: '@',
		switcherValue: '='
	  }
	};
  }

})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.balanceRation').factory('batchReportService', batchReportService);
	/** @ngInject */
	function batchReportService($filter, $q, APP_CONST, unitConversionService) {
		var i18nFilter = $filter('i18n');

		return {
			exportBatchReport: exportBatchReport
		};

		function exportBatchReport(scope) {
			var vm = angular.copy(scope);
			var reportPromise = $q.defer();
			vm.batch.separatelyFeeds = [];
			vm.batch.togetherFeeds = [];
			vm.batch.dmi_adj = [];
			vm.ration.concentration_supplied = unitConversionService.convertData(vm.ration.concentration_supplied, ['bulkPercentToAmount', 'bulkKgToLb', 'bulkMcalToMjoule', 'bulkRoundValues'], 1);
			vm.ration.supply_amount = unitConversionService.convertData(vm.ration.supply_amount, ['bulkPercentToAmount', 'bulkKgToLb', 'bulkMcalToMjoule', 'bulkRoundValues'], 2);
			vm.ration.group.bw_without_fetus = unitConversionService.convertData(vm.ration.group.bw_without_fetus, ['kgToLb'], 1);
			vm.ration.group.target_milk_yield = unitConversionService.convertData(vm.ration.group.target_milk_yield, ['kgToLb'], 1);
			vm.ration.group.target_daily_bw_gain = unitConversionService.convertData(vm.ration.group.target_daily_bw_gain, ['kgToLb'], 1);
			angular.copy(vm.batch.feeds, vm.batch.togetherFeeds);
			for (var i = vm.batch.togetherFeeds.length - 1; i >= 0; i--) {
				vm.batch.togetherFeeds[i] = unitConversionService.convertData(vm.batch.togetherFeeds[i], ['bulkPercentToAmount', 'bulkKgToLb', 'bulkMcalToMjoule', 'bulkRoundValues'], 1);
				if (vm.batch.togetherFeeds[i].fed_separately) {
					vm.batch.separatelyFeeds.push(vm.batch.togetherFeeds[i]);
					vm.batch.togetherFeeds.splice(i, 1);
				}
			}
			vm.batch.separatelyFeeds.reverse();
			for (var i = 0; i < vm.batch.togetherFeeds.length; i++) {
				if (vm.settings.use_percent) {
					if (vm.batch.togetherFeeds[i].dm < 80) {
						vm.batch.dmi_adj.push(vm.batch.togetherFeeds[i]);
					}
				} else {
					if (vm.batch.togetherFeeds[i].dm < 800) {
						vm.batch.dmi_adj.push(vm.batch.togetherFeeds[i]);
					}
				}
			}
			vm.breeds = APP_CONST.mocks.breeds;
			for (var i = 0; i < vm.breeds.length; i++) {
				if (vm.breeds[i].value == vm.ration.group.breed) {
					vm.batch.breed = vm.breeds[i].name;
					break;
				}
			}
			vm.animal_types = APP_CONST.mocks.animal_types;
			for (var i = 0; i < vm.animal_types.length; i++) {
				if (vm.animal_types[i].type == vm.ration.group.type) {
					vm.batch.animal_type = vm.animal_types[i].name;
					break;
				}
			}
			var locationName = vm.batch.location_name ? vm.batch.location_name : '';
			vm.batch.diet_dmi = $filter('number')(vm.ration.concentration_supplied.amount_dm, 1);
			vm.batch.bw_without_fetus = $filter('number')(vm.ration.group.bw_without_fetus, 0);
			vm.batch.diet_dm = vm.ration.concentration_supplied.dm;
			vm.batch.diet_ndf = $filter('number')(vm.ration.supply_conc.ndf, 2);
			vm.batch.diet_cp = $filter('number')(vm.ration.supply_conc.cp, 2);
			var c1r1 = '';
			var c2r1 = '';
			var c3r1 = '';
			var c1r2 = '';
			var c2r2 = '';
			var c3r2 = '';
			var c1r3 = '';
			var c2r3 = '';
			var c3r3 = '';
			if (vm.ration.group.type == 'lactating_cow') {
				c1r1 = i18nFilter('_report_lactation_number_') + ':';
				c2r1 = vm.ration.group.lactation_number;
				c1r2 = i18nFilter('_groups_days_in_milk_') + ':';
				c2r2 = vm.ration.group.days_in_milk;
				c1r3 = i18nFilter('_groups_target_milk_yield_') + ':';
				c2r3 = $filter('number')(vm.ration.group.target_milk_yield, 1);
				c3r3 = vm.weight + '/' + i18nFilter('_unit_day_');
			} else if (vm.ration.group.type == 'drycow/late_pregnant_heifer') {
				c1r1 = i18nFilter('_report_upcoming_lactation_number_') + ':';
				c2r1 = vm.ration.group.upcoming_lactation_number;
				c1r2 = i18nFilter('_groups_days_to_calving_') + ':';
				c2r2 = vm.ration.group.days_to_calving;
				c1r3 = i18nFilter('_report_target_daily_gain_') + ':';
				c2r3 = $filter('number')(vm.ration.group.target_daily_bw_gain, 2);
				c3r3 = vm.weight + '/' + i18nFilter('_unit_day_');
			} else if (vm.ration.group.type == 'heifer') {
				c1r1 = i18nFilter('_report_target_daily_gain_') + ':';
				c2r1 = $filter('number')(vm.ration.group.target_daily_bw_gain, 2);
				c3r1 = vm.weight + '/' + i18nFilter('_unit_day_');
			}

			var NA = vm.batch.number_of_animals;
			var INA = vm.batch.number_of_animals - vm.batch.group_increment_number;
			var IINA = vm.batch.number_of_animals - 2 * vm.batch.group_increment_number;
			var IIINA = vm.batch.number_of_animals - 3 * vm.batch.group_increment_number;
			var IVNA = vm.batch.number_of_animals - 4 * vm.batch.group_increment_number;
			var NAI = vm.batch.number_of_animals + vm.batch.group_increment_number;
			var NAII = vm.batch.number_of_animals + 2 * vm.batch.group_increment_number;
			var NAIII = vm.batch.number_of_animals + 3 * vm.batch.group_increment_number;
			var NAIV = vm.batch.number_of_animals + 4 * vm.batch.group_increment_number;
			var T = 0;
			var IT = 0;
			var IIT = 0;
			var IIIT = 0;
			var IVT = 0;
			var TI = 0;
			var TII = 0;
			var TIII = 0;
			var TIV = 0;
			var dd = {
				pageOrientation: 'landscape',
				header: [
					{
						alignment: 'justify',
						style: 'headerStyle',
						columns: [
							{
								text: i18nFilter('_report_batch_'),
								margin: [45, 10, 0, 0],
								width: 300
							},
							{
								text: vm.batch.ration_name ? vm.batch.ration_name : '',
								margin: [0, 10, 0, 0],
								width: '*'
							},
							{
								text: $filter('date')(new Date(), 'shortDate'),
								bold: false,
								fontSize: 12,
								margin: [10, 12, 0, 0],
								width: 100
							}
						]
					}
				],
				footer: [
					{
						margin: [45, 0, 30, 10],
						table: {
							widths: ['auto'],
							body: [
								[
									{
										text: i18nFilter('_report_footer_feed_'),
										border: [false, false, false, false]
									}
								]
							]
						}
					}
				],
				content: [
					{
						table: {
							widths: [200, 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', '*'],
							body: [
								[
									{
										text: i18nFilter('_report_prepared_for_'),
										bold: true,
										alignment: 'left',
										colSpan: 8,
										border: [false, false, false, false]
									},
									{},
									{},
									{},
									{},
									{},
									{},
									{}
								],
								[
									{
										text: vm.preperedFor ? vm.preperedFor : '',
										alignment: 'left',
										rowSpan: 3,
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_report_location_') + ': ' + (locationName ? locationName : ''),
										alignment: 'left',
										colSpan: 6,
										bold: true,
										fontSize: 15,
										border: [false, false, false, false]
									},
									{},
									{},
									{},
									{},
									{},
									{
										text: '',
										alignment: 'left',
										border: [false, false, false, false]
									}
								],
								[
									{},
									{
										text: (vm.batch.breed ? vm.batch.breed : '') + ', ' + (vm.batch.animal_type ? vm.batch.animal_type : ''),
										alignment: 'left',
										colSpan: 3,
										border: [true, true, false, false]
									},
									{},
									{},
									{
										text: i18nFilter('_feeds_diet_dmi_') + ':',
										alignment: 'left',
										border: [true, true, false, false]
									},
									{
										text: vm.batch.diet_dmi ? vm.batch.diet_dmi : '',
										alignment: 'right',
										border: [false, true, false, false]
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										alignment: 'left',
										border: [false, true, true, false]
									},
									{
										text: '',
										alignment: 'left',
										border: [false, false, false, false]
									}
								],
								[
									{},
									{
										text: i18nFilter('_report_body_weight_without_fetus_') + ':',
										alignment: 'right',
										border: [true, false, false, false]
									},
									{
										text: vm.batch.bw_without_fetus ? vm.batch.bw_without_fetus : '',
										alignment: 'right',
										border: [false, false, false, false]
									},
									{
										text: vm.weight ? vm.weight : '',
										alignment: 'left',
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_report_diet_dm_') + ':',
										alignment: 'left',
										border: [true, false, false, false]
									},
									{
										text: vm.batch.diet_dm ? vm.batch.diet_dm : '',
										alignment: 'right',
										border: [false, false, false, false]
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										alignment: 'left',
										border: [false, false, true, false]
									},
									{
										text: '',
										alignment: 'left',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: i18nFilter('_report_prepared_by_'),
										alignment: 'left',
										bold: true,
										border: [false, false, false, false]
									},
									{
										text: c1r1,
										alignment: 'right',
										border: [true, false, false, false]
									},
									{
										text: c2r1,
										alignment: 'right',
										border: [false, false, false, false]
									},
									{
										text: c3r1,
										alignment: 'left',
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_report_diet_ndf_') + ':',
										alignment: 'left',
										border: [true, false, false, false]
									},
									{
										text: vm.batch.diet_ndf ? vm.batch.diet_ndf : '',
										alignment: 'left',
										border: [false, false, false, false]
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										alignment: 'left',
										border: [false, false, true, false]
									},
									{
										text: '',
										alignment: 'left',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: vm.preperedBy ? vm.preperedBy : '',
										alignment: 'left',
										rowSpan: 3,
										border: [false, false, false, false]
									},
									{
										text: c1r2 ? c1r2 : '',
										alignment: 'right',
										border: [true, false, false, false]
									},
									{
										text: c2r2 ? c2r2 : '',
										alignment: 'right',
										border: [false, false, false, false]
									},
									{
										text: c3r2 ? c3r2 : '',
										alignment: 'left',
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_report_diet_cp_') + ':',
										alignment: 'left',
										border: [true, false, false, false]
									},
									{
										text: vm.batch.diet_cp ? vm.batch.diet_cp : '',
										alignment: 'right',
										border: [false, false, false, false]
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										alignment: 'left',
										border: [false, false, true, false]
									},
									{
										text: '',
										alignment: 'left',
										border: [false, false, false, false]
									}
								],
								[
									{},
									{
										text: c1r3 ? c1r3 : '',
										alignment: 'left',
										border: [true, false, false, true]
									},
									{
										text: c2r3 ? c2r3 : '',
										alignment: 'right',
										border: [false, false, false, true]
									},
									{
										text: c3r3 ? c3r3 : '',
										alignment: 'left',
										border: [false, false, false, true]
									},
									{
										text: '',
										alignment: 'left',
										border: [true, false, false, true]
									},
									{
										text: '',
										alignment: 'left',
										border: [false, false, false, true]
									},
									{
										text: '',
										alignment: 'left',
										border: [false, false, true, true]
									},
									{
										text: '',
										alignment: 'left',
										border: [false, false, false, false]
									}
								],
								[
									{},
									{
										text: '',
										alignment: 'left',
										border: [false, false, false, false]
									},
									{
										text: '',
										alignment: 'left',
										border: [false, false, false, false]
									},
									{
										text: '',
										alignment: 'left',
										border: [false, false, false, false]
									},
									{
										text: '',
										alignment: 'left',
										border: [false, false, false, false]
									},
									{
										text: '',
										alignment: 'left',
										border: [false, false, false, false]
									},
									{
										text: '',
										alignment: 'left',
										border: [false, false, false, false]
									},
									{
										text: '',
										alignment: 'left',
										border: [false, false, false, false]
									}
								]
							]
						}
					},
					{
						margin: [0, 10, 0, 0],
						style: 'bigFontSizeTable',
						table: {
							headerRows: 2,
							dontBreakRows: true,
							keepWithHeaderRows: 15,
							widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
							body: [
								[
									{
										text: '',
										bold: true,
										alignment: 'left',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_report_test_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_dm_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_as_fed_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_report_number_of_cows_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false],
										colSpan: 9
									},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{}
								],
								[
									{
										text: i18nFilter('_feeds_name_'),
										alignment: 'left',
										border: [false, false, false, true]
									},
									{
										text: i18nFilter('_report_date_'),
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.weight ? vm.weight : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: IVNA ? $filter('number')(IVNA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: IIINA ? $filter('number')(IIINA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: IINA ? $filter('number')(IINA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: INA ? $filter('number')(INA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NA ? $filter('number')(NA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAI ? $filter('number')(NAI, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAII ? $filter('number')(NAII, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAIII ? $filter('number')(NAIII, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAIV ? $filter('number')(NAIV, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'gray';
							},
							paddingLeft: function (i, node) {
								return 3;
							},
							paddingRight: function (i, node) {
								return 3;
							},
							paddingTop: function (i, node) {
								return 1;
							},
							paddingBottom: function (i, node) {
								return 0;
							}
						} //pageBreak: 'after'
					},
					{
						margin: [0, 10, 0, 0],
						style: 'bigFontSizeTable',
						table: {
							headerRows: 2,
							dontBreakRows: true,
							keepWithHeaderRows: 15,
							widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
							body: [
								[
									{
										text: i18nFilter('_report_w_m_added_separately_'),
										bold: true,
										alignment: 'left',
										border: [false, false, false, false],
										colSpan: 13
									},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{}
								],
								[
									{
										text: '',
										bold: true,
										alignment: 'left',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_report_test_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_dm_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_as_fed_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_report_number_of_cows_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false],
										colSpan: 9
									},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{}
								],
								[
									{
										text: i18nFilter('_feeds_name_'),
										alignment: 'left',
										border: [false, false, false, true]
									},
									{
										text: i18nFilter('_report_date_'),
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.weight ? vm.weight : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: IVNA ? $filter('number')(IVNA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: IIINA ? $filter('number')(IIINA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: IINA ? $filter('number')(IINA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: INA ? $filter('number')(INA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NA ? $filter('number')(NA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAI ? $filter('number')(NAI, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAII ? $filter('number')(NAII, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAIII ? $filter('number')(NAIII, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAIV ? $filter('number')(NAIV, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === 1 || i === node.table.body.length ? 1.5 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === 1 || i === node.table.body.length ? 'black' : 'gray';
							},
							paddingLeft: function (i, node) {
								return 3;
							},
							paddingRight: function (i, node) {
								return 3;
							},
							paddingTop: function (i, node) {
								return 1;
							},
							paddingBottom: function (i, node) {
								return 0;
							}
						}
					},
					{
						margin: [0, 10, 0, 0],
						style: 'bigFontSizeTable',
						table: {
							headerRows: 2,
							dontBreakRows: true,
							keepWithHeaderRows: 15,
							widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
							body: [
								[
									{
										text: i18nFilter('_report_accumulating_'),
										bold: true,
										alignment: 'left',
										border: [false, false, false, false],
										colSpan: 13
									},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{}
								],
								[
									{
										text: '',
										bold: true,
										alignment: 'left',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_report_test_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_dm_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_as_fed_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_report_number_of_cows_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false],
										colSpan: 9
									},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{}
								],
								[
									{
										text: i18nFilter('_feeds_name_'),
										alignment: 'left',
										border: [false, false, false, true]
									},
									{
										text: i18nFilter('_report_date_'),
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.weight ? vm.weight : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: IVNA ? $filter('number')(IVNA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: IIINA ? $filter('number')(IIINA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: IINA ? $filter('number')(IINA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: INA ? $filter('number')(INA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NA ? $filter('number')(NA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAI ? $filter('number')(NAI, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAII ? $filter('number')(NAII, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAIII ? $filter('number')(NAIII, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAIV ? $filter('number')(NAIV, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === 1 || i === node.table.body.length ? 1.5 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === 1 || i === node.table.body.length ? 'black' : 'gray';
							},
							paddingLeft: function (i, node) {
								return 3;
							},
							paddingRight: function (i, node) {
								return 3;
							},
							paddingTop: function (i, node) {
								return 1;
							},
							paddingBottom: function (i, node) {
								return 0;
							}
						}
					},
					{
						margin: [0, 10, 0, 0],
						style: 'bigFontSizeTable',
						table: {
							headerRows: 2,
							dontBreakRows: true,
							keepWithHeaderRows: 15,
							widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
							body: [
								[
									{
										text: i18nFilter('_report_accumulating_') + '; ' + i18nFilter('_report_w_m_added_separately_'),
										bold: true,
										alignment: 'left',
										border: [false, false, false, false],
										colSpan: 13
									},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{}
								],
								[
									{
										text: '',
										bold: true,
										alignment: 'left',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_report_test_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_dm_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_as_fed_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_report_number_of_cows_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false],
										colSpan: 9
									},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{}
								],
								[
									{
										text: i18nFilter('_feeds_name_'),
										alignment: 'left',
										border: [false, false, false, true]
									},
									{
										text: i18nFilter('_report_date_'),
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.weight ? vm.weight : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: IVNA ? $filter('number')(IVNA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: IIINA ? $filter('number')(IIINA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: IINA ? $filter('number')(IINA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: INA ? $filter('number')(INA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NA ? $filter('number')(NA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAI ? $filter('number')(NAI, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAII ? $filter('number')(NAII, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAIII ? $filter('number')(NAIII, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAIV ? $filter('number')(NAIV, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === 1 || i === node.table.body.length ? 1.5 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === 1 || i === node.table.body.length ? 'black' : 'gray';
							},
							paddingLeft: function (i, node) {
								return 3;
							},
							paddingRight: function (i, node) {
								return 3;
							},
							paddingTop: function (i, node) {
								return 1;
							},
							paddingBottom: function (i, node) {
								return 0;
							}
						}
					},
					{
						margin: [0, 10, 0, 0],
						style: 'bigFontSizeTable',
						table: {
							widths: ['*'],
							body: [
								[
									{
										text: i18nFilter('_report_dm_adj_'),
										bold: true,
										border: [false, false, false, true]
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === 1 || i === node.table.body.length ? 1.5 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === 1 || i === node.table.body.length ? 'black' : 'gray';
							},
							paddingLeft: function (i, node) {
								return 3;
							},
							paddingRight: function (i, node) {
								return 3;
							},
							paddingTop: function (i, node) {
								return 1;
							},
							paddingBottom: function (i, node) {
								return 0;
							}
						},
						pageBreak: 'before'
					}
				],
				styles: {
					headerStyle: {
						fontSize: 18,
						bold: true
					},
					bold: {
						bold: true
					},
					small: {
						fontSize: 10
					},
					bigFontSizeTable: {
						fontSize: 13
					}
				},
				defaultStyle: {
					fontSize: 10
				}
			};
			if (vm.batch.togetherFeeds.length > 0) {
				var t = 0;
				var it = 0;
				var iit = 0;
				var iiit = 0;
				var ivt = 0;
				var ti = 0;
				var tii = 0;
				var tiii = 0;
				var tiv = 0;
				var tAF = 0;
				for (var i = 0; i < vm.batch.togetherFeeds.length; i++) {
					vm.batch.togetherFeeds[i].as_fed_show = $filter('number')(vm.batch.togetherFeeds[i].as_fed, 1);
					tAF = tAF + vm.batch.togetherFeeds[i].as_fed;
					vm.batch.togetherFeeds[i].c = (vm.batch.togetherFeeds[i].as_fed * NA * vm.batch.daily_af) / 100;
					t = t + vm.batch.togetherFeeds[i].c;
					vm.batch.togetherFeeds[i].c = $filter('number')(vm.batch.togetherFeeds[i].c, 1);
					vm.batch.togetherFeeds[i].ic = (vm.batch.togetherFeeds[i].as_fed * INA * vm.batch.daily_af) / 100;
					it = it + vm.batch.togetherFeeds[i].ic;
					vm.batch.togetherFeeds[i].ic = $filter('number')(vm.batch.togetherFeeds[i].ic, 1);
					vm.batch.togetherFeeds[i].iic = (vm.batch.togetherFeeds[i].as_fed * IINA * vm.batch.daily_af) / 100;
					iit = iit + vm.batch.togetherFeeds[i].iic;
					vm.batch.togetherFeeds[i].iic = $filter('number')(vm.batch.togetherFeeds[i].iic, 1);
					vm.batch.togetherFeeds[i].iiic = (vm.batch.togetherFeeds[i].as_fed * IIINA * vm.batch.daily_af) / 100;
					iiit = iiit + vm.batch.togetherFeeds[i].iiic;
					vm.batch.togetherFeeds[i].iiic = $filter('number')(vm.batch.togetherFeeds[i].iiic, 1);
					vm.batch.togetherFeeds[i].ivc = (vm.batch.togetherFeeds[i].as_fed * IVNA * vm.batch.daily_af) / 100;
					ivt = ivt + vm.batch.togetherFeeds[i].ivc;
					vm.batch.togetherFeeds[i].ivc = $filter('number')(vm.batch.togetherFeeds[i].ivc, 1);
					vm.batch.togetherFeeds[i].ci = (vm.batch.togetherFeeds[i].as_fed * NAI * vm.batch.daily_af) / 100;
					ti = ti + vm.batch.togetherFeeds[i].ci;
					vm.batch.togetherFeeds[i].ci = $filter('number')(vm.batch.togetherFeeds[i].ci, 1);
					vm.batch.togetherFeeds[i].cii = (vm.batch.togetherFeeds[i].as_fed * NAII * vm.batch.daily_af) / 100;
					tii = tii + vm.batch.togetherFeeds[i].cii;
					vm.batch.togetherFeeds[i].cii = $filter('number')(vm.batch.togetherFeeds[i].cii, 1);
					vm.batch.togetherFeeds[i].ciii = (vm.batch.togetherFeeds[i].as_fed * NAIII * vm.batch.daily_af) / 100;
					tiii = tiii + vm.batch.togetherFeeds[i].ciii;
					vm.batch.togetherFeeds[i].ciii = $filter('number')(vm.batch.togetherFeeds[i].ciii, 1);
					vm.batch.togetherFeeds[i].civ = (vm.batch.togetherFeeds[i].as_fed * NAIV * vm.batch.daily_af) / 100;
					tiv = tiv + vm.batch.togetherFeeds[i].civ;
					vm.batch.togetherFeeds[i].civ = $filter('number')(vm.batch.togetherFeeds[i].civ, 1);
				}
				var total = [
					{
						text: i18nFilter('_report_total_').toUpperCase(),
						bold: true,
						alignment: 'left',
						border: [false, true, false, true]
					},
					{
						text: '',
						bold: true,
						alignment: 'left',
						border: [false, true, false, true]
					},
					{
						text: '',
						bold: true,
						alignment: 'left',
						border: [false, true, false, true]
					},
					{
						text: tAF ? $filter('number')(tAF, 1) : '',
						alignment: 'center',
						border: [false, true, false, true]
					},
					{
						text: ivt ? $filter('number')(ivt, 0) : '',
						alignment: 'center',
						border: [false, true, false, true]
					},
					{
						text: iiit ? $filter('number')(iiit, 0) : '',
						alignment: 'center',
						border: [false, true, false, true]
					},
					{
						text: iit ? $filter('number')(iit, 0) : '',
						alignment: 'center',
						border: [false, true, false, true]
					},
					{
						text: it ? $filter('number')(it, 0) : '',
						alignment: 'center',
						border: [false, true, false, true]
					},
					{
						text: t ? $filter('number')(t, 0) : '',
						alignment: 'center',
						bold: true,
						border: [false, true, false, true]
					},
					{
						text: ti ? $filter('number')(ti, 0) : '',
						alignment: 'center',
						border: [false, true, false, true]
					},
					{
						text: tii ? $filter('number')(tii, 0) : '',
						alignment: 'center',
						border: [false, true, false, true]
					},
					{
						text: tiii ? $filter('number')(tiii, 0) : '',
						alignment: 'center',
						border: [false, true, false, true]
					},
					{
						text: tiv ? $filter('number')(tiv, 0) : '',
						alignment: 'center',
						border: [false, true, false, true]
					}
				];
				dd.content[1].table.body.splice(2, 0, total);
				for (var i = vm.batch.togetherFeeds.length - 1; i >= 0; i--) {
					var feed = [
						{
							text: vm.batch.togetherFeeds[i].feed_name ? vm.batch.togetherFeeds[i].feed_name : '',
							alignment: 'left',
							border: [false, false, false, false]
						},
						{
							text: vm.batch.togetherFeeds[i].test_date ? $filter('date')(vm.batch.togetherFeeds[i].test_date, 'shortDate') : '',
							alignment: 'center',
							border: [false, false, false, false]
						},
						{
							text: vm.batch.togetherFeeds[i].dm ? $filter('number')(vm.batch.togetherFeeds[i].dm, 0) : '',
							bold: true,
							alignment: 'center',
							border: [false, false, false, false]
						},
						{
							text: vm.batch.togetherFeeds[i].as_fed ? $filter('number')(vm.batch.togetherFeeds[i].as_fed, 1) : '',
							alignment: 'center',
							border: [false, false, false, false]
						},
						{
							text: vm.batch.togetherFeeds[i].ivc ? vm.batch.togetherFeeds[i].ivc : '',
							alignment: 'center',
							border: [false, false, false, false]
						},
						{
							text: vm.batch.togetherFeeds[i].iiic ? vm.batch.togetherFeeds[i].iiic : '',
							alignment: 'center',
							border: [false, false, false, false]
						},
						{
							text: vm.batch.togetherFeeds[i].iic ? vm.batch.togetherFeeds[i].iic : '',
							alignment: 'center',
							border: [false, false, false, false]
						},
						{
							text: vm.batch.togetherFeeds[i].ic ? vm.batch.togetherFeeds[i].ic : '',
							alignment: 'center',
							border: [false, false, false, false]
						},
						{
							text: vm.batch.togetherFeeds[i].c ? vm.batch.togetherFeeds[i].c : '',
							alignment: 'center',
							bold: true,
							border: [false, false, false, false]
						},
						{
							text: vm.batch.togetherFeeds[i].ci ? vm.batch.togetherFeeds[i].ci : '',
							alignment: 'center',
							border: [false, false, false, false]
						},
						{
							text: vm.batch.togetherFeeds[i].cii ? vm.batch.togetherFeeds[i].cii : '',
							alignment: 'center',
							border: [false, false, false, false]
						},
						{
							text: vm.batch.togetherFeeds[i].ciii ? vm.batch.togetherFeeds[i].ciii : '',
							alignment: 'center',
							border: [false, false, false, false]
						},
						{
							text: vm.batch.togetherFeeds[i].civ ? vm.batch.togetherFeeds[i].civ : '',
							alignment: 'center',
							border: [false, false, false, false]
						}
					];
					dd.content[1].table.body.splice(2, 0, feed);
				}
			}
			if (vm.batch.separatelyFeeds.length > 0) {
				for (var i = vm.batch.separatelyFeeds.length - 1; i >= 0; i--) {
					vm.batch.separatelyFeeds[i].as_fed_show = $filter('number')(vm.batch.separatelyFeeds[i].as_fed, 1);
					vm.batch.separatelyFeeds[i].c = (vm.batch.separatelyFeeds[i].as_fed * NA * vm.batch.daily_af) / 100;
					vm.batch.separatelyFeeds[i].c = $filter('number')(vm.batch.separatelyFeeds[i].c, 1);
					vm.batch.separatelyFeeds[i].ic = (vm.batch.separatelyFeeds[i].as_fed * INA * vm.batch.daily_af) / 100;
					vm.batch.separatelyFeeds[i].ic = $filter('number')(vm.batch.separatelyFeeds[i].ic, 1);
					vm.batch.separatelyFeeds[i].iic = (vm.batch.separatelyFeeds[i].as_fed * IINA * vm.batch.daily_af) / 100;
					vm.batch.separatelyFeeds[i].iic = $filter('number')(vm.batch.separatelyFeeds[i].iic, 1);
					vm.batch.separatelyFeeds[i].iiic = (vm.batch.separatelyFeeds[i].as_fed * IIINA * vm.batch.daily_af) / 100;
					vm.batch.separatelyFeeds[i].iiic = $filter('number')(vm.batch.separatelyFeeds[i].iiic, 1);
					vm.batch.separatelyFeeds[i].ivc = (vm.batch.separatelyFeeds[i].as_fed * IVNA * vm.batch.daily_af) / 100;
					vm.batch.separatelyFeeds[i].ivc = $filter('number')(vm.batch.separatelyFeeds[i].ivc, 1);
					vm.batch.separatelyFeeds[i].ci = (vm.batch.separatelyFeeds[i].as_fed * NAI * vm.batch.daily_af) / 100;
					vm.batch.separatelyFeeds[i].ci = $filter('number')(vm.batch.separatelyFeeds[i].ci, 1);
					vm.batch.separatelyFeeds[i].cii = (vm.batch.separatelyFeeds[i].as_fed * NAII * vm.batch.daily_af) / 100;
					vm.batch.separatelyFeeds[i].cii = $filter('number')(vm.batch.separatelyFeeds[i].cii, 1);
					vm.batch.separatelyFeeds[i].ciii = (vm.batch.separatelyFeeds[i].as_fed * NAIII * vm.batch.daily_af) / 100;
					vm.batch.separatelyFeeds[i].ciii = $filter('number')(vm.batch.separatelyFeeds[i].ciii, 1);
					vm.batch.separatelyFeeds[i].civ = (vm.batch.separatelyFeeds[i].as_fed * NAIV * vm.batch.daily_af) / 100;
					vm.batch.separatelyFeeds[i].civ = $filter('number')(vm.batch.separatelyFeeds[i].civ, 1);
					var feed = [
						{
							text: vm.batch.separatelyFeeds[i].feed_name ? vm.batch.separatelyFeeds[i].feed_name : '',
							alignment: 'left',
							border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
						},
						{
							text: vm.batch.separatelyFeeds[i].test_date ? $filter('date')(vm.batch.separatelyFeeds[i].test_date, 'shortDate') : '',
							alignment: 'center',
							border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
						},
						{
							text: vm.batch.separatelyFeeds[i].dm ? $filter('number')(vm.batch.separatelyFeeds[i].dm, 0) : '',
							bold: true,
							alignment: 'center',
							border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
						},
						{
							text: vm.batch.separatelyFeeds[i].as_fed ? $filter('number')(vm.batch.separatelyFeeds[i].as_fed, 1) : '',
							alignment: 'center',
							border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
						},
						{
							text: vm.batch.separatelyFeeds[i].ivc ? vm.batch.separatelyFeeds[i].ivc : '',
							alignment: 'center',
							border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
						},
						{
							text: vm.batch.separatelyFeeds[i].iiic ? vm.batch.separatelyFeeds[i].iiic : '',
							alignment: 'center',
							border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
						},
						{
							text: vm.batch.separatelyFeeds[i].iic ? vm.batch.separatelyFeeds[i].iic : '',
							alignment: 'center',
							border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
						},
						{
							text: vm.batch.separatelyFeeds[i].ic ? vm.batch.separatelyFeeds[i].ic : '',
							alignment: 'center',
							border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
						},
						{
							text: vm.batch.separatelyFeeds[i].c ? vm.batch.separatelyFeeds[i].c : '',
							alignment: 'center',
							bold: true,
							border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
						},
						{
							text: vm.batch.separatelyFeeds[i].ci ? vm.batch.separatelyFeeds[i].ci : '',
							alignment: 'center',
							border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
						},
						{
							text: vm.batch.separatelyFeeds[i].cii ? vm.batch.separatelyFeeds[i].cii : '',
							alignment: 'center',
							border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
						},
						{
							text: vm.batch.separatelyFeeds[i].ciii ? vm.batch.separatelyFeeds[i].ciii : '',
							alignment: 'center',
							border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
						},
						{
							text: vm.batch.separatelyFeeds[i].civ ? vm.batch.separatelyFeeds[i].civ : '',
							alignment: 'center',
							border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
						}
					];
					dd.content[2].table.body.splice(3, 0, feed);
				}
			}
			if (vm.batch.print_acc) {
				if (vm.batch.togetherFeeds.length > 0) {
					var tempc = 0;
					var tempic = 0;
					var tempiic = 0;
					var tempiiic = 0;
					var tempivc = 0;
					var tempci = 0;
					var tempcii = 0;
					var tempciii = 0;
					var tempciv = 0;
					for (var i = 0; i < vm.batch.togetherFeeds.length; i++) {
						vm.batch.togetherFeeds[i].as_fed_show = $filter('number')(vm.batch.togetherFeeds[i].as_fed, 1);
						tempc = tempc + (vm.batch.togetherFeeds[i].as_fed * NA * vm.batch.daily_af) / 100;
						vm.batch.togetherFeeds[i].c = $filter('number')(tempc, 1);
						tempic = tempic + (vm.batch.togetherFeeds[i].as_fed * INA * vm.batch.daily_af) / 100;
						vm.batch.togetherFeeds[i].ic = $filter('number')(tempic, 1);
						tempiic = tempiic + (vm.batch.togetherFeeds[i].as_fed * IINA * vm.batch.daily_af) / 100;
						vm.batch.togetherFeeds[i].iic = $filter('number')(tempiic, 1);
						tempiiic = tempiiic + (vm.batch.togetherFeeds[i].as_fed * IIINA * vm.batch.daily_af) / 100;
						vm.batch.togetherFeeds[i].iiic = $filter('number')(tempiiic, 1);
						tempivc = tempivc + (vm.batch.togetherFeeds[i].as_fed * IVNA * vm.batch.daily_af) / 100;
						vm.batch.togetherFeeds[i].ivc = $filter('number')(tempivc, 1);
						tempci = tempci + (vm.batch.togetherFeeds[i].as_fed * NAI * vm.batch.daily_af) / 100;
						vm.batch.togetherFeeds[i].ci = $filter('number')(tempci, 1);
						tempcii = tempcii + (vm.batch.togetherFeeds[i].as_fed * NAII * vm.batch.daily_af) / 100;
						vm.batch.togetherFeeds[i].cii = $filter('number')(tempcii, 1);
						tempciii = tempciii + (vm.batch.togetherFeeds[i].as_fed * NAIII * vm.batch.daily_af) / 100;
						vm.batch.togetherFeeds[i].ciii = $filter('number')(tempciii, 1);
						tempciv = tempciv + (vm.batch.togetherFeeds[i].as_fed * NAIV * vm.batch.daily_af) / 100;
						vm.batch.togetherFeeds[i].civ = $filter('number')(tempciv, 1);
					}
					for (var i = vm.batch.togetherFeeds.length - 1; i >= 0; i--) {
						var feed = [
							{
								text: vm.batch.togetherFeeds[i].feed_name ? vm.batch.togetherFeeds[i].feed_name : '',
								alignment: 'left',
								border: i == vm.batch.togetherFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.togetherFeeds[i].test_date ? $filter('date')(vm.batch.togetherFeeds[i].test_date, 'shortDate') : '',
								alignment: 'center',
								border: i == vm.batch.togetherFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.togetherFeeds[i].dm ? $filter('number')(vm.batch.togetherFeeds[i].dm, 0) : '',
								bold: true,
								alignment: 'center',
								border: i == vm.batch.togetherFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.togetherFeeds[i].as_fed ? $filter('number')(vm.batch.togetherFeeds[i].as_fed, 1) : '',
								alignment: 'center',
								border: i == vm.batch.togetherFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.togetherFeeds[i].ivc ? vm.batch.togetherFeeds[i].ivc : '',
								alignment: 'center',
								border: i == vm.batch.togetherFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.togetherFeeds[i].iiic ? vm.batch.togetherFeeds[i].iiic : '',
								alignment: 'center',
								border: i == vm.batch.togetherFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.togetherFeeds[i].iic ? vm.batch.togetherFeeds[i].iic : '',
								alignment: 'center',
								border: i == vm.batch.togetherFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.togetherFeeds[i].ic ? vm.batch.togetherFeeds[i].ic : '',
								alignment: 'center',
								border: i == vm.batch.togetherFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.togetherFeeds[i].c ? vm.batch.togetherFeeds[i].c : '',
								alignment: 'center',
								bold: true,
								border: i == vm.batch.togetherFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.togetherFeeds[i].ci ? vm.batch.togetherFeeds[i].ci : '',
								alignment: 'center',
								border: i == vm.batch.togetherFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.togetherFeeds[i].cii ? vm.batch.togetherFeeds[i].cii : '',
								alignment: 'center',
								border: i == vm.batch.togetherFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.togetherFeeds[i].ciii ? vm.batch.togetherFeeds[i].ciii : '',
								alignment: 'center',
								border: i == vm.batch.togetherFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.togetherFeeds[i].civ ? vm.batch.togetherFeeds[i].civ : '',
								alignment: 'center',
								border: i == vm.batch.togetherFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							}
						];
						dd.content[3].table.body.splice(3, 0, feed);
					}
				}
				if (vm.batch.separatelyFeeds.length > 0) {
					var tempc = 0;
					var tempic = 0;
					var tempiic = 0;
					var tempiiic = 0;
					var tempivc = 0;
					var tempci = 0;
					var tempcii = 0;
					var tempciii = 0;
					var tempciv = 0;
					for (var i = 0; i < vm.batch.separatelyFeeds.length; i++) {
						vm.batch.separatelyFeeds[i].as_fed_show = $filter('number')(vm.batch.separatelyFeeds[i].as_fed, 1);
						tempc = tempc + (vm.batch.separatelyFeeds[i].as_fed * NA * vm.batch.daily_af) / 100;
						vm.batch.separatelyFeeds[i].c = $filter('number')(tempc, 1);
						tempic = tempic + (vm.batch.separatelyFeeds[i].as_fed * INA * vm.batch.daily_af) / 100;
						vm.batch.separatelyFeeds[i].ic = $filter('number')(tempic, 1);
						tempiic = tempiic + (vm.batch.separatelyFeeds[i].as_fed * IINA * vm.batch.daily_af) / 100;
						vm.batch.separatelyFeeds[i].iic = $filter('number')(tempiic, 1);
						tempiiic = tempiiic + (vm.batch.separatelyFeeds[i].as_fed * IIINA * vm.batch.daily_af) / 100;
						vm.batch.separatelyFeeds[i].iiic = $filter('number')(tempiiic, 1);
						tempivc = tempivc + (vm.batch.separatelyFeeds[i].as_fed * IVNA * vm.batch.daily_af) / 100;
						vm.batch.separatelyFeeds[i].ivc = $filter('number')(tempivc, 1);
						tempci = tempci + (vm.batch.separatelyFeeds[i].as_fed * NAI * vm.batch.daily_af) / 100;
						vm.batch.separatelyFeeds[i].ci = $filter('number')(tempci, 1);
						tempcii = tempcii + (vm.batch.separatelyFeeds[i].as_fed * NAII * vm.batch.daily_af) / 100;
						vm.batch.separatelyFeeds[i].cii = $filter('number')(tempcii, 1);
						tempciii = tempciii + (vm.batch.separatelyFeeds[i].as_fed * NAIII * vm.batch.daily_af) / 100;
						vm.batch.separatelyFeeds[i].ciii = $filter('number')(tempciii, 1);
						tempciv = tempciv + (vm.batch.separatelyFeeds[i].as_fed * NAIV * vm.batch.daily_af) / 100;
						vm.batch.separatelyFeeds[i].civ = $filter('number')(tempciv, 1);
					}
					for (var i = vm.batch.separatelyFeeds.length - 1; i >= 0; i--) {
						var feed = [
							{
								text: vm.batch.separatelyFeeds[i].feed_name ? vm.batch.separatelyFeeds[i].feed_name : '',
								alignment: 'left',
								border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.separatelyFeeds[i].test_date ? $filter('date')(vm.batch.separatelyFeeds[i].test_date, 'shortDate') : '',
								alignment: 'center',
								border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.separatelyFeeds[i].dm ? $filter('number')(vm.batch.separatelyFeeds[i].dm, 0) : '',
								bold: true,
								alignment: 'center',
								border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.separatelyFeeds[i].as_fed ? $filter('number')(vm.batch.separatelyFeeds[i].as_fed, 1) : '',
								alignment: 'center',
								border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.separatelyFeeds[i].ivc ? vm.batch.separatelyFeeds[i].ivc : '',
								alignment: 'center',
								border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.separatelyFeeds[i].iiic ? vm.batch.separatelyFeeds[i].iiic : '',
								alignment: 'center',
								border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.separatelyFeeds[i].iic ? vm.batch.separatelyFeeds[i].iic : '',
								alignment: 'center',
								border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.separatelyFeeds[i].ic ? vm.batch.separatelyFeeds[i].ic : '',
								alignment: 'center',
								border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.separatelyFeeds[i].c ? vm.batch.separatelyFeeds[i].c : '',
								alignment: 'center',
								bold: true,
								border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.separatelyFeeds[i].ci ? vm.batch.separatelyFeeds[i].ci : '',
								alignment: 'center',
								border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.separatelyFeeds[i].cii ? vm.batch.separatelyFeeds[i].cii : '',
								alignment: 'center',
								border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.separatelyFeeds[i].ciii ? vm.batch.separatelyFeeds[i].ciii : '',
								alignment: 'center',
								border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							},
							{
								text: vm.batch.separatelyFeeds[i].civ ? vm.batch.separatelyFeeds[i].civ : '',
								alignment: 'center',
								border: i == vm.batch.separatelyFeeds.length - 1 ? [false, false, false, true] : [false, false, false, false]
							}
						];
						dd.content[4].table.body.splice(3, 0, feed);
					}
				}
			}
			if (vm.batch.dmi_adj.length > 0) {
				for (var i = vm.batch.dmi_adj.length - 1; i >= 0; i--) {
					vm.batch.dmi_adj[i].as_fed_show = $filter('number')(vm.batch.dmi_adj[i].as_fed, 1);
					vm.batch.dmi_adj[i].c = (vm.batch.dmi_adj[i].as_fed * NA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].c = $filter('number')(vm.batch.dmi_adj[i].c, 1);
					vm.batch.dmi_adj[i].ic = (vm.batch.dmi_adj[i].as_fed * INA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].ic = $filter('number')(vm.batch.dmi_adj[i].ic, 1);
					vm.batch.dmi_adj[i].iic = (vm.batch.dmi_adj[i].as_fed * IINA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].iic = $filter('number')(vm.batch.dmi_adj[i].iic, 1);
					vm.batch.dmi_adj[i].iiic = (vm.batch.dmi_adj[i].as_fed * IIINA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].iiic = $filter('number')(vm.batch.dmi_adj[i].iiic, 1);
					vm.batch.dmi_adj[i].ivc = (vm.batch.dmi_adj[i].as_fed * IVNA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].ivc = $filter('number')(vm.batch.dmi_adj[i].ivc, 1);
					vm.batch.dmi_adj[i].ci = (vm.batch.dmi_adj[i].as_fed * NAI * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].ci = $filter('number')(vm.batch.dmi_adj[i].ci, 1);
					vm.batch.dmi_adj[i].cii = (vm.batch.dmi_adj[i].as_fed * NAII * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].cii = $filter('number')(vm.batch.dmi_adj[i].cii, 1);
					vm.batch.dmi_adj[i].ciii = (vm.batch.dmi_adj[i].as_fed * NAIII * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].ciii = $filter('number')(vm.batch.dmi_adj[i].ciii, 1);
					vm.batch.dmi_adj[i].civ = (vm.batch.dmi_adj[i].as_fed * NAIV * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].civ = $filter('number')(vm.batch.dmi_adj[i].civ, 1);
					vm.batch.dmi_adj[i].dmp2 = vm.batch.dmi_adj[i].dm + 2;
					vm.batch.dmi_adj[i].dmn2 = vm.batch.dmi_adj[i].dm - 2;
					vm.batch.dmi_adj[i].dmp4 = vm.batch.dmi_adj[i].dm + 4;
					vm.batch.dmi_adj[i].dmn4 = vm.batch.dmi_adj[i].dm - 4;
					vm.batch.dmi_adj[i].as_fed_p2 = (vm.batch.dmi_adj[i].as_fed * vm.batch.dmi_adj[i].dm) / vm.batch.dmi_adj[i].dmp2;
					vm.batch.dmi_adj[i].as_fed_p4 = (vm.batch.dmi_adj[i].as_fed * vm.batch.dmi_adj[i].dm) / vm.batch.dmi_adj[i].dmp4;
					vm.batch.dmi_adj[i].as_fed_n2 = (vm.batch.dmi_adj[i].as_fed * vm.batch.dmi_adj[i].dm) / vm.batch.dmi_adj[i].dmn2;
					vm.batch.dmi_adj[i].as_fed_n4 = (vm.batch.dmi_adj[i].as_fed * vm.batch.dmi_adj[i].dm) / vm.batch.dmi_adj[i].dmn4;
					vm.batch.dmi_adj[i].cp2 = (vm.batch.dmi_adj[i].as_fed_p2 * NA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].cp2 = $filter('number')(vm.batch.dmi_adj[i].cp2, 1);
					vm.batch.dmi_adj[i].icp2 = (vm.batch.dmi_adj[i].as_fed_p2 * INA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].icp2 = $filter('number')(vm.batch.dmi_adj[i].icp2, 1);
					vm.batch.dmi_adj[i].iicp2 = (vm.batch.dmi_adj[i].as_fed_p2 * IINA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].iicp2 = $filter('number')(vm.batch.dmi_adj[i].iicp2, 1);
					vm.batch.dmi_adj[i].iiicp2 = (vm.batch.dmi_adj[i].as_fed_p2 * IIINA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].iiicp2 = $filter('number')(vm.batch.dmi_adj[i].iiicp2, 1);
					vm.batch.dmi_adj[i].ivcp2 = (vm.batch.dmi_adj[i].as_fed_p2 * IVNA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].ivcp2 = $filter('number')(vm.batch.dmi_adj[i].ivcp2, 1);
					vm.batch.dmi_adj[i].cip2 = (vm.batch.dmi_adj[i].as_fed_p2 * NAI * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].cip2 = $filter('number')(vm.batch.dmi_adj[i].cip2, 1);
					vm.batch.dmi_adj[i].ciip2 = (vm.batch.dmi_adj[i].as_fed_p2 * NAII * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].ciip2 = $filter('number')(vm.batch.dmi_adj[i].ciip2, 1);
					vm.batch.dmi_adj[i].ciiip2 = (vm.batch.dmi_adj[i].as_fed_p2 * NAIII * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].ciiip2 = $filter('number')(vm.batch.dmi_adj[i].ciiip2, 1);
					vm.batch.dmi_adj[i].civp2 = (vm.batch.dmi_adj[i].as_fed_p2 * NAIV * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].civp2 = $filter('number')(vm.batch.dmi_adj[i].civp2, 1);
					vm.batch.dmi_adj[i].cp4 = (vm.batch.dmi_adj[i].as_fed_p4 * NA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].cp4 = $filter('number')(vm.batch.dmi_adj[i].cp4, 1);
					vm.batch.dmi_adj[i].icp4 = (vm.batch.dmi_adj[i].as_fed_p4 * INA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].icp4 = $filter('number')(vm.batch.dmi_adj[i].icp4, 1);
					vm.batch.dmi_adj[i].iicp4 = (vm.batch.dmi_adj[i].as_fed_p4 * IINA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].iicp4 = $filter('number')(vm.batch.dmi_adj[i].iicp4, 1);
					vm.batch.dmi_adj[i].iiicp4 = (vm.batch.dmi_adj[i].as_fed_p4 * IIINA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].iiicp4 = $filter('number')(vm.batch.dmi_adj[i].iiicp4, 1);
					vm.batch.dmi_adj[i].ivcp4 = (vm.batch.dmi_adj[i].as_fed_p4 * IVNA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].ivcp4 = $filter('number')(vm.batch.dmi_adj[i].ivcp4, 1);
					vm.batch.dmi_adj[i].cip4 = (vm.batch.dmi_adj[i].as_fed_p4 * NAI * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].cip4 = $filter('number')(vm.batch.dmi_adj[i].cip4, 1);
					vm.batch.dmi_adj[i].ciip4 = (vm.batch.dmi_adj[i].as_fed_p4 * NAII * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].ciip4 = $filter('number')(vm.batch.dmi_adj[i].ciip4, 1);
					vm.batch.dmi_adj[i].ciiip4 = (vm.batch.dmi_adj[i].as_fed_p4 * NAIII * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].ciiip4 = $filter('number')(vm.batch.dmi_adj[i].ciiip4, 1);
					vm.batch.dmi_adj[i].civp4 = (vm.batch.dmi_adj[i].as_fed_p4 * NAIV * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].civp4 = $filter('number')(vm.batch.dmi_adj[i].civp4, 1);
					vm.batch.dmi_adj[i].cn2 = (vm.batch.dmi_adj[i].as_fed_n2 * NA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].cn2 = $filter('number')(vm.batch.dmi_adj[i].cn2, 1);
					vm.batch.dmi_adj[i].icn2 = (vm.batch.dmi_adj[i].as_fed_n2 * INA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].icn2 = $filter('number')(vm.batch.dmi_adj[i].icn2, 1);
					vm.batch.dmi_adj[i].iicn2 = (vm.batch.dmi_adj[i].as_fed_n2 * IINA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].iicn2 = $filter('number')(vm.batch.dmi_adj[i].iicn2, 1);
					vm.batch.dmi_adj[i].iiicn2 = (vm.batch.dmi_adj[i].as_fed_n2 * IIINA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].iiicn2 = $filter('number')(vm.batch.dmi_adj[i].iiicn2, 1);
					vm.batch.dmi_adj[i].ivcn2 = (vm.batch.dmi_adj[i].as_fed_n2 * IVNA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].ivcn2 = $filter('number')(vm.batch.dmi_adj[i].ivcn2, 1);
					vm.batch.dmi_adj[i].cin2 = (vm.batch.dmi_adj[i].as_fed_n2 * NAI * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].cin2 = $filter('number')(vm.batch.dmi_adj[i].cin2, 1);
					vm.batch.dmi_adj[i].ciin2 = (vm.batch.dmi_adj[i].as_fed_n2 * NAII * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].ciin2 = $filter('number')(vm.batch.dmi_adj[i].ciin2, 1);
					vm.batch.dmi_adj[i].ciiin2 = (vm.batch.dmi_adj[i].as_fed_n2 * NAIII * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].ciiin2 = $filter('number')(vm.batch.dmi_adj[i].ciiin2, 1);
					vm.batch.dmi_adj[i].civn2 = (vm.batch.dmi_adj[i].as_fed_n2 * NAIV * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].civn2 = $filter('number')(vm.batch.dmi_adj[i].civn2, 1);
					vm.batch.dmi_adj[i].cn4 = (vm.batch.dmi_adj[i].as_fed_n4 * NA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].cn4 = $filter('number')(vm.batch.dmi_adj[i].cn4, 1);
					vm.batch.dmi_adj[i].icn4 = (vm.batch.dmi_adj[i].as_fed_n4 * INA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].icn4 = $filter('number')(vm.batch.dmi_adj[i].icn4, 1);
					vm.batch.dmi_adj[i].iicn4 = (vm.batch.dmi_adj[i].as_fed_n4 * IINA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].iicn4 = $filter('number')(vm.batch.dmi_adj[i].iicn4, 1);
					vm.batch.dmi_adj[i].iiicn4 = (vm.batch.dmi_adj[i].as_fed_n4 * IIINA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].iiicn4 = $filter('number')(vm.batch.dmi_adj[i].iiicn4, 1);
					vm.batch.dmi_adj[i].ivcn4 = (vm.batch.dmi_adj[i].as_fed_n4 * IVNA * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].ivcn4 = $filter('number')(vm.batch.dmi_adj[i].ivcn4, 1);
					vm.batch.dmi_adj[i].cin4 = (vm.batch.dmi_adj[i].as_fed_n4 * NAI * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].cin4 = $filter('number')(vm.batch.dmi_adj[i].cin4, 1);
					vm.batch.dmi_adj[i].ciin4 = (vm.batch.dmi_adj[i].as_fed_n4 * NAII * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].ciin4 = $filter('number')(vm.batch.dmi_adj[i].ciin4, 1);
					vm.batch.dmi_adj[i].ciiin4 = (vm.batch.dmi_adj[i].as_fed_n4 * NAIII * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].ciiin4 = $filter('number')(vm.batch.dmi_adj[i].ciiin4, 1);
					vm.batch.dmi_adj[i].civn4 = (vm.batch.dmi_adj[i].as_fed_n4 * NAIV * vm.batch.daily_af) / 100;
					vm.batch.dmi_adj[i].civn4 = $filter('number')(vm.batch.dmi_adj[i].civn4, 1);
					var dmTable = {
						margin: [0, 10, 0, 0],
						style: 'bigFontSizeTable',
						table: {
							headerRows: 2,
							dontBreakRows: true,
							keepWithHeaderRows: 5,
							widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
							body: [
								[
									{
										text: '',
										bold: true,
										alignment: 'left',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_dm_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_as_fed_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_report_number_of_cows_'),
										bold: true,
										alignment: 'center',
										border: [false, true, false, false],
										colSpan: 9
									},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{}
								],
								[
									{
										text: i18nFilter('_feeds_name_'),
										alignment: 'left',
										border: [false, false, false, true]
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.weight ? vm.weight : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: IVNA ? $filter('number')(IVNA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: IIINA ? $filter('number')(IIINA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: IINA ? $filter('number')(IINA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: INA ? $filter('number')(INA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NA ? $filter('number')(NA, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAI ? $filter('number')(NAI, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAII ? $filter('number')(NAII, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAIII ? $filter('number')(NAIII, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: NAIV ? $filter('number')(NAIV, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									}
								],
								[
									{
										text: '-4% ' + i18nFilter('_feeds_dm_'),
										alignment: 'left',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].dmn4 ? $filter('number')(vm.batch.dmi_adj[i].dmn4, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].as_fed_n4 ? $filter('number')(vm.batch.dmi_adj[i].as_fed_n4, 1) : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].ivcn4 ? vm.batch.dmi_adj[i].ivcn4 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].iiicn4 ? vm.batch.dmi_adj[i].iiicn4 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].iicn4 ? vm.batch.dmi_adj[i].iicn4 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].icn4 ? vm.batch.dmi_adj[i].icn4 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].cn4 ? vm.batch.dmi_adj[i].cn4 : '',
										alignment: 'center',
										bold: true,
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].cin4 ? vm.batch.dmi_adj[i].cin4 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].ciin4 ? vm.batch.dmi_adj[i].ciin4 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].ciiin4 ? vm.batch.dmi_adj[i].ciiin4 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].civn4 ? vm.batch.dmi_adj[i].civn4 : '',
										alignment: 'center',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: '-2% ' + i18nFilter('_feeds_dm_'),
										alignment: 'left',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].dmn2 ? $filter('number')(vm.batch.dmi_adj[i].dmn2, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].as_fed_n2 ? $filter('number')(vm.batch.dmi_adj[i].as_fed_n2, 1) : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].ivcn2 ? vm.batch.dmi_adj[i].ivcn2 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].iiicn2 ? vm.batch.dmi_adj[i].iiicn2 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].iicn2 ? vm.batch.dmi_adj[i].iicn2 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].icn2 ? vm.batch.dmi_adj[i].icn2 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].cn2 ? vm.batch.dmi_adj[i].cn2 : '',
										alignment: 'center',
										bold: true,
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].cin2 ? vm.batch.dmi_adj[i].cin2 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].ciin2 ? vm.batch.dmi_adj[i].ciin2 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].ciiin2 ? vm.batch.dmi_adj[i].ciiin2 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].civn2 ? vm.batch.dmi_adj[i].civn2 : '',
										alignment: 'center',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: vm.batch.dmi_adj[i].feed_name ? vm.batch.dmi_adj[i].feed_name : '',
										alignment: 'left',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].dm ? $filter('number')(vm.batch.dmi_adj[i].dm, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].as_fed ? $filter('number')(vm.batch.dmi_adj[i].as_fed, 1) : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].ivc ? vm.batch.dmi_adj[i].ivc : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].iiic ? vm.batch.dmi_adj[i].iiic : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].iic ? vm.batch.dmi_adj[i].iic : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].ic ? vm.batch.dmi_adj[i].ic : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].c ? vm.batch.dmi_adj[i].c : '',
										alignment: 'center',
										bold: true,
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].ci ? vm.batch.dmi_adj[i].ci : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].cii ? vm.batch.dmi_adj[i].cii : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].ciii ? vm.batch.dmi_adj[i].ciii : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].civ ? vm.batch.dmi_adj[i].civ : '',
										alignment: 'center',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: '+2% ' + i18nFilter('_feeds_dm_'),
										alignment: 'left',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].dmp2 ? $filter('number')(vm.batch.dmi_adj[i].dmp2, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].as_fed_p2 ? $filter('number')(vm.batch.dmi_adj[i].as_fed_p2, 1) : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].ivcp2 ? vm.batch.dmi_adj[i].ivcp2 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].iiicp2 ? vm.batch.dmi_adj[i].iiicp2 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].iicp2 ? vm.batch.dmi_adj[i].iicp2 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].icp2 ? vm.batch.dmi_adj[i].icp2 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].cp2 ? vm.batch.dmi_adj[i].cp2 : '',
										alignment: 'center',
										bold: true,
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].cip2 ? vm.batch.dmi_adj[i].cip2 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].ciip2 ? vm.batch.dmi_adj[i].ciip2 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].ciiip2 ? vm.batch.dmi_adj[i].ciiip2 : '',
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: vm.batch.dmi_adj[i].civp2 ? vm.batch.dmi_adj[i].civp2 : '',
										alignment: 'center',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: '+4% ' + i18nFilter('_feeds_dm_'),
										alignment: 'left',
										border: [false, false, false, true]
									},
									{
										text: vm.batch.dmi_adj[i].dmp4 ? $filter('number')(vm.batch.dmi_adj[i].dmp4, 0) : '',
										bold: true,
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.batch.dmi_adj[i].as_fed_p4 ? $filter('number')(vm.batch.dmi_adj[i].as_fed_p4, 1) : '',
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.batch.dmi_adj[i].ivcp4 ? vm.batch.dmi_adj[i].ivcp4 : '',
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.batch.dmi_adj[i].iiicp4 ? vm.batch.dmi_adj[i].iiicp4 : '',
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.batch.dmi_adj[i].iicp4 ? vm.batch.dmi_adj[i].iicp4 : '',
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.batch.dmi_adj[i].icp4 ? vm.batch.dmi_adj[i].icp4 : '',
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.batch.dmi_adj[i].cp4 ? vm.batch.dmi_adj[i].cp4 : '',
										alignment: 'center',
										bold: true,
										border: [false, false, false, true]
									},
									{
										text: vm.batch.dmi_adj[i].cip4 ? vm.batch.dmi_adj[i].cip4 : '',
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.batch.dmi_adj[i].ciip4 ? vm.batch.dmi_adj[i].ciip4 : '',
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.batch.dmi_adj[i].ciiip4 ? vm.batch.dmi_adj[i].ciiip4 : '',
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.batch.dmi_adj[i].civp4 ? vm.batch.dmi_adj[i].civp4 : '',
										alignment: 'center',
										border: [false, false, false, true]
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 0.5 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function (i, node) {
								return 3;
							},
							paddingRight: function (i, node) {
								return 3;
							},
							paddingTop: function (i, node) {
								return 1;
							},
							paddingBottom: function (i, node) {
								return 0;
							}
						}
					};
					dd.content.push(dmTable);
				}
			}
			if (!vm.batch.print_acc) {
				dd.content.splice(4, 1);
				dd.content.splice(3, 1);
			} else {
				if (vm.batch.separatelyFeeds.length == 0) {
					dd.content.splice(4, 1);
				}
				if (vm.batch.togetherFeeds.length == 0) {
					dd.content.splice(3, 1);
				}
			}
			if (vm.batch.separatelyFeeds.length == 0) {
				dd.content.splice(2, 1);
			}
			if (vm.batch.togetherFeeds.length == 0) {
				dd.content.splice(1, 1);
			}
			var aANDc = {
				pageBreak: 'before',
				table: {
					widths: ['*'],
					body: [
						[
							{
								text: i18nFilter('_report_assumptions_').toUpperCase(),
								border: [false, false, false, false]
							}
						],
						[
							{
								text: '',
								border: [false, true, false, true]
							}
						],
						[
							{
								text: vm.aAndC ? vm.aAndC : '',
								border: [false, false, false, false]
							}
						]
					]
				},
				layout: {
					hLineWidth: function (i, node) {
						return i === 0 || i === node.table.body.length ? 1.5 : 1.5;
					},
					hLineColor: function (i, node) {
						return i === 0 || i === node.table.body.length ? 'black' : 'black';
					},
					paddingLeft: function (i, node) {
						return 2;
					},
					paddingRight: function (i, node) {
						return 5;
					},
					paddingTop: function (i, node) {
						return 5;
					},
					paddingBottom: function (i, node) {
						return 0;
					}
				}
			};
			dd.content.push(aANDc);
			var name = i18nFilter('_report_batch_') + ' ' + (vm.batch.ration_name ? vm.batch.ration_name : '') + '.pdf';
			pdfMake.createPdf(dd).download(name);
			reportPromise.resolve();
			return reportPromise.promise;
		}
	}
})();

(function () {
	'use strict';
	angular.module('Spartan.pages.rations.balanceRation').factory('mixReportService', mixReportService);
	/** @ngInject */
	function mixReportService($filter, $q, unitConversionService) {
		var i18nFilter = $filter('i18n');

		return {
			exportUsMixReport: exportUsMixReport,
			exportVemMixReport: exportVemMixReport
		};

		function exportUsMixReport(scope, decimalPlaces) {
			var vm = angular.copy(scope);
			var reportPromise = $q.defer();
			var feed = vm.selectedReportFeed;
			var date = new Date();
			date = $filter('date')(date, 'mediumDate');
			vm.halfMixBatchSize = vm.mixBatchSize / 2;
			vm.doubleMixBatchSize = vm.mixBatchSize * 2;
            feed = unitConversionService.convertData(feed, ['bulkPercentToAmount', 'bulkKgToLb', 'bulkMcalToMjoule'], 1);
			var reportData = {
				dm: feed.dm,
				npncpe: feed.npncpe,
				cost_dm: feed.cost_dm,
				ndf: feed.ndf,
				ef_ndf_as_dm: feed.ef_ndf_as_dm,
				lignin: feed.lignin,
				ndf_digest: feed.ndf_digest,
				adf: feed.adf,
				rd_ndf: feed.rd_ndf,
				disc_fac: feed.disc_fac,
				nel_89: feed.nel_89,
				me_89: feed.me_89,
				cp: feed.cp,
				rup_dig: feed.rup_dig,
				a_prot: feed.a_prot,
				b_prot: feed.b_prot,
				c_prot: feed.c_prot,
				kd_b_prot: feed.kd_b_prot,
				rup_89: feed.rup_89,
				ndicp: feed.ndicp,
				adicp: feed.adicp,
				nfc: feed.nfc,
				nfc_dig: feed.nfc_dig,
				starch: feed.starch,
				rd_starch: feed.rd_starch,
				sugar: feed.sugar,
				in_fa: feed.in_fa,
				sol_fiber: feed.sol_fiber,
				rd_sol_fiber: feed.rd_sol_fiber,
				ee: feed.ee,
				fa: feed.fa,
				sfa: feed.sfa,
				pufa: feed.pufa,
				bhfa: feed.bhfa,
				fa_dig: feed.fa_dig,
				ca: feed.ca,
				ca_abs: feed.ca_abs,
				p: feed.p,
				p_abs: feed.p_abs,
				mg: feed.mg,
				mg_abs: feed.mg_abs,
				k: feed.k,
				na: feed.na,
				cl: feed.cl,
				s: feed.s,
				dcad: feed.dcad,
				ash: feed.ash,
				co: feed.co,
				cu: feed.cu,
				cu_abs: feed.cu_abs,
				fe: feed.fe,
				fe_abs: feed.fe_abs,
				i: feed.i,
				i_abs: feed.i_abs,
				mo: feed.mo,
				mn: feed.mn,
				mn_abs: feed.mn_abs,
				se: feed.se,
				se_abs: feed.se_abs,
				zn: feed.zn,
				zn_abs: feed.zn_abs,
				vitamin_a: feed.vitamin_a,
				vitamin_d: feed.vitamin_d,
				vitamin_e: feed.vitamin_e,
				lysine: feed.lysine,
				methionine: feed.methionine,
				teaa: feed.teaa,
				blank_1: feed.blank_1,
				blank_2: feed.blank_2,
				blank_3: feed.blank_3,
				blank_4: feed.blank_4,
				blank_5: feed.blank_5
			};
			Object.keys(reportData).forEach(function (key) {
				var temp = reportData[key];
				temp = Number(temp);
				if (temp && !isNaN(temp)) {
					var param = temp.toPrecision(3);
					var param_nod = decimalPlaces(param);
					reportData[key] = $filter('number')(param, param_nod);
				}
			});
			reportData.test_date = $filter('date')(feed.test_date, 'shortDate');
			reportData.totalsDM = $filter('number')(100, 2);
			reportData.totalsAsFed = $filter('number')(100, 2);
			reportData.totalsPerCent = $filter('number')(feed.dm, 2);
			reportData.mixBatchSize = $filter('number')(vm.mixBatchSize, 2);
			reportData.halfMixBatchSize = $filter('number')(vm.halfMixBatchSize, 2);
			reportData.doubleMixBatchSize = $filter('number')(vm.doubleMixBatchSize, 2);
			var dd = {
				pageMargins: [25, 40, 20, 40],
				footer: [
					{
						margin: [45, 0, 30, 10],
						table: {
							widths: ['auto'],
							body: [
								[
									{
										text: i18nFilter('_report_footer_feed_'),
										border: [false, false, false, false]
									}
								]
							]
						}
					}
				],
				content: [
					{
						alignment: 'justify',
						columns: [
							{
								text: i18nFilter('_report_mix_'),
								style: 'header'
							},
							{
								text: feed.feed_name ? feed.feed_name : '',
								style: 'header'
							},
							{
								text: date
							}
						]
					},
					'\n',
					{
						columns: [
							{
								text: i18nFilter('_report_prepared_for_'),
								style: 'bold'
							},
							{
								text: i18nFilter('_report_prepared_by_'),
								style: 'bold'
							},
							{
								text: ''
							}
						]
					},
					{
						alignment: 'justify',
						columns: [
							{
								text: vm.preperedFor ? vm.preperedFor : '',
								style: 'small'
							},
							{
								text: vm.preperedBy ? vm.preperedBy : '',
								style: 'small'
							},
							{
								text: '',
								style: 'small'
							}
						]
					},
					'\n',
					{
						style: 'tableStyle',
						table: {
							widths: ['*', 23, 'auto', 'auto', 'auto', 23, 'auto', 'auto', 'auto'],
							body: [
								[
									{
										text: '',
										colSpan: 6,
										border: [false, false, false, false]
									},
									{},
									{},
									{},
									{},
									{},
									{
										text: i18nFilter('_report_batch_amount_asfed_'),
										colSpan: 3,
										border: [false, false, false, false],
										alignment: 'center',
										bold: true
									},
									{},
									{}
								],
								[
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'center',
										bold: true
									},
									{
										text: i18nFilter('_report_mix_composition_'),
										colSpan: 2,
										border: [false, false, false, false],
										alignment: 'center',
										bold: true
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '1/2X',
										border: [false, false, false, false],
										alignment: 'center',
										bold: true
									},
									{
										text: '1X',
										border: [false, false, false, false],
										alignment: 'center',
										bold: true
									},
									{
										text: '2X',
										border: [false, false, false, false],
										alignment: 'center',
										bold: true
									}
								],
								[
									{
										text: i18nFilter('_report_mix_ingredient_name_'),
										border: [false, false, false, true],
										bold: true,
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: vm.settings.use_percent ? '%' : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_report_asfed_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.weight ? vm.weight : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.weight ? vm.weight : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.weight ? vm.weight : '',
										border: [false, false, false, true],
										alignment: 'center'
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 0.5 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function (i, node) {
								return 3;
							},
							paddingRight: function (i, node) {
								return 2;
							},
							paddingTop: function (i, node) {
								return 1;
							},
							paddingBottom: function (i, node) {
								return 1;
							}
						}
					},
					'\n',
					'\n',
					{
						style: 'tableStyle',
						table: {
							body: [
								[
									{
										text: i18nFilter('_report_mix_nutrient_characteristics_'),
										colSpan: 12,
										border: [false, false, false, false],
										bold: true
									},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{}
								],
								[
									{
										text: i18nFilter('_feeds_dm_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.dm ? reportData.dm : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_npncpe_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.npncpe ? reportData.npncpe : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_cp_'),
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_ca_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.ca ? reportData.ca : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_mo_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.mo ? reportData.mo : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, true, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_cost_dm_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.cost_dm ? reportData.cost_dm : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.currency ? vm.currency : '') + '/k',
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_rup89_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.rup_89 ? reportData.rup_89 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_ca_abs_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.ca_abs ? reportData.ca_abs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_ca_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_mn_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.mn ? reportData.mn : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: 'Test date',
										border: [true, false, false, false]
									},
									{
										text: reportData.test_date ? reportData.test_date : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_ndicp_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.ndicp ? reportData.ndicp : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_p_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.p ? reportData.p : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_mn_abs_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.mn_abs ? reportData.mn_abs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_mn_'),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_ndf_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.ndf ? reportData.ndf : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_adicp_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.adicp ? reportData.adicp : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_p_abs_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.p_abs ? reportData.p_abs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_p_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_se_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.se ? reportData.se : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_efndf_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.ef_ndf_as_dm ? reportData.ef_ndf_as_dm : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_ndf_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_nfc_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.nfc ? reportData.nfc : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_mg_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.mg ? reportData.mg : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_se_abs_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.se_abs ? reportData.se_abs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_se_'),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_lingnin_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.lignin ? reportData.lignin : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_nfc_digestibility_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.nfc_dig ? reportData.nfc_dig : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_nfc_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_mg_abs_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.mg_abs ? reportData.mg_abs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_mg_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_zn_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.zn ? reportData.zn : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_ndf_dig_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.ndf_digest ? reportData.ndf_digest : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_ndfn_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_starch_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.starch ? reportData.starch : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_k_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.k ? reportData.k : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_zn_abs_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.zn_abs ? reportData.zn_abs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_zn_'),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_adf_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.adf ? reportData.adf : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_rdstarch_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.rd_starch ? reportData.rd_starch : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_starch_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_na_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.na ? reportData.na : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_vit_a_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.vitamin_a ? reportData.vitamin_a : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_iu_k_') + '/' + (vm.weight ? vm.weight : ''),
										border: [false, true, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_rdndf_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.rd_ndf ? reportData.rd_ndf : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_ndf_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_sugar_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.sugar ? reportData.sugar : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_cl_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.cl ? reportData.cl : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_vit_d_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.vitamin_d ? reportData.vitamin_d : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_iu_k_') + '/' + (vm.weight ? vm.weight : ''),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_disc_fac_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.disc_fac ? reportData.disc_fac : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: '%',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_infa_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.in_fa ? reportData.in_fa : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_s_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.s ? reportData.s : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_vit_e_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.vitamin_e ? reportData.vitamin_e : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_iu_') + '/' + (vm.weight ? vm.weight : ''),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_nel89_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.nel_89 ? reportData.nel_89 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.energy ? vm.energy : '') + '/' + (vm.weight ? vm.weight : ''),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_solfiber_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.sol_fiber ? reportData.sol_fiber : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_dcad_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.dcad ? reportData.dcad : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_meq_') + '/100' + i18nFilter('_unit_grams_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_lysine_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.lysine ? reportData.lysine : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_drup_'),
										border: [false, true, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_me89_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.me_89 ? reportData.me_89 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.energy ? vm.energy : '') + '/' + (vm.weight ? vm.weight : ''),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_rdsolf_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.rd_sol_fiber ? reportData.rd_sol_fiber : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_solfiber_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_ash_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.ash ? reportData.ash : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_methionine_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.methionine ? reportData.methionine : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_drup_'),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_cp_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.cp ? reportData.cp : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_ee_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.ee ? reportData.ee : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_co_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.co ? reportData.co : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_teaa_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.teaa ? reportData.teaa : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_drup_'),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_rup_dig_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.rup_dig ? reportData.rup_dig : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_fa_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.fa ? reportData.fa : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_cu_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.cu ? reportData.cu : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: 'ppm',
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_blank_') + '1',
										border: [true, true, false, false]
									},
									{
										text: reportData.blank_1 ? reportData.blank_1 : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, true, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_protein_a_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.a_prot ? reportData.a_prot : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_cp_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_sfa_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.sfa ? reportData.sfa : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_fa_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_cu_abs_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.cu_abs ? reportData.cu_abs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_cu_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_blank_') + '2',
										border: [true, false, false, false]
									},
									{
										text: reportData.blank_2 ? reportData.blank_2 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_protein_b_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.b_prot ? reportData.b_prot : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_cp_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_pufa_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.pufa ? reportData.pufa : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_fa_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_fe_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.fe ? reportData.fe : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_blank_') + '3',
										border: [true, false, false, false]
									},
									{
										text: reportData.blank_3 ? reportData.blank_3 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_protein_c_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.c_prot ? reportData.c_prot : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_cp_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_bhfa_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.bhfa ? reportData.bhfa : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_fa_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_fe_abs_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.fe_abs ? reportData.fe_abs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_fe_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_blank_') + '4',
										border: [true, false, false, false]
									},
									{
										text: reportData.blank_4 ? reportData.blank_4 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_kd_bprot_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.kd_b_prot ? reportData.kd_b_prot : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%/' + i18nFilter('_unit_hours_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_fa_dig_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.fa_dig ? reportData.fa_dig : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_fa_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_i_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.i ? reportData.i : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_blank_') + '5',
										border: [true, false, false, false]
									},
									{
										text: reportData.blank_5 ? reportData.blank_5 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: '',
										border: [true, false, false, true]
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, true]
									},
									{
										text: '',
										border: [true, false, false, true]
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, true]
									},
									{
										text: i18nFilter('_feeds_i_abs_'),
										border: [true, false, false, true]
									},
									{
										text: reportData.i_abs ? reportData.i_abs : '',
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_i_'),
										border: [false, false, false, true]
									},
									{
										text: '',
										border: [true, false, false, true]
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, true, true]
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function (i, node) {
								return 3;
							},
							paddingRight: function (i, node) {
								return 2;
							},
							paddingTop: function (i, node) {
								return 1;
							},
							paddingBottom: function (i, node) {
								return 1;
							}
						}
					},
					{
						table: {
							widths: ['*'],
							body: [
								[
									{
										text: i18nFilter('_report_assumptions_').toUpperCase(),
										border: [false, false, false, false]
									}
								],
								[
									{
										text: '',
										border: [false, true, false, true]
									}
								],
								[
									{
										text: vm.aAndC ? vm.aAndC : '',
										border: [false, false, false, false]
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1.5 : 1.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'black';
							},
							paddingLeft: function (i, node) {
								return 2;
							},
							paddingRight: function (i, node) {
								return 5;
							},
							paddingTop: function (i, node) {
								return 5;
							},
							paddingBottom: function (i, node) {
								return 0;
							}
						}
					}
				],
				styles: {
					header: {
						fontSize: 15,
						bold: true
					},
					bold: {
						bold: true
					},
					bigger: {
						fontSize: 15,
						italics: true
					},
					small: {
						fontSize: 10
					},
					tableStyle: {
						fontSize: 9,
						margin: [0, 0, 0, 0]
					}
				},
				defaultStyle: {
					fontSize: 10
				}
			};
			var asFedSum = 0;
			for (var i = 0; i < vm.reportMixFeeds.length; i++) {
				vm.reportMixFeeds[i] = unitConversionService.convertData(vm.reportMixFeeds[i], ['bulkPercentToAmount', 'bulkKgToLb', 'bulkMcalToMjoule', 'bulkRoundValues'], 1);
				asFedSum = asFedSum + vm.reportMixFeeds[i].as_fed;
			}
			var b = [
				{
					text: i18nFilter('_report_totals_'),
					border: [false, true, false, false],
					alignment: 'center',
					bold: true
				},
				{
					text: '',
					border: [false, false, false, false]
				},
				{
					text: reportData.totalsPerCent ? reportData.totalsPerCent : '',
					border: [false, true, false, false],
					alignment: 'center',
					bold: true
				},
				{
					text: reportData.totalsAsFed ? reportData.totalsAsFed : '',
					border: [false, true, false, false],
					alignment: 'center',
					bold: true
				},
				{
					text: reportData.totalsAsFed ? reportData.totalsAsFed : '',
					border: [false, true, false, false],
					alignment: 'center',
					bold: true
				},
				{
					text: '',
					border: [false, false, false, false]
				},
				{
					text: reportData.halfMixBatchSize ? reportData.halfMixBatchSize : '',
					border: [false, true, false, false],
					alignment: 'center',
					bold: true
				},
				{
					text: reportData.mixBatchSize ? reportData.mixBatchSize : '',
					border: [false, true, false, false],
					alignment: 'center',
					bold: true
				},
				{
					text: reportData.doubleMixBatchSize ? reportData.doubleMixBatchSize : '',
					border: [false, true, false, false],
					alignment: 'center',
					bold: true
				}
			];
			for (var i = 0; i < vm.reportMixFeeds.length; i++) {
				var asFed = (100 * vm.reportMixFeeds[i].as_fed) / asFedSum;
				asFed = (asFed * vm.mixBatchSize) / 100;
				var temp = Number(asFed);
				if (temp && !isNaN(temp)) {
					var param = temp.toPrecision(3);
					var param_nod = decimalPlaces(param);
					asFed = $filter('number')(param, param_nod);
				}
				var dietDMI = Number(vm.reportMixFeeds[i].diet_dmi);
				if (temp && !isNaN(dietDMI)) {
					var param = dietDMI.toPrecision(3);
					var param_nod = decimalPlaces(param);
					vm.reportMixFeeds[i].diet_dmi = $filter('number')(param, param_nod);
				}
				var halfAsFed = asFed / 2;
				var doubleAsFed = asFed * 2;
				var a = [
					{
						text: vm.reportMixFeeds[i].feed_name ? vm.reportMixFeeds[i].feed_name : '',
						border: [false, false, false, false]
					},
					{
						text: '',
						border: [false, false, false, false],
						alignment: 'center'
					},
					{
						text: vm.reportMixFeeds[i].dm ? vm.reportMixFeeds[i].dm : '',
						border: [false, false, false, false],
						alignment: 'center'
					},
					{
						text: vm.reportMixFeeds[i].diet_dmi ? vm.reportMixFeeds[i].diet_dmi : '',
						border: [false, false, false, false],
						alignment: 'center'
					},
					{
						text: asFed ? asFed : '',
						border: [false, false, false, false],
						alignment: 'center'
					},
					{
						text: '',
						border: [false, false, false, false]
					},
					{
						text: halfAsFed ? halfAsFed : '',
						border: [false, false, false, false],
						alignment: 'center'
					},
					{
						text: asFed ? asFed : '',
						border: [false, false, false, false],
						alignment: 'center'
					},
					{
						text: doubleAsFed ? doubleAsFed : '',
						border: [false, false, false, false],
						alignment: 'center'
					}
				];
				dd.content[5].table.body.push(a);
			}
			dd.content[5].table.body.push(b);
			var name = feed.feed_name + '.pdf';
			pdfMake.createPdf(dd).download(name);
			reportPromise.resolve();
			return reportPromise.promise;
		}

		function exportVemMixReport(vm, decimalPlaces) {
			var reportPromise = $q.defer();
			var feed = vm.selectedReportFeed;
			var date = new Date();
			date = $filter('date')(date, 'mediumDate');
			vm.halfMixBatchSize = vm.mixBatchSize / 2;
			vm.doubleMixBatchSize = vm.mixBatchSize * 2;
            feed = unitConversionService.convertData(feed, ['bulkPercentToAmount', 'bulkKgToLb', 'bulkMcalToMjoule'], 1);
			var reportData = {
				dm: feed.dm,
				npncpe: feed.npncpe,
				cost_dm: feed.cost_dm,
				ndf: feed.ndf,
				ef_ndf_as_dm: feed.ef_ndf_as_dm,
				lignin: feed.lignin,
				ndf_digest: feed.ndf_digest,
				adf: feed.adf,
				rd_ndf: feed.rd_ndf,
				disc_fac: feed.disc_fac,
				nel_89: feed.nel_89,
				me_89: feed.me_89,
				cp: feed.cp,
				rup_dig: feed.rup_dig,
				a_prot: feed.a_prot,
				b_prot: feed.b_prot,
				c_prot: feed.c_prot,
				kd_b_prot: feed.kd_b_prot,
				rup_89: feed.rup_89,
				ndicp: feed.ndicp,
				adicp: feed.adicp,
				nfc: feed.nfc,
				nfc_dig: feed.nfc_dig,
				starch: feed.starch,
				rd_starch: feed.rd_starch,
				sugar: feed.sugar,
				in_fa: feed.in_fa,
				sol_fiber: feed.sol_fiber,
				rd_sol_fiber: feed.rd_sol_fiber,
				ee: feed.ee,
				fa: feed.fa,
				sfa: feed.sfa,
				pufa: feed.pufa,
				bhfa: feed.bhfa,
				fa_dig: feed.fa_dig,
				ca: feed.ca,
				ca_abs: feed.ca_abs,
				p: feed.p,
				p_abs: feed.p_abs,
				mg: feed.mg,
				mg_abs: feed.mg_abs,
				k: feed.k,
				na: feed.na,
				cl: feed.cl,
				s: feed.s,
				dcad: feed.dcad,
				ash: feed.ash,
				co: feed.co,
				cu: feed.cu,
				cu_abs: feed.cu_abs,
				fe: feed.fe,
				fe_abs: feed.fe_abs,
				i: feed.i,
				i_abs: feed.i_abs,
				mo: feed.mo,
				mn: feed.mn,
				mn_abs: feed.mn_abs,
				se: feed.se,
				se_abs: feed.se_abs,
				zn: feed.zn,
				zn_abs: feed.zn_abs,
				vitamin_a: feed.vitamin_a,
				vitamin_d: feed.vitamin_d,
				vitamin_e: feed.vitamin_e,
				lysine: feed.lysine,
				methionine: feed.methionine,
				teaa: feed.teaa,
				blank_1: feed.blank_1,
				blank_2: feed.blank_2,
				blank_3: feed.blank_3,
				blank_4: feed.blank_4,
				blank_5: feed.blank_5,
				vem: feed.vem,
				fos: feed.fos,
				dve: feed.dve,
				oeb: feed.oeb
			};
			Object.keys(reportData).forEach(function (key) {
				var temp = reportData[key];
				temp = Number(temp);
				if (temp && !isNaN(temp)) {
					var param = temp.toPrecision(3);
					var param_nod = decimalPlaces(param);
					reportData[key] = $filter('number')(param, param_nod);
				}
			});
			reportData.test_date = $filter('date')(feed.test_date, 'shortDate');
			reportData.totalsDM = $filter('number')(100, 2);
			reportData.totalsAsFed = $filter('number')(100, 2);
			reportData.totalsPerCent = $filter('number')(feed.dm, 2);
			reportData.mixBatchSize = $filter('number')(vm.mixBatchSize, 2);
			reportData.halfMixBatchSize = $filter('number')(vm.halfMixBatchSize, 2);
			reportData.doubleMixBatchSize = $filter('number')(vm.doubleMixBatchSize, 2);
			var dd = {
				pageMargins: [25, 40, 20, 40],
				footer: [
					{
						margin: [45, 0, 30, 10],
						table: {
							widths: ['auto'],
							body: [
								[
									{
										text: i18nFilter('_report_footer_feed_'),
										border: [false, false, false, false]
									}
								]
							]
						}
					}
				],
				content: [
					{
						alignment: 'justify',
						columns: [
							{
								text: i18nFilter('_report_mix_'),
								style: 'header'
							},
							{
								text: feed.feed_name ? feed.feed_name : '',
								style: 'header'
							},
							{
								text: date
							}
						]
					},
					'\n',
					{
						columns: [
							{
								text: i18nFilter('_report_prepared_for_'),
								style: 'bold'
							},
							{
								text: i18nFilter('_report_prepared_by_'),
								style: 'bold'
							},
							{
								text: ''
							}
						]
					},
					{
						alignment: 'justify',
						columns: [
							{
								text: vm.preperedFor ? vm.preperedFor : '',
								style: 'small'
							},
							{
								text: vm.preperedBy ? vm.preperedBy : '',
								style: 'small'
							},
							{
								text: '',
								style: 'small'
							}
						]
					},
					'\n',
					{
						style: 'tableStyle',
						table: {
							widths: ['*', 23, 'auto', 'auto', 'auto', 23, 'auto', 'auto', 'auto'],
							body: [
								[
									{
										text: '',
										colSpan: 6,
										border: [false, false, false, false]
									},
									{},
									{},
									{},
									{},
									{},
									{
										text: i18nFilter('_report_batch_amount_asfed_'),
										colSpan: 3,
										border: [false, false, false, false],
										alignment: 'center',
										bold: true
									},
									{},
									{}
								],
								[
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'center',
										bold: true
									},
									{
										text: i18nFilter('_report_mix_composition_'),
										colSpan: 2,
										border: [false, false, false, false],
										alignment: 'center',
										bold: true
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '1/2X',
										border: [false, false, false, false],
										alignment: 'center',
										bold: true
									},
									{
										text: '1X',
										border: [false, false, false, false],
										alignment: 'center',
										bold: true
									},
									{
										text: '2X',
										border: [false, false, false, false],
										alignment: 'center',
										bold: true
									}
								],
								[
									{
										text: i18nFilter('_report_mix_ingredient_name_'),
										border: [false, false, false, true],
										bold: true,
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: vm.settings.use_percent ? '%' : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_report_asfed_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.weight ? vm.weight : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.weight ? vm.weight : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.weight ? vm.weight : '',
										border: [false, false, false, true],
										alignment: 'center'
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 0.5 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function (i, node) {
								return 3;
							},
							paddingRight: function (i, node) {
								return 2;
							},
							paddingTop: function (i, node) {
								return 1;
							},
							paddingBottom: function (i, node) {
								return 1;
							}
						}
					},
					'\n',
					'\n',
					{
						style: 'tableStyle',
						table: {
							body: [
								[
									{
										text: i18nFilter('_report_mix_nutrient_characteristics_'),
										colSpan: 12,
										border: [false, false, false, false],
										bold: true
									},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{}
								],
								[
									{
										text: i18nFilter('_feeds_dm_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.dm ? reportData.dm : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_npncpe_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.npncpe ? reportData.npncpe : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_cp_'),
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_ca_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.ca ? reportData.ca : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_mo_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.mo ? reportData.mo : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, true, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_cost_dm_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.cost_dm ? reportData.cost_dm : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.currency ? vm.currency : '') + '/k',
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_rup89_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.rup_89 ? reportData.rup_89 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_ca_abs_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.ca_abs ? reportData.ca_abs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_ca_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_mn_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.mn ? reportData.mn : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: 'Test date',
										border: [true, false, false, false]
									},
									{
										text: reportData.test_date ? reportData.test_date : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_ndicp_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.ndicp ? reportData.ndicp : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_p_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.p ? reportData.p : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_mn_abs_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.mn_abs ? reportData.mn_abs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_mn_'),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_ndf_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.ndf ? reportData.ndf : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_adicp_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.adicp ? reportData.adicp : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_p_abs_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.p_abs ? reportData.p_abs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_p_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_se_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.se ? reportData.se : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_efndf_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.ef_ndf_as_dm ? reportData.ef_ndf_as_dm : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_ndf_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_nfc_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.nfc ? reportData.nfc : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_mg_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.mg ? reportData.mg : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_se_abs_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.se_abs ? reportData.se_abs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_se_'),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_lingnin_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.lignin ? reportData.lignin : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_nfc_digestibility_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.nfc_dig ? reportData.nfc_dig : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_nfc_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_mg_abs_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.mg_abs ? reportData.mg_abs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_mg_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_zn_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.zn ? reportData.zn : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_ndf_dig_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.ndf_digest ? reportData.ndf_digest : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_ndfn_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_starch_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.starch ? reportData.starch : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_k_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.k ? reportData.k : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_zn_abs_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.zn_abs ? reportData.zn_abs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_zn_'),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_adf_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.adf ? reportData.adf : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_rdstarch_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.rd_starch ? reportData.rd_starch : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_starch_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_na_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.na ? reportData.na : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_vit_a_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.vitamin_a ? reportData.vitamin_a : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_iu_k_') + '/' + (vm.weight ? vm.weight : ''),
										border: [false, true, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_rdndf_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.rd_ndf ? reportData.rd_ndf : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_ndf_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_sugar_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.sugar ? reportData.sugar : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_cl_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.cl ? reportData.cl : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_vit_d_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.vitamin_d ? reportData.vitamin_d : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_iu_k_') + '/' + (vm.weight ? vm.weight : ''),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_disc_fac_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.disc_fac ? reportData.disc_fac : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: '%',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_infa_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.in_fa ? reportData.in_fa : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_s_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.s ? reportData.s : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_vit_e_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.vitamin_e ? reportData.vitamin_e : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_iu_') + '/' + (vm.weight ? vm.weight : ''),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_nel89_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.nel_89 ? reportData.nel_89 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.energy ? vm.energy : '') + '/' + (vm.weight ? vm.weight : ''),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_solfiber_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.sol_fiber ? reportData.sol_fiber : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_dcad_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.dcad ? reportData.dcad : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_meq_') + '/100' + i18nFilter('_unit_grams_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_lysine_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.lysine ? reportData.lysine : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_drup_'),
										border: [false, true, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_me89_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.me_89 ? reportData.me_89 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.energy ? vm.energy : '') + '/' + (vm.weight ? vm.weight : ''),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_rdsolf_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.rd_sol_fiber ? reportData.rd_sol_fiber : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_solfiber_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_ash_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.ash ? reportData.ash : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_methionine_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.methionine ? reportData.methionine : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_drup_'),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_vem_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.vem ? reportData.vem : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_ee_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.ee ? reportData.ee : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_co_'),
										border: [true, true, false, false]
									},
									{
										text: reportData.co ? reportData.co : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_teaa_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.teaa ? reportData.teaa : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_drup_'),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_fos_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.fos ? reportData.fos : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_grams_') + '/' + vm.weight + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_fa_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.fa ? reportData.fa : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_cu_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.cu ? reportData.cu : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: 'ppm',
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_blank_') + '1',
										border: [true, true, false, false]
									},
									{
										text: reportData.blank_1 ? reportData.blank_1 : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, true, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_cp_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.cp ? reportData.cp : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_sfa_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.sfa ? reportData.sfa : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_fa_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_cu_abs_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.cu_abs ? reportData.cu_abs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_cu_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_blank_') + '2',
										border: [true, false, false, false]
									},
									{
										text: reportData.blank_2 ? reportData.blank_2 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_dve_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.dve ? reportData.dve : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_grams_') + '/' + vm.weight + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_pufa_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.pufa ? reportData.pufa : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_fa_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_fe_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.fe ? reportData.fe : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_blank_') + '3',
										border: [true, false, false, false]
									},
									{
										text: reportData.blank_3 ? reportData.blank_3 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_oeb_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.oeb ? reportData.oeb : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_grams_') + '/' + vm.weight + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_bhfa_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.bhfa ? reportData.bhfa : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_fa_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_fe_abs_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.fe_abs ? reportData.fe_abs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_fe_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_blank_') + '4',
										border: [true, false, false, false]
									},
									{
										text: reportData.blank_4 ? reportData.blank_4 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_rup_dig_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.rup_dig ? reportData.rup_dig : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_fa_dig_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.fa_dig ? reportData.fa_dig : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_fa_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_i_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.i ? reportData.i : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_blank_') + '5',
										border: [true, false, false, false]
									},
									{
										text: reportData.blank_5 ? reportData.blank_5 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_protein_a_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.a_prot ? reportData.a_prot : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_cp_'),
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [true, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_feeds_i_abs_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.i_abs ? reportData.i_abs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_i_'),
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [true, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_protein_b_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.b_prot ? reportData.b_prot : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_cp_'),
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [true, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [true, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [true, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_protein_c_'),
										border: [true, false, false, false]
									},
									{
										text: reportData.c_prot ? reportData.c_prot : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_cp_'),
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [true, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [true, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [true, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: i18nFilter('_feeds_kd_bprot_'),
										border: [true, false, false, true]
									},
									{
										text: reportData.kd_b_prot ? reportData.kd_b_prot : '',
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: '%/' + i18nFilter('_unit_hours_'),
										border: [false, false, false, true]
									},
									{
										text: '',
										border: [true, false, false, true]
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, true]
									},
									{
										text: '',
										border: [true, false, false, true]
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, true]
									},
									{
										text: '',
										border: [true, false, false, true]
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, true, true]
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function (i, node) {
								return 3;
							},
							paddingRight: function (i, node) {
								return 2;
							},
							paddingTop: function (i, node) {
								return 1;
							},
							paddingBottom: function (i, node) {
								return 1;
							}
						}
					},
					{
						table: {
							widths: ['*'],
							body: [
								[
									{
										text: i18nFilter('_report_assumptions_').toUpperCase(),
										border: [false, false, false, false]
									}
								],
								[
									{
										text: '',
										border: [false, true, false, true]
									}
								],
								[
									{
										text: vm.aAndC ? vm.aAndC : '',
										border: [false, false, false, false]
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1.5 : 1.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'black';
							},
							paddingLeft: function (i, node) {
								return 2;
							},
							paddingRight: function (i, node) {
								return 5;
							},
							paddingTop: function (i, node) {
								return 5;
							},
							paddingBottom: function (i, node) {
								return 0;
							}
						}
					}
				],
				styles: {
					header: {
						fontSize: 15,
						bold: true
					},
					bold: {
						bold: true
					},
					bigger: {
						fontSize: 15,
						italics: true
					},
					small: {
						fontSize: 10
					},
					tableStyle: {
						fontSize: 9,
						margin: [0, 0, 0, 0]
					}
				},
				defaultStyle: {
					fontSize: 10
				}
			};
			var asFedSum = 0;
			for (var i = 0; i < vm.reportMixFeeds.length; i++) {
				vm.reportMixFeeds[i] = unitConversionService.convertData(vm.reportMixFeeds[i], ['bulkPercentToAmount', 'bulkKgToLb', 'bulkMcalToMjoule', 'bulkRoundValues'], 1);
				asFedSum = asFedSum + vm.reportMixFeeds[i].as_fed;
			}
			var b = [
				{
					text: i18nFilter('_report_totals_'),
					border: [false, true, false, false],
					alignment: 'center',
					bold: true
				},
				{
					text: '',
					border: [false, false, false, false]
				},
				{
					text: reportData.totalsPerCent ? reportData.totalsPerCent : '',
					border: [false, true, false, false],
					alignment: 'center',
					bold: true
				},
				{
					text: reportData.totalsAsFed ? reportData.totalsAsFed : '',
					border: [false, true, false, false],
					alignment: 'center',
					bold: true
				},
				{
					text: reportData.totalsAsFed ? reportData.totalsAsFed : '',
					border: [false, true, false, false],
					alignment: 'center',
					bold: true
				},
				{
					text: '',
					border: [false, false, false, false]
				},
				{
					text: reportData.halfMixBatchSize ? reportData.halfMixBatchSize : '',
					border: [false, true, false, false],
					alignment: 'center',
					bold: true
				},
				{
					text: reportData.mixBatchSize ? reportData.mixBatchSize : '',
					border: [false, true, false, false],
					alignment: 'center',
					bold: true
				},
				{
					text: reportData.doubleMixBatchSize ? reportData.doubleMixBatchSize : '',
					border: [false, true, false, false],
					alignment: 'center',
					bold: true
				}
			];
			for (var i = 0; i < vm.reportMixFeeds.length; i++) {
				var asFed = (100 * vm.reportMixFeeds[i].as_fed) / asFedSum;
				asFed = (asFed * vm.mixBatchSize) / 100;
				var temp = Number(asFed);
				if (temp && !isNaN(temp)) {
					var param = temp.toPrecision(3);
					var param_nod = decimalPlaces(param);
					asFed = $filter('number')(param, param_nod);
				}
				var dietDMI = Number(vm.reportMixFeeds[i].diet_dmi);
				if (temp && !isNaN(dietDMI)) {
					var param = dietDMI.toPrecision(3);
					var param_nod = decimalPlaces(param);
					vm.reportMixFeeds[i].diet_dmi = $filter('number')(param, param_nod);
				}
				var halfAsFed = asFed / 2;
				var doubleAsFed = asFed * 2;
				var a = [
					{
						text: vm.reportMixFeeds[i].feed_name ? vm.reportMixFeeds[i].feed_name : '',
						border: [false, false, false, false]
					},
					{
						text: '',
						border: [false, false, false, false],
						alignment: 'center'
					},
					{
						text: vm.reportMixFeeds[i].dm ? vm.reportMixFeeds[i].dm : '',
						border: [false, false, false, false],
						alignment: 'center'
					},
					{
						text: vm.reportMixFeeds[i].diet_dmi ? vm.reportMixFeeds[i].diet_dmi : '',
						border: [false, false, false, false],
						alignment: 'center'
					},
					{
						text: asFed ? asFed : '',
						border: [false, false, false, false],
						alignment: 'center'
					},
					{
						text: '',
						border: [false, false, false, false]
					},
					{
						text: halfAsFed ? halfAsFed : '',
						border: [false, false, false, false],
						alignment: 'center'
					},
					{
						text: asFed ? asFed : '',
						border: [false, false, false, false],
						alignment: 'center'
					},
					{
						text: doubleAsFed ? doubleAsFed : '',
						border: [false, false, false, false],
						alignment: 'center'
					}
				];
				dd.content[5].table.body.push(a);
			}
			dd.content[5].table.body.push(b);
			var name = feed.feed_name + '.pdf';
			pdfMake.createPdf(dd).download(name);
			reportPromise.resolve();
			return reportPromise.promise;
		}
	}
})();

/* eslint-disable no-unused-vars */
/* eslint-disable no-redeclare */
(function () {
	'use strict';
	angular.module('Spartan.pages.rations.balanceRation').factory('summaryOfficeReportService', summaryOfficeReportService);
	/** @ngInject */
	function summaryOfficeReportService($filter, $q, APP_CONST, unitConversionService) {
		var i18nFilter = $filter('i18n');
		var formatViewValuesSignificant = $filter('formatViewValuesSignificant');

		return {
			exportSummaryOfficeReportUS: exportSummaryOfficeReportUS,
			exportSummaryOfficeReportVem: exportSummaryOfficeReportVem
		};

		function exportSummaryOfficeReportUS(isSummary, scope, round, setSignificant, RRToLb, RRToMjoule) {
			var reportPromise = $q.defer();
			var vm = angular.copy(scope);
			vm.summary.group = {};
			vm.breeds = APP_CONST.mocks.breeds;
			for (var i = 0; i < vm.breeds.length; i++) {
				if (vm.breeds[i].value == vm.ration.group.breed) {
					vm.summary.group.breed = vm.breeds[i].name;
					break;
				}
			}
			vm.animal_types = APP_CONST.mocks.animal_types;
			for (var i = 0; i < vm.animal_types.length; i++) {
				if (vm.animal_types[i].type == vm.ration.group.type) {
					vm.summary.group.animal_type = vm.animal_types[i].name;
					break;
				}
			}
			vm.summary.group.current_age = vm.ration.group.current_age;
			vm.summary.group.target_age = vm.ration.group.target_age;
			vm.summary.group.upcoming_lactation_number = vm.ration.group.upcoming_lactation_number;
			vm.summary.group.lactation_number = vm.ration.group.lactation_number;
			vm.summary.group.days_in_milk = vm.ration.group.days_in_milk;
			vm.summary.group.target_milk_yield = $filter('number')(vm.ration.group.target_milk_yield, 1);
			vm.summary.group.actual_milk_yield = $filter('number')(vm.ration.group.actual_milk_yield, 1);
			vm.summary.group.target_fat = $filter('number')(vm.ration.group.target_fat, 2);
			vm.summary.group.actual_fat = $filter('number')(vm.ration.group.actual_fat, 2);
			vm.summary.group.target_protein = $filter('number')(vm.ration.group.target_t_protein, 2);
			vm.summary.group.actual_protein = $filter('number')(vm.ration.group.actual_t_protein, 2);
			vm.summary.group.target_lactose = $filter('number')(vm.ration.group.target_lactose, 2);
			vm.summary.group.actual_lactose = $filter('number')(vm.ration.group.actual_lactose, 2);
			var bw_without_fetus = vm.ration.group.bw_without_fetus;
			vm.summary.group.bw_without_fetus = round(bw_without_fetus, 0);
			vm.summary.group.body_condition_score = vm.ration.group.body_condition_score;
			var target_daily_bw_gain = vm.ration.group.target_daily_bw_gain;
			target_daily_bw_gain = Number(target_daily_bw_gain);
			if (target_daily_bw_gain && !isNaN(target_daily_bw_gain)) {
				var param = target_daily_bw_gain.toPrecision(3);
				var param_nod = decimalPlaces(param);
				target_daily_bw_gain = $filter('number')(param, param_nod);
			}
			vm.summary.group.target_daily_bw_gain = target_daily_bw_gain;
			var mature_bw = vm.ration.group.mature_bw;
			vm.summary.group.mature_bw = round(mature_bw, 0);
			vm.summary.group.days_pregnant = vm.ration.group.days_pregnant;
			var ts = APP_CONST.constants.temperature_stresses;
			for (var i = 0; i < ts.length; i++) {
				if (ts[i].name == vm.ration.ration_header.temperature_stress) {
					vm.summary.group.temperature_stress = i18nFilter(ts[i].value);
					break;
				}
			}
			var al = APP_CONST.constants.activity_levels;
			for (var i = 0; i < al.length; i++) {
				if (al[i].name == vm.ration.ration_header.activity_level) {
					vm.summary.group.activity_level = i18nFilter(al[i].value);
					break;
				}
			}
			var fa = APP_CONST.constants.feed_additives;
			for (var i = 0; i < fa.length; i++) {
				if (fa[i].name == vm.ration.ration_header.description) {
					vm.summary.group.feed_additive = i18nFilter(fa[i].value);
					break;
				}
			}
			var mps = APP_CONST.constants.met_prot_sys;
			for (var i = 0; i < mps.length; i++) {
				if (mps[i].value == vm.ration.ration_header.model_name) {
					vm.summary.group.met_prot_sys = i18nFilter(mps[i].name);
					break;
				}
			}
			var feeds = [];
			for (var i = 0; i < vm.ration.feeds.length; i++) {
				vm.ration.feeds[i] = unitConversionService.convertData(vm.ration.feeds[i], ['bulkPercentToAmount', 'bulkKgToLb', 'bulkMcalToMjoule', 'bulkRoundValues', 'bulkGetSignificant'], 1);
				if (vm.ration.feeds[i].amount > 0) {
					feeds.push(vm.ration.feeds[i]);
				}
			}
			vm.summary.feeds = feeds;
			vm.ration.balance_amount = unitConversionService.convertData(vm.ration.balance_amount, ['bulkPercentToAmount', 'bulkKgToLb', 'bulkMcalToMjoule', 'bulkRoundValues', 'bulkGetSignificant'], 2);
			vm.ration.requirement_amount = unitConversionService.convertData(vm.ration.requirement_amount, ['bulkPercentToAmount', 'bulkKgToLb', 'bulkMcalToMjoule', 'bulkRoundValues', 'bulkGetSignificant'], 2);
			vm.ration.supply_amount = unitConversionService.convertData(vm.ration.supply_amount, ['bulkPercentToAmount', 'bulkKgToLb', 'bulkMcalToMjoule', 'bulkRoundValues', 'bulkGetSignificant'], 2);
			vm.ration.balance_conc = unitConversionService.convertData(vm.ration.balance_conc, ['balanceKgToLbConcentration', 'bulkMcalToMjoule', 'bulkRoundValues', 'bulkGetSignificant'], 3);
			vm.ration.requirement_conc = unitConversionService.convertData(vm.ration.requirement_conc, ['balanceKgToLbConcentration', 'bulkMcalToMjoule', 'bulkRoundValues', 'bulkGetSignificant'], 3);
			vm.ration.supply_conc = unitConversionService.convertData(vm.ration.supply_conc, ['balanceKgToLbConcentration', 'bulkMcalToMjoule', 'bulkRoundValues', 'bulkGetSignificant'], 3);
			// var formattedValue = formatViewValuesSignificant(vm.ration.supply_conc.k, 'k');
			var randr = {};
			angular.copy(vm.ration.rations_and_relationships, randr);
			if (!vm.settings.use_kgs) {
				randr = RRToLb(randr);
			}
			if (!vm.settings.use_mcal) {
				randr = RRToMjoule(randr);
			}
			randr = setSignificant(randr);
			vm.summary.randr = randr;
			if (vm.ration.group.type == 'heifer') {
				var negOrNel = i18nFilter('_rations_neg_');
				var negOrNelSupply = vm.ration.supply_amount.neg;
				var negOrNelRequirements = vm.ration.requirement_amount.neg;
				var negOrNelBalance = vm.ration.balance_amount.neg;
			} else {
				var negOrNel = i18nFilter('_feeds_nel_');
				var negOrNelSupply = vm.ration.supply_amount.nel;
				var negOrNelRequirements = vm.ration.requirement_amount.nel;
				var negOrNelBalance = vm.ration.balance_amount.nel;
			}
			var energyAllowable = '';
			var proteinAllowable = '';
			var energyAllowableValue = '';
			var proteinAllowableValue = '';
			if (vm.ration.group.type == 'heifer') {
				energyAllowable = i18nFilter('_rations_energy_allowable_gain_');
				proteinAllowable = i18nFilter('_rations_protein_allowable_gain_');
				energyAllowableValue = vm.summary.randr.energyallowable_gain;
				proteinAllowableValue = vm.summary.randr.proteinallowable_gain;
			} else if (vm.ration.group.type == 'drycow/late_pregnant_heifer') {
				energyAllowable = i18nFilter('_rations_energy_allowable_bc_gain_');
				proteinAllowable = i18nFilter('_rations_protein_allowable_bc_gain_');
				energyAllowableValue = vm.summary.randr.energyallowable_bc_gain;
				proteinAllowableValue = vm.summary.randr.proteinallowable_bc_gain;
			} else if (vm.ration.group.type == 'lactating_cow') {
				energyAllowable = i18nFilter('_rations_energy_allowable_milk_');
				proteinAllowable = i18nFilter('_rations_protein_allowable_milk_');
				energyAllowableValue = vm.summary.randr.energyallowable_milk;
				proteinAllowableValue = vm.summary.randr.proteinallowable_milk;
			}
			var c0r0 = '';
			var c0r1 = '';
			var c0r2 = '';
			var c0r3 = '';
			var c1r0 = '';
			var c1r1 = '';
			var c1r2 = '';
			var c1r3 = '';
			var c2r0 = '';
			var c2r1 = '';
			var c2r2 = '';
			var c2r3 = '';
			var c3r0 = '';
			var c3r1 = '';
			var c3r2 = '';
			var c3r3 = '';
			var c4r0 = '';
			var c4r1 = '';
			var c4r2 = '';
			var c4r3 = '';
			var c5r0 = '';
			var c5r1 = '';
			var c5r2 = '';
			var c5r3 = '';
			var c6r0 = '';
			var c6r1 = '';
			var c6r2 = '';
			var c6r3 = '';
			var c7r0 = '';
			var c7r1 = '';
			var c7r2 = '';
			var c7r3 = '';
			var rr04 = '';
			var rr05 = '';
			var rr14 = '';
			var rr15 = '';
			var rr24 = '';
			var rr25 = '';
			var rr31 = '';
			var rr41 = '';
			var rr51 = '';
			var rr32 = '';
			var rr42 = '';
			var rr52 = '';
			if (vm.ration.group.type == 'heifer') {
				c1r1 = i18nFilter('_groups_current_age_') + ':';
				c1r2 = vm.summary.group.current_age;
				c1r3 = i18nFilter('_unit_months_');
				c2r1 = i18nFilter('_groups_target_age_') + ':';
				c2r2 = vm.summary.group.target_age;
				c2r3 = i18nFilter('_unit_months_');
			} else if (vm.ration.group.type == 'lactating_cow') {
				c1r2 = i18nFilter('_report_lactation_number_') + ':';
				c1r3 = vm.summary.group.lactation_number;
				c2r2 = i18nFilter('_groups_days_in_milk_') + ':';
				c2r3 = vm.summary.group.days_in_milk;
				c3r1 = i18nFilter('_report_target_');
				c3r2 = i18nFilter('_report_actual_');
				c4r0 = i18nFilter('_report_milk_yield_') + ':';
				c4r1 = vm.summary.group.target_milk_yield;
				c4r2 = vm.summary.group.actual_milk_yield;
				c4r3 = vm.weight + '/' + i18nFilter('_unit_day_');
				c5r0 = i18nFilter('_report_fat_') + ':';
				c5r1 = vm.summary.group.target_fat;
				c5r2 = vm.summary.group.actual_fat;
				c5r3 = '%';
				c6r0 = i18nFilter('_report_protein_') + ':';
				c6r1 = vm.summary.group.target_protein;
				c6r2 = vm.summary.group.actual_protein;
				c6r3 = '%';
				c7r0 = i18nFilter('_report_lactose_') + ':';
				c7r1 = vm.summary.group.target_lactose;
				c7r2 = vm.summary.group.actual_lactose;
				c7r3 = '%';
				var rr04 = i18nFilter('_rations_energy_corrected_milk_');
				var rr05 = i18nFilter('_rations_energy_corrected_milk_short_') + '/' + i18nFilter('_feeds_dmi_');
				var rr14 = vm.summary.randr.energycorrected_milk;
				var rr15 = vm.summary.randr.ecm_dmi;
				var rr24 = vm.weight + '/' + i18nFilter('_unit_day_');
				var rr25 = '';
				var rr31 = i18nFilter('_rations_feed_cost_') + '/' + i18nFilter('_rations_100_wt_milk_');
				var rr41 = vm.summary.randr.feed_cost_100_wt_milk;
				var rr51 = vm.currency + '/100';
				var rr32 = i18nFilter('_rations_income_over_feed_costs_');
				var rr42 = vm.summary.randr.income_over_feed_costs;
				var rr52 = vm.currency + '/' + i18nFilter('_unit_day_');
			} else if (vm.ration.group.type == 'drycow/late_pregnant_heifer') {
				c1r2 = i18nFilter('_report_upcoming_lactation_number_') + ':';
				c1r3 = vm.summary.group.upcoming_lactation_number;
			}
			var dd = {
				pageMargins: [25, 40, 20, 40],
				header: [
					{
						alignment: 'justify',
						style: 'headerStyle',
						columns: [
							{
								text: isSummary ? i18nFilter('_report_summary_') : i18nFilter('_report_office_report_'),
								margin: [25, 10, 0, 0],
								width: 200
							},
							{
								text: vm.summary.ration_name ? vm.summary.ration_name : '',
								margin: [0, 10, 0, 0],
								width: '*'
							},
							{
								text: $filter('date')(new Date(), 'shortDate'),
								bold: false,
								fontSize: 12,
								margin: [10, 12, 0, 0],
								width: 100
							}
						]
					}
				],
				footer: [
					{
						margin: [45, 0, 30, 10],
						table: {
							widths: ['auto'],
							body: [
								[
									{
										text: i18nFilter('_report_footer_feed_'),
										border: [false, false, false, false]
									}
								]
							]
						}
					}
				],
				content: [
					{
						alignment: 'justify',
						columns: [
							{
								text: i18nFilter('_report_prepared_for_') + ':',
								style: 'bold'
							},
							{
								text: i18nFilter('_report_prepared_by_') + ':',
								style: 'bold'
							}
						]
					},
					{
						alignment: 'justify',
						columns: [
							{
								text: vm.preperedFor ? vm.preperedFor : '',
								style: 'small'
							},
							{
								text: vm.preperedBy ? vm.preperedBy : '',
								style: 'small'
							}
						]
					},
					'\n',
					{
						table: {
							body: [
								[
									{
										text: (vm.summary.group.breed ? vm.summary.group.breed : '') + ', ' + (vm.summary.group.animal_type ? vm.summary.group.animal_type : ''),
										colSpan: 7,
										border: [false, false, false, false]
									},
									{},
									{},
									{},
									{},
									{},
									{}
								],
								[
									{
										text: c0r0 ? c0r0 : '',
										border: [true, true, false, false]
									},
									{
										text: c0r1 ? c0r1 : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: c0r2 ? c0r2 : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: c0r3 ? c0r3 : '',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_report_body_weight_without_fetus_') + ':',
										border: [true, true, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.group.bw_without_fetus ? vm.summary.group.bw_without_fetus : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: vm.weight ? vm.weight : '',
										border: [false, true, true, false]
									}
								],
								[
									{
										text: c1r0 ? c1r0 : '',
										border: [true, false, false, false]
									},
									{
										text: c1r1 ? c1r1 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: c1r2 ? c1r2 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: c1r3 ? c1r3 : '',
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_report_current_body_condition_score_') + ':',
										border: [true, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.group.body_condition_score ? vm.summary.group.body_condition_score : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: c2r0 ? c2r0 : '',
										border: [true, false, false, false]
									},
									{
										text: c2r1 ? c2r1 : '',
										border: [false, false, false, false]
									},
									{
										text: c2r2 ? c2r2 : '',
										border: [false, false, false, false]
									},
									{
										text: c2r3 ? c2r3 : '',
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_report_target_daily_gain_') + ':',
										border: [true, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.group.target_daily_bw_gain ? vm.summary.group.target_daily_bw_gain : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: c3r0 ? c3r0 : '',
										border: [true, false, false, true]
									},
									{
										text: c3r1 ? c3r1 : '',
										border: [false, false, false, true],
										alignment: 'right',
										bold: true
									},
									{
										text: c3r2 ? c3r2 : '',
										border: [false, false, false, true],
										alignment: 'right',
										bold: true
									},
									{
										text: c3r3 ? c3r3 : '',
										border: [false, false, false, true]
									},
									{
										text: i18nFilter('_groups_mature_bw_') + ':',
										border: [true, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.group.mature_bw ? vm.summary.group.mature_bw : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.weight ? vm.weight : '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: c4r0 ? c4r0 : '',
										border: [true, false, false, false],
										alignment: 'right'
									},
									{
										text: c4r1 ? c4r1 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: c4r2 ? c4r2 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: c4r3 ? c4r3 : '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_groups_days_pregnant_') + ':',
										border: [true, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.group.days_pregnant ? vm.summary.group.days_pregnant : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: c5r0 ? c5r0 : '',
										border: [true, false, false, false],
										alignment: 'right'
									},
									{
										text: c5r1 ? c5r1 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: c5r2 ? c5r2 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: c5r3 ? c5r3 : '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.group.temperature_stress ? vm.summary.group.temperature_stress : '',
										border: [true, true, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, true, false, false]
									},
									{
										text: '',
										border: [false, true, true, false]
									}
								],
								[
									{
										text: c6r0 ? c6r0 : '',
										border: [true, false, false, false],
										alignment: 'right'
									},
									{
										text: c6r1 ? c6r1 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: c6r2 ? c6r2 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: c6r3 ? c6r3 : '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.group.activity_level ? vm.summary.group.activity_level : '',
										border: [true, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: c7r0 ? c7r0 : '',
										border: [true, false, false, true],
										alignment: 'right'
									},
									{
										text: c7r1 ? c7r1 : '',
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: c7r2 ? c7r2 : '',
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: c7r3 ? c7r3 : '',
										border: [false, false, false, true],
										alignment: 'left'
									},
									{
										text: i18nFilter('_rations_animal_feed_additives_') + ': ' + (vm.summary.group.feed_additive ? vm.summary.group.feed_additive : ''),
										border: [true, false, false, true],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, true]
									},
									{
										text: '',
										border: [false, false, true, true]
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 3;
							},
							paddingRight: function () {
								return 2;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						}
					},
					'\n',
					{
						table: {
							widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
							body: [
								[
									{
										text: '',
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_amount_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_as_fed_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_dm_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_report_diet_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_ndf_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: negOrNel ? negOrNel : '',
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_cp_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_rup_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_report_asSold_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_report_wt_as_sold_'),
										border: [false, true, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: '',
										border: [false, false, false, true]
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_dmi_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.energy ? vm.energy : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.currency ? vm.currency : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_supply_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.as_fed ? $filter('number')(vm.ration.supply_amount.as_fed, 2) : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.dm ? vm.ration.supply_amount.dm : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.diet_dmi ? vm.ration.supply_amount.diet_dmi : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.ndf ? vm.ration.supply_amount.ndf : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: negOrNelSupply ? negOrNelSupply : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.cp ? vm.ration.supply_amount.cp : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.rup ? vm.ration.supply_amount.rup : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.cost_dm ? vm.ration.supply_amount.cost_dm : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_requirements_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.ndf ? vm.ration.requirement_amount.ndf : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: negOrNelRequirements ? negOrNelRequirements : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.cp ? vm.ration.requirement_amount.cp : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.rup ? vm.ration.requirement_amount.rup : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_difference_'),
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.ndf ? vm.ration.balance_amount.ndf : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: negOrNelBalance ? negOrNelBalance : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.cp ? vm.ration.balance_amount.cp : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.rup ? vm.ration.balance_amount.rup : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 0;
							},
							paddingRight: function () {
								return 2;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						}
					},
					'\n',
					{
						table: {
							widths: ['*', '*'],
							body: [
								[
									{
										text: i18nFilter('_report_diet_summary_').toUpperCase(),
										border: [false, false, false, true],
										bold: true
									},
									{
										text: i18nFilter('_report_mp_system_used_') + ': ' + (vm.summary.group.met_prot_sys ? vm.summary.group.met_prot_sys : ''),
										border: [false, false, false, true],
										alignment: 'right'
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 2;
							},
							paddingRight: function () {
								return 5;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						}
					},

					{
						table: {
							dontBreakRows: true,
							headerRows: 2,
							keepWithHeaderRows: 3,
							widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
							body: [
								[
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_ndf_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_efndf_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_for_ndf_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_nel_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_rations_neg_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_cp_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_rup_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_rdp_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_rup_dig_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_npncpe_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_mp_'),
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.energy ? vm.energy : '') + '/' + (vm.weight ? vm.weight : ''),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.energy ? vm.energy : '') + '/' + (vm.weight ? vm.weight : ''),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_cp_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_cp_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_rup_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_cp_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_supply_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.ration.supply_conc.ndf ? formatViewValuesSignificant(vm.ration.supply_conc.ndf, 'ndf'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.ef_ndf_as_dm ? formatViewValuesSignificant(vm.ration.supply_conc.ef_ndf_as_dm, 'ef_ndf_as_dm') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.for_ndf ? formatViewValuesSignificant(vm.ration.supply_conc.for_ndf, 'for_ndf') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.nel ? vm.ration.supply_conc.nel : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.neg ? vm.ration.supply_conc.neg : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.cp ? formatViewValuesSignificant(vm.ration.supply_conc.cp, 'cp'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.rup ? vm.ration.supply_conc.rup : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.rdp ? vm.ration.supply_conc.rdp : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.rup_dig ? vm.ration.supply_conc.rup_dig : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.npncpe ? vm.ration.supply_conc.npncpe : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.mp ? vm.ration.supply_conc.mp : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_requirements_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.ration.requirement_conc.ndf ? formatViewValuesSignificant(vm.ration.requirement_conc.ndf, 'ndf'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.ef_ndf_as_dm ? formatViewValuesSignificant(vm.ration.requirement_conc.ef_ndf_as_dm, 'ef_ndf_as_dm') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.for_ndf ? formatViewValuesSignificant(vm.ration.requirement_conc.for_ndf, 'for_ndf') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.nel ? vm.ration.requirement_conc.nel : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.neg ? vm.ration.requirement_conc.neg : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.cp ? formatViewValuesSignificant(vm.ration.requirement_conc.cp, 'cp') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.rup ? vm.ration.requirement_conc.rup : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.rdp ? vm.ration.requirement_conc.rdp : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.rup_dig ? vm.ration.requirement_conc.rup_dig : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.mp ? vm.ration.requirement_conc.mp : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_difference_'),
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: vm.ration.balance_conc.ndf ? formatViewValuesSignificant(vm.ration.balance_conc.ndf, 'ndf') : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.ef_ndf_as_dm ? formatViewValuesSignificant(vm.ration.balance_conc.ef_ndf_as_dm, 'ef_ndf_as_dm') : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.for_ndf ? formatViewValuesSignificant(vm.ration.balance_conc.for_ndf, 'for_ndf') : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.nel ? vm.ration.balance_conc.nel : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.neg ? vm.ration.balance_conc.neg : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.cp ? formatViewValuesSignificant(vm.ration.balance_conc.cp, 'cp') : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.rup ? vm.ration.balance_conc.rup : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.rdp ? vm.ration.balance_conc.rdp : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.rup_dig ? vm.ration.balance_conc.rup_dig : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.mp ? vm.ration.balance_conc.mp : '',
										border: [false, false, false, true],
										alignment: 'center'
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 2;
							},
							paddingRight: function () {
								return 5;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						}
					},
					{
						table: {
							dontBreakRows: true,
							headerRows: 2,
							keepWithHeaderRows: 3,
							widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
							body: [
								[
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_ca_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_p_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_mg_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_k_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_na_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_cl_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_s_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_co_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_cu_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_fe_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_i_'),
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, false, true],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_supply_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.ration.supply_conc.ca ? formatViewValuesSignificant(vm.ration.supply_conc.ca, 'ca') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.p ? formatViewValuesSignificant(vm.ration.supply_conc.p, 'p'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.mg ? formatViewValuesSignificant(vm.ration.supply_conc.mg, 'mg'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.k ? formatViewValuesSignificant(vm.ration.supply_conc.k, 'k'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.na ? formatViewValuesSignificant(vm.ration.supply_conc.na, 'na'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.cl ? formatViewValuesSignificant(vm.ration.supply_conc.cl, 'cl'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.s ? formatViewValuesSignificant(vm.ration.supply_conc.s, 's'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.co ? formatViewValuesSignificant(vm.ration.supply_conc.co, 'co'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.cu ? formatViewValuesSignificant(vm.ration.supply_conc.cu, 'cu'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.fe ? formatViewValuesSignificant(vm.ration.supply_conc.fe, 'fe'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.i ? formatViewValuesSignificant(vm.ration.supply_conc.i, 'i'): '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_requirements_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.ration.requirement_conc.ca ? formatViewValuesSignificant(vm.ration.requirement_conc.ca, 'ca') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.p ? formatViewValuesSignificant(vm.ration.requirement_conc.p, 'p') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.mg ? formatViewValuesSignificant(vm.ration.requirement_conc.mg, 'mg') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.k ? formatViewValuesSignificant(vm.ration.requirement_conc.k, 'k') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.na ? formatViewValuesSignificant(vm.ration.requirement_conc.na, 'na') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.cl ? formatViewValuesSignificant(vm.ration.requirement_conc.cl, 'cl') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.s ? formatViewValuesSignificant(vm.ration.requirement_conc.s, 's') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.co ? vm.ration.requirement_conc.co : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.cu ? vm.ration.requirement_conc.cu : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.fe ? vm.ration.requirement_conc.fe : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.i ? vm.ration.requirement_conc.i : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_difference_'),
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: vm.ration.balance_conc.ca ? formatViewValuesSignificant(vm.ration.balance_conc.ca, 'ca') : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.p ? formatViewValuesSignificant(vm.ration.balance_conc.p, 'p') : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.mg ? formatViewValuesSignificant(vm.ration.balance_conc.mg, 'mg') : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.k ? formatViewValuesSignificant(vm.ration.balance_conc.k, 'k') : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.na ? formatViewValuesSignificant(vm.ration.balance_conc.na, 'na') : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.cl ? formatViewValuesSignificant(vm.ration.balance_conc.cl, 'cl') : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.s ? formatViewValuesSignificant(vm.ration.balance_conc.s, 's') : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.co ? vm.ration.balance_conc.co : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.cu ? vm.ration.balance_conc.cu : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.fe ? vm.ration.balance_conc.fe : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.i ? vm.ration.balance_conc.i : '',
										border: [false, false, false, true],
										alignment: 'center'
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 2;
							},
							paddingRight: function () {
								return 5;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						}
					},
					{
						table: {
							dontBreakRows: true,
							headerRows: 2,
							keepWithHeaderRows: 3,
							widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
							body: [
								[
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_mn_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_se_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_zn_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_starch_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_rdstarch_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_fa_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_nfc_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_dcad_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_vit_a_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_vit_d_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_vit_e_'),
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_starch_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_meq_') + '/100' + i18nFilter('_unit_grams_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_iu_k_') + '/' + (vm.weight ? vm.weight : ''),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_iu_k_') + '/' + (vm.weight ? vm.weight : ''),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_iu_') + '/' + (vm.weight ? vm.weight : ''),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_supply_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.ration.supply_conc.mn ? vm.ration.supply_conc.mn : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.se ? vm.ration.supply_conc.se : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.zn ? vm.ration.supply_conc.zn : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{ 
										text: vm.ration.supply_conc.starch ? formatViewValuesSignificant(vm.ration.supply_conc.starch, 'starch'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.rd_starch ? vm.ration.supply_conc.rd_starch : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.fa ? formatViewValuesSignificant(vm.ration.supply_conc.fa, 'fa') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.nfc ? formatViewValuesSignificant(vm.ration.supply_conc.nfc, 'nfc') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.dcad ? vm.ration.supply_conc.dcad : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.vitamin_a ? vm.ration.supply_conc.vitamin_a : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.vitamin_d ? vm.ration.supply_conc.vitamin_d : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.vitamin_e ? vm.ration.supply_conc.vitamin_e : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_requirements_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.ration.requirement_conc.mn ? vm.ration.requirement_conc.mn : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.se ? vm.ration.requirement_conc.se : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.zn ? vm.ration.requirement_conc.zn : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.starch ? formatViewValuesSignificant(vm.ration.requirement_conc.starch, 'starch') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.rd_starch ? vm.ration.requirement_conc.rd_starch : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.fa ? formatViewValuesSignificant(vm.ration.requirement_conc.fa, 'fa') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.nfc ? formatViewValuesSignificant(vm.ration.requirement_conc.nfc, 'nfc') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.dcad ? vm.ration.requirement_conc.dcad : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.vitamin_a ? vm.ration.requirement_conc.vitamin_a : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.vitamin_d ? vm.ration.requirement_conc.vitamin_d : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.vitamin_e ? vm.ration.requirement_conc.vitamin_e : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_difference_'),
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: vm.ration.balance_conc.mn ? vm.ration.balance_conc.mn : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.se ? vm.ration.balance_conc.se : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.zn ? vm.ration.balance_conc.zn : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.starch ? formatViewValuesSignificant(vm.ration.balance_conc.starch, 'starch') : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.rd_starch ? vm.ration.balance_conc.rd_starch : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.fa ? formatViewValuesSignificant(vm.ration.balance_conc.fa, 'fa') : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.nfc ? formatViewValuesSignificant(vm.ration.balance_conc.nfc, 'nfc') : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.dcad ? vm.ration.balance_conc.dcad : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.vitamin_a ? vm.ration.balance_conc.vitamin_a : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.vitamin_d ? vm.ration.balance_conc.vitamin_d : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.vitamin_e ? vm.ration.balance_conc.vitamin_e : '',
										border: [false, false, false, true],
										alignment: 'center'
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 2;
							},
							paddingRight: function () {
								return 5;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						},
						pageBreak: 'after'
					},
					{
						table: {
							widths: ['*', 'auto', 'auto', '*', 'auto', 'auto', '*', 'auto', 'auto'],
							headerRows: 1,
							body: [
								[
									{
										text: i18nFilter('_rations_ration_ratios_relationships_').toUpperCase(),
										bold: true,
										colSpan: 9,
										border: [false, false, false, true]
									},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{}
								],
								[
									{
										text: i18nFilter('_rations_actual_dmi_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.actual_dmi ? vm.summary.randr.actual_dmi : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_rations_purchased_feed_costs_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.purchased_feed_costs ? vm.summary.randr.purchased_feed_costs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.currency ? vm.currency : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_rations_predicted_fecal_dm_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.predicted_fecal_dm ? vm.summary.randr.predicted_fecal_dm : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									}
								],
								[
									{
										text: i18nFilter('_rations_dmi_') + '/' + i18nFilter('_rations_bw_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.dmi_bw ? vm.summary.randr.dmi_bw : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_rations_bw_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: rr31 ? rr31 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: rr41 ? rr41 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: rr51 ? rr51 : '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_rations_n_captured_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.n_captured ? vm.summary.randr.n_captured : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%',
										border: [false, false, false, false],
										alignment: 'left'
									}
								],
								[
									{
										text: i18nFilter('_rations_nrc01_predicted_dmi_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.nrc01_predicted_dmi ? vm.summary.randr.nrc01_predicted_dmi : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: rr32 ? rr32 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: rr42 ? rr42 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: rr52 ? rr52 : '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_rations_total_n_excreted_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.total_n_excreted ? vm.summary.randr.total_n_excreted : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									}
								],
								[
									{
										text: i18nFilter('_feeds_dep_') + '/' + i18nFilter('_feeds_de1x_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.dep_de1x ? vm.summary.randr.dep_de1x : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_rations_forage_diet_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.forage_in_diet ? vm.summary.randr.forage_in_diet : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_rations_fecal_n_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.fecal_n ? vm.summary.randr.fecal_n : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									}
								],
								[
									{
										text: rr04 ? rr04 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: rr14 ? rr14 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: rr24 ? rr24 : '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_rations_forage_ndf_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.forage_ndf ? vm.summary.randr.forage_ndf : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_ndf_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_rations_urinary_n_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.urinary_n ? vm.summary.randr.urinary_n : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									}
								],
								[
									{
										text: rr05 ? rr05 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: rr15 ? rr15 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: rr25 ? rr25 : '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_feeds_cp_') + '/' + i18nFilter('_rations_me3x_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.cp_me3x ? vm.summary.randr.cp_me3x : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_grams_') + '/' + (vm.energy ? vm.energy : ''),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_rations_p_captured_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.p_captured ? vm.summary.randr.p_captured : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%',
										border: [false, false, false, false],
										alignment: 'left'
									}
								],
								[
									{
										text: energyAllowable ? energyAllowable : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: energyAllowableValue ? energyAllowableValue : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_feeds_mp_') + '/' + i18nFilter('_feeds_me_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.mp_me ? vm.summary.randr.mp_me : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: i18nFilter('_unit_grams_') + '/' + (vm.energy ? vm.energy : ''),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_rations_p_excreted_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.p_excreted ? vm.summary.randr.p_excreted : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									}
								],
								[
									{
										text: proteinAllowable ? proteinAllowable : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: proteinAllowableValue ? proteinAllowableValue : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_rations_lys_met_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.lys_met ? vm.summary.randr.lys_met : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_rations_p_excreted_p205_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.p_excreted_as_p205 ? vm.summary.randr.p_excreted_as_p205 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									}
								],

								[
									{
										text: i18nFilter('_rations_feed_cost_') + '/' + i18nFilter('_rations_me3x_'),
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.feed_cost_me3x ? vm.summary.randr.feed_cost_me3x : '',
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: (vm.currency ? vm.currency : '') + '/100' + (vm.energy ? vm.energy : ''),
										border: [false, false, false, true],
										alignment: 'left'
									},
									{
										text: i18nFilter('_rations_lys_nrc01_met_'),
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.nrc01_lys_met ? vm.summary.randr.nrc01_lys_met : '',
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'left'
									},
									{
										text: i18nFilter('_rations_k_excreted_k20_'),
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: vm.summary.randr.k_excreted_as_k2O ? vm.summary.randr.k_excreted_as_k2O : '',
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, true],
										alignment: 'left'
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1.5 : 1.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'black';
							},
							paddingLeft: function () {
								return 1;
							},
							paddingRight: function () {
								return 1;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 1;
							}
						}
					},
					'\n',
					{
						table: {
							widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 45],
							body: [
								[
									{
										text: '',
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_amount_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_efndf_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_me_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_rup_dig_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_fa_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_starch_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_ca_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_p_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_k_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_cost_dm_'),
										border: [false, true, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: '',
										border: [false, false, false, true]
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.energy ? vm.energy : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.currency ? vm.currency : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_supply_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.ef_ndf_as_dm ? vm.ration.supply_amount.ef_ndf_as_dm : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.me ? vm.ration.supply_amount.me : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.rup_dig ? vm.ration.supply_amount.rup_dig : '',
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.fa ? vm.ration.supply_amount.fa : '',
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.starch ? vm.ration.supply_amount.starch : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.ca ? vm.ration.supply_amount.ca : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.p ? vm.ration.supply_amount.p : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.k ? vm.ration.supply_amount.k : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.cost_dm ? vm.ration.supply_amount.cost_dm : '',
										border: [false, true, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_requirements_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.ef_ndf_as_dm ? vm.ration.requirement_amount.ef_ndf_as_dm : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.me ? vm.ration.requirement_amount.me : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.rup_dig ? vm.ration.requirement_amount.rup_dig : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.ca ? vm.ration.requirement_amount.ca : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.p ? vm.ration.requirement_amount.p : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.k ? vm.ration.requirement_amount.k : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_difference_'),
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.ef_ndf_as_dm ? vm.ration.balance_amount.ef_ndf_as_dm : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.me ? vm.ration.balance_amount.me : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.rup_dig ? vm.ration.balance_amount.rup_dig : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.ca ? vm.ration.balance_amount.ca : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.p ? vm.ration.balance_amount.p : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.k ? vm.ration.balance_amount.k : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'cefalsenter'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 1;
							},
							paddingRight: function () {
								return 2;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						}
					},
					'\n',
					{
						table: {
							widths: ['*', '*'],
							body: [
								[
									{
										text: i18nFilter('_report_diet_summary_continued_').toUpperCase(),
										border: [false, false, false, true],
										bold: true
									},
									{
										text: i18nFilter('_report_mp_system_used_') + ': ' + (vm.summary.group.met_prot_sys ? vm.summary.group.met_prot_sys : ''),
										border: [false, false, false, true],
										alignment: 'right'
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 2;
							},
							paddingRight: function () {
								return 5;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						}
					},

					{
						table: {
							dontBreakRows: true,
							headerRows: 2,
							keepWithHeaderRows: 3,
							widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
							body: [
								[
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_ndf_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_rdndf_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_me01_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_nel89_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_starch_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_rdstarch_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_sugar_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_infa_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_solfiber_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_ee_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_fa_'),
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_ndf_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.energy ? vm.energy : '') + '/' + (vm.weight ? vm.weight : ''),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.energy ? vm.energy : '') + '/' + (vm.weight ? vm.weight : ''),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_starch_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_supply_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.ration.supply_conc.ndf ? formatViewValuesSignificant(vm.ration.supply_conc.ndf, 'ndf'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.rd_ndf ? vm.ration.supply_conc.rd_ndf : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.me_01 ? vm.ration.supply_conc.me_01 : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.nel_89 ? vm.ration.supply_conc.nel_89 : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.starch ? formatViewValuesSignificant(vm.ration.supply_conc.starch, 'starch'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.rd_starch ? vm.ration.supply_conc.rd_starch : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.sugar ? formatViewValuesSignificant(vm.ration.supply_conc.sugar, 'sugar'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.in_fa ? formatViewValuesSignificant(vm.ration.supply_conc.in_fa, 'in_fa'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.sol_fiber ? formatViewValuesSignificant(vm.ration.supply_conc.sol_fiber, 'sol_fiber'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.ee ? formatViewValuesSignificant(vm.ration.supply_conc.ee, 'ee'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.fa ? formatViewValuesSignificant(vm.ration.supply_conc.fa, 'fa') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_requirements_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.ration.requirement_conc.ndf ? formatViewValuesSignificant(vm.ration.requirement_conc.ndf, 'ndf') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.me_01 ? vm.ration.requirement_conc.me_01 : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.nel_89 ? vm.ration.requirement_conc.nel_89 : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_difference_'),
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: vm.ration.balance_conc.ndf ? formatViewValuesSignificant(vm.ration.balance_conc.ndf, 'ndf') : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.me_01 ? vm.ration.balance_conc.me_01 : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.nel_89 ? vm.ration.balance_conc.nel_89 : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 2;
							},
							paddingRight: function () {
								return 5;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						}
					},
					{
						table: {
							dontBreakRows: true,
							headerRows: 2,
							keepWithHeaderRows: 3,
							widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
							body: [
								[
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_sfa_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_mufa_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_pufa_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_bhfa_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_idufa_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_ash_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_mo_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_ca_abs_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_p_abs_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_mg_abs_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_cu_abs_'),
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_fa_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_fa_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_fa_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_fa_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_fa_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_ca_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_p_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_mg_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_cu_'),
										border: [false, false, false, true],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_supply_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.ration.supply_conc.sfa ? vm.ration.supply_conc.sfa : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.mufa ? vm.ration.supply_conc.mufa : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.pufa ? vm.ration.supply_conc.pufa : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.bhfa ? vm.ration.supply_conc.bhfa : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.idufa ? vm.ration.supply_conc.idufa : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.ash ? formatViewValuesSignificant(vm.ration.supply_conc.ash, 'ash'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.mo ? vm.ration.supply_conc.mo : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.ca_abs ? vm.ration.supply_conc.ca_abs : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.p_abs ? vm.ration.supply_conc.p_abs : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.mg_abs ? vm.ration.supply_conc.mg_abs : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.cu_abs ? vm.ration.supply_conc.cu_abs : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_requirements_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.ca_abs ? vm.ration.requirement_conc.ca_abs : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.p_abs ? vm.ration.requirement_conc.p_abs : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.mg_abs ? vm.ration.requirement_conc.mg_abs : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.cu_abs ? vm.ration.requirement_conc.cu_abs : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_difference_'),
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.ca_abs ? vm.ration.balance_conc.ca_abs : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.p_abs ? vm.ration.balance_conc.p_abs : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.mg_abs ? vm.ration.balance_conc.mg_abs : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.cu_abs ? vm.ration.balance_conc.cu_abs : '',
										border: [false, false, false, true],
										alignment: 'center'
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 2;
							},
							paddingRight: function () {
								return 5;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						}
					},
					{
						table: {
							dontBreakRows: true,
							headerRows: 2,
							keepWithHeaderRows: 3,
							widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
							body: [
								[
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_fe_abs_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_i_abs_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_mn_abs_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_zn_abs_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_se_abs_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_lysine_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_methionine_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_blank_') + '1',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_blank_') + '2',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_blank_') + '3',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_fe_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_i_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_mn_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_zn_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_se_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_drup_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_drup_'),
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_supply_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.ration.supply_conc.fe_abs ? vm.ration.supply_conc.fe_abs : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.i_abs ? vm.ration.supply_conc.i_abs : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.mn_abs ? vm.ration.supply_conc.mn_abs : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.zn_abs ? vm.ration.supply_conc.zn_abs : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.se_abs ? vm.ration.supply_conc.se_abs : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.lysine ? vm.ration.supply_conc.lysine : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_conc.methionine ? vm.ration.supply_conc.methionine : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_requirements_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.ration.requirement_conc.fe_abs ? vm.ration.requirement_conc.fe_abs : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.i_abs ? vm.ration.requirement_conc.i_abs : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.mn_abs ? vm.ration.requirement_conc.mn_abs : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.zn_abs ? vm.ration.requirement_conc.zn_abs : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.se_abs ? vm.ration.requirement_conc.se_abs : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.lysine ? vm.ration.requirement_conc.lysine : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.methionine ? vm.ration.requirement_conc.methionine : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_difference_'),
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: vm.ration.balance_conc.fe_abs ? vm.ration.balance_conc.fe_abs : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.i_abs ? vm.ration.balance_conc.i_abs : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.mn_abs ? vm.ration.balance_conc.mn_abs : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.zn_abs ? vm.ration.balance_conc.zn_abs : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.se_abs ? vm.ration.balance_conc.se_abs : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.lysine ? vm.ration.balance_conc.lysine : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.methionine ? vm.ration.balance_conc.methionine : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 2;
							},
							paddingRight: function () {
								return 5;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						}
					},
					{
						table: {
							dontBreakRows: true,
							headerRows: 2,
							keepWithHeaderRows: 3,
							widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
							body: [
								[
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_mp_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_rdp_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_mp01_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_rdp01_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_nel01_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_rations_neg_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_vit_a_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_vit_d_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_vit_e_'),
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_blank_') + '1',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_blank_') + '2',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.energy ? vm.energy : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.energy ? vm.energy : '') + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_iu_k_') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_iu_k_') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_iu_') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_supply_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.ration.supply_amount.mp ? vm.ration.supply_amount.mp : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.rdp ? vm.ration.supply_amount.rdp : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.mp_01 ? vm.ration.supply_amount.mp_01 : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.rdp_01 ? vm.ration.supply_amount.rdp_01 : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.nel_01 ? vm.ration.supply_amount.nel_01 : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.group.type == 'heifer' ? (vm.ration.supply_amount.neg ? vm.ration.supply_amount.neg : '') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.vitamin_a ? vm.ration.supply_amount.vitamin_a : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.vitamin_d ? vm.ration.supply_amount.vitamin_d : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.vitamin_e ? vm.ration.supply_amount.vitamin_e : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_requirements_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.ration.requirement_amount.mp ? vm.ration.requirement_amount.mp : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.rdp ? vm.ration.requirement_amount.rdp : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.mp_01 ? vm.ration.requirement_amount.mp_01 : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.rdp_01 ? vm.ration.requirement_amount.rdp_01 : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.group.type == 'heifer' ? (vm.ration.requirement_amount.neg ? vm.ration.requirement_amount.neg : '') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.vitamin_a ? vm.ration.requirement_amount.vitamin_a : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.vitamin_d ? vm.ration.requirement_amount.vitamin_d : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.vitamin_e ? vm.ration.requirement_amount.vitamin_e : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_difference_'),
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: vm.ration.balance_amount.mp ? vm.ration.balance_amount.mp : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.rdp ? vm.ration.balance_amount.rdp : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.mp_01 ? vm.ration.balance_amount.mp_01 : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.rdp_01 ? vm.ration.balance_amount.rdp_01 : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.group.type == 'heifer' ? (vm.ration.balance_amount.neg ? vm.ration.balance_amount.neg : '') : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.vitamin_a ? vm.ration.balance_amount.vitamin_a : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.vitamin_d ? vm.ration.balance_amount.vitamin_d : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.vitamin_e ? vm.ration.balance_amount.vitamin_e : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 2;
							},
							paddingRight: function () {
								return 5;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						},
						pageBreak: 'after'
					},
					{
						table: {
							widths: ['*'],
							body: [
								[
									{
										text: i18nFilter('_report_assumptions_').toUpperCase(),
										border: [false, false, false, false]
									}
								],
								[
									{
										text: '',
										border: [false, true, false, true]
									}
								],
								[
									{
										text: vm.aAndC ? vm.aAndC : '',
										border: [false, false, false, false]
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1.5 : 1.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'black';
							},
							paddingLeft: function () {
								return 2;
							},
							paddingRight: function () {
								return 5;
							},
							paddingTop: function () {
								return 5;
							},
							paddingBottom: function () {
								return 0;
							}
						}
					}
				],
				styles: {
					headerStyle: {
						fontSize: 18,
						bold: true
					},
					bold: {
						bold: true
					},
					small: {
						fontSize: 10
					}
				},
				defaultStyle: {
					fontSize: 10
				}
			};
			var table2Row0 = [
				{
					text: '',
					border: [false, true, false, false]
				},
				{
					text: i18nFilter('_report_test_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_amount_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_as_fed_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_dm_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: '%' + i18nFilter('_report_diet_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_ndf_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: negOrNel,
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_cp_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_rup_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_report_asSold_'),
					border: [false, true, false, false]
				},
				{
					text: i18nFilter('_report_wt_as_sold_'),
					border: [false, true, false, false],
					alignment: 'center'
				}
			];
			var table2Row1 = [
				{
					text: i18nFilter('_feeds_name_'),
					border: [false, false, false, true]
				},
				{
					text: i18nFilter('_report_date_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.weight,
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.weight,
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.settings.use_percent ? '%': i18nFilter('_unit_grams_') + '/' + vm.weight,
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: '%' + i18nFilter('_feeds_dmi_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: (vm.energy ? vm.energy : '') + '/' + (vm.weight ? vm.weight : ''),
					fontSize: 8,
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: '%' + i18nFilter('_feeds_cp_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.currency ? vm.currency : '',
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.weight ? vm.weight : '',
					border: [false, false, false, true],
					alignment: 'center'
				}
			];
			var table5Row0 = [
				{
					text: '',
					border: [false, true, false, false]
				},
				{
					text: i18nFilter('_feeds_amount_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_efndf_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_me_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_rup_dig_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_fa_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_starch_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_ca_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_p_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_k_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_report_feed_'),
					border: [false, true, false, false]
				},
				{
					text: i18nFilter('_feeds_cost_dm_'),
					border: [false, true, false, false],
					alignment: 'center'
				}
			];
			var table5Row1 = [
				{
					text: i18nFilter('_feeds_name_'),
					border: [false, false, false, true]
				},
				{
					text: vm.weight ? vm.weight : '',
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: '%' + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: (vm.energy ? vm.energy : '') + '/' + (vm.weight ? vm.weight : ''),
					fontSize: 8,
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: '%' + i18nFilter('_feeds_rup_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: '%' + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: i18nFilter('_report_type_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: (vm.currency ? vm.currency : '') + '/' + (vm.weight ? vm.weight : ''),
					border: [false, false, false, true],
					alignment: 'center'
				}
			];
			if (vm.summary.feeds.length > 0) {
				for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
					var date = new Date(vm.summary.feeds[i].test_date);
					date = $filter('date')(date, 'shortDate');
					var wt_as_sold = vm.summary.feeds[i].wt_as_sold;
					wt_as_sold = $filter('number')(wt_as_sold, 2);
					var dm_kg = vm.summary.feeds[i].amount;
					dm_kg = $filter('number')(dm_kg, 2);
					var neg_nel;
					if (vm.ration.group.type == 'heifer') {
						neg_nel = vm.summary.feeds[i].neg;
					} else {
						neg_nel = vm.summary.feeds[i].nel;
					}
					var feedstuff = {
						as_fed: vm.summary.feeds[i].as_fed,
						dm: vm.summary.feeds[i].dm,
						diet_dmi: vm.summary.feeds[i].diet_dmi,
						ndf: vm.summary.feeds[i].ndf,
						cp: vm.summary.feeds[i].cp,
						rup: vm.summary.feeds[i].rup,
						cost_as_sold: vm.summary.feeds[i].cost_as_sold,
						ef_ndf_as_dm: vm.summary.feeds[i].ef_ndf_as_dm,
						neg_nel: neg_nel,
						me: vm.summary.feeds[i].me,
						rup_dig: vm.summary.feeds[i].rup_dig,
						fa: vm.summary.feeds[i].fa,
						starch: vm.summary.feeds[i].starch,
						ca: vm.summary.feeds[i].ca,
						p: vm.summary.feeds[i].p,
						k: vm.summary.feeds[i].k,
						cost_dm: vm.summary.feeds[i].cost_dm,
						lysine: vm.summary.feeds[i].lysine,
						methionine: vm.summary.feeds[i].methionine,
						teaa: vm.summary.feeds[i].teaa,
						wt_as_sold: vm.summary.feeds[i].wt_as_sold,
						i: vm.summary.feeds[i].i,
						i_abs: vm.summary.feeds[i].i_abs,
						mo: vm.summary.feeds[i].mo,
						mn: vm.summary.feeds[i].mn,
						mn_abs: vm.summary.feeds[i].mn_abs,
						se: vm.summary.feeds[i].se,
						se_abs: vm.summary.feeds[i].se_abs,
						zn: vm.summary.feeds[i].zn,
						zn_abs: vm.summary.feeds[i].zn_abs,
						s: vm.summary.feeds[i].s,
						ash: vm.summary.feeds[i].ash,
						vitamin_a: vm.summary.feeds[i].vitamin_a,
						vitamin_d: vm.summary.feeds[i].vitamin_d,
						vitamin_e: vm.summary.feeds[i].vitamin_e,
						co: vm.summary.feeds[i].co,
						cu: vm.summary.feeds[i].cu,
						cu_abs: vm.summary.feeds[i].cu_abs,
						fe: vm.summary.feeds[i].fe,
						fe_abs: vm.summary.feeds[i].fe_abs,
						fa_dig: vm.summary.feeds[i].fa_dig,
						ca_abs: vm.summary.feeds[i].ca_abs,
						p_abs: vm.summary.feeds[i].p_abs,
						mg: vm.summary.feeds[i].mg,
						mg_abs: vm.summary.feeds[i].mg_abs,
						na: vm.summary.feeds[i].na,
						cl: vm.summary.feeds[i].cl,
						nfc_dig: vm.summary.feeds[i].nfc_dig,
						rd_starch: vm.summary.feeds[i].rd_starch,
						sugar: vm.summary.feeds[i].sugar,
						in_fa: vm.summary.feeds[i].in_fa,
						rd_sol_fiber: vm.summary.feeds[i].rd_sol_fiber,
						ee: vm.summary.feeds[i].ee,
						sfa: vm.summary.feeds[i].sfa,
						pufa: vm.summary.feeds[i].pufa,
						bhfa: vm.summary.feeds[i].bhfa,
						a_prot: vm.summary.feeds[i].a_prot,
						b_prot: vm.summary.feeds[i].b_prot,
						c_prot: vm.summary.feeds[i].c_prot,
						kd_b_prot: vm.summary.feeds[i].kd_b_prot,
						npncpe: vm.summary.feeds[i].npncpe,
						rup_89: vm.summary.feeds[i].rup_89,
						ndicp: vm.summary.feeds[i].ndicp,
						adicp: vm.summary.feeds[i].adicp,
						ef_ndf_as_ndf: vm.summary.feeds[i].ef_ndf_as_ndf,
						lignin: vm.summary.feeds[i].lignin,
						ndf_digest: vm.summary.feeds[i].ndf_digest,
						adf: vm.summary.feeds[i].adf,
						rd_ndf: vm.summary.feeds[i].rd_ndf,
						disc_fac: vm.summary.feeds[i].disc_fac,
						nel_89: vm.summary.feeds[i].nel_89,
						me_89: vm.summary.feeds[i].me_89
					};
					feedstuff = setSignificant(feedstuff);
					var feed1 = [
						{
							text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
							border: [false, false, false, false]
						},
						{
							text: dm_kg ? dm_kg : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.ef_ndf_as_dm ? feedstuff.ef_ndf_as_dm : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.me ? feedstuff.me : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.rup_dig ? feedstuff.rup_dig : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.fa ? feedstuff.fa : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.starch ? feedstuff.starch : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.ca ? feedstuff.ca : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.p ? feedstuff.p : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.k ? feedstuff.k : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: vm.summary.feeds[i].feed_category ? vm.summary.feeds[i].feed_category : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.cost_dm ? feedstuff.cost_dm : '',
							border: [false, false, false, false],
							alignment: 'center'
						}
					];
					var feed = [
						{
							text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
							border: [false, false, false, false]
						},
						{
							text: date ? date : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: dm_kg ? dm_kg : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.as_fed ? feedstuff.as_fed : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.dm ? feedstuff.dm : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.diet_dmi ? feedstuff.diet_dmi : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.ndf ? feedstuff.ndf : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.neg_nel ? feedstuff.neg_nel : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.cp ? feedstuff.cp : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.rup ? feedstuff.rup : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.cost_as_sold ? feedstuff.cost_as_sold : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: wt_as_sold ? wt_as_sold : '',
							border: [false, false, false, false],
							alignment: 'center'
						}
					];
					dd.content[5].table.body.splice(0, 0, feed);
					dd.content[13].table.body.splice(0, 0, feed1);
				}
				dd.content[5].table.body.splice(0, 0, table2Row1);
				dd.content[5].table.body.splice(0, 0, table2Row0);
				dd.content[13].table.body.splice(0, 0, table5Row1);
				dd.content[13].table.body.splice(0, 0, table5Row0);
			}
			// OFFICE REPORT //
			if (!isSummary) {
				if (vm.summary.feeds.length > 0) {
					var ORTable8 = {
						margin: [0, 10, 0, 0],
						table: {
							dontBreakRows: true,
							headerRows: 1,
							keepWithHeaderRows: 30,
							widths: ['*', 'auto'],
							body: [
								[
									{
										text: i18nFilter('_feeds_name_'),
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_comment_'),
										border: [false, true, false, false]
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 0;
							},
							paddingRight: function () {
								return 2;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						}
					};
					dd.content.splice(20, 0, ORTable8);
					for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
						var ORTable8Feed = [
							{
								text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
								border: [false, false, false, false]
							},
							{
								text: vm.summary.feeds[i].comments ? vm.summary.feeds[i].comments : '',
								border: [false, false, false, false],
								alignment: 'center'
							}
						];
						dd.content[20].table.body.splice(1, 0, ORTable8Feed);
					}
				}
				var ORTable7 = {
					margin: [0, 10, 0, 0],
					table: {
						dontBreakRows: true,
						headerRows: 2,
						keepWithHeaderRows: 30,
						widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
						body: [
							[
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_amount_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_blank_') + '1',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_blank_') + '2',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_blank_') + '3',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_blank_') + '4',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_blank_') + '5',
									border: [false, true, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: '',
									border: [false, false, false, true]
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_supply_'),
									border: [false, true, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_difference_'),
									border: [false, false, false, true],
									alignment: 'right'
								},
								{
									text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							]
						]
					},
					layout: {
						hLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
						},
						vLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1 : 0.5;
						},
						hLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'black' : 'gray';
						},
						vLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
						},
						paddingLeft: function () {
							return 2;
						},
						paddingRight: function () {
							return 5;
						},
						paddingTop: function () {
							return 1;
						},
						paddingBottom: function () {
							return 0;
						}
					},
					pageBreak: 'before'
				};
				dd.content.splice(20, 0, ORTable7);
				if (vm.summary.feeds.length > 0) {
					for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
						var ORTable7Feed = [
							{
								text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
								border: [false, false, false, false]
							},
							{
								text: vm.summary.feeds[i].amount ? $filter('number')(vm.summary.feeds[i].amount, 2) : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: i18nFilter(vm.summary.feeds[i].feed_type.show_name),
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: '',
								border: [false, false, false, false],
								alignment: 'center'
							}
						];
						dd.content[20].table.body.splice(0, 0, ORTable7Feed);
					}
					var ORTTable7Header2 = [
						{
							text: i18nFilter('_feeds_name_'),
							border: [false, false, false, true]
						},
						{
							text: vm.weight ? vm.weight : '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_type_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '',
							border: [false, false, false, true],
							alignment: 'center'
						}
					];
					var ortTable7Header1 = [
						{
							text: '',
							border: [false, true, false, false]
						},
						{
							text: i18nFilter('_feeds_amount_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: '',
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_blank_') + '1',
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_blank_') + '1',
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_blank_') + '1',
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_blank_') + '1',
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_blank_') + '1',
							border: [false, true, false, false],
							alignment: 'center'
						}
					];
					dd.content[20].table.body.splice(0, 0, ORTTable7Header2);
					dd.content[20].table.body.splice(0, 0, ortTable7Header1);
				}
				var ORTable6 = {
					margin: [0, 10, 0, 0],
					table: {
						dontBreakRows: true,
						headerRows: 2,
						keepWithHeaderRows: 30,
						widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 40, 'auto', 'auto', 'auto'],
						body: [
							[
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_amount_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_lysine_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_methionine_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_teaa_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_cost_dm_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_purchased_cost_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: '',
									border: [false, false, false, true]
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.currency ? vm.currency : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.currency ? vm.currency : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_supply_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.lysine ? vm.ration.supply_amount.lysine : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.methionine ? vm.ration.supply_amount.methionine : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.teaa ? vm.ration.supply_amount.teaa : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.cost_dm ? vm.ration.supply_amount.cost_dm : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.pur_cost ? vm.ration.supply_amount.pur_cost : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.lysine ? vm.ration.requirement_amount.lysine : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.methionine ? vm.ration.requirement_amount.methionine : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_difference_'),
									border: [false, false, false, true],
									alignment: 'right'
								},
								{
									text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.lysine ? vm.ration.balance_amount.lysine : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.methionine ? vm.ration.balance_amount.methionine : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							]
						]
					},
					layout: {
						hLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
						},
						vLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1 : 0.5;
						},
						hLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'black' : 'gray';
						},
						vLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
						},
						paddingLeft: function () {
							return 2;
						},
						paddingRight: function () {
							return 1;
						},
						paddingTop: function () {
							return 1;
						},
						paddingBottom: function () {
							return 0;
						}
					}
				};
				dd.content.splice(20, 0, ORTable6);
				if (vm.summary.feeds.length > 0) {
					for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
						var date = new Date(vm.summary.feeds[i].test_date);
						date = $filter('date')(date, 'shortDate');
						var ORTable6Feed = [
							{
								text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
								border: [false, false, false, false]
							},
							{
								text: vm.summary.feeds[i].amount ? $filter('number')(vm.summary.feeds[i].amount, 2) : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].lysine ? vm.summary.feeds[i].lysine : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].methionine ? vm.summary.feeds[i].methionine : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].teaa ? vm.summary.feeds[i].teaa : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].cost_as_sold ? vm.summary.feeds[i].cost_as_sold : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].wt_as_sold ? vm.summary.feeds[i].wt_as_sold : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].cost_dm ? vm.summary.feeds[i].cost_dm : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].is_purchased ? vm.summary.feeds[i].is_purchased : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].common_feed ? vm.summary.feeds[i].common_feed : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: date,
								border: [false, false, false, false],
								alignment: 'center'
							}
						];
						dd.content[20].table.body.splice(0, 0, ORTable6Feed);
					}
					var ORTTable6Header1 = [
						{
							text: '',
							border: [false, true, false, false]
						},
						{
							text: i18nFilter('_feeds_amount_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_lysine_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_methionine_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_teaa_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_report_asSold_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_report_wt_as_sold_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_cost_dm_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_report_pur_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_report_common_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_report_test_'),
							border: [false, true, false, false],
							alignment: 'center'
						}
					];
					var ORTTable6Header2 = [
						{
							text: i18nFilter('_feeds_name_'),
							border: [false, false, false, true]
						},
						{
							text: vm.weight,
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_drup_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_drup_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_drup_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.currency ? vm.currency : '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.weight ? vm.weight : '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: (vm.currency ? vm.currency : '') + '/' + (vm.weight ? vm.weight : ''),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_report_chased_'),
							border: [false, false, false, true]
						},
						{
							text: i18nFilter('_report_feed_'),
							border: [false, false, false, true]
						},
						{
							text: i18nFilter('_report_date_'),
							border: [false, false, false, true]
						}
					];
					dd.content[20].table.body.splice(0, 0, ORTTable6Header2);
					dd.content[20].table.body.splice(0, 0, ORTTable6Header1);
				}
				var ORTable5 = {
					margin: [0, 10, 0, 0],
					table: {
						headerRows: 2,
						dontBreakRows: true,
						keepWithHeaderRows: 30,
						widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
						body: [
							[
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_amount_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_i_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_i_abs_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_mo_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_mn_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_mn_abs_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_se_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_se_abs_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_zn_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_zn_abs_'),
									border: [false, true, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: '',
									border: [false, false, false, true]
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_supply_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.i ? vm.ration.supply_amount.i : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.i_abs ? vm.ration.supply_amount.i_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.mo ? vm.ration.supply_amount.mo : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.mn ? vm.ration.supply_amount.mn : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.mn_abs ? vm.ration.supply_amount.mn_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.se ? vm.ration.supply_amount.se : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.se_abs ? vm.ration.supply_amount.se_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.zn ? vm.ration.supply_amount.zn : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.zn_abs ? vm.ration.supply_amount.zn_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.i ? vm.ration.requirement_amount.i : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.i_abs ? vm.ration.requirement_amount.i_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.mn ? vm.ration.requirement_amount.mn : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.mn_abs ? vm.ration.requirement_amount.mn_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.se ? vm.ration.requirement_amount.se : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.se_abs ? vm.ration.requirement_amount.se_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.zn ? vm.ration.requirement_amount.zn : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.zn_abs ? vm.ration.requirement_amount.zn_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_difference_'),
									border: [false, false, false, true],
									alignment: 'right'
								},
								{
									text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.i ? vm.ration.balance_amount.i : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.i_abs ? vm.ration.balance_amount.i_abs : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.mn ? vm.ration.balance_amount.mn : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.mn_abs ? vm.ration.balance_amount.mn_abs : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.se ? vm.ration.balance_amount.se : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.se_abs ? vm.ration.balance_amount.se_abs : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.zn ? vm.ration.balance_amount.zn : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.zn_abs ? vm.ration.balance_amount.zn_abs : '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							]
						]
					},
					layout: {
						hLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
						},
						vLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1 : 0.5;
						},
						hLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'black' : 'gray';
						},
						vLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
						},
						paddingLeft: function () {
							return 2;
						},
						paddingRight: function () {
							return 1;
						},
						paddingTop: function () {
							return 1;
						},
						paddingBottom: function () {
							return 0;
						}
					}
				};
				dd.content.splice(20, 0, ORTable5);
				if (vm.summary.feeds.length > 0) {
					for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
						var date = new Date(vm.summary.feeds[i].test_date);
						date = $filter('date')(date, 'shortDate');
						var ORTable5Feed = [
							{
								text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
								border: [false, false, false, false]
							},
							{
								text: vm.summary.feeds[i].amount ? $filter('number')(vm.summary.feeds[i].amount, 2) : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].i ? vm.summary.feeds[i].i : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].i_abs ? vm.summary.feeds[i].i_abs : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].mo ? vm.summary.feeds[i].mo : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].mn ? vm.summary.feeds[i].mn : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].mn_abs ? vm.summary.feeds[i].mn_abs : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].se ? vm.summary.feeds[i].se : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].se_abs ? vm.summary.feeds[i].se_abs : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].zn ? vm.summary.feeds[i].zn : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].zn_abs ? vm.summary.feeds[i].zn_abs : '',
								border: [false, false, false, false],
								alignment: 'center'
							}
						];
						dd.content[20].table.body.splice(0, 0, ORTable5Feed);
					}
					var ORTTable5Header1 = [
						{
							text: '',
							border: [false, true, false, false]
						},
						{
							text: i18nFilter('_feeds_amount_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_i_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_i_abs_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_mo_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_mn_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_mn_abs_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_se_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_se_abs_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_zn_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_zn_abs_'),
							border: [false, true, false, false],
							alignment: 'center'
						}
					];
					var ORTTable5Header2 = [
						{
							text: i18nFilter('_feeds_name_'),
							border: [false, false, false, true]
						},
						{
							text: vm.weight ? vm.weight : '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_unit_ppm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_i_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_unit_ppm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_unit_ppm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_mn_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_unit_ppm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_se_'),
							border: [false, false, false, true]
						},
						{
							text: i18nFilter('_unit_ppm_'),
							border: [false, false, false, true]
						},
						{
							text: '%' + i18nFilter('_feeds_zn_'),
							border: [false, false, false, true]
						}
					];
					dd.content[20].table.body.splice(0, 0, ORTTable5Header2);
					dd.content[20].table.body.splice(0, 0, ORTTable5Header1);
				}
				var ORTable4 = {
					margin: [0, 10, 0, 0],
					table: {
						dontBreakRows: true,
						headerRows: 2,
						keepWithHeaderRows: 30,
						widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
						body: [
							[
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_amount_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_s_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_ash_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_vit_a_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_vit_d_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_vit_e_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_co_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_cu_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_cu_abs_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_fe_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_fe_abs_'),
									border: [false, true, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: '',
									border: [false, false, false, true]
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_iu_k_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_iu_k_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_iu_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_supply_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.s ? vm.ration.supply_amount.s : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.ash ? vm.ration.supply_amount.ash : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.vitamin_a ? vm.ration.supply_amount.vitamin_a : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.vitamin_d ? vm.ration.supply_amount.vitamin_d : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.vitamin_e ? vm.ration.supply_amount.vitamin_e : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.co ? vm.ration.supply_amount.co : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.cu ? vm.ration.supply_amount.cu : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.cu_abs ? vm.ration.supply_amount.cu_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.fe ? vm.ration.supply_amount.fe : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.fe_abs ? vm.ration.supply_amount.fe_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.s ? vm.ration.requirement_amount.s : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.vitamin_a ? vm.ration.requirement_amount.vitamin_a : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.vitamin_d ? vm.ration.requirement_amount.vitamin_d : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.vitamin_e ? vm.ration.requirement_amount.vitamin_e : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.co ? vm.ration.requirement_amount.co : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.cu ? vm.ration.requirement_amount.cu : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.cu_abs ? vm.ration.requirement_amount.cu_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.fe ? vm.ration.requirement_amount.fe : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.fe_abs ? vm.ration.requirement_amount.fe_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_difference_'),
									border: [false, false, false, true],
									alignment: 'right'
								},
								{
									text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.s ? vm.ration.balance_amount.s : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.vitamin_a ? vm.ration.balance_amount.vitamin_a : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.vitamin_d ? vm.ration.balance_amount.vitamin_d : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.vitamin_e ? vm.ration.balance_amount.vitamin_e : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.co ? vm.ration.balance_amount.co : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.cu ? vm.ration.balance_amount.cu : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.cu_abs ? vm.ration.balance_amount.cu_abs : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.fe ? vm.ration.balance_amount.fe : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.fe_abs ? vm.ration.balance_amount.fe_abs : '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							]
						]
					},
					layout: {
						hLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
						},
						vLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1 : 0.5;
						},
						hLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'black' : 'gray';
						},
						vLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
						},
						paddingLeft: function () {
							return 2;
						},
						paddingRight: function () {
							return 1;
						},
						paddingTop: function () {
							return 1;
						},
						paddingBottom: function () {
							return 0;
						}
					}
				};
				dd.content.splice(20, 0, ORTable4);
				if (vm.summary.feeds.length > 0) {
					for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
						var date = new Date(vm.summary.feeds[i].test_date);
						date = $filter('date')(date, 'shortDate');
						var ORTable4Feed = [
							{
								text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
								border: [false, false, false, false]
							},
							{
								text: vm.summary.feeds[i].amount ? $filter('number')(vm.summary.feeds[i].amount, 2) : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].s ? vm.summary.feeds[i].s : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].ash ? vm.summary.feeds[i].ash : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].vitamin_a ? vm.summary.feeds[i].vitamin_a : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].vitamin_d ? vm.summary.feeds[i].vitamin_d : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].vitamin_e ? vm.summary.feeds[i].vitamin_e : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].co ? vm.summary.feeds[i].co : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].cu ? vm.summary.feeds[i].cu : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].cu_abs ? vm.summary.feeds[i].cu_abs : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].fe ? vm.summary.feeds[i].fe : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].fe_abs ? vm.summary.feeds[i].fe_abs : '',
								border: [false, false, false, false],
								alignment: 'center'
							}
						];
						dd.content[20].table.body.splice(0, 0, ORTable4Feed);
					}
					var ORTTable4Header1 = [
						{
							text: '',
							border: [false, true, false, false]
						},
						{
							text: i18nFilter('_feeds_amount_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_s_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_ash_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_vit_a_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_vit_d_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_vit_e_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_co_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_cu_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_cu_abs_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_fe_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_fe_abs_'),
							border: [false, true, false, false],
							alignment: 'center'
						}
					];
					var ORTTable4Header2 = [
						{
							text: i18nFilter('_feeds_name_'),
							border: [false, false, false, true]
						},
						{
							text: vm.weight ? vm.weight : '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_unit_iu_k_') + '/' + (vm.weight ? vm.weight : ''),
							fontSize: 8,
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_unit_iu_k_') + '/' + (vm.weight ? vm.weight : ''),
							fontSize: 8,
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_unit_iu_') + '/' + (vm.weight ? vm.weight : ''),
							fontSize: 8,
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_unit_ppm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_unit_ppm_'),
							border: [false, false, false, true]
						},
						{
							text: '%' + i18nFilter('_feeds_cu_'),
							border: [false, false, false, true]
						},
						{
							text: i18nFilter('_unit_ppm_'),
							border: [false, false, false, true]
						},
						{
							text: '%' + i18nFilter('_feeds_fe_'),
							border: [false, false, false, true]
						}
					];
					dd.content[20].table.body.splice(0, 0, ORTTable4Header2);
					dd.content[20].table.body.splice(0, 0, ORTTable4Header1);
				}
				var ORTable3 = {
					margin: [0, 10, 0, 0],
					table: {
						dontBreakRows: true,
						headerRows: 2,
						keepWithHeaderRows: 30,
						widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
						body: [
							[
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_amount_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_fa_dig_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_ca_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_ca_abs_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_p_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_p_abs_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_mg_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_mg_abs_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_k_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_na_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_cl_'),
									border: [false, true, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: '',
									border: [false, false, false, true]
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_supply_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.fa_dig ? vm.ration.supply_amount.fa_dig : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.ca ? vm.ration.supply_amount.ca : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.ca_abs ? vm.ration.supply_amount.ca_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.p ? vm.ration.supply_amount.p : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.p_abs ? vm.ration.supply_amount.p_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.mg ? vm.ration.supply_amount.mg : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.mg_abs ? vm.ration.supply_amount.mg_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.k ? vm.ration.supply_amount.k : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.na ? vm.ration.supply_amount.na : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.cl ? vm.ration.supply_amount.cl : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.ca ? vm.ration.requirement_amount.ca : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.ca_abs ? vm.ration.requirement_amount.ca_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.p ? vm.ration.requirement_amount.p : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.p_abs ? vm.ration.requirement_amount.p_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.mg ? vm.ration.requirement_amount.mg : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.mg_abs ? vm.ration.requirement_amount.mg_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.k ? vm.ration.requirement_amount.k : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.na ? vm.ration.requirement_amount.na : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.cl ? vm.ration.requirement_amount.cl : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, true],
									alignment: 'right'
								},
								{
									text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.ca ? vm.ration.balance_amount.ca : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.ca_abs ? vm.ration.balance_amount.ca_abs : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.p ? vm.ration.balance_amount.p : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.p_abs ? vm.ration.balance_amount.p_abs : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.mg ? vm.ration.balance_amount.mg : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.mg_abs ? vm.ration.balance_amount.mg_abs : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.k ? vm.ration.balance_amount.k : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.na ? vm.ration.balance_amount.na : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.cl ? vm.ration.balance_amount.cl : '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							]
						]
					},
					layout: {
						hLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
						},
						vLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1 : 0.5;
						},
						hLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'black' : 'gray';
						},
						vLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
						},
						paddingLeft: function () {
							return 2;
						},
						paddingRight: function () {
							return 1;
						},
						paddingTop: function () {
							return 1;
						},
						paddingBottom: function () {
							return 0;
						}
					},
					pageBreak: 'before'
				};
				dd.content.splice(20, 0, ORTable3);
				if (vm.summary.feeds.length > 0) {
					for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
						var date = new Date(vm.summary.feeds[i].test_date);
						date = $filter('date')(date, 'shortDate');
						var ORTable3Feed = [
							{
								text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
								border: [false, false, false, false]
							},
							{
								text: vm.summary.feeds[i].amount ? $filter('number')(vm.summary.feeds[i].amount, 2) : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].fa_dig ? vm.summary.feeds[i].fa_dig : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].ca ? vm.summary.feeds[i].ca : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].ca_abs ? vm.summary.feeds[i].ca_abs : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].p ? vm.summary.feeds[i].p : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].p_abs ? vm.summary.feeds[i].p_abs : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].mg ? vm.summary.feeds[i].mg : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].mg_abs ? vm.summary.feeds[i].mg_abs : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].k ? vm.summary.feeds[i].k : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].na ? vm.summary.feeds[i].na : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].cl ? vm.summary.feeds[i].cl : '',
								border: [false, false, false, false],
								alignment: 'center'
							}
						];
						dd.content[20].table.body.splice(0, 0, ORTable3Feed);
					}
					var ORTTable3Header1 = [
						{
							text: '',
							border: [false, true, false, false]
						},
						{
							text: i18nFilter('_feeds_amount_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_fa_dig_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_ca_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_ca_abs_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_p_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_p_abs_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_mg_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_mg_abs_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_k_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_na_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_cl_'),
							border: [false, true, false, false],
							alignment: 'center'
						}
					];
					var ORTTable3Header2 = [
						{
							text: i18nFilter('_feeds_name_'),
							border: [false, false, false, true]
						},
						{
							text: vm.weight ? vm.weight : '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_fa_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_ca_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_p_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_mg_'),
							border: [false, false, false, true]
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true]
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true]
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true]
						}
					];
					dd.content[20].table.body.splice(0, 0, ORTTable3Header2);
					dd.content[20].table.body.splice(0, 0, ORTTable3Header1);
				}
				var ORTable2 = {
					margin: [0, 10, 0, 0],
					table: {
						headerRows: 2,
						dontBreakRows: true,
						keepWithHeaderRows: 30,
						widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
						body: [
							[
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_amount_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_nfc_digestibility_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_starch_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_rdstarch_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_sugar_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_infa_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_rdsolf_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_ee_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_sfa_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_pufa_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_bhfa_'),
									border: [false, true, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: '',
									border: [false, false, false, true]
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_supply_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.nfc_dig ? vm.ration.supply_amount.nfc_dig : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.starch ? vm.ration.supply_amount.starch : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.rd_starch ? vm.ration.supply_amount.rd_starch : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.sugar ? vm.ration.supply_amount.sugar : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.in_fa ? vm.ration.supply_amount.in_fa : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.rd_sol_fiber ? vm.ration.supply_amount.rd_sol_fiber : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.ee ? vm.ration.supply_amount.ee : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.sfa ? vm.ration.supply_amount.sfa : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.pufa ? vm.ration.supply_amount.pufa : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.bhfa ? vm.ration.supply_amount.bhfa : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_difference_'),
									border: [false, false, false, true],
									alignment: 'right'
								},
								{
									text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							]
						]
					},
					layout: {
						hLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
						},
						vLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1 : 0.5;
						},
						hLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'black' : 'gray';
						},
						vLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
						},
						paddingLeft: function () {
							return 2;
						},
						paddingRight: function () {
							return 1;
						},
						paddingTop: function () {
							return 1;
						},
						paddingBottom: function () {
							return 0;
						}
					}
				};
				dd.content.splice(20, 0, ORTable2);
				if (vm.summary.feeds.length > 0) {
					for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
						var date = new Date(vm.summary.feeds[i].test_date);
						date = $filter('date')(date, 'shortDate');
						var ORTable2Feed = [
							{
								text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
								border: [false, false, false, false]
							},
							{
								text: vm.summary.feeds[i].amount ? $filter('number')(vm.summary.feeds[i].amount, 2) : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].nfc_dig ? vm.summary.feeds[i].nfc_dig : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].starch ? vm.summary.feeds[i].starch : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].rd_starch ? vm.summary.feeds[i].rd_starch : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].sugar ? vm.summary.feeds[i].sugar : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].in_fa ? vm.summary.feeds[i].in_fa : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].rd_sol_fiber ? vm.summary.feeds[i].rd_sol_fiber : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].ee ? vm.summary.feeds[i].ee : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].sfa ? vm.summary.feeds[i].sfa : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].pufa ? vm.summary.feeds[i].pufa : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].bhfa ? vm.summary.feeds[i].bhfa : '',
								border: [false, false, false, false],
								alignment: 'center'
							}
						];
						dd.content[20].table.body.splice(0, 0, ORTable2Feed);
					}
					var ORTTable2Header1 = [
						{
							text: '',
							border: [false, true, false, false]
						},
						{
							text: i18nFilter('_feeds_amount_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_nfc_digestibility_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_starch_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_rdstarch_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_sugar_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_infa_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_rdsolf_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_ee_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_sfa_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_pufa_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_bhfa_'),
							border: [false, true, false, false],
							alignment: 'center'
						}
					];
					var ORTTable2Header2 = [
						{
							text: i18nFilter('_feeds_name_'),
							border: [false, false, false, true]
						},
						{
							text: vm.weight ? vm.weight : '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_nfc_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_starch_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_solfiber_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true]
						},
						{
							text: '%' + i18nFilter('_feeds_fa_'),
							border: [false, false, false, true]
						},
						{
							text: '%' + i18nFilter('_feeds_fa_'),
							border: [false, false, false, true]
						},
						{
							text: '%' + i18nFilter('_feeds_fa_'),
							border: [false, false, false, true]
						}
					];
					dd.content[20].table.body.splice(0, 0, ORTTable2Header2);
					dd.content[20].table.body.splice(0, 0, ORTTable2Header1);
				}
				var ORTable1 = {
					margin: [0, 10, 0, 0],
					table: {
						dontBreakRows: true,
						headerRows: 2,
						keepWithHeaderRows: 30,
						widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
						body: [
							[
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_amount_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_cp_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_rup_dig_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_npncpe_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_rup89_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_ndicp_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_adicp_'),
									border: [false, true, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: '',
									border: [false, false, false, true]
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_supply_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.cp ? vm.ration.supply_amount.cp : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.rup_dig ? vm.ration.supply_amount.rup_dig : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.npncpe ? vm.ration.supply_amount.npncpe : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.rup_89 ? vm.ration.supply_amount.rup_89 : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.ndicp ? vm.ration.supply_amount.ndicp : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.adicp ? vm.ration.supply_amount.adicp : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.cp ? vm.ration.requirement_amount.cp : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.rup_dig ? vm.ration.requirement_amount.rup_dig : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.rup_89 ? vm.ration.requirement_amount.rup_89 : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_difference_'),
									border: [false, false, false, true],
									alignment: 'right'
								},
								{
									text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.cp ? vm.ration.balance_amount.cp : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.rup_dig ? vm.ration.balance_amount.rup_dig : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.rup_89 ? vm.ration.balance_amount.rup_89 : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							]
						]
					},
					layout: {
						hLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
						},
						vLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1 : 0.5;
						},
						hLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'black' : 'gray';
						},
						vLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
						},
						paddingLeft: function () {
							return 2;
						},
						paddingRight: function () {
							return 1;
						},
						paddingTop: function () {
							return 1;
						},
						paddingBottom: function () {
							return 0;
						}
					}
				};
				dd.content.splice(20, 0, ORTable1);
				if (vm.summary.feeds.length > 0) {
					for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
						var date = new Date(vm.summary.feeds[i].test_date);
						date = $filter('date')(date, 'shortDate');
						var ORTable1Feed = [
							{
								text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
								border: [false, false, false, false]
							},
							{
								text: vm.summary.feeds[i].amount ? $filter('number')(vm.summary.feeds[i].amount, 2) : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].cp ? vm.summary.feeds[i].cp : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].rup_dig ? vm.summary.feeds[i].rup_dig : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].a_prot ? vm.summary.feeds[i].a_prot : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].b_prot ? vm.summary.feeds[i].b_prot : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].c_prot ? vm.summary.feeds[i].c_prot : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].kd_b_prot ? vm.summary.feeds[i].kd_b_prot : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].npncpe ? vm.summary.feeds[i].npncpe : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].rup_89 ? vm.summary.feeds[i].rup_89 : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].ndicp ? vm.summary.feeds[i].ndicp : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].adicp ? vm.summary.feeds[i].adicp : '',
								border: [false, false, false, false],
								alignment: 'center'
							}
						];
						dd.content[20].table.body.splice(0, 0, ORTable1Feed);
					}
					var ORTTable1Header1 = [
						{
							text: '',
							border: [false, true, false, false]
						},
						{
							text: i18nFilter('_feeds_amount_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_cp_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_rup_dig_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_protein_a_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_protein_b_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_protein_c_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_kd_bprot_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_npncpe_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_rup89_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_ndicp_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_adicp_'),
							border: [false, true, false, false],
							alignment: 'center'
						}
					];
					var ORTTable1Header2 = [
						{
							text: i18nFilter('_feeds_name_'),
							border: [false, false, false, true]
						},
						{
							text: vm.weight ? vm.weight : '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_rup_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_cp_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_cp_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_cp_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_unit_hours_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_cp_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_cp_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						}
					];
					dd.content[20].table.body.splice(0, 0, ORTTable1Header2);
					dd.content[20].table.body.splice(0, 0, ORTTable1Header1);
				}
				var ORTable0 = {
					margin: [0, 10, 0, 0],
					table: {
						dontBreakRows: true,
						headerRows: 2,
						keepWithHeaderRows: 30,
						widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
						body: [
							[
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_amount_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_ndf_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_efndf_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_lingnin_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_ndf_dig_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_efndf_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_adf_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_rdndf_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_disc_fac_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_nel89_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_me89_'),
									border: [false, true, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: '',
									border: [false, false, false, true]
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.energy ? vm.energy : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.energy ? vm.energy : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_supply_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.ndf ? vm.ration.supply_amount.ndf : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.ef_ndf_as_ndf ? vm.ration.supply_amount.ef_ndf_as_ndf : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.lignin ? vm.ration.supply_amount.lignin : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.ndf_digest ? vm.ration.supply_amount.ndf_digest : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.ef_ndf_as_dm ? vm.ration.supply_amount.ef_ndf_as_dm : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.adf ? vm.ration.supply_amount.adf : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.rd_ndf ? vm.ration.supply_amount.rd_ndf : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.disc_fac ? vm.ration.supply_amount.disc_fac : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.nel_89 ? vm.ration.supply_amount.nel_89 : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.me_89 ? vm.ration.supply_amount.me_89 : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.ndf ? vm.ration.requirement_amount.ndf : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.ef_ndf_as_ndf ? vm.ration.requirement_amount.ef_ndf_as_ndf : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.ef_ndf_as_dm ? vm.ration.requirement_amount.ef_ndf_as_dm : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.nel_89 ? vm.ration.requirement_amount.nel_89 : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.me_89 ? vm.ration.requirement_amount.me_89 : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, true],
									alignment: 'right'
								},
								{
									text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.ndf ? vm.ration.balance_amount.ndf : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.ef_ndf_as_ndf ? vm.ration.balance_amount.ef_ndf_as_ndf : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.ef_ndf_as_dm ? vm.ration.balance_amount.ef_ndf_as_dm : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.nel_89 ? vm.ration.balance_amount.nel_89 : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.me_89 ? vm.ration.balance_amount.me_89 : '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							]
						]
					},
					layout: {
						hLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
						},
						vLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1 : 0.5;
						},
						hLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'black' : 'gray';
						},
						vLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
						},
						paddingLeft: function () {
							return 2;
						},
						paddingRight: function () {
							return 1;
						},
						paddingTop: function () {
							return 1;
						},
						paddingBottom: function () {
							return 0;
						}
					}
				};
				dd.content.splice(20, 0, ORTable0);
				if (vm.summary.feeds.length > 0) {
					for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
						var date = new Date(vm.summary.feeds[i].test_date);
						date = $filter('date')(date, 'shortDate');
						var ORTable0Feed = [
							{
								text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
								border: [false, false, false, false]
							},
							{
								text: vm.summary.feeds[i].amount ? $filter('number')(vm.summary.feeds[i].amount, 2) : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].ndf ? vm.summary.feeds[i].ndf : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].ef_ndf_as_ndf ? vm.summary.feeds[i].ef_ndf_as_ndf : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].lignin ? vm.summary.feeds[i].lignin : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].ndf_digest ? vm.summary.feeds[i].ndf_digest : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].ef_ndf_as_dm ? vm.summary.feeds[i].ef_ndf_as_dm : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].adf ? vm.summary.feeds[i].adf : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].rd_ndf ? vm.summary.feeds[i].rd_ndf : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].disc_fac ? vm.summary.feeds[i].disc_fac : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].nel_89 ? vm.summary.feeds[i].nel_89 : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].me_89 ? vm.summary.feeds[i].me_89 : '',
								border: [false, false, false, false],
								alignment: 'center'
							}
						];
						dd.content[20].table.body.splice(0, 0, ORTable0Feed);
					}
					var ORTTable0Header1 = [
						{
							text: '',
							border: [false, true, false, false]
						},
						{
							text: i18nFilter('_feeds_amount_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_ndf_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_efndf_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_lingnin_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_ndf_dig_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_efndf_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_adf_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_rdndf_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_disc_fac_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_nel89_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_me89_'),
							border: [false, true, false, false],
							alignment: 'center'
						}
					];
					var ORTTable0Header2 = [
						{
							text: i18nFilter('_feeds_name_'),
							border: [false, false, false, true]
						},
						{
							text: vm.weight ? vm.weight : '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_ndf_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_ndfn_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_unit_hours_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_ndf_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: (vm.energy ? vm.energy : '') + '/' + i18nFilter('_unit_day_'),
							fontSize: 8,
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: (vm.energy ? vm.energy : '') + '/' + i18nFilter('_unit_day_'),
							fontSize: 8,
							border: [false, false, false, true],
							alignment: 'center'
						}
					];
					dd.content[20].table.body.splice(0, 0, ORTTable0Header2);
					dd.content[20].table.body.splice(0, 0, ORTTable0Header1);
				}
			}
			var name = vm.summary.ration_name;
			if (isSummary) {
				var type = i18nFilter('_report_summary_');
			} else {
				var type = i18nFilter('_report_office_report_');
			}
			var reportName = type + ' ' + name + '.pdf';
			pdfMake.createPdf(dd).download(reportName);
			reportPromise.resolve();
			return reportPromise.promise;
		}

		function exportSummaryOfficeReportVem(isSummary, scope, round, setSignificant, RRToLb, RRToMjoule) {
			var reportPromise = $q.defer();
			var vm = angular.copy(scope);
			vm.summary.group = {};
			vm.breeds = APP_CONST.mocks.breeds;
			for (var i = 0; i < vm.breeds.length; i++) {
				if (vm.breeds[i].value == vm.ration.group.breed) {
					vm.summary.group.breed = vm.breeds[i].name;
					break;
				}
			}
			vm.animal_types = APP_CONST.mocks.animal_types;
			for (var i = 0; i < vm.animal_types.length; i++) {
				if (vm.animal_types[i].type == vm.ration.group.type) {
					vm.summary.group.animal_type = vm.animal_types[i].name;
					break;
				}
			}
			vm.summary.group.current_age = vm.ration.group.current_age;
			vm.summary.group.target_age = vm.ration.group.target_age;
			vm.summary.group.upcoming_lactation_number = vm.ration.group.upcoming_lactation_number;
			vm.summary.group.lactation_number = vm.ration.group.lactation_number;
			vm.summary.group.days_in_milk = vm.ration.group.days_in_milk;
			vm.summary.group.target_milk_yield = $filter('number')(vm.ration.group.target_milk_yield, 1);
			vm.summary.group.actual_milk_yield = $filter('number')(vm.ration.group.actual_milk_yield, 1);
			vm.summary.group.target_fat = $filter('number')(vm.ration.group.target_fat, 2);
			vm.summary.group.actual_fat = $filter('number')(vm.ration.group.actual_fat, 2);
			vm.summary.group.target_protein = $filter('number')(vm.ration.group.target_t_protein, 2);
			vm.summary.group.actual_protein = $filter('number')(vm.ration.group.actual_t_protein, 2);
			vm.summary.group.target_lactose = $filter('number')(vm.ration.group.target_lactose, 2);
			vm.summary.group.actual_lactose = $filter('number')(vm.ration.group.actual_lactose, 2);
			var bw_without_fetus = vm.ration.group.bw_without_fetus;
			vm.summary.group.bw_without_fetus = round(bw_without_fetus, 0);
			vm.summary.group.body_condition_score = vm.ration.group.body_condition_score;
			var target_daily_bw_gain = vm.ration.group.target_daily_bw_gain;
			target_daily_bw_gain = Number(target_daily_bw_gain);
			if (target_daily_bw_gain && !isNaN(target_daily_bw_gain)) {
				var param = target_daily_bw_gain.toPrecision(3);
				var param_nod = decimalPlaces(param);
				target_daily_bw_gain = $filter('number')(param, param_nod);
			}
			vm.summary.group.target_daily_bw_gain = target_daily_bw_gain;
			var mature_bw = vm.ration.group.mature_bw;
			vm.summary.group.mature_bw = round(mature_bw, 0);
			vm.summary.group.days_pregnant = vm.ration.group.days_pregnant;
			var ts = APP_CONST.constants.temperature_stresses;
			for (var i = 0; i < ts.length; i++) {
				if (ts[i].name == vm.ration.ration_header.temperature_stress) {
					vm.summary.group.temperature_stress = i18nFilter(ts[i].value);
					break;
				}
			}
			var al = APP_CONST.constants.activity_levels;
			for (var i = 0; i < al.length; i++) {
				if (al[i].name == vm.ration.ration_header.activity_level) {
					vm.summary.group.activity_level = i18nFilter(al[i].value);
					break;
				}
			}
			var fa = APP_CONST.constants.feed_additives;
			for (var i = 0; i < fa.length; i++) {
				if (fa[i].name == vm.ration.ration_header.description) {
					vm.summary.group.feed_additive = i18nFilter(fa[i].value);
					break;
				}
			}
			var mps = APP_CONST.constants.met_prot_sys;
			for (var i = 0; i < mps.length; i++) {
				if (mps[i].value == vm.ration.ration_header.model_name) {
					vm.summary.group.met_prot_sys = i18nFilter(mps[i].name);
					break;
				}
			}
			var feeds = [];
			for (var i = 0; i < vm.ration.feeds.length; i++) {
				vm.ration.feeds[i] = unitConversionService.convertData(vm.ration.feeds[i], ['bulkPercentToAmount', 'bulkKgToLb', 'bulkMcalToMjoule', 'bulkRoundValues', 'bulkGetSignificant'], 1);
				if (vm.ration.feeds[i].amount > 0) {
					feeds.push(vm.ration.feeds[i]);
				}
			}
			vm.summary.feeds = feeds;
			vm.ration.supply_conc.rus = vm.ration.concentration_supplied.rus;
			vm.ration.balance_amount = unitConversionService.convertData(vm.ration.balance_amount, ['bulkPercentToAmount', 'bulkKgToLb', 'bulkMcalToMjoule', 'bulkRoundValues', 'bulkGetSignificant'], 2);
			vm.ration.requirement_amount = unitConversionService.convertData(vm.ration.requirement_amount, ['bulkPercentToAmount', 'bulkKgToLb', 'bulkMcalToMjoule', 'bulkRoundValues', 'bulkGetSignificant'], 2);
			vm.ration.supply_amount = unitConversionService.convertData(vm.ration.supply_amount, ['bulkPercentToAmount', 'bulkKgToLb', 'bulkMcalToMjoule', 'bulkRoundValues', 'bulkGetSignificant'], 2);
			vm.ration.balance_conc = unitConversionService.convertData(vm.ration.balance_conc, ['balanceKgToLbConcentration', 'bulkMcalToMjoule', 'bulkRoundValues', 'bulkGetSignificant'], 3);
			vm.ration.requirement_conc = unitConversionService.convertData(vm.ration.requirement_conc, ['balanceKgToLbConcentration', 'bulkMcalToMjoule', 'bulkRoundValues', 'bulkGetSignificant'], 3);
			vm.ration.supply_conc = unitConversionService.convertData(vm.ration.supply_conc, ['balanceKgToLbConcentration', 'bulkMcalToMjoule', 'bulkRoundValues', 'bulkGetSignificant'], 3);
			var randr = {};
			angular.copy(vm.ration.rations_and_relationships, randr);
			if (!vm.settings.use_kgs) {
				randr = RRToLb(randr);
			}
			if (!vm.settings.use_mcal) {
				randr = RRToMjoule(randr);
			}
			randr = setSignificant(randr);
			vm.summary.randr = randr;
			if (vm.ration.group.type == 'heifer') {
				var negOrNel = i18nFilter('_rations_neg_');
				var negOrNelSupply = vm.ration.supply_amount.neg;
				var negOrNelRequirements = vm.ration.requirement_amount.neg;
				var negOrNelBalance = vm.ration.balance_amount.neg;
			} else {
				var negOrNel = i18nFilter('_feeds_nel_');
				var negOrNelSupply = vm.ration.supply_amount.nel;
				var negOrNelRequirements = vm.ration.requirement_amount.nel;
				var negOrNelBalance = vm.ration.balance_amount.nel;
			}
			var energyAllowable = '';
			var proteinAllowable = '';
			var energyAllowableValue = '';
			var proteinAllowableValue = '';
			if (vm.ration.group.type == 'heifer') {
				energyAllowable = i18nFilter('_rations_vem_allowable_gain_');
				proteinAllowable = i18nFilter('_rations_dve_allowable_gain_');
				energyAllowableValue = vm.summary.randr.energyallowable_gain;
				proteinAllowableValue = vm.summary.randr.proteinallowable_gain;
			} else if (vm.ration.group.type == 'drycow/late_pregnant_heifer') {
				energyAllowable = i18nFilter('_rations_vem_allowable_bc_gain_');
				proteinAllowable = i18nFilter('_rations_dve_allowable_bc_gain_');
				energyAllowableValue = vm.summary.randr.energyallowable_bc_gain;
				proteinAllowableValue = vm.summary.randr.proteinallowable_bc_gain;
			} else if (vm.ration.group.type == 'lactating_cow') {
				energyAllowable = i18nFilter('_rations_vem_allowable_milk_');
				proteinAllowable = i18nFilter('_rations_dve_allowable_milk_');
				energyAllowableValue = vm.summary.randr.vem_allowable_milk;
				proteinAllowableValue = vm.summary.randr.dve_allowable_milk;
			}
			var c0r0 = '';
			var c0r1 = '';
			var c0r2 = '';
			var c0r3 = '';
			var c1r0 = '';
			var c1r1 = '';
			var c1r2 = '';
			var c1r3 = '';
			var c2r0 = '';
			var c2r1 = '';
			var c2r2 = '';
			var c2r3 = '';
			var c3r0 = '';
			var c3r1 = '';
			var c3r2 = '';
			var c3r3 = '';
			var c4r0 = '';
			var c4r1 = '';
			var c4r2 = '';
			var c4r3 = '';
			var c5r0 = '';
			var c5r1 = '';
			var c5r2 = '';
			var c5r3 = '';
			var c6r0 = '';
			var c6r1 = '';
			var c6r2 = '';
			var c6r3 = '';
			var c7r0 = '';
			var c7r1 = '';
			var c7r2 = '';
			var c7r3 = '';
			var rr04 = '';
			var rr05 = '';
			var rr14 = '';
			var rr15 = '';
			var rr24 = '';
			var rr25 = '';
			var rr31 = '';
			var rr41 = '';
			var rr51 = '';
			var rr32 = '';
			var rr42 = '';
			var rr52 = '';
			if (vm.ration.group.type == 'heifer') {
				c1r1 = i18nFilter('_groups_current_age_') + ':';
				c1r2 = vm.summary.group.current_age;
				c1r3 = i18nFilter('_unit_months_');
				c2r1 = i18nFilter('_groups_target_age_') + ':';
				c2r2 = vm.summary.group.target_age;
				c2r3 = i18nFilter('_unit_months_');
			} else if (vm.ration.group.type == 'lactating_cow') {
				c1r2 = i18nFilter('_report_lactation_number_') + ':';
				c1r3 = vm.summary.group.lactation_number;
				c2r2 = i18nFilter('_groups_days_in_milk_') + ':';
				c2r3 = vm.summary.group.days_in_milk;
				c3r1 = i18nFilter('_report_target_');
				c3r2 = i18nFilter('_report_actual_');
				c4r0 = i18nFilter('_report_milk_yield_') + ':';
				c4r1 = vm.summary.group.target_milk_yield;
				c4r2 = vm.summary.group.actual_milk_yield;
				c4r3 = vm.weight + '/' + i18nFilter('_unit_day_');
				c5r0 = i18nFilter('_report_fat_') + ':';
				c5r1 = vm.summary.group.target_fat;
				c5r2 = vm.summary.group.actual_fat;
				c5r3 = '%';
				c6r0 = i18nFilter('_report_protein_') + ':';
				c6r1 = vm.summary.group.target_protein;
				c6r2 = vm.summary.group.actual_protein;
				c6r3 = '%';
				c7r0 = i18nFilter('_report_lactose_') + ':';
				c7r1 = vm.summary.group.target_lactose;
				c7r2 = vm.summary.group.actual_lactose;
				c7r3 = '%';
				var rr04 = i18nFilter('_rations_energy_corrected_milk_');
				var rr05 = i18nFilter('_rations_energy_corrected_milk_short_') + '/' + i18nFilter('_feeds_dmi_');
				var rr14 = vm.summary.randr.energycorrected_milk;
				var rr15 = vm.summary.randr.ecm_dmi;
				var rr24 = vm.weight + '/' + i18nFilter('_unit_day_');
				var rr25 = '';
				var rr31 = i18nFilter('_rations_feed_cost_') + '/' + i18nFilter('_rations_100_wt_milk_');
				var rr41 = vm.summary.randr.feed_cost_100_wt_milk;
				var rr51 = vm.currency + '/100';
				var rr32 = i18nFilter('_rations_income_over_feed_costs_');
				var rr42 = vm.summary.randr.income_over_feed_costs;
				var rr52 = vm.currency + '/' + i18nFilter('_unit_day_');
			} else if (vm.ration.group.type == 'drycow/late_pregnant_heifer') {
				c1r2 = i18nFilter('_report_upcoming_lactation_number_') + ':';
				c1r3 = vm.summary.group.upcoming_lactation_number;
			}
			var dd = {
				pageMargins: [25, 40, 20, 40],
				header: [
					{
						alignment: 'justify',
						style: 'headerStyle',
						columns: [
							{
								text: isSummary ? i18nFilter('_report_summary_') : i18nFilter('_report_office_report_'),
								margin: [25, 10, 0, 0],
								width: 200
							},
							{
								text: vm.summary.ration_name ? vm.summary.ration_name : '',
								margin: [0, 10, 0, 0],
								width: '*'
							},
							{
								text: $filter('date')(new Date(), 'shortDate'),
								bold: false,
								fontSize: 12,
								margin: [10, 12, 0, 0],
								width: 100
							}
						]
					}
				],
				footer: [
					{
						margin: [45, 0, 30, 10],
						table: {
							widths: ['auto'],
							body: [
								[
									{
										text: i18nFilter('_report_footer_feed_'),
										border: [false, false, false, false]
									}
								]
							]
						}
					}
				],
				content: [
					{
						alignment: 'justify',
						columns: [
							{
								text: i18nFilter('_report_prepared_for_') + ':',
								style: 'bold'
							},
							{
								text: i18nFilter('_report_prepared_by_') + ':',
								style: 'bold'
							}
						]
					},
					{
						alignment: 'justify',
						columns: [
							{
								text: vm.preperedFor ? vm.preperedFor : '',
								style: 'small'
							},
							{
								text: vm.preperedBy ? vm.preperedBy : '',
								style: 'small'
							}
						]
					},
					'\n',
					{
						table: {
							body: [
								[
									{
										text: (vm.summary.group.breed ? vm.summary.group.breed : '') + ', ' + (vm.summary.group.animal_type ? vm.summary.group.animal_type : ''),
										colSpan: 7,
										border: [false, false, false, false]
									},
									{},
									{},
									{},
									{},
									{},
									{}
								],
								[
									{
										text: c0r0 ? c0r0 : '',
										border: [true, true, false, false]
									},
									{
										text: c0r1 ? c0r1 : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: c0r2 ? c0r2 : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: c0r3 ? c0r3 : '',
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_report_body_weight_without_fetus_') + ':',
										border: [true, true, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.group.bw_without_fetus ? vm.summary.group.bw_without_fetus : '',
										border: [false, true, false, false],
										alignment: 'right'
									},
									{
										text: vm.weight ? vm.weight : '',
										border: [false, true, true, false]
									}
								],
								[
									{
										text: c1r0 ? c1r0 : '',
										border: [true, false, false, false]
									},
									{
										text: c1r1 ? c1r1 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: c1r2 ? c1r2 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: c1r3 ? c1r3 : '',
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_report_current_body_condition_score_') + ':',
										border: [true, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.group.body_condition_score ? vm.summary.group.body_condition_score : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: c2r0 ? c2r0 : '',
										border: [true, false, false, false]
									},
									{
										text: c2r1 ? c2r1 : '',
										border: [false, false, false, false]
									},
									{
										text: c2r2 ? c2r2 : '',
										border: [false, false, false, false]
									},
									{
										text: c2r3 ? c2r3 : '',
										border: [false, false, false, false]
									},
									{
										text: i18nFilter('_report_target_daily_gain_') + ':',
										border: [true, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.group.target_daily_bw_gain ? vm.summary.group.target_daily_bw_gain : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, true, false]
									}
								],
								[
									{
										text: c3r0 ? c3r0 : '',
										border: [true, false, false, true]
									},
									{
										text: c3r1 ? c3r1 : '',
										border: [false, false, false, true],
										alignment: 'right',
										bold: true
									},
									{
										text: c3r2 ? c3r2 : '',
										border: [false, false, false, true],
										alignment: 'right',
										bold: true
									},
									{
										text: c3r3 ? c3r3 : '',
										border: [false, false, false, true]
									},
									{
										text: i18nFilter('_groups_mature_bw_') + ':',
										border: [true, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.group.mature_bw ? vm.summary.group.mature_bw : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.weight ? vm.weight : '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: c4r0 ? c4r0 : '',
										border: [true, false, false, false],
										alignment: 'right'
									},
									{
										text: c4r1 ? c4r1 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: c4r2 ? c4r2 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: c4r3 ? c4r3 : '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_groups_days_pregnant_') + ':',
										border: [true, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.summary.group.days_pregnant ? vm.summary.group.days_pregnant : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: c5r0 ? c5r0 : '',
										border: [true, false, false, false],
										alignment: 'right'
									},
									{
										text: c5r1 ? c5r1 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: c5r2 ? c5r2 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: c5r3 ? c5r3 : '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.group.temperature_stress ? vm.summary.group.temperature_stress : '',
										border: [true, true, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, true, false, false]
									},
									{
										text: '',
										border: [false, true, true, false]
									}
								],
								[
									{
										text: c6r0 ? c6r0 : '',
										border: [true, false, false, false],
										alignment: 'right'
									},
									{
										text: c6r1 ? c6r1 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: c6r2 ? c6r2 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: c6r3 ? c6r3 : '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.group.activity_level ? vm.summary.group.activity_level : '',
										border: [true, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, true, false]
									}
								],
								[
									{
										text: c7r0 ? c7r0 : '',
										border: [true, false, false, true],
										alignment: 'right'
									},
									{
										text: c7r1 ? c7r1 : '',
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: c7r2 ? c7r2 : '',
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: c7r3 ? c7r3 : '',
										border: [false, false, false, true],
										alignment: 'left'
									},
									{
										text: i18nFilter('_rations_animal_feed_additives_') + ': ' + (vm.summary.group.feed_additive ? vm.summary.group.feed_additive : ''),
										border: [true, false, false, true],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, true]
									},
									{
										text: '',
										border: [false, false, true, true]
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 3;
							},
							paddingRight: function () {
								return 2;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						}
					},
					'\n',
					{
						table: {
							widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
							body: [
								[
									{
										text: '',
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_amount_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_as_fed_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_dm_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_report_diet_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_ndf_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_vem_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_dve_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_cp_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_report_asSold_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_report_wt_as_sold_'),
										border: [false, true, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: '',
										border: [false, false, false, true]
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%',
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '%' + i18nFilter('_feeds_dmi_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_vem_') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.currency ? vm.currency : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									}
								],
								[
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_rations_supply_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.as_fed ? $filter('number')(vm.ration.supply_amount.as_fed, 2) : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.dm ? vm.ration.supply_amount.dm : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.diet_dmi ? vm.ration.supply_amount.diet_dmi : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.ndf ? vm.ration.supply_amount.ndf : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.vem ? vm.ration.supply_amount.vem : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.dve ? vm.ration.supply_amount.dve : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.cp ? vm.ration.supply_amount.cp : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.cost_dm ? vm.ration.supply_amount.cost_dm : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_rations_requirements_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.ndf ? vm.ration.requirement_amount.ndf : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.vem ? vm.ration.requirement_amount.vem : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.dve ? vm.ration.requirement_amount.dve : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.cp ? vm.ration.requirement_amount.cp : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_rations_difference_'),
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.ndf ? vm.ration.balance_amount.ndf : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.vem ? vm.ration.balance_amount.vem : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.dve ? vm.ration.balance_amount.dve : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.cp ? vm.ration.balance_amount.cp : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 0;
							},
							paddingRight: function () {
								return 2;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						}
					},
					'\n',
					{
						table: {
							widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 45],
							body: [
								[
									{
										text: '',
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_amount_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_fos_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_oeb_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_fa_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_starch_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_ca_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_p_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_k_'),
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: i18nFilter('_feeds_cost_dm_'),
										border: [false, true, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true]
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: (vm.currency ? vm.currency : '') + '/' + i18nFilter('_unit_day_'),
										fontSize: 8,
										border: [false, false, false, true],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_supply_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.fos ? vm.ration.supply_amount.fos : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.oeb ? vm.ration.supply_amount.oeb : '',
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.fa ? vm.ration.supply_amount.fa : '',
										border: [false, true, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.starch ? vm.ration.supply_amount.starch : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.ca ? vm.ration.supply_amount.ca : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.p ? vm.ration.supply_amount.p : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.k ? vm.ration.supply_amount.k : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.supply_amount.cost_dm ? vm.ration.supply_amount.cost_dm : '',
										border: [false, true, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_requirements_'),
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.fos ? vm.ration.requirement_amount.fos : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.oeb ? vm.ration.requirement_amount.oeb : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.ca ? vm.ration.requirement_amount.ca : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.p ? vm.ration.requirement_amount.p : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.k ? vm.ration.requirement_amount.k : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_difference_'),
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.fos ? vm.ration.balance_amount.fos : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.oeb ? vm.ration.balance_amount.oeb : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.ca ? vm.ration.balance_amount.ca : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.p ? vm.ration.balance_amount.p : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.k ? vm.ration.balance_amount.k : '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'cefalsenter'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 1;
							},
							paddingRight: function () {
								return 2;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						},
						pageBreak: 'after'
					},
					{
						table: {
							widths: ['*', '*'],
							body: [
								[
									{
										text: i18nFilter('_report_diet_summary_').toUpperCase(),
										border: [false, false, false, true],
										bold: true
									},
									{
										text: i18nFilter('_report_mp_system_used_') + ': ' + (vm.summary.group.met_prot_sys ? vm.summary.group.met_prot_sys : ''),
										border: [false, false, false, true],
										alignment: 'right'
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 2;
							},
							paddingRight: function () {
								return 5;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						}
					},

					{
						table: {
							headerRows: 1,
							widths: ['auto', 'auto', '*', '*', '*'],
							body: [
								[
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center',
										margin: [0, 5, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center',
										margin: [0, 5, 0, 0]
									},
									{
										text: i18nFilter('_rations_supply_'),
										border: [false, false, false, true],
										alignment: 'center',
										margin: [0, 5, 0, 0]
									},
									{
										text: i18nFilter('_rations_requirements_'),
										border: [false, false, false, true],
										alignment: 'center',
										margin: [0, 5, 0, 0]
									},
									{
										text: i18nFilter('_rations_difference_'),
										border: [false, false, false, true],
										alignment: 'center',
										margin: [0, 5, 0, 0]
									}
								],
								[
									{
										text: i18nFilter('_feeds_vem_'),
										border: [false, false, false, false],
										alignment: 'left',
										margin: [0, 5, 0, 0]
									},
									{
										text: i18nFilter('_feeds_vem_'),
										border: [false, false, false, false],
										alignment: 'left',
										margin: [0, 5, 0, 0]
									},
									{
										text: vm.ration.supply_conc.vem ? formatViewValuesSignificant(vm.ration.supply_conc.vem, 'vem') : '',
										border: [false, false, false, false],
										alignment: 'center',
										margin: [0, 5, 0, 0]
									},
									{
										text: vm.ration.requirement_conc.vem ? formatViewValuesSignificant(vm.ration.requirement_conc.vem, 'vem') : '',
										border: [false, false, false, false],
										alignment: 'center',
										margin: [0, 5, 0, 0]
									},
									{
										text: vm.ration.balance_conc.vem ? formatViewValuesSignificant(vm.ration.balance_conc.vem, 'vem') : '',
										border: [false, false, false, false],
										alignment: 'center',
										margin: [0, 5, 0, 0]
									}
								],
								[
									{
										text: i18nFilter('_feeds_dve_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_unit_grams_') + '/' + vm.weight + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.dve ? formatViewValuesSignificant(vm.ration.supply_conc.dve, 'dve') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.dve ? formatViewValuesSignificant(vm.ration.requirement_conc.dve, 'dve') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.dve ? formatViewValuesSignificant(vm.ration.balance_conc.dve, 'dve') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_oeb_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_unit_grams_') + '/' + vm.weight + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.oeb ? formatViewValuesSignificant(vm.ration.supply_conc.oeb, 'oeb') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.oeb ? formatViewValuesSignificant(vm.ration.requirement_conc.oeb, 'oeb') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.oeb ? formatViewValuesSignificant(vm.ration.balance_conc.oeb, 'oeb') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_cp_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.cp ? formatViewValuesSignificant(vm.ration.supply_conc.cp, 'cp') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.cp ? formatViewValuesSignificant(vm.ration.requirement_conc.cp, 'cp') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.cp ? formatViewValuesSignificant(vm.ration.balance_conc.cp, 'cp') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_fos_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_unit_grams_') + '/' + vm.weight + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.fos ? formatViewValuesSignificant(vm.ration.supply_conc.fos, 'fos') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.fos ? formatViewValuesSignificant(vm.ration.requirement_conc.fos, 'fos') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.fos ? formatViewValuesSignificant(vm.ration.balance_conc.fos, 'fos') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_starch_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.starch ? formatViewValuesSignificant(vm.ration.supply_conc.starch, 'starch') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.starch ? formatViewValuesSignificant(vm.ration.requirement_conc.starch, 'starch') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.starch ? formatViewValuesSignificant(vm.ration.balance_conc.starch, 'starch') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_rus_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.rus ? formatViewValuesSignificant(vm.ration.supply_conc.rus, 'rus') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.rus ? formatViewValuesSignificant(vm.ration.requirement_conc.rus, 'rus') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.rus ? formatViewValuesSignificant(vm.ration.balance_conc.rus, 'rus') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_sugar_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.sugar ? formatViewValuesSignificant(vm.ration.supply_conc.sugar, 'sugar'): '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.sugar ? formatViewValuesSignificant(vm.ration.requirement_conc.sugar, 'sugar') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.sugar ? formatViewValuesSignificant(vm.ration.balance_conc.sugar, 'sugar') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_ca_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.ca ? formatViewValuesSignificant(vm.ration.supply_conc.ca, 'ca') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.ca ? formatViewValuesSignificant(vm.ration.requirement_conc.ca, 'ca') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.ca ? formatViewValuesSignificant(vm.ration.balance_conc.ca, 'ca') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_p_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.p ? formatViewValuesSignificant(vm.ration.supply_conc.p, 'p') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.p ? formatViewValuesSignificant(vm.ration.requirement_conc.p, 'p') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.p ? formatViewValuesSignificant(vm.ration.balance_conc.p, 'p') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_mg_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.mg ? formatViewValuesSignificant(vm.ration.supply_conc.mg, 'mg') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.mg ? formatViewValuesSignificant(vm.ration.requirement_conc.mg, 'mg') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.mg ? formatViewValuesSignificant(vm.ration.balance_conc.mg, 'mg') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_na_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.na ? formatViewValuesSignificant(vm.ration.supply_conc.na, 'na') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.na ? formatViewValuesSignificant(vm.ration.requirement_conc.na, 'na') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.na ? formatViewValuesSignificant(vm.ration.balance_conc.na, 'na') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_k_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.k ? formatViewValuesSignificant(vm.ration.supply_conc.k, 'k') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.k ? formatViewValuesSignificant(vm.ration.requirement_conc.k, 'k') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.k ? formatViewValuesSignificant(vm.ration.balance_conc.k, 'k') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_cl_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.cl ? formatViewValuesSignificant(vm.ration.supply_conc.cl, 'cl') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.cl ? formatViewValuesSignificant(vm.ration.requirement_conc.cl, 'cl') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.cl ? formatViewValuesSignificant(vm.ration.balance_conc.cl, 'cl') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_s_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.s ? formatViewValuesSignificant(vm.ration.supply_conc.s, 's') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.s ? formatViewValuesSignificant(vm.ration.requirement_conc.s, 's') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.s ? formatViewValuesSignificant(vm.ration.balance_conc.s, 's') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_adf_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.adf ? formatViewValuesSignificant(vm.ration.supply_conc.adf, 'adf') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.adf ? formatViewValuesSignificant(vm.ration.requirement_conc.adf, 'adf') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.adf ? formatViewValuesSignificant(vm.ration.balance_conc.adf, 'adf') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_lingnin_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.lignin ? formatViewValuesSignificant(vm.ration.supply_conc.lignin, 'lignin') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.lignin ? formatViewValuesSignificant(vm.ration.requirement_conc.lignin, 'lignin') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.lignin ? formatViewValuesSignificant(vm.ration.balance_conc.lignin, 'lignin') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_efndf_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.ef_ndf_as_dm ? formatViewValuesSignificant(vm.ration.supply_conc.ef_ndf_as_dm, 'ef_ndf_as_dm') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.ef_ndf_as_dm ? formatViewValuesSignificant(vm.ration.requirement_conc.ef_ndf_as_dm, 'ef_ndf_as_dm') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.ef_ndf_as_dm ? formatViewValuesSignificant(vm.ration.balance_conc.ef_ndf_as_dm, 'ef_ndf_as_dm') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_for_ndf_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.for_ndf ? formatViewValuesSignificant(vm.ration.supply_conc.for_ndf, 'for_ndf') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.for_ndf ? formatViewValuesSignificant(vm.ration.requirement_conc.for_ndf, 'for_ndf') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.for_ndf ? formatViewValuesSignificant(vm.ration.balance_conc.for_ndf, 'for_ndf') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_ee_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.ee ? formatViewValuesSignificant(vm.ration.supply_conc.ee, 'ee') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.ee ? formatViewValuesSignificant(vm.ration.requirement_conc.ee, 'ee') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.ee ? formatViewValuesSignificant(vm.ration.balance_conc.ee, 'ee') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_ash_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.ash ? formatViewValuesSignificant(vm.ration.supply_conc.ash, 'ash') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.ash ? formatViewValuesSignificant(vm.ration.requirement_conc.ash, 'ash') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.ash ? formatViewValuesSignificant(vm.ration.balance_conc.ash, 'ash') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_ndf_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.ndf ? formatViewValuesSignificant(vm.ration.supply_conc.ndf, 'ndf') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.ndf ? formatViewValuesSignificant(vm.ration.requirement_conc.ndf, 'ndf') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.ndf ? formatViewValuesSignificant(vm.ration.balance_conc.ndf, 'ndf') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_rdndf_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '%' + i18nFilter('_feeds_ndf_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.rd_ndf ? formatViewValuesSignificant(vm.ration.supply_conc.rd_ndf, 'rd_ndf') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_me01_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: (vm.energy ? vm.energy : '') + '/' + (vm.weight ? vm.weight : ''),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.me_01 ? formatViewValuesSignificant(vm.ration.supply_conc.me_01, 'me_01') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.me_01 ? formatViewValuesSignificant(vm.ration.requirement_conc.me_01, 'me_01') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.me_01 ? formatViewValuesSignificant(vm.ration.balance_conc.me_01, 'me_01') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_nel89_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: (vm.energy ? vm.energy : '') + '/' + (vm.weight ? vm.weight : ''),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.nel_89 ? formatViewValuesSignificant(vm.ration.supply_conc.nel_89, 'nel_89') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.nel_89 ? formatViewValuesSignificant(vm.ration.requirement_conc.nel_89, 'nel_89') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.nel_89 ? formatViewValuesSignificant(vm.ration.balance_conc.nel_89, 'nel_89') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_rdstarch_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '%' + i18nFilter('_feeds_starch_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.rd_starch ? formatViewValuesSignificant(vm.ration.supply_conc.rd_starch, 'rd_starch') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_infa_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.in_fa ? formatViewValuesSignificant(vm.ration.supply_conc.in_fa, 'in_fa') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_solfiber_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.sol_fiber ? formatViewValuesSignificant(vm.ration.supply_conc.sol_fiber, 'sol_fiber') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_fa_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.fa ? formatViewValuesSignificant(vm.ration.supply_conc.fa, 'fa') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_sfa_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '%' + i18nFilter('_feeds_fa_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.sfa ? formatViewValuesSignificant(vm.ration.supply_conc.sfa, 'sfa') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_mufa_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '%' + i18nFilter('_feeds_fa_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.mufa ? formatViewValuesSignificant(vm.ration.supply_conc.mufa, 'mufa') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_pufa_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '%' + i18nFilter('_feeds_fa_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.pufa ? formatViewValuesSignificant(vm.ration.supply_conc.pufa, 'pufa') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_bhfa_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '%' + i18nFilter('_feeds_fa_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.bhfa ? formatViewValuesSignificant(vm.ration.supply_conc.bhfa, 'bhfa') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_idufa_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '%' + i18nFilter('_feeds_fa_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.idufa ? formatViewValuesSignificant(vm.ration.supply_conc.idufa, 'idufa') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_mo_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_unit_ppm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.mo ? formatViewValuesSignificant(vm.ration.supply_conc.mo, 'mo') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_ca_abs_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '%' + i18nFilter('_feeds_ca_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.ca_abs ? formatViewValuesSignificant(vm.ration.supply_conc.ca_abs, 'ca_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.ca_abs ? formatViewValuesSignificant(vm.ration.requirement_conc.ca_abs, 'ca_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.ca_abs ? formatViewValuesSignificant(vm.ration.balance_conc.ca_abs, 'ca_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_p_abs_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '%' + i18nFilter('_feeds_p_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.p_abs ? formatViewValuesSignificant(vm.ration.supply_conc.p_abs, 'p_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.p_abs ? formatViewValuesSignificant(vm.ration.requirement_conc.p_abs, 'p_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.p_abs ? formatViewValuesSignificant(vm.ration.balance_conc.p_abs, 'p_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_mg_abs_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '%' + i18nFilter('_feeds_mg_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.mg_abs ? formatViewValuesSignificant(vm.ration.supply_conc.mg_abs, 'mg_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.mg_abs ? formatViewValuesSignificant(vm.ration.requirement_conc.mg_abs, 'mg_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.mg_abs ? formatViewValuesSignificant(vm.ration.balance_conc.mg_abs, 'mg_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_cu_abs_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text:  '%' + i18nFilter('_feeds_cu_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.cu_abs ? formatViewValuesSignificant(vm.ration.supply_conc.cu_abs, 'cu_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.cu_abs ? formatViewValuesSignificant(vm.ration.requirement_conc.cu_abs, 'cu_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.cu_abs ? formatViewValuesSignificant(vm.ration.balance_conc.cu_abs, 'cu_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_fe_abs_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text:  '%' + i18nFilter('_feeds_fe_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.fe_abs ? formatViewValuesSignificant(vm.ration.supply_conc.fe_abs, 'fe_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.fe_abs ? formatViewValuesSignificant(vm.ration.requirement_conc.fe_abs, 'fe_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.fe_abs ? formatViewValuesSignificant(vm.ration.balance_conc.fe_abs, 'fe_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_i_abs_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text:  '%' + i18nFilter('_feeds_i_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.i_abs ? formatViewValuesSignificant(vm.ration.supply_conc.i_abs, 'i_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.i_abs ? formatViewValuesSignificant(vm.ration.requirement_conc.i_abs, 'i_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.i_abs ? formatViewValuesSignificant(vm.ration.balance_conc.i_abs, 'i_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_mn_abs_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text:  '%' + i18nFilter('_feeds_mn_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.mn_abs ? formatViewValuesSignificant(vm.ration.supply_conc.mn_abs, 'mn_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.mn_abs ? formatViewValuesSignificant(vm.ration.requirement_conc.mn_abs, 'mn_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.mn_abs ? formatViewValuesSignificant(vm.ration.balance_conc.mn_abs, 'mn_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_zn_abs_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text:  '%' + i18nFilter('_feeds_zn_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.zn_abs ? formatViewValuesSignificant(vm.ration.supply_conc.zn_abs, 'zn_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.zn_abs ? formatViewValuesSignificant(vm.ration.requirement_conc.zn_abs, 'zn_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.zn_abs ? formatViewValuesSignificant(vm.ration.balance_conc.zn_abs, 'zn_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_se_abs_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text:  '%' + i18nFilter('_feeds_se_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.se_abs ? formatViewValuesSignificant(vm.ration.supply_conc.se_abs, 'se_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.se_abs ? formatViewValuesSignificant(vm.ration.requirement_conc.se_abs, 'se_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.se_abs ? formatViewValuesSignificant(vm.ration.balance_conc.se_abs, 'se_abs') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_lysine_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '%' + i18nFilter('_feeds_drup_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.lysine ? formatViewValuesSignificant(vm.ration.supply_conc.lysine, 'lysine') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.lysine ? formatViewValuesSignificant(vm.ration.requirement_conc.lysine, 'lysine') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.lysine ? formatViewValuesSignificant(vm.ration.balance_conc.lysine, 'lysine') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_methionine_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '%' + i18nFilter('_feeds_drup_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_conc.methionine ? formatViewValuesSignificant(vm.ration.supply_conc.methionine, 'methionine') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_conc.methionine ? formatViewValuesSignificant(vm.ration.requirement_conc.methionine, 'methionine') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_conc.methionine ? formatViewValuesSignificant(vm.ration.balance_conc.methionine, 'methionine') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_blank_') + '1',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_blank_') + '2',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_blank_') + '3',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_mp_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_amount.mp ? vm.ration.supply_amount.mp : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.mp ? vm.ration.requirement_amount.mp : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.mp ? vm.ration.balance_amount.mp : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_rdp_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_amount.rdp ? vm.ration.supply_amount.rdp : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.rdp ? vm.ration.requirement_amount.rdp : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.rdp ? vm.ration.balance_amount.rdp : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_mp01_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_amount.mp_01 ? vm.ration.supply_amount.mp_01 : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.mp_01 ? vm.ration.requirement_amount.mp_01 : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.mp_01 ? vm.ration.balance_amount.mp_01 : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_rdp01_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_amount.rdp_01 ? vm.ration.supply_amount.rdp_01 : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.rdp_01 ? vm.ration.requirement_amount.rdp_01 : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.rdp_01 ? vm.ration.balance_amount.rdp_01 : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_nel01_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: (vm.energy ? vm.energy : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_amount.nel_01 ? vm.ration.supply_amount.nel_01 : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_rations_neg_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: (vm.energy ? vm.energy : '') + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.group.type == 'heifer' ? (vm.ration.supply_amount.neg ? vm.ration.supply_amount.neg : '') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.group.type == 'heifer' ? (vm.ration.requirement_amount.neg ? vm.ration.requirement_amount.neg : '') : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.group.type == 'heifer' ? (vm.ration.balance_amount.neg ? vm.ration.balance_amount.neg : '') : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_vit_a_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_unit_iu_k_') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_amount.vitamin_a ? vm.ration.supply_amount.vitamin_a : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.vitamin_a ? vm.ration.requirement_amount.vitamin_a : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.vitamin_a ? vm.ration.balance_amount.vitamin_a : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_vit_d_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_unit_iu_k_') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_amount.vitamin_d ? vm.ration.supply_amount.vitamin_d : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.vitamin_d ? vm.ration.requirement_amount.vitamin_d : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.vitamin_d ? vm.ration.balance_amount.vitamin_d : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_vit_e_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: i18nFilter('_unit_iu_') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.ration.supply_amount.vitamin_e ? vm.ration.supply_amount.vitamin_e : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.requirement_amount.vitamin_e ? vm.ration.requirement_amount.vitamin_e : '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: vm.ration.balance_amount.vitamin_e ? vm.ration.balance_amount.vitamin_e : '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_blank_') + '1',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'center'
									}
								],
								[
									{
										text: i18nFilter('_feeds_blank_') + '2',
										border: [false, false, false, true],
										alignment: 'left'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'left'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									},
									{
										text: '',
										border: [false, false, false, true],
										alignment: 'center'
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 2;
							},
							paddingRight: function () {
								return 5;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						},
						pageBreak: 'after'
					},
					{
						table: {
							widths: ['auto', '*', '*', 'auto', 'auto', 'auto', 'auto', '*', '*'],
							headerRows: 1,
							body: [
								[
									{
										text: i18nFilter('_rations_ration_ratios_relationships_').toUpperCase(),
										bold: true,
										colSpan: 9,
										border: [false, false, false, true]
									},
									{},
									{},
									{},
									{},
									{},
									{},
									{},
									{}
								],
								[
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'left',
										margin: [0, 10, 0, 0]
									},
									{
										text: i18nFilter('_report_value_'),
										border: [false, false, false, false],
										alignment: 'right',
										bold: true,
										margin: [0, 10, 0, 0]
									},
									{
										text: i18nFilter('_report_unit_'),
										border: [false, false, false, false],
										alignment: 'left',
										bold: true,
										margin: [5, 10, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: i18nFilter('_rations_actual_dmi_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.randr.actual_dmi ? vm.summary.randr.actual_dmi : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: i18nFilter('_rations_dmi_') + '/' + i18nFilter('_rations_bw_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.randr.dmi_bw ? vm.summary.randr.dmi_bw : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_rations_bw_'),
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: i18nFilter('_rations_nrc01_predicted_dmi_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.randr.nrc01_predicted_dmi ? vm.summary.randr.nrc01_predicted_dmi : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: rr04 ? rr04 : '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: rr14 ? rr14 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: rr24 ? rr24 : '',
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: rr05 ? rr05 : '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: rr15 ? rr15 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: rr25 ? rr25 : '',
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: energyAllowable ? energyAllowable : '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: energyAllowableValue ? energyAllowableValue : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: proteinAllowable ? proteinAllowable : '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: proteinAllowableValue ? proteinAllowableValue : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: i18nFilter('_rations_purchased_feed_costs_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.randr.purchased_feed_costs ? vm.summary.randr.purchased_feed_costs : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.currency ? vm.currency : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: rr31 ? rr31 : '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: rr41 ? rr41 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: rr51 ? rr51 : '',
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: rr32 ? rr32 : '',
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: rr42 ? rr42 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: rr52 ? rr52 : '',
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: i18nFilter('_rations_forage_diet_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.randr.forage_in_diet ? vm.summary.randr.forage_in_diet : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_dm_'),
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: i18nFilter('_rations_forage_ndf_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.randr.forage_ndf ? vm.summary.randr.forage_ndf : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%' + i18nFilter('_feeds_ndf_'),
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: i18nFilter('_rations_lys_met_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.randr.lys_met ? vm.summary.randr.lys_met : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '',
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: i18nFilter('_rations_predicted_fecal_dm_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.randr.predicted_fecal_dm ? vm.summary.randr.predicted_fecal_dm : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: i18nFilter('_rations_n_captured_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.randr.n_captured ? vm.summary.randr.n_captured : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%',
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: i18nFilter('_rations_total_n_excreted_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.randr.total_n_excreted ? vm.summary.randr.total_n_excreted : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: i18nFilter('_rations_fecal_n_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.randr.fecal_n ? vm.summary.randr.fecal_n : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: i18nFilter('_rations_urinary_n_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.randr.urinary_n ? vm.summary.randr.urinary_n : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: i18nFilter('_rations_p_captured_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.randr.p_captured ? vm.summary.randr.p_captured : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: '%',
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: i18nFilter('_rations_p_excreted_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.randr.p_excreted ? vm.summary.randr.p_excreted : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: i18nFilter('_rations_p_excreted_p205_'),
										border: [false, false, false, false],
										alignment: 'left'
									},
									{
										text: vm.summary.randr.p_excreted_as_p205 ? vm.summary.randr.p_excreted_as_p205 : '',
										border: [false, false, false, false],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, false],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									},
									{
										text: '',
										border: [false, false, false, false]
									}
								],
								[
									{
										text: i18nFilter('_rations_k_excreted_k20_'),
										border: [false, false, false, true],
										alignment: 'left'
									},
									{
										text: vm.summary.randr.k_excreted_as_k2O ? vm.summary.randr.k_excreted_as_k2O : '',
										border: [false, false, false, true],
										alignment: 'right'
									},
									{
										text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
										border: [false, false, false, true],
										alignment: 'left',
										margin: [5, 0, 0, 0]
									},
									{
										text: '',
										border: [false, false, false, true]
									},
									{
										text: '',
										border: [false, false, false, true]
									},
									{
										text: '',
										border: [false, false, false, true]
									},
									{
										text: '',
										border: [false, false, false, true]
									},
									{
										text: '',
										border: [false, false, false, true]
									},
									{
										text: '',
										border: [false, false, false, true]
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1.5 : 1.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'black';
							},
							paddingLeft: function () {
								return 1;
							},
							paddingRight: function () {
								return 1;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 1;
							}
						},
						pageBreak: 'after'
					},
					{
						table: {
							widths: ['*'],
							body: [
								[
									{
										text: i18nFilter('_report_assumptions_').toUpperCase(),
										border: [false, false, false, false]
									}
								],
								[
									{
										text: '',
										border: [false, true, false, true]
									}
								],
								[
									{
										text: vm.aAndC ? vm.aAndC : '',
										border: [false, false, false, false]
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1.5 : 1.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'black';
							},
							paddingLeft: function () {
								return 2;
							},
							paddingRight: function () {
								return 5;
							},
							paddingTop: function () {
								return 5;
							},
							paddingBottom: function () {
								return 0;
							}
						}
					}
				],
				styles: {
					headerStyle: {
						fontSize: 18,
						bold: true
					},
					bold: {
						bold: true
					},
					small: {
						fontSize: 10
					}
				},
				defaultStyle: {
					fontSize: 10
				}
			};
			var table2Row0 = [
				{
					text: '',
					border: [false, true, false, false]
				},
				{
					text: i18nFilter('_report_test_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_amount_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_as_fed_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_dm_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: '%' + i18nFilter('_report_diet_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_ndf_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_vem_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_dve_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_cp_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_report_asSold_'),
					border: [false, true, false, false]
				},
				{
					text: i18nFilter('_report_wt_as_sold_'),
					border: [false, true, false, false],
					alignment: 'center'
				}
			];
			var table2Row1 = [
				{
					text: i18nFilter('_feeds_name_'),
					border: [false, false, false, true]
				},
				{
					text: i18nFilter('_report_date_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.weight,
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.weight,
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.settings.use_percent ? '%' : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: '%' + i18nFilter('_feeds_dmi_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: '',
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: i18nFilter('_unit_grams_') + '/' + vm.weight + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.currency ? vm.currency : '',
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.weight ? vm.weight : '',
					border: [false, false, false, true],
					alignment: 'center'
				}
			];
			var table5Row0 = [
				{
					text: '',
					border: [false, true, false, false]
				},
				{
					text: '',
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_amount_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_fos_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_oeb_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_fa_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_starch_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_ca_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_p_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_feeds_k_'),
					border: [false, true, false, false],
					alignment: 'center'
				},
				{
					text: i18nFilter('_report_feed_'),
					border: [false, true, false, false]
				},
				{
					text: i18nFilter('_feeds_cost_dm_'),
					border: [false, true, false, false],
					alignment: 'center'
				}
			];
			var table5Row1 = [
				{
					text: i18nFilter('_feeds_name_'),
					border: [false, false, false, true]
				},
				{
					text: '',
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.weight ? vm.weight : '',
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: i18nFilter('_unit_grams_') + '/' + vm.weight + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: i18nFilter('_unit_grams_') + '/' + vm.weight + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: '%' + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: i18nFilter('_report_type_'),
					border: [false, false, false, true],
					alignment: 'center'
				},
				{
					text: (vm.currency ? vm.currency : '') + '/' + (vm.weight ? vm.weight : ''),
					border: [false, false, false, true],
					alignment: 'center'
				}
			];
			if (vm.summary.feeds.length > 0) {
				for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
					var date = new Date(vm.summary.feeds[i].test_date);
					date = $filter('date')(date, 'shortDate');
					var wt_as_sold = vm.summary.feeds[i].wt_as_sold;
					wt_as_sold = $filter('number')(wt_as_sold, 2);
					var dm_kg = vm.summary.feeds[i].amount;
					dm_kg = $filter('number')(dm_kg, 2);
					var neg_nel;
					if (vm.ration.group.type == 'heifer') {
						neg_nel = vm.summary.feeds[i].neg;
					} else {
						neg_nel = vm.summary.feeds[i].nel;
					}
					var feedstuff = {
						as_fed: vm.summary.feeds[i].as_fed,
						dm: vm.summary.feeds[i].dm,
						diet_dmi: vm.summary.feeds[i].diet_dmi,
						ndf: vm.summary.feeds[i].ndf,
						cp: vm.summary.feeds[i].cp,
						rup: vm.summary.feeds[i].rup,
						cost_as_sold: vm.summary.feeds[i].cost_as_sold,
						ef_ndf_as_dm: vm.summary.feeds[i].ef_ndf_as_dm,
						neg_nel: neg_nel,
						me: vm.summary.feeds[i].me,
						rup_dig: vm.summary.feeds[i].rup_dig,
						fa: vm.summary.feeds[i].fa,
						starch: vm.summary.feeds[i].starch,
						ca: vm.summary.feeds[i].ca,
						p: vm.summary.feeds[i].p,
						k: vm.summary.feeds[i].k,
						cost_dm: vm.summary.feeds[i].cost_dm,
						lysine: vm.summary.feeds[i].lysine,
						methionine: vm.summary.feeds[i].methionine,
						teaa: vm.summary.feeds[i].teaa,
						wt_as_sold: vm.summary.feeds[i].wt_as_sold,
						i: vm.summary.feeds[i].i,
						i_abs: vm.summary.feeds[i].i_abs,
						mo: vm.summary.feeds[i].mo,
						mn: vm.summary.feeds[i].mn,
						mn_abs: vm.summary.feeds[i].mn_abs,
						se: vm.summary.feeds[i].se,
						se_abs: vm.summary.feeds[i].se_abs,
						zn: vm.summary.feeds[i].zn,
						zn_abs: vm.summary.feeds[i].zn_abs,
						s: vm.summary.feeds[i].s,
						ash: vm.summary.feeds[i].ash,
						vitamin_a: vm.summary.feeds[i].vitamin_a,
						vitamin_d: vm.summary.feeds[i].vitamin_d,
						vitamin_e: vm.summary.feeds[i].vitamin_e,
						co: vm.summary.feeds[i].co,
						cu: vm.summary.feeds[i].cu,
						cu_abs: vm.summary.feeds[i].cu_abs,
						fe: vm.summary.feeds[i].fe,
						fe_abs: vm.summary.feeds[i].fe_abs,
						fa_dig: vm.summary.feeds[i].fa_dig,
						ca_abs: vm.summary.feeds[i].ca_abs,
						p_abs: vm.summary.feeds[i].p_abs,
						mg: vm.summary.feeds[i].mg,
						mg_abs: vm.summary.feeds[i].mg_abs,
						na: vm.summary.feeds[i].na,
						cl: vm.summary.feeds[i].cl,
						nfc_dig: vm.summary.feeds[i].nfc_dig,
						rd_starch: vm.summary.feeds[i].rd_starch,
						sugar: vm.summary.feeds[i].sugar,
						in_fa: vm.summary.feeds[i].in_fa,
						rd_sol_fiber: vm.summary.feeds[i].rd_sol_fiber,
						ee: vm.summary.feeds[i].ee,
						sfa: vm.summary.feeds[i].sfa,
						pufa: vm.summary.feeds[i].pufa,
						bhfa: vm.summary.feeds[i].bhfa,
						a_prot: vm.summary.feeds[i].a_prot,
						b_prot: vm.summary.feeds[i].b_prot,
						c_prot: vm.summary.feeds[i].c_prot,
						kd_b_prot: vm.summary.feeds[i].kd_b_prot,
						npncpe: vm.summary.feeds[i].npncpe,
						rup_89: vm.summary.feeds[i].rup_89,
						ndicp: vm.summary.feeds[i].ndicp,
						adicp: vm.summary.feeds[i].adicp,
						ef_ndf_as_ndf: vm.summary.feeds[i].ef_ndf_as_ndf,
						lignin: vm.summary.feeds[i].lignin,
						ndf_digest: vm.summary.feeds[i].ndf_digest,
						adf: vm.summary.feeds[i].adf,
						rd_ndf: vm.summary.feeds[i].rd_ndf,
						disc_fac: vm.summary.feeds[i].disc_fac,
						nel_89: vm.summary.feeds[i].nel_89,
						me_89: vm.summary.feeds[i].me_89,
						dve: vm.summary.feeds[i].dve,
						vem: vm.summary.feeds[i].vem,
						fos: vm.summary.feeds[i].fos,
						oeb: vm.summary.feeds[i].oeb
					};
					feedstuff = setSignificant(feedstuff);
					var feed1 = [
						{
							text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
							border: [false, false, false, false]
						},
						{
							text: '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: dm_kg ? dm_kg : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.fos ? feedstuff.fos : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.oeb ? feedstuff.oeb : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.fa ? feedstuff.fa : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.starch ? feedstuff.starch : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.ca ? feedstuff.ca : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.p ? feedstuff.p : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.k ? feedstuff.k : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: vm.summary.feeds[i].feed_category ? vm.summary.feeds[i].feed_category : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.cost_dm ? feedstuff.cost_dm : '',
							border: [false, false, false, false],
							alignment: 'center'
						}
					];
					var feed = [
						{
							text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
							border: [false, false, false, false]
						},
						{
							text: date ? date : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: dm_kg ? dm_kg : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.as_fed ? feedstuff.as_fed : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.dm ? feedstuff.dm : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.diet_dmi ? feedstuff.diet_dmi : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.ndf ? feedstuff.ndf : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.vem ? feedstuff.vem : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.dve ? feedstuff.dve : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.cp ? feedstuff.cp : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: feedstuff.cost_as_sold ? feedstuff.cost_as_sold : '',
							border: [false, false, false, false],
							alignment: 'center'
						},
						{
							text: wt_as_sold ? wt_as_sold : '',
							border: [false, false, false, false],
							alignment: 'center'
						}
					];
					dd.content[5].table.body.splice(0, 0, feed);
					dd.content[7].table.body.splice(0, 0, feed1);
				}
				dd.content[5].table.body.splice(0, 0, table2Row1);
				dd.content[5].table.body.splice(0, 0, table2Row0);
				dd.content[7].table.body.splice(0, 0, table5Row1);
				dd.content[7].table.body.splice(0, 0, table5Row0);
			}
			// OFFICE REPORT //
			if (!isSummary) {
				if (vm.summary.feeds.length > 0) {
					var ORTable8 = {
						margin: [0, 10, 0, 0],
						table: {
							dontBreakRows: true,
							headerRows: 1,
							keepWithHeaderRows: 30,
							widths: ['*', 'auto'],
							body: [
								[
									{
										text: i18nFilter('_feeds_name_'),
										border: [false, true, false, false]
									},
									{
										text: i18nFilter('_feeds_comment_'),
										border: [false, true, false, false]
									}
								]
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
							},
							vLineWidth: function (i, node) {
								return i === 0 || i === node.table.body.length ? 1 : 0.5;
							},
							hLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'black' : 'gray';
							},
							vLineColor: function (i, node) {
								return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
							},
							paddingLeft: function () {
								return 0;
							},
							paddingRight: function () {
								return 2;
							},
							paddingTop: function () {
								return 1;
							},
							paddingBottom: function () {
								return 0;
							}
						}
					};
					dd.content.splice(12, 0, ORTable8);
					for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
						var ORTable8Feed = [
							{
								text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
								border: [false, false, false, false]
							},
							{
								text: vm.summary.feeds[i].comments ? vm.summary.feeds[i].comments : '',
								border: [false, false, false, false],
								alignment: 'center'
							}
						];
						dd.content[12].table.body.splice(1, 0, ORTable8Feed);
					}
				}
				var ORTable7 = {
					margin: [0, 10, 0, 0],
					table: {
						dontBreakRows: true,
						headerRows: 2,
						keepWithHeaderRows: 30,
						widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
						body: [
							[
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_amount_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_blank_') + '1',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_blank_') + '2',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_blank_') + '3',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_blank_') + '4',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_blank_') + '5',
									border: [false, true, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: '',
									border: [false, false, false, true]
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_supply_'),
									border: [false, true, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_difference_'),
									border: [false, false, false, true],
									alignment: 'right'
								},
								{
									text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							]
						]
					},
					layout: {
						hLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
						},
						vLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1 : 0.5;
						},
						hLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'black' : 'gray';
						},
						vLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
						},
						paddingLeft: function () {
							return 2;
						},
						paddingRight: function () {
							return 5;
						},
						paddingTop: function () {
							return 1;
						},
						paddingBottom: function () {
							return 0;
						}
					},
					pageBreak: 'before'
				};
				dd.content.splice(12, 0, ORTable7);
				if (vm.summary.feeds.length > 0) {
					for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
						var ORTable7Feed = [
							{
								text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
								border: [false, false, false, false]
							},
							{
								text: vm.summary.feeds[i].amount ? $filter('number')(vm.summary.feeds[i].amount, 2) : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: i18nFilter(vm.summary.feeds[i].feed_type.show_name),
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: '',
								border: [false, false, false, false],
								alignment: 'center'
							}
						];
						dd.content[12].table.body.splice(0, 0, ORTable7Feed);
					}
					var ORTTable7Header2 = [
						{
							text: i18nFilter('_feeds_name_'),
							border: [false, false, false, true]
						},
						{
							text: vm.weight ? vm.weight : '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_type_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '',
							border: [false, false, false, true],
							alignment: 'center'
						}
					];
					var ortTable7Header1 = [
						{
							text: '',
							border: [false, true, false, false]
						},
						{
							text: i18nFilter('_feeds_amount_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: '',
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_blank_') + '1',
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_blank_') + '1',
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_blank_') + '1',
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_blank_') + '1',
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_blank_') + '1',
							border: [false, true, false, false],
							alignment: 'center'
						}
					];
					dd.content[12].table.body.splice(0, 0, ORTTable7Header2);
					dd.content[12].table.body.splice(0, 0, ortTable7Header1);
				}
				var ORTable6 = {
					margin: [0, 10, 0, 0],
					table: {
						dontBreakRows: true,
						headerRows: 2,
						keepWithHeaderRows: 30,
						widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 40, 'auto', 'auto', 'auto'],
						body: [
							[
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_amount_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_lysine_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_methionine_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_teaa_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_cost_dm_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_purchased_cost_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: '',
									border: [false, false, false, true]
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.currency ? vm.currency : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.currency ? vm.currency : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_supply_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.lysine ? vm.ration.supply_amount.lysine : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.methionine ? vm.ration.supply_amount.methionine : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.teaa ? vm.ration.supply_amount.teaa : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.cost_dm ? vm.ration.supply_amount.cost_dm : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.pur_cost ? vm.ration.supply_amount.pur_cost : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.lysine ? vm.ration.requirement_amount.lysine : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.methionine ? vm.ration.requirement_amount.methionine : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_difference_'),
									border: [false, false, false, true],
									alignment: 'right'
								},
								{
									text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.lysine ? vm.ration.balance_amount.lysine : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.methionine ? vm.ration.balance_amount.methionine : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							]
						]
					},
					layout: {
						hLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
						},
						vLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1 : 0.5;
						},
						hLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'black' : 'gray';
						},
						vLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
						},
						paddingLeft: function () {
							return 2;
						},
						paddingRight: function () {
							return 1;
						},
						paddingTop: function () {
							return 1;
						},
						paddingBottom: function () {
							return 0;
						}
					}
				};
				dd.content.splice(12, 0, ORTable6);
				if (vm.summary.feeds.length > 0) {
					for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
						var date = new Date(vm.summary.feeds[i].test_date);
						date = $filter('date')(date, 'shortDate');
						var ORTable6Feed = [
							{
								text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
								border: [false, false, false, false]
							},
							{
								text: vm.summary.feeds[i].amount ? $filter('number')(vm.summary.feeds[i].amount, 2) : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].lysine ? vm.summary.feeds[i].lysine : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].methionine ? vm.summary.feeds[i].methionine : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].teaa ? vm.summary.feeds[i].teaa : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].cost_as_sold ? vm.summary.feeds[i].cost_as_sold : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].wt_as_sold ? vm.summary.feeds[i].wt_as_sold : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].cost_dm ? vm.summary.feeds[i].cost_dm : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].is_purchased ? vm.summary.feeds[i].is_purchased : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].common_feed ? vm.summary.feeds[i].common_feed : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: date,
								border: [false, false, false, false],
								alignment: 'center'
							}
						];
						dd.content[12].table.body.splice(0, 0, ORTable6Feed);
					}
					var ORTTable6Header1 = [
						{
							text: '',
							border: [false, true, false, false]
						},
						{
							text: i18nFilter('_feeds_amount_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_lysine_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_methionine_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_teaa_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_report_asSold_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_report_wt_as_sold_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_cost_dm_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_report_pur_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_report_common_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_report_test_'),
							border: [false, true, false, false],
							alignment: 'center'
						}
					];
					var ORTTable6Header2 = [
						{
							text: i18nFilter('_feeds_name_'),
							border: [false, false, false, true]
						},
						{
							text: vm.weight,
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_drup_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_drup_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_drup_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.currency ? vm.currency : '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.weight ? vm.weight : '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: (vm.currency ? vm.currency : '') + '/' + (vm.weight ? vm.weight : ''),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_report_chased_'),
							border: [false, false, false, true]
						},
						{
							text: i18nFilter('_report_feed_'),
							border: [false, false, false, true]
						},
						{
							text: i18nFilter('_report_date_'),
							border: [false, false, false, true]
						}
					];
					dd.content[12].table.body.splice(0, 0, ORTTable6Header2);
					dd.content[12].table.body.splice(0, 0, ORTTable6Header1);
				}
				var ORTable5 = {
					margin: [0, 10, 0, 0],
					table: {
						headerRows: 2,
						dontBreakRows: true,
						keepWithHeaderRows: 30,
						widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
						body: [
							[
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_amount_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_i_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_i_abs_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_mo_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_mn_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_mn_abs_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_se_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_se_abs_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_zn_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_zn_abs_'),
									border: [false, true, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: '',
									border: [false, false, false, true]
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_supply_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.i ? vm.ration.supply_amount.i : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.i_abs ? vm.ration.supply_amount.i_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.mo ? vm.ration.supply_amount.mo : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.mn ? vm.ration.supply_amount.mn : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.mn_abs ? vm.ration.supply_amount.mn_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.se ? vm.ration.supply_amount.se : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.se_abs ? vm.ration.supply_amount.se_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.zn ? vm.ration.supply_amount.zn : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.zn_abs ? vm.ration.supply_amount.zn_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.i ? vm.ration.requirement_amount.i : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.i_abs ? vm.ration.requirement_amount.i_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.mn ? vm.ration.requirement_amount.mn : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.mn_abs ? vm.ration.requirement_amount.mn_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.se ? vm.ration.requirement_amount.se : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.se_abs ? vm.ration.requirement_amount.se_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.zn ? vm.ration.requirement_amount.zn : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.zn_abs ? vm.ration.requirement_amount.zn_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_difference_'),
									border: [false, false, false, true],
									alignment: 'right'
								},
								{
									text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.i ? vm.ration.balance_amount.i : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.i_abs ? vm.ration.balance_amount.i_abs : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.mn ? vm.ration.balance_amount.mn : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.mn_abs ? vm.ration.balance_amount.mn_abs : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.se ? vm.ration.balance_amount.se : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.se_abs ? vm.ration.balance_amount.se_abs : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.zn ? vm.ration.balance_amount.zn : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.zn_abs ? vm.ration.balance_amount.zn_abs : '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							]
						]
					},
					layout: {
						hLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
						},
						vLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1 : 0.5;
						},
						hLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'black' : 'gray';
						},
						vLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
						},
						paddingLeft: function () {
							return 2;
						},
						paddingRight: function () {
							return 1;
						},
						paddingTop: function () {
							return 1;
						},
						paddingBottom: function () {
							return 0;
						}
					}
				};
				dd.content.splice(12, 0, ORTable5);
				if (vm.summary.feeds.length > 0) {
					for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
						var date = new Date(vm.summary.feeds[i].test_date);
						date = $filter('date')(date, 'shortDate');
						var ORTable5Feed = [
							{
								text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
								border: [false, false, false, false]
							},
							{
								text: vm.summary.feeds[i].amount ? $filter('number')(vm.summary.feeds[i].amount, 2) : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].i ? vm.summary.feeds[i].i : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].i_abs ? vm.summary.feeds[i].i_abs : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].mo ? vm.summary.feeds[i].mo : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].mn ? vm.summary.feeds[i].mn : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].mn_abs ? vm.summary.feeds[i].mn_abs : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].se ? vm.summary.feeds[i].se : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].se_abs ? vm.summary.feeds[i].se_abs : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].zn ? vm.summary.feeds[i].zn : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].zn_abs ? vm.summary.feeds[i].zn_abs : '',
								border: [false, false, false, false],
								alignment: 'center'
							}
						];
						dd.content[12].table.body.splice(0, 0, ORTable5Feed);
					}
					var ORTTable5Header1 = [
						{
							text: '',
							border: [false, true, false, false]
						},
						{
							text: i18nFilter('_feeds_amount_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_i_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_i_abs_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_mo_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_mn_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_mn_abs_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_se_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_se_abs_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_zn_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_zn_abs_'),
							border: [false, true, false, false],
							alignment: 'center'
						}
					];
					var ORTTable5Header2 = [
						{
							text: i18nFilter('_feeds_name_'),
							border: [false, false, false, true]
						},
						{
							text: vm.weight ? vm.weight : '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_unit_ppm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_i_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_unit_ppm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_unit_ppm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_mn_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_unit_ppm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_se_'),
							border: [false, false, false, true]
						},
						{
							text: i18nFilter('_unit_ppm_'),
							border: [false, false, false, true]
						},
						{
							text: '%' + i18nFilter('_feeds_zn_'),
							border: [false, false, false, true]
						}
					];
					dd.content[12].table.body.splice(0, 0, ORTTable5Header2);
					dd.content[12].table.body.splice(0, 0, ORTTable5Header1);
				}
				var ORTable4 = {
					margin: [0, 10, 0, 0],
					table: {
						dontBreakRows: true,
						headerRows: 2,
						keepWithHeaderRows: 30,
						widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
						body: [
							[
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_amount_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_s_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_ash_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_vit_a_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_vit_d_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_vit_e_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_co_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_cu_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_cu_abs_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_fe_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_fe_abs_'),
									border: [false, true, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: '',
									border: [false, false, false, true]
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_iu_k_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_iu_k_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_iu_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_mg_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_supply_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.s ? vm.ration.supply_amount.s : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.ash ? vm.ration.supply_amount.ash : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.vitamin_a ? vm.ration.supply_amount.vitamin_a : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.vitamin_d ? vm.ration.supply_amount.vitamin_d : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.vitamin_e ? vm.ration.supply_amount.vitamin_e : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.co ? vm.ration.supply_amount.co : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.cu ? vm.ration.supply_amount.cu : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.cu_abs ? vm.ration.supply_amount.cu_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.fe ? vm.ration.supply_amount.fe : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.fe_abs ? vm.ration.supply_amount.fe_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.s ? vm.ration.requirement_amount.s : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.vitamin_a ? vm.ration.requirement_amount.vitamin_a : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.vitamin_d ? vm.ration.requirement_amount.vitamin_d : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.vitamin_e ? vm.ration.requirement_amount.vitamin_e : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.co ? vm.ration.requirement_amount.co : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.cu ? vm.ration.requirement_amount.cu : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.cu_abs ? vm.ration.requirement_amount.cu_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.fe ? vm.ration.requirement_amount.fe : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.fe_abs ? vm.ration.requirement_amount.fe_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_difference_'),
									border: [false, false, false, true],
									alignment: 'right'
								},
								{
									text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.s ? vm.ration.balance_amount.s : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.vitamin_a ? vm.ration.balance_amount.vitamin_a : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.vitamin_d ? vm.ration.balance_amount.vitamin_d : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.vitamin_e ? vm.ration.balance_amount.vitamin_e : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.co ? vm.ration.balance_amount.co : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.cu ? vm.ration.balance_amount.cu : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.cu_abs ? vm.ration.balance_amount.cu_abs : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.fe ? vm.ration.balance_amount.fe : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.fe_abs ? vm.ration.balance_amount.fe_abs : '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							]
						]
					},
					layout: {
						hLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
						},
						vLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1 : 0.5;
						},
						hLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'black' : 'gray';
						},
						vLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
						},
						paddingLeft: function () {
							return 2;
						},
						paddingRight: function () {
							return 1;
						},
						paddingTop: function () {
							return 1;
						},
						paddingBottom: function () {
							return 0;
						}
					}
				};
				dd.content.splice(12, 0, ORTable4);
				if (vm.summary.feeds.length > 0) {
					for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
						var date = new Date(vm.summary.feeds[i].test_date);
						date = $filter('date')(date, 'shortDate');
						var ORTable4Feed = [
							{
								text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
								border: [false, false, false, false]
							},
							{
								text: vm.summary.feeds[i].amount ? $filter('number')(vm.summary.feeds[i].amount, 2) : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].s ? vm.summary.feeds[i].s : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].ash ? vm.summary.feeds[i].ash : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].vitamin_a ? vm.summary.feeds[i].vitamin_a : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].vitamin_d ? vm.summary.feeds[i].vitamin_d : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].vitamin_e ? vm.summary.feeds[i].vitamin_e : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].co ? vm.summary.feeds[i].co : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].cu ? vm.summary.feeds[i].cu : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].cu_abs ? vm.summary.feeds[i].cu_abs : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].fe ? vm.summary.feeds[i].fe : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].fe_abs ? vm.summary.feeds[i].fe_abs : '',
								border: [false, false, false, false],
								alignment: 'center'
							}
						];
						dd.content[12].table.body.splice(0, 0, ORTable4Feed);
					}
					var ORTTable4Header1 = [
						{
							text: '',
							border: [false, true, false, false]
						},
						{
							text: i18nFilter('_feeds_amount_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_s_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_ash_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_vit_a_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_vit_d_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_vit_e_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_co_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_cu_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_cu_abs_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_fe_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_fe_abs_'),
							border: [false, true, false, false],
							alignment: 'center'
						}
					];
					var ORTTable4Header2 = [
						{
							text: i18nFilter('_feeds_name_'),
							border: [false, false, false, true]
						},
						{
							text: vm.weight ? vm.weight : '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_unit_iu_k_') + '/' + (vm.weight ? vm.weight : ''),
							fontSize: 8,
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_unit_iu_k_') + '/' + (vm.weight ? vm.weight : ''),
							fontSize: 8,
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_unit_iu_') + '/' + (vm.weight ? vm.weight : ''),
							fontSize: 8,
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_unit_ppm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: i18nFilter('_unit_ppm_'),
							border: [false, false, false, true]
						},
						{
							text: '%' + i18nFilter('_feeds_cu_'),
							border: [false, false, false, true]
						},
						{
							text: i18nFilter('_unit_ppm_'),
							border: [false, false, false, true]
						},
						{
							text: '%' + i18nFilter('_feeds_fe_'),
							border: [false, false, false, true]
						}
					];
					dd.content[12].table.body.splice(0, 0, ORTTable4Header2);
					dd.content[12].table.body.splice(0, 0, ORTTable4Header1);
				}
				var ORTable3 = {
					margin: [0, 10, 0, 0],
					table: {
						dontBreakRows: true,
						headerRows: 2,
						keepWithHeaderRows: 30,
						widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
						body: [
							[
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_amount_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_fa_dig_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_ca_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_ca_abs_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_p_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_p_abs_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_mg_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_mg_abs_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_k_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_na_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_cl_'),
									border: [false, true, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: '',
									border: [false, false, false, true]
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: i18nFilter('_unit_grams_') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_supply_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.fa_dig ? vm.ration.supply_amount.fa_dig : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.ca ? vm.ration.supply_amount.ca : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.ca_abs ? vm.ration.supply_amount.ca_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.p ? vm.ration.supply_amount.p : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.p_abs ? vm.ration.supply_amount.p_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.mg ? vm.ration.supply_amount.mg : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.mg_abs ? vm.ration.supply_amount.mg_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.k ? vm.ration.supply_amount.k : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.na ? vm.ration.supply_amount.na : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.cl ? vm.ration.supply_amount.cl : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.ca ? vm.ration.requirement_amount.ca : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.ca_abs ? vm.ration.requirement_amount.ca_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.p ? vm.ration.requirement_amount.p : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.p_abs ? vm.ration.requirement_amount.p_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.mg ? vm.ration.requirement_amount.mg : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.mg_abs ? vm.ration.requirement_amount.mg_abs : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.k ? vm.ration.requirement_amount.k : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.na ? vm.ration.requirement_amount.na : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.cl ? vm.ration.requirement_amount.cl : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, true],
									alignment: 'right'
								},
								{
									text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.ca ? vm.ration.balance_amount.ca : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.ca_abs ? vm.ration.balance_amount.ca_abs : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.p ? vm.ration.balance_amount.p : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.p_abs ? vm.ration.balance_amount.p_abs : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.mg ? vm.ration.balance_amount.mg : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.mg_abs ? vm.ration.balance_amount.mg_abs : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.k ? vm.ration.balance_amount.k : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.na ? vm.ration.balance_amount.na : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.cl ? vm.ration.balance_amount.cl : '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							]
						]
					},
					layout: {
						hLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
						},
						vLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1 : 0.5;
						},
						hLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'black' : 'gray';
						},
						vLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
						},
						paddingLeft: function () {
							return 2;
						},
						paddingRight: function () {
							return 1;
						},
						paddingTop: function () {
							return 1;
						},
						paddingBottom: function () {
							return 0;
						}
					},
					pageBreak: 'before'
				};
				dd.content.splice(12, 0, ORTable3);
				if (vm.summary.feeds.length > 0) {
					for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
						var date = new Date(vm.summary.feeds[i].test_date);
						date = $filter('date')(date, 'shortDate');
						var ORTable3Feed = [
							{
								text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
								border: [false, false, false, false]
							},
							{
								text: vm.summary.feeds[i].amount ? $filter('number')(vm.summary.feeds[i].amount, 2) : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].fa_dig ? vm.summary.feeds[i].fa_dig : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].ca ? vm.summary.feeds[i].ca : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].ca_abs ? vm.summary.feeds[i].ca_abs : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].p ? vm.summary.feeds[i].p : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].p_abs ? vm.summary.feeds[i].p_abs : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].mg ? vm.summary.feeds[i].mg : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].mg_abs ? vm.summary.feeds[i].mg_abs : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].k ? vm.summary.feeds[i].k : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].na ? vm.summary.feeds[i].na : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].cl ? vm.summary.feeds[i].cl : '',
								border: [false, false, false, false],
								alignment: 'center'
							}
						];
						dd.content[12].table.body.splice(0, 0, ORTable3Feed);
					}
					var ORTTable3Header1 = [
						{
							text: '',
							border: [false, true, false, false]
						},
						{
							text: i18nFilter('_feeds_amount_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_fa_dig_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_ca_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_ca_abs_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_p_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_p_abs_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_mg_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_mg_abs_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_k_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_na_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_cl_'),
							border: [false, true, false, false],
							alignment: 'center'
						}
					];
					var ORTTable3Header2 = [
						{
							text: i18nFilter('_feeds_name_'),
							border: [false, false, false, true]
						},
						{
							text: vm.weight ? vm.weight : '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_fa_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_ca_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_p_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_mg_'),
							border: [false, false, false, true]
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true]
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true]
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true]
						}
					];
					dd.content[12].table.body.splice(0, 0, ORTTable3Header2);
					dd.content[12].table.body.splice(0, 0, ORTTable3Header1);
				}
				var ORTable2 = {
					margin: [0, 10, 0, 0],
					table: {
						headerRows: 2,
						dontBreakRows: true,
						keepWithHeaderRows: 30,
						widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
						body: [
							[
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_amount_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_nfc_digestibility_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_starch_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_rdstarch_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_sugar_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_infa_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_rdsolf_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_ee_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_sfa_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_pufa_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_bhfa_'),
									border: [false, true, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: '',
									border: [false, false, false, true]
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_supply_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.nfc_dig ? vm.ration.supply_amount.nfc_dig : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.starch ? vm.ration.supply_amount.starch : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.rd_starch ? vm.ration.supply_amount.rd_starch : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.sugar ? vm.ration.supply_amount.sugar : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.in_fa ? vm.ration.supply_amount.in_fa : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.rd_sol_fiber ? vm.ration.supply_amount.rd_sol_fiber : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.ee ? vm.ration.supply_amount.ee : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.sfa ? vm.ration.supply_amount.sfa : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.pufa ? vm.ration.supply_amount.pufa : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.bhfa ? vm.ration.supply_amount.bhfa : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_difference_'),
									border: [false, false, false, true],
									alignment: 'right'
								},
								{
									text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							]
						]
					},
					layout: {
						hLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
						},
						vLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1 : 0.5;
						},
						hLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'black' : 'gray';
						},
						vLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
						},
						paddingLeft: function () {
							return 2;
						},
						paddingRight: function () {
							return 1;
						},
						paddingTop: function () {
							return 1;
						},
						paddingBottom: function () {
							return 0;
						}
					}
				};
				dd.content.splice(12, 0, ORTable2);
				if (vm.summary.feeds.length > 0) {
					for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
						var date = new Date(vm.summary.feeds[i].test_date);
						date = $filter('date')(date, 'shortDate');
						var ORTable2Feed = [
							{
								text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
								border: [false, false, false, false]
							},
							{
								text: vm.summary.feeds[i].amount ? $filter('number')(vm.summary.feeds[i].amount, 2) : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].nfc_dig ? vm.summary.feeds[i].nfc_dig : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].starch ? vm.summary.feeds[i].starch : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].rd_starch ? vm.summary.feeds[i].rd_starch : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].sugar ? vm.summary.feeds[i].sugar : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].in_fa ? vm.summary.feeds[i].in_fa : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].rd_sol_fiber ? vm.summary.feeds[i].rd_sol_fiber : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].ee ? vm.summary.feeds[i].ee : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].sfa ? vm.summary.feeds[i].sfa : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].pufa ? vm.summary.feeds[i].pufa : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].bhfa ? vm.summary.feeds[i].bhfa : '',
								border: [false, false, false, false],
								alignment: 'center'
							}
						];
						dd.content[12].table.body.splice(0, 0, ORTable2Feed);
					}
					var ORTTable2Header1 = [
						{
							text: '',
							border: [false, true, false, false]
						},
						{
							text: i18nFilter('_feeds_amount_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_nfc_digestibility_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_starch_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_rdstarch_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_sugar_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_infa_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_rdsolf_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_ee_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_sfa_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_pufa_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_bhfa_'),
							border: [false, true, false, false],
							alignment: 'center'
						}
					];
					var ORTTable2Header2 = [
						{
							text: i18nFilter('_feeds_name_'),
							border: [false, false, false, true]
						},
						{
							text: vm.weight ? vm.weight : '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_nfc_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_starch_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_solfiber_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true]
						},
						{
							text: '%' + i18nFilter('_feeds_fa_'),
							border: [false, false, false, true]
						},
						{
							text: '%' + i18nFilter('_feeds_fa_'),
							border: [false, false, false, true]
						},
						{
							text: '%' + i18nFilter('_feeds_fa_'),
							border: [false, false, false, true]
						}
					];
					dd.content[12].table.body.splice(0, 0, ORTTable2Header2);
					dd.content[12].table.body.splice(0, 0, ORTTable2Header1);
				}
				var ORTable1 = {
					margin: [0, 10, 0, 0],
					table: {
						dontBreakRows: true,
						headerRows: 2,
						keepWithHeaderRows: 30,
						widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
						body: [
							[
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_amount_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_cp_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_rup_dig_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_npncpe_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_rup89_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_ndicp_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_adicp_'),
									border: [false, true, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: '',
									border: [false, false, false, true]
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_supply_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.cp ? vm.ration.supply_amount.cp : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.rup_dig ? vm.ration.supply_amount.rup_dig : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.npncpe ? vm.ration.supply_amount.npncpe : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.rup_89 ? vm.ration.supply_amount.rup_89 : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.ndicp ? vm.ration.supply_amount.ndicp : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.adicp ? vm.ration.supply_amount.adicp : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.cp ? vm.ration.requirement_amount.cp : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.rup_dig ? vm.ration.requirement_amount.rup_dig : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.rup_89 ? vm.ration.requirement_amount.rup_89 : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_difference_'),
									border: [false, false, false, true],
									alignment: 'right'
								},
								{
									text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.cp ? vm.ration.balance_amount.cp : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.rup_dig ? vm.ration.balance_amount.rup_dig : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.rup_89 ? vm.ration.balance_amount.rup_89 : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							]
						]
					},
					layout: {
						hLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
						},
						vLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1 : 0.5;
						},
						hLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'black' : 'gray';
						},
						vLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
						},
						paddingLeft: function () {
							return 2;
						},
						paddingRight: function () {
							return 1;
						},
						paddingTop: function () {
							return 1;
						},
						paddingBottom: function () {
							return 0;
						}
					}
				};
				dd.content.splice(12, 0, ORTable1);
				if (vm.summary.feeds.length > 0) {
					for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
						var date = new Date(vm.summary.feeds[i].test_date);
						date = $filter('date')(date, 'shortDate');
						var ORTable1Feed = [
							{
								text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
								border: [false, false, false, false]
							},
							{
								text: vm.summary.feeds[i].amount ? $filter('number')(vm.summary.feeds[i].amount, 2) : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].cp ? vm.summary.feeds[i].cp : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].rup_dig ? vm.summary.feeds[i].rup_dig : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].a_prot ? vm.summary.feeds[i].a_prot : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].b_prot ? vm.summary.feeds[i].b_prot : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].c_prot ? vm.summary.feeds[i].c_prot : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].kd_b_prot ? vm.summary.feeds[i].kd_b_prot : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].npncpe ? vm.summary.feeds[i].npncpe : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].rup_89 ? vm.summary.feeds[i].rup_89 : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].ndicp ? vm.summary.feeds[i].ndicp : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].adicp ? vm.summary.feeds[i].adicp : '',
								border: [false, false, false, false],
								alignment: 'center'
							}
						];
						dd.content[12].table.body.splice(0, 0, ORTable1Feed);
					}
					var ORTTable1Header1 = [
						{
							text: '',
							border: [false, true, false, false]
						},
						{
							text: i18nFilter('_feeds_amount_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_cp_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_rup_dig_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_protein_a_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_protein_b_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_protein_c_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_kd_bprot_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_npncpe_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_rup89_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_ndicp_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_adicp_'),
							border: [false, true, false, false],
							alignment: 'center'
						}
					];
					var ORTTable1Header2 = [
						{
							text: i18nFilter('_feeds_name_'),
							border: [false, false, false, true]
						},
						{
							text: vm.weight ? vm.weight : '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_rup_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_cp_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_cp_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_cp_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_unit_hours_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_cp_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_cp_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						}
					];
					dd.content[12].table.body.splice(0, 0, ORTTable1Header2);
					dd.content[12].table.body.splice(0, 0, ORTTable1Header1);
				}
				var ORTable0 = {
					margin: [0, 10, 0, 0],
					table: {
						dontBreakRows: true,
						headerRows: 2,
						keepWithHeaderRows: 30,
						widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
						body: [
							[
								{
									text: '',
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_amount_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_ndf_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_efndf_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_lingnin_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_ndf_dig_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_efndf_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_adf_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_rdndf_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_disc_fac_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_nel89_'),
									border: [false, true, false, false],
									alignment: 'center'
								},
								{
									text: i18nFilter('_feeds_me89_'),
									border: [false, true, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: '',
									border: [false, false, false, true]
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.weight ? vm.weight : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.energy ? vm.energy : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: (vm.energy ? vm.energy : '') + '/' + i18nFilter('_unit_day_'),
									fontSize: 8,
									border: [false, false, false, true],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_supply_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.supply_amount.amount_dm ? $filter('number')(vm.ration.supply_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.ndf ? vm.ration.supply_amount.ndf : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.ef_ndf_as_ndf ? vm.ration.supply_amount.ef_ndf_as_ndf : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.lignin ? vm.ration.supply_amount.lignin : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.ndf_digest ? vm.ration.supply_amount.ndf_digest : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.ef_ndf_as_dm ? vm.ration.supply_amount.ef_ndf_as_dm : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.adf ? vm.ration.supply_amount.adf : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.rd_ndf ? vm.ration.supply_amount.rd_ndf : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.disc_fac ? vm.ration.supply_amount.disc_fac : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.nel_89 ? vm.ration.supply_amount.nel_89 : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.supply_amount.me_89 ? vm.ration.supply_amount.me_89 : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, false],
									alignment: 'right'
								},
								{
									text: vm.ration.requirement_amount.amount_dm ? $filter('number')(vm.ration.requirement_amount.amount_dm, 2) : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.ndf ? vm.ration.requirement_amount.ndf : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.ef_ndf_as_ndf ? vm.ration.requirement_amount.ef_ndf_as_ndf : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.ef_ndf_as_dm ? vm.ration.requirement_amount.ef_ndf_as_dm : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.nel_89 ? vm.ration.requirement_amount.nel_89 : '',
									border: [false, false, false, false],
									alignment: 'center'
								},
								{
									text: vm.ration.requirement_amount.me_89 ? vm.ration.requirement_amount.me_89 : '',
									border: [false, false, false, false],
									alignment: 'center'
								}
							],
							[
								{
									text: i18nFilter('_rations_requirements_'),
									border: [false, false, false, true],
									alignment: 'right'
								},
								{
									text: vm.ration.balance_amount.amount_dm ? $filter('number')(vm.ration.balance_amount.amount_dm, 2) : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.ndf ? vm.ration.balance_amount.ndf : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.ef_ndf_as_ndf ? vm.ration.balance_amount.ef_ndf_as_ndf : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.ef_ndf_as_dm ? vm.ration.balance_amount.ef_ndf_as_dm : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.nel_89 ? vm.ration.balance_amount.nel_89 : '',
									border: [false, false, false, true],
									alignment: 'center'
								},
								{
									text: vm.ration.balance_amount.me_89 ? vm.ration.balance_amount.me_89 : '',
									border: [false, false, false, true],
									alignment: 'center'
								}
							]
						]
					},
					layout: {
						hLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1.5 : 0.5;
						},
						vLineWidth: function (i, node) {
							return i === 0 || i === node.table.body.length ? 1 : 0.5;
						},
						hLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'black' : 'gray';
						},
						vLineColor: function (i, node) {
							return i === 0 || i === node.table.body.length ? 'gray' : 'gray';
						},
						paddingLeft: function () {
							return 2;
						},
						paddingRight: function () {
							return 1;
						},
						paddingTop: function () {
							return 1;
						},
						paddingBottom: function () {
							return 0;
						}
					}
				};
				dd.content.splice(12, 0, ORTable0);
				if (vm.summary.feeds.length > 0) {
					for (var i = vm.summary.feeds.length - 1; i >= 0; i--) {
						var date = new Date(vm.summary.feeds[i].test_date);
						date = $filter('date')(date, 'shortDate');
						var ORTable0Feed = [
							{
								text: vm.summary.feeds[i].feed_name ? vm.summary.feeds[i].feed_name : '',
								border: [false, false, false, false]
							},
							{
								text: vm.summary.feeds[i].amount ? $filter('number')(vm.summary.feeds[i].amount, 2) : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].ndf ? vm.summary.feeds[i].ndf : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].ef_ndf_as_ndf ? vm.summary.feeds[i].ef_ndf_as_ndf : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].lignin ? vm.summary.feeds[i].lignin : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].ndf_digest ? vm.summary.feeds[i].ndf_digest : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].ef_ndf_as_dm ? vm.summary.feeds[i].ef_ndf_as_dm : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].adf ? vm.summary.feeds[i].adf : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].rd_ndf ? vm.summary.feeds[i].rd_ndf : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].disc_fac ? vm.summary.feeds[i].disc_fac : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].nel_89 ? vm.summary.feeds[i].nel_89 : '',
								border: [false, false, false, false],
								alignment: 'center'
							},
							{
								text: vm.summary.feeds[i].me_89 ? vm.summary.feeds[i].me_89 : '',
								border: [false, false, false, false],
								alignment: 'center'
							}
						];
						dd.content[12].table.body.splice(0, 0, ORTable0Feed);
					}
					var ORTTable0Header1 = [
						{
							text: '',
							border: [false, true, false, false]
						},
						{
							text: i18nFilter('_feeds_amount_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_ndf_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_efndf_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_lingnin_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_ndf_dig_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_efndf_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_adf_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_rdndf_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_disc_fac_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_nel89_'),
							border: [false, true, false, false],
							alignment: 'center'
						},
						{
							text: i18nFilter('_feeds_me89_'),
							border: [false, true, false, false],
							alignment: 'center'
						}
					];
					var ORTTable0Header2 = [
						{
							text: i18nFilter('_feeds_name_'),
							border: [false, false, false, true]
						},
						{
							text: vm.weight ? vm.weight : '',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_ndf_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: vm.settings.use_percent ? '%' + i18nFilter('_feeds_dm_') : i18nFilter('_unit_grams_') + '/' + vm.weight + ' ' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_ndfn_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_dm_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_unit_hours_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%' + i18nFilter('_feeds_ndf_'),
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: '%',
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: (vm.energy ? vm.energy : '') + '/' + i18nFilter('_unit_day_'),
							fontSize: 8,
							border: [false, false, false, true],
							alignment: 'center'
						},
						{
							text: (vm.energy ? vm.energy : '') + '/' + i18nFilter('_unit_day_'),
							fontSize: 8,
							border: [false, false, false, true],
							alignment: 'center'
						}
					];
					dd.content[12].table.body.splice(0, 0, ORTTable0Header2);
					dd.content[12].table.body.splice(0, 0, ORTTable0Header1);
				}
			}
			var name = vm.summary.ration_name;
			if (isSummary) {
				var type = i18nFilter('_report_summary_');
			} else {
				var type = i18nFilter('_report_office_report_');
			}
			var reportName = type + ' ' + name + '.pdf';
			pdfMake.createPdf(dd).download(reportName);
			reportPromise.resolve();
			return reportPromise.promise;
		}
	}
})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('Spartan').run(['$templateCache', function($templateCache) {$templateCache.put('app/components/infoPopoverComponent/infoPopover.component.html','<span class="info-popover-component" popover-class="{{vm.infoPopoverClass}}" ng-style="vm.iconStyle" popover-trigger="{{vm.popoverTrigger != null ? vm.popoverTrigger : \'outsideClick\'}}" uib-popover-template="\'app/components/infoPopoverComponent/infoPopoverContent.html\'" popover-placement="{{vm.popoverPlacement != null ? vm.popoverPlacement : \'bottom\'}}" popover-append-to-body="{{vm.appendToBody != null ? vm.appendToBody : true}}"><i class="fa fa-info-circle"></i></span>');
$templateCache.put('app/components/infoPopoverComponent/infoPopoverContent.html','<div class="info-popover-content"><h5 ng-if="vm.title">{{vm.title}}</h5><h6 ng-if="vm.subtitle">{{vm.subtitle}}</h6><div ng-if="vm.items && !vm.loading"><ul><li ng-repeat="item in vm.items">{{item}}</li></ul></div><div align="center" ng-if="vm.loading"><loading-spinner></loading-spinner></div></div>');
$templateCache.put('app/components/loadingModal/loading.modal.html','<div class="modal-content"><div class="modal-header"><div align="center"><span class="secondaryText"><data-i18n i18n="_title_please_wait_">please wait</data-i18n></span></div></div><div class="modal-body"><loading-spinner-large></loading-spinner-large></div></div>');
$templateCache.put('app/pages/calendar/calendar.html','<div class="widgets" ng-cloak=""><div class="row"><div class="col-lg-12 col-md-12"><div ng-class="vm.showCreatePdfBlock || vm.showEditBlock ? \'create-pdf\': \'\'"><div ng-show="vm.selectedHerd" ba-panel="" ba-panel-class="{{vm.showFeedingDescription ? \'with-scroll calendar-overview-panel\' : \'calendar-main-panel\'}}"><div ng-style="!vm.showFeedingDescription ? {} : {display: \'none\'}" include-with-scope="app/pages/calendar/calendar.panel.html"></div><div ng-if="vm.showFeedingDescription" include-with-scope="app/pages/calendar/feedingTable/recipeOverview.panel.html"></div></div><div ng-if="!vm.loading && !vm.selectedHerd" align="center" ba-panel=""><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div></div></div></div>');
$templateCache.put('app/pages/calendar/calendar.panel.html','<div id="calendar" class="blurCalendar" ng-if="vm.showCalendar" ng-show="!vm.showCreatePdfBlock && !vm.showEditBlock" element-loaded="vm.calendarDivLoaded()"><div class="custom-buttons" ng-if="!vm.loadingCustomButtons"><div class="calendar-datepicker-button-container"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.dateFromat}}" ng-model="vm.datepickerModel" ng-change="vm.datepickerChanged()" datepicker-append-to-body="true" is-open="vm.popupOpened" close-text="{{\'_label_close_\' | i18n}}" readonly=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div ng-class="vm.settings.language == \'it-it\' ? \'form-group calendar-filter-reports-wider\' : vm.settings.language == \'pl-pl\' ? \'form-group calendar-filter-reports-wider\' : vm.settings.language == \'de-de\' ? \'form-group calendar-filter-reports-wider\' : \'form-group calendar-filter-reports\'" ng-if="vm.deviceType !== \'mobile\'"><select class="form-control selectpicker show-tick" selectpicker="" ng-options="type as type.label for type in vm.reportTypes" ng-model="vm.reportType" ng-change="vm.reportTypeChanged()"></select></div><div class="btn-group calendar-filter-btn"><button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.openFilterModal()" tooltip-enable="vm.recipeFilterActive" uib-tooltip="{{\'_reports_filter_active_\' | i18n}}" tooltip-is-open="filter_active" tooltip-placement="left" tooltip-class="customBlue left tooltip-opaque" tooltip-popup-delay="500"><span class="glyphicon glyphicon-filter"></span></button></div><div class="notification" ng-if="vm.recipeFilterActive"></div></div></div><div ng-if="vm.showCreatePdfBlock && !vm.showEditBlock"><div style="text-align: right"><button class="btn btn-primary btn-sm" ng-click="vm.openExportModal()"><data-i18n i18n="_label_export_pdf_">Export pdf</data-i18n></button> <button class="btn btn-primary btn-sm" ng-click="vm.hideCreatePdfBlock()"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div><div ng-repeat="event in vm.eventsForPdf" class="events-preview"><div><div class="event-info" style="margin-left: 0px">{{event.Title}}</div></div><div><div class="image-holder" ng-if="event.Pictures && event.Pictures.length>0"><img ng-src="{{event.Pictures[0].ThumbnailUrl}}"></div><div class="general-info"><div style="font-weight: bold"><span>{{event.StartDate | date: \'shortDate\'}}</span><span style="margin-right: 2px; margin-left: 2px">&mdash;</span><span>{{event.EndDate | date: \'shortDate\'}}</span></div><div ng-if="event.Recurring && event.Recurring > 0"><span><data-i18n i18n="_calendar_repeat_event_">Repeat event</data-i18n>:</span><div class="event-info"><data-i18n i18n="{{event.ReccuringString}}"></data-i18n></div></div><div ng-if="event.Recurring && event.Recurring > 0"><span><data-i18n i18n="_calendar_repeat_interval_">Repeat Interval</data-i18n>:</span><div class="event-info">{{event.RecurringInterval}}</div></div><div ng-if="event.RecurringEndDate"><span><data-i18n i18n="_calendar_repeat_end_">Repeat End</data-i18n>:</span><div class="event-info">{{event.RecurringEndDate | date: \'shortDate\'}}</div></div><div><data-i18n i18n="_label_herd_"></data-i18n>:<div class="event-info">{{event.HerdName}}</div></div></div></div><div ng-if="event.Description"><data-i18n i18n="_calendar_event_description_"></data-i18n>:<div class="event-info">{{event.Description}}</div></div><div><data-i18n i18n="_dc_comments_">Comments</data-i18n>:</div><div><input type="text" class="form-control" ng-model="event.Comment" maxlength="1023"></div></div></div><div ng-if="vm.showEditBlock"><div style="height: 30px"><button class="btn btn-primary btn-sm" style="float: right"><data-i18n i18n="_label_cancel_" ng-click="vm.closeEditBlock()">Cancel</data-i18n></button></div><div style="margin-top: 10px"><div><input type="text" class="form-control" placeholder="Add title" ng-model="vm.selected_event.Title" maxlength="1023"> <textarea class="form-control" ng-model="vm.selected_event.Description" placeholder="Add description" style="resize: none; width: 100%; margin-top: 10px"></textarea></div><div ng-if="vm.hidePicturesButton"><div class="event-picture" ng-if="vm.selected_event.Pictures.length>0"><div ng-if="vm.selected_event.Pictures && vm.selected_event.Pictures.length>0" class="animal-reproduction" style="text-align: center; padding-left: 0px"><div class="reproduction-thumbnail" ng-class="vm.selected_event.Pictures[0].Importance == 1 ? \'importance-1\' : (vm.selected_event.Pictures[0].Importance == 2 ? \'importance-2\' : (vm.selected_event.Pictures[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage($index)" style="position: relative"><div class="animal-remove-icon" ng-click="vm.removePicture()"><i class="fa fa-times-circle-o fa-2x primaryModal"></i></div><img src="assets/img/MmmLogo.png" width="120px" lazy-img="{{vm.selected_event.Pictures[0].ThumbnailUrl}}" lazy-img-error="assets/img/MmmLogo.png" ng-if="!vm.selected_event.Pictures[0].hideImage" ng-style="vm.selected_event.Pictures[0].FileUrl && {\'min-width\': \'96px\', \'min-height\': \'96px\'}"></div></div></div></div><div style="padding-top: 5px; padding-bottom: 5px" ng-if="!vm.hidePicturesButton"><button class="btn btn-primary btn-sm" ng-click="vm.showAddPictureBlock = true;"><data-i18n i18n="_label_add_picture_">Add picture</data-i18n></button></div><div ng-if="vm.showAddPictureBlock"><div class="upload-file-block"><div align="center" ng-if="!vm.fileName"><i class="primaryModal fa fa-cloud-upload fa-3x"></i></div><div align="center" ng-if="!vm.fileName"><button type="file" class="btn btn-primary" ngf-select="" ng-model="vm.file" name="file" ngf-max-size="10MB" ngf-change="vm.uploadChanged()"><data-i18n i18n="_btn_choose_file_to_upload_">choose file</data-i18n></button></div><div ng-if="vm.fileName"><span>{{vm.fileName}}</span>&nbsp;<span class="fa fa-times-circle-o fa-lg remove-selected" ng-click="vm.removeSelectedFile()"></span></div></div><div style="height: 166px; overflow-x: auto; white-space: nowrap; display: flex; margin-top: 5px" lazy-img-container="" ng-if="vm.showPictures"><div class="calendar-pictures-navigation" ng-if="vm.showLoadLeft && !vm.loadingPictures"><div ng-click="vm.loadLeft()"><span style="vertical-align: middle"><i class="fa fa-chevron-left"></i></span><span style="vertical-align: middle"><i class="fa fa-chevron-left"></i></span></div></div><div ng-repeat="picture in vm.pictures" style="display: inline" ng-if="!vm.loadingPictures"><div class="animal-wrapper-list clearfix"><div class="image-canvas" ng-click="vm.selectPicture(picture)" style="margin-top: 0px"><img src="assets/img/MmmLogo.png" width="80px" lazy-img="{{picture.ThumbnailUrl}}" lazy-img-error="assets/img/MmmLogo.png" ng-if="picture.ThumbnailUrl && !vm.hideImage"> <img ng-src="assets/img/MmmLogo.png" ng-if="!picture.ThumbnailUrl || vm.hideImage"></div></div></div><div class="calendar-pictures-navigation" ng-if="vm.showLoadRight && !vm.loadingPictures"><div ng-click="vm.loadRight()"><span style="vertical-align: middle"><i class="fa fa-chevron-right"></i></span><span style="vertical-align: middle"><i class="fa fa-chevron-right"></i></span></div></div><div ng-if="vm.loadingPictures" style="text-align: center; overflow: hidden"><div id="loading-animation-large"></div></div></div></div><div class="calendar-date-time-picker"><div class="date-time-picker-cell time-icon"><i class="fa fa-clock-o"></i></div><div class="date-time-picker-cell time-holder" ng-class="!vm.showTime ? \'show-button\' : \'\'"><div class="time-holder-cell" ng-class="!vm.showTime ? \'hide-time\' : \'\'" style="width: auto; max-width: 150px;"><input type="text" class="form-control" uib-datepicker-popup="shortDate" ng-model="vm.selected_event.StartDate" is-open="vm.showStartPicker" show-button-bar="false" ng-click="vm.showStartPicker = true"></div><div class="time-holder-cell input-group" ng-if="vm.showTime" style="width: auto; max-width: 200px;"><input time-validator-model="rule" class="form-control pickerInput ng-pristine ng-isolate-scope ng-empty ng-valid-time-validators ng-invalid ng-invalid-required ng-touched" placeholder="--:-- --" ng-model="vm.selected_event.startTime.time" style="width: auto; max-width: 150px;" required=""> <span class="input-group-btn" style="width: auto; max-width: 20px;"><button type="button" class="btn btn-default ng-pristine ng-valid ng-isolate-scope moment-picker-input ng-empty ng-valid-min-date ng-valid-max-date ng-touched" moment-picker="vm.selected_event.startTime.time" ng-model="vm.selected_event.startTime.momentTime" change="editEvent()" format="hh:mm A" locale="en" ng-model-options="{ updateOn: \'blur\' }"><i class="glyphicon glyphicon-time ng-scope"></i></button></span></div><div class="time-holder-cell dash-cell" style="padding-left: 70px;">-</div><div class="time-holder-cell" ng-class="!vm.showTime ? \'hide-time\' : \'\'" style="width: auto; max-width: 150px;"><input type="text" class="form-control" uib-datepicker-popup="shortDate" ng-model="vm.selected_event.EndDate" is-open="vm.showEndPicker" show-button-bar="false" ng-click="vm.showEndPicker = true"></div><div class="time-holder-cell input-group" ng-if="vm.showTime" style="width: auto; max-width: 200px;"><input time-validator-model="rule" class="form-control pickerInput ng-pristine ng-isolate-scope ng-empty ng-valid-time-validators ng-invalid ng-invalid-required ng-touched" placeholder="--:-- --" ng-model="vm.selected_event.endTime.time" style="width: auto; max-width: 150px;" required=""> <span class="input-group-btn" style="width: auto; max-width: 20px;"><button type="button" class="btn btn-default ng-pristine ng-valid ng-isolate-scope moment-picker-input ng-empty ng-valid-min-date ng-valid-max-date ng-touched" moment-picker="vm.selected_event.endTime.time" ng-model="vm.selected_event.endTime.momentTime" change="editEvent()" format="hh:mm A" locale="en" ng-model-options="{ updateOn: \'blur\' }"><i class="glyphicon glyphicon-time ng-scope"></i></button></span></div></div><div ng-if="!vm.showTime" class="date-time-picker-cell" style="float: right"><button class="btn btn-sm btn-primary" ng-click="vm.showTimePickers()"><data-i18n i18n="_calendar_show_time_">Show Time</data-i18n></button></div></div><div><div class="row" style="padding: 15px"><button class="btn btn-sm btn-primary" ng-click="vm.showRepeatBlock()"><data-i18n i18n="_calendar_repeat_event_">Repeat event</data-i18n></button></div></div><div class="repeat-event-block" ng-if="vm.showRepeat" style="width: 40%"><div class="repeat-label"><data-i18n i18n="_calendar_repeat_">Repeat</data-i18n>:</div><div class="repeat-selector"><ui-select ng-model="vm.selected_event.RecurringObject" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true"><ui-select-match>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="repeat in vm.repeatList">{{repeat.label}}</ui-select-choices></ui-select></div></div><div class="repeat-event-block" ng-if="vm.showRepeat && vm.selected_event.RecurringObject.value" style="margin-top: 10px; padding-bottom: 0px; width: 40%"><div class="repeat-label"><data-i18n i18n="_calendar_repeat_interval_">Repeat interval</data-i18n>:</div><div class="repeat-selector"><input type="number" step="1" class="form-control" style="height: 36px; margin-bottom: 10px" min="0" ng-model="vm.selected_event.RecurringInterval"></div></div><div class="repeat-event-block" ng-if="vm.showRepeat && vm.selected_event.RecurringObject.value" style="width: 40%"><div class="repeat-label"><data-i18n i18n="_calendar_repeat_end_">Repeat end</data-i18n>:</div><div class="repeat-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="shortDate" ng-model="vm.selected_event.RecurringEndDate" is-open="vm.showEndRepeat" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.showEndRepeat = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div><button type="button" class="btn btn-info" ng-click="vm.saveEvent()" ng-disabled="!vm.selected_event.Title || vm.selected_event.Title.lenght<=0" style="float: right"><data-i18n i18n="_label_save_">save</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/calendar/confirmation.modal.html','<div class="modal-content"><div class="modal-header"><div align="center"><span class="ion-android-warning warningModal" style="font-size: 36px"></span></div><div align="center"><span class="warningModal"><data-i18n i18n="_title_unsaved_changes_">Warning message</data-i18n></span></div></div><div class="modal-body"><div align="center"><button type="button" class="btn btn-primary" ng-click="vm.confirm()"><data-i18n i18n="_btn_continue_">Continue</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/calendar/deleteEvent.modal.html','<div class="modal-content"><div class="modal-header" ng-if="!vm.loadingModal"><div align="center"><span class="ion-android-warning warningModal" style="font-size: 36px"></span></div><div align="center"><span class="warningModal"><data-i18n i18n="_calendar_event_delete_warning_message_">Warning message</data-i18n></span></div></div><div class="modal-body" ng-if="!vm.loadingModal"><div align="center"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="vm.deleteEventProceed()"><data-i18n i18n="_btn_delete_">Delete</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="$dismiss()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div class="modal-body" style="height: 200px; overflow: hidden" ng-if="vm.loadingModal" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/calendar/description.modal.html','<div class="modal-content calendar-description"><div class="modal-header" style="padding: 10px" ng-style="{\'background-color\': \'#126da2\'}"><div class="header-buttons"><i class="fa fa-trash calendar-description-header-button" ng-click="vm.deleteEvent()"></i> <i class="fa fa-pencil-square-o calendar-description-header-button" ng-click="vm.editEvent()"></i> <i class="fa fa-times calendar-description-header-button" ng-click="$dismiss()"></i></div><div class="event-title">{{vm.selected_event.Title}}</div></div><div class="modal-body" style="padding-top: 10px"><div><div class="event-picture" ng-if="vm.selected_event.Pictures.length>0"><div ng-if="vm.selected_event.Pictures && vm.selected_event.Pictures.length>0" class="animal-reproduction" style="text-align: center"><div class="reproduction-thumbnail" ng-class="vm.selected_event.Pictures[0].Importance == 1 ? \'importance-1\' : (vm.selected_event.Pictures[0].Importance == 2 ? \'importance-2\' : (vm.selected_event.Pictures[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage($index)"><img src="assets/img/MmmLogo.png" lazy-img="{{vm.selected_event.Pictures[0].ThumbnailUrl}}" lazy-img-error="assets/img/MmmLogo.png" ng-if="!vm.selected_event.Pictures[0].hideImage" width="70px" ng-style="vm.selected_event.Pictures[0].FileUrl && {\'min-width\': \'96px\', \'min-height\': \'96px\'}"></div></div></div><div class="event-details"><div><span><i class="fa fa-clock-o lg" style="margin-right: 5px"></i>{{vm.selected_event.startDate }} - {{vm.selected_event.endDate }}</span></div><div ng-if="vm.selected_event.Recurring"><span><data-i18n i18n="_calendar_repeat_event_">Repeat event</data-i18n>&nbsp;:&nbsp;{{vm.selected_event.ReccuringString}}</span></div><div ng-if="vm.selected_event.Recurring && vm.selected_event.RecurringInterval"><span><data-i18n i18n="_calendar_repeat_interval_">Repeat interval</data-i18n>:<span style="margin-left: 5px">{{vm.selected_event.RecurringInterval}}</span></span></div><div ng-if="vm.selected_event.Recurring && vm.selected_event.RecurringEndDate"><span><data-i18n i18n="_calendar_repeat_end_">Repeat end</data-i18n>: <span style="margin-left: 5px">{{vm.selected_event.RecurringEndDate | date:\'shortDate\'}}</span></span></div></div></div><div class="event-description" ng-if="vm.selected_event.Description"><data-i18n i18n="_calendar_event_description_"></data-i18n>:&nbsp;{{vm.selected_event.Description}}</div></div></div>');
$templateCache.put('app/pages/calendar/exportPdf.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><i class="fa fa-times"></i></button></div><div class="modal-body" ng-if="!vm.selectHerdError && !vm.loadingModal"><form novalidate="" form="vm.exportForm"><div class="form-group"><label for="name"><data-i18n i18n="_label_file_name_">File name</data-i18n></label> <input type="text" class="form-control" id="name" name="name" placeholder="{{\'_label_file_name_\' | i18n}}" ng-model="vm.file_name" required=""></div><span style="margin-top: -15px; font-size: 12px" class="help-block basic-block warningModal" ng-if="vm.file_name.length > 250"><data-i18n i18n="_message_error_file_name_too_long">File name too long</data-i18n></span><div class="form-group"><label for="name"><data-i18n i18n="_label_file_header_">File header</data-i18n></label> <input type="text" class="form-control" placeholder="{{\'_label_file_header_\' | i18n}}" ng-model="vm.file_header" required=""></div></form><div ng-if="vm.showNewDiscussionBlock"><div style="padding: 10px 20px"><span class="action-menu-label"><data-i18n i18n="_label_priority_">Priority</data-i18n>:</span> <span class="label label-importance label-importance-none" data-importance="0" tabindex="0" ng-click="vm.discussion.importance=0" ng-class="vm.discussion.importance==0 ? \'label-importance-selected\' : (!vm.discussion.importance ? \'label-importance-selected\': \'\')"><data-i18n i18n="_label_none_">None</data-i18n></span> <span class="label label-importance label-importance-1 bg-success" data-importance="1" tabindex="0" ng-class="vm.discussion.importance==1 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=1"><data-i18n i18n="_label_low_">Low</data-i18n></span> <span class="label label-importance label-importance-2 bg-warning" data-importance="2" tabindex="0" ng-class="vm.discussion.importance==2 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=2"><data-i18n i18n="_label_medium_">Medium</data-i18n></span> <span class="label label-importance label-importance-3 bg-danger" data-importance="3" tabindex="0" ng-class="vm.discussion.importance==3 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=3"><data-i18n i18n="_label_high_">High</data-i18n></span></div><div style="padding: 10px 20px"><span class="action-menu-label" style="margin-top: 3px"><data-i18n i18n="_label_is_task_">is task</data-i18n>?</span> <input type="checkbox" ng-model="vm.discussion.isTask"></div><div style="padding: 10px 20px"><div class="input-group" style="max-width: 310px"><span class="input-group-addon" style="padding: 0px 7px; font-size: 27px"><span class="fa fa-comment-o"></span></span> <input type="text" class="form-control" placeholder="{{\'_placeholder_comment_add_\'|i18n}}" tabindex="0" ng-model="vm.discussion.comments"></div></div><div style="padding: 10px 20px"><div class="input-group" style="max-width: 310px"><span class="input-group-addon"><span style="padding: 0px 0px; font-size: 18px" class="fa fa-tags"></span></span><ui-select multiple="" ng-model="vm.discussion.tags_list" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px" on-select="vm.newDiscussionSetTags()" on-remove="vm.newDiscussionSetTags()"><ui-select-match>{{$item.label}}</ui-select-match><ui-select-choices repeat="tag in vm.tagsList | filter: $select.search">{{tag.label}}</ui-select-choices></ui-select></div></div></div></div><div class="modal-body" ng-if="vm.selectHerdError"><div style="text-align: center"><h4 class="warningModal"><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h4></div></div><div class="modal-body" style="text-align: center; overflow: hidden" ng-if="vm.loadingModal"><div id="loading-animation-large"></div></div><div class="modal-body" style="text-align: center" ng-if="vm.pdfError"><div><span class="warningModal"><data-i18n i18n="_toastr_error_occured_">Error</data-i18n></span></div></div><div class="modal-footer" ng-if="!vm.selectHerdError && !vm.loadingNewDiscussion && !vm.loadingModal"><button type="button" class="btn btn-info" ng-click="vm.showNewDiscussion()" ng-if="!vm.showNewDiscussionBlock" ng-disabled="!vm.file_name || vm.file_name== \'\' || vm.file_name.lenght == 0 || vm.file_name.length > 250"><data-i18n i18n="_label_export_pdf_discussion_">export and create discussion</data-i18n></button> <button type="button" class="btn btn-info" ng-click="vm.exportPdf()" ng-disabled="!vm.file_name || vm.file_name== \'\' || vm.file_name.lenght == 0 || vm.file_name.length > 250" ng-if="!vm.showNewDiscussionBlock"><data-i18n i18n="_label_export_pdf_">export to pdf</data-i18n></button> <button type="button" class="btn btn-info" ng-click="vm.exportPdf(true)" ng-disabled="!vm.file_name || vm.file_name== \'\' || vm.file_name.lenght == 0 || vm.file_name.length > 250 || !vm.selectedHerd" ng-if="vm.showNewDiscussionBlock"><data-i18n i18n="_label_save_">save</data-i18n></button></div></div>');
$templateCache.put('app/pages/calendar/loadingModal.html','<div class="modal-content"><div class="modal-header"><div align="center"><span class="secondaryText"><data-i18n i18n="_title_please_wait_">please wait</data-i18n></span></div></div><div class="modal-body"><div style="height: 200px" align="center"><div style="margin-top: 50px"><div id="loading-animation-large" style="display: inline-block"></div></div></div></div></div>');
$templateCache.put('app/pages/calendar/newEvent.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><i class="fa fa-times"></i></button><div ng-if="vm.showEventPicker"><button type="button" class="btn btn-sm btn-primary" style="margin-right: 10px" ng-click="vm.showNewEventBlock = true;" ng-if="!vm.showNewEventBlock">Create new event</button><button type="button" class="btn btn-sm btn-primary" ng-if="!vm.showNewEventBlock" ng-click="vm.openCreatePdf()">Create PDF</button></div></div><div class="modal-body" ng-if="!vm.loadingAddNewEvent && vm.showNewEventBlock"><div><input type="text" class="form-control" placeholder="Add title" ng-model="vm.newEvent.title" maxlength="1023"> <textarea class="form-control" ng-model="vm.newEvent.description" placeholder="Add description" style="resize: none; width: 100%; margin-top: 10px"></textarea></div><div style="padding-top: 5px; padding-bottom: 5px"><button class="btn btn-primary btn-sm" ng-click="vm.showAddPictureBlock = true;"><data-i18n i18n="_label_add_picture_">Add picture</data-i18n></button></div><div ng-if="vm.showAddPictureBlock"><div class="upload-file-block"><div align="center" ng-if="!vm.fileName"><i class="fa fa-cloud-upload fa-3x primaryModal"></i></div><div align="center" ng-if="!vm.fileName"><button type="file" class="btn btn-primary" ngf-select="" ng-model="vm.file" name="file" ngf-max-size="10MB" ngf-change="vm.uploadChanged()"><data-i18n i18n="_btn_choose_file_to_upload_">choose file</data-i18n></button></div><div ng-if="vm.fileName"><span>{{vm.fileName}}</span>&nbsp;<span class="fa fa-times-circle-o fa-lg remove-selected warningModal" ng-click="vm.removeSelectedFile()"></span></div></div><div style="height: 166px; overflow-x: auto; white-space: nowrap; display: flex; margin-top: 5px" lazy-img-container="" ng-if="vm.showPictures"><div class="calendar-pictures-navigation" ng-if="vm.showLoadLeft && !vm.loadingPictures"><div ng-click="vm.loadLeft()"><span><i class="fa fa-chevron-left"></i></span><span><i class="fa fa-chevron-left"></i></span></div></div><div ng-repeat="picture in vm.pictures" style="display: inline" ng-if="!vm.loadingPictures"><div class="animal-wrapper-list clearfix"><div class="image-canvas" ng-click="vm.selectPicture(picture)" style="margin-top: 0px"><img src="assets/img/MmmLogo.png" lazy-img="{{picture.ThumbnailUrl}}" width="80px" lazy-img-error="assets/img/MmmLogo.png" ng-if="picture.ThumbnailUrl && !vm.hideImage"> <img ng-src="assets/img/MmmLogo.png" ng-if="!picture.ThumbnailUrl || vm.hideImage"></div></div></div><div class="calendar-pictures-navigation" ng-if="vm.showLoadRight && !vm.loadingPictures"><div ng-click="vm.loadRight()"><span><i class="fa fa-chevron-right"></i></span><span><i class="fa fa-chevron-right"></i></span></div></div><div ng-if="vm.loadingPictures" style="text-align: center"><div id="loading-animation-large"></div></div></div></div><div class="calendar-date-time-picker"><div class="date-time-picker-cell time-icon"><i class="fa fa-clock-o"></i></div><div class="date-time-picker-cell time-holder" ng-class="!vm.showTime ? \'show-button\' : \'\'"><div class="time-holder-cell" ng-class="!vm.showTime ? \'hide-time\' : \'\'" style="width: auto; max-width: 95px;"><input type="text" class="form-control" uib-datepicker-popup="shortDate" ng-model="vm.newEvent.startDate" is-open="vm.showStartPicker" show-button-bar="false" ng-click="vm.showStartPicker = true"></div><div class="time-holder-cell input-group" ng-if="vm.showTime"><input class="form-control pickerInput ng-pristine ng-isolate-scope ng-empty ng-valid-time-validators ng-invalid ng-invalid-required ng-touched" ng-model="vm.newEvent.startTime.time" ng-change="openEventModal()" required="" placeholder="--:-- --" style="width: auto; max-width: 90px;"> <span class="input-group-btn"><button type="button" class="btn btn-default ng-pristine ng-valid ng-isolate-scope moment-picker-input ng-empty ng-valid-min-date ng-valid-max-date ng-touched" moment-picker="vm.newEvent.startTime.time" ng-model="vm.newEvent.startTime.momentTime" ng-change="openEventModal()" format="hh:mm A" locale="en"><i class="glyphicon glyphicon-time ng-scope"></i></button></span></div><div class="time-holder-cell dash-cell" style="padding-left: 25px;">-</div><div class="time-holder-cell" ng-class="!vm.showTime ? \'hide-time\' : \'\'" style="width: auto; max-width: 95px;"><input type="text" class="form-control" uib-datepicker-popup="shortDate" ng-model="vm.newEvent.endDate" is-open="vm.showEndPicker" show-button-bar="false" ng-click="vm.showEndPicker = true"></div><div class="time-holder-cell input-group" ng-if="vm.showTime"><input class="form-control pickerInput ng-pristine ng-isolate-scope ng-empty ng-valid-time-validators ng-invalid ng-invalid-required ng-touched" ng-model="vm.newEvent.endTime.time" ng-change="openEventModal()" required="" placeholder="--:-- --" style="width: auto; max-width: 90px;"> <span class="input-group-btn"><button type="button" class="btn btn-default ng-pristine ng-valid ng-isolate-scope moment-picker-input ng-empty ng-valid-min-date ng-valid-max-date ng-touched" moment-picker="vm.newEvent.endTime.time" ng-model="vm.newEvent.endTime.momentTime" ng-change="openEventModal()" format="hh:mm A" locale="en"><i class="glyphicon glyphicon-time ng-scope"></i></button></span></div></div><div ng-if="!vm.showTime" class="date-time-picker-cell" style="float: right"><button class="btn btn-sm btn-primary" ng-click="vm.showTimePickers()"><data-i18n i18n="_calendar_show_time_">Show Time</data-i18n></button></div></div><div><div class="row" style="padding: 15px"><button class="btn btn-sm btn-primary" ng-click="vm.showRepeatBlock()"><data-i18n i18n="_calendar_repeat_event_">Repeat event</data-i18n></button></div></div><div class="repeat-event-block" ng-if="vm.showRepeat"><div class="repeat-label"><data-i18n i18n="_calendar_repeat_">Repeat</data-i18n>:</div><div class="repeat-selector"><ui-select ng-model="vm.newEvent.repeatType" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true"><ui-select-match>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="repeat in vm.repeatList">{{repeat.label}}</ui-select-choices></ui-select></div></div><div class="repeat-event-block" ng-if="vm.showRepeat && vm.newEvent.repeatType.value" style="margin-top: 10px; padding-bottom: 0px"><div class="repeat-label" style="vertical-align: baseline"><data-i18n i18n="_calendar_repeat_interval_">Repeat interval</data-i18n>:</div><div class="repeat-selector"><input type="number" step="1" class="input-group" style="height: 36px" min="0" ng-model="vm.newEvent.repeatInterval"></div></div><div class="repeat-event-block" ng-if="vm.showRepeat && vm.newEvent.repeatType.value"><div class="repeat-label" style="vertical-align: baseline"><data-i18n i18n="_calendar_repeat_end_">Repeat end</data-i18n>:</div><div class="repeat-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="shortDate" ng-model="vm.newEvent.endRepeat" is-open="vm.showEndRepeat" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.showEndRepeat = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="vm.addNewEvent()" ng-disabled="!vm.newEvent.title || vm.newEvent.title.lenght<=0 || !vm.selectedHerd || !vm.newEvent.startDate || !vm.newEvent.endDate"><data-i18n i18n="_label_save_">save</data-i18n></button></div></div><div class="modal-body" ng-if="vm.loadingAddNewEvent" style="text-align: center"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/calendar/recipeFilter.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="vm.closeModal(\'filter\')" aria-label="Close" style="margin-right: 10px"><i class="fa fa-times primaryModal"></i></button></div><div class="modal-body"><ul class="calendar-recipe-list"><li><div class="calendar-recipe-list-item"><div class="recipe-color" style="border: none" ng-click="vm.selectAllFilters()"><p class="feedSecondary" ng-if="!vm.allFiltersActive" style="white-space: nowrap"><data-i18n i18n="_m_f_check_all_">Check all</data-i18n></p><p ng-if="vm.allFiltersActive" style="white-space: nowrap" class="feedSecondary"><data-i18n i18n="_m_f_uncheck_all_">Uncheck all</data-i18n></p></div><div class="recipe-name" style="height: 16px; width: 100%" ng-click="vm.selectAllFilters()"></div><div class="selector" style="margin-right: 3px"><span class="newCheck"><input type="checkbox" id="is_checked-all-X" ng-true-value="true" ng-false-value="false" ng-model="vm.allFiltersActive" style="margin-right: 2px" ng-change="vm.selectAllFiltersChanged()"> <label for="is_checked-all-X"></label></span></div></div></li><li ng-repeat="recipe in vm.recipeList"><div class="calendar-recipe-list-item"><div class="recipe-color" ng-style="{\'background-color\':\'{{recipe.color}}\', \'border-color\':\'{{recipe.color}}\'}" ng-click="vm.selectFilter(\'recipe\', $index)"></div><div class="recipe-name" ng-click="vm.selectFilter(\'recipe\', $index)">{{recipe.recipe_name}}</div><div class="selector"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}-X" ng-true-value="true" ng-false-value="false" ng-model="recipe.selected" style="margin-right: 2px" ng-change="vm.checkAreAllFiltersSelected()"> <label for="is_checked{{$index}}-X"></label></span></div></div></li><li ng-if="vm.regularEventsPresent"><div class="calendar-recipe-list-item"><div class="recipe-color regularEvent" ng-click="vm.selectFilter(\'regular\')"></div><div class="recipe-name" ng-click="vm.selectFilter(\'regular\')"><data-i18n i18n="_calendar_event_regular_">Regular events</data-i18n></div><div class="selector"><span class="newCheck"><input type="checkbox" id="is_checked-regular-X" ng-true-value="false" ng-false-value="true" ng-model="vm.hideRegularEvents" style="margin-right: 2px" ng-change="vm.checkAreAllFiltersSelected()"> <label for="is_checked-regular-X"></label></span></div></div></li></ul><div class="calendar-filter-date-range"><label><data-i18n i18n="_m_f_date_range_label_">Date range</data-i18n></label><div><div><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.dateFromat}}" datepicker-options="vm.datepickerStartOptions" ng-model="vm.startDateOverride" is-open="vm.startDateOverrideOpened" close-text="{{\'_label_close_\' | i18n}}"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.startDateOverrideOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.dateFromat}}" datepicker-options="vm.datepickerEndOptions" ng-model="vm.endDateOverride" is-open="vm.endDateOverrideOpened" close-text="{{\'_label_close_\' | i18n}}"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.endDateOverrideOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><div ng-if="vm.deviceType === \'mobile\'" class="form-group select-page-size-wrap dropup filter-report-dropdown"><label><data-i18n i18n="_m_f_calendar_report_type_label_">Report type</data-i18n><select class="form-control selectpicker show-tick" selectpicker="" ng-options="type as type.label for type in vm.reportTypes" ng-model="vm.reportType" ng-change="vm.isReportTypeChanged = true"></select></label></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="vm.filterEvents()"><data-i18n i18n="_btn_save_">save</data-i18n></button></div></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<div class="row"><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div ba-panel="" ba-panel-class="small-panel" style="height: auto"><div class="row pie-charts" ng-if="!vm.defaultTeamLoading"><div class="col-xs-3"><a href="" style="font-size: 72px" ng-click="vm.typeSelected(\'team\')" uib-tooltip="{{\'_tips_set_default_team_\' | i18n}}" tooltip-is-open="tooltipIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><img src="/assets/img/icons/Teams.svg" style="max-width: 70px !important"></a></div><div class="col-xs-9 description" align="center" ng-if="vm.defaultTeamExists"><div class="ng-binding"><data-i18n i18n="_dashboard_default_team_">Default team</data-i18n>:</div><div uib-tooltip="{{vm.selectedTeam.Name}}" tooltip-is-open="teamNameIsOpen" tooltip-placement="bottom" tooltip-class="customBlue bottom" tooltip-popup-delay="500" class="description-stats ng-binding">{{vm.selectedTeam.Name}}</div></div><div class="col-xs-9 description" align="center" ng-if="!vm.defaultTeamExists"><div class="ng-binding"><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></div></div></div><div ng-if="vm.defaultTeamLoading" align="center"><div id="loading-animation-large"></div></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div ba-panel="" ba-panel-class="small-panel" style="height: auto"><div class="row pie-charts" ng-if="!vm.defaultHerdLoading"><div class="col-xs-3"><a href="" style="font-size: 72px" ng-click="vm.typeSelected(\'herd\')" uib-tooltip="{{\'_tips_set_default_herd_\' | i18n}}" tooltip-is-open="tooltipIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><img src="/assets/img/icons/Herds.svg" style="max-width: 70px !important"></a></div><div class="col-xs-9 description" align="center" ng-if="vm.defaultHerdExists"><div class="ng-binding"><data-i18n i18n="_dashboard_default_herd_">Default herd</data-i18n>:</div><div uib-tooltip="{{vm.selectedHerd.Name}}" tooltip-is-open="herdNameIsOpen" tooltip-placement="bottom" tooltip-class="customBlue bottom" tooltip-popup-delay="500" class="description-stats ng-binding">{{vm.selectedHerd.Name}}</div></div><div class="col-xs-9 description" align="center" ng-if="!vm.defaultHerdExists"><div class="ng-binding"><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></div></div></div><div ng-if="vm.defaultHerdLoading" align="center"><div id="loading-animation-large"></div></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12" ng-if="vm.haveFeedAccess()"><div ba-panel="" ba-panel-class="small-panel" style="height: auto"><div class="row pie-charts"><div class="col-xs-3"><a href="" style="font-size: 72px"><img src="/assets/img/icons/Groups.svg" style="max-width: 70px !important"></a></div><div class="col-xs-9 description" style="padding: 10px 0px 0px 10px"><div class="row" style="margin-bottom: 10px"><div class="col-xs-8"><data-i18n i18n="_shortcut_group_view_">View available groups.</data-i18n></div><div style="padding: 0 !important" align="right" class="col-xs-4"><button style="margin-right: 15px; min-width: 60px" class="btn btn-primary btn-xs" ng-click="vm.redirect(\'groups.myGroups\')"><data-i18n i18n="_btn_view_">View</data-i18n></button></div></div><div class="row"><div class="col-xs-8"><data-i18n i18n="_shortcut_group_create_">Add new group.</data-i18n></div><div style="padding: 0 !important" align="right" class="col-xs-4"><button style="margin-right: 15px; min-width: 60px" class="btn btn-primary btn-xs" ng-click="vm.redirect(\'groups.addNewGroup\')"><data-i18n i18n="_btn_add_">Create</data-i18n></button></div></div></div></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12" ng-if="vm.haveFeedAccess()"><div ba-panel="" ba-panel-class="small-panel" style="height: auto"><div class="row pie-charts"><div class="col-xs-3"><a href="" style="font-size: 72px"><img src="/assets/img/icons/Feeds.svg" style="max-width: 70px !important"></a></div><div class="col-xs-9 description" style="padding: 10px 0px 0px 10px"><div class="row" style="margin-bottom: 10px"><div class="col-xs-8"><data-i18n i18n="_shortcut_feed_view_">View available feeds.</data-i18n></div><div style="padding: 0 !important" align="right" class="col-xs-4"><button style="margin-right: 15px; min-width: 60px" class="btn btn-primary btn-xs" ng-click="vm.redirect(\'feeds.myfeeds\')"><data-i18n i18n="_btn_view_">View</data-i18n></button></div></div><div class="row"><div class="col-xs-8"><data-i18n i18n="_shortcut_feed_create_">Add new feed.</data-i18n></div><div style="padding: 0 !important" align="right" class="col-xs-4"><button style="margin-right: 15px; min-width: 60px" class="btn btn-primary btn-xs" ng-click="vm.redirect(\'feeds.addNewFeed\')"><data-i18n i18n="_btn_add_">Create</data-i18n></button></div></div></div></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12" ng-if="vm.haveFeedAccess()"><div ba-panel="" ba-panel-class="small-panel" style="height: auto"><div class="row pie-charts"><div class="col-xs-3"><a href="" style="font-size: 72px"><img src="/assets/img/icons/Rations.svg" style="max-width: 70px !important"></a></div><div class="col-xs-9 description" style="padding: 10px 0px 0px 10px"><div class="row" style="margin-bottom: 10px"><div class="col-xs-8"><data-i18n i18n="_shortcut_ration_view_">View available Rations.</data-i18n></div><div style="padding: 0 !important" align="right" class="col-xs-4"><button style="margin-right: 15px; min-width: 60px" class="btn btn-primary btn-xs" ng-click="vm.redirect(\'rations.myrations\')"><data-i18n i18n="_btn_view_">View</data-i18n></button></div></div><div class="row"><div class="col-xs-8"><data-i18n i18n="_shortcut_ration_create_">Add new Ration.</data-i18n></div><div style="padding: 0 !important" align="right" class="col-xs-4"><button style="margin-right: 15px; min-width: 60px" class="btn btn-primary btn-xs" ng-click="vm.redirect(\'rations.addnewration\')"><data-i18n i18n="_btn_add_">Create</data-i18n></button></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/herdDefault.modal.html','<div class="modal-content"><div class="modal-header"><div ng-if="!vm.modalLoading"><div class="form-group"><ui-select ng-model="vm.modalSelectedHerd" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true"><ui-select-match placeholder="{{\'_search_placeholder_herd_name_\' | i18n}}">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="herd in vm.herdsToShow | filter: $select.search"><span ng-bind-html="herd.Name"></span></ui-select-choices></ui-select></div><div align="right"><button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button> <button type="submit" class="btn btn-info btn-with-icon save-profile" ng-click="vm.setDefaultHerd()"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/selectCalculation.modal.html','<div class="modal-content"><div class="modal-header"><div ng-if="!vm.defaultTeamLoading && !vm.defaultHerdLoading && !vm.modalLoading"><div class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12"><div class="form-group"><label><data-i18n i18n="_dashboard_calculation_type_">Energy measurement</data-i18n></label><ui-select style="z-index: 9000 !important" ng-model="vm.selectedCalculation" class="btn-group bootstrap-select form-control" ng-disabled="vm.loadingTable" append-to-body="true" search-enabled="true"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.defaultCalculationList | filter: $select.search"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div><div align="right"><button type="submit" class="btn btn-info btn-with-icon save-profile" ng-click="vm.saveDefaultCalculation()"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></div><div style="height: 200px" ng-if="vm.defaultTeamLoading || vm.defaultHerdLoading || vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/teamDefault.modal.html','<div class="modal-content"><div class="modal-header"><div ng-if="!vm.modalLoading"><div class="form-group"><ui-select ng-model="vm.modalSelectedTeam" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true"><ui-select-match placeholder="{{\'_search_placeholder_team_name_\' | i18n}}">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="team in vm.teams | filter: $select.search"><span ng-bind-html="team.Name"></span></ui-select-choices></ui-select></div><div align="right"><button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button> <button type="submit" class="btn btn-info btn-with-icon save-profile" ng-click="vm.setDefaultTeam()"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/login/login.modal.html','<div class="modal-content"><div class="modal-header"><div align="center"><span class="secondaryText">Please wait...</span></div></div><div class="modal-body"><div style="height: 200px" align="center"><div style="margin-top: 50px; overflow: hidden"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/login/token.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><div class="form-group has-feedback"><label>id_token</label> <input type="text" class="form-control" ng-model="lc.token"></div></div></div>');
$templateCache.put('app/pages/insights/addToReport.modal.html','<div><div class="modal-header" ng-if="!vm.addToReportModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.addToReportModalLoading"><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.modalComment"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.addToReport()"><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></button></div></div><div class="modal-body" ng-if="vm.addToReportModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div>');
$templateCache.put('app/pages/insights/custom.modal.html','<div><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-info pull-right" ng-click="vm.customTimeSelected()"><data-i18n i18n="_label_preview_">preview</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/insights/insights.html','<div class="widgets"><div class="row" ng-if="vm.selectedTeam"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll no-padding" ng-if="vm.showFrame"><div include-with-scope="app/pages/insights/insights.panel.html"></div></div><div ng-if="!vm.showFrame"><div include-with-scope="app/pages/insights/insights.panel.html"></div></div></div></div><div class="row" ng-if="!vm.selectedTeam"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll no-padding"><div><h3><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></h3></div></div></div></div></div>');
$templateCache.put('app/pages/insights/insights.panel.html','<div class="row" style="margin: 0px" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.showCreateReportBlock"><div class="dashboard-pills"><button ng-repeat="category in vm.allCategories" class="btn btn-sm" ng-class="vm.getBtnClass(category, $index)" ng-click="vm.categorySelected($index, category)" ng-if="category.used">{{category.name}}</button><div class="btn-group" style="display: inline-block; vertical-align: middle" ng-if="!vm.hideTiles && !vm.loadingError"><button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(1)" ng-class="vm.selectedLayout == 1 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th-list"></span></button> <button id="grid" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(2)" ng-class="vm.selectedLayout == 2 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th"></span></button></div></div></div><div class="horizontal-scroll" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.loadingError && !vm.showCreateReportBlock"><div ng-if="vm.selectedLayout == 2" include-with-scope="app/pages/insights/insights.tiles.html"></div><div ng-if="vm.selectedLayout == 1" include-with-scope="app/pages/insights/insights.table.html"></div></div><div ng-if="vm.loadingError && !vm.loadingBaseTable" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_toastr_error_occured_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_calendar_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div><div ng-if="vm.showFrame && !vm.showCreateReportBlock" class="dashboards-frame"><div style="text-align: right; padding: 5px 10px"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto; float: left;" ng-click="vm.openAddToReportModal(vm.lastUsedDashboard, vm.lastUsedDashboard.type)" ng-if="(vm.selectedHerd && vm.lastUsedDashboard && vm.lastUsedDashboard.addToReport && vm.showAddToReportButton && !vm.hideAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button><div>({{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}})</div></div><div id="frame" class="dashboard-wrapper" ng-if="!vm.errorLoading"></div><div class="dashboard-back-button" ng-style="vm.showBackButton && {\'display\': \'block\'}" ng-click="vm.goBack()"><img src="assets/img/back.png"></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_toastr_error_occured_" ng-if="!vm.dashboardNotAvailable">Error</data-i18n><data-i18n i18n="_message_error_dashboard_not_available_" ng-if="vm.dashboardNotAvailable">Dashboard not available</data-i18n></span> <button class="btn btn-primary" ng-click="vm.reload()" ng-if="!vm.dashboardNotAvailable"><span><data-i18n i18n="_calendar_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button> <button class="btn btn-primary" ng-click="vm.goBackOnClose()" ng-if="vm.dashboardNotAvailable"><span><data-i18n i18n="_label_close_">Close</data-i18n></span></button></div></div></div><div ng-if="vm.showCreateReportBlock"><div ba-panel="" ba-panel-class="with-scroll"><div class="ios-message" ng-if="vm.safariMobileUsed"><div class="info-icon"><i class="material-icons">info</i></div><div class="message"><data-i18n i18n="_ios_message_safari_"></data-i18n></div></div><div class="report-error-message" ng-if="vm.errorLoadingReports"><data-i18n i18n="_error_message_loading_reports_">There was an error loading reports</data-i18n></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError" class="report-page-header"><div class="input-group report-selector" ng-if="vm.multipleReports"><ui-select ng-model="vm.selectedReport" theme="selectize" class="select-tags" style="height:20px; width: 220px" on-select="vm.reportSelected()"><ui-select-match allow-clear="true"><span style="margin-right: 3px">Report</span>{{$select.selected.id }}</ui-select-match><ui-select-choices repeat="report in vm.availableReports track by report.id"><span style="margin-right: 3px">Report</span> {{report.id}}</ui-select-choices></ui-select></div><div class="date-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportDate" is-open="vm.reportDateOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-change="vm.setReportDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.reportDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><table class="table report-table"><thead><tr><th><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th class="time-period"><data-i18n i18n="_m_f_reports_time_period_">Time period</data-i18n></th><th style="text-align: center"><data-i18n i18n="_placeholder_comments_">Comments</data-i18n></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.reportDashboards"><td><div class="filter-checkbox" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="dashboard.selected = !dashboard.selected" ng-if="!dashboard.default"></div><div class="filter-checkbox color-red" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-if="dashboard.default"></div></td><td>{{dashboard.title}}</td><td class="time-period row" ng-click="vm.openReportDashboardPeriodModal($index)">{{dashboard.start_date | date:\'shortDate\'}} - {{dashboard.end_date | date:\'shortDate\'}}</td>{{dashboard.report_date | date:\'shortDate\'}}<td class="comment" ng-click="vm.openReportCommentModal($index)">{{dashboard.comment}}</td></tr></tbody></table></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><div class="form-group"><label for="title"><data-i18n i18n="_report_title_">Report title</data-i18n></label> <input type="text" class="form-control" id="title" name="title" placeholder="{{\'_dashboard_name_spp_actual_\' | i18n}}" ng-model="vm.report_title" maxlength="40"></div><div class="form-group"><label><data-i18n i18n="_report_positive_points_">Positive points</data-i18n>:</label> <textarea placeholder="{{\'_report_positive_points_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.positivePoints" maxlength="700" onkeydown="(event.keyCode!=13);"></textarea></div><div class="form-group"><label><data-i18n i18n="_report_points_to_improve_">Points to improve</data-i18n>:</label> <textarea placeholder="{{\'_report_points_to_improve_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.pointsToImprove" maxlength="700" onkeydown="(event.keyCode!=13);"></textarea></div><div><button class="btn btn-success" ng-click="vm.setReportData()" style="float: right"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div><button class="btn btn-danger" ng-click="vm.closeCreateReport()" style="float: right; margin-right: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.reportLoading" style="text-align: center; height: 200px;"><div id="loading-animation-large"></div></div><div ng-if="vm.pdfLoading" style="text-align: center"><span><data-i18n i18n="_report_create_message_">Please wait while the document is being prepared</data-i18n></span><div style="width: 25px; display: inline-block; text-align: left">{{vm.loadingDots}}</div></div><div ng-if="vm.herdNotSelected"><span class="color-red"><data-i18n i18n="_dashboard_default_herd_not_defined_">Select one herd</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><span class="color-red"><data-i18n i18n="_toastr_error_occured_">Error occurred, please try again.</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><button class="btn btn-primary" style="line-height: 1px" ng-click="vm.openCreateReport()"><i class="material-icons">replay</i></button></div></div></div><div style="text-align: center" ng-if="vm.loadingBaseTable && !vm.showFrame"><div id="loading-animation-large"></div></div>');
$templateCache.put('app/pages/insights/insights.table.html','<table class="table table-limitless dashboards-table" st-table="vm.dashboards" st-safe-src="vm.dashboardsSafe" ng-class="vm.getTableClass()"><thead><tr class="sortable"><th st-sort="category.name"><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th st-sort="title"><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th st-sort="" style="text-align: center;"><data-i18n i18n="_title_column_action_">Action</data-i18n></th></tr><tr><th></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th style="text-align: right;"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerd)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.dashboards"><td style="text-align: left"><span class="info-label" ng-class="[vm.getLabelId(dashboard), vm.activeCategory == $index ? \'btn-info\' : \'\']">{{dashboard.category.name}}</span></td><td>{{dashboard.title}}</td><td style="text-align: right;"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)">{{\'_label_preview_\' | i18n}}</button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerd && dashboard.addToReport)">{{\'_report_add_to_report_\' | i18n}}</button></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-template="app/pages/insights/pagination.html" st-pagination="" st-items-by-page="vm.itemsPerPage.value" st-displayed-pages="5"></div><div style="float: right" class="table-select-number-wraper"><label><span><data-i18n i18n="_label_show_">Show</data-i18n>:</span><select class="form-control selectpicker show-tick dropup" selectpicker="" title="" ng-model="vm.itemsPerPage" ng-options="i.label for i in vm.itemsToShow"></select></label></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/insights/insights.tiles.html','<table class="table table-limitless dashboards-table"><thead><tr><th style="width: 120px;"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th style="text-align: right; width: 120px;"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerd)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead></table><div ng-repeat="dashboard in vm.dashboardsSafe" class="dashboards-tile-wrapper clearfix"><div class="dashboard-thumbnail image-canvas" ng-class="vm.getDashboardClass(dashboard)" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)"><img src="assets/img/thumbnails/thumbnail.png" lazy-img="{{dashboard.thumbnail}}" lazy-img-error="assets/img/thumbnails/thumbnail.png"></div><div class="dashboard-title">{{dashboard.title}}</div><div class="dashboard-action"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerd && dashboard.addToReport)">{{\'_report_add_to_report_\' | i18n}}</button></div></div>');
$templateCache.put('app/pages/insights/pagination.html','<div class="pagination" ng-if="pages.length >= 2"><ul class="pagination"><li ng-if="currentPage > 1"><a ng-click="selectPage(1)">&lt;&lt;</a></li><li ng-if="currentPage > 1"><a ng-click="selectPage(currentPage-1)">&lt;</a></li><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a ng-click="selectPage(page)">{{page}}</a></li><li ng-if="currentPage < numPages"><a ng-click="selectPage(currentPage+1)"></a></li><li ng-if="currentPage < numPages"><a ng-click="selectPage(numPages)"></a></li></ul></div>');
$templateCache.put('app/pages/insights/reportComment.modal.html','<div><div class="modal-header" ng-if="!vm.addCommentModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.addCommentModalLoading"><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.selectedReportDashboard.comment"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setReportDashboardComment()"><data-i18n i18n="_report_set_">Set</data-i18n></button></div></div><div class="modal-body" ng-if="vm.addCommentModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div>');
$templateCache.put('app/pages/insights/reportRangeSelector.modal.html','<div><div class="modal-header" ng-if="!vm.setRangeModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.setRangeModalLoading"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-disabled="vm.selectedReportDashboard.actual"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.selectedReportDashboard.actual"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setReportDashboardRange()"><data-i18n i18n="_report_set_">Set</data-i18n></button></div></div><div class="modal-body" ng-if="vm.setRangeModalLoading"><div class="loading-spinner"><div class="loading-animation"></div></div></div></div>');
$templateCache.put('app/pages/rap/addToReport.modal.html','<div><div class="modal-header" ng-if="!vm.addToReportModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.addToReportModalLoading"><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.modalComment"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.addToReport()"><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></button></div></div><div class="modal-body" ng-if="vm.addToReportModalLoading"><div style="text-align: center; height: 182px"><div id="loading-animation-large" style="margin-top: 70px"></div></div></div></div>');
$templateCache.put('app/pages/rap/datePeriodMessage.modal.html','<div><div class="modal-body" style="height: 120px"><div><span><data-i18n i18n="_date_period_message_">Last milk date is before selected last date, because of that selected last date will be automatically set to last milk date.</data-i18n></span></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.closeModal()">OK</button></div></div></div>');
$templateCache.put('app/pages/rap/daySelector.modal.html','<div><div class="modal-header" ng-if="!vm.setDateModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.setDateModalLoading"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_dashboard_name_parameter_date_">Date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.setActualReportDate()"><data-i18n i18n="_label_preview_">preview</data-i18n></button></div></div><div class="modal-body" ng-if="vm.setDateModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div>');
$templateCache.put('app/pages/rap/rangeSelector.modal.html','<div><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.modal_start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-disabled="vm.actualDashboardOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.actualDashboardOpen"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.modal_end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setRange()"><data-i18n i18n="_label_preview_">preview</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/rap/rap.html','<div class="row" ng-if="vm.selectedHerd"><div class="col-xs-12" ng-hide="vm.showCreateReportBlock"><div ba-panel="" ba-panel-class="with-scroll" style="height: auto" id="panel-map"><div style="text-align: right"><div style="text-align: right; margin-bottom: 5px" ng-hide="vm.loadingDashboards || vm.noAvailableDashboards || vm.errorLoading"><div style="display: inline-block; vertical-align: bottom; margin-right: 5px" ng-if="!vm.showCreateReportButton"><button class="btn btn-primary" ng-click="vm.openAddToReportModal()" ng-disabled="!vm.selectedHerd || vm.disableAddToReport" ng-show="vm.showAddToReportButton"><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></button></div><div style="display: inline-block; vertical-align: bottom; margin-right: 5px" ng-if="vm.showCreateReportButton"><button class="btn btn-primary" ng-click="vm.openCreateReport()" ng-disabled="!vm.selectedHerd"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div class="dashboard-range-selector" style="display: inline-block; vertical-align: bottom"><div class="range-selector-block selector-dates">{{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}}</div><div class="range-selector-block selector-icon"><i class="fa fa-calendar" aria-hidden="true" ng-click="vm.openRangeSelector()" ng-class="vm.disableRangeSelector ? \'disabled\': \'\'"></i></div><div class="message-block" ng-if="vm.showDPMessage"><div><data-i18n i18n="_date_period_message_">Last milk date is before selected last date, because of that selected last date will be automatically set to last milk date.</data-i18n></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.showDPMessage = false">OK</button></div></div><div class="message-block-arrow" ng-if="vm.showDPMessage"></div></div></div><div><div ng-if="vm.reselectTeamError"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.errorLoading"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center"><span class="color-red" style="margin-bottom: 10px"><data-i18n i18n="_toastr_error_occured_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_calendar_reload_">Reload</data-i18n></span> <span class="material-icons" style="vertical-align: text-bottom; font-size: 19px">refresh</span></button></div></div><div ng-if="vm.noAvailableDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden"><div id="loading-animation-large"></div></div><div id="rapFrame" class="dashboard-wrapper-rap" ng-if="!vm.loadingDashboards && !vm.errorLoading"><div ng-if="vm.showActualCurrentDateMessage" class="day-filter-info"><div class="close-button" ng-click="vm.showActualCurrentDateMessage = false"><span class="material-icons">close</span></div><div><data-i18n i18n="_rap_day_filter_message_">Showing data for</data-i18n>:</div><div ng-if="vm.actualFilterValue.type == 1">{{vm.actualFilterValue.day | date:\'shortDate\'}}</div><div ng-if="vm.actualFilterValue.type == 2"><data-i18n i18n="_animal_dim_">DIM</data-i18n>:<span style="margin-left: 3px">{{vm.actualFilterValue.dim }}</span></div><div ng-if="vm.actualFilterValue.type == 2"><data-i18n i18n="_dashboard_name_filter_parity_">Parity</data-i18n>:<span style="margin-left: 3px">{{vm.actualFilterValue.parity }}</span></div></div><div class="missing-data-info-message" ng-if="vm.showMissingDataMessage"><div><div class="icon"><span class="fa fa-info-circle"></span></div><div class="text"><div style="margin-bottom: 10px"><data-i18n i18n="_rap_missing_data_message_">Some data is missing for selected herd. Columns with data missing</data-i18n>:</div><ul style="text-align: left"><li ng-repeat="item in vm.missingDataColumns">{{item}}</li></ul></div></div><div style="margin-top: 5px; padding: 5px"><div class="do-not-show-again" ng-click="vm.doNotShowAgain = !vm.doNotShowAgain"><span class="check-box" ng-class="vm.doNotShowAgain ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"></span><datai-i18n i18n="_label_do_not_show_again_">Do not show again</datai-i18n><span></span></div><button class="btn btn-xs btn-info pull-right" ng-click="vm.hideMissingDataMessage()">Ok</button></div></div></div></div></div></div></div><div ng-if="vm.showCreateReportBlock" class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll"><div class="ios-message" ng-if="vm.safariMobileUsed"><div class="info-icon"><i class="material-icons">info</i></div><div class="message"><data-i18n i18n="_ios_message_safari_"></data-i18n></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError" class="report-page-header"><div class="input-group report-selector" ng-if="vm.multipleReports"><ui-select ng-model="vm.selectedReport" theme="selectize" class="select-tags" style="height: 20px; width: 220px" on-select="vm.reportSelected()"><ui-select-match allow-clear="true"><span style="margin-right: 3px">Report</span>{{$select.selected.id }}</ui-select-match><ui-select-choices repeat="report in vm.availableReports track by report.id"><span style="margin-right: 3px">Report</span> {{report.id}}</ui-select-choices></ui-select></div><div class="date-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportDate" is-open="vm.reportDateOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-change="vm.setReportDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.reportDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><table class="table report-table"><thead><tr><th><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th class="time-period"><data-i18n i18n="_m_f_reports_time_period_">Time period</data-i18n></th><th style="text-align: center"><data-i18n i18n="_placeholder_comments_">Comments</data-i18n></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.reportDashboards"><td><div class="filter-checkbox" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="dashboard.selected = !dashboard.selected" ng-if="!dashboard.default"></div><div class="filter-checkbox color-red" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-if="dashboard.default"></div></td><td>{{dashboard.description}}</td><td class="time-period row" ng-click="vm.openReportDashboardPeriodModal($index)" ng-if="vm.showStartEndDate(dashboard)">{{dashboard.start_date | date:\'shortDate\'}} - {{dashboard.end_date | date:\'shortDate\'}}</td><td class="time-period row" ng-click="vm.openReportDashboardDayModal($index)" ng-if="!vm.showStartEndDate(dashboard)">{{dashboard.report_date | date:\'shortDate\'}}</td><td class="comment" ng-click="vm.openReportCommentModal($index)">{{dashboard.comment}}</td></tr></tbody></table></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><div class="form-group"><label><data-i18n i18n="_report_positive_points_">Positive points</data-i18n>:</label> <textarea placeholder="{{\'_report_positive_points_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.positivePoints"></textarea></div><div class="form-group"><label><data-i18n i18n="_report_points_to_improve_">Points to improve</data-i18n>:</label> <textarea placeholder="{{\'_report_points_to_improve_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.pointsToImprove"></textarea></div><div><button class="btn btn-success" ng-click="vm.setReportData()" style="float: right"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div><button class="btn btn-danger" ng-click="vm.closeCreateReport()" style="float: right; margin-right: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.reportLoading" style="text-align: center; overflow: hidden"><div id="loading-animation-large"></div></div><div ng-if="vm.pdfLoading" style="text-align: center"><span><data-i18n i18n="_report_create_message_">Please wait while the document is being prepared</data-i18n></span><div style="width: 25px; display: inline-block; text-align: left">{{vm.loadingDots}}</div></div><div ng-if="vm.herdNotSelected"><span class="color-red"><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><span class="color-red"><data-i18n i18n="_toastr_error_occured_">Error occurred, please try again.</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><button class="btn btn-primary" style="line-height: 1px" ng-click="vm.openCreateReport()"><i class="material-icons">replay</i></button></div></div></div></div><div ng-if="!vm.selectedHerd"><div ba-panel=""><data-i18n i18n="_tips_group_selector_">Herd has to be selected</data-i18n></div></div>');
$templateCache.put('app/pages/rap/reportComment.modal.html','<div><div class="modal-header" ng-if="!vm.addCommentModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.addCommentModalLoading"><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.selectedReportDashboard.comment"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setReportDashboardComment()"><data-i18n i18n="_btn_add_">Add</data-i18n></button></div></div><div class="modal-body" ng-if="vm.addCommentModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div>');
$templateCache.put('app/pages/rap/reportRangeSelector.modal.html','<div><div class="modal-header" ng-if="!vm.setRangeModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.setRangeModalLoading"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-disabled="vm.selectedReportDashboard.actual"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.selectedReportDashboard.actual"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setReportDashboardRange()"><data-i18n i18n="_label_preview_">preview</data-i18n></button></div></div><div class="modal-body" ng-if="vm.setRangeModalLoading"><div class="loading-spinner"><div class="loading-animation"></div></div></div></div>');
$templateCache.put('app/pages/recipes/feedingDatepicker.modal.html','<div><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><form name="vm.datePickerForm"><label><data-i18n i18n="_m_f_recipe_choose_feeding_time_">When do you want to start feeding this recipe?</data-i18n></label><div class="input-group form-group has-feedback" ng-class="{\'has-error\': vm.datePickerForm.recipe_start_feeding_time.$invalid && (vm.datePickerForm.recipe_start_feeding_time.$dirty || vm.datePickerForm.$submitted)}"><input class="form-control" id="recipe_start_feeding_time" name="recipe_start_feeding_time" placeholder="--:-- --" ng-model="vm.startDate" ng-model-options="{allowInvalid: true, updateOn: \'blur\'}" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" moment-picker="vm.startDate" min-view="month" max-view="minute" min-date="vm.today" ng-model="vm.startTime" format="YYYY-MM-DD hh:mm A" locale="{{vm.locale}}" ng-model-options="{ updateOn: \'blur\' }"><i class="glyphicon glyphicon-time"></i></button></span></div><div style="height: 20px; margin-top: 10px"><button ng-if="!vm.myRecipesPage" style="float: right" class="btn btn-xs btn-success" ng-disabled="vm.datePickerForm.$invalid" ng-click="vm.saveRecipe(true);$dismiss()"><data-i18n i18n="_btn_save_">save</data-i18n></button> <button ng-if="vm.myRecipesPage" style="float: right" class="btn btn-xs btn-success" ng-disabled="vm.datePickerForm.$invalid" ng-click="vm.changeRecipeActive(vm.datepickerIndex, true);$dismiss()"><data-i18n i18n="_btn_save_">save</data-i18n></button></div></form></div></div>');
$templateCache.put('app/pages/recipes/feedingTime.popover.html','<div style="margin: 5px 0" class="feeding-time-picker" ng-if="vm.datepickerDisplay.feeding_1"><div><data-i18n i18n="_m_f_pen_morning_feeding_short_">Morning</data-i18n></div><div class="form-group time-picker-wrapper"><div uib-timepicker="" ng-model="pen.feeding_1" hour-step="1" minute-step="15" show-meridian="true" ng-change="vm.checkValidation(pen, \'feeding_1\')"></div></div><div align="center" class="warningModal" ng-if="vm.timepickerDisable"><data-i18n i18n="_m_f_recipe_time_not_vaild_">time is not valid</data-i18n></div></div><div style="margin: 5px 0" class="feeding-time-picker" ng-if="vm.datepickerDisplay.feeding_2"><div><data-i18n i18n="_m_f_pen_noon_feeding_short_">Noon</data-i18n></div><div class="form-group time-picker-wrapper"><div uib-timepicker="" ng-model="pen.feeding_2" hour-step="1" minute-step="15" show-meridian="true" ng-change="vm.checkValidation(pen, \'feeding_2\')"></div></div><div align="center" class="warningModal" ng-if="vm.timepickerDisable"><data-i18n i18n="_m_f_recipe_time_not_vaild_">time is not valid</data-i18n></div></div><div style="margin: 5px 0" class="feeding-time-picker" ng-if="vm.datepickerDisplay.feeding_3"><div><data-i18n i18n="_m_f_pen_evening_feeding_short_">Evening</data-i18n></div><div class="form-group time-picker-wrapper"><div uib-timepicker="" ng-model="pen.feeding_3" hour-step="1" minute-step="15" show-meridian="true" ng-change="vm.checkValidation(pen, \'feeding_3\')"></div></div><div align="center" class="warningModal" ng-if="vm.timepickerDisable"><data-i18n i18n="_m_f_recipe_time_not_vaild_">time is not valid</data-i18n></div></div>');
$templateCache.put('app/pages/recipes/mixingTimeSelector.modal.html','<div class="modal-header"><h4 class="modal-title"><data-i18n i18n="_m_f_recipe_select_mixing_time_">Select Mixing Time</data-i18n></h4><button type="button" class="close" ng-click="$dismiss()" aria-label="{{ \'_label_close_\' | i18n }}"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><form name="mixingTimeForm"><div class="form-group"><label for="minutes"><data-i18n i18n="_unit_minutes_">Minutes</data-i18n></label><select id="minutes" class="form-control" ng-model="vm.mixingTime.minutes" ng-options="minute as minute for minute in vm.getMinutes() track by minute"><option value=""><data-i18n i18n="_m_f_recipe_mixing_time_select_">-- Select --</data-i18n></option></select></div><div class="form-group" style="margin-bottom: 0;"><span class="newCheck"><input type="checkbox" id="mixing_time_set_to_all" ng-true-value="true" ng-false-value="false" ng-model="vm.mixingTimeData.set_to_all"> <label for="mixing_time_set_to_all"></label></span> <label for="mixing_time_set_to_all" style="font-weight: 400; margin-left: 6px;"><data-i18n i18n="_m_f_recipe_mixing_time_set_to_all_">Set to all</data-i18n></label></div></form></div><div class="modal-footer"><button type="button" class="btn btn-secondary" ng-click="$dismiss()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button> <button type="button" class="btn btn-primary" ng-click="vm.saveMixingTime()"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div>');
$templateCache.put('app/pages/recipes/weekOverview.modal.html','<div class="overview-mixing-panel"><div ng-if="!vm.loadingWeekModal" class="modal-content" ng-cloak=""><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><table class="table week-overview-table" st-table="vm.recipe.pens" ng-if="vm.schedulerOverviewData.length"><tbody><tr ng-repeat-start="day in vm.schedulerOverviewData" ng-if="day.pens.length" class="date-header primaryModal"><td colspan="4">{{day.date | date:\'mediumDate\'}}</td></tr><tr ng-repeat-end="" ng-if="day.pens.length"><td><table class="table"><thead><th style="font-weight: bold"><data-i18n i18n="_m_f_menu_pens_">Pens</data-i18n></th></thead><tbody><tr ng-repeat="pen in day.pens"><td>{{pen.pen_name}}&nbsp;({{pen.amount_as_fed ? pen.amount_as_fed : pen.total_as_fed | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}})</td></tr></tbody></table></td><td ng-if="day.feeding_1_sum"><table class="table"><thead><tr><th colspan="3" class="text-primary"><data-i18n i18n="_m_f_recipe_feeding_">Feeding</data-i18n>&nbsp;1&nbsp;({{day.feeding_1_sum | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}})</th></tr></thead><tbody><tr ng-repeat="load in day.feeding_1_loads.loads"><td><data-i18n i18n="_m_f_recipe_load_">Load</data-i18n>&nbsp;{{$index+1}}&nbsp;</td><td>{{load.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</td><td uib-tooltip="{{load.wagon.name}}" tooltip-enable="{{load.wagon.name.length > 30 ? true : false}}" tooltip-is-open="wagonNameOpen" tooltip-placement="left" tooltip-class="customBlue left wrap-text" tooltip-popup-delay="500"><div class="wagon-name-md">{{load.wagon.name}}</div></td></tr></tbody></table></td><td ng-if="day.feeding_2_sum"><table class="table"><thead><tr><th colspan="3" class="text-primary"><data-i18n i18n="_m_f_recipe_feeding_">Feeding</data-i18n>&nbsp;2&nbsp;({{day.feeding_2_sum | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}})</th></tr></thead><tbody><tr ng-repeat="load in day.feeding_2_loads.loads"><td><data-i18n i18n="_m_f_recipe_load_">Load</data-i18n>&nbsp;{{$index+1}}&nbsp;</td><td>{{load.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</td><td uib-tooltip="{{load.wagon.name}}" tooltip-enable="{{load.wagon.name.length > 30 ? true : false}}" tooltip-is-open="wagonNameOpen" tooltip-placement="left" tooltip-class="customBlue left wrap-text" tooltip-popup-delay="500"><div class="wagon-name-md">{{load.wagon.name}}</div></td></tr></tbody></table></td><td ng-if="day.feeding_3_sum"><table class="table"><thead><tr><th colspan="3" class="text-primary"><data-i18n i18n="_m_f_recipe_feeding_">Feeding</data-i18n>&nbsp;3&nbsp;({{day.feeding_3_sum | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}})</th></tr></thead><tbody><tr ng-repeat="load in day.feeding_3_loads.loads"><td><data-i18n i18n="_m_f_recipe_load_">Load</data-i18n>&nbsp;{{$index+1}}&nbsp;</td><td>{{load.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</td><td uib-tooltip="{{load.wagon.name}}" tooltip-enable="{{load.wagon.name.length > 30 ? true : false}}" tooltip-is-open="wagonNameOpen" tooltip-placement="left" tooltip-class="customBlue left wrap-text" tooltip-popup-delay="500"><div class="wagon-name-md">{{load.wagon.name}}</div></td></tr></tbody></table></td></tr></tbody></table><table ng-if="!vm.schedulerOverviewData.length" class="table"><tr><td><data-i18n i18n="_label_no_feedings_week_">No scheduled feedings this week</data-i18n></td></tr></table></div></div><div ng-if="vm.loadingWeekModal" align="center" style="overflow: hidden"><div><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/settings/settings.html','<div ba-panel="" ba-panel-class="profile-page"><div ng-if="!vm.loading"><div class="panel-content"><h3 class="with-line"><data-i18n i18n="_settings_general_settings_title_">General Settings</data-i18n></h3><div class="row"><div class="col-xlg-3 col-lg-3 col-md-3 col-sm-6"><div class="form-group"><label><data-i18n i18n="_settings_weight_measurement_title_">Weight measurement</data-i18n></label><div><toggle-switch ng-model="vm.settings.use_kgs" on-label="kg" off-label="lb" class="switch-primary" style="width: 120px"></toggle-switch></div></div></div><div class="col-xlg-3 col-lg-3 col-md-3 col-sm-6"><div class="form-group"><label><data-i18n i18n="_settings_energy_measurement_title_">Energy measurement</data-i18n></label><div><toggle-switch ng-model="vm.settings.use_mcal" on-label="Mcal" off-label="Mjoule" class="switch-primary" style="width: 120px"></toggle-switch></div></div></div><div class="col-xlg-3 col-lg-3 col-md-3 col-sm-6"><div class="form-group"><label><data-i18n i18n="_report_unit_">Unit</data-i18n></label><div><toggle-switch ng-model="vm.settings.use_percent" on-label="%" off-label="g/{{vm.weight}}" class="switch-primary" style="width: 120px"></toggle-switch></div></div></div></div><h3 class="with-line"><data-i18n i18n="_settings_user_settings_title_">User Settings</data-i18n></h3><div class="row"><div class="col-xlg-4 col-lg-4 col-md-4 col-sm-6"><div class="form-group"><label ng-click="vm.openTranslate($event)"><data-i18n i18n="_settings_localization_title_">Localization</data-i18n></label><ui-select ng-model="vm.currentLanguage" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="{{\'_picker_language_placeholder_\'|i18n}}"><span><img ng-src="{{$select.selected.image | flagImg}}"> {{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="language in vm.languages | filter: $select.search"><img ng-src="{{language.image | flagImg}}"> <span ng-bind-html="language.name"></span></ui-select-choices></ui-select></div></div><div class="col-xlg-4 col-lg-4 col-md-4 col-sm-6"><div class="form-group"><label><data-i18n i18n="_settings_calculation_type_title_">Energy measurement</data-i18n></label><ui-select ng-model="vm.selectedCalculation" class="btn-group bootstrap-select form-control" ng-disabled="vm.loadingTable" append-to-body="true" search-enabled="true"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.defaultCalculationList | filter: $select.search"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div><div class="settings-ver-info"><button type="button" class="btn btn-info btn-with-icon save-profile" ng-click="vm.save()"><i class="ion-android-checkmark-circle"></i><data-i18n i18n="_btn_save_">Save</data-i18n></button><div><label class="info-note" ng-if="vm.version">{{vm.version}}</label><br><label class="info-note" ng-if="vm.database">{{vm.database}}</label><br><label class="info-note" ng-if="vm.buildDate">{{\'_current_build_date_info_\' | i18n}}: {{vm.buildDate}}</label><br><label class="info-note"><a href="https://flagpedia.net" target="_blank">Icons by flagpedia</a></label></div></div></div></div><div ng-if="vm.loading" align="center"><div style="overflow: hidden"><div id="loading-animation-large" style="display: inline-block"></div></div></div></div>');
$templateCache.put('app/pages/calendar/feedingTable/amountChanged.popover.html','<div ng-if="ft.popoverType === \'load\'"><data i18n="_m_f_calendar_load_changed_">Load changed</data>:&nbsp;{{ft.popoverModel | number: 0}}</div><div ng-if="ft.popoverType === \'drop\'"><data i18n="_m_f_calendar_load_changed_">Load changed</data>:&nbsp;{{ft.popoverModel}}</div><div ng-if="ft.popoverType === \'load-date\'"><data i18n="_m_f_calendar_load_date_warning_">This load was not loaded on</data>&nbsp;{{ft.popoverModel}}</div><div ng-if="ft.popoverType === \'drop-date\'"><data i18n="_m_f_calendar_unload_date_warning_">This load was not unloaded on</data>&nbsp;{{ft.popoverModel}}</div>');
$templateCache.put('app/pages/calendar/feedingTable/confirmation.modal.html','<div class="modal-content"><div class="modal-header"><div align="center"><span class="ion-android-warning warningModal" style="font-size: 36px"></span></div><div align="center"><span class="warningModal"><data-i18n ng-show="ft.modalType === \'delete\'" i18n="_m_f_calendar_delete_feeding_">Warning message</data-i18n><data-i18n ng-show="ft.modalType === \'delete_pen_load\' || ft.modalType === \'delete_load\'" i18n="_m_f_calendar_remove_pen_load_message_">Warning message</data-i18n><data-i18n ng-show="ft.modalType === \'delete_ingredient\'" i18n="_m_f_calendar_remove_ingredient_message_">Warning message</data-i18n></span></div></div><div class="modal-body"><div align="center"><button type="button" class="btn btn-primary" ng-click="ft.confirm()"><data-i18n i18n="_btn_continue_">Continue</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="ft.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/calendar/feedingTable/datetimePicker.modal.html','<div class="modal-content"><div class="modal-body"><div class="row"><div class="col-md-6 calendar-datetime-picker-wrapper"><h4><span ng-class="ft[ft.modalType].start_date_error ? \'validation-error-text-color\' : \'\'"><data i18n="_label_start_date_">Start date</data>:&nbsp;{{(ft.modalStartDate | date: ft.dateFormat) || (\'_m_f_calendar_invalid_date_label_\' | i18n)}}</span></h4><div class="calendar-validation-container" ng-class="ft[ft.modalType].start_date_error ? \'calendar-error\' : \'\'"><div uib-datepicker="" ng-model="ft.modalStartDate" ng-change="ft.checkDateValidation(ft.modalType)"></div><div uib-timepicker="" ng-model="ft.modalStartDate" ng-change="ft.checkDateValidation(ft.modalType)" hour-step="1" minute-step="15" show-meridian="true"></div></div></div><div class="col-md-6 calendar-datetime-picker-wrapper"><h4><span ng-class="ft[ft.modalType].end_date_error ? \'validation-error-text-color\' : \'\'"><data i18n="_label_end_date_">End date</data>:&nbsp;{{(ft.modalEndDate | date: ft.dateFormat) || (\'_m_f_calendar_invalid_date_label_\' | i18n)}}</span></h4><div class="calendar-validation-container" ng-class="ft[ft.modalType].end_date_error ? \'calendar-error\' : \'\'"><div uib-datepicker="" ng-model="ft.modalEndDate" ng-change="ft.checkDateValidation(ft.modalType)"></div><div uib-timepicker="" ng-model="ft.modalEndDate" ng-change="ft.checkDateValidation(ft.modalType)" hour-step="1" minute-step="15" show-meridian="true"></div></div></div></div><div class="row"><div class="col-md-6"><div class="calendar-error-text" ng-class="ft[ft.modalType].start_date_error ? \'calendar-error\' : \'\'"><data-i18n i18n="_m_f_calendar_start_date_error_">Invalid start date</data-i18n></div></div><div class="col-md-6"><div class="calendar-error-text" ng-class="ft[ft.modalType].end_date_error ? \'calendar-error\' : \'\'"><data-i18n i18n="_m_f_calendar_end_date_error_">Invalid end date (must be after start date)</data-i18n></div></div></div><div align="right"><button type="button" class="btn btn-success" ng-click="ft.confirm()" ng-disabled="ft[ft.modalType].start_date_error || ft[ft.modalType].end_date_error"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="ft.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/calendar/feedingTable/feedingNotAvailable.html','<div align="center"><h1><data i18n="_m_f_calendar_no_available_feeding_">No available data for selected day</data></h1></div>');
$templateCache.put('app/pages/calendar/feedingTable/insertData.modal.html','<div ba-panel="" class="ng-cloak calendar-missing-data-modal"><div class="panel-group" ng-if="!vm.modalLoading"><div class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-title="{{ft.modalTitle}}" ba-panel-class="with-scroll xmedium-panel"><div include-with-scope="app/pages/calendar/feedingTable/tables/insertData.table.html"></div></div></div></div><div class="row" align="right"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><button ng-if="ft.modalType === \'loading\'" class="btn btn-md btn-primary" ng-click="ft.updateLoadReport(ft.selectedRow, null, null, \'add_ingredient\')"><data-i18n i18n="_btn_feed_add_selected_">Add selected</data-i18n></button> <button ng-if="ft.modalType === \'dropping\'" class="btn btn-md btn-primary" ng-click="ft.updatePenReport(ft.selectedRow, null, null, \'add_unload\')"><data-i18n i18n="_btn_feed_add_selected_">Add selected</data-i18n></button> <button class="btn btn-md btn-danger" ng-click="$dismiss()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div></div></div><div style="height: 200px; overflow: hidden" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/calendar/feedingTable/mixingTimeDeviation.popover.html','<div ng-if="load.mixing_time > load.actual_mixing_time">{{\'_m_f_calendar_mixing_time_shorter_than_specified_\' | i18n}} ({{\'_m_f_calendar_planned_\' | i18n}}: {{load.mixing_time | time}}, {{\'_m_f_calendar_actual_\' | i18n}}: {{load.actual_mixing_time | time}})</div><div ng-if="load.actual_mixing_time > load.mixing_time">{{\'_m_f_calendar_mixing_time_longer_than_specified_\' | i18n}} ({{\'_m_f_calendar_planned_\' | i18n}}: {{load.mixing_time | time}}, {{\'_m_f_calendar_actual_\' | i18n}}: {{load.actual_mixing_time | time}})</div>');
$templateCache.put('app/pages/calendar/feedingTable/recipeOverview.panel.html','<div class="calendar-recipe-overview"><div class="sticky-navigation-panel"><div class="navigation-panel"><div class="navigation-panel-body"><div class="navigation-button navigation-button-prev"><button ng-disabled="vm.loadingPreview" ng-click="vm.goToFeeding(\'prev\')" uib-tooltip="{{\'_m_f_calendar_previous_date_tooltip_\' | i18n}}" tooltip-is-open="previousDayIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-opaque" tooltip-popup-delay="500"><i class="fa fa-arrow-circle-o-left" aria-hidden="true"></i></button></div><div></div><div class="navigation-panel-text"><label>{{vm.selectedRecipe.recipe_name}}</label> <label>{{vm.selectedRecipe.feeding_date}}</label></div><div class="navigation-button report-options"><button ng-disabled="vm.loadingPreview" ng-show="!vm.hideNavButtons && (vm.displayButtons === 1 || vm.displayButtons === 3)" ng-click="vm.goToLoadingGraph()" uib-tooltip="{{\'_m_f_calendar_loading_graph_tooltip_\' | i18n}}" tooltip-is-open="goToLoadingGraphIsOpen" tooltip-placement="bottom" tooltip-class="customBlue bottom" tooltip-popup-delay="500" style="margin-top: 3px"><i class="fa fa-line-chart" aria-hidden="true"></i></button> <button ng-disabled="vm.loadingPreview" ng-show="vm.displayButtons === 2 || vm.displayButtons === 3" ng-click="vm.changeReportType(\'to_loading\')" uib-tooltip="{{\'_m_f_calendar_loading_report_tooltip_\' | i18n}}" tooltip-is-open="goToLoadingIsOpen" tooltip-placement="bottom" tooltip-class="customBlue bottom" tooltip-popup-delay="500"><i class="fa fa-sign-in fa-icon-rotate-90" aria-hidden="true"></i></button> <button ng-disabled="vm.loadingPreview" ng-show="!vm.hideNavButtons && (vm.displayButtons === 1 || vm.displayButtons === 3)" ng-click="vm.changeReportType(\'to_dropping\')" uib-tooltip="{{\'_m_f_calendar_dropping_report_tooltip_\' | i18n}}" tooltip-is-open="goToDroppingIsOpen" tooltip-placement="bottom" tooltip-class="customBlue bottom" tooltip-popup-delay="500" style="margin-top: 3px"><i class="fa fa-sign-out fa-icon-rotate-90" aria-hidden="true"></i></button> <button ng-disabled="vm.loadingPreview || !vm.feedingsList[0].recipe_visible" ng-style="!vm.feedingsList[0].recipe_visible ? {\'opacity\': \'0.5\', \'cursor\': \'not-allowed\'} : {}" ng-show="!vm.hideNavButtons" ng-click="vm.goToEdit(vm.feedingsList[0].is_premix, vm.feedingsList[0].recipe_id)"><i class="fa fa-pencil" aria-hidden="true" uib-tooltip="{{vm.feedingsList[0].recipe_visible ? (\'_m_f_calendar_edit_recipe_tooltip_\' | i18n) : !vm.feedingsList[0].recipe_visible ? (\'_m_f_calendar_edit_recipe_disabled_\' | i18n) : \'\'}}" tooltip-is-open="editRecipeIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"></i></button></div><div class="navigation-button navigation-button-next"><button ng-disabled="vm.loadingPreview" ng-click="vm.goToFeeding(\'next\')" uib-tooltip="{{\'_m_f_calendar_next_date_tooltip_\' | i18n}}" tooltip-is-open="nextDayIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-opaque" tooltip-popup-delay="500"><i class="fa fa-arrow-circle-o-right" aria-hidden="true"></i></button></div></div></div></div><div class="main-panel"><div ng-if="!vm.loadingPreview"><div class="calendar-info-header" ng-class="::vm.checkStickyHeader()"><div class="calendar-top-buttons"><div ng-if="vm.feedingsList && vm.feedingsList[0].recipe_id"><toggle-switch ng-model="vm.showCost" ng-change="vm.showCostChanged()" on-label="{{\'_label_on_\' | i18n}}" off-label="{{\'_label_off_\' | i18n}}" knob-label="{{\'_m_f_calendar_report_cost_\' | i18n}}" class="switch-primary" style="width: 120px"></toggle-switch></div><button ng-if="vm.feedingsList && vm.feedingsList[0].recipe_id" class="btn btn-md btn-success" ng-click="vm.saveChanges()" ng-disabled="!vm.updateList.length"><data i18n="_btn_save_">Save</data></button> <button class="btn btn-md btn-primary" ng-click="vm.cancelRecipeDetails()"><i class="ion-arrow-left-c"></i>&nbsp;<data i18n="_btn_back_">Back</data></button></div></div><div ng-repeat="feeding in vm.feedingsList | orderBy: \'feeding_number\'"><feeding-table feeding-table-data="feeding" feeding-table-url="feeding.url" report-type="vm.reportType" update-feeding="vm.updateFeeding(action, data)" delete-feeding="vm.deleteFeeding(feeding_number)" set-calendar-dirty="vm.setDirty()" redirect-id="vm.redirectId" show-cost="vm.showCost"></feeding-table></div></div><div ng-show="vm.loadingPreview" class="calendar-preview-spinner"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/configurations/equipment/equipment.html','<h1>equipment</h1>');
$templateCache.put('app/pages/configurations/locations/locations.html','<h1>locations</h1>');
$templateCache.put('app/pages/configurations/feeders/feeders.html','<h1>feeders</h1>');
$templateCache.put('app/pages/configurations/stock/stock.html','<h1>stock</h1>');
$templateCache.put('app/pages/feeds/addNewFeed/addNewFeed.html','<div ba-panel="" class="ng-cloak"><div class="panel-group" ng-if="!vm.loading && vm.selectedTeam"><div><div class="row"><div class="col-xlg-2 col-lg-4 col-md-4 col-sm-6 col-xs-4"><div class="form-group"><div ng-if="!vm.loading"><label><data-i18n i18n="_settings_calculation_type_title_">Select calculation type</data-i18n></label><ui-select ng-model="vm.selectedCalculation" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.defaultCalculationChanged()"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.defaultCalculationList | filter: $select.search" ui-disable-choice="vm.selectedCalculation.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div><div class="col-xlg-2 col-lg-4 col-md-4 col-sm-6 col-xs-4"><div class="form-group"><div ng-if="!vm.loading"><label><data-i18n i18n="_report_unit_">Unit</data-i18n></label><ui-select ng-model="vm.selectedUnit" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.changeUnit()"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type in vm.unitList | filter: $select.search" ui-disable-choice="vm.selectedUnit.name == type.name"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div></div></div><div class="col-xlg-8 col-lg-10 col-md-10 col-sm-12 col-xs-12" style="float: right"><div style="float: right"><button type="button" class="btn btn-primary" ng-click="vm.source(\'blank\')" ng-disabled="!vm.isTeamSelected" style="margin: 10px 0 0 10px"><data-i18n i18n="_btn_add_new_feed_blank_feed_">Blank feed</data-i18n></button> <button type="button" class="btn btn-primary" ng-click="vm.source(\'existing\')" ng-disabled="!vm.feedsLoaded || !vm.isTeamSelected" style="margin: 10px 0 0 10px"><data-i18n i18n="_btn_add_new_use_existing_"></data-i18n></button> <button type="button" class="btn btn-primary" ng-click="vm.importXml()" style="margin: 10px 0 0 10px"><data-i18n i18n="_btn_feed_import_xml_"></data-i18n></button></div></div></div></div><div ng-if="vm.showPicker"><div include-with-scope="app/pages/feeds/addNewFeed/useExisting.table.html"></div><div style="margin-top: 150px" align="center"></div></div><div ng-if="vm.showPanels"><div ng-if="!vm.loadingFields"><div ng-if="vm.fieldsCalculation.calc_type == 0" include-with-scope="app/pages/feeds/addNewFeed/blankAddNewFeedUS.html"></div><div ng-if="vm.fieldsCalculation.calc_type == 1" include-with-scope="app/pages/feeds/addNewFeed/blankAddNewFeedVemDve.html"></div></div><div align="center" ng-if="vm.loadingFields"><<div id="loading-animation-large"></div>></div></div></div><div ng-if="!vm.loading && !vm.selectedTeam" align="center"><div><h3><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></h3></div></div><div align="center" ng-if="vm.loading"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/addNewFeed/blankAddNewFeedUS.html','<form name="vm.addFeedForm"><div class="first-third-grid"><div style="margin-top: 5px" class="panel g-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_general_">General</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.feed_name.$invalid && (vm.addFeedForm.feed_name.$dirty || vm.addFeedForm.$submitted)}"><label for="feed_name"><data-i18n i18n="_feeds_name_">Feed name</data-i18n></label> <input type="text" class="form-control" id="feed_name" placeholder="{{ \'_feeds_name_\' | i18n }}" ng-model="vm.feedDTO.feed_name" required="" name="feed_name" maxlength="60" select-on-click=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.test_date.$invalid && (vm.addFeedForm.test_date.$dirty || vm.addFeedForm.$submitted)}"><label for="test_date"><data-i18n i18n="_feeds_test_date_">Test date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.date_format}}" placeholder="{{vm.date_format}}" datepicker-options="vm.options" ng-model="vm.test_date" is-open="vm.DPOpened" ng-required="true" close-text="Close" show-button-bar="false" id="test_date" name="test_date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openDatePicker()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.dm.$invalid && (vm.addFeedForm.dm.$dirty || vm.addFeedForm.$submitted)}"><label for="dm" class="span-label"><data-i18n i18n="_feeds_dm_">DM</data-i18n></label> <input type="number" format-input-value="dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0.01" class="form-control with-units" required="" name="dm" id="dm" ng-model="vm.feedDTO.dm" select-on-click=""><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0.01&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.dm.$invalid && (vm.addFeedForm.dm.$dirty || vm.addFeedForm.$submitted)}"><label for="dm" class="span-label"><data-i18n i18n="_feeds_dm_">DM</data-i18n></label> <input type="number" format-input-value="dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000" min="0.01" class="form-control with-units" required="" name="dm" id="dm" ng-model="vm.feedDTO.dm" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0.01&nbsp;&&nbsp;1000</span></div><div class="form-group"><label for="feed_type"><data-i18n i18n="_feeds_type_">Feed type</data-i18n></label><ui-select ng-model="vm.feedTypesItemBlank" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" on-select="vm.newFeedTypeChanged()"><ui-select-match>{{ $select.selected.name | i18n }}</ui-select-match><ui-select-choices repeat="type in vm.feedTypesListBlank | filter: $select.search"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap" uib-tooltip="{{ \'_description_common_feed_\' | i18n }}" tooltip-is-open="commonIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><input type="checkbox" id="common_feed" ng-model="vm.feedDTO.common_feed" select-on-click=""> <span><data-i18n i18n="_feeds_common_">Common feed</data-i18n></span></label></div></div></div><div class="panel f-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_fiber_">Fiber</data-i18n></div><div class="panel-body"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ndf.$invalid && (vm.addFeedForm.ndf.$dirty || vm.addFeedForm.$submitted)}"><label for="ndf" class="span-label"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n></label> <input type="number" format-input-value="ndf" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="ndf" id="ndf" ng-model="vm.feedDTO.ndf" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ndf.$invalid && (vm.addFeedForm.ndf.$dirty || vm.addFeedForm.$submitted)}"><label for="ndf" class="span-label"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n></label> <input type="number" format-input-value="ndf" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="ndf" id="ndf" ng-model="vm.feedDTO.ndf" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ndf_digest.$invalid && (vm.addFeedForm.ndf_digest.$dirty || vm.addFeedForm.$submitted)}"><label for="ndf_digest" class="span-label"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n></label> <input type="number" format-input-value="ndf_digest" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="ndf_digest" id="ndf_digest" ng-model="vm.feedDTO.ndf_digest" select-on-click=""><span>%<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ef_ndf_as_ndf.$invalid && (vm.addFeedForm.ef_ndf_as_ndf.$dirty || vm.addFeedForm.$submitted)}"><label for="ef_ndf_as_ndf" class="span-label"><data-i18n i18n="_feeds_efndf_">efNDF</data-i18n></label> <input type="number" format-input-value="ef_ndf_as_ndf" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="ef_ndf_as_ndf" id="ef_ndf_as_ndf" ng-model="vm.feedDTO.ef_ndf_as_ndf" select-on-click=""><span>%<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.adf.$invalid && (vm.addFeedForm.adf.$dirty || vm.addFeedForm.$submitted)}"><label for="adf" class="span-label"><data-i18n i18n="_feeds_adf_">ADF</data-i18n></label> <input type="number" format-input-value="adf" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="adf" id="adf" ng-model="vm.feedDTO.adf" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.adf.$invalid && (vm.addFeedForm.adf.$dirty || vm.addFeedForm.$submitted)}"><label for="adf" class="span-label"><data-i18n i18n="_feeds_adf_">ADF</data-i18n></label> <input type="number" format-input-value="adf" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="adf" id="adf" ng-model="vm.feedDTO.adf" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.lignin.$invalid && (vm.addFeedForm.lignin.$dirty || vm.addFeedForm.$submitted)}"><label for="lignin" class="span-label"><data-i18n i18n="_feeds_lingnin_">Lignin</data-i18n></label> <input type="number" format-input-value="lignin" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="lignin" id="lignin" ng-model="vm.feedDTO.lignin" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.lignin.$invalid && (vm.addFeedForm.lignin.$dirty || vm.addFeedForm.$submitted)}"><label for="lignin" class="span-label"><data-i18n i18n="_feeds_lingnin_">Lignin</data-i18n></label> <input type="number" format-input-value="lignin" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="lignin" id="lignin" ng-model="vm.feedDTO.lignin" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.rd_ndf.$invalid && (vm.addFeedForm.rd_ndf.$dirty || vm.addFeedForm.$submitted)}"><label for="rd_ndf" class="span-label"><data-i18n i18n="_feeds_rdndf_">RDNDF</data-i18n></label> <input type="number" format-input-value="rd_ndf" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="rd_ndf" id="rd_ndf" ng-model="vm.feedDTO.rd_ndf" select-on-click=""><span>%<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div></div><div class="panel e-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_energy_">Energy</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.disc_fac.$invalid && (vm.addFeedForm.disc_fac.$dirty || vm.addFeedForm.$submitted)}"><label for="disc_fac" class="span-label"><data-i18n i18n="_feeds_disc_fac_">Disc. Fac.</data-i18n></label> <input type="number" format-input-value="disc_fac" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="disc_fac" id="disc_fac" ng-model="vm.feedDTO.disc_fac" select-on-click=""> <span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.nel_89.$invalid && (vm.addFeedForm.nel_89.$dirty || vm.addFeedForm.$submitted)}"><label for="nel_89" class="span-label"><data-i18n i18n="_feeds_nel89_">NEL 89</data-i18n></label> <input type="number" format-input-value="nel_89" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="{{vm.nel_89Max}}" min="0" class="form-control with-units" name="nel_89" id="nel_89" ng-model="vm.feedDTO.nel_89" select-on-click=""><span>{{ vm.energy }}/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;{{vm.nel_89Max}}</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.me_89.$invalid && (vm.addFeedForm.me_89.$dirty || vm.addFeedForm.$submitted)}"><label for="me_89" class="span-label"><data-i18n i18n="_feeds_me89_">ME 89</data-i18n></label> <input type="number" format-input-value="me_89" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="{{vm.me_89max}}" min="0" class="form-control with-units" name="me_89" id="me_89" ng-model="vm.feedDTO.me_89" select-on-click=""><span>{{ vm.energy }}/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;{{vm.me_89max}}</span></div></div></div><div class="panel p-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_protein_">protein</data-i18n></div><div class="panel-body"><div class="row"><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cp.$invalid && (vm.addFeedForm.cp.$dirty || vm.addFeedForm.$submitted)}"><label for="cp" class="span-label"><data-i18n i18n="_feeds_cp_">cp</data-i18n></label> <input type="number" format-input-value="cp" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="cp" id="cp" ng-model="vm.feedDTO.cp" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cp.$invalid && (vm.addFeedForm.cp.$dirty || vm.addFeedForm.$submitted)}"><label for="cp" class="span-label"><data-i18n i18n="_feeds_cp_">cp</data-i18n></label> <input type="number" format-input-value="cp" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="cp" id="cp" ng-model="vm.feedDTO.cp" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.rup_dig.$invalid && (vm.addFeedForm.rup_dig.$dirty || vm.addFeedForm.$submitted)}"><label for="rup_dig" class="span-label"><data-i18n i18n="_feeds_rup_dig_">rup dig</data-i18n></label> <input type="number" format-input-value="rup_dig" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="rup_dig" id="rup_dig" ng-model="vm.feedDTO.rup_dig" select-on-click=""><span>%<data-i18n i18n="_feeds_cp_">cp</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.b_prot.$invalid && (vm.addFeedForm.b_prot.$dirty || vm.addFeedForm.$submitted)}"><label for="b_prot" class="span-label"><data-i18n i18n="_feeds_protein_b_">B prot</data-i18n></label> <input type="number" format-input-value="b_prot" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="b_prot" id="b_prot" ng-model="vm.feedDTO.b_prot" select-on-click=""><span>%<data-i18n i18n="_feeds_cp_">cp</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.c_prot.$invalid && (vm.addFeedForm.c_prot.$dirty || vm.addFeedForm.$submitted)}"><label for="c_prot" class="span-label"><data-i18n i18n="_feeds_protein_c_">C prot</data-i18n></label> <input type="number" format-input-value="c_prot" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="c_prot" id="c_prot" ng-model="vm.feedDTO.c_prot" select-on-click=""><span>%<data-i18n i18n="_feeds_cp_">cp</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.kd_b_prot.$invalid && (vm.addFeedForm.kd_b_prot.$dirty || vm.addFeedForm.$submitted)}"><label for="kd_b_prot" class="span-label"><data-i18n i18n="_feeds_kd_bprot_">kd Bprot</data-i18n></label> <input type="number" format-input-value="kd_b_prot" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="kd_b_prot" id="kd_b_prot" ng-model="vm.feedDTO.kd_b_prot" select-on-click=""><span>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.npncpe.$invalid && (vm.addFeedForm.npncpe.$dirty || vm.addFeedForm.$submitted)}"><label for="npncpe" class="span-label"><data-i18n i18n="_feeds_npncpe_">NPNCPE</data-i18n></label> <input type="number" format-input-value="npncpe" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="npncpe" id="npncpe" ng-model="vm.feedDTO.npncpe" select-on-click=""><span>%<data-i18n i18n="_feeds_cp_">cp</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.rup_89.$invalid && (vm.addFeedForm.rup_89.$dirty || vm.addFeedForm.$submitted)}"><label for="rup_89" class="span-label"><data-i18n i18n="_feeds_rup89_">rup 89</data-i18n></label> <input type="number" format-input-value="rup_89" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="rup_89" id="rup_89" ng-model="vm.feedDTO.rup_89" select-on-click=""><span>%<data-i18n i18n="_feeds_cp_">cp</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ndicp.$invalid && (vm.addFeedForm.ndicp.$dirty || vm.addFeedForm.$submitted)}"><label for="ndicp" class="span-label"><data-i18n i18n="_feeds_ndicp_">ndicp</data-i18n></label> <input type="number" format-input-value="ndicp" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="ndicp" id="ndicp" ng-model="vm.feedDTO.ndicp" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ndicp.$invalid && (vm.addFeedForm.ndicp.$dirty || vm.addFeedForm.$submitted)}"><label for="ndicp" class="span-label"><data-i18n i18n="_feeds_ndicp_">ndicp</data-i18n></label> <input type="number" format-input-value="ndicp" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="ndicp" id="ndicp" ng-model="vm.feedDTO.ndicp" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.adicp.$invalid && (vm.addFeedForm.adicp.$dirty || vm.addFeedForm.$submitted)}"><label for="adicp" class="span-label"><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n></label> <input type="number" format-input-value="adicp" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="adicp" id="adicp" ng-model="vm.feedDTO.adicp" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.adicp.$invalid && (vm.addFeedForm.adicp.$dirty || vm.addFeedForm.$submitted)}"><label for="adicp" class="span-label"><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n></label> <input type="number" format-input-value="adicp" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="adicp" id="adicp" ng-model="vm.feedDTO.adicp" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div></div></div></div></div><div class="panel c-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_carb_">Carbohydrates</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.nfc_dig.$invalid && (vm.addFeedForm.nfc_dig.$dirty || vm.addFeedForm.$submitted)}"><label for="nfc_dig" class="span-label"><data-i18n i18n="_feeds_nfc_digestibility_">NFC dig</data-i18n></label> <input type="number" format-input-value="nfc_dig" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="nfc_dig" id="nfc_dig" ng-model="vm.feedDTO.nfc_dig" select-on-click=""><span>%<data-i18n i18n="_feeds_nfc_">NFC</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.sugar.$invalid && (vm.addFeedForm.sugar.$dirty || vm.addFeedForm.$submitted)}"><label for="sugar" class="span-label"><data-i18n i18n="_feeds_sugar_">Sugar</data-i18n></label> <input type="number" format-input-value="sugar" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="sugar" id="sugar" ng-model="vm.feedDTO.sugar" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.sugar.$invalid && (vm.addFeedForm.sugar.$dirty || vm.addFeedForm.$submitted)}"><label for="sugar" class="span-label"><data-i18n i18n="_feeds_sugar_">Sugar</data-i18n></label> <input type="number" format-input-value="sugar" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="sugar" id="sugar" ng-model="vm.feedDTO.sugar" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.starch.$invalid && (vm.addFeedForm.starch.$dirty || vm.addFeedForm.$submitted)}"><label for="starch" class="span-label"><data-i18n i18n="_feeds_starch_">Starch</data-i18n></label> <input type="number" format-input-value="starch" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="starch" id="starch" ng-model="vm.feedDTO.starch" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.starch.$invalid && (vm.addFeedForm.starch.$dirty || vm.addFeedForm.$submitted)}"><label for="starch" class="span-label"><data-i18n i18n="_feeds_starch_">Starch</data-i18n></label> <input type="number" format-input-value="starch" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="starch" id="starch" ng-model="vm.feedDTO.starch" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.in_fa.$invalid && (vm.addFeedForm.in_fa.$dirty || vm.addFeedForm.$submitted)}"><label for="in_fa" class="span-label"><data-i18n i18n="_feeds_infa_">INFA</data-i18n></label> <input type="number" format-input-value="in_fa" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="in_fa" id="in_fa" ng-model="vm.feedDTO.in_fa" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.in_fa.$invalid && (vm.addFeedForm.in_fa.$dirty || vm.addFeedForm.$submitted)}"><label for="in_fa" class="span-label"><data-i18n i18n="_feeds_infa_">INFA</data-i18n></label> <input type="number" format-input-value="in_fa" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="in_fa" id="in_fa" ng-model="vm.feedDTO.in_fa" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.rd_starch.$invalid && (vm.addFeedForm.rd_starch.$dirty || vm.addFeedForm.$submitted)}"><label for="rd_starch" class="span-label"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n></label> <input type="number" format-input-value="rd_starch" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="rd_starch" id="rd_starch" ng-model="vm.feedDTO.rd_starch" select-on-click=""><span>%<data-i18n i18n="_feeds_starch_">Starch</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.rd_sol_fiber.$invalid && (vm.addFeedForm.rd_sol_fiber.$dirty || vm.addFeedForm.$submitted)}"><label for="rd_sol_fiber" class="span-label"><data-i18n i18n="_feeds_rdsolf_">RDSolf</data-i18n></label> <input type="number" format-input-value="rd_sol_fiber" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="rd_sol_fiber" id="rd_sol_fiber" ng-model="vm.feedDTO.rd_sol_fiber" select-on-click=""><span>%<data-i18n i18n="_feeds_solfiber_">SolF</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div></div><div class="panel l-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_lipid_">Lipid</data-i18n></div><div class="panel-body"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ee.$invalid && (vm.addFeedForm.ee.$dirty || vm.addFeedForm.$submitted)}"><label for="ee" class="span-label"><data-i18n i18n="_feeds_ee_">EE</data-i18n></label> <input type="number" format-input-value="ee" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="ee" id="ee" ng-model="vm.feedDTO.ee" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ee.$invalid && (vm.addFeedForm.ee.$dirty || vm.addFeedForm.$submitted)}"><label for="ee" class="span-label"><data-i18n i18n="_feeds_ee_">EE</data-i18n></label> <input type="number" format-input-value="ee" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="ee" id="ee" ng-model="vm.feedDTO.ee" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.bhfa.$invalid && (vm.addFeedForm.bhfa.$dirty || vm.addFeedForm.$submitted)}"><label for="bhfa" class="span-label"><data-i18n i18n="_feeds_bhfa_">BHFA</data-i18n></label> <input type="number" format-input-value="bhfa" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="bhfa" id="bhfa" ng-model="vm.feedDTO.bhfa" select-on-click=""> <span>%<data-i18n i18n="_feeds_fa_">FA</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.pufa.$invalid && (vm.addFeedForm.pufa.$dirty || vm.addFeedForm.$submitted)}"><label for="pufa" class="span-label"><data-i18n i18n="_feeds_pufa_">PUFA</data-i18n></label> <input type="number" format-input-value="pufa" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="pufa" id="pufa" ng-model="vm.feedDTO.pufa" select-on-click=""> <span>%<data-i18n i18n="_feeds_fa_">FA</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.sfa.$invalid && (vm.addFeedForm.sfa.$dirty || vm.addFeedForm.$submitted)}"><label for="sfa" class="span-label"><data-i18n i18n="_feeds_sfa_">SFA</data-i18n></label> <input type="number" format-input-value="sfa" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="sfa" id="sfa" ng-model="vm.feedDTO.sfa" select-on-click=""> <span>%<data-i18n i18n="_feeds_fa_">FA</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.fa_dig.$invalid && (vm.addFeedForm.fa_dig.$dirty || vm.addFeedForm.$submitted)}"><label for="fa_dig" class="span-label"><data-i18n i18n="_feeds_fa_dig_">FA dig</data-i18n></label> <input type="number" format-input-value="fa_dig" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="fa_dig" id="fa_dig" ng-model="vm.feedDTO.fa_dig" select-on-click=""> <span>%<data-i18n i18n="_feeds_fa_">FA</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div></div><div class="panel v-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_vitamin_">Vitamin</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.vitamin_a.$invalid && (vm.addFeedForm.vitamin_a.$dirty || vm.addFeedForm.$submitted)}"><label for="vitamin_a" class="span-label"><data-i18n i18n="_feeds_vit_a_">Vitamin A</data-i18n></label> <input type="number" format-input-value="vitamin_a" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="vitamin_a" id="vitamin_a" ng-model="vm.feedDTO.vitamin_a" select-on-click=""><span><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.vitamin_d.$invalid && (vm.addFeedForm.vitamin_d.$dirty || vm.addFeedForm.$submitted)}"><label for="vitamin_d" class="span-label"><data-i18n i18n="_feeds_vit_d_">Vitamin D</data-i18n></label> <input type="number" format-input-value="vitamin_d" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="vitamin_d" id="vitamin_d" ng-model="vm.feedDTO.vitamin_d" select-on-click=""> <span><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.vitamin_e.$invalid && (vm.addFeedForm.vitamin_e.$dirty || vm.addFeedForm.$submitted)}"><label for="vitamin_e" class="span-label"><data-i18n i18n="_feeds_vit_e_">Vitamin E</data-i18n></label> <input type="number" format-input-value="vitamin_e" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="vitamin_e" id="vitamin_e" ng-model="vm.feedDTO.vitamin_e" select-on-click=""> <span><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div></div></div><div class="panel aa-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_amino_acid_">Amino Acid</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.lysine.$invalid && (vm.addFeedForm.lysine.$dirty || vm.addFeedForm.$submitted)}"><label for="lysine" class="span-label"><data-i18n i18n="_feeds_lysine_">Lys</data-i18n></label> <input type="number" format-input-value="lysine" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="lysine" id="lysine" ng-model="vm.feedDTO.lysine" select-on-click=""><span>%<data-i18n i18n="_feeds_drup_">dRUP</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.methionine.$invalid && (vm.addFeedForm.methionine.$dirty || vm.addFeedForm.$submitted)}"><label for="methionine" class="span-label"><data-i18n i18n="_feeds_methionine_">Met</data-i18n></label> <input type="number" format-input-value="methionine" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="methionine" id="methionine" ng-model="vm.feedDTO.methionine" select-on-click=""><span>%<data-i18n i18n="_feeds_drup_">dRUP</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.teaa.$invalid && (vm.addFeedForm.teaa.$dirty || vm.addFeedForm.$submitted)}"><label for="teaa" class="span-label"><data-i18n i18n="_feeds_teaa_">TEAA</data-i18n></label> <input type="number" format-input-value="teaa" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="teaa" id="teaa" ng-model="vm.feedDTO.teaa" select-on-click=""> <span>%<data-i18n i18n="_feeds_drup_">dRUP</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div></div></div><div class="second-grid"><div style="margin-top: 5px" class="panel m-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_mineral_">Mineral</data-i18n></div><div class="panel-body"><div class="row"><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ash.$invalid && (vm.addFeedForm.ash.$dirty || vm.addFeedForm.$submitted)}"><label for="ash" class="span-label"><data-i18n i18n="_feeds_ash_">ash</data-i18n></label> <input type="number" format-input-value="ash" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="ash" id="ash" ng-model="vm.feedDTO.ash" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ash.$invalid && (vm.addFeedForm.ash.$dirty || vm.addFeedForm.$submitted)}"><label for="ash" class="span-label"><data-i18n i18n="_feeds_ash_">ash</data-i18n></label> <input type="number" format-input-value="ash" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="ash" id="ash" ng-model="vm.feedDTO.ash" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ca.$invalid && (vm.addFeedForm.ca.$dirty || vm.addFeedForm.$submitted)}"><label for="ca" class="span-label"><data-i18n i18n="_feeds_ca_">Ca</data-i18n></label> <input type="number" format-input-value="ca" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="ca" id="ca" ng-model="vm.feedDTO.ca" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ca.$invalid && (vm.addFeedForm.ca.$dirty || vm.addFeedForm.$submitted)}"><label for="ca" class="span-label"><data-i18n i18n="_feeds_ca_">Ca</data-i18n></label> <input type="number" format-input-value="ca" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="ca" id="ca" ng-model="vm.feedDTO.ca" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ca_abs.$invalid && (vm.addFeedForm.ca_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="ca_abs" class="span-label"><data-i18n i18n="_feeds_ca_abs_">abs Ca</data-i18n></label> <input type="number" format-input-value="ca_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="ca_abs" id="ca_abs" ng-model="vm.feedDTO.ca_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_ca_">ca</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.p.$invalid && (vm.addFeedForm.p.$dirty || vm.addFeedForm.$submitted)}"><label for="p" class="span-label"><data-i18n i18n="_feeds_p_">p</data-i18n></label> <input type="number" format-input-value="p" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="p" id="p" ng-model="vm.feedDTO.p" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.p.$invalid && (vm.addFeedForm.p.$dirty || vm.addFeedForm.$submitted)}"><label for="p" class="span-label"><data-i18n i18n="_feeds_p_">p</data-i18n></label> <input type="number" format-input-value="p" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="p" id="p" ng-model="vm.feedDTO.p" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.p_abs.$invalid && (vm.addFeedForm.p_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="p_abs" class="span-label"><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n></label> <input type="number" format-input-value="p_abs" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="p_abs" id="p_abs" ng-model="vm.feedDTO.p_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_p_">p</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mg.$invalid && (vm.addFeedForm.mg.$dirty || vm.addFeedForm.$submitted)}"><label for="mg" class="span-label"><data-i18n i18n="_feeds_mg_">Mg</data-i18n></label> <input type="number" format-input-value="mg" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="mg" id="mg" ng-model="vm.feedDTO.mg" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mg.$invalid && (vm.addFeedForm.mg.$dirty || vm.addFeedForm.$submitted)}"><label for="mg" class="span-label"><data-i18n i18n="_feeds_mg_">Mg</data-i18n></label> <input type="number" format-input-value="mg" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="mg" id="mg" ng-model="vm.feedDTO.mg" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mg_abs.$invalid && (vm.addFeedForm.mg_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="mg_abs" class="span-label"><data-i18n i18n="_feeds_mg_abs_">abs Mg</data-i18n></label> <input type="number" format-input-value="mg_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="mg_abs" id="mg_abs" ng-model="vm.feedDTO.mg_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_mg_">Mg</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.k.$invalid && (vm.addFeedForm.k.$dirty || vm.addFeedForm.$submitted)}"><label for="k" class="span-label"><data-i18n i18n="_feeds_k_">K</data-i18n></label> <input type="number" format-input-value="k" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="k" id="k" ng-model="vm.feedDTO.k" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.k.$invalid && (vm.addFeedForm.k.$dirty || vm.addFeedForm.$submitted)}"><label for="k" class="span-label"><data-i18n i18n="_feeds_k_">K</data-i18n></label> <input type="number" format-input-value="k" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="k" id="k" ng-model="vm.feedDTO.k" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.na.$invalid && (vm.addFeedForm.na.$dirty || vm.addFeedForm.$submitted)}"><label for="na" class="span-label"><data-i18n i18n="_feeds_na_">Na</data-i18n></label> <input type="number" format-input-value="na" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="na" id="na" ng-model="vm.feedDTO.na" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.na.$invalid && (vm.addFeedForm.na.$dirty || vm.addFeedForm.$submitted)}"><label for="na" class="span-label"><data-i18n i18n="_feeds_na_">Na</data-i18n></label> <input type="number" format-input-value="na" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="na" id="na" ng-model="vm.feedDTO.na" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cl.$invalid && (vm.addFeedForm.cl.$dirty || vm.addFeedForm.$submitted)}"><label for="cl" class="span-label"><data-i18n i18n="_feeds_cl_">cl</data-i18n></label> <input type="number" format-input-value="cl" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="cl" id="cl" ng-model="vm.feedDTO.cl" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cl.$invalid && (vm.addFeedForm.cl.$dirty || vm.addFeedForm.$submitted)}"><label for="cl" class="span-label"><data-i18n i18n="_feeds_cl_">cl</data-i18n></label> <input type="number" format-input-value="cl" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="cl" id="cl" ng-model="vm.feedDTO.cl" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.s.$invalid && (vm.addFeedForm.s.$dirty || vm.addFeedForm.$submitted)}"><label for="s" class="span-label"><data-i18n i18n="_feeds_s_">s</data-i18n></label> <input type="number" format-input-value="s" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="s" id="s" ng-model="vm.feedDTO.s" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.s.$invalid && (vm.addFeedForm.s.$dirty || vm.addFeedForm.$submitted)}"><label for="s" class="span-label"><data-i18n i18n="_feeds_s_">s</data-i18n></label> <input type="number" format-input-value="s" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="s" id="s" ng-model="vm.feedDTO.s" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div></div></div></div></div><div class="panel t-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_trace_min_">Trace mineral</data-i18n></div><div class="panel-body"><div class="row"><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.co.$invalid && (vm.addFeedForm.co.$dirty || vm.addFeedForm.$submitted)}"><label for="co" class="span-label"><data-i18n i18n="_feeds_co_">co</data-i18n></label> <input type="number" format-input-value="co" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="co" id="co" ng-model="vm.feedDTO.co" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cu.$invalid && (vm.addFeedForm.cu.$dirty || vm.addFeedForm.$submitted)}"><label for="cu" class="span-label"><data-i18n i18n="_feeds_cu_">Cu</data-i18n></label> <input type="number" format-input-value="cu" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="cu" id="cu" ng-model="vm.feedDTO.cu" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cu_abs.$invalid && (vm.addFeedForm.cu_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="cu_abs" class="span-label"><data-i18n i18n="_feeds_cu_abs_">abs cu</data-i18n></label> <input type="number" format-input-value="cu_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="cu_abs" id="cu_abs" ng-model="vm.feedDTO.cu_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_cu_">Cu</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.fe.$invalid && (vm.addFeedForm.fe.$dirty || vm.addFeedForm.$submitted)}"><label for="fe" class="span-label"><data-i18n i18n="_feeds_fe_">fe</data-i18n></label> <input type="number" format-input-value="fe" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="fe" id="fe" ng-model="vm.feedDTO.fe" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.fe_abs.$invalid && (vm.addFeedForm.fe_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="fe_abs" class="span-label"><data-i18n i18n="_feeds_fe_abs_">abs fe</data-i18n></label> <input type="number" format-input-value="fe_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="fe_abs" id="fe_abs" ng-model="vm.feedDTO.fe_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_fe_">fe</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.i.$invalid && (vm.addFeedForm.i.$dirty || vm.addFeedForm.$submitted)}"><label for="i" class="span-label"><data-i18n i18n="_feeds_i_">i</data-i18n></label> <input type="number" format-input-value="i" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="i" id="i" ng-model="vm.feedDTO.i" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.i_abs.$invalid && (vm.addFeedForm.i_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="i_abs" class="span-label"><data-i18n i18n="_feeds_i_abs_">abs i</data-i18n></label> <input type="number" format-input-value="i_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="i_abs" id="i_abs" ng-model="vm.feedDTO.i_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_i_">i</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mo.$invalid && (vm.addFeedForm.mo.$dirty || vm.addFeedForm.$submitted)}"><label for="mo" class="span-label"><data-i18n i18n="_feeds_mo_">Mo</data-i18n></label> <input type="number" format-input-value="mo" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="1000000" min="0" class="form-control with-units" name="mo" id="mo" ng-model="vm.feedDTO.mo" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mn.$invalid && (vm.addFeedForm.mn.$dirty || vm.addFeedForm.$submitted)}"><label for="mn" class="span-label"><data-i18n i18n="_feeds_mn_">mn</data-i18n></label> <input type="number" format-input-value="mn" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="1000000" min="0" class="form-control with-units" name="mn" id="mn" ng-model="vm.feedDTO.mn" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mn_abs.$invalid && (vm.addFeedForm.mn_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="mn_abs" class="span-label"><data-i18n i18n="_feeds_mn_abs_">abs Mn</data-i18n></label> <input type="number" format-input-value="mn_abs" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="mn_abs" id="mn_abs" ng-model="vm.feedDTO.mn_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_mn_">mn</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.se.$invalid && (vm.addFeedForm.se.$dirty || vm.addFeedForm.$submitted)}"><label for="se" class="span-label"><data-i18n i18n="_feeds_se_">se</data-i18n></label> <input type="number" format-input-value="se" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="se" id="se" ng-model="vm.feedDTO.se" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.se_abs.$invalid && (vm.addFeedForm.se_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="se_abs" class="span-label"><data-i18n i18n="_feeds_se_abs_">abs se</data-i18n></label> <input type="number" format-input-value="se_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="se_abs" id="se_abs" ng-model="vm.feedDTO.se_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_se_">se</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.zn.$invalid && (vm.addFeedForm.zn.$dirty || vm.addFeedForm.$submitted)}"><label for="zn" class="span-label"><data-i18n i18n="_feeds_zn_">zn</data-i18n></label> <input type="number" format-input-value="zn" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="zn" id="zn" ng-model="vm.feedDTO.zn" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.zn_abs.$invalid && (vm.addFeedForm.zn_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="zn_abs" class="span-label"><data-i18n i18n="_feeds_zn_abs_">abs Zn</data-i18n></label> <input type="number" format-input-value="zn_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="zn_abs" id="zn_abs" ng-model="vm.feedDTO.zn_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_zn_">zn</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div></div></div></div></div><div class="first-third-grid"><div style="margin-top: 5px" class="panel cost-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_cost_">Cost</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cost_as_sold.$invalid && (vm.addFeedForm.cost_as_sold.$dirty || vm.addFeedForm.$submitted)}"><label for="cost_as_sold" class="span-label"><data-i18n i18n="_feeds_cost_as_sold_">Cost as sold</data-i18n></label> <input type="number" format-input-value="cost_as_sold" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000000" min="0" class="form-control with-units" name="cost_as_sold" id="cost_as_sold" ng-model="vm.feedDTO.cost_as_sold" select-on-click=""><span>{{ vm.currency }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.wt_as_sold.$invalid && (vm.addFeedForm.wt_as_sold.$dirty || vm.addFeedForm.$submitted)}"><label for="wt_as_sold" class="span-label"><data-i18n i18n="_feeds_wt_as_sold_">Wt as sold</data-i18n></label> <input type="number" format-input-value="wt_as_sold" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="wt_as_sold" id="wt_as_sold" ng-model="vm.feedDTO.wt_as_sold" select-on-click=""><span>{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="is_purchased" ng-true-value="1" ng-false-value="0" ng-model="vm.feedDTO.is_purchased" select-on-click=""> <span><data-i18n i18n="_feeds_purchased_">Purchased</data-i18n></span></label></div></div></div><div class="panel misc-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_misc_">Misc</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_1.$invalid && (vm.addFeedForm.blank_1.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_1" class="span-label"><data-i18n i18n="_feeds_blank_">Blank</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_1" id="blank_1" ng-model="vm.feedDTO.blank_1" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_2.$invalid && (vm.addFeedForm.blank_2.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_2" class="span-label"><data-i18n i18n="_feeds_blank_">Blank</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_2" id="blank_2" ng-model="vm.feedDTO.blank_2" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_3.$invalid && (vm.addFeedForm.blank_3.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_3" class="span-label"><data-i18n i18n="_feeds_blank_">Blank</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_3" id="blank_3" ng-model="vm.feedDTO.blank_3" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_4.$invalid && (vm.addFeedForm.blank_4.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_4" class="span-label"><data-i18n i18n="_feeds_blank_">Blank</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_4" id="blank_4" ng-model="vm.feedDTO.blank_4" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_5.$invalid && (vm.addFeedForm.blank_5.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_5" class="span-label"><data-i18n i18n="_feeds_blank_">Blank</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_5" id="blank_5" ng-model="vm.feedDTO.blank_5" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div></div></div><div class="panel comm-panel"><div class="panel-heading"></div><div class="panel-body"><div class="form-group"><label for="comments"><data-i18n i18n="_feeds_comment_">comment</data-i18n></label> <textarea placeholder="{{ \'_feeds_comment_\' | i18n }}" class="form-control" id="comments" style="resize: none" ng-model="vm.feedDTO.comments"></textarea></div><div align="right"><button type="submit" class="btn btn-success" ng-click="vm.saveFeed()"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div></div></form>');
$templateCache.put('app/pages/feeds/addNewFeed/blankAddNewFeedVemDve.html','<form name="vm.addFeedForm"><div class="first-third-grid"><div style="margin-top: 5px" class="panel g-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_general_">General</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.feed_name.$invalid && (vm.addFeedForm.feed_name.$dirty || vm.addFeedForm.$submitted)}"><label for="feed_name"><data-i18n i18n="_feeds_name_">Feed name</data-i18n></label> <input type="text" class="form-control" id="feed_name" name="feed_name" placeholder="{{ \'_feeds_name_\' | i18n }}" ng-model="vm.feedDTO.feed_name" required="" maxlength="60" select-on-click=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.test_date.$invalid && (vm.addFeedForm.test_date.$dirty || vm.addFeedForm.$submitted)}"><label for="test_date"><data-i18n i18n="_feeds_test_date_">Test date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.date_format}}" placeholder="{{vm.date_format}}" datepicker-options="vm.options" ng-model="vm.test_date" is-open="vm.DPOpened" ng-required="true" close-text="Close" show-button-bar="false" id="test_date" name="test_date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openDatePicker()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.dm.$invalid && (vm.addFeedForm.dm.$dirty || vm.addFeedForm.$submitted)}"><label for="dm" class="span-label"><data-i18n i18n="_feeds_dm_">DM</data-i18n></label> <input type="number" format-input-value="dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0.01" name="dm" class="form-control with-units" id="dm" required="" ng-model="vm.feedDTO.dm" select-on-click=""><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0.01&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.dm.$invalid && (vm.addFeedForm.dm.$dirty || vm.addFeedForm.$submitted)}"><label for="dm" class="span-label"><data-i18n i18n="_feeds_dm_">DM</data-i18n></label> <input type="number" format-input-value="dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000" min="0.01" name="dm" class="form-control with-units" id="dm" required="" ng-model="vm.feedDTO.dm" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0.01&nbsp;&&nbsp;1000</span></div><div class="form-group"><label for="feed_type"><data-i18n i18n="_feeds_type_">Feed type</data-i18n></label><ui-select ng-model="vm.feedTypesItemBlank" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" on-select="vm.newFeedTypeChanged()"><ui-select-match>{{ $select.selected.name | i18n }}</ui-select-match><ui-select-choices repeat="type in vm.feedTypesListBlank | filter: $select.search"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap" uib-tooltip="{{ \'_description_common_feed_\' | i18n }}" tooltip-is-open="commonIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><input type="checkbox" id="common_feed" ng-model="vm.feedDTO.common_feed" select-on-click=""> <span><data-i18n i18n="_feeds_common_">Common feed</data-i18n></span></label></div></div></div><div class="panel f-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_fiber_">Fiber</data-i18n></div><div class="panel-body"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.rc.$invalid && (vm.addFeedForm.rc.$dirty || vm.addFeedForm.$submitted)}"><label for="rc" class="span-label"><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n></label> <input type="number" format-input-value="rc" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" id="rc" name="rc" ng-model="vm.feedDTO.rc" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.rc.$invalid && (vm.addFeedForm.rc.$dirty || vm.addFeedForm.$submitted)}"><label for="rc" class="span-label"><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n></label> <input type="number" format-input-value="rc" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" id="rc" name="rc" ng-model="vm.feedDTO.rc" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ndf.$invalid && (vm.addFeedForm.ndf.$dirty || vm.addFeedForm.$submitted)}"><label for="ndf" class="span-label"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n></label> <input type="number" format-input-value="ndf" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" id="ndf" name="ndf" ng-model="vm.feedDTO.ndf" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ndf.$invalid && (vm.addFeedForm.ndf.$dirty || vm.addFeedForm.$submitted)}"><label for="ndf" class="span-label"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n></label> <input type="number" format-input-value="ndf" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" id="ndf" name="ndf" ng-model="vm.feedDTO.ndf" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ndf_digest.$invalid && (vm.addFeedForm.ndf_digest.$dirty || vm.addFeedForm.$submitted)}"><label for="ndf_digest" class="span-label"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n></label> <input type="number" format-input-value="ndf_digest" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" id="ndf_digest" name="ndf_digest" ng-model="vm.feedDTO.ndf_digest" select-on-click=""><span>%<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.adf.$invalid && (vm.addFeedForm.adf.$dirty || vm.addFeedForm.$submitted)}"><label for="adf" class="span-label"><data-i18n i18n="_feeds_adf_">ADF</data-i18n></label> <input type="number" format-input-value="adf" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" id="adf" name="adf" ng-model="vm.feedDTO.adf" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.adf.$invalid && (vm.addFeedForm.adf.$dirty || vm.addFeedForm.$submitted)}"><label for="adf" class="span-label"><data-i18n i18n="_feeds_adf_">ADF</data-i18n></label> <input type="number" format-input-value="adf" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" id="adf" name="adf" ng-model="vm.feedDTO.adf" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.lignin.$invalid && (vm.addFeedForm.lignin.$dirty || vm.addFeedForm.$submitted)}"><label for="lignin" class="span-label"><data-i18n i18n="_feeds_lingnin_">Lignin</data-i18n></label> <input type="number" format-input-value="lignin" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" id="lignin" name="lignin" ng-model="vm.feedDTO.lignin" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.lignin.$invalid && (vm.addFeedForm.lignin.$dirty || vm.addFeedForm.$submitted)}"><label for="lignin" class="span-label"><data-i18n i18n="_feeds_lingnin_">Lignin</data-i18n></label> <input type="number" format-input-value="lignin" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" id="lignin" name="lignin" ng-model="vm.feedDTO.lignin" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div></div></div><div class="panel e-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_energy_">Energy</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.vem.$invalid && (vm.addFeedForm.vem.$dirty || vm.addFeedForm.$submitted)}"><label for="vem" class="span-label"><data-i18n i18n="_feeds_vem_">vem</data-i18n></label> <input type="number" format-input-value="vem" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="vem" id="vem" ng-model="vm.feedDTO.vem" select-on-click=""><span>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.fos.$invalid && (vm.addFeedForm.fos.$dirty || vm.addFeedForm.$submitted)}"><label for="fos" class="span-label"><data-i18n i18n="_feeds_fos_">fos</data-i18n></label> <input type="number" format-input-value="fos" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="fos" id="fos" ng-model="vm.feedDTO.fos" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div></div></div><div class="panel p-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_protein_">protein</data-i18n></div><div class="panel-body"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cp.$invalid && (vm.addFeedForm.cp.$dirty || vm.addFeedForm.$submitted)}"><label for="cp" class="span-label"><data-i18n i18n="_feeds_cp_">cp</data-i18n></label> <input type="number" format-input-value="cp" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="cp" id="cp" ng-model="vm.feedDTO.cp" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cp.$invalid && (vm.addFeedForm.cp.$dirty || vm.addFeedForm.$submitted)}"><label for="cp" class="span-label"><data-i18n i18n="_feeds_cp_">cp</data-i18n></label> <input type="number" format-input-value="cp" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="cp" id="cp" ng-model="vm.feedDTO.cp" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.dve.$invalid && (vm.addFeedForm.dve.$dirty || vm.addFeedForm.$submitted)}"><label for="dve" class="span-label"><data-i18n i18n="_feeds_dve_">DVE</data-i18n></label> <input type="number" format-input-value="dve" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="dve" id="dve" ng-model="vm.feedDTO.dve" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.oeb.$invalid && (vm.addFeedForm.oeb.$dirty || vm.addFeedForm.$submitted)}"><label for="oeb" class="span-label"><data-i18n i18n="_feeds_oeb_">OEB</data-i18n></label> <input type="number" format-input-value="oeb" format-value-dm="vm.feedDTO.dm" pattern="^-?\\d*(\\.\\d{0})?$" step="any" max="1000000" min="-1000000" class="form-control with-units" name="oeb" id="oeb" ng-model="vm.feedDTO.oeb" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;-1000000&nbsp;&&nbsp;1000000</span></div></div></div><div class="panel c-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_carb_">Carbohydrates</data-i18n></div><div class="panel-body"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.sugar.$invalid && (vm.addFeedForm.sugar.$dirty || vm.addFeedForm.$submitted)}"><label for="sugar" class="span-label"><data-i18n i18n="_feeds_sugar_">Sugar</data-i18n></label> <input type="number" format-input-value="sugar" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="sugar" id="sugar" ng-model="vm.feedDTO.sugar" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.sugar.$invalid && (vm.addFeedForm.sugar.$dirty || vm.addFeedForm.$submitted)}"><label for="sugar" class="span-label"><data-i18n i18n="_feeds_sugar_">Sugar</data-i18n></label> <input type="number" format-input-value="sugar" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="sugar" id="sugar" ng-model="vm.feedDTO.sugar" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.starch.$invalid && (vm.addFeedForm.starch.$dirty || vm.addFeedForm.$submitted)}"><label for="starch" class="span-label"><data-i18n i18n="_feeds_starch_">Starch</data-i18n></label> <input type="number" format-input-value="starch" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="starch" id="starch" ng-model="vm.feedDTO.starch" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.starch.$invalid && (vm.addFeedForm.starch.$dirty || vm.addFeedForm.$submitted)}"><label for="starch" class="span-label"><data-i18n i18n="_feeds_starch_">Starch</data-i18n></label> <input type="number" format-input-value="starch" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="starch" id="starch" ng-model="vm.feedDTO.starch" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.rus.$invalid && (vm.addFeedForm.rus.$dirty || vm.addFeedForm.$submitted)}"><label for="rus" class="span-label"><data-i18n i18n="_feeds_rus_">RUS</data-i18n></label> <input type="number" format-input-value="rus" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="rus" id="rus" ng-model="vm.feedDTO.rus" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.rus.$invalid && (vm.addFeedForm.rus.$dirty || vm.addFeedForm.$submitted)}"><label for="rus" class="span-label"><data-i18n i18n="_feeds_rus_">RUS</data-i18n></label> <input type="number" format-input-value="rus" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="rus" id="rus" ng-model="vm.feedDTO.rus" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div></div></div><div class="panel l-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_lipid_">Lipid</data-i18n></div><div class="panel-body"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ee.$invalid && (vm.addFeedForm.ee.$dirty || vm.addFeedForm.$submitted)}"><label for="ee" class="span-label"><data-i18n i18n="_feeds_ee_">EE</data-i18n></label> <input type="number" format-input-value="ee" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="ee" id="ee" ng-model="vm.feedDTO.ee" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ee.$invalid && (vm.addFeedForm.ee.$dirty || vm.addFeedForm.$submitted)}"><label for="ee" class="span-label"><data-i18n i18n="_feeds_ee_">EE</data-i18n></label> <input type="number" format-input-value="ee" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="ee" id="ee" ng-model="vm.feedDTO.ee" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.bhfa.$invalid && (vm.addFeedForm.bhfa.$dirty || vm.addFeedForm.$submitted)}"><label for="bhfa" class="span-label"><data-i18n i18n="_feeds_bhfa_">BHFA</data-i18n></label> <input type="number" format-input-value="bhfa" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="bhfa" id="bhfa" ng-model="vm.feedDTO.bhfa" select-on-click=""><span>%<data-i18n i18n="_feeds_fa_">FA</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.pufa.$invalid && (vm.addFeedForm.pufa.$dirty || vm.addFeedForm.$submitted)}"><label for="pufa" class="span-label"><data-i18n i18n="_feeds_pufa_">PUFA</data-i18n></label> <input type="number" format-input-value="pufa" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="pufa" id="pufa" ng-model="vm.feedDTO.pufa" select-on-click=""><span>%<data-i18n i18n="_feeds_fa_">FA</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.sfa.$invalid && (vm.addFeedForm.sfa.$dirty || vm.addFeedForm.$submitted)}"><label for="sfa" class="span-label"><data-i18n i18n="_feeds_sfa_">SFA</data-i18n></label> <input type="number" format-input-value="sfa" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="sfa" id="sfa" ng-model="vm.feedDTO.sfa" select-on-click=""><span>%<data-i18n i18n="_feeds_fa_">FA</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.fa_dig.$invalid && (vm.addFeedForm.fa_dig.$dirty || vm.addFeedForm.$submitted)}"><label for="fa_dig" class="span-label"><data-i18n i18n="_feeds_fa_dig_">FA dig</data-i18n></label> <input type="number" format-input-value="fa_dig" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="fa_dig" id="fa_dig" ng-model="vm.feedDTO.fa_dig" select-on-click=""><span>%<data-i18n i18n="_feeds_fa_">FA</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div></div><div class="panel v-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_vitamin_">Vitamin</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.vitamin_a.$invalid && (vm.addFeedForm.vitamin_a.$dirty || vm.addFeedForm.$submitted)}"><label for="vitamin_a" class="span-label"><data-i18n i18n="_feeds_vit_a_">Vitamin A</data-i18n></label> <input type="number" format-input-value="vitamin_a" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="vitamin_a" id="vitamin_a" ng-model="vm.feedDTO.vitamin_a" select-on-click=""><span><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.vitamin_d.$invalid && (vm.addFeedForm.vitamin_d.$dirty || vm.addFeedForm.$submitted)}"><label for="vitamin_d" class="span-label"><data-i18n i18n="_feeds_vit_d_">Vitamin D</data-i18n></label> <input type="number" format-input-value="vitamin_d" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="vitamin_d" id="vitamin_d" ng-model="vm.feedDTO.vitamin_d" select-on-click=""> <span><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.vitamin_e.$invalid && (vm.addFeedForm.vitamin_e.$dirty || vm.addFeedForm.$submitted)}"><label for="vitamin_e" class="span-label"><data-i18n i18n="_feeds_vit_e_">Vitamin E</data-i18n></label> <input type="number" format-input-value="vitamin_e" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="vitamin_e" id="vitamin_e" ng-model="vm.feedDTO.vitamin_e" select-on-click=""> <span><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div></div></div><div class="panel aa-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_amino_acid_">Amino Acid</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.lysine.$invalid && (vm.addFeedForm.lysine.$dirty || vm.addFeedForm.$submitted)}"><label for="lysine" class="span-label"><data-i18n i18n="_feeds_lysine_">Lys</data-i18n></label> <input type="number" format-input-value="lysine" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="lysine" id="lysine" ng-model="vm.feedDTO.lysine" select-on-click=""><span>%<data-i18n i18n="_feeds_drup_">dRUP</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.methionine.$invalid && (vm.addFeedForm.methionine.$dirty || vm.addFeedForm.$submitted)}"><label for="methionine" class="span-label"><data-i18n i18n="_feeds_methionine_">Met</data-i18n></label> <input type="number" format-input-value="methionine" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="methionine" id="methionine" ng-model="vm.feedDTO.methionine" select-on-click=""><span>%<data-i18n i18n="_feeds_drup_">dRUP</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div></div></div><div class="second-grid"><div style="margin-top: 5px" class="panel m-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_mineral_">Mineral</data-i18n></div><div class="panel-body"><div class="row"><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ash.$invalid && (vm.addFeedForm.ash.$dirty || vm.addFeedForm.$submitted)}"><label for="ash" class="span-label"><data-i18n i18n="_feeds_ash_">ash</data-i18n></label> <input type="number" format-input-value="ash" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="ash" id="ash" ng-model="vm.feedDTO.ash" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ash.$invalid && (vm.addFeedForm.ash.$dirty || vm.addFeedForm.$submitted)}"><label for="ash" class="span-label"><data-i18n i18n="_feeds_ash_">ash</data-i18n></label> <input type="number" format-input-value="ash" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="ash" id="ash" ng-model="vm.feedDTO.ash" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ca.$invalid && (vm.addFeedForm.ca.$dirty || vm.addFeedForm.$submitted)}"><label for="ca" class="span-label"><data-i18n i18n="_feeds_ca_">Ca</data-i18n></label> <input type="number" format-input-value="ca" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="ca" id="ca" ng-model="vm.feedDTO.ca" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ca.$invalid && (vm.addFeedForm.ca.$dirty || vm.addFeedForm.$submitted)}"><label for="ca" class="span-label"><data-i18n i18n="_feeds_ca_">Ca</data-i18n></label> <input type="number" format-input-value="ca" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="ca" id="ca" ng-model="vm.feedDTO.ca" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ca_abs.$invalid && (vm.addFeedForm.ca_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="ca_abs" class="span-label"><data-i18n i18n="_feeds_ca_abs_">abs Ca</data-i18n></label> <input type="number" format-input-value="ca_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="ca_abs" id="ca_abs" ng-model="vm.feedDTO.ca_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_ca_">ca</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.p.$invalid && (vm.addFeedForm.p.$dirty || vm.addFeedForm.$submitted)}"><label for="p" class="span-label"><data-i18n i18n="_feeds_p_">p</data-i18n></label> <input type="number" format-input-value="p" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="p" id="p" ng-model="vm.feedDTO.p" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.p.$invalid && (vm.addFeedForm.p.$dirty || vm.addFeedForm.$submitted)}"><label for="p" class="span-label"><data-i18n i18n="_feeds_p_">p</data-i18n></label> <input type="number" format-input-value="p" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="p" id="p" ng-model="vm.feedDTO.p" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.p_abs.$invalid && (vm.addFeedForm.p_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="p_abs" class="span-label"><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n></label> <input type="number" format-input-value="p_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="p_abs" id="p_abs" ng-model="vm.feedDTO.p_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_p_">p</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mg.$invalid && (vm.addFeedForm.mg.$dirty || vm.addFeedForm.$submitted)}"><label for="mg" class="span-label"><data-i18n i18n="_feeds_mg_">Mg</data-i18n></label> <input type="number" format-input-value="mg" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="mg" id="mg" ng-model="vm.feedDTO.mg" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mg.$invalid && (vm.addFeedForm.mg.$dirty || vm.addFeedForm.$submitted)}"><label for="mg" class="span-label"><data-i18n i18n="_feeds_mg_">Mg</data-i18n></label> <input type="number" format-input-value="mg" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="mg" id="mg" ng-model="vm.feedDTO.mg" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mg_abs.$invalid && (vm.addFeedForm.mg_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="mg_abs" class="span-label"><data-i18n i18n="_feeds_mg_abs_">abs Mg</data-i18n></label> <input type="number" format-input-value="mg_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="mg_abs" id="mg_abs" ng-model="vm.feedDTO.mg_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_mg_">Mg</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.k.$invalid && (vm.addFeedForm.k.$dirty || vm.addFeedForm.$submitted)}"><label for="k" class="span-label"><data-i18n i18n="_feeds_k_">K</data-i18n></label> <input type="number" format-input-value="k" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="k" id="k" ng-model="vm.feedDTO.k" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.k.$invalid && (vm.addFeedForm.k.$dirty || vm.addFeedForm.$submitted)}"><label for="k" class="span-label"><data-i18n i18n="_feeds_k_">K</data-i18n></label> <input type="number" format-input-value="k" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="k" id="k" ng-model="vm.feedDTO.k" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.na.$invalid && (vm.addFeedForm.na.$dirty || vm.addFeedForm.$submitted)}"><label for="na" class="span-label"><data-i18n i18n="_feeds_na_">Na</data-i18n></label> <input type="number" format-input-value="na" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="na" id="na" ng-model="vm.feedDTO.na" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.na.$invalid && (vm.addFeedForm.na.$dirty || vm.addFeedForm.$submitted)}"><label for="na" class="span-label"><data-i18n i18n="_feeds_na_">Na</data-i18n></label> <input type="number" format-input-value="na" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="na" id="na" ng-model="vm.feedDTO.na" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cl.$invalid && (vm.addFeedForm.cl.$dirty || vm.addFeedForm.$submitted)}"><label for="cl" class="span-label"><data-i18n i18n="_feeds_cl_">cl</data-i18n></label> <input type="number" format-input-value="cl" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="cl" id="cl" ng-model="vm.feedDTO.cl" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cl.$invalid && (vm.addFeedForm.cl.$dirty || vm.addFeedForm.$submitted)}"><label for="cl" class="span-label"><data-i18n i18n="_feeds_cl_">cl</data-i18n></label> <input type="number" format-input-value="cl" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="cl" id="cl" ng-model="vm.feedDTO.cl" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.s.$invalid && (vm.addFeedForm.s.$dirty || vm.addFeedForm.$submitted)}"><label for="s" class="span-label"><data-i18n i18n="_feeds_s_">s</data-i18n></label> <input type="number" format-input-value="s" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="s" id="s" ng-model="vm.feedDTO.s" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.s.$invalid && (vm.addFeedForm.s.$dirty || vm.addFeedForm.$submitted)}"><label for="s" class="span-label"><data-i18n i18n="_feeds_s_">s</data-i18n></label> <input type="number" format-input-value="s" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="s" id="s" ng-model="vm.feedDTO.s" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div></div></div></div></div><div class="panel t-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_trace_min_">Trace mineral</data-i18n></div><div class="panel-body"><div class="row"><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.co.$invalid && (vm.addFeedForm.co.$dirty || vm.addFeedForm.$submitted)}"><label for="co" class="span-label"><data-i18n i18n="_feeds_co_">co</data-i18n></label> <input type="number" format-input-value="co" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="co" id="co" ng-model="vm.feedDTO.co" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cu.$invalid && (vm.addFeedForm.cu.$dirty || vm.addFeedForm.$submitted)}"><label for="cu" class="span-label"><data-i18n i18n="_feeds_cu_">Cu</data-i18n></label> <input type="number" format-input-value="cu" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="cu" id="cu" ng-model="vm.feedDTO.cu" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cu_abs.$invalid && (vm.addFeedForm.cu_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="cu_abs" class="span-label"><data-i18n i18n="_feeds_cu_abs_">abs cu</data-i18n></label> <input type="number" format-input-value="cu_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="cu_abs" id="cu_abs" ng-model="vm.feedDTO.cu_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_cu_">Cu</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.fe.$invalid && (vm.addFeedForm.fe.$dirty || vm.addFeedForm.$submitted)}"><label for="fe" class="span-label"><data-i18n i18n="_feeds_fe_">fe</data-i18n></label> <input type="number" format-input-value="fe" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="fe" id="fe" ng-model="vm.feedDTO.fe" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.fe_abs.$invalid && (vm.addFeedForm.fe_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="fe_abs" class="span-label"><data-i18n i18n="_feeds_fe_abs_">abs fe</data-i18n></label> <input type="number" format-input-value="fe_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="fe_abs" id="fe_abs" ng-model="vm.feedDTO.fe_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_fe_">fe</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.i.$invalid && (vm.addFeedForm.i.$dirty || vm.addFeedForm.$submitted)}"><label for="i" class="span-label"><data-i18n i18n="_feeds_i_">i</data-i18n></label> <input type="number" format-input-value="i" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="i" id="i" ng-model="vm.feedDTO.i" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.i_abs.$invalid && (vm.addFeedForm.i_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="i_abs" class="span-label"><data-i18n i18n="_feeds_i_abs_">abs i</data-i18n></label> <input type="number" format-input-value="i_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="i_abs" id="i_abs" ng-model="vm.feedDTO.i_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_i_">i</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mo.$invalid && (vm.addFeedForm.mo.$dirty || vm.addFeedForm.$submitted)}"><label for="mo" class="span-label"><data-i18n i18n="_feeds_mo_">Mo</data-i18n></label> <input type="number" format-input-value="mo" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="1000000" min="0" class="form-control with-units" name="mo" id="mo" ng-model="vm.feedDTO.mo" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mn.$invalid && (vm.addFeedForm.mn.$dirty || vm.addFeedForm.$submitted)}"><label for="mn" class="span-label"><data-i18n i18n="_feeds_mn_">mn</data-i18n></label> <input type="number" format-input-value="mn" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="1000000" min="0" class="form-control with-units" name="mn" id="mn" ng-model="vm.feedDTO.mn" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mn_abs.$invalid && (vm.addFeedForm.mn_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="mn_abs" class="span-label"><data-i18n i18n="_feeds_mn_abs_">abs Mn</data-i18n></label> <input type="number" format-input-value="mn_abs" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="mn_abs" id="mn_abs" ng-model="vm.feedDTO.mn_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_mn_">mn</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.se.$invalid && (vm.addFeedForm.se.$dirty || vm.addFeedForm.$submitted)}"><label for="se" class="span-label"><data-i18n i18n="_feeds_se_">se</data-i18n></label> <input type="number" format-input-value="se" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="se" id="se" ng-model="vm.feedDTO.se" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.se_abs.$invalid && (vm.addFeedForm.se_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="se_abs" class="span-label"><data-i18n i18n="_feeds_se_abs_">abs se</data-i18n></label> <input type="number" format-input-value="se_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="se_abs" id="se_abs" ng-model="vm.feedDTO.se_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_se_">se</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.zn.$invalid && (vm.addFeedForm.zn.$dirty || vm.addFeedForm.$submitted)}"><label for="zn" class="span-label"><data-i18n i18n="_feeds_zn_">zn</data-i18n></label> <input type="number" format-input-value="zn" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="zn" id="zn" ng-model="vm.feedDTO.zn" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.zn_abs.$invalid && (vm.addFeedForm.zn_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="zn_abs" class="span-label"><data-i18n i18n="_feeds_zn_abs_">abs Zn</data-i18n></label> <input type="number" format-input-value="zn_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="zn_abs" id="zn_abs" ng-model="vm.feedDTO.zn_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_zn_">zn</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div></div></div></div></div><div class="first-third-grid"><div style="margin-top: 5px" class="panel cost-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_cost_">Cost</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cost_as_sold.$invalid && (vm.addFeedForm.cost_as_sold.$dirty || vm.addFeedForm.$submitted)}"><label for="cost_as_sold" class="span-label"><data-i18n i18n="_feeds_cost_as_sold_">Cost as sold</data-i18n></label> <input type="number" format-input-value="cost_as_sold" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000000" min="0" class="form-control with-units" name="cost_as_sold" id="cost_as_sold" ng-model="vm.feedDTO.cost_as_sold" select-on-click=""><span>{{ vm.currency }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.wt_as_sold.$invalid && (vm.addFeedForm.wt_as_sold.$dirty || vm.addFeedForm.$submitted)}"><label for="wt_as_sold" class="span-label"><data-i18n i18n="_feeds_wt_as_sold_">Wt as sold</data-i18n></label> <input type="number" format-input-value="wt_as_sold" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="wt_as_sold" id="wt_as_sold" ng-model="vm.feedDTO.wt_as_sold" select-on-click=""><span>{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="is_purchased" ng-true-value="1" ng-false-value="0" ng-model="vm.feedDTO.is_purchased" select-on-click=""> <span><data-i18n i18n="_feeds_purchased_">Purchased</data-i18n></span></label></div></div></div><div class="panel misc-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_misc_">Misc</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_1.$invalid && (vm.addFeedForm.blank_1.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_1" class="span-label"><data-i18n i18n="_feeds_blank_">Blank</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_1" id="blank_1" ng-model="vm.feedDTO.blank_1" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_2.$invalid && (vm.addFeedForm.blank_2.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_2" class="span-label"><data-i18n i18n="_feeds_blank_">Blank</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_2" id="blank_2" ng-model="vm.feedDTO.blank_2" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_3.$invalid && (vm.addFeedForm.blank_3.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_3" class="span-label"><data-i18n i18n="_feeds_blank_">Blank</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_3" id="blank_3" ng-model="vm.feedDTO.blank_3" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_4.$invalid && (vm.addFeedForm.blank_4.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_4" class="span-label"><data-i18n i18n="_feeds_blank_">Blank</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_4" id="blank_4" ng-model="vm.feedDTO.blank_4" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_5.$invalid && (vm.addFeedForm.blank_5.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_5" class="span-label"><data-i18n i18n="_feeds_blank_">Blank</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_5" id="blank_5" ng-model="vm.feedDTO.blank_5" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div></div></div><div class="panel comm-panel"><div class="panel-heading"></div><div class="panel-body"><div class="form-group"><label for="comments"><data-i18n i18n="_feeds_comment_">comment</data-i18n></label> <textarea placeholder="{{ \'_feeds_comment_\' | i18n }}" class="form-control" id="comments" style="resize: none" ng-model="vm.feedDTO.comments"></textarea></div><div align="right"><button type="submit" class="btn btn-success" ng-click="vm.saveFeed()"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div></div></form>');
$templateCache.put('app/pages/feeds/addNewFeed/confirmationDialog.modal.html','<div class="modal-content"><div class="modal-header" ng-if="!vm.modalLoading"><div style="margin-bottom: 5px" ng-if="vm.selected_herd.Id" class="form-group"><label style="font-size: 15px"><data-i18n i18n="_create_feed_for_herd_warning_">Are you sure you want to save this new feed for</data-i18n>&nbsp<b>{{vm.selected_herd.Name}}</b>?</label></div><div class="form-group"><label style="font-size: 15px" ng-if="!vm.selected_herd.Id"><data-i18n i18n="_herd_selection_for_feed_">Select herd</data-i18n></label> <label style="font-size: 15px" ng-if="vm.selected_herd.Id"><data-i18n i18n="_select_another_herd_">Select another herd</data-i18n></label><ui-select style="z-index: 9000 !important" ng-model="vm.selected_herd" class="btn-group bootstrap-select form-control" ng-disabled="vm.loadingTable" append-to-body="true" search-enabled="true"><ui-select-match>{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="type in vm.herds | filter: $select.search"><span ng-bind-html="type.Name"></span></ui-select-choices></ui-select></div><div ng-if="!vm.modalFeedType" class="form-group"><label style="font-size: 15px"><data-i18n i18n="_feeds_type_">Feed type</data-i18n></label><ui-select style="z-index: 9000 !important" ng-model="vm.feedTypesItemBlank" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match>{{ $select.selected.name | i18n }}</ui-select-match><ui-select-choices repeat="type in vm.feedTypesListBlank | filter: $select.search"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div><div class="form-group"><label style="font-size: 15px"><data-i18n i18n="_feeds_name_">Feed name</data-i18n>:&nbsp;<b class="wrap-text">{{vm.feedDTO.feed_name}}</b></label></div></div><div class="modal-body" ng-if="!vm.modalLoading"><div align="right"><button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="$dismiss()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button> <button type="button" class="btn btn-success btn-with-icon save-profile" ng-click="vm.saveFeedProceed()"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/feeds/addNewFeed/useExisting.table.html','<div ng-if="vm.isTeamSelected" class="vertical-scroll"><table class="table sort-table" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th colspan="6"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_feeds_search_feeds_label_">Search feeds</data-i18n></label> <input placeholder="{{\'_search_placeholder_feed_name_\'|i18n}}" class="form-control" type="text" style="margin-top: 5px" ng-model="vm.searchMaster" id="feedsSearchInput" ng-change="vm.searchMasterChanged()"></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><div class="form-group" style="text-align: left"><label style="margin-bottom: 9px"><data-i18n i18n="_feeds_my_master_">my/master</data-i18n></label><br><ui-select ng-model="vm.selectedFeedType" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.feedTypeSelected()"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.filterTypes | filter: $select.search" ui-disable-choice="vm.selectedFeedType.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_feeds_common_">Common</data-i18n></label><br><ui-select ng-model="vm.commonFeedItem" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.commonFeedChanged()"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type in vm.commonFeedList | filter: $select.search" ui-disable-choice="vm.commonFeedItem.name == type.name"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_picker_feed_type_placeholder_">Select feed type</data-i18n></label><br><ui-select ng-model="vm.feedTypesItem" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.feedTypeChanged()"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.feedTypesList | filter: $select.search" ui-disable-choice="vm.feedTypesItem.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div></th></tr><tr ng-if="vm.feedsLoaded" class="sortable"><th style="width: 5%"></th><th style="width: 25%" ng-click="vm.sort(\'feed_name\')"><data-i18n i18n="_feeds_name_">Feed name</data-i18n>&nbsp;<i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br></th><th style="width: 19%" ng-click="vm.sort(\'test_date\')"><data-i18n i18n="_feeds_test_date_">Test date</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'test_date_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'test_date_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br></th><th style="width: 17%" ng-click="vm.sort(\'dm\')"><data-i18n i18n="_feeds_dm_">dm</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span></th><th style="width: 17%" ng-click="vm.sort(\'cp\')"><data-i18n i18n="_feeds_cp_">cp</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th><th style="width: 17%" ng-click="vm.sort(\'ndf\')"><data-i18n i18n="_feeds_ndf_">ndf</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th></tr></thead><tbody id="scrollable" infinite-scroll="" scroll-fn="vm.paginationChangedMaster()" scroll-no-all="vm.totalItemsMaster" scroll-no-displayed="vm.feeds.length" scroll-disable="vm.disableScroll" ng-if="vm.feedsLoaded"><tr ng-repeat="feed in vm.feeds"><td style="width: 5%"><a class="ion-plus-circled icon-edit" href="" ng-click="vm.selectFeed(feed.id)"></a></td><td style="width: 25%" ng-click="vm.selectFeed(feed.id)" class="hover-cell">{{feed.feed_name}}</td><td style="width: 19%">{{feed.test_date | date:\'mediumDate\'}}</td><td style="width: 17%">{{feed.dm | formatViewValues: \'dm\'}}</td><td style="width: 17%">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td style="width: 17%">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td></tr><tr ng-if="vm.disableScroll"><td><data-i18n i18n="_title_loading_">Loading...</data-i18n></td></tr></tbody><tbody ng-if="!vm.feedsLoaded"><tr><td colspan="5"><div id="loading-animation-large"></div></td></tr></tbody><tfoot></tfoot></table></div><div ng-if="vm.feedsLoaded && !vm.isTeamSelected" align="center"><div><h3><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></h3></div></div>');
$templateCache.put('app/pages/feeds/editFeed/confirmationDialog.modal.html','<div class="modal-content"><div class="modal-header" ng-if="!vm.modalLoading"><div style="margin-bottom: 5px" ng-if="vm.selected_herd.Id" class="form-group"><label style="font-size: 15px"><data-i18n i18n="_create_feed_for_herd_warning_">Are you sure you want to save this new feed for</data-i18n>&nbsp<b>{{vm.selected_herd.Name}}</b>?</label></div><div class="form-group"><label style="font-size: 15px" ng-if="!vm.selected_herd.Id"><data-i18n i18n="_herd_selection_for_feed_">Select herd</data-i18n></label> <label style="font-size: 15px" ng-if="vm.selected_herd.Id"><data-i18n i18n="_select_another_herd_">Select another herd</data-i18n></label><ui-select style="z-index: 9000 !important" ng-model="vm.selected_herd" class="btn-group bootstrap-select form-control" ng-disabled="vm.loadingTable" append-to-body="true" search-enabled="true"><ui-select-match>{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="type in vm.herds | filter: $select.search"><span ng-bind-html="type.Name"></span></ui-select-choices></ui-select></div><div ng-if="!vm.modalFeedType" class="form-group"><label style="font-size: 15px"><data-i18n i18n="_feeds_type_">Feed type</data-i18n></label><ui-select style="z-index: 9000 !important" ng-model="vm.feedTypesItem" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match>{{ $select.selected.name | i18n }}</ui-select-match><ui-select-choices repeat="type in vm.feedTypesList | filter: $select.search"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div><div class="form-group"><label style="font-size: 15px"><data-i18n i18n="_feeds_name_">Feed name</data-i18n>:&nbsp;<b class="wrap-text">{{vm.feedDTO.feed_name}}</b></label></div></div><div class="modal-body" ng-if="!vm.modalLoading"><div align="right"><button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="$dismiss()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button> <button type="button" class="btn btn-success btn-with-icon save-profile" ng-click="vm.saveFeedProceed()"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px; overflow: hidden"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/feeds/editFeed/editFeed.html','<div ng-if="vm.feedCalculationType != null || vm.feedCalculationType != undefined" ba-panel="" class="ng-cloak"><div class="row"><div class="col-xlg-2 col-lg-4 col-md-4 col-sm-6 col-xs-6"><div class="form-group"><div ng-if="!vm.loading"><label><data-i18n i18n="_report_unit_">Unit</data-i18n></label><ui-select ng-model="vm.selectedUnit" class="btn-group bootstrap-select form-control custom-dropdown" ng-disabled="vm.loadingTable" append-to-body="true" search-enabled="true" on-select="vm.changeUnit(vm.showPanels, vm.showPicker)"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type in vm.unitList | filter: $select.search" ui-disable-choice="vm.selectedUnit.name == type.name"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div></div></div></div><div ng-if="vm.feedDTO && vm.feedCalculationType == 0" include-with-scope="app/pages/feeds/editFeed/editFeedsUS.html"></div><div ng-if="vm.feedDTO && vm.feedCalculationType == 1" include-with-scope="app/pages/feeds/editFeed/editFeedsVemDve.html"></div><div align="center" style="overflow: hidden" ng-if="vm.loading"><div id="loading-animation-large"></div></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" class="ng-cloak"><div class="row"><div class="col-xlg-2 col-lg-4 col-md-4 col-sm-6 col-xs-6"><div class="form-group"><div ng-if="!vm.loading"><label><data-i18n i18n="_report_unit_">Unit</data-i18n></label><ui-select ng-model="vm.selectedUnit" class="btn-group bootstrap-select form-control custom-dropdown" ng-disabled="vm.loadingTable" append-to-body="true" search-enabled="true" on-select="vm.changeUnit(vm.showPanels, vm.showPicker)"><ui-select-match>{{$select.selected}}</ui-select-match><ui-select-choices repeat="type in vm.unitList | filter: $select.search" ui-disable-choice="vm.selectedUnit.name == type.name"><span ng-bind-html="type"></span></ui-select-choices></ui-select></div></div></div></div><div ng-if="vm.feedDTO && vm.settings.calculation_type == 0" include-with-scope="app/pages/feeds/editFeed/editFeedsUS.html"></div><div ng-if="vm.feedDTO && vm.settings.calculation_type == 1" include-with-scope="app/pages/feeds/editFeed/editFeedsVemDve.html"></div><div align="center" ng-if="vm.loading" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/editFeed/editFeedsUS.html','<div class="panel-group" ng-if="!vm.loading"><form name="vm.addFeedForm"><div class="first-third-grid"><div style="margin-top: 5px" class="panel g-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_general_">General</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.feed_name.$invalid && (vm.addFeedForm.feed_name.$dirty || vm.addFeedForm.$submitted)}"><label for="feed_name"><data-i18n i18n="_feeds_name_">Feed name</data-i18n></label> <input type="text" class="form-control" id="feed_name" placeholder="{{ \'_feeds_name_\' | i18n }}" ng-model="vm.feedDTO.feed_name" required="" name="feed_name" maxlength="60" select-on-click=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.test_date.$invalid && (vm.addFeedForm.test_date.$dirty || vm.addFeedForm.$submitted)}"><label for="test_date"><data-i18n i18n="_feeds_test_date_">Test date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.date_format}}" placeholder="{{vm.date_format}}" datepicker-options="vm.options" ng-model="vm.test_date" is-open="vm.DPOpened" ng-required="true" close-text="Close" show-button-bar="false" id="test_date" name="test_date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openDatePicker()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.dm.$invalid && (vm.addFeedForm.dm.$dirty || vm.addFeedForm.$submitted)}"><label for="dm" class="span-label"><data-i18n i18n="_feeds_dm_">DM</data-i18n></label> <input type="number" format-input-value="dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0.01" class="form-control with-units" required="" name="dm" id="dm" ng-model="vm.feedDTO.dm" select-on-click=""><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0.01&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.dm.$invalid && (vm.addFeedForm.dm.$dirty || vm.addFeedForm.$submitted)}"><label for="dm" class="span-label"><data-i18n i18n="_feeds_dm_">DM</data-i18n></label> <input type="number" format-input-value="dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000" min="0.01" class="form-control with-units" required="" name="dm" id="dm" ng-model="vm.feedDTO.dm" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0.01&nbsp;&&nbsp;1000</span></div><div class="form-group"><label for="feed_type"><data-i18n i18n="_feeds_type_">Feed type</data-i18n></label><ui-select ng-model="vm.feedTypesItem" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" on-select="vm.newFeedTypeChanged()"><ui-select-match>{{ $select.selected.name | i18n }}</ui-select-match><ui-select-choices repeat="type in vm.feedTypesList | filter: $select.search"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="common_feed" ng-model="vm.feedDTO.common_feed"> <span><data-i18n i18n="_feeds_common_">Common feed</data-i18n></span></label></div></div></div><div class="panel f-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_fiber_">Fiber</data-i18n></div><div class="panel-body"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ndf.$invalid && (vm.addFeedForm.ndf.$dirty || vm.addFeedForm.$submitted)}"><label for="ndf" class="span-label"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n></label> <input type="number" format-input-value="ndf" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="ndf" id="ndf" ng-model="vm.feedDTO.ndf" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ndf.$invalid && (vm.addFeedForm.ndf.$dirty || vm.addFeedForm.$submitted)}"><label for="ndf" class="span-label"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n></label> <input type="number" format-input-value="ndf" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="ndf" id="ndf" ng-model="vm.feedDTO.ndf" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ndf_digest.$invalid && (vm.addFeedForm.ndf_digest.$dirty || vm.addFeedForm.$submitted)}"><label for="ndf_digest" class="span-label"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n></label> <input type="number" format-input-value="ndf_digest" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="ndf_digest" id="ndf_digest" ng-model="vm.feedDTO.ndf_digest" select-on-click=""><span>%<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ef_ndf_as_ndf.$invalid && (vm.addFeedForm.ef_ndf_as_ndf.$dirty || vm.addFeedForm.$submitted)}"><label for="ef_ndf_as_ndf" class="span-label"><data-i18n i18n="_feeds_efndf_">efNDF</data-i18n></label> <input type="number" format-input-value="ef_ndf_as_ndf" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="ef_ndf_as_ndf" id="ef_ndf_as_ndf" ng-model="vm.feedDTO.ef_ndf_as_ndf" select-on-click=""><span>%<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.adf.$invalid && (vm.addFeedForm.adf.$dirty || vm.addFeedForm.$submitted)}"><label for="adf" class="span-label"><data-i18n i18n="_feeds_adf_">ADF</data-i18n></label> <input type="number" format-input-value="adf" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="adf" id="adf" ng-model="vm.feedDTO.adf" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.adf.$invalid && (vm.addFeedForm.adf.$dirty || vm.addFeedForm.$submitted)}"><label for="adf" class="span-label"><data-i18n i18n="_feeds_adf_">ADF</data-i18n></label> <input type="number" format-input-value="adf" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="adf" id="adf" ng-model="vm.feedDTO.adf" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.lignin.$invalid && (vm.addFeedForm.lignin.$dirty || vm.addFeedForm.$submitted)}"><label for="lignin" class="span-label"><data-i18n i18n="_feeds_lingnin_">Lignin</data-i18n></label> <input type="number" format-input-value="lignin" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="lignin" id="lignin" ng-model="vm.feedDTO.lignin" select-on-click=""> <span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.lignin.$invalid && (vm.addFeedForm.lignin.$dirty || vm.addFeedForm.$submitted)}"><label for="lignin" class="span-label"><data-i18n i18n="_feeds_lingnin_">Lignin</data-i18n></label> <input type="number" format-input-value="lignin" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="lignin" id="lignin" ng-model="vm.feedDTO.lignin" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.rd_ndf.$invalid && (vm.addFeedForm.rd_ndf.$dirty || vm.addFeedForm.$submitted)}"><label for="rd_ndf" class="span-label"><data-i18n i18n="_feeds_rdndf_">RDNDF</data-i18n></label> <input type="number" format-input-value="rd_ndf" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="rd_ndf" id="rd_ndf" ng-model="vm.feedDTO.rd_ndf" select-on-click=""> <span>%<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div></div><div class="panel e-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_energy_">Energy</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.disc_fac.$invalid && (vm.addFeedForm.disc_fac.$dirty || vm.addFeedForm.$submitted)}"><label for="disc_fac" class="span-label"><data-i18n i18n="_feeds_disc_fac_">Disc. Fac.</data-i18n></label> <input type="number" format-input-value="disc_fac" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="disc_fac" id="disc_fac" ng-model="vm.feedDTO.disc_fac" select-on-click=""> <span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.nel_89.$invalid && (vm.addFeedForm.nel_89.$dirty || vm.addFeedForm.$submitted)}"><label for="nel_89" class="span-label"><data-i18n i18n="_feeds_nel89_">NEL 89</data-i18n></label> <input type="number" format-input-value="nel_89" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="{{vm.nel_89Max}}" min="0" class="form-control with-units" name="nel_89" id="nel_89" ng-model="vm.feedDTO.nel_89" select-on-click=""><span>{{ vm.energy }}/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;{{vm.nel_89Max}}</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.me_89.$invalid && (vm.addFeedForm.me_89.$dirty || vm.addFeedForm.$submitted)}"><label for="me_89" class="span-label"><data-i18n i18n="_feeds_me89_">ME 89</data-i18n></label> <input type="number" format-input-value="me_89" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="{{vm.me_89max}}" min="0" class="form-control with-units" name="me_89" id="me_89" ng-model="vm.feedDTO.me_89" select-on-click=""><span>{{ vm.energy }}/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;{{vm.me_89max}}</span></div></div></div><div class="panel p-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_protein_">Protein</data-i18n></div><div class="panel-body"><div class="row"><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cp.$invalid && (vm.addFeedForm.cp.$dirty || vm.addFeedForm.$submitted)}"><label for="cp" class="span-label"><data-i18n i18n="_feeds_cp_">cp</data-i18n></label> <input type="number" format-input-value="cp" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="cp" id="cp" ng-model="vm.feedDTO.cp" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cp.$invalid && (vm.addFeedForm.cp.$dirty || vm.addFeedForm.$submitted)}"><label for="cp" class="span-label"><data-i18n i18n="_feeds_cp_">cp</data-i18n></label> <input type="number" format-input-value="cp" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="cp" id="cp" ng-model="vm.feedDTO.cp" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.rup_dig.$invalid && (vm.addFeedForm.rup_dig.$dirty || vm.addFeedForm.$submitted)}"><label for="rup_dig" class="span-label"><data-i18n i18n="_feeds_rup_dig_">rup dig</data-i18n></label> <input type="number" format-input-value="rup_dig" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="rup_dig" id="rup_dig" ng-model="vm.feedDTO.rup_dig" select-on-click=""><span>%<data-i18n i18n="_feeds_cp_">cp</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.b_prot.$invalid && (vm.addFeedForm.b_prot.$dirty || vm.addFeedForm.$submitted)}"><label for="b_prot" class="span-label"><data-i18n i18n="_feeds_protein_b_">B prot</data-i18n></label> <input type="number" format-input-value="b_prot" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="b_prot" id="b_prot" ng-model="vm.feedDTO.b_prot" select-on-click=""><span>%<data-i18n i18n="_feeds_cp_">cp</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.c_prot.$invalid && (vm.addFeedForm.c_prot.$dirty || vm.addFeedForm.$submitted)}"><label for="c_prot" class="span-label"><data-i18n i18n="_feeds_protein_c_">C prot</data-i18n></label> <input type="number" format-input-value="c_prot" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="c_prot" id="c_prot" ng-model="vm.feedDTO.c_prot" select-on-click=""><span>%<data-i18n i18n="_feeds_cp_">cp</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.kd_b_prot.$invalid && (vm.addFeedForm.kd_b_prot.$dirty || vm.addFeedForm.$submitted)}"><label for="kd_b_prot" class="span-label"><data-i18n i18n="_feeds_kd_bprot_">kd Bprot</data-i18n></label> <input type="number" format-input-value="kd_b_prot" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="kd_b_prot" id="kd_b_prot" ng-model="vm.feedDTO.kd_b_prot" select-on-click=""><span>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.npncpe.$invalid && (vm.addFeedForm.npncpe.$dirty || vm.addFeedForm.$submitted)}"><label for="npncpe" class="span-label"><data-i18n i18n="_feeds_npncpe_">NPNCPE</data-i18n></label> <input type="number" format-input-value="npncpe" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="npncpe" id="npncpe" ng-model="vm.feedDTO.npncpe" select-on-click=""><span>%<data-i18n i18n="_feeds_cp_">cp</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.rup_89.$invalid && (vm.addFeedForm.rup_89.$dirty || vm.addFeedForm.$submitted)}"><label for="rup_89" class="span-label"><data-i18n i18n="_feeds_rup89_">rup 89</data-i18n></label> <input type="number" format-input-value="rup_89" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="rup_89" id="rup_89" ng-model="vm.feedDTO.rup_89" select-on-click=""><span>%<data-i18n i18n="_feeds_cp_">cp</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ndicp.$invalid && (vm.addFeedForm.ndicp.$dirty || vm.addFeedForm.$submitted)}"><label for="ndicp" class="span-label"><data-i18n i18n="_feeds_ndicp_">ndicp</data-i18n></label> <input type="number" format-input-value="ndicp" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="ndicp" id="ndicp" ng-model="vm.feedDTO.ndicp" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ndicp.$invalid && (vm.addFeedForm.ndicp.$dirty || vm.addFeedForm.$submitted)}"><label for="ndicp" class="span-label"><data-i18n i18n="_feeds_ndicp_">ndicp</data-i18n></label> <input type="number" format-input-value="ndicp" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="ndicp" id="ndicp" ng-model="vm.feedDTO.ndicp" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.adicp.$invalid && (vm.addFeedForm.adicp.$dirty || vm.addFeedForm.$submitted)}"><label for="adicp" class="span-label"><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n></label> <input type="number" format-input-value="adicp" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="adicp" id="adicp" ng-model="vm.feedDTO.adicp" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.adicp.$invalid && (vm.addFeedForm.adicp.$dirty || vm.addFeedForm.$submitted)}"><label for="adicp" class="span-label"><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n></label> <input type="number" format-input-value="adicp" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="adicp" id="adicp" ng-model="vm.feedDTO.adicp" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div></div></div></div></div><div class="panel c-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_carb_">Carbohydrates</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.nfc_dig.$invalid && (vm.addFeedForm.nfc_dig.$dirty || vm.addFeedForm.$submitted)}"><label for="nfc_dig" class="span-label"><data-i18n i18n="_feeds_nfc_digestibility_">NFC dig</data-i18n></label> <input type="number" format-input-value="nfc_dig" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="nfc_dig" id="nfc_dig" ng-model="vm.feedDTO.nfc_dig" select-on-click=""><span>%<data-i18n i18n="_feeds_nfc_">NFC</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.sugar.$invalid && (vm.addFeedForm.sugar.$dirty || vm.addFeedForm.$submitted)}"><label for="sugar" class="span-label"><data-i18n i18n="_feeds_sugar_">Sugar</data-i18n></label> <input type="number" format-input-value="sugar" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="sugar" id="sugar" ng-model="vm.feedDTO.sugar" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.sugar.$invalid && (vm.addFeedForm.sugar.$dirty || vm.addFeedForm.$submitted)}"><label for="sugar" class="span-label"><data-i18n i18n="_feeds_sugar_">Sugar</data-i18n></label> <input type="number" format-input-value="sugar" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="sugar" id="sugar" ng-model="vm.feedDTO.sugar" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.starch.$invalid && (vm.addFeedForm.starch.$dirty || vm.addFeedForm.$submitted)}"><label for="starch" class="span-label"><data-i18n i18n="_feeds_starch_">Starch</data-i18n></label> <input type="number" format-input-value="starch" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="starch" id="starch" ng-model="vm.feedDTO.starch" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.starch.$invalid && (vm.addFeedForm.starch.$dirty || vm.addFeedForm.$submitted)}"><label for="starch" class="span-label"><data-i18n i18n="_feeds_starch_">Starch</data-i18n></label> <input type="number" format-input-value="starch" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="starch" id="starch" ng-model="vm.feedDTO.starch" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.in_fa.$invalid && (vm.addFeedForm.in_fa.$dirty || vm.addFeedForm.$submitted)}"><label for="in_fa" class="span-label"><data-i18n i18n="_feeds_infa_">INFA</data-i18n></label> <input type="number" format-input-value="in_fa" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="in_fa" id="in_fa" ng-model="vm.feedDTO.in_fa" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.in_fa.$invalid && (vm.addFeedForm.in_fa.$dirty || vm.addFeedForm.$submitted)}"><label for="in_fa" class="span-label"><data-i18n i18n="_feeds_infa_">INFA</data-i18n></label> <input type="number" format-input-value="in_fa" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="in_fa" id="in_fa" ng-model="vm.feedDTO.in_fa" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.rd_starch.$invalid && (vm.addFeedForm.rd_starch.$dirty || vm.addFeedForm.$submitted)}"><label for="rd_starch" class="span-label"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n></label> <input type="number" format-input-value="rd_starch" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="rd_starch" id="rd_starch" ng-model="vm.feedDTO.rd_starch" select-on-click=""><span>%<data-i18n i18n="_feeds_starch_">Starch</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.rd_sol_fiber.$invalid && (vm.addFeedForm.rd_sol_fiber.$dirty || vm.addFeedForm.$submitted)}"><label for="rd_sol_fiber" class="span-label"><data-i18n i18n="_feeds_rdsolf_">RDSolf</data-i18n></label> <input type="number" format-input-value="rd_sol_fiber" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="rd_sol_fiber" id="rd_sol_fiber" ng-model="vm.feedDTO.rd_sol_fiber" select-on-click=""><span>%<data-i18n i18n="_feeds_solfiber_">SolF</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div></div><div class="panel l-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_lipid_">Lipid</data-i18n></div><div class="panel-body"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ee.$invalid && (vm.addFeedForm.ee.$dirty || vm.addFeedForm.$submitted)}"><label for="ee" class="span-label"><data-i18n i18n="_feeds_ee_">EE</data-i18n></label> <input type="number" format-input-value="ee" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="ee" id="ee" ng-model="vm.feedDTO.ee" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ee.$invalid && (vm.addFeedForm.ee.$dirty || vm.addFeedForm.$submitted)}"><label for="ee" class="span-label"><data-i18n i18n="_feeds_ee_">EE</data-i18n></label> <input type="number" format-input-value="ee" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="ee" id="ee" ng-model="vm.feedDTO.ee" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.bhfa.$invalid && (vm.addFeedForm.bhfa.$dirty || vm.addFeedForm.$submitted)}"><label for="bhfa" class="span-label"><data-i18n i18n="_feeds_bhfa_">BHFA</data-i18n></label> <input type="number" format-input-value="bhfa" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="bhfa" id="bhfa" ng-model="vm.feedDTO.bhfa" select-on-click=""> <span>%<data-i18n i18n="_feeds_fa_">FA</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.pufa.$invalid && (vm.addFeedForm.pufa.$dirty || vm.addFeedForm.$submitted)}"><label for="pufa" class="span-label"><data-i18n i18n="_feeds_pufa_">PUFA</data-i18n></label> <input type="number" format-input-value="pufa" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="pufa" id="pufa" ng-model="vm.feedDTO.pufa" select-on-click=""> <span>%<data-i18n i18n="_feeds_fa_">FA</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.sfa.$invalid && (vm.addFeedForm.sfa.$dirty || vm.addFeedForm.$submitted)}"><label for="sfa" class="span-label"><data-i18n i18n="_feeds_sfa_">SFA</data-i18n></label> <input type="number" format-input-value="sfa" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="sfa" id="sfa" ng-model="vm.feedDTO.sfa" select-on-click=""> <span>%<data-i18n i18n="_feeds_fa_">FA</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.fa_dig.$invalid && (vm.addFeedForm.fa_dig.$dirty || vm.addFeedForm.$submitted)}"><label for="fa_dig" class="span-label"><data-i18n i18n="_feeds_fa_dig_">FA dig</data-i18n></label> <input type="number" format-input-value="fa_dig" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="fa_dig" id="fa_dig" ng-model="vm.feedDTO.fa_dig" select-on-click=""> <span>%<data-i18n i18n="_feeds_fa_">FA</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div></div><div class="panel v-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_vitamin_">Vitamin</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.vitamin_a.$invalid && (vm.addFeedForm.vitamin_a.$dirty || vm.addFeedForm.$submitted)}"><label for="vitamin_a" class="span-label"><data-i18n i18n="_feeds_vit_a_">Vitamin A</data-i18n></label> <input type="number" format-input-value="vitamin_a" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="vitamin_a" id="vitamin_a" ng-model="vm.feedDTO.vitamin_a" select-on-click=""><span><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.vitamin_d.$invalid && (vm.addFeedForm.vitamin_d.$dirty || vm.addFeedForm.$submitted)}"><label for="vitamin_d" class="span-label"><data-i18n i18n="_feeds_vit_d_">Vitamin D</data-i18n></label> <input type="number" format-input-value="vitamin_d" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="vitamin_d" id="vitamin_d" ng-model="vm.feedDTO.vitamin_d" select-on-click=""> <span><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.vitamin_e.$invalid && (vm.addFeedForm.vitamin_e.$dirty || vm.addFeedForm.$submitted)}"><label for="vitamin_e" class="span-label"><data-i18n i18n="_feeds_vit_e_">Vitamin E</data-i18n></label> <input type="number" format-input-value="vitamin_e" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="vitamin_e" id="vitamin_e" ng-model="vm.feedDTO.vitamin_e" select-on-click=""> <span><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div></div></div><div class="panel aa-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_amino_acid_">Amino Acid</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.lysine.$invalid && (vm.addFeedForm.lysine.$dirty || vm.addFeedForm.$submitted)}"><label for="lysine" class="span-label"><data-i18n i18n="_feeds_lysine_">Lys</data-i18n></label> <input type="number" format-input-value="lysine" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="lysine" id="lysine" ng-model="vm.feedDTO.lysine" select-on-click=""><span>%<data-i18n i18n="_feeds_drup_">dRUP</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.methionine.$invalid && (vm.addFeedForm.methionine.$dirty || vm.addFeedForm.$submitted)}"><label for="methionine" class="span-label"><data-i18n i18n="_feeds_methionine_">Met</data-i18n></label> <input type="number" format-input-value="methionine" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="methionine" id="methionine" ng-model="vm.feedDTO.methionine" select-on-click=""><span>%<data-i18n i18n="_feeds_drup_">dRUP</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.teaa.$invalid && (vm.addFeedForm.teaa.$dirty || vm.addFeedForm.$submitted)}"><label for="teaa" class="span-label"><data-i18n i18n="_feeds_teaa_">TEAA</data-i18n></label> <input type="number" format-input-value="teaa" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="teaa" id="teaa" ng-model="vm.feedDTO.teaa" select-on-click=""> <span>%<data-i18n i18n="_feeds_drup_">dRUP</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div></div></div><div class="second-grid"><div style="margin-top: 5px" class="panel m-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_mineral_">Mineral</data-i18n></div><div class="panel-body"><div class="row"><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ash.$invalid && (vm.addFeedForm.ash.$dirty || vm.addFeedForm.$submitted)}"><label for="ash" class="span-label"><data-i18n i18n="_feeds_ash_">ash</data-i18n></label> <input type="number" format-input-value="ash" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="ash" id="ash" ng-model="vm.feedDTO.ash" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ash.$invalid && (vm.addFeedForm.ash.$dirty || vm.addFeedForm.$submitted)}"><label for="ash" class="span-label"><data-i18n i18n="_feeds_ash_">ash</data-i18n></label> <input type="number" format-input-value="ash" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="ash" id="ash" ng-model="vm.feedDTO.ash" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ca.$invalid && (vm.addFeedForm.ca.$dirty || vm.addFeedForm.$submitted)}"><label for="ca" class="span-label"><data-i18n i18n="_feeds_ca_">Ca</data-i18n></label> <input type="number" format-input-value="ca" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="ca" id="ca" ng-model="vm.feedDTO.ca" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ca.$invalid && (vm.addFeedForm.ca.$dirty || vm.addFeedForm.$submitted)}"><label for="ca" class="span-label"><data-i18n i18n="_feeds_ca_">Ca</data-i18n></label> <input type="number" format-input-value="ca" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="ca" id="ca" ng-model="vm.feedDTO.ca" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ca_abs.$invalid && (vm.addFeedForm.ca_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="ca_abs" class="span-label"><data-i18n i18n="_feeds_ca_abs_">abs Ca</data-i18n></label> <input type="number" format-input-value="ca_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="ca_abs" id="ca_abs" ng-model="vm.feedDTO.ca_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_ca_">ca</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.p.$invalid && (vm.addFeedForm.p.$dirty || vm.addFeedForm.$submitted)}"><label for="p" class="span-label"><data-i18n i18n="_feeds_p_">p</data-i18n></label> <input type="number" format-input-value="p" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="p" id="p" ng-model="vm.feedDTO.p" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.p.$invalid && (vm.addFeedForm.p.$dirty || vm.addFeedForm.$submitted)}"><label for="p" class="span-label"><data-i18n i18n="_feeds_p_">p</data-i18n></label> <input type="number" format-input-value="p" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="p" id="p" ng-model="vm.feedDTO.p" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.p_abs.$invalid && (vm.addFeedForm.p_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="p_abs" class="span-label"><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n></label> <input type="number" format-input-value="p_abs" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="p_abs" id="p_abs" ng-model="vm.feedDTO.p_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_p_">p</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mg.$invalid && (vm.addFeedForm.mg.$dirty || vm.addFeedForm.$submitted)}"><label for="mg" class="span-label"><data-i18n i18n="_feeds_mg_">Mg</data-i18n></label> <input type="number" format-input-value="mg" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="mg" id="mg" ng-model="vm.feedDTO.mg" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mg.$invalid && (vm.addFeedForm.mg.$dirty || vm.addFeedForm.$submitted)}"><label for="mg" class="span-label"><data-i18n i18n="_feeds_mg_">Mg</data-i18n></label> <input type="number" format-input-value="mg" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="mg" id="mg" ng-model="vm.feedDTO.mg" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mg_abs.$invalid && (vm.addFeedForm.mg_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="mg_abs" class="span-label"><data-i18n i18n="_feeds_mg_abs_">abs Mg</data-i18n></label> <input type="number" format-input-value="mg_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="mg_abs" id="mg_abs" ng-model="vm.feedDTO.mg_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_mg_">Mg</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.k.$invalid && (vm.addFeedForm.k.$dirty || vm.addFeedForm.$submitted)}"><label for="k" class="span-label"><data-i18n i18n="_feeds_k_">K</data-i18n></label> <input type="number" format-input-value="k" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="k" id="k" ng-model="vm.feedDTO.k" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.k.$invalid && (vm.addFeedForm.k.$dirty || vm.addFeedForm.$submitted)}"><label for="k" class="span-label"><data-i18n i18n="_feeds_k_">K</data-i18n></label> <input type="number" format-input-value="k" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="k" id="k" ng-model="vm.feedDTO.k" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.na.$invalid && (vm.addFeedForm.na.$dirty || vm.addFeedForm.$submitted)}"><label for="na" class="span-label"><data-i18n i18n="_feeds_na_">Na</data-i18n></label> <input type="number" format-input-value="na" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="na" id="na" ng-model="vm.feedDTO.na" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.na.$invalid && (vm.addFeedForm.na.$dirty || vm.addFeedForm.$submitted)}"><label for="na" class="span-label"><data-i18n i18n="_feeds_na_">Na</data-i18n></label> <input type="number" format-input-value="na" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="na" id="na" ng-model="vm.feedDTO.na" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cl.$invalid && (vm.addFeedForm.cl.$dirty || vm.addFeedForm.$submitted)}"><label for="cl" class="span-label"><data-i18n i18n="_feeds_cl_">cl</data-i18n></label> <input type="number" format-input-value="cl" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="cl" id="cl" ng-model="vm.feedDTO.cl" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cl.$invalid && (vm.addFeedForm.cl.$dirty || vm.addFeedForm.$submitted)}"><label for="cl" class="span-label"><data-i18n i18n="_feeds_cl_">cl</data-i18n></label> <input type="number" format-input-value="cl" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="cl" id="cl" ng-model="vm.feedDTO.cl" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.s.$invalid && (vm.addFeedForm.s.$dirty || vm.addFeedForm.$submitted)}"><label for="s" class="span-label"><data-i18n i18n="_feeds_s_">s</data-i18n></label> <input type="number" format-input-value="s" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="s" id="s" ng-model="vm.feedDTO.s" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.s.$invalid && (vm.addFeedForm.s.$dirty || vm.addFeedForm.$submitted)}"><label for="s" class="span-label"><data-i18n i18n="_feeds_s_">s</data-i18n></label> <input type="number" format-input-value="s" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="s" id="s" ng-model="vm.feedDTO.s" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div></div></div></div></div><div class="panel t-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_trace_min_">Trace mineral</data-i18n></div><div class="panel-body"><div class="row"><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.co.$invalid && (vm.addFeedForm.co.$dirty || vm.addFeedForm.$submitted)}"><label for="co" class="span-label"><data-i18n i18n="_feeds_co_">co</data-i18n></label> <input type="number" format-input-value="co" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="co" id="co" ng-model="vm.feedDTO.co" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cu.$invalid && (vm.addFeedForm.cu.$dirty || vm.addFeedForm.$submitted)}"><label for="cu" class="span-label"><data-i18n i18n="_feeds_cu_">Cu</data-i18n></label> <input type="number" format-input-value="cu" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="cu" id="cu" ng-model="vm.feedDTO.cu" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cu_abs.$invalid && (vm.addFeedForm.cu_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="cu_abs" class="span-label"><data-i18n i18n="_feeds_cu_abs_">abs cu</data-i18n></label> <input type="number" format-input-value="cu_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="cu_abs" id="cu_abs" ng-model="vm.feedDTO.cu_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_cu_">Cu</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.fe.$invalid && (vm.addFeedForm.fe.$dirty || vm.addFeedForm.$submitted)}"><label for="fe" class="span-label"><data-i18n i18n="_feeds_fe_">fe</data-i18n></label> <input type="number" format-input-value="fe" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="fe" id="fe" ng-model="vm.feedDTO.fe" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.fe_abs.$invalid && (vm.addFeedForm.fe_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="fe_abs" class="span-label"><data-i18n i18n="_feeds_fe_abs_">abs fe</data-i18n></label> <input type="number" format-input-value="fe_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="fe_abs" id="fe_abs" ng-model="vm.feedDTO.fe_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_fe_">fe</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.i.$invalid && (vm.addFeedForm.i.$dirty || vm.addFeedForm.$submitted)}"><label for="i" class="span-label"><data-i18n i18n="_feeds_i_">i</data-i18n></label> <input type="number" format-input-value="i" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="i" id="i" ng-model="vm.feedDTO.i" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.i_abs.$invalid && (vm.addFeedForm.i_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="i_abs" class="span-label"><data-i18n i18n="_feeds_i_abs_">abs i</data-i18n></label> <input type="number" format-input-value="i_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="i_abs" id="i_abs" ng-model="vm.feedDTO.i_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_i_">i</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mo.$invalid && (vm.addFeedForm.mo.$dirty || vm.addFeedForm.$submitted)}"><label for="mo" class="span-label"><data-i18n i18n="_feeds_mo_">Mo</data-i18n></label> <input type="number" format-input-value="mo" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="1000000" min="0" class="form-control with-units" name="mo" id="mo" ng-model="vm.feedDTO.mo" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mn.$invalid && (vm.addFeedForm.mn.$dirty || vm.addFeedForm.$submitted)}"><label for="mn" class="span-label"><data-i18n i18n="_feeds_mn_">mn</data-i18n></label> <input type="number" format-input-value="mn" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="1000000" min="0" class="form-control with-units" name="mn" id="mn" ng-model="vm.feedDTO.mn" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mn_abs.$invalid && (vm.addFeedForm.mn_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="mn_abs" class="span-label"><data-i18n i18n="_feeds_mn_abs_">abs Mn</data-i18n></label> <input type="number" format-input-value="mn_abs" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="mn_abs" id="mn_abs" ng-model="vm.feedDTO.mn_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_mn_">mn</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.se.$invalid && (vm.addFeedForm.se.$dirty || vm.addFeedForm.$submitted)}"><label for="se" class="span-label"><data-i18n i18n="_feeds_se_">se</data-i18n></label> <input type="number" format-input-value="se" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="se" id="se" ng-model="vm.feedDTO.se" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.se_abs.$invalid && (vm.addFeedForm.se_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="se_abs" class="span-label"><data-i18n i18n="_feeds_se_abs_">abs se</data-i18n></label> <input type="number" format-input-value="se_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="se_abs" id="se_abs" ng-model="vm.feedDTO.se_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_se_">se</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.zn.$invalid && (vm.addFeedForm.zn.$dirty || vm.addFeedForm.$submitted)}"><label for="zn" class="span-label"><data-i18n i18n="_feeds_zn_">zn</data-i18n></label> <input type="number" format-input-value="zn" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="zn" id="zn" ng-model="vm.feedDTO.zn" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.zn_abs.$invalid && (vm.addFeedForm.zn_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="zn_abs" class="span-label"><data-i18n i18n="_feeds_zn_abs_">abs Zn</data-i18n></label> <input type="number" format-input-value="zn_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="zn_abs" id="zn_abs" ng-model="vm.feedDTO.zn_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_zn_">zn</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div></div></div></div></div><div class="first-third-grid"><div style="margin-top: 5px" class="panel cost-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_cost_">Cost</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cost_as_sold.$invalid && (vm.addFeedForm.cost_as_sold.$dirty || vm.addFeedForm.$submitted)}"><label for="cost_as_sold" class="span-label"><data-i18n i18n="_feeds_cost_as_sold_">Cost as sold</data-i18n></label> <input type="number" format-input-value="cost_as_sold" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000000" min="0" class="form-control with-units" name="cost_as_sold" id="cost_as_sold" ng-model="vm.feedDTO.cost_as_sold" select-on-click=""><span>{{ vm.currency }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.wt_as_sold.$invalid && (vm.addFeedForm.wt_as_sold.$dirty || vm.addFeedForm.$submitted)}"><label for="wt_as_sold" class="span-label"><data-i18n i18n="_feeds_wt_as_sold_">Wt as sold</data-i18n></label> <input type="number" format-input-value="wt_as_sold" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="wt_as_sold" id="wt_as_sold" ng-model="vm.feedDTO.wt_as_sold" select-on-click=""><span>{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="is_purchased" ng-true-value="1" ng-false-value="0" ng-model="vm.feedDTO.is_purchased"> <span><data-i18n i18n="_feeds_purchased_">Purchased</data-i18n></span></label></div></div></div><div class="panel misc-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_misc_">Misc</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_1.$invalid && (vm.addFeedForm.blank_1.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_1" class="span-label"><data-i18n i18n="_feeds_blank_">Blank</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_1" id="blank_1" ng-model="vm.feedDTO.blank_1" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_2.$invalid && (vm.addFeedForm.blank_2.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_2" class="span-label"><data-i18n i18n="_feeds_blank_"></data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_2" id="blank_2" ng-model="vm.feedDTO.blank_2" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_3.$invalid && (vm.addFeedForm.blank_3.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_3" class="span-label"><data-i18n i18n="_feeds_blank_">Blank</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_3" id="blank_3" ng-model="vm.feedDTO.blank_3" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_4.$invalid && (vm.addFeedForm.blank_4.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_4" class="span-label"><data-i18n i18n="_feeds_blank_">Blank</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_4" id="blank_4" ng-model="vm.feedDTO.blank_4" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_5.$invalid && (vm.addFeedForm.blank_5.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_5" class="span-label"><data-i18n i18n="_feeds_blank_">Blank</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_5" id="blank_5" ng-model="vm.feedDTO.blank_5" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div></div></div><div class="panel comm-panel"><div class="panel-heading"></div><div class="panel-body"><div class="form-group"><label for="comments"><data-i18n i18n="_feeds_comment_">comment</data-i18n></label> <textarea placeholder="{{ \'_feeds_comment_\' | i18n }}" class="form-control" id="comments" style="resize: none" ng-model="vm.feedDTO.comments"></textarea></div><div align="right"><button type="submit" class="btn btn-success" ng-click="vm.save(\'update\')"><data-i18n i18n="_btn_update_">update</data-i18n></button> <button type="submit" class="btn btn-success" ng-click="vm.save(\'new\')"><data-i18n i18n="_btn_feed_save_as_new_">Save as new</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div></div></form></div>');
$templateCache.put('app/pages/feeds/editFeed/editFeedsVemDve.html','<div class="panel-group" ng-if="!vm.loading"><form name="vm.addFeedForm"><div class="first-third-grid"><div style="margin-top: 5px" class="panel g-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_general_">General</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.feed_name.$invalid && (vm.addFeedForm.feed_name.$dirty || vm.addFeedForm.$submitted)}"><label for="feed_name"><data-i18n i18n="_feeds_name_">Feed name</data-i18n></label> <input type="text" class="form-control" id="feed_name" name="feed_name" placeholder="{{ \'_feeds_name_\' | i18n }}" ng-model="vm.feedDTO.feed_name" required="" maxlength="60" select-on-click=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.test_date.$invalid && (vm.addFeedForm.test_date.$dirty || vm.addFeedForm.$submitted)}"><label for="test_date"><data-i18n i18n="_feeds_test_date_">Test date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.date_format}}" placeholder="{{vm.date_format}}" datepicker-options="vm.options" ng-model="vm.test_date" is-open="vm.DPOpened" ng-required="true" close-text="Close" show-button-bar="false" id="test_date" name="test_date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openDatePicker()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.dm.$invalid && (vm.addFeedForm.dm.$dirty || vm.addFeedForm.$submitted)}"><label for="dm" class="span-label"><data-i18n i18n="_feeds_dm_">DM</data-i18n></label> <input type="number" format-input-value="dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0.01" class="form-control with-units" required="" name="dm" id="dm" ng-model="vm.feedDTO.dm" select-on-click=""><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0.01&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.dm.$invalid && (vm.addFeedForm.dm.$dirty || vm.addFeedForm.$submitted)}"><label for="dm" class="span-label"><data-i18n i18n="_feeds_dm_">DM</data-i18n></label> <input type="number" format-input-value="dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000" min="0.01" class="form-control with-units" required="" name="dm" id="dm" ng-model="vm.feedDTO.dm" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0.01&nbsp;&&nbsp;1000</span></div><div class="form-group"><label for="feed_type"><data-i18n i18n="_feeds_type_">Feed type</data-i18n></label><ui-select ng-model="vm.feedTypesItem" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" on-select="vm.newFeedTypeChanged()"><ui-select-match>{{ $select.selected.name | i18n }}</ui-select-match><ui-select-choices repeat="type in vm.feedTypesList | filter: $select.search"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="common_feed" ng-model="vm.feedDTO.common_feed"> <span><data-i18n i18n="_feeds_common_">Common feed</data-i18n></span></label></div></div></div><div class="panel f-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_fiber_">Fiber</data-i18n></div><div class="panel-body"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.rc.$invalid && (vm.addFeedForm.rc.$dirty || vm.addFeedForm.$submitted)}"><label for="rc" class="span-label"><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n></label> <input type="number" format-input-value="rc" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="rc" id="rc" ng-model="vm.feedDTO.rc" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.rc.$invalid && (vm.addFeedForm.rc.$dirty || vm.addFeedForm.$submitted)}"><label for="rc" class="span-label"><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n></label> <input type="number" format-input-value="rc" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="rc" id="rc" ng-model="vm.feedDTO.rc" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ndf.$invalid && (vm.addFeedForm.ndf.$dirty || vm.addFeedForm.$submitted)}"><label for="ndf" class="span-label"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n></label> <input type="number" format-input-value="ndf" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="ndf" id="ndf" ng-model="vm.feedDTO.ndf" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ndf.$invalid && (vm.addFeedForm.ndf.$dirty || vm.addFeedForm.$submitted)}"><label for="ndf" class="span-label"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n></label> <input type="number" format-input-value="ndf" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="ndf" id="ndf" ng-model="vm.feedDTO.ndf" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ndf_digest.$invalid && (vm.addFeedForm.ndf_digest.$dirty || vm.addFeedForm.$submitted)}"><label for="ndf_digest" class="span-label"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n></label> <input type="number" format-input-value="ndf_digest" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="ndf_digest" id="ndf_digest" ng-model="vm.feedDTO.ndf_digest" select-on-click=""><span>%<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.adf.$invalid && (vm.addFeedForm.adf.$dirty || vm.addFeedForm.$submitted)}"><label for="adf" class="span-label"><data-i18n i18n="_feeds_adf_">ADF</data-i18n></label> <input type="number" format-input-value="adf" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="adf" id="adf" ng-model="vm.feedDTO.adf" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.adf.$invalid && (vm.addFeedForm.adf.$dirty || vm.addFeedForm.$submitted)}"><label for="adf" class="span-label"><data-i18n i18n="_feeds_adf_">ADF</data-i18n></label> <input type="number" format-input-value="adf" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="adf" id="adf" ng-model="vm.feedDTO.adf" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.lignin.$invalid && (vm.addFeedForm.lignin.$dirty || vm.addFeedForm.$submitted)}"><label for="lignin" class="span-label"><data-i18n i18n="_feeds_lingnin_">Lignin</data-i18n></label> <input type="number" format-input-value="lignin" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="lignin" id="lignin" ng-model="vm.feedDTO.lignin" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.lignin.$invalid && (vm.addFeedForm.lignin.$dirty || vm.addFeedForm.$submitted)}"><label for="lignin" class="span-label"><data-i18n i18n="_feeds_lingnin_">Lignin</data-i18n></label> <input type="number" format-input-value="lignin" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="lignin" id="lignin" ng-model="vm.feedDTO.lignin" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div></div></div><div class="panel e-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_energy_">Energy</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.vem.$invalid && (vm.addFeedForm.vem.$dirty || vm.addFeedForm.$submitted)}"><label for="vem" class="span-label"><data-i18n i18n="_feeds_vem_">vem</data-i18n></label> <input type="number" format-input-value="vem" pattern="^\\d*(\\.\\d{0,2})?$" step="any" min="0" max="1000000" class="form-control with-units" name="vem" id="vem" ng-model="vm.feedDTO.vem" select-on-click=""><span>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.fos.$invalid && (vm.addFeedForm.fos.$dirty || vm.addFeedForm.$submitted)}"><label for="fos" class="span-label"><data-i18n i18n="_feeds_fos_">fos</data-i18n></label> <input type="number" format-input-value="fos" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" min="0" max="1000000" class="form-control with-units" name="fos" id="fos" ng-model="vm.feedDTO.fos" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div></div></div><div class="panel p-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_protein_">Protein</data-i18n></div><div class="panel-body"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cp.$invalid && (vm.addFeedForm.cp.$dirty || vm.addFeedForm.$submitted)}"><label for="cp" class="span-label"><data-i18n i18n="_feeds_cp_">cp</data-i18n></label> <input type="number" format-input-value="cp" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="cp" id="cp" ng-model="vm.feedDTO.cp" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cp.$invalid && (vm.addFeedForm.cp.$dirty || vm.addFeedForm.$submitted)}"><label for="cp" class="span-label"><data-i18n i18n="_feeds_cp_">cp</data-i18n></label> <input type="number" format-input-value="cp" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="cp" id="cp" ng-model="vm.feedDTO.cp" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.dve.$invalid && (vm.addFeedForm.dve.$dirty || vm.addFeedForm.$submitted)}"><label for="dve" class="span-label"><data-i18n i18n="_feeds_dve_">DVE</data-i18n></label> <input type="number" format-input-value="dve" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="dve" id="dve" ng-model="vm.feedDTO.dve" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.oeb.$invalid && (vm.addFeedForm.oeb.$dirty || vm.addFeedForm.$submitted)}"><label for="oeb" class="span-label"><data-i18n i18n="_feeds_oeb_">OEB</data-i18n></label> <input type="number" format-input-value="oeb" format-value-dm="vm.feedDTO.dm" pattern="^-?\\d*(\\.\\d{0})?$" step="any" max="1000000" min="-1000000" class="form-control with-units" name="oeb" id="oeb" ng-model="vm.feedDTO.oeb" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;-1000000&nbsp;&&nbsp;1000000</span></div></div></div><div class="panel c-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_carb_">Carbohydrates</data-i18n></div><div class="panel-body"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.sugar.$invalid && (vm.addFeedForm.sugar.$dirty || vm.addFeedForm.$submitted)}"><label for="sugar" class="span-label"><data-i18n i18n="_feeds_sugar_">Sugar</data-i18n></label> <input type="number" format-input-value="sugar" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" min="0" max="100" class="form-control with-units" name="sugar" id="sugar" ng-model="vm.feedDTO.sugar" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.sugar.$invalid && (vm.addFeedForm.sugar.$dirty || vm.addFeedForm.$submitted)}"><label for="sugar" class="span-label"><data-i18n i18n="_feeds_sugar_">Sugar</data-i18n></label> <input type="number" format-input-value="sugar" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" min="0" max="10000" class="form-control with-units" name="sugar" id="sugar" ng-model="vm.feedDTO.sugar" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.starch.$invalid && (vm.addFeedForm.starch.$dirty || vm.addFeedForm.$submitted)}"><label for="starch" class="span-label"><data-i18n i18n="_feeds_starch_">Starch</data-i18n></label> <input type="number" format-input-value="starch" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" min="0" max="100" class="form-control with-units" name="starch" id="starch" ng-model="vm.feedDTO.starch" ng-change="vm.valueChanged(\'starch\')" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.starch.$invalid && (vm.addFeedForm.starch.$dirty || vm.addFeedForm.$submitted)}"><label for="starch" class="span-label"><data-i18n i18n="_feeds_starch_">Starch</data-i18n></label> <input type="number" format-input-value="starch" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" min="0" max="10000" class="form-control with-units" name="starch" id="starch" ng-model="vm.feedDTO.starch" ng-change="vm.valueChanged(\'starch\')" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.rus.$invalid && (vm.addFeedForm.rus.$dirty || vm.addFeedForm.$submitted)}"><label for="rus" class="span-label"><data-i18n i18n="_feeds_rus_">RUS</data-i18n></label> <input type="number" format-input-value="rus" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" min="0" max="100" class="form-control with-units" name="rus" id="rus" ng-model="vm.feedDTO.rus" ng-change="vm.valueChanged(\'rus\')" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.rus.$invalid && (vm.addFeedForm.rus.$dirty || vm.addFeedForm.$submitted)}"><label for="rus" class="span-label"><data-i18n i18n="_feeds_rus_">RUS</data-i18n></label> <input type="number" format-input-value="rus" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" min="0" max="10000" class="form-control with-units" name="rus" id="rus" ng-model="vm.feedDTO.rus" ng-change="vm.valueChanged(\'rus\')" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div></div></div><div class="panel l-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_lipid_">Lipid</data-i18n></div><div class="panel-body"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ee.$invalid && (vm.addFeedForm.ee.$dirty || vm.addFeedForm.$submitted)}"><label for="ee" class="span-label"><data-i18n i18n="_feeds_ee_">EE</data-i18n></label> <input type="number" format-input-value="ee" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="ee" id="ee" ng-model="vm.feedDTO.ee" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ee.$invalid && (vm.addFeedForm.ee.$dirty || vm.addFeedForm.$submitted)}"><label for="ee" class="span-label"><data-i18n i18n="_feeds_ee_">EE</data-i18n></label> <input type="number" format-input-value="ee" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="ee" id="ee" ng-model="vm.feedDTO.ee" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.bhfa.$invalid && (vm.addFeedForm.bhfa.$dirty || vm.addFeedForm.$submitted)}"><label for="bhfa" class="span-label"><data-i18n i18n="_feeds_bhfa_">BHFA</data-i18n></label> <input type="number" format-input-value="bhfa" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="bhfa" id="bhfa" ng-model="vm.feedDTO.bhfa" select-on-click=""> <span>%<data-i18n i18n="_feeds_fa_">FA</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.pufa.$invalid && (vm.addFeedForm.pufa.$dirty || vm.addFeedForm.$submitted)}"><label for="pufa" class="span-label"><data-i18n i18n="_feeds_pufa_">PUFA</data-i18n></label> <input type="number" format-input-value="pufa" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="pufa" id="pufa" ng-model="vm.feedDTO.pufa" select-on-click=""> <span>%<data-i18n i18n="_feeds_fa_">FA</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.sfa.$invalid && (vm.addFeedForm.sfa.$dirty || vm.addFeedForm.$submitted)}"><label for="sfa" class="span-label"><data-i18n i18n="_feeds_sfa_">SFA</data-i18n></label> <input type="number" format-input-value="sfa" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="sfa" id="sfa" ng-model="vm.feedDTO.sfa" select-on-click=""> <span>%<data-i18n i18n="_feeds_fa_">FA</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.fa_dig.$invalid && (vm.addFeedForm.fa_dig.$dirty || vm.addFeedForm.$submitted)}"><label for="fa_dig" class="span-label"><data-i18n i18n="_feeds_fa_dig_">FA dig</data-i18n></label> <input type="number" format-input-value="fa_dig" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="fa_dig" id="fa_dig" ng-model="vm.feedDTO.fa_dig" select-on-click=""> <span>%<data-i18n i18n="_feeds_fa_">FA</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div></div><div class="panel v-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_vitamin_">Vitamin</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.vitamin_a.$invalid && (vm.addFeedForm.vitamin_a.$dirty || vm.addFeedForm.$submitted)}"><label for="vitamin_a" class="span-label"><data-i18n i18n="_feeds_vit_a_">Vitamin A</data-i18n></label> <input type="number" format-input-value="vitamin_a" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="vitamin_a" id="vitamin_a" ng-model="vm.feedDTO.vitamin_a" select-on-click=""><span><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.vitamin_d.$invalid && (vm.addFeedForm.vitamin_d.$dirty || vm.addFeedForm.$submitted)}"><label for="vitamin_d" class="span-label"><data-i18n i18n="_feeds_vit_d_">Vitamin D</data-i18n></label> <input type="number" format-input-value="vitamin_d" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="vitamin_d" id="vitamin_d" ng-model="vm.feedDTO.vitamin_d" select-on-click=""> <span><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.vitamin_e.$invalid && (vm.addFeedForm.vitamin_e.$dirty || vm.addFeedForm.$submitted)}"><label for="vitamin_e" class="span-label"><data-i18n i18n="_feeds_vit_e_">Vitamin E</data-i18n></label> <input type="number" format-input-value="vitamin_e" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="vitamin_e" id="vitamin_e" ng-model="vm.feedDTO.vitamin_e" select-on-click=""> <span><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div></div></div><div class="panel aa-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_amino_acid_">Amino Acid</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.lysine.$invalid && (vm.addFeedForm.lysine.$dirty || vm.addFeedForm.$submitted)}"><label for="lysine" class="span-label"><data-i18n i18n="_feeds_lysine_">Lys</data-i18n></label> <input type="number" format-input-value="lysine" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="lysine" id="lysine" ng-model="vm.feedDTO.lysine" select-on-click=""><span>%<data-i18n i18n="_feeds_drup_">dRUP</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.methionine.$invalid && (vm.addFeedForm.methionine.$dirty || vm.addFeedForm.$submitted)}"><label for="methionine" class="span-label"><data-i18n i18n="_feeds_methionine_">Met</data-i18n></label> <input type="number" format-input-value="methionine" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="methionine" id="methionine" ng-model="vm.feedDTO.methionine" select-on-click=""><span>%<data-i18n i18n="_feeds_drup_">dRUP</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div></div></div><div class="second-grid"><div style="margin-top: 5px" class="panel m-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_mineral_">Mineral</data-i18n></div><div class="panel-body"><div class="row"><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ash.$invalid && (vm.addFeedForm.ash.$dirty || vm.addFeedForm.$submitted)}"><label for="ash" class="span-label"><data-i18n i18n="_feeds_ash_">ash</data-i18n></label> <input type="number" format-input-value="ash" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="100" min="0" class="form-control with-units" name="ash" id="ash" ng-model="vm.feedDTO.ash" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ash.$invalid && (vm.addFeedForm.ash.$dirty || vm.addFeedForm.$submitted)}"><label for="ash" class="span-label"><data-i18n i18n="_feeds_ash_">ash</data-i18n></label> <input type="number" format-input-value="ash" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0})?$" step="any" max="10000" min="0" class="form-control with-units" name="ash" id="ash" ng-model="vm.feedDTO.ash" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ca.$invalid && (vm.addFeedForm.ca.$dirty || vm.addFeedForm.$submitted)}"><label for="ca" class="span-label"><data-i18n i18n="_feeds_ca_">Ca</data-i18n></label> <input type="number" format-input-value="ca" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="ca" id="ca" ng-model="vm.feedDTO.ca" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ca.$invalid && (vm.addFeedForm.ca.$dirty || vm.addFeedForm.$submitted)}"><label for="ca" class="span-label"><data-i18n i18n="_feeds_ca_">Ca</data-i18n></label> <input type="number" format-input-value="ca" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="ca" id="ca" ng-model="vm.feedDTO.ca" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.ca_abs.$invalid && (vm.addFeedForm.ca_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="ca_abs" class="span-label"><data-i18n i18n="_feeds_ca_abs_">abs Ca</data-i18n></label> <input type="number" format-input-value="ca_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="ca_abs" id="ca_abs" ng-model="vm.feedDTO.ca_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_ca_">ca</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.p.$invalid && (vm.addFeedForm.p.$dirty || vm.addFeedForm.$submitted)}"><label for="p" class="span-label"><data-i18n i18n="_feeds_p_">p</data-i18n></label> <input type="number" format-input-value="p" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="p" id="p" ng-model="vm.feedDTO.p" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.p.$invalid && (vm.addFeedForm.p.$dirty || vm.addFeedForm.$submitted)}"><label for="p" class="span-label"><data-i18n i18n="_feeds_p_">p</data-i18n></label> <input type="number" format-input-value="p" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="p" id="p" ng-model="vm.feedDTO.p" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.p_abs.$invalid && (vm.addFeedForm.p_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="p_abs" class="span-label"><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n></label> <input type="number" format-input-value="p_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="p_abs" id="p_abs" ng-model="vm.feedDTO.p_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_p_">p</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mg.$invalid && (vm.addFeedForm.mg.$dirty || vm.addFeedForm.$submitted)}"><label for="mg" class="span-label"><data-i18n i18n="_feeds_mg_">Mg</data-i18n></label> <input type="number" format-input-value="mg" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="mg" id="mg" ng-model="vm.feedDTO.mg" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mg.$invalid && (vm.addFeedForm.mg.$dirty || vm.addFeedForm.$submitted)}"><label for="mg" class="span-label"><data-i18n i18n="_feeds_mg_">Mg</data-i18n></label> <input type="number" format-input-value="mg" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="mg" id="mg" ng-model="vm.feedDTO.mg" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mg_abs.$invalid && (vm.addFeedForm.mg_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="mg_abs" class="span-label"><data-i18n i18n="_feeds_mg_abs_">abs Mg</data-i18n></label> <input type="number" format-input-value="mg_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="mg_abs" id="mg_abs" ng-model="vm.feedDTO.mg_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_mg_">Mg</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.k.$invalid && (vm.addFeedForm.k.$dirty || vm.addFeedForm.$submitted)}"><label for="k" class="span-label"><data-i18n i18n="_feeds_k_">K</data-i18n></label> <input type="number" format-input-value="k" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="k" id="k" ng-model="vm.feedDTO.k" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.k.$invalid && (vm.addFeedForm.k.$dirty || vm.addFeedForm.$submitted)}"><label for="k" class="span-label"><data-i18n i18n="_feeds_k_">K</data-i18n></label> <input type="number" format-input-value="k" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="k" id="k" ng-model="vm.feedDTO.k" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.na.$invalid && (vm.addFeedForm.na.$dirty || vm.addFeedForm.$submitted)}"><label for="na" class="span-label"><data-i18n i18n="_feeds_na_">Na</data-i18n></label> <input type="number" format-input-value="na" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="na" id="na" ng-model="vm.feedDTO.na" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.na.$invalid && (vm.addFeedForm.na.$dirty || vm.addFeedForm.$submitted)}"><label for="na" class="span-label"><data-i18n i18n="_feeds_na_">Na</data-i18n></label> <input type="number" format-input-value="na" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="na" id="na" ng-model="vm.feedDTO.na" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cl.$invalid && (vm.addFeedForm.cl.$dirty || vm.addFeedForm.$submitted)}"><label for="cl" class="span-label"><data-i18n i18n="_feeds_cl_">cl</data-i18n></label> <input type="number" format-input-value="cl" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="cl" id="cl" ng-model="vm.feedDTO.cl" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cl.$invalid && (vm.addFeedForm.cl.$dirty || vm.addFeedForm.$submitted)}"><label for="cl" class="span-label"><data-i18n i18n="_feeds_cl_">cl</data-i18n></label> <input type="number" format-input-value="cl" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="cl" id="cl" ng-model="vm.feedDTO.cl" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div><div ng-if="vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.s.$invalid && (vm.addFeedForm.s.$dirty || vm.addFeedForm.$submitted)}"><label for="s" class="span-label"><data-i18n i18n="_feeds_s_">s</data-i18n></label> <input type="number" format-input-value="s" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="s" id="s" ng-model="vm.feedDTO.s" select-on-click=""><span>%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div ng-if="!vm.settings.use_percent" class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.s.$invalid && (vm.addFeedForm.s.$dirty || vm.addFeedForm.$submitted)}"><label for="s" class="span-label"><data-i18n i18n="_feeds_s_">s</data-i18n></label> <input type="number" format-input-value="s" format-value-dm="vm.feedDTO.dm" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="10000" min="0" class="form-control with-units" name="s" id="s" ng-model="vm.feedDTO.s" select-on-click=""><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></div></div></div></div></div><div class="panel t-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_trace_min_">Trace mineral</data-i18n></div><div class="panel-body"><div class="row"><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.co.$invalid && (vm.addFeedForm.co.$dirty || vm.addFeedForm.$submitted)}"><label for="co" class="span-label"><data-i18n i18n="_feeds_co_">co</data-i18n></label> <input type="number" format-input-value="co" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="co" id="co" ng-model="vm.feedDTO.co" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cu.$invalid && (vm.addFeedForm.cu.$dirty || vm.addFeedForm.$submitted)}"><label for="cu" class="span-label"><data-i18n i18n="_feeds_cu_">Cu</data-i18n></label> <input type="number" format-input-value="cu" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="cu" id="cu" ng-model="vm.feedDTO.cu" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cu_abs.$invalid && (vm.addFeedForm.cu_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="cu_abs" class="span-label"><data-i18n i18n="_feeds_cu_abs_">abs cu</data-i18n></label> <input type="number" format-input-value="cu_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="cu_abs" id="cu_abs" ng-model="vm.feedDTO.cu_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_cu_">Cu</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.fe.$invalid && (vm.addFeedForm.fe.$dirty || vm.addFeedForm.$submitted)}"><label for="fe" class="span-label"><data-i18n i18n="_feeds_fe_">fe</data-i18n></label> <input type="number" format-input-value="fe" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="fe" id="fe" ng-model="vm.feedDTO.fe" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.fe_abs.$invalid && (vm.addFeedForm.fe_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="fe_abs" class="span-label"><data-i18n i18n="_feeds_fe_abs_">abs fe</data-i18n></label> <input type="number" format-input-value="fe_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="fe_abs" id="fe_abs" ng-model="vm.feedDTO.fe_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_fe_">fe</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.i.$invalid && (vm.addFeedForm.i.$dirty || vm.addFeedForm.$submitted)}"><label for="i" class="span-label"><data-i18n i18n="_feeds_i_">i</data-i18n></label> <input type="number" format-input-value="i" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="i" id="i" ng-model="vm.feedDTO.i" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.i_abs.$invalid && (vm.addFeedForm.i_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="i_abs" class="span-label"><data-i18n i18n="_feeds_i_abs_">abs i</data-i18n></label> <input type="number" format-input-value="i_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="i_abs" id="i_abs" ng-model="vm.feedDTO.i_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_i_">i</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div><div class="col-xlg-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mo.$invalid && (vm.addFeedForm.mo.$dirty || vm.addFeedForm.$submitted)}"><label for="mo" class="span-label"><data-i18n i18n="_feeds_mo_">Mo</data-i18n></label> <input type="number" format-input-value="mo" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="1000000" min="0" class="form-control with-units" name="mo" id="mo" ng-model="vm.feedDTO.mo" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mn.$invalid && (vm.addFeedForm.mn.$dirty || vm.addFeedForm.$submitted)}"><label for="mn" class="span-label"><data-i18n i18n="_feeds_mn_">mn</data-i18n></label> <input type="number" format-input-value="mn" pattern="^\\d*(\\.\\d{0,1})?$" step="any" max="1000000" min="0" class="form-control with-units" name="mn" id="mn" ng-model="vm.feedDTO.mn" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.mn_abs.$invalid && (vm.addFeedForm.mn_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="mn_abs" class="span-label"><data-i18n i18n="_feeds_mn_abs_">abs Mn</data-i18n></label> <input type="number" format-input-value="mn_abs" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0" class="form-control with-units" name="mn_abs" id="mn_abs" ng-model="vm.feedDTO.mn_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_mn_">mn</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.se.$invalid && (vm.addFeedForm.se.$dirty || vm.addFeedForm.$submitted)}"><label for="se" class="span-label"><data-i18n i18n="_feeds_se_">se</data-i18n></label> <input type="number" format-input-value="se" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="se" id="se" ng-model="vm.feedDTO.se" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.se_abs.$invalid && (vm.addFeedForm.se_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="se_abs" class="span-label"><data-i18n i18n="_feeds_se_abs_">abs se</data-i18n></label> <input type="number" format-input-value="se_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="se_abs" id="se_abs" ng-model="vm.feedDTO.se_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_se_">se</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.zn.$invalid && (vm.addFeedForm.zn.$dirty || vm.addFeedForm.$submitted)}"><label for="zn" class="span-label"><data-i18n i18n="_feeds_zn_">zn</data-i18n></label> <input type="number" format-input-value="zn" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="zn" id="zn" ng-model="vm.feedDTO.zn" select-on-click=""><span><data-i18n i18n="_unit_ppm_">ppm</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.zn_abs.$invalid && (vm.addFeedForm.zn_abs.$dirty || vm.addFeedForm.$submitted)}"><label for="zn_abs" class="span-label"><data-i18n i18n="_feeds_zn_abs_">abs Zn</data-i18n></label> <input type="number" format-input-value="zn_abs" pattern="^\\d*(\\.\\d{0})?$" step="any" max="100" min="0" class="form-control with-units" name="zn_abs" id="zn_abs" ng-model="vm.feedDTO.zn_abs" select-on-click=""><span>%<data-i18n i18n="_feeds_zn_">zn</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></div></div></div></div></div></div><div class="first-third-grid"><div style="margin-top: 5px" class="panel cost-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_cost_">Cost</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cost_as_sold.$invalid && (vm.addFeedForm.cost_as_sold.$dirty || vm.addFeedForm.$submitted)}"><label for="cost_as_sold" class="span-label"><data-i18n i18n="_feeds_cost_as_sold_">Cost as sold</data-i18n></label> <input type="number" format-input-value="cost_as_sold" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000000" min="0" class="form-control with-units" name="cost_as_sold" id="cost_as_sold" ng-model="vm.feedDTO.cost_as_sold" select-on-click=""><span>{{ vm.currency }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.wt_as_sold.$invalid && (vm.addFeedForm.wt_as_sold.$dirty || vm.addFeedForm.$submitted)}"><label for="wt_as_sold" class="span-label"><data-i18n i18n="_feeds_wt_as_sold_">Wt as sold</data-i18n></label> <input type="number" format-input-value="wt_as_sold" pattern="^\\d*(\\.\\d{0})?$" step="any" max="1000000" min="0" class="form-control with-units" name="wt_as_sold" id="wt_as_sold" ng-model="vm.feedDTO.wt_as_sold" select-on-click=""><span>{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="is_purchased" ng-true-value="1" ng-false-value="0" ng-model="vm.feedDTO.is_purchased"> <span><data-i18n i18n="_feeds_purchased_">Purchased</data-i18n></span></label></div></div></div><div class="panel misc-panel"><div class="panel-heading"><data-i18n i18n="_feeds_panel_misc_">Misc</data-i18n></div><div class="panel-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_1.$invalid && (vm.addFeedForm.blank_1.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_1" class="span-label"><data-i18n i18n="_feeds_blank_">Blank</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_1" id="blank_1" ng-model="vm.feedDTO.blank_1" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_2.$invalid && (vm.addFeedForm.blank_2.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_2" class="span-label"><data-i18n i18n="_feeds_blank_"></data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_2" id="blank_2" ng-model="vm.feedDTO.blank_2" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_3.$invalid && (vm.addFeedForm.blank_3.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_3" class="span-label"><data-i18n i18n="_feeds_blank_">Blank</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_3" id="blank_3" ng-model="vm.feedDTO.blank_3" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_4.$invalid && (vm.addFeedForm.blank_4.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_4" class="span-label"><data-i18n i18n="_feeds_blank_">Blank</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_4" id="blank_4" ng-model="vm.feedDTO.blank_4" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.blank_5.$invalid && (vm.addFeedForm.blank_5.$dirty || vm.addFeedForm.$submitted)}"><label for="blank_5" class="span-label"><data-i18n i18n="_feeds_blank_">Blank</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000000" min="0" class="form-control with-units" name="blank_5" id="blank_5" ng-model="vm.feedDTO.blank_5" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></div></div></div><div class="panel comm-panel"><div class="panel-heading"></div><div class="panel-body"><div class="form-group"><label for="comments"><data-i18n i18n="_feeds_comment_">comment</data-i18n></label> <textarea placeholder="{{ \'_feeds_comment_\' | i18n }}" class="form-control" id="comments" style="resize: none" ng-model="vm.feedDTO.comments"></textarea></div><div align="right"><button type="submit" class="btn btn-success" ng-click="vm.save(\'update\')"><data-i18n i18n="_btn_update_">update</data-i18n></button> <button type="submit" class="btn btn-success" ng-click="vm.save(\'new\')"><data-i18n i18n="_btn_feed_save_as_new_">Save as new</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div></div></form></div>');
$templateCache.put('app/pages/feeds/addNewManualFeed/addNewManualFeed.html','<div><div ng-if="!vm.loading && vm.selectedHerd" class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/pages/feeds/addNewManualFeed/addNewManualFeed.panel.html\'"></div></div></div></div><div ng-if="vm.loading" class="row" ba-panel=""><div class="col-lg-12 col-md-12"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div><div ng-if="!vm.loading && !vm.selectedHerd" align="center" ba-panel=""><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div>');
$templateCache.put('app/pages/feeds/addNewManualFeed/addNewManualFeed.panel.html','<form name="vm.addFeedForm" novalidate=""><div class="row"><div class="col-md-4"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.feed_name.$invalid && (vm.addFeedForm.feed_name.$dirty || vm.addFeedForm.$submitted)}"><label for="feed_name" class="span-label"><data-i18n i18n="_feeds_name_">Feed name</data-i18n></label> <input type="text" class="form-control" required="" name="feed_name" id="feed_name" ng-model="vm.feedDTO.feed_name" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_feeds_name_required_">Feed name required</data-i18n></span></div></div><div class="col-md-4"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.feed_type.$invalid && (vm.addFeedForm.feed_type.$dirty || vm.addFeedForm.$submitted)}"><label for="feed_type"><data-i18n i18n="_feeds_type_">Feed type</data-i18n></label><ui-select ng-model="vm.feedDTO.feed_type" class="btn-group bootstrap-select form-control" required="" append-to-body="true" search-enabled="true" id="feed_type" name="feed_type"><ui-select-match placeholder="{{\'_picker_feed_type_placeholder_\' | i18n}}">{{$select.selected.translated}}</ui-select-match><ui-select-choices repeat="type in vm.feedTypes | filter: $select.search"><span ng-bind-html="type.translated"></span></ui-select-choices></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_toastr_feeds_type_required_">Feed type is required</data-i18n></span></div></div><div class="col-md-4" ng-if="vm.settings.use_percent"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.dm.$invalid && (vm.addFeedForm.dm.$dirty || vm.addFeedForm.$submitted)}"><label for="dm" class="span-label"><data-i18n i18n="_feeds_dm_">DM</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="100" min="0.01" class="form-control with-units-block" required="" name="dm" id="dm" ng-model="vm.feedDTO.dm" format-input-value="percentage" ng-change="vm.updateFeed(\'dm\')" select-on-click=""> <span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0.01&nbsp;&&nbsp;100</span></div></div><div class="col-md-4" ng-if="!vm.settings.use_percent"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.dm.$invalid && (vm.addFeedForm.dm.$dirty || vm.addFeedForm.$submitted)}"><label for="dm" class="span-label"><data-i18n i18n="_feeds_dm_">DM</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" step="any" max="1000" min="0.1" class="form-control with-units-block" required="" name="dm" id="dm" ng-model="vm.feedDTO.dm" format-input-value="percentage" ng-change="vm.updateFeed(\'dm\')" select-on-click=""> <span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0.1&nbsp;&&nbsp;1000</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.amount_dm.$invalid && (vm.addFeedForm.amount_dm.$dirty || vm.addFeedForm.$submitted)}"><label for="amount_dm" class="span-label"><data-i18n i18n="_feeds_amount_">Amount</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" min="0" step="0.01" class="form-control with-units-block" name="amount_dm" id="amount_dm" ng-model="vm.feedDTO.amount_dm" format-input-value="amount" ng-change="vm.updateFeed(\'amount_dm\')" select-on-click="" required=""> <span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_amount_dm_required_">Amount DM is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.amount_as_fed.$invalid && (vm.addFeedForm.amount_as_fed.$dirty || vm.addFeedForm.$submitted)}"><label for="amount_as_fed" class="span-label"><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,2})?$" min="0" step="0.01" class="form-control with-units-block" name="amount_as_fed" id="amount_as_fed" ng-model="vm.feedDTO.amount_as_fed" format-input-value="as_fed" ng-change="vm.updateFeed(\'amount_as_fed\')" select-on-click="" required=""> <span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_feeds_as_fed_required_">As fed is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cost_dm.$invalid && (vm.addFeedForm.cost_dm.$dirty || vm.addFeedForm.$submitted)}"><label for="cost_dm" class="span-label"><data-i18n i18n="_feeds_cost_dm_">Cost dm</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,3})?$" min="0" step="0.01" class="form-control with-units-block" name="cost_dm" id="cost_dm" ng-model="vm.feedDTO.cost_dm" format-input-value="cost_dm" default-return-value="null" ng-change="vm.updateFeed(\'cost_dm\')" select-on-click="" required=""> <span>{{vm.currency}}/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_cost_dm_required_">Cost DM is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addFeedForm.cost_as_fed.$invalid && (vm.addFeedForm.cost_as_fed.$dirty || vm.addFeedForm.$submitted)}"><label for="cost_as_fed" class="span-label"><data-i18n i18n="_feeds_cost_as_fed_">Cost as fed</data-i18n></label> <input type="number" pattern="^\\d*(\\.\\d{0,3})?$" min="0" step="0.01" class="form-control with-units-block" name="cost_as_fed" id="cost_as_fed" ng-model="vm.feedDTO.cost_as_fed" format-input-value="cost_as_fed" default-return-value="null" ng-change="vm.updateFeed(\'cost_as_fed\')" select-on-click="" required=""> <span>{{vm.currency}}/{{vm.weight}}&nbsp;<data-i18n style="text-transform: lowercase" i18n="_feeds_as_fed_">as fed</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_feeds_cost_as_fed_required_">Cost as fed is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-12"><div align="right"><button class="btn btn-success btn-md" ng-click="vm.saveFeed()"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button class="btn btn-danger btn-md" ng-click="vm.cancel()"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div></div></form>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistory.amino_acid.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_lys_\' | i18n}}" tooltip-is-open="lysIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lysine_">Lys</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th><th><div uib-tooltip="{{\'_description_met_\' | i18n}}" tooltip-is-open="metIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_methionine_">Met</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th><th><div uib-tooltip="{{\'_description_teaa_\' | i18n}}" tooltip-is-open="teaaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_teaa_">teaa</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.lysine | formatViewValues: \'lysine\'}}</td><td>{{feed.methionine | formatViewValues: \'methionine\'}}</td><td>{{feed.teaa | formatViewValues: \'teaa\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistory.cost.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br>%</div></th><th><div uib-tooltip="{{\'_description_cost_as_sold_\' | i18n}}" tooltip-is-open="costAsSoldIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_as_sold_">cost as sold</data-i18n><br>{{vm.currency}}</div></th><th><div uib-tooltip="{{\'_description_wt_as_sold_\' | i18n}}" tooltip-is-open="wtAsSoldIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_wt_as_sold_">wt as sold</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_is_purchased_\' | i18n}}" tooltip-is-open="isPurchasedIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_purchased_">Purchased</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.dm | formatViewValues: \'dm\'}}</td><td>{{feed.cost_as_sold | formatViewValues: \'cost_as_sold\'}}</td><td>{{feed.wt_as_sold | formatViewValues: \'wt_as_sold\'}}</td><td>{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</td><td><span class="newCheck"><input type="checkbox" id="is_purchased{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="feed.is_purchased" disabled=""> <label for="is_purchased{{$index}}"></label></span></td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistory.html','<div><div class="row" ng-if="vm.selectedHerd"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><div ng-include="\'app/pages/feeds/feedHistory/feedHistory.tabs.html\'"></div></div></div></div><div ba-panel="" ng-if="!vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistory.mineral.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ca_abs_\' | i18n}}" tooltip-is-open="absCaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_abs_">abs Ca</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ca_">Ca</data-i18n></div></th><th><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_p_abs_\' | i18n}}" tooltip-is-open="absPIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_p_">P</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">Mg</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_mg_abs_\' | i18n}}" tooltip-is-open="absMgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_abs_">abs Mg</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_mg_">Mg</data-i18n></div></th><th><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">K</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">Cl</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">S</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th><div uib-tooltip="{{\'_description_ash_\' | i18n}}" tooltip-is-open="ashIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ash_">ash</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.ca | formatViewValues: \'ca\': feed.dm}}</td><td>{{feed.ca_abs | formatViewValues: \'ca_abs\'}}</td><td>{{feed.p | formatViewValues: \'p\': feed.dm}}</td><td>{{feed.p_abs | formatViewValues: \'p_abs\'}}</td><td>{{feed.mg | formatViewValues: \'mg\': feed.dm}}</td><td>{{feed.mg_abs | formatViewValues: \'mg_abs\'}}</td><td>{{feed.k | formatViewValues: \'k\': feed.dm}}</td><td>{{feed.na | formatViewValues: \'na\': feed.dm}}</td><td>{{feed.cl | formatViewValues: \'cl\': feed.dm}}</td><td>{{feed.s | formatViewValues: \'s\': feed.dm}}</td><td>{{feed.dcad | formatViewValues: \'dcad\'}}</td><td>{{feed.ash | formatViewValues: \'ash\': feed.dm}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistory.misc.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_feed_type_\' | i18n}}" tooltip-is-open="feedTypeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_type_">feed type</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_common_feed_\' | i18n}}" tooltip-is-open="commonIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_common_">Common feed</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_blank_1_\' | i18n}}" tooltip-is-open="blank1IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>1<br></div></th><th><div uib-tooltip="{{\'_description_blank_2_\' | i18n}}" tooltip-is-open="blank2IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>2<br></div></th><th><div uib-tooltip="{{\'_description_blank_3_\' | i18n}}" tooltip-is-open="blank3IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>3<br></div></th><th><div uib-tooltip="{{\'_description_blank_4_\' | i18n}}" tooltip-is-open="blank4IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>4<br></div></th><th><div uib-tooltip="{{\'_description_blank_5_\' | i18n}}" tooltip-is-open="blank5IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>5<br></div></th><th><div uib-tooltip="{{\'_description_comment_\' | i18n}}" tooltip-is-open="commentIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_comment_">Comment</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.feed_type.show_name | i18n}}</td><td><span class="newCheck"><input type="checkbox" id="is_common{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="feed.common_feed" disabled=""> <label for="is_common{{$index}}"></label></span></td><td>{{feed.blank_1}}</td><td>{{feed.blank_2}}</td><td>{{feed.blank_3}}</td><td>{{feed.blank_4}}</td><td>{{feed.blank_5}}</td><td>{{feed.comments}}</td><td>{{ feed.test_date | date: vm.date_format}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistory.tabs.html','<div><button type="button" class="btn btn-primary btn-xs" ng-click="vm.goBack()" style="margin: 10px"><i class="ion-arrow-left-c"><data-i18n i18n="_btn_back_">back</data-i18n></i></button><uib-tabset active="$tabSetStatus.activeTab" ng-if="!vm.loading"><uib-tab heading="{{\'_feeds_tab_home_\'|i18n}}" select="vm.selectedTab=1"><div class="row" ng-if="vm.selectedTab == 1"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryHome/feedHistory.home.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryHome/feedHistory.home.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryHome/feedHistory.home.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryHome/feedHistory.home.VemDve.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 1 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryHome/feedHistoryMix.homeUS.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryHome/feedHistoryMix.homeVemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryHome/feedHistoryMix.homeUS.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryHome/feedHistoryMix.homeVemDve.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_fiber_\'|i18n}}" select="vm.selectedTab=2"><div class="row" ng-if="vm.selectedTab == 2"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryFiber/feedHistory.fiber.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryFiber/feedHistory.fiber.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryFiber/feedHistory.fiber.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryFiber/feedHistory.fiber.VemDve.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 2 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryFiber/feedHistoryMix.fiber.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryFiber/feedHistoryMix.fiber.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryFiber/feedHistoryMix.fiber.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryFiber/feedHistoryMix.fiber.VemDve.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_energy_\'|i18n}}" select="vm.selectedTab=3"><div class="row" ng-if="vm.selectedTab == 3"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryEnergy/feedHistory.energy.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryEnergy/feedHistory.energy.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryEnergy/feedHistory.energy.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryEnergy/feedHistory.energy.VemDve.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 3 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryEnergy/feedHistoryMix.energy.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryEnergy/feedHistoryMix.energy.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryEnergy/feedHistoryMix.energy.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryEnergy/feedHistoryMix.energy.VemDve.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_protein_\'|i18n}}" select="vm.selectedTab=4"><div class="row" ng-if="vm.selectedTab == 4"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryProtein/feedHistory.protein.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryProtein/feedHistory.protein.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryProtein/feedHistory.protein.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryProtein/feedHistory.protein.VemDve.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 4 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryProtein/feedHistoryMix.protein.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryProtein/feedHistoryMix.protein.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryProtein/feedHistoryMix.protein.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryProtein/feedHistoryMix.protein.VemDve.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_carb_\'|i18n}}" select="vm.selectedTab=5"><div class="row" ng-if="vm.selectedTab == 5"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryCarb/feedHistory.carb.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryCarb/feedHistory.carb.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryCarb/feedHistory.carb.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryCarb/feedHistory.carb.VemDve.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 5 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryCarb/feedHistoryMix.carb.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryCarb/feedHistoryMix.carb.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryCarb/feedHistoryMix.carb.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryCarb/feedHistoryMix.carb.VemDve.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_lipid_\'|i18n}}" select="vm.selectedTab=6"><div class="row" ng-if="vm.selectedTab == 6"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryLipid/feedHistory.lipid.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryLipid/feedHistory.lipid.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryLipid/feedHistory.lipid.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryLipid/feedHistory.lipid.VemDve.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 6 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryLipid/feedHistoryMix.lipid.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryLipid/feedHistoryMix.lipid.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/feeds/feedHistory/feedHistoryLipid/feedHistoryMix.lipid.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/feeds/feedHistory/feedHistoryLipid/feedHistoryMix.lipid.VemDve.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_mineral_\'|i18n}}" select="vm.selectedTab=7"><div class="row" ng-if="vm.selectedTab == 7"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/feeds/feedHistory/feedHistory.mineral.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 7 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/feeds/feedHistory/feedHistoryMix.mineral.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_trace_min_\'|i18n}}" select="vm.selectedTab=8"><div class="row" ng-if="vm.selectedTab == 8"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/feeds/feedHistory/feedHistory.trace_min.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 8 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/feeds/feedHistory/feedHistoryMix.trace_min.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_vitamin_\'|i18n}}" select="vm.selectedTab=9"><div class="row" ng-if="vm.selectedTab == 9"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/feeds/feedHistory/feedHistory.vitamin.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 9 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/feeds/feedHistory/feedHistoryMix.vitamin.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_amino_acid_\'|i18n}}" select="vm.selectedTab=10"><div class="row" ng-if="vm.selectedTab == 10"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/feeds/feedHistory/feedHistory.amino_acid.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 10 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/feeds/feedHistory/feedHistoryMix.amino_acid.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_cost_\'|i18n}}" select="vm.selectedTab=11"><div class="row" ng-if="vm.selectedTab == 11"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/feeds/feedHistory/feedHistory.cost.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 11 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/feeds/feedHistory/feedHistoryMix.cost.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_misc_\'|i18n}}" select="vm.selectedTab=12"><div class="row" ng-if="vm.selectedTab == 12"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/feeds/feedHistory/feedHistory.misc.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 12 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/feeds/feedHistory/feedHistoryMix.misc.html"></div></div></div></div></uib-tab></uib-tabset><div ng-if="vm.showDetails && !vm.loading"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="vm.closeDetailsWindow()"><data-i18n i18n="_btn_hide_">Hide</data-i18n></button></div></div><div ng-if="vm.loading" align="center"><div align="center" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistory.trace_min.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_co_\' | i18n}}" tooltip-is-open="coIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_co_">Co</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_cu_\' | i18n}}" tooltip-is-open="cuIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cu_">Cu</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_cu_abs_\' | i18n}}" tooltip-is-open="absCuIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cu_abs_">abs Cu</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cu_">Cu</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fe_\' | i18n}}" tooltip-is-open="feIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fe_">Fe</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fe_abs_\' | i18n}}" tooltip-is-open="absFeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fe_abs_">abs Fe</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fe_">Fe</data-i18n></div></th><th><div uib-tooltip="{{\'_description_i_\' | i18n}}" tooltip-is-open="iIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_i_">I</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_i_abs_\' | i18n}}" tooltip-is-open="absIIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_i_abs_">abs I</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_i_">I</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mo_\' | i18n}}" tooltip-is-open="moIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mo_">Mo</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mn_\' | i18n}}" tooltip-is-open="mnIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mn_">Mn</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mn_abs_\' | i18n}}" tooltip-is-open="absMnIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mn_abs_">abs Mn</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_mn_">Mn</data-i18n></div></th><th><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_se_abs_\' | i18n}}" tooltip-is-open="absSeIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_abs_">abs Se</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_se_">Se</data-i18n></div></th><th><div uib-tooltip="{{\'_description_zn_\' | i18n}}" tooltip-is-open="znIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_zn_">Zn</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_zn_abs_\' | i18n}}" tooltip-is-open="absZnIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_zn_abs_">abs Zn</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_zn_">Zn</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.co | formatViewValues: \'co\'}}</td><td>{{feed.cu | formatViewValues: \'cu\'}}</td><td>{{feed.cu_abs | formatViewValues: \'cu_abs\'}}</td><td>{{feed.fe | formatViewValues: \'fe\'}}</td><td>{{feed.fe_abs | formatViewValues: \'fe_abs\'}}</td><td>{{feed.i | formatViewValues: \'i\'}}</td><td>{{feed.i_abs | formatViewValues: \'i_abs\'}}</td><td>{{feed.mo | formatViewValues: \'mo\'}}</td><td>{{feed.mn | formatViewValues: \'mn\'}}</td><td>{{feed.mn_abs | formatViewValues: \'mn_abs\'}}</td><td>{{feed.se | formatViewValues: \'se\'}}</td><td>{{feed.se_abs | formatViewValues: \'se_abs\'}}</td><td>{{feed.zn | formatViewValues: \'zn\'}}</td><td>{{feed.zn_abs | formatViewValues: \'zn_abs\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistory.vitamin.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_vitamin_a_\' | i18n}}" tooltip-is-open="vitAIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_a_">vit a</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_vitamin_d_\' | i18n}}" tooltip-is-open="vitDIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_d_">vit d</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.vitamin_a | formatViewValues: \'vitamin_a\'}}</td><td>{{feed.vitamin_d | formatViewValues: \'vitamin_d\'}}</td><td>{{feed.vitamin_e | formatViewValues: \'vitamin_e\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryMix.amino_acid.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_lys_\' | i18n}}" tooltip-is-open="lysIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lysine_">Lys</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th><th><div uib-tooltip="{{\'_description_met_\' | i18n}}" tooltip-is-open="metIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_methionine_">Met</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th><th><div uib-tooltip="{{\'_description_teaa_\' | i18n}}" tooltip-is-open="teaaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_teaa_">teaa</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td ng-class="feed.lysine_changed ? \'property-changed\' : \'\'">{{feed.lysine | formatViewValues: \'lysine\'}}</td><td ng-class="feed.methionine_changed ? \'property-changed\' : \'\'">{{feed.methionine | formatViewValues: \'methionine\'}}</td><td ng-class="feed.teaa_changed ? \'property-changed\' : \'\'">{{feed.teaa | formatViewValues: \'teaa\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryMix.cost.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br>%</div></th><th><div uib-tooltip="{{\'_description_cost_as_sold_\' | i18n}}" tooltip-is-open="costAsSoldIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_as_sold_">cost as sold</data-i18n><br>{{vm.currency}}</div></th><th><div uib-tooltip="{{\'_description_wt_as_sold_\' | i18n}}" tooltip-is-open="wtAsSoldIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_wt_as_sold_">wt as sold</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_is_purchased_\' | i18n}}" tooltip-is-open="isPurchasedIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_purchased_">Purchased</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td ng-class="feed.dm_changed ? \'property-changed\' : \'\'">{{feed.dm | formatViewValues: \'dm\'}}</td><td ng-class="feed.cost_as_sold_changed ? \'property-changed\' : \'\'">{{feed.cost_as_sold | formatViewValues: \'cost_as_sold\'}}</td><td ng-class="feed.wt_as_sold_changed ? \'property-changed\' : \'\'">{{feed.wt_as_sold | formatViewValues: \'wt_as_sold\'}}</td><td ng-class="feed.cost_dm_changed ? \'property-changed\' : \'\'">{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</td><td ng-class="feed.is_purchased_changed ? \'property-changed\' : \'\'"><span class="newCheck"><input type="checkbox" id="is_purchased{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="feed.is_purchased" disabled=""> <label for="is_purchased{{$index}}"></label></span></td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryMix.mineral.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ca_abs_\' | i18n}}" tooltip-is-open="absCaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_abs_">abs Ca</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ca_">Ca</data-i18n></div></th><th><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_p_abs_\' | i18n}}" tooltip-is-open="absPIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_p_">P</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">Mg</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_mg_abs_\' | i18n}}" tooltip-is-open="absMgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_abs_">abs Mg</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_mg_">Mg</data-i18n></div></th><th><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">K</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">Cl</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">S</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th><div uib-tooltip="{{\'_description_ash_\' | i18n}}" tooltip-is-open="ashIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ash_">ash</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td ng-class="feed.ca_changed ? \'property-changed\' : \'\'">{{feed.ca | formatViewValues: \'ca\': feed.dm}}</td><td ng-class="feed.ca_abs_changed ? \'property-changed\' : \'\'">{{feed.ca_abs | formatViewValues: \'ca_abs\'}}</td><td ng-class="feed.p_changed ? \'property-changed\' : \'\'">{{feed.p | formatViewValues: \'p\': feed.dm}}</td><td ng-class="feed.p_abs_changed ? \'property-changed\' : \'\'">{{feed.p_abs | formatViewValues: \'p_abs\'}}</td><td ng-class="feed.mg_changed ? \'property-changed\' : \'\'">{{feed.mg | formatViewValues: \'mg\': feed.dm}}</td><td ng-class="feed.mg_abs_changed ? \'property-changed\' : \'\'">{{feed.mg_abs | formatViewValues: \'mg_abs\'}}</td><td ng-class="feed.k_changed ? \'property-changed\' : \'\'">{{feed.k | formatViewValues: \'k\': feed.dm}}</td><td ng-class="feed.na_changed ? \'property-changed\' : \'\'">{{feed.na | formatViewValues: \'na\': feed.dm}}</td><td ng-class="feed.cl_changed ? \'property-changed\' : \'\'">{{feed.cl | formatViewValues: \'cl\': feed.dm}}</td><td ng-class="feed.s_changed ? \'property-changed\' : \'\'">{{feed.s | formatViewValues: \'s\': feed.dm}}</td><td ng-class="feed.dcad_changed ? \'property-changed\' : \'\'">{{feed.dcad | formatViewValues: \'dcad\'}}</td><td ng-class="feed.ash_changed ? \'property-changed\' : \'\'">{{feed.ash | formatViewValues: \'ash\': feed.dm}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryMix.misc.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_feed_type_\' | i18n}}" tooltip-is-open="feedTypeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_type_">feed type</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_common_feed_\' | i18n}}" tooltip-is-open="commonIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_common_">Common feed</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_blank_1_\' | i18n}}" tooltip-is-open="blank1IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>1<br></div></th><th><div uib-tooltip="{{\'_description_blank_2_\' | i18n}}" tooltip-is-open="blank2IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>2<br></div></th><th><div uib-tooltip="{{\'_description_blank_3_\' | i18n}}" tooltip-is-open="blank3IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>3<br></div></th><th><div uib-tooltip="{{\'_description_blank_4_\' | i18n}}" tooltip-is-open="blank4IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>4<br></div></th><th><div uib-tooltip="{{\'_description_blank_5_\' | i18n}}" tooltip-is-open="blank5IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>5<br></div></th><th><div uib-tooltip="{{\'_description_comment_\' | i18n}}" tooltip-is-open="commentIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_comment_">Comment</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td ng-class="feed.feed_type_changed ? \'property-changed\' : \'\'">{{feed.feed_type.show_name | i18n}}</td><td ng-class="feed.is_purchased_changed ? \'property-changed\' : \'\'"><span class="newCheck"><input type="checkbox" id="is_common{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="feed.common_feed" disabled=""> <label for="is_common{{$index}}"></label></span></td><td ng-class="feed.blank_1_changed ? \'property-changed\' : \'\'">{{feed.blank_1}}</td><td ng-class="feed.blank_2_changed ? \'property-changed\' : \'\'">{{feed.blank_2}}</td><td ng-class="feed.blank_3_changed ? \'property-changed\' : \'\'">{{feed.blank_3}}</td><td ng-class="feed.blank_4_changed ? \'property-changed\' : \'\'">{{feed.blank_4}}</td><td ng-class="feed.blank_5_changed ? \'property-changed\' : \'\'">{{feed.blank_5}}</td><td ng-class="feed.comments_changed ? \'property-changed\' : \'\'">{{feed.comments}}</td><td ng-class="feed.test_date_changed ? \'property-changed\' : \'\'">{{ feed.test_date | date: vm.date_format}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryMix.trace_min.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_co_\' | i18n}}" tooltip-is-open="coIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_co_">Co</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_cu_\' | i18n}}" tooltip-is-open="cuIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cu_">Cu</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_cu_abs_\' | i18n}}" tooltip-is-open="absCuIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cu_abs_">abs Cu</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cu_">Cu</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fe_\' | i18n}}" tooltip-is-open="feIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fe_">Fe</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fe_abs_\' | i18n}}" tooltip-is-open="absFeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fe_abs_">abs Fe</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fe_">Fe</data-i18n></div></th><th><div uib-tooltip="{{\'_description_i_\' | i18n}}" tooltip-is-open="iIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_i_">I</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_i_abs_\' | i18n}}" tooltip-is-open="absIIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_i_abs_">abs I</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_i_">I</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mo_\' | i18n}}" tooltip-is-open="moIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mo_">Mo</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mn_\' | i18n}}" tooltip-is-open="mnIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mn_">Mn</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mn_abs_\' | i18n}}" tooltip-is-open="absMnIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mn_abs_">abs Mn</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_mn_">Mn</data-i18n></div></th><th><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_se_abs_\' | i18n}}" tooltip-is-open="absSeIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_abs_">abs Se</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_se_">Se</data-i18n></div></th><th><div uib-tooltip="{{\'_description_zn_\' | i18n}}" tooltip-is-open="znIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_zn_">Zn</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_zn_abs_\' | i18n}}" tooltip-is-open="absZnIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_zn_abs_">abs Zn</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_zn_">Zn</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td ng-class="feed.co_changed ? \'property-changed\' : \'\'">{{feed.co | formatViewValues: \'co\'}}</td><td ng-class="feed.cu_changed ? \'property-changed\' : \'\'">{{feed.cu | formatViewValues: \'cu\'}}</td><td ng-class="feed.cu_abs_changed ? \'property-changed\' : \'\'">{{feed.cu_abs | formatViewValues: \'cu_abs\'}}</td><td ng-class="feed.fe_changed ? \'property-changed\' : \'\'">{{feed.fe | formatViewValues: \'fe\'}}</td><td ng-class="feed.fe_abs_changed ? \'property-changed\' : \'\'">{{feed.fe_abs | formatViewValues: \'fe_abs\'}}</td><td ng-class="feed.i_changed ? \'property-changed\' : \'\'">{{feed.i | formatViewValues: \'i\'}}</td><td ng-class="feed.i_abs_changed ? \'property-changed\' : \'\'">{{feed.i_abs | formatViewValues: \'i_abs\'}}</td><td ng-class="feed.mo_changed ? \'property-changed\' : \'\'">{{feed.mo | formatViewValues: \'mo\'}}</td><td ng-class="feed.mn_changed ? \'property-changed\' : \'\'">{{feed.mn | formatViewValues: \'mn\'}}</td><td ng-class="feed.mn_abs_changed ? \'property-changed\' : \'\'">{{feed.mn_abs | formatViewValues: \'mn_abs\'}}</td><td ng-class="feed.se_changed ? \'property-changed\' : \'\'">{{feed.se | formatViewValues: \'se\'}}</td><td ng-class="feed.se_abs_changed ? \'property-changed\' : \'\'">{{feed.se_abs | formatViewValues: \'se_abs\'}}</td><td ng-class="feed.zn_changed ? \'property-changed\' : \'\'">{{feed.zn | formatViewValues: \'zn\'}}</td><td ng-class="feed.zn_abs_changed ? \'property-changed\' : \'\'">{{feed.zn_abs | formatViewValues: \'zn_abs\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryMix.vitamin.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_vitamin_a_\' | i18n}}" tooltip-is-open="vitAIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_a_">vit a</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_vitamin_d_\' | i18n}}" tooltip-is-open="vitDIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_d_">vit d</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td ng-class="feed.vitamin_a_changed ? \'property-changed\' : \'\'">{{feed.vitamin_a | formatViewValues: \'vitamin_a\'}}</td><td ng-class="feed.vitamin_d_changed ? \'property-changed\' : \'\'">{{feed.vitamin_d | formatViewValues: \'vitamin_d\'}}</td><td ng-class="feed.vitamin_e_changed ? \'property-changed\' : \'\'">{{feed.vitamin_e | formatViewValues: \'vitamin_e\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/importSpartan3/importFeeds.modal.html','<div ba-panel=""><div class="panel-group" ng-if="!vm.loading && !vm.loadingTeams"><div class="row"><div class="btn-group-example" style="padding-left: 15px"></div></div><div style="margin-top: 10px" class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="btn-group" role="group" aria-label="Basic example" id="e0"><button type="button" class="btn btn-primary no-border-radius" ng-click="vm.addAll()"><data-i18n i18n="_btn_feed_add_all_">Add all</data-i18n></button> <button type="button" class="btn btn-danger no-border-radius" ng-click="vm.cancel(\'insert_feed\')"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><div ba-panel="" ba-panel-title="{{\'_feeds_imort_feeds_panel_available_feeds_\'|i18n}}" ba-panel-class="with-scroll xmedium-panel"><div include-with-scope="app/pages/feeds/importSpartan3/master-table.html"></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="btn-group" role="group" id="e0"><button type="button" class="btn btn-danger no-border-radius" ng-click="vm.removeAll()"><data-i18n i18n="_btn_feed_remove_all_">Remove all</data-i18n></button> <button type="button" class="btn btn-primary no-border-radius" ng-click="vm.importFeeds()" ng-disabled="!vm.selectedTeam"><data-i18n i18n="_btn_feed_import_">Import</data-i18n></button></div><div ba-panel="" ba-panel-title="{{\'_feeds_imort_feeds_panel_feeds_import_\'|i18n}}" ba-panel-class="with-scroll xmedium-panel"><div include-with-scope="app/pages/feeds/importSpartan3/table.html"></div></div></div></div></div><div ng-if="vm.loading || vm.loadingTeams" align="center"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/feeds/importSpartan3/importSpartan3.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-title="{{\'_feeds_insert_feeds_uploaded_databases_\'|i18n}}" ba-panel-class="with-scroll"><div include-with-scope="app/pages/feeds/importSpartan3/importSpartan3.table.html"></div></div></div></div></div>');
$templateCache.put('app/pages/feeds/importSpartan3/importSpartan3.table.html','<div class="row" ng-if="!vm.loadingDbs"><div class="col-sm-6"></div><div class="col-sm-6" align="right"><button type="button" class="btn btn-primary" ng-click="vm.openUploadModal(\'app/pages/feeds/importSpartan3/upload.modal.html\', \'sm\')" uib-tooltip="{{\'_spar_upload_db_btn_\' | i18n}}" tooltip-is-open="upload_feed" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_btn_upload_">upload</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.back()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div class="horizontal-scroll" ng-if="!vm.loadingDbs"><table class="table" st-table="vm.dbs"><thead><tr class="sortable"><th style="min-width: 300px" st-sort="file_name"><data-i18n i18n="_title_file_name_">file name</data-i18n></th><th style="min-width: 150px" st-sort="upload_date" st-sort-default="reverse"><data-i18n i18n="_title_upload_date_">upload date</data-i18n></th><th></th></tr><tr><th><input st-search="file_name" placeholder="{{\'_search_placeholder_file_name_\' | i18n }}" class="input-sm form-control search-input" type="search"></th><th><input st-search="upload_date" placeholder="{{\'_search_placeholder_upload_date_\' | i18n }}" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody ng-if="!vm.loadingTable"><tr ng-repeat="db in vm.dbs track by db.id" ng-if="vm.hasFiles"><td style="height: 30px">{{db.file_name}}</td><td style="height: 30px">{{db.upload_date }}</td><td style="height: 30px"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.openImportModal(db, \'app/pages/feeds/importSpartan3/importFeeds.modal.html\', \'lg\')" uib-tooltip="{{\'_spar_import_btn_\' | i18n}}" tooltip-is-open="feed_import" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_btn_feed_import_">import</data-i18n></button></td></tr><tr ng-if="!vm.hasFiles"><td colspan="3">{{\'_feeds_import_feeds_spartan3_no_files_message_\'|i18n}}</td></tr></tbody><tfoot><tr><td colspan="3" class="text-center"><div st-pagination="" st-items-by-page="vm.itemsPerPage" st-displayed-pages="5"></div></td></tr><tr ng-if="vm.itemsPerPageValues.length > 0"><td colspan="3" class="text-left"><div class="form-group select-page-size-wrap dropup" ng-class="vm.itemsPerPageValues.length == 4 ? \'exended-1\' : (vm.itemsPerPageValues.length == 5 ? \'exended-2\' : \'\')"><label><data-i18n i18n="_title_rows_on_page_">rows on page</data-i18n><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="vm.itemsPerPage" ng-options="i for i in vm.itemsPerPageValues"></select></label></div></td></tr></tfoot></table></div><div ng-if="vm.loadingDbs || vm.loadingTable" align="center"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/importSpartan3/master-table.html','<div class="vertical-scroll"><table class="table-header-fixed" st-table="vm.masterLib" st-safe-src="vm.masterLibSafe"><thead><tr><th colspan="6" style="width: 100%"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group"><label><data-i18n i18n="_feeds_search_feeds_label_">Search feeds</data-i18n></label> <input st-search="feed_name" placeholder="{{\'_search_placeholder_feed_name_\'|i18n}}" class="form-control" type="search" style="margin-top: 5px"></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group"><label><data-i18n i18n="_picker_feed_type_placeholder_">Select feed type</data-i18n></label><select st-search="feed_type" class="form-control" style="margin-top: 5px"><option value="">{{\'_feeds_type_all_\' | i18n}}</option><option value="dry_forage">{{\'_feeds_type_dry_forage_\' | i18n}}</option><option value="corn_silage">{{\'_feeds_type_corn_silage_\' | i18n}}</option><option value="alfa_silage">{{\'_feeds_type_alfa_silage_\' | i18n}}</option><option value="other_wet_forage">{{\'_feeds_type_other_wet_forage_\' | i18n}}</option><option value="by_product">{{\'_feeds_type_by_product_\' | i18n}}</option><option value="grain">{{\'_feeds_type_grain_\' | i18n}}</option><option value="fatty_acid_source">{{\'_feeds_type_fatty_acid_source_\' | i18n}}</option><option value="triglycerides">{{\'_feeds_type_triglycerides_\' | i18n}}</option><option value="cp_source">{{\'_feeds_type_cp_source_\' | i18n}}</option><option value="rup_source">{{\'_feeds_type_rup_source_\' | i18n}}</option><option value="mineral">{{\'_feeds_type_mineral_\' | i18n}}</option><option value="vitamin">{{\'_feeds_type_vitamin_\' | i18n}}</option><option value="mix">{{\'_feeds_type_mix_\' | i18n}}</option></select></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group"><label><data-i18n i18n="_feeds_common_">Common</data-i18n></label><select st-search="common_feed" class="form-control" style="margin-top: 5px"><option value="">{{\'_feeds_type_all_\' | i18n}}</option><option value="true">{{\'_feeds_yes_\' | i18n}}</option><option value="false">{{\'_feeds_no_\' | i18n}}</option></select></div></div></div></th></tr><tr class="sortable" style="margin-right: 15px"><th style="width: 10%"></th><th st-sort="feed_name" st-sort-default="true" style="width: 20%"><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br></th><th st-sort="test_date" style="width: 19%"><data-i18n i18n="_feeds_test_date_">Test date</data-i18n><br></th><th st-sort="dm" style="width: 17%"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span></th><th st-sort="cp" style="width: 17%"><data-i18n i18n="_feeds_cp_">cp</data-i18n><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th><th st-sort="NDF" style="width: 17%"><data-i18n i18n="_feeds_ndf_">ndf</data-i18n><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th></tr></thead><tbody><tr ng-repeat="feed in vm.masterLib" ng-click="vm.addSelected(feed.id)" style="margin-bottom: 5px; margin-top: 5px"><td style="width: 10%"><button type="button" class="btn btn-primary btn-xs" style="border-radius: 50%; transform: none"><i class="ion-plus-round"></i></button></td><td style="width: 20%">{{feed.feed_name}}</td><td style="width: 19%">{{feed.test_date | date:\'mediumDate\'}}</td><td style="width: 17%">{{feed.dm | formatViewValues: \'dm\'}}</td><td style="width: 17%">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td style="width: 17%">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/feeds/importSpartan3/table.html','<div class="horizontal-scroll"><table class="table-header-fixed auto-scroll" st-table="vm.importList" st-safe-src="vm.importListSafe" ng-if="vm.masterLib"><thead><tr class="sortable" style="margin-right: 15px"><th style="width: 10%"></th><th st-sort="feed_name" st-sort-default="true" style="width: 20%"><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br></th><th st-sort="test_date" style="width: 19%"><data-i18n i18n="_feeds_test_date_">Test date</data-i18n><br></th><th st-sort="dm" style="width: 17%"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span></th><th st-sort="cp" style="width: 17%"><data-i18n i18n="_feeds_cp_">cp</data-i18n><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th><th st-sort="NDF" style="width: 17%"><data-i18n i18n="_feeds_ndf_">ndf</data-i18n><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th></tr></thead><tbody><tr ng-repeat="feed in vm.importList track by $index" ng-click="vm.removeSelected(feed.id)" style="margin-top: 5px; margin-bottom: 5px"><td style="width: 10%"><button type="button" class="btn btn-danger btn-xs" style="border-radius: 50%; transform: none"><i class="ion-minus-round"></i></button></td><td style="width: 20%">{{feed.feed_name}}</td><td style="width: 19%">{{feed.test_date | date:\'mediumDate\'}}</td><td style="width: 17%">{{feed.dm | formatViewValues: \'dm\'}}</td><td style="width: 17%">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td style="width: 17%">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/feeds/importSpartan3/upload.modal.html','<div class="modal-content"><div class="modal-header"><div align="center"><span class="secondaryText"><data-i18n i18n="_feeds_insert_upload_select_database_">Select database do upload</data-i18n></span></div></div><div class="modal-body" align="center"><form name="form"><div><a class="ion-upload primaryModal" uib-tooltip="{{\'_btn_select_file_\' | i18n}}" tooltip-append-to-body="true" tooltip-is-open="xml" tooltip-placement="top" tooltip-class="customBlue top" tooltip-popup-delay="500" style="font-size: 55px" ngf-select="" ng-model="vm.file" name="file" ngf-pattern="\'.sdlb\'" ngf-accept="\'.sdlb\'" ngf-max-size="10MB" ngf-change="vm.uploadChanged()" ngf-multiple="true"></a></div></form><div ng-repeat="file in vm.file"><div><div class="spinner-x-small" style="display: inline-block; vertical-align: super" ng-if="file.uploading"><div id="loading-animation"></div></div><div style="display: inline-block; vertical-align: super" ng-class="file.status == 1 ? \'primaryModal\' : \'warningModal\'">{{file.name}}</div></div></div><div class="form-group"><div align="center"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-disabled="!vm.file" ng-click="vm.upload()"><data-i18n i18n="_btn_upload_">upload</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div></div>');
$templateCache.put('app/pages/feeds/importXML/importXML.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-title="{{\'_feeds_insert_feeds_uploaded_xml_\'|i18n}}" ba-panel-class="with-scroll"><div include-with-scope="app/pages/feeds/importXML/importXml.table.html"></div></div></div></div></div>');
$templateCache.put('app/pages/feeds/importXML/importXml.table.html','<div class="row" ng-if="!vm.loadingDbs"><div class="col-sm-6"></div><div class="col-sm-6" align="right"><button uib-tooltip="{{\'_spar_upload_btn_\' | i18n}}" tooltip-is-open="upload_feed" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" type="button" class="btn btn-primary" ng-click="vm.openUploadModal(\'app/pages/feeds/importXML/upload.modal.html\', \'sm\')"><data-i18n i18n="_btn_upload_">upload</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.back()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div class="horizontal-scroll xml-files-table-container" ng-if="!vm.loadingDbs"><table class="table table-hover" st-table="vm.dbs"><thead><tr class="sortable"><th></th><th st-sort="file_name"><data-i18n i18n="_title_file_name_">file name</data-i18n></th><th st-sort="id" st-sort-default="reverse"><data-i18n i18n="_title_upload_date_">upload date</data-i18n></th><th><data-i18n i18n="_m_f_label_imported_feeds_">Imported feeds</data-i18n>/<data-i18n i18n="_m_f_label_total_feeds_">Total feeds</data-i18n></th><th><data-i18n i18n="_m_f_label_all_feeds_imported_">All feeds imported</data-i18n></th><th></th></tr><tr><th></th><th><input st-search="file_name" placeholder="{{\'_search_placeholder_file_name_\' | i18n }}" class="input-sm form-control search-input" type="search"></th><th><input st-search="upload_date" placeholder="{{\'_search_placeholder_upload_date_\' | i18n }}" class="input-sm form-control search-input" type="search"></th><th colspan="3"></th></tr></thead><tbody ng-if="!vm.loadingTable"><tr ng-repeat-start="ration in vm.dbs" ng-if="vm.hasFiles"><td><div><span class="expand-arrow" ng-click="ration.expanded = !ration.expanded"><i class="fa" ng-class="ration.expanded ? \'fa-caret-up\' : \'fa-caret-down\'"></i></span></div></td><td>{{ration.file_name}}</td><td>{{ration.upload_date | date: vm.date_format}}</td><td>{{ration.imported_count}}/{{ration.feeds.length}}</td><td><a class="ion-checkmark-round primaryModal" ng-if="ration.all_feeds_imported"></a> <a class="ion-close-round warningModal" ng-if="!ration.all_feeds_imported"></a></td><td><button type="button" class="btn btn-primary btn-xs" ng-click="vm.redirectTo(ration.file_uuid)" uib-tooltip="{{\'_spar_import_btn_\' | i18n}}" tooltip-is-open="feed_import" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_btn_feed_import_">import</data-i18n></button></td></tr><tr ng-if="ration.expanded" class="xml-files-table-subrow"><td></td><td><data-i18n i18n="_feeds_name_">Feed name</data-i18n></td><td></td><td></td><td><data-i18n i18n="_m_f_label_imported_">Imported</data-i18n></td><td></td></tr><tr ng-if="ration.expanded" class="xml-files-table-subrow" ng-repeat="feed in ration.feeds" ng-class="$index === ration.feeds.length - 1 ? \'xml-files-table-subrow-border\' : \'\'"><td></td><td>{{feed.feed_name}}</td><td></td><td></td><td><a class="ion-checkmark-round primaryModal" ng-if="feed.imported"></a> <a class="ion-close-round warningModal" ng-if="!feed.imported"></a></td><td><button type="button" class="btn btn-primary btn-xs" ng-click="vm.redirectTo(ration.file_uuid, feed.feed_name)" uib-tooltip="{{\'_menu_import_feed_\' | i18n}}" tooltip-is-open="feed_import" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_btn_feed_import_">import</data-i18n></button></td></tr><tr ng-repeat-end=""></tr><tr ng-if="!vm.hasFiles"><td colspan="6">{{\'_feeds_import_feeds_spartan3_no_files_message_\'|i18n}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="vm.itemsPerPage" st-displayed-pages="5"></div></td></tr><tr ng-if="vm.itemsPerPageValues.length > 0"><td colspan="6" class="text-left"><div class="form-group select-page-size-wrap dropup" ng-class="vm.itemsPerPageValues.length == 4 ? \'exended-1\' : (vm.itemsPerPageValues.length == 5 ? \'exended-2\' : \'\')"><label><data-i18n i18n="_title_rows_on_page_">rows on page</data-i18n><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="vm.itemsPerPage" ng-options="i for i in vm.itemsPerPageValues"></select></label></div></td></tr></tfoot></table></div><loading-spinner-large ng-if="vm.loadingDbs || vm.loadingTable"></loading-spinner-large>');
$templateCache.put('app/pages/feeds/importXML/upload.modal.html','<div class="modal-content"><div class="modal-header"><div align="center"><span class="secondaryText"><data-i18n i18n="_feeds_insert_upload_select_xml_">Select XML file to upload</data-i18n></span></div></div><div class="modal-body" align="center"><form name="form"><div><a class="ion-upload primaryModal" uib-tooltip="{{\'_btn_select_file_\' | i18n}}" tooltip-append-to-body="true" tooltip-is-open="xml" tooltip-placement="top" tooltip-class="customBlue top" tooltip-popup-delay="500" style="font-size: 55px" ngf-select="" ng-model="vm.file" name="file" ngf-pattern="\'.xml\'" ngf-accept="\'.xml\'" ngf-max-size="10MB" ngf-change="vm.uploadChanged()" ngf-multiple="true"></a></div></form><div ng-repeat="file in vm.file"><div><div class="spinner-x-small" style="display: inline-block; vertical-align: super" ng-if="file.uploading"><div id="loading-animation"></div></div><div style="display: inline-block; vertical-align: super" ng-class="file.status == 1 ? \'primaryModal\' : \'warningModal\'">{{file.name}}</div></div></div><div class="form-group"><div align="center"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-disabled="!vm.file" ng-click="vm.upload()"><data-i18n i18n="_btn_upload_">upload</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div></div>');
$templateCache.put('app/pages/feeds/importXMLFeed/chooseFeed.modal.html','<div class="modal-content"><div class="modal-body"><table class="table sort-table" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr ng-if="!vm.hideFilters"><th colspan="6"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_feeds_search_feeds_label_">Search feeds</data-i18n></label> <input placeholder="{{\'_search_placeholder_feed_name_\'|i18n}}" class="form-control" type="text" ng-model="vm.searchMaster" id="feedsSearchInput" ng-change="vm.searchMasterChanged()"></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_settings_calculation_type_title_">Select calculation</data-i18n></label><br><ui-select style="z-index: 9000 !important" ng-model="vm.selectedCalculation" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.defaultCalculationChanged()" id="calc" name="calc" required=""><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.defaultCalculationList | filter: $select.search" ui-disable-choice="vm.selectedCalculation.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_picker_feed_type_placeholder_">Select feed type</data-i18n></label><br><ui-select style="z-index: 9000 !important" ng-model="vm.feedTypesItem" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.feedTypeChanged()"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.feedTypesList | filter: $select.search" ui-disable-choice="vm.feedTypesItem.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_feeds_common_">Common</data-i18n></label><br><ui-select style="z-index: 9000 !important" ng-model="vm.commonFeedItem" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.commonFeedChanged()"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type in vm.commonFeedList | filter: $select.search" ui-disable-choice="vm.commonFeedItem.name == type.name"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div></div></div><div class="row" ng-if="vm.feedType == \'new\'"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_feeds_my_master_">my/master</data-i18n></label><br><ui-select style="z-index: 9000 !important" ng-model="vm.selectedFeedType" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.feedTypeSelected()"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.filterTypes | filter: $select.search" ui-disable-choice="vm.selectedFeedType.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div></th></tr><tr class="show-hide-filters"><td><button ng-click="vm.hideFilters = !vm.hideFilters"><i ng-if="!vm.hideFilters" class="ion-arrow-up-b"></i><i ng-if="vm.hideFilters" class="ion-arrow-down-b"></i><span><data-i18n i18n="_modal_show_hide_filters_">Show/hide filters</data-i18n></span><i ng-if="!vm.hideFilters" class="ion-arrow-up-b"></i><i ng-if="vm.hideFilters" class="ion-arrow-down-b"></i></button></td></tr><tr class="sortable"><th style="width: 5%"></th><th style="width: 25%" ng-click="vm.sort(\'feed_name\')"><data-i18n i18n="_feeds_name_">Feed name</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br></th><th style="width: 19%" ng-click="vm.sort(\'test_date\')"><data-i18n i18n="_feeds_test_date_">Test date</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'test_date_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'test_date_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br></th><th style="width: 17%" ng-click="vm.sort(\'dm\')"><data-i18n i18n="_feeds_dm_">dm</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span></th><th style="width: 17%" ng-click="vm.sort(\'cp\')"><data-i18n i18n="_feeds_cp_">cp</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th><th style="width: 17%" ng-click="vm.sort(\'ndf\')"><data-i18n i18n="_feeds_ndf_">ndf</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th></tr></thead><tbody infinite-scroll="" scroll-fn="vm.paginationChangedMaster()" scroll-no-all="vm.totalItemsMaster" scroll-no-displayed="vm.totalDisplayed" scroll-disable="vm.disableScroll" ng-if="vm.feedsLoaded"><tr ng-repeat="feed in vm.feeds"><td style="width: 5%"><a class="ion-plus-circled icon-edit" href="" ng-click="vm.selectFeed(feed)"></a></td><td style="width: 25%">{{feed.feed_name}}</td><td style="width: 19%">{{feed.test_date | date:\'mediumDate\'}}</td><td style="width: 17%">{{feed.dm | formatViewValues: \'dm\'}}</td><td style="width: 17%">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td style="width: 17%">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td></tr><tr ng-if="vm.disableScroll"><td><data-i18n i18n="_title_loading_">Loading...</data-i18n></td></tr></tbody><tbody ng-if="!vm.feedsLoaded"><tr><td style="width: 100%" align="center"><div id="loading-animation-large"></div></td></tr></tbody><tfoot></tfoot></table><div align="right"><button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/feeds/importXMLFeed/importXMLFeed.html','<div><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><div ng-include="\'app/pages/feeds/importXMLFeed/importXMLFeed.panel.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/feeds/importXMLFeed/importXMLFeed.panel.html','<div ng-if="!vm.loadingTeams && !vm.loadingXmlFeeds && !vm.loadingUpdate && vm.myFeedsLoaded"><div ng-if="vm.selectedTeam"><div class="row" style="margin-top: 10px; margin-bottom: 10px; margin-right: 0px; margin-left: 0px" ng-if="!vm.loadingTeams && !vm.loadingXmlFeeds"><div class="col-xlg-4 col-lg-4 col-md-12 col-sm-12 col-xs-12"></div><div class="col-xlg-4 col-lg-4 col-md-12 col-sm-12 col-xs-12"><div class="text-center" style="text-align: center"><div><button type="button" class="btn btn-primary no-border-radius" ng-click="vm.selectType(\'update\')" uib-tooltip="{{\'_spar_update_existing_btn_\' | i18n}}" tooltip-is-open="feed_update" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" style="margin: 10px; height: 55px"><data-i18n i18n="_btn_update_feed_">Update existing feeds</data-i18n></button> <button type="button" class="btn btn-primary no-border-radius" ng-click="vm.selectType(\'new\')" uib-tooltip="{{\'_create_new_feed_button_\' | i18n}}" tooltip-is-open="feed_create_new" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin: 10px; height: 55px"><data-i18n i18n="_btn_feed_new_feed_">New feed</data-i18n></button></div></div></div></div><div class="row" style="margin-top: 10px; margin-bottom: 10px; margin-right: 0px; margin-left: 0px" ng-if="vm.showFeeds"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/feeds/importXMLFeed/xmlFeeds.table.html"></div></div></div></div><div class="row" style="margin-top: 10px; margin-bottom: 10px; margin-right: 0px; margin-left: 0px" ng-if="vm.selectedXmlFeed && !vm.loadingTable && (vm.updateSelected || vm.newSelected)"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.defaultTable.calc_type == 0" include-with-scope="app/pages/feeds/importXMLFeed/importXMLFeed.table.US.html"></div><div ng-if="vm.defaultTable.calc_type == 1" include-with-scope="app/pages/feeds/importXMLFeed/importXMLFeed.table.VemDve.html"></div></div></div><button type="button" class="btn btn-primary pull-right" ng-if="vm.updateSelected" ng-click="vm.updateFeed()" style="margin-right: 15px" ng-disabled="!vm.selectedXmlFeed || !vm.selectedMyFeed || vm.xmlForm.$invalid"><data-i18n i18n="_btn_update_">Update</data-i18n></button> <span ng-if="vm.newSelected"><button type="button" class="btn btn-info pull-right" ng-click="vm.createFeed()" style="margin-right: 15px" ng-if="vm.selectedMyFeed" ng-disabled="!vm.selectedXmlFeed || vm.xmlForm.$invalid"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button type="button" class="btn btn-success pull-right" ng-click="vm.createFeed()" style="margin-right: 15px" ng-if="!vm.selectedMyFeed" ng-disabled="!vm.selectedXmlFeed"><data-i18n i18n="_btn_save_">Save</data-i18n></button></span></div><div ng-if="vm.loadingTable" align="center"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></div></div><div ng-if="!vm.selectedTeam" align="center"><div><h3><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></h3></div></div></div><div ng-if="vm.loadingTeams || vm.loadingXmlFeeds || vm.loadingUpdate || !vm.myFeedsLoaded" align="center"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/importXMLFeed/importXMLFeed.table.US.html','<div class="vertical-scroll"><form name="vm.xmlForm"><table class="table table-bordered-striped xml_table"><thead><tr class="sortable" style="height: 30px"><th style="padding: 5px; vertical-align: middle; text-align: center; margin-bottom: 15px"><div style="margin-top: 5px"><data-i18n i18n="_spar_nutrients_">Nutrients</data-i18n></div></th><th style="text-align: center; padding: 5px; vertical-align: middle"><div style="margin-bottom: -15px"><data-i18n i18n="_title_imported_own_feed_">imported own feed</data-i18n><br>{{vm.selectedXmlFeed.feed_name}}</div></th><th style="text-align: center; padding: 5px; vertical-align: middle"><div style="float: left; margin-top: 10px"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.openChooseFeedModal()" uib-tooltip="{{\'_spar_reference_feed_button_\' | i18n}}" tooltip-is-open="reference" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><i class="fa fa-plus"></i></button></div><div style="display: inline-block" ng-if="!vm.selectedMyFeed.feed_name"><data-i18n i18n="_title_reference_feed_">Reference feed</data-i18n><br><data-i18n i18n="_title_no_reference_feed_">No reference feed selected</data-i18n></div><div style="display: inline-block" ng-if="vm.selectedMyFeed.feed_name"><data-i18n i18n="_title_reference_feed_">Reference feed</data-i18n><br>{{vm.selectedMyFeed.feed_name}}</div></th><th style="text-align: center; padding: 5px; vertical-align: middle"><div style="margin-bottom: -10px"><data-i18n i18n="_title_result_feed_">result</data-i18n><br></div></th></tr></thead><tbody><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_dm_">DM</data-i18n>(%)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_dm_">DM</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}})</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.dm | formatViewValues: \'dm\'}}</td><td>{{vm.selectedMyFeed.dm | formatViewValues: \'dm\'}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.dm.$invalid && (vm.xmlForm.dm.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="dm" required="" step="any" min="0.01" max="100" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="dm" ng-model="vm.resultFeed.dm" ng-class="vm.checkDeviation(\'dm\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0.01&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.dm.$invalid && (vm.xmlForm.dm.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="dm" required="" step="any" min="0.01" max="1000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="dm" ng-model="vm.resultFeed.dm" ng-class="vm.checkDeviation(\'dm\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0.01&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.ndf | formatViewValues: \'ndf\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.ndf | formatViewValues: \'ndf\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.ndf.$invalid && (vm.xmlForm.ndf.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ndf" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="ndf" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.ndf" ng-class="vm.checkDeviation(\'ndf\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.ndf.$invalid && (vm.xmlForm.ndf.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ndf" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="ndf" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.ndf" ng-class="vm.checkDeviation(\'ndf\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_ndf_dig_">NDF Dig</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.ndf_digest | formatViewValues: \'ndf_digest\'}}</td><td>{{vm.selectedMyFeed.ndf_digest | formatViewValues: \'ndf_digest\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.ndf_digest.$invalid && (vm.xmlForm.ndf_digest.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ndf_digest" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="ndf_digest" ng-model="vm.resultFeed.ndf_digest" ng-class="vm.checkDeviation(\'ndf_digest\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td>{{vm.selectedMyFeed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.ef_ndf_as_ndf.$invalid && (vm.xmlForm.ef_ndf_as_ndf.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ef_ndf_as_ndf" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="ef_ndf_as_ndf" ng-model="vm.resultFeed.ef_ndf_as_ndf" ng-class="vm.checkDeviation(\'ef_ndf_as_ndf\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_adf_">ADF</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_adf_">ADF</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.adf | formatViewValues: \'adf\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.adf | formatViewValues: \'adf\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.adf.$invalid && (vm.xmlForm.adf.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="adf" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="adf" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.adf" ng-class="vm.checkDeviation(\'adf\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.adf.$invalid && (vm.xmlForm.adf.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="adf" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="adf" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.adf" ng-class="vm.checkDeviation(\'adf\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_lingnin_">Lignin</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_lingnin_">Lignin</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.lignin | formatViewValues: \'lignin\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.lignin | formatViewValues: \'lignin\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.lignin.$invalid && (vm.xmlForm.lignin.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="lignin" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="lignin" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.lignin" ng-class="vm.checkDeviation(\'lignin\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.lignin.$invalid && (vm.xmlForm.lignin.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="lignin" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="lignin" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.lignin" ng-class="vm.checkDeviation(\'lignin\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_rdndf_">RDNDF</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.rd_ndf | formatViewValues: \'rd_ndf\'}}</td><td>{{vm.selectedMyFeed.rd_ndf | formatViewValues: \'rd_ndf\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.rd_ndf.$invalid && (vm.xmlForm.rd_ndf.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="rd_ndf" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="rd_ndf" ng-model="vm.resultFeed.rd_ndf" ng-class="vm.checkDeviation(\'rd_ndf\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_disc_fac_">Disc. Fac</data-i18n>(%)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.disc_fac | formatViewValues: \'disc_fac\'}}</td><td>{{vm.selectedMyFeed.disc_fac | formatViewValues: \'disc_fac\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.disc_fac.$invalid && (vm.xmlForm.disc_fac.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="disc_fac" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="disc_fac" ng-model="vm.resultFeed.disc_fac" ng-class="vm.checkDeviation(\'disc_fac\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_nel89_">NEL 89</data-i18n>({{vm.energy}}/{{vm.weight}})</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.nel_89 | formatViewValues: \'nel_89\'}}</td><td>{{vm.selectedMyFeed.nel_89 | formatViewValues: \'nel_89\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.nel_89.$invalid && (vm.xmlForm.nel_89.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="nel_89" required="" step="any" min="0" max="{{vm.nel_89Max}}" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="nel_89" ng-model="vm.resultFeed.nel_89" ng-class="vm.checkDeviation(\'nel_89\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;{{vm.nel_89Max}}</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_me89_">ME 89</data-i18n>({{vm.energy}}/{{vm.weight}})</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.me_89 | formatViewValues: \'me_89\'}}</td><td>{{vm.selectedMyFeed.me_89 | formatViewValues: \'me_89\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.me_89.$invalid && (vm.xmlForm.me_89.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="me_89" required="" step="any" min="0" max="{{vm.me_89max}}" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="me_89" ng-model="vm.resultFeed.me_89" ng-class="vm.checkDeviation(\'me_89\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;{{vm.me_89max}}</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_cp_">CP</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_cp_">CP</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.cp | formatViewValues: \'cp\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.cp | formatViewValues: \'cp\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.cp.$invalid && (vm.xmlForm.cp.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="cp" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="cp" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.cp" ng-class="vm.checkDeviation(\'cp\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.cp.$invalid && (vm.xmlForm.cp.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="cp" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="cp" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.cp" ng-class="vm.checkDeviation(\'cp\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.rup_dig | formatViewValues: \'rup_dig\'}}</td><td>{{vm.selectedMyFeed.rup_dig | formatViewValues: \'rup_dig\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.rup_dig.$invalid && (vm.xmlForm.rup_dig.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="rup_dig" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="rup_dig" ng-model="vm.resultFeed.rup_dig" ng-class="vm.checkDeviation(\'rup_dig\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_protein_b_">B Prot</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.b_prot | formatViewValues: \'b_prot\'}}</td><td>{{vm.selectedMyFeed.b_prot | formatViewValues: \'b_prot\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.b_prot.$invalid && (vm.xmlForm.b_prot.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="b_prot" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="b_prot" ng-model="vm.resultFeed.b_prot" ng-class="vm.checkDeviation(\'b_prot\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_protein_c_">C Prot</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.c_prot | formatViewValues: \'c_prot\'}}</td><td>{{vm.selectedMyFeed.c_prot | formatViewValues: \'c_prot\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.c_prot.$invalid && (vm.xmlForm.c_prot.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="c_prot" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="c_prot" ng-model="vm.resultFeed.c_prot" ng-class="vm.checkDeviation(\'c_prot\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_kd_bprot_">kd BProt</data-i18n>(%/&nbsp;<data-i18n i18n="_unit_hours_">hr</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.kd_b_prot | formatViewValues: \'kd_b_prot\'}}</td><td>{{vm.selectedMyFeed.kd_b_prot | formatViewValues: \'kd_b_prot\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.kd_b_prot.$invalid && (vm.xmlForm.kd_b_prot.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="kd_b_prot" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="kd_b_prot" ng-model="vm.resultFeed.kd_b_prot" ng-class="vm.checkDeviation(\'kd_b_prot\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_npncpe_">NPNCPE</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.npncpe | formatViewValues: \'npncpe\'}}</td><td>{{vm.selectedMyFeed.npncpe | formatViewValues: \'npncpe\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.npncpe.$invalid && (vm.xmlForm.npncpe.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="npncpe" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="npncpe" ng-model="vm.resultFeed.npncpe" ng-class="vm.checkDeviation(\'npncpe\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_rup89_">RUP 89</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.rup_89 | formatViewValues: \'rup_89\'}}</td><td>{{vm.selectedMyFeed.rup_89 | formatViewValues: \'rup_89\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.rup_89.$invalid && (vm.xmlForm.rup_89.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="rup_89" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="rup_89" ng-model="vm.resultFeed.rup_89" ng-class="vm.checkDeviation(\'rup_89\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_ndicp_">NDICP</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_ndicp_">NDICP</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.ndicp | formatViewValues: \'ndicp\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.ndicp | formatViewValues: \'ndicp\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.ndicp.$invalid && (vm.xmlForm.ndicp.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ndicp" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="ndicp" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.ndicp" ng-class="vm.checkDeviation(\'ndicp\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.ndicp.$invalid && (vm.xmlForm.ndicp.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ndicp" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="ndicp" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.ndicp" ng-class="vm.checkDeviation(\'ndicp\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.adicp | formatViewValues: \'adicp\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.adicp | formatViewValues: \'adicp\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.adicp.$invalid && (vm.xmlForm.adicp.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="adicp" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="adicp" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.adicp" ng-class="vm.checkDeviation(\'adicp\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.adicp.$invalid && (vm.xmlForm.adicp.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="adicp" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="adicp" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.adicp" ng-class="vm.checkDeviation(\'adicp\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_nfc_digestibility_">NFC dig</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_nfc_">NFC</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.nfc_dig | formatViewValues: \'nfc_dig\'}}</td><td>{{vm.selectedMyFeed.nfc_dig | formatViewValues: \'nfc_dig\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.nfc_dig.$invalid && (vm.xmlForm.nfc_dig.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="nfc_dig" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="nfc_dig" ng-model="vm.resultFeed.nfc_dig" ng-class="vm.checkDeviation(\'nfc_dig\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_sugar_">Sugar</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_sugar_">Sugar</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.sugar | formatViewValues: \'sugar\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.sugar | formatViewValues: \'sugar\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.sugar.$invalid && (vm.xmlForm.sugar.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="sugar" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="sugar" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.sugar" ng-class="vm.checkDeviation(\'sugar\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.sugar.$invalid && (vm.xmlForm.sugar.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="sugar" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="sugar" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.sugar" ng-class="vm.checkDeviation(\'sugar\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_starch_">Starch</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_starch_">Starch</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.starch | formatViewValues: \'starch\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.starch | formatViewValues: \'starch\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.starch.$invalid && (vm.xmlForm.starch.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="starch" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="starch" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.starch" ng-class="vm.checkDeviation(\'starch\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.starch.$invalid && (vm.xmlForm.starch.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="starch" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="starch" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.starch" ng-class="vm.checkDeviation(\'starch\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_infa_">INFA</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_infa_">INFA</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.in_fa | formatViewValues: \'in_fa\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.in_fa | formatViewValues: \'in_fa\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.in_fa.$invalid && (vm.xmlForm.in_fa.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="in_fa" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="in_fa" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.in_fa" ng-class="vm.checkDeviation(\'in_fa\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.in_fa.$invalid && (vm.xmlForm.in_fa.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="in_fa" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="in_fa" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.in_fa" ng-class="vm.checkDeviation(\'in_fa\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_starch_">Starch</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.rd_starch | formatViewValues: \'rd_starch\'}}</td><td>{{vm.selectedMyFeed.rd_starch | formatViewValues: \'rd_starch\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.rd_starch.$invalid && (vm.xmlForm.rd_starch.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="rd_starch" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="rd_starch" ng-model="vm.resultFeed.rd_starch" ng-class="vm.checkDeviation(\'rd_starch\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_rdsolf_">RDSolf</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_solfiber_">Solf</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.rd_sol_fiber | formatViewValues: \'rd_sol_fiber\'}}</td><td>{{vm.selectedMyFeed.rd_sol_fiber | formatViewValues: \'rd_sol_fiber\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.rd_sol_fiber.$invalid && (vm.xmlForm.rd_sol_fiber.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="rd_sol_fiber" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="rd_sol_fiber" ng-model="vm.resultFeed.rd_sol_fiber" ng-class="vm.checkDeviation(\'rd_sol_fiber\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_ee_">EE</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_ee_">EE</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.ee | formatViewValues: \'ee\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.ee | formatViewValues: \'ee\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.ee.$invalid && (vm.xmlForm.ee.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ee" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="ee" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.ee" ng-class="vm.checkDeviation(\'ee\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.ee.$invalid && (vm.xmlForm.ee.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ee" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="ee" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.ee" ng-class="vm.checkDeviation(\'ee\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_bhfa_">BHFA</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.bhfa | formatViewValues: \'bhfa\'}}</td><td>{{vm.selectedMyFeed.bhfa | formatViewValues: \'bhfa\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.bhfa.$invalid && (vm.xmlForm.bhfa.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="bhfa" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="bhfa" ng-model="vm.resultFeed.bhfa" ng-class="vm.checkDeviation(\'bhfa\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_pufa_">PUFA</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.pufa | formatViewValues: \'pufa\'}}</td><td>{{vm.selectedMyFeed.pufa | formatViewValues: \'pufa\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.pufa.$invalid && (vm.xmlForm.pufa.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="pufa" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="pufa" ng-model="vm.resultFeed.pufa" ng-class="vm.checkDeviation(\'pufa\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_sfa_">SFA</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.sfa | formatViewValues: \'sfa\'}}</td><td>{{vm.selectedMyFeed.sfa | formatViewValues: \'sfa\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.sfa.$invalid && (vm.xmlForm.sfa.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="sfa" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="sfa" ng-model="vm.resultFeed.sfa" ng-class="vm.checkDeviation(\'sfa\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_fa_dig_">FA dig</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.fa_dig | formatViewValues: \'fa_dig\'}}</td><td>{{vm.selectedMyFeed.fa_dig | formatViewValues: \'fa_dig\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.fa_dig.$invalid && (vm.xmlForm.fa_dig.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="fa_dig" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="fa_dig" ng-model="vm.resultFeed.fa_dig" ng-class="vm.checkDeviation(\'fa_dig\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_ca_">Ca</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_ca_">Ca</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.ca | formatViewValues: \'ca\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.ca | formatViewValues: \'ca\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.ca.$invalid && (vm.xmlForm.ca.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ca" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="ca" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.ca" ng-class="vm.checkDeviation(\'ca\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.ca.$invalid && (vm.xmlForm.ca.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ca" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="ca" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.ca" ng-class="vm.checkDeviation(\'ca\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_ca_abs_">Ca</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_ca_">Ca</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.ca_abs | formatViewValues: \'ca_abs\'}}</td><td>{{vm.selectedMyFeed.ca_abs | formatViewValues: \'ca_abs\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.ca_abs.$invalid && (vm.xmlForm.ca_abs.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ca_abs" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="ca_abs" ng-model="vm.resultFeed.ca_abs" ng-class="vm.checkDeviation(\'ca_abs\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_p_">P</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_p_">P</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.p | formatViewValues: \'p\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.p | formatViewValues: \'p\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.p.$invalid && (vm.xmlForm.p.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="p" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="p" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.p" ng-class="vm.checkDeviation(\'p\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.p.$invalid && (vm.xmlForm.p.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="p" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="p" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.p" ng-class="vm.checkDeviation(\'p\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_p_">P</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.p_abs | formatViewValues: \'p_abs\'}}</td><td>{{vm.selectedMyFeed.p_abs | formatViewValues: \'p_abs\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.p_abs.$invalid && (vm.xmlForm.p_abs.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="p_abs" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="p_abs" ng-model="vm.resultFeed.p_abs" ng-class="vm.checkDeviation(\'p_abs\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_mg_">Mg</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_mg_">Mg</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.mg | formatViewValues: \'mg\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.mg | formatViewValues: \'mg\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.mg.$invalid && (vm.xmlForm.mg.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="mg" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="mg" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.mg" ng-class="vm.checkDeviation(\'mg\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.mg.$invalid && (vm.xmlForm.mg.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="mg" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="mg" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.mg" ng-class="vm.checkDeviation(\'mg\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_mg_abs_">Mg</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_mg_">Mg</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.mg_abs | formatViewValues: \'mg_abs\'}}</td><td>{{vm.selectedMyFeed.mg_abs | formatViewValues: \'mg_abs\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.mg_abs.$invalid && (vm.xmlForm.mg_abs.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="mg_abs" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="mg_abs" ng-model="vm.resultFeed.mg_abs" ng-class="vm.checkDeviation(\'mg_abs\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_k_">K</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_k_">K</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.k | formatViewValues: \'k\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.k | formatViewValues: \'k\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.k.$invalid && (vm.xmlForm.k.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="k" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="k" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.k" ng-class="vm.checkDeviation(\'k\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.k.$invalid && (vm.xmlForm.k.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="k" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="k" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.k" ng-class="vm.checkDeviation(\'k\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_na_">Na</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_na_">Na</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.na | formatViewValues: \'na\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.na | formatViewValues: \'na\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.na.$invalid && (vm.xmlForm.na.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="na" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="na" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.na" ng-class="vm.checkDeviation(\'na\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.na.$invalid && (vm.xmlForm.na.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="na" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="na" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.na" ng-class="vm.checkDeviation(\'na\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_cl_">Cl</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_cl_">Cl</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.cl | formatViewValues: \'cl\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.cl | formatViewValues: \'cl\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.cl.$invalid && (vm.xmlForm.cl.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="cl" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="cl" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.cl" ng-class="vm.checkDeviation(\'cl\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.cl.$invalid && (vm.xmlForm.cl.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="cl" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="cl" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.cl" ng-class="vm.checkDeviation(\'cl\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_s_">S</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_s_">S</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.s | formatViewValues: \'s\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.s | formatViewValues: \'s\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.s.$invalid && (vm.xmlForm.s.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="s" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="s" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.s" ng-class="vm.checkDeviation(\'s\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.s.$invalid && (vm.xmlForm.s.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="s" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="s" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.s" ng-class="vm.checkDeviation(\'s\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_ash_">Ash</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_ash_">Ash</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.ash | formatViewValues: \'ash\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.ash | formatViewValues: \'ash\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.ash.$invalid && (vm.xmlForm.ash.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ash" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="ash" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.ash" ng-class="vm.checkDeviation(\'ash\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.ash.$invalid && (vm.xmlForm.ash.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ash" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="ash" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.ash" ng-class="vm.checkDeviation(\'ash\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_co_">Co</data-i18n>(<data-i18n i18n="_unit_ppm_">ppm</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.co | formatViewValues: \'co\'}}</td><td>{{vm.selectedMyFeed.co | formatViewValues: \'co\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.co.$invalid && (vm.xmlForm.co.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="co" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="co" ng-model="vm.resultFeed.co" ng-class="vm.checkDeviation(\'co\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_cu_">Cu</data-i18n>(<data-i18n i18n="_unit_ppm_">ppm</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.cu | formatViewValues: \'cu\'}}</td><td>{{vm.selectedMyFeed.cu | formatViewValues: \'cu\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.cu.$invalid && (vm.xmlForm.cu.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="cu" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="cu" ng-model="vm.resultFeed.cu" ng-class="vm.checkDeviation(\'cu\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_cu_abs_">abs Cu</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_cu_">cu</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.cu_abs | formatViewValues: \'cu_abs\'}}</td><td>{{vm.selectedMyFeed.cu_abs | formatViewValues: \'cu_abs\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.cu_abs.$invalid && (vm.xmlForm.cu_abs.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="cu_abs" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="cu_abs" ng-model="vm.resultFeed.cu_abs" ng-class="vm.checkDeviation(\'cu_abs\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_fe_">Fe</data-i18n>(<data-i18n i18n="_unit_ppm_">ppm</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.fe | formatViewValues: \'fe\'}}</td><td>{{vm.selectedMyFeed.fe | formatViewValues: \'fe\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.fe.$invalid && (vm.xmlForm.fe.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="fe" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="fe" ng-model="vm.resultFeed.fe" ng-class="vm.checkDeviation(\'fe\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_fe_abs_">abs Fe</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_fe_">Fe</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.fe_abs | formatViewValues: \'fe_abs\'}}</td><td>{{vm.selectedMyFeed.fe_abs | formatViewValues: \'fe_abs\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.fe_abs.$invalid && (vm.xmlForm.fe_abs.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="fe_abs" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="fe_abs" ng-model="vm.resultFeed.fe_abs" ng-class="vm.checkDeviation(\'fe_abs\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_i_">I</data-i18n>(<data-i18n i18n="_unit_ppm_">ppm</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.i | formatViewValues: \'i\'}}</td><td>{{vm.selectedMyFeed.i | formatViewValues: \'i\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.i.$invalid && (vm.xmlForm.i.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="i" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="i" ng-model="vm.resultFeed.i" ng-class="vm.checkDeviation(\'i\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_i_abs_">abs I</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_i_">I</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.i_abs | formatViewValues: \'i_abs\'}}</td><td>{{vm.selectedMyFeed.i_abs | formatViewValues: \'i_abs\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.i_abs.$invalid && (vm.xmlForm.i_abs.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="i_abs" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="i_abs" ng-model="vm.resultFeed.i_abs" ng-class="vm.checkDeviation(\'i_abs\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_mo_">Mo</data-i18n>(<data-i18n i18n="_unit_ppm_">ppm</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.mo | formatViewValues: \'mo\'}}</td><td>{{vm.selectedMyFeed.mo | formatViewValues: \'mo\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.mo.$invalid && (vm.xmlForm.mo.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="mo" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="mo" ng-model="vm.resultFeed.mo" ng-class="vm.checkDeviation(\'mo\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_mn_">Mn</data-i18n>(<data-i18n i18n="_unit_ppm_">ppm</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.mn | formatViewValues: \'mn\'}}</td><td>{{vm.selectedMyFeed.mn | formatViewValues: \'mn\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.mn.$invalid && (vm.xmlForm.mn.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="mn" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="mn" ng-model="vm.resultFeed.mn" ng-class="vm.checkDeviation(\'mn\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_mn_abs_">abs Mn</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_mn_">Mn</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.mn_abs | formatViewValues: \'mn_abs\'}}</td><td>{{vm.selectedMyFeed.mn_abs | formatViewValues: \'mn_abs\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.mn_abs.$invalid && (vm.xmlForm.mn_abs.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="mn_abs" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="mn_abs" ng-model="vm.resultFeed.mn_abs" ng-class="vm.checkDeviation(\'mn_abs\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_se_">Se</data-i18n>(<data-i18n i18n="_unit_ppm_">ppm</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.se | formatViewValues: \'se\'}}</td><td>{{vm.selectedMyFeed.se | formatViewValues: \'se\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.se.$invalid && (vm.xmlForm.se.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="se" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="se" ng-model="vm.resultFeed.se" ng-class="vm.checkDeviation(\'se\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_se_abs_">abs Se</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_se_">Se</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.se_abs | formatViewValues: \'se_abs\'}}</td><td>{{vm.selectedMyFeed.se_abs | formatViewValues: \'se_abs\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.se_abs.$invalid && (vm.xmlForm.se_abs.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="se_abs" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="se_abs" ng-model="vm.resultFeed.se_abs" ng-class="vm.checkDeviation(\'se_abs\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_zn_">Zn</data-i18n>(<data-i18n i18n="_unit_ppm_">ppm</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.zn | formatViewValues: \'zn\'}}</td><td>{{vm.selectedMyFeed.zn | formatViewValues: \'zn\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.zn.$invalid && (vm.xmlForm.zn.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="zn" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="zn" ng-model="vm.resultFeed.zn" ng-class="vm.checkDeviation(\'zn\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_zn_abs_">abs Zn</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_zn_">Zn</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.zn_abs | formatViewValues: \'zn_abs\'}}</td><td>{{vm.selectedMyFeed.zn_abs | formatViewValues: \'zn_abs\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.zn_abs.$invalid && (vm.xmlForm.zn_abs.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="zn_abs" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="zn_abs" ng-model="vm.resultFeed.zn_abs" ng-class="vm.checkDeviation(\'zn_abs\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_vit_a_">Vitamin A</data-i18n>(<data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}})</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.vitamin_a | formatViewValues: \'vitamin_a\'}}</td><td>{{vm.selectedMyFeed.vitamin_a | formatViewValues: \'vitamin_a\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.vitamin_a.$invalid && (vm.xmlForm.vitamin_a.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="vitamin_a" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="vitamin_a" ng-model="vm.resultFeed.vitamin_a" ng-class="vm.checkDeviation(\'vitamin_a\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_vit_d_">Vitamin D</data-i18n>(<data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}})</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.vitamin_d | formatViewValues: \'vitamin_d\'}}</td><td>{{vm.selectedMyFeed.vitamin_d | formatViewValues: \'vitamin_d\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.vitamin_d.$invalid && (vm.xmlForm.vitamin_d.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="vitamin_d" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="vitamin_d" ng-model="vm.resultFeed.vitamin_d" ng-class="vm.checkDeviation(\'vitamin_d\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_vit_e_">Vitamin E</data-i18n>(<data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}})</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.vitamin_e | formatViewValues: \'vitamin_e\'}}</td><td>{{vm.selectedMyFeed.vitamin_e | formatViewValues: \'vitamin_e\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.vitamin_e.$invalid && (vm.xmlForm.vitamin_e.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="vitamin_e" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="vitamin_e" ng-model="vm.resultFeed.vitamin_e" ng-class="vm.checkDeviation(\'vitamin_e\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_lysine_">lysine</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_drup_">dRUP</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.lysine | formatViewValues: \'lysine\'}}</td><td>{{vm.selectedMyFeed.lysine | formatViewValues: \'lysine\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.lysine.$invalid && (vm.xmlForm.lysine.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="lysine" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="lysine" ng-model="vm.resultFeed.lysine" ng-class="vm.checkDeviation(\'lysine\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_methionine_">Met</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_drup_">dRUP</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.methionine | formatViewValues: \'methionine\'}}</td><td>{{vm.selectedMyFeed.methionine | formatViewValues: \'methionine\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.methionine.$invalid && (vm.xmlForm.methionine.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="methionine" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="methionine" ng-model="vm.resultFeed.methionine" ng-class="vm.checkDeviation(\'methionine\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_teaa_">TEAA</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_drup_">dRUP</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.teaa | formatViewValues: \'teaa\'}}</td><td>{{vm.selectedMyFeed.teaa | formatViewValues: \'teaa\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.teaa.$invalid && (vm.xmlForm.teaa.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="teaa" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="teaa" ng-model="vm.resultFeed.teaa" ng-class="vm.checkDeviation(\'teaa\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_cost_as_sold_">Cost as sold</data-i18n>({{vm.currency}})</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.cost_as_sold | formatViewValues: \'cost_as_sold\'}}</td><td>{{vm.selectedMyFeed.cost_as_sold | formatViewValues: \'cost_as_sold\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.cost_as_sold.$invalid && (vm.xmlForm.cost_as_sold.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="cost_as_sold" required="" step="any" min="0" max="1000000000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="cost_as_sold" ng-model="vm.resultFeed.cost_as_sold" ng-class="vm.checkDeviation(\'cost_as_sold\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_wt_as_sold_">Wt as sold</data-i18n>({{vm.weight}})</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.wt_as_sold | formatViewValues: \'wt_as_sold\'}}</td><td>{{vm.selectedMyFeed.wt_as_sold | formatViewValues: \'wt_as_sold\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.wt_as_sold.$invalid && (vm.xmlForm.wt_as_sold.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="wt_as_sold" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="wt_as_sold" ng-model="vm.resultFeed.wt_as_sold" ng-class="vm.checkDeviation(\'wt_as_sold\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_test_date_">Test date</data-i18n></td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.test_date | date:\'mediumDate\'}}</td><td>{{vm.selectedMyFeed.test_date | date:\'mediumDate\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.test_date.$invalid && (vm.xmlForm.test_date.$dirty || vm.xmlForm.$submitted)}"><p class="input-group" style="width: 50%"><input type="text" uib-datepicker-popup="{{vm.date_format}}" placeholder="{{vm.date_format}}" class="form-control" ng-model="vm.resultFeed.test_date" is-open="vm.opened" required="" name="test_date" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></td></tr></tbody><tfoot></tfoot></table></form></div>');
$templateCache.put('app/pages/feeds/importXMLFeed/importXMLFeed.table.VemDve.html','<div class="vertical-scroll"><form name="vm.xmlForm"><table class="table table-bordered-striped xml_table"><thead><tr class="sortable" style="height: 30px"><th style="padding: 5px; vertical-align: middle; text-align: center"><div style="margin-top: 5px"><data-i18n i18n="_spar_nutrients_">Nutrients</data-i18n></div></th><th style="text-align: center; padding: 5px; vertical-align: middle"><div style="margin-bottom: -15px"><data-i18n i18n="_title_imported_own_feed_">imported own feed</data-i18n><br>{{vm.selectedXmlFeed.feed_name}}</div></th><th style="text-align: center; padding: 5px; vertical-align: middle"><div style="float: left; margin-top: 10px"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.openChooseFeedModal()" uib-tooltip="{{\'_spar_reference_feed_button_\' | i18n}}" tooltip-is-open="reference" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><i class="fa fa-plus"></i></button></div><div style="display: inline-block" ng-if="!vm.selectedMyFeed.feed_name"><data-i18n i18n="_title_reference_feed_">Reference feed</data-i18n><br><data-i18n i18n="_title_no_reference_feed_">No reference feed selected</data-i18n></div><div style="display: inline-block" ng-if="vm.selectedMyFeed.feed_name"><data-i18n i18n="_title_reference_feed_">Reference feed</data-i18n><br>{{vm.selectedMyFeed.feed_name}}</div></th><th style="text-align: center; padding: 5px; vertical-align: middle"><div style="margin-bottom: -10px"><data-i18n i18n="_title_result_feed_">result</data-i18n><br></div></th></tr></thead><tbody><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_dm_">DM</data-i18n>(%)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_dm_">DM</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}})</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.dm | formatViewValues: \'dm\'}}</td><td>{{vm.selectedMyFeed.dm | formatViewValues: \'dm\'}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.dm.$invalid && (vm.xmlForm.dm.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="dm" required="" step="any" min="0.01" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="dm" ng-model="vm.resultFeed.dm" ng-class="vm.checkDeviation(\'dm\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0.01&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.dm.$invalid && (vm.xmlForm.dm.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="dm" required="" step="any" min="0.01" max="1000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="dm" ng-model="vm.resultFeed.dm" ng-class="vm.checkDeviation(\'dm\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0.01&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.rc | formatViewValues: \'rc\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.rc | formatViewValues: \'rc\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.rc.$invalid && (vm.xmlForm.rc.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="rc" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="rc" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.rc" ng-class="vm.checkDeviation(\'rc\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.rc.$invalid && (vm.xmlForm.rc.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="rc" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="rc" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.rc" ng-class="vm.checkDeviation(\'rc\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.ndf | formatViewValues: \'ndf\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.ndf | formatViewValues: \'ndf\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.ndf.$invalid && (vm.xmlForm.ndf.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ndf" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="ndf" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.ndf" ng-class="vm.checkDeviation(\'ndf\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.ndf.$invalid && (vm.xmlForm.ndf.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ndf" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="ndf" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.ndf" ng-class="vm.checkDeviation(\'ndf\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_ndf_dig_">NDF Dig</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.ndf_digest | formatViewValues: \'ndf_digest\'}}</td><td>{{vm.selectedMyFeed.ndf_digest | formatViewValues: \'ndf_digest\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.ndf_digest.$invalid && (vm.xmlForm.ndf_digest.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ndf_digest" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="ndf_digest" ng-model="vm.resultFeed.ndf_digest" ng-class="vm.checkDeviation(\'ndf_digest\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_adf_">ADF</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_adf_">ADF</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.adf | formatViewValues: \'adf\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.adf | formatViewValues: \'adf\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.adf.$invalid && (vm.xmlForm.adf.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="adf" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="adf" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.adf" ng-class="vm.checkDeviation(\'adf\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.adf.$invalid && (vm.xmlForm.adf.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="adf" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="adf" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.adf" ng-class="vm.checkDeviation(\'adf\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_lingnin_">Lignin</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_lingnin_">Lignin</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.lignin | formatViewValues: \'lignin\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.lignin | formatViewValues: \'lignin\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.lignin.$invalid && (vm.xmlForm.lignin.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="lignin" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="lignin" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.lignin" ng-class="vm.checkDeviation(\'lignin\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.lignin.$invalid && (vm.xmlForm.lignin.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="lignin" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="lignin" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.lignin" ng-class="vm.checkDeviation(\'lignin\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_vem_">Vem</data-i18n>(/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.vem | formatViewValues: \'vem\'}}</td><td>{{vm.selectedMyFeed.vem | formatViewValues: \'vem\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.vem.$invalid && (vm.xmlForm.vem.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="vem" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="vem" ng-model="vm.resultFeed.vem" ng-class="vm.checkDeviation(\'vem\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_fos_">Fos</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.fos | formatViewValues: \'fos\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.fos | formatViewValues: \'fos\': vm.selectedMyFeed.dm}}</td><td ng-class="{\'has-error\': vm.xmlForm.fos.$invalid && (vm.xmlForm.fos.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="fos" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="fos" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.fos" ng-class="vm.checkDeviation(\'fos\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_cp_">CP</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_cp_">CP</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.cp | formatViewValues: \'cp\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.cp | formatViewValues: \'cp\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.cp.$invalid && (vm.xmlForm.cp.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="cp" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="cp" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.cp" ng-class="vm.checkDeviation(\'cp\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.cp.$invalid && (vm.xmlForm.cp.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="cp" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="cp" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.cp" ng-class="vm.checkDeviation(\'cp\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_dve_">Dve</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.dve | formatViewValues: \'dve\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.dve | formatViewValues: \'dve\': vm.selectedMyFeed.dm}}</td><td ng-class="{\'has-error\': vm.xmlForm.dve.$invalid && (vm.xmlForm.dve.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="dve" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="dve" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.dve" ng-class="vm.checkDeviation(\'dve\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_oeb_">Oeb</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.oeb | formatViewValues: \'oeb\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.oeb | formatViewValues: \'oeb\': vm.selectedMyFeed.dm}}</td><td ng-class="{\'has-error\': vm.xmlForm.oeb.$invalid && (vm.xmlForm.oeb.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="oeb" required="" step="any" min="-1000000" max="1000000" type="number" pattern="^-?\\d*(\\.\\d{0})?$" format-input-value="oeb" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.oeb" ng-class="vm.checkDeviation(\'oeb\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;-1000000&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_sugar_">Sugar</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_sugar_">Sugar</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.sugar | formatViewValues: \'sugar\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.sugar | formatViewValues: \'sugar\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.sugar.$invalid && (vm.xmlForm.sugar.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="sugar" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="sugar" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.sugar" ng-class="vm.checkDeviation(\'sugar\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.sugar.$invalid && (vm.xmlForm.sugar.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="sugar" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="sugar" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.sugar" ng-class="vm.checkDeviation(\'sugar\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_starch_">Starch</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_starch_">Starch</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.starch | formatViewValues: \'starch\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.starch | formatViewValues: \'starch\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.starch.$invalid && (vm.xmlForm.starch.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="starch" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="starch" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.starch" ng-changed="vm.valueChanged(\'starch\')" ng-class="vm.checkDeviation(\'starch\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.starch.$invalid && (vm.xmlForm.starch.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="starch" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="starch" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.starch" ng-changed="vm.valueChanged(\'starch\')" ng-class="vm.checkDeviation(\'starch\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_rus_">Rus</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_rus_">Rus</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.rus | formatViewValues: \'rus\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.rus | formatViewValues: \'rus\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.rus.$invalid && (vm.xmlForm.rus.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="rus" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="rus" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.rus" ng-changed="vm.valueChanged(\'rus\')" ng-class="vm.checkDeviation(\'rus\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.rus.$invalid && (vm.xmlForm.rus.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="rus" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="rus" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.rus" ng-changed="vm.valueChanged(\'rus\')" ng-class="vm.checkDeviation(\'rus\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_ee_">EE</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_ee_">EE</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.ee | formatViewValues: \'ee\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.ee | formatViewValues: \'ee\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.ee.$invalid && (vm.xmlForm.ee.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ee" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="ee" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.ee" ng-class="vm.checkDeviation(\'ee\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.ee.$invalid && (vm.xmlForm.ee.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ee" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="ee" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.ee" ng-class="vm.checkDeviation(\'ee\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_bhfa_">BHFA</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.bhfa | formatViewValues: \'bhfa\'}}</td><td>{{vm.selectedMyFeed.bhfa | formatViewValues: \'bhfa\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.bhfa.$invalid && (vm.xmlForm.bhfa.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="bhfa" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="bhfa" ng-model="vm.resultFeed.bhfa" ng-class="vm.checkDeviation(\'bhfa\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_pufa_">PUFA</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.pufa | formatViewValues: \'pufa\'}}</td><td>{{vm.selectedMyFeed.pufa | formatViewValues: \'pufa\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.pufa.$invalid && (vm.xmlForm.pufa.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="pufa" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="pufa" ng-model="vm.resultFeed.pufa" ng-class="vm.checkDeviation(\'pufa\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_sfa_">SFA</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.sfa | formatViewValues: \'sfa\'}}</td><td>{{vm.selectedMyFeed.sfa | formatViewValues: \'sfa\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.sfa.$invalid && (vm.xmlForm.sfa.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="sfa" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="sfa" ng-model="vm.resultFeed.sfa" ng-class="vm.checkDeviation(\'sfa\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_fa_dig_">FA dig</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.fa_dig | formatViewValues: \'fa_dig\'}}</td><td>{{vm.selectedMyFeed.fa_dig | formatViewValues: \'fa_dig\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.fa_dig.$invalid && (vm.xmlForm.fa_dig.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="fa_dig" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="fa_dig" ng-model="vm.resultFeed.fa_dig" ng-class="vm.checkDeviation(\'fa_dig\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_ca_">Ca</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_ca_">Ca</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.ca | formatViewValues: \'ca\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.ca | formatViewValues: \'ca\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.ca.$invalid && (vm.xmlForm.ca.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ca" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="ca" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.ca" ng-class="vm.checkDeviation(\'ca\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.ca.$invalid && (vm.xmlForm.ca.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ca" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="ca" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.ca" ng-class="vm.checkDeviation(\'ca\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_ca_abs_">Ca</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_ca_">Ca</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.ca_abs | formatViewValues: \'ca_abs\'}}</td><td>{{vm.selectedMyFeed.ca_abs | formatViewValues: \'ca_abs\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.ca_abs.$invalid && (vm.xmlForm.ca_abs.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ca_abs" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="ca_abs" ng-model="vm.resultFeed.ca_abs" ng-class="vm.checkDeviation(\'ca_abs\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_p_">P</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_p_">P</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.p | formatViewValues: \'p\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.p | formatViewValues: \'p\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.p.$invalid && (vm.xmlForm.p.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="p" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="p" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.p" ng-class="vm.checkDeviation(\'p\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.p.$invalid && (vm.xmlForm.p.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="p" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="p" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.p" ng-class="vm.checkDeviation(\'p\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_p_">P</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.p_abs | formatViewValues: \'p_abs\'}}</td><td>{{vm.selectedMyFeed.p_abs | formatViewValues: \'p_abs\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.p_abs.$invalid && (vm.xmlForm.p_abs.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="p_abs" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="p_abs" ng-model="vm.resultFeed.p_abs" ng-class="vm.checkDeviation(\'p_abs\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_mg_">Mg</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_mg_">Mg</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.mg | formatViewValues: \'mg\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.mg | formatViewValues: \'mg\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.mg.$invalid && (vm.xmlForm.mg.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="mg" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="mg" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.mg" ng-class="vm.checkDeviation(\'mg\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.mg.$invalid && (vm.xmlForm.mg.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="mg" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="mg" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.mg" ng-class="vm.checkDeviation(\'mg\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_mg_abs_">Mg</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_mg_">Mg</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.mg_abs | formatViewValues: \'mg_abs\'}}</td><td>{{vm.selectedMyFeed.mg_abs | formatViewValues: \'mg_abs\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.mg_abs.$invalid && (vm.xmlForm.mg_abs.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="mg_abs" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="mg_abs" ng-model="vm.resultFeed.mg_abs" ng-class="vm.checkDeviation(\'mg_abs\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_k_">K</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_k_">K</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.k | formatViewValues: \'k\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.k | formatViewValues: \'k\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.k.$invalid && (vm.xmlForm.k.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="k" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="k" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.k" ng-class="vm.checkDeviation(\'k\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.k.$invalid && (vm.xmlForm.k.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="k" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="k" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.k" ng-class="vm.checkDeviation(\'k\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_na_">Na</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_na_">Na</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.na | formatViewValues: \'na\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.na | formatViewValues: \'na\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.na.$invalid && (vm.xmlForm.na.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="na" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="na" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.na" ng-class="vm.checkDeviation(\'na\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.na.$invalid && (vm.xmlForm.na.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="na" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="na" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.na" ng-class="vm.checkDeviation(\'na\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_cl_">Cl</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_cl_">Cl</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.cl | formatViewValues: \'cl\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.cl | formatViewValues: \'cl\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.cl.$invalid && (vm.xmlForm.cl.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="cl" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="cl" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.cl" ng-class="vm.checkDeviation(\'cl\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.cl.$invalid && (vm.xmlForm.cl.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="cl" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="cl" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.cl" ng-class="vm.checkDeviation(\'cl\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_s_">S</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_s_">S</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.s | formatViewValues: \'s\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.s | formatViewValues: \'s\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.s.$invalid && (vm.xmlForm.s.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="s" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="s" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.s" ng-class="vm.checkDeviation(\'s\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.s.$invalid && (vm.xmlForm.s.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="s" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="s" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.s" ng-class="vm.checkDeviation(\'s\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td ng-if="vm.settings.use_percent"><data-i18n i18n="_feeds_ash_">Ash</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>)</td><td ng-if="!vm.settings.use_percent"><data-i18n i18n="_feeds_ash_">Ash</data-i18n>(<data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.ash | formatViewValues: \'ash\': vm.selectedXmlFeed.dm}}</td><td>{{vm.selectedMyFeed.ash | formatViewValues: \'ash\': vm.selectedMyFeed.dm}}</td><td ng-if="vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.ash.$invalid && (vm.xmlForm.ash.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ash" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="ash" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.ash" ng-class="vm.checkDeviation(\'ash\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td><td ng-if="!vm.settings.use_percent" ng-class="{\'has-error\': vm.xmlForm.ash.$invalid && (vm.xmlForm.ash.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="ash" required="" step="any" min="0" max="10000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="ash" format-value-dm="vm.resultFeed.dm" ng-model="vm.resultFeed.ash" ng-class="vm.checkDeviation(\'ash\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_co_">Co</data-i18n>(<data-i18n i18n="_unit_ppm_">ppm</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.co | formatViewValues: \'co\'}}</td><td>{{vm.selectedMyFeed.co | formatViewValues: \'co\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.co.$invalid && (vm.xmlForm.co.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="co" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="co" ng-model="vm.resultFeed.co" ng-class="vm.checkDeviation(\'co\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_cu_">Cu</data-i18n>(<data-i18n i18n="_unit_ppm_">ppm</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.cu | formatViewValues: \'cu\'}}</td><td>{{vm.selectedMyFeed.cu | formatViewValues: \'cu\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.cu.$invalid && (vm.xmlForm.cu.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="cu" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="cu" ng-model="vm.resultFeed.cu" ng-class="vm.checkDeviation(\'cu\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_cu_abs_">abs Cu</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_cu_">cu</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.cu_abs | formatViewValues: \'cu_abs\'}}</td><td>{{vm.selectedMyFeed.cu_abs | formatViewValues: \'cu_abs\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.cu_abs.$invalid && (vm.xmlForm.cu_abs.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="cu_abs" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="cu_abs" ng-model="vm.resultFeed.cu_abs" ng-class="vm.checkDeviation(\'cu_abs\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_fe_">Fe</data-i18n>(<data-i18n i18n="_unit_ppm_">ppm</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.fe | formatViewValues: \'fe\'}}</td><td>{{vm.selectedMyFeed.fe | formatViewValues: \'fe\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.fe.$invalid && (vm.xmlForm.fe.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="fe" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="fe" ng-model="vm.resultFeed.fe" ng-class="vm.checkDeviation(\'fe\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_fe_abs_">abs Fe</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_fe_">Fe</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.fe_abs | formatViewValues: \'fe_abs\'}}</td><td>{{vm.selectedMyFeed.fe_abs | formatViewValues: \'fe_abs\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.fe_abs.$invalid && (vm.xmlForm.fe_abs.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="fe_abs" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="fe_abs" ng-model="vm.resultFeed.fe_abs" ng-class="vm.checkDeviation(\'fe_abs\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_i_">I</data-i18n>(<data-i18n i18n="_unit_ppm_">ppm</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.i | formatViewValues: \'i\'}}</td><td>{{vm.selectedMyFeed.i | formatViewValues: \'i\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.i.$invalid && (vm.xmlForm.i.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="i" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="i" ng-model="vm.resultFeed.i" ng-class="vm.checkDeviation(\'i\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_i_abs_">abs I</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_i_">I</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.i_abs | formatViewValues: \'i_abs\'}}</td><td>{{vm.selectedMyFeed.i_abs | formatViewValues: \'i_abs\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.i_abs.$invalid && (vm.xmlForm.i_abs.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="i_abs" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="i_abs" ng-model="vm.resultFeed.i_abs" ng-class="vm.checkDeviation(\'i_abs\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_mo_">Mo</data-i18n>(<data-i18n i18n="_unit_ppm_">ppm</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.mo | formatViewValues: \'mo\'}}</td><td>{{vm.selectedMyFeed.mo | formatViewValues: \'mo\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.mo.$invalid && (vm.xmlForm.mo.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="mo" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="mo" ng-model="vm.resultFeed.mo" ng-class="vm.checkDeviation(\'mo\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_mn_">Mn</data-i18n>(<data-i18n i18n="_unit_ppm_">ppm</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.mn | formatViewValues: \'mn\'}}</td><td>{{vm.selectedMyFeed.mn | formatViewValues: \'mn\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.mn.$invalid && (vm.xmlForm.mn.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="mn" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0,1})?$" format-input-value="mn" ng-model="vm.resultFeed.mn" ng-class="vm.checkDeviation(\'mn\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_one_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_mn_abs_">abs Mn</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_mn_">Mn</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.mn_abs | formatViewValues: \'mn_abs\'}}</td><td>{{vm.selectedMyFeed.mn_abs | formatViewValues: \'mn_abs\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.mn_abs.$invalid && (vm.xmlForm.mn_abs.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="mn_abs" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="mn_abs" ng-model="vm.resultFeed.mn_abs" ng-class="vm.checkDeviation(\'mn_abs\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_se_">Se</data-i18n>(<data-i18n i18n="_unit_ppm_">ppm</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.se | formatViewValues: \'se\'}}</td><td>{{vm.selectedMyFeed.se | formatViewValues: \'se\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.se.$invalid && (vm.xmlForm.se.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="se" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="se" ng-model="vm.resultFeed.se" ng-class="vm.checkDeviation(\'se\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_se_abs_">abs Se</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_se_">Se</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.se_abs | formatViewValues: \'se_abs\'}}</td><td>{{vm.selectedMyFeed.se_abs | formatViewValues: \'se_abs\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.se_abs.$invalid && (vm.xmlForm.se_abs.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="se_abs" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="se_abs" ng-model="vm.resultFeed.se_abs" ng-class="vm.checkDeviation(\'se_abs\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_zn_">Zn</data-i18n>(<data-i18n i18n="_unit_ppm_">ppm</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.zn | formatViewValues: \'zn\'}}</td><td>{{vm.selectedMyFeed.zn | formatViewValues: \'zn\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.zn.$invalid && (vm.xmlForm.zn.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="zn" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="zn" ng-model="vm.resultFeed.zn" ng-class="vm.checkDeviation(\'zn\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_zn_abs_">abs Zn</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_zn_">Zn</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.zn_abs | formatViewValues: \'zn_abs\'}}</td><td>{{vm.selectedMyFeed.zn_abs | formatViewValues: \'zn_abs\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.zn_abs.$invalid && (vm.xmlForm.zn_abs.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="zn_abs" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="zn_abs" ng-model="vm.resultFeed.zn_abs" ng-class="vm.checkDeviation(\'zn_abs\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_vit_a_">Vitamin A</data-i18n>(<data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}})</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.vitamin_a | formatViewValues: \'vitamin_a\'}}</td><td>{{vm.selectedMyFeed.vitamin_a | formatViewValues: \'vitamin_a\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.vitamin_a.$invalid && (vm.xmlForm.vitamin_a.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="vitamin_a" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="vitamin_a" ng-model="vm.resultFeed.vitamin_a" ng-class="vm.checkDeviation(\'vitamin_a\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_vit_d_">Vitamin D</data-i18n>(<data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}})</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.vitamin_d | formatViewValues: \'vitamin_d\'}}</td><td>{{vm.selectedMyFeed.vitamin_d | formatViewValues: \'vitamin_d\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.vitamin_d.$invalid && (vm.xmlForm.vitamin_d.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="vitamin_d" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="vitamin_d" ng-model="vm.resultFeed.vitamin_d" ng-class="vm.checkDeviation(\'vitamin_d\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_vit_e_">Vitamin E</data-i18n>(<data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}})</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.vitamin_e | formatViewValues: \'vitamin_e\'}}</td><td>{{vm.selectedMyFeed.vitamin_e | formatViewValues: \'vitamin_e\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.vitamin_e.$invalid && (vm.xmlForm.vitamin_e.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="vitamin_e" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0})?$" format-input-value="vitamin_e" ng-model="vm.resultFeed.vitamin_e" ng-class="vm.checkDeviation(\'vitamin_e\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_no_dec_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_lysine_">lysine</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_drup_">dRUP</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.lysine | formatViewValues: \'lysine\'}}</td><td>{{vm.selectedMyFeed.lysine | formatViewValues: \'lysine\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.lysine.$invalid && (vm.xmlForm.lysine.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="lysine" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="lysine" ng-model="vm.resultFeed.lysine" ng-class="vm.checkDeviation(\'lysine\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_methionine_">Met</data-i18n>(%&nbsp;<data-i18n i18n="_feeds_drup_">dRUP</data-i18n>)</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.methionine | formatViewValues: \'methionine\'}}</td><td>{{vm.selectedMyFeed.methionine | formatViewValues: \'methionine\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.methionine.$invalid && (vm.xmlForm.methionine.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="methionine" required="" step="any" min="0" max="100" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="methionine" ng-model="vm.resultFeed.methionine" ng-class="vm.checkDeviation(\'methionine\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;100</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_cost_as_sold_">Cost as sold</data-i18n>({{vm.currency}})</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.cost_as_sold | formatViewValues: \'cost_as_sold\'}}</td><td>{{vm.selectedMyFeed.cost_as_sold | formatViewValues: \'cost_as_sold\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.cost_as_sold.$invalid && (vm.xmlForm.cost_as_sold.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="cost_as_sold" required="" step="any" min="0" max="1000000000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="cost_as_sold" ng-model="vm.resultFeed.cost_as_sold" ng-class="vm.checkDeviation(\'cost_as_sold\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_wt_as_sold_">Wt as sold</data-i18n>({{vm.weight}})</td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.wt_as_sold | formatViewValues: \'wt_as_sold\'}}</td><td>{{vm.selectedMyFeed.wt_as_sold | formatViewValues: \'wt_as_sold\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.wt_as_sold.$invalid && (vm.xmlForm.wt_as_sold.$dirty || vm.xmlForm.$submitted)}"><input select-on-click="" style="line-height: normal; width: 50%; height: 28px; display: inline" class="form-control" name="wt_as_sold" required="" step="any" min="0" max="1000000" type="number" pattern="^\\d*(\\.\\d{0,2})?$" format-input-value="wt_as_sold" ng-model="vm.resultFeed.wt_as_sold" ng-class="vm.checkDeviation(\'wt_as_sold\')"><span ng-hide="!vm.selectedMyFeed" style="margin-left: 10px"><a class="ion-arrow-up-b" href="" ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 0" style="font-size: 18px" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a><a ng-hide="vm.deviationUp == 3" ng-if="vm.deviationUp == 1" style="font-size: 18px" class="ion-arrow-down-b warningModal" href="" uib-tooltip="{{vm.resultFeed.deviationToolTip}}" tooltip-append-to-body="true" tooltip-is-open="deviationToolTip1" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></span><span class="help-block error-block basic-block"><data-i18n i18n="_value_should_be_between_">Value should be between</data-i18n>&nbsp;0&nbsp;&&nbsp;1000000</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_feeds_test_date_">Test date</data-i18n></td><td style="text-align: right; font-weight: 600">{{vm.selectedXmlFeed.test_date | date:\'mediumDate\'}}</td><td>{{vm.selectedMyFeed.test_date | date:\'mediumDate\'}}</td><td ng-class="{\'has-error\': vm.xmlForm.test_date.$invalid && (vm.xmlForm.test_date.$dirty || vm.xmlForm.$submitted)}"><p class="input-group" style="width: 50%"><input type="text" uib-datepicker-popup="{{vm.date_format}}" placeholder="{{vm.date_format}}" class="form-control" ng-model="vm.resultFeed.test_date" is-open="vm.opened" required="" name="test_date" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></td></tr></tbody><tfoot></tfoot></table></form></div>');
$templateCache.put('app/pages/feeds/importXMLFeed/importXMLNewFeed.modal.html','<div class="modal-content" ng-cloak=""><div class="modal-body" ng-if="!vm.loadingSave"><form name="vm.addXmlFeedForm" novalidate=""><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addXmlFeedForm.feed_name.$invalid && (vm.addXmlFeedForm.feed_name.$dirty || vm.addXmlFeedForm.$submitted)}"><label for="feed_name"><data-i18n i18n="_feeds_name_">Feed name</data-i18n></label> <input type="text" maxlength="60" class="form-control" id="feed_name" name="feed_name" placeholder="{{\'_feeds_name_\'|i18n}}" ng-model="vm.newFeed.feed_name" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_feeds_name_required_">feed name is required</data-i18n></span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addXmlFeedForm.feed_type.$invalid && (vm.addXmlFeedForm.feed_type.$dirty || vm.addXmlFeedForm.$submitted)}"><label for="feed_type"><data-i18n i18n="_feeds_type_">Feed type</data-i18n></label><ui-select style="z-index: 9000 !important" ng-model="vm.feedTypesItem" class="btn-group bootstrap-select form-control" append-to-body="true" id="feed_type" name="feed_type" required="" on-select="vm.feedTypeSelectedValidate()"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.feedTypesList | filter: $select.search"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_toastr_feeds_type_required_">feed type is required</data-i18n></span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addXmlFeedForm.selected_herd.$invalid && (vm.addXmlFeedForm.selected_herd.$dirty || vm.addXmlFeedForm.$submitted)}"><label style="font-size: 15px" ng-if="vm.selected_herd.Id"><data-i18n i18n="_create_feed_for_herd_warning_">Are you sure you want to save this new feed for</data-i18n>&nbsp<b>{{vm.selected_herd.Name}}</b>?</label><br><label style="font-size: 15px" ng-if="!vm.selected_herd.Id"><data-i18n i18n="_herd_selection_for_feed_">Select herd</data-i18n></label> <label style="font-size: 15px" ng-if="vm.selected_herd.Id"><data-i18n i18n="_select_another_herd_">Select another herd</data-i18n></label><ui-select style="z-index: 9000 !important" ng-model="vm.selected_herd" class="btn-group bootstrap-select form-control" append-to-body="true" id="selected_herd" name="selected_herd" required=""><ui-select-match>{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="type in vm.herds | filter: $select.search"><span ng-bind-html="type.Name"></span></ui-select-choices></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_feeds_name_required_">feed name is required</data-i18n></span></div><div class="form-group"><label for="comments"><data-i18n i18n="_feeds_comment_">comment</data-i18n></label> <textarea placeholder="{{\'_feeds_comment_\'|i18n}}" class="form-control" id="comments" style="resize: none" ng-model="vm.newFeed.comments"></textarea></div><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap" uib-tooltip="{{\'_description_common_feed_\' | i18n}}" tooltip-is-open="commonIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><input type="checkbox" id="common_feed" ng-model="vm.newFeed.common_feed"> <span><data-i18n i18n="_feeds_common_">Common feed</data-i18n></span></label></div><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="is_purchased" ng-model="vm.newFeed.is_purchased"> <span><data-i18n i18n="_feeds_purchased_">Purchased</data-i18n></span></label></div><div align="right"><button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'animal_description\')"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button> <button type="submit" class="btn btn-info btn-with-icon save-profile" ng-click="vm.saveFeed()"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></form></div><div ng-if="vm.loadingSave" align="center"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/feeds/importXMLFeed/xmlFeeds.table.html','<div class="vertical-scroll"><table class="table xml_table" style="padding: 0 10px 10px 10px"><thead><tr><th><data-i18n i18n="_feeds_name_">Feed name</data-i18n></th><th><data-i18n i18n="_m_f_label_imported_">imported</data-i18n></th><th></th></tr></thead><tbody><tr ng-repeat="feed in vm.xmlFeeds" ng-class="feed === vm.selectedXmlFeed ? \'tr-highlight\' : \'\'"><td style="padding: 2.5px 0">{{feed.feed_name}}</td><td style="padding: 2.5px 0"><a class="ion-checkmark-round primaryModal" ng-if="feed.imported"></a> <a class="ion-close-round warningModal" ng-if="!feed.imported"></a></td><td style="padding: 2.5px 0"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.selectXmlFeed(feed)"><data-i18n i18n="_m_f_btn_choose_">Choose</data-i18n></button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/feeds/manualFeedHistory/manualFeedsHistory.html','<div><div ng-if="!vm.loading && vm.selectedHerd" class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div ng-include="\'app/pages/feeds/manualFeedHistory/manualFeedsHistory.table.html\'"></div></div></div></div><div ng-if="vm.loading" class="row" ba-panel=""><div class="col-lg-12 col-md-12"><div style="height: 200px; overflow: hidden" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div><div ng-if="!vm.loading && !vm.selectedHerd" align="center" ba-panel=""><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div>');
$templateCache.put('app/pages/feeds/manualFeedHistory/manualFeedsHistory.table.html','<div ng-if="!vm.loadingTable"><button class="btn btn-primary btn-xs" ng-click="vm.back()" style="margin: 5px"><i class="ion-arrow-left-c"></i>&nbsp;<data i18n="_btn_back_">Back</data></button><table class="table table-bordered"><thead><tr><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br><br></th><th><data-i18n i18n="_feeds_type_">Feed type</data-i18n><br><br></th><th><data-i18n i18n="_feeds_dm_">DM</data-i18n><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span></th><th><data-i18n i18n="_feeds_amount_">Amount</data-i18n><br><span>{{vm.weight}}</span></th><th><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n><br><span>{{vm.weight}}</span></th><th><data-i18n i18n="_feeds_cost_dm_">Cost dm</data-i18n><br><span>{{vm.currency}}/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th><th><data-i18n i18n="_feeds_cost_as_fed_">Cost as fed</data-i18n><br><span>{{vm.currency}}/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th><th><data-i18n i18n="_title_create_date">Create date</data-i18n><br><br></th><th><data-i18n i18n="_title_last_modified_date_">Last modified date</data-i18n><br><br></th><th><data-i18n i18n="_description_user_">Last modified user</data-i18n><br><br></th></tr></thead><tbody><tr ng-repeat="history in vm.history track by history.id"><td>{{history.action}}</td><td>{{history.feed_name}}</td><td>{{history.feed_type.translated}}</td><td>{{history.dm | formatViewValues: \'percentage\'}}</td><td>{{history.amount_dm | formatViewValues: \'amount\'}}</td><td>{{history.amount_as_fed | formatViewValues: \'amount\'}}</td><td>{{history.cost_dm | formatViewValues: \'cost_dm\'}}</td><td>{{history.cost_as_fed | formatViewValues: \'cost_dm\'}}</td><td>{{history.create_date | date: \'short\'}}</td><td>{{history.last_modified_date | date: \'short\'}}</td><td>{{history.last_modified_user}}</td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table></div><loading-spinner-large ng-if="vm.loadingTable"></loading-spinner-large>');
$templateCache.put('app/pages/feeds/myfeeds/confirmationDialog.modal.html','<div class="modal-content" ng-if="!vm.modalLoading"><div class="modal-header"><div align="center"><span class="ion-android-warning warningModal" style="font-size: 36px"></span></div><div align="center"><span class="warningModal">{{vm.warningMessage | i18n}}</span></div></div><div align="center"><button type="button" class="btn btn-with-icon save-profile" ng-class="vm.warningMessage == \'_feeds_delete_warning_message_ || _feeds_unmix_warning_message_ || _feeds_convert_warning_message_ || _feeds_remove_from_mix_warning_message_\' ? \'btn-primary\' : \'btn-primary\'" ng-click="vm.proceed(vm.warningMessage)"><span class="defaultModal" ng-if="vm.warningMessage == \'_feeds_delete_warning_message_\'"><data-i18n i18n="_btn_delete_">Delete</data-i18n></span> <span class="defaultModal" ng-if="vm.warningMessage == \'_feeds_unmix_warning_message_\'"><data-i18n i18n="_btn_unmix_">Unmix</data-i18n></span> <span class="defaultModal" ng-if="vm.warningMessage == \'_feeds_convert_warning_message_\'"><data-i18n i18n="_btn_convert_">Convert</data-i18n></span> <span class="defaultModal" ng-if="vm.warningMessage == \'_feeds_remove_from_mix_warning_message_\'"><data-i18n i18n="_btn_remove_from_mix_">Remove</data-i18n></span></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.modalLoading" align="center"><div><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/feeds.amino_acid.html','<div><table ng-if="!vm.loadingTable" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="5"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th class="editable-header" ng-click="vm.sort(\'lysine\')"><div uib-tooltip="{{\'_description_lys_\' | i18n}}" tooltip-is-open="lysIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lysine_">Lys</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'lysine_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'lysine_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th><th class="editable-header" ng-click="vm.sort(\'methionine\')"><div uib-tooltip="{{\'_description_met_\' | i18n}}" tooltip-is-open="metIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_methionine_">Met</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'methionine_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'methionine_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th><th class="editable-header" ng-click="vm.sort(\'teaa\')"><div uib-tooltip="{{\'_description_teaa_\' | i18n}}" tooltip-is-open="teaaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_teaa_">teaa</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'teaa_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'teaa_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'A\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" e-ng-keydown="vm.feedKeyDown($event, $data)" id="feed_name{{$index}}A"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="lysine" editable-number="feed.lysine" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'lysine\', \'A\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="lysine{{$index}}A">{{feed.lysine | formatViewValues: \'lysine\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="methionine" editable-number="feed.methionine" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'methionine\', \'A\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="methionine{{$index}}A">{{feed.methionine | formatViewValues: \'methionine\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="teaa" editable-number="feed.teaa" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'teaa\', \'A\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="teaa{{$index}}A">{{feed.teaa | formatViewValues: \'teaa\'}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_lys_\' | i18n}}" tooltip-is-open="lysIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lysine_">Lys</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_met_\' | i18n}}" tooltip-is-open="metIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_methionine_">Met</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_teaa_\' | i18n}}" tooltip-is-open="teaaIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_teaa_">teaa</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" e-style="width:200px" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'A\')" id="feed_nameMIX{{$index}}A{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" e-format-input-value="lysine" editable-number="mixfeed.lysine" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'lysine\', \'A\', feed.id)" id="lysineMIX{{$index}}A{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.lysine | formatViewValues: \'lysine\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" e-format-input-value="methionine" editable-number="mixfeed.methionine" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'methionine\', \'A\', feed.id)" id="methionineMIX{{$index}}A{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.methionine | formatViewValues: \'methionine\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="teaa" editable-number="mixfeed.teaa" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'teaa\', \'A\', feed.id)" id="teaaMIX{{$index}}A{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.teaa | formatViewValues: \'teaa\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/feeds.cost.html','<div><table ng-if="!vm.loadingTable && vm.settings.use_percent" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="7"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th class="editable-header" ng-click="vm.sort(\'dm\')"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%</span></div></th><th class="editable-header" ng-click="vm.sort(\'wt_as_sold\')"><div uib-tooltip="{{\'_description_wt_as_sold_\' | i18n}}" tooltip-is-open="wtAsSoldIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_wt_as_sold_">wt as sold</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'wt_as_sold_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'wt_as_sold_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.weight}}</div></th><th class="editable-header" ng-click="vm.sort(\'costAsSold\')"><div uib-tooltip="{{\'_description_cost_as_sold_\' | i18n}}" tooltip-is-open="costAsSoldIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_as_sold_">cost as sold</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'costAsSold_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'costAsSold_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.currency}}</div></th><th ng-click="vm.sort(\'cost_dm\')"><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cost_dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cost_dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.currency}}/{{vm.weight}}</div></th><th class="editable-header" ng-click="vm.sort(\'isPurchased\')"><div uib-tooltip="{{\'_description_is_purchased_\' | i18n}}" tooltip-is-open="isPurchasedIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_purchased_">Purchased</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'isPurchased_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'isPurchased_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'CS\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" e-ng-keydown="vm.feedKeyDown($event, $data)" id="feed_name{{$index}}CS"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="dm" editable-number="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'dm\', \'CS\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="dm{{$index}}CS">{{feed.dm | formatViewValues: \'dm\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="wt_as_sold" editable-number="feed.wt_as_sold" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'wt_as_sold\', \'CS\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="wt_as_sold{{$index}}CS">{{feed.wt_as_sold | formatViewValues: \'wt_as_sold\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="cost_as_sold" editable-number="feed.cost_as_sold" e-min="0" e-max="1000000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'cost_as_sold\', \'CS\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="cost_as_sold{{$index}}CS">{{feed.cost_as_sold | formatViewValues: \'cost_as_sold\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td style="padding: 3px 3px"><span class="newCheck"><input type="checkbox" id="is_purchased{{$index-X}}" ng-disabled="!feed.team_id || feed.loading" ng-model="feed.is_purchased" ng-change="vm.updateFeed(feed, $index, $data, \'is_purchased\')"><label for="is_purchased{{$index-X}}" style="left: 45%; top: 50%"></label></span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span>%</span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_wt_as_sold_\' | i18n}}" tooltip-is-open="wtAsSoldIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_wt_as_sold_">wt as sold</data-i18n><br>{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_cost_as_sold_\' | i18n}}" tooltip-is-open="costAsSoldIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_as_sold_">cost as sold</data-i18n><br>{{vm.currency}}</div></th><th><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_is_purchased_\' | i18n}}" tooltip-is-open="isPurchasedIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_purchased_">Purchased</data-i18n><br><br></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'CS\')" id="feed_nameMIX{{$index}}CS{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="dm" editable-number="mixfeed.dm" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'dm\', \'CS\', feed.id)" id="dmMIX{{$index}}CS{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.dm | formatViewValues: \'dm\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="wt_as_sold" editable-number="mixfeed.wt_as_sold" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'wt_as_sold\', \'CS\', feed.id)" id="wt_as_soldMIX{{$index}}CS{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.wt_as_sold | formatViewValues: \'wt_as_sold\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" e-format-input-value="cost_as_sold" editable-number="mixfeed.cost_as_sold" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'cost_as_sold\', \'CS\', feed.id)" id="cost_as_soldMIX{{$index}}CS{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cost_as_sold | formatViewValues: \'cost_as_sold\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td style="padding: 3px 3px"><span class="newCheck"><input type="checkbox" id="{{\'is_purchased\' + indexY + indexX}}-Z" ng-disabled="vm.ingredientsLoading" ng-model="mixfeed.is_purchased" ng-change="vm.updateMix(mixfeed, $index, $data, \'is_purchased\')"><label for="{{\'is_purchased\' + indexY + indexX}}-Z" style="left: 45%; top: 50%"></label></span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><table ng-if="!vm.loadingTable && !vm.settings.use_percent" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="7"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th class="editable-header" ng-click="vm.sort(\'dm\')"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></div></th><th class="editable-header" ng-click="vm.sort(\'wt_as_sold\')"><div uib-tooltip="{{\'_description_wt_as_sold_\' | i18n}}" tooltip-is-open="wtAsSoldIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_wt_as_sold_">wt as sold</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'wt_as_sold_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'wt_as_sold_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.weight}}</div></th><th class="editable-header" ng-click="vm.sort(\'costAsSold\')"><div uib-tooltip="{{\'_description_cost_as_sold_\' | i18n}}" tooltip-is-open="costAsSoldIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_as_sold_">cost as sold</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'costAsSold_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'costAsSold_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.currency}}</div></th><th ng-click="vm.sort(\'cost_dm\')"><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cost_dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cost_dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.currency}}/{{vm.weight}}</div></th><th class="editable-header" ng-click="vm.sort(\'isPurchased\')"><div uib-tooltip="{{\'_description_is_purchased_\' | i18n}}" tooltip-is-open="isPurchasedIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_purchased_">Purchased</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'isPurchased_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'isPurchased_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'CS\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" e-ng-keydown="vm.feedKeyDown($event, $data)" id="feed_name{{$index}}CS"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="dm" editable-number="feed.dm" e-min="0" e-max="1000" onbeforesave="vm.updateFeed(feed, $index, $data, \'dm\', \'CS\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="dm{{$index}}CS">{{feed.dm | formatViewValues: \'dm\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="wt_as_sold" editable-number="feed.wt_as_sold" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'wt_as_sold\', \'CS\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="wt_as_sold{{$index}}CS">{{feed.wt_as_sold | formatViewValues: \'wt_as_sold\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="cost_as_sold" editable-number="feed.cost_as_sold" e-min="0" e-max="1000000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'cost_as_sold\', \'CS\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="cost_as_sold{{$index}}CS">{{feed.cost_as_sold | formatViewValues: \'cost_as_sold\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td style="padding: 3px 3px"><span class="newCheck"><input type="checkbox" id="is_purchased{{$index-X}}" ng-disabled="!feed.team_id || feed.loading" ng-model="feed.is_purchased" ng-change="vm.updateFeed(feed, $index, $data, \'is_purchased\')"><label for="is_purchased{{$index-X}}" style="left: 45%; top: 50%"></label></span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_wt_as_sold_\' | i18n}}" tooltip-is-open="wtAsSoldIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_wt_as_sold_">wt as sold</data-i18n><br>{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_cost_as_sold_\' | i18n}}" tooltip-is-open="costAsSoldIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_as_sold_">cost as sold</data-i18n><br>{{vm.currency}}</div></th><th><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_is_purchased_\' | i18n}}" tooltip-is-open="isPurchasedIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_purchased_">Purchased</data-i18n><br><br></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'CS\')" id="feed_nameMIX{{$index}}CS{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="dm" editable-number="mixfeed.dm" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'dm\', \'CS\', feed.id)" id="dmMIX{{$index}}CS{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.dm | formatViewValues: \'dm\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="wt_as_sold" editable-number="mixfeed.wt_as_sold" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'wt_as_sold\', \'CS\', feed.id)" id="wt_as_soldMIX{{$index}}CS{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.wt_as_sold | formatViewValues: \'wt_as_sold\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" e-format-input-value="cost_as_sold" editable-number="mixfeed.cost_as_sold" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'cost_as_sold\', \'CS\', feed.id)" id="cost_as_soldMIX{{$index}}CS{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cost_as_sold | formatViewValues: \'cost_as_sold\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td style="padding: 3px 3px"><span class="newCheck"><input type="checkbox" id="{{\'is_purchased\' + indexY + indexX}}-Z" ng-disabled="vm.ingredientsLoading" ng-model="mixfeed.is_purchased" ng-change="vm.updateMix(mixfeed, $index, $data, \'is_purchased\')"><label for="{{\'is_purchased\' + indexY + indexX}}-Z" style="left: 45%; top: 50%"></label></span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/feeds.mineral.html','<div><table ng-if="!vm.loadingTable && vm.settings.use_percent" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="12"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th class="editable-header" ng-click="vm.sort(\'dm\')"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'ca_abs\')"><div uib-tooltip="{{\'_description_ca_abs_\' | i18n}}" tooltip-is-open="absCaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_abs_">abs Ca</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ca_abs_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ca_abs_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_ca_">Ca</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'p\')"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'p_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'p_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'p_abs\')"><div uib-tooltip="{{\'_description_p_abs_\' | i18n}}" tooltip-is-open="absPIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'p_abs_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'p_abs_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_p_">P</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'mg\')"><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">Mg</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'mg_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'mg_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'mg_abs\')"><div uib-tooltip="{{\'_description_mg_abs_\' | i18n}}" tooltip-is-open="absMgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_abs_">abs Mg</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'mg_abs_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'mg_abs_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_mg_">Mg</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'k\')"><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">K</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'k_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'k_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'na\')"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'na_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'na_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'cl\')"><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">Cl</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cl_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cl_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'s\')"><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">S</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'s_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'s_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th ng-click="vm.sort(\'dcad\')"><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dcad_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dcad_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th class="editable-header" ng-click="vm.sort(\'ash\')"><div uib-tooltip="{{\'_description_ash_\' | i18n}}" tooltip-is-open="ashIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ash_">ash</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ash_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ash_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'M\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" id="feed_name{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="ca" e-format-value-dm="feed.dm" editable-number="feed.ca" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ca\', \'M\')" id="ca{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ca | formatViewValues: \'ca\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="ca_abs" editable-number="feed.ca_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ca_abs\', \'M\')" id="ca_abs{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ca_abs | formatViewValues: \'ca_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="p" e-format-value-dm="feed.dm" editable-number="feed.p" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'p\', \'M\')" id="p{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.p | formatViewValues: \'p\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="p_abs" editable-number="feed.p_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'p_abs\', \'M\')" id="p_abs{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.p_abs | formatViewValues: \'p_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="mg" e-format-value-dm="feed.dm" editable-number="feed.mg" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'mg\', \'M\')" id="mg{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.mg | formatViewValues: \'mg\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="mg_abs" editable-number="feed.mg_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'mg_abs\', \'M\')" id="mg_abs{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.mg_abs | formatViewValues: \'mg_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="k" e-format-value-dm="feed.dm" editable-number="feed.k" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'k\', \'M\')" id="k{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.k | formatViewValues: \'k\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="na" e-format-value-dm="feed.dm" editable-number="feed.na" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'na\', \'M\')" id="na{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.na | formatViewValues: \'na\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="cl" e-format-value-dm="feed.dm" editable-number="feed.cl" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'cl\', \'M\')" id="cl{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.cl | formatViewValues: \'cl\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="s" e-format-value-dm="feed.dm" editable-number="feed.s" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'s\', \'M\')" id="s{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.s | formatViewValues: \'s\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.dcad | formatViewValues: \'dcad\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ash" e-format-value-dm="feed.dm" editable-number="feed.ash" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ash\', \'M\')" id="ash{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ash | formatViewValues: \'ash\': feed.dm}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ca_abs_\' | i18n}}" tooltip-is-open="absCaIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_abs_">abs Ca</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ca_">Ca</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_p_abs_\' | i18n}}" tooltip-is-open="absPIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_p_">P</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">Mg</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_mg_abs_\' | i18n}}" tooltip-is-open="absMgIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_abs_">abs Mg</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_mg_">Mg</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">K</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">Cl</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">S</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ash_\' | i18n}}" tooltip-is-open="ashIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ash_">ash</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'M\')" id="feed_nameMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.ingredientsLoading" e-format-input-value="ca" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ca" e-step="0.01" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ca\', \'M\', feed.id)" id="caMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ca | formatViewValues: \'ca\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="ca_abs" editable-number="mixfeed.ca_abs" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ca_abs\', \'M\', feed.id)" id="ca_absMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ca_abs | formatViewValues: \'ca_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="p" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.p" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'p\', \'M\', feed.id)" id="pMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.p | formatViewValues: \'p\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="p_abs" editable-number="mixfeed.p_abs" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'p_abs\', \'M\', feed.id)" id="p_absMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.p_abs | formatViewValues: \'p_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="mg" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.mg" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'mg\', \'M\', feed.id)" id="mgMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.mg | formatViewValues: \'mg\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="mg_abs" editable-number="mixfeed.mg_abs" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'mg_abs\', \'M\', feed.id)" id="mg_absMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.mg_abs | formatViewValues: \'mg_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="k" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.k" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'k\', \'M\', feed.id)" id="kMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.k | formatViewValues: \'k\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="na" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.na" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'na\', \'M\', feed.id)" id="naMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.na | formatViewValues: \'na\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="cl" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.cl" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'cl\', \'M\', feed.id)" id="clMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cl | formatViewValues: \'cl\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="s" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.s" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'s\', \'M\', feed.id)" id="sMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.s | formatViewValues: \'s\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.dcad | formatViewValues: \'dcad\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="ash" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ash" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ash\', \'M\', feed.id)" id="ashMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ash | formatViewValues: \'ash\': mixfeed.dm}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><table ng-if="!vm.loadingTable && !vm.settings.use_percent" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="12"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th class="editable-header" ng-click="vm.sort(\'dm\')"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'ca_abs\')"><div uib-tooltip="{{\'_description_ca_abs_\' | i18n}}" tooltip-is-open="absCaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_abs_">abs Ca</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ca_abs_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ca_abs_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_ca_">Ca</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'p\')"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'p_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'p_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'p_abs\')"><div uib-tooltip="{{\'_description_p_abs_\' | i18n}}" tooltip-is-open="absPIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'p_abs_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'p_abs_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_p_">P</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'mg\')"><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">Mg</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'mg_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'mg_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'mg_abs\')"><div uib-tooltip="{{\'_description_mg_abs_\' | i18n}}" tooltip-is-open="absMgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_abs_">abs Mg</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'mg_abs_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'mg_abs_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_mg_">Mg</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'k\')"><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">K</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'k_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'k_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'na\')"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'na_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'na_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'cl\')"><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">Cl</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cl_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cl_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'s\')"><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">S</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'s_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'s_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th ng-click="vm.sort(\'dcad\')"><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dcad_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dcad_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th class="editable-header" ng-click="vm.sort(\'ash\')"><div uib-tooltip="{{\'_description_ash_\' | i18n}}" tooltip-is-open="ashIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ash_">ash</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ash_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ash_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'M\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" id="feed_name{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ca" e-format-value-dm="feed.dm" editable-number="feed.ca" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ca\', \'M\')" id="ca{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ca | formatViewValues: \'ca\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="ca_abs" editable-number="feed.ca_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ca_abs\', \'M\')" id="ca_abs{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ca_abs | formatViewValues: \'ca_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="p" e-format-value-dm="feed.dm" editable-number="feed.p" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'p\', \'M\')" id="p{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.p | formatViewValues: \'p\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="p_abs" editable-number="feed.p_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'p_abs\', \'M\')" id="p_abs{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.p_abs | formatViewValues: \'p_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="mg" e-format-value-dm="feed.dm" editable-number="feed.mg" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'mg\', \'M\')" id="mg{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.mg | formatViewValues: \'mg\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="mg_abs" editable-number="feed.mg_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'mg_abs\', \'M\')" id="mg_abs{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.mg_abs | formatViewValues: \'mg_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="k" e-format-value-dm="feed.dm" editable-number="feed.k" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'k\', \'M\')" id="k{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.k | formatViewValues: \'k\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="na" e-format-value-dm="feed.dm" editable-number="feed.na" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'na\', \'M\')" id="na{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.na | formatViewValues: \'na\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="cl" e-format-value-dm="feed.dm" editable-number="feed.cl" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'cl\', \'M\')" id="cl{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.cl | formatViewValues: \'cl\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="s" e-format-value-dm="feed.dm" editable-number="feed.s" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'s\', \'M\')" id="s{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.s | formatViewValues: \'s\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.dcad | formatViewValues: \'dcad\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="ash" e-format-value-dm="feed.dm" editable-number="feed.ash" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ash\', \'M\')" id="ash{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ash | formatViewValues: \'ash\': feed.dm}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ca_abs_\' | i18n}}" tooltip-is-open="absCaIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_abs_">abs Ca</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ca_">Ca</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_p_abs_\' | i18n}}" tooltip-is-open="absPIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_p_">P</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">Mg</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_mg_abs_\' | i18n}}" tooltip-is-open="absMgIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_abs_">abs Mg</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_mg_">Mg</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">K</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">Cl</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">S</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ash_\' | i18n}}" tooltip-is-open="ashIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ash_">ash</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'M\')" id="feed_nameMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.ingredientsLoading" e-format-input-value="ca" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ca" e-step="0.1" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ca\', \'M\', feed.id)" id="caMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ca | formatViewValues: \'ca\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="ca_abs" editable-number="mixfeed.ca_abs" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ca_abs\', \'M\', feed.id)" id="ca_absMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ca_abs | formatViewValues: \'ca_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="p" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.p" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'p\', \'M\', feed.id)" id="pMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.p | formatViewValues: \'p\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="p_abs" editable-number="mixfeed.p_abs" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'p_abs\', \'M\', feed.id)" id="p_absMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.p_abs | formatViewValues: \'p_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="mg" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.mg" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'mg\', \'M\', feed.id)" id="mgMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.mg | formatViewValues: \'mg\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="mg_abs" editable-number="mixfeed.mg_abs" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'mg_abs\', \'M\', feed.id)" id="mg_absMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.mg_abs | formatViewValues: \'mg_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="k" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.k" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'k\', \'M\', feed.id)" id="kMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.k | formatViewValues: \'k\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="na" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.na" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'na\', \'M\', feed.id)" id="naMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.na | formatViewValues: \'na\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="cl" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.cl" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'cl\', \'M\', feed.id)" id="clMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cl | formatViewValues: \'cl\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="s" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.s" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'s\', \'M\', feed.id)" id="sMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.s | formatViewValues: \'s\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.dcad | formatViewValues: \'dcad\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="ash" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ash" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ash\', \'M\', feed.id)" id="ashMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ash | formatViewValues: \'ash\': mixfeed.dm}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/feeds.misc.html','<div><table ng-if="!vm.loadingTable" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th style="min-width: 200px; width: 250px"><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th style="width: 120px; min-width: 120px"><ui-select ng-model="vm.feedTypeItem" class="active-filter btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-disabled="vm.loadingTable" on-select="vm.feedTypeFilterChanged()"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="item in vm.feedTypeList | filter: $select.search"><i ng-if="item.category" class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="item.category == \'DF\' ? \'dry-forage\' : (item.category == \'WF\' ? \'wet-forage\' : (item.category == \'FA\' ? \'fat\' : (item.category == \'MIX\' ? \'mix\' : (item.category == \'C\' ? \'corn\' : (item.category == \'Forage\' ? \'forage\' : (item.category == \'Concentrate\' ? \'concentrate\' : (item.category == \'Commercial\' ? \'commercial\' : (item.category == \'TRI\' ? \'triglyceride\' : \'\'))))))))"></i><span ng-bind-html="item.name | i18n"></span></ui-select-choices></ui-select></th><th colspan="9"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br></th><th class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br></div></th><th class="editable-header" ng-click="vm.sort(\'feed_type\')" style="min-width: 200px; width: 200px"><div uib-tooltip="{{\'_description_feed_type_\' | i18n}}" tooltip-is-open="feedTypeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_type_">feed type</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_type_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_type_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br></div></th><th class="editable-header" ng-click="vm.sort(\'commonfeed\')" style="text-align: center"><div uib-tooltip="{{\'_description_common_feed_\' | i18n}}" tooltip-is-open="commonIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_common_">Common feed</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'commonfeed_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'commonfeed_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_blank_1_\' | i18n}}" tooltip-is-open="blank1IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>1<br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_blank_2_\' | i18n}}" tooltip-is-open="blank2IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>2<br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_blank_3_\' | i18n}}" tooltip-is-open="blank3IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>3<br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_blank_4_\' | i18n}}" tooltip-is-open="blank4IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>4<br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_blank_5_\' | i18n}}" tooltip-is-open="blank5IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>5<br></div></th><th class="editable-header" ng-click="vm.sort(\'comments\')"><div uib-tooltip="{{\'_description_comment_\' | i18n}}" tooltip-is-open="commentIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_comment_">Comment</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'comments_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'comments_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br></div></th><th style="min-width: 180px" class="editable-header" ng-click="vm.sort(\'test_date\')"><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'test_date_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'test_date_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br></div></th><th style="min-width: 180px" class="editable-header" ng-click="vm.sort(\'herd_id\')" ng-if="!vm.settings.selectedHerd || !vm.settings.selectedHerd.id"><div uib-tooltip="{{\'_description_herd_\' | i18n}}" tooltip-is-open="herdIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_title_herd_">Herd</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'herd_id_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'herd_id_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'MC\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" e-ng-keydown="vm.feedKeyDown($event, $index)" id="feed_name{{$index}}MC"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="min-width: 200px; width: 200px"><a href="#" editable-select="feed.feed_type" edit-disabled="!feed.team_id || feed.loading" onshow="loadGroups()" e-ng-options="feed_type as (feed_type.show_name | i18n) for feed_type in vm.feed_types | feedTypeFilter: feed.feed_locale" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_type\', \'MC\')">{{(feed.feed_type.show_name | i18n) || \'-\' }}</a></td><td style="padding: 3px 3px"><span class="newCheck"><input type="checkbox" id="is_purchased{{indexX}}-X" ng-disabled="!feed.team_id || feed.loading" ng-model="feed.common_feed" ng-change="vm.updateFeed(feed, $index, $data, \'common_feed\', \'MC\')"> <label for="is_purchased{{indexX}}-X" style="left: 45%; top: 50%"></label></span></td><td style="padding: 7px 7px"><span editable-number="feed.blank_1" e-style="width:200px" e-step="1" e-min="0" e-max="1000000" edit-disabled="!feed.team_id || feed.loading" onbeforesave="vm.updateFeed(feed, $index, $data, \'blank_1\', \'MC\')" e-ng-keydown="vm.feedKeyDown($event, $index)" id="blank_1{{$index}}MC">{{feed.blank_1}}</span></td><td style="padding: 7px 7px"><span editable-number="feed.blank_2" e-style="width:200px" e-step="1" e-min="0" e-max="1000000" edit-disabled="!feed.team_id || feed.loading" onbeforesave="vm.updateFeed(feed, $index, $data, \'blank_2\', \'MC\')" e-ng-keydown="vm.feedKeyDown($event, $index)" id="blank_2{{$index}}MC">{{feed.blank_2}}</span></td><td style="padding: 7px 7px"><span editable-number="feed.blank_3" e-style="width:200px" e-step="1" e-min="0" e-max="1000000" edit-disabled="!feed.team_id || feed.loading" onbeforesave="vm.updateFeed(feed, $index, $data, \'blank_3\', \'MC\')" e-ng-keydown="vm.feedKeyDown($event, $index)" id="blank_3{{$index}}MC">{{feed.blank_3}}</span></td><td style="padding: 7px 7px"><span editable-number="feed.blank_4" e-style="width:200px" e-step="1" e-min="0" e-max="1000000" edit-disabled="!feed.team_id || feed.loading" onbeforesave="vm.updateFeed(feed, $index, $data, \'blank_4\', \'MC\')" e-ng-keydown="vm.feedKeyDown($event, $index)" id="blank_4{{$index}}MC">{{feed.blank_4}}</span></td><td style="padding: 7px 7px"><span editable-number="feed.blank_5" e-style="width:200px" e-step="1" e-min="0" e-max="1000000" edit-disabled="!feed.team_id || feed.loading" onbeforesave="vm.updateFeed(feed, $index, $data, \'blank_5\', \'MC\')" e-ng-keydown="vm.feedKeyDown($event, $index)" id="blank_5{{$index}}MC">{{feed.blank_5}}</span></td><td style="padding: 7px 7px"><span editable-text="feed.comments" e-style="width:200px" edit-disabled="!feed.team_id || feed.loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'comments\', \'MC\')" e-ng-keydown="vm.feedKeyDown($event, $index)" id="comments{{$index}}MC">{{feed.comments || \'-\'}}</span></td><td style="padding: 7px 7px"><a href="#" editable-bsdate="feed.test_date" e-is-open="vm.opened.$data" edit-disabled="!feed.team_id || feed.loading" e-ng-click="vm.open($event,\'$data\')" e-datepicker-popup="{{vm.date_format}}" onbeforesave="vm.updateFeed(feed, $index, $data, \'test_date\')" e-class="editable-has-buttons">{{ (feed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</a></td><td style="padding: 7px 7px" ng-if="!vm.settings.selectedHerd || !vm.settings.selectedHerd.id">{{feed.herd_name || \'-\'}}</td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 77px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></th><th class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_feed_type_\' | i18n}}" tooltip-is-open="feedTypeIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_type_">feed type</data-i18n><br></div></th><th class="editable-header" style="text-align: center"><div uib-tooltip="{{\'_description_common_feed_\' | i18n}}" tooltip-is-open="commonIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_common_">Common feed</data-i18n><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_blank_1_\' | i18n}}" tooltip-is-open="blank1IsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>1<br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_blank_2_\' | i18n}}" tooltip-is-open="blank2IsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>2<br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_blank_3_\' | i18n}}" tooltip-is-open="blank3IsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>3<br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_blank_4_\' | i18n}}" tooltip-is-open="blank4IsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>4<br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_blank_5_\' | i18n}}" tooltip-is-open="blank5IsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>5<br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_comment_\' | i18n}}" tooltip-is-open="commentIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_comment_">Comment</data-i18n><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br></div></th><th class="editable-header" ng-if="!vm.settings.selectedHerd || !vm.settings.selectedHerd.id"></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'MC\')" id="feed_nameMIX{{$index}}MC{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $index)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 7px 7px"><a href="#" editable-select="mixfeed.feed_type" onshow="loadGroups()" e-ng-options="feed_type as (feed_type.show_name | i18n) for feed_type in vm.feed_types | feedTypeFilter: mixfeed.feed_locale" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_type\', \'MC\')">{{(mixfeed.feed_type.show_name | i18n) || \'-\' }}</a></td><td style="padding: 3px 3px"><span class="newCheck"><input type="checkbox" id="{{\'is_purchased\' + indexY + indexX}}-Y" ng-disabled="vm.ingredientsLoading" ng-model="mixfeed.common_feed" ng-change="vm.updateMix(mixfeed, $index, $data, \'common_feed\', \'MC\')"> <label for="{{\'is_purchased\' + indexY + indexX}}-Y" style="left: 45%; top: 50%"></label></span></td><td style="padding: 7px 7px"><span editable-number="mixfeed.blank_1" edit-disabled="vm.ingredientsLoading" e-step="1" e-min="0" e-max="1000000" e-style="width:200px" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'blank_1\', \'MC\')" id="blank_1MIX{{$index}}MC{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $index)">{{mixfeed.blank_1}}</span></td><td style="padding: 7px 7px"><span editable-number="mixfeed.blank_2" edit-disabled="vm.ingredientsLoading" e-step="1" e-min="0" e-max="1000000" e-style="width:200px" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'blank_2\', \'MC\')" id="blank_2MIX{{$index}}MC{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $index)">{{mixfeed.blank_2}}</span></td><td style="padding: 7px 7px"><span editable-number="mixfeed.blank_3" edit-disabled="vm.ingredientsLoading" e-step="1" e-min="0" e-max="1000000" e-style="width:200px" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'blank_3\', \'MC\')" id="blank_3MIX{{$index}}MC{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $index)">{{mixfeed.blank_3}}</span></td><td style="padding: 7px 7px"><span editable-number="mixfeed.blank_4" edit-disabled="vm.ingredientsLoading" e-step="1" e-min="0" e-max="1000000" e-style="width:200px" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'blank_4\', \'MC\')" id="blank_4MIX{{$index}}MC{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $index)">{{mixfeed.blank_4}}</span></td><td style="padding: 7px 7px"><span editable-number="mixfeed.blank_5" edit-disabled="vm.ingredientsLoading" e-step="1" e-min="0" e-max="1000000" e-style="width:200px" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'blank_5\', \'MC\')" id="blank_5MIX{{$index}}MC{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $index)">{{mixfeed.blank_5}}</span></td><td style="padding: 7px 7px"><span editable-text="mixfeed.comments" edit-disabled="vm.ingredientsLoading" e-required="" e-style="width:200px" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'comments\', \'MC\')" id="commentsMIX{{$index}}MC{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $index)">{{mixfeed.comments || \'-\'}}</span></td><td style="padding: 7px 7px"><span><a href="#" editable-bsdate="mixfeed.test_date" edit-disabled="vm.ingredientsLoading" e-is-open="vm.opened.$data" e-ng-click="vm.open($event,\'$data\')" e-datepicker-popup="{{vm.date_format}}" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'test_date\')">{{ (mixfeed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</a></span></td><td style="padding: 7px 7px" ng-if="!vm.settings.selectedHerd || !vm.settings.selectedHerd.id"></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/feeds.tabs.html','<div class="row" style="margin-top: 20px; margin-right: 0px; margin-left: 0px" ng-if="!vm.loading && vm.selectedTeam"><div class="col-xlg-2 col-lg-2 col-md-5 col-sm-5 col-xs-5"><div class="form-group"><div><ui-select ng-model="vm.selectedFeedType" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.feedTypeSelected()"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.filterTypes | filter: $select.search" ui-disable-choice="vm.selectedFeedType.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div><div class="col-xlg-2 col-lg-2 col-md-5 col-sm-5 col-xs-5"><div class="form-group"><div><ui-select style="z-index: 9000 !important; transform: unset !important" ng-model="vm.selectedCalculation" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.defaultCalculationChanged()"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.defaultCalculationList | filter: $select.search" ui-disable-choice="vm.selectedCalculation.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div><div class="col-xlg-1 col-lg-1 col-md-2 col-sm-2 col-xs-2"><button type="button" class="btn btn-primary" ng-click="vm.openFiltersModal()" uib-tooltip="{{\'_description_additional_filters_\' | i18n}}" tooltip-is-open="filtersIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="fa fa-filter fa-lg"></i></button></div><div class="col-xlg-7 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div style="text-align: right"><button type="button" class="btn btn-primary" ng-click="vm.redirectTo(\'feeds.addNewFeed\')" style="margin: 0 0 10px 10px"><data-i18n i18n="_btn_feed_new_feed_">New feed</data-i18n></button> <button type="button" class="btn btn-danger mydisable" ng-click="vm.deleteFeed()" ng-disabled="vm.selectedList.length == 0 || vm.deleteDisabled" style="margin: 0 0 10px 10px"><data-i18n i18n="_btn_feed_delete_feeds_">Delete feeds</data-i18n></button> <button type="button" class="btn btn-primary mydisable" ng-click="vm.createMIX(\'app/pages/feeds/myfeeds/mix_modal.html\', \'lg\')" style="margin: 0 0 10px 10px"><data-i18n i18n="_btn_feed_create_mix_">Create Premix</data-i18n></button> <button type="button" class="btn btn-primary mydisable" ng-click="vm.createRation()" style="margin: 0 0 10px 10px"><data-i18n i18n="_btn_create_ration_">create ration</data-i18n></button><div class="btn-group" uib-dropdown="" dropdown-append-to-body="" style="margin: 0 0 10px 10px"><button type="button" class="btn btn-primary" uib-dropdown-toggle=""><data-i18n i18n="_btn_feed_import_">Import</data-i18n><span class="caret"></span></button><ul uib-dropdown-menu="" class="dropdown-menu-right"><li><a href="" ng-click="vm.redirectTo(\'feeds.importSpartan3\')"><data-i18n i18n="_feeds_from_spartan3_">from spartan3 db</data-i18n></a> <a href="" ng-click="vm.redirectTo(\'feeds.importXml\')"><data-i18n i18n="_feeds_from_xml_">From XML file</data-i18n></a></li></ul></div></div></div></div><uib-tabset ng-if="!vm.loading && vm.selectedTeam"><uib-tab select="vm.selectedTab = 1" heading="{{\'_feeds_tab_home_\'|i18n}}"><div ng-show="!vm.loadingTabs"><div ng-if="vm.showHome"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div ng-if="vm.selectedCalculation.calc_type === 0" include-with-scope="app/pages/feeds/myfeeds/feedsHome/feeds.home.US.html"></div><div ng-if="vm.selectedCalculation.calc_type === 1" include-with-scope="app/pages/feeds/myfeeds/feedsHome/feeds.home.VemDve.html"></div></div></div></div></div></div></uib-tab><uib-tab select="vm.selectedTab = 2" heading="{{\'_feeds_tab_fiber_\'|i18n}}"><div ng-show="!vm.loadingTabs"><div ng-if="vm.showFiber"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div ng-if="vm.selectedCalculation.calc_type === 0" include-with-scope="app/pages/feeds/myfeeds/feedsFiber/feeds.fiber.US.html"></div><div ng-if="vm.selectedCalculation.calc_type === 1" include-with-scope="app/pages/feeds/myfeeds/feedsFiber/feeds.fiber.VemDve.html"></div></div></div></div></div></div></uib-tab><uib-tab select="vm.selectedTab = 3" heading="{{\'_feeds_tab_energy_\'|i18n}}"><div ng-show="!vm.loadingTabs"><div ng-if="vm.showEnergy"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div ng-if="vm.selectedCalculation.calc_type === 0" include-with-scope="app/pages/feeds/myfeeds/feedsEnergy/feeds.energy.US.html"></div><div ng-if="vm.selectedCalculation.calc_type === 1" include-with-scope="app/pages/feeds/myfeeds/feedsEnergy/feeds.energy.VemDve.html"></div></div></div></div></div></div></uib-tab><uib-tab select="vm.selectedTab = 4" heading="{{\'_feeds_tab_protein_\'|i18n}}"><div ng-show="!vm.loadingTabs"><div ng-if="vm.showProtein"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div ng-if="vm.selectedCalculation.calc_type === 0" include-with-scope="app/pages/feeds/myfeeds/feedsProtein/feeds.protein.US.html"></div><div ng-if="vm.selectedCalculation.calc_type === 1" include-with-scope="app/pages/feeds/myfeeds/feedsProtein/feeds.protein.VemDve.html"></div></div></div></div></div></div></uib-tab><uib-tab select="vm.selectedTab = 5" heading="{{\'_feeds_tab_carb_\'|i18n}}"><div ng-show="!vm.loadingTabs"><div ng-if="vm.showCarb"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div ng-if="vm.selectedCalculation.calc_type === 0" include-with-scope="app/pages/feeds/myfeeds/feedsCarb/feeds.carbohydrate.US.html"></div><div ng-if="vm.selectedCalculation.calc_type === 1" include-with-scope="app/pages/feeds/myfeeds/feedsCarb/feeds.carbohydrate.VemDve.html"></div></div></div></div></div></div></uib-tab><uib-tab select="vm.selectedTab = 6" heading="{{\'_feeds_tab_lipid_\'|i18n}}"><div ng-show="!vm.loadingTabs"><div ng-if="vm.showLipid"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div ng-if="vm.selectedCalculation.calc_type === 0" include-with-scope="app/pages/feeds/myfeeds/feedsLipid/feeds.lipid.US.html"></div><div ng-if="vm.selectedCalculation.calc_type === 1" include-with-scope="app/pages/feeds/myfeeds/feedsLipid/feeds.lipid.VemDve.html"></div></div></div></div></div></div></uib-tab><uib-tab select="vm.selectedTab = 7" heading="{{\'_feeds_tab_mineral_\'|i18n}}"><div ng-show="!vm.loadingTabs"><div ng-if="vm.showMineral"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div include-with-scope="app/pages/feeds/myfeeds/feeds.mineral.html"></div></div></div></div></div></div></uib-tab><uib-tab select="vm.selectedTab = 8" heading="{{\'_feeds_tab_trace_min_\'|i18n}}"><div ng-show="!vm.loadingTabs"><div ng-if="vm.showTMineral"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div include-with-scope="app/pages/feeds/myfeeds/feeds.trace_min.html"></div></div></div></div></div></div></uib-tab><uib-tab select="vm.selectedTab = 9" heading="{{\'_feeds_tab_vitamin_\'|i18n}}"><div ng-show="!vm.loadingTabs"><div ng-if="vm.showVitamin"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div include-with-scope="app/pages/feeds/myfeeds/feeds.vitamin.html"></div></div></div></div></div></div></uib-tab><uib-tab select="vm.selectedTab = 10" heading="{{\'_feeds_tab_amino_acid_\'|i18n}}"><div ng-show="!vm.loadingTabs"><div ng-if="vm.showAA"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div include-with-scope="app/pages/feeds/myfeeds/feeds.amino_acid.html"></div></div></div></div></div></div></uib-tab><uib-tab select="vm.selectedTab = 11" heading="{{\'_feeds_tab_cost_\'|i18n}}"><div ng-show="!vm.loadingTabs"><div ng-if="vm.showCostTab"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div include-with-scope="app/pages/feeds/myfeeds/feeds.cost.html"></div></div></div></div></div></div></uib-tab><uib-tab select="vm.selectedTab = 12" heading="{{\'_feeds_tab_misc_\'|i18n}}"><div ng-show="!vm.loadingTabs"><div ng-if="vm.showMisc"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div include-with-scope="app/pages/feeds/myfeeds/feeds.misc.html"></div></div></div></div></div></div></uib-tab><div class="slider-wraper"><div><toggle-switch ng-model="vm.sliderUsePercent" ng-change="vm.changeUnits()" on-label="%" off-label="g/{{vm.weight}}" knob-label="{{\'_report_unit_\' | i18n}}" class="switch-primary" style="width: 120px"></toggle-switch></div></div></uib-tabset><div ng-if="!vm.loading && !vm.selectedTeam" align="center"><div><h3><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></h3></div></div><div ng-if="vm.loading || vm.loadingTabs" align="center" style="overflow: hidden"><div id="loading-animation-large"></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/feeds.trace_min.html','<div><table ng-if="!vm.loadingTable" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="14"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th class="editable-header" ng-click="vm.sort(\'co\')"><div uib-tooltip="{{\'_description_co_\' | i18n}}" tooltip-is-open="coIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_co_">Co</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'co_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'co_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'cu\')"><div uib-tooltip="{{\'_description_cu_\' | i18n}}" tooltip-is-open="cuIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cu_">Cu</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cu_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cu_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'cu_abs\')"><div uib-tooltip="{{\'_description_cu_abs_\' | i18n}}" tooltip-is-open="absCuIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cu_abs_">abs Cu</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cu_abs_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cu_abs_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_cu_">Cu</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'fe\')"><div uib-tooltip="{{\'_description_fe_\' | i18n}}" tooltip-is-open="feIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fe_">Fe</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'fe_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'fe_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'fe_abs\')"><div uib-tooltip="{{\'_description_fe_abs_\' | i18n}}" tooltip-is-open="absFeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fe_abs_">abs Fe</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'fe_abs_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'fe_abs_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_fe_">Fe</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'i\')"><div uib-tooltip="{{\'_description_i_\' | i18n}}" tooltip-is-open="iIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_i_">I</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'i_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'i_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'i_abs\')"><div uib-tooltip="{{\'_description_i_abs_\' | i18n}}" tooltip-is-open="absIIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_i_abs_">abs I</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'i_abs_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'i_abs_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_i_">I</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'mo\')"><div uib-tooltip="{{\'_description_mo_\' | i18n}}" tooltip-is-open="moIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mo_">Mo</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'mo_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'mo_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'mn\')"><div uib-tooltip="{{\'_description_mn_\' | i18n}}" tooltip-is-open="mnIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mn_">Mn</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'mn_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'mn_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'mn_abs\')"><div uib-tooltip="{{\'_description_mn_abs_\' | i18n}}" tooltip-is-open="absMnIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mn_abs_">abs Mn</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'mn_abs_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'mn_abs_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_mn_">Mn</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'se\')"><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'se_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'se_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'se_abs\')"><div uib-tooltip="{{\'_description_se_abs_\' | i18n}}" tooltip-is-open="absSeIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_abs_">abs Se</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'se_abs_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'se_abs_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_se_">Se</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'zn\')"><div uib-tooltip="{{\'_description_zn_\' | i18n}}" tooltip-is-open="znIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_zn_">Zn</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'zn_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'zn_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'zn_abs\')"><div uib-tooltip="{{\'_description_zn_abs_\' | i18n}}" tooltip-is-open="absZnIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_zn_abs_">abs Zn</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'zn_abs_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'zn_abs_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_zn_">Zn</data-i18n></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'T\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" e-ng-keydown="vm.feedKeyDown($event, $data)" id="feed_name{{$index}}T"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="co" editable-number="feed.co" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'co\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="co{{$index}}T">{{feed.co | formatViewValues: \'co\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="cu" editable-number="feed.cu" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'cu\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="cu{{$index}}T">{{feed.cu | formatViewValues: \'cu\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="cu_abs" editable-number="feed.cu_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'cu_abs\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="cu_abs{{$index}}T">{{feed.cu_abs | formatViewValues: \'cu_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="fe" editable-number="feed.fe" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'fe\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="fe{{$index}}T">{{feed.fe | formatViewValues: \'fe\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="fe_abs" editable-number="feed.fe_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'fe_abs\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="fe_abs{{$index}}T">{{feed.fe_abs | formatViewValues: \'fe_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="i" editable-number="feed.i" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'i\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="i{{$index}}T">{{feed.i | formatViewValues: \'i\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="i_abs" editable-number="feed.i_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'i_abs\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="i_abs{{$index}}T">{{feed.i_abs | formatViewValues: \'i_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="mo" editable-number="feed.mo" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'mo\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="mo{{$index}}T">{{feed.mo | formatViewValues: \'mo\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="mn" editable-number="feed.mn" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'mn\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="mn{{$index}}T">{{feed.mn | formatViewValues: \'mn\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="mn_abs" editable-number="feed.mn_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'mn_abs\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="mn_abs{{$index}}T">{{feed.mn_abs | formatViewValues: \'mn_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="se" editable-number="feed.se" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'se\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="se{{$index}}T">{{feed.se | formatViewValues: \'se\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="se_abs" editable-number="feed.se_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'se_abs\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="se_abs{{$index}}T">{{feed.se_abs | formatViewValues: \'se_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="zn" editable-number="feed.zn" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'zn\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="zn{{$index}}T">{{feed.zn | formatViewValues: \'zn\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="zn_abs" editable-number="feed.zn_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'zn_abs\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="zn_abs{{$index}}T">{{feed.zn_abs | formatViewValues: \'zn_abs\'}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_co_\' | i18n}}" tooltip-is-open="coIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_co_">Co</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_cu_\' | i18n}}" tooltip-is-open="cuIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cu_">Cu</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_cu_abs_\' | i18n}}" tooltip-is-open="absCuIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cu_abs_">abs Cu</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cu_">Cu</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_fe_\' | i18n}}" tooltip-is-open="feIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fe_">Fe</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_fe_abs_\' | i18n}}" tooltip-is-open="absFeIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fe_abs_">abs Fe</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fe_">Fe</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_i_\' | i18n}}" tooltip-is-open="iIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_i_">I</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_i_abs_\' | i18n}}" tooltip-is-open="absIIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_i_abs_">abs I</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_i_">I</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_mo_\' | i18n}}" tooltip-is-open="moIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mo_">Mo</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_mn_\' | i18n}}" tooltip-is-open="mnIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mn_">Mn</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_mn_abs_\' | i18n}}" tooltip-is-open="absMnIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mn_abs_">abs Mn</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_mn_">Mn</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_se_abs_\' | i18n}}" tooltip-is-open="absSeIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_abs_">abs Se</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_se_">Se</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_zn_\' | i18n}}" tooltip-is-open="znIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_zn_">Zn</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_zn_abs_\' | i18n}}" tooltip-is-open="absZnIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_zn_abs_">abs Zn</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_zn_">Zn</data-i18n></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" e-required="" edit-disabled="vm.ingredientsLoading" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'T\', feed.id)" id="feed_nameMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="co" editable-number="mixfeed.co" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'co\', \'T\', feed.id)" id="coMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.co | formatViewValues: \'co\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="cu" editable-number="mixfeed.cu" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'cu\', \'T\', feed.id)" id="cuMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cu | formatViewValues: \'cu\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="cu_abs" editable-number="mixfeed.cu_abs" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'cu_abs\', \'T\', feed.id)" id="cu_absMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cu_abs | formatViewValues: \'cu_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="fe" editable-number="mixfeed.fe" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'fe\', \'T\', feed.id)" id="feMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.fe | formatViewValues: \'fe\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="fe_abs" editable-number="mixfeed.fe_abs" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'fe_abs\', \'T\', feed.id)" id="fe_absMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.fe_abs | formatViewValues: \'fe_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="i" editable-number="mixfeed.i" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'i\', \'T\', feed.id)" id="iMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.i | formatViewValues: \'i\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="i_abs" editable-number="mixfeed.i_abs" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'i_abs\', \'T\', feed.id)" id="i_absMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.i_abs | formatViewValues: \'i_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="mo" editable-number="mixfeed.mo" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'mo\', \'T\', feed.id)" id="moMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.mo | formatViewValues: \'mo\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="mn" editable-number="mixfeed.mn" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'mn\', \'T\', feed.id)" id="mnMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.mn | formatViewValues: \'mn\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="mn_abs" editable-number="mixfeed.mn_abs" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'mn_abs\', \'T\', feed.id)" id="mn_absMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.mn_abs | formatViewValues: \'mn_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="se" editable-number="mixfeed.se" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'se\', \'T\', feed.id)" id="seMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.se | formatViewValues: \'se\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="se_abs" editable-number="mixfeed.se_abs" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'se_abs\', \'T\', feed.id)" id="se_absMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.se_abs | formatViewValues: \'se_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="zn" editable-number="mixfeed.zn" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'zn\', \'T\', feed.id)" id="znMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.zn | formatViewValues: \'zn\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="zn_abs" editable-number="mixfeed.zn_abs" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'zn_abs\', \'T\', feed.id)" id="zn_absMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.zn_abs | formatViewValues: \'zn_abs\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/feeds.vitamin.html','<div><table ng-if="!vm.loadingTable" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="3"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th class="editable-header" ng-click="vm.sort(\'vitamin_a\')"><div uib-tooltip="{{\'_description_vitamin_a_\' | i18n}}" tooltip-is-open="vitAIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_a_">vit a</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'vitamin_a_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'vitamin_a_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th class="editable-header" ng-click="vm.sort(\'vitamin_d\')"><div uib-tooltip="{{\'_description_vitamin_d_\' | i18n}}" tooltip-is-open="vitDIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_d_">vit d</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'vitamin_d_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'vitamin_d_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th class="editable-header" ng-click="vm.sort(\'vitamin_e\')"><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'vitamin_e_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'vitamin_e_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" edit-disabled="!feed.team_id || feed.loading" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'V\')" e-maxlength="60" e-ng-keydown="vm.feedKeyDown($event, $data)" id="feed_name{{$index}}V"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="vitamin_a" editable-number="feed.vitamin_a" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'vitamin_a\', \'V\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="vitamin_a{{$index}}V">{{feed.vitamin_a | formatViewValues: \'vitamin_a\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="vitamin_d" editable-number="feed.vitamin_d" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'vitamin_d\', \'V\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="vitamin_d{{$index}}V">{{feed.vitamin_d | formatViewValues: \'vitamin_d\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="vitamin_e" editable-number="feed.vitamin_e" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'vitamin_e\', \'V\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="vitamin_e{{$index}}V">{{feed.vitamin_e | formatViewValues: \'vitamin_e\'}}</span></td></tr><tr ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" class="rationThBackground"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_vitamin_a_\' | i18n}}" tooltip-is-open="vitAIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_a_">vit a</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_vitamin_d_\' | i18n}}" tooltip-is-open="vitDIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_d_">vit d</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'V\')" e-maxlength="60" id="feed_nameMIX{{$index}}V{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="vitamin_a" editable-number="mixfeed.vitamin_a" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'vitamin_a\', \'V\', feed.id)" id="vitamin_aMIX{{$index}}V{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.vitamin_a | formatViewValues: \'vitamin_a\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="vitamin_d" editable-number="mixfeed.vitamin_d" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'vitamin_d\', \'V\', feed.id)" id="vitamin_dMIX{{$index}}V{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.vitamin_d | formatViewValues: \'vitamin_d\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="vitamin_e" editable-number="mixfeed.vitamin_e" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'vitamin_e\', \'V\', feed.id)" id="vitamin_eMIX{{$index}}V{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.vitamin_e | formatViewValues: \'vitamin_e\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/filter.modal.html','<div class="modal-content" ng-cloak=""><div class="modal-body"><div ng-if="!vm.modalLoading"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_picker_feed_type_placeholder_">Select feed type</data-i18n></label><br><ui-select style="z-index: 9000 !important" ng-model="vm.feedTypeItem" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.feedTypeList | filter: $select.search"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div><div align="right"><button type="submit" class="btn btn-success" ng-click="vm.saveFilter()"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancelFilters()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/insertFeed.modal.html','<div ba-panel="" class="ng-cloak"><div class="panel-group" ng-if="!vm.modalLoading"><div style="margin-top: 10px" class="row" ng-if="vm.selectedTeam"><div style="margin-bottom: 10px; padding-left: 5px; padding-right: 5px" class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="btn-group" role="group" aria-label="Basic example" id="e0"><button type="button" class="btn btn-primary no-border-radius" ng-click="vm.addAll()"><data-i18n i18n="_btn_feed_add_all_">Add all</data-i18n></button> <button type="button" class="btn btn-danger no-border-radius" ng-click="vm.cancel(\'insert_feed\')"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><div style="margin-top: 10px" ba-panel="" ba-panel-title="{{\'_feeds_imort_feeds_panel_available_feeds_\'|i18n}}" ba-panel-class="with-scroll xmedium-panel"><div include-with-scope="app/pages/feeds/myfeeds/insertFeed.sourceTable.html"></div></div></div><div style="padding-left: 5px; padding-right: 5px" class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="btn-group" role="group" id="e0"><button type="button" class="btn btn-danger no-border-radius" ng-click="vm.removeAll()"><data-i18n i18n="_btn_feed_remove_all_">Remove all</data-i18n></button> <button type="button" class="btn btn-primary no-border-radius" ng-click="vm.insertFeeds()"><data-i18n i18n="_btn_feed_insert_">insert</data-i18n></button></div><div style="margin-top: 10px" ba-panel="" ba-panel-title="{{\'_feeds_insert_feeds_panel_feeds_insert_\'|i18n}}" ba-panel-class="with-scroll xmedium-panel"><div include-with-scope="app/pages/rations/balanceRation/modals/insertFeed.table.html"></div></div></div></div><div ng-if="!vm.selectedTeam" align="center"><div><h3><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></h3><button type="button" class="btn btn-danger no-border-radius" ng-click="vm.cancel(\'insert_feed\')"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div></div></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/insertFeed.sourceTable.html','<div class="vertical-scroll"><table class="table-header-fixed auto-scroll" st-table="vm.feedsByTeam"><thead><tr ng-if="!vm.hideFilters"><th colspan="6"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_feeds_search_feeds_label_">Search feeds</data-i18n></label> <input placeholder="{{\'_search_placeholder_feed_name_\'|i18n}}" class="form-control" type="text" ng-model="vm.searchMaster" id="feedsSearchInput" ng-change="vm.searchMix()"></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_picker_feed_type_placeholder_">Select feed type</data-i18n></label><ui-select style="z-index: 9000 !important" ng-model="vm.feedTypeItemMix" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.feedTypeChangedMix()"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.feedTypeListMix | filter: $select.search" ui-disable-choice="vm.feedTypeItemMix.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_feeds_my_master_">my/master</data-i18n></label><ui-select style="z-index: 9000 !important" ng-model="vm.selectedFeedTypeMix" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.feedTypeSelectedMix()"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.filterTypes | filter: $select.search" ui-disable-choice="vm.selectedFeedTypeMix.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_settings_calculation_type_title_">type</data-i18n></label><ui-select style="z-index: 90000 !important" ng-model="vm.addFeedCalculation" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.defaultCalculationChangedMix()"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.defaultCalculationList |filter: $select.search" ui-disable-choice="vm.addFeedCalculation.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div></th></tr><tr class="show-hide-filters"><td><button ng-click="vm.hideFilters = !vm.hideFilters"><i ng-if="!vm.hideFilters" class="ion-arrow-up-b"></i><i ng-if="vm.hideFilters" class="ion-arrow-down-b"></i><span><data-i18n i18n="_modal_show_hide_filters_">Show/hide filters</data-i18n></span><i ng-if="!vm.hideFilters" class="ion-arrow-up-b"></i><i ng-if="vm.hideFilters" class="ion-arrow-down-b"></i></button></td></tr><tr class="sortable" style="margin-right: 15px"><th style="width: 10%"></th><th ng-click="vm.sortMix(\'feed_name\')" style="width: 20%"><data-i18n i18n="_feeds_name_">Feed name</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col_mix == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col_mix == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br></th><th ng-click="vm.sortMix(\'test_date\')" style="width: 19%"><data-i18n i18n="_feeds_test_date_">Test date</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col_mix == \'test_date_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col_mix == \'test_date_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br></th><th ng-click="vm.sortMix(\'dm\')" style="width: 17%"><data-i18n i18n="_feeds_dm_">dm</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col_mix == \'dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col_mix == \'dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span></th><th ng-click="vm.sortMix(\'cp\')" style="width: 17%"><data-i18n i18n="_feeds_cp_">cp</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col_mix == \'cp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col_mix == \'cp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th><th ng-click="vm.sortMix(\'ndf\')" style="width: 17%"><data-i18n i18n="_feeds_ndf_">ndf</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col_mix == \'ndf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col_mix == \'ndf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th></tr></thead><tbody infinite-scroll="" scroll-fn="vm.paginationMix()" scroll-no-all="vm.totalItemsMaster" scroll-no-displayed="vm.feedsByTeam.length" scroll-disable="vm.disableScroll" ng-if="vm.feedsLoaded"><tr ng-click="vm.addSelected(feed)" ng-repeat="feed in vm.feedsByTeam" style="margin-bottom: 5px; margin-top: 5px"><td style="width: 10%"><button type="button" ng-if="!feed.is_mix" class="btn btn-primary btn-xs" style="border-radius: 50%; transform: none"><i class="ion-plus-round"></i></button></td><td style="width: 20%">{{feed.feed_name}}</td><td style="width: 19%">{{feed.test_date | date: vm.date_format}}</td><td style="width: 17%">{{feed.dm | number: 2}}</td><td style="width: 17%">{{feed.cp| number: 1}}</td><td style="width: 17%">{{feed.ndf | number: 1}}</td></tr><tr ng-if="vm.disableScroll"><td style="width: 100%" align="center"><data-i18n i18n="_title_loading_">Loading...</data-i18n></td></tr></tbody><tbody style="overflow: hidden" ng-if="!vm.feedsLoaded"><tr><td style="width: 100%" align="center"><div id="loading-animation-large"></div></td></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/feeds/myfeeds/mix_edit.modal.html','<div class="modal-content" ng-cloak=""><div class="modal-header" ng-if="!vm.modalLoading"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title"><data-i18n i18n="_feeds_set_amount_label_">set amounts for feed</data-i18n></h4></div><form name="vm.editMixForm" novalidate=""><div class="row" style="margin-left: 5px; margin-right: 5px; margin-bottom: 10px" ng-if="!vm.modalLoading"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><input type="text" class="form-control with-units" placeholder="{{\'_feeds_name_\' | i18n}}" ng-model="vm.feedToEdit.feed_name" required="" select-on-click=""></div></div><div ng-repeat="feed in vm.feedToEdit.mixes" ng-if="!vm.modalLoading"><div><div class="row" style="margin-left: 5px; margin-right: 5px"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xsm-12"><label><data-i18n i18n="_feeds_name_">feed name</data-i18n></label> <input type="text" maxlength="60" step="any" class="form-control" ng-model="feed.feed_name" required="" min="0" select-on-click="" ng-change="feed.dirty = true"></div><div class="col-xlg-3 col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.editMixForm.amount{{$index}}.$invalid}"><label><data-i18n i18n="_feeds_amount_">Amount</data-i18n>&nbsp;({{vm.weight}})</label> <input type="number" step="any" class="form-control" placeholder="{{\'_feeds_amount_\' | i18n}}" ng-model="feed.amount" format-input-value="amount" required="" min="0" name="amount{{$index}}" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.changeAmount(feed)" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_not_valid_">Value not valid</data-i18n></span></div></div><div class="col-xlg-3 col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.editMixForm.as_fed{{$index}}.$invalid}"><label><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n>&nbsp;({{vm.weight}})</label> <input type="number" step="any" class="form-control" placeholder="{{\'_feeds_as_fed_\' | i18n}}" ng-model="feed.as_fed" format-input-value="as_fed" required="" min="0" name="as_fed{{$index}}" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.changeAsFed(feed)" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_not_valid_">Value not valid</data-i18n></span></div></div></div></div></div></form><div class="modal-footer" ng-if="!vm.modalLoading"><button type="button" class="btn btn-success" ng-click="vm.updateMixEdit()" ng-disabled="vm.editMixForm.$invalid"><data-i18n i18n="_btn_feed_save_mix_">Save Premix</data-i18n></button> <button type="button" class="btn btn-success" ng-click="vm.createMixFromEdit()" ng-disabled="vm.editMixForm.$invalid"><data-i18n i18n="_btn_save_as_new_mix">Save as new</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><div ng-if="vm.modalLoading" align="center"><div><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/mix_message.html','<div class="modal-content" ng-cloak=""><div class="modal-header"></div><div class="modal-body"><div class="row" style="margin-left: 5px; margin-right: 5px; margin-bottom: 10px" ng-if="!vm.modalLoading"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><span><data-i18n i18n="_title_create_mix_message">Select 2 or more feeds first</data-i18n></span></div></div></div><div class="modal-footer" ng-if="!vm.modalLoading"><button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_ok_">ok</data-i18n></button></div><div ng-if="vm.modalLoading" align="center"><div><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/mix_modal.html','<div class="modal-content" ng-cloak=""><div class="modal-header" ng-if="!vm.modalLoading"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title"><data-i18n i18n="_feeds_set_amount_label_">set amounts for feed</data-i18n></h4></div><form name="vm.createMixForm"><div class="row" style="margin-left: 5px; margin-right: 5px; margin-bottom: 10px" ng-if="!vm.modalLoading"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><input type="text" class="form-control with-units" placeholder="{{\'_feeds_name_\' | i18n}}" ng-model="vm.mix_name" required="" select-on-click=""></div></div><div ng-repeat="feed in vm.listOfFeeds" ng-if="!vm.modalLoading"><div><div class="row" style="margin-left: 5px; margin-right: 5px"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xsm-12"><label style="padding-top: 10px; margin-top: 20px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</label></div><div class="col-xlg-3 col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.createMixForm.amount{{$index}}.$invalid}"><label><data-i18n i18n="_feeds_amount_">Amount</data-i18n>&nbsp;({{vm.weight}})</label> <input type="number" step="any" class="form-control" placeholder="{{\'_feeds_amount_\' | i18n}}" ng-model="feed.amount" format-input-value="amount" name="amount{{$index}}" required="" min="0" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.changeAmount(feed)" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_not_valid_">Value not valid</data-i18n></span></div></div><div class="col-xlg-3 col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.createMixForm.as_fed{{$index}}.$invalid}"><label><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n>&nbsp;({{vm.weight}})</label> <input type="number" step="any" class="form-control" placeholder="{{\'_feeds_as_fed_\' | i18n}}" ng-model="feed.as_fed" format-input-value="as_fed" name="as_fed{{$index}}" required="" min="0" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.changeAsFed(feed)" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_not_valid_">Value not valid</data-i18n></span></div></div></div></div></div></form><div class="row" ng-if="!vm.modalLoading" style="margin-left: 5px; margin-right: 5px"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group"><div ng-if="!vm.loading"><ui-select style="z-index: 90000 !important" ng-model="vm.createMixCalculation" class="btn-group bootstrap-select form-control" ng-disabled="vm.loadingTable" append-to-body="true" search-enabled="true" on-select="vm.mixCalculationSelected()"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.defaultCalculationList | filter: $select.search"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div></div><div class="modal-footer" ng-if="!vm.modalLoading"><button type="button" class="btn btn-success" ng-click="vm.saveMIX()" ng-disabled="vm.createMixForm.$invalid"><data-i18n i18n="_btn_feed_save_mix_">Save Premix</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><div ng-if="vm.modalLoading" align="center"><div><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/myfeeds.html','<div><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><div class="custom-errors" ng-include="\'app/pages/feeds/myfeeds/feeds.tabs.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/ration_message.html','<div class="modal-content" ng-cloak=""><div class="modal-header"></div><div class="modal-body"><div class="row" style="margin-left: 5px; margin-right: 5px; margin-bottom: 10px" ng-if="!vm.modalLoading"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><span><data-i18n i18n="_title_create_ration_message">Select one or more feeds first</data-i18n></span></div></div></div><div class="modal-footer" ng-if="!vm.modalLoading"><button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_ok_">ok</data-i18n></button></div><div ng-if="vm.modalLoading" align="center"><div><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/feeds/myManualFeeds/confirmation.modal.html','<div class="modal-content" ng-if="!vm.modalLoading"><div class="modal-header"><div align="center"><span class="ion-android-warning warningModal" style="font-size: 36px"></span></div><div align="center"><span class="warningModal"><data-i18n i18n="_feeds_delete_warning_message_">Warning message</data-i18n></span></div></div><div class="modal-body"><div align="center"><button type="button" class="btn btn-primary" ng-click="vm.confirm()"><data-i18n i18n="_btn_continue_">Continue</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div><div class="modal-content" ng-if="vm.modalLoading"><div class="modal-body"><div style="height: 200px; overflow: hidden" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/feeds/myManualFeeds/myManualFeeds.html','<div><div ng-if="!vm.loading && vm.selectedHerd" class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div ng-include="\'app/pages/feeds/myManualFeeds/mymanualfeeds.table.html\'"></div></div></div></div><div ng-if="vm.loading" class="row" ba-panel=""><div class="col-lg-12 col-md-12"><div style="height: 200px; overflow: hidden" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div><div ng-if="!vm.loading && !vm.selectedHerd" align="center" ba-panel=""><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div>');
$templateCache.put('app/pages/feeds/myManualFeeds/mymanualfeeds.table.html','<div ng-if="!vm.loadingTable"><table class="table table-bordered"><thead><tr><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br><br></th><th><data-i18n i18n="_feeds_type_">Feed type</data-i18n><br><br></th><th><data-i18n i18n="_feeds_dm_">DM</data-i18n><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span></th><th><data-i18n i18n="_feeds_amount_">Amount</data-i18n><br><span>{{vm.weight}}</span></th><th><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n><br><span>{{vm.weight}}</span></th><th><data-i18n i18n="_feeds_cost_dm_">Cost dm</data-i18n><br><span>{{vm.currency}}/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th><th><data-i18n i18n="_feeds_cost_as_fed_">Cost as fed</data-i18n><br><span>{{vm.currency}}/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_as_fed_">As fed</data-i18n></span></th><th style="text-align: center"><data-i18n i18n="_btn_delete_">Delete</data-i18n><br><br></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds track by feed.id"><td><button class="btn btn-xs btn-primary" ng-click="vm.goToHistory(feed.id)"><i class="ion-clock"></i></button></td><td><span editable-text="feed.feed_name" e-required="" e-style="width: 150px" edit-disabled="vm.updatingFeed" onaftersave="vm.updateFeed(feed, $data, \'feed_name\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="feed_name_{{$index}}">{{feed.feed_name}}</span></td><td><a href="#" editable-select="feed.feed_type" e-required="" e-style="width: 150px" edit-disabled="vm.updatingFeed" onaftersave="vm.updateFeed(feed, $data, \'feed_type\')" e-ng-options="feed_type as feed_type.translated for feed_type in vm.feedTypes">{{feed.feed_type.translated}}</a></td><td><span editable-number="feed.dm" e-format-input-value="percentage" e-required="" e-style="width: 150px" e-step="0.01" edit-disabled="vm.updatingFeed" onaftersave="vm.updateFeed(feed, $data, \'dm\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="dm_{{$index}}">{{feed.dm | formatViewValues: \'percentage\'}}</span></td><td><span editable-number="feed.amount_dm" e-format-input-value="amount" e-required="" e-style="width: 100px" e-step="0.01" edit-disabled="vm.updatingFeed" onaftersave="vm.updateFeed(feed, $data, \'amount_dm\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="amount_dm_{{$index}}">{{feed.amount_dm | formatViewValues: \'amount\'}}</span></td><td><span editable-number="feed.amount_as_fed" e-format-input-value="amount" e-required="" e-style="width: 100px" e-step="0.01" edit-disabled="vm.updatingFeed" onaftersave="vm.updateFeed(feed, $data, \'amount_as_fed\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="amount_as_fed_{{$index}}">{{feed.amount_as_fed | formatViewValues: \'amount\'}}</span></td><td><span editable-number="feed.cost_dm" e-format-input-value="cost_dm" e-required="" e-style="width: 100px" e-step="0.01" edit-disabled="vm.updatingFeed" onaftersave="vm.updateFeed(feed, $data, \'cost_dm\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="cost_dm_{{$index}}">{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td><span editable-number="feed.cost_as_fed" e-format-input-value="cost_dm" e-required="" e-style="width: 100px" e-step="0.01" edit-disabled="vm.updatingFeed" onaftersave="vm.updateFeed(feed, $data, \'cost_as_fed\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="cost_as_fed_{{$index}}">{{feed.cost_as_fed | formatViewValues: \'cost_dm\'}}</span></td><td style="text-align: center"><button class="btn btn-xs btn-danger" ng-click="vm.deleteFeed(feed)"><i class="fa fa-trash"></i></button></td></tr></tbody><tfoot ng-if="vm.totalItems > 10"><tr><td colspan="8" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table></div><div style="height: 200px; overflow: hidden" align="center" ng-if="vm.loadingTable"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/groups/addNewGroup/addNewGroup.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll horizontal-scrol"><ba-wizard ng-show="!vm.loading && vm.selectedHerd" class="group-tabs" ng-class="vm.tabValidation()"><ba-wizard-step title="{{\'_groups_add_new_group_step1_title_\'|i18n}}" form="vm.basicInfoForm"><div align="right"><button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.basicInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicInfoForm.name.$invalid && (vm.basicInfoForm.name.$dirty || vm.basicInfoForm.$submitted)}"><label for="name"><data-i18n i18n="_groups_group_name_">group name</data-i18n></label> <input type="text" maxlength="50" class="form-control" id="name" name="name" placeholder="{{\'_groups_group_name_\' | i18n}}" ng-model="vm.group.name" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_group_name_required_" select-on-click="">group name is required</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.basicInfoForm.numberOfAnimals.$invalid && (vm.basicInfoForm.numberOfAnimals.$dirty || vm.basicInfoForm.$submitted)}"><label for="numberOfAnimals"><data-i18n i18n="_groups_no_animals_">number of animals</data-i18n></label> <input type="number" class="form-control" id="numberOfAnimals" name="numberOfAnimals" placeholder="{{\'_groups_no_animals_\'|i18n}}" ng-model="vm.group.number_of_animals" required="" min="1" max="99999" pattern="^\\d*(\\.\\d{0})?$" step="1" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_no_animals_required_" select-on-click="">number of animals is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group"><label for="breed"><data-i18n i18n="_groups_breed_">breed</data-i18n></label><ui-select ng-model="vm.selectedBreed" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.selected(\'breed\')" required="" id="breed"><ui-select-match placeholder="{{\'_picker_breed_placeholder_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="breed in vm.breeds | filter: $select.search"><span ng-bind-html="breed.name"></span></ui-select-choices></ui-select></div><div class="form-group"><label for="type"><data-i18n i18n="_groups_animal_type_">Animal Type</data-i18n></label><ui-select ng-model="vm.selectedAnimalType" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.selected(\'type\')" required="" id="type"><ui-select-match placeholder="{{\'_picker_animal_type_placeholder_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type in vm.animal_types | filter: $select.search"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div></div></div></form></ba-wizard-step><ba-wizard-step title="{{\'_groups_add_new_group_step2_title_\'|i18n}}" form="vm.animalInfoForm"><div align="right" style="padding-bottom: 10px"><button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.animalInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="panel"><div class="panel-heading"><data-i18n i18n="_groups_panel_current_info_title_">Current information</data-i18n></div><div class="panel-body"><div class="form-group" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\' || vm.selectedAnimalType.type ==\'drycow/late_pregnant_heifer\'"><label for="cowStage"><data-i18n i18n="_groups_cow_stage_">Cow stage</data-i18n></label><ui-select ng-model="vm.selectedCowStage" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" id="cowStage" on-select="vm.cowStageChanged()"><ui-select-match placeholder="{{\'_picker_cow_stage_placeholder_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="stage in vm.cowStages | filter: $select.search"><span ng-bind-html="stage.name"></span></ui-select-choices></ui-select></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.lactationNumber.$invalid && (vm.animalInfoForm.lactationNumber.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="lactationNumber" class="span-label"><data-i18n i18n="_groups_lactation_number_">lactation number</data-i18n></label> <input type="number" class="form-control with-units" id="lactationNumber" name="lactationNumber" placeholder="{{\'_groups_lactation_number_\'|i18n}}" ng-model="vm.group.lactation_number" required="" min="0" max="20" pattern="^\\d*(\\.\\d{0,3})?$" step="1" ng-change="vm.inputChanged(\'lactation_number\')" ng-disabled="vm.disableInput" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_lactation_number_required_">Lactation number(0-20) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.currentAge.$invalid && (vm.animalInfoForm.currentAge.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'heifer\'"><label for="currentAge" class="span-label"><data-i18n i18n="_groups_current_age_">Current age</data-i18n></label> <input type="number" class="form-control with-units" id="currentAge" name="currentAge" placeholder="{{\'_groups_current_age_\' | i18n}}" ng-model="vm.group.current_age" required="" min="1" max="36" pattern="^\\d*(\\.\\d{0,3})?$" step="1" ng-change="vm.inputChanged(\'current_age\')" ng-disabled="vm.disableInput" select-on-click=""> <span><data-i18n i18n="_unit_months_">months</data-i18n></span><span class="help-block error-block basic-block"><data-i18n i18n="_groups_current_age_required_">Current age(1-36) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.daysInMilk.$invalid && (vm.animalInfoForm.daysInMilk.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="daysInMilk" class="span-label"><data-i18n i18n="_groups_days_in_milk_">Days in milk</data-i18n></label> <input type="number" class="form-control with-units" id="daysInMilk" name="daysInMilk" placeholder="{{\'_groups_days_in_milk_\' | i18n}}" ng-model="vm.group.days_in_milk" required="" min="0" ng-max="vm.weight_max" pattern="^\\d*(\\.\\d{0,3})?$" step="1" ng-change="vm.inputChanged(\'days_in_milk\')" ng-disabled="vm.disableInput" select-on-click=""> <span><data-i18n i18n="_unit_days_">days</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_days_in_milk_required_">Days in milk(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.upLacNumber.$invalid && (vm.animalInfoForm.upLacNumber.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'drycow/late_pregnant_heifer\'"><label for="upLacNumber"><data-i18n i18n="_groups_upcoming_lactation_number_">Upcoming lactation number</data-i18n></label> <input type="number" class="form-control" id="upLacNumber" name="upLacNumber" placeholder="{{\'_groups_upcoming_lactation_number_\'|i18n}}" ng-model="vm.group.upcoming_lactation_number" required="" min="1" max="21" pattern="^\\d*(\\.\\d{0,3})?$" step="1" ng-change="vm.inputChanged(\'upcoming_lactation_number\')" ng-disabled="vm.disableInput" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_upcoming_lactation_number_required_">Upcoming lactation number(1-21) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.daysToCalving.$invalid && (vm.animalInfoForm.daysToCalving.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'drycow/late_pregnant_heifer\'"><label for="daysToCalving" class="span-label"><data-i18n i18n="_groups_days_to_calving_">Days to calving</data-i18n></label> <input type="number" class="form-control with-units" id="daysToCalving" name="daysToCalving" placeholder="{{\'_groups_days_to_calving_\'|i18n}}" ng-model="vm.group.days_to_calving" required="" min="0" max="280" pattern="^\\d*(\\.\\d{0,3})?$" step="1" ng-change="vm.inputChanged(\'days_to_calving\')" ng-disabled="vm.disableInput" select-on-click=""><span><data-i18n i18n="_unit_days_">days</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_days_to_calving_required_">Days to calving(0-280) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.totalBodyWeight.$invalid && (vm.animalInfoForm.totalBodyWeight.$dirty || vm.animalInfoForm.$submitted)}"><label for="totalBodyWeight" class="span-label"><data-i18n i18n="_groups_total_bw_">Total body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="totalBodyWeight" name="totalBodyWeight" placeholder="{{\'_groups_total_bw_\'|i18n}}" ng-model="vm.group.total_bw" format-input-value="total_bw" required="" min="0" ng-max="vm.weight_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'total_bw\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_total_bw_required_">Total body weight(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.bwWithoutFetus.$invalid && (vm.animalInfoForm.bwWithoutFetus.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'drycow/late_pregnant_heifer\'"><label for="bwWithoutFetus" class="span-label"><data-i18n i18n="_groups_bw_without_fetus_">Body weight without fetus</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="bwWithoutFetus" name="bwWithoutFetus" placeholder="{{\'_groups_bw_without_fetus_\'|i18n}}" ng-model="vm.group.bw_without_fetus" format-input-value="bw_without_fetus" required="" min="0" ng-max="vm.weight_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'bw_without_fetus\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_bw_without_fetus_required_">Body weight without fetus(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.matureBodyWeight.$invalid && (vm.animalInfoForm.matureBodyWeight.$dirty || vm.animalInfoForm.$submitted)}"><label for="matureBodyWeight" class="span-label"><data-i18n i18n="_groups_mature_bw_">Mature body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="matureBodyWeight" name="matureBodyWeight" placeholder="{{\'_groups_mature_bw_\'|i18n}}" ng-model="vm.group.mature_bw" format-input-value="mature_bw" required="" min="0" ng-max="vm.weight_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'mature_bw\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_mature_bw_required_">Mature body weight(0-2000) is reqired</data-i18n></span></div></div></div><div class="panel" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><div class="panel-heading"><data-i18n i18n="_groups_panel_predictions_target_animal_">Predictions from target animal</data-i18n></div><div class="panel-body"><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_predicted_base_dmi_">Predicted base DMI</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.predicted_base_dmi | formatViewValues: \'predicted_base_dmi\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_predicted_adjusted_dmi_">Predicted adjusted DMI</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.predicted_adjusted_dmi | formatViewValues: \'predicted_adjusted_dmi\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_predicted_daily_gain_">Predicted daily gain</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.predicted_daily_gain | formatViewValues: \'predicted_daily_gain\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row" ng-if="vm.selectedAnimalType.type!=\'heifer\'"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label ng-if="vm.settings.calculation_type == 0"><data-i18n i18n="_groups_required_nel_density_"></data-i18n>:</label> <label ng-if="vm.settings.calculation_type == 1"><data-i18n i18n="_groups_required_nel_density_"></data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label ng-if="vm.settings.calculation_type == 0">{{vm.group.required_nel_density | formatViewValues: \'required_nel_density\'}}&nbsp;{{vm.energy}}/{{vm.weight}}</label> <label ng-if="vm.settings.calculation_type == 1">{{vm.group.required_nel_density | formatViewValues: \'required_nel_density\'}}&nbsp;VEM/{{vm.weight}} DM</label></div></div><div class="row" ng-if="vm.selectedAnimalType.type==\'heifer\'"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_required_nem_density_"></data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.required_nem_density | formatViewValues: \'required_nem_density\'}}&nbsp{{vm.energy}}/{{vm.weight}}</label></div></div><div ng-if="vm.settings.calculation_type == 0" class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_required_me_density_">Required ME density</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.required_me_density | formatViewValues: \'required_me_density\'}}&nbsp{{vm.energy}}/{{vm.weight}}</label></div></div></div></div></div><div class="col-md-6"><div class="panel"><div class="panel-heading"><data-i18n i18n="_groups_panel_production_informations_">Production informations</data-i18n></div><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.targetMilkYield.$invalid && (vm.animalInfoForm.targetMilkYield.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="targetMilkYield" class="span-label"><data-i18n i18n="_groups_target_milk_yield_">Target milk yield</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetMilkYield" name="targetMilkYield" placeholder="{{\'_groups_target_milk_yield_\' | i18n}}" ng-model="vm.group.target_milk_yield" format-input-value="target_milk_yield" required="" min="0" ng-max="vm.milk_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'target_milk_yield\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_milk_yield_required_">Target milk yield(0-200) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.actualMilkYield.$invalid && (vm.animalInfoForm.actualMilkYield.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="actualMilkYieldr" class="span-label"><data-i18n i18n="_groups_actual_milk_yield_">Actual milk yield</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="actualMilkYield" name="actualMilkYield" placeholder="{{\'_groups_actual_milk_yield_\'|i18n}}" ng-model="vm.group.actual_milk_yield" format-input-value="actual_milk_yield" required="" min="0" ng-max="vm.milk_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_actual_milk_yield_required_">Actual milk yield(0-200) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.targetFat.$invalid && (vm.animalInfoForm.targetFat.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="targetFat" class="span-label"><data-i18n i18n="_groups_target_fat_">Target Fat</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetFat" name="targetFat" placeholder="{{\'_groups_target_fat_\' | i18n}}" ng-model="vm.group.target_fat" required="" min="0" max="100" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'target_fat\')" ng-disabled="vm.disableInput" select-on-click=""><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_fat_required_">Target fat(0-100) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.actualFat.$invalid && (vm.animalInfoForm.actualFat.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="actualFat" class="span-label"><data-i18n i18n="_groups_actual_fat_">Actual fat</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="actualFat" name="actualFat" placeholder="{{\'_groups_actual_fat_\'|i18n}}" ng-model="vm.group.actual_fat" required="" min="0" max="100" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'actual_fat\')" ng-disabled="vm.disableInput" select-on-click=""><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_actual_fat_required_">Actual fat(0-100) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.targetTProtein.$invalid && (vm.animalInfoForm.targetTProtein.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="targetTProtein" class="span-label"><data-i18n i18n="_groups_target_t_protein_">Target T Protein</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetTProtein" name="targetTProtein" placeholder="{{\'_groups_target_t_protein_\'|i18n}}" ng-model="vm.group.target_t_protein" required="" min="0" max="100" pattern="^\\d*(\\.\\d{0,3})?$" ng-disabled="vm.disableInput" select-on-click=""><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_target_t_required_">Target T protein(0-100) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.actualTProtein.$invalid && (vm.animalInfoForm.actualTProtein.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="actualTProtein" class="span-label"><data-i18n i18n="_groups_actual_t_protein_">Actual T Protein</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="actualTProtein" name="actualTProtein" placeholder="{{\'_groups_actual_t_protein_\'|i18n}}" ng-model="vm.group.actual_t_protein" required="" min="0" max="100" pattern="^\\d*(\\.\\d{0,3})?$" ng-disabled="vm.disableInput" select-on-click=""><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_actual_t_protein_required_">Actual T protein(0-100) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.targetLactose.$invalid && (vm.animalInfoForm.targetLactose.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="targetLactose" class="span-label"><data-i18n i18n="_groups_target_lactose_">Target lactose</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetLactose" name="targetLactose" placeholder="{{\'_groups_target_lactose_\'|i18n}}" ng-model="vm.group.target_lactose" required="" min="0" max="100" pattern="^\\d*(\\.\\d{0,3})?$" ng-disabled="vm.disableInput" select-on-click=""><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_lactose_required_">Target lactose(0-100) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.actualLactose.$invalid && (vm.animalInfoForm.actualLactose.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="actualLactose" class="span-label"><data-i18n i18n="_groups_actual_lactose_">Actual lactose</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="actualLactose" name="actualLactose" placeholder="{{\'_groups_actual_lactose_\'|i18n}}" ng-model="vm.group.actual_lactose" required="" min="0" max="100" pattern="^\\d*(\\.\\d{0,3})?$" ng-disabled="vm.disableInput" select-on-click=""> <span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_actual_lactose_required_">Actual lactose(0-100) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.farmsMilkPrice.$invalid && (vm.animalInfoForm.farmsMilkPrice.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="farmsMilkPrice" class="span-label"><data-i18n i18n="_groups_farms_milk_price_">Farm\'s milk price</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="farmsMilkPrice" name="farmsMilkPrice" placeholder="{{\'_groups_farms_milk_price_\'|i18n}}" ng-model="vm.group.farm_milk_price" format-input-value="farm_milk_price" required="" min="0" max="1000" pattern="^\\d*(\\.\\d{0,3})?$" ng-disabled="vm.disableInput" select-on-click=""><span></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_farms_milk_price_required_">Farm\'s milk price(0-1000) is reqired</data-i18n></span></div><div class="input-demo radio-demo row" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="price" id="price1" ng-value="1" ng-model="vm.group.is_price_per_one"> <span>{{vm.currency}}/{{vm.weight}}</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="price" id="price2" ng-value="0" ng-model="vm.group.is_price_per_one"> <span>{{vm.currency}}/100{{vm.weight}}</span></label></div></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.actualDmiPerCow.$invalid && (vm.animalInfoFormactualDmiPerCowe.$dirty || vm.animalInfoForm.$submitted)}"><label for="actualDmiPerCow" class="span-label"><data-i18n i18n="_groups_actual_dmi_per_cow_">Actual DMI per cow</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="actualDmiPerCow" name="actualDmiPerCow" placeholder="{{\'_groups_actual_dmi_per_cow_\'|i18n}}" ng-model="vm.group.actual_dmi" required="" min="0" ng-max="vm.milk_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_actual_dmi_per_cow_required_">Actual DMI per cow(0-200) is reqired</data-i18n></span></div></div></div><div class="panel" ng-if="vm.selectedAnimalType.type ==\'heifer\'"><div class="panel-heading"><data-i18n i18n="_groups_panel_target_informations_">Target informations</data-i18n></div><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.targetAge.$invalid && (vm.animalInfoForm.targetAge.$dirty || vm.animalInfoForm.$submitted)}"><label for="targetAge" class="span-label"><data-i18n i18n="_groups_target_age_">Target age</data-i18n></label> <input type="number" class="form-control with-units" id="targetAge" name="targetAge" placeholder="{{\'_groups_target_age_\'|i18n}}" ng-model="vm.group.target_age" required="" min="0" max="36" pattern="^\\d*(\\.\\d{0,3})?$" step="1" ng-change="vm.inputChanged(\'target_age\')" ng-disabled="vm.disableInput" select-on-click=""><span><data-i18n i18n="_unit_months_">months</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_age_required_">Target age(current age - 36) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.targetNPBC3BW.$invalid && (vm.animalInfoForm.targetNPBC3BW.$dirty || vm.animalInfoForm.$submitted)}"><label for="targetNPBC3BW" class="span-label"><data-i18n i18n="_groups_non_pregnant_bc3_bw_">Non-pregnant BC3 body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetNPBC3BW" name="targetNPBC3BW" placeholder="{{\'_groups_non_pregnant_bc3_bw_\'|i18n}}" ng-model="vm.group.non_pregnant_bc3_bw" format-input-value="non_pregnant_bc3_bw" required="" min="0" ng-max="vm.weight_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'non_pregnant_bc3_bw\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_non_pregnant_bc3_bw_required_">Non-pregnant BC3 body weight(0-2000) is reqired</data-i18n></span></div></div></div><div class="panel" ng-if="vm.selectedAnimalType.type ==\'drycow/late_pregnant_heifer\'"><div class="panel-heading"><data-i18n i18n="_groups_panel_management_options_">Management options</data-i18n></div><div class="panel-body"><div class="form-group"><label for="dcad_strategy"><data-i18n i18n="_groups_dcad_strategy_">DCAD strategy</data-i18n></label><ui-select ng-model="vm.selectedDcad_strategy" class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="true" search-enabled="true" id="dcad_strategy"><ui-select-match placeholder="{{\'_picker_dcad_strategy_placeholder_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="strategy in vm.strategies | filter: $select.search"><span ng-bind-html="strategy.name"></span></ui-select-choices></ui-select></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.dmiAdjustment.$invalid && (vm.animalInfoForm.dmiAdjustment.$dirty || vm.animalInfoForm.$submitted)}"><label for="dmiAdjustment" class="span-label"><data-i18n i18n="_groups_dmi_adjustment_">DMI adjustment</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="dmiAdjustment" name="dmiAdjustment" placeholder="{{\'_groups_dmi_adjustment_\'|i18n}}" ng-model="vm.group.dmi_adjustment" required="" min="80" max="120" pattern="^\\d*(\\.\\d{0,3})?$" ng-disabled="true" select-on-click=""><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_dmi_adjustment_required_">DMI adjustment(80-120) is reqired</data-i18n></span></div></div></div></div></div><div class="row" ng-if="vm.selectedAnimalType.type ==\'heifer\' || vm.selectedAnimalType.type ==\'drycow/late_pregnant_heifer\'"><div class="col-md-6"><div class="panel"><div class="panel-heading"><data-i18n i18n="_groups_panel_predictions_target_animal_">Predictions from target animal</data-i18n></div><div class="panel-body"><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_predicted_base_dmi_">Predicted base DMI</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.predicted_base_dmi | formatViewValues: \'predicted_base_dmi\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_predicted_adjusted_dmi_">Predicted adjusted DMI</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.predicted_adjusted_dmi | formatViewValues: \'predicted_adjusted_dmi\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_predicted_daily_gain_">Predicted daily gain</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.predicted_daily_gain | formatViewValues: \'predicted_daily_gain\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row" ng-if="vm.selectedAnimalType.type!=\'heifer\'"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label ng-if="vm.settings.calculation_type == 0"><data-i18n i18n="_groups_required_nel_density_"></data-i18n>:</label> <label ng-if="vm.settings.calculation_type == 1"><data-i18n i18n="_groups_required_nel_density_"></data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label ng-if="vm.settings.calculation_type == 0">{{vm.group.required_nel_density | formatViewValues: \'required_nel_density\'}}&nbsp;{{vm.energy}}/{{vm.weight}}</label> <label ng-if="vm.settings.calculation_type == 1">{{vm.group.required_nel_density | formatViewValues: \'required_nel_density\'}}&nbsp;VEM/{{vm.weight}} DM</label></div></div><div class="row" ng-if="vm.selectedAnimalType.type==\'heifer\'"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_required_nem_density_"></data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.required_nem_density | formatViewValues: \'required_nem_density\'}}&nbsp{{vm.energy}}/{{vm.weight}}</label></div></div><div ng-if="vm.settings.calculation_type == 0" class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_required_me_density_">Required ME density</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.required_me_density | formatViewValues: \'required_me_density\'}}&nbsp{{vm.energy}}/{{vm.weight}}</label></div></div></div></div></div></div></form></ba-wizard-step><ba-wizard-step title="{{\'_groups_add_new_group_step3_title_\'|i18n}}" form="vm.bwGain"><div align="right" style="padding-bottom: 10px"><button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.bwGain" novalidate=""><div class="row"><div class="col-md-6"><div class="panel"><div class="panel-heading"><data-i18n i18n="_groups_panel_current_info_title_">Current informations</data-i18n></div><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.bwGain.totalBodyWeightG.$invalid && (vm.bwGain.totalBodyWeightG.$dirty || vm.bwGain.$submitted)}"><label for="totalBodyWeightG" class="span-label"><data-i18n i18n="_groups_total_bw_">Total body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="totalBodyWeightG" name="totalBodyWeightG" placeholder="{{\'_groups_total_bw_\'|i18n}}" ng-model="vm.group.total_bw" format-input-value="total_bw" required="" min="0" ng-max="vm.weight_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'total_bw\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_total_bw_required_">Total body weight(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.bodyConditionScore.$invalid && (vm.bwGain.bodyConditionScore.$dirty || vm.bwGain.$submitted)}"><label for="bodyConditionScore" class="span-label"><data-i18n i18n="_groups_body_condition_score_">Body condition score</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="bodyConditionScore" name="bodyConditionScore" placeholder="{{\'_groups_body_condition_score_\' | i18n}}" ng-model="vm.group.body_condition_score" required="" min="0" max="5" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'body_condition_score\')" ng-disabled="vm.disableInput" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_body_condition_score_required_">Body condition score(0-5) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.daysPregnant.$invalid && (vm.bwGain.daysPregnant.$dirty || vm.bwGain.$submitted)}"><label for="daysPregnant" class="span-label"><data-i18n i18n="_groups_days_pregnant_">Days pregnant</data-i18n></label> <input type="number" class="form-control with-units" id="daysPregnant" name="daysPregnant" placeholder="{{\'_groups_days_pregnant_\'|i18n}}" ng-model="vm.group.days_pregnant" required="" min="0" max="280" pattern="^\\d*(\\.\\d{0,3})?$" step="1" ng-change="vm.inputChanged(\'days_pregnant\')" ng-disabled="vm.disableInput" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_days_in_milk_required_">Days pregnant(0-280) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.bwWithoutFetusG.$invalid && (vm.bwGain.bwWithoutFetusG.$dirty || vm.bwGain.$submitted)}"><label for="bwWithoutFetusG" class="span-label"><data-i18n i18n="_groups_bw_without_fetus_">Body weight without fetus</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="bwWithoutFetusG" name="bwWithoutFetusG" placeholder="{{\'_groups_bw_without_fetus_\'|i18n}}" ng-model="vm.group.bw_without_fetus" format-input-value="bw_without_fetus" required="" min="0" ng-max="vm.weight_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'bw_without_fetus\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_bw_without_fetus_required_">Body weight without fetus(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.nonPregnancyBC3BW.$invalid && (vm.bwGain.nonPregnancyBC3BW.$dirty || vm.bwGain.$submitted)}"><label for="nonPregnancyBC3BW" class="span-label"><data-i18n i18n="_groups_non_pregnant_bc3_bw_">Non-pregnant BC3 body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="nonPregnancyBC3BW" name="nonPregnancyBC3BW" placeholder="{{\'_groups_non_pregnant_bc3_bw_\'|i18n}}" ng-model="vm.group.non_pregnant_bc3_bw" format-input-value="non_pregnant_bc3_bw" required="" min="0" ng-max="vm.weight_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'non_pregnant_bc3_bw\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_non_pregnant_bc3_bw_required_">Non-pregnant BC3 body weight(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.matureBodyWeightG.$invalid && (vm.bwGain.matureBodyWeightG.$dirty || vm.bwGain.$submitted)}"><label for="matureBodyWeightG" class="span-label"><data-i18n i18n="_groups_mature_bw_">Mature body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="matureBodyWeightG" name="matureBodyWeightG" placeholder="{{\'_groups_mature_bw_\'|i18n}}" ng-model="vm.group.mature_bw" format-input-value="mature_bw" required="" min="0" ng-max="vm.weight_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'mature_bw\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_mature_bw_required_">Mature body weight(0-2000) is reqired</data-i18n></span></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_daily_pregnancy_gain_">Daily pregnancy gain</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.daily_pregnancy_gain | formatViewValues: \'daily_pregnancy_gain\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_"></data-i18n></label></div></div></div></div></div><div class="col-md-6"><div class="panel"><div class="panel-heading"><data-i18n i18n="_groups_panel_target_frame_growth_">Target frame growth</data-i18n></div><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.bwGain.targetNPBC3BWG.$invalid && (vm.bwGain.targetNPBC3BWG.$dirty || vm.bwGain.$submitted)}"><label for="targetNPBC3BWG" class="span-label"><data-i18n i18n="_groups_target_non_pregnant_bc3_bw_">Non-pregnant BC3 body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetNPBC3BWG" name="targetNPBC3BWG" placeholder="{{\'_groups_target_non_pregnant_bc3_bw_\'|i18n}}" ng-model="vm.group.target_non_pregnant_bc3_bw" format-input-value="target_non_pregnant_bc3_bw" required="" min="0" ng-max="vm.weight_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'target_non_pregnant_bc3_bw\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_non_pregnant_bc3_bw_required_">Non-pregnant BC3 body weight(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.daysTAFG.$invalid && (vm.bwGain.daysTAFG.$dirty || vm.bwGain.$submitted)}"><label for="daysTAFG" class="span-label"><data-i18n i18n="_groups_days_to_achieve_fg_">Days to achieve frame growth</data-i18n></label> <input type="number" class="form-control with-units" id="daysTAFG" name="daysTAFG" placeholder="{{\'_groups_days_to_achieve_fg_\'|i18n}}" ng-model="vm.group.days_to_achieve_fg" required="" min="0" max="1100" pattern="^\\d*(\\.\\d{0,3})?$" step="1" ng-change="vm.inputChanged(\'days_to_achieve_fg\')" ng-disabled="vm.disableInput" select-on-click=""><span><data-i18n i18n="_unit_days_">days</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_days_to_achieve_fg_required_">Days to achieve frame growth(0-1100) is reqired</data-i18n></span></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_target_frame_growth_">Target frame growth</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.target_frame_growth | formatViewValues: \'target_frame_growth\'}}&nbsp{{vm.weight}}</label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_target_daily_fg_">Target daily frame growth</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.target_daily_fg | formatViewValues: \'target_daily_fg\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div></div></div><div class="panel"><div class="panel-heading"><data-i18n i18n="_groups_panel_target_bc_gain_">Target body condition gain</data-i18n></div><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.bwGain.targetBCS.$invalid && (vm.bwGain.targetBCS.$dirty || vm.bwGain.$submitted)}"><label for="targetBCS" class="span-label"><data-i18n i18n="_groups_target_bc_score_">Target body condition score</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetBCS" name="targetBCS" placeholder="{{\'_groups_target_bc_score_\'|i18n}}" ng-model="vm.group.target_body_condition_score" required="" min="0" max="5" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'target_body_condition_score\')" ng-disabled="vm.disableInput" select-on-click=""><span></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_bc_score_required_">Target body condition score(0-5) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.daysTABC.$invalid && (vm.bwGain.daysTABC.$dirty || vm.bwGain.$submitted)}"><label for="daysTABC" class="span-label"><data-i18n i18n="_groups_days_to_achieve_bc_">Days to achieve body condition</data-i18n></label> <input type="number" class="form-control with-units" id="daysTABC" name="daysTABC" placeholder="{{\'_groups_days_to_achieve_bc_\'|i18n}}" ng-model="vm.group.days_to_achieve_bc" required="" min="0" max="1100" pattern="^\\d*(\\.\\d{0,3})?$" step="1" ng-change="vm.inputChanged(\'days_to_achieve_bc\')" ng-disabled="vm.disableInput" select-on-click=""><span><data-i18n i18n="_unit_days_">days</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_days_to_achieve_bc_required_">Days to achieve body condition(0-500) is reqired</data-i18n></span></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_target_bc_gain_">Target body condition gain</data-i18n>:</label></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label>{{vm.group.target_body_condition_gain | formatViewValues: \'target_body_condition_gain\'}}&nbsp{{vm.weight}}</label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_target_daily_bc_gain_">Target daily body condition gain</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.target_daily_bc_gain | formatViewValues: \'target_daily_bc_gain\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div></div></div></div></div><div class="row"><div class="col-md-6"><div class="panel"><div class="panel-body"><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_target_daily_bw_gain_">Target daily body weight gain</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.target_daily_bw_gain | formatViewValues: \'target_daily_bw_gain\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div></div></div></div></div></form></ba-wizard-step><ba-wizard-step title="{{\'_groups_add_new_group_step4_title_\'|i18n}}"><div align="right"><button type="button" class="btn btn-success" ng-click="vm.saveGroup()" ng-disabled="vm.basicInfoForm.$invalid == true || vm.animalInfoForm.$invalid == true || vm.bwGain.$invalid == true"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_"></data-i18n></button></div><form class="form-horizontal" name="vm.finishForm" novalidate="" style="font-size: 16px; margin-top: 10px"><data-i18n i18n="_groups_add_new_group_finish_message_">You have successfully defined the group, save your work.</data-i18n></form></ba-wizard-step></ba-wizard><div ng-if="!vm.loading && !vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div><div ng-if="vm.loading" align="center"><div style="overflow: hidden"><div id="loading-animation-large" style="display: inline-block"></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/groups/editGroup/editGroup.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll horizontal-scrol"><ba-wizard ng-if="!vm.editLoading && !vm.loading" class="group-tabs" ng-class="vm.tabValidation()"><ba-wizard-step title="{{\'_groups_edit_group_step1_title_\'|i18n}}" form="vm.basicInfoForm"><div align="right" style="padding-bottom: 10px"><button type="button" class="btn btn-success" ng-click="vm.updateGroup()" ng-if="vm.showUpdate" ng-disabled="vm.basicInfoForm.$invalid == true || vm.animalInfoForm.$invalid == true || vm.bwGain.$invalid == true || vm.disableInput"><data-i18n i18n="_btn_update_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.closeEditWindow()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.basicInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicInfoForm.name.$invalid && (vm.basicInfoForm.name.$dirty || vm.basicInfoForm.$submitted)}"><label for="name"><data-i18n i18n="_groups_group_name_">group name</data-i18n></label> <input type="text" maxlength="50" class="form-control" id="name" name="name" placeholder="{{\'_groups_group_name_\' | i18n}}" ng-model="vm.group.name" required="" select-on-click="" ng-change="vm.showUpdate = true"> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_group_name_required_">group name is required</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.basicInfoForm.numberOfAnimals.$invalid && (vm.basicInfoForm.numberOfAnimals.$dirty || vm.basicInfoForm.$submitted)}"><label for="numberOfAnimals"><data-i18n i18n="_groups_no_animals_">number of animals</data-i18n></label> <input type="number" class="form-control" id="numberOfAnimals" name="numberOfAnimals" placeholder="{{\'_groups_no_animals_\'|i18n}}" ng-model="vm.group.number_of_animals" required="" min="1" max="99999" step="1" pattern="^\\d*(\\.\\d{0})?$" select-on-click="" ng-change="vm.showUpdate = true"> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_no_animals_required_">number of animals is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group"><label for="breed"><data-i18n i18n="_groups_breed_">breed</data-i18n></label><ui-select ng-model="vm.selectedBreed" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.selected(\'breed\')" required="" id="breed" ng-change="vm.showUpdate = true"><ui-select-match placeholder="{{\'_picker_breed_placeholder_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="breed in vm.breeds | filter: $select.search"><span ng-bind-html="breed.name"></span></ui-select-choices></ui-select></div><div class="form-group"><label for="type"><data-i18n i18n="_groups_animal_type_">Animal Type</data-i18n></label><ui-select ng-model="vm.selectedAnimalType" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.selected(\'type\')" required="" id="type" ng-change="vm.showUpdate = true"><ui-select-match placeholder="{{\'_picker_animal_type_placeholder_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type in vm.animal_types | filter: $select.search"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div></div></div></form></ba-wizard-step><ba-wizard-step title="{{\'_groups_edit_group_step2_title_\'|i18n}}" form="vm.animalInfoForm"><div align="right" style="padding-bottom: 10px"><button type="button" class="btn btn-success" ng-click="vm.updateGroup()" ng-if="vm.showUpdate" ng-disabled="vm.basicInfoForm.$invalid == true || vm.animalInfoForm.$invalid == true || vm.bwGain.$invalid == true || vm.disableInput"><data-i18n i18n="_btn_update_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.closeEditWindow()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.animalInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="panel"><div class="panel-heading"><data-i18n i18n="_groups_panel_current_info_title_">Current information</data-i18n></div><div class="panel-body"><div class="form-group" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\' || vm.selectedAnimalType.type ==\'drycow/late_pregnant_heifer\'"><label for="cowStage"><data-i18n i18n="_groups_cow_stage_">Cow stage</data-i18n></label><ui-select ng-model="vm.selectedCowStage" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" id="cowStage" on-select="vm.cowStageChanged()" ng-change="vm.showUpdate = true"><ui-select-match placeholder="{{\'_picker_cow_stage_placeholder_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="stage in vm.cowStages | filter: $select.search"><span ng-bind-html="stage.name"></span></ui-select-choices></ui-select></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.lactationNumber.$invalid && (vm.animalInfoForm.lactationNumber.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="lactationNumber" class="span-label"><data-i18n i18n="_groups_lactation_number_">lactation number</data-i18n></label> <input type="number" class="form-control with-units" id="lactationNumber" name="lactationNumber" placeholder="{{\'_groups_lactation_number_\'|i18n}}" ng-model="vm.group.lactation_number" required="" min="0" max="20" pattern="^\\d*(\\.\\d{0,3})?$" step="1" ng-change="vm.inputChanged(\'lactation_number\')" ng-disabled="vm.disableInput" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_lactation_number_required_">Lactation number(0-20) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.currentAge.$invalid && (vm.animalInfoForm.currentAge.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'heifer\'"><label for="currentAge" class="span-label"><data-i18n i18n="_groups_current_age_">Current age</data-i18n></label> <input type="number" class="form-control with-units" id="currentAge" name="currentAge" placeholder="{{\'_groups_current_age_\' | i18n}}" ng-model="vm.group.current_age" required="" min="1" max="36" step="1" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'current_age\')" ng-disabled="vm.disableInput" select-on-click=""> <span><data-i18n i18n="_unit_months_">months</data-i18n></span><span class="help-block error-block basic-block"><data-i18n i18n="_groups_current_age_required_">Current age(1-36) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.daysInMilk.$invalid && (vm.animalInfoForm.daysInMilk.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="daysInMilk" class="span-label"><data-i18n i18n="_groups_days_in_milk_">Days in milk</data-i18n></label> <input type="number" class="form-control with-units" id="daysInMilk" name="daysInMilk" placeholder="{{\'_groups_days_in_milk_\' | i18n}}" ng-model="vm.group.days_in_milk" required="" min="0" ng-max="vm.weight_max" pattern="^\\d*(\\.\\d{0,3})?$" step="1" ng-change="vm.inputChanged(\'days_in_milk\')" ng-disabled="vm.disableInput" select-on-click=""> <span><data-i18n i18n="_unit_days_">days</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_days_in_milk_required_">Days in milk(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.upLacNumber.$invalid && (vm.animalInfoForm.upLacNumber.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'drycow/late_pregnant_heifer\'"><label for="upLacNumber"><data-i18n i18n="_groups_upcoming_lactation_number_">Upcoming lactation number</data-i18n></label> <input type="number" class="form-control" id="upLacNumber" name="upLacNumber" placeholder="{{\'_groups_upcoming_lactation_number_\'|i18n}}" ng-model="vm.group.upcoming_lactation_number" required="" min="1" max="21" pattern="^\\d*(\\.\\d{0,3})?$" step="1" ng-change="vm.inputChanged(\'upcoming_lactation_number\')" ng-disabled="vm.disableInput" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_upcoming_lactation_number_required_">Upcoming lactation number(1-21) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.daysToCalving.$invalid && (vm.animalInfoForm.daysToCalving.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'drycow/late_pregnant_heifer\'"><label for="daysToCalving" class="span-label"><data-i18n i18n="_groups_days_to_calving_">Days to calving</data-i18n></label> <input type="number" class="form-control with-units" id="daysToCalving" name="daysToCalving" placeholder="{{\'_groups_days_to_calving_\'|i18n}}" ng-model="vm.group.days_to_calving" required="" min="0" max="280" pattern="^\\d*(\\.\\d{0,3})?$" step="1" ng-change="vm.inputChanged(\'days_to_calving\')" ng-disabled="vm.disableInput" select-on-click=""><span><data-i18n i18n="_unit_days_">days</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_days_to_calving_required_">Days to calving(0-280) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.totalBodyWeight.$invalid && (vm.animalInfoForm.totalBodyWeight.$dirty || vm.animalInfoForm.$submitted)}"><label for="totalBodyWeight" class="span-label"><data-i18n i18n="_groups_total_bw_">Total body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="totalBodyWeight" name="totalBodyWeight" placeholder="{{\'_groups_total_bw_\'|i18n}}" ng-model="vm.group.total_bw" format-input-value="total_bw" required="" min="0" ng-max="vm.weight_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'total_bw\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_total_bw_required_">Total body weight(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.bwWithoutFetus.$invalid && (vm.animalInfoForm.bwWithoutFetus.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'drycow/late_pregnant_heifer\'"><label for="bwWithoutFetus" class="span-label"><data-i18n i18n="_groups_bw_without_fetus_">Body weight without fetus</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="bwWithoutFetus" name="bwWithoutFetus" placeholder="{{\'_groups_bw_without_fetus_\'|i18n}}" ng-model="vm.group.bw_without_fetus" format-input-value="bw_without_fetus" required="" min="0" ng-max="vm.weight_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'bw_without_fetus\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_bw_without_fetus_required_">Body weight without fetus(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.matureBodyWeight.$invalid && (vm.animalInfoForm.matureBodyWeight.$dirty || vm.animalInfoForm.$submitted)}"><label for="matureBodyWeight" class="span-label"><data-i18n i18n="_groups_mature_bw_">Mature body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="matureBodyWeight" name="matureBodyWeight" placeholder="{{\'_groups_mature_bw_\'|i18n}}" ng-model="vm.group.mature_bw" format-input-value="mature_bw" required="" min="0" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'mature_bw\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_mature_bw_required_">Mature body weight(0-2000) is reqired</data-i18n></span></div></div></div><div class="panel" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><div class="panel-heading"><data-i18n i18n="_groups_panel_predictions_target_animal_">Predictions from target animal</data-i18n></div><div class="panel-body"><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_predicted_base_dmi_">Predicted base DMI</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.predicted_base_dmi | formatViewValues: \'predicted_base_dmi\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_predicted_adjusted_dmi_">Predicted adjusted DMI</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.predicted_adjusted_dmi | formatViewValues: \'predicted_adjusted_dmi\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_predicted_daily_gain_">Predicted daily gain</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.predicted_daily_gain | formatViewValues: \'predicted_daily_gain\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row" ng-if="vm.selectedAnimalType.type!=\'heifer\'"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label ng-if="vm.settings.calculation_type == 0"><data-i18n i18n="_groups_required_nel_density_"></data-i18n>:</label> <label ng-if="vm.settings.calculation_type == 1"><data-i18n i18n="_groups_required_nel_density_"></data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label ng-if="vm.settings.calculation_type == 0">{{vm.group.required_nel_density | formatViewValues: \'required_nel_density\'}}&nbsp;{{vm.energy}}/{{vm.weight}}</label> <label ng-if="vm.settings.calculation_type == 1">{{vm.group.required_nel_density | formatViewValues: \'required_nel_density\'}}&nbsp;VEM/{{vm.weight}}DM</label></div></div><div class="row" ng-if="vm.selectedAnimalType.type==\'heifer\'"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_required_nem_density_"></data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.required_nem_density | formatViewValues: \'required_nem_density\'}}&nbsp{{vm.energy}}/{{vm.weight}}</label></div></div><div ng-if="vm.settings.calculation_type == 0" class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_required_me_density_">Required ME density</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.required_me_density | formatViewValues: \'required_me_density\'}}&nbsp{{vm.energy}}/{{vm.weight}}</label></div></div></div></div></div><div class="col-md-6"><div class="panel"><div class="panel-heading"><data-i18n i18n="_groups_panel_production_informations_">Production informations</data-i18n></div><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.targetMilkYield.$invalid && (vm.animalInfoForm.targetMilkYield.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="targetMilkYield" class="span-label"><data-i18n i18n="_groups_target_milk_yield_">Target milk yield</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetMilkYield" name="targetMilkYield" placeholder="{{\'_groups_target_milk_yield_\' | i18n}}" ng-model="vm.group.target_milk_yield" format-input-value="target_milk_yield" required="" min="0" ng-max="vm.milk_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'target_milk_yield\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_milk_yield_required_">Target milk yield(0-200) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.actualMilkYield.$invalid && (vm.animalInfoForm.actualMilkYield.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="actualMilkYieldr" class="span-label"><data-i18n i18n="_groups_actual_milk_yield_">Actual milk yield</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="actualMilkYield" name="actualMilkYield" placeholder="{{\'_groups_actual_milk_yield_\'|i18n}}" ng-model="vm.group.actual_milk_yield" format-input-value="actual_milk_yield" required="" min="0" ng-max="vm.milk_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-disabled="vm.disableInput" select-on-click="" ng-change="vm.showUpdate = true"><span>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_actual_milk_yield_required_">Actual milk yield(0-200) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.targetFat.$invalid && (vm.animalInfoForm.targetFat.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="targetFat" class="span-label"><data-i18n i18n="_groups_target_fat_">Target Fat</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetFat" name="targetFat" placeholder="{{\'_groups_target_fat_\' | i18n}}" ng-model="vm.group.target_fat" required="" min="0" max="100" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'target_fat\')" ng-disabled="vm.disableInput" select-on-click=""><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_fat_required_">Target fat(0-100) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.actualFat.$invalid && (vm.animalInfoForm.actualFat.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="actualFat" class="span-label"><data-i18n i18n="_groups_actual_fat_">Actual fat</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="actualFat" name="actualFat" placeholder="{{\'_groups_actual_fat_\'|i18n}}" ng-model="vm.group.actual_fat" required="" min="0" max="100" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'actual_fat\')" ng-disabled="vm.disableInput" select-on-click=""><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_actual_fat_required_">Actual fat(0-100) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.targetTProtein.$invalid && (vm.animalInfoForm.targetTProtein.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="targetTProtein" class="span-label"><data-i18n i18n="_groups_target_t_protein_">Target T Protein</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetTProtein" name="targetTProtein" placeholder="{{\'_groups_target_t_protein_\'|i18n}}" ng-model="vm.group.target_t_protein" required="" min="0" max="100" pattern="^\\d*(\\.\\d{0,3})?$" ng-disabled="vm.disableInput" select-on-click="" ng-change="vm.showUpdate = true;"><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_target_t_required_">Target T protein(0-100) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.actualTProtein.$invalid && (vm.animalInfoForm.actualTProtein.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="actualTProtein" class="span-label"><data-i18n i18n="_groups_actual_t_protein_">Actual T Protein</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="actualTProtein" name="actualTProtein" placeholder="{{\'_groups_actual_t_protein_\'|i18n}}" ng-model="vm.group.actual_t_protein" required="" min="0" max="100" pattern="^\\d*(\\.\\d{0,3})?$" ng-disabled="vm.disableInput" select-on-click="" ng-change="vm.showUpdate = true;"><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_actual_t_protein_required_">Actual T protein(0-100) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.targetLactose.$invalid && (vm.animalInfoForm.targetLactose.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="targetLactose" class="span-label"><data-i18n i18n="_groups_target_lactose_">Target lactose</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetLactose" name="targetLactose" placeholder="{{\'_groups_target_lactose_\'|i18n}}" ng-model="vm.group.target_lactose" required="" min="0" max="100" pattern="^\\d*(\\.\\d{0,3})?$" ng-disabled="vm.disableInput" select-on-click="" ng-change="vm.showUpdate = true;"><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_lactose_required_">Target lactose(0-100) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.actualLactose.$invalid && (vm.animalInfoForm.actualLactose.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="actualLactose" class="span-label"><data-i18n i18n="_groups_actual_lactose_">Actual lactose</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="actualLactose" name="actualLactose" placeholder="{{\'_groups_actual_lactose_\'|i18n}}" ng-model="vm.group.actual_lactose" required="" min="0" max="100" pattern="^\\d*(\\.\\d{0,3})?$" ng-disabled="vm.disableInput" select-on-click="" ng-change="vm.showUpdate = true;"> <span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_actual_lactose_required_">Actual lactose(0-100) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.farmsMilkPrice.$invalid && (vm.animalInfoForm.farmsMilkPrice.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><label for="farmsMilkPrice" class="span-label"><data-i18n i18n="_groups_farms_milk_price_">Farm\'s milk price</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="farmsMilkPrice" name="farmsMilkPrice" placeholder="{{\'_groups_farms_milk_price_\'|i18n}}" ng-model="vm.group.farm_milk_price" format-input-value="farm_milk_price" required="" min="0" max="1000" pattern="^\\d*(\\.\\d{0,3})?$" ng-disabled="vm.disableInput" select-on-click="" ng-change="vm.showUpdate = true;"><span></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_farms_milk_price_required_">Farm\'s milk price(0-1000) is reqired</data-i18n></span></div><div class="input-demo radio-demo row" ng-if="vm.selectedAnimalType.type ==\'lactating_cow\'"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="price" id="price1" ng-value="1" ng-model="vm.group.is_price_per_one" ng-change="vm.showUpdate = true;"> <span>{{vm.currency}}/{{vm.weight}}</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="price" id="price2" ng-value="0" ng-model="vm.group.is_price_per_one" ng-change="vm.showUpdate = true;"> <span>{{vm.currency}}/100{{vm.weight}}</span></label></div></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.actualDmiPerCow.$invalid && (vm.animalInfoFormactualDmiPerCowe.$dirty || vm.animalInfoForm.$submitted)}"><label for="actualDmiPerCow" class="span-label"><data-i18n i18n="_groups_actual_dmi_per_cow_">Actual DMI per cow</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="actualDmiPerCow" name="actualDmiPerCow" placeholder="{{\'_groups_actual_dmi_per_cow_\'|i18n}}" ng-model="vm.group.actual_dmi" required="" min="0" ng-max="vm.milk_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-disabled="vm.disableInput" select-on-click="" ng-change="vm.showUpdate = true;"><span>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_actual_dmi_per_cow_required_">Actual DMI per cow(0-200) is reqired</data-i18n></span></div></div></div><div class="panel" ng-if="vm.selectedAnimalType.type ==\'heifer\'"><div class="panel-heading"><data-i18n i18n="_groups_panel_target_informations_">Target informations</data-i18n></div><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.targetAge.$invalid && (vm.animalInfoForm.targetAge.$dirty || vm.animalInfoForm.$submitted)}"><label for="targetAge" class="span-label"><data-i18n i18n="_groups_target_age_">Target age</data-i18n></label> <input type="number" class="form-control with-units" id="targetAge" name="targetAge" placeholder="{{\'_groups_target_age_\'|i18n}}" ng-model="vm.group.target_age" required="" min="0" max="36" pattern="^\\d*(\\.\\d{0,3})?$" step="1" ng-change="vm.inputChanged(\'target_age\')" ng-disabled="vm.disableInput" select-on-click=""><span><data-i18n i18n="_unit_months_">months</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_age_required_">Target age(current age - 36) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.targetNPBC3BW.$invalid && (vm.animalInfoForm.targetNPBC3BW.$dirty || vm.animalInfoForm.$submitted)}"><label for="targetNPBC3BW" class="span-label"><data-i18n i18n="_groups_non_pregnant_bc3_bw_">Non-pregnant BC3 body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetNPBC3BW" name="targetNPBC3BW" placeholder="{{\'_groups_non_pregnant_bc3_bw_\'|i18n}}" ng-model="vm.group.non_pregnant_bc3_bw" format-input-value="non_pregnant_bc3_bw" required="" min="0" ng-max="vm.weight_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'non_pregnant_bc3_bw\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_non_pregnant_bc3_bw_required_">Non-pregnant BC3 body weight(0-2000) is reqired</data-i18n></span></div></div></div><div class="panel" ng-if="vm.selectedAnimalType.type ==\'drycow/late_pregnant_heifer\'"><div class="panel-heading"><data-i18n i18n="_groups_panel_management_options_">Management options</data-i18n></div><div class="panel-body"><div class="form-group"><label for="dcad_strategy"><data-i18n i18n="_groups_dcad_strategy_">DCAD strategy</data-i18n></label><ui-select ng-model="vm.group.dcad_strategy" class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="true" search-enabled="true" id="dcad_strategy" ng-change="vm.showUpdate = true;"><ui-select-match placeholder="{{\'_picker_dcad_strategy_placeholder_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="strategy in vm.strategies | filter: $select.search"><span ng-bind-html="strategy.name"></span></ui-select-choices></ui-select></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.dmiAdjustment.$invalid && (vm.animalInfoForm.dmiAdjustment.$dirty || vm.animalInfoForm.$submitted)}"><label for="dmiAdjustment" class="span-label"><data-i18n i18n="_groups_dmi_adjustment_">DMI adjustment</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="dmiAdjustment" name="dmiAdjustment" placeholder="{{\'_groups_dmi_adjustment_\'|i18n}}" ng-model="vm.group.dmi_adjustment" required="" min="80" max="120" pattern="^\\d*(\\.\\d{0,3})?$" ng-disabled="true" select-on-click="" ng-change="vm.showUpdate = true;"><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_dmi_adjustment_required_">DMI adjustment(80-120) is reqired</data-i18n></span></div></div></div></div></div><div class="row" ng-if="vm.selectedAnimalType.type ==\'heifer\' || vm.selectedAnimalType.type ==\'drycow/late_pregnant_heifer\'"><div class="col-md-6"><div class="panel"><div class="panel-heading"><data-i18n i18n="_groups_panel_predictions_target_animal_">Predictions from target animal</data-i18n></div><div class="panel-body"><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_predicted_base_dmi_">Predicted base DMI</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.predicted_base_dmi | formatViewValues: \'predicted_base_dmi\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_predicted_adjusted_dmi_">Predicted adjusted DMI</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.predicted_adjusted_dmi | formatViewValues: \'predicted_adjusted_dmi\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_predicted_daily_gain_">Predicted daily gain</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.predicted_daily_gain | formatViewValues: \'predicted_daily_gain\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row" ng-if="vm.selectedAnimalType.type!=\'heifer\'"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label ng-if="vm.settings.calculation_type == 0"><data-i18n i18n="_groups_required_nel_density_"></data-i18n>:</label> <label ng-if="vm.settings.calculation_type == 1"><data-i18n i18n="_groups_required_nel_density_"></data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label ng-if="vm.settings.calculation_type == 0">{{vm.group.required_nel_density | formatViewValues: \'required_nel_density\'}}&nbsp;{{vm.energy}}/{{vm.weight}}</label> <label ng-if="vm.settings.calculation_type == 1">{{vm.group.required_nel_density | formatViewValues: \'required_nel_density\'}}&nbsp;VEM/{{vm.weight}}DM</label></div></div><div class="row" ng-if="vm.selectedAnimalType.type==\'heifer\'"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_required_nem_density_"></data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.required_nem_density | formatViewValues: \'required_nem_density\'}}&nbsp{{vm.energy}}/{{vm.weight}}</label></div></div><div ng-if="vm.settings.calculation_type == 0" class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_required_me_density_">Required ME density</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.required_me_density | formatViewValues: \'required_me_density\'}}&nbsp{{vm.energy}}/{{vm.weight}}</label></div></div></div></div></div></div></form></ba-wizard-step><ba-wizard-step title="{{\'_groups_edit_group_step3_title_\'|i18n}}" form="vm.bwGain"><div align="right" style="padding-bottom: 10px"><button type="button" class="btn btn-success" ng-click="vm.updateGroup()" ng-if="vm.showUpdate" ng-disabled="vm.basicInfoForm.$invalid == true || vm.animalInfoForm.$invalid == true || vm.bwGain.$invalid == true || vm.disableInput"><data-i18n i18n="_btn_update_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.closeEditWindow()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.bwGain" novalidate=""><div class="row"><div class="col-md-6"><div class="panel"><div class="panel-heading"><data-i18n i18n="_groups_panel_current_info_title_">Current informations</data-i18n></div><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.bwGain.totalBodyWeightG.$invalid && (vm.bwGain.totalBodyWeightG.$dirty || vm.bwGain.$submitted)}"><label for="totalBodyWeightG" class="span-label"><data-i18n i18n="_groups_total_bw_">Total body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="totalBodyWeightG" name="totalBodyWeightG" placeholder="{{\'_groups_total_bw_\'|i18n}}" ng-model="vm.group.total_bw" format-input-value="total_bw" required="" min="0" ng-max="vm.weight_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'total_bw\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_total_bw_required_">Total body weight(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.bodyConditionScore.$invalid && (vm.bwGain.bodyConditionScore.$dirty || vm.bwGain.$submitted)}"><label for="bodyConditionScore" class="span-label"><data-i18n i18n="_groups_body_condition_score_">Body condition score</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="bodyConditionScore" name="bodyConditionScore" placeholder="{{\'_groups_body_condition_score_\' | i18n}}" ng-model="vm.group.body_condition_score" required="" min="0" max="5" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'body_condition_score\')" ng-disabled="vm.disableInput" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_body_condition_score_required_">Body condition score(0-5) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.daysPregnant.$invalid && (vm.bwGain.daysPregnant.$dirty || vm.bwGain.$submitted)}"><label for="daysPregnant" class="span-label"><data-i18n i18n="_groups_days_pregnant_">Days pregnant</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="daysPregnant" name="daysPregnant" placeholder="{{\'_groups_days_pregnant_\'|i18n}}" ng-model="vm.group.days_pregnant" required="" min="0" max="280" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'days_pregnant\')" ng-disabled="vm.disableInput" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_days_in_milk_required_">Days pregnant(0-280) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.bwWithoutFetusG.$invalid && (vm.bwGain.bwWithoutFetusG.$dirty || vm.bwGain.$submitted)}"><label for="bwWithoutFetusG" class="span-label"><data-i18n i18n="_groups_bw_without_fetus_">Body weight without fetus</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="bwWithoutFetusG" name="bwWithoutFetusG" placeholder="{{\'_groups_bw_without_fetus_\'|i18n}}" ng-model="vm.group.bw_without_fetus" format-input-value="bw_without_fetus" required="" min="0" ng-max="vm.weight_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'bw_without_fetus\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_bw_without_fetus_required_">Body weight without fetus(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.nonPregnancyBC3BW.$invalid && (vm.bwGain.nonPregnancyBC3BW.$dirty || vm.bwGain.$submitted)}"><label for="nonPregnancyBC3BW" class="span-label"><data-i18n i18n="_groups_non_pregnant_bc3_bw_">Non-pregnant BC3 body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="nonPregnancyBC3BW" name="nonPregnancyBC3BW" placeholder="{{\'_groups_non_pregnant_bc3_bw_\'|i18n}}" ng-model="vm.group.non_pregnant_bc3_bw" format-input-value="non_pregnant_bc3_bw" required="" min="0" ng-max="vm.weight_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'non_pregnant_bc3_bw\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_non_pregnant_bc3_bw_required_">Non-pregnant BC3 body weight(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.matureBodyWeightG.$invalid && (vm.bwGain.matureBodyWeightG.$dirty || vm.bwGain.$submitted)}"><label for="matureBodyWeightG" class="span-label"><data-i18n i18n="_groups_mature_bw_">Mature body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="matureBodyWeightG" name="matureBodyWeightG" placeholder="{{\'_groups_mature_bw_\'|i18n}}" ng-model="vm.group.mature_bw" format-input-value="mature_bw" required="" min="0" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'mature_bw\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_mature_bw_required_">Mature body weight(0-2000) is reqired</data-i18n></span></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_daily_pregnancy_gain_">Daily pregnancy gain</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.daily_pregnancy_gain | formatViewValues: \'daily_pregnancy_gain\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_"></data-i18n></label></div></div></div></div></div><div class="col-md-6"><div class="panel"><div class="panel-heading"><data-i18n i18n="_groups_panel_target_frame_growth_">Target frame growth</data-i18n></div><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.bwGain.targetNPBC3BWG.$invalid && (vm.bwGain.targetNPBC3BWG.$dirty || vm.bwGain.$submitted)}"><label for="targetNPBC3BWG" class="span-label"><data-i18n i18n="_groups_target_non_pregnant_bc3_bw_">Non-pregnant BC3 body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetNPBC3BWG" name="targetNPBC3BWG" placeholder="{{\'_groups_target_non_pregnant_bc3_bw_\'|i18n}}" ng-model="vm.group.target_non_pregnant_bc3_bw" format-input-value="target_non_pregnant_bc3_bw" required="" min="0" ng-max="vm.weight_max" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'target_non_pregnant_bc3_bw\')" ng-disabled="vm.disableInput" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_non_pregnant_bc3_bw_required_">Non-pregnant BC3 body weight(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.daysTAFG.$invalid && (vm.bwGain.daysTAFG.$dirty || vm.bwGain.$submitted)}"><label for="daysTAFG" class="span-label"><data-i18n i18n="_groups_days_to_achieve_fg_">Days to achieve frame growth</data-i18n></label> <input type="number" class="form-control with-units" id="daysTAFG" name="daysTAFG" placeholder="{{\'_groups_days_to_achieve_fg_\'|i18n}}" ng-model="vm.group.days_to_achieve_fg" required="" min="0" max="1100" pattern="^\\d*(\\.\\d{0,3})?$" step="1" ng-change="vm.inputChanged(\'days_to_achieve_fg\')" ng-disabled="vm.disableInput" select-on-click=""><span><data-i18n i18n="_unit_days_">days</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_days_to_achieve_fg_required_">Days to achieve frame growth(0-1100) is reqired</data-i18n></span></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_target_frame_growth_">Target frame growth</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.target_frame_growth | formatViewValues: \'target_frame_growth\'}}&nbsp{{vm.weight}}</label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_target_daily_fg_">Target daily frame growth</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.target_daily_fg | formatViewValues: \'target_daily_fg\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div></div></div><div class="panel"><div class="panel-heading"><data-i18n i18n="_groups_panel_target_bc_gain_">Target body condition gain</data-i18n></div><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.bwGain.targetBCS.$invalid && (vm.bwGain.targetBCS.$dirty || vm.bwGain.$submitted)}"><label for="targetBCS" class="span-label"><data-i18n i18n="_groups_target_bc_score_">Target body condition score</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetBCS" name="targetBCS" placeholder="{{\'_groups_target_bc_score_\'|i18n}}" ng-model="vm.group.target_body_condition_score" required="" min="0" max="5" pattern="^\\d*(\\.\\d{0,3})?$" ng-change="vm.inputChanged(\'target_body_condition_score\')" ng-disabled="vm.disableInput" select-on-click=""><span></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_bc_score_required_">Target body condition score(0-5) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.daysTABC.$invalid && (vm.bwGain.daysTABC.$dirty || vm.bwGain.$submitted)}"><label for="daysTABC" class="span-label"><data-i18n i18n="_groups_days_to_achieve_bc_">Days to achieve body condition</data-i18n></label> <input type="number" class="form-control with-units" id="daysTABC" name="daysTABC" placeholder="{{\'_groups_days_to_achieve_bc_\'|i18n}}" ng-model="vm.group.days_to_achieve_bc" required="" min="0" max="1100" pattern="^\\d*(\\.\\d{0,3})?$" step="1" ng-change="vm.inputChanged(\'days_to_achieve_bc\')" ng-disabled="vm.disableInput" select-on-click=""><span><data-i18n i18n="_unit_days_">days</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_days_to_achieve_bc_required_">Days to achieve body condition(0-500) is reqired</data-i18n></span></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_target_bc_gain_">Target body condition gain</data-i18n>:</label></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label>{{vm.group.target_body_condition_gain | formatViewValues: \'target_body_condition_gain\'}}&nbsp{{vm.weight}}</label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_target_daily_bc_gain_">Target daily body condition gain</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.target_daily_bc_gain | formatViewValues: \'target_daily_bc_gain\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div></div></div></div></div><div class="row"><div class="col-md-6"><div class="panel"><div class="panel-body"><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_target_daily_bw_gain_">Target daily body weight gain</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.target_daily_bw_gain | formatViewValues: \'target_daily_bw_gain\'}}&nbsp{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div></div></div></div></div></form></ba-wizard-step><ba-wizard-step title="{{\'_groups_edit_group_step4_title_\'|i18n}}"><div align="right"><button type="button" class="btn btn-success" ng-click="vm.updateGroup()" ng-disabled="vm.basicInfoForm.$invalid == true || vm.animalInfoForm.$invalid == true || vm.bwGain.$invalid == true || vm.disableInput"><data-i18n i18n="_btn_update_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.closeEditWindow()"><data-i18n i18n="_btn_cancel_"></data-i18n></button></div><form class="form-horizontal" name="vm.finishForm" novalidate="" style="font-size: 16px; margin-top: 10px"><data-i18n i18n="_groups_edit_group_finish_message_">Group edited, save your work.</data-i18n></form></ba-wizard-step></ba-wizard><div ng-if="vm.editLoading || vm.loading" align="center"><div style="overflow: hidden"><div id="loading-animation-large" style="display: inline-block"></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/groups/groupDetails/groupDetails.html','<div class="panel-content" ng-if="!vm.detailsLoading && vm.selectedHerd"><h3 class="with-line"><data-i18n i18n="_groups_details_general_info_title_">General Informations</data-i18n></h3><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_group_name_">Name</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 wrap-text"><span>{{vm.details.name}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_title_herd_">Herd</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.herd_name}}</span></div></div></div></div><h3 class="with-line"><data-i18n i18n="_groups_details_animals_info_title_">Animal Informations</data-i18n></h3><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_no_animals_">Number of animals</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.number_of_animals}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_breed_">Animal Breed</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.breed.name}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_animal_type_">Animal Type</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.animal_type.name}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type!=\'heifer\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_cow_stage_">Animal Stage</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.cow_stage.name}}</span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_total_bw_">Total body weight</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.total_bw | formatViewValues: \'total_bw\'}} {{vm.weight}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_mature_bw_">Mature body weight</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.mature_bw | formatViewValues: \'mature_bw\'}} {{vm.weight}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'drycow/late_pregnant_heifer\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_bw_without_fetus_">Body weight without fetus</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.bw_without_fetus | formatViewValues: \'bw_without_fetus\'}} {{vm.weight}}</span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'lactating_cow\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_lactation_number_">Lactation number</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.lactation_number }}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'lactating_cow\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_days_in_milk_">Days in milk</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.days_in_milk | number:0}}<data-i18n i18n="_unit_days_">days</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'drycow/late_pregnant_heifer\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_upcoming_lactation_number_">Upcoming lactation number</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.upcoming_lactation_number }}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'drycow/late_pregnant_heifer\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_days_to_calving_">Days to calving</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.days_to_calving | number:0}}<data-i18n i18n=""></data-i18n>days</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'heifer\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_current_age_">Current age</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.current_age }}<data-i18n i18n="_unit_months_">months</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'heifer\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_age_">Target age</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_age | number:0}}<data-i18n i18n="_unit_months_">months</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_actual_dmi_per_cow_">Actual DMI per cow</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.actual_dmi | number:2}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'lactating_cow\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_farms_milk_price_">Farm\'s milk price</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.farms_milk_price | number:2}}</span></div></div></div></div><div class="row" ng-if="vm.group.animal_type.type==\'lactating_cow\'"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_milk_yield_">Target milk yield</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_milk_yield | formatViewValues: \'target_milk_yield\'}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_actual_milk_yield_">Actual milk yield</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.actual_milk_yield | formatViewValues: \'actual_milk_yield\'}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_fat_">Target fat</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_fat | number:2}} %</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_actual_fat_">Actual fat</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.actual_fat | number:2}} %</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_t_protein_">Target T Protein</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_t_protein | number:2}} %</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_actual_t_protein_">Actual T Protein</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.actual_t_protein | number:2}} %</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_lactose_">Target Lactose</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_lactose | number:2}} %</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_actual_lactose_">Actual Lactose</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.actual_lactose | number:2}} %</span></div></div></div></div><div class="row" ng-if="vm.group.animal_type.type==\'drycow/late_pregnant_heifer\'"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_dcad_strategy_">DCAD strategy</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.dcad_strategy.name }}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_dmi_adjustment_">DMI adjustment</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.dmi_adjustment | number:2}} %</span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_predicted_base_dmi_">Predicted base DMI</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.predicted_base_dmi | formatViewValues: \'predicted_base_dmi\'}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_predicted_adjusted_dmi_">Predicted adjusted DMI</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.predicted_adjusted_dmi | formatViewValues: \'predicted_adjusted_dmi\'}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_predicted_daily_gain_">Predicted daily gain</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.predicted_daily_gain | formatViewValues: \'predicted_daily_gain\'}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'heifer\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_required_nem_density_">Required NEm density</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.required_nem_density | formatViewValues: \'required_nem_density\'}} {{vm.energy}}/{{vm.weight}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type!=\'heifer\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_required_nel_density_">Required NEL density</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.required_nel_density | formatViewValues: \'required_nel_density\'}} {{vm.energy}}/{{vm.weight}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_required_me_density_">Required ME density</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.required_me_density | formatViewValues: \'required_me_density\'}} {{vm.energy}}/{{vm.weight}}</span></div></div></div></div><h3 class="with-line"><data-i18n i18n="_groups_details_gain_pregnancy_title_">Gain and pregnancy</data-i18n></h3><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_body_condition_score_">Body condition score</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.body_condition_score | number: 1}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_days_pregnant_">Days pregnant</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.days_pregnant | number:0}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'drycow/late_pregnant_heifer\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_bw_without_fetus_">Body weight without fetus</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.bw_without_fetus | formatViewValues: \'bw_without_fetus\'}} {{vm.weight}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_non_pregnant_bc3_bw_">Non pregnant BC3 body weight</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.non_pregnant_bc3_bw | formatViewValues: \'non_pregnant_bc3_bw\'}} {{vm.weight}}</span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_daily_pregnancy_gain_">Daily pregnancy gain</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.daily_pregnancy_gain | formatViewValues: \'daily_pregnancy_gain\'}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_non_pregnant_bc3_bw_">Target non pregnant BC3 body weight</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_non_pregnant_bc3_bw | formatViewValues: \'target_non_pregnant_bc3_bw\'}} {{vm.weight}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_days_to_achieve_fg_">Days to achieve frame growth</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.days_to_achieve_fg| number:0}}<data-i18n i18n="_unit_days_">days</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_frame_growth_">Target frame growth</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_frame_growth | formatViewValues: \'target_frame_growth\'}} {{vm.weight}}</span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_daily_fg_">Target daily frame growth</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_daily_fg | formatViewValues: \'target_daily_fg\'}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_bc_score_">Target body condition score</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_body_condition_score | number: 1}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_days_to_achieve_bc_">Days to achieve body condition</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.days_to_achieve_bc| number:0}}<data-i18n i18n="_unit_days_">days</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_panel_target_bc_gain_">Target body condition gain</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_body_condition_gain | formatViewValues: \'target_body_condition_gain\'}} {{vm.weight}}</span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_daily_bc_gain_">Target daily body condition gain</data-i18n></label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_daily_bc_gain | formatViewValues: \'target_daily_bc_gain\'}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_daily_bw_gain_">Target daily body weight gain</data-i18n></label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_daily_bw_gain | formatViewValues: \'target_daily_bw_gain\'}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div></div><div align="right"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="vm.closeDetailsWindow()"><data-i18n i18n="_btn_hide_">Hide</data-i18n></button></div></div><div ng-if="vm.detailsLoading" align="center"><div style="overflow: hidden"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/groups/groupHistory/groupHistory.details.html','<div class="panel-content" ng-if="!vm.detailsLoading"><h3 class="with-line"><data-i18n i18n="_groups_details_general_info_title_">General Informations</data-i18n></h3><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_group_name_">Name</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 wrap-text"><span>{{vm.details.name}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_title_herd_">Herd</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.herd_name}}</span></div></div></div></div><h3 class="with-line"><data-i18n i18n="_groups_details_animals_info_title_">Animal Informations</data-i18n></h3><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_no_animals_">Number of animals</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.number_of_animals}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_breed_">Animal Breed</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.breed.name}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_animal_type_">Animal Type</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.animal_type.name}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type!=\'heifer\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_cow_stage_">Animal Stage</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.cow_stage.name}}</span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_total_bw_">Total body weight</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.total_bw | formatViewValues: \'total_bw\'}} {{vm.weight}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_mature_bw_">Mature body weight</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.mature_bw | formatViewValues: \'mature_bw\'}} {{vm.weight}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'drycow/late_pregnant_heifer\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_bw_without_fetus_">Body weight without fetus</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.bw_without_fetus | formatViewValues: \'bw_without_fetus\'}} {{vm.weight}}</span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'lactating_cow\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_lactation_number_">Lactation number</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.lactation_number }}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'lactating_cow\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_days_in_milk_">Days in milk</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.days_in_milk | number:0}}<data-i18n i18n="_unit_days_">days</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'drycow/late_pregnant_heifer\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_upcoming_lactation_number_">Upcoming lactation number</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.upcoming_lactation_number }}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'drycow/late_pregnant_heifer\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_days_to_calving_">Days to calving</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.days_to_calving | number:0}}<data-i18n i18n=""></data-i18n>days</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'heifer\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_current_age_">Current age</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.current_age }}<data-i18n i18n="_unit_months_">months</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'heifer\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_age_">Target age</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_age | number:0}}<data-i18n i18n="_unit_months_">months</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_actual_dmi_per_cow_">Actual DMI per cow</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.actual_dmi | number:2}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'lactating_cow\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_farms_milk_price_">Farm\'s milk price</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.farms_milk_price | number:2}}</span></div></div></div></div><div class="row" ng-if="vm.group.animal_type.type==\'lactating_cow\'"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_milk_yield_">Target milk yield</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_milk_yield | formatViewValues: \'target_milk_yield\'}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_actual_milk_yield_">Actual milk yield</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.actual_milk_yield | formatViewValues: \'actual_milk_yield\'}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_fat_">Target fat</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_fat | number:2}} %</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_actual_fat_">Actual fat</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.actual_fat | number:2}} %</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_t_protein_">Target T Protein</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_t_protein | number:2}} %</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_actual_t_protein_">Actual T Protein</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.actual_t_protein | number:2}} %</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_lactose_">Target Lactose</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_lactose | number:2}} %</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_actual_lactose_">Actual Lactose</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.actual_lactose | number:2}} %</span></div></div></div></div><div class="row" ng-if="vm.group.animal_type.type==\'drycow/late_pregnant_heifer\'"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_dcad_strategy_">DCAD strategy</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.dcad_strategy.name }}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_dmi_adjustment_">DMI adjustment</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.dmi_adjustment | number:2}} %</span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_predicted_base_dmi_">Predicted base DMI</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.predicted_base_dmi | formatViewValues: \'predicted_base_dmi\'}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_predicted_adjusted_dmi_">Predicted adjusted DMI</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.predicted_adjusted_dmi | formatViewValues: \'predicted_adjusted_dmi\'}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_predicted_daily_gain_">Predicted daily gain</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.predicted_daily_gain | formatViewValues: \'predicted_daily_gain\'}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'heifer\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_required_nem_density_">Required NEm density</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.required_nem_density | formatViewValues: \'required_nem_density\'}} {{vm.energy}}/{{vm.weight}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type!=\'heifer\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_required_nel_density_">Required NEL density</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.required_nel_density | formatViewValues: \'required_nel_density\'}} {{vm.energy}}/{{vm.weight}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_required_me_density_">Required ME density</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.required_me_density | formatViewValues: \'required_me_density\'}} {{vm.energy}}/{{vm.weight}}</span></div></div></div></div><h3 class="with-line"><data-i18n i18n="_groups_details_gain_pregnancy_title_">Gain and pregnancy</data-i18n></h3><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_body_condition_score_">Body condition score</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.body_condition_score | number:0}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_days_pregnant_">Days pregnant</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.days_pregnant | number:0}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12" ng-if="vm.group.animal_type.type==\'drycow/late_pregnant_heifer\'"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_bw_without_fetus_">Body weight without fetus</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.bw_without_fetus | formatViewValues: \'bw_without_fetus\'}} {{vm.weight}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_non_pregnant_bc3_bw_">Non pregnant BC3 body weight</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.non_pregnant_bc3_bw | formatViewValues: \'non_pregnant_bc3_bw\'}} {{vm.weight}}</span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_daily_pregnancy_gain_">Daily pregnancy gain</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.daily_pregnancy_gain | formatViewValues: \'daily_pregnancy_gain\'}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_non_pregnant_bc3_bw_">Target non pregnant BC3 body weight</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_non_pregnant_bc3_bw | formatViewValues: \'target_non_pregnant_bc3_bw\'}} {{vm.weight}}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_days_to_achieve_fg_">Days to achieve frame growth</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.days_to_achieve_fg| number:0}}<data-i18n i18n="_unit_days_">days</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_frame_growth_">Target frame growth</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_frame_growth | formatViewValues: \'target_frame_growth\'}} {{vm.weight}}</span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_daily_fg_">Target daily frame growth</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_daily_fg | formatViewValues: \'target_daily_fg\'}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_bc_score_">Target body condition score</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_body_condition_score }}</span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_days_to_achieve_bc_">Days to achieve body condition</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.days_to_achieve_bc| number:0}}<data-i18n i18n="_unit_days_">days</data-i18n></span></div></div></div><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_panel_target_bc_gain_">Target body condition gain</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_body_condition_gain | formatViewValues: \'target_body_condition_gain\'}} {{vm.weight}}</span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_daily_bc_gain_">Target daily body condition gain</data-i18n></label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_daily_bc_gain | formatViewValues: \'target_daily_bc_gain\'}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div></div><div class="row"><div class="col-xlg-3 col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_target_daily_bw_gain_">Target daily body weight gain</data-i18n></label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.target_daily_bw_gain | formatViewValues: \'target_daily_bw_gain\'}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div></div></div></div><div align="right"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="vm.hideHistory()"><data-i18n i18n="_btn_hide_">Hide</data-i18n></button></div></div><div ng-if="vm.detailsLoading" align="center"><div style="overflow: hidden"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/groups/groupHistory/groupHistory.html','<div class="widgets"><div class="row" ng-if="vm.selectedHerd"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/groups/groupHistory/groupHistory.table.html"></div></div></div></div><div class="row" ng-if="vm.showDetails && vm.selectedHerd"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/groups/groupHistory/groupHistory.details.html"></div></div></div></div></div><div ba-panel="" ng-if="!vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div>');
$templateCache.put('app/pages/groups/groupHistory/groupHistory.table.html','<div ng-if="!vm.loading" class="vertical-scroll group-history"><button ng-if="vm.selectedHerd" type="button" class="btn btn-primary btn-xs" ng-click="vm.goBack()" style="margin: 10px"><i class="ion-arrow-left-c"><data-i18n i18n="_btn_back_">back</data-i18n></i></button><table ng-if="vm.selectedHerd" class="table table-hover" st-table="vm.groups"><thead><tr class="sortable"><th></th><th style="min-width: 250px" st-sort="last_modified_user"><data-i18n i18n="_title_user_">user</data-i18n><br></th><th style="min-width: 150px" st-sort="last_modified_date"><data-i18n i18n="_title_last_modified_date_">last modified date</data-i18n><br></th><th style="min-width: 150px" st-sort="create_date"><data-i18n i18n="_title_create_date">create date</data-i18n><br></th><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br></th></tr></thead><tbody><tr ng-repeat="group in vm.groups" ng-class="{\'tr-highlight\':$index == vm.selectedGroup}"><td ng-click="vm.getDetails(group.id, $index)"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.getDetails(group.id, $index)"><i class="ion-clipboard"></i></button></td><td>{{group.last_modified_user}}</td><td>{{group.last_modified_date | date:\'medium\'}}</td><td>{{group.create_date | date:\'medium\'}}</td><td>{{group.action}}</td></tr></tbody></table><div ng-if="!vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div></div><div ng-if="vm.loading" align="center"><div style="overflow: hidden"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/herds/addNewHerd/addNewHerd.html','<div ba-panel="" class="ng-cloak"><div class="panel-group" ng-if="vm.selectedTeam"><form name="vm.herdForm" novalidate="" ng-if="!vm.loading"><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.herdForm.herd_name.$invalid && (vm.herdForm.herd_name.$dirty || vm.herdForm.$submitted)}"><label for="herd_name"><data-i18n i18n="_groups_herd_name_">Herd name</data-i18n></label> <input type="text" maxlength="60" class="form-control" id="herd_name" name="herd_name" placeholder="{{\'_groups_herd_name_\'|i18n}}" ng-model="vm.herdDTO.Name" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_herd_name_required_">herd name is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.herdForm.street_address.$invalid && (vm.herdForm.street_address.$dirty || vm.herdForm.$submitted)}"><label for="street_address"><data-i18n i18n="_title_street_address_">Street address</data-i18n></label> <input type="text" class="form-control" id="street_address" name="street_address" placeholder="{{\'_title_street_address_\'|i18n}}" ng-model="vm.herdDTO.Address.Street" required=""><span class="help-block error-block basic-block"><data-i18n i18n="_title_street_address_required_">street address is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group"><label for="street_name_2"><data-i18n i18n="_title_street_address_2_">Street address 2</data-i18n></label> <input type="text" class="form-control" id="street_name_2" placeholder="{{\'_title_street_address_2_\'|i18n}}" ng-model="vm.herdDTO.Address.street_address_2"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.herdForm.zip.$invalid && (vm.herdForm.zip.$dirty || vm.herdForm.$submitted)}"><label for="zip"><data-i18n i18n="_zip_postal_code_">Zip / postal code</data-i18n></label> <input type="text" class="form-control" id="zip" name="zip" placeholder="{{\'_zip_postal_code_\'|i18n}}" ng-model="vm.herdDTO.Address.Zip" required=""><span class="help-block error-block basic-block"><data-i18n i18n="_zip_postal_code_required_">zip / postal code is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.herdForm.city.$invalid && (vm.herdForm.city.$dirty || vm.herdForm.$submitted)}"><label for="city"><data-i18n i18n="_title_city_">City</data-i18n></label> <input type="text" class="form-control" id="city" name="city" placeholder="{{\'_title_city_\'|i18n}}" ng-model="vm.herdDTO.Address.City" required=""><span class="help-block error-block basic-block"><data-i18n i18n="_title_city_required_">city is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.herdForm.country.$invalid && (vm.herdForm.country.$dirty || vm.herdForm.$submitted)}"><label for="feed_name"><data-i18n i18n="_title_country_">Country</data-i18n></label><select class="form-control dropdown-toggle category-iteam category-select" id="country" name="country" ng-model="vm.herdDTO.Address.CountryCode" required=""><option value="">{{vm.selectPlaceholder | i18n}}</option><option value="USA">United States</option><option value="CAN">Canada</option><option value="AFG">Afghanistan</option><option value="ALB">Albania</option><option value="DZA">Algeria</option><option value="ASM">American Samoa</option><option value="AND">Andorra</option><option value="AGO">Angola</option><option value="AIA">Anguilla</option><option value="ATA">Antarctica</option><option value="ATG">Antigua and Barbuda</option><option value="ARG">Argentina</option><option value="ARM">Armenia</option><option value="ABW">Aruba</option><option value="AUS">Australia</option><option value="AUT">Austria</option><option value="AZE">Azerbaijan</option><option value="BHS">Bahamas</option><option value="BHR">Bahrain</option><option value="BGD">Bangladesh</option><option value="BRB">Barbados</option><option value="BLR">Belarus</option><option value="BEL">Belgium</option><option value="BLZ">Belize</option><option value="BEN">Benin</option><option value="BMU">Bermuda</option><option value="BTN">Bhutan</option><option value="BOL">Bolivia</option><option value="BIH">Bosnia and Herzegowina</option><option value="BWA">Botswana</option><option value="BVT">Bouvet Island</option><option value="BRA">Brazil</option><option value="IOT">British Indian Ocean Territory</option><option value="BRN">Brunei Darussalam</option><option value="BGR">Bulgaria</option><option value="BFA">Burkina Faso</option><option value="BDI">Burundi</option><option value="KHM">Cambodia</option><option value="CMR">Cameroon</option><option value="CPV">Cape Verde</option><option value="CYM">Cayman Islands</option><option value="CAF">Central African Republic</option><option value="TCD">Chad</option><option value="CHL">Chile</option><option value="CHN">China</option><option value="CXR">Christmas Island</option><option value="CCK">Cocos (Keeling) Islands</option><option value="COL">Colombia</option><option value="COM">Comoros</option><option value="COG">Congo</option><option value="COK">Cook Islands</option><option value="CRI">Costa Rica</option><option value="CIV">Cote D&#39;Ivoire</option><option value="HRV">Croatia</option><option value="CUB">Cuba</option><option value="CYP">Cyprus</option><option value="CZE">Czech Republic</option><option value="DNK">Denmark</option><option value="DJI">Djibouti</option><option value="DMA">Dominica</option><option value="DOM">Dominican Republic</option><option value="ECU">Ecuador</option><option value="EGY">Egypt</option><option value="SLV">El Salvador</option><option value="GNQ">Equatorial Guinea</option><option value="ERI">Eritrea</option><option value="EST">Estonia</option><option value="ETH">Ethiopia</option><option value="FLK">Falkland Islands (Malvinas)</option><option value="FRO">Faroe Islands</option><option value="FJI">Fiji</option><option value="FIN">Finland</option><option value="FRA">France</option><option value="GUF">French Guiana</option><option value="PYF">French Polynesia</option><option value="ATF">French Southern Territories</option><option value="GAB">Gabon</option><option value="GMB">Gambia</option><option value="GEO">Georgia</option><option value="DEU">Germany</option><option value="GHA">Ghana</option><option value="GIB">Gibraltar</option><option value="GRC">Greece</option><option value="GRL">Greenland</option><option value="GRD">Grenada</option><option value="GLP">Guadeloupe</option><option value="GUM">Guam</option><option value="GTM">Guatemala</option><option value="GIN">Guinea</option><option value="GNB">Guinea-bissau</option><option value="GUY">Guyana</option><option value="HTI">Haiti</option><option value="HMD">Heard and Mc Donald Islands</option><option value="HND">Honduras</option><option value="HKG">Hong Kong</option><option value="HUN">Hungary</option><option value="ISL">Iceland</option><option value="IND">India</option><option value="IDN">Indonesia</option><option value="IRN">Iran (Islamic Republic of)</option><option value="IRQ">Iraq</option><option value="IRL">Ireland</option><option value="ISR">Israel</option><option value="ITA">Italy</option><option value="JAM">Jamaica</option><option value="JPN">Japan</option><option value="JOR">Jordan</option><option value="KAZ">Kazakhstan</option><option value="KEN">Kenya</option><option value="KIR">Kiribati</option><option value="KOR">Korea</option><option value="PRK">Korea, Democratic People&#39;s Republic of</option><option value="KWT">Kuwait</option><option value="KGZ">Kyrgyzstan</option><option value="LAO">Lao People&#39;s Democratic Republic</option><option value="LVA">Latvia</option><option value="LBN">Lebanon</option><option value="LSO">Lesotho</option><option value="LBR">Liberia</option><option value="LBY">Libyan Arab Jamahiriya</option><option value="LIE">Liechtenstein</option><option value="LTU">Lithuania</option><option value="LUX">Luxembourg</option><option value="MAC">Macau</option><option value="MKD">Macedonia</option><option value="MDG">Madagascar</option><option value="MWI">Malawi</option><option value="MYS">Malaysia</option><option value="MDV">Maldives</option><option value="MLI">Mali</option><option value="MLT">Malta</option><option value="MHL">Marshall Islands</option><option value="MTQ">Martinique</option><option value="MRT">Mauritania</option><option value="MUS">Mauritius</option><option value="MYT">Mayotte</option><option value="MEX">Mexico</option><option value="FSM">Micronesia</option><option value="MDA">Moldova</option><option value="MCO">Monaco</option><option value="MNG">Mongolia</option><option value="MNE">Montenegro</option><option value="MSR">Montserrat</option><option value="MAR">Morocco</option><option value="MOZ">Mozambique</option><option value="MMR">Myanmar</option><option value="NAM">Namibia</option><option value="NRU">Nauru</option><option value="NPL">Nepal</option><option value="NLD">Netherlands</option><option value="ANT">Netherlands Antilles</option><option value="NCL">New Caledonia</option><option value="NZL">New Zealand</option><option value="NIC">Nicaragua</option><option value="NER">Niger</option><option value="NGA">Nigeria</option><option value="NIU">Niue</option><option value="NFK">Norfolk Island</option><option value="MNP">Northern Mariana Islands</option><option value="NOR">Norway</option><option value="OMN">Oman</option><option value="PAK">Pakistan</option><option value="PLW">Palau</option><option value="PAN">Panama</option><option value="PNG">Papua New Guinea</option><option value="PRY">Paraguay</option><option value="PER">Peru</option><option value="PHL">Philippines</option><option value="PCN">Pitcairn</option><option value="POL">Poland</option><option value="PRT">Portugal</option><option value="PRI">Puerto Rico</option><option value="QAT">Qatar</option><option value="REU">Reunion</option><option value="ROM">Romania</option><option value="RUS">Russia</option><option value="RWA">Rwanda</option><option value="KNA">Saint Kitts and Nevis</option><option value="LCA">Saint Lucia</option><option value="VCT">Saint Vincent and the Grenadines</option><option value="WSM">Samoa</option><option value="SMR">San Marino</option><option value="STP">Sao Tome and Principe</option><option value="SAU">Saudi Arabia</option><option value="SEN">Senegal</option><option value="SRB">Serbia</option><option value="SYC">Seychelles</option><option value="SLE">Sierra Leone</option><option value="SGP">Singapore</option><option value="SVK">Slovakia (Slovak Republic)</option><option value="SVN">Slovenia</option><option value="SLB">Solomon Islands</option><option value="SOM">Somalia</option><option value="ZAF">South Africa</option><option value="SGS">South Georgia &amp; South Sandwich Islands</option><option value="ESP">Spain</option><option value="LKA">Sri Lanka</option><option value="SHN">St. Helena</option><option value="SPM">St. Pierre and Miquelon</option><option value="SDN">Sudan</option><option value="SUR">Suriname</option><option value="SJM">Svalbard and Jan Mayen Islands</option><option value="SWZ">Swaziland</option><option value="SWE">Sweden</option><option value="CHE">Switzerland</option><option value="SYR">Syrian Arab Republic</option><option value="TWN">Taiwan</option><option value="TJK">Tajikistan</option><option value="TZA">Tanzania</option><option value="THA">Thailand</option><option value="TGO">Togo</option><option value="TKL">Tokelau</option><option value="TON">Tonga</option><option value="TTO">Trinidad and Tobago</option><option value="TUN">Tunisia</option><option value="TUR">Turkey</option><option value="TKM">Turkmenistan</option><option value="TCA">Turks and Caicos Islands</option><option value="TUV">Tuvalu</option><option value="UGA">Uganda</option><option value="UKR">Ukraine</option><option value="ARE">United Arab Emirates</option><option value="GBR">United Kingdom</option><option value="UMI">United States minor outlying islands</option><option value="URY">Uruguay</option><option value="UZB">Uzbekistan</option><option value="VUT">Vanuatu</option><option value="VAT">Vatican City State (Holy See)</option><option value="VEN">Venezuela</option><option value="VNM">Viet Nam</option><option value="VGB">Virgin Islands (British)</option><option value="VIR">Virgin Islands (U.S.)</option><option value="WLF">Wallis and Futuna Islands</option><option value="ESH">Western Sahara</option><option value="YEM">Yemen</option><option value="ZMB">Zambia</option><option value="ZWE">Zimbabwe</option></select><span class="help-block error-block basic-block"><data-i18n i18n="_title_country_required">country is required</data-i18n></span></div></div></div><div align="right"><button type="submit" class="btn btn-success" ng-click="vm.addNewHerd()"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></form><div align="center" ng-if="vm.loading" style="overflow: hidden"><div id="loading-animation-large"></div></div></div><div ng-if="!vm.selectedTeam" align="center"><div><h3><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></h3></div></div></div>');
$templateCache.put('app/pages/groups/myGroups/deleteGroup.modal.html','<div class="modal-content"><div class="modal-header" ng-if="!vm.modalLoading"><div align="center"><span class="ion-android-warning warningModal" style="font-size: 36px"></span></div><div align="center"><span class="warningModal"><data-i18n i18n="_groups_delete_warning_message_">Warning message</data-i18n></span></div></div><div class="modal-body" ng-if="!vm.modalLoading"><div align="center"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="vm.deleteGroupProceed()"><data-i18n i18n="_btn_delete_">Delete</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px; overflow: hidden"><div id="loading-animation-large" style="display: inline-block"></div></div></div></div>');
$templateCache.put('app/pages/groups/myGroups/myGroups.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/groups/myGroups/myGroups.table.html"></div></div></div></div><div class="row" ng-if="vm.showDetails && vm.selectedHerd"><div class="col-lg-12 col-md-12"><div ng-if="!vm.groupError" ba-panel="" ba-panel-title="{{\'_groups_details_title_\'|i18n}}" ba-panel-class="with-scroll"><div include-with-scope="app/pages/groups/groupDetails/groupDetails.html"></div></div></div></div><div class="row" ng-if="vm.showEdit && vm.selectedHerd"><div class="col-lg-12 col-md-12"><div ng-if="!vm.groupError" ba-panel="" ba-panel-title="{{\'_groups_edit_\'|i18n}}" ba-panel-class="with-scroll"><div include-with-scope="app/pages/groups/editGroup/editGroup.html"></div></div></div></div></div>');
$templateCache.put('app/pages/groups/myGroups/myGroups.table.html','<div class="horizontal-scroll group-history" ng-if="!vm.loading && !vm.loadingTable"><table class="table" st-table="vm.groups" st-safe-src="vm.groupsSafe" ng-if="vm.selectedHerd" style="font-size: 14px"><thead><tr class="sortable"><th style="min-width: 100px"><data-i18n i18n="_title_column_action_">action</data-i18n></th><th style="min-width: 200px" st-sort="name"><data-i18n i18n="_groups_group_name_">group name</data-i18n></th><th style="min-width: 200px" st-sort="herd_name"><data-i18n i18n="_groups_herd_name_">herd name</data-i18n></th><th style="min-width: 200px" st-sort="number_of_animals"><data-i18n i18n="_groups_no_animals_">number of animals</data-i18n></th><th style="min-width: 200px" st-sort="breed.name"><data-i18n i18n="_groups_breed_">breed</data-i18n></th><th style="min-width: 200px" st-sort="type.name"><data-i18n i18n="_groups_type_">type</data-i18n></th><th style="min-width: 200px"><data-i18n i18n="_remove_group_">Remove group</data-i18n></th></tr><tr><th></th><th><input st-search="name" placeholder="{{\'_search_placeholder_group_name_\' | i18n }}" class="input-sm form-control search-input" type="search"></th><th><input st-search="herd_name" placeholder="{{\'_search_placeholder_herd_name_\' | i18n }}" class="input-sm form-control search-input" type="search"></th><th><input st-search="number_of_animals" placeholder="{{\'_search_placeholder_number_of_animals_\' | i18n }}" class="input-sm form-control search-input" type="search"></th><th><input st-search="breed.name" placeholder="{{\'_search_placeholder_breed_name_\' | i18n }}" class="input-sm form-control search-input" type="search"></th><th><input st-search="type.name" placeholder="{{\'_search_placeholder_animal_type_\' | i18n }}" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody ng-if="!vm.loadingTable"><tr ng-repeat="group in vm.groups" ng-class="vm.selectedGroupIndex == $index ? \'tr-highlight\': \'\'"><td><button type="button" class="btn btn-primary btn-xs" uib-tooltip="{{\'_tips_history_\' | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-click="vm.goToHistory(group.id)"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editGroup(group.id, $index)" uib-tooltip="{{\'_tips_edit_\' | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.groupDetails(group.id, $index)" uib-tooltip="{{\'_tips_details_\' | i18n}}" tooltip-is-open="detailsIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clipboard"></i></button></td><td class="shorten-long-text" uib-tooltip="{{group.name}}" tooltip-enable="{{group.name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{group.name}}</td><td>{{group.herd_name}}</td><td>{{group.number_of_animals}}</td><td>{{group.breed.name}}</td><td>{{group.type.name}}</td><td><button type="button" class="btn btn-danger btn-xs" ng-click="vm.deleteGroup(group, $index)"><data-i18n i18n="_btn_delete_">delete</data-i18n></button></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="vm.itemsPerPage" st-displayed-pages="5"></div></td></tr><tr ng-if="vm.itemsPerPageValues.length > 0"><td colspan="7" class="text-left"><div class="form-group select-page-size-wrap dropup" ng-class="vm.itemsPerPageValues.length == 4 ? \'exended-1\' : (vm.itemsPerPageValues.length == 5 ? \'exended-2\' : \'\')"><label><data-i18n i18n="_title_rows_on_page_">rows on page</data-i18n><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="vm.itemsPerPage" ng-options="i for i in vm.itemsPerPageValues"></select></label></div></td></tr></tfoot></table><div ng-if="!vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div></div><div ng-if="vm.loading || vm.loadingTable" align="center"><div style="overflow: hidden"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/ingredientsManagement/addNewIngredient/addNewIngredient.html','<div ba-panel="" class="ng-cloak"><div class="panel-group" ng-if="vm.selectedHerd"><form name="vm.ingredientForm" novalidate="" ng-if="!vm.loading"><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.ingredientForm.name.$invalid && (vm.ingredientForm.name.$dirty || vm.ingredientForm.$submitted)}"><label for="name"><data-i18n i18n="_m_f_i_m_ingredient_name_">name</data-i18n></label> <input type="text" maxlength="60" class="form-control" id="name" name="name" placeholder="{{\'_m_f_i_m_ingredient_name_\'|i18n}}" ng-model="vm.ingredient.name" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_label_name_required_">name is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.ingredientForm.feed_type.$invalid && (vm.ingredientForm.feed_type.$dirty || vm.ingredientForm.$submitted)}"><label for="feed_type"><data-i18n i18n="_label_type_">Type</data-i18n></label><ui-select ng-model="vm.selected_type" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" required="" id="feed_type" name="feed_type"><ui-select-match placeholder="{{\'_picker_feed_type_placeholder_\'|i18n}}"><span>{{$select.selected.show_name}}</span></ui-select-match><ui-select-choices repeat="feed_type in vm.feed_types | filter: $select.search"><span ng-bind-html="feed_type.show_name"></span></ui-select-choices></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_toastr_feeds_type_required_">feed type is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.ingredientForm.location_name.$invalid && (vm.ingredientForm.location_name.$dirty || vm.ingredientForm.$submitted)}"><label for="location_name"><data-i18n i18n="_m_f_i_m_ingredient_location_">location</data-i18n></label> <input type="text" class="form-control" id="location_name" name="location_name" placeholder="{{\'_m_f_i_m_ingredient_location_name\'|i18n}}" ng-model="vm.ingredient.location_name" required=""><span class="help-block error-block basic-block"><data-i18n i18n="_label_location_required_">location is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.ingredientForm.ingredient_dm.$invalid && (vm.ingredientForm.ingredient_dm.$dirty || vm.ingredientForm.$submitted)}"><label for="dm">%&nbsp;<data-i18n i18n="_feeds_dm_">DM %</data-i18n></label> <input type="number" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" min="0.01" max="100" class="form-control" placeholder="{{(\'_btn_feed_insert_\' | i18n) + (\' \') + (\'_feeds_dm_\' | i18n)}}" ng-model="vm.ingredient.dm" id="ingredient_dm" name="ingredient_dm" required=""><span class="help-block error-block basic-block"><data-i18n i18n="_m_f_label_dm_required_">DM % is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.ingredientForm.ingredient_address.$invalid && (vm.ingredientForm.ingredient_address.$dirty || vm.ingredientForm.$submitted)}"><label for="address"><data-i18n i18n="_label_address_">address</data-i18n></label> <input type="text" class="form-control" placeholder="{{\'_label_address_\'|i18n}}" ng-model="vm.ingredient.address" id="ingredient_address" name="ingredient_address" required=""><span class="help-block error-block basic-block"><data-i18n i18n="_m_f_label_address_required_">address is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6 ingredient-current-quantity"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.ingredientForm.current_quantity.$invalid && (vm.ingredientForm.current_quantity.$dirty || vm.ingredientForm.$submitted)}"><label for="current_quantity"><data-i18n i18n="_label_current_quantity_">current quantity</data-i18n></label> <input type="number" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" class="form-control" id="current_quantity" name="current_quantity" format-input-value="current_quantity" placeholder="{{\'_label_current_quantity_\'|i18n}}" ng-model="vm.ingredient.current_quantity" required="" min="0"><span class="help-block error-block basic-block"><data-i18n i18n="_label_current_quantity_required_">current quantity is required</data-i18n></span></div><div><span>{{vm.weight}}</span> <span><i ng-class="vm.unit_icon == \'toggle_off\' ? \'ion-toggle-filled flip primaryModal\' : \'ion-toggle-filled primaryModal\'" ng-click="vm.changeUnit()"></i></span> <span><data-i18n ng-if="vm.settings.use_kgs" i18n="_m_f_wagons_tonnes_">Tonnes</data-i18n><data-i18n ng-if="!vm.settings.use_kgs" i18n="_m_f_wagons_imperial_tonnes_">Tonnes</data-i18n></span></div></div></div><div align="right"><button type="submit" class="btn btn-success" ng-click="vm.addNewIngredient()"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></form><div align="center" ng-if="vm.loading" style="overflow: hidden"><div id="loading-animation-large"></div></div></div><div ng-if="!vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div></div>');
$templateCache.put('app/pages/herds/myHerds/interface.modal.html','<div><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right; font-size: 20px" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.loadingInterfaceModal"><div class="interface-block" ng-if="!vm.interfaceModalError"><div class="header"><img src="assets/img/fodjan_logo.svg"></div><div class="body"><div class="g-token" ng-if="!vm.staticToken"><button class="btn btn-sm btn-primary" ng-click="vm.generateToken()"><data-i18n i18n="_btn_generate_token_">Generate token</data-i18n></button></div><div ng-if="vm.staticToken && vm.token" class="token-wrapper" style="text-align: center"><span class="token" id="token">{{vm.token}}</span><span><a class="ion-ios-copy-outline copy-icon" ng-click="vm.copyToClipboard()"></a></span><div class="description"><data-i18n i18n="_m_f_fodjan_token_generated_message_">Use generated token to link to Fodjan. Make sure to copy your token. You won\'t be able to see it again!</data-i18n></div></div><div ng-if="vm.staticToken && !vm.token" class="g-token"><span><data-i18n i18n="_m_f_fodjan_token_generated_">Token generated</data-i18n>:</span><span style="margin-left: 5px">{{vm.staticToken.create_date | date: \'shortDate\'}}</span><span style="margin-left: 5px; margin-right: 25px; line-break: anywhere;">({{vm.staticToken.last_modified_user}})</span> <button class="btn btn-sm btn-primary" ng-click="vm.regenerateToken()"><data-i18n i18n="_btn_regenerate_token_">Regenerate token</data-i18n></button></div></div></div><div class="error-block" ng-if="vm.interfaceModalError || vm.errorDeletingToken || vm.errorGeneratingToken" style="text-align: right; margin-top: 3px"><span class="color-red"><data-i18n i18n="_toastr_error_occured_">Error occurred, please try again.</data-i18n></span></div></div><div class="modal-body" ng-if="vm.loadingInterfaceModal"><div style="text-align: center"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/herds/myHerds/myHerds.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/herds/myHerds/myHerds.table.html"></div></div></div></div></div>');
$templateCache.put('app/pages/herds/myHerds/myHerds.table.html','<div class="horizontal-scroll" ng-if="!vm.loading && !vm.loadingTable"><table class="table table-hover" st-table="vm.herds" st-safe-src="vm.herdsSafe" ng-if="vm.selectedTeam" style="font-size: 14px"><thead><tr class="sortable"><th style="min-width: 400px" st-sort-default="true" st-sort="Name" align="left"><data-i18n i18n="_groups_herd_name_">herd name</data-i18n></th><th style="min-width: 300px" st-sort="Email"><data-i18n i18n="_title_column_email_">email</data-i18n></th><th></th><th ng-if="vm.showLinkIcon"></th></tr><tr><th><input st-search="Name" placeholder="{{\'_search_placeholder_herd_name_\' | i18n }}" class="input-sm form-control search-input" type="search"></th><th><input st-search="Email" placeholder="{{\'_search_placeholder_email_\' | i18n }}" class="input-sm form-control search-input" type="search"></th><th></th><th ng-if="vm.showLinkIcon"></th></tr></thead><tbody ng-if="!vm.loadingTable"><tr ng-repeat="herd in vm.herds" ng-click="vm.setAsDefault(herd, $index)"><td style="padding: 4px 5px" align="left">{{herd.Name}}</td><td style="padding: 4px 5px">{{herd.Email}}</td><td style="padding: 4px 5px" align="center"><a class="ion-star icon-edit green-icon" href="" style="margin-right: 5px" ng-if="herd.isDefault"></a> <a class="ion-ios-star-outline icon-edit green-icon" href="" uib-tooltip="{{\'_tips_set_as_default_herd_\' | i18n}}" tooltip-is-open="tooltipIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" style="margin-right: 5px" ng-if="!herd.isDefault"></a></td><td style="padding: 4px 5px" align="center" ng-if="vm.showLinkIcon"><a class="ion-link icon-edit green-icon" href="" uib-tooltip="Link to Fodjan" tooltip-is-open="tooltip2IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" style="margin-right: 5px; font-size: 24px" ng-click="vm.openInterface(herd); $event.stopPropagation()"></a></td></tr></tbody><tfoot><tr><td colspan="{{vm.numberOfColumns}}" class="text-center"><div st-pagination="" st-items-by-page="vm.itemsPerPage" st-displayed-pages="5"></div></td></tr><tr ng-if="vm.itemsPerPageValues.length > 0"><td colspan="{{vm.numberOfColumns}}" class="text-left"><div class="form-group select-page-size-wrap dropup" ng-class="vm.itemsPerPageValues.length == 4 ? \'exended-1\' : (vm.itemsPerPageValues.length == 5 ? \'exended-2\' : \'\')"><label><data-i18n i18n="_title_rows_on_page_">rows on page</data-i18n><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="vm.itemsPerPage" ng-options="i for i in vm.itemsPerPageValues"></select></label></div></td></tr></tfoot></table><div ng-if="!vm.selectedTeam" align="center"><div><h3><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></h3></div></div></div><div ng-if="vm.loading || vm.loadingTable" align="center"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/ingredientsManagement/editIngredient/editIngredient.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ingredientsManagement/editIngredient/editIngredient.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/ingredientsManagement/editIngredient/editIngredient.panel.html','<div class="panel-group" ng-if="vm.selectedHerd"><form name="vm.ingredientForm" novalidate="" ng-if="!vm.loading"><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.ingredientForm.name.$invalid && (vm.ingredientForm.name.$dirty || vm.ingredientForm.$submitted)}"><label for="name"><data-i18n i18n="_m_f_i_m_ingredient_name_">name</data-i18n></label> <input type="text" maxlength="60" class="form-control" id="name" name="name" placeholder="{{\'_m_f_i_m_ingredient_name_\'|i18n}}" ng-model="vm.ingredient.name" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_label_name_required_">name is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.ingredientForm.feed_type.$invalid && (vm.ingredientForm.feed_type.$dirty || vm.ingredientForm.$submitted)}"><label for="feed_type"><data-i18n i18n="_label_type_">Type</data-i18n></label><ui-select ng-model="vm.selected_type" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" required="" id="feed_type" name="feed_type"><ui-select-match placeholder="{{\'_picker_feed_type_placeholder_\'|i18n}}"><span>{{$select.selected.show_name}}</span></ui-select-match><ui-select-choices repeat="feed_type in vm.feed_types | filter: $select.search"><span ng-bind-html="feed_type.show_name"></span></ui-select-choices></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_toastr_feeds_type_required_">feed type is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.ingredientForm.location_name.$invalid && (vm.ingredientForm.location_name.$dirty || vm.ingredientForm.$submitted)}"><label for="location_name"><data-i18n i18n="_m_f_i_m_ingredient_location_">location</data-i18n></label> <input type="text" class="form-control" id="location_name" name="location_name" placeholder="{{\'_m_f_i_m_ingredient_location_name\'|i18n}}" ng-model="vm.ingredient.location_name" required=""><span class="help-block error-block basic-block"><data-i18n i18n="_label_location_required_">location is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.ingredientForm.ingredient_dm.$invalid && (vm.ingredientForm.ingredient_dm.$dirty || vm.ingredientForm.$submitted)}"><label for="dm">%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></label> <input type="number" min="0.01" max="100" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" class="form-control" placeholder="{{(\'_btn_feed_insert_\' | i18n) + (\' \') + (\'_feeds_dm_\' | i18n)}}" ng-model="vm.ingredient.dm" id="ingredient_dm" name="ingredient_dm" required=""><span class="help-block error-block basic-block"><data-i18n i18n="_m_f_label_dm_required_">DM is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.ingredientForm.ingredient_address.$invalid && (vm.ingredientForm.ingredient_address.$dirty || vm.ingredientForm.$submitted)}"><label for="address"><data-i18n i18n="_label_address_">address</data-i18n></label> <input type="text" class="form-control" placeholder="{{\'_label_address_\'|i18n}}" ng-model="vm.ingredient.address" id="ingredient_address" name="ingredient_address" required=""><span class="help-block error-block basic-block"><data-i18n i18n="_m_f_label_address_required_">address is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6 ingredient-current-quantity"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.ingredientForm.current_quantity.$invalid && (vm.ingredientForm.current_quantity.$dirty || vm.ingredientForm.$submitted)}"><label for="current_quantity"><data-i18n i18n="_label_current_quantity_">current quantity</data-i18n></label> <input type="number" class="form-control" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" id="current_quantity" name="current_quantity" placeholder="{{\'_label_current_quantity_\'|i18n}}" ng-model="vm.ingredient.current_quantity" format-input-value="current_quantity" required="" min="0" ng-change="vm.currentQuantityChanged()"><span class="help-block error-block basic-block"><data-i18n i18n="_label_current_quantity_required_">current quantity is required</data-i18n></span></div><div><span>{{vm.weight}}</span> <span><i ng-class="vm.unit_icon == \'toggle_off\' ? \'ion-toggle-filled flip primaryModal\' : \'ion-toggle-filled primaryModal\'" ng-click="vm.changeUnit()" style="font-size: 34px"></i></span> <span><data-i18n ng-if="vm.settings.use_kgs" i18n="_m_f_wagons_tonnes_">Tonnes</data-i18n><data-i18n ng-if="!vm.settings.use_kgs" i18n="_m_f_wagons_imperial_tonnes_">Tonnes</data-i18n></span></div></div></div><div align="right"><button type="submit" class="btn btn-success" ng-click="vm.updateIngredient()"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></form><div align="center" ng-if="vm.loading" style="overflow: hidden"><div id="loading-animation-large"></div></div></div><div ng-if="!vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div>');
$templateCache.put('app/pages/ingredientsManagement/ingredientHistory/ingredientHistory.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ingredientsManagement/ingredientHistory/ingredientHistory.table.html"></div><div ng-if="vm.loading" align="center" style="overflow: hidden"><div id="loading-animation-large"></div></div></div></div></div></div>');
$templateCache.put('app/pages/ingredientsManagement/ingredientHistory/ingredientHistory.table.html','<div class="row" style="width: 100%" ng-if="!vm.loading"><button class="btn btn-primary btn-xs" ng-click="vm.back()" style="margin-left: 6px; margin-top: 6px"><i class="ion-arrow-left-c"></i>&nbsp;<data i18n="_btn_back_">Back</data></button><div class="horizontal-scroll"><table class="table table-hover ingredients-table" style="font-size: 14px"><thead><tr class="sortable"><th><data-i18n i18n="_label_name_">Name</data-i18n></th><th><data-i18n i18n="_feeds_dm_">DM</data-i18n></th><th><data-i18n i18n="_label_type_">type</data-i18n></th><th><data-i18n i18n="_label_location_">location</data-i18n></th><th><data-i18n i18n="_label_current_quantity_">current quantity</data-i18n></th><th><data-i18n i18n="_m_f_i_m_link_with_recipe_">linked with recipe</data-i18n></th><th><data-i18n i18n="_title_user_">User</data-i18n></th><th><data-i18n i18n="_title_last_modified_date_">last modified date</data-i18n></th></tr></thead><tbody><tr ng-repeat="ingredient in vm.history"><td class="shorten-long-text" uib-tooltip="{{ingredient.name}}" tooltip-enable="{{ingredient.name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{ingredient.name}}</td><td>{{ingredient.dm}}</td><td>{{ingredient.ingredient_type.name}}</td><td class="clickable-td" ng-click="vm.openLocation(ingredient)">{{ingredient.location_name}}</td><td>{{ingredient.current_quantity}}<data-i18n ng-if="!vm.use_kg && vm.settings.use_kgs" i18n="_m_f_wagons_tonnes_">Tonnes</data-i18n><data-i18n ng-if="!vm.use_kg && !vm.settings.use_kgs" i18n="_m_f_wagons_imperial_tonnes_">Tonnes</data-i18n><span ng-if="vm.use_kg">{{vm.weight}}</span></td><td align="center"><a class="ion-checkmark-round primaryModal" ng-if="ingredient.link_with_recipe"></a> <a ng-if="!ingredient.link_with_recipe" class="ion-close-round warningModal"></a></td><td>{{ingredient.last_modified_user}}</td><td>{{ingredient.last_modified_date | date:\'short\'}}</td></tr></tbody><tfoot ng-if="!vm.loadingTable && !vm.loading && vm.totalItems > vm.history.length"><tr><td colspan="14" style="text-align: center"><button class="btn btn-primary" ng-click="vm.paginationChanged()"><data-i18n i18n="_m_f_title_load_more_">Load more</data-i18n></button></td></tr></tfoot><tfoot ng-if="vm.loadingTable || vm.loading"><tr><td colspan="14" style="text-align: center"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/ingredientsManagement/ingredientDetails/ingredientDetails.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ng-if="vm.selectedHerd && vm.selectedTeamHerd && !vm.loading" ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ingredientsManagement/ingredientDetails/ingredientDetails.panel.html"></div></div></div></div></div><div class="panel-content" ng-if="!vm.selectedHerd" align="center" ba-panel=""><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div><div class="panel-content" ng-if="!vm.selectedTeamHerd && ! vm.loading" align="center" ba-panel="" ng-hide="!vm.selectedHerd"><h3><data-i18n i18n="_details_default_herdTeam_not_defined_">Details are not available for this herd / team</data-i18n></h3></div><div ng-if="vm.loading" align="center" ba-panel=""><div style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/ingredientsManagement/ingredientDetails/ingredientDetails.panel.html','<div class="panel-content" ng-if="!vm.loading"><button class="btn btn-primary btn-xs" ng-click="vm.back()" style="margin-left: 6px; margin-top: 6px"><i class="ion-arrow-left-c"></i>&nbsp;<data i18n="_btn_back_">Back</data></button><h3 class="with-line"><data-i18n i18n="_m_f_pen_details_basic_informations_">Basic Informations</data-i18n></h3><div class="row"><div class="col-xlg-4 col-lg-4 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_label_name_">Name</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 wrap-text"><span>{{vm.details.name}}</span></div></div></div><div class="col-xlg-4 col-lg-4 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_label_type_">type</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.ingredient_type.name}}</span></div></div></div><div class="col-xlg-4 col-lg-4 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_i_m_link_with_recipe_">linked with recipe</data-i18n></label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span><a ng-if="vm.details.linked" class="ion-checkmark-round primaryModal"></a> <a ng-if="!vm.details.linked" class="ion-close-round warningModal"></a></span></div></div></div></div><div class="row"><div class="col-xlg-4 col-lg-4 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_label_current_quantity_">current quantity</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.current_quantity}}</span><data-i18n ng-if="!vm.use_kg && vm.settings.use_kgs" i18n="_m_f_wagons_tonnes_">Tonnes</data-i18n><data-i18n ng-if="!vm.use_kg && !vm.settings.use_kgs" i18n="_m_f_wagons_imperial_tonnes_">Tonnes</data-i18n><span ng-if="vm.use_kg">{{vm.weight}}</span></div></div></div></div><div class="row"><div class="col-xlg-4 col-lg-4 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_label_location_">location</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.location_name}}</span></div></div></div></div><div class="row"><div class="col-xlg-4 col-lg-4 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label>%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.dm}}&nbsp;%</span></div></div></div></div><div class="row" style="margin: 10px 20px 0 20px"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="row"><div id="google-maps" class="medium-panel-maps"></div></div></div></div></div><div ng-if="vm.loading" align="center" style="overflow: hidden"><div><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/ingredientsManagement/ingredientUsageOverview/filter.modal.html','<div class="modal-content" ng-if="!vm.modalLoading" ng-cloak=""><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><i class="fa fa-times"></i></button></div><div class="modal-body"><div class="form-group"><label for="breed"><data-i18n i18n="_m_f_mixing_feeding_recipe_">Recipe</data-i18n></label><ui-select multiple="" ng-model="vm.modalSelectedRecipes" class="btn-group bootstrap-select form-control ingredient-usage-recipe-filter" search-enabled="true" id="recipe" name="recipe"><ui-select-match allow-clear="true" placeholder="{{\'_m_f_mixing_feeding_select_recipe_\'|i18n}}">{{$item.recipe_name}}</ui-select-match><ui-select-choices repeat="recipe in vm.recipeFilter | filter: $select.search"><span ng-bind-html="recipe.recipe_name"></span></ui-select-choices></ui-select></div><div class="form-group"><label for="test_date"><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.dateFormat}}" placeholder="{{vm.dateFormat}}" datepicker-options="vm.options" ng-model="vm.startDate" ng-required="true" is-open="startDateOpened" close-text="Close" id="start_date" name="start_date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="startDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="form-group"><label for="test_date"><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.dateFormat}}" placeholder="{{vm.dateFormat}}" datepicker-options="vm.options" ng-model="vm.endDate" ng-required="true" is-open="endDateOpened" close-text="Close" id="end_date" name="end_date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="endDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="modal-footer"><button class="btn btn-xs btn-success" ng-click="vm.saveFilter()"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></div><div class="modal-content" ng-if="vm.modalLoading"><div class="modal-footer"><div style="height: 200px; overflow: hidden" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/ingredientsManagement/ingredientUsageOverview/ingredientUsageOverview.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ng-if="vm.selectedHerd" ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ingredientsManagement/ingredientUsageOverview/ingredientUsageOverview.panel.html"></div></div><div ng-if="!vm.loading && !vm.selectedHerd" align="center" ba-panel=""><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div></div></div>');
$templateCache.put('app/pages/ingredientsManagement/ingredientUsageOverview/ingredientUsageOverview.panel.html','<div ng-if="!vm.loading"><div class="row" style="margin: 0"><div class="col-md-12"><div style="float: right"><div style="float: right"><div class="pdf-icon"><i class="fa fa-file-excel-o" ng-click="vm.exportToXls()" uib-tooltip="{{\'_btn_export_xls_\' | i18n}}" tooltip-is-open="exportToXlsIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-opaque" tooltip-popup-delay="200"></i></div><div class="pdf-icon"><i class="fa fa-file-pdf-o" ng-click="vm.exportToPdf()" uib-tooltip="{{\'_btn_export_pdf_\' | i18n}}" tooltip-is-open="exportToPdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-opaque" tooltip-popup-delay="200"></i></div><toggle-switch ng-model="vm.showRobotData" on-label="{{\'_label_on_\' | i18n}}" off-label="{{\'_label_off_\' | i18n}}" knob-label="{{\'_mf_ing_overview_robots_label_\' | i18n}}" class="switch-primary" style="width: 130px; margin-right: 10px" is-disabled="vm.modalLoading" ng-if="vm.hasRobotAccess" on-change="vm.showRobotDataChanged()"></toggle-switch><toggle-switch ng-model="vm.toggleLoadDrop" on-label="{{\'_m_f_calendar_report_dropping_\' | i18n}}" off-label="{{\'_m_f_calendar_report_loading_\' | i18n}}" knob-label="" class="switch-primary" style="width: 130px; margin-right: 10px" on-change="vm.showLoadDropChanged()" is-disabled="vm.modalLoading"></toggle-switch><toggle-switch ng-model="vm.toggleShowCost" on-label="{{\'_label_on_\' | i18n}}" off-label="{{\'_label_off_\' | i18n}}" knob-label="{{\'_m_f_calendar_report_cost_\' | i18n}}" class="switch-primary" style="width: 120px; margin-right: 10px" on-change="vm.showCostChanged()" is-disabled="vm.modalLoading"></toggle-switch><button tooltip-enable="vm.recipeFilterActive" uib-tooltip="{{\'_reports_filter_active_\' | i18n}}" tooltip-is-open="filter_active" tooltip-placement="left" tooltip-class="customBlue left tooltip-opaque" tooltip-popup-delay="500" id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.openFilterModal()"><span class="glyphicon glyphicon-filter"></span></button><div class="notification" ng-if="vm.recipeFilterActive"></div></div></div></div><div class="row"><div class="col-md-12"><div include-with-scope="app/pages/ingredientsManagement/ingredientUsageOverview/ingredientUsageOverview.table.html"></div></div></div></div></div><loading-spinner-large ng-if="vm.loading"></loading-spinner-large>');
$templateCache.put('app/pages/ingredientsManagement/ingredientUsageOverview/ingredientUsageOverview.table.html','<div class="ingredient-usage-overview-container" ng-if="!vm.showLoadDrop"><div class="ingredient-usage-table-wrapper ingredient-usage-main-table horizontal-scroll" id="main-table"><table class="table"><thead><tr><th><div><div><span><data i18n="_title_column_action_">Action</data></span></div><div><span><data i18n="_m_f_recipe_name_">Recipe name</data></span></div></div></th><th><data i18n="_m_f_total_label_">Total</data></th><th ng-repeat="date in vm.dates track by $index">{{date | date: \'shortDate\'}}</th></tr></thead><tbody><tr ng-repeat-start="(recipeIndex, recipe) in vm.recipes track by $index" ng-if="recipe.total_amount"><td><div><div><span class="expand-arrow" ng-click="recipe.expanded = !recipe.expanded"><i class="fa" ng-class="recipe.expanded ? \'fa-caret-up\' : \'fa-caret-down\'"></i></span></div><div><span>{{recipe.recipe_name}}&nbsp;({{vm.weight}})</span></div></div></td><td><span>{{recipe.total_amount | formatViewValues: \'rounded_amount\'}}</span></td><td ng-repeat="date in recipe.feeding_dates track by $index"><span>{{date.amount | formatViewValues: \'rounded_amount\'}}</span></td></tr><tr ng-repeat-start="(ingredientIndex, ingredient) in recipe.ingredients track by $index" ng-show="recipe.expanded" class="ingredient-usage-table-sub-row"><td><div><div><span class="newCheck"><input type="checkbox" id="is_checked-all-{{recipeIndex}}-{{ingredientIndex}}" ng-true-value="true" ng-false-value="false" ng-model="ingredient.selected" ng-change="vm.selectIngredient(ingredient)" ng-disabled="ingredient.disabled"> <label for="is_checked-all-{{recipeIndex}}-{{ingredientIndex}}"></label></span> <span class="expand-arrow" ng-click="ingredient.expanded = !ingredient.expanded"><i class="fa" ng-class="ingredient.expanded ? \'fa-caret-up\' : \'fa-caret-down\'"></i></span></div><div><span>{{ingredient.ingredient_name}}&nbsp;({{vm.weight}})</span></div></div></td><td><span>{{ingredient.total_amount | formatViewValues: \'rounded_amount\'}}</span></td><td ng-repeat="date in ingredient.feeding_dates track by $index"><span>{{date.amount | formatViewValues: \'rounded_amount\'}}</span></td></tr><tr class="ingredient-total-row" ng-show="recipe.expanded && ingredient.expanded"><td><div class="ingredient-total-label"><data-i18n i18n="_feeds_dm_"></data-i18n>&nbsp;(%)</div></td><td>{{ingredient.dm | formatViewValues: \'percentage\'}}</td><td ng-repeat="date in ingredient.feeding_dates track by $index"><span>{{date.dm | formatViewValues: \'percentage\'}}</span></td></tr><tr class="ingredient-total-row" ng-show="recipe.expanded && ingredient.expanded"><td><div class="ingredient-total-label"><data-i18n i18n="_feeds_amount_"></data-i18n>&nbsp;({{vm.weight}})</div></td><td>{{ingredient.total_amount_dm | formatViewValues: \'rounded_amount\'}}</td><td ng-repeat="date in ingredient.feeding_dates track by $index"><span>{{date.amount_dm | formatViewValues: \'rounded_amount\'}}</span></td></tr><tr class="ingredient-total-row" ng-show="vm.showCost && recipe.expanded && ingredient.expanded"><td><div class="ingredient-total-label"><data-i18n i18n="_feeds_tab_cost_"></data-i18n>&nbsp;({{vm.currency}})</div></td><td>{{ingredient.total_cost | number: 0}}</td><td ng-repeat="date in ingredient.feeding_dates track by $index"><span>{{date.cost | number: 0}}</span></td></tr><tr ng-repeat-end=""></tr><tr ng-show="recipe.expanded" class="separator-row"><td colspan="{{vm.dates.length+4}}"></td></tr><tr style="height: 25px" ng-show="recipe.expanded"><td><div class="ingredient-total-label"><b><data-i18n i18n="_report_total_">Total</data-i18n></b></div></td><td colspan="{{vm.dates.length+3}}"></td></tr><tr ng-show="recipe.expanded"><td><div class="ingredient-total-label"><data-i18n i18n="_feeds_dm_"></data-i18n>&nbsp;(%)</div></td><td>{{recipe.dm | formatViewValues: \'percentage\'}}</td><td ng-repeat="date in recipe.feeding_dates track by $index"><span>{{date.dm | formatViewValues: \'percentage\'}}</span></td></tr><tr ng-show="recipe.expanded" ng-class="!vm.showCost ? \'last-row\' : \'\'"><td><div class="ingredient-total-label"><data-i18n i18n="_feeds_amount_"></data-i18n>&nbsp;({{vm.weight}})</div></td><td>{{recipe.total_amount_dm | formatViewValues: \'rounded_amount\'}}</td><td ng-repeat="date in recipe.feeding_dates track by $index"><span>{{date.amount_dm | formatViewValues: \'rounded_amount\'}}</span></td></tr><tr ng-show="vm.showCost && recipe.expanded" class="last-row"><td><div class="ingredient-total-label"><data-i18n i18n="_feeds_tab_cost_"></data-i18n>&nbsp;({{vm.currency}})</div></td><td>{{recipe.total_cost | number: 0}}</td><td ng-repeat="date in recipe.feeding_dates track by $index"><span>{{date.cost | number: 0}}</span></td></tr><tr ng-repeat-end=""></tr><tr style="height: 25px" ng-if="vm.checkSummaryTableDisplayed()"><td colspan="{{vm.dates.length+4}}"></td></tr><tr ng-if="vm.checkSummaryTableDisplayed()"><th><div><div><span><button class="btn btn-xs btn-primary" ng-disabled="vm.checkSummaryButtonDisabled()" ng-click="vm.createSummary()"><i class="fa fa-plus" uib-tooltip="{{\'_m_f_ingredient_usage_create_summary_\' | i18n}}" tooltip-is-open="createSummaryIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-opaque" tooltip-popup-delay="500"></i></button></span></div><div><span><data i18n="_m_f_i_m_ingredient_name_">Ingredient name</data></span></div></div></th><th><data i18n="_m_f_total_label_">Total</data></th><th ng-repeat="date in vm.dates track by $index"></th></tr><tr ng-repeat-start="summary in vm.summary track by $index" class="ingredient-usage-summary-row" ng-if="vm.checkSummaryTableDisplayed()"><td><div><div><span><button class="btn btn-xs btn-danger" ng-click="vm.deleteSummary(summary)" uib-tooltip="{{\'_m_f_ingredient_usage_delete_summary_\' | i18n}}" tooltip-is-open="deleteSummaryIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-opaque" tooltip-popup-delay="500"><i class="fa fa-trash"></i></button></span> <span class="expand-arrow" ng-click="summary.expanded = !summary.expanded"><i class="fa" ng-class="summary.expanded ? \'fa-caret-up\' : \'fa-caret-down\'"></i></span></div><div><span><span editable-text="summary.ingredient_name" e-required="" e-style="width: 150px">{{summary.ingredient_name}}</span></span></div></div></td><td><span>{{summary.total_amount | formatViewValues: \'rounded_amount\'}}</span></td><td ng-repeat="date in summary.feeding_dates track by $index"><span>{{date.amount | formatViewValues: \'rounded_amount\'}}</span></td></tr><tr class="ingredient-total-row" ng-if="summary.expanded"><td><div class="ingredient-total-label"><data-i18n i18n="_feeds_dm_"></data-i18n>&nbsp;(%)</div></td><td>{{summary.dm | formatViewValues: \'percentage\'}}</td><td ng-repeat="date in summary.feeding_dates track by $index"><span>{{date.dm | formatViewValues: \'percentage\'}}</span></td></tr><tr class="ingredient-total-row" ng-if="summary.expanded"><td><div class="ingredient-total-label"><data-i18n i18n="_feeds_amount_"></data-i18n>&nbsp;({{vm.weight}})</div></td><td>{{summary.total_amount_dm | formatViewValues: \'rounded_amount\'}}</td><td ng-repeat="date in summary.feeding_dates track by $index"><span>{{date.amount_dm | formatViewValues: \'rounded_amount\'}}</span></td></tr><tr class="ingredient-total-row" ng-if="vm.showCost && summary.expanded"><td><div class="ingredient-total-label"><data-i18n i18n="_feeds_tab_cost_"></data-i18n>&nbsp;({{vm.currency}})</div></td><td>{{summary.total_cost | number: 0}}</td><td ng-repeat="date in summary.feeding_dates track by $index"><span>{{date.cost | number: 0}}</span></td></tr><tr ng-repeat-end=""></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess" class="separator-row"><td colspan="{{vm.dates.length+4}}"></td></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess"><th><div><div><span><data i18n="_title_column_action_">Action</data></span></div><div><span><data-i18n i18n="_mf_ing_overview_robot_daily_feedings_label_">Robot daily feedings</data-i18n></span></div></div></th><th><data i18n="_m_f_total_label_">Total</data></th><th ng-repeat="date in vm.feedIntake.feeding_dates track by $index"></th></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess"><td><div><div><span class="expand-arrow" ng-click="vm.feedIntake.expanded = !vm.feedIntake.expanded"><i class="fa" ng-class="!vm.feedIntake.expanded ? \'fa-caret-up\' : \'fa-caret-down\'"></i></span></div><div><span>{{vm.feedIntake.recipe_name}}</span></div></div></td><td><span>{{vm.feedIntake.total_amount | formatViewValues: \'rounded_amount\'}}</span></td><td ng-repeat="date in vm.feedIntake.feeding_dates track by $index"><span>{{date.amount | formatViewValues: \'rounded_amount\'}}</span></td></tr><tr ng-repeat="(ingredientIndex, ingredient) in vm.feedIntake.ingredients track by $index" ng-show="!vm.feedIntake.expanded" class="ingredient-usage-table-sub-row" ng-if="vm.showRobotData && vm.hasRobotAccess"><td><div><div></div><div><span>{{ingredient.ingredient_name}}</span></div></div></td><td><span>{{ingredient.total_amount | formatViewValues: \'rounded_amount\'}}</span></td><td ng-repeat="date in ingredient.feeding_dates track by $index"><span>{{date.amount | formatViewValues: \'rounded_amount\'}}</span></td></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess" class="separator-row"><td colspan="{{vm.dates.length+4}}"></td></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess"><th><div><div><span><data i18n="_title_column_action_">Action</data></span></div><div><span><data-i18n i18n="_m_f_ing_overview_robot_daily_leftovers_label_">Robot daily leftovers</data-i18n></span></div></div></th><th><data i18n="_m_f_total_label_">Total</data></th><th ng-repeat="date in vm.dates track by $index"></th></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess"><td><div><div><span class="expand-arrow" ng-click="vm.feedIntake.leftoversExpanded = !vm.feedIntake.leftoversExpanded"><i class="fa" ng-class="!vm.feedIntake.leftoversExpanded ? \'fa-caret-up\' : \'fa-caret-down\'"></i></span></div><div><span>{{vm.feedIntake.recipe_name}}</span></div></div></td><td><span>{{vm.feedIntake.total_leftovers | formatViewValues: \'rounded_amount\'}}</span></td><td ng-repeat="date in vm.feedIntake.feeding_dates track by $index"><span>{{date.leftovers | formatViewValues: \'rounded_amount\'}}</span></td></tr><tr ng-repeat="(ingredientIndex, ingredient) in vm.feedIntake.ingredients track by $index" ng-show="!vm.feedIntake.leftoversExpanded" class="ingredient-usage-table-sub-row" ng-if="vm.showRobotData && vm.hasRobotAccess"><td><div><div></div><div><span>{{ingredient.ingredient_name}}</span></div></div></td><td><span>{{ingredient.total_leftovers | formatViewValues: \'rounded_amount\'}}&nbsp;</span></td><td ng-repeat="date in ingredient.feeding_dates track by $index"><span>{{date.leftovers | formatViewValues: \'rounded_amount\'}}</span></td></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess" class="separator-row"><td colspan="{{vm.dates.length+4}}"></td></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess"><th><div><div></div><div><span><data i18n="_mf_ing_overview_robot_daily_milkings_label_">Robot daily milkings</data></span></div></div></th><th><data i18n="_m_f_total_label_">Total</data></th><th ng-repeat="date in vm.milkIntake.feeding_dates track by $index"></th></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess"><td><div><div><span>{{vm.feedIntake.recipe_name}}</span></div></div></td><td><span>{{vm.milkIntake.total_amount | formatViewValues: \'rounded_amount\'}}</span></td><td ng-repeat="date in vm.milkIntake.feeding_dates track by $index"><span>{{date.amount | formatViewValues: \'rounded_amount\'}}</span></td></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess"><td><div><div></div><div><span><data-i18n i18n="_m_f_pen_number_of_animals_">Number of animals</data-i18n></span></div></div></td><td></td><td ng-repeat="date in vm.milkIntake.feeding_dates track by $index"><span>{{date.n_animals}}</span></td></tr></tbody></table></div></div><div class="ingredient-usage-overview-container" ng-if="vm.showLoadDrop"><div class="ingredient-usage-table-wrapper ingredient-usage-main-table horizontal-scroll" ng-class="getTableClass()" id="main-table"><table class="table"><thead><tr><th><div><div><span><data i18n="_title_column_action_">Action</data></span></div><div><span><data i18n="_m_f_pen_name_">Pen name</data></span></div></div></th><th><data i18n="_m_f_total_label_">Total</data></th><th ng-repeat="date in vm.dates track by $index">{{date | date: \'shortDate\'}}</th></tr></thead><tbody><tr ng-repeat-start="(penIndex, pen) in vm.pens track by $index" ng-if="pen.total_amount"><td><div><div><span class="expand-arrow" ng-click="pen.expanded = !pen.expanded"><i class="fa" ng-class="pen.expanded ? \'fa-caret-up\' : \'fa-caret-down\'"></i></span></div><div><span>{{pen.pen_name}}&nbsp;({{vm.weight}})</span></div></div></td><td><span>{{pen.total_amount | formatViewValues: \'rounded_amount\'}}</span></td><td ng-repeat="date in pen.feeding_dates track by $index"><span>{{date.amount | formatViewValues: \'rounded_amount\'}}</span></td></tr><tr ng-repeat-start="(ingredientIndex, ingredient) in pen.ingredients track by $index" ng-show="pen.expanded" class="ingredient-usage-table-sub-row"><td><div><div><span class="newCheck"><input type="checkbox" id="is_checked-all-{{penIndex}}-{{ingredientIndex}}" ng-true-value="true" ng-false-value="false" ng-model="ingredient.selected" ng-change="vm.selectIngredient(ingredient)" ng-disabled="ingredient.disabled"> <label for="is_checked-all-{{penIndex}}-{{ingredientIndex}}"></label></span> <span class="expand-arrow" ng-click="ingredient.expanded = !ingredient.expanded"><i class="fa" ng-class="ingredient.expanded ? \'fa-caret-up\' : \'fa-caret-down\'"></i></span></div><div><span>{{ingredient.ingredient_name}}&nbsp;({{vm.weight}})</span></div></div></td><td><span>{{ingredient.total_amount | formatViewValues: \'rounded_amount\'}}</span></td><td ng-repeat="date in ingredient.feeding_dates track by $index"><span>{{date.amount | formatViewValues: \'rounded_amount\'}}</span></td></tr><tr class="ingredient-total-row" ng-show="pen.expanded && ingredient.expanded"><td><div class="ingredient-total-label"><data-i18n i18n="_feeds_dm_"></data-i18n>&nbsp;(%)</div></td><td>{{ingredient.dm | formatViewValues: \'percentage\'}}</td><td ng-repeat="date in ingredient.feeding_dates track by $index"><span>{{date.dm | formatViewValues: \'percentage\'}}</span></td></tr><tr class="ingredient-total-row" ng-show="pen.expanded && ingredient.expanded"><td><div class="ingredient-total-label"><data-i18n i18n="_feeds_amount_"></data-i18n>&nbsp;({{vm.weight}})</div></td><td>{{ingredient.total_amount_dm | formatViewValues: \'rounded_amount\'}}</td><td ng-repeat="date in ingredient.feeding_dates track by $index"><span>{{date.amount_dm | formatViewValues: \'rounded_amount\'}}</span></td></tr><tr class="ingredient-total-row" ng-show="vm.showCost && pen.expanded && ingredient.expanded"><td><div class="ingredient-total-label"><data-i18n i18n="_feeds_tab_cost_"></data-i18n>&nbsp;({{vm.currency}})</div></td><td>{{ingredient.total_cost | number: 0}}</td><td ng-repeat="date in ingredient.feeding_dates track by $index"><span>{{date.cost | number: 0}}</span></td></tr><tr ng-repeat-end=""></tr><tr ng-show="pen.expanded" class="separator-row"><td colspan="{{vm.dates.length+4}}"></td></tr><tr style="height: 25px" ng-show="pen.expanded"><td><div class="ingredient-total-label"><b><data-i18n i18n="_report_total_">Total</data-i18n></b></div></td><td colspan="{{vm.dates.length+3}}"></td></tr><tr ng-show="pen.expanded"><td><div class="ingredient-total-label"><data-i18n i18n="_feeds_dm_"></data-i18n>&nbsp;(%)</div></td><td>{{pen.dm | formatViewValues: \'percentage\'}}</td><td ng-repeat="date in pen.feeding_dates track by $index"><span>{{date.dm | formatViewValues: \'percentage\'}}</span></td></tr><tr ng-show="pen.expanded"><td><div class="ingredient-total-label"><data-i18n i18n="_feeds_amount_"></data-i18n>&nbsp;({{vm.weight}})</div></td><td>{{pen.total_amount_dm | formatViewValues: \'rounded_amount\'}}</td><td ng-repeat="date in pen.feeding_dates track by $index"><span>{{date.amount_dm | formatViewValues: \'rounded_amount\'}}</span></td></tr><tr ng-show="vm.showCost && pen.expanded"><td><div class="ingredient-total-label"><data-i18n i18n="_feeds_tab_cost_"></data-i18n>&nbsp;({{vm.currency}})</div></td><td>{{pen.total_cost | number: 0}}</td><td ng-repeat="date in pen.feeding_dates track by $index"><span>{{date.cost | number: 0}}</span></td></tr><tr ng-show="pen.expanded && pen.total_amount" class="last-row"><td><div><div></div><div><span><data-i18n i18n="_m_f_pen_number_of_animals_">Number of animals</data-i18n></span></div></div></td><td></td><td ng-repeat="date in pen.feeding_dates track by $index"><span>{{date.n_animals}}</span></td></tr><tr ng-repeat-end=""></tr><tr style="height: 25px" ng-if="vm.checkSummaryTableDisplayed()"><td colspan="{{vm.dates.length+4}}"></td></tr><tr ng-if="vm.checkSummaryTableDisplayed()"><th><div><div><span><button class="btn btn-xs btn-primary" ng-disabled="vm.checkSummaryButtonDisabled()" ng-click="vm.createSummary()"><i class="fa fa-plus" uib-tooltip="{{\'_m_f_ingredient_usage_create_summary_\' | i18n}}" tooltip-is-open="createSummaryIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-opaque" tooltip-popup-delay="500"></i></button></span></div><div><span><data i18n="_m_f_i_m_ingredient_name_">Ingredient name</data></span></div></div></th><th><data i18n="_m_f_total_label_">Total</data></th><th ng-repeat="date in vm.dates track by $index"></th></tr><tr ng-repeat-start="summary in vm.summary track by $index" class="ingredient-usage-summary-row" ng-if="vm.checkSummaryTableDisplayed()"><td><div><div><span><button class="btn btn-xs btn-danger" ng-click="vm.deleteSummary(summary)" uib-tooltip="{{\'_m_f_ingredient_usage_delete_summary_\' | i18n}}" tooltip-is-open="deleteSummaryIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-opaque" tooltip-popup-delay="500"><i class="fa fa-trash"></i></button></span> <span class="expand-arrow" ng-click="summary.expanded = !summary.expanded"><i class="fa" ng-class="summary.expanded ? \'fa-caret-up\' : \'fa-caret-down\'"></i></span></div><div><span><span editable-text="summary.ingredient_name" e-required="" e-style="width: 150px">{{summary.ingredient_name}}</span></span></div></div></td><td><span>{{summary.total_amount | formatViewValues: \'rounded_amount\'}}</span></td><td ng-repeat="date in summary.feeding_dates track by $index"><span>{{date.amount | formatViewValues: \'rounded_amount\'}}</span></td></tr><tr class="ingredient-total-row" ng-if="summary.expanded"><td><div class="ingredient-total-label"><data-i18n i18n="_feeds_dm_"></data-i18n>&nbsp;(%)</div></td><td>{{summary.dm | formatViewValues: \'percentage\'}}</td><td ng-repeat="date in summary.feeding_dates track by $index"><span>{{date.dm | formatViewValues: \'percentage\'}}</span></td></tr><tr class="ingredient-total-row" ng-if="summary.expanded"><td><div class="ingredient-total-label"><data-i18n i18n="_feeds_amount_"></data-i18n>&nbsp;({{vm.weight}})</div></td><td>{{summary.total_amount_dm | formatViewValues: \'rounded_amount\'}}</td><td ng-repeat="date in summary.feeding_dates track by $index"><span>{{date.amount_dm | formatViewValues: \'rounded_amount\'}}</span></td></tr><tr class="ingredient-total-row" ng-if="vm.showCost && summary.expanded"><td><div class="ingredient-total-label"><data-i18n i18n="_feeds_tab_cost_"></data-i18n>&nbsp;({{vm.currency}})</div></td><td>{{summary.total_cost | number: 0}}</td><td ng-repeat="date in summary.feeding_dates track by $index"><span>{{date.cost | number: 0}}</span></td></tr><tr ng-repeat-end=""></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess" class="separator-row"><td colspan="{{vm.dates.length+4}}"></td></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess"><th><div><div><span><data i18n="_title_column_action_">Action</data></span></div><div><span><data-i18n i18n="_mf_ing_overview_robot_daily_feedings_label_">Robot concentrate intake</data-i18n></span></div></div></th><th><data i18n="_m_f_total_label_">Total</data></th><th ng-repeat="date in vm.feedIntake.feeding_dates track by $index"></th></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess"><td><div><div><span class="expand-arrow" ng-click="vm.feedIntake.expanded = !vm.feedIntake.expanded"><i class="fa" ng-class="!vm.feedIntake.expanded ? \'fa-caret-up\' : \'fa-caret-down\'"></i></span></div><div><span>{{vm.feedIntake.recipe_name}}</span></div></div></td><td><span>{{vm.feedIntake.total_amount | formatViewValues: \'rounded_amount\'}}{{vm.weight}}</span></td><td ng-repeat="date in vm.feedIntake.feeding_dates track by $index"><span>{{date.amount | formatViewValues: \'rounded_amount\'}}{{vm.weight}}</span></td></tr><tr ng-repeat="(ingredientIndex, ingredient) in vm.feedIntake.ingredients track by $index" ng-show="!vm.feedIntake.expanded" class="ingredient-usage-table-sub-row" ng-if="vm.showRobotData && vm.hasRobotAccess"><td><div><div></div><div><span>{{ingredient.ingredient_name}}</span></div></div></td><td><span>{{ingredient.total_amount | formatViewValues: \'rounded_amount\'}}{{vm.weight}}</span></td><td ng-repeat="date in ingredient.feeding_dates track by $index"><span>{{date.amount | formatViewValues: \'rounded_amount\'}}{{vm.weight}}</span></td></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess" class="separator-row"><td colspan="{{vm.dates.length+4}}"></td></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess"><th><div><div><span><data i18n="_title_column_action_">Action</data></span></div><div><span><data-i18n i18n="_m_f_ing_overview_robot_daily_leftovers_label_">Robot daily leftovers</data-i18n></span></div></div></th><th><data i18n="_m_f_total_label_">Total</data></th><th ng-repeat="date in vm.dates track by $index"></th></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess"><td><div><div><span class="expand-arrow" ng-click="vm.feedIntake.leftoversExpanded = !vm.feedIntake.leftoversExpanded"><i class="fa" ng-class="!vm.feedIntake.leftoversExpanded ? \'fa-caret-up\' : \'fa-caret-down\'"></i></span></div><div><span>{{vm.feedIntake.recipe_name}}</span></div></div></td><td><span>{{vm.feedIntake.total_leftovers | formatViewValues: \'rounded_amount\'}}{{vm.weight}}</span></td><td ng-repeat="date in vm.feedIntake.feeding_dates track by $index"><span>{{date.leftovers | formatViewValues: \'rounded_amount\'}}{{vm.weight}}</span></td></tr><tr ng-repeat="(ingredientIndex, ingredient) in vm.feedIntake.ingredients track by $index" ng-show="!vm.feedIntake.leftoversExpanded" class="ingredient-usage-table-sub-row" ng-if="vm.showRobotData && vm.hasRobotAccess"><td><div><div></div><div><span>{{ingredient.ingredient_name}}</span></div></div></td><td><span>{{ingredient.total_leftovers | formatViewValues: \'rounded_amount\'}}{{vm.weight}}&nbsp;</span></td><td ng-repeat="date in ingredient.feeding_dates track by $index"><span>{{date.leftovers | formatViewValues: \'rounded_amount\'}}{{vm.weight}}</span></td></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess" class="separator-row"><td colspan="{{vm.dates.length+4}}"></td></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess"><th><div><div></div><div><span><data i18n="_mf_ing_overview_robot_daily_milkings_label_">Robot daily milkings</data></span></div></div></th><th><data i18n="_m_f_total_label_">Total</data></th><th ng-repeat="date in vm.milkIntake.feeding_dates track by $index"></th></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess"><td><div><div><span>{{vm.feedIntake.recipe_name}}</span></div></div></td><td><span>{{vm.milkIntake.total_amount | formatViewValues: \'rounded_amount\'}}{{vm.weight}}</span></td><td ng-repeat="date in vm.milkIntake.feeding_dates track by $index"><span>{{date.amount | formatViewValues: \'rounded_amount\'}}{{vm.weight}}</span></td></tr><tr ng-if="vm.showRobotData && vm.hasRobotAccess"><td><div><div></div><div><span><data-i18n i18n="_m_f_pen_number_of_animals_">Number of animals</data-i18n></span></div></div></td><td></td><td ng-repeat="date in vm.milkIntake.feeding_dates track by $index"><span>{{date.n_animals}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/ingredientsManagement/ingredientUsageOverview/loadingModal.html','<div class="modal-content"><div class="modal-header"><div align="center"><span class="secondaryText"><data-i18n i18n="_title_please_wait_">please wait</data-i18n></span></div></div><div class="modal-body"><div style="height: 200px" align="center"><div style="margin-top: 50px"><div id="loading-animation-large" style="display: inline-block"></div></div></div></div></div>');
$templateCache.put('app/pages/ingredientsManagement/overview/location.modal.html','<div class="modal-content" ng-if="!vm.modalLoading"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><form name="vm.updateLocationForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.updateLocationForm.location_name.$invalid && (vm.updateLocationForm.location_name.$dirty || vm.updateLocationForm.$submitted)}"><label for="location_name"><data-i18n i18n="_m_f_i_m_ingredient_location_">location</data-i18n></label> <input type="text" class="form-control" id="location_name" name="location_name" placeholder="{{\'_m_f_i_m_ingredient_location_name\'|i18n}}" ng-model="vm.selectedIngredient.ingredient.location_name" required="" ng-change="vm.locationChanged = true"><span class="help-block error-block basic-block warningModal"><data-i18n i18n="_label_location_required_">location is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.updateLocationForm.ingredient_address.$invalid && (vm.updateLocationForm.ingredient_address.$dirty || vm.updateLocationForm.$submitted)}"><label for="address"><data-i18n i18n="_label_address_">address</data-i18n></label> <input type="text" class="form-control" placeholder="{{\'_label_address_\'|i18n}}" ng-model="vm.selectedIngredient.ingredient.address" id="ingredient_address" name="ingredient_address" required=""><span class="help-block error-block basic-block warningModal"><data-i18n i18n="_m_f_label_address_required_">address is required</data-i18n></span></div></div></div></form><button class="btn btn-map" style="position: absolute; z-index: 999; bottom: 0px" ng-click="vm.removeSelection()" ng-if="vm.locationSelected"><data-i18n i18n="_btn_remove_selection_">remove selection</data-i18n></button><div id="google-maps" class="medium-panel-maps"></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="vm.saveLocation()" ng-disabled="!vm.locationChanged"><data-i18n i18n="_btn_save_"></data-i18n></button></div></div><div class="modal-content" ng-if="vm.modalLoading"><div class="modal-body"><div align="center" style="overflow: hidden"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/ingredientsManagement/overview/overview.cards.html','<div ng-if="!vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div><div ng-if="!vm.loading && vm.selectedHerd"><div class="grid-card-wrapper horizontal-scroll"><div ng-repeat="ingredient in vm.ingredients" ng-class="pen.active ? \'pen-active\' : \'\'"><div class="grid-card-header"><div>{{ingredient.feed_name}}</div></div><hr class="separator"><div><table><tbody><tr><td><data-i18n i18n="_feeds_type_">feed type</data-i18n></td><td>{{ingredient.feed_type.name}}</td></tr><tr><td><data-i18n i18n="_m_f_i_m_overview_in_recipe_">in recipe?</data-i18n></td><td><a class="ion-checkmark-round primaryModal" ng-if="ingredient.recipe_feed_id"></a><a ng-if="!ingredient.recipe_feed_id" class="ion-close-round warningModal"></a></td></tr><tr><td><data-i18n i18n="_m_f_i_m_overview_location_">location</data-i18n></td><td><span class="editable-td" ng-click="vm.openLocation(ingredient)">{{ingredient.ingredient.location_name || (\'_m_f_calendar_not_available_label_\' | i18n)}}</span></td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_m_f_i_m_cost_as_fed_per_ton_">cost as fed</data-i18n></td><td ng-if="ingredient.recipe_feed_id"><span editable-number="ingredient.cost_as_fed" onbeforesave="vm.costChanged($data, \'as_fed\', ingredient, $index)" e-step="0.01">{{ingredient.cost_as_fed}}</span></td><td ng-if="!ingredient.recipe_feed_id">{{ingredient.cost_as_fed}}</td></tr><tr class="editable-tr-wrap"><td><data-i18n i18n="_m_f_i_m_cost_dm_per_ton_">cost dm</data-i18n></td><td ng-if="ingredient.recipe_feed_id"><span editable-number="ingredient.cost" onbeforesave="vm.costChanged($data, \'cost\', ingredient, $index)" e-step="0.01">{{ingredient.cost}}</span></td><td ng-if="!ingredient.recipe_feed_id">{{ingredient.cost}}</td></tr><tr class="editable-tr-wrap"><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td ng-if="!ingredient.recipe_feed_id">{{ingredient.dm}}</td><td ng-if="ingredient.recipe_feed_id"><span editable-number="ingredient.dm" e-min="0.01" onbeforesave="vm.costChanged($data, \'dm\', ingredient, $index)" e-step="0.01">{{ingredient.dm}}</span></td></tr></tbody></table></div></div></div><div align="center" ng-if="!vm.loadingTable && !vm.loading && vm.totalItems > vm.ingredients.length"><button class="btn btn-primary" ng-click="vm.paginationChanged()"><data-i18n i18n="_m_f_title_load_more_">Load more</data-i18n></button></div></div><div ng-if="vm.loading || vm.loadingTable" align="center" style="overflow: hidden"><div id="loading-animation-large"></div></div>');
$templateCache.put('app/pages/ingredientsManagement/overview/overview.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ingredientsManagement/overview/overview.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/ingredientsManagement/overview/overview.panel.html','<div class="row" ng-if="!vm.loading"><div class="btn-group" style="float: right" ng-if="vm.selectedHerd"><button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(1)" ng-class="vm.selectedLayout == 1 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th-list" ng-class="vm.selectedLayout == 1 ? \'glyphicon glyphicon-th-list selected\' : \'glyphicon glyphicon-th-list\'"></span></button> <button id="grid" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(2)" ng-class="vm.selectedLayout == 2 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th" ng-class="vm.selectedLayout == 2 ? \'glyphicon glyphicon-th selected\' : \'glyphicon glyphicon-th\'"></span></button></div></div><div class="row" ng-if="vm.selectedLayout == 1"><div include-with-scope="app/pages/ingredientsManagement/overview/overview.table.html"></div></div><div class="row" ng-if="vm.selectedLayout == 2"><div include-with-scope="app/pages/ingredientsManagement/overview/overview.cards.html"></div></div>');
$templateCache.put('app/pages/ingredientsManagement/overview/overview.table.html','<div ng-if="!vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div><div ng-if="vm.selectedHerd"><div class="horizontal-scroll" ng-if="!vm.loading"><table class="table table-hover" style="font-size: 14px"><thead><tr class="sortable"><th><data-i18n i18n="_feeds_name_">feed name</data-i18n></th><th><data-i18n i18n="_feeds_type_">feed type</data-i18n></th><th><data-i18n i18n="_m_f_i_m_overview_in_recipe_">in_recipe</data-i18n></th><th><data-i18n i18n="_m_f_i_m_overview_location_">location</data-i18n></th><th><data-i18n i18n="_m_f_i_m_cost_as_fed_per_ton_">cost as fed</data-i18n></th><th><data-i18n i18n="_m_f_i_m_cost_dm_per_ton_">cost dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></th></tr></thead><tbody><tr ng-repeat="ingredient in vm.ingredients" class="editable-tr-wrap"><td style="padding: 3px 3px; white-space: nowrap">{{ingredient.feed_name}}</td><td style="padding: 3px 3px">{{ingredient.feed_type.name}}</td><td style="text-align: left; padding: 3px 3px"><a class="ion-checkmark-round primaryModal" ng-if="ingredient.recipe_feed_id"></a><a ng-if="!ingredient.recipe_feed_id" class="ion-close-round warningModal"></a></td><td style="padding: 3px 3px"><span class="editable-td" ng-click="vm.openLocation(ingredient)">{{ingredient.ingredient.location_name || (\'_m_f_calendar_not_available_label_\' | i18n)}}</span></td><td style="padding: 3px 3px" ng-if="ingredient.recipe_feed_id"><span editable-number="ingredient.cost_as_fed" onbeforesave="vm.costChanged($data, \'as_fed\', ingredient, $index)" e-step="0.01">{{ingredient.cost_as_fed}}</span></td><td style="padding: 3px 3px" ng-if="!ingredient.recipe_feed_id">{{ingredient.cost_as_fed}}</td><td style="padding: 3px 3px" ng-if="ingredient.recipe_feed_id"><span editable-number="ingredient.cost" onbeforesave="vm.costChanged($data, \'cost\', ingredient, $index)" e-step="0.01">{{ingredient.cost}}</span></td><td style="padding: 3px 3px" ng-if="!ingredient.recipe_feed_id">{{ingredient.cost}}</td><td style="padding: 3px 3px" ng-if="ingredient.recipe_feed_id"><span editable-number="ingredient.dm" onbeforesave="vm.costChanged($data, \'dm\', ingredient, $index)" e-step="0.01">{{ingredient.dm}}</span></td><td style="padding: 3px 3px" ng-if="!ingredient.recipe_feed_id">{{ingredient.dm}}</td></tr></tbody><tbody ng-if="vm.loadingTable"><tr><td colspan="20"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></td></tr></tbody><tfoot ng-if="!vm.loadingTable && !vm.loading && vm.totalItems > vm.ingredients.length"><tr ng-if="vm.totalItems > 10"><td colspan="9" style="text-align: center"><button class="btn btn-primary" ng-click="vm.paginationChanged()"><data-i18n i18n="_m_f_title_load_more_">Load more</data-i18n></button></td></tr></tfoot></table></div><div ng-if="vm.loading" align="center"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/ingredientsManagement/inventory/confirmationDialog.modal.html','<div class="modal-content"><div class="modal-header" ng-if="!vm.modalLoading"><div align="center"><span class="ion-android-warning warningModal" style="font-size: 36px"></span></div><div align="center"><span class="warningModal">{{vm.warningMessage | i18n}}</span></div></div><div class="modal-body" ng-if="!vm.modalLoading"><div align="center"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="vm.proceedDelete()"><data-i18n i18n="_btn_delete_">Delete</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="$dismiss()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div style="height: 200px; overflow: hidden" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/ingredientsManagement/inventory/inventory.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ingredientsManagement/inventory/inventory.table.html"></div></div></div></div></div>');
$templateCache.put('app/pages/ingredientsManagement/inventory/inventory.table.html','<div ng-if="!vm.selectedHerd" align="center" style="vertical-align: top"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div><div ng-if="vm.selectedHerd"><div class="horizontal-scroll" close-ing-popover="" close-popover="vm.closePopover()" ng-if="!vm.loading"><div style="padding: 10px 15px"><button class="btn btn-primary" ng-click="vm.redirect(\'iManagement.addNewIngredient\')"><data-i18n i18n="_btn_add_new_ingredient_"></data-i18n></button><div style="display: inline; margin-left: 5px"><span><data-i18n i18n="_m_f_change_unit_"></data-i18n></span>:&nbsp; <span>({{vm.weight}})</span> <span style="display: inline-block; vertical-align: middle"><i ng-class="vm.unit_icon == \'toggle_off\' ? \'ion-toggle-filled flip primaryModal\' : \'ion-toggle-filled primaryModal\'" ng-click="vm.changeUnit()" style="font-size: 34px"></i></span> <span ng-if="vm.settings.use_kgs">(<data-i18n i18n="_m_f_wagons_tonnes_">Tonnes</data-i18n>)</span> <span ng-if="!vm.settings.use_kgs">(<data-i18n i18n="_m_f_wagons_imperial_tonnes_">Tonnes</data-i18n>)</span></div></div><table class="table table-hover" style="font-size: 14px"><thead><tr class="sortable"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br></th><th><data-i18n i18n="_label_name_">name</data-i18n><br></th><th><data-i18n i18n="_feeds_dm_">DM</data-i18n><br>%</th><th><data-i18n i18n="_label_type_">type</data-i18n><br></th><th><data-i18n i18n="_label_location_">location</data-i18n><br></th><th><data-i18n i18n="_m_f_i_m_original_quantity_">Original quantity</data-i18n><br><span ng-if="!vm.use_kg && vm.settings.use_kgs">(<data-i18n i18n="_m_f_wagons_tonnes_">Tonnes</data-i18n>)</span> <span ng-if="!vm.use_kg && !vm.settings.use_kgs">(<data-i18n i18n="_m_f_wagons_imperial_tonnes_">Tonnes</data-i18n>)</span> <span ng-if="vm.use_kg">({{vm.weight}})</span></th><th><data-i18n i18n="_label_current_quantity_">current quantity</data-i18n><br><span ng-if="!vm.use_kg && vm.settings.use_kgs">(<data-i18n i18n="_m_f_wagons_tonnes_">Tonnes</data-i18n>)</span> <span ng-if="!vm.use_kg && !vm.settings.use_kgs">(<data-i18n i18n="_m_f_wagons_imperial_tonnes_">Tonnes</data-i18n>)</span> <span ng-if="vm.use_kg">({{vm.weight}})</span></th><th><data-i18n i18n="_m_f_i_m_30_days_usage_">30 days usage</data-i18n><br><span ng-if="!vm.use_kg && vm.settings.use_kgs">(<data-i18n i18n="_m_f_wagons_tonnes_">Tonnes</data-i18n>)</span> <span ng-if="!vm.use_kg && !vm.settings.use_kgs">(<data-i18n i18n="_m_f_wagons_imperial_tonnes_">Tonnes</data-i18n>)</span> <span ng-if="vm.use_kg">({{vm.weight}})</span></th><th><data-i18n i18n="_m_f_i_m_60_days_usage_">60 days usge</data-i18n><br><span ng-if="!vm.use_kg && vm.settings.use_kgs">(<data-i18n i18n="_m_f_wagons_tonnes_">Tonnes</data-i18n>)</span> <span ng-if="!vm.use_kg && !vm.settings.use_kgs">(<data-i18n i18n="_m_f_wagons_imperial_tonnes_">Tonnes</data-i18n>)</span> <span ng-if="vm.use_kg">({{vm.weight}})</span></th><th><data-i18n i18n="_m_f_i_m_90_days_usage_">90 days usage</data-i18n><br><span ng-if="!vm.use_kg && vm.settings.use_kgs">(<data-i18n i18n="_m_f_wagons_tonnes_">Tonnes</data-i18n>)</span> <span ng-if="!vm.use_kg && !vm.settings.use_kgs">(<data-i18n i18n="_m_f_wagons_imperial_tonnes_">Tonnes</data-i18n>)</span> <span ng-if="vm.use_kg">({{vm.weight}})</span></th><th><data-i18n i18n="_m_f_i_m_days_until_empty_">days until empty</data-i18n><br></th><th><data-i18n i18n="_m_f_i_m_link_with_recipe_">linked with recipe</data-i18n><br></th><th><data-i18n i18n="_m_f_i_m_linked_recipes_">Linked recipes</data-i18n><br></th><th><data-i18n i18n="_m_f_i_m_remove_ingredient_">Remove ingredient</data-i18n><br></th></tr></thead><tbody><tr ng-repeat="ingredient in vm.ingredients" class="editable-tr-wrap"><td style="min-width: 120px; vertical-align: middle"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToIngredientHistory(ingredient)" uib-tooltip="{{\'_tips_history_\' | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editIngredient(ingredient)" uib-tooltip="{{\'_tips_edit_\' | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.ingredientDetails(ingredient)" uib-tooltip="{{\'_tips_details_\' | i18n}}" tooltip-is-open="tooltipIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clipboard"></i></button><div id="loading-animation" ng-if="vm.ingredients[$index].loading" style="display: inline-block"></div></td><td style="vertical-align: middle" class="shorten-long-text" uib-tooltip="{{ingredient.name}}" tooltip-enable="{{ingredient.name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{ingredient.name}}</td><td style="vertical-align: middle"><span editable-number="ingredient.dm" edit-disabled="vm.ingredient_loading" e-step="0.01" e-min="0.01" e-max="100" e-required="" onbeforesave="vm.updateIngredient($data, ingredient, $index, \'dm\')" ng-class="ingredient.dm == 0 ? \'warningModal\' : \'\'">{{ingredient.dm || (\'_label_empty_\' | i18n)}}</span></td><td style="vertical-align: middle; white-space: nowrap !important">{{ingredient.ingredient_type.name}}</td><td style="vertical-align: middle" class="clickable-td" ng-click="vm.openLocation(ingredient)">{{ingredient.location_name}}</td><td style="vertical-align: middle"><span editable-number="ingredient.original_quantity" e-min="0.01" e-required="" e-format-input-value="current_quantity" onbeforesave="vm.updateIngredient($data, ingredient, $index, \'q\')" edit-disabled="vm.ingredient_loading" e-step="0.01">{{ingredient.original_quantity | formatViewValues: \'current_quantity\'}}</span><br>{{ingredient.quantity_date | date:\'shortDate\'}}</td><td style="vertical-align: middle" ng-class="{ \'warningModal\': ingredient.current_quantity == 0}">{{ingredient.current_quantity | formatViewValues: \'current_quantity\'}}</td><td style="vertical-align: middle" ng-if="ingredient.daily_ingredient_amount_usage">{{ingredient.usage_30 | formatViewValues: \'current_quantity\'}}</td><td style="vertical-align: middle" ng-if="!ingredient.daily_ingredient_amount_usage">/</td><td style="vertical-align: middle" ng-if="ingredient.daily_ingredient_amount_usage">{{ingredient.usage_60 | formatViewValues: \'current_quantity\'}}</td><td style="vertical-align: middle" ng-if="!ingredient.daily_ingredient_amount_usage">/</td><td style="vertical-align: middle" ng-if="ingredient.daily_ingredient_amount_usage">{{ingredient.usage_90 | formatViewValues: \'current_quantity\'}}</td><td style="vertical-align: middle" ng-if="!ingredient.daily_ingredient_amount_usage">/</td><td style="vertical-align: middle" ng-if="ingredient.daily_ingredient_amount_usage" ng-class="ingredient.days_until_empty == 0 ? \'warningModal\' : \'\'">{{(ingredient.days_until_empty | number: 0) || (\'_label_empty_\' | i18n)}}</td><td style="vertical-align: middle" ng-if="!ingredient.daily_ingredient_amount_usage">/</td><td style="vertical-align: middle" align="center"><a class="ion-checkmark-round primaryModal" ng-if="ingredient.linked"></a> <a ng-if="!ingredient.linked" class="ion-close-round warningModal"></a></td><td style="vertical-align: middle" align="center"><span ng-if="ingredient.linked" id="recipe-info" class="linked-recipes-button" ng-click="vm.openRecipe(ingredient, $index)" popover-trigger="outsideClick" popover-is-open="vm.popoverOpen[$index]" uib-popover-template="\'app/pages/ingredientsManagement/inventory/linkedRecipesPopover.html\'" popover-placement="left" popover-append-to-body="true"><i class="fa fa-info-circle"></i></span></td><td style="vertical-align: middle" align="center"><button class="btn btn-danger btn-xs" ng-click="vm.deleteIngredient($index, ingredient)"><data-i18n i18n="_btn_delete_">Delete</data-i18n></button></td></tr></tbody><tfoot ng-if="!vm.loadingTable && !vm.loading && vm.totalItems > vm.ingredients.length"><tr><td colspan="14" style="text-align: center"><button class="btn btn-primary" ng-click="vm.paginationChanged()"><data-i18n i18n="_m_f_title_load_more_">Load more</data-i18n></button></td></tr></tfoot><tfoot ng-if="vm.loadingTable && !vm.loading"><tr><td colspan="14" style="text-align: center"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></td></tr></tfoot></table></div><div ng-if="vm.loading" align="center"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/ingredientsManagement/inventory/linkedRecipesPopover.html','<div ng-if="!vm.popoverLoading" style="height: 200px; overflow-y: auto"><label><data-i18n i18n="_m_f_ingredient_linked_recipes_">Linked recipes</data-i18n></label><ul style="margin-right: 20px" ng-repeat="r in vm.popoverRecipes"><li>{{r.name}}</li></ul></div><div ng-if="vm.popoverLoading" align="center"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/ingredientsManagement/inventory/location.modal.html','<div class="modal-content"><div class="modal-header" style="padding-bottom: 0px"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><span><data-i18n i18n="_label_address_"></data-i18n>: &nbsp;{{vm.selectedIngredient.address}}</span><div id="google-maps" class="medium-panel-maps"></div></div></div>');
$templateCache.put('app/pages/mixerWagons/addNewWagon/addNewWagon.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/mixerWagons/addNewWagon/addNewWagon.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/mixerWagons/addNewWagon/addNewWagon.panel.html','<div ng-if="!vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div><div ng-if="vm.selectedHerd"><div ng-if="!vm.loading"><form name="vm.addNewWagonForm" novalidate="" style="width: fit-content; position: relative; left: 0; right: 0; margin: auto"><div class="row" style="width: 600px"><div><div class="form-group has-feedback" style="max-width: 375px" ng-class="{\'has-error\': vm.addNewWagonForm.wagon_name.$invalid && (vm.addNewWagonForm.wagon_name.$dirty || vm.addNewWagonForm.$submitted)}"><label for="wagon_name"><data-i18n i18n="_m_f_wagons_name_">Mixer wagon name</data-i18n></label> <input type="text" maxlength="60" class="form-control" id="wagon_name" name="wagon_name" placeholder="{{\'_m_f_wagons_name_\' | i18n}}" ng-model="vm.wagon.name" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_wagons_name_required_" select-on-click="">Mixer wagon name required</data-i18n></span></div><div class="form-group has-feedback" style="max-width: 375px" ng-class="{\'has-error\': vm.addNewWagonForm.mac_address.$invalid && (vm.addNewWagonForm.mac_address.$dirty || vm.addNewWagonForm.$submitted)}"><label for="mac_address"><data-i18n i18n="_m_f_premix_mac_label_">MAC address</data-i18n></label> <input type="text" class="form-control" id="mac_address" name="mac_address" placeholder="xx:xx:xx:xx:xx:xx" pattern="^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$" maxlength="17" ng-model="vm.wagon.mac_address"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_premix_mac_required_label_" select-on-click="">MAC address is required</data-i18n></span></div><div class="form-group" style="max-width: 500px" ng-class="{\'has-error\': vm.addNewWagonForm.volume.$invalid && (vm.addNewWagonForm.volume.$dirty || vm.addNewWagonForm.$submitted)}"><label style="display: block"><data-i18n i18n="_m_f_wagons_capacity_">capacity</data-i18n></label> <input type="number" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" class="form-control with-units" id="volume" name="volume" placeholder="{{\'_m_f_wagons_volume_\' | i18n}}" ng-model="vm.wagon.volume" min="0" max="90" step="0.1" select-on-click=""><span>m<sup>3</sup></span></div><div class="form-group" ng-class="{\'has-error\': vm.addNewWagonForm.weight.$invalid && (vm.addNewWagonForm.weight.$dirty || vm.addNewWagonForm.$submitted)}" style="max-width: 500px"><input type="number" class="form-control with-units" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" id="weight" name="weight" placeholder="{{\'_m_f_wagons_weight_\' | i18n}}" ng-model="vm.wagon.weight" required="" min="0.1" max="90" step="0.1" select-on-click=""><span><data-i18n ng-if="vm.settings.use_kgs" i18n="_m_f_wagons_tonnes_">Tonnes</data-i18n><data-i18n ng-if="!vm.settings.use_kgs" i18n="_m_f_wagons_imperial_tonnes_">Tonnes</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_wagons_weight_required_" select-on-click="">weight is required</data-i18n></span></div></div></div><div class="row"><span class="form-group"><label><data-i18n i18n="_m_f_wagons_picture_">Pictures</data-i18n></label></span></div><div class="row" ng-if="!vm.file"><div class="form-group" style="max-width: 500px; display: flex; flex-direction: row" ng-class="{\'has-error\': vm.addNewWagonForm.image_url.$invalid}"><input class="form-control with-units" type="url" placeholder="{{\'_enter_image_url_\' | i18n}}" style="margin-top: 10px" ng-model="vm.wagon.image_url" id="image_url" name="image_url" ng-change="vm.imageUrlChanged()"><div ng-if="!vm.file"><div class="wagon-upload-button"><a class="ion-upload primaryModal" style="font-size: 50px" ng-click="vm.openFileSystem()"></a></div><div ng-show="false"><input type="file" class="btn btn-primary btn-with-icon save-profile" ngf-select="" ng-model="vm.file" name="file" ngf-accept="\'image/*\'" ngf-max-size="10MB" ngf-change="vm.uploadChanged()" id="up_button" ngf-pattern="\'image/*\'"></div></div></div></div><div class="row" align="center" ng-if="!vm.hideUploadButton"><div class="wagon-upload-image-preview" ng-if="vm.file"><img ngf-thumbnail="vm.file"><div style="margin-top: 20px"><button type="button" class="btn btn-danger btn-sm" ng-click="vm.removeImage()" ng-if="vm.showRemoveImageButton"><data-i18n i18n="_mf_remove_image_">Remove image</data-i18n></button></div></div></div><div class="row"><div align="right" style="margin-right: 20px"><button type="submit" class="btn btn-success" ng-disabled="vm.addNewWagonForm.$invalid" ng-click="vm.saveWagon()"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></form></div><div class="row" ng-if="vm.loading" style="text-align: center; overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/mixerWagons/editWagon/editWagon.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/mixerWagons/editWagon/editWagon.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/mixerWagons/editWagon/editWagon.panel.html','<div ng-if="!vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div><div ng-if="vm.selectedHerd"><div ng-if="!vm.loading"><form name="vm.addNewWagonForm" novalidate="" style="width: fit-content; position: relative; left: 0; right: 0; margin: auto"><div class="row" style="width: 600px"><div><div class="form-group has-feedback" style="max-width: 375px" ng-class="{\'has-error\': vm.addNewWagonForm.wagon_name.$invalid && (vm.addNewWagonForm.wagon_name.$dirty || vm.addNewWagonForm.$submitted)}"><label for="wagon_name"><data-i18n i18n="_m_f_wagons_name_">Mixer wagon name</data-i18n></label> <input type="text" maxlength="60" class="form-control" id="wagon_name" name="wagon_name" placeholder="{{\'_m_f_wagons_name_\' | i18n}}" ng-model="vm.wagon.name" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_wagons_name_required_" select-on-click="">Mixer wagon name required</data-i18n></span></div><div class="form-group has-feedback" style="max-width: 375px" ng-class="{\'has-error\': vm.addNewWagonForm.mac_address.$invalid && (vm.addNewWagonForm.mac_address.$dirty || vm.addNewWagonForm.$submitted)}"><label for="mac_address"><data-i18n i18n="_m_f_premix_mac_label_">MAC address</data-i18n></label> <input type="text" class="form-control" id="mac_address" name="mac_address" placeholder="xx:xx:xx:xx:xx:xx" pattern="^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$" maxlength="17" ng-model="vm.wagon.mac_address"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_premix_mac_required_label_" select-on-click="">MAC address is required</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.addNewWagonForm.volume.$invalid && (vm.addNewWagonForm.volume.$dirty || vm.addNewWagonForm.$submitted)}" style="max-width: 500px"><label style="display: block"><data-i18n i18n="_m_f_wagons_capacity_">capacity</data-i18n></label> <input type="number" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" class="form-control with-units" id="volume" name="volume" placeholder="{{\'_m_f_wagons_volume_\'|i18n}}" ng-model="vm.wagon.volume" min="0" max="90" step="0.1" select-on-click=""><span>m<sup>3</sup></span></div><div class="form-group" ng-class="{\'has-error\': vm.addNewWagonForm.weight.$invalid && (vm.addNewWagonForm.weight.$dirty || vm.addNewWagonForm.$submitted)}" style="max-width: 500px"><input type="number" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" class="form-control with-units" id="weight" name="weight" placeholder="{{\'_m_f_wagons_weight_\'|i18n}}" ng-model="vm.wagon.weight" required="" min="0.1" max="90" step="0.1" select-on-click=""><span><data-i18n ng-if="vm.settings.use_kgs" i18n="_m_f_wagons_tonnes_">Tonnes</data-i18n><data-i18n ng-if="!vm.settings.use_kgs" i18n="_m_f_wagons_imperial_tonnes_">Tonnes</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_wagons_weight_required_" select-on-click="">weight is required</data-i18n></span></div></div></div><div class="row"><span class="form-group"><label><data-i18n i18n="_m_f_wagons_picture_">Pictures</data-i18n></label></span></div><div class="row" ng-if="!vm.file && !vm.hideUrlInput"><div class="form-group" style="max-width: 500px; display: flex; flex-direction: row" ng-class="{\'has-error\': vm.addNewWagonForm.image_url.$invalid}"><input class="form-control with-units" type="url" placeholder="{{\'_enter_image_url_\' | i18n}}" style="margin-top: 10px" ng-model="vm.wagon.image_url" id="image_url" name="image_url" ng-change="vm.imageUrlChanged()"><div ng-if="!vm.file && !vm.wagon.image_url"><div class="wagon-upload-button"><a class="ion-upload primaryModal" style="font-size: 50px" ng-click="vm.openFileSystem()"></a></div><div ng-show="false"><input type="file" class="btn btn-primary btn-with-icon save-profile" ngf-select="" ng-model="vm.file" name="file" ngf-accept="\'image/*\'" ngf-max-size="10MB" ngf-change="vm.uploadChanged()" id="up_button" ngf-pattern="\'image/*\'"></div></div></div></div><div class="row" align="center" ng-if="!vm.hideUploadButton"><div class="wagon-upload-image-preview" ng-if="vm.file || vm.wagon.image_url"><img ngf-thumbnail="vm.file" ng-if="vm.file"> <img ng-if="vm.wagon.image_url" ng-src="{{vm.wagon.image_url}}"><div style="margin-top: 20px"><button type="button" class="btn btn-danger btn-sm" ng-click="vm.removeImage()" ng-if="vm.showRemoveImageButton"><data-i18n i18n="_mf_remove_image_">Remove image</data-i18n></button></div></div></div><div class="row"><div align="right"><button type="submit" class="btn btn-success" ng-disabled="vm.addNewWagonForm.$invalid" ng-click="vm.saveWagon()"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></form></div><div class="row" ng-if="vm.loading" style="text-align: center; overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/mixerWagons/myWagons/confirmationDialog.modal.html','<div class="modal-content"><div class="modal-header" ng-if="!vm.modalLoading"><div align="center"><span class="ion-android-warning warningModal" style="font-size: 36px"></span></div><div align="center"><span class="warningModal">{{vm.warningMessage | i18n}}</span></div></div><div class="modal-body" ng-if="!vm.modalLoading"><div align="center"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="vm.proceedDelete()"><data-i18n i18n="_btn_delete_">Delete</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="$dismiss()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div style="height: 200px; overflow: hidden" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/mixerWagons/myWagons/image.modal.html','<div class="modal-content" ng-cloak=""><div><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><div class="modal-wagon-image" style="margin-top: 0px"><img src="assets/img/logo_head.png" lazy-img="{{vm.wagon_image}}" lazy-img-error="assets/img/logo_head.png" ng-if="vm.wagon_image"> <img ng-src="assets/img/logo_head.png" ng-if="!vm.wagon_image"></div></div></div></div>');
$templateCache.put('app/pages/mixerWagons/myWagons/myWagons.cards.html','<div class="grid-card-wrapper horizontal-scroll"><div ng-repeat="wagon in vm.wagons"><div class="grid-card-header"><div class="shorten-long-text" uib-tooltip="{{wagon.name}}" tooltip-enable="{{wagon.name.length > 30 ? true : false}}" tooltip-placement="bottom" tooltip-class="customBlue bottom wrap-text">{{wagon.name}}</div><div><button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToWagonHistory(wagon)" uib-tooltip="{{\'_tips_history_\' | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="left" tooltip-class="customBlue medium left" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editWagon(wagon, $index)" uib-tooltip="{{\'_tips_edit_\' | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="left" tooltip-class="customBlue medium left" tooltip-popup-delay="750"><i class="ion-edit"></i></button></div></div><hr class="separator"><div><div class="card-wagon-image" ng-click="vm.showImage(wagon)"><img src="assets/img/MmmLogo.png" lazy-img="{{wagon.image_url}}" lazy-img-error="assets/img/MmmLogo.png" ng-if="wagon.image_url"> <img ng-src="assets/img/MmmLogo.png" ng-if="!wagon.image_url"></div><div><table class="table"><tbody><td><span ng-if="wagon.volume">{{wagon.volume}}<span>m<sup>3</sup></span><br></span> {{wagon.weight | number: 2}} <span><data-i18n ng-if="vm.settings.use_kgs" i18n="_m_f_wagons_tonnes_">Tonnes</data-i18n><data-i18n ng-if="!vm.settings.use_kgs" i18n="_m_f_wagons_imperial_tonnes_">Tonnes</data-i18n></span><br><span ng-if="wagon.mac_address">{{wagon.mac_address}}</span></td></tbody></table></div></div><div align="right"><button class="btn btn-danger btn-xs" ng-click="vm.deleteWagon($index, wagon)"><data-i18n i18n="_btn_delete_"></data-i18n></button></div></div></div><div align="center" ng-if="!vm.loadingTable && vm.totalItems > vm.wagons.length"><button class="btn btn-primary" ng-click="vm.paginationChanged()"><data-i18n i18n="_m_f_title_load_more_">Load more</data-i18n></button></div><div style="overflow: hidden" ng-if="vm.loadingTable"><loading-spinner-large></loading-spinner-large></div>');
$templateCache.put('app/pages/mixerWagons/myWagons/myWagons.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/mixerWagons/myWagons/myWagons.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/mixerWagons/myWagons/myWagons.panel.html','<div class="row" ng-if="!vm.loading && vm.selectedHerd"><div class="btn-group" style="float: right"><button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(1)" ng-class="vm.selectedLayout == 1 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th-list" ng-class="vm.selectedLayout == 1 ? \'glyphicon glyphicon-th-list selected\' : \'glyphicon glyphicon-th-list\'"></span></button> <button id="grid" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(2)" ng-class="vm.selectedLayout == 2 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th" ng-class="vm.selectedLayout == 2 ? \'glyphicon glyphicon-th selected selected\' : \'glyphicon glyphicon-th\'"></span></button></div></div><div class="row" ng-if="vm.selectedLayout == 1"><div include-with-scope="app/pages/mixerWagons/myWagons/myWagons.table.html"></div></div><div class="row" ng-if="vm.selectedLayout == 2"><div include-with-scope="app/pages/mixerWagons/myWagons/myWagons.cards.html"></div></div><div class="row" ng-if="vm.loading"><loading-spinner-large></loading-spinner-large></div><div class="row" ng-if="!vm.loading && !vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div>');
$templateCache.put('app/pages/mixerWagons/myWagons/myWagons.table.html','<div class="horizontal-scroll" ng-if="!vm.loading && vm.selectedHerd"><table class="table table-hover" style="font-size: 14px"><thead><tr class="sortable"><th><data-i18n i18n="_title_column_action_">Action</data-i18n></th><th><data-i18n i18n="_label_name_">Name</data-i18n></th><th><data-i18n i18n="_m_f_wagons_capacity_">Capacity</data-i18n></th><th><data-i18n i18n="_m_f_premix_mac_label_">MAC address</data-i18n></th><th><data-i18n i18n="_m_f_wagons_calibration_start_weight_">Calibration start weight</data-i18n></th><th><data-i18n i18n="_m_f_wagons_calibration_finish_weight_">Calibration finish weight</data-i18n></th><th><data-i18n i18n="_m_f_wagons_is_calibrated_">Is calibrated?</data-i18n></th><th><data-i18n i18n="_m_f_wagons_picture_">Picture</data-i18n></th><th style="text-align: center"><data-i18n i18n="_m_f_wagons_remove_">Remove wagon</data-i18n></th></tr></thead><tbody style="vertical-align: top"><tr ng-repeat="wagon in vm.wagons"><td style="min-width: 120px; vertical-align: middle"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToWagonHistory(wagon)" uib-tooltip="{{\'_tips_history_\' | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editWagon(wagon, $index)" uib-tooltip="{{\'_tips_edit_\' | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button></td><td style="vertical-align: middle" class="shorten-long-text" uib-tooltip="{{wagon.name}}" tooltip-enable="{{wagon.name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{wagon.name}}</td><td style="vertical-align: middle"><span ng-if="wagon.volume">{{wagon.volume}}<span style="margin-left: 3px">m<sup>3</sup></span><br></span> {{wagon.weight | number: 2}}<span style="margin-left: 3px"><data-i18n ng-if="vm.settings.use_kgs" i18n="_m_f_wagons_tonnes_">Tonnes</data-i18n><data-i18n ng-if="!vm.settings.use_kgs" i18n="_m_f_wagons_imperial_tonnes_">Tonnes</data-i18n></span></td><td style="vertical-align: middle">{{wagon.mac_address || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td style="vertical-align: middle">{{wagon.calibration_start_weight | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</td><td style="vertical-align: middle">{{wagon.calibration_final_weight | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</td><td style="vertical-align: middle"><a class="ion-checkmark-round primaryModal" ng-if="wagon.is_calibrated"></a><a ng-if="!wagon.is_calibrated" class="ion-close-round warningModal"></a></td><td style="vertical-align: middle"><div class="wagon-image" ng-click="vm.showImage(wagon)" style="margin-top: 0px; display: table-cell; text-align: center; vertical-align: middle"><img src="assets/img/MmmLogo.png" lazy-img="{{wagon.image_url}}" lazy-img-error="assets/img/MmmLogo.png" ng-if="wagon.image_url"> <img ng-src="assets/img/MmmLogo.png" ng-if="!wagon.image_url"></div></td><td style="vertical-align: middle; text-align: center;"><button class="btn btn-danger btn-xs" ng-click="vm.deleteWagon($index, wagon)"><data-i18n i18n="_btn_delete_"></data-i18n></button></td></tr></tbody><tfoot ng-if="!vm.loadingTable && vm.totalItems > vm.wagons.length"><tr><td colspan="9" style="text-align: center"><button class="btn btn-primary" ng-click="vm.paginationChanged()"><data-i18n i18n="_m_f_title_load_more_">Load more</data-i18n></button></td></tr></tfoot><tfoot ng-if="vm.loadingTable"><tr><td colspan="9"><loading-spinner-large></loading-spinner-large></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/mixerWagons/wagonHistory/wagonHistory.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/mixerWagons/wagonHistory/wagonHistory.table.html"></div></div></div></div></div>');
$templateCache.put('app/pages/mixerWagons/wagonHistory/wagonHistory.table.html','<div ng-if="!vm.loading"><button class="btn btn-primary btn-xs" ng-click="vm.back()" style="margin-left: 6px; margin-top: 6px"><i class="ion-arrow-left-c"></i>&nbsp;<data i18n="_btn_back_">Back</data></button><div class="horizontal-scroll"><table class="table table-hover mwagTable" style="font-size: 14px"><thead><tr class="sortable"><th><data-i18n i18n="_label_name_">Name</data-i18n></th><th><data-i18n i18n="_m_f_wagons_capacity_">Capacity</data-i18n></th><th><data-i18n i18n="_m_f_wagons_picture_">Picture</data-i18n></th><th><data-i18n i18n="_title_user_">User</data-i18n></th><th><data-i18n i18n="_title_last_modified_date_">last modified date</data-i18n></th></tr></thead><tbody><tr ng-repeat="wagon in vm.wagons"><td class="shorten-long-text" uib-tooltip="{{wagon.name}}" tooltip-enable="{{wagon.name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{wagon.name}}</td><td>{{wagon.volume}}<span style="margin-left: 3px">m<sup>3</sup></span><br>{{wagon.weight}}<span style="margin-left: 3px"><data-i18n ng-if="vm.settings.use_kgs" i18n="_m_f_wagons_tonnes_">Tonnes</data-i18n><data-i18n ng-if="!vm.settings.use_kgs" i18n="_m_f_wagons_imperial_tonnes_">Tonnes</data-i18n></span></td><td><div class="wagon-image" ng-click="vm.showImage(wagon)" style="margin-top: 0px; display: table-cell; text-align: center; vertical-align: middle"><img src="assets/img/MmmLogo.png" lazy-img="{{wagon.image_url}}" lazy-img-error="assets/img/MmmLogo.png" ng-if="wagon.image_url"> <img ng-src="assets/img/MmmLogo.png" ng-if="!wagon.image_url"></div></td><td>{{wagon.last_modified_user_id}}</td><td>{{wagon.last_modified_date | date:\'short\'}}</td></tr></tbody><tfoot ng-if="!vm.loadingTable && vm.totalItems > vm.wagons.length"><tr><td colspan="5" style="text-align: center"><button class="btn btn-primary" ng-click="vm.paginationChanged()"><data-i18n i18n="_m_f_title_load_more_">Load more</data-i18n></button></td></tr></tfoot><tfoot ng-if="vm.loadingTable"><tr><td colspan="5" style="text-align: center"><loading-spinner-large></loading-spinner-large></td></tr></tfoot></table></div></div><loading-spinner-large ng-if="vm.loading"></loading-spinner-large>');
$templateCache.put('app/pages/pens/addNewPen/addCategory.modal.html','<div class="modal-content" ng-cloak=""><div class="modal-header"><div ng-if="!vm.addCategoryLoading"><form name="vm.addCategoryForm" novalidate=""><div class="panel"><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.addCategoryForm.category_name.$invalid && (vm.addCategoryForm.category_name.$dirty || vm.addCategoryForm.$submitted)}"><label for="category_name" class="span-label"><data-i18n i18n="_m_f_add_new_pen_add_category_name_">category name</data-i18n></label> <input type="text" class="form-control" id="category_name" name="category_name" placeholder="{{\'_m_f_add_new_pen_add_category_name_\' | i18n}}" ng-model="vm.newCategory.name" required=""></div><div class="form-group" ng-class="{\'has-error\': vm.addCategoryForm.feed_intake.$invalid && (vm.addCategoryForm.feed_intake.$dirty || vm.addCategoryForm.$submitted)}"><label for="feed_intake" class="span-label"><data-i18n i18n="_feeds_dmi_">dmi</data-i18n></label> <input type="number" step="any" min="0.5" ng-max="vm.max" class="form-control with-units" id="feed_intake" name="feed_intake" placeholder="{{\'_feeds_dmi_\' | i18n}}" ng-model="vm.newCategory.feed_intake" format-input-value="amount" required="" style="width: 50%; display: inline-block"><span style="display: inline-block">{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n>/<data-i18n i18n="_unit_day_"></data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_pen_feed_intake_required_">feed intake is required</data-i18n>&nbsp;{{vm.max}}/{{vm.weight}}&nbsp;DM</span></div></div></div><div align="right"><button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button> <button type="submit" class="btn btn-info btn-with-icon save-profile" ng-click="vm.addNewCategory()" ng-disabled="vm.addCategoryForm.$invalid"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></form></div><div style="height: 200px; overflow: hidden" ng-if="vm.addCategoryLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/pens/addNewPen/addNewPen.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll horizontal-scrol"><ba-wizard id="add-pen-tabs" ng-show="!vm.loading && vm.selectedHerd" class="pen-tabs" ng-class="vm.tabValidation()"><ba-wizard-step title="{{\'_m_f_add_new_pen_step1_title_\'|i18n}}" form="vm.basicInfoForm" class="wizard-step"><div align="right"><button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.basicInfoForm" novalidate="" class="add-pen-basic-info-form"><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicInfoForm.pen_name.$invalid && (vm.basicInfoForm.pen_name.$dirty || vm.basicInfoForm.$submitted)}"><label for="pen_name"><data-i18n i18n="_m_f_pen_name_">pen name</data-i18n></label> <input type="text" maxlength="60" class="form-control" id="pen_name" name="pen_name" placeholder="{{\'_m_f_pen_name_\' | i18n}}" ng-model="vm.pen.pen_name" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_pen_name_required_">pen name is required</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.basicInfoForm.numberOfAnimals.$invalid && (vm.basicInfoForm.numberOfAnimals.$dirty || vm.basicInfoForm.$submitted)}"><label for="numberOfAnimals"><data-i18n i18n="_groups_no_animals_">number of animals</data-i18n></label> <input type="number" class="form-control" id="numberOfAnimals" ng-pattern="/^\\d*$/" name="numberOfAnimals" placeholder="{{\'_groups_no_animals_\'|i18n}}" ng-model="vm.pen.number_of_animals" required="" min="1" max="99999" step="1" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_no_animals_required_">number of animals is required</data-i18n></span></div><div class="form-group" style="margin-left: 0.5px"><label for="automaticUpdateSwitch"><data-i18n i18n="_m_f_pen_automatic_update_">automatic update</data-i18n></label><div><toggle-switch ng-model="vm.automatic_update" on-label="{{\'_m_f_title_yes_\' | i18n}}" off-label="{{\'_m_f_title_no_\' | i18n}}" class="switch-primary" style="width: 120px" id="automaticUpdateSwitch"></toggle-switch></div></div><div class="form-group"><label for="pen_location"><data-i18n i18n="_m_f_pen_address_">location</data-i18n></label> <input type="text" class="form-control" id="pen_address" name="pen_address" placeholder="{{\'_m_f_pen_address_\'|i18n}}" ng-model="vm.pen.pen_address"></div></div><div class="col-md-6"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.basicInfoForm.category.$invalid && vm.basicInfoForm.$submitted}"><label for="breed"><data-i18n i18n="_m_f_title_category_">category</data-i18n></label><ui-select ng-model="vm.selected_pen_category" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" required="" id="category" name="category" ng-change="vm.categorySelected()"><ui-select-match placeholder="{{\'_m_f_placeholder_select_category_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="category in vm.categories | filter: $select.search"><span ng-bind-html="category.name"></span></ui-select-choices><div class="ui-select-choices-row ng-scope active"><span>adasd</span></div></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_m_f_pen_category_required_">category is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicInfoForm.feed_intake.$invalid && (vm.basicInfoForm.feed_intake.$dirty || vm.basicInfoForm.$submitted)}"><label for="feed_intake"><data-i18n i18n="_feeds_dmi_">dmi</data-i18n>&nbsp;({{vm.weight}}&nbsp;<data i18n="_feeds_dm_">DM</data>/<data i18n="_unit_day_">day</data>)</label> <input type="number" min="0.5" ng-max="vm.max" class="form-control" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" id="feed_intake" name="feed_intake" placeholder="{{\'_feeds_dmi_\' | i18n}}" ng-model="vm.pen.feed_intake" format-input-value="amount" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_pen_feed_intake_required_">feed intake is required</data-i18n>&nbsp;{{vm.max}}/{{vm.weight}}&nbsp;<data i18n="_feeds_dm_">DM</data>/<data i18n="_unit_day_">day</data></span></div></div><div class="col-md-6"><div class="form-group"><label for="chooseFeedIntakeSwitch"><data-i18n i18n="_m_f_pen_choose_pen_inake_source_">Choose feed intake source</data-i18n></label><div><toggle-switch ng-model="vm.pen.use_pen_feed_intake" on-label="{{\'_m_f_fixed_\' | i18n}}" off-label="{{\'_m_f_ration_depending_\' | i18n}}" ng-style="vm.settings.language == \'nl-nl\' ? {\'width\': \'290px\'} : vm.settings.language == \'cs-cz\' ? {\'width\' : \'310px\'} : vm.settings.language == \'es-es\' ? {\'width\': \'340\'} : vm.settings.language == \'it-it\' ? {\'width\': \'280\'} : {\'width\' : \'260px\'}" class="switch-primary" id="chooseFeedIntakeSwitch"></toggle-switch></div></div></div></div><div class="form-group" ng-class="{\'has-error\': vm.basicInfoForm.number_of_cubicles.$invalid && (vm.basicInfoForm.number_of_cubicles.$dirty || vm.basicInfoForm.$submitted)}"><label for="numberOfAnimals"><data-i18n i18n="_m_f_pen_number_of_cubicles_">number of cubicles</data-i18n></label> <input type="number" class="form-control" id="number_of_cubicles" ng-pattern="/^\\d*$/" name="number_of_cubicles" placeholder="{{\'_m_f_pen_number_of_cubicles_\'|i18n}}" ng-model="vm.pen.number_of_cubicles" min="1" max="99999" step="1" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_pen_number_of_cubicles_required_">number of cubicles is required</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.basicInfoForm.number_of_headlocks.$invalid && (vm.basicInfoForm.number_of_headlocks.$dirty || vm.basicInfoForm.$submitted)}"><label for="number_of_headlocks"><data-i18n i18n="_m_f_pen_number_of_headlocks_">number of headlocks</data-i18n></label> <input type="number" class="form-control" id="number_of_headlocks" ng-pattern="/^\\d*$/" name="number_of_headlocks" placeholder="{{\'_m_f_pen_number_of_headlocks_\'|i18n}}" ng-model="vm.pen.number_of_headlocks" min="1" max="99999" step="1" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_pen_number_of_headlocks_required_">number of headlocks is required</data-i18n></span></div></div></div></form></ba-wizard-step><ba-wizard-step title="{{\'_m_f_add_new_pen_step2_title_\'|i18n}}" form="vm.feedingInfoForm" class="wizard-step"><div align="right"><button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><div include-with-scope="app/pages/pens/addNewPen/customFrequency.table.html"></div></ba-wizard-step><ba-wizard-step title="{{\'_m_f_add_new_pen_step3_title_\'|i18n}}" class="wizard-step"><div class="form-group"><label for="penActive"><data-i18n i18n="_m_f_pen_is_active_">Is this pen active</data-i18n></label><br><toggle-switch ng-model="vm.pen_active" on-label="{{\'_m_f_title_yes_\' | i18n}}" off-label="{{\'_m_f_title_no_\' | i18n}}" class="switch-primary" style="width: 120px" id="penActive"></toggle-switch></div><form class="form-horizontal" name="vm.finishForm" novalidate=""><div><data-i18n i18n="_m_f_add_new_pen_finish_message_">You have successfully defined a new pen. Do you want to save your work?</data-i18n></div></form><div style="margin-top: 10px" align="right"><button type="button" class="btn btn-success" ng-click="vm.savePen()"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_"></data-i18n></button></div></ba-wizard-step></ba-wizard><div ng-if="!vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div><div ng-if="vm.loading && vm.selectedHerd" align="center"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/pens/addNewPen/customFrequency.table.html','<div class="horizontal-scroll" style="vertical-align: top"><form name="vm.feedingInfoForm" novalidate=""><table class="table custom-feeding-frequency"><thead><tr><th></th><th><span><data-i18n i18n="_m_f_pen_feeding_start_date_">number of feedings per day</data-i18n></span></th><th><span><data-i18n i18n="_m_f_pen_number_of_feedings_per_day_">number of feedings per day</data-i18n></span></th><th><span><data-i18n i18n="_m_f_pen_frequency_of_feeding_">frequency of feeding</data-i18n></span></th></tr></thead><tbody ng-if="!vm.resetTable"><tr ng-repeat="rule in vm.feedingRules" class="feeding-rule-row"><td style="width: 2.5%"><button ng-if="$index == 0" class="btn btn-primary btn-sm add-rule-btn" ng-click="vm.addRule($event)" uib-tooltip="{{\'_m_f_pen_add_new_rule_\' | i18n}}" tooltip-is-open="addNewRuleIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="fa fa-plus"></i></button></td><td style="width: 25%; min-width: 180px"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.feedingInfoForm.feeding_date_{{rule.id}}.$invalid && (vm.feedingInfoForm.feeding_date_{{rule.id}}.$dirty || vm.feedingInfoForm.$submitted)}"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" placeholder="{{vm.date_format}}" ng-model="rule.feeding_date" is-open="rule.datePickerOpened" required="" datepicker-append-to-body="true" close-text="Close" show-button-bar="false" id="feeding_date_{{rule.id}}" name="feeding_date_{{rule.id}}" popup-placement="bottom-left" ng-change="vm.sortRules(rule.feeding_date, rule.id)"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="rule.datePickerOpened = !rule.datePickerOpened"><i class="glyphicon glyphicon-calendar"></i></button></span></p><span class="help-block error-block basic-block"><data-i18n i18n="_date_format_validation_label_">date required</data-i18n>&nbsp;{{vm.date_format}}</span></div></td><td style="width: 35%; min-width: 280px"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.feedingInfoForm.number_of_feedings_{{rule.id}}.$invalid && (vm.feedingInfoForm.number_of_feedings_{{rule.id}}.$dirty || vm.feedingInfoForm.$submitted)}"><ui-select ng-model="rule.selected_number_of_feedings" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" required="" id="number_of_feedings_{{rule.id}}" name="number_of_feedings_{{rule.id}}" ng-change="vm.numberOfFeedingsChanged(rule)"><ui-select-match placeholder="{{\'_m_f_placeholder_select_number_of_feedings_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="feeding in vm.no_feedings | filter: $select.search"><span ng-bind-html="feeding.name"></span></ui-select-choices></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_m_f_pen_number_of_feedings_per_day_required_">number of feedings is required</data-i18n></span></div><div class="custom-time-pickers"><div class="form-group has-feedback" ng-if="rule.selected_number_of_feedings.value === 1 || rule.selected_number_of_feedings.value === 2 || rule.selected_number_of_feedings.value === 3" ng-class="{\'has-error\': vm.feedingInfoForm.feeding_period_1_{{rule.id}}.$invalid && (vm.feedingInfoForm.feeding_period_1_{{rule.id}}.$dirty || vm.feedingInfoForm.$submitted)}"><label for="feeding_period_1_{{rule.id}}"><data-i18n i18n="_m_f_feeding_period_label_">Feeding period</data-i18n>:&nbsp;{{rule.feeding_period_1.name}}</label><div class="input-group"><input pen-time-validator="" time-validator-model="rule" class="form-control" id="feeding_period_1_{{rule.id}}" name="feeding_period_1_{{rule.id}}" placeholder="--:-- --" ng-model="rule.ft_1" ng-model-options="{allowInvalid: true, updateOn: \'blur\'}" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" moment-picker="rule.ft_1" ng-model="rule.feeding_time_1" change="vm.timeChanged(rule, \'feeding_period_1\', \'feeding_time_1\')" format="hh:mm A" locale="{{vm.locale}}" ng-model-options="{ updateOn: \'blur\' }"><i class="glyphicon glyphicon-time"></i></button></span></div></div><div class="form-group has-feedback" ng-if="rule.selected_number_of_feedings.value === 2 || rule.selected_number_of_feedings.value === 3" ng-class="{\'has-error\': vm.feedingInfoForm.feeding_period_2_{{rule.id}}.$invalid && (vm.feedingInfoForm.feeding_period_2_{{rule.id}}.$dirty || vm.feedingInfoForm.$submitted)}"><label for="feeding_period_2_{{rule.id}}"><data-i18n i18n="_m_f_feeding_period_label_">Feeding period</data-i18n>:&nbsp;{{rule.feeding_period_2.name}}</label><div class="input-group"><input pen-time-validator="" time-validator-model="rule" class="form-control" id="feeding_period_2_{{rule.id}}" name="feeding_period_2_{{rule.id}}" placeholder="--:-- --" ng-model="rule.ft_2" ng-model-options="{allowInvalid: true, updateOn: \'blur\'}" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" moment-picker="rule.ft_2" ng-model="rule.feeding_time_2" change="vm.timeChanged(rule, \'feeding_period_2\', \'feeding_time_2\')" format="hh:mm A" locale="{{vm.locale}}" ng-model-options="{ updateOn: \'blur\' }"><i class="glyphicon glyphicon-time"></i></button></span></div></div><div class="form-group has-feedback" ng-if="rule.selected_number_of_feedings.value === 3" ng-class="{\'has-error\': vm.feedingInfoForm.feeding_period_3_{{rule.id}}.$invalid && (vm.feedingInfoForm.feeding_period_3_{{rule.id}}.$dirty || vm.feedingInfoForm.$submitted)}"><label for="feeding_period_3_{{rule.id}}"><data-i18n i18n="_m_f_feeding_period_label_">Feeding period</data-i18n>:&nbsp;{{rule.feeding_period_3.name}}</label><div class="input-group"><input pen-time-validator="" time-validator-model="rule" class="form-control" id="feeding_period_3_{{rule.id}}" name="feeding_period_3_{{rule.id}}" placeholder="--:-- --" ng-model="rule.ft_3" ng-model-options="{allowInvalid: true, updateOn: \'blur\'}" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" moment-picker="rule.ft_3" ng-model="rule.feeding_time_3" change="vm.timeChanged(rule, \'feeding_period_3\', \'feeding_time_3\')" format="hh:mm A" locale="{{vm.locale}}" ng-model-options="{ updateOn: \'blur\' }"><i class="glyphicon glyphicon-time"></i></button></span></div></div></div><div class="pen-error-text" ng-class="{\'pen-error\': (vm.feedingInfoForm.feeding_period_1_{{rule.id}}.$invalid || vm.feedingInfoForm.feeding_period_2_{{rule.id}}.$invalid || vm.feedingInfoForm.feeding_period_3_{{rule.id}}.$invalid || vm.feedingInfoForm[\'feeding_period_1_\' + rule.id].$invalid || vm.feedingInfoForm[\'feeding_period_2_\' + rule.id].$invalid || vm.feedingInfoForm[\'feeding_period_3_\' + rule.id].$invalid) && vm.feedingInfoForm.$submitted}"><span><data-i18n i18n="_m_f_pen_feeding_time_required_">please enter valid feeding time</data-i18n></span></div></td><td ng-if="rule.selected_number_of_feedings.value == 0" style="width: 35%; min-width: 280px"></td><td ng-if="rule.selected_number_of_feedings.value != 0" style="width: 35%; min-width: 280px"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.feedingInfoForm.selected_frequency_{{rule.id}}.$invalid && (vm.feedingInfoForm.selected_frequency_{{rule.id}}.$dirty || vm.feedingInfoForm.$submitted)}"><ui-select ng-model="rule.selected_frequency" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" required="" id="selected_frequency_{{rule.id}}" name="selected_frequency_{{rule.id}}"><ui-select-match placeholder="{{\'_m_f_placeholder_select_feeding_frequency_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="frequency in vm.frequencies | filter: $select.search"><span ng-bind-html="frequency.name"></span></ui-select-choices></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_m_f_pen_frequency_of_feeding_required_">frequency of feeding is required</data-i18n></span></div><div class="row form-group" ng-if="rule.selected_frequency.value == 4"><div class="col-lg-12 col-md-10 col-sm-10 col-xs-10"><div class="weekDays-selector checkbox-inline" ng-repeat="day in rule.customDays"><input type="checkbox" ng-click="vm.daySelected(rule)" ng-model="day.selected" id="custom_frequency_{{rule.id}}_{{$index}}"> <label for="custom_frequency_{{rule.id}}_{{$index}}">{{day.name}}</label></div><div ng-if="!rule.customDaysValidation && vm.feedingInfoForm.$submitted"><span class="warningModal"><data-i18n i18n="_m_f_pen_frequency_of_feeding_required_">frequency of feeding is required</data-i18n></span></div><input required="" type="text" ng-show="false" ng-model="rule.customDaysValidation"></div></div></td><td style="width: 2.5%"><button ng-if="vm.feedingRules.length > 1" class="btn btn-danger btn-sm remove-rule-btn" ng-click="vm.removeRule(rule.id, $event)" uib-tooltip="{{\'_m_f_pen_remove_rule_\' | i18n}}" tooltip-is-open="removeRuleIsOpen_{{$index}}" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><i class="fa fa-remove"></i></button></td></tr></tbody></table></form></div>');
$templateCache.put('app/pages/pens/editPen/activeRecipe.modal.html','<div class="modal-content" ng-cloak=""><div class="modal-body"><div><data-i18n i18n="_m_f_pen_update_message_">Be aware that updating the pen will result in recalculation and the creation of new versions for all active recipes that rely on the current pen.</data-i18n>:</div><div style="max-height: 300px; overflow-y: auto;"><ul><li ng-repeat="recipe in vm.activeRecipesList">{{recipe.name}}</li></ul></div></div><div class="modal-footer"><div align="right"><button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button> <button type="submit" class="btn btn-success" ng-click="vm.savePen()"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/pens/editPen/customFrequency.table.html','<div class="horizontal-scroll" style="vertical-align: top"><form name="vm.feedingInfoForm" novalidate=""><table class="table custom-feeding-frequency"><thead><tr><th></th><th><span><data-i18n i18n="_m_f_pen_feeding_start_date_">number of feedings per day</data-i18n></span></th><th><span><data-i18n i18n="_m_f_pen_number_of_feedings_per_day_">number of feedings per day</data-i18n></span></th><th><span><data-i18n i18n="_m_f_pen_frequency_of_feeding_">frequency of feeding</data-i18n></span></th></tr></thead><tbody ng-if="!vm.resetTable"><tr ng-repeat="rule in vm.feedingRules" class="feeding-rule-row"><td style="width: 2.5%"><button ng-if="$index == 0" class="btn btn-primary btn-sm add-rule-btn" ng-click="vm.addRule($event)" uib-tooltip="{{\'_m_f_pen_add_new_rule_\' | i18n}}" tooltip-is-open="addNewRuleIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="fa fa-plus"></i></button></td><td style="width: 25%; min-width: 180px"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.feedingInfoForm.feeding_date_{{rule.id}}.$invalid && (vm.feedingInfoForm.feeding_date_{{rule.id}}.$dirty || vm.feedingInfoForm.$submitted)}"><p class="input-group"><input ng-disabled="vm.disableColumn(rule)" type="text" class="form-control" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" placeholder="{{vm.date_format}}" ng-model="rule.feeding_date" is-open="rule.datePickerOpened" required="" datepicker-append-to-body="true" close-text="Close" show-button-bar="false" id="feeding_date_{{rule.id}}" name="feeding_date_{{rule.id}}" popup-placement="bottom-left" ng-change="vm.sortRules(rule.feeding_date, rule.id)"> <span class="input-group-btn"><button ng-disabled="vm.disableColumn(rule)" type="button" class="btn btn-default" ng-click="rule.datePickerOpened = !rule.datePickerOpened"><i class="glyphicon glyphicon-calendar"></i></button></span></p><span class="help-block error-block basic-block"><data-i18n i18n="_date_format_validation_label_">date required</data-i18n>&nbsp;{{vm.date_format}}</span></div></td><td style="width: 35%; min-width: 280px"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.feedingInfoForm.number_of_feedings_{{rule.id}}.$invalid && (vm.feedingInfoForm.number_of_feedings_{{rule.id}}.$dirty || vm.feedingInfoForm.$submitted)}"><ui-select ng-disabled="vm.disableColumn(rule)" ng-model="rule.selected_number_of_feedings" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" required="" id="number_of_feedings_{{rule.id}}" name="number_of_feedings_{{rule.id}}" ng-change="vm.numberOfFeedingsChanged(rule)"><ui-select-match placeholder="{{\'_m_f_placeholder_select_number_of_feedings_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="feeding in vm.no_feedings | filter: $select.search"><span ng-bind-html="feeding.name"></span></ui-select-choices></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_m_f_pen_number_of_feedings_per_day_required_">number of feedings is required</data-i18n></span></div><div class="custom-time-pickers"><div class="form-group has-feedback" ng-if="rule.selected_number_of_feedings.value === 1 || rule.selected_number_of_feedings.value === 2 || rule.selected_number_of_feedings.value === 3" ng-class="{\'has-error\': vm.feedingInfoForm.feeding_period_1_{{rule.id}}.$invalid && (vm.feedingInfoForm.feeding_period_1_{{rule.id}}.$dirty || vm.feedingInfoForm.$submitted)}"><label for="feeding_period_1_{{rule.id}}"><data-i18n i18n="_m_f_feeding_period_label_">Feeding period</data-i18n>:&nbsp;{{rule.feeding_period_1.name}}</label><div class="input-group"><input pen-time-validator="" time-validator-model="rule" ng-disabled="vm.disableColumn(rule)" class="form-control" id="feeding_period_1_{{rule.id}}" name="feeding_period_1_{{rule.id}}" placeholder="--:-- --" ng-model="rule.ft_1" ng-model-options="{allowInvalid: true, updateOn: \'blur\'}" ng-change="vm.setPenEvent()" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" moment-picker="rule.ft_1" ng-model="rule.feeding_time_1" change="vm.timeChanged(rule, \'feeding_period_1\', \'feeding_time_1\')" format="hh:mm A" locale="{{vm.locale}}" ng-model-options="{ updateOn: \'blur\' }" ng-disabled="vm.disableColumn(rule)"><i class="glyphicon glyphicon-time"></i></button></span></div></div><div class="form-group has-feedback" ng-if="rule.selected_number_of_feedings.value === 2 || rule.selected_number_of_feedings.value === 3" ng-class="{\'has-error\': vm.feedingInfoForm.feeding_period_2_{{rule.id}}.$invalid && (vm.feedingInfoForm.feeding_period_2_{{rule.id}}.$dirty || vm.feedingInfoForm.$submitted)}"><label for="feeding_period_2_{{rule.id}}"><data-i18n i18n="_m_f_feeding_period_label_">Feeding period</data-i18n>:&nbsp;{{rule.feeding_period_2.name}}</label><div class="input-group"><input pen-time-validator="" time-validator-model="rule" ng-disabled="vm.disableColumn(rule)" class="form-control" id="feeding_period_2_{{rule.id}}" name="feeding_period_2_{{rule.id}}" placeholder="--:-- --" ng-model="rule.ft_2" ng-model-options="{allowInvalid: true, updateOn: \'blur\'}" ng-change="vm.setPenEvent()" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" moment-picker="rule.ft_2" ng-model="rule.feeding_time_2" change="vm.timeChanged(rule, \'feeding_period_2\', \'feeding_time_2\')" format="hh:mm A" locale="{{vm.locale}}" ng-model-options="{ updateOn: \'blur\' }" ng-disabled="vm.disableColumn(rule)"><i class="glyphicon glyphicon-time"></i></button></span></div></div><div class="form-group has-feedback" ng-if="rule.selected_number_of_feedings.value === 3" ng-class="{\'has-error\': vm.feedingInfoForm.feeding_period_3_{{rule.id}}.$invalid && (vm.feedingInfoForm.feeding_period_3_{{rule.id}}.$dirty || vm.feedingInfoForm.$submitted)}"><label for="feeding_period_3_{{rule.id}}"><data-i18n i18n="_m_f_feeding_period_label_">Feeding period</data-i18n>:&nbsp;{{rule.feeding_period_3.name}}</label><div class="input-group"><input pen-time-validator="" time-validator-model="rule" ng-disabled="vm.disableColumn(rule)" class="form-control" id="feeding_period_3_{{rule.id}}" name="feeding_period_3_{{rule.id}}" placeholder="--:-- --" ng-model="rule.ft_3" ng-model-options="{allowInvalid: true, updateOn: \'blur\'}" ng-change="vm.setPenEvent()" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" moment-picker="rule.ft_3" ng-model="rule.feeding_time_3" change="vm.timeChanged(rule, \'feeding_period_3\', \'feeding_time_3\')" format="hh:mm A" locale="{{vm.locale}}" ng-model-options="{ updateOn: \'blur\' }" ng-disabled="vm.disableColumn(rule)"><i class="glyphicon glyphicon-time"></i></button></span></div></div></div><div class="pen-error-text" ng-class="{\'pen-error\': (vm.feedingInfoForm.feeding_period_1_{{rule.id}}.$invalid || vm.feedingInfoForm.feeding_period_2_{{rule.id}}.$invalid || vm.feedingInfoForm.feeding_period_3_{{rule.id}}.$invalid || vm.feedingInfoForm[\'feeding_period_1_\' + rule.id].$invalid || vm.feedingInfoForm[\'feeding_period_2_\' + rule.id].$invalid || vm.feedingInfoForm[\'feeding_period_3_\' + rule.id].$invalid) && vm.feedingInfoForm.$submitted}"><span><data-i18n i18n="_m_f_pen_feeding_time_required_">please enter valid feeding time</data-i18n></span></div></td><td ng-if="rule.selected_number_of_feedings.value == 0" style="width: 35%; min-width: 280px"></td><td ng-if="rule.selected_number_of_feedings.value != 0" style="width: 35%; min-width: 280px"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.feedingInfoForm.selected_frequency_{{rule.id}}.$invalid && (vm.feedingInfoForm.selected_frequency_{{rule.id}}.$dirty || vm.feedingInfoForm.$submitted)}"><ui-select ng-disabled="vm.disableColumn(rule)" ng-model="rule.selected_frequency" ng-change="vm.setPenEvent()" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" required="" id="selected_frequency_{{rule.id}}" name="selected_frequency_{{rule.id}}"><ui-select-match placeholder="{{\'_m_f_placeholder_select_feeding_frequency_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="frequency in vm.frequencies | filter: $select.search"><span ng-bind-html="frequency.name"></span></ui-select-choices></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_m_f_pen_frequency_of_feeding_required_">frequency of feeding is required</data-i18n></span></div><div class="row form-group" ng-if="rule.selected_frequency.value == 4"><div class="col-lg-12 col-md-10 col-sm-10 col-xs-10"><div class="weekDays-selector checkbox-inline" ng-repeat="day in rule.customDays"><input ng-disabled="vm.disableColumn(rule)" type="checkbox" ng-click="vm.daySelected(rule)" ng-model="day.selected" id="custom_frequency_{{rule.id}}_{{$index}}"> <label ng-style="vm.disableColumn(rule) ? {\'opacity\': \'0.9\', \'cursor\': \'not-allowed\'} : {}" for="custom_frequency_{{rule.id}}_{{$index}}">{{day.name}}</label></div><div ng-if="!rule.customDaysValidation && vm.feedingInfoForm.$submitted"><span class="warningModal"><data-i18n i18n="_m_f_pen_frequency_of_feeding_required_">frequency of feeding is required</data-i18n></span></div><input required="" type="text" ng-show="false" ng-model="rule.customDaysValidation"></div></div></td><td style="width: 2.5%"><button ng-disabled="vm.disableColumn(rule)" ng-if="vm.feedingRules.length > 1" class="btn btn-danger btn-sm remove-rule-btn" ng-click="vm.removeRule(rule.id, $event)" uib-tooltip="{{\'_m_f_pen_remove_rule_\' | i18n}}" tooltip-is-open="removeRuleIsOpen_{{$index}}" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><i class="fa fa-remove"></i></button></td></tr></tbody></table></form></div>');
$templateCache.put('app/pages/pens/editPen/editPen.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll horizontal-scrol"><ba-wizard id="edit-pen-tabs" ng-show="!vm.loading" class="pen-tabs" ng-class="vm.tabValidation()"><ba-wizard-step title="{{\'_m_f_add_new_pen_step1_title_\'|i18n}}" form="vm.basicInfoForm" class="wizard-step"><div align="right"><button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.openSaveModal()"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.basicInfoForm" novalidate="" class="add-pen-basic-info-form"><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicInfoForm.pen_name.$invalid && (vm.basicInfoForm.pen_name.$dirty || vm.basicInfoForm.$submitted)}"><label for="pen_name"><data-i18n i18n="_m_f_pen_name_">pen name</data-i18n></label> <input type="text" maxlength="60" class="form-control" id="pen_name" name="pen_name" placeholder="{{\'_m_f_pen_name_\' | i18n}}" ng-model="vm.pen.pen_name" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_pen_name_required_" select-on-click="">pen name is required</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.basicInfoForm.numberOfAnimals.$invalid && (vm.basicInfoForm.numberOfAnimals.$dirty || vm.basicInfoForm.$submitted)}"><label for="numberOfAnimals"><data-i18n i18n="_groups_no_animals_">number of animals</data-i18n></label> <input type="number" class="form-control" id="numberOfAnimals" name="numberOfAnimals" ng-pattern="/^\\d*$/" placeholder="{{\'_groups_no_animals_\'|i18n}}" ng-model="vm.pen.number_of_animals" required="" min="1" max="99999" step="1" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_no_animals_required_" select-on-click="">number of animals is required</data-i18n></span></div><div class="form-group" style="margin-left: 0.5px"><label for="numberOfAnimals"><data-i18n i18n="_m_f_pen_automatic_update_">automatic update</data-i18n></label><div><toggle-switch ng-model="vm.automatic_update" on-label="{{\'_m_f_title_yes_\' | i18n}}" off-label="{{\'_m_f_title_no_\' | i18n}}" class="switch-primary" style="width: 120px" id="automaticUpdateSwitch"></toggle-switch></div></div><div class="form-group"><label for="pen_location"><data-i18n i18n="_m_f_pen_location_">location</data-i18n></label> <input type="text" class="form-control" id="pen_address" name="pen_address" placeholder="{{\'_m_f_pen_address_\'|i18n}}" ng-model="vm.pen.pen_address"></div></div><div class="col-md-6"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.basicInfoForm.category.$invalid && vm.basicInfoForm.$submitted}"><label for="breed"><data-i18n i18n="_m_f_title_category_">category</data-i18n></label><ui-select ng-model="vm.selected_pen_category" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" required="" id="category" name="category" ng-change="vm.categorySelected()"><ui-select-match placeholder="{{\'_m_f_placeholder_select_category_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="category in vm.categories | filter: $select.search"><span ng-bind-html="category.name"></span></ui-select-choices><div class="ui-select-choices-row ng-scope active"><span>adasd</span></div></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_m_f_pen_category_required_">category is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicInfoForm.feed_intake.$invalid && (vm.basicInfoForm.feed_intake.$dirty || vm.basicInfoForm.$submitted)}"><label for="feed_intake"><data-i18n i18n="_feeds_dmi_">dmi</data-i18n>&nbsp;({{vm.weight}}&nbsp;<data i18n="_feeds_dm_">DM</data>/<data i18n="_unit_day_">day</data>)</label> <input type="number" min="0.5" ng-max="vm.max" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" class="form-control" id="feed_intake" name="feed_intake" placeholder="{{\'_feeds_dmi_\' | i18n}}" ng-model="vm.pen.feed_intake" format-input-value="amount" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_pen_feed_intake_required_">feed intake is required</data-i18n>&nbsp;{{vm.max}}/{{vm.weight}}&nbsp;<data i18n="_feeds_dm_">DM</data>/<data i18n="_unit_day_">day</data></span></div></div><div class="col-md-6"><div class="form-group"><label for="chooseFeedIntakeSwitch"><data-i18n i18n="_m_f_pen_choose_pen_inake_source_">Choose feed intake source</data-i18n></label><div><toggle-switch ng-model="vm.pen.use_pen_feed_intake" on-label="{{\'_m_f_fixed_\' | i18n}}" off-label="{{\'_m_f_ration_depending_\' | i18n}}" ng-style="vm.settings.language == \'nl-nl\' ? {\'width\': \'290px\'} : vm.settings.language == \'cs-cz\' ? {\'width\' : \'310px\'} : vm.settings.language == \'es-es\' ? {\'width\': \'340\'} : vm.settings.language == \'it-it\' ? {\'width\': \'280\'} : {\'width\' : \'260px\'}" class="switch-primary" id="chooseFeedIntakeSwitch"></toggle-switch></div></div></div></div><div class="form-group" ng-class="{\'has-error\': vm.basicInfoForm.number_of_cubicles.$invalid && (vm.basicInfoForm.number_of_cubicles.$dirty || vm.basicInfoForm.$submitted)}"><label for="numberOfAnimals"><data-i18n i18n="_m_f_pen_number_of_cubicles_">number of cubicles</data-i18n></label> <input type="number" class="form-control" id="number_of_cubicles" ng-pattern="/^\\d*$/" name="number_of_cubicles" placeholder="{{\'_m_f_pen_number_of_cubicles_\'|i18n}}" ng-model="vm.pen.number_of_cubicles" min="1" max="99999" step="1" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_pen_number_of_cubicles_required_" select-on-click="">number of cubicles is required</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.basicInfoForm.number_of_headlocks.$invalid && (vm.basicInfoForm.number_of_headlocks.$dirty || vm.basicInfoForm.$submitted)}"><label for="number_of_headlocks"><data-i18n i18n="_m_f_pen_number_of_headlocks_">number of headlocks</data-i18n></label> <input type="number" class="form-control" id="number_of_headlocks" ng-pattern="/^[0-9]*$/" name="number_of_headlocks" placeholder="{{\'_m_f_pen_number_of_headlocks_\'|i18n}}" ng-model="vm.pen.number_of_headlocks" min="1" max="99999" step="1" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_pen_number_of_headlocks_required_" select-on-click="">number of headlocks is required</data-i18n></span></div></div></div></form></ba-wizard-step><ba-wizard-step title="{{\'_m_f_add_new_pen_step2_title_\'|i18n}}" form="vm.feedingInfoForm" class="wizard-step"><div align="right"><button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.openSaveModal()"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><div include-with-scope="app/pages/pens/editPen/customFrequency.table.html"></div></ba-wizard-step><ba-wizard-step title="{{\'_m_f_add_new_pen_step3_title_\'|i18n}}" select="vm.test" class="wizard-step"><div class="form-group"><label for="penActive"><data-i18n i18n="_m_f_pen_is_active_">Is this pen active</data-i18n></label><br><toggle-switch ng-model="vm.pen_active" on-label="{{\'_m_f_title_yes_\' | i18n}}" off-label="{{\'_m_f_title_no_\' | i18n}}" class="switch-primary" style="width: 120px" id="penActive"></toggle-switch></div><form class="form-horizontal" name="vm.finishForm" novalidate=""><div style="font-size: 16px"><data-i18n i18n="_m_f_edit_pen_finish_message_">Pen updated. Do you want to save your work?</data-i18n></div></form><div style="margin-top: 10px" align="right"><button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.openSaveModal()"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_"></data-i18n></button></div></ba-wizard-step></ba-wizard><div ng-if="vm.loading" align="center" style="overflow: hidden"><div><div id="loading-animation-large"></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/pens/penDetails/penDetails.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ng-if="vm.selectedHerd && vm.selectedTeamHerd && !vm.detailsLoading" ba-panel="" ba-panel-title="{{\'_m_f_menu_pens_details_\'|i18n}}" ba-panel-class="with-scroll"><button class="btn btn-primary btn-xs" ng-click="vm.back()" style="margin-left: 6px; margin-top: 6px"><i class="ion-arrow-left-c"></i>&nbsp;<data i18n="_btn_back_">Back</data></button><div include-with-scope="app/pages/pens/penDetails/penDetails.panel.html"></div></div><div class="panel-content" ng-if="!vm.selectedHerd" align="center" ba-panel=""><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div><div class="panel-content" ng-if="!vm.selectedTeamHerd && !vm.detailsLoading" align="center" ba-panel="" ng-hide="!vm.selectedHerd"><h3><data-i18n i18n="_details_default_herdTeam_not_defined_">Details are not available for this herd / team</data-i18n></h3></div></div></div></div><div ng-if="vm.detailsLoading" align="center" ba-panel=""><div style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/pens/penDetails/penDetails.panel.html','<div class="panel-content" ng-if="!vm.detailsLoading"><h3 class="with-line"><data-i18n i18n="_m_f_pen_details_basic_informations_">Basic Informations</data-i18n></h3><div class="row"><div class="col-xlg-4 col-lg-4 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_name_">Name</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span class="wrap-text">{{vm.details.pen_name}}</span></div></div></div><div class="col-xlg-4 col-lg-4 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_active_">Pen active</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span><a class="ion-checkmark-round primaryModal" ng-if="vm.details.pen_active"></a> <a ng-if="!vm.details.pen_active" class="ion-close-round warningModal"></a></span></div></div></div><div class="col-xlg-4 col-lg-4 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_automatic_update_">Automatic update</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span><a class="ion-checkmark-round primaryModal" ng-if="vm.details.automatic_update"></a><a ng-if="!vm.details.automatic_update" class="ion-close-round warningModal"></a></span></div></div></div></div><div class="row"><div class="col-xlg-4 col-lg-4 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_category_">Pen category</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.pen_category.name}}</span></div></div></div><div class="col-xlg-4 col-lg-4 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_feeds_dmi_">dmi</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.feed_intake | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</span></div></div></div></div><div class="row"><div class="col-xlg-4 col-lg-4 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_no_animals_">Number of animals</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.number_of_animals}}</span></div></div></div><div class="col-xlg-4 col-lg-4 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_number_of_cubicles_">Number of cubicles</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.number_of_cubicles || (\'_m_f_calendar_not_available_label_\' | i18n)}}</span></div></div></div><div class="col-xlg-4 col-lg-4 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_number_of_headlocks_">Number of headlocks</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.number_of_headlocks || (\'_m_f_calendar_not_available_label_\' | i18n)}}</span></div></div></div></div><div class="row"><div class="col-xlg-4 col-lg-4 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_address_">Pen address</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.pen_address || (\'_m_f_calendar_not_available_label_\' | i18n)}}</span></div></div></div><div class="col-xlg-4 col-lg-4 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_mf_dmi_source_">DMI source</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.dmi_source}}</span></div></div></div></div></div><h3 class="with-line"><data-i18n i18n="_m_f_pen_feeding_schedule_">Feeding schedule</data-i18n></h3><div class="row pen-feeding-details horizontal-scroll"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="row"><table class="table table-striped"><thead><tr><th><data-i18n i18n="_m_f_pen_feeding_start_date_">Feeding date</data-i18n></th><th><data-i18n i18n="_m_f_pen_frequency_of_feeding_">Frequency of feeding</data-i18n></th><th><data-i18n i18n="_m_f_pen_feedings_per_day">feeding per day</data-i18n></th><th><data-i18n i18n="_m_f_placeholder_select_feeding_time_">feeding</data-i18n></th><th><data-i18n i18n="_active_schedule_">Active schedule</data-i18n></th></tr></thead><tbody><tr ng-repeat="freq in vm.details.pen_feeding_scheduler_list | orderBy:\'-start_feeding_date\'" ng-class="freq.schedule_set ? \'primaryModal\' : \'\'"><td>{{freq.start_feeding_date | date:\'shortDate\'}}</td><td>{{freq.feeding_frequency || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td>{{freq.number_of_feedings}}</td><td><div><span ng-if="freq.morning_feeding">{{freq.morning_feeding_time | date: \'hh:mm a\'}}</span> <span ng-if="freq.noon_feeding">{{freq.noon_feeding_time | date: \'hh:mm a\'}}</span> <span ng-if="freq.evening_feeding">{{freq.evening_feeding_time | date: \'hh:mm a\'}}</span></div><div ng-if="!freq.morning_feeding && !freq.noon_feeding && !freq.evening_feeding"><data-i18n i18n="_m_f_calendar_not_available_label_"></data-i18n></div></td><td><a class="ion-checkmark-round primaryModal" ng-if="freq.schedule_set"></a> <a ng-if="!freq.schedule_set" class="ion-close-round warningModal"></a></td></tr></tbody></table></div></div></div><div ng-if="vm.detailsLoading" align="center" style="overflow: hidden"><div><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/pens/myPens/confirmationDialog.modal.html','<div class="modal-content"><div class="modal-header" ng-if="!vm.modalLoading"><div align="center"><span class="ion-android-warning warningModal" style="font-size: 36px;"></span></div><div align="center"><span class="warningModal">{{vm.warningMessage | i18n}}</span></div></div><div class="modal-body" ng-if="!vm.modalLoading"><div align="center"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="vm.proceedDelete()"><data-i18n i18n="_btn_delete_" "="">Delete</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="$dismiss()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div style="height:200px; overflow: hidden;" ng-if="vm.modalLoading" align="center"><div style="margin-top:50px"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/pens/myPens/myPens.cards.html','<div class="grid-card-wrapper horizontal-scroll"><div ng-repeat="pen in vm.pens" ng-class="pen.active ? \'pen-active\' : \'\'"><div class="grid-card-header"><div class="shorten-long-text" uib-tooltip="{{pen.pen_name}}" tooltip-enable="{{pen.pen_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{pen.pen_name}}</div><div><button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToPenHistory(pen.id)" uib-tooltip="{{\'_tips_history_\' | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="left" tooltip-class="customBlue medium left" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editPen(pen, $index)" uib-tooltip="{{\'_tips_edit_\' | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="left" tooltip-class="customBlue medium left" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.penDetails(pen)" uib-tooltip="{{\'_tips_details_\' | i18n}}" tooltip-is-open="detailsOpen" tooltip-placement="left" tooltip-class="customBlue medium left" tooltip-popup-delay="500"><i class="ion-clipboard"></i></button></div></div><hr class="separator"><div><table><tbody><tr><td><data-i18n i18n="_m_f_title_category_">category</data-i18n>:</td><td>{{pen.pen_category.name}}</td></tr><tr><td><data-i18n i18n="_m_f_pen_number_of_animals_">number of animals</data-i18n>:</td><td>{{pen.number_of_animals}}</td></tr><tr><td><data-i18n i18n="_m_f_pen_feedings_">feedings</data-i18n>:</td><td><span>{{pen.feeding_1_time | date: \'hh:mm a\'}}</span><span ng-if="pen.feeding_2_time">&nbsp;/</span> <span ng-if="pen.feeding_2_time">{{pen.feeding_2_time | date: \'hh:mm a\'}}</span><span ng-if="pen.feeding_3_time">&nbsp;/</span> <span ng-if="pen.feeding_3_time">{{pen.feeding_3_time | date: \'hh:mm a\'}}</span> <span ng-if="!pen.feeding_1_time && !pen.feeding_2_time && !pen.feeding_3_time"><data-i18n i18n="_m_f_calendar_not_available_label_">none</data-i18n></span></td></tr><tr><td><data-i18n i18n="_m_f_pen_feeding_frequency_">feeding frequency</data-i18n>:</td><td>{{pen.feeding_frequency || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td></tr><tr><td><data-i18n i18n="_start_feeding_date_">Feeding date</data-i18n>:</td><td>{{pen.feeding_started | date:\'shortDate\'}}</td></tr><tr><td><data-i18n i18n="_title_create_date">create date</data-i18n>:</td><td>{{pen.create_date | date:\'short\'}}</td></tr><tr><td><data-i18n i18n="_m_f_pen_automatic_update_">automatic update</data-i18n>:</td><td><a class="ion-checkmark-round primaryModal" ng-if="pen.automatic_update" style="padding-right: 2.5px"></a> <a ng-if="!pen.automatic_update" class="ion-close-round warningModal" style="padding-right: 2.5px"></a></td></tr><tr><td><data-i18n i18n="_m_f_title_status_">Status</data-i18n>:</td><td><a class="icon-edit green-icon" href="" id="setAsDef" ng-click="vm.changeActive(pen, $index)" ng-class="pen.pen_active ? \'ion-star\' : \'ion-ios-star-outline\'"></a></td></tr><tr><td><data-i18n i18n="_m_f_remove_pen_">remove pen</data-i18n>:</td><td><button class="btn btn-danger btn-xs" ng-click="vm.deletePen($index, pen)"><data-i18n i18n="_btn_delete_"></data-i18n></button></td></tr></tbody></table></div></div></div><div align="center" ng-if="!vm.loadingTable && !vm.loading && vm.totalItems > vm.pens.length"><button class="btn btn-primary" ng-click="vm.paginationChanged()"><data-i18n i18n="_m_f_title_load_more_">Load more</data-i18n></button></div><div align="center" style="overflow: hidden" ng-if="vm.loadingTable && !vm.loading"><div id="loading-animation-large"></div></div>');
$templateCache.put('app/pages/pens/myPens/myPens.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/pens/myPens/myPens.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/pens/myPens/myPens.panel.html','<div class="row" ng-if="!vm.loading && vm.selectedHerd"><div class="btn-group" style="float: right"><button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(1)" ng-class="vm.selectedLayout == 1 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th-list" ng-class="vm.selectedLayout == 1 ? \'glyphicon glyphicon-th-list selected\' : \'glyphicon glyphicon-th-list\'"></span></button> <button id="grid" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(2)" ng-class="vm.selectedLayout == 2 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th" ng-class="vm.selectedLayout == 2 ? \'glyphicon glyphicon-th selected\' : \'glyphicon glyphicon-th\'"></span></button></div></div><div class="row" ng-if="vm.selectedHerd && vm.selectedLayout == 1"><div include-with-scope="app/pages/pens/myPens/myPens.table.html"></div></div><div class="row" ng-if="vm.selectedHerd && vm.selectedLayout == 2"><div include-with-scope="app/pages/pens/myPens/myPens.cards.html"></div></div><div class="row" ng-if="vm.loading" style="text-align: center; overflow: hidden"><div id="loading-animation-large"></div></div><div class="row" ng-if="!vm.loading && !vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div>');
$templateCache.put('app/pages/pens/myPens/myPens.table.html','<div class="horizontal-scroll" ng-if="!vm.loading" style="vertical-align: top"><table class="table table-hover my-pens-table" style="font-size: 14px"><thead><tr class="sortable"><th align="left"><data-i18n i18n="_title_column_action_">action</data-i18n></th><th style="min-width: 200px" ng-click="vm.sort(\'penName\')"><data-i18n i18n="_m_f_pen_name_">pen name</data-i18n>&nbsp; <i class="fa" ng-class="vm.sortCol == \'penName_DESC\' ? \'fa-long-arrow-down\' : (vm.sortCol == \'penName_ASC\'? \'fa-long-arrow-up\' : \'fa-arrows-v\')"></i></th><th style="min-width: 200px" ng-click="vm.sort(\'penCategory.name\')"><data-i18n i18n="_m_f_title_category_">category</data-i18n>&nbsp; <i class="fa" ng-class="vm.sortCol == \'penCategory.name_DESC\' ? \'fa-long-arrow-down\' : (vm.sortCol == \'penCategory.name_ASC\'? \'fa-long-arrow-up\' : \'fa-arrows-v\')"></i></th><th ng-click="vm.sort(\'numberOfAnimals\')"><data-i18n i18n="_m_f_pen_number_of_animals_">number of animals</data-i18n>&nbsp; <i class="fa" ng-class="vm.sortCol == \'numberOfAnimals_DESC\' ? \'fa-long-arrow-down\' : (vm.sortCol == \'numberOfAnimals_ASC\'? \'fa-long-arrow-up\' : \'fa-arrows-v\')"></i></th><th><data-i18n i18n="_m_f_pen_feedings_">feedings</data-i18n></th><th><data-i18n i18n="_m_f_pen_feeding_frequency_">feeding frequency</data-i18n></th><th><data-i18n i18n="_m_f_pen_feeding_start_date_">Feeding date</data-i18n></th><th style="min-width: 150px" ng-click="vm.sort(\'createDate\')"><data-i18n i18n="_title_create_date">create date</data-i18n>&nbsp; <i class="fa" ng-class="vm.sortCol == \'createDate_DESC\' ? \'fa-long-arrow-down\' : (vm.sortCol == \'createDate_ASC\'? \'fa-long-arrow-up\' : \'fa-arrows-v\')"></i></th><th style="text-align: center"><data-i18n i18n="_m_f_pen_automatic_update_">automatic update</data-i18n></th><th><data-i18n i18n="_m_f_remove_pen_">remove pen</data-i18n></th></tr></thead><tbody><tr ng-repeat="pen in vm.pens"><td style="min-width: 120px; vertical-align: middle"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToPenHistory(pen.id)" uib-tooltip="{{\'_tips_history_\' | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-bottom: 3px"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editPen(pen, $index)" uib-tooltip="{{\'_tips_edit_\' | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" style="margin-bottom: 3px"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.penDetails(pen)" uib-tooltip="{{\'_tips_details_\' | i18n}}" tooltip-is-open="tooltipIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-bottom: 3px"><i class="ion-clipboard"></i></button> <a class="icon-edit green-icon" href="" id="setAsDef" style="margin-left: 10px" ng-click="vm.changeActive(pen, $index)" ng-class="pen.pen_active ? \'ion-star\' : \'ion-ios-star-outline\'"></a></td><td style="vertical-align: middle" class="shorten-long-text" uib-tooltip="{{pen.pen_name}}" tooltip-enable="{{pen.pen_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{pen.pen_name}}</td><td style="vertical-align: middle">{{pen.pen_category.name}}</td><td style="vertical-align: middle">{{pen.number_of_animals}}</td><td><div>{{pen.feeding_1_time | date: \'hh:mm a\'}}</div><div ng-if="pen.feeding_2_time">{{pen.feeding_2_time | date: \'hh:mm a\'}}</div><div ng-if="pen.feeding_3_time">{{pen.feeding_3_time | date: \'hh:mm a\'}}</div><div ng-if="!pen.feeding_1_time && !pen.feeding_2_time && !pen.feeding_3_time"><data-i18n i18n="_label_none_">none</data-i18n></div></td><td style="vertical-align: middle">{{pen.feeding_frequency || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td style="vertical-align: middle">{{(pen.feeding_started | date:\'shortDate\') || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td style="vertical-align: middle">{{pen.create_date | date:\'short\'}}</td><td style="vertical-align: middle" align="center"><a class="ion-checkmark-round primaryModal" ng-if="pen.automatic_update"></a><a ng-if="!pen.automatic_update" class="ion-close-round warningModal"></a></td><td style="vertical-align: middle"><button class="btn btn-danger btn-xs" ng-click="vm.deletePen($index, pen)"><data-i18n i18n="_btn_delete_"></data-i18n></button></td></tr></tbody><tfoot ng-if="!vm.loadingTable && !vm.loading && vm.totalItems > vm.pens.length"><tr><td colspan="10" style="text-align: center"><button class="btn btn-primary" ng-click="vm.paginationChanged()"><data-i18n i18n="_m_f_title_load_more_">Load more</data-i18n></button></td></tr></tfoot><tfoot ng-if="vm.loadingTable && !vm.loading"><tr><td colspan="10"><loading-spinner-large></loading-spinner-large></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/pens/penHistory/penHistory.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/pens/penHistory/penHistory.table.html"></div></div></div></div></div>');
$templateCache.put('app/pages/pens/penHistory/penHistory.table.html','<div class="horizontal-scroll" ng-if="!vm.loading"><button class="btn btn-primary btn-xs" ng-click="vm.back()" style="margin: 5px"><i class="ion-arrow-left-c"></i>&nbsp;<data i18n="_btn_back_">Back</data></button><table class="table table-hover pen-history" st-table="vm.history" st-safe-src="vm.historySafe"><thead><tr class="sortable"><th><data-i18n i18n="_m_f_pen_active_">pen active</data-i18n></th><th><data-i18n i18n="_m_f_pen_name_">pen name</data-i18n></th><th><data-i18n i18n="_m_f_pen_number_of_animals_">number of animals</data-i18n></th><th><data-i18n i18n="_feeds_dmi_">DMI</data-i18n></th><th><data-i18n i18n="_m_f_title_category_">category</data-i18n></th><th><data-i18n i18n="_m_f_pen_automatic_update_">automatic update</data-i18n></th><th><data-i18n i18n="_title_user_">User</data-i18n></th><th><data-i18n i18n="_title_last_modified_date_">last modified date</data-i18n></th></tr></thead><tbody><tr ng-repeat="pen in vm.history"><td><a class="ion-checkmark-round primaryModal" ng-if="pen.pen_active"></a><a ng-if="!pen.pen_active" class="ion-close-round warningModal"></a></td><td class="shorten-long-text" uib-tooltip="{{pen.pen_name}}" tooltip-enable="{{pen.pen_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{pen.pen_name}}</td><td>{{pen.number_of_animals}}</td><td>{{pen.feed_intake}}&nbsp;{{vm.weight}}</td><td>{{pen.pen_category_name}}</td><td><a class="ion-checkmark-round primaryModal" ng-if="pen.automatic_update"></a><a ng-if="!pen.automatic_update" class="ion-close-round warningModal"></a></td><td>{{pen.last_modified_user}}</td><td>{{pen.last_modified_date | date:\'short\'}}</td></tr></tbody><tfoot ng-if="!vm.loadingTable && vm.totalItems > vm.history.length"><tr><td colspan="8"><button class="btn btn-primary" ng-click="vm.paginationChanged()"><data-i18n i18n="_m_f_title_load_more_">Load more</data-i18n></button></td></tr></tfoot><tfoot ng-if="vm.loadingTable"><tr><td colspan="8"><loading-spinner-large></loading-spinner-large></td></tr></tfoot></table></div><loading-spinner-large ng-if="vm.loading"></loading-spinner-large>');
$templateCache.put('app/pages/premixes/addNewPremix/addNewPremix.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll horizontal-scrol"><div include-with-scope="app/pages/premixes/addNewPremix/wizard.html"></div></div></div></div></div>');
$templateCache.put('app/pages/premixes/addNewPremix/addWagon.modal.html','<div class="modal-content" ng-cloak=""><div ng-if="!vm.modalLoading"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><div style="max-height: 400px; overflow: auto"><table style="padding: 5px" class="table"><tbody><tr ng-repeat="wagon in vm.premix.wagons" ng-show="!wagon.selected"><td><span class="wagon-name" uib-tooltip="{{wagon.name}}" tooltip-enable="{{wagon.name.length > 30 ? true : false}}" tooltip-is-open="wagonNameOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-hide-overflow" tooltip-popup-delay="500">{{wagon.name}}</span></td><td>{{wagon.value | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</td><td><button class="btn btn-xs btn-success" ng-click="vm.addExistingWagon(wagon)"><data-i18n i18n="_m_f_btn_add_">Add</data-i18n></button></td></tr></tbody></table></div><span style="margin-bottom: 10px; display: inline-block"><data-i18n i18n="_m_f_menu_wagons_add_wagon_">Create custom wagon</data-i18n>:</span><form name="vm.customWagonForm" novalidate=""><div class="form-group"><div class="form-group" ng-class="{\'has-error\': vm.customWagonForm.wagon_name.$invalid && (vm.customWagonForm.wagon_name.$dirty || vm.customWagonForm.$submitted)}"><input class="form-control" type="text" id="wagon_name" name="wagon_name" ng-model="vm.newWagon.name" placeholder="{{\'_m_f_wagons_name_\' | i18n}}" select-on-click="" required=""> <span class="help-block error-block basic-block warningModal"><data-i18n i18n="_m_f_premix_wagon_name_required_">Wagon name is required</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.customWagonForm.mac_address.$invalid && (vm.customWagonForm.mac_address.$dirty || vm.customWagonForm.$submitted)}"><input class="form-control" type="text" id="mac_address" name="mac_address" placeholder="xx:xx:xx:xx:xx:xx" pattern="^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$" maxlength="17" ng-model="vm.newWagon.mac_address" select-on-click=""> <span class="help-block error-block basic-block warningModal"><data-i18n i18n="_m_f_premix_mac_required_label_">MAC address is required</data-i18n></span></div><label><data-i18n i18n="_m_f_wagons_capacity_">capacity</data-i18n></label><div class="form-group" ng-class="{\'has-error\': vm.customWagonForm.volume.$invalid && (vm.customWagonForm.volume.$dirty || vm.customWagonForm.$submitted)}"><input type="number" class="form-control with-units" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" min="0.1" max="90" step="0.1" id="volume" name="volume" ng-model="vm.newWagon.volume" placeholder="{{\'_m_f_wagons_volume_\'|i18n}}" select-on-click=""><span>m<sup>3</sup></span><br></div><div class="form-group" ng-class="{\'has-error\': vm.customWagonForm.value.$invalid && (vm.customWagonForm.value.$dirty || vm.customWagonForm.$submitted)}"><input type="number" class="form-control with-units" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" min="0.1" max="90" step="0.1" id="value" name="value" ng-model="vm.newWagon.value" placeholder="{{\'_m_f_wagons_weight_\'|i18n}}" select-on-click="" required=""><span>t</span> <span class="help-block error-block basic-block warningModal"><data-i18n i18n="_m_f_wagons_weight_required_">weight is required</data-i18n></span></div></div><button class="btn btn-xs btn-success" ng-disabled="vm.customWagonForm.$invalid === true" ng-click="vm.addWagon()"><data-i18n i18n="_m_f_btn_add_">Add</data-i18n></button></form></div></div><div class="modal-body" ng-if="vm.modalLoading" style="overflow: hidden"><div align="center"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/premixes/addNewPremix/basis.table.html','<div class="horizontal-scroll premix-table" ng-class="!vm.premix.basis_help_input && vm.selectBasisForm.$submitted ? \'premix-error\' : \'\'"><table class="table table-hover" ng-if="!vm.loadingBasis"><thead><tr class="sortable"><th align="left"><data-i18n i18n="_title_column_action_">action</data-i18n></th><th><data-i18n i18n="_m_f_premix_basis_name_label_">Basis name</data-i18n></th><th><data-i18n i18n="_feeds_dm_">dm</data-i18n>&nbsp;(%)</th><th><data-i18n i18n="_m_f_premix_amount_label_">Amount</data-i18n>&nbsp;({{vm.weight}})</th><th><data-i18n i18n="_m_f_premix_cost_label_">Cost</data-i18n>&nbsp;({{vm.currency}})</th></tr></thead><tbody><tr ng-repeat="basis in vm.basis | orderBy: \'-id\'"><td><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}-X" ng-true-value="true" ng-false-value="false" ng-click="vm.selectBasis(basis)" ng-model="basis.is_selected" ng-disabled="basis.is_selected" style="margin-right: 2px"> <label for="is_checked{{$index}}-X"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editBasis(basis)" uib-tooltip="{{\'_tips_edit_\' | i18n}}" tooltip-is-open="editBasisOpen{{basis.id}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="vm.premix.selected_basis.value != 2"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.basisDetails(basis)" uib-tooltip="{{\'_tips_details_\' | i18n}}" tooltip-is-open="detailsbasisOpen{{basis.id}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clipboard"></i></button></td><td>{{basis.name}}</td><td>{{basis.dm | number:2}}</td><td>{{basis.amount | formatViewValues: \'amount\'}}</td><td>{{basis.cost | number:2}}</td></tr></tbody><tfoot ng-if="vm.totalItemsBasis > 10"><tr><td colspan="6" style="text-align: center"><uib-pagination boundary-links="true" total-items="vm.totalItemsBasis" ng-model="vm.premix.current_page" items-per-page="10" max-size="7" ng-change="vm.basisPaginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></td></tr></tfoot></table></div><div class="premix-error-text" ng-class="!vm.premix.basis_help_input && vm.selectBasisForm.$submitted ? \'premix-error\' : \'\'"><data-i18n i18n="_m_f_premix_basis_required_" select-on-click="">Basis is required</data-i18n></div><div ng-if="vm.loadingBasis" align="center" style="overflow: hidden"><div><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/premixes/addNewPremix/basisDetails.modal.html','<div class="modal-content" ng-cloak=""><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><table class="table table-hover"><thead><tr><th style="text-align: center"><data-i18n i18n="_feeds_name_">Feed name</data-i18n></th><th><data-i18n i18n="_feeds_dm_">DM</data-i18n><br>%</th><th><data-i18n i18n="_feeds_amount_">Amount DM</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_cost_dm_">Cost</data-i18n><br>{{vm.currency}}/{{vm.weight}}<span>&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th><th><data-i18n i18n="_feeds_cost_as_fed_">Cost as fed</data-i18n><br>{{vm.currency}}/{{vm.weight}}<span>&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th></tr></thead><tbody><tr ng-repeat="feed in vm.modalBasis.ingredient_list"><td>{{feed.name}}</td><td>{{feed.dm | number: 2}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.as_fed | formatViewValues: \'as_fed\'}}</td><td>{{feed.cost | formatViewValues: \'cost_dm\'}}</td><td>{{feed.cost_as_fed | formatViewValues: \'cost_dm\'}}</td></tr></tbody></table><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div></div>');
$templateCache.put('app/pages/premixes/addNewPremix/feedingSchedule.panel.html','<div><div class="suggestion-heading"><h3><data-i18n i18n="_m_f_premix_feeding_schedule_">Feeding schedule</data-i18n></h3></div><div>kalendar</div></div>');
$templateCache.put('app/pages/premixes/addNewPremix/loadForm.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><div ng-show="vm.load.wagon"><label><data-i18n i18n="_m_f_wagons_capacity_">Capacity</data-i18n>:&nbsp;{{vm.load.wagon.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</label></div><div ng-if="vm.showRequiredAmount"><label><data-i18n i18n="_recipe_load_required_amount_">required amount</data-i18n>:&nbsp;<span>{{vm.loadRequiredAmount | formatViewValues: \'rounded_amount\'}}</span></label> <button ng-show="vm.loadRequiredAmount !== vm.load.value" class="btn btn-xs btn-success" ng-click="vm.setLoad()"><data-i18n i18n="_button_label_set_">set</data-i18n></button></div><form name="vm.loadForm"><div ng-class="{\'has-error\': vm.load.value > vm.load.wagon.value || (vm.loadForm.value.$invalid && (vm.loadForm.value.$dirty || vm.loadForm.$submitted))}" class="form-group has-feedback"><label for="value"><data-i18n i18n="_m_f_recipe_load_kg_">Load</data-i18n>&nbsp;({{vm.weight}}):</label> <input type="number" name="value" class="form-control" ng-model="vm.load.value" format-input-value="rounded_amount" required="" min="0" select-on-click=""></div><div class="form-group" ng-if="vm.load.wagons.length > 1"><label><data-i18n i18n="_m_f_menu_mixer_wagons_">Mixer wagons</data-i18n>:</label><ui-select ng-model="vm.load.wagon" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true" on-select="vm.calculateLoad()" required=""><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="wagon in vm.load.wagons | filter: $select.search"><span ng-bind-html="wagon.name"></span></ui-select-choices></ui-select></div></form></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button> <button ng-disabled="vm.load.value > vm.load.wagon.value || vm.loadForm.$invalid == true" type="button" class="btn btn-success" ng-click="vm.saveLoad()"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></div>');
$templateCache.put('app/pages/premixes/addNewPremix/load_suggestion.table.html','<div class="suggestion-heading"><h3><data-i18n i18n="_m_f_recipe_mixing_suggestion_">Mixing suggestion</data-i18n></h3></div><div class="premix-loads-table"><div class="col-md-9"><table class="table table-hover"><thead><tr><th><div class="mixing-suggestion-primary"><span><data-i18n i18n="_m_f_recipe_selected_wagons_">Selected wagons</data-i18n><span class="suggestion-add-button primaryModal" uib-tooltip="{{\'_m_f_recipe_add_wagon_\' | i18n}}" tooltip-append-to-body="true" tooltip-is-open="addWagon" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-ios-plus-outline" ng-click="vm.openAddWagonModal($event, true)"></i></span></span><br ng-if="vm.feedingsError"></div></th><th><div class="mixing-suggestion-primary"><data-i18n i18n="_m_f_recipe_loads_">Loads</data-i18n>&nbsp;<span>({{vm.premix.suggestion.sum | formatViewValues: \'amount\'}}</span>&nbsp;{{vm.weight}}) <span class="suggestion-add-button primaryModal" ng-if="vm.premix.total_amount && vm.premix.total_amount > 0 && vm.premix.suggestion.loads.length < 10" ng-hide="vm.premix.wagons && vm.premix.wagons.length === 0" uib-tooltip="{{\'_m_f_premix_add_load_\' | i18n}}" tooltip-append-to-body="true" tooltip-is-open="addLoad" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-ios-plus-outline" ng-click="vm.openAddLoadModal()"></i></span> <span class="suggestion-add-button premix-reload-btn primaryModal" ng-if="vm.premix.suggestion.dirty" uib-tooltip="{{\'_m_f_premix_reset_load_configuration_\' | i18n}}" tooltip-append-to-body="true" tooltip-is-open="resetLoads" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="fa fa-refresh" ng-click="vm.calculateSuggestion()"></i></span><br ng-if="vm.feedingsError"><span ng-if="vm.feedingsError" class="warningModal"><data-i18n i18n="_rations_difference_">Difference</data-i18n>:&nbsp;{{vm.feedingsError | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</span></div></th></tr></thead><tbody><tr ng-repeat="wagon in vm.premix.wagons" ng-show="wagon.selected"><td><div><span class="premix-has-warning premix-wagon-warning" ng-class="wagon.default ? \'premix-display-warning\' : \'premix-disable-warning\'" uib-popover="{{\'_m_f_recipe_default_mixer_wagon_remove_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right"><span><span>{{wagon.name}}</span>&nbsp; <span>({{wagon.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}})</span></span> <i ng-show="wagon.default" class="fa fa-info-circle"></i></span> <span class="suggestion-remove-button" uib-tooltip="{{\'_m_f_wagons_remove_\' | i18n}}" tooltip-append-to-body="true" tooltip-is-open="removeWagon" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-ios-close-outline" ng-show="!wagon.default" ng-click="vm.removeWagon(wagon)"></i></span></div></td><td><div ng-repeat="load in vm.premix.suggestion.loads track by $index" ng-show="load.wagon_id == wagon.id" class="editable-suggestion-value"><data-i18n i18n="_m_f_recipe_load_">Load</data-i18n>&nbsp;{{$index+1}}: <span class="editable-load-value" ng-click="vm.openEditLoadModal($index)" uib-tooltip="{{\'_m_f_premix_edit_load_\' | i18n}}" tooltip-append-to-body="true" tooltip-is-open="editLoad" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500">{{load.value | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{vm.weight}} <span class="suggestion-remove-button" uib-tooltip="{{\'_m_f_premix_remove_load_\' | i18n}}" tooltip-append-to-body="true" tooltip-is-open="removeLoad" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-ios-close-outline" ng-click="vm.removeLoad($index)"></i></span></div></td></tr><tr><td class="mixing-suggestion-primary"><data-i18n i18n="_m_f_recipe_number_of_loads_">Number of loads</data-i18n></td><td>{{vm.premix.suggestion.loads.length}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/premixes/addNewPremix/overview.panel.html','<div><div class="suggestion-heading"><h3><data-i18n i18n="_m_f_label_summary_">Summary</data-i18n></h3></div><div class="horizontal-scroll premix-overview-table"><table class="table table-hover"><thead><tr><th ng-if="vm.premix.basis.name"><data i18n="_m_f_premix_selected_basis_">Selected basis</data></th><th><data i18n="_feeds_amount_">Amount DM</data></th><th><data i18n="_feeds_as_fed_">As fed</data></th><th>%&nbsp;<data i18n="_feeds_dm_">DM</data></th><th><data i18n="_m_f_title_total_cost_per_day_">Total cost</data>&nbsp;($)</th><th ng-if="vm.premix.number_of_animals"><data i18n="_m_f_premix_number_of_animals_">N\xB0 of animals</data></th><th><data i18n="_m_f_premix_total_amount_">N\xB0 of animals</data></th></tr></thead><tbody><tr><td style="min-width: 200px" ng-if="vm.premix.basis.name">{{vm.premix.basis.name}}</td><td style="min-width: 110px">{{vm.premix.amount | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</td><td style="min-width: 110px">{{vm.premix.amount_as_fed | formatViewValues: \'as_fed\'}}&nbsp;{{vm.weight}}</td><td style="min-width: 110px">{{vm.premix.dm | formatViewValues: \'percentage\'}}&nbsp;%</td><td style="min-width: 110px">{{vm.premix.total_cost | formatViewValues: \'cost_dm\'}}</td><td style="min-width: 110px" ng-if="vm.premix.number_of_animals">{{vm.premix.number_of_animals | number: 0}}</td><td style="min-width: 110px">{{vm.premix.total_premix_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</td></tr></tbody></table></div><div class="horizontal-scroll premix-overview-table"><table class="table table-hover"><thead><tr><th><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br></th><th><data-i18n i18n="_feeds_type_">Feed type</data-i18n><br></th><th><data-i18n i18n="_feeds_dm_">DM</data-i18n><br>%</th><th><data-i18n i18n="_feeds_amount_">Amount DM</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_cost_dm_">Cost DM</data-i18n><br>{{vm.currency}}/{{vm.weight}}&nbsp; <span><data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th><th><data-i18n i18n="_feeds_cost_as_fed_">Cost as fed</data-i18n><br>{{vm.currency}}/{{vm.weight}}&nbsp; <span><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n></span></th></tr></thead><tbody><tr ng-repeat="feed in vm.premix.feeds"><td style="min-width: 200px">{{feed.name}}</td><td style="min-width: 200px">{{feed.feed_type.translated}}</td><td style="min-width: 110px">{{feed.dm | formatViewValues: \'percentage\'}}</td><td style="min-width: 110px">{{feed.amount | formatViewValues: \'amount\'}}</td><td style="min-width: 110px">{{feed.as_fed | formatViewValues: \'as_fed\'}}</td><td style="min-width: 110px">{{feed.cost | formatViewValues: \'cost_dm\'}}</td><td style="min-width: 110px">{{feed.cost_as_fed | formatViewValues: \'cost_dm\'}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/premixes/addNewPremix/premixFeeds.table.html','<div ng-if="!vm.loading"><h3 class="with-line"><data i18n="_m_f_premix_info_">Premix info</data></h3><div class="basis-info"><div ng-if="vm.premix.basis.name" class="form-group basis-info-item"><label><data-i18n i18n="_m_f_premix_basis_name_label_">Basis name</data-i18n></label><div>{{(vm.premix.basis.name) || \'-\'}}</div></div><div class="form-group basis-info-item"><label><data-i18n i18n="_feeds_dm_">DM</data-i18n>&nbsp;(%)</label><div><span class="premix-has-warning" ng-class="!vm.premix.dm ? \'premix-display-warning\' : \'premix-disable-warning\'" uib-popover="{{\'_m_f_premix_basis_dm_error_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{(vm.premix.dm | number: 2) || (0 | number: 2)}}&nbsp;<i ng-show="!vm.premix.dm" class="fa fa-info-circle"></i></span></div></div><div class="form-group basis-info-item"><label><data-i18n i18n="_feeds_amount_">Amount</data-i18n>&nbsp;({{vm.weight}})</label><div>{{vm.premix.amount | formatViewValues: \'amount\'}}</div></div><div class="form-group basis-info-item"><label><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n>&nbsp;({{vm.weight}})</label><div>{{vm.premix.amount_as_fed | formatViewValues: \'as_fed\'}}</div></div><div class="form-group basis-info-item"><label><data-i18n i18n="_m_f_recipe_cost_">Cost</data-i18n>&nbsp;({{vm.currency}})</label><div>{{vm.premix.cost | formatViewValues: \'cost_dm\'}}</div></div></div><div style="margin-bottom: 10px" class="horizontal-scroll premix-table premix-validation-container" ng-class="vm.premix.amount > 40 ? \'dmi-error\' : (vm.premix.feeds.length === 0 || vm.newPremixFeedForm.$invalid || vm.showIFields || !vm.premix.dm || vm.hasDM0Error) && vm.selectBasisForm.$submitted ? \'premix-error\' : \'\'"><table class="table premix_table"><thead><tr><th><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br></th><th><data-i18n i18n="_feeds_type_">Feed type</data-i18n><br></th><th><data-i18n i18n="_feeds_dm_">DM</data-i18n><br>%</th><th><data-i18n i18n="_feeds_amount_">Amount DM</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_cost_dm_">Cost DM</data-i18n><br>{{vm.currency}}/{{vm.weight}}&nbsp; <span><data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th><th><data-i18n i18n="_feeds_cost_as_fed_">Cost as fed</data-i18n><br>{{vm.currency}}/{{vm.weight}} <span><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n></span></th><th class="premix-feeds-table-action"><button type="button" class="btn btn-success btn-xs" ng-click="vm.openAddNewFeedForm()" ng-disabled="vm.showIFields"><i class="fa fa-plus"></i></button></th></tr></thead><tbody dnd-list="vm.premix.feeds" dnd-disable-if="vm.disableDrag || vm.showIFields"><tr ng-repeat="feed in vm.premix.feeds" dnd-disable-if="vm.disableDrag || vm.showIFields" dnd-draggable="feed" dnd-moved="vm.drag($index)"><td style="min-width: 200px"><span editable-text="feed.name" e-required="" e-style="width: 150px" onbeforesave="vm.updateNewFeed($data, $index, \'name\')">{{feed.name}}</span></td><td style="min-width: 200px"><a href="#" editable-select="feed.feed_type" e-required="" e-style="width: 150px" onshow="loadGroups()" e-ng-options="feed_type as (feed_type.show_name | i18n) for feed_type in vm.feed_types">{{feed.feed_type.translated}}</a></td><td style="min-width: 110px"><span editable-number="feed.dm" e-required="" e-step="0.01" e-min="0.01" e-max="100" e-style="width: 100px" e-format-input-value="percentage" onbeforesave="vm.updateNewFeed($data, $index, \'dm\')">{{feed.dm | formatViewValues: \'percentage\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.amount" e-required="" e-step="0.01" e-min="0" e-style="width: 100px" e-format-input-value="amount" onbeforesave="vm.updateNewFeed($data, $index, \'amount\')">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.as_fed" e-required="" e-step="0.01" e-min="0" e-style="width: 100px" e-format-input-value="as_fed" onbeforesave="vm.updateNewFeed($data, $index, \'as_fed\')">{{feed.as_fed | formatViewValues: \'as_fed\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.cost" e-step="0.001" e-min="0" e-style="width: 100px" e-format-input-value="cost_dm" onbeforesave="vm.updateNewFeed($data, $index, \'cost\')">{{feed.cost | formatViewValues: \'cost_dm\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.cost_as_fed" e-step="0.001" e-min="0" e-style="width: 100px" e-format-input-value="cost_dm" onbeforesave="vm.updateNewFeed($data, $index, \'cost_as_fed\')">{{feed.cost_as_fed | formatViewValues: \'cost_dm\'}}</span></td><td style="min-width: 100px" class="premix-feeds-table-action"><button type="button" class="btn btn-danger btn-xs" ng-click="vm.removeNewFeed(feed)"><i class="fa fa-close"></i></button></td></tr><tr class="dndPlaceholder"><td colspan="8"><data-i18n i18n="_m_f_drag_and_drop_placeholder_">Drop here</data-i18n></td></tr><tr ng-form="" name="vm.newPremixFeedForm" ng-if="vm.showIFields" class="premix-feeds-table-manual-row"><td><div class="form-group has-feedback premix-feed-name-column" ng-class="{\'has-error\': vm.newPremixFeedForm.name.$invalid && (vm.newPremixFeedForm.name.$dirty || vm.newPremixFeedForm.$submitted)}"><input type="text" class="form-control" required="" id="name" name="name" ng-model="vm.feedFromApi" uib-typeahead="feed as feed.feed_name for feed in vm.getFeedByName($viewValue)" typeahead-on-select="vm.feedSelected($item)" typeahead-loading="vm.loadingFeedByName" typeahead-append-to-body="true" typeahead-no-results="vm.noResults" ng-keypress="vm.inputKeyPress($event)"> <span class="help-block error-block basic-block"><data-i18n i18n="_toastr_feeds_name_required_">Feed name is required</data-i18n></span></div></td><td><div class="form-group premix-feed-type-column" ng-class="{\'has-error\': vm.newPremixFeedForm.feed_type.$invalid && vm.newPremixFeedForm.$submitted}"><ui-select ng-model="vm.new_feed.feed_type" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" required="" id="feed_type" name="feed_type" ng-change="vm.feedTypeSelected()"><ui-select-match placeholder="{{\'_picker_feed_type_placeholder_\' | i18n}}" uib-tooltip="{{$select.selected.translated}}" tooltip-enable="{{$select.selected.translated.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{$select.selected.translated}}</ui-select-match><ui-select-choices repeat="feed_type in vm.feed_types | filter: $select.search"><span class="shorten-long-text" ng-bind-html="feed_type.translated"></span></ui-select-choices></ui-select></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newPremixFeedForm.dm.$invalid && (vm.newPremixFeedForm.dm.$dirty || vm.newPremixFeedForm.$submitted)}"><input select-on-click="" type="number" class="form-control" required="" id="dm" name="dm" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.new_feed.dm" min="0.01" max="100" step="0.01" ng-change="vm.newFeedDmChanged()" ng-keypress="vm.inputKeyPress($event)"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_label_dm_required_">DM is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newPremixFeedForm.amount.$invalid && (vm.newPremixFeedForm.amount.$dirty || vm.newPremixFeedForm.$submitted)}"><input select-on-click="" type="number" class="form-control" required="" id="amount" name="amount" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.new_feed.amount" format-input-value="amount" default-return-value="null" min="0" ng-change="vm.newFeedAmountDmChanged()" ng-keypress="vm.inputKeyPress($event)"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_amount_dm_required_">Amount DM is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newPremixFeedForm.as_fed.$invalid && (vm.newPremixFeedForm.as_fed.$dirty || vm.newPremixFeedForm.$submitted)}"><input select-on-click="" type="number" class="form-control" required="" id="as_fed" name="as_fed" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.new_feed.as_fed" format-input-value="as_fed" default-return-value="null" min="0" ng-change="vm.newFeedAmountAsFedChanged()" ng-keypress="vm.inputKeyPress($event)"> <span class="help-block error-block basic-block"><data-i18n i18n="_feeds_as_fed_required_">As fed is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newPremixFeedForm.cost.$invalid && (vm.newPremixFeedForm.cost.$dirty || vm.newPremixFeedForm.$submitted)}"><input select-on-click="" type="number" class="form-control" id="cost" name="cost" ng-pattern="/^[0-9]+(\\.[0-9]{1,3})?$/" ng-model="vm.new_feed.cost" format-input-value="cost_dm" default-return-value="null" min="0" ng-change="vm.newFeedCostDmChanged()" ng-keypress="vm.inputKeyPress($event)"></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newPremixFeedForm.cost_as_fed.$invalid && (vm.newPremixFeedForm.cost_as_fed.$dirty || vm.newPremixFeedForm.$submitted)}"><input select-on-click="" type="number" class="form-control" ng-pattern="/^[0-9]+(\\.[0-9]{1,3})?$/" id="cost_as_fed" name="cost_as_fed" ng-model="vm.new_feed.cost_as_fed" format-input-value="cost_dm" default-return-value="null" min="0" ng-change="vm.newFeedCostAsFedChanged()" ng-keypress="vm.inputKeyPress($event)"></div></td><td style="width: 100px" class="premix-feeds-table-action"><button type="submit" ng-disabled="vm.newPremixFeedForm.$invalid || vm.disableAddFeed" class="btn btn-primary btn-xs" ng-click="vm.addNewFeed()"><i class="fa fa-check"></i></button> <button type="button" class="btn btn-danger btn-xs" ng-click="vm.cancelAddNewFeed()"><i class="fa fa-trash"></i></button></td></tr></tbody></table></div><div class="premix-error-text" ng-class="(vm.premix.feeds.length === 0 || vm.newPremixFeedForm.$invalid || vm.showIFields) && vm.selectBasisForm.$submitted ? \'premix-error\' : \'\'"><data-i18n i18n="_m_f_premix_feeds_required_">Feeds are required</data-i18n></div><div class="premix-error-text" ng-class="!vm.premix.dm && vm.selectBasisForm.$submitted ? \'premix-error\' : \'\'"><data-i18n i18n="_m_f_premix_basis_dm_error_">Basis DM is 0. Choose another basis or update the selected one to continue</data-i18n></div><div class="premix-error-text" ng-class="vm.hasDM0Error && vm.selectBasisForm.$submitted ? \'premix-error\' : \'\'"><data-i18n i18n="_m_f_premix_ingredient_dm_error_">Ingredient DM can\'t be 0</data-i18n></div><div class="premix-error-text" ng-class="vm.premix.amount > 40 ? \'dmi-error\' : \'\'"><data-i18n i18n="_m_f_dmi_exceeded_message_" select-on-click="">Daily DMI should not exceed</data-i18n>&nbsp;{{vm.max}}{{vm.weight}}</div></div><div ng-if="vm.loading" style="height: 200px; overflow: hidden" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/premixes/addNewPremix/wizard.html','<div ng-if="!vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div><ba-wizard id="add-premix-tabs" ng-show="!vm.loading && vm.selectedHerd" class="premix-tabs" ng-class="vm.tabValidation()"><ba-wizard-step title="{{vm.step1}}" form="vm.selectBasisForm" class="wizard-step"><div align="right"><button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.selectBasisForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.selectBasisForm.premix_name.$invalid && (vm.selectBasisForm.premix_name.$dirty || vm.selectBasisForm.$submitted)}"><label for="premix_name"><data-i18n i18n="_m_f_premix_name_">Premix name</data-i18n></label> <input select-on-click="" type="text" maxlength="60" class="form-control" id="premix_name" name="premix_name" placeholder="{{\'_m_f_premix_name_\' | i18n}}" ng-model="vm.premix.premix_name" ng-change="vm.premixDirty(\'basis\')" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_premix_name_required_">Premix name is required</data-i18n></span></div></div></div><input type="text" required="" ng-show="false" ng-model="vm.premix.dm"> <input type="text" required="" ng-show="false" ng-if="vm.showIFields" ng-model="vm.emptyFeedFormValidator"> <input type="text" required="" ng-show="false" ng-if="vm.premix.selected_basis.value !== 3" ng-model="vm.premix.basis_help_input"> <input type="text" required="" ng-show="false" ng-if="vm.premix.feeds.length === 0 || vm.newPremixFeedForm.$invalid || vm.hasDM0Error" ng-model="vm.newFeedFormValidator"></form><div class="row"><div class="col-md-6"><label style="font-weight: 400; margin-top: 10px"><data i18n="_m_f_premix_select_basis_option_">Select your basis for creating a premix</data>:</label></div></div><div class="row" style="padding-top: 10px"><div class="col-md-6"><div class="form-group"><label><data i18n="_m_f_premix_select_basis_">Select basis</data>:</label><ui-select ng-model="vm.premix.selected_basis" class="btn-group bootstrap-select form-control" ng-disabled="vm.loadingBasis" append-to-body="true" search-enabled="true" ng-change="vm.basisChanged()"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type in vm.basisTypes | filter: $select.search"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div></div></div><div ng-if="vm.premix.selected_basis.value !== 3"><div class="row"><div class="col-md-12"><div include-with-scope="app/pages/premixes/addNewPremix/basis.table.html"></div></div></div><div class="row" ng-if="vm.premix.basis_selected"><div class="col-md-12"><div include-with-scope="app/pages/premixes/addNewPremix/premixFeeds.table.html"></div></div></div></div><div ng-if="vm.premix.selected_basis.value === 3" class="row"><div class="col-md-12"><div include-with-scope="app/pages/premixes/addNewPremix/premixFeeds.table.html"></div></div></div></ba-wizard-step><ba-wizard-step title="{{vm.step2}}" form="vm.planningForm" class="wizard-step"><div align="right"><button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.planningForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group"><label><data i18n="_m_f_premix_choose_amount_">Choose how premix amount is calculated</data>:</label><ui-select ng-model="vm.premix.selected_amount_option" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-change="vm.amountOptionChanged()"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type in vm.amountOptions | filter: $select.search"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-if="vm.premix.selected_amount_option.value === 0" ng-class="{\'has-error\': vm.planningForm.number_of_animals.$invalid && (vm.planningForm.number_of_animals.$dirty || vm.planningForm.$submitted)}"><label for="number_of_animals"><data-i18n i18n="_groups_no_animals_">Number of animals</data-i18n>&nbsp;(<data i18n="_m_f_premix_total_amount_">Total amount</data>:&nbsp;{{vm.premix.total_premix_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}})</label> <input select-on-click="" type="number" min="1" max="99999" step="1" pattern="^\\d*(\\.\\d{0})?$" class="form-control" id="number_of_animals" name="number_of_animals" placeholder="{{\'_groups_no_animals_\' | i18n}}" ng-model="vm.premix.number_of_animals" ng-change="vm.calculateTotalAmount()" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_no_animals_required_">Number of animals is required</data-i18n></span></div><div class="form-group has-feedback" ng-if="vm.premix.selected_amount_option.value === 1" ng-class="{\'has-error\': vm.planningForm.total_amount.$invalid && (vm.planningForm.total_amount.$dirty || vm.planningForm.$submitted)}"><label for="total_amount"><data i18n="_m_f_premix_total_amount_">Total amount</data>:&nbsp;{{vm.premix.total_premix_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</label> <input select-on-click="" type="number" min="1" max="99999" step="1" pattern="^\\d*(\\.\\d{0})?$" class="form-control" id="total_amount" name="total_amount" placeholder="{{\'_m_f_premix_total_amount_\' | i18n}}" ng-model="vm.premix.total_amount" format-input-value="rounded_amount" ng-change="vm.calculateTotalAmount()" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_premix_total_amount_required_">Total amount is required</data-i18n></span></div><div class="premix-wagon-container"><label><data-i18n i18n="_m_f_premix_choose_mixer_wagon_">Choose your mixer wagons</data-i18n>:</label><div><button class="btn btn-sm btn-primary" ng-click="vm.openAddWagonModal($event)"><data-i18n i18n="_m_f_recipe_add_wagon_">Add wagon</data-i18n></button></div><div class="premix-wagon-inner premix-validation-container" ng-class="!vm.premix.wagon_help_input && vm.planningForm.$submitted ? \'premix-error\' : \'\'"><table class="premix-wagon-table" ng-if="!vm.loadingMixerWagons"><thead><tr ng-if="vm.premix.wagons.length > 0"><th colspan="2"><data i18n="_m_f_premix_select_mixer_wagon_">Select wagon</data></th><th><data i18n="_label_name_">Name</data></th><th><data i18n="_m_f_wagons_capacity_">Capacity</data></th><th><data i18n="_m_f_premix_choose_default_mixer_wagon_">Choose default mixer wagon</data>:</th></tr><span class="warningModal" ng-if="vm.premix.wagons.length === 0"><data-i18n i18n="_m_f_premix_wagon_not_available_">Mixer wagon not availabe</data-i18n></span></thead><tbody lazy-img-container="" ng-if="vm.premix.wagons.length > 0"><tr ng-repeat="wagon in vm.premix.wagons"><td><span class="newCheck"><input type="checkbox" id="wagon_checked_{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="wagon.selected" ng-change="vm.wagonSelected(wagon)"> <label for="wagon_checked_{{$index}}"></label></span></td><td><span class="select-wagon-img"><img src="assets/img/MmmLogo.png" lazy-img="{{wagon.image_url}}" lazy-img-error="assets/img/MmmLogo.png" ng-if="wagon.image_url"> <img src="assets/img/MmmLogo.png" ng-if="!wagon.image_url"></span></td><td class="shorten-long-text"><span class="wagon-name" uib-tooltip="{{wagon.name}}" tooltip-enable="{{wagon.name.length > 15 ? true : false}}" tooltip-is-open="wagonNameOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-hide-overflow" tooltip-popup-delay="500">{{wagon.name}}</span></td><td><span>{{wagon.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</span></td><td><span ng-if="wagon.selected" class="newCheck"><input type="checkbox" id="default_checked_{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="wagon.default" ng-disabled="wagon.default" ng-change="vm.defaultSelected(wagon)"> <label for="default_checked_{{$index}}"></label></span></td></tr></tbody></table></div></div><div class="premix-error-text" ng-class="!vm.premix.wagon_help_input && vm.planningForm.$submitted ? \'premix-error\' : \'\'"><span class="warningModal"><data-i18n i18n="_m_f_feeding_mixer_wagon_required_">Mixer wagon is required</data-i18n></span></div><div ng-if="vm.loadingMixerWagons" style="overflow: hidden"><div style="text-align: center"><div id="loading-animation-large"></div></div></div><input required="" type="text" ng-show="false" ng-model="vm.premix.wagon_help_input"></div><div class="col-md-6"><div class="row"><div class="col-md-6 form-group has-feedback premix-feeding-date" ng-class="{\'has-error\': vm.planningForm.start_feeding_date.$invalid && (vm.planningForm.start_feeding_date.$dirty || vm.planningForm.$submitted)}"><label for="start_feeding_date"><data i18n="_m_f_premix_select_start_feeding_date_">Select start feeding date</data>:</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" placeholder="{{vm.date_format}}" ng-model="vm.premix.start_feeding_date" is-open="datePickerOpened1" required="" datepicker-append-to-body="true" close-text="Close" show-button-bar="false" id="start_feeding_date" name="start_feeding_date" popup-placement="bottom-right" ng-change="vm.calculateTotalPremixAmount()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="datePickerOpened1 = !datePickerOpened1"><i class="glyphicon glyphicon-calendar"></i></button></span></p><span class="premix-error-text" ng-class="{\'premix-error\': vm.planningForm.start_feeding_date.$invalid && (vm.planningForm.start_feeding_date.$dirty || vm.planningForm.$submitted)}"><data-i18n i18n="_date_format_validation_label_">date required</data-i18n>&nbsp;{{vm.date_format}}</span></div><div class="col-md-6 form-group has-feedback premix-time-picker" ng-class="{\'has-error\': vm.planningForm.premix_feeding_time.$invalid && (vm.planningForm.premix_feeding_time.$dirty || vm.planningForm.$submitted)}"><label for="premix_feeding_time"><data-i18n i18n="_m_f_feeding_period_label_">Feeding period</data-i18n>:&nbsp;{{vm.premix.feeding_period.name}}</label><div class="input-group"><input type="text" class="form-control" id="premix_feeding_time" name="premix_feeding_time" ng-model="vm.premix.ft" ng-change="vm.timeChanged()" required="" placeholder="--:-- --" ng-model-options="{allowInvalid: true, updateOn: \'blur\'}"> <span class="input-group-btn"><button type="button" class="btn btn-default" moment-picker="vm.premix.ft" ng-model="vm.premix.feeding_time" change="vm.timeChanged()" format="hh:mm A" locale="{{vm.locale}}" ng-model-options="{ updateOn: \'blur\' }"><i class="glyphicon glyphicon-time"></i></button></span></div><span class="premix-error-text" ng-class="{\'premix-error\': vm.planningForm.premix_feeding_time.$invalid && (vm.planningForm.premix_feeding_time.$dirty || vm.planningForm.$submitted)}"><data-i18n i18n="_m_f_premix_feeding_time_required_">Feeding time is not set properly</data-i18n></span></div></div><div class="form-group"><label><data i18n="_m_f_premix_select_repeat_interval_">Select repeat interval</data>:</label><ui-select ng-model="vm.premix.selected_interval" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-change="vm.calculateTotalPremixAmount()"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type in vm.intervalOptions | filter: $select.search"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div><div ng-if="vm.premix.selected_interval.value === 4" style="padding-bottom: 10px"><div class="weekDays-selector checkbox-inline" ng-repeat="day in vm.premix.custom_days"><input type="checkbox" ng-click="vm.daySelected()" ng-model="day.selected" id="custom_frequency_{{$index}}"> <label for="custom_frequency_{{$index}}">{{day.name}}</label></div><div ng-if="!vm.premix.custom_days_validation && vm.planningForm.$submitted"><span class="warningModal"><data-i18n i18n="_m_f_pen_frequency_of_feeding_required_">frequency of feeding is required</data-i18n></span></div><input required="" type="text" ng-show="false" ng-model="vm.premix.custom_days_validation"></div><div ng-if="vm.premix.selected_interval.value !== 5" class="form-group has-feedback" ng-class="{\'has-error\': vm.planningForm.repeat_interval.$invalid && (vm.planningForm.repeat_interval.$dirty || vm.planningForm.$submitted)}"><label for="repeat_interval"><data-i18n i18n="_m_f_premix_repeat_interval_">Repeat interval</data-i18n></label> <input select-on-click="" type="number" step="1" min="1" class="form-control" id="repeat_interval" name="repeat_interval" placeholder="{{\'_m_f_premix_repeat_interval_\' | i18n}}" ng-model="vm.premix.repeat_interval" ng-change="vm.calculateTotalPremixAmount()" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_premix_repeat_interval_required_">Repeat interval is required</data-i18n></span></div></div></div></form></ba-wizard-step><ba-wizard-step title="{{vm.step3}}" form="vm.managementForm" class="wizard-step"><form name="vm.managementForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.managementForm.premix_name_m.$invalid && (vm.managementForm.premix_name_m.$dirty || vm.managementForm.$submitted)}"><label for="premix_name_m"><data-i18n i18n="_m_f_premix_name_">Premix name</data-i18n></label> <input select-on-click="" type="text" class="form-control" id="premix_name_m" name="premix_name_m" placeholder="{{\'_m_f_premix_name_\' | i18n}}" ng-model="vm.premix.premix_name" ng-change="vm.premixDirty(\'drop\')" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_premix_name_required_">Premix name is required</data-i18n></span></div></div></div><input type="text" required="" ng-show="false" ng-model="vm.premix.suggestion_help_input"></form><div class="row"><div class="col-md-12"><div include-with-scope="app/pages/premixes/addNewPremix/overview.panel.html"></div></div><div class="col-md-12"><div include-with-scope="app/pages/premixes/addNewPremix/load_suggestion.table.html"></div></div></div></ba-wizard-step><ba-wizard-step title="{{vm.step4}}" class="wizard-step"><form class="form-horizontal" name="vm.finishForm" novalidate=""><div style="font-size: 16px"><data-i18n i18n="_m_f_add_new_premix_finish_message_">You have successfully defined a new premix. Do you want to save your work?</data-i18n></div></form><div style="margin-top: 10px" align="right"><button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.savePremix()"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_"></data-i18n></button></div></ba-wizard-step></ba-wizard><div ng-if="vm.loading" align="center" style="overflow: hidden"><div><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/premixes/editPremix/addWagon.modal.html','<div class="modal-content" ng-cloak=""><div ng-if="!vm.modalLoading"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><div style="max-height: 400px; overflow: auto"><table style="padding: 5px" class="table"><tbody><tr ng-repeat="wagon in vm.premix.wagons" ng-show="!wagon.selected"><td><span class="wagon-name" uib-tooltip="{{wagon.name}}" tooltip-enable="{{wagon.name.length > 30 ? true : false}}" tooltip-is-open="wagonNameOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-hide-overflow" tooltip-popup-delay="500">{{wagon.name}}</span></td><td>{{wagon.value | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</td><td><button class="btn btn-xs btn-success" ng-click="vm.addExistingWagon(wagon)"><data-i18n i18n="_m_f_btn_add_">Add</data-i18n></button></td></tr></tbody></table></div><span style="margin-bottom: 10px; display: inline-block"><data-i18n i18n="_m_f_menu_wagons_add_wagon_">Create custom wagon</data-i18n>:</span><form name="vm.customWagonForm" novalidate=""><div class="form-group"><div class="form-group" ng-class="{\'has-error\': vm.customWagonForm.wagon_name.$invalid && (vm.customWagonForm.wagon_name.$dirty || vm.customWagonForm.$submitted)}"><input class="form-control" type="text" id="wagon_name" name="wagon_name" ng-model="vm.newWagon.name" placeholder="{{\'_m_f_wagons_name_\' | i18n}}" select-on-click="" required=""> <span class="help-block error-block basic-block warningModal"><data-i18n i18n="_m_f_premix_wagon_name_required_">Wagon name is required</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.customWagonForm.mac_address.$invalid && (vm.customWagonForm.mac_address.$dirty || vm.customWagonForm.$submitted)}"><input class="form-control" type="text" id="mac_address" name="mac_address" placeholder="xx:xx:xx:xx:xx:xx" pattern="^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$" maxlength="17" ng-model="vm.newWagon.mac_address" select-on-click=""> <span class="help-block error-block basic-block warningModal"><data-i18n i18n="_m_f_premix_mac_required_label_">MAC address is required</data-i18n></span></div><label><data-i18n i18n="_m_f_wagons_capacity_">capacity</data-i18n></label><div class="form-group" ng-class="{\'has-error\': vm.customWagonForm.volume.$invalid && (vm.customWagonForm.volume.$dirty || vm.customWagonForm.$submitted)}"><input type="number" class="form-control with-units" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" min="0.1" max="90" step="0.1" id="volume" name="volume" ng-model="vm.newWagon.volume" placeholder="{{\'_m_f_wagons_volume_\'|i18n}}" select-on-click=""><span>m<sup>3</sup></span><br></div><div class="form-group" ng-class="{\'has-error\': vm.customWagonForm.value.$invalid && (vm.customWagonForm.value.$dirty || vm.customWagonForm.$submitted)}"><input type="number" class="form-control with-units" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" min="0.1" max="90" step="0.1" id="value" name="value" ng-model="vm.newWagon.value" placeholder="{{\'_m_f_wagons_weight_\'|i18n}}" select-on-click="" required=""><span>t</span> <span class="help-block error-block basic-block warningModal"><data-i18n i18n="_m_f_wagons_weight_required_">weight is required</data-i18n></span></div></div><button class="btn btn-xs btn-success" ng-disabled="vm.customWagonForm.$invalid === true" ng-click="vm.addWagon()"><data-i18n i18n="_m_f_btn_add_">Add</data-i18n></button></form></div></div><div class="modal-body" ng-if="vm.modalLoading" style="overflow: hidden"><div align="center"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/premixes/editPremix/basis.table.html','<div class="horizontal-scroll premix-table" ng-class="!vm.premix.basis_help_input && vm.selectBasisForm.$submitted ? \'premix-error\' : \'\'"><table class="table table-hover" ng-if="!vm.loadingBasis"><thead><tr class="sortable"><th align="left"><data-i18n i18n="_title_column_action_">action</data-i18n></th><th><data-i18n i18n="_m_f_premix_basis_name_label_">Basis name</data-i18n></th><th><data-i18n i18n="_feeds_dm_">dm</data-i18n>&nbsp;(%)</th><th><data-i18n i18n="_m_f_premix_amount_label_">Amount</data-i18n>&nbsp;({{vm.weight}})</th><th><data-i18n i18n="_m_f_premix_cost_label_">Cost</data-i18n>&nbsp;({{vm.currency}})</th></tr></thead><tbody class="premix-basis"><tr ng-class="!vm.premix.original_basis.visible ? \'ration-deleted\' : \'\'"><td><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}-X" ng-true-value="true" ng-false-value="false" ng-click="vm.selectOriginalBasis()" ng-model="vm.premix.original_basis_selected" ng-disabled="vm.premix.original_basis_selected || vm.historicalVersion" style="margin-right: 2px"> <label for="is_checked{{$index}}-X"></label></span></td><td class="shorten-long-text"><span>{{vm.premix.original_basis.name}}&nbsp;</span> <label class="basis-info-note">{{vm.premix.original_basis.origin}}</label></td><td>{{vm.premix.original_basis.dm | number:2}}</td><td>{{vm.premix.original_basis.amount | formatViewValues: \'amount\'}}</td><td>{{vm.premix.original_basis.cost | number:2}}</td></tr></tbody><thead><tr class="error-row" ng-if="!vm.premix.original_basis.visible && vm.premix.original_basis_selected"><td colspan="6"><data-i18n i18n="_m_f_recipe_ration_deleted_">Selected ration has been deleted.</data-i18n></td></tr></thead><tbody class="basis-list"><tr ng-repeat="basis in vm.basis | orderBy: \'-id\'" ng-if="basis.is_displayed" ng-class="basis.duplicate ? \'duplicate-ration-opacity\' : \'\'"><td><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}-X" ng-true-value="true" ng-false-value="false" ng-click="vm.selectBasis(basis)" ng-model="basis.is_selected" ng-disabled="basis.is_selected || vm.historicalVersion" style="margin-right: 2px"> <label for="is_checked{{$index}}-X"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editBasis(basis)" uib-tooltip="{{\'_tips_edit_\' | i18n}}" tooltip-is-open="editBasisOpen{{basis.id}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="vm.premix.selected_basis.value != 2" ng-disabled="vm.historicalVersion"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.basisDetails(basis)" uib-tooltip="{{\'_tips_details_\' | i18n}}" tooltip-is-open="detailsbasisOpen{{basis.id}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clipboard"></i></button></td><td class="shorten-long-text"><span>{{basis.name}}</span> <label class="basis-info-note">{{basis.origin}}</label></td><td>{{basis.dm | number:2}}</td><td>{{basis.amount | formatViewValues: \'amount\'}}</td><td>{{basis.cost | number:2}}</td></tr><tr class="show-hide-filters" ng-if="vm.premix.show_hide_ration_button"><td colspan="6"><button ng-click="vm.toggleShowBasis()"><i ng-if="vm.hideFilters" class="ion-arrow-up-b"></i><i ng-if="!vm.hideFilters" class="ion-arrow-down-b"></i><span><data-i18n i18n="_label_show_hide_ration_">Show/hide duplicate ration</data-i18n></span><i ng-if="vm.hideFilters" class="ion-arrow-up-b"></i><i ng-if="!vm.hideFilters" class="ion-arrow-down-b"></i></button></td></tr></tbody><tfoot ng-if="vm.totalItemsBasis > 10"><tr><td colspan="6" style="text-align: center"><uib-pagination boundary-links="true" total-items="vm.totalItemsBasis" ng-model="vm.premix.current_page" items-per-page="10" max-size="7" ng-change="vm.basisPaginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></td></tr></tfoot></table></div><div class="premix-error-text" ng-class="!vm.premix.basis_help_input && vm.selectBasisForm.$submitted ? \'premix-error\' : \'\'"><data-i18n i18n="_m_f_premix_basis_required_" select-on-click="">Basis is required</data-i18n></div><div ng-if="vm.loadingBasis" align="center" style="overflow: hidden"><div><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/premixes/editPremix/basisDetails.modal.html','<div class="modal-content" ng-cloak=""><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><table class="table table-hover"><thead><tr><th style="text-align: center"><data-i18n i18n="_feeds_name_">Feed name</data-i18n></th><th><data-i18n i18n="_feeds_dm_">DM</data-i18n><br>%</th><th><data-i18n i18n="_feeds_amount_">Amount DM</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_cost_dm_">Cost</data-i18n><br>{{vm.currency}}/{{vm.weight}}<span>&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th><th><data-i18n i18n="_feeds_cost_as_fed_">Cost as fed</data-i18n><br>{{vm.currency}}/{{vm.weight}}<span>&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th></tr></thead><tbody><tr ng-repeat="feed in vm.modalBasis.ingredient_list"><td>{{feed.name}}</td><td>{{feed.dm | number: 2}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.as_fed | formatViewValues: \'as_fed\'}}</td><td>{{feed.cost | formatViewValues: \'cost_dm\'}}</td><td>{{feed.cost_as_fed | formatViewValues: \'cost_dm\'}}</td></tr></tbody></table><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div></div>');
$templateCache.put('app/pages/premixes/editPremix/editPremix.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll horizontal-scrol"><div include-with-scope="app/pages/premixes/editPremix/wizard.html"></div></div></div></div></div>');
$templateCache.put('app/pages/premixes/editPremix/editPremixManually.panel.html','<div ng-if="!vm.loading"><h3 class="with-line"><data i18n="_m_f_premix_info_">Premix info</data></h3><div class="row"><div class="col-md-6"><div class="form-group"><label><data-i18n i18n="_feeds_dm_">DM</data-i18n></label><div>{{vm.new_premix.dm || \'-\'}}</div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label><data-i18n i18n="_m_f_recipe_cost_">Cost</data-i18n></label><div>{{vm.new_premix.cost_dm || \'-\'}}</div></div></div></div><div style="margin-bottom: 10px" class="premix-validation-container" ng-class="(vm.new_premix.feeds.length === 0 || vm.newPremixFeedForm.$invalid) && vm.selectBasisForm.$submitted ? \'premix-error\' : \'\'"><table class="table"><thead><tr><th style="padding: 4px 4px"><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br></th><th style="padding: 4px 4px"><data-i18n i18n="_feeds_type_">Feed type</data-i18n><br></th><th style="padding: 4px 4px"><data-i18n i18n="_feeds_dm_">DM</data-i18n><br>%</th><th style="padding: 4px 4px"><data-i18n i18n="_feeds_amount_">Amount DM</data-i18n><br>{{vm.weight}}</th><th style="padding: 4px 4px"><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n><br>{{vm.weight}}</th><th style="padding: 4px 4px"><data-i18n i18n="_feeds_cost_dm_">Cost DM</data-i18n><br>{{vm.currency}}/{{vm.weight}}<span style="margin-left: 3px"><data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th><th style="padding: 4px 4px"><data-i18n i18n="_feeds_cost_as_fed_">Cost as fed</data-i18n><br>{{vm.currency}}/{{vm.weight}}<span style="margin-left: 3px; text-transform: lowercase"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n></span></th><th style="padding: 4px 4px"><button type="button" class="btn btn-success btn-with-icon" style="width: 36px; display: inline-block; margin-left: 3px" ng-click="vm.showInputFields()" ng-disabled="vm.showIFields"><i class="ion-android-add"></i></button></th></tr></thead><tbody><tr ng-repeat="feed in vm.new_premix.feeds"><td style="width: 200px; vertical-align: middle; padding: 4px 4px"><span editable-text="feed.feed_name" e-required="" e-style="width: 220px">{{feed.feed_name}}</span></td><td style="width: 180px; vertical-align: middle; padding: 4px 4px"><a href="#" editable-select="feed.feed_type" e-required="" e-style="width: 200px" onshow="loadGroups()" e-ng-options="feed_type as feed_type.name for feed_type in vm.feed_types">{{feed.feed_type.name}}</a></td><td style="width: 180px; vertical-align: middle; padding: 4px 4px"><span editable-number="feed.dm" e-step="0.01" e-required="" e-style="width: 200px" onbeforesave="vm.updateNewFeed($data,$index,\'dm\')">{{feed.dm}}</span></td><td style="width: 180px; vertical-align: middle; padding: 4px 4px"><span editable-number="feed.amount_dm" e-required="" e-step="0.01" e-style="width: 200px" onbeforesave="vm.updateNewFeed($data,$index,\'amount_dm\')">{{feed.amount_dm}}</span></td><td style="width: 180px; vertical-align: middle; padding: 4px 4px"><span editable-number="feed.amount_as_fed" e-required="" e-step="0.01" e-style="width: 200px" onbeforesave="vm.updateNewFeed($data,$index,\'amount_as_fed\')">{{feed.amount_as_fed}}</span></td><td style="width: 180px; vertical-align: middle; padding: 4px 4px"><span editable-number="feed.cost_dm" e-required="" e-step="0.01" e-style="width: 200px" onbeforesave="vm.updateNewFeed($data,$index,\'cost_dm\')">{{feed.cost_dm}}</span></td><td style="width: 180px; vertical-align: middle; padding: 4px 4px"><span editable-number="feed.cost_as_fed" e-required="" e-step="0.01" e-style="width: 200px" onbeforesave="vm.updateNewFeed($data,$index,\'cost_as_fed\')">{{feed.cost_as_fed}}</span></td><td style="width: 100px; vertical-align: middle; padding: 4px 4px"><button type="button" class="btn btn-danger btn-sm" style="width: 36px; display: inline-block; margin-left: 3px" ng-click="vm.removeNewFeed($index)"><i class="ion-android-close"></i></button></td></tr><tr ng-form="" name="vm.newPremixFeedForm" ng-if="vm.showIFields"><td style="padding: 4px 4px"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newPremixFeedForm.feed_name.$invalid && (vm.newPremixFeedForm.feed_name.$dirty || vm.newPremixFeedForm.$submitted)}"><input type="text" class="form-control" required="" id="feed_name" name="feed_name" ng-model="vm.new_feed.feed_name" style="padding-right: 12px; margin-top: 5px" ng-keypress="vm.inputKeyPress($event)"> <span class="help-block error-block basic-block"><data-i18n i18n="_toastr_feeds_name_required_" select-on-click="">Feed name is required</data-i18n></span></div></td><td style="padding: 4px 4px"><div class="form-group" ng-class="{\'has-error\': vm.newPremixFeedForm.feed_type.$invalid && vm.newPremixFeedForm.$submitted}" style="width: auto; min-width: 175px; margin-top: 5px"><ui-select ng-model="vm.new_feed.feed_type" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" required="" id="feed_type" name="feed_type" ng-change="vm.feedTypeSelected()"><ui-select-match placeholder="{{\'_picker_feed_type_placeholder_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="feed_type in vm.feed_types | filter: $select.search"><span ng-bind-html="feed_type.name"></span></ui-select-choices></ui-select></div></td><td style="min-width: 75px; padding: 4px 4px"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newPremixFeedForm.dm.$invalid && (vm.newPremixFeedForm.dm.$dirty || vm.newPremixFeedForm.$submitted)}"><input type="number" class="form-control" required="" id="dm" name="dm" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.new_feed.dm" min="0.01" max="100" step="0.01" ng-change="vm.newFeedDmChanged()" style="padding-right: 12px; margin-top: 5px" ng-keypress="vm.inputKeyPress($event)"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_label_dm_required_" select-on-click="">DM is required</data-i18n></span></div></td><td style="padding: 4px 4px"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newPremixFeedForm.amount_dm.$invalid && (vm.newPremixFeedForm.amount_dm.$dirty || vm.newPremixFeedForm.$submitted)}"><input type="number" class="form-control" required="" id="amount_dm" name="amount_dm" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.new_feed.amount_dm" min="0" ng-change="vm.newFeedAmountDmChanged()" style="padding-right: 12px; margin-top: 5px" ng-keypress="vm.inputKeyPress($event)"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_amount_dm_required_" select-on-click="">Amount DM is required</data-i18n></span></div></td><td style="padding: 4px 4px"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newPremixFeedForm.amount_as_fed.$invalid && (vm.newPremixFeedForm.amount_as_fed.$dirty || vm.newPremixFeedForm.$submitted)}"><input type="number" class="form-control" required="" id="amount_as_fed" name="amount_as_fed" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.new_feed.amount_as_fed" min="0" ng-change="vm.newFeedAmountAsFedChanged()" style="padding-right: 12px; margin-top: 5px" ng-keypress="vm.inputKeyPress($event)"> <span class="help-block error-block basic-block"><data-i18n i18n="_feeds_as_fed_required_" select-on-click="">As fed is required</data-i18n></span></div></td><td style="padding: 4px 4px"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newPremixFeedForm.cost_dm.$invalid && (vm.newPremixFeedForm.cost_dm.$dirty || vm.newPremixFeedForm.$submitted)}"><input type="number" class="form-control" id="cost_dm" name="cost_dm" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.new_feed.cost_dm" min="0" ng-change="vm.newFeedCostDmChanged()" style="padding-right: 12px; margin-top: 5px" ng-keypress="vm.inputKeyPress($event)"></div></td><td style="padding: 4px 4px"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newPremixFeedForm.cost_as_fed.$invalid && (vm.newPremixFeedForm.cost_as_fed.$dirty || vm.newPremixFeedForm.$submitted)}"><input type="number" class="form-control" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" id="cost_as_fed" name="cost_as_fed" ng-model="vm.new_feed.cost_as_fed" min="0" ng-change="vm.newFeedCostAsFedChanged()" style="padding-right: 12px; margin-top: 5px" ng-keypress="vm.inputKeyPress($event)"></div></td><td style="width: 100px"><button type="submit" ng-disabled="vm.newPremixFeedForm.cost_dm.$invalid || vm.newPremixFeedForm.cost_as_fed.$invalid" class="btn btn-primary btn-with-icon" style="width: 36px; display: inline-block; margin-top: 8px" ng-click="vm.addNewFeed()"><i class="ion-checkmark-round"></i></button> <button type="button" class="btn btn-danger btn-with-icon" style="width: 36px; display: inline-block; margin-top: 8px" ng-click="vm.cancelAddNewFeed()"><i class="ion-android-close"></i></button></td></tr></tbody></table></div><div class="premix-error-text" ng-class="(vm.new_premix.feeds.length === 0 || vm.newPremixFeedForm.$invalid) && vm.selectBasisForm.$submitted ? \'premix-error\' : \'\'"><data-i18n i18n="_m_f_premix_feeds_required_" select-on-click="">Feeds are required</data-i18n></div></div><div ng-if="vm.loading" style="height: 200px; overflow: hidden;" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/premixes/editPremix/loadForm.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><div ng-show="vm.load.wagon"><label><data-i18n i18n="_m_f_wagons_capacity_">Capacity</data-i18n>:&nbsp;{{vm.load.wagon.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</label></div><div ng-if="vm.showRequiredAmount"><label><data-i18n i18n="_recipe_load_required_amount_">required amount</data-i18n>:&nbsp;<span>{{vm.loadRequiredAmount | formatViewValues: \'rounded_amount\'}}</span></label> <button ng-show="vm.loadRequiredAmount !== vm.load.value" class="btn btn-xs btn-success" ng-click="vm.setLoad()"><data-i18n i18n="_button_label_set_">set</data-i18n></button></div><form name="vm.loadForm"><div ng-class="{\'has-error\': vm.load.value > vm.load.wagon.value || (vm.loadForm.value.$invalid && (vm.loadForm.value.$dirty || vm.loadForm.$submitted))}" class="form-group has-feedback"><label for="value"><data-i18n i18n="_m_f_recipe_load_kg_">Load</data-i18n>&nbsp;({{vm.weight}}):</label> <input type="number" name="value" class="form-control" ng-model="vm.load.value" format-input-value="rounded_amount" required="" min="0" select-on-click=""></div><div class="form-group" ng-if="vm.load.wagons.length > 1"><label><data-i18n i18n="_m_f_menu_mixer_wagons_">Mixer wagons</data-i18n>:</label><ui-select ng-model="vm.load.wagon" class="btn-group bootstrap-select form-control" append-to-body="false" search-enabled="true" on-select="vm.calculateLoad()" required=""><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="wagon in vm.load.wagons | filter: $select.search"><span ng-bind-html="wagon.name"></span></ui-select-choices></ui-select></div></form></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button> <button ng-disabled="vm.load.value > vm.load.wagon.value || vm.loadForm.$invalid == true" type="button" class="btn btn-success" ng-click="vm.saveLoad()"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></div>');
$templateCache.put('app/pages/premixes/editPremix/load_suggestion.table.html','<div class="suggestion-heading"><h3><data-i18n i18n="_m_f_recipe_mixing_suggestion_">Mixing suggestion</data-i18n></h3></div><div class="premix-loads-table"><div class="col-md-9"><table class="table table-hover"><thead><tr><th><div class="mixing-suggestion-primary"><span><data-i18n i18n="_m_f_recipe_selected_wagons_">Selected wagons</data-i18n><span class="suggestion-add-button primaryModal" uib-tooltip="{{\'_m_f_recipe_add_wagon_\' | i18n}}" tooltip-append-to-body="true" tooltip-is-open="addWagon" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-ios-plus-outline" ng-click="vm.openAddWagonModal($event, true)" ng-disabled="vm.historicalVersion"></i></span></span><br ng-if="vm.feedingsError"></div></th><th><div class="mixing-suggestion-primary"><data-i18n i18n="_m_f_recipe_loads_">Loads</data-i18n>&nbsp;<span>({{vm.premix.suggestion.sum | formatViewValues: \'amount\'}}</span>&nbsp;{{vm.weight}}) <span class="suggestion-add-button primaryModal" ng-if="vm.premix.total_amount && vm.premix.total_amount > 0 && vm.premix.suggestion.loads.length < 10" ng-hide="vm.premix.wagons && vm.premix.wagons.length === 0" uib-tooltip="{{\'_m_f_premix_add_load_\' | i18n}}" tooltip-append-to-body="true" tooltip-is-open="addLoad" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-ios-plus-outline" ng-click="vm.openAddLoadModal()"></i></span> <span class="suggestion-add-button premix-reload-btn primaryModal" ng-if="vm.premix.suggestion.dirty" uib-tooltip="{{\'_m_f_premix_reset_load_configuration_\' | i18n}}" tooltip-append-to-body="true" tooltip-is-open="resetLoads" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="fa fa-refresh" ng-click="vm.calculateSuggestion()"></i></span><br ng-if="vm.feedingsError"><span ng-if="vm.feedingsError" class="warningModal"><data-i18n i18n="_rations_difference_">Difference</data-i18n>:&nbsp;{{vm.feedingsError | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</span></div></th></tr></thead><tbody><tr ng-repeat="wagon in vm.premix.wagons" ng-show="wagon.selected"><td><div><span class="premix-has-warning premix-wagon-warning" ng-class="wagon.default ? \'premix-display-warning\' : \'premix-disable-warning\'" uib-popover="{{\'_m_f_recipe_default_mixer_wagon_remove_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right"><span><span>{{wagon.name}}</span>&nbsp; <span>({{wagon.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}})</span></span> <i ng-show="wagon.default" class="fa fa-info-circle"></i></span> <span class="suggestion-remove-button" uib-tooltip="{{\'_m_f_wagons_remove_\' | i18n}}" tooltip-append-to-body="true" tooltip-is-open="removeWagon" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-ios-close-outline" ng-show="!wagon.default" ng-click="vm.removeWagon(wagon)"></i></span></div></td><td><div ng-repeat="load in vm.premix.suggestion.loads track by $index" ng-show="load.wagon_id == wagon.id" class="editable-suggestion-value"><data-i18n i18n="_m_f_recipe_load_">Load</data-i18n>&nbsp;{{$index+1}}: <span class="editable-load-value" ng-click="vm.openEditLoadModal($index)" uib-tooltip="{{\'_m_f_premix_edit_load_\' | i18n}}" tooltip-append-to-body="true" tooltip-is-open="editLoad" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500">{{load.value | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{vm.weight}} <span class="suggestion-remove-button" uib-tooltip="{{\'_m_f_premix_remove_load_\' | i18n}}" tooltip-append-to-body="true" tooltip-is-open="removeLoad" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-ios-close-outline" ng-click="vm.removeLoad($index)"></i></span></div></td></tr><tr><td class="mixing-suggestion-primary"><data-i18n i18n="_m_f_recipe_number_of_loads_">Number of loads</data-i18n></td><td>{{vm.premix.suggestion.loads.length}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/premixes/editPremix/overview.panel.html','<div><div class="suggestion-heading"><h3><data-i18n i18n="_m_f_label_summary_">Summary</data-i18n></h3></div><div class="horizontal-scroll premix-overview-table"><table class="table table-hover"><thead><tr><th ng-if="vm.premix.basis.name"><data i18n="_m_f_premix_selected_basis_">Selected basis</data></th><th><data i18n="_feeds_amount_">Amount DM</data></th><th><data i18n="_feeds_as_fed_">As fed</data></th><th>%&nbsp;<data i18n="_feeds_dm_">DM</data></th><th><data i18n="_m_f_title_total_cost_per_day_">Total cost</data>&nbsp;($)</th><th ng-if="vm.premix.number_of_animals"><data i18n="_m_f_premix_number_of_animals_">N\xB0 of animals</data></th><th><data i18n="_m_f_premix_total_amount_">N\xB0 of animals</data></th></tr></thead><tbody><tr><td style="min-width: 200px" ng-if="vm.premix.basis.name">{{vm.premix.basis.name}}</td><td style="min-width: 110px">{{vm.premix.amount | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</td><td style="min-width: 110px">{{vm.premix.amount_as_fed | formatViewValues: \'as_fed\'}}&nbsp;{{vm.weight}}</td><td style="min-width: 110px">{{vm.premix.dm | formatViewValues: \'percentage\'}}&nbsp;%</td><td style="min-width: 110px">{{vm.premix.total_cost | formatViewValues: \'cost_dm\'}}</td><td style="min-width: 110px" ng-if="vm.premix.number_of_animals">{{vm.premix.number_of_animals | number: 0}}</td><td style="min-width: 110px">{{vm.premix.total_premix_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</td></tr></tbody></table></div><div class="horizontal-scroll premix-overview-table"><table class="table table-hover"><thead><tr><th><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br></th><th><data-i18n i18n="_feeds_type_">Feed type</data-i18n><br></th><th><data-i18n i18n="_feeds_dm_">DM</data-i18n><br>%</th><th><data-i18n i18n="_feeds_amount_">Amount DM</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_cost_dm_">Cost DM</data-i18n><br>{{vm.currency}}/{{vm.weight}}&nbsp; <span><data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th><th><data-i18n i18n="_feeds_cost_as_fed_">Cost as fed</data-i18n><br>{{vm.currency}}/{{vm.weight}}&nbsp; <span><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n></span></th></tr></thead><tbody><tr ng-repeat="feed in vm.premix.feeds"><td style="min-width: 200px">{{feed.name}}</td><td style="min-width: 200px">{{feed.feed_type.translated}}</td><td style="min-width: 110px">{{feed.dm | formatViewValues: \'percentage\'}}</td><td style="min-width: 110px">{{feed.amount | formatViewValues: \'amount\'}}</td><td style="min-width: 110px">{{feed.as_fed | formatViewValues: \'as_fed\'}}</td><td style="min-width: 110px">{{feed.cost | formatViewValues: \'cost_dm\'}}</td><td style="min-width: 110px">{{feed.cost_as_fed | formatViewValues: \'cost_dm\'}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/premixes/editPremix/premixFeeds.table.html','<div ng-if="!vm.loading"><h3 class="with-line"><data i18n="_m_f_premix_info_">Premix info</data></h3><div class="basis-info"><div ng-if="vm.premix.basis.name" class="form-group basis-info-item"><label><data-i18n i18n="_m_f_premix_basis_name_label_">Basis name</data-i18n></label><div>{{(vm.premix.basis.name) || \'-\'}}</div></div><div class="form-group basis-info-item"><label><data-i18n i18n="_feeds_dm_">DM</data-i18n>&nbsp;(%)</label><div><span class="premix-has-warning" ng-class="!vm.premix.dm ? \'premix-display-warning\' : \'premix-disable-warning\'" uib-popover="{{\'_m_f_premix_basis_dm_error_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{(vm.premix.dm | number: 2) || (0 | number: 2)}}&nbsp;<i ng-show="!vm.premix.dm" class="fa fa-info-circle"></i></span></div></div><div class="form-group basis-info-item"><label><data-i18n i18n="_feeds_amount_">Amount</data-i18n>&nbsp;({{vm.weight}})</label><div>{{vm.premix.amount | formatViewValues: \'amount\'}}</div></div><div class="form-group basis-info-item"><label><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n>&nbsp;({{vm.weight}})</label><div>{{vm.premix.amount_as_fed | formatViewValues: \'as_fed\'}}</div></div><div class="form-group basis-info-item"><label><data-i18n i18n="_m_f_recipe_cost_">Cost</data-i18n>&nbsp;({{vm.currency}})</label><div>{{vm.premix.cost | formatViewValues: \'cost_dm\'}}</div></div></div><div style="margin-bottom: 10px" class="horizontal-scroll premix-table premix-validation-container" ng-class="vm.premix.amount > 40 ? \'dmi-error\' : (vm.premix.feeds.length === 0 || vm.newPremixFeedForm.$invalid || vm.showIFields || !vm.premix.dm || vm.hasDM0Error) && vm.selectBasisForm.$submitted ? \'premix-error\' : \'\'"><table class="table premix_table"><thead><tr><th><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br></th><th><data-i18n i18n="_feeds_type_">Feed type</data-i18n><br></th><th><data-i18n i18n="_feeds_dm_">DM</data-i18n><br>%</th><th><data-i18n i18n="_feeds_amount_">Amount DM</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_cost_dm_">Cost DM</data-i18n><br>{{vm.currency}}/{{vm.weight}}&nbsp; <span><data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th><th><data-i18n i18n="_feeds_cost_as_fed_">Cost as fed</data-i18n><br>{{vm.currency}}/{{vm.weight}} <span><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n></span></th><th class="premix-feeds-table-action"><button type="button" class="btn btn-success btn-xs" ng-click="vm.openAddNewFeedForm()" ng-disabled="vm.showIFields || vm.historicalVersion"><i class="fa fa-plus"></i></button></th></tr></thead><tbody dnd-list="vm.premix.feeds" dnd-disable-if="vm.disableDrag || vm.showIFields"><tr ng-repeat="feed in vm.premix.feeds" dnd-disable-if="vm.disableDrag || vm.showIFields" dnd-draggable="feed" dnd-moved="vm.drag($index)"><td style="min-width: 200px"><span editable-text="feed.name" e-required="" e-style="width: 150px" onbeforesave="vm.updateNewFeed($data, $index, \'name\')" e-ng-disabled="vm.historicalVersion">{{feed.name}}</span></td><td style="min-width: 200px"><a href="#" editable-select="feed.feed_type" e-required="" e-style="width: 150px" onshow="loadGroups()" e-ng-disabled="vm.historicalVersion" e-ng-options="feed_type as (feed_type.show_name | i18n) for feed_type in vm.feed_types">{{feed.feed_type.translated}}</a></td><td style="min-width: 110px"><span editable-number="feed.dm" e-required="" e-step="0.01" e-min="0.01" e-max="100" e-style="width: 100px" e-format-input-value="percentage" e-ng-disabled="vm.historicalVersion" onbeforesave="vm.updateNewFeed($data, $index, \'dm\')">{{feed.dm | formatViewValues: \'percentage\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.amount" e-required="" e-step="0.01" e-min="0" e-style="width: 100px" e-format-input-value="amount" e-ng-disabled="vm.historicalVersion" onbeforesave="vm.updateNewFeed($data, $index, \'amount\')">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.as_fed" e-required="" e-step="0.01" e-min="0" e-style="width: 100px" e-format-input-value="as_fed" e-ng-disabled="vm.historicalVersion" onbeforesave="vm.updateNewFeed($data, $index, \'as_fed\')">{{feed.as_fed | formatViewValues: \'as_fed\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.cost" e-step="0.001" e-min="0" e-style="width: 100px" e-ng-disabled="vm.historicalVersion" e-format-input-value="cost_dm" onbeforesave="vm.updateNewFeed($data, $index, \'cost\')">{{feed.cost | formatViewValues: \'cost_dm\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.cost_as_fed" e-step="0.001" e-min="0" e-style="width: 100px" e-format-input-value="cost_dm" e-ng-disabled="vm.historicalVersion" onbeforesave="vm.updateNewFeed($data, $index, \'cost_as_fed\')">{{feed.cost_as_fed | formatViewValues: \'cost_dm\'}}</span></td><td style="min-width: 100px" class="premix-feeds-table-action"><button type="button" class="btn btn-danger btn-xs" ng-click="vm.removeNewFeed(feed)" ng-disabled="vm.historicalVersion"><i class="fa fa-close"></i></button></td></tr><tr class="dndPlaceholder"><td colspan="8"><data-i18n i18n="_m_f_drag_and_drop_placeholder_">Drop here</data-i18n></td></tr><tr ng-form="" name="vm.newPremixFeedForm" ng-if="vm.showIFields" class="premix-feeds-table-manual-row"><td><div class="form-group has-feedback premix-feed-name-column" ng-class="{\'has-error\': vm.newPremixFeedForm.name.$invalid && (vm.newPremixFeedForm.name.$dirty || vm.newPremixFeedForm.$submitted)}"><input type="text" class="form-control" required="" id="name" name="name" ng-model="vm.feedFromApi" uib-typeahead="feed as feed.feed_name for feed in vm.getFeedByName($viewValue)" typeahead-on-select="vm.feedSelected($item)" typeahead-loading="vm.loadingFeedByName" typeahead-append-to-body="true" typeahead-no-results="vm.noResults" ng-keypress="vm.inputKeyPress($event)"> <span class="help-block error-block basic-block"><data-i18n i18n="_toastr_feeds_name_required_">Feed name is required</data-i18n></span></div></td><td><div class="form-group premix-feed-type-column" ng-class="{\'has-error\': vm.newPremixFeedForm.feed_type.$invalid && vm.newPremixFeedForm.$submitted}"><ui-select ng-model="vm.new_feed.feed_type" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" required="" id="feed_type" name="feed_type" ng-change="vm.feedTypeSelected()"><ui-select-match placeholder="{{\'_picker_feed_type_placeholder_\' | i18n}}" uib-tooltip="{{$select.selected.translated}}" tooltip-enable="{{$select.selected.translated.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{$select.selected.translated}}</ui-select-match><ui-select-choices repeat="feed_type in vm.feed_types | filter: $select.search"><span class="shorten-long-text" ng-bind-html="feed_type.translated"></span></ui-select-choices></ui-select></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newPremixFeedForm.dm.$invalid && (vm.newPremixFeedForm.dm.$dirty || vm.newPremixFeedForm.$submitted)}"><input select-on-click="" type="number" class="form-control" required="" id="dm" name="dm" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.new_feed.dm" min="0.01" max="100" step="0.01" ng-change="vm.newFeedDmChanged()" ng-keypress="vm.inputKeyPress($event)"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_label_dm_required_">DM is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newPremixFeedForm.amount.$invalid && (vm.newPremixFeedForm.amount.$dirty || vm.newPremixFeedForm.$submitted)}"><input select-on-click="" type="number" class="form-control" required="" id="amount" name="amount" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.new_feed.amount" format-input-value="amount" default-return-value="null" min="0" ng-change="vm.newFeedAmountDmChanged()" ng-keypress="vm.inputKeyPress($event)"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_amount_dm_required_">Amount DM is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newPremixFeedForm.as_fed.$invalid && (vm.newPremixFeedForm.as_fed.$dirty || vm.newPremixFeedForm.$submitted)}"><input select-on-click="" type="number" class="form-control" required="" id="as_fed" name="as_fed" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.new_feed.as_fed" format-input-value="as_fed" default-return-value="null" min="0" ng-change="vm.newFeedAmountAsFedChanged()" ng-keypress="vm.inputKeyPress($event)"> <span class="help-block error-block basic-block"><data-i18n i18n="_feeds_as_fed_required_">As fed is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newPremixFeedForm.cost.$invalid && (vm.newPremixFeedForm.cost.$dirty || vm.newPremixFeedForm.$submitted)}"><input select-on-click="" type="number" class="form-control" id="cost" name="cost" ng-pattern="/^[0-9]+(\\.[0-9]{1,3})?$/" ng-model="vm.new_feed.cost" format-input-value="cost_dm" default-return-value="null" min="0" ng-change="vm.newFeedCostDmChanged()" ng-keypress="vm.inputKeyPress($event)"></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newPremixFeedForm.cost_as_fed.$invalid && (vm.newPremixFeedForm.cost_as_fed.$dirty || vm.newPremixFeedForm.$submitted)}"><input select-on-click="" type="number" class="form-control" ng-pattern="/^[0-9]+(\\.[0-9]{1,3})?$/" id="cost_as_fed" name="cost_as_fed" ng-model="vm.new_feed.cost_as_fed" format-input-value="cost_dm" default-return-value="null" min="0" ng-change="vm.newFeedCostAsFedChanged()" ng-keypress="vm.inputKeyPress($event)"></div></td><td style="width: 100px" class="premix-feeds-table-action"><button type="submit" ng-disabled="vm.newPremixFeedForm.$invalid || vm.disableAddFeed" class="btn btn-primary btn-xs" ng-click="vm.addNewFeed()"><i class="fa fa-check"></i></button> <button type="button" class="btn btn-danger btn-xs" ng-click="vm.cancelAddNewFeed()"><i class="fa fa-trash"></i></button></td></tr></tbody></table></div><div class="premix-error-text" ng-class="(vm.premix.feeds.length === 0 || vm.newPremixFeedForm.$invalid || vm.showIFields) && vm.selectBasisForm.$submitted ? \'premix-error\' : \'\'"><data-i18n i18n="_m_f_premix_feeds_required_">Feeds are required</data-i18n></div><div class="premix-error-text" ng-class="!vm.premix.dm && vm.selectBasisForm.$submitted ? \'premix-error\' : \'\'"><data-i18n i18n="_m_f_premix_basis_dm_error_">Basis DM is 0. Choose another basis or update the selected one to continue</data-i18n></div><div class="premix-error-text" ng-class="vm.hasDM0Error && vm.selectBasisForm.$submitted ? \'premix-error\' : \'\'"><data-i18n i18n="_m_f_premix_ingredient_dm_error_">Ingredient DM can\'t be 0</data-i18n></div><div class="premix-error-text" ng-class="vm.premix.amount > 40 ? \'dmi-error\' : \'\'"><data-i18n i18n="_m_f_dmi_exceeded_message_" select-on-click="">Daily DMI should not exceed</data-i18n>&nbsp;{{vm.max}}{{vm.weight}}</div></div><div ng-if="vm.loading" style="height: 200px; overflow: hidden" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/premixes/editPremix/versions.table.html','<div class="horizontal-scroll" ng-if="!vm.loading && vm.selectedHerd"><table class="table table-hover my-recipes-table"><thead><tr class="sortable"><th></th><th><data-i18n i18n="_label_used_from_">Used from</data-i18n></th><th><data-i18n i18n="_title_last_modified_date_">Last modified date</data-i18n></th><th><data-i18n i18n="_m_f_pen_feeding_time_">Feeding time</data-i18n></th><th><data-i18n i18n="_m_f_pen_number_of_animals_">Number of animals</data-i18n></th><th><data-i18n i18n="_m_f_premix_total_amount_">Total amount</data-i18n></th></tr></thead><tbody><tr ng-repeat="version in vm.premix.versions"><td><span class="newCheck"><input type="checkbox" id="version_checked{{$index}}-X" ng-true-value="true" ng-false-value="false" ng-click="vm.selectVersion(version)" ng-model="version.is_selected" ng-disabled="version.is_selected" style="margin-right: 2px"> <label for="version_checked{{$index}}-X"></label></span></td><td>{{version.used_from| date: \'medium\'}}</td><td>{{version.create_date| date: \'medium\'}}</td><td>{{version.feeding_time }}</td><td>{{version.number_of_animals}}</td><td>{{version.amount | number: 2}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/premixes/editPremix/wizard.html','<div ng-if="!vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div><ba-wizard id="edit-premix-tabs" ng-show="!vm.loading && vm.selectedHerd && !vm.errorOccured" class="premix-tabs" ng-class="vm.tabValidation()"><ba-wizard-step title="{{vm.step1}}" form="vm.selectVersionForm" class="wizard-step"><div class="row"><div class="col-md-12"><div include-with-scope="app/pages/premixes/editPremix/versions.table.html"></div></div></div></ba-wizard-step><ba-wizard-step title="{{vm.step2}}" form="vm.selectBasisForm" class="wizard-step"><div align="right"><button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.savePremix()"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.selectBasisForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.selectBasisForm.premix_name.$invalid && (vm.selectBasisForm.premix_name.$dirty || vm.selectBasisForm.$submitted)}"><label for="premix_name"><data-i18n i18n="_m_f_premix_name_">Premix name</data-i18n></label> <input select-on-click="" type="text" maxlength="60" class="form-control" id="premix_name" name="premix_name" placeholder="{{\'_m_f_premix_name_\' | i18n}}" ng-model="vm.premix.name" ng-change="vm.premixDirty(\'basis\')" required="" ng-disabled="vm.historicalVersion"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_premix_name_required_">Premix name is required</data-i18n></span></div></div></div><input type="text" required="" ng-show="false" ng-model="vm.premix.dm"> <input type="text" required="" ng-show="false" ng-if="vm.showIFields" ng-model="vm.emptyFeedFormValidator"> <input type="text" required="" ng-show="false" ng-if="vm.premix.selected_basis.value !== 3" ng-model="vm.premix.basis_help_input"> <input type="text" required="" ng-show="false" ng-if="vm.premix.feeds.length === 0 || vm.newPremixFeedForm.$invalid || vm.hasDM0Error || vm.deletedRation" ng-model="vm.newFeedFormValidator"></form><div class="row"><div class="col-md-6"><label style="font-weight: 400; margin-top: 10px"><data i18n="_m_f_premix_select_basis_option_">Select your basis for creating a premix</data>:</label></div></div><div class="row" style="padding-top: 10px"><div class="col-md-6"><div class="form-group"><label><data i18n="_m_f_premix_select_basis_">Select basis</data>:</label><ui-select ng-model="vm.premix.selected_basis" class="btn-group bootstrap-select form-control" ng-disabled="vm.loadingBasis || vm.historicalVersion" append-to-body="true" search-enabled="true" ng-change="vm.basisChanged()"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type in vm.basisTypes | filter: $select.search"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div></div></div><div ng-if="vm.premix.selected_basis.value !== 3"><div class="row"><div class="col-md-12"><div include-with-scope="app/pages/premixes/editPremix/basis.table.html"></div></div></div><div class="row" ng-if="vm.premix.basis_selected"><div class="col-md-12"><div include-with-scope="app/pages/premixes/editPremix/premixFeeds.table.html"></div></div></div></div><div ng-if="vm.premix.selected_basis.value === 3" class="row"><div class="col-md-12"><div include-with-scope="app/pages/premixes/editPremix/premixFeeds.table.html"></div></div></div></ba-wizard-step><ba-wizard-step title="{{vm.step3}}" form="vm.planningForm" class="wizard-step"><div align="right"><button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.savePremix()"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.planningForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group"><label><data i18n="_m_f_premix_choose_amount_">Choose how premix amount is calculated</data>:</label><ui-select ng-model="vm.premix.selected_amount_option" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-change="vm.amountOptionChanged()" ng-disabled="vm.historicalVersion"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type in vm.amountOptions | filter: $select.search"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-if="vm.premix.selected_amount_option.value === 0" ng-class="{\'has-error\': vm.planningForm.number_of_animals.$invalid && (vm.planningForm.number_of_animals.$dirty || vm.planningForm.$submitted)}"><label for="number_of_animals"><data-i18n i18n="_groups_no_animals_">Number of animals</data-i18n>&nbsp;(<data i18n="_m_f_premix_total_amount_">Total amount</data>:&nbsp;{{vm.premix.total_premix_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}})</label> <input select-on-click="" type="number" min="1" max="99999" step="1" pattern="^\\d*(\\.\\d{0})?$" class="form-control" id="number_of_animals" name="number_of_animals" placeholder="{{\'_groups_no_animals_\' | i18n}}" ng-model="vm.premix.number_of_animals" ng-change="vm.calculateTotalAmount()" required="" ng-disabled="vm.historicalVersion"> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_no_animals_required_">Number of animals is required</data-i18n></span></div><div class="form-group has-feedback" ng-if="vm.premix.selected_amount_option.value === 1" ng-class="{\'has-error\': vm.planningForm.total_amount.$invalid && (vm.planningForm.total_amount.$dirty || vm.planningForm.$submitted)}"><label for="total_amount"><data i18n="_m_f_premix_total_amount_">Total amount</data>:&nbsp;{{vm.premix.total_premix_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</label> <input select-on-click="" type="number" min="1" max="99999" step="1" pattern="^\\d*(\\.\\d{0})?$" class="form-control" id="total_amount" name="total_amount" placeholder="{{\'_m_f_premix_total_amount_\' | i18n}}" ng-model="vm.premix.total_amount" format-input-value="rounded_amount" ng-change="vm.calculateTotalAmount()" required="" ng-disabled="vm.historicalVersion"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_premix_total_amount_required_">Total amount is required</data-i18n></span></div><div class="premix-wagon-container"><label><data-i18n i18n="_m_f_premix_choose_mixer_wagon_">Choose your mixer wagons</data-i18n>:</label><div><button class="btn btn-sm btn-primary" ng-click="vm.openAddWagonModal($event)" ng-disabled="vm.historicalVersion"><data-i18n i18n="_m_f_recipe_add_wagon_">Add wagon</data-i18n></button></div><div class="premix-wagon-inner premix-validation-container" ng-class="!vm.premix.wagon_help_input && vm.planningForm.$submitted ? \'premix-error\' : \'\'"><table class="premix-wagon-table" ng-if="!vm.loadingMixerWagons"><thead><tr ng-if="vm.premix.wagons.length > 0"><th colspan="2"><data i18n="_m_f_premix_select_mixer_wagon_">Select wagon</data></th><th><data i18n="_label_name_">Name</data></th><th><data i18n="_m_f_wagons_capacity_">Capacity</data></th><th><data i18n="_m_f_premix_choose_default_mixer_wagon_">Choose default mixer wagon</data>:</th></tr><span class="warningModal" ng-if="vm.premix.wagons.length === 0"><data-i18n i18n="_m_f_premix_wagon_not_available_">Mixer wagon not availabe</data-i18n></span></thead><tbody lazy-img-container="" ng-if="vm.premix.wagons.length > 0"><tr ng-repeat="wagon in vm.premix.wagons"><td><span class="newCheck"><input type="checkbox" id="wagon_checked_{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="wagon.selected" ng-change="vm.wagonSelected(wagon)" ng-disabled="vm.historicalVersion"> <label for="wagon_checked_{{$index}}"></label></span></td><td><span class="select-wagon-img"><img src="assets/img/MmmLogo.png" lazy-img="{{wagon.image_url}}" lazy-img-error="assets/img/MmmLogo.png" ng-if="wagon.image_url"> <img src="assets/img/MmmLogo.png" ng-if="!wagon.image_url"></span></td><td class="shorten-long-text"><span class="wagon-name" uib-tooltip="{{wagon.name}}" tooltip-enable="{{wagon.name.length > 15 ? true : false}}" tooltip-is-open="wagonNameOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-hide-overflow" tooltip-popup-delay="500" ng-class="wagon.deleted ? \'deleted-wagon\' : \'\'">{{wagon.name}}</span></td><td><span class="wagon-name" ng-class="wagon.deleted ? \'deleted-wagon\' : \'\'">{{wagon.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</span></td><td><span ng-if="wagon.selected" class="newCheck"><input class="wagon-name" type="checkbox" id="default_checked_{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="wagon.default" ng-disabled="wagon.default || vm.historicalVersion" ng-change="vm.defaultSelected(wagon)" ng-class="wagon.deleted ? \'deleted-wagon\' : \'\'"> <label for="default_checked_{{$index}}"></label></span></td></tr></tbody></table></div></div><div class="premix-error-text" ng-class="!vm.premix.wagon_help_input && vm.planningForm.$submitted ? \'premix-error\' : \'\'"><span class="warningModal"><data-i18n i18n="_m_f_feeding_mixer_wagon_required_">Mixer wagon is required</data-i18n></span></div><div ng-if="vm.loadingMixerWagons" style="overflow: hidden"><div style="text-align: center"><div id="loading-animation-large"></div></div></div><input required="" type="text" ng-show="false" ng-model="vm.premix.wagon_help_input"></div><div class="col-md-6"><div class="row"><div class="col-md-6 form-group has-feedback premix-feeding-date" ng-class="{\'has-error\': vm.planningForm.start_feeding_date.$invalid && (vm.planningForm.start_feeding_date.$dirty || vm.planningForm.$submitted)}"><label for="start_feeding_date"><data i18n="_m_f_premix_select_start_feeding_date_">Select start feeding date</data>: ({{vm.premix.start_from | date:\'shortDate\'}})</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" placeholder="{{vm.date_format}}" ng-model="vm.premix.start_feeding_date" is-open="datePickerOpened1" required="" datepicker-append-to-body="true" close-text="Close" show-button-bar="false" id="start_feeding_date" name="start_feeding_date" popup-placement="bottom-right" ng-change="vm.calculateTotalPremixAmount()" ng-disabled="vm.historicalVersion"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="datePickerOpened1 = !datePickerOpened1" ng-disabled="vm.historicalVersion"><i class="glyphicon glyphicon-calendar"></i></button></span></p><span class="premix-error-text" ng-class="{\'premix-error\': vm.planningForm.start_feeding_date.$invalid && (vm.planningForm.start_feeding_date.$dirty || vm.planningForm.$submitted)}"><data-i18n i18n="_date_format_validation_label_">date required</data-i18n>&nbsp;{{vm.date_format}}</span></div><div class="col-md-6 form-group has-feedback premix-time-picker" ng-class="{\'has-error\': vm.planningForm.premix_feeding_time.$invalid && (vm.planningForm.premix_feeding_time.$dirty || vm.planningForm.$submitted)}"><label for="premix_feeding_time"><data-i18n i18n="_m_f_feeding_period_label_">Feeding period</data-i18n>:&nbsp;{{vm.premix.feeding_period.name}}</label><div class="input-group"><input type="text" class="form-control" id="premix_feeding_time" name="premix_feeding_time" ng-model="vm.premix.ft" ng-change="vm.timeChanged()" required="" placeholder="--:-- --" ng-model-options="{allowInvalid: true, updateOn: \'blur\'}" ng-disabled="vm.historicalVersion"> <span class="input-group-btn"><button type="button" class="btn btn-default" moment-picker="vm.premix.ft" ng-model="vm.premix.feeding_time" change="vm.timeChanged()" format="hh:mm A" locale="{{vm.locale}}" ng-model-options="{ updateOn: \'blur\' }" ng-disabled="vm.historicalVersion"><i class="glyphicon glyphicon-time"></i></button></span></div><span class="premix-error-text" ng-class="{\'premix-error\': vm.planningForm.premix_feeding_time.$invalid && (vm.planningForm.premix_feeding_time.$dirty || vm.planningForm.$submitted)}"><data-i18n i18n="_m_f_premix_feeding_time_required_">Feeding time is not set properly</data-i18n></span></div></div><div class="form-group"><label><data i18n="_m_f_premix_select_repeat_interval_">Select repeat interval</data>:</label><ui-select ng-model="vm.premix.selected_interval" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-change="vm.calculateTotalPremixAmount()" ng-disabled="vm.historicalVersion"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type in vm.intervalOptions | filter: $select.search"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div><div ng-if="vm.premix.selected_interval.value === 4" style="padding-bottom: 10px"><div class="weekDays-selector checkbox-inline" ng-repeat="day in vm.premix.custom_days"><input type="checkbox" ng-click="vm.daySelected()" ng-model="day.selected" id="custom_frequency_{{$index}}" ng-disabled="vm.historicalVersion"> <label for="custom_frequency_{{$index}}">{{day.name}}</label></div><div ng-if="!vm.premix.custom_days_validation && vm.planningForm.$submitted"><span class="warningModal"><data-i18n i18n="_m_f_pen_frequency_of_feeding_required_">frequency of feeding is required</data-i18n></span></div><input required="" type="text" ng-show="false" ng-model="vm.premix.custom_days_validation" ng-disabled="vm.historicalVersion"></div><div ng-if="vm.premix.selected_interval.value !== 5" class="form-group has-feedback" ng-class="{\'has-error\': vm.planningForm.repeat_interval.$invalid && (vm.planningForm.repeat_interval.$dirty || vm.planningForm.$submitted)}"><label for="repeat_interval"><data-i18n i18n="_m_f_premix_repeat_interval_">Repeat interval</data-i18n></label> <input select-on-click="" type="number" step="1" min="1" class="form-control" id="repeat_interval" name="repeat_interval" placeholder="{{\'_m_f_premix_repeat_interval_\' | i18n}}" ng-model="vm.premix.repeat_interval" ng-change="vm.calculateTotalPremixAmount()" required="" ng-disabled="vm.historicalVersion"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_premix_repeat_interval_required_">Repeat interval is required</data-i18n></span></div></div></div></form></ba-wizard-step><ba-wizard-step title="{{vm.step4}}" form="vm.managementForm" class="wizard-step"><div align="right"><button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.savePremix()"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.managementForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.managementForm.premix_name_m.$invalid && (vm.managementForm.premix_name_m.$dirty || vm.managementForm.$submitted)}"><label for="premix_name_m"><data-i18n i18n="_m_f_premix_name_">Premix name</data-i18n></label> <input select-on-click="" type="text" class="form-control" id="premix_name_m" name="premix_name_m" placeholder="{{\'_m_f_premix_name_\' | i18n}}" ng-model="vm.premix.name" ng-change="vm.premixDirty(\'drop\')" required="" ng-disabled="vm.historicalVersion"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_premix_name_required_">Premix name is required</data-i18n></span></div></div></div><input type="text" required="" ng-show="false" ng-model="vm.premix.suggestion_help_input"></form><div class="row"><div class="col-md-12"><div include-with-scope="app/pages/premixes/editPremix/overview.panel.html"></div></div><div class="col-md-12"><div include-with-scope="app/pages/premixes/editPremix/load_suggestion.table.html"></div></div></div></ba-wizard-step><ba-wizard-step title="{{vm.step5}}" class="wizard-step"><form class="form-horizontal" name="vm.finishForm" novalidate=""><div style="font-size: 16px"><data-i18n i18n="_m_f_add_new_premix_finish_message_">You have successfully defined a new premix. Do you want to save your work?</data-i18n></div></form><div style="margin-top: 10px" align="right"><button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.savePremix()"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_"></data-i18n></button></div></ba-wizard-step></ba-wizard><div ng-if="vm.loading" align="center" style="overflow: hidden"><div><div id="loading-animation-large"></div></div></div><div ng-if="vm.errorOccured" style="font-weight: bold"><span class="warningModal"><data-i18n i18n="_m_f_recipe_ration_missing_error_">The data corrupted. Can\'t open recipe.</data-i18n></span></div>');
$templateCache.put('app/pages/rations/addManualRation/addManualRation.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/addManualRation/addManualRation.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/addManualRation/addManualRation.panel.html','<div ng-if="vm.selectedTeam && vm.selectedHerd"><div ng-if="!vm.loading"><h3 class="with-line"><data-i18n i18n="_ration_informations_label_">Ration informations</data-i18n></h3><form name="vm.rationInfo"><div class="row"><div class="col-md-3"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.rationInfo.ration_name.$invalid && (vm.rationInfo.ration_name.$dirty || vm.rationInfo.$submitted)}"><label for="ration_name"><data-i18n i18n="_rations_ration_name_">ration name</data-i18n></label> <input select-on-click="" type="text" maxlength="60" class="form-control" id="ration_name" name="ration_name" placeholder="{{\'_rations_ration_name_\' | i18n}}" ng-model="vm.ration.ration_name" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_rations_ration_name_required_">ration name is required</data-i18n></span></div></div></div><div class="basis-info"><div class="form-group basis-info-item manual-ration-basis-info-item"><label><data-i18n i18n="_m_f_recipe_total_kg_dm_">Total kg DM</data-i18n>&nbsp;({{vm.weight}})</label><div><span>{{vm.ration.amount_dm | formatViewValues: \'amount\' | defaultReturnValue: \'-\'}}</span>&nbsp;<span ng-if="vm.ration.amount_dm">{{vm.weight}}</span></div></div><div class="form-group basis-info-item manual-ration-basis-info-item"><label><data-i18n i18n="_m_f_recipe_total_kg_as_fed_">Total kg DM</data-i18n>&nbsp;({{vm.weight}})</label><div><span>{{vm.ration.amount_as_fed | formatViewValues: \'amount\' | defaultReturnValue: \'-\'}}</span>&nbsp;<span ng-if="vm.ration.amount_as_fed">{{vm.weight}}</span></div></div><div class="form-group basis-info-item manual-ration-basis-info-item"><label><data-i18n i18n="_feeds_dm_">dm</data-i18n>&nbsp;(%)</label><div><span>{{vm.ration.dm | formatViewValues: \'percentage\' | defaultReturnValue: \'-\'}}</span>&nbsp;<span ng-if="vm.ration.dm">%</span></div></div><div class="form-group basis-info-item manual-ration-basis-info-item"><label><data-i18n i18n="_m_f_total_ration_cost_">Total ration cost</data-i18n>&nbsp;({{vm.currency}})</label><div><span>{{vm.ration.cost_dm | formatViewValues: \'cost_dm\' | defaultReturnValue: \'-\'}}</span>&nbsp;<span ng-if="vm.ration.cost_dm != null">{{vm.currency}}</span></div></div></div></form><div class="feeds-line-separator"><h3><data-i18n i18n="_menu_feeds_">Feeds</data-i18n></h3><span><button type="button" class="btn btn-primary btn-xs" ng-click="vm.openFeedsModal()"><i class="fa fa-plus"></i></button></span></div><hr><div class="horizontal-scroll manual-ration-table" ng-class="vm.ration.amount_dm > vm.maxAmount ? \'has-warning\' : \'\'"><table class="table rations_table"><thead><tr><th><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br></th><th><data-i18n i18n="_feeds_type_">Feed type</data-i18n><br></th><th><data-i18n i18n="_feeds_dm_">dm</data-i18n><br>%&nbsp;</th><th><data-i18n i18n="_feeds_amount_">Amount DM</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_cost_dm_">Cost DM</data-i18n><br>{{vm.currency}}/{{vm.weight}}<span>&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th><th><data-i18n i18n="_feeds_cost_as_fed_">Cost as fed</data-i18n><br>{{vm.currency}}/{{vm.weight}}<span>&nbsp;<data-i18n i18n="_feeds_as_fed_">as fed</data-i18n></span></th><th></th></tr></thead><tbody ui-sortable="{ \'ui-floating\': true, \'disabled\': vm.ration.ration_feeds.length < 2, axis: \'y\', placeholder: \'drop-zone\' }" ng-model="vm.ration.ration_feeds" ng-class="vm.ration.ration_feeds.length >= 2 ? \'manual-ration-table-sortable\' : \'\'"><tr ng-repeat="feed in vm.ration.ration_feeds" ng-if="vm.ration.ration_feeds.length"><td style="min-width: 200px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span editable-text="feed.feed_name" e-required="" e-maxlength="60" e-style="width: 150px" id="feed_name_{{$index}}" e-ng-keydown="vm.inputKeyPress($event)">{{feed.feed_name}}</span></td><td style="min-width: 200px"><a href="#" editable-select="feed.feed_type" e-required="" e-style="width: 150px" e-ng-options="feed_type as feed_type.translated for feed_type in vm.feedTypes">{{feed.feed_type.translated}}</a></td><td style="min-width: 110px"><span editable-number="feed.dm" e-format-input-value="percentage" e-required="" e-step="0.01" e-min="0.01" e-max="100" e-style="width: 100px" onaftersave="vm.updateFeed(feed, $data, \'dm\')" id="dm_{{$index}}" e-ng-keydown="vm.inputKeyPress($event)">{{feed.dm | formatViewValues: \'percentage\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.amount_dm" e-format-input-value="amount" e-required="" e-step="0.01" e-min="0" e-style="width: 100px" onaftersave="vm.updateFeed(feed, $data, \'amount_dm\')" id="amount_dm_{{$index}}" e-ng-keydown="vm.inputKeyPress($event)">{{feed.amount_dm | formatViewValues: \'amount\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.amount_as_fed" e-format-input-value="as_fed" e-required="" e-step="0.01" e-min="0" e-style="width: 100px" onaftersave="vm.updateFeed(feed, $data, \'amount_as_fed\')" id="amount_as_fed_{{$index}}" e-ng-keydown="vm.inputKeyPress($event)">{{feed.amount_as_fed | formatViewValues: \'as_fed\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.cost_dm" e-format-input-value="cost_dm" e-step="0.001" e-min="0" e-style="width: 100px" onaftersave="vm.updateFeed(feed, $data, \'cost_dm\')" id="cost_dm_{{$index}}" e-ng-keydown="vm.inputKeyPress($event)">{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.cost_as_fed" e-format-input-value="cost_dm" e-step="0.001" e-min="0" e-style="width: 100px" onaftersave="vm.updateFeed(feed, $data, \'cost_as_fed\')" id="cost_as_fed_{{$index}}" e-ng-keydown="vm.inputKeyPress($event)">{{feed.cost_as_fed | formatViewValues: \'cost_dm\'}}</span></td><td style="min-width: 100px" class="manual-feeds-table-action"><button type="button" class="btn btn-danger btn-xs" ng-click="vm.removeFeed(feed)"><i class="fa fa-trash"></i></button></td></tr><tr ng-form="" name="vm.newManualRationForm" class="manual-feeds-table-row"><td ng-if="false"></td><td><div class="form-group has-feedback manual-feed-name-column" ng-class="{\'has-error\': vm.newManualRationForm.feed_name.$invalid && (vm.newManualRationForm.feed_name.$dirty || vm.newManualRationForm.$submitted)}"><input type="text" ng-model="vm.feedFromApi" uib-typeahead="feed as feed.feed_name for feed in vm.getFeedByName($viewValue)" typeahead-on-select="vm.feedSelected($item)" typeahead-loading="vm.loadingFeedByName" typeahead-append-to-body="true" typeahead-no-results="vm.noResults" class="form-control" id="feed_name" name="feed_name" required=""><div class="manual-feed-name-search-icons"><span ng-show="vm.loadingFeedByName"><i class="fa fa-spinner"></i><data-i18n i18n="_title_loading_">Loading...</data-i18n></span> <span ng-show="vm.noResults"><i class="fa fa-times text-danger"></i> No Results Found</span></div><span class="help-block error-block basic-block"><data-i18n i18n="_toastr_feeds_name_required_">Feed name is required</data-i18n></span></div></td><td><div class="form-group manual-feed-type-column" ng-class="{\'has-error\': vm.newManualRationForm.feed_type.$invalid && vm.newManualRationForm.$submitted}"><ui-select ng-model="vm.newFeed.feed_type" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" required="" id="feed_type" name="feed_type" ng-change="vm.feedTypeSelected()"><ui-select-match placeholder="{{\'_picker_feed_type_placeholder_\'|i18n}}" uib-tooltip="{{$select.selected.translated}}" tooltip-enable="{{$select.selected.translated.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{$select.selected.translated}}</ui-select-match><ui-select-choices repeat="feedType in vm.feedTypes | filter: $select.search"><span class="shorten-long-text" ng-bind-html="feedType.translated"></span></ui-select-choices></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_toastr_feeds_type_required_">Feed type is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newManualRationForm.dm.$invalid && (vm.newManualRationForm.dm.$dirty || vm.newManualRationForm.$submitted)}"><input select-on-click="" type="number" class="form-control" required="" id="dm" name="dm" ng-pattern="/^([0-9]?)+(\\.[0-9]{1,2})?$/" ng-model="vm.newFeed.dm" format-input-value="percentage" default-return-value="null" min="0.01" max="100" step="0.01" ng-change="vm.updateNewFeed(\'dm\')"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_label_dm_required_">DM is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newManualRationForm.amount_dm.$invalid && (vm.newManualRationForm.amount_dm.$dirty || vm.newManualRationForm.$submitted)}"><input select-on-click="" type="number" class="form-control" required="" id="amount_dm" name="amount_dm" ng-pattern="/^([0-9]?)+(\\.[0-9]{1,2})?$/" ng-model="vm.newFeed.amount_dm" format-input-value="amount" default-return-value="null" min="0" step="0.01" ng-change="vm.updateNewFeed(\'amount_dm\')"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_amount_dm_required_">Amount DM is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newManualRationForm.amount_as_fed.$invalid && (vm.newManualRationForm.amount_as_fed.$dirty || vm.newManualRationForm.$submitted)}"><input select-on-click="" type="number" class="form-control" required="" id="amount_as_fed" name="amount_as_fed" ng-pattern="/^([0-9]?)+(\\.[0-9]{1,2})?$/" ng-model="vm.newFeed.amount_as_fed" format-input-value="as_fed" default-return-value="null" min="0" step="0.01" ng-change="vm.updateNewFeed(\'amount_as_fed\')"> <span class="help-block error-block basic-block"><data-i18n i18n="_feeds_as_fed_required_">As fed is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newManualRationForm.cost_dm.$invalid && (vm.newManualRationForm.cost_dm.$dirty || vm.newManualRationForm.$submitted)}"><input select-on-click="" type="number" class="form-control" id="cost_dm" name="cost_dm" ng-pattern="/^([0-9]?)+(\\.[0-9]{1,3})?$/" ng-model="vm.newFeed.cost_dm" format-input-value="cost_dm" default-return-value="null" min="0" step="0.01" ng-change="vm.updateNewFeed(\'cost_dm\')"></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newManualRationForm.cost_as_fed.$invalid && (vm.newManualRationForm.cost_as_fed.$dirty || vm.newManualRationForm.$submitted)}"><input select-on-click="" type="number" class="form-control" ng-pattern="/^([0-9]?)+(\\.[0-9]{1,3})?$/" id="cost_as_fed" name="cost_as_fed" ng-model="vm.newFeed.cost_as_fed" format-input-value="cost_dm" default-return-value="null" min="0" step="0.01" ng-change="vm.updateNewFeed(\'cost_as_fed\')"></div></td><td style="width: 100px" class="manual-feeds-table-action"><button type="button" ng-disabled="vm.disableAddFeed" class="btn btn-primary btn-xs" ng-click="vm.addNewFeed()"><i class="fa fa-check"></i></button></td></tr></tbody></table></div><div ng-if="vm.ration.amount_dm > vm.maxAmount" class="manual-raton-warning-message"><data-i18n i18n="_m_f_dmi_exceeded_message_">Daily DMI should not exceed</data-i18n>&nbsp;{{vm.maxAmount | formatViewValues: \'amount\'}}{{vm.weight}}</div><div align="right"><button type="button" class="btn btn-success" ng-click="vm.saveRation()" ng-disabled="vm.rationInfo.$invalid || !vm.ration.ration_feeds.length"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div></div><loading-spinner-large ng-if="vm.loading"></loading-spinner-large></div><div ng-if="!vm.selectedTeam" align="center"><div><h3><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></h3></div></div><div ng-if="!vm.selectedHerd && vm.selectedTeam" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div>');
$templateCache.put('app/pages/rations/addManualRation/insertFeed.modal.html','<div ba-panel="" class="ng-cloak" ng-if="!vm.modalLoading"><div class="panel-group"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="btn-group"><button type="button" class="btn btn-primary no-border-radius" ng-click="vm.addAll()"><data-i18n i18n="_btn_feed_add_all_">Add all</data-i18n></button> <button type="button" class="btn btn-danger no-border-radius" ng-click="vm.closeModal()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><div ba-panel="" ba-panel-title="{{\'_feeds_imort_feeds_panel_available_feeds_\'|i18n}}" ba-panel-class="with-scroll xmedium-panel"><div include-with-scope="app/pages/rations/addManualRation/insertFeed.sourceTable.html"></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="btn-group"><button type="button" class="btn btn-primary no-border-radius" ng-click="vm.insertFeeds()"><data-i18n i18n="_btn_feed_insert_">insert</data-i18n></button> <button type="button" class="btn btn-danger no-border-radius" ng-click="vm.removeAll()"><data-i18n i18n="_btn_feed_remove_all_">Remove all</data-i18n></button></div><div ba-panel="" ba-panel-title="{{\'_feeds_insert_feeds_panel_feeds_insert_\'|i18n}}" ba-panel-class="with-scroll xmedium-panel"><div include-with-scope="app/pages/rations/addManualRation/insertFeed.table.html"></div></div></div></div></div></div><loading-spinner-large ng-if="vm.modalLoading"></loading-spinner-large>');
$templateCache.put('app/pages/rations/addManualRation/insertFeed.sourceTable.html','<div class="vertical-scroll add-manual-feed-to-ration-table-wrapper"><table class="table"><thead><tr><th></th><th><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br><br></th><th><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></th><th><data-i18n i18n="_feeds_amount_">Amount</data-i18n><br><span>{{vm.weight}}</span></th><th><data-i18n i18n="_feeds_cost_dm_">Cost dm</data-i18n><br><span>{{vm.currency}}/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds" ng-click="vm.addSelected(feed)" ng-show="feed.displayed"><td><button type="button" class="btn btn-primary btn-xs"><i class="ion-plus-round"></i></button></td><td>{{feed.feed_name}}</td><td>{{feed.dm | formatViewValues: \'percentage\'}}</td><td>{{feed.amount_dm | formatViewValues: \'amount\'}}</td><td>{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</td></tr><tr ng-hide="vm.hideLoadMoreButton"><td colspan="5"><button class="btn btn-md btn-primary load-more-manual-feeds-btn" ng-click="vm.loadMoreFeeds()" ng-disabled="vm.loadingFeeds" ng-class="vm.loadingFeeds ? \'disabled-background\' : \'\'"><span ng-show="!vm.loadingFeeds"><data-i18n i18n="_m_f_title_load_more_">Load more</data-i18n></span><loading-spinner ng-show="vm.loadingFeeds"></loading-spinner></button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/addManualRation/insertFeed.table.html','<div class="vertical-scroll add-manual-feed-to-ration-table-wrapper"><table class="table"><thead><tr><th></th><th><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br><br></th><th><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span></th><th><data-i18n i18n="_feeds_amount_">Amount</data-i18n><br><span>{{vm.weight}}</span></th><th><data-i18n i18n="_feeds_cost_dm_">Cost dm</data-i18n><br><span>{{vm.currency}}/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th></tr></thead><tbody><tr ng-click="vm.removeSelected(feed)" ng-repeat="feed in vm.importList track by feed.id"><td><button type="button" class="btn btn-danger btn-xs"><i class="ion-minus-round"></i></button></td><td>{{feed.feed_name}}</td><td>{{feed.dm | formatViewValues: \'percentage\'}}</td><td>{{feed.amount_dm | formatViewValues: \'amount\'}}</td><td>{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/premixes/myPremixes/confirmationDialog.modal.html','<div class="modal-content" ng-if="!vm.modalLoading"><div class="modal-header"><div align="center"><span class="ion-android-warning warningModal" style="font-size: 36px"></span></div><div align="center"><span class="warningModal">{{vm.warningMessage | i18n}}</span></div></div><div class="modal-body"><div align="center"><button type="button" class="btn btn-primary" ng-click="vm.confirm()"><data-i18n i18n="_btn_continue_">Continue</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div><div class="modal-content" ng-if="vm.modalLoading"><div class="modal-body"><div style="height: 200px; overflow: hidden" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/premixes/myPremixes/feedingDatepicker.modal.html','<div class="modal-content" ng-if="!vm.modalLoading"><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><form name="vm.datePickerForm"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.datePickerForm.feedingDate.$invalid && (vm.datePickerForm.feedingDate.$dirty || vm.datePickerForm.$submitted)}"><label><data-i18n i18n="_m_f_premix_choose_feeding_time_">When do you want to start feeding this premix?</data-i18n></label><p class="input-group feeding-datepicker"><input type="text" class="form-control" uib-datepicker-popup="{{vm.date_format}}" placeholder="{{vm.date_format}}" datepicker-options="vm.options" ng-model="vm.startDate" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" name="feedingDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p><span class="help-block error-block basic-block warningModal"><data-i18n i18n="_date_format_validation_label_">Date should have this format:</data-i18n>&nbsp;{{vm.date_format}}</span></div><div style="height: 20px; margin-top: 10px"><button style="float: right" class="btn btn-xs btn-success" ng-disabled="vm.datePickerForm.$invalid" ng-click="vm.confirm()"><data-i18n i18n="_btn_save_">save</data-i18n></button></div></form></div></div><div class="modal-content" ng-if="vm.modalLoading"><div class="modal-body"><div style="height: 200px; overflow: hidden" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/premixes/myPremixes/myPremixes.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/premixes/myPremixes/myPremixes.table.html"></div></div></div></div></div>');
$templateCache.put('app/pages/premixes/myPremixes/myPremixes.table.html','<div class="row save-premix-order-btn" ng-if="!vm.loading && vm.selectedHerd"><button class="btn btn-info" ng-disabled="!vm.reordered" ng-click="vm.saveNewOrder()"><data-i18n i18n="_m_f_btn_update_order_">update</data-i18n></button></div><div class="horizontal-scroll" ng-if="!vm.loading && vm.selectedHerd"><table class="table table-hover my-premixes-table"><thead><tr class="sortable"><th><data-i18n i18n="_m_f_premix_order_">Premix order</data-i18n><br></th><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br></th><th><data-i18n i18n="_m_f_premix_name_">Premix name</data-i18n><br></th><th><data-i18n i18n="_m_f_premix_cost_label_">Cost per animal</data-i18n><br>{{vm.currency}}</th><th><data-i18n i18n="_title_create_date">create date</data-i18n><br></th><th><data-i18n i18n="_m_f_recipe_feeding_from_">feeding from</data-i18n><br></th><th></th></tr></thead><tbody dnd-list="vm.premixes" dnd-disable-if="vm.disableDrag || vm.disableReorder"><tr ng-repeat="premix in vm.premixes" dnd-disable-if="vm.disableDrag || vm.disableReorder" dnd-draggable="premix" dnd-moved="vm.drag($index)"><td><a class="ion-arrow-up-a icon-edit" ng-class="$index == 0 ? \'hidden\' : \'\'" ng-click="vm.move(premix, \'up\')"></a> <a class="ion-arrow-down-a icon-edit" ng-class="$index == vm.premixes.length - 1 ? \'hidden\' : \'\'" ng-click="vm.move(premix, \'down\')"></a></td><td><button type="button" class="btn btn-primary btn-xs" ng-click="vm.editPremix(premix)" uib-tooltip="{{\'_tips_edit_\' | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-edit"></i></button> <a class="icon-edit green-icon" href="" id="setPremixAsDef" ng-click="vm.changePremixActive(premix)" ng-class="premix.active ? \'ion-star\' : \'ion-ios-star-outline\'"></a></td><td class="shorten-long-text" uib-tooltip="{{premix.name}}" tooltip-enable="{{premix.name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{premix.name}}</td><td>{{premix.cost | number:2}}</td><td>{{premix.create_date | date:\'short\'}}</td><td>{{premix.start_from | date:\'short\'}}</td><td><button class="btn btn-xs btn-danger" ng-click="vm.deletePremix(premix)"><data-i18n i18n="_btn_delete_">Delete</data-i18n></button></td></tr><tr class="dndPlaceholder"><td colspan="8"><data-i18n i18n="_m_f_drag_and_drop_placeholder_">Drop here</data-i18n></td></tr><tr ng-if="vm.loadingRecipes"><td colspan="7"><div><div id="loading-animation"></div></div></td></tr></tbody><tfoot><tr><td colspan="7" style="text-align: center"><button class="btn btn-primary" ng-if="vm.totalItems > vm.premixes.length" ng-click="vm.paginationChanged()"><data-i18n i18n="_m_f_title_load_more_">Load more</data-i18n></button></td></tr></tfoot></table></div><div ng-if="!vm.loading && !vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div><loading-spinner-large ng-if="vm.loading"></loading-spinner-large>');
$templateCache.put('app/pages/rations/addNewRation/addNewRation.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll horizontal-scrol"><ba-wizard ng-if="!vm.loading && vm.selectedTeam && vm.selectedHerd" class="ration-validation" ng-class="vm.tabValidation()"><ba-wizard-step title="{{\'_rations_add_new_ration_step1_title_\'|i18n}}" form="vm.basicInfoForm"><form name="vm.basicInfoForm" novalidate=""><div class="row"><div class="col-xlg-4 col-lg-4 col-md-4 col-sm-4 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicInfoForm.name.$invalid && (vm.basicInfoForm.name.$dirty || vm.basicInfoForm.$submitted)}"><label for="name"><data-i18n i18n="_rations_ration_name_">ration name</data-i18n></label> <input type="text" class="form-control" id="name" name="name" placeholder="{{\'_rations_ration_name_\' | i18n}}" ng-model="vm.ration.ration_name" required="" maxlength="60"> <span class="help-block error-block basic-block"><data-i18n i18n="_rations_ration_name_required_">ration name is required</data-i18n></span></div></div><div class="col-xlg-4 col-lg-4 col-md-4 col-sm-4 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicInfoForm.group.$invalid && vm.basicInfoForm.$submitted }"><label><data-i18n i18n="_rations_add_new_ration_pickers_title_">Select group to create ration</data-i18n></label><ui-select ng-if="vm.groups.length > 0 && !vm.loading" ng-model="vm.selectedGroup" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.selected(\'group\')" id="group" name="group" required=""><ui-select-match placeholder="{{\'_picker_group_placeholder_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="group in vm.groups | filter: $select.search"><span ng-bind-html="group.name"></span></ui-select-choices></ui-select><ui-select ng-if="vm.groups.length == 0 && !vm.loading" ng-model="vm.selectedGroup" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.selected(\'group\')" id="group" name="group" required=""><ui-select-match placeholder="{{\'_picker_group_placeholder_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="nogroup in vm.groupList | filter: $select.search" ng-click="vm.redirect(\'groups.addNewGroup\')"><span ng-bind-html="nogroup.name"></span></ui-select-choices></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_groups_group_required_">group is required</data-i18n></span></div></div><div class="col-xlg-4 col-lg-4 col-md-4 col-sm-4 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicInfoForm.calc.$invalid && vm.basicInfoForm.$submitted}"><label><data-i18n i18n="_settings_calculation_type_title_">Select group to create ration</data-i18n></label><ui-select ng-model="vm.selectedCalculation" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.defaultCalculationChanged()" id="calc" name="calc" required=""><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.defaultCalculationList | filter: $select.search" ui-disable-choice="vm.selectedCalculation.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div></form></ba-wizard-step><ba-wizard-step title="{{\'_rations_add_new_ration_step2_title_\'|i18n}}" form="vm.animalInfoForm"><form name="vm.animalInfoForm" novalidate=""><input type="text" required="" ng-show="false" ng-model="vm.rations_suggestion_help_input"><div class="panel-group"><div class="row"><div class="btn-group-example" style="padding-left: 15px"></div></div><div class="row"><div style="margin-bottom: 10px" class="col-xlg-6 col-lg-6 col-md-12 col-sm-12 col-xs-12"><div class="btn-group" role="group" aria-label="Basic example" id="e0"><button type="button" class="btn btn-primary no-border-radius" ng-click="vm.addAll()"><data-i18n i18n="_btn_feed_add_all_">Add all</data-i18n></button></div><div ba-panel="" ba-panel-title="{{\'_rations_panel_available_feeds_\'|i18n}}" ba-panel-class="with-scroll xmedium-panel"><div include-with-scope="app/pages/rations/addNewRation/source-table.html"></div></div></div><div class="col-xlg-6 col-lg-6 col-md-12 col-sm-12 col-xs-12"><div class="btn-group" role="group" id="e0"><button type="button" class="btn btn-danger no-border-radius" ng-click="vm.removeAll()"><data-i18n i18n="_btn_feed_remove_all_">Remove all</data-i18n></button></div><div ba-panel="" ba-panel-title="{{\'_rations_panel_ration_feeds_\'|i18n}}" ba-panel-class="with-scroll xmedium-panel"><div include-with-scope="app/pages/rations/addNewRation/table.html"></div></div></div></div></div></form></ba-wizard-step><ba-wizard-step title="{{\'_rations_add_new_ration_step3_title_\'|i18n}}"><form class="form-horizontal" name="vm.finishForm" novalidate="" style="font-size: 16px"><data-i18n i18n="_rations_add_new_ration_finish_message_">You have successfully defined the ration, save your work.</data-i18n><div style="margin-top: 10px" align="right"><button type="button" class="btn btn-success" ng-click="vm.saveRation()" ng-disabled="vm.basicInfoForm.$invalid == true || vm.rationList.length == 0"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_"></data-i18n></button></div></form></ba-wizard-step></ba-wizard><div ng-if="!vm.loading && (!vm.selectedHerd || !vm.selectedTeam)" align="center"><div ng-show="!vm.selectedTeam"><h3><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></h3></div><div ng-show="vm.selectedTeam && !vm.selectedHerd"><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div><div ng-if="vm.loading" align="center"><div style="overflow: hidden"><div id="loading-animation-large" style="display: inline-block"></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/rations/addNewRation/source-table.html','<div class="vertical-scroll"><table class="table-header-fixed auto-scroll" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr ng-if="!vm.hideFilters"><th style="width: 100%"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_feeds_search_feeds_label_">Search feeds</data-i18n></label> <input placeholder="{{\'_search_placeholder_feed_name_\'|i18n}}" class="form-control" type="text" ng-model="vm.searchMaster" id="feedsSearchInput" ng-change="vm.searchMasterChanged()"></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_picker_feed_type_placeholder_">Select feed type</data-i18n></label><br><ui-select style="z-index: 9000 !important" ng-model="vm.feedTypesItem" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.feedTypeChanged()"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.feedTypesList | filter: $select.search" ui-disable-choice="vm.feedTypesItem.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_feeds_common_">Common</data-i18n></label><br><ui-select style="z-index: 9000 !important" ng-model="vm.commonFeedItem" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.commonFeedChanged()"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type in vm.commonFeedList | filter: $select.search" ui-disable-choice="vm.commonFeedItem.name == type.name"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_settings_calculation_type_title_">type</data-i18n></label><ui-select ng-model="vm.selectedCalculationFeed" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.defaultCalculationChanged(true)"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.defaultCalculationList | filter: $select.search" ui-disable-choice="vm.selectedCalculationFeed.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_feeds_my_master_">my/master</data-i18n></label><br><ui-select style="z-index: 9000 !important" ng-model="vm.selectedFeedType" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.feedTypeSelected()"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.filterTypes | filter: $select.search" ui-disable-choice="vm.selectedFeedType.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div></th></tr><tr class="show-hide-filters"><td><button ng-click="vm.hideFilters = !vm.hideFilters"><i ng-if="!vm.hideFilters" class="ion-arrow-up-b"></i><i ng-if="vm.hideFilters" class="ion-arrow-down-b"></i><span><data-i18n i18n="_modal_show_hide_filters_">Show/hide filters</data-i18n></span><i ng-if="!vm.hideFilters" class="ion-arrow-up-b"></i><i ng-if="vm.hideFilters" class="ion-arrow-down-b"></i></button></td></tr><tr ng-if="!vm.loadingFeeds" class="sortable" style="margin-right: 15px"><th style="width: 5%"></th><th ng-click="vm.sort(\'feed_name\')" style="width: 25%"><data-i18n i18n="_feeds_name_">Feed name</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br></th><th ng-click="vm.sort(\'test_date\')" style="width: 19%"><data-i18n i18n="_feeds_test_date_">Test date</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'test_date_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'test_date_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br></th><th ng-click="vm.sort(\'dm\')" style="width: 17%"><data-i18n i18n="_feeds_dm_">dm</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span></th><th ng-click="vm.sort(\'cp\')" style="width: 17%"><data-i18n i18n="_feeds_cp_">cp</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th><th ng-click="vm.sort(\'ndf\')" style="width: 17%"><data-i18n i18n="_feeds_ndf_">ndf</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th></tr></thead><tbody ng-if="!vm.loadingFeeds" infinite-scroll="" scroll-fn="vm.paginationChangedMaster()" scroll-no-all="vm.totalItemsMaster" scroll-no-displayed="vm.feeds.length" scroll-disable="vm.disableScroll"><tr ng-repeat="feed in vm.feeds track by $index" ng-click="vm.addSelected(feed.id)" style="margin-top: 5px; margin-bottom: 5px"><td style="width: 10%"><button type="button" class="btn btn-primary btn-xs" style="border-radius: 50%; transform: none"><i class="ion-plus-round"></i></button></td><td style="width: 20%">{{feed.feed_name}}</td><td style="width: 19%">{{feed.test_date | date: vm.date_format}}</td><td style="width: 17%">{{feed.dm | number: 2}}</td><td style="width: 17%">{{feed.cp| number: 1}}</td><td style="width: 17%">{{feed.ndf | number: 1}}</td></tr><tr ng-if="vm.disableScroll"><td style="width: 100%" align="center"><data-i18n i18n="_title_loading_">Loading...</data-i18n></td></tr></tbody><tbody ng-if="vm.loadingFeeds"><tr><td style="width: 100%" align="center"><div id="loading-animation-large" style="display: inline-block"></div></td></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/rations/addNewRation/table.html','<div class="horizontal-scroll"><table class="table-header-fixed auto-scroll" st-table="vm.rationList" st-safe-src="vm.rationListSafe" ng-if="vm.feeds"><thead><tr class="sortable" style="margin-right: 15px"><th style="width: 10%"></th><th st-sort="feed_name" st-sort-default="true" style="width: 20%"><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br></th><th st-sort="test_date" style="width: 19%"><data-i18n i18n="_feeds_test_date_">Test date</data-i18n><br></th><th st-sort="dm" style="width: 17%"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span></th><th st-sort="cp" style="width: 17%"><data-i18n i18n="_feeds_cp_">cp</data-i18n><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th><th st-sort="NDF" style="width: 17%"><data-i18n i18n="_feeds_ndf_">ndf</data-i18n><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th></tr></thead><tbody><tr ng-repeat="feed in vm.rationList track by $index" ng-click="vm.removeSelected(feed.id, $index)" style="margin-bottom: 5px; margin-top: 5px"><td style="width: 10%"><button type="button" class="btn btn-danger btn-xs" style="border-radius: 50%; transform: none"><i class="ion-minus-round"></i></button></td><td style="width: 20%">{{feed.feed_name}}</td><td style="width: 19%">{{feed.test_date | date:\'mediumDate\'}}</td><td style="width: 17%">{{feed.dm | number: 2}}</td><td style="width: 17%">{{feed.cp| number: 1}}</td><td style="width: 17%">{{feed.ndf | number: 1}}</td></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/rations/balanceRation/balanceRation.amino_acid.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="aminoTable"><thead><tr class="sortable"><th style="height: 77px" class="editable-header" st-sort="feed_name"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th style="min-width: 110px" st-sort="lysine" class="editable-header"><div uib-tooltip="{{\'_description_lys_\' | i18n}}" tooltip-is-open="lysIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lysine_">Lys</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th><th style="min-width: 110px" st-sort="methionine" class="editable-header"><div uib-tooltip="{{\'_description_met_\' | i18n}}" tooltip-is-open="metIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_methionine_">Met</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th><th style="min-width: 110px" st-sort="teaa" class="editable-header"><div uib-tooltip="{{\'_description_teaa_\' | i18n}}" tooltip-is-open="teaaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_teaa_">teaa</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th></tr></thead><tbody id="aminoBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="any" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="feed.loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'A\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="amount{{$index}}A">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px; min-width: 110px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.lysine" e-format-input-value="lysine" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'lysine\', \'A\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="lysine{{$index}}A">{{feed.lysine | formatViewValues: \'lysine\'}}</span></td><td style="padding: 3px 3px; min-width: 110px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.methionine" e-format-input-value="methionine" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'methionine\', \'A\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="methionine{{$index}}A">{{feed.methionine | formatViewValues: \'methionine\'}}</span></td><td style="padding: 3px 3px; min-width: 110px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.teaa" e-format-input-value="teaa" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'teaa\', \'A\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="teaa{{$index}}A">{{feed.teaa | formatViewValues: \'teaa\'}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="any" editable-number="mixfeed.amount" e-format-input-value="amount" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'A\', feed.id)" id="amountMIX{{$index}}A{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px; min-width: 110px"><span e-step="0.01" editable-number="mixfeed.lysine" e-format-input-value="lysine" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'lysine\', \'A\', feed.id)" id="lysineMIX{{$index}}A{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.lysine | formatViewValues: \'lysine\'}}</span></td><td style="padding: 3px 3px; min-width: 110px"><span e-step="0.01" editable-number="mixfeed.methionine" e-format-input-value="methionine" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'methionine\', \'A\', feed.id)" id="methionineMIX{{$index}}A{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.methionine | formatViewValues: \'methionine\'}}</span></td><td style="padding: 3px 3px; min-width: 110px"><span e-step="0.1" editable-number="mixfeed.teaa" e-format-input-value="teaa" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'teaa\', \'A\', feed.id)" id="teaaMIX{{$index}}A{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.teaa | formatViewValues: \'teaa\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/balanceRation.amino_acid.requirements.html','<div ng-if="!vm.loadingTabs" class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th></th><th><data-i18n i18n="_feeds_amount_">amount</data-i18n></th><th><data-i18n i18n="_feeds_lysine_">Lys</data-i18n></th><th><data-i18n i18n="_feeds_methionine_">Met</data-i18n></th><th><data-i18n i18n="_feeds_teaa_">teaa</data-i18n></th></tr></thead><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></th><th>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></th><th>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></th></tr></tbody><tbody><tr><td><data-i18n class="nowrap" i18n="_rations_concentration_supplied_">Concentration supplied</data-i18n></td><td>{{vm.ration.concentration_supplied.amount_dm | formatViewValuesSignificant: \'amount\'}}</td><td>{{vm.ration.concentration_supplied.lysine | formatViewValuesSignificant: \'lysine\'}}</td><td>{{vm.ration.concentration_supplied.methionine | formatViewValuesSignificant: \'methionine\'}}</td><td>{{vm.ration.concentration_supplied.teaa | formatViewValuesSignificant: \'teaa\'}}</td></tr></tbody><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n i18n="_rations_supply_">Supply</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.supply.lysine | formatViewValuesPerDay: \'lysine\'}}</td><td>{{vm.ration.supply.methionine | formatViewValuesPerDay: \'methionine\'}}</td><td>{{vm.ration.supply.teaa | formatViewValuesPerDay: \'teaa\'}}</td></tr><tr><td><data-i18n i18n="_rations_requirements_">Requirements</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.requirements.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.requirements.lysine | formatViewValuesPerDay: \'lysine\'}}</td><td>{{vm.ration.requirements.methionine | formatViewValuesPerDay: \'methionine\'}}</td><td></td></tr><tr class="ration-difference"><td><data-i18n i18n="_rations_difference_">Difference</data-i18n></td><td><span ng-class="vm.ration.difference.amount_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.amount_dm | formatViewValuesPerDay: \'amount\'}}</span></td><td><span ng-class="vm.ration.difference.lysine >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.lysine | formatViewValuesPerDay: \'lysine\'}}</span></td><td><span ng-class="vm.ration.difference.methionine >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.methionine | formatViewValuesPerDay: \'methionine\'}}</span></td><td></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/balanceRation.cost.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="costTable"><thead><tr class="sortable"><th style="height: 77px" class="editable-header" st-sort="feed_name"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="dm" class="editable-header"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-show="vm.settings.use_percent">%</span> <span ng-show="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></div></th><th style="min-width: 170px" st-sort="wt_as_sold" class="editable-header"><div uib-tooltip="{{\'_description_wt_as_sold_\' | i18n}}" tooltip-is-open="wtAsSoldIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_wt_as_sold_">wt as sold</data-i18n><br>{{vm.weight}}</div></th><th style="min-width: 150px" st-sort="cost_as_sold" class="editable-header"><div uib-tooltip="{{\'_description_cost_as_sold_\' | i18n}}" tooltip-is-open="costAsSoldIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_as_sold_">cost as sold</data-i18n><br>{{vm.currency}}</div></th><th st-sort="cost_dm"><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th style="min-width: 150px" st-sort="cost_per_cow"><div><data-i18n i18n="_feeds_cost_per_cow_">cost per cow</data-i18n><br>{{vm.currency}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th style="min-width: 170px" st-sort="actual_milk_cost"><div><data-i18n i18n="_feeds_cost_milk_actual_">milk cost(actual)</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th style="min-width: 150px" st-sort="target_milk_cost"><div><data-i18n i18n="_feeds_cost_milk_target_">milk cost(target)</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th style="min-width: 105px" st-sort="is_purchased" class="editable-header"><div uib-tooltip="{{\'_description_is_purchased_\' | i18n}}" tooltip-is-open="isPurchasedIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_purchased_">Purchased</data-i18n><br><br></div></th></tr></thead><tbody id="costBody"><tr ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-switch="" on="vm.dataCollapse[$index]" class="editable-tr-wrap" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="any" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'CS\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="amount{{$index}}CS">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.settings.use_percent"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.dm" e-format-input-value="dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'dm\', \'CS\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="dm{{$index}}CS">{{feed.dm | formatViewValues: \'dm\'}}</span></td><td style="padding: 3px 3px" ng-show="!vm.settings.use_percent"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.dm" e-format-input-value="dm" e-min="0" e-max="1000" onbeforesave="vm.updateFeed(feed, $index, $data, \'dm\', \'CS\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="dm{{$index}}CS">{{feed.dm | formatViewValues: \'dm\'}}</span></td><td style="min-width: 170px; padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.wt_as_sold" e-format-input-value="wt_as_sold" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'wt_as_sold\', \'CS\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="wt_as_sold{{$index}}CS">{{feed.wt_as_sold | formatViewValues: \'wt_as_sold\'}}</span></td><td style="min-width: 150px; padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.cost_as_sold" e-format-input-value="cost_as_sold" e-min="0" e-max="1000000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'cost_as_sold\', \'CS\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="cost_as_sold{{$index}}CS">{{feed.cost_as_sold | formatViewValues: \'cost_as_sold\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td style="min-width: 150px; padding: 3px 3px"><span>{{feed.cost_per_cow | formatViewValues: \'cost_per_cow\'}}</span></td><td style="min-width: 170px; padding: 3px 3px"><span>{{feed.actual_milk_cost | formatViewValues: \'actual_milk_cost\'}}</span></td><td style="min-width: 150px; padding: 3px 3px"><span>{{feed.target_milk_cost | formatViewValues: \'target_milk_cost\'}}</span></td><td style="min-width: 105px; padding: 3px 3px"><span class="newCheck"><input type="checkbox" id="is_purchased{{$index-X}}" ng-disabled="vm.feed_loading" ng-model="feed.is_purchased" ng-change="vm.updateFeed(feed, $index, $data, \'is_purchased\')"><label for="is_purchased{{$index-X}}" style="left: 45%; top: 50%"></label></span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.amount" e-format-input-value="amount" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'CS\', feed.id)" id="amountMIX{{$index}}CS{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.settings.use_percent"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.dm" e-format-input-value="dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'dm\', \'CS\', feed.id)" id="dmMIX{{$index}}CS{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.dm | formatViewValues: \'dm\'}}</span></td><td style="padding: 3px 3px" ng-show="!vm.settings.use_percent"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.dm" e-format-input-value="dm" e-min="0" e-max="1000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'dm\', \'CS\', feed.id)" id="dmMIX{{$index}}CS{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.dm | formatViewValues: \'dm\'}}</span></td><td style="min-width: 170px; padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.wt_as_sold" e-format-input-value="wt_as_sold" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'wt_as_sold\', \'CS\', feed.id)" id="wt_as_soldMIX{{$index}}CS{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.wt_as_sold | formatViewValues: \'wt_as_sold\'}}</span></td><td style="min-width: 150px; padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.cost_as_sold" e-format-input-value="cost_as_sold" e-min="0" e-max="1000000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'cost_as_sold\', \'CS\', feed.id)" id="cost_as_soldMIX{{$index}}CS{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cost_as_sold | formatViewValues: \'cost_as_sold\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td style="min-width: 150px; padding: 3px 3px"><span>{{mixfeed.cost_per_cow | formatViewValues: \'cost_per_cow\'}}</span></td><td style="min-width: 170px; padding: 3px 3px"><span>{{mixfeed.actual_milk_cost | formatViewValues: \'actual_milk_cost\'}}</span></td><td style="min-width: 150px; padding: 3px 3px"><span>{{mixfeed.target_milk_cost | formatViewValues: \'target_milk_cost\'}}</span></td><td style="min-width: 105px; padding: 3px 3px"><span class="newCheck"><input type="checkbox" ng-disabled="vm.mixfeed_loading" id="{{\'is_purchased\' + indexY + indexX}}-Z" ng-model="mixfeed.is_purchased" ng-change="vm.updateFeedMix(mixfeed, $index, $data, \'is_purchased\')"><label for="{{\'is_purchased\' + indexY + indexX}}-Z" style="left: 45%; top: 50%"></label></span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/balanceRation.cost.requirements.html','<div ng-if="!vm.loadingTabs" class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th></th><th><data-i18n i18n="_feeds_amount_">amount</data-i18n></th><th><data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n></th><th><data-i18n i18n="_feeds_cost_per_cow_">cost per cow</data-i18n></th><th><data-i18n i18n="_feeds_cost_milk_actual_">milk cost(actual)</data-i18n></th><th><data-i18n i18n="_feeds_cost_milk_target_">milk cost(target)</data-i18n></th><th><data-i18n i18n="_feeds_purchased_cost_">Pur cost</data-i18n></th></tr></thead><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th><span ng-show="vm.settings.use_percent">%</span> <span ng-show="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></th><th></th><th></th><th></th><th></th><th></th></tr></tbody><tbody><tr><td><data-i18n class="nowrap" i18n="_rations_concentration_supplied_">Concentration supplied</data-i18n></td><td>{{vm.ration.concentration_supplied.amount_dm | formatViewValuesSignificant: \'amount\'}}</td><td>{{vm.ration.concentration_supplied.dm | formatViewValuesSignificant: \'dm\'}}</td><td>{{vm.ration.concentration_supplied.cost_dm | formatViewValuesSignificant: \'cost_dm\'}}</td><td></td><td></td><td></td><td>{{vm.ration.concentration_supplied.pur_cost | formatViewValuesSignificant: \'pur_cost\'}}</td></tr></tbody><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</th><th>{{vm.currency}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.currency}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.currency}}/{{vm.weight}}</th><th>{{vm.currency}}/{{vm.weight}}</th><th>{{vm.currency}}/<data-i18n i18n="_unit_day_">day</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n i18n="_rations_supply_">Supply</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.supply.dm | formatViewValuesPerDay: \'dm\'}}</td><td>{{vm.ration.supply.cost_dm | formatViewValuesPerDay: \'cost_dm\'}}</td><td>{{vm.ration.supply.cost_per_cow | formatViewValuesPerDay: \'cost_per_cow\'}}</td><td>{{vm.ration.supply.actual_milk_cost | formatViewValuesPerDay: \'actual_milk_cost\'}}</td><td>{{vm.ration.supply.target_milk_cost | formatViewValuesPerDay: \'target_milk_cost\'}}</td><td>{{vm.ration.supply.pur_cost | formatViewValuesPerDay: \'pur_cost\'}}</td></tr><tr><td><data-i18n i18n="_rations_requirements_">Requirements</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.requirements.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr class="ration-difference"><td><data-i18n i18n="_rations_difference_">Difference</data-i18n></td><td><span ng-class="vm.ration.difference.amount_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.amount_dm | formatViewValuesPerDay: \'amount\'}}</span></td><td></td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/balanceRation.html','<div class="row"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel" ng-if="vm.loading" align="center" style="height: 150px; overflow: hidden"><div id="loading-animation-large"></div></div><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><div ng-if="!vm.loading" class="custom-errors" ng-include="\'app/pages/rations/balanceRation/balanceRation.tabs.html\'"></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/balanceRation.mineral.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="mineralTable" ng-if="vm.settings.use_percent"><thead><tr class="sortable"><th style="height: 77px" class="editable-header" st-sort="feed_name"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="ca" class="editable-header"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="ca_abs" class="editable-header"><div uib-tooltip="{{\'_description_ca_abs_\' | i18n}}" tooltip-is-open="absCaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_abs_">abs Ca</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ca_">Ca</data-i18n></div></th><th st-sort="p" class="editable-header"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="p_abs" class="editable-header"><div uib-tooltip="{{\'_description_p_abs_\' | i18n}}" tooltip-is-open="absPIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_p_">P</data-i18n></div></th><th st-sort="mg" class="editable-header"><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">Mg</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="mg_abs" class="editable-header"><div uib-tooltip="{{\'_description_mg_abs_\' | i18n}}" tooltip-is-open="absMgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_abs_">abs Mg</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_mg_">Mg</data-i18n></div></th><th st-sort="k" class="editable-header"><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">K</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="na" class="editable-header"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="cl" class="editable-header"><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">Cl</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="s" class="editable-header"><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">S</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="dcad"><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th st-sort="ash" class="editable-header"><div uib-tooltip="{{\'_description_ash_\' | i18n}}" tooltip-is-open="ashIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ash_">ash</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th></tr></thead><tbody id="mineralBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'M\')" id="amount{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.ca" e-format-input-value="ca" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ca\', \'M\')" id="ca{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ca | formatViewValues: \'ca\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.ca_abs" e-format-input-value="ca_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ca_abs\', \'M\')" id="ca_abs{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ca_abs | formatViewValues: \'ca_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.p" e-format-input-value="p" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'p\', \'M\')" id="p{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.p | formatViewValues: \'p\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.p_abs" e-format-input-value="p_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'p_abs\', \'M\')" id="p_abs{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.p_abs | formatViewValues: \'p_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.mg" e-format-input-value="mg" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'mg\', \'M\')" id="mg{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.mg | formatViewValues: \'mg\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.mg_abs" e-format-input-value="mg_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'mg_abs\', \'M\')" id="mg_abs{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.mg_abs | formatViewValues: \'mg_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.k" e-format-input-value="k" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'k\', \'M\')" id="k{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.k | formatViewValues: \'k\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.na" e-format-input-value="na" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'na\', \'M\')" id="na{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.na | formatViewValues: \'na\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.cl" e-format-input-value="cl" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'cl\', \'M\')" id="cl{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.cl | formatViewValues: \'cl\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.s" e-format-input-value="s" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'s\', \'M\')" id="s{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.s | formatViewValues: \'s\': feed.dm}}</span></td><td style="padding: 3px 3px" e-step="0.1"><span>{{feed.dcad | formatViewValues: \'dcad\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ash" e-format-input-value="ash" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ash\', \'M\')" id="ash{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ash | formatViewValues: \'ash\': feed.dm}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.amount" e-format-input-value="amount" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'M\', feed.id)" id="amountMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ca" e-format-input-value="ca" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ca\', \'M\', feed.id)" id="caMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ca | formatViewValues: \'ca\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ca_abs" e-format-input-value="ca_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ca_abs\', \'M\', feed.id)" id="ca_absMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ca_abs | formatViewValues: \'ca_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.p" e-format-input-value="p" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'p\', \'M\', feed.id)" id="pMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.p | formatViewValues: \'p\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.p_abs" e-format-input-value="p_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'p_abs\', \'M\', feed.id)" id="p_absMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.p_abs | formatViewValues: \'p_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.mg" e-format-input-value="mg" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'mg\', \'M\', feed.id)" id="mgMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.mg | formatViewValues: \'mg\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.mg_abs" e-format-input-value="mg_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'mg_abs\', \'M\', feed.id)" id="mg_absMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.mg_abs | formatViewValues: \'mg_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.k" e-format-input-value="k" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'k\', \'M\', feed.id)" id="kMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.k | formatViewValues: \'k\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.na" e-format-input-value="na" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'na\', \'M\', feed.id)" id="naMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.na | formatViewValues: \'na\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.cl" e-format-input-value="cl" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'cl\', \'M\', feed.id)" id="clMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cl | formatViewValues: \'cl\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.s" e-format-input-value="s" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'s\', \'M\', feed.id)" id="sMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.s | formatViewValues: \'s\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.dcad | formatViewValues: \'dcad\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ash" e-format-input-value="ash" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ash\', \'M\', feed.id)" id="ashMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ash | formatViewValues: \'ash\': mixfeed.dm}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="mineralTable" ng-if="!vm.settings.use_percent"><thead><tr class="sortable"><th style="height: 77px" class="editable-header"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="ca" class="editable-header"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="ca_abs" class="editable-header"><div uib-tooltip="{{\'_description_ca_abs_\' | i18n}}" tooltip-is-open="absCaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_abs_">abs Ca</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ca_">Ca</data-i18n></div></th><th st-sort="p" class="editable-header"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="p_abs" class="editable-header"><div uib-tooltip="{{\'_description_p_abs_\' | i18n}}" tooltip-is-open="absPIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_p_">P</data-i18n></div></th><th st-sort="mg" class="editable-header"><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">Mg</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="mg_abs" class="editable-header"><div uib-tooltip="{{\'_description_mg_abs_\' | i18n}}" tooltip-is-open="absMgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_abs_">abs Mg</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_mg_">Mg</data-i18n></div></th><th st-sort="k" class="editable-header"><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">K</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="na" class="editable-header"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="cl" class="editable-header"><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">Cl</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="s" class="editable-header"><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">S</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="dcad"><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th st-sort="ash" class="editable-header"><div uib-tooltip="{{\'_description_ash_\' | i18n}}" tooltip-is-open="ashIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ash_">ash</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody id="mineralBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'M\')" id="amount{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ca" e-format-input-value="ca" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ca\', \'M\')" id="ca{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ca | formatViewValues: \'ca\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.ca_abs" e-format-input-value="ca_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ca_abs\', \'M\')" id="ca_abs{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ca_abs | formatViewValues: \'ca_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.p" e-format-input-value="p" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'p\', \'M\')" id="p{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.p | formatViewValues: \'p\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.p_abs" e-format-input-value="p_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'p_abs\', \'M\')" id="p_abs{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.p_abs | formatViewValues: \'p_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.mg" e-format-input-value="mg" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'mg\', \'M\')" id="mg{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.mg | formatViewValues: \'mg\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.mg_abs" e-format-input-value="mg_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'mg_abs\', \'M\')" id="mg_abs{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.mg_abs | formatViewValues: \'mg_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.k" e-format-input-value="k" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'k\', \'M\')" id="k{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.k | formatViewValues: \'k\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.na" e-format-input-value="na" e-format-value-dm="feed.dm" e-min="0" e-max="1000" onbeforesave="vm.updateFeed(feed, $index, $data, \'na\', \'M\')" id="na{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.na | formatViewValues: \'na\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.cl" e-format-input-value="cl" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'cl\', \'M\')" id="cl{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.cl | formatViewValues: \'cl\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.s" e-format-input-value="s" e-format-value-dm="feed.dm" e-min="0" e-max="1000" onbeforesave="vm.updateFeed(feed, $index, $data, \'s\', \'M\')" id="s{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.s | formatViewValues: \'s\': feed.dm}}</span></td><td style="padding: 3px 3px" e-step="0.1"><span>{{feed.dcad | formatViewValues: \'dcad\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.ash" e-format-input-value="ash" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ash\', \'M\')" id="ash{{$index}}M" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ash | formatViewValues: \'ash\': feed.dm}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.amount" e-format-input-value="amount" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'M\', feed.id)" id="amountMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ca" e-format-input-value="ca" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ca\', \'M\', feed.id)" id="caMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ca | formatViewValues: \'ca\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ca_abs" e-format-input-value="ca_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ca_abs\', \'M\', feed.id)" id="ca_absMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ca_abs | formatViewValues: \'ca_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.p" e-format-input-value="p" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'p\', \'M\', feed.id)" id="pMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.p | formatViewValues: \'p\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.p_abs" e-format-input-value="p_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'p_abs\', \'M\', feed.id)" id="p_absMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.p_abs | formatViewValues: \'p_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.mg" e-format-input-value="mg" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'mg\', \'M\', feed.id)" id="mgMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.mg | formatViewValues: \'mg\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.mg_abs" e-format-input-value="mg_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'mg_abs\', \'M\', feed.id)" id="mg_absMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.mg_abs | formatViewValues: \'mg_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.k" e-format-input-value="k" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'k\', \'M\', feed.id)" id="kMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.k | formatViewValues: \'k\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.na" e-format-input-value="na" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'na\', \'M\', feed.id)" id="naMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.na | formatViewValues: \'na\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.cl" e-format-input-value="cl" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'cl\', \'M\', feed.id)" id="clMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cl | formatViewValues: \'cl\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.s" e-format-input-value="s" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'s\', \'M\', feed.id)" id="sMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.s | formatViewValues: \'s\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.dcad | formatViewValues: \'dcad\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ash" e-format-input-value="ash" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ash\', \'M\', feed.id)" id="ashMIX{{$index}}M{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ash | formatViewValues: \'ash\': mixfeed.dm}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/balanceRation.mineral.requirements.html','<div ng-if="!vm.loadingTabs" class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th></th><th><data-i18n i18n="_feeds_amount_">amount</data-i18n></th><th><data-i18n i18n="_feeds_ca_">Ca</data-i18n></th><th><data-i18n i18n="_feeds_ca_abs_">abs Ca</data-i18n></th><th><data-i18n i18n="_feeds_p_">P</data-i18n></th><th><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n></th><th><data-i18n i18n="_feeds_mg_">Mg</data-i18n></th><th><data-i18n i18n="_feeds_mg_abs_">abs Mg</data-i18n></th><th><data-i18n i18n="_feeds_k_">K</data-i18n></th><th><data-i18n i18n="_feeds_na_">Na</data-i18n></th><th><data-i18n i18n="_feeds_cl_">Cl</data-i18n></th><th><data-i18n i18n="_feeds_s_">S</data-i18n></th><th><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n></th><th><data-i18n i18n="_feeds_ash_">ash</data-i18n></th></tr></thead><tbody ng-if="vm.settings.use_percent"><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_ca_">Ca</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_p_">P</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_mg_">Mg</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th></tr></tbody><tbody ng-if="!vm.settings.use_percent"><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_ca_">Ca</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_p_">P</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_mg_">Mg</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th></tr></tbody><tbody><tr><td><data-i18n class="nowrap" i18n="_rations_concentration_supplied_">Concentration supplied</data-i18n></td><td>{{vm.ration.concentration_supplied.amount_dm | formatViewValuesSignificant: \'amount\'}}</td><td>{{vm.ration.concentration_supplied.ca | formatViewValuesSignificant: \'ca\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.ca_abs | formatViewValuesSignificant: \'ca_abs\'}}</td><td>{{vm.ration.concentration_supplied.p | formatViewValuesSignificant: \'p\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.p_abs | formatViewValuesSignificant: \'p_abs\'}}</td><td>{{vm.ration.concentration_supplied.mg | formatViewValuesSignificant: \'mg\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.mg_abs | formatViewValuesSignificant: \'mg_abs\'}}</td><td>{{vm.ration.concentration_supplied.k | formatViewValuesSignificant: \'k\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.na | formatViewValuesSignificant: \'na\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.cl | formatViewValuesSignificant: \'cl\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.s | formatViewValuesSignificant: \'s\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.dcad | formatViewValuesSignificant: \'dcad\'}}</td><td>{{vm.ration.concentration_supplied.ash | formatViewValuesSignificant: \'ash\' : vm.ration.concentration_supplied.dm}}</td></tr></tbody><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_meq_">meq</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n i18n="_rations_supply_">Supply</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.supply.ca | formatViewValuesPerDay: \'ca\'}}</td><td>{{vm.ration.supply.ca_abs | formatViewValuesPerDay: \'ca_abs\'}}</td><td>{{vm.ration.supply.p | formatViewValuesPerDay: \'p\'}}</td><td>{{vm.ration.supply.p_abs | formatViewValuesPerDay: \'p_abs\'}}</td><td>{{vm.ration.supply.mg | formatViewValuesPerDay: \'mg\'}}</td><td>{{vm.ration.supply.mg_abs | formatViewValuesPerDay: \'mg_abs\'}}</td><td>{{vm.ration.supply.k | formatViewValuesPerDay: \'k\'}}</td><td>{{vm.ration.supply.na | formatViewValuesPerDay: \'na\'}}</td><td>{{vm.ration.supply.cl | formatViewValuesPerDay: \'cl\'}}</td><td>{{vm.ration.supply.s | formatViewValuesPerDay: \'s\'}}</td><td>{{vm.ration.supply.dcad | formatViewValuesPerDay: \'dcad\'}}</td><td>{{vm.ration.supply.ash | formatViewValuesPerDay: \'ash\'}}</td></tr><tr><td><data-i18n i18n="_rations_requirements_">Requirements</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.requirements.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.requirements.ca | formatViewValuesPerDay: \'ca\'}}</td><td>{{vm.ration.requirements.ca_abs | formatViewValuesPerDay: \'ca_abs\'}}</td><td>{{vm.ration.requirements.p | formatViewValuesPerDay: \'p\'}}</td><td>{{vm.ration.requirements.p_abs | formatViewValuesPerDay: \'p_abs\'}}</td><td>{{vm.ration.requirements.mg | formatViewValuesPerDay: \'mg\'}}</td><td>{{vm.ration.requirements.mg_abs | formatViewValuesPerDay: \'mg_abs\'}}</td><td>{{vm.ration.requirements.k | formatViewValuesPerDay: \'k\'}}</td><td>{{vm.ration.requirements.na | formatViewValuesPerDay: \'na\'}}</td><td>{{vm.ration.requirements.cl | formatViewValuesPerDay: \'cl\'}}</td><td>{{vm.ration.requirements.s | formatViewValuesPerDay: \'s\'}}</td><td></td><td></td></tr><tr class="ration-difference"><td><data-i18n i18n="_rations_difference_">Difference</data-i18n></td><td><span ng-class="vm.ration.difference.amount_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.amount_dm | formatViewValuesPerDay: \'amount\'}}</span></td><td><span ng-class="vm.ration.difference.ca >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.ca | formatViewValuesPerDay: \'ca\'}}</span></td><td><span ng-class="vm.ration.difference.ca_abs >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.ca_abs | formatViewValuesPerDay: \'ca_abs\'}}</span></td><td><span ng-class="vm.ration.difference.p >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.p | formatViewValuesPerDay: \'p\'}}</span></td><td><span ng-class="vm.ration.difference.p_abs >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.p_abs | formatViewValuesPerDay: \'p_abs\'}}</span></td><td><span ng-class="vm.ration.difference.mg >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.mg | formatViewValuesPerDay: \'mg\'}}</span></td><td><span ng-class="vm.ration.difference.mg_abs >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.mg_abs | formatViewValuesPerDay: \'mg_abs\'}}</span></td><td><span ng-class="vm.ration.difference.k >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.k | formatViewValuesPerDay: \'k\'}}</span></td><td><span ng-class="vm.ration.difference.na >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.na | formatViewValuesPerDay: \'na\'}}</span></td><td><span ng-class="vm.ration.difference.cl >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.cl | formatViewValuesPerDay: \'cl\'}}</span></td><td><span ng-class="vm.ration.difference.s >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.s | formatViewValuesPerDay: \'s\'}}</span></td><td></td><td></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/balanceRation.misc.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped extended" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="miscTable"><thead><tr class="sortable"><th style="height: 77px" class="editable-header" st-sort="feed_name"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="feed_type.show_name" style="min-width: 150px" class="editable-header"><div uib-tooltip="{{\'_description_feed_type_\' | i18n}}" tooltip-is-open="feedTypeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_type_">feed type</data-i18n><br><br></div></th><th st-sort="feed_category" style="min-width: 130px"><div uib-tooltip="{{\'_description_feed_category_\' | i18n}}" tooltip-is-open="feedCategoryIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_category_">feed category</data-i18n><br><br></div></th><th st-sort="common_feed" style="min-width: 190px" class="editable-header"><div uib-tooltip="{{\'_description_common_feed_\' | i18n}}" tooltip-is-open="commonIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_common_">Common feed</data-i18n><br><br></div></th><th st-sort="blank_1" class="editable-header"><div uib-tooltip="{{\'_description_blank_1_\' | i18n}}" tooltip-is-open="blank1IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>1<br><br></div></th><th st-sort="blank_2" class="editable-header"><div uib-tooltip="{{\'_description_blank_2_\' | i18n}}" tooltip-is-open="blank2IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>2<br><br></div></th><th st-sort="blank_3" class="editable-header"><div uib-tooltip="{{\'_description_blank_3_\' | i18n}}" tooltip-is-open="blank3IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>3<br><br></div></th><th st-sort="blank_4" class="editable-header"><div uib-tooltip="{{\'_description_blank_4_\' | i18n}}" tooltip-is-open="blank4IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>4<br><br></div></th><th st-sort="blank_5" class="editable-header"><div uib-tooltip="{{\'_description_blank_5_\' | i18n}}" tooltip-is-open="blank5IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>5<br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_comment_\' | i18n}}" tooltip-is-open="commentIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_comment_">Comment</data-i18n><br><br></div></th><th st-sort="test_date" style="min-width: 180px" class="editable-header"><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br><br></div></th></tr></thead><tbody id="miscBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="any" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'MC\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="amount{{$index}}MC">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="min-width: 150px; padding: 3px 3px"><a href="#" editable-select="feed.feed_type" edit-disabled="vm.feed_loading" onshow="loadGroups()" e-ng-options="feed_type as (feed_type.show_name | i18n) for feed_type in vm.feed_types | feedTypeFilter: feed.feed_locale" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_type\')">{{(feed.feed_type.show_name | i18n) || \'-\' }}</a></td><td style="min-width: 130px; padding: 3px 3px">{{feed.feed_category}}</td><td style="min-width: 190px; padding: 3px 3px"><span class="newCheck"><input type="checkbox" ng-disabled="vm.feed_loading" id="is_purchased{{indexX}}-X" ng-change="vm.updateFeed(feed, $index, $data, \'common_feed\', \'MC\')" ng-model="feed.common_feed"><label for="is_purchased{{indexX}}-X" style="left: 45%; top: 50%"></label></span></td><td style="padding: 3px 3px"><span editable-number="feed.blank_1" e-step="any" e-min="0" e-max="1000000" edit-disabled="vm.feed_loading" onbeforesave="vm.updateFeed(feed, $index, $data, \'blank_1\', \'MC\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="blank_1{{$index}}MC">{{feed.blank_1}}</span></td><td style="padding: 3px 3px"><span editable-number="feed.blank_2" e-step="any" e-min="0" e-max="1000000" edit-disabled="vm.feed_loading" onbeforesave="vm.updateFeed(feed, $index, $data, \'blank_2\', \'MC\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="blank_2{{$index}}MC">{{feed.blank_2}}</span></td><td style="padding: 3px 3px"><span editable-number="feed.blank_3" e-step="any" e-min="0" e-max="1000000" edit-disabled="vm.feed_loading" onbeforesave="vm.updateFeed(feed, $index, $data, \'blank_3\', \'MC\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="blank_3{{$index}}MC">{{feed.blank_3}}</span></td><td style="padding: 3px 3px"><span editable-number="feed.blank_4" e-step="any" e-min="0" e-max="1000000" edit-disabled="vm.feed_loading" onbeforesave="vm.updateFeed(feed, $index, $data, \'blank_4\', \'MC\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="blank_4{{$index}}MC">{{feed.blank_4}}</span></td><td style="padding: 3px 3px"><span editable-number="feed.blank_5" e-step="any" e-min="0" e-max="1000000" edit-disabled="vm.feed_loading" onbeforesave="vm.updateFeed(feed, $index, $data, \'blank_5\', \'MC\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="blank_5{{$index}}MC">{{feed.blank_5}}</span></td><td style="padding: 3px 3px"><span editable-text="feed.comments" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'comments\', \'MC\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="comments{{$index}}MC">{{feed.comments|| \'-\'}}</span></td><td style="min-width: 180px; padding: 3px 3px"><div class="form-group"><p ng-click="feedMisc.datepicker = !feedMisc.datepicker" ng-hide="$data" ng-model="$data" is-open="feedMisc.datepicker" style="width: 95px; text-decoration: underline; text-decoration-style: dotted" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="feedzDate{{$index}}" name="feedzDate{{$index}}" popup-placement="bottom-right"><span>{{(feed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</span></p><p class="input-group" ng-show="$data"><input type="text" class="form-control" ng-click="feedMisc.datepickerr = !feedMisc.datepickerr" ng-model="$data" is-open="feedMisc.datepickerr" style="width: 95px" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" placeholder="{{(feed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="feedxDate{{$index}}" name="feedxDate{{$index}}" popup-placement="bottom-right"> <span class="input-group-btn"><button type="button" ng-disabled="vm.feed_loading" class="btn btn-primary btn-sm active" ng-click="vm.updateFeed(feed, $index, $data, \'test_date\')"><i class="glyphicon glyphicon-ok"></i></button> <button type="button" ng-disabled="vm.feed_loading" class="btn btn-danger btn-sm active" ng-click="$data = \'\'"><i class="ion-close-round ng-scope"></i></button></span></p></div></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix" style="z-index: 3"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="any" editable-number="mixfeed.amount" e-format-input-value="amount" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="500" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'MC\')" id="amountMIX{{$index}}MC{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="min-width: 150px; padding: 3px 3px"><a href="#" editable-select="mixfeed.feed_type" edit-disabled="vm.mixfeed_loading" onshow="loadGroups()" e-ng-options="feed_type as (feed_type.show_name | i18n) for feed_type in vm.feed_types | feedTypeFilter: mixfeed.feed_locale" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_type\')">{{(mixfeed.feed_type.show_name | i18n) || \'-\' }}</a></td><td style="min-width: 130px; padding: 3px 3px">{{mixfeed.feed_category}}</td><td style="min-width: 190px; padding: 3px 3px"><span style="z-index: 2" class="newCheck"><input type="checkbox" ng-disabled="vm.mixfeed_loading" id="{{\'is_purchased\' + indexY +indexX}}-Y" ng-change="vm.updateFeedMix(mixfeed, $index, $data, \'common_feed\')" ng-model="mixfeed.common_feed"><label for="{{\'is_purchased\' + indexY +indexX}}-Y" ng-disabled="vm.mixfeed_loading" style="left: 45%; top: 50%"></label></span></td><td style="padding: 3px 3px"><span editable-number="mixfeed.blank_1" e-step="any" e-min="0" e-max="1000000" edit-disabled="vm.mixfeed_loading" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'blank_1\', \'MC\')" id="blank_1MIX{{$index}}MC{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.blank_1}}</span></td><td style="padding: 3px 3px"><span editable-number="mixfeed.blank_2" e-step="any" e-min="0" e-max="1000000" edit-disabled="vm.mixfeed_loading" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'blank_2\', \'MC\')" id="blank_2MIX{{$index}}MC{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.blank_2}}</span></td><td style="padding: 3px 3px"><span editable-number="mixfeed.blank_3" e-step="any" e-min="0" e-max="1000000" edit-disabled="vm.mixfeed_loading" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'blank_3\', \'MC\')" id="blank_3MIX{{$index}}MC{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.blank_3}}</span></td><td style="padding: 3px 3px"><span editable-number="mixfeed.blank_4" e-step="any" e-min="0" e-max="1000000" edit-disabled="vm.mixfeed_loading" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'blank_4\', \'MC\')" id="blank_4MIX{{$index}}MC{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.blank_4}}</span></td><td style="padding: 3px 3px"><span editable-number="mixfeed.blank_5" e-step="any" e-min="0" e-max="1000000" edit-disabled="vm.mixfeed_loading" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'blank_5\', \'MC\')" id="blank_5MIX{{$index}}MC{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.blank_5}}</span></td><td style="padding: 3px 3px"><span editable-text="mixfeed.comments" edit-disabled="vm.mixfeed_loading" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'comments\', \'MC\')" id="commentsMIX{{$index}}MC{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.comments || \'-\'}}</span></td><td style="min-width: 180px; padding: 3px 3px"><div class="form-group"><p ng-click="feedMixMisc.datepicker = !feedMixMisc.datepicker" ng-hide="$data[$index]" is-open="feedMixMisc.datepicker" ng-model="$data[$index]" style="width: 95px; text-decoration: underline; text-decoration-style: dotted" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="mixzfeedDate{{indexX}}{{indexY}}" name="mixzfeedDate{{indexX}}{{indexY}}" popup-placement="bottom-right"><span>{{(mixfeed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</span></p><p class="input-group" ng-show="$data[$index]"><input type="text" class="form-control" is-open="feedMixMisc.datepickerr" ng-click="feedMixMisc.datepickerr = !feedMixMisc.datepickerr" ng-model="$data[$index]" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" placeholder="{{(mixfeed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}" style="width: 95px" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="mixvfeedDate{{indexX}}{{indexY}}" name="mixvfeedDate{{indexX}}{{indexY}}" popup-placement="bottom-right"> <span class="input-group-btn"><button type="button" ng-disabled="vm.mixfeed_loading" class="btn btn-primary btn-sm" ng-click="vm.updateFeedMix(mixfeed, $index, $data[$index], \'test_date\')"><i class="glyphicon glyphicon-ok"></i></button> <button type="button" ng-disabled="vm.mixfeed_loading" class="btn btn-danger btn-sm active" ng-click="$data[$index] = \'\'"><i class="ion-close-round ng-scope"></i></button></span></p></div></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/balanceRation.misc.requirements.html','<div ng-if="!vm.loadingTabs" class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th></th><th><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_feeds_blank_">blank</data-i18n>1<br><br></th><th><data-i18n i18n="_feeds_blank_">blank</data-i18n>2<br><br></th><th><data-i18n i18n="_feeds_blank_">blank</data-i18n>3<br><br></th><th><data-i18n i18n="_feeds_blank_">blank</data-i18n>4<br><br></th><th><data-i18n i18n="_feeds_blank_">blank</data-i18n>5<br><br></th></tr></thead><tbody><tr><td><data-i18n class="nowrap" i18n="_rations_concentration_supplied_">Concentration supplied</data-i18n></td><td>{{vm.ration.concentration_supplied.amount_dm | formatViewValuesSignificant: \'amount\'}}</td><td>{{vm.ration.concentration_supplied.blank_1}}</td><td>{{vm.ration.concentration_supplied.blank_2}}</td><td>{{vm.ration.concentration_supplied.blank_3}}</td><td>{{vm.ration.concentration_supplied.blank_4}}</td><td>{{vm.ration.concentration_supplied.blank_5}}</td></tr><tr><td><data-i18n i18n="_rations_supply_">Supply</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td></td><td></td><td></td><td></td><td></td></tr><tr><td><data-i18n i18n="_rations_requirements_">Requirements</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.requirements.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td></td><td></td><td></td><td></td><td></td></tr><tr class="ration-difference"><td><data-i18n i18n="_rations_difference_">Difference</data-i18n></td><td><span ng-class="vm.ration.difference.amount_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.amount_dm | formatViewValuesPerDay: \'amount\'}}</span></td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/balanceRation.tabs.html','<div><div class="row" ng-if="!vm.loading" style="margin-top: 20px; margin-right: 0px; margin-left: 0px"><div class="col-xs-12" style="margin-bottom: 10px"><div style="float: right"><div><div class="btn-group ration-info-popover-component" ng-if="vm.usedRecipesList && vm.usedRecipesList.length > 0"><info-popover title="{{\'_m_f_title_recipe_ration_list_\' | i18n}}" subtitle="{{\'_m_f_subtitle_recipe_ration_list_\' | i18n}}" items="vm.usedRecipesList" loading="vm.popoverLoading" size="large"></info-popover></div><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary" uib-dropdown-toggle="" style="margin: 10px 0 0 10px"><data-i18n i18n="_title_feeds_">feeds</data-i18n><span class="caret"></span></button><ul uib-dropdown-menu="" class="dropdown-menu"><li><a href="" ng-click="vm.insertFeedOpenModal(\'app/pages/rations/balanceRation/modals/insertFeed.modal.html\', \'lg\')"><data-i18n i18n="_btn_feed_add_feed_">add feed</data-i18n></a></li><li><a href="" ng-click="vm.deleteFeed()" ng-if="vm.checkIsSelectedDelete()"><data-i18n i18n="_btn_feed_delete_feeds_">delete feeds</data-i18n></a> <a href="" class="disabled-link" ng-if="!vm.checkIsSelectedDelete()"><data-i18n i18n="_btn_feed_delete_feeds_">delete feeds</data-i18n></a></li><li><a href="" ng-click="vm.createMIX(\'app/pages/rations/balanceRation/modals/createMix.modal.html\', \'lg\')"><data-i18n i18n="_btn_feed_create_mix_">create premix</data-i18n></a></li></ul></div><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary" uib-dropdown-toggle="" style="margin: 10px 0 0 10px"><data-i18n i18n="_btn_reports_">reports</data-i18n><span class="caret"></span></button><ul uib-dropdown-menu="" class="dropdown-menu"><li><a href="" ng-click="vm.openMixModal(\'app/pages/rations/balanceRation/modals/mixReport.modal.html\', \'md\')" ng-if="vm.hasMix"><data-i18n i18n="_report_mix_">premix report</data-i18n></a> <a href="" class="disabled-link" ng-if="!vm.hasMix"><data-i18n i18n="_report_mix_">premix report</data-i18n></a> <a href="" ng-click="vm.openBatchModal(\'app/pages/rations/balanceRation/modals/batchReport.modal.html\', \'md\')" ng-if="vm.hasBatch"><data-i18n i18n="_report_batch_">batch report</data-i18n></a> <a href="" class="disabled-link" ng-if="!vm.hasBatch"><data-i18n i18n="_report_batch_">batch report</data-i18n></a> <a href="" ng-click="vm.openSummaryModal(\'app/pages/rations/balanceRation/modals/summaryReport.modal.html\', \'md\')"><data-i18n i18n="_report_summary_">summary report</data-i18n></a> <a href="" ng-click="vm.openOfficeModal(\'app/pages/rations/balanceRation/modals/officeReport.modal.html\', \'md\')"><data-i18n i18n="_report_office_report_">office report</data-i18n></a></li></ul></div><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success" uib-dropdown-toggle="" style="margin: 10px 0 0 10px"><data-i18n i18n="_btn_save_">save</data-i18n><span class="caret"></span></button><ul uib-dropdown-menu="" class="dropdown-menu"><li><a href="" ng-click="vm.saveRation()"><data-i18n i18n="_btn_save_">save</data-i18n></a></li><li><a href="" ng-click="vm.openSaveAsModal(\'app/pages/rations/balanceRation/modals/saveAs.modal.html\', \'md\')"><data-i18n i18n="_btn_save_as_">save as</data-i18n></a></li></ul></div><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary dark-blue" uib-dropdown-toggle="" style="margin: 10px 0 0 10px"><data-i18n i18n="_btn_animal_">animal</data-i18n><span class="caret"></span></button><ul uib-dropdown-menu="" class="dropdown-menu-right"><li><a href="" ng-click="vm.editGroup()"><data-i18n i18n="_rations_animal_group_settings_">group settings</data-i18n></a></li><li><a href="" ng-click="vm.openChangeGroup(\'app/pages/rations/balanceRation/modals/changeGroup.html\',\'md\', false)"><data-i18n i18n="_rations_animal_group_change_">change group</data-i18n></a></li><li><a href="" ng-click="vm.openAnimalEnvironmentalFactors(\'app/pages/rations/balanceRation/modals/animalEnvironmental.html\', \'md\')"><data-i18n i18n="_rations_animal_environmental_factors_">enviromental factors</data-i18n></a></li><li><a href="" ng-click="vm.openAnimalFeedAdditives(\'app/pages/rations/balanceRation/modals/animalFeedAdditives.html\', \'md\')"><data-i18n i18n="_rations_animal_feed_additives_">feed additives</data-i18n></a></li></ul></div><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary dark-blue" uib-dropdown-toggle="" style="margin: 10px 0 0 10px"><data-i18n i18n="_btn_ration_">ration</data-i18n><span class="caret"></span></button><ul uib-dropdown-menu="" class="dropdown-menu-right"><li><a href="" ng-click="vm.openRationGroupInfo(\'app/pages/rations/balanceRation/modals/rationGroupInformations.html\', \'sm\')"><data-i18n i18n="_rations_ration_group_info_">group information</data-i18n></a></li><li ng-if="vm.rationCalculationLabel == \'US\'"><a href="" ng-click="vm.openRationMetProtSys(\'app/pages/rations/balanceRation/modals/rationMetabolizablePSys.html\', \'sm\')"><data-i18n i18n="_rations_ration_metabolizable_protein_system_">metabolizable protein system</data-i18n></a></li><li><a href="" ng-click="vm.openRationRatiosRelationships(\'app/pages/rations/balanceRation/modals/rationRatiosRelationships.html\', \'lg\')"><data-i18n i18n="_rations_ration_ratios_relationships_">ratios and relationships</data-i18n></a></li></ul></div><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary dark-blue" uib-dropdown-toggle="" style="margin: 10px 0 0 10px"><data-i18n i18n="_btn_settings_">settings</data-i18n><span class="caret"></span></button><ul uib-dropdown-menu="" class="dropdown-menu-right"><li><a href="" ng-click="vm.openSettingsGeneral(\'app/pages/rations/balanceRation/modals/settingsGeneral.html\', \'md\')"><data-i18n i18n="_rations_settings_general_">general settings</data-i18n></a></li><li><a href="" ng-click="vm.openSettingsNBG(\'app/pages/rations/balanceRation/modals/settingsNutrientBalanceGraph.html\', \'md\')"><data-i18n i18n="_rations_settings_nutrient_balance_graph_">nutrient balance graph</data-i18n></a></li></ul></div></div></div></div><div class="row" style="margin-left: 10px; margin-bottom: 10px; margin-right: 0px; margin-top: 5px"><div class="col-xlg-12" ng-if="vm.ration"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory()" uib-tooltip="{{\'_ration_history_\' | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button ng-if="false" type="button" class="btn btn-primary btn-xs" ng-click="vm.openOrderModal(\'app/pages/rations/balanceRation/modals/changeOrder.modal.html\', \'lg\')" uib-tooltip="{{\'_m_f_btn_update_order_\' | i18n}}" tooltip-is-open="orderIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="fa fa-exchange fa-icon-rotate-90"></i></button> {{vm.ration.ration_header.ration_name}}:&nbsp;{{vm.ration.group.name}}:&nbsp;{{vm.ration.group.number_of_animals}}&nbsp;<data-i18n i18n="{{vm.ration.group.br}}"></data-i18n>,&nbsp;<data-i18n i18n="{{vm.ration.group.t}}"></data-i18n><span ng-if="vm.ration.group.type == \'drycow/late_pregnant_heifer\'">,&nbsp;<data-i18n i18n="_groups_upcoming_lactation_number_short_"></data-i18n>:&nbsp;{{vm.ration.group.upcoming_lactation_number}}</span><span ng-if="vm.ration.group.type == \'lactating_cow\'">,&nbsp;<data-i18n i18n="_groups_lactation_number_short_"></data-i18n>:&nbsp;{{vm.ration.group.lactation_number}}</span><span>,&nbsp;<data-i18n i18n="_groups_total_bw_short_">BW</data-i18n>:&nbsp;{{vm.ration.group.tbw | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</span><span ng-if="vm.ration.group.type == \'drycow/late_pregnant_heifer\'">,&nbsp;<data-i18n i18n="_groups_days_to_calving_short_">DTF</data-i18n>:&nbsp;{{vm.ration.group.days_to_calving}}</span><span ng-if="vm.ration.group.type == \'lactating_cow\'">,&nbsp;<data-i18n i18n="_groups_days_in_milk_short_">DIM</data-i18n>:&nbsp;{{vm.ration.group.days_in_milk}}</span><span ng-if="vm.ration.group.type == \'lactating_cow\'">,&nbsp;<data-i18n i18n="_groups_target_milk_yield_short_">MPD</data-i18n>:&nbsp;{{vm.ration.group.mpd | formatViewValues: \'amount\'}}</span><span ng-if="vm.ration.group.type == \'lactating_cow\'">,&nbsp;<data-i18n i18n="_groups_target_fat_short_">MFat</data-i18n>:&nbsp;{{vm.ration.group.target_fat}} %</span><span ng-if="vm.ration.group.type == \'heifer\'">,&nbsp;<data-i18n i18n="_groups_current_age_short_">Age</data-i18n>:&nbsp;{{vm.ration.group.current_age}}<data-i18n i18n="_unit_months_">months</data-i18n></span><span>,&nbsp;<data-i18n i18n="_groups_target_daily_fg_short_">DG</data-i18n>:&nbsp;{{vm.ration.group.dg | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}/<data-i18n i18n="_unit_days_">days</data-i18n></span><span>,&nbsp;<data-i18n i18n="_groups_predicted_base_dmi_short_">DMI</data-i18n>:&nbsp;{{vm.ration.group.dmi | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</span><span ng-if="vm.rationCalculationLabel">,&nbsp;<data-i18n i18n="_ration_calculation_type">Calculation type</data-i18n>:&nbsp;{{vm.rationCalculationLabel}}</span></div></div><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{\'_feeds_tab_home_\'|i18n}}" select="vm.activeTab = 1"><div ng-show="!vm.loadingTabs"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div ng-if="vm.rationTables.showHome" element-loaded="vm.stopLoadingTabs()"><div class="row"><div class="col-xs-12"><div class="ration-feeds" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div ng-if="vm.ration.ration_header.ration_locale === 0" include-with-scope="app/pages/rations/balanceRation/rationsHome/balanceRation.homeUS.html"></div><div ng-if="vm.ration.ration_header.ration_locale === 1" include-with-scope="app/pages/rations/balanceRation/rationsHome/balanceRation.homeVemDve.html"></div></div></div><div ng-if="!vm.loadingTabs" class="ration-balance-graph-switch" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'" ng-click="vm.changeShowGraph()"><i class="ion-arrow-right-b" ng-if="vm.showGraph"></i> <i class="ion-arrow-left-b" ng-if="!vm.showGraph"></i></div><div class="ration-balance-graph" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-title="{{\'_rations_panel_nutrient_balance_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" ng-if="vm.showChart"><div><canvas id="bar" class="chart chart-horizontal-bar" chart-data="vm.data" chart-labels="vm.labels" chart-update="updateC" chart-options="vm.chartOptions" chart-colors="vm.colors" ng-style="vm.chartStyle"></canvas></div><div align="center"><data-i18n i18n="_rations_x_axis_">+/- % of requested</data-i18n></div></div></div></div></div><div class="row"><div class="col-lg-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div ng-if="vm.ration.ration_header.ration_locale === 0" include-with-scope="app/pages/rations/balanceRation/rationsHome/balanceRation.home.requirementsUS.html"></div><div ng-if="vm.ration.ration_header.ration_locale === 1" include-with-scope="app/pages/rations/balanceRation/rationsHome/balanceRation.home.requirementsVemDve.html"></div></div></div></div></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_fiber_\'|i18n}}" select="vm.activeTab = 2"><div ng-show="!vm.loadingTabs"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div ng-if="vm.rationTables.showFiber" element-loaded="vm.stopLoadingTabs()"><div class="row"><div class="col-xs-12"><div class="ration-feeds" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div ng-if="vm.ration.ration_header.ration_locale === 0" include-with-scope="app/pages/rations/balanceRation/rationsFiber/balanceRation.fiberUS.html"></div><div ng-if="vm.ration.ration_header.ration_locale === 1" include-with-scope="app/pages/rations/balanceRation/rationsFiber/balanceRation.fiberVemDve.html"></div></div></div><div ng-if="!vm.loadingTabs" class="ration-balance-graph-switch" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'" ng-click="vm.changeShowGraph()"><i class="ion-arrow-right-b" ng-if="vm.showGraph"></i> <i class="ion-arrow-left-b" ng-if="!vm.showGraph"></i></div><div class="ration-balance-graph" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-title="{{\'_rations_panel_nutrient_balance_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" ng-if="vm.showChart"><div><canvas id="bar" class="chart chart-horizontal-bar" chart-data="vm.data" chart-labels="vm.labels" chart-update="updateC" chart-options="vm.chartOptions" chart-colors="vm.colors" ng-style="vm.chartStyle"></canvas></div><div align="center"><data-i18n i18n="_rations_x_axis_">+/- % of requested</data-i18n></div></div></div></div></div><div class="row"><div class="col-lg-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div ng-if="vm.ration.ration_header.ration_locale === 0" include-with-scope="app/pages/rations/balanceRation/rationsFiber/balanceRation.fiber.requirementsUS.html"></div><div ng-if="vm.ration.ration_header.ration_locale === 1" include-with-scope="app/pages/rations/balanceRation/rationsFiber/balanceRation.fiber.requirementsVemDve.html"></div></div></div></div></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_energy_\'|i18n}}" select="vm.activeTab = 3"><div ng-show="!vm.loadingTabs"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div ng-if="vm.rationTables.showEnergy" element-loaded="vm.stopLoadingTabs()"><div class="row"><div class="col-xs-12"><div class="ration-feeds" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div ng-if="vm.ration.ration_header.ration_locale === 0" include-with-scope="app/pages/rations/balanceRation/rationsEnergy/balanceRation.energyUS.html"></div><div ng-if="vm.ration.ration_header.ration_locale === 1" include-with-scope="app/pages/rations/balanceRation/rationsEnergy/balanceRation.energyVemDve.html"></div></div></div><div ng-if="!vm.loadingTabs" class="ration-balance-graph-switch" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'" ng-click="vm.changeShowGraph()"><i class="ion-arrow-right-b" ng-if="vm.showGraph"></i> <i class="ion-arrow-left-b" ng-if="!vm.showGraph"></i></div><div class="ration-balance-graph" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-title="{{\'_rations_panel_nutrient_balance_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" ng-if="vm.showChart"><div><canvas id="bar" class="chart chart-horizontal-bar" chart-data="vm.data" chart-labels="vm.labels" chart-update="updateC" chart-options="vm.chartOptions" chart-colors="vm.colors" ng-style="vm.chartStyle"></canvas></div><div align="center"><data-i18n i18n="_rations_x_axis_">+/- % of requested</data-i18n></div></div></div></div></div><div class="row"><div class="col-lg-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div ng-if="vm.ration.ration_header.ration_locale === 0" include-with-scope="app/pages/rations/balanceRation/rationsEnergy/balanceRation.energy.requirementsUS.html"></div><div ng-if="vm.ration.ration_header.ration_locale === 1" include-with-scope="app/pages/rations/balanceRation/rationsEnergy/balanceRation.energy.requirementsVemDve.html"></div></div></div></div></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_protein_\'|i18n}}" select="vm.activeTab = 4"><div ng-show="!vm.loadingTabs"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div ng-if="vm.rationTables.showProtein" element-loaded="vm.stopLoadingTabs()"><div class="row"><div class="col-xs-12"><div class="ration-feeds" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div ng-if="vm.ration.ration_header.ration_locale === 0" include-with-scope="app/pages/rations/balanceRation/rationsProtein/balanceRation.proteinUS.html"></div><div ng-if="vm.ration.ration_header.ration_locale === 1" include-with-scope="app/pages/rations/balanceRation/rationsProtein/balanceRation.proteinVemDve.html"></div></div></div><div ng-if="!vm.loadingTabs" class="ration-balance-graph-switch" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'" ng-click="vm.changeShowGraph()"><i class="ion-arrow-right-b" ng-if="vm.showGraph"></i> <i class="ion-arrow-left-b" ng-if="!vm.showGraph"></i></div><div class="ration-balance-graph" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" ng-if="vm.showChart" ba-panel-title="{{\'_rations_panel_nutrient_balance_\'|i18n}}"><div><canvas id="bar" class="chart chart-horizontal-bar" chart-data="vm.data" chart-labels="vm.labels" chart-update="updateC" chart-options="vm.chartOptions" chart-colors="vm.colors" ng-style="vm.chartStyle"></canvas></div><div align="center"><data-i18n i18n="_rations_x_axis_">+/- % of requested</data-i18n></div></div></div></div></div><div class="row"><div class="col-lg-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div ng-if="vm.ration.ration_header.ration_locale === 0" include-with-scope="app/pages/rations/balanceRation/rationsProtein/balanceRation.protein.requirementsUS.html"></div><div ng-if="vm.ration.ration_header.ration_locale === 1" include-with-scope="app/pages/rations/balanceRation/rationsProtein/balanceRation.protein.requirementsVemDve.html"></div></div></div></div></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_carb_\'|i18n}}" select="vm.activeTab = 5"><div ng-show="!vm.loadingTabs"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div ng-if="vm.rationTables.showCarb" element-loaded="vm.stopLoadingTabs()"><div class="row"><div class="col-xs-12"><div class="ration-feeds" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div ng-if="vm.ration.ration_header.ration_locale === 0" include-with-scope="app/pages/rations/balanceRation/rationsCarb/balanceRation.carbohydrateUS.html"></div><div ng-if="vm.ration.ration_header.ration_locale === 1" include-with-scope="app/pages/rations/balanceRation/rationsCarb/balanceRation.carbohydrateVemDve.html"></div></div></div><div ng-if="!vm.loadingTabs" class="ration-balance-graph-switch" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'" ng-click="vm.changeShowGraph()"><i class="ion-arrow-right-b" ng-if="vm.showGraph"></i> <i class="ion-arrow-left-b" ng-if="!vm.showGraph"></i></div><div class="ration-balance-graph" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-title="{{\'_rations_panel_nutrient_balance_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" ng-if="vm.showChart"><div><canvas id="bar" class="chart chart-horizontal-bar" chart-data="vm.data" chart-labels="vm.labels" chart-update="updateC" chart-options="vm.chartOptions" chart-colors="vm.colors" ng-style="vm.chartStyle"></canvas></div><div align="center"><data-i18n i18n="_rations_x_axis_">+/- % of requested</data-i18n></div></div></div></div></div><div class="row"><div class="col-lg-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div ng-if="vm.ration.ration_header.ration_locale === 0" include-with-scope="app/pages/rations/balanceRation/rationsCarb/balanceRation.carbohydrate.requirementsUS.html"></div><div ng-if="vm.ration.ration_header.ration_locale === 1" include-with-scope="app/pages/rations/balanceRation/rationsCarb/balanceRation.carbohydrate.requirementsVemDve.html"></div></div></div></div></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_lipid_\'|i18n}}" select="vm.activeTab = 6"><div ng-show="!vm.loadingTabs"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div ng-if="vm.rationTables.showLipid" element-loaded="vm.stopLoadingTabs()"><div class="row"><div class="col-xs-12"><div class="ration-feeds" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div ng-if="vm.ration.ration_header.ration_locale === 0" include-with-scope="app/pages/rations/balanceRation/rationsLipid/balanceRation.lipid.US.html"></div><div ng-if="vm.ration.ration_header.ration_locale === 1" include-with-scope="app/pages/rations/balanceRation/rationsLipid/balanceRation.lipid.VemDve.html"></div></div></div><div ng-if="!vm.loadingTabs" class="ration-balance-graph-switch" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'" ng-click="vm.changeShowGraph()"><i class="ion-arrow-right-b" ng-if="vm.showGraph"></i> <i class="ion-arrow-left-b" ng-if="!vm.showGraph"></i></div><div class="ration-balance-graph" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-title="{{\'_rations_panel_nutrient_balance_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" ng-if="vm.showChart"><div><canvas id="bar" class="chart chart-horizontal-bar" chart-data="vm.data" chart-labels="vm.labels" chart-update="updateC" chart-options="vm.chartOptions" chart-colors="vm.colors" ng-style="vm.chartStyle"></canvas></div><div align="center"><data-i18n i18n="_rations_x_axis_">+/- % of requested</data-i18n></div></div></div></div></div><div class="row"><div class="col-lg-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div ng-if="vm.ration.ration_header.ration_locale === 0" include-with-scope="app/pages/rations/balanceRation/rationsLipid/balanceRation.lipid.requirements.US.html"></div><div ng-if="vm.ration.ration_header.ration_locale === 1" include-with-scope="app/pages/rations/balanceRation/rationsLipid/balanceRation.lipid.requirements.VemDve.html"></div></div></div></div></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_mineral_\'|i18n}}" select="vm.activeTab = 7"><div ng-show="!vm.loadingTabs"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div ng-if="vm.rationTables.showMineral" element-loaded="vm.stopLoadingTabs()"><div class="row"><div class="col-xs-12"><div class="ration-feeds" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div include-with-scope="app/pages/rations/balanceRation/balanceRation.mineral.html"></div></div></div><div ng-if="!vm.loadingTabs" class="ration-balance-graph-switch" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'" ng-click="vm.changeShowGraph()"><i class="ion-arrow-right-b" ng-if="vm.showGraph"></i> <i class="ion-arrow-left-b" ng-if="!vm.showGraph"></i></div><div class="ration-balance-graph" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-title="{{\'_rations_panel_nutrient_balance_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" ng-if="vm.showChart"><div><canvas id="bar" class="chart chart-horizontal-bar" chart-data="vm.data" chart-labels="vm.labels" chart-update="updateC" chart-options="vm.chartOptions" chart-colors="vm.colors" ng-style="vm.chartStyle"></canvas></div><div align="center"><data-i18n i18n="_rations_x_axis_">+/- % of requested</data-i18n></div></div></div></div></div><div class="row"><div class="col-lg-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div include-with-scope="app/pages/rations/balanceRation/balanceRation.mineral.requirements.html"></div></div></div></div></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_trace_min_\'|i18n}}" select="vm.activeTab = 8"><div ng-show="!vm.loadingTabs"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div ng-if="vm.rationTables.showTMineral" element-loaded="vm.stopLoadingTabs()"><div class="row"><div class="col-xs-12"><div class="ration-feeds" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div include-with-scope="app/pages/rations/balanceRation/balanceRation.trace_min.html"></div></div></div><div ng-if="!vm.loadingTabs" class="ration-balance-graph-switch" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'" ng-click="vm.changeShowGraph()"><i class="ion-arrow-right-b" ng-if="vm.showGraph"></i> <i class="ion-arrow-left-b" ng-if="!vm.showGraph"></i></div><div class="ration-balance-graph" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-title="{{\'_rations_panel_nutrient_balance_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" ng-if="vm.showChart"><div><canvas id="bar" class="chart chart-horizontal-bar" chart-data="vm.data" chart-labels="vm.labels" chart-update="updateC" chart-options="vm.chartOptions" chart-colors="vm.colors" ng-style="vm.chartStyle"></canvas></div><div align="center"><data-i18n i18n="_rations_x_axis_">+/- % of requested</data-i18n></div></div></div></div></div><div class="row"><div class="col-lg-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div include-with-scope="app/pages/rations/balanceRation/balanceRation.trace_min.requirements.html"></div></div></div></div></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_vitamin_\'|i18n}}" select="vm.activeTab = 9"><div ng-show="!vm.loadingTabs"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div ng-if="vm.rationTables.showVitamin" element-loaded="vm.stopLoadingTabs()"><div class="row"><div class="col-xs-12"><div class="ration-feeds" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div include-with-scope="app/pages/rations/balanceRation/balanceRation.vitamin.html"></div></div></div><div ng-if="!vm.loadingTabs" class="ration-balance-graph-switch" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'" ng-click="vm.changeShowGraph()"><i class="ion-arrow-right-b" ng-if="vm.showGraph"></i> <i class="ion-arrow-left-b" ng-if="!vm.showGraph"></i></div><div class="ration-balance-graph" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-title="{{\'_rations_panel_nutrient_balance_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" ng-if="vm.showChart"><div><canvas id="bar" class="chart chart-horizontal-bar" chart-data="vm.data" chart-labels="vm.labels" chart-update="updateC" chart-options="vm.chartOptions" chart-colors="vm.colors" ng-style="vm.chartStyle"></canvas></div><div align="center"><data-i18n i18n="_rations_x_axis_">+/- % of requested</data-i18n></div></div></div></div></div><div class="row"><div class="col-lg-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div include-with-scope="app/pages/rations/balanceRation/balanceRation.vitamin.requirements.html"></div></div></div></div></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_amino_acid_\'|i18n}}" select="vm.activeTab = 10"><div ng-show="!vm.loadingTabs"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div ng-if="vm.rationTables.showAA" element-loaded="vm.stopLoadingTabs()"><div class="row"><div class="col-xs-12"><div class="ration-feeds" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div include-with-scope="app/pages/rations/balanceRation/balanceRation.amino_acid.html"></div></div></div><div ng-if="!vm.loadingTabs" class="ration-balance-graph-switch" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'" ng-click="vm.changeShowGraph()"><i class="ion-arrow-right-b" ng-if="vm.showGraph"></i> <i class="ion-arrow-left-b" ng-if="!vm.showGraph"></i></div><div class="ration-balance-graph" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-title="{{\'_rations_panel_nutrient_balance_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" ng-if="vm.showChart"><div><canvas id="bar" class="chart chart-horizontal-bar" chart-data="vm.data" chart-labels="vm.labels" chart-update="updateC" chart-options="vm.chartOptions" chart-colors="vm.colors" ng-style="vm.chartStyle"></canvas></div><div align="center"><data-i18n i18n="_rations_x_axis_">+/- % of requested</data-i18n></div></div></div></div></div><div class="row"><div class="col-lg-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div include-with-scope="app/pages/rations/balanceRation/balanceRation.amino_acid.requirements.html"></div></div></div></div></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_cost_\'|i18n}}" select="vm.activeTab = 11"><div ng-show="!vm.loadingTabs"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div ng-if="vm.rationTables.showCostTab" element-loaded="vm.stopLoadingTabs()"><div class="row"><div class="col-xs-12"><div class="ration-feeds" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div include-with-scope="app/pages/rations/balanceRation/balanceRation.cost.html"></div></div></div><div ng-if="!vm.loadingTabs" class="ration-balance-graph-switch" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'" ng-click="vm.changeShowGraph()"><i class="ion-arrow-right-b" ng-if="vm.showGraph"></i> <i class="ion-arrow-left-b" ng-if="!vm.showGraph"></i></div><div class="ration-balance-graph" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-title="{{\'_rations_panel_nutrient_balance_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" ng-if="vm.showChart"><div><canvas id="bar" class="chart chart-horizontal-bar" chart-data="vm.data" chart-labels="vm.labels" chart-update="updateC" chart-options="vm.chartOptions" chart-colors="vm.colors" ng-style="vm.chartStyle"></canvas></div><div align="center"><data-i18n i18n="_rations_x_axis_">+/- % of requested</data-i18n></div></div></div></div></div><div class="row"><div class="col-lg-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div include-with-scope="app/pages/rations/balanceRation/balanceRation.cost.requirements.html"></div></div></div></div></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_misc_\'|i18n}}" select="vm.activeTab = 12"><div ng-show="!vm.loadingTabs"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_feeds_selected_">Number of feeds selected</data-i18n>: {{vm.selectedList.length}}</span></div><div ng-if="vm.rationTables.showMisc" element-loaded="vm.stopLoadingTabs()"><div class="row"><div class="col-xs-12"><div class="ration-feeds" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div include-with-scope="app/pages/rations/balanceRation/balanceRation.misc.html"></div></div></div><div ng-if="!vm.loadingTabs" class="ration-balance-graph-switch" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'" ng-click="vm.changeShowGraph()"><i class="ion-arrow-right-b" ng-if="vm.showGraph"></i> <i class="ion-arrow-left-b" ng-if="!vm.showGraph"></i></div><div class="ration-balance-graph" ng-class="!vm.showGraph ? \'bg-collapsed\' : \'\'"><div ba-panel="" ba-panel-title="{{\'_rations_panel_nutrient_balance_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" ng-if="vm.showChart"><div><canvas id="bar" class="chart chart-horizontal-bar" chart-data="vm.data" chart-labels="vm.labels" chart-update="updateC" chart-options="vm.chartOptions" chart-colors="vm.colors" ng-style="vm.chartStyle"></canvas></div><div align="center"><data-i18n i18n="_rations_x_axis_">+/- % of requested</data-i18n></div></div></div></div></div><div class="row"><div class="col-lg-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div include-with-scope="app/pages/rations/balanceRation/balanceRation.misc.requirements.html"></div></div></div></div></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'tabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><li class="slider-wraper"><div><toggle-switch ng-model="vm.switchUseAmount" ng-change="vm.changeAmountProduct()" on-label="{{vm.amountSwitchLabel}}" off-label="{{vm.productSwitchLabel}}" class="switch-primary" style="width: 200px"></toggle-switch><toggle-switch ng-model="vm.sliderUsePercent" ng-change="vm.changeUnits()" on-label="%" off-label="g/{{vm.weight}}" knob-label="{{\'_report_unit_\' | i18n}}" class="switch-primary" style="width: 120px"></toggle-switch></div></li></uib-tabset></div><div ng-if="vm.loading" align="center" style="height: 150px; overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/balanceRation.trace_min.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="traceTable"><thead><tr class="sortable"><th style="height: 77px" class="editable-header" st-sort="feed_name"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="co" class="editable-header"><div uib-tooltip="{{\'_description_co_\' | i18n}}" tooltip-is-open="coIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_co_">Co</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th st-sort="cu" class="editable-header"><div uib-tooltip="{{\'_description_cu_\' | i18n}}" tooltip-is-open="cuIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cu_">Cu</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th st-sort="cu_abs" class="editable-header"><div uib-tooltip="{{\'_description_cu_abs_\' | i18n}}" tooltip-is-open="absCuIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cu_abs_">abs Cu</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cu_">Cu</data-i18n></div></th><th st-sort="fe" class="editable-header"><div uib-tooltip="{{\'_description_fe_\' | i18n}}" tooltip-is-open="feIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fe_">Fe</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th st-sort="fe_abs" class="editable-header"><div uib-tooltip="{{\'_description_fe_abs_\' | i18n}}" tooltip-is-open="absFeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fe_abs_">abs Fe</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fe_">Fe</data-i18n></div></th><th st-sort="i" class="editable-header"><div uib-tooltip="{{\'_description_i_\' | i18n}}" tooltip-is-open="iIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_i_">I</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th st-sort="i_abs" class="editable-header"><div uib-tooltip="{{\'_description_i_abs_\' | i18n}}" tooltip-is-open="absIIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_i_abs_">abs I</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_i_">I</data-i18n></div></th><th st-sort="mo" class="editable-header"><div uib-tooltip="{{\'_description_mo_\' | i18n}}" tooltip-is-open="moIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mo_">Mo</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th st-sort="mn" class="editable-header"><div uib-tooltip="{{\'_description_mn_\' | i18n}}" tooltip-is-open="mnIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mn_">Mn</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th st-sort="mn_abs" class="editable-header"><div uib-tooltip="{{\'_description_mn_abs_\' | i18n}}" tooltip-is-open="absMnIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mn_abs_">abs Mn</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_mn_">Mn</data-i18n></div></th><th st-sort="se" class="editable-header"><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th st-sort="se_abs" class="editable-header"><div uib-tooltip="{{\'_description_se_abs_\' | i18n}}" tooltip-is-open="absSeIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_abs_">abs Se</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_se_">Se</data-i18n></div></th><th st-sort="zn" class="editable-header"><div uib-tooltip="{{\'_description_zn_\' | i18n}}" tooltip-is-open="znIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_zn_">Zn</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th st-sort="zn_abs" class="editable-header"><div uib-tooltip="{{\'_description_zn_abs_\' | i18n}}" tooltip-is-open="absZnIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_zn_abs_">abs Zn</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_zn_">Zn</data-i18n></div></th></tr></thead><tbody id="traceBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="any" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="amount{{$index}}T">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.co" e-format-input-value="co" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'co\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="co{{$index}}T">{{feed.co | formatViewValues: \'co\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.cu" e-format-input-value="cu" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'cu\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="cu{{$index}}T">{{feed.cu | formatViewValues: \'cu\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.cu_abs" e-format-input-value="cu_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'cu_abs\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="cu_abs{{$index}}T">{{feed.cu_abs | formatViewValues: \'cu_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.fe" e-format-input-value="fe" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'fe\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="fe{{$index}}T">{{feed.fe | formatViewValues: \'fe\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.fe_abs" e-format-input-value="fe_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'fe_abs\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="fe_abs{{$index}}T">{{feed.fe_abs | formatViewValues: \'fe_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.i" e-format-input-value="i" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'i\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="i{{$index}}T">{{feed.i | formatViewValues: \'i\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.i_abs" e-format-input-value="i_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'i_abs\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="i_abs{{$index}}T">{{feed.i_abs | formatViewValues: \'i_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.mo" e-format-input-value="mo" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'mo\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="mo{{$index}}T">{{feed.mo | formatViewValues: \'mo\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.mn" e-format-input-value="mn" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'mn\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="mn{{$index}}T">{{feed.mn | formatViewValues: \'mn\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.mn_abs" e-format-input-value="mn_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'mn_abs\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="mn_abs{{$index}}T">{{feed.mn_abs | formatViewValues: \'mn_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.se" e-format-input-value="se" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'se\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="se{{$index}}T">{{feed.se | formatViewValues: \'se\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.se_abs" e-format-input-value="se_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'se_abs\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="se_abs{{$index}}T">{{feed.se_abs | formatViewValues: \'se_abs\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.zn" e-format-input-value="zn" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'zn\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="zn{{$index}}T">{{feed.zn | formatViewValues: \'zn\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.zn_abs" e-format-input-value="zn_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'zn_abs\', \'T\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="zn_abs{{$index}}T">{{feed.zn_abs | formatViewValues: \'zn_abs\'}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.amount" e-format-input-value="amount" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'T\', feed.id)" id="amountMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.co" e-format-input-value="co" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'co\', \'T\', feed.id)" id="coMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.co | formatViewValues: \'co\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.cu" e-format-input-value="cu" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'cu\', \'T\', feed.id)" id="cuMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cu | formatViewValues: \'cu\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.cu_abs" e-format-input-value="cu_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'cu_abs\', \'T\', feed.id)" id="cu_absMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cu_abs | formatViewValues: \'cu_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.fe" e-format-input-value="fe" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'fe\', \'T\', feed.id)" id="feMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.fe | formatViewValues: \'fe\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.fe_abs" e-format-input-value="fe_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'fe_abs\', \'T\', feed.id)" id="fe_absMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.fe_abs | formatViewValues: \'fe_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.i" e-format-input-value="i" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'i\', \'T\', feed.id)" id="iMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.i | formatViewValues: \'i\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.i_abs" e-format-input-value="i_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'i_abs\', \'T\', feed.id)" id="i_absMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.i_abs | formatViewValues: \'i_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.mo" e-format-input-value="mo" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'mo\', \'T\', feed.id)" id="moMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.mo | formatViewValues: \'mo\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.mn" e-format-input-value="mn" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'mn\', \'T\', feed.id)" id="mnMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.mn | formatViewValues: \'mn\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.mn_abs" e-format-input-value="mn_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'mn_abs\', \'T\', feed.id)" id="mn_absMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.mn_abs | formatViewValues: \'mn_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.se" e-format-input-value="se" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'se\', \'T\', feed.id)" id="seMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.se | formatViewValues: \'se\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.se_abs" e-format-input-value="se_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'se_abs\', \'T\', feed.id)" id="se_absMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.se_abs | formatViewValues: \'se_abs\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.zn" e-format-input-value="zn" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'zn\', \'T\', feed.id)" id="znMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.zn | formatViewValues: \'zn\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.zn_abs" e-format-input-value="zn_abs" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'zn_abs\', \'T\', feed.id)" id="zn_absMIX{{$index}}T{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.zn_abs | formatViewValues: \'zn_abs\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/balanceRation.trace_min.requirements.html','<div ng-if="!vm.loadingTabs" class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th></th><th><data-i18n i18n="_feeds_amount_">amount</data-i18n></th><th><data-i18n i18n="_feeds_co_">Co</data-i18n></th><th><data-i18n i18n="_feeds_cu_">Cu</data-i18n></th><th><data-i18n i18n="_feeds_cu_abs_">abs Cu</data-i18n></th><th><data-i18n i18n="_feeds_fe_">Fe</data-i18n></th><th><data-i18n i18n="_feeds_fe_abs_">abs Fe</data-i18n></th><th><data-i18n i18n="_feeds_i_">I</data-i18n></th><th><data-i18n i18n="_feeds_i_abs_">abs I</data-i18n></th><th><data-i18n i18n="_feeds_mo_">Mo</data-i18n></th><th><data-i18n i18n="_feeds_mn_">Mn</data-i18n></th><th><data-i18n i18n="_feeds_mg_abs_">abs Mn</data-i18n></th><th><data-i18n i18n="_feeds_se_">Se</data-i18n></th><th><data-i18n i18n="_feeds_se_abs_">abs Se</data-i18n></th><th><data-i18n i18n="_feeds_zn_">Zn</data-i18n></th><th><data-i18n i18n="_feeds_zn_abs_">abs Zn</data-i18n></th></tr></thead><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th><data-i18n i18n="_unit_ppm_">ppm</data-i18n></th><th><data-i18n i18n="_unit_ppm_">ppm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_cu_">Cu</data-i18n></th><th><data-i18n i18n="_unit_ppm_">ppm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_fe_">Fe</data-i18n></th><th><data-i18n i18n="_unit_ppm_">ppm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_i_">I</data-i18n></th><th><data-i18n i18n="_unit_ppm_">ppm</data-i18n></th><th><data-i18n i18n="_unit_ppm_">ppm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_mn_">Mn</data-i18n></th><th><data-i18n i18n="_unit_ppm_">ppm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_se_">Se</data-i18n></th><th><data-i18n i18n="_unit_ppm_">ppm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_zn_">Zn</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n class="nowrap" i18n="_rations_concentration_supplied_">Concentration supplied</data-i18n></td><td>{{vm.ration.concentration_supplied.amount_dm | formatViewValuesSignificant: \'amount\'}}</td><td>{{vm.ration.concentration_supplied.co | formatViewValuesSignificant: \'co\'}}</td><td>{{vm.ration.concentration_supplied.cu | formatViewValuesSignificant: \'cu\'}}</td><td>{{vm.ration.concentration_supplied.cu_abs | formatViewValuesSignificant: \'cu_abs\'}}</td><td>{{vm.ration.concentration_supplied.fe | formatViewValuesSignificant: \'fe\'}}</td><td>{{vm.ration.concentration_supplied.fe_abs | formatViewValuesSignificant: \'fe_abs\'}}</td><td>{{vm.ration.concentration_supplied.i | formatViewValuesSignificant: \'i\'}}</td><td>{{vm.ration.concentration_supplied.i_abs | formatViewValuesSignificant: \'i_abs\'}}</td><td>{{vm.ration.concentration_supplied.mo | formatViewValuesSignificant: \'mo\'}}</td><td>{{vm.ration.concentration_supplied.mn | formatViewValuesSignificant: \'mn\'}}</td><td>{{vm.ration.concentration_supplied.mn_abs | formatViewValuesSignificant: \'mn_abs\'}}</td><td>{{vm.ration.concentration_supplied.se | formatViewValuesSignificant: \'se\'}}</td><td>{{vm.ration.concentration_supplied.se_abs | formatViewValuesSignificant: \'se_abs\'}}</td><td>{{vm.ration.concentration_supplied.zn | formatViewValuesSignificant: \'zn\'}}</td><td>{{vm.ration.concentration_supplied.zn_abs | formatViewValuesSignificant: \'zn_abs\'}}</td></tr></tbody><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n i18n="_rations_supply_">Supply</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.supply.co | formatViewValuesPerDay: \'co\'}}</td><td>{{vm.ration.supply.cu | formatViewValuesPerDay: \'cu\'}}</td><td>{{vm.ration.supply.cu_abs | formatViewValuesPerDay: \'cu_abs\'}}</td><td>{{vm.ration.supply.fe | formatViewValuesPerDay: \'fe\'}}</td><td>{{vm.ration.supply.fe_abs | formatViewValuesPerDay: \'fe_abs\'}}</td><td>{{vm.ration.supply.i | formatViewValuesPerDay: \'i\'}}</td><td>{{vm.ration.supply.i_abs | formatViewValuesPerDay: \'i_abs\'}}</td><td>{{vm.ration.supply.mo | formatViewValuesPerDay: \'mo\'}}</td><td>{{vm.ration.supply.mn | formatViewValuesPerDay: \'mn\'}}</td><td>{{vm.ration.supply.mn_abs | formatViewValuesPerDay: \'mn_abs\'}}</td><td>{{vm.ration.supply.se | formatViewValuesPerDay: \'se\'}}</td><td>{{vm.ration.supply.se_abs | formatViewValuesPerDay: \'se_abs\'}}</td><td>{{vm.ration.supply.zn | formatViewValuesPerDay: \'zn\'}}</td><td>{{vm.ration.supply.zn_abs | formatViewValuesPerDay: \'zn_abs\'}}</td></tr><tr><td><data-i18n i18n="_rations_requirements_">Requirements</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.requirements.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.requirements.co | formatViewValuesPerDay: \'co\'}}</td><td>{{vm.ration.requirements.cu | formatViewValuesPerDay: \'cu\'}}</td><td>{{vm.ration.requirements.cu_abs | formatViewValuesPerDay: \'cu_abs\'}}</td><td>{{vm.ration.requirements.fe | formatViewValuesPerDay: \'fe\'}}</td><td>{{vm.ration.requirements.fe_abs | formatViewValuesPerDay: \'fe_abs\'}}</td><td>{{vm.ration.requirements.i | formatViewValuesPerDay: \'i\'}}</td><td>{{vm.ration.requirements.i_abs | formatViewValuesPerDay: \'i_abs\'}}</td><td></td><td>{{vm.ration.requirements.mn | formatViewValuesPerDay: \'mn\'}}</td><td>{{vm.ration.requirements.mn_abs | formatViewValuesPerDay: \'mn_abs\'}}</td><td>{{vm.ration.requirements.se | formatViewValuesPerDay: \'se\'}}</td><td>{{vm.ration.requirements.se_abs | formatViewValuesPerDay: \'se_abs\'}}</td><td>{{vm.ration.requirements.zn | formatViewValuesPerDay: \'zn\'}}</td><td>{{vm.ration.requirements.zn_abs | formatViewValuesPerDay: \'zn_abs\'}}</td></tr><tr class="ration-difference"><td><data-i18n i18n="_rations_difference_">Difference</data-i18n></td><td><span ng-class="vm.ration.difference.amount_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.amount_dm | formatViewValuesPerDay: \'amount\'}}</span></td><td><span ng-class="vm.ration.difference.co >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.co | formatViewValuesPerDay: \'co\'}}</span></td><td><span ng-class="vm.ration.difference.cu >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.cu | formatViewValuesPerDay: \'cu\'}}</span></td><td><span ng-class="vm.ration.difference.cu_abs >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.cu_abs | formatViewValuesPerDay: \'cu_abs\'}}</span></td><td><span ng-class="vm.ration.difference.fe >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.fe | formatViewValuesPerDay: \'fe\'}}</span></td><td><span ng-class="vm.ration.difference.fe_abs >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.fe_abs | formatViewValuesPerDay: \'fe_abs\'}}</span></td><td><span ng-class="vm.ration.difference.i >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.i | formatViewValuesPerDay: \'i\'}}</span></td><td><span ng-class="vm.ration.difference.i_abs >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.i_abs | formatViewValuesPerDay: \'i_abs\'}}</span></td><td></td><td><span ng-class="vm.ration.difference.mn >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.mn | formatViewValuesPerDay: \'mn\'}}</span></td><td><span ng-class="vm.ration.difference.mn_abs >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.mn_abs | formatViewValuesPerDay: \'mn_abs\'}}</span></td><td><span ng-class="vm.ration.difference.se >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.se | formatViewValuesPerDay: \'se\'}}</span></td><td><span ng-class="vm.ration.difference.se_abs >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.se_abs | formatViewValuesPerDay: \'se_abs\'}}</span></td><td><span ng-class="vm.ration.difference.zn >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.zn | formatViewValuesPerDay: \'zn\'}}</span></td><td><span ng-class="vm.ration.difference.zn_abs >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.zn_abs | formatViewValuesPerDay: \'zn_abs\'}}</span></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/balanceRation.vitamin.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="vitaminTable"><thead><tr class="sortable" id="vitaminTr"><th style="height: 77px" class="editable-header" st-sort="feed_name"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="vitamin_a" class="editable-header"><div uib-tooltip="{{\'_description_vitamin_a_\' | i18n}}" tooltip-is-open="vitAIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_a_">vit a</data-i18n><br><data-i18n i18n="_unit_iu_k_">IU</data-i18n>/{{vm.weight}}</div></th><th st-sort="vitamin_d" class="editable-header"><div uib-tooltip="{{\'_description_vitamin_d_\' | i18n}}" tooltip-is-open="vitDIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_d_">vit d</data-i18n><br><data-i18n i18n="_unit_iu_k_">IU</data-i18n>/{{vm.weight}}</div></th><th st-sort="vitamin_e" class="editable-header"><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th></tr></thead><tbody id="vitaminBody"><tr class="editable-tr-wrap" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'" ng-cloak="" ng-repeat-start="(indexX, feed) in vm.ration.feeds"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="any" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'V\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="amount{{$index}}V">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="1" editable-number="feed.vitamin_a" e-format-input-value="vitamin_a" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'vitamin_a\', \'V\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="vitamin_a{{$index}}V">{{feed.vitamin_a | formatViewValues: \'vitamin_a\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="1" editable-number="feed.vitamin_d" e-format-input-value="vitamin_d" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'vitamin_d\', \'V\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="vitamin_d{{$index}}V">{{feed.vitamin_d | formatViewValues: \'vitamin_d\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="1" editable-number="feed.vitamin_e" e-format-input-value="vitamin_e" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'vitamin_e\', \'V\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="vitamin_e{{$index}}V">{{feed.vitamin_e | formatViewValues: \'vitamin_e\'}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.amount" e-format-input-value="amount" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'V\', feed.id)" id="amountMIX{{$index}}V{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.vitamin_a" e-format-input-value="vitamin_a" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'vitamin_a\', \'V\', feed.id)" id="vitamin_aMIX{{$index}}V{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.vitamin_a | formatViewValues: \'vitamin_a\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.vitamin_d" e-format-input-value="vitamin_d" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'vitamin_d\', \'V\', feed.id)" id="vitamin_dMIX{{$index}}V{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.vitamin_d | formatViewValues: \'vitamin_d\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.vitamin_e" e-format-input-value="vitamin_e" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'vitamin_e\', \'V\', feed.id)" id="vitamin_eMIX{{$index}}V{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.vitamin_e | formatViewValues: \'vitamin_e\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/balanceRation.vitamin.requirements.html','<div ng-if="!vm.loadingTabs" class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th></th><th><data-i18n i18n="_feeds_amount_">amount</data-i18n></th><th><data-i18n i18n="_feeds_vit_a_">vit a</data-i18n></th><th><data-i18n i18n="_feeds_vit_d_">vit d</data-i18n></th><th><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n></th></tr></thead><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th><data-i18n i18n="_unit_iu_k_">IU</data-i18n>/{{vm.weight}}</th><th><data-i18n i18n="_unit_iu_k_">IU</data-i18n>/{{vm.weight}}</th><th><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</th></tr></tbody><tbody><tr><td><data-i18n class="nowrap" i18n="_rations_concentration_supplied_">Concentration supplied</data-i18n></td><td>{{vm.ration.concentration_supplied.amount_dm | formatViewValuesSignificant: \'amount\'}}</td><td>{{vm.ration.concentration_supplied.vitamin_a | formatViewValuesSignificant: \'vitamin_a\'}}</td><td>{{vm.ration.concentration_supplied.vitamin_d | formatViewValuesSignificant: \'vitamin_d\'}}</td><td>{{vm.ration.concentration_supplied.vitamin_e | formatViewValuesSignificant: \'vitamin_e\'}}</td></tr></tbody><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_iu_k_">kIU</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_iu_k_">kIU</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_iu_">IU</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n i18n="_rations_supply_">Supply</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.supply.vitamin_a | formatViewValuesPerDay: \'vitamin_a\'}}</td><td>{{vm.ration.supply.vitamin_d | formatViewValuesPerDay: \'vitamin_d\'}}</td><td>{{vm.ration.supply.vitamin_e | formatViewValuesPerDay: \'vitamin_e\'}}</td></tr><tr><td><data-i18n i18n="_rations_requirements_">Requirements</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.requirements.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.requirements.vitamin_a | formatViewValuesPerDay: \'vitamin_a\'}}</td><td>{{vm.ration.requirements.vitamin_d | formatViewValuesPerDay: \'vitamin_d\'}}</td><td>{{vm.ration.requirements.vitamin_e | formatViewValuesPerDay: \'vitamin_e\'}}</td></tr><tr class="ration-difference"><td><data-i18n i18n="_rations_difference_">Difference</data-i18n></td><td><span ng-class="vm.ration.difference.amount_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.amount_dm | formatViewValuesPerDay: \'amount\'}}</span></td><td><span ng-class="vm.ration.difference.vitamin_a >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.vitamin_a | formatViewValuesPerDay: \'vitamin_a\'}}</span></td><td><span ng-class="vm.ration.difference.vitamin_d >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.vitamin_d | formatViewValuesPerDay: \'vitamin_d\'}}</span></td><td><span ng-class="vm.ration.difference.vitamin_e >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.vitamin_e | formatViewValuesPerDay: \'vitamin_e\'}}</span></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/editManualRation/editManualRation.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/editManualRation/editManualRation.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/editManualRation/editManualRation.panel.html','<div ng-if="vm.selectedTeam && vm.selectedHerd"><div ng-if="!vm.loading"><h3 class="with-line"><data-i18n i18n="_ration_informations_label_">Ration informations</data-i18n></h3><form name="vm.rationInfo"><div class="row"><div class="col-md-4 manual-ration-name-container"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.rationInfo.ration_name.$invalid && (vm.rationInfo.ration_name.$dirty || vm.rationInfo.$submitted)}"><label for="ration_name"><data-i18n i18n="_rations_ration_name_">ration name</data-i18n></label> <input select-on-click="" type="text" maxlength="60" class="form-control" id="ration_name" name="ration_name" placeholder="{{\'_rations_ration_name_\' | i18n}}" ng-model="vm.ration.ration_name" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_rations_ration_name_required_">ration name is required</data-i18n></span></div><div ng-if="vm.usedRecipesList && vm.usedRecipesList.length > 0"><info-popover title="{{\'_m_f_title_recipe_ration_list_\' | i18n}}" subtitle="{{\'_m_f_subtitle_recipe_ration_list_\' | i18n}}" items="vm.usedRecipesList" loading="vm.popoverLoading" size="large"></info-popover></div></div></div><div class="basis-info"><div class="form-group basis-info-item manual-ration-basis-info-item"><label><data-i18n i18n="_m_f_recipe_total_kg_dm_">Total kg DM</data-i18n>&nbsp;({{vm.weight}})</label><div><span>{{vm.ration.amount_dm | formatViewValues: \'amount\' | defaultReturnValue: \'-\'}}</span>&nbsp;<span ng-if="vm.ration.amount_dm">{{vm.weight}}</span></div></div><div class="form-group basis-info-item manual-ration-basis-info-item"><label><data-i18n i18n="_m_f_recipe_total_kg_as_fed_">Total kg DM</data-i18n>&nbsp;({{vm.weight}})</label><div><span>{{vm.ration.amount_as_fed | formatViewValues: \'amount\' | defaultReturnValue: \'-\'}}</span>&nbsp;<span ng-if="vm.ration.amount_as_fed">{{vm.weight}}</span></div></div><div class="form-group basis-info-item manual-ration-basis-info-item"><label><data-i18n i18n="_feeds_dm_">dm</data-i18n>&nbsp;(%)</label><div><span>{{vm.ration.dm | formatViewValues: \'percentage\' | defaultReturnValue: \'-\'}}</span>&nbsp;<span ng-if="vm.ration.dm">%</span></div></div><div class="form-group basis-info-item manual-ration-basis-info-item"><label><data-i18n i18n="_m_f_total_ration_cost_">Total ration cost</data-i18n>&nbsp;({{vm.currency}})</label><div><span>{{vm.ration.cost_dm | formatViewValues: \'cost_dm\' | defaultReturnValue: \'-\'}}</span>&nbsp;<span ng-if="vm.ration.cost_dm != null">{{vm.currency}}</span></div></div></div></form><div class="feeds-line-separator"><h3><data-i18n i18n="_menu_feeds_">Feeds</data-i18n></h3><span><button type="button" class="btn btn-primary btn-xs" ng-click="vm.openFeedsModal()"><i class="fa fa-plus"></i></button></span></div><hr><div class="horizontal-scroll manual-ration-table" ng-class="vm.ration.amount_dm > vm.maxAmount ? \'has-warning\' : \'\'"><table class="table rations_table"><thead><tr><th><data-i18n i18n="_title_column_action_">action</data-i18n></th><th><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br></th><th><data-i18n i18n="_feeds_type_">Feed type</data-i18n><br></th><th><data-i18n i18n="_feeds_dm_">dm</data-i18n><br>%&nbsp;</th><th><data-i18n i18n="_feeds_amount_">Amount DM</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_cost_dm_">Cost DM</data-i18n><br>{{vm.currency}}/{{vm.weight}}<span>&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th><th><data-i18n i18n="_feeds_cost_as_fed_">Cost as fed</data-i18n><br>{{vm.currency}}/{{vm.weight}}<span>&nbsp;<data-i18n i18n="_feeds_as_fed_">as fed</data-i18n></span></th><th></th></tr></thead><tbody ui-sortable="{ \'ui-floating\': true, \'disabled\': vm.ration.ration_feeds.length < 2, axis: \'y\', placeholder: \'drop-zone\' }" ng-model="vm.ration.ration_feeds" ng-class="vm.ration.ration_feeds.length >= 2 ? \'manual-ration-table-sortable\' : \'\'"><tr ng-repeat="feed in vm.ration.ration_feeds" ng-if="feed.visible"><td><button class="btn btn-xs btn-primary" ng-click="vm.goToHistory(feed.id)"><i class="ion-clock"></i></button></td><td style="min-width: 200px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span editable-text="feed.feed_name" e-required="" e-maxlength="60" e-style="width: 150px" id="feed_name_{{$index}}" e-ng-keydown="vm.inputKeyPress($event)">{{feed.feed_name}}</span></td><td style="min-width: 200px"><a ng-class="{\'color-red\' : feed.feed_type.show_name == \'_feeds_type_not_set_\'}" href="#" editable-select="feed.feed_type" e-required="" e-style="width: 150px" e-ng-options="feed_type as feed_type.translated for feed_type in vm.feedTypes">{{feed.feed_type.translated}}</a></td><td style="min-width: 110px"><span editable-number="feed.dm" e-format-input-value="percentage" e-required="" e-step="0.01" e-min="0.01" e-max="100" e-style="width: 100px" onaftersave="vm.updateFeed(feed, $data, \'dm\')" id="dm_{{$index}}" e-ng-keydown="vm.inputKeyPress($event)">{{feed.dm | formatViewValues: \'percentage\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.amount_dm" e-format-input-value="amount" e-required="" e-step="0.01" e-min="0" e-style="width: 100px" onaftersave="vm.updateFeed(feed, $data, \'amount_dm\')" id="amount_dm_{{$index}}" e-ng-keydown="vm.inputKeyPress($event)">{{feed.amount_dm | formatViewValues: \'amount\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.amount_as_fed" e-format-input-value="as_fed" e-required="" e-step="0.01" e-min="0" e-style="width: 100px" onaftersave="vm.updateFeed(feed, $data, \'amount_as_fed\')" id="amount_as_fed_{{$index}}" e-ng-keydown="vm.inputKeyPress($event)">{{feed.amount_as_fed | formatViewValues: \'as_fed\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.cost_dm" e-format-input-value="cost_dm" e-step="0.001" e-min="0" e-style="width: 100px" onaftersave="vm.updateFeed(feed, $data, \'cost_dm\')" id="cost_dm_{{$index}}" e-ng-keydown="vm.inputKeyPress($event)">{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.cost_as_fed" e-format-input-value="cost_dm" e-step="0.001" e-min="0" e-style="width: 100px" onaftersave="vm.updateFeed(feed, $data, \'cost_as_fed\')" id="cost_as_fed_{{$index}}" e-ng-keydown="vm.inputKeyPress($event)">{{feed.cost_as_fed | formatViewValues: \'cost_dm\'}}</span></td><td style="min-width: 100px" class="manual-feeds-table-action"><button type="button" class="btn btn-danger btn-xs" ng-click="vm.removeFeed(feed)"><i class="fa fa-trash"></i></button></td></tr><tr ng-form="" name="vm.newManualRationForm" class="manual-feeds-table-row"><td></td><td><div class="form-group has-feedback manual-feed-name-column" ng-class="{\'has-error\': vm.newManualRationForm.feed_name.$invalid && (vm.newManualRationForm.feed_name.$dirty || vm.newManualRationForm.$submitted)}"><input type="text" ng-model="vm.feedFromApi" uib-typeahead="feed as feed.feed_name for feed in vm.getFeedByName($viewValue)" typeahead-on-select="vm.feedSelected($item)" typeahead-loading="vm.loadingFeedByName" typeahead-append-to-body="true" typeahead-no-results="vm.noResults" class="form-control" id="feed_name" name="feed_name" required=""><div class="manual-feed-name-search-icons"><span ng-show="vm.loadingFeedByName"><i class="fa fa-spinner"></i><data-i18n i18n="_title_loading_">Loading...</data-i18n></span> <span ng-show="vm.noResults"><i class="fa fa-times text-danger"></i> No Results Found</span></div><span class="help-block error-block basic-block"><data-i18n i18n="_toastr_feeds_name_required_">Feed name is required</data-i18n></span></div></td><td><div class="form-group manual-feed-type-column" ng-class="{\'has-error\': vm.newManualRationForm.feed_type.$invalid && vm.newManualRationForm.$submitted}"><ui-select ng-model="vm.newFeed.feed_type" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" required="" id="feed_type" name="feed_type" ng-change="vm.feedTypeSelected()"><ui-select-match placeholder="{{\'_picker_feed_type_placeholder_\'|i18n}}" uib-tooltip="{{$select.selected.translated}}" tooltip-enable="{{$select.selected.translated.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{$select.selected.translated}}</ui-select-match><ui-select-choices repeat="feedType in vm.feedTypes | filter: $select.search"><span class="shorten-long-text" ng-bind-html="feedType.translated"></span></ui-select-choices></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_toastr_feeds_type_required_">Feed type is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newManualRationForm.dm.$invalid && (vm.newManualRationForm.dm.$dirty || vm.newManualRationForm.$submitted)}"><input select-on-click="" type="number" class="form-control" required="" id="dm" name="dm" ng-pattern="/^([0-9]?)+(\\.[0-9]{1,2})?$/" ng-model="vm.newFeed.dm" format-input-value="percentage" default-return-value="null" min="0.01" max="100" step="0.01" ng-change="vm.updateNewFeed(\'dm\')"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_label_dm_required_">DM is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newManualRationForm.amount_dm.$invalid && (vm.newManualRationForm.amount_dm.$dirty || vm.newManualRationForm.$submitted)}"><input select-on-click="" type="number" class="form-control" required="" id="amount_dm" name="amount_dm" ng-pattern="/^([0-9]?)+(\\.[0-9]{1,2})?$/" ng-model="vm.newFeed.amount_dm" format-input-value="amount" default-return-value="null" min="0" step="0.01" ng-change="vm.updateNewFeed(\'amount_dm\')"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_amount_dm_required_">Amount DM is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newManualRationForm.amount_as_fed.$invalid && (vm.newManualRationForm.amount_as_fed.$dirty || vm.newManualRationForm.$submitted)}"><input select-on-click="" type="number" class="form-control" required="" id="amount_as_fed" name="amount_as_fed" ng-pattern="/^([0-9]?)+(\\.[0-9]{1,2})?$/" ng-model="vm.newFeed.amount_as_fed" format-input-value="as_fed" default-return-value="null" min="0" step="0.01" ng-change="vm.updateNewFeed(\'amount_as_fed\')"> <span class="help-block error-block basic-block"><data-i18n i18n="_feeds_as_fed_required_">As fed is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newManualRationForm.cost_dm.$invalid && (vm.newManualRationForm.cost_dm.$dirty || vm.newManualRationForm.$submitted)}"><input select-on-click="" type="number" class="form-control" id="cost_dm" name="cost_dm" ng-pattern="/^([0-9]?)+(\\.[0-9]{1,3})?$/" ng-model="vm.newFeed.cost_dm" format-input-value="cost_dm" default-return-value="null" min="0" step="0.01" ng-change="vm.updateNewFeed(\'cost_dm\')"></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.newManualRationForm.cost_as_fed.$invalid && (vm.newManualRationForm.cost_as_fed.$dirty || vm.newManualRationForm.$submitted)}"><input select-on-click="" type="number" class="form-control" ng-pattern="/^([0-9]?)+(\\.[0-9]{1,3})?$/" id="cost_as_fed" name="cost_as_fed" ng-model="vm.newFeed.cost_as_fed" format-input-value="cost_dm" default-return-value="null" min="0" step="0.01" ng-change="vm.updateNewFeed(\'cost_as_fed\')"></div></td><td style="width: 100px" class="manual-feeds-table-action"><button type="button" ng-disabled="vm.disableAddFeed" class="btn btn-primary btn-xs" ng-click="vm.addNewFeed()"><i class="fa fa-check"></i></button></td></tr></tbody></table></div><div ng-if="vm.ration.amount_dm > vm.maxAmount" class="manual-raton-warning-message"><data-i18n i18n="_m_f_dmi_exceeded_message_">Daily DMI should not exceed</data-i18n>&nbsp;{{vm.maxAmount | formatViewValues: \'amount\'}}{{vm.weight}}</div><div align="right" class="manual-ration-button-container"><div class="btn-group" uib-dropdown=""><button type="button" class="btn btn-success" ng-disabled="vm.rationInfo.$invalid || !vm.ration.ration_feeds.length" uib-dropdown-toggle=""><data-i18n i18n="_btn_save_">save</data-i18n>&nbsp;<i class="fa fa-caret-up"></i></button><ul uib-dropdown-menu="" class="dropdown-menu manual-ration-dropdown-menu"><li ng-if="!vm.disableSave"><a href="" ng-click="vm.saveRation()"><data-i18n i18n="_btn_save_">save</data-i18n></a></li><li><a href="" ng-click="vm.openSaveAsModal()"><data-i18n i18n="_btn_save_as_">save as</data-i18n></a></li></ul></div><button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><div align="right"><span ng-if="vm.disableSave" class="info-note">*{{\'_m_f_external_ration_disabled_save_note_\' | i18n}}</span></div></div><loading-spinner-large ng-if="vm.loading"></loading-spinner-large></div><div ng-if="!vm.selectedTeam" align="center"><div><h3><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></h3></div></div><div ng-if="!vm.selectedHerd && vm.selectedTeam" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div>');
$templateCache.put('app/pages/rations/editManualRation/insertFeed.modal.html','<div ba-panel="" class="ng-cloak" ng-if="!vm.modalLoading"><div class="panel-group"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="btn-group"><button type="button" class="btn btn-primary no-border-radius" ng-click="vm.addAll()"><data-i18n i18n="_btn_feed_add_all_">Add all</data-i18n></button> <button type="button" class="btn btn-danger no-border-radius" ng-click="vm.closeModal()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><div ba-panel="" ba-panel-title="{{\'_feeds_imort_feeds_panel_available_feeds_\'|i18n}}" ba-panel-class="with-scroll xmedium-panel"><div include-with-scope="app/pages/rations/editManualRation/insertFeed.sourceTable.html"></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="btn-group"><button type="button" class="btn btn-primary no-border-radius" ng-click="vm.insertFeeds()"><data-i18n i18n="_btn_feed_insert_">insert</data-i18n></button> <button type="button" class="btn btn-danger no-border-radius" ng-click="vm.removeAll()"><data-i18n i18n="_btn_feed_remove_all_">Remove all</data-i18n></button></div><div ba-panel="" ba-panel-title="{{\'_feeds_insert_feeds_panel_feeds_insert_\'|i18n}}" ba-panel-class="with-scroll xmedium-panel"><div include-with-scope="app/pages/rations/editManualRation/insertFeed.table.html"></div></div></div></div></div></div><loading-spinner-large ng-if="vm.modalLoading"></loading-spinner-large>');
$templateCache.put('app/pages/rations/editManualRation/insertFeed.sourceTable.html','<div class="vertical-scroll add-manual-feed-to-ration-table-wrapper"><table class="table"><thead><tr><th></th><th><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br><br></th><th><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></th><th><data-i18n i18n="_feeds_amount_">Amount</data-i18n><br><span>{{vm.weight}}</span></th><th><data-i18n i18n="_feeds_cost_dm_">Cost dm</data-i18n><br><span>{{vm.currency}}/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds" ng-click="vm.addSelected(feed)" ng-show="feed.displayed"><td><button type="button" class="btn btn-primary btn-xs"><i class="ion-plus-round"></i></button></td><td>{{feed.feed_name}}</td><td>{{feed.dm | formatViewValues: \'percentage\'}}</td><td>{{feed.amount_dm | formatViewValues: \'amount\'}}</td><td>{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</td></tr><tr ng-hide="vm.hideLoadMoreButton"><td colspan="5"><button class="btn btn-md btn-primary load-more-manual-feeds-btn" ng-click="vm.loadMoreFeeds()" ng-disabled="vm.loadingFeeds" ng-class="vm.loadingFeeds ? \'disabled-background\' : \'\'"><span ng-show="!vm.loadingFeeds"><data-i18n i18n="_m_f_title_load_more_">Load more</data-i18n></span><loading-spinner ng-show="vm.loadingFeeds"></loading-spinner></button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/editManualRation/insertFeed.table.html','<div class="vertical-scroll add-manual-feed-to-ration-table-wrapper"><table class="table"><thead><tr><th></th><th><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br><br></th><th><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span></th><th><data-i18n i18n="_feeds_amount_">Amount</data-i18n><br><span>{{vm.weight}}</span></th><th><data-i18n i18n="_feeds_cost_dm_">Cost dm</data-i18n><br><span>{{vm.currency}}/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th></tr></thead><tbody><tr ng-click="vm.removeSelected(feed)" ng-repeat="feed in vm.importList track by feed.id"><td><button type="button" class="btn btn-danger btn-xs"><i class="ion-minus-round"></i></button></td><td>{{feed.feed_name}}</td><td>{{feed.dm | formatViewValues: \'percentage\'}}</td><td>{{feed.amount_dm | formatViewValues: \'amount\'}}</td><td>{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/editManualRation/saveAs.modal.html','<div class="modal-content" ng-cloak=""><div class="modal-body"><div ng-if="!vm.saveAsModalLoading"><form name="vm.groupInfo" novalidate=""><div class="panel"><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.groupInfo.rationNameSaveAs.$invalid && (vm.groupInfo.rationNameSaveAs.$dirty || vm.groupInfo.$submitted)}"><label for="rationName" class="span-label"><data-i18n i18n="_rations_ration_name_">Group name</data-i18n></label> <input type="text" class="form-control" id="groupName" name="rationNameSaveAs" placeholder="{{\'_rations_ration_name_\' | i18n}}" ng-model="vm.rationNameSaveAs" required="" select-on-click="" maxlength="60"> <span class="help-block error-block basic-block"><data-i18n i18n="_rations_ration_name_required_">ration name is reqired</data-i18n></span></div></div></div><div ng-if="vm.showInfoMessage" class="color-warning" style="padding: 10px;"><data-i18n i18n="_m_f_warning_third_party_save_as_">You are going to create a copy of a third-party ration. Be aware that the ration\'s copy can\'t be traced in the third-party app.</data-i18n></div><div align="right"><button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.closeModal()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button> <button type="submit" class="btn btn-info btn-with-icon save-profile" ng-click="vm.saveRation(true)"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></form></div><div style="height: 200px" ng-if="vm.saveAsModalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/importRation/importRation.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/importRation/importRation.table.html"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/importRation/importRation.modal.html','<div class="modal-content" ng-if="!vm.uploading"><div class="modal-header"><div align="center"><span class="secondaryText"><data-i18n i18n="_rations_import_upload_select_ration_">Select ration file to upload</data-i18n></span></div></div><div class="modal-body" align="center"><form name="form"><div><a class="ion-upload primaryModal" uib-tooltip="{{\'_btn_select_file_\' | i18n}}" tooltip-append-to-body="true" tooltip-is-open="sdrt" tooltip-placement="top" tooltip-class="customBlue top" tooltip-popup-delay="500" style="font-size: 55px" ngf-select="" ng-model="vm.file" name="file" ngf-pattern="\'.sdrt\'" ngf-accept="\'.sdrt\'" ngf-max-size="10MB" ngf-change="vm.uploadChanged()"></a></div></form><div><span>{{vm.fileSelected}}</span></div><div class="form-group"><div align="center"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-disabled="!vm.file" ng-click="vm.upload()"><data-i18n i18n="_btn_upload_">upload</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'redirect_modal\')"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div></div><div ng-if="vm.uploading" align="center" style="overflow: hidden; height: 140px;"><div><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/rations/importRation/importRation.table.html','<div class="row" ng-if="!vm.loadingDbs"><div class="col-sm-6"></div><div class="col-sm-6" align="right"><button type="button" class="btn btn-primary" ng-click="vm.openUploadModal(\'app/pages/rations/importRation/importRation.modal.html\', \'sm\')" uib-tooltip="{{\'_spar_upload_db_btn_\' | i18n}}" tooltip-is-open="upload_feed" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_btn_upload_">upload</data-i18n></button></div></div><div class="horizontal-scroll" ng-if="!vm.loadingDbs"><table class="table table-hover" st-table="vm.herds" st-safe-src="vm.herdsSafe"><thead><tr class="sortable"><th st-sort="file_name"><data-i18n i18n="_title_file_name_">file name</data-i18n></th><th st-sort="upload_date"><data-i18n i18n="_title_upload_date_">upload date</data-i18n></th><th></th></tr></thead><tbody ng-if="!vm.loadingTable"><tr ng-repeat="db in vm.dbs" ng-if="vm.hasFiles"><td style="height: 30px">{{db.file_name}}</td><td style="height: 30px">{{db.upload_date | date: vm.date_format}}</td><td style="height: 30px"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.redirectTo(db.file_uuid)" uib-tooltip="{{\'_spar_import_ration_btn_\' | i18n}}" tooltip-is-open="feed_import" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_btn_create_ration_">create</data-i18n></button></td></tr><tr ng-if="!vm.hasFiles"><td colspan="3">{{\'_feeds_import_feeds_spartan3_no_files_message_\'|i18n}}</td></tr></tbody></table></div><div ng-if="vm.loadingDbs || vm.loadingTable" align="center"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/rations/manualRationFeedHistory/manualRationFeedHistory.html','<div><div ng-if="!vm.loading && vm.selectedHerd" class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div ng-include="\'app/pages/feeds/manualFeedHistory/manualFeedsHistory.table.html\'"></div></div></div></div><div ng-if="vm.loading" class="row" ba-panel=""><div class="col-lg-12 col-md-12"><div style="height: 200px; overflow: hidden" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div><div ng-if="!vm.loading && !vm.selectedHerd" align="center" ba-panel=""><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div>');
$templateCache.put('app/pages/rations/manualRationFeedHistory/manualRationFeedHistory.table.html','<div ng-if="!vm.loadingTable"><button class="btn btn-primary btn-xs" ng-click="vm.back()" style="margin: 5px"><i class="ion-arrow-left-c"></i>&nbsp;<data i18n="_btn_back_">Back</data></button><table class="table table-bordered"><thead><tr><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br><br></th><th><data-i18n i18n="_feeds_type_">Feed type</data-i18n><br><br></th><th><data-i18n i18n="_feeds_dm_">DM</data-i18n><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span></th><th><data-i18n i18n="_feeds_amount_">Amount</data-i18n><br><span>{{vm.weight}}</span></th><th><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n><br><span>{{vm.weight}}</span></th><th><data-i18n i18n="_feeds_cost_dm_">Cost dm</data-i18n><br><span>{{vm.currency}}/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th><th><data-i18n i18n="_feeds_cost_as_fed_">Cost as fed</data-i18n><br><span>{{vm.currency}}/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th><th><data-i18n i18n="_title_create_date">Create date</data-i18n><br><br></th><th><data-i18n i18n="_title_last_modified_date_">Last modified date</data-i18n><br><br></th><th><data-i18n i18n="_description_user_">Last modified user</data-i18n><br><br></th></tr></thead><tbody><tr ng-repeat="history in vm.history track by history.id"><td>{{history.action}}</td><td>{{history.feed_name}}</td><td>{{history.feed_type.translated}}</td><td>{{history.dm | formatViewValues: \'percentage\'}}</td><td>{{history.amount_dm | formatViewValues: \'amount\'}}</td><td>{{history.amount_as_fed | formatViewValues: \'amount\'}}</td><td>{{history.cost_dm | formatViewValues: \'cost_dm\'}}</td><td>{{history.cost_as_fed | formatViewValues: \'cost_dm\'}}</td><td>{{history.create_date | date: \'short\'}}</td><td>{{history.last_modified_date | date: \'short\'}}</td><td>{{history.last_modified_user}}</td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table></div><loading-spinner-large ng-if="vm.loadingTable"></loading-spinner-large>');
$templateCache.put('app/pages/rations/importRationNew/importRationNew.html','<div><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><div ng-include="\'app/pages/rations/importRationNew/importRationNew.panel.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/importRationNew/importRationNew.modal.html','<div class="modal-content"><div class="modal-header"></div><div ng-if="!vm.modalLoading"><div class="modal-body" align="center"><form name="form"><div><span style="font-size: 24px"><i style="font-size: 30px; margin-right: 7px" class="ion-alert-circled warningModal"></i><data-i18n i18n="_title_warning_">Warning!</data-i18n></span></div><div style="margin: 10px"><span><data-i18n i18n="_rations_import_warning_">final ration calculations values may be different to calculations in Spartan V3.</data-i18n></span></div></form><div><span>{{vm.fileSelected}}</span></div><div ng-if="vm.uploading" align="center" style="overflow: hidden"><div><div id="loading-animation-large"></div></div></div><div class="form-group"><div align="center"><button type="button" class="btn btn-info btn-with-icon save-profile" ng-click="vm.createRation()"><data-i18n i18n="_btn_save_">save</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.closeModal()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/rations/importRationNew/importRationNew.panel.html','<div ng-if="!vm.fileLoading && !vm.groupsLoading && !vm.herdLoading"><div><div ng-if="vm.teamSelected && vm.herdSelected"><div class="row" style="margin-top: 10px; margin-bottom: 10px; margin-right: 0px; margin-left: 0px"><div class="col-xlg-4 col-lg-4 col-md-12 col-sm-12 col-xs-12"></div><div class="col-xlg-4 col-lg-4 col-md-12 col-sm-12 col-xs-12"><div class="text-center" style="text-align: center"><div><button type="button" class="btn btn-primary no-border-radius" ng-click="vm.selectType(\'new\')" style="margin: 10px; height: 55px"><data-i18n i18n="_btn_create_group_">Create new group</data-i18n></button> <button type="button" class="btn btn-primary no-border-radius" ng-click="vm.selectType(\'existing\')" style="margin: 10px; height: 55px"><data-i18n i18n="_btn_use_existing_group_">Use existing group</data-i18n></button></div></div></div></div><form name="vm.form" ng-show="vm.showNew || vm.showExisting" novalidate=""><div class="row" style="margin-top: 10px; margin-bottom: 10px; margin-right: 0px; margin-left: 0px"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.form.groupName.$invalid && (vm.form.groupName.$dirty || vm.form.$submitted)}" ng-if="vm.showNew"><label for="name"><data-i18n i18n="_groups_group_name_">group name</data-i18n></label> <input type="text" maxlength="50" class="form-control" id="groupName" name="groupName" placeholder="{{\'_groups_group_name_\' | i18n}}" ng-model="vm.group_name" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_group_name_required_">group name is required</data-i18n></span></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.form.group.$invalid && vm.form.$submitted }" ng-if="vm.showExisting"><label><data-i18n i18n="_rations_add_new_ration_pickers_title_">Select group to create ration</data-i18n></label><ui-select ng-model="vm.selectedGroup" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.selected(\'group\')" id="group" name="group" required=""><ui-select-match placeholder="{{\'_picker_group_placeholder_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="group in vm.groups | filter: $select.search"><span ng-bind-html="group.name"></span></ui-select-choices></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_groups_group_required_">group is required</data-i18n></span></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.form.name.$invalid && (vm.form.name.$dirty || vm.form.$submitted)}"><label for="name"><data-i18n i18n="_rations_ration_name_">ration name</data-i18n></label> <input type="text" class="form-control" id="name" name="name" placeholder="{{\'_rations_ration_name_\' | i18n}}" ng-model="vm.ration_name" required="" maxlength="60"> <span class="help-block error-block basic-block"><data-i18n i18n="_rations_ration_name_required_">ration name is required</data-i18n></span></div></div></div><div class="row" style="margin-top: 10px; margin-bottom: 10px; margin-right: 0px; margin-left: 0px"><button type="submit" class="btn btn-success pull-right" ng-click="vm.openModal(\'app/pages/rations/importRationNew/importRationNew.modal.html\', \'sm\')" style="margin-right: 15px"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-danger pull-right" ng-click="vm.cancel()" style="margin-right: 15px"><data-i18n i18n="_btn_cancel_"></data-i18n></button></div></form></div></div><div ng-if="!vm.teamSelected" align="center"><div><h3><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></h3></div></div><div ng-if="!vm.herdSelected && vm.teamSelected" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div></div><div ng-if="vm.fileLoading || vm.groupsLoading || vm.herdLoading" align="center" style="overflow: hidden"><div><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/rations/myManualRations/confirmation.modal.html','<div class="modal-content" ng-if="!vm.modalLoading"><div class="modal-header"><div align="center"><span class="ion-android-warning warningModal" style="font-size: 36px"></span></div><div align="center"><span class="warningModal"><data-i18n ng-if="vm.modalType === \'set-herd\'" i18n="_m_f_warning_message_change_herd_">Warning message</data-i18n><data-i18n ng-if="vm.modalType === \'delete\'" i18n="_rations_delete_warning_message">Warning message</data-i18n></span></div></div><div class="modal-body"><div align="center"><button type="button" class="btn btn-primary" ng-click="vm.confirm()"><data-i18n ng-if="vm.modalType === \'set-herd\'" i18n="_btn_continue_">Continue</data-i18n><data-i18n ng-if="vm.modalType === \'delete\'" i18n="_btn_delete_">Delete</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div><loading-spinner-large ng-if="vm.modalLoading"></loading-spinner-large>');
$templateCache.put('app/pages/rations/myManualRations/myManualRations.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/myManualRations/myManualRations.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/myManualRations/myManualRations.panel.html','<div ng-if="vm.showFodjanTable && !vm.loading && vm.selectedTeam"><div class="row"><div class="dashboard-pills rations"><button ng-repeat="tab in vm.tabs" class="btn btn-sm" ng-class="{\'btn-active\': tab.active}" ng-click="vm.tabSelected($index, tab)">{{tab.name}}</button></div></div><div ng-repeat="tab in vm.tabs"><div ng-if="tab.active" ng-include="tab.url"></div></div></div><div ng-if="!vm.showFodjanTable && !vm.loading && vm.selectedTeam && vm.selectedHerd"><div include-with-scope="app/pages/rations/myManualRations/tables/mmmooogle.table.html"></div></div><div ng-if="!vm.selectedTeam" align="center"><div><h3><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></h3></div></div><div ng-if="!vm.showFodjanTable && !vm.selectedHerd && vm.selectedTeam" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div><loading-spinner-large ng-if="vm.loading && vm.selectedTeam"></loading-spinner-large>');
$templateCache.put('app/pages/rations/manualRationHistory/manualRationHistory.html','<div><div ng-if="!vm.loading && vm.selectedHerd" class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation"><div ng-include="\'app/pages/rations/manualRationHistory/manualRationHistory.table.html\'"></div></div></div></div><div ng-if="vm.loading" class="row" ba-panel=""><div class="col-lg-12 col-md-12"><div style="height: 200px; overflow: hidden" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div><div ng-if="!vm.loading && !vm.selectedHerd" align="center" ba-panel=""><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div>');
$templateCache.put('app/pages/rations/manualRationHistory/manualRationHistory.table.html','<div ng-if="!vm.loadingTable"><button class="btn btn-primary btn-xs" ng-click="vm.back()" style="margin: 5px"><i class="ion-arrow-left-c"></i>&nbsp;<data i18n="_btn_back_">Back</data></button><table class="table table-bordered"><thead><tr><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th><data-i18n i18n="_rations_ration_name_">Ration name</data-i18n><br><br></th><th><data-i18n i18n="_feeds_dm_">DM</data-i18n><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span></th><th><data-i18n i18n="_feeds_cost_per_cow_">Cost per cow</data-i18n><br><span>{{vm.currency}}</span></th><th><data-i18n i18n="_title_create_date">Create date</data-i18n><br><br></th><th><data-i18n i18n="_title_last_modified_date_">Last modified date</data-i18n><br><br></th><th><data-i18n i18n="_description_user_">Last modified user</data-i18n><br><br></th></tr></thead><tbody><tr ng-repeat="history in vm.history track by history.id"><td>{{history.action}}</td><td ng-class="{\'primaryModal\' : history.ration_name_changed}">{{history.ration_name}}</td><td ng-class="{\'primaryModal\' : history.dm_changed}">{{history.dm | formatViewValues: \'percentage\'}}</td><td ng-class="{\'primaryModal\' : history.cost_dm_changed}">{{history.cost_dm | formatViewValues: \'cost_dm\'}}</td><td>{{history.create_date | date: \'short\'}}</td><td>{{history.last_modified_date | date: \'short\'}}</td><td>{{history.last_modified_user_id}}</td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table></div><loading-spinner-large ng-if="vm.loadingTable"></loading-spinner-large>');
$templateCache.put('app/pages/rations/myRations/deleteRation.modal.html','<div class="modal-content"><div class="modal-header" ng-if="!vm.modalLoading"><div align="center"><span class="ion-android-warning warningModal" style="font-size: 36px"></span></div><div align="center"><span class="warningModal"><data-i18n i18n="_rations_delete_warning_message">Warning message</data-i18n></span></div></div><div class="modal-body" ng-if="!vm.modalLoading"><div align="center"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="vm.deleteRationProceed()"><data-i18n i18n="_btn_delete_">Delete</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div style="height: 120px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/rations/myRations/myRations.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/myRations/myRations.table.html"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/myRations/myRations.table.html','<div class="row" ng-if="!vm.loading && vm.selectedTeam"><div class="horizontal-scroll" style="min-height: 380px"><table class="table" style="font-size: 14px"><thead><tr class="sortable"><th style="width: 120px; min-width: 120px"><data-i18n i18n="_title_column_action_">action</data-i18n></th><th style="min-width: 250px"><data-i18n i18n="_rations_ration_name_">ration name</data-i18n></th><th style="min-width: 250px" ng-if="!vm.selectedHerd"><data-i18n i18n="_groups_herd_name_">herd name</data-i18n></th><th style="min-width: 250px" ng-if="!vm.selectedGroup"><data-i18n i18n="_groups_group_name_">group name</data-i18n></th><th style="min-width: 150px"><data-i18n i18n="_title_create_date">create date</data-i18n></th><th style="min-width: 150px"><data-i18n i18n="_title_last_modified_date_">last modified date</data-i18n></th><th style="min-width: 150px"><data-i18n i18n="_settings_calculation_type_title_">Calculation type</data-i18n></th><th style="min-width: 250px"><data-i18n i18n="_remove_ration_">Remove ration</data-i18n></th></tr><tr><th style="width: 120px; min-width: 120px"><ui-select ng-model="vm.activeFilter" class="active-filter btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-disabled="vm.loadingTable" on-select="vm.activeFilterChanged()"><ui-select-match>{{$select.selected.name }}</ui-select-match><ui-select-choices repeat="item in vm.activeFilterItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.rationFilterString" ng-change="vm.searchRation()" ng-disabled="vm.loadingTable"></th><th ng-if="!vm.selectedHerd"><input class="input-sm form-control search-input" type="search" ng-model="vm.herdFilterString" ng-change="vm.searchRation()" ng-disabled="vm.loadingTable"></th><th ng-if="!vm.selectedGroup"><input class="input-sm form-control search-input" type="search" ng-model="vm.groupFilterString" ng-change="vm.searchRation()" ng-disabled="vm.loadingTable"></th><th><p class="input-group active-filter" style="margin: 0px"><input type="text" class="form-control" uib-datepicker-popup="{{vm.date_format}}" placeholder="{{vm.date_format}}" ng-model="vm.dateFilter" is-open="vm.openDatePicker" ng-required="true" close-text="X" ng-change="vm.dateFilterChanged()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openDatePicker = true" style="height: 30px; margin-top: 4px"><i class="glyphicon glyphicon-calendar"></i></button></span></p></th><th colspan="3"></th></tr></thead><tbody ng-if="!vm.loadingTable"><tr ng-repeat="ration in vm.rations"><td style="width: 120px; min-width: 120px; padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.groupDetails(ration.id)" uib-tooltip="{{\'_ration_details_\' | i18n}}" tooltip-is-open="tooltipIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-right: 5px"><i class="ion-clipboard"></i></button> <i class="icon-edit green-icon" ng-class="ration.active ? \'ion-star\': \'ion-ios-star-outline\'" ng-click="vm.setAsActive(ration, $index)" uib-tooltip="{{\'_set_ration_active_\' | i18n}}" tooltip-is-open="activeRation" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></i></td><td class="shorten-long-text" uib-tooltip="{{ration.ration_name}}" tooltip-enable="{{ration.ration_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text" style="padding: 3px 3px">{{ration.ration_name}}</td><td class="shorten-long-text" uib-tooltip="{{ration.herd_name}}" tooltip-enable="{{ration.herd_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text" style="padding: 3px 3px" ng-if="!vm.selectedHerd">{{ration.herd_name}}</td><td class="shorten-long-text" uib-tooltip="{{ration.group_name}}" tooltip-enable="{{ration.group_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text" style="padding: 3px 3px" ng-if="!vm.selectedGroup">{{ration.group_name}}</td><td style="padding: 3px 3px">{{ration.create_date | date: vm.date_format}}</td><td style="padding: 3px 3px">{{ration.last_modified_date | date: vm.date_format}}</td><td><span ng-if="ration.ration_locale === 0"><data-i18n i18n="_calculation_us_short_">US</data-i18n></span> <span ng-if="ration.ration_locale === 1"><data-i18n i18n="_calculation_vem_dve_short_">Vem/Dve</data-i18n></span></td><td style="padding: 3px 3px"><button type="button" class="btn btn-danger btn-xs" ng-click="vm.deleteRation(ration, $index)" style="margin-left: 10px"><data-i18n i18n="_btn_delete_">delete</data-i18n></button></td></tr></tbody><tbody ng-if="vm.loadingTable && !vm.loading"><tr><td colspan="8"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></td></tr></tbody><tfoot><tr><td colspan="8" style="text-align: center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="10" max-size="7" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></td></tr></tfoot></table></div></div><div ng-if="!vm.selectedTeam" align="center"><div><h3><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></h3></div></div><div ng-if="vm.loading && vm.selectedTeam" align="center"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparison.amino_acid.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" id="aminoTable" st-table="vm.rations" st-safe-src="vm.rationsSafe"><thead id="aminoHeader"><tr class="sortable"><th style="height: 77px" st-sort="ration_name"><data-i18n i18n="_rations_ration_name_"></data-i18n></th><th style="min-width: 120px" st-sort="supply.amount_dm"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.lysine"><div uib-tooltip="{{\'_description_lys_\' | i18n}}" tooltip-is-open="lysIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lysine_">Lys</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.methionine"><div uib-tooltip="{{\'_description_met_\' | i18n}}" tooltip-is-open="metIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_methionine_">Met</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.teaa"><div uib-tooltip="{{\'_description_teaa_\' | i18n}}" tooltip-is-open="teaaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_teaa_">teaa</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th></tr></thead><tbody id="aminoBody" ng-if="!vm.loadingTable"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, ration) in vm.rations" ng-class="ration.supply.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 7px; padding-right: 0px; text-align: left"><div class="ration-name" style="margin-left: 10px !important; padding-bottom: 10px; margin-top: 1px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(ration, $event)" ng-model="ration.is_selected" style="margin-right: 5px" ng-if="!vm.comparisonActive"> <label for="is_checked{{$index}}" style="padding-left: 20px; margin-right: 1px"></label> {{ration.ration_name}}</span> <a class="ion-arrow" ng-click="vm.selectTableRow($index, ration.id)" href="" ng-class="vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" style="position: absolute; right: 0px; margin-top: 3px; margin-right: 6px" uib-tooltip="{{\'_expand_ration_\' | i18n}}" tooltip-is-open="Ration" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></div></th><td style="min-width: 120px">{{ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{ration.supply.lysine | formatViewValuesPerDay: \'lysine\'}}</td><td>{{ration.supply.methionine | formatViewValuesPerDay: \'methionine\'}}</td><td>{{ration.supply.teaa | formatViewValuesPerDay: \'teaa\'}}</td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></td><td>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></td><td>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, feed) in ration.feeds" ng-if="ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationThBackground" style="text-align: left"><div class="ration-name"><span><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px">{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.lysine | formatViewValues: \'lysine\'}}</td><td>{{feed.methionine | formatViewValues: \'methionine\'}}</td><td>{{feed.teaa | formatViewValues: \'teaa\'}}</td></tr><tr ng-repeat-end="" ng-if="rationfeeds"></tr><tr ng-if="vm.loadingFeeds && vm.dataCollapse[indexX]==true" class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable"><tr class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparison.cost.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" id="costTable" st-table="vm.rations" st-safe-src="vm.rationsSafe"><thead id="costHeader"><tr class="sortable"><th style="height: 77px" st-sort="ration_name"><data-i18n i18n="_rations_ration_name_"></data-i18n></th><th style="min-width: 120px" st-sort="supply.amount_dm"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.dm"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</div></th><th style="min-width: 150px" st-sort="supply.cost_dm"><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpen" tooltip-placement="left" tooltip-class="customBlue with-top-margin left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><br>{{vm.currency}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th style="min-width: 150px" st-sort="cost_as_fed"><div><data-i18n i18n="_feeds_cost_as_fed_">cost as fed</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th style="min-width: 150px" st-sort="cost_per_cow"><div><data-i18n i18n="_feeds_cost_per_cow_">cost per cow</data-i18n><br>{{vm.currency}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th style="min-width: 170px" st-sort="actual_milk_cost"><div><data-i18n i18n="_feeds_cost_milk_actual_">milk cost(actual)</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th style="min-width: 150px" st-sort="target_milk_cost"><div><data-i18n i18n="_feeds_cost_milk_target_">milk cost(target)</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th></tr></thead><tbody id="costBody" ng-if="!vm.loadingTable"><tr ng-repeat-start="(indexX, ration) in vm.rations" ng-switch="" on="vm.dataCollapse[$index]" class="editable-tr-wrap" ng-class="ration.supply.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 7px; padding-right: 0px; text-align: left"><div class="ration-name" style="margin-left: 10px !important; padding-bottom: 10px; margin-top: 1px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(ration, $event)" ng-model="ration.is_selected" style="margin-right: 5px" ng-if="!vm.comparisonActive"> <label for="is_checked{{$index}}" style="padding-left: 20px; margin-right: 1px"></label> {{ration.ration_name}}</span> <a class="ion-arrow" ng-click="vm.selectTableRow($index, ration.id)" href="" ng-class="vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" style="position: absolute; right: 0px; margin-top: 3px; margin-right: 6px" uib-tooltip="{{\'_expand_ration_\' | i18n}}" tooltip-is-open="Ration" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></div></th><td style="min-width: 120px">{{ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{ration.supply.dm | formatViewValuesPerDay: \'dm\'}}</td><td style="min-width: 150px">{{ration.supply.cost_dm | formatViewValuesPerDay: \'cost_dm\'}}</td><td style="min-width: 150px">{{ration.cost_as_fed | formatViewValuesPerDay: \'cost_as_fed\'}}</td><td style="min-width: 150px">{{ration.cost_per_cow | formatViewValuesPerDay: \'cost_per_cow\'}}</td><td style="min-width: 170px">{{ration.actual_milk_cost | formatViewValuesPerDay: \'actual_milk_cost\'}}</td><td style="min-width: 150px">{{ration.target_milk_cost | formatViewValuesPerDay: \'target_milk_cost\'}}</td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td><span ng-show="vm.settings.use_percent">%</span> <span ng-show="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></td><td></td><td></td><td></td><td></td><td></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, feed) in ration.feeds" ng-if="ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationThBackground"><div class="ration-name"><span><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px">{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.dm | formatViewValues: \'dm\'}}</td><td style="min-width: 150px">{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</td><td style="min-width: 150px">-</td><td style="min-width: 150px"></td><td style="min-width: 150px"></td><td style="min-width: 150px"></td></tr><tr ng-repeat-end="" ng-if="rationfeeds"></tr><tr ng-if="vm.loadingFeeds && vm.dataCollapse[indexX]==true" class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable"><tr class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparison.html','<div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><div ng-include="\'app/pages/rations/rationComparison/rationComparison.tabs.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparison.mineral.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" id="mineralTable" st-table="vm.rations" st-safe-src="vm.rationsSafe"><thead id="mineralHeader"><tr class="sortable"><th style="height: 77px" st-sort="ration_name"><data-i18n i18n="_rations_ration_name_"></data-i18n></th><th style="min-width: 120px" st-sort="supply.amount_dm"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.ca"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.ca_abs"><div uib-tooltip="{{\'_description_ca_abs_\' | i18n}}" tooltip-is-open="absCaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_abs_">abs Ca</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.p"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.p_abs"><div uib-tooltip="{{\'_description_p_abs_\' | i18n}}" tooltip-is-open="absPIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.mg"><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">Mg</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.mg_abs"><div uib-tooltip="{{\'_description_mg_abs_\' | i18n}}" tooltip-is-open="absMgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_abs_">abs Mg</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.k"><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">K</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.na"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.cl"><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">Cl</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.s"><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">S</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.dcad"><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.ash"><div uib-tooltip="{{\'_description_ash_\' | i18n}}" tooltip-is-open="ashIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ash_">ash</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th></tr></thead><tbody id="mineralBody" ng-if="!vm.loadingTable"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, ration) in vm.rations" ng-class="ration.supply.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 7px; padding-right: 0px; text-align: left"><div class="ration-name" style="margin-left: 10px !important; padding-bottom: 10px; margin-top: 1px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(ration, $event)" ng-model="ration.is_selected" style="margin-right: 5px" ng-if="!vm.comparisonActive"> <label for="is_checked{{$index}}" style="padding-left: 20px; margin-right: 1px"></label> {{ration.ration_name}}</span> <a class="ion-arrow" ng-click="vm.selectTableRow($index, ration.id)" href="" ng-class="vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" style="position: absolute; right: 0px; margin-top: 3px; margin-right: 6px" uib-tooltip="{{\'_expand_ration_\' | i18n}}" tooltip-is-open="Ration" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></div></th><td style="min-width: 120px">{{ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{ration.supply.ca | formatViewValuesPerDay: \'ca\'}}</td><td>{{ration.supply.ca_abs | formatViewValuesPerDay: \'ca_abs\'}}</td><td>{{ration.supply.p | formatViewValuesPerDay: \'p\'}}</td><td>{{ration.supply.p_abs | formatViewValuesPerDay: \'p_abs\'}}</td><td>{{ration.supply.mg | formatViewValuesPerDay: \'mg\'}}</td><td>{{ration.supply.mg_abs | formatViewValuesPerDay: \'mg_abs\'}}</td><td>{{ration.supply.k | formatViewValuesPerDay: \'k\'}}</td><td>{{ration.supply.na | formatViewValuesPerDay: \'na\'}}</td><td>{{ration.supply.cl | formatViewValuesPerDay: \'cl\'}}</td><td>{{ration.supply.s | formatViewValuesPerDay: \'s\'}}</td><td>{{ration.supply.dcad | formatViewValuesPerDay: \'dcad\'}}</td><td>{{ration.supply.ash | formatViewValuesPerDay: \'ash\'}}</td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds && vm.settings.use_percent" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_ca_">Ca</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_p_">P</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_mg_">Mg</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds && !vm.settings.use_percent" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_ca_">Ca</data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_p_">P</data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_mg_">Mg</data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, feed) in ration.feeds" ng-if="!vm.loadingTable && ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationThBackground" style="text-align: left"><div class="ration-name"><span><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px">{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.ca | formatViewValues: \'ca\': feed.dm}}</td><td>{{feed.ca_abs | formatViewValues: \'ca_abs\'}}</td><td>{{feed.p | formatViewValues: \'p\': feed.dm}}</td><td>{{feed.p_abs | formatViewValues: \'p_abs\'}}</td><td>{{feed.mg | formatViewValues: \'mg\': feed.dm}}</td><td>{{feed.mg_abs | formatViewValues: \'mg_abs\'}}</td><td>{{feed.k | formatViewValues: \'k\': feed.dm}}</td><td>{{feed.na | formatViewValues: \'na\': feed.dm}}</td><td>{{feed.cl | formatViewValues: \'cl\': feed.dm}}</td><td>{{feed.s | formatViewValues: \'s\': feed.dm}}</td><td>{{feed.dcad | formatViewValues: \'dcad\'}}</td><td>{{feed.ash | formatViewValues: \'ash\': feed.dm}}</td></tr><tr ng-repeat-end="" ng-if="ration.feeds"></tr><tr ng-if="vm.loadingFeeds && vm.dataCollapse[indexX]==true" class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable"><tr class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparison.misc.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped extended" id="miscTable" st-table="vm.rations" st-safe-src="vm.rationsSafe"><thead id="miscHeader"><tr class="sortable"><th style="height: 77px" st-sort="ration_name"><data-i18n i18n="_rations_ration_name_"></data-i18n></th><th style="min-width: 120px" st-sort="supply.amount_dm"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.blank_1"><div uib-tooltip="{{\'_description_blank_1_\' | i18n}}" tooltip-is-open="blank1IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>1<br><br></div></th><th st-sort="supply.blank_2"><div uib-tooltip="{{\'_description_blank_2_\' | i18n}}" tooltip-is-open="blank2IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>2<br><br></div></th><th st-sort="supply.blank_3"><div uib-tooltip="{{\'_description_blank_3_\' | i18n}}" tooltip-is-open="blank3IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>3<br><br></div></th><th st-sort="supply.blank_4"><div uib-tooltip="{{\'_description_blank_4_\' | i18n}}" tooltip-is-open="blank4IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>4<br><br></div></th><th st-sort="supply.blank_5"><div uib-tooltip="{{\'_description_blank_5_\' | i18n}}" tooltip-is-open="blank5IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>5<br><br></div></th></tr></thead><tbody id="miscBody" ng-if="!vm.loadingTable"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, ration) in vm.rations" ng-class="ration.supply.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 7px; padding-right: 0px; text-align: left"><div class="ration-name" style="margin-left: 10px !important; padding-bottom: 10px; margin-top: 1px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(ration, $event)" ng-model="ration.is_selected" style="margin-right: 5px" ng-if="!vm.comparisonActive"> <label for="is_checked{{$index}}" style="padding-left: 20px; margin-right: 1px"></label> {{ration.ration_name}}</span> <a class="ion-arrow" ng-click="vm.selectTableRow($index, ration.id)" href="" ng-class="vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" style="position: absolute; right: 0px; margin-top: 3px; margin-right: 6px" uib-tooltip="{{\'_expand_ration_\' | i18n}}" tooltip-is-open="Ration" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></div></th><td style="min-width: 120px">{{ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{ration.supply.blank_1}}</td><td>{{ration.supply.blank_2}}</td><td>{{ration.supply.blank_3}}</td><td>{{ration.supply.blank_4}}</td><td>{{ration.supply.blank_5}}</td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, feed) in ration.feeds" ng-if="ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationThBackground" style="text-align: left"><div class="ration-name"><span><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px">{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.blank_1}}</td><td>{{feed.blank_2}}</td><td>{{feed.blank_3}}</td><td>{{feed.blank_4}}</td><td>{{feed.blank_5}}</td></tr><tr ng-repeat-end="" ng-if="ration.feeds"></tr><tr ng-if="vm.loadingFeeds && vm.dataCollapse[indexX]==true" class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable"><tr class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparison.tabs.html','<div><div class="row" style="margin-top: 20px; margin-right: 0px; margin-left: 0px"><uib-tabset active="$tabSetStatus.activeTab" ng-if="!vm.loading"><uib-tab heading="{{\'_feeds_tab_home_\'|i18n}}" select="vm.activeTab = 1"><div class="row" ng-if="vm.activeTab == 1"><div ba-panel="" ba-panel-title="{{\'_feeds_panel_home_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" id="homePanel"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationComparison/rationComparisonHome/rationComparison.home.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationComparison/rationComparisonHome/rationComparison.home.VemDve.html"></div></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_fiber_\'|i18n}}" select="vm.activeTab = 2"><div class="row"><div ba-panel="" ba-panel-title="{{\'_feeds_panel_home_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" id="fiberPanel"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationComparison/rationComparisonFiber/rationComparison.fiber.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationComparison/rationComparisonFiber/rationComparison.fiber.VemDve.html"></div></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_energy_\'|i18n}}" select="vm.activeTab = 3"><div class="row"><div ba-panel="" ba-panel-title="{{\'_feeds_panel_home_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" id="energyPanel"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationComparison/rationComparisonEnergy/rationComparison.energy.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationComparison/rationComparisonEnergy/rationComparison.energy.VemDve.html"></div></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_protein_\'|i18n}}" select="vm.activeTab = 4"><div class="row"><div ba-panel="" ba-panel-title="{{\'_feeds_panel_home_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" id="proteinPanel"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationComparison/rationComparisonProtein/rationComparison.protein.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationComparison/rationComparisonProtein/rationComparison.protein.VemDve.html"></div></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_carb_\'|i18n}}" select="vm.activeTab = 5"><div class="row"><div ba-panel="" ba-panel-title="{{\'_feeds_panel_home_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" id="carbPanel"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationComparison/rationComparisonCarb/rationComparison.carbohydrate.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationComparison/rationComparisonCarb/rationComparison.carbohydrate.VemDve.html"></div></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_lipid_\'|i18n}}" select="vm.activeTab = 6"><div class="row"><div ba-panel="" ba-panel-title="{{\'_feeds_panel_home_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" id="lipidPanel"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationComparison/rationComparisonLipid/rationComparison.lipid.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationComparison/rationComparisonLipid/rationComparison.lipid.VemDve.html"></div></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_mineral_\'|i18n}}" select="vm.activeTab = 7"><div class="row"><div ba-panel="" ba-panel-title="{{\'_feeds_panel_home_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" id="mineralPanel"><div include-with-scope="app/pages/rations/rationComparison/rationComparison.mineral.html"></div></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_trace_min_\'|i18n}}" select="vm.activeTab = 8"><div class="row"><div ba-panel="" ba-panel-title="{{\'_feeds_panel_home_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" id="tracePanel"><div include-with-scope="app/pages/rations/rationComparison/rationComparison.trace_min.html"></div></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_vitamin_\'|i18n}}" select="vm.activeTab = 9"><div class="row"><div ba-panel="" ba-panel-title="{{\'_feeds_panel_home_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" id="vitaminPanel"><div include-with-scope="app/pages/rations/rationComparison/rationComparison.vitamin.html"></div></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_amino_acid_\'|i18n}}" select="vm.activeTab = 10"><div class="row"><div ba-panel="" ba-panel-title="{{\'_feeds_panel_home_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" id="aminoPanel"><div include-with-scope="app/pages/rations/rationComparison/rationComparison.amino_acid.html"></div></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_cost_\'|i18n}}" select="vm.activeTab = 11"><div class="row"><div ba-panel="" ba-panel-title="{{\'_feeds_panel_home_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" id="costPanel"><div include-with-scope="app/pages/rations/rationComparison/rationComparison.cost.html"></div></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab><uib-tab heading="{{\'_feeds_tab_misc_\'|i18n}}" select="vm.activeTab = 12"><div class="row"><div ba-panel="" ba-panel-title="{{\'_feeds_panel_home_\'|i18n}}" ba-panel-class="with-scroll disabled-animation" id="miscPanel"><div include-with-scope="app/pages/rations/rationComparison/rationComparison.misc.html"></div></div></div><ul class="nav nav-tabs bottom-placement" ng-class="{\'nav-stacked\' : vertical, \'nav-justified\' : justified}"><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 0" class="nav-link" ng-class="$tabSetStatus.activeTab == 0 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_home_">home</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 1" class="nav-link" ng-class="$tabSetStatus.activeTab == 1 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_fiber_">fiber</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 2" class="nav-link" ng-class="$tabSetStatus.activeTab == 2 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_energy_">energy</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 3" class="nav-link" ng-class="$tabSetStatus.activeTab == 3 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_protein_">protein</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 4" class="nav-link" ng-class="$tabSetStatus.activeTab == 4 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_carb_">carb.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 5" class="nav-link" ng-class="$tabSetStatus.activeTab == 5 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_lipid_">lipid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 6" class="nav-link" ng-class="$tabSetStatus.activeTab == 6 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_mineral_">mineral</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 7" class="nav-link" ng-class="$tabSetStatus.activeTab == 7 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_trace_min_">trace min.</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 8" class="nav-link" ng-class="$tabSetStatus.activeTab == 8 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_vitamin_">vitamin</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 9" class="nav-link" ng-class="$tabSetStatus.activeTab == 9 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_amino_acid_">amino acid</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 10" class="nav-link" ng-class="$tabSetStatus.activeTab == 10 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_cost_">cost</data-i18n></a></li><li class="uib-tab nav-item ng-scope ng-isolate-scope"><a href="" ng-click="$tabSetStatus.activeTab = 11" class="nav-link" ng-class="$tabSetStatus.activeTab == 11 ? \'comparisonTabsBg\' : \'\'"><data-i18n i18n="_feeds_tab_misc_">misc</data-i18n></a></li></ul></uib-tab></uib-tabset><div ng-if="vm.loading" align="center" style="overflow: hidden"><div><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparison.trace_min.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" id="traceTable" st-table="vm.rations" st-safe-src="vm.rationsSafe"><thead id="traceHeader"><tr class="sortable"><th style="height: 77px" st-sort="ration_name"><data-i18n i18n="_rations_ration_name_"></data-i18n></th><th style="min-width: 120px" st-sort="supply.amount_dm"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.co"><div uib-tooltip="{{\'_description_co_\' | i18n}}" tooltip-is-open="coIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_co_">Co</data-i18n><br><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.cu"><div uib-tooltip="{{\'_description_cu_\' | i18n}}" tooltip-is-open="cuIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cu_">Cu</data-i18n><br><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.cu_abs"><div uib-tooltip="{{\'_description_cu_abs_\' | i18n}}" tooltip-is-open="absCuIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cu_abs_">abs Cu</data-i18n><br><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.fe"><div uib-tooltip="{{\'_description_fe_\' | i18n}}" tooltip-is-open="feIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fe_">Fe</data-i18n><br><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.fe_abs"><div uib-tooltip="{{\'_description_fe_abs_\' | i18n}}" tooltip-is-open="absFeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fe_abs_">abs Fe</data-i18n><br><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.i"><div uib-tooltip="{{\'_description_i_\' | i18n}}" tooltip-is-open="iIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_i_">I</data-i18n><br><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.i_abs"><div uib-tooltip="{{\'_description_i_abs_\' | i18n}}" tooltip-is-open="absIIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_i_abs_">abs I</data-i18n><br><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.mo"><div uib-tooltip="{{\'_description_mo_\' | i18n}}" tooltip-is-open="moIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mo_">Mo</data-i18n><br><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.mn"><div uib-tooltip="{{\'_description_mn_\' | i18n}}" tooltip-is-open="mnIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mn_">Mn</data-i18n><br><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.mn_abs"><div uib-tooltip="{{\'_description_mn_abs_\' | i18n}}" tooltip-is-open="absMnIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mn_abs_">abs Mn</data-i18n><br><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.se"><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><br><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.se_abs"><div uib-tooltip="{{\'_description_se_abs_\' | i18n}}" tooltip-is-open="absSeIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_abs_">abs Se</data-i18n><br><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.zn"><div uib-tooltip="{{\'_description_zn_\' | i18n}}" tooltip-is-open="znIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_zn_">Zn</data-i18n><br><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.zn_abs"><div uib-tooltip="{{\'_description_zn_abs_\' | i18n}}" tooltip-is-open="absZnIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_zn_abs_">abs Zn</data-i18n><br><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th></tr></thead><tbody id="traceBody" ng-if="!vm.loadingTable"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, ration) in vm.rations" ng-switch="" on="vm.dataCollapse[$index]" ng-class="ration.supply.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 7px; padding-right: 0px; text-align: left"><div class="ration-name" style="margin-left: 10px !important; padding-bottom: 10px; margin-top: 1px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(ration, $event)" ng-model="ration.is_selected" style="margin-right: 5px" ng-if="!vm.comparisonActive"> <label for="is_checked{{$index}}" style="padding-left: 20px; margin-right: 1px"></label> {{ration.ration_name}}</span> <a class="ion-arrow" ng-click="vm.selectTableRow($index, ration.id)" href="" ng-class="vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" style="position: absolute; right: 0px; margin-top: 3px; margin-right: 6px" uib-tooltip="{{\'_expand_ration_\' | i18n}}" tooltip-is-open="Ration" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></div></th><td style="min-width: 120px">{{ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{ration.supply.co | formatViewValuesPerDay: \'co\'}}</td><td>{{ration.supply.cu | formatViewValuesPerDay: \'cu\'}}</td><td>{{ration.supply.cu_abs | formatViewValuesPerDay: \'cu_abs\'}}</td><td>{{ration.supply.fe | formatViewValuesPerDay: \'fe\'}}</td><td>{{ration.supply.fe_abs | formatViewValuesPerDay: \'fe_abs\'}}</td><td>{{ration.supply.i | formatViewValuesPerDay: \'i\'}}</td><td>{{ration.supply.i_abs | formatViewValuesPerDay: \'i_abs\'}}</td><td>{{ration.supply.mo | formatViewValuesPerDay: \'mo\'}}</td><td>{{ration.supply.mn | formatViewValuesPerDay: \'mn\'}}</td><td>{{ration.supply.mn_abs | formatViewValuesPerDay: \'mn_abs\'}}</td><td>{{ration.supply.se | formatViewValuesPerDay: \'se\'}}</td><td>{{ration.supply.se_abs | formatViewValuesPerDay: \'se_abs\'}}</td><td>{{ration.supply.zn | formatViewValuesPerDay: \'zn\'}}</td><td>{{ration.supply.zn_abs | formatViewValuesPerDay: \'zn_abs\'}}</td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td><data-i18n i18n="_unit_ppm_">ppm</data-i18n></td><td><data-i18n i18n="_unit_ppm_">ppm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_cu_">Cu</data-i18n></td><td><data-i18n i18n="_unit_ppm_">ppm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_fe_">Fe</data-i18n></td><td><data-i18n i18n="_unit_ppm_">ppm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_i_">I</data-i18n></td><td><data-i18n i18n="_unit_ppm_">ppm</data-i18n></td><td><data-i18n i18n="_unit_ppm_">ppm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_mn_">Mn</data-i18n></td><td><data-i18n i18n="_unit_ppm_">ppm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_se_">Se</data-i18n></td><td><data-i18n i18n="_unit_ppm_">ppm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_zn_">Zn</data-i18n></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, feed) in ration.feeds" ng-if="ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationThBackground" style="text-align: left"><div class="ration-name"><span><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px">{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.co | formatViewValues: \'co\'}}</td><td>{{feed.cu | formatViewValues: \'cu\'}}</td><td>{{feed.cu_abs | formatViewValues: \'cu_abs\'}}</td><td>{{feed.fe | formatViewValues: \'fe\'}}</td><td>{{feed.fe_abs | formatViewValues: \'fe_abs\'}}</td><td>{{feed.i | formatViewValues: \'i\'}}</td><td>{{feed.i_abs | formatViewValues: \'i_abs\'}}</td><td>{{feed.mo | formatViewValues: \'mo\'}}</td><td>{{feed.mn | formatViewValues: \'mn\'}}</td><td>{{feed.mn_abs | formatViewValues: \'mn_abs\'}}</td><td>{{feed.se | formatViewValues: \'se\'}}</td><td>{{feed.se_abs | formatViewValues: \'se_abs\'}}</td><td>{{feed.zn | formatViewValues: \'zn\'}}</td><td>{{feed.zn_abs | formatViewValues: \'zn_abs\'}}</td></tr><tr ng-repeat-end="" ng-if="ration.feeds"></tr><tr ng-if="vm.loadingFeeds && vm.dataCollapse[indexX]==true" class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable"><tr class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparison.vitamin.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" id="vitaminTable" st-table="vm.rations" st-safe-src="vm.rationsSafe"><thead id="vitaminHeader"><tr class="sortable" id="vitaminTr"><th style="height: 77px" st-sort="ration_name"><data-i18n i18n="_rations_ration_name_"></data-i18n></th><th style="min-width: 120px" st-sort="supply.amount_dm"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.vitamin_a"><div uib-tooltip="{{\'_description_vitamin_a_\' | i18n}}" tooltip-is-open="vitAIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_a_">vit a</data-i18n><br><data-i18n i18n="_unit_iu_k_">kIU</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="vitamin_d"><div uib-tooltip="{{\'_description_vitamin_d_\' | i18n}}" tooltip-is-open="vitDIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_d_">vit d</data-i18n><br><data-i18n i18n="_unit_iu_k_">kIU</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="vitamin_e"><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th></tr></thead><tbody id="vitaminBody" ng-if="!vm.loadingTable"><tr class="editable-tr-wrap" ng-class="ration.supply.is_mix ? \'darkBackground \' : \'defaultBackground\'" ng-cloak="" ng-repeat-start="(indexX, ration) in vm.rations"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 7px; padding-right: 0px; text-align: left"><div class="ration-name" style="margin-left: 10px !important; padding-bottom: 10px; margin-top: 1px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(ration, $event)" ng-model="ration.is_selected" style="margin-right: 5px" ng-if="!vm.comparisonActive"> <label for="is_checked{{$index}}" style="padding-left: 20px; margin-right: 1px"></label> {{ration.ration_name}}</span> <a class="ion-arrow" ng-click="vm.selectTableRow($index, ration.id)" href="" ng-class="vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" style="position: absolute; right: 0px; margin-top: 3px; margin-right: 6px" uib-tooltip="{{\'_expand_ration_\' | i18n}}" tooltip-is-open="Ration" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></div></th><td style="min-width: 120px">{{ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{ration.supply.vitamin_a | formatViewValuesPerDay: \'vitamin_a\'}}</td><td>{{ration.supply.vitamin_d | formatViewValuesPerDay: \'vitamin_d\'}}</td><td>{{ration.supply.vitamin_e | formatViewValuesPerDay: \'vitamin_e\'}}</td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td><data-i18n i18n="_unit_iu_k_">IU</data-i18n>/{{vm.weight}}</td><td><data-i18n i18n="_unit_iu_k_">IU</data-i18n>/{{vm.weight}}</td><td><data-i18n i18n="_unit_iu_k_">IU</data-i18n>/{{vm.weight}}</td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, feed) in ration.feeds" ng-if="ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationThBackground" style="text-align: left"><div class="ration-name"><span><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px">{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.vitamin_a | formatViewValues: \'vitamin_a\'}}</td><td>{{feed.vitamin_d | formatViewValues: \'vitamin_d\'}}</td><td>{{feed.vitamin_e | formatViewValues: \'vitamin_e\'}}</td></tr><tr ng-repeat-end="" ng-if="ration.feeds"></tr><tr ng-if="vm.loadingFeeds && vm.dataCollapse[indexX]==true" class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable"><tr class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationComparisonList/rationComparison.tabs.html','<div ng-if="!vm.selectedTeam" align="center" style="height: 55px; display: flex; align-items: center; justify-content: center"><div><h3><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></h3></div></div><div><div class="row" style="margin-right: 0px; margin-left: 0px"><uib-tabset active="$tabSetStatus.activeTab" ng-if="!vm.loading"><uib-tab heading="{{\'_feeds_tab_home_\'|i18n}}" select="vm.activeTab = 1"><div class="row" style="margin: 10px"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_rations_selected_">Number of rations selected</data-i18n>: {{vm.selectedRations.length}}</span> <button class="btn btn-primary" ng-disabled="vm.selectedRations.length == 0" ng-click="vm.compare()" ng-if="!vm.comparisonActive"><data-i18n i18n="_btn_compare_">compare</data-i18n></button> <button class="btn btn-danger" ng-click="vm.reset()" ng-if="vm.comparisonActive"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><div ng-show="!vm.loadingTabs"><div ng-if="vm.showHome"><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationComparison/rationComparisonHome/rationComparison.home.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationComparison/rationComparisonHome/rationComparison.home.VemDve.html"></div></div></div></div></div></div><div class="row paginator" ng-if="!vm.comparisonActive && vm.activeTab == 1"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="10" max-size="7" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></div></uib-tab><uib-tab heading="{{\'_feeds_tab_fiber_\'|i18n}}" select="vm.activeTab = 2"><div class="row" style="margin: 10px"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_rations_selected_">Number of rations selected</data-i18n>: {{vm.selectedRations.length}}</span> <button class="btn btn-primary" ng-disabled="vm.selectedRations.length == 0" ng-click="vm.compare()" ng-if="!vm.comparisonActive"><data-i18n i18n="_btn_compare_">compare</data-i18n></button> <button class="btn btn-danger" ng-click="vm.reset()" ng-if="vm.comparisonActive"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><div ng-show="!vm.loadingTabs"><div ng-if="vm.showFiber"><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationComparison/rationComparisonFiber/rationComparison.fiber.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationComparison/rationComparisonFiber/rationComparison.fiber.VemDve.html"></div></div></div></div></div></div><div class="row paginator" ng-if="!vm.comparisonActive && vm.showFiber"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="10" max-size="7" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></div></uib-tab><uib-tab heading="{{\'_feeds_tab_energy_\'|i18n}}" select="vm.activeTab = 3"><div class="row" style="margin: 10px"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_rations_selected_">Number of rations selected</data-i18n>: {{vm.selectedRations.length}}</span> <button class="btn btn-primary" ng-disabled="vm.selectedRations.length == 0" ng-click="vm.compare()" ng-if="!vm.comparisonActive"><data-i18n i18n="_btn_compare_">compare</data-i18n></button> <button class="btn btn-danger" ng-click="vm.reset()" ng-if="vm.comparisonActive"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><div ng-show="!vm.loadingTabs"><div ng-if="vm.showEnergy"><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationComparison/rationComparisonEnergy/rationComparison.energy.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationComparison/rationComparisonEnergy/rationComparison.energy.VemDve.html"></div></div></div></div></div></div><div class="row paginator" ng-if="!vm.comparisonActive && vm.showEnergy"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="10" max-size="7" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></div></uib-tab><uib-tab heading="{{\'_feeds_tab_protein_\'|i18n}}" select="vm.activeTab = 4"><div class="row" style="margin: 10px"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_rations_selected_">Number of rations selected</data-i18n>: {{vm.selectedRations.length}}</span> <button class="btn btn-primary" ng-disabled="vm.selectedRations.length == 0" ng-click="vm.compare()" ng-if="!vm.comparisonActive"><data-i18n i18n="_btn_compare_">compare</data-i18n></button> <button class="btn btn-danger" ng-click="vm.reset()" ng-if="vm.comparisonActive"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><div ng-show="!vm.loadingTabs"><div ng-if="vm.showProtein"><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationComparison/rationComparisonProtein/rationComparison.protein.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationComparison/rationComparisonProtein/rationComparison.protein.VemDve.html"></div></div></div></div></div></div><div class="row paginator" ng-if="!vm.comparisonActive && vm.showProtein"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="10" max-size="7" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></div></uib-tab><uib-tab heading="{{\'_feeds_tab_carb_\'|i18n}}" select="vm.activeTab = 5"><div class="row" style="margin: 10px"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_rations_selected_">Number of rations selected</data-i18n>: {{vm.selectedRations.length}}</span> <button class="btn btn-primary" ng-disabled="vm.selectedRations.length == 0" ng-click="vm.compare()" ng-if="!vm.comparisonActive"><data-i18n i18n="_btn_compare_">compare</data-i18n></button> <button class="btn btn-danger" ng-click="vm.reset()" ng-if="vm.comparisonActive"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><div ng-show="!vm.loadingTabs"><div ng-if="vm.showCarb"><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationComparison/rationComparisonCarb/rationComparison.carbohydrate.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationComparison/rationComparisonCarb/rationComparison.carbohydrate.VemDve.html"></div></div></div></div></div></div><div class="row paginator" ng-if="!vm.comparisonActive && vm.showCarb"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="10" max-size="7" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></div></uib-tab><uib-tab heading="{{\'_feeds_tab_lipid_\'|i18n}}" select="vm.activeTab = 6"><div class="row" style="margin: 10px"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_rations_selected_">Number of rations selected</data-i18n>: {{vm.selectedRations.length}}</span> <button class="btn btn-primary" ng-disabled="vm.selectedRations.length == 0" ng-click="vm.compare()" ng-if="!vm.comparisonActive"><data-i18n i18n="_btn_compare_">compare</data-i18n></button> <button class="btn btn-danger" ng-click="vm.reset()" ng-if="vm.comparisonActive"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><div ng-show="!vm.loadingTabs"><div ng-if="vm.showLipid"><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationComparison/rationComparisonLipid/rationComparison.lipid.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationComparison/rationComparisonLipid/rationComparison.lipid.VemDve.html"></div></div></div></div></div></div><div class="row paginator" ng-if="!vm.comparisonActive && vm.showLipid"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="10" max-size="7" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></div></uib-tab><uib-tab heading="{{\'_feeds_tab_mineral_\'|i18n}}" select="vm.activeTab = 7"><div class="row" style="margin: 10px"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_rations_selected_">Number of rations selected</data-i18n>: {{vm.selectedRations.length}}</span> <button class="btn btn-primary" ng-disabled="vm.selectedRations.length == 0" ng-click="vm.compare()" ng-if="!vm.comparisonActive"><data-i18n i18n="_btn_compare_">compare</data-i18n></button> <button class="btn btn-danger" ng-click="vm.reset()" ng-if="vm.comparisonActive"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><div ng-show="!vm.loadingTabs"><div ng-if="vm.showMineral"><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div include-with-scope="app/pages/rations/rationComparison/rationComparison.mineral.html"></div></div></div></div></div></div><div class="row paginator" ng-if="!vm.comparisonActive && vm.showMineral"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="10" max-size="7" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></div></uib-tab><uib-tab heading="{{\'_feeds_tab_trace_min_\'|i18n}}" select="vm.activeTab = 8"><div class="row" style="margin: 10px"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_rations_selected_">Number of rations selected</data-i18n>: {{vm.selectedRations.length}}</span> <button class="btn btn-primary" ng-disabled="vm.selectedRations.length == 0" ng-click="vm.compare()" ng-if="!vm.comparisonActive"><data-i18n i18n="_btn_compare_">compare</data-i18n></button> <button class="btn btn-danger" ng-click="vm.reset()" ng-if="vm.comparisonActive"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><div ng-show="!vm.loadingTabs"><div ng-if="vm.showTMineral"><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div include-with-scope="app/pages/rations/rationComparison/rationComparison.trace_min.html"></div></div></div></div></div></div><div class="row paginator" ng-if="!vm.comparisonActive && vm.showTMineral"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="10" max-size="7" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></div></uib-tab><uib-tab heading="{{\'_feeds_tab_vitamin_\'|i18n}}" select="vm.activeTab = 9"><div class="row" style="margin: 10px"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_rations_selected_">Number of rations selected</data-i18n>: {{vm.selectedRations.length}}</span> <button class="btn btn-primary" ng-disabled="vm.selectedRations.length == 0" ng-click="vm.compare()" ng-if="!vm.comparisonActive"><data-i18n i18n="_btn_compare_">compare</data-i18n></button> <button class="btn btn-danger" ng-click="vm.reset()" ng-if="vm.comparisonActive"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><div ng-show="!vm.loadingTabs"><div ng-if="vm.showVitamin"><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div include-with-scope="app/pages/rations/rationComparison/rationComparison.vitamin.html"></div></div></div></div></div></div><div class="row paginator" ng-if="!vm.comparisonActive && vm.showVitamin"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="10" max-size="7" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></div></uib-tab><uib-tab heading="{{\'_feeds_tab_amino_acid_\'|i18n}}" select="vm.activeTab = 10"><div class="row" style="margin: 10px"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_rations_selected_">Number of rations selected</data-i18n>: {{vm.selectedRations.length}}</span> <button class="btn btn-primary" ng-disabled="vm.selectedRations.length == 0" ng-click="vm.compare()" ng-if="!vm.comparisonActive"><data-i18n i18n="_btn_compare_">compare</data-i18n></button> <button class="btn btn-danger" ng-click="vm.reset()" ng-if="vm.comparisonActive"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><div ng-show="!vm.loadingTabs"><div ng-if="vm.showAA"><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div include-with-scope="app/pages/rations/rationComparison/rationComparison.amino_acid.html"></div></div></div></div></div></div><div class="row paginator" ng-if="!vm.comparisonActive && vm.showAA"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="10" max-size="7" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></div></uib-tab><uib-tab heading="{{\'_feeds_tab_cost_\'|i18n}}" select="vm.activeTab = 11"><div class="row" style="margin: 10px"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_rations_selected_">Number of rations selected</data-i18n>: {{vm.selectedRations.length}}</span> <button class="btn btn-primary" ng-disabled="vm.selectedRations.length == 0" ng-click="vm.compare()" ng-if="!vm.comparisonActive"><data-i18n i18n="_btn_compare_">compare</data-i18n></button> <button class="btn btn-danger" ng-click="vm.reset()" ng-if="vm.comparisonActive"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><div ng-show="!vm.loadingTabs"><div ng-if="vm.showCostTab"><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div include-with-scope="app/pages/rations/rationComparison/rationComparison.cost.html"></div></div></div></div></div></div><div class="row paginator" ng-if="!vm.comparisonActive && vm.showCostTab"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="10" max-size="7" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></div></uib-tab><uib-tab heading="{{\'_feeds_tab_misc_\'|i18n}}" select="vm.activeTab = 12"><div class="row" style="margin: 10px"><div style="float: right"><span style="margin-right: 10px"><data-i18n i18n="_title_no_rations_selected_">Number of rations selected</data-i18n>: {{vm.selectedRations.length}}</span> <button class="btn btn-primary" ng-disabled="vm.selectedRations.length == 0" ng-click="vm.compare()" ng-if="!vm.comparisonActive"><data-i18n i18n="_btn_compare_">compare</data-i18n></button> <button class="btn btn-danger" ng-click="vm.reset()" ng-if="vm.comparisonActive"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.loadingTabs" align="center"><div id="loading-animation-large"></div></div><div ng-show="!vm.loadingTabs"><div ng-if="vm.showMisc"><div class="row" element-loaded="vm.stopLoadingTabs()"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="with-scroll disabled-animation" id="balance-ration-table"><div include-with-scope="app/pages/rations/rationComparison/rationComparison.misc.html"></div></div></div></div></div></div><div class="row paginator" ng-if="!vm.comparisonActive && vm.showMisc"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="10" max-size="7" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></div></uib-tab><li class="slider-wraper"><div><toggle-switch ng-model="vm.sliderUsePercent" ng-change="vm.changeUnits()" on-label="%" off-label="g/{{vm.weight}}" knob-label="{{\'_report_unit_\' | i18n}}" class="switch-primary" style="width: 120px"></toggle-switch></div></li></uib-tabset><div ng-if="vm.loading && vm.selectedTeam" align="center" style="overflow: hidden"><div><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/rationComparisonList/rationComparisonList.html','<div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><div ng-include="\'app/pages/rations/rationComparisonList/rationComparison.tabs.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/rationComparisonList/rationComparisonList.table.html','<div class="row" style="margin: 10px 0px 0px 0px"><div class="col-xlg-4 col-lg-4 col-md-4 col-sm-12 col-xs-12"></div><div class="col-xlg-4 col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group"><div uib-tooltip="{{\'_tips_group_selector_\'|i18n}}" tooltip-is-open="tooltipIsOpen" tooltip-placement="bottom" tooltip-class="customBlue bottom" tooltip-popup-delay="500" uib-enabled="{{!vm.showGroupSelector}}"><ui-select ng-model="vm.selectedGroup" class="btn-group bootstrap-select form-control" ng-disabled="vm.loadingGroups || vm.loadingTable || !vm.showGroupSelector" append-to-body="true" search-enabled="true" on-select="vm.groupSelected()"><ui-select-match placeholder="{{\'_picker_group_placeholder_\' | i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="group in vm.groups | filter: $select.search"><span ng-bind-html="group.name"></span></ui-select-choices></ui-select></div></div></div></div><div class="row" style="margin: 10px"><div style="float: right"><span style="margin-right: 10px" ng-class="vm.selectedRations.length > 0 ? \'hover-animation\': \'\'" ng-click="vm.showSelected()" uib-tooltip="{{\'_tips_preview_selected_rations_\' | i18n}}" tooltip-is-open="tooltipIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" tooltip-enable="{{vm.selectedRations.length > 0}}"><data-i18n i18n="_title_no_rations_selected_">Number of rations selected</data-i18n>: {{vm.selectedRations.length}}</span> <button class="btn btn-primary" ng-click="vm.compare()"><data-i18n i18n="_btn_compare_">compare</data-i18n></button></div></div><div class="row" style="margin: 0px"><div class="horizontal-scroll"><table class="table" style="font-size: 14px"><thead><tr><th><data-i18n i18n="_title_column_action_">action</data-i18n></th><th><data-i18n i18n="_rations_ration_name_">ration name</data-i18n></th><th><data-i18n i18n="_groups_herd_name_">herd name</data-i18n></th><th><data-i18n i18n="_groups_group_name_">group name</data-i18n></th><th><data-i18n i18n="_rations_date_">create date</data-i18n></th></tr></thead><tbody ng-if="!vm.loadingTable"><tr ng-repeat="ration in vm.rations"><td><input type="checkbox" id="is_checked" ng-true-value="true" ng-false-value="false" ng-click="vm.select(ration)" ng-model="ration.is_selected" style="margin-right: 2px"></td><td>{{ration.ration_name}}</td><td>{{ration.herd_name}}</td><td>{{ration.group_name}}</td><td>{{ration.create_date |date:\'mediumDate\'}}</td></tr></tbody><tbody ng-if="vm.loadingTable"><tr><td colspan="5" class="text-center"><div><div id="loading-animation-large" style="display: inline-block"></div></div></td></tr></tbody><tfoot ng-if="!vm.loadingFooter && vm.showFooter"><tr><td colspan="5" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="10" max-size="7" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></td></tr></tfoot></table></div></div><div ng-if="!vm.selectedTeam" align="center"><div><h3><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></h3></div></div>');
$templateCache.put('app/pages/rations/rationComparisonList/selectedRations.modal.html','<div class="modal-content" ng-cloak=""><div class="modal-header"><div><table class="table modal-table"><thead><tr><th><data-i18n i18n="_rations_ration_name_">ration name</data-i18n></th><th><data-i18n i18n="_groups_herd_name_">herd name</data-i18n></th><th><data-i18n i18n="_groups_group_name_">group name</data-i18n></th><th><data-i18n i18n="_rations_date_">create date</data-i18n></th></tr></thead><tbody><tr ng-repeat="ration in vm.selectedRations"><td>{{ration.ration_name}}</td><td>{{ration.herd_name}}</td><td>{{ration.group_name}}</td><td>{{ration.create_date |date:\'mediumDate\'}}</td></tr></tbody></table><button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'animal_stage_breed\')" style="float: right"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistory.amino_acid.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_lys_\' | i18n}}" tooltip-is-open="lysIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lysine_">Lys</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th><th><div uib-tooltip="{{\'_description_met_\' | i18n}}" tooltip-is-open="metIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_methionine_">Met</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th><th><div uib-tooltip="{{\'_description_teaa_\' | i18n}}" tooltip-is-open="teaaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_teaa_">teaa</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.lysine | formatViewValues: \'lysine\'}}</td><td>{{feed.methionine | formatViewValues: \'methionine\'}}</td><td>{{feed.teaa | formatViewValues: \'teaa\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistory.cost.html','<div><table class="table table-hover-striped historyTable" st-table="vm.feeds"><thead><tr class="sortable" style="height: 30px"><th st-sort="feed_name" style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="dm"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br>%</div></th><th st-sort="cost_as_sold"><div uib-tooltip="{{\'_description_cost_as_sold_\' | i18n}}" tooltip-is-open="costAsSoldIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_as_sold_">cost as sold</data-i18n><br>{{vm.currency}}</div></th><th st-sort="wt_as_sold"><div uib-tooltip="{{\'_description_wt_as_sold_\' | i18n}}" tooltip-is-open="wtAsSoldIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_wt_as_sold_">wt as sold</data-i18n><br>{{vm.weight}}</div></th><th st-sort="cost_dm"><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th st-sort="is_purchased"><div uib-tooltip="{{\'_description_is_purchased_\' | i18n}}" tooltip-is-open="isPurchasedIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_purchased_">Purchased</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.dm | formatViewValues: \'dm\'}}</td><td>{{feed.cost_as_sold | formatViewValues: \'cost_as_sold\'}}</td><td>{{feed.wt_as_sold | formatViewValues: \'wt_as_sold\'}}</td><td>{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</td><td><span class="newCheck"><input type="checkbox" id="is_purchased{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="feed.is_purchased" disabled=""> <label for="is_purchased{{$index}}"></label></span></td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistory.html','<div><div class="row" ng-if="vm.selectedHerd"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><div ng-include="\'app/pages/rations/rationFeedHistory/rationFeedHistory.tabs.html\'"></div></div></div></div><div ba-panel="" ng-if="!vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistory.mineral.html','<div><table class="table table-hover-striped historyTable" st-table="vm.feeds"><thead><tr class="sortable" style="height: 30px"><th st-sort="feed_name" style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="ca"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="ca_abs"><div uib-tooltip="{{\'_description_ca_abs_\' | i18n}}" tooltip-is-open="absCaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_abs_">abs Ca</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ca_">Ca</data-i18n></div></th><th st-sort="p"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="p_abs"><div uib-tooltip="{{\'_description_p_abs_\' | i18n}}" tooltip-is-open="absPIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_p_">P</data-i18n></div></th><th st-sort="mg"><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">Mg</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="mg_abs"><div uib-tooltip="{{\'_description_mg_abs_\' | i18n}}" tooltip-is-open="absMgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_abs_">abs Mg</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_mg_">Mg</data-i18n></div></th><th st-sort="k"><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">K</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="na"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="cl"><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">Cl</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="s"><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">S</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="dcad"><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th st-sort="ash"><div uib-tooltip="{{\'_description_ash_\' | i18n}}" tooltip-is-open="ashIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ash_">ash</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.ca | formatViewValues: \'ca\': feed.dm}}</td><td>{{feed.ca_abs | formatViewValues: \'ca_abs\'}}</td><td>{{feed.p | formatViewValues: \'p\': feed.dm}}</td><td>{{feed.p_abs | formatViewValues: \'p_abs\'}}</td><td>{{feed.mg | formatViewValues: \'mg\': feed.dm}}</td><td>{{feed.mg_abs | formatViewValues: \'mg_abs\'}}</td><td>{{feed.k | formatViewValues: \'k\': feed.dm}}</td><td>{{feed.na | formatViewValues: \'na\': feed.dm}}</td><td>{{feed.cl | formatViewValues: \'cl\': feed.dm}}</td><td>{{feed.s | formatViewValues: \'s\': feed.dm}}</td><td>{{feed.dcad | formatViewValues: \'dcad\'}}</td><td>{{feed.ash | formatViewValues: \'ash\': feed.dm}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistory.misc.html','<div><table class="table table-hover-striped historyTable" st-table="vm.feeds"><thead><tr class="sortable" style="height: 30px"><th><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="feed_type"><div uib-tooltip="{{\'_description_feed_type_\' | i18n}}" tooltip-is-open="feedTypeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_type_">feed type</data-i18n><br></div></th><th st-sort="common_feed"><div uib-tooltip="{{\'_description_common_feed_\' | i18n}}" tooltip-is-open="commonIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_common_">Common feed</data-i18n><br></div></th><th st-sort="blank_1"><div uib-tooltip="{{\'_description_blank_1_\' | i18n}}" tooltip-is-open="blank1IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>1<br></div></th><th st-sort="blank_2"><div uib-tooltip="{{\'_description_blank_2_\' | i18n}}" tooltip-is-open="blank2IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>2<br></div></th><th st-sort="blank_3"><div uib-tooltip="{{\'_description_blank_3_\' | i18n}}" tooltip-is-open="blank3IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>3<br></div></th><th st-sort="blank_4"><div uib-tooltip="{{\'_description_blank_4_\' | i18n}}" tooltip-is-open="blank4IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>4<br></div></th><th st-sort="blank_5"><div uib-tooltip="{{\'_description_blank_5_\' | i18n}}" tooltip-is-open="blank5IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>5<br></div></th><th><div uib-tooltip="{{\'_description_comment_\' | i18n}}" tooltip-is-open="commentIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_comment_">Comment</data-i18n><br></div></th><th st-sort="test_date"><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.feed_type.show_name | i18n}}</td><td><span class="newCheck"><input type="checkbox" id="is_common{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="feed.common_feed" disabled=""> <label for="is_common{{$index}}"></label></span></td><td>{{feed.blank_1}}</td><td>{{feed.blank_2}}</td><td>{{feed.blank_3}}</td><td>{{feed.blank_4}}</td><td>{{feed.blank_5}}</td><td>{{feed.comments}}</td><td>{{ feed.test_date | date: vm.date_format}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistory.tabs.html','<div><button type="button" class="btn btn-primary btn-xs" ng-click="vm.goBack()" style="margin: 10px"><i class="ion-arrow-left-c"><data-i18n i18n="_btn_back_">back</data-i18n></i></button><uib-tabset active="$tabSetStatus.activeTab" ng-if="!vm.loading"><uib-tab heading="{{\'_feeds_tab_home_\'|i18n}}" select="vm.selectedTab=1"><div class="row" ng-if="vm.selectedTab == 1"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryHome/rationFeedHistory.home.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryHome/rationFeedHistory.home.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryHome/rationFeedHistory.home.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryHome/rationFeedHistory.home.VemDve.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 1 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryHome/rationFeedHistoryMix.home.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryHome/rationFeedHistoryMix.home.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryHome/rationFeedHistoryMix.home.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryHome/rationFeedHistoryMix.home.VemDve.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_fiber_\'|i18n}}" select="vm.selectedTab=2"><div class="row" ng-if="vm.selectedTab == 2"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryFiber/rationFeedHistory.fiber.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryFiber/rationFeedHistory.fiber.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryFiber/rationFeedHistory.fiber.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryFiber/rationFeedHistory.fiber.VemDve.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 2 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryFiber/rationFeedHistoryMix.fiber.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryFiber/rationFeedHistoryMix.fiber.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryFiber/rationFeedHistoryMix.fiber.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryFiber/rationFeedHistoryMix.fiber.VemDve.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_energy_\'|i18n}}" select="vm.selectedTab=3"><div class="row" ng-if="vm.selectedTab == 3"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryEnergy/rationFeedHistory.energy.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryEnergy/rationFeedHistory.energy.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryEnergy/rationFeedHistory.energy.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryEnergy/rationFeedHistory.energy.VemDve.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 3 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryEnergy/rationFeedHistoryMix.energy.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryEnergy/rationFeedHistoryMix.energy.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryEnergy/rationFeedHistoryMix.energy.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryEnergy/rationFeedHistoryMix.energy.VemDve.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_protein_\'|i18n}}" select="vm.selectedTab=4"><div class="row" ng-if="vm.selectedTab == 4"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryProtein/rationFeedHistory.protein.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryProtein/rationFeedHistory.protein.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryProtein/rationFeedHistory.protein.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryProtein/rationFeedHistory.protein.VemDve.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 4 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryProtein/rationFeedHistoryMix.protein.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryProtein/rationFeedHistoryMix.protein.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryProtein/rationFeedHistoryMix.protein.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryProtein/rationFeedHistoryMix.protein.VemDve.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_carb_\'|i18n}}" select="vm.selectedTab=5"><div class="row" ng-if="vm.selectedTab == 5"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryCarb/rationFeedHistory.carb.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryCarb/rationFeedHistory.carb.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryCarb/rationFeedHistory.carb.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryCarb/rationFeedHistory.carb.VemDve.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 5 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryCarb/rationFeedHistoryMix.carb.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryCarb/rationFeedHistoryMix.carb.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryCarb/rationFeedHistoryMix.carb.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryCarb/rationFeedHistoryMix.carb.VemDve.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_lipid_\'|i18n}}" select="vm.selectedTab=6"><div class="row" ng-if="vm.selectedTab == 6"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryLipid/rationFeedHistory.lipid.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryLipid/rationFeedHistory.lipid.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryLipid/rationFeedHistory.lipid.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryLipid/rationFeedHistory.lipid.VemDve.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 6 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ng-if="vm.feedCalculationType != null && vm.feedCalculationType != undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.feedCalculationType == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryLipid/rationFeedHistoryMix.lipid.US.html"></div><div ng-if="vm.feedCalculationType == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryLipid/rationFeedHistoryMix.lipid.VemDve.html"></div></div><div ng-if="vm.feedCalculationType == null || vm.feedCalculationType == undefined" ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.settings.calculation_type == 0" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryLipid/rationFeedHistoryMix.lipid.US.html"></div><div ng-if="vm.settings.calculation_type == 1" include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryLipid/rationFeedHistoryMix.lipid.VemDve.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_mineral_\'|i18n}}" select="vm.selectedTab=7"><div class="row" ng-if="vm.selectedTab == 7"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistory.mineral.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 7 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryMix.mineral.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_trace_min_\'|i18n}}" select="vm.selectedTab=8"><div class="row" ng-if="vm.selectedTab == 8"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistory.trace_min.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 8 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryMix.trace_min.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_vitamin_\'|i18n}}" select="vm.selectedTab=9"><div class="row" ng-if="vm.selectedTab == 9"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistory.vitamin.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 9 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryMix.vitamin.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_amino_acid_\'|i18n}}" select="vm.selectedTab=10"><div class="row" ng-if="vm.selectedTab == 10"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistory.amino_acid.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 10 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryMix.amino_acid.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_cost_\'|i18n}}" select="vm.selectedTab=11"><div class="row" ng-if="vm.selectedTab == 11"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistory.cost.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 11 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryMix.cost.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_misc_\'|i18n}}" select="vm.selectedTab=12"><div class="row" ng-if="vm.selectedTab == 12"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistory.misc.html"></div></div></div></div><div class="row" ng-if="vm.selectedTab == 12 && vm.showMix && vm.showDetails"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationFeedHistory/rationFeedHistoryMix.misc.html"></div></div></div></div></uib-tab></uib-tabset><div ng-if="vm.showDetails && !vm.loading"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="vm.closeDetailsWindow()"><data-i18n i18n="_btn_hide_">Hide</data-i18n></button></div></div><div ng-if="vm.loading" align="center" style="overflow: hidden"><div id="loading-animation-large" style="display: inline-block"></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistory.trace_min.html','<div><table class="table table-hover-striped historyTable" st-table="vm.feeds"><thead><tr class="sortable" style="height: 30px"><th st-sort="feed_name" style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="co"><div uib-tooltip="{{\'_description_co_\' | i18n}}" tooltip-is-open="coIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_co_">Co</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th st-sort="cu"><div uib-tooltip="{{\'_description_cu_\' | i18n}}" tooltip-is-open="cuIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cu_">Cu</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th st-sort="cu_abs"><div uib-tooltip="{{\'_description_cu_abs_\' | i18n}}" tooltip-is-open="absCuIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cu_abs_">abs Cu</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cu_">Cu</data-i18n></div></th><th st-sort="fe"><div uib-tooltip="{{\'_description_fe_\' | i18n}}" tooltip-is-open="feIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fe_">Fe</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th st-sort="fe_abs"><div uib-tooltip="{{\'_description_fe_abs_\' | i18n}}" tooltip-is-open="absFeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fe_abs_">abs Fe</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fe_">Fe</data-i18n></div></th><th st-sort="i"><div uib-tooltip="{{\'_description_i_\' | i18n}}" tooltip-is-open="iIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_i_">I</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th st-sort="i_abs"><div uib-tooltip="{{\'_description_i_abs_\' | i18n}}" tooltip-is-open="absIIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_i_abs_">abs I</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_i_">I</data-i18n></div></th><th st-sort="mo"><div uib-tooltip="{{\'_description_mo_\' | i18n}}" tooltip-is-open="moIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mo_">Mo</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th st-sort="mn"><div uib-tooltip="{{\'_description_mn_\' | i18n}}" tooltip-is-open="mnIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mn_">Mn</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th st-sort="mn_abs"><div uib-tooltip="{{\'_description_mn_abs_\' | i18n}}" tooltip-is-open="absMnIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mn_abs_">abs Mn</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_mn_">Mn</data-i18n></div></th><th st-sort="se"><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th st-sort="se_abs"><div uib-tooltip="{{\'_description_se_abs_\' | i18n}}" tooltip-is-open="absSeIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_abs_">abs Se</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_se_">Se</data-i18n></div></th><th st-sort="zn"><div uib-tooltip="{{\'_description_zn_\' | i18n}}" tooltip-is-open="znIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_zn_">Zn</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th st-sort="zn_abs"><div uib-tooltip="{{\'_description_zn_abs_\' | i18n}}" tooltip-is-open="absZnIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_zn_abs_">abs Zn</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_zn_">Zn</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.co | formatViewValues: \'co\'}}</td><td>{{feed.cu | formatViewValues: \'cu\'}}</td><td>{{feed.cu_abs | formatViewValues: \'cu_abs\'}}</td><td>{{feed.fe | formatViewValues: \'fe\'}}</td><td>{{feed.fe_abs | formatViewValues: \'fe_abs\'}}</td><td>{{feed.i | formatViewValues: \'i\'}}</td><td>{{feed.i_abs | formatViewValues: \'i_abs\'}}</td><td>{{feed.mo | formatViewValues: \'mo\'}}</td><td>{{feed.mn | formatViewValues: \'mn\'}}</td><td>{{feed.mn_abs | formatViewValues: \'mn_abs\'}}</td><td>{{feed.se | formatViewValues: \'se\'}}</td><td>{{feed.se_abs | formatViewValues: \'se_abs\'}}</td><td>{{feed.zn | formatViewValues: \'zn\'}}</td><td>{{feed.zn_abs | formatViewValues: \'zn_abs\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistory.vitamin.html','<div><table class="table table-hover-striped historyTable" st-table="vm.feeds"><thead><tr class="sortable" style="height: 30px"><th st-sort="feed_name" style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="vitamin_a"><div uib-tooltip="{{\'_description_vitamin_a_\' | i18n}}" tooltip-is-open="vitAIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_a_">vit a</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th st-sort="vitamin_d"><div uib-tooltip="{{\'_description_vitamin_d_\' | i18n}}" tooltip-is-open="vitDIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_d_">vit d</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th st-sort="vitamin_e"><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.vitamin_a | formatViewValues: \'vitamin_a\'}}</td><td>{{feed.vitamin_d | formatViewValues: \'vitamin_d\'}}</td><td>{{feed.vitamin_e | formatViewValues: \'vitamin_e\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryMix.amino_acid.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_lys_\' | i18n}}" tooltip-is-open="lysIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lysine_">Lys</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th><th><div uib-tooltip="{{\'_description_met_\' | i18n}}" tooltip-is-open="metIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_methionine_">Met</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th><th><div uib-tooltip="{{\'_description_teaa_\' | i18n}}" tooltip-is-open="teaaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_teaa_">teaa</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.lysine_changed ? \'property-changed\' : \'\'">{{feed.lysine | formatViewValues: \'lysine\'}}</td><td ng-class="feed.methionine_changed ? \'property-changed\' : \'\'">{{feed.methionine | formatViewValues: \'methionine\'}}</td><td ng-class="feed.teaa_changed ? \'property-changed\' : \'\'">{{feed.teaa | formatViewValues: \'teaa\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryMix.cost.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br>%</div></th><th><div uib-tooltip="{{\'_description_cost_as_sold_\' | i18n}}" tooltip-is-open="costAsSoldIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_as_sold_">cost as sold</data-i18n><br>{{vm.currency}}</div></th><th><div uib-tooltip="{{\'_description_wt_as_sold_\' | i18n}}" tooltip-is-open="wtAsSoldIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_wt_as_sold_">wt as sold</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_is_purchased_\' | i18n}}" tooltip-is-open="isPurchasedIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_purchased_">Purchased</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.dm_changed ? \'property-changed\' : \'\'">{{feed.dm | formatViewValues: \'dm\'}}</td><td ng-class="feed.cost_as_sold_changed ? \'property-changed\' : \'\'">{{feed.cost_as_sold | formatViewValues: \'cost_as_sold\'}}</td><td ng-class="feed.wt_as_sold_changed ? \'property-changed\' : \'\'">{{feed.wt_as_sold | formatViewValues: \'wt_as_sold\'}}</td><td ng-class="feed.cost_dm_changed ? \'property-changed\' : \'\'">{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</td><td ng-class="feed.is_purchased_changed ? \'property-changed\' : \'\'"><span class="newCheck"><input type="checkbox" id="is_purchased{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="feed.is_purchased" disabled=""> <label for="is_purchased{{$index}}"></label></span></td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryMix.mineral.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ca_abs_\' | i18n}}" tooltip-is-open="absCaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_abs_">abs Ca</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ca_">Ca</data-i18n></div></th><th><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_p_abs_\' | i18n}}" tooltip-is-open="absPIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_p_">P</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">Mg</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_mg_abs_\' | i18n}}" tooltip-is-open="absMgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_abs_">abs Mg</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_mg_">Mg</data-i18n></div></th><th><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">K</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">Cl</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">S</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th><div uib-tooltip="{{\'_description_ash_\' | i18n}}" tooltip-is-open="ashIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ash_">ash</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.ca_changed ? \'property-changed\' : \'\'">{{feed.ca | formatViewValues: \'ca\': feed.dm}}</td><td ng-class="feed.ca_abs_changed ? \'property-changed\' : \'\'">{{feed.ca_abs | formatViewValues: \'ca_abs\'}}</td><td ng-class="feed.p_changed ? \'property-changed\' : \'\'">{{feed.p | formatViewValues: \'p\': feed.dm}}</td><td ng-class="feed.p_abs_changed ? \'property-changed\' : \'\'">{{feed.p_abs | formatViewValues: \'p_abs\'}}</td><td ng-class="feed.mg_changed ? \'property-changed\' : \'\'">{{feed.mg | formatViewValues: \'mg\': feed.dm}}</td><td ng-class="feed.mg_abs_changed ? \'property-changed\' : \'\'">{{feed.mg_abs | formatViewValues: \'mg_abs\'}}</td><td ng-class="feed.k_changed ? \'property-changed\' : \'\'">{{feed.k | formatViewValues: \'k\': feed.dm}}</td><td ng-class="feed.na_changed ? \'property-changed\' : \'\'">{{feed.na | formatViewValues: \'na\': feed.dm}}</td><td ng-class="feed.cl_changed ? \'property-changed\' : \'\'">{{feed.cl | formatViewValues: \'cl\': feed.dm}}</td><td ng-class="feed.s_changed ? \'property-changed\' : \'\'">{{feed.s | formatViewValues: \'s\': feed.dm}}</td><td ng-class="feed.dcad_changed ? \'property-changed\' : \'\'">{{feed.dcad | formatViewValues: \'dcad\'}}</td><td ng-class="feed.ash_changed ? \'property-changed\' : \'\'">{{feed.ash | formatViewValues: \'ash\': feed.dm}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryMix.misc.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_feed_type_\' | i18n}}" tooltip-is-open="feedTypeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_type_">feed type</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_common_feed_\' | i18n}}" tooltip-is-open="commonIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_common_">Common feed</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_blank_1_\' | i18n}}" tooltip-is-open="blank1IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>1<br></div></th><th><div uib-tooltip="{{\'_description_blank_2_\' | i18n}}" tooltip-is-open="blank2IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>2<br></div></th><th><div uib-tooltip="{{\'_description_blank_3_\' | i18n}}" tooltip-is-open="blank3IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>3<br></div></th><th><div uib-tooltip="{{\'_description_blank_4_\' | i18n}}" tooltip-is-open="blank4IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>4<br></div></th><th><div uib-tooltip="{{\'_description_blank_5_\' | i18n}}" tooltip-is-open="blank5IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>5<br></div></th><th><div uib-tooltip="{{\'_description_comment_\' | i18n}}" tooltip-is-open="commentIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_comment_">Comment</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.feed_type_changed ? \'property-changed\' : \'\'">{{feed.feed_type.show_name | i18n}}</td><td ng-class="feed.is_purchased_changed ? \'property-changed\' : \'\'"><span class="newCheck"><input type="checkbox" id="is_common{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="feed.common_feed" disabled=""> <label for="is_common{{$index}}"></label></span></td><td ng-class="feed.blank_1_changed ? \'property-changed\' : \'\'">{{feed.blank_1}}</td><td ng-class="feed.blank_2_changed ? \'property-changed\' : \'\'">{{feed.blank_2}}</td><td ng-class="feed.blank_3_changed ? \'property-changed\' : \'\'">{{feed.blank_3}}</td><td ng-class="feed.blank_4_changed ? \'property-changed\' : \'\'">{{feed.blank_4}}</td><td ng-class="feed.blank_5_changed ? \'property-changed\' : \'\'">{{feed.blank_5}}</td><td ng-class="feed.comments_changed ? \'property-changed\' : \'\'">{{feed.comments}}</td><td ng-class="feed.test_date_changed ? \'property-changed\' : \'\'">{{ feed.test_date | date: vm.date_format}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryMix.trace_min.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_co_\' | i18n}}" tooltip-is-open="coIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_co_">Co</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_cu_\' | i18n}}" tooltip-is-open="cuIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cu_">Cu</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_cu_abs_\' | i18n}}" tooltip-is-open="absCuIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cu_abs_">abs Cu</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cu_">Cu</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fe_\' | i18n}}" tooltip-is-open="feIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fe_">Fe</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fe_abs_\' | i18n}}" tooltip-is-open="absFeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fe_abs_">abs Fe</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fe_">Fe</data-i18n></div></th><th><div uib-tooltip="{{\'_description_i_\' | i18n}}" tooltip-is-open="iIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_i_">I</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_i_abs_\' | i18n}}" tooltip-is-open="absIIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_i_abs_">abs I</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_i_">I</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mo_\' | i18n}}" tooltip-is-open="moIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mo_">Mo</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mn_\' | i18n}}" tooltip-is-open="mnIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mn_">Mn</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mn_abs_\' | i18n}}" tooltip-is-open="absMnIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mn_abs_">abs Mn</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_mn_">Mn</data-i18n></div></th><th><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_se_abs_\' | i18n}}" tooltip-is-open="absSeIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_abs_">abs Se</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_se_">Se</data-i18n></div></th><th><div uib-tooltip="{{\'_description_zn_\' | i18n}}" tooltip-is-open="znIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_zn_">Zn</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_zn_abs_\' | i18n}}" tooltip-is-open="absZnIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_zn_abs_">abs Zn</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_zn_">Zn</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.co_changed ? \'property-changed\' : \'\'">{{feed.co | formatViewValues: \'co\'}}</td><td ng-class="feed.cu_changed ? \'property-changed\' : \'\'">{{feed.cu | formatViewValues: \'cu\'}}</td><td ng-class="feed.cu_abs_changed ? \'property-changed\' : \'\'">{{feed.cu_abs | formatViewValues: \'cu_abs\'}}</td><td ng-class="feed.fe_changed ? \'property-changed\' : \'\'">{{feed.fe | formatViewValues: \'fe\'}}</td><td ng-class="feed.fe_abs_changed ? \'property-changed\' : \'\'">{{feed.fe_abs | formatViewValues: \'fe_abs\'}}</td><td ng-class="feed.i_changed ? \'property-changed\' : \'\'">{{feed.i | formatViewValues: \'i\'}}</td><td ng-class="feed.i_abs_changed ? \'property-changed\' : \'\'">{{feed.i_abs | formatViewValues: \'i_abs\'}}</td><td ng-class="feed.mo_changed ? \'property-changed\' : \'\'">{{feed.mo | formatViewValues: \'mo\'}}</td><td ng-class="feed.mn_changed ? \'property-changed\' : \'\'">{{feed.mn | formatViewValues: \'mn\'}}</td><td ng-class="feed.mn_abs_changed ? \'property-changed\' : \'\'">{{feed.mn_abs | formatViewValues: \'mn_abs\'}}</td><td ng-class="feed.se_changed ? \'property-changed\' : \'\'">{{feed.se | formatViewValues: \'se\'}}</td><td ng-class="feed.se_abs_changed ? \'property-changed\' : \'\'">{{feed.se_abs | formatViewValues: \'se_abs\'}}</td><td ng-class="feed.zn_changed ? \'property-changed\' : \'\'">{{feed.zn | formatViewValues: \'zn\'}}</td><td ng-class="feed.zn_abs_changed ? \'property-changed\' : \'\'">{{feed.zn_abs | formatViewValues: \'zn_abs\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryMix.vitamin.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_vitamin_a_\' | i18n}}" tooltip-is-open="vitAIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_a_">vit a</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_vitamin_d_\' | i18n}}" tooltip-is-open="vitDIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_d_">vit d</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.vitamin_a_changed ? \'property-changed\' : \'\'">{{feed.vitamin_a | formatViewValues: \'vitamin_a\'}}</td><td ng-class="feed.vitamin_d_changed ? \'property-changed\' : \'\'">{{feed.vitamin_d | formatViewValues: \'vitamin_d\'}}</td><td ng-class="feed.vitamin_e_changed ? \'property-changed\' : \'\'">{{feed.vitamin_e | formatViewValues: \'vitamin_e\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistory.amino_acid.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_lys_\' | i18n}}" tooltip-is-open="lysIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lysine_">Lys</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th><th><div uib-tooltip="{{\'_description_met_\' | i18n}}" tooltip-is-open="metIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_methionine_">Met</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th><th><div uib-tooltip="{{\'_description_teaa_\' | i18n}}" tooltip-is-open="teaaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_teaa_">teaa</data-i18n><br>%&nbsp;<data-i18b i18n="_feeds_drup_">dRUP</data-i18b></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.lysine | formatViewValues: \'lysine\'}}</td><td>{{feed.methionine | formatViewValues: \'methionine\'}}</td><td>{{feed.teaa | formatViewValues: \'teaa\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistory.cost.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br>%</div></th><th><div uib-tooltip="{{\'_description_cost_as_sold_\' | i18n}}" tooltip-is-open="costAsSoldIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_as_sold_">cost as sold</data-i18n><br>{{vm.currency}}</div></th><th><div uib-tooltip="{{\'_description_wt_as_sold_\' | i18n}}" tooltip-is-open="wtAsSoldIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_wt_as_sold_">wt as sold</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_is_purchased_\' | i18n}}" tooltip-is-open="isPurchasedIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_purchased_">Purchased</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td style="white-space: nowrap">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.dm | formatViewValues: \'dm\'}}</td><td>{{feed.cost_as_sold | formatViewValues: \'cost_as_sold\'}}</td><td>{{feed.wt_as_sold | formatViewValues: \'wt_as_sold\'}}</td><td>{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</td><td><span class="newCheck"><input type="checkbox" id="is_purchased{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="feed.is_purchased" disabled=""> <label for="is_purchased{{$index}}"></label></span></td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistory.html','<div class="widgets"><div ng-if="!vm.loading"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationHistory/rationHistory.table.html"></div></div></div></div><div class="row"><div class="col-md-12" ng-if="vm.showFeeds"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><div ng-include="\'app/pages/rations/rationHistory/rationHistory.tabs.html\'"></div></div></div></div></div><div class="col-md-12" ng-if="vm.loading && vm.selectedHerd"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel"><div align="center"><div style="overflow: hidden"><div id="loading-animation-large" style="display: inline-block"></div></div></div></div></div><div ba-panel="" ng-if="!vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistory.mineral.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ca_abs_\' | i18n}}" tooltip-is-open="absCaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_abs_">abs Ca</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ca_">Ca</data-i18n></div></th><th><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_p_abs_\' | i18n}}" tooltip-is-open="absPIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_abs_">abs P</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_p_">P</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">Mg</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_mg_abs_\' | i18n}}" tooltip-is-open="absMgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_abs_">abs Mg</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_mg_">Mg</data-i18n></div></th><th><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">K</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">Cl</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">S</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th><div uib-tooltip="{{\'_description_ash_\' | i18n}}" tooltip-is-open="ashIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ash_">ash</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.ca | formatViewValues: \'ca\': feed.dm}}</td><td>{{feed.ca_abs | formatViewValues: \'ca_abs\'}}</td><td>{{feed.p | formatViewValues: \'p\': feed.dm}}</td><td>{{feed.p_abs | formatViewValues: \'p_abs\'}}</td><td>{{feed.mg | formatViewValues: \'mg\': feed.dm}}</td><td>{{feed.mg_abs | formatViewValues: \'mg_abs\'}}</td><td>{{feed.k | formatViewValues: \'k\': feed.dm}}</td><td>{{feed.na | formatViewValues: \'na\': feed.dm}}</td><td>{{feed.cl | formatViewValues: \'cl\': feed.dm}}</td><td>{{feed.s | formatViewValues: \'s\': feed.dm}}</td><td>{{feed.dcad | formatViewValues: \'dcad\'}}</td><td>{{feed.ash | formatViewValues: \'ash\': feed.dm}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistory.misc.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_feed_type_\' | i18n}}" tooltip-is-open="feedTypeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_type_">feed type</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_common_feed_\' | i18n}}" tooltip-is-open="commonIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_common_">Common feed</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_blank_1_\' | i18n}}" tooltip-is-open="blank1IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>1<br></div></th><th><div uib-tooltip="{{\'_description_blank_2_\' | i18n}}" tooltip-is-open="blank2IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>2<br></div></th><th><div uib-tooltip="{{\'_description_blank_3_\' | i18n}}" tooltip-is-open="blank3IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>3<br></div></th><th><div uib-tooltip="{{\'_description_blank_4_\' | i18n}}" tooltip-is-open="blank4IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>4<br></div></th><th><div uib-tooltip="{{\'_description_blank_5_\' | i18n}}" tooltip-is-open="blank5IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_blank_">blank</data-i18n>5<br></div></th><th><div uib-tooltip="{{\'_description_comment_\' | i18n}}" tooltip-is-open="commentIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_comment_">Comment</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.feed_type.show_name | i18n}}</td><td><span class="newCheck"><input type="checkbox" id="is_common{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="feed.common_feed" disabled=""> <label for="is_common{{$index}}"></label></span></td><td>{{feed.blank_1}}</td><td>{{feed.blank_2}}</td><td>{{feed.blank_3}}</td><td>{{feed.blank_4}}</td><td>{{feed.blank_5}}</td><td>{{feed.comments}}</td><td>{{feed.test_date | date: vm.date_format}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistory.table.html','<div class="vertical-scroll"><table class="table table-hover" st-table="vm.rations"><thead><tr class="sortable"><th><button type="button" class="btn btn-primary btn-xs" ng-click="vm.showFeeds = !vm.showFeeds"><i class="ion-clipboard"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goBack()"><i class="ion-arrow-left-c"><data-i18n i18n="_btn_back_">back</data-i18n></i></button></th><th><data-i18n i18n="_rations_ration_name_">ation name</data-i18n><br></th><th><data-i18n i18n="_title_create_date">create date</data-i18n><br></th><th><data-i18n i18n="_title_user_">user</data-i18n><br></th><th><data-i18n i18n="_title_last_modified_date_">last modified date</data-i18n><br></th><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br></th><th><data-i18n i18n="_rations_temperature_stress_">temperature stress</data-i18n><br></th><th><data-i18n i18n="_rations_temperature_stress_">temperature stress</data-i18n><br><data-i18n i18n="_rations_energy_">Energy</data-i18n><data-i18n i18n="_unit_adj_percents_">adj. %</data-i18n></th><th><data-i18n i18n="_rations_temperature_stress_">temperature stress</data-i18n><br><data-i18n i18n="_feeds_dmi_">DMI</data-i18n><data-i18n i18n="_unit_adj_percents_">adj. %</data-i18n></th><th><data-i18n i18n="_rations_panel_activity_level_">activity level</data-i18n><br></th><th><data-i18n i18n="_rations_panel_activity_level_">activity level</data-i18n><br><data-i18n i18n="_rations_energy_">Energy</data-i18n><data-i18n i18n="_unit_adj_percents_">adj. %</data-i18n></th><th><data-i18n i18n="_rations_panel_activity_level_">activity level</data-i18n><br><data-i18n i18n="_feeds_dmi_">DMI</data-i18n><data-i18n i18n="_unit_adj_percents_">adj. %</data-i18n></th><th><data-i18n i18n="_rations_animal_feed_additives_">feed additives</data-i18n><br></th><th><data-i18n i18n="_rations_energetic_efficiency_">energetic efficiency</data-i18n><br>%</th><th><data-i18n i18n="_rations_mic_protein_efficiency_">Mic. protein efficiency</data-i18n><br>%</th><th><data-i18n i18n="_rations_rup_efficiency_">RUP efficiency</data-i18n><br>%</th><th><data-i18n i18n="_rations_dmi_factor_">DMI factor</data-i18n><br>%</th><th><data-i18n i18n="_rations_maint_reqt_">Maint. reqt.</data-i18n><br>%</th><th><data-i18n i18n="_rations_ration_metabolizable_protein_system_">Metabolizable protein system</data-i18n><br></th><th><data-i18n i18n="_rations_energy_potential_">Energy potential</data-i18n><br></th><th><data-i18n i18n="_rations_nitrogen_potential_">Nitrogren potential</data-i18n><br></th></tr></thead><tbody><tr ng-repeat="ration in vm.rations"><td></td><td>{{ration.ration_name}}</td><td>{{ration.create_date | date:\'short\'}}</td><td>{{ration.last_modified_user}}</td><td>{{ration.last_modified_date | date:\'short\'}}</td><td>{{ration.action}}</td><td>{{ration.temperature_stress | i18n}}</td><td>{{ration.ts_maint_energy}}</td><td>{{ration.ts_dmi}}</td><td>{{ration.activity_level| i18n}}</td><td>{{ration.al_maint_energy}}</td><td>{{ration.al_dmi}}</td><td>{{ration.description| i18n}}</td><td>{{ration.energetic_efficiency}}</td><td>{{ration.mic_protein_efficiency}}</td><td>{{ration.rup_efficiency}}</td><td>{{ration.dmi_factor}}</td><td>{{ration.maint_reqt}}</td><td>{{ration.model_name| i18n}}</td><td>{{ration.energy_potential}}</td><td>{{ration.nitrogen_potential}}</td></tr></tbody></table><div ng-if="vm.loading" align="center"><div style="overflow: hidden"><div id="loading-animation-large" style="display: inline-block"></div></div></div></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistory.tabs.html','<div><uib-tabset active="$tabSetStatus.activeTab" ng-if="!vm.loading"><uib-tab heading="{{\'_feeds_tab_home_\'|i18n}}" select="vm.selectedTab=1"><div class="row" ng-if="vm.selectedTab == 1"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.calculationType == 0" include-with-scope="app/pages/rations/rationHistory/rationHistoryHome/rationHistory.home.US.html"></div><div ng-if="vm.calculationType == 1" include-with-scope="app/pages/rations/rationHistory/rationHistoryHome/rationHistory.home.VemDve.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_fiber_\'|i18n}}" select="vm.selectedTab=2"><div class="row" ng-if="vm.selectedTab == 2"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.calculationType == 0" include-with-scope="app/pages/rations/rationHistory/rationHistoryFiber/rationHistory.fiber.US.html"></div><div ng-if="vm.calculationType == 1" include-with-scope="app/pages/rations/rationHistory/rationHistoryFiber/rationHistory.fiber.VemDve.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_energy_\'|i18n}}" select="vm.selectedTab=3"><div class="row" ng-if="vm.selectedTab == 3"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.calculationType == 0" include-with-scope="app/pages/rations/rationHistory/rationHistoryEnergy/rationHistory.energy.US.html"></div><div ng-if="vm.calculationType == 1" include-with-scope="app/pages/rations/rationHistory/rationHistoryEnergy/rationHistory.energy.VemDve.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_protein_\'|i18n}}" select="vm.selectedTab=4"><div class="row" ng-if="vm.selectedTab == 4"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.calculationType == 0" include-with-scope="app/pages/rations/rationHistory/rationHistoryProtein/rationHistory.protein.US.html"></div><div ng-if="vm.calculationType== 1" include-with-scope="app/pages/rations/rationHistory/rationHistoryProtein/rationHistory.protein.VemDve.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_carb_\'|i18n}}" select="vm.selectedTab=5"><div class="row" ng-if="vm.selectedTab == 5"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.calculationType == 0" include-with-scope="app/pages/rations/rationHistory/rationHistoryCarb/rationHistory.carb.US.html"></div><div ng-if="vm.calculationType == 1" include-with-scope="app/pages/rations/rationHistory/rationHistoryCarb/rationHistory.carb.VemDve.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_lipid_\'|i18n}}" select="vm.selectedTab=6"><div class="row" ng-if="vm.selectedTab == 6"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-if="vm.calculationType == 0" include-with-scope="app/pages/rations/rationHistory/rationHistoryLipid/rationHistory.lipid.US.html"></div><div ng-if="vm.calculationType == 1" include-with-scope="app/pages/rations/rationHistory/rationHistoryLipid/rationHistory.lipid.VemDve.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_mineral_\'|i18n}}" select="vm.selectedTab=7"><div class="row" ng-if="vm.selectedTab == 7"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationHistory/rationHistory.mineral.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_trace_min_\'|i18n}}" select="vm.selectedTab=8"><div class="row" ng-if="vm.selectedTab == 8"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationHistory/rationHistory.trace_min.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_vitamin_\'|i18n}}" select="vm.selectedTab=9"><div class="row" ng-if="vm.selectedTab == 9"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationHistory/rationHistory.vitamin.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_amino_acid_\'|i18n}}" select="vm.selectedTab=10"><div class="row" ng-if="vm.selectedTab == 10"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationHistory/rationHistory.amino_acid.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_cost_\'|i18n}}" select="vm.selectedTab=11"><div class="row" ng-if="vm.selectedTab == 11"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationHistory/rationHistory.cost.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_feeds_tab_misc_\'|i18n}}" select="vm.selectedTab=12"><div class="row" ng-if="vm.selectedTab == 12"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/rationHistory/rationHistory.misc.html"></div></div></div></div></uib-tab></uib-tabset></div><div ng-if="vm.loading" align="center"><div style="overflow: hidden"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistory.trace_min.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_co_\' | i18n}}" tooltip-is-open="coIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_co_">Co</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_cu_\' | i18n}}" tooltip-is-open="cuIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cu_">Cu</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_cu_abs_\' | i18n}}" tooltip-is-open="absCuIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cu_abs_">abs Cu</data-i18n><br>%<data-i18n i18n="_feeds_cu_">Cu</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fe_\' | i18n}}" tooltip-is-open="feIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fe_">Fe</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fe_abs_\' | i18n}}" tooltip-is-open="absFeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fe_abs_">abs Fe</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fe_">Fe</data-i18n></div></th><th><div uib-tooltip="{{\'_description_i_\' | i18n}}" tooltip-is-open="iIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_i_">I</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_i_abs_\' | i18n}}" tooltip-is-open="absIIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_i_abs_">abs I</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_i_">I</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mo_\' | i18n}}" tooltip-is-open="moIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mo_">Mo</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mn_\' | i18n}}" tooltip-is-open="mnIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mn_">Mn</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mn_abs_\' | i18n}}" tooltip-is-open="absMnIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mn_abs_">abs Mn</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_mn_">Mn</data-i18n></div></th><th><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_se_abs_\' | i18n}}" tooltip-is-open="absSeIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_abs_">abs Se</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_se_">Se</data-i18n></div></th><th><div uib-tooltip="{{\'_description_zn_\' | i18n}}" tooltip-is-open="znIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_zn_">Zn</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_zn_abs_\' | i18n}}" tooltip-is-open="absZnIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_zn_abs_">abs Zn</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_zn_">Zn</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.co | formatViewValues: \'co\'}}</td><td>{{feed.cu | formatViewValues: \'cu\'}}</td><td>{{feed.cu_abs | formatViewValues: \'cu_abs\'}}</td><td>{{feed.fe | formatViewValues: \'fe\'}}</td><td>{{feed.fe_abs | formatViewValues: \'fe_abs\'}}</td><td>{{feed.i | formatViewValues: \'i\'}}</td><td>{{feed.i_abs | formatViewValues: \'i_abs\'}}</td><td>{{feed.mo | formatViewValues: \'mo\'}}</td><td>{{feed.mn | formatViewValues: \'mn\'}}</td><td>{{feed.mn_abs | formatViewValues: \'mn_abs\'}}</td><td>{{feed.se | formatViewValues: \'se\'}}</td><td>{{feed.se_abs | formatViewValues: \'se_abs\'}}</td><td>{{feed.zn | formatViewValues: \'zn\'}}</td><td>{{feed.zn_abs | formatViewValues: \'zn_abs\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistory.vitamin.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_vitamin_a_\' | i18n}}" tooltip-is-open="vitAIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_a_">vit a</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_vitamin_d_\' | i18n}}" tooltip-is-open="vitDIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_d_">vit d</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.vitamin_a | formatViewValues: \'vitamin_a\'}}</td><td>{{feed.vitamin_d | formatViewValues: \'vitamin_d\'}}</td><td>{{feed.vitamin_e | formatViewValues: \'vitamin_e\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/recipes/addNewRecipe/addNewRecipe.html','<div class="widgets" ng-if="vm.showPage"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll horizontal-scrol"><div include-with-scope="app/pages/recipes/addNewRecipe/wizard.html"></div></div></div></div></div>');
$templateCache.put('app/pages/recipes/addNewRecipe/editLoads.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><table class="table edit-loads-table"><thead><tr><th style="width: 120px"><button ng-disabled="!vm.editLoadsData.difference || vm.editLoadsData.difference >= 0" type="button" class="btn btn-primary btn-xs" ng-click="vm.addLoad()"><i class="fa fa-plus"></i></button></th><th class="edit-load-total-sum" colspan="4"><span><data-i18n i18n="_report_total_"></data-i18n>&nbsp;{{vm.editLoadsData.sum | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</span></th></tr></thead><tbody><tr ng-repeat="(loadIndex, load) in vm.editLoadsData.loads track by $index" class="edit-loads-table-row"><td><data-i18n i18n="_m_f_recipe_load_">Load</data-i18n>&nbsp;{{$index + 1}}:</td><td><span><div uib-dropdown="" keyboard-nav="" class="wagon-dropdown btn-group"><div uib-dropdown-toggle=""><div class="wagon-dropdown-container"><div><span class="wagon-name wagon-name-center">{{load.wagon.name}}</span>&nbsp;({{load.wagon.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}})</div><div class="dropdown-icon"><a href=""><span class="fa fa-chevron-down"></span></a></div></div></div><ul class="dropdown-menu-left" uib-dropdown-menu="" role="menu" aria-labelledby="herd-selector" style="max-height: 150px; overflow-y: auto"><li role="menuitem" ng-repeat="wagon in vm.recipe.wagons | orderBy: [\'-value\', \'name\']" ng-click="vm.updateLoad(load, load.value, loadIndex, wagon)"><a href="#"><div class="wagon-name">{{wagon.name}}</div>&nbsp;({{wagon.value | formatViewValues: \'rounded_amount\'}})&nbsp;{{vm.weight}}</a></li></ul></div></span></td><td><span editable-number="load.value" e-format-input-value="rounded_amount" e-min="0" e-required="" onbeforesave="vm.updateLoad(load, $data, loadIndex)" e-max="{{load.max}}" e-style="width: 100px"><b>{{load.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</b></span></td><td><button class="btn btn-xs btn-success" ng-click="vm.setLoad(load, $index)" ng-if="vm.editLoadsData.difference && vm.showSetButton(load)"><data-i18n i18n="_button_label_set_">set</data-i18n></button> <button class="btn btn-danger btn-xs" ng-click="vm.removeLoad($index)"><i class="fa fa-trash"></i></button></td></tr><tr ng-if="vm.editLoadsData.difference"><td colspan="12" class="difference"><span><data-i18n i18n="_rations_difference_">Difference</data-i18n>:&nbsp;{{vm.editLoadsData.difference | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</span></td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button> <button ng-disabled="vm.editLoadsData.loads.length > 10" type="button" class="btn btn-success" ng-click="vm.saveLoads()"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></div>');
$templateCache.put('app/pages/recipes/addNewRecipe/feeds.table.html','<div ng-if="!vm.loading"><h3 class="with-line"><data i18n="_ration_informations_label_">Ration informations</data></h3><div class="basis-info"><div class="form-group basis-info-item"><label><data-i18n i18n="_rations_ration_name_">Ration name</data-i18n></label><div>{{(vm.recipe.selectedRation.ration_name) || \'-\'}}</div></div><div class="form-group basis-info-item"><label><data-i18n i18n="_feeds_dm_">DM</data-i18n>&nbsp;(%)</label><div><span class="recipe-has-warning" ng-class="vm.recipe.selectedRation && !vm.recipe.selectedRation.dm ? \'recipe-display-warning\' : \'recipe-disable-warning\'" uib-popover="{{\'_m_f_premix_basis_dm_error_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{vm.recipe.selectedRation.dm | formatViewValues: \'percentage\'}}&nbsp;<i ng-show="vm.recipe.selectedRation && !vm.recipe.selectedRation.dm" class="fa fa-info-circle"></i></span></div></div><div class="form-group basis-info-item"><label><data-i18n i18n="_feeds_amount_">Amount</data-i18n>&nbsp;({{vm.weight}})</label><div>{{vm.recipe.selectedRation.amount_dm | formatViewValues: \'amount\'}}</div></div><div class="form-group basis-info-item"><label><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n>&nbsp;({{vm.weight}})</label><div>{{vm.recipe.selectedRation.amount_as_fed | formatViewValues: \'as_fed\'}}</div></div><div class="form-group basis-info-item"><label><data-i18n i18n="_m_f_recipe_cost_">Cost</data-i18n>&nbsp;({{vm.currency}})</label><div>{{vm.recipe.selectedRation.cost_dm | formatViewValues: \'cost_dm\'}}</div></div></div><div style="margin-bottom: 10px" class="horizontal-scroll recipe-table recipe-validation-container" ng-class="!vm.recipe.rationHelpInput && vm.selectBasisForm.$submitted ? \'recipe-error\' : vm.recipe.ration_intake_warning ? \'recipe-dmi-warning\' : \'\'"><table id="recipe-info" class="table table-hover recipe-ration-feed-tmr-table"><thead><tr><th><data-i18n i18n="_m_f_label_change_loading_order_">Change loading order</data-i18n><br><br></th><th><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br><br></th><th><data-i18n i18n="_m_f_recipe_ingredient_label_">Ingredient</data-i18n>&nbsp; <button class="btn btn-xs btn-primary" ng-click="vm.goToPage(\'iManagement.addNewIngredient\')" uib-tooltip="{{\'_btn_add_new_ingredient_\' | i18n}}" tooltip-placement="right" tooltip-class="customBlue right"><i class="fa fa-plus"></i></button><br><br></th><th><data-i18n i18n="_feeds_dm_">DM</data-i18n><br>%</th><th><data-i18n i18n="_feeds_amount_">Amount DM</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_cost_dm_">Cost DM</data-i18n><br>{{vm.currency}}/{{vm.weight}}&nbsp; <span><data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th><th><data-i18n i18n="_feeds_cost_as_fed_">Cost as fed</data-i18n><br>{{vm.currency}}/{{vm.weight}} <span><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n></span></th></tr></thead><tbody dnd-list="vm.recipe.selectedRation.ration_feeds" dnd-disable-if="vm.disableDrag || vm.showIFields"><tr ng-repeat="feed in vm.recipe.selectedRation.ration_feeds" dnd-disable-if="vm.disableDrag || vm.showIFields" dnd-draggable="feed" dnd-moved="vm.drag($index)"><td class="dm-table-cell"><a class="ion-drag icon-edit" ng-class="vm.recipe.selectedRation.ration_feeds.length < 2 ? \'hidden\' : \'\'" uib-tooltip="Drag and drop a section to change the order" tooltip-placement="left" tooltip-class="customBlue left wrap-text" tooltip-is-open="dragAndDropOpen" tooltip-popup-delay="300"></a></td><td style="min-width: 200px">{{feed.feed_name}}</td><td style="min-width: 200px"><a href="#" editable-select="feed.ingredient" e-style="width: 150px" e-ng-options="ingredient as ingredient.name for ingredient in vm.recipe.ingredients" e-placeholder="{{\'_m_f_recipe_choose_ingredient_\' | i18n}}" onaftersave="vm.linkIngredient($data, feed)" buttons="no">{{feed.ingredient.name || (\'_m_f_recipe_choose_ingredient_\' | i18n)}}</a></td><td style="min-width: 110px"><span editable-number="feed.dm" e-required="" e-step="0.01" e-min="0.01" e-max="100" e-style="width: 100px" e-format-input-value="percentage" e-ng-disabled="feed.ingredient" onaftersave="vm.updateFeed($data, feed, \'dm\')">{{feed.dm | formatViewValues: \'percentage\'}}<label class="info-note" ng-if="feed.dm != feed.original_dm">(<data-i18n i18n="_m_f_recipe_original_dm_label_">Original DM</data-i18n>:&nbsp;{{feed.original_dm | formatViewValues: \'percentage\'}})</label></span></td><td style="min-width: 110px"><span editable-number="feed.amount_dm" e-required="" e-step="0.01" e-min="0" e-style="width: 100px" e-format-input-value="amount" onaftersave="vm.updateFeed($data, feed, \'amount_dm\')" ng-class="feed.amount_dm > vm.maxAmount ? \'dmi-warning-label\' : \'\'">{{feed.amount_dm | formatViewValues: \'amount\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.amount_as_fed" e-required="" e-step="0.01" e-min="0" e-style="width: 100px" e-format-input-value="as_fed" onaftersave="vm.updateFeed($data, feed, \'amount_as_fed\')">{{feed.amount_as_fed | formatViewValues: \'as_fed\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.cost_dm" e-required="" e-step="0.001" e-min="0" e-style="width: 100px" e-format-input-value="cost_dm" onaftersave="vm.updateFeed($data, feed, \'cost_dm\')">{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.cost_as_fed" e-required="" e-step="0.001" e-min="0" e-style="width: 100px" e-format-input-value="cost_dm" onaftersave="vm.updateFeed($data, feed, \'cost_as_fed\')">{{feed.cost_as_fed | formatViewValues: \'cost_dm\'}}</span></td></tr><tr class="dndPlaceholder"><td colspan="8"><data-i18n i18n="_m_f_drag_and_drop_placeholder_">Drop here</data-i18n></td></tr><tr ng-form="" name="vm.feedsForm" ng-if="vm.showIFields" class="recipe-feeds-table-manual-row"><td><div class="form-group has-feedback recipe-feed-name-column" ng-class="{\'has-error\': vm.feedsForm.feed_name.$invalid && (vm.feedsForm.feed_name.$dirty || vm.feedsForm.$submitted)}"><input select-on-click="" type="text" class="form-control" required="" id="feed_name" name="feed_name" ng-model="vm.new_feed.feed_name" ng-keypress="vm.inputKeyPress($event)"> <span class="help-block error-block basic-block"><data-i18n i18n="_toastr_feeds_name_required_">Feed name is required</data-i18n></span></div></td><td><div class="form-group recipe-feed-type-column" ng-class="{\'has-error\': vm.feedsForm.feed_type.$invalid && vm.feedsForm.$submitted}"><ui-select ng-model="vm.new_feed.feed_type" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" required="" id="feed_type" name="feed_type" ng-change="vm.feedTypeSelected()"><ui-select-match placeholder="{{\'_picker_feed_type_placeholder_\' | i18n}}" uib-tooltip="{{$select.selected.translated}}" tooltip-enable="{{$select.selected.translated.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{$select.selected.translated}}</ui-select-match><ui-select-choices repeat="feed_type in vm.feed_types | filter: $select.search"><span class="shorten-long-text" ng-bind-html="feed_type.translated"></span></ui-select-choices></ui-select></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.feedsForm.dm.$invalid && (vm.feedsForm.dm.$dirty || vm.feedsForm.$submitted)}"><input select-on-click="" type="number" class="form-control" required="" id="dm" name="dm" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.new_feed.dm" min="0.01" max="100" step="0.01" ng-change="vm.newFeedDmChanged()" ng-keypress="vm.inputKeyPress($event)"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_label_dm_required_">DM is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.feedsForm.amount.$invalid && (vm.feedsForm.amount.$dirty || vm.feedsForm.$submitted)}"><input select-on-click="" type="number" class="form-control" required="" id="amount" name="amount" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.new_feed.amount" format-input-value="amount" default-return-value="null" min="0" ng-change="vm.newFeedAmountDmChanged()" ng-keypress="vm.inputKeyPress($event)"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_amount_dm_required_">Amount DM is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.feedsForm.as_fed.$invalid && (vm.feedsForm.as_fed.$dirty || vm.feedsForm.$submitted)}"><input select-on-click="" type="number" class="form-control" required="" id="as_fed" name="as_fed" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.new_feed.as_fed" format-input-value="as_fed" default-return-value="null" min="0" ng-change="vm.newFeedAmountAsFedChanged()" ng-keypress="vm.inputKeyPress($event)"> <span class="help-block error-block basic-block"><data-i18n i18n="_feeds_as_fed_required_">As fed is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.feedsForm.cost_dm.$invalid && (vm.feedsForm.cost_dm.$dirty || vm.feedsForm.$submitted)}"><input select-on-click="" type="number" class="form-control" id="cost_dm" name="cost_dm" ng-pattern="/^[0-9]+(\\.[0-9]{1,3})?$/" ng-model="vm.new_feed.cost_dm" format-input-value="cost_dm" default-return-value="null" min="0" ng-change="vm.newFeedCostDmChanged()" ng-keypress="vm.inputKeyPress($event)"></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.feedsForm.cost_as_fed.$invalid && (vm.feedsForm.cost_as_fed.$dirty || vm.feedsForm.$submitted)}"><input select-on-click="" type="number" class="form-control" ng-pattern="/^[0-9]+(\\.[0-9]{1,3})?$/" id="cost_as_fed" name="cost_as_fed" ng-model="vm.new_feed.cost_as_fed" format-input-value="cost_dm" default-return-value="null" min="0" ng-change="vm.newFeedCostAsFedChanged()" ng-keypress="vm.inputKeyPress($event)"></div></td><td style="width: 100px" class="recipe-feeds-table-action"><button type="submit" ng-disabled="vm.feedsForm.$invalid || vm.disableAddFeed" class="btn btn-primary btn-xs" ng-click="vm.addNewFeed()"><i class="fa fa-check"></i></button> <button type="button" class="btn btn-danger btn-xs" ng-click="vm.cancelAddNewFeed()"><i class="fa fa-trash"></i></button></td></tr></tbody></table></div><div class="recipe-error-text" ng-class="(vm.recipe.feeds.length === 0 || vm.feedsForm.$invalid || vm.showIFields) && vm.selectBasisForm.$submitted ? \'recipe-error\' : \'\'"><data-i18n i18n="_m_f_premix_feeds_required_">Feeds are required</data-i18n></div><div class="recipe-error-text" ng-class="!vm.recipe.dm && vm.selectBasisForm.$submitted ? \'recipe-error\' : \'\'"><data-i18n i18n="_m_f_premix_basis_dm_error_">Basis DM is 0. Choose another basis or update the selected one to continue</data-i18n></div><div class="recipe-error-text" ng-class="vm.hasDM0Error && vm.selectBasisForm.$submitted ? \'recipe-error\' : \'\'"><data-i18n i18n="_m_f_premix_ingredient_dm_error_">Ingredient DM can\'t be 0</data-i18n></div><div class="recipe-error-text" ng-class="{\'recipe-error dmi-warning-label\': vm.recipe.ration_intake_warning}"><data-i18n i18n="_m_f_dmi_exceeded_message_" select-on-click="">Daily DMI should not exceed</data-i18n>&nbsp;{{vm.maxAmount}}{{vm.weight}}</div></div><loading-spinner-large ng-if="vm.loading"></loading-spinner-large>');
$templateCache.put('app/pages/recipes/addNewRecipe/insertWagon.modal.html','<div class="modal-content" ng-cloak=""><div ng-if="!vm.modalLoading"><div class="modal-header" style="padding-bottom: 0px"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body" style="padding-top: 3px"><div style="padding-top: 10px"><span><data-i18n i18n="_m_f_menu_wagons_add_wagon_">Create custom wagon</data-i18n>:</span><form name="vm.customWagonForm" novalidate=""><div class="form-group"><input class="form-control" type="text" id="wagon-name" name="wagon-name" required="" ng-model="vm.newWagon.name" placeholder="{{\'_m_f_wagons_name_\' | i18n}}" style="max-width: 250px; margin-top: 5px; margin-bottom: 10px"> <input class="form-control" type="text" id="wagon-serial" name="wagon-serial" ng-model="vm.newWagon.serial_number" placeholder="{{\'_m_f_serial_number_\' | i18n}}" maxlength="25" style="max-width: 250px"><br><label style="display: block"><data-i18n i18n="_m_f_wagons_capacity_">capacity</data-i18n></label><div class="form-group" style="max-width: 500px" ng-class="{\'has-error\': vm.customWagonForm.volume.$invalid && (vm.customWagonForm.volume.$dirty || vm.customWagonForm.$submitted)}"><input class="form-control with-units" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" type="number" min="0.1" max="90" step="0.1" id="volume" name="volume" ng-model="vm.newWagon.volume" placeholder="{{\'_m_f_wagons_volume_\'|i18n}}" style="margin-bottom: 10px; max-width: 250px"><span>m<sup>3</sup></span><br></div><div class="form-group" ng-class="{\'has-error\': vm.customWagonForm.weight.$invalid && (vm.customWagonForm.weight.$dirty || vm.customWagonForm.$submitted)}" style="max-width: 500px"><input type="number" class="form-control with-units" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" id="weight" name="weight" placeholder="{{\'_m_f_wagons_weight_\'|i18n}}" ng-model="vm.newWagon.weight" required="" min="0.1" max="90" step="0.1" style="max-width: 250px" select-on-click=""><span><data-i18n ng-if="vm.settings.use_kgs" i18n="_m_f_wagons_tonnes_">Tonnes</data-i18n><data-i18n ng-if="!vm.settings.use_kgs" i18n="_m_f_wagons_imperial_tonnes_">Tonnes</data-i18n></span> <span class="help-block error-block basic-block warningModal"><data-i18n i18n="_m_f_wagons_weight_required_" select-on-click="">weight is required</data-i18n></span></div></div><button style="margin-right: 0; margin-left: auto" class="btn btn-xs btn-success" ng-disabled="vm.customWagonForm.$invalid == true" ng-click="vm.addWagon(false)"><data-i18n i18n="_m_f_btn_add_">Add</data-i18n></button></form></div></div></div><loading-spinner-large ng-if="vm.modalLoading"></loading-spinner-large></div>');
$templateCache.put('app/pages/recipes/addNewRecipe/mixing_suggestion.table.html','<div class="horizontal-scroll"><table class="table load-configuration-table"><thead><tr><th colspan="3" align="center" class="mixing-suggestion-header"><data-i18n i18n="_m_f_recipe_mixing_suggestion_">Mixing suggestion</data-i18n></th></tr><tr class="sortable"><th ng-if="vm.recipe.total_feeding_1" class="text-primary"><data-i18n i18n="_m_f_recipe_feeding_">Feeding</data-i18n>&nbsp;1&nbsp;<span>({{vm.recipe.total_feeding_1 | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{vm.weight}})<div ng-if="vm.recipe.feedingsError.feeding_1" class="warningModal"><data-i18n i18n="_rations_difference_">Difference</data-i18n>:&nbsp;{{vm.recipe.feedingsError.feeding_1 | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</div></th><th ng-if="vm.recipe.total_feeding_2" class="text-primary"><data-i18n i18n="_m_f_recipe_feeding_">Feeding</data-i18n>&nbsp;2&nbsp;<span>({{vm.recipe.total_feeding_2 | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{vm.weight}})<div ng-if="vm.recipe.feedingsError.feeding_2" class="warningModal"><data-i18n i18n="_rations_difference_">Difference</data-i18n>:&nbsp;{{vm.recipe.feedingsError.feeding_2 | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</div></th><th ng-if="vm.recipe.total_feeding_3" class="text-primary"><data-i18n i18n="_m_f_recipe_feeding_">Feeding</data-i18n>&nbsp;3&nbsp;<span>({{vm.recipe.total_feeding_3 | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{vm.weight}})<div ng-if="vm.recipe.feedingsError.feeding_3" class="warningModal"><data-i18n i18n="_rations_difference_">Difference</data-i18n>:&nbsp;{{vm.recipe.feedingsError.feeding_3 | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</div></th></tr></thead><tbody class="load-suggestion"><tr><td ng-if="vm.recipe.total_feeding_1"><table class="table suggestion-table"><thead><tr><th><data-i18n i18n="_m_f_recipe_loads_">Loads</data-i18n><span class="suggestion-add-button"><button type="button" class="btn btn-primary btn-xs" uib-tooltip="{{\'_m_f_premix_edit_load_\' | i18n}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-click="vm.openEditLoadsModal(\'feeding_1\')" ng-if="vm.recipe.total_feeding_1 && vm.recipe.total_feeding_1 > 0"><i class="fa fa-pencil"></i></button></span></th><th><data-i18n i18n="_m_f_menu_configurations_equipment_">Mixer wagon</data-i18n></th></tr></thead><tbody><tr ng-repeat="(indexX, load) in vm.recipe.suggestion.feeding_1.loads track by indexX" class="editable-suggestion-value"><td><data-i18n i18n="_m_f_recipe_load_">Load</data-i18n>&nbsp;{{$index+1}}: <span>{{load.value | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{vm.weight}}</td><td><div uib-dropdown="" keyboard-nav="" class="wagon-dropdown btn-group" dropdown-append-to-body=""><div uib-dropdown-toggle=""><div class="wagon-name-long" uib-tooltip="{{load.wagon.name}}" tooltip-enable="{{load.wagon.name.length > 30 ? true : false}}" tooltip-is-open="wagonNameOpen" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500"><span>{{load.wagon.name}}</span></div><div class="dropdown-icon"><a href=""><span class="fa fa-chevron-down"></span></a></div></div><ul class="dropdown-menu-left" style="transform: translateX(-25%); max-height: 150px; overflow-y: auto" uib-dropdown-menu="" role="menu" aria-labelledby="herd-selector"><li role="menuitem" ng-repeat="wagon in vm.recipe.wagons | orderBy: [\'-value\', \'name\']" ng-click="vm.loadWagonChanged(\'feeding_1\', indexX, wagon)"><a href="#"><div class="wagon-name wagon-name-center">{{wagon.name}}</div>&nbsp;({{wagon.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}})</a></li></ul></div></td><td></td></tr></tbody></table></td><td ng-if="vm.recipe.total_feeding_2"><table class="table suggestion-table"><thead><tr><th><data-i18n i18n="_m_f_recipe_loads_">Loads</data-i18n><span class="suggestion-add-button"><button type="button" class="btn btn-primary btn-xs" uib-tooltip="{{\'_m_f_premix_edit_load_\' | i18n}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-click="vm.openEditLoadsModal(\'feeding_2\')" ng-if="vm.recipe.total_feeding_2 && vm.recipe.total_feeding_2 > 0"><i class="fa fa-pencil"></i></button></span></th><th><data-i18n i18n="_m_f_menu_configurations_equipment_">Mixer wagon</data-i18n></th></tr></thead><tbody><tr ng-repeat="(indexX, load) in vm.recipe.suggestion.feeding_2.loads track by indexX" class="editable-suggestion-value"><td><data-i18n i18n="_m_f_recipe_load_">Load</data-i18n>&nbsp;{{$index+1}}: <span>{{load.value | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{vm.weight}}</td><td><div uib-dropdown="" keyboard-nav="" class="wagon-dropdown btn-group" dropdown-append-to-body=""><div uib-dropdown-toggle=""><div class="wagon-name-long" uib-tooltip="{{load.wagon.name}}" tooltip-enable="{{load.wagon.name.length > 30 ? true : false}}" tooltip-is-open="wagonNameOpen" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500"><span>{{load.wagon.name}}</span></div><div class="dropdown-icon"><a href=""><span class="fa fa-chevron-down"></span></a></div></div><ul class="dropdown-menu-left" style="transform: translateX(-25%); max-height: 150px; overflow-y: auto" uib-dropdown-menu="" role="menu" aria-labelledby="herd-selector"><li role="menuitem" ng-repeat="wagon in vm.recipe.wagons | orderBy: [\'-value\', \'name\']" ng-click="vm.loadWagonChanged(\'feeding_2\', indexX, wagon)"><a href="#"><div class="wagon-name wagon-name-center">{{wagon.name}}</div>&nbsp;({{wagon.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}})</a></li></ul></div></td></tr></tbody></table></td><td ng-if="vm.recipe.total_feeding_3"><table class="table suggestion-table"><thead><tr><th><data-i18n i18n="_m_f_recipe_loads_">Loads</data-i18n><span class="suggestion-add-button"><button type="button" class="btn btn-primary btn-xs" uib-tooltip="{{\'_m_f_premix_edit_load_\' | i18n}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-click="vm.openEditLoadsModal(\'feeding_3\')" ng-if="vm.recipe.total_feeding_3 && vm.recipe.total_feeding_3 > 0"><i class="fa fa-pencil"></i></button></span></th><th><data-i18n i18n="_m_f_menu_configurations_equipment_">Mixer wagon</data-i18n></th></tr></thead><tbody><tr ng-repeat="(indexX, load) in vm.recipe.suggestion.feeding_3.loads track by indexX" class="editable-suggestion-value"><td><data-i18n i18n="_m_f_recipe_load_">Load</data-i18n>&nbsp;{{$index+1}}: <span>{{load.value | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{vm.weight}}</td><td><div uib-dropdown="" keyboard-nav="" class="wagon-dropdown btn-group" dropdown-append-to-body=""><div uib-dropdown-toggle=""><div class="wagon-name-long" uib-tooltip="{{load.wagon.name}}" tooltip-enable="{{load.wagon.name.length > 30 ? true : false}}" tooltip-is-open="wagonNameOpen" tooltip-placement="left" tooltip-class="customBlue left wrap-text" tooltip-popup-delay="500"><span>{{load.wagon.name}}</span></div><div class="dropdown-icon"><a href=""><span class="fa fa-chevron-down"></span></a></div></div><ul class="dropdown-menu-left" style="transform: translateX(-25%); max-height: 150px; overflow-y: auto" uib-dropdown-menu="" role="menu" aria-labelledby="herd-selector"><li role="menuitem" ng-repeat="wagon in vm.recipe.wagons | orderBy: [\'-value\', \'name\']" ng-click="vm.loadWagonChanged(\'feeding_3\', indexX, wagon)"><a href="#"><div class="wagon-name wagon-name-center">{{wagon.name}}</div>&nbsp;({{wagon.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}})</a></li></ul></div></td></tr></tbody></table></td></tr><tr><td ng-if="vm.recipe.total_feeding_1"><table class="table suggestion-table"><tr><td class="text-primary"><data-i18n i18n="_m_f_recipe_number_of_loads_">Number of loads</data-i18n></td><td>{{vm.recipe.suggestion.feeding_1.loads.length}}</td></tr></table></td><td ng-if="vm.recipe.total_feeding_2"><table class="table suggestion-table"><tr><td class="text-primary"><data-i18n i18n="_m_f_recipe_number_of_loads_">Number of loads</data-i18n></td><td>{{vm.recipe.suggestion.feeding_2.loads.length}}</td></tr></table></td><td ng-if="vm.recipe.total_feeding_3"><table class="table suggestion-table"><tr><td class="text-primary"><data-i18n i18n="_m_f_recipe_number_of_loads_">Number of loads</data-i18n></td><td>{{vm.recipe.suggestion.feeding_3.loads.length}}</td></tr></table></td></tr></tbody></table></div>');
$templateCache.put('app/pages/recipes/addNewRecipe/penDetails.modal.html','<div class="modal-content" ng-cloak=""><div class="panel-content recipe-pen-details" ng-if="!vm.modalLoading"><h3 class="with-line"><data-i18n i18n="_m_f_pen_details_basic_informations_">Basic Informations</data-i18n></h3><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_name_">Name</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 wrap-text"><span>{{vm.details.pen_name}}</span></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_no_animals_">Number of animals</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.number_of_animals}}</span></div></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_category_">Pen category</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.pen_category.name}}</span></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_feeds_dmi_">dmi</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.feed_intake | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</span></div></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_number_of_cubicles_">Number of cubicles</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.number_of_cubicles || (\'_m_f_calendar_not_available_label_\' | i18n)}}</span></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_number_of_headlocks_">Number of headlocks</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.number_of_headlocks || (\'_m_f_calendar_not_available_label_\' | i18n)}}</span></div></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_active_">Pen active</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span><a class="ion-checkmark-round primaryModal" ng-if="vm.details.pen_active"></a><a ng-if="!vm.details.pen_active" class="ion-close-round warningModal"></a></span></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_automatic_update_">Automatic update</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span><a class="ion-checkmark-round primaryModal" ng-if="vm.details.automatic_update"></a> <a ng-if="!vm.details.automatic_update" class="ion-close-round warningModal"></a></span></div></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_address_">Pen address</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.pen_address}}</span></div></div></div></div><div ng-if="vm.showGMap" class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="row"><div id="google-maps" class="medium-panel-maps"></div></div></div></div><h3 class="with-line"><data-i18n i18n="_m_f_pen_details_feeding_informations_">Feeding Informations</data-i18n></h3><div class="row pen-feeding-details recipe-pen-feeding-details horizontal-scroll"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="row"><table class="table table-striped"><thead><tr><th><data-i18n i18n="_m_f_pen_feeding_start_date_">Feeding date</data-i18n></th><th><data-i18n i18n="_m_f_pen_frequency_of_feeding_">Frequency of feeding</data-i18n></th><th><data-i18n i18n="_m_f_pen_feedings_per_day">feeding per day</data-i18n></th><th><data-i18n i18n="_m_f_placeholder_select_feeding_time_">feeding</data-i18n></th><th><data-i18n i18n="_active_schedule_">Active schedule</data-i18n></th></tr></thead><tbody><tr ng-repeat="freq in vm.details.pen_feeding_scheduler_list | orderBy:\'-start_feeding_date\'" ng-class="freq.schedule_set ? \'primaryModal\' : \'\'"><td>{{freq.start_feeding_date | date:\'shortDate\'}}</td><td>{{freq.feeding_frequency || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td>{{freq.number_of_feedings}}</td><td><div><span ng-if="freq.morning_feeding">{{freq.morning_feeding_time | date: \'hh:mm a\'}}</span> <span ng-if="freq.noon_feeding">{{freq.noon_feeding_time | date: \'hh:mm a\'}}</span> <span ng-if="freq.evening_feeding">{{freq.evening_feeding_time | date: \'hh:mm a\'}}</span></div><div ng-if="!freq.morning_feeding && !freq.noon_feeding && !freq.evening_feeding"><data-i18n i18n="_m_f_calendar_not_available_label_"></data-i18n></div></td><td><a class="ion-checkmark-round primaryModal" ng-if="freq.schedule_set"></a> <a ng-if="!freq.schedule_set" class="ion-close-round warningModal"></a></td></tr></tbody></table></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><loading-spinner-large ng-if="vm.modalLoading"></loading-spinner-large></div>');
$templateCache.put('app/pages/recipes/addNewRecipe/pens.table.html','<div class="horizontal-scroll recipe-table" ng-class="!vm.recipe.penHelpInput && vm.selectPenForm.$submitted ? \'recipe-error\' : vm.recipe.pen_intake_warning ? \'recipe-dmi-warning\' :\'\'"><table class="table table-hover"><thead><tr class="sortable"><th align="left"><data-i18n i18n="_title_column_action_">action</data-i18n></th><th><data-i18n i18n="_m_f_pen_active_">pen active</data-i18n></th><th><data-i18n i18n="_m_f_pen_name_">pen name</data-i18n></th><th><data-i18n i18n="_m_f_title_category_">category</data-i18n></th><th><data-i18n i18n="_m_f_pen_number_of_animals_">number of animals</data-i18n></th><th class="recipe-pen-feed-intake-heading"><data-i18n i18n="_feeds_dmi_">dmi</data-i18n></th><th class="recipe-number-of-feedings recipe-number-of-feedings-th"><data-i18n i18n="_m_f_pen_feedings_">feedings</data-i18n></th><th><data-i18n i18n="_title_create_date">create date</data-i18n></th><th style="text-align: center"><data-i18n i18n="_m_f_pen_automatic_update_">automatic update</data-i18n></th></tr></thead><tbody ng-if="!vm.loadingPensTable"><tr ng-repeat="pen in vm.recipe.pens"><td style="min-width: 120px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="pen.is_selected" style="margin-right: 2px" ng-change="vm.selectPen(pen)" ng-disabled="vm.disableRationSelect"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToPage(\'pens.penHistory\', pen)" uib-tooltip="{{\'_tips_history_\' | i18n}}" tooltip-is-open="penHistoryOpen{{pen.id}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToPage(\'pens.editPen\', pen)" uib-tooltip="{{\'_tips_edit_\' | i18n}}" tooltip-is-open="editPenOpen{{pen.id}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.openPenDetailsModal(pen)" uib-tooltip="{{\'_tips_details_\' | i18n}}" tooltip-is-open="penDetailsOpen{{pen.id}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clipboard"></i></button></td><td><a class="icon-edit green-icon" href="" style="margin-left: 10px" ng-click="vm.changeActive(pen)" ng-class="pen.pen_active ? \'ion-star\' : \'ion-ios-star-outline\'"></a></td><td class="shorten-long-text" uib-tooltip="{{pen.pen_name}}" tooltip-enable="{{pen.pen_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{pen.pen_name}}</td><td>{{pen.pen_category.name}}</td><td>{{pen.number_of_animals}}</td><td class="recipe-pen-feed-intake"><div><div><ui-select ng-model="pen.use_pen_feed_intake" ng-disabled="!pen.is_selected" class="btn-group bootstrap-select intake-source-column" append-to-body="true" on-select="vm.updateUsePenIntake(pen)"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item.value as item in vm.feedIntakeSources"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select></div><div><span ng-style="pen.use_pen_feed_intake ? {} : {\'display\': \'none\'}">{{pen.feed_intake | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</span> <span ng-style="!pen.use_pen_feed_intake && pen.is_selected ? {} : {\'display\': \'none\'}" ng-class="vm.recipe.pen_intake_warning ? \'dmi-warning-label\' : \'\'">{{vm.recipe.ration_feed_intake | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</span> <span ng-style="!pen.use_pen_feed_intake && !pen.is_selected ? {} : {\'display\': \'none\'}">-</span></div></div></td><td class="recipe-number-of-feedings"><span>{{pen.number_of_feedings}}</span></td><td>{{pen.create_date | date:\'short\'}}</td><td align="center"><a class="ion-checkmark-round primaryModal" ng-if="pen.automatic_update"></a> <a ng-if="!pen.automatic_update" class="ion-close-round warningModal"></a></td></tr></tbody><tfoot ng-if="vm.recipe.totalItemsPens > 10 && !vm.loadingPensTable"><tr><td colspan="11" style="text-align: center"><uib-pagination boundary-links="true" total-items="vm.recipe.totalItemsPens" ng-model="vm.recipe.currentPagePens" items-per-page="10" max-size="7" ng-change="vm.pensPaginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table></div><div class="recipe-error-text" ng-class="!vm.recipe.penHelpInput && vm.selectPenForm.$submitted ? \'recipe-error\' : \'\'"><data-i18n i18n="_m_f_pen_required_" select-on-click="">Pen is required</data-i18n></div><div class="recipe-warning-text" ng-class="!vm.recipe.penHelpInput && vm.selectPenForm.$submitted ? \'\' : vm.recipe.pen_intake_warning ? \'recipe-dmi-warning\' :\'\'"><data-i18n i18n="_m_f_dmi_exceeded_message_" select-on-click="">Daily DMI should not exceed</data-i18n>&nbsp;{{vm.maxAmount | formatViewValues: \'amount\'}}{{vm.weight}}</div><loading-spinner-large ng-if="vm.loadingPensTable"></loading-spinner-large>');
$templateCache.put('app/pages/recipes/addNewRecipe/pen_cost.table.html','<div class="horizontal-scroll recipe-table"><table class="table" st-table="vm.recipe.pens"><thead><tr class="sortable"><th><data-i18n i18n="_m_f_pen_name_">pen name</data-i18n></th><th><data-i18n i18n="_m_f_title_category_">category</data-i18n></th><th><data-i18n i18n="_m_f_pen_number_of_animals_">number of animals</data-i18n></th><th><data-i18n i18n="_feeds_dmi_">dmi</data-i18n></th><th><data-i18n i18n="_m_f_recipe_cost_">Cost</data-i18n>&nbsp;({{vm.currency}})</th><th><data-i18n ng-if="vm.settings.use_kgs" i18n="_m_f_recipe_total_kg_dm_">Total kg DM</data-i18n><data-i18n ng-if="!vm.settings.use_kgs" i18n="_m_f_recipe_total_lb_dm_">Total lb DM</data-i18n></th><th><data-i18n ng-if="vm.settings.use_kgs" i18n="_m_f_recipe_total_kg_as_fed_">Total kg as fed</data-i18n><data-i18n ng-if="!vm.settings.use_kgs" i18n="_m_f_recipe_total_lb_as_fed_">Total lb as fed</data-i18n></th><th><data-i18n i18n="_m_f_pen_morning_feeding_short_">morning</data-i18n></th><th><data-i18n i18n="_m_f_pen_noon_feeding_short_">noon</data-i18n></th><th><data-i18n i18n="_m_f_pen_evening_feeding_short_">evening</data-i18n></th></tr></thead><tbody><tr ng-repeat="pen in vm.recipe.selected_pens | orderBy: \'id\': true" class="editable-tr-wrap"><td class="recipe-ration-name" uib-tooltip="{{pen.pen_name}}" tooltip-enable="{{pen.pen_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{pen.pen_name}}</td><td>{{pen.pen_category.name}}</td><td>{{pen.number_of_animals}}</td><td>{{pen.used_feed_intake | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</td><td>{{pen.cost_dm | number: 2}}</td><td>{{pen.total_amount_dm | formatViewValues: \'rounded_amount\'}}</td><td>{{pen.total_as_fed | formatViewValues: \'rounded_amount\'}}</td><td style="min-width: 100px"><div><span>{{pen.feeding_1_amount | formatViewValues: \'rounded_amount\' | defaultReturnValue: null}}</span></div><div class="link-color" ng-class="pen.feeding_1_valid ? \'timepicker-link\' : \'\'"><span>{{(pen.feeding_1 | date: "hh:mm a")}}</span></div><span ng-if="!pen.feeding_1"><data-i18n i18n="_label_none_"></data-i18n></span></td><td style="min-width: 100px"><div><span>{{pen.feeding_2_amount | formatViewValues: \'rounded_amount\' | defaultReturnValue: null}}</span></div><div class="link-color" ng-class="pen.feeding_2_valid ? \'timepicker-link\' : \'\'"><span>{{(pen.feeding_2 | date: "hh:mm a")}}</span></div><span ng-if="!pen.feeding_2"><data-i18n i18n="_label_none_"></data-i18n></span></td><td style="min-width: 100px"><div><span>{{pen.feeding_3_amount | formatViewValues: \'rounded_amount\' | defaultReturnValue: null}}</span></div><div class="link-color" ng-class="pen.feeding_3_valid ? \'timepicker-link\' : \'\'"><span>{{(pen.feeding_3 | date: "hh:mm a")}}</span></div><span ng-if="!pen.feeding_3"><data-i18n i18n="_label_none_"></data-i18n></span></td></tr><tr class="highlight-sum-table"><td><span style="text-transform: uppercase"><data-i18n i18n="_m_f_label_summary_">Summary</data-i18n>:</span></td><td class="shorten-long-text" uib-tooltip="{{recipe.recipe_name}}" tooltip-enable="{{recipe.recipe_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{vm.recipe.recipe_name}}</td><td>{{vm.recipe.total_number_of_animals}}</td><td></td><td>{{vm.recipe.total_cost | number: 2}}&nbsp;({{vm.currency}})</td><td>{{vm.recipe.total_amount_dm | formatViewValues: \'rounded_amount\'}}</td><td>{{vm.recipe.total_as_fed | formatViewValues: \'rounded_amount\'}}</td><td>{{vm.recipe.total_feeding_1 | formatViewValues: \'rounded_amount\'}}</td><td>{{vm.recipe.total_feeding_2 | formatViewValues: \'rounded_amount\'}}</td><td>{{vm.recipe.total_feeding_3 | formatViewValues: \'rounded_amount\'}}</td><td></td></tr></tbody></table></div>');
$templateCache.put('app/pages/recipes/addNewRecipe/rationRecipes.popover.html','<div style="height: 200px; overflow-y: auto"><label><data-i18n i18n="_m_f_linking_ingredient_warning_">Warning</data-i18n></label><ul ng-repeat="r in vm.recipe.rations[vm.recipe.popover_ration_index].recipe_list | orderBy: \'id\': true"><li>{{r.name}}</li></ul></div>');
$templateCache.put('app/pages/recipes/addNewRecipe/rations.table.html','<div class="horizontal-scroll recipe-table" ng-class="!vm.recipe.rationHelpInput && vm.selectRationForm.$submitted ? \'recipe-error\' : \'\'"><table class="table table-hover" ng-if="!vm.loadingRations"><thead><tr class="sortable"><th align="left"><data-i18n i18n="_title_column_action_">action</data-i18n></th><th><data-i18n i18n="_rations_ration_name_">ration name</data-i18n></th><th><data-i18n i18n="_groups_group_name_">group name</data-i18n></th><th><data-i18n i18n="_title_create_date">create date</data-i18n></th><th><data-i18n i18n="_label_updated_on_">Updated on</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th></tr></thead><tbody><tr ng-repeat="ration in vm.recipe.rations" ng-show="!vm.isCollapsed || $index < 5"><td><div class="rationBtns"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}-X" ng-true-value="true" ng-false-value="false" ng-click="vm.selectRation(ration)" ng-model="ration.is_selected" style="margin-right: 2px" ng-disabled="vm.disableRationSelect"> <label for="is_checked{{$index}}-X"></label></span></div></td><td class="shorten-long-text"><span class="recipe-has-warning" ng-class="ration.is_selected && ration.recipe_list && ration.recipe_list.length ? \'recipe-display-warning\' : \'recipe-disable-warning\'" uib-popover-template="\'app/pages/recipes/addNewRecipe/rationRecipes.popover.html\'" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="bottom">{{ration.ration_name}}&nbsp;<i ng-show="ration.is_selected && ration.recipe_list && ration.recipe_list.length" class="fa fa-info-circle"></i></span></td><td class="shorten-long-text" uib-tooltip="{{ration.group_name}}" tooltip-enable="{{ration.group_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{ration.group_name || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td>{{(ration.create_date | date: \'medium\') || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td>{{(ration.last_modified_date | date: \'medium\') || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td>{{ration.dm | formatViewValues: \'percentage\'}}</td></tr><tr ng-show="vm.recipe.rations.length > 5"><td colspan="6" style="text-align: center"><a ng-click="vm.toggleCollapse()" style="cursor: pointer">{{vm.isCollapsed ? \'Show More\' : \'Show Less\'}}</a></td></tr></tbody><tfoot ng-if="vm.recipe.totalItemsRation > 10"><tr><td colspan="6" style="text-align: center" ng-show="!vm.isCollapsed"><uib-pagination boundary-links="true" total-items="vm.recipe.totalItemsRation" ng-model="vm.recipe.currentPageRation" items-per-page="10" max-size="7" ng-change="vm.rationsPaginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></td></tr></tfoot></table></div><div class="recipe-error-text" ng-class="!vm.recipe.rationHelpInput && vm.selectRationForm.$submitted ? \'recipe-error\' : \'\'"><span class="warningModal"><data-i18n i18n="_m_f_ration_required_" select-on-click="">Ration is required</data-i18n></span></div><loading-spinner-large ng-if="vm.loadingRations"></loading-spinner-large>');
$templateCache.put('app/pages/recipes/addNewRecipe/wizard.html','<div ng-if="!vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div><ba-wizard id="add-recipe-tabs" ng-show="!vm.loading && vm.selectedHerd" class="recipe-tabs" ng-class="vm.tabValidation()"><ba-wizard-step title="{{vm.step1}}" form="vm.selectRationForm" class="wizard-step"><div align="right"><button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.selectRationForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.selectRationForm.recipe_name.$invalid && (vm.selectRationForm.recipe_name.$dirty || vm.selectRationForm.$submitted)}"><label for="recipe_name"><data-i18n i18n="_m_f_recipe_name_">recipe name</data-i18n></label> <input type="text" maxlength="60" class="form-control" id="recipe_name" name="recipe_name" placeholder="{{\'_m_f_recipe_name_\' | i18n}}" ng-model="vm.recipe.recipe_name" ng-change="vm.addRecipeDirty()" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_recipe_name_required_" select-on-click="">recipe name is required</data-i18n></span></div></div></div><input type="text" required="" ng-show="false" ng-model="vm.recipe.rationHelpInput"></form><div class="row"><div class="col-md-6"><label style="font-weight: 400; margin-top: 10px"><data-i18n i18n="_m_f_recipe_select_1_ration_">select 1 ration</data-i18n>:</label></div><div class="col-md-6"><div style="float: right"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary" uib-dropdown-toggle="" style="margin-left: 10px"><data-i18n i18n="_btn_add_ration_">add ration</data-i18n><span class="caret"></span></button><ul uib-dropdown-menu="" class="dropdown-menu"><li ng-if="vm.hasRationAccess"><a href="" ng-click="vm.goToPage(\'rations.addnewration\')"><data-i18n i18n="_report_footer_feed_">add ration</data-i18n></a></li><li><a href="" ng-click="vm.goToPage(\'rations.addmanualration\')"><data-i18n i18n="_btn_add_ration_manually_">Add manually</data-i18n></a></li></ul></div></div></div></div><div class="row" style="padding-top: 10px"><div class="col-md-6"><div class="form-group" style="width: auto; min-width: 175px; margin-bottom: 0px"><label><data-i18n i18n="_add_new_recipe_show_rations_label_">Show rations</data-i18n>:</label><ui-select ng-model="vm.recipe.selected_ration_type" class="btn-group bootstrap-select form-control" ng-disabled="vm.loadingRations" append-to-body="true" search-enabled="true" required="" ng-change="vm.selectRationType()"><ui-select-match placeholder="{{\'_mf_ration_source_\' | i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type in vm.rationTypes | filter: $select.search"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div style="padding: 0px 10px"><div include-with-scope="app/pages/recipes/addNewRecipe/rations.table.html"></div></div></div><div class="row" ng-if="vm.recipe.selectedRation"><div class="col-md-12"><div ng-if="!vm.loadingRationFeeds" include-with-scope="app/pages/recipes/addNewRecipe/feeds.table.html"></div><loading-spinner-large ng-if="vm.loadingRationFeeds"></loading-spinner-large></div></div></ba-wizard-step><ba-wizard-step title="{{vm.step2}}" form="vm.selectPenForm" class="wizard-step"><div align="right"><button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.selectPenForm" novalidate=""><input required="" type="text" ng-model="vm.recipe.penHelpInput" ng-show="false"><div class="row" style="margin-top: 10px"><div class="col-md-6"><label style="font-weight: 400; margin-top: 10px"><data-i18n i18n="_m_f_recipe_select_pens_">select pens</data-i18n>:</label></div><div class="col-md-6"><div style="float: right"><button class="btn btn-primary" onclick="return false;" ng-click="vm.goToPage(\'pens.addNewPen\')"><data-i18n i18n="_btn_add_new_pen_">add new pen</data-i18n></button></div></div></div><div class="row"><div><div include-with-scope="app/pages/recipes/addNewRecipe/pens.table.html"></div></div></div></form></ba-wizard-step><ba-wizard-step title="{{vm.step3}}" form="vm.feedingMethod" class="wizard-step"><div align="right"><button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.feedingMethod" novalidate=""><input type="text" required="" ng-show="false" ng-model="vm.recipe.wagonHelpInput"> <input type="text" required="" ng-show="false" ng-model="vm.recipe.feedingMethodHelpInput"><div class="row" style="margin-top: 10px"><div class="col-md-3"></div><div class="col-md-6" ng-if="vm.recipe.tmr"><div class="recipe-wagon-container" ng-if="!vm.loadingMixerWagons"><label><data-i18n i18n="_m_f_recipe_choose_mixer_wagons_">Choose your mixer wagons</data-i18n>:</label><div><button class="btn btn-sm btn-primary" ng-click="vm.insertWagon($event)"><data-i18n i18n="_m_f_recipe_add_wagon_">Add wagon</data-i18n></button></div><div class="recipe-wagon-inner recipe-validation-container" ng-class="!vm.recipe.wagonHelpInput && vm.feedingMethod.$submitted ? \'recipe-error\' : \'\'"><table class="recipe-wagon-table"><thead><tr ng-if="vm.recipe.wagons.length > 0"><th colspan="2"><data i18n="_m_f_premix_select_mixer_wagon_">Select wagon</data></th><th><data i18n="_label_name_">Name</data></th><th><data i18n="_m_f_wagons_capacity_">Capacity</data></th><th><data i18n="_m_f_recipe_choose_default_mixer_wagon_">Choose default mixer wagon</data>:</th></tr><span class="warningModal" ng-if="vm.recipe.wagons.length === 0"><data-i18n i18n="_m_f_premix_wagon_not_available_">Mixer wagon not availabe</data-i18n></span></thead><tbody lazy-img-container="" ng-if="vm.recipe.wagons.length > 0"><tr ng-repeat="wagon in vm.recipe.wagons"><td><span class="newCheck"><input type="checkbox" id="wagon_checked_{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="wagon.selected" ng-change="vm.wagonSelected(wagon)"> <label for="wagon_checked_{{$index}}"></label></span></td><td><span class="select-wagon-img"><img src="assets/img/MmmLogo.png" lazy-img="{{wagon.image_url}}" lazy-img-error="assets/img/MmmLogo.png" ng-if="wagon.image_url"> <img src="assets/img/MmmLogo.png" ng-if="!wagon.image_url"></span></td><td><span class="wagon-name" uib-tooltip="{{wagon.name}}" tooltip-enable="{{wagon.name.length > 30 ? true : false}}" tooltip-is-open="wagonNameOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-hide-overflow" tooltip-popup-delay="500">{{wagon.name}}</span></td><td><span>{{wagon.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</span></td><td><span ng-if="wagon.selected" class="newCheck"><input type="checkbox" id="default_checked_{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="wagon.default" ng-disabled="wagon.default" ng-change="vm.defaultSelected(wagon)"> <label for="default_checked_{{$index}}"></label></span></td></tr></tbody></table></div></div><div class="recipe-error-text" ng-class="!vm.recipe.wagonHelpInput && vm.planningForm.$submitted ? \'recipe-error\' : \'\'"><span class="warningModal"><data-i18n i18n="_m_f_feeding_mixer_wagon_required_">Mixer wagon is required</data-i18n></span></div><loading-spinner-large ng-if="vm.loadingMixerWagons"></loading-spinner-large></div></div></form></ba-wizard-step><ba-wizard-step title="{{vm.step4}}" form="vm.management" class="wizard-step"><div align="right"><button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.management" novalidate=""><div class="row" style="margin-top: 10px"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.management.recipe_name_m.$invalid && (vm.management.recipe_name_m.$dirty || vm.management.$submitted)}"><label for="recipe_name"><data-i18n i18n="_m_f_recipe_name_">recipe name</data-i18n></label> <input type="text" maxlength="60" class="form-control" id="recipe_name_m" name="recipe_name_m" placeholder="{{\'_m_f_recipe_name_\' | i18n}}" ng-model="vm.recipe.recipe_name" ng-change="vm.addRecipeDirty()" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_recipe_name_required_" select-on-click="">recipe name is required</data-i18n></span></div></div><div class="col-md-6" align="right"><button type="button" class="btn btn-primary" ng-click="vm.openWeekPreviewModal()" style="margin-top: 10px"><data-i18n i18n="_button_label_week_overview_">7 days preview</data-i18n></button></div></div><input type="text" required="" ng-show="false" ng-model="vm.recipe.suggestionHelpInput"></form><div class="row"><div style="padding: 20px 10px"><div include-with-scope="app/pages/recipes/addNewRecipe/pen_cost.table.html"></div></div></div><div class="row"><div style="padding: 20px 10px"><div include-with-scope="app/pages/recipes/addNewRecipe/mixing_suggestion.table.html"></div></div></div><div class="row"><div class="col-md-6"><div><label for="recipe_name"><data-i18n i18n="_mf_comment_feeder_">Comment for the feeder</data-i18n></label> <textarea style="resize: none; height: 34px; width: 100%" ng-model="vm.recipe.recipe_comment"></textarea></div></div><div class="col-md-6"><div><label for="recipe_name"><data-i18n i18n="_mf_comment_feeder_drop_">Comment for the feeder for dropping</data-i18n></label> <textarea style="resize: none; height: 34px; width: 100%" ng-model="vm.recipe.dropping_comment"></textarea></div></div></div></ba-wizard-step><ba-wizard-step title="{{vm.step5}}" class="wizard-step"><form class="form-horizontal" name="vm.finishForm" novalidate=""><div style="font-size: 16px"><data-i18n i18n="_m_f_add_new_recipe_finish_message_">You have successfully defined a new recipe. Do you want to save your work?</data-i18n></div></form><div style="margin-top: 10px" align="right"><button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.saveRecipe()"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.openFeedingDatepicker()"><data-i18n i18n="_btn_save_and_feed_now_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_"></data-i18n></button></div></ba-wizard-step></ba-wizard><loading-spinner-large ng-if="vm.loading"></loading-spinner-large>');
$templateCache.put('app/pages/recipes/editRecipe/editLoads.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><table class="table edit-loads-table"><thead><tr><th style="width: 120px"><button ng-disabled="!vm.editLoadsData.difference || vm.editLoadsData.difference >= 0" type="button" class="btn btn-primary btn-xs" ng-click="vm.addLoad()"><i class="fa fa-plus"></i></button></th><th class="edit-load-total-sum" colspan="4"><span><data-i18n i18n="_report_total_"></data-i18n>&nbsp;{{vm.editLoadsData.sum | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</span></th></tr></thead><tbody><tr ng-repeat="(loadIndex, load) in vm.editLoadsData.loads track by $index" class="edit-loads-table-row"><td><data-i18n i18n="_m_f_recipe_load_">Load</data-i18n>&nbsp;{{$index + 1}}:</td><td><span><div uib-dropdown="" keyboard-nav="" class="wagon-dropdown btn-group"><div uib-dropdown-toggle=""><div class="wagon-dropdown-container"><div><span class="wagon-name wagon-name-center">{{load.wagon.name}}</span>&nbsp;({{load.wagon.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}})</div><div class="dropdown-icon"><a href=""><span class="fa fa-chevron-down"></span></a></div></div></div><ul class="dropdown-menu-left" uib-dropdown-menu="" role="menu" aria-labelledby="herd-selector" style="max-height: 150px; overflow-y: auto"><li role="menuitem" ng-repeat="wagon in vm.recipe.wagons | orderBy: [\'-value\', \'name\']" ng-click="vm.updateLoad(load, load.value, loadIndex, wagon)"><a href="#"><div class="wagon-name">{{wagon.name}}</div>&nbsp;({{wagon.value | formatViewValues: \'rounded_amount\'}})&nbsp;{{vm.weight}}</a></li></ul></div></span></td><td><span editable-number="load.value" e-format-input-value="rounded_amount" e-min="0" e-required="" onbeforesave="vm.updateLoad(load, $data, loadIndex)" e-max="{{load.max}}" e-style="width: 100px"><b>{{load.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</b></span></td><td><button class="btn btn-xs btn-success" ng-click="vm.setLoad(load, $index)" ng-if="vm.editLoadsData.difference && vm.showSetButton(load)"><data-i18n i18n="_button_label_set_">set</data-i18n></button> <button class="btn btn-danger btn-xs" ng-click="vm.removeLoad($index)"><i class="fa fa-trash"></i></button></td></tr><tr ng-if="vm.editLoadsData.difference"><td colspan="12" class="difference"><span><data-i18n i18n="_rations_difference_">Difference</data-i18n>:&nbsp;{{vm.editLoadsData.difference | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</span></td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button> <button ng-disabled="vm.editLoadsData.loads.length > 10" type="button" class="btn btn-success" ng-click="vm.saveLoads()"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></div>');
$templateCache.put('app/pages/recipes/editRecipe/editRecipe.html','<div class="widgets" ng-if="vm.showPage"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll horizontal-scrol"><div include-with-scope="app/pages/recipes/editRecipe/wizard.html"></div></div></div></div></div>');
$templateCache.put('app/pages/recipes/editRecipe/feeds.table.html','<div ng-if="!vm.loading"><h3 class="with-line"><data i18n="_m_f_recipe_info_">Recipe info</data></h3><div class="basis-info"><div class="form-group basis-info-item"><label><data-i18n i18n="_rations_ration_name_">Ration name</data-i18n></label><div>{{(vm.recipe.selectedRation.ration_name) || \'-\'}}</div></div><div class="form-group basis-info-item"><label><data-i18n i18n="_feeds_dm_">DM</data-i18n>&nbsp;(%)</label><div><span class="recipe-has-warning" ng-class="vm.recipe.selectedRation && !vm.recipe.selectedRation.dm ? \'recipe-display-warning\' : \'recipe-disable-warning\'" uib-popover="{{\'_m_f_premix_basis_dm_error_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{vm.recipe.selectedRation.dm | formatViewValues: \'percentage\'}}&nbsp;<i ng-show="vm.recipe.selectedRation && !vm.recipe.selectedRation.dm" class="fa fa-info-circle"></i></span></div></div><div class="form-group basis-info-item"><label><data-i18n i18n="_feeds_amount_">Amount</data-i18n>&nbsp;({{vm.weight}})</label><div>{{vm.recipe.selectedRation.amount_dm | formatViewValues: \'amount\'}}</div></div><div class="form-group basis-info-item"><label><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n>&nbsp;({{vm.weight}})</label><div>{{vm.recipe.selectedRation.amount_as_fed | formatViewValues: \'as_fed\'}}</div></div><div class="form-group basis-info-item"><label><data-i18n i18n="_m_f_recipe_cost_">Cost</data-i18n>&nbsp;({{vm.currency}})</label><div>{{vm.recipe.selectedRation.cost_dm | formatViewValues: \'cost_dm\'}}</div></div></div><div style="margin-bottom: 10px" class="horizontal-scroll recipe-table recipe-validation-container" ng-class="!vm.recipe.rationHelpInput && vm.selectBasisForm.$submitted ? \'recipe-error\' : vm.recipe.ration_intake_warning ? \'recipe-dmi-warning\' : \'\'"><table class="table table-hover recipe-ration-feed-tmr-table"><thead><tr><th><data-i18n i18n="_m_f_label_change_loading_order_">Change loading order</data-i18n><br><br></th><th><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br><br></th><th><data-i18n i18n="_m_f_recipe_ingredient_label_">Ingredient</data-i18n>&nbsp; <button class="btn btn-xs btn-primary" ng-click="vm.goToPage(\'iManagement.addNewIngredient\')" uib-tooltip="{{\'_btn_add_new_ingredient_\' | i18n}}" tooltip-placement="right" tooltip-class="customBlue right" ng-disabled="vm.historicalVersion"><i class="fa fa-plus"></i></button><br><br></th><th><data-i18n i18n="_feeds_dm_">DM</data-i18n><br>%</th><th><data-i18n i18n="_feeds_amount_">Amount DM</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n><br>{{vm.weight}}</th><th><data-i18n i18n="_feeds_cost_dm_">Cost DM</data-i18n><br>{{vm.currency}}/{{vm.weight}}&nbsp; <span><data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th><th><data-i18n i18n="_feeds_cost_as_fed_">Cost as fed</data-i18n><br>{{vm.currency}}/{{vm.weight}} <span><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n></span></th></tr></thead><tbody dnd-list="vm.recipe.selectedRation.ration_feeds" dnd-disable-if="vm.disableDrag || vm.showIFields || vm.historicalVersion"><tr ng-repeat="feed in vm.recipe.selectedRation.ration_feeds" dnd-disable-if="vm.disableDrag || vm.showIFields || vm.historicalVersion" dnd-draggable="feed" dnd-moved="vm.drag($index)" dnd-dragend="vm.dragEnd(feed)"><td class="dm-table-cell"><a class="ion-drag icon-edit" ng-class="vm.recipe.selectedRation.ration_feeds.length < 2 ? \'hidden\' : \'\'" uib-tooltip="Drag and drop a section to change the order" tooltip-placement="left" tooltip-class="customBlue left wrap-text" tooltip-is-open="dragAndDropOpen" tooltip-popup-delay="300"></a></td><td style="min-width: 200px">{{feed.feed_name}}</td><td style="min-width: 200px"><a href="#" editable-select="feed.ingredient" e-style="width: 150px" edit-disabled="feed.access_error" e-ng-disabled="vm.historicalVersion" e-ng-options="ingredient as ingredient.name for ingredient in vm.recipe.ingredients" e-placeholder="{{\'_m_f_recipe_choose_ingredient_\' | i18n}}" onaftersave="vm.linkIngredient($data, feed)" buttons="no">{{feed.ingredient.name || (\'_m_f_recipe_choose_ingredient_\' | i18n)}}</a></td><td style="min-width: 110px"><span editable-number="feed.dm" e-required="" e-step="0.01" e-min="0.01" e-max="100" e-style="width: 100px" e-format-input-value="percentage" e-ng-disabled="feed.ingredient || vm.historicalVersion" onaftersave="vm.updateFeed($data, feed, \'dm\')">{{feed.dm | formatViewValues: \'percentage\'}}<label class="info-note" ng-if="feed.dm != feed.original_dm">(<data-i18n i18n="_m_f_recipe_original_dm_label_">Original DM</data-i18n>:&nbsp;{{feed.original_dm | formatViewValues: \'percentage\'}})</label></span></td><td style="min-width: 110px"><span editable-number="feed.amount_dm" e-required="" e-step="0.01" e-min="0" e-style="width: 100px" e-format-input-value="amount" e-ng-disabled="vm.historicalVersion" onaftersave="vm.updateFeed($data, feed, \'amount_dm\')" ng-class="feed.amount_dm > vm.maxAmount ? \'dmi-warning-label\' : \'\'">{{feed.amount_dm | formatViewValues: \'amount\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.amount_as_fed" e-required="" e-step="0.01" e-min="0" e-style="width: 100px" e-format-input-value="as_fed" e-ng-disabled="vm.historicalVersion" onaftersave="vm.updateFeed($data, feed, \'amount_as_fed\')">{{feed.amount_as_fed | formatViewValues: \'as_fed\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.cost_dm" e-required="" e-step="0.001" e-min="0" e-style="width: 100px" e-format-input-value="cost_dm" e-ng-disabled="vm.historicalVersion" onaftersave="vm.updateFeed($data, feed, \'cost_dm\')">{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td style="min-width: 110px"><span editable-number="feed.cost_as_fed" e-required="" e-step="0.001" e-min="0" e-style="width: 100px" e-format-input-value="cost_dm" e-ng-disabled="vm.historicalVersion" onaftersave="vm.updateFeed($data, feed, \'cost_as_fed\')">{{feed.cost_as_fed | formatViewValues: \'cost_dm\'}}</span></td></tr><tr class="dndPlaceholder"><td colspan="8"><data-i18n i18n="_m_f_drag_and_drop_placeholder_">Drop here</data-i18n></td></tr><tr ng-form="" name="vm.feedsForm" ng-if="vm.showIFields" class="recipe-feeds-table-manual-row"><td><div class="form-group has-feedback recipe-feed-name-column" ng-class="{\'has-error\': vm.feedsForm.feed_name.$invalid && (vm.feedsForm.feed_name.$dirty || vm.feedsForm.$submitted)}"><input select-on-click="" type="text" class="form-control" required="" id="feed_name" name="feed_name" ng-model="vm.new_feed.feed_name" ng-keypress="vm.inputKeyPress($event)"> <span class="help-block error-block basic-block"><data-i18n i18n="_toastr_feeds_name_required_">Feed name is required</data-i18n></span></div></td><td><div class="form-group recipe-feed-type-column" ng-class="{\'has-error\': vm.feedsForm.feed_type.$invalid && vm.feedsForm.$submitted}"><ui-select ng-model="vm.new_feed.feed_type" class="btn-group bootstrap-select form-control" ng-disabled="vm.historicalVersion" append-to-body="true" search-enabled="true" required="" id="feed_type" name="feed_type" ng-change="vm.feedTypeSelected()"><ui-select-match ng-disabled="vm.historicalVersion" placeholder="{{\'_picker_feed_type_placeholder_\' | i18n}}" uib-tooltip="{{$select.selected.translated}}" tooltip-enable="{{$select.selected.translated.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{$select.selected.translated}}</ui-select-match><ui-select-choices repeat="feed_type in vm.feed_types | filter: $select.search"><span class="shorten-long-text" ng-bind-html="feed_type.translated"></span></ui-select-choices></ui-select></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.feedsForm.dm.$invalid && (vm.feedsForm.dm.$dirty || vm.feedsForm.$submitted)}"><input select-on-click="" type="number" class="form-control" required="" id="dm" name="dm" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.new_feed.dm" min="0.01" max="100" step="0.01" ng-change="vm.newFeedDmChanged()" ng-keypress="vm.inputKeyPress($event)" ng-disabled="vm.historicalVersion"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_label_dm_required_">DM is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.feedsForm.amount.$invalid && (vm.feedsForm.amount.$dirty || vm.feedsForm.$submitted)}"><input select-on-click="" type="number" class="form-control" required="" id="amount" name="amount" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.new_feed.amount" format-input-value="amount" default-return-value="null" min="0" ng-change="vm.newFeedAmountDmChanged()" ng-keypress="vm.inputKeyPress($event)" ng-disabled="vm.historicalVersion"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_amount_dm_required_">Amount DM is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.feedsForm.as_fed.$invalid && (vm.feedsForm.as_fed.$dirty || vm.feedsForm.$submitted)}"><input select-on-click="" type="number" class="form-control" required="" id="as_fed" name="as_fed" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.new_feed.as_fed" format-input-value="as_fed" default-return-value="null" min="0" ng-change="vm.newFeedAmountAsFedChanged()" ng-keypress="vm.inputKeyPress($event)" ng-disabled="vm.historicalVersion"> <span class="help-block error-block basic-block"><data-i18n i18n="_feeds_as_fed_required_">As fed is required</data-i18n></span></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.feedsForm.cost_dm.$invalid && (vm.feedsForm.cost_dm.$dirty || vm.feedsForm.$submitted)}"><input select-on-click="" type="number" class="form-control" id="cost_dm" name="cost_dm" ng-pattern="/^[0-9]+(\\.[0-9]{1,3})?$/" ng-model="vm.new_feed.cost_dm" format-input-value="cost_dm" default-return-value="null" min="0" ng-change="vm.newFeedCostDmChanged()" ng-keypress="vm.inputKeyPress($event)" ng-disabled="vm.historicalVersion"></div></td><td><div class="form-group has-feedback" ng-class="{\'has-error\': vm.feedsForm.cost_as_fed.$invalid && (vm.feedsForm.cost_as_fed.$dirty || vm.feedsForm.$submitted)}"><input select-on-click="" type="number" class="form-control" ng-pattern="/^[0-9]+(\\.[0-9]{1,3})?$/" id="cost_as_fed" name="cost_as_fed" ng-model="vm.new_feed.cost_as_fed" format-input-value="cost_dm" default-return-value="null" min="0" ng-change="vm.newFeedCostAsFedChanged()" ng-keypress="vm.inputKeyPress($event)" ng-disabled="vm.historicalVersion"></div></td><td style="width: 100px" class="recipe-feeds-table-action"><button type="submit" ng-disabled="vm.feedsForm.$invalid || vm.disableAddFeed || vm.historicalVersion" class="btn btn-primary btn-xs" ng-click="vm.addNewFeed()"><i class="fa fa-check"></i></button> <button type="button" class="btn btn-danger btn-xs" ng-click="vm.cancelAddNewFeed()"><i class="fa fa-trash"></i></button></td></tr></tbody></table></div><div class="recipe-error-text" ng-class="(vm.recipe.feeds.length === 0 || vm.feedsForm.$invalid || vm.showIFields) && vm.selectBasisForm.$submitted ? \'recipe-error\' : \'\'"><data-i18n i18n="_m_f_premix_feeds_required_">Feeds are required</data-i18n></div><div class="recipe-error-text" ng-class="!vm.recipe.dm && vm.selectBasisForm.$submitted ? \'recipe-error\' : \'\'"><data-i18n i18n="_m_f_premix_basis_dm_error_">Basis DM is 0. Choose another basis or update the selected one to continue</data-i18n></div><div class="recipe-error-text" ng-class="vm.hasDM0Error && vm.selectBasisForm.$submitted ? \'recipe-error\' : \'\'"><data-i18n i18n="_m_f_premix_ingredient_dm_error_">Ingredient DM can\'t be 0</data-i18n></div><div class="recipe-error-text" ng-class="{\'recipe-error dmi-warning-label\': vm.recipe.ration_intake_warning}"><data-i18n i18n="_m_f_dmi_exceeded_message_" select-on-click="">Daily DMI should not exceed</data-i18n>&nbsp;{{vm.maxAmount}}{{vm.weight}}</div></div><loading-spinner-large ng-if="vm.loading"></loading-spinner-large>');
$templateCache.put('app/pages/recipes/editRecipe/insertWagon.modal.html','<div class="modal-content" ng-cloak=""><div ng-if="!vm.modalLoading"><div class="modal-header" style="padding-bottom: 0px"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body" style="padding-top: 3px"><div style="padding-top: 10px"><span><data-i18n i18n="_m_f_menu_wagons_add_wagon_">Create custom wagon</data-i18n>:</span><form name="vm.customWagonForm" novalidate=""><div class="form-group"><input class="form-control" type="text" id="wagon-name" name="wagon-name" required="" ng-model="vm.newWagon.name" placeholder="{{\'_m_f_wagons_name_\' | i18n}}" style="max-width: 250px; margin-top: 5px; margin-bottom: 10px"> <input class="form-control" type="text" id="wagon-serial" name="wagon-serial" ng-model="vm.newWagon.serial_number" placeholder="{{\'_m_f_serial_number_\' | i18n}}" maxlength="25" style="max-width: 250px"><br><label style="display: block"><data-i18n i18n="_m_f_wagons_capacity_">capacity</data-i18n></label><div class="form-group" style="max-width: 500px" ng-class="{\'has-error\': vm.customWagonForm.volume.$invalid && (vm.customWagonForm.volume.$dirty || vm.customWagonForm.$submitted)}"><input class="form-control with-units" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" type="number" min="0.1" max="90" step="0.1" id="volume" name="volume" ng-model="vm.newWagon.volume" placeholder="{{\'_m_f_wagons_volume_\'|i18n}}" style="margin-bottom: 10px; max-width: 250px"><span>m<sup>3</sup></span><br></div><div class="form-group" ng-class="{\'has-error\': vm.customWagonForm.weight.$invalid && (vm.customWagonForm.weight.$dirty || vm.customWagonForm.$submitted)}" style="max-width: 500px"><input type="number" class="form-control with-units" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" id="weight" name="weight" placeholder="{{\'_m_f_wagons_weight_\'|i18n}}" ng-model="vm.newWagon.weight" required="" min="0.1" max="90" step="0.1" style="max-width: 250px" select-on-click=""><span><data-i18n ng-if="vm.settings.use_kgs" i18n="_m_f_wagons_tonnes_">Tonnes</data-i18n><data-i18n ng-if="!vm.settings.use_kgs" i18n="_m_f_wagons_imperial_tonnes_">Tonnes</data-i18n></span> <span class="help-block error-block basic-block warningModal"><data-i18n i18n="_m_f_wagons_weight_required_" select-on-click="">weight is required</data-i18n></span></div></div><button style="margin-right: 0; margin-left: auto" class="btn btn-xs btn-success" ng-disabled="vm.customWagonForm.$invalid == true" ng-click="vm.addWagon(false)"><data-i18n i18n="_m_f_btn_add_">Add</data-i18n></button></form></div></div></div><loading-spinner-large ng-if="vm.modalLoading"></loading-spinner-large></div>');
$templateCache.put('app/pages/recipes/editRecipe/mixing_suggestion.table.html','<div class="horizontal-scroll"><table class="table load-configuration-table"><thead><tr><th colspan="3" align="center" class="mixing-suggestion-header"><data-i18n i18n="_m_f_recipe_mixing_suggestion_">Mixing suggestion</data-i18n></th></tr><tr class="sortable"><th ng-if="vm.recipe.total_feeding_1" class="text-primary"><data-i18n i18n="_m_f_recipe_feeding_">Feeding</data-i18n>&nbsp;1&nbsp;<span>({{vm.recipe.total_feeding_1 | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{vm.weight}})<div ng-if="vm.recipe.feedingsError.feeding_1" class="warningModal"><data-i18n i18n="_rations_difference_">Difference</data-i18n>:&nbsp;{{vm.recipe.feedingsError.feeding_1 | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</div></th><th ng-if="vm.recipe.total_feeding_2" class="text-primary"><data-i18n i18n="_m_f_recipe_feeding_">Feeding</data-i18n>&nbsp;2&nbsp;<span>({{vm.recipe.total_feeding_2 | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{vm.weight}})<div ng-if="vm.recipe.feedingsError.feeding_2" class="warningModal"><data-i18n i18n="_rations_difference_">Difference</data-i18n>:&nbsp;{{vm.recipe.feedingsError.feeding_2 | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</div></th><th ng-if="vm.recipe.total_feeding_3" class="text-primary"><data-i18n i18n="_m_f_recipe_feeding_">Feeding</data-i18n>&nbsp;3&nbsp;<span>({{vm.recipe.total_feeding_3 | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{vm.weight}})<div ng-if="vm.recipe.feedingsError.feeding_3" class="warningModal"><data-i18n i18n="_rations_difference_">Difference</data-i18n>:&nbsp;{{vm.recipe.feedingsError.feeding_3 | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</div></th></tr></thead><tbody class="load-suggestion"><tr><td ng-if="vm.recipe.total_feeding_1"><table class="table suggestion-table"><thead><tr><th><data-i18n i18n="_m_f_recipe_loads_">Loads</data-i18n><span class="suggestion-add-button"><button type="button" class="btn btn-primary btn-xs" uib-tooltip="{{\'_m_f_premix_edit_load_\' | i18n}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-click="vm.openEditLoadsModal(\'feeding_1\')" ng-if="vm.recipe.total_feeding_1 && vm.recipe.total_feeding_1 > 0" ng-disabled="vm.historicalVersion"><i class="fa fa-pencil"></i></button></span></th><th><data-i18n i18n="_m_f_menu_configurations_equipment_">Mixer wagon</data-i18n></th></tr></thead><tbody><tr ng-repeat="(indexX, load) in vm.recipe.suggestion.feeding_1.loads track by indexX" class="editable-suggestion-value"><td><data-i18n i18n="_m_f_recipe_load_">Load</data-i18n>&nbsp;{{$index+1}}: <span>{{load.value | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{vm.weight}}</td><td><div uib-dropdown="" keyboard-nav="" class="wagon-dropdown btn-group" dropdown-append-to-body=""><div uib-dropdown-toggle="" ng-disabled="vm.historicalVersion"><div class="wagon-name-long" uib-tooltip="{{load.wagon.name}}" tooltip-enable="{{load.wagon.name.length > 30 ? true : false}}" tooltip-is-open="wagonNameOpen" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500"><span>{{load.wagon.name}}</span></div><div class="dropdown-icon"><a href=""><span class="fa fa-chevron-down"></span></a></div></div><ul class="dropdown-menu-left" style="transform: translateX(-25%); max-height: 150px; overflow-y: auto" uib-dropdown-menu="" role="menu" aria-labelledby="herd-selector"><li role="menuitem" ng-repeat="wagon in vm.recipe.wagons | orderBy: [\'-value\', \'name\']" ng-click="vm.loadWagonChanged(\'feeding_1\', indexX, wagon)" ng-disabled="vm.historicalVersion"><a href="#"><div class="wagon-name wagon-name-center">{{wagon.name}}</div>&nbsp;({{wagon.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}})</a></li></ul></div></td></tr></tbody></table></td><td ng-if="vm.recipe.total_feeding_2"><table class="table suggestion-table"><thead><tr><th><data-i18n i18n="_m_f_recipe_loads_">Loads</data-i18n><span class="suggestion-add-button"><button type="button" class="btn btn-primary btn-xs" uib-tooltip="{{\'_m_f_premix_edit_load_\' | i18n}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-click="vm.openEditLoadsModal(\'feeding_2\')" ng-if="vm.recipe.total_feeding_2 && vm.recipe.total_feeding_2 > 0" ng-disabled="vm.historicalVersion"><i class="fa fa-pencil"></i></button></span></th><th><data-i18n i18n="_m_f_menu_configurations_equipment_">Mixer wagon</data-i18n></th></tr></thead><tbody><tr ng-repeat="(indexX, load) in vm.recipe.suggestion.feeding_2.loads track by indexX" class="editable-suggestion-value"><td><data-i18n i18n="_m_f_recipe_load_">Load</data-i18n>&nbsp;{{$index+1}}: <span>{{load.value | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{vm.weight}}</td><td><div uib-dropdown="" keyboard-nav="" class="wagon-dropdown btn-group" dropdown-append-to-body=""><div uib-dropdown-toggle="" ng-disabled="vm.historicalVersion"><div class="wagon-name-long" uib-tooltip="{{load.wagon.name}}" tooltip-enable="{{load.wagon.name.length > 30 ? true : false}}" tooltip-is-open="wagonNameOpen" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500"><span>{{load.wagon.name}}</span></div><div class="dropdown-icon"><a href=""><span class="fa fa-chevron-down"></span></a></div></div><ul class="dropdown-menu-left" style="transform: translateX(-25%); max-height: 150px; overflow-y: auto" uib-dropdown-menu="" role="menu" aria-labelledby="herd-selector"><li role="menuitem" ng-repeat="wagon in vm.recipe.wagons | orderBy: [\'-value\', \'name\']" ng-click="vm.loadWagonChanged(\'feeding_2\', indexX, wagon)" ng-disabled="vm.historicalVersion"><a href="#"><div class="wagon-name wagon-name-center">{{wagon.name}}</div>&nbsp;({{wagon.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}})</a></li></ul></div></td></tr></tbody></table></td><td ng-if="vm.recipe.total_feeding_3"><table class="table suggestion-table"><thead><tr><th><data-i18n i18n="_m_f_recipe_loads_">Loads</data-i18n><span class="suggestion-add-button"><button type="button" class="btn btn-primary btn-xs" uib-tooltip="{{\'_m_f_premix_edit_load_\' | i18n}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-click="vm.openEditLoadsModal(\'feeding_3\')" ng-if="vm.recipe.total_feeding_3 && vm.recipe.total_feeding_3 > 0" ng-disabled="vm.historicalVersion"><i class="fa fa-pencil"></i></button></span></th><th><data-i18n i18n="_m_f_menu_configurations_equipment_">Mixer wagon</data-i18n></th></tr></thead><tbody><tr ng-repeat="(indexX, load) in vm.recipe.suggestion.feeding_3.loads track by indexX" class="editable-suggestion-value"><td><data-i18n i18n="_m_f_recipe_load_">Load</data-i18n>&nbsp;{{$index+1}}: <span>{{load.value | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{vm.weight}}</td><td><div uib-dropdown="" keyboard-nav="" class="wagon-dropdown btn-group" dropdown-append-to-body=""><div uib-dropdown-toggle="" ng-disabled="vm.historicalVersion"><div class="wagon-name-long" uib-tooltip="{{load.wagon.name}}" tooltip-enable="{{load.wagon.name.length > 30 ? true : false}}" tooltip-is-open="wagonNameOpen" tooltip-placement="left" tooltip-class="customBlue left wrap-text" tooltip-popup-delay="500"><span>{{load.wagon.name}}</span></div><div class="dropdown-icon"><a href=""><span class="fa fa-chevron-down"></span></a></div></div><ul class="dropdown-menu-left" style="transform: translateX(-25%); max-height: 150px; overflow-y: auto" uib-dropdown-menu="" role="menu" aria-labelledby="herd-selector"><li role="menuitem" ng-repeat="wagon in vm.recipe.wagons | orderBy: [\'-value\', \'name\']" ng-click="vm.loadWagonChanged(\'feeding_3\', indexX, wagon)" ng-disabled="vm.historicalVersion"><a href="#"><div class="wagon-name wagon-name-center">{{wagon.name}}</div>&nbsp;({{wagon.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}})</a></li></ul></div></td></tr></tbody></table></td></tr><tr><td ng-if="vm.recipe.total_feeding_1"><table class="table suggestion-table"><tr><td class="text-primary"><data-i18n i18n="_m_f_recipe_number_of_loads_">Number of loads</data-i18n></td><td>{{vm.recipe.suggestion.feeding_1.loads.length}}</td></tr></table></td><td ng-if="vm.recipe.total_feeding_2"><table class="table suggestion-table"><tr><td class="text-primary"><data-i18n i18n="_m_f_recipe_number_of_loads_">Number of loads</data-i18n></td><td>{{vm.recipe.suggestion.feeding_2.loads.length}}</td></tr></table></td><td ng-if="vm.recipe.total_feeding_3"><table class="table suggestion-table"><tr><td class="text-primary"><data-i18n i18n="_m_f_recipe_number_of_loads_">Number of loads</data-i18n></td><td>{{vm.recipe.suggestion.feeding_3.loads.length}}</td></tr></table></td></tr></tbody></table></div>');
$templateCache.put('app/pages/recipes/editRecipe/penDetails.modal.html','<div class="modal-content" ng-cloak=""><div class="panel-content recipe-pen-details" ng-if="!vm.modalLoading"><h3 class="with-line"><data-i18n i18n="_m_f_pen_details_basic_informations_">Basic Informations</data-i18n></h3><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_name_">Name</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 wrap-text"><span>{{vm.details.pen_name}}</span></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_groups_no_animals_">Number of animals</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.number_of_animals}}</span></div></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_category_">Pen category</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.pen_category.name}}</span></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_feeds_dmi_">dmi</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.feed_intake | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</span></div></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_number_of_cubicles_">Number of cubicles</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.number_of_cubicles || \'/\'}}</span></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_number_of_headlocks_">Number of headlocks</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.number_of_headlocks || \'/\'}}</span></div></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_active_">Pen active</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span><a class="ion-checkmark-round primaryModal" ng-if="vm.details.pen_active"></a><a ng-if="!vm.details.pen_active" class="ion-close-round warningModal"></a></span></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_automatic_update_">Automatic update</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span><a class="ion-checkmark-round primaryModal" ng-if="vm.details.automatic_update"></a> <a ng-if="!vm.details.automatic_update" class="ion-close-round warningModal"></a></span></div></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_m_f_pen_address_">Pen address</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.pen_address}}</span></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><label><data-i18n i18n="_mf_dmi_source_">DMI source</data-i18n>:</label></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><span>{{vm.details.dmi_source}}</span>&nbsp; <span ng-if="vm.details.ration_depending">({{vm.details.ration_depending | number: 2}}&nbsp;{{vm.weight}})</span></div></div></div></div><div ng-if="vm.showGMap" class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="row"><div id="google-maps" class="medium-panel-maps"></div></div></div></div><h3 class="with-line"><data-i18n i18n="_m_f_pen_details_feeding_informations_">Feeding Informations</data-i18n></h3><div class="row pen-feeding-details recipe-pen-feeding-details horizontal-scroll"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="row"><table class="table table-striped"><thead><tr><th><data-i18n i18n="_m_f_pen_feeding_start_date_">Feeding date</data-i18n></th><th><data-i18n i18n="_m_f_pen_frequency_of_feeding_">Frequency of feeding</data-i18n></th><th><data-i18n i18n="_m_f_pen_feedings_per_day">feeding per day</data-i18n></th><th><data-i18n i18n="_m_f_placeholder_select_feeding_time_">feeding</data-i18n></th><th><data-i18n i18n="_active_schedule_">Active schedule</data-i18n></th></tr></thead><tbody><tr ng-repeat="freq in vm.details.pen_feeding_scheduler_list | orderBy:\'-start_feeding_date\'" ng-class="freq.schedule_set ? \'primaryModal\' : \'\'"><td>{{freq.start_feeding_date | date:\'shortDate\'}}</td><td>{{freq.feeding_frequency || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td>{{freq.number_of_feedings}}</td><td><div><span ng-if="freq.morning_feeding">{{freq.morning_feeding_time | date: \'hh:mm a\'}}</span> <span ng-if="freq.noon_feeding">{{freq.noon_feeding_time | date: \'hh:mm a\'}}</span> <span ng-if="freq.evening_feeding">{{freq.evening_feeding_time | date: \'hh:mm a\'}}</span></div><div ng-if="!freq.morning_feeding && !freq.noon_feeding && !freq.evening_feeding"><data-i18n i18n="_m_f_calendar_not_available_label_"></data-i18n></div></td><td><a class="ion-checkmark-round primaryModal" ng-if="freq.schedule_set"></a> <a ng-if="!freq.schedule_set" class="ion-close-round warningModal"></a></td></tr></tbody></table></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><loading-spinner-large ng-if="vm.modalLoading"></loading-spinner-large></div>');
$templateCache.put('app/pages/recipes/editRecipe/penMessage.modal.html','<div class="modal-content" ng-cloak=""><div class="modal-body"><div><data-i18n i18n="_m_f_pen_update_recipe_message_">Following the pen update, the recipe was recalculated, and a new version was created automatically.</data-i18n></div></div><div class="modal-footer"><div align="right"><button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_label_close_">Close</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/recipes/editRecipe/pens.table.html','<div class="horizontal-scroll recipe-table" ng-class="!vm.recipe.penHelpInput && vm.selectPenForm.$submitted ? \'recipe-error\' : vm.recipe.pen_intake_warning ? \'recipe-dmi-warning\' :\'\'"><table class="table table-hover"><thead><tr class="sortable"><th align="left"><data-i18n i18n="_title_column_action_">action</data-i18n></th><th><data-i18n i18n="_m_f_pen_active_">pen active</data-i18n></th><th><data-i18n i18n="_m_f_pen_name_">pen name</data-i18n></th><th><data-i18n i18n="_m_f_title_category_">category</data-i18n></th><th><data-i18n i18n="_m_f_pen_number_of_animals_">number of animals</data-i18n></th><th class="recipe-pen-feed-intake-heading"><data-i18n i18n="_feeds_dmi_">dmi</data-i18n></th><th class="recipe-number-of-feedings recipe-number-of-feedings-th"><data-i18n i18n="_m_f_pen_feedings_">feedings</data-i18n></th><th><data-i18n i18n="_title_create_date">create date</data-i18n></th><th style="text-align: center"><data-i18n i18n="_m_f_pen_automatic_update_">automatic update</data-i18n></th></tr></thead><tbody ng-if="!vm.loadingPensTable && vm.recipe.selected_pens_deleted.length" class="pens-deleted"><tr ng-repeat="pen in vm.recipe.selected_pens_deleted"><td style="min-width: 120px"><span class="newCheck"><input type="checkbox" id="is_checked_deleted{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="pen.is_selected" style="margin-right: 2px" ng-change="vm.selectPen(pen)" ng-disabled="!pen.is_selected || vm.historicalVersion"> <label ng-class="!pen.is_selected ? \'disabled\' : \'\'" for="is_checked_deleted{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" disabled=""><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" disabled=""><i class="ion-clipboard"></i></button></td><td><a class="icon-edit green-icon" href="" style="margin-left: 10px" ng-class="pen.pen_active ? \'ion-star\' : \'ion-ios-star-outline\'"></a></td><td class="shorten-long-text" uib-tooltip="{{pen.pen_name}}" tooltip-enable="{{pen.pen_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{pen.pen_name}}</td><td>{{pen.pen_category.name}}</td><td>{{pen.number_of_animals}}</td><td class="recipe-pen-feed-intake"><div><div><ui-select ng-model="pen.use_pen_feed_intake" ng-disabled="true" class="btn-group bootstrap-select intake-source-column" append-to-body="true"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item.value as item in vm.feedIntakeSources"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select></div><div><span ng-style="pen.use_pen_feed_intake ? {} : {\'display\': \'none\'}">{{pen.feed_intake | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</span> <span ng-style="!pen.use_pen_feed_intake && pen.is_selected ? {} : {\'display\': \'none\'}">{{vm.recipe.ration_feed_intake | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</span> <span ng-style="!pen.use_pen_feed_intake && !pen.is_selected ? {} : {\'display\': \'none\'}">-</span></div></div></td><td class="recipe-number-of-feedings"><span>{{pen.number_of_feedings}}</span></td><td>{{pen.create_date | date:\'short\'}}</td><td align="center"><a class="ion-checkmark-round primaryModal" ng-if="pen.automatic_update"></a> <a ng-if="!pen.automatic_update" class="ion-close-round warningModal"></a></td></tr><tr><td colspan="30"><data-i18n i18n="_m_f_recipe_deleted_pens_">Deleted pens</data-i18n></td></tr></tbody><tbody ng-if="!vm.loadingPensTable"><tr ng-repeat="pen in vm.recipe.pens"><td style="min-width: 120px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="pen.is_selected" style="margin-right: 2px" ng-change="vm.selectPen(pen)" ng-disabled="vm.historicalVersion"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToPage(\'pens.penHistory\', pen)" uib-tooltip="{{\'_tips_history_\' | i18n}}" tooltip-is-open="penHistoryOpen{{pen.id}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToPage(\'pens.editPen\', pen)" uib-tooltip="{{\'_tips_edit_\' | i18n}}" tooltip-is-open="editPenOpen{{pen.id}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-disabled="vm.historicalVersion"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.openPenDetailsModal(pen)" uib-tooltip="{{\'_tips_details_\' | i18n}}" tooltip-is-open="penDetailsOpen{{pen.id}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clipboard"></i></button></td><td><a class="icon-edit green-icon" href="" style="margin-left: 10px" ng-click="vm.changeActive(pen)" ng-class="pen.pen_active ? \'ion-star\' : \'ion-ios-star-outline\'"></a></td><td class="shorten-long-text" uib-tooltip="{{pen.pen_name}}" tooltip-enable="{{pen.pen_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{pen.pen_name}}</td><td>{{pen.pen_category.name}}</td><td>{{pen.number_of_animals}}</td><td class="recipe-pen-feed-intake"><div><div><ui-select ng-model="pen.use_pen_feed_intake" ng-disabled="!pen.is_selected || vm.historicalVersion" class="btn-group bootstrap-select intake-source-column" append-to-body="true" on-select="vm.updateUsePenIntake(pen)"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item.value as item in vm.feedIntakeSources"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select></div><div><span ng-style="pen.use_pen_feed_intake ? {} : {\'display\': \'none\'}">{{pen.feed_intake | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</span> <span ng-style="!pen.use_pen_feed_intake && pen.is_selected ? {} : {\'display\': \'none\'}" ng-class="vm.recipe.pen_intake_warning ? \'dmi-warning-label\' : \'\'">{{vm.recipe.ration_feed_intake | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</span> <span ng-style="!pen.use_pen_feed_intake && !pen.is_selected ? {} : {\'display\': \'none\'}">-</span></div></div></td><td class="recipe-number-of-feedings"><span>{{pen.number_of_feedings}}</span></td><td>{{pen.create_date | date:\'short\'}}</td><td align="center"><a class="ion-checkmark-round primaryModal" ng-if="pen.automatic_update"></a> <a ng-if="!pen.automatic_update" class="ion-close-round warningModal"></a></td></tr></tbody><tfoot ng-if="vm.recipe.totalItemsPens > 10"><tr><td colspan="11" style="text-align: center"><uib-pagination boundary-links="true" total-items="vm.recipe.totalItemsPens" ng-model="vm.recipe.currentPagePens" items-per-page="10" max-size="7" ng-change="vm.pensPaginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table></div><div class="recipe-error-text" ng-class="!vm.recipe.penHelpInput && vm.selectPenForm.$submitted ? \'recipe-error\' : \'\'"><data-i18n i18n="_m_f_pen_required_" select-on-click="">Pen is required</data-i18n></div><div class="recipe-warning-text" ng-class="!vm.recipe.penHelpInput && vm.selectPenForm.$submitted ? \'\' : vm.recipe.pen_intake_warning ? \'recipe-dmi-warning\' :\'\'"><data-i18n i18n="_m_f_dmi_exceeded_message_" select-on-click="">Daily DMI should not exceed</data-i18n>&nbsp;{{vm.maxAmount | formatViewValues: \'amount\'}}{{vm.weight}}</div><loading-spinner-large ng-if="vm.loadingPensTable"></loading-spinner-large>');
$templateCache.put('app/pages/recipes/editRecipe/pen_cost.table.html','<div class="horizontal-scroll recipe-table"><table class="table" st-table="vm.recipe.pens"><thead><tr class="sortable"><th><data-i18n i18n="_m_f_pen_name_">pen name</data-i18n></th><th><data-i18n i18n="_m_f_title_category_">category</data-i18n></th><th><data-i18n i18n="_m_f_pen_number_of_animals_">number of animals</data-i18n></th><th><data-i18n i18n="_feeds_dmi_">dmi</data-i18n></th><th><data-i18n i18n="_m_f_recipe_cost_">Cost</data-i18n>&nbsp;({{vm.currency}})</th><th><data-i18n ng-if="vm.settings.use_kgs" i18n="_m_f_recipe_total_kg_dm_">Total kg DM</data-i18n><data-i18n ng-if="!vm.settings.use_kgs" i18n="_m_f_recipe_total_lb_dm_">Total lb DM</data-i18n></th><th><data-i18n ng-if="vm.settings.use_kgs" i18n="_m_f_recipe_total_kg_as_fed_">Total kg as fed</data-i18n><data-i18n ng-if="!vm.settings.use_kgs" i18n="_m_f_recipe_total_lb_as_fed_">Total lb as fed</data-i18n></th><th><data-i18n i18n="_m_f_pen_morning_feeding_short_">morning</data-i18n></th><th><data-i18n i18n="_m_f_pen_noon_feeding_short_">noon</data-i18n></th><th><data-i18n i18n="_m_f_pen_evening_feeding_short_">evening</data-i18n></th></tr></thead><tbody><tr ng-repeat="pen in vm.recipe.selected_pens | orderBy: \'id\': true" class="editable-tr-wrap"><td class="recipe-ration-name" uib-tooltip="{{pen.pen_name}}" tooltip-enable="{{pen.pen_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span ng-if="pen.visible">{{pen.pen_name}}</span> <span ng-if="!pen.visible" class="recipe-warning-my" uib-popover="{{\'_m_f_recipe_pen_removed_warning_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{pen.pen_name}}&nbsp;<i class="fa fa-info-circle"></i></span></td><td>{{pen.pen_category.name}}</td><td>{{pen.number_of_animals}}</td><td>{{pen.used_feed_intake | formatViewValues: \'amount\'}}&nbsp;{{vm.weight}}</td><td>{{pen.cost_dm | number: 2}}</td><td>{{pen.total_amount_dm | formatViewValues: \'rounded_amount\'}}</td><td>{{pen.total_as_fed | formatViewValues: \'rounded_amount\'}}</td><td style="min-width: 100px"><div><span>{{pen.feeding_1_amount | formatViewValues: \'rounded_amount\' | defaultReturnValue: null}}</span></div><div class="link-color" ng-class="pen.feeding_1_valid ? \'timepicker-link\' : \'\'"><span>{{(pen.feeding_1 | date: "hh:mm a")}}</span></div><span ng-if="!pen.feeding_1"><data-i18n i18n="_label_none_"></data-i18n></span></td><td style="min-width: 100px"><div><span>{{pen.feeding_2_amount | formatViewValues: \'rounded_amount\' | defaultReturnValue: null}}</span></div><div class="link-color" ng-class="pen.feeding_2_valid ? \'timepicker-link\' : \'\'"><span>{{(pen.feeding_2 | date: "hh:mm a")}}</span></div><span ng-if="!pen.feeding_2"><data-i18n i18n="_label_none_"></data-i18n></span></td><td style="min-width: 100px"><div><span>{{pen.feeding_3_amount | formatViewValues: \'rounded_amount\' | defaultReturnValue: null}}</span></div><div class="link-color" ng-class="pen.feeding_3_valid ? \'timepicker-link\' : \'\'"><span>{{(pen.feeding_3 | date: "hh:mm a")}}</span></div><span ng-if="!pen.feeding_3"><data-i18n i18n="_label_none_"></data-i18n></span></td></tr><tr class="highlight-sum-table"><td><span style="text-transform: uppercase"><data-i18n i18n="_m_f_label_summary_">Summary</data-i18n>:</span></td><td class="shorten-long-text" uib-tooltip="{{vm.recipe.recipe_name}}" tooltip-enable="{{vm.recipe.recipe_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{vm.recipe.recipe_name}}</td><td>{{vm.recipe.total_number_of_animals}}</td><td></td><td>{{vm.recipe.total_cost | number: 2}}&nbsp;({{vm.currency}})</td><td>{{vm.recipe.total_amount_dm | formatViewValues: \'rounded_amount\'}}</td><td>{{vm.recipe.total_as_fed | formatViewValues: \'rounded_amount\'}}</td><td>{{vm.recipe.total_feeding_1 | formatViewValues: \'rounded_amount\'}}</td><td>{{vm.recipe.total_feeding_2 | formatViewValues: \'rounded_amount\'}}</td><td>{{vm.recipe.total_feeding_3 | formatViewValues: \'rounded_amount\'}}</td><td></td></tr></tbody></table></div>');
$templateCache.put('app/pages/recipes/editRecipe/rationRecipe.popover.html','<div style="height: 200px; overflow-y: auto"><label><data-i18n i18n="_m_f_linking_ingredient_warning_">Warning</data-i18n></label><ul ng-if="vm.recipe.is_selected" ng-repeat="r in vm.recipe.recipe_list | orderBy: \'id\': true"><li>{{r.name}}</li></ul><ul ng-if="!vm.recipe.is_selected" ng-repeat="r in vm.recipe.rations[vm.recipe.popover_ration_index].recipe_list | orderBy: \'id\': true"><li>{{r.name}}</li></ul></div>');
$templateCache.put('app/pages/recipes/editRecipe/rations.table.html','<div class="horizontal-scroll recipe-table" ng-class="!vm.recipe.rationHelpInput && vm.selectRationForm.$submitted ? \'recipe-error\' : \'\'"><table class="table table-hover ration-table" ng-if="!vm.loadingRations"><thead><tr class="sortable"><th align="left"><data-i18n i18n="_title_column_action_">action</data-i18n></th><th><data-i18n i18n="_rations_ration_name_">ration name</data-i18n></th><th><data-i18n i18n="_groups_group_name_">group name</data-i18n></th><th><data-i18n i18n="_title_create_date">create date</data-i18n></th><th><data-i18n i18n="_label_updated_on_">Updated on</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th></tr></thead><tbody class="recipe-ration"><tr ng-class="!vm.recipe.ration.visible ? \'ration-deleted\' : \'\'"><td><div class="rationBtns"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}-X" ng-click="vm.selectRecipeRation()" ng-model="vm.recipe.is_selected" ng-disabled="vm.disableRationSelect || vm.historicalVersion"> <label for="is_checked{{$index}}-X"></label></span></div></td><td class="shorten-long-text"><span class="recipe-has-warning" ng-class="vm.recipe.is_selected && vm.recipe.recipe_list && vm.recipe.recipe_list.length ? \'recipe-display-warning\' : \'recipe-disable-warning\'" ng-mouseover="vm.rationTypeSelected(\'recipe_ration\')" uib-popover-template="\'app/pages/recipes/editRecipe/rationRecipe.popover.html\'" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="bottom">{{vm.recipe.ration.ration_name}}&nbsp;<i ng-show="vm.recipe.is_selected && vm.recipe.recipe_list && vm.recipe.recipe_list.length" class="fa fa-info-circle"></i></span> <label class="ration-info-note">{{vm.recipe.ration.origin}}</label></td><td class="shorten-long-text" uib-tooltip="{{vm.recipe.ration.group.name}}" tooltip-enable="{{vm.recipe.ration.group.name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{vm.recipe.ration.group.name || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td>{{(vm.recipe.ration.create_date | date:\'medium\') || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td>{{(vm.recipe.ration.last_modified_date | date: \'medium\') || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td>{{vm.recipe.ration.dm | formatViewValues: \'percentage\'}}</td></tr></tbody><thead><tr class="error-row" ng-if="!vm.recipe.ration.visible && vm.recipe.is_selected"><td colspan="6"><data-i18n i18n="_m_f_recipe_ration_deleted_">Selected ration has been deleted.</data-i18n></td></tr></thead><tbody class="list-of-rations"><tr ng-repeat="ration in vm.recipe.rations" ng-if="ration.is_displayed" ng-class="ration.duplicate ? \'duplicate-ration-opacity\' : \'\'"><td><div class="rationBtns"><span class="newCheck"><input type="checkbox" id="is_checked1{{$index}}-Y" ng-checked="ration.is_selected" ng-click="vm.selectRation(ration, $index)" ng-model="ration.is_selected" style="margin-right: 2px" ng-disabled="vm.disableRationSelect || vm.historicalVersion"> <label for="is_checked1{{$index}}-Y"></label></span></div></td><td class="shorten-long-text"><span class="recipe-has-warning" ng-class="ration.is_selected && ration.recipe_list && ration.recipe_list.length ? \'recipe-display-warning\' : \'recipe-disable-warning\'" ng-mouseover="vm.rationTypeSelected(\'ration\')" uib-popover-template="\'app/pages/recipes/editRecipe/rationRecipe.popover.html\'" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="bottom">{{ration.ration_name}}&nbsp;<i ng-show="ration.is_selected && ration.recipe_list && ration.recipe_list.length" class="fa fa-info-circle"></i></span> <label class="ration-info-note">{{ration.origin}}</label></td><td class="shorten-long-text" uib-tooltip="{{ration.group_name}}" tooltip-enable="{{ration.group_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{ration.group_name || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td>{{(ration.create_date | date:\'medium\') || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td>{{(ration.last_modified_date | date: \'medium\') || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td>{{ration.dm | formatViewValues: \'percentage\'}}</td></tr><tr class="show-hide-filters" ng-if="vm.recipe.show_hide_ration_button"><td colspan="6"><button ng-click="vm.toggleShowRation()"><i ng-if="vm.hideFilters" class="ion-arrow-up-b"></i><i ng-if="!vm.hideFilters" class="ion-arrow-down-b"></i><span><data-i18n i18n="_label_show_hide_ration_">Show/hide duplicate ration</data-i18n></span><i ng-if="vm.hideFilters" class="ion-arrow-up-b"></i><i ng-if="!vm.hideFilters" class="ion-arrow-down-b"></i></button></td></tr></tbody><tfoot ng-if="vm.recipe.totalItemsRation > 10"><tr><td colspan="6" style="text-align: center"><uib-pagination boundary-links="true" total-items="vm.recipe.totalItemsRation" ng-model="vm.recipe.currentPageRation" items-per-page="10" max-size="7" ng-change="vm.rationsPaginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></td></tr></tfoot></table></div><div class="recipe-error-text _m_f_ration_required_" ng-class="!vm.recipe.rationHelpInput && vm.selectRationForm.$submitted ? \'recipe-error warningModal\' : \'\'"><span class="warningModal"><data-i18n i18n="_m_f_ration_required_" select-on-click="">Ration is required</data-i18n></span></div><loading-spinner-large ng-if="vm.loadingRations"></loading-spinner-large>');
$templateCache.put('app/pages/recipes/editRecipe/versions.table.html','<div class="horizontal-scroll" ng-if="!vm.loading && vm.selectedHerd"><table class="table table-hover my-recipes-table"><thead><tr class="sortable"><th></th><th><data-i18n i18n="_label_used_from_">Used from</data-i18n><br></th><th><data-i18n i18n="_title_last_modified_date_">Last modified date</data-i18n><br></th><th><data-i18n i18n="_m_f_recipe_pen_">Pen(s)</data-i18n><br></th><th><data-i18n i18n="_m_f_recipe_total_price_">Total price</data-i18n><br>{{vm.currency}}/<data-i18n i18n="_unit_day_">day</data-i18n></th></tr></thead><tbody><tr ng-repeat="version in vm.recipe.versions"><td><span class="newCheck"><input type="checkbox" id="version_checked{{$index}}-X" ng-true-value="true" ng-false-value="false" ng-click="vm.selectVersion(version)" ng-model="version.is_selected" ng-disabled="version.is_selected" style="margin-right: 2px"> <label for="version_checked{{$index}}-X"></label></span></td><td>{{version.used_from| date: \'medium\'}}</td><td>{{version.create_date| date: \'medium\'}}</td><td>{{version.scheduled_pens.length }}</td><td>{{version.total_price| number:2}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/recipes/editRecipe/wizard.html','<div ng-if="!vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div><div ng-if="vm.selectedHerd"><ba-wizard id="edit-recipe-tabs" ng-show="!vm.loading && !vm.recipe.ration_error" class="recipe-tabs" ng-class="vm.tabValidation()"><ba-wizard-step title="{{\'_label_versions_\' | i18n}}" form="vm.selectVersionForm" class="wizard-step"><div class="row"><div class="col-md-12"><div include-with-scope="app/pages/recipes/editRecipe/versions.table.html"></div></div></div></ba-wizard-step><ba-wizard-step title="{{\'_m_f_add_new_recipe_step1_title_\' | i18n}}" form="vm.selectRationForm" class="wizard-step"><div align="right"><button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.saveRecipe(false)"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.openFeedingDatepicker()"><data-i18n i18n="_btn_save_and_feed_now_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.selectRationForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.selectRationForm.recipe_name.$invalid && (vm.selectRationForm.recipe_name.$dirty || vm.selectRationForm.$submitted)}"><label for="recipe_name"><data-i18n i18n="_m_f_recipe_name_">recipe name</data-i18n></label> <input type="text" maxlength="60" class="form-control" id="recipe_name" name="recipe_name" placeholder="{{\'_m_f_recipe_name_\' | i18n}}" ng-model="vm.recipe.recipe_name" required="" ng-change="vm.addRecipeDirty()" ng-disabled="vm.historicalVersion"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_recipe_name_required_" select-on-click="">recipe name is required</data-i18n></span></div></div></div><input type="text" required="" ng-show="false" ng-model="vm.recipe.rationHelpInput"></form><div class="row"><div class="col-md-6"><label style="font-weight: 400; margin-top: 10px"><data-i18n i18n="_m_f_recipe_select_1_ration_">select 1 ration</data-i18n>:</label></div><div class="col-md-6"><div style="float: right"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary" uib-dropdown-toggle="" style="margin-left: 10px" ng-disabled="vm.historicalVersion"><data-i18n i18n="_btn_add_ration_">add ration</data-i18n><span class="caret"></span></button><ul uib-dropdown-menu="" class="dropdown-menu"><li ng-if="vm.hasRationAccess"><a href="" ng-click="vm.goToPage(\'rations.addnewration\')"><data-i18n i18n="_report_footer_feed_">add ration</data-i18n></a></li><li><a href="" ng-click="vm.goToPage(\'rations.addmanualration\')"><data-i18n i18n="_btn_add_ration_manually_">Add manually</data-i18n></a></li></ul></div></div></div></div><div class="row" style="padding-top: 10px"><div class="col-md-6"><div class="form-group" style="width: auto; min-width: 175px; margin-bottom: 0px"><label><data-i18n i18n="_add_new_recipe_show_rations_label_">Show rations</data-i18n>:</label><ui-select ng-model="vm.recipe.selected_ration_type" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" required="" ng-change="vm.selectRationType()" ng-disabled="vm.historicalVersion"><ui-select-match placeholder="{{\'_mf_ration_source_\' | i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type in vm.rationTypes | filter: $select.search"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div style="padding: 20px 10px"><div include-with-scope="app/pages/recipes/editRecipe/rations.table.html"></div></div></div><div class="row" ng-if="vm.recipe.selectedRation"><div class="col-md-12"><div ng-if="!vm.loadingRationFeeds" include-with-scope="app/pages/recipes/editRecipe/feeds.table.html"></div><loading-spinner-large ng-if="vm.loadingRationFeeds"></loading-spinner-large></div></div></ba-wizard-step><ba-wizard-step title="{{\'_m_f_add_new_recipe_step2_title_\' | i18n}}" form="vm.selectPenForm" class="wizard-step"><div align="right"><button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.saveRecipe(false)"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.openFeedingDatepicker()"><data-i18n i18n="_btn_save_and_feed_now_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.selectPenForm" novalidate=""><input required="" type="text" ng-model="vm.recipe.penHelpInput" ng-show="false"><div class="row" style="margin-top: 10px"><div class="col-md-6"><label style="font-weight: 400; margin-top: 10px"><data-i18n i18n="_m_f_recipe_select_pens_">select pens</data-i18n>:</label></div><div class="col-md-6"><div style="float: right"><button class="btn btn-primary" onclick="return false;" ng-click="vm.goToPage(\'pens.addNewPen\')"><data-i18n i18n="_btn_add_new_pen_">add new pen</data-i18n></button></div></div></div><div class="row"><div><div include-with-scope="app/pages/recipes/editRecipe/pens.table.html"></div></div></div></form></ba-wizard-step><ba-wizard-step title="{{\'_m_f_recipe_choose_mixer_wagons_\' | i18n}}" form="vm.feedingMethod" class="wizard-step"><div align="right"><button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.saveRecipe(false)"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.openFeedingDatepicker()"><data-i18n i18n="_btn_save_and_feed_now_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.feedingMethod" novalidate=""><input required="" type="text" ng-show="false" ng-model="vm.recipe.feedingMethodHelpInput"> <input required="" type="text" ng-show="false" ng-model="vm.recipe.wagonHelpInput"><div class="row" style="margin-top: 10px"><div class="col-md-3"></div><div class="col-md-6" ng-if="vm.recipe.tmr"><div class="recipe-wagon-container"><label><data-i18n i18n="_m_f_recipe_choose_mixer_wagons_">Choose your mixer wagons</data-i18n>:</label><div><button class="btn btn-sm btn-primary" ng-click="vm.insertWagon($event)" ng-disabled="vm.historicalVersion"><data-i18n i18n="_m_f_recipe_add_wagon_">Add wagon</data-i18n></button></div><div class="recipe-wagon-inner recipe-validation-container" ng-class="!vm.recipe.wagonHelpInput && vm.feedingMethod.$submitted ? \'recipe-error\' : \'\'"><table class="recipe-wagon-table" ng-if="!vm.loadingMixerWagons"><thead><tr ng-if="vm.recipe.wagons.length > 0"><th colspan="2"><data i18n="_m_f_premix_select_mixer_wagon_">Select wagon</data></th><th><data i18n="_label_name_">Name</data></th><th><data i18n="_m_f_wagons_capacity_">Capacity</data></th><th><data i18n="_m_f_recipe_choose_default_mixer_wagon_">Choose default mixer wagon</data>:</th></tr><span class="warningModal" ng-if="vm.recipe.wagons.length === 0"><data-i18n i18n="_m_f_premix_wagon_not_available_">Mixer wagon not availabe</data-i18n></span></thead><tbody lazy-img-container="" ng-if="vm.recipe.wagons.length > 0"><tr ng-repeat="wagon in vm.recipe.wagons"><td><span class="newCheck"><input type="checkbox" id="wagon_checked_{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="wagon.selected" ng-change="vm.wagonSelected(wagon)" ng-disabled="vm.historicalVersion"> <label for="wagon_checked_{{$index}}"></label></span></td><td><span class="select-wagon-img"><img src="assets/img/MmmLogo.png" lazy-img="{{wagon.image_url}}" lazy-img-error="assets/img/MmmLogo.png" ng-if="wagon.image_url"> <img src="assets/img/MmmLogo.png" ng-if="!wagon.image_url"></span></td><td><span class="wagon-name" uib-tooltip="{{wagon.name}}" tooltip-enable="{{wagon.name.length > 30 ? true : false}}" tooltip-is-open="wagonNameOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-hide-overflow" tooltip-popup-delay="500" ng-class="wagon.deleted ? \'deleted-wagon\' : \'\'">{{wagon.name}}</span></td><td><span class="wagon-name" ng-class="wagon.deleted ? \'deleted-wagon\' : \'\'">{{wagon.value | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</span></td><td><span ng-if="wagon.selected" class="newCheck"><input type="checkbox" id="default_checked_{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="wagon.default" ng-disabled="wagon.default" ng-change="vm.defaultSelected(wagon)"> <label for="default_checked_{{$index}}"></label></span></td></tr></tbody></table></div></div><div class="recipe-error-text" ng-class="!vm.recipe.wagonHelpInput && vm.planningForm.$submitted ? \'recipe-error\' : \'\'"><span class="warningModal"><data-i18n i18n="_m_f_feeding_mixer_wagon_required_">Mixer wagon is required</data-i18n></span></div><loading-spinner-large ng-if="vm.loadingMixerWagons"></loading-spinner-large></div></div></form></ba-wizard-step><ba-wizard-step title="{{\'_m_f_add_new_recipe_step4_title_\' | i18n}}" form="vm.management" class="wizard-step"><div align="right"><button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.saveRecipe(false)"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.openFeedingDatepicker()"><data-i18n i18n="_btn_save_and_feed_now_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><form name="vm.management" novalidate=""><div class="row" style="margin-top: 10px"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.management.recipe_name_m.$invalid && (vm.management.recipe_name_m.$dirty || vm.management.$submitted)}"><label for="recipe_name"><data-i18n i18n="_m_f_recipe_name_">recipe name</data-i18n></label> <input type="text" maxlength="60" class="form-control" id="recipe_name_m" name="recipe_name_m" placeholder="{{\'_m_f_recipe_name_\' | i18n}}" ng-model="vm.recipe.recipe_name" required="" ng-change="vm.addRecipeDirty()" ng-disabled="vm.historicalVersion"> <span class="help-block error-block basic-block"><data-i18n i18n="_m_f_recipe_name_required_" select-on-click="">recipe name is required</data-i18n></span></div></div><div class="col-md-6" align="right"><button type="button" class="btn btn-primary" ng-click="vm.openWeekPreviewModal()" style="margin-top: 10px" ng-disabled="vm.historicalVersion"><data-i18n i18n="_button_label_week_overview_">7 days preview</data-i18n></button></div></div><input type="text" required="" ng-show="false" ng-model="vm.recipe.suggestionHelpInput"></form><div class="row"><div style="padding: 20px 10px"><div include-with-scope="app/pages/recipes/editRecipe/pen_cost.table.html"></div></div></div><div class="row"><div style="padding: 20px 10px"><div include-with-scope="app/pages/recipes/editRecipe/mixing_suggestion.table.html"></div></div></div><div class="row"><div class="col-md-6"><div><label for="recipe_name"><data-i18n i18n="_mf_comment_feeder_">Comment for the feeder</data-i18n></label> <textarea class="form-control" style="resize: none; height: 34px; width: 100%" ng-model="vm.recipe.recipe_comment"></textarea></div></div><div class="col-md-6"><div><label for="recipe_name"><data-i18n i18n="_mf_comment_feeder_drop_">Comment for the feeder for dropping</data-i18n></label> <textarea class="form-control" style="resize: none; height: 34px; width: 100%" ng-model="vm.recipe.dropping_comment"></textarea></div></div></div></ba-wizard-step><ba-wizard-step title="{{\'_m_f_add_new_recipe_step5_title_\' | i18n}}" class="wizard-step"><form class="form-horizontal" name="vm.finishForm" novalidate=""><div style="font-size: 16px"><data-i18n i18n="_m_f_edit_recipe_finish_message_">Recipe updated. Do you want to save your work?</data-i18n></div></form><div style="margin-top: 10px" align="right"><button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.saveRecipe(false)"><data-i18n i18n="_btn_save_"></data-i18n></button> <button type="button" class="btn btn-success" ng-disabled="vm.disableSaveButton()" ng-class="vm.disableSaveButton() ? \'disable-btn-color\' : \'\'" ng-click="vm.openFeedingDatepicker()"><data-i18n i18n="_btn_save_and_feed_now_"></data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancelWizard()"><data-i18n i18n="_btn_cancel_"></data-i18n></button></div></ba-wizard-step></ba-wizard><loading-spinner-large ng-if="vm.loading"><div ng-if="vm.recipe.ration_error" style="font-weight: bold"><span class="warningModal"><data-i18n i18n="_m_f_recipe_ration_missing_error_">The data corrupted. Can\'t open recipe.</data-i18n></span></div></loading-spinner-large></div>');
$templateCache.put('app/pages/recipes/myRecipes/confirmationDialog.modal.html','<div class="modal-content" ng-if="!vm.modalLoading"><div class="modal-header"><div align="center"><span class="ion-android-warning warningModal" style="font-size: 36px"></span></div><div align="center"><span class="warningModal">{{vm.warningMessage | i18n}}</span></div></div><div class="modal-body"><div align="center"><button type="button" class="btn btn-primary" ng-click="vm.confirm()"><data-i18n i18n="_btn_continue_">Continue</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div><div class="modal-content" ng-if="vm.modalLoading"><div class="modal-body"><div style="height: 200px; overflow: hidden" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/recipes/myRecipes/feedingDatepicker.modal.html','<div class="modal-content" ng-if="!vm.modalLoading"><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body"><form name="vm.datePickerForm"><label><data-i18n i18n="_m_f_recipe_choose_feeding_time_">When do you want to start feeding this recipe?</data-i18n></label><div class="input-group form-group has-feedback" ng-class="{\'has-error\': vm.datePickerForm.recipe_start_feeding_time.$invalid && (vm.datePickerForm.recipe_start_feeding_time.$dirty || vm.datePickerForm.$submitted)}"><input class="form-control" id="recipe_start_feeding_time" name="recipe_start_feeding_time" placeholder="--:-- --" ng-model="vm.startDate" ng-model-options="{allowInvalid: true, updateOn: \'blur\'}" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" moment-picker="vm.startDate" min-view="month" max-view="minute" min-date="vm.today" ng-model="vm.startTime" format="YYYY-MM-DD hh:mm A" locale="{{vm.locale}}" ng-model-options="{ updateOn: \'blur\' }"><i class="glyphicon glyphicon-time"></i></button></span></div><div style="height: 20px; margin-top: 10px"><button style="float: right" class="btn btn-xs btn-success" ng-disabled="vm.datePickerForm.$invalid" ng-click="vm.confirm()"><data-i18n i18n="_btn_save_">save</data-i18n></button></div></form></div></div><div class="modal-content" ng-if="vm.modalLoading"><div class="modal-body"><div style="height: 200px; overflow: hidden" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/recipes/myRecipes/myRecipes.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/recipes/myRecipes/myRecipes.table.html"></div></div></div></div></div>');
$templateCache.put('app/pages/recipes/myRecipes/myRecipes.table.html','<div class="row" style="width: 100%" ng-if="!vm.loading && vm.selectedHerd.id"><button class="btn btn-info" style="float: right" ng-disabled="!vm.reordered" ng-click="vm.saveNewOrder()"><data-i18n i18n="_m_f_btn_update_order_">update</data-i18n></button></div><div class="horizontal-scroll" ng-if="!vm.loading && vm.selectedHerd.id"><table class="table table-hover my-recipes-table"><thead><tr class="sortable"><th></th><th><data-i18n i18n="_title_column_action_">action</data-i18n><br></th><th><data-i18n i18n="_m_f_recipe_name_">recipe name</data-i18n><br></th><th><data-i18n i18n="_m_f_recipe_pen_">Pen(s)</data-i18n><br></th><th><data-i18n i18n="_m_f_recipe_total_price_">Total price</data-i18n><br>{{vm.currency}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_title_create_date">create date</data-i18n><br></th><th><data-i18n i18n="_m_f_recipe_feeding_from_">feeding from</data-i18n><br></th><th><data-i18n i18n="_m_f_remove_recipe_">remove recipe</data-i18n><br></th></tr></thead><tbody dnd-list="vm.recipes" dnd-disable-if="vm.disableDrag || vm.disableReorder"><tr ng-repeat-start="(indexX, recipe) in vm.recipes" dnd-disable-if="vm.disableDrag || vm.disableReorder" dnd-draggable="recipe" dnd-moved="vm.drag($index)" dnd-dragstart="vm.onDragStart()"><td style="min-width: 30px"><a class="ion-arrow-up-a icon-edit" style="margin-right: 5px; font-size: 20px" ng-class="indexX == 0 ? \'hidden\' : \'\'" ng-click="vm.move($index, \'up\')"></a> <a class="ion-arrow-down-a icon-edit" style="margin-right: 5px; font-size: 20px" ng-class="indexX == vm.recipes.length - 1 ? \'hidden\' : \'\'" ng-click="vm.move($index, \'down\')"></a></td><td style="min-width: 120px" class="disable-active"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.recipeHistory(recipe)" uib-tooltip="{{\'_tips_history_\' | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editRecipe(recipe, $index)" uib-tooltip="{{\'_tips_edit_\' | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.recipeDetails(recipe)" uib-tooltip="{{\'_tips_details_\' | i18n}}" tooltip-is-open="tooltipIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clipboard"></i></button> <a class="icon-edit green-icon" href="" id="setAsDef" ng-click="vm.changeRecipeActive(recipe)" ng-class="recipe.active ? \'ion-star\' : \'ion-ios-star-outline\'"></a> <a href="" ng-click="vm.selectTableRow(recipe)" ng-class="recipe.is_expanded ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'"></a></td><td ng-class="{\'inactive-recipe\' : recipe.inactive_recipe}"><span ng-if="!recipe.pen_deactivated && !recipe.inactive_recipe">{{recipe.recipe_name}}</span> <span ng-if="recipe.pen_deactivated && !recipe.inactive_recipe" class="recipe-warning-my" uib-popover="{{\'_m_f_recipe_pen_deactivated_warning_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{recipe.recipe_name}}&nbsp;<i class="fa fa-info-circle"></i></span> <span ng-if="recipe.inactive_recipe" class="inactive-recipe-icon" uib-popover="{{\'_m_f_recipe_inactive_warning_\' | i18n}}{{recipe.feeding_from | date:\'short\'}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{recipe.recipe_name}}&nbsp;<i class="fa fa-info-circle"></i></span></td><td><span ng-if="!recipe.inactive_recipe || recipe.number_of_pens != 0">{{recipe.number_of_pens}}</span></td><td><span ng-if="!recipe.inactive_recipe || recipe.number_of_pens != 0">{{recipe.total_price | number:2}}</span></td><td>{{recipe.create_date | date:\'short\'}}</td><td ng-class="{\'inactive-recipe\' : recipe.inactive_recipe}">{{(recipe.feeding_from | date:\'short\') || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.deleteRecipe(recipe)"><data-i18n i18n="_btn_delete_"></data-i18n></button></td></tr><tr ng-if="recipe.pens_loading"><td colspan="8"><div class="spiner-small" style="overflow: hidden"><div id="loading-animation"></div></div></td></tr><tr ng-repeat-start="(indexY, pen) in recipe.pens" class="recipe-pen" ng-if="recipe.is_expanded"><td></td><td style="min-width: 120px"></td><td><span ng-if="pen.visible">{{pen.name}}</span> <span ng-if="!pen.visible" class="recipe-warning-my" uib-popover="{{\'_m_f_recipe_pen_removed_warning_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{pen.name}}&nbsp;<i class="fa fa-info-circle"></i></span></td><td><a class="icon-edit green-icon" href="" ng-class="pen.active ? \'ion-star\' : \'ion-ios-star-outline\'"></a></td><td>{{pen.total_price | number:2}}</td><td>{{pen.create_date | date:\'short\'}}</td><td>{{pen.feeding_from | date:\'short\'}}</td><td></td></tr><tr ng-if="false" ng-repeat-end=""></tr><tr ng-if="false" ng-repeat-end=""></tr><tr class="dndPlaceholder"><td colspan="8"><data-i18n i18n="_m_f_drag_and_drop_placeholder_">Drop here</data-i18n></td></tr><tr ng-if="vm.loadingRecipes"><td colspan="8"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></td></tr></tbody><tfoot><tr><td colspan="8" style="text-align: center"><button class="btn btn-primary" ng-if="vm.displayShowMoreBtn" ng-click="vm.loadMore()"><data-i18n i18n="_m_f_title_load_more_">Load more</data-i18n></button></td></tr></tfoot></table></div><div ng-if="!vm.loading && !vm.selectedHerd.id" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div><loading-spinner-large ng-if="vm.loading"></loading-spinner-large>');
$templateCache.put('app/pages/recipes/recipeDetails/cost.table.html','<div class="horizontal-scroll" ng-if="!vm.loading"><table class="table table-hover" style="font-size: 14px"><thead><tr class="sortable"><th><data-i18n i18n="_m_f_pen_name_">pen name</data-i18n></th><th><data-i18n i18n="_m_f_title_category_">category</data-i18n></th><th><data-i18n i18n="_m_f_pen_number_of_animals_">number of animals</data-i18n></th><th><data-i18n i18n="_m_f_recipe_cost_">Cost</data-i18n></th><th><data-i18n i18n="_m_f_recipe_total_kg_dm_">Total kg DM</data-i18n>&nbsp;({{vm.weight}})</th><th><data-i18n i18n="_m_f_recipe_total_kg_as_fed_">Total kg as fed</data-i18n>&nbsp;({{vm.weight}})</th><th><data-i18n i18n="_m_f_pen_morning_feeding_short_">morning</data-i18n></th><th><data-i18n i18n="_m_f_pen_noon_feeding_short_">noon</data-i18n></th><th><data-i18n i18n="_m_f_pen_evening_feeding_short_">evening</data-i18n></th></tr></thead><tbody><tr ng-repeat="pen in vm.details.pens" class="editable-tr-wrap"><td>{{pen.pen_name}}</td><td>{{pen.pen_category.name}}</td><td>{{pen.number_of_animals}}</td><td>{{pen.cost_dm | number: 2}}</td><td>{{pen.total_amount_dm | formatViewValues: \'amount\'}}</td><td>{{pen.total_as_fed | formatViewValues: \'amount\'}}</td><td><div>{{pen.feeding_1_amount | formatViewValues: \'amount\'}}</div><div>{{pen.feeding_1 | date:"hh:mm a" }}</div></td><td><div>{{pen.feeding_2_amount | formatViewValues: \'amount\'}}</div><div>{{ pen.feeding_2 | date:"hh:mm a" }}</div></td><td><div>{{pen.feeding_3_amount | formatViewValues: \'amount\'}}</div><div>{{ pen.feeding_3 | date:"hh:mm a" }}</div></td></tr></tbody></table></div><div ng-if="vm.loading || vm.loadingTable" align="center" style="overflow: hidden"><div><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/recipes/recipeDetails/pens.table.html','<div class="horizontal-scroll"><table class="table table-hover recipe-table" style="font-size: 14px"><thead><tr class="sortable"><th><data-i18n i18n="_m_f_pen_name_">pen name</data-i18n></th><th><data-i18n i18n="_m_f_pen_number_of_animals_">number of animals</data-i18n></th><th><data-i18n i18n="_m_f_title_category_">category</data-i18n></th><th><data-i18n i18n="_m_f_pen_feedings_">feedings</data-i18n></th><th><data-i18n i18n="_title_create_date">create date</data-i18n></th><th style="text-align: center"><data-i18n i18n="_m_f_pen_automatic_update_">automatic update</data-i18n></th></tr></thead><tbody><tr ng-repeat="pen in vm.details.pens | orderBy:\'id\'" ng-class="{\'recipe_pen_removed\' : !pen.visible , \'highlight-sum-table\' : pen.active_version}"><td><span ng-if="pen.visible">{{pen.pen_name}}</span> <span ng-if="!pen.visible" class="recipe-warning-my" uib-popover="{{\'_m_f_recipe_pen_removed_warning_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{pen.pen_name}}&nbsp;<i class="fa fa-info-circle"></i></span></td><td>{{pen.number_of_animals}}</td><td>{{pen.pen_category.name}}</td><td><div ng-if="pen.pen_feeding_scheduler.morning_feeding">{{pen.pen_feeding_scheduler.morning_feeding_time | date: "hh:mm a"}}</div><div ng-if="pen.pen_feeding_scheduler.noon_feeding">{{pen.pen_feeding_scheduler.noon_feeding_time | date: "hh:mm a"}}</div><div ng-if="pen.pen_feeding_scheduler.evening_feeding">{{pen.pen_feeding_scheduler.evening_feeding_time | date: "hh:mm a"}}</div></td><td>{{pen.create_date | date:\'short\'}}</td><td align="center"><a class="ion-checkmark-round primaryModal" ng-if="pen.automatic_update"></a> <a ng-if="!pen.automatic_update" class="ion-close-round warningModal"></a></td></tr></tbody></table></div>');
$templateCache.put('app/pages/recipes/recipeDetails/ration.table.html','<div class="horizontal-scroll" ng-if="!vm.loadingRationTable"><table class="table table-hover"><thead><tr class="sortable" style="margin-right: 15px"><th><data-i18n i18n="_rations_ration_name_">ration name</data-i18n></th><th><data-i18n i18n="_groups_group_name_">group name</data-i18n></th><th><data-i18n i18n="_title_create_date">create date</data-i18n></th><th><data-i18n i18n="_start_feeding_date_">Start feeding date</data-i18n></th><th>DM %</th></tr></thead><tbody><tr ng-repeat="ration in vm.details.rations" ng-class="{ \'highlight-sum-table\' : ration.active_version}"><td>{{ration.ration_name}}</td><td>{{ration.group.name}}</td><td>{{ration.create_date | date:\'short\'}}</td><td>{{ration.used_from | date:\'short\'}}</td><td>{{ration.dm | formatViewValues: \'percentage\'}}</td></tr></tbody><tfoot></tfoot></table></div><div ng-if="vm.loadingRationTable" align="center" style="overflow: hidden"><div><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/recipes/recipeDetails/recipeDetails.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ng-if="vm.selectedHerd && vm.selectedTeamHerd && !vm.loading" ba-panel="" ba-panel-title="{{\'_m_f_menu_recipe_details_\'|i18n}}" ba-panel-class="with-scroll"><div include-with-scope="app/pages/recipes/recipeDetails/recipeDetails.panel.html"></div></div><div class="panel-content" ng-if="!vm.selectedHerd" align="center" ba-panel=""><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div><div class="panel-content" ng-if="!vm.selectedTeamHerd && !vm.loading" align="center" ba-panel="" ng-hide="!vm.selectedHerd"><h3><data-i18n i18n="_details_default_herdTeam_not_defined_">Details are not available for this herd / team</data-i18n></h3></div></div></div></div><div ng-if="vm.loading" align="center" style="overflow: hidden" ba-panel=""><div><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/recipes/recipeDetails/recipeDetails.panel.html','<div class="panel-content" ng-if="!vm.loading && vm.selectedHerd && vm.selectedTeamHerd"><button class="btn btn-primary btn-xs" ng-click="vm.back()" style="margin-left: 6px; margin-top: 6px"><i class="ion-arrow-left-c"></i>&nbsp;<data i18n="_btn_back_">Back</data></button><h3 class="with-line" style="padding-top: 10px">{{vm.details.recipe_name}}</h3><h3 class="with-line" style="padding-top: 10px"><data-i18n i18n="_m_f_recipe_details_ration_">Ration</data-i18n></h3><div class="row"><div style="padding: 20px 10px"><div include-with-scope="app/pages/recipes/recipeDetails/ration.table.html"></div></div></div><h3 class="with-line" style="padding-top: 10px"><data-i18n i18n="_m_f_recipe_pen_">Pens</data-i18n></h3><div class="row"><div style="padding: 20px 10px"><div include-with-scope="app/pages/recipes/recipeDetails/pens.table.html"></div></div></div><h3 class="with-line" style="padding-top: 10px"><data-i18n i18n="_m_f_recipe_details_feeding_informations_">Feeding informations</data-i18n></h3><div class="row"><div class="col-md-12"><table class="table table-hover recipe-table"><thead><tr class="sortable"><th><data-i18n i18n="_m_f_recipe_details_feeding_methods_">Feeding methods</data-i18n></th><th><data-i18n i18n="_m_f_wagons_picture_">Picture</data-i18n></th><th><data i18n="_m_f_wagons_name_">Name</data></th><th><data i18n="_m_f_wagons_capacity_">Capacity</data></th></tr></thead><tbody><tr ng-repeat="wagon in vm.details.mixer_wagons | unique: \'mixer_wagon_id\'"><td><div ng-repeat="feedingMethod in vm.details.feeding_methods">{{feedingMethod.name}}</div></td><td><span class="select-wagon-img"><img src="assets/img/MmmLogo.png" lazy-img="{{wagon.image_url}}" lazy-img-error="assets/img/MmmLogo.png" ng-if="wagon.image_url"> <img src="assets/img/MmmLogo.png" ng-if="!wagon.image_url"></span></td><td><span ng-if="wagon.visible">{{wagon.name}}</span> <span ng-if="!wagon.visible" class="recipe-warning-my" uib-popover="{{\'_m_f_recipe_wagon_removed_warning_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{wagon.name}}&nbsp;<i class="fa fa-info-circle"></i></span></td><td>{{wagon.weight}} <span style="margin-left: 3px"><data-i18n ng-if="vm.settings.use_kgs" i18n="_m_f_wagons_tonnes_">Tonnes</data-i18n><data-i18n ng-if="!vm.settings.use_kgs" i18n="_m_f_wagons_imperial_tonnes_">Tonnes</data-i18n></span></td></tr></tbody></table></div></div></div><div ng-repeat="day in vm.details.per_day"><h3 class="with-line" style="padding-top: 10px"><data-i18n i18n="_m_f_recipe_details_summary_">Recipe summary</data-i18n><span style="margin-left: 3px;">- {{day.date_formated}}</span></h3><div class="row"><div style="padding: 20px 10px"><div summary-recipe-details="app/pages/recipes/recipeDetails/summary.table.html" day="day" currency="vm.currency" weight="vm.weight" recipe="vm.details"></div></div></div><h3 class="with-line" style="padding-top: 10px"><data-i18n i18n="_m_f_recipe_mixing_suggestion_">Mixing suggestion</data-i18n></h3><div class="row"><div style="padding: 20px 10px"><div summary-recipe-details="app/pages/recipes/recipeDetails/suggestion.table.html" day="day" currency="vm.currency" weight="vm.weight" recipe="vm.details"></div></div></div></div><div><div class="row"><div class="col-md-6"><div><label><data-i18n i18n="_mf_comment_feeder_">Comment for the feeder</data-i18n></label><h3 class="with-line" style="padding-top: 10px" ng-if="vm.details.recipe_comment"></h3><span ng-if="vm.details.recipe_comment">{{vm.details.recipe_comment}}</span></div></div><div class="col-md-6" style="float: right"><div><label><data-i18n i18n="_mf_comment_feeder_drop_">Comment for the feeder for dropping</data-i18n></label><h3 class="with-line" style="padding-top: 10px" ng-if="vm.details.dropping_comment"></h3><span ng-if="vm.details.dropping_comment">{{vm.details.dropping_comment}}</span></div></div></div></div><div ng-if="vm.loading" align="center" style="overflow: hidden"><div><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/recipes/recipeDetails/suggestion.table.html','<div class="horizontal-scroll" ng-if="!vm.loading"><table class="table load-configuration-table"><thead><tr class="sortable"><th ng-if="day.version.loading.morning.total" class="text-primary"><data-i18n i18n="_m_f_recipe_feeding_">Feeding</data-i18n>&nbsp;1&nbsp;<span>({{day.version.loading.morning.total | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{weight}})</th><th ng-if="day.version.loading.noon.total" class="text-primary"><data-i18n i18n="_m_f_recipe_feeding_">Feeding</data-i18n>&nbsp;2&nbsp;<span>({{day.version.loading.noon.total| formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{weight}})</th><th ng-if="day.version.loading.evening.total" class="text-primary"><data-i18n i18n="_m_f_recipe_feeding_">Feeding</data-i18n>&nbsp;3&nbsp;<span>({{day.version.loading.evening.total | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{weight}})</th></tr></thead><tbody class="load-suggestion"><tr><td ng-if="day.version.loading.morning.total"><table class="table suggestion-table"><thead><tr><th><data-i18n i18n="_m_f_recipe_loads_">Loads</data-i18n></th><th><data-i18n i18n="_m_f_menu_configurations_equipment_">Mixer wagon</data-i18n></th></tr></thead><tbody><tr ng-repeat="(indexX, load) in day.version.loading.morning.loads track by indexX" class="editable-suggestion-value"><td><data-i18n i18n="_m_f_recipe_load_">Load</data-i18n>&nbsp;{{$index+1}}: <span>{{load.value | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{weight}}</td><td><div class="wagon-name-recipe"><span ng-if="load.wagon.visible">{{load.wagon.name}}</span> <span ng-if="!load.wagon.visible" class="recipe-warning-my" uib-popover="{{\'_m_f_recipe_wagon_removed_warning_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{load.wagon.name}}&nbsp;<i class="fa fa-info-circle"></i></span></div></td></tr></tbody></table></td><td ng-if="day.version.loading.noon.total"><table class="table suggestion-table"><thead><tr><th><data-i18n i18n="_m_f_recipe_loads_">Loads</data-i18n></th><th><data-i18n i18n="_m_f_menu_configurations_equipment_">Mixer wagon</data-i18n></th></tr></thead><tbody><tr ng-repeat="(indexX, load) in day.version.loading.noon.loads track by indexX" class="editable-suggestion-value"><td><data-i18n i18n="_m_f_recipe_load_">Load</data-i18n>&nbsp;{{$index+1}}: <span>{{load.value | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{weight}}</td><td><div class="wagon-name-recipe"><span ng-if="load.wagon.visible">{{load.wagon.name}}</span> <span ng-if="!load.wagon.visible" class="recipe-warning-my" uib-popover="{{\'_m_f_recipe_wagon_removed_warning_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{load.wagon.name}}&nbsp;<i class="fa fa-info-circle"></i></span></div></td></tr></tbody></table></td><td ng-if="day.version.loading.evening.total"><table class="table suggestion-table"><thead><tr><th><data-i18n i18n="_m_f_recipe_loads_">Loads</data-i18n></th><th><data-i18n i18n="_m_f_menu_configurations_equipment_">Mixer wagon</data-i18n></th></tr></thead><tbody><tr ng-repeat="(indexX, load) in day.version.loading.evening.loads track by indexX" class="editable-suggestion-value"><td><data-i18n i18n="_m_f_recipe_load_">Load</data-i18n>&nbsp;{{$index+1}}: <span>{{load.value | formatViewValues: \'rounded_amount\'}}</span>&nbsp;{{weight}}</td><td><div class="wagon-name-recipe"><span ng-if="load.wagon.visible">{{load.wagon.name}}</span> <span ng-if="!load.wagon.visible" class="recipe-warning-my" uib-popover="{{\'_m_f_recipe_wagon_removed_warning_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{load.wagon.name}}&nbsp;<i class="fa fa-info-circle"></i></span></div></td></tr></tbody></table></td></tr><tr><td ng-if="vm.suggestion.feeding_1.total_feeding_1"><table class="table suggestion-table"><tr><td class="text-primary"><data-i18n i18n="_m_f_recipe_number_of_loads_">Number of loads</data-i18n></td><td>{{vm.suggestion.feeding_1.number_of_loads}}</td></tr></table></td><td ng-if="vm.suggestion.feeding_2.total_feeding_2"><table class="table suggestion-table"><tr><td class="text-primary"><data-i18n i18n="_m_f_recipe_number_of_loads_">Number of loads</data-i18n></td><td>{{vm.suggestion.feeding_2.number_of_loads}}</td></tr></table></td><td ng-if="vm.suggestion.feeding_3.total_feeding_3"><table class="table suggestion-table"><tr><td class="text-primary"><data-i18n i18n="_m_f_recipe_number_of_loads_">Number of loads</data-i18n></td><td>{{vm.suggestion.feeding_3.number_of_loads}}</td></tr></table></td></tr></tbody></table></div>');
$templateCache.put('app/pages/recipes/recipeDetails/summary.table.html','<div class="horizontal-scroll" ng-if="!vm.loading"><table class="table table-hover recipe-table" style="font-size: 14px" st-table="vm.pens"><thead><tr class="sortable"><th><data-i18n i18n="_m_f_pen_name_">pen name</data-i18n></th><th><data-i18n i18n="_m_f_title_category_">category</data-i18n></th><th><data-i18n i18n="_m_f_pen_number_of_animals_">number of animals</data-i18n></th><th><data-i18n i18n="_feeds_dmi_">dmi</data-i18n>&nbsp;({{weight}})</th><th><data-i18n i18n="_m_f_recipe_cost_">Cost</data-i18n>&nbsp;({{currency}})</th><th><data-i18n i18n="_m_f_recipe_total_kg_dm_">Total kg DM</data-i18n>&nbsp;({{weight}})</th><th><data-i18n i18n="_m_f_recipe_total_kg_as_fed_">Total kg as fed</data-i18n>&nbsp;({{weight}})</th><th><data-i18n i18n="_m_f_pen_morning_feeding_short_">morning</data-i18n></th><th><data-i18n i18n="_m_f_pen_noon_feeding_short_">noon</data-i18n></th><th><data-i18n i18n="_m_f_pen_evening_feeding_short_">evening</data-i18n></th></tr></thead><tbody><tr ng-repeat="pen in day.version.scheduled_pens | orderBy:\'id\'" class="editable-tr-wrap" ng-class="!pen.visible ? \'recipe_pen_removed\' : \'\'"><td><span ng-if="pen.visible">{{pen.pen_name}}</span> <span ng-if="!pen.visible" class="recipe-warning-my" uib-popover="{{\'_m_f_recipe_pen_removed_warning_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{pen.pen_name}}&nbsp;<i class="fa fa-info-circle"></i></span></td><td>{{pen.pen_category.name}}</td><td>{{pen.number_of_animals}}</td><td ng-if="pen.use_pen_feed_intake">{{pen.feed_intake | formatViewValues: \'amount\'}}</td><td ng-if="!pen.use_pen_feed_intake">{{day.version.recipe_ration.amount_dm | formatViewValues: \'amount\'}}</td><td>{{pen.cost_dm | number: 2}}</td><td>{{pen.total_dm | formatViewValues: \'rounded_amount\' | defaultReturnValue: null}}</td><td>{{pen.total_as_fed | formatViewValues: \'rounded_amount\' | defaultReturnValue: null}}</td><td style="min-width: 100px"><div><span>{{pen.morning_feeding | formatViewValues: \'rounded_amount\' | defaultReturnValue: null}}</span></div><div>{{(pen.pen_feeding_scheduler.morning_feeding_time | date: "hh:mm a")}}</div><span ng-if="!pen.pen_feeding_scheduler.morning_feeding"><data-i18n i18n="_label_none_"></data-i18n></span></td><td style="min-width: 100px"><div><span>{{pen.noon_feeding | formatViewValues: \'rounded_amount\' | defaultReturnValue: null}}</span></div><div>{{(pen.pen_feeding_scheduler.noon_feeding_time | date: "hh:mm a")}}</div><span ng-if="!pen.pen_feeding_scheduler.noon_feeding"><data-i18n i18n="_label_none_"></data-i18n></span></td><td style="min-width: 100px"><div><span>{{pen.evening_feeding | formatViewValues: \'rounded_amount\' | defaultReturnValue: null}}</span></div><div>{{(pen.pen_feeding_scheduler.evening_feeding_time | date: "hh:mm a")}}</div><span ng-if="!pen.pen_feeding_scheduler.evening_feeding"><data-i18n i18n="_label_none_"></data-i18n></span></td></tr><tr class="separaton-line highlight-sum-table"><th></th><th style="text-align: center"><data-i18n i18n="_m_f_recipe_name_">recipe name</data-i18n></th><th><data-i18n i18n="_m_f_recipe_total_number_of_animals_">Total number of animals</data-i18n></th><th></th><th><data-i18n i18n="_m_f_recipe_total_cost_">total cost</data-i18n>&nbsp;({{currency}})</th><th><data-i18n i18n="_m_f_recipe_total_kg_dm_">Total kg DM</data-i18n>&nbsp;({{weight}})</th><th><data-i18n i18n="_m_f_recipe_total_kg_as_fed_">Total kg as fed</data-i18n>&nbsp;({{weight}})</th><th><data-i18n i18n="_m_f_recipe_feeding_">feeding</data-i18n>&nbsp;1</th><th><data-i18n i18n="_m_f_recipe_feeding_">feeding</data-i18n>&nbsp;2</th><th><data-i18n i18n="_m_f_recipe_feeding_">feeding</data-i18n>&nbsp;3</th></tr><tr class="highlight-sum-table"><td><span style="text-transform: uppercase"><data-i18n i18n="_m_f_label_summary_">Summary</data-i18n></span>:</td><td style="text-align: center">{{recipe.recipe_name}}</td><td>{{day.version.summary.number_of_animals}}</td><td></td><td>{{day.version.summary.cost_dm | number: 2}}</td><td>{{day.version.summary.total_dm | formatViewValues: \'rounded_amount\' | defaultReturnValue: null}}</td><td>{{day.version.summary.total_as_fed | formatViewValues: \'rounded_amount\' | defaultReturnValue: null}}</td><td>{{day.version.summary.morning | formatViewValues: \'rounded_amount\' | defaultReturnValue: null}}</td><td>{{day.version.summary.noon | formatViewValues: \'rounded_amount\' | defaultReturnValue: null}}</td><td>{{day.version.summary.evening | formatViewValues: \'rounded_amount\' | defaultReturnValue: null}}</td></tr></tbody></table></div><div ng-if="vm.loading" align="center" style="overflow: hidden"><div><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/recipes/recipeHistory/recipeHistory.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/recipes/recipeHistory/recipeHistory.table.html"></div></div></div></div></div>');
$templateCache.put('app/pages/recipes/recipeHistory/recipeHistory.table.html','<div class="horizontal-scroll" ng-if="!vm.loading"><button class="btn btn-primary btn-xs" ng-click="vm.back()" style="margin-left: 6px; margin-top: 6px"><i class="ion-arrow-left-c"></i>&nbsp;<data i18n="_btn_back_">Back</data></button><table class="table table-hover my-recipes-table" style="font-size: 14px"><thead><tr class="sortable"><th></th><th><data-i18n i18n="_m_f_recipe_name_">recipe name</data-i18n></th><th><data-i18n i18n="_m_f_recipe_pen_">Pen(s)</data-i18n></th><th><data-i18n i18n="_m_f_recipe_total_price_">Total price</data-i18n></th><th><data-i18n i18n="_title_create_date">create date</data-i18n></th><th><data-i18n i18n="_m_f_recipe_feeding_from_">feeding from</data-i18n></th><th><data-i18n i18n="_title_user_">User</data-i18n></th><th><data-i18n i18n="_title_last_modified_date_">last modified date</data-i18n></th></tr></thead><tbody ng-if="!vm.loadingTable"><tr ng-repeat-start="(indexX, recipe) in vm.history"><td><a href="" ng-click="vm.selectTableRow($index, recipe.recipe_id, recipe)" ng-class="vm.dataCollapse[$index]? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'"></a></td><td>{{recipe.recipe_name}}</td><td>{{recipe.number_of_pens}}</td><td>{{vm.currency}}{{recipe.total_price | number: 2}}</td><td>{{recipe.create_date | date:\'short\'}}</td><td>{{recipe.feeding_from | date:\'short\'}}</td><td>{{recipe.last_modified_user}}</td><td>{{recipe.last_modified_date | date:\'short\'}}</td></tr><tr ng-if="recipe.loadingPen"><td colspan="9"><div class="spiner-small" style="overflow: hidden"><div id="loading-animation"></div></div></td></tr><tr ng-repeat-start="(indexY, pen) in recipe.pens" ng-show="vm.dataCollapse[indexX]==true"><td></td><td style="text-align: center"><a style="cursor: default" class="icon-edit green-icon" href="" ng-class="pen.pen_active ? \'ion-star\' : \'ion-ios-star-outline\'"></a></td><td>{{pen.pen_name}}</td><td>{{vm.currency}}{{pen.total_price | number: 2}}</td><td>{{pen.create_date | date:\'short\'}}</td><td>{{pen.feeding_from | date:\'short\'}}</td><td>{{pen.last_modified_user}}</td><td>{{pen.last_modified_date | date:\'short\'}}</td></tr><tr ng-repeat-end=""></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable && !vm.loading"><tr><td colspan="9"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></td></tr></tbody></table></div><div ng-if="vm.loading" align="center"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/reports/communication/communication.html','<h1>communication</h1>');
$templateCache.put('app/pages/reports/complianceDashboard/complianceDashboard.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/complianceDashboard/complianceDashboard.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/reports/complianceDashboard/complianceDashboard.panel.html','<div class="row" ng-if="!vm.loading && vm.selectedHerd"><div><div class="compliance-filter-block" ng-class="vm.showFilter ? \'show-filter-block\': \'\'"><div class="filter-list"><li ng-repeat="pen in vm.pens track by pen.id" class="filter-item" ng-style="pen.pen_location ? \'\' : {\'color\':\'lightgray\'}"><input type="checkbox" ng-disabled="!pen.pen_location || (!pen.is_selected && vm.list_to_show.length>9)" ng-model="pen.is_selected" ng-change="vm.penSelected()"> {{pen.pen_name}}</li></div></div><div class="compliance-switch" ng-class="vm.showFilter ? \'show-filter-block\': \'\'" ng-click="vm.changeFilterVisibility()"><div style="margin-top: 17px"><i ng-class="vm.showFilter ? \'ion-arrow-left-b\': \'ion-arrow-right-b\'"></i></div></div><div class="compliance-map-wrapper" ng-class="vm.showFilter ? \'show-filter-block\': \'\'"><div id="comp-map" class="compliance-map"></div></div></div></div><div class="row" ng-if="vm.loading" style="text-align: center; overflow: hidden"><div id="loading-animation-large"></div></div><div class="row" ng-if="!vm.loading && !vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div>');
$templateCache.put('app/pages/reports/dropping/dropping.html','<h1>dropping</h1>');
$templateCache.put('app/pages/reports/mixing/filter.modal.html','<div class="modal-content" ng-cloak=""><div class="modal-body"><div ng-if="!vm.modalLoading"><div class="form-group"><label for="breed"><data-i18n i18n="_m_f_mixing_feeding_recipe_">Recipe</data-i18n></label><ui-select ng-model="vm.selectedRecipe" class="btn-group bootstrap-select form-control" search-enabled="true" required="" id="recipe" name="recipe"><ui-select-match allow-clear="true" placeholder="{{\'_m_f_mixing_feeding_select_recipe_\'|i18n}}">{{$select.selected.recipe_name}}</ui-select-match><ui-select-choices repeat="recipe in vm.recipes | filter: $select.search"><span ng-bind-html="recipe.recipe_name"></span></ui-select-choices></ui-select></div><div class="form-group"><label for="breed"><data-i18n i18n="_m_f_reports_pen_">Pen</data-i18n></label><ui-select ng-model="vm.selectedPen" class="btn-group bootstrap-select form-control" search-enabled="true" required="" id="pen" name="pen"><ui-select-match allow-clear="true" placeholder="{{\'_m_f_reports_select_pen_\'|i18n}}">{{$select.selected.pen_name}}</ui-select-match><ui-select-choices repeat="pen in vm.pens | filter: $select.search"><span ng-bind-html="pen.pen_name"></span></ui-select-choices></ui-select></div><div class="form-group"><label for="breed"><data-i18n i18n="_m_f_title_category_">category</data-i18n></label><ui-select ng-model="vm.selectedCategory" class="btn-group bootstrap-select form-control" search-enabled="true" required="" id="category" name="category"><ui-select-match allow-clear="true" placeholder="{{\'_m_f_placeholder_select_category_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="category in vm.categories | filter: $select.search"><span ng-bind-html="category.name"></span></ui-select-choices></ui-select></div><div class="form-group" ng-if="!vm.show_custom_selector"><label for="date"><data-i18n i18n="_m_f_reports_time_period_">Time period</data-i18n></label><ui-select ng-model="vm.selectedPredefinedDate" class="btn-group bootstrap-select form-control" search-enabled="true" required="" id="date" name="date" ng-change="vm.selectPredefinedDates()"><ui-select-match placeholder="{{\'_m_f_reports_select_time_period_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="category in vm.predefinedDates | filter: $select.search"><span ng-bind-html="category.name"></span></ui-select-choices></ui-select></div><div><div style="display: inline-block; margin-right: 10px" ng-click="vm.showCustomSelector()"><a href="" ng-class="vm.show_custom_selector? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'"></a></div><div style="display: inline-block" ng-click="vm.showCustomSelector()" class="time-period-label"><data-i18n i18n="_m_f_reports_custom_time_period_">Custom time period</data-i18n></div></div><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'" ng-if="vm.show_custom_selector"><div class="form-group"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="" ng-change="vm.checkDateValidation()" ng-model="vm.start_date_picker" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p><span ng-if="!vm.start_date_picker" class="warningModal"><p><data-i18n i18n="_mf_start_date_required_">Selecting start date is required</data-i18n></p></span> <label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="" ng-change="vm.checkDateValidation()" ng-model="vm.end_date_picker" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p><span ng-if="!vm.end_date_picker" class="warningModal"><p><data-i18n i18n="_mf_end_date_required_">Selecting end date is required</data-i18n></p></span><div class="calendar-error-text" ng-class="vm.end_date_error ? \'calendar-error\' : \'\'"><data-i18n i18n="_m_f_calendar_end_date_error_">Invalid end date (must be after start date)</data-i18n></div></div></div><div align="right"><button type="submit" class="btn btn-success btn-with-icon save-profile" ng-click="vm.saveFilter()" ng-disabled="vm.end_date_error || vm.addCategoryForm.$invalid || !vm.start_date_picker || !vm.end_date_picker"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div style="height: 200px; overflow: hidden" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/reports/mixing/mixing.graph.html','<div style="height: auto"><div class="chart-wrapper" ng-if="!vm.loadingTable" style="height: 450px"><div class="ct-chart ct-perfect-fourth"></div></div><div class="mixing-legend-main" ng-if="!vm.loadingTable"><div class="mixing-legend-group"><div><label class="mixing-legend-title"><data-i18n i18n="_m_f_reports_legend_">Legend</data-i18n></label></div><div ng-click="vm.checkAll(true)" uib-tooltip="{{\'_m_f_reports_check_all_\' | i18n}}" tooltip-is-open="checkAllIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="fa fa-check-circle-o mixing-legend-control check" aria-hidden="true"></i></div><div ng-click="vm.checkAll(false)" uib-tooltip="{{\'_m_f_uncheck_all_\' | i18n}}" tooltip-is-open="uncheckAllIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="fa fa-times-circle-o mixing-legend-control uncheck" aria-hidden="true"></i></div></div><div><div class="mixing-legend"><div class="mixing-legend-list"><div class="mixing-legend-lines"><div class="calculated-line"><i18n i18n="_m_f_reports_calculated_weight_">Calculated weight</i18n>({{vm.weight}})</div><div class="loaded-line"><i18n i18n="_m_f_reports_loaded_weight_">Loaded weight</i18n>({{vm.weight}})</div></div></div><div class="mixing-legend-list" ng-repeat="recipe in vm.graphData" ng-click="vm.onSelect(recipe)" ng-class="!recipe.displayed ? \'disabled-item\': \'\'"><div class="mixing-legend-info"><div class="mixing-legend-box" ng-style="vm.getRecipeStyle(recipe)"><div class="mixing-legend-check-icon"><i class="fa" aria-hidden="true" style="color: white" ng-class="recipe.displayed ? \'fa-check\' : \'fa-times\'"></i></div></div><div class="mixing-legend-item">&nbsp;<span>{{recipe.recipe_name}}</span></div></div></div></div></div></div><div style="overflow: hidden"><div style="margin-left: auto; margin-right: auto; text-align: center" ng-if="!vm.loading && vm.loadingTable"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/reports/mixing/mixing.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel=""><button class="btn btn-primary btn-xs" ng-click="vm.back()" ng-if="vm.fromCalendar && vm.selectedLayout == 2 && !vm.loading" style="float: left;"><i class="ion-arrow-left-c"></i>&nbsp;<data i18n="_btn_back_">Back</data></button><div include-with-scope="app/pages/reports/mixing/mixing.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/reports/mixing/mixing.panel.html','<div class="row" ng-if="!vm.loading && vm.selectedHerd"><div class="btn-group" style="float: right"><button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.openFilterModal()" uib-tooltip="{{\'_reports_filter_active_\' | i18n}}" tooltip-is-open="filter_active" tooltip-enable="vm.recipeFilterActive" tooltip-placement="left" tooltip-class="customBlue left tooltip-opaque" tooltip-popup-delay="500"><span class="glyphicon glyphicon-filter"></span></button> <button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(1)" ng-class="vm.selectedLayout == 1 ? \'btn-active-primary selected\' : \'\'"><span class="glyphicon glyphicon-th-list" ng-class="vm.selectedLayout == 1 ? \'selected\' : \'\'"></span></button> <button id="grid" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(2)" ng-class="vm.selectedLayout == 2 ? \'btn-active-primary selected\' : \'\'"><span class="glyphicon glyphicon-th" ng-class="vm.selectedLayout == 2 ? \'selected\' : \'\'"></span></button><div class="notificationMixing" ng-if="vm.recipeFilterActive"></div></div></div><div class="row" ng-if="vm.selectedHerd && vm.selectedLayout == 1"><div include-with-scope="app/pages/reports/mixing/mixing.table.html"></div></div><div class="row" ng-if="vm.selectedHerd && vm.selectedLayout == 2"><div include-with-scope="app/pages/reports/mixing/mixing.graph.html"></div></div><div class="row" ng-if="vm.loading" style="text-align: center; overflow: hidden"><div id="loading-animation-large"></div></div><div class="row" ng-if="!vm.loading && !vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div>');
$templateCache.put('app/pages/reports/mixing/mixing.table.html','<div class="horizontal-scroll" ng-if="!vm.loading"><table class="table mixing-table" style="font-size: 14px"><thead><tr class="table-header"><th style="width: 5%"></th><th style="width: 10%" align="left"><data-i18n i18n="_report_date_">Date</data-i18n><br></th><th style="width: 10%"><data-i18n i18n="_dashboards_time_">Time</data-i18n><br></th><th style="width: 15%"><data-i18n i18n="_m_f_recipe_name_">Recipe name</data-i18n><br></th><th style="width: 15%"><data-i18n i18n="_m_f_recipe_pen_">Pen(s)</data-i18n><br></th><th style="width: 10%"><data-i18n i18n="_m_f_reports_deviation_">Deviation</data-i18n><br>%/{{vm.weight}}</th><th style="width: 10%"><data-i18n i18n="_m_f_reports_deviation_">Deviation</data-i18n><br><data-i18n i18n="_m_f_reports_price_">Price</data-i18n>({{vm.currency}})</th><th style="width: 15%"><data-i18n i18n="_m_f_reports_feeder_">Feeder</data-i18n><br></th><th style="width: 10%"><data-i18n i18n="_m_f_reports_load_status_">Feeding status</data-i18n><br></th></tr></thead><tbody ng-if="!vm.loadingTable"><tr ng-repeat-start="(indexX, report) in vm.reports" ng-style="vm.setBackgroundColor(report.color)"><td><a href="" ng-click="vm.selectTableRow($index, recipe.id, recipe, \'close\')" ng-class="vm.dataCollapse[$index]? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'"></a></td><td>{{report.feeding_date | date:\'shortDate\'}}</td><td>{{(report.load_time | date:\'shortTime\') || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td>{{report.recipe_name}}</td><td><div ng-repeat="pen in report.pen_list">{{pen.pen_name}}</div></td><td>{{report.deviation | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}<br>{{report.deviation_percentage * 100 | number: 2}}&nbsp;%</td><td>{{report.deviation_price | number: 2}}</td><td>{{report.feeder || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td><i class="feeding-status-icon" ng-class="report.status == 0 ? \'feeding-status-to-do\' : (report.status == 1 ? \'feeding-status-in-progress\' : \'feeding-status-done\')" tooltip-is-open="statusOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" uib-tooltip="{{report.status === 0 ? (\'_m_f_calendar_report_to_do_\' | i18n) : report.status === 1 ? (\'_m_f_calendar_report_in_progress_\' | i18n) : (\'_m_f_calendar_report_done_\' | i18n)}}"></i></td></tr><tr ng-if="vm.dataCollapse[indexX]==true" class="table-header" ng-style="vm.setBackgroundColor(report.color)"><th colspan="3"></th><th><data-i18n i18n="_m_f_i_m_ingredient_name_">Ingredient name</data-i18n></th><th><data-i18n i18n="_m_f_reports_deviation_">Deviation</data-i18n><br>%/{{vm.weight}}</th><th><data-i18n i18n="_m_f_reports_calculated_weight_">Calculated weight</data-i18n><br>({{vm.weight}})</th><th><data-i18n i18n="_m_f_reports_loaded_weight_">Loaded weight</data-i18n><br>({{vm.weight}})</th><th colspan="2"></th></tr><tr ng-repeat-start="(indexY, feed) in report.load_ingredient_list" ng-if="vm.dataCollapse[indexX]==true" ng-style="vm.setBackgroundColor(report.color)"><th colspan="3"></th><td>{{feed.feed_name}}</td><td>{{feed.deviation | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}<br>{{feed.deviation_percentage | number: 2}}&nbsp;%</td><td>{{feed.calculated_weight | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</td><td>{{feed.actual_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</td><th colspan="2"></th></tr><tr ng-repeat-end=""></tr><tr ng-if="vm.dataCollapse[indexX]==true" class="summary" ng-style="vm.setBackgroundColor(report.color)"><th colspan="3"></th><td><data-i18n i18n="_m_f_label_summary_">Summary</data-i18n></td><td>{{report.deviation | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}<br>{{report.deviation_percentage * 100 | number: 2}}&nbsp;%</td><td>{{report.calculated_weight | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</td><td>{{report.actual_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{vm.weight}}</td><th colspan="2"></th></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable && !vm.loading"><tr><td colspan="9"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></td></tr></tbody><tfoot><tr ng-if="vm.totalItems > 10"><td colspan="9"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="10" max-size="7" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reports/weighback/filter.modal.html','<div class="modal-content" ng-cloak=""><div class="modal-body"><div ng-if="!vm.modalLoading"><div class="form-group"><label for="breed"><data-i18n i18n="_m_f_mixing_feeding_recipe_">Recipe</data-i18n></label><ui-select ng-model="vm.selectedRecipe" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" required="" id="recipe" name="recipe"><ui-select-match allow-clear="true" placeholder="{{\'_m_f_mixing_feeding_select_recipe_\'|i18n}}">{{$select.selected.recipe_name}}</ui-select-match><ui-select-choices repeat="recipe in vm.recipes | filter: $select.search"><span ng-bind-html="recipe.recipe_name"></span></ui-select-choices></ui-select></div><div class="form-group"><label for="breed"><data-i18n i18n="_m_f_reports_pen_">Pen</data-i18n></label><ui-select ng-model="vm.selectedPen" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" required="" id="pen" name="pen"><ui-select-match allow-clear="true" placeholder="{{\'_m_f_reports_select_pen_\'|i18n}}">{{$select.selected.pen_name}}</ui-select-match><ui-select-choices repeat="pen in vm.pens | filter: $select.search"><span ng-bind-html="pen.pen_name"></span></ui-select-choices></ui-select></div><div class="form-group"><label for="breed"><data-i18n i18n="_m_f_title_category_">category</data-i18n></label><ui-select ng-model="vm.selectedCategory" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" required="" id="category" name="category"><ui-select-match allow-clear="true" placeholder="{{\'_m_f_placeholder_select_category_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="category in vm.categories | filter: $select.search"><span ng-bind-html="category.name"></span></ui-select-choices></ui-select></div><div class="form-group"><label for="date"><data-i18n i18n="_m_f_reports_time_period_">Time period</data-i18n></label><ui-select ng-model="vm.selectedPredefinedDate" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" required="" id="date" name="date" ng-change="vm.selectPredefinedDates()"><ui-select-match allow-clear="false" placeholder="{{\'_m_f_reports_select_time_period_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="category in vm.predefinedDates | filter: $select.search"><span ng-bind-html="category.name"></span></ui-select-choices></ui-select></div><div><div><div style="display: inline-block; margin-right: 10px" ng-click="vm.showCustomSelector()"><a href="" ng-class="vm.show_custom_selector? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'"></a></div><div style="display: inline-block" ng-click="vm.showCustomSelector()" class="time-period-label"><data-i18n i18n="_m_f_reports_custom_time_period_">Custom time period</data-i18n></div></div></div><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'" ng-if="vm.show_custom_selector"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.start_date_picker" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p><span ng-if="!vm.start_date_picker" class="warningModal"><p><data-i18n i18n="_mf_start_date_required_">Selecting start date is required</data-i18n></p></span> <label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.end_date_picker" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p><span ng-if="!vm.end_date_picker" class="warningModal"><p><data-i18n i18n="_mf_end_date_required_">Selecting end date is required</data-i18n></p></span></div><div align="right"><button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button> <button type="submit" class="btn btn-info btn-with-icon save-profile" ng-click="vm.saveFilter()" ng-disabled="vm.addCategoryForm.$invalid|| !vm.start_date_picker || !vm.end_date_picker"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></div><div style="height: 200px; overflow: hidden" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/reports/weighback/weighback.graph.html','');
$templateCache.put('app/pages/reports/weighback/weighback.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/reports/weighback/weighback.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/reports/weighback/weighback.panel.html','<div class="row" ng-if="!vm.loading && vm.selectedHerd"><div class="btn-group" style="float: right"><button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.openFilterModal()"><span class="glyphicon glyphicon-filter" uib-tooltip="{{\'_reports_filter_active_\' | i18n}}" tooltip-is-open="filter_active" tooltip-enable="vm.recipeFilterActive" tooltip-placement="left" tooltip-class="customBlue left tooltip-opaque" tooltip-popup-delay="500"></span></button> <button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(1)" ng-class="vm.selectedLayout == 1 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th-list" ng-class="vm.selectedLayout == 1 ? \'selected\' : \'\'"></span></button> <button id="grid" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(2)" ng-class="vm.selectedLayout == 2 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th" ng-class="vm.selectedLayout == 2 ? \'selected\' : \'\'"></span></button></div><div class="notificationWeighback" ng-if="vm.recipeFilterActive"></div></div><div class="row" ng-if="vm.selectedHerd && vm.selectedLayout == 1"><div include-with-scope="app/pages/reports/weighback/weighback.table.html"></div></div><div class="row" ng-if="vm.selectedHerd && vm.selectedLayout == 2"><div include-with-scope="app/pages/reports/weighback/weighback.graph.html"></div></div><div class="row" ng-if="vm.loading" style="text-align: center; overflow: hidden"><div id="loading-animation-large"></div></div><div class="row" ng-if="!vm.loading && !vm.selectedHerd" align="center"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div>');
$templateCache.put('app/pages/reports/weighback/weighback.table.html','<div class="horizontal-scroll" ng-if="!vm.loading"><table class="table mixing-table" style="font-size: 14px"><thead><tr class="table-header"><th></th><th align="left"><data-i18n i18n="_report_date_">Date</data-i18n><br></th><th><data-i18n i18n="_m_f_recipe_name_">Recipe name</data-i18n><br></th><th><data-i18n i18n="_m_f_pen_number_of_animals_"># animals</data-i18n><br></th><th><data-i18n i18n="_m_f_reports_total_loaded_">Total loaded</data-i18n><br>({{vm.weight}})</th><th><data-i18n i18n="_m_f_reports_total_weighbacks_">Total weighbacks</data-i18n><br>({{vm.weight}})</th><th><data-i18n i18n="_m_f_reports_price_">Price</data-i18n><br><data-i18n i18n="_m_f_reports_weighbacks_">Weighbacks</data-i18n></th><th><data-i18n i18n="_m_f_reports_total_net_intake_">Total Net intake</data-i18n><br></th></tr></thead><tbody ng-if="!vm.loadingTable"><tr ng-repeat-start="(indexX, report) in vm.reports"><td style="padding: 5px 5px"><a href="" ng-click="vm.selectTableRow($index, recipe.id, recipe, \'close\')" ng-class="vm.dataCollapse[$index]? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'"></a></td><td style="padding: 5px 5px">{{report.feeding_date | date:\'shortDate\'}}</td><td style="padding: 5px 5px">{{report.recipe_name}}</td><td style="padding: 5px 5px">{{report.number_of_animals}}</td><td style="padding: 5px 5px">{{report.total_load}}</td><td style="padding: 5px 5px">{{report.total_weighbacks}}</td><td style="padding: 5px 5px">{{report.weighbacks_price}}</td><td style="padding: 5px 5px">{{report.total_net_intake}}</td></tr><tr ng-if="vm.dataCollapse[indexX]==true"><td colspan="10"><table class="table"><thead><tr><th><data-i18n i18n="_m_f_recipe_pen_">Pen(s)</data-i18n></th><th><data-i18n i18n="_m_f_pen_category_">Category</data-i18n><br></th><th><data-i18n i18n="_m_f_pen_number_of_animals_"># animals</data-i18n><br></th><th><data-i18n i18n="_m_f_reports_loaded_kg_">Loaded</data-i18n>({{vm.weight}})<br><data-i18n i18n="_m_f_reports_pen_">Pen</data-i18n></th><th><data-i18n i18n="_m_f_reports_loaded_kg_">Loaded</data-i18n>({{vm.weight}})<br><data-i18n i18n="_m_f_reports_animal_">Animal</data-i18n></th><th><data-i18n i18n="_m_f_reports_weighbacks_kg_">Weighbacks</data-i18n>({{vm.weight}})<br><data-i18n i18n="_m_f_reports_pen_">Pen</data-i18n></th><th><data-i18n i18n="_m_f_reports_weighbacks_kg_">Weighbacks</data-i18n>({{vm.weight}})<br><data-i18n i18n="_m_f_reports_animal_">Animal</data-i18n></th><th><data-i18n i18n="_m_f_reports_intake_">Intake</data-i18n>({{vm.weight}})<br><data-i18n i18n="_m_f_reports_pen_">Pen</data-i18n></th><th><data-i18n i18n="_m_f_reports_intake_kg_animal_">Intake Animal</data-i18n>({{vm.weight}})<br><data-i18n i18n="_m_f_reports_as_fed_">(as fed)</data-i18n></th><th><data-i18n i18n="_m_f_reports_intake_kg_animal_">Intake Animal</data-i18n><br>({{vm.weight}}&nbsp;DM)</th></tr></thead><tbody><tr ng-repeat="pen in report.pen_feedingWeight_DTO"><td>{{pen.pen.pen_name}}</td><td>{{pen.pen.pen_category.name}}</td><td>{{pen.pen.number_of_animals}}</td><td>{{pen.loaded_pen}}</td><td>{{pen.loaded_animal | number:2}}</td><td>{{pen.weighbacks_pen}}</td><td>{{pen.weighbacks_animals}}</td><td>{{pen.intake_pen | number:2}}</td><td>{{pen.intake_animal | number:2}}</td><td>{{pen.intake_animal_dm}}</td></tr></tbody></table></td></tr><tr ng-repeat-end=""></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable && !vm.loading"><tr><td colspan="9"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></td></tr></tbody><tfoot><tr ng-if="vm.totalItems > 10"><td colspan="9" style="text-align: center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="10" max-size="7" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-disabled="vm.loadingTable"></uib-pagination></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/teams/addNewTeam/addNewTeam.html','<div ba-panel="" class="ng-cloak"><div class="panel-group"><form name="vm.teamForm" novalidate="" ng-if="!vm.loading"><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.teamForm.team_name.$invalid && (vm.teamForm.team_name.$dirty || vm.teamForm.$submitted)}"><label for="team_name"><data-i18n i18n="_groups_team_name_">Team name</data-i18n></label> <input type="text" maxlength="70" class="form-control" id="team_name" name="team_name" placeholder="{{\'_groups_team_name_\'|i18n}}" ng-model="vm.teamDTO.Name" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_team_name_required_">team name is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.teamForm.team_email.$invalid && (vm.teamForm.team_email.$dirty || vm.teamForm.$submitted)}"><label for="team_email"><data-i18n i18n="_title_column_email_">Email</data-i18n></label> <input type="email" class="form-control" id="team_email" name="team_email" placeholder="{{\'_title_column_email_\'|i18n}}" ng-model="vm.teamDTO.Email" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_title_column_email_required_">email is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.teamForm.street_address.$invalid && (vm.teamForm.street_address.$dirty || vm.teamForm.$submitted)}"><label for="street_address"><data-i18n i18n="_title_street_address_">Street address</data-i18n></label> <input type="text" class="form-control" id="street_address" name="street_address" placeholder="{{\'_title_street_address_\'|i18n}}" ng-model="vm.teamDTO.Address.Street" required=""><span class="help-block error-block basic-block"><data-i18n i18n="_title_street_address_required_">street address is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group"><label for="street_name_2"><data-i18n i18n="_title_street_address_2_">Street address 2</data-i18n></label> <input type="text" class="form-control" id="street_name_2" placeholder="{{\'_title_street_address_2_\'|i18n}}" ng-model="vm.teamDTO.Address.street_address_2"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.teamForm.zip.$invalid && (vm.teamForm.zip.$dirty || vm.teamForm.$submitted)}"><label for="zip"><data-i18n i18n="_zip_postal_code_">Zip / postal code</data-i18n></label> <input type="text" class="form-control" id="zip" name="zip" placeholder="{{\'_zip_postal_code_\'|i18n}}" ng-model="vm.teamDTO.Address.Zip" required=""><span class="help-block error-block basic-block"><data-i18n i18n="_zip_postal_code_required_">zip / postal code is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.teamForm.city.$invalid && (vm.teamForm.city.$dirty || vm.teamForm.$submitted)}"><label for="city"><data-i18n i18n="_title_city_">City</data-i18n></label> <input type="text" class="form-control" id="city" name="city" placeholder="{{\'_title_city_\'|i18n}}" ng-model="vm.teamDTO.Address.City" required=""><span class="help-block error-block basic-block"><data-i18n i18n="_title_city_required_">city is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.teamForm.country.$invalid && (vm.teamForm.country.$dirty || vm.teamForm.$submitted)}"><label for="feed_name"><data-i18n i18n="_title_country_">Country</data-i18n></label><select class="form-control dropdown-toggle category-iteam category-select" id="country" name="country" ng-model="vm.teamDTO.Address.CountryCode" required=""><option value="">{{vm.selectPlaceholder | i18n}}</option><option value="USA">United States</option><option value="CAN">Canada</option><option value="AFG">Afghanistan</option><option value="ALB">Albania</option><option value="DZA">Algeria</option><option value="ASM">American Samoa</option><option value="AND">Andorra</option><option value="AGO">Angola</option><option value="AIA">Anguilla</option><option value="ATA">Antarctica</option><option value="ATG">Antigua and Barbuda</option><option value="ARG">Argentina</option><option value="ARM">Armenia</option><option value="ABW">Aruba</option><option value="AUS">Australia</option><option value="AUT">Austria</option><option value="AZE">Azerbaijan</option><option value="BHS">Bahamas</option><option value="BHR">Bahrain</option><option value="BGD">Bangladesh</option><option value="BRB">Barbados</option><option value="BLR">Belarus</option><option value="BEL">Belgium</option><option value="BLZ">Belize</option><option value="BEN">Benin</option><option value="BMU">Bermuda</option><option value="BTN">Bhutan</option><option value="BOL">Bolivia</option><option value="BIH">Bosnia and Herzegowina</option><option value="BWA">Botswana</option><option value="BVT">Bouvet Island</option><option value="BRA">Brazil</option><option value="IOT">British Indian Ocean Territory</option><option value="BRN">Brunei Darussalam</option><option value="BGR">Bulgaria</option><option value="BFA">Burkina Faso</option><option value="BDI">Burundi</option><option value="KHM">Cambodia</option><option value="CMR">Cameroon</option><option value="CPV">Cape Verde</option><option value="CYM">Cayman Islands</option><option value="CAF">Central African Republic</option><option value="TCD">Chad</option><option value="CHL">Chile</option><option value="CHN">China</option><option value="CXR">Christmas Island</option><option value="CCK">Cocos (Keeling) Islands</option><option value="COL">Colombia</option><option value="COM">Comoros</option><option value="COG">Congo</option><option value="COK">Cook Islands</option><option value="CRI">Costa Rica</option><option value="CIV">Cote D&#39;Ivoire</option><option value="HRV">Croatia</option><option value="CUB">Cuba</option><option value="CYP">Cyprus</option><option value="CZE">Czech Republic</option><option value="DNK">Denmark</option><option value="DJI">Djibouti</option><option value="DMA">Dominica</option><option value="DOM">Dominican Republic</option><option value="ECU">Ecuador</option><option value="EGY">Egypt</option><option value="SLV">El Salvador</option><option value="GNQ">Equatorial Guinea</option><option value="ERI">Eritrea</option><option value="EST">Estonia</option><option value="ETH">Ethiopia</option><option value="FLK">Falkland Islands (Malvinas)</option><option value="FRO">Faroe Islands</option><option value="FJI">Fiji</option><option value="FIN">Finland</option><option value="FRA">France</option><option value="GUF">French Guiana</option><option value="PYF">French Polynesia</option><option value="ATF">French Southern Territories</option><option value="GAB">Gabon</option><option value="GMB">Gambia</option><option value="GEO">Georgia</option><option value="DEU">Germany</option><option value="GHA">Ghana</option><option value="GIB">Gibraltar</option><option value="GRC">Greece</option><option value="GRL">Greenland</option><option value="GRD">Grenada</option><option value="GLP">Guadeloupe</option><option value="GUM">Guam</option><option value="GTM">Guatemala</option><option value="GIN">Guinea</option><option value="GNB">Guinea-bissau</option><option value="GUY">Guyana</option><option value="HTI">Haiti</option><option value="HMD">Heard and Mc Donald Islands</option><option value="HND">Honduras</option><option value="HKG">Hong Kong</option><option value="HUN">Hungary</option><option value="ISL">Iceland</option><option value="IND">India</option><option value="IDN">Indonesia</option><option value="IRN">Iran (Islamic Republic of)</option><option value="IRQ">Iraq</option><option value="IRL">Ireland</option><option value="ISR">Israel</option><option value="ITA">Italy</option><option value="JAM">Jamaica</option><option value="JPN">Japan</option><option value="JOR">Jordan</option><option value="KAZ">Kazakhstan</option><option value="KEN">Kenya</option><option value="KIR">Kiribati</option><option value="KOR">Korea</option><option value="PRK">Korea, Democratic People&#39;s Republic of</option><option value="KWT">Kuwait</option><option value="KGZ">Kyrgyzstan</option><option value="LAO">Lao People&#39;s Democratic Republic</option><option value="LVA">Latvia</option><option value="LBN">Lebanon</option><option value="LSO">Lesotho</option><option value="LBR">Liberia</option><option value="LBY">Libyan Arab Jamahiriya</option><option value="LIE">Liechtenstein</option><option value="LTU">Lithuania</option><option value="LUX">Luxembourg</option><option value="MAC">Macau</option><option value="MKD">Macedonia</option><option value="MDG">Madagascar</option><option value="MWI">Malawi</option><option value="MYS">Malaysia</option><option value="MDV">Maldives</option><option value="MLI">Mali</option><option value="MLT">Malta</option><option value="MHL">Marshall Islands</option><option value="MTQ">Martinique</option><option value="MRT">Mauritania</option><option value="MUS">Mauritius</option><option value="MYT">Mayotte</option><option value="MEX">Mexico</option><option value="FSM">Micronesia</option><option value="MDA">Moldova</option><option value="MCO">Monaco</option><option value="MNG">Mongolia</option><option value="MNE">Montenegro</option><option value="MSR">Montserrat</option><option value="MAR">Morocco</option><option value="MOZ">Mozambique</option><option value="MMR">Myanmar</option><option value="NAM">Namibia</option><option value="NRU">Nauru</option><option value="NPL">Nepal</option><option value="NLD">Netherlands</option><option value="ANT">Netherlands Antilles</option><option value="NCL">New Caledonia</option><option value="NZL">New Zealand</option><option value="NIC">Nicaragua</option><option value="NER">Niger</option><option value="NGA">Nigeria</option><option value="NIU">Niue</option><option value="NFK">Norfolk Island</option><option value="MNP">Northern Mariana Islands</option><option value="NOR">Norway</option><option value="OMN">Oman</option><option value="PAK">Pakistan</option><option value="PLW">Palau</option><option value="PAN">Panama</option><option value="PNG">Papua New Guinea</option><option value="PRY">Paraguay</option><option value="PER">Peru</option><option value="PHL">Philippines</option><option value="PCN">Pitcairn</option><option value="POL">Poland</option><option value="PRT">Portugal</option><option value="PRI">Puerto Rico</option><option value="QAT">Qatar</option><option value="REU">Reunion</option><option value="ROM">Romania</option><option value="RUS">Russia</option><option value="RWA">Rwanda</option><option value="KNA">Saint Kitts and Nevis</option><option value="LCA">Saint Lucia</option><option value="VCT">Saint Vincent and the Grenadines</option><option value="WSM">Samoa</option><option value="SMR">San Marino</option><option value="STP">Sao Tome and Principe</option><option value="SAU">Saudi Arabia</option><option value="SEN">Senegal</option><option value="SRB">Serbia</option><option value="SYC">Seychelles</option><option value="SLE">Sierra Leone</option><option value="SGP">Singapore</option><option value="SVK">Slovakia (Slovak Republic)</option><option value="SVN">Slovenia</option><option value="SLB">Solomon Islands</option><option value="SOM">Somalia</option><option value="ZAF">South Africa</option><option value="SGS">South Georgia &amp; South Sandwich Islands</option><option value="ESP">Spain</option><option value="LKA">Sri Lanka</option><option value="SHN">St. Helena</option><option value="SPM">St. Pierre and Miquelon</option><option value="SDN">Sudan</option><option value="SUR">Suriname</option><option value="SJM">Svalbard and Jan Mayen Islands</option><option value="SWZ">Swaziland</option><option value="SWE">Sweden</option><option value="CHE">Switzerland</option><option value="SYR">Syrian Arab Republic</option><option value="TWN">Taiwan</option><option value="TJK">Tajikistan</option><option value="TZA">Tanzania</option><option value="THA">Thailand</option><option value="TGO">Togo</option><option value="TKL">Tokelau</option><option value="TON">Tonga</option><option value="TTO">Trinidad and Tobago</option><option value="TUN">Tunisia</option><option value="TUR">Turkey</option><option value="TKM">Turkmenistan</option><option value="TCA">Turks and Caicos Islands</option><option value="TUV">Tuvalu</option><option value="UGA">Uganda</option><option value="UKR">Ukraine</option><option value="ARE">United Arab Emirates</option><option value="GBR">United Kingdom</option><option value="UMI">United States minor outlying islands</option><option value="URY">Uruguay</option><option value="UZB">Uzbekistan</option><option value="VUT">Vanuatu</option><option value="VAT">Vatican City State (Holy See)</option><option value="VEN">Venezuela</option><option value="VNM">Viet Nam</option><option value="VGB">Virgin Islands (British)</option><option value="VIR">Virgin Islands (U.S.)</option><option value="WLF">Wallis and Futuna Islands</option><option value="ESH">Western Sahara</option><option value="YEM">Yemen</option><option value="ZMB">Zambia</option><option value="ZWE">Zimbabwe</option></select><span class="help-block error-block basic-block"><data-i18n i18n="_title_country_required">country is required</data-i18n></span></div></div></div><div align="right"><button type="submit" class="btn btn-success" ng-click="vm.addNewTeam()"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></form><div align="center" ng-if="vm.loading" style="overflow: hidden"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/teams/myTeams/myTeams.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/teams/myTeams/myTeams.table.html"></div></div></div></div></div>');
$templateCache.put('app/pages/teams/myTeams/myTeams.table.html','<div class="horizontal-scroll"><table class="table table-hover" st-table="vm.teams" st-safe-src="vm.teamsSafe" ng-if="!vm.loading" style="font-size: 14px"><thead><tr class="sortable"><th style="min-width: 400px" st-sort-default="true" st-sort="Name"><data-i18n i18n="_groups_team_name_">team name</data-i18n></th><th style="min-width: 300px; text-align: center" st-sort="Email"><data-i18n i18n="_title_column_email_">email</data-i18n></th><th style="text-align: center"><data-i18n i18n="_label_order_exp_date_">Order expiration date</data-i18n></th><th></th></tr><tr><th><input st-search="Name" placeholder="{{\'_search_placeholder_team_name_\' | i18n }}" class="input-sm form-control search-input" type="search"></th><th><input st-search="Email" placeholder="{{\'_search_placeholder_email_\' | i18n }}" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="team in vm.teams track by team.Id" ng-click="vm.setAsDefault(team)"><td style="padding: 3px 3px">{{team.Name}}</td><td style="text-align: center; padding: 3px 3px">{{team.Email}}</td><td style="text-align: center; padding: 3px 3px"><ul class="order-list"><li class="{{team.rationOrder.status}}" ng-if="team.rationOrder">MmmooOgle Ration: <span>{{team.rationOrder.EndDate}}</span></li><li class="{{team.feedOrder.status}}" ng-if="team.feedOrder">Feed Now: <span>{{team.feedOrder.EndDate}}</span></li></ul></td><td style="padding: 3px 3px"><a class="icon-edit green-icon" ng-disabled="vm.loading" href="" ng-class="team.isDefault ? \'ion-star\' : \'ion-ios-star-outline\'" uib-tooltip="{{\'_tips_set_as_default_team_\' | i18n}}" tooltip-is-open="tooltipIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="750" style="margin-right: 5px"></a></td></tr></tbody><tfoot><tr><td colspan="4" class="text-center"><div st-pagination="" st-items-by-page="vm.itemsPerPage" st-displayed-pages="5"></div></td></tr><tr ng-if="vm.itemsPerPageValues.length > 0"><td colspan="4" class="text-left"><div class="form-group select-page-size-wrap dropup" ng-class="vm.itemsPerPageValues.length == 4 ? \'exended-1\' : (vm.itemsPerPageValues.length == 5 ? \'exended-2\' : \'\')"><label><data-i18n i18n="_title_rows_on_page_">rows on page</data-i18n><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="vm.itemsPerPage" ng-options="i for i in vm.itemsPerPageValues"></select></label></div></td></tr></tfoot></table><div ng-if="vm.loading" align="center"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu && !item.fixedHref" class="al-sidebar-list-link hide-tip" uib-tooltip="{{item.titleTranslated }}" tooltip-is-open="item_open_{{$index}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" tooltip-append-to-body="true" tooltip-enable="{{$baSidebarService.isMenuCollapsed()}}"><i ng-class="{ \'large-font\': $baSidebarService.isMenuCollapsed() }" class="{{ ::item.icon }}" ng-if="item.icon"></i> <img ng-src="{{$baSidebarService.isMenuCollapsed() ? item.imgLarge : item.img}}" ng-if="item.img" class="sidebar-img" ng-class="{ \'sidebar-img-large\': $baSidebarService.isMenuCollapsed() }"> <span><data-i18n i18n="{{ ::item.title }}">{{ ::item.title }}</data-i18n></span></a> <a ng-mouseenter="hoverItem($event, item)" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu && item.fixedHref" class="al-sidebar-list-link hide-tip" uib-tooltip="{{item.titleTranslated }}" tooltip-is-open="item_open_{{$index}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" tooltip-append-to-body="true" tooltip-enable="{{$baSidebarService.isMenuCollapsed()}}" target="_blank"><i ng-class="{ \'large-font\': $baSidebarService.isMenuCollapsed() }" class="{{ ::item.icon }}" ng-if="item.icon"></i> <img ng-src="{{$baSidebarService.isMenuCollapsed() ? item.imgLarge : item.img}}" ng-if="item.img" class="sidebar-img" ng-class="{ \'sidebar-img-large\': $baSidebarService.isMenuCollapsed() }"> <span><data-i18n i18n="{{ ::item.title }}">{{ ::item.title }}</data-i18n></span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler="" uib-tooltip="{{item.titleTranslated }}" tooltip-is-open="item_open_{{$index}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" tooltip-append-to-body="true" tooltip-enable="{{$baSidebarService.isMenuCollapsed()}}" ng-class="{ \'wrap\': !$baSidebarService.isMenuCollapsed()}"><i ng-class="{ \'large-font\': $baSidebarService.isMenuCollapsed() }" class="{{ ::item.icon }}" ng-if="item.icon"></i> <img ng-src="{{$baSidebarService.isMenuCollapsed() ? item.imgLarge : item.img}}" ng-if="item.img" class="sidebar-img" ng-class="{ \'sidebar-img-large\': $baSidebarService.isMenuCollapsed() }"><div style="display: inline-block;vertical-align: middle;width: 130px;height: auto;overflow: hidden;text-overflow: ellipsis;"><data-i18n i18n="{{ ::item.title }}">{{ ::item.title }}</data-i18n></div><b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span><data-i18n i18n="{{ ::subitem.title }}">{{ ::subitem.title }}</data-i18n></span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link"><data-i18n i18n="{{ ::subSubitem.title }}">{{ ::subSubitem.title }}</data-i18n></a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}"><data-i18n i18n="{{ ::subSubitem.title }}">{{ ::subSubitem.title }}</data-i18n></a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link"><data-i18n i18n="{{ ::subitem.title }}">{{ ::subitem.title }}</data-i18n></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}"><data-i18n i18n="{{ ::subitem.title }}">{{ ::subitem.title }}</data-i18n></a></li></ul></li><li class="al-sidebar-list-item"><a ng-mouseenter="hoverItem($event, item)" target="_blank" href="https://my.mmmooogle.com" class="al-sidebar-list-link" uib-tooltip="My MmmooOgle" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" tooltip-append-to-body="true" tooltip-enable="{{$baSidebarService.isMenuCollapsed()}}"><span ng-class="{ \'large-font\': $baSidebarService.isMenuCollapsed() }"><img ng-src="{{$baSidebarService.isMenuCollapsed()? \'assets/img/icons/My MmmooOgle.svg\' : \'assets/img/icons/My MmmooOgle.svg\'}}" class="sidebar-img" ng-class="{ \'sidebar-img-large\': $baSidebarService.isMenuCollapsed() }"></span>My MmmooOgle</a> <a ng-mouseenter="hoverItem($event, item)" target="_blank" href="https://www.youtube.com/playlist?list=PL09WtOITpvJqGF5Zklu2qgdebJisV8e5W" class="al-sidebar-list-link" uib-tooltip="{{\'_page_title_videos_\'| i18n}}" tooltip-is-open="videosIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" tooltip-append-to-body="true" tooltip-enable="{{$baSidebarService.isMenuCollapsed()}}"><span ng-class="{ \'large-font\': $baSidebarService.isMenuCollapsed() }"><img ng-src="{{$baSidebarService.isMenuCollapsed()? \'assets/img/icons/Videos-32.png\' : \'assets/img/icons/Videos-24.png\'}}" id="videoIcon" class="sidebar-img" ng-class="{ \'sidebar-img-large\': $baSidebarService.isMenuCollapsed() }"></span><data-i18n i18n="_page_title_videos_">Videos</data-i18n></a></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}} wizard-validation-{{$index}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-hide="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span><data-i18n i18n="_btn_previous_">previous</data-i18n></button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-hide="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary"><data-i18n i18n="_btn_next_">next</data-i18n><span aria-hidden="true">&rarr;</span></button></li></ul></nav><div class="steps" ng-transclude=""></div></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/browserMessage/browserMessage.html','<div class="browser-massage" id="browser-id"><div class="browser-massage-wraper" id="browser-id" ng-if="bm.show"><div class="bm-body"><div class="bm-text">{{bm.message}}</div><div class="bm-button" ng-if="bm.showButton"><button class="btn" ng-click="bm.ok()">Ok</button></div></div></div></div>');
$templateCache.put('app/theme/components/cookiePolicy/cookiePolicy.html','<div class="cookie-policy"><div class="cookie-policy-wraper" ng-if="vm.showCookiePolicyMessage"><div class="cp-header">Cookies</div><div class="cp-body"><div class="cp-text">Cookies help us deliver our services. By using our services, you agree to our use of cookies. <span ng-click="vm.openPrivacyPolicy()">Learn more.</span></div><div class="cp-button"><button class="btn" ng-click="vm.acceptCookies()">Accept</button></div></div></div><div class="policy-text" ng-if="vm.showPrivacyPolicyText"><div class="button-holder"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closePrivacyPolicy()"></i></div><div class="heading">Privacy Policy</div><div>This privacy policy (the \u201CPrivacy Policy\u201D) covers Bovicom/MmmooOgle service (the \u201CService\u201D). Please read below to review our Privacy Policy and the types of information we gather through our Service. In this Privacy Policy, \u201Cwe\u201D, \u201Cus\u201D, \u201Cour\u201D and other similar references mean Bovicom/MmmooOgle and \u201Cyou\u201D and \u201Cyour\u201D and other similar references mean a specific user of the Service. Bovicom/MmmooOgle knows that you care about how your personal information is used and shared, and we take your privacy seriously. Please read the following to learn more about our privacy policy. By visiting Bovicom/MmmooOgle website and by using Bovicom/MmmooOgle Services, you are accepting the practices outlined in this Privacy Policy.</div><div class="heading">1. Website Visitors</div><div>Like most website operators, Bovicom/MmmooOgle collects non-personally-identifying information of the sort that web browsers and servers typically make available, such as the browser type, language preference, referring site, and the date and time of each visitor request. Bovicom/MmmooOgle\u2019s purpose in collecting non-personally identifying information is to better understand how Bovicom/MmmooOgle\u2019s visitors use its website. From time to time, Bovicom/MmmooOgle may release non-personally-identifying information in the aggregate, e.g., by publishing a report on trends in the usage of its website. Bovicom/MmmooOgle also collects potentially personally-identifying information like Internet Protocol (IP) addresses for logged in users.</div><div class="heading">2. Gathering of Personally-Identifying Information</div><div>Certain visitors to Bovicom/MmmooOgle\u2019s websites choose to interact with Bovicom/MmmooOgle in ways that require Bovicom/MmmooOgle to gather personally-identifying information. The amount and type of information that Bovicom/MmmooOgle gathers depends on the nature of the interaction. In each case, Bovicom/MmmooOgle collects such information only insofar as is necessary or appropriate to fulfill the purpose of the visitor\u2019s interaction with Bovicom/MmmooOgle. Bovicom/MmmooOgle does not disclose personally-identifying information other than as described below. And visitors can always refuse to supply personally-identifying information, with the caveat that it may prevent them from engaging in certain website-related activities.</div><div class="heading">3. Links</div><div>Bovicom/MmmooOgle may contain links to other sites. Our site is not responsible for the privacy policies and/or practices on other sites. When linking to another site a user should read the privacy policy stated on that site.</div><div class="heading">4. Aggregated Statistic</div><div>Bovicom/MmmooOgle may collect statistics about the behavior of visitors to its websites. However, Bovicom/MmmooOgle does not disclose personally-identifying information other than as described below.</div><div class="heading">5. Protection of Certain Personally-Identifying Information</div><div>Bovicom/MmmooOgle collects and uses your personal information to operate and deliver the Services.</div><div>Bovicom/MmmooOgle discloses potentially personally-identifying and personally-identifying information only to those of its employees, contractors and affiliated organizations that (i) need to know that information in order to process it on Bovicom/MmmooOgle\u2019s behalf or to provide services available at Bovicom/MmmooOgle\u2019s websites, and (ii) that have agreed not to disclose it to others. Some of those employees, contractors and affiliated organizations may be located outside of your home country; by using Bovicom/MmmooOgle\u2019s websites, you consent to the transfer of such information to them. Bovicom/MmmooOgle will not rent or sell potentially personally-identifying and personally-identifying information to anyone. Other than to its employees, contractors and affiliated organizations, as described above, Bovicom/MmmooOgle discloses potentially personally-identifying and personally-identifying information only in response to a subpoena, court order or other governmental request, or when Bovicom/MmmooOgle believes in good faith that disclosure is reasonably necessary to protect the property or rights of Bovicom/MmmooOgle, third parties or the public at large. If you are a registered user of the Bovicom/MmmooOgle website and have supplied your email address, Bovicom/MmmooOgle may occasionally send you an email to tell you about new features, solicit your feedback, or just keep you up to date with what\u2019s going on with Bovicom/MmmooOgle and our products. If you send us a request (for example via a support email or via one of our feedback mechanisms), we reserve the right to publish it in order to help us clarify or respond to your request or to help us support other users. Bovicom/MmmooOgle takes all measures reasonably necessary to protect against the unauthorized access, use, alteration or destruction of potentially personally-identifying and personally-identifying information.</div><div class="heading">6. Cookies</div><div>A cookie is a string of information that a website stores on a visitor\u2019s computer, and that the visitor\u2019s browser provides to the website each time the visitor returns. Bovicom/MmmooOgle uses cookies to help Bovicom/MmmooOgle identify and track visitors, their usage of Bovicom/MmmooOgle website, and their website access preferences. Bovicom/MmmooOgle visitors who do not wish to have cookies placed on their computers should set their browsers to refuse cookies before using Bovicom/MmmooOgle\u2019s websites, with the drawback that certain features of Bovicom/MmmooOgle\u2019s websites may not function properly without the aid of cookies.</div><div class="heading">7. Processing herd data</div><div>Herd data is processed on behalf of, and in accordance with the instruction from, those making this data available.</div><div>Bovicom/MmmooOgle may use herd data for internal business purposes, such as data analysis, providing customer support, customizing and improving our Services, product development, providing, selling and licensing products and services based on anonymised and/or aggregated herd data, meeting government regulatory requirements, and so forth.</div><div class="heading">8. Access and rectification</div><div>Bovicom/MmmooOgle complies with applicable law regarding your ability to access, correct and delete your personally identifiable information. If you have an online account, you may be able to log into your account to access and update certain information you provided to us. If you need assistance updating or deleting your personal information, please contact us via email to info@mmmooogle.com. Please provide your name, address, and detailed information about the change you would like to make.</div><div class="heading">9. Privacy Policy Changes</div><div>Bovicom/MmmooOgle may change its Privacy Policy from time to time, and in Bovicom/MmmooOgle\u2019s sole discretion. Bovicom/MmmooOgle encourages visitors to frequently check this page for any changes to its Privacy Policy. Your continued use of this site after any change in this Privacy Policy will constitute your acceptance of such change.</div><div class="heading">10. Contacting Us</div><div>If there are any questions regarding this Privacy Policy you may contact us using the information below. Bovicom BVBA, Zeutestraat 1, 2870 Puurs, BELGIUM</div><div class="heading">11. Last Modification</div><div>This Privacy Policy was last modified on March the 3rd, 2017.</div></div></div>');
$templateCache.put('app/theme/components/cookiePolicy/cookiePolicy.modal.html','<div style="z-index: 99999999"><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="shortDate" ng-model="vm.period_start" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.actualDashboardOpen"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="shortDate" ng-model="vm.period_end" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-info pull-right" ng-click="vm.setRange()" style="margin-left:5px;"><data-i18n i18n="_label_apply_">apply</data-i18n></button> <button class="btn btn-xs btn-danger pull-right" ng-click="vm.closeModal()" style="margin-left:5px;"><data-i18n i18n="_label_cancel_">cancel</data-i18n></button> <button class="btn btn-xs btn-danger pull-right" ng-click="vm.resetRange()" style="margin-left:5px;" ng-if="vm.use_date_range"><data-i18n i18n="_label_reset_">reset</data-i18n></button></div></div></div>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><ul class="breadcrumb al-breadcrumb"><li><a href="/dashboard"><data-i18n i18n="_menu_home_">home</data-i18n></a></li><li ng-if="activePageParentData.parent_data && !vm.hide_parent"><a><data-i18n i18n="{{activePageParentData.parent_data.title}}" ng-if="activePageParentData.parent_data">{{activePageParentData.parent_data.title}}</data-i18n></a></li><li ng-if="activePageParentData && !vm.hide_parent" ng-click="vm.goToParent(activePageParentData)"><a><data-i18n i18n="{{activePageParentData.title}}" ng-if="activePageParentData">{{activePageParentData}}</data-i18n></a></li><li ng-if="vm.checkCustomParentTitles()" ng-click="vm.goToCustomParentState()"><a>{{vm.custom_parent_state}}</a></li><li ng-if="vm.checkCustomTitles()" ng-click="vm.goToCustomState()"><a>{{vm.custom_state}}</a></li><li ng-class="vm.addClass()" ng-click="vm.activePageSelected()"><data-i18n i18n="{{ activePageTitle }}" ng-if="activePageTitle">{{ activePageTitle }}</data-i18n></li><li ng-if="vm.showDashboardState()" class="al-title-hover" ng-click="vm.activeCategorySelected()">{{vm.category.name}}</li><li ng-if="vm.showSelectedDashboard()">{{vm.selectedDashboard}}</li></ul><div class="dashboard-pills period-selector" style="text-align: right" ng-if="vm.showSelectedDashboard()"><button class="btn time-selector" ng-class="vm.selectedTime==7 ? \'active-time-selector\' : \'\'" ng-click="vm.timeSelectorChanged(7)" style="padding: 6px 12px; font-size: 14px; font-weight: 400"><data-i18n i18n="_label_time_7_days_">7 days</data-i18n></button> <button class="btn time-selector" ng-class="vm.selectedTime==30 ? \'active-time-selector\' : \'\'" ng-click="vm.timeSelectorChanged(30)" style="padding: 6px 12px; font-size: 14px; font-weight: 400"><data-i18n i18n="_label_time_30_days_">30 days</data-i18n></button> <button class="btn time-selector" ng-class="vm.selectedTime==90 ? \'active-time-selector\' : \'\'" ng-click="vm.timeSelectorChanged(90)" style="padding: 6px 12px; font-size: 14px; font-weight: 400"><data-i18n i18n="_label_time_90_days_">90 days</data-i18n></button> <button class="btn time-selector" ng-class="vm.selectedTime==1 ? \'active-time-selector\' : \'\'" ng-click="vm.timeSelectorChanged(1)" style="padding: 6px 12px; font-size: 14px; font-weight: 400"><data-i18n i18n="_label_time_1_year_">1 year</data-i18n></button> <button class="btn time-selector" ng-class="vm.selectedTime==69 ? \'active-time-selector\' : \'\'" ng-click="vm.timeSelectorChanged(69)" style="padding: 6px 12px; font-size: 14px; font-weight: 400"><data-i18n i18n="_label_time_custom_">Custom</data-i18n></button></div></div>');
$templateCache.put('app/theme/components/errorHandling/errorHandling.html','<div id="error-handling" ng-if="er.showError" tabindex="-1" class="error-handling" ng-blur="er.onBlur()"><div ba-panel=""><div class="error-handling-panel"><label class="error-message">{{er.errorMessage | i18n}}</label><br></div><button ng-if="er.isInit" class="btn btn-md btn-primary reload-btn" ng-click="er.reloadApis()"><data i18n="_try_again_">Try again</data>&nbsp;<i class="fa fa-refresh"></i></button> <button ng-if="!er.isInit" class="btn btn-md btn-primary reload-btn" ng-click="er.dismiss()"><data i18n="_btn_dismiss_">Dismiss</data></button></div></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center" ng-style="vm.disableTeamHerd ? {cursor: \'not-allowed\'} : {}"><li uib-dropdown="" keyboard-nav="true" auto-close="outsideClick" is-open="vm.teamSelectorIsOpenPT" ng-style="vm.disableTeamHerd ? {pointerEvents: \'none\'} : {}"><div class="top-bar" uib-dropdown-toggle="" style="float:right"><div class="selector-text"><span class="defaultModal">{{vm.selectedTeam.Name}}</span></div><div id="team-selector" class="dropdown"><a href=""><span class="fa fa-chevron-down" style="color:whitesmoke; margin-left:5px"></span></a></div></div><ul class="dropdown-menu-right" uib-dropdown-menu="" role="menu" aria-labelledby="team-selector" style="max-height:150px; overflow-y:auto"><div class="option-filter"><input type="text" class="form-control" placeholder="{{vm.team_placeholder}}" ng-model="vm.textFilter" autofocus=""></div><li role="menuitem" ng-repeat="team in vm.teams | filter:vm.textFilter" ng-click="vm.selectTeam(team)" ng-if="vm.teamsLoaded" ng-class="{\'selected\' : vm.selectedTeam.Id == team.Id}"><a href="#">{{team.Name}}</a></li><li ng-if="!vm.teamsLoaded"><a href=""><data-i18n i18n="_title_loading_">loading</data-i18n>...</a></li></ul></li><li uib-dropdown="" keyboard-nav="true" auto-close="outsideClick" is-open="vm.herdSelectorIsOpenPT" ng-style="vm.disableTeamHerd ? {pointerEvents: \'none\'} : {}"><div class="top-bar" uib-dropdown-toggle="" style="float:right"><div class="selector-text" style="vertical-align: middle;"><span class="defaultModal">{{vm.selectedHerd.Name}}</span></div><div id="team-selector" class="dropdown" style="vertical-align: middle;"><a href=""><span class="fa fa-chevron-down" style="color:whitesmoke; margin-left:5px" ng-if="!vm.setHerdLoading"></span> <span ng-if="vm.setHerdLoading"><div style="margin-top: -10px;" id="loading-animation-small"></div></span></a></div></div><ul class="dropdown-menu-right" uib-dropdown-menu="" role="menu" aria-labelledby="team-selector" style="max-height:150px; overflow-y:auto"><div class="option-filter"><input type="text" class="form-control" placeholder="{{vm.herd_placeholder}}" ng-model="vm.textFilterHerd" autofocus=""></div><li style="height: 26px;" ng-click="vm.deselectHerd(true)" class="herd-deselect"></li><li role="menuitem" ng-repeat="herd in vm.herds | filter:vm.textFilterHerd" ng-click="vm.selectHerd(herd)" ng-if="vm.selectedTeam && !vm.loadingHerds && !vm.loadingSelectTeam" ng-class="{\'selected\' : vm.selectedHerd.Id == herd.Id}"><a href="#">{{herd.Name}}</a></li><li ng-if="!vm.selectedTeam"><a href=""><data-i18n i18n="_dashboard_default_team_not_defined_"></data-i18n></a></li><li ng-if="vm.loadingHerds"><a href=""><data-i18n i18n="_title_loading_">loading...</data-i18n></a></li></ul></li></ul>');
$templateCache.put('app/theme/components/loadingSpinner/loadingSpinner.html','<div id="loading-animation" style="display: inline-block"></div>');
$templateCache.put('app/theme/components/loadingSpinner/loadingSpinnerLarge.html','<div style="height: 200px; overflow: hidden" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/theme/components/offline-message/offlineMessage.html','<div class="offline-message"><span id="offline-message"><data-i18n i18n="_offline_notification_">No connection</data-i18n></span> <span id="online-message"><data-i18n i18n="_online_notification_">Back online</data-i18n>&nbsp;<a class="ion-wifi defaultModal"></a></span></div>');
$templateCache.put('app/theme/components/pageTop/orders.modal.html','<div><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body"><div class="row orders-warning-block" style="text-align: center;"><div ng-if="vm.expired.length" class="order-danger" style="padding-bottom: 0.7em;"><data-i18n i18n="_label_expired_orders_">Expired orders</data-i18n>:</div><div ng-if="vm.expired.length" ng-repeat="order in vm.expired"><span ng-if="order.ProductId == 11">MmmooOgle Ration:</span> <span ng-if="order.ProductId == 23">Feed Now:</span><span>{{order.EndDate | date:\'shortDate\'}}</span></div><div ng-if="vm.warning.length" class="order-warning" style="padding-bottom: 0.7em;"><data-i18n i18n="_label_orders_expire_soon_">Orders due to expire soon</data-i18n>:</div><div ng-if="vm.warning.length" ng-repeat="order in vm.warning"><span ng-if="order.ProductId == 11">MmmooOgle Ration:</span> <span ng-if="order.ProductId == 23">Feed Now:</span><span>{{order.EndDate | date:\'shortDate\'}}</span></div></div><div style="padding-top: 1em; text-align: center;;"><data-i18n i18n="_toastr_access_denied_insights_message_">For more informations contact us at info@mmmooogle.com</data-i18n></div></div></div>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><div class="logo"><a class="al-logo clearfix defaultBackground" style="pointer-events: none"><img class="defaultBackground" ng-src="{{\'MmmooOgle_logo.png\' | appImage}}" max-height="30px" width="200px"></a></div><a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="search" ng-disabled="vm.disableTeamHerd"><i class="ion-ios-search-strong defaultModal"></i> <input id="searchInput" type="text" placeholder="{{vm.searchPlaceholder}}" ng-change="vm.searchItem()" ng-model="vm.text" ng-keydown="vm.onEnter($event)" ng-disabled="vm.loadingTeams || vm.loadingHerds" focus="vm.focus()" ng-blur="vm.outOfFocus()"><ul class="dropdown-menu ng-isolate-scope" style="position:relative; max-height:150px; overflow-y:scroll;" ng-style="{display: show}"><li ng-class="item.active ? \'search-list-active\': \'search-list\'" ng-repeat="item in vm.items" style="margin-left:6px" ng-click="vm.selectItem($index)" id="{{\'item\'+$index }}">{{item.Name}}</li></ul></div><div class="user-profile"><div class="help-holder"><a target="_blank" href="https://bovicom.atlassian.net/servicedesk/customer/portal/3" class="ion-help help defaultModal"></a></div><div class="help-holder"><a target="_blank" href="https://bovicom.atlassian.net/wiki/spaces/SPARV4/pages" class="fa fa-book defaultModal" style="font-size:24px;"></a></div><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><img lazy-img="{{vm.userImage}}" lazy-img-error="assets/img/app/profile/Avatar.png" src="assets/img/app/profile/Avatar.png"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu="" id="itemsList"><li><i class="dropdown-arr"></i></li><li><a href="" ng-click="vm.redirect(\'settings\')"><i class="fa fa-cog primaryModal"></i><data-i18n i18n="_menu_settings_">settings</data-i18n></a></li><li><a href="" class="signout" ng-click="vm.logout()"><i class="fa fa-power-off primaryModal"></i><data-i18n i18n="_menu_log_out_">log out</data-i18n></a></li></ul></div><msg-center></msg-center></div></div>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/pages/calendar/feedingTable/tables/dropping.table.html','<div ng-init="mainTableDisplayed = true" class="calendar-table-section"><div class="calendar-table-heading" ng-click="mainTableDisplayed = !mainTableDisplayed"><span class="calendar-feeding-status" uib-tooltip="{{ft.feedingTableData.dropping_status === 1 ? (\'_m_f_calendar_report_in_progress_\' | i18n) : ft.feedingTableData.dropping_status === 2 ? (\'_m_f_calendar_report_done_\' | i18n) : (\'_m_f_calendar_report_to_do_\' | i18n)}}" tooltip-is-open="droppingStatusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="feeding-status-icon" ng-class="ft.feedingTableData.dropping_status === 1 ? \'feeding-status-in-progress\' : ft.feedingTableData.dropping_status === 2 ? \'feeding-status-done\' : \'feeding-status-to-do\'"></i></span> <span class="calendar-table-heading-name"><i class="fa" ng-class="mainTableDisplayed ? \'fa-caret-up\' : \'fa-caret-down\'"></i>{{ft.feedingTableData.feeding_name}}&nbsp;({{\'_m_f_menu_reports_dropping_\' | i18n}})<i class="fa" ng-class="mainTableDisplayed ? \'fa-caret-up\' : \'fa-caret-down\'"></i></span> <span class="action-buttons"></span></div><div class="calendar-table-main" ng-show="mainTableDisplayed"><div class="calendar-table-info"><label><data i18n="_m_f_calendar_dropping_time_">Dropping time</data>:</label>&nbsp;<span ng-if="!ft.feedingTableData.dropping_date_changed">{{(ft.feedingTableData.dropping_start | date: \'hh:mm a\') || (\'_m_f_calendar_not_available_label_\' | i18n)}} - {{(ft.feedingTableData.dropping_finish | date: \'hh:mm a\') || (\'_m_f_calendar_not_available_label_\' | i18n)}}</span><span ng-if="ft.feedingTableData.dropping_date_changed">{{(ft.feedingTableData.dropping_start | date: ft.dateFormat) || (\'_m_f_calendar_not_available_label_\' | i18n)}} - {{(ft.feedingTableData.dropping_finish | date: ft.dateFormat) || (\'_m_f_calendar_not_available_label_\' | i18n)}}</span>&nbsp;, <label><data i18n="_m_f_calendar_duration_">Duration</data>:</label>&nbsp; <span>{{(ft.feedingTableData.dropping_duration) || (\'_m_f_calendar_not_available_label_\' | i18n)}}</span> <span ng-if="ft.feedingTableData.dropping_duration"></span><br><label><data i18n="_m_f_reports_feeder_">Feeder</data>:</label>&nbsp;<span ng-if="ft.feedingTableData.dropping_feeders.length > 0" ng-repeat="feeder in ft.feedingTableData.dropping_feeders">{{feeder}},&nbsp;</span><span ng-if="ft.feedingTableData.dropping_feeders.length === 0"><data i18n="_m_f_calendar_not_available_label_">N/A</data>,&nbsp;</span><label><data i18n="_m_f_reports_deviation_">Deviation</data>:</label>&nbsp;{{ft.feedingTableData.summary.dropping_total_deviation_percentage | number: 0}}&nbsp;%<div ng-if="ft.feedingTableData.exception_amount"><label><data-i18n i18n="_m_f_calendar_feeding_interval_change_">Feeding interval change</data-i18n>:&nbsp;</label><span>{{ft.feedingTableData.feeding_interval_change | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.feedingTableData.exception_unit}}</span>, <label><data-i18n i18n="_m_f_calendar_original_weight_">Original weight</data-i18n>:&nbsp;</label><span>{{ft.feedingTableData.original_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</span>, <label><data-i18n i18n="_m_f_calendar_changed_interval_weight_">Changed interval weight</data-i18n>:&nbsp;</label><span>{{ft.feedingTableData.exception_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</span></div><br ng-if="!ft.feedingTableData.exception_amount"><label ng-if="::ft.checkRationOrigin(ft.feedingTableData.ration) === \'ration\'"><data i18n="_m_f_calendar_feeding_selected_ration_">Selected ration</data>:</label> <label ng-if="::ft.checkRationOrigin(ft.feedingTableData.ration) === \'ration_premix\'"><data i18n="_m_f_calendar_feeding_selected_mix_">Selected mix</data>:</label> &nbsp;{{ft.feedingTableData.ration.ration_name}}<br></div><div class="row horizontal-scroll"><div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><table class="table pens-table"><thead><tr><th></th><th><data i18n="_m_f_pen_">Pen name</data></th><th><data i18n="_m_f_reports_calculated_weight_">Calculated weight</data></th><th><data i18n="_m_f_reports_dropped_weight_">Dropped weight</data></th><th><data i18n="_m_f_reports_deviation_">Deviation</data></th><th ng-show="!ft.showCost" colspan="2"></th><th ng-show="ft.showCost"><data i18n="_m_f_calendar_calculated_cost_label_">Calculated cost</data></th><th ng-show="ft.showCost"><data i18n="_m_f_calendar_actual_cost_label_">Actual cost</data></th><th><data i18n="_title_column_action_">Action</data></th></tr></thead><tbody><tr ng-repeat-start="(penIndex, pen) in ft.feedingTableData.pen_feedings"><td style="width: 10%"></td><td style="width: 20%" ng-click="ft.selectPenRow(pen)" class="shorten-long-text"><span class="expand-arrow"><i class="fa" ng-class="pen.expanded ? \'fa-caret-up\' : \'fa-caret-down\'"></i><span class="calendar-has-warning" ng-class="pen.has_dropping_conflict ? \'calendar-display-warning\' : \'calendar-disable-warning\'" uib-popover="{{\'_m_f_calendar_pen_conflict_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="bottom">{{pen.pen_name}}&nbsp;<i ng-show="pen.has_dropping_conflict" class="fa fa-info-circle"></i></span></span></td><td style="width: 10%">{{pen.feeding_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</td><td style="width: 10%"><b>{{pen.actual_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</b></td><td style="width: 15%"><span class="calendar-has-warning" ng-class="pen.deviation_warn ? \'calendar-display-warning\' : \'calendar-disable-warning\'" uib-popover="{{\'_m_f_calendar_deviation_warning_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{pen.deviation_percentage | number: 0}}&nbsp;%&nbsp;<i ng-show="pen.deviation_warn" class="fa fa-info-circle"></i></span></td><td ng-show="!ft.showCost" style="width: 15%"></td><td ng-show="!ft.showCost" style="width: 10%"></td><td ng-show="ft.showCost" style="width: 15%">{{ft.currency}}{{pen.pen_calculated_cost | number: 0}}</td><td ng-show="ft.showCost" style="width: 10%">{{ft.currency}}{{pen.pen_actual_cost | number: 0}}</td><td style="width: 10%" class="action-cell"><button class="btn btn-primary btn-xs" ng-click="ft.openAddDataModal(\'dropping\', pen)" uib-tooltip="{{\'_m_f_calendar_add_missing_load_tooltip_\' | i18n}}" tooltip-is-open="addLoadIsOpen_{{loadIndex}}" tooltip-placement="left" tooltip-class="customBlue left tooltip-opaque" tooltip-popup-delay="500"><i class="fa fa-plus"></i></button> <button class="btn btn-primary btn-xs" ng-click="ft.goToPage(\'pens.editPen\', pen.pen_id, $event)" ng-disabled="!pen.visible"><i class="fa fa-pencil" uib-tooltip="{{pen.visible ? (\'_m_f_calendar_edit_pen_tooltip_\' | i18n) : !pen.visible ? (\'_m_f_calendar_edit_pen_disabled_\' | i18n) : \'\'}}" tooltip-is-open="editPenIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"></i></button></td></tr><tr class="feedLightGrey" ng-show="pen.expanded"><td><data i18n="_m_f_reports_drop_status_">Drop status</data></td><td colspan="2"><data i18n="_m_f_reports_dropped_from_">Dropped from</data></td><td><data i18n="_m_f_reports_dropped_weight_">Dropped weight</data></td><td><data i18n="_m_f_calendar_dropping_time_">Dropping time</data></td><td ng-show="!ft.showCost"><data i18n="_m_f_reports_feeder_">Feeder</data></td><td ng-show="ft.showCost"></td><td ng-show="!ft.showCost"><data i18n="_m_f_menu_configurations_equipment_">Mixer wagon</data></td><td ng-show="ft.showCost"><data i18n="_m_f_calendar_actual_cost_label_">Actual cost</data></td><td><data i18n="_title_column_action_">Action</data></td></tr><tr ng-if="pen.loads && pen.loads.length > 0" class="feedLightGrey" ng-repeat-start="(loadIndex, load) in pen.loads" ng-show="pen.expanded"><td ng-show="!load.conflicts" class="load-status"><i class="feeding-status-icon" uib-tooltip="{{load.status === 1 ? (\'_m_f_calendar_report_in_progress_\' | i18n) : load.status === 2 ? (\'_m_f_calendar_report_done_\' | i18n) : (\'_m_f_calendar_report_to_do_\' | i18n)}}" tooltip-is-open="loadStatusIsOpen_{{loadIndex}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-class="load.status === 1 ? \'feeding-status-in-progress\' : load.status === 2 ? \'feeding-status-done\' : \'feeding-status-to-do\'"></i></td><td ng-show="load.conflicts"></td><td ng-click="ft.selectUnloadRow(pen, load)" colspan="2"><span class="expand-arrow"><i ng-show="load.conflicts" class="fa" ng-class="load.expanded ? \'fa-caret-up\' : \'fa-caret-down\'"></i>{{load.load_name}}</span></td><td colspan="5" ng-show="load.conflicts"></td><td ng-show="!load.conflicts"><span editable-number="load.actual_loaded" e-format-input-value="amount" e-min="0" required="" onbeforesave="ft.updateUnload(pen, load, $data, $index, \'actual_loaded\')" e-style="width: 100px"><b>{{load.actual_loaded | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</b></span></td><td ng-show="!load.conflicts"><span class="calendar-datetime-picker" ng-click="ft.changeDroppingTime(pen, load)"><span ng-if="load.feeding_date_changed"><span class="calendar-has-warning calendar-display-warning" uib-popover-template="\'app/pages/calendar/feedingTable/amountChanged.popover.html\'" popover-append-to-body="true" popover-trigger="mouseenter" ng-mouseover="ft.openChangePopover($event, load.unloading_start, \'drop-date\')" popover-placement="bottom">{{(load.unloading_start | date: \'hh:mm a\') || (\'_m_f_calendar_not_available_label_\' | i18n)}} - {{(load.unloading_finish | date: \'hh:mm a\') || (\'_m_f_calendar_not_available_label_\' | i18n)}}&nbsp;<i ng-show="load.feeding_date_changed" class="fa fa-info-circle"></i></span></span> <span ng-if="!load.feeding_date_changed">{{(load.unloading_start | date: \'hh:mm a\') || (\'_m_f_calendar_not_available_label_\' | i18n)}} - {{(load.unloading_finish | date: \'hh:mm a\') || (\'_m_f_calendar_not_available_label_\' | i18n)}}</span></span></td><td ng-show="!load.conflicts && !ft.showCost">{{load.feeder || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td ng-show="!load.conflicts && ft.showCost"></td><td class="shorten-long-text" uib-tooltip="{{load.mixer_wagon.name}}" tooltip-enable="{{load.mixer_wagon.name.length > 30 ? true : false}}" tooltip-placement="left" tooltip-class="customBlue left wrap-text" ng-show="!load.conflicts && !ft.showCost">{{load.mixer_wagon.name || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td ng-show="!load.conflicts && ft.showCost">{{ft.currency}}{{load.drop_actual_cost | number: 0}}</td><td ng-show="!load.conflicts" class="action-cell"><button class="btn btn-danger btn-xs" ng-click="ft.updateUnload(pen, load, null, penIndex, \'remove_unload\')" uib-tooltip="{{\'_m_f_calendar_remove_pen_load_\' | i18n}}" tooltip-is-open="removeIngredientIsOpen_{{loadIndex}}_{{ingrIndex}}" tooltip-placement="left" tooltip-class="customBlue left tooltip-opaque" tooltip-popup-delay="500"><i class="fa fa-trash"></i></button></td></tr><tr class="conflicted-ingredient-row" ng-if="load.conflicts" ng-repeat-start="conflict in load.conflicts" ng-show="load.expanded"><td class="load-status"><i class="feeding-status-icon" uib-tooltip="{{conflict.status === 1 ? (\'_m_f_calendar_report_in_progress_\' | i18n) : conflict.status === 2 ? (\'_m_f_calendar_report_done_\' | i18n) : (\'_m_f_calendar_report_to_do_\' | i18n)}}" tooltip-is-open="conflictStatusIsOpen_{{loadIndex}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-class="conflict.status === 1 ? \'feeding-status-in-progress\' : conflict.status === 2 ? \'feeding-status-done\' : \'feeding-status-to-do\'"></i></td><td colspan="2">{{conflict.load_name}}</td><td><span editable-number="conflict.actual_loaded" e-format-input-value="amount" e-min="0" required="" onbeforesave="ft.updateUnload(pen, conflict, $data, $index, \'actual_loaded\')" e-style="width: 100px"><b>{{conflict.actual_loaded | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</b></span></td><td><span class="calendar-datetime-picker" ng-click="ft.changeDroppingTime(pen, conflict)"><span ng-if="conflict.feeding_date_changed"><span class="calendar-has-warning calendar-display-warning" uib-popover-template="\'app/pages/calendar/feedingTable/amountChanged.popover.html\'" popover-append-to-body="true" popover-trigger="mouseenter" ng-mouseover="ft.openChangePopover($event, conflict.unloading_start, \'drop-date\')" popover-placement="bottom">{{(conflict.unloading_start | date: \'hh:mm a\') || (\'_m_f_calendar_not_available_label_\' | i18n)}} - {{(conflict.unloading_finish | date: \'hh:mm a\') || (\'_m_f_calendar_not_available_label_\' | i18n)}}&nbsp;<i ng-show="conflict.feeding_date_changed" class="fa fa-info-circle"></i></span></span> <span ng-if="!conflict.feeding_date_changed">{{(conflict.unloading_start | date: \'hh:mm a\') || (\'_m_f_calendar_not_available_label_\' | i18n)}} - {{(conflict.unloading_finish | date: \'hh:mm a\') || (\'_m_f_calendar_not_available_label_\' | i18n)}}</span></span></td><td ng-show="!ft.showCost">{{conflict.feeder || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td ng-show="ft.showCost"></td><td class="shorten-long-text" uib-tooltip="{{conflict.mixer_wagon.name}}" tooltip-enable="{{conflict.mixer_wagon.name.length > 30 ? true : false}}" tooltip-placement="left" tooltip-class="customBlue left wrap-text" ng-show="!ft.showCost">{{conflict.mixer_wagon.name || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td ng-show="ft.showCost">{{ft.currency}}{{conflict.drop_actual_cost | number: 0}}</td><td class="action-cell"><button class="btn btn-danger btn-xs" ng-click="ft.updateUnload(pen, conflict, null, penIndex, \'remove_unload\', true)" uib-tooltip="{{\'_m_f_calendar_remove_pen_load_\' | i18n}}" tooltip-is-open="removeIngredientIsOpen_{{loadIndex}}_{{ingrIndex}}" tooltip-placement="left" tooltip-class="customBlue left tooltip-opaque" tooltip-popup-delay="500"><i class="fa fa-trash"></i></button></td></tr><tr ng-if="load.conflicts" ng-repeat-end=""></tr><tr ng-if="pen.loads && pen.loads.length > 0" ng-repeat-end=""></tr><tr class="feedLightGrey" ng-if="!pen.load_dropped_report || pen.load_dropped_report.length === 0" ng-show="pen.expanded"><td colspan="8"><data i18n="_m_f_calendar_not_available_label_">N/A</data></td></tr><tr ng-repeat-end=""></tr><tr><td></td><td ng-click="ft.selectSummary(\'unload_summary\', \'dropping_expanded\')"><span ng-show="ft.feedingTableData.summary.unload_summary.length > 0" class="expand-arrow"><i class="fa" ng-class="ft.feedingTableData.summary.dropping_expanded ? \'fa-caret-up\' : \'fa-caret-down\'"></i><data i18n="_m_f_label_summary_">Summary</data></span> <span ng-show="ft.feedingTableData.summary.unload_summary.length === 0"><data i18n="_m_f_label_summary_">Summary</data></span></td><td>{{ft.feedingTableData.summary.dropping_calculated_sum | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</td><td><b>{{ft.feedingTableData.summary.dropping_actual_sum | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</b></td><td>{{ft.feedingTableData.summary.dropping_total_deviation_percentage | number: 0}}&nbsp;%</td><td ng-show="!ft.showCost" colspan="3"></td><td ng-show="ft.showCost">{{ft.currency}}{{ft.feedingTableData.summary.dropping_calculated_cost | number: 0}}</td><td ng-show="ft.showCost">{{ft.currency}}{{ft.feedingTableData.summary.dropping_actual_cost | number: 0}}</td><td ng-show="ft.showCost"></td></tr><tr class="feedLightGrey" ng-repeat="(summaryIndex, summary) in ft.feedingTableData.summary.unload_summary" ng-show="ft.feedingTableData.summary.dropping_expanded"><td><i class="feeding-status-icon" uib-tooltip="{{summary.dropping_status === 1 ? (\'_m_f_calendar_report_in_progress_\' | i18n) : summary.dropping_status === 2 ? (\'_m_f_calendar_report_done_\' | i18n) : (\'_m_f_calendar_report_to_do_\' | i18n)}}" tooltip-is-open="summaryLoadStatusIsOpen_{{summaryIndex}}" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-class="summary.dropping_status === 1 ? \'feeding-status-in-progress\' : summary.dropping_status === 2 ? \'feeding-status-done\' : \'feeding-status-to-do\'"></i></td><td>{{summary.load_name}}</td><td><span class="calendar-has-warning" ng-class="summary.load_changed ? \'calendar-display-warning\' : \'calendar-disable-warning\'" uib-popover-template="\'app/pages/calendar/feedingTable/amountChanged.popover.html\'" popover-append-to-body="true" popover-trigger="mouseenter" ng-mouseover="ft.openChangePopover($event, summary.calculated_amount, \'load\')" popover-placement="right">{{summary.calculated | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}&nbsp;<i ng-show="summary.load_changed" class="fa fa-info-circle"></i></span></td><td>{{summary.actual | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</td><td><span class="calendar-has-warning" ng-class="summary.deviation_warning ? \'calendar-display-warning\' : \'calendar-disable-warning\'" uib-popover="{{\'_m_f_calendar_deviation_warning_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{summary.deviation | number: 0}}&nbsp;%&nbsp;<i ng-show="summary.deviation_warning" class="fa fa-info-circle"></i></span></td><td ng-show="!ft.showCost" colspan="3"></td><td ng-show="ft.showCost">{{ft.currency}}{{summary.dropped_load_calculated_cost | number: 0}}</td><td ng-show="ft.showCost">{{ft.currency}}{{summary.dropped_load_actual_cost | number: 0}}</td><td ng-show="ft.showCost"></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/calendar/feedingTable/tables/insertData.table.html','<div class="vertical-scroll"><table class="table calendar-missing-data-table" st-table="ft.missingData"><thead><tr class="sortable"><th></th><th><data-i18n i18n="_label_name_">Name</data-i18n><br></th><th ng-if="ft.modalType === \'loading\'"><data-i18n i18n="_m_f_reports_calculated_weight_">Calculated weight</data-i18n><br>{{ft.weight}}</th><th><data-i18n i18n="_m_f_reports_loaded_weight_">Loaded weight</data-i18n><br>{{ft.weight}}</th></tr></thead><tbody infinite-scroll="" scroll-fn="ft.paginationChanged()" scroll-no-all="ft.totalMissingItems" scroll-no-displayed="ft.missingData.length" scroll-disable="ft.disableScroll" ng-if="!ft.missingTableLoading"><tr ng-if="ft.modalType === \'loading\'" ng-repeat="data in ft.missingData"><td><span class="newCheck"><input type="checkbox" id="is_checked_{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="data.is_selected"> <label for="is_checked_{{$index}}"></label></span></td><td class="recipe-ration-name" uib-tooltip="{{data.feeding_name}}" tooltip-enable="{{data.feeding_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{data.feeding_name}}</td><td>{{data.calculated | formatViewValues: \'rounded_amount\'}}</td><td>{{data.actual | formatViewValues: \'rounded_amount\'}}</td></tr><tr ng-if="ft.modalType === \'dropping\'" ng-repeat="data in ft.missingData | orderBy: \'load_name\'"><td><span class="newCheck"><input type="checkbox" id="is_checked_{{$index}}" ng-true-value="true" ng-false-value="false" ng-model="data.is_selected" ng-disabled="data.loading_status != 2"> <label for="is_checked_{{$index}}"></label></span></td><td>{{data.load_name}}</td><td>{{data.actual_loaded | formatViewValues: \'rounded_amount\'}}</td></tr><tr ng-if="ft.disableScroll"><td colspan="4" align="center"><data-i18n i18n="_title_loading_">Loading...</data-i18n></td></tr></tbody><tbody style="overflow: hidden" ng-if="ft.missingTableLoading"><tr><td colspan="4" align="center"><div style="overflow: hidden"><div id="loading-animation-large"></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/calendar/feedingTable/tables/loading.table.html','<div ng-init="mainTableDisplayed = true" class="calendar-table-section"><div class="calendar-table-heading" ng-click="mainTableDisplayed = !mainTableDisplayed"><span class="calendar-feeding-status" uib-tooltip="{{ft.feedingTableData.loading_status === 1 ? (\'_m_f_calendar_report_in_progress_\' | i18n) : ft.feedingTableData.loading_status === 2 ? (\'_m_f_calendar_report_done_\' | i18n) : (\'_m_f_calendar_report_to_do_\' | i18n)}}" tooltip-is-open="loadingStatusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="feeding-status-icon" ng-class="ft.feedingTableData.loading_status === 1 ? \'feeding-status-in-progress\' : ft.feedingTableData.loading_status === 2 ? \'feeding-status-done\' : \'feeding-status-to-do\'"></i></span> <span class="calendar-table-heading-name"><i class="fa" ng-class="mainTableDisplayed ? \'fa-caret-up\' : \'fa-caret-down\'"></i>{{ft.feedingTableData.feeding_name}}&nbsp;({{\'_m_f_calendar_report_loading_\' | i18n}})<i class="fa" ng-class="mainTableDisplayed ? \'fa-caret-up\' : \'fa-caret-down\'"></i></span></div><div class="calendar-table-main" ng-show="mainTableDisplayed"><div class="calendar-table-info"><label><data i18n="_m_f_loading_time_">Feeding time</data>:</label>&nbsp;<span ng-show="!ft.feedingTableData.loading_date_changed">{{(ft.feedingTableData.loading_start | date: \'hh:mm a\') || (\'_m_f_calendar_not_available_label_\' | i18n)}} - {{(ft.feedingTableData.loading_finish | date: \'hh:mm a\') || (\'_m_f_calendar_not_available_label_\' | i18n)}}</span> <span ng-show="ft.feedingTableData.loading_date_changed">{{(ft.feedingTableData.loading_start | date: ft.dateFormat) || (\'_m_f_calendar_not_available_label_\' | i18n)}} - {{(ft.feedingTableData.loading_finish | date: ft.dateFormat) || (\'_m_f_calendar_not_available_label_\' | i18n)}}</span>, <span><label><data i18n="_m_f_calendar_duration_">Duration</data>:</label>&nbsp; {{(ft.feedingTableData.loading_duration) || (\'_m_f_calendar_not_available_label_\' | i18n)}}</span> <span ng-show="ft.feedingTableData.loading_duration"></span><br><label><data i18n="_m_f_reports_feeder_">Feeder</data>:</label>&nbsp;<span ng-show="ft.feedingTableData.loading_feeders.length > 0" ng-repeat="feeder in ft.feedingTableData.loading_feeders">{{feeder}},&nbsp;</span><span ng-show="ft.feedingTableData.loading_feeders.length === 0"><data i18n="_m_f_calendar_not_available_label_">N/A</data>,&nbsp;</span><label><data i18n="_m_f_reports_deviation_">Deviation</data>:</label>&nbsp;{{ft.feedingTableData.summary.loading_total_deviation_percentage | number: 0}}&nbsp;%<br><div ng-if="ft.feedingTableData.exception_amount"><label ng-if="ft.feedingTableData.feeding_interval_change"><data-i18n i18n="_m_f_calendar_feeding_interval_change_">Feeding interval change</data-i18n>:&nbsp;</label><span ng-if="ft.feedingTableData.feeding_interval_change">{{ft.feedingTableData.feeding_interval_change | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.feedingTableData.exception_unit}},</span> <label><data-i18n i18n="_m_f_calendar_original_weight_">Original weight</data-i18n>:&nbsp;</label><span>{{ft.feedingTableData.original_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</span>, <label ng-if="ft.feedingTableData.feeding_interval_change"><data-i18n i18n="_m_f_calendar_changed_interval_weight_">Changed interval weight</data-i18n>:&nbsp;</label> <label ng-if="!ft.feedingTableData.feeding_interval_change"><data-i18n i18n="_m_f_wagons_weight_">weight</data-i18n>:&nbsp;</label> <span>{{ft.feedingTableData.exception_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</span></div><label ng-if="::ft.checkRationOrigin(ft.feedingTableData.ration) === \'ration\'"><data i18n="_m_f_calendar_feeding_selected_ration_">Selected ration</data>:</label> <label ng-if="::ft.checkRationOrigin(ft.feedingTableData.ration) === \'ration_premix\'"><data i18n="_m_f_calendar_feeding_selected_mix_">Selected mix</data>:</label> &nbsp;{{ft.feedingTableData.ration.ration_name || ft.feedingTableData.ration.premix_name}}<br></div><div class="row horizontal-scroll" ng-if="ft.feedingTableData.is_premix !== true"><div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><table class="table"><thead><tr><th><data i18n="_m_f_pen_">Pen name</data></th><th><data i18n="_m_f_pen_number_of_animals_">N\xB0 of animals</data></th><th><data i18n="_m_f_loading_amount_">Amount</data></th><th ng-show="ft.showCost"><data i18n="_m_f_calendar_calculated_cost_label_">Calculated cost</data></th><th><data i18n="_title_column_action_">Action</data></th></tr></thead><tbody><tr ng-repeat="pen in ft.feedingTableData.pen_feedings | orderBy: \'pen_id\'"><td ng-style="ft.showCost ? {\'width\': \'30%\'} : {\'width\': \'40%\'}"><span class="calendar-has-warning" ng-class="pen.updated_from_app ? \'calendar-display-warning\' : \'calendar-disable-warning\'" uib-popover="{{\'_m_f_calendar_pen_changed_\' | i18n }}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{pen.pen.pen_name }}&nbsp;<i ng-show="pen.updated_from_app" class="fa fa-info-circle"></i></span></td><td style="width: 20%">{{pen.number_of_animals}}</td><td style="width: 20%">{{pen.feeding_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</td><td ng-show="ft.showCost" style="width: 10%">{{ft.currency}}{{pen.pen_calculated_cost | number: 0}}</td><td style="width: 20%" class="action-cell"><button class="btn btn-primary btn-xs" ng-click="ft.goToPage(\'pens.editPen\', pen.pen_id, $event)" ng-disabled="!pen.pen.visible"><i class="fa fa-pencil" uib-tooltip="{{pen.pen.visible ? (\'_m_f_calendar_edit_pen_tooltip_\' | i18n) : !pen.pen.visible ? (\'_m_f_calendar_edit_pen_disabled_\' | i18n) : \'\'}}" tooltip-is-open="editPenIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"></i></button></td></tr></tbody></table></div></div><div class="row horizontal-scroll"><div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><table class="table loads-table"><thead><tr><th><data i18n="_m_f_reports_loading_status_">Status</data></th><th><data i18n="_m_f_recipe_loads_">Loads</data></th><th><data i18n="_m_f_reports_calculated_weight_">Calculated weight</data></th><th><data i18n="_m_f_reports_loaded_weight_">Loaded weight</data></th><th><data i18n="_m_f_reports_deviation_">Deviation</data></th><th ng-show="ft.showCost"><data i18n="_m_f_calendar_calculated_cost_label_">Calculated cost</data></th><th ng-show="ft.showCost"><data i18n="_m_f_calendar_actual_cost_label_">Actual cost</data></th><th><data i18n="_m_f_loading_time_">Loading time</data></th><th><data i18n="_m_f_reports_feeder_">Feeder</data></th><th><data i18n="_m_f_menu_configurations_equipment_">Mixer wagon</data></th><th><data i18n="_title_column_action_">Action</data></th></tr></thead><tbody><tr ng-repeat-start="(loadIndex, load) in ft.feedingTableData.feeding_loads" ng-hide="load.visible === false"><td ng-style="ft.showCost ? {\'width\': \'7.5%\'} : {\'width\': \'10%\'}" class="load-status"><i class="feeding-status-icon" uib-tooltip="{{load.loading_status === 1 ? (\'_m_f_calendar_report_in_progress_\' | i18n) : load.loading_status === 2 ? (\'_m_f_calendar_report_done_\' | i18n) : (\'_m_f_calendar_report_to_do_\' | i18n)}}" tooltip-is-open="loadStatusIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-opaque" tooltip-popup-delay="500" ng-class="load.loading_status === 1 ? \'feeding-status-in-progress\' : load.loading_status === 2 ? \'feeding-status-done\' : \'feeding-status-to-do\'"></i></td><td ng-style="ft.showCost ? {\'width\': \'15%\'} : {\'width\': \'20%\'}" ng-click="ft.selectLoadRow(load)"><span class="expand-arrow"><i class="fa" ng-class="load.expanded ? \'fa-caret-up\' : \'fa-caret-down\'"></i><span class="calendar-has-warning" ng-class="load.has_loading_conflict || load.has_conflict ? \'calendar-display-warning\' : \'calendar-disable-warning\'" uib-popover="{{\'_m_f_calendar_load_conflict_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{load.load_name}}&nbsp;<i ng-show="load.has_loading_conflict || load.has_conflict" class="fa fa-info-circle"></i></span></span></td><td style="width: 10%;"><span class="calendar-has-warning" ng-class="load.load_changed ? \'calendar-display-warning\' : \'calendar-disable-warning\'" uib-popover-template="\'app/pages/calendar/feedingTable/amountChanged.popover.html\'" popover-append-to-body="true" popover-trigger="mouseenter" ng-mouseover="ft.openChangePopover($event, load.calculated_amount, \'load\')" popover-placement="right">{{load.amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}&nbsp;<i ng-show="load.load_changed" class="fa fa-info-circle"></i></span></td><td style="width: 10%;"><b>{{load.actual_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</b></td><td style="width: 10%;"><span class="calendar-has-warning" ng-class="load.deviation_warn ? \'calendar-display-warning\' : \'calendar-disable-warning\'" uib-popover="{{load.deviation_warn_text}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{load.loading_deviation_percentage | number: 0}}&nbsp;%&nbsp;<i ng-show="load.deviation_warn" class="fa fa-info-circle"></i></span></td><td style="width: 10%" ng-show="ft.showCost">{{ft.currency}}{{load.load_calculated_cost| number: 0}}</td><td style="width: 10%" ng-show="ft.showCost">{{ft.currency}}{{load.load_actual_cost | number: 0}}</td><td style="width: 10%"><span class="calendar-datetime-picker" ng-click="ft.changeLoadingTime(load)"><span ng-if="load.feeding_date_changed"><span class="calendar-has-warning calendar-display-warning" uib-popover-template="\'app/pages/calendar/feedingTable/amountChanged.popover.html\'" popover-append-to-body="true" popover-trigger="mouseenter" ng-mouseover="ft.openChangePopover($event, load.loading_start, \'load-date\')" popover-placement="right">{{(load.loading_start | date: \'hh:mm a\') || (\'_m_f_calendar_not_available_label_\' | i18n)}} - {{(load.loading_finish | date: \'hh:mm a\') || (\'_m_f_calendar_not_available_label_\' | i18n)}}&nbsp;<i ng-show="load.feeding_date_changed" class="fa fa-info-circle"></i></span></span> <span ng-if="!load.feeding_date_changed">{{(load.loading_start | date: \'hh:mm a\') || (\'_m_f_calendar_not_available_label_\' | i18n)}} - {{(load.loading_finish | date: \'hh:mm a\') || (\'_m_f_calendar_not_available_label_\' | i18n)}}</span></span></td><td style="width: 10%">{{load.feeder || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td class="shorten-long-text" uib-tooltip="{{load.mixer_wagon.name}}" tooltip-enable="{{load.mixer_wagon.name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text" style="width: 10%">{{load.mixer_wagon.name}}</td><td ng-style="ft.showCost ? {\'width\': \'7.5%\'} : {\'width\': \'10%\'}" class="action-cell"><button class="btn btn-primary btn-xs" ng-click="ft.openAddDataModal(\'loading\', load)" uib-tooltip="{{\'_m_f_calendar_add_ingredient_tooltip_\' | i18n}}" tooltip-is-open="addIngredientIsOpen_{{loadIndex}}" tooltip-placement="left" tooltip-class="customBlue left tooltip-opaque" tooltip-popup-delay="500"><i class="fa fa-plus"></i></button> <button class="btn btn-danger btn-xs" ng-click="ft.updateLoadReport(load, null, $index, \'remove_load_report\')" ng-show="load.has_conflict" uib-tooltip="{{\'_m_f_calendar_remove_load_tooltip_\' | i18n}}" tooltip-is-open="removeLoadIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><i class="fa fa-trash"></i></button></td></tr><tr class="feedLightGrey" ng-repeat-start="(ingrIndex, ing) in load.ingredients | orderBy: \'order_number\'" ng-if="load.ingredients.length > 0" ng-show="load.expanded"><td><span class="calendar-has-warning" ng-class="ing.order_changed ? \'calendar-display-warning\' : \'calendar-disable-warning\'" uib-popover="{{\'_m_f_calendar_loading_order_changed_\' | i18n }}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right"><i ng-show="ing.order_changed" class="fa fa-info-circle"></i></span></td><td ng-click="ft.selectIngredientRow(load, ing)" class="shorten-long-text" uib-tooltip="{{ing.feeding_name}}" tooltip-enable="{{ing.feeding_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span class="expand-arrow"><i ng-show="ing.conflicts" class="fa" ng-class="ing.expanded ? \'fa-caret-up\' : \'fa-caret-down\'"></i>{{ing.feeding_name}}</span></td><td ng-show="ing.conflicts" colspan="10"></td><td ng-show="!ing.conflicts">{{ing.calculated | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</td><td ng-show="!ing.conflicts"><span editable-number="ing.actual" e-format-input-value="rounded_amount" e-min="0" required="" onbeforesave="ft.updateIngredient(load, ing, $data, $index, \'actual\')" e-style="width: 200px"><b>{{ing.actual | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</b></span></td><td ng-show="!ing.conflicts" ng-class="{ \'warningModal\': ing.deviation_warn}">{{ing.deviation_percentage | number: 0}}&nbsp;%</td><td ng-show="!ing.conflicts && ft.showCost">{{ft.currency}}{{ing.ingredient_calculated_cost | number: 0}}</td><td ng-show="!ing.conflicts && ft.showCost">{{ft.currency}}{{ing.ingredient_actual_cost | number: 0}}</td><td ng-show="!ing.conflicts" colspan="4"></td><td ng-show="!ing.conflicts" class="action-cell"><button class="btn btn-danger btn-xs" ng-click="ft.updateIngredient(load, ing, null, ingrIndex, \'remove_ingredient\')" uib-tooltip="{{\'_m_f_calendar_remove_ingredient_tooltip_\' | i18n}}" tooltip-is-open="removeIngredientIsOpen_{{loadIndex}}_{{ingrIndex}}" tooltip-placement="left" tooltip-class="customBlue left tooltip-opaque" tooltip-popup-delay="500"><i class="fa fa-trash"></i></button></td></tr><tr class="conflicted-ingredient-row" ng-if="ing.conflicts" ng-repeat-start="conflict in ing.conflicts | orderBy: \'id\'" ng-show="ing.expanded"><td></td><td class="shorten-long-text" uib-tooltip="{{conflict.feeding_name}}" tooltip-enable="{{conflict.feeding_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span>{{conflict.feeding_name}}</span></td><td>{{conflict.calculated | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</td><td><span editable-number="conflict.actual" e-format-input-value="rounded_amount" e-min="0" required="" onbeforesave="ft.updateIngredient(load, conflict, $data, $index, \'actual\')" e-style="width: 200px"><b>{{conflict.actual | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</b></span></td><td ng-class="{ \'warningModal\': conflict.deviation_warn}">{{conflict.deviation_percentage | number: 0}}&nbsp;%</td><td ng-show="ft.showCost">{{ft.currency}}{{conflict.ingredient_calculated_cost | number: 0}}</td><td ng-show="ft.showCost">{{ft.currency}}{{conflict.ingredient_actual_cost | number: 0}}</td><td colspan="4"></td><td class="action-cell"><button class="btn btn-danger btn-xs" ng-click="ft.updateIngredient(load, conflict, null, ingrIndex, \'remove_ingredient\', true)" uib-tooltip="{{\'_m_f_calendar_remove_ingredient_tooltip_\' | i18n}}" tooltip-is-open="removeIngredientIsOpen_{{loadIndex}}_{{ingrIndex}}" tooltip-placement="left" tooltip-class="customBlue left tooltip-opaque" tooltip-popup-delay="500"><i class="fa fa-trash"></i></button></td></tr><tr ng-if="ing.conflicts" ng-repeat-end=""></tr><tr ng-if="load.ingredients.length > 0" ng-repeat-end=""></tr><tr ng-if="load.ingredients.length === 0" ng-show="load.expanded"><td colspan="15"><data i18n="_m_f_calendar_not_available_label_">N/A</data></td></tr><tr ng-repeat-end=""></tr><tr><td></td><td ng-click="ft.selectSummary(\'ingredient_summary\', \'loading_expanded\')"><span ng-show="ft.feedingTableData.summary.ingredient_summary.length > 0" class="expand-arrow"><i class="fa" ng-class="ft.feedingTableData.summary.loading_expanded ? \'fa-caret-up\' : \'fa-caret-down\'"></i><data i18n="_m_f_label_summary_">Summary</data></span> <span ng-show="ft.feedingTableData.summary.ingredient_summary.length === 0"><data i18n="_m_f_label_summary_">Summary</data></span></td><td>{{ft.feedingTableData.summary.loading_calculated_sum | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</td><td><b>{{ft.feedingTableData.summary.loading_actual_sum | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</b></td><td><span class="calendar-has-warning" ng-class="ft.feedingTableData.summary.loading_total_deviation_warn ? \'calendar-display-warning\' : \'calendar-disable-warning\'" uib-popover="{{\'_m_f_calendar_deviation_warning_\' | i18n}}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{ft.feedingTableData.summary.loading_total_deviation_percentage | number: 0}}&nbsp;%&nbsp;<i ng-show="ft.feedingTableData.summary.loading_total_deviation_warn" class="fa fa-info-circle"></i></span></td><td ng-show="ft.showCost">{{ft.currency}}{{ft.feedingTableData.summary.loading_calculated_cost| number: 0}}</td><td ng-show="ft.showCost">{{ft.currency}}{{ft.feedingTableData.summary.loading_actual_cost | number: 0}}</td><td colspan="8"></td></tr><tr class="feedLightGrey" ng-repeat="(summaryIndex, summary) in ft.feedingTableData.summary.ingredient_summary" ng-show="ft.feedingTableData.summary.loading_expanded"><td></td><td class="shorten-long-text" uib-tooltip="{{summary.feeding_name}}" tooltip-enable="{{summary.feeding_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{summary.feeding_name}}</td><td>{{summary.calculated | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</td><td>{{summary.actual | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</td><td ng-class="summary.deviation_warning ? \'warningModal\' : \'\'">{{summary.deviation_percentage | number: 0}}&nbsp;%</td><td ng-show="ft.showCost">{{ft.currency}}{{summary.ingredient_calculated_cost | number: 0}}</td><td ng-show="ft.showCost">{{ft.currency}}{{summary.ingredient_actual_cost | number: 0}}</td><td colspan="6"></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/calendar/feedingTable/tables/planning.table.html','<div ng-init="mainTableDisplayed = true; ft.prop = \'planning\' + ft.feedingTableData.feeding_number" class="calendar-table-section"><div class="calendar-table-heading" ng-click="mainTableDisplayed = !mainTableDisplayed"><span></span> <span class="calendar-table-heading-name"><i class="fa" ng-class="mainTableDisplayed ? \'fa-caret-up\' : \'fa-caret-down\'"></i>{{ft.feedingTableData.feeding_name}}&nbsp;({{\'_m_f_calendar_planning_heading_\' | i18n}})<i class="fa" ng-class="mainTableDisplayed ? \'fa-caret-up\' : \'fa-caret-down\'"></i></span> <span class="action-buttons"></span></div><div class="calendar-table-main" ng-show="mainTableDisplayed"><div class="calendar-table-info"><div ng-if="ft.feedingTableData.exception_amount"><label ng-if="ft.feedingTableData.feeding_interval_change"><data-i18n i18n="_m_f_calendar_feeding_interval_change_">Feeding interval change</data-i18n>:&nbsp;</label><span ng-if="ft.feedingTableData.feeding_interval_change">{{ft.feedingTableData.feeding_interval_change | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.feedingTableData.exception_unit}},</span> <label><data-i18n i18n="_m_f_calendar_original_weight_">Original weight</data-i18n>:&nbsp;</label> <span>{{ft.feedingTableData.original_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</span>, <label ng-if="ft.feedingTableData.feeding_interval_change"><data-i18n i18n="_m_f_calendar_changed_interval_weight_">Changed interval weight</data-i18n>:&nbsp;</label> <label ng-if="!ft.feedingTableData.feeding_interval_change"><data-i18n i18n="_m_f_wagons_weight_">weight</data-i18n>:&nbsp;</label> <span>{{ft.feedingTableData.exception_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</span></div><label ng-if="::ft.checkRationOrigin(ft.feedingTableData.ration) === \'ration\'"><data i18n="_m_f_calendar_feeding_selected_ration_">Selected ration</data>:</label> <label ng-if="::ft.checkRationOrigin(ft.feedingTableData.ration) === \'ration_premix\'"><data i18n="_m_f_calendar_feeding_selected_mix_">Selected mix</data>:</label> &nbsp;{{ft.feedingTableData.ration.ration_name || ft.feedingTableData.ration.premix_name}}<br></div><div class="row" ng-if="ft.feedingTableData.is_premix !== true"><div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><table class="table"><thead><tr><th class="action-cell"></th><th><data i18n="_m_f_pen_">Pen name</data></th><th><data i18n="_m_f_pen_number_of_animals_">N\xB0 of animals</data></th><th><data i18n="_m_f_loading_amount_">Amount</data></th><th><data i18n="_title_column_action_">Action</data></th></tr></thead><tbody><tr ng-repeat="pen in ft.feedingTableData.pen_feedings | orderBy: \'pen_id\'"><td style="width: 10%"></td><td style="width: 30%"><span class="calendar-has-warning" ng-class="pen.updated_from_app ? \'calendar-display-warning\' : \'calendar-disable-warning\'" uib-popover="{{\'_m_f_calendar_pen_changed_\' | i18n }}" popover-append-to-body="true" popover-trigger="mouseenter" popover-placement="right">{{pen.pen.pen_name }}&nbsp;<i ng-show="pen.updated_from_app" class="fa fa-info-circle"></i></span></td><td style="width: 20%">{{pen.number_of_animals}}</td><td style="width: 20%"><span edit-disabled="true" editable-number="pen.feeding_amount" e-format-input-value="amount" required="" onbeforesave="ft.updatePen(pen, $data, $index, \'feeding_amount\')" e-style="width: 200px">{{pen.feeding_amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</span></td><td style="width: 20%" class="action-cell"><button class="btn btn-primary btn-xs" ng-click="ft.goToPage(\'pens.editPen\', pen.pen_id, $event)" ng-disabled="!pen.pen.visible"><i class="fa fa-pencil" uib-tooltip="{{pen.pen.visible ? (\'_m_f_calendar_edit_pen_tooltip_\' | i18n) : !pen.pen.visible ? (\'_m_f_calendar_edit_pen_disabled_\' | i18n) : \'\'}}" tooltip-is-open="editPenIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"></i></button></td></tr></tbody></table></div></div><div class="row"><div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><table class="table loads-table"><thead><tr><th></th><th><data i18n="_m_f_recipe_loads_">Loads</data></th><th><data i18n="_m_f_loading_amount_">Amount</data></th><th><data i18n="_m_f_menu_configurations_equipment_">Mixer wagon</data></th><th></th></tr></thead><tbody><tr ng-repeat-start="(loadIndex, load) in ft.feedingTableData.feeding_loads"><td style="width: 10%"></td><td style="width: 30%" ng-click="ft.selectLoad(load)"><span class="expand-arrow"><i class="fa" ng-class="load.expanded ? \'fa-caret-up\' : \'fa-caret-down\'"></i>{{load.load_name}}</span></td><td style="width: 20%"><span class="calendar-has-warning" ng-class="load.load_changed ? \'calendar-display-warning\' : \'calendar-disable-warning\'" edit-disabled="true" editable-number="load.amount" e-format-input-value="amount" e-min="0" e-max="{{load.wagon.value}}" e-step="0.01" required="" onbeforesave="ft.updateLoad(load, $data, $index, \'amount\')" e-style="width: 120px" uib-popover-template="\'app/pages/calendar/feedingTable/amountChanged.popover.html\'" popover-append-to-body="true" popover-trigger="mouseenter" ng-mouseover="ft.openChangePopover($event, load.calculated_amount, \'load\')" popover-placement="right">{{load.amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}&nbsp;<i ng-show="load.load_changed" class="fa fa-info-circle"></i></span></td><td style="width: 20%" class="shorten-long-text" uib-tooltip="{{load.mixer_wagon.name}}" tooltip-enable="{{load.mixer_wagon.name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{load.mixer_wagon.name}}</td><td style="width: 20%" class="action-cell"></td></tr><tr class="feedLightGrey" ng-repeat-start="ing in load.planning_ingredients" ng-show="load.expanded" ng-if="ing.amount"><td></td><td class="shorten-long-text" uib-tooltip="{{ing.name}}" tooltip-enable="{{ing.name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{ing.name}}</td><td>{{ing.amount | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</td><td></td><td></td><td></td></tr><tr ng-repeat-end=""></tr><tr ng-repeat-end=""></tr><tr><td></td><td><span><data i18n="_m_f_label_summary_">Summary</data>:</span></td><td>{{ft.feedingTableData.planing_amount_sum | formatViewValues: \'rounded_amount\'}}&nbsp;{{ft.weight}}</td><td></td><td></td><td></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryCarb/feedHistory.carb.US.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_nfc_\' | i18n}}" tooltip-is-open="nfcIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_">NFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_nfc_dig_\' | i18n}}" tooltip-is-open="nfcDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_digestibility_">NFC dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_nfc_">NFC</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_infa_\' | i18n}}" tooltip-is-open="infaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_infa_">infa</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_sol_fiber_\' | i18n}}" tooltip-is-open="solFiberIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_" dm=""></data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_rd_sol_fiber_\' | i18n}}" tooltip-is-open="rdSolFiberIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdsolf_">RDSolF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.nfc | formatViewValues: \'nfc\'}}</td><td>{{feed.nfc_dig | formatViewValues: \'nfc_dig\'}}</td><td>{{feed.starch | formatViewValues: \'starch\': feed.dm}}</td><td>{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</td><td>{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</td><td>{{feed.in_fa | formatViewValues: \'in_fa\': feed.dm}}</td><td>{{feed.sol_fiber | formatViewValues: \'sol_fiber\'}}</td><td>{{feed.rd_sol_fiber | formatViewValues: \'rd_sol_fiber\'}}</td><td>{{feed.td_nfc | formatViewValues: \'td_nfc\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryCarb/feedHistory.carb.VemDve.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.rus | formatViewValues: \'rus\': feed.dm}}</td><td>{{feed.starch | formatViewValues: \'starch\': feed.dm}}</td><td>{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</td><td>{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</td><td>{{feed.td_nfc | formatViewValues: \'td_nfc\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryCarb/feedHistoryMix.carb.US.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_nfc_\' | i18n}}" tooltip-is-open="nfcIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_">NFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_nfc_dig_\' | i18n}}" tooltip-is-open="nfcDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_digestibility_">NFC dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_nfc_">NFC</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_infa_\' | i18n}}" tooltip-is-open="infaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_infa_">infa</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_sol_fiber_\' | i18n}}" tooltip-is-open="solFiberIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_" dm=""></data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_rd_sol_fiber_\' | i18n}}" tooltip-is-open="rdSolFiberIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdsolf_">RDSolF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td ng-class="feed.nfc_changed ? \'property-changed\' : \'\'">{{feed.nfc | formatViewValues: \'nfc\'}}</td><td ng-class="feed.nfc_dig_changed ? \'property-changed\' : \'\'">{{feed.nfc_dig | formatViewValues: \'nfc_dig\'}}</td><td ng-class="feed.starch_changed ? \'property-changed\' : \'\'">{{feed.starch | formatViewValues: \'starch\': feed.dm}}</td><td ng-class="feed.rd_starch_changed ? \'property-changed\' : \'\'">{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</td><td ng-class="feed.sugar_changed ? \'property-changed\' : \'\'">{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</td><td ng-class="feed.in_fa_changed ? \'property-changed\' : \'\'">{{feed.in_fa | formatViewValues: \'in_fa\': feed.dm}}</td><td ng-class="feed.sol_fiber_changed ? \'property-changed\' : \'\'">{{feed.sol_fiber | formatViewValues: \'sol_fiber\'}}</td><td ng-class="feed.rd_sol_fiber_changed ? \'property-changed\' : \'\'">{{feed.rd_sol_fiber | formatViewValues: \'rd_sol_fiber\'}}</td><td ng-class="feed.td_nfc_changed ? \'property-changed\' : \'\'">{{feed.td_nfc | formatViewValues: \'td_nfc\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryCarb/feedHistoryMix.carb.VemDve.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td ng-class="feed.rus_changed ? \'property-changed\' : \'\'">{{feed.rus | formatViewValues: \'rus\': feed.dm}}</td><td ng-class="feed.starch_changed ? \'property-changed\' : \'\'">{{feed.starch | formatViewValues: \'starch\': feed.dm}}</td><td ng-class="feed.rd_starch_changed ? \'property-changed\' : \'\'">{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</td><td ng-class="feed.sugar_changed ? \'property-changed\' : \'\'">{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</td><td ng-class="feed.td_nfc_changed ? \'property-changed\' : \'\'">{{feed.td_nfc | formatViewValues: \'td_nfc\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryHome/feedHistory.home.US.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th ng-if="vm.showButton"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.getMixHistory()" style="display: block; margin: auto" uib-tooltip="{{\'_toggle_premix_ingredients_\' | i18n}}" tooltip-is-open="togglePremix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clipboard"></i></button></th><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_user_\' | i18n}}" tooltip-is-open="lastModifiedUserIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_user_">user</data-i18n><br></div></th><th><div uib-tooltip="{{\'_title_last_modified_date_\' | i18n}}" tooltip-is-open="lastModifiedDateIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_last_modified_date_">last modified date</data-i18n><br></div></th><th><div uib-tooltip="{{\'_title_create_date\' | i18n}}" tooltip-is-open="createdDateIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_create_date">create date</data-i18n><br></div></th><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br></th><th><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></div></th><th><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><data-i18n i18n="_feeds_me_">ME</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td ng-if="vm.showButton"></td><td style="white-space: nowrap" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.last_modified_user}}</td><td>{{feed.last_modified_date | date:\'short\'}}</td><td>{{feed.create_date | date:\'short\'}}</td><td>{{feed.action}}</td><td>{{feed.dm | formatViewValues: \'dm\'}}</td><td>{{feed.nel | formatViewValues: \'nel\'}}</td><td>{{feed.me | formatViewValues: \'me\'}}</td><td>{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td>{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td>{{feed.rup | formatViewValues: \'rup\'}}</td><td>{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</td><td>{{feed.fa | formatViewValues: \'fa\'}}</td><td>{{feed.ca | formatViewValues: \'ca\': feed.dm}}</td><td>{{feed.p | formatViewValues: \'p\': feed.dm}}</td><td>{{feed.na | formatViewValues: \'na\': feed.dm}}</td><td>{{feed.dcad | formatViewValues: \'dcad\'}}</td><td>{{feed.se | formatViewValues: \'se\'}}</td><td>{{feed.vitamin_e | formatViewValues: \'vitamin_e\'}}</td><td>{{feed.cost_dm | formatViewValues: \'cost_dm\' }}</td><td>{{feed.test_date | date: vm.date_format}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryHome/feedHistory.home.VemDve.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th ng-if="vm.showButton"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.getMixHistory()" style="display: block; margin: auto" uib-tooltip="{{\'_toggle_premix_ingredients_\' | i18n}}" tooltip-is-open="togglePremix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clipboard"></i></button></th><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_user_\' | i18n}}" tooltip-is-open="lastModifiedUserIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_user_">user</data-i18n><br></div></th><th><div uib-tooltip="{{\'_title_last_modified_date_\' | i18n}}" tooltip-is-open="lastModifiedDateIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_last_modified_date_">last modified date</data-i18n><br></div></th><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></div></th><th><div uib-tooltip="{{\'_description_group_as_fed_\' | i18n}}" tooltip-is-open="groupAsFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_group_as_fed_">group as fed</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_diet_dmi_\' | i18n}}" tooltip-is-open="dietDmiIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_diet_dmi_">diet dmi</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dmi_">dmi</data-i18n></div></th><th><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">vem</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dveIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">dve</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oebIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">oeb</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">cp</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">fos</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">ca</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">p</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">mg</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">na</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">k</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">cl</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">s</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">adf</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">ndf</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td ng-if="vm.showButton"></td><td style="white-space: nowrap" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.last_modified_user}}</td><td>{{feed.last_modified_date | date:\'short\'}}</td><td>{{feed.action}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.as_fed | formatViewValues: \'as_fed\'}}</td><td>{{feed.dm | formatViewValues: \'dm\'}}</td><td>{{feed.group_as_fed | formatViewValues: \'group_as_fed\'}}</td><td>{{feed.diet_dmi | formatViewValues: \'diet_dmi\'}}&nbsp;%</td><td>{{feed.vem | formatViewValues: \'vem\'}}</td><td>{{feed.dve | formatViewValues: \'dve\': feed.dm}}</td><td>{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</td><td>{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td>{{feed.fos | formatViewValues: \'fos\': feed.dm}}</td><td>{{feed.starch | formatViewValues: \'starch\': feed.dm}}</td><td>{{feed.rus | formatViewValues: \'rus\': feed.dm}}</td><td>{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</td><td>{{feed.ca | formatViewValues: \'ca\': feed.dm}}</td><td>{{feed.p | formatViewValues: \'p\': feed.dm}}</td><td>{{feed.mg | formatViewValues: \'mg\': feed.dm}}</td><td>{{feed.na | formatViewValues: \'na\': feed.dm}}</td><td>{{feed.k | formatViewValues: \'k\': feed.dm}}</td><td>{{feed.cl | formatViewValues: \'cl\': feed.dm}}</td><td>{{feed.s | formatViewValues: \'s\': feed.dm}}</td><td>{{feed.adf | formatViewValues: \'adf\': feed.dm}}</td><td>{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</td><td>{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td>{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td>{{feed.test_date | date: vm.date_format}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryHome/feedHistoryMix.homeUS.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_user_\' | i18n}}" tooltip-is-open="lastModifiedUserIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_user_">user</data-i18n><br></div></th><th><div uib-tooltip="{{\'_title_last_modified_date_\' | i18n}}" tooltip-is-open="lastModifiedDateIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_last_modified_date_">last modified date</data-i18n><br></div></th><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></div></th><th><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><data-i18n i18n="_feeds_me_">ME</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td style="white-space: nowrap" ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td ng-class="feed.last_modified_user_changed ? \'property-changed\' : \'\'">{{feed.last_modified_user}}</td><td ng-class="feed.last_modified_date_changed ? \'property-changed\' : \'\'">{{feed.last_modified_date | date:\'short\'}}</td><td>{{feed.action}}</td><td ng-class="feed.amount_changed ? \'property-changed\' : \'\'">{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.as_fed_changed ? \'property-changed\' : \'\'">{{feed.as_fed | formatViewValues: \'as_fed\'}}</td><td ng-class="feed.dm_changed ? \'property-changed\' : \'\'">{{feed.dm | formatViewValues: \'dm\'}}</td><td ng-class="feed.nel_changed ? \'property-changed\' : \'\'">{{feed.nel | formatViewValues: \'nel\'}}</td><td ng-class="feed.me_changed ? \'property-changed\' : \'\'">{{feed.me | formatViewValues: \'me\'}}</td><td ng-class="feed.ndf_changed ? \'property-changed\' : \'\'">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td ng-class="feed.cp_changed ? \'property-changed\' : \'\'">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td ng-class="feed.rup_changed ? \'property-changed\' : \'\'">{{feed.rup | formatViewValues: \'rup\'}}</td><td ng-class="feed.rup_dig_changed ? \'property-changed\' : \'\'">{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</td><td ng-class="feed.fa_changed ? \'property-changed\' : \'\'">{{feed.fa | formatViewValues: \'fa\'}}</td><td ng-class="feed.ca_changed ? \'property-changed\' : \'\'">{{feed.ca | formatViewValues: \'ca\': feed.dm}}</td><td ng-class="feed.p_changed ? \'property-changed\' : \'\'">{{feed.p | formatViewValues: \'p\': feed.dm}}</td><td ng-class="feed.na_changed ? \'property-changed\' : \'\'">{{feed.na | formatViewValues: \'na\': feed.dm}}</td><td ng-class="feed.dcad_changed ? \'property-changed\' : \'\'">{{feed.dcad | formatViewValues: \'dcad\'}}</td><td ng-class="feed.se_changed ? \'property-changed\' : \'\'">{{feed.se | formatViewValues: \'se\'}}</td><td ng-class="feed.vitamin_e_changed ? \'property-changed\' : \'\'">{{feed.vitamin_e | formatViewValues: \'vitamin_e\'}}</td><td ng-class="feed.cost_dm_changed ? \'property-changed\' : \'\'">{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</td><td ng-class="feed.test_date_changed ? \'property-changed\' : \'\'">{{feed.test_date | date: vm.date_format}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryHome/feedHistoryMix.homeVemDve.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_user_\' | i18n}}" tooltip-is-open="lastModifiedUserIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_user_">user</data-i18n><br></div></th><th><div uib-tooltip="{{\'_title_last_modified_date_\' | i18n}}" tooltip-is-open="lastModifiedDateIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_last_modified_date_">last modified date</data-i18n><br></div></th><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></div></th><th><div uib-tooltip="{{\'_description_group_as_fed_\' | i18n}}" tooltip-is-open="groupAsFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_group_as_fed_">group as fed</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_diet_dmi_\' | i18n}}" tooltip-is-open="dietDmiIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_diet_dmi_">diet dmi</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dmi_">dmi</data-i18n></div></th><th><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">vem</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dveIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">dve</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oebIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">oeb</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">cp</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">fos</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">ca</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">p</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">mg</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">na</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">k</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">cl</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">s</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">adf</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">ndf</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td ng-class="feed.last_modified_user_changed ? \'property-changed\' : \'\'">{{feed.last_modified_user}}</td><td ng-class="feed.last_modified_date_changed ? \'property-changed\' : \'\'">{{feed.last_modified_date | date:\'short\'}}</td><td>{{feed.action}}</td><td ng-class="feed.amount_changed ? \'property-changed\' : \'\'">{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.as_fed_changed ? \'property-changed\' : \'\'">{{feed.as_fed | formatViewValues: \'as_fed\'}}</td><td ng-class="feed.dm_changed ? \'property-changed\' : \'\'">{{feed.dm | formatViewValues: \'dm\'}}</td><td ng-class="feed.group_as_fed_changed ? \'property-changed\' : \'\'">{{feed.group_as_fed | formatViewValues: \'group_as_fed\'}}</td><td ng-class="feed.diet_dmi_changed ? \'property-changed\' : \'\'">{{feed.diet_dmi | formatViewValues: \'diet_dmi\'}}&nbsp;%</td><td ng-class="feed.vem_changed ? \'property-changed\' : \'\'">{{feed.vem | formatViewValues: \'vem\'}}</td><td ng-class="feed.dve_changed ? \'property-changed\' : \'\'">{{feed.dve | formatViewValues: \'dve\': feed.dm}}</td><td ng-class="feed.oeb_changed ? \'property-changed\' : \'\'">{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</td><td ng-class="feed.cp_changed ? \'property-changed\' : \'\'">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td ng-class="feed.fos_changed ? \'property-changed\' : \'\'">{{feed.fos | formatViewValues: \'fos\': feed.dm}}</td><td ng-class="feed.starch_changed ? \'property-changed\' : \'\'">{{feed.starch | formatViewValues: \'starch\': feed.dm}}</td><td ng-class="feed.rus_changed ? \'property-changed\' : \'\'">{{feed.rus | formatViewValues: \'rus\': feed.dm}}</td><td ng-class="feed.sugar_changed ? \'property-changed\' : \'\'">{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</td><td ng-class="feed.ca_changed ? \'property-changed\' : \'\'">{{feed.ca | formatViewValues: \'ca\': feed.dm}}</td><td ng-class="feed.p_changed ? \'property-changed\' : \'\'">{{feed.p | formatViewValues: \'p\': feed.dm}}</td><td ng-class="feed.mg_changed ? \'property-changed\' : \'\'">{{feed.mg | formatViewValues: \'mg\': feed.dm}}</td><td ng-class="feed.na_changed ? \'property-changed\' : \'\'">{{feed.na | formatViewValues: \'na\': feed.dm}}</td><td ng-class="feed.k_changed ? \'property-changed\' : \'\'">{{feed.k | formatViewValues: \'k\': feed.dm}}</td><td ng-class="feed.cl_changed ? \'property-changed\' : \'\'">{{feed.cl | formatViewValues: \'cl\': feed.dm}}</td><td ng-class="feed.s_changed ? \'property-changed\' : \'\'">{{feed.s | formatViewValues: \'s\': feed.dm}}</td><td ng-class="feed.adf_changed ? \'property-changed\' : \'\'">{{feed.adf | formatViewValues: \'adf\': feed.dm}}</td><td ng-class="feed.lignin_changed ? \'property-changed\' : \'\'">{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</td><td ng-class="feed.ndf_changed ? \'property-changed\' : \'\'">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td ng-class="feed.efndf_changed ? \'property-changed\' : \'\'">{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td ng-class="feed.test_date_changed ? \'property-changed\' : \'\'">{{feed.test_date | date: vm.date_format}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryEnergy/feedHistory.energy.US.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me_">ME</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_disc_fac_\' | i18n}}" tooltip-is-open="discFacIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_disc_fac_">Disc. Fac.</data-i18n><br>%</div></th><th><div uib-tooltip="{{\'_description_nel_89_\' | i18n}}" tooltip-is-open="nel89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel89_">NEL 89</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_me_89_\' | i18n}}" tooltip-is-open="me89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me89_">ME 89</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_dep_\' | i18n}}" tooltip-is-open="depIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dep_">DEp</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_de1x_\' | i18n}}" tooltip-is-open="de1xIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_de1x_">DE1X</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_mftdn_\' | i18n}}" tooltip-is-open="mftdnIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mftdn_">MF-TDN</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_tdn1x_\' | i18n}}" tooltip-is-open="tdn1xIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdn1x_">TDN1X</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.nel | formatViewValues: \'nel\'}}</td><td>{{feed.me | formatViewValues: \'me\'}}</td><td>{{feed.disc_fac | formatViewValues: \'disc_fac\'}}</td><td>{{feed.nel_89 | formatViewValues: \'nel_89\'}}</td><td>{{feed.me_89 | formatViewValues: \'me_89\'}}</td><td>{{feed.dep | formatViewValues: \'dep\' }}</td><td>{{feed.de1x | formatViewValues: \'de1x\'}}</td><td>{{feed.mftdn | formatViewValues: \'mftdn\'}}</td><td>{{feed.tdn1x | formatViewValues: \'tdn1x\' }}</td></tr></tbody></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryEnergy/feedHistory.energy.VemDve.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_"></data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">cost dm</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">cost dm</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.vem | formatViewValues: \'vem\' }}</td><td>{{feed.fos | formatViewValues: \'fos\': feed.dm }}</td></tr></tbody></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryEnergy/feedHistoryMix.energy.US.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me_">ME</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_disc_fac_\' | i18n}}" tooltip-is-open="discFacIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_disc_fac_">Disc. Fac.</data-i18n><br>%</div></th><th><div uib-tooltip="{{\'_description_nel_89_\' | i18n}}" tooltip-is-open="nel89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel89_">NEL 89</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_me_89_\' | i18n}}" tooltip-is-open="me89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me89_">ME 89</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_dep_\' | i18n}}" tooltip-is-open="depIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dep_">DEp</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_de1x_\' | i18n}}" tooltip-is-open="de1xIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_de1x_">DE1X</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_mftdn_\' | i18n}}" tooltip-is-open="mftdnIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mftdn_">MF-TDN</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_tdn1x_\' | i18n}}" tooltip-is-open="tdn1xIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdn1x_">TDN1X</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td ng-class="feed.nel_changed ? \'property-changed\' : \'\'">{{feed.nel | formatViewValues: \'nel\'}}</td><td ng-class="feed.me_changed ? \'property-changed\' : \'\'">{{feed.me | formatViewValues: \'me\'}}</td><td ng-class="feed.disc_fac_changed ? \'property-changed\' : \'\'">{{feed.disc_fac | formatViewValues: \'disc_fac\'}}</td><td ng-class="feed.nel_89_changed ? \'property-changed\' : \'\'">{{feed.nel_89 | formatViewValues: \'nel_89\'}}</td><td ng-class="feed.me_89_changed ? \'property-changed\' : \'\'">{{feed.me_89 | formatViewValues: \'me_89\'}}</td><td ng-class="feed.dep_changed ? \'property-changed\' : \'\'">{{feed.dep | formatViewValues: \'dep\'}}</td><td ng-class="feed.de1x_changed ? \'property-changed\' : \'\'">{{feed.de1x | formatViewValues: \'de1x\'}}</td><td ng-class="feed.mftdn_changed ? \'property-changed\' : \'\'">{{feed.mftdn | formatViewValues: \'mftdn\'}}</td><td ng-class="feed.tdn1x_changed ? \'property-changed\' : \'\'">{{feed.tdn1x | formatViewValues: \'tdn1x\' }}</td></tr></tbody></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryEnergy/feedHistoryMix.energy.VemDve.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_"></data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">cost dm</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">cost dm</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td ng-class="feed.amount_changed ? \'property-changed\' : \'\'">{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.vem_changed ? \'property-changed\' : \'\'">{{feed.vem | formatViewValues: \'vem\' }}</td><td ng-class="feed.fos_changed ? \'property-changed\' : \'\'">{{feed.fos | formatViewValues: \'fos\': feed.dm }}</td></tr></tbody></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryFiber/feedHistory.fiber.US.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rdndf_\' | i18n}}" tooltip-is-open="rdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdndf_">RDNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_td_ndf_\' | i18n}}" tooltip-is-open="tdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdndf_">tdNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td>{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td>{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</td><td>{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</td><td>{{feed.adf | formatViewValues: \'adf\': feed.dm}}</td><td>{{feed.rd_ndf | formatViewValues: \'rd_ndf\'}}</td><td>{{feed.td_ndf | formatViewValues: \'td_ndf\'}}</td></tr></tbody></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryFiber/feedHistory.fiber.VemDve.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_rcel_\' | i18n}}" tooltip-is-open="rcNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.rc | formatViewValues: \'rc\': feed.dm}}</td><td>{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td>{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td>{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</td><td>{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</td><td>{{feed.adf | formatViewValues: \'adf\': feed.dm}}</td></tr></tbody></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryFiber/feedHistoryMix.fiber.US.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rdndf_\' | i18n}}" tooltip-is-open="rdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdndf_">RDNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_td_ndf_\' | i18n}}" tooltip-is-open="tdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdndf_">tdNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td ng-class="feed.ndf_changed ? \'property-changed\' : \'\'">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td ng-class="feed.ef_ndf_as_ndf_changed ? \'property-changed\' : \'\'">{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td ng-class="feed.lignin_changed ? \'property-changed\' : \'\'">{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</td><td ng-class="feed.ndf_digest_changed ? \'property-changed\' : \'\'">{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</td><td ng-class="feed.adf_changed ? \'property-changed\' : \'\'">{{feed.adf | formatViewValues: \'adf\': feed.dm}}</td><td ng-class="feed.rd_ndf_changed ? \'property-changed\' : \'\'">{{feed.rd_ndf | formatViewValues: \'rd_ndf\'}}</td><td ng-class="feed.td_ndf_changed ? \'property-changed\' : \'\'">{{feed.td_ndf | formatViewValues: \'td_ndf\'}}</td></tr></tbody></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryFiber/feedHistoryMix.fiber.VemDve.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_rcel_\' | i18n}}" tooltip-is-open="rcNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td ng-class="feed.rc_changed ? \'property-changed\' : \'\'">{{feed.rc | formatViewValues: \'rc\': feed.dm}}</td><td ng-class="feed.ndf_changed ? \'property-changed\' : \'\'">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td ng-class="feed.ef_ndf_as_ndf_changed ? \'property-changed\' : \'\'">{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td ng-class="feed.lignin_changed ? \'property-changed\' : \'\'">{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</td><td ng-class="feed.ndf_digest_changed ? \'property-changed\' : \'\'">{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</td><td ng-class="feed.adf_changed ? \'property-changed\' : \'\'">{{feed.adf | formatViewValues: \'adf\': feed.dm}}</td></tr></tbody></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryLipid/feedHistory.lipid.US.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_sfa_\' | i18n}}" tooltip-is-open="sfaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sfa_">SFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mufa_\' | i18n}}" tooltip-is-open="mufaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mufa_">MUFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_pufa_\' | i18n}}" tooltip-is-open="pufaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_pufa_">PUFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_bhfa_\' | i18n}}" tooltip-is-open="bhfaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_bhfa_">BHFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fa_dig_\' | i18n}}" tooltip-is-open="faDigIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_dig_">FA dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_td_fa_\' | i18n}}" tooltip-is-open="tdFaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdfa_">td FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.ee | formatViewValues: \'ee\': feed.dm}}</td><td>{{feed.fa | formatViewValues: \'fa\'}}</td><td>{{feed.sfa | formatViewValues: \'sfa\'}}</td><td>{{feed.mufa | formatViewValues: \'mufa\'}}</td><td>{{feed.pufa | formatViewValues: \'pufa\'}}</td><td>{{feed.bhfa | formatViewValues: \'bhfa\'}}</td><td>{{feed.fa_dig | formatViewValues: \'fa_dig\'}}</td><td>{{feed.td_fa | formatViewValues: \'td_fa\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryLipid/feedHistory.lipid.VemDve.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n></div></th><th><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.ee | formatViewValues: \'ee\': feed.dm}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryLipid/feedHistoryMix.lipid.US.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_sfa_\' | i18n}}" tooltip-is-open="sfaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sfa_">SFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mufa_\' | i18n}}" tooltip-is-open="mufaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mufa_">MUFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_pufa_\' | i18n}}" tooltip-is-open="pufaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_pufa_">PUFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_bhfa_\' | i18n}}" tooltip-is-open="bhfaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_bhfa_">BHFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fa_dig_\' | i18n}}" tooltip-is-open="faDigIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_dig_">FA dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_td_fa_\' | i18n}}" tooltip-is-open="tdFaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdfa_">td FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td ng-class="feed.ee_changed ? \'property-changed\' : \'\'">{{feed.ee | formatViewValues: \'ee\': feed.dm}}</td><td ng-class="feed.fa_changed ? \'property-changed\' : \'\'">{{feed.fa | formatViewValues: \'fa\'}}</td><td ng-class="feed.sfa_changed ? \'property-changed\' : \'\'">{{feed.sfa | formatViewValues: \'sfa\'}}</td><td ng-class="feed.mufa_changed ? \'property-changed\' : \'\'">{{feed.mufa | formatViewValues: \'mufa\'}}</td><td ng-class="feed.pufa_changed ? \'property-changed\' : \'\'">{{feed.pufa | formatViewValues: \'pufa\'}}</td><td ng-class="feed.bhfa_changed ? \'property-changed\' : \'\'">{{feed.bhfa | formatViewValues: \'bhfa\'}}</td><td ng-class="feed.fa_dig_changed ? \'property-changed\' : \'\'">{{feed.fa_dig | formatViewValues: \'fa_dig\'}}</td><td ng-class="feed.td_fa_changed ? \'property-changed\' : \'\'">{{feed.td_fa | formatViewValues: \'td_fa\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryLipid/feedHistoryMix.lipid.VemDve.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n></div></th><th><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td ng-class="feed.ee_changed ? \'property-changed\' : \'\'">{{feed.ee | formatViewValues: \'ee\': feed.dm}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryProtein/feedHistory.protein.US.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rdp_\' | i18n}}" tooltip-is-open="rdpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp_">rdp</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mp_\' | i18n}}" tooltip-is-open="mpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp_">mp</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_a_prot_\' | i18n}}" tooltip-is-open="AProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_a_">A Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_b_prot_\' | i18n}}" tooltip-is-open="BProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_b_">B Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_c_prot_\' | i18n}}" tooltip-is-open="CProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_c_">C Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_kd_bprot_\' | i18n}}" tooltip-is-open="kdBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kd_bprot_">kd bprot</data-i18n><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th><div uib-tooltip="{{\'_description_kp_bprot_\' | i18n}}" tooltip-is-open="kpBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kp_bprot_">kp bprot</data-i18n><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th><div uib-tooltip="{{\'_description_npncpe_\' | i18n}}" tooltip-is-open="npncpeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_npncpe_">NPNCPE</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rup_89_\' | i18n}}" tooltip-is-open="rup89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup89_">rup 89</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rdp_01_\' | i18n}}" tooltip-is-open="rdp01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp01_">rdp 01</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mp_01_\' | i18n}}" tooltip-is-open="mp01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp01_">mp 01</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_ndicp_\' | i18n}}" tooltip-is-open="ndicpIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndicp_">NDICP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_adicp_\' | i18n}}" tooltip-is-open="adicpIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_td_trup_\' | i18n}}" tooltip-is-open="tdtrupIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdtrup_">tdtrup</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td>{{feed.rup | formatViewValues: \'rup\'}}</td><td>{{feed.rdp | formatViewValues: \'rdp\'}}</td><td>{{feed.mp | formatViewValues: \'mp\'}}</td><td>{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</td><td>{{feed.a_prot | formatViewValues: \'a_prot\'}}</td><td>{{feed.b_prot | formatViewValues: \'b_prot\'}}</td><td>{{feed.c_prot | formatViewValues: \'c_prot\'}}</td><td>{{feed.kd_b_prot | formatViewValues: \'kd_b_prot\'}}</td><td>{{feed.kp_b_prot | formatViewValues: \'kp_b_prot\'}}</td><td>{{feed.npncpe | formatViewValues: \'npncpe\'}}</td><td>{{feed.rup_89 | formatViewValues: \'rup_89\'}}</td><td>{{feed.rdp_01 | formatViewValues: \'rdp_01\'}}</td><td>{{feed.mp_01 | formatViewValues: \'mp_01\'}}</td><td>{{feed.ndicp | formatViewValues: \'ndicp\': feed.dm}}</td><td>{{feed.adicp | formatViewValues: \'adicp\': feed.dm}}</td><td>{{feed.td_trup | formatViewValues: \'td_trup\'}}</td></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryProtein/feedHistory.protein.VemDve.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_"></data-i18n></div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dveSevenIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">DVE</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oebSevenIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">OEB</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td>{{feed.dve | formatViewValues: \'dve\': feed.dm}}</td><td>{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</td></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryProtein/feedHistoryMix.protein.US.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rdp_\' | i18n}}" tooltip-is-open="rdpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp_">rdp</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mp_\' | i18n}}" tooltip-is-open="mpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp_">mp</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_a_prot_\' | i18n}}" tooltip-is-open="AProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_a_">A Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_b_prot_\' | i18n}}" tooltip-is-open="BProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_b_">B Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_c_prot_\' | i18n}}" tooltip-is-open="CProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_c_">C Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_kd_bprot_\' | i18n}}" tooltip-is-open="kdBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kd_bprot_">kd bprot</data-i18n><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th><div uib-tooltip="{{\'_description_kp_bprot_\' | i18n}}" tooltip-is-open="kpBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kp_bprot_">kp bprot</data-i18n><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th><div uib-tooltip="{{\'_description_npncpe_\' | i18n}}" tooltip-is-open="npncpeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_npncpe_">NPNCPE</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rup_89_\' | i18n}}" tooltip-is-open="rup89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup89_">rup 89</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rdp_01_\' | i18n}}" tooltip-is-open="rdp01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp01_">rdp 01</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mp_01_\' | i18n}}" tooltip-is-open="mp01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp01_">mp 01</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_ndicp_\' | i18n}}" tooltip-is-open="ndicpIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndicp_">NDICP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_adicp_\' | i18n}}" tooltip-is-open="adicpIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_td_trup_\' | i18n}}" tooltip-is-open="tdtrupIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdtrup_">tdtrup</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td ng-class="feed.cp_changed ? \'property-changed\' : \'\'">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td ng-class="feed.rup_changed ? \'property-changed\' : \'\'">{{feed.rup | formatViewValues: \'rup\'}}</td><td ng-class="feed.rdp_changed ? \'property-changed\' : \'\'">{{feed.rdp | formatViewValues: \'rdp\'}}</td><td ng-class="feed.mp_changed ? \'property-changed\' : \'\'">{{feed.mp | formatViewValues: \'mp\'}}</td><td ng-class="feed.rup_dig_changed ? \'property-changed\' : \'\'">{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</td><td ng-class="feed.a_prot_changed ? \'property-changed\' : \'\'">{{feed.a_prot | formatViewValues: \'a_prot\'}}</td><td ng-class="feed.b_prot_changed ? \'property-changed\' : \'\'">{{feed.b_prot | formatViewValues: \'b_prot\'}}</td><td ng-class="feed.c_prot_changed ? \'property-changed\' : \'\'">{{feed.c_prot | formatViewValues: \'c_prot\'}}</td><td ng-class="feed.kd_b_prot_changed ? \'property-changed\' : \'\'">{{feed.kd_b_prot | formatViewValues: \'kd_b_prot\'}}</td><td ng-class="feed.kp_b_prot_changed ? \'property-changed\' : \'\'">{{feed.kp_b_prot | formatViewValues: \'kp_b_prot\'}}</td><td ng-class="feed.npncpe_changed ? \'property-changed\' : \'\'">{{feed.npncpe | formatViewValues: \'npncpe\'}}</td><td ng-class="feed.rup_89_changed ? \'property-changed\' : \'\'">{{feed.rup_89 | formatViewValues: \'rup_89\'}}</td><td ng-class="feed.rdp_01_changed ? \'property-changed\' : \'\'">{{feed.rdp_01 | formatViewValues: \'rdp_01\'}}</td><td ng-class="feed.mp_01_changed ? \'property-changed\' : \'\'">{{feed.mp_01 | formatViewValues: \'mp_01\'}}</td><td ng-class="feed.ndicp_changed ? \'property-changed\' : \'\'">{{feed.ndicp | formatViewValues: \'ndicp\': feed.dm}}</td><td ng-class="feed.adicp_changed ? \'property-changed\' : \'\'">{{feed.adicp | formatViewValues: \'adicp\': feed.dm}}</td><td ng-class="feed.td_trup_changed ? \'property-changed\' : \'\'">{{feed.td_trup | formatViewValues: \'td_trup\'}}</td></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/feeds/feedHistory/feedHistoryProtein/feedHistoryMix.protein.VemDve.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_"></data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dveSevenIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">DVE</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oebSevenIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">OEB</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td ng-class="feed.amount_changed ? \'property-changed\' : \'\'">{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.cp_changed ? \'property-changed\' : \'\'">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td ng-class="feed.dve_changed ? \'property-changed\' : \'\'">{{feed.dve | formatViewValues: \'dve\': feed.dm}}</td><td ng-class="feed.oeb_changed ? \'property-changed\' : \'\'">{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</td></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/feeds/myfeeds/feedsFiber/feeds.fiber.US.html','<div><table class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe" ng-if="!vm.loadingTable && vm.settings.use_percent"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="7"></th></tr><tr class="sortable" style="height: 30px; border-spacing: 0"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th class="editable-header" ng-click="vm.sort(\'ndf\')"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'efNdfAsNdf\')"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'efNdfAsNdf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'efNdfAsNdf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'lignin\')"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'lignin_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'lignin_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'ndfDigest\')"><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndfDigest_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndfDigest_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'adf\')"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'adf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'adf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'rdNdf\')"><div uib-tooltip="{{\'_description_rdndf_\' | i18n}}" tooltip-is-open="rdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdndf_">RDNDF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rdNdf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rdNdf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th ng-click="vm.sort(\'tdNdf\')"><div uib-tooltip="{{\'_description_td_ndf_\' | i18n}}" tooltip-is-open="tdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdndf_">tdNDF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'tdNdf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'tdNdf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'F\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" id="feed_name{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ndf" e-format-value-dm="feed.dm" editable-number="feed.ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf\', \'F\')" id="ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ef_ndf_as_ndf" editable-number="feed.ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ef_ndf_as_ndf\', \'F\')" id="ef_ndf_as_ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="lignin" e-format-value-dm="feed.dm" editable-number="feed.lignin" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'lignin\', \'F\')" id="lignin{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ndf_digest" editable-number="feed.ndf_digest" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf_digest\', \'F\')" id="ndf_digest{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="adf" e-format-value-dm="feed.dm" editable-number="feed.adf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'adf\', \'F\')" id="adf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.adf | formatViewValues: \'adf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="rd_ndf" editable-number="feed.rd_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rd_ndf\', \'F\')" id="rd_ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rd_ndf | formatViewValues: \'rd_ndf\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_ndf | formatViewValues: \'td_ndf\'}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_rdndf_\' | i18n}}" tooltip-is-open="rdNdfIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdndf_">RDNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_td_ndf_\' | i18n}}" tooltip-is-open="tdNdfIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdndf_">tdNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'F\')" id="feed_nameMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="ndf" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ndf" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ndf\', \'F\', feed.id)" id="ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf | formatViewValues: \'ndf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="ef_ndf_as_ndf" editable-number="mixfeed.ef_ndf_as_ndf" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ef_ndf_as_ndf\', \'F\', feed.id)" id="ef_ndf_as_ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="lignin" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.lignin" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'lignin\', \'F\', feed.id)" id="ligninMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.lignin | formatViewValues: \'lignin\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="ndf_digest" editable-number="mixfeed.ndf_digest" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ndf_digest\', \'F\', feed.id)" id="ndf_digestMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf_digest | formatViewValues: \'ndf_digest\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="adf" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.adf" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'adf\', \'F\', feed.id)" id="adfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.adf | formatViewValues: \'adf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="rd_ndf" editable-number="mixfeed.rd_ndf" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rd_ndf\', \'F\', feed.id)" id="rd_ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rd_ndf | formatViewValues: \'rd_ndf\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_ndf | formatViewValues: \'td_ndf\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><table class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe" ng-if="!vm.loadingTable && !vm.settings.use_percent"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="7"></th></tr><tr class="sortable" style="height: 30px; border-spacing: 0"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th class="editable-header" ng-click="vm.sort(\'ndf\')"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'efNdfAsNdf\')"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'efNdfAsNdf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'efNdfAsNdf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'lignin\')"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'lignin_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'lignin_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'ndfDigest\')"><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndfDigest_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndfDigest_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'adf\')"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'adf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'adf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'rdNdf\')"><div uib-tooltip="{{\'_description_rdndf_\' | i18n}}" tooltip-is-open="rdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdndf_">RDNDF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rdNdf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rdNdf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th ng-click="vm.sort(\'tdNdf\')"><div uib-tooltip="{{\'_description_td_ndf_\' | i18n}}" tooltip-is-open="tdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdndf_">tdNDF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'tdNdf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'tdNdf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'F\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" id="feed_name{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="ndf" e-format-value-dm="feed.dm" editable-number="feed.ndf" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf\', \'F\')" id="ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ef_ndf_as_ndf" editable-number="feed.ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ef_ndf_as_ndf\', \'F\')" id="ef_ndf_as_ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="lignin" e-format-value-dm="feed.dm" editable-number="feed.lignin" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'lignin\', \'F\')" id="lignin{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ndf_digest" editable-number="feed.ndf_digest" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf_digest\', \'F\')" id="ndf_digest{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="adf" e-format-value-dm="feed.dm" editable-number="feed.adf" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'adf\', \'F\')" id="adf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.adf | formatViewValues: \'adf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="rd_ndf" editable-number="feed.rd_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rd_ndf\', \'F\')" id="rd_ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rd_ndf | formatViewValues: \'rd_ndf\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_ndf | formatViewValues: \'td_ndf\'}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_rdndf_\' | i18n}}" tooltip-is-open="rdNdfIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdndf_">RDNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_td_ndf_\' | i18n}}" tooltip-is-open="tdNdfIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdndf_">tdNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'F\')" id="feed_nameMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="ndf" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ndf" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ndf\', \'F\', feed.id)" id="ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf | formatViewValues: \'ndf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="ef_ndf_as_ndf" editable-number="mixfeed.ef_ndf_as_ndf" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ef_ndf_as_ndf\', \'F\', feed.id)" id="ef_ndf_as_ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="lignin" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.lignin" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'lignin\', \'F\', feed.id)" id="ligninMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.lignin | formatViewValues: \'lignin\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="ndf_digest" editable-number="mixfeed.ndf_digest" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ndf_digest\', \'F\', feed.id)" id="ndf_digestMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf_digest | formatViewValues: \'ndf_digest\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="adf" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.adf" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'adf\', \'F\', feed.id)" id="adfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.adf | formatViewValues: \'adf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="rd_ndf" editable-number="mixfeed.rd_ndf" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rd_ndf\', \'F\', feed.id)" id="rd_ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rd_ndf | formatViewValues: \'rd_ndf\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_ndf | formatViewValues: \'td_ndf\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/feedsFiber/feeds.fiber.VemDve.html','<div><table class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe" ng-if="!vm.loadingTable && vm.settings.use_percent"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="8"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th class="editable-header" ng-click="vm.sort(\'rc\')"><div uib-tooltip="{{\'_description_rcel_\' | i18n}}" tooltip-is-open="rcNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rc_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rc_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'ndf\')"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'efNdfAsNdf\')"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'efNdfAsNdf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'efNdfAsNdf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'lignin\')"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'lignin_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'lignin_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'ndfDigest\')"><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndfDigest_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndfDigest_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'adf\')"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'adf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'adf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'F\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" id="feed_name{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="rc" e-format-value-dm="feed.dm" editable-number="feed.rc" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rc\', \'F\')" id="rc{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rc | formatViewValues: \'rc\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ndf" e-format-value-dm="feed.dm" editable-number="feed.ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf\', \'F\')" id="ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ef_ndf_as_ndf" editable-number="feed.ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ef_ndf_as_ndf\', \'F\')" id="ef_ndf_as_ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="lignin" e-format-value-dm="feed.dm" editable-number="feed.lignin" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'lignin\', \'F\')" id="lignin{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ndf_digest" editable-number="feed.ndf_digest" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf_digest\', \'F\')" id="ndf_digest{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="adf" e-format-value-dm="feed.dm" editable-number="feed.adf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'adf\', \'F\')" id="adf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.adf | formatViewValues: \'adf\': feed.dm}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_rcel_\' | i18n}}" tooltip-is-open="rcNameIsOpenm" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'F\')" id="feed_nameMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="rc" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.rc" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rc\', \'F\', feed.id)" id="rcMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rc | formatViewValues: \'rc\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="ndf" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ndf" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ndf\', \'F\', feed.id)" id="ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf | formatViewValues: \'ndf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="ef_ndf_as_ndf" editable-number="mixfeed.ef_ndf_as_ndf" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ef_ndf_as_ndf\', \'F\', feed.id)" id="ef_ndf_as_ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="lignin" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.lignin" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'lignin\', \'F\', feed.id)" id="ligninMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.lignin | formatViewValues: \'lignin\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="ndf_digest" editable-number="mixfeed.ndf_digest" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ndf_digest\', \'F\', feed.id)" id="ndf_digestMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf_digest | formatViewValues: \'ndf_digest\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="adf" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.adf" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'adf\', \'F\', feed.id)" id="adfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.adf | formatViewValues: \'adf\': mixfeed.dm}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><table class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe" ng-if="!vm.loadingTable && !vm.settings.use_percent"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="8"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th class="editable-header" ng-click="vm.sort(\'rc\')"><div uib-tooltip="{{\'_description_rcel_\' | i18n}}" tooltip-is-open="rcNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rc_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rc_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'ndf\')"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'efNdfAsNdf\')"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'efNdfAsNdf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'efNdfAsNdf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'lignin\')"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'lignin_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'lignin_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'ndfDigest\')"><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndfDigest_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndfDigest_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'adf\')"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'adf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'adf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'F\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" id="feed_name{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="rc" e-format-value-dm="feed.dm" editable-number="feed.rc" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'rc\', \'F\')" id="rc{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rc | formatViewValues: \'rc\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="ndf" e-format-value-dm="feed.dm" editable-number="feed.ndf" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf\', \'F\')" id="ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ef_ndf_as_ndf" editable-number="feed.ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ef_ndf_as_ndf\', \'F\')" id="ef_ndf_as_ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="lignin" e-format-value-dm="feed.dm" editable-number="feed.lignin" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'lignin\', \'F\')" id="lignin{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ndf_digest" editable-number="feed.ndf_digest" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf_digest\', \'F\')" id="ndf_digest{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="adf" e-format-value-dm="feed.dm" editable-number="feed.adf" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'adf\', \'F\')" id="adf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.adf | formatViewValues: \'adf\': feed.dm}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_rcel_\' | i18n}}" tooltip-is-open="rcNameIsOpenm" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'F\')" id="feed_nameMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="rc" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.rc" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rc\', \'F\', feed.id)" id="rcMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rc | formatViewValues: \'rc\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="ndf" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ndf" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ndf\', \'F\', feed.id)" id="ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf | formatViewValues: \'ndf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="ef_ndf_as_ndf" editable-number="mixfeed.ef_ndf_as_ndf" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ef_ndf_as_ndf\', \'F\', feed.id)" id="ef_ndf_as_ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="lignin" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.lignin" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'lignin\', \'F\', feed.id)" id="ligninMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.lignin | formatViewValues: \'lignin\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="ndf_digest" editable-number="mixfeed.ndf_digest" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ndf_digest\', \'F\', feed.id)" id="ndf_digestMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf_digest | formatViewValues: \'ndf_digest\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="adf" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.adf" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'adf\', \'F\', feed.id)" id="adfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.adf | formatViewValues: \'adf\': mixfeed.dm}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/feedsCarb/feeds.carbohydrate.US.html','<div><table ng-if="!vm.loadingTable && vm.settings.use_percent" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="9"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th style="width: 200px" ng-click="vm.sort(\'nfc\')"><div uib-tooltip="{{\'_description_nfc_\' | i18n}}" tooltip-is-open="nfcIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_">NFC</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'nfc_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'nfc_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'nfc_dig\')"><div uib-tooltip="{{\'_description_nfc_dig_\' | i18n}}" tooltip-is-open="nfcDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_digestibility_">NFC dig</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'nfc_dig_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'nfc_dig_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_nfc_">NFC</data-i18n></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'starch\')"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'starch_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'starch_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'rd_starch\')"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rd_starch_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rd_starch_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'sugar\')"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'sugar_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'sugar_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'in_fa\')"><div uib-tooltip="{{\'_description_infa_\' | i18n}}" tooltip-is-open="infaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_infa_">infa</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'in_fa_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'in_fa_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th style="width: 200px" ng-click="vm.sort(\'sol_fiber\')"><div uib-tooltip="{{\'_description_sol_fiber_\' | i18n}}" tooltip-is-open="solFiberIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'sol_fiber_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'sol_fiber_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_" dm=""></data-i18n></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'rd_sol_fiber\')"><div uib-tooltip="{{\'_description_rd_sol_fiber_\' | i18n}}" tooltip-is-open="rdSolFiberIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdsolf_">RDSolF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rd_sol_fiber_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rd_sol_fiber_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n></div></th><th style="width: 200px" ng-click="vm.sort(\'td_nfc\')"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'td_nfc_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'td_nfc_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'C\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" id="feed_name{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span>{{feed.nfc | formatViewValues: \'nfc\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix || feed.is_mix" e-step="0.1" e-format-input-value="nfc_dig" editable-number="feed.nfc_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'nfc_dig\', \'C\')" id="nfc_dig{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.nfc_dig | formatViewValues: \'nfc_dig\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="starch" e-format-value-dm="feed.dm" editable-number="feed.starch" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'starch\', \'C\')" id="starch{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.starch | formatViewValues: \'starch\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="rd_starch" editable-number="feed.rd_starch" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rd_starch\', \'C\')" id="rd_starch{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="sugar" e-format-value-dm="feed.dm" editable-number="feed.sugar" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'sugar\', \'C\')" id="sugar{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="in_fa" e-format-value-dm="feed.dm" editable-number="feed.in_fa" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'in_fa\', \'C\')" id="in_fa{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.in_fa | formatViewValues: \'in_fa\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.sol_fiber | formatViewValues: \'sol_fiber\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="rd_sol_fiber" editable-number="feed.rd_sol_fiber" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rd_sol_fiber\', \'C\')" id="rd_sol_fiber{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rd_sol_fiber | formatViewValues: \'rd_sol_fiber\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_nfc | formatViewValues: \'td_nfc\'}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenm" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_nfc_\' | i18n}}" tooltip-is-open="nfcIsOpenm" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_">NFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_nfc_dig_\' | i18n}}" tooltip-is-open="nfcDigIsOpenm" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_digestibility_">NFC dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_nfc_">NFC</data-i18n></div></th><th style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpenm" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpenm" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpenm" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_infa_\' | i18n}}" tooltip-is-open="infaIsOpenm" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_infa_">infa</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_sol_fiber_\' | i18n}}" tooltip-is-open="solFiberIsOpenm" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_" dm=""></data-i18n></div></th><th st-sort="rd_sol_fiber" style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_rd_sol_fiber_\' | i18n}}" tooltip-is-open="rdSolFiberIsOpenm" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdsolf_">RDSolF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpenm" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'C\')" id="feed_nameMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.nfc | formatViewValues: \'nfc\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="nfc_dig" editable-number="mixfeed.nfc_dig" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" eblur="cancel" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'nfc_dig\', \'C\', feed.id)" id="nfc_digMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.nfc_dig | formatViewValues: \'nfc_dig\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="starch" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.starch" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'starch\', \'C\', feed.id)" id="starchMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.starch | formatViewValues: \'starch\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="rd_starch" editable-number="mixfeed.rd_starch" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rd_starch\', \'C\', feed.id)" id="rd_starchMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rd_starch | formatViewValues: \'rd_starch\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="sugar" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.sugar" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" eblur="cancel" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'sugar\', \'C\', feed.id)" id="sugarMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.sugar | formatViewValues: \'sugar\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="in_fa" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.in_fa" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" eblur="cancel" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'in_fa\', \'C\', feed.id)" id="in_faMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.in_fa | formatViewValues: \'in_fa\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.sol_fiber | formatViewValues: \'sol_fiber\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="rd_sol_fiber" editable-number="mixfeed.rd_sol_fiber" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rd_sol_fiber\', \'C\', feed.id)" id="rd_sol_fiberMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rd_sol_fiber | formatViewValues: \'rd_sol_fiber\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_nfc | formatViewValues: \'td_nfc\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><table ng-if="!vm.loadingTable && !vm.settings.use_percent" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="9"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th style="width: 200px" ng-click="vm.sort(\'nfc\')"><div uib-tooltip="{{\'_description_nfc_\' | i18n}}" tooltip-is-open="nfcIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_">NFC</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'nfc_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'nfc_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'nfc_dig\')"><div uib-tooltip="{{\'_description_nfc_dig_\' | i18n}}" tooltip-is-open="nfcDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_digestibility_">NFC dig</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'nfc_dig_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'nfc_dig_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_nfc_">NFC</data-i18n></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'starch\')"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'starch_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'starch_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'rd_starch\')"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rd_starch_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rd_starch_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'sugar\')"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'sugar_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'sugar_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'in_fa\')"><div uib-tooltip="{{\'_description_infa_\' | i18n}}" tooltip-is-open="infaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_infa_">infa</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'in_fa_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'in_fa_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px" ng-click="vm.sort(\'sol_fiber\')"><div uib-tooltip="{{\'_description_sol_fiber_\' | i18n}}" tooltip-is-open="solFiberIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'sol_fiber_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'sol_fiber_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_" dm=""></data-i18n></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'rd_sol_fiber\')"><div uib-tooltip="{{\'_description_rd_sol_fiber_\' | i18n}}" tooltip-is-open="rdSolFiberIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdsolf_">RDSolF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rd_sol_fiber_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rd_sol_fiber_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n></div></th><th style="width: 200px" ng-click="vm.sort(\'td_nfc\')"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'td_nfc_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'td_nfc_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'C\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" id="feed_name{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span>{{feed.nfc | formatViewValues: \'nfc\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix || feed.is_mix" e-step="0.1" e-format-input-value="nfc_dig" editable-number="feed.nfc_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'nfc_dig\', \'C\')" id="nfc_dig{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.nfc_dig | formatViewValues: \'nfc_dig\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="starch" e-format-value-dm="feed.dm" editable-number="feed.starch" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'starch\', \'C\')" id="starch{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.starch | formatViewValues: \'starch\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="rd_starch" editable-number="feed.rd_starch" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rd_starch\', \'C\')" id="rd_starch{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="sugar" e-format-value-dm="feed.dm" editable-number="feed.sugar" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'sugar\', \'C\')" id="sugar{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="in_fa" e-format-value-dm="feed.dm" editable-number="feed.in_fa" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'in_fa\', \'C\')" id="in_fa{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.in_fa | formatViewValues: \'in_fa\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.sol_fiber | formatViewValues: \'sol_fiber\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="rd_sol_fiber" editable-number="feed.rd_sol_fiber" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rd_sol_fiber\', \'C\')" id="rd_sol_fiber{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rd_sol_fiber | formatViewValues: \'rd_sol_fiber\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_nfc | formatViewValues: \'td_nfc\'}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenm" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_nfc_\' | i18n}}" tooltip-is-open="nfcIsOpenm" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_">NFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_nfc_dig_\' | i18n}}" tooltip-is-open="nfcDigIsOpenm" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_digestibility_">NFC dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_nfc_">NFC</data-i18n></div></th><th style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpenm" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpenm" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpenm" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_infa_\' | i18n}}" tooltip-is-open="infaIsOpenm" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_infa_">infa</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_sol_fiber_\' | i18n}}" tooltip-is-open="solFiberIsOpenm" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_" dm=""></data-i18n></div></th><th st-sort="rd_sol_fiber" style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_rd_sol_fiber_\' | i18n}}" tooltip-is-open="rdSolFiberIsOpenm" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdsolf_">RDSolF</data-i18n><br>%<data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpenm" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'C\')" id="feed_nameMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.nfc | formatViewValues: \'nfc\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="nfc_dig" editable-number="mixfeed.nfc_dig" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" eblur="cancel" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'nfc_dig\', \'C\', feed.id)" id="nfc_digMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.nfc_dig | formatViewValues: \'nfc_dig\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="starch" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.starch" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'starch\', \'C\', feed.id)" id="starchMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.starch | formatViewValues: \'starch\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="rd_starch" editable-number="mixfeed.rd_starch" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rd_starch\', \'C\', feed.id)" id="rd_starchMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rd_starch | formatViewValues: \'rd_starch\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="sugar" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.sugar" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000" eblur="cancel" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'sugar\', \'C\', feed.id)" id="sugarMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.sugar | formatViewValues: \'sugar\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="in_fa" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.in_fa" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000" eblur="cancel" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'in_fa\', \'C\', feed.id)" id="in_faMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.in_fa | formatViewValues: \'in_fa\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.sol_fiber | formatViewValues: \'sol_fiber\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="rd_sol_fiber" editable-number="mixfeed.rd_sol_fiber" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rd_sol_fiber\', \'C\', feed.id)" id="rd_sol_fiberMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rd_sol_fiber | formatViewValues: \'rd_sol_fiber\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_nfc | formatViewValues: \'td_nfc\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/feedsCarb/feeds.carbohydrate.VemDve.html','<div><table ng-if="!vm.loadingTable && vm.settings.use_percent" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="9"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'rus\')"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rus_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rus_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'starch\')"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'starch_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'starch_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'rd_starch\')"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rd_starch_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rd_starch_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'sugar\')"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'sugar_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'sugar_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th style="width: 200px" ng-click="vm.sort(\'td_nfc\')"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'td_nfc_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'td_nfc_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'C\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" id="feed_name{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="rus" e-format-value-dm="feed.dm" editable-number="feed.rus" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rus\', \'C\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="rus{{$index}}C">{{feed.rus | formatViewValues: \'rus\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="starch" e-format-value-dm="feed.dm" editable-number="feed.starch" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'starch\', \'C\')" id="starch{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.starch | formatViewValues: \'starch\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="rd_starch" editable-number="feed.rd_starch" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rd_starch\', \'C\')" id="rd_starch{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="sugar" e-format-value-dm="feed.dm" editable-number="feed.sugar" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'sugar\', \'C\')" id="sugar{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_nfc | formatViewValues: \'td_nfc\'}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenm" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpenm" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpenm" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'C\')" id="feed_nameMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="rus" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.rus" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rus\', \'C\', feed.id)" id="rusMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rus | formatViewValues: \'rus\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="starch" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.starch" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'starch\', \'C\', feed.id)" id="starchMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.starch | formatViewValues: \'starch\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="rd_starch" editable-number="mixfeed.rd_starch" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rd_starch\', \'C\', feed.id)" id="rd_starchMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rd_starch | formatViewValues: \'rd_starch\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="sugar" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.sugar" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" eblur="cancel" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'sugar\', \'C\', feed.id)" id="sugarMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.sugar | formatViewValues: \'sugar\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_nfc | formatViewValues: \'td_nfc\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><table ng-if="!vm.loadingTable && !vm.settings.use_percent" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="9"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'rus\')"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rus_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rus_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'starch\')"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'starch_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'starch_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'rd_starch\')"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rd_starch_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rd_starch_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th style="width: 200px" class="editable-header" ng-click="vm.sort(\'sugar\')"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'sugar_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'sugar_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px" ng-click="vm.sort(\'td_nfc\')"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'td_nfc_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'td_nfc_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'C\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" id="feed_name{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="rus" e-format-value-dm="feed.dm" editable-number="feed.rus" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'rus\', \'C\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="rus{{$index}}C">{{feed.rus | formatViewValues: \'rus\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="starch" e-format-value-dm="feed.dm" editable-number="feed.starch" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'starch\', \'C\')" id="starch{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.starch | formatViewValues: \'starch\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="rd_starch" editable-number="feed.rd_starch" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rd_starch\', \'C\')" id="rd_starch{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="sugar" e-format-value-dm="feed.dm" editable-number="feed.sugar" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'sugar\', \'C\')" id="sugar{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_nfc | formatViewValues: \'td_nfc\'}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenm" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpenm" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpenm" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th style="width: 200px" class="editable-header"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'C\')" id="feed_nameMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="rus" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.rus" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rus\', \'C\', feed.id)" id="rusMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rus | formatViewValues: \'rus\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="starch" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.starch" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'starch\', \'C\', feed.id)" id="starchMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.starch | formatViewValues: \'starch\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="rd_starch" editable-number="mixfeed.rd_starch" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rd_starch\', \'C\', feed.id)" id="rd_starchMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rd_starch | formatViewValues: \'rd_starch\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="sugar" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.sugar" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000" eblur="cancel" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'sugar\', \'C\', feed.id)" id="sugarMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.sugar | formatViewValues: \'sugar\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_nfc | formatViewValues: \'td_nfc\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/feedsEnergy/feeds.energy.US.html','<div><table ng-if="!vm.loadingTable" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="9"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th ng-click="vm.sort(\'nel\')"><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'nel_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'nel_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.energy}}/{{vm.weight}}</div></th><th ng-click="vm.sort(\'me\')"><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me_">ME</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'me_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'me_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.energy}}/{{vm.weight}}</div></th><th class="editable-header" ng-click="vm.sort(\'discFac\')"><div uib-tooltip="{{\'_description_disc_fac_\' | i18n}}" tooltip-is-open="discFacIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_disc_fac_">Disc. Fac.</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'discFac_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'discFac_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%</div></th><th class="editable-header" ng-click="vm.sort(\'nel89\')"><div uib-tooltip="{{\'_description_nel_89_\' | i18n}}" tooltip-is-open="nel89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel89_">NEL 89</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'nel89_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'nel89_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.energy}}/{{vm.weight}}</div></th><th class="editable-header" ng-click="vm.sort(\'me89\')"><div uib-tooltip="{{\'_description_me_89_\' | i18n}}" tooltip-is-open="me89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me89_">ME 89</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'me89_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'me89_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.energy}}/{{vm.weight}}</div></th><th ng-click="vm.sort(\'dep\')"><div uib-tooltip="{{\'_description_dep_\' | i18n}}" tooltip-is-open="depIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dep_">DEp</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dep_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dep_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.energy}}/{{vm.weight}}</div></th><th ng-click="vm.sort(\'de1x\')"><div uib-tooltip="{{\'_description_de1x_\' | i18n}}" tooltip-is-open="de1xIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_de1x_">DE1X</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'de1x_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'de1x_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.energy}}/{{vm.weight}}</div></th><th ng-click="vm.sort(\'mftdn\')"><div uib-tooltip="{{\'_description_mftdn_\' | i18n}}" tooltip-is-open="mftdnIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mftdn_">MF-TDN</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'mftdn_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'mftdn_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th ng-click="vm.sort(\'tdn1x\')"><div uib-tooltip="{{\'_description_tdn1x_\' | i18n}}" tooltip-is-open="tdn1xIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdn1x_">TDN1X</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'tdn1x_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'tdn1x_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'E\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" id="feed_name{{$index}}E" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span>{{feed.nel | formatViewValues: \'nel\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.me | formatViewValues: \'me\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="disc_fac" editable-number="feed.disc_fac" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'disc_fac\', \'E\')" id="disc_fac{{$index}}E" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.disc_fac | formatViewValues: \'disc_fac\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="nel_89" editable-number="feed.nel_89" e-min="0" e-max="{{vm.nel_89Max}}" onbeforesave="vm.updateFeed(feed, $index, $data, \'nel_89\', \'E\')" id="nel_89{{$index}}E" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.nel_89 | formatViewValues: \'nel_89\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="me_89" editable-number="feed.me_89" e-min="0" e-max="{{vm.me_89max}}" onbeforesave="vm.updateFeed(feed, $index, $data, \'me_89\', \'E\')" id="me_89{{$index}}E" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.me_89 | formatViewValues: \'me_89\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.dep | formatViewValues: \'dep\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.de1x | formatViewValues: \'de1x\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.mftdn | formatViewValues: \'mftdn\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.tdn1x | formatViewValues: \'tdn1x\'}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpened" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpened" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpened" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me_">ME</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_disc_fac_\' | i18n}}" tooltip-is-open="discFacIsOpened" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_disc_fac_">Disc. Fac.</data-i18n><br>%</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_nel_89_\' | i18n}}" tooltip-is-open="nel89IsOpened" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel89_">NEL 89</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_me_89_\' | i18n}}" tooltip-is-open="me89IsOpened" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me89_">ME 89</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_dep_\' | i18n}}" tooltip-is-open="depIsOpened" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dep_">DEp</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_de1x_\' | i18n}}" tooltip-is-open="de1xIsOpened" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_de1x_">DE1X</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_mftdn_\' | i18n}}" tooltip-is-open="mftdnIsOpened" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mftdn_">MF-TDN</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_tdn1x_\' | i18n}}" tooltip-is-open="tdn1xIsOpened" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdn1x_">TDN1X</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'E\')" id="feed_nameMIX{{$index}}E{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.nel | formatViewValues: \'nel\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.me | formatViewValues: \'me\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="disc_fac" editable-number="mixfeed.disc_fac" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'disc_fac\', \'E\', feed.id)" id="disc_facMIX{{$index}}E{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.disc_fac | formatViewValues: \'disc_fac\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" e-format-input-value="nel_89" editable-number="mixfeed.nel_89" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="{{vm.nel_89Max}}" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'nel_89\', \'E\', feed.id)" id="nel_89MIX{{$index}}E{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.nel_89 | formatViewValues: \'nel_89\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" e-format-input-value="me_89" editable-number="mixfeed.me_89" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="{{vm.me_89max}}" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'me_89\', \'E\', feed.id)" id="me_89MIX{{$index}}E{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.me_89 | formatViewValues: \'me_89\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.dep | formatViewValues: \'dep\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.de1x | formatViewValues: \'de1x\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.mftdn | formatViewValues: \'mftdn\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.tdn1x | formatViewValues: \'tdn1x\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/feedsEnergy/feeds.energy.VemDve.html','<div><table ng-if="!vm.loadingTable" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="3"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th ng-click="vm.sort(\'amount\')"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'amount_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'amount_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.weight}}</div></th><th class="editable-header" ng-click="vm.sort(\'vem\')"><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">vem</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'vem_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'vem_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th class="editable-header" ng-click="vm.sort(\'fos\')"><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">fos</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'fos_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'fos_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'E\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" id="feed_name{{$index}}E" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span>{{(feed.amount | formatViewValues: \'amount\')}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-min="0" e-max="1000000" e-format-input-value="vem" editable-number="feed.vem" onbeforesave="vm.updateFeed(feed, $index, $data, \'vem\', \'E\')" id="vem{{$index}}E" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.vem | formatViewValues: \'vem\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-min="0" e-max="1000000" e-format-input-value="fos" e-format-value-dm="feed.dm" editable-number="feed.fos" onbeforesave="vm.updateFeed(feed, $index, $data, \'fos\', \'E\')" id="fos{{$index}}E" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.fos | formatViewValues: \'fos\': feed.dm}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">vem</data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">fos</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'E\')" id="feed_nameMIX{{$index}}E{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" e-format-input-value="vem" editable-number="mixfeed.vem" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'vem\', \'E\', feed.id)" id="vemMIX{{$index}}E{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.vem | formatViewValues: \'vem\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" e-format-input-value="fos" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.fos" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'fos\', \'E\', feed.id)" id="fosMIX{{$index}}E{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.fos | formatViewValues: \'fos\': mixfeed.dm}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/feedsHome/feeds.home.US.html','<div><table class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe" ng-if="!vm.loadingTable && vm.settings.use_percent"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="18"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px; text-align: center" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th class="editable-header" ng-click="vm.sort(\'dm\')"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%</span></div></th><th ng-click="vm.sort(\'nel\')"><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'nel_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'nel_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.energy}}/{{vm.weight}}</div></th><th ng-click="vm.sort(\'me\')"><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><data-i18n i18n="_feeds_me_">ME</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'me_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'me_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.energy}}/{{vm.weight}}</div></th><th class="editable-header" ng-click="vm.sort(\'ndf\')"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'cp\')"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th ng-click="vm.sort(\'rup\')"><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rup_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rup_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'rup_dig\')"><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rup_dig_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rup_dig_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th ng-click="vm.sort(\'fa\')"><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'fa_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'fa_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'ca\')"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ca_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ca_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'p\')"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'p_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'p_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'na\')"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'na_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'na_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th ng-click="vm.sort(\'dcad\')"><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dcad_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dcad_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th class="editable-header" ng-click="vm.sort(\'se\')"><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'se_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'se_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'vitamin_e\')"><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'vitamin_e_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'vitamin_e_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th ng-click="vm.sort(\'cost_dm\')"><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cost_dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cost_dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.currency}}/{{vm.weight}}</div></th><th style="min-width: 180px" class="editable-header" ng-click="vm.sort(\'test_date\')"><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'test_date_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'test_date_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th></tr></thead><tbody ng-show="vm.showTable"><tr ng-repeat-start="(indexX, feed) in vm.feeds" class="editable-tr-wrap" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" e-required="" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" e-ng-keydown="vm.feedKeyDown($event, $data)" id="feed_name{{$index}}H"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px">{{(feed.amount | formatViewValues: \'amount\')}}</td><td style="padding: 3px 3px">{{(feed.as_fed | formatViewValues: \'as_fed\')}}</td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="dm" editable-number="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'dm\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="dm{{$index}}H">{{feed.dm | formatViewValues: \'dm\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.nel | formatViewValues: \'nel\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.me | formatViewValues: \'me\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ndf" e-format-value-dm="feed.dm" editable-number="feed.ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="ndf{{$index}}H">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="cp" e-format-value-dm="feed.dm" editable-number="feed.cp" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'cp\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="cp{{$index}}H">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.rup | formatViewValues: \'rup\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="rup_dig" editable-number="feed.rup_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rup_dig\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="rup_dig{{$index}}H">{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.fa | formatViewValues: \'fa\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="ca" e-format-value-dm="feed.dm" editable-number="feed.ca" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ca\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="ca{{$index}}H">{{feed.ca | formatViewValues: \'ca\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="p" e-format-value-dm="feed.dm" editable-number="feed.p" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'p\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="p{{$index}}H">{{feed.p | formatViewValues: \'p\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="na" e-format-value-dm="feed.dm" editable-number="feed.na" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'na\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="na{{$index}}H">{{feed.na | formatViewValues: \'na\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.dcad | formatViewValues: \'dcad\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="se" editable-number="feed.se" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'se\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="se{{$index}}H">{{feed.se | formatViewValues: \'se\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="vitamin_e" editable-number="feed.vitamin_e" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'vitamin_e\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="vitamin_e{{$index}}H">{{feed.vitamin_e | formatViewValues: \'vitamin_e\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td style="padding: 3px 3px"><span><a href="#" editable-bsdate="feed.test_date" e-is-open="vm.opened.$data" e-ng-click="vm.open($event,\'$data\')" e-datepicker-popup="{{vm.date_format}}" onbeforesave="vm.updateFeed(feed, $index, $data, \'test_date\')" edit-disabled="!feed.team_id || feed.loading">{{(feed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</a></span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span>%</span></div></th><th><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><data-i18n i18n="_feeds_me_">ME</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br><br></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-if="feed.is_mix" ng-show="vm.dataCollapse[indexX]==true"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'H\')" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" e-format-input-value="amount" editable-number="mixfeed.amount" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'amount\', \'H\')" id="amountMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" e-format-input-value="as_fed" editable-number="mixfeed.as_fed" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'as_fed\', \'H\')" id="as_fedMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.as_fed | formatViewValues: \'as_fed\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="dm" editable-number="mixfeed.dm" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'dm\', \'H\', feed.id)" id="dmMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.dm | formatViewValues: \'dm\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.nel | formatViewValues: \'nel\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.me | formatViewValues: \'me\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="ndf" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ndf" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ndf\', \'H\', feed.id)" id="ndfMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf | formatViewValues: \'ndf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="cp" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.cp" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'cp\', \'H\', feed.id)" id="cpMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cp | formatViewValues: \'cp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.rup | formatViewValues: \'rup\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="rup_dig" editable-number="mixfeed.rup_dig" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rup_dig\', \'H\', feed.id)" id="rup_digMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rup_dig | formatViewValues: \'rup_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.fa | formatViewValues: \'fa\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" e-format-input-value="ca" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ca" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ca\', \'H\', feed.id)" id="caMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ca | formatViewValues: \'ca\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" e-format-input-value="p" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.p" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'p\', \'H\', feed.id)" id="pMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.p | formatViewValues: \'p\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" e-format-input-value="na" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.na" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'na\', \'H\', feed.id)" id="naMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.na | formatViewValues: \'na\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.dcad | formatViewValues: \'dcad\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" e-format-input-value="se" editable-number="mixfeed.se" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'se\', \'H\', feed.id)" id="seMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.se | formatViewValues: \'se\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="vitamin_e" editable-number="mixfeed.vitamin_e" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'vitamin_e\', \'H\', feed.id)" id="vitamin_eMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.vitamin_e | formatViewValues: \'vitamin_e\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td style="padding: 3px 3px"><span><a href="#" editable-bsdate="mixfeed.test_date" edit-disabled="vm.ingredientsLoading" e-is-open="vm.opened.$data" e-ng-click="vm.open($event,\'$data\')" e-datepicker-popup="{{vm.date_format}}" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'test_date\')">{{(mixfeed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</a></span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><table class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe" ng-if="!vm.loadingTable && !vm.settings.use_percent"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="18"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px; text-align: center" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th class="editable-header" ng-click="vm.sort(\'dm\')"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></div></th><th ng-click="vm.sort(\'nel\')"><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'nel_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'nel_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.energy}}/{{vm.weight}}</div></th><th ng-click="vm.sort(\'me\')"><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><data-i18n i18n="_feeds_me_">ME</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'me_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'me_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.energy}}/{{vm.weight}}</div></th><th class="editable-header" ng-click="vm.sort(\'ndf\')"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'cp\')"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th ng-click="vm.sort(\'rup\')"><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rup_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rup_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'rup_dig\')"><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rup_dig_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rup_dig_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th ng-click="vm.sort(\'fa\')"><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'fa_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'fa_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'ca\')"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ca_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ca_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'p\')"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'p_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'p_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'na\')"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'na_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'na_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th ng-click="vm.sort(\'dcad\')"><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dcad_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dcad_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th class="editable-header" ng-click="vm.sort(\'se\')"><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'se_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'se_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'vitamin_e\')"><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'vitamin_e_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'vitamin_e_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th ng-click="vm.sort(\'cost_dm\')"><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cost_dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cost_dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.currency}}/{{vm.weight}}</div></th><th style="min-width: 180px" class="editable-header" ng-click="vm.sort(\'test_date\')"><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'test_date_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'test_date_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th></tr></thead><tbody ng-show="vm.showTable"><tr ng-repeat-start="(indexX, feed) in vm.feeds" class="editable-tr-wrap" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" e-required="" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" e-ng-keydown="vm.feedKeyDown($event, $data)" id="feed_name{{$index}}H"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px">{{(feed.amount | formatViewValues: \'amount\')}}</td><td style="padding: 3px 3px">{{(feed.as_fed | formatViewValues: \'as_fed\')}}</td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="dm" editable-number="feed.dm" e-min="0" e-max="1000" onbeforesave="vm.updateFeed(feed, $index, $data, \'dm\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="dm{{$index}}H">{{feed.dm | formatViewValues: \'dm\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.nel | formatViewValues: \'nel\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.me | formatViewValues: \'me\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="ndf" e-format-value-dm="feed.dm" editable-number="feed.ndf" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="ndf{{$index}}H">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="cp" e-format-value-dm="feed.dm" editable-number="feed.cp" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'cp\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="cp{{$index}}H">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.rup | formatViewValues: \'rup\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="rup_dig" editable-number="feed.rup_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rup_dig\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="rup_dig{{$index}}H">{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.fa | formatViewValues: \'fa\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ca" e-format-value-dm="feed.dm" editable-number="feed.ca" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ca\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="ca{{$index}}H">{{feed.ca | formatViewValues: \'ca\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="p" e-format-value-dm="feed.dm" editable-number="feed.p" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'p\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="p{{$index}}H">{{feed.p | formatViewValues: \'p\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="na" e-format-value-dm="feed.dm" editable-number="feed.na" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'na\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="na{{$index}}H">{{feed.na | formatViewValues: \'na\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.dcad | formatViewValues: \'dcad\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="se" editable-number="feed.se" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'se\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="se{{$index}}H">{{feed.se | formatViewValues: \'se\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="vitamin_e" editable-number="feed.vitamin_e" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'vitamin_e\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="vitamin_e{{$index}}H">{{feed.vitamin_e | formatViewValues: \'vitamin_e\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td style="padding: 3px 3px"><span><a href="#" editable-bsdate="feed.test_date" e-is-open="vm.opened.$data" e-ng-click="vm.open($event,\'$data\')" e-datepicker-popup="{{vm.date_format}}" onbeforesave="vm.updateFeed(feed, $index, $data, \'test_date\')" edit-disabled="!feed.team_id || feed.loading">{{(feed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</a></span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><data-i18n i18n="_feeds_me_">ME</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br><br></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-if="feed.is_mix" ng-show="vm.dataCollapse[indexX]==true"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'H\')" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" e-format-input-value="amount" editable-number="mixfeed.amount" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'amount\', \'H\')" id="amountMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" e-format-input-value="as_fed" editable-number="mixfeed.as_fed" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'as_fed\', \'H\')" id="as_fedMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.as_fed | formatViewValues: \'as_fed\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="dm" editable-number="mixfeed.dm" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'dm\', \'H\', feed.id)" id="dmMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.dm | formatViewValues: \'dm\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.nel | formatViewValues: \'nel\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.me | formatViewValues: \'me\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="ndf" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ndf" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ndf\', \'H\', feed.id)" id="ndfMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf | formatViewValues: \'ndf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="cp" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.cp" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'cp\', \'H\', feed.id)" id="cpMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cp | formatViewValues: \'cp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.rup | formatViewValues: \'rup\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="rup_dig" editable-number="mixfeed.rup_dig" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rup_dig\', \'H\', feed.id)" id="rup_digMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rup_dig | formatViewValues: \'rup_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.fa | formatViewValues: \'fa\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="ca" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ca" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ca\', \'H\', feed.id)" id="caMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ca | formatViewValues: \'ca\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="p" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.p" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'p\', \'H\', feed.id)" id="pMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.p | formatViewValues: \'p\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="na" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.na" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'na\', \'H\', feed.id)" id="naMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.na | formatViewValues: \'na\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.dcad | formatViewValues: \'dcad\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" e-format-input-value="se" editable-number="mixfeed.se" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'se\', \'H\', feed.id)" id="seMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.se | formatViewValues: \'se\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="vitamin_e" editable-number="mixfeed.vitamin_e" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'vitamin_e\', \'H\', feed.id)" id="vitamin_eMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.vitamin_e | formatViewValues: \'vitamin_e\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td style="padding: 3px 3px"><span><a href="#" editable-bsdate="mixfeed.test_date" edit-disabled="vm.ingredientsLoading" e-is-open="vm.opened.$data" e-ng-click="vm.open($event,\'$data\')" e-datepicker-popup="{{vm.date_format}}" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'test_date\')">{{(mixfeed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</a></span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/feedsHome/feeds.home.VemDve.html','<div><table class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe" ng-if="!vm.loadingTable && vm.settings.use_percent"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="26"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px; text-align: center" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th ng-click="vm.sort(\'amount\')"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'amount_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'amount_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.weight}}</div></th><th ng-click="vm.sort(\'as_fed\')"><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'as_fed_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'as_fed_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.weight}}</div></th><th class="editable-header" ng-click="vm.sort(\'dm\')"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%</span></div></th><th ng-click="vm.sort(\'group_as_fed\')"><div uib-tooltip="{{\'_description_group_as_fed_\' | i18n}}" tooltip-is-open="groupAsFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_group_as_fed_">group as fed</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'group_as_fed_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'group_as_fed_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.weight}}</div></th><th ng-click="vm.sort(\'diet_dmi\')"><div uib-tooltip="{{\'_description_diet_dmi_\' | i18n}}" tooltip-is-open="dietDmiIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_diet_dmi_">diet dmi</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'diet_dmi_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'diet_dmi_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dmi_">dmi</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'vem\')"><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">vem</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'vem_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'vem_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th ng-click="vm.sort(\'dve\')" class="editable-header"><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dveIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">dve</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dve_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dve_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th ng-click="vm.sort(\'oeb\')" class="editable-header"><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oebIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">oeb</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'oeb_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'oeb_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'cp\')"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'fos\')"><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">fos</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'fos_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'fos_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'starch\')"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">neg</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'starch_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'starch_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'rus\')"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rus_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rus_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'sugar\')"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'sugar_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'sugar_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'ca\')"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ca_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ca_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'p\')"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'p_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'p_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'mg\')"><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">Mg</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'mg_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'mg_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'na\')"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'na_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'na_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'k\')"><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">K</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'k_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'k_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'cl\')"><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">Cl</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cl_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cl_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'s\')"><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">S</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'s_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'s_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th ng-click="vm.sort(\'adf\')" class="editable-header"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'adf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'adf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'lignin\')"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'lignin_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'lignin_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'ndf\')"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th ng-click="vm.sort(\'ef_ndf_as_ndf\')" class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ef_ndf_as_ndf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ef_ndf_as_ndf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th ng-click="vm.sort(\'ef_ndf_as_dm\')" class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_dm_\' | i18n}}" tooltip-is-open="efndfAsDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ef_ndf_as_dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ef_ndf_as_dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th style="min-width: 180px" class="editable-header" ng-click="vm.sort(\'test_date\')"><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'test_date_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'test_date_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th></tr></thead><tbody ng-show="vm.showTable"><tr ng-repeat-start="(indexX, feed) in vm.feeds" class="editable-tr-wrap" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected" style="margin-right: 2px"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" e-required="" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" e-ng-keydown="vm.feedKeyDown($event, $data)" id="feed_name{{$index}}H"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px">{{(feed.amount | formatViewValues: \'amount\')}}</td><td style="padding: 3px 3px">{{(feed.as_fed | formatViewValues: \'as_fed\')}}</td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="dm" editable-number="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'dm\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="dm{{$index}}H">{{feed.dm | formatViewValues: \'dm\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.group_as_fed | formatViewValues: \'group_as_fed\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.diet_dmi | formatViewValues: \'diet_dmi\'}}&nbsp;%</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="vem" editable-number="feed.vem" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'vem\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="vem{{$index}}H">{{feed.vem | formatViewValues: \'vem\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="dve" e-format-value-dm="feed.dm" editable-number="feed.dve" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'dve\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="dve{{$index}}H">{{feed.dve | formatViewValues: \'dve\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="oeb" e-format-value-dm="feed.dm" editable-number="feed.oeb" e-min="-1000000" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'oeb\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="oeb{{$index}}H">{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="cp" e-format-value-dm="feed.dm" editable-number="feed.cp" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'cp\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="cp{{$index}}H">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="fos" e-format-value-dm="feed.dm" editable-number="feed.fos" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'fos\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="fos{{$index}}H">{{feed.fos | formatViewValues: \'fos\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="starch" e-format-value-dm="feed.dm" editable-number="feed.starch" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'starch\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="starch{{$index}}H">{{feed.starch | formatViewValues: \'starch\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="rus" e-format-value-dm="feed.dm" editable-number="feed.rus" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rus\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="rus{{$index}}H">{{feed.rus | formatViewValues: \'rus\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="sugar" e-format-value-dm="feed.dm" editable-number="feed.sugar" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'sugar\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="sugar{{$index}}H">{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="ca" e-format-value-dm="feed.dm" editable-number="feed.ca" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ca\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="ca{{$index}}H">{{feed.ca | formatViewValues: \'ca\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="p" e-format-value-dm="feed.dm" editable-number="feed.p" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'p\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="p{{$index}}H">{{feed.p | formatViewValues: \'p\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="mg" e-format-value-dm="feed.dm" editable-number="feed.mg" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'mg\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="mg{{$index}}H">{{feed.mg | formatViewValues: \'mg\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="na" e-format-value-dm="feed.dm" editable-number="feed.na" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'na\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="na{{$index}}H">{{feed.na | formatViewValues: \'na\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="k" e-format-value-dm="feed.dm" editable-number="feed.k" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'k\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="k{{$index}}H">{{feed.k | formatViewValues: \'k\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="cl" e-format-value-dm="feed.dm" editable-number="feed.cl" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'cl\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="cl{{$index}}H">{{feed.cl | formatViewValues: \'cl\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.01" e-format-input-value="s" e-format-value-dm="feed.dm" editable-number="feed.s" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'s\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="s{{$index}}H">{{feed.s | formatViewValues: \'s\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="adf" e-format-value-dm="feed.dm" editable-number="feed.adf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'adf\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="adf{{$index}}H">{{feed.adf | formatViewValues: \'adf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="lignin" e-format-value-dm="feed.dm" editable-number="feed.lignin" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'lignin\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="lignin{{$index}}H">{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ndf" e-format-value-dm="feed.dm" editable-number="feed.ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="ndf{{$index}}H">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ef_ndf_as_ndf" editable-number="feed.ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ef_ndf_as_ndf\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="ef_ndf_as_ndf{{$index}}H">{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="padding: 3px 3px"><span><a href="#" editable-bsdate="feed.test_date" e-is-open="vm.opened.$data" e-ng-click="vm.open($event,\'$data\')" e-datepicker-popup="{{vm.date_format}}" onbeforesave="vm.updateFeed(feed, $index, $data, \'test_date\')" edit-disabled="!feed.team_id || feed.loading">{{(feed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</a></span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_group_as_fed_\' | i18n}}" tooltip-is-open="groupAsFedMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_group_as_fed_">group as fed</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_diet_dmi_\' | i18n}}" tooltip-is-open="dietDmiMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_diet_dmi_">diet dmi</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dmi_">dmi</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">vem</data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dveMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">dve</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oebMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">oeb</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">fos</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">neg</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">Mg</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">K</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">Cl</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">S</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_dm_\' | i18n}}" tooltip-is-open="efndfAsDmMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br><br></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-if="feed.is_mix" ng-show="vm.dataCollapse[indexX]==true"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'H\')" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="amount" editable-number="mixfeed.amount" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'amount\', \'H\')" id="amountMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" style="padding: 3px 3px">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="as_fed" editable-number="mixfeed.as_fed" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'as_fed\', \'H\')" id="as_fedMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" style="padding: 3px 3px">{{mixfeed.as_fed | formatViewValues: \'as_fed\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" ($event,="" $data)="" e-format-input-value="dm" editable-number="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'dm\', \'H\', feed.id)" id="dmMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" style="padding: 3px 3px">{{mixfeed.dm | formatViewValues: \'dm\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.group_as_fed | formatViewValues: \'group_as_fed\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.diet_dmi | formatViewValues: \'diet_dmi\'}}&nbsp;%</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="vem" editable-number="mixfeed.vem" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'vem\', \'H\', feed.id)" id="vemMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.vem | formatViewValues: \'vem\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="dve" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.dve" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'dve\', \'H\', feed.id)" id="dveMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.dve | formatViewValues: \'dve\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="oeb" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.oeb" e-min="-1000000" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'oeb\', \'H\', feed.id)" id="oebMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.oeb | formatViewValues: \'oeb\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="cp" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.cp" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'cp\', \'H\', feed.id)" id="cpMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cp | formatViewValues: \'cp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="fos" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.fos" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'fos\', \'H\', feed.id)" id="fosMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.fos | formatViewValues: \'fos\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="starch" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.starch" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'starch\', \'H\', feed.id)" id="starchMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.starch | formatViewValues: \'starch\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="rus" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.rus" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rus\', \'H\', feed.id)" id="rusMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rus | formatViewValues: \'rus\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="sugar" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.sugar" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'sugar\', \'H\', feed.id)" id="sugarMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.sugar | formatViewValues: \'sugar\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="ca" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ca" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ca\', \'H\', feed.id)" id="caMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ca | formatViewValues: \'ca\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="p" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.p" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'p\', \'H\', feed.id)" id="pMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.p | formatViewValues: \'p\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="mg" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.mg" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'mg\', \'H\', feed.id)" id="mgMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.mg | formatViewValues: \'mg\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="na" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.na" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'na\', \'H\', feed.id)" id="naMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.na | formatViewValues: \'na\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="k" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.k" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'k\', \'H\', feed.id)" id="kMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.k | formatViewValues: \'k\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="cl" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.cl" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'cl\', \'H\', feed.id)" id="clMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cl | formatViewValues: \'cl\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="s" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.s" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'s\', \'H\', feed.id)" id="sMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.s | formatViewValues: \'s\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="adf" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.adf" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'adf\', \'H\', feed.id)" id="adfMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.adf | formatViewValues: \'adf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="lignin" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.lignin" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'lignin\', \'H\', feed.id)" id="ligninMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.lignin | formatViewValues: \'lignin\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="ndf" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ndf" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ndf\', \'H\', feed.id)" id="ndfMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf | formatViewValues: \'ndf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="ef_ndf_as_ndf" editable-number="mixfeed.ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ef_ndf_as_ndf\', \'H\', feed.id)" id="ef_ndf_as_ndfMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="padding: 3px 3px"><span><a href="#" editable-bsdate="mixfeed.test_date" edit-disabled="vm.ingredientsLoading" e-is-open="vm.opened.$data" e-ng-click="vm.open($event,\'$data\')" e-datepicker-popup="{{vm.date_format}}" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'test_date\')">{{(mixfeed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</a></span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="28" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><table class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe" ng-if="!vm.loadingTable && !vm.settings.use_percent"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="26"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px; text-align: center" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th class="editable-header" ng-click="vm.sort(\'dm\')"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></div></th><th ng-click="vm.sort(\'group_as_fed\')"><div uib-tooltip="{{\'_description_group_as_fed_\' | i18n}}" tooltip-is-open="groupAsFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_group_as_fed_">group as fed</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'group_as_fed_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'group_as_fed_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.weight}}</div></th><th ng-click="vm.sort(\'diet_dmi\')"><div uib-tooltip="{{\'_description_diet_dmi_\' | i18n}}" tooltip-is-open="dietDmiIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_diet_dmi_">diet dmi</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'diet_dmi_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'diet_dmi_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dmi_">dmi</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'vem\')"><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">vem</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'vem_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'vem_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th ng-click="vm.sort(\'dve\')" class="editable-header"><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dveIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">dve</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dve_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dve_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th ng-click="vm.sort(\'oeb\')" class="editable-header"><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oebIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">oeb</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'oeb_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'oeb_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'cp\')"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'fos\')"><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">fos</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'fos_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'fos_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'starch\')"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">neg</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'starch_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'starch_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'rus\')"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rus_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rus_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'sugar\')"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'sugar_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'sugar_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'ca\')"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ca_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ca_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'p\')"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'p_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'p_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'mg\')"><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">Mg</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'mg_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'mg_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'na\')"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'na_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'na_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'k\')"><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">K</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'k_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'k_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'cl\')"><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">Cl</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cl_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cl_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'s\')"><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">S</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'s_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'s_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th ng-click="vm.sort(\'adf\')" class="editable-header"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'adf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'adf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'lignin\')"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'lignin_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'lignin_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'ndf\')"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th ng-click="vm.sort(\'ef_ndf_as_ndf\')" class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th ng-click="vm.sort(\'ef_ndf_as_dm\')" class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_dm_\' | i18n}}" tooltip-is-open="efndfAsDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th style="min-width: 180px" class="editable-header" ng-click="vm.sort(\'test_date\')"><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'test_date_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'test_date_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th></tr></thead><tbody ng-show="vm.showTable"><tr ng-repeat-start="(indexX, feed) in vm.feeds" class="editable-tr-wrap" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected" style="margin-right: 2px"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" e-required="" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" e-ng-keydown="vm.feedKeyDown($event, $data)" id="feed_name{{$index}}H"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px">{{(feed.amount | formatViewValues: \'amount\')}}</td><td style="padding: 3px 3px">{{(feed.as_fed | formatViewValues: \'as_fed\')}}</td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="dm" editable-number="feed.dm" e-min="0" e-max="1000" onbeforesave="vm.updateFeed(feed, $index, $data, \'dm\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="dm{{$index}}H">{{feed.dm | formatViewValues: \'dm\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.group_as_fed | formatViewValues: \'group_as_fed\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.diet_dmi | formatViewValues: \'diet_dmi\'}}&nbsp;%</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="vem" editable-number="feed.vem" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'vem\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="vem{{$index}}H">{{feed.vem | formatViewValues: \'vem\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="dve" e-format-value-dm="feed.dm" editable-number="feed.dve" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'dve\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="dve{{$index}}H">{{feed.dve | formatViewValues: \'dve\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="oeb" e-format-value-dm="feed.dm" editable-number="feed.oeb" e-min="-1000000" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'oeb\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="oeb{{$index}}H">{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="cp" e-format-value-dm="feed.dm" editable-number="feed.cp" e-min="0" e-max="1000" onbeforesave="vm.updateFeed(feed, $index, $data, \'cp\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="cp{{$index}}H">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="fos" e-format-value-dm="feed.dm" editable-number="feed.fos" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'fos\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="fos{{$index}}H">{{feed.fos | formatViewValues: \'fos\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="starch" e-format-value-dm="feed.dm" editable-number="feed.starch" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'starch\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="starch{{$index}}H">{{feed.starch | formatViewValues: \'starch\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="rus" e-format-value-dm="feed.dm" editable-number="feed.rus" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'rus\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="rus{{$index}}H">{{feed.rus | formatViewValues: \'rus\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="sugar" e-format-value-dm="feed.dm" editable-number="feed.sugar" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'sugar\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="sugar{{$index}}H">{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ca" e-format-value-dm="feed.dm" editable-number="feed.ca" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ca\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="ca{{$index}}H">{{feed.ca | formatViewValues: \'ca\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="p" e-format-value-dm="feed.dm" editable-number="feed.p" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'p\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="p{{$index}}H">{{feed.p | formatViewValues: \'p\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="mg" e-format-value-dm="feed.dm" editable-number="feed.mg" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'mg\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="mg{{$index}}H">{{feed.mg | formatViewValues: \'mg\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="na" e-format-value-dm="feed.dm" editable-number="feed.na" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'na\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="na{{$index}}H">{{feed.na | formatViewValues: \'na\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="k" e-format-value-dm="feed.dm" editable-number="feed.k" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'k\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="k{{$index}}H">{{feed.k | formatViewValues: \'k\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="cl" e-format-value-dm="feed.dm" editable-number="feed.cl" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'cl\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="cl{{$index}}H">{{feed.cl | formatViewValues: \'cl\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="s" e-format-value-dm="feed.dm" editable-number="feed.s" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'s\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="s{{$index}}H">{{feed.s | formatViewValues: \'s\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="adf" e-format-value-dm="feed.dm" editable-number="feed.adf" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'adf\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="adf{{$index}}H">{{feed.adf | formatViewValues: \'adf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="lignin" e-format-value-dm="feed.dm" editable-number="feed.lignin" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'lignin\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="lignin{{$index}}H">{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="ndf" e-format-value-dm="feed.dm" editable-number="feed.ndf" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="ndf{{$index}}H">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ef_ndf_as_ndf" editable-number="feed.ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ef_ndf_as_ndf\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="ef_ndf_as_ndf{{$index}}H">{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="padding: 3px 3px"><span><a href="#" editable-bsdate="feed.test_date" e-is-open="vm.opened.$data" e-ng-click="vm.open($event,\'$data\')" e-datepicker-popup="{{vm.date_format}}" onbeforesave="vm.updateFeed(feed, $index, $data, \'test_date\')" edit-disabled="!feed.team_id || feed.loading">{{(feed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</a></span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_group_as_fed_\' | i18n}}" tooltip-is-open="groupAsFedMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_group_as_fed_">group as fed</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_diet_dmi_\' | i18n}}" tooltip-is-open="dietDmiMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_diet_dmi_">diet dmi</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dmi_">dmi</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">vem</data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dveMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">dve</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oebMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">oeb</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">fos</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">neg</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">Mg</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">K</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">Cl</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">S</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_dm_\' | i18n}}" tooltip-is-open="efndfAsDmMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br><br></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-if="feed.is_mix" ng-show="vm.dataCollapse[indexX]==true"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'H\')" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="amount" editable-number="mixfeed.amount" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'amount\', \'H\')" id="amountMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" style="padding: 3px 3px">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.ingredientsLoading" e-format-input-value="as_fed" editable-number="mixfeed.as_fed" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'as_fed\', \'H\')" id="as_fedMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" style="padding: 3px 3px">{{mixfeed.as_fed | formatViewValues: \'as_fed\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="dm" editable-number="mixfeed.dm" e-min="0" e-max="1000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'dm\', \'H\', feed.id)" id="dmMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" style="padding: 3px 3px">{{mixfeed.dm | formatViewValues: \'dm\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.group_as_fed | formatViewValues: \'group_as_fed\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.diet_dmi | formatViewValues: \'diet_dmi\'}}&nbsp;%</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="vem" editable-number="mixfeed.vem" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'vem\', \'H\', feed.id)" id="vemMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.vem | formatViewValues: \'vem\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="dve" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.dve" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'dve\', \'H\', feed.id)" id="dveMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.dve | formatViewValues: \'dve\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="oeb" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.oeb" e-min="-1000000" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'oeb\', \'H\', feed.id)" id="oebMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.oeb | formatViewValues: \'oeb\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="cp" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.cp" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'cp\', \'H\', feed.id)" id="cpMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cp | formatViewValues: \'cp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="fos" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.fos" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'fos\', \'H\', feed.id)" id="fosMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.fos | formatViewValues: \'fos\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="starch" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.starch" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'starch\', \'H\', feed.id)" id="starchMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.starch | formatViewValues: \'starch\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="rus" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.rus" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rus\', \'H\', feed.id)" id="rusMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rus | formatViewValues: \'rus\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="sugar" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.sugar" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'sugar\', \'H\', feed.id)" id="sugarMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.sugar | formatViewValues: \'sugar\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="ca" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ca" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ca\', \'H\', feed.id)" id="caMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ca | formatViewValues: \'ca\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="p" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.p" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'p\', \'H\', feed.id)" id="pMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.p | formatViewValues: \'p\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="mg" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.mg" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'mg\', \'H\', feed.id)" id="mgMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.mg | formatViewValues: \'mg\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="na" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.na" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'na\', \'H\', feed.id)" id="naMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.na | formatViewValues: \'na\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="k" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.k" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'k\', \'H\', feed.id)" id="kMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.k | formatViewValues: \'k\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="cl" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.cl" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'cl\', \'H\', feed.id)" id="clMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cl | formatViewValues: \'cl\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="s" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.s" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'s\', \'H\', feed.id)" id="sMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.s | formatViewValues: \'s\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="adf" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.adf" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'adf\', \'H\', feed.id)" id="adfMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.adf | formatViewValues: \'adf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="lignin" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.lignin" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'lignin\', \'H\', feed.id)" id="ligninMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.lignin | formatViewValues: \'lignin\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" edit-disabled="vm.ingredientsLoading" e-format-input-value="ndf" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ndf" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ndf\', \'H\', feed.id)" id="ndfMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf | formatViewValues: \'ndf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.ingredientsLoading" e-format-input-value="ef_ndf_as_ndf" editable-number="mixfeed.ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ef_ndf_as_ndf\', \'H\', feed.id)" id="ef_ndf_as_ndfMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="padding: 3px 3px"><span><a href="#" editable-bsdate="mixfeed.test_date" edit-disabled="vm.ingredientsLoading" e-is-open="vm.opened.$data" e-ng-click="vm.open($event,\'$data\')" e-datepicker-popup="{{vm.date_format}}" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'test_date\')">{{(mixfeed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</a></span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="28" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/feedsProtein/feeds.protein.US.html','<div><table ng-if="!vm.loadingTable && vm.settings.use_percent" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="14"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th class="editable-header" ng-click="vm.sort(\'cp\')"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th ng-click="vm.sort(\'rup\')"><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rup_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rup_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th ng-click="vm.sort(\'rdp\')"><div uib-tooltip="{{\'_description_rdp_\' | i18n}}" tooltip-is-open="rdpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp_">rdp</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rdp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rdp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'rup_dig\')"><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rup_dig_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rup_dig_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th ng-click="vm.sort(\'aProt\')"><div uib-tooltip="{{\'_description_a_prot_\' | i18n}}" tooltip-is-open="AProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_a_">A Prot</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'aProt_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'aProt_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'bProt\')"><div uib-tooltip="{{\'_description_b_prot_\' | i18n}}" tooltip-is-open="BProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_b_">B Prot</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'bProt_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'bProt_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'cProt\')"><div uib-tooltip="{{\'_description_c_prot_\' | i18n}}" tooltip-is-open="CProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_c_">C Prot</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cProt_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cProt_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'kdBProt\')"><div uib-tooltip="{{\'_description_kd_bprot_\' | i18n}}" tooltip-is-open="kdBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kd_bprot_">kd bprot</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'kdBProt_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'kdBProt_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th ng-click="vm.sort(\'kpBProt\')"><div uib-tooltip="{{\'_description_kp_bprot_\' | i18n}}" tooltip-is-open="kpBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kp_bprot_">kp bprot</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'kpBProt_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'kpBProt_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'npncpe\')"><div uib-tooltip="{{\'_description_npncpe_\' | i18n}}" tooltip-is-open="npncpeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_npncpe_">NPNCPE</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'npncpe_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'npncpe_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'rup89\')"><div uib-tooltip="{{\'_description_rup_89_\' | i18n}}" tooltip-is-open="rup89IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup89_">rup 89</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rup89_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rup89_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'ndicp\')"><div uib-tooltip="{{\'_description_ndicp_\' | i18n}}" tooltip-is-open="ndicpIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndicp_">NDICP</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndicp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndicp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'adicp\')"><div uib-tooltip="{{\'_description_adicp_\' | i18n}}" tooltip-is-open="adicpIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'adicp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'adicp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th ng-click="vm.sort(\'tdTrup\')"><div uib-tooltip="{{\'_description_td_trup_\' | i18n}}" tooltip-is-open="tdtrupIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdtrup_">tdtrup</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'tdTrup_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'tdTrup_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\' , \'P\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" id="feed_name{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="cp" e-format-value-dm="feed.dm" editable-number="feed.cp" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'cp\' , \'P\')" id="cp{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.rup | formatViewValues: \'rup\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.rdp | formatViewValues: \'rdp\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="rup_dig" editable-number="feed.rup_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rup_dig\' , \'P\')" id="rup_dig{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.a_prot | formatViewValues: \'a_prot\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="b_prot" editable-number="feed.b_prot" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'b_prot\' , \'P\')" id="b_prot{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.b_prot | formatViewValues: \'b_prot\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="c_prot" editable-number="feed.c_prot" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'c_prot\' , \'P\')" id="c_prot{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.c_prot | formatViewValues: \'c_prot\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="kd_b_prot" editable-number="feed.kd_b_prot" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'kd_b_prot\' , \'P\')" id="kd_b_prot{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.kd_b_prot | formatViewValues: \'kd_b_prot\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.kp_b_prot | formatViewValues: \'kp_b_prot\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="npncpe" editable-number="feed.npncpe" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'npncpe\' , \'P\')" id="npncpe{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.npncpe | formatViewValues: \'npncpe\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="rup_89" editable-number="feed.rup_89" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rup_89\' , \'P\')" id="rup_89{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rup_89 | formatViewValues: \'rup_89\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ndicp" e-format-value-dm="feed.dm" editable-number="feed.ndicp" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndicp\' , \'P\')" id="ndicp{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndicp | formatViewValues: \'ndicp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="adicp" e-format-value-dm="feed.dm" editable-number="feed.adicp" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'adicp\' , \'P\')" id="adicp{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.adicp | formatViewValues: \'adicp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_trup | formatViewValues: \'td_trup\'}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rdp_\' | i18n}}" tooltip-is-open="rdpMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp_">rdp</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_a_prot_\' | i18n}}" tooltip-is-open="AProtMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_a_">A Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_b_prot_\' | i18n}}" tooltip-is-open="BProtMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_b_">B Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_c_prot_\' | i18n}}" tooltip-is-open="CProtMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_c_">C Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_kd_bprot_\' | i18n}}" tooltip-is-open="kdBprotMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kd_bprot_">kd bprot</data-i18n><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th><div uib-tooltip="{{\'_description_kp_bprot_\' | i18n}}" tooltip-is-open="kpBprotMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kp_bprot_">kp bprot</data-i18n><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_npncpe_\' | i18n}}" tooltip-is-open="npncpeMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_npncpe_">NPNCPE</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_rup_89_\' | i18n}}" tooltip-is-open="rup89MixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup89_">rup 89</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ndicp_\' | i18n}}" tooltip-is-open="ndicpMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndicp_">NDICP</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_adicp_\' | i18n}}" tooltip-is-open="adicpMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_td_trup_\' | i18n}}" tooltip-is-open="tdtrupMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdtrup_">tdtrup</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\' , \'P\')" id="feed_nameMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="cp" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.cp" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'cp\' , \'P\', feed.id)" id="cpMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cp | formatViewValues: \'cp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.rup | formatViewValues: \'rup\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.rdp | formatViewValues: \'rdp\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="rup_dig" editable-number="mixfeed.rup_dig" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rup_dig\' , \'P\', feed.id)" id="rup_digMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rup_dig | formatViewValues: \'rup_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.a_prot | formatViewValues: \'a_prot\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="b_prot" editable-number="mixfeed.b_prot" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'b_prot\' , \'P\', feed.id)" id="b_protMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.b_prot | formatViewValues: \'b_prot\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="c_prot" editable-number="mixfeed.c_prot" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'c_prot\' , \'P\', feed.id)" id="c_protMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.c_prot | formatViewValues: \'c_prot\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="kd_b_prot" editable-number="mixfeed.kd_b_prot" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'kd_b_prot\' , \'P\', feed.id)" id="kd_b_protMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.kd_b_prot | formatViewValues: \'kd_b_prot\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.kp_b_prot | formatViewValues: \'kp_b_prot\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="npncpe" editable-number="mixfeed.npncpe" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'npncpe\' , \'P\', feed.id)" id="npncpeMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.npncpe | formatViewValues: \'npncpe\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="rup_89" editable-number="mixfeed.rup_89" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rup_89\' , \'P\', feed.id)" id="rup_89MIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rup_89 | formatViewValues: \'rup_89\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="ndicp" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ndicp" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ndicp\' , \'P\', feed.id)" id="ndicpMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndicp | formatViewValues: \'ndicp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="adicp" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.adicp" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'adicp\' , \'P\', feed.id)" id="adicpMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.adicp | formatViewValues: \'adicp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_trup | formatViewValues: \'td_trup\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><table ng-if="!vm.loadingTable && !vm.settings.use_percent" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="14"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th class="editable-header" ng-click="vm.sort(\'cp\')"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th ng-click="vm.sort(\'rup\')"><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rup_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rup_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th ng-click="vm.sort(\'rdp\')"><div uib-tooltip="{{\'_description_rdp_\' | i18n}}" tooltip-is-open="rdpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp_">rdp</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rdp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rdp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'rup_dig\')"><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rup_dig_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rup_dig_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th ng-click="vm.sort(\'aProt\')"><div uib-tooltip="{{\'_description_a_prot_\' | i18n}}" tooltip-is-open="AProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_a_">A Prot</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'aProt_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'aProt_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'bProt\')"><div uib-tooltip="{{\'_description_b_prot_\' | i18n}}" tooltip-is-open="BProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_b_">B Prot</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'bProt_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'bProt_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'cProt\')"><div uib-tooltip="{{\'_description_c_prot_\' | i18n}}" tooltip-is-open="CProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_c_">C Prot</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cProt_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cProt_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'kdBProt\')"><div uib-tooltip="{{\'_description_kd_bprot_\' | i18n}}" tooltip-is-open="kdBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kd_bprot_">kd bprot</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'kdBProt_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'kdBProt_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th ng-click="vm.sort(\'kpBProt\')"><div uib-tooltip="{{\'_description_kp_bprot_\' | i18n}}" tooltip-is-open="kpBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kp_bprot_">kp bprot</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'kpBProt_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'kpBProt_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'npncpe\')"><div uib-tooltip="{{\'_description_npncpe_\' | i18n}}" tooltip-is-open="npncpeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_npncpe_">NPNCPE</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'npncpe_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'npncpe_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'rup89\')"><div uib-tooltip="{{\'_description_rup_89_\' | i18n}}" tooltip-is-open="rup89IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup89_">rup 89</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'rup89_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'rup89_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'ndicp\')"><div uib-tooltip="{{\'_description_ndicp_\' | i18n}}" tooltip-is-open="ndicpIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndicp_">NDICP</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndicp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndicp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'adicp\')"><div uib-tooltip="{{\'_description_adicp_\' | i18n}}" tooltip-is-open="adicpIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'adicp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'adicp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th ng-click="vm.sort(\'tdTrup\')"><div uib-tooltip="{{\'_description_td_trup_\' | i18n}}" tooltip-is-open="tdtrupIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdtrup_">tdtrup</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'tdTrup_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'tdTrup_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\' , \'P\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" id="feed_name{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="cp" e-format-value-dm="feed.dm" editable-number="feed.cp" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'cp\' , \'P\')" id="cp{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.rup | formatViewValues: \'rup\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.rdp | formatViewValues: \'rdp\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="rup_dig" editable-number="feed.rup_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rup_dig\' , \'P\')" id="rup_dig{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.a_prot | formatViewValues: \'a_prot\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="b_prot" editable-number="feed.b_prot" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'b_prot\' , \'P\')" id="b_prot{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.b_prot | formatViewValues: \'b_prot\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="c_prot" editable-number="feed.c_prot" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'c_prot\' , \'P\')" id="c_prot{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.c_prot | formatViewValues: \'c_prot\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="kd_b_prot" editable-number="feed.kd_b_prot" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'kd_b_prot\' , \'P\')" id="kd_b_prot{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.kd_b_prot | formatViewValues: \'kd_b_prot\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.kp_b_prot | formatViewValues: \'kp_b_prot\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="npncpe" editable-number="feed.npncpe" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'npncpe\' , \'P\')" id="npncpe{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.npncpe | formatViewValues: \'npncpe\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="rup_89" editable-number="feed.rup_89" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rup_89\' , \'P\')" id="rup_89{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rup_89 | formatViewValues: \'rup_89\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="ndicp" e-format-value-dm="feed.dm" editable-number="feed.ndicp" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndicp\' , \'P\')" id="ndicp{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndicp | formatViewValues: \'ndicp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="adicp" e-format-value-dm="feed.dm" editable-number="feed.adicp" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'adicp\' , \'P\')" id="adicp{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.adicp | formatViewValues: \'adicp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_trup | formatViewValues: \'td_trup\'}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rdp_\' | i18n}}" tooltip-is-open="rdpMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp_">rdp</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_a_prot_\' | i18n}}" tooltip-is-open="AProtMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_a_">A Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_b_prot_\' | i18n}}" tooltip-is-open="BProtMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_b_">B Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_c_prot_\' | i18n}}" tooltip-is-open="CProtMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_c_">C Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_kd_bprot_\' | i18n}}" tooltip-is-open="kdBprotMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kd_bprot_">kd bprot</data-i18n><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th><div uib-tooltip="{{\'_description_kp_bprot_\' | i18n}}" tooltip-is-open="kpBprotMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kp_bprot_">kp bprot</data-i18n><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_npncpe_\' | i18n}}" tooltip-is-open="npncpeMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_npncpe_">NPNCPE</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_rup_89_\' | i18n}}" tooltip-is-open="rup89MixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup89_">rup 89</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ndicp_\' | i18n}}" tooltip-is-open="ndicpMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndicp_">NDICP</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_adicp_\' | i18n}}" tooltip-is-open="adicpMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_td_trup_\' | i18n}}" tooltip-is-open="tdtrupMixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdtrup_">tdtrup</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\' , \'P\')" id="feed_nameMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="cp" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.cp" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'cp\' , \'P\', feed.id)" id="cpMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cp | formatViewValues: \'cp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.rup | formatViewValues: \'rup\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.rdp | formatViewValues: \'rdp\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="rup_dig" editable-number="mixfeed.rup_dig" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rup_dig\' , \'P\', feed.id)" id="rup_digMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rup_dig | formatViewValues: \'rup_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.a_prot | formatViewValues: \'a_prot\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="b_prot" editable-number="mixfeed.b_prot" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'b_prot\' , \'P\', feed.id)" id="b_protMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.b_prot | formatViewValues: \'b_prot\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="c_prot" editable-number="mixfeed.c_prot" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'c_prot\' , \'P\', feed.id)" id="c_protMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.c_prot | formatViewValues: \'c_prot\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="kd_b_prot" editable-number="mixfeed.kd_b_prot" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'kd_b_prot\' , \'P\', feed.id)" id="kd_b_protMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.kd_b_prot | formatViewValues: \'kd_b_prot\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.kp_b_prot | formatViewValues: \'kp_b_prot\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="npncpe" editable-number="mixfeed.npncpe" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'npncpe\' , \'P\', feed.id)" id="npncpeMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.npncpe | formatViewValues: \'npncpe\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="rup_89" editable-number="mixfeed.rup_89" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'rup_89\' , \'P\', feed.id)" id="rup_89MIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rup_89 | formatViewValues: \'rup_89\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="ndicp" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ndicp" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ndicp\' , \'P\', feed.id)" id="ndicpMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndicp | formatViewValues: \'ndicp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="adicp" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.adicp" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'adicp\' , \'P\', feed.id)" id="adicpMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.adicp | formatViewValues: \'adicp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_trup | formatViewValues: \'td_trup\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/feedsProtein/feeds.protein.VemDve.html','<div><table ng-if="!vm.loadingTable && vm.settings.use_percent" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="4"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th ng-click="vm.sort(\'amount\')"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'amount_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'amount_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>{{vm.weight}}</div></th><th class="editable-header" ng-click="vm.sort(\'cp\')"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'dve\')"><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dve07IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">DVE</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dve_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dve_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'oeb\')"><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oeb07IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">OEB</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'oeb_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'oeb_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\' , \'P\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" id="feed_name{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span>{{(feed.amount | formatViewValues: \'amount\')}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="cp" e-format-value-dm="feed.dm" editable-number="feed.cp" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'cp\' , \'P\')" id="cp{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="dve" e-format-value-dm="feed.dm" editable-number="feed.dve" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'dve\' , \'P\')" id="dve{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.dve | formatViewValues: \'dve\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="oeb" e-format-value-dm="feed.dm" editable-number="feed.oeb" e-min="-1000000" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'oeb\' , \'P\')" id="oeb{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dve07MixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">DVE</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oeb07MixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">OEB</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\' , \'P\')" id="feed_nameMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" e-format-input-value="cp" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.cp" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'cp\' , \'P\', feed.id)" id="cpMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cp | formatViewValues: \'cp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="dve" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.dve" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'dve\' , \'P\', feed.id)" id="dveMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.dve | formatViewValues: \'dve\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="oeb" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.oeb" edit-disabled="vm.ingredientsLoading" e-min="-1000000" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'oeb\' , \'P\', feed.id)" id="oebMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.oeb | formatViewValues: \'oeb\': mixfeed.dm}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><table ng-if="!vm.loadingTable && !vm.settings.use_percent" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="4"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th class="editable-header" ng-click="vm.sort(\'cp\')"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'dve\')"><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dve07IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">DVE</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dve_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dve_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header" ng-click="vm.sort(\'oeb\')"><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oeb07IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">OEB</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'oeb_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'oeb_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\' , \'P\')" edit-disabled="!feed.team_id || feed.loading" e-maxlength="60" id="feed_name{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span>{{(feed.amount | formatViewValues: \'amount\')}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="cp" e-format-value-dm="feed.dm" editable-number="feed.cp" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'cp\' , \'P\')" id="cp{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="dve" e-format-value-dm="feed.dm" editable-number="feed.dve" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'dve\' , \'P\')" id="dve{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.dve | formatViewValues: \'dve\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="oeb" e-format-value-dm="feed.dm" editable-number="feed.oeb" e-min="-1000000" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'oeb\' , \'P\')" id="oeb{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th class="editable-header"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpMixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dve07MixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">DVE</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oeb07MixIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">OEB</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\' , \'P\')" id="feed_nameMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="cp" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.cp" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'cp\' , \'P\', feed.id)" id="cpMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cp | formatViewValues: \'cp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="dve" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.dve" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'dve\' , \'P\', feed.id)" id="dveMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.dve | formatViewValues: \'dve\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="oeb" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.oeb" edit-disabled="vm.ingredientsLoading" e-min="-1000000" e-max="1000000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'oeb\' , \'P\', feed.id)" id="oebMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.oeb | formatViewValues: \'oeb\': mixfeed.dm}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/feedsLipid/feeds.lipid.US.html','<div><table ng-if="!vm.loadingTable && vm.settings.use_percent" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="8"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th class="editable-header" ng-click="vm.sort(\'ee\')"><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ee_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ee_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th ng-click="vm.sort(\'fa\')"><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'fa_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'fa_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th ng-click="vm.sort(\'sfa\')"><div uib-tooltip="{{\'_description_sfa_\' | i18n}}" tooltip-is-open="sfaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sfa_">SFA</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'sfa_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'sfa_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th ng-click="vm.sort(\'mufa\')"><div uib-tooltip="{{\'_description_mufa_\' | i18n}}" tooltip-is-open="mufaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mufa_">MUFA</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'mufa_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'mufa_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'pufa\')"><div uib-tooltip="{{\'_description_pufa_\' | i18n}}" tooltip-is-open="pufaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_pufa_">PUFA</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'pufa_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'pufa_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'bhfa\')"><div uib-tooltip="{{\'_description_bhfa_\' | i18n}}" tooltip-is-open="bhfaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_bhfa_">BHFA</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'bhfa_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'bhfa_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'faDig\')"><div uib-tooltip="{{\'_description_fa_dig_\' | i18n}}" tooltip-is-open="faDigIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_dig_">FA dig</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'faDig_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'faDig_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th ng-click="vm.sort(\'tdFa\')"><div uib-tooltip="{{\'_description_td_fa_\' | i18n}}" tooltip-is-open="tdFaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdfa_">td FA</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'tdFa_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'tdFa_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'L\')" edit-disabled="!feed.team_id || feed.loading" id="feed_name{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ee" e-format-value-dm="feed.dm" editable-number="feed.ee" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ee\', \'L\')" id="ee{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ee | formatViewValues: \'ee\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.fa | formatViewValues: \'fa\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.sfa | formatViewValues: \'sfa\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.mufa | formatViewValues: \'mufa\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="pufa" editable-number="feed.pufa" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'pufa\', \'L\')" id="pufa{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.pufa | formatViewValues: \'pufa\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="bhfa" editable-number="feed.bhfa" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'bhfa\', \'L\')" id="bhfa{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.bhfa | formatViewValues: \'bhfa\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="fa_dig" editable-number="feed.fa_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'fa_dig\', \'L\')" id="fa_dig{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.fa_dig | formatViewValues: \'fa_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_fa | formatViewValues: \'td_fa\'}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th class="editable-header" style="min-width: 250px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_sfa_\' | i18n}}" tooltip-is-open="sfaIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sfa_">SFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mufa_\' | i18n}}" tooltip-is-open="mufaIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mufa_">MUFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_pufa_\' | i18n}}" tooltip-is-open="pufaIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_pufa_">PUFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_bhfa_\' | i18n}}" tooltip-is-open="bhfaIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_bhfa_">BHFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_fa_dig_\' | i18n}}" tooltip-is-open="faDigIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_dig_">FA dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_td_fa_\' | i18n}}" tooltip-is-open="tdFaIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdfa_">td FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'L\')" id="feed_nameMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="ee" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ee" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ee\', \'L\', feed.id)" id="eeMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ee | formatViewValues: \'ee\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.fa | formatViewValues: \'fa\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.sfa | formatViewValues: \'sfa\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.mufa | formatViewValues: \'mufa\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="pufa" editable-number="mixfeed.pufa" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'pufa\', \'L\', feed.id)" id="pufaMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.pufa | formatViewValues: \'pufa\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="bhfa" editable-number="mixfeed.bhfa" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'bhfa\', \'L\', feed.id)" id="bhfaMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.bhfa | formatViewValues: \'bhfa\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="fa_dig" editable-number="mixfeed.fa_dig" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'fa_dig\', \'L\', feed.id)" id="fa_digMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.fa_dig | formatViewValues: \'fa_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_fa | formatViewValues: \'td_fa\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><table ng-if="!vm.loadingTable && !vm.settings.use_percent" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="8"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th class="editable-header" ng-click="vm.sort(\'ee\')"><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ee_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ee_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th ng-click="vm.sort(\'fa\')"><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'fa_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'fa_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th ng-click="vm.sort(\'sfa\')"><div uib-tooltip="{{\'_description_sfa_\' | i18n}}" tooltip-is-open="sfaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sfa_">SFA</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'sfa_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'sfa_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th ng-click="vm.sort(\'mufa\')"><div uib-tooltip="{{\'_description_mufa_\' | i18n}}" tooltip-is-open="mufaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mufa_">MUFA</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'mufa_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'mufa_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'pufa\')"><div uib-tooltip="{{\'_description_pufa_\' | i18n}}" tooltip-is-open="pufaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_pufa_">PUFA</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'pufa_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'pufa_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'bhfa\')"><div uib-tooltip="{{\'_description_bhfa_\' | i18n}}" tooltip-is-open="bhfaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_bhfa_">BHFA</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'bhfa_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'bhfa_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th class="editable-header" ng-click="vm.sort(\'faDig\')"><div uib-tooltip="{{\'_description_fa_dig_\' | i18n}}" tooltip-is-open="faDigIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_dig_">FA dig</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'faDig_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'faDig_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th ng-click="vm.sort(\'tdFa\')"><div uib-tooltip="{{\'_description_td_fa_\' | i18n}}" tooltip-is-open="tdFaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdfa_">td FA</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'tdFa_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'tdFa_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'L\')" edit-disabled="!feed.team_id || feed.loading" id="feed_name{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="ee" e-format-value-dm="feed.dm" editable-number="feed.ee" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ee\', \'L\')" id="ee{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ee | formatViewValues: \'ee\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.fa | formatViewValues: \'fa\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.sfa | formatViewValues: \'sfa\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.mufa | formatViewValues: \'mufa\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="pufa" editable-number="feed.pufa" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'pufa\', \'L\')" id="pufa{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.pufa | formatViewValues: \'pufa\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="bhfa" editable-number="feed.bhfa" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'bhfa\', \'L\')" id="bhfa{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.bhfa | formatViewValues: \'bhfa\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="fa_dig" editable-number="feed.fa_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'fa_dig\', \'L\')" id="fa_dig{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.fa_dig | formatViewValues: \'fa_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_fa | formatViewValues: \'td_fa\'}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th class="editable-header" style="min-width: 250px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_sfa_\' | i18n}}" tooltip-is-open="sfaIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sfa_">SFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mufa_\' | i18n}}" tooltip-is-open="mufaIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mufa_">MUFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_pufa_\' | i18n}}" tooltip-is-open="pufaIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_pufa_">PUFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_bhfa_\' | i18n}}" tooltip-is-open="bhfaIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_bhfa_">BHFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_fa_dig_\' | i18n}}" tooltip-is-open="faDigIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_dig_">FA dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_td_fa_\' | i18n}}" tooltip-is-open="tdFaIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdfa_">td FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'L\')" id="feed_nameMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="ee" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ee" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ee\', \'L\', feed.id)" id="eeMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ee | formatViewValues: \'ee\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.fa | formatViewValues: \'fa\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.sfa | formatViewValues: \'sfa\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.mufa | formatViewValues: \'mufa\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="pufa" editable-number="mixfeed.pufa" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'pufa\', \'L\', feed.id)" id="pufaMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.pufa | formatViewValues: \'pufa\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="bhfa" editable-number="mixfeed.bhfa" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'bhfa\', \'L\', feed.id)" id="bhfaMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.bhfa | formatViewValues: \'bhfa\'}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="fa_dig" editable-number="mixfeed.fa_dig" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'fa_dig\', \'L\', feed.id)" id="fa_digMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.fa_dig | formatViewValues: \'fa_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_fa | formatViewValues: \'td_fa\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/feeds/myfeeds/feedsLipid/feeds.lipid.VemDve.html','<div><table ng-if="!vm.loadingTable && vm.settings.use_percent" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="8"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th class="editable-header" ng-click="vm.sort(\'ee\')"><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ee_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ee_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'L\')" edit-disabled="!feed.team_id || feed.loading" id="feed_name{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="0.1" e-format-input-value="ee" e-format-value-dm="feed.dm" editable-number="feed.ee" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ee\', \'L\')" id="ee{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ee | formatViewValues: \'ee\': feed.dm}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th class="editable-header" style="min-width: 250px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'L\')" id="feed_nameMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" e-format-input-value="ee" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ee" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="100" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ee\', \'L\', feed.id)" id="eeMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ee | formatViewValues: \'ee\': mixfeed.dm}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><table ng-if="!vm.loadingTable && !vm.settings.use_percent" class="table table-bordered-striped" st-table="vm.feeds" st-safe-src="vm.feedsSafe"><thead><tr><th></th><th><input placeholder="{{\'_search_placeholder_feed_name_\' | i18n }}" class="input-sm form-control search-input" ng-model="vm.searchString" ng-change="vm.search()" style="margin-left: 3px"></th><th colspan="8"></th></tr><tr class="sortable" style="height: 30px"><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th style="min-width: 250px" class="editable-header" ng-click="vm.sort(\'feed_name\')"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><br></div></th><th class="editable-header" ng-click="vm.sort(\'ee\')"><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ee_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ee_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><td style="padding: 3px 3px; min-width: 150px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.editFeed(feed, $index)" ng-if="feed.team_id" uib-tooltip="{{vm.titleEdit | i18n}}" tooltip-is-open="editIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-edit"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToHistory(feed.id, feed.feed_locale)" ng-if="feed.team_id" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-arrow-return-left"></i></button> <a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id, feed)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expendIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750" ng-if="feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="feed.feed_name" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'L\')" edit-disabled="!feed.team_id || feed.loading" id="feed_name{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></td><td style="padding: 3px 3px"><span edit-disabled="!feed.team_id || feed.loading || feed.is_mix" e-step="1" e-format-input-value="ee" e-format-value-dm="feed.dm" editable-number="feed.ee" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ee\', \'L\')" id="ee{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ee | formatViewValues: \'ee\': feed.dm}}</span></td></tr><tr class="sortable rationThBackground" ng-show="vm.dataCollapse[$index]==true" ng-if="feed.is_mix" style="height: 30px"><th style="text-align: center"><data-i18n i18n="_title_column_action_">Action</data-i18n><br><br></th><th class="editable-header" style="min-width: 250px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feed_nameIsOpenMix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br><br></div></th><th class="editable-header"><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpenMix" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><td style="padding: 3px 3px"><button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" href="" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><i class="ion-minus-round"></i></button><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div></td><td style="padding: 3px 3px" class="shorten-long-text" uib-tooltip="{{mixfeed.feed_name}}" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text"><span style="white-space: nowrap !important" editable-text="mixfeed.feed_name" edit-disabled="vm.ingredientsLoading" e-required="" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'feed_name\', \'L\')" id="feed_nameMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></td><td style="padding: 3px 3px"><span e-step="1" e-format-input-value="ee" e-format-value-dm="mixfeed.dm" editable-number="mixfeed.ee" edit-disabled="vm.ingredientsLoading" e-min="0" e-max="10000" onbeforesave="vm.updateMix(mixfeed, $index, $data, \'ee\', \'L\', feed.id)" id="eeMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ee | formatViewValues: \'ee\': mixfeed.dm}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><uib-pagination boundary-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="10" ng-change="vm.paginationChanged()" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination></td></tr></tfoot></table><div align="center" ng-if="vm.loadingTable" style="overflow: hidden"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsCarb/balanceRation.carbohydrate.requirementsUS.html','<div ng-if="!vm.loadingTabs" class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th></th><th><data-i18n i18n="_feeds_amount_">amount</data-i18n></th><th><data-i18n i18n="_feeds_nfc_">NFC</data-i18n></th><th><data-i18n i18n="_feeds_nfc_digestibility_">NFC dig</data-i18n></th><th><data-i18n i18n="_feeds_starch_">starch</data-i18n></th><th><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n></th><th><data-i18n i18n="_feeds_sugar_">sugar</data-i18n></th><th><data-i18n i18n="_feeds_infa_">infa</data-i18n></th><th><data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n></th><th><data-i18n i18n="_feeds_rdsolf_">RDSolF</data-i18n></th><th><data-i18n i18n="_feeds_rdom_">rdom</data-i18n></th><th><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n></th></tr></thead><tbody ng-if="vm.settings.use_percent"><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_nfc_">NFC</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th></tr></tbody><tbody ng-if="!vm.settings.use_percent"><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_nfc_">NFC</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n class="nowrap" i18n="_rations_concentration_supplied_">Concentration supplied</data-i18n></td><td>{{vm.ration.concentration_supplied.amount_dm | formatViewValuesSignificant: \'amount\'}}</td><td>{{vm.ration.concentration_supplied.nfc | formatViewValuesSignificant: \'nfc\'}}</td><td>{{vm.ration.concentration_supplied.nfc_dig | formatViewValuesSignificant: \'nfc_dig\'}}</td><td>{{vm.ration.concentration_supplied.starch | formatViewValuesSignificant: \'starch\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.rd_starch | formatViewValuesSignificant: \'rd_starch\'}}</td><td>{{vm.ration.concentration_supplied.sugar | formatViewValuesSignificant: \'sugar\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.in_fa | formatViewValuesSignificant: \'in_fa\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.sol_fiber | formatViewValuesSignificant: \'sol_fiber\'}}</td><td>{{vm.ration.concentration_supplied.rd_sol_fiber | formatViewValuesSignificant: \'rd_sol_fiber\'}}</td><td>{{vm.ration.concentration_supplied.rdom | formatViewValuesSignificant: \'rdom\'}}</td><td>{{vm.ration.concentration_supplied.td_nfc | formatViewValuesSignificant: \'td_nfc\'}}</td></tr></tbody><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n i18n="_rations_supply_">Supply</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.supply.nfc | formatViewValuesPerDay: \'nfc\'}}</td><td>{{vm.ration.supply.nfc_dig | formatViewValuesPerDay: \'nfc_dig\'}}</td><td>{{vm.ration.supply.starch | formatViewValuesPerDay: \'starch\'}}</td><td>{{vm.ration.supply.rd_starch | formatViewValuesPerDay: \'rd_starch\'}}</td><td>{{vm.ration.supply.sugar | formatViewValuesPerDay: \'sugar\'}}</td><td>{{vm.ration.supply.in_fa | formatViewValuesPerDay: \'in_fa\'}}</td><td>{{vm.ration.supply.sol_fiber | formatViewValuesPerDay: \'sol_fiber\'}}</td><td>{{vm.ration.supply.rd_sol_fiber | formatViewValuesPerDay: \'rd_sol_fiber\'}}</td><td>{{vm.ration.supply.rdom | formatViewValuesPerDay: \'rdom\'}}</td><td>{{vm.ration.supply.td_nfc | formatViewValuesPerDay: \'td_nfc\'}}</td></tr><tr><td><data-i18n i18n="_rations_requirements_">Requirements</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.requirements.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr class="ration-difference"><td><data-i18n i18n="_rations_difference_">Difference</data-i18n></td><td><span ng-class="vm.ration.difference.amount_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.amount_dm | formatViewValuesPerDay: \'amount\'}}</span></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsCarb/balanceRation.carbohydrate.requirementsVemDve.html','<div ng-if="!vm.loadingTabs" class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th></th><th><data-i18n i18n="_feeds_amount_">amount</data-i18n></th><th><data-i18n i18n="_feeds_rus_">rus</data-i18n></th><th><data-i18n i18n="_feeds_starch_">starch</data-i18n></th><th><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n></th><th><data-i18n i18n="_feeds_sugar_">sugar</data-i18n></th><th><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n></th></tr></thead><tbody ng-if="vm.settings.use_percent"><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th></tr></tbody><tbody ng-if="!vm.settings.use_percent"><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n class="nowrap" i18n="_rations_concentration_supplied_">Concentration supplied</data-i18n></td><td>{{vm.ration.concentration_supplied.amount_dm | formatViewValuesSignificant: \'amount\'}}</td><td>{{vm.ration.concentration_supplied.rus | formatViewValuesSignificant: \'rus\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.starch | formatViewValuesSignificant: \'starch\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.rd_starch | formatViewValuesSignificant: \'rd_starch\'}}</td><td>{{vm.ration.concentration_supplied.sugar | formatViewValuesSignificant: \'sugar\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.td_nfc | formatViewValuesSignificant: \'td_nfc\'}}</td></tr></tbody><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n i18n="_rations_supply_">Supply</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.supply.rus | formatViewValuesPerDay: \'rus\'}}</td><td>{{vm.ration.supply.starch | formatViewValuesPerDay: \'starch\'}}</td><td>{{vm.ration.supply.rd_starch | formatViewValuesPerDay: \'rd_starch\'}}</td><td>{{vm.ration.supply.sugar | formatViewValuesPerDay: \'sugar\'}}</td><td>{{vm.ration.supply.td_nfc | formatViewValuesPerDay: \'td_nfc\'}}</td></tr><tr><td><data-i18n i18n="_rations_requirements_">Requirements</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.requirements.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td></td><td></td><td></td><td></td><td></td></tr><tr class="ration-difference"><td><data-i18n i18n="_rations_difference_">Difference</data-i18n></td><td><span ng-class="vm.ration.difference.amount_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.amount_dm | formatViewValuesPerDay: \'amount\'}}</span></td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsCarb/balanceRation.carbohydrateUS.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="carbTable" ng-if="vm.settings.use_percent"><thead><tr class="sortable"><th style="height: 77px" class="editable-header" st-sort="feed_name"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="nfc"><div uib-tooltip="{{\'_description_nfc_\' | i18n}}" tooltip-is-open="nfcIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_">NFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th style="min-width: 120px" st-sort="nfc_dig" class="editable-header"><div uib-tooltip="{{\'_description_nfc_dig_\' | i18n}}" tooltip-is-open="nfcDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_digestibility_">NFC dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_nfc_">NFC</data-i18n></div></th><th st-sort="starch" class="editable-header"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="rd_starch" class="editable-header"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th st-sort="sugar" class="editable-header"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="in_fa" class="editable-header"><div uib-tooltip="{{\'_description_infa_\' | i18n}}" tooltip-is-open="infaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_infa_">infa</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th style="min-width: 140px" st-sort="sol_fiber"><div uib-tooltip="{{\'_description_sol_fiber_\' | i18n}}" tooltip-is-open="solFiberIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th style="min-width: 155px" st-sort="rd_sol_fiber" class="editable-header"><div uib-tooltip="{{\'_description_rd_sol_fiber_\' | i18n}}" tooltip-is-open="rdSolFiberIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdsolf_">RDSolF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n></div></th><th st-sort="rdom"><div uib-tooltip="{{\'_description_rdom_\' | i18n}}" tooltip-is-open="rdomIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdom_">rdom</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="td_nfc"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody id="carbBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'C\')" id="amount{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.nfc | formatViewValues: \'nfc\'}}</span></td><td style="padding: 3px 3px; min-width: 120px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.nfc_dig" e-format-input-value="nfc_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'nfc_dig\', \'C\')" id="nfc_dig{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.nfc_dig | formatViewValues: \'nfc_dig\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.starch" e-format-input-value="starch" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'starch\', \'C\')" id="starch{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.starch | formatViewValues: \'starch\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.rd_starch" e-format-input-value="rd_starch" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rd_starch\', \'C\')" id="rd_starch{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.sugar" e-format-input-value="sugar" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'sugar\', \'C\')" id="sugar{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.in_fa" e-format-input-value="in_fa" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'in_fa\', \'C\')" id="in_fa{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.in_fa | formatViewValues: \'in_fa\': feed.dm}}</span></td><td style="padding: 3px 3px; min-width: 140px"><span>{{feed.sol_fiber | formatViewValues: \'sol_fiber\'}}</span></td><td style="padding: 3px 3px; min-width: 155px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.rd_sol_fiber" e-format-input-value="rd_sol_fiber" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rd_sol_fiber\', \'C\')" id="rd_sol_fiber{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rd_sol_fiber | formatViewValues: \'rd_sol_fiber\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.rdom | formatViewValues: \'rdom\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_nfc | formatViewValues: \'td_nfc\'}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.amount" e-format-input-value="amount" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'C\', feed.id)" id="amountMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.nfc | formatViewValues: \'nfc\'}}</span></td><td style="padding: 3px 3px; min-width: 120px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.nfc_dig" e-format-input-value="nfc_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'nfc_dig\', \'C\', feed.id)" id="nfc_digMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.nfc_dig | formatViewValues: \'nfc_dig\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.starch" e-format-input-value="starch" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'starch\', \'C\', feed.id)" id="starchMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.starch | formatViewValues: \'starch\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.rd_starch" e-format-input-value="rd_starch" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rd_starch\', \'C\', feed.id)" id="rd_starchMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rd_starch | formatViewValues: \'rd_starch\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.sugar" e-format-input-value="sugar" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'sugar\', \'C\', feed.id)" id="sugarMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.sugar | formatViewValues: \'sugar\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.in_fa" e-format-input-value="in_fa" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'in_fa\', \'C\', feed.id)" id="in_faMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.in_fa | formatViewValues: \'in_fa\': mixfeed.dm}}</span></td><td style="padding: 3px 3px; min-width: 140px"><span>{{mixfeed.sol_fiber | formatViewValues: \'sol_fiber\'}}</span></td><td style="padding: 3px 3px; min-width: 155px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.rd_sol_fiber" e-format-input-value="rd_sol_fiber" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rd_sol_fiber\', \'C\', feed.id)" id="rd_sol_fiberMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rd_sol_fiber | formatViewValues: \'rd_sol_fiber\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.rdom | formatViewValues: \'rdom\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_nfc | formatViewValues: \'td_nfc\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="carbTable" ng-if="!vm.settings.use_percent"><thead><tr class="sortable"><th style="height: 77px" class="editable-header"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="nfc"><div uib-tooltip="{{\'_description_nfc_\' | i18n}}" tooltip-is-open="nfcIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_">NFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th style="min-width: 120px" st-sort="nfc_dig" class="editable-header"><div uib-tooltip="{{\'_description_nfc_dig_\' | i18n}}" tooltip-is-open="nfcDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_digestibility_">NFC dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_nfc_">NFC</data-i18n></div></th><th st-sort="starch" class="editable-header"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="rd_starch" class="editable-header"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th st-sort="sugar" class="editable-header"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="in_fa" class="editable-header"><div uib-tooltip="{{\'_description_infa_\' | i18n}}" tooltip-is-open="infaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_infa_">infa</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="min-width: 140px" st-sort="sol_fiber"><div uib-tooltip="{{\'_description_sol_fiber_\' | i18n}}" tooltip-is-open="solFiberIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th style="min-width: 155px" st-sort="rd_sol_fiber" class="editable-header"><div uib-tooltip="{{\'_description_rd_sol_fiber_\' | i18n}}" tooltip-is-open="rdSolFiberIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdsolf_">RDSolF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n></div></th><th st-sort="rdom"><div uib-tooltip="{{\'_description_rdom_\' | i18n}}" tooltip-is-open="rdomIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdom_">rdom</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="td_nfc"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody id="carbBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'C\')" id="amount{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.nfc | formatViewValues: \'nfc\'}}</span></td><td style="padding: 3px 3px; min-width: 120px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.nfc_dig" e-format-input-value="nfc_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'nfc_dig\', \'C\')" id="nfc_dig{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.nfc_dig | formatViewValues: \'nfc_dig\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.starch" e-format-input-value="starch" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'starch\', \'C\')" id="starch{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.starch | formatViewValues: \'starch\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.rd_starch" e-format-input-value="rd_starch" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rd_starch\', \'C\')" id="rd_starch{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.sugar" e-format-input-value="sugar" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'sugar\', \'C\')" id="sugar{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.in_fa" e-format-input-value="in_fa" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'in_fa\', \'C\')" id="in_fa{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.in_fa | formatViewValues: \'in_fa\': feed.dm}}</span></td><td style="padding: 3px 3px; min-width: 140px"><span>{{feed.sol_fiber | formatViewValues: \'sol_fiber\'}}</span></td><td style="padding: 3px 3px; min-width: 155px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.rd_sol_fiber" e-format-input-value="rd_sol_fiber" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rd_sol_fiber\', \'C\')" id="rd_sol_fiber{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rd_sol_fiber | formatViewValues: \'rd_sol_fiber\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.rdom | formatViewValues: \'rdom\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_nfc | formatViewValues: \'td_nfc\'}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.amount" e-format-input-value="amount" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'C\', feed.id)" id="amountMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.nfc | formatViewValues: \'nfc\'}}</span></td><td style="padding: 3px 3px; min-width: 120px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.nfc_dig" e-format-input-value="nfc_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'nfc_dig\', \'C\', feed.id)" id="nfc_digMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.nfc_dig | formatViewValues: \'nfc_dig\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.starch" e-format-input-value="starch" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'starch\', \'C\', feed.id)" id="starchMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.starch | formatViewValues: \'starch\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.rd_starch" e-format-input-value="rd_starch" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rd_starch\', \'C\', feed.id)" id="rd_starchMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rd_starch | formatViewValues: \'rd_starch\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.sugar" e-format-input-value="sugar" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'sugar\', \'C\', feed.id)" id="sugarMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.sugar | formatViewValues: \'sugar\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.in_fa" e-format-input-value="in_fa" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'in_fa\', \'C\', feed.id)" id="in_faMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.in_fa | formatViewValues: \'in_fa\': mixfeed.dm}}</span></td><td style="padding: 3px 3px; min-width: 140px"><span>{{mixfeed.sol_fiber | formatViewValues: \'sol_fiber\'}}</span></td><td style="padding: 3px 3px; min-width: 155px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.rd_sol_fiber" e-format-input-value="rd_sol_fiber" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rd_sol_fiber\', \'C\', feed.id)" id="rd_sol_fiberMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rd_sol_fiber | formatViewValues: \'rd_sol_fiber\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.rdom | formatViewValues: \'rdom\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_nfc | formatViewValues: \'td_nfc\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsCarb/balanceRation.carbohydrateVemDve.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="carbTable" ng-if="vm.settings.use_percent"><thead><tr class="sortable"><th style="height: 77px" class="editable-header" st-sort="feed_name"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="rus" class="editable-header"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="starch" class="editable-header"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="rd_starch" class="editable-header"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th st-sort="sugar" class="editable-header"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="td_nfc"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody id="carbBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expandIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'C\')" id="amount{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.rus" e-format-input-value="rus" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rus\', \'C\')" id="rus{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rus | formatViewValues: \'rus\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.starch" e-format-input-value="starch" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'starch\', \'C\')" id="starch{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.starch | formatViewValues: \'starch\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.rd_starch" e-format-input-value="rd_starch" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rd_starch\', \'C\')" id="rd_starch{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.sugar" e-format-input-value="sugar" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'sugar\', \'C\')" id="sugar{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_nfc}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.amount" e-format-input-value="amount" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'C\', feed.id)" id="amountMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.rus" e-format-input-value="rus" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rus\', \'C\', feed.id)" id="rusMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rus | formatViewValues: \'rus\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.starch" e-format-input-value="starch" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'starch\', \'C\', feed.id)" id="starchMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.starch | formatViewValues: \'starch\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.rd_starch" e-format-input-value="rd_starch" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rd_starch\', \'C\', feed.id)" id="rd_starchMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rd_starch | formatViewValues: \'rd_starch\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.sugar" e-format-input-value="sugar" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'sugar\', \'C\', feed.id)" id="sugarMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.sugar | formatViewValues: \'sugar\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_nfc}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="carbTable" ng-if="!vm.settings.use_percent"><thead><tr class="sortable"><th style="height: 77px" class="editable-header"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="rus" class="editable-header"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="starch" class="editable-header"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="rd_starch" class="editable-header"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th st-sort="sugar" class="editable-header"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="td_nfc"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody id="carbBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expandIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'C\')" id="amount{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.rus" e-format-input-value="rus" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'rus\', \'C\')" id="rus{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rus | formatViewValues: \'rus\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.starch" e-format-input-value="starch" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'starch\', \'C\')" id="starch{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.starch | formatViewValues: \'starch\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.rd_starch" e-format-input-value="rd_starch" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rd_starch\', \'C\')" id="rd_starch{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.sugar" e-format-input-value="sugar" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'sugar\', \'C\')" id="sugar{{$index}}C" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_nfc}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.amount" e-format-input-value="amount" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'C\', feed.id)" id="amountMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.rus" e-format-input-value="rus" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rus\', \'C\', feed.id)" id="rusMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rus | formatViewValues: \'rus\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.starch" e-format-input-value="starch" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'starch\', \'C\', feed.id)" id="starchMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.starch | formatViewValues: \'starch\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.rd_starch" e-format-input-value="rd_starch" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rd_starch\', \'C\', feed.id)" id="rd_starchMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rd_starch | formatViewValues: \'rd_starch\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.sugar" e-format-input-value="sugar" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'sugar\', \'C\', feed.id)" id="sugarMIX{{$index}}C{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.sugar | formatViewValues: \'sugar\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_nfc}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/animalDescription.html','<div class="modal-content" ng-cloak=""><div class="modal-header"><div ng-if="!vm.modalLoading"><form name="vm.animalInfoForm" novalidate=""><div class="row"><div class="panel"><div class="panel-heading"><data-i18n i18n="_groups_panel_current_info_title_">Current information</data-i18n></div><div class="panel-body"><div class="form-group" ng-if="vm.selectedAnimalType ==\'lactating\' || vm.selectedAnimalType ==\'dry\'"><label for="cowStage"><data-i18n i18n="_groups_cow_stage_">Cow stage</data-i18n></label><ui-select ng-model="vm.group.cow_stage" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" id="cowStage" on-select="vm.cowStageChanged()"><ui-select-match placeholder="{{\'_picker_cow_stage_placeholder_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="stage in vm.cowStages | filter: $select.search"><span ng-bind-html="stage.name"></span></ui-select-choices></ui-select></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.lactationNumber.$invalid && (vm.animalInfoForm.lactationNumber.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType ==\'lactating\'"><label for="lactationNumber" class="span-label"><data-i18n i18n="_groups_lactation_number_">lactation number</data-i18n></label> <input type="number" class="form-control with-units" id="lactationNumber" name="lactationNumber" placeholder="{{\'_groups_lactation_number_\'|i18n}}" ng-model="vm.group.lactation_number" required="" min="0" max="20" step="1" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_lactation_number_required_">Lactation number(0-20) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.currentAge.$invalid && (vm.animalInfoForm.currentAge.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType ==\'heifer\'"><label for="currentAge" class="span-label"><data-i18n i18n="_groups_current_age_">Current age</data-i18n></label> <input type="number" class="form-control with-units" id="currentAge" name="currentAge" placeholder="{{\'_groups_current_age_\' | i18n}}" ng-model="vm.group.current_age" required="" min="1" max="36" step="1" select-on-click=""> <span><data-i18n i18n="_unit_months_">months</data-i18n></span><span class="help-block error-block basic-block"><data-i18n i18n="_groups_current_age_required_">Current age(1-36) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.daysInMilk.$invalid && (vm.animalInfoForm.daysInMilk.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType ==\'lactating\'"><label for="daysInMilk" class="span-label"><data-i18n i18n="_groups_days_in_milk_">Days in milk</data-i18n></label> <input type="number" class="form-control with-units" id="daysInMilk" name="daysInMilk" placeholder="{{\'_groups_days_in_milk_\' | i18n}}" ng-model="vm.group.days_in_milk" required="" min="0" max="2000" step="1" select-on-click=""> <span><data-i18n i18n="_unit_days_">days</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_days_in_milk_required_">Days in milk(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.upLacNumber.$invalid && (vm.animalInfoForm.upLacNumber.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType ==\'dry\'"><label for="upLacNumber"><data-i18n i18n="_groups_upcoming_lactation_number_">Upcoming lactation number</data-i18n></label> <input type="number" class="form-control" id="upLacNumber" name="upLacNumber" placeholder="{{\'_groups_upcoming_lactation_number_\'|i18n}}" ng-model="vm.group.upcoming_lactation_number" required="" min="1" max="21" step="1" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_upcoming_lactation_number_required_">Upcoming lactation number(1-21) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.daysToCalving.$invalid && (vm.animalInfoForm.daysToCalving.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType ==\'dry\'"><label for="daysToCalving" class="span-label"><data-i18n i18n="_groups_days_to_calving_">Days to calving</data-i18n></label> <input type="number" class="form-control with-units" id="daysToCalving" name="daysToCalving" placeholder="{{\'_groups_days_to_calving_\'|i18n}}" ng-model="vm.group.days_to_calving" required="" min="0" max="280" step="1" select-on-click=""><span><data-i18n i18n="_unit_days_">days</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_days_to_calving_required_">Days to calving(0-280) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.totalBodyWeight.$invalid && (vm.animalInfoForm.totalBodyWeight.$dirty || vm.animalInfoForm.$submitted)}"><label for="totalBodyWeight" class="span-label"><data-i18n i18n="_groups_total_bw_">Total body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="totalBodyWeight" name="totalBodyWeight" placeholder="{{\'_groups_total_bw_\'|i18n}}" ng-model="vm.group.total_bw" format-input-value="amount" required="" min="0" max="2000" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_total_bw_required_">Total body weight(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.bwWithoutFetus.$invalid && (vm.animalInfoForm.bwWithoutFetus.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType ==\'dry\'"><label for="bwWithoutFetus" class="span-label"><data-i18n i18n="_groups_bw_without_fetus_">Body weight without fetus</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="bwWithoutFetus" name="bwWithoutFetus" placeholder="{{\'_groups_bw_without_fetus_\'|i18n}}" ng-model="vm.group.bw_without_fetus" required="" min="0" max="2000" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_bw_without_fetus_required_">Body weight without fetus(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.matureBodyWeight.$invalid && (vm.animalInfoForm.matureBodyWeight.$dirty || vm.animalInfoForm.$submitted)}"><label for="matureBodyWeight" class="span-label"><data-i18n i18n="_groups_mature_bw_">Mature body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="matureBodyWeight" name="matureBodyWeight" placeholder="{{\'_groups_mature_bw_\'|i18n}}" ng-model="vm.group.mature_bw" required="" min="0" max="2000" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_mature_bw_required_">Mature body weight(0-2000) is reqired</data-i18n></span></div></div></div></div><div class="row"><div class="panel"><div class="panel-heading"><data-i18n i18n="_groups_panel_production_informations_">Production informations</data-i18n></div><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.targetMilkYield.$invalid && (vm.animalInfoForm.targetMilkYield.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType ==\'lactating\'"><label for="targetMilkYield" class="span-label"><data-i18n i18n="_groups_target_milk_yield_">Target milk yield</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetMilkYield" name="targetMilkYield" placeholder="{{\'_groups_target_milk_yield_\' | i18n}}" ng-model="vm.group.target_milk_yield" format-input-value="amount" required="" min="0" max="200" select-on-click=""><span>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_milk_yield_required_">Target milk yield(0-200) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.actualMilkYield.$invalid && (vm.animalInfoForm.actualMilkYield.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType ==\'lactating\'"><label for="actualMilkYieldr" class="span-label"><data-i18n i18n="_groups_actual_milk_yield_">Actual milk yield</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="actualMilkYield" name="actualMilkYield" placeholder="{{\'_groups_actual_milk_yield_\'|i18n}}" ng-model="vm.group.actual_milk_yield" format-input-value="actual_milk_yield" required="" min="0" max="200" select-on-click=""><span>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_actual_milk_yield_required_">Actual milk yield(0-200) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.targetFat.$invalid && (vm.animalInfoForm.targetFat.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType ==\'lactating\'"><label for="targetFat" class="span-label"><data-i18n i18n="_groups_target_fat_">Target Fat</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetFat" name="targetFat" placeholder="{{\'_groups_target_fat_\' | i18n}}" ng-model="vm.group.target_fat" required="" min="0" max="100" select-on-click=""><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_fat_required_">Target fat(0-100) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.actualFat.$invalid && (vm.animalInfoForm.actualFat.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType ==\'lactating\'"><label for="actualFat" class="span-label"><data-i18n i18n="_groups_actual_fat_">Actual fat</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="actualFat" name="actualFat" placeholder="{{\'_groups_actual_fat_\'|i18n}}" ng-model="vm.group.actual_fat" required="" min="0" max="100" select-on-click=""><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_actual_fat_required_">Actual fat(0-100) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.targetTProtein.$invalid && (vm.animalInfoForm.targetTProtein.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType ==\'lactating\'"><label for="targetTProtein" class="span-label"><data-i18n i18n="_groups_target_t_protein_">Target T Protein</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetTProtein" name="targetTProtein" placeholder="{{\'_groups_target_t_protein_\'|i18n}}" ng-model="vm.group.target_t_protein" required="" min="0" max="100" select-on-click=""><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_target_t_required_">Target T protein(0-100) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.actualTProtein.$invalid && (vm.animalInfoForm.actualTProtein.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType ==\'lactating\'"><label for="actualTProtein" class="span-label"><data-i18n i18n="_groups_actual_t_protein_">Actual T Protein</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="actualTProtein" name="actualTProtein" placeholder="{{\'_groups_actual_t_protein_\'|i18n}}" ng-model="vm.group.actual_t_protein" required="" min="0" max="100" select-on-click=""><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_actual_t_protein_required_">Actual T protein(0-100) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.targetLactose.$invalid && (vm.animalInfoForm.targetLactose.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType ==\'lactating\'"><label for="targetLactose" class="span-label"><data-i18n i18n="_groups_target_lactose_">Target lactose</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetLactose" name="targetLactose" placeholder="{{\'_groups_target_lactose_\'|i18n}}" ng-model="vm.group.target_lactose" required="" min="0" max="100" select-on-click=""><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_lactose_required_">Target lactose(0-100) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.actualLactose.$invalid && (vm.animalInfoForm.actualLactose.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType ==\'lactating\'"><label for="actualLactose" class="span-label"><data-i18n i18n="_groups_actual_lactose_">Actual lactose</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="actualLactose" name="actualLactose" placeholder="{{\'_groups_actual_lactose_\'|i18n}}" ng-model="vm.group.actual_lactose" required="" min="0" max="100" select-on-click=""> <span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_actual_lactose_required_">Actual lactose(0-100) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.farmsMilkPrice.$invalid && (vm.animalInfoForm.farmsMilkPrice.$dirty || vm.animalInfoForm.$submitted)}" ng-if="vm.selectedAnimalType ==\'lactating\'"><label for="farmsMilkPrice" class="span-label"><data-i18n i18n="_groups_farms_milk_price_">Farm\'s milk price</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="farmsMilkPrice" name="farmsMilkPrice" placeholder="{{\'_groups_farms_milk_price_\'|i18n}}" ng-model="vm.group.farms_milk_price" required="" min="0" max="1000" select-on-click=""><span></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_farms_milk_price_required_">Farm\'s milk price(0-1000) is reqired</data-i18n></span></div><div class="input-demo radio-demo row" ng-if="vm.selectedAnimalType ==\'lactating\'"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="price" id="price1" ng-value="1" ng-model="vm.group.is_price_per_one"> <span>{{vm.currency}}/{{vm.weight}}</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="price" id="price2" ng-value="0" ng-model="vm.group.is_price_per_one"> <span>{{vm.currency}}/100{{vm.weight}}</span></label></div></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.actualDmiPerCow.$invalid && (vm.animalInfoFormactualDmiPerCowe.$dirty || vm.animalInfoForm.$submitted)}"><label for="actualDmiPerCow" class="span-label"><data-i18n i18n="_groups_actual_dmi_per_cow_">Actual DMI per cow</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="actualDmiPerCow" name="actualDmiPerCow" placeholder="{{\'_groups_actual_dmi_per_cow_\'|i18n}}" ng-model="vm.group.actual_dmi_cow" required="" min="0" max="200" select-on-click=""><span>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_actual_dmi_per_cow_required_">Actual DMI per cow(0-200) is reqired</data-i18n></span></div></div></div><div class="panel" ng-if="vm.selectedAnimalType ==\'heifer\'"><div class="panel-heading"><data-i18n i18n="_groups_panel_target_informations_">Target informations</data-i18n></div><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.targetAge.$invalid && (vm.animalInfoForm.targetAge.$dirty || vm.animalInfoForm.$submitted)}"><label for="targetAge" class="span-label"><data-i18n i18n="_groups_target_age_">Target age</data-i18n></label> <input type="number" class="form-control with-units" id="targetAge" name="targetAge" placeholder="{{\'_groups_target_age_\'|i18n}}" ng-model="vm.group.target_age" required="" min="0" max="36" step="1" select-on-click=""><span><data-i18n i18n="_unit_months_">months</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_age_required_">Target age(current age - 36) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.targetNPBC3BW.$invalid && (vm.animalInfoForm.targetNPBC3BW.$dirty || vm.animalInfoForm.$submitted)}"><label for="targetNPBC3BW" class="span-label"><data-i18n i18n="_groups_non_pregnant_bc3_bw_">Non-pregnant BC3 body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetNPBC3BW" name="targetNPBC3BW" placeholder="{{\'_groups_non_pregnant_bc3_bw_\'|i18n}}" ng-model="vm.group.target_non_pregnant_bc3_bw" required="" min="0" max="2000" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_non_pregnant_bc3_bw_required_">Non-pregnant BC3 body weight(0-2000) is reqired</data-i18n></span></div></div></div><div class="panel" ng-if="vm.selectedAnimalType ==\'dry\'"><div class="panel-heading"><data-i18n i18n="_groups_panel_management_options_">Management options</data-i18n></div><div class="panel-body"><div class="form-group"><label for="dcad_strategy"><data-i18n i18n="_groups_dcad_strategy_">DCAD strategy</data-i18n></label><ui-select ng-model="vm.group.dcad_strategy" class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="true" search-enabled="true" id="dcad_strategy"><ui-select-match placeholder="{{\'_picker_dcad_strategy_placeholder_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="strategy in vm.strategies | filter: $select.search"><span ng-bind-html="strategy.name"></span></ui-select-choices></ui-select></div><div class="form-group" ng-class="{\'has-error\': vm.animalInfoForm.dmiAdjustment.$invalid && (vm.animalInfoForm.dmiAdjustment.$dirty || vm.animalInfoForm.$submitted)}"><label for="dmiAdjustment" class="span-label"><data-i18n i18n="_groups_dmi_adjustment_">DMI adjustment</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="dmiAdjustment" name="dmiAdjustment" placeholder="{{\'_groups_dmi_adjustment_\'|i18n}}" ng-model="vm.group.dmi_adjustment" required="" min="80" max="120" ng-disabled="true" select-on-click=""><span>%</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_dmi_adjustment_required_">DMI adjustment(80-120) is reqired</data-i18n></span></div></div></div></div><div class="row"><div class="panel"><div class="panel-heading"><data-i18n i18n="_groups_panel_predictions_target_animal_">Predictions from target animal</data-i18n></div><div class="panel-body"><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_predicted_base_dmi_">Predicted base DMI</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.predicted_base_dmi | formatViewValues: \'amount\'}}{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_predicted_adjusted_dmi_">Predicted adjusted DMI</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.predicted_adjusted_dmi}}{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_predicted_daily_gain_">Predicted daily gain</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.predicted_daily_gain | formatViewValues: \'amount\'}}{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row" ng-if="vm.group.animal_type.type!=\'heifer\'"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_required_nel_density_"></data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.required_nel_density}}{{vm.energy}}/{{vm.weight}}</label></div></div><div class="row" ng-if="vm.group.animal_type.type==\'heifer\'"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_required_nem_density_"></data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.required_nem_density}}{{vm.energy}}/{{vm.weight}}</label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_required_me_density_">Required ME density</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.required_me_density}}{{vm.energy}}/{{vm.weight}}</label></div></div></div></div></div><div align="right"><button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'animal_description\')"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button> <button type="submit" class="btn btn-info btn-with-icon save-profile" ng-click="vm.saveAnimalDescription()"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></form></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/animalEnvironmental.html','<div class="modal-content" ng-cloak=""><div class="modal-header"><div ng-if="!vm.modalLoading"><form name="vm.animalEnv" novalidate=""><div class="panel"><div class="panel-heading"><data-i18n i18n="_rations_panel_temperature_activity_">temperature and activity inputs</data-i18n></div><div class="panel-body"><div class="form-group"><label for="breed"><data-i18n i18n="_rations_temperature_stress_">temperature stress</data-i18n></label><ui-select ng-model="vm.selectedTemperatureStress" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="vm.tempStressSelected()" required="" id="breed"><ui-select-match placeholder="{{\'_picker_temp_stress_placeholder_\'|i18n}}">{{$select.selected.show_name}}</ui-select-match><ui-select-choices repeat="temperatureStress in vm.temperatureStresses | filter: $select.search"><span ng-bind-html="temperatureStress.show_name"></span></ui-select-choices></ui-select></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.animalEnv.tempStressEnergy.$invalid && (vm.animalEnv.tempStressEnergy.$dirty || vm.animalEnv.$submitted)}"><label for="tempStressEnergy" class="span-label"><data-i18n i18n="_rations_energy_">Energy</data-i18n></label> <input type="number" step="any" pattern="^\\d*(\\.\\d{0,2})?$" class="form-control with-units" id="tempStressEnergy" name="tempStressEnergy" placeholder="{{\'_rations_energy_\' | i18n}}" ng-model="vm.ts_maint_energy" required="" min="90" max="200" ng-change="vm.envChanged(\'ts_maint_energy\')" select-on-click=""> <span><data-i18n i18n="_unit_adj_percents_">adj. %</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_rations_energy_required_">Energy is reqired</data-i18n></span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.animalEnv.tempStressDMI.$invalid && (vm.animalEnv.tempStressDMI.$dirty || vm.animalEnv.$submitted)}"><label for="tempStressDMI" class="span-label"><data-i18n i18n="_feeds_dmi_">dmi</data-i18n></label> <input type="number" step="any" pattern="^\\d*(\\.\\d{0,2})?$" class="form-control with-units" id="tempStressDMI" name="tempStressDMI" placeholder="{{\'_feeds_dmi_\' | i18n}}" ng-model="vm.ts_dmi" required="" min="50" max="150" ng-change="vm.envChanged(\'ts_dmi\')" select-on-click=""> <span><data-i18n i18n="_unit_adj_percents_">adj. %</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_feeds_dmi_required_">DMI is reqired</data-i18n></span></div></div></div><div class="form-group"><label for="type"><data-i18n i18n="_rations_panel_activity_level_">Activity level</data-i18n></label><ui-select ng-model="vm.selectedActivityLevel" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="vm.activityLevelSelected()" required="" id="type"><ui-select-match placeholder="{{\'_picker_activity_level_\'|i18n}}">{{$select.selected.show_name}}</ui-select-match><ui-select-choices repeat="activityLevel in vm.activityLevels | filter: $select.search"><span ng-bind-html="activityLevel.show_name"></span></ui-select-choices></ui-select></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.animalEnv.activityLevelEnergy.$invalid && (vm.animalEnv.activityLevelEnergy.$dirty || vm.animalEnv.$submitted)}"><label for="activityLevelEnergy" class="span-label"><data-i18n i18n="_rations_energy_">Energy</data-i18n></label> <input type="number" step="any" pattern="^\\d*(\\.\\d{0,2})?$" class="form-control with-units" id="activityLevelEnergy" name="activityLevelEnergy" placeholder="{{\'_rations_energy_\' | i18n}}" ng-model="vm.al_maint_energy" required="" min="100" max="200" ng-change="vm.envChanged(\'al_maint_energy\')" select-on-click=""> <span><data-i18n i18n="_unit_adj_percents_">adj. %</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_rations_energy_required_">Energy is reqired</data-i18n></span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.animalEnv.activityLevelDMI.$invalid && (vm.animalEnv.activityLevelDMI.$dirty || vm.animalEnv.$submitted)}"><label for="activityLevelDMI" class="span-label"><data-i18n i18n="_feeds_dmi_">dmi</data-i18n></label> <input type="number" step="any" pattern="^\\d*(\\.\\d{0,2})?$" class="form-control with-units" id="activityLevelDMI" name="activityLevelDMI" placeholder="{{\'_feeds_dmi_\' | i18n}}" ng-model="vm.al_dmi" required="" min="80" max="150" ng-change="vm.envChanged(\'al_dmi\')" select-on-click=""> <span><data-i18n i18n="_unit_adj_percents_">adj. %</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_feeds_dmi_required_">DMI is reqired</data-i18n></span></div></div></div></div></div><div class="panel"><div class="panel-heading"><data-i18n i18n="_rations_panel_changes_to_ration_targets_">changest to ration targets</data-i18n></div><div class="panel-body" ng-if="!vm.loadingEnv"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_change_energy_requirement_">change to energy requirement</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.change_to_energy_requirement}} {{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_change_predicted_dmi_">change to predicted dmi</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.change_to_predicted_dmi }} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_change_energy_density_diet_">change to energy density of diet</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.change_to_energy_density }} %</label></div></div></div><div class="panel-body" ng-if="vm.loadingEnv" align="center"><div><div id="loading-animation-large" style="display: inline-block"></div></div></div></div><div align="right"><button type="submit" class="btn btn-success btn-with-icon save-profile" ng-click="vm.saveAnimalEnvironmental()"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'animal_stage_breed\')"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></form></div></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large" style="display: inline-block"></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/animalFeedAdditives.html','<div class="modal-content" ng-cloak=""><div class="modal-header"><div ng-if="!vm.modalLoading"><form name="vm.feedAdditives" novalidate=""><div class="panel"><div class="panel-heading"><data-i18n i18n="_rations_panel_set_feed_additives_">set feed additives</data-i18n></div><div class="panel-body"><div class="form-group"><label for="breed"><data-i18n i18n="_rations_description_">description</data-i18n></label><ui-select ng-model="vm.selectedFeedAdditives" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="vm.feedAdditiveSelected()" required="" id="breed"><ui-select-match placeholder="{{\'_picker_feed_aditives_placeholder_\'|i18n}}">{{$select.selected.show_name}}</ui-select-match><ui-select-choices repeat="feed_additive in vm.feed_additives | filter: $select.search"><span ng-bind-html="feed_additive.show_name"></span></ui-select-choices></ui-select></div><h3 class="with-line"><data-i18n i18n="_rations_feed_additives_change_performance_">% change in performance</data-i18n></h3><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.feedAdditives.energeticEff.$invalid && (vm.feedAdditives.energeticEff.$dirty || vm.feedAdditives.$submitted)}"><label for="energeticEff" class="span-label"><data-i18n i18n="_rations_energetic_efficiency_">Energetic efficiency</data-i18n></label> <input type="number" step="any" pattern="^\\d*(\\.\\d{0,2})?$" class="form-control" id="energeticEff" name="energeticEff" placeholder="{{\'_rations_energetic_efficiency_\' | i18n}}" ng-model="vm.energetic_efficiency" required="" min="80" max="120" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_rations_energetic_efficiency_required_">Energetic efficiency is reqired</data-i18n></span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.feedAdditives.micProtEff.$invalid && (vm.feedAdditives.micProtEff.$dirty || vm.feedAdditives.$submitted)}"><label for="micProtEff" class="span-label"><data-i18n i18n="_rations_mic_protein_efficiency_">mic. protein efficiency</data-i18n></label> <input type="number" step="any" pattern="^\\d*(\\.\\d{0,2})?$" class="form-control" id="micProtEff" name="micProtEff" placeholder="{{\'_rations_mic_protein_efficiency_\' | i18n}}" ng-model="vm.mic_protein_efficiency" required="" min="80" max="120" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_rations_mic_protein_efficiency_required_">Mic. protein efficiency is reqired</data-i18n></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.feedAdditives.rupEff.$invalid && (vm.feedAdditives.rupEff.$dirty || vm.feedAdditives.$submitted)}"><label for="rupEff" class="span-label"><data-i18n i18n="_rations_rup_efficiency_">rup efficiency</data-i18n></label> <input type="number" step="any" pattern="^\\d*(\\.\\d{0,2})?$" class="form-control" id="rupEff" name="rupEff" placeholder="{{\'_rations_rup_efficiency_\' | i18n}}" ng-model="vm.rup_efficiency" required="" min="80" max="120" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_rations_rup_efficiency_required_">RUP efficiency is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.feedAdditives.DMIFactor.$invalid && (vm.feedAdditives.DMIFactor.$dirty || vm.feedAdditives.$submitted)}"><label for="tempStressDMI" class="span-label"><data-i18n i18n="_rations_dmi_factor_">dmi factor</data-i18n></label> <input type="number" step="any" pattern="^\\d*(\\.\\d{0,2})?$" class="form-control" id="DMIFactor" name="DMIFactor" placeholder="{{\'_rations_dmi_factor_\' | i18n}}" ng-model="vm.dmi_factor" required="" min="80" max="120" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_rations_dmi_factor_required_">DMI factor is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.feedAdditives.maintReqt.$invalid && (vm.feedAdditives.maintReqt.$dirty || vm.feedAdditives.$submitted)}"><label for="maintReqt" class="span-label"><data-i18n i18n="_rations_maint_reqt_">maint. reqt.</data-i18n></label> <input type="number" step="any" pattern="^\\d*(\\.\\d{0,2})?$" class="form-control" id="maintReqt" name="maintReqt" placeholder="{{\'_rations_maint_reqt_\' | i18n}}" ng-model="vm.maint_reqt" required="" min="80" max="120" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_rations_maint_reqt_required_">Maint. reqt. is required</data-i18n></span></div></div></div><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="is_legal_additive" ng-model="vm.is_legal"> <span><data-i18n i18n="_rations_feed_additives_legal_statement_">Yes, this additive is legal for this animal class in my area.</data-i18n></span></label></div></div></div><div align="right"><button type="submit" class="btn btn-success btn-with-icon save-profile" ng-click="vm.saveAnimalFeedAdditives()" ng-disabled="vm.selectedFeedAdditives.value == \'_fa_ionophore_\' && !vm.is_legal"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'animal_stage_breed\')"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></form></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large" style="display: inline-block"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/animalGainPregnancy.html','<div class="modal-content" ng-cloak=""><div class="modal-header"><div ng-if="!vm.modalLoading"><form name="vm.bwGain" novalidate=""><div class="row"><div class="panel"><div class="panel-heading"><data-i18n i18n="_groups_panel_current_info_title_">Current informations</data-i18n></div><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.bwGain.totalBodyWeightG.$invalid && (vm.bwGain.totalBodyWeightG.$dirty || vm.bwGain.$submitted)}"><label for="totalBodyWeightG" class="span-label"><data-i18n i18n="_groups_total_bw_">Total body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="totalBodyWeightG" name="totalBodyWeightG" placeholder="{{\'_groups_total_bw_\'|i18n}}" ng-model="vm.group.total_bw" format-input-value="amount" required="" min="0" max="2000" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_total_bw_required_">Total body weight(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.bodyConditionScore.$invalid && (vm.bwGain.bodyConditionScore.$dirty || vm.bwGain.$submitted)}"><label for="bodyConditionScore" class="span-label"><data-i18n i18n="_groups_body_condition_score_">Body condition score</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="bodyConditionScore" name="bodyConditionScore" placeholder="{{\'_groups_body_condition_score_\' | i18n}}" ng-model="vm.group.body_condition_score" required="" min="0" max="5" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_body_condition_score_required_">Body condition score(0-5) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.daysPregnant.$invalid && (vm.bwGain.daysPregnant.$dirty || vm.bwGain.$submitted)}"><label for="daysPregnant" class="span-label"><data-i18n i18n="_groups_days_pregnant_">Days pregnant</data-i18n></label> <input type="number" class="form-control with-units" id="daysPregnant" name="daysPregnant" placeholder="{{\'_groups_days_pregnant_\'|i18n}}" ng-model="vm.group.days_pregnant" required="" min="0" max="280" step="1" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_days_in_milk_required_">Days pregnant(0-280) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.bwWithoutFetusG.$invalid && (vm.bwGain.bwWithoutFetusG.$dirty || vm.bwGain.$submitted)}"><label for="bwWithoutFetusG" class="span-label"><data-i18n i18n="_groups_bw_without_fetus_">Body weight without fetus</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="bwWithoutFetusG" name="bwWithoutFetusG" placeholder="{{\'_groups_bw_without_fetus_\'|i18n}}" ng-model="vm.group.bw_without_fetus" required="" min="0" max="2000" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_bw_without_fetus_required_">Body weight without fetus(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.nonPregnancyBC3BW.$invalid && (vm.bwGain.nonPregnancyBC3BW.$dirty || vm.bwGain.$submitted)}"><label for="nonPregnancyBC3BW" class="span-label"><data-i18n i18n="_groups_non_pregnant_bc3_bw_">Non-pregnant BC3 body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="nonPregnancyBC3BW" name="nonPregnancyBC3BW" placeholder="{{\'_groups_non_pregnant_bc3_bw_\'|i18n}}" ng-model="vm.group.non_pregnant_bc3_bw" required="" min="0" max="2000" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_non_pregnant_bc3_bw_required_">Non-pregnant BC3 body weight(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.matureBodyWeightG.$invalid && (vm.bwGain.matureBodyWeightG.$dirty || vm.bwGain.$submitted)}"><label for="matureBodyWeightG" class="span-label"><data-i18n i18n="_groups_mature_bw_">Mature body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="matureBodyWeightG" name="matureBodyWeightG" placeholder="{{\'_groups_mature_bw_\'|i18n}}" ng-model="vm.group.mature_bw" required="" min="0" max="2000" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_mature_bw_required_">Mature body weight(0-2000) is reqired</data-i18n></span></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_daily_pregnancy_gain_">Daily pregnancy gain</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.daily_pregnancy_gain | number:2}}{{vm.weight}}/<data-i18n i18n="_unit_day_"></data-i18n></label></div></div></div></div></div><div class="row"><div class="panel"><div class="panel-heading"><data-i18n i18n="_groups_panel_target_frame_growth_"></data-i18n>Target frame growth</div><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.bwGain.targetNPBC3BWG.$invalid && (vm.bwGain.targetNPBC3BWG.$dirty || vm.bwGain.$submitted)}"><label for="targetNPBC3BWG" class="span-label"><data-i18n i18n="_groups_target_non_pregnant_bc3_bw_">Non-pregnant BC3 body weight</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetNPBC3BWG" name="targetNPBC3BWG" placeholder="{{\'_groups_target_non_pregnant_bc3_bw_\'|i18n}}" ng-model="vm.group.target_non_pregnant_bc3_bw" required="" min="0" max="2000" select-on-click=""><span>{{vm.weight}}</span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_non_pregnant_bc3_bw_required_">Non-pregnant BC3 body weight(0-2000) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.daysTAFG.$invalid && (vm.bwGain.daysTAFG.$dirty || vm.bwGain.$submitted)}"><label for="daysTAFG" class="span-label"><data-i18n i18n="_groups_days_to_achieve_fg_">Days to achieve frame growth</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="daysTAFG" name="daysTAFG" placeholder="{{\'_groups_days_to_achieve_fg_\'|i18n}}" ng-model="vm.group.days_to_achieve_fg" required="" min="0" max="1100" select-on-click=""><span><data-i18n i18n="_unit_days_">days</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_days_to_achieve_fg_required_">Days to achieve frame growth(0-1100) is reqired</data-i18n></span></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_target_frame_growth_">Target frame growth</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.target_frame_growth | number:2}}{{vm.weight}}</label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_target_daily_fg_">Target daily frame growth</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.target_daily_fg | number:2}}{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div></div></div><div class="panel"><div class="panel-heading"><data-i18n i18n="_groups_panel_target_bc_gain_">Target body condition gain</data-i18n></div><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.bwGain.targetBCS.$invalid && (vm.bwGain.targetBCS.$dirty || vm.bwGain.$submitted)}"><label for="targetBCS" class="span-label"><data-i18n i18n="_groups_target_bc_score_">Target body condition score</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="targetBCS" name="targetBCS" placeholder="{{\'_groups_target_bc_score_\'|i18n}}" ng-model="vm.group.target_body_condition_score" required="" min="0" max="5" select-on-click=""><span></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_target_bc_score_required_">Target body condition score(0-5) is reqired</data-i18n></span></div><div class="form-group" ng-class="{\'has-error\': vm.bwGain.daysTABC.$invalid && (vm.bwGain.daysTABC.$dirty || vm.bwGain.$submitted)}"><label for="daysTABC" class="span-label"><data-i18n i18n="_groups_days_to_achieve_bc_">Days to achieve body condition</data-i18n></label> <input type="number" class="form-control with-units" id="daysTABC" name="daysTABC" placeholder="{{\'_groups_days_to_achieve_bc_\'|i18n}}" ng-model="vm.group.days_to_achieve_bc" required="" min="0" max="500" step="1" select-on-click=""><span><data-i18n i18n="_unit_days_">days</data-i18n></span> <span class="help-block error-block basic-block"><data-i18n i18n="_groups_days_to_achieve_bc_required_">Days to achieve body condition(0-500) is reqired</data-i18n></span></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_target_bc_gain_">Target body condition gain</data-i18n>:</label></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label>{{vm.group.target_body_condition_gain | number:2}}{{vm.weight}}</label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_target_daily_bc_gain_">Target daily body condition gain</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.target_daily_bc_gain | number:2}}{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div></div></div></div><div class="row"><div class="panel"><div class="panel-body"><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"><label><data-i18n i18n="_groups_target_daily_bw_gain_">Target daily body weight gain</data-i18n>:</label></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"><label>{{vm.group.target_daily_bw_gain | number:2}}{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div></div></div></div><div align="right"><button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'animal_stage_breed\')"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button> <button type="submit" class="btn btn-info btn-with-icon save-profile" ng-click="vm.saveAnimalGainPregnancy()"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></form></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/animalStageBreed.html','<div class="modal-content" ng-cloak=""><div class="modal-header"><div ng-if="!vm.modalLoading"><div class="form-group"><label for="breed"><data-i18n i18n="_groups_breed_">breed</data-i18n></label><ui-select ng-model="vm.modal.breed" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="vm.selected(\'breed\')" required="" id="breed"><ui-select-match placeholder="{{\'_picker_breed_placeholder_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="breed in vm.breeds | filter: $select.search"><span ng-bind-html="breed.name"></span></ui-select-choices></ui-select></div><div class="form-group"><label for="type"><data-i18n i18n="_groups_animal_type_">Animal Type</data-i18n></label><ui-select ng-model="vm.modal.animal_type" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="vm.selected(\'type\')" required="" id="type"><ui-select-match placeholder="{{\'_picker_animal_type_placeholder_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type in vm.animal_types | filter: $select.search"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div><div align="right"><button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'animal_stage_breed\')"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button> <button type="button" class="btn btn-info btn-with-icon save-profile" ng-click="vm.saveAnimalStageBreed()"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/batchReport.modal.html','<div class="modal-content"><div class="modal-body"><div ba-panel="" class="ng-cloak" ng-if="!vm.modalLoading"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{\'_report_heading_general_\'|i18n}}"><div class="form-group"><label for="feed_name"><data-i18n i18n="_rations_ration_name_">ration name</data-i18n></label> <input type="text" class="form-control" id="feed_name" ng-model="vm.batch.ration_name" required="" maxlength="30"></div><div class="form-group"><label for="preperedFor"><data-i18n i18n="_report_prepared_for_">prepered for</data-i18n></label> <textarea class="form-control" id="preperedFor" style="resize: none" maxlength="150" ng-model="vm.preperedFor"></textarea></div><div class="form-group"><label for="preperedBy"><data-i18n i18n="_report_prepared_by_">prepered by</data-i18n></label> <textarea class="form-control" id="preperedBy" style="resize: none" maxlength="150" ng-model="vm.preperedBy"></textarea></div></uib-tab><uib-tab heading="{{\'_report_heading_batch_settings_\'|i18n}}"><div class="form-group" style="margin-bottom: 2px"><label for="location_name"><data-i18n i18n="_report_location_name_">location name</data-i18n></label> <input type="text" class="form-control" id="location_name" placeholder="{{\'_report_location_name_\'|i18n}}" ng-model="vm.batch.location_name" required="" maxlength="30"></div><div class="form-group" style="margin-bottom: 2px"><label for="tmr_a_af"><data-i18n i18n="_report_tmr_amount_as_fed_">tmr amount as fed</data-i18n>:</label> <span>{{vm.batch.tmr_a_af}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></span></div><div class="form-group" style="margin-bottom: 2px"><label for="no_animals" class="span-label"><data-i18n i18n="_groups_no_animals_">number of animals</data-i18n></label> <input type="number" max="999999" min="1" step="1" class="form-control with-units" id="no_animals" ng-model="vm.batch.number_of_animals" ng-change="vm.batchNOAChanged()" select-on-click=""><span></span></div><div class="form-group" style="margin-bottom: 2px"><label for="group_increment_number" class="span-label"><data-i18n i18n="_report_group_increment_">group increment</data-i18n>(#)</label> <input type="number" step="1" min="1" class="form-control with-units" id="group_increment_number" ng-model="vm.batch.group_increment_number" ng-change="vm.batchGINChanged()" select-on-click=""><span>#<data-i18n i18n="_report_animals_">animals</data-i18n></span></div><div class="form-group" style="margin-bottom: 2px"><label for="group_increment_percent" class="span-label"><data-i18n i18n="_report_group_increment_">group increment</data-i18n>(%)</label> <input type="number" step="any" min="0.01" class="form-control with-units" id="group_increment_percent" ng-model="vm.batch.group_increment_percent" ng-change="vm.batchGIPChanged()" select-on-click=""><span>%</span></div><div class="form-group" style="margin-bottom: 2px"><label for="daily_af" class="span-label"><data-i18n i18n="_report_daily_amount_fed_">DM</data-i18n></label> <input type="number" step="any" max="999" min="0.01" class="form-control with-units" id="daily_af" ng-model="vm.batch.daily_af" ng-change="vm.batchDAFhanged()" select-on-click=""><span>%</span></div><div class="form-group" style="margin-bottom: 2px"><label for="batch_size" class="span-label"><data-i18n i18n="_report_batch_size_">Batch size</data-i18n></label> <input type="number" step="any" min="0.01" class="form-control with-units" id="batch_size" ng-model="vm.batch.batch_size" ng-change="vm.batchBShanged()" select-on-click=""><span>{{vm.weight}}</span></div><div class="form-group" style="margin-bottom: 2px"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="print_acc" ng-model="vm.batch.print_acc"> <span><data-i18n i18n="_report_print_accumulator_">print accumulator</data-i18n></span></label></div></uib-tab><uib-tab heading="{{\'_report_heading_mixing_order_\'|i18n}}"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/balanceRation/modals/batchReport.table.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_report_heading_finish_\'|i18n}}"><div class="form-group"><label for="aAndC"><data-i18n i18n="_report_assumptions_">Assumptions & Comments</data-i18n></label> <textarea class="form-control" id="aAndC" style="resize: none" ng-model="vm.aAndC"></textarea></div><div align="right"><button type="button" class="btn btn-success btn-with-icon save-profile" ng-click="vm.exportBatchReport()"><data-i18n i18n="_btn_export_pdf_">export</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'mixReport\')"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></uib-tab></uib-tabset></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/batchReport.table.html','<div class="vertical-scroll"><table class="table table-bordered-striped"><thead></thead><tr><th></th><th style="text-align: center"><data-i18n i18n="_feeds_name_">name</data-i18n><br></th><th style="text-align: center"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</th><th style="text-align: center"><data-i18n i18n="_report_fed_">Fed</data-i18n><br><data-i18n i18n="_report_separately_">Separately</data-i18n></th></tr><tbody ng-repeat="feed in vm.batch.feeds"><tr><td><a class="ion-arrow-up-b icon-edit" href="" ng-click="vm.reportBatchUp($index)" ng-if="$index != 0"></a><br ng-if="$index != 0"><a class="ion-arrow-down-b icon-edit" href="" ng-click="vm.reportBatchDown($index)" ng-if="$index != vm.reportBatchFeedIndexNo"></a></td><td>{{feed.feed_name}}</td><td>{{feed.as_fed | number: 2}}</td><td style="text-align: center"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-model="feed.fed_separately"> <label for="is_checked{{$index}}"></label></span></td></tr></tbody></table><div align="center" ng-if="vm.loadingTable"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/changeFeeds.modal.html','<div class="modal-content"><div class="modal-header"><div align="center"><span ng-if="vm.modalType != \'changeUnits\'" class="secondaryText"><data-i18n i18n="_title_unsaved_changes_continue_">unsaved changes</data-i18n></span> <span ng-if="vm.modalType == \'changeUnits\'" class="secondaryText"><data-i18n i18n="_title_unsaved_changes_save_ration_">unsaved changes</data-i18n></span></div></div><div class="modal-body"><div align="center"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="vm.continueModalOpen();$dismiss();"><data-i18n ng-if="vm.modalType != \'changeUnits\'" i18n="_btn_continue_">Continue</data-i18n><data-i18n ng-if="vm.modalType == \'changeUnits\'" i18n="_btn_continue_and_save_">Continue</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'change_feed_modal\');$dismiss();"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/changeGroup.html','<div class="modal-content" ng-cloak=""><div class="modal-header"><div ng-if="!vm.changeGroupModalLoading"><form name="vm.groupInfo" novalidate=""><div class="panel"><div class="panel-body"><div class="form-group"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.groupInfo.group.$invalid && (vm.groupInfo.group.$dirty || vm.groupInfo.$submitted)}"><label for="breed"><data-i18n i18n="_groups_group_name_">Group name</data-i18n></label><ui-select ng-model="vm.selectedGroupGroupChange" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" required="" id="group" name="group"><ui-select-match placeholder="{{\'_picker_group_placeholder_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="group in vm.groupsSelect | filter: $select.search"><span ng-bind-html="group.name"></span></ui-select-choices></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_groups_group_required_">group is required</data-i18n></span></div></div></div></div><div align="right"><button type="submit" class="btn btn-success btn-with-icon save-profile" ng-click="vm.changeGroup()"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></form></div><div style="height: 200px" ng-if="vm.changeGroupModalLoading && vm.selectedHerd" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div><div class="panel" ng-if="!vm.selectedHerd" align="center" ba-panel=""><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3><button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel()" style="float: right"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/changeOrder.modal.html','<div class="modal-content ration-change-order-modal"><div class="modal-header"><div align="center"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><i class="fa fa-times"></i></button></div></div><div class="modal-body"><div class="table-container"><table class="table" st-table="vm.rationOrderedList" st-safe-src="vm.rationOrderedListSafe"><thead><tr class="sortable"><th></th><th><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br></th><th><data-i18n i18n="_feeds_test_date_">Test date</data-i18n><br></th><th><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span></th><th><data-i18n i18n="_feeds_cp_">cp</data-i18n><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th><th><data-i18n i18n="_feeds_ndf_">ndf</data-i18n><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></span></th></tr></thead><tbody><tr ng-repeat="feed in vm.rationOrderedList"><td><a class="ion-arrow-up-a icon-edit" ng-class="$index == 0 ? \'hidden\' : \'\'" ng-click="vm.move(feed, \'up\')"></a> <a class="ion-arrow-down-a icon-edit" ng-class="$index == vm.ration.feeds.length - 1 ? \'hidden\' : \'\'" ng-click="vm.move(feed, \'down\')"></a></td><td>{{feed.feed_name}}</td><td>{{feed.test_date | date: \'shortDate\'}}</td><td>{{feed.dm | number: 2}}</td><td>{{feed.cp | number: 1}}</td><td>{{feed.ndf | number: 1}}</td></tr></tbody></table></div></div><div class="modal-footer"><div align="right"><button type="button" class="btn btn-md btn-danger" ng-click="vm.closeModal()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button> <button type="button" class="btn btn-md btn-success" ng-click="vm.updateOrder()"><data-i18n i18n="_m_f_btn_update_order_">Update order</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/confirmationDialog.modal.html','<div class="modal-content"><div class="modal-header" ng-if="!vm.modalLoading"><div align="center"><span class="ion-android-warning warningModal" style="font-size: 36px"></span></div><div align="center"><span class="warningModal">{{vm.warningMessage | i18n}}</span></div></div><div class="modal-body" ng-if="!vm.modalLoading"><div align="center"><button type="button" class="btn btn-with-icon save-profile" ng-class="vm.warningMessage == \'_feeds_delete_warning_message_\' ? \'btn-primary\' : \'btn-primary\'" ng-click="vm.proceed(vm.warningMessage)"><span class="defaultModal" ng-if="vm.warningMessage == \'_feeds_delete_warning_message_\'"><data-i18n i18n="_btn_delete_">Delete</data-i18n></span> <span class="defaultModal" ng-if="vm.warningMessage == \'_feeds_remove_from_mix_warning_message_\'"><data-i18n i18n="_btn_remove_from_mix_">Remove</data-i18n></span> <span class="defaultModal" ng-if="vm.warningMessage == \'_feeds_unmix_warning_message_\'"><data-i18n i18n="_btn_unmix_">Unmix</data-i18n></span> <span class="defaultModal" ng-if="vm.warningMessage == \'_feeds_convert_warning_message_\'"><data-i18n i18n="_btn_convert_">Convert</data-i18n></span></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.modalLoading" align="center"><div><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/createMix.modal.html','<div class="modal-content" ng-cloak=""><div ng-if="!vm.modalLoading"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title"><data-i18n i18n="_feeds_set_amount_label_">set amounts for feed</data-i18n></h4></div><form name="vm.createMixForm"><div class="row" style="margin-left: 5px; margin-right: 5px; margin-bottom: 10px"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><input type="text" maxlength="60" class="form-control with-units" placeholder="{{\'_feeds_name_\' | i18n}}" ng-model="vm.mix_name" required="" select-on-click=""></div></div><div ng-repeat="feed in vm.listOfFeeds"><div><div class="row" style="margin-left: 5px; margin-right: 5px"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xsm-12"><label style="padding-top: 10px; margin-top: 20px" class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</label></div><div class="col-xlg-3 col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.createMixForm.amount{{$index}}.$invalid}"><label><data-i18n i18n="_feeds_amount_">Amount</data-i18n>&nbsp;({{vm.weight}})</label> <input type="number" step="any" class="form-control" placeholder="{{\'_feeds_amount_\' | i18n}}" ng-model="feed.amount" format-input-value="amount" pattern="^\\d*(\\.\\d{0,3})?$" required="" min="0" name="amount{{$index}}" ng-change="vm.changeAmount(feed)" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_not_valid_">Value not valid</data-i18n></span></div></div><div class="col-xlg-3 col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.createMixForm.as_fed{{$index}}.$invalid}"><label><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n>&nbsp;({{vm.weight}})</label> <input type="number" step="any" class="form-control" placeholder="{{\'_feeds_as_fed_\' | i18n}}" ng-model="feed.as_fed" format-input-value="as_fed" pattern="^\\d*(\\.\\d{0,3})?$" required="" min="0" name="as_fed{{$index}}" ng-change="vm.changeAsFed(feed)" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_value_not_valid_">Value not valid</data-i18n></span></div></div></div></div></div></form><div class="row" ng-if="!vm.modalLoading" style="margin-left: 5px; margin-right: 5px"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group"><div ng-if="!vm.loading"><ui-select style="z-index: 90000 !important" ng-model="vm.defaultCalculation" class="btn-group bootstrap-select form-control" ng-disabled="vm.loadingTable" append-to-body="true" search-enabled="true"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.defaultCalculationList | filter: $select.search"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="vm.saveMIX()" ng-disabled="vm.createMixForm.$invalid"><data-i18n i18n="_btn_feed_save_mix_">Save PREMIX</data-i18n></button> <button type="button" class="btn btn-danger" ng-click="vm.cancel(\'create_mix\')"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div></div><div class="modal-footer"><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/insertFeed.modal.html','<div ba-panel="" class="ng-cloak"><div class="panel-group" ng-if="!vm.modalLoading"><div style="margin-top: 10px" class="row" ng-if="vm.selectedTeam"><div style="margin-bottom: 10px; padding-left: 5px; padding-right: 5px" class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="btn-group" role="group" aria-label="Basic example" id="e0"><button type="button" class="btn btn-primary no-border-radius" ng-click="vm.addAll(\'ration\')"><data-i18n i18n="_btn_feed_add_all_">Add all</data-i18n></button> <button type="button" class="btn btn-danger no-border-radius" ng-click="vm.cancel(\'insert_feed\')"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><div ba-panel="" ba-panel-title="{{\'_feeds_imort_feeds_panel_available_feeds_\'|i18n}}" ba-panel-class="with-scroll xmedium-panel"><div include-with-scope="app/pages/rations/balanceRation/modals/insertFeed.sourceTable.html"></div></div></div><div style="padding-left: 5px; padding-right: 5px" class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="btn-group" role="group" id="e0"><button type="button" class="btn btn-danger no-border-radius" ng-click="vm.removeAll()"><data-i18n i18n="_btn_feed_remove_all_">Remove all</data-i18n></button> <button type="button" class="btn btn-primary no-border-radius" ng-click="vm.insertFeeds()"><data-i18n i18n="_btn_feed_insert_">insert</data-i18n></button></div><div ba-panel="" ba-panel-title="{{\'_feeds_insert_feeds_panel_feeds_insert_\'|i18n}}" ba-panel-class="with-scroll xmedium-panel"><div include-with-scope="app/pages/rations/balanceRation/modals/insertFeed.table.html"></div></div></div></div><div ng-if="!vm.selectedTeam" align="center"><div><h3><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></h3><button type="button" class="btn btn-danger no-border-radius" ng-click="vm.cancel(\'insert_feed\')"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div></div></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large" style="display: inline-block"></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/insertFeed.sourceTable.html','<div class="vertical-scroll"><table class="table-header-fixed auto-scroll" st-table="vm.feedsByTeam"><thead><tr ng-if="!vm.hideFilters"><th colspan="6" style="width: 100%"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_feeds_search_feeds_label_">dsadrch feeds</data-i18n></label> <input placeholder="{{\'_search_placeholder_feed_name_\'|i18n}}" class="form-control" type="text" ng-model="vm.searchMaster" id="feedsSearchInput" ng-change="vm.searchChanged(\'ration\')"></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_picker_feed_type_placeholder_">Select feed type</data-i18n></label><ui-select style="z-index: 9000 !important" ng-model="vm.feedCategotyItem" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.feedTypeChanged(\'ration\')"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.feedCategotyList | filter: $select.search" ui-disable-choice="vm.feedCategotyItem.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_feeds_common_">Common</data-i18n></label><ui-select style="z-index: 9000 !important" ng-model="vm.commonFeedItem" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.commonFeedChanged(\'ration\')"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type in vm.commonFeedList | filter: $select.search" ui-disable-choice="vm.commonFeedItem.name == type.name"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_settings_calculation_type_title_">type</data-i18n></label><ui-select style="z-index: 90000 !important" ng-model="vm.defaultCalculation" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.defaultCalculationChanged(\'ration\')"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.defaultCalculationList | filter: $select.search" ui-disable-choice="vm.defaultCalculation.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_feeds_my_master_">my/master</data-i18n></label><ui-select style="z-index: 9000 !important" ng-model="vm.selectedFeedType" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.feedTypeSelected(\'ration\')"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.filterTypes | filter: $select.search" ui-disable-choice="vm.selectedFeedType.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div></th></tr><tr class="show-hide-filters"><td><button ng-click="vm.hideFilters = !vm.hideFilters"><i ng-if="!vm.hideFilters" class="ion-arrow-up-b"></i><i ng-if="vm.hideFilters" class="ion-arrow-down-b"></i><span><data-i18n i18n="_modal_show_hide_filters_">Show/hide filters</data-i18n></span><i ng-if="!vm.hideFilters" class="ion-arrow-up-b"></i><i ng-if="vm.hideFilters" class="ion-arrow-down-b"></i></button></td></tr><tr class="sortable" style="margin-right: 15px"><th style="width: 10%"></th><th ng-click="vm.sort(\'feed_name\', \'ration\')" style="width: 20%"><data-i18n i18n="_feeds_name_">Feed name</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br></th><th ng-click="vm.sort(\'test_date\', \'ration\')" style="width: 19%"><data-i18n i18n="_feeds_test_date_">Test date</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'test_date_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'test_date_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br></th><th ng-click="vm.sort(\'dm\', \'ration\')" style="width: 17%"><data-i18n i18n="_feeds_dm_">dm</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span></th><th ng-click="vm.sort(\'cp\', \'ration\')" style="width: 17%"><data-i18n i18n="_feeds_cp_">cp</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th><th ng-click="vm.sort(\'ndf\', \'ration\')" style="width: 17%"><data-i18n i18n="_feeds_ndf_">ndf</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th></tr></thead><tbody style="overflow-y: auto" infinite-scroll="" scroll-fn="vm.paginationChanged(\'ration\')" scroll-no-all="vm.totalItemsMaster" scroll-no-displayed="vm.feedsByTeam.length" scroll-disable="vm.disableScroll" ng-if="vm.feedsLoaded"><tr ng-click="vm.addSelected(feed.id, \'ration\')" ng-hide="feed.feed_name == null" ng-repeat="feed in vm.feedsByTeam" style="margin-top: 5px; margin-bottom: 5px"><td style="width: 10%"><button type="button" class="btn btn-primary btn-xs" style="border-radius: 50%; transform: none"><i class="ion-plus-round"></i></button></td><td style="width: 20%">{{feed.feed_name}}</td><td style="width: 19%">{{feed.test_date | date: vm.date_format}}</td><td style="width: 17%">{{feed.dm | number: 2}}</td><td style="width: 17%">{{feed.cp| number: 1}}</td><td style="width: 17%">{{feed.ndf | number: 1}}</td></tr><tr ng-if="vm.disableScroll"><td style="width: 100%" align="center"><data-i18n i18n="_title_loading_">Loading...</data-i18n></td></tr></tbody><tbody style="overflow: hidden" ng-if="!vm.feedsLoaded"><tr><td style="width: 100%" align="center"><div id="loading-animation-large"></div></td></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/insertFeed.table.html','<div class="horizontal-scroll"><table class="table-header-fixed auto-scroll" st-table="vm.importList" st-safe-src="vm.importListSafe"><thead><tr class="sortable" style="margin-right: 15px"><th style="width: 10%"></th><th st-sort="feed_name" st-sort-default="true" style="width: 20%"><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br></th><th st-sort="test_date" style="width: 19%"><data-i18n i18n="_feeds_test_date_">Test date</data-i18n><br></th><th st-sort="dm" style="width: 17%"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span></th><th st-sort="cp" style="width: 17%"><data-i18n i18n="_feeds_cp_">cp</data-i18n><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th><th st-sort="NDF" style="width: 17%"><data-i18n i18n="_feeds_ndf_">ndf</data-i18n><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th></tr></thead><tbody><tr ng-click="vm.removeSelected(feed.id)" ng-repeat="feed in vm.importList track by $index" style="margin-top: 5px; margin-bottom: 5px"><td style="width: 10%"><button type="button" class="btn btn-danger btn-xs" style="border-radius: 50%; transform: none"><i class="ion-minus-round"></i></button></td><td style="width: 20%">{{feed.feed_name}}</td><td style="width: 19%">{{feed.test_date | date:\'mediumDate\'}}</td><td style="width: 17%">{{feed.dm | number: 2}}</td><td style="width: 17%">{{feed.cp| number: 1}}</td><td style="width: 17%">{{feed.ndf | number: 1}}</td></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/insertFeedToMix.modal.html','<div ba-panel="" class="ng-cloak"><div class="panel-group" ng-if="!vm.modalLoading"><div style="margin-top: 10px" class="row" ng-if="vm.selectedTeam"><div style="margin-bottom: 10px; padding-left: 5px; padding-right: 5px" class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="btn-group" role="group" aria-label="Basic example" id="e0"><button type="button" class="btn btn-primary no-border-radius" ng-click="vm.addAll(\'mix\')"><data-i18n i18n="_btn_feed_add_all_">Add all</data-i18n></button> <button type="button" class="btn btn-danger no-border-radius" ng-click="vm.cancel(\'insert_feed\')"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div><div ba-panel="" ba-panel-title="{{\'_feeds_imort_feeds_panel_available_feeds_\'|i18n}}" ba-panel-class="with-scroll xmedium-panel"><div include-with-scope="app/pages/rations/balanceRation/modals/insertFeedToMix.sourceTable.html"></div></div></div><div style="padding-left: 5px; padding-right: 5px" class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="btn-group" role="group" id="e0"><button type="button" class="btn btn-danger no-border-radius" ng-click="vm.removeAll()"><data-i18n i18n="_btn_feed_remove_all_">Remove all</data-i18n></button> <button type="button" class="btn btn-primary no-border-radius" ng-click="vm.insertFeeds()"><data-i18n i18n="_btn_feed_insert_">insert</data-i18n></button></div><div ba-panel="" ba-panel-title="{{\'_feeds_insert_feeds_panel_feeds_insert_\'|i18n}}" ba-panel-class="with-scroll xmedium-panel"><div include-with-scope="app/pages/rations/balanceRation/modals/insertFeedToMix.table.html"></div></div></div></div><div ng-if="!vm.selectedTeam" align="center"><div><h3><data-i18n i18n="_dashboard_default_team_not_defined_">Default team is not defined</data-i18n></h3><button type="button" class="btn btn-danger no-border-radius" ng-click="vm.cancel(\'insert_feed\')"><data-i18n i18n="_btn_cancel_">cancel</data-i18n></button></div></div></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/insertFeedToMix.sourceTable.html','<div class="vertical-scroll"><table class="table-header-fixed auto-scroll" st-table="vm.feedsByTeam"><thead><tr ng-if="!vm.hideFilters"><th colspan="6" style="width: 100%"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_feeds_search_feeds_label_">dsadrch feeds</data-i18n></label> <input placeholder="{{\'_search_placeholder_feed_name_\'|i18n}}" class="form-control" type="text" ng-model="vm.searchMaster" id="feedsSearchInput" ng-change="vm.searchChanged(\'mix\')"></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_picker_feed_type_placeholder_">Select feed type</data-i18n></label><ui-select style="z-index: 9000 !important" ng-model="vm.feedCategotyItem" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.feedTypeChanged(\'mix\')"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.feedCategotyList | filter: $select.search" ui-disable-choice="vm.feedCategotyItem.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_feeds_common_">Common</data-i18n></label><ui-select style="z-index: 9000 !important" ng-model="vm.commonFeedItem" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.commonFeedChanged(\'mix\')"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="type in vm.commonFeedList | filter: $select.search" ui-disable-choice="vm.commonFeedItem.name == type.name"><span ng-bind-html="type.name"></span></ui-select-choices></ui-select></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_settings_calculation_type_title_">type</data-i18n></label><ui-select style="z-index: 90000 !important" ng-model="vm.defaultCalculation" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.defaultCalculationChanged(\'mix\')"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.defaultCalculationList | filter: $select.search" ui-disable-choice="vm.defaultCalculation.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="form-group" style="text-align: left"><label><data-i18n i18n="_feeds_my_master_">my/master</data-i18n></label><ui-select style="z-index: 9000 !important" ng-model="vm.selectedFeedType" class="btn-group bootstrap-select form-control custom-dropdown" append-to-body="true" search-enabled="true" on-select="vm.feedTypeSelected(\'mix\')"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.filterTypes | filter: $select.search" ui-disable-choice="vm.selectedFeedType.name == type.name"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div></div></div></th></tr><tr class="show-hide-filters"><td><button ng-click="vm.hideFilters = !vm.hideFilters"><i ng-if="!vm.hideFilters" class="ion-arrow-up-b"></i><i ng-if="vm.hideFilters" class="ion-arrow-down-b"></i><span><data-i18n i18n="_modal_show_hide_filters_">Show/hide filters</data-i18n></span><i ng-if="!vm.hideFilters" class="ion-arrow-up-b"></i><i ng-if="vm.hideFilters" class="ion-arrow-down-b"></i></button></td></tr><tr class="sortable" style="margin-right: 15px"><th style="width: 10%"></th><th ng-click="vm.sort(\'feed_name\', \'mix\')" style="width: 20%"><data-i18n i18n="_feeds_name_">Feed name</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'feed_name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'feed_name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br></th><th ng-click="vm.sort(\'test_date\', \'mix\')" style="width: 19%"><data-i18n i18n="_feeds_test_date_">Test date</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'test_date_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'test_date_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br></th><th ng-click="vm.sort(\'dm\', \'mix\')" style="width: 17%"><data-i18n i18n="_feeds_dm_">dm</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'dm_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'dm_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span></th><th ng-click="vm.sort(\'cp\', \'mix\')" style="width: 17%"><data-i18n i18n="_feeds_cp_">cp</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'cp_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'cp_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th><th ng-click="vm.sort(\'ndf\', \'mix\')" style="width: 17%"><data-i18n i18n="_feeds_ndf_">ndf</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ndf_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ndf_ASC\'? \'ion-arrow-up-b\' : \'\')"></i><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th></tr></thead><tbody style="overflow-y: auto" infinite-scroll="" scroll-fn="vm.paginationChanged(\'mix\')" scroll-no-all="vm.totalItemsMaster" scroll-no-displayed="vm.feedsByTeam.length" scroll-disable="vm.disableScroll" ng-if="vm.feedsLoaded"><tr ng-click="vm.addSelected(feed.id, \'mix\')" ng-repeat="feed in vm.feedsByTeam" style="margin-bottom: 5px; margin-top: 5px"><td style="width: 10%"><button type="button" class="btn btn-primary btn-xs" style="border-radius: 50%; transform: none"><i class="ion-plus-round"></i></button></td><td style="width: 20%">{{feed.feed_name}}</td><td style="width: 19%">{{feed.test_date | date: vm.date_format}}</td><td style="width: 17%">{{feed.dm | number: 2}}</td><td style="width: 17%">{{feed.cp| number: 1}}</td><td style="width: 17%">{{feed.ndf | number: 1}}</td></tr><tr ng-if="vm.disableScroll"><td style="width: 100%" align="center"><data-i18n i18n="_title_loading_">Loading...</data-i18n></td></tr></tbody><tbody style="overflow: hidden" ng-if="!vm.feedsLoaded"><tr><td style="width: 100%" align="center"><div id="loading-animation-large"></div></td></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/insertFeedToMix.table.html','<div class="horizontal-scroll"><table class="table-header-fixed" st-table="vm.importList" st-safe-src="vm.importListSafe"><thead><tr class="sortable" style="margin-right: 15px"><th style="width: 10%"></th><th st-sort="feed_name" st-sort-default="true" style="width: 30%"><data-i18n i18n="_feeds_name_">Feed name</data-i18n><br></th><th st-sort="test_date" style="width: 21%"><data-i18n i18n="_feeds_test_date_">Test date</data-i18n><br></th><th st-sort="dm" style="width: 13%"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%</span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}</span></th><th st-sort="cp" style="width: 13%"><data-i18n i18n="_feeds_cp_">cp</data-i18n><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th><th st-sort="NDF" style="width: 13%"><data-i18n i18n="_feeds_ndf_">ndf</data-i18n><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{ vm.weight }}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th></tr></thead><tbody><tr ng-repeat="feed in vm.importList track by $index" ng-click="vm.removeSelected(feed.id, $index)" style="margin-bottom: 5px; margin-top: 5px"><td style="width: 10%"><button type="button" class="btn btn-danger btn-xs" style="border-radius: 50%; transform: none"><i class="ion-minus-round"></i></button></td><td style="width: 30%">{{feed.feed_name}}</td><td style="width: 21%">{{feed.test_date | date:\'mediumDate\'}}</td><td style="width: 13%">{{feed.dm | number: 2}}</td><td style="width: 13%">{{feed.cp| number: 1}}</td><td style="width: 13%">{{feed.ndf | number: 1}}</td></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/loadingModal.html','<div class="modal-content"><div class="modal-header"><div align="center"><span class="secondaryText"><data-i18n i18n="_title_please_wait_">please wait</data-i18n></span></div></div><div class="modal-body"><div style="height: 200px" align="center"><div style="margin-top: 50px"><div id="loading-animation-large" style="display: inline-block"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/mixReport.modal.html','<div class="modal-content"><div class="modal-body"><div ba-panel="" class="ng-cloak" ng-if="!vm.modalLoading"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{\'_report_heading_general_\'|i18n}}"><div class="form-group"><label><data-i18n i18n="_settings_calculation_type_title_">Select group to create ration</data-i18n></label><ui-select style="z-index: 90000 !important" ng-model="vm.defaultCalculation" class="btn-group bootstrap-select form-control" ng-disabled="vm.loadingTable" append-to-body="true" search-enabled="true"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.defaultCalculationList | filter: $select.search"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div><div class="form-group"><label for="preperedFor"><data-i18n i18n="_report_prepared_for_">prepered for</data-i18n></label> <textarea class="form-control" id="preperedFor" style="resize: none" maxlength="150" ng-model="vm.preperedFor"></textarea></div><div class="form-group"><label for="preperedBy"><data-i18n i18n="_report_prepared_by_">prepered by</data-i18n></label> <textarea class="form-control" id="preperedBy" style="resize: none" maxlength="150" ng-model="vm.preperedBy"></textarea></div></uib-tab><uib-tab heading="{{\'_report_heading_mix_settings_\'|i18n}}"><div class="form-group"><label for="mixName"><data-i18n i18n="_report_mix_name_label_">premix name</data-i18n></label><ui-select ng-model="vm.selectedReportFeed" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="vm.selectMixReportFeed()" id="mixName"><ui-select-match placeholder="{{\'_picker_feed_placeholder_\'|i18n}}">{{$select.selected.feed_name}}</ui-select-match><ui-select-choices repeat="feed in vm.reportFeeds| filter: $select.search"><span ng-bind-html="feed.feed_name"></span></ui-select-choices></ui-select></div><div class="form-group"><label for="mixBatchSize" class="span-label"><data-i18n i18n="_report_mix_batch_size_label">premix batch size</data-i18n></label> <input type="number" step="any" class="form-control with-units" id="mixBatchSize" name="mixBatchSize" ng-model="vm.mixBatchSize" ng-change="vm.mixReportBatchSizeChanged()" required="" min="0" max="99999" select-on-click=""> <span>{{vm.weight}}</span></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/rations/balanceRation/modals/mixReport.table.html"></div></div></div></div></uib-tab><uib-tab heading="{{\'_report_heading_finish_\'|i18n}}"><div class="form-group"><label for="aAndC"><data-i18n i18n="_report_assumptions_">Assumptions & Comments</data-i18n></label> <textarea class="form-control" id="aAndC" style="resize: none" ng-model="vm.aAndC"></textarea></div><div align="right"><button type="button" class="btn btn-success btn-with-icon save-profile" ng-click="vm.exportMixReport()"><data-i18n i18n="_btn_export_pdf_">export</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'mixReport\')"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></uib-tab></uib-tabset></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/mixReport.table.html','<div class="vertical-scroll"><table class="table table-bordered-striped"><thead></thead><tr><th></th><th style="text-align: center"><data-i18n i18n="_feeds_name_">name</data-i18n><br></th><th style="text-align: center"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</th><th style="text-align: center"><data-i18n i18n="_report_batch_size_">batch size</data-i18n><br>{{vm.weight}}</th><th style="text-align: center"><data-i18n i18n="_report_mixing_order_">mixing order</data-i18n><br></th></tr><tbody ng-repeat="feed in vm.reportMixFeeds"><tr><td><a class="ion-arrow-up-b icon-edit" href="" ng-click="vm.reportMixUp($index)" ng-if="$index != 0"></a><br ng-if="$index != 0"><a class="ion-arrow-down-b icon-edit" href="" ng-click="vm.reportMixDown($index)" ng-if="$index != vm.reportMixFeedIndexNo"></a></td><td>{{feed.feed_name}}</td><td>{{feed.as_fed_sign}}</td><td>{{feed.batch_size}}</td><td style="text-align: center">{{$index+1}}</td></tr></tbody></table><div align="center" ng-if="vm.loadingTable"><div id="loading-animation-large"></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/officeReport.modal.html','<div class="modal-content"><div class="modal-body"><div ba-panel="" class="ng-cloak" ng-if="!vm.modalLoading"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{\'_report_heading_general_\'|i18n}}"><div class="form-group"><label><data-i18n i18n="_settings_calculation_type_title_">Select group to create ration</data-i18n></label><ui-select style="z-index: 90000 !important" ng-model="vm.defaultCalculation" class="btn-group bootstrap-select form-control" ng-disabled="vm.loadingTable" append-to-body="true" search-enabled="true"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.defaultCalculationList | filter: $select.search"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div><div class="form-group"><label for="feed_name"><data-i18n i18n="_rations_ration_name_">ration name</data-i18n></label> <input type="text" class="form-control" id="feed_name" ng-model="vm.summary.ration_name" required="" maxlength="30" select-on-click=""></div><div class="form-group"><label for="preperedFor"><data-i18n i18n="_report_prepared_for_">prepered for</data-i18n></label> <textarea class="form-control" id="preperedFor" style="resize: none" maxlength="150" ng-model="vm.preperedFor"></textarea></div><div class="form-group"><label for="preperedBy"><data-i18n i18n="_report_prepared_by_">prepered by</data-i18n></label> <textarea class="form-control" id="preperedBy" style="resize: none" maxlength="150" ng-model="vm.preperedBy"></textarea></div></uib-tab><uib-tab heading="{{\'_report_heading_finish_\'|i18n}}"><div class="form-group"><label for="aAndC"><data-i18n i18n="_report_assumptions_">Assumptions & Comments</data-i18n></label> <textarea class="form-control" id="aAndC" style="resize: none" ng-model="vm.aAndC"></textarea></div><div align="right"><button type="button" class="btn btn-success btn-with-icon save-profile" ng-click="vm.exportSummaryOfficeReport(false)"><data-i18n i18n="_btn_export_pdf_">export</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'mixReport\')"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></uib-tab></uib-tabset></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/rationGroupInformations.html','<div class="modal-content" ng-cloak=""><div class="modal-header"><div ng-if="!vm.modalNALoading && !vm.modalRNLoading"><form name="vm.groupInfo" novalidate=""><div class="panel"><div class="panel-heading"><data-i18n i18n="_rations_panel_group_info_">group informations</data-i18n></div><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.groupInfo.rationName.$invalid && (vm.groupInfo.rationName.$dirty || vm.groupInfo.$submitted)}"><label for="rationName" class="span-label"><data-i18n i18n="_rations_ration_name_">Group name</data-i18n></label> <input type="text" class="form-control" id="rationName" name="rationName" placeholder="{{\'_rations_ration_name_\' | i18n}}" ng-model="vm.modalGI.ration_name" maxlength="60" required="" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_rations_ration_name_required_">group name is reqired</data-i18n></span></div></div></div><div align="right"><button type="submit" class="btn btn-success btn-with-icon save-profile" ng-disabled="vm.groupInfo.rationName.$invalid" ng-click="vm.saveRationGeneralInfo()"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'animal_stage_breed\')"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></form></div><div style="height: 200px" ng-if="vm.modalNALoading || vm.modalRNLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/rationMetabolizablePSys.html','<div class="modal-content" ng-cloak=""><div class="modal-header"><div ng-if="!vm.modalLoading"><form name="vm.mps" novalidate=""><div class="panel"><div class="panel-body"><div class="form-group"><label for="breed"><data-i18n i18n="_rations_ration_metabolizable_protein_system_">MP system</data-i18n></label><ui-select class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" on-select="vm.mpsSelected()" required="" id="breed" ng-model="vm.selectedMPS"><ui-select-match placeholder="{{\'_picker_mpc_placeholder_\'|i18n}}">{{$select.selected.show_name}}</ui-select-match><ui-select-choices repeat="mpc in vm.metProtSystems | filter: $select.search"><span ng-bind-html="mpc.show_name"></span></ui-select-choices></ui-select></div><h3 class="with-line"><data-i18n i18n="_rations_mpc_coefficients_">mpc coefficients</data-i18n></h3><div class="form-group" ng-class="{\'has-error\': vm.mps.energyPotential.$invalid && (vm.mps.energyPotential.$dirty || vm.mps.$submitted)}"><label for="energyPotential" class="span-label"><data-i18n i18n="_rations_energy_potential_">Energy potential</data-i18n></label> <input type="number" step="any" pattern="^\\d*(\\.\\d{0,2})?$" class="form-control" id="energyPotential" name="energyPotential" placeholder="{{\'_rations_energy_potential_\' | i18n}}" ng-model="vm.energy_potential" required="" ng-min="vm.minEP" ng-max="vm.maxEP" ng-disabled="vm.disableMPSInput" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_rations_energy_potential_required_">Energy potential is required</data-i18n>{{vm.minEP}} - {{vm.maxEP}}</span></div><div class="form-group" ng-class="{\'has-error\': vm.mps.nitrogenPotential.$invalid && (vm.mps.nitrogenPotential.$dirty || vm.mps.$submitted)}"><label for="nitrogenPotential" class="span-label"><data-i18n i18n="_rations_nitrogen_potential_">nitrogen potential</data-i18n></label> <input type="number" step="any" pattern="^\\d*(\\.\\d{0,2})?$" class="form-control" id="nitrogenPotential" name="nitrogenPotential" placeholder="{{\'_rations_nitrogen_potential_\' | i18n}}" ng-model="vm.nitrogen_potential" required="" ng-disabled="vm.disableMPSInput" ng-min="vm.minNP" ng-max="vm.maxNP" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_rations_nitrogen_potential_required_">Nitrogen potential is required</data-i18n>{{vm.minNP}} - {{vm.maxNP}}</span></div></div></div><div align="right"><button type="submit" class="btn btn-success btn-with-icon save-profile" ng-click="vm.saveRationMPS()"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'animal_stage_breed\')"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></form></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/rationRatiosRelationships.html','<div class="modal-content" ng-cloak=""><div class="modal-header"><div ng-if="!vm.modalLoading"><div class="panel-group"><div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="panel"><div class="panel-heading"><data-i18n i18n="_rations_panel_intake_">Intake</data-i18n></div><div class="panel-body"><div class="row"><div class="col-xs-7 col-sm-7 col-md-7 col-lg-7 col-xl-7"><label><data-i18n i18n="_rations_actual_dmi_">actual dmi</data-i18n>:</label></div><div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5"><label>{{vm.r_r.actual_dmi }} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-7 col-sm-7 col-md-7 col-lg-7 col-xl-7"><label><data-i18n i18n="_rations_dmi_">dmi</data-i18n>/<data-i18n i18n="_rations_bw_">bw</data-i18n>:</label></div><div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5"><label>{{vm.r_r.dmi_bw }} %/<data-i18n i18n="_rations_bw_">bw</data-i18n></label></div></div><div class="row"><div class="col-xs-7 col-sm-7 col-md-7 col-lg-7 col-xl-7"><label><data-i18n i18n="_rations_nrc01_predicted_dmi_">NRC01 predicted DMI</data-i18n>:</label></div><div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5"><label>{{vm.r_r.nrc01_predicted_dmi }} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div ng-if="vm.rationCalculationLabel == \'US\'" class="row"><div class="col-xs-7 col-sm-7 col-md-7 col-lg-7 col-xl-7"><label><data-i18n i18n="_feeds_dep_">dep</data-i18n>/<data-i18n i18n="_feeds_de1x_">de1x</data-i18n>:</label></div><div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5"><label>{{vm.r_r.dep_de1x }} %</label></div></div><div class="row" ng-if="vm.ration.group.type==\'lactating_cow\'"><div class="col-xs-7 col-sm-7 col-md-7 col-lg-7 col-xl-7"><label><data-i18n i18n="_rations_energy_corrected_milk_">energy-corrected milk</data-i18n>:</label></div><div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5"><label>{{vm.r_r.energycorrected_milk}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row" ng-if="vm.ration.group.type==\'lactating_cow\'"><div class="col-xs-7 col-sm-7 col-md-7 col-lg-7 col-xl-7"><label><data-i18n i18n="_rations_energy_corrected_milk_short_">ecm</data-i18n>/<data-i18n i18n="_rations_dmi_">dmi</data-i18n>:</label></div><div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5"><label>{{vm.r_r.ecm_dmi }}</label></div></div><div class="row"><div class="col-xs-7 col-sm-7 col-md-7 col-lg-7 col-xl-7"><label><data-i18n i18n="_rations_fat_corrected_milk_">Fat-corrected milk (FCM)</data-i18n>:</label></div><div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5"><label>{{vm.r_r.fcm }}</label></div></div><div class="row"><div class="col-xs-7 col-sm-7 col-md-7 col-lg-7 col-xl-7"><label><data-i18n i18n="_rations_fat_protein_corrected_milk_">Fat-and-protein-corrected milk (FPCM)</data-i18n>:</label></div><div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5"><label>{{vm.r_r.fpcm }}</label></div></div></div></div><div class="panel"><div class="panel-heading"><data-i18n i18n="_rations_panel_production_daily_gain_">production / daily gain</data-i18n></div><div class="panel-body"><div class="row" ng-if="vm.ration.group.type==\'heifer\'"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_energy_allowable_gain_">Energy allowable gain</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.energyallowable_gain }} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row" ng-if="vm.ration.group.type==\'heifer\'"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_protein_allowable_gain_">protein allowable gain</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.proteinallowable_gain}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row" ng-if="vm.ration.group.type==\'drycow/late_pregnant_heifer\'"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_energy_allowable_bc_gain_">Energy allowable BC gain</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.energyallowable_bc_gain }} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row" ng-if="vm.ration.group.type==\'drycow/late_pregnant_heifer\'"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_protein_allowable_bc_gain_">protein allowable bc gain</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.proteinallowable_bc_gain }} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row" ng-if="vm.ration.group.type==\'lactating_cow\' && vm.rationCalculationLabel == \'US\'"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_energy_allowable_milk_">Energy allowable milk</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.energyallowable_milk}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row" ng-if="vm.ration.group.type==\'lactating_cow\' && vm.rationCalculationLabel == \'US\'"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_protein_allowable_milk_">protein allowable milk</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.proteinallowable_milk}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row" ng-if="vm.ration.group.type==\'lactating_cow\' && vm.rationCalculationLabel != \'US\'"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_vem_allowable_milk_">Vem-allowable milk</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.vem_allowable_milk}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row" ng-if="vm.ration.group.type==\'lactating_cow\' && vm.rationCalculationLabel != \'US\'"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_dve_allowable_milk_">DVE-allowable milk</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.dve_allowable_milk}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div ng-if="vm.rationCalculationLabel == \'US\'" class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_target_body_energy_balance_">target body energy balance</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.target_body_energy_balance }} {{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div ng-if="vm.rationCalculationLabel == \'US\'" class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_target_body_protein_balance_">target body protein balance</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.target_body_protein_balance }} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div></div></div><div class="panel"><div class="panel-heading"><data-i18n i18n="_rations_panel_costs_">Costs</data-i18n></div><div class="panel-body"><div ng-if="vm.rationCalculationLabel == \'US\'" class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_feed_cost_">feed cost</data-i18n>/<data-i18n i18n="_rations_me3x_">me3x</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.feed_cost_me3x }} <span>{{vm.currency}}</span>/100 {{vm.energy}}</label></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_purchased_feed_costs_">purchased feed costs</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.purchased_feed_costs }} <span>{{vm.currency}}</span>/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row" ng-if="vm.ration.group.type==\'lactating_cow\'"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_feed_cost_">feed cost</data-i18n>/<data-i18n i18n="_rations_100_wt_milk_">100 wt milk</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.feed_cost_100_wt_milk }} <span>{{vm.currency}}</span>/ 100 {{vm.weight}}</label></div></div><div class="row" ng-if="vm.ration.group.type==\'lactating_cow\'"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_income_over_feed_costs_">income over feed costs</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.income_over_feed_costs}} <span>{{vm.currency}}</span>/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="panel"><div class="panel-heading"><data-i18n i18n="_rations_panel_diet_composition_">Diet composition</data-i18n></div><div class="panel-body"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_forage_diet_">forage in diet</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.forage_in_diet }} %<data-i18n i18n="_feeds_dm_">dm</data-i18n></label></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_forage_ndf_">forage ndf</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.forage_ndf }} %<data-i18n i18n="_feeds_ndf_">ndf</data-i18n></label></div></div><div ng-if="vm.rationCalculationLabel == \'US\'" class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_feeds_cp_">cp</data-i18n>/<data-i18n i18n="_rations_me3x_">me3x</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.cp_me3x }}<data-i18n i18n="_unit_grams_">grams</data-i18n>/{{vm.energy}}</label></div></div><div ng-if="vm.rationCalculationLabel == \'US\'" class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_feeds_mp_">mp</data-i18n>/<data-i18n i18n="_feeds_me_">me</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.mp_me }}<data-i18n i18n="_unit_grams_">grams</data-i18n>/{{vm.energy}}</label></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_lys_met_">lys:met</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.lys_met }}</label></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_lys_nrc01_met_">nrc01 lys: met</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.nrc01_lys_met }}</label></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_lys_nrc01_">nrc01 lys</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.nrc01_lys }} %/<data-i18n i18n="_feeds_mp_">mp</data-i18n></label></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_met_nrc01_">nrc01 met</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.nrc01_met }} %/<data-i18n i18n="_feeds_mp_">mp</data-i18n></label></div></div></div></div><div class="panel"><div class="panel-heading"><data-i18n i18n="_rations_panel_nutrient_management_">nutrient management</data-i18n></div><div class="panel-body"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_predicted_fecal_dm_">predicted fecal dm</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.predicted_fecal_dm }} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_n_captured_">n captured</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.n_captured }} %</label></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_total_n_excreted_">total n excreted</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.total_n_excreted }} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_fecal_n_">fecal n</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.fecal_n }} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_urinary_n_">urinary n</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.urinary_n }} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_p_captured_">p captured</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.p_captured }} %</label></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_p_excreted_">p excreted</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.p_excreted }} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_p_excreted_p205_">p excreted as p205</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.p_excreted_as_p205 }} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label><data-i18n i18n="_rations_k_excreted_k20_">k excreted as k20</data-i18n>:</label></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><label>{{vm.r_r.k_excreted_as_k2O}} {{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></label></div></div></div></div></div></div></div></div><button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'animal_stage_breed\')"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/redirectModal.html','<div class="modal-content"><div class="modal-header"><div align="center"><span class="secondaryText"><data-i18n i18n="_title_unsaved_changes_">unsaved changes</data-i18n></span></div></div><div class="modal-body"><div align="center"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="vm.redirectProceed()"><data-i18n i18n="_btn_leave_">Leave</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'redirect_modal\')"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/saveAs.modal.html','<div class="modal-content" ng-cloak=""><div class="modal-header"><div ng-if="!vm.saveAsModalLoading"><form name="vm.groupInfo" novalidate=""><div class="panel"><div class="panel-body"><div class="form-group" ng-class="{\'has-error\': vm.groupInfo.rationNameSaveAs.$invalid && (vm.groupInfo.rationNameSaveAs.$dirty || vm.groupInfo.$submitted)}"><label for="rationName" class="span-label"><data-i18n i18n="_rations_ration_name_">Group name</data-i18n></label> <input type="text" class="form-control" id="groupName" name="rationNameSaveAs" placeholder="{{\'_rations_ration_name_\' | i18n}}" ng-model="vm.rationNameSaveAs" required="" select-on-click="" maxlength="60"> <span class="help-block error-block basic-block"><data-i18n i18n="_rations_ration_name_required_">ration name is reqired</data-i18n></span></div><div class="form-group"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.groupInfo.group.$invalid && (vm.groupInfo.group.$dirty || vm.groupInfo.$submitted)}"><label for="breed"><data-i18n i18n="_groups_group_name_">Group name</data-i18n></label><ui-select ng-model="vm.selectedGroup" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="true" required="" id="group" name="group"><ui-select-match placeholder="{{\'_picker_breed_placeholder_\'|i18n}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="group in vm.groups | filter: $select.search"><span ng-bind-html="group.name"></span></ui-select-choices></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_groups_group_name_required_">group name is required</data-i18n></span></div></div></div></div><div align="right"><button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel()"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button> <button type="submit" class="btn btn-info btn-with-icon save-profile" ng-click="vm.saveRationAs()"><data-i18n i18n="_btn_save_">Save</data-i18n></button></div></form></div><div style="height: 200px" ng-if="vm.saveAsModalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/settingsGeneral.html','<div class="modal-content" ng-cloak=""><div class="modal-header"><div ng-if="!vm.modalLoading"><h3 class="with-line"><data-i18n i18n="_settings_general_settings_title_">General Settings</data-i18n></h3><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6"><div class="form-group"><label class="modal-margin"><data-i18n i18n="_settings_weight_measurement_title_">Weight measurement</data-i18n></label><div><toggle-switch ng-model="vm.modalSettings.use_kgs" on-label="kg" off-label="lb" class="switch-primary" style="width: 120px"></toggle-switch></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6"><div class="form-group"><label class="modal-margin"><data-i18n i18n="_settings_energy_measurement_title_">Energy measurement</data-i18n></label><div><toggle-switch ng-model="vm.modalSettings.use_mcal" on-label="Mcal" off-label="Mjoule" class="switch-primary" style="width: 120px"></toggle-switch></div></div></div></div><div align="right"><button type="button" class="btn btn-success btn-with-icon save-profile" ng-click="vm.saveSettingsGeneral()"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'animal_stage_breed\')"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/modals/settingsNutrientBalanceGraph.html','<form name="vm.nutrientGraph"><div class="modal-content" ng-cloak=""><div class="modal-header"><div ng-if="!vm.modalLoading"><h3 class="with-line"><data-i18n i18n="_rations_set_x_axis_">set x axis</data-i18n></h3><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.nutrientGraph.min.$invalid && (vm.nutrientGraph.min.$dirty || vm.nutrientGraph.$submitted)}"><label for="min" class="span-label"><data-i18n i18n="_title_min_">min</data-i18n></label> <input type="number" class="form-control" id="min" name="min" placeholder="{{\'_title_min_\' | i18n}}" ng-model="vm.modalNutrientSettings.x_axis_min" min="-100" max="-4" step="1" required="" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_title_min_required_">min value is reqired</data-i18n></span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.nutrientGraph.max.$invalid && (vm.nutrientGraph.max.$dirty || vm.nutrientGraph.$submitted)}"><label for="max" class="span-label"><data-i18n i18n="_title_max_">max</data-i18n></label> <input type="number" class="form-control" id="max" name="max" placeholder="{{\'_title_max_\' | i18n}}" ng-model="vm.modalNutrientSettings.x_axis_max" min="5" max="100" step="1" required="" select-on-click=""> <span class="help-block error-block basic-block"><data-i18n i18n="_title_max_required_">max value is reqired</data-i18n></span></div></div></div><h3 class="with-line"><data-i18n i18n="_rations_select_nutrients_to_graph_">select nutrients to graph</data-i18n></h3><div class="row"><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="dmi" ng-model="vm.modalNutrientSettings.dmi"> <span><data-i18n i18n="_feeds_dmi_long_">dmi</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="ndf" ng-model="vm.modalNutrientSettings.ndf"> <span><data-i18n i18n="_feeds_ndf_long_">ndf</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="ef_ndf" ng-model="vm.modalNutrientSettings.ef_ndf"> <span><data-i18n i18n="_feeds_efndf_long_">ef ndf</data-i18n></span></label></div></div></div><div class="row"><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="for_ndf" ng-model="vm.modalNutrientSettings.for_ndf"> <span><data-i18n i18n="_feeds_for_ndf_long_">for ndf</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group" ng-if="vm.ration.group.type!=\'heifer\'"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="nel" ng-model="vm.modalNutrientSettings.nel"> <span><data-i18n i18n="_feeds_nel_long_">nel</data-i18n></span></label></div><div class="form-group" ng-if="vm.ration.group.type==\'heifer\'"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="neg" ng-model="vm.modalNutrientSettings.neg"> <span><data-i18n i18n="_feeds_nel_long_">nel</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="me" ng-model="vm.modalNutrientSettings.me"> <span><data-i18n i18n="_feeds_me_long_">me</data-i18n></span></label></div></div></div><div class="row"><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="nel_89" ng-model="vm.modalNutrientSettings.nel_89"> <span><data-i18n i18n="_feeds_nel89_long_">nel 89</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="me_89" ng-model="vm.modalNutrientSettings.me_89"> <span><data-i18n i18n="_feeds_me89_long_">me 89</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="nel_01" ng-model="vm.modalNutrientSettings.nel_01"> <span><data-i18n i18n="_feeds_nel01_long_">nel 01</data-i18n></span></label></div></div></div><div class="row"><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="me_01" ng-model="vm.modalNutrientSettings.me_01"> <span><data-i18n i18n="_feeds_me01_long_">me 01</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="cp" ng-model="vm.modalNutrientSettings.cp"> <span><data-i18n i18n="_feeds_cp_long_">cp</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="rdp" ng-model="vm.modalNutrientSettings.rdp"> <span><data-i18n i18n="_feeds_rdp_long_">rdp</data-i18n></span></label></div></div></div><div class="row"><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="mp" ng-model="vm.modalNutrientSettings.mp"> <span><data-i18n i18n="_feeds_mp_long_">mp</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="mp_01" ng-model="vm.modalNutrientSettings.mp_01"> <span><data-i18n i18n="_feeds_mp01_long_">mp 01</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="ca" ng-model="vm.modalNutrientSettings.ca"> <span><data-i18n i18n="_feeds_ca_long_">ca</data-i18n></span></label></div></div></div><div class="row"><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="p" ng-model="vm.modalNutrientSettings.p"> <span><data-i18n i18n="_feeds_p_long_">p</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="mg" ng-model="vm.modalNutrientSettings.mg"> <span><data-i18n i18n="_feeds_mg_long_">Mg</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="k" ng-model="vm.modalNutrientSettings.k"> <span><data-i18n i18n="_feeds_k_long_">k</data-i18n></span></label></div></div></div><div class="row"><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="na" ng-model="vm.modalNutrientSettings.na"> <span><data-i18n i18n="_feeds_na_long_">na</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="cl" ng-model="vm.modalNutrientSettings.cl"> <span><data-i18n i18n="_feeds_cl_long_">cl</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="s" ng-model="vm.modalNutrientSettings.s"> <span><data-i18n i18n="_feeds_s_long_">s</data-i18n></span></label></div></div></div><div class="row"><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="co" ng-model="vm.modalNutrientSettings.co"> <span><data-i18n i18n="_feeds_co_long_">co</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="cu" ng-model="vm.modalNutrientSettings.cu"> <span><data-i18n i18n="_feeds_cu_long_">cu</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="fe" ng-model="vm.modalNutrientSettings.fe"> <span><data-i18n i18n="_feeds_fe_long_">fe</data-i18n></span></label></div></div></div><div class="row"><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="i" ng-model="vm.modalNutrientSettings.i"> <span><data-i18n i18n="_feeds_i_long_">I</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="mn" ng-model="vm.modalNutrientSettings.mn"> <span><data-i18n i18n="_feeds_mn_long_">mn</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="se" ng-model="vm.modalNutrientSettings.se"> <span><data-i18n i18n="_feeds_se_long_">se</data-i18n></span></label></div></div></div><div class="row"><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="zn" ng-model="vm.modalNutrientSettings.zn"> <span><data-i18n i18n="_feeds_zn_long_">zn</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="vitamin_a" ng-model="vm.modalNutrientSettings.vitamine_a"> <span><data-i18n i18n="_feeds_vit_a_long_">vitamin a</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="vitamin_d" ng-model="vm.modalNutrientSettings.vitamine_d"> <span><data-i18n i18n="_feeds_vit_d_long_">vitamin d</data-i18n></span></label></div></div></div><div class="row"><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="vitamin_e" ng-model="vm.modalNutrientSettings.vitamine_e"> <span><data-i18n i18n="_feeds_vit_e_long_">vitamin e</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="lysine" ng-model="vm.modalNutrientSettings.lysine"> <span><data-i18n i18n="_feeds_lysine_long_">lysine</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="methionine" ng-model="vm.modalNutrientSettings.methionine"> <span><data-i18n i18n="_feeds_methionine_long_">methionie</data-i18n></span></label></div></div></div><div class="row"><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="vem" ng-model="vm.modalNutrientSettings.vem"> <span><data-i18n i18n="_feeds_vem_">Vem</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="dve" ng-model="vm.modalNutrientSettings.dve"> <span><data-i18n i18n="_feeds_dve_">dve</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="oeb" ng-model="vm.modalNutrientSettings.oeb"> <span><data-i18n i18n="_feeds_oeb_">oeb</data-i18n></span></label></div></div></div><div class="row"><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="fos" ng-model="vm.modalNutrientSettings.fos"> <span><data-i18n i18n="_feeds_fos_">fos</data-i18n></span></label></div></div><div class="col-md-4 col-sm-6"><div class="form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="starch" ng-model="vm.modalNutrientSettings.starch"> <span><data-i18n i18n="_feeds_starch_">starch</data-i18n></span></label></div></div></div><div align="right"><button type="button" class="btn btn-success btn-with-icon save-profile" ng-click="vm.saveNutrientBalance()"><data-i18n i18n="_btn_save_">Save</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'animal_stage_breed\')"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div></form>');
$templateCache.put('app/pages/rations/balanceRation/modals/summaryReport.modal.html','<div class="modal-content"><div class="modal-body"><div ba-panel="" class="ng-cloak"><uib-tabset active="$tabSetStatus.activeTab" ng-if="!vm.modalLoading"><uib-tab heading="{{\'_report_heading_general_\'|i18n}}"><div class="form-group"><label><data-i18n i18n="_settings_calculation_type_title_">Select group to create ration</data-i18n></label><ui-select style="z-index: 90000 !important" ng-model="vm.defaultCalculation" class="btn-group bootstrap-select form-control" ng-disabled="vm.loadingTable" append-to-body="true" search-enabled="true"><ui-select-match>{{$select.selected.name | i18n}}</ui-select-match><ui-select-choices repeat="type in vm.defaultCalculationList | filter: $select.search"><span ng-bind-html="type.name | i18n"></span></ui-select-choices></ui-select></div><div class="form-group"><label for="feed_name"><data-i18n i18n="_rations_ration_name_">ration name</data-i18n></label> <input type="text" class="form-control" id="feed_name" ng-model="vm.summary.ration_name" required="" maxlength="30" select-on-click=""></div><div class="form-group"><label for="preperedFor"><data-i18n i18n="_report_prepared_for_">prepered for</data-i18n></label> <textarea class="form-control" id="preparedFor" style="resize: none" maxlength="150" ng-model="vm.preperedFor"></textarea></div><div class="form-group"><label for="preperedBy"><data-i18n i18n="_report_prepared_by_">prepered by</data-i18n></label> <textarea class="form-control" id="preperedBy" style="resize: none" maxlength="150" ng-model="vm.preperedBy"></textarea></div></uib-tab><uib-tab heading="{{\'_report_heading_finish_\'|i18n}}"><div class="form-group"><label for="aAndC"><data-i18n i18n="_report_assumptions_">Assumptions & Comments</data-i18n></label> <textarea class="form-control" id="aAndC" style="resize: none" ng-model="vm.aAndC"></textarea></div><div align="right"><button type="button" class="btn btn-success btn-with-icon save-profile" ng-click="vm.exportSummaryOfficeReport(true)"><data-i18n i18n="_btn_export_pdf_">export</data-i18n></button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="vm.cancel(\'mixReport\')"><data-i18n i18n="_btn_cancel_">Cancel</data-i18n></button></div></uib-tab></uib-tabset></div><div style="height: 200px" ng-if="vm.modalLoading" align="center"><div style="margin-top: 50px"><div id="loading-animation-large"></div></div></div></div></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsEnergy/balanceRation.energy.requirementsUS.html','<div ng-if="!vm.loadingTabs" class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th></th><th><data-i18n i18n="_feeds_amount_">amount</data-i18n></th><th ng-show="vm.ration.group.animal_type.type!=\'heifer\'"><data-i18n i18n="_feeds_nel_">NEL</data-i18n></th><th><data-i18n i18n="_feeds_me_">ME</data-i18n></th><th><data-i18n i18n="_feeds_disc_fac_">disc. fac.</data-i18n></th><th ng-show="vm.ration.group.animal_type.type==\'heifer\'"><data-i18n i18n="_rations_nem_">nem</data-i18n></th><th ng-show="vm.ration.group.animal_type.type==\'heifer\'"><data-i18n i18n="_rations_neg_">neg</data-i18n></th><th ng-show="vm.ration.group.animal_type.type!=\'heifer\'"><data-i18n i18n="_feeds_nel89_">NEL 89</data-i18n></th><th><data-i18n i18n="_feeds_me89_">ME 89</data-i18n></th><th ng-show="vm.ration.group.animal_type.type!=\'heifer\'"><data-i18n i18n="_feeds_nel01_">nel 01</data-i18n></th><th><data-i18n i18n="_feeds_me01_">me 01</data-i18n></th><th><data-i18n i18n="_feeds_dep_">DEp</data-i18n></th><th><data-i18n i18n="_feeds_de1x_">DE1X</data-i18n></th><th><data-i18n i18n="_feeds_mftdn_">MF-TDN</data-i18n></th><th><data-i18n i18n="_feeds_tdn1x_">TDN1X</data-i18n></th></tr></thead><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th ng-show="vm.ration.group.animal_type.type!=\'heifer\'">{{vm.energy}}/{{vm.weight}}</th><th>{{vm.energy}}/{{vm.weight}}</th><th>%</th><th ng-show="vm.ration.group.animal_type.type==\'heifer\'">{{vm.energy}}/{{vm.weight}}</th><th ng-show="vm.ration.group.animal_type.type==\'heifer\'">{{vm.energy}}/{{vm.weight}}</th><th ng-show="vm.ration.group.animal_type.type!=\'heifer\'">{{vm.energy}}/{{vm.weight}}</th><th>{{vm.energy}}/{{vm.weight}}</th><th ng-show="vm.ration.group.animal_type.type!=\'heifer\'">{{vm.energy}}/{{vm.weight}}</th><th>{{vm.energy}}/{{vm.weight}}</th><th>{{vm.energy}}/{{vm.weight}}</th><th>{{vm.energy}}/{{vm.weight}}</th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n class="nowrap" i18n="_rations_concentration_supplied_">Concentration supplied</data-i18n></td><td>{{vm.ration.concentration_supplied.amount_dm | formatViewValuesSignificant: \'amount\'}}</td><td ng-show="vm.ration.group.animal_type.type!=\'heifer\'">{{vm.ration.concentration_supplied.nel | formatViewValuesSignificant: \'nel\'}}</td><td>{{vm.ration.concentration_supplied.me | formatViewValuesSignificant: \'me\'}}</td><td>{{vm.ration.concentration_supplied.disc_fac | formatViewValuesSignificant: \'disc_fac\'}}</td><td ng-show="vm.ration.group.animal_type.type==\'heifer\'">{{vm.ration.concentration_supplied.nem | formatViewValuesSignificant: \'nem\'}}</td><td ng-show="vm.ration.group.animal_type.type==\'heifer\'">{{vm.ration.concentration_supplied.neg | formatViewValuesSignificant: \'neg\'}}</td><td ng-show="vm.ration.group.animal_type.type!=\'heifer\'">{{vm.ration.concentration_supplied.nel_89 | formatViewValuesSignificant: \'nel_89\'}}</td><td>{{vm.ration.concentration_supplied.me_89 | formatViewValuesSignificant: \'me_89\'}}</td><td ng-show="vm.ration.group.animal_type.type!=\'heifer\'">{{vm.ration.concentration_supplied.nel_01 | formatViewValuesSignificant: \'nel_01\'}}</td><td>{{vm.ration.concentration_supplied.me_01 | formatViewValuesSignificant: \'me_01\'}}</td><td>{{vm.ration.concentration_supplied.dep | formatViewValuesSignificant: \'dep\'}}</td><td>{{vm.ration.concentration_supplied.de1x | formatViewValuesSignificant: \'de1x\'}}</td><td>{{vm.ration.concentration_supplied.mftdn | formatViewValuesSignificant: \'mftdn\'}}</td><td>{{vm.ration.concentration_supplied.tdn1x | formatViewValuesSignificant: \'tdn1x\'}}</td></tr></tbody><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th ng-show="vm.ration.group.animal_type.type!=\'heifer\'">{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}</th><th ng-show="vm.ration.group.animal_type.type==\'heifer\'">{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th ng-show="vm.ration.group.animal_type.type==\'heifer\'">{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th ng-show="vm.ration.group.animal_type.type!=\'heifer\'">{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th ng-show="vm.ration.group.animal_type.type!=\'heifer\'">{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n i18n="_rations_supply_">Supply</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td ng-show="vm.ration.group.animal_type.type!=\'heifer\'">{{vm.ration.supply.nel | formatViewValuesPerDay: \'nel\'}}</td><td>{{vm.ration.supply.me | formatViewValuesPerDay: \'me\'}}</td><td>{{vm.ration.supply.disc_fac | formatViewValuesPerDay: \'disc_fac\'}}</td><td ng-show="vm.ration.group.animal_type.type==\'heifer\'">{{vm.ration.supply.nem | formatViewValuesPerDay: \'nem\'}}</td><td ng-show="vm.ration.group.animal_type.type==\'heifer\'">{{vm.ration.supply.neg | formatViewValuesPerDay: \'neg\'}}</td><td ng-show="vm.ration.group.animal_type.type!=\'heifer\'">{{vm.ration.supply.nel_89 | formatViewValuesPerDay: \'nel_89\'}}</td><td>{{vm.ration.supply.me_89 | formatViewValuesPerDay: \'me_89\'}}</td><td ng-show="vm.ration.group.animal_type.type!=\'heifer\'">{{vm.ration.supply.nel_01 | formatViewValuesPerDay: \'nel_01\'}}</td><td>{{vm.ration.supply.me_01 | formatViewValuesPerDay: \'me_01\'}}</td><td>{{vm.ration.supply.dep | formatViewValuesPerDay: \'dep\'}}</td><td>{{vm.ration.supply.de1x | formatViewValuesPerDay: \'de1x\'}}</td><td>{{vm.ration.supply.mftdn | formatViewValuesPerDay: \'mftdn\'}}</td><td>{{vm.ration.supply.tdn1x | formatViewValuesPerDay: \'tdn1x\'}}</td></tr><tr><td><data-i18n i18n="_rations_requirements_">Requirements</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.requirements.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td ng-show="vm.ration.group.animal_type.type!=\'heifer\'">{{vm.ration.requirements.nel | formatViewValuesPerDay: \'nel\'}}</td><td>{{vm.ration.requirements.me | formatViewValuesPerDay: \'me\'}}</td><td></td><td ng-show="vm.ration.group.animal_type.type==\'heifer\'">{{vm.ration.requirements.nem | formatViewValuesPerDay: \'nem\'}}</td><td ng-show="vm.ration.group.animal_type.type==\'heifer\'">{{vm.ration.requirements.neg | formatViewValuesPerDay: \'neg\'}}</td><td ng-show="vm.ration.group.animal_type.type!=\'heifer\'">{{vm.ration.requirements.nel_89 | formatViewValuesPerDay: \'nel_89\'}}</td><td>{{vm.ration.requirements.me_89 | formatViewValuesPerDay: \'me_89\'}}</td><td ng-show="vm.ration.group.animal_type.type!=\'heifer\'">{{vm.ration.requirements.nel_01 | formatViewValuesPerDay: \'nel_01\'}}</td><td>{{vm.ration.requirements.me_01 | formatViewValuesPerDay: \'me_01\'}}</td><td></td><td></td><td></td><td></td></tr><tr class="ration-difference"><td><data-i18n i18n="_rations_difference_">Difference</data-i18n></td><td><span ng-class="vm.ration.difference.amount_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.amount_dm | formatViewValuesPerDay: \'amount\'}}</span></td><td ng-show="vm.ration.group.animal_type.type!=\'heifer\'"><span ng-class="vm.ration.difference.nel >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.nel | formatViewValuesPerDay: \'nel\'}}</span></td><td><span ng-class="vm.ration.difference.me >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.me | formatViewValuesPerDay: \'me\'}}</span></td><td></td><td ng-show="vm.ration.group.animal_type.type==\'heifer\'"><span ng-class="vm.ration.difference.nem >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.nem | formatViewValuesPerDay: \'nem\'}}</span></td><td ng-show="vm.ration.group.animal_type.type==\'heifer\'"><span ng-class="vm.ration.difference.neg >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.neg | formatViewValuesPerDay: \'neg\'}}</span></td><td ng-show="vm.ration.group.animal_type.type!=\'heifer\'"><span ng-class="vm.ration.difference.nel_89 >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.nel_89 | formatViewValuesPerDay: \'nel_89\'}}</span></td><td><span ng-class="vm.ration.difference.me_89 >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.me_89 | formatViewValuesPerDay: \'me_89\'}}</span></td><td ng-show="vm.ration.group.animal_type.type!=\'heifer\'"><span ng-class="vm.ration.difference.nel_01 >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.nel_01 | formatViewValuesPerDay: \'nel_01\'}}</span></td><td><span ng-class="vm.ration.difference.me_01 >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.me_01 | formatViewValuesPerDay: \'me_01\'}}</span></td><td></td><td></td><td></td><td></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsEnergy/balanceRation.energy.requirementsVemDve.html','<div ng-if="!vm.loadingTabs" class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th></th><th><data-i18n i18n="_feeds_amount_">amount</data-i18n></th><th><data-i18n i18n="_feeds_vem_">vem</data-i18n></th><th><data-i18n i18n="_feeds_fos_">fos</data-i18n></th></tr></thead><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th><data-i18n i18n="_feeds_vem_unit_">vem</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th></tr></tbody><tbody><tr><td><data-i18n class="nowrap" i18n="_rations_concentration_supplied_">Concentration supplied</data-i18n></td><td>{{vm.ration.concentration_supplied.amount_dm | formatViewValuesSignificant: \'amount\'}}</td><td>{{vm.ration.concentration_supplied.vem | formatViewValues: \'vem\'}}</td><td>{{vm.ration.concentration_supplied.fos | formatViewValuesSignificant: \'fos\' : vm.ration.concentration_supplied.dm}}</td></tr></tbody><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_feeds_vem_unit_">vem</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n i18n="_rations_supply_">Supply</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.supply.vem | formatViewValues: \'vem\'}}</td><td>{{vm.ration.supply.fos | formatViewValuesPerDay: \'fos\'}}</td></tr><tr><td><data-i18n i18n="_rations_requirements_">Requirements</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.requirements.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.requirements.vem | formatViewValues: \'vem\'}}</td><td></td></tr><tr class="ration-difference"><td><data-i18n i18n="_rations_difference_">Difference</data-i18n></td><td><span ng-class="vm.ration.difference.amount_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.amount_dm | formatViewValuesPerDay: \'amount\'}}</span></td><td><span ng-class="vm.ration.difference.vem >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.vem | formatViewValues: \'vem\'}}</span></td><td></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsEnergy/balanceRation.energyUS.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="energyTable"><thead><tr class="sortable"><th style="height: 77px" class="editable-header" st-sort="feed_name"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="nel" ng-show="vm.ration.group.type!=\'heifer\'"><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="me"><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me_">ME</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="nem" ng-show="vm.ration.group.type==\'heifer\'"><div uib-tooltip="{{\'_description_nem_\' | i18n}}" tooltip-is-open="nemIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_rations_nem_">nem</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="neg" ng-show="vm.ration.group.type==\'heifer\'"><div uib-tooltip="{{\'_description_neg_\' | i18n}}" tooltip-is-open="negIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_rations_neg_">neg</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th style="min-width: 120px" st-sort="disc_fac" class="editable-header"><div uib-tooltip="{{\'_description_disc_fac_\' | i18n}}" tooltip-is-open="discFacIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_disc_fac_">Disc. Fac.</data-i18n><br>%</div></th><th st-sort="nel_89" ng-show="vm.ration.group.type!=\'heifer\'" class="editable-header"><div uib-tooltip="{{\'_description_nel_89_\' | i18n}}" tooltip-is-open="nel89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel89_">NEL 89</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="me_89" class="editable-header"><div uib-tooltip="{{\'_description_me_89_\' | i18n}}" tooltip-is-open="me89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me89_">ME 89</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="nel_01" ng-show="vm.ration.group.type!=\'heifer\'"><div uib-tooltip="{{\'_description_nel_01_\' | i18n}}" tooltip-is-open="nel01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel01_">nel 01</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="me_01"><div uib-tooltip="{{\'_description_me_01_\' | i18n}}" tooltip-is-open="me01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me01_">me 01</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="dep"><div uib-tooltip="{{\'_description_dep_\' | i18n}}" tooltip-is-open="depIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dep_">DEp</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="de1x"><div uib-tooltip="{{\'_description_de1x_\' | i18n}}" tooltip-is-open="de1xIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_de1x_">DE1X</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="mftdn"><div uib-tooltip="{{\'_description_mftdn_\' | i18n}}" tooltip-is-open="mftdnIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mftdn_">MF-TDN</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="tdn1x"><div uib-tooltip="{{\'_description_tdn1x_\' | i18n}}" tooltip-is-open="tdn1xIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdn1x_">TDN1X</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody id="energyBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="any" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'E\')" id="amount{{$index}}E" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type!=\'heifer\'"><span>{{feed.nel | formatViewValues: \'nel\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.me | formatViewValues: \'me\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type==\'heifer\'"><span>{{feed.nem | formatViewValues: \'nem\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type==\'heifer\'"><span>{{feed.neg | formatViewValues: \'neg\'}}</span></td><td style="padding: 3px 3px; min-width: 120px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.disc_fac" e-format-input-value="disc_fac" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'disc_fac\', \'E\')" id="disc_fac{{$index}}E" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.disc_fac | formatViewValues: \'disc_fac\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type!=\'heifer\'"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.nel_89" e-format-input-value="nel_89" e-min="0" e-max="{{vm.nel_89Max}}" onbeforesave="vm.updateFeed(feed, $index, $data, \'nel_89\', \'E\')" id="nel_89{{$index}}E" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.nel_89 | formatViewValues: \'nel_89\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.me_89" e-format-input-value="me_89" e-min="0" e-max="{{vm.me_89max}}" onbeforesave="vm.updateFeed(feed, $index, $data, \'me_89\', \'E\')" id="me_89{{$index}}E" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.me_89 | formatViewValues: \'me_89\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type!=\'heifer\'"><span>{{feed.nel_01 | formatViewValues: \'nel_01\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.me_01 | formatViewValues: \'me_01\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.dep | formatViewValues: \'dep\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.de1x | formatViewValues: \'de1x\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.mftdn | formatViewValues: \'mftdn\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.tdn1x | formatViewValues: \'tdn1x\'}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="any" editable-number="mixfeed.amount" e-format-input-value="amount" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'E\', feed.id, feed.id)" id="amountMIX{{$index}}E{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type!=\'heifer\'"><span>{{mixfeed.nel | formatViewValues: \'nel\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.me | formatViewValues: \'me\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type==\'heifer\'"><span>{{mixfeed.nem | formatViewValues: \'nem\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type==\'heifer\'"><span>{{mixfeed.neg | formatViewValues: \'neg\'}}</span></td><td style="padding: 3px 3px; min-width: 120px"><span e-step="0.1" editable-number="mixfeed.disc_fac" e-format-input-value="disc_fac" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'disc_fac\', \'E\', feed.id)" id="disc_facMIX{{$index}}E{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.disc_fac | formatViewValues: \'disc_fac\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type!=\'heifer\'"><span e-step="0.01" editable-number="mixfeed.nel_89" e-format-input-value="nel_89" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="{{vm.nel_89Max}}" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'nel_89\', \'E\', feed.id)" id="nel_89MIX{{$index}}E{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.nel_89 | formatViewValues: \'nel_89\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" editable-number="mixfeed.me_89" e-format-input-value="me_89" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="{{vm.me_89max}}" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'me_89\', \'E\', feed.id)" id="me_89MIX{{$index}}E{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.me_89 | formatViewValues: \'me_89\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type!=\'heifer\'"><span>{{mixfeed.nel_01 | formatViewValues: \'nel_01\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.me_01 | formatViewValues: \'me_01\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.dep | formatViewValues: \'dep\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.de1x | formatViewValues: \'de1x\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.mftdn | formatViewValues: \'mftdn\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.tdn1x | formatViewValues: \'tdn1x\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsEnergy/balanceRation.energyVemDve.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="energyTable"><thead><tr class="sortable"><th style="height: 77px" class="editable-header" st-sort="feed_name"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="vem" class="editable-header"><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">vem</data-i18n><br><br></div></th><th st-sort="fos" class="editable-header"><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">fos</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody id="energyBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.feed_loading" editable-number="feed.amount" e-format-input-value="amount" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'E\')" id="amount{{$index}}E" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.feed_loading || feed.is_mix" editable-number="feed.vem" e-format-input-value="vem" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'vem\', \'E\')" id="vem{{$index}}E" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.vem | formatViewValues: \'vem\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.feed_loading || feed.is_mix" editable-number="feed.fos" e-format-input-value="fos" e-format-value-dm="feed.dm" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'fos\', \'E\')" id="fos{{$index}}E" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.fos | formatViewValues: \'fos\': feed.dm}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.amount" e-format-input-value="amount" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'E\', feed.id)" id="amountMIX{{$index}}E{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.vem" e-format-input-value="vem" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'vem\', \'E\', feed.id)" id="vemMIX{{$index}}E{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.vem | formatViewValues: \'vem\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.fos" e-format-input-value="fos" e-format-value-dm="mixfeed.dm" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'fos\', \'E\', feed.id)" id="fosMIX{{$index}}E{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.fos | formatViewValues: \'fos\': mixfeed.dm}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsFiber/balanceRation.fiber.requirementsUS.html','<div ng-if="!vm.loadingTabs" class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th></th><th><data-i18n i18n="_feeds_amount_">amount</data-i18n></th><th><data-i18n i18n="_feeds_ndf_">NDF</data-i18n></th><th><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n></th><th><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n></th><th><data-i18n i18n="_feeds_for_ndf_">forNDF</data-i18n></th><th><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n></th><th><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n></th><th><data-i18n i18n="_feeds_adf_">ADF</data-i18n></th><th><data-i18n i18n="_feeds_rdndf_">RDNDF</data-i18n></th><th><data-i18n i18n="_feeds_tdndf_">tdNDF</data-i18n></th></tr></thead><tbody ng-if="vm.settings.use_percent"><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th></tr></tbody><tbody ng-if="!vm.settings.use_percent"><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n class="nowrap" i18n="_rations_concentration_supplied_">Concentration supplied</data-i18n></td><td>{{vm.ration.concentration_supplied.amount_dm | formatViewValuesSignificant: \'amount\'}}</td><td>{{vm.ration.concentration_supplied.ndf | formatViewValuesSignificant: \'ndf\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.ef_ndf_as_ndf | formatViewValuesSignificant: \'ef_ndf_as_ndf\'}}</td><td>{{vm.ration.concentration_supplied.lignin | formatViewValuesSignificant: \'lignin\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.for_ndf | formatViewValuesSignificant: \'for_ndf\'}}</td><td>{{vm.ration.concentration_supplied.ndf_digest | formatViewValuesSignificant: \'ndf_digest\'}}</td><td>{{vm.ration.concentration_supplied.ef_ndf_as_dm | formatViewValuesSignificant: \'ef_ndf_as_dm\'}}</td><td>{{vm.ration.concentration_supplied.adf | formatViewValuesSignificant: \'adf\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.rd_ndf | formatViewValuesSignificant: \'rd_ndf\'}}</td><td>{{vm.ration.concentration_supplied.td_ndf | formatViewValuesSignificant: \'td_ndf\'}}</td></tr></tbody><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n i18n="_rations_supply_">Supply</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.supply.ndf | formatViewValuesPerDay: \'ndf\'}}</td><td>{{vm.ration.supply.ef_ndf_as_ndf | formatViewValuesPerDay: \'ef_ndf_as_ndf\'}}</td><td>{{vm.ration.supply.lignin | formatViewValuesPerDay: \'lignin\'}}</td><td>{{vm.ration.supply.for_ndf | formatViewValuesPerDay: \'for_ndf\'}}</td><td>{{vm.ration.supply.ndf_digest | formatViewValuesPerDay: \'ndf_digest\'}}</td><td>{{vm.ration.supply.ef_ndf_as_dm | formatViewValuesPerDay: \'ef_ndf_as_dm\'}}</td><td>{{vm.ration.supply.adf | formatViewValuesPerDay: \'adf\'}}</td><td>{{vm.ration.supply.rd_ndf | formatViewValuesPerDay: \'rd_ndf\'}}</td><td>{{vm.ration.supply.td_ndf | formatViewValuesPerDay: \'td_ndf\'}}</td></tr><tr><td><data-i18n i18n="_rations_requirements_">Requirements</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.requirements.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.requirements.ndf | formatViewValuesPerDay: \'ndf\'}}</td><td>{{vm.ration.requirements.ef_ndf_as_ndf | formatViewValuesPerDay: \'ef_ndf_as_ndf\'}}</td><td></td><td>{{vm.ration.requirements.for_ndf | formatViewValuesPerDay: \'for_ndf\'}}</td><td></td><td>{{vm.ration.requirements.ef_ndf_as_dm | formatViewValuesPerDay: \'ef_ndf_as_dm\'}}</td><td></td><td></td><td></td></tr><tr class="ration-difference"><td><data-i18n i18n="_rations_difference_">Difference</data-i18n></td><td><span ng-class="vm.ration.difference.amount_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.amount_dm | formatViewValuesPerDay: \'amount\'}}</span></td><td><span ng-class="vm.ration.difference.ndf >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.ndf | formatViewValuesPerDay: \'ndf\'}}</span></td><td><span ng-class="vm.ration.difference.ef_ndf_as_ndf >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.ef_ndf_as_ndf | formatViewValuesPerDay: \'ef_ndf_as_ndf\'}}</span></td><td></td><td><span ng-class="vm.ration.difference.for_ndf >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.for_ndf | formatViewValuesPerDay: \'for_ndf\'}}</span></td><td></td><td><span ng-class="vm.ration.difference.ef_ndf_as_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.ef_ndf_as_dm | formatViewValuesPerDay: \'ef_ndf_as_dm\'}}</span></td><td></td><td></td><td></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsFiber/balanceRation.fiber.requirementsVemDve.html','<div ng-if="!vm.loadingTabs" class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th></th><th><data-i18n i18n="_feeds_amount_">amount</data-i18n></th><th><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n></th><th><data-i18n i18n="_feeds_ndf_">NDF</data-i18n></th><th><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n></th><th><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n></th><th><data-i18n i18n="_feeds_for_ndf_">forNDF</data-i18n></th><th><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n></th><th><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n></th><th><data-i18n i18n="_feeds_adf_">ADF</data-i18n></th></tr></thead><tbody ng-if="vm.settings.use_percent"><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th></tr></tbody><tbody ng-if="!vm.settings.use_percent"><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th></tr></tbody><tbody><tr><td><data-i18n class="nowrap" i18n="_rations_concentration_supplied_">Concentration supplied</data-i18n></td><td>{{vm.ration.concentration_supplied.amount_dm | formatViewValuesSignificant: \'amount\'}}</td><td>{{vm.ration.concentration_supplied.rc | formatViewValuesSignificant: \'rc\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.ndf | formatViewValuesSignificant: \'ndf\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.ef_ndf_as_ndf | formatViewValuesSignificant: \'ef_ndf_as_ndf\'}}</td><td>{{vm.ration.concentration_supplied.lignin | formatViewValuesSignificant: \'lignin\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.for_ndf | formatViewValuesSignificant: \'for_ndf\'}}</td><td>{{vm.ration.concentration_supplied.ndf_digest | formatViewValuesSignificant: \'ndf_digest\'}}</td><td>{{vm.ration.concentration_supplied.ef_ndf_as_dm | formatViewValuesSignificant: \'ef_ndf_as_dm\'}}</td><td>{{vm.ration.concentration_supplied.adf | formatViewValuesSignificant: \'adf\' : vm.ration.concentration_supplied.dm}}</td></tr></tbody><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n i18n="_rations_supply_">Supply</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.supply.rc | formatViewValuesPerDay: \'rc\'}}</td><td>{{vm.ration.supply.ndf | formatViewValuesPerDay: \'ndf\'}}</td><td>{{vm.ration.supply.ef_ndf_as_ndf | formatViewValuesPerDay: \'ef_ndf_as_ndf\'}}</td><td>{{vm.ration.supply.lignin | formatViewValuesPerDay: \'lignin\'}}</td><td>{{vm.ration.supply.for_ndf | formatViewValuesPerDay: \'for_ndf\'}}</td><td>{{vm.ration.supply.ndf_digest | formatViewValuesPerDay: \'ndf_digest\'}}</td><td>{{vm.ration.supply.ef_ndf_as_dm | formatViewValuesPerDay: \'ef_ndf_as_dm\'}}</td><td>{{vm.ration.supply.adf | formatViewValuesPerDay: \'adf\'}}</td></tr><tr><td><data-i18n i18n="_rations_requirements_">Requirements</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.requirements.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td></td><td>{{vm.ration.requirements.ndf | formatViewValuesPerDay: \'ndf\'}}</td><td>{{vm.ration.requirements.ef_ndf_as_ndf | formatViewValuesPerDay: \'ef_ndf_as_ndf\'}}</td><td></td><td>{{vm.ration.requirements.for_ndf | formatViewValuesPerDay: \'for_ndf\'}}</td><td></td><td>{{vm.ration.requirements.ef_ndf_as_dm | formatViewValuesPerDay: \'ef_ndf_as_dm\'}}</td><td></td></tr><tr class="ration-difference"><td><data-i18n i18n="_rations_difference_">Difference</data-i18n></td><td><span ng-class="vm.ration.difference.amount_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.amount_dm | formatViewValuesPerDay: \'amount\'}}</span></td><td></td><td><span ng-class="vm.ration.difference.ndf >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.ndf | formatViewValuesPerDay: \'ndf\'}}</span></td><td><span ng-class="vm.ration.difference.ef_ndf_as_ndf >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.ef_ndf_as_ndf | formatViewValuesPerDay: \'ef_ndf_as_ndf\'}}</span></td><td></td><td><span ng-class="vm.ration.difference.for_ndf >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.for_ndf | formatViewValuesPerDay: \'for_ndf\'}}</span></td><td></td><td><span ng-class="vm.ration.difference.ef_ndf_as_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.ef_ndf_as_dm | formatViewValuesPerDay: \'ef_ndf_as_dm\'}}</span></td><td></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsFiber/balanceRation.fiberUS.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="fiberTable" ng-if="vm.settings.use_percent"><thead><tr class="sortable"><th style="height: 76px" class="editable-header" st-sort="feed_name"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="ndf" class="editable-header"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="ef_ndf_as_ndf" class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th st-sort="lignin" class="editable-header"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="for_ndf"><div uib-tooltip="{{\'_description_for_ndf_\' | i18n}}" tooltip-is-open="forNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_for_ndf_">forNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th style="min-width: 130px" st-sort="ndf_digest" class="editable-header"><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th st-sort="ef_ndf_as_dm"><div uib-tooltip="{{\'_description_ef_ndf_as_dm_\' | i18n}}" tooltip-is-open="efNdfAsDmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="adf" class="editable-header"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="rd_ndf" class="editable-header"><div uib-tooltip="{{\'_description_rdndf_\' | i18n}}" tooltip-is-open="rdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdndf_">RDNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th st-sort="td_ndf"><div uib-tooltip="{{\'_description_td_ndf_\' | i18n}}" tooltip-is-open="tdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdndf_">tdNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody id="fiberBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'F\')" id="amount{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ndf" e-format-input-value="ndf" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf\', \'F\')" id="ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ef_ndf_as_ndf" e-format-input-value="ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ef_ndf_as_ndf\', \'F\')" id="ef_ndf_as_ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.lignin" e-format-input-value="lignin" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'lignin\', \'F\')" id="lignin{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.for_ndf | formatViewValues: \'for_ndf\'}}</span></td><td style="padding: 3px 3px; min-width: 130px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ndf_digest" e-format-input-value="ndf_digest" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf_digest\', \'F\')" id="ndf_digest{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.adf" e-format-input-value="adf" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'adf\', \'F\')" id="adf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.adf | formatViewValues: \'adf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.rd_ndf" e-format-input-value="rd_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rd_ndf\', \'F\')" id="rd_ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rd_ndf | formatViewValues: \'rd_ndf\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_ndf | formatViewValues: \'td_ndf\'}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.amount" e-format-input-value="amount" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'F\', feed.id)" id="amountMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ndf" e-format-input-value="ndf" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ndf\', \'F\', feed.id)" id="ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf | formatViewValues: \'ndf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ef_ndf_as_ndf" e-format-input-value="ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ef_ndf_as_ndf\', \'F\', feed.id)" id="ef_ndf_as_ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.lignin" e-format-input-value="lignin" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'lignin\', \'F\', feed.id)" id="ligninMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.lignin | formatViewValues: \'lignin\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.for_ndf | formatViewValues: \'for_ndf\'}}</span></td><td style="padding: 3px 3px; min-width: 130px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ndf_digest" e-format-input-value="ndf_digest" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ndf_digest\', \'F\', feed.id)" id="ndf_digestMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf_digest | formatViewValues: \'ndf_digest\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.adf" e-format-input-value="adf" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'adf\', \'F\', feed.id)" id="adfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.adf | formatViewValues: \'adf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.rd_ndf" e-format-input-value="rd_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rd_ndf\', \'F\', feed.id)" id="rd_ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rd_ndf | formatViewValues: \'rd_ndf\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_ndf | formatViewValues: \'td_ndf\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="fiberTable" ng-if="!vm.settings.use_percent"><thead><tr class="sortable"><th style="height: 76px" class="editable-header"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="ndf" class="editable-header"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="ef_ndf_as_ndf" class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th st-sort="lignin" class="editable-header"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="for_ndf"><div uib-tooltip="{{\'_description_for_ndf_\' | i18n}}" tooltip-is-open="forNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_for_ndf_">forNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th style="min-width: 130px" st-sort="ndf_digest" class="editable-header"><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th st-sort="ef_ndf_as_dm"><div uib-tooltip="{{\'_description_ef_ndf_as_dm_\' | i18n}}" tooltip-is-open="efNdfAsDmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="adf" class="editable-header"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="rd_ndf" class="editable-header"><div uib-tooltip="{{\'_description_rdndf_\' | i18n}}" tooltip-is-open="rdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdndf_">RDNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th st-sort="td_ndf"><div uib-tooltip="{{\'_description_td_ndf_\' | i18n}}" tooltip-is-open="tdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdndf_">tdNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody id="fiberBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'F\')" id="amount{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.ndf" e-format-input-value="ndf" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf\', \'F\')" id="ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ef_ndf_as_ndf" e-format-input-value="ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ef_ndf_as_ndf\', \'F\')" id="ef_ndf_as_ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.lignin" e-format-input-value="lignin" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'lignin\', \'F\')" id="lignin{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.for_ndf | formatViewValues: \'for_ndf\'}}</span></td><td style="padding: 3px 3px; min-width: 130px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ndf_digest" e-format-input-value="ndf_digest" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf_digest\', \'F\')" id="ndf_digest{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.adf" e-format-input-value="adf" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'adf\', \'F\')" id="adf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.adf | formatViewValues: \'adf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.rd_ndf" e-format-input-value="rd_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rd_ndf\', \'F\')" id="rd_ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rd_ndf | formatViewValues: \'rd_ndf\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_ndf | formatViewValues: \'td_ndf\'}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.amount" e-format-input-value="amount" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'F\', feed.id)" id="amountMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ndf" e-format-input-value="ndf" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ndf\', \'F\', feed.id)" id="ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf | formatViewValues: \'ndf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ef_ndf_as_ndf" e-format-input-value="ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ef_ndf_as_ndf\', \'F\', feed.id)" id="ef_ndf_as_ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.lignin" e-format-input-value="lignin" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'lignin\', \'F\', feed.id)" id="ligninMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.lignin | formatViewValues: \'lignin\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.for_ndf | formatViewValues: \'for_ndf\'}}</span></td><td style="padding: 3px 3px; min-width: 130px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ndf_digest" e-format-input-value="ndf_digest" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ndf_digest\', \'F\', feed.id)" id="ndf_digestMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf_digest | formatViewValues: \'ndf_digest\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.adf" e-format-input-value="adf" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'adf\', \'F\', feed.id)" id="adfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.adf | formatViewValues: \'adf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.rd_ndf" e-format-input-value="rd_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rd_ndf\', \'F\', feed.id)" id="rd_ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rd_ndf | formatViewValues: \'rd_ndf\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_ndf | formatViewValues: \'td_ndf\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsFiber/balanceRation.fiberVemDve.html','<div class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="fiberTable" ng-if="vm.settings.use_percent"><thead><tr class="sortable"><th style="height: 76px" st-sort="feed_name" class="editable-header"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="rc" class="editable-header"><div uib-tooltip="{{\'_description_rcel_\' | i18n}}" tooltip-is-open="rcNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="ndf" class="editable-header"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="ef_ndf_as_ndf" class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th st-sort="lignin" class="editable-header"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="for_ndf"><div uib-tooltip="{{\'_description_for_ndf_\' | i18n}}" tooltip-is-open="forNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_for_ndf_">forNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th style="min-width: 130px" st-sort="ndf_digest" class="editable-header"><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th st-sort="ef_ndf_as_dm"><div uib-tooltip="{{\'_description_ef_ndf_as_dm_\' | i18n}}" tooltip-is-open="efNdfAsDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="adf" class="editable-header"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th></tr></thead><tbody id="fiberBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'F\')" id="amount{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.rc" e-format-input-value="rc" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rc\', \'F\')" id="rc{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rc | formatViewValues: \'rc\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ndf" e-format-input-value="ndf" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf\', \'F\')" id="ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ef_ndf_as_ndf" e-format-input-value="ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ef_ndf_as_ndf\', \'F\')" id="ef_ndf_as_ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.lignin" e-format-input-value="lignin" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'lignin\', \'F\')" id="lignin{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.for_ndf}}</span></td><td style="padding: 3px 3px; min-width: 130px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ndf_digest" e-format-input-value="ndf_digest" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf_digest\', \'F\')" id="ndf_digest{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.adf" e-format-input-value="adf" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'adf\', \'F\')" id="adf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.adf | formatViewValues: \'adf\': feed.dm}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.amount" e-format-input-value="amount" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'F\', feed.id)" id="amountMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.rc" e-format-input-value="rc" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rc\', \'F\', feed.id)" id="rcMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rc | formatViewValues: \'rc\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ndf" e-format-input-value="ndf" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ndf\', \'F\', feed.id)" id="ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf | formatViewValues: \'ndf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ef_ndf_as_ndf" e-format-input-value="ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ef_ndf_as_ndf\', \'F\', feed.id)" id="ef_ndf_as_ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.lignin" e-format-input-value="lignin" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'lignin\', \'F\', feed.id)" id="ligninMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.lignin | formatViewValues: \'lignin\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.for_ndf}}</span></td><td style="padding: 3px 3px; min-width: 130px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ndf_digest" e-format-input-value="ndf_digest" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ndf_digest\', \'F\', feed.id)" id="ndf_digestMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf_digest | formatViewValues: \'ndf_digest\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.adf" e-format-input-value="adf" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'adf\', \'F\', feed.id)" id="adfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.adf | formatViewValues: \'adf\': mixfeed.dm}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="fiberTable" ng-if="!vm.settings.use_percent"><thead><tr class="sortable"><th style="height: 76px" class="editable-header"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="rc" class="editable-header"><div uib-tooltip="{{\'_description_rcel_\' | i18n}}" tooltip-is-open="rcNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="ndf" class="editable-header"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="ef_ndf_as_ndf" class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th st-sort="lignin" class="editable-header"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="for_ndf"><div uib-tooltip="{{\'_description_for_ndf_\' | i18n}}" tooltip-is-open="forNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_for_ndf_">forNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th style="min-width: 130px" st-sort="ndf_digest" class="editable-header"><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th st-sort="ef_ndf_as_dm"><div uib-tooltip="{{\'_description_ef_ndf_as_dm_\' | i18n}}" tooltip-is-open="efNdfAsDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="adf" class="editable-header"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody id="fiberBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'F\')" id="amount{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.rc" e-format-input-value="rc" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'rc\', \'F\')" id="rc{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rc | formatViewValues: \'rc\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.ndf" e-format-input-value="ndf" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf\', \'F\')" id="ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ef_ndf_as_ndf" e-format-input-value="ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ef_ndf_as_ndf\', \'F\')" id="ef_ndf_as_ndf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.lignin" e-format-input-value="lignin" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'lignin\', \'F\')" id="lignin{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.for_ndf}}</span></td><td style="padding: 3px 3px; min-width: 130px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ndf_digest" e-format-input-value="ndf_digest" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf_digest\', \'F\')" id="ndf_digest{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.adf" e-format-input-value="adf" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'adf\', \'F\')" id="adf{{$index}}F" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.adf | formatViewValues: \'adf\': feed.dm}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.amount" e-format-input-value="amount" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'F\', feed.id)" id="amountMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.rc" e-format-input-value="rc" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rc\', \'F\', feed.id)" id="rcMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rc | formatViewValues: \'rc\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ndf" e-format-input-value="ndf" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ndf\', \'F\', feed.id)" id="ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf | formatViewValues: \'ndf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ef_ndf_as_ndf" e-format-input-value="ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ef_ndf_as_ndf\', \'F\', feed.id)" id="ef_ndf_as_ndfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.lignin" e-format-input-value="lignin" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'lignin\', \'F\', feed.id)" id="ligninMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.lignin | formatViewValues: \'lignin\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.for_ndf}}</span></td><td style="padding: 3px 3px; min-width: 130px"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ndf_digest" e-format-input-value="ndf_digest" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ndf_digest\', \'F\', feed.id)" id="ndf_digestMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf_digest | formatViewValues: \'ndf_digest\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.adf" e-format-input-value="adf" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'adf\', \'F\', feed.id)" id="adfMIX{{$index}}F{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.adf | formatViewValues: \'adf\': mixfeed.dm}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsHome/balanceRation.home.requirementsUS.html','<div ng-if="!vm.loadingTabs" class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th></th><th><data-i18n i18n="_feeds_amount_">amount</data-i18n></th><th><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n></th><th><data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th><data-i18n i18n="_feeds_group_as_fed_">group as fed</data-i18n></th><th><data-i18n i18n="_feeds_diet_dmi_">diet dmi</data-i18n></th><th><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n></th><th ng-show="vm.ration.group.type!=\'heifer\'"><data-i18n i18n="_feeds_nel_">NEL</data-i18n></th><th><data-i18n i18n="_feeds_me_">ME</data-i18n></th><th ng-show="vm.ration.group.type==\'heifer\'"><data-i18n i18n="_rations_nem_">nem</data-i18n></th><th ng-show="vm.ration.group.type==\'heifer\'"><data-i18n i18n="_rations_neg_">neg</data-i18n></th><th><data-i18n i18n="_feeds_ndf_">NDF</data-i18n></th><th><data-i18n i18n="_feeds_cp_">CP</data-i18n></th><th><data-i18n i18n="_feeds_rup_">RUP</data-i18n></th><th><data-i18n i18n="_feeds_mp_">mp</data-i18n></th><th><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n></th><th><data-i18n i18n="_feeds_fa_">FA</data-i18n></th><th><data-i18n i18n="_feeds_ca_">Ca</data-i18n></th><th><data-i18n i18n="_feeds_p_">P</data-i18n></th><th><data-i18n i18n="_feeds_na_">Na</data-i18n></th><th><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n></th><th><data-i18n i18n="_feeds_se_">Se</data-i18n></th><th><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n></th><th><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n></th></tr></thead><tbody ng-if="vm.settings.use_percent"><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th>{{vm.weight}}</th><th>%</th><th>{{vm.weight}}</th><th>%&nbsp;<data-i18n i18n="_feeds_dmi_">dmi</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th ng-show="vm.ration.group.type!=\'heifer\'">{{vm.energy}}/{{vm.weight}}</th><th>{{vm.energy}}/{{vm.weight}}</th><th ng-show="vm.ration.group.type==\'heifer\'">{{vm.energy}}/{{vm.weight}}</th><th ng-show="vm.ration.group.type==\'heifer\'">{{vm.energy}}/{{vm.weight}}</th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></th><th></th><th>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</th><th><data-i18n i18n="_unit_ppm_">ppm</data-i18n></th><th><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</th><th>{{vm.currency}}/{{vm.weight}}</th></tr></tbody><tbody ng-if="!vm.settings.use_percent"><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th>{{vm.weight}}</th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</th><th>{{vm.weight}}</th><th>%&nbsp;<data-i18n i18n="_feeds_dmi_">dmi</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th ng-show="vm.ration.group.type!=\'heifer\'">{{vm.energy}}/{{vm.weight}}</th><th>{{vm.energy}}/{{vm.weight}}</th><th ng-show="vm.ration.group.type==\'heifer\'">{{vm.energy}}/{{vm.weight}}</th><th ng-show="vm.ration.group.type==\'heifer\'">{{vm.energy}}/{{vm.weight}}</th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></th><th></th><th>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</th><th><data-i18n i18n="_unit_ppm_">ppm</data-i18n></th><th><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</th><th>{{vm.currency}}/{{vm.weight}}</th></tr></tbody><tbody><tr><td><data-i18n class="nowrap" i18n="_rations_concentration_supplied_">Concentration supplied</data-i18n></td><td>{{vm.ration.concentration_supplied.amount_dm | formatViewValuesSignificant: \'amount\'}}</td><td>{{vm.ration.concentration_supplied.as_fed | formatViewValuesSignificant: \'as_fed\'}}</td><td>{{vm.ration.concentration_supplied.dm | formatViewValuesSignificant: \'dm\'}}</td><td>{{vm.ration.concentration_supplied.group_as_fed | formatViewValuesSignificant: \'group_as_fed\'}}</td><td>{{vm.ration.concentration_supplied.diet_dmi | formatViewValuesSignificant: \'diet_dmi\'}}</td><td>{{vm.ration.concentration_supplied.ef_ndf_as_dm | formatViewValuesSignificant: \'ef_ndf_as_dm\'}}</td><td ng-show="vm.ration.group.type!=\'heifer\'">{{vm.ration.concentration_supplied.nel | formatViewValuesSignificant: \'nel\'}}</td><td>{{vm.ration.concentration_supplied.me | formatViewValuesSignificant: \'me\'}}</td><td ng-show="vm.ration.group.type==\'heifer\'">{{vm.ration.concentration_supplied.nem | formatViewValuesSignificant: \'nem\'}}</td><td ng-show="vm.ration.group.type==\'heifer\'">{{vm.ration.concentration_supplied.neg | formatViewValuesSignificant: \'neg\'}}</td><td>{{vm.ration.concentration_supplied.ndf | formatViewValuesSignificant: \'ndf\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.cp | formatViewValuesSignificant: \'cp\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.rup | formatViewValuesSignificant: \'rup\'}}</td><td>{{vm.ration.concentration_supplied.mp | formatViewValuesSignificant: \'mp\'}}</td><td>{{vm.ration.concentration_supplied.rup_dig | formatViewValuesSignificant: \'rup_dig\'}}</td><td>{{vm.ration.concentration_supplied.fa | formatViewValuesSignificant: \'fa\'}}</td><td>{{vm.ration.concentration_supplied.ca | formatViewValuesSignificant: \'ca\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.p | formatViewValuesSignificant: \'p\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.na | formatViewValuesSignificant: \'na\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.dcad | formatViewValuesSignificant: \'dcad\'}}</td><td>{{vm.ration.concentration_supplied.se | formatViewValuesSignificant: \'se\'}}</td><td>{{vm.ration.concentration_supplied.vitamin_e | formatViewValuesSignificant: \'vitamin_e\'}}</td><td>{{vm.ration.concentration_supplied.cost_dm | formatViewValuesSignificant: \'cost_dm\'}}</td></tr></tbody><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th ng-if="vm.settings.use_percent">%</th><th ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dmi_">dmi</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th ng-show="vm.ration.group.type!=\'heifer\'">{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th ng-show="vm.ration.group.type==\'heifer\'">{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th ng-show="vm.ration.group.type==\'heifer\'">{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_meq_">meq</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_iu_">IU</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.currency}}/<data-i18n i18n="_unit_day_">day</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n i18n="_rations_supply_">Supply</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.supply.as_fed | formatViewValuesPerDay: \'as_fed\'}}</td><td>{{vm.ration.supply.dm | formatViewValuesPerDay: \'dm\'}}</td><td>{{vm.ration.supply.group_as_fed | formatViewValuesPerDay: \'group_as_fed\'}}</td><td>{{vm.ration.supply.diet_dmi | formatViewValuesPerDay: \'diet_dmi\'}}</td><td>{{vm.ration.supply.ef_ndf_as_dm | formatViewValuesPerDay: \'ef_ndf_as_dm\'}}</td><td ng-show="vm.ration.group.type!=\'heifer\'">{{vm.ration.supply.nel | formatViewValuesPerDay: \'nel\'}}</td><td>{{vm.ration.supply.me | formatViewValuesPerDay: \'me\'}}</td><td ng-show="vm.ration.group.type==\'heifer\'">{{vm.ration.supply.nem | formatViewValuesPerDay: \'nem\'}}</td><td ng-show="vm.ration.group.type==\'heifer\'">{{vm.ration.supply.neg | formatViewValuesPerDay: \'neg\'}}</td><td>{{vm.ration.supply.ndf | formatViewValuesPerDay: \'ndf\'}}</td><td>{{vm.ration.supply.cp | formatViewValuesPerDay: \'cp\'}}</td><td>{{vm.ration.supply.rup | formatViewValuesPerDay: \'rup\'}}</td><td>{{vm.ration.supply.mp | formatViewValuesPerDay: \'mp\'}}</td><td>{{vm.ration.supply.rup_dig | formatViewValuesPerDay: \'rup_dig\'}}</td><td>{{vm.ration.supply.fa | formatViewValuesPerDay: \'fa\'}}</td><td>{{vm.ration.supply.ca | formatViewValuesPerDay: \'ca\'}}</td><td>{{vm.ration.supply.p | formatViewValuesPerDay: \'p\'}}</td><td>{{vm.ration.supply.na | formatViewValuesPerDay: \'na\'}}</td><td>{{vm.ration.supply.dcad | formatViewValuesPerDay: \'dcad\'}}</td><td>{{vm.ration.supply.se | formatViewValuesPerDay: \'se\'}}</td><td>{{vm.ration.supply.vitamin_e | formatViewValuesPerDay: \'vitamin_e\'}}</td><td>{{vm.ration.supply.cost_dm | formatViewValuesPerDay: \'cost_dm\'}}</td></tr><tr><td><data-i18n i18n="_rations_requirements_">Requirements</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.requirements.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td></td><td></td><td></td><td></td><td>{{vm.ration.requirements.ef_ndf_as_dm | formatViewValuesPerDay: \'ef_ndf_as_dm\'}}</td><td ng-show="vm.ration.group.type!=\'heifer\'">{{vm.ration.requirements.nel | formatViewValuesPerDay: \'nel\'}}</td><td>{{vm.ration.requirements.me | formatViewValuesPerDay: \'me\'}}</td><td ng-show="vm.ration.group.type==\'heifer\'">{{vm.ration.requirements.nem | formatViewValuesPerDay: \'nem\'}}</td><td ng-show="vm.ration.group.type==\'heifer\'">{{vm.ration.requirements.neg | formatViewValuesPerDay: \'neg\'}}</td><td>{{vm.ration.requirements.ndf | formatViewValuesPerDay: \'ndf\'}}</td><td>{{vm.ration.requirements.cp | formatViewValuesPerDay: \'cp\'}}</td><td>{{vm.ration.requirements.rup | formatViewValuesPerDay: \'rup\'}}</td><td>{{vm.ration.requirements.mp | formatViewValuesPerDay: \'mp\'}}</td><td>{{vm.ration.requirements.rup_dig | formatViewValuesPerDay: \'rup_dig\'}}</td><td></td><td>{{vm.ration.requirements.ca | formatViewValuesPerDay: \'ca\'}}</td><td>{{vm.ration.requirements.p | formatViewValuesPerDay: \'p\'}}</td><td>{{vm.ration.requirements.na | formatViewValuesPerDay: \'na\'}}</td><td></td><td>{{vm.ration.requirements.se | formatViewValuesPerDay: \'se\'}}</td><td>{{vm.ration.requirements.vitamin_e | formatViewValuesPerDay: \'vitamin_e\'}}</td><td></td></tr><tr class="ration-difference"><td><data-i18n i18n="_rations_difference_">Difference</data-i18n></td><td><span ng-class="vm.ration.difference.amount_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.amount_dm | formatViewValuesPerDay: \'amount\'}}</span></td><td></td><td></td><td></td><td></td><td><span ng-class="vm.ration.difference.ef_ndf_as_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.ef_ndf_as_dm | formatViewValuesPerDay: \'ef_ndf_as_dm\'}}</span></td><td ng-show="vm.ration.group.type!=\'heifer\'"><span ng-class="vm.ration.difference.nel >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.nel | formatViewValuesPerDay: \'nel\'}}</span></td><td><span ng-class="vm.ration.difference.me >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.me | formatViewValuesPerDay: \'me\'}}</span></td><td ng-show="vm.ration.group.type==\'heifer\'"><span ng-class="vm.ration.difference.nem >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.nem | formatViewValuesPerDay: \'nem\'}}</span></td><td ng-show="vm.ration.group.type==\'heifer\'"><span ng-class="vm.ration.difference.neg >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.neg | formatViewValuesPerDay: \'neg\'}}</span></td><td><span ng-class="vm.ration.difference.ndf >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.ndf | formatViewValuesPerDay: \'ndf\'}}</span></td><td><span ng-class="vm.ration.difference.cp >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.cp | formatViewValuesPerDay: \'cp\'}}</span></td><td><span ng-class="vm.ration.difference.rup >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.rup | formatViewValuesPerDay: \'rup\'}}</span></td><td><span ng-class="vm.ration.difference.mp >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.mp | formatViewValuesPerDay: \'mp\'}}</span></td><td><span ng-class="vm.ration.difference.rup_dig >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.rup_dig | formatViewValuesPerDay: \'rup_dig\'}}</span></td><td></td><td><span ng-class="vm.ration.difference.ca >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.ca | formatViewValuesPerDay: \'ca\'}}</span></td><td><span ng-class="vm.ration.difference.p >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.p | formatViewValuesPerDay: \'p\'}}</span></td><td><span ng-class="vm.ration.difference.na >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.na | formatViewValuesPerDay: \'na\'}}</span></td><td></td><td><span ng-class="vm.ration.difference.se >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.se | formatViewValuesPerDay: \'se\'}}</span></td><td><span ng-class="vm.ration.difference.vitamin_e >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.vitamin_e | formatViewValuesPerDay: \'vitamin_e\'}}</span></td><td></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsHome/balanceRation.home.requirementsVemDve.html','<div ng-if="!vm.loadingTabs" class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th></th><th><data-i18n i18n="_feeds_amount_">amount</data-i18n></th><th><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n></th><th><data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th><data-i18n i18n="_feeds_group_as_fed_">group as fed</data-i18n></th><th><data-i18n i18n="_feeds_vem_">vem</data-i18n></th><th><data-i18n i18n="_feeds_dve_">dve</data-i18n></th><th><data-i18n i18n="_feeds_oeb_">oeb</data-i18n></th><th><data-i18n i18n="_feeds_cp_">CP</data-i18n></th><th><data-i18n i18n="_feeds_fos_">fos</data-i18n></th><th><data-i18n i18n="_feeds_starch_">starch</data-i18n></th><th><data-i18n i18n="_feeds_rus_">rus</data-i18n></th><th><data-i18n i18n="_feeds_sugar_">sugar</data-i18n></th><th><data-i18n i18n="_feeds_ca_">Ca</data-i18n></th><th><data-i18n i18n="_feeds_p_">P</data-i18n></th><th><data-i18n i18n="_feeds_mg_">Mg</data-i18n></th><th><data-i18n i18n="_feeds_na_">Na</data-i18n></th><th><data-i18n i18n="_feeds_k_">K</data-i18n></th><th><data-i18n i18n="_feeds_cl_">Cl</data-i18n></th><th><data-i18n i18n="_feeds_s_">S</data-i18n></th><th><data-i18n i18n="_feeds_adf_">ADF</data-i18n></th><th><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n></th><th><data-i18n i18n="_feeds_ndf_">NDF</data-i18n></th><th><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n></th><th><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n></th></tr></thead><tbody ng-if="vm.settings.use_percent"><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th>{{vm.weight}}</th><th>%</th><th>{{vm.weight}}</th><th><data-i18n i18n="_feeds_vem_unit_">vem</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th></tr></tbody><tbody ng-if="!vm.settings.use_percent"><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th>{{vm.weight}}</th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</th><th>{{vm.weight}}</th><th><data-i18n i18n="_feeds_vem_unit_">vem</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n class="nowrap" i18n="_rations_concentration_supplied_">Concentration supplied</data-i18n></td><td>{{vm.ration.concentration_supplied.amount_dm | formatViewValuesSignificant: \'amount\'}}</td><td>{{vm.ration.concentration_supplied.as_fed | formatViewValuesSignificant: \'as_fed\'}}</td><td>{{vm.ration.concentration_supplied.dm | formatViewValuesSignificant: \'dm\'}}</td><td>{{vm.ration.concentration_supplied.group_as_fed | formatViewValuesSignificant: \'group_as_fed\'}}</td><td>{{vm.ration.concentration_supplied.vem | formatViewValues: \'vem\'}}</td><td>{{vm.ration.concentration_supplied.dve | formatViewValuesSignificant: \'dve\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.oeb | formatViewValuesSignificant: \'oeb\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.cp | formatViewValuesSignificant: \'cp\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.fos | formatViewValuesSignificant: \'fos\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.starch | formatViewValuesSignificant: \'starch\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.rus | formatViewValuesSignificant: \'rus\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.sugar | formatViewValuesSignificant: \'sugar\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.ca | formatViewValuesSignificant: \'ca\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.p | formatViewValuesSignificant: \'p\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.mg | formatViewValuesSignificant: \'mg\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.na | formatViewValuesSignificant: \'na\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.k | formatViewValuesSignificant: \'k\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.cl | formatViewValuesSignificant: \'cl\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.s | formatViewValuesSignificant: \'s\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.adf | formatViewValuesSignificant: \'adf\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.lignin | formatViewValuesSignificant: \'lignin\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.ndf | formatViewValuesSignificant: \'ndf\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.ef_ndf_as_ndf | formatViewValuesSignificant: \'ef_ndf_as_ndf\'}}</td><td>{{vm.ration.concentration_supplied.ef_ndf_as_dm | formatViewValuesSignificant: \'ef_ndf_as_dm\'}}</td></tr></tbody><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th ng-if="vm.settings.use_percent">%</th><th ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_feeds_vem_unit_">vem</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n i18n="_rations_supply_">Supply</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.supply.as_fed | formatViewValuesPerDay: \'as_fed\'}}</td><td>{{vm.ration.supply.dm | formatViewValuesSignificant: \'dm\'}}</td><td>{{vm.ration.supply.group_as_fed | formatViewValuesPerDay: \'group_as_fed\'}}</td><td>{{vm.ration.supply.vem | formatViewValues: \'vem\'}}</td><td>{{vm.ration.supply.dve | formatViewValuesPerDay: \'dve\'}}</td><td>{{vm.ration.supply.oeb | formatViewValuesPerDay: \'oeb\'}}</td><td>{{vm.ration.supply.cp | formatViewValuesPerDay: \'cp\'}}</td><td>{{vm.ration.supply.fos | formatViewValuesPerDay: \'fos\'}}</td><td>{{vm.ration.supply.starch | formatViewValuesPerDay: \'starch\'}}</td><td>{{vm.ration.supply.rus | formatViewValuesPerDay: \'rus\'}}</td><td>{{vm.ration.supply.sugar | formatViewValuesPerDay: \'sugar\'}}</td><td>{{vm.ration.supply.ca | formatViewValuesPerDay: \'ca\'}}</td><td>{{vm.ration.supply.p | formatViewValuesPerDay: \'p\'}}</td><td>{{vm.ration.supply.mg | formatViewValuesPerDay: \'mg\'}}</td><td>{{vm.ration.supply.na | formatViewValuesPerDay: \'na\'}}</td><td>{{vm.ration.supply.k | formatViewValuesPerDay: \'k\'}}</td><td>{{vm.ration.supply.cl | formatViewValuesPerDay: \'cl\'}}</td><td>{{vm.ration.supply.s | formatViewValuesPerDay: \'s\'}}</td><td>{{vm.ration.supply.adf | formatViewValuesPerDay: \'adf\'}}</td><td>{{vm.ration.supply.lignin | formatViewValuesPerDay: \'lignin\'}}</td><td>{{vm.ration.supply.ndf | formatViewValuesPerDay: \'ndf\'}}</td><td>{{vm.ration.supply.ef_ndf_as_ndf | formatViewValuesPerDay: \'ef_ndf_as_ndf\'}}</td><td>{{vm.ration.supply.ef_ndf_as_dm | formatViewValuesPerDay: \'ef_ndf_as_dm\'}}</td></tr><tr><td><data-i18n i18n="_rations_requirements_">Requirements</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.requirements.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td></td><td></td><td></td><td>{{vm.ration.requirements.vem | formatViewValues: \'vem\'}}</td><td>{{vm.ration.requirements.dve | formatViewValuesPerDay: \'dve\'}}</td><td></td><td>{{vm.ration.requirements.cp | formatViewValuesPerDay: \'cp\'}}</td><td></td><td></td><td></td><td></td><td>{{vm.ration.requirements.ca | formatViewValuesPerDay: \'ca\'}}</td><td>{{vm.ration.requirements.p | formatViewValuesPerDay: \'p\'}}</td><td>{{vm.ration.requirements.mg | formatViewValuesPerDay: \'mg\'}}</td><td>{{vm.ration.requirements.na | formatViewValuesPerDay: \'na\'}}</td><td>{{vm.ration.requirements.k | formatViewValuesPerDay: \'k\'}}</td><td>{{vm.ration.requirements.cl | formatViewValuesPerDay: \'cl\'}}</td><td>{{vm.ration.requirements.s | formatViewValuesPerDay: \'s\'}}</td><td></td><td></td><td>{{vm.ration.requirements.ndf | formatViewValuesPerDay: \'ndf\'}}</td><td>{{vm.ration.requirements.ef_ndf_as_ndf | formatViewValuesPerDay: \'ef_ndf_as_ndf\'}}</td><td>{{vm.ration.requirements.ef_ndf_as_dm | formatViewValuesPerDay: \'ef_ndf_as_dm\'}}</td></tr><tr class="ration-difference"><td><data-i18n i18n="_rations_difference_">Difference</data-i18n></td><td><span ng-class="vm.ration.difference.amount_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.amount_dm | formatViewValuesPerDay: \'amount\'}}</span></td><td></td><td></td><td></td><td><span ng-class="vm.ration.difference.vem >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.vem | formatViewValues: \'vem\'}}</span></td><td><span ng-class="vm.ration.difference.dve >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.dve | formatViewValuesPerDay: \'dve\'}}</span></td><td></td><td><span ng-class="vm.ration.difference.cp >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.cp | formatViewValuesPerDay: \'cp\'}}</span></td><td></td><td></td><td></td><td></td><td><span ng-class="vm.ration.difference.ca >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.ca | formatViewValuesPerDay: \'ca\'}}</span></td><td><span ng-class="vm.ration.difference.p >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.p | formatViewValuesPerDay: \'p\'}}</span></td><td><span ng-class="vm.ration.difference.mg >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.mg | formatViewValuesPerDay: \'mg\'}}</span></td><td><span ng-class="vm.ration.difference.na >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.na | formatViewValuesPerDay: \'na\'}}</span></td><td><span ng-class="vm.ration.difference.k >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.k | formatViewValuesPerDay: \'k\'}}</span></td><td><span ng-class="vm.ration.difference.cl >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.cl | formatViewValuesPerDay: \'cl\'}}</span></td><td><span ng-class="vm.ration.difference.s >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.s | formatViewValuesPerDay: \'s\'}}</span></td><td></td><td></td><td><span ng-class="vm.ration.difference.ndf >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.ndf | formatViewValuesPerDay: \'ndf\'}}</span></td><td><span ng-class="vm.ration.difference.ef_ndf_as_ndf >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.ef_ndf_as_ndf | formatViewValuesPerDay: \'ef_ndf_as_ndf\'}}</span></td><td><span ng-class="vm.ration.difference.ef_ndf_as_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.ef_ndf_as_dm | formatViewValuesPerDay: \'ef_ndf_as_dm\'}}</span></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsHome/balanceRation.homeUS.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="homeTable" ng-if="vm.settings.use_percent"><thead><tr class="sortable"><th st-sort="feed_name" style="height: 76px" class="editable-header"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th style="min-width: 125px" st-sort="as_fed" class="editable-header"><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th st-sort="dm" class="editable-header"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span>%</span></div></th><th style="min-width: 165px" st-sort="group_as_fed" class="editable-header"><div uib-tooltip="{{\'_description_group_as_fed_\' | i18n}}" tooltip-is-open="groupAsFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_group_as_fed_">group as fed</data-i18n><br>{{vm.weight}}</div></th><th style="min-width: 120px" st-sort="diet_dmi" class="editable-header"><div uib-tooltip="{{\'_description_diet_dmi_\' | i18n}}" tooltip-is-open="dietDmiIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_diet_dmi_">diet dmi</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dmi_">dmi</data-i18n></div></th><th st-sort="ef_ndf_as_dm_" class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_dm_\' | i18n}}" tooltip-is-open="efNdfAsDmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="nel" ng-show="vm.ration.group.type!=\'heifer\'"><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="me"><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me_">ME</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="nem" ng-show="vm.ration.group.type==\'heifer\'"><div uib-tooltip="{{\'_description_nem_\' | i18n}}" tooltip-is-open="nemIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_rations_nem_">nem</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="neg" ng-show="vm.ration.group.type==\'heifer\'"><div uib-tooltip="{{\'_description_neg_\' | i18n}}" tooltip-is-open="negIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_rations_neg_">neg</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="ndf" class="editable-header"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="cp" class="editable-header"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="rup"><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="mp"><div uib-tooltip="{{\'_description_mp_\' | i18n}}" tooltip-is-open="mpIsOpen" tooltip-placement="right" tooltip-append-to-body="true" tooltip-class="custBlue right tooltip-largeX" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp_">mp</data-i18n><br><br></div></th><th style="min-width: 130px" st-sort="rup_dig" class="editable-header"><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th st-sort="fa"><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="ca" class="editable-header"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="p" class="editable-header"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="na" class="editable-header"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="dcad"><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th st-sort="se" class="editable-header"><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th st-sort="vitamin_e" class="editable-header"><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th st-sort="cost_dm"><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th st-sort="test_date" style="min-width: 180px" class="editable-header"><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br><br></div></th></tr></thead><tbody id="homeBody"><tr ng-repeat-start="(indexX, feed) in vm.ration.feeds" class="editable-tr-wrap" ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-append-to-body="true" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px" id="test"><span e-step="0.01" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="amount{{$index}}H">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="min-width: 125px; padding: 3px 3px"><span e-step="0.01" editable-number="feed.as_fed" e-format-input-value="as_fed" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'as_fed\', \'H\')" id="as_fed{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.as_fed | formatViewValues: \'as_fed\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.dm" e-format-input-value="dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'dm\', \'H\')" id="dm{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.dm | formatViewValues: \'dm\'}}</span></td><td style="min-width: 165px; padding: 3px 3px"><span edit-disabled="vm.feed_loading" e-step="0.01" editable-number="feed.group_as_fed" e-format-input-value="group_as_fed" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'group_as_fed\', \'H\')" id="group_as_fed{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.group_as_fed | formatViewValues: \'group_as_fed\'}}</span></td><td style="padding: 3px 3px; min-width: 120px"><span edit-disabled="vm.feed_loading" e-step="0.01" editable-number="feed.diet_dmi" e-format-input-value="diet_dmi" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'diet_dmi\', \'H\')" id="diet_dmi{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.diet_dmi | formatViewValues: \'diet_dmi\'}}&nbsp;%</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ef_ndf_as_dm" e-format-input-value="ef_ndf_as_dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ef_ndf_as_dm\', \'H\')" id="ef_ndf_as_dm{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type!=\'heifer\'"><span>{{feed.nel | formatViewValues: \'nel\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.me | formatViewValues: \'me\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type==\'heifer\'"><span>{{feed.nem | formatViewValues: \'nem\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type==\'heifer\'"><span>{{feed.neg | formatViewValues: \'neg\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ndf" e-format-input-value="ndf" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf\', \'H\')" id="ndf{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.cp" e-format-input-value="cp" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'cp\', \'H\')" id="cp{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.rup | formatViewValues: \'rup\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.mp | formatViewValues: \'mp\'}}</span></td><td style="padding: 3px 3px; min-width: 130px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.rup_dig" e-format-input-value="rup_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rup_dig\', \'H\')" id="rup_dig{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.fa | formatViewValues: \'fa\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.ca" e-format-input-value="ca" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ca\', \'H\')" id="ca{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ca | formatViewValues: \'ca\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.p" e-format-input-value="p" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'p\', \'H\')" id="p{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.p | formatViewValues: \'p\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.na" e-format-input-value="na" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'na\', \'H\')" id="na{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.na | formatViewValues: \'na\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.dcad | formatViewValues: \'dcad\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.se" e-format-input-value="se" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'se\', \'H\')" id="se{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.se | formatViewValues: \'se\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.vitamin_e" e-format-input-value="vitamin_e" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'vitamin_e\', \'H\')" id="vitamin_e{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.vitamin_e | formatViewValues: \'vitamin_e\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td style="min-width: 180px; padding: 3px 3px"><div class="form-group"><p class="input-group" ng-click="feed.datepickers = !feed.datepickers" ng-hide="$data" ng-model="$data" is-open="feed.datepickers" style="width: 95px; text-decoration: underline; text-decoration-style: dotted" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="feedsDate{{$index}}" name="feedsDate{{$index}}" popup-placement="bottom-right"><span>{{(feed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</span></p><p class="input-group" ng-show="$data"><input type="text" class="form-control" ng-click="feed.datepicker = !feed.datepicker" ng-model="$data" is-open="feed.datepicker" style="width: 95px" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" placeholder="{{(feed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="feedDate{{$index}}" name="feedDate{{$index}}" popup-placement="bottom-right"> <span class="input-group-btn"><button type="button" ng-disabled="vm.feed_loading" class="btn btn-primary btn-sm active" ng-click="vm.updateFeed(feed, $index, $data, \'test_date\')"><i class="glyphicon glyphicon-ok"></i></button> <button type="button" ng-disabled="vm.feed_loading" class="btn btn-danger btn-sm active" ng-click="$data = \'\'"><i class="ion-close-round ng-scope"></i></button></span></p></div></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix" ng-cloak=""><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="mixfeed.amount" e-format-input-value="amount" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'H\', feed.id)" id="amountMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="min-width: 125px; padding: 3px 3px"><span e-step="0.01" editable-number="mixfeed.as_fed" e-format-input-value="as_fed" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'as_fed\', \'H\', feed.id)" id="as_fedMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.as_fed | formatViewValues: \'as_fed\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.dm" e-format-input-value="dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'dm\', \'H\', feed.id)" id="dmMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.dm | formatViewValues: \'dm\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.group_as_fed" e-format-input-value="group_as_fed" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'group_as_fed\', \'H\', feed.id)" id="group_as_fedMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.group_as_fed | formatViewValues: \'group_as_fed\'}}</span></td><td style="padding: 3px 3px; min-width: 120px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.diet_dmi" e-format-input-value="diet_dmi" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'diet_dmi\', \'H\', feed.id)" id="diet_dmiMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.diet_dmi | formatViewValues: \'diet_dmi\'}}&nbsp;%</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.ef_ndf_as_dm" e-format-input-value="ef_ndf_as_dm" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ef_ndf_as_dm\', \'H\', feed.id)" id="ef_ndf_as_dmMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type!=\'heifer\'"><span>{{mixfeed.nel | formatViewValues: \'nel\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.me | formatViewValues: \'me\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type==\'heifer\'"><span>{{mixfeed.nem | formatViewValues: \'nem\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type==\'heifer\'"><span>{{mixfeed.neg | formatViewValues: \'neg\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.ndf" e-format-input-value="ndf" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ndf\', \'H\', feed.id)" id="ndfMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf | formatViewValues: \'ndf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.cp" e-format-input-value="cp" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'cp\', \'H\', feed.id)" id="cpMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cp | formatViewValues: \'cp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.rup | formatViewValues: \'rup\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.mp | formatViewValues: \'mp\'}}</span></td><td style="padding: 3px 3px; min-width: 130px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.rup_dig" e-format-input-value="rup_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rup_dig\', \'H\', feed.id)" id="rup_digMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rup_dig | formatViewValues: \'rup_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.fa | formatViewValues: \'fa\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.ca" e-format-input-value="ca" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ca\', \'H\', feed.id)" id="caMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ca | formatViewValues: \'ca\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.p" e-format-input-value="p" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'p\', \'H\', feed.id)" id="pMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.p | formatViewValues: \'p\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.na" e-format-input-value="na" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'na\', \'H\', feed.id)" id="naMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.na | formatViewValues: \'na\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.dcad | formatViewValues: \'dcad\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.se" e-format-input-value="se" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'se\', \'H\', feed.id)" id="seMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.se | formatViewValues: \'se\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.vitamin_e" e-format-input-value="vitamin_e" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'vitamin_e\', \'H\', feed.id)" id="vitamin_eMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.vitamin_e | formatViewValues: \'vitamin_e\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td style="min-width: 180px; padding: 3px 3px"><div class="form-group"><p ng-click="feedMixe.datepicker = !feedMixe.datepicker" ng-hide="$data[$index]" is-open="feedMixe.datepicker" ng-model="$data[$index]" uib-datepicker-popup="{{vm.date_format}}" style="text-decoration: underline; text-decoration-style: dotted" datepicker-options="vm.datepickerOptions" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="mixefeedDate{{indexX}}{{indexY}}" name="mixefeedDate{{indexX}}{{indexY}}" popup-placement="bottom-right"><span>{{(mixfeed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</span></p><p class="input-group" ng-show="$data[$index]"><input type="text" class="form-control" is-open="feedMix.datepicker" ng-click="feedMix.datepicker = !feedMix.datepicker" ng-model="$data[$index]" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" placeholder="{{(mixfeed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="mixfeedDate{{indexX}}{{indexY}}" name="mixfeedDate{{indexX}}{{indexY}}" popup-placement="bottom-right"> <span class="input-group-btn"><button type="button" ng-disabled="vm.mixfeed_loading" class="btn btn-primary btn-sm" ng-click="vm.updateFeedMix(mixfeed, $index, $data[$index], \'test_date\')"><i class="glyphicon glyphicon-ok"></i></button> <button type="button" ng-disabled="vm.mixfeed_loading" class="btn btn-danger btn-sm active" ng-click="$data[$index] = \'\'"><i class="ion-close-round ng-scope"></i></button></span></p></div></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" ng-if="!vm.settings.use_percent"><thead><tr class="sortable"><th st-sort="feed_name" style="height: 76px" class="editable-header"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th style="min-width: 125px" st-sort="as_fed" class="editable-header"><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th st-sort="dm" class="editable-header"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></div></th><th style="min-width: 165px" st-sort="group_as_fed" class="editable-header"><div uib-tooltip="{{\'_description_group_as_fed_\' | i18n}}" tooltip-is-open="groupAsFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_group_as_fed_">group as fed</data-i18n><br>{{vm.weight}}</div></th><th style="min-width: 120px" st-sort="diet_dmi" class="editable-header"><div uib-tooltip="{{\'_description_diet_dmi_\' | i18n}}" tooltip-is-open="dietDmiIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_diet_dmi_">diet dmi</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dmi_">dmi</data-i18n></div></th><th st-sort="ef_ndf_as_dm_" class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_dm_\' | i18n}}" tooltip-is-open="efNdfAsDmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="nel" ng-show="vm.ration.group.type!=\'heifer\'"><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="me"><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me_">ME</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="nem" ng-show="vm.ration.group.type==\'heifer\'"><div uib-tooltip="{{\'_description_nem_\' | i18n}}" tooltip-is-open="nemIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_rations_nem_">nem</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="neg" ng-show="vm.ration.group.type==\'heifer\'"><div uib-tooltip="{{\'_description_neg_\' | i18n}}" tooltip-is-open="negIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_rations_neg_">neg</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="ndf" class="editable-header"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="cp" class="editable-header"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="rup"><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="mp"><div uib-tooltip="{{\'_description_mp_\' | i18n}}" tooltip-is-open="mpIsOpen" tooltip-placement="right" tooltip-append-to-body="true" tooltip-class="custBlue right tooltip-largeX" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp_">mp</data-i18n><br><br></div></th><th style="min-width: 130px" st-sort="rup_dig" class="editable-header"><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th st-sort="fa"><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="ca" class="editable-header"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="p" class="editable-header"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="na" class="editable-header"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="dcad"><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th st-sort="se" class="editable-header"><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th st-sort="vitamin_e" class="editable-header"><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th st-sort="cost_dm"><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th st-sort="test_date" style="min-width: 180px" class="editable-header"><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br><br></div></th></tr></thead><tbody id="homeBody"><tr ng-repeat-start="(indexX, feed) in vm.ration.feeds" class="editable-tr-wrap" ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expandIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px" id="test"><span e-step="0.01" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="amount{{$index}}H">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="min-width: 125px; padding: 3px 3px"><span e-step="0.01" editable-number="feed.as_fed" e-format-input-value="as_fed" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'as_fed\', \'H\')" id="as_fed{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.as_fed | formatViewValues: \'as_fed\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.dm" e-format-input-value="dm" e-min="0" e-max="1000" onbeforesave="vm.updateFeed(feed, $index, $data, \'dm\', \'H\')" id="dm{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.dm | formatViewValues: \'dm\'}}</span></td><td style="min-width: 165px; padding: 3px 3px"><span edit-disabled="vm.feed_loading" e-step="0.01" editable-number="feed.group_as_fed" e-format-input-value="group_as_fed" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'group_as_fed\', \'H\')" id="group_as_fed{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.group_as_fed | formatViewValues: \'group_as_fed\'}}</span></td><td style="padding: 3px 3px; min-width: 120px"><span edit-disabled="vm.feed_loading" e-step="0.01" editable-number="feed.diet_dmi" e-format-input-value="diet_dmi" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'diet_dmi\', \'H\')" id="diet_dmi{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.diet_dmi | formatViewValues: \'diet_dmi\'}}&nbsp;%</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ef_ndf_as_dm" e-format-input-value="ef_ndf_as_dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ef_ndf_as_dm\', \'H\')" id="ef_ndf_as_dm{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type!=\'heifer\'"><span>{{feed.nel | formatViewValues: \'nel\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.me | formatViewValues: \'me\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type==\'heifer\'"><span>{{feed.nem | formatViewValues: \'nem\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type==\'heifer\'"><span>{{feed.neg | formatViewValues: \'neg\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.ndf" e-format-input-value="ndf" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf\', \'H\')" id="ndf{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.cp" e-format-input-value="cp" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'cp\', \'H\')" id="cp{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.rup | formatViewValues: \'rup\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.mp | formatViewValues: \'mp\'}}</span></td><td style="padding: 3px 3px; min-width: 130px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.rup_dig" e-format-input-value="rup_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rup_dig\', \'H\')" id="rup_dig{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.fa | formatViewValues: \'fa\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ca" e-format-input-value="ca" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ca\', \'H\')" id="ca{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ca | formatViewValues: \'ca\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.p" e-format-input-value="p" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'p\', \'H\')" id="p{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.p | formatViewValues: \'p\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.na" e-format-input-value="na" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'na\', \'H\')" id="na{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.na | formatViewValues: \'na\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.dcad | formatViewValues: \'dcad\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.se" e-format-input-value="se" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'se\', \'H\')" id="se{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.se | formatViewValues: \'se\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.vitamin_e" e-format-input-value="vitamin_e" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'vitamin_e\', \'H\')" id="vitamin_e{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.vitamin_e | formatViewValues: \'vitamin_e\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td style="min-width: 180px; padding: 3px 3px"><div class="form-group"><p class="input-group" ng-click="feed.datepickers = !feed.datepickers" ng-hide="$data" ng-model="$data" is-open="feed.datepickers" style="width: 95px; text-decoration: underline; text-decoration-style: dotted" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="feedsDate{{$index}}" name="feedsDate{{$index}}" popup-placement="bottom-right"><span>{{(feed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</span></p><p class="input-group" ng-show="$data"><input type="text" class="form-control" ng-click="feed.datepicker = !feed.datepicker" ng-model="$data" is-open="feed.datepicker" style="width: 95px" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" placeholder="{{(feed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="feedDate{{$index}}" name="feedDate{{$index}}" popup-placement="bottom-right"> <span class="input-group-btn"><button type="button" ng-disabled="vm.feed_loading" class="btn btn-primary btn-sm active" ng-click="vm.updateFeed(feed, $index, $data, \'test_date\')"><i class="glyphicon glyphicon-ok"></i></button> <button type="button" ng-disabled="vm.feed_loading" class="btn btn-danger btn-sm active" ng-click="$data = \'\'"><i class="ion-close-round ng-scope"></i></button></span></p></div></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix" ng-cloak=""><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="mixfeed.amount" e-format-input-value="amount" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'H\', feed.id)" id="amountMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="min-width: 125px; padding: 3px 3px"><span e-step="0.01" editable-number="mixfeed.as_fed" e-format-input-value="as_fed" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'as_fed\', \'H\', feed.id)" id="as_fedMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.as_fed | formatViewValues: \'as_fed\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.dm" e-format-input-value="dm" e-min="0" e-max="1000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'dm\', \'H\', feed.id)" id="dmMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.dm | formatViewValues: \'dm\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.group_as_fed" e-format-input-value="group_as_fed" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'group_as_fed\', \'H\', feed.id)" id="group_as_fedMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.group_as_fed | formatViewValues: \'group_as_fed\'}}</span></td><td style="padding: 3px 3px; min-width: 120px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.diet_dmi" e-format-input-value="diet_dmi" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'diet_dmi\', \'H\', feed.id)" id="diet_dmiMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.diet_dmi | formatViewValues: \'diet_dmi\'}}&nbsp;%</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.ef_ndf_as_dm" e-format-input-value="ef_ndf_as_dm" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ef_ndf_as_dm\', \'H\', feed.id)" id="ef_ndf_as_dmMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type!=\'heifer\'"><span>{{mixfeed.nel | formatViewValues: \'nel\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.me | formatViewValues: \'me\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type==\'heifer\'"><span>{{mixfeed.nem | formatViewValues: \'nem\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.ration.group.type==\'heifer\'"><span>{{mixfeed.neg | formatViewValues: \'neg\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.ndf" e-format-input-value="ndf" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ndf\', \'H\', feed.id)" id="ndfMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf | formatViewValues: \'ndf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.cp" e-format-input-value="cp" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'cp\', \'H\', feed.id)" id="cpMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cp | formatViewValues: \'cp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.rup | formatViewValues: \'rup\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.mp | formatViewValues: \'mp\'}}</span></td><td style="padding: 3px 3px; min-width: 130px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.rup_dig" e-format-input-value="rup_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rup_dig\', \'H\', feed.id)" id="rup_digMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rup_dig | formatViewValues: \'rup_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.fa | formatViewValues: \'fa\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.ca" e-format-input-value="ca" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ca\', \'H\', feed.id)" id="caMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ca | formatViewValues: \'ca\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.p" e-format-input-value="p" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'p\', \'H\', feed.id)" id="pMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.p | formatViewValues: \'p\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.na" e-format-input-value="na" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'na\', \'H\', feed.id)" id="naMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.na | formatViewValues: \'na\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.dcad | formatViewValues: \'dcad\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.se" e-format-input-value="se" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'se\', \'H\', feed.id)" id="seMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.se | formatViewValues: \'se\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.vitamin_e" e-format-input-value="vitamin_e" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'vitamin_e\', \'H\', feed.id)" id="vitamin_eMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.vitamin_e | formatViewValues: \'vitamin_e\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.cost_dm | formatViewValues: \'cost_dm\'}}</span></td><td style="min-width: 180px; padding: 3px 3px"><div class="form-group"><p ng-click="feedMixe.datepicker = !feedMixe.datepicker" ng-hide="$data[$index]" is-open="feedMixe.datepicker" ng-model="$data[$index]" uib-datepicker-popup="{{vm.date_format}}" style="text-decoration: underline; text-decoration-style: dotted" datepicker-options="vm.datepickerOptions" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="mixefeedDate{{indexX}}{{indexY}}" name="mixefeedDate{{indexX}}{{indexY}}" popup-placement="bottom-right"><span>{{(mixfeed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</span></p><p class="input-group" ng-show="$data[$index]"><input type="text" class="form-control" is-open="feedMix.datepicker" ng-click="feedMix.datepicker = !feedMix.datepicker" ng-model="$data[$index]" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" placeholder="{{(mixfeed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="mixfeedDate{{indexX}}{{indexY}}" name="mixfeedDate{{indexX}}{{indexY}}" popup-placement="bottom-right"> <span class="input-group-btn"><button type="button" ng-disabled="vm.mixfeed_loading" class="btn btn-primary btn-sm" ng-click="vm.updateFeedMix(mixfeed, $index, $data[$index], \'test_date\')"><i class="glyphicon glyphicon-ok"></i></button> <button type="button" ng-disabled="vm.mixfeed_loading" class="btn btn-danger btn-sm active" ng-click="$data[$index] = \'\'"><i class="ion-close-round ng-scope"></i></button></span></p></div></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsHome/balanceRation.homeVemDve.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" ng-if="vm.settings.use_percent"><thead><tr class="sortable"><th st-sort="feed_name" style="height: 76px" class="editable-header"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th style="min-width: 125px" st-sort="as_fed" class="editable-header"><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th st-sort="dm" class="editable-header"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span>%</span></div></th><th style="min-width: 165px" st-sort="group_as_fed" class="editable-header"><div uib-tooltip="{{\'_description_group_as_fed_\' | i18n}}" tooltip-is-open="groupAsFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_group_as_fed_">group as fed</data-i18n><br>{{vm.weight}}</div></th><th style="min-width: 120px" st-sort="diet_dmi" class="editable-header"><div uib-tooltip="{{\'_description_diet_dmi_\' | i18n}}" tooltip-is-open="dietDmiIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_diet_dmi_">diet dmi</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dmi_">dmi</data-i18n></div></th><th st-sort="vem" class="editable-header"><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">vem</data-i18n><br><br></div></th><th st-sort="dve" class="editable-header"><div uib-tooltip="DVE" tooltip-is-open="dveIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">dve</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="oeb" class="editable-header"><div uib-tooltip="OEB" tooltip-is-open="oebIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">oeb</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="cp" class="editable-header"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="fos" class="editable-header"><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">fos</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="starch" class="editable-header"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="rus" class="editable-header"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="sugar" class="editable-header"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="ca" class="editable-header"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="p" class="editable-header"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="mg" class="editable-header"><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">Mg</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="na" class="editable-header"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="k" class="editable-header"><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">K</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="cl" class="editable-header"><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">Cl</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="s" class="editable-header"><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">S</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="adf" class="editable-header"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="lignin" class="editable-header"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="ndf" class="editable-header"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="ef_ndf_as_ndf" class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th st-sort="ef_ndf_as_dm"><div uib-tooltip="{{\'_description_ef_ndf_as_dm_\' | i18n}}" tooltip-is-open="efNdfAsDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="test_date" style="min-width: 180px" class="editable-header"><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br><br></div></th></tr></thead><tbody id="homeBody"><tr ng-repeat-start="(indexX, feed) in vm.ration.feeds" class="editable-tr-wrap" ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected" style="margin-right: 2px"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-append-to-body="true" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" tooltip-append-to-body="true" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px" id="test"><span e-step="0.01" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="amount{{$index}}H">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="min-width: 125px; padding: 3px 3px"><span e-step="0.01" editable-number="feed.as_fed" e-format-input-value="as_fed" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'as_fed\', \'H\')" id="as_fed{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.as_fed | formatViewValues: \'as_fed\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.dm" e-format-input-value="dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'dm\', \'H\')" id="dm{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.dm | formatViewValues: \'dm\'}}</span></td><td style="min-width: 165px; padding: 3px 3px"><span edit-disabled="vm.feed_loading" e-step="0.01" editable-number="feed.group_as_fed" e-format-input-value="group_as_fed" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'group_as_fed\', \'H\')" id="group_as_fed{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.group_as_fed | formatViewValues: \'group_as_fed\'}}</span></td><td style="padding: 3px 3px; min-width: 120px"><span edit-disabled="vm.feed_loading" e-step="0.01" editable-number="feed.diet_dmi" e-format-input-value="diet_dmi" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'diet_dmi\', \'H\')" id="diet_dmi{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.diet_dmi | formatViewValues: \'diet_dmi\'}}&nbsp;%</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.vem" e-format-input-value="vem" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'vem\', \'H\')" id="vem{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.vem | formatViewValues: \'vem\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.dve" e-format-input-value="dve" e-format-value-dm="feed.dm" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'dve\', \'H\')" id="dve{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.dve | formatViewValues: \'dve\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.oeb" e-format-input-value="oeb" e-format-value-dm="feed.dm" e-min="-1000000" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'oeb\', \'H\')" id="oeb{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.cp" e-format-input-value="cp" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'cp\', \'H\')" id="cp{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.fos" e-format-input-value="fos" e-format-value-dm="feed.dm" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'fos\', \'H\')" id="fos{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.fos | formatViewValues: \'fos\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.starch" e-format-input-value="starch" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'starch\', \'H\')" id="starch{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.starch | formatViewValues: \'starch\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.rus" e-format-input-value="rus" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rus\', \'H\')" id="rus{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rus | formatViewValues: \'rus\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.sugar" e-format-input-value="sugar" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'sugar\', \'H\')" id="sugar{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.ca" e-format-input-value="ca" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ca\', \'H\')" id="ca{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ca | formatViewValues: \'ca\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.p" e-format-input-value="p" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'p\', \'H\')" id="p{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.p | formatViewValues: \'p\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.mg" e-format-input-value="mg" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'mg\', \'H\')" id="mg{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.mg | formatViewValues: \'mg\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.na" e-format-input-value="na" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'na\', \'H\')" id="na{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.na | formatViewValues: \'na\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.k" e-format-input-value="k" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'k\', \'H\')" id="k{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.k | formatViewValues: \'k\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.cl" e-format-input-value="cl" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'cl\', \'H\')" id="cl{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.cl | formatViewValues: \'cl\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.01" editable-number="feed.s" e-format-input-value="s" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'s\', \'H\')" id="s{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.s | formatViewValues: \'s\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.adf" e-format-input-value="adf" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'adf\', \'H\')" id="adf{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.adf | formatViewValues: \'adf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.lignin" e-format-input-value="lignin" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'lignin\', \'H\')" id="lignin{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ndf" e-format-input-value="ndf" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf\', \'H\')" id="ndf{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ef_ndf_as_ndf" e-format-input-value="ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ef_ndf_as_ndf\', \'H\')" id="ef_ndf_as_ndf{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="min-width: 180px; padding: 3px 3px"><div class="form-group"><p class="input-group" ng-click="feed.datepickers = !feed.datepickers" ng-hide="$data" ng-model="$data" is-open="feed.datepickers" style="width: 95px; text-decoration: underline; text-decoration-style: dotted" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="feedsDate{{$index}}" name="feedsDate{{$index}}" popup-placement="bottom-right"><span>{{(feed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</span></p><p class="input-group" ng-show="$data"><input type="text" class="form-control" ng-click="feed.datepicker = !feed.datepicker" ng-model="$data" is-open="feed.datepicker" style="width: 95px" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" placeholder="{{(feed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="feedDate{{$index}}" name="feedDate{{$index}}" popup-placement="bottom-right"> <span class="input-group-btn"><button type="button" ng-disabled="vm.feed_loading" class="btn btn-primary btn-sm active" ng-click="vm.updateFeed(feed, $index, $data, \'test_date\')"><i class="glyphicon glyphicon-ok"></i></button> <button type="button" ng-disabled="vm.feed_loading" class="btn btn-danger btn-sm active" ng-click="$data = \'\'"><i class="ion-close-round ng-scope"></i></button></span></p></div></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix" ng-cloak=""><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="mixfeed.amount" e-format-input-value="amount" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'H\', feed.id, feed.id)" id="amountMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="min-width: 125px; padding: 3px 3px"><span e-step="0.01" editable-number="mixfeed.as_fed" e-format-input-value="as_fed" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'as_fed\', \'H\', feed.id)" id="as_fedMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.as_fed | formatViewValues: \'as_fed\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.dm" e-format-input-value="dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'dm\', \'H\', feed.id)" id="dmMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.dm | formatViewValues: \'dm\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.group_as_fed" e-format-input-value="group_as_fed" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'group_as_fed\', \'H\', feed.id)" id="group_as_fedMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.group_as_fed | formatViewValues: \'group_as_fed\'}}</span></td><td style="padding: 3px 3px; min-width: 120px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.diet_dmi" e-format-input-value="diet_dmi" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'diet_dmi\', \'H\', feed.id)" id="diet_dmiMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.diet_dmi | formatViewValues: \'diet_dmi\'}}&nbsp;%</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.vem" e-format-input-value="vem" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'vem\', \'H\', feed.id)" id="vemMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.vem | formatViewValues: \'vem\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.dve" e-format-input-value="dve" e-format-value-dm="mixfeed.dm" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'dve\', \'H\', feed.id)" id="dveMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.dve | formatViewValues: \'dve\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.oeb" e-format-input-value="oeb" e-format-value-dm="mixfeed.dm" e-min="-1000000" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'oeb\', \'H\', feed.id)" id="oebMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.oeb | formatViewValues: \'oeb\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.cp" e-format-input-value="cp" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'cp\', \'H\', feed.id)" id="cpMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cp | formatViewValues: \'cp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.fos" e-format-input-value="fos" e-format-value-dm="mixfeed.dm" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'fos\', \'H\', feed.id)" id="fosMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.fos | formatViewValues: \'fos\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.starch" e-format-input-value="starch" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'starch\', \'H\', feed.id)" id="starchMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.starch | formatViewValues: \'starch\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.rus" e-format-input-value="rus" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rus\', \'H\', feed.id)" id="rusMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rus | formatViewValues: \'rus\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.sugar" e-format-input-value="sugar" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'sugar\', \'H\', feed.id)" id="sugarMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.sugar | formatViewValues: \'sugar\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.ca" e-format-input-value="ca" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ca\', \'H\', feed.id)" id="caMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ca | formatViewValues: \'ca\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.p" e-format-input-value="p" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'p\', \'H\', feed.id)" id="pMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.p | formatViewValues: \'p\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.mg" e-format-input-value="mg" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'mg\', \'H\', feed.id)" id="mgMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.mg | formatViewValues: \'mg\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.na" e-format-input-value="na" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'na\', \'H\', feed.id)" id="naMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.na | formatViewValues: \'na\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.k" e-format-input-value="k" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'k\', \'H\', feed.id)" id="kMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.k | formatViewValues: \'k\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.cl" e-format-input-value="cl" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'cl\', \'H\', feed.id)" id="clMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cl | formatViewValues: \'cl\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.s" e-format-input-value="s" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'s\', \'H\', feed.id)" id="sMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.s | formatViewValues: \'s\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.adf" e-format-input-value="adf" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'adf\', \'H\', feed.id)" id="adfMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.adf | formatViewValues: \'adf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.lignin" e-format-input-value="lignin" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'lignin\', \'H\', feed.id)" id="ligninMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.lignin | formatViewValues: \'lignin\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.ndf" e-format-input-value="ndf" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ndf\', \'H\', feed.id)" id="ndfMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf | formatViewValues: \'ndf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.ef_ndf_as_ndf" e-format-input-value="ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ef_ndf_as_ndf\', \'H\', feed.id)" id="ef_ndf_as_ndfMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="min-width: 180px; padding: 3px 3px"><div class="form-group"><p ng-click="feedMixe.datepicker = !feedMixe.datepicker" ng-hide="$data[$index]" is-open="feedMixe.datepicker" ng-model="$data[$index]" uib-datepicker-popup="{{vm.date_format}}" style="text-decoration: underline; text-decoration-style: dotted" datepicker-options="vm.datepickerOptions" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="mixefeedDate{{indexX}}{{indexY}}" name="mixefeedDate{{indexX}}{{indexY}}" popup-placement="bottom-right"><span>{{(mixfeed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</span></p><p class="input-group" ng-show="$data[$index]"><input type="text" class="form-control" is-open="feedMix.datepicker" ng-click="feedMix.datepicker = !feedMix.datepicker" ng-model="$data[$index]" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" placeholder="{{(mixfeed.test_date | date: vm.date_format) || \'empty\'}}" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="mixfeedDate{{indexX}}{{indexY}}" name="mixfeedDate{{indexX}}{{indexY}}" popup-placement="bottom-right"> <span class="input-group-btn"><button type="button" ng-disabled="vm.mixfeed_loading" class="btn btn-primary btn-sm" ng-click="vm.updateFeedMix(mixfeed, $index, $data[$index], \'test_date\')"><i class="glyphicon glyphicon-ok"></i></button> <button type="button" ng-disabled="vm.mixfeed_loading" class="btn btn-danger btn-sm active" ng-click="$data[$index] = \'\'"><i class="ion-close-round ng-scope"></i></button></span></p></div></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="homeTable" ng-if="!vm.settings.use_percent"><thead><tr class="sortable"><th st-sort="feed_name" style="height: 76px" class="editable-header"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th style="min-width: 125px" st-sort="as_fed" class="editable-header"><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th st-sort="dm" class="editable-header"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></div></th><th style="min-width: 165px" st-sort="group_as_fed" class="editable-header"><div uib-tooltip="{{\'_description_group_as_fed_\' | i18n}}" tooltip-is-open="groupAsFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_group_as_fed_">group as fed</data-i18n><br>{{vm.weight}}</div></th><th style="min-width: 120px" st-sort="diet_dmi" class="editable-header"><div uib-tooltip="{{\'_description_diet_dmi_\' | i18n}}" tooltip-is-open="dietDmiIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_diet_dmi_">diet dmi</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dmi_">dmi</data-i18n></div></th><th st-sort="vem" class="editable-header"><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">vem</data-i18n><br><br></div></th><th st-sort="dve" class="editable-header"><div uib-tooltip="DVE" tooltip-is-open="dveIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">dve</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="oeb" class="editable-header"><div uib-tooltip="OEB" tooltip-is-open="oebIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">oeb</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="cp" class="editable-header"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="fos" class="editable-header"><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">fos</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="starch" class="editable-header"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="rus" class="editable-header"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="sugar" class="editable-header"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="ca" class="editable-header"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="p" class="editable-header"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="mg" class="editable-header"><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">Mg</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="na" class="editable-header"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="k" class="editable-header"><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">K</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="cl" class="editable-header"><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">Cl</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="s" class="editable-header"><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">S</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="adf" class="editable-header"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="lignin" class="editable-header"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="ndf" class="editable-header"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="ef_ndf_as_ndf" class="editable-header"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th st-sort="ef_ndf_as_dm"><div uib-tooltip="{{\'_description_ef_ndf_as_dm_\' | i18n}}" tooltip-is-open="efNdfAsDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="test_date" style="min-width: 180px" class="editable-header"><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br><br></div></th></tr></thead><tbody id="homeBody"><tr ng-repeat-start="(indexX, feed) in vm.ration.feeds" class="editable-tr-wrap" ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected" style="margin-right: 2px"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-append-to-body="true" tooltip-is-open="convertIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-append-to-body="true" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px" id="test"><span e-step="0.01" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'H\')" e-ng-keydown="vm.feedKeyDown($event, $data)" id="amount{{$index}}H">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="min-width: 125px; padding: 3px 3px"><span e-step="0.01" editable-number="feed.as_fed" e-format-input-value="as_fed" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'as_fed\', \'H\')" id="as_fed{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.as_fed | formatViewValues: \'as_fed\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.dm" e-format-input-value="dm" e-min="0" e-max="1000" onbeforesave="vm.updateFeed(feed, $index, $data, \'dm\', \'H\')" id="dm{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.dm | formatViewValues: \'dm\'}}</span></td><td style="min-width: 165px; padding: 3px 3px"><span edit-disabled="vm.feed_loading" e-step="0.01" editable-number="feed.group_as_fed" e-format-input-value="group_as_fed" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'group_as_fed\', \'H\')" id="group_as_fed{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.group_as_fed | formatViewValues: \'group_as_fed\'}}</span></td><td style="padding: 3px 3px; min-width: 120px"><span edit-disabled="vm.feed_loading" e-step="0.01" editable-number="feed.diet_dmi" e-format-input-value="diet_dmi" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'diet_dmi\', \'H\')" id="diet_dmi{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.diet_dmi | formatViewValues: \'diet_dmi\'}}&nbsp;%</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.vem" e-format-input-value="vem" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'vem\', \'H\')" id="vem{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.vem | formatViewValues: \'vem\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.dve" e-format-input-value="dve" e-format-value-dm="feed.dm" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'dve\', \'H\')" id="dve{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.dve | formatViewValues: \'dve\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.oeb" e-format-input-value="oeb" e-format-value-dm="feed.dm" e-min="-1000000" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'oeb\', \'H\')" id="oeb{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.cp" e-format-input-value="cp" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'cp\', \'H\')" id="cp{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.fos" e-format-input-value="fos" e-format-value-dm="feed.dm" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'fos\', \'H\')" id="fos{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.fos | formatViewValues: \'fos\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.starch" e-format-input-value="starch" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'starch\', \'H\')" id="starch{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.starch | formatViewValues: \'starch\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.rus" e-format-input-value="rus" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'rus\', \'H\')" id="rus{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rus | formatViewValues: \'rus\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.sugar" e-format-input-value="sugar" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'sugar\', \'H\')" id="sugar{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ca" e-format-input-value="ca" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ca\', \'H\')" id="ca{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ca | formatViewValues: \'ca\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.p" e-format-input-value="p" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'p\', \'H\')" id="p{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.p | formatViewValues: \'p\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.mg" e-format-input-value="mg" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'mg\', \'H\')" id="mg{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.mg | formatViewValues: \'mg\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.na" e-format-input-value="na" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'na\', \'H\')" id="na{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.na | formatViewValues: \'na\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.k" e-format-input-value="k" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'k\', \'H\')" id="k{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.k | formatViewValues: \'k\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.cl" e-format-input-value="cl" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'cl\', \'H\')" id="cl{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.cl | formatViewValues: \'cl\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.s" e-format-input-value="s" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'s\', \'H\')" id="s{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.s | formatViewValues: \'s\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.adf" e-format-input-value="adf" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'adf\', \'H\')" id="adf{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.adf | formatViewValues: \'adf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.lignin" e-format-input-value="lignin" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'lignin\', \'H\')" id="lignin{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.ndf" e-format-input-value="ndf" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndf\', \'H\')" id="ndf{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ef_ndf_as_ndf" e-format-input-value="ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ef_ndf_as_ndf\', \'H\')" id="ef_ndf_as_ndf{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="min-width: 180px; padding: 3px 3px"><div class="form-group"><p class="input-group" ng-click="feed.datepickers = !feed.datepickers" ng-hide="$data" ng-model="$data" is-open="feed.datepickers" style="width: 95px; text-decoration: underline; text-decoration-style: dotted" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="feedsDate{{$index}}" name="feedsDate{{$index}}" popup-placement="bottom-right"><span>{{(feed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</span></p><p class="input-group" ng-show="$data"><input type="text" class="form-control" ng-click="feed.datepicker = !feed.datepicker" ng-model="$data" is-open="feed.datepicker" style="width: 95px" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" placeholder="{{(feed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="feedDate{{$index}}" name="feedDate{{$index}}" popup-placement="bottom-right"> <span class="input-group-btn"><button type="button" ng-disabled="vm.feed_loading" class="btn btn-primary btn-sm active" ng-click="vm.updateFeed(feed, $index, $data, \'test_date\')"><i class="glyphicon glyphicon-ok"></i></button> <button type="button" ng-disabled="vm.feed_loading" class="btn btn-danger btn-sm active" ng-click="$data = \'\'"><i class="ion-close-round ng-scope"></i></button></span></p></div></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix" ng-cloak=""><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="mixfeed.amount" e-format-input-value="amount" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'H\', feed.id, feed.id)" id="amountMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="min-width: 125px; padding: 3px 3px"><span e-step="0.01" editable-number="mixfeed.as_fed" e-format-input-value="as_fed" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'as_fed\', \'H\', feed.id)" id="as_fedMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.as_fed | formatViewValues: \'as_fed\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.dm" e-format-input-value="dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'dm\', \'H\', feed.id)" id="dmMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.dm | formatViewValues: \'dm\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.group_as_fed" e-format-input-value="group_as_fed" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'group_as_fed\', \'H\', feed.id)" id="group_as_fedMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.group_as_fed | formatViewValues: \'group_as_fed\'}}</span></td><td style="padding: 3px 3px; min-width: 120px"><span edit-disabled="vm.mixfeed_loading" e-step="0.01" editable-number="mixfeed.diet_dmi" e-format-input-value="diet_dmi" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'diet_dmi\', \'H\', feed.id)" id="diet_dmiMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.diet_dmi | formatViewValues: \'diet_dmi\'}}&nbsp;%</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.vem" e-format-input-value="vem" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'vem\', \'H\', feed.id)" id="vemMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.vem | formatViewValues: \'vem\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.dve" e-format-input-value="dve" e-format-value-dm="mixfeed.dm" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'dve\', \'H\', feed.id)" id="dveMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.dve | formatViewValues: \'dve\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.oeb" e-format-input-value="oeb" e-format-value-dm="mixfeed.dm" e-min="-1000000" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'oeb\', \'H\', feed.id)" id="oebMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.oeb | formatViewValues: \'oeb\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.cp" e-format-input-value="cp" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'cp\', \'H\', feed.id)" id="cpMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cp | formatViewValues: \'cp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.fos" e-format-input-value="fos" e-format-value-dm="mixfeed.dm" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'fos\', \'H\', feed.id)" id="fosMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.fos | formatViewValues: \'fos\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.starch" e-format-input-value="starch" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'starch\', \'H\', feed.id)" id="starchMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.starch | formatViewValues: \'starch\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.rus" e-format-input-value="rus" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rus\', \'H\', feed.id)" id="rusMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rus | formatViewValues: \'rus\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.sugar" e-format-input-value="sugar" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'sugar\', \'H\', feed.id)" id="sugarMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.sugar | formatViewValues: \'sugar\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.ca" e-format-input-value="ca" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ca\', \'H\', feed.id)" id="caMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ca | formatViewValues: \'ca\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.p" e-format-input-value="p" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'p\', \'H\', feed.id)" id="pMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.p | formatViewValues: \'p\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.mg" e-format-input-value="mg" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'mg\', \'H\', feed.id)" id="mgMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.mg | formatViewValues: \'mg\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.na" e-format-input-value="na" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'na\', \'H\', feed.id)" id="naMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.na | formatViewValues: \'na\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.k" e-format-input-value="k" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'k\', \'H\', feed.id)" id="kMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.k | formatViewValues: \'k\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.cl" e-format-input-value="cl" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'cl\', \'H\', feed.id)" id="clMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cl | formatViewValues: \'cl\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.s" e-format-input-value="s" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'s\', \'H\', feed.id)" id="sMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.s | formatViewValues: \'s\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.adf" e-format-input-value="adf" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'adf\', \'H\', feed.id)" id="adfMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.adf | formatViewValues: \'adf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.lignin" e-format-input-value="lignin" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'lignin\', \'H\', feed.id)" id="ligninMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.lignin | formatViewValues: \'lignin\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="any" editable-number="mixfeed.ndf" e-format-input-value="ndf" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ndf\', \'H\', feed.id)" id="ndfMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndf | formatViewValues: \'ndf\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.mixfeed_loading" e-step="0.1" editable-number="mixfeed.ef_ndf_as_ndf" e-format-input-value="ef_ndf_as_ndf" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ef_ndf_as_ndf\', \'H\', feed.id)" id="ef_ndf_as_ndfMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</span></td><td style="min-width: 180px; padding: 3px 3px"><div class="form-group"><p ng-click="feedMixe.datepicker = !feedMixe.datepicker" ng-hide="$data[$index]" is-open="feedMixe.datepicker" ng-model="$data[$index]" uib-datepicker-popup="{{vm.date_format}}" style="text-decoration: underline; text-decoration-style: dotted" datepicker-options="vm.datepickerOptions" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="mixefeedDate{{indexX}}{{indexY}}" name="mixefeedDate{{indexX}}{{indexY}}" popup-placement="bottom-right"><span>{{(mixfeed.test_date | date: vm.date_format) || (\'_label_empty_\' | i18n)}}</span></p><p class="input-group" ng-show="$data[$index]"><input type="text" class="form-control" is-open="feedMix.datepicker" ng-click="feedMix.datepicker = !feedMix.datepicker" ng-model="$data[$index]" uib-datepicker-popup="{{vm.date_format}}" datepicker-options="vm.datepickerOptions" placeholder="{{(mixfeed.test_date | date: vm.date_format) || \'empty\'}}" datepicker-append-to-body="true" close-text="Close" show-button-bar="true" id="mixfeedDate{{indexX}}{{indexY}}" name="mixfeedDate{{indexX}}{{indexY}}" popup-placement="bottom-right"> <span class="input-group-btn"><button type="button" ng-disabled="vm.mixfeed_loading" class="btn btn-primary btn-sm" ng-click="vm.updateFeedMix(mixfeed, $index, $data[$index], \'test_date\')"><i class="glyphicon glyphicon-ok"></i></button> <button type="button" ng-disabled="vm.mixfeed_loading" class="btn btn-danger btn-sm active" ng-click="$data[$index] = \'\'"><i class="ion-close-round ng-scope"></i></button></span></p></div></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsLipid/balanceRation.lipid.requirements.US.html','<div ng-if="!vm.loadingTabs" class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th></th><th><data-i18n i18n="_feeds_amount_">amount</data-i18n></th><th><data-i18n i18n="_feeds_ee_">EE</data-i18n></th><th><data-i18n i18n="_feeds_fa_">FA</data-i18n></th><th><data-i18n i18n="_feeds_sfa_">SFA</data-i18n></th><th><data-i18n i18n="_feeds_mufa_">MUFA</data-i18n></th><th><data-i18n i18n="_feeds_pufa_">PUFA</data-i18n></th><th><data-i18n i18n="_feeds_bhfa_">BHFA</data-i18n></th><th><data-i18n i18n="_feeds_idufa_">idufa</data-i18n></th><th><data-i18n i18n="_feeds_fa_dig_">FA dig</data-i18n></th><th><data-i18n i18n="_feeds_tdfa_">td FA</data-i18n></th></tr></thead><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th><span ng-show="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-show="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n class="nowrap" i18n="_rations_concentration_supplied_">Concentration supplied</data-i18n></td><td>{{vm.ration.concentration_supplied.amount_dm | formatViewValuesSignificant: \'amount\'}}</td><td>{{vm.ration.concentration_supplied.ee | formatViewValuesSignificant: \'ee\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.fa | formatViewValuesSignificant: \'fa\'}}</td><td>{{vm.ration.concentration_supplied.sfa | formatViewValuesSignificant: \'sfa\'}}</td><td>{{vm.ration.concentration_supplied.mufa | formatViewValuesSignificant: \'mufa\'}}</td><td>{{vm.ration.concentration_supplied.pufa | formatViewValuesSignificant: \'pufa\'}}</td><td>{{vm.ration.concentration_supplied.bhfa | formatViewValuesSignificant: \'bhfa\'}}</td><td>{{vm.ration.concentration_supplied.idufa | formatViewValuesSignificant: \'idufa\'}}</td><td>{{vm.ration.concentration_supplied.fa_dig | formatViewValuesSignificant: \'fa_dig\'}}</td><td>{{vm.ration.concentration_supplied.td_fa | formatViewValuesSignificant: \'td_fa\'}}</td></tr></tbody><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n i18n="_rations_supply_">Supply</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.supply.ee | formatViewValuesPerDay: \'ee\'}}</td><td>{{vm.ration.supply.fa | formatViewValuesPerDay: \'fa\'}}</td><td>{{vm.ration.supply.sfa | formatViewValuesPerDay: \'sfa\'}}</td><td>{{vm.ration.supply.mufa | formatViewValuesPerDay: \'mufa\'}}</td><td>{{vm.ration.supply.pufa | formatViewValuesPerDay: \'pufa\'}}</td><td>{{vm.ration.supply.bhfa | formatViewValuesPerDay: \'bhfa\'}}</td><td>{{vm.ration.supply.idufa | formatViewValuesPerDay: \'idufa\'}}</td><td>{{vm.ration.supply.fa_dig | formatViewValuesPerDay: \'fa_dig\'}}</td><td>{{vm.ration.supply.td_fa | formatViewValuesPerDay: \'td_fa\'}}</td></tr><tr><td><data-i18n i18n="_rations_requirements_">Requirements</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.requirements.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr class="ration-difference"><td><data-i18n i18n="_rations_difference_">Difference</data-i18n></td><td><span ng-class="vm.ration.difference.amount_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.amount_dm | formatViewValuesPerDay: \'amount\'}}</span></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsLipid/balanceRation.lipid.requirements.VemDve.html','<div ng-if="!vm.loadingTabs" class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th></th><th><data-i18n i18n="_feeds_amount_">amount</data-i18n></th><th><data-i18n i18n="_feeds_ee_">EE</data-i18n></th></tr></thead><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th><span ng-show="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-show="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th></tr></tbody><tbody><tr><td><data-i18n class="nowrap" i18n="_rations_concentration_supplied_">Concentration supplied</data-i18n></td><td>{{vm.ration.concentration_supplied.amount_dm | formatViewValuesSignificant: \'amount\'}}</td><td>{{vm.ration.concentration_supplied.ee | formatViewValuesSignificant: \'ee\' : vm.ration.concentration_supplied.dm}}</td></tr></tbody><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n i18n="_rations_supply_">Supply</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.supply.ee | formatViewValuesPerDay: \'ee\'}}</td></tr><tr><td><data-i18n i18n="_rations_requirements_">Requirements</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.requirements.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td></td></tr><tr class="ration-difference"><td><data-i18n i18n="_rations_difference_">Difference</data-i18n></td><td><span ng-class="vm.ration.difference.amount_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.amount_dm | formatViewValuesPerDay: \'amount\'}}</span></td><td></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsLipid/balanceRation.lipid.US.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="lipidTable"><thead><tr class="sortable"><th style="height: 77px" class="editable-header" st-sort="feed_name"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="ee" class="editable-header"><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><br><span ng-show="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-show="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="fa"><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="sfa"><div uib-tooltip="{{\'_description_sfa_\' | i18n}}" tooltip-is-open="sfaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sfa_">SFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th st-sort="mufa"><div uib-tooltip="{{\'_description_mufa_\' | i18n}}" tooltip-is-open="mufaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mufa_">MUFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th st-sort="pufa" class="editable-header"><div uib-tooltip="{{\'_description_pufa_\' | i18n}}" tooltip-is-open="pufaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_pufa_">PUFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th st-sort="bhfa" class="editable-header"><div uib-tooltip="{{\'_description_bhfa_\' | i18n}}" tooltip-is-open="bhfaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_bhfa_">BHFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th st-sort="idufa"><div uib-tooltip="{{\'_description_idufa_\' | i18n}}" tooltip-is-open="idufaIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_idufa_">idufa</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th st-sort="fa_dig" class="editable-header"><div uib-tooltip="{{\'_description_fa_dig_\' | i18n}}" tooltip-is-open="faDigIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_dig_">FA dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th st-sort="td_fa"><div uib-tooltip="{{\'_description_td_fa_\' | i18n}}" tooltip-is-open="tdFaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdfa_">td FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody id="lipidBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="any" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'L\')" id="amount{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.settings.use_percent"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ee" e-format-input-value="ee" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ee\', \'L\')" id="ee{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ee | formatViewValues: \'ee\': feed.dm}}</span></td><td style="padding: 3px 3px" ng-show="!vm.settings.use_percent"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.ee" e-format-input-value="ee" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ee\', \'L\')" id="ee{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ee | formatViewValues: \'ee\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.fa | formatViewValues: \'fa\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.sfa | formatViewValues: \'sfa\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.mufa | formatViewValues: \'mufa\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.pufa" e-format-input-value="pufa" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'pufa\', \'L\')" id="pufa{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.pufa | formatViewValues: \'pufa\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.bhfa" e-format-input-value="bhfa" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'bhfa\', \'L\')" id="bhfa{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.bhfa | formatViewValues: \'bhfa\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.idufa | formatViewValues: \'idufa\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.fa_dig" e-format-input-value="fa_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'fa_dig\', \'L\')" id="fa_dig{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.fa_dig | formatViewValues: \'fa_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_fa | formatViewValues: \'td_fa\'}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.amount" e-format-input-value="amount" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'L\', feed.id)" id="amountMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.settings.use_percent"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ee" e-format-input-value="ee" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ee\', \'L\', feed.id)" id="eeMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ee | formatViewValues: \'ee\': mixfeed.dm}}</span></td><td style="padding: 3px 3px" ng-show="!vm.settings.use_percent"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ee" e-format-input-value="ee" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ee\', \'L\', feed.id)" id="eeMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ee | formatViewValues: \'ee\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.fa | formatViewValues: \'fa\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.sfa | formatViewValues: \'sfa\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.mufa | formatViewValues: \'mufa\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.pufa" e-format-input-value="pufa" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'pufa\', \'L\', feed.id)" id="pufaMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.pufa | formatViewValues: \'pufa\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.bhfa" e-format-input-value="bhfa" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'bhfa\', \'L\', feed.id)" id="bhfaMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.bhfa | formatViewValues: \'bhfa\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.idufa | formatViewValues: \'idufa\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.fa_dig" e-format-input-value="fa_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'fa_dig\', \'L\', feed.id)" id="fa_digMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.fa_dig | formatViewValues: \'fa_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_fa | formatViewValues: \'td_fa\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsLipid/balanceRation.lipid.VemDve.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="lipidTable"><thead><tr class="sortable"><th style="height: 77px" class="editable-header" st-sort="feed_name"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="ee" class="editable-header"><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><br><span ng-show="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-show="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody id="lipidBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="any" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'L\')" id="amount{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.settings.use_percent"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ee" e-format-input-value="ee" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ee\', \'L\')" id="ee{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ee | formatViewValues: \'ee\': feed.dm}}</span></td><td style="padding: 3px 3px" ng-show="!vm.settings.use_percent"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.ee" e-format-input-value="ee" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ee\', \'L\')" id="ee{{$index}}L" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ee | formatViewValues: \'ee\': feed.dm}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.amount" e-format-input-value="amount" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'L\', feed.id)" id="amountMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px" ng-show="vm.settings.use_percent"><span e-step="0.1" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ee" e-format-input-value="ee" e-format-value-dm="mixfeed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ee\', \'L\', feed.id)" id="eeMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ee | formatViewValues: \'ee\': mixfeed.dm}}</span></td><td style="padding: 3px 3px" ng-show="!vm.settings.use_percent"><span e-step="any" edit-disabled="vm.mixfeed_loading" editable-number="mixfeed.ee" e-format-input-value="ee" e-format-value-dm="mixfeed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ee\', \'L\', feed.id)" id="eeMIX{{$index}}L{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ee | formatViewValues: \'ee\': mixfeed.dm}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsProtein/balanceRation.protein.requirementsUS.html','<div ng-if="!vm.loadingTabs" class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th></th><th><data-i18n i18n="_feeds_amount_">amount</data-i18n></th><th><data-i18n i18n="_feeds_cp_">CP</data-i18n></th><th><data-i18n i18n="_feeds_rup_">RUP</data-i18n></th><th><data-i18n i18n="_feeds_rdp_">rdp</data-i18n></th><th><data-i18n i18n="_feeds_mp_">mp</data-i18n></th><th><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n></th><th><data-i18n i18n="_feeds_npncpe_">NPNCPE</data-i18n></th><th><data-i18n i18n="_feeds_rup89_">rup 89</data-i18n></th><th><data-i18n i18n="_feeds_rdp01_">rdp 01</data-i18n></th><th><data-i18n i18n="_feeds_mp01_">mp 01</data-i18n></th><th><data-i18n i18n="_feeds_ndicp_">NDICP</data-i18n></th><th><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n></th><th><data-i18n i18n="_feeds_tdtrup_">tdtrup</data-i18n></th></tr></thead><tbody ng-if="vm.settings.use_percent"><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></th><th></th><th>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th></tr></tbody><tbody ng-if="!vm.settings.use_percent"><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></th><th></th><th>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n class="nowrap" i18n="_rations_concentration_supplied_">Concentration supplied</data-i18n></td><td>{{vm.ration.concentration_supplied.amount_dm | formatViewValuesSignificant: \'amount\'}}</td><td>{{vm.ration.concentration_supplied.cp | formatViewValuesSignificant: \'cp\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.rup | formatViewValuesSignificant: \'rup\'}}</td><td>{{vm.ration.concentration_supplied.rdp | formatViewValuesSignificant: \'rdp\'}}</td><td>{{vm.ration.concentration_supplied.mp | formatViewValuesSignificant: \'mp\'}}</td><td>{{vm.ration.concentration_supplied.rup_dig | formatViewValuesSignificant: \'rup_dig\'}}</td><td>{{vm.ration.concentration_supplied.npncpe | formatViewValuesSignificant: \'npncpe\'}}</td><td>{{vm.ration.concentration_supplied.rup_89 | formatViewValuesSignificant: \'rup_89\'}}</td><td>{{vm.ration.concentration_supplied.rdp_01 | formatViewValuesSignificant: \'rdp_01\'}}</td><td>{{vm.ration.concentration_supplied.mp_01 | formatViewValuesSignificant: \'mp_01\'}}</td><td>{{vm.ration.concentration_supplied.ndicp | formatViewValuesSignificant: \'ndicp\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.adicp | formatViewValuesSignificant: \'adicp\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.td_trup | formatViewValuesSignificant: \'td_trup\'}}</td></tr></tbody><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th><data-i18n i18n="_unit_day_">day</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n i18n="_rations_supply_">Supply</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.supply.cp | formatViewValuesPerDay: \'cp\'}}</td><td>{{vm.ration.supply.rup | formatViewValuesPerDay: \'rup\'}}</td><td>{{vm.ration.supply.rdp | formatViewValuesPerDay: \'rdp\'}}</td><td>{{vm.ration.supply.mp | formatViewValuesPerDay: \'mp\'}}</td><td>{{vm.ration.supply.rup_dig | formatViewValuesPerDay: \'rup_dig\'}}</td><td>{{vm.ration.supply.npncpe | formatViewValuesPerDay: \'npncpe\'}}</td><td>{{vm.ration.supply.rup_89 | formatViewValuesPerDay: \'rup_89\'}}</td><td>{{vm.ration.supply.rdp_01 | formatViewValuesPerDay: \'rdp_01\'}}</td><td>{{vm.ration.supply.mp_01 | formatViewValuesPerDay: \'mp_01\'}}</td><td>{{vm.ration.supply.ndicp | formatViewValuesPerDay: \'ndicp\'}}</td><td>{{vm.ration.supply.adicp | formatViewValuesPerDay: \'adicp\'}}</td><td>{{vm.ration.supply.td_trup | formatViewValuesPerDay: \'td_trup\'}}</td></tr><tr><td><data-i18n i18n="_rations_requirements_">Requirements</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.requirements.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.requirements.cp | formatViewValuesPerDay: \'cp\'}}</td><td>{{vm.ration.requirements.rup | formatViewValuesPerDay: \'rup\'}}</td><td>{{vm.ration.requirements.rdp | formatViewValuesPerDay: \'rdp\'}}</td><td>{{vm.ration.requirements.mp | formatViewValuesPerDay: \'mp\'}}</td><td>{{vm.ration.requirements.rup_dig | formatViewValuesPerDay: \'rup_dig\'}}</td><td></td><td>{{vm.ration.requirements.rup_89 | formatViewValuesPerDay: \'rup_89\'}}</td><td>{{vm.ration.requirements.rdp_01 | formatViewValuesPerDay: \'rdp_01\'}}</td><td>{{vm.ration.requirements.mp_01 | formatViewValuesPerDay: \'mp_01\'}}</td><td></td><td></td><td></td></tr><tr class="ration-difference"><td><data-i18n i18n="_rations_difference_">Difference</data-i18n></td><td><span ng-class="vm.ration.difference.amount_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.amount_dm | formatViewValuesPerDay: \'amount\'}}</span></td><td><span ng-class="vm.ration.difference.cp >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.cp | formatViewValuesPerDay: \'cp\'}}</span></td><td><span ng-class="vm.ration.difference.rup >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.rup | formatViewValuesPerDay: \'rup\'}}</span></td><td><span ng-class="vm.ration.difference.rdp >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.rdp | formatViewValuesPerDay: \'rdp\'}}</span></td><td><span ng-class="vm.ration.difference.mp >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.mp | formatViewValuesPerDay: \'mp\'}}</span></td><td><span ng-class="vm.ration.difference.rup_dig >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.rup_dig | formatViewValuesPerDay: \'rup_dig\'}}</span></td><td></td><td><span ng-class="vm.ration.difference.rup_89 >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.rup_89 | formatViewValuesPerDay: \'rup_89\'}}</span></td><td><span ng-class="vm.ration.difference.rdp_01 >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.rdp_01 | formatViewValuesPerDay: \'rdp_01\'}}</span></td><td><span ng-class="vm.ration.difference.mp_01 >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.mp_01 | formatViewValuesPerDay: \'mp_01\'}}</span></td><td></td><td></td><td></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsProtein/balanceRation.protein.requirementsVemDve.html','<div ng-if="!vm.loadingTabs" class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th></th><th><data-i18n i18n="_feeds_amount_">amount</data-i18n></th><th><data-i18n i18n="_feeds_cp_">CP</data-i18n></th><th><data-i18n i18n="_feeds_dve_">DVE</data-i18n></th><th><data-i18n i18n="_feeds_oeb_">OEB</data-i18n></th></tr></thead><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}</th><th><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th><th><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></th></tr></tbody><tbody><tr><td><data-i18n class="nowrap" i18n="_rations_concentration_supplied_">Concentration supplied</data-i18n></td><td>{{vm.ration.concentration_supplied.amount_dm | formatViewValuesSignificant: \'amount\'}}</td><td>{{vm.ration.concentration_supplied.cp | formatViewValuesSignificant: \'cp\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.dve | formatViewValuesSignificant: \'dve\' : vm.ration.concentration_supplied.dm}}</td><td>{{vm.ration.concentration_supplied.oeb | formatViewValuesSignificant: \'oeb\' : vm.ration.concentration_supplied.dm}}</td></tr></tbody><tbody><tr class="concentration-header"><th></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th><th>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></th></tr></tbody><tbody><tr><td><data-i18n i18n="_rations_supply_">Supply</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.supply.cp | formatViewValuesPerDay: \'cp\'}}</td><td>{{vm.ration.supply.dve | formatViewValuesPerDay: \'dve\'}}</td><td>{{vm.ration.supply.oeb | formatViewValuesPerDay: \'oeb\'}}</td></tr><tr><td><data-i18n i18n="_rations_requirements_">Requirements</data-i18n>&nbsp;<span>({{vm.amountString}})</span></td><td>{{vm.ration.requirements.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{vm.ration.requirements.cp | formatViewValuesPerDay: \'cp\'}}</td><td>{{vm.ration.requirements.dve | formatViewValuesPerDay: \'dve\'}}</td><td></td></tr><tr class="ration-difference"><td><data-i18n i18n="_rations_difference_">Difference</data-i18n></td><td><span ng-class="vm.ration.difference.amount_dm >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.amount_dm | formatViewValuesPerDay: \'amount\'}}</span></td><td><span ng-class="vm.ration.difference.cp >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.cp | formatViewValuesPerDay: \'cp\'}}</span></td><td><span ng-class="vm.ration.difference.dve >= 0 ? \'primaryModal\' : \'warningModal\'">{{vm.ration.difference.dve | formatViewValuesPerDay: \'dve\'}}</span></td><td></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsProtein/balanceRation.proteinUS.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="proteinTable" ng-if="vm.settings.use_percent"><thead><tr class="sortable"><th style="height: 77px" class="editable-header" st-sort="feed_name"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="cp" class="editable-header"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="rup"><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="rdp"><div uib-tooltip="{{\'_description_rdp_\' | i18n}}" tooltip-is-open="rdpIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp_">rdp</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="mp"><div uib-tooltip="{{\'_description_mp_\' | i18n}}" tooltip-is-open="mpIsOpen" tooltip-placement="right" tooltip-append-to-body="true" tooltip-class="custBlue right tooltip-largeX" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp_">mp</data-i18n><br><br></div></th><th style="min-width: 130px" st-sort="rup_dig" class="editable-header"><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th st-sort="a_prot"><div uib-tooltip="{{\'_description_a_prot_\' | i18n}}" tooltip-is-open="AProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_a_">A Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="b_prot" class="editable-header"><div uib-tooltip="{{\'_description_b_prot_\' | i18n}}" tooltip-is-open="BProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_b_">B Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="c_prot" class="editable-header"><div uib-tooltip="{{\'_description_c_prot_\' | i18n}}" tooltip-is-open="CProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_c_">C Prot</data-i18n><br>%<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="kd_b_prot" class="editable-header"><div uib-tooltip="{{\'_description_kd_bprot_\' | i18n}}" tooltip-is-open="kdBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kd_bprot_">kd bprot</data-i18n><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th st-sort="kp_b_prot"><div uib-tooltip="{{\'_description_kp_bprot_\' | i18n}}" tooltip-is-open="kpBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kp_bprot_">kp bprot</data-i18n><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th st-sort="npncpe" class="editable-header"><div uib-tooltip="{{\'_description_npncpe_\' | i18n}}" tooltip-is-open="npncpeIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_npncpe_">NPNCPE</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="rup_89" class="editable-header"><div uib-tooltip="{{\'_description_rup_89_\' | i18n}}" tooltip-is-open="rup89IsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup89_">rup 89</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="rdp_01"><div uib-tooltip="{{\'_description_rdp_01_\' | i18n}}" tooltip-is-open="rdp01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp01_">rdp 01</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="mp_01"><div uib-tooltip="{{\'_description_mp_01_\' | i18n}}" tooltip-is-open="mp01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp01_">mp 01</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="ndicp" class="editable-header"><div uib-tooltip="{{\'_description_ndicp_\' | i18n}}" tooltip-is-open="ndicpIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndicp_">NDICP</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="adicp" class="editable-header"><div uib-tooltip="{{\'_description_adicp_\' | i18n}}" tooltip-is-open="adicpIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="td_trup"><div uib-tooltip="{{\'_description_td_trup_\' | i18n}}" tooltip-is-open="tdtrupIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdtrup_">tdtrup</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody id="proteinBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'P\')" id="amount{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.cp" e-format-input-value="cp" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'cp\', \'P\')" id="cp{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.rup | formatViewValues: \'rup\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.rdp | formatViewValues: \'rdp\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.mp | formatViewValues: \'mp\'}}</span></td><td style="padding: 3px 3px; min-width: 130px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.rup_dig" e-format-input-value="rup_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rup_dig\', \'P\')" id="rup_dig{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.a_prot | formatViewValues: \'a_prot\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.b_prot" e-format-input-value="b_prot" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'b_prot\', \'P\')" id="b_prot{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.b_prot | formatViewValues: \'b_prot\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.c_prot" e-format-input-value="c_prot" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'c_prot\', \'P\')" id="c_prot{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.c_prot | formatViewValues: \'c_prot\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.kd_b_prot" e-format-input-value="kd_b_prot" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'kd_b_prot\', \'P\')" id="kd_b_prot{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.kd_b_prot | formatViewValues: \'kd_b_prot\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.kp_b_prot | formatViewValues: \'kp_b_prot\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.npncpe" e-format-input-value="npncpe" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'npncpe\', \'P\')" id="npncpe{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.npncpe | formatViewValues: \'npncpe\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.rup_89" e-format-input-value="rup_89" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rup_89\', \'P\')" id="rup_89{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rup_89 | formatViewValues: \'rup_89\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.rdp_01 | formatViewValues: \'rdp_01\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.mp_01 | formatViewValues: \'mp_01\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.ndicp" e-format-input-value="ndicp" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndicp\', \'P\')" id="ndicp{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndicp | formatViewValues: \'ndicp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.adicp" e-format-input-value="adicp" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'adicp\', \'P\')" id="adicp{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.adicp | formatViewValues: \'adicp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_trup | formatViewValues: \'td_trup\'}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="mixfeed.amount" e-format-input-value="amount" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'P\', feed.id)" id="amountMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" editable-number="mixfeed.cp" e-format-input-value="cp" e-format-value-dm="mixfeed.dm" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'cp\', \'P\', feed.id)" id="cpMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cp | formatViewValues: \'cp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.rup | formatViewValues: \'rup\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.rdp | formatViewValues: \'rdp\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.mp | formatViewValues: \'mp\'}}</span></td><td style="padding: 3px 3px; min-width: 130px"><span e-step="any" editable-number="mixfeed.rup_dig" e-format-input-value="rup_dig" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rup_dig\', \'P\', feed.id)" id="rup_digMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rup_dig | formatViewValues: \'rup_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.a_prot | formatViewValues: \'a_prot\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" editable-number="mixfeed.b_prot" e-format-input-value="b_prot" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'b_prot\', \'P\', feed.id)" id="b_protMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.b_prot | formatViewValues: \'b_prot\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" editable-number="mixfeed.c_prot" e-format-input-value="c_prot" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'c_prot\', \'P\', feed.id)" id="c_protMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.c_prot | formatViewValues: \'c_prot\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" editable-number="mixfeed.kd_b_prot" e-format-input-value="kd_b_prot" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'kd_b_prot\', \'P\', feed.id)" id="kd_b_protMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.kd_b_prot | formatViewValues: \'kd_b_prot\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.kp_b_prot | formatViewValues: \'kp_b_prot\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" editable-number="mixfeed.npncpe" e-format-input-value="npncpe" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'npncpe\', \'P\', feed.id)" id="npncpeMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.npncpe | formatViewValues: \'npncpe\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" editable-number="mixfeed.rup_89" e-format-input-value="rup_89" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rup_89\', \'P\', feed.id)" id="rup_89MIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rup_89 | formatViewValues: \'rup_89\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.rdp01 | formatViewValues: \'rdp01\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.mp01 | formatViewValues: \'mp01\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" editable-number="mixfeed.ndicp" e-format-input-value="ndicp" e-format-value-dm="mixfeed.dm" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ndicp\', \'P\', feed.id)" id="ndicpMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndicp | formatViewValues: \'ndicp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" editable-number="mixfeed.adicp" e-format-input-value="adicp" e-format-value-dm="mixfeed.dm" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'adicp\', \'P\', feed.id)" id="adicpMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.adicp | formatViewValues: \'adicp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_trup | formatViewValues: \'td_trup\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="proteinTable" ng-if="!vm.settings.use_percent"><thead><tr class="sortable"><th style="height: 77px" class="editable-header"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="cp" class="editable-header"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="rup"><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="rdp"><div uib-tooltip="{{\'_description_rdp_\' | i18n}}" tooltip-is-open="rdpIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp_">rdp</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="mp"><div uib-tooltip="{{\'_description_mp_\' | i18n}}" tooltip-is-open="mpIsOpen" tooltip-placement="right" tooltip-append-to-body="true" tooltip-class="custBlue right tooltip-largeX" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp_">mp</data-i18n><br><br></div></th><th style="min-width: 130px" st-sort="rup_dig" class="editable-header"><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th st-sort="a_prot"><div uib-tooltip="{{\'_description_a_prot_\' | i18n}}" tooltip-is-open="AProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_a_">A Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="b_prot" class="editable-header"><div uib-tooltip="{{\'_description_b_prot_\' | i18n}}" tooltip-is-open="BProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_b_">B Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="c_prot" class="editable-header"><div uib-tooltip="{{\'_description_c_prot_\' | i18n}}" tooltip-is-open="CProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_c_">C Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="kd_b_prot" class="editable-header"><div uib-tooltip="{{\'_description_kd_bprot_\' | i18n}}" tooltip-is-open="kdBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kd_bprot_">kd bprot</data-i18n><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th st-sort="kp_b_prot"><div uib-tooltip="{{\'_description_kp_bprot_\' | i18n}}" tooltip-is-open="kpBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kp_bprot_">kp bprot</data-i18n><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th st-sort="npncpe" class="editable-header"><div uib-tooltip="{{\'_description_npncpe_\' | i18n}}" tooltip-is-open="npncpeIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_npncpe_">NPNCPE</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="rup_89" class="editable-header"><div uib-tooltip="{{\'_description_rup_89_\' | i18n}}" tooltip-is-open="rup89IsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup89_">rup 89</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="rdp_01"><div uib-tooltip="{{\'_description_rdp_01_\' | i18n}}" tooltip-is-open="rdp01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp01_">rdp 01</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="mp_01"><div uib-tooltip="{{\'_description_mp_01_\' | i18n}}" tooltip-is-open="mp01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp01_">mp 01</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="ndicp" class="editable-header"><div uib-tooltip="{{\'_description_ndicp_\' | i18n}}" tooltip-is-open="ndicpIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndicp_">NDICP</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="adicp" class="editable-header"><div uib-tooltip="{{\'_description_adicp_\' | i18n}}" tooltip-is-open="adicpIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="td_trup"><div uib-tooltip="{{\'_description_td_trup_\' | i18n}}" tooltip-is-open="tdtrupIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdtrup_">tdtrup</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody id="proteinBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'P\')" id="amount{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.cp" e-format-input-value="cp" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'cp\', \'P\')" id="cp{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.rup | formatViewValues: \'rup\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.rdp | formatViewValues: \'rdp\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.mp | formatViewValues: \'mp\'}}</span></td><td style="padding: 3px 3px; min-width: 130px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.rup_dig" e-format-input-value="rup_dig" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rup_dig\', \'P\')" id="rup_dig{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.a_prot | formatViewValues: \'a_prot\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.b_prot" e-format-input-value="b_prot" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'b_prot\', \'P\')" id="b_prot{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.b_prot | formatViewValues: \'b_prot\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.c_prot" e-format-input-value="c_prot" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'c_prot\', \'P\')" id="c_prot{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.c_prot | formatViewValues: \'c_prot\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.kd_b_prot" e-format-input-value="kd_b_prot" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'kd_b_prot\', \'P\')" id="kd_b_prot{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.kd_b_prot | formatViewValues: \'kd_b_prot\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.kp_b_prot | formatViewValues: \'kp_b_prot\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.npncpe" e-format-input-value="npncpe" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'npncpe\', \'P\')" id="npncpe{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.npncpe | formatViewValues: \'npncpe\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.rup_89" e-format-input-value="rup_89" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'rup_89\', \'P\')" id="rup_89{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.rup_89 | formatViewValues: \'rup_89\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.rdp_01 | formatViewValues: \'rdp_01\'}}</span></td><td style="padding: 3px 3px"><span>{{feed.mp_01 | formatViewValues: \'mp_01\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.ndicp" e-format-input-value="ndicp" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'ndicp\', \'P\')" id="ndicp{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.ndicp | formatViewValues: \'ndicp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.adicp" e-format-input-value="adicp" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'adicp\', \'P\')" id="adicp{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.adicp | formatViewValues: \'adicp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span>{{feed.td_trup | formatViewValues: \'td_trup\'}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="mixfeed.amount" e-format-input-value="amount" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'P\', feed.id)" id="amountMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" editable-number="mixfeed.cp" e-format-input-value="cp" e-format-value-dm="mixfeed.dm" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'cp\', \'P\', feed.id)" id="cpMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cp | formatViewValues: \'cp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.rup | formatViewValues: \'rup\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.rdp | formatViewValues: \'rdp\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.mp | formatViewValues: \'mp\'}}</span></td><td style="padding: 3px 3px; min-width: 130px"><span e-step="any" editable-number="mixfeed.rup_dig" e-format-input-value="rup_dig" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rup_dig\', \'P\', feed.id)" id="rup_digMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rup_dig | formatViewValues: \'rup_dig\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.a_prot | formatViewValues: \'a_prot\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" editable-number="mixfeed.b_prot" e-format-input-value="b_prot" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'b_prot\', \'P\', feed.id)" id="b_protMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.b_prot | formatViewValues: \'b_prot\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" editable-number="mixfeed.c_prot" e-format-input-value="c_prot" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'c_prot\', \'P\', feed.id)" id="c_protMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.c_prot | formatViewValues: \'c_prot\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" editable-number="mixfeed.kd_b_prot" e-format-input-value="kd_b_prot" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'kd_b_prot\', \'P\', feed.id)" id="kd_b_protMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.kd_b_prot | formatViewValues: \'kd_b_prot\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.kp_b_prot | formatViewValues: \'kp_b_prot\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" editable-number="mixfeed.npncpe" e-format-input-value="npncpe" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'npncpe\', \'P\', feed.id)" id="npncpeMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.npncpe | formatViewValues: \'npncpe\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" editable-number="mixfeed.rup_89" e-format-input-value="rup_89" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'rup_89\', \'P\', feed.id)" id="rup_89MIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.rup_89 | formatViewValues: \'rup_89\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.rdp01 | formatViewValues: \'rdp01\'}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.mp01 | formatViewValues: \'mp01\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" editable-number="mixfeed.ndicp" e-format-input-value="ndicp" e-format-value-dm="mixfeed.dm" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'ndicp\', \'P\', feed.id)" id="ndicpMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.ndicp | formatViewValues: \'ndicp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="any" editable-number="mixfeed.adicp" e-format-input-value="adicp" e-format-value-dm="mixfeed.dm" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'adicp\', \'P\', feed.id)" id="adicpMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.adicp | formatViewValues: \'adicp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span>{{mixfeed.td_trup | formatViewValues: \'td_trup\'}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/balanceRation/rationsProtein/balanceRation.proteinVemDve.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="proteinTable" ng-if="vm.settings.use_percent"><thead><tr class="sortable"><th style="height: 77px" class="editable-header" st-sort="feed_name"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="cp" class="editable-header"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span></div></th><th st-sort="dve" class="editable-header"><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dve07IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">dve07</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="oeb" class="editable-header"><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oeb07IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">oeb07</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody id="proteinBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'P\')" id="amount{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="0.1" editable-number="feed.cp" e-format-input-value="cp" e-format-value-dm="feed.dm" e-min="0" e-max="100" onbeforesave="vm.updateFeed(feed, $index, $data, \'cp\', \'P\')" id="cp{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.dve" e-format-input-value="dve" e-format-value-dm="feed.dm" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'dve\', \'P\')" id="dve{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.dve | formatViewValues: \'dve\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.oeb" e-format-input-value="oeb" e-format-value-dm="feed.dm" e-min="-1000000" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'oeb\', \'P\')" id="oeb{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="mixfeed.amount" e-format-input-value="amount" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'P\', feed.id)" id="amountMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="0.1" editable-number="mixfeed.cp" e-format-input-value="cp" e-format-value-dm="mixfeed.dm" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="100" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'cp\', \'P\', feed.id)" id="cpMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cp | formatViewValues: \'cp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="any" editable-number="mixfeed.dve" e-format-input-value="dve" e-format-value-dm="mixfeed.dm" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'dve\', \'P\', feed.id)" id="dveMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.dve | formatViewValues: \'dve\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="any" editable-number="mixfeed.oeb" e-format-input-value="oeb" e-format-value-dm="mixfeed.dm" edit-disabled="vm.mixfeed_loading" e-min="-1000000" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'oeb\', \'P\', feed.id)" id="oebMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.oeb | formatViewValues: \'oeb\': mixfeed.dm}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table><table class="table table-bordered-striped" st-table="vm.ration.feeds" st-safe-src="vm.feedsSafe" id="proteinTable" ng-if="!vm.settings.use_percent"><thead><tr class="sortable"><th style="height: 77px" class="editable-header"><div class="fixed-action"><data-i18n i18n="_title_column_action_">Action</data-i18n><br></div><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" class="fixed-feed-name"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="min-width: 120px" st-sort="amount" class="editable-header"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="cp" class="editable-header"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="dve" class="editable-header"><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dve07IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">dve07</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="oeb" class="editable-header"><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oeb07IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">oeb07</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody id="proteinBody"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, feed) in vm.ration.feeds" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 0px; padding-right: 0px"><div class="fixed-action"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(feed)" ng-model="feed.is_selected"> <label for="is_checked{{$index}}" style="padding-left: 20px"></label></span> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.goToFeedHistory(feed.id, feed.feed_locale)" uib-tooltip="{{vm.titleHistory | i18n}}" tooltip-is-open="historyIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.convertToFeed(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleConvert | i18n}}" tooltip-is-open="convertIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-swap"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.unmix(feed, $index)" ng-if="feed.is_mix" uib-tooltip="{{vm.titleUnmix | i18n}}" tooltip-append-to-body="true" tooltip-is-open="unmixIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-arrow-return-left"></i></button><br ng-if="feed.is_mix"><a class="ion-arrow" ng-click="vm.selectTableRow($index, feed.id)" href="" ng-class="feed.is_mix && vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" uib-tooltip="{{vm.titleExpand | i18n}}" tooltip-append-to-body="true" tooltip-is-open="expandIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" ng-hide="!feed.is_mix"></a><div id="loading-animation" ng-if="feed.loading" style="display: inline-block"></div></div><div class="fixed-feed-name" style="min-width: 120px"><span editable-text="feed.feed_name" edit-disabled="vm.feed_loading" e-required="" onbeforesave="vm.updateFeed(feed, $index, $data, \'feed_name\', \'H\')" class="feed-name" style="display: inline-block" id="feed_name{{$index}}H" e-ng-keydown="vm.feedKeyDown($event, $data)" uib-tooltip="{{feed.feed_name}}" tooltip-is-open="H$index" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="feed.amount" e-format-input-value="amount" edit-disabled="vm.feed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'amount\', \'P\')" id="amount{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.cp" e-format-input-value="cp" e-format-value-dm="feed.dm" e-min="0" e-max="10000" onbeforesave="vm.updateFeed(feed, $index, $data, \'cp\', \'P\')" id="cp{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.dve" e-format-input-value="dve" e-format-value-dm="feed.dm" e-min="0" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'dve\', \'P\')" id="dve{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.dve | formatViewValues: \'dve\': feed.dm}}</span></td><td style="padding: 3px 3px"><span edit-disabled="vm.feed_loading || feed.is_mix" e-step="any" editable-number="feed.oeb" e-format-input-value="oeb" e-format-value-dm="feed.dm" e-min="-1000000" e-max="1000000" onbeforesave="vm.updateFeed(feed, $index, $data, \'oeb\', \'P\')" id="oeb{{$index}}P" e-ng-keydown="vm.feedKeyDown($event, $data)">{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, mixfeed) in feed.mixes" ng-show="vm.dataCollapse[indexX]==true" ng-if="feed.is_mix"><th class="rationThBackground"><div class="fixed-action"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addFeedToMix(mixfeed)" ng-if="$index == 0" uib-tooltip="{{vm.titleAddFeedToMix | i18n}}" tooltip-is-open="addIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-plus-round"></i></button> <button type="button" class="btn btn-primary btn-xs" ng-click="vm.removeFeedFromMix(mixfeed, $index)" uib-tooltip="{{vm.titleRemoveFeedFromMix | i18n}}" tooltip-is-open="remove$indexIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" style="margin-top: 5px"><i class="ion-minus-round"></i></button></div><div id="loading-animation" ng-if="mixfeed.loading" style="display: inline-block"></div><div class="fixed-feed-name"><span editable-text="mixfeed.feed_name" edit-disabled="vm.mixfeed_loading" e-required="" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'feed_name\', \'H\')" class="feed-name" id="feed_nameMIX{{$index}}H{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)" uib-tooltip="{{mixfeed.feed_name}}" tooltip-is-open="H$indexM$indexX" tooltip-placement="right" tooltip-class="customBlue right wrap-text" tooltip-popup-delay="500" tooltip-enable="{{mixfeed.feed_name.length > 30 ? true : false}}"><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="mixfeed.feed_category == \'DF\' ? \'dry-forage\' : (mixfeed.feed_category == \'WF\' ? \'wet-forage\' : (mixfeed.feed_category == \'FA\' ? \'fat\' : (mixfeed.feed_category == \'MIX\' ? \'mix\' : (mixfeed.feed_category == \'C\' ? \'corn\' : (mixfeed.feed_category == \'TRI\' ? \'triglyceride\' : (mixfeed.feed_category == \'Forage\' ? \'forage\' : (mixfeed.feed_category == \'Concentrate\' ? \'concentrate\' : (mixfeed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{mixfeed.feed_name}}</span></div></th><td style="min-width: 120px; padding: 3px 3px"><span e-step="0.01" editable-number="mixfeed.amount" e-format-input-value="amount" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'amount\', \'P\', feed.id)" id="amountMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.amount | formatViewValues: \'amount\'}}</span></td><td style="padding: 3px 3px"><span e-step="any" editable-number="mixfeed.cp" e-format-input-value="cp" e-format-value-dm="mixfeed.dm" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="10000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'cp\', \'P\', feed.id)" id="cpMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.cp | formatViewValues: \'cp\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="any" editable-number="mixfeed.dve" e-format-input-value="dve" e-format-value-dm="mixfeed.dm" edit-disabled="vm.mixfeed_loading" e-min="0" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'dve\', \'P\', feed.id)" id="dveMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.dve | formatViewValues: \'dve\': mixfeed.dm}}</span></td><td style="padding: 3px 3px"><span e-step="any" editable-number="mixfeed.oeb" e-format-input-value="oeb" e-format-value-dm="mixfeed.dm" edit-disabled="vm.mixfeed_loading" e-min="-1000000" e-max="1000000" onbeforesave="vm.updateFeedMix(mixfeed, $index, $data, \'oeb\', \'P\', feed.id)" id="oebMIX{{$index}}P{{indexX}}" e-ng-keydown="vm.mixKeyDown($event, $data)">{{mixfeed.oeb | formatViewValues: \'oeb\': mixfeed.dm}}</span></td></tr><tr ng-repeat-end="" ng-if="feed.is_mix"></tr><tr ng-repeat-end=""></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/myManualRations/tables/fodjan.table.html','<table class="table manually-added-table" ng-if="!vm.loadingFodjanRations"><thead><tr class="sortable"><th class="shorten-width-config" style="min-width: 90px;"><data-i18n i18n="_title_column_action_">action</data-i18n></th><th><data-i18n i18n="_rations_ration_name_">ration name</data-i18n></th><th style="width: 10%">%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></th><th style="width: 10%"><data-i18n i18n="_feeds_tab_cost_">Cost</data-i18n></th><th style="width: 20%"><data-i18n i18n="_rations_date_">create date</data-i18n></th><th style="width: 20%"><data-i18n i18n="_title_last_modified_date_">create date</data-i18n></th><th style="width: 20%"><data-i18n i18n="_title_farm_name_">Farm name</data-i18n></th><th style="width: 20%"><data-i18n i18n="_title_herd_">Herd</data-i18n></th><th></th></tr></thead><tbody><tr ng-repeat-start="ration in vm.fodjanRations"><td><button class="btn btn-xs btn-primary" ng-click="vm.goToHistory(ration.id)"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" uib-tooltip="{{\'_tips_edit_ration_\' | i18n}}" ng-click="vm.editRation(ration.id)" tooltip-is-open="tooltipIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="fa fa-pencil"></i></button> <a href="" ng-click="vm.selectTableRow(vm.fodjanRations, ration)" ng-class="ration.expanded ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'"></a></td><td class="shorten-long-text" uib-tooltip="{{ration.ration_name}}" tooltip-enable="{{ration.ration_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{ration.ration_name}}</td><td>{{ration.dm | formatViewValues: \'percentage\'}}</td><td>{{ration.cost_dm | formatViewValues: \'cost_dm\'}}</td><td>{{ration.create_date | date: vm.date_format}}</td><td>{{ration.last_modified_date | date: vm.date_format}}</td><td>{{ration.farm_name || (\'_m_f_calendar_not_available_label_\' | i18n)}}</td><td><a href="#" editable-select="ration.selected_herd" onshow="vm.onShow(ration.selected_herd)" onbeforesave="vm.setHerd(ration, $data)" buttons="no" e-style="width: 150px" e-ng-options="herd as herd.Name for herd in vm.herds">{{ration.selected_herd.Name || (\'_label_choose_herd_\' | i18n)}}</a></td><td><button type="button" class="btn btn-danger btn-xs" ng-click="vm.deleteThirdPartyRation(vm.fodjanRations, ration)"><data-i18n i18n="_btn_delete_">delete</data-i18n></button></td></tr><tr ng-show="ration.expanded" class="feeds-row header"><td><data-i18n i18n="_feeds_name_">Feed name</data-i18n></td><td><data-i18n i18n="_feeds_type_">Feed type</data-i18n></td><td><data-i18n i18n="_feeds_dm_">DM</data-i18n><br>%</td><td><data-i18n i18n="_feeds_amount_">Amount DM</data-i18n><br>{{vm.weight}}</td><td><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n><br>{{vm.weight}}</td><td><data-i18n i18n="_feeds_cost_dm_">Cost DM</data-i18n><br>{{vm.currency}}/{{vm.weight}}<span style="margin-left: 3px"><data-i18n i18n="_feeds_dm_">DM</data-i18n></span></td><td><data-i18n i18n="_feeds_cost_as_fed_">Cost as fed</data-i18n><br>{{vm.currency}}/{{vm.weight}}<span style="margin-left: 3px; text-transform: lowercase"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n></span></td><td></td><td></td></tr><tr ng-repeat-start="feed in ration.ration_feeds" ng-show="ration.expanded" class="feeds-row header"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.feed_type.translated}}</td><td>{{feed.dm | formatViewValues: \'percentage\'}}</td><td>{{feed.amount_dm | formatViewValues: \'amount\'}}</td><td>{{feed.amount_as_fed | formatViewValues: \'as_fed\'}}</td><td>{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</td><td>{{feed.cost_as_fed | formatViewValues: \'cost_dm\'}}</td><td></td><td></td></tr><tr ng-repeat-end=""></tr><tr ng-repeat-end=""></tr></tbody><tfoot ng-if="vm.loadingFodjanRationsTable && !vm.loading"><tr><td colspan="9" style="text-align: center"><loading-spinner></loading-spinner></td></tr></tfoot><tfoot ng-if="!vm.loadingFodjanRationsTable && !vm.loading && vm.totalFodjanRations > vm.fodjanRations.length"><tr><td colspan="9" style="text-align: center"><button class="btn btn-primary" ng-click="vm.fodjanRationsPaginationChanged()"><data-i18n i18n="_m_f_title_load_more_">Load more</data-i18n></button></td></tr></tfoot></table><loading-spinner-large ng-if="vm.loadingFodjanRations"></loading-spinner-large>');
$templateCache.put('app/pages/rations/myManualRations/tables/mmmooogle.table.html','<table class="table manually-added-table" ng-if="vm.selectedHerd"><thead><tr class="sortable"><th class="shorten-width-config" style="min-width: 90px;"><data-i18n i18n="_title_column_action_">action</data-i18n></th><th><data-i18n i18n="_rations_ration_name_">ration name</data-i18n></th><th style="width: 10%">%&nbsp;<data-i18n i18n="_feeds_dm_">DM</data-i18n></th><th style="width: 10%;"><data-i18n i18n="_feeds_cost_per_cow_">Cost per cow</data-i18n>({{vm.currency}})</th><th style="width: 10%"><data-i18n i18n="_rations_date_">create date</data-i18n></th><th style="width: 25%" colspan="2"><data-i18n i18n="_title_last_modified_date_">create date</data-i18n></th><th></th></tr></thead><tbody><tr ng-repeat-start="ration in vm.manualRations"><td><button class="btn btn-xs btn-primary" ng-click="vm.goToHistory(ration.id)"><i class="ion-clock"></i></button> <button type="button" class="btn btn-primary btn-xs" uib-tooltip="{{\'_tips_edit_ration_\' | i18n}}" ng-click="vm.editRation(ration.id)" tooltip-is-open="tooltipIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="fa fa-pencil"></i></button> <a href="" ng-click="vm.selectTableRow(vm.manualRations, ration)" ng-class="ration.expanded ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'"></a></td><td class="shorten-long-text" uib-tooltip="{{ration.ration_name}}" tooltip-enable="{{ration.ration_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{ration.ration_name}}</td><td>{{ration.dm | formatViewValues: \'percentage\'}}</td><td>{{ration.cost_dm | formatViewValues: \'cost_dm\'}}</td><td>{{ration.create_date | date: vm.date_format}}</td><td>{{ration.last_modified_date | date: vm.date_format}}</td><td></td><td><button type="button" class="btn btn-danger btn-xs" ng-click="vm.deleteRation(vm.manualRations, ration)"><data-i18n i18n="_btn_delete_">delete</data-i18n></button></td></tr><tr ng-show="ration.expanded" class="feeds-row header"><td><data-i18n i18n="_feeds_name_">Feed name</data-i18n></td><td><data-i18n i18n="_feeds_type_">Feed type</data-i18n></td><td><data-i18n i18n="_feeds_dm_">DM</data-i18n><br>%</td><td><data-i18n i18n="_feeds_amount_">Amount DM</data-i18n><br>{{vm.weight}}</td><td><data-i18n i18n="_feeds_as_fed_">As fed</data-i18n><br>{{vm.weight}}</td><td><data-i18n i18n="_feeds_cost_dm_">Cost DM</data-i18n><br>{{vm.currency}}/{{vm.weight}}<span style="margin-left: 3px"><data-i18n i18n="_feeds_dm_">DM</data-i18n></span></td><td><data-i18n i18n="_feeds_cost_as_fed_">Cost as fed</data-i18n><br>{{vm.currency}}/{{vm.weight}}<span style="margin-left: 3px; text-transform: lowercase"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n></span></td><td></td></tr><tr ng-repeat-start="feed in ration.ration_feeds" ng-show="ration.expanded" class="feeds-row header"><td class="shorten-long-text" uib-tooltip="{{feed.feed_name}}" tooltip-enable="{{feed.feed_name.length > 30 ? true : false}}" tooltip-placement="right" tooltip-class="customBlue right wrap-text">{{feed.feed_name}}</td><td>{{feed.feed_type.translated}}</td><td>{{feed.dm | formatViewValues: \'percentage\'}}</td><td>{{feed.amount_dm | formatViewValues: \'amount\'}}</td><td>{{feed.amount_as_fed | formatViewValues: \'as_fed\'}}</td><td>{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</td><td>{{feed.cost_as_fed | formatViewValues: \'cost_dm\'}}</td><td></td></tr><tr ng-repeat-end=""></tr><tr ng-repeat-end=""></tr></tbody><tfoot ng-if="vm.loadingManualRationsTable && !vm.loading"><tr><td colspan="10" style="text-align: center"><loading-spinner></loading-spinner></td></tr></tfoot><tfoot ng-if="!vm.loadingManualRationsTable && !vm.loading && vm.totalManualRations > vm.manualRations.length"><tr><td colspan="10" style="text-align: center"><button class="btn btn-primary" ng-click="vm.manualRationsPaginationChanged()"><data-i18n i18n="_m_f_title_load_more_">Load more</data-i18n></button></td></tr></tfoot></table><div ng-if="!vm.selectedHerd && vm.selectedTeam && !vm.loading" align="center" style="margin-top: 20px;"><div><h3><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></h3></div></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparisonFiber/rationComparison.fiber.US.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.rations" st-safe-src="vm.rationsSafe" id="fiberTable"><thead id="fiberHeader"><tr class="sortable"><th style="height: 76px" st-sort="ration_name"><data-i18n i18n="_rations_ration_name_"></data-i18n></th><th style="min-width: 120px" st-sort="supply.amount_dm"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.ndf"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.ef_ndf_as_ndf"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.lignin"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.for_ndf"><div uib-tooltip="{{\'_description_for_ndf_\' | i18n}}" tooltip-is-open="forNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_for_ndf_">forNDF</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th style="min-width: 130px" st-sort="supply.ndf_digest"><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.ef_ndf_as_dm"><div uib-tooltip="{{\'_description_ef_ndf_as_dm_\' | i18n}}" tooltip-is-open="efNdfAsDmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.adf"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.rd_ndf"><div uib-tooltip="{{\'_description_rdndf_\' | i18n}}" tooltip-is-open="rdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdndf_">RDNDF</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.td_ndf"><div uib-tooltip="{{\'_description_td_ndf_\' | i18n}}" tooltip-is-open="tdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdndf_">tdNDF</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th></tr></thead><tbody id="fiberBody" ng-if="!vm.loadingTable"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, ration) in vm.rations" ng-switch="" on="vm.dataCollapse[$index]" ng-class="ration.difference.is_mix? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 7px; padding-right: 0px; text-align: left"><div class="ration-name" style="margin-left: 10px !important; padding-bottom: 10px; margin-top: 1px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(ration, $event)" ng-model="ration.is_selected" style="margin-right: 5px" ng-if="!vm.comparisonActive"> <label for="is_checked{{$index}}"></label> {{ration.ration_name}}</span> <a class="ion-arrow" ng-click="vm.selectTableRow($index, ration.id)" href="" ng-class="vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" style="position: absolute; right: 0px; margin-top: 3px; margin-right: 6px" uib-tooltip="{{\'_expand_ration_\' | i18n}}" tooltip-is-open="Ration" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></div></th><td style="min-width: 120px">{{ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{ration.supply.ndf | formatViewValuesPerDay: \'ndf\'}}</td><td>{{ration.supply.ef_ndf_as_ndf | formatViewValuesPerDay: \'ef_ndf_as_ndf\'}}</td><td>{{ration.supply.lignin | formatViewValuesPerDay: \'lignin\'}}</td><td>{{ration.supply.for_ndf | formatViewValuesPerDay: \'for_ndf\'}}</td><td style="min-width: 130px">{{ration.supply.ndf_digest | formatViewValuesPerDay: \'ndf_digest\'}}</td><td>{{ration.supply.ef_ndf_as_dm | formatViewValuesPerDay: \'ef_ndf_as_dm\'}}</td><td>{{ration.supply.adf | formatViewValuesPerDay: \'adf\'}}</td><td>{{ration.supply.rd_ndf | formatViewValuesPerDay: \'rd_ndf\'}}</td><td>{{ration.supply.td_ndf | formatViewValuesPerDay: \'td_ndf\'}}</td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds && vm.settings.use_percent" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds && !vm.settings.use_percent" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, feed) in ration.feeds" ng-if="ration.feeds" ng-show="vm.dataCollapse[indexX]==true"><th class="rationThBackground" style="text-align: left"><div class="ration-name"><span><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px">{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td>{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td>{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</td><td>{{feed.for_ndf | formatViewValues: \'for_ndf\'}}</td><td style="min-width: 130px">{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</td><td>{{feed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</td><td>{{feed.adf | formatViewValues: \'adf\': feed.dm}}</td><td>{{feed.rd_ndf | formatViewValues: \'rd_ndf\'}}</td><td>{{feed.td_ndf | formatViewValues: \'td_ndf\'}}</td></tr><tr ng-repeat-end="" ng-if="ration.feeds"></tr><tr ng-if="vm.loadingFeeds && vm.dataCollapse[indexX]==true" class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable"><tr class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparisonFiber/rationComparison.fiber.VemDve.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.rations" st-safe-src="vm.rationsSafe" id="fiberTable"><thead id="fiberHeader"><tr class="sortable"><th style="height: 76px" st-sort="ration_name"><data-i18n i18n="_rations_ration_name_"></data-i18n></th><th style="min-width: 120px" st-sort="supply.amount_dm"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.rc"><div uib-tooltip="{{\'_description_rcel_\' | i18n}}" tooltip-is-open="rcNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.ndf"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.ef_ndf_as_ndf"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.lignin"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.for_ndf"><div uib-tooltip="{{\'_description_for_ndf_\' | i18n}}" tooltip-is-open="forNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_for_ndf_">forNDF</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th style="min-width: 130px" st-sort="supply.ndf_digest"><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.ef_ndf_as_dm"><div uib-tooltip="{{\'_description_ef_ndf_as_dm_\' | i18n}}" tooltip-is-open="efNdfAsDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.adf"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th></tr></thead><tbody id="fiberBody" ng-if="!vm.loadingTable"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, ration) in vm.rations" ng-switch="" on="vm.dataCollapse[$index]" ng-class="ration.difference.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 7px; padding-right: 0px; text-align: left"><div class="ration-name" style="margin-left: 10px !important; padding-bottom: 10px; margin-top: 1px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(ration, $event)" ng-model="ration.is_selected" style="margin-right: 5px" ng-if="!vm.comparisonActive"> <label for="is_checked{{$index}}"></label> {{ration.ration_name}}</span> <a class="ion-arrow" ng-click="vm.selectTableRow($index, ration.id)" href="" ng-class="vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" style="position: absolute; right: 0px; margin-top: 3px; margin-right: 6px" uib-tooltip="{{\'_expand_ration_\' | i18n}}" tooltip-is-open="Ration" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></div></th><td style="min-width: 120px">{{ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{ration.supply.rc | formatViewValuesPerDay: \'rc\'}}</td><td>{{ration.supply.ndf | formatViewValuesPerDay: \'ndf\'}}</td><td>{{ration.supply.ef_ndf_as_ndf | formatViewValuesPerDay: \'ef_ndf_as_ndf\'}}</td><td>{{ration.supply.lignin | formatViewValuesPerDay: \'lignin\'}}</td><td>{{ration.supply.for_ndf | formatViewValuesPerDay: \'for_ndf\'}}</td><td style="min-width: 130px">{{ration.supply.ndf_digest | formatViewValuesPerDay: \'ndf_digest\'}}</td><td>{{ration.supply.ef_ndf_as_dm | formatViewValuesPerDay: \'ef_ndf_as_dm\'}}</td><td>{{ration.supply.adf | formatViewValuesPerDay: \'adf\'}}</td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds && vm.settings.use_percent" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds && !vm.settings.use_percent" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, feed) in ration.feeds" ng-if="ration.feeds" ng-show="vm.dataCollapse[indexX]==true"><th class="rationThBackground" style="text-align: left"><div class="ration-name"><span><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px">{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.rc | formatViewValues: \'rc\': feed.dm}}</td><td>{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td>{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td>{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</td><td>{{feed.for_ndf | formatViewValues: \'for_ndf\'}}</td><td style="min-width: 130px">{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</td><td>{{feed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</td><td>{{feed.adf | formatViewValues: \'adf\': feed.dm}}</td></tr><tr ng-repeat-end="" ng-if="ration.feeds"></tr><tr ng-if="vm.loadingFeeds && vm.dataCollapse[indexX]==true" class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable"><tr class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparisonCarb/rationComparison.carbohydrate.US.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" id="carbTable" st-table="vm.rations" st-safe-src="vm.rationsSafe"><thead id="carbHeader"><tr class="sortable"><th style="height: 77px" st-safe="ration_name" st-sort="ration_name"><data-i18n i18n="_rations_ration_name_"></data-i18n></th><th style="min-width: 120px" st-sort="supply.amount_dm"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.nfc"><div uib-tooltip="{{\'_description_nfc_\' | i18n}}" tooltip-is-open="nfcIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_">NFC</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th style="min-width: 120px" st-sort="supply.nfc_dig"><div uib-tooltip="{{\'_description_nfc_dig_\' | i18n}}" tooltip-is-open="nfcDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_digestibility_">NFC dig</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.starch"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.rd_starch"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.sugar"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.in_fa"><div uib-tooltip="{{\'_description_infa_\' | i18n}}" tooltip-is-open="infaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_infa_">infa</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th style="min-width: 140px" st-sort="supply.sol_fiber"><div uib-tooltip="{{\'_description_sol_fiber_\' | i18n}}" tooltip-is-open="solFiberIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.rd_sol_fiber"><div uib-tooltip="{{\'_description_rd_sol_fiber_\' | i18n}}" tooltip-is-open="rdSolFiberIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdsolf_">RDSolF</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.rdom"><div uib-tooltip="{{\'_description_rdom_\' | i18n}}" tooltip-is-open="rdomIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdom_">rdom</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.td_nfc"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th></tr></thead><tbody id="carbBody" ng-if="!vm.loadingTable"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, ration) in vm.rations" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 7px; padding-right: 0px; text-align: left"><div class="ration-name" style="margin-left: 10px !important; padding-bottom: 10px; margin-top: 1px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(ration, $event)" ng-model="ration.is_selected" style="margin-right: 5px" ng-if="!vm.comparisonActive"> <label for="is_checked{{$index}}" style="padding-left: 20px; margin-right: 1px"></label> {{ration.ration_name}}</span> <a class="ion-arrow" ng-click="vm.selectTableRow($index, ration.id)" href="" ng-class="vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" style="position: absolute; right: 0px; margin-top: 3px; margin-right: 6px" uib-tooltip="{{\'_expand_ration_\' | i18n}}" tooltip-is-open="Ration" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></div></th><td style="min-width: 120px">{{ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{ration.supply.nfc | formatViewValuesPerDay: \'nfc\'}}</td><td style="min-width: 120px">{{ration.supply.nfc_dig | formatViewValuesPerDay: \'nfc_dig\'}}</td><td>{{ration.supply.starch | formatViewValuesPerDay: \'starch\'}}</td><td>{{ration.supply.rd_starch | formatViewValuesPerDay: \'rd_starch\'}}</td><td>{{ration.supply.sugar | formatViewValuesPerDay: \'sugar\'}}</td><td>{{ration.supply.in_fa | formatViewValuesPerDay: \'in_fa\'}}</td><td style="min-width: 140px">{{ration.supply.sol_fiber | formatViewValuesPerDay: \'sol_fiber\'}}</td><td>{{ration.supply.rd_sol_fiber | formatViewValuesPerDay: \'rd_sol_fiber\'}}</td><td>{{ration.supply.rdom | formatViewValuesPerDay: \'rdom\'}}</td><td>{{ration.supply.td_nfc | formatViewValuesPerDay: \'td_nfc\'}}</td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds && vm.settings.use_percent" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_nfc_">NFC</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds && !vm.settings.use_percent" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_nfc_">NFC</data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, feed) in ration.feeds" ng-if="ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationThBackground" style="text-align: left"><div class="ration-name"><span><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px">{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.nfc | formatViewValues: \'nfc\'}}</td><td style="min-width: 120px">{{feed.nfc_dig | formatViewValues: \'nfc_dig\'}}</td><td>{{feed.starch | formatViewValues: \'starch\': feed.dm}}</td><td>{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</td><td>{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</td><td>{{feed.in_fa | formatViewValues: \'in_fa\': feed.dm}}</td><td style="min-width: 140px">{{feed.sol_fiber | formatViewValues: \'sol_fiber\'}}</td><td>{{feed.rd_sol_fiber | formatViewValues: \'rd_sol_fiber\'}}</td><td>{{feed.rdom | formatViewValues: \'rdom\'}}</td><td>{{feed.td_nfc | formatViewValues: \'td_nfc\'}}</td></tr><tr ng-repeat-end="" ng-if="ration.feeds"></tr><tr ng-if="vm.loadingFeeds && vm.dataCollapse[indexX]==true" class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable"><tr class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparisonCarb/rationComparison.carbohydrate.VemDve.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" id="carbTable" st-table="vm.rations" st-safe-src="vm.rationsSafe"><thead id="carbHeader"><tr class="sortable"><th style="height: 77px" st-safe="ration_name" st-sort="ration_name"><data-i18n i18n="_rations_ration_name_"></data-i18n></th><th style="min-width: 120px" st-sort="supply.amount_dm"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.rus"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.starch"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.rd_starch"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.sugar"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.td_nfc"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th></tr></thead><tbody id="carbBody" ng-if="!vm.loadingTable"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, ration) in vm.rations" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 7px; padding-right: 0px; text-align: left"><div class="ration-name" style="margin-left: 10px !important; padding-bottom: 10px; margin-top: 1px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(ration, $event)" ng-model="ration.is_selected" style="margin-right: 5px" ng-if="!vm.comparisonActive"> <label for="is_checked{{$index}}"></label> {{ration.ration_name}}</span> <a class="ion-arrow" ng-click="vm.selectTableRow($index, ration.id)" href="" ng-class="vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" style="position: absolute; right: 0px; margin-top: 3px; margin-right: 6px" uib-tooltip="{{\'_expand_ration_\' | i18n}}" tooltip-is-open="Ration" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></div></th><td style="min-width: 120px">{{ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{ration.supply.rus | formatViewValuesPerDay: \'rus\'}}</td><td>{{ration.supply.starch | formatViewValuesPerDay: \'starch\'}}</td><td>{{ration.supply.rd_starch | formatViewValuesPerDay: \'rd_starch\'}}</td><td>{{ration.supply.sugar | formatViewValuesPerDay: \'sugar\'}}</td><td>{{ration.supply.td_nfc | formatViewValuesPerDay: \'td_nfc\'}}</td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds && vm.settings.use_percent" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds && !vm.settings.use_percent" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, feed) in ration.feeds" ng-if="ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationThBackground" style="text-align: left"><div class="ration-name"><span><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px">{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.rus | formatViewValues: \'rus\': feed.dm}}</td><td>{{feed.starch | formatViewValues: \'starch\': feed.dm}}</td><td>{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</td><td>{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</td><td>{{feed.td_nfc | formatViewValues: \'td_nfc\'}}</td></tr><tr ng-repeat-end="" ng-if="ration.feeds"></tr><tr ng-if="vm.loadingFeeds && vm.dataCollapse[indexX]==true" class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable"><tr class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparisonEnergy/rationComparison.energy.US.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.rations" st-safe-src="vm.rationsSafe" id="energyTable"><thead id="energyHeader"><tr class="sortable"><th style="height: 77px" st-sort="ration_name"><data-i18n i18n="_rations_ration_name_"></data-i18n></th><th style="min-width: 120px" st-sort="supply.amount_dm"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.nel"><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><br>{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.me"><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me_">ME</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="supply.nem"><div uib-tooltip="{{\'_description_nem_\' | i18n}}" tooltip-is-open="nemIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_rations_nem_">nem</data-i18n><br>{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.neg"><div uib-tooltip="{{\'_description_neg_\' | i18n}}" tooltip-is-open="negIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_rations_neg_">neg</data-i18n><br>{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th style="min-width: 110px" st-sort="supply.disc_fac"><div uib-tooltip="{{\'_description_disc_fac_\' | i18n}}" tooltip-is-open="discFacIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_disc_fac_">Disc. Fac.</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.nel_89"><div uib-tooltip="{{\'_description_nel_89_\' | i18n}}" tooltip-is-open="nel89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel89_">NEL 89</data-i18n><br>{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.me_89"><div uib-tooltip="{{\'_description_me_89_\' | i18n}}" tooltip-is-open="me89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me89_">ME 89</data-i18n><br>{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.nel_01"><div uib-tooltip="{{\'_description_nel_01_\' | i18n}}" tooltip-is-open="nel01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel01_">nel 01</data-i18n><br>{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.me_01"><div uib-tooltip="{{\'_description_me_01_\' | i18n}}" tooltip-is-open="me01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me01_">me 01</data-i18n><br>{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.dep"><div uib-tooltip="{{\'_description_dep_\' | i18n}}" tooltip-is-open="depIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dep_">DEp</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="supply.de1x"><div uib-tooltip="{{\'_description_de1x_\' | i18n}}" tooltip-is-open="de1xIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_de1x_">DE1X</data-i18n><br>{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.mftdn"><div uib-tooltip="{{\'_description_mftdn_\' | i18n}}" tooltip-is-open="mftdnIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mftdn_">MF-TDN</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.tdn1x"><div uib-tooltip="{{\'_description_tdn1x_\' | i18n}}" tooltip-is-open="tdn1xIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdn1x_">TDN1X</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th></tr></thead><tbody id="energyBody" ng-if="!vm.loadingTable"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, ration) in vm.rations" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 7px; padding-right: 0px; text-align: left"><div class="ration-name" style="margin-left: 10px !important; padding-bottom: 10px; margin-top: 1px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(ration, $event)" ng-model="ration.is_selected" style="margin-right: 5px" ng-if="!vm.comparisonActive"> <label for="is_checked{{$index}}" style="padding-left: 20px; margin-right: 1px"></label> {{ration.ration_name}}</span> <a class="ion-arrow" ng-click="vm.selectTableRow($index, ration.id)" href="" ng-class="vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" style="position: absolute; right: 0px; margin-top: 3px; margin-right: 6px" uib-tooltip="{{\'_expand_ration_\' | i18n}}" tooltip-is-open="Ration" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></div></th><td style="min-width: 120px">{{ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{ration.supply.nel | formatViewValuesPerDay: \'nel\'}}</td><td>{{ration.supply.me | formatViewValuesPerDay: \'me\'}}</td><td>{{ration.supply.nem | formatViewValuesPerDay: \'nem\'}}</td><td>{{ration.supply.neg | formatViewValuesPerDay: \'neg\'}}</td><td style="min-width: 110px">{{ration.supply.disc_fac | formatViewValuesPerDay: \'disc_fac\'}}</td><td>{{ration.supply.nel_89 | formatViewValuesPerDay: \'nel_89\'}}</td><td>{{ration.supply.me_89 | formatViewValuesPerDay: \'me_89\'}}</td><td>{{ration.supply.nel_01 | formatViewValuesPerDay: \'nel_01\'}}</td><td>{{ration.supply.me_01 | formatViewValuesPerDay: \'me_01\'}}</td><td>{{ration.supply.dep | formatViewValuesPerDay: \'dep\'}}</td><td>{{ration.supply.de1x | formatViewValuesPerDay: \'de1x\'}}</td><td>{{ration.supply.mftdn | formatViewValuesPerDay: \'mftdn\'}}</td><td>{{ration.supply.tdn1x | formatViewValuesPerDay: \'tdn1x\'}}</td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td ng-show="vm.ration.group.animal_type.type!=\'heifer\'">{{vm.energy}}/{{vm.weight}}</td><td>{{vm.energy}}/{{vm.weight}}</td><td>{{vm.energy}}/{{vm.weight}}</td><td>{{vm.energy}}/{{vm.weight}}</td><td>%</td><td ng-show="vm.ration.group.animal_type.type==\'heifer\'">{{vm.energy}}/{{vm.weight}}</td><td ng-show="vm.ration.group.animal_type.type==\'heifer\'">{{vm.energy}}/{{vm.weight}}</td><td ng-show="vm.ration.group.animal_type.type!=\'heifer\'">{{vm.energy}}/{{vm.weight}}</td><td>{{vm.energy}}/{{vm.weight}}</td><td ng-show="vm.ration.group.animal_type.type!=\'heifer\'">{{vm.energy}}/{{vm.weight}}</td><td>{{vm.energy}}/{{vm.weight}}</td><td>{{vm.energy}}/{{vm.weight}}</td><td>{{vm.energy}}/{{vm.weight}}</td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, feed) in ration.feeds" ng-if="ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationThBackground" style="text-align: left"><div class="ration-name"><span><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px">{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.nel | formatViewValues: \'nel\'}}</td><td>{{feed.me | formatViewValues: \'me\'}}</td><td>{{feed.nem | formatViewValues: \'nem\'}}</td><td>{{feed.neg | formatViewValues: \'neg\'}}</td><td style="min-width: 110px">{{feed.disc_fac | formatViewValues: \'disc_fac\'}}</td><td>{{feed.nel_89 | formatViewValues: \'nel_89\'}}</td><td>{{feed.me_89 | formatViewValues: \'me_89\'}}</td><td>{{feed.nel_01 | formatViewValues: \'nel_01\'}}</td><td>{{feed.me_01 | formatViewValues: \'me_01\'}}</td><td>{{feed.dep | formatViewValues: \'dep\'}}</td><td>{{feed.de1x | formatViewValues: \'de1x\'}}</td><td>{{feed.mftdn | formatViewValues: \'mftdn\'}}</td><td>{{feed.tdn1x | formatViewValues: \'tdn1x\'}}</td></tr><tr ng-repeat-end="" ng-if="ration.feeds"></tr><tr ng-if="vm.loadingFeeds && vm.dataCollapse[indexX]==true" class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable"><tr class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparisonEnergy/rationComparison.energy.VemDve.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.rations" st-safe-src="vm.rationsSafe" id="energyTable"><thead id="energyHeader"><tr class="sortable"><th style="height: 77px" st-sort="ration_name"><data-i18n i18n="_rations_ration_name_"></data-i18n></th><th style="min-width: 120px" st-sort="supply.amount_dm"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.vem"><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">vem</data-i18n><br><data-i18n i18n="_feeds_vem_unit_">vem</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.fos"><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">fos</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th></tr></thead><tbody id="energyBody" ng-if="!vm.loadingTable"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, ration) in vm.rations" ng-switch="" on="vm.dataCollapse[$index]" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 7px; padding-right: 0px; text-align: left"><div class="ration-name" style="margin-left: 10px !important; padding-bottom: 10px; margin-top: 1px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(ration, $event)" ng-model="ration.is_selected" style="margin-right: 5px" ng-if="!vm.comparisonActive"> <label for="is_checked{{$index}}"></label> {{ration.ration_name}}</span> <a class="ion-arrow" ng-click="vm.selectTableRow($index, ration.id)" href="" ng-class="vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" style="position: absolute; right: 0px; margin-top: 3px; margin-right: 6px" uib-tooltip="{{\'_expand_ration_\' | i18n}}" tooltip-is-open="Ration" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></div></th><td style="min-width: 120px">{{ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{ration.supply.vem | formatViewValuesPerDay: \'vem\'}}</td><td>{{ration.supply.fos | formatViewValuesPerDay: \'fos\'}}</td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td><data-i18n i18n="_feeds_vem_unit_">vem</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, feed) in ration.feeds" ng-if="ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationThBackground" style="text-align: left"><div class="ration-name"><span><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px">{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.vem | formatViewValues: \'vem\'}}</td><td>{{feed.fos | formatViewValues: \'fos\': feed.dm}}</td></tr><tr ng-repeat-end="" ng-if="ration.feeds"></tr><tr ng-if="vm.loadingFeeds && vm.dataCollapse[indexX]==true" class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable"><tr class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparisonHome/rationComparison.home.US.html','<div ng-if="!vm.loadingTabs" class="container fixed ration-comparison-table" style="width: auto"><table class="table table-bordered-striped" st-table="vm.rations" st-safe-src="vm.rationsSafe" id="homeTable"><thead id="homeHeader"><tr class="sortable"><th style="height: 76px" st-sort="ration_name"><div class="fixed-feed-name"><data-i18n i18n="_rations_ration_name_"></data-i18n></div></th><th ng-if="!vm.selectedHerd" style="min-width: 175px" st-sort="herd_name"><data-i18n i18n="_groups_herd_name_">herd name</data-i18n></th><th ng-if="!vm.selectedGroup" style="min-width: 175px" st-sort="group_name"><data-i18n i18n="_groups_group_name_">group name</data-i18n><br><br></th><th style="min-width: 130px" st-sort="create_date"><data-i18n i18n="_rations_date_">create date</data-i18n><br><br></th><th style="min-width: 120px" st-sort="supply.amount_dm"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th style="min-width: 125px" st-sort="supply.as_fed"><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.dm"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</div></th><th style="min-width: 165px" st-sort="supply.group_as_fed"><div uib-tooltip="{{\'_description_group_as_fed_\' | i18n}}" tooltip-is-open="groupAsFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_group_as_fed_">group as fed</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.ef_ndf_as_dm_"><div uib-tooltip="{{\'_description_ef_ndf_as_dm_\' | i18n}}" tooltip-is-open="efNdfAsDmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.nel"><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><br>{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.me"><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="750"><data-i18n i18n="_feeds_me_">ME</data-i18n><br>{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.nem"><div uib-tooltip="{{\'_description_nem_\' | i18n}}" tooltip-is-open="nemIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="750"><data-i18n i18n="_rations_nem_">nem</data-i18n><br>{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.neg"><div uib-tooltip="{{\'_description_neg_\' | i18n}}" tooltip-is-open="negIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="750"><data-i18n i18n="_rations_neg_">neg</data-i18n><br>{{vm.energy}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.ndf"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.cp"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.rup"><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-placement="right" tooltip-append-to-body="true" tooltip-class="custBlue right tooltip-largeX" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.mp"><div uib-tooltip="{{\'_description_mp_\' | i18n}}" tooltip-is-open="mpIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp_">mp</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th style="min-width: 170px" st-sort="supply.rup_dig"><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.fa"><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.ca"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.p"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.na"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.dcad"><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.se"><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><br><data-i18n i18n="_unit_mg_">mg</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.vitamin_e"><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th></tr></thead><tbody id="homeBody" ng-if="!vm.loadingTable"><tr><th><input class="input-sm form-control search-input" type="search" ng-model="vm.rationFilterString" ng-change="vm.searchRation()" ng-disabled="vm.loadingTable" style="margin: 0px"></th><td ng-if="!vm.selectedHerd"><input class="input-sm form-control search-input" type="search" ng-model="vm.herdFilterString" ng-change="vm.searchRation()" ng-disabled="vm.loadingTable" style="margin: 0px"></td><td ng-if="!vm.selectedGroup"><input class="input-sm form-control search-input" type="search" ng-model="vm.groupFilterString" ng-change="vm.searchRation()" ng-disabled="vm.loadingTable" style="margin: 0px"></td><td colspan="30"></td></tr><tr ng-repeat-start="(indexX, ration) in vm.rations" class="editable-tr-wrap" ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 7px; padding-right: 0px; text-align: left"><div class="ration-name" style="margin-left: 10px !important; padding-bottom: 10px; margin-top: 1px"><span class="newCheck"><input type="checkbox" ng-click="vm.select(ration, $event)" id="is_checked{{indexX}}-I" ng-true-value="true" ng-false-value="false" ng-model="ration.is_selected" style="margin-right: 5px" ng-if="!vm.comparisonActive"> <label for="is_checked{{indexX}}-I" style="padding-left: 20px; margin-right: 1px"></label>{{ration.ration_name}}</span> <a class="ion-arrow" ng-click="vm.selectTableRow($index, ration.id)" href="" ng-class="vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" style="position: absolute; right: 0px; margin-top: 3px; margin-right: 6px" uib-tooltip="{{\'_expand_ration_\' | i18n}}" tooltip-is-open="Ration" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></div></th><td ng-if="!vm.selectedHerd" style="min-width: 175px"><div class="group-herd-name">{{ration.herd_name}}</div></td><td ng-if="!vm.selectedGroup" style="min-width: 175px"><div class="group-herd-name">{{ration.group_name}}</div></td><td style="min-width: 130px">{{ration.create_date | date: vm.date_format}}</td><td style="min-width: 120px">{{ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td style="min-width: 125px">{{ration.supply.as_fed | formatViewValuesPerDay: \'as_fed\'}}</td><td>{{ration.supply.dm | formatViewValuesPerDay: \'dm\'}}</td><td style="min-width: 165px">{{ration.supply.group_as_fed | formatViewValuesPerDay: \'group_as_fed\'}}</td><td>{{ration.supply.ef_ndf_as_dm | formatViewValuesPerDay: \'ef_ndf_as_dm\'}}</td><td>{{ration.supply.nel | formatViewValuesPerDay: \'nel\'}}</td><td>{{ration.supply.me | formatViewValuesPerDay: \'me\'}}</td><td>{{ration.supply.nem | formatViewValuesPerDay: \'nem\'}}</td><td>{{ration.supply.neg | formatViewValuesPerDay: \'neg\'}}</td><td>{{ration.supply.ndf | formatViewValuesPerDay: \'ndf\'}}</td><td>{{ration.supply.cp | formatViewValuesPerDay: \'cp\'}}</td><td>{{ration.supply.rup | formatViewValuesPerDay: \'rup\'}}</td><td>{{ration.supply.mp | formatViewValuesPerDay: \'mp\'}}</td><td style="min-width: 170px">{{ration.supply.rup_dig | formatViewValuesPerDay: \'rup_dig\'}}</td><td>{{ration.supply.fa | formatViewValuesPerDay: \'fa\'}}</td><td>{{ration.supply.ca | formatViewValuesPerDay: \'ca\'}}</td><td>{{ration.supply.p | formatViewValuesPerDay: \'p\'}}</td><td>{{ration.supply.na | formatViewValuesPerDay: \'na\'}}</td><td>{{ration.supply.dcad | formatViewValuesPerDay: \'dcad\'}}</td><td>{{ration.supply.se | formatViewValuesPerDay: \'se\'}}</td><td>{{ration.supply.vitamin_e | formatViewValuesPerDay: \'vitamin_e\'}}</td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds && vm.settings.use_percent" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td></td><td></td><td>{{vm.weight}}</td><td>{{vm.weight}}</td><td>%</td><td>{{vm.weight}}</td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td ng-if="vm.ration.group.type!=\'heifer\'">{{vm.energy}}/{{vm.weight}}</td><td>{{vm.energy}}/{{vm.weight}}</td><td ng-if="vm.ration.group.type==\'heifer\'">{{vm.energy}}/{{vm.weight}}</td><td ng-if="vm.ration.group.type==\'heifer\'">{{vm.energy}}/{{vm.weight}}</td><td>{{vm.energy}}/{{vm.weight}}</td><td>{{vm.energy}}/{{vm.weight}}</td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></td><td></td><td>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</td><td><data-i18n i18n="_unit_ppm_">ppm</data-i18n></td><td><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds && !vm.settings.use_percent" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td></td><td></td><td>{{vm.weight}}</td><td>{{vm.weight}}</td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</td><td>{{vm.weight}}</td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td ng-if="vm.ration.group.type!=\'heifer\'">{{vm.energy}}/{{vm.weight}}</td><td>{{vm.energy}}/{{vm.weight}}</td><td ng-if="vm.ration.group.type==\'heifer\'">{{vm.energy}}/{{vm.weight}}</td><td ng-if="vm.ration.group.type==\'heifer\'">{{vm.energy}}/{{vm.weight}}</td><td>{{vm.energy}}/{{vm.weight}}</td><td>{{vm.energy}}/{{vm.weight}}</td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></td><td></td><td>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</td><td><data-i18n i18n="_unit_ppm_">ppm</data-i18n></td><td><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, feed) in ration.feeds" ng-if="ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationThBackground" style="text-align: left"><div class="ration-name"><span><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td ng-if="!vm.selectedHerd" style="min-width: 170px"></td><td ng-if="!vm.selectedGroup" style="min-width: 170px"></td><td style="min-width: 130px"></td><td style="min-width: 120px">{{feed.amount | formatViewValues: \'amount\'}}</td><td style="min-width: 125px">{{feed.as_fed | formatViewValues: \'as_fed\'}}</td><td>{{feed.dm | formatViewValues: \'dm\'}}</td><td style="min-width: 165px">{{feed.group_as_fed | formatViewValues: \'group_as_fed\'}}</td><td>{{feed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</td><td>{{feed.nel | formatViewValues: \'nel\'}}</td><td>{{feed.me | formatViewValues: \'me\'}}</td><td>{{feed.nem | formatViewValues: \'nem\'}}</td><td>{{feed.neg | formatViewValues: \'neg\'}}</td><td>{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td>{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td>{{feed.rup | formatViewValues: \'rup\'}}</td><td>{{feed.mp | formatViewValues: \'mp\'}}</td><td style="min-width: 170px">{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</td><td>{{feed.fa | formatViewValues: \'fa\'}}</td><td>{{feed.ca | formatViewValues: \'ca\': feed.dm}}</td><td>{{feed.p | formatViewValues: \'p\': feed.dm}}</td><td>{{feed.na | formatViewValues: \'na\': feed.dm}}</td><td>{{feed.dcad | formatViewValues: \'dcad\'}}</td><td>{{feed.se | formatViewValues: \'se\'}}</td><td>{{feed.vitamin_e | formatViewValues: \'vitamin_e\'}}</td></tr><tr ng-repeat-end="" ng-if="ration.feeds"></tr><tr ng-if="vm.loadingFeeds && vm.dataCollapse[indexX]==true" class="defaultBackground"><td colspan="30"><div id="loading-animation" style="display: inline-block"></div></td></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable"><tr class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparisonHome/rationComparison.home.VemDve.html','<div ng-if="!vm.loadingTabs" class="container fixed ration-comparison-table" style="width: auto"><table class="table table-bordered-striped" st-table="vm.rations" st-safe-src="vm.rationsSafe" id="homeTable"><thead id="homeHeader"><tr class="sortable"><th style="height: 76px" st-sort="ration_name"><div class="fixed-feed-name"><data-i18n i18n="_rations_ration_name_"></data-i18n></div></th><th ng-if="!vm.selectedHerd" style="min-width: 170px" st-sort="herd_name"><data-i18n i18n="_groups_herd_name_">herd name</data-i18n></th><th ng-if="!vm.selectedGroup" style="min-width: 170px" st-sort="group_name"><data-i18n i18n="_groups_group_name_">group name</data-i18n><br><br></th><th style="min-width: 130px" st-sort="create_date"><data-i18n i18n="_rations_date_">create date</data-i18n><br><br></th><th style="min-width: 120px" st-sort="supply.amount_dm"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th style="min-width: 125px" st-sort="supply.as_fed"><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.dm"><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</div></th><th style="min-width: 165px" st-sort="supply.group_as_fed"><div uib-tooltip="{{\'_description_group_as_fed_\' | i18n}}" tooltip-is-open="groupAsFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_group_as_fed_">group as fed</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.vem"><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">vem</data-i18n><br><data-i18n i18n="_feeds_vem_unit_">vem</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.dve"><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dveIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">dve</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.oeb"><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oebIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">oeb</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.cp"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.fos"><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">fos</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.starch"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.rus"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.sugar"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.ca"><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.p"><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.mg"><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">mg</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.na"><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.k"><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">k</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.cl"><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">cl</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.s"><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">s</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.adf"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">adf</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.lignin"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.ndf"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.efndf"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfNameIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">efndf</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.efndf"><div uib-tooltip="{{\'_description_ef_ndf_as_dm_\' | i18n}}" tooltip-is-open="efndfNameIsOpen2" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">efndf</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th></tr></thead><tbody id="homeBody" ng-if="!vm.loadingTable"><tr><th><input class="input-sm form-control search-input" type="search" ng-model="vm.rationFilterString" ng-change="vm.searchRation()" ng-disabled="vm.loadingTable" style="margin: 0px"></th><td ng-if="!vm.selectedHerd"><input class="input-sm form-control search-input" type="search" ng-model="vm.herdFilterString" ng-change="vm.searchRation()" ng-disabled="vm.loadingTable" style="margin: 0px"></td><td ng-if="!vm.selectedGroup"><input class="input-sm form-control search-input" type="search" ng-model="vm.groupFilterString" ng-change="vm.searchRation()" ng-disabled="vm.loadingTable" style="margin: 0px"></td><td colspan="30"></td></tr><tr ng-repeat-start="(indexX, ration) in vm.rations" class="editable-tr-wrap" ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 7px; padding-right: 0px; text-align: left"><div class="ration-name" style="margin-left: 10px !important; padding-bottom: 10px; margin-top: 1px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-click="vm.select(ration, $event)" ng-true-value="true" ng-false-value="false" ng-model="ration.is_selected" style="margin-right: 5px" ng-if="!vm.comparisonActive"> <label for="is_checked{{$index}}" style="padding-left: 20px; margin-right: 1px"></label>{{ration.ration_name}}</span> <a class="ion-arrow" ng-click="vm.selectTableRow($index, ration.id)" href="" ng-class="vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" style="position: absolute; right: 0px; margin-top: 3px; margin-right: 6px" uib-tooltip="{{\'_expand_ration_\' | i18n}}" tooltip-is-open="Ration" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></div></th><td ng-if="!vm.selectedHerd" style="min-width: 170px"><div class="group-herd-name">{{ration.herd_name}}</div></td><td ng-if="!vm.selectedGroup" style="min-width: 170px"><div class="group-herd-name">{{ration.group_name}}</div></td><td style="min-width: 130px">{{ration.create_date | date: vm.date_format}}</td><td style="min-width: 120px">{{ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td style="min-width: 125px">{{ration.supply.as_fed | formatViewValuesPerDay: \'as_fed\'}}</td><td>{{ration.supply.dm | formatViewValuesPerDay: \'dm\'}}</td><td style="min-width: 165px">{{ration.supply.group_as_fed | formatViewValuesPerDay: \'group_as_fed\'}}</td><td>{{ration.supply.vem | formatViewValuesPerDay: \'vem\'}}</td><td>{{ration.supply.dve | formatViewValuesPerDay: \'dve\'}}</td><td>{{ration.supply.oeb | formatViewValuesPerDay: \'oeb\'}}</td><td>{{ration.supply.cp | formatViewValuesPerDay: \'cp\'}}</td><td>{{ration.supply.fos | formatViewValuesPerDay: \'fos\'}}</td><td>{{ration.supply.starch | formatViewValuesPerDay: \'starch\'}}</td><td>{{ration.supply.rus | formatViewValuesPerDay: \'rus\'}}</td><td>{{ration.supply.sugar | formatViewValuesPerDay: \'sugar\'}}</td><td>{{ration.supply.ca | formatViewValuesPerDay: \'ca\'}}</td><td>{{ration.supply.p | formatViewValuesPerDay: \'p\'}}</td><td>{{ration.supply.mg | formatViewValuesPerDay: \'mg\'}}</td><td>{{ration.supply.na | formatViewValuesPerDay: \'na\'}}</td><td>{{ration.supply.k | formatViewValuesPerDay: \'k\'}}</td><td>{{ration.supply.cl | formatViewValuesPerDay: \'cl\'}}</td><td>{{ration.supply.s | formatViewValuesPerDay: \'s\'}}</td><td>{{ration.supply.adf | formatViewValuesPerDay: \'adf\'}}</td><td>{{ration.supply.lignin | formatViewValuesPerDay: \'lignin\'}}</td><td>{{ration.supply.ndf | formatViewValuesPerDay: \'ndf\'}}</td><td>{{ration.supply.ef_ndf_as_ndf | formatViewValuesPerDay: \'ef_ndf_as_ndf\'}}</td><td>{{ration.supply.ef_ndf_as_dm | formatViewValuesPerDay: \'ef_ndf_as_dm\'}}</td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds && vm.settings.use_percent" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td></td><td></td><td>{{vm.weight}}</td><td>{{vm.weight}}</td><td>%</td><td>{{vm.weight}}</td><td><data-i18n i18n="_feeds_vem_unit_">vem</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds && !vm.settings.use_percent" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td></td><td></td><td>{{vm.weight}}</td><td>{{vm.weight}}</td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</td><td>{{vm.weight}}</td><td><data-i18n i18n="_feeds_vem_unit_">vem</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, feed) in ration.feeds" ng-if="ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationThBackground" style="text-align: left"><div class="ration-name"><span><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td ng-if="!vm.selectedHerd" style="min-width: 170px"></td><td ng-if="!vm.selectedGroup" style="min-width: 170px"></td><td style="min-width: 130px"></td><td style="min-width: 120px">{{feed.amount | formatViewValues: \'amount\'}}</td><td style="min-width: 125px">{{feed.as_fed| formatViewValues: \'as_fed\'}}</td><td>{{feed.dm | formatViewValues: \'dm\'}}</td><td style="min-width: 165px">{{feed.group_as_fed | formatViewValues: \'group_as_fed\'}}</td><td>{{feed.vem | formatViewValues: \'vem\'}}</td><td>{{feed.dve | formatViewValues: \'dve\': feed.dm}}</td><td>{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</td><td>{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td>{{feed.fos | formatViewValues: \'fos\': feed.dm}}</td><td>{{feed.starch | formatViewValues: \'starch\': feed.dm}}</td><td>{{feed.rus | formatViewValues: \'rus\': feed.dm}}</td><td>{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</td><td>{{feed.ca | formatViewValues: \'ca\': feed.dm}}</td><td>{{feed.p | formatViewValues: \'p\': feed.dm}}</td><td>{{feed.mg | formatViewValues: \'mg\': feed.dm}}</td><td>{{feed.na | formatViewValues: \'na\': feed.dm}}</td><td>{{feed.k | formatViewValues: \'k\': feed.dm}}</td><td>{{feed.cl | formatViewValues: \'cl\': feed.dm}}</td><td>{{feed.s | formatViewValues: \'s\': feed.dm}}</td><td>{{feed.adf | formatViewValues: \'adf\': feed.dm}}</td><td>{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</td><td>{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td>{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td>{{feed.ef_ndf_as_dm | formatViewValues: \'ef_ndf_as_dm\'}}</td></tr><tr ng-repeat-end="" ng-if="ration.feeds"></tr><tr ng-if="vm.loadingFeeds && vm.dataCollapse[indexX]==true" class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable"><tr class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparisonLipid/rationComparison.lipid.US.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" id="lipidTable" st-table="vm.rations" st-safe-src="vm.rationsSafe"><thead id="lipidHeader"><tr class="sortable"><th style="height: 77px" st-sort="ration_name"><data-i18n i18n="_rations_ration_name_"></data-i18n></th><th style="min-width: 120px" st-sort="supply.amount_dm"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.ee"><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.fa"><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.sfa"><div uib-tooltip="{{\'_description_sfa_\' | i18n}}" tooltip-is-open="sfaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sfa_">SFA</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.mufa"><div uib-tooltip="{{\'_description_mufa_\' | i18n}}" tooltip-is-open="mufaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mufa_">MUFA</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.pufa"><div uib-tooltip="{{\'_description_pufa_\' | i18n}}" tooltip-is-open="pufaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_pufa_">PUFA</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.bhfa"><div uib-tooltip="{{\'_description_bhfa_\' | i18n}}" tooltip-is-open="bhfaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_bhfa_">BHFA</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.idufa"><div uib-tooltip="{{\'_description_idufa_\' | i18n}}" tooltip-is-open="idufaIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_idufa_">idufa</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.fa_dig"><div uib-tooltip="{{\'_description_fa_dig_\' | i18n}}" tooltip-is-open="faDigIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_dig_">FA dig</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.td_fa"><div uib-tooltip="{{\'_description_td_fa_\' | i18n}}" tooltip-is-open="tdFaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdfa_">td FA</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th></tr></thead><tbody id="lipidBody" ng-if="!vm.loadingTable"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, ration) in vm.rations" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 7px; padding-right: 0px; text-align: left"><div class="ration-name" style="margin-left: 10px !important; padding-bottom: 10px; margin-top: 1px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(ration, $event)" ng-model="ration.is_selected" style="margin-right: 5px" ng-if="!vm.comparisonActive"> <label for="is_checked{{$index}}" style="padding-left: 20px; margin-right: 1px"></label> {{ration.ration_name}}</span> <a class="ion-arrow" ng-click="vm.selectTableRow($index, ration.id)" href="" ng-class="vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" style="position: absolute; right: 0px; margin-top: 3px; margin-right: 6px" uib-tooltip="{{\'_expand_ration_\' | i18n}}" tooltip-append-to-body="true" tooltip-is-open="Ration" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></div></th><td style="min-width: 120px">{{ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{ration.supply.ee | formatViewValuesPerDay: \'ee\'}}</td><td>{{ration.supply.fa | formatViewValuesPerDay: \'fa\'}}</td><td>{{ration.supply.sfa | formatViewValuesPerDay: \'sfa\'}}</td><td>{{ration.supply.mufa | formatViewValuesPerDay: \'mufa\'}}</td><td>{{ration.supply.pufa | formatViewValuesPerDay: \'pufa\'}}</td><td>{{ration.supply.bhfa | formatViewValuesPerDay: \'bhfa\'}}</td><td>{{ration.supply.idufa | formatViewValuesPerDay: \'idufa\'}}</td><td>{{ration.supply.fa_dig | formatViewValuesPerDay: \'fa_dig\'}}</td><td>{{ration.supply.td_fa | formatViewValuesPerDay: \'td_fa\'}}</td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td><span ng-show="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-show="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, feed) in ration.feeds" ng-if="ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationThBackground" style="text-align: left"><div class="ration-name"><span><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px">{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.ee | formatViewValues: \'ee\': feed.dm}}</td><td>{{feed.fa | formatViewValues: \'fa\'}}</td><td>{{feed.sfa | formatViewValues: \'sfa\'}}</td><td>{{feed.mufa | formatViewValues: \'mufa\'}}</td><td>{{feed.pufa | formatViewValues: \'pufa\'}}</td><td>{{feed.bhfa | formatViewValues: \'bhfa\'}}</td><td>{{feed.idufa | formatViewValues: \'idufa\'}}</td><td>{{feed.fa_dig | formatViewValues: \'fa_dig\'}}</td><td>{{feed.td_fa | formatViewValues: \'td_fa\'}}</td></tr><tr ng-repeat-end="" ng-if="ration.feeds"></tr><tr ng-if="vm.loadingFeeds && vm.dataCollapse[indexX]==true" class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable"><tr class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparisonLipid/rationComparison.lipid.VemDve.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" id="lipidTable" st-table="vm.rations" st-safe-src="vm.rationsSafe"><thead id="lipidHeader"><tr class="sortable"><th style="height: 77px" st-sort="ration_name"><data-i18n i18n="_rations_ration_name_"></data-i18n></th><th style="min-width: 120px" st-sort="supply.amount_dm"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.ee"><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th></tr></thead><tbody id="lipidBody" ng-if="!vm.loadingTable"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, ration) in vm.rations" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 7px; padding-right: 0px; text-align: left"><div class="ration-name" style="margin-left: 10px !important; padding-bottom: 10px; margin-top: 1px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(ration, $event)" ng-model="ration.is_selected" style="margin-right: 5px" ng-if="!vm.comparisonActive"> <label for="is_checked{{$index}}"></label> {{ration.ration_name}}</span> <a class="ion-arrow" ng-click="vm.selectTableRow($index, ration.id)" href="" ng-class="vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" style="position: absolute; right: 0px; margin-top: 3px; margin-right: 6px" uib-tooltip="{{\'_expand_ration_\' | i18n}}" tooltip-is-open="Ration" tooltip-placement="right" tooltip-append-to-body="true" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></div></th><td style="min-width: 120px">{{ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{ration.supply.ee | formatViewValuesPerDay: \'ee\'}}</td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td><span ng-show="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-show="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, feed) in ration.feeds" ng-if="ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationThBackground" style="text-align: left"><div class="ration-name"><span><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px">{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.ee | formatViewValues: \'ee\': feed.dm}}</td></tr><tr ng-repeat-end="" ng-if="ration.feeds"></tr><tr ng-if="vm.loadingFeeds && vm.dataCollapse[indexX]==true" class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable"><tr class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryCarb/rationFeedHistory.carb.US.html','<div><table class="table table-hover-striped" st-table="vm.feeds"><thead><tr class="sortable" style="height: 30px"><th st-sort="feed_name" style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="nfc" style="width: 200px"><div uib-tooltip="{{\'_description_nfc_\' | i18n}}" tooltip-is-open="nfcIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_">NFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="nfc_dig" style="width: 200px"><div uib-tooltip="{{\'_description_nfc_dig_\' | i18n}}" tooltip-is-open="nfcDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_digestibility_">NFC dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_nfc_">NFC</data-i18n></div></th><th st-sort="starch" style="width: 200px"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="rd_starch" style="width: 200px"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th st-sort="sugar" style="width: 200px"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="in_fa" style="width: 200px"><div uib-tooltip="{{\'_description_infa_\' | i18n}}" tooltip-is-open="infaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_infa_">infa</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="sol_fiber" style="width: 200px"><div uib-tooltip="{{\'_description_sol_fiber_\' | i18n}}" tooltip-is-open="solFiberIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_" dm=""></data-i18n></div></th><th st-sort="rd_sol_fiber" style="width: 200px"><div uib-tooltip="{{\'_description_rd_sol_fiber_\' | i18n}}" tooltip-is-open="rdSolFiberIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdsolf_">RDSolF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n></div></th><th st-sort="td_nfc" style="width: 200px"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.nfc | formatViewValues: \'nfc\'}}</td><td>{{feed.nfc_dig | formatViewValues: \'nfc_dig\'}}</td><td>{{feed.starch | formatViewValues: \'starch\': feed.dm}}</td><td>{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</td><td>{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</td><td>{{feed.in_fa | formatViewValues: \'in_fa\': feed.dm}}</td><td>{{feed.sol_fiber | formatViewValues: \'sol_fiber\'}}</td><td>{{feed.rd_sol_fiber | formatViewValues: \'rd_sol_fiber\'}}</td><td>{{feed.td_nfc | formatViewValues: \'td_nfc\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryCarb/rationFeedHistory.carb.VemDve.html','<div><table class="table table-hover-striped" st-table="vm.feeds"><thead><tr class="sortable" style="height: 30px"><th st-sort="feed_name" style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="rus" style="width: 200px"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="starch" style="width: 200px"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="rd_starch" style="width: 200px"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th st-sort="sugar" style="width: 200px"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="td_nfc" style="width: 200px"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.rus | formatViewValues: \'rus\': feed.dm}}</td><td>{{feed.starch | formatViewValues: \'starch\': feed.dm}}</td><td>{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</td><td>{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</td><td>{{feed.td_nfc | formatViewValues: \'td_nfc\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryCarb/rationFeedHistoryMix.carb.US.html','<div><table class="table table-hover-striped"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_nfc_\' | i18n}}" tooltip-is-open="nfcIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_">NFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_nfc_dig_\' | i18n}}" tooltip-is-open="nfcDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_digestibility_">NFC dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_nfc_">NFC</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_infa_\' | i18n}}" tooltip-is-open="infaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_infa_">infa</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_sol_fiber_\' | i18n}}" tooltip-is-open="solFiberIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_" dm=""></data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_rd_sol_fiber_\' | i18n}}" tooltip-is-open="rdSolFiberIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdsolf_">RDSolF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" style="white-space: nowrap">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.nfc_changed ? \'property-changed\' : \'\'">{{feed.nfc | formatViewValues: \'nfc\'}}</td><td ng-class="feed.nfc_dig_changed ? \'property-changed\' : \'\'">{{feed.nfc_dig | formatViewValues: \'nfc_dig\'}}</td><td ng-class="feed.starch_changed ? \'property-changed\' : \'\'">{{feed.starch | formatViewValues: \'starch\': feed.dm}}</td><td ng-class="feed.rd_starch_changed ? \'property-changed\' : \'\'">{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</td><td ng-class="feed.sugar_changed ? \'property-changed\' : \'\'">{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</td><td ng-class="feed.in_fa_changed ? \'property-changed\' : \'\'">{{feed.in_fa | formatViewValues: \'in_fa\': feed.dm}}</td><td ng-class="feed.sol_fiber_changed ? \'property-changed\' : \'\'">{{feed.sol_fiber | formatViewValues: \'sol_fiber\'}}</td><td ng-class="feed.rd_sol_fiber_changed ? \'property-changed\' : \'\'">{{feed.rd_sol_fiber | formatViewValues: \'rd_sol_fiber\'}}</td><td ng-class="feed.td_nfc_changed ? \'property-changed\' : \'\'">{{feed.td_nfc | formatViewValues: \'td_nfc\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryCarb/rationFeedHistoryMix.carb.VemDve.html','<div><table class="table table-hover-striped"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" style="white-space: nowrap">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.rus_changed ? \'property-changed\' : \'\'">{{feed.rus | formatViewValues: \'rus\': feed.dm}}</td><td ng-class="feed.starch_changed ? \'property-changed\' : \'\'">{{feed.starch | formatViewValues: \'starch\': feed.dm}}</td><td ng-class="feed.rd_starch_changed ? \'property-changed\' : \'\'">{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</td><td ng-class="feed.sugar_changed ? \'property-changed\' : \'\'">{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</td><td ng-class="feed.td_nfc_changed ? \'property-changed\' : \'\'">{{feed.td_nfc | formatViewValues: \'td_nfc\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparisonProtein/rationComparison.protein.US.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.rations" st-safe-src="vm.rationsSafe" id="proteinTable"><thead id="proteinHeader"><tr class="sortable"><th style="height: 77px" st-safe="ration_name" st-sort="ration_name"><data-i18n i18n="_rations_ration_name_"></data-i18n></th><th style="min-width: 120px" st-sort="supply.amount_dm"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.cp"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.rup"><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.rdp"><div uib-tooltip="{{\'_description_rdp_\' | i18n}}" tooltip-is-open="rdpIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp_">rdp</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.mp"><div uib-tooltip="{{\'_description_mp_\' | i18n}}" tooltip-is-open="mpIsOpen" tooltip-placement="right" tooltip-append-to-body="true" tooltip-class="custBlue right tooltip-largeX" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp_">mp</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th style="min-width: 130px" st-sort="supply.rup_dig"><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.a_prot"><div uib-tooltip="{{\'_description_a_prot_\' | i18n}}" tooltip-is-open="AProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_a_">A Prot</data-i18n><br><br></div></th><th st-sort="supply.b_prot"><div uib-tooltip="{{\'_description_b_prot_\' | i18n}}" tooltip-is-open="BProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_b_">B Prot</data-i18n><br><br></div></th><th st-sort="supply.c_prot"><div uib-tooltip="{{\'_description_c_prot_\' | i18n}}" tooltip-is-open="CProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_c_">C Prot</data-i18n><br><br></div></th><th st-sort="supply.kd_b_prot"><div uib-tooltip="{{\'_description_kd_bprot_\' | i18n}}" tooltip-is-open="kdBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kd_bprot_">kd bprot</data-i18n><br><br></div></th><th st-sort="supply.kp_b_prot"><div uib-tooltip="{{\'_description_kp_bprot_\' | i18n}}" tooltip-is-open="kpBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kp_bprot_">kp bprot</data-i18n><br><br></div></th><th st-sort="supply.npncpe"><div uib-tooltip="{{\'_description_npncpe_\' | i18n}}" tooltip-is-open="npncpeIsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_npncpe_">NPNCPE</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.rup_89"><div uib-tooltip="{{\'_description_rup_89_\' | i18n}}" tooltip-is-open="rup89IsOpen" tooltip-placement="right" tooltip-class="customBlue right tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup89_">rup 89</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.rdp_01"><div uib-tooltip="{{\'_description_rdp_01_\' | i18n}}" tooltip-is-open="rdp01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp01_">rdp 01</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.mp_01"><div uib-tooltip="{{\'_description_mp_01_\' | i18n}}" tooltip-is-open="mp01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp01_">mp 01</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.ndicp"><div uib-tooltip="{{\'_description_ndicp_\' | i18n}}" tooltip-is-open="ndicpIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndicp_">NDICP</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.adicp"><div uib-tooltip="{{\'_description_adicp_\' | i18n}}" tooltip-is-open="adicpIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.td_trup"><div uib-tooltip="{{\'_description_td_trup_\' | i18n}}" tooltip-is-open="tdtrupIsOpen" tooltip-placement="left" tooltip-class="customBlue left tooltip-large" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdtrup_">tdtrup</data-i18n><br><data-i18n i18n="_unit_day_">day</data-i18n></div></th></tr></thead><tbody id="proteinBody" ng-if="!vm.loadingTable"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, ration) in vm.rations" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 7px; padding-right: 0px; text-align: left"><div class="ration-name" style="margin-left: 10px !important; padding-bottom: 10px; margin-top: 1px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(ration, $event)" ng-model="ration.is_selected" style="margin-right: 5px" ng-if="!vm.comparisonActive"> <label for="is_checked{{$index}}" style="padding-left: 20px; margin-right: 1px"></label> {{ration.ration_name}}</span> <a class="ion-arrow" ng-click="vm.selectTableRow($index, ration.id)" href="" ng-class="vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" style="position: absolute; right: 0px; margin-top: 3px; margin-right: 6px" uib-tooltip="{{\'_expand_ration_\' | i18n}}" tooltip-is-open="Ration" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></div></th><td style="min-width: 120px">{{ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{ration.supply.cp | formatViewValuesPerDay: \'cp\'}}</td><td>{{ration.supply.rup | formatViewValuesPerDay: \'rup\'}}</td><td>{{ration.supply.rdp | formatViewValuesPerDay: \'rdp\'}}</td><td>{{ration.supply.mp | formatViewValuesPerDay: \'mp\'}}</td><td style="min-width: 130px">{{ration.supply.rup_dig | formatViewValuesPerDay: \'rup_dig\'}}</td><td>{{ration.supply.a_prot | formatViewValuesPerDay: \'a_prot\'}}</td><td>{{ration.supply.b_prot | formatViewValuesPerDay: \'b_prot\'}}</td><td>{{ration.supply.c_prot | formatViewValuesPerDay: \'c_prot\'}}</td><td>{{ration.supply.kd_b_prot | formatViewValuesPerDay: \'kd_b_prot\'}}</td><td>{{ration.supply.kp_b_prot | formatViewValuesPerDay: \'kp_b_prot\'}}</td><td>{{ration.supply.npncpe | formatViewValuesPerDay: \'npncpe\'}}</td><td>{{ration.supply.rup_89 | formatViewValuesPerDay: \'rup_89\'}}</td><td>{{ration.supply.rdp_01 | formatViewValuesPerDay: \'rdp_01\'}}</td><td>{{ration.supply.mp_01 | formatViewValuesPerDay: \'mp_01\'}}</td><td>{{ration.supply.ndicp | formatViewValuesPerDay: \'ndicp\'}}</td><td>{{ration.supply.adicp | formatViewValuesPerDay: \'adicp\'}}</td><td><span blur="cancel">{{ration.supply.td_trup | formatViewValuesPerDay: \'td_trup\'}}</span></td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds && vm.settings.use_percent" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></td><td></td><td>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></td><td></td><td></td><td></td><td></td><td></td><td>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds && !vm.settings.use_percent" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></td><td></td><td>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></td><td></td><td></td><td></td><td></td><td></td><td>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></td><td>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, feed) in ration.feeds" ng-if="ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationThBackground" style="text-align: left"><div class="ration-name"><span><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px">{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td>{{feed.rup | formatViewValues: \'rup\'}}</td><td>{{feed.rdp | formatViewValues: \'rdp\'}}</td><td>{{feed.mp | formatViewValues: \'mp\'}}</td><td style="min-width: 130px">{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</td><td>{{feed.a_prot | formatViewValues: \'a_prot\'}}</td><td>{{feed.b_prot | formatViewValues: \'b_prot\'}}</td><td>{{feed.c_prot | formatViewValues: \'c_prot\'}}</td><td>{{feed.kd_b_prot | formatViewValues: \'kd_b_prot\'}}</td><td>{{feed.kp_b_prot | formatViewValues: \'kp_b_prot\'}}</td><td>{{feed.npncpe | formatViewValues: \'npncpe\'}}</td><td>{{feed.rup_89 | formatViewValues: \'rup_89\'}}</td><td>{{feed.rdp01 | formatViewValues: \'rdp01\'}}</td><td>{{feed.mp01 | formatViewValues: \'mp01\'}}</td><td>{{feed.ndicp | formatViewValues: \'ndicp\': feed.dm}}</td><td>{{feed.adicp | formatViewValues: \'adicp\': feed.dm}}</td><td>{{feed.td_trup | formatViewValues: \'td_trup\'}}</td></tr><tr ng-repeat-end="" ng-if="ration.feeds"></tr><tr ng-if="vm.loadingFeeds && vm.dataCollapse[indexX]==true" class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable"><tr class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div>></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationComparison/rationComparisonProtein/rationComparison.protein.VemDve.html','<div ng-if="!vm.loadingTabs" class="container fixed" style="width: auto"><table class="table table-bordered-striped" st-table="vm.rations" st-safe-src="vm.rationsSafe" id="proteinTable"><thead id="proteinHeader"><tr class="sortable"><th style="height: 77px" st-safe="ration_name" st-sort="ration_name"><data-i18n i18n="_rations_ration_name_"></data-i18n></th><th style="min-width: 120px" st-sort="supply.amount_dm"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="supply.cp"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.dve"><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dve07IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">DVE</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th><th st-sort="supply.oeb"><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oeb07IsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">OEB</data-i18n><br><data-i18n i18n="_unit_grams_">g</data-i18n>/<data-i18n i18n="_unit_day_">day</data-i18n></div></th></tr></thead><tbody id="proteinBody" ng-if="!vm.loadingTable"><tr class="editable-tr-wrap" ng-repeat-start="(indexX, ration) in vm.rations" ng-class="feed.is_mix ? \'darkBackground \' : \'defaultBackground\'"><th ng-class="feed.is_mix ? \'darkBackgroundCustom\' : \'defaultBackground\'" ng-cloak="" style="padding-left: 7px; padding-right: 0px; text-align: left"><div class="ration-name" style="margin-left: 10px !important; padding-bottom: 10px; margin-top: 1px"><span class="newCheck"><input type="checkbox" id="is_checked{{$index}}" ng-true-value="true" ng-false-value="false" ng-click="vm.select(ration, $event)" ng-model="ration.is_selected" style="margin-right: 5px" ng-if="!vm.comparisonActive"> <label for="is_checked{{$index}}"></label> {{ration.ration_name}}</span> <a class="ion-arrow" ng-click="vm.selectTableRow($index, ration.id)" href="" ng-class="vm.dataCollapse[$index] ? \'ion-arrow-up-b icon-edit\' : \'ion-arrow-down-b icon-edit\'" style="position: absolute; right: 0px; margin-top: 3px; margin-right: 6px" uib-tooltip="{{\'_expand_ration_\' | i18n}}" tooltip-is-open="Ration" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"></a></div></th><td style="min-width: 120px">{{ration.supply.amount_dm | formatViewValuesPerDay: \'amount\'}}</td><td>{{ration.supply.cp | formatViewValuesPerDay: \'cp\'}}</td><td>{{ration.supply.dve | formatViewValuesPerDay: \'dve\'}}</td><td><span blur="cancel">{{ration.supply.oeb | formatViewValuesPerDay: \'oeb\'}}</span></td></tr><tr class="editable-tr-wrap rationComparisonBg" ng-if="!vm.loadingFeeds && ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationComparisonBg"></th><td>{{vm.weight}}</td><td><span ng-show="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-show="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></td><td>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></td><td>{{vm.weight}}/<data-i18n i18n="_unit_day_">day</data-i18n></td></tr><tr class="editable-tr-wrap rationThBackground" ng-repeat-start="(indexY, feed) in ration.feeds" ng-if="ration.feeds" ng-cloak="" ng-show="vm.dataCollapse[indexX]==true"><th class="rationThBackground" style="text-align: left"><div class="ration-name"><span><i class="fa fa-circle feed-type-dot" aria-hidden="true" ng-class="feed.feed_category == \'DF\' ? \'dry-forage\' : (feed.feed_category == \'WF\' ? \'wet-forage\' : (feed.feed_category == \'FA\' ? \'fat\' : (feed.feed_category == \'MIX\' ? \'mix\' : (feed.feed_category == \'C\' ? \'corn\' : (feed.feed_category == \'TRI\' ? \'triglyceride\' : (feed.feed_category == \'Forage\' ? \'forage\' : (feed.feed_category == \'Concentrate\' ? \'concentrate\' : (feed.feed_category == \'Commercial\' ? \'commercial\' : \'\'))))))))"></i>{{feed.feed_name}}</span></div></th><td style="min-width: 120px">{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td>{{feed.dve | formatViewValues: \'dve\': feed.dm}}</td><td>{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</td></tr><tr ng-repeat-end="" ng-if="ration.feeds"></tr><tr ng-if="vm.loadingFeeds && vm.dataCollapse[indexX]==true" class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr><tr ng-repeat-end=""></tr></tbody><tbody ng-if="vm.loadingTable"><tr class="defaultBackground"><td colspan="30"><div class="spinner-small"><div id="loading-animation" style="display: inline-block"></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryEnergy/rationFeedHistory.energy.US.html','<div><table class="table table-hover-striped historyTable" st-table="vm.feeds"><thead><tr class="sortable" style="height: 30px"><th st-sort="feed_name" style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="nel"><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="me"><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me_">ME</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="disc_fac"><div uib-tooltip="{{\'_description_disc_fac_\' | i18n}}" tooltip-is-open="discFacIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_disc_fac_">Disc. Fac.</data-i18n><br>%</div></th><th st-sort="nel_89"><div uib-tooltip="{{\'_description_nel_89_\' | i18n}}" tooltip-is-open="nel89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel89_">NEL 89</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="me_89"><div uib-tooltip="{{\'_description_me_89_\' | i18n}}" tooltip-is-open="me89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me89_">ME 89</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="dep"><div uib-tooltip="{{\'_description_dep_\' | i18n}}" tooltip-is-open="depIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dep_">DEp</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="de1x"><div uib-tooltip="{{\'_description_de1x_\' | i18n}}" tooltip-is-open="de1xIsOpen" tooltip-placement="left" tooltip-append-to-body="true" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_de1x_">DE1X</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th st-sort="mftdn"><div uib-tooltip="{{\'_description_mftdn_\' | i18n}}" tooltip-is-open="mftdnIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mftdn_">MF-TDN</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="tdn1x"><div uib-tooltip="{{\'_description_tdn1x_\' | i18n}}" tooltip-is-open="tdn1xIsOpen" tooltip-append-to-body="true" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdn1x_">TDN1X</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.nel | formatViewValues: \'nel\'}}</td><td>{{feed.me | formatViewValues: \'me\'}}</td><td>{{feed.disc_fac | formatViewValues: \'disc_fac\'}}</td><td>{{feed.nel_89 | formatViewValues: \'nel_89\'}}</td><td>{{feed.me_89 | formatViewValues: \'me_89\'}}</td><td>{{feed.dep | formatViewValues: \'dep\'}}</td><td>{{feed.de1x | formatViewValues: \'de1x\'}}</td><td>{{feed.mftdn | formatViewValues: \'mftdn\'}}</td><td>{{feed.tdn1x | formatViewValues: \'tdn1x\'}}</td></tr></tbody></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryEnergy/rationFeedHistory.energy.VemDve.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_"></data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">cost dm</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">cost dm</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.vem | formatViewValues: \'vem\'}}</td><td>{{feed.fos | formatViewValues: \'fos\': feed.dm}}</td></tr></tbody></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryEnergy/rationFeedHistoryMix.energy.US.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_"></data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me_">ME</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_disc_fac_\' | i18n}}" tooltip-is-open="discFacIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_disc_fac_">Disc. Fac.</data-i18n><br>%</div></th><th><div uib-tooltip="{{\'_description_nel_89_\' | i18n}}" tooltip-is-open="nel89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel89_">NEL 89</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_me_89_\' | i18n}}" tooltip-is-open="me89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me89_">ME 89</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_dep_\' | i18n}}" tooltip-is-open="depIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dep_">DEp</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_de1x_\' | i18n}}" tooltip-is-open="de1xIsOpen" tooltip-append-to-body="true" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_de1x_">DE1X</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_mftdn_\' | i18n}}" tooltip-is-open="mftdnIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mftdn_">MF-TDN</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_tdn1x_\' | i18n}}" tooltip-is-open="tdn1xIsOpen" tooltip-append-to-body="true" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdn1x_">TDN1X</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" style="white-space: nowrap">{{feed.feed_name}}</td><td ng-class="feed.amount_changed ? \'property-changed\' : \'\'">{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.nel_changed ? \'property-changed\' : \'\'">{{feed.nel | formatViewValues: \'nel\'}}</td><td ng-class="feed.me_changed ? \'property-changed\' : \'\'">{{feed.me | formatViewValues: \'me\'}}</td><td ng-class="feed.disc_fac_changed ? \'property-changed\' : \'\'">{{feed.disc_fac | formatViewValues: \'disc_fac\'}}</td><td ng-class="feed.nel_89_changed ? \'property-changed\' : \'\'">{{feed.nel_89 | formatViewValues: \'nel_89\'}}</td><td ng-class="feed.me_89_changed ? \'property-changed\' : \'\'">{{feed.me_89 | formatViewValues: \'me_89\'}}</td><td ng-class="feed.dep_changed ? \'property-changed\' : \'\'">{{feed.dep | formatViewValues: \'dep\'}}</td><td ng-class="feed.de1x_changed ? \'property-changed\' : \'\'">{{feed.de1x | formatViewValues: \'de1x\'}}</td><td ng-class="feed.mftdn_changed ? \'property-changed\' : \'\'">{{feed.mftdn | formatViewValues: \'mftdn\'}}</td><td ng-class="feed.tdn1x_changed ? \'property-changed\' : \'\'">{{feed.tdn1x | formatViewValues: \'tdn1x\'}}</td></tr></tbody></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryEnergy/rationFeedHistoryMix.energy.VemDve.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_"></data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">cost dm</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">cost dm</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" style="white-space: nowrap">{{feed.feed_name}}</td><td ng-class="feed.amount_changed ? \'property-changed\' : \'\'">{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.vem_changed ? \'property-changed\' : \'\'">{{feed.vem | formatViewValues: \'vem\'}}</td><td ng-class="feed.fos_changed ? \'property-changed\' : \'\'">{{feed.fos | formatViewValues: \'fos\': feed.dm}}</td></tr></tbody></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryFiber/rationFeedHistory.fiber.US.html','<div><table class="table table-hover-striped historyTable" st-table="vm.feeds"><thead><tr class="sortable" style="height: 30px"><th st-sort="feed_name"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="ndf"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="ef_ndf_as_ndf"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th st-sort="lignin"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="ndf_digest"><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th st-sort="adf"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="rd_ndf"><div uib-tooltip="{{\'_description_rdndf_\' | i18n}}" tooltip-is-open="rdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdndf_">RDNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th st-sort="td_ndf"><div uib-tooltip="{{\'_description_td_ndf_\' | i18n}}" tooltip-is-open="tdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdndf_">tdNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td>{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td>{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</td><td>{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</td><td>{{feed.adf | formatViewValues: \'adf\': feed.dm}}</td><td>{{feed.rd_ndf | formatViewValues: \'rd_ndf\'}}</td><td>{{feed.td_ndf | formatViewValues: \'td_ndf\'}}</td></tr></tbody></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryFiber/rationFeedHistory.fiber.VemDve.html','<div><table class="table table-hover-striped historyTable" st-table="vm.feeds"><thead><tr class="sortable" style="height: 30px"><th st-sort="feed_name"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="rc"><div uib-tooltip="{{\'_description_rcel_\' | i18n}}" tooltip-is-open="rcNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="ndf"><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="ef_ndf_as_ndf"><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th st-sort="lignin"><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="ndf_digest"><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th st-sort="adf"><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.rc | formatViewValues: \'rc\': feed.dm}}</td><td>{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td>{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td>{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</td><td>{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</td><td>{{feed.adf | formatViewValues: \'adf\': feed.dm}}</td></tr></tbody></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryFiber/rationFeedHistoryMix.fiber.US.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rdndf_\' | i18n}}" tooltip-is-open="rdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdndf_">RDNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_td_ndf_\' | i18n}}" tooltip-is-open="tdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdndf_">tdNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" style="white-space: nowrap">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.ndf_changed ? \'property-changed\' : \'\'">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td ng-class="feed.ef_ndf_as_ndf_changed ? \'property-changed\' : \'\'">{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td ng-class="feed.lignin_changed ? \'property-changed\' : \'\'">{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</td><td ng-class="feed.ndf_digest_changed ? \'property-changed\' : \'\'">{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</td><td ng-class="feed.adf_changed ? \'property-changed\' : \'\'">{{feed.adf | formatViewValues: \'adf\': feed.dm}}</td><td ng-class="feed.rd_ndf_changed ? \'property-changed\' : \'\'">{{feed.rd_ndf | formatViewValues: \'rd_ndf\'}}</td><td ng-class="feed.td_ndf_changed ? \'property-changed\' : \'\'">{{feed.td_ndf | formatViewValues: \'td_ndf\'}}</td></tr></tbody></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryFiber/rationFeedHistoryMix.fiber.VemDve.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_rcel_\' | i18n}}" tooltip-is-open="rcNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" style="white-space: nowrap">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.rc_changed ? \'property-changed\' : \'\'">{{feed.rc | formatViewValues: \'rc\': feed.dm}}</td><td ng-class="feed.ndf_changed ? \'property-changed\' : \'\'">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td ng-class="feed.ef_ndf_as_ndf_changed ? \'property-changed\' : \'\'">{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td ng-class="feed.lignin_changed ? \'property-changed\' : \'\'">{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</td><td ng-class="feed.ndf_digest_changed ? \'property-changed\' : \'\'">{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</td><td ng-class="feed.adf_changed ? \'property-changed\' : \'\'">{{feed.adf | formatViewValues: \'adf\': feed.dm}}</td></tr></tbody></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryHome/rationFeedHistory.home.US.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th ng-if="vm.showButton"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.getMixHistory();" style="display: block; margin: auto" uib-tooltip="{{\'_toggle_premix_ingredients_\' | i18n}}" tooltip-is-open="togglePremix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clipboard"></i></button></th><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_user_\' | i18n}}" tooltip-is-open="lastModifiedUserIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_user_">user</data-i18n><br></div></th><th><div uib-tooltip="{{\'_title_last_modified_date_\' | i18n}}" tooltip-is-open="lastModifiedDateIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_last_modified_date_">last modified date</data-i18n><br></div></th><th><div uib-tooltip="{{\'_title_create_date\' | i18n}}" tooltip-is-open="createdDateIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_create_date">create date</data-i18n><br></div></th><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></div></th><th><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><data-i18n i18n="_feeds_me_">ME</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td ng-if="vm.showButton"></td><td style="white-space: nowrap">{{feed.feed_name}}</td><td>{{feed.last_modified_user}}</td><td>{{feed.last_modified_date | date:\'short\'}}</td><td>{{feed.create_date | date:\'short\'}}</td><td>{{feed.action}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.dm | formatViewValues: \'dm\'}}</td><td>{{feed.nel | formatViewValues: \'nel\'}}</td><td>{{feed.me | formatViewValues: \'me\'}}</td><td>{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td>{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td>{{feed.rup | formatViewValues: \'rup\'}}</td><td>{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</td><td>{{feed.fa | formatViewValues: \'fa\'}}</td><td>{{feed.ca | formatViewValues: \'ca\': feed.dm}}</td><td>{{feed.p | formatViewValues: \'p\': feed.dm}}</td><td>{{feed.na | formatViewValues: \'na\': feed.dm}}</td><td>{{feed.dcad | formatViewValues: \'dcad\'}}</td><td>{{feed.se | formatViewValues: \'se\'}}</td><td>{{feed.vitamin_e | formatViewValues: \'vitamin_e\'}}</td><td>{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</td><td>{{feed.test_date | date: vm.date_format}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryHome/rationFeedHistory.home.VemDve.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th ng-if="vm.showButton"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.getMixHistory()" style="display: block; margin: auto" uib-tooltip="{{\'_toggle_premix_ingredients_\' | i18n}}" tooltip-is-open="togglePremix" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><i class="ion-clipboard"></i></button></th><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_user_\' | i18n}}" tooltip-is-open="lastModifiedUserIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_user_">user</data-i18n><br></div></th><th><div uib-tooltip="{{\'_title_last_modified_date_\' | i18n}}" tooltip-is-open="lastModifiedDateIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_last_modified_date_">last modified date</data-i18n><br></div></th><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></div></th><th><div uib-tooltip="{{\'_description_group_as_fed_\' | i18n}}" tooltip-is-open="groupAsFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_group_as_fed_">group as fed</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_diet_dmi_\' | i18n}}" tooltip-is-open="dietDmiIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_diet_dmi_">diet dmi</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dmi_">dmi</data-i18n></div></th><th><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">vem</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dveIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">dve</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oebIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">oeb</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">cp</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">fos</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">ca</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">p</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">mg</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">na</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">k</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">cl</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">s</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">adf</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">ndf</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td ng-if="vm.showButton"></td><td style="white-space: nowrap">{{feed.feed_name}}</td><td>{{feed.last_modified_user}}</td><td>{{feed.last_modified_date | date:\'short\'}}</td><td>{{feed.action}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.as_fed | formatViewValues: \'as_fed\'}}</td><td>{{feed.dm | formatViewValues: \'dm\'}}</td><td>{{feed.group_as_fed | formatViewValues: \'group_as_fed\'}}</td><td>{{feed.diet_dmi | formatViewValues: \'diet_dmi\'}}&nbsp;%</td><td>{{feed.vem | formatViewValues: \'vem\'}}</td><td>{{feed.dve | formatViewValues: \'dve\': feed.dm}}</td><td>{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</td><td>{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td>{{feed.fos | formatViewValues: \'fos\': feed.dm}}</td><td>{{feed.starch | formatViewValues: \'starch\': feed.dm}}</td><td>{{feed.rus | formatViewValues: \'rus\': feed.dm}}</td><td>{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</td><td>{{feed.ca | formatViewValues: \'ca\': feed.dm}}</td><td>{{feed.p | formatViewValues: \'p\': feed.dm}}</td><td>{{feed.mg | formatViewValues: \'mg\': feed.dm}}</td><td>{{feed.na | formatViewValues: \'na\': feed.dm}}</td><td>{{feed.k | formatViewValues: \'k\': feed.dm}}</td><td>{{feed.cl | formatViewValues: \'cl\': feed.dm}}</td><td>{{feed.s | formatViewValues: \'s\': feed.dm}}</td><td>{{feed.adf | formatViewValues: \'adf\': feed.dm}}</td><td>{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</td><td>{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td>{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td>{{feed.test_date | date: vm.date_format}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryHome/rationFeedHistoryMix.home.US.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_user_\' | i18n}}" tooltip-is-open="lastModifiedUserIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_user_">user</data-i18n><br></div></th><th><div uib-tooltip="{{\'_title_last_modified_date_\' | i18n}}" tooltip-is-open="lastModifiedDateIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_last_modified_date_">last modified date</data-i18n><br></div></th><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></div></th><th><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="750"><data-i18n i18n="_feeds_me_">ME</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td style="white-space: nowrap" ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'">{{feed.feed_name}}</td><td ng-class="feed.last_modified_user_changed ? \'property-changed\' : \'\'">{{feed.last_modified_user }}</td><td ng-class="feed.last_modified_date_changed ? \'property-changed\' : \'\'">{{feed.last_modified_date | date:\'short\'}}</td><td>{{feed.action}}</td><td ng-class="feed.amount_changed ? \'property-changed\' : \'\'">{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.as_fed_changed ? \'property-changed\' : \'\'">{{feed.as_fed | formatViewValues: \'as_fed\'}}</td><td ng-class="feed.dm_changed ? \'property-changed\' : \'\'">{{feed.dm | formatViewValues: \'dm\'}}</td><td ng-class="feed.nel_changed ? \'property-changed\' : \'\'">{{feed.nel | formatViewValues: \'nel\'}}</td><td ng-class="feed.me_changed ? \'property-changed\' : \'\'">{{feed.me | formatViewValues: \'me\'}}</td><td ng-class="feed.ndf_changed ? \'property-changed\' : \'\'">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td ng-class="feed.cp_changed ? \'property-changed\' : \'\'">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td ng-class="feed.rup_changed ? \'property-changed\' : \'\'">{{feed.rup | formatViewValues: \'rup\'}}</td><td ng-class="feed.rup_dig_changed ? \'property-changed\' : \'\'">{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</td><td ng-class="feed.fa_changed ? \'property-changed\' : \'\'">{{feed.fa | formatViewValues: \'fa\'}}</td><td ng-class="feed.ca_changed ? \'property-changed\' : \'\'">{{feed.ca | formatViewValues: \'ca\': feed.dm}}</td><td ng-class="feed.p_changed ? \'property-changed\' : \'\'">{{feed.p | formatViewValues: \'p\': feed.dm}}</td><td ng-class="feed.na_changed ? \'property-changed\' : \'\'">{{feed.na | formatViewValues: \'na\': feed.dm}}</td><td ng-class="feed.dcad_changed ? \'property-changed\' : \'\'">{{feed.dcad | formatViewValues: \'dcad\'}}</td><td ng-class="feed.se_changed ? \'property-changed\' : \'\'">{{feed.se | formatViewValues: \'se\'}}</td><td ng-class="feed.vitamin_e_changed ? \'property-changed\' : \'\'">{{feed.vitamin_e | formatViewValues: \'vitamin_e\'}}</td><td ng-class="feed.cost_dm_changed ? \'property-changed\' : \'\'">{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</td><td ng-class="feed.test_date_changed ? \'property-changed\' : \'\'">{{ feed.test_date | date: vm.date_format}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryHome/rationFeedHistoryMix.home.VemDve.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_user_\' | i18n}}" tooltip-is-open="lastModifiedUserIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_user_">user</data-i18n><br></div></th><th><div uib-tooltip="{{\'_title_last_modified_date_\' | i18n}}" tooltip-is-open="lastModifiedDateIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_last_modified_date_">last modified date</data-i18n><br></div></th><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></div></th><th><div uib-tooltip="{{\'_description_group_as_fed_\' | i18n}}" tooltip-is-open="groupAsFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_group_as_fed_">group as fed</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_diet_dmi_\' | i18n}}" tooltip-is-open="dietDmiIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_diet_dmi_">diet dmi</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dmi_">dmi</data-i18n></div></th><th><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">vem</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dveIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">dve</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oebIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">oeb</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">cp</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">fos</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">ca</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">p</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">mg</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">na</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">k</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">cl</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">s</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">adf</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">ndf</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td style="white-space: nowrap" ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'">{{feed.feed_name}}</td><td ng-class="feed.last_modified_user_changed ? \'property-changed\' : \'\'">{{feed.last_modified_user }}</td><td ng-class="feed.last_modified_date_changed ? \'property-changed\' : \'\'">{{feed.last_modified_date | date:\'short\'}}</td><td>{{feed.action}}</td><td ng-class="feed.amount_changed ? \'property-changed\' : \'\'">{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.as_fed_changed ? \'property-changed\' : \'\'">{{feed.as_fed | formatViewValues: \'as_fed\'}}</td><td ng-class="feed.dm_changed ? \'property-changed\' : \'\'">{{feed.dm | formatViewValues: \'dm\'}}</td><td ng-class="feed.group_as_fed_changed ? \'property-changed\' : \'\'">{{feed.group_as_fed | formatViewValues: \'group_as_fed\'}}</td><td ng-class="feed.diet_dmi_changed ? \'property-changed\' : \'\'">{{feed.diet_dmi | formatViewValues: \'diet_dmi\'}}&nbsp;%</td><td ng-class="feed.vem_changed ? \'property-changed\' : \'\'">{{feed.vem | formatViewValues: \'vem\'}}</td><td ng-class="feed.dve_changed ? \'property-changed\' : \'\'">{{feed.dve | formatViewValues: \'dve\': feed.dm}}</td><td ng-class="feed.oeb_changed ? \'property-changed\' : \'\'">{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</td><td ng-class="feed.cp_changed ? \'property-changed\' : \'\'">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td ng-class="feed.fos_changed ? \'property-changed\' : \'\'">{{feed.fos | formatViewValues: \'fos\': feed.dm}}</td><td ng-class="feed.starch_changed ? \'property-changed\' : \'\'">{{feed.starch | formatViewValues: \'starch\': feed.dm}}</td><td ng-class="feed.rus_changed ? \'property-changed\' : \'\'">{{feed.rus | formatViewValues: \'rus\': feed.dm}}</td><td ng-class="feed.sugar_changed ? \'property-changed\' : \'\'">{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</td><td ng-class="feed.ca_changed ? \'property-changed\' : \'\'">{{feed.ca | formatViewValues: \'ca\': feed.dm}}</td><td ng-class="feed.p_changed ? \'property-changed\' : \'\'">{{feed.p | formatViewValues: \'p\': feed.dm}}</td><td ng-class="feed.mg_changed ? \'property-changed\' : \'\'">{{feed.mg | formatViewValues: \'mg\': feed.dm}}</td><td ng-class="feed.na_changed ? \'property-changed\' : \'\'">{{feed.na | formatViewValues: \'na\': feed.dm}}</td><td ng-class="feed.k_changed ? \'property-changed\' : \'\'">{{feed.k | formatViewValues: \'k\': feed.dm}}</td><td ng-class="feed.cl_changed ? \'property-changed\' : \'\'">{{feed.cl | formatViewValues: \'cl\': feed.dm}}</td><td ng-class="feed.s_changed ? \'property-changed\' : \'\'">{{feed.s | formatViewValues: \'s\': feed.dm}}</td><td ng-class="feed.adf_changed ? \'property-changed\' : \'\'">{{feed.adf | formatViewValues: \'adf\': feed.dm}}</td><td ng-class="feed.lignin_changed ? \'property-changed\' : \'\'">{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</td><td ng-class="feed.ndf_changed ? \'property-changed\' : \'\'">{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td ng-class="feed.ef_ndf_as_ndf_changed ? \'property-changed\' : \'\'">{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td ng-class="feed.test_date_changed ? \'property-changed\' : \'\'">{{feed.test_date | date: vm.date_format}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryLipid/rationFeedHistory.lipid.US.html','<div><table class="table table-hover-striped historyTable" st-table="vm.feeds"><thead><tr class="sortable" style="height: 30px"><th st-sort="feed_name" style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="ee"><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="fa"><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="sfa"><div uib-tooltip="{{\'_description_sfa_\' | i18n}}" tooltip-is-open="sfaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sfa_">SFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th st-sort="mufa"><div uib-tooltip="{{\'_description_mufa_\' | i18n}}" tooltip-is-open="mufaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mufa_">MUFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th st-sort="pufa"><div uib-tooltip="{{\'_description_pufa_\' | i18n}}" tooltip-is-open="pufaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_pufa_">PUFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th st-sort="bhfa"><div uib-tooltip="{{\'_description_bhfa_\' | i18n}}" tooltip-is-open="bhfaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_bhfa_">BHFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th st-sort="fa_dig"><div uib-tooltip="{{\'_description_fa_dig_\' | i18n}}" tooltip-is-open="faDigIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_dig_">FA dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th st-sort="td_fa"><div uib-tooltip="{{\'_description_td_fa_\' | i18n}}" tooltip-is-open="tdFaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdfa_">td FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.ee | formatViewValues: \'ee\': feed.dm}}</td><td>{{feed.fa | formatViewValues: \'fa\'}}</td><td>{{feed.sfa | formatViewValues: \'sfa\'}}</td><td>{{feed.mufa | formatViewValues: \'mufa\'}}</td><td>{{feed.pufa | formatViewValues: \'pufa\'}}</td><td>{{feed.bhfa | formatViewValues: \'bhfa\'}}</td><td>{{feed.fa_dig | formatViewValues: \'fa_dig\'}}</td><td>{{feed.td_fa | formatViewValues: \'td_fa\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryLipid/rationFeedHistory.lipid.VemDve.html','<div><table class="table table-hover-striped historyTable" st-table="vm.feeds"><thead><tr class="sortable" style="height: 30px"><th st-sort="feed_name"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="ee"><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.ee | formatViewValues: \'ee\': feed.dm}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryLipid/rationFeedHistoryMix.lipid.US.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_sfa_\' | i18n}}" tooltip-is-open="sfaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sfa_">SFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mufa_\' | i18n}}" tooltip-is-open="mufaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mufa_">MUFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_pufa_\' | i18n}}" tooltip-is-open="pufaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_pufa_">PUFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_bhfa_\' | i18n}}" tooltip-is-open="bhfaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_bhfa_">BHFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fa_dig_\' | i18n}}" tooltip-is-open="faDigIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_dig_">FA dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_td_fa_\' | i18n}}" tooltip-is-open="tdFaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdfa_">td FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" style="white-space: nowrap">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.ee_changed ? \'property-changed\' : \'\'">{{feed.ee | formatViewValues: \'ee\': feed.dm}}</td><td ng-class="feed.fa_changed ? \'property-changed\' : \'\'">{{feed.fa | formatViewValues: \'fa\'}}</td><td ng-class="feed.sfa_changed ? \'property-changed\' : \'\'">{{feed.sfa | formatViewValues: \'sfa\'}}</td><td ng-class="feed.mufa_changed ? \'property-changed\' : \'\'">{{feed.mufa | formatViewValues: \'mufa\'}}</td><td ng-class="feed.pufa_changed ? \'property-changed\' : \'\'">{{feed.pufa | formatViewValues: \'pufa\'}}</td><td ng-class="feed.bhfa_changed ? \'property-changed\' : \'\'">{{feed.bhfa | formatViewValues: \'bhfa\'}}</td><td ng-class="feed.fa_dig_changed ? \'property-changed\' : \'\'">{{feed.fa_dig | formatViewValues: \'fa_dig\'}}</td><td ng-class="feed.td_fa_changed ? \'property-changed\' : \'\'">{{feed.td_fa | formatViewValues: \'td_fa\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryLipid/rationFeedHistoryMix.lipid.VemDve.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" style="white-space: nowrap">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.ee_changed ? \'property-changed\' : \'\'">{{feed.ee | formatViewValues: \'ee\': feed.dm}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryProtein/rationFeedHistory.protein.US.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable" st-table="vm.ration.feeds"><thead><tr class="sortable" style="height: 30px"><th st-sort="feed_name" style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th st-sort="cp"><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="rup"><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="rdp"><div uib-tooltip="{{\'_description_rdp_\' | i18n}}" tooltip-is-open="rdpIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp_">rdp</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="mp"><div uib-tooltip="{{\'_description_mp_\' | i18n}}" tooltip-is-open="mpIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp_">mp</data-i18n><br></div></th><th st-sort="rup_dig"><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th st-sort="a_prot"><div uib-tooltip="{{\'_description_a_prot_\' | i18n}}" tooltip-is-open="AProtIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_a_">A Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="b_prot"><div uib-tooltip="{{\'_description_b_prot_\' | i18n}}" tooltip-is-open="BProtIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_b_">B Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="c_prot"><div uib-tooltip="{{\'_description_c_prot_\' | i18n}}" tooltip-is-open="CProtIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_c_">C Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="kd_b_prot"><div uib-tooltip="{{\'_description_kd_bprot_\' | i18n}}" tooltip-is-open="kdBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kd_bprot_">kd bprot</data-i18n><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th st-sort="kp_b_prot"><div uib-tooltip="{{\'_description_kp_bprot_\' | i18n}}" tooltip-is-open="kpBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kp_bprot_">kp bprot</data-i18n><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th st-sort="npncpe"><div uib-tooltip="{{\'_description_npncpe_\' | i18n}}" tooltip-is-open="npncpeIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_npncpe_">NPNCPE</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="rup_89"><div uib-tooltip="{{\'_description_rup_89_\' | i18n}}" tooltip-is-open="rup89IsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup89_">rup 89</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th st-sort="rdp_01"><div uib-tooltip="{{\'_description_rdp_01_\' | i18n}}" tooltip-is-open="rdp01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp01_">rdp 01</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="mp_01"><div uib-tooltip="{{\'_description_mp_01_\' | i18n}}" tooltip-is-open="mp01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp01_">mp 01</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th st-sort="ndicp"><div uib-tooltip="{{\'_description_ndicp_\' | i18n}}" tooltip-is-open="ndicpIsOpen" tooltip-append-to-body="true" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndicp_">NDICP</data-i18n><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="adicp"><div uib-tooltip="{{\'_description_adicp_\' | i18n}}" tooltip-is-open="adicpIsOpen" tooltip-append-to-body="true" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n><br><span ng-if="vm.settings.use_percent">%<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th st-sort="td_trup"><div uib-tooltip="{{\'_description_td_trup_\' | i18n}}" tooltip-is-open="tdtrupIsOpen" tooltip-append-to-body="true" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdtrup_">tdtrup</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td>{{feed.rup | formatViewValues: \'rup\'}}</td><td>{{feed.rdp | formatViewValues: \'rdp\'}}</td><td>{{feed.mp | formatViewValues: \'mp\'}}</td><td>{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</td><td>{{feed.a_prot | formatViewValues: \'a_prot\'}}</td><td>{{feed.b_prot | formatViewValues: \'b_prot\'}}</td><td>{{feed.c_prot | formatViewValues: \'c_prot\'}}</td><td>{{feed.kd_b_prot | formatViewValues: \'kd_b_prot\'}}</td><td>{{feed.kp_b_prot | formatViewValues: \'kp_b_prot\'}}</td><td>{{feed.npncpe | formatViewValues: \'npncpe\'}}</td><td>{{feed.rup_89 | formatViewValues: \'rup_89\'}}</td><td>{{feed.rdp_01 | formatViewValues: \'rdp_01\'}}</td><td>{{feed.mp_01 | formatViewValues: \'mp_01\'}}</td><td>{{feed.ndicp | formatViewValues: \'ndicp\': feed.dm}}</td><td>{{feed.adicp | formatViewValues: \'adicp\': feed.dm}}</td><td>{{feed.td_trup | formatViewValues: \'td_trup\'}}</td></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryProtein/rationFeedHistory.protein.VemDve.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_"></data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dveSevenIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">DVE</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oebSevenIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">OEB</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td>{{feed.dve | formatViewValues: \'dve\': feed.dm}}</td><td>{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</td></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryProtein/rationFeedHistoryMix.protein.US.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_"></data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rdp_\' | i18n}}" tooltip-is-open="rdpIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp_">rdp</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mp_\' | i18n}}" tooltip-is-open="mpIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp_">mp</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_a_prot_\' | i18n}}" tooltip-is-open="AProtIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_a_">A Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_b_prot_\' | i18n}}" tooltip-is-open="BProtIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_b_">B Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_c_prot_\' | i18n}}" tooltip-is-open="CProtIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_c_">C Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_kd_bprot_\' | i18n}}" tooltip-is-open="kdBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kd_bprot_">kd bprot</data-i18n><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th><div uib-tooltip="{{\'_description_kp_bprot_\' | i18n}}" tooltip-is-open="kpBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kp_bprot_">kp bprot</data-i18n><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th><div uib-tooltip="{{\'_description_npncpe_\' | i18n}}" tooltip-is-open="npncpeIsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_npncpe_">NPNCPE</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rup_89_\' | i18n}}" tooltip-is-open="rup89IsOpen" tooltip-append-to-body="true" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup89_">rup 89</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rdp_01_\' | i18n}}" tooltip-is-open="rdp01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp01_">rdp 01</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mp_01_\' | i18n}}" tooltip-is-open="mp01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp01_">mp 01</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_ndicp_\' | i18n}}" tooltip-is-open="ndicpIsOpen" tooltip-append-to-body="true" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndicp_">NDICP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_adicp_\' | i18n}}" tooltip-is-open="adicpIsOpen" tooltip-append-to-body="true" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_td_trup_\' | i18n}}" tooltip-is-open="tdtrupIsOpen" tooltip-append-to-body="true" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdtrup_">tdtrup</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" style="white-space: nowrap">{{feed.feed_name}}</td><td ng-class="feed.amount_changed ? \'property-changed\' : \'\'">{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.cp_changed ? \'property-changed\' : \'\'">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td ng-class="feed.rup_changed ? \'property-changed\' : \'\'">{{feed.rup | formatViewValues: \'rup\'}}</td><td ng-class="feed.rdp_changed ? \'property-changed\' : \'\'">{{feed.rdp | formatViewValues: \'rdp\'}}</td><td ng-class="feed.mp_changed ? \'property-changed\' : \'\'">{{feed.mp | formatViewValues: \'mp\'}}</td><td ng-class="feed.rup_dig_changed ? \'property-changed\' : \'\'">{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</td><td ng-class="feed.a_prot_changed ? \'property-changed\' : \'\'">{{feed.a_prot | formatViewValues: \'a_prot\'}}</td><td ng-class="feed.b_prot_changed ? \'property-changed\' : \'\'">{{feed.b_prot | formatViewValues: \'b_prot\'}}</td><td ng-class="feed.c_prot_changed ? \'property-changed\' : \'\'">{{feed.c_prot | formatViewValues: \'c_prot\'}}</td><td ng-class="feed.kd_b_prot_changed ? \'property-changed\' : \'\'">{{feed.kd_b_prot | formatViewValues: \'kd_b_prot\'}}</td><td ng-class="feed.kp_b_prot_changed ? \'property-changed\' : \'\'">{{feed.kp_b_prot | formatViewValues: \'kp_b_prot\'}}</td><td ng-class="feed.npncpe_changed ? \'property-changed\' : \'\'">{{feed.npncpe | formatViewValues: \'npncpe\'}}</td><td ng-class="feed.rup_89_changed ? \'property-changed\' : \'\'">{{feed.rup_89 | formatViewValues: \'rup_89\'}}</td><td ng-class="feed.rdp_01_changed ? \'property-changed\' : \'\'">{{feed.rdp_01 | formatViewValues: \'rdp_01\'}}</td><td ng-class="feed.mp_01_changed ? \'property-changed\' : \'\'">{{feed.mp_01 | formatViewValues: \'mp_01\'}}</td><td ng-class="feed.ndicp_changed ? \'property-changed\' : \'\'">{{feed.ndicp | formatViewValues: \'ndicp\': feed.dm}}</td><td ng-class="feed.adicp_changed ? \'property-changed\' : \'\'">{{feed.adicp | formatViewValues: \'adicp\': feed.dm}}</td><td ng-class="feed.td_trup_changed ? \'property-changed\' : \'\'">{{feed.td_trup | formatViewValues: \'td_trup\'}}</td></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/rations/rationFeedHistory/rationFeedHistoryProtein/rationFeedHistoryMix.protein.VemDve.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_"></data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dveSevenIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">DVE</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oebSevenIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">OEB</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.mix"><td ng-class="feed.feed_name_changed ? \'property-changed\' : \'\'" style="white-space: nowrap">{{feed.feed_name}}</td><td ng-class="feed.amount_changed ? \'property-changed\' : \'\'">{{feed.amount | formatViewValues: \'amount\'}}</td><td ng-class="feed.cp_changed ? \'property-changed\' : \'\'">{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td ng-class="feed.dve_changed ? \'property-changed\' : \'\'">{{feed.dve | formatViewValues: \'dve\': feed.dm}}</td><td ng-class="feed.oeb_changed ? \'property-changed\' : \'\'">{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</td></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistoryCarb/rationHistory.carb.US.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_nfc_\' | i18n}}" tooltip-is-open="nfcIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_">NFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_nfc_dig_\' | i18n}}" tooltip-is-open="nfcDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nfc_digestibility_">NFC dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_nfc_">NFC</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_infa_\' | i18n}}" tooltip-is-open="infaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_infa_">infa</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_sol_fiber_\' | i18n}}" tooltip-is-open="solFiberIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_" dm=""></data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_rd_sol_fiber_\' | i18n}}" tooltip-is-open="rdSolFiberIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdsolf_">RDSolF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_solfiber_">solFiber</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td style="white-space: nowrap">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.nfc | formatViewValues: \'nfc\'}}</td><td>{{feed.nfc_dig | formatViewValues: \'nfc_dig\'}}</td><td>{{feed.starch | formatViewValues: \'starch\': feed.dm}}</td><td>{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</td><td>{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</td><td>{{feed.in_fa | formatViewValues: \'in_fa\': feed.dm}}</td><td>{{feed.sol_fiber | formatViewValues: \'sol_fiber\'}}</td><td>{{feed.rd_sol_fiber | formatViewValues: \'rd_sol_fiber\'}}</td><td>{{feed.td_nfc | formatViewValues: \'td_nfc\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistoryCarb/rationHistory.carb.VemDve.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_rd_starch_\' | i18n}}" tooltip-is-open="rdStarchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdstarch_">RDStarch</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_starch_">starch</data-i18n></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_td_nfc_\' | i18n}}" tooltip-is-open="tdNfcIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdnfc_">tdNFC</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td style="white-space: nowrap">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.rus | formatViewValues: \'rus\': feed.dm}}</td><td>{{feed.starch | formatViewValues: \'starch\': feed.dm}}</td><td>{{feed.rd_starch | formatViewValues: \'rd_starch\'}}</td><td>{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</td><td>{{feed.td_nfc | formatViewValues: \'td_nfc\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistoryEnergy/rationHistory.energy.US.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me_">ME</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_disc_fac_\' | i18n}}" tooltip-is-open="discFacIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_disc_fac_">Disc. Fac.</data-i18n><br>%</div></th><th><div uib-tooltip="{{\'_description_nel_89_\' | i18n}}" tooltip-is-open="nel89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel89_">NEL 89</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_me_89_\' | i18n}}" tooltip-is-open="me89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me89_">ME 89</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_dep_\' | i18n}}" tooltip-is-open="depIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dep_">DEp</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_de1x_\' | i18n}}" tooltip-is-open="de1xIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_de1x_">DE1X</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_mftdn_\' | i18n}}" tooltip-is-open="mftdnIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mftdn_">MF-TDN</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_tdn1x_\' | i18n}}" tooltip-is-open="tdn1xIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdn1x_">TDN1X</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.nel | formatViewValues: \'nel\'}}</td><td>{{feed.me | formatViewValues: \'me\'}}</td><td>{{feed.disc_fac | formatViewValues: \'disc_fac\'}}</td><td>{{feed.nel_89 | formatViewValues: \'nel_89\'}}</td><td>{{feed.me_89 | formatViewValues: \'me_89\'}}</td><td>{{feed.dep | formatViewValues: \'dep\' }}</td><td>{{feed.de1x | formatViewValues: \'de1x\'}}</td><td>{{feed.mftdn | formatViewValues: \'mftdn\'}}</td><td>{{feed.tdn1x | formatViewValues: \'tdn1x\'}}</td></tr></tbody></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistoryEnergy/rationHistory.energy.VemDve.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th style="width: 200px"><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_"></data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">cost dm</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">cost dm</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.vem | formatViewValues: \'vem\'}}</td><td>{{feed.fos | formatViewValues: \'fos\': feed.dm}}</td></tr></tbody></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistoryFiber/rationHistory.fiber.US.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rdndf_\' | i18n}}" tooltip-is-open="rdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdndf_">RDNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_td_ndf_\' | i18n}}" tooltip-is-open="tdNdfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdndf_">tdNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td>{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td>{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</td><td>{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</td><td>{{feed.adf | formatViewValues: \'adf\': feed.dm}}</td><td>{{feed.rd_ndf | formatViewValues: \'rd_ndf\'}}</td><td>{{feed.td_ndf | formatViewValues: \'td_ndf\'}}</td></tr></tbody></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistoryFiber/rationHistory.fiber.VemDve.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_rcel_\' | i18n}}" tooltip-is-open="rcNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rcel_">RCEL</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ndf_digest_\' | i18n}}" tooltip-is-open="ndfDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_dig_">NDF dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndfn_">NDFn</data-i18n></div></th><th><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">ADF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.rc | formatViewValues: \'rc\': feed.dm}}</td><td>{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td>{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td>{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</td><td>{{feed.ndf_digest | formatViewValues: \'ndf_digest\'}}</td><td>{{feed.adf | formatViewValues: \'adf\': feed.dm}}</td></tr></tbody></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistoryHome/rationHistory.home.US.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_user_\' | i18n}}" tooltip-is-open="lastModifiedUserIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_user_">user</data-i18n><br></div></th><th><div uib-tooltip="{{\'_title_last_modified_date_\' | i18n}}" tooltip-is-open="lastModifiedDateIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_last_modified_date_">last modified date</data-i18n><br></div></th><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></div></th><th><div uib-tooltip="{{\'_description_nel_\' | i18n}}" tooltip-is-open="nelIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_nel_">NEL</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_me_\' | i18n}}" tooltip-is-open="meIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_me_">ME</data-i18n><br>{{vm.energy}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">NDF</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">Ca</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">P</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">Na</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_dcad_\' | i18n}}" tooltip-is-open="dcadIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dcad_">DCAD</data-i18n><br><data-i18n i18n="_unit_meq_">meq</data-i18n>/100g</div></th><th><div uib-tooltip="{{\'_description_se_\' | i18n}}" tooltip-is-open="seIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_se_">Se</data-i18n><br><data-i18n i18n="_unit_ppm_">ppm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_vitamin_e_\' | i18n}}" tooltip-is-open="vitEIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vit_e_">vit e</data-i18n><br><data-i18n i18n="_unit_iu_">IU</data-i18n>/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_cost_dm_\' | i18n}}" tooltip-is-open="costDmIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cost_dm_">cost dm</data-i18n><br>{{vm.currency}}/{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="1500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td style="white-space: nowrap">{{feed.feed_name}}</td><td>{{feed.last_modified_user}}</td><td>{{feed.last_modified_date | date:\'short\'}}</td><td>{{feed.action}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.dm | formatViewValues: \'dm\'}}</td><td>{{feed.nel | formatViewValues: \'nel\'}}</td><td>{{feed.me | formatViewValues: \'me\'}}</td><td>{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td>{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td>{{feed.rup | formatViewValues: \'rup\'}}</td><td>{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</td><td>{{feed.fa | formatViewValues: \'fa\'}}</td><td>{{feed.ca | formatViewValues: \'ca\': feed.dm}}</td><td>{{feed.p | formatViewValues: \'p\': feed.dm}}</td><td>{{feed.na | formatViewValues: \'na\': feed.dm}}</td><td>{{feed.dcad | formatViewValues: \'dcad\'}}</td><td>{{feed.se | formatViewValues: \'se\'}}</td><td>{{feed.vitamin_e | formatViewValues: \'vitamin_e\'}}</td><td>{{feed.cost_dm | formatViewValues: \'cost_dm\'}}</td><td>{{feed.test_date | date: vm.date_format}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistoryHome/rationHistory.home.VemDve.html','<div><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th ng-if="vm.showButton"><button type="button" class="btn btn-primary btn-xs" ng-click="vm.getMixHistory()"><i class="ion-clipboard"></i></button></th><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_user_\' | i18n}}" tooltip-is-open="lastModifiedUserIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_user_">user</data-i18n><br></div></th><th><div uib-tooltip="{{\'_title_last_modified_date_\' | i18n}}" tooltip-is-open="lastModifiedDateIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_title_last_modified_date_">last modified date</data-i18n><br></div></th><th><data-i18n i18n="_title_column_action_">Action</data-i18n><br></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_as_fed_\' | i18n}}" tooltip-is-open="asFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_as_fed_">as fed</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_dm_\' | i18n}}" tooltip-is-open="dmIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dm_">dm</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}</span></div></th><th><div uib-tooltip="{{\'_description_group_as_fed_\' | i18n}}" tooltip-is-open="groupAsFedIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_group_as_fed_">group as fed</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_diet_dmi_\' | i18n}}" tooltip-is-open="dietDmiIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_diet_dmi_">diet dmi</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dmi_">dmi</data-i18n></div></th><th><div uib-tooltip="{{\'_description_vem_\' | i18n}}" tooltip-is-open="vemIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_vem_">vem</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dveIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">dve</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oebIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">oeb</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">cp</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_fos_\' | i18n}}" tooltip-is-open="fosIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fos_">fos</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_starch_\' | i18n}}" tooltip-is-open="starchIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_starch_">starch</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rus_\' | i18n}}" tooltip-is-open="rusIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rus_">rus</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_sugar_\' | i18n}}" tooltip-is-open="sugarIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sugar_">sugar</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ca_\' | i18n}}" tooltip-is-open="caIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ca_">ca</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_p_\' | i18n}}" tooltip-is-open="pIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_p_">p</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_mg_\' | i18n}}" tooltip-is-open="mgIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mg_">mg</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_na_\' | i18n}}" tooltip-is-open="naIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_na_">na</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_k_\' | i18n}}" tooltip-is-open="kIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_k_">k</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_cl_\' | i18n}}" tooltip-is-open="clIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cl_">cl</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_s_\' | i18n}}" tooltip-is-open="sIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_s_">s</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_adf_\' | i18n}}" tooltip-is-open="adfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adf_">adf</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_lignin_\' | i18n}}" tooltip-is-open="ligninIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_lingnin_">lignin</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ndf_\' | i18n}}" tooltip-is-open="ndfNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndf_">ndf</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_ef_ndf_as_ndf_\' | i18n}}" tooltip-is-open="efndfAsNdfIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_efndf_">EfNDF</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_ndf_">NDF</data-i18n></div></th><th><div uib-tooltip="{{\'_description_test_date_\' | i18n}}" tooltip-is-open="tDateIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_test_date_">test date</data-i18n><br></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td ng-if="vm.showButton"></td><td style="white-space: nowrap">{{feed.feed_name}}</td><td>{{feed.last_modified_user }}</td><td>{{feed.last_modified_date | date:\'short\'}}</td><td>{{feed.action}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.as_fed | formatViewValues: \'as_fed\'}}</td><td>{{feed.dm | formatViewValues: \'dm\'}}</td><td>{{feed.group_as_fed | formatViewValues: \'group_as_fed\'}}</td><td>{{feed.diet_dmi | formatViewValues: \'diet_dmi\'}}&nbsp;%</td><td>{{feed.vem | formatViewValues: \'vem\'}}</td><td>{{feed.dve | formatViewValues: \'dve\': feed.dm}}</td><td>{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</td><td>{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td>{{feed.fos | formatViewValues: \'fos\': feed.dm}}</td><td>{{feed.starch | formatViewValues: \'starch\': feed.dm}}</td><td>{{feed.rus | formatViewValues: \'rus\': feed.dm}}</td><td>{{feed.sugar | formatViewValues: \'sugar\': feed.dm}}</td><td>{{feed.ca | formatViewValues: \'ca\': feed.dm}}</td><td>{{feed.p | formatViewValues: \'p\': feed.dm}}</td><td>{{feed.mg | formatViewValues: \'mg\': feed.dm}}</td><td>{{feed.na | formatViewValues: \'na\': feed.dm}}</td><td>{{feed.k | formatViewValues: \'k\': feed.dm}}</td><td>{{feed.cl | formatViewValues: \'cl\': feed.dm}}</td><td>{{feed.s | formatViewValues: \'s\': feed.dm}}</td><td>{{feed.adf | formatViewValues: \'adf\': feed.dm}}</td><td>{{feed.lignin | formatViewValues: \'lignin\': feed.dm}}</td><td>{{feed.ndf | formatViewValues: \'ndf\': feed.dm}}</td><td>{{feed.ef_ndf_as_ndf | formatViewValues: \'ef_ndf_as_ndf\'}}</td><td>{{feed.test_date | date: vm.date_format}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistoryLipid/rationHistory.lipid.US.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_fa_\' | i18n}}" tooltip-is-open="faIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_">FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_sfa_\' | i18n}}" tooltip-is-open="sfaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_sfa_">SFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mufa_\' | i18n}}" tooltip-is-open="mufaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mufa_">MUFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_pufa_\' | i18n}}" tooltip-is-open="pufaIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_pufa_">PUFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_bhfa_\' | i18n}}" tooltip-is-open="bhfaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_bhfa_">BHFA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_fa_dig_\' | i18n}}" tooltip-is-open="faDigIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_fa_dig_">FA dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_fa_">FA</data-i18n></div></th><th><div uib-tooltip="{{\'_description_td_fa_\' | i18n}}" tooltip-is-open="tdFaIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdfa_">td FA</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.ee | formatViewValues: \'ee\': feed.dm}}</td><td>{{feed.fa | formatViewValues: \'fa\'}}</td><td>{{feed.sfa | formatViewValues: \'sfa\'}}</td><td>{{feed.mufa | formatViewValues: \'mufa\'}}</td><td>{{feed.pufa | formatViewValues: \'pufa\'}}</td><td>{{feed.bhfa | formatViewValues: \'bhfa\'}}</td><td>{{feed.fa_dig | formatViewValues: \'fa_dig\'}}</td><td>{{feed.td_fa | formatViewValues: \'td_fa\'}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistoryLipid/rationHistory.lipid.VemDve.html','<div class="vertical-scroll"><table class="table table-hover-striped historyTable"><thead><tr class="sortable" style="height: 30px"><th><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_ee_\' | i18n}}" tooltip-is-open="eeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ee_">EE</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td>{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.ee | formatViewValues: \'ee\': feed.dm}}</td></tr></tbody><tfoot></tfoot></table><div align="center" style="overflow: hidden" ng-if="vm.loadingTable"><div id="loading-animation-large" style="display: inline-block"></div></div></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistoryProtein/rationHistory.protein.US.html','<div class="vertical-scroll"><table class="table table-hover-striped"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_rup_\' | i18n}}" tooltip-is-open="rupIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_">RUP</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rdp_\' | i18n}}" tooltip-is-open="rdpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp_">rdp</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mp_\' | i18n}}" tooltip-is-open="mpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp_">mp</data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_rup_dig_\' | i18n}}" tooltip-is-open="rupDigIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup_dig_">RUP dig</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_rup_">RUP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_a_prot_\' | i18n}}" tooltip-is-open="AProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_a_">A Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_b_prot_\' | i18n}}" tooltip-is-open="BProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_b_">B Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_c_prot_\' | i18n}}" tooltip-is-open="CProtIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_protein_c_">C Prot</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_kd_bprot_\' | i18n}}" tooltip-is-open="kdBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kd_bprot_">kd bprot</data-i18n><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th><div uib-tooltip="{{\'_description_kp_bprot_\' | i18n}}" tooltip-is-open="kpBprotIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_kp_bprot_">kp bprot</data-i18n><br>%/<data-i18n i18n="_unit_hours_">hr</data-i18n></div></th><th><div uib-tooltip="{{\'_description_npncpe_\' | i18n}}" tooltip-is-open="npncpeIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_npncpe_">NPNCPE</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rup_89_\' | i18n}}" tooltip-is-open="rup89IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rup89_">rup 89</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_cp_">CP</data-i18n></div></th><th><div uib-tooltip="{{\'_description_rdp_01_\' | i18n}}" tooltip-is-open="rdp01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_rdp01_">rdp 01</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_mp_01_\' | i18n}}" tooltip-is-open="mp01IsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_mp01_">mp 01</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th><th><div uib-tooltip="{{\'_description_ndicp_\' | i18n}}" tooltip-is-open="ndicpIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_ndicp_">NDICP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_adicp_\' | i18n}}" tooltip-is-open="adicpIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_adicp_">ADICP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_td_trup_\' | i18n}}" tooltip-is-open="tdtrupIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_tdtrup_">tdtrup</data-i18n><br>%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td style="white-space: nowrap">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td>{{feed.rup | formatViewValues: \'rup\'}}</td><td>{{feed.rdp | formatViewValues: \'rdp\'}}</td><td>{{feed.mp | formatViewValues: \'mp\'}}</td><td>{{feed.rup_dig | formatViewValues: \'rup_dig\'}}</td><td>{{feed.a_prot | formatViewValues: \'a_prot\'}}</td><td>{{feed.b_prot | formatViewValues: \'b_prot\'}}</td><td>{{feed.c_prot | formatViewValues: \'c_prot\'}}</td><td>{{feed.kd_b_prot | formatViewValues: \'kd_b_prot\'}}</td><td>{{feed.kp_b_prot | formatViewValues: \'kp_b_prot\'}}</td><td>{{feed.npncpe | formatViewValues: \'npncpe\'}}</td><td>{{feed.rup_89 | formatViewValues: \'rup_89\'}}</td><td>{{feed.rdp_01 | formatViewValues: \'rdp_01\'}}</td><td>{{feed.mp_01 | formatViewValues: \'mp_01\'}}</td><td>{{feed.ndicp | formatViewValues: \'ndicp\': feed.dm}}</td><td>{{feed.adicp | formatViewValues: \'adicp\': feed.dm}}</td><td>{{feed.td_trup | formatViewValues: \'td_trup\'}}</td></tr></tbody><tfoot></tfoot></table></div>');
$templateCache.put('app/pages/rations/rationHistory/rationHistoryProtein/rationHistory.protein.VemDve.html','<div class="vertical-scroll"><table class="table table-hover-striped"><thead><tr class="sortable" style="height: 30px"><th style="width: 200px"><div uib-tooltip="{{\'_description_feed_name_\' | i18n}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_name_"></data-i18n><br></div></th><th><div uib-tooltip="{{\'_description_amount_dm_\' | i18n}}" tooltip-is-open="amountIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_amount_">amount</data-i18n><br>{{vm.weight}}</div></th><th><div uib-tooltip="{{\'_description_cp_\' | i18n}}" tooltip-is-open="cpIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500"><data-i18n i18n="_feeds_cp_">CP</data-i18n><br><span ng-if="vm.settings.use_percent">%&nbsp;<data-i18n i18n="_feeds_dm_">dm</data-i18n></span> <span ng-if="!vm.settings.use_percent"><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_dve_\' | i18n}}" tooltip-is-open="dveSevenIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_dve_">DVE</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th><th><div uib-tooltip="{{\'_description_oeb_\' | i18n}}" tooltip-is-open="oebSevenIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500"><data-i18n i18n="_feeds_oeb_">OEB</data-i18n><br><span><data-i18n i18n="_unit_grams_">g</data-i18n>/{{vm.weight}}&nbsp;<data-i18n i18n="_feeds_dm_"></data-i18n></span></div></th></tr></thead><tbody><tr ng-repeat="feed in vm.feeds"><td style="white-space: nowrap">{{feed.feed_name}}</td><td>{{feed.amount | formatViewValues: \'amount\'}}</td><td>{{feed.cp | formatViewValues: \'cp\': feed.dm}}</td><td>{{feed.dve | formatViewValues: \'dve\': feed.dm}}</td><td>{{feed.oeb | formatViewValues: \'oeb\': feed.dm}}</td></tr></tbody><tfoot></tfoot></table></div>');}]);